
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g7CEg", function(module, exports) {
$parcel$export(module.exports, "UniformWrapper", function () { return $85ecc4bac898c23a$export$227673ab846fab74; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $dNSrU = parcelRequire("dNSrU");

var $jsxHL = parcelRequire("jsxHL");

var $5AtlP = parcelRequire("5AtlP");

var $5HK05 = parcelRequire("5HK05");

var $7WM7y = parcelRequire("7WM7y");

var $eRzlV = parcelRequire("eRzlV");

var $3d4V3 = parcelRequire("3d4V3");

var $7GVWk = parcelRequire("7GVWk");

var $hu7gH = parcelRequire("hu7gH");

var $lCZC9 = parcelRequire("lCZC9");

var $eNxv9 = parcelRequire("eNxv9");

var $kFmOH = parcelRequire("kFmOH");

var $g70ym = parcelRequire("g70ym");

var $9rnwe = parcelRequire("9rnwe");
const $85ecc4bac898c23a$var$resolveRenderer = ({ type: type })=>{
    const MissingComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $g70ym.UniformMissingComponent), {
            componentName: type
        });
    return (0, $eNxv9.default)[type] ?? MissingComponent;
};
const $85ecc4bac898c23a$export$227673ab846fab74 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const preloadedComposition = typeof window !== 'undefined' ? window._uniformPreloadedComposition : null;
    const initialData = preloadedComposition || composition;
    const [baseComposition, setBaseComposition] = (0, $1oC0p.useState)(initialData);
    const [isFetched, setIsFetched] = (0, $1oC0p.useState)(!!initialData);
    const [shouldRender404, setShouldRender404] = (0, $1oC0p.useState)(false);
    // NOTE: the legacy postMessage flow (UNIFORM_COMPOSITION_UPDATE) used
    // to live here as a separate useEffect. It was removed because the
    // full composition JSON was too large to chunk over postMessage
    // reliably. The ad-hoc preview flow now uses compositionId+projectId
    // URL params instead (see fetchFromCanvasApi below).
    (0, $1oC0p.useEffect)(()=>{
        const updateDocumentMetaFromComposition = (comp)=>{
            if (typeof document === 'undefined' || !comp?.parameters) return;
            const title = comp.parameters['pageTitle']?.value;
            const description = comp.parameters['metaDescription']?.value;
            if (title) document.title = title;
            if (description) {
                let metaDesc = document.querySelector('meta[name="description"]');
                if (!metaDesc) {
                    metaDesc = document.createElement('meta');
                    metaDesc.setAttribute('name', 'description');
                    document.head.appendChild(metaDesc);
                }
                metaDesc.setAttribute('content', description);
            }
        };
        // When compositionSource is live, fetch the live composition from WACMAN
        const loadLiveComposition = async (queryParams)=>{
            const { path: path, locale: locale } = (0, $hu7gH.parseRoute)(window.location);
            const liveComposition = await (0, $kFmOH.getLiveComposition)(queryParams, path, locale);
            const enhancedComp = await (0, $3d4V3.enhanceComposition)(liveComposition);
            setBaseComposition(enhancedComp);
            updateDocumentMetaFromComposition(enhancedComp);
            setShouldRender404(false);
            setIsFetched(true);
        };
        const queryParams = new URLSearchParams(window.location.search);
        const compositionSource = queryParams.get('compositionSource');
        if (compositionSource === 'live' && !(0, $eRzlV.isProduction)() && !baseComposition) {
            loadLiveComposition(queryParams);
            return;
        }
        // When isAllowPostMessage is true and compositionId is in the URL,
        // we need to fetch from the Canvas API even if initialData exists
        // (because initialData may be EMPTY_COMPOSITION from SSR).
        const hasCompositionIdInUrl = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('compositionId');
        if (initialData && !(isAllowPostMessage && hasCompositionIdInUrl)) return;
        const addNoIndexTag = ()=>{
            if (typeof document !== 'undefined') {
                let robotsMeta = document.querySelector('meta[name="robots"]');
                if (!robotsMeta) {
                    robotsMeta = document.createElement('meta');
                    robotsMeta.setAttribute('name', 'robots');
                    document.head.appendChild(robotsMeta);
                }
                robotsMeta.setAttribute('content', 'noindex,nofollow');
            }
        };
        const fetchFromCanvasApi = async (compositionId, projectId, previewLocale)=>{
            const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
            // On localhost, proxy through the local dev server (avoids CORS + keeps
            // the API key out of the browser even in local dev — the dev server
            // reads UNIFORM_API_KEY from .env.local / .env.dev).
            // On staging/prod, proxy through wac-management-service which holds the
            // Uniform API key server-side — never call uniform.app directly from the
            // browser as that triggers CORS errors AND would leak the API key.
            const buildCanvasUrl = (state)=>{
                if (isLocalhost) return `/api/uniform-canvas-proxy?compositionId=${encodeURIComponent(compositionId)}&state=${state}&projectId=${encodeURIComponent(projectId)}&locale=${encodeURIComponent(previewLocale)}`;
                // process.env.X is inlined at client-bundle build time by
                // Atlaspack — the var must be listed in `inlineEnvironment`
                // under `@atlaspack/transformer-js` in package.json (same
                // mechanism as WAC_MANAGEMENT_CDN above).
                const wacmanBase = "https://wac-management-service.us-east-1.prod.atl-paas.net" ?? '';
                return `${wacmanBase}/api/v1/uniform/composition/get?compositionId=${encodeURIComponent(compositionId)}&projectId=${encodeURIComponent(projectId)}&state=${encodeURIComponent(state)}&locale=${encodeURIComponent(previewLocale)}`;
            };
            // Default to draft state (0) since the AI migration tooling
            // creates ad-hoc compositions in draft. Callers can override
            // by passing &state=64 (published) in the URL if they really
            // want the published version of a published composition.
            // No credentials needed — WACMAN supplies the Uniform API key
            // server-side. On localhost the dev-server proxy also handles auth.
            const params = new URLSearchParams(window.location.search);
            const requestedState = params.get('state') || '0';
            const res = await fetch(buildCanvasUrl(requestedState), {});
            if (!res.ok) {
                console.error(`Canvas API error: ${res.status}`);
                setShouldRender404(true);
                setIsFetched(true);
                return;
            }
            const data = await res.json();
            const enhancedComp = await (0, $3d4V3.enhanceComposition)(data.composition);
            setBaseComposition(enhancedComp);
            setShouldRender404(false);
            setIsFetched(true);
            console.log(`uniform-preview: composition loaded from Canvas API (state=${requestedState})`);
        };
        // oxlint-disable-next-line complexity
        // eslint-disable-next-line complexity
        const fetchComposition = async ()=>{
            if (typeof window === 'undefined') return;
            const { path: path, locale: locale } = (0, $hu7gH.parseRoute)(window.location);
            if (path === 'uniform-preview' && isAllowPostMessage === true) {
                // Check for compositionId query param — if present, fetch directly
                // from the Uniform Canvas API. This is the preferred (and now
                // only) approach for ad-hoc migration validation since the
                // legacy postMessage flow was removed.
                const params = new URLSearchParams(window.location.search);
                const compositionId = params.get('compositionId');
                const projectId = params.get('projectId');
                if (compositionId && projectId) {
                    // Get locale from query param or default to en-US.
                    // Required to resolve localized parameters correctly.
                    const previewLocale = params.get('locale') || 'en-US';
                    console.log('uniform-preview: fetching composition directly from Canvas API', {
                        compositionId: compositionId,
                        projectId: projectId,
                        locale: previewLocale
                    });
                    try {
                        await fetchFromCanvasApi(compositionId, projectId, previewLocale);
                    } catch (error) {
                        console.error('Error fetching composition from Canvas API:', error);
                        setShouldRender404(true);
                        setIsFetched(true);
                    }
                    return;
                }
                console.log('uniform-preview with allowPostMessage - compositionId / projectId missing, nothing to render');
                return;
            }
            const slug = path.startsWith('/') ? path.substring(1) : path;
            const cdn = (0, $lCZC9.getCompositionCdn)();
            const cdnPath = `release/${locale}/${slug}/composition.json`;
            const cdnComposition = `${cdn}${cdnPath.replace(/\/\//g, '/')}`;
            try {
                const req = await fetch(cdnComposition);
                setShouldRender404(req.status !== 200);
                if (req.status === 404) {
                    setIsFetched(true);
                    return;
                }
                const file = await req.json();
                const enhancedComp = await (0, $3d4V3.enhanceComposition)(file.compositionApiResponse.composition);
                setBaseComposition(enhancedComp);
                setShouldRender404(false);
                setIsFetched(true);
                if (enhancedComp?.parameters?.['noIndex']?.value) addNoIndexTag();
            } catch (error) {
                console.error('Error fetching composition from CDN:', error);
                setShouldRender404(true);
                setIsFetched(true);
            }
        };
        fetchComposition();
    }, [
        initialData,
        composition,
        isAllowPostMessage
    ]);
    const { user: user } = (0, $7GVWk.useUserContext)();
    const { context: context } = (0, $dNSrU.useUniformContext)();
    const { personalizationValues: personalizationValues } = (0, $9rnwe.useWAEContext)();
    (0, $1oC0p.useMemo)(()=>{
        context.update({
            quirks: {
                ...personalizationValues
            }
        });
    }, [
        context,
        personalizationValues
    ]);
    const personalizedComposition = (0, $1oC0p.useMemo)(()=>{
        const tokens = new Map([
            [
                '{{name}}',
                user?.name || ''
            ],
            [
                '{{first-name}}',
                (0, $5AtlP.getFirstName)(user?.name || '')
            ]
        ]);
        let jsonString = JSON.stringify(baseComposition);
        if (!jsonString) return baseComposition;
        jsonString = jsonString.replace(/\{\{[a-zA-Z_-]*\}\}/g, (match)=>{
            return tokens.get(match) || match;
        });
        return JSON.parse(jsonString);
    }, [
        baseComposition,
        user?.name
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const updateQuirks = async ()=>{
            if (!user?.name) return;
            const quirks = {
                ...context.quirks,
                name: user.name,
                'first-name': (0, $5AtlP.getFirstName)(user.name)
            };
            await context.update({
                quirks: quirks
            });
        };
        updateQuirks();
    }, [
        user?.name,
        context
    ]);
    if (isUniformPlayground) {
        const typographyStylesDecorator = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                children: children
            });
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformPlayground), {
            behaviorTracking: "onLoad",
            resolveRenderer: $85ecc4bac898c23a$var$resolveRenderer,
            contextualEditingEnhancer: ({ composition: composition })=>(0, $3d4V3.enhanceComposition)(composition),
            decorators: [
                typographyStylesDecorator
            ]
        });
    }
    return shouldRender404 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}) : isFetched && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformComposition), {
            data: (0, $5HK05.expectContent)(personalizedComposition || baseComposition),
            behaviorTracking: "onLoad",
            resolveRenderer: $85ecc4bac898c23a$var$resolveRenderer,
            contextualEditingEnhancer: ({ composition: composition })=>(0, $3d4V3.enhanceComposition)(composition)
        })
    });
};

});
parcelRegister("3d4V3", function(module, exports) {
$parcel$export(module.exports, "enhanceComposition", function () { return $bea8ea4430d263c8$export$c6905b5a726736f3; });

var $f2QWG = parcelRequire("f2QWG");

var $hoxx0 = parcelRequire("hoxx0");

var $6GrXU = parcelRequire("6GrXU");

var $3lGAh = parcelRequire("3lGAh");

var $hM3sF = parcelRequire("hM3sF");

var $6Vl9e = parcelRequire("6Vl9e");

var $gVC4y = parcelRequire("gVC4y");
const $bea8ea4430d263c8$var$rtfToHTMLEnhancer = ({ parameter: parameter })=>{
    if (typeof parameter === 'string') return parameter;
    return (0, $gVC4y.richTextToHTML)(parameter.value);
};
const $bea8ea4430d263c8$var$customerStoryBodyEnhancer = ({ parameter: parameter })=>{
    const result = parameter.value;
    // @ts-expect-error - type mismatch
    if (result.storyText) // @ts-expect-error - type mismatch
    result.storyText = (0, $gVC4y.richTextToHTML)(// @ts-expect-error - type mismatch
    result.storyText);
    return result;
};
const $bea8ea4430d263c8$export$8012d36ea1a85499 = async ({ component: component })=>{
    const parameters = component.parameters;
    const locale = parameters.roadmapFeaturesLocale.value;
    const roadmapName = parameters.roadmapName?.value ?? 'Cloud';
    return (0, $hoxx0.getRoadmapFeatures)({
        limit: (0, $hoxx0.ROADMAP_FEATURES_INITIAL_PAGE_SIZE),
        locale: locale,
        roadmapName: roadmapName
    });
};
const $bea8ea4430d263c8$export$62885b6f3404cc9d = new (0, $f2QWG.EnhancerBuilder)()// don't implement for richText param type, as that is Uniform rich text, not Contentful
.parameterName('story', $bea8ea4430d263c8$var$customerStoryBodyEnhancer).parameterName([
    'richText',
    'feature1RichText',
    'feature2RichText',
    'feature3RichText'
], $bea8ea4430d263c8$var$rtfToHTMLEnhancer)// @ts-expect-error - type mismatch
.parameterName('comparePlansData', (0, $6GrXU.comparePlansEnhancer)).component('pricingCalculator', (builder)=>{
    builder.data('comparePlansData', (0, $hM3sF.pricingCalculatorEnhancer));
})// @ts-expect-error - type mismatch
.parameterName('tableData', (0, $6Vl9e.tableDataEnhancer)).component('roadmapFeatures', (builder)=>{
    builder.data('data', $bea8ea4430d263c8$export$8012d36ea1a85499);
}).component('filterableGallery', (builder)=>{
    builder.parameterName('items', (0, $3lGAh.contentfulIncludesEnhancer));
});
const $bea8ea4430d263c8$export$c6905b5a726736f3 = async (composition)=>{
    await (0, $f2QWG.enhance)({
        composition: composition,
        enhancers: $bea8ea4430d263c8$export$62885b6f3404cc9d,
        context: {}
    });
    return composition;
};

});
parcelRegister("hoxx0", function(module, exports) {
$parcel$export(module.exports, "ROADMAP_FEATURES_INITIAL_PAGE_SIZE", function () { return $8fefb655ffdbd82b$export$8b80ff538f17d2ea; });
$parcel$export(module.exports, "ROADMAP_FEATURES_ALL_ITEMS_PAGE_SIZE", function () { return $8fefb655ffdbd82b$export$926c841e781e53f7; });
$parcel$export(module.exports, "getRoadmapFeatures", function () { return $8fefb655ffdbd82b$export$67db44fab066fc1c; });

var $1dWiR = parcelRequire("1dWiR");

var $eRzlV = parcelRequire("eRzlV");

var $79QIK = parcelRequire("79QIK");
const $8fefb655ffdbd82b$export$8b80ff538f17d2ea = 50;
const $8fefb655ffdbd82b$export$926c841e781e53f7 = 1000;
const $8fefb655ffdbd82b$export$6fbfab67b98d8352 = ()=>{
    /* istanbul ignore next */ return typeof window === 'undefined' ? "fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8" : window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
};
const $8fefb655ffdbd82b$var$CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES = $8fefb655ffdbd82b$export$6fbfab67b98d8352();
const $8fefb655ffdbd82b$export$67db44fab066fc1c = async (args)=>{
    const limit = args.limit;
    const skip = args.skip;
    const locale = args.locale;
    const roadmapName = args.roadmapName;
    const exchanges = [
        (0, $1dWiR.fetchExchange)
    ];
    const client = new (0, $1dWiR.Client)({
        url: (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL),
        exchanges: exchanges,
        fetchOptions: ()=>{
            return {
                headers: {
                    Authorization: `Bearer ${$8fefb655ffdbd82b$var$CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
                }
            };
        }
    });
    const queryVariables = {
        limit: limit,
        skip: skip,
        locale: locale,
        roadmapNames: [
            roadmapName
        ]
    };
    const data = await client.query((0, $79QIK.RoadmapFeaturesQuery), queryVariables);
    return data.data;
};

});
parcelRegister("79QIK", function(module, exports) {
$parcel$export(module.exports, "RoadmapFeaturesQuery", function () { return $83fe1e6c7d9c135a$export$f2d0bd81df38ebd7; });

var $1dWiR = parcelRequire("1dWiR");
const $83fe1e6c7d9c135a$export$f2d0bd81df38ebd7 = (0, $1dWiR.gql)`
	query ($limit: Int, $skip: Int, $locale: String, $roadmapNames: [String!]!) {
		roadmapFeatureCollection(
			limit: $limit
			skip: $skip
			locale: $locale
			order: [statusOrder_ASC, sys_publishedAt_DESC]
			where: { roadmaps: { name_in: $roadmapNames } }
		) {
			total
			items {
				title
				description {
					json
				}
				status {
					roadmapStatusNameExternal
				}
				appsCollection(limit: 30) {
					items {
						roadmapAppNameExternal
						filterQueryParam
					}
				}
				category {
					queryParameter
					roadmapCategoryNameExternal
				}
				relatedLinksCollection(locale: $locale, limit: 5) {
					items {
						ctaButtonText
						ctaUrl
					}
				}
				timeFrame
				slug
				pid
				statusOrder
			}
		}
		taxonomyRoadmapAppCollection(locale: $locale, where: { roadmaps: { name_in: $roadmapNames } }) {
			items {
				roadmapAppNameExternal
				filterQueryParam
			}
		}
		taxonomyRoadmapCategoryCollection(
			locale: $locale
			where: { roadmaps: { name_in: $roadmapNames } }
		) {
			items {
				roadmapCategoryNameExternal
				queryParameter
			}
		}
		taxonomyRoadmapStatusCollection(locale: $locale) {
			items {
				roadmapStatusNameExternal
			}
		}
	}
`;

});


parcelRegister("6GrXU", function(module, exports) {
$parcel$export(module.exports, "getContentfulEnvironment", function () { return $46eb17ab9643138a$export$9e751421e780b92; });
$parcel$export(module.exports, "comparePlansEnhancer", function () { return $46eb17ab9643138a$export$b4d2dbc8f604aa9e; });

var $dkcYJ = parcelRequire("dkcYJ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $eRzlV = parcelRequire("eRzlV");

var $gVC4y = parcelRequire("gVC4y");
const $46eb17ab9643138a$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $46eb17ab9643138a$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $46eb17ab9643138a$export$9e751421e780b92 = ()=>{
    if ((0, $eRzlV.isProduction)()) return 'master';
    const isCcpStaging = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9034WacPricingCcpStaging);
    return isCcpStaging ? 'ccp_staging' : 'master';
};
const $46eb17ab9643138a$export$b4d2dbc8f604aa9e = async ({ parameter: parameter })=>{
    const plans = parameter.value;
    if (!plans?.length) return parameter.value;
    const shouldStripExcessData = (0, $gVC4y.getShouldStripExcessData)();
    if (shouldStripExcessData) (0, $gVC4y.stripContentfulMetadata)(parameter.value);
    const disableEnhancer = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).waePricingDisableComparePlansEnhancer);
    if (disableEnhancer) return plans;
    const contentfulEnvironment = $46eb17ab9643138a$export$9e751421e780b92();
    const productCatalogClient = new (0, $dkcYJ.ProductCatalogClient)(String($46eb17ab9643138a$var$PRODUCT_CATALOG_DELIVERY_KEY), String($46eb17ab9643138a$var$PRODUCT_CATALOG_SPACE), contentfulEnvironment);
    const skus = plans.map((plan)=>plan.fields.sku);
    const ccpPricingData = await productCatalogClient.getCCPPricingData(skus);
    return plans.map((plan)=>({
            ...plan,
            pricingPlan: ccpPricingData[plan.fields.sku]
        }));
};

});

parcelRegister("3lGAh", function(module, exports) {
$parcel$export(module.exports, "isContentfulEnvelope", function () { return $4de904912e8f9f99$export$b0c8e3f5240af3fc; });
$parcel$export(module.exports, "contentfulIncludesEnhancer", function () { return $4de904912e8f9f99$export$fbc34e765720c7f9; });
function $4de904912e8f9f99$export$b0c8e3f5240af3fc(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value) && Array.isArray(value.items);
}
const $4de904912e8f9f99$export$fbc34e765720c7f9 = ({ parameter: parameter })=>{
    const response = parameter.value;
    if (Array.isArray(response)) return {
        items: response
    };
    const rawItems = response?.items ?? [];
    const includedEntries = response?.includes?.Entry;
    if (!Array.isArray(includedEntries) || includedEntries.length === 0) return {
        items: rawItems,
        total: response?.total,
        limit: response?.limit,
        skip: response?.skip
    };
    const entryMap = new Map(includedEntries.map((entry)=>[
            entry.sys.id,
            entry
        ]));
    const stitchedItems = rawItems.map((item)=>{
        if (typeof item !== 'object' || item === null) return item;
        const typedItem = item;
        const fields = typedItem['fields'];
        if (typeof fields !== 'object' || fields === null) return item;
        const stitchedFields = $4de904912e8f9f99$var$stitchFields(fields, entryMap, new Set());
        return {
            ...typedItem,
            fields: stitchedFields
        };
    });
    return {
        items: stitchedItems,
        total: response?.total,
        limit: response?.limit,
        skip: response?.skip
    };
};
/**
 * Walks a `fields` object and replaces any Contentful Link stubs with their
 * resolved entries from the entryMap. Handles both single links and arrays.
 */ function $4de904912e8f9f99$var$stitchFields(fields, entryMap, visited) {
    return Object.fromEntries(Object.entries(fields).map(([key, value])=>[
            key,
            $4de904912e8f9f99$var$stitchValue(value, entryMap, visited)
        ]));
}
function $4de904912e8f9f99$var$stitchValue(value, entryMap, visited) {
    if (Array.isArray(value)) return value.map((v)=>$4de904912e8f9f99$var$stitchValue(v, entryMap, visited));
    if ($4de904912e8f9f99$var$isLinkStub(value)) {
        const sys = value['sys'];
        const id = sys?.['id'];
        if (!id) return value;
        if (visited.has(id)) return value;
        const resolved = entryMap.get(id);
        if (!resolved) return value;
        return {
            ...resolved,
            fields: $4de904912e8f9f99$var$stitchFields(resolved.fields, entryMap, new Set(visited).add(id))
        };
    }
    return value;
}
function $4de904912e8f9f99$var$isLinkStub(value) {
    if (typeof value !== 'object' || value === null) return false;
    const sys = value['sys'];
    if (typeof sys !== 'object' || sys === null) return false;
    return sys['type'] === 'Link';
}

});

parcelRegister("hM3sF", function(module, exports) {
$parcel$export(module.exports, "pricingCalculatorEnhancer", function () { return $afcda22f81ac1a98$export$ac6781ae0dd681b3; });

var $dkcYJ = parcelRequire("dkcYJ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $6GrXU = parcelRequire("6GrXU");

var $hhIJy = parcelRequire("hhIJy");

var $5hAGJ = parcelRequire("5hAGJ");

var $6dQnb = parcelRequire("6dQnb");
const $afcda22f81ac1a98$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $afcda22f81ac1a98$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $afcda22f81ac1a98$export$ac6781ae0dd681b3 = async ({ component: component })=>{
    const waePricingGqlEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).waePricingGql);
    const parameters = component.parameters;
    if (parameters?.comparePlansData || !waePricingGqlEnabled) return undefined;
    const urlSlug = parameters.urlSlug?.value;
    if (!urlSlug) throw new Error('no urlSlug provided');
    const locale = parameters.componentLocale?.value ?? 'en-US';
    const content = await (0, $5hAGJ.getPricingCalculatorContent)({
        urlSlug: urlSlug,
        locale: locale
    });
    if (!content) throw new Error('pricing calculator content is empty');
    const offeringSkusArray = (0, $6dQnb.getOfferingSkusArrayByUrlSlug)(urlSlug);
    if (!offeringSkusArray) throw new Error(`No offering SKUs found for urlSlug: "${urlSlug}"`);
    const planLimitConfigs = (0, $6dQnb.getPlanLimitConfigsByUrlSlug)(urlSlug);
    if (!planLimitConfigs) throw new Error(`No plan limit configs found for urlSlug: "${urlSlug}"`);
    const contentfulEnvironment = (0, $6GrXU.getContentfulEnvironment)();
    const productCatalogClient = new (0, $dkcYJ.ProductCatalogClient)(String($afcda22f81ac1a98$var$PRODUCT_CATALOG_DELIVERY_KEY), String($afcda22f81ac1a98$var$PRODUCT_CATALOG_SPACE), contentfulEnvironment);
    const ccpPricingData = await productCatalogClient.getCCPPricingData(offeringSkusArray);
    return (0, $hhIJy.getComparePlansDataFromGqlContent)(content, planLimitConfigs, ccpPricingData);
};

});
parcelRegister("hhIJy", function(module, exports) {
$parcel$export(module.exports, "getComparePlansDataFromGqlContent", function () { return $25f2f495ff1f99ec$export$38e6c92d574132a9; });
function $25f2f495ff1f99ec$export$38e6c92d574132a9(gqlContent, planLimitConfigs, ccpPricingData) {
    const items = gqlContent.pricingCollection.items[0]?.comparePlansCollection.items ?? [];
    return items.flatMap((item, index)=>{
        const sku = planLimitConfigs[index]?.offeringSku ?? '';
        const pricingPlan = ccpPricingData[sku];
        if (!pricingPlan) return [];
        return [
            {
                fields: {
                    planTitleInternal: '',
                    planTitleExternal: item.planTitleExternal,
                    planOneLiner: item.planOneLiner,
                    sku: sku,
                    highlightedFeaturesTitle: item.highlightedFeaturesTitle ?? '',
                    highlightedFeaturesContainer: item.highlightedFeaturesContainerCollection.items.map((feature)=>({
                            fields: {
                                highlightedFeatureTitleInternal: '',
                                highlightedFeatureTitleExternal: feature.highlightedFeatureTitleExternal,
                                highlightedFeatureDetails: feature.highlightedFeatureDetails?.json,
                                highlightedLabel: feature.callOut ?? undefined
                            }
                        })),
                    microCta: item.microCtaCollection.items.map((cta)=>({
                            fields: {
                                ctaMicrocopyNameInternal: '',
                                ctaMicrocopyTitleExternal: cta.ctaMicrocopyTitleExternal,
                                ctaButtonText: cta.ctaButtonText,
                                ctaUrl: cta.ctaUrl
                            }
                        })),
                    relatedProduct: []
                },
                pricingPlan: pricingPlan
            }
        ];
    });
}

});

parcelRegister("5hAGJ", function(module, exports) {
$parcel$export(module.exports, "getPricingCalculatorContent", function () { return $933ba02cc7733faf$export$1a2450c4de286d22; });

var $2iZII = parcelRequire("2iZII");

var $jPnzY = parcelRequire("jPnzY");
const $933ba02cc7733faf$export$1a2450c4de286d22 = async (args)=>{
    const { urlSlug: urlSlug, locale: locale } = args;
    const client = (0, $2iZII.getContentfulGqlClient)();
    const result = await client.query((0, $jPnzY.pricingCalculatorContentQuery), {
        urlSlug: urlSlug,
        locale: locale
    });
    return result.data;
};

});
parcelRegister("2iZII", function(module, exports) {
$parcel$export(module.exports, "getContentfulGqlClient", function () { return $914a19f06f37855a$export$c55ca49fcae63941; });

var $1dWiR = parcelRequire("1dWiR");

var $eRzlV = parcelRequire("eRzlV");
const $914a19f06f37855a$var$getContentfulDeliveryKey = ()=>{
    return typeof window === 'undefined' ? "fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8" : window['CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES'];
};
let $914a19f06f37855a$var$contentfulGqlClient;
const $914a19f06f37855a$export$c55ca49fcae63941 = ()=>{
    if ($914a19f06f37855a$var$contentfulGqlClient) return $914a19f06f37855a$var$contentfulGqlClient;
    const deliveryKey = $914a19f06f37855a$var$getContentfulDeliveryKey();
    $914a19f06f37855a$var$contentfulGqlClient = new (0, $1dWiR.Client)({
        url: (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL),
        exchanges: [
            (0, $1dWiR.fetchExchange)
        ],
        fetchOptions: ()=>({
                headers: {
                    Authorization: `Bearer ${deliveryKey}`
                }
            })
    });
    return $914a19f06f37855a$var$contentfulGqlClient;
};

});

parcelRegister("jPnzY", function(module, exports) {
$parcel$export(module.exports, "pricingCalculatorContentQuery", function () { return $969650c1f1b7aafc$export$d1373c2ad7bc60be; });

var $1dWiR = parcelRequire("1dWiR");
const $969650c1f1b7aafc$export$d1373c2ad7bc60be = (0, $1dWiR.gql)`
	query pricingCalculatorContent($urlSlug: String!, $locale: String!) {
		pricingCollection(where: { urlSlug: $urlSlug }, locale: $locale, limit: 1) {
			items {
				pricingTitleInternal
				headline {
					json
				}
				comparePlansCollection(limit: 10) {
					items {
						planTitleExternal
						planOneLiner
						microCtaCollection(limit: 15) {
							items {
								... on CallToActionMicrocopy {
									ctaMicrocopyTitleExternal
									ctaButtonText
									ctaUrl
								}
							}
						}
						highlightedFeaturesTitle
						highlightedFeaturesContainerCollection(limit: 15) {
							items {
								highlightedFeatureDetails {
									json
								}
								highlightedFeatureTitleExternal
								callOut
							}
						}
					}
				}
			}
		}
	}
`;

});


parcelRegister("6dQnb", function(module, exports) {
$parcel$export(module.exports, "getOfferingSkusArrayByUrlSlug", function () { return $400e01adc37d92c1$export$ad60229e511290bd; });
$parcel$export(module.exports, "getPlanLimitConfigsByUrlSlug", function () { return $400e01adc37d92c1$export$1d51d8a481926a; });

var $aTHox = parcelRequire("aTHox");

var $7dhmX = parcelRequire("7dhmX");

var $29JVp = parcelRequire("29JVp");

var $44C4o = parcelRequire("44C4o");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $gcAZd = parcelRequire("gcAZd");

var $4utnL = parcelRequire("4utnL");

var $9Nmuw = parcelRequire("9Nmuw");

var $fEBe5 = parcelRequire("fEBe5");

var $hGYMM = parcelRequire("hGYMM");

var $YmHME = parcelRequire("YmHME");
const $400e01adc37d92c1$export$ad60229e511290bd = (urlSlug)=>{
    const urlSlugToSkusArray = {
        jira: (0, $j1ORI.jiraOfferingSkusArray),
        confluence: (0, $29JVp.confluenceOfferingSkusArray),
        bitbucket: (0, $aTHox.bitbucketOfferingSkusArray),
        loom: (0, $4utnL.loomOfferingSkusArray),
        compass: (0, $7dhmX.compassOfferingSkusArray),
        guard: (0, $44C4o.guardOfferingSkusArray),
        'rovo-dev': (0, $9Nmuw.rovoDevOfferingSkusArray),
        'product-discovery': (0, $lc7EO.jpdOfferingSkusArray)(),
        'service-management': (0, $gcAZd.jsmOfferingSkusArray),
        service: (0, $fEBe5.serviceCollectionOfferingSkusArray),
        strategy: (0, $hGYMM.strategyCollectionOfferingSkusArray),
        teamwork: (0, $YmHME.teamworkCollectionOfferingSkusArray)
    };
    return urlSlugToSkusArray[urlSlug];
};
const $400e01adc37d92c1$export$1d51d8a481926a = (urlSlug)=>{
    const urlSlugToPlanLimitConfigs = {
        jira: (0, $j1ORI.jiraPlanLimitConfigs),
        confluence: (0, $29JVp.confluencePlanLimitConfigs),
        bitbucket: (0, $aTHox.bitbucketPlanLimitConfigs),
        loom: (0, $4utnL.loomPlanLimitConfigs),
        compass: (0, $7dhmX.compassPlanLimitConfigs),
        guard: (0, $44C4o.guardPlanLimitConfigs),
        'rovo-dev': (0, $9Nmuw.rovoDevPlanLimitConfigs),
        'product-discovery': (0, $lc7EO.jpdPlanLimitConfigs)(),
        'service-management': (0, $gcAZd.jsmPlanLimitConfigs),
        service: (0, $fEBe5.serviceCollectionPlanLimitConfigs),
        strategy: (0, $hGYMM.strategyCollectionPlanLimitConfigs),
        teamwork: (0, $YmHME.teamworkCollectionPlanLimitConfigs)
    };
    return urlSlugToPlanLimitConfigs[urlSlug];
};

});


parcelRegister("6Vl9e", function(module, exports) {
$parcel$export(module.exports, "tableDataEnhancer", function () { return $1789d6dbd0c18f10$export$230f7887d8fcf17f; });

var $gVC4y = parcelRequire("gVC4y");
const $1789d6dbd0c18f10$export$230f7887d8fcf17f = async ({ parameter: parameter })=>{
    const shouldStripExcessData = (0, $gVC4y.getShouldStripExcessData)();
    if (shouldStripExcessData) (0, $gVC4y.stripContentfulMetadata)(parameter.value);
    parameter.value?.forEach((featureGroup)=>{
        featureGroup.fields.features.forEach((feature)=>{
            if (typeof feature.fields.description === 'object' && feature.fields.description?.nodeType === 'document') feature.fields.description = (0, $gVC4y.richTextToHTML)(feature.fields.description);
            if (shouldStripExcessData) $1789d6dbd0c18f10$var$trimRelevantPlans(feature);
        });
    });
    return parameter.value;
};
function $1789d6dbd0c18f10$var$trimRelevantPlans(feature) {
    feature.fields.relevantPlan?.forEach((plan)=>{
        if (plan.fields) plan.fields = {
            planTitleExternal: plan.fields.planTitleExternal
        };
    });
    feature.fields.featureAdditionalInformation?.forEach((info)=>{
        info.fields?.relevantPlan?.forEach((plan)=>{
            if (plan.fields) plan.fields = {
                planTitleExternal: plan.fields.planTitleExternal
            };
        });
    });
}

});


parcelRegister("lCZC9", function(module, exports) {
$parcel$export(module.exports, "getCompositionCdn", function () { return $bd123ad034db2258$export$fe37e13dbbc60f35; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $bd123ad034db2258$export$fe37e13dbbc60f35 = ({ isPreview: isPreview = false } = {})=>{
    const useWacman = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).useWacman);
    if (isPreview) return useWacman ? "https://wac-management-service--comp-prv.us-east-1.prod.public.atl-paas.net/" : "https://wac-uniform-promotion--production.us-east-1.prod.public.atl-paas.net/";
    return useWacman ? "https://wac-management-service--comp-prd.us-east-1.prod.public.atl-paas.net/" : "https://wac-uniform-promotion--production.us-east-1.prod.public.atl-paas.net/";
};

});

parcelRegister("eNxv9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ccc1f30aa8c203e0$export$2e2bcd8739ae039; });

var $ksvEJ = parcelRequire("ksvEJ");

var $iLjCW = parcelRequire("iLjCW");

var $4JOZV = parcelRequire("4JOZV");

var $d2ttO = parcelRequire("d2ttO");

var $lqBhQ = parcelRequire("lqBhQ");

var $3wpTl = parcelRequire("3wpTl");

var $1d9MG = parcelRequire("1d9MG");

var $jgyhc = parcelRequire("jgyhc");

var $aiWEP = parcelRequire("aiWEP");

var $fZxve = parcelRequire("fZxve");

var $7v1H9 = parcelRequire("7v1H9");

var $8hbU0 = parcelRequire("8hbU0");
parcelRequire("eWth0");
var $aghrj = parcelRequire("aghrj");

var $ezRYc = parcelRequire("ezRYc");

var $dm54q = parcelRequire("dm54q");

var $6SooZ = parcelRequire("6SooZ");

var $4h1q1 = parcelRequire("4h1q1");

var $k1kqo = parcelRequire("k1kqo");

var $iCnJ7 = parcelRequire("iCnJ7");

var $jswU3 = parcelRequire("jswU3");

var $82Z9J = parcelRequire("82Z9J");

var $7QjKf = parcelRequire("7QjKf");

var $9eDC1 = parcelRequire("9eDC1");

var $hStuA = parcelRequire("hStuA");

var $8MWwK = parcelRequire("8MWwK");

var $5nbaa = parcelRequire("5nbaa");

var $gQYRi = parcelRequire("gQYRi");

var $ijBWj = parcelRequire("ijBWj");

var $Ms48M = parcelRequire("Ms48M");

var $91YSm = parcelRequire("91YSm");

var $k1j8C = parcelRequire("k1j8C");

var $kEr7H = parcelRequire("kEr7H");

var $cDjwJ = parcelRequire("cDjwJ");

var $gl1tq = parcelRequire("gl1tq");

var $hvVOW = parcelRequire("hvVOW");

var $9xmV3 = parcelRequire("9xmV3");

var $2m9G1 = parcelRequire("2m9G1");

var $6nTac = parcelRequire("6nTac");

var $7FUnn = parcelRequire("7FUnn");

var $2540f = parcelRequire("2540f");

var $j6nXt = parcelRequire("j6nXt");

var $kud54 = parcelRequire("kud54");

var $8JW63 = parcelRequire("8JW63");

var $jK7xK = parcelRequire("jK7xK");

var $856b3 = parcelRequire("856b3");

var $2bofd = parcelRequire("2bofd");

var $3VYCw = parcelRequire("3VYCw");

var $g0xMT = parcelRequire("g0xMT");

var $76Hra = parcelRequire("76Hra");

var $89oar = parcelRequire("89oar");
parcelRequire("ccVGG");
var $hTiWM = parcelRequire("hTiWM");

var $lmfaS = parcelRequire("lmfaS");

var $3wi1O = parcelRequire("3wi1O");

var $7d42O = parcelRequire("7d42O");

var $wwZ1W = parcelRequire("wwZ1W");

var $f7IMH = parcelRequire("f7IMH");

var $jGtmE = parcelRequire("jGtmE");

var $dr4ha = parcelRequire("dr4ha");

var $1Gd1W = parcelRequire("1Gd1W");

var $gOX57 = parcelRequire("gOX57");

var $6JkkA = parcelRequire("6JkkA");

var $1ij5s = parcelRequire("1ij5s");

var $3jkl6 = parcelRequire("3jkl6");

var $bkhKq = parcelRequire("bkhKq");

var $5uOL0 = parcelRequire("5uOL0");

var $6jbRM = parcelRequire("6jbRM");

var $h1pep = parcelRequire("h1pep");

var $g9CPg = parcelRequire("g9CPg");

var $kb6mk = parcelRequire("kb6mk");

var $ks0ka = parcelRequire("ks0ka");

var $42RaW = parcelRequire("42RaW");

var $5c1uT = parcelRequire("5c1uT");

var $f8O2Y = parcelRequire("f8O2Y");

var $1bORF = parcelRequire("1bORF");

var $96bxg = parcelRequire("96bxg");

var $iSxa6 = parcelRequire("iSxa6");

var $lATol = parcelRequire("lATol");

var $1dXNn = parcelRequire("1dXNn");

var $dXbVO = parcelRequire("dXbVO");

var $3fweY = parcelRequire("3fweY");

var $3E1lH = parcelRequire("3E1lH");

var $7xYdG = parcelRequire("7xYdG");

var $gebIf = parcelRequire("gebIf");

var $9tius = parcelRequire("9tius");

var $6b4fD = parcelRequire("6b4fD");

var $hTABe = parcelRequire("hTABe");

var $8HKOE = parcelRequire("8HKOE");

var $aT8t4 = parcelRequire("aT8t4");

var $eNJPT = parcelRequire("eNJPT");

var $f9rY4 = parcelRequire("f9rY4");

var $lPMtR = parcelRequire("lPMtR");

var $4oasi = parcelRequire("4oasi");

var $aSjAq = parcelRequire("aSjAq");

var $exkom = parcelRequire("exkom");

var $6smfw = parcelRequire("6smfw");

var $2Oxuw = parcelRequire("2Oxuw");

var $4Aw5W = parcelRequire("4Aw5W");

var $4LrCk = parcelRequire("4LrCk");

var $v15B3 = parcelRequire("v15B3");

var $71GXn = parcelRequire("71GXn");

var $3DCiB = parcelRequire("3DCiB");

var $acEyk = parcelRequire("acEyk");

var $ies6q = parcelRequire("ies6q");

var $a9JqH = parcelRequire("a9JqH");

var $kSxbf = parcelRequire("kSxbf");

var $dXwUh = parcelRequire("dXwUh");

var $5EeVR = parcelRequire("5EeVR");

var $aeR15 = parcelRequire("aeR15");

var $4YtaH = parcelRequire("4YtaH");

var $kfc2o = parcelRequire("kfc2o");

var $4YxT8 = parcelRequire("4YxT8");

var $3rWcE = parcelRequire("3rWcE");

var $j4sH0 = parcelRequire("j4sH0");

var $fDTuB = parcelRequire("fDTuB");

var $jrzD7 = parcelRequire("jrzD7");

var $hcVIx = parcelRequire("hcVIx");

var $lyzDC = parcelRequire("lyzDC");

var $evFps = parcelRequire("evFps");

var $eWY7v = parcelRequire("eWY7v");

var $kov0f = parcelRequire("kov0f");

var $gSQsG = parcelRequire("gSQsG");

var $gP8Hr = parcelRequire("gP8Hr");

var $cwpkM = parcelRequire("cwpkM");
parcelRequire("aSmcz");
var $eFi9k = parcelRequire("eFi9k");

var $aQkGJ = parcelRequire("aQkGJ");

var $11uBo = parcelRequire("11uBo");

var $hnLdc = parcelRequire("hnLdc");

var $9VQLz = parcelRequire("9VQLz");

var $hTage = parcelRequire("hTage");

var $3QKwy = parcelRequire("3QKwy");

var $lEcJc = parcelRequire("lEcJc");

var $1GX5U = parcelRequire("1GX5U");

var $fzMpf = parcelRequire("fzMpf");

var $10B1c = parcelRequire("10B1c");

var $9Cjg1 = parcelRequire("9Cjg1");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ccc1f30aa8c203e0$var$UNIFORM_DEFINITIONS = {
    accordion: (0, $4JOZV.default),
    accordionsSection: (0, $d2ttO.default),
    animationWrapper: (0, $lqBhQ.default),
    articleCta: (0, $3wpTl.default),
    backgroundVideoContainer: (0, $1d9MG.default),
    bannerAlert: (0, $jgyhc.default),
    bitbucketSearchIntegration: (0, $aiWEP.default),
    bleedingImageHero: (0, $fZxve.default),
    blockContainer: (0, $8MWwK.default),
    blogNewsGallery: (0, $7v1H9.default),
    bodyContent: (0, $8hbU0.default),
    button: (0, $6SooZ.default),
    callToAction: (0, $4h1q1.default),
    card: (0, $k1kqo.default),
    careersGallery: (0, $iCnJ7.default),
    collectionPricingHero: (0, $jswU3.default),
    columnLayout: (0, $82Z9J.UniformColumnLayout),
    companyTimeline: (0, $7QjKf.default),
    confluenceAnimatedHero: (0, $9eDC1.default),
    connector: (0, $hStuA.default),
    contentBlock: (0, $5nbaa.default),
    copyText: (0, $91YSm.default),
    contextualBanditsContainer: (0, $ijBWj.default),
    contextualBanditsVariant: (0, $Ms48M.default),
    ctaWithPolygonBackground: (0, $8HKOE.default),
    customTableCell: (0, $k1j8C.default),
    customerBodyContent: (0, $aghrj.default),
    customerGallery: (0, $kEr7H.default),
    customerStat: (0, $cDjwJ.default),
    customerStoriesDetailsHero: (0, $gl1tq.default),
    customerTestimonials: (0, $hvVOW.default),
    decorativeContainer: (0, $9xmV3.default),
    designRefreshBar: (0, $2m9G1.default),
    designRefreshHeading: (0, $6nTac.default),
    emailSubscriptionForm: (0, $kud54.default),
    embeddedVideo: (0, $8JW63.default),
    enhancedBanner: (0, $jK7xK.default),
    downloadRow: (0, $2540f.default),
    downloadTable: (0, $j6nXt.default),
    expand: (0, $856b3.default),
    featuresHighlight: (0, $g0xMT.default),
    globalFooter: (0, $iLjCW.GlobalFooter),
    globalNav: (0, $7d42O.default),
    graphPaperReveal: (0, $wwZ1W.default),
    heading: (0, $f7IMH.default),
    heroCarouselSection: (0, $jGtmE.default),
    heroScrollToEnlargeContainer: (0, $dr4ha.default),
    heroSection: (0, $1Gd1W.default),
    hoveringTeamworkGraph: (0, $gOX57.default),
    jsmLoggedInHeroSection: (0, $g9CPg.default),
    jsmPortalPlayground: (0, $kb6mk.default),
    horizontalDivider: (0, $7FUnn.default),
    image: (0, $6JkkA.default),
    imageV2: (0, $1ij5s.default),
    integration: (0, $3jkl6.default),
    invisibleContent: (0, $bkhKq.default),
    navBar: (0, $1dXNn.default),
    navigationTab: (0, $dXbVO.default),
    navigationTabs: (0, $3fweY.default),
    pricingTiersTable: (0, $f9rY4.default),
    productCardBlock: (0, $4oasi.default),
    returnToProduct: (0, $aSjAq.default),
    roadmapFeatures: (0, $exkom.default),
    rovoChatContainer: (0, $2Oxuw.default),
    rovoChatBox: (0, $6smfw.default),
    rovoChatHeader: (0, $4Aw5W.default),
    scrollableHeroCards: (0, $v15B3.default),
    filterableGallery: (0, $89oar.default),
    filterableItem: (0, $hTiWM.default),
    form: (0, $3wi1O.default),
    formCompanyField: (0, $lmfaS.default),
    formCustomChoiceField: (0, $lmfaS.default),
    formCustomTextField: (0, $lmfaS.default),
    formEmailField: (0, $lmfaS.default),
    formNamesFields: (0, $lmfaS.default),
    formOption: (0, $lmfaS.default),
    formPhoneNumberField: (0, $lmfaS.default),
    jiraAjAnimatedHero: (0, $5uOL0.JiraAjAnimatedHero),
    jiraTemplatesTabContentSubgridLayout: (0, $6jbRM.default),
    jobPostingSubheading: (0, $h1pep.default),
    link: (0, $ks0ka.default),
    listv2: (0, $42RaW.default),
    logos: (0, $5c1uT.default),
    lozenge: (0, $f8O2Y.default),
    marketoForm: (0, $1bORF.default),
    migrationPlaceholder: (0, $96bxg.default),
    mobileApp: (0, $iSxa6.default),
    modal: (0, $lATol.default),
    page: (0, $3E1lH.default),
    pagination: (0, $7xYdG.default),
    panel: (0, $gebIf.default),
    personalizationContainer: (0, $9tius.default),
    pixelIcon: (0, $6b4fD.default),
    pixelRepelGrid: (0, $hTABe.default),
    pricingCalculator: (0, $aT8t4.default),
    pricingTable: (0, $eNJPT.default),
    productCard: (0, $lPMtR.default),
    pullQuote: (0, $ksvEJ.PullQuote),
    rovoHero: (0, $4LrCk.default),
    breadcrumbs: (0, $dm54q.default),
    breadcrumbLink: (0, $ezRYc.default),
    sideNav: (0, $71GXn.default),
    sideNavCollection: (0, $3DCiB.default),
    sideNavLink: (0, $acEyk.default),
    signUpForm: (0, $ies6q.default),
    simpleTableCell: (0, $a9JqH.default),
    singleStat: (0, $kSxbf.default),
    skeleton: (0, $5EeVR.default),
    slidingLayout: (0, $aeR15.default),
    staticPricingCards: (0, $4YxT8.default),
    subProduct: (0, $j4sH0.default),
    singleTab: (0, $dXwUh.default),
    speakers: (0, $4YtaH.default),
    splitBackgroundContainer: (0, $kfc2o.default),
    statsSection: (0, $3rWcE.UniformStatsSection),
    statsigExperimentContainer: (0, $2bofd.default),
    statsigFeatureGateContainer: (0, $3VYCw.default),
    subColumnLayout: (0, $82Z9J.UniformSubColumnLayout),
    table: (0, $fDTuB.default),
    tableColumnHeader: (0, $jrzD7.default),
    tableHeaderRow: (0, $hcVIx.default),
    tableRow: (0, $lyzDC.default),
    tabs12Col: (0, $evFps.default),
    tabs8Col: (0, $eWY7v.default),
    takeoverBanner: (0, $kov0f.default),
    teamworkGraph: (0, $gSQsG.default),
    templateModalButton: (0, $gP8Hr.default),
    templatePreview: (0, $cwpkM.default),
    filterableCard: (0, $76Hra.default),
    contentfulGalleryContainer: (0, $gQYRi.default),
    templatesSearchBar: (0, $eFi9k.default),
    terminalTyping: (0, $aQkGJ.default),
    text: (0, $11uBo.default),
    textWithIcon: (0, $hnLdc.default),
    thirdPartyEmbed: (0, $9VQLz.default),
    variant: (0, $3QKwy.default),
    variantContainer: (0, $lEcJc.default),
    valueProps: (0, $hTage.default),
    video: (0, $1GX5U.default),
    videoCarousel: (0, $fzMpf.default),
    webinarButton: (0, $10B1c.default),
    webinarForm: (0, $9Cjg1.default)
};
var $ccc1f30aa8c203e0$export$2e2bcd8739ae039 = $ccc1f30aa8c203e0$var$UNIFORM_DEFINITIONS;

});
parcelRegister("ksvEJ", function(module, exports) {
$parcel$export(module.exports, "PullQuote", function () { return $e3e126ce9d25b04e$export$f32a6ca59ed1d5d5; });
/* pull-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $e3e126ce9d25b04e$export$f32a6ca59ed1d5d5 = ({ quote: quote, quoteRichTextString: quoteRichTextString, authorName: authorName, authorDetails: authorDetails, size: size = 'small', variant: variant = 'basic', alignment: alignment = 'start' })=>{
    const quoteComponent = quoteRichTextString ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_hmk91wug _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kt912u0 _aetr1lzr",
            size === 'large' && variant === 'basic' ? 'callout-lg' : 'callout'
        ]),
        dangerouslySetInnerHTML: {
            __html: quoteRichTextString
        }
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_hmk91wug _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kt912u0 _aetr1lzr",
            size === 'large' && variant === 'basic' ? 'callout-lg' : 'callout'
        ]),
        children: quote
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _zulpu2gc _1rjcpxbi",
            alignment === 'center' && "_y3gn1h6o",
            variant === 'cutout' && "_zulppxbi _1mou74w7 _kqswh2mm _11q7uol8 _18zrxy5q _1rjcpxbi _1kt9b3bt _1cs8stnw _iajm1ld3 _z5wtidpf _1mp41osq _kfgt82ui _1s6kuol8 _tgsm13jo _aetrb3bt _18postnw _1guf11s5 _g0nfidpf _z0ai1osq _1qdg12bs _16r2uol8 _1oj4iz7d _umua1k7u _z4r91k7u _ecdx172j _tnqlq4g3 _ryq61nat _1l5u1lev _1ruvtyve _z1a1webb"
        ]),
        style: {
            "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("blockquote", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: quoteComponent
            }),
            (authorName || authorDetails) && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    authorName && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_k48p53lb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "body-lg"
                        ]),
                        children: authorName
                    }),
                    authorDetails && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "eyebrow-md"
                        ]),
                        children: authorDetails
                    })
                ]
            })
        ]
    });
};
const $e3e126ce9d25b04e$var$commonStyling = null;
const $e3e126ce9d25b04e$var$centeredStyling = null;
const $e3e126ce9d25b04e$var$cutoutStyling = null;
const $e3e126ce9d25b04e$var$quoteContainerStyling = null;
const $e3e126ce9d25b04e$var$quoteStyling = null;
const $e3e126ce9d25b04e$var$authorNameStyling = null;
const $e3e126ce9d25b04e$var$authorDetailsStyling = null;

});

parcelRegister("4JOZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a332e2a761197bf6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $dZNgt = parcelRequire("dZNgt");

var $6cu9L = parcelRequire("6cu9L");

var $lTkkF = parcelRequire("lTkkF");

var $d2ttO = parcelRequire("d2ttO");

var $f9rY4 = parcelRequire("f9rY4");
const $a332e2a761197bf6$var$pricingTableMarker = /<div data-pricing-tiers-table="([^"]+)"><\/div>/g;
const $a332e2a761197bf6$var$UniformAccordion = (props)=>{
    const { header: header, anchorId: anchorId, textBody: textBody, richText: richText } = props;
    const section = (0, $d2ttO.useAccordionsSection)();
    const sectionItemId = (0, $1oC0p.useId)();
    (0, $1oC0p.useEffect)(()=>{
        if (!section) return;
        section.register(sectionItemId);
        return ()=>section.unregister(sectionItemId);
    }, [
        section?.register,
        section?.unregister,
        sectionItemId
    ]);
    const richTextContent = richText?.split($a332e2a761197bf6$var$pricingTableMarker).map((part, index)=>index % 2 === 0 ? part ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: part
        }, index) : null : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f9rY4.default), {
            ...JSON.parse(decodeURIComponent(part))
        }, index));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6cu9L.Accordion), {
        header: header,
        id: anchorId,
        isOpen: section ? section.openItems[sectionItemId] ?? false : undefined,
        onOpenChange: section ? (isOpen)=>section.setOpen(sectionItemId, isOpen) : undefined,
        headingElement: section?.headingElement === 'h3' ? 'h4' : 'h3',
        content: richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: richTextContent
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : textBody
    });
};
var $a332e2a761197bf6$export$2e2bcd8739ae039 = $a332e2a761197bf6$var$UniformAccordion;

});
parcelRegister("dZNgt", function(module, exports) {
$parcel$export(module.exports, "isRichTextNodeType", function () { return $a3072fd4d6f8ea7f$export$76356ac770fe566f; });
$parcel$export(module.exports, "isRichTextValueConsideredEmpty", function () { return $a3072fd4d6f8ea7f$export$3113f85f4f2c043b; });
$parcel$export(module.exports, "getRichTextTagsFromTextFormat", function () { return $a3072fd4d6f8ea7f$export$5a89a4161bd9ebd2; });
$parcel$export(module.exports, "renderToText", function () { return $a3072fd4d6f8ea7f$export$f21c5276b1e9847a; });
$parcel$export(module.exports, "walkRichTextTree", function () { return $a3072fd4d6f8ea7f$export$5a4dbd7b3859d56e; });
// src/elements.ts
var $a3072fd4d6f8ea7f$var$rendererTypeTagMap = /* @__PURE__ */ new Map([
    [
        "linebreak",
        [
            "br"
        ]
    ],
    [
        "quote",
        [
            "blockquote"
        ]
    ],
    [
        "code",
        [
            "pre",
            "code"
        ]
    ]
]);
function $a3072fd4d6f8ea7f$export$a4ec677d66b3eef3(text) {
    return text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $a3072fd4d6f8ea7f$export$8553002765ef8155(format) {
    return Boolean(format && [
        "center",
        "end",
        "justify",
        "left",
        "right",
        "start"
    ].includes(format));
}
function $a3072fd4d6f8ea7f$export$2d8458e4858dd6bc(direction) {
    return Boolean(direction && [
        "ltr",
        "rtl"
    ].includes(direction));
}
var $a3072fd4d6f8ea7f$var$voidElements = /* @__PURE__ */ new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "source",
    "track",
    "wbr"
]);
function $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, attributes, children) {
    const attributesString = attributes && attributes.size > 0 ? " " + Array.from(attributes).reduce((result, [key, value])=>[
            ...result,
            `${key}="${$a3072fd4d6f8ea7f$export$a4ec677d66b3eef3(value)}"`
        ], []).join(" ") : "";
    return $a3072fd4d6f8ea7f$var$voidElements.has(tag) ? `<${tag}${attributesString}>` : `<${tag}${attributesString}>${children != null ? children : ""}</${tag}>`;
}
// src/guards.ts
function $a3072fd4d6f8ea7f$export$70f15e3e004ad6dd(arr) {
    return Array.isArray(arr) && arr.length > 0;
}
function $a3072fd4d6f8ea7f$export$5397ae48e85521ee(node) {
    return !!node && typeof node === "object" && "type" in node;
}
function $a3072fd4d6f8ea7f$export$bce37bf8275274bb(value) {
    return typeof value === "object" && value !== null && "root" in value && $a3072fd4d6f8ea7f$export$5397ae48e85521ee(value.root);
}
function $a3072fd4d6f8ea7f$export$76356ac770fe566f(node, type) {
    return $a3072fd4d6f8ea7f$export$5397ae48e85521ee(node) && node.type === type;
}
function $a3072fd4d6f8ea7f$export$3113f85f4f2c043b(value) {
    if (!value) return true;
    if (value.root.children.length === 0) return true;
    if (value.root.children.length > 1) return false;
    const child = value.root.children[0];
    if (!$a3072fd4d6f8ea7f$export$76356ac770fe566f(child, "paragraph")) return false;
    return !$a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(child);
}
function $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(node) {
    return "children" in node && $a3072fd4d6f8ea7f$export$70f15e3e004ad6dd(node.children);
}
// src/nodes/asset.ts
var $a3072fd4d6f8ea7f$export$7b8470edeb266d2d = ({ context: context })=>{
    var _a, _b;
    const node = context.currentNode;
    if (node.__asset === void 0) return "";
    if (node.__asset.type !== "image") return "";
    const imgAttributes = /* @__PURE__ */ new Map();
    imgAttributes.set("src", node.__asset.fields.url.value);
    if ((_a = node.__asset.fields.title) == null ? void 0 : _a.value) imgAttributes.set("alt", node.__asset.fields.title.value);
    const img = $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("img", imgAttributes);
    const figcaption = ((_b = node.__asset.fields.description) == null ? void 0 : _b.value) ? $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("figcaption", null, node.__asset.fields.description.value) : "";
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("figure", null, `${img}${figcaption}`);
};
// src/nodes/heading.ts
var $a3072fd4d6f8ea7f$export$bf6388ba992fa09c = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "h1", null, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$headingTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/link.ts
var $a3072fd4d6f8ea7f$export$936fe693edb52ead = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const htmlAttrs = $a3072fd4d6f8ea7f$export$448f6a3f2f14a6d1(node.link);
    const attributes = new Map(Object.entries(htmlAttrs));
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("a", attributes, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$DENYLIST_EXACT = /* @__PURE__ */ new Set([
    "href",
    "src",
    "style",
    "formaction"
]);
var $a3072fd4d6f8ea7f$var$EVENT_HANDLER_PATTERN = /^on/i;
var $a3072fd4d6f8ea7f$var$SAFE_ATTRIBUTE_NAME_PATTERN = /^[A-Za-z][A-Za-z0-9:_.-]*$/;
var $a3072fd4d6f8ea7f$var$DANGEROUS_SCHEME_PATTERN = /^(?:javascript|data|vbscript):/i;
function $a3072fd4d6f8ea7f$var$hasDangerousScheme(value) {
    const normalized = value.replace(/[\u0000-\u0020\u007f-\u00a0]+/g, "").toLowerCase();
    return $a3072fd4d6f8ea7f$var$DANGEROUS_SCHEME_PATTERN.test(normalized);
}
function $a3072fd4d6f8ea7f$export$d5b64517003f37ad(key) {
    return $a3072fd4d6f8ea7f$var$EVENT_HANDLER_PATTERN.test(key) || $a3072fd4d6f8ea7f$var$DENYLIST_EXACT.has(key.toLowerCase());
}
function $a3072fd4d6f8ea7f$export$448f6a3f2f14a6d1(link) {
    var _a;
    const result = {};
    const href = $a3072fd4d6f8ea7f$export$14401f8b485975ea(link);
    if (href) result.href = href;
    if (!(link == null ? void 0 : link.attributes)) return result;
    for (const [key, value] of Object.entries(link.attributes)){
        if (!key || typeof value !== "string") continue;
        if (!$a3072fd4d6f8ea7f$var$SAFE_ATTRIBUTE_NAME_PATTERN.test(key)) continue;
        if ($a3072fd4d6f8ea7f$var$EVENT_HANDLER_PATTERN.test(key)) continue;
        if ($a3072fd4d6f8ea7f$var$DENYLIST_EXACT.has(key.toLowerCase())) continue;
        if ($a3072fd4d6f8ea7f$var$hasDangerousScheme(value)) continue;
        result[key] = value;
    }
    const targetEntry = Object.entries(result).find(([key])=>key.toLowerCase() === "target");
    const hasRel = Object.keys(result).some((key)=>key.toLowerCase() === "rel");
    if (((_a = targetEntry == null ? void 0 : targetEntry[1]) == null ? void 0 : _a.toLowerCase()) === "_blank" && !hasRel) result.rel = "noopener noreferrer";
    return result;
}
function $a3072fd4d6f8ea7f$export$121e9031016ca3ae(link) {
    const raw = $a3072fd4d6f8ea7f$export$448f6a3f2f14a6d1(link);
    const result = {};
    for (const [key, value] of Object.entries(raw))if (key === "class") result["className"] = value;
    else result[key] = value;
    return result;
}
function $a3072fd4d6f8ea7f$export$14401f8b485975ea(link) {
    switch(link == null ? void 0 : link.type){
        case "email":
            return `mailto:${link.path}`;
        case "tel":
            return `tel:${link.path}`;
        case "url":
        case "projectMapNode":
            if ($a3072fd4d6f8ea7f$var$hasDangerousScheme(link.path)) {
                console.warn(`[richtext] Dropped disallowed link URL scheme: "${link.path}"`);
                return void 0;
            }
            return link.path;
    }
}
// src/nodes/list.ts
var $a3072fd4d6f8ea7f$export$7d9d55832c255604 = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (node.start > 1) attributes.set("start", node.start.toString());
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "ul", attributes, renderChildren(context.currentNode.children));
};
// src/nodes/listitem.ts
var $a3072fd4d6f8ea7f$export$7db814f6895f686a = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (Number.isFinite(node.value) && node.value > 0) attributes.set("value", node.value.toString());
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("li", attributes, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$listitemTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    if (!$a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode)) return "";
    const childrenRendered = renderChildren(context.currentNode.children);
    if (childrenRendered.endsWith(" ")) return childrenRendered;
    return `${childrenRendered} `;
};
// src/nodes/paragraph.ts
var $a3072fd4d6f8ea7f$export$8bcf4977d6029c8 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if ($a3072fd4d6f8ea7f$export$8553002765ef8155(node.format)) attributes.set("style", `text-align: ${node.format};`);
    if ($a3072fd4d6f8ea7f$export$2d8458e4858dd6bc(node.direction)) attributes.set("dir", node.direction);
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("p", attributes, $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "<br>");
};
var $a3072fd4d6f8ea7f$var$paragraphTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/root.ts
var $a3072fd4d6f8ea7f$export$1a6e4df79d5098f8 = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "";
};
// src/nodes/table.ts
var $a3072fd4d6f8ea7f$export$29b37b9cb24833f8 = ({ context: context, renderChildren: renderChildren })=>{
    return [
        "table",
        "tbody"
    ].reduceRight((children, tag)=>{
        return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, children);
    }, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$tableTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/tablecell.ts
var $a3072fd4d6f8ea7f$export$5bdbd5436df1f109 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const tag = $a3072fd4d6f8ea7f$export$37fd5c6d3c00d303(node.headerState);
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$tablecellTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
function $a3072fd4d6f8ea7f$export$37fd5c6d3c00d303(headerState) {
    if (headerState === 0) return "td";
    return "th";
}
// src/nodes/tablerow.ts
var $a3072fd4d6f8ea7f$export$28c41253e2c9901a = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("tr", null, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$tablerowTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/text.ts
var $a3072fd4d6f8ea7f$export$56ed6376d093860 = ({ context: context })=>{
    const node = context.currentNode;
    const tags = $a3072fd4d6f8ea7f$export$5a89a4161bd9ebd2(node.format);
    const pureText = $a3072fd4d6f8ea7f$export$a4ec677d66b3eef3(node.text);
    return tags.length === 0 ? pureText : tags.reduceRight((children, tag)=>{
        return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, children);
    }, pureText);
};
var $a3072fd4d6f8ea7f$var$textTextRenderer = ({ context: context })=>{
    const node = context.currentNode;
    return node.text;
};
function $a3072fd4d6f8ea7f$export$5a89a4161bd9ebd2(format) {
    const tags = [];
    if (format & 1) tags.push("strong");
    if (format & 2) tags.push("em");
    if (format & 4) tags.push("s");
    if (format & 8) tags.push("u");
    if (format & 16) tags.push("code");
    if (format & 32) tags.push("sub");
    if (format & 64) tags.push("sup");
    return tags;
}
// src/nodes/tab.ts
var $a3072fd4d6f8ea7f$var$tabHtmlRenderer = ()=>{
    return "	";
};
var $a3072fd4d6f8ea7f$var$tabTextRenderer = ()=>{
    return "	";
};
// src/renderToHtml.ts
var $a3072fd4d6f8ea7f$var$rendererTypeMap = /* @__PURE__ */ new Map([
    [
        "heading",
        $a3072fd4d6f8ea7f$export$bf6388ba992fa09c
    ],
    [
        "link",
        $a3072fd4d6f8ea7f$export$936fe693edb52ead
    ],
    [
        "list",
        $a3072fd4d6f8ea7f$export$7d9d55832c255604
    ],
    [
        "listitem",
        $a3072fd4d6f8ea7f$export$7db814f6895f686a
    ],
    [
        "paragraph",
        $a3072fd4d6f8ea7f$export$8bcf4977d6029c8
    ],
    [
        "root",
        $a3072fd4d6f8ea7f$export$1a6e4df79d5098f8
    ],
    [
        "text",
        $a3072fd4d6f8ea7f$export$56ed6376d093860
    ],
    [
        "tab",
        $a3072fd4d6f8ea7f$var$tabHtmlRenderer
    ],
    [
        "table",
        $a3072fd4d6f8ea7f$export$29b37b9cb24833f8
    ],
    [
        "tablecell",
        $a3072fd4d6f8ea7f$export$5bdbd5436df1f109
    ],
    [
        "tablerow",
        $a3072fd4d6f8ea7f$export$28c41253e2c9901a
    ],
    [
        "asset",
        $a3072fd4d6f8ea7f$export$7b8470edeb266d2d
    ]
]);
var $a3072fd4d6f8ea7f$export$28174e313edd87cd = (context)=>{
    const renderer = $a3072fd4d6f8ea7f$var$rendererTypeMap.get(context.currentNode.type);
    if (renderer) return renderer;
    const tags = $a3072fd4d6f8ea7f$var$rendererTypeTagMap.get(context.currentNode.type);
    if (tags) return ({ renderChildren: renderChildren })=>{
        var _a;
        return (_a = tags.reduceRight((children, tag)=>{
            return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, children);
        }, $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : void 0)) != null ? _a : "";
    };
    return ()=>`<!-- WARNING: No renderer for type ${context.currentNode.type} -->`;
};
function $a3072fd4d6f8ea7f$var$initializeRenderContext(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return {
        ...parentContext != null ? parentContext : {},
        currentNode: node,
        ancestorNodes: ancestorNodes
    };
}
function $a3072fd4d6f8ea7f$export$32f1246b4326e182(node, parentContext) {
    var _a;
    if (!$a3072fd4d6f8ea7f$export$5397ae48e85521ee(node)) return "";
    const context = $a3072fd4d6f8ea7f$var$initializeRenderContext(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $a3072fd4d6f8ea7f$export$28174e313edd87cd(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$a3072fd4d6f8ea7f$export$e4421ac256b62cb6(children, context);
    if (renderer) return renderer({
        context: context,
        renderChildren: renderChildren
    });
    else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $a3072fd4d6f8ea7f$export$e4421ac256b62cb6(children, context) {
    return Array.isArray(children) ? children.map((node)=>$a3072fd4d6f8ea7f$export$32f1246b4326e182(node, context)).join("") : "";
}
// src/nodes/linebreak.ts
var $a3072fd4d6f8ea7f$var$linebreakTextRenderer = ()=>{
    return " ";
};
// src/renderToText.ts
var $a3072fd4d6f8ea7f$var$rendererTypeMap2 = /* @__PURE__ */ new Map([
    [
        "text",
        $a3072fd4d6f8ea7f$var$textTextRenderer
    ],
    [
        "tab",
        $a3072fd4d6f8ea7f$var$tabTextRenderer
    ],
    [
        "linebreak",
        $a3072fd4d6f8ea7f$var$linebreakTextRenderer
    ],
    [
        "paragraph",
        $a3072fd4d6f8ea7f$var$paragraphTextRenderer
    ],
    [
        "listitem",
        $a3072fd4d6f8ea7f$var$listitemTextRenderer
    ],
    [
        "heading",
        $a3072fd4d6f8ea7f$var$headingTextRenderer
    ],
    [
        "table",
        $a3072fd4d6f8ea7f$var$tableTextRenderer
    ],
    [
        "tablecell",
        $a3072fd4d6f8ea7f$var$tablecellTextRenderer
    ],
    [
        "tablerow",
        $a3072fd4d6f8ea7f$var$tablerowTextRenderer
    ]
]);
var $a3072fd4d6f8ea7f$export$dd531e7b53a0cbec = (context)=>{
    const renderer = $a3072fd4d6f8ea7f$var$rendererTypeMap2.get(context.currentNode.type);
    if (renderer) return renderer;
    return ({ context: context2, renderChildren: renderChildren })=>{
        return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context2.currentNode) ? renderChildren(context2.currentNode.children) : "";
    };
};
function $a3072fd4d6f8ea7f$var$initializeRenderContext2(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return {
        ...parentContext != null ? parentContext : {},
        currentNode: node,
        ancestorNodes: ancestorNodes
    };
}
function $a3072fd4d6f8ea7f$export$f21c5276b1e9847a(node, parentContext) {
    var _a;
    if (!$a3072fd4d6f8ea7f$export$5397ae48e85521ee(node)) return "";
    const context = $a3072fd4d6f8ea7f$var$initializeRenderContext2(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $a3072fd4d6f8ea7f$export$dd531e7b53a0cbec(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$a3072fd4d6f8ea7f$export$6ba9468a0a4c5ffc(children, context);
    if (renderer) {
        const rendered = renderer({
            context: context,
            renderChildren: renderChildren
        });
        return context.ancestorNodes.length > 0 ? rendered : rendered.trim();
    } else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $a3072fd4d6f8ea7f$export$6ba9468a0a4c5ffc(children, context) {
    return Array.isArray(children) ? children.map((node)=>$a3072fd4d6f8ea7f$export$f21c5276b1e9847a(node, context)).join("") : "";
}
// src/types.ts
function $a3072fd4d6f8ea7f$export$cfe6cc97d98b211b(entry) {
    var _a;
    return {
        key: entry.key,
        options: entry.options,
        label: (_a = entry.label) != null ? _a : entry.key,
        helpText: entry.helpText
    };
}
// src/utils.ts
var $a3072fd4d6f8ea7f$export$5a4dbd7b3859d56e = (node, callback, parent)=>{
    if (!$a3072fd4d6f8ea7f$export$5397ae48e85521ee(node)) return;
    callback(node, parent);
    if (Array.isArray(node.children)) {
        let i = 0;
        while(node.children.length > i){
            $a3072fd4d6f8ea7f$export$5a4dbd7b3859d56e(node.children[i], callback, node);
            i += 1;
        }
    }
};
var $a3072fd4d6f8ea7f$export$4593e5e0513f0a70 = [
    {
        label: "Heading 1",
        type: "h1"
    },
    {
        label: "Heading 2",
        type: "h2"
    },
    {
        label: "Heading 3",
        type: "h3"
    },
    {
        label: "Heading 4",
        type: "h4"
    },
    {
        label: "Heading 5",
        type: "h5"
    },
    {
        label: "Heading 6",
        type: "h6"
    },
    {
        label: "Bullet List",
        type: "unorderedList"
    },
    {
        label: "Ordered List",
        type: "orderedList"
    },
    {
        label: "Link",
        type: "link"
    },
    {
        label: "Blockquote",
        type: "quote"
    },
    {
        label: "Code Block",
        type: "code"
    },
    {
        label: "Table",
        type: "table"
    },
    {
        label: "Asset",
        type: "asset"
    },
    {
        label: "Dynamic Token",
        type: "variable"
    }
];
var $a3072fd4d6f8ea7f$export$1c57de179d11d54c = [
    {
        label: "Bold",
        type: "bold"
    },
    {
        label: "Italic",
        type: "italic"
    },
    {
        label: "Underline",
        type: "underline"
    },
    {
        label: "Strikethrough",
        type: "strikethrough"
    },
    {
        label: "Code",
        type: "code"
    },
    {
        label: "Superscript",
        type: "superscript"
    },
    {
        label: "Subscript",
        type: "subscript"
    }
];
var $a3072fd4d6f8ea7f$export$401e495ff5af005a = (type)=>{
    var _a;
    if (type === "paragraph") return "Normal";
    const element = $a3072fd4d6f8ea7f$export$4593e5e0513f0a70.find((element2)=>element2.type === type);
    return (_a = element == null ? void 0 : element.label) != null ? _a : type;
};
var $a3072fd4d6f8ea7f$export$419f7a872c5c801f = (type)=>{
    var _a;
    const format = $a3072fd4d6f8ea7f$export$1c57de179d11d54c.find((element)=>element.type === type);
    return (_a = format == null ? void 0 : format.label) != null ? _a : type;
};
var $a3072fd4d6f8ea7f$export$ea67c934009c1e06 = {
    root: {
        type: "root",
        version: 1,
        direction: null,
        format: "",
        indent: 0,
        children: [
            {
                type: "paragraph",
                version: 1,
                format: "start",
                indent: 0,
                direction: null,
                children: [],
                textFormat: 0,
                textStyle: ""
            }
        ]
    }
};
var $a3072fd4d6f8ea7f$export$730a30483768c78a = {
    required: false,
    formatting: {
        builtIn: $a3072fd4d6f8ea7f$export$1c57de179d11d54c.map((format)=>format.type)
    },
    elements: {
        builtIn: $a3072fd4d6f8ea7f$export$4593e5e0513f0a70.map((element)=>element.type)
    },
    elementsConfig: {
        asset: {
            allowedTypes: [
                "image"
            ]
        }
    }
};

});

parcelRegister("6cu9L", function(module, exports) {
$parcel$export(module.exports, "Accordion", function () { return $77686e2e3b01bc1f$export$a766cd26d0d69044; });
/* accordion.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $akmzh = parcelRequire("akmzh");

var $1uTEn = parcelRequire("1uTEn");
const $77686e2e3b01bc1f$export$a766cd26d0d69044 = (props)=>{
    const { header: header, content: content, id: id, isOpen: controlledIsOpen, onOpenChange: onOpenChange, headingElement: headingElement = 'h3' } = props;
    const [localIsOpen, setLocalIsOpen] = (0, $1oC0p.useState)(false);
    const isOpen = controlledIsOpen ?? localIsOpen;
    const headingId = (0, $1oC0p.useId)();
    const contentId = (0, $1oC0p.useId)();
    const HeadingTag = headingElement;
    const handleToggle = ()=>{
        if (controlledIsOpen !== undefined) onOpenChange?.(!isOpen);
        else setLocalIsOpen((open)=>!open);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        id: id || undefined,
        className: (0, $2jatx.default)([
            "_1bsb1osq _179rn5xp _1yt41ejb _5hz2ftjs _b2tjftjs"
        ]),
        style: {
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c1txw _4cvr1h6o _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)(HeadingTag, {
                        id: headingId,
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1ul9idpf _16jlkb7n _lcxvglyw",
                            "card-title-sm"
                        ]),
                        children: header
                    }),
                    id && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $akmzh.AccordionCopyLink), {
                        id: id,
                        header: header
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1o9zidpf _lcxvglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1uTEn.TogglerIcon), {
                            icon: isOpen ? 'minus' : 'plus'
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        "aria-expanded": isOpen,
                        "aria-controls": contentId,
                        "aria-labelledby": headingId,
                        onClick: handleToggle,
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1r04idpf _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _bfhk1j28 _80omtlke _1ygb19d8 _1ah31b66"
                        ]),
                        style: {
                            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                id: contentId,
                "aria-hidden": !isOpen,
                className: (0, $2jatx.default)([
                    "_1kz6idpf _1q51idpf _18m9zryt _3um015vq _cj1815vq _tw1z1t97 _k8m01w63 _1oec1doz _1s9z1a5r _6fl41ytf _156yru3m",
                    isOpen && "_1kz61wug _1q51pxbi _3um0ewfl _cj18ewfl"
                ]),
                children: content
            })
        ]
    });
};
const $77686e2e3b01bc1f$var$containerCss = null;
const $77686e2e3b01bc1f$var$headerContainerCss = null;
const $77686e2e3b01bc1f$var$toggleButtonCss = null;
const $77686e2e3b01bc1f$var$togglerContainerCss = null;
const $77686e2e3b01bc1f$var$headerCss = null;
const $77686e2e3b01bc1f$var$contentCss = null;
const $77686e2e3b01bc1f$var$contentOpenCss = null;

});
parcelRegister("akmzh", function(module, exports) {
$parcel$export(module.exports, "AccordionCopyLink", function () { return $1db223e84ab01a02$export$736d3cebb86626b; });
/* accordion-copy-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $8DbjG = parcelRequire("8DbjG");

var $gqkLW = parcelRequire("gqkLW");

var $FapDU = parcelRequire("FapDU");

var $kbpa7 = parcelRequire("kbpa7");
const $1db223e84ab01a02$export$736d3cebb86626b = (props)=>{
    const { id: id, header: header } = props;
    const intl = (0, $8e22h.default)();
    const [copied, setCopied] = (0, $1oC0p.useState)(false);
    const tooltipContent = copied ? intl.formatMessage({
        id: 'Accordion.CopyLink.copied',
        defaultMessage: 'Copied!'
    }) : intl.formatMessage({
        id: 'Accordion.CopyLink.tooltip',
        defaultMessage: 'Copy link to heading'
    });
    const handleCopy = async ()=>{
        setCopied(false);
        const url = new URL(window.location.href);
        url.hash = id;
        try {
            await navigator.clipboard.writeText(url.toString());
            setCopied(true);
        } catch  {}
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c116y _1o9zidpf _1pbykb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqkLW.default), {
                content: tooltipContent,
                delay: 0,
                children: (tooltipProps)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        ...tooltipProps,
                        type: "button",
                        "aria-label": intl.formatMessage({
                            id: 'Accordion.CopyLink.label',
                            defaultMessage: 'Copy link to {heading}'
                        }, {
                            heading: header
                        }),
                        onClick: handleCopy,
                        className: (0, $2jatx.default)([
                            "_1e0c116y _4cvr1h6o _1bah1h6o _1bsbxy5q _4t3ixy5q _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _bfhk1j28 _syazftjs _80omtlke _1ygb19d8 _1ah31b66"
                        ]),
                        style: {
                            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DbjG))), {
                            label: ""
                        })
                    })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    role: "status",
                    children: copied && tooltipContent
                })
            })
        ]
    });
};
const $1db223e84ab01a02$var$copyLinkContainerCss = null;
const $1db223e84ab01a02$var$copyLinkCss = null;

});

parcelRegister("1uTEn", function(module, exports) {
$parcel$export(module.exports, "TogglerIcon", function () { return $2ac222beeecd6cd9$export$bc229f4f272e226c; });
/* toggler-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $2ac222beeecd6cd9$export$bc229f4f272e226c = (props)=>{
    const { icon: icon } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q7ftjs _2rko1ssb _4t3i1tcg _v56488n5 _1bsb1tcg _1ul91tcg _wtqc14w8 _pmf41sub _ts4v19bv _49x519bv _1mf219bv _12h0b3bt _s971b3bt _229db3bt _1st5stnw _vuffstnw _kd02stnw _hpnvidpf _kzlzidpf _sdl2idpf _yj65idpf _y2jtidpf _1v8kidpf _10t5idpf _tz0cidpf _11hpidpf _l73cidpf _1ewaidpf _12tkidpf _107y1afi _1br21afi _qnpf1afi _aze81wug _8u7c1wug _19dq1wug _144j14y2 _iui614y2 _6v8s14y2 _1faz1wug _1ew01wug _3r7i1wug _1oz314y2 _18xc14y2 _u63c14y2 _1xlyyh40 _kotoyh40 _6zj4yh40 _6zj41wug _ornayh40 _19dq14y2 _6v8s1wug _3r7i14y2 _u63c1wug",
            icon
        ]),
        "aria-hidden": "true",
        style: {
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        }
    });
};
const $2ac222beeecd6cd9$var$togglerIconCss = null;

});


parcelRegister("d2ttO", function(module, exports) {
$parcel$export(module.exports, "useAccordionsSection", function () { return $546268e16eca53be$export$56d080a95f928a6a; });
$parcel$export(module.exports, "default", function () { return $546268e16eca53be$export$2e2bcd8739ae039; });
/* accordions-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
const $546268e16eca53be$var$AccordionsSectionContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $546268e16eca53be$export$56d080a95f928a6a = ()=>(0, $1oC0p.useContext)($546268e16eca53be$var$AccordionsSectionContext);
const $546268e16eca53be$var$UniformAccordionsSection = (props)=>{
    const { heading: heading, headingElement: headingElement = 'h2', children: children } = props;
    const intl = (0, $8e22h.default)();
    const headingId = (0, $1oC0p.useId)();
    const toggleId = (0, $1oC0p.useId)();
    const [openItems, setOpenItems] = (0, $1oC0p.useState)({});
    const itemIds = Object.keys(openItems);
    const allOpen = itemIds.length > 0 && itemIds.every((id)=>openItems[id]);
    const HeadingTag = headingElement;
    const register = (0, $1oC0p.useCallback)((id)=>{
        setOpenItems((items)=>id in items ? items : {
                ...items,
                [id]: false
            });
    }, []);
    const unregister = (0, $1oC0p.useCallback)((id)=>{
        setOpenItems((items)=>{
            if (!(id in items)) return items;
            const nextItems = {
                ...items
            };
            delete nextItems[id];
            return nextItems;
        });
    }, []);
    const setOpen = (0, $1oC0p.useCallback)((id, isOpen)=>{
        setOpenItems((items)=>({
                ...items,
                [id]: isOpen
            }));
    }, []);
    const toggleAll = ()=>{
        setOpenItems((items)=>Object.fromEntries(Object.keys(items).map((id)=>[
                    id,
                    !allOpen
                ])));
    };
    const contextValue = (0, $1oC0p.useMemo)(()=>({
            openItems: openItems,
            headingElement: headingElement,
            register: register,
            unregister: unregister,
            setOpen: setOpen
        }), [
        openItems,
        headingElement,
        register,
        unregister,
        setOpen
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($546268e16eca53be$var$AccordionsSectionContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            "aria-labelledby": headingId,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulppxbi _85i5pxbi"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)(HeadingTag, {
                            id: headingId,
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bozgv47k _y4tiv47k"
                            ]),
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            id: toggleId,
                            type: "button",
                            "aria-labelledby": `${toggleId} ${headingId}`,
                            onClick: toggleAll,
                            disabled: itemIds.length === 0,
                            className: (0, $2jatx.default)([
                                "_1o9zidpf _19itidpf _1yt4u2gc _bfhk1j28 _syazftjs _80omtlke _1ygb19d8 _1ah31b66"
                            ]),
                            style: {
                                "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                            },
                            children: allOpen ? intl.formatMessage({
                                id: 'AccordionsSection.hideAll',
                                defaultMessage: 'Hide all'
                            }) : intl.formatMessage({
                                id: 'AccordionsSection.showAll',
                                defaultMessage: 'Show all'
                            })
                        })
                    ]
                }),
                children ?? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: "accordions"
                })
            ]
        })
    });
};
var $546268e16eca53be$export$2e2bcd8739ae039 = $546268e16eca53be$var$UniformAccordionsSection;
const $546268e16eca53be$var$headerCss = null;
const $546268e16eca53be$var$headingCss = null;
const $546268e16eca53be$var$toggleCss = null;

});

parcelRegister("f9rY4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3eebc66b705411e7$export$2e2bcd8739ae039; });
/* pricing-tiers-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $hu3Tl = parcelRequire("hu3Tl");

var $fOfCM = parcelRequire("fOfCM");

var $bDMnL = parcelRequire("bDMnL");
const $3eebc66b705411e7$var$tableCss = null;
const $3eebc66b705411e7$var$captionCss = null;
const $3eebc66b705411e7$var$linkCss = null;
const $3eebc66b705411e7$var$headingCss = null;
const $3eebc66b705411e7$var$tierCss = null;
const $3eebc66b705411e7$var$priceCss = null;
const $3eebc66b705411e7$var$UniformPricingTiersTable = (props)=>{
    const { sku: sku, title: title, titleHref: titleHref, billingCycle: billingCycle, unit: unit = 'user', countryCode: countryCode = 'US' } = props;
    const intl = (0, $8e22h.default)();
    const [fetchedPricingData, setFetchedPricingData] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        if (!sku) return;
        let isCurrent = true;
        (0, $fOfCM.getPricingTiersTableData)({
            sku: sku
        }).then((data)=>{
            if (isCurrent) setFetchedPricingData({
                sku: sku,
                data: data
            });
        }).catch(()=>{
            if (isCurrent) setFetchedPricingData({
                sku: sku
            });
        });
        return ()=>{
            isCurrent = false;
        };
    }, [
        sku
    ]);
    const currency = (0, $hu3Tl.getCurrencyFromUserLocale)(countryCode);
    const offering = fetchedPricingData?.sku === sku ? fetchedPricingData.data : undefined;
    const plan = offering?.defaultPricingPlans?.find((item)=>item.primaryCycle_interval === billingCycle && item.currency === currency && item.type === 'COMMERCIAL' && item.status === 'ACTIVE' && item.activatedWithReason === 'DEFAULT_PRICING');
    const tiers = plan?.items?.[0]?.tiers;
    const tierHeadingByUnit = {
        user: (0, $bDMnL.pricingTiersTableMessages).userTierHeading,
        creator: (0, $bDMnL.pricingTiersTableMessages).creatorTierHeading,
        agent: (0, $bDMnL.pricingTiersTableMessages).agentTierHeading
    };
    const monthlyPriceByUnit = {
        user: (0, $bDMnL.pricingTiersTableMessages).monthlyUserPrice,
        creator: (0, $bDMnL.pricingTiersTableMessages).monthlyCreatorPrice,
        agent: (0, $bDMnL.pricingTiersTableMessages).monthlyAgentPrice
    };
    const tierHeading = intl.formatMessage(tierHeadingByUnit[unit]);
    const priceHeading = intl.formatMessage(billingCycle === 'MONTH' ? (0, $bDMnL.pricingTiersTableMessages).monthlyPriceHeading : (0, $bDMnL.pricingTiersTableMessages).annualPriceHeading);
    if (!tiers?.length) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
        "data-offering-sku": sku,
        className: (0, $2jatx.default)([
            "_1bsb1osq _1kqm1n9t _btyzv77o _y3gn1h6o _syazi7uo"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($3eebc66b705411e7$var$PricingTiersTableCaption, {
                title: title,
                titleHref: titleHref
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                            scope: "col",
                            className: (0, $2jatx.default)([
                                "_bfhk1s93 _1q51utpp _85i5utpp _bozgu2gc _y4tiu2gc _k48pi7a9"
                            ]),
                            children: tierHeading
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                            scope: "col",
                            className: (0, $2jatx.default)([
                                "_bfhk1s93 _1q51utpp _85i5utpp _bozgu2gc _y4tiu2gc _k48pi7a9"
                            ]),
                            children: priceHeading
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                children: tiers.map((tier)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                scope: "row",
                                className: (0, $2jatx.default)([
                                    "_bfhk1s93 _1q51utpp _85i5utpp _bozgu2gc _y4tiu2gc _k48pi7a9"
                                ]),
                                children: $3eebc66b705411e7$var$formatTierRange(tier)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                                className: (0, $2jatx.default)([
                                    "_bfhksm61 _1q51utpp _85i5utpp _bozgu2gc _y4tiu2gc"
                                ]),
                                children: billingCycle === 'MONTH' ? intl.formatMessage(monthlyPriceByUnit[unit], {
                                    price: $3eebc66b705411e7$var$formatTierPrice(tier, currency)
                                }) : $3eebc66b705411e7$var$formatTierPrice(tier, currency)
                            })
                        ]
                    }, `${tier.floor}-${tier.ceiling}`))
            })
        ]
    });
};
var $3eebc66b705411e7$export$2e2bcd8739ae039 = $3eebc66b705411e7$var$UniformPricingTiersTable;
const $3eebc66b705411e7$var$PricingTiersTableCaption = (props)=>{
    const { title: title, titleHref: titleHref } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("caption", {
        className: (0, $2jatx.default)([
            "_bfhk1s93 _1q51utpp _85i5utpp"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: titleHref,
            className: (0, $2jatx.default)([
                "_syaz13af _4bfu1r31 _1hms8stv _ajmmnqa1"
            ]),
            children: title
        })
    });
};
function $3eebc66b705411e7$var$formatTierRange(tier) {
    const floor = Math.max(1, tier.floor);
    const start = new Intl.NumberFormat('en-US').format(floor);
    if (!tier.ceiling || tier.ceiling < floor) return `${start}+`;
    return `${start} - ${new Intl.NumberFormat('en-US').format(tier.ceiling)}`;
}
function $3eebc66b705411e7$var$formatTierPrice(tier, currency) {
    const amount = tier.flatAmount || tier.unitAmount;
    const value = currency === 'USD' ? amount / 100 : amount;
    const locale = currency === 'JPY' ? 'ja-JP' : 'en-US';
    return `${currency} ${new Intl.NumberFormat(locale, {
        maximumFractionDigits: 2
    }).format(value)}`;
}

});
parcelRegister("fOfCM", function(module, exports) {
$parcel$export(module.exports, "getPricingTiersTableData", function () { return $8ac7878019d5d32a$export$5b0b8e73483250bc; });

var $61WdP = parcelRequire("61WdP");
async function $8ac7878019d5d32a$export$5b0b8e73483250bc(args) {
    const { sku: sku } = args;
    const client = (0, $61WdP.getContentfulProductCatalogClient)();
    const offerings = await client.getCCPPricingData([
        sku
    ]);
    return offerings[sku];
}

});

parcelRegister("bDMnL", function(module, exports) {
$parcel$export(module.exports, "pricingTiersTableMessages", function () { return $dda00e6fdb89008e$export$261d2a8bf28ffd15; });

var $fnHPc = parcelRequire("fnHPc");
const $dda00e6fdb89008e$export$261d2a8bf28ffd15 = (0, $fnHPc.defineMessages)({
    userTierHeading: {
        id: 'PricingTiersTable.userTierHeading',
        defaultMessage: 'Number of users'
    },
    creatorTierHeading: {
        id: 'PricingTiersTable.creatorTierHeading',
        defaultMessage: 'Number of creators'
    },
    agentTierHeading: {
        id: 'PricingTiersTable.agentTierHeading',
        defaultMessage: 'Number of agents'
    },
    monthlyPriceHeading: {
        id: 'PricingTiersTable.monthlyPriceHeading',
        defaultMessage: 'Price per month'
    },
    annualPriceHeading: {
        id: 'PricingTiersTable.annualPriceHeading',
        defaultMessage: 'Annual price'
    },
    monthlyUserPrice: {
        id: 'PricingTiersTable.monthlyUserPrice',
        defaultMessage: '{price} /user'
    },
    monthlyCreatorPrice: {
        id: 'PricingTiersTable.monthlyCreatorPrice',
        defaultMessage: '{price} /creator'
    },
    monthlyAgentPrice: {
        id: 'PricingTiersTable.monthlyAgentPrice',
        defaultMessage: '{price} /agent'
    }
});

});



parcelRegister("lqBhQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc3ec1ef37643663$export$2e2bcd8739ae039; });
/* animation-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $bNzAT = parcelRequire("bNzAT");
const $cc3ec1ef37643663$var$UniformAnimationWrapper = ({ animationName: animationName, duration: duration = 'motion.duration.0ms', easing: easing = 'motion.easing.constant', delay: delay = 'motion.delay.0ms', fillMode: fillMode = 'none', trigger: trigger = 'in-view' })=>{
    const [triggered, setTriggered] = (0, $1oC0p.useState)(trigger === 'load');
    const ref = (0, $1oC0p.useRef)(null);
    const isInViewMode = trigger === 'in-view' || trigger === 'in-view-once';
    (0, $1oC0p.useEffect)(()=>{
        if (!isInViewMode || !ref.current) return;
        const el = ref.current;
        const observer = new IntersectionObserver(([entry])=>{
            if (!entry) return;
            if (entry.isIntersecting) setTriggered(true);
            else if (trigger === 'in-view') setTriggered(false);
        }, {
            threshold: 0.1
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        trigger,
        isInViewMode
    ]);
    // Restart animation when re-entering view in "in-view" mode so it replays from the beginning
    (0, $1oC0p.useEffect)(()=>{
        if (trigger !== 'in-view' || !triggered || !ref.current) return;
        const el = ref.current;
        el.style.animationName = 'none';
        el.offsetHeight; // force reflow
        el.style.animationName = '';
    }, [
        trigger,
        triggered
    ]);
    const animationStyles = {
        // We will want to add logic to this to allow fades and only limit the translations, scales and other motion.
        // For right now we simply do not animate until we get clarity on design intent long term for WAC Refresh 2026
        '@media (prefers-reduced-motion: no-preference)': {
            animationName: (0, $bNzAT.default)(animationName),
            animationDuration: (0, $bNzAT.default)(duration),
            animationTimingFunction: (0, $bNzAT.default)(easing),
            animationDelay: (0, $bNzAT.default)(delay),
            animationFillMode: fillMode,
            animationPlayState: triggered ? 'running' : 'paused'
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        className: (0, $2jatx.default)([
            "_1cro18mb _wqfn1oj7 _1e0reic5 _sl5pz1s3 _dqw8pyqb _1c1q1l54",
            "animation-wrapper"
        ]),
        style: {
            "--_suaiuv": (0, $6ZVlx.default)((0, $bNzAT.default)(animationName)),
            "--_pnuefe": (0, $6ZVlx.default)((0, $bNzAT.default)(duration)),
            "--_1a43xu8": (0, $6ZVlx.default)((0, $bNzAT.default)(easing)),
            "--_2ye55a": (0, $6ZVlx.default)((0, $bNzAT.default)(delay)),
            "--_1jen591": (0, $6ZVlx.default)(fillMode),
            "--_db0xha": (0, $6ZVlx.default)(triggered ? 'running' : 'paused')
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content"
        })
    });
};
var $cc3ec1ef37643663$export$2e2bcd8739ae039 = $cc3ec1ef37643663$var$UniformAnimationWrapper;

});

parcelRegister("3wpTl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f7cd193ad4e26d6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $73mLU = parcelRequire("73mLU");

var $lTkkF = parcelRequire("lTkkF");
const $1f7cd193ad4e26d6$var$UniformArticleCta = (props)=>{
    const articleCtaProps = {
        ...props,
        copy: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.copy
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $73mLU.ArticleCta), {
        ...articleCtaProps,
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event-component': 'linkButton',
            'data-event-container': 'ctaSection',
            'data-event': 'clicked'
        }
    });
};
var $1f7cd193ad4e26d6$export$2e2bcd8739ae039 = $1f7cd193ad4e26d6$var$UniformArticleCta;

});
parcelRegister("73mLU", function(module, exports) {
$parcel$export(module.exports, "ArticleCta", function () { return $858e9386dc2085cf$export$441e3def6ec0f6dd; });
/* article-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");
const $858e9386dc2085cf$var$containerStyle = null;
const $858e9386dc2085cf$var$copyContainerStyle = null;
const $858e9386dc2085cf$var$ctaContainerStyle = null;
const $858e9386dc2085cf$var$noWrapLinkStyle = null;
const $858e9386dc2085cf$var$marginZeroCss = null;
const $858e9386dc2085cf$export$441e3def6ec0f6dd = (props)=>{
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `article-cta-title-${uniqueId}`;
    const buttonId = `article-cta-button-${uniqueId}`;
    const linkId = `article-cta-link-${uniqueId}`;
    const copyElement = typeof props.copy === 'string' ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1mouze3t"
        ]),
        children: props.copy
    }) : props.copy;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1bjw _2rko1ylz _1yt4xy5q _1e0c1txw _zulpxy5q _1bsb1ns9 _6ssj1ejb _1gde1bp4"
        ]),
        style: {
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1b66 _1bah1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        id: titleId,
                        className: (0, $2jatx.default)([
                            "_1mouze3t",
                            "card-title"
                        ]),
                        children: props.title
                    }),
                    props.copy && copyElement
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi _1bah1h6o _4cvr1h6o _ag851y6m",
                    "_sjfo1q9c"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                        id: buttonId,
                        variant: "primary",
                        size: "small",
                        color: "blue",
                        href: props.buttonHref,
                        ariaLabelledby: `${buttonId} ${titleId}`,
                        dataEventProps: props.dataEventProps,
                        children: props.buttonText
                    }),
                    props.linkText && props.linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        id: linkId,
                        text: props.linkText,
                        href: props.linkHref,
                        ariaLabelledby: `${linkId} ${titleId}`,
                        "aria-label": props.linkText,
                        dataEventProps: props.dataEventProps
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("1d9MG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44015486d9fa361e$export$2e2bcd8739ae039; });
/* background-video-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $aKeh7 = parcelRequire("aKeh7");

var $1iN19 = parcelRequire("1iN19");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $f6WjX = parcelRequire("f6WjX");
const $44015486d9fa361e$var$containerStyles = null;
const $44015486d9fa361e$var$contentStyles = null;
const $44015486d9fa361e$var$svgOverlayStyles = null;
const $44015486d9fa361e$var$backgroundVideoStyles = null;
const $44015486d9fa361e$var$headingStyles = null;
const $44015486d9fa361e$var$descriptionStyles = null;
const $44015486d9fa361e$var$controlButtonStyles = null;
const $44015486d9fa361e$var$UniformBackgroundVideoContainer = (props)=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const [isVisible, setIsVisible] = (0, $1oC0p.useState)(false);
    const videoRef = (0, $1oC0p.useRef)(null);
    const [isPlaying, setPlaying] = (0, $1oC0p.useState)(false);
    const { firePlayPauseClicked: firePlayPauseClicked } = (0, $f6WjX.useBackgroundVideoContainerAnalytics)();
    const [hasEnded, setHasEnded] = (0, $1oC0p.useState)(false);
    const [currentVideoSource, setCurrentVideoSource] = (0, $1oC0p.useState)('');
    const [windowWidth, setWindowWidth] = (0, $1oC0p.useState)(typeof globalThis.window !== 'undefined' ? globalThis.window.innerWidth : 1200);
    const [holeWidth, setHoleWidth] = (0, $1oC0p.useState)(1); // Separate width for rectangle
    const [holeHeight, setHoleHeight] = (0, $1oC0p.useState)(1); // Separate height for rectangle
    const [holeRadius, setHoleRadius] = (0, $1oC0p.useState)(300);
    const [containerDimensions, setContainerDimensions] = (0, $1oC0p.useState)({
        width: 0,
        height: 0
    });
    const intl = (0, $8e22h.default)();
    const prefersReducedMotion = typeof globalThis.window !== 'undefined' ? globalThis.window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
    // can turn the feature flag on to disable the overlay if it's glitchy
    const isAnimationOverlayEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7823AnimationOverlayOption);
    const computedWidth = containerDimensions.width || 1200;
    const computedHeight = containerDimensions.height || 700;
    const getVideoSource = (0, $1oC0p.useCallback)((width)=>{
        if (width >= 1024) return props.videoSourceDesktop;
        if (width >= 768) return props.videoSourceTablet;
        return props.videoSourceMobile;
    }, [
        props.videoSourceDesktop,
        props.videoSourceTablet,
        props.videoSourceMobile
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const handleResize = ()=>{
            if (typeof globalThis.window !== 'undefined') setWindowWidth(globalThis.window.innerWidth);
        };
        const updateVideoSource = (newSource)=>{
            if (newSource === currentVideoSource) return;
            setCurrentVideoSource(newSource);
            if (!videoRef.current) return;
            if (isPlaying) {
                const currentTime = videoRef.current.currentTime;
                videoRef.current.src = newSource;
                videoRef.current.load();
                videoRef.current.currentTime = currentTime;
                videoRef.current.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
            } else {
                videoRef.current.src = newSource;
                videoRef.current.load();
            }
        };
        const initialSource = getVideoSource(windowWidth);
        updateVideoSource(initialSource);
        if (typeof globalThis.window !== 'undefined') {
            globalThis.window.addEventListener('resize', handleResize);
            return ()=>globalThis.window.removeEventListener('resize', handleResize);
        }
        return undefined;
    }, [
        windowWidth,
        currentVideoSource,
        isPlaying,
        getVideoSource
    ]);
    const togglePlay = ()=>{
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
                firePlayPauseClicked('pause');
            } else {
                videoRef.current.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
                firePlayPauseClicked('play');
            }
        }
    };
    const handleVideoPlay = ()=>{
        setPlaying(true);
        setHasEnded(false);
    };
    const handleVideoPause = ()=>setPlaying(false);
    const handleVideoEnded = ()=>{
        setPlaying(false);
        setHasEnded(true);
    };
    const startHoleAnimation = (0, $1oC0p.useCallback)((containerElement)=>{
        const containerWidth = containerElement.offsetWidth;
        const containerHeight = containerElement.offsetHeight;
        setContainerDimensions({
            width: containerWidth,
            height: containerHeight
        });
        setTimeout(()=>{
            const startTime = Date.now();
            const duration = 800;
            const startSize = 1;
            const animationInterval = setInterval(()=>{
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = 1 - Math.pow(1 - progress, 3); // ease-out cubic
                const currentHoleWidth = startSize + (containerWidth - startSize) * easedProgress;
                const currentHoleHeight = startSize + (containerHeight - startSize) * easedProgress;
                const currentRadius = 300 * (1 - Math.min(progress * 1.5, 1));
                setHoleWidth(currentHoleWidth);
                setHoleHeight(currentHoleHeight);
                setHoleRadius(currentRadius);
                if (progress >= 1) clearInterval(animationInterval);
            }, 16);
        }, 800);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry?.isIntersecting) {
                setIsVisible(true);
                if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
                if (!prefersReducedMotion && containerRef.current && isAnimationOverlayEnabled) startHoleAnimation(containerRef.current);
                else if (containerRef.current && isAnimationOverlayEnabled) {
                    const containerWidth = containerRef.current.offsetWidth;
                    const containerHeight = containerRef.current.offsetHeight;
                    setContainerDimensions({
                        width: containerWidth,
                        height: containerHeight
                    });
                    setHoleWidth(containerWidth);
                    setHoleHeight(containerHeight);
                    setHoleRadius(0);
                }
            }
        }, {
            threshold: 0.3
        });
        if (containerRef.current) observer.observe(containerRef.current);
        return ()=>observer.disconnect();
    }, [
        prefersReducedMotion,
        startHoleAnimation,
        isAnimationOverlayEnabled
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_bfhksjoz _kqswh2mm _1reo15vq _18m915vq _4t3i1j7z _1gdlbcwg _1knekdgb"
        ]),
        style: {
            '--video-width-mobile': props.videoWidthMobile ? `${props.videoWidthMobile}px` : '500px',
            '--video-height-mobile': props.videoHeightMobile ? `${props.videoHeightMobile}px` : '700px',
            '--video-width-tablet': props.videoWidthTablet ? `${props.videoWidthTablet}px` : '800px',
            '--video-height-tablet': props.videoHeightTablet ? `${props.videoHeightTablet}px` : '1000px',
            '--video-width-desktop': props.videoWidthDesktop ? `${props.videoWidthDesktop}px` : '1200px',
            '--video-height-desktop': props.videoHeightDesktop ? `${props.videoHeightDesktop}px` : '700px',
            "--_8vca0i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                ref: videoRef,
                src: currentVideoSource,
                muted: true,
                loop: props.videoLoop || false,
                playsInline: true,
                onPlay: handleVideoPlay,
                onPause: handleVideoPause,
                onEnded: handleVideoEnded,
                className: (0, $2jatx.default)([
                    "_kqswstnw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152tidpf _u7coidpf _1pbykb7n _1e021l2x _rjxp1l2x _4t3i1j7z _1j7jwqo7 _19tlwqo7 _1gdlbcwg _nqop1vnc _1a5h1vnc _1knekdgb"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_tzy4idpf _kqswh2mm _1pbycs5v _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _y3gn1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _p12f1osq _4t3i1osq _1bsbbxu3 _w19j1ve8 _v5641v33 _1s4p1erl _14u4kb7n _22qt1amc",
                    isVisible ? 'animate-reveal' : ''
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_18s812pl _16cq1afi",
                            "video-heading"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: props.videoHeading
                    }),
                    props.videoDescription && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_163y1afi",
                            "video-description"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: props.videoDescription
                    }),
                    props.videoCta && props.videoCtaLink && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        "aria-label": props.videoCta,
                        href: props.videoCtaLink,
                        text: props.videoCta,
                        type: 'primary',
                        bgColor: "bgBlackBlue",
                        dataEventProps: {
                            'data-product-key': 'uniform',
                            'data-event': 'clicked',
                            'data-event-component': 'linkButton',
                            'data-event-container': 'videoContainer'
                        }
                    })
                ]
            }),
            !hasEnded && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: togglePlay,
                "aria-label": intl.formatMessage(isPlaying ? {
                    id: 'uniform-video.pause',
                    defaultMessage: 'Pause'
                } : {
                    id: 'uniform-video.play',
                    defaultMessage: 'Play'
                }),
                "aria-pressed": isPlaying,
                className: (0, $2jatx.default)([
                    "_80omtlke _tzy41ou4 _bfhk1j28 _syaz1afi _19it1axk _2rko1mv1 _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7copxbi _16l4kb7n _1ygb1qgu _1ah3yh40 _19lvkb7n _w8l5dlk8"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: isPlaying ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aKeh7))), {
                    label: intl.formatMessage({
                        id: 'uniform-video.pause',
                        defaultMessage: 'Pause'
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iN19))), {
                    label: intl.formatMessage({
                        id: 'uniform-video.play',
                        defaultMessage: 'Play'
                    })
                })
            }),
            isAnimationOverlayEnabled && /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                viewBox: `0 0 ${computedWidth} ${computedHeight}`,
                preserveAspectRatio: "none",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1pby11wp _lcxvglyw _1r04idpf _1bsb1osq _4t3i1osq _1lmqglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("mask", {
                            id: "hole-mask",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                                    width: computedWidth,
                                    height: computedHeight,
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                                    x: computedWidth / 2 - holeWidth / 2,
                                    y: computedHeight / 2 - holeHeight / 2,
                                    width: holeWidth,
                                    height: holeHeight,
                                    rx: holeRadius,
                                    ry: holeRadius,
                                    fill: "black"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: computedWidth,
                        height: computedHeight,
                        fill: (0, $kbpa7.wacToken)('color.neutral.light0'),
                        mask: "url(#hole-mask)"
                    })
                ]
            })
        ]
    });
};
var $44015486d9fa361e$export$2e2bcd8739ae039 = $44015486d9fa361e$var$UniformBackgroundVideoContainer;

});
parcelRegister("f6WjX", function(module, exports) {
$parcel$export(module.exports, "useBackgroundVideoContainerAnalytics", function () { return $6a37d2f15d9a1bb5$export$b171fc3ce9294fa; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
function $6a37d2f15d9a1bb5$export$b171fc3ce9294fa() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const firePlayPauseClicked = (0, $1oC0p.useCallback)((label)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'playPause',
            source: 'backgroundVideoContainer',
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        firePlayPauseClicked: firePlayPauseClicked
    };
}

});


parcelRegister("jgyhc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f03812964141fa1$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $2HoYQ = parcelRequire("2HoYQ");
const $4f03812964141fa1$var$UniformBannerAlert = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2HoYQ.BannerAlert), {
        ...props,
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event-component': 'linkButton',
            'data-event-container': 'bannerAlert',
            'data-event': 'clicked'
        }
    });
};
var $4f03812964141fa1$export$2e2bcd8739ae039 = $4f03812964141fa1$var$UniformBannerAlert;

});
parcelRegister("2HoYQ", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return $88b6e8b9726997a4$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $dE0sS = parcelRequire("dE0sS");

var $2gCne = parcelRequire("2gCne");
const $88b6e8b9726997a4$var$containerStyles = null;
const $88b6e8b9726997a4$var$paragraphStyles = null;
const $88b6e8b9726997a4$var$textStyles = null;
const $88b6e8b9726997a4$var$primaryInlineLinkStyles = null;
const $88b6e8b9726997a4$var$closeIconStyles = null;
const $88b6e8b9726997a4$var$containerDarkThemeStyles = null;
const $88b6e8b9726997a4$var$closeIconDarkThemeStyles = null;
const $88b6e8b9726997a4$export$4eb8f3e4e539379b = ({ id: id, text: text, linkText: linkText, linkUrl: linkUrl, ariaLabel: ariaLabel, dataEventProps: dataEventProps })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const bannerStorageItem = `BannerAlert_dismiss-${id}`;
    const closeLabel = intl.formatMessage({
        id: 'banner-alert.close.aria-label',
        defaultMessage: 'Close'
    });
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== '1') setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-dismissed": isHidden ? 'true' : undefined,
            className: (0, $2jatx.default)([
                "_bfhk1bjw _kqswh2mm _y4tioahv _d2ikoahv _1rjcutpp _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw",
                isDarkTheme && "_bfhkkhc1 _syaz1afi"
            ]),
            style: {
                "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
                "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000')),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    "aria-label": closeLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, '1');
                        createAnalyticsEvent({
                            eventType: 'ui',
                            action: 'clicked',
                            actionSubject: 'linkButton',
                            attributes: {
                                page_path: location?.pathname,
                                url: location?.href,
                                label: closeLabel,
                                labelEnglish: 'Close',
                                event: 'clicked',
                                eventComponent: 'linkButton',
                                eventContainer: 'bannerAlertClose'
                            }
                        }).fire();
                    },
                    className: (0, $2jatx.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1ygb1qgu _1ah3yh40",
                        isDarkTheme && "_1ygb1idu"
                    ]),
                    style: {
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_xvz68f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue400'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
                        size: "20",
                        color: isDarkTheme ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.primary.black')
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _10hl1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1lvau2gc"
                                ]),
                                children: text
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_tkqh1ule _sd3jutpp _dzos1o8l _1od5idpf"
                                ]),
                                children: linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    "aria-label": linkText,
                                    text: linkText,
                                    href: linkUrl,
                                    type: "inline",
                                    dataEventProps: dataEventProps,
                                    ariaLabel: ariaLabel
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});


parcelRegister("aiWEP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd88dea26fec7209$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $k8XNp = parcelRequire("k8XNp");
const $cd88dea26fec7209$var$UniformBitbucketSearchIntegration = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k8XNp.BitbucketPipelinesIntegrations), {});
};
var $cd88dea26fec7209$export$2e2bcd8739ae039 = $cd88dea26fec7209$var$UniformBitbucketSearchIntegration;

});
parcelRegister("k8XNp", function(module, exports) {
$parcel$export(module.exports, "BitbucketPipelinesIntegrations", function () { return $28b3e37fdfde712f$export$741f4d4a3a2b287c; });

var $7VQPk = parcelRequire("7VQPk");

var $kdQMu = parcelRequire("kdQMu");

var $gvpkz = parcelRequire("gvpkz");
const $28b3e37fdfde712f$export$741f4d4a3a2b287c = ()=>{
    const { items: items, categories: categories, loading: loading, error: error } = (0, $gvpkz.usePipesData)();
    if (loading) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: "Loading integrations\u2026"
    });
    if (error) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: "Failed to load integrations."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kdQMu.IntegrationsSearchGrid), {
        items: items,
        categories: categories
    });
};

});
parcelRegister("kdQMu", function(module, exports) {
$parcel$export(module.exports, "IntegrationsSearchGrid", function () { return $4edc21c9abdc48ad$export$9b532486e289a2c2; });
/* integrations-search-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $iVmQ7 = parcelRequire("iVmQ7");

var $g3ie4 = parcelRequire("g3ie4");
// ============================================================================
// Colors
// ============================================================================
const $4edc21c9abdc48ad$var$TEXT_PRIMARY = (0, $kbpa7.wacToken)('color.extended.blue1000'); // N900
const $4edc21c9abdc48ad$var$TEXT_SECONDARY = (0, $kbpa7.wacToken)('color.neutral.light800'); // N600
const $4edc21c9abdc48ad$var$TEXT_LINK = (0, $kbpa7.wacToken)('color.primary.blue'); // B700
const $4edc21c9abdc48ad$var$BORDER_COLOR = (0, $kbpa7.wacToken)('color.neutral.light300'); // N40
// ============================================================================
// Styles
// ============================================================================
const $4edc21c9abdc48ad$var$layoutStyle = null;
const $4edc21c9abdc48ad$var$sidebarStyle = null;
const $4edc21c9abdc48ad$var$mainStyle = null;
const $4edc21c9abdc48ad$var$mobileFiltersStyle = null;
// Sidebar heading — "Discover" in black, slightly larger
const $4edc21c9abdc48ad$var$sidebarHeadingStyle = null;
const $4edc21c9abdc48ad$var$resetButtonStyle = null;
const $4edc21c9abdc48ad$var$categoryListStyle = null;
const $4edc21c9abdc48ad$var$categoryItemStyle = null;
// Category buttons — black text, NO background on hover, blue text on hover
const $4edc21c9abdc48ad$var$categoryButtonBaseStyle = null;
// Active category — blue text, bold, NO background
const $4edc21c9abdc48ad$var$categoryButtonActiveStyle = null;
// Mobile select
const $4edc21c9abdc48ad$var$mobileSelectRowStyle = null;
const $4edc21c9abdc48ad$var$mobileLabelStyle = null;
const $4edc21c9abdc48ad$var$mobileSelectStyle = null;
// Breadcrumb — bigger, no bold on active category
const $4edc21c9abdc48ad$var$breadcrumbStyle = null;
const $4edc21c9abdc48ad$var$breadcrumbActiveStyle = null;
// Results header
const $4edc21c9abdc48ad$var$resultsHeaderStyle = null;
// Search
const $4edc21c9abdc48ad$var$searchWrapperStyle = null;
const $4edc21c9abdc48ad$var$searchInputStyle = null;
const $4edc21c9abdc48ad$var$clearButtonStyle = null;
// Grid
const $4edc21c9abdc48ad$var$gridStyle = null;
// Empty state
const $4edc21c9abdc48ad$var$emptyStateStyle = null;
// ============================================================================
// Helpers
// ============================================================================
const $4edc21c9abdc48ad$var$buildCategoryId = (label)=>label.toLowerCase().replace(/\s+/g, '');
const $4edc21c9abdc48ad$export$9b532486e289a2c2 = ({ items: items, categories: categories })=>{
    const [activeCategoryId, setActiveCategoryId] = (0, $1oC0p.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $1oC0p.useState)('');
    const [modalItem, setModalItem] = (0, $1oC0p.useState)(null);
    const activeCategoryLabel = (0, $1oC0p.useMemo)(()=>{
        if (!activeCategoryId) return 'All categories';
        return categories.find((c)=>c.id === activeCategoryId)?.label ?? 'All categories';
    }, [
        categories,
        activeCategoryId
    ]);
    const filteredItems = (0, $1oC0p.useMemo)(()=>{
        const term = searchTerm.trim().toLowerCase();
        return items.filter((item)=>{
            const catMatch = !activeCategoryId || $4edc21c9abdc48ad$var$buildCategoryId(item.category || 'Other') === activeCategoryId;
            const searchMatch = !term || item.name.toLowerCase().includes(term) || item.description.toLowerCase().includes(term) || item.tags.some((t)=>t.toLowerCase().includes(term));
            return catMatch && searchMatch;
        });
    }, [
        items,
        activeCategoryId,
        searchTerm
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulpxy5q _na0i1bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("aside", {
                        className: (0, $2jatx.default)([
                            "_1bsbp3fh _1o9zidpf _1mjbglyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h5", {
                                className: (0, $2jatx.default)([
                                    "_18s812pl _1wyb7vkz _k48pni7l _syazw3q9 _1e0c1txw _4cvr1h6o _zulpu2gc _1p1dangw"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: "Discover"
                                    }),
                                    activeCategoryId && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: "|"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setActiveCategoryId(null),
                                                className: (0, $2jatx.default)([
                                                    "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1wybdlk8 _syazqs6p _9oik1r31 _1bnx8stv _jf4cnqa1"
                                                ]),
                                                style: {
                                                    "--_nf3ash": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_LINK)
                                                },
                                                children: "Reset"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                                className: (0, $2jatx.default)([
                                    "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                        className: (0, $2jatx.default)([
                                            "_6rth1y44"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>setActiveCategoryId(null),
                                            className: (0, $2jatx.default)([
                                                "_1bsb1osq _y3gn1e5h _11q7glyw _19itglyw _2rko1y44 _1yt41bs6 _80omtlke _1wybdlk8 _ect48q0o _syazw3q9 _v5641y4z _30l3qs6p",
                                                activeCategoryId === null && "_k48pni7l _syazqs6p"
                                            ]),
                                            style: {
                                                "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY),
                                                "--_nf3ash": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_LINK)
                                            },
                                            children: [
                                                "All categories (",
                                                items.length,
                                                ")"
                                            ]
                                        })
                                    }),
                                    categories.map((cat)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                            className: (0, $2jatx.default)([
                                                "_6rth1y44"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setActiveCategoryId(cat.id),
                                                className: (0, $2jatx.default)([
                                                    "_1bsb1osq _y3gn1e5h _11q7glyw _19itglyw _2rko1y44 _1yt41bs6 _80omtlke _1wybdlk8 _ect48q0o _syazw3q9 _v5641y4z _30l3qs6p",
                                                    activeCategoryId === cat.id && "_k48pni7l _syazqs6p"
                                                ]),
                                                style: {
                                                    "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY),
                                                    "--_nf3ash": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_LINK)
                                                },
                                                children: [
                                                    cat.label,
                                                    " (",
                                                    cat.count,
                                                    ")"
                                                ]
                                            })
                                        }, cat.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0cglyw _1mjb1ule _1eglpxbi"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulputpp"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            className: (0, $2jatx.default)([
                                                "_1wyb7vkz _k48pni7l _syazw3q9"
                                            ]),
                                            style: {
                                                "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                            },
                                            children: "Discover"
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                                            value: activeCategoryId ?? '',
                                            onChange: (e)=>setActiveCategoryId(e.target.value || null),
                                            className: (0, $2jatx.default)([
                                                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1yt41bs6 _2rko1y44 _19it895m _1wybdlk8 _ect48q0o _bfhk1afi _syazw3q9 _80omtlke"
                                            ]),
                                            style: {
                                                "--_16labcr": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$BORDER_COLOR),
                                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                                "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("option", {
                                                    value: "",
                                                    children: [
                                                        "All categories (",
                                                        items.length,
                                                        ")"
                                                    ]
                                                }),
                                                categories.map((cat)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("option", {
                                                        value: cat.id,
                                                        children: [
                                                            cat.label,
                                                            " (",
                                                            cat.count,
                                                            ")"
                                                        ]
                                                    }, cat.id))
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wyb7vkz _k48pbfng _syazw3q9 _18s812pl"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: "Integrations / "
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazw3q9 _k48pbfng"
                                        ]),
                                        style: {
                                            "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                        },
                                        children: activeCategoryLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h5", {
                                className: (0, $2jatx.default)([
                                    "_1wybdlk8 _k48pni7l _syazw3q9 _1p1dangw _1dyzt94y _18s8ivgg"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                },
                                children: [
                                    filteredItems.length,
                                    " ",
                                    filteredItems.length === 1 ? 'Result' : 'Results'
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _6rth1ejb"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        "aria-label": "Search integrations",
                                        className: (0, $2jatx.default)([
                                            "_1bsb1osq _ca0q19bv _u5f31ylp _n3td19bv _19bv7vkz _2rko1y44 _19it895m _1wybdlk8 _ect48q0o _syazw3q9 _bfhk1afi _vchhusvi _12ji1r31 _1qu2glyw _12y31o36 _858uqs6p _1idr1mx4"
                                        ]),
                                        style: {
                                            "--_16labcr": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$BORDER_COLOR),
                                            "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY),
                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                            "--_nf3ash": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_LINK),
                                            "--_1oflnjk": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_SECONDARY)
                                        }
                                    }),
                                    searchTerm && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setSearchTerm(''),
                                        "aria-label": "Clear search",
                                        className: (0, $2jatx.default)([
                                            "_kqswstnw _1xi21crf _154i1ssb _t9ec1i34 _11q7glyw _19itglyw _1wybf6fq _80omtlke _syaz1mx4 _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _vwz4kb7n _30l3w3q9"
                                        ]),
                                        style: {
                                            "--_1oflnjk": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_SECONDARY),
                                            "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                        },
                                        children: "\xd7"
                                    })
                                ]
                            }),
                            filteredItems.length > 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c11p5 _yv0e10lg _zulpv47k"
                                ]),
                                children: filteredItems.map((item)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVmQ7.IntegrationsSearchCard), {
                                        item: item,
                                        onClick: setModalItem
                                    }, item.repositoryPath))
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_y3gn1h6o _1rjcoahv _1wyb7vkz _syaz1mx4"
                                ]),
                                style: {
                                    "--_1oflnjk": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_SECONDARY)
                                },
                                children: "No Results"
                            })
                        ]
                    })
                ]
            }),
            modalItem && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ie4.IntegrationsSearchModal), {
                item: modalItem,
                onClose: ()=>setModalItem(null)
            })
        ]
    });
};

});
parcelRegister("iVmQ7", function(module, exports) {
$parcel$export(module.exports, "IntegrationsSearchCard", function () { return $2d97ae6a4a79e242$export$dbc4feda1f27ad36; });
/* integrations-search-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
// ============================================================================
// Colors
// ============================================================================
const $2d97ae6a4a79e242$var$TEXT_PRIMARY = (0, $kbpa7.wacToken)('color.extended.blue1000');
const $2d97ae6a4a79e242$var$TEXT_SECONDARY = (0, $kbpa7.wacToken)('color.neutral.light800');
const $2d97ae6a4a79e242$var$TEXT_TAG_SELECTED = (0, $kbpa7.wacToken)('color.extended.blue1000');
// ============================================================================
// Styles
// ============================================================================
const $2d97ae6a4a79e242$var$cardStyle = null;
const $2d97ae6a4a79e242$var$logoAreaStyle = null;
const $2d97ae6a4a79e242$var$logoStyle = null;
const $2d97ae6a4a79e242$var$titleStyle = null;
const $2d97ae6a4a79e242$var$descriptionStyle = null;
const $2d97ae6a4a79e242$var$tagsContainerStyle = null;
const $2d97ae6a4a79e242$var$tagButtonBaseStyle = null;
const $2d97ae6a4a79e242$var$tagButtonSelectedStyle = null;
const $2d97ae6a4a79e242$var$expandButtonStyle = null;
// ============================================================================
// Constants
// ============================================================================
const $2d97ae6a4a79e242$var$MAX_VISIBLE_TAGS = 3;
const $2d97ae6a4a79e242$export$dbc4feda1f27ad36 = ({ item: item, onClick: onClick })=>{
    const [selectedTag, setSelectedTag] = (0, $1oC0p.useState)(null);
    const [expanded, setExpanded] = (0, $1oC0p.useState)(false);
    const visibleTags = item.tags.slice(0, $2d97ae6a4a79e242$var$MAX_VISIBLE_TAGS);
    const hiddenTags = item.tags.slice($2d97ae6a4a79e242$var$MAX_VISIBLE_TAGS);
    const hasHiddenTags = hiddenTags.length > 0;
    const tagsToRender = expanded ? item.tags : visibleTags;
    const handleTagClick = (0, $1oC0p.useCallback)((e, tag)=>{
        e.stopPropagation();
        setSelectedTag((prev)=>prev === tag ? null : tag);
    }, []);
    const handleExpandClick = (0, $1oC0p.useCallback)((e)=>{
        e.stopPropagation();
        setExpanded((prev)=>!prev);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        type: "button",
        onClick: ()=>onClick?.(item),
        "aria-label": item.name,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _bfhk1afi _2rkoftgi _1yt41ejb _80omtlke _16qst7xp _v5641gli _4t3i1osq _vchhusvi _19itglyw _11q7glyw _y3gn1e5h _11c81kw7 _syaz1kw7 _1dbz130s _1llwp1qy _1ygb1qgu _1ah3yh40"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthpxbi _1e0c1txw _4cvr1h6o _1bah1h6o _4t3iys9h"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: item.logo,
                    alt: item.name,
                    loading: "lazy",
                    className: (0, $2jatx.default)([
                        "_p12fys9h _c71lys9h _5ral1f51"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_18s861nu _ect48q0o _1wyb7vkz _k48pni7l _vwz419ii _syazw3q9 _1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _1yyjcs5v _sudp1e54 _1nmz1hna"
                ]),
                style: {
                    "--_ctyyjv": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_PRIMARY)
                },
                children: item.name
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_18s812pl _ect48q0o _1wybdlk8 _vwz4bs82 _syazw3q9 _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0ccj1k _1yyj11wp _sudp1e54 _1reo15vq _18m915vq"
                ]),
                style: {
                    "--_ctyyjv": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_PRIMARY)
                },
                children: item.description
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1n261g80 _zulpi2wt _1pfh1wug"
                ]),
                children: [
                    tagsToRender.map((tag)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            onClick: (e)=>handleTagClick(e, tag),
                            className: (0, $2jatx.default)([
                                "_11q7dkka _19itglyw _2rko1y44 _ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _ect48q0o _1wyb1crf _syaz1mx4 _80omtlke _v564ezw5 _irr3s3kk",
                                selectedTag === tag && "_bfhkp4k8 _syaz15cs _k48pni7l"
                            ]),
                            style: {
                                "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                                "--_1oflnjk": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_SECONDARY),
                                "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                                "--_1aetymw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light500')),
                                "--_12r9gtj": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_TAG_SELECTED)
                            },
                            children: tag
                        }, tag)),
                    hasHiddenTags && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: handleExpandClick,
                        "aria-label": expanded ? 'Show fewer tags' : 'Show more tags',
                        className: (0, $2jatx.default)([
                            "_11q7dkka _19itglyw _2rko1y44 _ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _ect48q0o _1wyb1crf _syaz1mx4 _80omtlke _k48pni7l _v564mvc0 _irr3s3kk"
                        ]),
                        style: {
                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                            "--_1oflnjk": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_SECONDARY),
                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                        },
                        children: expanded ? "\xd7" : '...'
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("g3ie4", function(module, exports) {
$parcel$export(module.exports, "IntegrationsSearchModal", function () { return $ef5116a4464ba208$export$5104ff47239f45a7; });
/* integrations-search-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $10a00 = parcelRequire("10a00");
// ============================================================================
// Colors
// ============================================================================
const $ef5116a4464ba208$var$TEXT_PRIMARY = (0, $kbpa7.wacToken)('color.extended.blue1000');
const $ef5116a4464ba208$var$TEXT_SECONDARY = (0, $kbpa7.wacToken)('color.neutral.light800');
const $ef5116a4464ba208$var$TEXT_LINK = (0, $kbpa7.wacToken)('color.primary.blue');
const $ef5116a4464ba208$var$BG_CODE = (0, $kbpa7.wacToken)('color.neutral.light100');
const $ef5116a4464ba208$var$BORDER_COLOR = (0, $kbpa7.wacToken)('color.neutral.light300');
// ============================================================================
// Styles
// ============================================================================
// Fix 1 & 4: Restructured overlay into wrapper + backdrop button
// Wrapper is purely for positioning (no click handler, no background)
const $ef5116a4464ba208$var$wrapperStyle = null;
// Backdrop is a proper <button> — fixes a11y errors
// Uses wacToken + opacity instead of hard-coded rgba()
const $ef5116a4464ba208$var$backdropStyle = null;
// Fix 2: Use ADS elevation token instead of hard-coded boxShadow
const $ef5116a4464ba208$var$modalOuterStyle = null;
const $ef5116a4464ba208$var$modalInnerStyle = null;
const $ef5116a4464ba208$var$closeButtonStyle = null;
const $ef5116a4464ba208$var$logoAreaStyle = null;
const $ef5116a4464ba208$var$logoImgStyle = null;
const $ef5116a4464ba208$var$titleStyle = null;
const $ef5116a4464ba208$var$descriptionStyle = null;
const $ef5116a4464ba208$var$versionStyle = null;
const $ef5116a4464ba208$var$yamlSectionStyle = null;
const $ef5116a4464ba208$var$yamlHeadingStyle = null;
const $ef5116a4464ba208$var$yamlCodeBlockStyle = null;
// Fix 3: Container-level styles ONLY — no nested selectors.
// All child element styles moved to MARKDOWN_CONTENT_STYLES below.
const $ef5116a4464ba208$var$markdownContainerStyle = null;
const $ef5116a4464ba208$var$readmeLoadingStyle = null;
const $ef5116a4464ba208$var$buttonsAreaStyle = null;
const $ef5116a4464ba208$var$visitRepoButtonStyle = null;
// ============================================================================
// Scoped styles for README child elements
//
// Injected via a <style> tag so they bypass Compiled's no-nested-selectors
// rule. These target child elements within .bb-readme-content.
// wacToken() and token() return CSS var() expressions, so they work
// fine inside template literal CSS strings.
// ============================================================================
const $ef5116a4464ba208$var$scope = (0, $10a00.README_SCOPE_CLASS);
const $ef5116a4464ba208$var$MARKDOWN_CONTENT_STYLES = `
  .${$ef5116a4464ba208$var$scope} h1 {
    font-size: 18px;
    font-weight: 600;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-150, 12px)"};
  }

  .${$ef5116a4464ba208$var$scope} h2 {
    font-size: 16px;
    font-weight: 600;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: ${"var(--ds-space-250, 20px)"} 0 ${"var(--ds-space-100, 8px)"};
  }

  .${$ef5116a4464ba208$var$scope} h3 {
    font-size: 14px;
    font-weight: 600;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-100, 8px)"};
  }

  .${$ef5116a4464ba208$var$scope} p {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: 0 0 ${"var(--ds-space-150, 12px)"};
  }

  .${$ef5116a4464ba208$var$scope} ul,
  .${$ef5116a4464ba208$var$scope} ol {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: 0 0 ${"var(--ds-space-150, 12px)"};
    padding-inline-start: ${"var(--ds-space-300, 24px)"};
  }

  .${$ef5116a4464ba208$var$scope} li {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin-block-end: ${"var(--ds-space-050, 4px)"};
  }

  .${$ef5116a4464ba208$var$scope} pre {
    background-color: ${$ef5116a4464ba208$var$BG_CODE};
    border-radius: 4px;
    padding: ${"var(--ds-space-200, 16px)"};
    overflow-x: auto;
    margin: 0 0 ${"var(--ds-space-150, 12px)"};
    border: 1px solid ${$ef5116a4464ba208$var$BORDER_COLOR};
  }

  .${$ef5116a4464ba208$var$scope} code {
    font-family: SFMono-Medium, 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace;
    font-size: 13px;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
  }

  .${$ef5116a4464ba208$var$scope} p code,
  .${$ef5116a4464ba208$var$scope} li code,
  .${$ef5116a4464ba208$var$scope} td code {
    background-color: ${$ef5116a4464ba208$var$BG_CODE};
    border-radius: 3px;
    padding: 2px 6px;
    font-size: 12px;
  }

  .${$ef5116a4464ba208$var$scope} table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 ${"var(--ds-space-150, 12px)"};
    font-size: 13px;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
  }

  .${$ef5116a4464ba208$var$scope} th,
  .${$ef5116a4464ba208$var$scope} td {
    border: 1px solid ${$ef5116a4464ba208$var$BORDER_COLOR};
    padding: ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"};
    text-align: left;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
  }

  .${$ef5116a4464ba208$var$scope} th {
    background-color: ${$ef5116a4464ba208$var$BG_CODE};
    font-weight: 600;
  }

  .${$ef5116a4464ba208$var$scope} a {
    color: ${$ef5116a4464ba208$var$TEXT_LINK};
    text-decoration: none;
  }

  .${$ef5116a4464ba208$var$scope} a:hover {
    text-decoration: underline;
  }

  .${$ef5116a4464ba208$var$scope} strong {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    font-weight: 600;
  }

  .${$ef5116a4464ba208$var$scope} em {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
  }
`;
// Combine syntax highlighting + markdown content styles
const $ef5116a4464ba208$var$ALL_README_STYLES = (0, $10a00.SYNTAX_STYLES) + $ef5116a4464ba208$var$MARKDOWN_CONTENT_STYLES;
const $ef5116a4464ba208$export$5104ff47239f45a7 = ({ item: item, onClose: onClose })=>{
    const modalRef = (0, $1oC0p.useRef)(null);
    const [readmeHtml, setReadmeHtml] = (0, $1oC0p.useState)(null);
    const [readmeLoading, setReadmeLoading] = (0, $1oC0p.useState)(true);
    // Fetch README when modal opens
    (0, $1oC0p.useEffect)(()=>{
        let cancelled = false;
        const loadReadme = async ()=>{
            setReadmeLoading(true);
            const html = await (0, $10a00.fetchReadmeHtml)(item.repositoryPath);
            if (!cancelled) {
                setReadmeHtml(html);
                setReadmeLoading(false);
            }
        };
        loadReadme();
        return ()=>{
            cancelled = true;
        };
    }, [
        item.repositoryPath
    ]);
    // Close on Escape
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === 'Escape') onClose();
    }, [
        onClose
    ]);
    (0, $1oC0p.useEffect)(()=>{
        document.addEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'hidden';
        modalRef.current?.focus();
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = '';
        };
    }, [
        handleKeyDown
    ]);
    const repoUrl = `https://bitbucket.org/${item.repositoryPath}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1r04idpf _1e0c1txw _4cvr1h6o _1bah1h6o _1pby15gg _1yt41ejb _vchhusvi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: onClose,
                "aria-label": "Close dialog",
                tabIndex: -1,
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _bfhkcj8d _tzy4105o _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80om73ad"
                ]),
                style: {
                    "--_1bik04v": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark900'))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                role: "dialog",
                "aria-modal": "true",
                "aria-label": item.name,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _bfhk1afi _2rkoftgi _p12f1yw0 _1bsb1osq _c71l1us8 _1e0c1txw _2lx21bp4 _16qs130s _1pbykb7n"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        "aria-label": "Close",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tpxbi _rjxppxbi _11q7glyw _19itglyw _1wyb1tcg _80omtlke _syaz1mx4 _vwz4kb7n _1yt4u2gc _2rko1y44 _1pbykb7n _30l3w3q9 _irr31lhl"
                        ]),
                        style: {
                            "--_1oflnjk": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_SECONDARY),
                            "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY),
                            "--_npmk8l": (0, $6ZVlx.default)($ef5116a4464ba208$var$BG_CODE)
                        },
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        ref: modalRef,
                        tabIndex: -1,
                        className: (0, $2jatx.default)([
                            "_1yt4xy5q _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_6rthpxbi _1e0c1txw _4cvr1h6o _1bah1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                    src: item.logo,
                                    alt: item.name,
                                    className: (0, $2jatx.default)([
                                        "_p12fys9h _c71lys9h _5ral1f51"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                className: (0, $2jatx.default)([
                                    "_18s861nu _ect48q0o _1wybgktf _k48pni7l _syazw3q9"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                },
                                children: item.name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_18s812pl _ect48q0o _1wybdlk8 _vwz4bs82 _syazw3q9"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                },
                                children: item.description
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_18s81km1 _ect48q0o _1wybw1gv _syaz1mx4"
                                ]),
                                style: {
                                    "--_1oflnjk": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_SECONDARY)
                                },
                                children: item.version
                            }),
                            readmeLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_y3gn1h6o _1yt41ejb _1wybdlk8 _syaz1mx4"
                                ]),
                                style: {
                                    "--_1oflnjk": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_SECONDARY)
                                },
                                children: "Loading documentation\u2026"
                            }) : readmeHtml ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("style", {
                                        dangerouslySetInnerHTML: {
                                            __html: $ef5116a4464ba208$var$ALL_README_STYLES
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_ect48q0o _1wybdlk8 _vwz4yu22 _syazw3q9",
                                            (0, $10a00.README_SCOPE_CLASS)
                                        ]),
                                        dangerouslySetInnerHTML: {
                                            __html: readmeHtml
                                        },
                                        style: {
                                            "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                children: item.yml && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_6rth1ejb"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                            className: (0, $2jatx.default)([
                                                "_1wyb7vkz _k48pni7l _ect48q0o _syazw3q9 _18s861nu"
                                            ]),
                                            style: {
                                                "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                            },
                                            children: "YAML Definition"
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("pre", {
                                            className: (0, $2jatx.default)([
                                                "_bfhk1lhl _2rko1y44 _1yt4pxbi _1reo1wug _ect410ur _1wybw1gv _vwz4bs82 _syazw3q9 _o572qvpr _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                            ]),
                                            style: {
                                                "--_npmk8l": (0, $6ZVlx.default)($ef5116a4464ba208$var$BG_CODE),
                                                "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                            },
                                            children: item.yml
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt41lhf _mqm2895m _1e0c1txw _1bah1y6m"
                        ]),
                        style: {
                            "--_16labcr": (0, $6ZVlx.default)($ef5116a4464ba208$var$BORDER_COLOR)
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: repoUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: (0, $2jatx.default)([
                                "_1e0c1o8l _1yt41pyq _bfhkqs6p _syaz1afi _19itglyw _2rko1y44 _ect48q0o _1wybdlk8 _k48pni7l _80omtlke _4bfu1r31 _1hmsglyw _ajmmnqa1 _16l4q80t"
                            ]),
                            style: {
                                "--_nf3ash": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_LINK),
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            },
                            children: "Visit Repo"
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("10a00", function(module, exports) {
$parcel$export(module.exports, "fetchReadmeHtml", function () { return $832c920d7c16dbe1$export$184de531c3da8b72; });
$parcel$export(module.exports, "SYNTAX_STYLES", function () { return $832c920d7c16dbe1$export$a6ba3cea863bf06e; });
$parcel$export(module.exports, "README_SCOPE_CLASS", function () { return $832c920d7c16dbe1$export$69ff8761afe2a1fd; });

var $5QRrh = parcelRequire("5QRrh");
// ============================================================================
// YAML syntax highlighting
// ============================================================================
const $832c920d7c16dbe1$var$highlightYamlLine = (line)=>{
    if (!line.trim()) return line;
    // Full-line comments
    if (/^\s*#/.test(line)) return `<span class="c">${line}</span>`;
    let result = line;
    // Quoted strings "..."
    result = result.replace(/"([^"]*?)"/g, '<span class="s">"$1"</span>');
    // YAML keys before colon
    result = result.replace(/^(\s*(?:[-*]\s+)?)([A-Za-z_][\w.-]*)(:\s*)/, '$1<span class="k">$2</span>$3');
    return result;
};
const $832c920d7c16dbe1$var$addYamlSyntaxHighlighting = (html)=>{
    return html.replace(/<pre><code(?:\s[^>]*)?>([\s\S]*?)<\/code><\/pre>/gi, (_match, codeContent)=>{
        const normalized = codeContent.replace(/<br\s*\/?>/gi, '\n');
        const highlighted = normalized.split('\n').map((line)=>$832c920d7c16dbe1$var$highlightYamlLine(line)).join('<br>');
        return `<pre><code class="language-yaml">${highlighted}</code></pre>`;
    });
};
// ============================================================================
// Pipe table → <table> conversion
// ============================================================================
const $832c920d7c16dbe1$var$parsePipeRow = (line)=>{
    const trimmed = line.replace(/^\|/, '').replace(/\|$/, '');
    return trimmed.split('|').map((cell)=>cell.trim());
};
const $832c920d7c16dbe1$var$convertPipeTablesToHtml = (html)=>{
    return html.replace(/<p>([\s\S]*?)<\/p>/g, (match, innerContent)=>{
        const lines = innerContent.split(/<br\s*\/?>|\n/).map((l)=>l.trim()).filter((l)=>l.length > 0);
        if (lines.length < 3) return match;
        const pipeLines = lines.filter((l)=>l.includes('|'));
        if (pipeLines.length < lines.length * 0.8) return match;
        const separatorIndex = lines.findIndex((line)=>line.includes('|') && line.includes('-') && line.replace(/[|\s:-]/g, '').length === 0);
        if (separatorIndex < 1) return match;
        const headerLines = lines.slice(0, separatorIndex);
        const bodyLines = lines.slice(separatorIndex + 1).filter((line)=>line.includes('|'));
        if (bodyLines.length === 0) return match;
        let table = '<table><thead>';
        headerLines.forEach((line)=>{
            table += '<tr>';
            $832c920d7c16dbe1$var$parsePipeRow(line).forEach((cell)=>{
                table += `<th>${cell}</th>`;
            });
            table += '</tr>';
        });
        table += '</thead><tbody>';
        bodyLines.forEach((line)=>{
            table += '<tr>';
            $832c920d7c16dbe1$var$parsePipeRow(line).forEach((cell)=>{
                table += `<td>${cell}</td>`;
            });
            table += '</tr>';
        });
        table += '</tbody></table>';
        return table;
    });
};
// ============================================================================
// Asterisk list fix
// ============================================================================
const $832c920d7c16dbe1$var$fixAsterisksAsListItems = (html)=>{
    return html.replace(/<pre><code(?:\s[^>]*)?>([\s\S]*?)<\/code><\/pre>/gi, (match, codeContent)=>{
        const fixed = codeContent.replace(/^(\s*)\* /gm, '$1- ');
        return match.replace(codeContent, fixed);
    });
};
// ============================================================================
// Basic markdown → HTML fallback
// ============================================================================
const $832c920d7c16dbe1$var$convertBasicMarkdown = (md)=>{
    let html = md;
    html = html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    // Code blocks
    html = html.replace(/```(\w*)\n([\s\S]*?)```/g, (_match, _lang, code)=>`<pre><code>${code.trim()}</code></pre>`);
    // Inline code
    html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
    // Headings
    html = html.replace(/^### (.+)$/gm, '<h3>$1</h3>');
    html = html.replace(/^## (.+)$/gm, '<h2>$1</h2>');
    html = html.replace(/^# (.+)$/gm, '<h1>$1</h1>');
    // Bold
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    // Italic
    html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
    // Links
    html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
    // Unordered lists
    html = html.replace(/^[\-\*] (.+)$/gm, '<li>$1</li>');
    html = html.replace(/((?:<li>.*<\/li>\n?)+)/g, '<ul>$1</ul>');
    // Paragraphs
    html = html.split('\n\n').map((block)=>{
        const trimmed = block.trim();
        if (!trimmed) return '';
        if (/^<[a-z]/.test(trimmed)) return trimmed;
        return `<p>${trimmed.replace(/\n/g, '<br>')}</p>`;
    }).join('\n');
    return html;
};
// ============================================================================
// Post-processing pipeline
// ============================================================================
const $832c920d7c16dbe1$var$postProcessReadmeHtml = (html)=>{
    let processed = html;
    processed = $832c920d7c16dbe1$var$fixAsterisksAsListItems(processed);
    processed = $832c920d7c16dbe1$var$convertPipeTablesToHtml(processed);
    processed = $832c920d7c16dbe1$var$addYamlSyntaxHighlighting(processed);
    return processed;
};
const $832c920d7c16dbe1$export$184de531c3da8b72 = async (repositoryPath)=>{
    try {
        // Try README.md first
        const rawUrl = `https://api.bitbucket.org/2.0/repositories/${repositoryPath}/src/master/README.md`;
        const res = await fetch(rawUrl, {
            headers: {
                Accept: 'text/html'
            }
        });
        if (res.ok) {
            const text = await res.text();
            const html = text.trim().startsWith('<') ? text : $832c920d7c16dbe1$var$convertBasicMarkdown(text);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5QRrh))).sanitize($832c920d7c16dbe1$var$postProcessReadmeHtml(html));
        }
        // Fallback: pipe.md
        const pipeUrl = `https://api.bitbucket.org/2.0/repositories/${repositoryPath}/src/master/pipe.md`;
        const pipeRes = await fetch(pipeUrl, {
            headers: {
                Accept: 'text/html'
            }
        });
        if (pipeRes.ok) {
            const text = await pipeRes.text();
            const html = text.trim().startsWith('<') ? text : $832c920d7c16dbe1$var$convertBasicMarkdown(text);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5QRrh))).sanitize($832c920d7c16dbe1$var$postProcessReadmeHtml(html));
        }
        return null;
    } catch  {
        return null;
    }
};
const $832c920d7c16dbe1$export$a6ba3cea863bf06e = `
  .bb-readme-content .k,
  .bb-readme-content .kn,
  .bb-readme-content .kd,
  .bb-readme-content .kp,
  .bb-readme-content .kt {
    color: #0052CC;
    font-weight: 600;
  }

  .bb-readme-content .s,
  .bb-readme-content .s1,
  .bb-readme-content .s2,
  .bb-readme-content .se,
  .bb-readme-content .sb,
  .bb-readme-content .sc,
  .bb-readme-content .sd,
  .bb-readme-content .sh,
  .bb-readme-content .si,
  .bb-readme-content .sx,
  .bb-readme-content .sr,
  .bb-readme-content .ss {
    color: #36B37E;
  }

  .bb-readme-content .c,
  .bb-readme-content .c1,
  .bb-readme-content .cm,
  .bb-readme-content .cp,
  .bb-readme-content .cs,
  .bb-readme-content .ch {
    color: #6B778C;
    font-style: italic;
  }

  .bb-readme-content .nf,
  .bb-readme-content .nb,
  .bb-readme-content .nc,
  .bb-readme-content .ni,
  .bb-readme-content .ne,
  .bb-readme-content .nd {
    color: #6554C0;
  }

  .bb-readme-content .mi,
  .bb-readme-content .mf,
  .bb-readme-content .mh,
  .bb-readme-content .mo,
  .bb-readme-content .mb,
  .bb-readme-content .il {
    color: #FF5630;
  }

  .bb-readme-content .o,
  .bb-readme-content .p,
  .bb-readme-content .ow {
    color: #091E42;
  }

  .bb-readme-content .n,
  .bb-readme-content .na,
  .bb-readme-content .no,
  .bb-readme-content .nv,
  .bb-readme-content .nn,
  .bb-readme-content .nt,
  .bb-readme-content .nx,
  .bb-readme-content .bp,
  .bb-readme-content .vc,
  .bb-readme-content .vg,
  .bb-readme-content .vi,
  .bb-readme-content .vm {
    color: #091E42;
  }
`;
const $832c920d7c16dbe1$export$69ff8761afe2a1fd = 'bb-readme-content';

});



parcelRegister("gvpkz", function(module, exports) {
$parcel$export(module.exports, "usePipesData", function () { return $510982361a72aabd$export$82afdb6e66ce8c05; });

var $1oC0p = parcelRequire("1oC0p");
const $510982361a72aabd$var$PIPES_JSON_URL = 'https://bitbucket.org/bitbucketpipelines/official-pipes/raw/master/pipes.prod.json';
const $510982361a72aabd$var$buildCategoryId = (label)=>label.toLowerCase().replace(/\s+/g, '');
const $510982361a72aabd$export$82afdb6e66ce8c05 = (jsonUrl)=>{
    const [items, setItems] = (0, $1oC0p.useState)([]);
    const [loading, setLoading] = (0, $1oC0p.useState)(true);
    const [error, setError] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        let cancelled = false;
        const run = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const res = await fetch(jsonUrl || $510982361a72aabd$var$PIPES_JSON_URL);
                if (!res.ok) throw new Error(`Failed to fetch pipes data: ${res.status}`);
                const data = await res.json();
                if (!cancelled) setItems(data);
            } catch (err) {
                if (!cancelled) setError(err instanceof Error ? err : new Error('Unknown error fetching pipes data'));
            } finally{
                if (!cancelled) setLoading(false);
            }
        };
        run();
        return ()=>{
            cancelled = true;
        };
    }, [
        jsonUrl
    ]);
    const categories = (0, $1oC0p.useMemo)(()=>{
        const counts = new Map();
        items.forEach((item)=>{
            const label = item.category || 'Other';
            counts.set(label, (counts.get(label) ?? 0) + 1);
        });
        return Array.from(counts.entries()).map(([label, count])=>({
                id: $510982361a72aabd$var$buildCategoryId(label),
                label: label,
                count: count
            })).sort((a, b)=>a.label.localeCompare(b.label));
    }, [
        items
    ]);
    return {
        items: items,
        categories: categories,
        loading: loading,
        error: error
    };
};

});



parcelRegister("fZxve", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32c5d817419f263d$export$2e2bcd8739ae039; });
/* bleeding-image-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lqyi6 = parcelRequire("lqyi6");

var $2axoc = parcelRequire("2axoc");

var $bSVv5 = parcelRequire("bSVv5");
const $32c5d817419f263d$export$5460398cf21adb2e = '#191919';
/**
 * `colorAgainst` value passed to {@link Button} so it picks the white text +
 * white outline treatment intended for dark surfaces (`secondary_against_black`
 * in the underlying button style map).
 */ const $32c5d817419f263d$var$BUTTON_COLOR_AGAINST_DARK_BG = 'black';
const $32c5d817419f263d$var$sectionStyles = null;
const $32c5d817419f263d$var$rowStyles = null;
const $32c5d817419f263d$var$contentBlockSlotStyles = null;
const $32c5d817419f263d$var$imageSlotStyles = null;
/**
 * Inline `<img>` styles for the bleeding image. Renders the image at the
 * width of its slot with proportional height so there is never any
 * letterboxing whitespace around it. `display: block` removes the inline
 * baseline gap that would otherwise add a few pixels under the image.
 */ const $32c5d817419f263d$var$imageElementStyles = null;
/**
 * `UniformBleedingImageHero` is a Uniform-registered pattern component that
 * composes a {@link ContentBlock} (left, heading + body only) and a
 * {@link Image} (right) inside a flexbox row, with a locally rendered
 * {@link Button} acting as the call-to-action. The image is rendered at a
 * fixed width per breakpoint and uses a negative right margin to bleed past
 * the right edge of the viewport (clipped by the section's `overflow-x:
 * clip`). On mobile the layout stacks and the image is shown in full.
 *
 * ----------------------------------------------------------------------------
 * Layout decision (Option X)
 * ----------------------------------------------------------------------------
 * Earlier iterations of this component used the WAC `ColumnLayout`'s 12-column
 * grid with the content block on cols 1–6 and the image on cols 5–12. After
 * comparing that against the GWP-11478 Figma frames, the design turns out to
 * be a flex layout of two **fixed-width** children (e.g. content block 312–
 * 668px, image 844–1438px) — not a fluid 12-col grid — which is why the
 * heading and body wrap as designed. Switching to a fixed-width flex row
 * matches the Figma exactly while still letting the image bleed past the
 * right edge thanks to the section's `overflow-x: clip`.
 *
 * ----------------------------------------------------------------------------
 * CTA architecture decision (recorded for future maintainers)
 * ----------------------------------------------------------------------------
 * `UniformContentBlock` *can* render its own button via `buttonLabel` /
 * `buttonHref` / `buttonVariant`, but its internal `renderCta` hardcodes
 * `colorAgainst` to `"white"` for every background except the WAC blue
 * (`#1868DB`), where it forces `"other"`. There is no code path that yields
 * `colorAgainst="black"` (the value required for white text + white outline
 * on a dark surface — see `getButtonVariant` in `button.tsx`, which maps it
 * to the `secondary_against_black` style).
 *
 * Two paths to fix the wrong-button-on-dark-bg:
 *   - Option A: patch ContentBlock so dark `backgroundColor` triggers
 *     `colorAgainst="black"`. Correct at the right layer; would also fix the
 *     latent bug for any future dark-bg ContentBlock consumers.
 *   - Option C (chosen here): keep ContentBlock for heading + body only and
 *     render the CTA `Button` ourselves with `colorAgainst="black"`.
 *
 * Option C was chosen for **this** PR for scope and risk reasons:
 *   1. It keeps every change inside `bleeding-image-hero/`, with zero blast
 *      radius on the shared `ContentBlock` (which is rendered in many places
 *      across WAC).
 *   2. ContentBlock currently has no other dark-bg consumers, so the latent
 *      bug isn't actively breaking anything in production today.
 *   3. The Option A patch is a clean, scoped follow-up that can ship in its
 *      own PR (with its own visual review of any newly dark-bg consumers)
 *      without blocking GWP-11478.
 *
 * If a second dark-bg consumer appears, prefer migrating both this component
 * and the new one to Option A so the dark-mode CTA logic lives in exactly
 * one place.
 */ const $32c5d817419f263d$var$UniformBleedingImageHero = ({ heading: heading, bodyText: bodyText, ctaLabel: ctaLabel, ctaUrl: ctaUrl, mediaImageUrl: mediaImageUrl, mediaAlt: mediaAlt, backgroundColor: backgroundColor, buttonVariant: buttonVariant = 'secondary' })=>{
    // Resolve the background color defensively. Destructuring defaults only
    // apply when the prop is strictly `undefined`; Uniform's authoring runtime
    // can emit `null` or `""` for unset string parameters, both of which would
    // bypass a destructured default and leave the section unstyled. Treat any
    // falsy value as "use the default" so the dark surface is always painted.
    const resolvedBackgroundColor = backgroundColor && backgroundColor.trim() !== '' ? backgroundColor : $32c5d817419f263d$export$5460398cf21adb2e;
    const sectionBackgroundStyle = {
        backgroundColor: resolvedBackgroundColor
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        style: sectionBackgroundStyle,
        "data-testid": "bleeding-image-hero",
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _1reozryt _1e0c1txw _2lx21bp4 _4cvr1h6o _18zrxy5q _1rjc1jfw _1wfq1wqb _15vt68cl _16imidpf _d2ik1wqb _exxm68cl _12z7bv7e _14mbclpc"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_p12f1m6w _1i7q167m _1e0c1txw _2lx21bp4 _4cvr1fhb _1bsb1osq _zulp1jfw _1lp7vrvc _19wgidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _bfhk1j28 _kqswh2mm _1e0c1txw _2lx21bp4 _zulp1jfw _4cvr1y6m _14b5eo28 _p7vbidpf _19wg1jfw _1waf1jfw _1yd31jfw _glte1vif _6ru51erl _a64kxncg _h140xncg _1rghxncg _1pbykb7n"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                            title: heading,
                            titleAs: "h2",
                            text: bodyText,
                            backgroundColor: resolvedBackgroundColor
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            variant: buttonVariant,
                            responsiveSize: {
                                mobile: 'small',
                                tablet: 'small',
                                desktop: 'large',
                                xl_desktop: 'large'
                            },
                            colorAgainst: $32c5d817419f263d$var$BUTTON_COLOR_AGAINST_DARK_BG,
                            href: ctaUrl,
                            "aria-label": `${ctaLabel}, ${heading}`,
                            dataEventProps: {
                                'data-product-key': 'uniform',
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'heroSection',
                                'data-label': ctaLabel,
                                'data-label-english': ctaLabel
                            },
                            children: ctaLabel
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _bfhk1j28 _1reoewfl _18m9ewfl _1o9zidpf _14b5n0dd _1lva1fgt _1ywm1wug _16im1ejb _glten0dd _161b1f6i _6ru57hph _1oyhltga"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: mediaImageUrl,
                        alt: mediaAlt,
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _1bsb1osq _4t3i1wug _p12f1osq"
                        ])
                    })
                })
            ]
        })
    });
};
var $32c5d817419f263d$export$2e2bcd8739ae039 = $32c5d817419f263d$var$UniformBleedingImageHero;

});

parcelRegister("7v1H9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aee83d009c5ce128$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $lP7A9 = parcelRequire("lP7A9");

var $ixBPH = parcelRequire("ixBPH");

var $30iuM = parcelRequire("30iuM");

var $kDYqJ = parcelRequire("kDYqJ");
const $aee83d009c5ce128$var$UniformBlogNewsGallery = ({ cards: cards, isMotionAvailable: isMotionAvailable, motionDelay: motionDelay, motionForward: transformForward, motionBackward: transformBackward })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedCards = (0, $f2QWG.flattenValues)(cards);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kDYqJ.GalleryContainer), {
        isMotionAvailable: isMotionAvailable,
        motionDelay: motionDelay,
        gap: {
            belowMd: (0, $lP7A9.default)('space.300'),
            aboveMd: (0, $lP7A9.default)('space.400')
        },
        children: flattenedCards.map((card, index)=>{
            if (card) {
                if ('dates' in card) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "entry-item",
                    style: {
                        // @ts-expect-error -- CSS custom property not in CSSProperties type
                        '--gc-item-i': index,
                        flex: 1
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ixBPH.BlogEventCard), {
                        date: card.dates,
                        location: card.location,
                        title: card.title,
                        link: {
                            href: card.ctaUrl,
                            text: card.ctaText,
                            dataEventProps: {
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'cardSection',
                                'data-product-key': 'uniform',
                                'data-label': card.ctaText
                            }
                        },
                        image: {
                            src: card.imageUrl,
                            alt: card.imageAlt ?? ''
                        },
                        motionConfig: transformForward && transformBackward ? {
                            transformForward: transformForward,
                            transformBackward: transformBackward
                        } : undefined
                    })
                }, index);
                else return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "entry-item",
                    style: {
                        // @ts-expect-error -- CSS custom property not in CSSProperties type
                        '--gc-item-i': index
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $30iuM.BlogNewsCard), {
                        color: card.color,
                        label: card.label,
                        title: card.title,
                        link: {
                            href: card.ctaUrl,
                            text: card.ctaText,
                            dataEventProps: {
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'cardSection',
                                'data-product-key': 'uniform',
                                'data-label': card.ctaText
                            }
                        },
                        image: {
                            src: card.imageUrl,
                            alt: card.imageAlt ?? ''
                        },
                        motionConfig: transformForward && transformBackward ? {
                            transformForward: transformForward,
                            transformBackward: transformBackward
                        } : undefined
                    })
                }, index);
            }
        })
    });
};
var $aee83d009c5ce128$export$2e2bcd8739ae039 = $aee83d009c5ce128$var$UniformBlogNewsGallery;

});
parcelRegister("ixBPH", function(module, exports) {
$parcel$export(module.exports, "BlogEventCard", function () { return $6d0a169d80108741$export$fe664c335408d8a7; });
/* blog-event-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $56bcs = parcelRequire("56bcs");

var $3fxcB = parcelRequire("3fxcB");

var $kbpa7 = parcelRequire("kbpa7");

var $30iuM = parcelRequire("30iuM");
const $6d0a169d80108741$export$fe664c335408d8a7 = (props)=>{
    const { date: date, location: location, ...rest } = props;
    const intl = (0, $8e22h.default)();
    const eventMeta = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _zulpv47k _syaz1afi"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp12x7"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($56bcs))), {
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_ect4z4z1 _k48pbfng _syaz1afi _fz897vkz _1ol91tcg _1wybdlk8 _vwz4gktf"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: date
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp12x7"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fxcB))), {
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_ect4z4z1 _k48pbfng _syaz1afi _fz897vkz _1ol91tcg _1wybdlk8 _vwz4gktf"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: location
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $30iuM.BlogNewsCard), {
        ...rest,
        color: "blue",
        label: intl.formatMessage({
            id: 'BlogEventCard.eventLabel',
            defaultMessage: 'Event'
        }),
        eventMeta: eventMeta
    });
};
const $6d0a169d80108741$var$metaRowStyles = null;
const $6d0a169d80108741$var$metaItemStyles = null;
const $6d0a169d80108741$var$metaTextStyles = null;

});
parcelRegister("30iuM", function(module, exports) {
$parcel$export(module.exports, "BlogNewsCard", function () { return $42a200ec897943d3$export$54efd7df5b33350e; });
/* blog-news-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $jE3Ci = parcelRequire("jE3Ci");
const $42a200ec897943d3$export$54efd7df5b33350e = (props)=>{
    const { color: color, label: label, title: title, link: link, image: image, eventMeta: eventMeta, motionConfig: motionConfig } = props;
    const bgColor = $42a200ec897943d3$var$colorToToken[color];
    const ariaLabel = `${link.text}: ${title}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rko1ylz _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1kw7 _16jlkb7n _1o9zkb7n _i0dlf1ug _1o9zidpf _kqswh2mm _1bsbjwe6 _1hr21178 _12rrpcwi _1rfmi4q4 _4t3i1osq _1pa0120f _sxoi1aaj _1cc51kli _13g21aaj _nrxub3bt _1m1hstnw _7bwcidpf _m6k41e03 _t9ecy7a9 _dk9v15m1",
            motionConfig?.transformForward && "_t9ecg30n _dk9vwey4"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_cww0s8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-out')),
            "--_1oyjq9z": (0, $6ZVlx.default)(motionConfig?.transformForward),
            "--_1vdjstz": (0, $6ZVlx.default)(motionConfig?.transformBackward)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq _kqswh2mm _179v1osq _14j11ekt _n2qi1dfr _ym5m1ule _1264sdv5 _aetrb3bt _1hfk1kw7 _18postnw _1gufidpf _13w1idpf _1qdgutpp _clh3xjh3 _1bqqidpf _qc5osdv5",
                    "blog-news-card-media"
                ]),
                style: {
                    backgroundColor: bgColor,
                    "--_1xytpwi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.delay.250ms')),
                    "--_1xb7skf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease60-in'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: image.src,
                    alt: image.alt,
                    className: "blog-news-card-image"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1y6m _16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _vchhusvi _zulppxbi _1yt41ejb _1aczpxbi _13znpxbi _15txpxbi _p03cuftu _oxk4uftu _123puftu _1cayuftu"
                ]),
                style: {
                    backgroundColor: bgColor,
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                        appearance: $42a200ec897943d3$var$colorToLozenge[color],
                        text: label
                    }),
                    eventMeta,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zidpf _i0dlf1ug _1tket94y _1ul91osq _1reo15vq _18m915vq _1vgk1vau _ud3o1afi _3o131tcg _jj6e1dsi _v8klbfng _1ocpidpf _1c14qslr _1h8vgktf _5yj4f6fq",
                            "card-title-sm"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1o9zidpf _1pfh1wug"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            type: "primary",
                            bgColor: "bgBlackBlue",
                            href: link.href,
                            text: link.text,
                            "aria-label": ariaLabel,
                            ariaLabel: ariaLabel,
                            className: "blog-news-card-link",
                            dataEventProps: link.dataEventProps
                        })
                    })
                ]
            })
        ]
    });
};
const $42a200ec897943d3$var$colorToToken = {
    purple: (0, $kbpa7.wacToken)('color.extended.purple800'),
    green: (0, $kbpa7.wacToken)('color.extended.lime800'),
    orange: (0, $kbpa7.wacToken)('color.extended.orange700'),
    blue: (0, $kbpa7.wacToken)('color.extended.blue800')
};
const $42a200ec897943d3$var$colorToLozenge = {
    purple: 'purple',
    green: 'lime',
    orange: 'saffron',
    blue: 'blue'
};
const $42a200ec897943d3$var$cardStyles = null;
const $42a200ec897943d3$var$imageWrapperStyles = null;
const $42a200ec897943d3$var$contentStyles = null;
const $42a200ec897943d3$var$titleStyles = null;
const $42a200ec897943d3$var$linkSlotStyles = null;

});


parcelRegister("kDYqJ", function(module, exports) {
$parcel$export(module.exports, "GalleryContainer", function () { return $a4e19702d625b9e1$export$2a3350e530f2dd7b; });
/* gallery-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $7kals = parcelRequire("7kals");

var $bwWCK = parcelRequire("bwWCK");

var $kbpa7 = parcelRequire("kbpa7");

var $6C7e6 = parcelRequire("6C7e6");
// All CSS Custom Properties prefixed --gc-scroll are to power scroll driven animations on sub elements
// Additional necessary @property rules appear in root index.css file
// Based on: https://www.bram.us/2023/10/23/css-scroll-detection/
const $a4e19702d625b9e1$var$scrollAnimations = null;
const $a4e19702d625b9e1$var$galleryStyles = null;
const $a4e19702d625b9e1$var$scrollableStyles = null;
const $a4e19702d625b9e1$var$scrollableAnimation = null;
// Applied when all content fits within the viewport — centers the inner row and removes bleed/scroll behaviour
const $a4e19702d625b9e1$var$scrollableCenteredStyles = null;
const $a4e19702d625b9e1$var$innerStyles = null;
const $a4e19702d625b9e1$var$entryFrames = null;
const $a4e19702d625b9e1$var$entrySetup = null;
const $a4e19702d625b9e1$var$entryAnimation = null;
const $a4e19702d625b9e1$var$controlsStyles = null;
const $a4e19702d625b9e1$var$controlsHiddenStyles = null;
const $a4e19702d625b9e1$var$paginationStyles = null;
const $a4e19702d625b9e1$var$paginationDotStyles = null;
const $a4e19702d625b9e1$var$paginationDotActiveStyles = null;
const $a4e19702d625b9e1$var$SCROLL_BUFFER = 40;
/** Items sit between the leading/trailing aria-hidden marker spans. */ const $a4e19702d625b9e1$var$getGalleryItems = (innerEl)=>Array.from(innerEl.children).slice(1, -1);
/** Mobile-only (< sm / 48rem). Tablet+ uses arrow controls. */ const $a4e19702d625b9e1$var$useIsBelowSm = ()=>{
    const [isBelowSm, setIsBelowSm] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const mq = window.matchMedia('(max-width: 47.99rem)');
        const sync = ()=>setIsBelowSm(mq.matches);
        sync();
        mq.addEventListener('change', sync);
        return ()=>mq.removeEventListener('change', sync);
    }, []);
    return isBelowSm;
};
const $a4e19702d625b9e1$var$useGalleryFitting = (scrollRef, innerRef)=>{
    const [isFitting, setIsFitting] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const scrollEl = scrollRef.current;
        const innerEl = innerRef.current;
        if (!scrollEl || !innerEl) return;
        const observer = new ResizeObserver(()=>{
            setIsFitting(innerEl.scrollWidth <= scrollEl.clientWidth - (0, $6C7e6.WCL_GRID_PADDING_SM) * 2);
        });
        observer.observe(scrollEl);
        observer.observe(innerEl);
        return ()=>observer.disconnect();
    }, [
        scrollRef,
        innerRef
    ]);
    return isFitting;
};
/** Tracks the centered slide for mobile pagination dots. No-ops when disabled. */ const $a4e19702d625b9e1$var$useActiveGalleryIndex = (scrollRef, innerRef, enabled)=>{
    const [activeIndex, setActiveIndex] = (0, $1oC0p.useState)(0);
    (0, $1oC0p.useEffect)(()=>{
        if (!enabled) return;
        const scrollEl = scrollRef.current;
        const innerEl = innerRef.current;
        if (!scrollEl || !innerEl) return;
        const update = ()=>{
            const items = $a4e19702d625b9e1$var$getGalleryItems(innerEl);
            if (items.length === 0) return;
            const viewCenter = scrollEl.getBoundingClientRect().left + scrollEl.clientWidth / 2;
            let closest = 0;
            let closestDist = Infinity;
            items.forEach((item, index)=>{
                const rect = item.getBoundingClientRect();
                const dist = Math.abs((rect.left + rect.right) / 2 - viewCenter);
                if (dist < closestDist) {
                    closestDist = dist;
                    closest = index;
                }
            });
            setActiveIndex(closest);
        };
        update();
        scrollEl.addEventListener('scroll', update, {
            passive: true
        });
        const observer = new ResizeObserver(update);
        observer.observe(scrollEl);
        observer.observe(innerEl);
        return ()=>{
            scrollEl.removeEventListener('scroll', update);
            observer.disconnect();
        };
    }, [
        enabled,
        scrollRef,
        innerRef
    ]);
    const scrollToIndex = (0, $1oC0p.useCallback)((index)=>{
        const innerEl = innerRef.current;
        if (!innerEl) return;
        $a4e19702d625b9e1$var$getGalleryItems(innerEl)[index]?.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: (0, $7kals.isReducedMotion)() ? 'auto' : 'smooth'
        });
    }, [
        innerRef
    ]);
    return {
        activeIndex: activeIndex,
        scrollToIndex: scrollToIndex
    };
};
const $a4e19702d625b9e1$var$GalleryNavControls = ({ isStartVisible: isStartVisible, isEndVisible: isEndVisible, onPrevious: onPrevious, onNext: onNext })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "12",
        horizontalAlignment: "end",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_v56415ls _1bsb1osq",
                isStartVisible && isEndVisible && "_tzy4idpf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bwWCK.GalleryControls), {
                isFirstItemVisible: isStartVisible,
                isLastItemVisible: isEndVisible,
                onPrevious: onPrevious,
                onNext: onNext,
                size: "large"
            })
        })
    });
const $a4e19702d625b9e1$var$GalleryPaginationDots = ({ itemCount: itemCount, activeIndex: activeIndex, onSelect: onSelect })=>{
    const intl = (0, $8e22h.default)();
    if (itemCount < 2) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        "aria-label": intl.formatMessage({
            id: 'gallery-container.pagination-label',
            defaultMessage: 'Gallery slides'
        }),
        "data-testid": "gallery-pagination-dots",
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc _1bsb1osq _1q51u2gc _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _18zridpf"
        ]),
        children: Array.from({
            length: itemCount
        }, (_, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    "aria-current": index === activeIndex ? 'true' : undefined,
                    "aria-label": intl.formatMessage({
                        id: 'gallery-container.pagination-dot',
                        defaultMessage: 'Go to slide {slide}'
                    }, {
                        slide: index + 1
                    }),
                    onClick: ()=>onSelect(index),
                    "data-testid": `gallery-pagination-dot-${index}`,
                    className: (0, $2jatx.default)([
                        "_r06hglyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsbftgi _4t3iftgi _2rko1osq _bfhkk0sw _80omtlke _1ygb7g83 _1ah3yh40",
                        index === activeIndex && "_bfhk1pfd"
                    ]),
                    style: {
                        "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700')),
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    }
                })
            }, index))
    });
};
const $a4e19702d625b9e1$var$GalleryScrollTrack = ({ scrollRef: scrollRef, innerRef: innerRef, firstItemRef: firstItemRef, lastItemRef: lastItemRef, isMotionAvailable: isMotionAvailable, isFitting: isFitting, motionDelay: motionDelay, showEntry: showEntry, isGalleryInView: isGalleryInView, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_1bsb1osq _18m915vq _1reo1wug _kpfhglyw _1q511ejb _1dm8q5uf _rjfvx6dd _18zr28yr _14hb28yr _1iuf1vi7 _9yq41wqb _769mosjt _o36f1yva",
            isMotionAvailable && "",
            isMotionAvailable && "_1cro6jan _1e0rp3kn _dqw81hrf _nzidwgdq _jg2w1f51",
            isFitting && "_1e0c1txw _1bah1h6o _18zridpf _14hbidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: innerRef,
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1fhb _1bsb1ris _8hxm17lu _zulpuls2 _n1xi16zn _co9xv2br _6jyt1h6o _tv8cbags _s9z0bags _v564yks3 _1mz7grv1 _1f2l10dv _extx102y",
                motionDelay && "_1oecnvsi",
                showEntry && "",
                showEntry && "_1j84z12g _olpvkb7n _n2e2q3pj _13ngw1p3 _1m701aaj _14ht1mi5 _1bn0eoah _1h13trqk",
                showEntry && isGalleryInView && "_1h13o91m"
            ]),
            style: {
                "--_13opc34": (0, $6ZVlx.default)(motionDelay),
                "--_cww0s8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-out'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "aria-hidden": "true",
                    ref: firstItemRef
                }),
                children,
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "aria-hidden": "true",
                    ref: lastItemRef
                })
            ]
        })
    });
const $a4e19702d625b9e1$export$2a3350e530f2dd7b = ({ isMotionAvailable: isMotionAvailable, motionDelay: motionDelay, gap: gap, showEntry: showEntry = true, children: children })=>{
    const scrollRef = (0, $1oC0p.useRef)(null);
    const innerRef = (0, $1oC0p.useRef)(null);
    const isFitting = $a4e19702d625b9e1$var$useGalleryFitting(scrollRef, innerRef);
    const isBelowSm = $a4e19702d625b9e1$var$useIsBelowSm();
    const itemCount = (0, $1oC0p.Children).toArray(children).length;
    const showDots = isBelowSm && !isFitting && itemCount > 1;
    const showArrows = !isBelowSm && !isFitting;
    const { activeIndex: activeIndex, scrollToIndex: scrollToIndex } = $a4e19702d625b9e1$var$useActiveGalleryIndex(scrollRef, innerRef, showDots);
    const { ref: firstItemRef, inView: isStartVisible } = (0, $jKShK.useInView)({
        root: scrollRef?.current,
        threshold: 1
    });
    const { ref: lastItemRef, inView: isEndVisible } = (0, $jKShK.useInView)({
        root: scrollRef?.current,
        threshold: 1
    });
    const handleChange = (0, $1oC0p.useCallback)((direction)=>{
        const el = scrollRef.current;
        if (!el) return;
        const pageAmount = Math.min((0, $6C7e6.WCL_GRID_MAX_WIDTH), el.clientWidth);
        el.scrollTo({
            top: 0,
            left: el.scrollLeft + (pageAmount - $a4e19702d625b9e1$var$SCROLL_BUFFER) * direction,
            behavior: (0, $7kals.isReducedMotion)() ? 'auto' : 'smooth'
        });
    }, []);
    const handlePrevious = (0, $1oC0p.useCallback)(()=>handleChange(-1), [
        handleChange
    ]);
    const handleNext = (0, $1oC0p.useCallback)(()=>handleChange(1), [
        handleChange
    ]);
    const { ref: containerRef, inView: isGalleryInView } = (0, $jKShK.useInView)({
        threshold: 0.25,
        triggerOnce: true
    });
    const gapStyle = gap ? {
        '--gc-gap-below-md': gap.belowMd,
        '--gc-gap-above-md': gap.aboveMd
    } : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1fhb _zulp1ejb _pdlmxy5q",
            "gallery-container"
        ]),
        style: gapStyle,
        ref: containerRef,
        children: [
            showArrows && /*#__PURE__*/ (0, $7VQPk.jsx)($a4e19702d625b9e1$var$GalleryNavControls, {
                isStartVisible: isStartVisible,
                isEndVisible: isEndVisible,
                onPrevious: handlePrevious,
                onNext: handleNext
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($a4e19702d625b9e1$var$GalleryScrollTrack, {
                scrollRef: scrollRef,
                innerRef: innerRef,
                firstItemRef: firstItemRef,
                lastItemRef: lastItemRef,
                isMotionAvailable: isMotionAvailable,
                isFitting: isFitting,
                motionDelay: motionDelay,
                showEntry: showEntry,
                isGalleryInView: isGalleryInView,
                children: children
            }),
            showDots && /*#__PURE__*/ (0, $7VQPk.jsx)($a4e19702d625b9e1$var$GalleryPaginationDots, {
                itemCount: itemCount,
                activeIndex: activeIndex,
                onSelect: scrollToIndex
            })
        ]
    });
};

});
parcelRegister("bwWCK", function(module, exports) {
$parcel$export(module.exports, "GalleryControls", function () { return $76423b87eeed5131$export$7a451794fcccf70c; });
/* gallery-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $clnBI = parcelRequire("clnBI");

var $Lp2P8 = parcelRequire("Lp2P8");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $cCPo5 = parcelRequire("cCPo5");
const $76423b87eeed5131$var$arrowCss = null;
const $76423b87eeed5131$var$containerCss = null;
const $76423b87eeed5131$var$chevronContainerCss = null;
const $76423b87eeed5131$var$darkThemeContainerCss = null;
const $76423b87eeed5131$var$buttonBaseCss = null;
const $76423b87eeed5131$var$arrowButtonStyles = null;
const $76423b87eeed5131$var$darkThemeButtonCss = null;
const $76423b87eeed5131$var$chevronButtonCss = null;
const $76423b87eeed5131$var$buttonLargeCss = null;
const $76423b87eeed5131$var$arrowButtonLargeCss = null;
const $76423b87eeed5131$var$counterCss = null;
const $76423b87eeed5131$export$7a451794fcccf70c = ({ showCounter: showCounter = false, currentCount: currentCount, totalCount: totalCount, onPrevious: onPrevious, onNext: onNext, isFirstItemVisible: isFirstItemVisible, isLastItemVisible: isLastItemVisible, size: size, iconAppearance: iconAppearance = 'arrow' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const { isDarkTheme: isDarkTheme, isDevTheme: isDevTheme } = (0, $eOIix.useTheme)();
    const fireGalleryControlClicked = (0, $1oC0p.useCallback)((direction)=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'galleryControlButton',
            eventType: 'ui',
            eventComponent: 'button',
            source: 'gallery-controls',
            attributes: {
                direction: direction
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handlePreviousClick = (0, $1oC0p.useCallback)(()=>{
        fireGalleryControlClicked('previous');
        onPrevious();
    }, [
        fireGalleryControlClicked,
        onPrevious
    ]);
    const handleNextClick = (0, $1oC0p.useCallback)(()=>{
        fireGalleryControlClicked('next');
        onNext();
    }, [
        fireGalleryControlClicked,
        onNext
    ]);
    const isLarge = size === 'large';
    const counterTypographyClass = size === 'small' ? 'body-sm' : 'body-md';
    const isAtFirstItem = currentCount !== undefined && currentCount < 2;
    const isAtLastItem = totalCount !== undefined && currentCount !== undefined && currentCount >= totalCount;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "group",
        "aria-label": intl.formatMessage({
            id: 'gallery-controls.group-label',
            defaultMessage: 'Gallery navigation'
        }),
        className: (0, $2jatx.default)([
            "_1e0c116y _2lx2vrvc _4cvr1h6o _zulpu2gc _1de71pfd _c2b01bd0 _wkf91bd0 _1g781pfd _15091v1w",
            isDarkTheme && "_1de71afi _c2b01wym _wkf91wym _1g781afi _15091v1w",
            iconAppearance === 'chevron' && "_1e0c1txw _4cvr1h6o _zulpi2wt"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1kmobfd": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.navy')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_138yw56": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue300'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handlePreviousClick,
                disabled: isFirstItemVisible || isAtFirstItem,
                "aria-label": intl.formatMessage({
                    id: 'gallery-controls.previous',
                    defaultMessage: 'Previous slide'
                }),
                "data-testid": "gallery-controls-previous",
                className: (0, $2jatx.default)([
                    "_1e0c116y _80omtlke _1o9zidpf _19itglyw _2rko1osq _2lx21bp4 _tzy4kb7n _1bsb1ylp _4t3i1ylp _bb32qjb0 _1j55clii _j5dh73ad _18o21jaz _16u2yh40",
                    iconAppearance === 'chevron' ? "_4cvr1h6o _1bah1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _syazm7hq _n47eg1d7 _pj3a175s _vbqbe3xi" : isDarkTheme ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _syazm7hq _n47eg1d7 _pj3a175s _vbqbe3xi" : "_4cvr1h6o _1bah1h6o _bfhkm7hq _syaz1afi _ca0qw1gv _u5f319bv _n3tdw1gv _19bv19bv _dmizg1d7 _14iu175s _cun9y4dw",
                    isLarge && "_glte1wqb _165t1wqb",
                    isLarge && !isDevTheme && "_oqic13pm _1rmjo7ao _cjbt13pm _pnmbo7ao"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: iconAppearance === 'chevron' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                    label: "",
                    spacing: "none",
                    size: "small"
                }) : isDevTheme ? (0, $cCPo5.leftArrowPixelDot) : /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    viewBox: "0 0 29 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": true,
                    style: {
                        transform: 'scaleX(-1)'
                    },
                    className: (0, $2jatx.default)([
                        "_1o9zidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.5361 19.1287C19.6575 20.0074 18.2322 20.0074 17.3535 19.1287C16.4748 18.25 16.4748 16.8248 17.3535 15.9461L21.248 12.0525L2.25 12.0525C1.00754 12.0523 0 11.045 0 9.80254C0.000234604 8.56023 1.00769 7.55276 2.25 7.55254L21.0654 7.55254L17.3535 3.84063C16.475 2.96202 16.4751 1.53765 17.3535 0.658987C18.2322 -0.219692 19.6575 -0.219692 20.5361 0.658987L27.8291 7.95293C28.4154 8.35896 28.8006 9.03537 28.8008 9.80254C28.8008 10.2822 28.6493 10.7265 28.3936 11.0916C28.2867 11.3125 28.1433 11.5206 27.96 11.7039L20.5361 19.1287Z",
                        fill: "currentColor"
                    })
                })
            }),
            showCounter && /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_1ul91ylp _y3gn1h6o _uiztglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    counterTypographyClass
                ]),
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                "data-testid": "gallery-controls-counter",
                "aria-label": intl.formatMessage({
                    id: 'gallery-controls.counter',
                    defaultMessage: '{current} of {total} slide'
                }, {
                    current: currentCount,
                    total: totalCount
                }),
                children: [
                    currentCount,
                    "/",
                    totalCount
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleNextClick,
                disabled: isLastItemVisible || isAtLastItem,
                "aria-label": intl.formatMessage({
                    id: 'gallery-controls.next',
                    defaultMessage: 'Next slide'
                }),
                "data-testid": "gallery-controls-next",
                className: (0, $2jatx.default)([
                    "_1e0c116y _80omtlke _1o9zidpf _19itglyw _2rko1osq _2lx21bp4 _tzy4kb7n _1bsb1ylp _4t3i1ylp _bb32qjb0 _1j55clii _j5dh73ad _18o21jaz _16u2yh40",
                    iconAppearance === 'chevron' ? "_4cvr1h6o _1bah1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _syazm7hq _n47eg1d7 _pj3a175s _vbqbe3xi" : isDarkTheme ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _syazm7hq _n47eg1d7 _pj3a175s _vbqbe3xi" : "_4cvr1h6o _1bah1h6o _bfhkm7hq _syaz1afi _ca0qw1gv _u5f319bv _n3tdw1gv _19bv19bv _dmizg1d7 _14iu175s _cun9y4dw",
                    isLarge && "_glte1wqb _165t1wqb",
                    isLarge && !isDevTheme && "_oqic13pm _1rmjo7ao _cjbt13pm _pnmbo7ao"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: iconAppearance === 'chevron' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                    label: "",
                    spacing: "none",
                    size: "small"
                }) : isDevTheme ? (0, $cCPo5.rightArrowPixelDot) : /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    viewBox: "0 0 29 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": true,
                    className: (0, $2jatx.default)([
                        "_1o9zidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.5361 19.1287C19.6575 20.0074 18.2322 20.0074 17.3535 19.1287C16.4748 18.25 16.4748 16.8248 17.3535 15.9461L21.248 12.0525L2.25 12.0525C1.00754 12.0523 0 11.045 0 9.80254C0.000234604 8.56023 1.00769 7.55276 2.25 7.55254L21.0654 7.55254L17.3535 3.84063C16.475 2.96202 16.4751 1.53765 17.3535 0.658987C18.2322 -0.219692 19.6575 -0.219692 20.5361 0.658987L27.8291 7.95293C28.4154 8.35896 28.8006 9.03537 28.8008 9.80254C28.8008 10.2822 28.6493 10.7265 28.3936 11.0916C28.2867 11.3125 28.1433 11.5206 27.96 11.7039L20.5361 19.1287Z",
                        fill: "currentColor"
                    })
                })
            })
        ]
    });
};

});
parcelRegister("cCPo5", function(module, exports) {
$parcel$export(module.exports, "leftArrowPixelDot", function () { return $d4b1f113e81cc7e2$export$c6f64773412179d3; });
$parcel$export(module.exports, "rightArrowPixelDot", function () { return $d4b1f113e81cc7e2$export$f64071501ca056aa; });

var $7VQPk = parcelRequire("7VQPk");
const $d4b1f113e81cc7e2$export$c6f64773412179d3 = /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
    children: [
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        })
    ]
});
const $d4b1f113e81cc7e2$export$f64071501ca056aa = /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
    children: [
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        })
    ]
});

});




parcelRegister("8hbU0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b29fa8567cae1d0$export$2e2bcd8739ae039; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $gA8LO = parcelRequire("gA8LO");

var $64xAu = parcelRequire("64xAu");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $2axoc = parcelRequire("2axoc");

var $6iX8D = parcelRequire("6iX8D");

var $bSVv5 = parcelRequire("bSVv5");

var $2smMv = parcelRequire("2smMv");

var $ksvEJ = parcelRequire("ksvEJ");

var $lE15B = parcelRequire("lE15B");

var $kbpa7 = parcelRequire("kbpa7");

var $lTkkF = parcelRequire("lTkkF");

var $1ij5s = parcelRequire("1ij5s");

var $7UtkR = parcelRequire("7UtkR");
const $7b29fa8567cae1d0$var$UniformBodyContent = ({ body: body, proTipType: proTipType = 'pro-tip', tableVariant: tableVariant = 'v1' })=>{
    const intl = (0, $8e22h.default)();
    const customComponentRenderer = (node)=>{
        switch(node.data.target.sys.contentType.sys.id){
            case 'embeddedVideoAsset':
                {
                    const embeddedVideoAssetData = node.data.target.fields;
                    let embeddedVideoThumbnail = undefined;
                    if (embeddedVideoAssetData.embedAssetOverlayOl) {
                        const orangeLogicThumbnail = embeddedVideoAssetData.embedAssetOverlayOl.fields;
                        const imageUrl = orangeLogicThumbnail.assetJson ? orangeLogicThumbnail.assetJson.imageUrl : orangeLogicThumbnail.assetUrl ?? '';
                        embeddedVideoThumbnail = {
                            src: imageUrl,
                            alt: orangeLogicThumbnail.alt ?? ''
                        };
                    } else if (embeddedVideoAssetData.embedAssetOverlay) embeddedVideoThumbnail = {
                        src: embeddedVideoAssetData.embedAssetOverlay.fields.file.url,
                        alt: embeddedVideoAssetData.embedAssetOverlay.fields.description,
                        contentType: embeddedVideoAssetData.embedAssetOverlay.fields.file.contentType
                    };
                    if (!embeddedVideoAssetData.embedded) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.EmbeddedVideo), {
                            embedUrl: embeddedVideoAssetData.embedded,
                            thumbnail: embeddedVideoThumbnail,
                            title: embeddedVideoAssetData.embeddedVideoAssetNameExternal ?? ''
                        })
                    });
                }
            case 'proTipComponent':
                {
                    const proTipComponentData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2smMv.Panel), {
                            panelType: proTipType,
                            label: proTipComponentData.proTipNameExternal,
                            description: proTipComponentData.proTipRichText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                                text: (0, $gA8LO.documentToHtmlString)(proTipComponentData.proTipRichText)
                            }) : proTipComponentData.proTipText ?? ''
                        })
                    });
                }
            case 'callOutComponent':
                {
                    const callOutComponentData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2smMv.Panel), {
                            panelType: "highlight",
                            label: callOutComponentData.callOutComponentTitleExternal,
                            description: callOutComponentData.callOutText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                                text: (0, $gA8LO.documentToHtmlString)(callOutComponentData.callOutText)
                            }) : ''
                        })
                    });
                }
            case 'callOut':
                {
                    const callOutData = node.data.target.fields;
                    const imageUrl = callOutData.orangeLogicImage?.fields.assetJson ? callOutData.orangeLogicImage?.fields.assetJson.imageUrl : callOutData.orangeLogicImage?.fields.assetUrl ?? undefined;
                    const sideBySideContentCss = null;
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi",
                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulppxbi"
                        ]),
                        children: [
                            imageUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                src: imageUrl,
                                alt: callOutData.orangeLogicImage?.fields.alt ?? '',
                                style: callOutData.orangeLogicImage?.fields.width ? {
                                    width: callOutData.orangeLogicImage?.fields.width
                                } : undefined
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                                title: callOutData.callOutTitleExternal,
                                text: callOutData.callOutShortDescription ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                                    text: (0, $gA8LO.documentToHtmlString)(callOutData.callOutShortDescription)
                                }) : '',
                                callToActionProps: callOutData.callToActionText && callOutData.urlLink ? {
                                    link: {
                                        text: callOutData.callToActionText,
                                        href: callOutData.urlLink
                                    }
                                } : undefined
                            })
                        ]
                    });
                }
            case 'beforeYouBeginComponent':
                {
                    const beforeYouBeginData = node.data.target.fields;
                    const beforeYouBeginContainerCss = null;
                    const individualItemContainerCss = null;
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi",
                            "_bfhkdkka _1yt4xy5q _zulppxbi _1e0c1txw _2lx21bp4"
                        ]),
                        style: {
                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                        },
                        children: [
                            beforeYouBeginData.time && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _19wgu2gc _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                        className: "eyebrow-lg",
                                        children: intl.formatMessage({
                                            id: 'beforeYouBegin.time',
                                            defaultMessage: 'Time'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        children: beforeYouBeginData.time
                                    })
                                ]
                            }),
                            beforeYouBeginData.audience && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _19wgu2gc _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                        className: "eyebrow-lg",
                                        children: intl.formatMessage({
                                            id: 'beforeYouBegin.audience',
                                            defaultMessage: 'Audience'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                                        text: (0, $gA8LO.documentToHtmlString)(beforeYouBeginData.audience)
                                    })
                                ]
                            }),
                            beforeYouBeginData.prerequisite && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _19wgu2gc _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                        className: "eyebrow-lg",
                                        children: intl.formatMessage({
                                            id: 'beforeYouBegin.prerequisite',
                                            defaultMessage: 'Prerequisite'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                                        text: (0, $gA8LO.documentToHtmlString)(beforeYouBeginData.prerequisite)
                                    })
                                ]
                            })
                        ]
                    });
                }
            case 'orangeLogicAsset':
                {
                    const orangeLogicAssetData = node.data.target.fields;
                    const imageUrl = orangeLogicAssetData.assetJson ? orangeLogicAssetData.assetJson.imageUrl : orangeLogicAssetData.assetUrl ?? undefined;
                    if (imageUrl === undefined) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
                    const isVideo = $7b29fa8567cae1d0$export$75bb95a9c117c683(orangeLogicAssetData.assetJson?.extraFields?.['CoreField.DocType'], imageUrl);
                    const assetContainerStyles = [
                        null,
                        null
                    ];
                    // Video is never wrapped in a link — that would swallow the player's controls.
                    if (isVideo) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _1e0c1txw _1bah1h6o",
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
                            loop: true,
                            src: imageUrl
                        })
                    });
                    const image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1ij5s.default), {
                        source: imageUrl,
                        altText: orangeLogicAssetData.alt ?? '',
                        caption: orangeLogicAssetData.caption,
                        width: orangeLogicAssetData.width,
                        height: orangeLogicAssetData.height,
                        maxWidth: "100%",
                        mobileSrc: orangeLogicAssetData.mobileSrc,
                        tabletSrc: orangeLogicAssetData.tabletSrc,
                        tabletWidth: orangeLogicAssetData.tabletWidth,
                        tabletHeight: orangeLogicAssetData.tabletHeight,
                        desktopWidth: orangeLogicAssetData.desktopWidth,
                        desktopHeight: orangeLogicAssetData.desktopHeight
                    });
                    // An asset carrying a linkUrl is clickable — the certification badges on the
                    // /legal pages link out to the certifying body. The anchor takes its
                    // accessible name from the image's alt text, so an asset with a link but no
                    // alt renders an unlabelled link. Opens in a new tab because every current
                    // use is a third-party destination.
                    if (orangeLogicAssetData.linkUrl) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _1e0c1txw _1bah1h6o",
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: orangeLogicAssetData.linkUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "data-product-key": "uniform",
                            "data-event-component": "linkImage",
                            "data-event-container": "bodyContentInline",
                            "data-event": "clicked",
                            children: image
                        })
                    });
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _1e0c1txw _1bah1h6o",
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: image
                    });
                }
            case 'callToActionMicrocopy':
                {
                    const callToActionMicrocopyData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            href: callToActionMicrocopyData.ctaUrl,
                            dataEventProps: {
                                'data-product-key': 'uniform',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'bodyContentInline',
                                'data-event': 'clicked'
                            },
                            children: callToActionMicrocopyData.ctaButtonText
                        })
                    });
                }
            case 'codeBlock':
                {
                    const codeBlockData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                        text: `<pre><code>${codeBlockData.code}</code></pre>`
                    });
                }
            case 'example':
                {
                    const exampleData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_mqm2kze7 _179rkze7 _bfhkg7ng _1yt4xy5q _1q51pxbi"
                        ]),
                        style: {
                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: "eyebrow-lg",
                                children: exampleData.title
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($7b29fa8567cae1d0$var$UniformBodyContent, {
                                body: exampleData.body,
                                tableVariant: tableVariant
                            })
                        ]
                    });
                }
            default:
                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
        }
    };
    // v2 cell content: the cell's paragraphs as rich text (marks, links, lozenges)
    const renderTableCellContent = (cell)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: (0, $gA8LO.documentToHtmlString)({
                nodeType: (0, $64xAu.BLOCKS).DOCUMENT,
                content: cell.content,
                data: {}
            }, {
                renderNode: {
                    [(0, $64xAu.INLINES).EMBEDDED_ENTRY]: $7b29fa8567cae1d0$var$renderLozengeInlineEntryHtml
                }
            })
        });
    const renderContentfulRichTextNodes = (nodes)=>{
        return nodes.map((node)=>{
            switch(node.nodeType){
                case 'embedded-entry-block':
                    return customComponentRenderer(node);
                case 'embedded-asset-block':
                    {
                        const embeddedAssetBlockData = node.data.target;
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: embeddedAssetBlockData.fields.file.url,
                            alt: embeddedAssetBlockData.fields.description,
                            style: $7b29fa8567cae1d0$var$embeddedItemStyles
                        });
                    }
                case 'blockquote':
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                        quote: "",
                        quoteRichTextString: $7b29fa8567cae1d0$var$parseRichTextStringForOnlyContentInsideParagraphs((0, $gA8LO.documentToHtmlString)({
                            nodeType: (0, $64xAu.BLOCKS).DOCUMENT,
                            content: node.content,
                            data: {}
                        }))
                    });
                default:
                    {
                        // v1 tables fall through to the rich text rendering below, unchanged
                        if (tableVariant === 'v2' && node.nodeType === (0, $64xAu.BLOCKS).TABLE) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1mou1ejb"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7UtkR.BodyContentTable), {
                                table: node,
                                renderCellContent: renderTableCellContent
                            })
                        });
                        const headingRenderer = (node, next)=>{
                            const headingNumber = node.nodeType.split('-')[1];
                            const marks = node.content?.at(0)?.marks ?? [];
                            marks?.filter((mark)=>mark.type.includes('id:'));
                            const id = marks[0]?.type.replace('id:', '');
                            return `<h${headingNumber}${id ? ` id="${id}"` : ''}>${next(node.content)}</h${headingNumber}>`;
                        };
                        const inlineEntryRenderer = (node)=>{
                            const entryNode = node;
                            const contentTypeId = entryNode.data.target?.sys?.contentType?.sys?.id;
                            if (contentTypeId === 'lozenge') return $7b29fa8567cae1d0$var$renderLozengeInlineEntryHtml(node);
                            return '';
                        };
                        const options = {
                            renderNode: {
                                [(0, $64xAu.BLOCKS).HEADING_2]: headingRenderer,
                                [(0, $64xAu.BLOCKS).HEADING_3]: headingRenderer,
                                [(0, $64xAu.BLOCKS).HEADING_4]: headingRenderer,
                                [(0, $64xAu.BLOCKS).HEADING_5]: headingRenderer,
                                [(0, $64xAu.BLOCKS).HEADING_6]: headingRenderer,
                                [(0, $64xAu.INLINES).EMBEDDED_ENTRY]: inlineEntryRenderer
                            }
                        };
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                            text: (0, $gA8LO.documentToHtmlString)({
                                nodeType: (0, $64xAu.BLOCKS).DOCUMENT,
                                content: [
                                    $7b29fa8567cae1d0$var$parseRichTextNodesForInlineEntries(node)
                                ],
                                data: {}
                            }, options)
                        });
                    }
            }
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: "body-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1srcpxbi _e3fzidpf _1cmiidpf _ynj4idpf _b289idpf _1d1c1hna _171a116y _u85y1h6o _1g3aftgi _1mem1h6o _gse0z4z1 _97x6bfng _doj9nl7k _14xdangw _j7nzuuw1 _1f8qusvi _11sdidpf _17so1ns9 _1ffh1skh _vhbk7vkz _132ugktf _1hlk1bjw _1my6ftjs _1qgmi8nm _4k2zazsu _n61k1tl1 _17uckyk1 _sydj6hld _rehrsei6 _1i5j1qk7 _d8nlirhu _1uqctaeo _m2qv1d19"
        ]),
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800')),
            "--_o8p2jx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron100')),
            "--_y2vd2j": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron800')),
            "--_1t0xqbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime100')),
            "--_rhsgef": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime800')),
            "--_548yx2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple100')),
            "--_208vpz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple800')),
            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
        },
        children: renderContentfulRichTextNodes(body.content)
    });
};
const $7b29fa8567cae1d0$var$tableV2ContainerCss = null;
const $7b29fa8567cae1d0$var$embeddedItemStyles = {
    maxWidth: '100%',
    marginBlock: "var(--ds-space-200, 16px)"
};
const $7b29fa8567cae1d0$var$exampleContainerCss = null;
const $7b29fa8567cae1d0$var$bodyContainerCss = null;
const $7b29fa8567cae1d0$var$parseRichTextStringForOnlyContentInsideParagraphs = (richTextString)=>{
    const paragraphRegex = /<p\b[^>]*>(.*?)<\/p>/gi;
    const matches = Array.from(richTextString.matchAll(paragraphRegex));
    return matches ? matches.map((m)=>m[1]).join() : richTextString;
};
const $7b29fa8567cae1d0$var$parseRichTextNodesForInlineEntries = (node)=>{
    if (node.nodeType.split('-')[0] === 'heading' && node.content && node.content.length > 1) {
        // check if anchor exists in heading node
        const anchorIndex = node.content.findIndex((innerNode)=>innerNode.nodeType === (0, $64xAu.INLINES).EMBEDDED_ENTRY && innerNode.data.target?.sys?.contentType.sys.id === 'anchorLink');
        if (anchorIndex > 0) {
            const anchorLinkData = node.content.at(anchorIndex)?.data.target?.fields;
            const contentCopy = node.content.slice(); // node.content is uneditable. need to copy to make changes
            const headerTextNode = contentCopy.at(0);
            if (headerTextNode && headerTextNode.marks) {
                // set mark id:<id> on header text node
                const newHeaderTextNode = {
                    ...headerTextNode,
                    marks: [
                        ...headerTextNode.marks,
                        {
                            type: `id:${anchorLinkData.id}`
                        }
                    ]
                };
                contentCopy.splice(anchorIndex, 1);
                return {
                    ...node,
                    content: [
                        newHeaderTextNode,
                        ...contentCopy.slice(1)
                    ]
                };
            }
        }
    }
    return node;
};
const $7b29fa8567cae1d0$var$renderLozengeInlineEntryHtml = (node)=>{
    const entryNode = node;
    const fields = entryNode.data.target?.fields;
    if (!fields?.text) return '';
    const rawType = fields.type?.toLowerCase() ?? 'neutral';
    // Map 'red' (and legacy 'danger') to the 'danger' design token appearance
    const appearance = rawType === 'red' || rawType === 'danger' ? 'danger' : rawType;
    return `<span data-lozenge-appearance="${appearance}">${fields.text}</span>`;
};
const $7b29fa8567cae1d0$export$75bb95a9c117c683 = (contentType, url)=>{
    if (contentType?.toLowerCase() === 'video') return true;
    //FIXME: interim rudimentary sollution for migration as we cannot ensure all assets have on OL asset JSON
    const parts = url?.split('.');
    const expectedExtension = parts?.[parts?.length - 1];
    if (expectedExtension === 'webm' || expectedExtension === 'mp4') return true;
    return false;
};
var $7b29fa8567cae1d0$export$2e2bcd8739ae039 = $7b29fa8567cae1d0$var$UniformBodyContent;

});
parcelRegister("2smMv", function(module, exports) {
$parcel$export(module.exports, "Panel", function () { return $98eab9054c032be6$export$2ddb90ad54e5f587; });
/* panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");

var $5ioYv = parcelRequire("5ioYv");

var $fyJbN = parcelRequire("fyJbN");

var $kSqS5 = parcelRequire("kSqS5");
const $98eab9054c032be6$var$iconMap = {
    'pro-tip': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kSqS5.ProTipIcon), {}),
    'atlassian-pro-tip': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5ioYv.AtlassianIcon), {}),
    highlight: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fyJbN.ErrorIcon), {})
};
const $98eab9054c032be6$var$addSectionTitleClass = (text)=>text.replace(/<p><b>([A-Z0-9\s:]+)<\/b><\/p>/g, '<p class="panel-section-title"><b>$1</b></p>');
const $98eab9054c032be6$export$2ddb90ad54e5f587 = (props)=>{
    const descriptionComponent = typeof props.description === 'string' ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        children: props.description
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).isValidElement(props.description) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(props.description, {
        ...props.description.props.text !== undefined ? {
            text: $98eab9054c032be6$var$addSectionTitleClass(props.description.props.text ?? '')
        } : {}
    }) : props.description ?? null;
    const icon = $98eab9054c032be6$var$iconMap[props.panelType];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rko1ylz _1q51pxbi _85i5v47k _18zrxy5q _1e0c1txw _zulppxbi _1gde1bp4 _81641b66",
            "_bfhk1a4x"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_xxkev2": (0, $6ZVlx.default)(props.panelType === 'atlassian-pro-tip' ? (0, $kbpa7.wacToken)('color.extended.blue100') : (0, $kbpa7.wacToken)('color.neutral.light200'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: icon
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _14x5u2gc _zpyku2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "eyebrow-lg",
                        children: props.label
                    }),
                    descriptionComponent
                ]
            })
        ]
    });
};
const $98eab9054c032be6$var$panelContainerCss = null;
const $98eab9054c032be6$var$textCss = null;

});
parcelRegister("5ioYv", function(module, exports) {
$parcel$export(module.exports, "AtlassianIcon", function () { return $50e3a288daddaec7$export$8a485e2e7ed91e8f; });

var $7VQPk = parcelRequire("7VQPk");

var $kbpa7 = parcelRequire("kbpa7");
const $50e3a288daddaec7$export$8a485e2e7ed91e8f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "44",
        height: "44",
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.4202 25.173C18.0911 20.515 17.8582 14.343 21.3906 8.75329C21.7399 8.20984 22.3999 8.24866 22.6328 8.7921C22.9433 9.37436 34.7438 32.9753 34.7438 32.9753C35.0155 33.48 34.6273 34.0622 34.0839 34.0622H25.3111C25.0394 34.0622 24.7677 33.9069 24.6513 33.6352C24.5808 33.4708 23.8992 32.1126 22.8559 30.0335C22.1749 28.6766 21.3399 27.0126 20.4202 25.173Z",
                fill: (0, $kbpa7.wacToken)('color.primary.blue')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.5278 20.3663C15.7995 19.8617 16.3817 19.8229 16.7699 20.2499C20.0694 23.7822 21.2339 29.7213 19.3319 33.6419C19.2154 33.9136 18.9437 34.0688 18.6719 34.0688H9.89923C9.35579 34.0688 9.00645 33.4866 9.23935 32.982L15.5278 20.3663Z",
                fill: (0, $kbpa7.wacToken)('color.primary.blue')
            })
        ]
    });
};

});

parcelRegister("fyJbN", function(module, exports) {
$parcel$export(module.exports, "ErrorIcon", function () { return $2a2632c6ae6dea63$export$19bc16ee58e19b3d; });

var $7VQPk = parcelRequire("7VQPk");

var $kbpa7 = parcelRequire("kbpa7");
const $2a2632c6ae6dea63$export$19bc16ee58e19b3d = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "44",
        height: "44",
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.11 7.65833C20.2574 5.51123 23.7394 5.51212 25.8873 7.65833L36.839 18.61C38.8523 20.6236 38.9794 23.8109 37.2177 25.9711L36.839 26.3873L25.8873 37.339C23.7395 39.4865 20.2578 39.4865 18.11 37.339L7.15833 26.3873C5.01212 24.2394 5.01123 20.7574 7.15833 18.61L18.11 7.65833ZM22.0013 27.9987C20.4828 27.9987 19.2517 29.2302 19.2513 30.7487C19.2513 32.2674 20.4826 33.4987 22.0013 33.4987C23.5195 33.4979 24.7513 32.267 24.7513 30.7487C24.751 29.2306 23.5193 27.9994 22.0013 27.9987ZM19.9388 11.4987V25.2487H24.0638V11.4987H19.9388Z",
            fill: (0, $kbpa7.wacToken)('color.neutral.light1000')
        })
    });
};

});

parcelRegister("kSqS5", function(module, exports) {
$parcel$export(module.exports, "ProTipIcon", function () { return $2cc3abe193b9fea5$export$878ebefa84ac806a; });

var $7VQPk = parcelRequire("7VQPk");

var $kbpa7 = parcelRequire("kbpa7");
const $2cc3abe193b9fea5$export$878ebefa84ac806a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "44",
        height: "44",
        viewBox: "0 0 76 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M60.5935 36.8029C60.9647 34.7229 61.1567 32.5181 61.1567 30.1757C61.1567 27.8333 60.9583 25.5677 60.5807 23.4621C58.3343 10.9373 49.6303 3.21893 37.4287 1.23173C35.3455 0.895727 33.1631 0.719727 30.8943 0.719727C28.6255 0.719727 26.2511 0.905327 24.0879 1.27013C11.8799 3.30853 3.19506 11.0109 0.939063 23.4621C0.558263 25.5645 0.359863 27.8045 0.359863 30.1757C0.359863 32.5469 0.555063 34.7229 0.926263 36.8029C3.16306 49.2413 11.8575 56.9565 24.0847 58.9949C26.2479 59.3565 28.5231 59.5453 30.8911 59.5453C33.2591 59.5453 35.3455 59.3725 37.4255 59.0333C49.6463 57.0493 58.3535 49.3117 60.5871 36.8029H60.5935Z",
                fill: (0, $kbpa7.wacToken)('color.extended.lime600')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.3296 29.9547L64.728 5.58032L73.3808 13.5931L39.3936 42.7675L23.3936 28.0251L31.7136 18.4187L41.3264 29.9579L41.3296 29.9547Z",
                fill: (0, $kbpa7.wacToken)('color.secondary.navy')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M60.5871 23.4621C59.9215 19.7693 58.6959 16.4861 56.9839 13.6509L41.3327 29.9549L31.7199 18.4157L23.3999 28.0221L39.3999 42.7645L60.7503 24.4381C60.7023 24.1085 60.6511 23.7821 60.5935 23.4589L60.5871 23.4621Z",
                fill: (0, $kbpa7.wacToken)('color.secondary.navy')
            })
        ]
    });
};

});


parcelRegister("lE15B", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $6c2ebb039f940200$export$ae01dedf5c052bb; });
/* video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $f5ck7 = parcelRequire("f5ck7");

var $jElRc = parcelRequire("jElRc");
const $6c2ebb039f940200$var$getVideoExtension = (src)=>src.split('?')[0]?.split('#')[0]?.split('.').at(-1)?.toLowerCase() ?? '';
/**
 * Returns the `type` attribute for a single-source `<video>` (i.e. when no
 * companion `fallbackSrc` is provided). When a fallback IS provided, the
 * source list is hard-coded to `[HEVC mp4, webm]` and this helper is not used.
 */ const $6c2ebb039f940200$var$getSingleSourceType = (src)=>{
    const ext = $6c2ebb039f940200$var$getVideoExtension(src);
    if (ext === 'webm') return 'video/webm';
    return 'video/mp4';
};
const $6c2ebb039f940200$export$ae01dedf5c052bb = ({ src: src, fallbackSrc: fallbackSrc, alt: alt = '', poster: poster, roundedCorners: roundedCorners = false, desktopHeight: desktopHeight, tabletHeight: tabletHeight, mobileHeight: mobileHeight, disableAutoplay: disableAutoplay = false, showVideoControls: showVideoControls = false, loop: loop = false, aspectRatio: aspectRatio, border: border = false, intersectionThreshold: intersectionThreshold = 0.5, eagerLoading: eagerLoading = false })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, $1oC0p.useState)(false);
    const [hasError, setHasError] = (0, $1oC0p.useState)(false);
    const isTabActive = (0, $f5ck7.useTabActiveContext)();
    // Keep a ref so the IntersectionObserver callback can read the latest value
    // without needing to be re-created every time isTabActive changes.
    const isTabActiveRef = (0, $1oC0p.useRef)(isTabActive);
    (0, $1oC0p.useEffect)(()=>{
        isTabActiveRef.current = isTabActive;
    }, [
        isTabActive
    ]);
    // Track whether the tab has ever been inactive so the resume branch in the
    // tab-active effect does not fire on initial mount (when isTabActive is
    // already true and the IntersectionObserver hasn't run yet).
    const wasTabInactiveRef = (0, $1oC0p.useRef)(false);
    // Reset the error state whenever the source list changes. This replaces the
    // old `onLoadStart={() => setHasError(false)}` handler, which fired on
    // every `<source>` the browser tried — racing with `onError` events from
    // earlier `<source>` elements (e.g. a codec rejection on the first source)
    // and intermittently leaving `hasError` stuck `true` between refreshes.
    (0, $1oC0p.useEffect)(()=>{
        setHasError(false);
    }, [
        src,
        fallbackSrc
    ]);
    // Capture the threshold at mount time so that subsequent re-renders
    // (e.g. from state changes or transient prop fluctuations) cannot
    // tear down and recreate the IntersectionObserver with a different value.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const intersectionThresholdRef = (0, $1oC0p.useRef)(intersectionThreshold);
    // Play from beginning when in viewport, pause when out.
    // Note: we intentionally do NOT depend on `hasError` here. A `<source>`-level
    // error must not prevent the play attempt — the browser will fall through to
    // the next source on its own. We still call `play()`; the returned promise
    // simply rejects if there's truly nothing to play, which we swallow.
    (0, $1oC0p.useEffect)(()=>{
        const video = videoRef.current;
        if (!video || disableAutoplay) return;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry && entry.isIntersecting) {
                // Don't autoplay if the enclosing tab is not active.
                if (!isTabActiveRef.current) return;
                video.currentTime = 0; // Always start from beginning
                video.play().catch(()=>{
                // Ignore play errors (autoplay restrictions, power
                // saving, no decodable source, etc.)
                });
            } else video.pause();
        }, {
            threshold: intersectionThresholdRef.current
        });
        observer.observe(video);
        return ()=>{
            observer.disconnect();
        };
    // intersectionThresholdRef is intentionally omitted — the threshold is
    // captured once at mount and stays stable for the lifetime of the component.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        disableAutoplay
    ]);
    // When the enclosing tab becomes inactive, pause and reset the video so it
    // starts from the beginning when the tab is re-selected. When it becomes
    // active again, resume playback — the IntersectionObserver will not re-fire
    // because the element's intersection state hasn't changed (still in-viewport).
    (0, $1oC0p.useEffect)(()=>{
        const video = videoRef.current;
        if (!video || disableAutoplay) return;
        if (!isTabActive) {
            wasTabInactiveRef.current = true;
            video.pause();
            video.currentTime = 0;
            setIsPlaying(false);
        } else if (wasTabInactiveRef.current) // Only resume when transitioning from inactive → active. Skips the
        // initial mount where isTabActive is already true (the
        // IntersectionObserver handles the first play in that case).
        // Guard with Promise.resolve() in case the environment's play()
        // does not return a Promise (e.g. jsdom in tests).
        Promise.resolve(video.play()).then(()=>{
            setIsPlaying(true);
        }).catch(()=>{
        // Ignore play errors (autoplay restrictions, power saving, etc.)
        });
    }, [
        isTabActive,
        disableAutoplay
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const togglePlay = (0, $1oC0p.useCallback)(()=>{
        if (videoRef.current && !hasError) {
            if (isPlaying) {
                videoRef.current.pause();
                setIsPlaying(false);
                createAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pauseVideo',
                    source: 'videoContainer',
                    attributes: {
                        label: 'pause'
                    }
                }).fire();
            } else videoRef.current.play().then(()=>{
                setIsPlaying(true);
                createAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'playVideo',
                    source: 'videoContainer',
                    attributes: {
                        label: 'play'
                    }
                }).fire();
            }).catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                setIsPlaying(false);
            });
        }
    }, [
        videoRef,
        hasError,
        isPlaying,
        createAnalyticsEvent
    ]);
    const videoCss = null;
    // When BOTH a primary and a fallback source are provided, the contract is:
    //   `src`         = .webm (VP9 + alpha)
    //   `fallbackSrc` = .mp4/.mov (HEVC / hvc1 + alpha)
    // The HEVC source MUST be rendered FIRST with `codecs="hvc1"` so Safari
    // picks it (Safari supports WebM but not WebM-with-alpha; without this
    // ordering Safari renders the alpha as a black background). Chrome/Firefox
    // do not support hvc1 and will skip past it to the WebM.
    // See: https://supergeekery.com/blog/transparent-video-in-chrome-edge-firefox-and-safari-circa-2022
    const sources = fallbackSrc ? [
        {
            src: fallbackSrc,
            type: 'video/mp4; codecs="hvc1"'
        },
        {
            src: src,
            type: 'video/webm'
        }
    ] : [
        {
            src: src,
            type: $6c2ebb039f940200$var$getSingleSourceType(src)
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm",
            roundedCorners && "_2rko1ylz _1reo15vq _18m915vq",
            border && "_19itn5xp"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
                ref: videoRef,
                playsInline: true,
                muted: true,
                preload: eagerLoading ? 'auto' : 'metadata',
                ...!eagerLoading ? {
                    loading: 'lazy'
                } : {},
                poster: poster,
                controls: showVideoControls,
                loop: loop,
                "aria-label": alt,
                "aria-hidden": alt === '',
                onPlay: ()=>setIsPlaying(true),
                onPause: ()=>setIsPlaying(false),
                onEnded: ()=>setIsPlaying(false),
                // Only mark the component as errored when the browser has
                // exhausted ALL `<source>` elements (NETWORK_NO_SOURCE). A
                // single source-level rejection (e.g. codec mismatch on the
                // HEVC fallback when the asset is actually H.264) is not a
                // failure — the browser will fall through to the next source.
                onError: ()=>{
                    const v = videoRef.current;
                    if (v && v.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) setHasError(true);
                },
                className: (0, $2jatx.default)([
                    "_1bsb1osq _165to2tq _1vkh1phk _tnrunlnk"
                ]),
                style: {
                    maxWidth: '100%',
                    aspectRatio: aspectRatio,
                    "--_1ls2h32": (0, $6ZVlx.default)(desktopHeight ? desktopHeight : 'auto'),
                    "--_1cb1a05": (0, $6ZVlx.default)(tabletHeight ? tabletHeight : 'auto'),
                    "--_4qax9k": (0, $6ZVlx.default)(mobileHeight ? mobileHeight : 'auto')
                },
                children: [
                    sources.map((source)=>/*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: source.src,
                            type: source.type
                        }, source.src)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("track", {
                        kind: "captions"
                    }),
                    "Video not supported."
                ]
            }),
            !hasError && !showVideoControls && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1bsb1osq _1e0c1txw _1bahh9n0 _u7cou2gc _1yt412x7"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                    isPlaying: isPlaying,
                    onToggle: togglePlay,
                    mediaLabel: alt !== '' ? alt : 'video'
                })
            })
        ]
    });
};
const $6c2ebb039f940200$var$controlContainerCss = null;
const $6c2ebb039f940200$var$roundedCornersCss = null;
const $6c2ebb039f940200$var$borderCss = null;

});
parcelRegister("jElRc", function(module, exports) {
$parcel$export(module.exports, "PlayPauseControls", function () { return $ccd69261239402ec$export$17b97ca49a11c070; });
/* play-pause-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $aKeh7 = parcelRequire("aKeh7");

var $1iN19 = parcelRequire("1iN19");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $k9sMy = parcelRequire("k9sMy");
const $ccd69261239402ec$export$17b97ca49a11c070 = ({ isPlaying: isPlaying, onToggle: onToggle, mediaLabel: mediaLabel })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { isDarkTheme: isDarkTheme, isDevTheme: isDevTheme } = (0, $eOIix.useTheme)();
    const handleToggleClick = (0, $1oC0p.useCallback)(()=>{
        const intent = isPlaying ? 'pause' : 'play';
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'playPauseControlButton',
            eventType: 'ui',
            eventComponent: 'button',
            source: 'play-pause-controls',
            attributes: {
                intent: intent
            }
        }).fire();
        onToggle();
    }, [
        createAnalyticsEvent,
        isPlaying,
        onToggle
    ]);
    const playLabel = mediaLabel ? intl.formatMessage({
        id: 'play-pause-controls.play-with-label',
        defaultMessage: 'Play {mediaLabel}'
    }, {
        mediaLabel: mediaLabel
    }) : intl.formatMessage({
        id: 'play-pause-controls.play',
        defaultMessage: 'Play'
    });
    const pauseLabel = mediaLabel ? intl.formatMessage({
        id: 'play-pause-controls.pause-with-label',
        defaultMessage: 'Pause {mediaLabel}'
    }, {
        mediaLabel: mediaLabel
    }) : intl.formatMessage({
        id: 'play-pause-controls.pause',
        defaultMessage: 'Pause'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        onClick: handleToggleClick,
        "aria-label": isPlaying ? pauseLabel : playLabel,
        "aria-pressed": isPlaying,
        "data-testid": "play-pause-controls",
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _vchhusvi _16jlidpf _1o9zidpf _i0dl1wug _1h1t1ekt _1yt4ze3t _bfhk1j28 _19itglyw _2rko1osq _80omtlke _1kz61jfw _15k51jfw _ugzy1jfw _uhwn1jfw _ofie1jfw _bu0k1jfw _1ygb7g83 _1ah3v77o _1de76u2e _c2b0s3kk _wkf9s3kk",
            isDarkTheme && "_1de71afi _c2b01qc2 _wkf91qc2 _syazm7hq _30l3g1d7 _9h8h175s"
        ]),
        style: {
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
        },
        children: isDevTheme ? isPlaying ? (0, $k9sMy.pauseIconPixelDot) : (0, $k9sMy.playIconPixelDot) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhkm7hq _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _vchhusvi _16jlidpf _1o9zidpf _i0dl1wug _1h1t1ekt _1kz61jfw _15k51jfw _ugzy1jfw _uhwn1jfw _ofie1jfw _bu0k1jfw _11lcxy5q _16jxxy5q _16m5xy5q _15mnxy5q _wvzdxy5q _1km9xy5q _irr3g1d7 _1di6175s"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_syaz1pfd _1e0c1txw _vwz4idpf"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: isPlaying ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aKeh7))), {
                    label: "",
                    size: "medium",
                    color: "currentColor"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iN19))), {
                    label: "",
                    size: "medium",
                    color: "currentColor"
                })
            })
        })
    });
};
const $ccd69261239402ec$var$controlButtonCss = null;
const $ccd69261239402ec$var$darkThemeControlButtonCss = null;
const $ccd69261239402ec$var$buttonCircleCss = null;
/** Figma: black glyphs on the neutral circular background */ const $ccd69261239402ec$var$iconGlyphCss = null;

});
parcelRegister("k9sMy", function(module, exports) {
$parcel$export(module.exports, "playIconPixelDot", function () { return $2932a75c83d5b92f$export$6ee5101786c461e6; });
$parcel$export(module.exports, "pauseIconPixelDot", function () { return $2932a75c83d5b92f$export$257bfc3efa771142; });

var $7VQPk = parcelRequire("7VQPk");
const $2932a75c83d5b92f$export$6ee5101786c461e6 = /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    fill: "none",
    "aria-hidden": true,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        })
    ]
});
const $2932a75c83d5b92f$export$257bfc3efa771142 = /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    fill: "none",
    "aria-hidden": true,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "3",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "6",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "9",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "12",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "18",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "15",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "21",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "24",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "30",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "27",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "33",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "36",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "39",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "21",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "42",
            width: "2",
            height: "2",
            fill: "currentColor"
        })
    ]
});

});



parcelRegister("1ij5s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00ee4cee431699a0$export$2e2bcd8739ae039; });
/* image-v2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $00ee4cee431699a0$var$UniformImageV2 = ({ source: source, altText: altText = '', caption: caption, width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false, roundedCorners: roundedCorners = false, mobileSrc: mobileSrc, tabletSrc: tabletSrc, aspectRatio: aspectRatio, maxPossibleWidth: maxPossibleWidth })=>{
    if (!source) return null;
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition,
        aspectRatio: aspectRatio
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null;
    // @ts-expect-error types
    const responsiveStyles = null;
    const makeCircleStyle = null;
    const roundedCornersStyle = null;
    const pictureStyle = null;
    const { maxWidth: maxWidthStyle, ...restImageStyle } = imageStyle;
    const hasResponsiveSources = mobileSrc || tabletSrc;
    if (hasResponsiveSources) {
        const sources = [];
        // The <source> media attribute requires a plain CSS media query string —
        // the @atlaskit/primitives media tokens (e.g. media.below.sm) are
        // Compiled-JS values and cannot be used here. The pixel values below
        // correspond to media.below.sm (< 768px = mobile) and
        // media.below.md (< 1024px = tablet), consistent with breakpoints used
        // elsewhere in this codebase.
        // Note: these use max-width (desktop-first) because <source> elements
        // are evaluated top-to-bottom by the browser — the most specific
        // (smallest) breakpoint must come first. This is separate from the
        // mobile-first min-width approach used for CSS sizing props above.
        if (mobileSrc) sources.push({
            srcSet: mobileSrc,
            media: '(max-width: 767px)'
        });
        if (tabletSrc) sources.push({
            srcSet: tabletSrc,
            media: '(max-width: 1023px)'
        });
        const pictureElement = /*#__PURE__*/ (0, $7VQPk.jsxs)("picture", {
            className: (0, $2jatx.default)([
                width && "_1bsbydm4",
                height && "_4t3i1j6h",
                tabletWidth && "_14b56k1b",
                desktopWidth && "_gltenwv8",
                tabletHeight && "_1xlo1phk",
                desktopHeight && "_165to2tq",
                roundedCorners && "_2rko1ylz",
                makeCircle && "_2rko1ssb",
                "_1e0c1ule"
            ]),
            style: {
                "--_ad5ho1": (0, $6ZVlx.default)(width ? width : 'auto'),
                "--_13eytri": (0, $6ZVlx.default)(height ? height : 'auto'),
                "--_glhwna": (0, $6ZVlx.default)(tabletWidth ? tabletWidth : 'auto'),
                "--_l1cbh": (0, $6ZVlx.default)(desktopWidth ? desktopWidth : 'auto'),
                "--_1cb1a05": (0, $6ZVlx.default)(tabletHeight ? tabletHeight : 'auto'),
                "--_1ls2h32": (0, $6ZVlx.default)(desktopHeight ? desktopHeight : 'auto'),
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
            },
            children: [
                sources.map((src, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                        ...src
                    }, index)),
                /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: source,
                    alt: altText,
                    style: {
                        maxWidth: maxWidthStyle ?? '100%',
                        display: 'block',
                        ...restImageStyle
                    }
                })
            ]
        });
        if (caption) return /*#__PURE__*/ (0, $7VQPk.jsxs)("figure", {
            className: (0, $2jatx.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
            ]),
            children: [
                pictureElement,
                /*#__PURE__*/ (0, $7VQPk.jsx)("figcaption", {
                    className: (0, $2jatx.default)([
                        "_1pfhu2gc",
                        "body-sm"
                    ]),
                    children: caption
                })
            ]
        });
        return pictureElement;
    }
    const parsedMaxPossibleWidth = maxPossibleWidth ? Number(maxPossibleWidth) : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        src: source,
        alt: altText,
        caption: caption,
        maxPossibleWidth: parsedMaxPossibleWidth,
        className: (0, $2jatx.default)([
            width && "_1bsbydm4",
            height && "_4t3i1j6h",
            tabletWidth && "_14b56k1b",
            desktopWidth && "_gltenwv8",
            tabletHeight && "_1xlo1phk",
            desktopHeight && "_165to2tq",
            roundedCorners && "_2rko1ylz",
            makeCircle && "_2rko1ssb"
        ]),
        style: {
            ...imageStyle,
            "--_ad5ho1": (0, $6ZVlx.default)(width ? width : 'auto'),
            "--_13eytri": (0, $6ZVlx.default)(height ? height : 'auto'),
            "--_glhwna": (0, $6ZVlx.default)(tabletWidth ? tabletWidth : 'auto'),
            "--_l1cbh": (0, $6ZVlx.default)(desktopWidth ? desktopWidth : 'auto'),
            "--_1cb1a05": (0, $6ZVlx.default)(tabletHeight ? tabletHeight : 'auto'),
            "--_1ls2h32": (0, $6ZVlx.default)(desktopHeight ? desktopHeight : 'auto'),
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
        }
    });
};
var $00ee4cee431699a0$export$2e2bcd8739ae039 = $00ee4cee431699a0$var$UniformImageV2;

});

parcelRegister("7UtkR", function(module, exports) {
$parcel$export(module.exports, "BodyContentTable", function () { return $f0c983c246184171$export$946bc34493b2ef2b; });
/* body-content-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $64xAu = parcelRequire("64xAu");

var $GVdPS = parcelRequire("GVdPS");

var $a25eA = parcelRequire("a25eA");

var $hGOQQ = parcelRequire("hGOQQ");

var $at2aH = parcelRequire("at2aH");

var $cZmh0 = parcelRequire("cZmh0");
/** Tables with at least this many columns (row title column included) span the full width. */ const $f0c983c246184171$var$FULL_WIDTH_MIN_COLUMNS = 4;
/** With this many columns or more, the row title column is capped at ROW_TITLE_MAX_WIDTH. */ const $f0c983c246184171$var$ROW_TITLE_CAP_MIN_COLUMNS = 5;
const $f0c983c246184171$var$ROW_TITLE_MAX_WIDTH = '240px';
// Column and row titles are bold. Their text is in rich text paragraphs, which global
// typography sets to `p { font-weight: 400 }`; `div p` (RichTextComponent's wrapper) out-ranks
// that selector regardless of stylesheet order.
const $f0c983c246184171$var$titleContentCss = null;
// Up to 3 columns span 8 of the 10 grid columns on desktop, centered
const $f0c983c246184171$var$narrowTableCss = null;
const $f0c983c246184171$var$getNodeText = (node)=>node.nodeType === 'text' ? node.value : node.content.map((child)=>$f0c983c246184171$var$getNodeText(child)).join('');
const $f0c983c246184171$var$getCells = (row)=>row.content.filter((cell)=>[
            (0, $64xAu.BLOCKS).TABLE_CELL,
            (0, $64xAu.BLOCKS).TABLE_HEADER_CELL
        ].includes(cell.nodeType));
const $f0c983c246184171$var$isHeaderCell = (cell)=>cell?.nodeType === (0, $64xAu.BLOCKS).TABLE_HEADER_CELL;
const $f0c983c246184171$var$isEmptyCell = (cell)=>!cell || !$f0c983c246184171$var$getNodeText(cell).trim();
const $f0c983c246184171$var$getTextNodes = (node)=>node.nodeType === 'text' ? [
        node
    ] : node.content.flatMap((child)=>$f0c983c246184171$var$getTextNodes(child));
/** True when the cell has text and all of it (whitespace aside) is bold, including link text. */ const $f0c983c246184171$var$isBoldCell = (cell)=>{
    const textNodes = cell ? $f0c983c246184171$var$getTextNodes(cell).filter((text)=>text.value.trim()) : [];
    return textNodes.length > 0 && textNodes.every((text)=>text.marks.some((mark)=>mark.type === (0, $64xAu.MARKS).BOLD));
};
const $f0c983c246184171$export$946bc34493b2ef2b = ({ table: table, renderCellContent: renderCellContent })=>{
    const rows = table.content.filter((row)=>row.nodeType === (0, $64xAu.BLOCKS).TABLE_ROW);
    const [firstRow, ...otherRows] = rows;
    const firstRowCells = firstRow ? $f0c983c246184171$var$getCells(firstRow) : [];
    const hasColumnTitles = firstRowCells.length > 0 && firstRowCells.every($f0c983c246184171$var$isHeaderCell);
    const bodyRows = hasColumnTitles ? otherRows : rows;
    const columnCount = Math.max(0, ...rows.map((row)=>$f0c983c246184171$var$getCells(row).length));
    if (!columnCount) return null;
    const [cornerCell] = firstRowCells;
    const hasEmptyCorner = hasColumnTitles && $f0c983c246184171$var$isEmptyCell(cornerCell);
    // The first column: all bold, or an empty top cell with every cell below it bold
    const [topCell, ...belowTopCells] = rows.map((row)=>$f0c983c246184171$var$getCells(row)[0]);
    const hasRowTitles = bodyRows.length > 0 && belowTopCells.every($f0c983c246184171$var$isBoldCell) && ($f0c983c246184171$var$isBoldCell(topCell) || $f0c983c246184171$var$isEmptyCell(topCell) && belowTopCells.length > 0);
    const columnWidth = `${100 / columnCount}%`;
    // The capped row title column frees space, which the other (unsized) columns share
    // equally — table-layout is fixed
    const rowTitleColWidth = hasRowTitles && columnCount >= $f0c983c246184171$var$ROW_TITLE_CAP_MIN_COLUMNS ? `min(${columnWidth}, ${$f0c983c246184171$var$ROW_TITLE_MAX_WIDTH})` : undefined;
    const renderTitle = (cell)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_durb1fw0"
            ]),
            children: renderCellContent(cell)
        });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            columnCount < $f0c983c246184171$var$FULL_WIDTH_MIN_COLUMNS && "_glte1w8u _xtn71wug"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $GVdPS.GenericTable), {
            variant: "v2",
            children: [
                hasColumnTitles && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $at2aH.GenericTableThead), {
                    colWidth: rowTitleColWidth ? undefined : columnWidth,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $at2aH.GenericTableHeadRow), {
                        children: firstRowCells.map((cell, index)=>{
                            // The empty top-left corner (above the row titles) is blank and hidden
                            const isCorner = index === 0 && hasEmptyCorner;
                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a25eA.GenericTableColumnHeader), {
                                "aria-hidden": isCorner || undefined,
                                colWidth: index === 0 ? rowTitleColWidth : undefined,
                                // Stays in place on mobile with the row titles below it
                                isRowHeaderColumn: hasRowTitles && index === 0,
                                children: !isCorner && renderTitle(cell)
                            }, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                    children: bodyRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cZmh0.GenericTableRow), {
                            children: $f0c983c246184171$var$getCells(row).map((cell, cellIndex)=>{
                                const isRowTitle = hasRowTitles && cellIndex === 0;
                                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hGOQQ.GenericTableCustomCell), {
                                    isRowHeader: isRowTitle,
                                    children: isRowTitle ? renderTitle(cell) : renderCellContent(cell)
                                }, cellIndex);
                            })
                        }, rowIndex))
                })
            ]
        })
    });
};

});
parcelRegister("GVdPS", function(module, exports) {
$parcel$export(module.exports, "GenericTable", function () { return $66259802600c3102$export$a8994f76dea4d338; });
/* generic-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $clnBI = parcelRequire("clnBI");

var $Lp2P8 = parcelRequire("Lp2P8");

var $kbpa7 = parcelRequire("kbpa7");

var $6Ztx3 = parcelRequire("6Ztx3");
const $66259802600c3102$var$MOBILE_COLUMN_WIDTH = 140;
const $66259802600c3102$var$MOBILE_COLUMN_WIDTH_CSS = `${$66259802600c3102$var$MOBILE_COLUMN_WIDTH}px`;
const $66259802600c3102$var$SCROLL_EDGE_TOLERANCE = 1;
const $66259802600c3102$var$tableCss = null;
const $66259802600c3102$var$tableContainerCss = null;
const $66259802600c3102$var$scrollContainerCss = null;
// v2: outer border on the visible frame (the scroll container), so it stays put while
// the table scrolls on mobile
const $66259802600c3102$var$scrollContainerV2Css = null;
const $66259802600c3102$var$controlsWrapperCss = null;
const $66259802600c3102$var$tableControlButtonCss = null;
const $66259802600c3102$var$getColumnCount = (table)=>{
    const rows = Array.from(table.querySelectorAll('tr'));
    const getTableCells = (row)=>Array.from(row.children).filter((child)=>child.matches('th, td'));
    const rowWithColumns = rows.find((row)=>getTableCells(row).length > 1);
    if (!rowWithColumns) return 0;
    return getTableCells(rowWithColumns).length;
};
const $66259802600c3102$var$getLogicalMaxScrollLeft = (dataColumnCount)=>Math.max(dataColumnCount - 1, 0) * $66259802600c3102$var$MOBILE_COLUMN_WIDTH;
const $66259802600c3102$var$getScrollState = (scrollContainer, dataColumnCount)=>{
    const measuredMaxScrollLeft = scrollContainer.scrollWidth === 0 && scrollContainer.clientWidth === 0 ? $66259802600c3102$var$getLogicalMaxScrollLeft(dataColumnCount) : Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
    const scrollLeft = Math.min(Math.max(scrollContainer.scrollLeft, 0), measuredMaxScrollLeft);
    return {
        scrollLeft: scrollLeft,
        maxScrollLeft: measuredMaxScrollLeft
    };
};
const $66259802600c3102$var$getNextColumnScrollLeft = (scrollLeft, maxScrollLeft)=>Math.min((Math.floor((scrollLeft + $66259802600c3102$var$SCROLL_EDGE_TOLERANCE) / $66259802600c3102$var$MOBILE_COLUMN_WIDTH) + 1) * $66259802600c3102$var$MOBILE_COLUMN_WIDTH, maxScrollLeft);
const $66259802600c3102$var$getPreviousColumnScrollLeft = (scrollLeft)=>Math.max(Math.ceil((scrollLeft - $66259802600c3102$var$SCROLL_EDGE_TOLERANCE) / $66259802600c3102$var$MOBILE_COLUMN_WIDTH) * $66259802600c3102$var$MOBILE_COLUMN_WIDTH - $66259802600c3102$var$MOBILE_COLUMN_WIDTH, 0);
const $66259802600c3102$var$GenericTableControls = ({ isPreviousDisabled: isPreviousDisabled, isNextDisabled: isNextDisabled, onPrevious: onPrevious, onNext: onNext })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const fireTableControlClicked = (0, $1oC0p.useCallback)((direction)=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'tableControlButton',
            eventType: 'ui',
            eventComponent: 'button',
            source: 'generic-table',
            attributes: {
                direction: direction
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handlePrevious = (0, $1oC0p.useCallback)(()=>{
        fireTableControlClicked('previous');
        onPrevious();
    }, [
        fireTableControlClicked,
        onPrevious
    ]);
    const handleNext = (0, $1oC0p.useCallback)(()=>{
        fireTableControlClicked('next');
        onNext();
    }, [
        fireTableControlClicked,
        onNext
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "aria-label": intl.formatMessage({
            id: 'generic-table.navigation',
            defaultMessage: 'Table navigation'
        }),
        "data-testid": "generic-table-controls",
        role: "group",
        className: (0, $2jatx.default)([
            "_1e0cglyw _suga1txw _8164u2gc _nsspesu3 _476dutpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                "aria-label": intl.formatMessage({
                    id: 'generic-table.previous-column',
                    defaultMessage: 'Previous column'
                }),
                disabled: isPreviousDisabled,
                onClick: handlePrevious,
                type: "button",
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _bfhk1afi _19itgo0a _2rko1ssb _syaz1pfd _80omtlke _1e0c116y _4t3i1tcg _1bah1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1tcg _dmizg7ng _bb32qjb0 _27uws3kk _vbqbs3kk _j5dh73ad _18o27g83 _16u2yh40"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                    label: "",
                    spacing: "none"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                "aria-label": intl.formatMessage({
                    id: 'generic-table.next-column',
                    defaultMessage: 'Next column'
                }),
                disabled: isNextDisabled,
                onClick: handleNext,
                type: "button",
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _bfhk1afi _19itgo0a _2rko1ssb _syaz1pfd _80omtlke _1e0c116y _4t3i1tcg _1bah1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1tcg _dmizg7ng _bb32qjb0 _27uws3kk _vbqbs3kk _j5dh73ad _18o27g83 _16u2yh40"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                    label: "",
                    spacing: "none"
                })
            })
        ]
    });
};
const $66259802600c3102$export$a8994f76dea4d338 = ({ variant: variant = 'v1', ...props })=>{
    const isV2 = variant === 'v2';
    const variantSettings = (0, $1oC0p.useMemo)(()=>({
            isV2: isV2
        }), [
        isV2
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Ztx3.GenericTableVariantContext).Provider, {
        value: variantSettings,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($66259802600c3102$var$GenericTableContent, {
            ...props
        })
    });
};
const $66259802600c3102$var$GenericTableContent = ({ children: children, style: style, ...props })=>{
    const { isV2: isV2 } = (0, $6Ztx3.useGenericTableVariant)();
    const tableRef = (0, $1oC0p.useRef)(null);
    const scrollContainerRef = (0, $1oC0p.useRef)(null);
    const [scrollState, setScrollState] = (0, $1oC0p.useState)({
        scrollLeft: 0,
        maxScrollLeft: 0
    });
    const [dataColumnCount, setDataColumnCount] = (0, $1oC0p.useState)(0);
    const [visibleWidth, setVisibleWidth] = (0, $1oC0p.useState)('100%');
    const syncScrollState = (0, $1oC0p.useCallback)((nextDataColumnCount = dataColumnCount)=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        setScrollState($66259802600c3102$var$getScrollState(scrollContainer, nextDataColumnCount));
        setVisibleWidth(scrollContainer.clientWidth > 0 ? `${scrollContainer.clientWidth}px` : '100%');
    }, [
        dataColumnCount
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const table = tableRef.current;
        if (!table) return;
        const columnCount = $66259802600c3102$var$getColumnCount(table);
        const nextDataColumnCount = Math.max(columnCount - 1, 0);
        setDataColumnCount(nextDataColumnCount);
        syncScrollState(nextDataColumnCount);
    }, [
        children,
        syncScrollState
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        syncScrollState();
        const handleResize = ()=>{
            syncScrollState();
        };
        window.addEventListener('resize', handleResize);
        if (typeof ResizeObserver === 'undefined') return ()=>{
            window.removeEventListener('resize', handleResize);
        };
        const resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(scrollContainer);
        if (tableRef.current) resizeObserver.observe(tableRef.current);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            resizeObserver.disconnect();
        };
    }, [
        syncScrollState
    ]);
    const scrollToPosition = (0, $1oC0p.useCallback)((nextScrollLeft)=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const { maxScrollLeft: maxScrollLeft } = $66259802600c3102$var$getScrollState(scrollContainer, dataColumnCount);
        const scrollLeft = Math.min(Math.max(nextScrollLeft, 0), maxScrollLeft);
        scrollContainer.scrollTo({
            top: 0,
            left: scrollLeft,
            behavior: 'smooth'
        });
    }, [
        dataColumnCount
    ]);
    const handlePrevious = (0, $1oC0p.useCallback)(()=>{
        scrollToPosition($66259802600c3102$var$getPreviousColumnScrollLeft(scrollState.scrollLeft));
    }, [
        scrollState.scrollLeft,
        scrollToPosition
    ]);
    const handleNext = (0, $1oC0p.useCallback)(()=>{
        scrollToPosition($66259802600c3102$var$getNextColumnScrollLeft(scrollState.scrollLeft, scrollState.maxScrollLeft));
    }, [
        scrollState.maxScrollLeft,
        scrollState.scrollLeft,
        scrollToPosition
    ]);
    const handleScroll = (0, $1oC0p.useCallback)(()=>{
        syncScrollState();
    }, [
        syncScrollState
    ]);
    const isPreviousDisabled = scrollState.scrollLeft <= $66259802600c3102$var$SCROLL_EDGE_TOLERANCE;
    const isNextDisabled = scrollState.maxScrollLeft <= $66259802600c3102$var$SCROLL_EDGE_TOLERANCE || scrollState.scrollLeft >= scrollState.maxScrollLeft - $66259802600c3102$var$SCROLL_EDGE_TOLERANCE;
    const shouldShowControls = dataColumnCount > 1 && (!isPreviousDisabled || !isNextDisabled);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "generic-table-scroll-container",
                onScroll: handleScroll,
                ref: scrollContainerRef,
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1o831wug _98bk15vq _7r1g1f51 _7lhbq5uf _1jk9glyw",
                    isV2 && "_189et94y _1dqonqa1 _1h6d6u2e"
                ]),
                style: {
                    "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("table", {
                    ...props,
                    ref: tableRef,
                    style: {
                        '--generic-table-mobile-column-width': $66259802600c3102$var$MOBILE_COLUMN_WIDTH_CSS,
                        '--generic-table-visible-width': visibleWidth,
                        ...style
                    },
                    className: (0, $2jatx.default)([
                        "_1kqm1n9t _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _yq5hcfaq _btyzidpf _1e0c5mfb _12b61osq _1rfm1ris"
                    ]),
                    children: children
                })
            }),
            shouldShowControls && /*#__PURE__*/ (0, $7VQPk.jsx)($66259802600c3102$var$GenericTableControls, {
                isPreviousDisabled: isPreviousDisabled,
                isNextDisabled: isNextDisabled,
                onPrevious: handlePrevious,
                onNext: handleNext
            })
        ]
    });
};

});
parcelRegister("6Ztx3", function(module, exports) {
$parcel$export(module.exports, "GenericTableVariantContext", function () { return $7d093f4a215e8bc2$export$5f45d42aa8e02fb3; });
$parcel$export(module.exports, "useGenericTableVariant", function () { return $7d093f4a215e8bc2$export$46e8e68b7a8254e0; });

var $1oC0p = parcelRequire("1oC0p");
const $7d093f4a215e8bc2$export$5f45d42aa8e02fb3 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    isV2: false
});
const $7d093f4a215e8bc2$export$46e8e68b7a8254e0 = ()=>(0, $1oC0p.useContext)($7d093f4a215e8bc2$export$5f45d42aa8e02fb3);

});


parcelRegister("a25eA", function(module, exports) {
$parcel$export(module.exports, "GenericTableColumnHeader", function () { return $c7ce558aa0ab6ca5$export$f3bad3278cde33da; });
/* generic-table-column-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $6Ztx3 = parcelRequire("6Ztx3");
const $c7ce558aa0ab6ca5$var$headCellCss = null;
const $c7ce558aa0ab6ca5$var$V2_DIVIDER = `1px solid ${(0, $kbpa7.wacToken)('color.neutral.light300')}`;
const $c7ce558aa0ab6ca5$var$headCellV2Css = null;
// v2: only the row title column's header stays in place on mobile; any other first column
// header scrolls with the others, like the cells below it
const $c7ce558aa0ab6ca5$var$firstColumnNotStickyV2Css = null;
const $c7ce558aa0ab6ca5$export$f3bad3278cde33da = ({ colWidth: colWidth, isRowHeaderColumn: isRowHeaderColumn, style: style, ...props })=>{
    const { width: width, ...restStyle } = style ?? {};
    const { isV2: isV2 } = (0, $6Ztx3.useGenericTableVariant)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...props,
        scope: "col",
        className: (0, $2jatx.default)([
            "_k48p1fw0 _y3gn1e5h _syaz1pfd _bfhk1afi _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zkze7 _10msglyw _1bsb5vxt _u1ajkze7 _1bz3idpf _1rkbz113 _12b6z113 _1rfmz113 _1xouidpf _5yuhidpf _u1n41if8 _rjzg11wp _6pi5s3kk _1hivb3bt _zo1cidpf _1sg9idpf _f9opglyw _4fgostnw _1kijt94y",
            isV2 && "_bfhk1bjw _t51z1ilk _u1aj1ilk",
            isV2 && !isRowHeaderColumn && "_1xou1ilk _u1n4pfqs _rjzg1wug _1hivglyw"
        ]),
        style: {
            ...{
                '--generic-table-column-header-width': colWidth ?? width ?? 'var(--generic-table-col-width)',
                ...restStyle
            },
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
            "--_19fcj2c": (0, $6ZVlx.default)($c7ce558aa0ab6ca5$var$V2_DIVIDER)
        }
    });
};

});

parcelRegister("hGOQQ", function(module, exports) {
$parcel$export(module.exports, "GenericTableCustomCell", function () { return $4e2fb24a36bde757$export$4d53be7d919b2a4b; });
/* generic-table-custom-cell.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $6Ztx3 = parcelRequire("6Ztx3");
// Only layout/border CSS — content styling is the responsibility of slot children
const $4e2fb24a36bde757$var$cellCss = null;
const $4e2fb24a36bde757$var$V2_DIVIDER = `1px solid ${(0, $kbpa7.wacToken)('color.neutral.light300')}`;
const $4e2fb24a36bde757$var$dataCellV2Css = null;
const $4e2fb24a36bde757$var$rowHeaderV2Css = null;
const $4e2fb24a36bde757$var$rowHeaderCss = null;
const $4e2fb24a36bde757$export$4d53be7d919b2a4b = ({ isRowHeader: isRowHeader, ...props })=>{
    const { isV2: isV2 } = (0, $6Ztx3.useGenericTableVariant)();
    return isRowHeader ? /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...props,
        scope: "row",
        className: (0, $2jatx.default)([
            "_bfhk1kw7 _1e0cdav6 _s7n4jp4b _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zkze7 _10msglyw _1bz3idpf _1rkbz113 _12b6z113 _1rfmz113 _1xouidpf _5yuhidpf _u1n41if8 _rjzgcs5v _6pi5s3kk _1hivb3bt _zo1cidpf _1sg9idpf _f9opglyw _4fgostnw _1kijt94y",
            isV2 && "_t51z1ilk _10ms1ilk",
            "_k48p1fw0 _y3gn1e5h"
        ]),
        style: {
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_19fcj2c": (0, $6ZVlx.default)($4e2fb24a36bde757$var$V2_DIVIDER)
        }
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
        ...props,
        className: (0, $2jatx.default)([
            "_bfhk1kw7 _1e0cdav6 _s7n4jp4b _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zkze7 _10msglyw _1bz3idpf _1rkbz113 _12b6z113 _1rfmz113 _1xouidpf _5yuhidpf _u1n41if8 _rjzgcs5v _6pi5s3kk _1hivb3bt _zo1cidpf _1sg9idpf _f9opglyw _4fgostnw _1kijt94y",
            isV2 && "_t51z1ilk _1xou1ilk _u1n4pfqs _rjzg1wug _1hivglyw"
        ]),
        style: {
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_19fcj2c": (0, $6ZVlx.default)($4e2fb24a36bde757$var$V2_DIVIDER)
        }
    });
};

});

parcelRegister("at2aH", function(module, exports) {
$parcel$export(module.exports, "GenericTableThead", function () { return $c82062036c1e2116$export$28f380d4579500ee; });
$parcel$export(module.exports, "GenericTableHeadRow", function () { return $c82062036c1e2116$export$92a04607b540963b; });
$parcel$export(module.exports, "GenericTableSectionHeaderRow", function () { return $c82062036c1e2116$export$83687016ee6fe30; });
$parcel$export(module.exports, "GenericTableSectionHeaderCell", function () { return $c82062036c1e2116$export$fb33888b304cf2b1; });
/* generic-table-header-row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");

var $6Ztx3 = parcelRequire("6Ztx3");
// <thead> wrapper — bottom border only, matching pricing table
const $c82062036c1e2116$var$theadCss = null;
const $c82062036c1e2116$var$theadV2Css = null;
const $c82062036c1e2116$export$28f380d4579500ee = ({ colWidth: colWidth, style: style, ...props })=>{
    const { isV2: isV2 } = (0, $6Ztx3.useGenericTableVariant)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
        ...props,
        className: (0, $2jatx.default)([
            "_179rh1cn _11q71afi",
            isV2 && "_11q71bjw"
        ]),
        style: {
            ...{
                '--generic-table-col-width': colWidth,
                ...style
            },
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
        }
    });
};
// Column header <tr>
const $c82062036c1e2116$var$headRowCss = null;
const $c82062036c1e2116$export$92a04607b540963b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        ...props
    });
};
// Section header <tr> — matches pricing table SectionHeader atom
const $c82062036c1e2116$var$sectionHeaderRowCss = null;
const $c82062036c1e2116$export$83687016ee6fe30 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        ...props,
        className: (0, $2jatx.default)([
            "_syaz1pfd _bfhkg7ng _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        }
    });
};
const $c82062036c1e2116$var$sectionHeaderCellCss = null;
const $c82062036c1e2116$var$sectionHeaderTextCss = null;
const $c82062036c1e2116$export$fb33888b304cf2b1 = ({ colSpan: colSpan = 999, children: children, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...props,
        colSpan: colSpan,
        scope: "rowgroup",
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1pfd _sugadav6 _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zkze7 _10msglyw"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_syaz1pfd _1bsb1osq _k48p8n31 _4t3i1wug _1e0c1ule _1i4q1hna _1eg6dlk8 _13zm1if8 _1rfm1fs3"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            },
            children: children
        })
    });
};

});

parcelRegister("cZmh0", function(module, exports) {
$parcel$export(module.exports, "GenericTableRow", function () { return $31872748d3812f71$export$ecda46818fa8c05d; });
/* generic-table-row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $6Ztx3 = parcelRequire("6Ztx3");
const $31872748d3812f71$var$rowCss = null;
const $31872748d3812f71$var$rowV2Css = null;
const $31872748d3812f71$export$ecda46818fa8c05d = (props)=>{
    const { isV2: isV2 } = (0, $6Ztx3.useGenericTableVariant)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        ...props,
        className: (0, $2jatx.default)([
            "_bfhk1afi _v56411zw _irr3g7ng",
            isV2 && "_4t3i1ex1 _v564glyw _179rn5xp _irr31afi _qw09glyw"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
        }
    });
};

});



parcelRegister("eWth0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("aghrj")).default; });

var $aghrj = parcelRequire("aghrj");

});
parcelRegister("aghrj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4cbd318bfd44317a$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $9Kroa = parcelRequire("9Kroa");
const $4cbd318bfd44317a$export$d9468344d3651243 = (body)=>{
    if (!body) return {};
    const { story: story, richText: richText, image: image, embeddedVideoLink: embeddedVideoLink, imageCaption: imageCaption } = body;
    const formattedBody = {
        storyText: story?.storyText ?? richText ?? undefined,
        bodyAsset: $4cbd318bfd44317a$var$formatBodyAsset(story?.bodyAsset ?? image),
        embeddedVideoLink: story?.embeddedVideoLink ?? embeddedVideoLink ?? undefined,
        bodyAssetCaption: story?.bodyAssetCaption ?? imageCaption ?? undefined,
        quote: $4cbd318bfd44317a$var$formatQuote(story?.quote)
    };
    // Remove undefined properties
    return Object.fromEntries(Object.entries(formattedBody).filter(([_, value])=>value !== undefined));
};
// eslint-disable-next-line complexity
const $4cbd318bfd44317a$var$formatBodyAsset = (bodyAsset)=>{
    if (!bodyAsset?.fields) return undefined;
    const { fields: fields } = bodyAsset;
    return {
        name: fields.title,
        size: fields.file?.details?.size,
        fileName: fields.file?.fileName ?? null,
        height: fields.file?.details?.image?.height ?? null,
        width: fields.file?.details?.image?.width ?? null,
        url: fields.file?.url,
        description: fields.description ?? null,
        contentType: fields.file?.contentType ?? null
    };
};
const $4cbd318bfd44317a$var$formatQuote = (quote)=>{
    if (!quote?.fields) return undefined;
    const { fields: fields } = quote;
    return {
        quote: fields.advocateQuote,
        authorName: fields.advocateName,
        authorDetails: fields.advocateJobTitle
    };
};
/**
 * @deprecated - Please use UniformBodyContent at /uniform/components/body-content instead
 */ const $4cbd318bfd44317a$var$UniformBodyContent = (props)=>{
    const bodyComponent = (0, $1oC0p.useMemo)(()=>$4cbd318bfd44317a$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Kroa.BodyContent), {
        ...props,
        story: bodyComponent
    });
};
var $4cbd318bfd44317a$export$2e2bcd8739ae039 = $4cbd318bfd44317a$var$UniformBodyContent;

});
parcelRegister("9Kroa", function(module, exports) {
$parcel$export(module.exports, "BodyContent", function () { return $484d9f987682576e$export$36cf6d64005c1ddf; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gA8LO = parcelRequire("gA8LO");

var $ftgEA = parcelRequire("ftgEA");

var $6iX8D = parcelRequire("6iX8D");

var $ksvEJ = parcelRequire("ksvEJ");

var $kbpa7 = parcelRequire("kbpa7");

var $lTkkF = parcelRequire("lTkkF");
function $484d9f987682576e$var$getRichText(richText) {
    if (typeof richText === 'string') return richText;
    return (0, $gA8LO.documentToHtmlString)(richText);
}
const $484d9f987682576e$export$36cf6d64005c1ddf = ({ story: story })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "customer-story-article-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb"
        ]),
        children: [
            story?.storyText && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_rrz6idpf _1cobidpf _7exw1ejb _1o6v1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                    text: $484d9f987682576e$var$getRichText(story.storyText)
                })
            }),
            story?.quote && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "10",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                    quote: story.quote.quote,
                    authorName: story.quote.authorName,
                    authorDetails: story.quote.authorDetails,
                    alignment: "start",
                    variant: story.quote.heroQuote ? 'cutout' : 'basic'
                })
            }),
            story?.bodyAsset && story?.embeddedVideoLink && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.EmbeddedVideo), {
                embedUrl: story.embeddedVideoLink,
                thumbnail: {
                    src: story.bodyAsset.url,
                    alt: story.bodyAsset.description ?? ''
                },
                title: "",
                dataEventProps: {
                    'data-product-key': 'uniform',
                    'data-event': 'clicked',
                    'data-event-component': 'embeddedVideo',
                    'data-event-container': 'bodyContentInline'
                }
            }),
            story?.bodyAsset && !story?.embeddedVideoLink && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                        src: story.bodyAsset.url ?? '',
                        alt: story.bodyAsset.description ?? '',
                        contentType: story.bodyAsset.contentType,
                        baseWidth: 856,
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1bsb1slu _195g1wug"
                        ]),
                        style: {
                            "--_1jjdp8t": (0, $6ZVlx.default)(story.bodyAsset.width ? `${story.bodyAsset.width}px` : '100%')
                        }
                    }),
                    story.bodyAssetCaption && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "fine-print"
                        ]),
                        children: story.bodyAssetCaption
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("ezRYc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24f6dbd9d7b9a161$export$2e2bcd8739ae039; });
// The `breadcrumbLink` component holds `{ name, path }` data that is read by
// the parent `UniformBreadcrumbs` wrapper. It never renders on its own — the
// parent walks its `links` slot and builds the crumb trail.
const $24f6dbd9d7b9a161$var$UniformBreadcrumbLink = ()=>null;
var $24f6dbd9d7b9a161$export$2e2bcd8739ae039 = $24f6dbd9d7b9a161$var$UniformBreadcrumbLink;

});

parcelRegister("dm54q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $787c5e7f378122a1$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $6QsFO = parcelRequire("6QsFO");
const $787c5e7f378122a1$var$UniformBreadcrumbs = ({ component: component })=>{
    const slotItems = component.slots?.['links'] ?? [];
    if (slotItems.length === 0) return null;
    const links = slotItems.filter((child)=>child.type === 'breadcrumbLink').map((child)=>({
            name: child.parameters?.['name']?.value ?? '',
            path: child.parameters?.['path']?.value ?? ''
        })).filter((link)=>link.name && link.path);
    if (links.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6QsFO.Breadcrumbs), {
        links: links,
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event-component': 'linkButton',
            'data-event-container': 'breadcrumbs',
            'data-event': 'clicked'
        }
    });
};
var $787c5e7f378122a1$export$2e2bcd8739ae039 = $787c5e7f378122a1$var$UniformBreadcrumbs;

});
parcelRegister("6QsFO", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", function () { return $027844c990546753$export$2dc68d50d56fbbd; });
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
const $027844c990546753$var$breadcrumbLink = null;
const $027844c990546753$var$breadcrumbsUnorderedList = null;
const $027844c990546753$var$breadcrumbsFirstItem = null;
const $027844c990546753$var$breadcrumbsInnerListItem = null;
const $027844c990546753$var$breadcrumbsLastItem = null;
const $027844c990546753$var$Breadcrumb = ({ link: link, name: name, dataEventProps: dataEventProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'breadcrumb',
            source: 'breadcrumbs',
            attributes: {
                label: name
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $jQ0cd.useLocalizedHref)(link),
        onClick: handleClick,
        ...dataEventProps,
        className: (0, $2jatx.default)([
            "_9oik1r31 _1bnx8stv _jf4cnqa1"
        ]),
        children: name
    });
};
const $027844c990546753$export$2dc68d50d56fbbd = ({ links: links, dataEventProps: dataEventProps })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
            ]),
            children: links.map((link, index)=>{
                if (index === 0) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        "_syazculw _1wybdlk8 _aetr1n76 _1ywu1o8l _14rninbi _j8d6idpf _1av21y44 _1doyidpf _pfzt1y44 _1s187vkz"
                    ]),
                    style: {
                        "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900')),
                        "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($027844c990546753$var$Breadcrumb, {
                        name: link.name,
                        link: link.path,
                        dataEventProps: dataEventProps
                    })
                }, index);
                else if (index + 1 === links.length) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        "_syazinbi _1wybdlk8 _1s187vkz"
                    ]),
                    style: {
                        "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($027844c990546753$var$Breadcrumb, {
                        name: link.name,
                        link: link.path,
                        dataEventProps: dataEventProps
                    })
                }, index);
                else return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        "_1e0cglyw _181n1nu9 _l8n0culw _a6uw1n76 _y0m51o8l _gyxeinbi _xbf0idpf _pdkb1y44 _160didpf _zvvd1y44"
                    ]),
                    style: {
                        "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900')),
                        "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($027844c990546753$var$Breadcrumb, {
                        name: link.name,
                        link: link.path,
                        dataEventProps: dataEventProps
                    })
                }, index);
            })
        })
    });
};

});


parcelRegister("6SooZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ab26b742cd3a699c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $kCjSr = parcelRequire("kCjSr");

var $lqyi6 = parcelRequire("lqyi6");
const $ab26b742cd3a699c$var$UniformButton = ({ text: text, href: href, size: size, variant: variant, colorAgainst: colorAgainst, mobileSize: mobileSize, tabletSize: tabletSize, desktopSize: desktopSize, xlDesktopSize: xlDesktopSize })=>{
    const resolvedHref = (0, $kCjSr.useJsmPlaygroundSignupHref)(href);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        href: resolvedHref,
        size: size,
        variant: variant,
        colorAgainst: colorAgainst,
        responsiveSize: mobileSize && tabletSize && desktopSize && xlDesktopSize && {
            mobile: mobileSize,
            tablet: tabletSize,
            desktop: desktopSize,
            xl_desktop: xlDesktopSize
        },
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event-component': 'linkButton',
            'data-event-container': 'button',
            'data-event': 'clicked'
        },
        children: text
    });
};
var $ab26b742cd3a699c$export$2e2bcd8739ae039 = $ab26b742cd3a699c$var$UniformButton;

});

parcelRegister("4h1q1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f39a289a0539a8be$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $2Uedv = parcelRequire("2Uedv");

var $lTkkF = parcelRequire("lTkkF");
const $f39a289a0539a8be$var$UniformCallToAction = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Uedv.BottomCallToAction), {
        title: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformRichText: {
                type: 'root',
                version: 1,
                children: props.title.root.children?.at(0)?.children
            }
        }),
        emphasisColor: props.emphasisColor,
        body: !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.body) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "body"
        }) : undefined,
        button: props.buttonLabel && props.buttonHref ? {
            href: props.buttonHref,
            label: props.buttonLabel,
            dataEventProps: {
                'data-product-key': 'uniform',
                'data-event-component': 'linkButton',
                'data-event-container': 'ctaSection',
                'data-event': 'clicked'
            }
        } : undefined,
        buttonVariant: props.buttonVariant,
        secondaryCta: props.secondaryCtaLabel && props.secondaryCtaHref ? {
            href: props.secondaryCtaHref,
            label: props.secondaryCtaLabel,
            dataEventProps: {
                'data-product-key': 'uniform',
                'data-event-component': 'linkButton',
                'data-event-container': 'ctaSection',
                'data-event': 'clicked'
            }
        } : undefined,
        secondaryCtaType: props.secondaryCtaType,
        backgroundImage: props.backgroundimage || undefined
    });
};
var $f39a289a0539a8be$export$2e2bcd8739ae039 = $f39a289a0539a8be$var$UniformCallToAction;

});
parcelRegister("2Uedv", function(module, exports) {
$parcel$export(module.exports, "BottomCallToAction", function () { return $c3e386a025d6cfc5$export$c9eb72e23dbe5cf6; });
/* bottom-call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $80kL5 = parcelRequire("80kL5");

var $1ka2O = parcelRequire("1ka2O");
const $c3e386a025d6cfc5$var$JSM_PRODUCT_TOUR_PATHNAME = '/software/jira/service-management';
const $c3e386a025d6cfc5$var$containerStyles = null;
const $c3e386a025d6cfc5$var$backgroundImageStyles = null;
const $c3e386a025d6cfc5$var$darkThemeContainerStyles = null;
const $c3e386a025d6cfc5$var$innerContainerStyles = null;
const $c3e386a025d6cfc5$var$buttonContainerStyles = null;
// On the JSM product tour (all locales), `primary_alt` uses Saffron 300 for its
// resting background; hover, focus and text colors come from the shared Button.
// `wacToken` resolves at runtime through an inline style, which Button does not
// forward. The token is therefore set on the native button container and reaches
// the button through an inherited custom property.
const $c3e386a025d6cfc5$var$jsmButtonContainerStyles = null;
const $c3e386a025d6cfc5$var$jsmButtonStyles = null;
// Rich-text `p` sits inside TypographyStyles, where refresh adds `p, .body-md` at lg+ with a
// direct font-size that overrides inheritance from `.h5`. Target paragraphs here so
// copy matches h5 (same tokens as typography-styles `.h5` ).
const $c3e386a025d6cfc5$var$bodyCopyStyles = null;
const $c3e386a025d6cfc5$export$c9eb72e23dbe5cf6 = ({ title: title, emphasisColor: emphasisColor, body: body, button: button, buttonVariant: buttonVariant = 'primary', secondaryCta: secondaryCta, secondaryCtaType: secondaryCtaType = 'link', backgroundImage: backgroundImage })=>{
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `bottom-cta-title-${uniqueId}`;
    const buttonId = `bottom-cta-button-${uniqueId}`;
    const secondaryCtaId = `bottom-cta-secondary-${uniqueId}`;
    const hasSecondaryCta = secondaryCta?.href && secondaryCta?.label;
    const { pathname: pathname } = (0, $1ka2O.useLocation)();
    const isJsmPrimaryAltButton = buttonVariant === 'primary_alt' && (0, $80kL5.delocalizePathname)(pathname) === $c3e386a025d6cfc5$var$JSM_PRODUCT_TOUR_PATHNAME;
    const { isDarkTheme: isDarkTheme, isDevTheme: isDevTheme } = (0, $eOIix.useTheme)();
    const emphasisStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1pfd _1rjcxncg _cg411afi _haj11afi _811z1afi _125x1afi _1afj1h6o _10so1h6o _14iu1h6o _31ku1h6o _1n46idpf _122gidpf _efi8idpf _clfdidpf _if5yidpf _1phwidpf _17o1idpf _11pqidpf _1gnpidpf _1bygidpf _1ql6idpf _q0a5idpf _7e5bidpf _o7a8idpf _5h4jidpf _c3k8idpf",
            backgroundImage && "_bfhkrf0c _18zr10yn _qjkj1ntv _1y1m1u8q _1lrw1f51 _ouxl1ssb _12vemgnk _1o60hxf2",
            isDarkTheme && "_bfhk1j28"
        ]),
        style: {
            ...backgroundImage ? {
                backgroundImage: `url("${backgroundImage}")`
            } : undefined,
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "8",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulputpp _16imxncg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        id: titleId,
                        className: (0, $2jatx.default)([
                            emphasisColor && "_r7o3eibj _cq6tn7od",
                            isDevTheme ? 'mono-font-family-heading' : 'h1-lg'
                        ]),
                        style: {
                            "--_1qfmyyb": (0, $6ZVlx.default)(emphasisColor)
                        },
                        children: title
                    }),
                    body ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1csa1vau _1adi1nn1 _q7gq1cby _zcqx1dsi _ecfq4jg8 _1cdq1k92 _p0o3imiu _15tu1dsi _cbmh1k8s _125x1afi _31ku1h6o _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _wphkpxbi",
                            "h5"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: body
                    }) : null,
                    (button || hasSecondaryCta) && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _1bah1h6o _4cvr1h6o _zulp1ejb _1q51xy5q",
                            isJsmPrimaryAltButton && "_j0301uv7"
                        ]),
                        style: {
                            "--_1g0po9p": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron300'))
                        },
                        children: [
                            button && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                id: buttonId,
                                href: button.href,
                                variant: buttonVariant,
                                responsiveSize: {
                                    mobile: 'small',
                                    tablet: 'small',
                                    desktop: 'large',
                                    xl_desktop: 'large'
                                },
                                ariaLabelledby: `${buttonId} ${titleId}`,
                                dataEventProps: button.dataEventProps,
                                className: (0, $2jatx.default)([
                                    isJsmPrimaryAltButton && "_bfhk1umk"
                                ]),
                                children: button.label
                            }),
                            hasSecondaryCta && (secondaryCtaType === 'button' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                id: secondaryCtaId,
                                href: secondaryCta.href,
                                variant: "secondary",
                                colorAgainst: "black",
                                responsiveSize: {
                                    mobile: 'small',
                                    tablet: 'small',
                                    desktop: 'large',
                                    xl_desktop: 'large'
                                },
                                ariaLabelledby: `${secondaryCtaId} ${titleId}`,
                                dataEventProps: secondaryCta.dataEventProps,
                                children: secondaryCta.label
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                id: secondaryCtaId,
                                text: secondaryCta.label,
                                href: secondaryCta.href,
                                type: "primary",
                                bgColor: isDarkTheme ? undefined : 'bgBlackBlue',
                                "aria-label": secondaryCta.label,
                                ariaLabelledby: `${secondaryCtaId} ${titleId}`,
                                "aria-labelledby": `${secondaryCtaId} ${titleId}`,
                                dataEventProps: secondaryCta.dataEventProps
                            }))
                        ]
                    })
                ]
            })
        })
    });
};

});


parcelRegister("k1kqo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $adfabc9115480b1c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $NtjLk = parcelRequire("NtjLk");

var $lTkkF = parcelRequire("lTkkF");

var $jQ0cd = parcelRequire("jQ0cd");
const $adfabc9115480b1c$var$getBodyText = (props)=>{
    if (!props.body && !props.richText) return undefined;
    if (props.richText) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
        text: props.richText
    });
    return props.body;
};
const $adfabc9115480b1c$var$UniformCard = (props)=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(props.linkUrl?.toString() ?? '');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), {
        align: props.alignment,
        orientation: props.orientation,
        columns: props.columns,
        background: props.background,
        eyebrow: props.eyebrow ? props.eyebrow : undefined,
        logo: props.logo,
        title: props.title ? props.title : undefined,
        titleAs: props.titleAs,
        body: $adfabc9115480b1c$var$getBodyText(props),
        callToAction: props.videoSrc && props.linkText ? {
            text: props.linkText,
            href: props.videoSrc,
            dataEventProps: {
                'data-product-key': 'uniform',
                'data-event-component': 'linkButton',
                'data-event-container': 'videoCard',
                'data-event': 'clicked',
                'data-label': props.dataLabel,
                'data-label-english': props.dataLabelEnglish
            }
        } : props.linkUrl && props.linkText ? {
            text: props.linkText,
            href: localizedHref,
            dataEventProps: {
                'data-product-key': 'uniform',
                'data-event-component': 'linkButton',
                'data-event-container': 'card',
                'data-event': 'clicked',
                'data-label': props.dataLabel,
                'data-label-english': props.dataLabelEnglish
            }
        } : undefined,
        image: props.imageUrl ? {
            src: props.imageUrl,
            alt: props.imageAlt ?? ''
        } : undefined,
        imageAspectRatio: props.imageAspectRatio,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                paddingIncluded: props.iconPaddingIncluded
            }
        } : undefined,
        icons: props.icons,
        spotIllustration: props.spotIllustrationUrl ? {
            src: props.spotIllustrationUrl,
            alt: props.spotIllustrationAlt,
            height: props.spotIllustrationHeight
        } : undefined,
        videoSrc: props.videoSrc
    });
};
var $adfabc9115480b1c$export$2e2bcd8739ae039 = $adfabc9115480b1c$var$UniformCard;

});

parcelRegister("iCnJ7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be844b412913529d$export$2e2bcd8739ae039; });
/* careers-gallery.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $f2QWG = parcelRequire("f2QWG");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $92PV0 = parcelRequire("92PV0");

var $jsxHL = parcelRequire("jsxHL");

var $7Ofoh = parcelRequire("7Ofoh");

var $H7SCD = parcelRequire("H7SCD");

var $96qiJ = parcelRequire("96qiJ");

var $e1RkQ = parcelRequire("e1RkQ");

var $e6X8o = parcelRequire("e6X8o");

var $jjDPo = parcelRequire("jjDPo");

var $igrWB = parcelRequire("igrWB");

var $aGyeX = parcelRequire("aGyeX");

var $6Ig8X = parcelRequire("6Ig8X");

var $kNuV4 = parcelRequire("kNuV4");
const $be844b412913529d$var$MISSING_VALUE_PLACEHOLDER = "\u2014";
/**
 * This gallery renders the `icimsJob` Contentful model and nothing else, so the
 * field paths are fixed in code rather than authored per composition. They were
 * `titlePath`, `locationPath`, `groupByPath` and `titleHrefPath` parameters. Read
 * the note in `configuration/components/careersGallery.json` before adding them
 * back.
 */ const $be844b412913529d$var$FIELD_PATH = {
    title: 'fields.title',
    locations: 'fields.locations',
    category: 'fields.category',
    id: 'fields.id'
};
/**
 * The live listing links every row to `/company/careers/details/<id>`, keyed on
 * the iCIMS job id. Verified on 219 of 219 rows, 2026-08-06.
 */ const $be844b412913529d$var$DETAILS_ROUTE_PREFIX = '/company/careers/details/';
const $be844b412913529d$var$messages = (0, $fnHPc.defineMessages)({
    emptyState: {
        id: 'careers-gallery.empty-state',
        defaultMessage: 'No results found.'
    },
    resultsCount: {
        id: 'careers-gallery.results-count',
        defaultMessage: '{count, plural, one {# result} other {# results}}'
    },
    positionColumn: {
        id: 'careers-gallery.position-column',
        defaultMessage: 'Position'
    },
    locationColumn: {
        id: 'careers-gallery.location-column',
        defaultMessage: 'Location'
    },
    searchPlaceholder: {
        id: 'careers-gallery.search-placeholder',
        defaultMessage: 'Search the results'
    }
});
const $be844b412913529d$var$UniformCareersGallery = ({ data: data, positionColumnLabel: rawPositionColumnLabel, locationColumnLabel: rawLocationColumnLabel, resultsCountLabel: rawResultsCountLabel, emptyStateLabel: rawEmptyStateLabel, searchPlaceholder: rawSearchPlaceholder, showSearchInput: rawShowSearchInput, urlSync: rawUrlSync, searchConfiguration: rawSearchConfiguration, filters: rawFilters, facetDataSources: rawFacetDataSources })=>{
    const intl = (0, $8e22h.default)();
    const showSearchInput = $be844b412913529d$var$resolveBooleanParameter(rawShowSearchInput, true);
    const urlSync = $be844b412913529d$var$resolveBooleanParameter(rawUrlSync, true);
    const positionColumnLabel = $be844b412913529d$var$unwrapText(rawPositionColumnLabel) ?? intl.formatMessage($be844b412913529d$var$messages.positionColumn);
    const locationColumnLabel = $be844b412913529d$var$unwrapText(rawLocationColumnLabel) ?? intl.formatMessage($be844b412913529d$var$messages.locationColumn);
    const emptyStateLabel = $be844b412913529d$var$unwrapText(rawEmptyStateLabel) ?? intl.formatMessage($be844b412913529d$var$messages.emptyState);
    const searchPlaceholder = $be844b412913529d$var$unwrapText(rawSearchPlaceholder) ?? intl.formatMessage($be844b412913529d$var$messages.searchPlaceholder);
    const dataItems = (0, $1oC0p.useMemo)(()=>$be844b412913529d$var$toDataItems(data), [
        data
    ]);
    const filterDefs = (0, $1oC0p.useMemo)(()=>{
        if (!rawFilters) return [];
        const flat = (0, $f2QWG.flattenValues)(rawFilters);
        return Array.isArray(flat) ? flat : [];
    }, [
        rawFilters
    ]);
    const optionsDataSources = (0, $1oC0p.useMemo)(()=>{
        if (!rawFacetDataSources) return {};
        const entries = $be844b412913529d$var$getUniformBlockEntries(rawFacetDataSources);
        return Object.fromEntries(entries.flatMap((entry)=>{
            const sourceId = entry.fields?.sourceId?.value;
            const sourceData = entry.fields?.data?.value;
            if (typeof sourceId !== 'string' || !Array.isArray(sourceData)) return [];
            return [
                [
                    sourceId,
                    sourceData
                ]
            ];
        }));
    }, [
        rawFacetDataSources
    ]);
    // Plan §5.6: `applySearch` returns the FULL item list when no search keys are
    // configured — silently, which is how GWP-12212 shipped a search box that
    // filtered nothing. Deriving a default from the bound field paths means
    // search works out of the box and stays tunable by config.
    const searchConfiguration = (0, $1oC0p.useMemo)(()=>{
        const authored = $be844b412913529d$var$unwrapParameterValue(rawSearchConfiguration);
        if (authored && Array.isArray(authored.keys) && authored.keys.length > 0) return authored;
        const keys = [
            {
                name: $be844b412913529d$var$FIELD_PATH.title,
                weight: 1
            },
            {
                name: $be844b412913529d$var$FIELD_PATH.locations,
                weight: 0.6
            }
        ];
        return {
            keys: keys,
            ignoreLocation: true
        };
    }, [
        rawSearchConfiguration
    ]);
    const { filterObject: filterObject, searchQuery: searchQuery, toggleOption: toggleOption, setSearchQuery: setSearchQuery, commitSearchQuery: commitSearchQuery } = (0, $igrWB.useCareersFilterState)({
        items: dataItems,
        filterDefs: filterDefs,
        urlSync: urlSync,
        optionsDataSources: optionsDataSources
    });
    const labelMaps = (0, $1oC0p.useMemo)(()=>(0, $H7SCD.buildLabelMaps)(dataItems, filterDefs, optionsDataSources), [
        dataItems,
        filterDefs,
        optionsDataSources
    ]);
    const optionCounts = (0, $1oC0p.useMemo)(()=>(0, $aGyeX.countFacetOptions)(dataItems, filterDefs, filterObject), [
        dataItems,
        filterDefs,
        filterObject
    ]);
    const facetGroups = (0, $1oC0p.useMemo)(()=>filterDefs.map((filterDef)=>{
            const subFilter = filterObject[filterDef.id] ?? {};
            const options = Object.keys(subFilter).map((value)=>({
                    value: value,
                    label: labelMaps[filterDef.id]?.[value] ?? value,
                    count: optionCounts[filterDef.id]?.[value] ?? 0,
                    checked: subFilter[value]?.committedActive ?? false
                }));
            // The reference renders both facet lists alphabetically. Auto-derived
            // options already arrive sorted, but statically authored `options` keep
            // their authored order, so sort here to cover both paths.
            options.sort((a, b)=>a.label.localeCompare(b.label));
            return {
                id: filterDef.id,
                label: filterDef.label ?? filterDef.id,
                options: options
            };
        }), [
        filterDefs,
        filterObject,
        labelMaps,
        optionCounts
    ]);
    const matchingItems = (0, $1oC0p.useMemo)(()=>{
        const filtered = (0, $H7SCD.applyFilters)(dataItems, filterDefs, filterObject);
        return (0, $H7SCD.applySearch)(filtered, searchQuery, searchConfiguration);
    }, [
        dataItems,
        filterDefs,
        filterObject,
        searchQuery,
        searchConfiguration
    ]);
    const jobGroups = (0, $1oC0p.useMemo)(()=>(0, $6Ig8X.groupItemsByFieldPath)(matchingItems, $be844b412913529d$var$FIELD_PATH.category).map((group)=>({
                key: group.key,
                label: group.label,
                rows: group.items.map((item, index)=>$be844b412913529d$export$3c03a99aba2cedef(item, `${group.key}-${index}`))
            })), [
        matchingItems
    ]);
    const resultsCountText = (0, $1oC0p.useMemo)(()=>$be844b412913529d$var$formatResultsCount(intl, $be844b412913529d$var$unwrapText(rawResultsCountLabel), matchingItems.length), [
        intl,
        rawResultsCountLabel,
        matchingItems.length
    ]);
    // `Tracking.autoTrackLinks/Buttons` bind a listener to every <a>/<button>
    // that exists at call time — they are not delegated. Job-row anchors mount
    // and remount on every filter, search and grouping change, so without this
    // re-arm they carry the right data-event-* props and still fire nothing.
    // Same pattern as filterable-gallery.tsx:403–407.
    (0, $1oC0p.useEffect)(()=>{
        (0, $92PV0.Tracking).autoTrackLinks(true);
        (0, $92PV0.Tracking).autoTrackButtons(true);
    }, [
        jobGroups
    ]);
    const fireFilterClickAnalytics = (0, $7Ofoh.useFireFilterClickAnalytics)();
    const handleToggleOption = (0, $1oC0p.useCallback)((facetId, optionValue)=>{
        fireFilterClickAnalytics(facetId);
        toggleOption(facetId, optionValue);
    }, [
        fireFilterClickAnalytics,
        toggleOption
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "uniform-careers-gallery",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1tcg _19wgzwfg"
                ]),
                children: [
                    facetGroups.length > 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e1RkQ.FacetPanel), {
                        groups: facetGroups,
                        onToggleOption: handleToggleOption
                    }) : null,
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jjDPo.ResultsCount), {
                        text: resultsCountText
                    }),
                    showSearchInput ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $96qiJ.CareersSearchField), {
                        value: searchQuery,
                        placeholder: searchPlaceholder,
                        onChange: setSearchQuery,
                        onSubmit: commitSearchQuery
                    }) : null,
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e6X8o.JobTable), {
                        groups: jobGroups,
                        positionColumnLabel: positionColumnLabel,
                        locationColumnLabel: locationColumnLabel,
                        emptyStateLabel: emptyStateLabel
                    })
                ]
            })
        })
    });
};
// Compiled CSS must stay local to the file that uses it — an imported `css(...)`
// object can render without its generated classes in gallery contexts (see the
// comment at filterable-card/src/filterable-card.tsx:113).
const $be844b412913529d$var$containerStyle = null;
function $be844b412913529d$export$3c03a99aba2cedef(item, key) {
    const title = $be844b412913529d$var$resolveText(item, $be844b412913529d$var$FIELD_PATH.title);
    const location = $be844b412913529d$var$resolveLocation(item, $be844b412913529d$var$FIELD_PATH.locations);
    const jobId = $be844b412913529d$var$resolveText(item, $be844b412913529d$var$FIELD_PATH.id);
    if (title === undefined) $be844b412913529d$var$warnOnce('title', `[careersGallery] "${$be844b412913529d$var$FIELD_PATH.title}" resolved to nothing.`);
    if (location === undefined) $be844b412913529d$var$warnOnce('location', `[careersGallery] "${$be844b412913529d$var$FIELD_PATH.locations}" resolved to nothing.`);
    if (jobId === undefined) $be844b412913529d$var$warnOnce('job-id', `[careersGallery] "${$be844b412913529d$var$FIELD_PATH.id}" resolved to nothing, so the row renders as plain text with no link.`);
    return {
        key: key,
        title: title ?? $be844b412913529d$var$MISSING_VALUE_PLACEHOLDER,
        location: location ?? $be844b412913529d$var$MISSING_VALUE_PLACEHOLDER,
        ...jobId !== undefined ? {
            href: `${$be844b412913529d$var$DETAILS_ROUTE_PREFIX}${jobId}`
        } : {}
    };
}
/**
 * This addresses the WHOLE `fields.locations` array, not one element,
 * because the summary depends on every element — see `formatLocationSummary`.
 *
 * A path that does not resolve at all returns `undefined`, so the caller warns
 * and shows the placeholder. A path that resolves to an EMPTY array returns the
 * empty string, which renders a blank cell. The live listing leaves the cell
 * blank for the 25 of 220 jobs that hold no location, and a placeholder there
 * would read as missing data.
 */ function $be844b412913529d$var$resolveLocation(item, path) {
    const resolved = (0, $H7SCD.resolveFieldPath)(item, path);
    if (resolved === undefined) return undefined;
    return (0, $kNuV4.formatLocationSummary)((0, $H7SCD.coerceToPrimitiveArray)(resolved));
}
function $be844b412913529d$var$resolveText(item, path) {
    return (0, $H7SCD.coerceToPrimitiveArray)((0, $H7SCD.resolveFieldPath)(item, path))[0];
}
/**
 * Uses the authored ICU label when it parses, else the localised default. An
 * unparseable authored label must not take the whole surface down.
 */ function $be844b412913529d$var$formatResultsCount(intl, authoredLabel, count) {
    if (authoredLabel) try {
        return intl.formatMessage({
            id: 'careers-gallery.results-count.authored',
            defaultMessage: authoredLabel
        }, {
            count: count
        });
    } catch  {
        $be844b412913529d$var$warnOnce(`results-count:${authoredLabel}`, `[careersGallery] resultsCountLabel "${authoredLabel}" is not a valid ICU message \u{2014} using the default.`);
    }
    return intl.formatMessage($be844b412913529d$var$messages.resultsCount, {
        count: count
    });
}
function $be844b412913529d$var$toDataItems(data) {
    const unwrapped = Array.isArray(data) ? data : $be844b412913529d$var$isRecord(data) && Array.isArray(data['value']) ? data['value'] : undefined;
    return unwrapped ?? [];
}
function $be844b412913529d$var$getUniformBlockEntries(data) {
    const entries = Array.isArray(data) ? data : $be844b412913529d$var$isRecord(data) && Array.isArray(data['value']) ? data['value'] : [];
    return entries.filter($be844b412913529d$var$isRecord);
}
function $be844b412913529d$var$resolveBooleanParameter(parameter, defaultValue) {
    if (typeof parameter === 'boolean') return parameter;
    if ($be844b412913529d$var$isRecord(parameter) && typeof parameter['value'] === 'boolean') return parameter['value'];
    return defaultValue;
}
function $be844b412913529d$var$unwrapText(parameter) {
    const value = $be844b412913529d$var$unwrapParameterValue(parameter);
    if (typeof value !== 'string') return undefined;
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
}
function $be844b412913529d$var$unwrapParameterValue(parameter) {
    if (parameter === undefined) return undefined;
    if (typeof parameter !== 'object' || parameter === null) return parameter;
    if (Array.isArray(parameter)) return parameter;
    return parameter.value;
}
function $be844b412913529d$var$isRecord(value) {
    return typeof value === 'object' && value !== null;
}
const $be844b412913529d$var$warnedKeys = new Set();
function $be844b412913529d$var$warnOnce(key, message) {
    if ($be844b412913529d$var$warnedKeys.has(key)) return;
    $be844b412913529d$var$warnedKeys.add(key);
    // eslint-disable-next-line no-console
    console.warn(message);
}
var $be844b412913529d$export$2e2bcd8739ae039 = $be844b412913529d$var$UniformCareersGallery;

});
parcelRegister("7Ofoh", function(module, exports) {
$parcel$export(module.exports, "useFireFilterClickAnalytics", function () { return $aa7e817244a8a5ef$export$95bea3ee3a9a8e3b; });

var $eY3N6 = parcelRequire("eY3N6");
const $aa7e817244a8a5ef$export$95bea3ee3a9a8e3b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return (filterId)=>{
        createAnalyticsEvent({
            origin: 'web',
            platform: 'web',
            product: 'marketing',
            source: 'none',
            userIdType: 'atlassianAccount',
            eventComponent: 'uniformFilterButton',
            event: 'clicked',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'component',
            attributes: {
                labelEnglish: filterId,
                url: location.href,
                page_path: location.pathname,
                eventComponent: 'uniformFilterButton'
            }
        }).fire();
    };
};

});

parcelRegister("H7SCD", function(module, exports) {
$parcel$export(module.exports, "normalizeUrlSlug", function () { return $ca127b9d3597e36e$export$884dc6c52e5ca88e; });
$parcel$export(module.exports, "coerceToPrimitiveArray", function () { return $ca127b9d3597e36e$export$7ee9ceeb236f8344; });
$parcel$export(module.exports, "resolveFieldPath", function () { return $ca127b9d3597e36e$export$329d3c8bdb587c75; });
$parcel$export(module.exports, "buildUniformFilterObject", function () { return $ca127b9d3597e36e$export$5ff5ecbcecad50cc; });
$parcel$export(module.exports, "buildLabelMaps", function () { return $ca127b9d3597e36e$export$a76d208414bdf304; });
$parcel$export(module.exports, "applyFilters", function () { return $ca127b9d3597e36e$export$47150c42ed89d097; });
$parcel$export(module.exports, "applySearch", function () { return $ca127b9d3597e36e$export$7fd91c352a58fa31; });
$parcel$export(module.exports, "searchWithFeaturedBoost", function () { return $ca127b9d3597e36e$export$57b3b77c1845381d; });
$parcel$export(module.exports, "applySort", function () { return $ca127b9d3597e36e$export$6dbc556d5545b9b1; });

var $djfBw = parcelRequire("djfBw");
const $ca127b9d3597e36e$var$UNRANKED_PRIORITY = Number.MAX_SAFE_INTEGER;
function $ca127b9d3597e36e$export$576ccdef7afa907a(items, featuredItemSlugs) {
    if (featuredItemSlugs.length === 0) return items;
    const priorityBySlug = new Map(featuredItemSlugs.map((slug, index)=>[
            slug,
            index
        ]));
    return [
        ...items
    ].sort((a, b)=>$ca127b9d3597e36e$var$getSlugPriority(a, priorityBySlug) - $ca127b9d3597e36e$var$getSlugPriority(b, priorityBySlug));
}
function $ca127b9d3597e36e$var$getSlugPriority(item, priorityBySlug) {
    const slug = $ca127b9d3597e36e$var$getItemFullUrlSlug(item);
    if (slug === undefined) return $ca127b9d3597e36e$var$UNRANKED_PRIORITY;
    return priorityBySlug.get(slug) ?? $ca127b9d3597e36e$var$UNRANKED_PRIORITY;
}
function $ca127b9d3597e36e$var$getItemFullUrlSlug(item) {
    if (!$ca127b9d3597e36e$var$isRecord(item)) return undefined;
    const fields = item['fields'];
    if (!$ca127b9d3597e36e$var$isRecord(fields)) return undefined;
    return $ca127b9d3597e36e$export$884dc6c52e5ca88e(fields['fullUrlSlug']);
}
function $ca127b9d3597e36e$export$884dc6c52e5ca88e(value) {
    if (typeof value !== 'string') return undefined;
    const trimmedValue = value.trim();
    if (trimmedValue.length === 0) return undefined;
    const pathname = $ca127b9d3597e36e$var$extractPathname(trimmedValue);
    return $ca127b9d3597e36e$var$stripTrailingSlash($ca127b9d3597e36e$var$stripQueryAndFragment(pathname));
}
function $ca127b9d3597e36e$var$extractPathname(value) {
    const valueWithProtocol = value.startsWith('//') ? `https:${value}` : value;
    try {
        return new URL(valueWithProtocol).pathname;
    } catch  {
        return value.startsWith('/') ? value : `/${value}`;
    }
}
function $ca127b9d3597e36e$var$stripQueryAndFragment(path) {
    return path.split(/[?#]/, 1)[0] ?? path;
}
function $ca127b9d3597e36e$var$stripTrailingSlash(path) {
    if (path === '/') return path;
    return path.endsWith('/') ? path.slice(0, -1) : path;
}
function $ca127b9d3597e36e$var$isRecord(value) {
    return typeof value === 'object' && value !== null;
}
const $ca127b9d3597e36e$var$DEFAULT_SEARCH_THRESHOLD = 0.4;
const $ca127b9d3597e36e$var$DEFAULT_FEATURED_BOOST = 0.15;
// ---------------------------------------------------------------------------
// Internal helpers
// ---------------------------------------------------------------------------
function $ca127b9d3597e36e$var$isPrimitive(v) {
    return v !== null && v !== undefined && typeof v !== 'object';
}
function $ca127b9d3597e36e$var$isUnresolvedLink(value) {
    if (typeof value !== 'object' || value === null) return false;
    const sys = value['sys'];
    return typeof sys === 'object' && sys !== null && sys['type'] === 'Link';
}
function $ca127b9d3597e36e$export$7ee9ceeb236f8344(value) {
    const values = Array.isArray(value) ? value : [
        value
    ];
    return values.filter($ca127b9d3597e36e$var$isPrimitive).map(String);
}
function $ca127b9d3597e36e$var$normaliseOptionItems(options) {
    if (!options) return [];
    if (Array.isArray(options)) return options;
    try {
        const parsed = JSON.parse(options);
        return Array.isArray(parsed) ? parsed : [];
    } catch  {
        return [];
    }
}
function $ca127b9d3597e36e$var$optionItemToPair(o) {
    return typeof o === 'string' ? {
        value: o,
        label: o
    } : {
        value: String(o.value),
        label: o.label ?? String(o.value)
    };
}
function $ca127b9d3597e36e$export$329d3c8bdb587c75(item, path) {
    const segments = path.split(/\[\]\.?/);
    function walk(value, segs) {
        if (segs.length === 0) return value;
        const [head, ...tail] = segs;
        if (head === undefined) return value;
        let current = value;
        for (const key of head.split('.').filter(Boolean)){
            if (current === null || current === undefined) return undefined;
            if (typeof current !== 'object') return undefined;
            // Block navigation into `fields` of an unresolved Link (the linked entry hasn't
            // been resolved so its `fields` is empty/missing). But allow navigating into `sys`
            // (e.g. sys.id) — that data is always present on Link stubs and is intentional.
            if ($ca127b9d3597e36e$var$isUnresolvedLink(current) && key !== 'sys') return undefined;
            current = current[key];
        }
        if (tail.length === 0) return current;
        if (!Array.isArray(current)) return undefined;
        const results = current.flatMap((el)=>{
            const resolved = walk(el, tail);
            return Array.isArray(resolved) ? resolved : [
                resolved
            ];
        });
        return results.filter((v)=>v !== undefined);
    }
    return walk(item, segments);
}
// ---------------------------------------------------------------------------
// Option parsing (explicit override)
// ---------------------------------------------------------------------------
/** Parses FilterDefinition.options into { value, label } pairs. */ function $ca127b9d3597e36e$var$parseOptionsWithLabels(options) {
    return $ca127b9d3597e36e$var$normaliseOptionItems(options).map($ca127b9d3597e36e$var$optionItemToPair);
}
function $ca127b9d3597e36e$export$cb7a25b3ee8582a2(items, fieldPath) {
    const seen = new Set();
    for (const item of items)for (const v of $ca127b9d3597e36e$export$7ee9ceeb236f8344($ca127b9d3597e36e$export$329d3c8bdb587c75(item, fieldPath)))seen.add(v);
    return Array.from(seen).sort((a, b)=>a.localeCompare(b));
}
/**
 * Like `deriveOptions`, but pairs each value with a display label from a
 * parallel `labelFieldPath`. Falls back to the value when the label doesn't resolve.
 */ function $ca127b9d3597e36e$var$deriveOptionsWithLabels(items, fieldPath, labelFieldPath) {
    // Map<label, Set<value>> — groups multiple IDs under the same display label.
    // This handles cases where distinct entries share a label (e.g. "Design" for
    // both Jira and Confluence categories). The combined IDs are pipe-separated so
    // matchValue can split and OR-match all of them.
    const labelToIds = new Map();
    for (const item of items){
        const valueArr = $ca127b9d3597e36e$export$7ee9ceeb236f8344($ca127b9d3597e36e$export$329d3c8bdb587c75(item, fieldPath));
        const labelArr = $ca127b9d3597e36e$export$7ee9ceeb236f8344($ca127b9d3597e36e$export$329d3c8bdb587c75(item, labelFieldPath));
        valueArr.forEach((valueStr, i)=>{
            const label = labelArr[i] ?? valueStr;
            if (!labelToIds.has(label)) labelToIds.set(label, new Set());
            labelToIds.get(label)?.add(valueStr);
        });
    }
    return Array.from(labelToIds.entries()).map(([label, ids])=>({
            value: Array.from(ids).join('|'),
            label: label
        })).sort((a, b)=>a.label.localeCompare(b.label));
}
// ---------------------------------------------------------------------------
// Shared resolution (used by both buildUniformFilterObject and buildLabelMaps)
// ---------------------------------------------------------------------------
function $ca127b9d3597e36e$var$resolveOptionPairs(items, filter, optionsDataSources) {
    // 1. Explicit static options — highest priority.
    if (filter.options) {
        const pairs = $ca127b9d3597e36e$var$parseOptionsWithLabels(filter.options);
        if (pairs.length > 0) return pairs;
    }
    // 2. Data-bound options from a gallery-level data resource — resolves the
    //    limitation of data bindings inside $block children not being resolved
    //    by Uniform before flattenValues runs. The gallery component receives
    //    the resolved array as a top-level prop and passes it here keyed by
    //    filter ID.
    const externalData = optionsDataSources?.[filter.id];
    if (Array.isArray(externalData) && externalData.length > 0) {
        if (!filter.optionsValuePath) // eslint-disable-next-line no-console
        console.warn(`[FilterableGallery] FacetDataSource found for filter "${filter.id}" but optionsValuePath is not set. ` + `Set Options Value Path on the FilterDefinition (e.g. "sys.id"). Falling back to auto-derive.`);
        else return $ca127b9d3597e36e$var$deriveOptionsWithLabels(externalData, filter.optionsValuePath, filter.optionsLabelPath ?? filter.optionsValuePath);
    }
    // 3. Auto-derive from gallery items — fallback.
    if (filter.labelFieldPath) return $ca127b9d3597e36e$var$deriveOptionsWithLabels(items, filter.fieldPath, filter.labelFieldPath);
    return $ca127b9d3597e36e$export$cb7a25b3ee8582a2(items, filter.fieldPath).map((v)=>({
            value: v,
            label: v
        }));
}
function $ca127b9d3597e36e$export$5ff5ecbcecad50cc(items, filters, optionsDataSources) {
    return Object.fromEntries(filters.map((filter)=>{
        const subFilter = Object.fromEntries($ca127b9d3597e36e$var$resolveOptionPairs(items, filter, optionsDataSources).map(({ value: value })=>[
                value,
                {
                    committedActive: false,
                    stagedActive: false
                }
            ]));
        return [
            filter.id,
            subFilter
        ];
    }));
}
function $ca127b9d3597e36e$export$a76d208414bdf304(items, filters, optionsDataSources) {
    return Object.fromEntries(filters.map((filter)=>[
            filter.id,
            Object.fromEntries($ca127b9d3597e36e$var$resolveOptionPairs(items, filter, optionsDataSources).map(({ value: value, label: label })=>[
                    value,
                    label
                ]))
        ]));
}
// ---------------------------------------------------------------------------
// Filter pipeline
// ---------------------------------------------------------------------------
function $ca127b9d3597e36e$var$matchValue(itemValue, matchType, selected) {
    const itemValues = $ca127b9d3597e36e$export$7ee9ceeb236f8344(itemValue);
    // Selected values may be pipe-separated IDs (e.g. "id1|id2") when multiple
    // entries share the same display label (see deriveOptionsWithLabels).
    // Each pipe-joined token represents OR semantics — the item matches if it
    // contains ANY of the IDs in the token.
    if (matchType === 'equals') // Item matches if it satisfies at least one selected token (OR across tokens,
    // OR across pipe-joined IDs within each token).
    return selected.some((token)=>token.split('|').some((id)=>itemValues.includes(id)));
    if (matchType === 'includes') // Item matches if it satisfies every selected token. Within each token,
    // pipe-joined IDs are OR'd (same label = different product variants).
    return selected.every((token)=>token.split('|').some((id)=>itemValues.includes(id)));
    if (matchType === 'contains') return selected.some((token)=>token.split('|').some((id)=>itemValues.some((v)=>v.toLowerCase().includes(id.toLowerCase()))));
    return false;
}
function $ca127b9d3597e36e$export$47150c42ed89d097(items, filters, filterState) {
    const activeFilters = filters.filter((filter)=>{
        const subFilter = filterState[filter.id];
        return subFilter && Object.values(subFilter).some((opt)=>opt.committedActive);
    });
    if (activeFilters.length === 0) return items;
    return items.filter((item)=>activeFilters.every((filter)=>{
            const subFilter = filterState[filter.id];
            if (!subFilter) return true;
            const selected = Object.entries(subFilter).filter(([, opt])=>opt.committedActive).map(([key])=>key);
            return $ca127b9d3597e36e$var$matchValue($ca127b9d3597e36e$export$329d3c8bdb587c75(item, filter.fieldPath), filter.matchType, selected);
        }));
}
function $ca127b9d3597e36e$export$7fd91c352a58fa31(items, query, searchConfiguration) {
    const trimmedQuery = query.trim();
    if (!trimmedQuery || !$ca127b9d3597e36e$var$hasSearchCriteria(searchConfiguration)) return items;
    return $ca127b9d3597e36e$var$scoredSearch(items, trimmedQuery, searchConfiguration).map((scored)=>scored.item);
}
function $ca127b9d3597e36e$export$57b3b77c1845381d(items, query, searchConfiguration, featuredItemSlugs) {
    const trimmedQuery = query.trim();
    if (!trimmedQuery || !$ca127b9d3597e36e$var$hasSearchCriteria(searchConfiguration)) return $ca127b9d3597e36e$export$576ccdef7afa907a(items, featuredItemSlugs);
    const scored = $ca127b9d3597e36e$var$scoredSearch(items, trimmedQuery, searchConfiguration);
    return $ca127b9d3597e36e$export$a1cf0b2ee0663507(scored, featuredItemSlugs, searchConfiguration.featuredBoost ?? $ca127b9d3597e36e$var$DEFAULT_FEATURED_BOOST);
}
function $ca127b9d3597e36e$export$a1cf0b2ee0663507(scored, featuredItemSlugs, boost) {
    if (featuredItemSlugs.length === 0) return scored.map((s)=>s.item);
    const priorityBySlug = new Map(featuredItemSlugs.map((slug, index)=>[
            slug,
            index
        ]));
    const ranked = scored.map((s, index)=>{
        const slugPriority = $ca127b9d3597e36e$var$getSlugPriority(s.item, priorityBySlug);
        const isFeatured = slugPriority !== $ca127b9d3597e36e$var$UNRANKED_PRIORITY;
        return {
            item: s.item,
            index: index,
            slugPriority: // stable tiebreak: keep relevance order for equal scores
            slugPriority,
            // featured order matches browse mode (prioritizeItemsBySlug)
            adjustedScore: s.score - (isFeatured ? boost : 0)
        };
    }).sort((a, b)=>a.adjustedScore - b.adjustedScore || a.slugPriority - b.slugPriority || a.index - b.index);
    return ranked.map((r)=>r.item);
}
function $ca127b9d3597e36e$var$hasSearchCriteria(searchConfiguration) {
    return searchConfiguration !== undefined && searchConfiguration.keys.length > 0;
}
/**
 * Weighted Fuse search. Each config key is indexed under a positional alias
 * (`key_0`, `key_1`, …) rather than its dot-path name. Fuse treats dot-paths as
 * nested lookups, and naively replacing dots with underscores would let two
 * distinct paths collide (e.g. `fields.name` and `fields_name`), silently
 * overwriting one key's data. Positional aliases sidestep both problems.
 */ function $ca127b9d3597e36e$var$scoredSearch(items, query, config) {
    const aliasFor = (index)=>`key_${index}`;
    const fuseKeys = config.keys.map((key, index)=>({
            name: aliasFor(index),
            weight: key.weight
        }));
    const indexedItems = items.map((item)=>{
        const indexed = {};
        config.keys.forEach((key, index)=>{
            indexed[aliasFor(index)] = $ca127b9d3597e36e$export$7ee9ceeb236f8344($ca127b9d3597e36e$export$329d3c8bdb587c75(item, key.name));
        });
        return {
            ...indexed,
            __fuseOriginalItem__: item
        };
    });
    return new (0, $djfBw.default)(indexedItems, {
        keys: fuseKeys,
        threshold: config.threshold ?? $ca127b9d3597e36e$var$DEFAULT_SEARCH_THRESHOLD,
        ignoreLocation: config.ignoreLocation ?? true,
        includeScore: true
    }).search(query).map((result)=>({
            item: result.item.__fuseOriginalItem__,
            score: result.score ?? 0
        }));
}
function $ca127b9d3597e36e$export$6dbc556d5545b9b1(items, sort) {
    if (!sort) return items;
    const direction = sort.direction === 'desc' ? -1 : 1;
    const valueType = sort.valueType ?? 'string';
    return [
        ...items
    ].sort((a, b)=>{
        const av = $ca127b9d3597e36e$var$coerceForSort($ca127b9d3597e36e$export$329d3c8bdb587c75(a, sort.fieldPath), valueType);
        const bv = $ca127b9d3597e36e$var$coerceForSort($ca127b9d3597e36e$export$329d3c8bdb587c75(b, sort.fieldPath), valueType);
        if (av === undefined && bv === undefined) return 0;
        if (av === undefined) return 1;
        if (bv === undefined) return -1;
        if (av < bv) return -1 * direction;
        if (av > bv) return 1 * direction;
        return 0;
    });
}
function $ca127b9d3597e36e$var$coerceForSort(value, valueType) {
    const first = Array.isArray(value) ? value[0] : value;
    if (first === null || first === undefined) return undefined;
    if (valueType === 'number') {
        const n = typeof first === 'number' ? first : Number(first);
        return Number.isNaN(n) ? undefined : n;
    }
    if (valueType === 'date') {
        const ms = new Date(String(first)).getTime();
        return Number.isNaN(ms) ? undefined : ms;
    }
    return String(first).toLowerCase();
}

});

parcelRegister("96qiJ", function(module, exports) {
$parcel$export(module.exports, "CareersSearchField", function () { return $0df2309fcaea9387$export$cbe166100ad0f4cf; });
/* careers-search-field.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $5ZCzy = parcelRequire("5ZCzy");

var $kbpa7 = parcelRequire("kbpa7");
const $0df2309fcaea9387$export$cbe166100ad0f4cf = ({ value: value, placeholder: placeholder, onChange: onChange, onSubmit: onSubmit })=>{
    const intl = (0, $8e22h.default)();
    const submitLabel = intl.formatMessage({
        id: 'careersGallery.searchField.submitLabel',
        defaultMessage: 'Search'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            onSubmit();
        },
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _zulpftgi _1bsb1osq _14b518a8"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                type: "text",
                value: value,
                placeholder: placeholder,
                "aria-label": placeholder,
                onChange: (event)=>onChange(event.target.value),
                className: (0, $2jatx.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1osq _4t3i1ou6 _ect4z4z1 _1wybgktf _vwz41ou6 _syazkhc1 _bfhk1j28 _19itglyw _179rj8n7 _2rkoidpf _6rthgktf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _1nuuyh40 _3nv2khc1"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "submit",
                "aria-label": submitLabel,
                "data-event": "clicked",
                "data-event-component": "button",
                "data-event-container": "careersGallerySearch",
                className: (0, $2jatx.default)([
                    "_1bsbdlk8 _4t3idlk8 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _bfhk1j28 _80omtlke _syaz5hrz _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _6rthgktf"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5ZCzy))), {
                    label: "",
                    size: "small"
                })
            })
        ]
    });
};
const $0df2309fcaea9387$var$formStyle = null;
const $0df2309fcaea9387$var$inputStyle = null;
const $0df2309fcaea9387$var$submitButtonStyle = null;

});

parcelRegister("e1RkQ", function(module, exports) {
$parcel$export(module.exports, "FacetPanel", function () { return $15b387332de8410e$export$1a869c244706495b; });
/* facet-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $15b387332de8410e$export$1a869c244706495b = ({ groups: groups, onToggleOption: onToggleOption })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1tcg _1lp7vrvc _19wgidpf"
        ]),
        children: groups.map((group)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("fieldset", {
                className: (0, $2jatx.default)([
                    "_19itidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug _1rhg18a8"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("legend", {
                        className: (0, $2jatx.default)([
                            "_ect41vau _1wyb7vkz _vwz4vd4q _k48pni7l _1dyzt94y _1p1dangw _syaz5hrz _6rth1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: group.label
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vt12am"
                        ]),
                        children: group.options.map((option)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                className: (0, $2jatx.default)([
                                    "_6rth1crf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _80omtlke _ect4z4z1 _1wyb7vkz _vwz41tcg _k48p1nn1 _syaz5hrz"
                                    ]),
                                    style: {
                                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            className: (0, $2jatx.default)([
                                                "_kqswh2mm _1bsb7vkz _4t3i7vkz _12l2ftgi _1o9zidpf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: option.checked,
                                                    onChange: ()=>onToggleOption(group.id, option.value),
                                                    className: (0, $2jatx.default)([
                                                        "_kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4idpf _80omtlke _r06hglyw _tbvj1qgu _174oyh40"
                                                    ]),
                                                    style: {
                                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    className: (0, $2jatx.default)([
                                                        "_kqswh2mm _1e0c1ule _1bsb7vkz _4t3i7vkz _19itj8n7 _2rkoidpf _bfhk1j28",
                                                        option.checked && "_bfhk5hrz _aetrb3bt _18postnw _g0nf1y44 _19nqt94y _z0ai14y2 _1qdgrdoj _eq431qsf _39yqvtp2 _clh3jyd4"
                                                    ]),
                                                    style: {
                                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                                    }
                                                })
                                            ]
                                        }),
                                        `${option.label} (${option.count})`
                                    ]
                                })
                            }, option.value))
                    })
                ]
            }, group.id))
    });
};
const $15b387332de8410e$var$panelStyle = null;
const $15b387332de8410e$var$fieldsetStyle = null;
const $15b387332de8410e$var$legendStyle = null;
const $15b387332de8410e$var$listStyle = null;
const $15b387332de8410e$var$listItemStyle = null;
const $15b387332de8410e$var$optionLabelStyle = null;
const $15b387332de8410e$var$checkboxWrapperStyle = null;
const $15b387332de8410e$var$checkboxInputStyle = null;
const $15b387332de8410e$var$checkboxBoxStyle = null;
const $15b387332de8410e$var$checkboxBoxCheckedStyle = null;

});

parcelRegister("e6X8o", function(module, exports) {
$parcel$export(module.exports, "JobTable", function () { return $196ec46330efb8fb$export$e8665416f40462b0; });
/* job-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $196ec46330efb8fb$export$e8665416f40462b0 = ({ groups: groups, positionColumnLabel: positionColumnLabel, locationColumnLabel: locationColumnLabel, emptyStateLabel: emptyStateLabel })=>{
    const hasResults = groups.some((group)=>group.rows.length > 0);
    if (!hasResults) return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_ect4z4z1 _1wyb7vkz _vwz41tcg _k48p1nn1 _syazkhc1"
        ]),
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
            "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
        },
        children: emptyStateLabel
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: groups.map((group)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    group.label !== undefined && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_ect41vau _1wyb1tcg _vwz4zwfg _k48pbfng _1dyznl7k _syazkhc1 _6rth1ou6"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                            "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                        },
                        children: group.label
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _yq5hcfaq _6rth66rk _1kqm1wug _52zn1n9t"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                            scope: "col",
                                            className: (0, $2jatx.default)([
                                                "_ect4z4z1 _1wyb7vkz _vwz47vkz _k48pni7l _1dyzt94y _1p1dangw _syaz5hrz _y3gn1e5h _ca0qgktf _u5f3idpf _n3tdgktf _19bvidpf _14b51ssb"
                                            ]),
                                            style: {
                                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                            },
                                            children: positionColumnLabel
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                            scope: "col",
                                            className: (0, $2jatx.default)([
                                                "_ect4z4z1 _1wyb7vkz _vwz47vkz _k48pni7l _1dyzt94y _1p1dangw _syaz5hrz _y3gn1e5h _ca0qgktf _u5f3idpf _n3tdgktf _19bvidpf _14b51ssb"
                                            ]),
                                            style: {
                                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                            },
                                            children: locationColumnLabel
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                                children: group.rows.map((row)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
                                        className: (0, $2jatx.default)([
                                            "_179r1ixx"
                                        ]),
                                        style: {
                                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                                                className: (0, $2jatx.default)([
                                                    "_ect4z4z1 _1wyb7vkz _vwz47vkz _k48p1nn1 _syazkhc1 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                                ]),
                                                style: {
                                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                                    "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                                                },
                                                children: row.href !== undefined ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                    href: row.href,
                                                    "data-event": "clicked",
                                                    "data-event-component": "link",
                                                    "data-event-container": "careersGallery",
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1ule _ect4z4z1 _1wyb7vkz _k48p1nn1 _syaz5hrz _4bfu1r31 _1hms8stv _ajmmnqa1 _ca0qgktf _u5f3gktf _n3tdgktf _19bvidpf"
                                                    ]),
                                                    style: {
                                                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                    },
                                                    children: row.title
                                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1ule _ca0qgktf _u5f3gktf _n3tdgktf _19bvidpf"
                                                    ]),
                                                    children: row.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                                                className: (0, $2jatx.default)([
                                                    "_ect4z4z1 _1wyb7vkz _vwz47vkz _k48p1nn1 _syazkhc1 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                                ]),
                                                style: {
                                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                                    "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                                                },
                                                children: row.location
                                            })
                                        ]
                                    }, row.key))
                            })
                        ]
                    })
                ]
            }, group.key))
    });
};
const $196ec46330efb8fb$var$groupHeadingStyle = null;
const $196ec46330efb8fb$var$tableStyle = null;
const $196ec46330efb8fb$var$thStyle = null;
const $196ec46330efb8fb$var$rowStyle = null;
const $196ec46330efb8fb$var$tdStyle = null;
const $196ec46330efb8fb$var$titleLinkStyle = null;
const $196ec46330efb8fb$var$titlePlainStyle = null;
const $196ec46330efb8fb$var$emptyStateStyle = null;

});

parcelRegister("jjDPo", function(module, exports) {
$parcel$export(module.exports, "ResultsCount", function () { return $475c2b53c8240ac1$export$71a5e95f441d7629; });
/* results-count.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $475c2b53c8240ac1$export$71a5e95f441d7629 = ({ text: text })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        role: "status",
        "aria-live": "polite",
        className: (0, $2jatx.default)([
            "_ect4z4z1 _1wyb1crf _vwz4f6fq _k48p1nn1 _1p1dangw _syazk0sw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
            "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700'))
        },
        children: text
    });
};
const $475c2b53c8240ac1$var$countStyle = null;

});

parcelRegister("igrWB", function(module, exports) {
$parcel$export(module.exports, "useCareersFilterState", function () { return $2649bd7d6ee9dd92$export$b7a1a2d4f0b045b5; });

var $1oC0p = parcelRequire("1oC0p");

var $H7SCD = parcelRequire("H7SCD");

var $iSHOM = parcelRequire("iSHOM");
function $2649bd7d6ee9dd92$export$b7a1a2d4f0b045b5({ items: items, filterDefs: filterDefs, urlSync: urlSync, optionsDataSources: optionsDataSources }) {
    const [filterObject, setFilterObject] = (0, $1oC0p.useState)(()=>(0, $H7SCD.buildUniformFilterObject)(items, filterDefs, optionsDataSources));
    const [searchQuery, setSearchQueryState] = (0, $1oC0p.useState)('');
    // Rebuild only when the item set actually changes shape, not on every
    // render — Uniform recreates `items`/`filterDefs` object identities
    // without the underlying data changing. Item COUNT is the change proxy
    // (same trade-off as use-filter-state.ts), merging forward existing
    // selections for options that still exist.
    const itemCount = items.length;
    (0, $1oC0p.useEffect)(()=>{
        const fresh = (0, $H7SCD.buildUniformFilterObject)(items, filterDefs, optionsDataSources);
        setFilterObject((prev)=>{
            const merged = Object.fromEntries(Object.entries(fresh).map(([filterId, subFilter])=>[
                    filterId,
                    Object.fromEntries(Object.entries(subFilter).map(([optionId, option])=>[
                            optionId,
                            prev[filterId]?.[optionId] ?? option
                        ]))
                ]));
            return $2649bd7d6ee9dd92$var$isFilterObjectEqual(merged, prev) ? prev : merged;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        itemCount,
        filterDefs,
        optionsDataSources
    ]);
    // Writing query params breaks the Uniform preview iframe — disable URL
    // sync there. Computed once via ref since preview state never changes
    // mid-session.
    const isUniformPreviewRef = (0, $1oC0p.useRef)(typeof window !== 'undefined' && window.location.pathname.includes('/uniform-preview'));
    const effectiveUrlSync = urlSync && !isUniformPreviewRef.current;
    // Hydrate from URL on mount + browser back/forward.
    (0, $1oC0p.useEffect)(()=>{
        if (!effectiveUrlSync || typeof window === 'undefined') return;
        const hydrate = ()=>{
            const urlState = (0, $iSHOM.readStateFromUrl)(window.location.search, filterDefs);
            setFilterObject((prev)=>(0, $iSHOM.filtersToUniformFilterObject)(urlState.filters, prev));
            setSearchQueryState(urlState.query);
        };
        hydrate();
        window.addEventListener('popstate', hydrate);
        return ()=>window.removeEventListener('popstate', hydrate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        effectiveUrlSync,
        filterDefs
    ]);
    const pushUrl = (nextFilterObject, nextQuery)=>{
        if (!effectiveUrlSync) return;
        (0, $iSHOM.writeStateToUrl)({
            filters: (0, $iSHOM.uniformFilterObjectToFlat)(nextFilterObject),
            query: nextQuery,
            sortId: undefined
        });
    };
    const toggleOption = (facetId, optionValue)=>{
        setFilterObject((prev)=>{
            const subFilter = prev[facetId] ?? {};
            const nextActive = !subFilter[optionValue]?.committedActive;
            const next = {
                ...prev,
                [facetId]: {
                    ...subFilter,
                    [optionValue]: {
                        committedActive: nextActive,
                        stagedActive: nextActive
                    }
                }
            };
            pushUrl(next, searchQuery);
            return next;
        });
    };
    const clearAllFilters = ()=>{
        setFilterObject((prev)=>{
            const cleared = Object.fromEntries(Object.entries(prev).map(([filterId, subFilter])=>[
                    filterId,
                    Object.fromEntries(Object.keys(subFilter ?? {}).map((optionId)=>[
                            optionId,
                            {
                                committedActive: false,
                                stagedActive: false
                            }
                        ]))
                ]));
            pushUrl(cleared, searchQuery);
            return cleared;
        });
    };
    const setSearchQuery = (query)=>setSearchQueryState(query);
    const commitSearchQuery = ()=>pushUrl(filterObject, searchQuery);
    return {
        filterObject: filterObject,
        searchQuery: searchQuery,
        toggleOption: toggleOption,
        setSearchQuery: setSearchQuery,
        commitSearchQuery: commitSearchQuery,
        clearAllFilters: clearAllFilters
    };
}
function $2649bd7d6ee9dd92$var$isFilterObjectEqual(a, b) {
    const filterIds = Object.keys(a);
    if (filterIds.length !== Object.keys(b).length) return false;
    return filterIds.every((filterId)=>{
        const aSubFilter = a[filterId] ?? {};
        const bSubFilter = b[filterId] ?? {};
        const optionIds = Object.keys(aSubFilter);
        if (optionIds.length !== Object.keys(bSubFilter).length) return false;
        return optionIds.every((optionId)=>aSubFilter[optionId]?.committedActive === bSubFilter[optionId]?.committedActive);
    });
}

});
parcelRegister("iSHOM", function(module, exports) {
$parcel$export(module.exports, "readStateFromUrl", function () { return $958e0f67d19dcee0$export$5ae5c11fea1e305c; });
$parcel$export(module.exports, "writeStateToUrl", function () { return $958e0f67d19dcee0$export$99ca66643841f01b; });
$parcel$export(module.exports, "filtersToUniformFilterObject", function () { return $958e0f67d19dcee0$export$d33e743aeb9f3bca; });
$parcel$export(module.exports, "uniformFilterObjectToFlat", function () { return $958e0f67d19dcee0$export$dc58eee439d7a466; });

var $9hXFt = parcelRequire("9hXFt");
const $958e0f67d19dcee0$var$SEARCH_KEY = 'term';
const $958e0f67d19dcee0$var$SORT_KEY = 'sort';
const $958e0f67d19dcee0$var$PAGE_KEY = 'page';
const $958e0f67d19dcee0$var$FIRST_PAGE = 1;
function $958e0f67d19dcee0$var$readSearchParams(search) {
    return new URLSearchParams(search);
}
function $958e0f67d19dcee0$var$getMulti(params, key) {
    const raw = params.get(key);
    return raw ? raw.split(';').filter(Boolean) : [];
}
function $958e0f67d19dcee0$export$5ae5c11fea1e305c(search, filterDefs) {
    const params = $958e0f67d19dcee0$var$readSearchParams(search);
    const query = params.get($958e0f67d19dcee0$var$SEARCH_KEY) ?? '';
    const filters = {};
    if (!query) for (const def of filterDefs){
        if ((0, $9hXFt.warnIfReservedKey)(def.id, 'filter id')) continue;
        const values = $958e0f67d19dcee0$var$getMulti(params, def.id);
        if (values.length > 0) filters[def.id] = values;
    }
    return {
        filters: filters,
        query: query,
        sortId: params.get($958e0f67d19dcee0$var$SORT_KEY) ?? undefined,
        page: $958e0f67d19dcee0$var$readPage(params.get($958e0f67d19dcee0$var$PAGE_KEY))
    };
}
/** `page=3` reads as 3. Missing, non-numeric, zero, or negative values read as page one. */ function $958e0f67d19dcee0$var$readPage(raw) {
    if (raw === null || raw.trim() === '') return $958e0f67d19dcee0$var$FIRST_PAGE;
    const value = Number(raw);
    if (!Number.isFinite(value)) return $958e0f67d19dcee0$var$FIRST_PAGE;
    const page = Math.floor(value);
    return page >= $958e0f67d19dcee0$var$FIRST_PAGE ? page : $958e0f67d19dcee0$var$FIRST_PAGE;
}
function $958e0f67d19dcee0$export$6b17a39e52c8ee53(state) {
    const params = new URLSearchParams();
    if (state.query) params.set($958e0f67d19dcee0$var$SEARCH_KEY, state.query);
    if (state.sortId) params.set($958e0f67d19dcee0$var$SORT_KEY, state.sortId);
    if (state.page !== undefined && state.page > $958e0f67d19dcee0$var$FIRST_PAGE) params.set($958e0f67d19dcee0$var$PAGE_KEY, String(Math.floor(state.page)));
    if (!state.query) for (const [key, values] of Object.entries(state.filters)){
        if ((0, $9hXFt.isReservedUrlKey)(key)) continue;
        if (!values || values.length === 0) continue;
        params.set(key, values.join(';'));
    }
    return $958e0f67d19dcee0$var$paramsToUnencodedString(params);
}
/**
 * Serialises params with semicolons left unencoded inside values
 * (mirrors roadmap-features/src/context/url.ts).
 */ function $958e0f67d19dcee0$var$paramsToUnencodedString(params) {
    return Array.from(params.entries()).map(([k, v])=>{
        const encodedKey = encodeURIComponent(k);
        const encodedValue = v.split(';').map(encodeURIComponent).join(';');
        return `${encodedKey}=${encodedValue}`;
    }).join('&');
}
function $958e0f67d19dcee0$export$99ca66643841f01b(state) {
    if (typeof window === 'undefined') return;
    const queryString = $958e0f67d19dcee0$export$6b17a39e52c8ee53(state);
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}${window.location.hash}`;
    if (newUrl !== `${window.location.pathname}${window.location.search}${window.location.hash}`) window.history.pushState({}, '', newUrl);
}
function $958e0f67d19dcee0$export$d33e743aeb9f3bca(flat, seedFilterObject) {
    const result = {};
    for (const [filterId, subFilter] of Object.entries(seedFilterObject)){
        const activeValues = new Set(flat[filterId] ?? []);
        const next = {};
        for (const optionKey of Object.keys(subFilter ?? {})){
            const isActive = activeValues.has(optionKey);
            next[optionKey] = {
                committedActive: isActive,
                stagedActive: isActive
            };
        }
        result[filterId] = next;
    }
    return result;
}
function $958e0f67d19dcee0$export$dc58eee439d7a466(state) {
    const flat = {};
    for (const [filterId, subFilter] of Object.entries(state)){
        const active = Object.entries(subFilter ?? {}).filter(([, opt])=>opt.committedActive).map(([key])=>key);
        if (active.length > 0) flat[filterId] = active;
    }
    return flat;
}

});
parcelRegister("9hXFt", function(module, exports) {
$parcel$export(module.exports, "isReservedUrlKey", function () { return $9b5db1cb5cc0ca12$export$a5c43a85198b9978; });
$parcel$export(module.exports, "warnIfReservedKey", function () { return $9b5db1cb5cc0ca12$export$954ab33cf89a3d04; });
const $9b5db1cb5cc0ca12$export$e5e16582af6ef4ec = [
    'term',
    'sort',
    'page'
];
function $9b5db1cb5cc0ca12$export$a5c43a85198b9978(key) {
    return $9b5db1cb5cc0ca12$export$e5e16582af6ef4ec.includes(key);
}
function $9b5db1cb5cc0ca12$export$954ab33cf89a3d04(key, context) {
    if (!$9b5db1cb5cc0ca12$export$a5c43a85198b9978(key)) return false;
    // eslint-disable-next-line no-console
    console.warn(`[filterableGallery] FilterDefinition.id "${key}" collides with a reserved URL key (${context}). URL sync skipped for this filter.`);
    return true;
}

});



parcelRegister("aGyeX", function(module, exports) {
$parcel$export(module.exports, "countFacetOptions", function () { return $62b2fd72a65d1987$export$a7731ac72b477478; });

var $H7SCD = parcelRequire("H7SCD");
function $62b2fd72a65d1987$export$a7731ac72b477478(items, filterDefs, filterObject) {
    const result = {};
    for (const filter of filterDefs){
        const otherFilters = filterDefs.filter((def)=>def.id !== filter.id);
        const itemsNarrowedByOtherFacets = (0, $H7SCD.applyFilters)(items, otherFilters, filterObject);
        const optionValues = Object.keys(filterObject[filter.id] ?? {});
        const counts = {};
        for (const optionValue of optionValues){
            const onlyThisOptionSelected = {
                [filter.id]: {
                    [optionValue]: {
                        committedActive: true,
                        stagedActive: true
                    }
                }
            };
            counts[optionValue] = (0, $H7SCD.applyFilters)(itemsNarrowedByOtherFacets, [
                filter
            ], onlyThisOptionSelected).length;
        }
        result[filter.id] = counts;
    }
    return result;
}

});

parcelRegister("6Ig8X", function(module, exports) {
$parcel$export(module.exports, "groupItemsByFieldPath", function () { return $151dd228d251d402$export$164886b06b35510c; });

var $H7SCD = parcelRequire("H7SCD");
/** Bucket for items where `groupByPath` resolves to nothing, when the path DOES resolve for other items. */ const $151dd228d251d402$var$MISSING_GROUP_LABEL = 'Other';
const $151dd228d251d402$var$MISSING_GROUP_KEY = '__missing__';
const $151dd228d251d402$var$UNGROUPED_KEY = 'ungrouped';
/** Warn once per distinct unresolvable path rather than once per render (§5.5 rule 4). */ const $151dd228d251d402$var$warnedUnresolvablePaths = new Set();
function $151dd228d251d402$var$warnUnresolvableGroupByPathOnce(groupByPath) {
    if ($151dd228d251d402$var$warnedUnresolvablePaths.has(groupByPath)) return;
    $151dd228d251d402$var$warnedUnresolvablePaths.add(groupByPath);
    // eslint-disable-next-line no-console
    console.warn(`[careersGallery] groupByPath "${groupByPath}" resolved for no item \u{2014} rendering a single ungrouped table.`);
}
function $151dd228d251d402$export$164886b06b35510c(items, groupByPath) {
    if (!groupByPath) return [
        {
            key: $151dd228d251d402$var$UNGROUPED_KEY,
            label: undefined,
            items: [
                ...items
            ]
        }
    ];
    const groupsInOrder = new Map();
    const missingGroupItems = [];
    let resolvedAtLeastOnce = false;
    for (const item of items){
        const value = (0, $H7SCD.coerceToPrimitiveArray)((0, $H7SCD.resolveFieldPath)(item, groupByPath))[0];
        if (value === undefined) {
            missingGroupItems.push(item);
            continue;
        }
        resolvedAtLeastOnce = true;
        if (!groupsInOrder.has(value)) groupsInOrder.set(value, []);
        groupsInOrder.get(value)?.push(item);
    }
    if (!resolvedAtLeastOnce) {
        $151dd228d251d402$var$warnUnresolvableGroupByPathOnce(groupByPath);
        return [
            {
                key: $151dd228d251d402$var$UNGROUPED_KEY,
                label: undefined,
                items: [
                    ...items
                ]
            }
        ];
    }
    // The reference lists group headings alphabetically, not in the order the
    // data resource happens to return them.
    const groups = Array.from(groupsInOrder.entries()).map(([value, groupItems])=>({
            key: value,
            label: value,
            items: groupItems
        })).sort((a, b)=>a.label.localeCompare(b.label));
    if (missingGroupItems.length > 0) groups.push({
        key: $151dd228d251d402$var$MISSING_GROUP_KEY,
        label: $151dd228d251d402$var$MISSING_GROUP_LABEL,
        items: missingGroupItems
    });
    return groups;
}

});

parcelRegister("kNuV4", function(module, exports) {
$parcel$export(module.exports, "formatLocationSummary", function () { return $7affeec8afd43fb8$export$c2feabb5440547e7; });
/**
 * iCIMS ships each location as one dirty string with two or three `" - "`
 * segments, for example:
 *
 *   "Yokohama - Japan -   Yokohama, Kanagawa 220-8114 Japan"
 *   "Remote - Remote"
 *
 * Measured over 522 elements on 2026-08-06: 398 carry three segments, 124 carry
 * two, and 304 contain a double space. The third segment is a full address and
 * no surface renders it.
 *
 * The listing and the job details page format the SAME array two different
 * ways, on purpose. A listing row holds one line in a narrow column. A details
 * subheading holds every location.
 *
 * The details side already owns its own formatter, `formatIcimsLocation` in
 * `job-posting-subheading/src/utils/`, merged under GWP-12935. That function
 * deliberately does not serve the gallery, and this module deliberately does not
 * serve the details page.
 *
 * CAUTION: both modules split on `" - "` and both normalize whitespace the same
 * way. That duplication is known and accepted for now. If the iCIMS format
 * changes, BOTH need the edit.
 */ const $7affeec8afd43fb8$var$SEGMENT_SEPARATOR = ' - ';
const $7affeec8afd43fb8$var$REMOTE_CITY = 'Remote';
function $7affeec8afd43fb8$export$fddedb77b8108f50(raw) {
    const segments = raw.split($7affeec8afd43fb8$var$SEGMENT_SEPARATOR).map((segment)=>segment.replace(/\s+/g, ' ').trim()).filter((segment)=>segment.length > 0);
    return {
        city: segments[0] ?? '',
        country: segments[1]
    };
}
function $7affeec8afd43fb8$export$c2feabb5440547e7(locations) {
    const cities = locations.map((raw)=>$7affeec8afd43fb8$export$fddedb77b8108f50(raw).city).filter((city)=>city !== '');
    const first = cities[0];
    if (first === undefined) return '';
    const hasRemote = cities.includes($7affeec8afd43fb8$var$REMOTE_CITY);
    return hasRemote ? `${first} or ${$7affeec8afd43fb8$var$REMOTE_CITY}` : first;
}

});


parcelRegister("jswU3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6d4cfc38fdffaa9$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $6jr7X = parcelRequire("6jr7X");

var $kU0PA = parcelRequire("kU0PA");

var $jfojT = parcelRequire("jfojT");
const $f6d4cfc38fdffaa9$var$UniformCollectionPricingHero = (props)=>{
    if (props.collectionType === 'teamwork') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jfojT.TeamworkCollectionPricingHero), {});
    if (props.collectionType === 'strategy') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kU0PA.StrategyCollectionPricingHero), {});
    if (props.collectionType === 'service') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6jr7X.ServiceCollectionPricingHero), {});
    return null;
};
var $f6d4cfc38fdffaa9$export$2e2bcd8739ae039 = $f6d4cfc38fdffaa9$var$UniformCollectionPricingHero;

});
parcelRegister("6jr7X", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionPricingHero", function () { return $17930c441541a572$export$5eff9997197d8e50; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $17930c441541a572$export$5eff9997197d8e50 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        orientation: "vertical",
        collectionImage: {
            height: 48,
            width: 168,
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wq7706lsya8q6fb1sj2k15h48h450ssr.svg',
            alt: 'Service Collection'
        },
        products: [
            {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7jcq40x67167gax15ux7b27r5r575tk5.svg',
                    alt: 'Jira Service Management'
                }
            },
            {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/466ke7l5j3i276s3p7k5660c525ru38d.svg',
                    alt: 'Customer Service Management'
                }
            },
            {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8hgm0up275i80h6m7b5j3f8t68a7fcp4.svg',
                    alt: 'Assets'
                }
            },
            {
                name: 'Rovo',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6kq772n08c357g2p82f8bnw824do06dn.svg',
                    alt: 'Rovo'
                }
            }
        ]
    });
};

});

parcelRegister("kU0PA", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionPricingHero", function () { return $0f9946b2ee41705a$export$4a5cc933f6e8553a; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $0f9946b2ee41705a$export$4a5cc933f6e8553a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        collectionImage: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5j2mvlle35t45d0e48ye5tqpoe0m63gu.svg',
            alt: 'Strategy Collection'
        },
        products: [
            {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hd3m515u7j3s37rldpf0dgeb7m383j4s.svg',
                    alt: 'Align'
                }
            },
            {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/241h1u1khig63kccl1fe3hisqom3q007/fl_keep_metadata/Apps-Talent.svg',
                    alt: 'Talent'
                }
            },
            {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/24e3l0ul76q4fpa4l2mmc7t00k202322.svg',
                    alt: 'Focus'
                }
            }
        ]
    });
};

});


parcelRegister("82Z9J", function(module, exports) {
$parcel$export(module.exports, "UniformColumnLayout", function () { return $3f1a8340323fe0b9$export$23133ddca0202abb; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return $3f1a8340323fe0b9$export$8807233e43f557a9; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");
const $3f1a8340323fe0b9$var$slotWrapper = ({ items: items })=>{
    return items.map((element, index)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
            children: element
        }, index);
    });
};
const $3f1a8340323fe0b9$export$23133ddca0202abb = ({ layout: layout = '12', tabletLayout: tabletLayout, mobileLayout: mobileLayout, paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = 'normal', renderAsList: renderAsList, mobileReverseOrder: mobileReverseOrder })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: layout,
        tabletLayout: tabletLayout,
        mobileLayout: mobileLayout,
        paddingTopv2: paddingTopv2,
        paddingBottomv2: paddingBottomv2,
        verticalAlignment: verticalAlignment,
        renderAsList: renderAsList,
        mobileReverseOrder: mobileReverseOrder,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $3f1a8340323fe0b9$var$slotWrapper : undefined
        })
    });
};
const $3f1a8340323fe0b9$export$8807233e43f557a9 = ({ layout: layout = '12', tabletLayout: tabletLayout, mobileLayout: mobileLayout, paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = 'normal', renderAsList: renderAsList, mobileReverseOrder: mobileReverseOrder })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.SubColumnLayout), {
        layout: layout,
        tabletLayout: tabletLayout,
        mobileLayout: mobileLayout,
        paddingTopv2: paddingTopv2,
        paddingBottomv2: paddingBottomv2,
        verticalAlignment: verticalAlignment,
        renderAsList: renderAsList,
        mobileReverseOrder: mobileReverseOrder,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $3f1a8340323fe0b9$var$slotWrapper : undefined
        })
    });
}; // Both components are exported as named exports above

});

parcelRegister("7QjKf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aa1bd5f2cdec282c$export$2e2bcd8739ae039; });
/* company-timeline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $ljqox = parcelRequire("ljqox");
const $aa1bd5f2cdec282c$var$HEADING_ID = 'company-timeline-heading';
const $aa1bd5f2cdec282c$var$TIMELINE_ENTRIES = [
    {
        year: '1998',
        body: [
            (0, $ljqox.companyTimelineMessages).entry1998
        ]
    },
    {
        year: '2001',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2001
        ]
    },
    {
        year: '2002',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2002
        ]
    },
    {
        year: '2003',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2003
        ]
    },
    {
        year: '2005',
        highlight: (0, $ljqox.companyTimelineMessages).entry2005Highlight,
        body: [
            (0, $ljqox.companyTimelineMessages).entry2005
        ]
    },
    {
        year: '2006',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2006
        ]
    },
    {
        year: '2007',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2007
        ],
        list: [
            (0, $ljqox.companyTimelineMessages).entry2007Value1,
            (0, $ljqox.companyTimelineMessages).entry2007Value2,
            (0, $ljqox.companyTimelineMessages).entry2007Value3,
            (0, $ljqox.companyTimelineMessages).entry2007Value4,
            (0, $ljqox.companyTimelineMessages).entry2007Value5
        ]
    },
    {
        year: '2009',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2009
        ]
    },
    {
        year: '2011',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2011
        ]
    },
    {
        year: '2012',
        highlight: (0, $ljqox.companyTimelineMessages).entry2012Highlight,
        body: [
            (0, $ljqox.companyTimelineMessages).entry2012Anniversary,
            (0, $ljqox.companyTimelineMessages).entry2012Revenue
        ]
    },
    {
        year: '2013',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2013Offices,
            (0, $ljqox.companyTimelineMessages).entry2013ServiceDesk
        ]
    },
    {
        year: '2015',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2015
        ]
    },
    {
        year: '2017',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2017
        ]
    },
    {
        year: '2018',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2018Opsgenie,
            (0, $ljqox.companyTimelineMessages).entry2018Bengaluru
        ]
    },
    {
        year: '2020',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2020ServiceManagement,
            (0, $ljqox.companyTimelineMessages).entry2020TeamAnywhere
        ]
    },
    {
        year: '2021',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2021
        ]
    },
    {
        year: '2022',
        highlight: (0, $ljqox.companyTimelineMessages).entry2022Highlight,
        body: [
            (0, $ljqox.companyTimelineMessages).entry2022
        ]
    },
    {
        year: '2023',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2023Ai,
            (0, $ljqox.companyTimelineMessages).entry2023Loom
        ]
    },
    {
        year: '2024',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2024Rovo,
            (0, $ljqox.companyTimelineMessages).entry2024Jira
        ]
    },
    {
        year: '2025',
        body: [
            (0, $ljqox.companyTimelineMessages).entry2025
        ]
    }
];
const $aa1bd5f2cdec282c$var$UniformCompanyTimeline = ()=>{
    const intl = (0, $8e22h.default)();
    const scrollerRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const scroller = scrollerRef.current;
        if (!scroller) return;
        // Keyboard users must be able to focus the track to scroll it (WCAG 2.1.1), but only when
        // there is something to scroll — otherwise it is a dead tab stop. Set from the DOM because
        // it depends on measured layout, which is not known at render time. The 1px allowance
        // absorbs sub-pixel layout rounding.
        const measure = ()=>{
            scroller.tabIndex = scroller.scrollWidth - scroller.clientWidth > 1 ? 0 : -1;
        };
        measure();
        if (typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(measure);
        observer.observe(scroller);
        Array.from(scroller.children).forEach((child)=>observer.observe(child));
        return ()=>observer.disconnect();
    }, []);
    const lastIndex = $aa1bd5f2cdec282c$var$TIMELINE_ENTRIES.length - 1;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        "aria-labelledby": $aa1bd5f2cdec282c$var$HEADING_ID,
        className: (0, $2jatx.default)([
            "_bfhkdkka"
        ]),
        style: {
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: scrollerRef,
            role: "group",
            "aria-label": intl.formatMessage((0, $ljqox.companyTimelineMessages).timelineLabel),
            className: (0, $2jatx.default)([
                "_1e0c1txw _1n261q9c _4cvresu3 _1bsb1osq _p12f1osq _1ul9idpf _1rjcoahv _18zr1ejb _1reo1wug _18m915vq _11im1f51 _8am5i4x0 _1fjgurpi _a5o9qdht _15peu2gc _aayns3kk _155a1rr0 _gogpq5uf _1ygb1qgu _1ah3v77o _owpu1jfw"
            ]),
            style: {
                "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulp1ejb _16jlidpf _1o9zidpf _i0dl1wug _1bsb3zno _bfhk1afi _1yt41jfw _12l2xy5q _glte1t5h"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            id: $aa1bd5f2cdec282c$var$HEADING_ID,
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybviql _vwz43ei5 _k48pbfng _syaz1pfd _3p1c1wto"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: intl.formatMessage((0, $ljqox.companyTimelineMessages).heading)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1j6v _vwz4bs82 _syaz1pfd"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: intl.formatMessage((0, $ljqox.companyTimelineMessages).introFounding)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1j6v _vwz4bs82 _syaz1pfd"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: intl.formatMessage((0, $ljqox.companyTimelineMessages).introToday)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1arc _4t3i1b66 _bfhkuol8"
                            ]),
                            style: {
                                "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron'))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("ol", {
                    role: "list",
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261q9c _4cvresu3 _16jlidpf _1o9zidpf _i0dl1wug _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                    ]),
                    children: $aa1bd5f2cdec282c$var$TIMELINE_ENTRIES.map((entry, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1e0c1txw _2lx21sxn _1bah1y6m _16jlidpf _1o9zidpf _i0dl1wug _1bsby4sk _1rjc1lhf _y4tixy5q _aetrb3bt _18postnw _13w1idpf _1gufidpf _1qdgud5o _1hfk5hrz _gltetye8",
                                (index === 0 || index === lastIndex) && "_1kt9b3bt _1cs8stnw _z5wtidpf _1fkrvvhv _1mp44yz6 _kfgt4yz6 _rfx31ssb _1rus5hrz",
                                index === lastIndex && "_1ywuglyw"
                            ]),
                            style: {
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfhpxbi _1wyb1k92 _vwz419ii _k48p1nn1 _syaz1qc2"
                                    ]),
                                    style: {
                                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("time", {
                                        dateTime: entry.year,
                                        children: entry.year
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx21bp4 _zulp1ejb"
                                    ]),
                                    children: [
                                        entry.highlight && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                "_1qqgidpf _pqm0idpf _px8lidpf _1s06idpf _5e3p1m1q _ln511038 _1xa1bfng _i5ol1pfd _u8gyahaf",
                                                "company-timeline-highlight"
                                            ]),
                                            style: {
                                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                            },
                                            children: intl.formatMessage(entry.highlight)
                                        }),
                                        entry.body.map((message)=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1j6v _vwz4bs82 _syaz1pfd"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                                },
                                                children: intl.formatMessage(message)
                                            }, message.id)),
                                        entry.list && /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                            role: "list",
                                            className: (0, $2jatx.default)([
                                                "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _vwz4bs82 _syaz1pfd"
                                            ]),
                                            style: {
                                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                            },
                                            children: entry.list.map((message)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                                    children: intl.formatMessage(message)
                                                }, message.id))
                                        })
                                    ]
                                })
                            ]
                        }, entry.year))
                })
            ]
        })
    });
};
const $aa1bd5f2cdec282c$var$TIMELINE_RULE_HEIGHT = '0.625rem';
const $aa1bd5f2cdec282c$var$TIMELINE_DOT_SIZE = '1.5625rem';
// Centres the dot on the rule: (dot - rule) / 2.
const $aa1bd5f2cdec282c$var$TIMELINE_DOT_OFFSET = '-0.46875rem';
const $aa1bd5f2cdec282c$var$sectionStyles = null;
const $aa1bd5f2cdec282c$var$scrollerStyles = null;
// Vertical rhythm comes from `gap` rather than child margins, so no trailing-margin reset is
// needed to keep the final element flush.
const $aa1bd5f2cdec282c$var$introStyles = null;
const $aa1bd5f2cdec282c$var$headingStyles = null;
const $aa1bd5f2cdec282c$var$paragraphStyles = null;
const $aa1bd5f2cdec282c$var$entryBodyStyles = null;
const $aa1bd5f2cdec282c$var$introRuleStyles = null;
const $aa1bd5f2cdec282c$var$trackStyles = null;
// Gaps between entries come from padding rather than `gap` so the bottom rule stays unbroken.
const $aa1bd5f2cdec282c$var$entryStyles = null;
const $aa1bd5f2cdec282c$var$entryDotStyles = null;
// The rule spans first dot to last dot, so the final entry carries a dot but no rule.
const $aa1bd5f2cdec282c$var$entryLastStyles = null;
const $aa1bd5f2cdec282c$var$yearStyles = null;
// Declared against the class name as well as the element so the rule is (0,2,0) — a global
// stylesheet `p` rule out-specifies Compiled's single-class output and was winning.
const $aa1bd5f2cdec282c$var$highlightStyles = null;
const $aa1bd5f2cdec282c$var$valuesListStyles = null;
var $aa1bd5f2cdec282c$export$2e2bcd8739ae039 = $aa1bd5f2cdec282c$var$UniformCompanyTimeline;

});
parcelRegister("ljqox", function(module, exports) {
$parcel$export(module.exports, "companyTimelineMessages", function () { return $b1243d2ceba7fd84$export$a2a2fd02b00f5bc1; });

var $fnHPc = parcelRequire("fnHPc");
const $b1243d2ceba7fd84$export$a2a2fd02b00f5bc1 = (0, $fnHPc.defineMessages)({
    timelineLabel: {
        id: 'company-timeline.timelineLabel',
        defaultMessage: 'Company history timeline'
    },
    heading: {
        id: 'company-timeline.heading',
        defaultMessage: 'A brief history'
    },
    introFounding: {
        id: 'company-timeline.introFounding',
        defaultMessage: "Armed with a credit card and a dream, two college friends, Mike Cannon-Brookes and Scott Farquhar set out to create Atlassian. In 2002, they didn't know what kind of company Atlassian was going to be, but they knew exactly what it shouldn't be\u2014an environment where they had to conform rather than be who they authentically are."
    },
    introToday: {
        id: 'company-timeline.introToday',
        defaultMessage: "Now 20 years in, we've grown into a global company with employees all over the world, but those early ambitions hold true. Here's our story:"
    },
    entry1998: {
        id: 'company-timeline.entry1998',
        defaultMessage: 'Mike and Scott, both 18, land in the same scholarship course at the University of New South Wales.'
    },
    entry2001: {
        id: 'company-timeline.entry2001',
        defaultMessage: 'Atlassian, inspired by the Greek Titan, is registered as a business name.'
    },
    entry2002: {
        id: 'company-timeline.entry2002',
        defaultMessage: 'Atlassian becomes real with the launch of Jira 1.0.'
    },
    entry2003: {
        id: 'company-timeline.entry2003',
        defaultMessage: 'Confluence 1.0 is born and released to the world.'
    },
    entry2005Highlight: {
        id: 'company-timeline.entry2005Highlight',
        defaultMessage: '1,000'
    },
    entry2005: {
        id: 'company-timeline.entry2005',
        defaultMessage: 'We get our 1,000th customer.'
    },
    entry2006: {
        id: 'company-timeline.entry2006',
        defaultMessage: 'We co-found Pledge 1% and Atlassian Foundation is created.'
    },
    entry2007: {
        id: 'company-timeline.entry2007',
        defaultMessage: 'Our five core values come to life.'
    },
    entry2007Value1: {
        id: 'company-timeline.entry2007Value1',
        defaultMessage: 'Open company, no bullshit.'
    },
    entry2007Value2: {
        id: 'company-timeline.entry2007Value2',
        defaultMessage: 'Build everything with heart and balance.'
    },
    entry2007Value3: {
        id: 'company-timeline.entry2007Value3',
        defaultMessage: "Don't #@!% the customer."
    },
    entry2007Value4: {
        id: 'company-timeline.entry2007Value4',
        defaultMessage: 'Play as a team.'
    },
    entry2007Value5: {
        id: 'company-timeline.entry2007Value5',
        defaultMessage: 'Be the change you seek.'
    },
    entry2009: {
        id: 'company-timeline.entry2009',
        defaultMessage: 'We open our first European office in Amsterdam.'
    },
    entry2011: {
        id: 'company-timeline.entry2011',
        defaultMessage: 'Atlassian ships first cloud versions of Confluence and Jira.'
    },
    entry2012Highlight: {
        id: 'company-timeline.entry2012Highlight',
        defaultMessage: '10 years!'
    },
    entry2012Anniversary: {
        id: 'company-timeline.entry2012Anniversary',
        defaultMessage: 'Atlassian celebrates its 10th anniversary.'
    },
    entry2012Revenue: {
        id: 'company-timeline.entry2012Revenue',
        defaultMessage: 'We hit $100 million dollars of revenue.'
    },
    entry2013Offices: {
        id: 'company-timeline.entry2013Offices',
        defaultMessage: 'We open offices in Yokohama and Manila.'
    },
    entry2013ServiceDesk: {
        id: 'company-timeline.entry2013ServiceDesk',
        defaultMessage: "Jira Service Desk (a former ShipIt project!) joins Atlassian's suite of tools."
    },
    entry2015: {
        id: 'company-timeline.entry2015',
        defaultMessage: 'Atlassian goes public! We are listed on NASDAQ as TEAM.'
    },
    entry2017: {
        id: 'company-timeline.entry2017',
        defaultMessage: 'Trello joins our growing family of tools.'
    },
    entry2018Opsgenie: {
        id: 'company-timeline.entry2018Opsgenie',
        defaultMessage: 'Opsgenie joins our product family.'
    },
    entry2018Bengaluru: {
        id: 'company-timeline.entry2018Bengaluru',
        defaultMessage: 'We opened our Bengaluru office.'
    },
    entry2020ServiceManagement: {
        id: 'company-timeline.entry2020ServiceManagement',
        defaultMessage: 'We launched Jira Service Management, the next generation of Jira Service Desk.'
    },
    entry2020TeamAnywhere: {
        id: 'company-timeline.entry2020TeamAnywhere',
        defaultMessage: 'Atlassian announces TEAM Anywhere, a distributed work policy that allows employees to work from (almost) anywhere.'
    },
    entry2021: {
        id: 'company-timeline.entry2021',
        defaultMessage: 'Launched Jira Work Management.'
    },
    entry2022Highlight: {
        id: 'company-timeline.entry2022Highlight',
        defaultMessage: '20 years!'
    },
    entry2022: {
        id: 'company-timeline.entry2022',
        defaultMessage: 'Celebrating 20 years!'
    },
    entry2023Ai: {
        id: 'company-timeline.entry2023Ai',
        defaultMessage: 'Introduced AI to Atlassian cloud platform.'
    },
    entry2023Loom: {
        id: 'company-timeline.entry2023Loom',
        defaultMessage: 'Atlassian acquires Loom.'
    },
    entry2024Rovo: {
        id: 'company-timeline.entry2024Rovo',
        defaultMessage: 'Announced Rovo, our AI teammate.'
    },
    entry2024Jira: {
        id: 'company-timeline.entry2024Jira',
        defaultMessage: 'Jira Software and Jira Work Management unite into Jira.'
    },
    entry2025: {
        id: 'company-timeline.entry2025',
        defaultMessage: 'Debut Strategy and Teamwork Collections.'
    }
});

});


parcelRegister("9eDC1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f9940d7299757e5$export$2e2bcd8739ae039; });
/* confluence-animated-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $01zo5 = parcelRequire("01zo5");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $aKeh7 = parcelRequire("aKeh7");

var $1iN19 = parcelRequire("1iN19");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $4f9940d7299757e5$var$backgroundColorMap = {
    blue100: (0, $kbpa7.wacToken)('color.extended.blue100'),
    primaryBlack: (0, $kbpa7.wacToken)('color.primary.black'),
    light100: (0, $kbpa7.wacToken)('color.neutral.light100')
};
const $4f9940d7299757e5$var$sectionCss = null;
const $4f9940d7299757e5$var$cardContainerCss = null;
const $4f9940d7299757e5$var$cardCss = null;
const $4f9940d7299757e5$var$cardTextCss = null;
const $4f9940d7299757e5$var$cardHeadingCss = null;
const $4f9940d7299757e5$var$cardBodyTextCss = null;
const $4f9940d7299757e5$var$controlButtonStyles = null;
const $4f9940d7299757e5$var$videoContainerCss = null;
const $4f9940d7299757e5$export$235b37640a653467 = ({ title: title, bodytext: bodytext, image: image, altText: altText })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    const [isPlaying, setPlaying] = (0, $1oC0p.useState)(false);
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const prefersReducedMotion = typeof window !== 'undefined' ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
    const togglePlay = ()=>{
        const label = isPlaying ? 'pause' : 'play';
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'playPause',
            source: 'confluenceAnimatedHero',
            attributes: {
                label: label
            }
        }).fire();
        if (videoRef.current) {
            if (isPlaying) videoRef.current.pause();
            else videoRef.current.play().catch(()=>{
            // Ignore error likely due to autoplay restrictions or browser power saving
            });
        }
    };
    const handleVideoPlay = ()=>setPlaying(true);
    const handleVideoPause = ()=>setPlaying(false);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz _kqswh2mm _1k9hgrho _1mj31wqb _162p1nty _1xjr1nty _1scc1gha _1nr41gha _1axucs5v _15z31nut _hauj1nut _188c150m _y5pt150m _11za1o02 _1rgq1o02 _tnzz120m _s118120m _ikf21klr _18zx1klr _zcbv1osq _mezj1osq _12l01wug _bna71wug _eq9p15vq _pzs515vq _175j15vq _dknm15vq _1gbl1wug _1cr61wug _qpgx1wug _1hlx1wug _1d2pidpf _1874idpf _s93b1wug _10ew1wug _1th61xym _k9x81xym _1wi11m52 _1biu1m52 _ldg01ylz _dzwg1ylz _8wcm1afi _d3lp1afi _1dhb130s _t1ov130s _1sdaagmp _ktt3agmp",
            "single-hero-card"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "text-container",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_gxfkidpf _tfg1idpf _16yqidpf _15zyidpf _14dwidpf _1u6jidpf _1ikgidpf _1p3yidpf _1niwidpf _a15ridpf _12k0idpf _1fx6idpf _104aidpf _10pqidpf _5ybeidpf _1avnidpf _1cmpidpf _174lidpf _tlu6idpf _kopkidpf _4s33idpf _lychidpf _zzhoidpf _x9vnidpf _65gh10nf _18ko10nf _17ie10nf _1dlt10nf _1t9o10nf _1x5u10nf _1g4p1ejb _1l3z1ejb _1qkw1ejb _8znu1ejb _vh191ejb _ret01ejb _kgcl1nn1 _1m1k1nn1 _b08d1nn1 _1bau1nn1 _zmdp1nn1 _1r881nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-heading"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                            node: title['root'] || title
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1axaidpf _420lidpf _195sidpf _thjjidpf _jhbppxbi _1yq31k8s _zcsk1nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-body"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                            node: bodytext['root'] || bodytext
                        })
                    })
                ]
            }),
            image?.includes('.mp4') ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _npsn1dfr _1y2k1osq _z18o1osq",
                    "imagery video video-container"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        ref: videoRef,
                        src: image,
                        autoPlay: !prefersReducedMotion,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        onPlay: handleVideoPlay,
                        onPause: handleVideoPause,
                        onLoadedMetadata: ()=>{
                            if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{
                            // Ignore error likely due to autoplay restrictions or browser power saving
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        className: (0, $2jatx.default)([
                            "_80omtlke _tzy41ou4 _bfhk1j28 _syaz1afi _19it1axk _2rko1mv1 _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7co1jfw _16l4kb7n _w8l5dlk8",
                            "control-button"
                        ]),
                        onClick: togglePlay,
                        "aria-label": intl.formatMessage(isPlaying ? {
                            id: 'uniform-video.pause',
                            defaultMessage: 'Pause'
                        } : {
                            id: 'uniform-video.play',
                            defaultMessage: 'Play'
                        }),
                        "aria-pressed": isPlaying,
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill'))
                        },
                        children: isPlaying ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aKeh7))), {
                            label: intl.formatMessage({
                                id: 'uniform-video.pause',
                                defaultMessage: 'Pause'
                            })
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iN19))), {
                            label: intl.formatMessage({
                                id: 'uniform-video.play',
                                defaultMessage: 'Play'
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: image,
                alt: altText ?? ''
            })
        ]
    });
};
const $4f9940d7299757e5$var$UniformConfluenceAnimatedHero = ({ confluenceHeroCards: confluenceHeroCards, imagesWidth: imagesWidth, imagesHeight: imagesHeight, flattenData: flattenData = true, backgroundColor: backgroundColor = 'blue100' })=>{
    if (flattenData) confluenceHeroCards = (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    confluenceHeroCards);
    const [inview, setInview] = (0, $1oC0p.useState)(false);
    const [hasScrolled, setHasScrolled] = (0, $1oC0p.useState)(false);
    const [moveUpValue, setMoveUpValue] = (0, $1oC0p.useState)(120);
    const containerRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY <= 50) {
                setInview(false);
                setHasScrolled(false);
                return;
            } else setHasScrolled(true);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasScrolled || !containerRef.current) return;
        const io = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) setInview(true);
            });
        }, {
            threshold: 0.5
        });
        io.observe(containerRef.current);
        return ()=>{
            io.disconnect();
        };
    }, [
        hasScrolled
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const updateMoveUpValue = ()=>{
            if (!containerRef.current) return;
            const textContainers = containerRef.current.querySelectorAll('.text-container');
            let maxHeight = 0;
            textContainers.forEach((container)=>{
                const height = container.offsetHeight;
                maxHeight = Math.max(maxHeight, height);
            });
            const calculatedMoveUp = maxHeight + 16;
            setMoveUpValue(calculatedMoveUp);
        };
        const timeoutId = setTimeout(updateMoveUpValue, 100);
        document?.fonts?.ready?.then(updateMoveUpValue);
        window.addEventListener('resize', updateMoveUpValue);
        return ()=>{
            clearTimeout(timeoutId);
            window.removeEventListener('resize', updateMoveUpValue);
        };
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_v5641r9r _lwq31qpa _ia4wwomy _mbuvwomy",
            'scroll-hero' + (inview ? ' inview' : ' outview')
        ]),
        style: {
            '--moveup': `-${moveUpValue}px`,
            '--imagesWidth': imagesWidth,
            '--imagesHeight': imagesHeight,
            background: $4f9940d7299757e5$var$backgroundColorMap[backgroundColor]
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: containerRef,
            className: (0, $2jatx.default)([
                "_1e0c11p5 _1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _zulp14hz _1dsl1tcg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx _1vsw1vi7 _1j8b16hb _1wafpxbi _1bah1h6o _1ojfg8ja _3qvcg8ja _1utgqo9z _1fjsqo9z _12n71qqw _xlt1xncg _131yxncg _bkwyglyw _xon5glyw _128dglyw _q8ukglyw _4y3qglyw _uzo21qqw",
                inview ? 'inview' : 'outview'
            ]),
            style: {
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
            },
            children: confluenceHeroCards.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($4f9940d7299757e5$export$235b37640a653467, {
                    title: card.cardTitle,
                    bodytext: card.cardDescription,
                    image: card.cardImageOrVideo,
                    altText: card.cardImageAlt ?? ''
                }, index))
        })
    });
};
var $4f9940d7299757e5$export$2e2bcd8739ae039 = $4f9940d7299757e5$var$UniformConfluenceAnimatedHero;

});

parcelRegister("hStuA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70c5c0076527144c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $fsuqf = parcelRequire("fsuqf");
const $70c5c0076527144c$var$UniformConnector = ({ title: title, text: text, linkText: linkText, linkHref: linkHref, customerQuotes: customerQuotes, mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos, flattenData: flattenData = true })=>{
    if (flattenData) {
        customerQuotes = (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        customerQuotes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mobileLogos = (0, $f2QWG.flattenValues)(mobileLogos);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tabletLogos = (0, $f2QWG.flattenValues)(tabletLogos);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        desktopLogos = (0, $f2QWG.flattenValues)(desktopLogos);
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fsuqf.Connector), {
        title: title,
        text: text,
        linkText: linkText,
        linkHref: linkHref,
        linkDataEventProps: {
            'data-product-key': 'uniform',
            'data-event': 'clicked',
            'data-event-component': 'linkButton',
            'data-event-container': 'connector'
        },
        customerQuotes: customerQuotes,
        mobileLogos: mobileLogos,
        tabletLogos: tabletLogos,
        desktopLogos: desktopLogos
    });
};
var $70c5c0076527144c$export$2e2bcd8739ae039 = $70c5c0076527144c$var$UniformConnector;

});
parcelRegister("fsuqf", function(module, exports) {
$parcel$export(module.exports, "Connector", function () { return $0d5223a79dc9016a$export$b2278035370d6017; });
/* connector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $i4BST = parcelRequire("i4BST");

var $kdSM2 = parcelRequire("kdSM2");

var $jiDxV = parcelRequire("jiDxV");
const $0d5223a79dc9016a$export$b2278035370d6017 = ({ title: title, text: text, linkText: linkText, linkHref: linkHref, linkDataEventProps: linkDataEventProps, customerQuotes: customerQuotes, mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `connector-title-${uniqueId}`;
    const buttonId = `connector-button-${uniqueId}`;
    const linkId = `connector-link-${uniqueId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1rjc1epz _bfhk1pfd _1e0c1txw _2lx21bp4 _zulpoahv",
            isWacRefresh && "_bfhkg7ng _1rjc16xz _zulp16xz _1t2pys9h _2osnys9h _133i1wqb _81641wqb"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                layout: isWacRefresh ? '6-6' : '5-7',
                tabletLayout: isWacRefresh ? '12' : undefined,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_cg411afi _125x1afi _xsmr1h6o",
                            isWacRefresh && "_cg411pfd _125x1pfd _xsmr1e5h",
                            "contentBlock"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                id: titleId,
                                className: (0, $2jatx.default)([
                                    "_1pfhxy5q _6rthu2gc _476didpf",
                                    isWacRefresh && "_1pfhidpf _6rthidpf"
                                ]),
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1mouidpf",
                                    isWacRefresh && "_1pfhutpp",
                                    isWacRefresh ? 'body-lg' : undefined
                                ]),
                                children: text
                            }),
                            linkText && linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh1ejb _6rthxy5q _srwz1ejb"
                                ]),
                                children: isWacRefresh ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    id: buttonId,
                                    href: linkHref,
                                    variant: "secondary",
                                    colorAgainst: "white",
                                    responsiveSize: {
                                        mobile: 'small',
                                        tablet: 'small',
                                        desktop: 'large',
                                        xl_desktop: 'large'
                                    },
                                    ariaLabelledby: `${buttonId} ${titleId}`,
                                    dataEventProps: linkDataEventProps,
                                    children: linkText
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    id: linkId,
                                    "aria-label": linkText,
                                    ariaLabelledby: `${linkId} ${titleId}`,
                                    text: linkText,
                                    href: linkHref,
                                    type: "primary",
                                    bgColor: "bgBlackBlue",
                                    ...linkDataEventProps && {
                                        dataEventProps: linkDataEventProps
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kdSM2.CustomerQuoteCarousel), {
                        customerQuotes: customerQuotes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jiDxV.LogosMarquee), {
                mobileLogos: mobileLogos,
                tabletLogos: tabletLogos,
                desktopLogos: desktopLogos
            })
        ]
    });
};
var $0d5223a79dc9016a$export$2e2bcd8739ae039 = $0d5223a79dc9016a$export$b2278035370d6017;
const $0d5223a79dc9016a$var$containerCss = null;
const $0d5223a79dc9016a$var$refreshContainerCss = null;
const $0d5223a79dc9016a$var$lightTextCss = null;
const $0d5223a79dc9016a$var$refreshTextBlockCss = null;
const $0d5223a79dc9016a$var$titleCss = null;
const $0d5223a79dc9016a$var$refreshTitleCss = null;
const $0d5223a79dc9016a$var$textCss = null;
const $0d5223a79dc9016a$var$refreshBodyTextCss = null;
const $0d5223a79dc9016a$var$linkCss = null;

});
parcelRegister("kdSM2", function(module, exports) {
$parcel$export(module.exports, "CustomerQuoteCarousel", function () { return $6e4e4b8ac7dd4aed$export$abab76d12bbd8406; });
/* customer-quote-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $clnBI = parcelRequire("clnBI");

var $Lp2P8 = parcelRequire("Lp2P8");

var $bwWCK = parcelRequire("bwWCK");

var $bSVv5 = parcelRequire("bSVv5");

var $ksvEJ = parcelRequire("ksvEJ");

var $kbpa7 = parcelRequire("kbpa7");

var $i4BST = parcelRequire("i4BST");
const $6e4e4b8ac7dd4aed$var$messages = {
    previousSlide: {
        id: 'customer-quote-carousel.previous-slide',
        defaultMessage: 'Previous slide'
    },
    nextSlide: {
        id: 'customer-quote-carousel.next-slide',
        defaultMessage: 'Next slide'
    }
};
const $6e4e4b8ac7dd4aed$export$abab76d12bbd8406 = ({ customerQuotes: customerQuotes })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const [activeQuoteIndex, setActiveQuoteIndex] = (0, $1oC0p.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const prevSlide = (0, $1oC0p.useCallback)(()=>{
        if (activeQuoteIndex > 0) {
            setActiveQuoteIndex(activeQuoteIndex - 1);
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'previousSlide',
                source: 'customerQuoteCarousel',
                attributes: {
                    label: 'previous slide'
                }
            }).fire();
        }
    }, [
        activeQuoteIndex,
        createAnalyticsEvent
    ]);
    const nextSlide = (0, $1oC0p.useCallback)(()=>{
        if (activeQuoteIndex < customerQuotes.length - 1) {
            setActiveQuoteIndex(activeQuoteIndex + 1);
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'nextSlide',
                source: 'customerQuoteCarousel',
                attributes: {
                    label: 'next slide'
                }
            }).fire();
        }
    }, [
        activeQuoteIndex,
        customerQuotes.length,
        createAnalyticsEvent
    ]);
    const intl = (0, $8e22h.default)();
    const logoSection = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: customerQuotes.map(({ companyLogo: companyLogo }, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": index !== activeQuoteIndex,
                className: (0, $2jatx.default)([
                    "_nd5lgbua _3um01xtx _1bsb11ux _4t3i1ylp"
                ]),
                style: {
                    "--_1sqyx0y": (0, $6ZVlx.default)(index === activeQuoteIndex ? 'visible' : 'hidden')
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: companyLogo[0]?.src,
                    alt: companyLogo[0]?.alt,
                    style: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        objectPosition: 'left'
                    }
                })
            }, index))
    });
    const quoteSection = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9",
            "_tfwpidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
            quote: customerQuotes[activeQuoteIndex]?.quote,
            authorName: customerQuotes[activeQuoteIndex]?.advocateName,
            authorDetails: customerQuotes[activeQuoteIndex]?.advocateJobTitle
        })
    });
    const legacyNavigationButtons = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _zulputpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: prevSlide,
                disabled: activeQuoteIndex === 0,
                "aria-label": intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.previousSlide),
                className: (0, $2jatx.default)([
                    "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1ygb1qgu _1ah3yh40 _1x1a73ad _v42d73ad _1tc8lkxj _64781qc2"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                    "--_1px5u0o": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1000')),
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3izwfg _1bsbzwfg _bfhk7ga5 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31ezn"
                    ]),
                    style: {
                        "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400')),
                        "--_xluqsf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark500'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                        label: intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.previousSlide)
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_cg411fu5 _125x1fu5 _1tjq1fu5",
                    "_1bsb183y _1mouidpf"
                ]),
                style: {
                    "--_1q70ahv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1000'))
                },
                children: `${activeQuoteIndex + 1}/${customerQuotes.length}`
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: nextSlide,
                disabled: activeQuoteIndex === customerQuotes.length - 1,
                "aria-label": intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.nextSlide),
                className: (0, $2jatx.default)([
                    "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1ygb1qgu _1ah3yh40 _1x1a73ad _v42d73ad _1tc8lkxj _64781qc2"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                    "--_1px5u0o": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1000')),
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3izwfg _1bsbzwfg _bfhk7ga5 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31ezn"
                    ]),
                    style: {
                        "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400')),
                        "--_xluqsf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark500'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                        label: intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.nextSlide)
                    })
                })
            })
        ]
    });
    if (isWacRefresh) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_nd5lgbua",
                    "_1yt4xy5q _15tx1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _4t3i1ns9",
                        "_1q5188uy"
                    ]),
                    children: customerQuotes.map((customerQuote, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_nd5lgbua",
                                "_3um015vq",
                                "_tfwpidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                                quote: customerQuote.quote,
                                authorName: customerQuote.advocateName,
                                authorDetails: customerQuote.advocateJobTitle
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rko1ylz _bfhkk553 _1yt4xy5q _4t3i1ns9 _1e0c1txw _2lx21bp4 _zulp1ejb _15tx1ejb",
                    "_2rkogktf _bfhk1afi _1yt4oahv _15tx1ejb",
                    "_cg411x3z _125x1x3z _1tjq1x3z",
                    "_nd5lgbua"
                ]),
                style: {
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulp1ejb _9959vrvc _a64koahv"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb11ux _1y9l1fhb"
                                ]),
                                children: logoSection
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
                                ]),
                                children: quoteSection
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bahesu3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bwWCK.GalleryControls), {
                            showCounter: true,
                            currentCount: activeQuoteIndex + 1,
                            totalCount: customerQuotes.length,
                            onPrevious: ()=>setActiveQuoteIndex(activeQuoteIndex - 1),
                            onNext: ()=>setActiveQuoteIndex(activeQuoteIndex + 1),
                            size: "small"
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_nd5lgbua",
                    "_1yt4xy5q _15tx1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _4t3i1ns9",
                        "_1q5188uy"
                    ]),
                    children: customerQuotes.map((customerQuote, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_nd5lgbua",
                                "_3um015vq",
                                "_tfwpidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                                quote: customerQuote.quote,
                                authorName: customerQuote.advocateName,
                                authorDetails: customerQuote.advocateJobTitle
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rko1ylz _bfhkk553 _1yt4xy5q _4t3i1ns9 _1e0c1txw _2lx21bp4 _zulp1ejb _15tx1ejb",
                    "_cg411fu5 _125x1fu5 _1tjq1fu5",
                    "_nd5lgbua"
                ]),
                style: {
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100')),
                    "--_1q70ahv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1000'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1yb4 _4cvr1h6o"
                        ]),
                        children: [
                            logoSection,
                            legacyNavigationButtons
                        ]
                    }),
                    quoteSection
                ]
            })
        ]
    });
};
const $6e4e4b8ac7dd4aed$var$lightTextCss = null;
const $6e4e4b8ac7dd4aed$var$refreshTextCss = null;
const $6e4e4b8ac7dd4aed$var$carouselContainerCss = null;
const $6e4e4b8ac7dd4aed$var$refreshCarouselContainerCss = null;
const $6e4e4b8ac7dd4aed$var$refreshQuoteLayoutCss = null;
const $6e4e4b8ac7dd4aed$var$refreshLogoContainerCss = null;
const $6e4e4b8ac7dd4aed$var$refreshQuoteContentCss = null;
const $6e4e4b8ac7dd4aed$var$refreshControlsContainerCss = null;
const $6e4e4b8ac7dd4aed$var$logoAndButtonContainerCss = null;
const $6e4e4b8ac7dd4aed$var$gridCss = null;
const $6e4e4b8ac7dd4aed$var$overlapGridItemCss = null;
const $6e4e4b8ac7dd4aed$var$buttonsContainerCss = null;
const $6e4e4b8ac7dd4aed$var$slideNumberCss = null;
const $6e4e4b8ac7dd4aed$var$buttonCss = null;
const $6e4e4b8ac7dd4aed$var$chevronCirlceCss = null;
const $6e4e4b8ac7dd4aed$var$hiddenCarouselContainerCss = null;
const $6e4e4b8ac7dd4aed$var$hiddenQuoteCss = null;
const $6e4e4b8ac7dd4aed$var$visibilityHiddenCss = null;
const $6e4e4b8ac7dd4aed$var$overrideQuotePadding = null;

});

parcelRegister("jiDxV", function(module, exports) {
$parcel$export(module.exports, "LogosMarquee", function () { return $c23f1eb8211a66c2$export$143c39d1bfa1977e; });
/* logos-marquee.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $aKeh7 = parcelRequire("aKeh7");

var $1iN19 = parcelRequire("1iN19");

var $bSVv5 = parcelRequire("bSVv5");

var $jElRc = parcelRequire("jElRc");

var $kbpa7 = parcelRequire("kbpa7");

var $i4BST = parcelRequire("i4BST");
const $c23f1eb8211a66c2$var$Logo = ({ src: src, href: href, alt: alt, ariaHidden: ariaHidden, tabIndex: tabIndex, isWacRefresh: isWacRefresh })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'connectorLogo',
            source: 'connector',
            attributes: {
                label: alt
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        alt
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        "aria-hidden": ariaHidden,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: href,
            tabIndex: tabIndex,
            onClick: handleClick,
            className: (0, $2jatx.default)([
                "_1e0c1txw _bfhkk553 _2rko1ylz _1bah1h6o _4cvr1h6o _1ygb1qgu _1ah3yh40 _tnruys9h _1rfmys9h",
                isWacRefresh ? "_bfhk1afi _2rko1tcg _1pfht94y _1dbz130s" : "_irr3vkha"
            ]),
            style: {
                "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100')),
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3i1wqb _1bsb1wqb _19pk19bv _2hwx19bv _otyr19bv _18u019bv",
                    isWacRefresh && "_4t3i8ved _1bsb8ved _1h1tkb7n _19pk1trj _2hwx1trj _otyr1trj _18u01trj _1kne8vuz _1s4p8vuz _3wvk1crf _1fbn1crf _1uby1crf _1t0r1crf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: src,
                    alt: alt,
                    style: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                    }
                })
            })
        })
    });
};
const $c23f1eb8211a66c2$export$143c39d1bfa1977e = ({ mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    // Default to true (running); correct to false after mount if the user prefers reduced motion.
    // We do this in useEffect (not useState initializer) to avoid SSR/hydration mismatches,
    // since window.matchMedia is not available on the server.
    const [running, setRunning] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) setRunning(false);
    }, []);
    tabletLogos = tabletLogos?.length === 0 ? desktopLogos : tabletLogos;
    mobileLogos = mobileLogos?.length === 0 ? desktopLogos : mobileLogos;
    const mobileLogosLength = (mobileLogos ?? []).length;
    const tabletLogosLength = (tabletLogos ?? []).length;
    const desktopLogosLength = desktopLogos.length;
    const safeMobileLogos = mobileLogos ?? [];
    mobileLogos = [
        ...safeMobileLogos,
        ...safeMobileLogos,
        ...safeMobileLogos,
        ...safeMobileLogos
    ];
    const safeTabletLogos = tabletLogos ?? [];
    tabletLogos = [
        ...safeTabletLogos,
        ...safeTabletLogos,
        ...safeTabletLogos,
        ...safeTabletLogos
    ];
    desktopLogos = [
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos
    ];
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handlePlayPauseClick = (0, $1oC0p.useCallback)(()=>{
        const next = !running;
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'marqueePlayPause',
            source: 'connector',
            attributes: {
                label: next ? 'play' : 'pause'
            }
        }).fire();
        setRunning(next);
    }, [
        running,
        createAnalyticsEvent
    ]);
    const pauseLabel = intl.formatMessage({
        id: 'connector-logo-marquee.pause',
        defaultMessage: 'Pause'
    });
    const playLabel = intl.formatMessage({
        id: 'connector-logo-marquee.play',
        defaultMessage: 'Play'
    });
    const playPauseButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _1e0c1txw _1bahh9n0 _85i51b66"
            ]),
            children: isWacRefresh ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                isPlaying: running,
                onToggle: ()=>setRunning((r)=>!r),
                mediaLabel: intl.formatMessage({
                    id: 'connector-logo-marquee.media-label',
                    defaultMessage: 'connector logos'
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handlePlayPauseClick,
                "aria-pressed": running,
                "aria-label": running ? pauseLabel : playLabel,
                className: (0, $2jatx.default)([
                    "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _1reoewfl _18m9ewfl _d0altlke _1ygb1qgu _1ah3yh40"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3izwfg _1bsbzwfg _bfhk7ga5 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31ezn _1tjq1fu5"
                    ]),
                    style: {
                        "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400')),
                        "--_xluqsf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark500')),
                        "--_1q70ahv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1000'))
                    },
                    children: running ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aKeh7))), {
                        label: pauseLabel
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iN19))), {
                        label: playLabel
                    })
                })
            })
        })
    });
    const logosList = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12f1s5k _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1reo15vq _1rjc1b66"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _o5721q9c",
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                    "_y44vc8cz _1y0c14a9",
                    "_16uvtrqk",
                    "_181nglyw",
                    isWacRefresh && "_1q511b66 _85i5pxbi"
                ]),
                style: {
                    "--_gus6x6": (0, $6ZVlx.default)(running ? 'running' : 'paused')
                },
                children: mobileLogos.map((logo, index)=>{
                    const isOriginal = index < mobileLogosLength;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c23f1eb8211a66c2$var$Logo, {
                        ariaHidden: !isOriginal,
                        tabIndex: isOriginal ? 0 : -1,
                        isWacRefresh: isWacRefresh,
                        ...logo
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _o5721q9c",
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                    "_y44v7abo _1y0c14a9",
                    "_16uvtrqk",
                    "_dm25glyw _sugaglyw",
                    isWacRefresh && "_1q511b66 _85i5pxbi"
                ]),
                style: {
                    "--_gus6x6": (0, $6ZVlx.default)(running ? 'running' : 'paused')
                },
                children: tabletLogos.map((logo, index)=>{
                    const isOriginal = index < tabletLogosLength;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c23f1eb8211a66c2$var$Logo, {
                        ariaHidden: !isOriginal,
                        tabIndex: isOriginal ? 0 : -1,
                        isWacRefresh: isWacRefresh,
                        ...logo
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _o5721q9c",
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                    "_y44vhu9l _1y0c14a9",
                    "_16uvtrqk",
                    "_1mjbglyw",
                    isWacRefresh && "_1q511b66 _85i5pxbi"
                ]),
                style: {
                    "--_gus6x6": (0, $6ZVlx.default)(running ? 'running' : 'paused')
                },
                children: desktopLogos.map((logo, index)=>{
                    const isOriginal = index < desktopLogosLength;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c23f1eb8211a66c2$var$Logo, {
                        ariaHidden: !isOriginal,
                        tabIndex: isOriginal ? 0 : -1,
                        isWacRefresh: isWacRefresh,
                        ...logo
                    }, index);
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m9ewfl _kqswh2mm _1e0c1txw _2lx21bp4 _zulputpp"
        ]),
        children: [
            logosList,
            playPauseButton
        ]
    });
};
const $c23f1eb8211a66c2$var$linkCss = null;
const $c23f1eb8211a66c2$var$nonRefreshLinkHoverCss = null;
const $c23f1eb8211a66c2$var$refreshLinkCss = null;
const $c23f1eb8211a66c2$var$logoCss = null;
const $c23f1eb8211a66c2$var$refreshLogoCss = null;
const $c23f1eb8211a66c2$var$listCss = null;
const $c23f1eb8211a66c2$var$refreshListPaddingCss = null;
const $c23f1eb8211a66c2$var$marqueeContainerCss = null;
const $c23f1eb8211a66c2$var$marqueeButtonContainerCss = null;
const $c23f1eb8211a66c2$var$marqueeButtonCss = null;
const $c23f1eb8211a66c2$var$buttonCirlceCss = null;
const $c23f1eb8211a66c2$var$listContainerCss = null;
const $c23f1eb8211a66c2$var$animationKeyframesCss = null;
const $c23f1eb8211a66c2$var$pauseOnHoverCss = null;
const $c23f1eb8211a66c2$var$desktopCss = null;
const $c23f1eb8211a66c2$var$tabletCss = null;
const $c23f1eb8211a66c2$var$mobileCss = null;

});



parcelRegister("8MWwK", function(module, exports) {
$parcel$export(module.exports, "containerTrackability", function () { return $a017d13ccc1f2d6e$export$63feb3e4596bc8ab; });
$parcel$export(module.exports, "default", function () { return $a017d13ccc1f2d6e$export$2e2bcd8739ae039; });
/* container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");

var $lTkkF = parcelRequire("lTkkF");

var $eOIix = parcelRequire("eOIix");

var $6ltia = parcelRequire("6ltia");

var $i4BST = parcelRequire("i4BST");
const $a017d13ccc1f2d6e$export$63feb3e4596bc8ab = {
    selector: '[data-uniform-container-id]',
    getKey: (el)=>el.getAttribute('data-uniform-container-id'),
    intersectionThreshold: 0
};
const $a017d13ccc1f2d6e$var$UniformContainer = ({ spacing: spacing, horizontalAlignment: horizontalAlignment = 'default', verticalAlignment: verticalAlignment = 'default', orientation: orientation = {
    mobile: 'vertical'
}, gapv2: gapv2 = {
    mobile: '0'
}, hat: hat, pants: pants, backgroundColor: backgroundColor = 'transparent', extendBackgroundColor: extendBackgroundColor, backgroundImageUrl: backgroundImageUrl, backgroundImageFit: backgroundImageFit = 'cover', backgroundImagePosition: backgroundImagePosition = 'center', position: position, sticky: sticky = false, stickyOnPage: stickyOnPage = false, roundedCorners: roundedCorners = false, responsiveHiding: responsiveHiding, overflow: overflow = 'visible', tagType: Component = 'div', maxWidth: maxWidth, darkTheme: darkTheme = false, id: id })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const spacingObject = {
        mobile: {
            marginTop: spacing?.mobile?.marginTop ?? '0',
            marginBottom: spacing?.mobile?.marginBottom ?? '0',
            marginLeft: spacing?.mobile?.marginLeft ?? '0',
            marginRight: spacing?.mobile?.marginRight ?? '0',
            paddingTop: spacing?.mobile?.paddingTop ?? '0',
            paddingBottom: spacing?.mobile?.paddingBottom ?? '0',
            paddingLeft: spacing?.mobile?.paddingLeft ?? '0',
            paddingRight: spacing?.mobile?.paddingRight ?? '0'
        },
        tablet: {
            marginTop: spacing?.tablet?.marginTop ?? spacing?.mobile?.marginTop ?? '0',
            marginBottom: spacing?.tablet?.marginBottom ?? spacing?.mobile?.marginBottom ?? '0',
            marginLeft: spacing?.tablet?.marginLeft ?? spacing?.mobile?.marginLeft ?? '0',
            marginRight: spacing?.tablet?.marginRight ?? spacing?.mobile?.marginRight ?? '0',
            paddingTop: spacing?.tablet?.paddingTop ?? spacing?.mobile?.paddingTop ?? '0',
            paddingBottom: spacing?.tablet?.paddingBottom ?? spacing?.mobile?.paddingBottom ?? '0',
            paddingLeft: spacing?.tablet?.paddingLeft ?? spacing?.mobile?.paddingLeft ?? '0',
            paddingRight: spacing?.tablet?.paddingRight ?? spacing?.mobile?.paddingRight ?? '0'
        },
        desktop: {
            marginTop: spacing?.desktop?.marginTop ?? spacing?.tablet?.marginTop ?? spacing?.mobile?.marginTop ?? '0',
            marginBottom: spacing?.desktop?.marginBottom ?? spacing?.tablet?.marginBottom ?? spacing?.mobile?.marginBottom ?? '0',
            marginLeft: spacing?.desktop?.marginLeft ?? spacing?.tablet?.marginLeft ?? spacing?.mobile?.marginLeft ?? '0',
            marginRight: spacing?.desktop?.marginRight ?? spacing?.tablet?.marginRight ?? spacing?.mobile?.marginRight ?? '0',
            paddingTop: spacing?.desktop?.paddingTop ?? spacing?.tablet?.paddingTop ?? spacing?.mobile?.paddingTop ?? '0',
            paddingBottom: spacing?.desktop?.paddingBottom ?? spacing?.tablet?.paddingBottom ?? spacing?.mobile?.paddingBottom ?? '0',
            paddingLeft: spacing?.desktop?.paddingLeft ?? spacing?.tablet?.paddingLeft ?? spacing?.mobile?.paddingLeft ?? '0',
            paddingRight: spacing?.desktop?.paddingRight ?? spacing?.tablet?.paddingRight ?? spacing?.mobile?.paddingRight ?? '0'
        }
    };
    const marginStyles = null;
    const paddingStyles = null;
    (0, $1oC0p.useEffect)(()=>{
        (0, $lTkkF.updateStickyNavOffset)();
    }, []);
    const hiddenMobileStyle = null;
    const hiddenTabletStyle = null;
    const hiddenDesktopStyle = null;
    // determine text color based on background color luminance
    const getTextColor = (bgColor)=>{
        if (!bgColor || bgColor === 'transparent') return undefined;
        try {
            // white text for dark backgrounds, dark text for light backgrounds
            return (0, $6ltia.isDarkColor)(bgColor) ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.primary.black');
        } catch (error) {
            // invalid color format, return undefined to use default
            console.error('Invalid backgroundColor format:', bgColor, error);
            return undefined;
        }
    };
    const textColor = getTextColor(backgroundColor);
    const colorStyle = null;
    // Map backgroundImageFit to the corresponding CSS background-size value
    const backgroundSizeMap = {
        cover: 'cover',
        contain: 'contain',
        fill: '100% 100%'
    };
    const backgroundImageInlineStyle = backgroundImageUrl ? {
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: backgroundSizeMap[backgroundImageFit],
        backgroundRepeat: 'no-repeat',
        backgroundPosition: backgroundImagePosition
    } : undefined;
    const gapObject = {
        mobile: gapv2.mobile ?? '0',
        tablet: gapv2?.tablet ?? gapv2.mobile ?? '0',
        desktop: gapv2?.desktop ?? gapv2?.tablet ?? gapv2.mobile ?? '0'
    };
    const innerStyle = null;
    const innerStyleFullHeight = null;
    const orientationObject = {
        mobile: orientation.mobile || 'vertical',
        tablet: orientation?.tablet || orientation.mobile || 'vertical',
        desktop: orientation?.desktop || orientation?.tablet || orientation.mobile || 'vertical'
    };
    const orientationStyle = null;
    const verticalAlignmentValue = verticalAlignment === 'center' ? 'center' : verticalAlignment === 'end' ? 'flex-end' : 'flex-start';
    const horizontalAlignmentValue = horizontalAlignment === 'center' ? 'center' : horizontalAlignment === 'start' ? 'flex-start' : horizontalAlignment === 'end' ? 'flex-end' : 'initial';
    const hiddenOnMobile = responsiveHiding?.includes('mobile');
    const hiddenOnTablet = responsiveHiding?.includes('tablet');
    const hiddenOnDesktop = responsiveHiding?.includes('desktop');
    const overflowStyle = null;
    const outerHeightFullStyle = null;
    const responsiveSectionDividerHeightsStyles = null;
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsbauwl _4t3i1cn3 _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _11q7183s",
            isWacRefresh && "_6ru5u57m _1i7q1hy1",
            roundedCorners && !hat && !pants && "_2rko1ylz _1reo15vq _18m915vq",
            hat && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6k183s",
            hat && "_1cs8h2mm _iajm18y9",
            hat && hat === 'high-right' ? "_tgsmkyn1" : hat === 'high-left' ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2183s",
            pants && "_18poh2mm _19nq1osq",
            pants && hat && "_18poh2mm _19nq1e6p",
            pants && pants === 'high-right' ? "_1oj4snn3" : pants === 'high-left' ? "_1oj4df5m" : "_1oj41mhh"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)(Component, {
        "data-uniform-container-id": id,
        className: (0, $2jatx.default)([
            "_vhvkte8j _wsfy5ydn _11nb1pej _tqhl1w1x _9s88xx3z _1rcble4j",
            "_1pfhay9a _6rthyezj _ahbq1xj8 _12l2v458 _kiya1bo5 _1ob910fp _1ywm13zu _1lva1jbi _1mt19hm1 _1tnt3yxk _3l1adckb _161b1kto",
            backgroundColor !== 'transparent' && "_1hooaxbu _1qgo1u00 _q3s11u00",
            verticalAlignment === 'end' && "_4t3i1osq",
            hat && !extendBackgroundColor && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6k183s",
            hat && !extendBackgroundColor && hat === 'high-right' ? "_tgsmkyn1" : hat === 'high-left' ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && !extendBackgroundColor && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2183s",
            pants && !extendBackgroundColor && pants === 'high-right' ? "_1oj4snn3" : pants === 'high-left' ? "_1oj4df5m" : "_1oj41mhh",
            hiddenOnMobile && "_sugaglyw",
            hiddenOnTablet && "_kzviglyw",
            hiddenOnDesktop && "_dm25glyw",
            "_1idncgrn",
            extendBackgroundColor && "_kqswh2mm",
            extendBackgroundColor && hat && "_1q511m3o",
            extendBackgroundColor && pants && "_85i51aiy",
            stickyOnPage && "_kqsw1if8 _152txohi _1pbyqfx8"
        ]),
        style: {
            ...backgroundImageInlineStyle,
            "--_1qkf21h": (0, $6ZVlx.default)(hat ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).mobile}px` : '0px'),
            "--_lmjtl5": (0, $6ZVlx.default)(pants ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).mobile}px` : '0px'),
            "--_1gqad6k": (0, $6ZVlx.default)(hat ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).tablet}px` : '0px'),
            "--_j464eu": (0, $6ZVlx.default)(pants ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).tablet}px` : '0px'),
            "--_1dzqs6e": (0, $6ZVlx.default)(hat ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).desktop}px` : '0px'),
            "--_10c1sh1": (0, $6ZVlx.default)(pants ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).desktop}px` : '0px'),
            "--_i49o2x": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.mobile.marginTop + ')'),
            "--_1u8kr0x": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.mobile.marginBottom + ')'),
            "--_rxekxp": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.mobile.marginLeft + ')'),
            "--_1trmegb": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.mobile.marginRight + ')'),
            "--_1topwr4": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.tablet.marginTop + ')'),
            "--_1bmyg5e": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.tablet.marginBottom + ')'),
            "--_f4ug91": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.tablet.marginLeft + ')'),
            "--_dtmbeo": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.tablet.marginRight + ')'),
            "--_6z2ii8": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.desktop.marginTop + ')'),
            "--_1riunu3": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.desktop.marginBottom + ')'),
            "--_77qsd2": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.desktop.marginLeft + ')'),
            "--_g1mpdd": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.desktop.marginRight + ')'),
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_srel9g": (0, $6ZVlx.default)(textColor),
            "--_lyok2l": (0, $6ZVlx.default)(overflow)
        },
        children: [
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q7183s _1bsb1osq _1e0c1txw _zulp17fv _19wg1im9 _pdlm1bxm",
                    verticalAlignment === 'end' && "_4t3i1osq",
                    extendBackgroundColor && "_bfhk1j28 _kqswh2mm _1pbykb7n",
                    "_1q511hrc _85i51jqd _bozg13hb _y4ti1q91 _1wafaauy _1yd3zu98 _1wfqhhsa _15vtzvlj _26vxeqr1 _40tu1ffz _d2ik43nl _exxmmjh9",
                    "_1e0c1txw _2lx21luv _1lp71gkj _1ini19q3",
                    orientationObject.mobile === 'horizontal' && "_4cvrop21 _1bah8u0b",
                    orientationObject.tablet === 'horizontal' && "_q8t5op21 _e8gh8u0b",
                    orientationObject.desktop === 'horizontal' && "_1jsvop21 _msup8u0b",
                    orientationObject.mobile === 'vertical' && "_4cvr8u0b _1bahop21",
                    orientationObject.tablet === 'vertical' && "_q8t58u0b _e8ghop21",
                    orientationObject.desktop === 'vertical' && "_1jsv8u0b _msupop21",
                    position && "_kqsw1fhc",
                    sticky && "_kqsw1if8 _152txohi",
                    roundedCorners && "_2rko1ylz _1reo15vq _18m915vq",
                    maxWidth && "_p12fd0ge _195g1wug"
                ]),
                style: {
                    "--_1lzn2ck": (0, $6ZVlx.default)('var(--ds-space-' + gapObject.mobile + ')'),
                    "--_9e7v2h": (0, $6ZVlx.default)('var(--ds-space-' + gapObject.tablet + ')'),
                    "--_1xgygbw": (0, $6ZVlx.default)('var(--ds-space-' + gapObject.desktop + ')'),
                    "--_1tmv8sa": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.mobile.paddingTop + ')'),
                    "--_1pcetbt": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.mobile.paddingBottom + ')'),
                    "--_u5v9xl": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.mobile.paddingLeft + ')'),
                    "--_9ot35z": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.mobile.paddingRight + ')'),
                    "--_17n4a40": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.tablet.paddingTop + ')'),
                    "--_13ma6th": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.tablet.paddingBottom + ')'),
                    "--_1qfxe96": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.tablet.paddingLeft + ')'),
                    "--_12ip1ci": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.tablet.paddingRight + ')'),
                    "--_8stuxx": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.desktop.paddingTop + ')'),
                    "--_rvldli": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.desktop.paddingBottom + ')'),
                    "--_1vmns7v": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.desktop.paddingLeft + ')'),
                    "--_12wjhwl": (0, $6ZVlx.default)('var(--ds-space-' + spacingObject.desktop.paddingRight + ')'),
                    "--_1kdc6hg": (0, $6ZVlx.default)(orientationObject.mobile === 'horizontal' ? 'row' : 'column'),
                    "--_1tsuz96": (0, $6ZVlx.default)(orientationObject.tablet === 'horizontal' ? 'row' : 'column'),
                    "--_1m7tih1": (0, $6ZVlx.default)(orientationObject.desktop === 'horizontal' ? 'row' : 'column'),
                    "--_7phn4c": (0, $6ZVlx.default)(verticalAlignmentValue),
                    "--_7e5uq9": (0, $6ZVlx.default)(horizontalAlignmentValue),
                    "--_1ia45kk": (0, $6ZVlx.default)(position),
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_1oqf9ha": (0, $6ZVlx.default)(maxWidth)
                },
                children: darkTheme ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eOIix.ThemeProvider), {
                    isDarkEnabled: true,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                        name: "component"
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: "component"
                })
            })
        ]
    });
};
const $a017d13ccc1f2d6e$var$xlDesktopExtendedBackgroundColorStyle = null;
const $a017d13ccc1f2d6e$var$hatCommonStyle = null;
const $a017d13ccc1f2d6e$var$extendedBackgroundColorHatStyle = null;
const $a017d13ccc1f2d6e$var$hatHighLeft = null;
const $a017d13ccc1f2d6e$var$hatHighRight = null;
const $a017d13ccc1f2d6e$var$hatPolygon = null;
const $a017d13ccc1f2d6e$var$pantsCommonStyle = null;
const $a017d13ccc1f2d6e$var$extendedBackgroundColorPantsStyle = null;
const $a017d13ccc1f2d6e$var$extendedBackgroundColorPantsWithHatStyle = null;
const $a017d13ccc1f2d6e$var$pantsHighLeft = null;
const $a017d13ccc1f2d6e$var$pantsHighRight = null;
const $a017d13ccc1f2d6e$var$pantsPolygon = null;
const $a017d13ccc1f2d6e$var$roundedCornersStyle = null;
var $a017d13ccc1f2d6e$export$2e2bcd8739ae039 = $a017d13ccc1f2d6e$var$UniformContainer;

});

parcelRegister("5nbaa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d2a96969d170342b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $2axoc = parcelRequire("2axoc");

var $lTkkF = parcelRequire("lTkkF");

var $jQ0cd = parcelRequire("jQ0cd");
function $d2a96969d170342b$var$toHref(hrefProp) {
    if (!hrefProp) return '';
    if (hrefProp.type === 'email') return `mailto:${hrefProp.path}`;
    return hrefProp.path;
}
const $d2a96969d170342b$var$UniformContentBlock = (props)=>{
    const localizedLinkHref = (0, $jQ0cd.useLocalizedHref)($d2a96969d170342b$var$toHref(props.linkHref));
    const localizedButtonHref = (0, $jQ0cd.useLocalizedHref)($d2a96969d170342b$var$toHref(props.buttonHref));
    const callToActionProps = $d2a96969d170342b$var$transformCtaProps({
        ...props,
        linkHref: props.linkHref ? {
            path: localizedLinkHref
        } : undefined,
        buttonHref: props.buttonHref ? {
            path: localizedButtonHref
        } : undefined
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        title: props.title,
        text: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.text,
        titleAs: props.titleAs,
        titleAppearsAs: props.titleAppearsAs,
        anchorLinkId: props.anchorLinkId,
        logo: props.logo,
        eyebrow: props.eyebrow,
        alignment: props.alignment,
        callToActionProps: callToActionProps,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: props.imageAlt ?? ''
        } : undefined,
        imageAspectRatio: props.imageAspectRatio,
        spotIllustration: props.spotIllustrationUrl ? {
            src: props.spotIllustrationUrl,
            height: props.spotIllustrationHeight
        } : undefined,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                alt: props.iconAlt ?? '',
                paddingIncluded: props.iconPaddingIncluded
            }
        } : undefined,
        orientation: props.orientation,
        columns: props.columns,
        backgroundColor: props.backgroundColor,
        hat: props.hat,
        pants: props.pants
    });
};
function $d2a96969d170342b$var$transformCtaProps({ buttonHref: buttonHref, buttonLabel: buttonLabel, buttonVariant: buttonVariant, linkHref: linkHref, linkText: linkText, linkType: linkType }) {
    const isButton = !!buttonHref?.path && !!buttonLabel;
    const isLink = !!linkHref?.path && !!linkText;
    if (isButton || isLink) {
        const ctaProps = {
            button: isButton ? {
                href: buttonHref.path,
                dataEventProps: {
                    'data-product-key': 'uniform',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'contentBlock',
                    'data-event': 'clicked',
                    'data-label': buttonLabel
                }
            } : undefined,
            buttonText: buttonLabel ?? undefined,
            buttonVariant: buttonVariant ?? undefined,
            link: isLink ? {
                href: linkHref.path,
                text: linkText,
                type: linkType,
                dataEventProps: {
                    'data-product-key': 'uniform',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'contentBlock',
                    'data-event': 'clicked',
                    'data-label': linkText
                }
            } : undefined
        };
        return ctaProps;
    }
    return undefined;
}
var $d2a96969d170342b$export$2e2bcd8739ae039 = $d2a96969d170342b$var$UniformContentBlock;

});

parcelRegister("gQYRi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b941cbe43c103c23$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $foNCS = parcelRequire("foNCS");

var $17RBn = parcelRequire("17RBn");

var $kf4PU = parcelRequire("kf4PU");

var $9rnwe = parcelRequire("9rnwe");

var $66vFr = parcelRequire("66vFr");

var $2wD1w = parcelRequire("2wD1w");
const $b941cbe43c103c23$var$DEFAULT_CONTENTFUL_LOCALE = 'en-US';
const $b941cbe43c103c23$var$SUPPORTED_CONTENTFUL_LOCALES = new Set(Object.values((0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)));
const $b941cbe43c103c23$var$toContentfulLocale = (pageLocale)=>{
    if (!pageLocale) return $b941cbe43c103c23$var$DEFAULT_CONTENTFUL_LOCALE;
    const mapped = (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[pageLocale];
    if (mapped) return mapped;
    if ($b941cbe43c103c23$var$SUPPORTED_CONTENTFUL_LOCALES.has(pageLocale)) return pageLocale;
    return $b941cbe43c103c23$var$DEFAULT_CONTENTFUL_LOCALE;
};
const $b941cbe43c103c23$var$ContentfulGalleryContainer = ({ contentType: contentType = 'productTemplate' })=>{
    const intlLocale = (0, $17RBn.useLocale)();
    const { locale: contextLocale } = (0, $9rnwe.useWAEContext)();
    const locale = $b941cbe43c103c23$var$toContentfulLocale(contextLocale ?? intlLocale);
    const loadContentfulItems = (0, $1oC0p.useCallback)(({ loaded: loaded })=>(0, $2wD1w.getContentfulGalleryItems)({
            contentType: contentType,
            loaded: loaded,
            locale: locale
        }), [
        contentType,
        locale
    ]);
    const currentRegistration = (0, $1oC0p.useMemo)(()=>({
            loader: loadContentfulItems
        }), [
        loadContentfulItems
    ]);
    const { extraItems: extraItems } = (0, $66vFr.useBackfill)({
        seedCount: 0,
        loader: loadContentfulItems
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $foNCS.FilterableGalleryLoaderProvider), {
        currentRegistration: currentRegistration,
        extraItems: extraItems,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content"
        })
    });
};
var $b941cbe43c103c23$export$2e2bcd8739ae039 = $b941cbe43c103c23$var$ContentfulGalleryContainer;

});
parcelRegister("foNCS", function(module, exports) {
$parcel$export(module.exports, "FilterableGalleryLoaderProvider", function () { return $c182ab1694ebe7b9$export$cb57cc654ea9ab7; });
$parcel$export(module.exports, "useFilterableGalleryLoader", function () { return $c182ab1694ebe7b9$export$6b88636f926b4970; });
$parcel$export(module.exports, "useIsInsideLoaderProvider", function () { return $c182ab1694ebe7b9$export$1bb59d992149f403; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $c182ab1694ebe7b9$var$FilterableGalleryLoaderContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
// Module-level constant so the default is the SAME reference on every render.
// A `= []` default parameter allocates a fresh array on every call — when a
// caller (e.g. the gallery self-wrapping without a `contentfulGalleryContainer`)
// never passes `extraItems` explicitly, every render of this provider handed a
// new default array, which cascaded into consumers keyed on it by reference
// and re-triggered this provider's own state updates: a self-sustaining loop.
const $c182ab1694ebe7b9$var$DEFAULT_EXTRA_ITEMS = [];
const $c182ab1694ebe7b9$export$cb57cc654ea9ab7 = ({ children: children, currentRegistration: currentRegistration = null, extraItems: extraItems = $c182ab1694ebe7b9$var$DEFAULT_EXTRA_ITEMS })=>{
    // Owned internally so neither the container nor the standalone gallery has
    // to thread it through props; the gallery publishes, the search bar reads.
    const [galleryConfig, setGalleryConfig] = (0, $1oC0p.useState)(null);
    const value = (0, $1oC0p.useMemo)(()=>({
            currentRegistration: currentRegistration,
            extraItems: extraItems,
            galleryConfig: galleryConfig,
            registerGalleryConfig: setGalleryConfig
        }), [
        currentRegistration,
        extraItems,
        galleryConfig
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($c182ab1694ebe7b9$var$FilterableGalleryLoaderContext.Provider, {
        value: value,
        children: children
    });
};
const $c182ab1694ebe7b9$export$6b88636f926b4970 = ()=>(0, $1oC0p.useContext)($c182ab1694ebe7b9$var$FilterableGalleryLoaderContext);
const $c182ab1694ebe7b9$export$1bb59d992149f403 = ()=>(0, $1oC0p.useContext)($c182ab1694ebe7b9$var$FilterableGalleryLoaderContext) !== null;

});

parcelRegister("66vFr", function(module, exports) {
$parcel$export(module.exports, "useBackfill", function () { return $4a1cb0c0d46e1d62$export$c65af1cb6431e0ed; });

var $1oC0p = parcelRequire("1oC0p");
const $4a1cb0c0d46e1d62$export$c65af1cb6431e0ed = ({ seedCount: seedCount, loader: loader, keyExtractor: keyExtractor = $4a1cb0c0d46e1d62$var$defaultKeyExtractor })=>{
    const [state, setState] = (0, $1oC0p.useState)({
        extraItems: [],
        isLoading: false,
        error: null
    });
    const mountedRef = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const keyExtractorRef = (0, $1oC0p.useRef)(keyExtractor);
    keyExtractorRef.current = keyExtractor;
    const hasFetchedRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        hasFetchedRef.current = false;
        setState({
            extraItems: [],
            isLoading: false,
            error: null
        });
    }, [
        loader,
        seedCount
    ]);
    const fetch = (0, $1oC0p.useCallback)(async ()=>{
        if (!loader || hasFetchedRef.current) return;
        setState((prev)=>({
                ...prev,
                isLoading: true,
                error: null
            }));
        try {
            const extra = await loader({
                skip: seedCount,
                limit: 0,
                total: 0,
                loaded: seedCount
            });
            if (!mountedRef.current) return;
            hasFetchedRef.current = true;
            const seen = new Set();
            const deduped = extra.filter((item)=>{
                const key = keyExtractorRef.current(item);
                if (key === undefined) return true;
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
            setState({
                extraItems: deduped,
                isLoading: false,
                error: null
            });
        } catch (err) {
            if (!mountedRef.current) return;
            setState({
                extraItems: [],
                isLoading: false,
                error: err
            });
        }
    }, [
        loader,
        seedCount
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!loader) return;
        if (typeof requestIdleCallback !== 'undefined') {
            const id = requestIdleCallback(fetch);
            return ()=>cancelIdleCallback(id);
        }
        fetch();
    }, [
        fetch,
        loader
    ]);
    return state;
};
function $4a1cb0c0d46e1d62$var$defaultKeyExtractor(item) {
    if (typeof item !== 'object' || item === null) return undefined;
    const record = item;
    const sys = record['sys'];
    if (typeof sys === 'object' && sys !== null) {
        const id = sys['id'];
        if (typeof id === 'string') return id;
    }
    return undefined;
}

});

parcelRegister("2wD1w", function(module, exports) {
$parcel$export(module.exports, "getContentfulGalleryItems", function () { return $e132d2285c53e8e3$export$8a5165f5eef5e7ce; });

var $2iZII = parcelRequire("2iZII");

var $ezTvi = parcelRequire("ezTvi");

var $ixJzr = parcelRequire("ixJzr");
const $e132d2285c53e8e3$var$GQL_FETCH_LIMIT = 100;
const $e132d2285c53e8e3$var$contentfulGalleryDataSources = {
    productTemplate: {
        fetchPage: $e132d2285c53e8e3$var$fetchProductTemplatePage,
        mapItem: (item)=>(0, $ezTvi.mapTemplateItem)(item)
    }
};
const $e132d2285c53e8e3$export$8a5165f5eef5e7ce = async ({ contentType: contentType, loaded: loaded, locale: locale })=>{
    const dataSource = $e132d2285c53e8e3$var$contentfulGalleryDataSources[contentType];
    const cacheKey = $e132d2285c53e8e3$var$getCacheKey({
        contentType: contentType,
        loaded: loaded,
        locale: locale
    });
    const cached = $e132d2285c53e8e3$var$getWindowCache(cacheKey);
    if (cached) return cached;
    const firstPage = await dataSource.fetchPage({
        limit: $e132d2285c53e8e3$var$GQL_FETCH_LIMIT,
        skip: loaded,
        locale: locale
    });
    const allItems = firstPage.items.map(dataSource.mapItem);
    const remainingSkips = $e132d2285c53e8e3$var$getRemainingSkips({
        loaded: loaded,
        total: firstPage.total,
        limit: $e132d2285c53e8e3$var$GQL_FETCH_LIMIT
    });
    const remainingPages = await Promise.all(remainingSkips.map((skip)=>dataSource.fetchPage({
            limit: $e132d2285c53e8e3$var$GQL_FETCH_LIMIT,
            skip: skip,
            locale: locale
        })));
    for (const page of remainingPages)allItems.push(...page.items.map(dataSource.mapItem));
    $e132d2285c53e8e3$var$setWindowCache(cacheKey, allItems);
    return allItems;
};
async function $e132d2285c53e8e3$var$fetchProductTemplatePage({ limit: limit, skip: skip, locale: locale }) {
    const result = await (0, $2iZII.getContentfulGqlClient)().query((0, $ixJzr.allProductTemplatesQuery), {
        limit: limit,
        skip: skip,
        locale: locale
    }).toPromise();
    const collection = result.data?.productTemplateCollection;
    return {
        total: collection?.total ?? 0,
        items: collection?.items ?? []
    };
}
function $e132d2285c53e8e3$var$getRemainingSkips({ loaded: loaded, total: total, limit: limit }) {
    const skips = [];
    for(let skip = loaded + limit; skip < total; skip += limit)skips.push(skip);
    return skips;
}
function $e132d2285c53e8e3$var$getCacheKey({ contentType: contentType, loaded: loaded, locale: locale }) {
    return `__UTG_${contentType.toUpperCase()}_LOCALE_${locale}_FROM_${loaded}__`;
}
function $e132d2285c53e8e3$var$getWindowCache(key) {
    const cached = window[key];
    return Array.isArray(cached) ? cached : null;
}
function $e132d2285c53e8e3$var$setWindowCache(key, items) {
    window[key] = items;
}

});
parcelRegister("ezTvi", function(module, exports) {
$parcel$export(module.exports, "mapTemplateItem", function () { return $edb519131f937f33$export$48a2c256ae09d4f0; });
const $edb519131f937f33$var$toAssetEnvelope = (asset)=>asset ? {
        fields: {
            title: asset.title ?? '',
            description: asset.description ?? '',
            file: {
                url: asset.url ?? '',
                title: asset.title ?? ''
            }
        }
    } : null;
const $edb519131f937f33$var$toAssetEnvelopeArray = (assets)=>(assets ?? []).map($edb519131f937f33$var$toAssetEnvelope).filter($edb519131f937f33$var$isPresent);
const $edb519131f937f33$var$isPresent = (value)=>value !== null && value !== undefined;
/**
 * Maps the contributor union into the same resolved shape the SSR/Uniform fetch
 * produces, so search resolves the same `fields.contributor.*` paths on
 * backfilled and seed items.
 */ function $edb519131f937f33$var$mapContributor(contributor) {
    if (!contributor) return null;
    if (contributor.__typename === 'Author') return {
        fields: {
            authorNameExternal: contributor.authorNameExternal ?? '',
            organization: contributor.organization ? {
                fields: {
                    organizationNameExternal: contributor.organization.organizationNameExternal ?? ''
                }
            } : null
        }
    };
    if (contributor.__typename === 'CompanyNameInternal') return {
        fields: {
            organizationNameExternal: contributor.organizationNameExternal ?? ''
        }
    };
    return null;
}
function $edb519131f937f33$export$48a2c256ae09d4f0(item) {
    const categories = (item.categoryCollection?.items ?? []).filter($edb519131f937f33$var$isPresent).map((cat)=>({
            sys: {
                id: cat.sys.id
            },
            fields: {
                urlSlug: cat.urlSlug ?? '',
                categoryNameExternal: cat.categoryNameExternal ?? '',
                shortDescriptionOneLiner: cat.shortDescriptionOneLiner ?? ''
            }
        }));
    const products = (item.productCollection?.items ?? []).filter($edb519131f937f33$var$isPresent).map((prod)=>({
            sys: {
                id: prod.sys.id
            },
            fields: {
                internalTitle: prod.internalTitle ?? '',
                url: prod.url ?? '',
                productNameReference: {
                    fields: {
                        productName: prod.productNameReference?.productName ?? ''
                    }
                },
                icon: $edb519131f937f33$var$toAssetEnvelope(prod.icon)
            }
        }));
    return {
        sys: {
            id: item.sys.id
        },
        fields: {
            templateNameInternal: item.templateNameInternal ?? '',
            templateNameExternal: item.templateNameExternal ?? '',
            oneLinerHeadline: item.oneLinerHeadline ?? '',
            fullUrlSlug: item.fullUrlSlug ?? '',
            templateIcon: $edb519131f937f33$var$toAssetEnvelope(item.templateIcon),
            templateThumbnail: $edb519131f937f33$var$toAssetEnvelope(item.templateThumbnail),
            templatePreview: $edb519131f937f33$var$toAssetEnvelopeArray(item.templatePreviewCollection?.items),
            contributor: $edb519131f937f33$var$mapContributor(item.contributor),
            category: categories,
            product: products
        }
    };
}

});

parcelRegister("ixJzr", function(module, exports) {
$parcel$export(module.exports, "allProductTemplatesQuery", function () { return $21e67e04eb912a5d$export$487101c30f9a39d8; });

var $1dWiR = parcelRequire("1dWiR");
const $21e67e04eb912a5d$export$487101c30f9a39d8 = (0, $1dWiR.gql)`
	query allProductTemplates($limit: Int, $skip: Int, $locale: String!) {
		productTemplateCollection(limit: $limit, skip: $skip, locale: $locale) {
			total
			items {
				sys {
					id
				}
				templateNameInternal
				templateNameExternal
				oneLinerHeadline
				fullUrlSlug
				templateIcon {
					url
					title
				}
				templateThumbnail {
					url
					title
				}
				templatePreviewCollection(limit: 10) {
					items {
						url
						title
						description
					}
				}
				contributor {
					__typename
					... on Author {
						authorNameExternal
						organization {
							organizationNameExternal
						}
					}
					... on CompanyNameInternal {
						organizationNameExternal
					}
				}
				categoryCollection(limit: 10, locale: $locale) {
					items {
						sys {
							id
						}
						urlSlug
						categoryNameExternal
						shortDescriptionOneLiner
					}
				}
				productCollection(limit: 5, locale: $locale) {
					items {
						sys {
							id
						}
						internalTitle
						url
						productNameReference {
							productName
						}
						icon {
							url
							title
						}
					}
				}
			}
		}
	}
`;

});



parcelRegister("ijBWj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63970a701463a0fa$export$2e2bcd8739ae039; });
/* contextual-bandits-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $8e22h = parcelRequire("8e22h");

var $lr38U = parcelRequire("lr38U");

var $ik40B = parcelRequire("ik40B");

var $eY3N6 = parcelRequire("eY3N6");

var $7GVWk = parcelRequire("7GVWk");

var $kbpa7 = parcelRequire("kbpa7");

var $l7lLR = parcelRequire("l7lLR");

var $lzMuy = parcelRequire("lzMuy");

var $gIKKj = parcelRequire("gIKKj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $eRzlV = parcelRequire("eRzlV");

var $iSeHD = parcelRequire("iSeHD");

var $3o1l4 = parcelRequire("3o1l4");

var $iuMpt = parcelRequire("iuMpt");
const $63970a701463a0fa$var$WRAPPER_STYLES = null;
const $63970a701463a0fa$var$PANEL_STYLES = null;
const $63970a701463a0fa$var$PANEL_EXPANDED_STYLES = null;
// Inner row that keeps the panel name and the variant <select> side-by-side
// while the experiment-override toggle stacks beneath them.
const $63970a701463a0fa$var$PANEL_ROW_STYLES = null;
const $63970a701463a0fa$var$LABEL_STYLES = null;
const $63970a701463a0fa$var$SELECT_STYLES = null;
const $63970a701463a0fa$var$EXPERIMENT_TOGGLE_ROW_STYLES = null;
const $63970a701463a0fa$var$EXPERIMENT_TOGGLE_ROW_EXPANDED_STYLES = null;
const $63970a701463a0fa$var$EXPERIMENT_TOGGLE_LABEL_STYLES = null;
// Small native checkbox sized to fit alongside the existing variant <select>.
const $63970a701463a0fa$var$EXPERIMENT_TOGGLE_CHECKBOX_STYLES = null;
const $63970a701463a0fa$var$OVERRIDE_LOADING = 'loading';
const $63970a701463a0fa$var$OVERRIDE_DEFAULT = 'default';
const $63970a701463a0fa$var$getBootstrapAnonymousId = ()=>typeof window !== 'undefined' && window.featureGateBootstrapValues?.identifiers?.analyticsAnonymousId || '';
/**
 * Identity wrapper for `<UniformSlot>`. Renders whatever `items` array it is
 * given, in order. Used as the base wrapper when delegating selection to a
 * higher-level wrapper, and on the `default` slot.
 */ const $63970a701463a0fa$var$VariantSelector = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: props.items.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                children: item
            }, `variant-${index}`))
    });
/**
 * Renders the `variants` slot but slices its `items` array down to a single
 * entry by index, so only the chosen variant is mounted.
 */ const $63970a701463a0fa$var$renderChosenVariant = (chosenVariantIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "variants",
        wrapperComponent: (slotProps)=>$63970a701463a0fa$var$VariantSelector({
                ...slotProps,
                items: [
                    slotProps.items[chosenVariantIndex]
                ]
            })
    });
const $63970a701463a0fa$var$useIsEnrolledInExperiment = ({ experimentId: experimentId = '' })=>{
    const hasExperimentId = experimentId.length > 0;
    const experimentStatus = (0, $gIKKj.useExperiment)({
        experimentName: experimentId,
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            // Do not fire exposure when there is no experiment to expose to.
            fireExperimentExposure: hasExperimentId,
            typeGuard: (value)=>typeof value === 'boolean'
        },
        targeting: {
            // Skip targeting evaluation entirely when no experiment is set.
            cohort: ()=>hasExperimentId
        },
        metadata: {
            description: 'Contextual Bandits Experiment - configured in Uniform',
            expectedReleaseDate: 'unknown - configured in Uniform',
            expectedRuntime: 'unknown - configured in Uniform',
            context: {
                urls: []
            }
        }
    });
    return hasExperimentId && experimentStatus.type === 'enrolled' && experimentStatus.value;
};
const $63970a701463a0fa$var$toggleExperimentOverride = (setExperimentOverride)=>{
    setExperimentOverride((prev)=>!prev);
};
const $63970a701463a0fa$export$3481e485f0011626 = (date = new Date())=>{
    const hour = date.getHours();
    if (hour < 6) return 'night';
    if (hour < 12) return 'morning';
    if (hour < 18) return 'afternoon';
    return 'evening';
};
const $63970a701463a0fa$var$JSM_GRS_CONTEXT = {
    product: (0, $l7lLR.BANDITS_PRODUCT).JIRA,
    subproduct: 'servicemanagement',
    useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_JSM,
    resolveSubAnchor: $iuMpt.resolveSubAnchor,
    sendsPaidSearchContext: false
};
const $63970a701463a0fa$var$JIRA_PT_LOCALE_GRS_CONTEXT = {
    product: (0, $l7lLR.BANDITS_PRODUCT).JIRA,
    subproduct: 'software',
    useCase: (0, $l7lLR.BANDITS_USE_CASE).JIRA_PT_LOCALE
};
const $63970a701463a0fa$var$CONFLUENCE_GRS_CONTEXT = {
    product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
    subproduct: 'software',
    useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY,
    resolveSubAnchor: (0, $iuMpt.forwardSubAnchor),
    sendsPaidSearchContext: true
};
/**
 * `useCaseId` values this container can serve.
 *
 */ const $63970a701463a0fa$var$GRS_USE_CASE_REGISTRY = new Map([
    [
        (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_JSM,
        $63970a701463a0fa$var$JSM_GRS_CONTEXT
    ],
    [
        (0, $l7lLR.BANDITS_USE_CASE).JIRA_PT_LOCALE,
        $63970a701463a0fa$var$JIRA_PT_LOCALE_GRS_CONTEXT
    ],
    [
        (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY,
        $63970a701463a0fa$var$CONFLUENCE_GRS_CONTEXT
    ],
    [
        (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        $63970a701463a0fa$var$CONFLUENCE_GRS_CONTEXT
    ]
]);
const $63970a701463a0fa$var$SUPPORTED_USE_CASE_IDS = [
    ...$63970a701463a0fa$var$GRS_USE_CASE_REGISTRY.keys()
].join(', ');
const $63970a701463a0fa$export$67aafe3f166b203e = (useCaseId, isJiraPtLocaleGrsEnabled = false)=>{
    const isJiraPtLocaleUseCase = useCaseId === (0, $l7lLR.BANDITS_USE_CASE).JIRA_PT_LOCALE;
    if (isJiraPtLocaleUseCase && !isJiraPtLocaleGrsEnabled) return null;
    if (useCaseId === undefined || useCaseId === '') {
        console.error(`Contextual bandits container: no valid useCaseId supplied by the composition. Expected one of: ${$63970a701463a0fa$var$SUPPORTED_USE_CASE_IDS}. Skipping the GRS request.`);
        return null;
    }
    const context = $63970a701463a0fa$var$GRS_USE_CASE_REGISTRY.get(useCaseId);
    if (!context) {
        console.error(`Contextual bandits container: unknown useCaseId "${useCaseId}". Expected one of: ${$63970a701463a0fa$var$SUPPORTED_USE_CASE_IDS}. Skipping the GRS request.`);
        return null;
    }
    return context;
};
const $63970a701463a0fa$export$e752525805e171b2 = async ({ locale: // GRS locale format uses an underscore, matching the UIP query builder's
// default in utils/anchor-queries/get-bandits-contents.ts. Contentful locale
// codes are hyphenated ('en-US') — do not copy that spelling here.
locale = 'en_US', anonymousId: anonymousId, subAnchor: subAnchor, channel: channel = '', utmContent: utmContent = '', keyword: keyword, utmCampaign: utmCampaign, country: country, deviceType: deviceType, os: os, browser: browser, localTimeBucket: localTimeBucket, product: product = (0, $l7lLR.BANDITS_PRODUCT).JIRA, subproduct: subproduct = 'servicemanagement', useCase: useCase = (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_JSM } = {})=>{
    const aggClient = new (0, $lr38U.AGGClient)({
        gatewayUrl: (0, $eRzlV.isProduction)() ? 'https://www.atlassian.com/gateway/api/graphql' : 'https://wac.stg.internal.atlassian.com/gateway/api/graphql'
    });
    // JSON.stringify rather than bare "${...}" — these values originate in URL
    // query params, and sanitizeHtml strips tags but leaves quotes, so an
    // unescaped value could terminate the GraphQL string early. Output is
    // identical for ordinary values.
    const customFields = [
        `channel: ${JSON.stringify(channel)}`,
        `utmContent: ${JSON.stringify(utmContent)}`
    ];
    if (subAnchor !== undefined) customFields.unshift(`subAnchor: ${JSON.stringify(subAnchor)}`);
    // Paid-search fields are omitted entirely when undefined, so use cases that
    // do not use them keep their original custom context.
    if (keyword !== undefined) customFields.push(`keyword: ${JSON.stringify(keyword)}`);
    if (utmCampaign !== undefined) customFields.push(`utmCampaign: ${JSON.stringify(utmCampaign)}`);
    if (country !== undefined) customFields.push(`country: ${JSON.stringify(country)}`);
    if (deviceType !== undefined) customFields.push(`deviceType: ${JSON.stringify(deviceType)}`);
    if (os !== undefined) customFields.push(`os: ${JSON.stringify(os)}`);
    if (browser !== undefined) customFields.push(`browser: ${JSON.stringify(browser)}`);
    if (localTimeBucket !== undefined) customFields.push(`localTimeBucket: ${JSON.stringify(localTimeBucket)}`);
    const query = `
query GrsRecommendations {
  growthRecommendations {
    recommendations(
      context: {
        tenantId: "",
        product: "${product}",
        subproduct: "${subproduct}",
        containers: null,
        sessionId: "",
        locale: "${locale}",
        orgId: "",
        workspaceId: null,
        useCase: "${useCase}",
        anonymousId: "${anonymousId}",
        custom: {
          ${customFields.join(',\n          ')}
        }
      },
      first: 1,
      rerank: []
    ) {
      ... on GrowthRecRecommendations {
        data {
          entityId,
          reasons
        },
        context {
          sessionId
        }
      }
      ... on QueryError {
        identifier
        message
      }
    }
  }
}
`;
    const result = await aggClient.query(query, {});
    return result.data;
};
const $63970a701463a0fa$export$7ce221c9d38a72ee = (data)=>{
    const recommendations = data?.growthRecommendations?.recommendations;
    if (!recommendations) {
        console.error('No recommendations found in GRS response.');
        return [];
    }
    if (Array.isArray(recommendations.data)) return recommendations.data.map(({ entityId: entityId })=>entityId);
    console.error('Unknown response format for GRS recommendations', recommendations);
    return [];
};
const $63970a701463a0fa$export$79b9295c2df49376 = (data)=>data?.growthRecommendations?.recommendations?.context?.sessionId ?? null;
const $63970a701463a0fa$var$getVariantId = (variant)=>{
    const variantId = variant.parameters?.['id']?.value;
    return typeof variantId === 'string' ? variantId : null;
};
const $63970a701463a0fa$var$getBanditChosenIndex = (recommendationEntityIds, variantSlots)=>{
    const recommendationEntityId = recommendationEntityIds[0];
    if (!recommendationEntityId) return null;
    const matchingVariantIndex = variantSlots.findIndex((variant)=>$63970a701463a0fa$var$getVariantId(variant) === recommendationEntityId);
    return matchingVariantIndex >= 0 ? matchingVariantIndex : null;
};
const $63970a701463a0fa$var$UniformContextualBanditsContainer = (props)=>{
    const isProd = (0, $eRzlV.isProduction)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition?.data?._id;
    // Resolve the product from the current page's URL via UserContext, so GRS
    // data is keyed to whichever product page this container is rendered on.
    // May be undefined on pages with no resolvable product; in that case GRS
    // storage buckets the data under its "none" key. `product` is derived from
    // the stable page location, so `productKey` is stable for the page's lifetime.
    const { product: product } = (0, $7GVWk.useUserContext)();
    const productKey = product?.key;
    // Stable reference to the `variants` slot entries. Required so authors can
    // see how many variant candidates exist and so downstream selection logic
    // does not re-run on every render.
    const variantSlots = (0, $1oC0p.useMemo)(()=>props.component.slots?.['variants'] ?? [], [
        props.component.slots
    ]);
    const variantSlotsRef = (0, $1oC0p.useRef)(variantSlots);
    (0, $1oC0p.useEffect)(()=>{
        variantSlotsRef.current = variantSlots;
    }, [
        variantSlots
    ]);
    // Dev-only override. In production this stays at `OVERRIDE_DEFAULT` and the
    // <select> is never rendered, so the value has no effect.
    const [override, setOverride] = (0, $1oC0p.useState)($63970a701463a0fa$var$OVERRIDE_DEFAULT);
    const [isExperimentOverridden, setIsExperimentOverridden] = (0, $1oC0p.useState)(false);
    const [isPanelExpanded, setIsPanelExpanded] = (0, $1oC0p.useState)(false);
    const [banditRecommendationEntityIds, setBanditRecommendationEntityIds] = (0, $1oC0p.useState)([]);
    // True until the GRS recommendation request settles (client-side only). On
    // the server this stays true so the skeleton is what gets SSR'd, and the
    // client hydrates the same markup before swapping in the resolved variant —
    // avoiding a flash of the (often empty) default slot and layout shift.
    const [isLoadingRecommendation, setIsLoadingRecommendation] = (0, $1oC0p.useState)(true);
    const intl = (0, $8e22h.default)();
    const locale = intl.locale;
    const anonymousId = analyticsClient?.getAnonymousId() ?? $63970a701463a0fa$var$getBootstrapAnonymousId();
    const { data: personalizationValues } = (0, $3o1l4.useUserSegments)();
    // Resolved against the active use case's vocabulary inside the fetch effect —
    // which vocabulary applies depends on the gate, and the gate must not be read
    // during render (it would risk an SSR/hydration mismatch).
    const rawSubAnchor = personalizationValues?.[(0, $3o1l4.UserSegmentTypes).SUB_ANCHOR];
    const channel = personalizationValues?.[(0, $3o1l4.UserSegmentTypes).CHANNEL];
    const utmContent = personalizationValues?.[(0, $3o1l4.UserSegmentTypes).UTM_CONTENT];
    // Set by page-wrapper-streaming from parseRoute, so already `+`-decoded and
    // sanitised. Forwarded only for use cases whose context opts in.
    const keyword = personalizationValues?.[(0, $3o1l4.UserSegmentTypes).KEYWORD];
    const utmCampaign = personalizationValues?.[(0, $3o1l4.UserSegmentTypes).UTM_CAMPAIGN];
    const banditChosenIndex = (0, $1oC0p.useMemo)(()=>$63970a701463a0fa$var$getBanditChosenIndex(banditRecommendationEntityIds, variantSlots), [
        banditRecommendationEntityIds,
        variantSlots
    ]);
    const chosenVariantIndex = !isProd && override !== $63970a701463a0fa$var$OVERRIDE_DEFAULT && override !== $63970a701463a0fa$var$OVERRIDE_LOADING ? override : banditChosenIndex;
    const isEnrolledInExperiment = $63970a701463a0fa$var$useIsEnrolledInExperiment({
        experimentId: props.experimentId
    });
    const variantChosen = chosenVariantIndex !== null && variantSlots[chosenVariantIndex];
    const isEnrolledInExperimentPlusOverride = !props.experimentId || isEnrolledInExperiment || isExperimentOverridden && !isProd;
    const isNoContentSwapEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).personalizationNoContentSwap);
    const shouldRenderVariant = isEnrolledInExperimentPlusOverride && variantChosen;
    const renderedVariant = shouldRenderVariant ? $63970a701463a0fa$var$renderChosenVariant(chosenVariantIndex) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "default",
        wrapperComponent: $63970a701463a0fa$var$VariantSelector
    });
    // Optional, author-composed skeleton. The container is content-agnostic —
    // it doesn't know what the chosen variant will render — so the loading
    // placeholder is supplied as a Uniform slot rather than hard-coded here.
    // When no `loading` slot is authored this is empty and behaviour is
    // unchanged (the default slot renders during the request).
    const hasLoadingSlot = (props.component.slots?.['loading']?.length ?? 0) > 0;
    // Show the author-composed loading slot when either:
    //  - the GRS request is still in flight in the real flow and its result can
    //    change what renders — this is the only path that runs in production,
    //    where `override` is always `OVERRIDE_DEFAULT`. Behind the
    //    `wac_personalization_no_content_swap` gate, visitors outside the
    //    container's experiment (or when it is off) always get the default slot,
    //    so they go straight to it instead of seeing the skeleton first; or
    //  - a developer explicitly picks "loading" in the non-production override
    //    panel to preview the skeleton (forced, regardless of request state).
    // A specific variant/default override is honoured immediately and is never
    // masked by the in-flight skeleton, so the panel stays usable in the
    // Uniform preview even if the recommendation request never settles there.
    const showLoadingSlot = hasLoadingSlot && (override === $63970a701463a0fa$var$OVERRIDE_LOADING || override === $63970a701463a0fa$var$OVERRIDE_DEFAULT && isLoadingRecommendation && (!isNoContentSwapEnabled || isEnrolledInExperimentPlusOverride));
    const content = showLoadingSlot ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "loading",
        wrapperComponent: $63970a701463a0fa$var$VariantSelector
    }) : renderedVariant;
    (0, $1oC0p.useEffect)(()=>{
        // Guard against SSR — AGGClient makes a network call that should only
        // happen in the browser, where anonymousId/sessionId/etc. are available.
        if (typeof window === 'undefined') return;
        let cancelled = false;
        // eslint-disable-next-line complexity
        (async ()=>{
            let recommendationEntityIds = [];
            try {
                const isJiraPtLocaleGrsEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).d1d6JiraPTLocaleGrsFetcher);
                const grsContext = $63970a701463a0fa$export$67aafe3f166b203e(props.useCaseId, isJiraPtLocaleGrsEnabled);
                // Unrecognised useCaseId: skip the request rather than fetch for
                // the wrong surface. `finally` still clears the skeleton.
                if (!grsContext) return;
                const { product: product, subproduct: subproduct, useCase: useCase, sendsPaidSearchContext: sendsPaidSearchContext } = grsContext;
                const isJiraPtLocaleUseCase = useCase === (0, $l7lLR.BANDITS_USE_CASE).JIRA_PT_LOCALE;
                const deviceInfo = isJiraPtLocaleUseCase ? (0, $lzMuy.detectDeviceInfo)(window.navigator.userAgent, window.navigator.platform, window.navigator.maxTouchPoints) : undefined;
                const subAnchor = grsContext.resolveSubAnchor?.((window.subAnchor ? window.subAnchor : rawSubAnchor)?.toLowerCase());
                const response = await $63970a701463a0fa$export$e752525805e171b2({
                    locale: locale,
                    anonymousId: anonymousId,
                    subAnchor: subAnchor,
                    channel: channel,
                    utmContent: utmContent,
                    keyword: sendsPaidSearchContext ? keyword ?? '' : undefined,
                    utmCampaign: sendsPaidSearchContext ? utmCampaign ?? '' : undefined,
                    country: isJiraPtLocaleUseCase && isEnrolledInExperiment ? 'india' : undefined,
                    deviceType: deviceInfo?.deviceType,
                    os: deviceInfo?.os,
                    browser: deviceInfo?.browser,
                    localTimeBucket: isJiraPtLocaleUseCase ? $63970a701463a0fa$export$3481e485f0011626() : undefined,
                    product: product,
                    subproduct: subproduct,
                    useCase: (0, $ik40B.isInConfluenceCBSubAnchorCMSVariant)(window.cmsPageVariant ?? '') && useCase === (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY ? (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR : useCase
                });
                recommendationEntityIds = $63970a701463a0fa$export$7ce221c9d38a72ee(response);
                const recoSessionId = $63970a701463a0fa$export$79b9295c2df49376(response);
                if (recoSessionId) (0, $l7lLR.setGrsDataToLocalStorage)({
                    recoSessionId: recoSessionId,
                    recoEntityId: recommendationEntityIds[0] ?? ''
                }, productKey);
                if (!cancelled) setBanditRecommendationEntityIds(recommendationEntityIds);
            } catch (error) {
                console.error('Failed to fetch GRS recommendations', error);
            } finally{
                if (cancelled) return;
                // Request settled — stop showing the skeleton and reveal the
                // resolved variant (or default fallback).
                setIsLoadingRecommendation(false);
                const currentVariantSlots = variantSlotsRef.current;
                const resolvedChosenVariantIndex = $63970a701463a0fa$var$getBanditChosenIndex(recommendationEntityIds, currentVariantSlots);
                const resolvedVariant = resolvedChosenVariantIndex !== null ? currentVariantSlots[resolvedChosenVariantIndex] : undefined;
                const resolvedShouldRenderVariant = isEnrolledInExperimentPlusOverride && resolvedVariant;
                const resolvedSelectedVariantKey = resolvedShouldRenderVariant && resolvedVariant ? $63970a701463a0fa$var$getVariantId(resolvedVariant) ?? `variant_${resolvedChosenVariantIndex}` : 'default';
                if (analyticsClient) createAnalyticsEvent({
                    name: 'waeBanditVariantRender',
                    action: 'banditVariantRender',
                    actionSubject: 'uniformPage',
                    eventType: 'screen',
                    source: window.location.pathname,
                    attributes: {
                        containerName: props.name,
                        path: window.location.pathname,
                        compositionId: compositionId,
                        variantName: resolvedSelectedVariantKey,
                        status: resolvedSelectedVariantKey,
                        recommendations: recommendationEntityIds
                    }
                }).fire();
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        analyticsClient,
        anonymousId,
        channel,
        compositionId,
        createAnalyticsEvent,
        isEnrolledInExperiment,
        isEnrolledInExperimentPlusOverride,
        keyword,
        locale,
        productKey,
        props.name,
        props.useCaseId,
        rawSubAnchor,
        utmCampaign,
        utmContent,
        window.subAnchor
    ]);
    if (isProd) return content;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                onMouseEnter: ()=>setIsPanelExpanded(true),
                onMouseLeave: ()=>setIsPanelExpanded(false),
                onFocus: ()=>setIsPanelExpanded(true),
                onBlur: (event)=>{
                    if (!event.currentTarget.contains(event.relatedTarget)) setIsPanelExpanded(false);
                },
                className: (0, $2jatx.default)([
                    "_kqswstnw _152t1b66 _1e021b66 _1pbyrpof _1e0c116y _2lx21bp4 _4cvr1fhb _syaz15cr _19itidpf _2rkoftgi _p12fgx0z _1yt4jjoz _bfhkculw _18k91p0y _tzy4x7ai _v5641baa",
                    isPanelExpanded && "_bfhkculw _18k91m5u _tzy4kb7n _1yt412x7"
                ]),
                style: {
                    "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                        className: (0, $2jatx.default)([
                            "_1e0c116y _4cvr1h6o _gy1p1b66 _1ul9idpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1skh _vwz4cjiy _k48p1fw0 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1ul9idpf _p12f11ux"
                                ]),
                                children: props.name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                                "aria-label": `Contextual bandits variant override for ${props.useCaseId}`,
                                value: String(override),
                                onChange: (event)=>{
                                    const next = event.target.value;
                                    setOverride(next === $63970a701463a0fa$var$OVERRIDE_LOADING ? $63970a701463a0fa$var$OVERRIDE_LOADING : next === $63970a701463a0fa$var$OVERRIDE_DEFAULT ? $63970a701463a0fa$var$OVERRIDE_DEFAULT : Number(next));
                                },
                                className: (0, $2jatx.default)([
                                    "_19itidpf _2rkow7q6 _1yt41ppf _1wyb19bv _vwz4cjiy _k48p1fw0 _80omtlke _syazi7uo _bfhkvuon _1ygb7g83 _1ah3yh40"
                                ]),
                                children: [
                                    hasLoadingSlot && /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                        value: $63970a701463a0fa$var$OVERRIDE_LOADING,
                                        children: "loading"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                        value: $63970a701463a0fa$var$OVERRIDE_DEFAULT,
                                        children: "default"
                                    }),
                                    variantSlots.map((_, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("option", {
                                            value: index,
                                            children: [
                                                "variant ",
                                                index
                                            ]
                                        }, index))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": !isPanelExpanded,
                        className: (0, $2jatx.default)([
                            "_1reo15vq _18m915vq _c71lidpf _1pfhidpf _tzy4idpf _lcxvglyw _t9ecr915 _v564rl08",
                            isPanelExpanded && "_c71lzwfg _1pfhu2gc _tzy4kb7n _lcxv1wug _t9ec1kli"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                            title: props.experimentId ? `Force experiment "${props.experimentId}" to behave as enrolled in non-production environments. Does not affect real Statsig enrollment.` : 'No experimentId is configured on this contextual bandits container, so there is no experiment to override.',
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1wpz1fhb _1bah1yb4 _gy1pu2gc _1wyb1skh _vwz4cjiy _k48p1fw0 _80omtlke _uiztglyw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: "Experiment Override"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    type: "checkbox",
                                    "aria-label": `Force experiment enrollment override for ${props.useCaseId}`,
                                    disabled: !props.experimentId,
                                    checked: isExperimentOverridden,
                                    // Removed from the tab order while the row is
                                    // collapsed and visually hidden. Restored when the
                                    // panel is hovered / focused.
                                    tabIndex: isPanelExpanded ? 0 : -1,
                                    onChange: ()=>$63970a701463a0fa$var$toggleExperimentOverride(setIsExperimentOverridden),
                                    className: (0, $2jatx.default)([
                                        "_1bsb1crf _4t3i1crf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1j551ou4 _j5dh13gf _1ygb7g83 _1ah3yh40"
                                    ])
                                })
                            ]
                        })
                    })
                ]
            }),
            content
        ]
    });
};
var $63970a701463a0fa$export$2e2bcd8739ae039 = $63970a701463a0fa$var$UniformContextualBanditsContainer;

});
parcelRegister("iuMpt", function(module, exports) {
$parcel$export(module.exports, "resolveSubAnchor", function () { return $39ffeb9d9b5a2a17$export$6a32d8605cf89213; });
$parcel$export(module.exports, "forwardSubAnchor", function () { return $39ffeb9d9b5a2a17$export$917a48d9cd63212a; });
/**
 * Known GRS subanchor values for the `wacAnchorJourneyJsm` use case.
 *
 * The `subAnchor` forwarded to the recommendation query must be one of these
 * values. Anything that is not a known subanchor (case-insensitive) is mapped
 * to {@link DEFAULT_SUB_ANCHOR} so GRS always receives a recognised value.
 *
 * Kept as a standalone list so it can be edited or removed without touching the
 * container component.
 */ const $39ffeb9d9b5a2a17$export$5cb7a0b3cbee30ee = [
    'IT service management',
    'IT tools',
    'ITSM software',
    'IT management solutions',
    'IT request management',
    'ITIL process',
    'AI for service management',
    'IT incident management',
    'service desk tools',
    'service desk alternatives',
    'help desk tools',
    'IT support help desk',
    'customer support help desk',
    'ticketing tools',
    'customer support ticketing',
    'ticket tracking',
    'IT support ticketing',
    'ticketing help desk',
    'internal ticketing',
    'external ticketing',
    'workflow automation',
    'service management automation',
    'automation tools',
    'service management workflow',
    'enterprise service management',
    'hr service management',
    'finance service management',
    'service portal',
    'facilities service management',
    'marketing service management',
    'ServiceNow',
    'other competitors',
    'Freshservice',
    'BMC Remedy',
    'PagerDuty',
    'Ivanti',
    'ManageEngine',
    'Cherwell',
    'issue tracking',
    'devops tools',
    'incident management',
    'change management',
    'service mapping',
    'incident response',
    'customer service management tools',
    'customer support',
    'client relationship',
    'live chat',
    'marketing core terms',
    'engineering core terms',
    'operations core terms',
    'hr core terms',
    'design core terms',
    'legal core terms',
    'core terms',
    'jsm solution',
    'jsm it management',
    'jsm itsm',
    'jsm ticketing',
    'jsm service desk software',
    'jsm service desk',
    'jsm service desk for business',
    'jsm helpdesk',
    'jsm helpdesk tool',
    'jsm chamados software',
    'jsm chamados helpdesk software',
    'jsm trial',
    'jsm service desk trial',
    'jsm signup',
    'jsm service desk sign up',
    'jsm free',
    'jsm pricing',
    'jsm reviews',
    'jsm demo',
    'jsm alternatives',
    'jsm api',
    'jsm app',
    'jsm service download',
    'jsm service app',
    'jsm os',
    'jsm features',
    'jsm service tutorial',
    'jsm service desk os',
    'what is jsm?',
    'what is jsm service desk?',
    'it asset management',
    'form software',
    'it operations',
    'it design project management',
    'service optimization',
    'ai jsm',
    'misc.',
    'team communication',
    'jsm platform',
    'jsm product',
    'jsm offerings',
    'jsm editions',
    'jsm architecture',
    'jsm infrastructure',
    'jsm dashboard',
    'Default (catch all)',
    'jsm site'
];
const $39ffeb9d9b5a2a17$export$d15705f280ecbddb = 'Default (catch all)';
const $39ffeb9d9b5a2a17$export$4fd6a22ae8e6ac85 = (knownSubAnchors, fallback)=>{
    // Lower-cased set for O(1), case-insensitive membership checks. Built once
    // per resolver, not once per call.
    const knownSubAnchorsLowerCase = new Set(knownSubAnchors.map((knownSubAnchor)=>knownSubAnchor.toLowerCase()));
    return (subAnchor)=>{
        if (!subAnchor) return fallback;
        return knownSubAnchorsLowerCase.has(subAnchor.toLowerCase()) ? subAnchor : fallback;
    };
};
const $39ffeb9d9b5a2a17$export$6a32d8605cf89213 = $39ffeb9d9b5a2a17$export$4fd6a22ae8e6ac85($39ffeb9d9b5a2a17$export$5cb7a0b3cbee30ee, $39ffeb9d9b5a2a17$export$d15705f280ecbddb);
const $39ffeb9d9b5a2a17$export$917a48d9cd63212a = (subAnchor)=>subAnchor ?? '';

});


parcelRegister("Ms48M", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ce67b152ccdba354$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");
const $ce67b152ccdba354$var$UniformContextualBanditsVariant = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "content"
    });
};
var $ce67b152ccdba354$export$2e2bcd8739ae039 = $ce67b152ccdba354$var$UniformContextualBanditsVariant;

});

parcelRegister("91YSm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dc77856cf5148741$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $9ggmE = parcelRequire("9ggmE");
const $dc77856cf5148741$var$UniformCopyText = ({ text: text, buttonText: buttonText, copiedText: copiedText, copiedAriaLabel: copiedAriaLabel })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9ggmE.CopyText), {
        text: text,
        buttonText: buttonText,
        copiedText: copiedText,
        copiedAriaLabel: copiedAriaLabel
    });
};
var $dc77856cf5148741$export$2e2bcd8739ae039 = $dc77856cf5148741$var$UniformCopyText;

});
parcelRegister("9ggmE", function(module, exports) {
$parcel$export(module.exports, "CopyText", function () { return $7b3427ede50332f8$export$1d8a493107fb4b3a; });
/* copy-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $7b3427ede50332f8$var$containerStyles = null;
const $7b3427ede50332f8$var$textContainerStyles = null;
const $7b3427ede50332f8$var$textStyles = null;
const $7b3427ede50332f8$var$buttonContainerStyles = null;
const $7b3427ede50332f8$export$1d8a493107fb4b3a = ({ text: text, buttonText: buttonText = 'Copy code', copiedText: copiedText = 'Copied!', copiedAriaLabel: copiedAriaLabel = 'Copied to clipboard', colorAgainst: colorAgainst = 'black' })=>{
    const [copied, setCopied] = (0, $1oC0p.useState)(false);
    const handleCopy = (0, $1oC0p.useCallback)(async ()=>{
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    }, [
        text
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _zulppxbi _2lx21bp4 _4cvr1h6o _1bsb1osq _p12f1osl _181n11p5 _19wgidpf _1j8b1iv9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _yyhy10xb _1ii7183o _1ul9idpf _p12f1osq _1reo15vq _18m915vq _2rko1mv1 _bfhkvkha _19it15uy _1tke14no _1e0c1txw _4cvr1h6o _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _vchhusvi _1csazzfg _q7gq7vkz _zcqx1tcg _125xcj8d"
                ]),
                style: {
                    "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill')),
                    "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200')),
                    "--_xluqsf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark500')),
                    "--_1bik04v": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark900'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c _1reo15vq _18m915vq _aetrb3bt _18postnw _19nqidpf _1czd7vkz _1gufidpf _z0aiys9h _16r21ry6 _11fnglyw"
                    ]),
                    style: {
                        "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                    },
                    children: text
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_yyhybxw0 _1ii7183o _1pbykb7n _bfhkk553 _2rko1mv1"
                ]),
                style: {
                    "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100')),
                    "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                    variant: "secondary",
                    size: "large",
                    colorAgainst: colorAgainst,
                    onClick: handleCopy,
                    dataEventProps: {
                        'data-product-key': 'uniform',
                        'data-event-component': 'linkButton',
                        'data-event-container': 'copyText',
                        'data-event': 'clicked'
                    },
                    "aria-label": copied ? copiedAriaLabel : buttonText,
                    children: copied ? copiedText : buttonText
                })
            })
        ]
    });
};
var $7b3427ede50332f8$export$2e2bcd8739ae039 = $7b3427ede50332f8$export$1d8a493107fb4b3a;

});


parcelRegister("k1j8C", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1d848c7575b036e3$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $hGOQQ = parcelRequire("hGOQQ");
const $1d848c7575b036e3$var$fragmentWrapper = ({ items: items })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: items
    });
const $1d848c7575b036e3$var$UniformCustomTableCell = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hGOQQ.GenericTableCustomCell), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "contents",
            wrapperComponent: $1d848c7575b036e3$var$fragmentWrapper
        })
    });
};
var $1d848c7575b036e3$export$2e2bcd8739ae039 = $1d848c7575b036e3$var$UniformCustomTableCell;

});

parcelRegister("kEr7H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23264f0466262a10$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $2O9Y7 = parcelRequire("2O9Y7");

var $6XpQD = parcelRequire("6XpQD");

var $kDYqJ = parcelRequire("kDYqJ");
const $23264f0466262a10$var$UniformCustomerGallery = ({ items: items, isMotionAvailable: isMotionAvailable, motionDelay: motionDelay, motionForward: transformForward, motionBackward: transformBackward })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedItems = (0, $f2QWG.flattenValues)(items);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kDYqJ.GalleryContainer), {
        isMotionAvailable: isMotionAvailable,
        motionDelay: motionDelay,
        children: flattenedItems.map((item, index)=>{
            if (item) {
                if ('quote' in item) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "entry-item",
                    style: {
                        // @ts-expect-error -- CSS custom property not in CSSProperties type
                        '--gc-item-i': index
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2O9Y7.CustomerQuote), {
                        logoSrc: item.companyLogo?.at(0)?.src ?? '',
                        logoAlt: item.companyLogo?.at(0)?.alt ?? '',
                        name: item.advocateName ?? '',
                        title: item.advocateJobTitle ?? '',
                        company: item.companyName ?? '',
                        quote: item.quote ?? '',
                        ctaLinkText: item.ctaLinkText,
                        ctaLinkUrl: item.ctaUrl,
                        ctaLinkDataEventProps: item.ctaLinkText ? {
                            'data-event': 'clicked',
                            'data-event-component': 'linkButton',
                            'data-event-container': 'customersSection',
                            'data-product-key': 'uniform',
                            'data-label': item.ctaLinkText
                        } : undefined,
                        imageSrc: item.advocateHeadshot?.at(0)?.src,
                        imageAlt: item.advocateHeadshot?.at(0)?.alt,
                        color: item.color,
                        motionConfig: transformForward && transformBackward ? {
                            transformForward: transformForward,
                            transformBackward: transformBackward
                        } : undefined
                    })
                }, index);
                else if ('statNumber' in item) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "entry-item",
                    style: {
                        // @ts-expect-error -- CSS custom property not in CSSProperties type
                        '--gc-item-i': index
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6XpQD.CustomerStat), {
                        logoSrc: item.logo?.at(0)?.src ?? '',
                        logoAlt: item.logo?.at(0)?.alt ?? '',
                        statValue: item.statNumber?.toString() ?? '',
                        statModifier: item.statModifier,
                        description: item.description ?? '',
                        linkText: item.ctaText,
                        linkHref: item.ctaUrl,
                        linkDataEventProps: item.ctaText ? {
                            'data-event': 'clicked',
                            'data-event-component': 'linkButton',
                            'data-event-container': 'customersSection',
                            'data-product-key': 'uniform',
                            'data-label': item.ctaText
                        } : undefined,
                        color: item.color,
                        motionConfig: transformForward && transformBackward ? {
                            transformForward: transformForward,
                            transformBackward: transformBackward
                        } : undefined
                    })
                }, index);
            }
        })
    });
};
var $23264f0466262a10$export$2e2bcd8739ae039 = $23264f0466262a10$var$UniformCustomerGallery;

});
parcelRegister("2O9Y7", function(module, exports) {
$parcel$export(module.exports, "CustomerQuote", function () { return $a9e6bc4742132548$export$615b20b92b568a40; });
/* customer-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $z2rqa = parcelRequire("z2rqa");
const $a9e6bc4742132548$export$3855eab3480168d5 = (color)=>{
    const map = {
        blue: {
            quoteBackground: (0, $kbpa7.wacToken)('color.extended.blue800'),
            imageBackground: (0, $kbpa7.wacToken)('color.extended.blue200'),
            textColor: (0, $kbpa7.wacToken)('color.neutral.light0')
        },
        lime: {
            quoteBackground: (0, $kbpa7.wacToken)('color.extended.lime800'),
            imageBackground: (0, $kbpa7.wacToken)('color.extended.lime200'),
            textColor: (0, $kbpa7.wacToken)('color.neutral.light0')
        },
        purple: {
            quoteBackground: (0, $kbpa7.wacToken)('color.extended.purple800'),
            imageBackground: (0, $kbpa7.wacToken)('color.extended.purple200'),
            textColor: (0, $kbpa7.wacToken)('color.neutral.light0')
        },
        orange: {
            quoteBackground: (0, $kbpa7.wacToken)('color.extended.orange700'),
            imageBackground: (0, $kbpa7.wacToken)('color.extended.saffron200'),
            textColor: (0, $kbpa7.wacToken)('color.neutral.light0')
        }
    };
    return map[color];
};
const $a9e6bc4742132548$var$customerQuoteStyles = null;
const $a9e6bc4742132548$var$linkImageContainerStyles = null;
const $a9e6bc4742132548$var$customerImageStyles = null;
const $a9e6bc4742132548$var$customerImageDarkThemeStyles = null;
const $a9e6bc4742132548$var$customerQuoteContentStyles = null;
const $a9e6bc4742132548$var$linkQuoteContainerStyles = null;
const $a9e6bc4742132548$var$logoStyles = null;
const $a9e6bc4742132548$var$logoColoringStyles = null;
const $a9e6bc4742132548$var$quoteIconStyles = null;
const $a9e6bc4742132548$var$logoQuoteStackStyles = null;
const $a9e6bc4742132548$export$615b20b92b568a40 = ({ logoSrc: logoSrc, logoAlt: logoAlt, name: name, title: title, quote: quote, ctaLinkText: ctaLinkText, ctaLinkUrl: ctaLinkUrl, ctaLinkDataEventProps: ctaLinkDataEventProps, imageSrc: imageSrc, imageAlt: imageAlt, color: color, motionConfig: motionConfig })=>{
    const { isDarkTheme: isDarkTheme, isDevTheme: isDevTheme } = (0, $eOIix.useTheme)();
    const isValidLink = ctaLinkUrl && ctaLinkText;
    const uniqueId = (0, $1oC0p.useId)();
    const attributionId = `customer-quote-attribution-${uniqueId}`;
    const linkId = `customer-quote-link-${uniqueId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("article", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21sbv _4cvr1y6m _p12fu5xx _19pkidpf _2hwx1wug _otyridpf _18u01wug _j6quy58e _1rkbi4q4 _m6k41e03 _t9ecy7a9 _dk9v15m1",
            isValidLink && "_vms7ab0i",
            motionConfig?.transformForward && "_t9ecg30n _dk9vwey4"
        ]),
        style: {
            '--customer-quote-bg': $a9e6bc4742132548$export$3855eab3480168d5(color).quoteBackground,
            '--customer-quote-img-bg': $a9e6bc4742132548$export$3855eab3480168d5(color).imageBackground,
            '--customer-quote-text': $a9e6bc4742132548$export$3855eab3480168d5(color).textColor,
            "--_1oyjq9z": (0, $6ZVlx.default)(motionConfig?.transformForward),
            "--_1vdjstz": (0, $6ZVlx.default)(motionConfig?.transformBackward)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rko1ylz _p12f1c1k _1e0c1txw _16jlkb7n _2lx21bp4 _zulputpp _1yt41uzm _bfhk1os4 _syaz1oll _1lzopxbi _j6qu7g90 _13znps30 _1cqsu2gc _1rfm1osq _1rkbi4q4 _15txxy5q",
                    isValidLink && "_kqswh2mm _13whb3bt _ykcxidpf _1heustnw _1w8ikb7n _17qt1kw7 _w6hs1kw7 _biez1kw7 _9yql1kw7 _65a7kb7n _1tmikb7n _1rpbkb7n _j8p3kb7n _1k67kb7n _cv5ikb7n _7awzkb7n _vxx0kb7n _g2lz4jg8 _msyw4jg8 _17ed4jg8 _1o3r4jg8 _4zvn4jg8 _1vl64jg8 _x7ym4jg8 _14414jg8 _1kt9b3bt _1cs8stnw _1g0v1mrw _iajmidpf _1812idpf _1jx81ylz _1u5s1ylz _kfgtckbl _1rus1kw7 _pdykxgvd"
                ]),
                style: {
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1p571jfw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                src: logoSrc,
                                alt: logoAlt,
                                height: "40",
                                className: (0, $2jatx.default)([
                                    "_1bsbmlf1 _4t3i1tcg _5ral1f51 _rsuf1048 _165tzwfg",
                                    "_kdamj8h6 _16buj8h6"
                                ])
                            }),
                            isDevTheme ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_syaz1oll _1bsb1h39 _4t3i1l27 _1rfm1qjk _tnruzwfg"
                                ]),
                                children: (0, $z2rqa.quotationMarkPixelDot)
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                width: "63",
                                height: "54",
                                viewBox: "0 0 63 54",
                                fill: "none",
                                "aria-hidden": true,
                                xmlns: "http://www.w3.org/2000/svg",
                                className: (0, $2jatx.default)([
                                    "_syaz1oll _1bsb1h39 _4t3i1l27 _1rfm1qjk _tnruzwfg"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                    d: "M58.2 41.4C58.2 49.2 53.2 54 46 54C38.2 54 32 48.8 32 34C32 14.4 43.2 0.999999 63 0V12.2C54.4 12.8 47 18.2 45 29H46.4C53.6 29 58.2 33.8 58.2 41.4ZM26.2 41.4C26.2 49.2 21.2 54 14 54C6.2 54 0 48.8 0 34C0 14.4 11.2 0.999999 31 0V12.2C22.4 12.8 15 18.2 13 29H14.4C21.6 29 26.2 33.8 26.2 41.4Z",
                                    fill: "currentColor"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        className: (0, $2jatx.default)([
                            "_1pfhidpf _6rthu2gc _syaztohn",
                            "callout-sm"
                        ]),
                        children: [
                            quote,
                            "\u201D"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        id: attributionId,
                        className: (0, $2jatx.default)([
                            "_syaztohn",
                            "body-md"
                        ]),
                        children: [
                            name.toUpperCase(),
                            ", ",
                            title
                        ]
                    }),
                    isValidLink && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaztohn",
                            "body-md"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            id: linkId,
                            href: ctaLinkUrl,
                            text: ctaLinkText,
                            ariaLabelledby: `${linkId} ${attributionId}`,
                            "aria-label": ctaLinkText,
                            bgColor: "bgBlackBlue",
                            type: "primary",
                            className: "full-card",
                            dataEventProps: ctaLinkDataEventProps
                        })
                    })
                ]
            }),
            imageSrc && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk3jub _1o2w1n0t _1bsbjwe6 _1o9zidpf _vwz4idpf _19pkidpf _2hwxdzxt _otyridpf _18u0idpf _kqswh2mm _2rko1ylz _1reo15vq _18m915vq _1h1tgbua _mezj1osq _bna71wug _v4pn1ule _1jpx1f51 _1j3s12c2 _12rr1yk2 _lg5ridpf _d97m10j7 _1b7eidpf _1252idpf _sugaglyw _t9ec5igf",
                    isDarkTheme && "_1o2w1lyw",
                    "card-image"
                ]),
                style: {
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: imageSrc,
                    alt: imageAlt ?? '',
                    width: "316"
                })
            })
        ]
    });
};

});
parcelRegister("z2rqa", function(module, exports) {
$parcel$export(module.exports, "quotationMarkPixelDot", function () { return $5c1bf9e2fbf1b167$export$1ee21f9c92c57fa; });

var $7VQPk = parcelRequire("7VQPk");
const $5c1bf9e2fbf1b167$export$1ee21f9c92c57fa = /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    fill: "none",
    "aria-hidden": true,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "2",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "2",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "5",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "5",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "5",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "5",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "8",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "8",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "8",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "8",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "11",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "11",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "14",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "11",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "14",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "14",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "17",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "17",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "17",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "5",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "8",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "8",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "8",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "5",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "2",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "8",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "5",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "2",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "5",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "2",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "11",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "11",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "11",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "17",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "14",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "14",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "20",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "3",
            y: "20",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "20",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "6",
            y: "41",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "9",
            y: "41",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "12",
            y: "41",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "18",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "15",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "20",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "20",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "23",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "17",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "17",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "14",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "20",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "26",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "29",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "33",
            y: "41",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "36",
            y: "41",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "39",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "32",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "42",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "24",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "35",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "30",
            y: "41",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
            x: "27",
            y: "38",
            width: "2.00001",
            height: "2.00001",
            fill: "currentColor"
        })
    ]
});

});


parcelRegister("6XpQD", function(module, exports) {
$parcel$export(module.exports, "CustomerStat", function () { return $eef05c7db30f41b6$export$e6dcb98258d692b5; });
/* customer-stat.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");
const $eef05c7db30f41b6$var$colorMap = {
    blue: {
        bg: (0, $kbpa7.wacToken)('color.extended.blue700'),
        text: (0, $kbpa7.wacToken)('color.neutral.light0'),
        linkBg: 'bgBlackBlue'
    },
    blueLight: {
        bg: (0, $kbpa7.wacToken)('color.extended.blue200'),
        text: (0, $kbpa7.wacToken)('color.primary.black'),
        linkBg: 'bgColored'
    },
    lime: {
        bg: (0, $kbpa7.wacToken)('color.extended.lime800'),
        text: (0, $kbpa7.wacToken)('color.neutral.light0'),
        linkBg: 'bgBlackBlue'
    },
    limeLight: {
        bg: (0, $kbpa7.wacToken)('color.extended.lime200'),
        text: (0, $kbpa7.wacToken)('color.primary.black'),
        linkBg: 'bgColored'
    },
    purple: {
        bg: (0, $kbpa7.wacToken)('color.extended.purple800'),
        text: (0, $kbpa7.wacToken)('color.neutral.light0'),
        linkBg: 'bgBlackBlue'
    },
    purpleLight: {
        bg: (0, $kbpa7.wacToken)('color.extended.purple200'),
        text: (0, $kbpa7.wacToken)('color.primary.black'),
        linkBg: 'bgColored'
    },
    orange: {
        bg: (0, $kbpa7.wacToken)('color.extended.orange700'),
        text: (0, $kbpa7.wacToken)('color.neutral.light0'),
        linkBg: 'bgBlackBlue'
    },
    orangeLight: {
        bg: (0, $kbpa7.wacToken)('color.extended.saffron200'),
        text: (0, $kbpa7.wacToken)('color.primary.black'),
        linkBg: 'bgColored'
    },
    black: {
        bg: (0, $kbpa7.wacToken)('color.primary.black'),
        text: (0, $kbpa7.wacToken)('color.neutral.light0'),
        linkBg: 'bgBlackBlue'
    }
};
const $eef05c7db30f41b6$var$containerCss = null;
const $eef05c7db30f41b6$var$logoImageCss = null;
/** Dark stat surfaces use light body text; invert a dark logo asset so it reads as light (same idea as `CustomerQuote`). */ const $eef05c7db30f41b6$var$logoOnDarkSurfaceCss = null;
const $eef05c7db30f41b6$var$fullStatCss = null;
const $eef05c7db30f41b6$var$statRowCss = null;
/** Atlassian Mono — Desktop 1440 spec from `above.md`; scales down on tablet/mobile. */ const $eef05c7db30f41b6$var$statValueCss = null;
const $eef05c7db30f41b6$var$statModifierCss = null;
const $eef05c7db30f41b6$var$linkWrapCss = null;
const $eef05c7db30f41b6$export$e6dcb98258d692b5 = ({ logoSrc: logoSrc, logoAlt: logoAlt, statValue: statValue, statModifier: statModifier, description: description, linkText: linkText, linkHref: linkHref, linkDataEventProps: linkDataEventProps, color: color = 'blue', motionConfig: motionConfig })=>{
    const { bg: surfaceBg, text: surfaceText, linkBg: linkBg } = $eef05c7db30f41b6$var$colorMap[color];
    const logoOnDarkSurface = surfaceText === (0, $kbpa7.wacToken)('color.neutral.light0');
    const uniqueId = (0, $1oC0p.useId)();
    const statDescriptionId = `customer-stat-description-${uniqueId}`;
    const linkId = `customer-stat-link-${uniqueId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "data-testid": "customer-stat",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _2rko1ylz _1yt4xy5q _1bsbk5xz _1yagae1c _12rr1si5 _1rfmi4q4 _m6k41e03 _t9ecy7a9 _dk9v15m1 _kqswh2mm _13whb3bt _ykcxidpf _1heustnw _1w8ikb7n _17qt1kw7 _w6hs1kw7 _biez1kw7 _9yql1kw7 _65a7kb7n _1tmikb7n _1rpbkb7n _j8p3kb7n _1k67kb7n _cv5ikb7n _7awzkb7n _vxx0kb7n _g2lz4jg8 _msyw4jg8 _17ed4jg8 _1o3r4jg8 _4zvn4jg8 _1vl64jg8 _x7ym4jg8 _14414jg8 _1kt9b3bt _1cs8stnw _1g0v1mrw _iajmidpf _1812idpf _1jx81ylz _1u5s1ylz _kfgtckbl _1rus1kw7 _pdykxgvd",
            motionConfig?.transformForward && "_t9ecg30n _dk9vwey4"
        ]),
        style: {
            backgroundColor: surfaceBg,
            color: surfaceText,
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1oyjq9z": (0, $6ZVlx.default)(motionConfig?.transformForward),
            "--_1vdjstz": (0, $6ZVlx.default)(motionConfig?.transformBackward)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: logoSrc,
                alt: logoAlt,
                height: "40",
                className: (0, $2jatx.default)([
                    "_5ral1f51 _rsuf2bpp _1bsbmlf1 _4t3i1tcg _165tzwfg",
                    logoOnDarkSurface && "_kdamj8h6 _16buj8h6"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx2vrvc _4cvr1q9y _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_ect41tx7 _zg8l4jg8 _k48p1fw0 _1dyzj39m _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1iqs1jhh _1wyb1wqb _vwz4ys9h _1lzoymf6 _119zys9h _3p1c16xz _py5o16xz _1ken24x1 _zu7r1yfw"
                                ]),
                                children: statValue
                            }),
                            statModifier && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_ect41tx7 _zg8l4jg8 _k48p1fw0 _1dyzj39m _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1iqs1jhh _1wybzwfg _vwz41wqb _1lzo1ylp _119z1wqb _3p1cvbgk _py5otudo _1ken24x1 _zu7r1yfw"
                                ]),
                                children: statModifier
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        id: statDescriptionId,
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1ken24x1 _zu7r1yfw",
                            "callout-sm"
                        ]),
                        style: {
                            color: surfaceText
                        },
                        children: description
                    })
                ]
            }),
            linkText && linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wyb1j6v _3p1c1cby"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    id: linkId,
                    text: linkText,
                    href: linkHref,
                    type: "primary",
                    bgColor: linkBg,
                    ariaLabelledby: `${linkId} ${statDescriptionId}`,
                    "aria-label": linkText,
                    className: "full-card",
                    dataEventProps: linkDataEventProps
                })
            })
        ]
    });
};

});


parcelRegister("cDjwJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b49d11c3d700c7d0$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $4MQZO = parcelRequire("4MQZO");
const $b49d11c3d700c7d0$export$760d8d36b06866af = (props)=>{
    const statProps = {
        ...props
    };
    statProps.stats = (0, $f2QWG.flattenValues)(props.stats);
    return statProps;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b49d11c3d700c7d0$var$UniformCustomerStat = (props)=>{
    const statProps = $b49d11c3d700c7d0$export$760d8d36b06866af(props);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4MQZO.CustomerDetailsStats), {
        ...statProps
    });
};
var $b49d11c3d700c7d0$export$2e2bcd8739ae039 = $b49d11c3d700c7d0$var$UniformCustomerStat;

});
parcelRegister("4MQZO", function(module, exports) {
$parcel$export(module.exports, "CustomerDetailsStats", function () { return $f63b6970ed36f5a7$export$60ec57d65c4d2d2b; });
/* customer-details-stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");
// Stats become vertical when the viewport is tablet or smaller
const $f63b6970ed36f5a7$var$containerStyle = null;
const $f63b6970ed36f5a7$var$horizontalContainerWithThreeStatsStyle = null;
const $f63b6970ed36f5a7$var$statsContainerStyle = null;
const $f63b6970ed36f5a7$var$statStyle = null;
const $f63b6970ed36f5a7$var$statTextStyle = null;
const $f63b6970ed36f5a7$var$horizontalStatStyle = null;
const $f63b6970ed36f5a7$var$horizontalStatTextStyle = null;
const $f63b6970ed36f5a7$var$layoutStyle = null;
const $f63b6970ed36f5a7$var$oneStatDesktopStyle = null;
const $f63b6970ed36f5a7$var$isEmptyStats = (currentObject)=>JSON.stringify(currentObject) === '{}';
const $f63b6970ed36f5a7$export$60ec57d65c4d2d2b = ({ title: title, stats: stats })=>{
    if (!stats || stats?.every($f63b6970ed36f5a7$var$isEmptyStats)) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_2rko1ylz _1wpz1h6o _11q7g7ng _18zrxy5q _1e0c1txw _2lx21bp4 _zulp1ejb _1rjcxy5q _1bhl1ejb _2osnpxbi",
                stats?.length === 1 && "_glte12it _xtn71wug",
                stats?.length === 3 && "_glteqciz _u5ggze3t _xtn7ukr8"
            ]),
            style: {
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
            },
            children: [
                title && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "eyebrow-md",
                    role: "heading",
                    "aria-level": 2,
                    children: title
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("dl", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx2vrvc _zulpxy5q _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2osn1ejb _1gde1bp4 _8164pxbi"
                    ]),
                    children: stats?.map((stat, idx)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1wpz1fhb _16jlkb7n _i0dlidpf _2lx21bp4",
                                    stats?.length < 3 && "_1inivrvc _pdlmxy5q"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("dt", {
                                        className: (0, $2jatx.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            stats?.length < 3 && "_cdjm1h6o",
                                            "stat-sm"
                                        ]),
                                        children: stat?.stat
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("dd", {
                                        className: (0, $2jatx.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            stats?.length < 3 && "_cdjm1h6o",
                                            "body-md"
                                        ]),
                                        children: stat?.statDescription
                                    })
                                ]
                            })
                        }, idx);
                    })
                })
            ]
        })
    });
};

});


parcelRegister("gl1tq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2fb2f2d214994b84$export$2e2bcd8739ae039; });
/* customer-stories-details-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $b9OTp = parcelRequire("b9OTp");

var $avaxs = parcelRequire("avaxs");
const $2fb2f2d214994b84$var$heroContainerCss = null;
const $2fb2f2d214994b84$export$74f30557f8a70c45 = ({ title: title, subtitle: subtitle, imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1bah1yb4 _1pfhxy5q _p12f1osq _vchhusvi _zulp1tcg _1bsb1osq _yv0ei47z _pdlmzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b9OTp.default), {
                title: title,
                subtitle: subtitle,
                alignment: imgSrc ? 'left' : 'center'
            }),
            quote && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $avaxs.default), {
                imgSrc: imgSrc,
                imgAlt: imgAlt,
                quote: quote,
                author: author,
                role: role,
                company: company
            })
        ]
    });
};
var $2fb2f2d214994b84$export$2e2bcd8739ae039 = $2fb2f2d214994b84$export$74f30557f8a70c45;

});
parcelRegister("b9OTp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $134c9de5826b2c34$export$2e2bcd8739ae039; });
/* hero-intro.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
const $134c9de5826b2c34$var$UniformHeroIntro = ({ title: title, subtitle: subtitle, alignment: alignment })=>{
    const heroContainer = null;
    const textCss = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_y3gnoues _yv0ecx6w _1e0c11p5 _gy1p1tcg _1rqtaigu _ikjdzwfg"
        ]),
        style: {
            "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _yyhy13k5 _1e3c123x"
                ]),
                style: {
                    "--_1s7r9nk": (0, $6ZVlx.default)(alignment == 'center' ? '2' : '1')
                },
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _yyhy13k5 _1e3c123x",
                    "body-lg"
                ]),
                style: {
                    "--_1s7r9nk": (0, $6ZVlx.default)(alignment == 'center' ? '2' : '1')
                },
                children: subtitle
            })
        ]
    });
};
var $134c9de5826b2c34$export$2e2bcd8739ae039 = $134c9de5826b2c34$var$UniformHeroIntro;

});

parcelRegister("avaxs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d76d7b05240d3961$export$2e2bcd8739ae039; });
/* customer-stories-details-hero-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ftgEA = parcelRequire("ftgEA");

var $ksvEJ = parcelRequire("ksvEJ");
const $d76d7b05240d3961$var$quoteBodyCss = null;
const $d76d7b05240d3961$var$quoteStylingWithImage = null;
const $d76d7b05240d3961$var$quoteStylingNoImage = null;
const $d76d7b05240d3961$var$imageCss = null;
const $d76d7b05240d3961$var$quoteContainerStyles = null;
const $d76d7b05240d3961$export$d35b0bc1e0617ca6 = ({ imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    const authorDetails = [
        role,
        company
    ].filter(Boolean).join(', ');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0ecx6w _zulp1tcg _4cvr1h6o _6a6zv2br _1rqtaigu _pdlmzwfg"
        ]),
        children: [
            imgSrc && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1461kb7n _f0zu1ohn _nw6ekb7n _1jpu1mrw _uhi5kb7n _eao7qfx8"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                    contentType: /* Since we do not pass in the direct Contentful image via Uniform,
                           this uses a rough assumption to trigger a webp transformation */ imgSrc.endsWith('.png') ? 'image/png' : undefined,
                    src: imgSrc,
                    alt: imgAlt ?? '',
                    style: {
                        maxWidth: '100%'
                    },
                    baseWidth: 440
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1461kb7n _f0zu1mrw _1vb6grf3",
                    imgSrc ? "_1e3c1gti" : "_1e3ceqnf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                    quote: quote ?? '',
                    authorName: author ?? '',
                    authorDetails: authorDetails,
                    alignment: imgSrc ? 'start' : 'center',
                    size: "large",
                    variant: "basic"
                })
            })
        ]
    });
};
var $d76d7b05240d3961$export$2e2bcd8739ae039 = $d76d7b05240d3961$export$d35b0bc1e0617ca6;

});


parcelRegister("hvVOW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $34f3707412098f34$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $i1SI4 = parcelRequire("i1SI4");
const $34f3707412098f34$var$transformContentfulImage = (image, alt = '')=>{
    if (!image?.file?.url) return undefined;
    return {
        contentType: image.file.contentType || 'image',
        src: image.file.url,
        alt: alt,
        baseWidth: 500,
        width: image.file.details?.image?.width,
        height: image.file.details?.image?.height
    };
};
const $34f3707412098f34$var$transformUniformCompanyLogo = (logos, alt = '')=>{
    const logo = logos?.[0];
    if (!logo?.src) return undefined;
    return {
        contentType: 'image',
        src: logo.src,
        alt: logo.alt ?? alt,
        baseWidth: 500,
        width: logo.width,
        height: undefined
    };
};
const $34f3707412098f34$var$transformUniformHeadshot = (headshots)=>{
    const headshot = headshots?.[0];
    if (!headshot?.src) return undefined;
    return {
        contentType: 'image',
        src: headshot.src,
        alt: headshot.alt ?? '',
        baseWidth: 500,
        width: undefined,
        height: undefined
    };
};
const $34f3707412098f34$var$transformCta = (url, text)=>{
    if (!url || !text) return undefined;
    return {
        url: url,
        text: text
    };
};
const $34f3707412098f34$var$isContentfulQuote = (quote)=>{
    return 'fields' in quote && quote.fields !== undefined;
};
const $34f3707412098f34$var$transformContentfulQuote = (quote)=>{
    const { fields: fields } = quote;
    const cta = fields.advocateCta?.[0]?.fields;
    const companyName = fields.organization?.fields?.organizationNameExternal ?? '';
    return {
        logo: $34f3707412098f34$var$transformContentfulImage(fields.organization?.fields?.logo?.[0]?.fields, companyName),
        name: fields.advocateName,
        title: fields.advocateJobTitle,
        image: $34f3707412098f34$var$transformContentfulImage(fields.advocateHeadshot?.fields),
        quote: fields.advocateQuote,
        link: $34f3707412098f34$var$transformCta(cta?.ctaUrl, cta?.ctaButtonText),
        label: companyName
    };
};
const $34f3707412098f34$var$transformUniformQuote = (quote)=>{
    return {
        logo: $34f3707412098f34$var$transformUniformCompanyLogo(quote.companyLogo, quote.companyName),
        name: quote.advocateName,
        title: quote.advocateJobTitle,
        image: $34f3707412098f34$var$transformUniformHeadshot(quote.advocateHeadshot),
        quote: quote.quote,
        link: $34f3707412098f34$var$transformCta(quote.ctaUrl, quote.ctaLinkText),
        label: quote.companyName
    };
};
const $34f3707412098f34$var$isValidTestimonial = (quote)=>{
    return !!quote.name && !!quote.image && !!quote.quote;
};
const $34f3707412098f34$var$flattenUniformQuote = (quote)=>{
    if (!quote || typeof quote !== 'object') return null;
    try {
        return (0, $f2QWG.flattenValues)(quote);
    } catch  {
        return null;
    }
};
const $34f3707412098f34$var$transformProps = (props)=>{
    let testimonials;
    if (props.uniformQuotes) {
        // Uniform CMS: flatten each raw quote entry, then transform
        const flattenedQuotes = (props.uniformQuotes ?? []).map($34f3707412098f34$var$flattenUniformQuote).filter((quote)=>quote !== null);
        testimonials = flattenedQuotes.map($34f3707412098f34$var$transformUniformQuote);
    } else {
        // Contentful fallback
        const contentfulQuotes = props.quotes ?? [];
        testimonials = contentfulQuotes.filter((quote)=>quote !== null && quote !== undefined).map((quote)=>{
            if ($34f3707412098f34$var$isContentfulQuote(quote)) return $34f3707412098f34$var$transformContentfulQuote(quote);
            return $34f3707412098f34$var$transformUniformQuote(quote);
        });
    }
    let validTestimonials = testimonials.filter($34f3707412098f34$var$isValidTestimonial);
    if (testimonials.length > 1) validTestimonials = validTestimonials.filter((quote)=>{
        return !!quote.logo;
    });
    return {
        bgColor: props.theme ?? 'white',
        testimonials: validTestimonials
    };
};
const $34f3707412098f34$var$UniformCustomerTestimonials = (props)=>{
    //TODO GWP-6632: add CTA links, and ensure they are localized in each panel
    const { bgColor: bgColor, testimonials: testimonials } = $34f3707412098f34$var$transformProps(props);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i1SI4.CustomerTestimonials), {
        bgColor: bgColor,
        testimonials: testimonials
    });
};
var $34f3707412098f34$export$2e2bcd8739ae039 = $34f3707412098f34$var$UniformCustomerTestimonials;

});

parcelRegister("9xmV3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea07de0a1df2f74b$export$2e2bcd8739ae039; });
/* decorative-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");
const $ea07de0a1df2f74b$var$wrapperStyles = null;
const $ea07de0a1df2f74b$var$decorativeImageStyles = null;
const $ea07de0a1df2f74b$var$UniformDecorativeContainer = ({ imageSrc: imageSrc, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        // backgroundImage must be set via inline style since the URL is a dynamic parameter
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            '--decorative-bg-image': `url(${imageSrc})`
        },
        className: (0, $2jatx.default)([
            "_kqswh2mm _19121cl4",
            "_1kt9b3bt _cfu11ule _1cs8stnw _1mp41mjv _kfgt1mjv _iajmidpf _z5wtidpf _7dwzl5nq _18cr1hry _1ank1f51 _f6gemgnk _wkf11ssb _1g0v1mrw _dsq4glyw"
        ]),
        children: children ?? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content"
        })
    });
};
var $ea07de0a1df2f74b$export$2e2bcd8739ae039 = $ea07de0a1df2f74b$var$UniformDecorativeContainer;

});

parcelRegister("2m9G1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $672275a99d24ea5f$export$2e2bcd8739ae039; });
/* design-refresh-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $3uttc = parcelRequire("3uttc");
const $672275a99d24ea5f$var$UniformDesignRefreshBar = ({ backgroundDesign: backgroundDesign = 'blueShapes' })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _4t3i7vkz _1reo15vq _18m915vq _1vym17i2 _1wlt1dux",
            backgroundDesign
        ]),
        style: {
            "--_xvz68f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue400')),
            "--_t0cjdu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron200'))
        },
        children: backgroundDesign === 'orangePurpleShapes' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3uttc.OrangePurpleShapes), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3uttc.BlueShapes), {})
    });
};
const $672275a99d24ea5f$var$containerCss = null;
var $672275a99d24ea5f$export$2e2bcd8739ae039 = $672275a99d24ea5f$var$UniformDesignRefreshBar;

});
parcelRegister("3uttc", function(module, exports) {
$parcel$export(module.exports, "BlueShapes", function () { return $460ff537c7911762$export$5a5238b19420ab54; });
$parcel$export(module.exports, "OrangePurpleShapes", function () { return $460ff537c7911762$export$20a09cdb7c5c22c2; });

var $7VQPk = parcelRequire("7VQPk");
const $460ff537c7911762$export$5a5238b19420ab54 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        style: {
            width: '100%'
        },
        xmlns: "http://www.w3.org/2000/svg",
        width: "1440",
        height: "16",
        viewBox: "0 0 1440 16",
        fill: "none",
        preserveAspectRatio: "xMidYMid slice",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M522.691 -149.313L621.485 -121.386L580.24 -97.898L561.353 -54.3125L522.772 -149.313H522.691ZM678.227 -60.6081C720.037 -62.8681 755.713 -30.8247 758.054 10.9852L769.354 219.631C771.614 261.441 739.57 297.117 697.76 299.457C655.95 301.798 620.275 269.674 617.934 227.864L606.634 19.2181C604.374 -22.5918 636.417 -58.2674 678.227 -60.6081Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M333.17 -168.762L304.112 -70.291L281.028 -111.859L237.685 -131.23L333.17 -168.762ZM242.689 -14.1947C244.465 27.6152 212.018 62.9679 170.208 64.7436L-38.5995 73.7029C-80.4094 75.4786 -115.762 43.0316 -117.538 1.22166C-119.314 -40.5882 -86.8664 -75.941 -45.0565 -77.7167L163.751 -86.676C205.561 -88.4517 240.913 -56.0047 242.689 -14.1947Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M542.063 168.623L481.447 85.8102L528.422 92.671L570.151 69.9902L542.063 168.623ZM474.102 2.99762C439.798 -20.9745 431.323 -68.1922 455.295 -102.576L574.833 -273.933C598.805 -308.236 646.023 -316.711 680.407 -292.739C714.791 -268.767 723.185 -221.549 699.213 -187.165L579.676 -15.8088C555.704 18.4947 508.486 26.9697 474.102 2.99762Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1065.58 213.497L1095.52 115.268L1118.2 156.997L1161.39 176.772L1065.58 213.416V213.497ZM1157.43 59.7368C1155.98 17.9269 1188.75 -17.1838 1230.64 -18.6366L1439.45 -25.7395C1481.26 -27.1924 1516.37 5.57762 1517.82 47.4682C1519.27 89.3589 1486.5 124.389 1444.61 125.842L1235.8 132.944C1193.99 134.397 1158.88 101.627 1157.43 59.7368Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M72.0586 -332.128L170.853 -304.201L129.608 -280.713L110.721 -237.128L72.1394 -332.128H72.0586ZM227.675 -243.423C269.485 -245.683 305.161 -213.64 307.502 -171.83L318.802 36.8161C321.062 78.626 289.018 114.302 247.208 116.642C205.398 118.983 169.723 86.8589 167.382 45.049L156.082 -163.597C153.822 -205.407 185.865 -241.082 227.675 -243.423Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-17.1288 192.192L-66.6873 102.276L-20.9223 115.11L23.3896 97.9176L-17.1288 192.192ZM-63.378 19.1407C-94.3722 -9.02853 -96.7128 -56.9727 -68.5436 -87.9669L71.9797 -242.696C100.149 -273.69 148.093 -276.031 179.087 -247.862C210.081 -219.692 212.422 -171.748 184.253 -140.754L43.7297 13.975C15.5605 44.9692 -32.3838 47.3099 -63.378 19.1407Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M736.746 141.664L638.597 171.77L660.552 129.637L652.803 82.7424L736.746 141.664ZM557.883 151.511C523.983 176.129 476.604 168.542 451.987 134.642L329.301 -34.5352C304.683 -68.4351 312.27 -115.814 346.17 -140.432C380.07 -165.05 427.45 -157.463 452.067 -123.563L574.753 45.614C599.37 79.5139 591.783 126.893 557.883 151.511Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M96.5958 58.8487L89.6543 -43.5775L125.653 -12.5833L173.032 -9.43549L96.515 58.8487H96.5958ZM127.751 -117.512C111.528 -156.093 129.688 -200.566 168.351 -216.709L361.015 -297.585C399.597 -313.808 444.07 -295.648 460.213 -256.986C476.356 -218.324 458.276 -173.931 419.614 -157.788L226.949 -76.9125C188.368 -60.6889 143.894 -78.8496 127.751 -117.512Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M58.4199 -174.657L154.873 -209.768L135.179 -166.505L145.349 -120.095L58.4199 -174.577V-174.657ZM236.475 -193.787C269.084 -220.099 316.786 -215.014 343.099 -182.406L474.34 -19.8477C500.652 12.7608 495.567 60.4627 462.959 86.7755C430.35 113.088 382.648 108.003 356.336 75.3949L225.094 -87.1634C198.782 -119.772 203.867 -167.474 236.475 -193.787Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-234.572 -1.28267L-146.029 -53.1819L-157.652 -7.09409L-139.33 36.7336L-234.572 -1.28267ZM-62.8935 -52.0519C-35.6121 -83.7725 12.2515 -87.324 43.9721 -60.0426L202.333 76.2834C234.054 103.565 237.605 151.428 210.324 183.149C183.042 214.87 135.179 218.421 103.458 191.14L-54.9026 54.8136C-86.6233 27.5322 -90.1749 -20.3313 -62.8935 -52.0519Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M79.082 -205.732L181.75 -207.185L148.9 -172.882L143.169 -125.745L79.082 -205.813V-205.732ZM253.505 -165.133C292.894 -179.258 336.318 -158.676 350.443 -119.287L420.826 77.4936C434.95 116.882 414.368 160.306 374.98 174.431C335.591 188.556 292.167 167.974 278.042 128.586L207.66 -68.1954C193.535 -107.584 214.117 -151.008 253.505 -165.133Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M232.761 284.202L206.287 185.005L247.613 208.492L294.75 202.439L232.842 284.202H232.761ZM229.533 105.178C206.206 70.3905 215.489 23.3342 250.276 0.00784302L423.812 -116.382C458.599 -139.708 505.656 -130.426 528.982 -95.6383C552.309 -60.8505 543.026 -13.7942 508.239 9.53218L334.703 125.922C299.915 149.248 252.859 139.966 229.533 105.178Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M702.764 6.86975L772.178 82.4988L724.718 80.8846L685.733 108.085L702.764 6.95042V6.86975ZM788.644 163.939C825.45 183.956 839.01 229.964 818.993 266.769L719.149 450.313C699.132 487.119 653.125 500.679 616.319 480.661C579.514 460.644 565.954 414.637 585.971 377.832L685.814 194.288C705.831 157.482 751.838 143.922 788.644 163.939Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M25.7318 280.489L-76.9366 279.117L-43.1982 245.702L-36.2566 198.726L25.651 280.489H25.7318ZM-147.481 235.128C-187.273 248.123 -230.051 226.492 -243.127 186.7L-308.183 -11.857C-321.178 -51.6491 -299.546 -94.4275 -259.754 -107.503C-219.962 -120.579 -177.184 -98.8668 -164.108 -59.0747L-99.0522 139.482C-86.0572 179.274 -107.689 222.052 -147.481 235.128Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M542.144 -134.379L600.419 -49.8712L553.605 -58.1041L511.23 -36.6341L542.144 -134.46V-134.379ZM605.343 33.1835C639.001 58.1242 646.023 105.584 621.082 139.242L496.621 307.127C471.68 340.785 424.22 347.807 390.563 322.866C356.905 297.926 349.883 250.466 374.823 216.808L499.284 48.9228C524.225 15.265 571.685 8.24289 605.343 33.1835Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1128.93 -45.8364L1059.6 29.8734L1057.18 -17.5864L1026.75 -54.0692L1129.02 -45.8364H1128.93ZM979.856 53.2805C963.067 91.6197 918.432 109.135 880.012 92.3461L688.558 8.64565C650.219 -8.14288 632.704 -52.7779 649.493 -91.1978C666.281 -129.618 710.916 -147.052 749.336 -130.263L940.79 -46.5628C979.129 -29.7742 996.644 14.8606 979.856 53.2805Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M93.043 -421.964L191.837 -394.036L150.592 -370.549L131.705 -326.963L93.1238 -421.964H93.043ZM248.66 -333.34C290.47 -335.6 326.145 -303.556 328.486 -261.746L339.786 -53.1003C342.046 -11.2903 310.003 24.3853 268.193 26.726C226.383 29.0667 190.707 -3.05746 188.366 -44.8674L177.066 -253.513C174.806 -295.323 206.85 -330.999 248.66 -333.34Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M12.4946 102.275L86.8325 31.4883L86.0253 79.0289L113.871 117.529L12.4141 102.355L12.4946 102.275ZM168.031 13.5698C187.402 -23.5587 233.167 -38.0066 270.295 -18.6352L455.615 77.8989C492.744 97.2703 507.191 143.035 487.82 180.164C468.449 217.292 422.684 231.74 385.555 212.369L200.236 115.835C163.107 96.4632 148.659 50.6983 168.031 13.5698Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M9.66917 58.3648L-50.9472 -24.4479L-3.97153 -17.5872L37.7575 -40.2678L9.66917 58.3648ZM-58.373 -107.261C-92.6765 -131.233 -101.151 -178.45 -77.1793 -212.835L42.3583 -384.191C66.3304 -418.494 113.548 -426.969 147.932 -402.997C182.316 -379.025 190.711 -331.807 166.739 -297.423L47.2012 -126.067C23.2291 -91.7635 -23.9888 -83.2885 -58.373 -107.261Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M872.022 203.165L837.315 106.55L880.416 126.487L926.907 116.559L872.022 203.246V203.165ZM853.7 25.029C827.548 -7.66019 832.875 -55.3622 865.565 -81.5136L1028.77 -212.028C1061.46 -238.18 1109.16 -232.853 1135.31 -200.163C1161.46 -167.474 1156.14 -119.772 1123.45 -93.6207L960.242 36.894C927.553 63.0454 879.851 57.7182 853.7 25.029Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M47.5254 -29.9348L138.087 -78.2019L124.608 -32.6792L141.154 11.875L47.5254 -29.9348ZM221.142 -73.7626C249.714 -104.353 297.659 -105.968 328.249 -77.3948L480.96 65.2271C511.551 93.7998 513.165 141.744 484.592 172.335C456.02 202.925 408.075 204.54 377.485 175.967L224.774 33.345C194.183 4.77221 192.569 -43.172 221.142 -73.7626Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-242.238 -69.8073L-143.444 -41.8803L-184.689 -18.3925L-203.576 25.1932L-242.158 -69.8073H-242.238ZM-86.6216 18.8975C-44.8117 16.6375 -9.13597 48.681 -6.79526 90.4909L4.50467 299.137C6.76466 340.947 -25.2788 376.622 -67.0887 378.963C-108.899 381.304 -144.574 349.18 -146.915 307.37L-158.215 98.7238C-160.475 56.9139 -128.432 21.2383 -86.6216 18.8975Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M987.206 -78.118L1056.62 -2.48898L1009.16 -4.10323L970.175 23.0974L987.206 -78.0374V-78.118ZM1073.09 79.0323C1109.89 99.0494 1123.45 145.056 1103.43 181.862L1003.59 365.406C983.573 402.211 937.566 415.771 900.761 395.754C863.955 375.737 850.395 329.73 870.412 292.925L970.256 109.381C990.273 72.5751 1036.28 59.0152 1073.09 79.0323Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M347.458 28.4211L249.31 58.5275L271.264 16.3947L263.515 -30.5002L347.458 28.4211ZM168.676 38.2683C134.776 62.8861 87.3972 55.299 62.7794 21.3991L-59.9061 -147.778C-84.5239 -181.678 -76.9366 -229.057 -43.0367 -253.675C-9.13676 -278.292 38.2424 -270.705 62.8602 -236.805L185.545 -67.6286C210.163 -33.7286 202.576 13.6505 168.676 38.2683Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M358.197 14.78L261.098 48.1956L281.599 5.33649L272.236 -41.2356L358.116 14.78H358.197ZM179.819 30.7614C146.807 56.5092 99.1854 50.5363 73.4376 17.5243L-54.8977 -147.375C-80.6455 -180.387 -74.6728 -228.008 -41.6607 -253.756C-8.64867 -279.504 38.9726 -273.531 64.7204 -240.519L193.056 -75.6197C218.804 -42.6077 212.831 5.01358 179.819 30.7614Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-275.492 -25.2512L-179.039 -60.3619L-198.733 -17.0992L-188.563 29.3114L-275.492 -25.1706V-25.2512ZM-97.4369 -44.3806C-64.8284 -70.6934 -17.1265 -65.6083 9.18634 -32.9998L140.428 129.558C166.74 162.167 161.655 209.869 129.047 236.182C96.4383 262.494 48.7364 257.409 22.4236 224.801L-108.818 62.2428C-135.13 29.6343 -130.045 -18.0678 -97.4369 -44.3806Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-200.834 -55.6016L-98.1656 -57.0544L-131.016 -22.7509L-136.747 24.3861L-200.834 -55.6823V-55.6016ZM-26.4915 -15.0024C12.897 -29.1274 56.3212 -8.54521 70.4462 30.8433L140.829 227.624C154.954 267.013 134.372 310.437 94.9831 324.562C55.5946 338.687 12.1706 318.105 -1.95435 278.716L-72.337 81.9353C-86.462 42.5468 -65.88 -0.877438 -26.4915 -15.0024Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-23.6664 286.223L-50.1406 187.025L-8.81504 210.513L38.322 204.459L-23.5859 286.223H-23.6664ZM-26.9757 107.118C-50.3021 72.3303 -41.0199 25.274 -6.23214 1.94759L167.303 -114.442C202.091 -137.769 249.147 -128.486 272.474 -93.6987C295.8 -58.9109 286.518 -11.8546 251.73 11.4718L78.1947 127.862C43.407 151.188 -3.64934 141.906 -26.9757 107.118Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M420.508 -427.13L489.923 -351.501L442.463 -353.115L403.478 -325.915L420.508 -427.049V-427.13ZM506.388 -270.06C543.194 -250.043 556.754 -204.036 536.737 -167.231L436.893 16.3132C416.876 53.1188 370.869 66.6787 334.063 46.6616C297.258 26.6445 283.698 -19.3624 303.715 -56.1681L403.558 -239.712C423.575 -276.518 469.582 -290.078 506.388 -270.06Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M270.537 366.611L168.596 354.666L205.644 324.882L217.428 278.875L270.618 366.611H270.537ZM102.814 303.735C61.8915 312.614 21.5346 286.624 12.6561 245.702L-31.5753 41.495C-40.4539 0.572971 -14.4639 -39.7841 26.4581 -48.6626C67.3802 -57.5412 107.737 -31.5512 116.616 9.37084L160.847 213.578C169.726 254.5 143.736 294.857 102.814 303.735Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M37.8359 9.6945L135.016 42.7067L92.5601 64.0152L71.413 106.551L37.8359 9.61383V9.6945ZM188.61 106.309C230.5 106.229 264.481 140.048 264.562 181.938L265.046 390.907C265.127 432.798 231.308 466.779 189.417 466.859C147.526 466.94 113.546 433.121 113.465 391.23L112.981 182.261C112.9 140.371 146.719 106.39 188.61 106.309Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-222.382 255.471L-236.83 153.851L-198.652 182.101L-151.112 181.779L-222.382 255.551V255.471ZM-204.222 77.2538C-223.189 39.9638 -208.338 -5.72038 -171.048 -24.6882L15.1594 -119.447C52.4493 -138.414 98.1335 -123.563 117.101 -86.2731C136.069 -48.9832 121.218 -3.29896 83.9277 15.6689L-102.28 110.427C-139.57 129.395 -185.254 114.544 -204.222 77.2538Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M278.045 383.725L176.103 371.779L213.151 341.996L224.935 295.989L278.125 383.725H278.045ZM110.402 320.849C69.4795 329.727 29.1225 303.737 20.244 262.815L-23.9874 58.6088C-32.866 17.6867 -6.87603 -22.6703 34.046 -31.5488C74.9681 -40.4274 115.325 -14.4375 124.204 26.4845L168.435 230.691C177.314 271.613 151.324 311.97 110.402 320.849Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-78.1484 -116.458L20.6455 -88.5315L-20.5992 -65.0436L-39.4866 -21.458L-78.0679 -116.458H-78.1484ZM77.4683 -27.7538C119.278 -30.0138 154.954 2.02982 157.294 43.8397L168.594 252.486C170.854 294.296 138.811 329.971 97.001 332.312C55.1911 334.653 19.5156 302.528 17.1749 260.719L5.87497 52.0725C3.61497 10.2626 35.6584 -25.4131 77.4683 -27.7538Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-348.379 298.329L-342.89 195.822L-310.847 230.932L-264.194 239.811L-348.379 298.329ZM-296.076 127.053C-307.457 86.7769 -284.05 44.8864 -243.773 33.5057L-42.7146 -23.3978C-2.43829 -34.7785 39.4523 -11.3714 50.833 28.9049C62.2137 69.1812 38.8067 111.072 -1.4696 122.453L-202.528 179.356C-242.805 190.737 -284.696 167.33 -296.076 127.053Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M875.171 -15.4877L790.26 42.223L798.816 -4.51054L777.588 -47.0469L875.171 -15.4877ZM707.205 46.5815C682.022 80.0779 634.563 86.7771 601.066 61.675L433.988 -63.8353C400.492 -89.0181 393.792 -136.478 418.894 -169.974C443.997 -203.471 491.537 -210.17 525.033 -185.068L692.112 -59.5575C725.608 -34.3747 732.307 13.0851 707.205 46.5815Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M475.314 98.7224L563.858 46.8232L552.235 92.911L570.557 136.739L475.314 98.7224ZM646.993 47.9532C674.275 16.2325 722.138 12.6811 753.859 39.9624L912.22 176.289C943.941 203.57 947.492 251.433 920.211 283.154C892.929 314.875 845.066 318.426 813.345 291.145L654.984 154.819C623.263 127.537 619.712 79.6738 646.993 47.9532Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M366.107 -277.164L466.92 -257.793L427.773 -230.834L412.68 -185.796L366.107 -277.164ZM528.666 -202.1C570.153 -207.912 608.492 -179.097 614.303 -137.61L643.441 69.3412C649.253 110.828 620.438 149.167 578.951 154.979C537.464 160.79 499.124 131.975 493.313 90.4883L464.175 -116.463C458.364 -157.95 487.179 -196.289 528.666 -202.1Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1295.13 -155.608L1266.07 -57.1369L1242.99 -98.7046L1199.65 -118.076L1295.13 -155.608ZM1204.65 -1.04045C1206.43 40.7695 1173.98 76.1222 1132.17 77.8979L923.361 86.8572C881.552 88.6329 846.199 56.1857 844.423 14.3758C842.647 -27.4341 875.094 -62.7868 916.904 -64.5625L1125.71 -73.5218C1167.52 -75.2975 1202.87 -42.8504 1204.65 -1.04045Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1505.47 209.866L1444.86 127.053L1491.83 133.914L1533.56 111.233L1505.47 209.866ZM1437.43 44.1595C1403.13 20.1875 1394.65 -27.0303 1418.62 -61.4145L1538.16 -232.771C1562.13 -267.074 1609.35 -275.549 1643.73 -251.577C1678.12 -227.605 1686.51 -180.387 1662.54 -146.003L1543 25.3531C1519.03 59.6566 1471.81 68.1316 1437.43 44.1595Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M265.532 479.129L171.419 438.127L215.489 420.37L240.107 379.77L265.532 479.129ZM123.314 370.246C81.5845 366.856 50.5095 330.293 53.8995 288.563L70.7687 80.321C74.1587 38.5918 110.722 7.51693 152.451 10.9069C194.181 14.2969 225.255 50.8604 221.865 92.5895L204.996 300.832C201.606 342.561 165.043 373.636 123.314 370.246Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1037.65 -313.566L1136.44 -285.639L1095.2 -262.151L1076.31 -218.565L1037.73 -313.566H1037.65ZM1193.27 -224.861C1235.08 -227.121 1270.75 -195.078 1273.09 -153.268L1284.39 55.3782C1286.65 97.1881 1254.61 132.864 1212.8 135.204C1170.99 137.545 1135.31 105.421 1132.97 63.6111L1121.67 -145.035C1119.41 -186.845 1151.46 -222.52 1193.27 -224.861Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M484.195 -43.2518L576.371 1.94818L531.574 17.6874L505.181 57.1566L484.276 -43.2518H484.195ZM621.329 71.9273C662.897 77.1737 692.276 115.109 686.949 156.677L660.636 363.951C655.39 405.519 617.454 434.899 575.887 429.571C534.319 424.244 504.939 386.389 510.266 344.822L536.579 137.548C541.825 95.9801 579.761 66.6002 621.329 71.9273Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M945.393 202.037L895.834 112.121L941.599 124.955L985.911 107.763L945.393 202.037ZM899.143 29.0665C868.149 0.897278 865.809 -47.0469 893.978 -78.0411L1034.5 -232.77C1062.67 -263.764 1110.61 -266.105 1141.61 -237.936C1172.6 -209.767 1174.94 -161.822 1146.77 -130.828L1006.25 23.9008C978.082 54.895 930.138 57.2357 899.143 29.0665Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1693.85 178.55L1595.7 208.656L1617.66 166.523L1609.91 119.628L1693.85 178.55ZM1515.07 188.477C1481.17 213.095 1433.79 205.508 1409.17 171.608L1286.49 2.43135C1261.87 -31.4686 1269.46 -78.8477 1303.36 -103.465C1337.26 -128.083 1384.64 -120.496 1409.25 -86.5963L1531.94 82.5805C1556.56 116.48 1548.97 163.86 1515.07 188.477Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M563.128 429.488L483.786 364.352L531.004 359.348L565.791 326.982L563.128 429.488ZM456.02 285.979C416.793 271.37 396.857 227.703 411.547 188.476L484.593 -7.25551C499.202 -46.4826 542.869 -66.4189 582.096 -51.7289C621.323 -37.039 641.259 6.54653 626.569 45.7736L553.523 241.505C538.914 280.732 495.247 300.669 456.02 285.979Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1426.29 -288.786L1443.07 -187.49L1404.25 -214.852L1356.79 -213.399L1426.37 -288.786H1426.29ZM1412.32 -110.327C1432.18 -73.4409 1418.38 -27.5146 1381.57 -7.65891L1197.62 91.458C1160.74 111.314 1114.81 97.5116 1094.95 60.706C1075.1 23.9003 1088.9 -22.1067 1125.71 -41.9624L1309.65 -141.079C1346.54 -160.935 1392.47 -147.133 1412.32 -110.327Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1021.34 -150.683L1117.79 -185.793L1098.1 -142.531L1108.27 -96.12L1021.34 -150.602V-150.683ZM1199.4 -169.812C1232.01 -196.125 1279.71 -191.04 1306.02 -158.431L1437.26 4.12689C1463.57 36.7354 1458.49 84.4373 1425.88 110.75C1393.27 137.063 1345.57 131.978 1319.26 99.3694L1188.02 -63.1888C1161.7 -95.7973 1166.79 -143.499 1199.4 -169.812Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M721.086 5.9808L809.629 -45.9184L798.006 0.16938L816.328 43.9971L721.086 5.9808ZM892.765 -44.7884C920.046 -76.5091 967.91 -80.0604 999.63 -52.779L1157.99 83.5471C1189.71 110.828 1193.26 158.692 1165.98 190.413C1138.7 222.133 1090.84 225.685 1059.12 198.403L900.756 62.0771C869.035 34.7957 865.483 -13.0678 892.765 -44.7884Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M390.238 314.391L332.043 229.803L378.857 238.116L421.232 216.646L390.238 314.391ZM327.2 146.829C293.623 121.888 286.601 74.4282 311.542 40.7704L436.083 -127.034C461.024 -160.611 508.484 -167.633 542.142 -142.693C575.8 -117.752 582.741 -70.2922 557.8 -36.6344L433.258 131.17C408.318 164.747 360.858 171.769 327.2 146.829Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M715.514 12.7603L613.411 2.18683L650.055 -28.081L661.194 -74.2494L715.514 12.7603ZM546.983 -47.9367C506.223 -38.4931 465.462 -63.9987 456.099 -104.759L409.124 -308.401C399.68 -349.162 425.186 -389.922 465.946 -399.285C506.707 -408.648 547.467 -383.223 556.83 -342.462L603.806 -138.821C613.249 -98.0601 587.744 -57.2995 546.983 -47.9367Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1039.66 -183.456L1142.33 -184.908L1109.48 -150.605L1103.75 -103.468L1039.66 -183.536V-183.456ZM1214.09 -142.856C1253.47 -156.981 1296.9 -136.399 1311.02 -97.0108L1381.41 99.7701C1395.53 139.159 1374.95 182.583 1335.56 196.708C1296.17 210.833 1252.75 190.251 1238.62 150.862L1168.24 -45.9189C1154.11 -85.3074 1174.7 -128.732 1214.09 -142.856Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1187.85 312.13L1161.38 212.933L1202.7 236.421L1249.84 230.367L1187.93 312.13H1187.85ZM1184.54 133.026C1161.22 98.2382 1170.5 51.1818 1205.29 27.8554L1378.82 -88.5343C1413.61 -111.861 1460.66 -102.579 1483.99 -67.7908C1507.32 -33.003 1498.04 14.0533 1463.25 37.3797L1289.71 153.769C1254.92 177.096 1207.87 167.814 1184.54 133.026Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M979.615 277.827L876.947 276.455L910.685 243.039L917.627 196.064L979.534 277.827H979.615ZM806.322 232.546C766.53 245.541 723.751 223.91 710.676 184.118L645.62 -14.4388C632.625 -54.2309 654.257 -97.0094 694.049 -110.085C733.841 -123.161 776.619 -101.449 789.695 -61.6566L854.75 136.9C867.745 176.692 846.114 219.471 806.322 232.546Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M152.776 102.679L138.328 1.05984L176.506 29.3098L224.047 28.987L152.776 102.76V102.679ZM170.937 -75.4571C151.969 -112.747 166.82 -158.431 204.11 -177.399L390.318 -272.157C427.607 -291.125 473.292 -276.274 492.259 -238.984C511.227 -201.694 496.376 -156.01 459.086 -137.042L272.879 -42.2836C235.589 -23.3158 189.904 -38.1672 170.937 -75.4571Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1063.96 -402.027L1162.75 -374.1L1121.51 -350.612L1102.62 -307.026L1064.04 -402.027H1063.96ZM1219.57 -313.322C1261.38 -315.582 1297.06 -283.539 1299.4 -241.729L1310.7 -33.0826C1312.96 8.72726 1280.92 44.4029 1239.11 46.7436C1197.3 49.0843 1161.62 16.96 1159.28 -24.8499L1147.98 -233.496C1145.72 -275.306 1177.76 -310.981 1219.57 -313.322Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M965.083 124.632L1039.42 53.8452L1038.61 101.386L1066.46 139.886L965.002 124.712L965.083 124.632ZM1120.62 35.9267C1139.99 -1.2018 1185.76 -15.6495 1222.88 3.72184L1408.2 100.256C1445.33 119.627 1459.78 165.392 1440.41 202.521C1421.04 239.649 1375.27 254.097 1338.14 234.726L1152.82 138.192C1115.7 118.82 1101.25 73.0552 1120.62 35.9267Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M980.499 68.2108L919.882 -14.6018L966.858 -7.74109L1008.59 -30.4217L980.499 68.2108ZM912.537 -97.4952C878.234 -121.467 869.759 -168.685 893.731 -203.069L1013.27 -374.425C1037.24 -408.729 1084.46 -417.204 1118.84 -393.232C1153.23 -369.26 1161.62 -322.042 1137.65 -287.658L1018.11 -116.302C994.139 -81.998 946.921 -73.5232 912.537 -97.4952Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M987.924 9.21087L1076.23 -43.1725L1064.84 2.91518L1083.41 46.6622L987.924 9.21087ZM1159.36 -42.5268C1186.48 -74.4089 1234.34 -78.2025 1266.23 -51.0826L1425.31 84.4365C1457.2 111.556 1460.99 159.42 1433.87 191.302C1406.75 223.184 1358.89 226.978 1327 199.858L1167.92 64.3386C1136.03 37.2187 1132.24 -10.6447 1159.36 -42.5268Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M708.33 -70.3748L807.124 -42.4476L765.879 -18.9598L746.992 24.6258L708.411 -70.3748H708.33ZM863.947 18.3301C905.757 16.0701 941.432 48.1135 943.773 89.9235L955.073 298.569C957.333 340.379 925.289 376.055 883.48 378.396C841.67 380.736 805.994 348.612 803.653 306.802L792.353 98.1563C790.093 56.3464 822.137 20.6708 863.947 18.3301Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1311.99 42.3828L1213.84 72.4892L1235.8 30.3564L1228.05 -16.5385L1311.99 42.3828ZM1133.21 52.3107C1099.31 76.9285 1051.93 69.3413 1027.31 35.4413L904.627 -133.735C880.009 -167.635 887.597 -215.014 921.497 -239.632C955.396 -264.25 1002.78 -256.663 1027.39 -222.763L1150.08 -53.5863C1174.7 -19.6864 1167.11 27.6929 1133.21 52.3107Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M647.477 260.072L653.046 157.565L685.089 192.675L731.742 201.554L647.557 260.072H647.477ZM699.779 88.7963C688.399 48.5199 711.806 6.62935 752.082 -4.75134L953.141 -61.6548C993.417 -73.0355 1035.31 -49.6283 1046.69 -9.35198C1058.07 30.9244 1034.66 72.8149 994.386 84.1956L793.327 141.099C753.051 152.48 711.16 129.073 699.779 88.7963Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M324.782 -125.743L399.12 -196.529L398.312 -148.988L426.159 -110.488L324.701 -125.662L324.782 -125.743ZM480.399 -214.528C499.77 -251.657 545.535 -266.105 582.663 -246.733L767.983 -150.199C805.111 -130.828 819.559 -85.0629 800.188 -47.9344C780.816 -10.8059 735.052 3.64194 697.923 -15.7294L512.604 -112.263C475.475 -131.635 461.027 -177.4 480.399 -214.528Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M679.201 -21.3796L775.655 -56.4902L755.96 -13.2275L766.13 33.1831L679.201 -21.2989V-21.3796ZM857.176 -40.5088C889.784 -66.8215 937.486 -61.7367 963.799 -29.1282L1095.04 133.43C1121.35 166.039 1116.27 213.741 1083.66 240.053C1051.05 266.366 1003.35 261.281 977.036 228.673L845.795 66.1145C819.482 33.506 824.567 -14.196 857.176 -40.5088Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M751.354 -50.1961L854.022 -51.6489L821.171 -17.3454L815.441 29.7916L751.354 -50.2767V-50.1961ZM925.777 -9.59689C965.165 -23.7219 1008.59 -3.13969 1022.71 36.2488L1093.1 233.03C1107.22 272.418 1086.64 315.842 1047.25 329.967C1007.86 344.092 964.439 323.51 950.314 284.122L879.931 87.3408C865.806 47.9523 886.388 4.52808 925.777 -9.59689Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M931.668 298.813L905.193 199.615L946.519 223.103L993.656 217.049L931.748 298.813H931.668ZM928.358 119.789C905.032 85.0013 914.314 37.9448 949.102 14.6184L1122.64 -101.771C1157.42 -125.098 1204.48 -115.815 1227.81 -81.0277C1251.13 -46.2399 1241.85 0.816399 1207.06 24.1428L1033.53 140.532C998.741 163.859 951.685 154.577 928.358 119.789Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M603.732 -291.286L635.13 -193.541L592.674 -214.93L545.941 -206.536L603.732 -291.286ZM615.92 -112.585C640.941 -79.0079 634 -31.548 600.423 -6.52667L432.861 118.338C399.283 143.359 351.823 136.418 326.802 102.841C301.781 69.2639 308.722 21.804 342.299 -3.21738L509.862 -128.082C543.439 -153.103 590.899 -146.162 615.92 -112.585Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M691.543 66.923L714.789 -33.0818L740.214 7.03313L784.606 23.9023L691.543 66.923ZM772.741 -92.6488C768.464 -134.297 798.812 -171.506 840.461 -175.704L1048.38 -196.851C1090.03 -201.129 1127.24 -170.78 1131.43 -129.132C1135.63 -87.4832 1105.36 -50.2739 1063.72 -46.0768L855.796 -24.9297C814.148 -20.6519 776.938 -51.0004 772.741 -92.6488Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M940.148 -179.177L1038.94 -151.249L997.697 -127.762L978.81 -84.176L940.229 -179.177H940.148ZM1095.68 -90.4717C1137.49 -92.7317 1173.17 -60.6882 1175.51 -18.8783L1186.81 189.768C1189.07 231.578 1157.03 267.253 1115.22 269.594C1073.41 271.935 1037.73 239.81 1035.39 198L1024.09 -10.6454C1021.83 -52.4553 1053.87 -88.131 1095.68 -90.4717Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M413.892 297.845L387.418 198.647L428.744 222.135L475.881 216.082L413.973 297.845H413.892ZM410.583 118.821C387.257 84.0333 396.539 36.977 431.326 13.6506L604.862 -102.739C639.65 -126.065 686.706 -116.783 710.032 -81.9955C733.359 -47.2077 724.076 -0.151436 689.289 23.1749L515.753 139.565C480.966 162.891 433.909 153.609 410.583 118.821Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1347.43 -140.512L1355.5 -38.1668L1319.1 -68.7574L1271.64 -71.421L1347.43 -140.593V-140.512ZM1318.21 36.0901C1334.84 74.5101 1317.16 119.145 1278.74 135.772L1086.96 218.746C1048.54 235.373 1003.91 217.697 987.28 179.277C970.653 140.857 988.329 96.2222 1026.75 79.595L1218.53 -3.37904C1256.95 -20.0061 1301.58 -2.32977 1318.21 36.0901Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M642.223 -419.219L711.637 -343.59L664.177 -345.204L625.192 -318.003L642.223 -419.138V-419.219ZM728.103 -262.149C764.909 -242.132 778.469 -196.125 758.451 -159.32L658.608 24.2242C638.591 61.0299 592.584 74.5899 555.778 54.5728C518.973 34.5557 505.413 -11.4514 525.43 -48.257L625.273 -231.801C645.29 -268.606 691.297 -282.166 728.103 -262.149Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1270.26 -198.707L1339.68 -123.078L1292.22 -124.692L1253.23 -97.4912L1270.26 -198.626V-198.707ZM1356.14 -41.5563C1392.95 -21.5392 1406.51 24.4679 1386.49 61.2735L1286.65 244.817C1266.63 281.623 1220.62 295.183 1183.82 275.166C1147.01 255.149 1133.45 209.142 1153.47 172.336L1253.31 -11.2078C1273.33 -48.0135 1319.34 -61.5734 1356.14 -41.5563Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M819.961 -423.578L889.376 -347.949L841.916 -349.563L802.931 -322.363L819.961 -423.497V-423.578ZM905.841 -266.508C942.647 -246.491 956.207 -200.484 936.19 -163.679L836.346 19.8652C816.329 56.6708 770.322 70.2307 733.517 50.2136C696.711 30.1965 683.151 -15.8104 703.168 -52.6161L803.011 -236.16C823.029 -272.966 869.036 -286.526 905.841 -266.508Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-139.759 284.393L-158.727 183.5L-119.338 209.974L-71.8782 207.553L-139.839 284.393H-139.759ZM-129.589 105.611C-150.252 69.2088 -137.418 22.9595 -101.016 2.29665L80.8329 -100.694C117.235 -121.357 163.484 -108.524 184.147 -72.1217C204.81 -35.7197 191.976 10.5296 155.574 31.1924L-26.2747 134.184C-62.6767 154.846 -108.926 142.013 -129.589 105.611Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M987.739 145.08L927.123 62.2674L974.098 69.1279L1015.83 46.4473L987.739 145.08ZM919.778 -20.5453C885.474 -44.5174 876.999 -91.735 900.971 -126.119L1020.51 -297.475C1044.48 -331.779 1091.7 -340.254 1126.08 -316.282C1160.47 -292.31 1168.86 -245.092 1144.89 -210.708L1025.35 -39.3516C1001.38 -5.0481 954.162 3.42676 919.778 -20.5453Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1028.52 99.1669L930.368 129.273L952.323 87.1406L944.574 40.2457L1028.52 99.1669ZM849.735 109.014C815.835 133.632 768.456 126.045 743.838 92.1448L621.152 -77.0319C596.535 -110.932 604.122 -158.311 638.022 -182.929C671.922 -207.547 719.301 -199.959 743.919 -166.06L866.604 3.11716C891.222 37.0171 883.635 84.3962 849.735 109.014Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1072.99 -81.7939L1149.34 -150.401L1147.16 -102.941L1173.88 -63.714L1072.91 -81.7939H1072.99ZM1231.03 -166.059C1251.45 -202.623 1297.61 -215.699 1334.18 -195.359L1516.67 -93.5781C1553.24 -73.1574 1566.31 -26.989 1545.97 9.57452C1525.55 46.138 1479.38 59.2135 1442.82 38.8735L1260.32 -62.9068C1223.76 -83.3275 1210.69 -129.496 1231.03 -166.059Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M237.112 65.8336L137.753 91.7428L161.403 50.5786L155.672 3.44154L237.032 65.8336H237.112ZM58.0887 68.1742C23.2202 91.2584 -23.8362 81.7343 -47.0011 46.8658L-162.422 -127.315C-185.507 -162.184 -175.982 -209.24 -141.114 -232.405C-106.245 -255.57 -59.1889 -245.965 -36.024 -211.096L79.3972 -36.9155C102.481 -2.04701 92.9572 45.0092 58.0887 68.1742Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M377.556 -218.359L402.82 -118.839L361.817 -142.811L314.6 -137.403L377.556 -218.359ZM378.606 -39.3351C401.448 -4.30518 391.601 42.6704 356.571 65.5932L181.583 179.804C146.553 202.646 99.5771 192.798 76.6543 157.769C53.7315 122.739 63.6594 75.7631 98.6894 52.8403L273.677 -61.3701C308.707 -84.2122 355.683 -74.365 378.606 -39.3351Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M103.526 -236.604L181.899 -170.338L134.601 -165.979L99.3287 -134.097L103.445 -236.604H103.526ZM208.535 -91.5605C247.52 -76.3863 266.81 -32.3973 251.636 6.5876L175.684 201.27C160.51 240.255 116.521 259.546 77.5358 244.371C38.5509 229.197 19.2603 185.208 34.4345 146.223L110.387 -48.4592C125.561 -87.4441 169.55 -106.735 208.535 -91.5605Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-114.965 -112.141L-17.7851 -79.0483L-60.2407 -57.7396L-81.3877 -15.2034L-114.965 -112.141ZM35.7284 -15.3647C77.619 -15.3647 111.6 18.4543 111.68 60.3449L112.003 269.314C112.003 311.204 78.1839 345.185 36.2933 345.266C-5.59731 345.346 -39.5779 311.447 -39.6586 269.556L-39.9815 60.587C-39.9815 18.6964 -6.16225 -15.284 35.7284 -15.3647Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M437.12 132.989L344.622 177.463L359.958 132.505L345.268 87.3049L437.12 132.909V132.989ZM261.809 169.633C232.026 199.013 184.001 198.69 154.621 168.826L7.96342 19.9894C-21.4165 -9.79412 -21.0936 -57.819 8.77061 -87.1989C38.6348 -116.579 86.579 -116.256 115.959 -86.3917L262.616 62.4451C291.996 92.2286 291.673 140.253 261.809 169.633Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-28.8398 -166.139L59.7035 -218.038L48.0807 -171.95L66.4028 -128.122L-28.8398 -166.139ZM142.92 -216.908C170.201 -248.628 218.065 -252.18 249.785 -224.899L408.146 -88.5724C439.867 -61.2911 443.418 -13.4277 416.137 18.2929C388.856 50.0136 340.992 53.5649 309.271 26.2835L150.91 -110.042C119.19 -137.324 115.638 -185.187 142.92 -216.908Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M499.761 168.742L441.566 84.1533L488.381 92.4668L530.755 70.9968L499.761 168.742ZM436.723 1.1792C403.146 -23.7614 396.124 -71.2215 421.065 -104.879L545.607 -272.684C570.548 -306.261 618.008 -313.283 651.665 -288.342C685.323 -263.402 692.264 -215.942 667.324 -182.284L542.782 -14.4793C517.841 19.0977 470.381 26.1198 436.723 1.1792Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-57.5799 71.2422L-107.138 -18.6732L-61.3734 -5.83972L-17.0615 -23.0319L-57.5799 71.2422ZM-103.829 -101.728C-134.823 -129.897 -137.164 -177.841 -108.995 -208.836L31.5284 -363.565C59.6977 -394.559 107.642 -396.9 138.636 -368.73C169.63 -340.561 171.971 -292.617 143.802 -261.623L3.2785 -106.894C-24.8907 -75.8997 -72.8349 -73.5589 -103.829 -101.728Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M643.35 123.868L719.706 55.2615L717.526 102.721L744.243 141.948L643.27 123.868H643.35ZM801.388 39.6835C821.809 3.12002 867.978 -9.9557 904.541 10.3842L1087.04 112.165C1123.6 132.586 1136.67 178.754 1116.33 215.317C1095.91 251.881 1049.75 264.956 1013.18 244.616L830.688 142.836C794.124 122.415 781.048 76.247 801.388 39.6835Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M727.775 290.538L708.807 189.646L748.195 216.12L795.655 213.698L727.694 290.538H727.775ZM737.944 111.837C717.282 75.4352 730.115 29.1861 766.517 8.52329L948.366 -94.468C984.768 -115.131 1031.02 -102.297 1051.68 -65.8951C1072.34 -29.4931 1059.51 16.756 1023.11 37.4188L841.258 140.41C804.856 161.073 758.607 148.239 737.944 111.837Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M249.059 -194.79L346.723 -226.43L325.495 -183.974L333.97 -137.24L249.059 -194.79ZM427.679 -207.462C461.175 -232.564 508.716 -225.784 533.818 -192.287L659.167 -25.0478C684.269 8.44856 677.489 55.9891 643.993 81.0912C610.496 106.193 562.956 99.4133 537.854 65.9169L412.505 -101.323C387.403 -134.819 394.183 -182.36 427.679 -207.462Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M309.271 -51.4433L340.669 46.3014L298.214 24.9122L251.48 33.2257L309.271 -51.524V-51.4433ZM321.459 127.177C346.48 160.754 339.539 208.214 305.962 233.235L138.4 358.1C104.822 383.121 57.3626 376.18 32.3412 342.603C7.31985 309.026 14.2612 261.566 47.8383 236.544L215.401 111.68C248.978 86.6585 296.438 93.5998 321.459 127.177Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M356.805 70.1137L281.741 0.0537109L329.201 -1.96414L366.007 -32.0703L356.805 70.1137ZM259.061 -79.9337C220.883 -97.0451 203.772 -141.922 220.883 -180.1L306.359 -370.747C323.471 -408.925 368.348 -426.036 406.525 -408.924C444.703 -391.813 461.814 -346.936 444.703 -308.758L359.227 -118.112C342.115 -79.9338 297.238 -62.8224 259.061 -79.9337Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M307.572 68.9796L205.63 57.0338L242.678 27.2505L254.462 -18.7566L307.653 68.9796H307.572ZM139.929 6.10324C99.0069 14.9818 58.6499 -11.0081 49.7713 -51.9302L5.5399 -256.137C-3.33865 -297.059 22.6513 -337.416 63.5734 -346.294C104.495 -355.173 144.852 -329.183 153.731 -288.261L197.962 -84.0543C206.841 -43.1322 180.851 -2.7753 139.929 6.10324Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M358.262 373.516L256.158 362.943L292.803 332.675L303.941 286.506L358.262 373.516ZM189.811 312.9C149.051 322.343 108.29 296.838 98.9274 256.077L51.9517 52.4356C42.5081 11.675 68.0139 -29.0857 108.774 -38.4485C149.535 -47.8921 190.296 -22.3863 199.659 18.3743L246.634 222.016C256.078 262.776 230.572 303.537 189.811 312.9Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-3.98438 -196.245L98.684 -197.698L65.8333 -163.395L60.1026 -116.257L-3.98438 -196.326V-196.245ZM170.439 -155.646C209.827 -169.771 253.251 -149.189 267.376 -109.8L337.759 86.9808C351.884 126.369 331.302 169.793 291.914 183.918C252.525 198.043 209.101 177.461 194.976 138.073L124.593 -58.7083C110.468 -98.0968 131.05 -141.521 170.439 -155.646Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M422.92 140.894L373.362 50.978L419.127 63.8117L463.439 46.6196L422.92 140.894ZM376.671 -32.1574C345.677 -60.3267 343.336 -108.271 371.505 -139.265L512.028 -293.994C540.198 -324.988 588.142 -327.329 619.136 -299.16C650.13 -270.99 652.471 -223.046 624.302 -192.052L483.778 -37.323C455.609 -6.3288 407.665 -3.98822 376.671 -32.1574Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M704.935 157.767L650.776 70.5956L697.106 81.0076L740.45 61.5557L704.935 157.767ZM649.727 -12.6206C617.28 -39.0948 612.518 -86.8777 638.992 -119.244L771.282 -280.995C797.756 -313.442 845.539 -318.204 877.906 -291.73C910.272 -265.256 915.115 -217.473 888.641 -185.107L756.35 -23.3557C729.876 9.09137 682.093 13.8536 649.727 -12.6206Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M402.25 71.9668L320.083 10.4627L367.059 3.27933L400.313 -30.6207L402.25 71.8863V71.9668ZM288.766 -66.6191C248.893 -79.4527 227.101 -122.231 239.934 -162.023L304.183 -360.903C317.016 -400.776 359.795 -422.568 399.587 -409.735C439.379 -396.901 461.252 -354.123 448.419 -314.331L384.17 -115.451C371.337 -75.5785 328.558 -53.7856 288.766 -66.6191Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M335.34 -222.639L431.309 -259.122L412.18 -215.617L422.995 -169.368L335.34 -222.639ZM513.072 -244.27C545.277 -271.067 593.06 -266.628 619.776 -234.423L753.358 -73.7214C780.155 -41.5165 775.716 6.2663 743.511 32.9827C711.306 59.699 663.523 55.3405 636.807 23.1355L503.225 -137.566C476.428 -169.771 480.867 -217.554 513.072 -244.27Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-232.324 74.8731L-143.781 22.974L-155.404 69.0617L-137.082 112.889L-232.324 74.8731ZM-60.6453 24.1039C-33.364 -7.61673 14.4996 -11.1681 46.2202 16.1133L204.581 152.439C236.302 179.721 239.853 227.584 212.572 259.305C185.291 291.025 137.427 294.577 105.706 267.295L-52.6546 130.969C-84.3752 103.688 -87.9267 55.8245 -60.6453 24.1039Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M465.453 -136.193L459.318 -33.6865L427.517 -68.9585L380.864 -78.0793L465.453 -136.113V-136.193ZM412.101 34.7591C423.239 75.1162 399.59 116.845 359.313 128.065L157.932 183.838C117.575 194.977 75.8456 171.327 64.6263 131.051C53.407 90.7747 77.1369 48.9648 117.413 37.7455L318.795 -18.028C359.152 -29.1665 400.881 -5.51721 412.101 34.7591Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "724",
                            height: "1448",
                            transform: "translate(1440 -80.9999) rotate(90)",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M1848.69 -161.878L1757.55 -237.61C1620.1 -351.828 1451.52 -349.573 1349.08 -226.288L1839.15 180.925C1864.55 202.031 1895.97 197.646 1917.21 172.087L2326.98 -321.054C2204.46 -422.857 2039.83 -391.91 1924.9 -253.59L1848.69 -161.878ZM1887.1 284.312L1795.96 208.58C1658.51 94.3619 1491.18 95.114 1388.74 218.399L1878.81 625.612C1904.21 646.717 1935.88 645.077 1957.12 619.518L2366.88 126.378C2244.37 24.5745 2078.24 54.2799 1963.31 192.6L1887.1 284.312ZM1928.26 730.24L1837.12 654.508C1699.66 540.29 1531.09 542.546 1428.65 665.831L1918.71 1073.04C1944.11 1094.15 1975.54 1089.76 1995.53 1065.71L2405.29 572.568C2282.78 470.765 2118.15 501.711 2003.21 640.031L1928.26 730.24Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M37.1931 -209.403L-81.2826 -211.715C-259.967 -215.202 -390.29 -108.256 -393.417 52.0055L243.632 64.4372C276.65 65.0816 298.472 42.0455 299.121 8.82061L311.63 -632.226C152.368 -635.334 43.0284 -508.427 39.5196 -328.622L37.1931 -209.403ZM345.617 115.306L227.141 112.994C48.4564 109.507 -81.8281 214.498 -84.9555 374.76L552.094 387.192C585.112 387.836 608.838 366.792 609.486 333.567L621.996 -307.479C462.734 -310.587 351.452 -183.718 347.943 -3.91272L345.617 115.306ZM656.021 438.099L537.545 435.787C358.86 432.3 228.538 539.245 225.41 699.507L862.46 711.939C895.478 712.583 917.3 689.547 917.91 658.276L930.42 17.2298C771.157 14.1218 661.818 141.028 658.309 320.834L656.021 438.099Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M296.845 -300.694L219.958 -390.863C103.998 -526.854 -62.4873 -553.385 -184.457 -449.381L228.966 35.457C250.393 60.5858 282.107 61.6255 307.394 40.0637L795.274 -375.953C691.918 -497.163 524.423 -494.751 387.579 -378.063L296.845 -300.694ZM258.583 145.508L181.696 55.3403C65.7361 -80.6508 -99.2618 -108.451 -221.232 -4.44649L192.191 480.392C213.619 505.52 245.106 509.307 270.392 487.745L758.272 71.7276C654.916 -49.4819 486.161 -48.5483 349.317 68.1394L258.583 145.508ZM223.069 591.921L146.182 501.753C30.2221 365.762 -136.263 339.23 -258.233 443.235L155.19 928.073C176.617 953.201 208.331 954.241 232.13 933.948L720.01 517.93C616.655 396.721 449.16 399.133 312.315 515.82L223.069 591.921Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M329.199 698.785L313.025 816.174C288.631 993.22 379.574 1135.17 538.366 1157.05L625.336 525.845C629.843 493.13 609.522 468.759 576.602 464.223L-58.5657 376.708C-80.3081 534.51 32.9168 657.962 211.074 682.509L329.199 698.785ZM687.801 430.521L671.627 547.91C647.233 724.956 736.24 866.642 895.032 888.521L982.001 257.314C986.509 224.599 968.389 198.571 935.469 194.035L300.301 106.52C278.559 264.321 391.519 389.698 569.675 414.245L687.801 430.521ZM1044.73 160.066L1028.56 277.455C1004.16 454.501 1095.11 596.454 1253.9 618.333L1340.87 -12.8748C1345.38 -45.5899 1325.05 -69.9602 1294.07 -74.2292L658.903 -161.745C637.161 -3.94262 750.386 119.51 928.542 144.057L1044.73 160.066Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M879.229 169.576L840.243 57.6752C781.444 -111.094 635.889 -196.152 484.52 -143.416L694.151 458.283C705.016 489.469 734.198 501.93 765.579 490.997L1371.05 280.051C1318.65 129.626 1161.66 71.178 991.832 130.346L879.229 169.576ZM681.875 571.587L642.889 459.685C584.09 290.916 440.381 205.215 289.012 257.951L498.643 859.65C509.508 890.836 537.483 905.775 568.864 894.842L1174.34 683.896C1121.93 533.471 964.307 473.188 794.478 532.356L681.875 571.587ZM487.006 974.788L448.02 862.887C389.221 694.118 243.666 609.06 92.2971 661.796L301.928 1263.49C312.793 1294.68 341.974 1307.14 371.51 1296.85L976.984 1085.91C924.576 935.481 767.592 877.033 597.763 936.201L487.006 974.788Z",
                            fill: "#8FB8F6"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M538.365 1157.05C379.573 1135.17 288.63 993.22 313.024 816.174L329.198 698.786L211.073 682.509C174.933 677.53 141.465 668.48 111.253 655.899C255.689 616.322 391.679 701.177 448.019 862.887L487.005 974.789L567.335 946.801L538.365 1157.05ZM569.675 414.246C450.012 397.758 359.763 335.781 319.988 249.045C448.144 219.964 566.839 289.223 627.856 422.261L569.675 414.246ZM576.602 464.223C609.522 468.759 629.842 493.13 625.335 525.844L574.778 892.78L568.862 894.841C537.481 905.775 509.507 890.836 498.642 859.65L349.998 433.001L576.602 464.223ZM935.469 194.035C968.389 198.571 986.509 224.599 982.001 257.314L959.094 423.576L765.577 490.997C734.196 501.93 705.014 489.468 694.149 458.283L686.859 437.356L687.801 430.521L684.311 430.04L585.276 145.784L935.469 194.035ZM865.633 130.555C730.414 90.2587 647.067 -14.1394 657.046 -144.432C737.818 -115.384 804.794 -44.0668 840.241 57.6754L865.633 130.555ZM910.563 775.794L759.495 828.425C688.988 766.703 655.487 665.046 671.626 547.911L672.193 543.798L681.874 571.587L794.478 532.356C847.465 513.895 899.265 507.062 947.052 510.968L910.563 775.794ZM1296.95 305.868L1030.46 398.713C1023.51 361.157 1022.65 320.335 1028.56 277.455L1044.73 160.066L945.694 146.42L991.831 130.346C1119.23 85.9618 1239.4 107.761 1313.62 184.923L1296.95 305.868Z",
                            fill: "#1558BC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M1503.9 -221.47L1464.91 -333.371C1406.11 -502.141 1260.56 -587.199 1109.19 -534.463L1318.82 67.2363C1329.69 98.422 1358.87 110.883 1390.25 99.9502L1995.72 -110.996C1943.32 -261.42 1786.33 -319.869 1616.5 -260.701L1503.9 -221.47ZM1306.54 180.54L1267.56 68.6389C1208.76 -100.13 1065.05 -185.832 913.682 -133.095L1123.31 468.604C1134.18 499.789 1162.15 514.728 1193.53 503.795L1799.01 292.849C1746.6 142.424 1588.98 82.1418 1419.15 141.309L1306.54 180.54ZM1111.68 583.742L1072.69 471.841C1013.89 303.071 868.336 218.013 716.967 270.749L926.598 872.448C937.463 903.634 966.644 916.095 996.18 905.805L1601.65 694.859C1549.25 544.435 1392.26 485.987 1222.43 545.154L1111.68 583.742Z",
                            fill: "#8FB8F6"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M198.886 -2.53919L99.1717 -66.5612C-51.2176 -163.119 -218.249 -140.273 -304.851 -5.38923L231.32 338.86C259.109 356.702 289.764 348.508 307.718 320.545L654.127 -218.99C520.084 -305.053 360.474 -254.212 263.31 -102.879L198.886 -2.53919ZM291.554 435.609L191.839 371.587C41.4499 275.029 -124.525 296.23 -211.127 431.114L325.043 775.363C352.833 793.205 384.066 787.706 402.02 759.742L748.429 220.207C614.387 134.145 453.141 183.936 355.977 335.269L291.554 435.609ZM386.912 873.161L287.198 809.14C136.808 712.582 -30.2228 735.428 -116.825 870.311L419.346 1214.56C447.135 1232.4 477.79 1224.21 494.688 1197.89L841.097 658.355C707.054 572.293 547.443 623.133 450.28 774.466L386.912 873.161Z",
                            fill: "#8FB8F6"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M307.719 320.545C289.765 348.509 259.11 356.703 231.32 338.861L-121.837 112.115L-221.23 -4.44694C-99.2605 -108.451 65.7372 -80.6509 181.697 55.3402L258.584 145.508L349.317 68.139C404.443 21.1333 464.747 -7.08895 523.868 -16.109L307.719 320.545ZM402.02 759.743C384.066 787.706 352.833 793.206 325.044 775.364L-211.127 431.115C-203.74 419.61 -195.776 408.932 -187.293 399.084C-76.9525 352.626 51.4693 390.677 146.184 501.752L223.07 591.92L312.316 515.82C406.382 435.609 514.931 409.395 607.175 440.213L402.02 759.743ZM232.131 933.947C208.332 954.24 176.618 953.2 155.19 928.072L15.3603 764.086C97.4661 735.761 195.43 750.22 287.198 809.14L339.281 842.579L232.131 933.947ZM270.394 487.744C245.107 509.306 213.62 505.52 192.192 480.391L51.9111 315.876C98.1955 323.465 145.75 341.995 191.84 371.587L291.555 435.61L355.978 335.269C426.12 226.023 529.657 169.693 632.248 179.189L270.394 487.744ZM307.395 40.0629C282.108 61.6247 250.394 60.5852 228.967 35.4564L193.764 -5.82875L198.887 -2.53872L263.311 -102.879C354.332 -244.645 500.155 -298.223 628.423 -233.679L307.395 40.0629Z",
                            fill: "#1558BC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M510.199 866.513L494.025 983.902C469.631 1160.95 560.574 1302.9 719.366 1324.78L806.336 693.572C810.843 660.857 790.522 636.487 757.602 631.951L122.434 544.436C100.692 702.238 213.917 825.69 392.074 850.237L510.199 866.513ZM868.801 598.249L852.627 715.638C828.233 892.684 917.24 1034.37 1076.03 1056.25L1163 425.041C1167.51 392.326 1149.39 366.299 1116.47 361.763L481.301 274.247C459.559 432.049 572.519 557.426 750.675 581.973L868.801 598.249ZM1225.73 327.794L1209.56 445.183C1185.16 622.229 1276.11 764.182 1434.9 786.06L1521.87 154.853C1526.38 122.138 1506.05 97.7676 1475.07 93.4985L839.903 5.98327C818.161 163.785 931.386 287.238 1109.54 311.785L1225.73 327.794Z",
                            fill: "#1868DB"
                        })
                    ]
                })
            ]
        })
    });
const $460ff537c7911762$export$20a09cdb7c5c22c2 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            width: '100%'
        },
        xmlns: "http://www.w3.org/2000/svg",
        width: "1440",
        height: "16",
        viewBox: "0 0 1440 16",
        fill: "none",
        preserveAspectRatio: "xMidYMid slice",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1440 -595.542H0.640625V611.939H1440V-595.542Z",
                fill: "#CB7FF5"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M972.322 -144.352L1011.06 -99.1573L983.597 -101.075L960.485 -86.1041L972.369 -144.352H972.322ZM1018.97 -51.6234C1039.88 -39.3189 1046.8 -12.3706 1034.5 8.54243L972.977 112.873C960.673 133.786 933.724 140.711 912.811 128.406C891.898 116.102 884.974 89.1533 897.279 68.2403L958.801 -36.0907C971.106 -57.0037 998.054 -63.928 1018.97 -51.6234Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1198.48 287.663L1146.55 258.609L1172.98 250.937L1189.55 228.901L1198.48 287.663ZM1122.74 216.643C1098.88 212.292 1083.06 189.414 1087.41 165.507L1109.17 46.3447C1113.52 22.4842 1136.4 6.67088 1160.3 11.0219C1184.21 15.3729 1199.98 38.2509 1195.63 62.1581L1173.87 181.32C1169.52 205.181 1146.64 220.994 1122.74 216.643Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M515.791 -125.778L556.026 -81.9403L528.517 -82.8761L505.919 -67.1095L515.791 -125.731V-125.778ZM565.57 -34.6874C586.904 -23.0846 594.764 3.58305 583.162 24.9171L525.288 131.307C513.686 152.641 487.018 160.501 465.684 148.898C444.35 137.295 436.49 110.628 448.093 89.2935L505.966 -17.0961C517.569 -38.4301 544.236 -46.2901 565.57 -34.6874Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M952.953 142.629L932.835 86.6268L957.818 98.1828L984.766 92.4281L952.953 142.675V142.629ZM942.332 39.3737C927.174 20.4257 930.262 -7.22443 949.21 -22.3828L1043.81 -98.0345C1062.76 -113.193 1090.41 -110.105 1105.57 -91.157C1120.72 -72.209 1117.64 -44.559 1098.69 -29.4006L1004.09 46.2511C985.141 61.4095 957.491 58.3217 942.332 39.3737Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M235.22 -127.088L281.678 -89.8938L254.309 -86.6656L234.378 -67.6708L235.22 -127.135V-127.088ZM298.24 -44.6057C321.071 -36.3715 332.908 -11.201 324.673 11.6302L283.596 125.599C275.362 148.43 250.191 160.267 227.36 152.033C204.529 143.798 192.692 118.628 200.927 95.7968L242.004 -18.1721C250.238 -41.0033 275.409 -52.8399 298.24 -44.6057Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M366.781 -101.824L418.105 -131.907L411.368 -105.192L421.988 -79.7881L366.781 -101.824ZM466.293 -131.252C482.107 -149.638 509.85 -151.697 528.237 -135.884L620.03 -56.8634C638.416 -41.05 640.475 -13.3064 624.661 5.08018C608.848 23.4668 581.104 25.5254 562.718 9.71201L470.925 -69.3083C452.539 -85.1217 450.48 -112.865 466.293 -131.252Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M175.336 95.282L141.604 46.2512L168.74 51.0701L193.302 38.6252L175.336 95.282ZM138.797 -1.84402C119.335 -16.3007 115.264 -43.8104 129.721 -63.3199L201.91 -160.586C216.367 -180.049 243.877 -184.119 263.386 -169.663C282.896 -155.206 286.919 -127.696 272.463 -108.187L200.273 -10.9204C185.816 8.54228 158.307 12.6126 138.797 -1.84402Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M548.588 -220.331L608.099 -221.173L589.057 -201.289L585.735 -173.967L548.588 -220.378V-220.331ZM649.691 -196.798C672.522 -204.985 697.693 -193.055 705.88 -170.224L746.677 -56.1615C754.864 -33.3303 742.934 -8.15982 720.103 0.0275879C697.271 8.21501 672.101 -3.71519 663.914 -26.5464L623.117 -140.609C614.929 -163.44 626.86 -188.61 649.691 -196.798Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M637.715 63.6557L622.369 6.15657L646.323 19.7711L673.646 16.2622L637.762 63.6557H637.715ZM635.796 -40.1141C622.276 -60.2785 627.656 -87.5543 647.82 -101.075L748.409 -168.539C768.573 -182.06 795.849 -176.68 809.37 -156.516C822.891 -136.351 817.51 -109.075 797.346 -95.5545L696.758 -28.0903C676.593 -14.5693 649.317 -19.9497 635.796 -40.1141Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M910.145 -97.0986L950.38 -53.2609L922.87 -54.1965L900.273 -38.4299L910.145 -97.0518V-97.0986ZM959.924 -6.05448C981.258 5.54826 989.118 32.2158 977.515 53.5499L919.642 159.939C908.039 181.273 881.372 189.133 860.037 177.531C838.703 165.928 830.844 139.26 842.446 117.926L900.32 11.5367C911.922 -9.79739 938.59 -17.6572 959.924 -6.05448Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M449.262 -53.4015L472.187 1.52447L446.642 -8.76834L420.021 -1.65704L449.262 -53.4015ZM465.029 49.1986C481.123 67.3513 479.439 95.1416 461.286 111.236L370.616 191.519C352.464 207.613 324.673 205.929 308.579 187.776C292.485 169.624 294.169 141.833 312.322 125.739L402.992 45.4557C421.144 29.3616 448.935 31.046 465.029 49.1986Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M181.465 68.7549L203.36 13.4079L214.495 38.5784L238.496 52.0526L181.418 68.7081L181.465 68.7549ZM241.724 -15.786C242.847 -40.0208 263.432 -58.7349 287.667 -57.612L408.654 -51.9042C432.889 -50.7814 451.603 -30.1959 450.48 -5.96111C449.357 18.2736 428.771 36.9878 404.537 35.8649L283.55 30.1571C259.315 29.0343 240.601 8.44872 241.724 -15.786Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M296.415 -144.726L342.873 -107.532L315.504 -104.304L295.573 -85.3088L296.415 -144.773V-144.726ZM359.435 -62.2906C382.266 -54.0564 394.103 -28.8858 385.869 -6.05464L344.791 107.914C336.557 130.745 311.387 142.582 288.555 134.348C265.724 126.114 253.888 100.943 262.122 78.1119L303.199 -35.8569C311.433 -58.6881 336.604 -70.5248 359.435 -62.2906Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M230.776 82.0888L197.044 33.0578L224.179 37.8767L248.742 25.4318L230.776 82.0888ZM194.237 -15.0374C174.774 -29.494 170.704 -57.0038 185.16 -76.5133L257.35 -173.78C271.807 -193.242 299.316 -197.313 318.826 -182.856C338.335 -168.399 342.359 -140.89 327.902 -121.38L255.712 -24.1137C241.256 -4.65109 213.746 -0.580765 194.237 -15.0374Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M690.113 7.6535L674.768 -49.8456L698.722 -36.2311L726.044 -39.74L690.16 7.6535H690.113ZM688.242 -96.1161C674.721 -116.281 680.101 -143.556 700.266 -157.077L800.854 -224.542C821.018 -238.063 848.294 -232.682 861.815 -212.518C875.336 -192.353 869.956 -165.078 849.791 -151.557L749.203 -84.0924C729.038 -70.5715 701.763 -75.9517 688.242 -96.1161Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M971.572 -169.756L1011.81 -125.918L984.298 -126.854L961.701 -111.087L971.572 -169.709V-169.756ZM1021.35 -78.7121C1042.69 -67.1094 1050.55 -40.4417 1038.94 -19.1076L981.07 87.282C969.467 108.616 942.799 116.476 921.465 104.873C900.131 93.2705 892.271 66.6028 903.874 45.2688L961.747 -61.1208C973.35 -82.4549 1000.02 -90.3148 1021.35 -78.7121Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M315.504 -150.387L373.939 -139.159L351.248 -123.532L342.499 -97.4263L315.504 -150.387ZM409.729 -106.877C433.777 -110.245 456 -93.5431 459.368 -69.4955L476.258 50.4619C479.626 74.5095 462.924 96.7324 438.877 100.101C414.829 103.469 392.606 86.7672 389.237 62.7196L372.348 -57.2377C368.979 -81.2853 385.682 -103.508 409.729 -106.877Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-158.195 74.4159L-153.891 15.0454L-135.692 35.7246L-108.743 41.3387L-158.149 74.369L-158.195 74.4159ZM-126.054 -24.301C-132.229 -47.7871 -118.241 -71.788 -94.7546 -77.9636L22.3489 -108.842C45.8351 -115.017 69.8359 -101.029 76.0116 -77.5426C82.1872 -54.0564 68.1984 -30.0556 44.7122 -23.8799L-72.3912 6.99836C-95.8774 13.174 -119.878 -0.814781 -126.054 -24.301Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M316.347 -22.6166L311.014 36.6602L293.189 15.6537L266.334 9.52485L316.347 -22.6166ZM282.428 75.4921C288.183 99.0718 273.726 122.839 250.193 128.593L132.528 157.319C108.949 163.074 85.1817 148.617 79.4271 125.084C73.6725 101.551 88.1291 77.7377 111.662 71.9832L229.327 43.257C252.907 37.5024 276.674 51.9591 282.428 75.4921Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M407.625 45.4557L434.573 -7.5987L443.322 18.5075L466.013 34.1338L407.672 45.4557H407.625ZM475.464 -33.0967C478.832 -57.1443 501.055 -73.8466 525.103 -70.4781L645.06 -53.5885C669.108 -50.22 685.81 -27.9971 682.441 -3.94946C679.073 20.0981 656.85 36.8004 632.802 33.4319L512.845 16.5425C488.797 13.174 472.095 -9.0491 475.464 -33.0967Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1353.01 52.4736L1298.04 75.258L1308.38 49.7133L1301.32 23.0925L1353.01 52.427V52.4736ZM1250.41 68.0532C1232.21 84.1005 1204.47 82.3694 1188.38 64.17L1108.23 -26.6402C1092.19 -44.8396 1093.92 -72.5832 1112.12 -88.6773C1130.32 -104.771 1158.06 -102.994 1174.15 -84.7942L1254.3 6.01595C1270.34 24.2154 1268.61 51.9591 1250.41 68.0532Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M741.578 -90.6892L792.902 -120.772L786.165 -94.0578L796.785 -68.6533L741.578 -90.6892ZM841.09 -120.117C856.904 -138.504 884.647 -140.562 903.034 -124.749L994.827 -45.7286C1013.21 -29.9152 1015.27 -2.17159 999.458 16.215C983.645 34.6016 955.901 36.6603 937.515 20.8468L845.722 -58.1735C827.335 -73.9869 825.277 -101.73 841.09 -120.117Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M316.205 154.84L257.116 147.915L278.59 130.652L285.421 103.984L316.252 154.84H316.205ZM219.032 118.394C195.312 123.54 171.92 108.475 166.773 84.7552L141.135 -33.6113C135.989 -57.3314 151.053 -80.7241 174.774 -85.8705C198.494 -91.0168 221.886 -75.952 227.033 -52.2319L252.671 66.1348C257.817 89.8549 242.753 113.247 219.032 118.394Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M763.847 243.17L704.664 237.041L725.904 219.497L732.361 192.736L763.847 243.17ZM666.16 207.988C642.533 213.461 618.907 198.677 613.48 175.051L586.251 57.0116C580.777 33.385 595.561 9.75843 619.187 4.33134C642.814 -1.14253 666.44 13.6416 671.867 37.2682L699.096 155.307C704.57 178.934 689.786 202.56 666.16 207.988Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1036.14 -27.9502L1059.06 26.9758L1033.52 16.683L1006.9 23.7943L1036.14 -27.9502ZM1051.9 74.6031C1068 92.7558 1066.31 120.546 1048.16 136.64L957.491 216.924C939.339 233.018 911.548 231.334 895.454 213.181C879.36 195.028 881.044 167.238 899.197 151.144L989.867 70.8602C1008.02 54.7661 1035.81 56.4504 1051.9 74.6031Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M506.574 -152.165L560.003 -125.965L534.037 -116.842L518.738 -93.9642L506.621 -152.165H506.574ZM586.062 -85.4026C610.157 -82.3615 627.187 -60.3725 624.099 -36.2781L608.847 83.8663C605.806 107.961 583.817 124.991 559.722 121.903C535.628 118.815 518.598 96.8727 521.686 72.7783L536.938 -47.3662C539.979 -71.4606 561.968 -88.4904 586.062 -85.4026Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M509.896 -134.387L556.354 -97.1923L528.984 -93.9642L509.054 -74.9694L509.896 -134.433V-134.387ZM572.916 -51.9511C595.747 -43.7169 607.583 -18.5464 599.349 4.28482L558.272 118.254C550.038 141.085 524.867 152.921 502.036 144.687C479.205 136.453 467.368 111.283 475.602 88.4514L516.68 -25.5173C524.914 -48.3485 550.084 -60.1853 572.916 -51.9511Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M430.643 181.648L396.911 132.617L424.046 137.436L448.609 124.991L430.643 181.648ZM394.057 84.4748C374.594 70.0182 370.524 42.5085 384.981 22.9991L457.17 -74.2675C471.627 -93.7301 499.137 -97.8004 518.646 -83.3438C538.156 -68.8872 542.179 -41.3774 527.722 -21.8679L455.533 75.3985C441.076 94.8611 413.566 98.9314 394.057 84.4748Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M435.322 40.8238L376.139 34.695L397.379 17.1505L403.835 -9.61064L435.322 40.8238ZM337.681 5.68806C314.055 11.1619 290.428 -3.62222 285.001 -27.2488L257.772 -145.288C252.298 -168.914 267.082 -192.541 290.709 -197.968C314.335 -203.395 337.962 -188.658 343.389 -165.031L370.618 -46.992C376.092 -23.3655 361.308 0.260986 337.681 5.68806Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M415.531 -35.5293L412.49 23.888L393.87 3.58323L366.781 -1.46965L415.484 -35.5293H415.531ZM385.495 63.8425C392.185 87.1883 378.664 111.517 355.365 118.16L238.917 151.471C215.571 158.162 191.243 144.641 184.599 121.342C177.956 98.0425 191.43 73.6675 214.729 67.024L331.177 33.7129C354.523 27.0226 378.852 40.5434 385.495 63.8425Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M251.689 35.1633L278.638 -17.8913L287.387 8.21491L310.077 23.8412L251.736 35.1633H251.689ZM319.528 -43.3892C322.897 -67.4368 345.12 -84.1391 369.167 -80.7705L489.124 -63.8811C513.172 -60.5126 529.874 -38.2896 526.506 -14.2419C523.137 9.80566 500.914 26.5079 476.867 23.1394L356.909 6.24987C332.862 2.88133 316.16 -19.3416 319.528 -43.3892Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-54.2402 -15.2245L3.02487 0.963305L-20.8824 14.5777L-31.8301 39.8418L-54.1935 -15.2245H-54.2402ZM35.9149 36.1926C60.1496 34.8826 80.8287 53.4563 82.1855 77.6911L88.7354 198.631C90.0454 222.866 71.4716 243.545 47.2369 244.901C23.0022 246.258 2.32308 227.638 0.966312 203.403L-5.58359 82.4631C-6.89358 58.2283 11.6801 37.5494 35.9149 36.1926Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-112.721 -69.0276L-69.6316 -110.058L-70.0994 -82.5018L-53.9585 -60.1851L-112.768 -68.9808L-112.721 -69.0276ZM-22.5657 -120.445C-11.3372 -141.966 15.19 -150.34 36.7112 -139.112L144.13 -83.1567C165.651 -71.9282 174.026 -45.4011 162.797 -23.8799C151.569 -2.35866 125.042 6.01599 103.521 -5.21246L-3.89834 -61.1677C-25.4195 -72.3962 -33.7941 -98.9233 -22.5657 -120.445Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M448.983 21.3147L437.988 -37.1668L460.819 -21.8213L488.329 -23.2248L448.936 21.3147H448.983ZM454.878 -82.3146C442.901 -103.415 450.34 -130.223 471.44 -142.2L576.847 -201.898C597.947 -213.875 624.755 -206.436 636.732 -185.336C648.709 -164.235 641.27 -137.428 620.17 -125.451L514.763 -65.7525C493.663 -53.7755 466.855 -61.2144 454.878 -82.3146Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M666.768 24.6364L615.818 -6.10152L642.486 -12.9321L659.75 -34.4067L666.768 24.6364ZM593.361 -48.7696C569.641 -53.916 554.577 -77.3086 559.723 -100.982L585.361 -219.349C590.508 -243.069 613.9 -258.134 637.574 -252.987C661.247 -247.841 676.359 -224.448 671.212 -200.775L645.574 -82.4082C640.427 -58.6881 617.035 -43.6232 593.361 -48.7696Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M92.9937 281.394L57.858 233.392L85.0869 237.369L109.275 224.222L92.9937 281.394ZM53.6005 185.39C33.7168 171.495 28.8043 144.126 42.6995 124.195L111.988 24.8704C125.884 4.98663 153.253 0.0742445 173.184 13.9695C193.114 27.8647 197.98 55.234 184.085 75.1645L114.796 174.49C100.9 194.373 73.531 199.286 53.6005 185.39Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-185.846 -42.1263L-139.762 -79.7883L-142.289 -52.3722L-127.879 -28.9328L-185.846 -42.1263ZM-92.0413 -86.6189C-79.2221 -107.251 -52.1335 -113.567 -31.548 -100.748L71.3328 -36.8395C91.965 -24.0204 98.281 3.06825 85.4619 23.6538C72.6427 44.2393 45.5541 50.6021 24.9686 37.783L-77.9122 -26.1257C-98.5445 -38.9448 -104.86 -66.0334 -92.0413 -86.6189Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M184.834 -164.469L242.099 -148.282L218.192 -134.667L207.244 -109.403L184.881 -164.469H184.834ZM275.036 -113.053C299.271 -114.363 319.95 -95.7887 321.306 -71.5539L327.856 49.3858C329.166 73.6205 310.593 94.2997 286.358 95.6564C262.123 97.0132 241.444 78.3927 240.087 54.158L233.537 -66.7819C232.227 -91.0166 250.801 -111.696 275.036 -113.053Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M239.572 19.5836L210.846 -32.535L237.374 -25.0962L263.059 -35.0615L239.572 19.5836ZM212.811 -80.6771C194.846 -97.0051 193.489 -124.796 209.817 -142.761L291.27 -232.448C307.598 -250.414 335.389 -251.771 353.354 -235.443C371.32 -219.115 372.676 -191.324 356.348 -173.359L274.895 -83.6714C258.567 -65.7059 230.777 -64.349 212.811 -80.6771Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M219.595 135.096L162.704 152.547L175.43 128.125L170.939 100.943L219.595 135.096ZM115.966 140.851C96.3161 155.12 68.8532 150.723 54.5837 131.073L-16.5298 33.0108C-30.7993 13.361 -26.4015 -14.1019 -6.75174 -28.3714C12.8981 -42.6409 40.361 -38.2431 54.6305 -18.5933L125.744 79.4687C140.013 99.1185 135.616 126.581 115.966 140.851Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1038.01 118.488L1042.31 59.1172L1060.51 79.7962L1087.46 85.4105L1038.05 118.441L1038.01 118.488ZM1070.15 19.7708C1063.97 -3.71536 1077.96 -27.7162 1101.45 -33.8918L1218.55 -64.7701C1242.04 -70.9458 1266.04 -56.957 1272.21 -33.4708C1278.39 -9.98461 1264.4 14.0162 1240.92 20.1919L1123.81 51.0702C1100.33 57.2458 1076.32 43.257 1070.15 19.7708Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M375.857 -108.281L373.378 -48.8167L354.57 -68.9342L327.481 -73.7531L375.904 -108.281H375.857ZM346.757 -8.67499C353.634 14.5773 340.347 39.046 317.095 45.9234L200.927 80.3106C177.675 87.188 153.206 73.901 146.329 50.6488C139.452 27.3965 152.739 2.9278 175.991 -3.94963L292.159 -38.3368C315.411 -45.2142 339.88 -31.9272 346.757 -8.67499Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M71.9395 -68.3727L127.848 -88.7243L116.432 -63.6475L122.327 -36.746L71.9395 -68.326V-68.3727ZM175.101 -79.4141C194.002 -94.6661 221.652 -91.7186 236.904 -72.8174L312.977 21.4081C328.229 40.3094 325.281 67.9594 306.38 83.2114C287.479 98.4634 259.829 95.5159 244.577 76.6146L168.504 -17.6107C153.252 -36.512 156.2 -64.1621 175.101 -79.4141Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M995.059 9.47792L935.969 2.5538L957.444 -14.71L964.274 -41.3776L995.106 9.47792H995.059ZM897.839 -26.9677C874.119 -21.8213 850.726 -36.8861 845.58 -60.6063L819.942 -178.973C814.795 -202.693 829.86 -226.086 853.58 -231.232C877.3 -236.378 900.693 -221.313 905.839 -197.593L931.478 -79.2268C936.624 -55.5067 921.559 -32.114 897.839 -26.9677Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M90.748 -135.416L150.259 -136.258L131.217 -116.374L127.896 -89.0518L90.748 -135.463V-135.416ZM191.851 -111.883C214.682 -120.07 239.853 -108.14 248.04 -85.3089L288.837 28.7534C297.024 51.5846 285.094 76.7551 262.263 84.9425C239.432 93.1299 214.261 81.1997 206.074 58.3685L165.277 -55.6939C157.089 -78.5251 169.02 -103.696 191.851 -111.883Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M47.7049 110.16L32.3594 52.6607L56.3134 66.2752L83.6359 62.7663L47.7517 110.16H47.7049ZM45.7867 6.39006C32.2658 -13.7744 37.6461 -41.0502 57.8105 -54.5711L158.399 -122.035C178.563 -135.556 205.839 -130.176 219.36 -110.011C232.881 -89.847 227.501 -62.5713 207.336 -49.0503L106.748 18.4139C86.5834 31.9348 59.3076 26.5545 45.7867 6.39006Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M633.878 42.368L576.286 27.4435L599.912 13.2675L610.299 -12.2303L633.878 42.3213V42.368ZM542.601 -7.03725C518.413 -5.21262 497.312 -23.3185 495.441 -47.5064L486.224 -168.259C484.4 -192.447 502.506 -213.547 526.693 -215.419C550.881 -217.29 571.982 -199.137 573.853 -174.949L583.07 -54.1967C584.894 -30.0087 566.788 -8.90865 542.601 -7.03725Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-149.119 23.1861L-103.036 -14.4761L-105.562 12.9401L-91.1522 36.3794L-149.119 23.1861ZM-55.3148 -21.3067C-42.4956 -41.939 -15.407 -48.2551 5.17854 -35.4359L108.059 28.4727C128.691 41.2919 135.008 68.3806 122.188 88.9661C109.369 109.552 82.2805 115.914 61.695 103.095L-41.1856 39.1866C-61.8179 26.3674 -68.1339 -0.721172 -55.3148 -21.3067Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M219.875 -124L277.14 -107.812L253.233 -94.1981L242.285 -68.9339L219.922 -124H219.875ZM310.03 -72.63C334.265 -73.94 354.944 -55.3663 356.301 -31.1315L362.851 89.8083C364.161 114.043 345.587 134.722 321.352 136.079C297.117 137.436 276.438 118.815 275.082 94.5804L268.532 -26.3595C267.222 -50.5942 285.795 -71.2732 310.03 -72.63Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M325.89 69.0357L290.754 21.034L317.983 25.0108L342.171 11.8642L325.89 69.0357ZM286.497 -26.9675C266.613 -40.8627 261.701 -68.2322 275.596 -88.1627L344.885 -187.488C358.78 -207.372 386.15 -212.284 406.08 -198.389C426.011 -184.493 430.876 -157.124 416.981 -137.194L347.692 -37.8686C333.797 -17.9848 306.427 -13.0723 286.497 -26.9675Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-7.31445 -8.25356L38.769 -45.9157L36.2427 -18.4995L50.6524 4.93977L-7.31445 -8.25356ZM86.4899 -52.7464C99.3091 -73.3786 126.398 -79.6946 146.983 -66.8754L249.864 -2.96694C270.496 9.85221 276.812 36.941 263.993 57.5265C251.174 78.112 224.085 84.4747 203.5 71.6555L100.619 7.74691C79.9868 -5.07224 73.6708 -32.1609 86.4899 -52.7464Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-241.193 -128.726L-185.285 -149.077L-196.701 -124L-190.806 -97.0988L-241.193 -128.679V-128.726ZM-138.032 -139.814C-119.131 -155.066 -91.4807 -152.118 -76.2287 -133.217L-0.155853 -38.9915C15.0961 -20.0903 12.1486 7.55974 -6.75259 22.8117C-25.6538 38.0637 -53.3039 35.1162 -68.5559 16.215L-144.629 -78.0104C-159.881 -96.9116 -156.933 -124.562 -138.032 -139.814Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M405.191 -9.04877L348.3 8.40218L361.026 -16.0197L356.534 -43.2019L405.191 -9.04877ZM301.562 -3.34096C281.912 10.9285 254.449 6.53075 240.179 -13.119L169.066 -111.181C154.796 -130.831 159.194 -158.294 178.844 -172.563C198.494 -186.833 225.957 -182.435 240.226 -162.785L311.34 -64.7232C325.609 -45.0734 321.211 -17.6105 301.562 -3.34096Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M374.781 33.6661L419.04 -6.10133L417.777 21.4084L433.263 44.146L374.734 33.6661H374.781ZM466.387 -15.1777C478.223 -36.3714 504.984 -43.9506 526.178 -32.1607L631.96 26.8355C653.153 38.6722 660.732 65.4333 648.943 86.627C637.106 107.821 610.345 115.4 589.151 103.61L483.37 44.6138C462.176 32.7772 454.597 6.01603 466.387 -15.1777Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1.38846 -14.2888L-53.5842 8.49554L-43.2446 -17.0492L-50.3092 -43.67L1.38846 -14.3357V-14.2888ZM-101.258 1.29057C-119.458 17.3379 -147.201 15.6069 -163.296 -2.59253L-243.439 -93.4027C-259.486 -111.602 -257.755 -139.346 -239.555 -155.44C-221.356 -171.534 -193.612 -169.756 -177.518 -151.557L-97.3751 -60.7466C-81.3278 -42.5471 -83.0589 -14.8035 -101.258 1.29057Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M671.867 -129.568L710.605 -84.3732L683.142 -86.2914L660.03 -71.3201L671.914 -129.568H671.867ZM718.465 -36.8394C739.378 -24.5349 746.302 2.4135 733.998 23.3265L672.475 127.658C660.171 148.57 633.222 155.495 612.309 143.19C591.396 130.886 584.472 103.937 596.777 83.0244L658.299 -21.3067C670.604 -42.2197 697.552 -49.1439 718.465 -36.8394Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M912.249 280.318L860.318 251.264L886.751 243.591L903.313 221.556L912.249 280.318ZM836.551 209.298C812.69 204.947 796.877 182.069 801.228 158.161L822.983 38.9995C827.334 15.139 850.212 -0.674333 874.119 3.67669C898.027 8.02772 913.793 30.9057 909.442 54.8129L887.687 173.975C883.336 197.835 860.458 213.649 836.551 209.298Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M220.016 -62.1969L260.251 -18.3592L232.741 -19.2949L210.144 -3.52833L220.016 -62.1502V-62.1969ZM269.795 28.8471C291.129 40.4498 298.989 67.1174 287.386 88.4514L229.513 194.841C217.91 216.175 191.243 224.035 169.909 212.432C148.575 200.83 140.715 174.162 152.317 152.828L210.191 46.4383C221.793 25.1042 248.461 17.2444 269.795 28.8471Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M740.454 -172.189L791.403 -141.404L764.736 -134.574L747.472 -113.099L740.501 -172.142L740.454 -172.189ZM813.813 -98.7362C837.534 -93.5899 852.598 -70.1972 847.452 -46.4771L821.767 71.8895C816.621 95.6096 793.228 110.674 769.508 105.528C745.788 100.382 730.723 76.9892 735.869 53.269L761.554 -65.0977C766.701 -88.8178 790.093 -103.883 813.813 -98.7362Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1498.98 -118.152L1537.72 -72.9576L1510.26 -74.8758L1487.15 -59.9044L1499.03 -118.152H1498.98ZM1545.63 -25.4237C1566.54 -13.1192 1573.47 13.829 1561.16 34.742L1499.64 139.073C1487.33 159.986 1460.39 166.91 1439.47 154.606C1418.56 142.301 1411.64 115.353 1423.94 94.44L1485.46 -9.89101C1497.77 -30.804 1524.72 -37.7283 1545.63 -25.4237Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1042.12 -126.433L1082.36 -82.5954L1054.85 -83.5311L1032.25 -67.7644L1042.12 -126.386V-126.433ZM1091.9 -35.3423C1113.24 -23.7395 1121.1 2.92801 1109.5 24.2621L1051.62 130.652C1040.02 151.986 1013.35 159.846 992.018 148.243C970.684 136.64 962.824 109.973 974.427 88.6386L1032.3 -17.751C1043.9 -39.085 1070.57 -46.945 1091.9 -35.3423Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M762.162 -143.042L808.619 -105.847L781.25 -102.619L761.319 -83.6245L762.162 -143.089V-143.042ZM825.181 -60.5594C848.013 -52.3252 859.849 -27.1547 851.615 -4.3235L810.538 109.645C802.303 132.476 777.133 144.313 754.302 136.079C731.47 127.845 719.634 102.674 727.868 79.8431L768.945 -34.1257C777.18 -56.9569 802.35 -68.7936 825.181 -60.5594Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M898.309 -102.339L949.632 -132.421L942.895 -105.707L953.515 -80.3028L898.309 -102.339ZM997.821 -131.767C1013.63 -150.153 1041.38 -152.212 1059.76 -136.398L1151.56 -57.3779C1169.94 -41.5645 1172 -13.8209 1156.19 4.56567C1140.38 22.9523 1112.63 25.0108 1094.25 9.19736L1002.45 -69.8228C984.066 -85.6362 982.007 -113.38 997.821 -131.767Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M706.536 76.4742L672.804 27.4433L699.939 32.2621L724.501 19.8174L706.536 76.4742ZM669.95 -20.6986C650.487 -35.1553 646.417 -62.665 660.873 -82.1745L733.063 -179.441C747.52 -198.904 775.029 -202.974 794.539 -188.517C814.048 -174.061 818.072 -146.551 803.615 -127.041L731.425 -29.775C716.969 -10.3123 689.459 -6.242 669.95 -20.6986Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1082.97 -212.143L1142.48 -212.986L1123.44 -193.102L1120.12 -165.779L1082.97 -212.19V-212.143ZM1184.07 -188.611C1206.9 -196.798 1232.07 -184.868 1240.26 -162.037L1281.06 -47.9741C1289.24 -25.1429 1277.31 0.0275574 1254.48 8.21497C1231.65 16.4024 1206.48 4.47218 1198.29 -18.359L1157.5 -132.421C1149.31 -155.253 1161.24 -180.423 1184.07 -188.611Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1168.82 75.1178L1153.47 17.6189L1177.43 31.2332L1204.75 27.7243L1168.87 75.1178H1168.82ZM1166.95 -28.6518C1153.43 -48.8162 1158.81 -76.092 1178.97 -89.6129L1279.56 -157.077C1299.73 -170.598 1327 -165.218 1340.52 -145.053C1354.04 -124.889 1348.66 -97.6133 1328.5 -84.0923L1227.91 -16.628C1207.75 -3.10703 1180.47 -8.48737 1166.95 -28.6518Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1434.09 -74.4077L1474.33 -30.57L1446.82 -31.5056L1424.22 -15.739L1434.09 -74.3609V-74.4077ZM1483.87 16.6831C1505.21 28.2859 1513.07 54.9534 1501.46 76.2875L1443.59 182.677C1431.99 204.011 1405.32 211.871 1383.98 200.268C1362.65 188.666 1354.79 161.998 1366.39 140.664L1424.27 34.2744C1435.87 12.9404 1462.54 5.08039 1483.87 16.6831Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M972.182 -61.0741L995.107 -6.14829L969.562 -16.441L942.941 -9.32965L972.182 -61.0741ZM987.949 41.5259C1004.04 59.6785 1002.36 87.469 984.206 103.563L893.536 183.847C875.384 199.941 847.593 198.256 831.499 180.104C815.405 161.951 817.089 134.161 835.242 118.067L925.912 37.7831C944.064 21.689 971.855 23.3732 987.949 41.5259Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M708.875 56.6375L730.77 1.29051L741.905 26.461L765.906 39.9352L708.828 56.5907L708.875 56.6375ZM769.181 -27.8566C770.304 -52.0913 790.889 -70.8054 815.124 -69.6826L936.111 -63.9748C960.346 -62.8519 979.06 -42.2666 977.937 -18.0318C976.814 6.20293 956.228 24.917 931.994 23.7942L811.007 18.0864C786.772 16.9635 768.058 -3.62185 769.181 -27.8566Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M824.294 -157.031L870.752 -119.836L843.383 -116.608L823.452 -97.6134L824.294 -157.078V-157.031ZM887.314 -74.5951C910.145 -66.3609 921.982 -41.1904 913.748 -18.3592L872.67 95.6095C864.436 118.441 839.266 130.277 816.434 122.043C793.603 113.809 781.767 88.6386 790.001 65.8074L831.078 -48.1614C839.312 -70.9926 864.483 -82.8293 887.314 -74.5951Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M762.678 66.6029L728.946 17.5719L756.082 22.3908L780.644 9.94592L762.678 66.6029ZM726.139 -30.5701C706.676 -45.0267 702.606 -72.5364 717.063 -92.0458L789.252 -189.312C803.709 -208.775 831.219 -212.845 850.728 -198.389C870.238 -183.932 874.261 -156.422 859.804 -136.913L787.615 -39.6465C773.158 -20.1838 745.648 -16.1135 726.139 -30.5701Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1224.5 22.3438L1209.15 -35.1551L1233.1 -21.5407L1260.43 -25.0496L1224.54 22.3438H1224.5ZM1222.62 -81.4258C1209.1 -101.59 1214.48 -128.866 1234.65 -142.387L1335.24 -209.851C1355.4 -223.372 1382.68 -217.992 1396.2 -197.827C1409.72 -177.663 1404.34 -150.387 1384.17 -136.866L1283.59 -69.4019C1263.42 -55.881 1236.15 -61.2613 1222.62 -81.4258Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1499.73 -143.276L1539.97 -99.4381L1512.46 -100.374L1489.86 -84.6072L1499.73 -143.229V-143.276ZM1549.51 -52.185C1570.85 -40.5823 1578.71 -13.9148 1567.1 7.4193L1509.23 113.809C1497.63 135.143 1470.96 143.003 1449.63 131.4C1428.29 119.797 1420.43 93.1299 1432.03 71.7958L1489.91 -34.5938C1501.51 -55.9278 1528.18 -63.7878 1549.51 -52.185Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M845.02 -157.545L903.454 -146.317L880.763 -130.69L872.015 -104.584L845.02 -157.545ZM939.292 -114.035C963.339 -117.403 985.562 -100.701 988.931 -76.6536L1005.82 43.3038C1009.19 67.3514 992.487 89.5743 968.439 92.9429C944.391 96.3114 922.168 79.6091 918.8 55.5615L901.91 -64.3958C898.542 -88.4434 915.244 -110.666 939.292 -114.035Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M371.787 40.7773L376.091 -18.5931L394.291 2.086L421.239 7.70015L371.834 40.7306L371.787 40.7773ZM403.929 -57.9395C397.753 -81.4257 411.742 -105.427 435.228 -111.602L552.331 -142.48C575.817 -148.656 599.818 -134.667 605.994 -111.181C612.17 -87.6948 598.181 -63.694 574.695 -57.5183L457.591 -26.6402C434.105 -20.4645 410.104 -34.4533 403.929 -57.9395Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M840.248 -41.6115L834.914 17.6654L817.089 -3.34117L790.235 -9.47002L840.248 -41.6115ZM806.329 56.4972C812.083 80.0769 797.627 103.844 774.094 109.598L656.429 138.325C632.849 144.079 609.082 129.622 603.327 106.089C597.573 82.5564 612.03 58.7429 635.563 52.9883L753.227 24.2621C776.807 18.5075 800.574 32.9642 806.329 56.4972Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M935.268 47.1401L962.216 -5.9143L970.965 20.1918L993.655 35.818L935.314 47.1401H935.268ZM1003.11 -31.4591C1006.47 -55.5067 1028.7 -72.209 1052.75 -68.8405L1172.7 -51.9511C1196.75 -48.5826 1213.45 -26.3595 1210.08 -2.31189C1206.72 21.7357 1184.49 38.438 1160.44 35.0695L1040.49 18.1801C1016.44 14.8115 999.738 -7.41153 1003.11 -31.4591Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1271.75 -68.9339L1323.07 -99.0169L1316.33 -72.3025L1326.95 -46.8981L1271.75 -68.9339ZM1371.31 -98.3619C1387.12 -116.748 1414.86 -118.807 1433.25 -102.994L1525.04 -23.9734C1543.43 -8.16 1545.49 19.5836 1529.68 37.9702C1513.86 56.3568 1486.12 58.4154 1467.73 42.602L1375.94 -36.4183C1357.55 -52.2317 1355.49 -79.9753 1371.31 -98.3619Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M842.026 137.202L782.936 130.278L804.41 113.014L811.241 86.3463L842.072 137.202H842.026ZM744.853 100.756C721.133 105.903 697.74 90.8377 692.594 67.1176L666.955 -51.249C661.809 -74.9691 676.874 -98.3618 700.594 -103.508C724.314 -108.655 747.707 -93.5897 752.853 -69.8696L778.491 48.497C783.638 72.2171 768.573 95.6098 744.853 100.756Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1283.58 251.826L1224.4 245.697L1245.64 228.152L1252.1 201.391L1283.58 251.826ZM1185.9 216.69C1162.27 222.164 1138.64 207.379 1133.22 183.753L1105.99 65.7139C1100.51 42.0874 1115.3 18.4608 1138.92 13.0337C1162.55 7.60662 1186.18 22.344 1191.6 45.9705L1218.83 164.01C1224.31 187.636 1209.52 211.263 1185.9 216.69Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1556.53 -0.814697L1579.45 54.1111L1553.91 43.8183L1527.29 50.9298L1556.53 -0.814697ZM1572.3 101.738C1588.39 119.891 1586.71 147.682 1568.55 163.776L1477.88 244.059C1459.73 260.153 1431.94 258.469 1415.85 240.316C1399.75 222.164 1401.44 194.373 1419.59 178.279L1510.26 97.9957C1528.41 81.9016 1556.2 83.5858 1572.3 101.738Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1034.87 -150.06L1088.3 -123.86L1062.34 -114.737L1047.04 -91.8589L1034.92 -150.06H1034.87ZM1114.36 -83.2971C1138.46 -80.256 1155.49 -58.267 1152.4 -34.1726L1137.15 85.9718C1134.1 110.066 1112.12 127.096 1088.02 124.008C1063.93 120.92 1046.9 98.9782 1049.98 74.8838L1065.24 -45.2607C1068.28 -69.3551 1090.27 -86.3849 1114.36 -83.2971Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1036.79 -134.059L1083.25 -96.8648L1055.88 -93.6366L1035.95 -74.6418L1036.79 -134.106V-134.059ZM1099.81 -51.5767C1122.64 -43.3425 1134.48 -18.1721 1126.25 4.65906L1085.17 118.628C1076.93 141.459 1051.76 153.296 1028.93 145.062C1006.1 136.827 994.265 111.657 1002.5 88.8258L1043.58 -25.1431C1051.81 -47.9743 1076.98 -59.8109 1099.81 -51.5767Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M956.229 177.811L922.497 128.78L949.632 133.599L974.195 121.154L956.229 177.811ZM919.69 80.6851C900.227 66.2285 896.157 38.7189 910.613 19.2094L982.803 -78.0571C997.26 -97.5198 1024.77 -101.59 1044.28 -87.1335C1063.79 -72.6768 1067.81 -45.167 1053.36 -25.6576L981.166 71.6088C966.709 91.0714 939.199 95.1418 919.69 80.6851Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M967.691 30.344L908.508 24.215L929.748 6.6705L936.204 -20.0905L967.691 30.344ZM870.003 -4.79179C846.377 0.682083 822.75 -14.1021 817.323 -37.7286L790.094 -155.768C784.62 -179.394 799.404 -203.021 823.031 -208.448C846.658 -213.875 870.284 -199.138 875.711 -175.511L902.94 -57.472C908.414 -33.8455 893.63 -10.2189 870.003 -4.79179Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1037.49 -142.247L1092.42 -165.124L1082.13 -139.58L1089.24 -112.959L1037.49 -142.247ZM1140.09 -157.966C1158.25 -174.06 1186.04 -172.376 1202.13 -154.177L1282.41 -63.4602C1298.51 -45.3076 1296.82 -17.5171 1278.63 -1.42299C1260.43 14.6711 1232.68 12.9869 1216.59 -5.21257L1136.3 -95.9292C1120.21 -114.082 1121.89 -141.872 1140.09 -157.966Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M940.555 -115.719L927.829 -57.6121L912.811 -80.6772L886.939 -90.1278L940.601 -115.766L940.555 -115.719ZM894.612 -22.6635C897.372 1.43086 880.061 23.2328 855.967 25.9931L735.635 39.7479C711.541 42.5083 689.739 25.1978 686.979 1.10345C684.218 -22.991 701.529 -44.793 725.623 -47.5533L845.955 -61.3082C870.049 -64.0685 891.851 -46.7579 894.612 -22.6635Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M888.998 211.356L840.154 177.39L867.196 172.291L885.769 151.986L888.951 211.356H888.998ZM820.457 133.365C797.111 126.722 783.591 102.393 790.234 79.0476L823.451 -37.4476C830.095 -60.7934 854.423 -74.3143 877.769 -67.6708C901.115 -61.0273 914.636 -36.699 907.992 -13.3532L874.775 103.142C868.131 126.488 843.803 140.009 820.457 133.365Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1106.55 191.987L1110.85 132.617L1129.05 153.296L1156 158.91L1106.6 191.94L1106.55 191.987ZM1138.69 93.2705C1132.51 69.7843 1146.5 45.7834 1169.99 39.6078L1287.09 8.72952C1310.58 2.55387 1334.58 16.5427 1340.76 40.0288C1346.93 63.515 1332.94 87.5159 1309.46 93.6915L1192.35 124.57C1168.87 130.745 1144.87 116.757 1138.69 93.2705Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M985.656 -207.98L1024.39 -162.785L996.931 -164.703L973.819 -149.732L985.703 -207.98H985.656ZM1032.25 -115.252C1053.17 -102.947 1060.09 -75.9987 1047.79 -55.0857L986.264 49.2453C973.96 70.1583 947.011 77.0826 926.098 64.778C905.185 52.4735 898.261 25.5253 910.566 4.61229L972.088 -99.7188C984.393 -120.632 1011.34 -127.556 1032.25 -115.252Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M849.418 -107.017L906.683 -90.8294L882.776 -77.2149L871.828 -51.9509L849.465 -107.017H849.418ZM939.573 -55.6002C963.808 -56.9102 984.487 -38.3363 985.844 -14.1015L992.394 106.838C993.704 131.073 975.13 151.752 950.895 153.109C926.66 154.466 905.981 135.845 904.624 111.61L898.075 -9.32951C896.765 -33.5643 915.338 -54.2434 939.573 -55.6002Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M440.187 96.1244L483.277 55.0937L482.809 82.6502L498.95 104.967L440.141 96.1711L440.187 96.1244ZM530.343 44.7073C541.571 23.1861 568.098 14.8116 589.619 26.0401L697.038 81.9952C718.56 93.2236 726.934 119.751 715.706 141.272C704.477 162.793 677.95 171.168 656.429 159.939L549.01 103.984C527.489 92.7558 519.114 66.2285 530.343 44.7073Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M543.816 151.424L528.471 93.9253L552.425 107.54L579.747 104.031L543.863 151.424H543.816ZM541.898 47.6546C528.377 27.4902 533.757 0.214424 553.922 -13.3065L654.51 -80.7707C674.675 -94.2917 701.95 -88.9115 715.471 -68.747C728.992 -48.5826 723.612 -21.3068 703.447 -7.78589L602.859 59.6785C582.695 73.1994 555.419 67.8191 541.898 47.6546Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M294.076 -16.8153L334.311 27.0224L306.802 26.0868L284.204 41.8534L294.076 -16.7685V-16.8153ZM343.856 74.2755C365.19 85.8783 373.05 112.546 361.447 133.88L303.574 240.27C291.971 261.604 265.303 269.463 243.969 257.861C222.635 246.258 214.775 219.59 226.378 198.256L284.251 91.8668C295.854 70.5328 322.522 62.6728 343.856 74.2755Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1085.03 -80.5837L1089.71 -21.2599L1068.61 -38.9916L1041.1 -40.5355L1085.03 -80.6304V-80.5837ZM1068.05 21.7824C1077.68 44.0522 1067.44 69.9244 1045.17 79.5622L934.006 127.657C911.736 137.295 885.864 127.049 876.226 104.779C866.588 82.5096 876.834 56.6375 899.104 46.9997L1010.27 -1.09549C1032.54 -10.7332 1058.41 -0.487358 1068.05 21.7824Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M684.359 -260.847L724.595 -217.009L697.085 -217.945L674.488 -202.178L684.359 -260.8V-260.847ZM734.139 -169.756C755.473 -158.153 763.333 -131.486 751.73 -110.152L693.857 -3.76218C682.254 17.5719 655.586 25.4319 634.252 13.8291C612.918 2.22638 605.058 -24.4413 616.661 -45.7754L674.534 -152.165C686.137 -173.499 712.805 -181.359 734.139 -169.756Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1040.11 -111.649L1080.35 -67.8111L1052.84 -68.7468L1030.24 -52.9802L1040.11 -111.602V-111.649ZM1089.89 -20.558C1111.23 -8.95523 1119.09 17.7123 1107.48 39.0464L1049.61 145.436C1038.01 166.77 1011.34 174.63 990.006 163.027C968.672 151.424 960.812 124.757 972.415 103.423L1030.29 -2.96681C1041.89 -24.3009 1068.56 -32.1607 1089.89 -20.558Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M787.334 -257.291L827.569 -213.454L800.059 -214.389L777.462 -198.623L787.334 -257.245V-257.291ZM837.113 -166.2C858.447 -154.598 866.307 -127.93 854.705 -106.596L796.831 -0.20639C785.229 21.1277 758.561 28.9875 737.227 17.3848C715.893 5.78201 708.033 -20.8855 719.636 -42.2196L777.509 -148.609C789.112 -169.943 815.779 -177.803 837.113 -166.2Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M424.42 -106.035L475.743 -136.118L469.006 -109.403L479.626 -83.999L424.42 -106.035ZM523.932 -135.463C539.745 -153.849 567.489 -155.908 585.876 -140.095L677.668 -61.0743C696.055 -45.2609 698.113 -17.5173 682.3 0.869308C666.487 19.2559 638.743 21.3144 620.356 5.50101L528.564 -73.5192C510.177 -89.3326 508.119 -117.076 523.932 -135.463Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M360.7 17.7591L326.968 -31.2719L354.103 -26.453L378.665 -38.8979L360.7 17.7591ZM324.161 -79.3671C304.698 -93.8237 300.628 -121.334 315.084 -140.843L387.274 -238.109C401.73 -257.572 429.24 -261.642 448.75 -247.186C468.259 -232.729 472.283 -205.219 457.826 -185.71L385.636 -88.4434C371.18 -68.9808 343.67 -64.9104 324.161 -79.3671Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M256.742 13.0335L278.638 -42.3133L289.772 -17.143L313.773 -3.66885L256.695 12.9867L256.742 13.0335ZM317.001 -71.4606C318.124 -95.6953 338.71 -114.409 362.945 -113.287L483.931 -107.579C508.166 -106.456 526.88 -85.8704 525.757 -61.6357C524.634 -37.4009 504.049 -18.6868 479.814 -19.8097L358.827 -25.5175C334.593 -26.6403 315.879 -47.2259 317.001 -71.4606Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M16.2656 -169.429L69.6943 -143.229L43.7285 -134.106L28.4297 -111.228L16.3124 -169.429H16.2656ZM95.7537 -102.666C119.848 -99.6253 136.878 -77.6363 133.79 -53.5419L118.538 66.6027C115.497 90.6971 93.508 107.727 69.4136 104.639C45.3193 101.551 28.2894 79.6089 31.3772 55.5145L46.6293 -64.6299C49.6703 -88.7243 71.6594 -105.754 95.7537 -102.666Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M763.94 90.6035L705.786 103.282L720.476 79.9833L718.231 52.5204L763.893 90.5568L763.94 90.6035ZM660.17 87.7028C639.398 100.288 612.402 93.6446 599.817 72.872L537.078 -30.7106C524.493 -51.4832 531.137 -78.4783 551.909 -91.0635C572.682 -103.649 599.677 -97.0052 612.262 -76.2325L675.001 27.3499C687.586 48.1225 680.943 75.1176 660.17 87.7028Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-128.908 -6.66284L-71.6431 9.52481L-95.5503 23.1393L-106.498 48.4033L-128.861 -6.66284H-128.908ZM-38.7063 44.7541C-14.4715 43.4441 6.20753 62.0178 7.5643 86.2526L14.1142 207.192C15.4242 231.427 -3.14952 252.106 -27.3843 253.463C-51.619 254.82 -72.2981 236.199 -73.6549 211.964L-80.2048 91.0247C-81.5148 66.79 -62.941 46.1109 -38.7063 44.7541Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M186.424 62.9537L194.939 4.05095L211.594 25.9932L238.075 33.5257L186.424 62.9537ZM225.443 -33.1901C220.951 -57.0505 236.624 -80.0221 260.485 -84.5135L379.507 -106.97C403.367 -111.462 426.339 -95.7887 430.83 -71.9282C435.321 -48.0678 419.648 -25.0962 395.788 -20.6048L276.766 1.85204C252.906 6.34341 229.934 -9.32959 225.443 -33.1901Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M144.785 -56.8634L109.462 -9.00204L105.158 -36.1842L85.3677 -55.3662L144.785 -56.8634ZM64.9225 9.38452C57.624 32.5432 32.9214 45.3623 9.76273 38.0171L-105.703 1.47781C-128.862 -5.82069 -141.681 -30.5233 -134.336 -53.682C-127.037 -76.8407 -102.335 -89.6598 -79.176 -82.3146L36.2899 -45.7753C59.4486 -38.4768 72.2678 -13.7742 64.9225 9.38452Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M758.28 87.4222L706.349 58.3686L732.783 50.6957L749.344 28.6599L758.28 87.4222ZM682.535 16.4491C658.675 12.098 642.861 -10.78 647.212 -34.6873L668.967 -153.849C673.318 -177.71 696.196 -193.523 720.104 -189.172C744.011 -184.821 759.778 -161.943 755.427 -138.036L733.671 -18.8739C729.32 4.9866 706.442 20.8001 682.535 16.4491Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M806.236 -123.72L857.185 -92.9348L830.517 -86.1042L813.253 -64.6298L806.282 -123.673L806.236 -123.72ZM879.595 -50.2667C903.315 -45.1204 918.38 -21.7278 913.233 1.99229L887.548 120.359C882.402 144.079 859.009 159.144 835.289 153.998C811.569 148.851 796.504 125.459 801.651 101.738L827.336 -16.6281C832.482 -40.3483 855.875 -55.4131 879.595 -50.2667Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M964.931 -187.347L1011.39 -150.153L984.019 -146.925L964.089 -127.93L964.931 -187.394V-187.347ZM1027.95 -104.912C1050.78 -96.6776 1062.62 -71.5072 1054.38 -48.676L1013.31 65.2929C1005.07 88.1241 979.902 99.9607 957.071 91.7265C934.24 83.4923 922.403 58.3218 930.637 35.4906L971.715 -78.4782C979.949 -101.309 1005.12 -113.146 1027.95 -104.912Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1035.25 4.84641L980.275 27.6308L990.615 2.08611L983.55 -24.5347L1035.25 4.79958V4.84641ZM932.648 20.3791C914.449 36.4265 886.705 34.6953 870.611 16.4959L790.468 -74.3143C774.42 -92.5137 776.151 -120.257 794.351 -136.351C812.55 -152.446 840.294 -150.668 856.388 -132.468L936.531 -41.6581C952.578 -23.4587 950.847 4.28502 932.648 20.3791Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1092.47 -90.8296L1089.99 -31.3655L1071.18 -51.4832L1044.09 -56.3021L1092.51 -90.8296H1092.47ZM1063.37 8.82304C1070.24 32.0753 1056.96 56.5439 1033.7 63.4213L917.537 97.8085C894.285 104.686 869.816 91.3989 862.938 68.1467C856.061 44.8944 869.348 20.4257 892.6 13.5482L1008.77 -20.8388C1032.02 -27.7162 1056.49 -14.4292 1063.37 8.82304Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M703.729 -87.648L759.637 -108L748.221 -82.9228L754.116 -56.0213L703.729 -87.6013V-87.648ZM806.89 -98.7363C825.791 -113.988 853.441 -111.041 868.693 -92.1395L944.766 2.08599C960.018 20.9872 957.071 48.6373 938.169 63.8892C919.268 79.1412 891.618 76.1937 876.366 57.2925L800.293 -36.9329C785.041 -55.8341 787.989 -83.4843 806.89 -98.7363Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1292.94 115.119L1233.76 108.99L1255 91.4458L1261.45 64.6846L1292.94 115.119ZM1195.25 79.9365C1171.63 85.4104 1148 70.6263 1142.57 46.9998L1115.34 -71.0394C1109.87 -94.6659 1124.65 -118.293 1148.28 -123.72C1171.91 -129.147 1195.53 -114.409 1200.96 -90.7828L1228.19 27.2564C1233.66 50.8829 1218.88 74.5094 1195.25 79.9365Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1064.21 -211.909L1123.72 -212.752L1104.68 -192.868L1101.36 -165.545L1064.21 -211.956V-211.909ZM1165.31 -188.376C1188.14 -196.564 1213.31 -184.634 1221.5 -161.802L1262.3 -47.7401C1270.49 -24.9089 1258.55 0.261475 1235.72 8.44888C1212.89 16.6363 1187.72 4.7061 1179.53 -18.1251L1138.74 -132.187C1130.55 -155.019 1142.48 -180.189 1165.31 -188.376Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M866.259 -214.155L912.717 -176.961L885.348 -173.733L865.417 -154.738L866.259 -214.202V-214.155ZM929.279 -131.673C952.11 -123.439 963.947 -98.2685 955.713 -75.4373L914.635 38.5316C906.401 61.3628 881.23 73.1995 858.399 64.9653C835.568 56.731 823.731 31.5605 831.966 8.72932L873.043 -105.239C881.277 -128.071 906.448 -139.907 929.279 -131.673Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M946.918 -156.937L944.438 -97.473L925.631 -117.591L898.542 -122.41L946.965 -156.937H946.918ZM917.771 -57.3314C924.648 -34.0791 911.361 -9.61037 888.109 -2.73293L771.941 31.6542C748.689 38.5317 724.22 25.2445 717.343 1.99228C710.465 -21.26 723.752 -45.7286 747.005 -52.606L863.172 -86.9932C886.425 -93.8706 910.893 -80.5836 917.771 -57.3314Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M993.047 -1.28261L1039.13 -38.9448L1036.6 -11.5286L1051.01 11.9109L993.047 -1.28261ZM1086.85 -45.7754C1099.67 -66.4077 1126.76 -72.7236 1147.34 -59.9045L1250.23 4.00415C1270.86 16.8233 1277.17 43.9119 1264.35 64.4974C1251.54 85.0829 1224.45 91.4456 1203.86 78.6265L1100.98 14.7179C1080.35 1.8987 1074.03 -25.1899 1086.85 -45.7754Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1454.68 -222.483L1493.42 -177.289L1465.95 -179.207L1442.84 -164.236L1454.72 -222.483H1454.68ZM1501.32 -129.755C1522.24 -117.45 1529.16 -90.502 1516.86 -69.5891L1455.33 34.7419C1443.03 55.6549 1416.08 62.5792 1395.17 50.2747C1374.25 37.9702 1367.33 11.0219 1379.63 -9.89105L1441.16 -114.222C1453.46 -135.135 1480.41 -142.059 1501.32 -129.755Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1273.57 -208.775L1330.84 -192.587L1306.93 -178.973L1295.98 -153.709L1273.62 -208.775H1273.57ZM1363.73 -157.358C1387.96 -158.668 1408.64 -140.094 1410 -115.86L1416.55 5.08011C1417.86 29.3148 1399.28 49.994 1375.05 51.3508C1350.81 52.7076 1330.14 34.087 1328.78 9.85229L1322.23 -111.088C1320.92 -135.322 1339.49 -156.001 1363.73 -157.358Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M395.6 205.555L361.868 156.524L389.003 161.343L413.566 148.898L395.6 205.555ZM359.061 108.428C339.598 93.9718 335.528 66.4621 349.985 46.9527L422.174 -50.3138C436.631 -69.7765 464.14 -73.8468 483.65 -59.3902C503.159 -44.9335 507.183 -17.4238 492.726 2.08568L420.537 99.3522C406.08 118.815 378.57 122.885 359.061 108.428Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1161.71 121.248L1102.62 114.324L1124.09 97.0599L1130.92 70.3924L1161.76 121.248H1161.71ZM1064.54 84.7554C1040.82 89.9018 1017.42 74.8369 1012.28 51.1168L986.639 -67.2498C981.493 -90.9699 996.557 -114.362 1020.28 -119.509C1044 -124.655 1067.39 -109.59 1072.54 -85.8703L1098.17 32.4964C1103.32 56.2165 1088.26 79.609 1064.54 84.7554Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1035.72 246.913L976.533 240.784L997.774 223.24L1004.23 196.478L1035.72 246.913ZM938.076 211.777C914.449 217.251 890.823 202.467 885.396 178.84L858.167 60.8013C852.693 37.1748 867.477 13.5483 891.103 8.12123C914.73 2.69415 938.356 17.4314 943.783 41.0579L971.012 159.097C976.486 182.724 961.702 206.35 938.076 211.777Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M921.279 -44.6055L980.79 -45.4476L961.749 -25.5639L958.427 1.75865L921.279 -44.6522V-44.6055ZM1022.38 -21.0726C1045.21 -29.26 1070.38 -17.3298 1078.57 5.50141L1119.37 119.564C1127.56 142.395 1115.63 167.566 1092.79 175.753C1069.96 183.94 1044.79 172.01 1036.61 149.179L995.808 35.1165C987.621 12.2853 999.551 -12.8852 1022.38 -21.0726Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M365.611 139.682L387.507 84.3345L398.642 109.505L422.642 122.979L365.564 139.635L365.611 139.682ZM425.871 55.1406C426.993 30.9059 447.579 12.1918 471.814 13.3146L592.8 19.0224C617.035 20.1452 635.749 40.7308 634.626 64.9655C633.503 89.2003 612.918 107.914 588.683 106.792L467.697 101.084C443.462 99.9609 424.748 79.3754 425.871 55.1406Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1593.96 131.541L1537.07 148.992L1549.79 124.57L1545.3 97.3875L1593.96 131.541ZM1490.33 137.248C1470.68 151.518 1443.22 147.12 1428.95 127.47L1357.83 29.4085C1343.56 9.75872 1347.96 -17.7042 1367.61 -31.9737C1387.26 -46.2432 1414.72 -41.8454 1428.99 -22.1956L1500.11 75.8662C1514.38 95.516 1509.98 122.979 1490.33 137.248Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1230.25 -86.2916L1276.71 -49.0973L1249.34 -45.8691L1229.41 -26.8743L1230.25 -86.3383V-86.2916ZM1293.27 -3.85603C1316.1 4.37817 1327.94 29.5487 1319.7 52.3799L1278.63 166.349C1270.39 189.18 1245.22 201.017 1222.39 192.782C1199.56 184.548 1187.72 159.378 1195.96 136.546L1237.03 22.5777C1245.27 -0.253448 1270.44 -12.0902 1293.27 -3.85603Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1355.96 23.7007L1300.99 46.485L1311.33 20.9403L1304.26 -5.68047L1355.96 23.6538V23.7007ZM1253.31 39.2801C1235.11 55.3274 1207.37 53.5964 1191.28 35.397L1111.13 -55.4132C1095.09 -73.6126 1096.82 -101.356 1115.02 -117.45C1133.22 -133.545 1160.96 -131.767 1177.05 -113.567L1257.2 -22.757C1273.24 -4.55759 1271.51 23.186 1253.31 39.2801Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1310.91 -29.12L1308.43 30.3441L1289.62 10.2264L1262.53 5.40753L1310.95 -29.12H1310.91ZM1281.76 70.4858C1288.64 93.7381 1275.35 118.207 1252.1 125.084L1135.93 159.471C1112.68 166.349 1088.21 153.062 1081.33 129.809C1074.46 106.557 1087.74 82.0886 1110.99 75.2112L1227.16 40.824C1250.41 33.9466 1274.88 47.2335 1281.76 70.4858Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1035.06 -137.053L1090.97 -157.405L1079.55 -132.328L1085.45 -105.427L1035.06 -137.007V-137.053ZM1138.22 -148.095C1157.12 -163.347 1184.77 -160.399 1200.03 -141.498L1276.1 -47.2726C1291.35 -28.3713 1288.4 -0.721146 1269.5 14.5308C1250.6 29.7828 1222.95 26.8353 1207.7 7.9341L1131.63 -86.2914C1116.37 -105.193 1119.32 -132.843 1138.22 -148.095Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M754.537 -2.45212L805.861 -32.535L799.123 -5.82066L809.744 19.5837L754.537 -2.45212ZM854.049 -31.8801C869.863 -50.2667 897.606 -52.3252 915.993 -36.5118L1007.79 42.5084C1026.17 58.3218 1028.23 86.0656 1012.42 104.452C996.604 122.839 968.86 124.897 950.474 109.084L858.681 30.0635C840.294 14.2501 838.236 -13.4935 854.049 -31.8801Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1525.7 249.065L1466.61 242.141L1488.08 224.877L1494.91 198.21L1525.74 249.065H1525.7ZM1428.52 212.62C1404.8 217.766 1381.41 202.701 1376.27 178.981L1350.63 60.6144C1345.48 36.8943 1360.55 13.5016 1384.27 8.35524C1407.99 3.20886 1431.38 18.2737 1436.52 41.9938L1462.16 160.36C1467.31 184.08 1452.24 207.473 1428.52 212.62Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M926.66 -223.045L973.117 -185.85L945.748 -182.622L925.817 -163.627L926.66 -223.091V-223.045ZM989.679 -140.562C1012.51 -132.328 1024.35 -107.158 1016.11 -84.3263L975.036 29.6424C966.801 52.4736 941.631 64.3104 918.8 56.0762C895.968 47.842 884.132 22.6714 892.366 -0.159729L933.443 -114.128C941.678 -136.96 966.848 -148.796 989.679 -140.562Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1006.57 -169.616L1004.09 -110.152L985.281 -130.27L958.192 -135.088L1006.62 -169.616H1006.57ZM977.421 -70.0102C984.298 -46.7579 971.011 -22.2892 947.759 -15.4117L831.592 18.9753C808.339 25.8527 783.871 12.5657 776.993 -10.6865C770.116 -33.9388 783.403 -58.4074 806.655 -65.2848L922.823 -99.672C946.075 -106.549 970.544 -93.2624 977.421 -70.0102Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1045.82 11.1621L1091.9 -26.5001L1089.38 0.916145L1103.79 24.3556L1045.82 11.1621ZM1139.58 -33.2838C1152.4 -53.9161 1179.49 -60.2322 1200.07 -47.4131L1302.95 16.4956C1323.58 29.3147 1329.9 56.4035 1317.08 76.989C1304.26 97.5745 1277.17 103.937 1256.59 91.1181L1153.71 27.2094C1133.07 14.3903 1126.76 -12.6983 1139.58 -33.2838Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1513.77 -184.166L1552.51 -138.972L1525.04 -140.89L1501.93 -125.919L1513.81 -184.166H1513.77ZM1560.37 -91.4378C1581.28 -79.1333 1588.2 -52.185 1575.9 -31.272L1514.38 73.059C1502.07 93.972 1475.12 100.896 1454.21 88.5917C1433.3 76.2872 1426.37 49.339 1438.68 28.426L1500.2 -75.9052C1512.5 -96.8182 1539.45 -103.742 1560.37 -91.4378Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1215.32 127.751L1156.23 120.827L1177.71 103.563L1184.54 76.8955L1215.37 127.751H1215.32ZM1118.15 91.3055C1094.43 96.4518 1071.04 81.387 1065.89 57.6669L1040.25 -60.6998C1035.11 -84.4199 1050.17 -107.812 1073.89 -112.959C1097.61 -118.105 1121.01 -103.04 1126.15 -79.3203L1151.79 39.0463C1156.94 62.7664 1141.87 86.1591 1118.15 91.3055Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1079.13 242.281L1019.95 236.152L1041.19 218.608L1047.65 191.847L1079.13 242.281ZM981.445 207.145C957.818 212.619 934.192 197.835 928.765 174.209L901.536 56.1695C896.062 32.5429 910.846 8.91636 934.473 3.48927C958.099 -1.93782 981.726 12.7996 987.153 36.4261L1014.38 154.465C1019.86 178.092 1005.07 201.718 981.445 207.145Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M970.637 -41.7519L1030.15 -42.5941L1011.11 -22.7104L1007.78 4.61231L970.637 -41.7987V-41.7519ZM1071.74 -18.2189C1094.57 -26.4063 1119.74 -14.4761 1127.93 8.35507L1168.73 122.417C1176.91 145.249 1164.98 170.419 1142.15 178.606C1119.32 186.794 1094.15 174.864 1085.96 152.032L1045.17 37.9701C1036.98 15.1389 1048.91 -10.0315 1071.74 -18.2189Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M443.555 -71.4137L501.989 -60.1853L479.299 -44.559L470.55 -18.4529L443.555 -71.4137ZM537.827 -27.9503C561.875 -31.3189 584.098 -14.6164 587.466 9.43118L604.355 129.388C607.724 153.436 591.022 175.659 566.974 179.028C542.927 182.396 520.703 165.694 517.335 141.646L500.446 21.6889C497.077 -2.35873 513.779 -24.5818 537.827 -27.9503Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1520.64 -97.2391L1525.32 -37.9154L1504.22 -55.6469L1476.71 -57.1909L1520.64 -97.2858V-97.2391ZM1503.71 5.17385C1513.35 27.4436 1503.1 53.3159 1480.83 62.9536L1369.67 111.049C1347.4 120.687 1321.53 110.441 1311.89 88.1708C1302.25 65.901 1312.5 40.0288 1334.77 30.391L1445.93 -17.7042C1468.2 -27.3419 1494.07 -17.0959 1503.71 5.17385Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M438.783 -72.9576L485.24 -35.7633L457.871 -32.5351L437.941 -13.5403L438.783 -73.0044V-72.9576ZM501.802 9.47798C524.634 17.7122 536.47 42.8827 528.236 65.7139L487.159 179.683C478.924 202.514 453.754 214.35 430.923 206.116C408.092 197.882 396.255 172.712 404.489 149.88L445.566 35.9116C453.801 13.0804 478.971 1.24378 501.802 9.47798Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M669.013 70.439L614.041 93.2234L624.38 67.6787L617.316 41.0579L669.013 70.3923V70.439ZM566.367 86.0185C548.167 102.066 520.424 100.335 504.329 82.1353L424.186 -8.67486C408.139 -26.8743 409.87 -54.6179 428.07 -70.712C446.269 -86.8061 474.013 -85.0283 490.107 -66.8289L570.25 23.9813C586.297 42.1807 584.566 69.9244 566.367 86.0185Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M536.471 -63.1796L533.991 -3.71544L515.183 -23.8332L488.095 -28.652L536.517 -63.1796H536.471ZM507.37 36.4262C514.248 59.6785 500.961 84.1472 477.708 91.0247L361.541 125.412C338.288 132.289 313.82 119.002 306.942 95.7499C300.065 72.4976 313.352 48.029 336.604 41.1516L452.772 6.76441C476.024 -0.113018 500.493 13.174 507.37 36.4262Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M371.039 249.58L311.855 243.451L333.096 225.906L339.552 199.145L371.039 249.58ZM273.398 214.397C249.771 219.871 226.145 205.087 220.718 181.46L193.489 63.4213C188.015 39.7948 202.799 16.1683 226.426 10.7412C250.052 5.31414 273.679 20.0514 279.106 43.6779L306.335 161.717C311.809 185.344 297.024 208.97 273.398 214.397Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M940.461 -277.035L980.696 -233.197L953.187 -234.133L930.589 -218.366L940.461 -276.988V-277.035ZM990.24 -185.944C1011.57 -174.341 1019.43 -147.674 1007.83 -126.34L949.958 -19.95C938.356 1.38403 911.688 9.24384 890.354 -2.35889C869.02 -13.9616 861.16 -40.6292 872.763 -61.9632L930.636 -168.353C942.239 -189.687 968.906 -197.547 990.24 -185.944Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M324.814 10.3668L380.723 -9.98477L369.307 15.0922L375.202 41.9937L324.814 10.4137V10.3668ZM428.023 -0.72124C446.924 -15.9732 474.574 -13.0257 489.826 5.87549L565.899 100.101C581.151 119.002 578.203 146.652 559.302 161.904C540.401 177.156 512.751 174.209 497.499 155.308L421.426 61.082C406.174 42.1808 409.121 14.5307 428.023 -0.72124Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1450.42 -89.7534L1490.66 -45.9157L1463.15 -46.8513L1440.55 -31.0847L1450.42 -89.7066V-89.7534ZM1500.2 1.33743C1521.53 12.9402 1529.39 39.6077 1517.79 60.9418L1459.92 167.331C1448.31 188.666 1421.65 196.525 1400.31 184.923C1378.98 173.32 1371.12 146.652 1382.72 125.318L1440.59 18.9287C1452.2 -2.40535 1478.87 -10.2653 1500.2 1.33743Z",
                        fill: "#CB7FF5"
                    })
                ]
            })
        ]
    });

});


parcelRegister("6nTac", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $489bc9d32a5c9852$export$2e2bcd8739ae039; });
/* design-refresh-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $dZNgt = parcelRequire("dZNgt");

var $jehLw = parcelRequire("jehLw");

var $kbpa7 = parcelRequire("kbpa7");

var $hMmnm = parcelRequire("hMmnm");
const $489bc9d32a5c9852$var$UniformDesignRefreshHeading = ({ heading: heading, subheading: subheading, emphasisStyle: emphasisStyle = 'blueShapes', textColor: textColor = 'dark' })=>{
    const textColorClass = textColor === 'light' ? 'textColor-light' : '';
    const getNode = (value)=>{
        if (!value) return undefined;
        return value.root || value;
    };
    const headingNode = getNode(heading);
    const subheadingNode = getNode(subheading);
    const hasHeading = heading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(heading);
    const hasSubheading = subheading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(subheading);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            hasHeading && headingNode && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1yoqidpf _rojhidpf _f0a5idpf _823zidpf _1n3widpf _gkzjidpf _pb27idpf _1x9pidpf _d09g1gnr _1bpp1gnr _ihkewebb _1rfewebb _io87pxbi _1ticpxbi _1ppph2mm _1uh8h2mm _bsml4jg8 _1kix4jg8 _uy2yb3bt _jmz4b3bt _4ql2stnw _3ebnstnw _1shtpm4n _1l3mpm4n _137116r0 _1egr16r0 _1i9t1et3 _6vws1et3 _1l9v8vuz _1lf68vuz _12eq1f51 _q8d91f51 _hhnzmgnk _uu55mgnk _1u2lglyw _15rkglyw _1quaov9v _1fzcov9v _7rsb1wug _jzo61wug _1tcg10j7 _15oh10j7 _zk071kdv _1rnv1kdv _d5961j28 _jmh61j28 _r0xv1kdv _32hl1kdv _eycy1x5a _33xt1x5a _jxar4pt2 _1haa4pt2 _1wsv8pqr _1paf8pqr _9x3m128p _dftg1mtn _qoyo1mw4 _744p2rrj _ydm7izje _lyva1uns _ck5g1afi _dgcs1afi",
                    `design-refresh-heading ${emphasisStyle} ${textColorClass}`
                ]),
                style: {
                    "--_12dmybu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue500')),
                    "--_1lttd86": (0, $6ZVlx.default)($489bc9d32a5c9852$var$cssifySVG((0, $hMmnm.blueShapesSVG)())),
                    "--_1dbhfcn": (0, $6ZVlx.default)($489bc9d32a5c9852$var$cssifySVG((0, $hMmnm.eyelashes)((0, $kbpa7.wacToken)('color.extended.blue500')))),
                    "--_1z9q1i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple500')),
                    "--_3zd0ej": (0, $6ZVlx.default)($489bc9d32a5c9852$var$cssifySVG((0, $hMmnm.orangePurpleShapesSVG)())),
                    "--_gf2t10": (0, $6ZVlx.default)($489bc9d32a5c9852$var$cssifySVG((0, $hMmnm.eyelashes)((0, $kbpa7.wacToken)('color.extended.purple500')))),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                    node: headingNode,
                    resolveRichTextRenderer: $489bc9d32a5c9852$var$resolveHeadingRenderer
                })
            }),
            hasSubheading && subheadingNode && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _q7gq1k92 _zcqxbs82 _1jzw1afi _vako1afi",
                    textColorClass
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                    node: subheadingNode,
                    resolveRichTextRenderer: $489bc9d32a5c9852$var$resolveSubheadingRenderer
                })
            })
        ]
    });
};
const $489bc9d32a5c9852$var$cssifySVG = (svgElement)=>{
    const svgString = (0, $jehLw.renderToStaticMarkup)(svgElement);
    return 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString) + '")';
};
const $489bc9d32a5c9852$var$containerCss = null;
const $489bc9d32a5c9852$var$headingCss = null;
const $489bc9d32a5c9852$var$subheadingCss = null;
function $489bc9d32a5c9852$var$resolveHeadingRenderer(node) {
    if (node.type === 'heading' || node.type === 'paragraph') return ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
            children: children
        });
    return undefined;
}
function $489bc9d32a5c9852$var$resolveSubheadingRenderer(node) {
    if (node.type === 'paragraph') return ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: children
        });
    return undefined;
}
var $489bc9d32a5c9852$export$2e2bcd8739ae039 = $489bc9d32a5c9852$var$UniformDesignRefreshHeading;

});
parcelRegister("jehLw", function(module, exports) {
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $dffd1af9bc104dd9$export$eb3a06aef9e6ee51; }, function (v) { return $dffd1af9bc104dd9$export$eb3a06aef9e6ee51 = v; });
var $dffd1af9bc104dd9$export$83d89fbfd8236492;
var $dffd1af9bc104dd9$export$80e7718417253a51;
var $dffd1af9bc104dd9$export$eb3a06aef9e6ee51;
var $dffd1af9bc104dd9$export$307591e98609eddd;
var $dffd1af9bc104dd9$export$b23711c915539651;
var $dffd1af9bc104dd9$export$7020a3240b287705;
'use strict';
var $dffd1af9bc104dd9$var$l, $dffd1af9bc104dd9$var$s;

$dffd1af9bc104dd9$var$l = (parcelRequire("8hHXc"));

$dffd1af9bc104dd9$var$s = (parcelRequire("dRPp5"));
$dffd1af9bc104dd9$export$83d89fbfd8236492 = $dffd1af9bc104dd9$var$l.version;
$dffd1af9bc104dd9$export$80e7718417253a51 = $dffd1af9bc104dd9$var$l.renderToString;
$dffd1af9bc104dd9$export$eb3a06aef9e6ee51 = $dffd1af9bc104dd9$var$l.renderToStaticMarkup;
$dffd1af9bc104dd9$export$307591e98609eddd = $dffd1af9bc104dd9$var$l.renderToNodeStream;
$dffd1af9bc104dd9$export$b23711c915539651 = $dffd1af9bc104dd9$var$l.renderToStaticNodeStream;
$dffd1af9bc104dd9$export$7020a3240b287705 = $dffd1af9bc104dd9$var$s.renderToReadableStream;

});
parcelRegister("8hHXc", function(module, exports) {
$parcel$export(module.exports, "renderToNodeStream", function () { return $60820199b182faf3$export$307591e98609eddd; }, function (v) { return $60820199b182faf3$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $60820199b182faf3$export$eb3a06aef9e6ee51; }, function (v) { return $60820199b182faf3$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $60820199b182faf3$export$b23711c915539651; }, function (v) { return $60820199b182faf3$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToString", function () { return $60820199b182faf3$export$80e7718417253a51; }, function (v) { return $60820199b182faf3$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "version", function () { return $60820199b182faf3$export$83d89fbfd8236492; }, function (v) { return $60820199b182faf3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $60820199b182faf3$export$307591e98609eddd;
var $60820199b182faf3$export$eb3a06aef9e6ee51;
var $60820199b182faf3$export$b23711c915539651;
var $60820199b182faf3$export$80e7718417253a51;
var $60820199b182faf3$export$83d89fbfd8236492;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
function $60820199b182faf3$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $60820199b182faf3$var$p = Object.prototype.hasOwnProperty, $60820199b182faf3$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $60820199b182faf3$var$ha = {}, $60820199b182faf3$var$ia = {};
function $60820199b182faf3$var$ja(a) {
    if ($60820199b182faf3$var$p.call($60820199b182faf3$var$ia, a)) return !0;
    if ($60820199b182faf3$var$p.call($60820199b182faf3$var$ha, a)) return !1;
    if ($60820199b182faf3$var$fa.test(a)) return $60820199b182faf3$var$ia[a] = !0;
    $60820199b182faf3$var$ha[a] = !0;
    return !1;
}
function $60820199b182faf3$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $60820199b182faf3$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $60820199b182faf3$var$t[b] = new $60820199b182faf3$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $60820199b182faf3$var$ka = /[\-:]([a-z])/g;
function $60820199b182faf3$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($60820199b182faf3$var$ka, $60820199b182faf3$var$la);
    $60820199b182faf3$var$t[b] = new $60820199b182faf3$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($60820199b182faf3$var$ka, $60820199b182faf3$var$la);
    $60820199b182faf3$var$t[b] = new $60820199b182faf3$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($60820199b182faf3$var$ka, $60820199b182faf3$var$la);
    $60820199b182faf3$var$t[b] = new $60820199b182faf3$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$60820199b182faf3$var$t.xlinkHref = new $60820199b182faf3$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $60820199b182faf3$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $60820199b182faf3$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($60820199b182faf3$var$u).forEach(function(a) {
    $60820199b182faf3$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $60820199b182faf3$var$u[b] = $60820199b182faf3$var$u[a];
    });
});
var $60820199b182faf3$var$na = /["'&<>]/;
function $60820199b182faf3$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $60820199b182faf3$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $60820199b182faf3$var$oa = /([A-Z])/g, $60820199b182faf3$var$pa = /^ms-/, $60820199b182faf3$var$qa = Array.isArray;
function $60820199b182faf3$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $60820199b182faf3$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $60820199b182faf3$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $60820199b182faf3$var$w(2, null);
        case "math":
            return $60820199b182faf3$var$w(3, null);
        case "foreignObject":
            return $60820199b182faf3$var$w(1, null);
        case "table":
            return $60820199b182faf3$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $60820199b182faf3$var$w(5, null);
        case "colgroup":
            return $60820199b182faf3$var$w(7, null);
        case "tr":
            return $60820199b182faf3$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $60820199b182faf3$var$w(1, null) : a;
}
var $60820199b182faf3$var$sa = new Map;
function $60820199b182faf3$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($60820199b182faf3$var$l(62));
    b = !0;
    for(var d in c)if ($60820199b182faf3$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $60820199b182faf3$var$v(d);
                f = $60820199b182faf3$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $60820199b182faf3$var$sa.get(e);
                void 0 !== g ? e = g : (g = $60820199b182faf3$var$v(e.replace($60820199b182faf3$var$oa, "-$1").toLowerCase().replace($60820199b182faf3$var$pa, "-ms-")), $60820199b182faf3$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $60820199b182faf3$var$p.call($60820199b182faf3$var$u, d) ? "" + f : f + "px" : $60820199b182faf3$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $60820199b182faf3$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $60820199b182faf3$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $60820199b182faf3$var$t.hasOwnProperty(c) ? $60820199b182faf3$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
            }
        } else if ($60820199b182faf3$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
        }
    }
}
function $60820199b182faf3$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($60820199b182faf3$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($60820199b182faf3$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $60820199b182faf3$var$ua(a) {
    var b = "";
    $1oC0p.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $60820199b182faf3$var$va(a, b, c, d) {
    a.push($60820199b182faf3$var$A(c));
    var f = c = null, e;
    for(e in b)if ($60820199b182faf3$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $60820199b182faf3$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $60820199b182faf3$var$y(a, f, c);
    return "string" === typeof c ? (a.push($60820199b182faf3$var$v(c)), null) : c;
}
var $60820199b182faf3$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $60820199b182faf3$var$xa = new Map;
function $60820199b182faf3$var$A(a) {
    var b = $60820199b182faf3$var$xa.get(a);
    if (void 0 === b) {
        if (!$60820199b182faf3$var$wa.test(a)) throw Error($60820199b182faf3$var$l(65, a));
        b = "<" + a;
        $60820199b182faf3$var$xa.set(a, b);
    }
    return b;
}
function $60820199b182faf3$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($60820199b182faf3$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($60820199b182faf3$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $60820199b182faf3$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $60820199b182faf3$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($60820199b182faf3$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($60820199b182faf3$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $60820199b182faf3$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $60820199b182faf3$var$ua(h), $60820199b182faf3$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $60820199b182faf3$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($60820199b182faf3$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($60820199b182faf3$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(91));
                default:
                    $60820199b182faf3$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($60820199b182faf3$var$l(92));
                if ($60820199b182faf3$var$qa(n) && 1 < n.length) throw Error($60820199b182faf3$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($60820199b182faf3$var$v("" + e));
            return null;
        case "input":
            a.push($60820199b182faf3$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($60820199b182faf3$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $60820199b182faf3$var$x(a, d, g, m);
            }
            null !== n ? $60820199b182faf3$var$x(a, d, "checked", n) : null !== k && $60820199b182faf3$var$x(a, d, "checked", k);
            null !== e ? $60820199b182faf3$var$x(a, d, "value", e) : null !== h && $60820199b182faf3$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($60820199b182faf3$var$A("menuitem"));
            for(var C in c)if ($60820199b182faf3$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(400));
                default:
                    $60820199b182faf3$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($60820199b182faf3$var$A("title"));
            e = null;
            for(q in c)if ($60820199b182faf3$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(434));
                default:
                    $60820199b182faf3$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($60820199b182faf3$var$A(b));
            g = e = null;
            for(k in c)if ($60820199b182faf3$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $60820199b182faf3$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($60820199b182faf3$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($60820199b182faf3$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($60820199b182faf3$var$A(b));
            for(var D in c)if ($60820199b182faf3$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(399, b));
                default:
                    $60820199b182faf3$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $60820199b182faf3$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $60820199b182faf3$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $60820199b182faf3$var$va(a, c, b, d);
            a.push($60820199b182faf3$var$A(b));
            g = e = null;
            for(m in c)if ($60820199b182faf3$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $60820199b182faf3$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $60820199b182faf3$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $60820199b182faf3$var$v(h), '"');
            }
            a.push(">");
            $60820199b182faf3$var$y(a, g, e);
            return e;
    }
}
function $60820199b182faf3$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($60820199b182faf3$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $60820199b182faf3$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($60820199b182faf3$var$l(397));
    }
}
function $60820199b182faf3$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($60820199b182faf3$var$l(397));
    }
}
var $60820199b182faf3$var$Ca = /[<\u2028\u2029]/g;
function $60820199b182faf3$var$Da(a) {
    return JSON.stringify(a).replace($60820199b182faf3$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $60820199b182faf3$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $60820199b182faf3$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($60820199b182faf3$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($60820199b182faf3$var$v(b)), a = !0);
    return a;
}
var $60820199b182faf3$var$B = Object.assign, $60820199b182faf3$var$Ga = Symbol.for("react.element"), $60820199b182faf3$var$Ha = Symbol.for("react.portal"), $60820199b182faf3$var$Ia = Symbol.for("react.fragment"), $60820199b182faf3$var$Ja = Symbol.for("react.strict_mode"), $60820199b182faf3$var$Ka = Symbol.for("react.profiler"), $60820199b182faf3$var$La = Symbol.for("react.provider"), $60820199b182faf3$var$Ma = Symbol.for("react.context"), $60820199b182faf3$var$Na = Symbol.for("react.forward_ref"), $60820199b182faf3$var$Oa = Symbol.for("react.suspense"), $60820199b182faf3$var$Pa = Symbol.for("react.suspense_list"), $60820199b182faf3$var$Qa = Symbol.for("react.memo"), $60820199b182faf3$var$Ra = Symbol.for("react.lazy"), $60820199b182faf3$var$Sa = Symbol.for("react.scope"), $60820199b182faf3$var$Ta = Symbol.for("react.debug_trace_mode"), $60820199b182faf3$var$Ua = Symbol.for("react.legacy_hidden"), $60820199b182faf3$var$Va = Symbol.for("react.default_value"), $60820199b182faf3$var$Wa = Symbol.iterator;
function $60820199b182faf3$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $60820199b182faf3$var$Ia:
            return "Fragment";
        case $60820199b182faf3$var$Ha:
            return "Portal";
        case $60820199b182faf3$var$Ka:
            return "Profiler";
        case $60820199b182faf3$var$Ja:
            return "StrictMode";
        case $60820199b182faf3$var$Oa:
            return "Suspense";
        case $60820199b182faf3$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $60820199b182faf3$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $60820199b182faf3$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $60820199b182faf3$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $60820199b182faf3$var$Qa:
            return b = a.displayName || null, null !== b ? b : $60820199b182faf3$var$Xa(a.type) || "Memo";
        case $60820199b182faf3$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $60820199b182faf3$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $60820199b182faf3$var$Ya = {};
function $60820199b182faf3$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $60820199b182faf3$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $60820199b182faf3$var$E = null;
function $60820199b182faf3$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($60820199b182faf3$var$l(401));
        } else {
            if (null === c) throw Error($60820199b182faf3$var$l(401));
            $60820199b182faf3$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $60820199b182faf3$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $60820199b182faf3$var$$a(a);
}
function $60820199b182faf3$var$ab(a) {
    var b = a.parent;
    null !== b && $60820199b182faf3$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $60820199b182faf3$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($60820199b182faf3$var$l(402));
    a.depth === b.depth ? $60820199b182faf3$var$F(a, b) : $60820199b182faf3$var$bb(a, b);
}
function $60820199b182faf3$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($60820199b182faf3$var$l(402));
    a.depth === c.depth ? $60820199b182faf3$var$F(a, c) : $60820199b182faf3$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $60820199b182faf3$var$G(a) {
    var b = $60820199b182faf3$var$E;
    b !== a && (null === b ? $60820199b182faf3$var$ab(a) : null === a ? $60820199b182faf3$var$$a(b) : b.depth === a.depth ? $60820199b182faf3$var$F(b, a) : b.depth > a.depth ? $60820199b182faf3$var$bb(b, a) : $60820199b182faf3$var$cb(b, a), $60820199b182faf3$var$E = a);
}
var $60820199b182faf3$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $60820199b182faf3$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $60820199b182faf3$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $60820199b182faf3$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $60820199b182faf3$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $60820199b182faf3$var$B({}, e, h)) : $60820199b182faf3$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $60820199b182faf3$var$fb = {
    id: 1,
    overflow: ""
};
function $60820199b182faf3$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $60820199b182faf3$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $60820199b182faf3$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $60820199b182faf3$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $60820199b182faf3$var$H = Math.clz32 ? Math.clz32 : $60820199b182faf3$var$hb, $60820199b182faf3$var$ib = Math.log, $60820199b182faf3$var$jb = Math.LN2;
function $60820199b182faf3$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($60820199b182faf3$var$ib(a) / $60820199b182faf3$var$jb | 0) | 0;
}
function $60820199b182faf3$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $60820199b182faf3$var$lb = "function" === typeof Object.is ? Object.is : $60820199b182faf3$var$kb, $60820199b182faf3$var$I = null, $60820199b182faf3$var$ob = null, $60820199b182faf3$var$J = null, $60820199b182faf3$var$K = null, $60820199b182faf3$var$L = !1, $60820199b182faf3$var$M = !1, $60820199b182faf3$var$N = 0, $60820199b182faf3$var$O = null, $60820199b182faf3$var$P = 0;
function $60820199b182faf3$var$Q() {
    if (null === $60820199b182faf3$var$I) throw Error($60820199b182faf3$var$l(321));
    return $60820199b182faf3$var$I;
}
function $60820199b182faf3$var$pb() {
    if (0 < $60820199b182faf3$var$P) throw Error($60820199b182faf3$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $60820199b182faf3$var$qb() {
    null === $60820199b182faf3$var$K ? null === $60820199b182faf3$var$J ? ($60820199b182faf3$var$L = !1, $60820199b182faf3$var$J = $60820199b182faf3$var$K = $60820199b182faf3$var$pb()) : ($60820199b182faf3$var$L = !0, $60820199b182faf3$var$K = $60820199b182faf3$var$J) : null === $60820199b182faf3$var$K.next ? ($60820199b182faf3$var$L = !1, $60820199b182faf3$var$K = $60820199b182faf3$var$K.next = $60820199b182faf3$var$pb()) : ($60820199b182faf3$var$L = !0, $60820199b182faf3$var$K = $60820199b182faf3$var$K.next);
    return $60820199b182faf3$var$K;
}
function $60820199b182faf3$var$rb() {
    $60820199b182faf3$var$ob = $60820199b182faf3$var$I = null;
    $60820199b182faf3$var$M = !1;
    $60820199b182faf3$var$J = null;
    $60820199b182faf3$var$P = 0;
    $60820199b182faf3$var$K = $60820199b182faf3$var$O = null;
}
function $60820199b182faf3$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $60820199b182faf3$var$tb(a, b, c) {
    $60820199b182faf3$var$I = $60820199b182faf3$var$Q();
    $60820199b182faf3$var$K = $60820199b182faf3$var$qb();
    if ($60820199b182faf3$var$L) {
        var d = $60820199b182faf3$var$K.queue;
        b = d.dispatch;
        if (null !== $60820199b182faf3$var$O && (c = $60820199b182faf3$var$O.get(d), void 0 !== c)) {
            $60820199b182faf3$var$O.delete(d);
            d = $60820199b182faf3$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $60820199b182faf3$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $60820199b182faf3$var$K.memoizedState,
            b
        ];
    }
    a = a === $60820199b182faf3$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $60820199b182faf3$var$K.memoizedState = a;
    a = $60820199b182faf3$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $60820199b182faf3$var$ub.bind(null, $60820199b182faf3$var$I, a);
    return [
        $60820199b182faf3$var$K.memoizedState,
        a
    ];
}
function $60820199b182faf3$var$vb(a, b) {
    $60820199b182faf3$var$I = $60820199b182faf3$var$Q();
    $60820199b182faf3$var$K = $60820199b182faf3$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $60820199b182faf3$var$K) {
        var c = $60820199b182faf3$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$60820199b182faf3$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $60820199b182faf3$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $60820199b182faf3$var$ub(a, b, c) {
    if (25 <= $60820199b182faf3$var$P) throw Error($60820199b182faf3$var$l(301));
    if (a === $60820199b182faf3$var$I) {
        if ($60820199b182faf3$var$M = !0, a = {
            action: c,
            next: null
        }, null === $60820199b182faf3$var$O && ($60820199b182faf3$var$O = new Map), c = $60820199b182faf3$var$O.get(b), void 0 === c) $60820199b182faf3$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $60820199b182faf3$var$wb() {
    throw Error($60820199b182faf3$var$l(394));
}
function $60820199b182faf3$var$R() {}
var $60820199b182faf3$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $60820199b182faf3$var$Q();
        return a._currentValue2;
    },
    useMemo: $60820199b182faf3$var$vb,
    useReducer: $60820199b182faf3$var$tb,
    useRef: function(a) {
        $60820199b182faf3$var$I = $60820199b182faf3$var$Q();
        $60820199b182faf3$var$K = $60820199b182faf3$var$qb();
        var b = $60820199b182faf3$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $60820199b182faf3$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $60820199b182faf3$var$tb($60820199b182faf3$var$sb, a);
    },
    useInsertionEffect: $60820199b182faf3$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $60820199b182faf3$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $60820199b182faf3$var$R,
    useEffect: $60820199b182faf3$var$R,
    useDebugValue: $60820199b182faf3$var$R,
    useDeferredValue: function(a) {
        $60820199b182faf3$var$Q();
        return a;
    },
    useTransition: function() {
        $60820199b182faf3$var$Q();
        return [
            !1,
            $60820199b182faf3$var$wb
        ];
    },
    useId: function() {
        var a = $60820199b182faf3$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $60820199b182faf3$var$H(a) - 1)).toString(32) + b;
        var c = $60820199b182faf3$var$S;
        if (null === c) throw Error($60820199b182faf3$var$l(404));
        b = $60820199b182faf3$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $60820199b182faf3$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($60820199b182faf3$var$l(407));
        return c();
    }
}, $60820199b182faf3$var$S = null, $60820199b182faf3$var$yb = $1oC0p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $60820199b182faf3$var$zb(a) {
    console.error(a);
    return null;
}
function $60820199b182faf3$var$T() {}
function $60820199b182faf3$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $60820199b182faf3$var$zb : f,
        onAllReady: void 0 === e ? $60820199b182faf3$var$T : e,
        onShellReady: void 0 === g ? $60820199b182faf3$var$T : g,
        onShellError: void 0 === h ? $60820199b182faf3$var$T : h,
        onFatalError: void 0 === k ? $60820199b182faf3$var$T : k
    };
    c = $60820199b182faf3$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $60820199b182faf3$var$Bb(b, a, null, c, n, $60820199b182faf3$var$Ya, null, $60820199b182faf3$var$fb);
    m.push(a);
    return b;
}
function $60820199b182faf3$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $60820199b182faf3$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $60820199b182faf3$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $60820199b182faf3$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $60820199b182faf3$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $60820199b182faf3$var$Db(a, b, c, d, f) {
    $60820199b182faf3$var$I = {};
    $60820199b182faf3$var$ob = b;
    $60820199b182faf3$var$N = 0;
    for(a = c(d, f); $60820199b182faf3$var$M;)$60820199b182faf3$var$M = !1, $60820199b182faf3$var$N = 0, $60820199b182faf3$var$P += 1, $60820199b182faf3$var$K = null, a = c(d, f);
    $60820199b182faf3$var$rb();
    return a;
}
function $60820199b182faf3$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($60820199b182faf3$var$l(108, $60820199b182faf3$var$Xa(d) || "Unknown", h));
            d = $60820199b182faf3$var$B({}, g, c);
        }
        b.legacyContext = d;
        $60820199b182faf3$var$X(a, b, f);
        b.legacyContext = g;
    } else $60820199b182faf3$var$X(a, b, f);
}
function $60820199b182faf3$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $60820199b182faf3$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $60820199b182faf3$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $60820199b182faf3$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $60820199b182faf3$var$eb(e, c, d, f);
            $60820199b182faf3$var$Eb(a, b, e, c);
        } else {
            e = $60820199b182faf3$var$Za(c, b.legacyContext);
            f = $60820199b182faf3$var$Db(a, b, c, d, e);
            var g = 0 !== $60820199b182faf3$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $60820199b182faf3$var$eb(f, c, d, e), $60820199b182faf3$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $60820199b182faf3$var$gb(d, 1, 0);
                try {
                    $60820199b182faf3$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $60820199b182faf3$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $60820199b182faf3$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $60820199b182faf3$var$ra(g, c, d);
        $60820199b182faf3$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $60820199b182faf3$var$Ua:
            case $60820199b182faf3$var$Ta:
            case $60820199b182faf3$var$Ja:
            case $60820199b182faf3$var$Ka:
            case $60820199b182faf3$var$Ia:
                $60820199b182faf3$var$X(a, b, d.children);
                return;
            case $60820199b182faf3$var$Pa:
                $60820199b182faf3$var$X(a, b, d.children);
                return;
            case $60820199b182faf3$var$Sa:
                throw Error($60820199b182faf3$var$l(343));
            case $60820199b182faf3$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $60820199b182faf3$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $60820199b182faf3$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($60820199b182faf3$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $60820199b182faf3$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $60820199b182faf3$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $60820199b182faf3$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $60820199b182faf3$var$Na:
                d = $60820199b182faf3$var$Db(a, b, c.render, d, f);
                if (0 !== $60820199b182faf3$var$N) {
                    c = b.treeContext;
                    b.treeContext = $60820199b182faf3$var$gb(c, 1, 0);
                    try {
                        $60820199b182faf3$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $60820199b182faf3$var$X(a, b, d);
                return;
            case $60820199b182faf3$var$Qa:
                c = c.type;
                d = $60820199b182faf3$var$Fb(c, d);
                $60820199b182faf3$var$Gb(a, b, c, d, f);
                return;
            case $60820199b182faf3$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $60820199b182faf3$var$E;
                $60820199b182faf3$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $60820199b182faf3$var$X(a, b, f);
                a = $60820199b182faf3$var$E;
                if (null === a) throw Error($60820199b182faf3$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $60820199b182faf3$var$Va ? a.context._defaultValue : d;
                a = $60820199b182faf3$var$E = a.parent;
                b.context = a;
                return;
            case $60820199b182faf3$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $60820199b182faf3$var$X(a, b, d);
                return;
            case $60820199b182faf3$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $60820199b182faf3$var$Fb(c, d);
                $60820199b182faf3$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($60820199b182faf3$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $60820199b182faf3$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $60820199b182faf3$var$Ga:
                $60820199b182faf3$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $60820199b182faf3$var$Ha:
                throw Error($60820199b182faf3$var$l(257));
            case $60820199b182faf3$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $60820199b182faf3$var$X(a, b, c);
                return;
        }
        if ($60820199b182faf3$var$qa(c)) {
            $60820199b182faf3$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $60820199b182faf3$var$Wa && c[$60820199b182faf3$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $60820199b182faf3$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($60820199b182faf3$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $60820199b182faf3$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $60820199b182faf3$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $60820199b182faf3$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $60820199b182faf3$var$gb(e, d, f);
        try {
            $60820199b182faf3$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $60820199b182faf3$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $60820199b182faf3$var$X(a, b, c);
    } catch (k) {
        if ($60820199b182faf3$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $60820199b182faf3$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $60820199b182faf3$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $60820199b182faf3$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $60820199b182faf3$var$G(e), k;
    }
}
function $60820199b182faf3$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $60820199b182faf3$var$Kb(this, b, a);
}
function $60820199b182faf3$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($60820199b182faf3$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $60820199b182faf3$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $60820199b182faf3$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $60820199b182faf3$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $60820199b182faf3$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($60820199b182faf3$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $60820199b182faf3$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $60820199b182faf3$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($60820199b182faf3$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($60820199b182faf3$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $60820199b182faf3$var$Cb(a) {
    if (2 !== a.status) {
        var b = $60820199b182faf3$var$E, c = $60820199b182faf3$var$yb.current;
        $60820199b182faf3$var$yb.current = $60820199b182faf3$var$xb;
        var d = $60820199b182faf3$var$S;
        $60820199b182faf3$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $60820199b182faf3$var$G(g.context);
                    try {
                        $60820199b182faf3$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $60820199b182faf3$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($60820199b182faf3$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $60820199b182faf3$var$V(h, q);
                            null === n ? $60820199b182faf3$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $60820199b182faf3$var$Mb(a, a.destination);
        } catch (z) {
            $60820199b182faf3$var$V(a, z), $60820199b182faf3$var$W(a, z);
        } finally{
            $60820199b182faf3$var$S = d, $60820199b182faf3$var$yb.current = c, c === $60820199b182faf3$var$xb && $60820199b182faf3$var$G(b);
        }
    }
}
function $60820199b182faf3$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $60820199b182faf3$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($60820199b182faf3$var$l(390));
    }
}
function $60820199b182faf3$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $60820199b182faf3$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $60820199b182faf3$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $60820199b182faf3$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $60820199b182faf3$var$za(b, a.responseState, d);
        $60820199b182faf3$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $60820199b182faf3$var$za(b, a.responseState, d.id), $60820199b182faf3$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($60820199b182faf3$var$l(391));
    $60820199b182faf3$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $60820199b182faf3$var$Ob(a, b, c) {
    $60820199b182faf3$var$Aa(b, a.responseState, c.formatContext, c.id);
    $60820199b182faf3$var$Nb(a, b, c);
    return $60820199b182faf3$var$Ba(b, c.formatContext);
}
function $60820199b182faf3$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$60820199b182faf3$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($60820199b182faf3$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $60820199b182faf3$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($60820199b182faf3$var$l(392));
        return $60820199b182faf3$var$Ob(a, b, d);
    }
    $60820199b182faf3$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $60820199b182faf3$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $60820199b182faf3$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($60820199b182faf3$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $60820199b182faf3$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $60820199b182faf3$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $60820199b182faf3$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$60820199b182faf3$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$60820199b182faf3$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$60820199b182faf3$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $60820199b182faf3$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $60820199b182faf3$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $60820199b182faf3$var$Mb(a, a.destination);
    } catch (d) {
        $60820199b182faf3$var$V(a, d), $60820199b182faf3$var$W(a, d);
    }
}
function $60820199b182faf3$var$Sb() {}
function $60820199b182faf3$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $60820199b182faf3$var$Ab(a, $60820199b182faf3$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $60820199b182faf3$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $60820199b182faf3$var$Cb(a);
    $60820199b182faf3$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $60820199b182faf3$var$Mb(a, h);
        } catch (m) {
            $60820199b182faf3$var$V(a, m), $60820199b182faf3$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($60820199b182faf3$var$l(426));
    return g;
}
$60820199b182faf3$export$307591e98609eddd = function() {
    throw Error($60820199b182faf3$var$l(207));
};
$60820199b182faf3$export$eb3a06aef9e6ee51 = function(a, b) {
    return $60820199b182faf3$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$60820199b182faf3$export$b23711c915539651 = function() {
    throw Error($60820199b182faf3$var$l(208));
};
$60820199b182faf3$export$80e7718417253a51 = function(a, b) {
    return $60820199b182faf3$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$60820199b182faf3$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("dRPp5", function(module, exports) {
$parcel$export(module.exports, "renderToReadableStream", function () { return $a1881948aaca9e76$export$7020a3240b287705; }, function (v) { return $a1881948aaca9e76$export$7020a3240b287705 = v; });
$parcel$export(module.exports, "version", function () { return $a1881948aaca9e76$export$83d89fbfd8236492; }, function (v) { return $a1881948aaca9e76$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a1881948aaca9e76$export$7020a3240b287705;
var $a1881948aaca9e76$export$83d89fbfd8236492;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
function $a1881948aaca9e76$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a1881948aaca9e76$var$l = null, $a1881948aaca9e76$var$n = 0;
function $a1881948aaca9e76$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $a1881948aaca9e76$var$n && (a.enqueue(new Uint8Array($a1881948aaca9e76$var$l.buffer, 0, $a1881948aaca9e76$var$n)), $a1881948aaca9e76$var$l = new Uint8Array(512), $a1881948aaca9e76$var$n = 0), a.enqueue(b);
        else {
            var c = $a1881948aaca9e76$var$l.length - $a1881948aaca9e76$var$n;
            c < b.length && (0 === c ? a.enqueue($a1881948aaca9e76$var$l) : ($a1881948aaca9e76$var$l.set(b.subarray(0, c), $a1881948aaca9e76$var$n), a.enqueue($a1881948aaca9e76$var$l), b = b.subarray(c)), $a1881948aaca9e76$var$l = new Uint8Array(512), $a1881948aaca9e76$var$n = 0);
            $a1881948aaca9e76$var$l.set(b, $a1881948aaca9e76$var$n);
            $a1881948aaca9e76$var$n += b.length;
        }
    }
}
function $a1881948aaca9e76$var$t(a, b) {
    $a1881948aaca9e76$var$p(a, b);
    return !0;
}
function $a1881948aaca9e76$var$ba(a) {
    $a1881948aaca9e76$var$l && 0 < $a1881948aaca9e76$var$n && (a.enqueue(new Uint8Array($a1881948aaca9e76$var$l.buffer, 0, $a1881948aaca9e76$var$n)), $a1881948aaca9e76$var$l = null, $a1881948aaca9e76$var$n = 0);
}
var $a1881948aaca9e76$var$ca = new TextEncoder;
function $a1881948aaca9e76$var$u(a) {
    return $a1881948aaca9e76$var$ca.encode(a);
}
function $a1881948aaca9e76$var$w(a) {
    return $a1881948aaca9e76$var$ca.encode(a);
}
function $a1881948aaca9e76$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $a1881948aaca9e76$var$x = Object.prototype.hasOwnProperty, $a1881948aaca9e76$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a1881948aaca9e76$var$fa = {}, $a1881948aaca9e76$var$ha = {};
function $a1881948aaca9e76$var$ia(a) {
    if ($a1881948aaca9e76$var$x.call($a1881948aaca9e76$var$ha, a)) return !0;
    if ($a1881948aaca9e76$var$x.call($a1881948aaca9e76$var$fa, a)) return !1;
    if ($a1881948aaca9e76$var$ea.test(a)) return $a1881948aaca9e76$var$ha[a] = !0;
    $a1881948aaca9e76$var$fa[a] = !0;
    return !1;
}
function $a1881948aaca9e76$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $a1881948aaca9e76$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a1881948aaca9e76$var$z[b] = new $a1881948aaca9e76$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a1881948aaca9e76$var$ja = /[\-:]([a-z])/g;
function $a1881948aaca9e76$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a1881948aaca9e76$var$ja, $a1881948aaca9e76$var$ka);
    $a1881948aaca9e76$var$z[b] = new $a1881948aaca9e76$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a1881948aaca9e76$var$ja, $a1881948aaca9e76$var$ka);
    $a1881948aaca9e76$var$z[b] = new $a1881948aaca9e76$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a1881948aaca9e76$var$ja, $a1881948aaca9e76$var$ka);
    $a1881948aaca9e76$var$z[b] = new $a1881948aaca9e76$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a1881948aaca9e76$var$z.xlinkHref = new $a1881948aaca9e76$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $a1881948aaca9e76$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a1881948aaca9e76$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a1881948aaca9e76$var$B).forEach(function(a) {
    $a1881948aaca9e76$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a1881948aaca9e76$var$B[b] = $a1881948aaca9e76$var$B[a];
    });
});
var $a1881948aaca9e76$var$oa = /["'&<>]/;
function $a1881948aaca9e76$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $a1881948aaca9e76$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $a1881948aaca9e76$var$pa = /([A-Z])/g, $a1881948aaca9e76$var$qa = /^ms-/, $a1881948aaca9e76$var$ra = Array.isArray, $a1881948aaca9e76$var$sa = $a1881948aaca9e76$var$w("<script>"), $a1881948aaca9e76$var$ta = $a1881948aaca9e76$var$w("\x3c/script>"), $a1881948aaca9e76$var$ua = $a1881948aaca9e76$var$w('<script src="'), $a1881948aaca9e76$var$va = $a1881948aaca9e76$var$w('<script type="module" src="'), $a1881948aaca9e76$var$wa = $a1881948aaca9e76$var$w('" async="">\x3c/script>'), $a1881948aaca9e76$var$xa = /(<\/|<)(s)(cript)/gi;
function $a1881948aaca9e76$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $a1881948aaca9e76$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $a1881948aaca9e76$var$sa : $a1881948aaca9e76$var$w('<script nonce="' + $a1881948aaca9e76$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $a1881948aaca9e76$var$u(("" + c).replace($a1881948aaca9e76$var$xa, $a1881948aaca9e76$var$ya)), $a1881948aaca9e76$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($a1881948aaca9e76$var$ua, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d[c])), $a1881948aaca9e76$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($a1881948aaca9e76$var$va, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(f[d])), $a1881948aaca9e76$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $a1881948aaca9e76$var$w(a + "P:"),
        segmentPrefix: $a1881948aaca9e76$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $a1881948aaca9e76$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $a1881948aaca9e76$var$Aa(a) {
    return $a1881948aaca9e76$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $a1881948aaca9e76$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $a1881948aaca9e76$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $a1881948aaca9e76$var$D(2, null);
        case "math":
            return $a1881948aaca9e76$var$D(3, null);
        case "foreignObject":
            return $a1881948aaca9e76$var$D(1, null);
        case "table":
            return $a1881948aaca9e76$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $a1881948aaca9e76$var$D(5, null);
        case "colgroup":
            return $a1881948aaca9e76$var$D(7, null);
        case "tr":
            return $a1881948aaca9e76$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $a1881948aaca9e76$var$D(1, null) : a;
}
var $a1881948aaca9e76$var$Ca = $a1881948aaca9e76$var$w("\x3c!-- --\x3e");
function $a1881948aaca9e76$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($a1881948aaca9e76$var$Ca);
    a.push($a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(b)));
    return !0;
}
var $a1881948aaca9e76$var$Ea = new Map, $a1881948aaca9e76$var$Fa = $a1881948aaca9e76$var$w(' style="'), $a1881948aaca9e76$var$Ga = $a1881948aaca9e76$var$w(":"), $a1881948aaca9e76$var$Ha = $a1881948aaca9e76$var$w(";");
function $a1881948aaca9e76$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($a1881948aaca9e76$var$k(62));
    b = !0;
    for(var d in c)if ($a1881948aaca9e76$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d));
                f = $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $a1881948aaca9e76$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $a1881948aaca9e76$var$w($a1881948aaca9e76$var$C(e.replace($a1881948aaca9e76$var$pa, "-$1").toLowerCase().replace($a1881948aaca9e76$var$qa, "-ms-"))), $a1881948aaca9e76$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $a1881948aaca9e76$var$x.call($a1881948aaca9e76$var$B, d) ? $a1881948aaca9e76$var$u("" + f) : $a1881948aaca9e76$var$u(f + "px") : $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($a1881948aaca9e76$var$Fa, e, $a1881948aaca9e76$var$Ga, f)) : a.push($a1881948aaca9e76$var$Ha, e, $a1881948aaca9e76$var$Ga, f);
        }
    }
    b || a.push($a1881948aaca9e76$var$E);
}
var $a1881948aaca9e76$var$H = $a1881948aaca9e76$var$w(" "), $a1881948aaca9e76$var$I = $a1881948aaca9e76$var$w('="'), $a1881948aaca9e76$var$E = $a1881948aaca9e76$var$w('"'), $a1881948aaca9e76$var$Ja = $a1881948aaca9e76$var$w('=""');
function $a1881948aaca9e76$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $a1881948aaca9e76$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $a1881948aaca9e76$var$z.hasOwnProperty(c) ? $a1881948aaca9e76$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $a1881948aaca9e76$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$Ja) : !1 !== d && a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
            }
        } else if ($a1881948aaca9e76$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($a1881948aaca9e76$var$H, $a1881948aaca9e76$var$u(c), $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
        }
    }
}
var $a1881948aaca9e76$var$K = $a1881948aaca9e76$var$w(">"), $a1881948aaca9e76$var$Ka = $a1881948aaca9e76$var$w("/>");
function $a1881948aaca9e76$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($a1881948aaca9e76$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($a1881948aaca9e76$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($a1881948aaca9e76$var$u("" + b));
    }
}
function $a1881948aaca9e76$var$La(a) {
    var b = "";
    $1oC0p.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $a1881948aaca9e76$var$Ma = $a1881948aaca9e76$var$w(' selected=""');
function $a1881948aaca9e76$var$Na(a, b, c, d) {
    a.push($a1881948aaca9e76$var$M(c));
    var f = c = null, e;
    for(e in b)if ($a1881948aaca9e76$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $a1881948aaca9e76$var$J(a, d, e, g);
        }
    }
    a.push($a1881948aaca9e76$var$K);
    $a1881948aaca9e76$var$L(a, f, c);
    return "string" === typeof c ? (a.push($a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(c))), null) : c;
}
var $a1881948aaca9e76$var$Oa = $a1881948aaca9e76$var$w("\n"), $a1881948aaca9e76$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $a1881948aaca9e76$var$Qa = new Map;
function $a1881948aaca9e76$var$M(a) {
    var b = $a1881948aaca9e76$var$Qa.get(a);
    if (void 0 === b) {
        if (!$a1881948aaca9e76$var$Pa.test(a)) throw Error($a1881948aaca9e76$var$k(65, a));
        b = $a1881948aaca9e76$var$w("<" + a);
        $a1881948aaca9e76$var$Qa.set(a, b);
    }
    return b;
}
var $a1881948aaca9e76$var$Ra = $a1881948aaca9e76$var$w("<!DOCTYPE html>");
function $a1881948aaca9e76$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($a1881948aaca9e76$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($a1881948aaca9e76$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $a1881948aaca9e76$var$J(a, d, r, h);
                }
            }
            a.push($a1881948aaca9e76$var$K);
            $a1881948aaca9e76$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($a1881948aaca9e76$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($a1881948aaca9e76$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $a1881948aaca9e76$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $a1881948aaca9e76$var$La(h), $a1881948aaca9e76$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($a1881948aaca9e76$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($a1881948aaca9e76$var$Ma);
            } else q && a.push($a1881948aaca9e76$var$Ma);
            a.push($a1881948aaca9e76$var$K);
            $a1881948aaca9e76$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($a1881948aaca9e76$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($a1881948aaca9e76$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(91));
                default:
                    $a1881948aaca9e76$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($a1881948aaca9e76$var$K);
            if (null != r) {
                if (null != e) throw Error($a1881948aaca9e76$var$k(92));
                if ($a1881948aaca9e76$var$ra(r) && 1 < r.length) throw Error($a1881948aaca9e76$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($a1881948aaca9e76$var$Oa);
            null !== e && a.push($a1881948aaca9e76$var$u($a1881948aaca9e76$var$C("" + e)));
            return null;
        case "input":
            a.push($a1881948aaca9e76$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($a1881948aaca9e76$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $a1881948aaca9e76$var$J(a, d, g, q);
            }
            null !== r ? $a1881948aaca9e76$var$J(a, d, "checked", r) : null !== m && $a1881948aaca9e76$var$J(a, d, "checked", m);
            null !== e ? $a1881948aaca9e76$var$J(a, d, "value", e) : null !== h && $a1881948aaca9e76$var$J(a, d, "value", h);
            a.push($a1881948aaca9e76$var$Ka);
            return null;
        case "menuitem":
            a.push($a1881948aaca9e76$var$M("menuitem"));
            for(var A in c)if ($a1881948aaca9e76$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(400));
                default:
                    $a1881948aaca9e76$var$J(a, d, A, e);
            }
            a.push($a1881948aaca9e76$var$K);
            return null;
        case "title":
            a.push($a1881948aaca9e76$var$M("title"));
            e = null;
            for(v in c)if ($a1881948aaca9e76$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(434));
                default:
                    $a1881948aaca9e76$var$J(a, d, v, g);
            }
            a.push($a1881948aaca9e76$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($a1881948aaca9e76$var$M(b));
            g = e = null;
            for(m in c)if ($a1881948aaca9e76$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $a1881948aaca9e76$var$J(a, d, m, h);
            }
            a.push($a1881948aaca9e76$var$K);
            if (null != g) {
                if (null != e) throw Error($a1881948aaca9e76$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($a1881948aaca9e76$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($a1881948aaca9e76$var$Oa, $a1881948aaca9e76$var$u(c)) : a.push($a1881948aaca9e76$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($a1881948aaca9e76$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($a1881948aaca9e76$var$M(b));
            for(var F in c)if ($a1881948aaca9e76$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(399, b));
                default:
                    $a1881948aaca9e76$var$J(a, d, F, e);
            }
            a.push($a1881948aaca9e76$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $a1881948aaca9e76$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($a1881948aaca9e76$var$Ra), $a1881948aaca9e76$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $a1881948aaca9e76$var$Na(a, c, b, d);
            a.push($a1881948aaca9e76$var$M(b));
            g = e = null;
            for(q in c)if ($a1881948aaca9e76$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $a1881948aaca9e76$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $a1881948aaca9e76$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($a1881948aaca9e76$var$H, $a1881948aaca9e76$var$u(q), $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(h)), $a1881948aaca9e76$var$E);
            }
            a.push($a1881948aaca9e76$var$K);
            $a1881948aaca9e76$var$L(a, g, e);
            return e;
    }
}
var $a1881948aaca9e76$var$Ta = $a1881948aaca9e76$var$w("</"), $a1881948aaca9e76$var$Ua = $a1881948aaca9e76$var$w(">"), $a1881948aaca9e76$var$Va = $a1881948aaca9e76$var$w('<template id="'), $a1881948aaca9e76$var$Wa = $a1881948aaca9e76$var$w('"></template>'), $a1881948aaca9e76$var$Xa = $a1881948aaca9e76$var$w("\x3c!--$--\x3e"), $a1881948aaca9e76$var$Ya = $a1881948aaca9e76$var$w('\x3c!--$?--\x3e<template id="'), $a1881948aaca9e76$var$Za = $a1881948aaca9e76$var$w('"></template>'), $a1881948aaca9e76$var$$a = $a1881948aaca9e76$var$w("\x3c!--$!--\x3e"), $a1881948aaca9e76$var$ab = $a1881948aaca9e76$var$w("\x3c!--/$--\x3e"), $a1881948aaca9e76$var$bb = $a1881948aaca9e76$var$w("<template"), $a1881948aaca9e76$var$cb = $a1881948aaca9e76$var$w('"'), $a1881948aaca9e76$var$db = $a1881948aaca9e76$var$w(' data-dgst="');
$a1881948aaca9e76$var$w(' data-msg="');
$a1881948aaca9e76$var$w(' data-stck="');
var $a1881948aaca9e76$var$eb = $a1881948aaca9e76$var$w("></template>");
function $a1881948aaca9e76$var$fb(a, b, c) {
    $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$Ya);
    if (null === c) throw Error($a1881948aaca9e76$var$k(395));
    $a1881948aaca9e76$var$p(a, c);
    return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$Za);
}
var $a1881948aaca9e76$var$gb = $a1881948aaca9e76$var$w('<div hidden id="'), $a1881948aaca9e76$var$hb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$ib = $a1881948aaca9e76$var$w("</div>"), $a1881948aaca9e76$var$jb = $a1881948aaca9e76$var$w('<svg aria-hidden="true" style="display:none" id="'), $a1881948aaca9e76$var$kb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$lb = $a1881948aaca9e76$var$w("</svg>"), $a1881948aaca9e76$var$mb = $a1881948aaca9e76$var$w('<math aria-hidden="true" style="display:none" id="'), $a1881948aaca9e76$var$nb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$ob = $a1881948aaca9e76$var$w("</math>"), $a1881948aaca9e76$var$pb = $a1881948aaca9e76$var$w('<table hidden id="'), $a1881948aaca9e76$var$qb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$rb = $a1881948aaca9e76$var$w("</table>"), $a1881948aaca9e76$var$sb = $a1881948aaca9e76$var$w('<table hidden><tbody id="'), $a1881948aaca9e76$var$tb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$ub = $a1881948aaca9e76$var$w("</tbody></table>"), $a1881948aaca9e76$var$vb = $a1881948aaca9e76$var$w('<table hidden><tr id="'), $a1881948aaca9e76$var$wb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$xb = $a1881948aaca9e76$var$w("</tr></table>"), $a1881948aaca9e76$var$yb = $a1881948aaca9e76$var$w('<table hidden><colgroup id="'), $a1881948aaca9e76$var$zb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$Ab = $a1881948aaca9e76$var$w("</colgroup></table>");
function $a1881948aaca9e76$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$gb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$hb);
        case 2:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$jb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$kb);
        case 3:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$mb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$nb);
        case 4:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$pb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$qb);
        case 5:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$sb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$tb);
        case 6:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$vb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$wb);
        case 7:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$yb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$zb);
        default:
            throw Error($a1881948aaca9e76$var$k(397));
    }
}
function $a1881948aaca9e76$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$ib);
        case 2:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$lb);
        case 3:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$ob);
        case 4:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$rb);
        case 5:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$ub);
        case 6:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$xb);
        case 7:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$Ab);
        default:
            throw Error($a1881948aaca9e76$var$k(397));
    }
}
var $a1881948aaca9e76$var$Db = $a1881948aaca9e76$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $a1881948aaca9e76$var$Eb = $a1881948aaca9e76$var$w('$RS("'), $a1881948aaca9e76$var$Gb = $a1881948aaca9e76$var$w('","'), $a1881948aaca9e76$var$Hb = $a1881948aaca9e76$var$w('")\x3c/script>'), $a1881948aaca9e76$var$Ib = $a1881948aaca9e76$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $a1881948aaca9e76$var$Jb = $a1881948aaca9e76$var$w('$RC("'), $a1881948aaca9e76$var$Kb = $a1881948aaca9e76$var$w('","'), $a1881948aaca9e76$var$Lb = $a1881948aaca9e76$var$w('")\x3c/script>'), $a1881948aaca9e76$var$Mb = $a1881948aaca9e76$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $a1881948aaca9e76$var$Nb = $a1881948aaca9e76$var$w('$RX("'), $a1881948aaca9e76$var$Ob = $a1881948aaca9e76$var$w('"'), $a1881948aaca9e76$var$Pb = $a1881948aaca9e76$var$w(")\x3c/script>"), $a1881948aaca9e76$var$Qb = $a1881948aaca9e76$var$w(","), $a1881948aaca9e76$var$Rb = /[<\u2028\u2029]/g;
function $a1881948aaca9e76$var$Sb(a) {
    return JSON.stringify(a).replace($a1881948aaca9e76$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $a1881948aaca9e76$var$N = Object.assign, $a1881948aaca9e76$var$Tb = Symbol.for("react.element"), $a1881948aaca9e76$var$Ub = Symbol.for("react.portal"), $a1881948aaca9e76$var$Vb = Symbol.for("react.fragment"), $a1881948aaca9e76$var$Wb = Symbol.for("react.strict_mode"), $a1881948aaca9e76$var$Xb = Symbol.for("react.profiler"), $a1881948aaca9e76$var$Yb = Symbol.for("react.provider"), $a1881948aaca9e76$var$Zb = Symbol.for("react.context"), $a1881948aaca9e76$var$$b = Symbol.for("react.forward_ref"), $a1881948aaca9e76$var$ac = Symbol.for("react.suspense"), $a1881948aaca9e76$var$bc = Symbol.for("react.suspense_list"), $a1881948aaca9e76$var$cc = Symbol.for("react.memo"), $a1881948aaca9e76$var$dc = Symbol.for("react.lazy"), $a1881948aaca9e76$var$ec = Symbol.for("react.scope"), $a1881948aaca9e76$var$fc = Symbol.for("react.debug_trace_mode"), $a1881948aaca9e76$var$gc = Symbol.for("react.legacy_hidden"), $a1881948aaca9e76$var$hc = Symbol.for("react.default_value"), $a1881948aaca9e76$var$ic = Symbol.iterator;
function $a1881948aaca9e76$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a1881948aaca9e76$var$Vb:
            return "Fragment";
        case $a1881948aaca9e76$var$Ub:
            return "Portal";
        case $a1881948aaca9e76$var$Xb:
            return "Profiler";
        case $a1881948aaca9e76$var$Wb:
            return "StrictMode";
        case $a1881948aaca9e76$var$ac:
            return "Suspense";
        case $a1881948aaca9e76$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a1881948aaca9e76$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $a1881948aaca9e76$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $a1881948aaca9e76$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a1881948aaca9e76$var$cc:
            return b = a.displayName || null, null !== b ? b : $a1881948aaca9e76$var$jc(a.type) || "Memo";
        case $a1881948aaca9e76$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $a1881948aaca9e76$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $a1881948aaca9e76$var$kc = {};
function $a1881948aaca9e76$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $a1881948aaca9e76$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $a1881948aaca9e76$var$O = null;
function $a1881948aaca9e76$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($a1881948aaca9e76$var$k(401));
        } else {
            if (null === c) throw Error($a1881948aaca9e76$var$k(401));
            $a1881948aaca9e76$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $a1881948aaca9e76$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $a1881948aaca9e76$var$mc(a);
}
function $a1881948aaca9e76$var$nc(a) {
    var b = a.parent;
    null !== b && $a1881948aaca9e76$var$nc(b);
    a.context._currentValue = a.value;
}
function $a1881948aaca9e76$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($a1881948aaca9e76$var$k(402));
    a.depth === b.depth ? $a1881948aaca9e76$var$P(a, b) : $a1881948aaca9e76$var$oc(a, b);
}
function $a1881948aaca9e76$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($a1881948aaca9e76$var$k(402));
    a.depth === c.depth ? $a1881948aaca9e76$var$P(a, c) : $a1881948aaca9e76$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $a1881948aaca9e76$var$Q(a) {
    var b = $a1881948aaca9e76$var$O;
    b !== a && (null === b ? $a1881948aaca9e76$var$nc(a) : null === a ? $a1881948aaca9e76$var$mc(b) : b.depth === a.depth ? $a1881948aaca9e76$var$P(b, a) : b.depth > a.depth ? $a1881948aaca9e76$var$oc(b, a) : $a1881948aaca9e76$var$pc(b, a), $a1881948aaca9e76$var$O = a);
}
var $a1881948aaca9e76$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $a1881948aaca9e76$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $a1881948aaca9e76$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $a1881948aaca9e76$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $a1881948aaca9e76$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $a1881948aaca9e76$var$N({}, e, h)) : $a1881948aaca9e76$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $a1881948aaca9e76$var$sc = {
    id: 1,
    overflow: ""
};
function $a1881948aaca9e76$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $a1881948aaca9e76$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $a1881948aaca9e76$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $a1881948aaca9e76$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $a1881948aaca9e76$var$uc = Math.clz32 ? Math.clz32 : $a1881948aaca9e76$var$vc, $a1881948aaca9e76$var$wc = Math.log, $a1881948aaca9e76$var$xc = Math.LN2;
function $a1881948aaca9e76$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a1881948aaca9e76$var$wc(a) / $a1881948aaca9e76$var$xc | 0) | 0;
}
function $a1881948aaca9e76$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a1881948aaca9e76$var$zc = "function" === typeof Object.is ? Object.is : $a1881948aaca9e76$var$yc, $a1881948aaca9e76$var$R = null, $a1881948aaca9e76$var$Ac = null, $a1881948aaca9e76$var$Bc = null, $a1881948aaca9e76$var$S = null, $a1881948aaca9e76$var$T = !1, $a1881948aaca9e76$var$Cc = !1, $a1881948aaca9e76$var$U = 0, $a1881948aaca9e76$var$V = null, $a1881948aaca9e76$var$Dc = 0;
function $a1881948aaca9e76$var$W() {
    if (null === $a1881948aaca9e76$var$R) throw Error($a1881948aaca9e76$var$k(321));
    return $a1881948aaca9e76$var$R;
}
function $a1881948aaca9e76$var$Ec() {
    if (0 < $a1881948aaca9e76$var$Dc) throw Error($a1881948aaca9e76$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $a1881948aaca9e76$var$Fc() {
    null === $a1881948aaca9e76$var$S ? null === $a1881948aaca9e76$var$Bc ? ($a1881948aaca9e76$var$T = !1, $a1881948aaca9e76$var$Bc = $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Ec()) : ($a1881948aaca9e76$var$T = !0, $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Bc) : null === $a1881948aaca9e76$var$S.next ? ($a1881948aaca9e76$var$T = !1, $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$S.next = $a1881948aaca9e76$var$Ec()) : ($a1881948aaca9e76$var$T = !0, $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$S.next);
    return $a1881948aaca9e76$var$S;
}
function $a1881948aaca9e76$var$Gc() {
    $a1881948aaca9e76$var$Ac = $a1881948aaca9e76$var$R = null;
    $a1881948aaca9e76$var$Cc = !1;
    $a1881948aaca9e76$var$Bc = null;
    $a1881948aaca9e76$var$Dc = 0;
    $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$V = null;
}
function $a1881948aaca9e76$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a1881948aaca9e76$var$Ic(a, b, c) {
    $a1881948aaca9e76$var$R = $a1881948aaca9e76$var$W();
    $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Fc();
    if ($a1881948aaca9e76$var$T) {
        var d = $a1881948aaca9e76$var$S.queue;
        b = d.dispatch;
        if (null !== $a1881948aaca9e76$var$V && (c = $a1881948aaca9e76$var$V.get(d), void 0 !== c)) {
            $a1881948aaca9e76$var$V.delete(d);
            d = $a1881948aaca9e76$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $a1881948aaca9e76$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $a1881948aaca9e76$var$S.memoizedState,
            b
        ];
    }
    a = a === $a1881948aaca9e76$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $a1881948aaca9e76$var$S.memoizedState = a;
    a = $a1881948aaca9e76$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $a1881948aaca9e76$var$Jc.bind(null, $a1881948aaca9e76$var$R, a);
    return [
        $a1881948aaca9e76$var$S.memoizedState,
        a
    ];
}
function $a1881948aaca9e76$var$Kc(a, b) {
    $a1881948aaca9e76$var$R = $a1881948aaca9e76$var$W();
    $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $a1881948aaca9e76$var$S) {
        var c = $a1881948aaca9e76$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$a1881948aaca9e76$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $a1881948aaca9e76$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a1881948aaca9e76$var$Jc(a, b, c) {
    if (25 <= $a1881948aaca9e76$var$Dc) throw Error($a1881948aaca9e76$var$k(301));
    if (a === $a1881948aaca9e76$var$R) {
        if ($a1881948aaca9e76$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $a1881948aaca9e76$var$V && ($a1881948aaca9e76$var$V = new Map), c = $a1881948aaca9e76$var$V.get(b), void 0 === c) $a1881948aaca9e76$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $a1881948aaca9e76$var$Lc() {
    throw Error($a1881948aaca9e76$var$k(394));
}
function $a1881948aaca9e76$var$Mc() {}
var $a1881948aaca9e76$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $a1881948aaca9e76$var$W();
        return a._currentValue;
    },
    useMemo: $a1881948aaca9e76$var$Kc,
    useReducer: $a1881948aaca9e76$var$Ic,
    useRef: function(a) {
        $a1881948aaca9e76$var$R = $a1881948aaca9e76$var$W();
        $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Fc();
        var b = $a1881948aaca9e76$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $a1881948aaca9e76$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $a1881948aaca9e76$var$Ic($a1881948aaca9e76$var$Hc, a);
    },
    useInsertionEffect: $a1881948aaca9e76$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $a1881948aaca9e76$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $a1881948aaca9e76$var$Mc,
    useEffect: $a1881948aaca9e76$var$Mc,
    useDebugValue: $a1881948aaca9e76$var$Mc,
    useDeferredValue: function(a) {
        $a1881948aaca9e76$var$W();
        return a;
    },
    useTransition: function() {
        $a1881948aaca9e76$var$W();
        return [
            !1,
            $a1881948aaca9e76$var$Lc
        ];
    },
    useId: function() {
        var a = $a1881948aaca9e76$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $a1881948aaca9e76$var$uc(a) - 1)).toString(32) + b;
        var c = $a1881948aaca9e76$var$Nc;
        if (null === c) throw Error($a1881948aaca9e76$var$k(404));
        b = $a1881948aaca9e76$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $a1881948aaca9e76$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($a1881948aaca9e76$var$k(407));
        return c();
    }
}, $a1881948aaca9e76$var$Nc = null, $a1881948aaca9e76$var$Pc = $1oC0p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $a1881948aaca9e76$var$Qc(a) {
    console.error(a);
    return null;
}
function $a1881948aaca9e76$var$X() {}
function $a1881948aaca9e76$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $a1881948aaca9e76$var$Qc : f,
        onAllReady: void 0 === e ? $a1881948aaca9e76$var$X : e,
        onShellReady: void 0 === g ? $a1881948aaca9e76$var$X : g,
        onShellError: void 0 === h ? $a1881948aaca9e76$var$X : h,
        onFatalError: void 0 === m ? $a1881948aaca9e76$var$X : m
    };
    c = $a1881948aaca9e76$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $a1881948aaca9e76$var$Tc(b, a, null, c, r, $a1881948aaca9e76$var$kc, null, $a1881948aaca9e76$var$sc);
    q.push(a);
    return b;
}
function $a1881948aaca9e76$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $a1881948aaca9e76$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $a1881948aaca9e76$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $a1881948aaca9e76$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $a1881948aaca9e76$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $a1881948aaca9e76$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $a1881948aaca9e76$var$Wc(a, b, c, d, f) {
    $a1881948aaca9e76$var$R = {};
    $a1881948aaca9e76$var$Ac = b;
    $a1881948aaca9e76$var$U = 0;
    for(a = c(d, f); $a1881948aaca9e76$var$Cc;)$a1881948aaca9e76$var$Cc = !1, $a1881948aaca9e76$var$U = 0, $a1881948aaca9e76$var$Dc += 1, $a1881948aaca9e76$var$S = null, a = c(d, f);
    $a1881948aaca9e76$var$Gc();
    return a;
}
function $a1881948aaca9e76$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($a1881948aaca9e76$var$k(108, $a1881948aaca9e76$var$jc(d) || "Unknown", h));
            d = $a1881948aaca9e76$var$N({}, g, c);
        }
        b.legacyContext = d;
        $a1881948aaca9e76$var$Z(a, b, f);
        b.legacyContext = g;
    } else $a1881948aaca9e76$var$Z(a, b, f);
}
function $a1881948aaca9e76$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $a1881948aaca9e76$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $a1881948aaca9e76$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $a1881948aaca9e76$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $a1881948aaca9e76$var$rc(e, c, d, f);
            $a1881948aaca9e76$var$Xc(a, b, e, c);
        } else {
            e = $a1881948aaca9e76$var$lc(c, b.legacyContext);
            f = $a1881948aaca9e76$var$Wc(a, b, c, d, e);
            var g = 0 !== $a1881948aaca9e76$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $a1881948aaca9e76$var$rc(f, c, d, e), $a1881948aaca9e76$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $a1881948aaca9e76$var$tc(d, 1, 0);
                try {
                    $a1881948aaca9e76$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $a1881948aaca9e76$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $a1881948aaca9e76$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $a1881948aaca9e76$var$Ba(g, c, d);
        $a1881948aaca9e76$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($a1881948aaca9e76$var$Ta, $a1881948aaca9e76$var$u(c), $a1881948aaca9e76$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $a1881948aaca9e76$var$gc:
            case $a1881948aaca9e76$var$fc:
            case $a1881948aaca9e76$var$Wb:
            case $a1881948aaca9e76$var$Xb:
            case $a1881948aaca9e76$var$Vb:
                $a1881948aaca9e76$var$Z(a, b, d.children);
                return;
            case $a1881948aaca9e76$var$bc:
                $a1881948aaca9e76$var$Z(a, b, d.children);
                return;
            case $a1881948aaca9e76$var$ec:
                throw Error($a1881948aaca9e76$var$k(343));
            case $a1881948aaca9e76$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $a1881948aaca9e76$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $a1881948aaca9e76$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($a1881948aaca9e76$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($a1881948aaca9e76$var$Ca), q.status = 1, $a1881948aaca9e76$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $a1881948aaca9e76$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $a1881948aaca9e76$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $a1881948aaca9e76$var$$b:
                d = $a1881948aaca9e76$var$Wc(a, b, c.render, d, f);
                if (0 !== $a1881948aaca9e76$var$U) {
                    c = b.treeContext;
                    b.treeContext = $a1881948aaca9e76$var$tc(c, 1, 0);
                    try {
                        $a1881948aaca9e76$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $a1881948aaca9e76$var$Z(a, b, d);
                return;
            case $a1881948aaca9e76$var$cc:
                c = c.type;
                d = $a1881948aaca9e76$var$Yc(c, d);
                $a1881948aaca9e76$var$Zc(a, b, c, d, f);
                return;
            case $a1881948aaca9e76$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $a1881948aaca9e76$var$O;
                $a1881948aaca9e76$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $a1881948aaca9e76$var$Z(a, b, f);
                a = $a1881948aaca9e76$var$O;
                if (null === a) throw Error($a1881948aaca9e76$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $a1881948aaca9e76$var$hc ? a.context._defaultValue : d;
                a = $a1881948aaca9e76$var$O = a.parent;
                b.context = a;
                return;
            case $a1881948aaca9e76$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $a1881948aaca9e76$var$Z(a, b, d);
                return;
            case $a1881948aaca9e76$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $a1881948aaca9e76$var$Yc(c, d);
                $a1881948aaca9e76$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($a1881948aaca9e76$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $a1881948aaca9e76$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $a1881948aaca9e76$var$Tb:
                $a1881948aaca9e76$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $a1881948aaca9e76$var$Ub:
                throw Error($a1881948aaca9e76$var$k(257));
            case $a1881948aaca9e76$var$dc:
                var d = c._init;
                c = d(c._payload);
                $a1881948aaca9e76$var$Z(a, b, c);
                return;
        }
        if ($a1881948aaca9e76$var$ra(c)) {
            $a1881948aaca9e76$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $a1881948aaca9e76$var$ic && c[$a1881948aaca9e76$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $a1881948aaca9e76$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($a1881948aaca9e76$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $a1881948aaca9e76$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $a1881948aaca9e76$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $a1881948aaca9e76$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $a1881948aaca9e76$var$tc(e, d, f);
        try {
            $a1881948aaca9e76$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $a1881948aaca9e76$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $a1881948aaca9e76$var$Z(a, b, c);
    } catch (m) {
        if ($a1881948aaca9e76$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $a1881948aaca9e76$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $a1881948aaca9e76$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $a1881948aaca9e76$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $a1881948aaca9e76$var$Q(e), m;
    }
}
function $a1881948aaca9e76$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $a1881948aaca9e76$var$dd(this, b, a);
}
function $a1881948aaca9e76$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($a1881948aaca9e76$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $a1881948aaca9e76$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $a1881948aaca9e76$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $a1881948aaca9e76$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $a1881948aaca9e76$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($a1881948aaca9e76$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $a1881948aaca9e76$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $a1881948aaca9e76$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($a1881948aaca9e76$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($a1881948aaca9e76$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $a1881948aaca9e76$var$Uc(a) {
    if (2 !== a.status) {
        var b = $a1881948aaca9e76$var$O, c = $a1881948aaca9e76$var$Pc.current;
        $a1881948aaca9e76$var$Pc.current = $a1881948aaca9e76$var$Oc;
        var d = $a1881948aaca9e76$var$Nc;
        $a1881948aaca9e76$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $a1881948aaca9e76$var$Q(g.context);
                    try {
                        $a1881948aaca9e76$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($a1881948aaca9e76$var$Ca), g.abortSet.delete(g), m.status = 1, $a1881948aaca9e76$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($a1881948aaca9e76$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $a1881948aaca9e76$var$Y(h, v);
                            null === r ? $a1881948aaca9e76$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $a1881948aaca9e76$var$fd(a, a.destination);
        } catch (G) {
            $a1881948aaca9e76$var$Y(a, G), $a1881948aaca9e76$var$Vc(a, G);
        } finally{
            $a1881948aaca9e76$var$Nc = d, $a1881948aaca9e76$var$Pc.current = c, c === $a1881948aaca9e76$var$Oc && $a1881948aaca9e76$var$Q(b);
        }
    }
}
function $a1881948aaca9e76$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Va);
            $a1881948aaca9e76$var$p(b, a.placeholderPrefix);
            a = $a1881948aaca9e76$var$u(d.toString(16));
            $a1881948aaca9e76$var$p(b, a);
            return $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$a1881948aaca9e76$var$p(b, d[e]);
                f = $a1881948aaca9e76$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$a1881948aaca9e76$var$p(b, d[e]);
            e < d.length && (f = $a1881948aaca9e76$var$t(b, d[e]));
            return f;
        default:
            throw Error($a1881948aaca9e76$var$k(390));
    }
}
function $a1881948aaca9e76$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $a1881948aaca9e76$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$$a), $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$bb), d && ($a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$db), $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d))), $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$cb)), $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$eb), $a1881948aaca9e76$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $a1881948aaca9e76$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $a1881948aaca9e76$var$fb(b, a.responseState, d);
        $a1881948aaca9e76$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $a1881948aaca9e76$var$fb(b, a.responseState, d.id), $a1881948aaca9e76$var$gd(a, b, c);
    else {
        $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($a1881948aaca9e76$var$k(391));
        $a1881948aaca9e76$var$hd(a, b, c[0]);
    }
    return $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$ab);
}
function $a1881948aaca9e76$var$id(a, b, c) {
    $a1881948aaca9e76$var$Bb(b, a.responseState, c.formatContext, c.id);
    $a1881948aaca9e76$var$hd(a, b, c);
    return $a1881948aaca9e76$var$Cb(b, c.formatContext);
}
function $a1881948aaca9e76$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$a1881948aaca9e76$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $a1881948aaca9e76$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Ib));
    if (null === d) throw Error($a1881948aaca9e76$var$k(395));
    c = $a1881948aaca9e76$var$u(c.toString(16));
    $a1881948aaca9e76$var$p(b, d);
    $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Kb);
    $a1881948aaca9e76$var$p(b, a.segmentPrefix);
    $a1881948aaca9e76$var$p(b, c);
    return $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$Lb);
}
function $a1881948aaca9e76$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($a1881948aaca9e76$var$k(392));
        return $a1881948aaca9e76$var$id(a, b, d);
    }
    $a1881948aaca9e76$var$id(a, b, d);
    a = a.responseState;
    $a1881948aaca9e76$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Eb) : (a.sentCompleteSegmentFunction = !0, $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Db));
    $a1881948aaca9e76$var$p(b, a.segmentPrefix);
    f = $a1881948aaca9e76$var$u(f.toString(16));
    $a1881948aaca9e76$var$p(b, f);
    $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Gb);
    $a1881948aaca9e76$var$p(b, a.placeholderPrefix);
    $a1881948aaca9e76$var$p(b, f);
    return $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$Hb);
}
function $a1881948aaca9e76$var$fd(a, b) {
    $a1881948aaca9e76$var$l = new Uint8Array(512);
    $a1881948aaca9e76$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $a1881948aaca9e76$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$a1881948aaca9e76$var$p(b, d[c]);
            c < d.length && $a1881948aaca9e76$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $a1881948aaca9e76$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Nb) : (h.sentClientRenderFunction = !0, $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Mb));
            if (null === m) throw Error($a1881948aaca9e76$var$k(395));
            $a1881948aaca9e76$var$p(d, m);
            $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Ob);
            if (q || r || v) $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Qb), $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$Sb(q || "")));
            if (r || v) $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Qb), $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$Sb(r || "")));
            v && ($a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Qb), $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$Sb(v))));
            if (!$a1881948aaca9e76$var$t(d, $a1881948aaca9e76$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$a1881948aaca9e76$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $a1881948aaca9e76$var$ba(b);
        $a1881948aaca9e76$var$l = new Uint8Array(512);
        $a1881948aaca9e76$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$a1881948aaca9e76$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$a1881948aaca9e76$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $a1881948aaca9e76$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $a1881948aaca9e76$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $a1881948aaca9e76$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $a1881948aaca9e76$var$fd(a, a.destination);
    } catch (d) {
        $a1881948aaca9e76$var$Y(a, d), $a1881948aaca9e76$var$Vc(a, d);
    }
}
$a1881948aaca9e76$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $a1881948aaca9e76$var$Rc(a, $a1881948aaca9e76$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $a1881948aaca9e76$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $a1881948aaca9e76$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $a1881948aaca9e76$var$fd(h, a);
                        } catch (A) {
                            $a1881948aaca9e76$var$Y(h, A), $a1881948aaca9e76$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $a1881948aaca9e76$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $a1881948aaca9e76$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $a1881948aaca9e76$var$Uc(h);
    });
};
$a1881948aaca9e76$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("hMmnm", function(module, exports) {
$parcel$export(module.exports, "eyelashes", function () { return $5234614371b266d4$export$e2a321401c0e05f3; });
$parcel$export(module.exports, "blueShapesSVG", function () { return $5234614371b266d4$export$4b78ca8dd9f1ebf5; });
$parcel$export(module.exports, "orangePurpleShapesSVG", function () { return $5234614371b266d4$export$4f43b91428c248ba; });

var $7VQPk = parcelRequire("7VQPk");
const $5234614371b266d4$export$e2a321401c0e05f3 = (fill = '#669DF1')=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "56",
        height: "84",
        viewBox: "0 0 56 84",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            fill: fill,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M26.4864 16.718C26.5405 16.0726 20.795 9.2477 20.8952 12.0688C20.7985 13.0952 21.2446 13.738 22.1426 13.5149C20.7856 14.6078 23.6044 14.8934 23.5211 15.8699C22.3421 16.2318 25.7092 17.0448 24.3987 17.2763C28.0425 26.1539 47.6897 36.8107 29.9444 20.1653C30.6415 22.4448 29.1343 20.7925 28.8411 19.7567C30.9149 20.2708 27.582 17.178 26.7213 16.7512C27.4235 17.9025 25.3303 16.5509 26.485 16.7235L26.4864 16.718Z"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M22.523 38.9197C21.8369 37.8857 11.9397 37.6356 10.9185 37.475C8.67196 37.5389 9.9636 40.0847 11.6524 39.6395C12.0179 39.6958 14.4962 39.1886 13.8968 40.2052C15.5696 42.0387 19.4456 40.176 20.701 41.8144C21.0254 41.2473 21.9705 41.5362 22.2143 41.2032C22.4626 41.7632 23.3379 41.6469 23.3281 41.4838C26.4577 42.6731 27.0008 38.6273 23.676 38.9433C23.7357 38.7869 22.9182 38.443 22.53 38.9156L22.523 38.9197Z"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M24.6199 74.1834C26.3875 74.443 25.0709 75.1187 24.2095 74.983C24.7947 73.487 22.2597 74.96 21.7776 75.6274C22.0718 75.5279 22.378 75.9607 21.7847 76.2001C21.6576 74.8105 14.1945 77.9237 18.7689 78.8462C18.8925 78.7842 18.5301 77.8072 18.8076 78.0361C19.1938 79.5902 19.9078 78.0574 20.1851 77.7988C20.5068 78.5509 20.5111 77.7138 20.7294 77.9863C20.7735 79.1752 21.9126 76.6327 21.8993 77.836C24.2573 78.5987 26.7045 75.057 28.6049 75.8635C28.7542 73.7751 35.2544 73.8343 31.7599 71.5663C29.1146 71.8979 27.0299 72.3559 24.6199 74.1834Z"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M3.05391 63.3631C3.48696 65.9405 8.33035 63.1301 10.1233 63.45C12.3839 64.0438 32.344 60.5753 25.6944 58.1455C19.6623 59.2462 14.5246 59.0943 7.37953 61.3534C6.19213 61.6357 2.19682 61.8136 3.05391 63.3631Z"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M48.0023 18.2733C50.4643 18.7368 48.974 21.7025 51.0738 22.2533C54.8718 22.7894 48.2743 5.2548 45.4835 7.19426C43.309 9.18589 48.5718 16.5473 48.0023 18.2733Z"
                })
            ]
        })
    });
const $5234614371b266d4$export$4b78ca8dd9f1ebf5 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "389",
        height: "207",
        viewBox: "0 0 389 207",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-250.535 100.922L-184.874 90.4661L-202.753 115.507L-202.021 146.247L-250.535 100.869V100.922ZM-134.949 110.698C-111.006 97.9941 -81.2595 107.09 -68.556 131.086L-5.14313 250.645C7.56036 274.589 -1.53593 304.335 -25.5314 317.038C-49.527 329.742 -79.2207 320.645 -91.9242 296.65L-155.337 177.09C-168.041 153.147 -158.944 123.401 -134.949 110.698Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M278.777 83.8796L287.299 149.802L262.78 131.191L231.989 131.034L278.725 83.8273L278.777 83.8796ZM265.603 199.1C277.575 223.409 267.59 252.842 243.281 264.865L121.892 324.776C97.5826 336.747 68.1501 326.762 56.1262 302.453C44.1023 278.144 54.1398 248.712 78.449 236.688L199.838 176.777C224.147 164.806 253.58 174.791 265.603 199.1Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-43.4141 -263.297L20.5739 -245.209L-6.14012 -229.996L-18.3731 -201.766L-43.3619 -263.297H-43.4141ZM57.3252 -205.844C84.4051 -207.308 107.512 -186.554 109.028 -159.474L116.347 -24.3354C117.811 2.74448 97.0564 25.8513 69.9765 27.3673C42.8966 28.8834 19.7897 8.07681 18.2737 -19.0031L10.9548 -154.141C9.49105 -181.221 30.2453 -204.328 57.3252 -205.844Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-300.983 -20.1016L-252.835 -65.9492L-253.358 -35.1576L-235.322 -10.2211L-301.035 -20.0493L-300.983 -20.1016ZM-200.244 -77.5549C-187.697 -101.603 -158.055 -110.96 -134.008 -98.4137L-13.9778 -35.8895C10.07 -23.3428 19.4278 6.29868 6.88113 30.3465C-5.66556 54.3943 -35.3071 63.752 -59.3549 51.2054L-179.385 -11.3189C-203.433 -23.8656 -212.79 -53.5071 -200.244 -77.5549Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M265.653 -107.927L270.881 -41.6388L247.303 -61.4521L216.564 -63.1773L265.653 -107.979V-107.927ZM246.676 6.50901C257.445 31.3932 245.996 60.3029 221.112 71.0721L96.9002 124.814C72.0159 135.583 43.1063 124.134 32.337 99.2499C21.5678 74.3656 33.0166 45.456 57.9008 34.6868L182.113 -19.0548C206.997 -29.8241 235.907 -18.3752 246.676 6.50901Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.7984 -116.866L34.6887 -50.7343L15.189 -74.5207L-14.7139 -81.8919L41.7984 -116.813V-116.866ZM2.01508 -7.91878C7.97473 18.5338 -8.59747 44.8295 -35.05 50.7892L-167.051 80.6398C-193.504 86.5995 -219.8 70.0274 -225.759 43.5748C-231.719 17.1222 -215.147 -9.17347 -188.694 -15.1331L-56.693 -44.9837C-30.2404 -50.9434 -3.9446 -34.3714 2.01508 -7.91878Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M242.811 189.743L188.389 151.528L218.658 145.986L239.569 123.402L242.811 189.743ZM166.694 102.23C140.66 94.6493 125.656 67.4126 133.236 41.3782L170.981 -88.5844C178.561 -114.619 205.798 -129.622 231.832 -122.042C257.867 -114.462 272.87 -87.2252 265.29 -61.1908L227.545 68.7718C219.965 94.8062 192.728 109.81 166.694 102.23Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.2233 -162.139L118.182 -113.155L87.4429 -114.2L62.1926 -96.5829L73.2233 -162.087V-162.139ZM128.847 -60.4066C152.686 -47.4417 161.468 -17.6434 148.503 6.19533L83.8357 125.075C70.8708 148.914 41.0724 157.696 17.2337 144.732C-6.60499 131.767 -15.3876 101.968 -2.42266 78.1296L62.245 -40.7501C75.2099 -64.5888 105.008 -73.3715 128.847 -60.4066Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-236.893 152.47L-180.589 117.078L-187.176 147.138L-174.421 175.159L-236.84 152.47H-236.893ZM-126.743 116.137C-109.701 95.069 -78.8045 91.7755 -57.6842 108.818L47.551 193.874C68.619 210.917 71.9124 241.813 54.8699 262.933C37.8273 284.053 6.93117 287.295 -14.1891 270.252L-119.424 185.196C-140.492 168.153 -143.786 137.257 -126.743 116.137Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-30.8142 -253.625L6.93022 -198.89L-23.3908 -204.222L-50.8367 -190.316L-30.8142 -253.677V-253.625ZM10.1192 -145.096C31.9191 -128.942 36.4673 -98.2026 20.3135 -76.4028L-60.299 32.3351C-76.4528 54.1349 -107.192 58.6831 -128.992 42.5292C-150.792 26.3754 -155.34 -4.36395 -139.186 -26.1638L-58.5739 -134.902C-42.42 -156.701 -11.6806 -161.25 10.1192 -145.096Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.1666 181.013L111.126 229.997L80.3862 228.952L55.1359 246.569L66.1666 181.065V181.013ZM121.79 282.798C145.629 295.763 154.412 325.561 141.447 349.4L76.779 468.28C63.8141 492.118 34.0158 500.901 10.1772 487.936C-13.6615 474.971 -22.4442 445.173 -9.47934 421.334L55.1883 302.454C68.1532 278.616 97.9515 269.833 121.79 282.798Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M320.289 163.447L353.643 220.953L323.844 213.268L295.405 225.03L320.289 163.447ZM352.702 274.799C373.142 292.573 375.338 323.574 357.563 344.067L268.743 446.218C250.969 466.658 219.968 468.854 199.475 451.08C179.035 433.305 176.839 402.304 194.614 381.811L283.434 279.661C301.208 259.22 332.209 257.024 352.702 274.799Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-185.816 166.688L-169.349 102.282L-153.456 128.63L-124.913 140.183L-185.816 166.74V166.688ZM-130.925 64.485C-133.068 37.4574 -112.941 13.7756 -85.9134 11.6323L49.0156 0.862955C76.0432 -1.28043 99.725 18.8465 101.868 45.8742C104.012 72.9018 83.8849 96.5836 56.8573 98.727L-78.0718 109.496C-105.099 111.64 -128.781 91.5127 -130.925 64.485Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-193.342 43.1568L-130.87 20.4159L-143.626 48.4369L-137.038 78.4966L-193.342 43.2091V43.1568ZM-78.017 30.7669C-56.8967 13.7244 -26.0004 17.0179 -8.95786 38.1381L76.0458 143.426C93.0883 164.546 89.795 195.442 68.6747 212.485C47.5545 229.527 16.6582 226.234 -0.384369 205.113L-85.388 99.826C-102.431 78.7057 -99.1372 47.8095 -78.017 30.7669Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-144.988 23.4496L-78.4909 22.5086L-99.7678 44.7267L-103.48 75.257L-144.988 23.3974V23.4496ZM-32.0158 49.7976C-6.50427 40.649 21.6212 53.9799 30.7699 79.4915L76.3561 206.945C85.5047 232.456 72.1738 260.582 46.6622 269.73C21.1506 278.879 -6.97473 265.548 -16.1234 240.037L-61.7096 112.583C-70.8582 87.0718 -57.5274 58.9463 -32.0158 49.7976Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-30.2357 244.846L-47.3828 180.596L-20.6166 195.809L9.91363 191.888L-30.1834 244.846H-30.2357ZM-32.3791 128.893C-47.4874 106.362 -41.4754 75.8838 -18.9437 60.7755L93.4536 -14.6091C115.985 -29.7174 146.463 -23.7055 161.572 -1.17375C176.68 21.358 170.668 51.836 148.136 66.9442L35.7389 142.329C13.2071 157.437 -17.2708 151.425 -32.3791 128.893Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M257.45 -217.185L302.409 -168.201L271.669 -169.246L246.419 -151.629L257.45 -217.133V-217.185ZM313.074 -115.4C336.912 -102.435 345.695 -72.6371 332.73 -48.7984L268.062 70.0814C255.097 93.9201 225.299 102.703 201.46 89.7378C177.622 76.7729 168.839 46.9746 181.804 23.1359L246.471 -95.7438C259.436 -119.583 289.235 -128.365 313.074 -115.4Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M122.314 73.3206L97.8999 135.165L85.4578 107.04L58.5869 91.9838L122.314 73.3206ZM55.032 167.787C53.7774 194.867 30.7751 215.778 3.69519 214.523L-131.495 208.197C-158.575 206.943 -179.486 183.94 -178.232 156.861C-176.977 129.781 -153.975 108.87 -126.895 110.124L8.29567 116.45C35.3756 117.704 56.2867 140.707 55.032 167.787Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M14.8776 151.684L-15.8095 210.653L-25.2718 181.378L-50.4174 163.656L14.9299 151.684H14.8776ZM-61.8662 238.674C-65.9439 265.493 -90.9327 283.947 -117.751 279.869L-251.582 259.585C-278.401 255.508 -296.855 230.519 -292.777 203.7C-288.7 176.882 -263.711 158.428 -236.892 162.505L-103.061 182.789C-76.2426 186.867 -57.7885 211.856 -61.8662 238.674Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.3516 381.288L26.3247 373.551L50.3202 354.26L57.9527 324.462L92.4038 381.288H92.3516ZM-16.2295 340.564C-42.7343 346.314 -68.8732 329.481 -74.6237 302.976L-103.272 170.713C-109.023 144.208 -92.1891 118.069 -65.6843 112.319C-39.1794 106.568 -13.0404 123.402 -7.28987 149.906L21.3583 282.169C27.1088 308.674 10.2754 334.813 -16.2295 340.564Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-193.711 76.5084L-144.204 32.0723L-145.615 62.8117L-128.312 88.2709L-193.711 76.5084ZM-91.2987 22.0349C-78.0724 -1.6469 -48.1695 -10.1159 -24.4877 3.11041L93.6602 69.1373C117.342 82.3636 125.811 112.266 112.585 135.948C99.3584 159.63 69.4555 168.099 45.7737 154.873L-72.3742 88.846C-96.056 75.6197 -104.525 45.7168 -91.2987 22.0349Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M101.921 58.525L140.45 4.36524L145.783 34.6864L168.262 55.7021L101.869 58.5774L101.921 58.525ZM189.853 -17.0686C197.59 -43.0507 224.879 -57.8976 250.913 -50.1605L380.667 -11.6318C406.649 -3.89465 421.496 23.3944 413.759 49.4288C406.021 75.4631 378.732 90.2577 352.698 82.5206L222.945 43.9918C196.963 36.2547 182.116 8.96573 189.853 -17.0686Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M568.915 177.667L566.667 244.112L545.495 221.79L515.174 216.667L568.915 177.667ZM537.34 289.228C545.234 315.158 530.648 342.604 504.718 350.498L375.278 390.02C349.349 397.914 321.903 383.328 314.009 357.398C306.115 331.469 320.7 304.023 346.63 296.129L476.07 256.607C502 248.713 529.446 263.298 537.34 289.228Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M311.086 -1.43771L359.233 -47.2854L358.711 -16.4937L376.746 8.4428L311.033 -1.38545L311.086 -1.43771ZM411.825 -58.9433C424.371 -82.9911 454.013 -92.3488 478.061 -79.8022L598.091 -17.2779C622.138 -4.73127 631.496 24.9103 618.949 48.9581C606.403 73.0059 576.761 82.3636 552.714 69.8169L432.684 7.29269C408.636 -5.25399 399.278 -34.8955 411.825 -58.9433Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M83.4648 2.01385L145.937 -20.7269L133.181 7.29396L139.768 37.3537L83.4648 2.06618V2.01385ZM198.79 -10.3237C219.91 -27.3663 250.806 -24.0728 267.849 -2.95252L352.852 102.335C369.895 123.455 366.601 154.351 345.481 171.394C324.361 188.437 293.465 185.143 276.422 164.023L191.418 58.7353C174.376 37.6151 177.669 6.71885 198.79 -10.3237Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-74.0977 -102.647L-16.7489 -136.262L-24.2768 -106.411L-12.4097 -78.0242L-74.0977 -102.647ZM37.0973 -135.53C54.7672 -156.075 85.7679 -158.375 106.313 -140.705L208.882 -52.408C229.427 -34.7381 231.728 -3.7374 214.058 16.8078C196.388 37.353 165.387 39.6532 144.842 21.9833L42.2728 -66.3139C21.7276 -83.9838 19.4274 -114.985 37.0973 -135.53Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M84.3086 -50.0568L150.806 -50.9978L129.529 -28.7797L125.817 1.75049L84.3086 -50.1091V-50.0568ZM197.229 -23.761C222.74 -32.9096 250.866 -19.5788 260.014 5.93273L305.601 133.386C314.749 158.898 301.418 187.023 275.907 196.172C250.395 205.32 222.27 191.989 213.121 166.478L167.535 39.0246C158.386 13.513 171.717 -14.6124 197.229 -23.761Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M90.9928 289.122L73.8457 224.872L100.612 240.085L131.142 236.164L91.0452 289.122H90.9928ZM88.8494 173.169C73.7411 150.638 79.7531 120.16 102.285 105.051L214.682 29.6668C237.214 14.5585 267.692 20.5705 282.8 43.1022C297.908 65.6339 291.896 96.1119 269.365 111.22L156.967 186.605C134.436 201.713 103.958 195.701 88.8494 173.169Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M74.5253 426.615L14.1966 398.647L43.0018 387.825L59.5737 361.895L74.5253 426.615ZM-15.9154 354.001C-42.8908 351.178 -62.4426 327.026 -59.6196 300.05L-45.5569 165.435C-42.7339 138.46 -18.5815 118.908 8.39387 121.731C35.3692 124.554 54.921 148.706 52.098 175.682L38.0353 310.297C35.2123 337.272 11.0599 356.824 -15.9154 354.001Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M209.14 -27.5756L257.288 -73.4232L256.765 -42.6316L274.801 -17.6951L209.088 -27.5233L209.14 -27.5756ZM309.88 -85.0289C322.426 -109.077 352.068 -118.434 376.116 -105.888L496.145 -43.3635C520.193 -30.8168 529.551 -1.17531 517.004 22.8725C504.457 46.9203 474.816 56.278 450.768 43.7314L330.738 -18.7929C306.691 -31.3396 297.333 -60.9811 309.88 -85.0289Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M178.717 154.926L241.189 132.185L228.433 160.206L235.02 190.266L178.717 154.978V154.926ZM294.042 142.536C315.162 125.494 346.058 128.787 363.101 149.908L448.104 255.195C465.147 276.315 461.853 307.211 440.733 324.254C419.613 341.297 388.717 338.003 371.674 316.883L286.67 211.595C269.628 190.475 272.921 159.579 294.042 142.536Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-15.7559 256.396L41.5929 222.781L34.0649 252.632L45.932 281.019L-15.7559 256.396ZM95.4391 223.513C113.109 202.968 144.11 200.668 164.655 218.337L267.224 306.635C287.769 324.305 290.069 355.305 272.4 375.851C254.73 396.396 223.729 398.696 203.184 381.026L100.615 292.729C80.0694 275.059 77.7692 244.058 95.4391 223.513Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.582 133.701L257.079 132.76L235.802 154.978L232.091 185.509L190.582 133.649V133.701ZM303.554 159.997C329.066 150.849 357.191 164.179 366.34 189.691L411.926 317.144C421.075 342.656 407.744 370.781 382.233 379.93C356.721 389.078 328.596 375.748 319.447 350.236L273.861 222.783C264.712 197.271 278.043 169.146 303.554 159.997Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M286.565 454.688L269.418 390.438L296.184 405.651L326.714 401.73L286.617 454.688H286.565ZM284.422 338.736C269.313 316.204 275.325 285.726 297.857 270.617L410.254 195.233C432.786 180.125 463.264 186.137 478.372 208.668C493.481 231.2 487.469 261.678 464.937 276.786L352.54 352.171C330.008 367.279 299.53 361.267 284.422 338.736Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-68.3457 -194.602L-8.64436 -165.327L-37.6586 -155.133L-54.7534 -129.569L-68.2934 -194.602H-68.3457ZM20.4744 -120.002C47.3975 -116.604 66.4265 -92.0334 62.9762 -65.1103L45.9337 69.1392C42.5356 96.0622 17.9651 115.091 -8.95802 111.641C-35.8811 108.191 -54.9102 83.6723 -51.4599 56.7493L-34.4173 -77.5001C-31.0192 -104.423 -6.44865 -123.452 20.4744 -120.002Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.668 -13.7203L96.0676 -25.8488L78.8158 -0.337156L80.3319 30.4022L30.668 -13.7203ZM146.463 -6.81963C170.093 -20.1505 200.048 -11.7337 213.327 11.8436L279.72 129.782C293.05 153.412 284.634 183.367 261.056 196.646C237.479 209.924 207.472 201.56 194.193 177.983L127.8 60.0437C114.469 36.4142 122.886 6.45893 146.463 -6.81963Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-17.2201 111.587L-68.6091 69.399L-38.0265 66.1578L-15.4948 45.1945L-17.2201 111.587ZM-86.5927 18.6373C-112 9.17503 -124.912 -19.1073 -115.398 -44.5143L-68.0863 -171.288C-58.624 -196.695 -30.3418 -209.608 -4.93475 -200.093C20.4723 -190.578 33.3849 -162.349 23.8704 -136.942L-23.4411 -10.1678C-32.9034 15.2392 -61.1856 28.1519 -86.5927 18.6373Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M485.852 106.204L459.661 167.317L448.003 138.825L421.603 123.037L485.852 106.204ZM415.957 198.735C413.918 225.763 390.341 246.047 363.313 244.008L228.332 233.866C201.304 231.827 181.02 208.25 183.059 181.223C185.098 154.195 208.675 133.911 235.703 135.95L370.684 146.092C397.712 148.131 417.996 171.708 415.957 198.735Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M387.405 35.5757L370.258 -28.6737L397.024 -13.4608L427.554 -17.3817L387.457 35.5757H387.405ZM385.262 -80.4287C370.153 -102.96 376.165 -133.438 398.697 -148.547L511.094 -223.931C533.626 -239.04 564.104 -233.028 579.212 -210.496C594.321 -187.964 588.309 -157.486 565.777 -142.378L453.38 -66.9933C430.848 -51.8851 400.37 -57.897 385.262 -80.4287Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M205.268 -146.978L204.066 -80.4811L182.528 -102.438L152.102 -107.09L205.268 -146.926V-146.978ZM175.418 -34.8948C183.73 -9.06956 169.563 18.5854 143.737 26.8976L14.9249 68.4061C-10.9003 76.7183 -38.5553 62.551 -46.8675 36.7258C-55.1797 10.9005 -41.0124 -16.7544 -15.1872 -25.0666L113.625 -66.5751C139.451 -74.8873 167.106 -60.72 175.418 -34.8948Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M252.528 13.3573L186.031 12.4686L207.883 -9.17445L212.379 -39.6001L252.476 13.3573H252.528ZM140.288 -15.9706C114.515 -7.55386 86.8074 -21.5643 78.3384 -47.3373L36.2025 -175.941C27.7858 -201.714 41.7962 -229.421 67.5692 -237.89C93.3422 -246.359 121.049 -232.296 129.518 -206.523L171.654 -77.9197C180.071 -52.1468 166.061 -24.4396 140.288 -15.9706Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M158.479 177.248L150.062 243.223L131.033 219.018L101.287 211.072L158.427 177.196L158.479 177.248ZM116.605 285.464C122.094 312.021 104.999 338.003 78.442 343.44L-54.1346 370.729C-80.6917 376.218 -106.674 359.123 -112.111 332.566C-117.548 306.009 -100.505 280.027 -73.9478 274.59L58.6287 247.301C85.1858 241.812 111.168 258.907 116.605 285.464Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M262.355 103.119L321.848 73.4249L312.333 102.7L322.266 131.819L262.355 103.171V103.119ZM375.537 77.7117C394.566 58.3689 425.671 58.1598 444.962 77.1889L541.362 172.178C560.705 191.207 560.914 222.312 541.885 241.603C522.856 260.893 491.751 261.155 472.46 242.125L376.06 147.137C356.717 128.107 356.508 97.0022 375.537 77.7117Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M233.762 99.6157L296.234 76.8749L283.478 104.896L290.065 134.956L233.762 99.668V99.6157ZM349.087 87.2258C370.207 70.1833 401.103 73.4768 418.145 94.597L503.149 199.884C520.192 221.005 516.898 251.901 495.778 268.944C474.658 285.986 443.762 282.693 426.719 261.572L341.715 156.285C324.673 135.165 327.966 104.268 349.087 87.2258Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M46.084 216.354L103.433 182.739L95.9047 212.59L107.772 240.976L46.084 216.354ZM157.331 183.471C175.001 162.926 206.002 160.625 226.547 178.295L329.116 266.592C349.661 284.262 351.961 315.263 334.292 335.808C316.622 356.353 285.621 358.654 265.076 340.984L162.507 252.687C141.961 235.017 139.661 204.016 157.331 183.471Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.5613 243.903L-36.5701 237.055L-12.8361 217.45L-5.62175 187.548L29.5613 243.903ZM-79.5948 204.59C-105.995 210.707 -132.395 194.187 -138.46 167.787L-168.885 35.8896C-175.002 9.48935 -158.482 -16.911 -132.082 -22.9752C-105.681 -29.0917 -79.2812 -12.5719 -73.2169 13.8284L-42.7912 145.725C-36.6747 172.126 -53.1945 198.526 -79.5948 204.59Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M247.721 79.9076L314.218 78.9666L292.941 101.185L289.229 131.715L247.721 79.8553V79.9076ZM360.693 106.203C386.205 97.0547 414.33 110.386 423.479 135.897L469.065 263.35C478.214 288.862 464.883 316.988 439.371 326.136C413.859 335.285 385.734 321.954 376.585 296.442L330.999 168.989C321.851 143.477 335.181 115.352 360.693 106.203Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M348.774 395.718L331.627 331.468L358.393 346.681L388.923 342.76L348.826 395.718H348.774ZM346.631 279.713C331.522 257.181 337.534 226.703 360.066 211.595L472.463 136.211C494.995 121.102 525.473 127.114 540.581 149.646C555.69 172.178 549.678 202.656 527.146 217.764L414.749 293.149C392.217 308.257 361.739 302.245 346.631 279.713Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-75.3027 194.709L-10.0078 207.256L-35.3626 224.717L-45.1385 253.888L-75.3027 194.709ZM30.037 243.275C56.9078 239.511 81.7399 258.175 85.5039 285.045L104.376 419.086C108.14 445.957 89.4769 470.788 62.6062 474.552C35.7354 478.316 10.9033 459.653 7.13931 432.783L-11.7329 298.742C-15.4969 271.871 3.16622 247.039 30.037 243.275Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-221.785 199.153L-234.07 133.805L-208.559 150.953L-177.819 149.384L-221.837 199.153H-221.785ZM-215.198 83.4097C-228.581 59.8324 -220.269 29.8772 -196.692 16.4941L-78.9098 -50.2124C-55.3325 -63.5955 -25.3774 -55.2834 -11.9943 -31.7061C1.38885 -8.1288 -6.9232 21.8264 -30.5005 35.2095L-148.282 101.916C-171.86 115.299 -201.815 106.987 -215.198 83.4097Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M316.466 -78.5991L297.646 -14.8202L282.695 -41.7432L254.622 -54.2899L316.466 -78.5991ZM257.863 21.4606C259.013 48.5405 237.997 71.4382 210.917 72.5883L75.6747 78.3911C48.5948 79.5413 25.6971 58.5256 24.547 31.4457C23.3969 4.36578 44.4125 -18.5319 71.4924 -19.682L206.735 -25.4848C233.815 -26.635 256.713 -5.61929 257.863 21.4606Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.8262 -212.17L140.814 -194.082L114.1 -178.869L101.867 -150.639L76.8783 -212.17H76.8262ZM177.618 -154.716C204.698 -156.18 227.804 -135.426 229.32 -108.346L236.639 26.7922C238.103 53.8721 217.349 76.9789 190.269 78.4949C163.189 80.011 140.082 59.2044 138.566 32.1245L131.247 -103.014C129.784 -130.094 150.538 -153.2 177.618 -154.716Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M181.38 -0.548485L229.528 -46.3961L229.005 -15.6045L247.041 9.33202L181.328 -0.496231L181.38 -0.548485ZM282.172 -58.0541C294.719 -82.1019 324.36 -91.4596 348.408 -78.9129L468.438 -16.3886C492.486 -3.84197 501.843 25.7995 489.297 49.8473C476.75 73.8951 447.108 83.2528 423.061 70.7061L303.031 8.18191C278.983 -4.36477 269.625 -34.0063 282.172 -58.0541Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M136.887 203.072L196.588 232.348L167.574 242.542L150.479 268.106L136.939 203.072H136.887ZM225.707 277.621C252.63 281.019 271.659 305.589 268.209 332.512L251.166 466.762C247.768 493.685 223.197 512.714 196.274 509.264C169.351 505.813 150.322 481.295 153.773 454.372L170.815 320.122C174.213 293.199 198.784 274.17 225.707 277.621Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M230.521 140.443L295.921 128.315L278.669 153.826L280.185 184.566L230.521 140.443ZM346.317 147.292C369.946 133.961 399.902 142.378 413.18 165.955L479.573 283.894C492.904 307.523 484.487 337.479 460.91 350.757C437.333 364.036 407.325 355.671 394.046 332.094L327.654 214.155C314.323 190.526 322.74 160.57 346.317 147.292Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M106.466 191.154L74.3673 132.917L104.009 141.229L132.709 130.093L106.466 191.154ZM76.5107 79.0703C56.4361 60.8254 54.9199 29.7723 73.1649 9.69766L164.181 -90.5189C182.426 -110.594 213.478 -112.11 233.553 -93.8647C253.628 -75.6197 255.144 -44.5667 236.899 -24.492L145.883 75.7246C127.638 95.7993 96.5854 97.3153 76.5107 79.0703Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M677.133 166.531L618.686 198.212L627.208 168.623L616.282 139.87L677.133 166.531ZM564.84 195.65C546.491 215.568 515.385 216.875 495.467 198.473L395.93 106.778C376.013 88.4284 374.706 57.3231 393.108 37.4052C411.509 17.4874 442.562 16.1804 462.48 34.5822L562.017 126.277C581.935 144.627 583.242 175.732 564.84 195.65Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.4082 1.85736L41.0154 -64.5354L61.7697 -41.7946L91.9863 -36.0441L37.4605 1.85736H37.4082ZM71.2843 -109.076C63.9131 -135.163 79.0736 -162.295 105.16 -169.666L235.384 -206.522C261.471 -213.893 288.603 -198.733 295.974 -172.646C303.345 -146.559 288.185 -119.427 262.098 -112.056L131.874 -75.2001C105.788 -67.8289 78.6555 -82.9895 71.2843 -109.076Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.957 -180.436L120.429 -203.177L107.673 -175.156L114.26 -145.096L57.957 -180.384V-180.436ZM173.23 -192.826C194.35 -209.868 225.246 -206.575 242.289 -185.455L327.292 -80.1672C344.335 -59.047 341.041 -28.1507 319.921 -11.1082C298.801 5.9344 267.905 2.64088 250.862 -18.4794L165.859 -123.767C148.816 -144.887 152.109 -175.783 173.23 -192.826Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.5957 46.1868L105.944 12.5722L98.4164 42.4229L110.284 70.8097L48.5957 46.1868ZM159.791 13.3041C177.461 -7.24108 208.461 -9.54133 229.006 8.12857L331.576 96.4258C352.121 114.096 354.421 145.096 336.751 165.642C319.081 186.187 288.08 188.487 267.535 170.817L164.966 82.5199C144.421 64.85 142.121 33.8493 159.791 13.3041Z",
                fill: "#4D8CED"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M61.7767 404.656L-4.35474 397.808L19.3793 378.204L26.5936 348.301L61.7767 404.656ZM-47.3271 365.396C-73.7274 371.512 -100.128 354.993 -106.192 328.592L-136.618 196.695C-142.734 170.295 -126.214 143.895 -99.8141 137.831C-73.4138 131.766 -47.0134 148.234 -40.9492 174.634L-10.5236 306.531C-4.40714 332.931 -20.9268 359.332 -47.3271 365.396Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M104.693 -199.1L171.191 -200.041L149.914 -177.823L146.202 -147.293L104.693 -199.153V-199.1ZM217.666 -172.805C243.177 -181.953 271.303 -168.622 280.451 -143.111L326.038 -15.6574C335.186 9.85416 321.855 37.9796 296.344 47.1282C270.832 56.2768 242.707 42.9459 233.558 17.4344L187.972 -110.019C178.823 -135.53 192.154 -163.656 217.666 -172.805Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M221.485 26.95L204.338 -37.2995L231.104 -22.0867L261.634 -26.0075L221.537 26.95H221.485ZM219.342 -89.0022C204.233 -111.534 210.245 -142.012 232.777 -157.12L345.174 -232.505C367.706 -247.613 398.184 -241.601 413.292 -219.069C428.401 -196.538 422.389 -166.06 399.857 -150.951L287.46 -75.5669C264.928 -60.4586 234.45 -66.4705 219.342 -89.0022Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M139.775 211.805L201.15 186.241L189.648 214.785L197.595 244.531L139.775 211.805ZM254.421 194.187C274.705 176.204 305.757 178.086 323.741 198.422L413.45 299.789C431.433 320.072 429.551 351.125 409.215 369.109C388.879 387.093 357.878 385.211 339.895 364.874L250.186 263.508C232.203 243.224 234.085 212.171 254.421 194.187Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M326.983 140.028L311.979 204.8L295.512 178.818L266.759 167.945L327.035 140.028H326.983ZM274.392 243.434C277.162 270.409 257.506 294.509 230.531 297.28L95.9152 311.029C68.9399 313.8 44.8397 294.143 42.069 267.168C39.2983 240.193 58.9548 216.092 85.9301 213.322L220.546 199.573C247.521 196.802 271.621 216.458 274.392 243.434Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M217.458 -18.8969L167.794 25.3302L169.362 -5.40919L152.163 -30.9208L217.51 -18.8969H217.458ZM114.837 35.1584C101.506 58.788 71.5505 67.1002 47.9732 53.7693L-69.9132 -12.7281C-93.5428 -26.0589 -101.855 -56.0141 -88.5241 -79.5914C-75.1932 -103.221 -45.238 -111.533 -21.6607 -98.2023L96.2257 -31.7049C119.855 -18.3741 128.167 11.5812 114.837 35.1584Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M97.4268 178.398L74.9473 115.822L102.864 128.735L132.976 122.304L97.4268 178.451V178.398ZM85.5596 63.0213C68.6216 41.8488 72.072 10.9527 93.2445 -5.98534L198.95 -90.5185C220.123 -107.457 251.019 -104.006 267.957 -82.8337C284.895 -61.6612 281.445 -30.765 260.272 -13.827L154.566 70.7062C133.394 87.6442 102.498 84.1938 85.5596 63.0213Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M345.591 261.625L377.847 203.492L386.525 233.03L411.2 251.431L345.539 261.678L345.591 261.625ZM424.635 176.674C429.393 149.96 454.904 132.238 481.618 136.995L614.822 160.834C641.536 165.591 659.258 191.103 654.501 217.817C649.744 244.531 624.232 262.253 597.518 257.495L464.314 233.657C437.6 228.9 419.878 203.388 424.635 176.674Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M319.19 269.677L261.527 236.585L291.169 228.325L309.937 203.912L319.242 269.677H319.19ZM235.441 189.483C208.831 184.307 191.423 158.587 196.598 131.925L222.319 -0.96516C227.494 -27.5746 253.215 -44.9831 279.877 -39.8076C306.538 -34.6321 323.895 -8.91137 318.719 17.7503L292.998 150.64C287.823 177.25 262.102 194.658 235.441 189.483Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M226.977 -282.64L290.965 -264.551L264.251 -249.339L252.018 -221.109L227.029 -282.64H226.977ZM327.716 -225.186C354.796 -226.65 377.902 -205.896 379.419 -178.816L386.738 -43.6776C388.201 -16.5977 367.447 6.50909 340.367 8.02515C313.287 9.5412 290.18 -11.2654 288.664 -38.3453L281.345 -173.483C279.882 -200.563 300.636 -223.67 327.716 -225.186Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-224.549 -33.6411L-176.401 -79.4888L-176.924 -48.6972L-158.888 -23.7606L-224.602 -33.5889L-224.549 -33.6411ZM-123.81 -91.1467C-111.263 -115.195 -81.6218 -124.552 -57.5741 -112.006L62.4559 -49.4813C86.5037 -36.9346 95.8614 -7.29312 83.3147 16.7547C70.768 40.8025 41.1265 50.1601 17.0787 37.6135L-102.951 -24.9107C-126.999 -37.4574 -136.357 -67.0989 -123.81 -91.1467Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M359.605 310.087L293.578 302.35L317.574 283.059L325.206 253.261L359.657 310.087H359.605ZM250.972 269.363C224.467 275.113 198.328 258.28 192.577 231.775L163.929 99.5121C158.179 73.0072 175.012 46.8683 201.517 41.1178C228.022 35.3672 254.161 52.2006 259.911 78.7054L288.559 210.968C294.31 237.473 277.477 263.612 250.972 269.363Z",
                fill: "#4D8CED"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M169.623 133.963L236.12 133.022L214.843 155.24L211.132 185.77L169.623 133.911V133.963ZM282.595 160.259C308.107 151.11 336.232 164.441 345.381 189.953L390.967 317.406C400.116 342.918 386.785 371.043 361.274 380.192C335.762 389.34 307.636 376.009 298.488 350.498L252.902 223.045C243.753 197.533 257.084 169.407 282.595 160.259Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-113.878 26.3229L-131.025 -37.9266L-104.259 -22.7137L-73.7289 -26.6346L-113.826 26.3229H-113.878ZM-116.022 -89.6294C-131.13 -112.161 -125.118 -142.639 -102.586 -157.747L9.81107 -233.132C32.3428 -248.24 62.8208 -242.228 77.929 -219.697C93.0373 -197.165 87.0254 -166.687 64.4936 -151.579L-47.9037 -76.1939C-70.4354 -61.0856 -100.913 -67.0976 -116.022 -89.6294Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M410.203 333.403L370.942 279.766L401.368 284.21L428.396 269.52L410.203 333.403ZM366.185 226.077C343.967 210.551 338.478 179.968 354.005 157.698L431.428 46.712C446.954 24.4939 477.537 19.0047 499.807 34.5312C522.078 50.0577 527.515 80.6403 511.988 102.911L434.565 213.896C419.038 236.115 388.456 241.604 366.185 226.077Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M328.909 136.159L327.707 202.656L306.168 180.699L275.742 176.047L328.909 136.211V136.159ZM299.058 248.242C307.37 274.067 293.203 301.722 267.378 310.035L138.566 351.543C112.74 359.855 85.0853 345.688 76.7731 319.863C68.4609 294.038 82.6282 266.383 108.453 258.07L237.266 216.562C263.091 208.25 290.746 222.417 299.058 248.242Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.3668 -3.21293L107.515 -49.0605L106.992 -18.2689L125.028 6.66757L59.3145 -3.16061L59.3668 -3.21293ZM160.106 -60.6662C172.653 -84.714 202.294 -94.0717 226.342 -81.5251L346.372 -19.0008C370.42 -6.45409 379.777 23.1874 367.231 47.2352C354.684 71.283 325.042 80.6407 300.995 68.094L180.965 5.56979C156.917 -6.97689 147.559 -36.6184 160.106 -60.6662Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-269.668 74.7848L-207.196 52.044L-219.952 80.0649L-213.365 110.125L-269.668 74.8371V74.7848ZM-154.395 62.395C-133.275 45.3524 -102.379 48.6459 -85.3365 69.7662L-0.332703 175.054C16.7099 196.174 13.4164 227.07 -7.70389 244.113C-28.8241 261.155 -59.7203 257.862 -76.7628 236.742L-161.767 131.454C-178.809 110.334 -175.516 79.4375 -154.395 62.395Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M232.454 129.886L215.307 65.6363L242.073 80.8492L272.603 76.9283L232.506 129.886H232.454ZM230.31 13.9335C215.202 -8.59819 221.214 -39.0761 243.746 -54.1844L356.143 -129.569C378.675 -144.677 409.153 -138.665 424.261 -116.134C439.369 -93.6019 433.357 -63.1239 410.826 -48.0156L298.428 27.369C275.897 42.4773 245.419 36.4653 230.31 13.9335Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M311.505 494.263L268.428 443.658L299.115 445.854L324.993 429.229L311.505 494.263ZM259.75 390.491C236.434 376.638 228.749 346.526 242.603 323.21L311.714 206.839C325.568 183.523 355.68 175.839 378.996 189.692C402.311 203.546 409.996 233.658 396.143 256.974L327.031 373.344C313.178 396.66 283.066 404.345 259.75 390.491Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M137.059 217.607L199.531 194.866L186.775 222.887L193.362 252.946L137.059 217.659V217.607ZM252.383 205.269C273.504 188.226 304.4 191.52 321.442 212.64L406.446 317.928C423.489 339.048 420.195 369.944 399.075 386.987C377.955 404.029 347.059 400.736 330.016 379.615L245.012 274.328C227.97 253.208 231.263 222.311 252.383 205.269Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M440.786 -295.289L485.745 -246.305L455.005 -247.35L429.755 -229.733L440.786 -295.237V-295.289ZM496.409 -193.504C520.248 -180.539 529.031 -150.741 516.066 -126.902L451.398 -8.02261C438.433 15.8161 408.635 24.5988 384.796 11.6339C360.958 -1.33099 352.175 -31.1294 365.14 -54.9681L429.807 -173.848C442.772 -197.687 472.571 -206.469 496.409 -193.504Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-101.131 270.093L-52.6171 224.611L-53.349 255.351L-35.4699 280.392L-101.079 270.041L-101.131 270.093ZM0.0789108 213.424C12.7824 189.481 42.5286 180.384 66.4718 193.088L186.031 256.553C209.974 269.257 219.071 299.003 206.367 322.946C193.664 346.889 163.918 355.986 139.974 343.282L20.4151 279.817C-3.52818 267.113 -12.6246 237.367 0.0789108 213.424Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M324.729 150.325L307.582 86.0759L334.348 101.289L364.878 97.3679L324.781 150.325H324.729ZM322.586 34.3209C307.477 11.7891 313.489 -18.6888 336.021 -33.7971L448.418 -109.182C470.95 -124.29 501.428 -118.278 516.536 -95.7464C531.645 -73.2146 525.633 -42.7367 503.101 -27.6284L390.704 47.7562C368.172 62.8645 337.694 56.8526 322.586 34.3209Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M163.644 -42.6136L144.824 21.1653L129.873 -5.75779L101.799 -18.3044L163.644 -42.6136ZM105.041 57.4984C106.191 84.5783 85.1752 107.476 58.0953 108.626L-77.1476 114.429C-104.227 115.579 -127.125 94.5634 -128.275 67.4835C-129.425 40.4036 -108.41 17.5059 -81.3297 16.3558L53.9129 10.5529C80.9929 9.40275 103.891 30.4185 105.041 57.4984Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.538 70.9435L213.368 128.763L183.622 120.817L155.078 132.318L180.485 70.9435H180.538ZM211.904 182.609C232.188 200.593 234.122 231.593 216.139 251.929L126.43 353.296C108.447 373.58 77.446 375.514 57.1099 357.53C36.7738 339.547 34.8917 308.546 52.8752 288.21L142.584 186.844C160.568 166.56 191.568 164.626 211.904 182.609Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M506.49 201.062L527.088 264.266L499.537 250.517L469.268 256.059L506.49 201.062ZM514.855 316.753C531.165 338.448 526.774 369.188 505.079 385.499L396.864 466.791C375.168 483.101 344.429 478.71 328.118 457.015C311.808 435.319 316.199 404.58 337.894 388.269L446.109 306.977C467.805 290.667 498.544 295.058 514.855 316.753Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-302.297 145.544L-244.948 111.93L-252.476 141.781L-240.609 170.167L-302.297 145.544ZM-191.05 112.662C-173.38 92.1166 -142.379 89.8161 -121.834 107.486L-19.2648 195.783C1.28036 213.453 3.58054 244.454 -14.0894 264.999C-31.7593 285.544 -62.76 287.845 -83.3051 270.175L-185.874 181.878C-206.419 164.208 -208.72 133.207 -191.05 112.662Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.1197 362.444L2.42732 307.657L32.7485 313.042L60.1944 299.136L40.1197 362.444ZM-0.761553 253.863C-22.5091 237.709 -27.0573 206.97 -10.9035 185.17L69.7612 76.4844C85.915 54.7369 116.654 50.1887 138.454 66.3425C160.254 82.4964 164.75 113.236 148.596 135.036L67.9314 243.721C51.7776 265.469 21.0383 270.017 -0.761553 253.863Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-110.231 179.156L-85.7649 117.311L-73.3228 145.437L-46.5042 160.493L-110.283 179.104L-110.231 179.156ZM-42.897 84.7423C-41.6424 57.6624 -18.6403 36.7512 8.43965 38.0059L143.63 44.384C170.71 45.6386 191.621 68.6406 190.367 95.7205C189.112 122.8 166.11 143.712 139.03 142.457L3.83934 136.079C-23.2406 134.824 -44.1517 111.822 -42.897 84.7423Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M337.111 -152.494L396.813 -123.219L367.798 -113.024L350.703 -87.4605L337.163 -152.494H337.111ZM425.931 -77.9459C452.854 -74.5479 471.884 -49.9773 468.433 -23.0542L451.391 111.195C447.993 138.118 423.422 157.147 396.499 153.697C369.576 150.247 350.547 125.728 353.997 98.8053L371.04 -35.444C374.438 -62.3671 399.008 -81.3963 425.931 -77.9459Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.44043 51.0242L-55.1293 70.524L-40.9097 43.2348L-45.9285 12.8614L8.44043 51.0242ZM-107.407 57.4546C-129.364 73.3993 -160.051 68.485 -175.996 46.5284L-255.458 -63.0459C-271.403 -85.0026 -266.489 -115.69 -244.532 -131.634C-222.575 -147.579 -191.888 -142.665 -175.943 -120.708L-96.4811 -11.1339C-80.5364 10.8228 -85.4505 41.5098 -107.407 57.4546Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.7377 -86.3604L84.1926 -130.797L82.781 -100.057L100.085 -74.6502L34.6855 -86.3604H34.7377ZM137.098 -140.886C150.324 -164.568 180.227 -173.037 203.909 -159.863L322.109 -93.9407C345.791 -80.7144 354.26 -50.8115 341.086 -27.1297C327.859 -3.44785 297.957 5.02101 274.275 -8.15298L156.075 -74.0752C132.393 -87.3015 123.924 -117.204 137.098 -140.886Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-95.543 -30.0601L-30.248 -17.5134L-55.6028 -0.0524883L-65.3787 29.1183L-95.543 -30.0601ZM9.79678 18.5061C36.6676 14.7421 61.4996 33.4052 65.2636 60.276L84.1358 194.316C87.8998 221.187 69.2367 246.019 42.3659 249.783C15.4951 253.547 -9.33692 234.884 -13.1009 208.013L-31.9731 73.9727C-35.7371 47.102 -17.074 22.2701 9.79678 18.5061Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M89.4162 21.5903L77.1309 -43.7568L102.642 -26.6097L133.382 -28.1781L89.3638 21.5903H89.4162ZM96.0031 -94.1527C82.62 -117.73 90.9322 -147.685 114.509 -161.068L232.291 -227.775C255.869 -241.158 285.824 -232.846 299.207 -209.268C312.59 -185.691 304.278 -155.736 280.701 -142.353L162.919 -75.6463C139.341 -62.2632 109.386 -70.5754 96.0031 -94.1527Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-67.5723 233.419L-20.5746 186.369L-20.3132 217.16L-1.65002 241.626L-67.5723 233.419ZM31.7033 173.508C43.6226 149.147 73.055 139.109 97.3642 151.029L218.91 210.573C243.272 222.493 253.309 251.925 241.39 276.234C229.47 300.543 200.038 310.633 175.729 298.714L54.1827 239.169C29.8212 227.25 19.7839 197.817 31.7033 173.508Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-75.0957 54.0554L-9.69627 41.9269L-26.9479 67.4385L-25.4318 98.1779L-75.0957 54.0554ZM40.6996 60.9561C64.3292 47.6252 94.2844 56.042 107.563 79.6193L173.956 197.558C187.287 221.188 178.87 251.143 155.293 264.421C131.715 277.7 101.708 269.335 88.4293 245.758L22.0364 127.819C8.70555 104.19 17.1223 74.2346 40.6996 60.9561Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M198.004 44.7518L147.661 88.1426L149.699 57.4555L132.918 31.6823L198.056 44.7518H198.004ZM94.5463 97.1342C80.8495 120.555 50.7899 128.396 27.3694 114.699L-89.4193 46.3203C-112.84 32.6236 -120.681 2.56362 -106.985 -20.8568C-93.2878 -44.2773 -63.2281 -52.1189 -39.8076 -38.4221L76.981 29.9574C100.401 43.6542 108.243 73.7138 94.5463 97.1342Z",
                fill: "#4D8CED"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M454.216 327.574L392.894 301.854L421.281 289.986L436.86 263.482L454.216 327.626V327.574ZM361.162 258.306C334.134 256.476 313.641 233.056 315.471 206.028L324.62 70.9945C326.449 43.9669 349.87 23.4741 376.897 25.3038C403.925 27.1335 424.418 50.554 422.588 77.5816L413.44 212.615C411.61 239.643 388.189 260.136 361.162 258.306Z",
                fill: "#4D8CED"
            })
        ]
    });
const $5234614371b266d4$export$4f43b91428c248ba = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "471",
        height: "220",
        viewBox: "0 0 471 220",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M162.119 -197.709L202.354 -153.871L174.845 -154.807L152.247 -139.04L162.119 -197.662V-197.709ZM211.899 -106.618C233.233 -95.0155 241.093 -68.3479 229.49 -47.0138L171.617 59.3758C160.014 80.7098 133.346 88.5698 112.012 76.9671C90.6781 65.3643 82.8182 38.6966 94.4209 17.3626L152.294 -89.027C163.897 -110.361 190.564 -118.221 211.899 -106.618Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M368.769 245.955L313.797 268.74L324.136 243.195L317.072 216.574L368.769 245.908V245.955ZM266.122 261.535C247.923 277.582 220.179 275.851 204.085 257.652L123.942 166.841C107.895 148.642 109.626 120.898 127.825 104.804C146.025 88.7101 173.768 90.488 189.863 108.687L270.006 199.498C286.053 217.697 284.322 245.441 266.122 261.535Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M95.5904 -125.332L118.515 -70.4064L92.9704 -80.6992L66.3496 -73.5879L95.5904 -125.332ZM111.357 -22.7323C127.451 -4.57961 125.767 23.2107 107.614 39.3048L16.9444 119.588C-1.20826 135.682 -28.9987 133.998 -45.0929 115.846C-61.187 97.6929 -59.5027 69.9024 -41.35 53.8083L49.3198 -26.4752C67.4725 -42.5693 95.2628 -40.8849 111.357 -22.7323Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-57.2564 -216.657L-10.7987 -179.463L-38.1681 -176.235L-58.0986 -157.24L-57.2564 -216.704V-216.657ZM5.76321 -134.221C28.5944 -125.987 40.4311 -100.817 32.1969 -77.9855L-8.88051 35.9832C-17.1147 58.8144 -42.2852 70.651 -65.1164 62.4168C-87.9476 54.1826 -99.7842 29.0122 -91.55 6.18103L-50.4726 -107.788C-42.2384 -130.619 -17.068 -142.456 5.76321 -134.221Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M449.099 199.404L394.127 222.188L404.466 196.644L397.402 170.023L449.099 199.357V199.404ZM346.5 214.984C328.3 231.031 300.556 229.3 284.462 211.1L204.319 120.29C188.272 102.091 190.003 74.3471 208.202 58.253C226.402 42.1589 254.145 43.9366 270.24 62.1361L350.383 152.946C366.43 171.146 364.699 198.889 346.5 214.984Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M288.066 34.8604L257.469 85.9031L250.591 59.2354L229.07 42.0652L288.066 34.8604ZM214.894 108.453C209.841 132.174 186.495 147.332 162.729 142.232L44.2684 116.922C20.5483 111.869 5.38986 88.523 10.4894 64.7561C15.589 40.9892 38.888 25.8775 62.6549 30.9771L181.115 56.288C204.835 61.3408 219.994 84.6866 214.894 108.453Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-38.168 -222.318L20.2668 -211.09L-2.42406 -195.463L-11.1729 -169.357L-38.168 -222.318ZM56.0575 -178.808C80.1051 -182.176 102.328 -165.474 105.697 -141.426L122.586 -21.469C125.955 2.57858 109.252 24.8015 85.2047 28.17C61.1571 31.5386 38.9341 14.8363 35.5656 -9.21132L18.6761 -129.169C15.3076 -153.216 32.0099 -175.439 56.0575 -178.808Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M484.704 -4.01823L531.162 33.1759L503.793 36.4041L483.862 55.3989L484.704 -4.06506V-4.01823ZM547.724 78.464C570.555 86.6982 582.392 111.869 574.158 134.7L533.08 248.669C524.846 271.5 499.676 283.336 476.845 275.102C454.013 266.868 442.177 241.698 450.411 218.867L491.488 104.898C499.723 82.0666 524.893 70.2298 547.724 78.464Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M405.45 312.016L371.718 262.985L398.853 267.804L423.415 255.359L405.45 312.016ZM368.911 214.89C349.448 200.433 345.378 172.924 359.834 153.414L432.024 56.1478C446.481 36.6852 473.99 32.6149 493.5 47.0715C513.009 61.5281 517.033 89.0379 502.576 108.547L430.386 205.814C415.93 225.276 388.42 229.347 368.911 214.89Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M410.175 171.239L350.992 165.11L372.233 147.566L378.689 120.805L410.175 171.239ZM312.488 136.057C288.861 141.531 265.235 126.746 259.808 103.12L232.579 -14.9194C227.105 -38.5459 241.889 -62.1725 265.515 -67.5996C289.142 -73.0734 312.768 -58.2893 318.196 -34.6627L345.425 83.3764C350.898 107.003 336.114 130.63 312.488 136.057Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M394.127 140.361L416.022 85.0142L427.157 110.185L451.158 123.659L394.08 140.314L394.127 140.361ZM454.386 55.8669C455.509 31.6322 476.095 12.9181 500.329 14.0409L621.316 19.7487C645.551 20.8716 664.265 41.4571 663.142 65.6918C662.019 89.9266 641.434 108.641 617.199 107.518L496.212 101.81C471.978 100.687 453.263 80.1017 454.386 55.8669Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M152.902 -224.096L206.331 -197.896L180.365 -188.773L165.066 -165.895L152.949 -224.096H152.902ZM232.39 -157.333C256.485 -154.292 273.515 -132.303 270.427 -108.209L255.175 11.9354C252.134 36.0298 230.145 53.0597 206.05 49.9718C181.956 46.884 164.926 24.9417 168.014 0.847351L183.266 -119.297C186.307 -143.391 208.296 -160.421 232.39 -157.333Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M177.418 212.27L219.478 170.163L219.712 197.72L236.414 219.615L177.418 212.27ZM266.31 158.654C276.977 136.852 303.317 127.869 325.072 138.536L433.848 191.825C455.65 202.492 464.633 228.832 453.966 250.587C443.299 272.342 416.958 281.372 395.203 270.705L286.428 217.416C264.626 206.749 255.643 180.409 266.31 158.654Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M156.224 -206.318L202.682 -169.123L175.312 -165.895L155.382 -146.9L156.224 -206.364V-206.318ZM219.244 -123.882C242.075 -115.648 253.912 -90.4773 245.677 -67.6461L204.6 46.3226C196.366 69.1538 171.195 80.9905 148.364 72.7563C125.533 64.5221 113.696 39.3517 121.93 16.5205L163.008 -97.4483C171.242 -120.279 196.413 -132.116 219.244 -123.882Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.9711 109.717L43.239 60.6859L70.3745 65.5048L94.9367 53.0599L76.9711 109.717ZM40.3851 12.5439C20.9225 -1.91273 16.8522 -29.4224 31.3088 -48.9318L103.498 -146.198C117.955 -165.661 145.465 -169.731 164.974 -155.275C184.484 -140.818 188.507 -113.308 174.05 -93.7988L101.861 3.46756C87.4043 22.9302 59.8946 27.0005 40.3851 12.5439Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M61.8593 -107.46L58.8183 -48.0429L40.1977 -68.3477L13.1091 -73.4006L61.8125 -107.46H61.8593ZM31.8232 -8.08842C38.5134 15.2574 24.9925 39.5858 1.69345 46.2293L-114.755 79.5404C-138.101 86.2307 -162.429 72.7097 -169.073 49.4107C-175.716 26.1116 -162.242 1.73659 -138.943 -4.90691L-22.4945 -38.218C0.851334 -44.9083 25.1797 -31.3875 31.8232 -8.08842Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M294.803 144.01L289.469 203.287L271.644 182.281L244.789 176.152L294.803 144.01ZM260.93 242.119C266.685 265.699 252.228 289.466 228.695 295.22L111.03 323.946C87.4505 329.701 63.6836 315.244 57.929 291.711C52.1745 268.178 66.6311 244.365 90.1641 238.61L207.829 209.884C231.409 204.129 255.176 218.586 260.93 242.119Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M236.742 341.35L177.653 334.426L199.127 317.163L205.958 290.495L236.789 341.35H236.742ZM139.57 304.858C115.849 310.004 92.4568 294.94 87.3104 271.219L61.6721 152.853C56.5258 129.133 71.5906 105.74 95.3107 100.594C119.031 95.4474 142.423 110.512 147.57 134.232L173.208 252.599C178.354 276.319 163.29 299.712 139.57 304.858Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.1855 -180.212L19.7059 -120.748L0.898178 -140.865L-26.1904 -145.684L22.2322 -180.212H22.1855ZM-6.91495 -80.6059C-0.0375214 -57.3536 -13.3245 -32.8849 -36.5768 -26.0075L-152.744 8.3797C-175.997 15.2571 -200.465 1.97014 -207.343 -21.2821C-214.22 -44.5344 -200.933 -69.0031 -177.681 -75.8805L-61.5133 -110.268C-38.261 -117.145 -13.7924 -103.858 -6.91495 -80.6059Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-271.812 163.754L-225.729 126.092L-228.255 153.508L-213.846 176.947L-271.812 163.754ZM-178.055 119.308C-165.236 98.6753 -138.147 92.3594 -117.562 105.179L-14.6809 169.087C5.95139 181.906 12.2674 208.995 -0.551758 229.58C-13.3709 250.166 -40.4596 256.529 -61.0451 243.71L-163.926 179.801C-184.558 166.982 -190.874 139.893 -178.055 119.308Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M98.8672 41.4573L156.132 57.6449L132.225 71.2594L121.277 96.5234L98.9139 41.4573H98.8672ZM189.022 92.8742C213.257 91.5642 233.936 110.138 235.293 134.373L241.843 255.313C243.153 279.547 224.579 300.226 200.344 301.583C176.11 302.94 155.431 284.319 154.074 260.085L147.524 139.145C146.214 114.91 164.788 94.231 189.022 92.8742Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-129.914 72.5226L-86.8249 31.492L-87.2928 59.0484L-71.1519 81.3651L-129.961 72.5694L-129.914 72.5226ZM-39.759 21.1056C-28.5306 -0.415558 -2.00335 -8.79021 19.5179 2.43824L126.937 58.3935C148.458 69.6219 156.833 96.1491 145.604 117.67C134.376 139.191 107.848 147.566 86.3272 136.338L-21.0917 80.3825C-42.6129 69.154 -50.9875 42.6269 -39.759 21.1056Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-83.082 132.127L-74.5672 73.2242L-57.9116 95.1665L-31.4312 102.699L-83.082 132.127ZM-44.0164 35.9364C-48.5078 12.0759 -32.8347 -10.8956 -8.97424 -15.387L110.047 -37.8438C133.908 -42.3352 156.879 -26.6622 161.371 -2.80175C165.862 21.0587 150.189 44.0303 126.329 48.5216L7.307 70.9786C-16.5535 75.47 -39.525 59.7969 -44.0164 35.9364Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-133.797 -195.931L-76.5318 -179.743L-100.439 -166.129L-111.387 -140.865L-133.75 -195.931H-133.797ZM-43.6418 -144.561C-19.4071 -145.871 1.27202 -127.297 2.62878 -103.062L9.17876 17.8774C10.4888 42.1122 -8.08504 62.7912 -32.3198 64.1479C-56.5545 65.5047 -77.2336 46.8842 -78.5904 22.6494L-85.1403 -98.2904C-86.4503 -122.525 -67.8765 -143.204 -43.6418 -144.561Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-38.4493 -54.3121L0.288826 -9.11773L-27.1741 -11.0358L-50.286 3.93539L-38.4025 -54.3121H-38.4493ZM8.19554 38.4161C29.1085 50.7206 36.0328 77.669 23.7283 98.582L-37.7943 202.913C-50.0989 223.826 -77.0472 230.75 -97.9602 218.446C-118.873 206.141 -125.797 179.193 -113.493 158.28L-51.9703 53.9488C-39.6657 33.0358 -12.7175 26.1116 8.19554 38.4161Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M201.982 355.573L150.05 326.519L176.484 318.847L193.046 296.811L201.982 355.573ZM126.236 284.553C102.376 280.202 86.5625 257.324 90.9135 233.417L112.669 114.255C117.02 90.3944 139.898 74.5809 163.805 78.9319C187.712 83.283 203.479 106.161 199.128 130.068L177.373 249.23C173.022 273.091 150.144 288.904 126.236 284.553Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.1093 -38.2648L65.3681 -78.0322L64.1049 -50.5225L79.5909 -27.785L21.0625 -38.2648H21.1093ZM112.715 -87.1086C124.551 -108.302 151.313 -115.882 172.506 -104.092L278.288 -45.0954C299.481 -33.2587 307.061 -6.4976 295.271 14.6961C283.434 35.8898 256.673 43.4689 235.479 31.679L129.698 -27.3171C108.504 -39.1537 100.925 -65.9149 112.715 -87.1086Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M318.195 -201.499L356.933 -156.304L329.47 -158.222L306.358 -143.251L318.242 -201.499H318.195ZM364.793 -108.77C385.706 -96.4658 392.63 -69.5174 380.326 -48.6044L318.803 55.7266C306.499 76.6396 279.551 83.5638 258.638 71.2593C237.725 58.9548 230.8 32.0064 243.105 11.0934L304.627 -93.2376C316.932 -114.151 343.88 -121.075 364.793 -108.77Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M558.577 208.387L506.646 179.333L533.08 171.66L549.641 149.625L558.577 208.387ZM482.879 137.367C459.019 133.016 443.205 110.138 447.556 86.2306L469.311 -32.9314C473.662 -56.7919 496.54 -72.6052 520.448 -68.2542C544.355 -63.9032 560.121 -41.0252 555.77 -17.118L534.015 102.044C529.664 125.904 506.786 141.718 482.879 137.367Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M386.782 -244.12L437.732 -213.335L411.064 -206.505L393.8 -185.03L386.829 -244.073L386.782 -244.12ZM460.142 -170.667C483.862 -165.521 498.927 -142.128 493.78 -118.408L468.095 -0.0414276C462.949 23.6787 439.556 38.7435 415.836 33.5972C392.116 28.4508 377.051 5.05826 382.198 -18.6619L407.883 -137.029C413.029 -160.749 436.421 -175.814 460.142 -170.667Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M408.49 -214.973L454.947 -177.778L427.578 -174.55L407.647 -155.555L408.49 -215.019V-214.973ZM471.509 -132.49C494.341 -124.256 506.177 -99.0856 497.943 -76.2544L456.866 37.7143C448.631 60.5455 423.461 72.3821 400.63 64.1479C377.799 55.9138 365.962 30.7433 374.196 7.91217L415.274 -106.057C423.508 -128.888 448.678 -140.725 471.509 -132.49Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M352.864 4.54333L319.132 -44.4876L346.267 -39.6688L370.829 -52.1135L352.864 4.54333ZM316.278 -92.6295C296.815 -107.086 292.745 -134.596 307.201 -154.105L379.391 -251.372C393.848 -270.835 421.357 -274.905 440.867 -260.448C460.376 -245.991 464.4 -218.482 449.943 -198.972L377.754 -101.706C363.297 -82.2432 335.787 -78.1729 316.278 -92.6295Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M618.51 -133.005L641.435 -78.0792L615.89 -88.3719L589.269 -81.2606L618.51 -133.005ZM634.277 -30.405C650.371 -12.2524 648.687 15.5381 630.534 31.6322L539.864 111.916C521.712 128.01 493.921 126.325 477.827 108.173C461.733 90.0201 463.417 62.2298 481.57 46.1357L572.24 -34.1478C590.392 -50.2419 618.183 -48.5577 634.277 -30.405Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M470.623 -228.962L517.08 -191.767L489.711 -188.539L469.78 -169.544L470.623 -229.008V-228.962ZM533.642 -146.526C556.473 -138.292 568.31 -113.121 560.076 -90.2901L518.998 23.6786C510.764 46.5098 485.594 58.3465 462.763 50.1122C439.931 41.8781 428.095 16.7077 436.329 -6.12354L477.406 -120.092C485.641 -142.923 510.811 -154.76 533.642 -146.526Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M486.576 -113.542L481.242 -54.2656L463.417 -75.2721L436.563 -81.4009L486.576 -113.542ZM452.657 -15.4337C458.411 8.14603 443.955 31.9128 420.422 37.6674L302.757 66.3936C279.177 72.1482 255.41 57.6915 249.656 34.1585C243.901 10.6255 258.358 -13.188 281.891 -18.9426L399.556 -47.6688C423.135 -53.4234 446.902 -38.9667 452.657 -15.4337Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M488.354 65.271L429.264 58.3467L450.738 41.0829L457.569 14.4154L488.401 65.271H488.354ZM391.181 28.8252C367.461 33.9716 344.068 18.9068 338.922 -4.81335L313.283 -123.18C308.137 -146.9 323.202 -170.293 346.922 -175.439C370.642 -180.585 394.035 -165.521 399.181 -141.8L424.819 -23.4339C429.966 0.286179 414.901 23.6788 391.181 28.8252Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M535.326 139.425L486.482 105.459L513.524 100.36L532.097 80.055L535.279 139.425H535.326ZM466.785 61.4344C443.44 54.7909 429.919 30.4625 436.562 7.11671L469.78 -109.378C476.423 -132.724 500.751 -146.245 524.097 -139.602C547.443 -132.958 560.964 -108.63 554.32 -85.2841L521.103 31.2112C514.459 54.557 490.131 68.0779 466.785 61.4344Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M320.863 205.439L367.32 242.634L339.951 245.862L320.021 264.857L320.863 205.393V205.439ZM383.882 287.922C406.714 296.156 418.55 321.326 410.316 344.158L369.239 458.126C361.004 480.958 335.834 492.794 313.003 484.56C290.172 476.326 278.335 451.155 286.569 428.324L327.647 314.355C335.881 291.524 361.051 279.688 383.882 287.922Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M399.602 160.526L445.685 122.863L443.159 150.28L457.569 173.719L399.602 160.526ZM493.406 116.08C506.225 95.4473 533.314 89.1313 553.899 101.95L656.78 165.859C677.412 178.678 683.728 205.767 670.909 226.352C658.09 246.938 631.001 253.301 610.416 240.481L507.535 176.573C486.903 163.754 480.587 136.665 493.406 116.08Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M86.5156 24.1935L129.605 -16.8372L129.137 10.7193L145.278 33.0358L86.4688 24.2402L86.5156 24.1935ZM176.671 -27.2236C187.899 -48.7448 214.426 -57.1193 235.948 -45.8908L343.366 10.0643C364.888 21.2927 373.262 47.82 362.034 69.3412C350.805 90.8624 324.278 99.2369 302.757 88.0085L195.338 32.0534C173.817 20.8249 165.442 -5.70237 176.671 -27.2236Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M597.551 348.275L538.461 341.35L559.936 324.086L566.766 297.419L597.598 348.275H597.551ZM500.331 311.829C476.611 316.975 453.219 301.91 448.072 278.19L422.434 159.824C417.287 136.104 432.352 112.711 456.072 107.564C479.793 102.418 503.185 117.483 508.332 141.203L533.97 259.57C539.116 283.29 524.051 306.682 500.331 311.829Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M423.883 192.199L483.394 191.357L464.352 211.241L461.03 238.563L423.883 192.152V192.199ZM524.986 215.779C547.817 207.591 572.987 219.521 581.175 242.353L621.972 356.415C630.159 379.246 618.229 404.417 595.397 412.604C572.566 420.792 547.396 408.861 539.209 386.03L498.412 271.968C490.224 249.137 502.155 223.966 524.986 215.779Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.144 79.4933L174.799 21.9944L198.753 35.6089L226.075 32.1L190.191 79.4933H190.144ZM188.226 -24.2763C174.705 -44.4407 180.086 -71.7165 200.25 -85.2374L300.838 -152.702C321.003 -166.223 348.278 -160.842 361.799 -140.678C375.32 -120.514 369.94 -93.2377 349.776 -79.7168L249.187 -12.2524C229.023 1.26851 201.747 -4.11183 188.226 -24.2763Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-59.5957 -88.7462L-19.3605 -44.9085L-46.8702 -45.8441L-69.4674 -30.0775L-59.5957 -88.6994V-88.7462ZM-9.81622 2.34463C11.5178 13.9474 19.3777 40.6149 7.77499 61.949L-50.0983 168.339C-61.701 189.673 -88.3687 197.533 -109.703 185.93C-131.037 174.327 -138.897 147.66 -127.294 126.325L-69.4206 19.9359C-57.8179 -1.39815 -31.1503 -9.25811 -9.81622 2.34463Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M223.923 172.83L270.381 210.024L243.012 213.253L223.081 232.247L223.923 172.783V172.83ZM286.99 255.312C309.821 263.547 321.658 288.717 313.423 311.548L272.346 425.517C264.112 448.348 238.941 460.185 216.11 451.951C193.279 443.717 181.442 418.546 189.677 395.715L230.754 281.746C238.988 258.915 264.159 247.078 286.99 255.312Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M355.203 281.372L300.23 304.156L310.57 278.611L303.505 251.991L355.203 281.325V281.372ZM252.603 296.904C234.404 312.952 206.66 311.221 190.566 293.021L110.423 202.211C94.3754 184.012 96.1064 156.268 114.306 140.174C132.505 124.08 160.249 125.858 176.343 144.057L256.486 234.867C272.533 253.067 270.802 280.81 252.603 296.904Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M338.5 66.4872L381.589 25.4566L381.121 53.0131L397.262 75.3297L338.453 66.534L338.5 66.4872ZM428.655 15.0703C439.883 -6.45095 466.411 -14.8255 487.932 -3.597L595.351 52.3581C616.872 63.5865 625.247 90.1138 614.018 111.635C602.79 133.156 576.262 141.531 554.741 130.302L447.322 74.3472C425.801 63.1187 417.427 36.5915 428.655 15.0703Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.9219 117.764L92.8302 97.4121L81.4147 122.489L87.3096 149.39L36.9219 117.81V117.764ZM140.13 106.675C159.031 91.4235 186.681 94.371 201.933 113.272L278.006 207.498C293.258 226.399 290.311 254.049 271.409 269.301C252.508 284.553 224.858 281.605 209.606 262.704L133.533 168.479C118.281 149.578 121.229 121.927 140.13 106.675Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-249.59 235.99L-198.266 205.907L-205.004 232.621L-194.383 258.026L-249.59 235.99ZM-150.078 206.562C-134.264 188.175 -106.521 186.117 -88.134 201.93L3.65855 280.951C22.0452 296.764 24.1037 324.508 8.29031 342.894C-7.52309 361.281 -35.2668 363.339 -53.6534 347.526L-145.446 268.506C-163.833 252.692 -165.891 224.949 -150.078 206.562Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M111.78 146.63L110.704 206.141L91.4282 186.491L64.1991 182.327L111.78 146.677V146.63ZM85.0654 246.938C92.5042 270.05 79.8254 294.799 56.7135 302.238L-58.5654 339.385C-81.6773 346.824 -106.427 334.146 -113.865 311.034C-121.304 287.922 -108.626 263.172 -85.5136 255.733L29.7652 218.586C52.8771 211.147 77.6265 223.826 85.0654 246.938Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M284.744 167.543L331.201 204.738L303.832 207.966L283.902 226.961L284.744 167.496V167.543ZM347.81 250.026C370.641 258.26 382.478 283.43 374.244 306.261L333.166 420.23C324.932 443.062 299.762 454.898 276.931 446.664C254.099 438.43 242.263 413.259 250.497 390.428L291.574 276.459C299.808 253.628 324.979 241.791 347.81 250.026Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M424.07 274.541L369.097 297.325L379.437 271.781L372.373 245.16L424.07 274.494V274.541ZM321.423 290.074C303.224 306.121 275.48 304.39 259.386 286.191L179.243 195.381C163.196 177.181 164.927 149.437 183.126 133.343C201.326 117.249 229.069 119.027 245.163 137.227L325.307 228.037C341.354 246.236 339.623 273.98 321.423 290.074Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M364.371 218.258L361.891 277.723L343.084 257.605L315.995 252.786L364.418 218.258H364.371ZM335.224 317.864C342.101 341.116 328.814 365.585 305.562 372.463L189.394 406.85C166.142 413.727 141.673 400.44 134.796 377.188C127.918 353.936 141.205 329.467 164.458 322.59L280.625 288.202C303.878 281.325 328.346 294.612 335.224 317.864Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M419.486 82.7684L462.575 41.7378L462.108 69.2943L478.249 91.6109L419.439 82.8153L419.486 82.7684ZM509.641 31.3515C520.87 9.83029 547.397 1.45564 568.918 12.6841L676.337 68.6393C697.858 79.8678 706.233 106.395 695.004 127.916C683.776 149.437 657.249 157.812 635.727 146.584L528.309 90.6283C506.787 79.3999 498.413 52.8727 509.641 31.3515Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M109.768 107.097L165.676 86.7452L154.26 111.822L160.155 138.723L109.768 107.143V107.097ZM212.976 96.0554C231.877 80.8034 259.527 83.7509 274.779 102.652L350.852 196.878C366.104 215.779 363.156 243.429 344.255 258.681C325.354 273.933 297.704 270.985 282.452 252.084L206.379 157.859C191.127 138.957 194.075 111.307 212.976 96.0554Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-183.623 201.697L-132.3 171.614L-139.037 198.328L-128.416 223.732L-183.623 201.697ZM-84.0641 172.269C-68.2507 153.882 -40.507 151.824 -22.1204 167.637L69.6722 246.657C88.0588 262.471 90.1174 290.214 74.304 308.601C58.4905 326.987 30.7469 329.046 12.3603 313.233L-79.4323 234.212C-97.8189 218.399 -99.8775 190.655 -84.0641 172.269Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-117.797 310.098L-90.8486 257.043L-82.0998 283.15L-59.4089 298.776L-117.75 310.098H-117.797ZM-49.9583 231.499C-46.5898 207.451 -24.3668 190.749 -0.319168 194.117L119.638 211.007C143.686 214.375 160.388 236.598 157.02 260.646C153.651 284.693 131.428 301.396 107.38 298.027L-12.577 281.138C-36.6245 277.769 -53.3268 255.546 -49.9583 231.499Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M281.376 51.3757L327.834 88.5699L300.465 91.798L280.534 110.793L281.376 51.3289V51.3757ZM344.396 133.858C367.227 142.092 379.064 167.263 370.83 190.094L329.752 304.063C321.518 326.894 296.348 338.731 273.516 330.496C250.685 322.262 238.849 297.092 247.083 274.26L288.16 160.292C296.394 137.46 321.565 125.624 344.396 133.858Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M515.021 199.451L460.049 222.235L470.388 196.691L463.324 170.07L515.021 199.404V199.451ZM412.374 215.03C394.175 231.078 366.431 229.347 350.337 211.147L270.194 120.337C254.147 102.138 255.878 74.3939 274.077 58.2998C292.277 42.2057 320.02 43.9836 336.115 62.1831L416.258 152.993C432.305 171.193 430.574 198.936 412.374 215.03Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M381.309 59.5631L378.829 119.027L360.021 98.9095L332.932 94.0906L381.355 59.5631H381.309ZM352.161 159.216C359.039 182.468 345.752 206.937 322.499 213.814L206.332 248.201C183.079 255.078 158.611 241.791 151.733 218.539C144.856 195.287 158.143 170.818 181.395 163.941L297.563 129.554C320.815 122.676 345.284 135.963 352.161 159.216Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M268.088 21.0119L323.996 0.660396L312.581 25.7372L318.476 52.6387L268.088 21.0587V21.0119ZM371.296 9.92378C390.197 -5.3282 417.847 -2.38072 433.099 16.5205L509.172 110.746C524.424 129.647 521.477 157.297 502.575 172.549C483.674 187.801 456.024 184.854 440.772 165.953L364.699 71.7272C349.447 52.8259 352.395 25.1758 371.296 9.92378Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M219.806 431.506L160.623 425.377L181.864 407.832L188.32 381.071L219.806 431.506ZM122.166 396.323C98.539 401.797 74.9125 387.013 69.4854 363.386L42.2564 245.347C36.7825 221.721 51.5667 198.094 75.1932 192.667C98.8198 187.24 122.446 201.977 127.873 225.604L155.102 343.643C160.576 367.269 145.792 390.896 122.166 396.323Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M62.3281 207.732L113.652 177.649L106.914 204.363L117.535 229.768L62.3281 207.732ZM161.84 178.304C177.654 159.917 205.397 157.859 223.784 173.672L315.577 252.692C333.963 268.506 336.022 296.249 320.208 314.636C304.395 333.023 276.651 335.081 258.265 319.268L166.472 240.247C148.085 224.434 146.027 196.69 161.84 178.304Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-1.39397 331.526L-35.1261 282.495L-7.99063 287.314L16.5716 274.869L-1.39397 331.526ZM-37.9332 234.399C-57.3959 219.943 -61.4662 192.433 -47.0096 172.924L25.1801 75.6572C39.6367 56.1946 67.1464 52.1243 86.6559 66.5809C106.165 81.0375 110.189 108.547 95.7322 128.057L23.5426 225.323C9.08592 244.786 -18.4238 248.856 -37.9332 234.399Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M410.268 18.6726L352.114 31.3515L366.805 8.05238L364.559 -19.4105L410.221 18.6259L410.268 18.6726ZM306.498 15.7719C285.726 28.3571 258.731 21.7137 246.145 0.941086L183.406 -102.641C170.821 -123.414 177.465 -150.409 198.237 -162.994C219.01 -175.58 246.005 -168.936 258.59 -148.163L321.329 -44.581C333.914 -23.8084 327.271 3.18669 306.498 15.7719Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.43071 216.761L-57.7701 229.206L-42.986 205.954L-45.0913 178.491L0.43071 216.714V216.761ZM-103.339 213.439C-124.158 225.931 -151.153 219.194 -163.598 198.375L-225.916 94.5114C-238.408 73.692 -231.671 46.6969 -210.851 34.252C-190.032 21.8071 -163.037 28.4974 -150.592 49.3169L-88.274 153.18C-75.7824 173.999 -82.5195 200.995 -103.339 213.439Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M82.725 390.615L71.7305 332.134L94.5617 347.479L122.071 346.076L82.6782 390.615H82.725ZM88.6199 286.986C76.6429 265.886 84.0817 239.078 105.182 227.101L210.589 167.403C231.689 155.426 258.497 162.865 270.474 183.965C282.451 205.065 275.012 231.873 253.912 243.85L148.505 303.548C127.405 315.525 100.597 308.086 88.6199 286.986Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-212.77 294.659L-208.465 235.288L-190.266 255.967L-163.318 261.582L-212.723 294.612L-212.77 294.659ZM-180.675 195.942C-186.851 172.456 -172.862 148.455 -149.376 142.279L-32.2721 111.401C-8.78592 105.225 15.2149 119.214 21.3906 142.7C27.5662 166.187 13.5774 190.187 -9.90877 196.363L-127.012 227.241C-150.498 233.417 -174.499 219.428 -180.675 195.942Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M80.2926 391.317L21.1094 385.188L42.3498 367.644L48.8062 340.882L80.2926 391.317ZM-17.3481 356.134C-40.9746 361.608 -64.6012 346.824 -70.0283 323.198L-97.2573 205.158C-102.731 181.532 -87.947 157.905 -64.3205 152.478C-40.694 147.051 -17.0674 161.789 -11.6403 185.415L15.5887 303.454C21.0625 327.081 6.27844 350.707 -17.3481 356.134Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M251.714 204.317L243.34 145.414L265.469 161.789L293.026 161.602L251.714 204.363V204.317ZM262.241 101.015C251.247 79.4 259.855 52.9195 281.47 41.925L389.403 -13.0008C411.018 -23.9954 437.499 -15.3868 448.493 6.22797C459.488 27.8428 450.879 54.3231 429.264 65.3176L321.331 120.244C299.716 131.238 273.236 122.63 262.241 101.015Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M220.414 330.824L162.821 315.899L186.448 301.723L196.834 276.225L220.414 330.777V330.824ZM129.136 281.418C104.948 283.243 83.8476 265.137 81.9762 240.949L72.7595 120.196C70.9348 96.0085 89.0407 74.9085 113.229 73.0371C137.417 71.1656 158.517 89.3183 160.388 113.506L169.605 234.259C171.429 258.447 153.324 279.547 129.136 281.418Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-138.006 205.673L-133.702 146.303L-115.502 166.982L-88.5538 172.596L-137.959 205.627L-138.006 205.673ZM-105.911 106.956C-112.087 83.4703 -98.098 59.4695 -74.6119 53.2938L42.4916 22.4156C65.9778 16.2399 89.9786 30.2287 96.1542 53.7149C102.33 77.2011 88.3411 101.202 64.8549 107.378L-52.2485 138.256C-75.7347 144.431 -99.7355 130.443 -105.911 106.956Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.4035 235.101L35.4719 206.048L61.9055 198.375L78.4675 176.339L87.4035 235.101ZM11.6582 164.128C-12.2022 159.777 -28.0156 136.899 -23.6646 112.992L-1.90952 -6.1702C2.44151 -30.0307 25.3195 -45.844 49.2268 -41.493C73.134 -37.142 88.9007 -14.264 84.5496 9.64323L62.7945 128.805C58.4434 152.666 35.5655 168.479 11.6582 164.128Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-97.3048 204.317L-53.0459 164.549L-54.3092 192.059L-38.8233 214.796L-97.3516 204.317H-97.3048ZM-5.69933 155.473C6.13734 134.279 32.8985 126.7 54.0922 138.49L159.874 197.486C181.067 209.323 188.647 236.084 176.857 257.277C165.02 278.471 138.259 286.05 117.065 274.26L11.2837 215.264C-9.90997 203.428 -17.4892 176.667 -5.69933 155.473Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M457.85 8.84778L496.588 54.0422L469.125 52.1241L446.013 67.0953L457.896 8.84778H457.85ZM504.494 101.576C525.407 113.881 532.332 140.829 520.027 161.742L458.505 266.073C446.2 286.986 419.252 293.91 398.339 281.606C377.426 269.301 370.501 242.353 382.806 221.44L444.329 117.109C456.633 96.1957 483.581 89.2715 504.494 101.576Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M404.609 15.4913L352.677 -13.5623L379.111 -21.2352L395.673 -43.271L404.609 15.4913ZM328.863 -55.4818C305.003 -59.8329 289.189 -82.711 293.54 -106.618L315.296 -225.78C319.647 -249.641 342.525 -265.454 366.432 -261.103C390.339 -256.752 406.106 -233.874 401.755 -209.967L380 -90.8048C375.649 -66.9443 352.771 -51.1308 328.863 -55.4818Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M313.049 103.635L370.314 119.822L346.407 133.437L335.459 158.701L313.096 103.635H313.049ZM403.204 155.005C427.439 153.695 448.118 172.268 449.475 196.503L456.025 317.443C457.335 341.678 438.761 362.357 414.526 363.714C390.291 365.07 369.612 346.45 368.255 322.215L361.706 201.275C360.396 177.041 378.969 156.362 403.204 155.005Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-102.637 270.097L-59.5476 229.066L-60.0155 256.622L-43.8745 278.939L-102.684 270.143L-102.637 270.097ZM-12.4817 218.68C-1.25323 197.158 25.274 188.784 46.7952 200.012L154.214 255.967C175.735 267.196 184.11 293.723 172.881 315.244C161.653 336.765 135.126 345.14 113.604 333.912L6.18565 277.956C-15.3356 266.728 -23.7101 240.201 -12.4817 218.68Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.2147 327.596L-0.130859 270.097L23.8232 283.711L51.1458 280.202L15.2615 327.596H15.2147ZM13.2965 223.779C-0.224453 203.615 5.15588 176.339 25.3203 162.818L125.909 95.3537C146.073 81.8328 173.349 87.2131 186.87 107.378C200.391 127.542 195.01 154.818 174.846 168.339L74.2577 235.803C54.0933 249.324 26.8174 243.944 13.2965 223.779Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M452.564 -195.651L503.513 -164.866L476.845 -158.035L459.581 -136.561L452.61 -195.604L452.564 -195.651ZM525.923 -122.198C549.643 -117.051 564.708 -93.6587 559.561 -69.9386L533.876 48.4281C528.73 72.1482 505.337 87.2131 481.617 82.0667C457.897 76.9203 442.832 53.5276 447.979 29.8075L473.664 -88.5591C478.81 -112.279 502.203 -127.344 525.923 -122.198Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M350.057 -159.579L405.965 -179.931L394.549 -154.854L400.444 -127.952L350.057 -159.532V-159.579ZM453.218 -170.667C472.119 -185.919 499.769 -182.972 515.021 -164.07L591.094 -69.8449C606.346 -50.9437 603.399 -23.2937 584.497 -8.04167C565.596 7.21031 537.946 4.26282 522.694 -14.6384L446.621 -108.864C431.369 -127.765 434.317 -155.415 453.218 -170.667Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M318.711 157.485L370.034 127.402L363.297 154.116L373.917 179.52L318.711 157.485ZM418.27 128.057C434.083 109.67 461.827 107.612 480.214 123.425L572.006 202.445C590.393 218.259 592.451 246.002 576.638 264.389C560.825 282.776 533.081 284.834 514.694 269.021L422.902 190C404.515 174.187 402.456 146.443 418.27 128.057Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M365.588 189.298L392.536 136.244L401.285 162.35L423.976 177.976L365.635 189.298H365.588ZM433.426 110.699C436.795 86.6516 459.018 69.9493 483.066 73.3178L603.023 90.2072C627.071 93.5758 643.773 115.799 640.404 139.846C637.036 163.894 614.813 180.596 590.765 177.228L470.808 160.338C446.76 156.97 430.058 134.747 433.426 110.699Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.9283 133.624L8.19611 84.5929L35.3316 89.4117L59.8938 76.9669L41.9283 133.624ZM5.38904 36.4975C-14.0736 22.0409 -18.1439 -5.46877 -3.6873 -24.9782L68.5023 -122.245C82.9589 -141.707 110.469 -145.778 129.978 -131.321C149.487 -116.864 153.511 -89.3547 139.054 -69.8452L66.8648 27.4213C52.4082 46.884 24.8985 50.9541 5.38904 36.4975Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.9393 67.7506L33.8348 12.4036L44.9697 37.5741L68.9705 51.0483L11.8926 67.7038L11.9393 67.7506ZM72.1987 -16.7903C73.3216 -41.0251 93.9071 -59.7392 118.142 -58.6163L239.128 -52.9085C263.363 -51.7857 282.077 -31.2001 280.954 -6.96538C279.832 17.2694 259.246 35.9835 235.011 34.8606L114.025 29.1528C89.79 28.03 71.0759 7.44444 72.1987 -16.7903Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.1094 185.275L66.5381 211.475L40.5723 220.598L25.2736 243.476L13.1561 185.275H13.1094ZM92.5975 251.991C116.692 255.032 133.722 277.021 130.634 301.115L115.382 421.26C112.341 445.354 90.3518 462.384 66.2574 459.296C42.163 456.208 25.1332 434.266 28.221 410.172L43.473 290.027C46.5141 265.933 68.5031 248.903 92.5975 251.991Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M400.865 -74.383L452.189 -104.466L445.452 -77.7516L456.072 -52.3472L400.865 -74.383ZM500.377 -103.811C516.191 -122.198 543.934 -124.256 562.321 -108.443L654.114 -29.4225C672.5 -13.6091 674.559 14.1346 658.745 32.5212C642.932 50.9078 615.188 52.9663 596.802 37.1529L505.009 -41.8674C486.623 -57.6808 484.564 -85.4244 500.377 -103.811Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M405.965 261.488L372.233 212.457L399.369 217.276L423.931 204.831L405.965 261.488ZM369.426 164.315C349.963 149.859 345.893 122.349 360.35 102.839L432.539 5.57288C446.996 -13.8898 474.506 -17.9601 494.015 -3.50346C513.525 10.9532 517.548 38.463 503.092 57.9724L430.902 155.239C416.445 174.701 388.936 178.772 369.426 164.315Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M520.682 300.039L461.171 299.244L480.727 279.875L484.751 252.646L520.635 300.039H520.682ZM420.234 273.793C397.169 281.325 372.373 268.786 364.793 245.721L327.084 130.63C319.552 107.565 332.09 82.7685 355.155 75.1893C378.221 67.6101 403.017 80.1953 410.596 103.26L448.305 218.352C455.837 241.417 443.299 266.213 420.234 273.793Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M402.361 177.462L429.31 124.407L438.058 150.513L460.749 166.14L402.408 177.462H402.361ZM470.2 98.8624C473.568 74.8148 495.791 58.1125 519.839 61.481L639.796 78.3704C663.844 81.739 680.546 103.962 677.178 128.01C673.809 152.057 651.586 168.76 627.538 165.391L507.581 148.501C483.534 145.133 466.831 122.91 470.2 98.8624Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M89.8828 -143.345L148.318 -132.116L125.627 -116.49L116.878 -90.3838L89.8828 -143.345ZM184.155 -99.8812C208.203 -103.25 230.426 -86.5473 233.794 -62.4997L250.684 57.4575C254.052 81.5051 237.35 103.728 213.302 107.097C189.255 110.465 167.032 93.7628 163.663 69.7152L146.774 -50.242C143.405 -74.2896 160.107 -96.5127 184.155 -99.8812Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M168.67 347.105L157.676 288.623L180.507 303.969L208.017 302.566L168.624 347.105H168.67ZM174.612 243.476C162.635 222.376 170.074 195.568 191.174 183.591L296.581 123.893C317.681 111.916 344.489 119.354 356.466 140.455C368.443 161.555 361.004 188.363 339.904 200.34L234.497 260.038C213.397 272.015 186.589 264.576 174.612 243.476Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.1108 -144.888L131.569 -107.694L104.199 -104.466L84.2687 -85.4712L85.1108 -144.935V-144.888ZM148.13 -62.4529C170.962 -54.2187 182.798 -29.0482 174.564 -6.217L133.487 107.752C125.252 130.583 100.082 142.42 77.2509 134.185C54.4197 125.951 42.583 100.781 50.8172 77.9496L91.8946 -36.0193C100.129 -58.8505 125.299 -70.6871 148.13 -62.4529Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M315.342 -1.49193L260.369 21.2924L270.708 -4.25223L263.644 -30.873L315.342 -1.53862V-1.49193ZM212.695 14.0876C194.495 30.135 166.752 28.4038 150.658 10.2044L70.5145 -80.6058C54.4672 -98.8052 56.1982 -126.549 74.3977 -142.643C92.5971 -158.737 120.341 -156.959 136.435 -138.76L216.578 -47.9496C232.625 -29.7502 230.894 -2.00648 212.695 14.0876Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M182.799 -135.11L180.319 -75.6463L161.511 -95.7641L134.423 -100.583L182.846 -135.11H182.799ZM153.698 -35.5047C160.576 -12.2524 147.289 12.2163 124.037 19.0938L7.8688 53.4808C-15.3835 60.3582 -39.8521 47.0712 -46.7295 23.819C-53.607 0.566696 -40.32 -23.9019 -17.0677 -30.7793L99.1 -65.1665C122.352 -72.0439 146.821 -58.7569 153.698 -35.5047Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-30.6348 261.488L15.4487 223.826L12.9223 251.242L27.3321 274.681L-30.6348 261.488ZM63.1229 217.042C75.942 196.41 103.031 190.094 123.616 202.913L226.497 266.821C247.129 279.641 253.445 306.729 240.626 327.315C227.807 347.9 200.718 354.263 180.133 341.444L77.252 277.535C56.6197 264.716 50.3037 237.627 63.1229 217.042Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.694 251.008L121.604 244.084L143.078 226.82L149.909 200.153L180.74 251.008H180.694ZM83.5207 214.563C59.8006 219.709 36.408 204.644 31.2617 180.924L5.6233 62.5572C0.476927 38.8371 15.5418 15.4446 39.2619 10.2982C62.982 5.15185 86.3746 20.2167 91.521 43.9368L117.159 162.303C122.306 186.023 107.241 209.416 83.5207 214.563Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.3669 177.649L-41.8165 171.52L-20.576 153.976L-14.1196 127.214L17.3669 177.649ZM-80.2739 142.466C-103.9 147.94 -127.527 133.156 -132.954 109.53L-160.183 -8.50961C-165.657 -32.1361 -150.873 -55.7626 -127.246 -61.1897C-103.62 -66.6168 -79.9932 -51.8795 -74.5661 -28.253L-47.3371 89.7862C-41.8632 113.413 -56.6474 137.039 -80.2739 142.466Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-82.1914 12.9181L-22.6806 12.076L-41.7222 31.9598L-45.0439 59.2823L-82.1914 12.8713V12.9181ZM18.8646 36.4978C41.6958 28.3104 66.8663 40.2407 75.0538 63.0719L115.85 177.134C124.038 199.966 112.108 225.136 89.2764 233.323C66.4452 241.511 41.2748 229.581 33.0874 206.749L-7.70933 92.6869C-15.8967 69.8557 -3.96655 44.6852 18.8646 36.4978Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M385.613 251.382L370.268 193.883L394.222 207.498L421.544 203.989L385.66 251.382H385.613ZM383.695 147.613C370.174 127.448 375.554 100.172 395.719 86.6514L496.307 19.1872C516.471 5.6663 543.747 11.0466 557.268 31.2111C570.789 51.3755 565.409 78.6513 545.244 92.1722L444.656 159.636C424.492 173.157 397.216 167.777 383.695 147.613Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.238 236.739L233.327 195.708L232.86 223.264L249 245.581L190.191 236.785L190.238 236.739ZM280.393 185.322C291.622 163.801 318.149 155.426 339.67 166.654L447.089 222.61C468.61 233.838 476.985 260.365 465.756 281.886C454.528 303.408 428.001 311.782 406.479 300.554L299.061 244.599C277.539 233.37 269.165 206.843 280.393 185.322Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-28.8574 -61.5641L27.0509 -81.9157L15.6353 -56.8387L21.5303 -29.9372L-28.8574 -61.5172V-61.5641ZM74.3508 -72.6521C93.252 -87.9041 120.902 -84.9566 136.154 -66.0554L212.227 28.17C227.479 47.0712 224.531 74.7214 205.63 89.9733C186.729 105.225 159.079 102.278 143.827 83.3766L67.7541 -10.8489C52.5021 -29.7501 55.4496 -57.4002 74.3508 -72.6521Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M527.326 364.93L468.143 358.801L489.383 341.257L495.839 314.496L527.326 364.93ZM429.685 329.748C406.059 335.222 382.432 320.437 377.005 296.811L349.776 178.772C344.302 155.145 359.086 131.519 382.713 126.092C406.339 120.664 429.966 135.402 435.393 159.028L462.622 277.067C468.096 300.694 453.312 324.321 429.685 329.748Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M427.768 200.199L487.278 199.357L468.237 219.241L464.915 246.564L427.768 200.153V200.199ZM528.824 223.732C551.655 215.545 576.825 227.475 585.013 250.306L625.809 364.369C633.997 387.2 622.067 412.37 599.235 420.558C576.404 428.745 551.234 416.815 543.046 393.984L502.25 279.921C494.062 257.09 505.993 231.92 528.824 223.732Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M244.883 228.224L296.206 198.141L289.469 224.855L300.089 250.259L244.883 228.224ZM344.442 198.796C360.255 180.409 387.999 178.351 406.385 194.164L498.178 273.184C516.565 288.998 518.623 316.741 502.81 335.128C486.996 353.515 459.253 355.573 440.866 339.76L349.073 260.739C330.687 244.926 328.628 217.182 344.442 198.796Z",
                fill: "#AF59E0"
            })
        ]
    });

});


parcelRegister("7FUnn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7c952e00ff9670b2$export$2e2bcd8739ae039; });
/* divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kbpa7 = parcelRequire("kbpa7");
const $7c952e00ff9670b2$var$dividerStyle = null;
const $7c952e00ff9670b2$var$horizontalStyle = null;
const $7c952e00ff9670b2$var$verticalStyle = null;
const $7c952e00ff9670b2$var$UniformDivider = ({ lineStyle: lineStyle = 'solid', orientation: orientation = 'horizontal' })=>{
    const isVertical = orientation === 'vertical';
    const border = `1px ${lineStyle} ${(0, $kbpa7.wacToken)('color.neutral.light400')}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
        role: "presentation",
        style: isVertical ? {
            borderInlineStart: border
        } : {
            borderBlockStart: border
        },
        className: (0, $2jatx.default)([
            "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            isVertical ? "_1bsbidpf _4t3i1wug _1wpz1fhb" : "_1bsb1osq"
        ])
    });
};
var $7c952e00ff9670b2$export$2e2bcd8739ae039 = $7c952e00ff9670b2$var$UniformDivider;

});

parcelRegister("2540f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b007b6ae3baf0cb1$export$2e2bcd8739ae039; });
/* download-row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");
const $b007b6ae3baf0cb1$var$rowStyle = null;
const $b007b6ae3baf0cb1$var$versionContainerStyle = null;
const $b007b6ae3baf0cb1$var$releaseNotesStyle = null;
const $b007b6ae3baf0cb1$var$cellStyle = null;
const $b007b6ae3baf0cb1$var$firstCellStyle = null;
const $b007b6ae3baf0cb1$var$UniformDownloadRow = ({ size: size, date: date })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
        className: (0, $2jatx.default)([
            "_vwz4kb7n _ect4q6fz _syazkhc1 _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _179r87ef"
        ]),
        style: {
            "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "_y3gn1e5h",
                    "p"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                            name: "version"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("small", {
                            className: (0, $2jatx.default)([
                                "_1wyb1wqq _1pfhi2wt"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                name: "releaseNotes"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: size
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: date
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: "format"
                })
            })
        ]
    });
};
var $b007b6ae3baf0cb1$export$2e2bcd8739ae039 = $b007b6ae3baf0cb1$var$UniformDownloadRow;

});

parcelRegister("j6nXt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $368a77dca296ff8b$export$2e2bcd8739ae039; });
/* download-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");
const $368a77dca296ff8b$var$containerStyle = null;
const $368a77dca296ff8b$var$titleStyle = null;
const $368a77dca296ff8b$var$tableStyle = null;
const $368a77dca296ff8b$var$headStyle = null;
const $368a77dca296ff8b$var$bodyStyle = null;
const $368a77dca296ff8b$var$UniformDownloadTable = ({ title: title })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyr7vkz _18u0idpf _k48p8n31 _1wyb1q5e"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
                className: (0, $2jatx.default)([
                    "_vwz4kb7n _ect4q6fz _syazkhc1 _1bsb1osq _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _yq5hcfaq _btyzidpf _6rth1tcg"
                ]),
                style: {
                    "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
                        className: (0, $2jatx.default)([
                            "_vwz4kb7n _ect4q6fz _syazkhc1 _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _n7zl87ef _1fr819bv _1160ftgi _lxpr19bv _il49ftgi _xhev1h6o _7dd61e5h"
                        ]),
                        style: {
                            "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: "Version"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: "Size"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: "Build Date"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: "Format"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                        className: (0, $2jatx.default)([
                            "_vwz4kb7n _ect4q6fz _syazkhc1 _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1a0z87ef _1czs19bv _ayjoftgi _7zpg19bv _3m4tftgi _1omddkka _ue361afi"
                        ]),
                        style: {
                            "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000')),
                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                            name: "downloadrow"
                        })
                    })
                ]
            })
        ]
    });
};
var $368a77dca296ff8b$export$2e2bcd8739ae039 = $368a77dca296ff8b$var$UniformDownloadTable;

});

parcelRegister("kud54", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $889c79622319a8f8$export$2e2bcd8739ae039; });
/* email-subscription-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $4gHHI = parcelRequire("4gHHI");

var $gKcsN = parcelRequire("gKcsN");

var $gfYxt = parcelRequire("gfYxt");

var $71xev = parcelRequire("71xev");

var $h6e9s = parcelRequire("h6e9s");
const $889c79622319a8f8$var$UniformEmailSubscriptionForm = (props)=>{
    const { formId: formId, showPrivacyAgreement: showPrivacyAgreement = false, placeholderText: placeholderText, orientation: orientation = 'horizontal', buttonVariant: buttonVariant = 'primary' } = props;
    const intl = (0, $8e22h.default)();
    const privacyPolicyHref = (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy');
    const consentConfig = (0, $4gHHI.useConsentConfig)();
    const productFamilyHref = (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy/product-family');
    const partnersHref = (0, $jQ0cd.useLocalizedHref)('/partners');
    const inputRef = (0, $1oC0p.useRef)(null);
    const [email, setEmail] = (0, $1oC0p.useState)('');
    const [isEmailInvalid, setIsEmailInvalid] = (0, $1oC0p.useState)(false);
    const [hasMarketingOptIn, setHasMarketingOptIn] = (0, $1oC0p.useState)(false);
    const inputId = `${(0, $1oC0p.useId)().replace(/:/g, '')}-email-subscription`;
    const errorId = `${inputId}-error`;
    const showMarketingOptIn = Boolean(consentConfig.localeRequiresMarketingCommunicationOptIn);
    const label = intl.formatMessage((0, $71xev.emailSubscriptionFormMessages).emailLabel);
    const placeholder = placeholderText?.trim() || intl.formatMessage((0, $71xev.emailSubscriptionFormMessages).emailPlaceholder);
    const { consentLabelText: consentLabelText, privacyPolicyText: privacyPolicyText } = (0, $gfYxt.buildConsentTexts)({
        intl: intl,
        showMarketingOptIn: showMarketingOptIn,
        showPrivacyAgreement: showPrivacyAgreement,
        privacyPolicyHref: privacyPolicyHref,
        productFamilyHref: productFamilyHref,
        partnersHref: partnersHref
    });
    const { status: status, submit: submit, reset: reset } = (0, $gKcsN.useSubmitEmailSubscription)({
        formId: formId,
        consentConfig: consentConfig,
        consentLabelText: consentLabelText,
        privacyPolicyText: privacyPolicyText
    });
    const isPending = status === 'pending';
    const isSuccess = status === 'success';
    const statusMessage = (0, $h6e9s.getStatusMessage)({
        intl: intl,
        isEmailInvalid: isEmailInvalid,
        status: status
    });
    const handleSubmit = (event)=>{
        event.preventDefault();
        if (isPending) return;
        if (!$889c79622319a8f8$var$isValidEmail(email)) {
            setIsEmailInvalid(true);
            inputRef.current?.focus();
            return;
        }
        setIsEmailInvalid(false);
        // Locales that don't require an explicit opt-in consent implicitly.
        submit({
            email: email,
            hasMarketingOptIn: showMarketingOptIn ? hasMarketingOptIn : true
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
            "data-testid": "uniform-email-subscription-form",
            noValidate: true,
            onSubmit: handleSubmit,
            className: (0, $2jatx.default)([
                "_syaz1pfd _1e0c11p5 _ect4z4z1 _zulputpp _yv0ehkll _1bsb1osq",
                orientation === 'horizontal' && "_1j8b1ghl"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                    htmlFor: inputId,
                    className: (0, $2jatx.default)([
                        "_4t3it94y _1e021cib _1reo15vq _18m915vq _kqswstnw _1bsbt94y"
                    ]),
                    children: label
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                    "aria-describedby": isEmailInvalid ? errorId : undefined,
                    "aria-invalid": isEmailInvalid,
                    autoComplete: "email",
                    id: inputId,
                    name: "email",
                    onChange: (event)=>{
                        setEmail(event.target.value);
                        setIsEmailInvalid(false);
                        reset();
                    },
                    placeholder: placeholder,
                    ref: inputRef,
                    type: "email",
                    value: email,
                    className: (0, $2jatx.default)([
                        "_r06hglyw _bfhk1afi _19it79pa _2rko1ylz _vchhusvi _syaz1pfd _16jlkb7n _1o9zkb7n _i0dl1wug _ect4z4z1 _1wyb1j6v _vwz41k8s _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1tke1jfw _1ul9idpf _1yt4s8vo _858u5hrz _7ehi1ju4 _nt751r31 _49pcglyw _1hvw1o36 _srxe1d19 _1qo0p6ku"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                        "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                        "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                    }
                }),
                statusMessage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h6e9s.EmailSubscriptionStatusMessage), {
                    errorId: errorId,
                    message: statusMessage
                }),
                showPrivacyAgreement && !isSuccess && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_yyhyjvu9",
                        "_1e0c1ule _1wyboxwj _vwz41k92 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...(0, $71xev.emailSubscriptionFormMessages).privacyAgreement,
                        values: {
                            // eslint-disable-next-line react/no-unstable-nested-components
                            link: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: privacyPolicyHref,
                                    className: (0, $2jatx.default)([
                                        "_syaz5hrz"
                                    ]),
                                    style: {
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                    },
                                    children: chunks
                                })
                        }
                    })
                }),
                showMarketingOptIn && !isSuccess && /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                    className: (0, $2jatx.default)([
                        "_yyhyjvu9",
                        "_4cvr1y6m _1e0c1txw _1wyboxwj _zulpu2gc _vwz41k92"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                            checked: hasMarketingOptIn,
                            name: "marketingOptIn",
                            onChange: (event)=>setHasMarketingOptIn(event.target.checked),
                            type: "checkbox",
                            className: (0, $2jatx.default)([
                                "_12yz5hrz _16jlidpf _1o9zidpf _i0dl1wug _4t3ipxbi _18s81c53 _1bsbpxbi"
                            ]),
                            style: {
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $71xev.emailSubscriptionFormMessages).marketingOptIn,
                                values: {
                                    // eslint-disable-next-line react/no-unstable-nested-components
                                    atlassianLink: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                            href: productFamilyHref,
                                            className: (0, $2jatx.default)([
                                                "_syaz5hrz"
                                            ]),
                                            style: {
                                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                            },
                                            children: chunks
                                        }),
                                    // eslint-disable-next-line react/no-unstable-nested-components
                                    partnersLink: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                            href: partnersHref,
                                            className: (0, $2jatx.default)([
                                                "_syaz5hrz"
                                            ]),
                                            style: {
                                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                            },
                                            children: chunks
                                        })
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                    isDisabled: isPending,
                    isLoading: isPending,
                    size: "large",
                    type: "submit",
                    variant: buttonVariant,
                    className: (0, $2jatx.default)([
                        "_yyhyjvu9",
                        orientation === 'horizontal' && "_1b1qcs5v _fythkb7n"
                    ]),
                    children: intl.formatMessage((0, $71xev.emailSubscriptionFormMessages).subscribeButton)
                })
            ]
        })
    });
};
var $889c79622319a8f8$export$2e2bcd8739ae039 = $889c79622319a8f8$var$UniformEmailSubscriptionForm;
const $889c79622319a8f8$var$EMAIL_PATTERN = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
const $889c79622319a8f8$var$isValidEmail = (email)=>$889c79622319a8f8$var$EMAIL_PATTERN.test(email.trim());
// The submit button is last in the DOM so it stays at the bottom whenever the
// form is stacked; the horizontal layout lifts it back beside the input.
const $889c79622319a8f8$var$formCss = null;
const $889c79622319a8f8$var$horizontalFormCss = null;
const $889c79622319a8f8$var$fullRowCss = null;
const $889c79622319a8f8$var$submitCss = null;
const $889c79622319a8f8$var$horizontalSubmitCss = null;
const $889c79622319a8f8$var$inputCss = null;
// Rendered on spans rather than paragraphs: TypographyStyles targets `p` as a
// descendant, which outranks a single class and would reset size and colour.
const $889c79622319a8f8$var$messageCss = null;
const $889c79622319a8f8$var$privacyLinkCss = null;
const $889c79622319a8f8$var$marketingOptInLabelCss = null;
const $889c79622319a8f8$var$checkboxCss = null;
const $889c79622319a8f8$var$visuallyHiddenCss = null;

});
parcelRegister("4gHHI", function(module, exports) {
$parcel$export(module.exports, "useConsentConfig", function () { return $39f7f6fd1c21288a$export$aca08a5ed2e2f2d9; });

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");
// Matches the consent-hub fallback: assume opt-in is required until we know otherwise.
const $39f7f6fd1c21288a$var$DEFAULT_CONSENT_CONFIG = {
    locale: 'UNKNOWN',
    localeRequiresMarketingCommunicationOptIn: true
};
const $39f7f6fd1c21288a$export$aca08a5ed2e2f2d9 = ()=>{
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const [consentConfig, setConsentConfig] = (0, $1oC0p.useState)($39f7f6fd1c21288a$var$DEFAULT_CONSENT_CONFIG);
    (0, $1oC0p.useEffect)(()=>{
        let isSubscribed = true;
        stargateClient?.getConsentConfig().then((config)=>{
            if (isSubscribed && config) setConsentConfig(config);
        }).catch(()=>{
        // Keep DEFAULT_CONSENT_CONFIG.
        });
        return ()=>{
            isSubscribed = false;
        };
    }, [
        stargateClient
    ]);
    return consentConfig;
};

});

parcelRegister("gKcsN", function(module, exports) {
$parcel$export(module.exports, "useSubmitEmailSubscription", function () { return $21a355db391ce39d$export$a798f3ea306034c1; });

var $1oC0p = parcelRequire("1oC0p");

var $hhv63 = parcelRequire("hhv63");

var $5Ntyw = parcelRequire("5Ntyw");
const $21a355db391ce39d$export$a798f3ea306034c1 = (args)=>{
    const { formId: formId, consentConfig: consentConfig, consentLabelText: consentLabelText, privacyPolicyText: privacyPolicyText } = args;
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const submit = (0, $1oC0p.useCallback)(async (submitArgs)=>{
        const { email: email, hasMarketingOptIn: hasMarketingOptIn } = submitArgs;
        setStatus('pending');
        try {
            const responseStatus = await (0, $hhv63.updatePreferences)(stargateClient, {
                formId: formId,
                email: email.trim(),
                formUrl: window.location.href,
                site: 'atlassian',
                source: 'uniform',
                consentCheckboxValue: hasMarketingOptIn,
                consentLabelText: consentLabelText,
                privacyPolicyText: privacyPolicyText
            }, consentConfig);
            // updateConsentPreferences resolves with the raw HTTP status rather than throwing.
            if (typeof responseStatus === 'number' && (responseStatus < 200 || responseStatus >= 300)) throw new Error(`Consent preferences update failed with status ${responseStatus}`);
            setStatus('success');
        } catch  {
            setStatus('error');
        }
    }, [
        stargateClient,
        formId,
        consentConfig,
        consentLabelText,
        privacyPolicyText
    ]);
    const reset = (0, $1oC0p.useCallback)(()=>setStatus('idle'), []);
    return {
        status: status,
        submit: submit,
        reset: reset
    };
};

});

parcelRegister("gfYxt", function(module, exports) {
$parcel$export(module.exports, "buildConsentTexts", function () { return $531d808933238b74$export$65e0c515013e82a9; });

var $71xev = parcelRequire("71xev");
const $531d808933238b74$export$65e0c515013e82a9 = (args)=>{
    const { intl: intl, showMarketingOptIn: showMarketingOptIn, showPrivacyAgreement: showPrivacyAgreement, privacyPolicyHref: privacyPolicyHref, productFamilyHref: productFamilyHref, partnersHref: partnersHref } = args;
    const consentLabel = intl.formatMessage((0, $71xev.emailSubscriptionFormMessages).marketingOptIn, {
        atlassianLink: (chunks)=>`<a href="${productFamilyHref}">${chunks.join('')}</a>`,
        partnersLink: (chunks)=>`<a href="${partnersHref}">${chunks.join('')}</a>`
    });
    const privacyAgreement = intl.formatMessage((0, $71xev.emailSubscriptionFormMessages).privacyAgreement, {
        link: (chunks)=>`<a href="${privacyPolicyHref}" target="_blank">${chunks.join('')}</a>`
    });
    return {
        consentLabelText: showMarketingOptIn ? `<p>${consentLabel}</p>\n` : '',
        privacyPolicyText: showPrivacyAgreement ? `<p>${privacyAgreement}</p>\n` : ''
    };
};

});
parcelRegister("71xev", function(module, exports) {
$parcel$export(module.exports, "emailSubscriptionFormMessages", function () { return $ab58df25674bbac0$export$b4d74ac0236eafae; });

var $fnHPc = parcelRequire("fnHPc");
const $ab58df25674bbac0$export$b4d74ac0236eafae = (0, $fnHPc.defineMessages)({
    emailLabel: {
        id: 'uniform.emailSubscriptionForm.emailLabel',
        defaultMessage: 'Email address'
    },
    emailPlaceholder: {
        id: 'uniform.emailSubscriptionForm.emailPlaceholder',
        defaultMessage: 'Email address'
    },
    subscribeButton: {
        id: 'uniform.emailSubscriptionForm.subscribeButton',
        defaultMessage: 'Subscribe'
    },
    privacyAgreement: {
        id: 'uniform.emailSubscriptionForm.privacyAgreement',
        defaultMessage: "By signing up on this form, I acknowledge Atlassian\u2019s <link>Privacy Policy</link>."
    },
    marketingOptIn: {
        id: 'uniform.emailSubscriptionForm.marketingOptIn',
        defaultMessage: 'Yes, I would like to receive promotional emails including product news, events, and more from <atlassianLink>Atlassian</atlassianLink> and <partnersLink>Atlassian Partners</partnersLink>.'
    },
    invalidEmail: {
        id: 'uniform.emailSubscriptionForm.validation.invalidEmail',
        defaultMessage: 'Please provide a valid email address'
    },
    unexpectedError: {
        id: 'uniform.emailSubscriptionForm.validation.unexpectedError',
        defaultMessage: 'An unexpected error occurred'
    },
    success: {
        id: 'uniform.emailSubscriptionForm.success',
        defaultMessage: 'You are now subscribed! Your email preferences can be updated in your Atlassian account settings.'
    }
});

});


parcelRegister("h6e9s", function(module, exports) {
$parcel$export(module.exports, "getStatusMessage", function () { return $5557c6ef37c72272$export$e238a77ea3a8cd66; });
$parcel$export(module.exports, "EmailSubscriptionStatusMessage", function () { return $5557c6ef37c72272$export$f87368385c13eb17; });
/* status-message.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $71xev = parcelRequire("71xev");
const $5557c6ef37c72272$export$e238a77ea3a8cd66 = (args)=>{
    const { intl: intl, isEmailInvalid: isEmailInvalid, status: status } = args;
    if (isEmailInvalid) return {
        text: intl.formatMessage((0, $71xev.emailSubscriptionFormMessages).invalidEmail),
        tone: 'error'
    };
    if (status === 'error') return {
        text: intl.formatMessage((0, $71xev.emailSubscriptionFormMessages).unexpectedError),
        tone: 'error'
    };
    if (status === 'success') return {
        text: intl.formatMessage((0, $71xev.emailSubscriptionFormMessages).success),
        tone: 'success'
    };
    return undefined;
};
const $5557c6ef37c72272$export$f87368385c13eb17 = (props)=>{
    const { errorId: errorId, message: message } = props;
    const isError = message.tone === 'error';
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-live": isError ? undefined : 'polite',
        id: isError ? errorId : undefined,
        role: isError ? 'alert' : 'status',
        className: (0, $2jatx.default)([
            "_1e0c1ule _1wyboxwj _yyhyjvu9 _vwz41k92 _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            isError && "_syaz1d19"
        ]),
        style: {
            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
        },
        children: message.text
    });
};
// A span rather than a paragraph: TypographyStyles targets `p` as a descendant,
// which outranks a single class and would reset size and colour. Spans the form's
// grid so it always sits on its own row.
const $5557c6ef37c72272$var$statusMessageCss = null;
const $5557c6ef37c72272$var$errorCss = null;

});


parcelRegister("8JW63", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6316a05e55dc2e95$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $6iX8D = parcelRequire("6iX8D");
const $6316a05e55dc2e95$var$UniformEmbeddedVideo = ({ url: url, title: title, thumbnailSrc: thumbnailSrc, thumbnailAlt: thumbnailAlt = '', videoType: videoType, roundedCorners: roundedCorners, aspectRatio: aspectRatio })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.EmbeddedVideo), {
        embedUrl: url,
        title: title,
        thumbnail: {
            src: thumbnailSrc ? thumbnailSrc : '',
            alt: thumbnailAlt
        },
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event-component': 'embeddedVideo',
            'data-event-container': 'video',
            'data-event': 'clicked',
            'data-track-event': 'videoPlayed'
        },
        videoType: videoType || undefined,
        roundedCorners: roundedCorners,
        aspectRatio: aspectRatio
    });
};
var $6316a05e55dc2e95$export$2e2bcd8739ae039 = $6316a05e55dc2e95$var$UniformEmbeddedVideo;

});

parcelRegister("jK7xK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dd4891ef82d7897a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $9NH4m = parcelRequire("9NH4m");
const $dd4891ef82d7897a$var$UniformEnhancedBanner = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9NH4m.EnhancedBanner), {
        ...props
    });
};
var $dd4891ef82d7897a$export$2e2bcd8739ae039 = $dd4891ef82d7897a$var$UniformEnhancedBanner;

});
parcelRegister("9NH4m", function(module, exports) {
$parcel$export(module.exports, "EnhancedBanner", function () { return $e32bc15c33666fdb$export$7fd4670b036c3898; });
/* enhanced-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $dE0sS = parcelRequire("dE0sS");

var $jsxHL = parcelRequire("jsxHL");

var $2gCne = parcelRequire("2gCne");
const $e32bc15c33666fdb$var$scrollUpTwoScreens = null;
const $e32bc15c33666fdb$var$containerStyles = null;
const $e32bc15c33666fdb$var$enhancedBannerRowStyles = null;
const $e32bc15c33666fdb$var$desktopContainerStyles = null;
const $e32bc15c33666fdb$var$mobileContainerStyles = null;
const $e32bc15c33666fdb$var$leftDesign = null;
const $e32bc15c33666fdb$var$leftDesignDesktopStyles = null;
const $e32bc15c33666fdb$var$leftDesignTabletStyles = null;
const $e32bc15c33666fdb$var$leftDesignMobileStyles = null;
const $e32bc15c33666fdb$var$bgTileStyles = null;
const $e32bc15c33666fdb$var$desktopLogoStyles = null;
const $e32bc15c33666fdb$var$marqueeContainerStyles = null;
const $e32bc15c33666fdb$var$marqueeItemStyle = null;
const $e32bc15c33666fdb$var$marqueeItem1Styles = null;
const $e32bc15c33666fdb$var$marqueeItem2Styles = null;
const $e32bc15c33666fdb$var$contentStyles = null;
const $e32bc15c33666fdb$var$textColorStyles = null;
const $e32bc15c33666fdb$var$headingStyle = null;
const $e32bc15c33666fdb$var$subheadingStyle = null;
const $e32bc15c33666fdb$var$lineStyle = null;
const $e32bc15c33666fdb$var$closeStyles = null;
const $e32bc15c33666fdb$export$7fd4670b036c3898 = (props)=>{
    const identifier = props.uniqueIdentifier || props.heading.replace(/\s+/g, '-').toLowerCase();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const uniqueId = (0, $1oC0p.useId)();
    const headingDesktopId = `enhanced-banner-heading-desktop-${uniqueId}`;
    const headingMobileId = `enhanced-banner-heading-mobile-${uniqueId}`;
    const productKey = props.productKey || 'home';
    const backgroundColor = props.backgroundColor || 'lightBlue';
    const bgColorToken = backgroundColor === 'lightBlue' ? (0, $kbpa7.wacToken)('color.extended.blue100') : backgroundColor === 'black' ? (0, $kbpa7.wacToken)('color.primary.black') : (0, $kbpa7.wacToken)('color.primary.blue');
    const textColor = backgroundColor === 'black' || backgroundColor === 'primaryBlue' ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.primary.black');
    const getShapeColor = (colorValue)=>{
        if (!colorValue) return (0, $kbpa7.wacToken)('color.extended.blue100');
        if (colorValue.startsWith('neutral-')) {
            const tokenPath = `color.${colorValue.replace('-', '.')}`;
            return (0, $kbpa7.wacToken)(tokenPath);
        }
        if (colorValue.startsWith('secondary-')) {
            const tokenPath = `color.${colorValue.replace('-', '.')}`;
            return (0, $kbpa7.wacToken)(tokenPath);
        }
        const tokenPath = `color.extended.${colorValue}`;
        return (0, $kbpa7.wacToken)(tokenPath);
    };
    const shapeColor1 = getShapeColor(props.shapeColor1 || 'saffron400');
    const shapeColor2 = getShapeColor(props.shapeColor2 || 'neutral-light0');
    const shapeColor3 = getShapeColor(props.shapeColor3 || 'lime500');
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        const dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== '1') setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const closeIconDataEventProps = {
        'data-product-key': productKey,
        'data-event-component': 'button',
        'data-event-container': 'announcementBanner',
        'data-event': 'clicked',
        'data-label': 'Close',
        'data-label-english': 'Close'
    };
    const ctaDataEventProps = {
        'data-product-key': productKey,
        'data-event-component': 'linkButton',
        'data-event-container': 'announcementBanner',
        'data-event': 'clicked'
    };
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-dismissed": isHidden ? 'true' : undefined,
            "data-testid": "enhanced-banner-container",
            className: (0, $2jatx.default)([
                "_kqswh2mm _1reo15vq _18m915vq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1pbykb7n _v56413z6 _bozgclpc _pvnyglyw _uk5lglyw _1rms4d55 _9zij10j7 _mg4c1llu _flocglyw _1g2m1ule _1mu0l1r9 _qbomglyw _19goglyw _1nqt1ule _nzmgglyw",
                "_bfhk18du _syaz1u00",
                "banner-enhanced"
            ]),
            style: {
                '--enhanced-banner-text-color': textColor,
                "--_y0rkh8": (0, $6ZVlx.default)(bgColorToken),
                "--_srel9g": (0, $6ZVlx.default)(textColor)
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1cclidpf _1e02idpf _rjxpidpf _v5641c4t _4t3i1osq",
                        "_1bsbp3fh",
                        "left-design design-desktop"
                    ]),
                    children: props.backgroundImageDesktop ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _4t3i1osq _1lrw1dfr _ouxl1osq _12vemgnk",
                            "bg-tile"
                        ]),
                        style: {
                            backgroundImage: `url(${props.backgroundImageDesktop})`
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                        version: "1.2",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 180 80",
                        width: "240",
                        height: "100%",
                        preserveAspectRatio: "none",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                fill: shapeColor2,
                                d: "m121.4-2.6l-22.5 74.9c38.6-29.9 51.7-40.6 81.6-75.8z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                fill: shapeColor1,
                                d: "m134.6 0l2.7 43.2-42.3 39.8-95-3v-80z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                fill: shapeColor3,
                                d: "m81.3 85.5c9.4-5.9 18.4-12.1 26.9-18.6 10.2-7.9 29.1-24.9 29.1-24.9l2.7 46.5z"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1cclidpf _1e02idpf _rjxpidpf _v5641c4t _4t3i1osq",
                        "_1bsb68cl",
                        "left-design design-tablet"
                    ]),
                    children: props.backgroundImageTablet ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _4t3i1osq _1lrw1dfr _ouxl1osq _12vemgnk",
                            "bg-tile"
                        ]),
                        style: {
                            backgroundImage: `url(${props.backgroundImageTablet})`
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                        version: "1.2",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 120 144",
                        width: "120",
                        height: "100%",
                        preserveAspectRatio: "none",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                fill: shapeColor2,
                                d: "m63.3 149c23.7-54 44.3-120.4 56.7-154.6l-123.4 2 0.3 147.6z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                fill: shapeColor1,
                                d: "m88.7-7.7l4.7 144.7-33.4 12-63.2-1.1 3.2-147.9z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                fill: shapeColor3,
                                d: "m57.7 147.8q7.5-13.1 14.4-27.4 10.3-21.4 19.2-45.2l3.7 72.8z"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1cclidpf _1e02idpf _rjxpidpf _v5641c4t _4t3i1osq",
                        "_1bsbvbgk",
                        "left-design design-mobile"
                    ]),
                    children: props.backgroundImageMobile ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _4t3i1osq _1lrw1dfr _ouxl1osq _12vemgnk",
                            "bg-tile"
                        ]),
                        style: {
                            backgroundImage: `url(${props.backgroundImageMobile})`
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                        version: "1.2",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 64 108",
                        width: "64",
                        height: "100%",
                        preserveAspectRatio: "none",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                fill: shapeColor2,
                                d: "m-6.2 108h38.2c13.2-39.6 22.8-67.5 33.1-114l-74 0.8z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                fill: shapeColor1,
                                d: "m49.2 111.9l-1.2-115.9h-48v112z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                fill: shapeColor3,
                                d: "m29.9 113q4.5-10.8 8.6-22.7 5.4-16 10.2-33.9l3.3 55.6z"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_16jlkb7n _1e0c1txw _1bsb1osq _2lx2vrvc _zulpxy5q _y4tiys9h _kqswh2mm",
                        "enhanced-banner-row"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx2vrvc _zulpxy5q _1bsb1osq _kqswh2mm _6rth12gs _zxndglyw",
                                    "desktop-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                            src: props.logoSrc,
                                            alt: props.logoAlt,
                                            style: {
                                                maxWidth: '200px',
                                                height: props.logoHeight ?? '40px',
                                                width: 'auto'
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1moupxbi _gx38t94y _ngwonqa1 _c71l1osq _zxndglyw",
                                            "line"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1rjcpxbi _1bsb1osq _1e0c1txw _16jlkb7n _2lx2vrvc _1bah1yb4 _4cvr1h6o _zulpxy5q _l60l1bp4 _1huu1y6m _18tvutpp _17951h6o _1bl2idpf"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                        "data-color": backgroundColor,
                                                        className: (0, $2jatx.default)([
                                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pwu06 _1pbykb7n",
                                                            "_14d71pfd _4bef1afi _1n8e1afi"
                                                        ]),
                                                        style: {
                                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                                        },
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                                            id: headingDesktopId,
                                                            children: props.heading
                                                        })
                                                    }),
                                                    props.subheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                        "data-color": backgroundColor,
                                                        className: (0, $2jatx.default)([
                                                            "_18s8hq3d _1pbykb7n",
                                                            "_14d71pfd _4bef1afi _1n8e1afi"
                                                        ]),
                                                        style: {
                                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                                        },
                                                        children: props.subheading
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                ariaLabelledby: headingDesktopId,
                                                "aria-label": props.ctaLinkText,
                                                bgColor: backgroundColor === 'black' || backgroundColor === 'primaryBlue' ? 'bgBlackBlue' : 'bgWhite',
                                                text: props.ctaLinkText,
                                                href: props.ctaLinkHref,
                                                type: "primary",
                                                dataEventProps: {
                                                    ...ctaDataEventProps
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1e0cglyw _1bsb1osq _2lx21bp4 _4cvr1h6o _zulppxbi _zxnd1txw",
                                    "mobile-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _p12f1osq _18zrpxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _j7hqq126 _5sag1onc",
                                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                                        src: props.logoSrc,
                                                        alt: props.logoAlt,
                                                        style: {
                                                            maxWidth: '200px',
                                                            height: props.logoHeight ?? '40px',
                                                            width: 'auto'
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _j7hqq126 _5sag1onc",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju25i11n"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                        "data-color": backgroundColor,
                                                        className: (0, $2jatx.default)([
                                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pwu06 _1pbykb7n",
                                                            "_14d71pfd _4bef1afi _1n8e1afi"
                                                        ]),
                                                        style: {
                                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                                        },
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                                            id: headingMobileId,
                                                            children: props.heading
                                                        })
                                                    }),
                                                    (props.subheadingMobile || props.subheading) && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                        "data-color": backgroundColor,
                                                        className: (0, $2jatx.default)([
                                                            "_18s8hq3d _1pbykb7n",
                                                            "_14d71pfd _4bef1afi _1n8e1afi"
                                                        ]),
                                                        style: {
                                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                                        },
                                                        children: props.subheadingMobile || props.subheading
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        ariaLabelledby: headingMobileId,
                                        "aria-label": props.ctaLinkText,
                                        bgColor: backgroundColor === 'black' || backgroundColor === 'primaryBlue' ? 'bgBlackBlue' : 'bgWhite',
                                        text: props.ctaLinkText,
                                        href: props.ctaLinkHref,
                                        type: "primary",
                                        dataEventProps: {
                                            ...ctaDataEventProps
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    className: (0, $2jatx.default)([
                        "_19itidpf _r06hglyw _bfhk1j28 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1pbykb7n _152tidpf _rjxpidpf _18s8pxbi _d4ksjs25 _1ygb12rt _1ah3yh40",
                        "close-button-symbol"
                    ]),
                    "data-testid": "close-button",
                    "aria-label": intl.formatMessage({
                        id: 'uniform.enhanced-banner.close.aria-label',
                        defaultMessage: 'Close'
                    }),
                    style: {
                        color: textColor
                    },
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, '1');
                    },
                    ...closeIconDataEventProps,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
                        size: "24"
                    })
                })
            ]
        })
    });
};

});


parcelRegister("856b3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b78c67bf5af211c6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $g3AHF = parcelRequire("g3AHF");

var $lTkkF = parcelRequire("lTkkF");
const $b78c67bf5af211c6$var$UniformExpand = (props)=>{
    const expandProps = {
        eventDataName: props.eventDataName ?? undefined,
        chevronColor: props.chevronColor,
        boldLabel: props.richText ? false : props.boldLabel,
        label: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.label,
        expandedLabelText: props.expandedLabelText ?? null
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3AHF.Expand), {
        ...expandProps,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "contents"
        })
    });
};
var $b78c67bf5af211c6$export$2e2bcd8739ae039 = $b78c67bf5af211c6$var$UniformExpand;

});

parcelRegister("2bofd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6173395c20c30f5b$export$2e2bcd8739ae039; });
/* experiment.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $Fp3mL = parcelRequire("Fp3mL");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $izdHQ = parcelRequire("izdHQ");

var $eRzlV = parcelRequire("eRzlV");

var $e61Ln = parcelRequire("e61Ln");

var $6ZCEA = parcelRequire("6ZCEA");
const $6173395c20c30f5b$var$WRAPPER_STYLES = null;
const $6173395c20c30f5b$var$renderSlot = (variant)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: variant
    });
const $6173395c20c30f5b$var$getSelectedVariantFromExperimentStatus = (experimentStatus)=>experimentStatus.type === 'enrolled' && experimentStatus.value ? 'treatment' : 'control';
const $6173395c20c30f5b$var$getActiveVariant = ({ manualOverride: manualOverride, propOverride: propOverride, experimentStatus: experimentStatus })=>{
    if (manualOverride) return manualOverride;
    if (propOverride) return propOverride;
    if (experimentStatus) return $6173395c20c30f5b$var$getSelectedVariantFromExperimentStatus(experimentStatus);
    return 'control';
};
const $6173395c20c30f5b$var$UniformExperiment = (props)=>{
    const { experimentId: experimentId, override: override, postExperimentationMode: postExperimentationMode, bypassManifest: bypassManifest = false } = props;
    if (bypassManifest) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6ZCEA.default), {
        experimentId: experimentId,
        override: override,
        postExperimentationMode: postExperimentationMode
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($6173395c20c30f5b$var$UniformExperimentWithManifest, {
        ...props
    });
};
const $6173395c20c30f5b$var$UniformExperimentWithManifest = (props)=>{
    const { experimentId: experimentId, override: override, postExperimentationMode: postExperimentationMode } = props;
    const isProd = (0, $eRzlV.isProduction)();
    const experiment = Object.entries((0, $4X0dO.experiments)).find(([, value])=>value.experimentName === experimentId)?.[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks -- intentional: experiment is stable per render, this is safe
    const experimentStatus = experiment ? // oxlint-disable-next-line react-hooks/rules-of-hooks
    (0, $gIKKj.useExperiment)(experiment) : undefined;
    const [manualOverride, setManualOverride] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        setManualOverride(null);
    }, [
        experimentId
    ]);
    if (postExperimentationMode) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: experimentId,
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "treatment"
        })
    });
    if (!isProd) {
        const activeVariant = $6173395c20c30f5b$var$getActiveVariant({
            manualOverride: manualOverride,
            propOverride: override,
            experimentStatus: experimentStatus
        });
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e61Ln.default), {
                    experimentId: experimentId,
                    selectedVariant: manualOverride,
                    setSelectedVariant: setManualOverride
                }),
                !experiment && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Fp3mL.ManifestErrorMessage), {
                    id: experimentId
                }),
                $6173395c20c30f5b$var$renderSlot(activeVariant)
            ]
        });
    }
    if (!experiment || !experimentStatus) return $6173395c20c30f5b$var$renderSlot('control');
    return $6173395c20c30f5b$var$renderSlot($6173395c20c30f5b$var$getSelectedVariantFromExperimentStatus(experimentStatus));
};
var $6173395c20c30f5b$export$2e2bcd8739ae039 = $6173395c20c30f5b$var$UniformExperiment;

});
parcelRegister("Fp3mL", function(module, exports) {
$parcel$export(module.exports, "ManifestErrorMessage", function () { return $080833fa2bf97116$export$702dc26c1a322512; });

var $7VQPk = parcelRequire("7VQPk");

var $8S1MN = parcelRequire("8S1MN");
const $080833fa2bf97116$export$702dc26c1a322512 = ({ id: id })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: id.length === 0 ? null : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8S1MN.default), {
            appearance: "error",
            isDismissible: true,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                        children: "Manifest entry not found for:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7VQPk.jsx)("code", {
                        children: id
                    }),
                    ". Rendering control slot."
                ]
            })
        })
    });
};

});

parcelRegister("e61Ln", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6a2f274f0a5e2609$export$2e2bcd8739ae039; });
/* experiment-override-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $6a2f274f0a5e2609$var$PANEL_STYLES = null;
const $6a2f274f0a5e2609$var$PANEL_EXPANDED_STYLES = null;
const $6a2f274f0a5e2609$var$META_STYLES = null;
const $6a2f274f0a5e2609$var$EXPERIMENT_ID_STYLES = null;
const $6a2f274f0a5e2609$var$BUTTON_CLUSTER_STYLES = null;
const $6a2f274f0a5e2609$var$BUTTON_CLUSTER_COLLAPSED_STYLES = null;
const $6a2f274f0a5e2609$var$BUTTON_CLUSTER_EXPANDED_STYLES = null;
const $6a2f274f0a5e2609$var$VARIANT_BUTTON_STYLES = null;
const $6a2f274f0a5e2609$var$SELECTED_VARIANT_BUTTON_STYLES = null;
const $6a2f274f0a5e2609$var$UNSELECTED_VARIANT_BUTTON_STYLES = null;
const $6a2f274f0a5e2609$var$getDisplayedExperimentLabel = (experimentId, isExpanded)=>{
    if (isExpanded) return experimentId;
    return experimentId.length > 14 ? `${experimentId.slice(0, 14)}\u{2026}` : experimentId;
};
const $6a2f274f0a5e2609$var$getVariantButtonText = (variant)=>variant === 'control' ? 'Control' : 'Treatment';
const $6a2f274f0a5e2609$var$getVariantButtonAriaLabel = (variant)=>variant === 'control' ? 'Show control (Original experience)' : 'Show treatment (Experiment experience)';
const $6a2f274f0a5e2609$var$getVariantDescription = (variant)=>variant === 'control' ? 'Original experience' : 'Experiment experience';
const $6a2f274f0a5e2609$var$VARIANTS = [
    'control',
    'treatment'
];
const $6a2f274f0a5e2609$var$renderVariantButton = (variant, selectedVariant, setSelectedVariant)=>{
    const isSelected = selectedVariant === variant;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        "aria-pressed": isSelected,
        "aria-label": $6a2f274f0a5e2609$var$getVariantButtonAriaLabel(variant),
        title: $6a2f274f0a5e2609$var$getVariantDescription(variant),
        onClick: ()=>setSelectedVariant(isSelected ? null : variant),
        className: (0, $2jatx.default)([
            "_19itidpf _2rkow7q6 _1ul91oqx _1yt41ppf _1wyb19bv _vwz4cjiy _80omtlke _k48p1fw0 _v564t6js _1llw1qs1 _1ygb7g83 _1ah3yh40",
            isSelected ? "_syazi7uo _bfhkvuon" : "_syaz15cr _bfhk1j28 _tzy4q80t"
        ]),
        children: $6a2f274f0a5e2609$var$getVariantButtonText(variant)
    }, variant);
};
const $6a2f274f0a5e2609$var$ExperimentOverrideControls = ({ experimentId: experimentId, selectedVariant: selectedVariant, setSelectedVariant: setSelectedVariant })=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const handleActivate = ()=>{
        setIsExpanded(true);
    };
    const handleDeactivate = ()=>{
        setIsExpanded(false);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "experiment-controls",
        onMouseEnter: handleActivate,
        onMouseLeave: handleDeactivate,
        onFocus: handleActivate,
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) handleDeactivate();
        },
        className: (0, $2jatx.default)([
            "_kqswstnw _152t1b66 _rjxp1b66 _1pbyrpof _1e0c116y _4cvr1h6o _1bahesu3 _gy1p1b66 _syaz15cr _19itidpf _16qs130s _8hrz11aj _2rko7vkz _p12f163w _1yt4u49m _bfhkculw _18k91p0y _tzy4x7ai _1reo15vq _18m915vq _v5641pcj",
            isExpanded && "_1pby14ny _p12fsb0t _1yt412x7 _bfhkculw _18k91m5u _tzy4kb7n"
        ]),
        style: {
            "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug _ae4v1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    title: `Experiment ID: ${experimentId}`,
                    "aria-label": `Experiment override for ${experimentId}`,
                    className: (0, $2jatx.default)([
                        "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wyb1skh _vwz4cjiy _k48p1fw0 _1ul9idpf _p12f1osq"
                    ]),
                    children: $6a2f274f0a5e2609$var$getDisplayedExperimentLabel(experimentId, isExpanded)
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "group",
                "aria-label": "Experiment variant override",
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _gy1pv77o _1yt4v77o _2rkow7q6 _1o9zidpf _v564ke4q",
                    isExpanded ? "_bfhk89wr" : "_bfhk89wr"
                ]),
                style: {
                    "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800'))
                },
                children: $6a2f274f0a5e2609$var$VARIANTS.map((variant)=>$6a2f274f0a5e2609$var$renderVariantButton(variant, selectedVariant, setSelectedVariant))
            })
        ]
    });
};
var $6a2f274f0a5e2609$export$2e2bcd8739ae039 = $6a2f274f0a5e2609$var$ExperimentOverrideControls;

});

parcelRegister("6ZCEA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $50bacc736c956db5$export$2e2bcd8739ae039; });
/* experiment-without-manifest.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $gIKKj = parcelRequire("gIKKj");

var $izdHQ = parcelRequire("izdHQ");

var $eRzlV = parcelRequire("eRzlV");

var $e61Ln = parcelRequire("e61Ln");

var $ct34K = parcelRequire("ct34K");
const $50bacc736c956db5$var$WRAPPER_STYLES = null;
const $50bacc736c956db5$var$renderSlot = (variant)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: variant
    });
const $50bacc736c956db5$var$getActiveVariant = ({ manualOverride: manualOverride, propOverride: propOverride, enrolledVariant: enrolledVariant })=>{
    if (manualOverride) return manualOverride;
    if (propOverride) return propOverride;
    return enrolledVariant;
};
const $50bacc736c956db5$var$UniformExperimentWithoutManifest = (props)=>{
    const { experimentId: experimentId, parameterName: parameterName, valueType: valueType, treatmentValues: treatmentValues, targetedPathnames: targetedPathnames, audience: audience, deferExposure: deferExposure, override: override, postExperimentationMode: postExperimentationMode } = props;
    const isProd = (0, $eRzlV.isProduction)();
    const experiment = (0, $ct34K.useUniformExperimentConfig)({
        experimentId: experimentId,
        parameterName: parameterName,
        valueType: valueType,
        treatmentValues: treatmentValues,
        targetedPathnames: targetedPathnames,
        audience: audience,
        deferExposure: deferExposure || postExperimentationMode
    });
    const experimentStatus = (0, $gIKKj.useExperiment)(experiment);
    const [manualOverride, setManualOverride] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        setManualOverride(null);
    }, [
        experimentId
    ]);
    const enrolledVariant = experimentStatus.type === 'enrolled' && (0, $ct34K.isTreatmentValue)({
        value: experimentStatus.value,
        valueType: valueType,
        treatmentValues: treatmentValues
    }) ? 'treatment' : 'control';
    if (postExperimentationMode) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: experimentId,
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "treatment"
        })
    });
    if (!isProd) {
        const activeVariant = $50bacc736c956db5$var$getActiveVariant({
            manualOverride: manualOverride,
            propOverride: override,
            enrolledVariant: enrolledVariant
        });
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e61Ln.default), {
                    experimentId: experimentId,
                    selectedVariant: manualOverride,
                    setSelectedVariant: setManualOverride
                }),
                $50bacc736c956db5$var$renderSlot(activeVariant)
            ]
        });
    }
    return $50bacc736c956db5$var$renderSlot(enrolledVariant);
};
var $50bacc736c956db5$export$2e2bcd8739ae039 = $50bacc736c956db5$var$UniformExperimentWithoutManifest;

});
parcelRegister("ct34K", function(module, exports) {
$parcel$export(module.exports, "useUniformExperimentConfig", function () { return $7444ece4491d7673$export$dc746328149ee01a; });
$parcel$export(module.exports, "isTreatmentValue", function () { return $7444ece4491d7673$export$5a4f7fe29df813b; });

var $2WL8B = parcelRequire("2WL8B");
const $7444ece4491d7673$export$61a8a9ab6a24ef2e = 'control';
function $7444ece4491d7673$export$dc746328149ee01a(args) {
    const { experimentId: experimentId, parameterName: parameterName = 'isEnabled', valueType: valueType = 'boolean', treatmentValues: treatmentValues = '', targetedPathnames: targetedPathnames = '', audience: audience = 'all', deferExposure: deferExposure = false, description: description = `Experiment configured in Uniform (${experimentId})`, expectedReleaseDate: expectedReleaseDate = 'unknown - configured in Uniform', expectedRuntime: expectedRuntime = 'unknown - configured in Uniform' } = args;
    const targetedPathnameList = $7444ece4491d7673$var$parseCommaSeparatedList(targetedPathnames);
    const treatmentValueList = $7444ece4491d7673$var$parseCommaSeparatedList(treatmentValues);
    const matchesTargetedPathname = (0, $2WL8B.useLocalizedPathnames)(targetedPathnameList);
    const isLoggedOut = (0, $2WL8B.useLoggedOut)();
    const isLoggedIn = (0, $2WL8B.useLoggedIn)();
    const hasExperimentId = experimentId.length > 0;
    const matchesAudience = $7444ece4491d7673$var$resolveAudienceMatch({
        audience: audience,
        isLoggedIn: isLoggedIn,
        isLoggedOut: isLoggedOut
    });
    const matchesPathname = targetedPathnameList.length === 0 || matchesTargetedPathname;
    const isInCohort = $7444ece4491d7673$var$resolveCohort({
        hasExperimentId: hasExperimentId,
        matchesAudience: matchesAudience,
        matchesPathname: matchesPathname
    });
    return {
        experimentName: experimentId,
        parameterName: parameterName || 'isEnabled',
        defaultValue: valueType === 'string' ? $7444ece4491d7673$export$61a8a9ab6a24ef2e : false,
        options: {
            fireExperimentExposure: !deferExposure && hasExperimentId,
            typeGuard: $7444ece4491d7673$var$createTypeGuard({
                valueType: valueType,
                treatmentValueList: treatmentValueList
            })
        },
        targeting: {
            cohort: ()=>isInCohort
        },
        metadata: {
            description: description,
            expectedReleaseDate: expectedReleaseDate,
            expectedRuntime: expectedRuntime,
            context: {
                urls: targetedPathnameList
            }
        }
    };
}
function $7444ece4491d7673$export$5a4f7fe29df813b(args) {
    const { value: value, valueType: valueType = 'boolean', treatmentValues: treatmentValues } = args;
    if (valueType === 'boolean') return value === true;
    if (typeof value !== 'string' || value.length === 0) return false;
    const treatmentValueList = $7444ece4491d7673$var$parseCommaSeparatedList(treatmentValues);
    if (treatmentValueList.length > 0) return treatmentValueList.includes(value);
    return value !== $7444ece4491d7673$export$61a8a9ab6a24ef2e;
}
function $7444ece4491d7673$var$parseCommaSeparatedList(value) {
    if (!value) return [];
    return value.split(',').map((entry)=>entry.trim()).filter((entry)=>entry.length > 0);
}
function $7444ece4491d7673$var$createTypeGuard(args) {
    const { valueType: valueType, treatmentValueList: treatmentValueList } = args;
    if (valueType === 'boolean') return (value)=>typeof value === 'boolean';
    return (value)=>{
        if (typeof value !== 'string') return false;
        if (treatmentValueList.length === 0) return true;
        return value === $7444ece4491d7673$export$61a8a9ab6a24ef2e || treatmentValueList.includes(value);
    };
}
function $7444ece4491d7673$var$resolveAudienceMatch(args) {
    const { audience: audience, isLoggedIn: isLoggedIn, isLoggedOut: isLoggedOut } = args;
    if (audience === 'loggedOut') return isLoggedOut;
    if (audience === 'loggedIn') return isLoggedIn;
    return true;
}
function $7444ece4491d7673$var$resolveCohort(args) {
    const { hasExperimentId: hasExperimentId, matchesAudience: matchesAudience, matchesPathname: matchesPathname } = args;
    if (!hasExperimentId) return false;
    if (matchesAudience === undefined) return undefined;
    return matchesAudience && matchesPathname;
}

});



parcelRegister("3VYCw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b2cb92c2df40e8d$export$2e2bcd8739ae039; });
/* feature-gate.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $Fp3mL = parcelRequire("Fp3mL");

var $9rnwe = parcelRequire("9rnwe");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $5oDng = parcelRequire("5oDng");
const $9b2cb92c2df40e8d$var$WRAPPER_STYLES = null;
const $9b2cb92c2df40e8d$var$UniformFeatureGate = (props)=>{
    const { featureGateId: featureGateId, override: override } = props;
    const context = (0, $9rnwe.useWAEContextSafe)();
    const isProduction = context?.wacEnvironment === 'production';
    const featureGate = Object.entries((0, $ai3ZP.featureFlags)).find(([, value])=>value.featureFlagName === featureGateId)?.[1];
    const [manualOverride, setManualOverride] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        setManualOverride(null);
    }, [
        featureGateId
    ]);
    if (!isProduction) {
        const activeVariant = (()=>{
            if (manualOverride) return manualOverride;
            if (override) return override;
            if (featureGate) return (0, $cN0Nw.checkFeatureFlagGate)(featureGate) ? 'treatment' : 'control';
            return 'control';
        })();
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5oDng.default), {
                    featureGateId: featureGateId,
                    selectedVariant: manualOverride,
                    setSelectedVariant: setManualOverride
                }),
                !featureGate && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Fp3mL.ManifestErrorMessage), {
                    id: featureGateId
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: activeVariant
                })
            ]
        });
    }
    if (!featureGate) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "control"
    });
    const showTreatment = (0, $cN0Nw.checkFeatureFlagGate)(featureGate);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: showTreatment ? 'treatment' : 'control'
    });
};
var $9b2cb92c2df40e8d$export$2e2bcd8739ae039 = $9b2cb92c2df40e8d$var$UniformFeatureGate;

});
parcelRegister("5oDng", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d53e3d0b3ec2075e$export$2e2bcd8739ae039; });
/* feature-gate-override-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $d53e3d0b3ec2075e$var$PANEL_STYLES = null;
const $d53e3d0b3ec2075e$var$PANEL_EXPANDED_STYLES = null;
const $d53e3d0b3ec2075e$var$META_STYLES = null;
const $d53e3d0b3ec2075e$var$FEATURE_GATE_ID_STYLES = null;
const $d53e3d0b3ec2075e$var$BUTTON_CLUSTER_STYLES = null;
const $d53e3d0b3ec2075e$var$BUTTON_CLUSTER_COLLAPSED_STYLES = null;
const $d53e3d0b3ec2075e$var$BUTTON_CLUSTER_EXPANDED_STYLES = null;
const $d53e3d0b3ec2075e$var$VARIANT_BUTTON_STYLES = null;
const $d53e3d0b3ec2075e$var$SELECTED_VARIANT_BUTTON_STYLES = null;
const $d53e3d0b3ec2075e$var$UNSELECTED_VARIANT_BUTTON_STYLES = null;
const $d53e3d0b3ec2075e$var$getDisplayedFeatureGateLabel = (featureGateId, isExpanded)=>{
    if (!featureGateId) return '';
    if (isExpanded) return featureGateId;
    return featureGateId.length > 14 ? `${featureGateId.slice(0, 14)}\u{2026}` : featureGateId;
};
const $d53e3d0b3ec2075e$var$getVariantButtonText = (variant)=>variant === 'control' ? 'Control' : 'Treatment';
const $d53e3d0b3ec2075e$var$getVariantButtonAriaLabel = (variant)=>variant === 'control' ? 'Show control (Gate off)' : 'Show treatment (Gate on)';
const $d53e3d0b3ec2075e$var$getVariantDescription = (variant)=>variant === 'control' ? 'Gate off' : 'Gate on';
const $d53e3d0b3ec2075e$var$VARIANTS = [
    'control',
    'treatment'
];
const $d53e3d0b3ec2075e$var$renderVariantButton = (variant, selectedVariant, setSelectedVariant)=>{
    const isSelected = selectedVariant === variant;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        "aria-pressed": isSelected,
        "aria-label": $d53e3d0b3ec2075e$var$getVariantButtonAriaLabel(variant),
        title: $d53e3d0b3ec2075e$var$getVariantDescription(variant),
        onClick: ()=>setSelectedVariant(isSelected ? null : variant),
        className: (0, $2jatx.default)([
            "_19itidpf _2rkow7q6 _1ul91oqx _1yt41ppf _1wyb19bv _vwz4cjiy _80omtlke _k48p1fw0 _v564t6js _1llw1qs1 _1ygb7g83 _1ah3yh40",
            isSelected ? "_syazi7uo _bfhkvuon" : "_syaz15cr _bfhk1j28 _tzy4q80t"
        ]),
        children: $d53e3d0b3ec2075e$var$getVariantButtonText(variant)
    }, variant);
};
const $d53e3d0b3ec2075e$var$FeatureGateOverrideControls = ({ featureGateId: featureGateId, selectedVariant: selectedVariant, setSelectedVariant: setSelectedVariant })=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const handleActivate = ()=>{
        setIsExpanded(true);
    };
    const handleDeactivate = ()=>{
        setIsExpanded(false);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "feature-gate-controls",
        onMouseEnter: handleActivate,
        onMouseLeave: handleDeactivate,
        onFocus: handleActivate,
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) handleDeactivate();
        },
        className: (0, $2jatx.default)([
            "_kqswstnw _152t1b66 _rjxp1b66 _1pbyrpof _1e0c116y _4cvr1h6o _1bahesu3 _gy1p1b66 _syaz15cr _19itidpf _16qs130s _8hrz11aj _2rko7vkz _p12f163w _1yt4u49m _bfhkculw _18k91p0y _tzy4x7ai _1reo15vq _18m915vq _v5641pcj",
            isExpanded && "_1pby14ny _p12fsb0t _1yt412x7 _bfhkculw _18k91m5u _tzy4kb7n"
        ]),
        style: {
            "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug _ae4v1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    title: `Feature Gate ID: ${featureGateId}`,
                    className: (0, $2jatx.default)([
                        "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wyb1skh _vwz4cjiy _k48p1fw0 _1ul9idpf _p12f1osq"
                    ]),
                    children: $d53e3d0b3ec2075e$var$getDisplayedFeatureGateLabel(featureGateId, isExpanded)
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "group",
                "aria-label": "Feature gate override",
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _gy1pv77o _1yt4v77o _2rkow7q6 _1o9zidpf _v564ke4q",
                    isExpanded ? "_bfhk89wr" : "_bfhk89wr"
                ]),
                style: {
                    "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800'))
                },
                children: $d53e3d0b3ec2075e$var$VARIANTS.map((variant)=>$d53e3d0b3ec2075e$var$renderVariantButton(variant, selectedVariant, setSelectedVariant))
            })
        ]
    });
};
var $d53e3d0b3ec2075e$export$2e2bcd8739ae039 = $d53e3d0b3ec2075e$var$FeatureGateOverrideControls;

});


parcelRegister("g0xMT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ff1fa21ab21004e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $anFhN = parcelRequire("anFhN");

var $lTkkF = parcelRequire("lTkkF");
const $3ff1fa21ab21004e$var$UniformFeaturesHighlight = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $anFhN.FeaturesHighlight), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkText: props.linkText,
        linkHref: props.linkHref,
        feature1Eyebrow: props.feature1Eyebrow,
        feature1Title: props.feature1Title,
        feature1Body: props.feature1RichText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.feature1RichText
        }) : props.feature1Body,
        feature1ImageSrc: props.feature1ImageSrc,
        feature1ImageAltText: props.feature1ImageAltText,
        feature1VideoSrc: props.feature1VideoSrc,
        feature1VideoAltText: props.feature1VideoAltText,
        feature1VideoPoster: props.feature1VideoPoster,
        feature2Eyebrow: props.feature2Eyebrow,
        feature2Title: props.feature2Title,
        feature2Body: props.feature2RichText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.feature2RichText
        }) : props.feature2Body,
        feature2ImageSrc: props.feature2ImageSrc,
        feature2ImageAltText: props.feature2ImageAltText,
        feature2VideoSrc: props.feature2VideoSrc,
        feature2VideoAltText: props.feature2VideoAltText,
        feature2VideoPoster: props.feature2VideoPoster,
        feature3Eyebrow: props.feature3Eyebrow,
        feature3Title: props.feature3Title,
        feature3Body: props.feature3RichText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.feature3RichText
        }) : props.feature3Body,
        feature3ImageSrc: props.feature3ImageSrc,
        feature3ImageAltText: props.feature3ImageAltText,
        feature3VideoSrc: props.feature3VideoSrc,
        feature3VideoAltText: props.feature3VideoAltText,
        feature3VideoPoster: props.feature3VideoPoster
    });
};
var $3ff1fa21ab21004e$export$2e2bcd8739ae039 = $3ff1fa21ab21004e$var$UniformFeaturesHighlight;

});
parcelRegister("anFhN", function(module, exports) {
$parcel$export(module.exports, "FeaturesHighlight", function () { return $00c15acb18b151d4$export$bf20c48d528647dd; });
/* features-highlight.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $ggSCt = parcelRequire("ggSCt");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $2axoc = parcelRequire("2axoc");

var $iPPTB = parcelRequire("iPPTB");

var $lE15B = parcelRequire("lE15B");

var $kbpa7 = parcelRequire("kbpa7");
const $00c15acb18b151d4$export$bf20c48d528647dd = (props)=>{
    const [activeFeature, setActiveFeature] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const onFeatureSelect = (0, $1oC0p.useCallback)((featureKey)=>{
        setActiveFeature(featureKey);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'tab',
            actionSubjectId: 'featuresHighlightTab',
            source: 'featuresHighlight',
            attributes: {
                label: `feature ${featureKey + 1}`,
                tabIndex: featureKey
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const singleFeature = (content, featureKey)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            onClick: ()=>onFeatureSelect(featureKey),
            onKeyDown: (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onFeatureSelect(featureKey);
                }
            },
            className: (0, $2jatx.default)([
                "_80omtlke _kqswh2mm _u5ggpxbi _11xx5hrz _uoz5x71z _suga1ule _1ygb1qgu _1ah31y44",
                `feature ${activeFeature === featureKey ? 'selected' : ''}`
            ]),
            role: "tab",
            tabIndex: 0,
            style: {
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: [
                activeFeature === featureKey && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1pbykb7n _bfhk5hrz _2rko1y44 _1bsb1osq _4t3iftgi _165t1osq _glteftgi"
                    ]),
                    style: {
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_owpupxbi _6ssjpxbi"
                    ]),
                    children: content
                })
            ]
        });
    const feature1Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        title: props.feature1Title,
        titleAs: "h3",
        text: props.feature1Body,
        eyebrow: props.feature1Eyebrow,
        alignment: "start"
    });
    const feature1Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: props.feature1ImageSrc,
            alt: props.feature1ImageAltText ?? '',
            style: {
                width: '100%',
                height: 'auto'
            }
        },
        style: {
            width: '100%',
            height: 'auto'
        }
    });
    const feature1Video = props.feature1VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature1VideoSrc,
        poster: props.feature1VideoPoster,
        alt: props.feature1VideoAltText ?? ''
    }, "feature1-video") : null;
    const feature2Video = props.feature2VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature2VideoSrc,
        poster: props.feature2VideoPoster,
        alt: props.feature2VideoAltText ?? ''
    }, "feature2-video") : null;
    const feature3Video = props.feature3VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature3VideoSrc,
        poster: props.feature3VideoPoster,
        alt: props.feature3VideoAltText ?? ''
    }, "feature3-video") : null;
    const feature2Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        title: props.feature2Title,
        titleAs: "h3",
        text: props.feature2Body,
        eyebrow: props.feature2Eyebrow,
        alignment: "start"
    });
    const feature2Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: props.feature2ImageSrc,
            alt: props.feature2ImageAltText ?? '',
            style: {
                width: '100%',
                height: 'auto'
            }
        },
        style: {
            width: '100%',
            height: 'auto'
        }
    });
    const feature3Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        title: props.feature3Title,
        titleAs: "h3",
        text: props.feature3Body,
        eyebrow: props.feature3Eyebrow,
        alignment: "start"
    });
    const feature3Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: props.feature3ImageSrc,
            alt: props.feature3ImageAltText ?? '',
            style: {
                width: '100%',
                height: 'auto'
            }
        },
        style: {
            width: '100%',
            height: 'auto'
        }
    });
    const featureTexts = [
        feature1Text,
        feature2Text,
        props.feature3Title && feature3Text
    ];
    const content = [
        props.feature1ImageSrc ? feature1Image : feature1Video,
        props.feature2ImageSrc ? feature2Image : feature2Video,
        props.feature3Title && props.feature3ImageSrc ? feature3Image : feature3Video
    ];
    const sectionContainerStyles = null;
    const topContentContainerStyles = null;
    const featuresContainerStyles = null;
    const imageContainerStyles = null;
    const navDotsContainerStyles = null;
    const navDot = (featureNum)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsbftgi _4t3iftgi _2rko1y44 _bfhk1od7"
            ]),
            style: {
                "--_c46naz": (0, $6ZVlx.default)(featureNum === activeFeature ? (0, $kbpa7.wacToken)('color.primary.black') : (0, $kbpa7.wacToken)('color.neutral.light500'))
            }
        });
    };
    const navDotsContainer = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _zulppxbi _1bah1h6o _1q51pxbi"
            ]),
            children: featureTexts.map((_, index)=>navDot(index))
        });
    const mobileCarouselContainerStyles = null;
    const sliderSettings = {
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (current)=>setActiveFeature(current),
        appendDots: navDotsContainer
    };
    const featureSlideStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_15fl1wug _1d2w1wug _1svy1wug _seov1wug _16imoahv _b8yq1osq _14b51osq _su071wqb _1j8bcx6w _181n11p5 _dwk3usvi _19wg14hz _11mz1tcg _owpu1wqb _10jxzqdx _1vsw1vi7 _suga1txw _1gde1bp4 _1rfm1osq _tnru1osq _8164pxbi _133i1jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1rfm1osq _xlt11ejb _s51szwfg _uoz5179g _1e3ceqnf _1e0c1txw _2lx21bp4 _zulpu2gc _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                        title: props.title,
                        titleAs: "h2",
                        text: props.description,
                        alignment: "center"
                    }),
                    props.linkText && props.linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: props.linkText,
                        href: props.linkHref,
                        "aria-label": props.linkText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tablist",
                className: (0, $2jatx.default)([
                    "_1e3cx71z _dm251txw _1ini1bp4 _kzvi1bgi _1e0cglyw"
                ]),
                children: featureTexts.map((feature, index)=>singleFeature(feature, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tabpanel",
                className: (0, $2jatx.default)([
                    "_1e3cthi2 _165t1osq _uoz5uufb _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: content[activeFeature]
                }, activeFeature)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule",
                    "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw",
                    "slider-container"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), {
                    ...sliderSettings,
                    children: featureTexts.map((feature, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_18zrzwfg _1e0c1txw _2lx21bp4 _zulppxbi"
                            ]),
                            children: [
                                singleFeature(feature, index),
                                content[index]
                            ]
                        }, index))
                })
            })
        ]
    });
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $00c15acb18b151d4$var$slickStyle = null;

});


parcelRegister("76Hra", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9017bbe137d60f3e$export$2e2bcd8739ae039; });
/* filterable-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $7sd2h = parcelRequire("7sd2h");

var $kbpa7 = parcelRequire("kbpa7");

var $17RBn = parcelRequire("17RBn");

var $9rnwe = parcelRequire("9rnwe");

var $k1kqo = parcelRequire("k1kqo");
const $9017bbe137d60f3e$var$PATH_PREFIX = '$:';
const $9017bbe137d60f3e$var$FALLBACK_PATH_SEPARATOR = '||';
const $9017bbe137d60f3e$var$resolveValue = (raw, itemData)=>{
    if (typeof raw !== 'string') return raw;
    if (!raw.startsWith($9017bbe137d60f3e$var$PATH_PREFIX)) return raw;
    const fallbackPaths = raw.slice($9017bbe137d60f3e$var$PATH_PREFIX.length).split($9017bbe137d60f3e$var$FALLBACK_PATH_SEPARATOR).map((path)=>path.trim()).filter(Boolean);
    for (const path of fallbackPaths){
        const value = $9017bbe137d60f3e$var$getByPath(itemData, path);
        if ($9017bbe137d60f3e$var$isPresentValue(value)) return value;
    }
    return undefined;
};
const $9017bbe137d60f3e$var$isPresentValue = (value)=>value !== undefined && value !== null && value !== '';
const $9017bbe137d60f3e$var$DEFAULT_LOCALE = 'en';
const $9017bbe137d60f3e$var$isAbsoluteUrl = (value)=>/^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(value);
const $9017bbe137d60f3e$var$isAlreadyLocalized = (value, locale)=>value === `/${locale}` || value.startsWith(`/${locale}/`);
const $9017bbe137d60f3e$var$withLocalePrefix = (value, locale)=>{
    if (typeof value !== 'string' || value.length === 0) return value;
    if (!locale || locale === $9017bbe137d60f3e$var$DEFAULT_LOCALE) return value;
    if ($9017bbe137d60f3e$var$isAbsoluteUrl(value)) return value;
    if ($9017bbe137d60f3e$var$isAlreadyLocalized(value, locale)) return value;
    const path = value.startsWith('/') ? value : `/${value}`;
    return `/${locale}${path}`;
};
const $9017bbe137d60f3e$var$getByPath = (obj, path)=>{
    if (obj === null || obj === undefined) return undefined;
    return path.split('.').reduce((acc, key)=>acc !== null && acc !== undefined && typeof acc === 'object' ? acc[key] : undefined, obj);
};
const $9017bbe137d60f3e$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $9017bbe137d60f3e$var$getIconUrl = (entry)=>{
    if (typeof entry === 'string' && entry.length > 0) return entry;
    if (!$9017bbe137d60f3e$var$isRecord(entry)) return undefined;
    const linkedIconUrl = $9017bbe137d60f3e$var$getByPath(entry, 'linkedIcon.url');
    if (typeof linkedIconUrl === 'string' && linkedIconUrl.length > 0) return linkedIconUrl;
    const productIconUrl = $9017bbe137d60f3e$var$getByPath(entry, 'fields.icon.fields.file.url');
    return typeof productIconUrl === 'string' && productIconUrl.length > 0 ? productIconUrl : undefined;
};
const $9017bbe137d60f3e$var$normalizeIcons = (value, size, paddingIncluded)=>{
    if (!Array.isArray(value)) return [];
    return value.flatMap((entry)=>{
        const url = $9017bbe137d60f3e$var$getIconUrl(entry);
        return url ? [
            {
                linkedIcon: {
                    url: url,
                    size: size ?? 'x-small',
                    paddingIncluded: paddingIncluded
                }
            }
        ] : [];
    });
};
const $9017bbe137d60f3e$var$getCategoryName = (entry)=>{
    if (typeof entry === 'string' && entry.length > 0) return entry;
    const categoryName = $9017bbe137d60f3e$var$isRecord(entry) ? $9017bbe137d60f3e$var$getByPath(entry, 'fields.categoryNameExternal') : undefined;
    return typeof categoryName === 'string' && categoryName.length > 0 ? categoryName : undefined;
};
const $9017bbe137d60f3e$var$normalizeCategoryNames = (value)=>Array.isArray(value) ? value.flatMap((entry)=>$9017bbe137d60f3e$var$getCategoryName(entry) ?? []) : [];
const $9017bbe137d60f3e$var$CategoryEyebrow = ({ categoryNames: categoryNames })=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-label": categoryNames.join(', '),
        children: categoryNames.map((categoryName, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                children: [
                    index > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        "aria-hidden": "true",
                        children: " \u2022 "
                    }),
                    categoryName
                ]
            }, `${categoryName}-${index}`))
    });
const $9017bbe137d60f3e$var$FilterableCard = (rawProps)=>{
    const itemData = (0, $1oC0p.useContext)((0, $7sd2h.FilterableCardItemDataContext));
    const intlLocale = (0, $17RBn.useLocale)();
    const { locale: contextLocale } = (0, $9rnwe.useWAEContext)();
    const activeLocale = contextLocale ?? intlLocale;
    const resolvedTitle = $9017bbe137d60f3e$var$resolveValue(rawProps.title, itemData);
    const resolvedDataLabelEnglish = $9017bbe137d60f3e$var$resolveValue(rawProps.dataLabelEnglish, itemData) ?? resolvedTitle;
    const resolvedIconSize = $9017bbe137d60f3e$var$resolveValue(rawProps.iconSize, itemData);
    const resolvedIconPaddingIncluded = $9017bbe137d60f3e$var$resolveValue(rawProps.iconPaddingIncluded, itemData);
    const resolvedIcons = $9017bbe137d60f3e$var$normalizeIcons($9017bbe137d60f3e$var$resolveValue(rawProps.icons, itemData), resolvedIconSize, resolvedIconPaddingIncluded);
    const categoryNames = $9017bbe137d60f3e$var$normalizeCategoryNames($9017bbe137d60f3e$var$resolveValue(rawProps.categories, itemData));
    const resolved = {
        alignment: $9017bbe137d60f3e$var$resolveValue(rawProps.alignment, itemData),
        orientation: $9017bbe137d60f3e$var$resolveValue(rawProps.orientation, itemData),
        columns: $9017bbe137d60f3e$var$resolveValue(rawProps.columns, itemData),
        background: $9017bbe137d60f3e$var$resolveValue(rawProps.background, itemData),
        eyebrow: categoryNames.length > 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)($9017bbe137d60f3e$var$CategoryEyebrow, {
            categoryNames: categoryNames
        }) : $9017bbe137d60f3e$var$resolveValue(rawProps.eyebrow, itemData),
        logo: $9017bbe137d60f3e$var$resolveValue(rawProps.logo, itemData),
        title: resolvedTitle,
        titleAs: $9017bbe137d60f3e$var$resolveValue(rawProps.titleAs, itemData),
        // Per-template attribution for the gallery card CTA click event.
        // An explicit dataLabel (incl. a "$:" binding) wins; otherwise fall
        // back to the resolved template title.
        dataLabel: $9017bbe137d60f3e$var$resolveValue(rawProps.dataLabel, itemData) ?? resolvedTitle,
        dataLabelEnglish: resolvedDataLabelEnglish,
        body: $9017bbe137d60f3e$var$resolveValue(rawProps.body, itemData),
        richText: $9017bbe137d60f3e$var$resolveValue(rawProps.richText, itemData),
        linkText: $9017bbe137d60f3e$var$resolveValue(rawProps.linkText, itemData),
        linkUrl: $9017bbe137d60f3e$var$withLocalePrefix($9017bbe137d60f3e$var$resolveValue(rawProps.linkUrl, itemData), activeLocale),
        imageUrl: $9017bbe137d60f3e$var$resolveValue(rawProps.imageUrl, itemData),
        imageAlt: $9017bbe137d60f3e$var$resolveValue(rawProps.imageAlt, itemData),
        iconUrl: $9017bbe137d60f3e$var$resolveValue(rawProps.iconUrl, itemData),
        iconSize: resolvedIconSize,
        iconPaddingIncluded: resolvedIconPaddingIncluded,
        icons: resolvedIcons.length > 0 ? resolvedIcons : undefined,
        spotIllustrationUrl: $9017bbe137d60f3e$var$resolveValue(rawProps.spotIllustrationUrl, itemData),
        spotIllustrationAlt: $9017bbe137d60f3e$var$resolveValue(rawProps.spotIllustrationAlt, itemData),
        spotIllustrationHeight: $9017bbe137d60f3e$var$resolveValue(rawProps.spotIllustrationHeight, itemData)
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3i1osq _1e0c11p5 _1lo71osq _19j31wug _q77bcq2i _5aue1dfr _1uusn17g _iwqy1heu _oop61jhh _whptz4z1 _1kn5dlk8 _9y154jg8 _18nk1nn1 _gdayf6fq _amuvangw _1b8v7vkz"
        ]),
        style: {
            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k1kqo.default), {
            ...resolved
        })
    });
};
// Filterable gallery cards sit in an equal-width, equal-height grid, so the
// card boxes already match. The shared Card renders its image with
// `object-fit: contain`, which letterboxes any source image that is not exactly
// 16:9 — making the *visible* image shorter on some cards than others within the
// same row. Forcing `object-fit: cover` (and filling the 16:9 box height) crops
// the overflow instead, so every card's image renders at the same height.
//
// This override lives here (not in the shared Card) so only the filterable
// gallery is affected. The `css` constant is intentionally local to this file:
// imported Compiled style objects can render without their generated classes in
// the filterable gallery context.
const $9017bbe137d60f3e$var$croppedImageWrapper = null;
var $9017bbe137d60f3e$export$2e2bcd8739ae039 = $9017bbe137d60f3e$var$FilterableCard;

});
parcelRegister("7sd2h", function(module, exports) {
$parcel$export(module.exports, "FilterableCardItemDataContext", function () { return $718a58a0cf5379a0$export$b57146c2dbbd8dd6; });

var $1oC0p = parcelRequire("1oC0p");
const $718a58a0cf5379a0$export$b57146c2dbbd8dd6 = (0, $1oC0p.createContext)(undefined);

});


parcelRegister("89oar", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3fddb102737e1f1a$export$2e2bcd8739ae039; });
/* filterable-gallery.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $01zo5 = parcelRequire("01zo5");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $7sd2h = parcelRequire("7sd2h");

var $foNCS = parcelRequire("foNCS");

var $lG1Of = parcelRequire("lG1Of");

var $Lp2P8 = parcelRequire("Lp2P8");

var $bQjAr = parcelRequire("bQjAr");

var $92PV0 = parcelRequire("92PV0");

var $eUwCn = parcelRequire("eUwCn");

var $sGleB = parcelRequire("sGleB");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $f4mYE = parcelRequire("f4mYE");

var $huvuR = parcelRequire("huvuR");

var $9aC9C = parcelRequire("9aC9C");

var $jh5WI = parcelRequire("jh5WI");

var $eAngy = parcelRequire("eAngy");

var $iPbWG = parcelRequire("iPbWG");

var $ddUw7 = parcelRequire("ddUw7");

var $3MZcV = parcelRequire("3MZcV");

var $H7SCD = parcelRequire("H7SCD");
const $3fddb102737e1f1a$var$DEFAULT_PAGINATION_MODE = 'loadMore';
const $3fddb102737e1f1a$var$messages = (0, $fnHPc.defineMessages)({
    emptyState: {
        id: 'filterable-gallery.empty-state',
        defaultMessage: 'No results found.'
    },
    loadMore: {
        id: 'filterable-gallery.load-more',
        defaultMessage: 'Load more'
    },
    resultsCount: {
        id: 'filterable-gallery.results-count',
        defaultMessage: '{count, plural, one {# result} other {# results}}'
    }
});
const $3fddb102737e1f1a$var$FilterableGallerySlot = ({ items: items, itemDataArrayRef: itemDataArrayRef, searchConfiguration: searchConfiguration, showSearchInput: showSearchInput = true, displayLimit: rawDisplayLimit, rawFilters: rawFilters, rawSorts: rawSorts, urlSync: urlSync, layout: layout, rawFacetDataSources: rawFacetDataSources, pageSize: pageSize, paginationMode: paginationMode, resourceTotal: resourceTotal, loadMoreShowsAll: loadMoreShowsAll, hydrationRef: hydrationRef, dataItems: dataItems, featuredItemSlugs: featuredItemSlugs, loadMoreLabel: loadMoreLabel, emptyStateLabel: emptyStateLabel })=>{
    const intl = (0, $8e22h.default)();
    const isPaginated = $3fddb102737e1f1a$var$getIsPaginated(paginationMode, pageSize);
    // Read once per render. The ref keeps `wrapperComponent` stable, and this stays
    // fresh because the gallery re-renders whenever hydration state changes.
    const hydration = $3fddb102737e1f1a$var$readHydration(hydrationRef);
    const [displayLimitOverrideQuery, setDisplayLimitOverrideQuery] = (0, $1oC0p.useState)();
    const { extraItems: extraItems, isAwaitingBackfill: isAwaitingBackfill } = $3fddb102737e1f1a$var$useFilterableBackfillState();
    const [visibleCount, setVisibleCount] = (0, $1oC0p.useState)(()=>$3fddb102737e1f1a$var$resolveInitialVisibleCount(pageSize, dataItems?.length));
    const registeredItems = itemDataArrayRef.current;
    const itemDataArray = (0, $1oC0p.useMemo)(()=>{
        if (dataItems && dataItems.length > 0) {
            const seenIds = new Set();
            return [
                ...dataItems,
                ...extraItems
            ].filter((item)=>{
                const id = $3fddb102737e1f1a$var$getSysId(item);
                if (!id) return true;
                if (seenIds.has(id)) return false;
                seenIds.add(id);
                return true;
            });
        }
        if (extraItems.length === 0) return registeredItems;
        const seenIds = new Set();
        for (const item of registeredItems){
            const id = $3fddb102737e1f1a$var$getSysId(item);
            if (id) seenIds.add(id);
        }
        const newExtras = extraItems.filter((item)=>{
            const id = $3fddb102737e1f1a$var$getSysId(item);
            return id ? !seenIds.has(id) : true;
        });
        return [
            ...registeredItems,
            ...newExtras
        ];
    }, [
        registeredItems,
        extraItems,
        dataItems
    ]);
    // Publish to the search bar so it searches the identical items + config.
    $3fddb102737e1f1a$var$usePublishGalleryConfig(itemDataArray, searchConfiguration, featuredItemSlugs);
    const canSearch = $3fddb102737e1f1a$var$hasSearchKeys(searchConfiguration);
    const shouldShowSearchInput = $3fddb102737e1f1a$var$resolveBooleanParameter(showSearchInput, true);
    const displayLimit = $3fddb102737e1f1a$var$resolvePositiveIntegerParameter(rawDisplayLimit);
    const skeletonCardCount = $3fddb102737e1f1a$var$resolveSkeletonCardCount(displayLimit, dataItems?.length ?? items.length);
    const filterDefs = (0, $1oC0p.useMemo)(()=>{
        if (!rawFilters) return [];
        const flat = (0, $f2QWG.flattenValues)(rawFilters);
        return Array.isArray(flat) ? flat : [];
    }, [
        rawFilters
    ]);
    const sortDefs = (0, $1oC0p.useMemo)(()=>{
        if (!rawSorts) return [];
        const flat = (0, $f2QWG.flattenValues)(rawSorts);
        return Array.isArray(flat) ? flat : [];
    }, [
        rawSorts
    ]);
    const optionsDataSources = (0, $1oC0p.useMemo)(()=>{
        if (!rawFacetDataSources) return {};
        const rawEntries = $3fddb102737e1f1a$var$getUniformBlockEntries(rawFacetDataSources);
        if (rawEntries.length === 0) return {};
        return Object.fromEntries(rawEntries.flatMap((entry)=>{
            const sourceId = entry.fields?.sourceId?.value;
            const data = entry.fields?.data?.value;
            if (typeof sourceId !== 'string' || !Array.isArray(data)) return [];
            return [
                [
                    sourceId,
                    data
                ]
            ];
        }));
    }, [
        rawFacetDataSources
    ]);
    const { filterObject: filterObject, searchQuery: searchQuery, selectedSortId: selectedSortId, dropdownVisibility: dropdownVisibility, isAnyDropdownOpen: isAnyDropdownOpen, setSearchQuery: setSearchQuery, handleFilterButtonClick: handleFilterButtonClick, toggleFilterOption: toggleFilterOption, clearFilter: clearFilter, clearAllFilters: clearAllFilters, handleSearchSubmit: handleSearchSubmit, handleSearchClear: handleSearchClear, handleSortChange: handleSortChange, closeAllDropdownsAndCommit: closeAllDropdownsAndCommit, urlPage: urlPage, pushPage: pushPage } = (0, $iPbWG.useFilterState)({
        items: itemDataArray,
        filterDefs: filterDefs,
        urlSync: urlSync,
        optionsDataSources: optionsDataSources
    });
    // In paginated mode a search submit lands on page one of the results instead
    // of revealing every match at once.
    const showAllSearchResults = (0, $1oC0p.useCallback)((query)=>{
        if (isPaginated) return;
        const trimmedQuery = query.trim();
        setDisplayLimitOverrideQuery(trimmedQuery);
        setVisibleCount(Infinity);
    }, [
        isPaginated
    ]);
    const handleSearchSubmitAndShowAll = (0, $1oC0p.useCallback)(()=>{
        handleSearchSubmit();
        showAllSearchResults(searchQuery);
    }, [
        handleSearchSubmit,
        searchQuery,
        showAllSearchResults
    ]);
    (0, $1oC0p.useEffect)(()=>(0, $f4mYE.subscribeToShowAllFilterableGalleryItems)(({ query: query })=>{
            setSearchQuery(query);
            showAllSearchResults(query);
        }), [
        setSearchQuery,
        showAllSearchResults
    ]);
    const trimmedSearchQuery = searchQuery.trim();
    const shouldShowAllSearchResults = $3fddb102737e1f1a$var$getShouldShowAllSearchResults(isPaginated, trimmedSearchQuery, displayLimitOverrideQuery);
    (0, $1oC0p.useEffect)(()=>{
        if (isPaginated) return;
        if (shouldShowAllSearchResults) {
            setVisibleCount(Infinity);
            return;
        }
        if (pageSize !== undefined) {
            setVisibleCount(pageSize);
            return;
        }
        if (dataItems !== undefined) setVisibleCount(dataItems.length);
    }, [
        isPaginated,
        filterObject,
        searchQuery,
        pageSize,
        dataItems,
        shouldShowAllSearchResults
    ]);
    const sortedMatchingDataItems = (0, $1oC0p.useMemo)(()=>{
        const filtered = (0, $H7SCD.applyFilters)(itemDataArray, filterDefs, filterObject);
        const selectedSort = sortDefs.find((sort)=>sort.id === selectedSortId);
        // An explicit sort wins; otherwise relevance + featured boost.
        return selectedSort ? (0, $H7SCD.applySort)((0, $H7SCD.applySearch)(filtered, searchQuery, searchConfiguration), selectedSort) : (0, $H7SCD.searchWithFeaturedBoost)(filtered, searchQuery, searchConfiguration, featuredItemSlugs);
    }, [
        itemDataArray,
        filterDefs,
        filterObject,
        searchConfiguration,
        searchQuery,
        sortDefs,
        selectedSortId,
        featuredItemSlugs
    ]);
    const shouldApplyDisplayLimit = $3fddb102737e1f1a$var$getShouldApplyDisplayLimit(displayLimit, shouldShowAllSearchResults);
    const pageState = (0, $3MZcV.useGalleryPagination)({
        isPaginated: isPaginated,
        items: sortedMatchingDataItems,
        loadedItemCount: itemDataArray.length,
        pageSize: pageSize,
        filterObject: filterObject,
        searchQuery: trimmedSearchQuery,
        sortId: selectedSortId,
        urlPage: urlPage,
        hasUnfetchedItems: hydration.hasUnfetchedItems,
        resourceTotal: resourceTotal
    });
    const usesVisibleCount = $3fddb102737e1f1a$var$getUsesVisibleCount(pageSize, dataItems, isPaginated);
    const effectiveVisibleCount = usesVisibleCount ? visibleCount : undefined;
    const visibleDataItems = (0, $1oC0p.useMemo)(()=>isPaginated ? pageState.pageItems : effectiveVisibleCount !== undefined ? sortedMatchingDataItems.slice(0, effectiveVisibleCount) : shouldApplyDisplayLimit ? sortedMatchingDataItems.slice(0, displayLimit) : sortedMatchingDataItems, [
        isPaginated,
        pageState.pageItems,
        effectiveVisibleCount,
        displayLimit,
        shouldApplyDisplayLimit,
        sortedMatchingDataItems
    ]);
    // Two reasons to offer "Load more". Either matching items are loaded but not
    // revealed yet, or a connector resource still holds pages the browser has not
    // fetched. The second one needs no `pageSize`: a gallery that server-renders 9
    // of 304 must offer the button even when all 9 are on screen. Paginated mode
    // has no button: the page controls take over.
    const hasMoreToShow = $3fddb102737e1f1a$var$getHasMoreToShow({
        isPaginated: isPaginated,
        effectiveVisibleCount: effectiveVisibleCount,
        visibleCount: visibleCount,
        matchingCount: sortedMatchingDataItems.length,
        hasUnfetchedItems: hydration.hasUnfetchedItems
    });
    const visibleIndices = (0, $1oC0p.useMemo)(()=>$3fddb102737e1f1a$var$getOrderedIndicesForDataItems(itemDataArray, visibleDataItems), [
        itemDataArray,
        visibleDataItems
    ]);
    const visibleIndexSet = (0, $1oC0p.useMemo)(()=>new Set(visibleIndices), [
        visibleIndices
    ]);
    const labelMaps = (0, $1oC0p.useMemo)(()=>(0, $H7SCD.buildLabelMaps)(itemDataArray, filterDefs, optionsDataSources), [
        itemDataArray,
        filterDefs,
        optionsDataSources
    ]);
    (0, $ddUw7.useOutsideClick)({
        isActive: isAnyDropdownOpen,
        insideMarkerAttribute: (0, $jh5WI.FILTER_DROPDOWN_DATA_ATTR),
        onOutsideClick: closeAllDropdownsAndCommit
    });
    const isRegistered = itemDataArray.length > 0;
    const allSlotItems = (0, $1oC0p.useMemo)(()=>{
        const slotChildren = items;
        const cardTemplate = slotChildren.find((0, $1oC0p.isValidElement));
        if (!cardTemplate) return slotChildren;
        if (dataItems && dataItems.length > 0) return itemDataArray.map((itemData, offset)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7sd2h.FilterableCardItemDataContext).Provider, {
                value: itemData,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1e0c11p5"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(cardTemplate, {
                        key: `data-card-${offset}`
                    })
                })
            }, `data-item-${offset}`));
        const backfilledItems = itemDataArray.slice(registeredItems.length);
        if (backfilledItems.length === 0) return slotChildren;
        const backfillItems = backfilledItems.map((data, offset)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7sd2h.FilterableCardItemDataContext).Provider, {
                value: data,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1e0c11p5"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(cardTemplate, {
                        key: `backfill-card-${offset}`
                    })
                })
            }, `backfill-${offset}`));
        return [
            ...slotChildren,
            ...backfillItems
        ];
    }, [
        items,
        dataItems,
        itemDataArray
    ]);
    const isDataDrivenMode = dataItems !== undefined;
    const orderedItems = (0, $1oC0p.useMemo)(()=>{
        const slotItems = allSlotItems;
        if (!isRegistered) {
            if (isDataDrivenMode) return [];
            return slotItems.map((item, index)=>({
                    index: index,
                    item: item,
                    visible: true
                }));
        }
        const visible = visibleIndices.map((index)=>({
                index: index,
                item: slotItems[index],
                visible: true
            }));
        const hidden = slotItems.map((item, index)=>({
                index: index,
                item: item,
                visible: false
            })).filter(({ index: index })=>!visibleIndexSet.has(index));
        return [
            ...visible,
            ...hidden
        ];
    }, [
        isRegistered,
        isDataDrivenMode,
        allSlotItems,
        visibleIndices,
        visibleIndexSet
    ]);
    const shouldRenderCards = !isAwaitingBackfill;
    const renderedItems = (0, $1oC0p.useMemo)(()=>shouldRenderCards ? orderedItems : [], [
        orderedItems,
        shouldRenderCards
    ]);
    const animatedVisibleIndices = $3fddb102737e1f1a$var$useAnimatedVisibleIndices(shouldRenderCards, visibleIndices);
    // Re-arm WAC click auto-tracking for the gallery's dynamically-rendered
    // controls. `autoTrackLinks`/`autoTrackButtons` run once at app init (analytics
    // initializer) and bind a click listener to every <a>/<button> that exists AT
    // THAT MOMENT — they are not delegated listeners. The gallery's card anchors
    // and the conditionally-rendered "Load more" button mount later and re-render
    // on backfill, search, filter, and "Load more", so without this they never get
    // a listener and clicking them fires no analytics event (despite carrying the
    // correct data-event-* props). Re-calling after each render set change binds
    // the newly mounted elements. Mirrors the same pattern in
    // patterns/global-nav/src/auto-complete-search-bar.tsx and product-navdropdown.
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldRenderCards) return;
        (0, $92PV0.Tracking).autoTrackLinks(true);
        (0, $92PV0.Tracking).autoTrackButtons(true);
    }, [
        shouldRenderCards,
        renderedItems,
        animatedVisibleIndices,
        hasMoreToShow
    ]);
    // After "Load more", move focus to the first newly revealed card so it
    // isn't lost when the button disappears.
    const gallerySlotRef = (0, $1oC0p.useRef)(null);
    const pendingFocusPositionRef = (0, $1oC0p.useRef)(null);
    const { handleLoadMoreClick: handleLoadMoreClick, isLoadMoreBusy: isLoadMoreBusy } = $3fddb102737e1f1a$var$useLoadMore({
        visibleCount: visibleCount,
        setVisibleCount: setVisibleCount,
        pageSize: pageSize,
        loadMoreShowsAll: loadMoreShowsAll,
        hasUnfetchedItems: hydration.hasUnfetchedItems,
        isHydrating: hydration.isHydrating,
        hydrateRest: hydration.hydrateRest,
        pendingFocusPositionRef: pendingFocusPositionRef
    });
    const pendingScrollRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (pendingScrollRef.current) {
            pendingScrollRef.current = false;
            $3fddb102737e1f1a$var$scrollGalleryIntoView(gallerySlotRef.current);
        }
        const firstNewPosition = pendingFocusPositionRef.current;
        if (firstNewPosition === null) return;
        pendingFocusPositionRef.current = null;
        $3fddb102737e1f1a$var$focusGalleryCardAtPosition(gallerySlotRef.current, firstNewPosition);
    }, [
        visibleDataItems
    ]);
    // A page click swaps the whole grid, so the visitor lands at the top of the
    // gallery with focus on the first card of the new page.
    const handlePageChange = (0, $1oC0p.useCallback)((_event, page)=>{
        pendingScrollRef.current = true;
        pendingFocusPositionRef.current = 0;
        pageState.setPage(page);
        pushPage(page);
    }, [
        pageState.setPage,
        pushPage
    ]);
    const loadMoreText = loadMoreLabel ?? intl.formatMessage($3fddb102737e1f1a$var$messages.loadMore);
    const resultsCountText = $3fddb102737e1f1a$var$getResultsCountText(intl, isRegistered, itemDataArray.length, sortedMatchingDataItems.length);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eAngy.Toolbar), {
                    filterDefs: filterDefs,
                    sortDefs: sortDefs,
                    canSearch: canSearch,
                    showSearchInput: shouldShowSearchInput,
                    filterObject: filterObject,
                    searchQuery: searchQuery,
                    selectedSortId: selectedSortId,
                    dropdownVisibility: dropdownVisibility,
                    labelMaps: labelMaps,
                    onSearchChange: setSearchQuery,
                    onSearchSubmit: handleSearchSubmitAndShowAll,
                    onSearchClear: handleSearchClear,
                    onFilterButtonClick: handleFilterButtonClick,
                    onOptionToggle: toggleFilterOption,
                    onClearFilter: clearFilter,
                    onClearAllFilters: clearAllFilters,
                    onSortChange: handleSortChange
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: gallerySlotRef,
                className: (0, $2jatx.default)([
                    "_1pfhxy5q"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        role: "status",
                        "aria-live": "polite",
                        "data-testid": "filterable-gallery-results-count",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1bsbt94y _4t3it94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _ogtohxbz _mkrz1wmp _o5721q9c"
                        ]),
                        children: resultsCountText
                    }),
                    isRegistered && sortedMatchingDataItems.length === 0 && itemDataArray.length > 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        role: "status",
                        "data-testid": "filterable-gallery-empty",
                        className: (0, $2jatx.default)([
                            "_1yt4pxbi _syaz1rpy _zg8l1m30 _y3gn1h6o"
                        ]),
                        children: emptyStateLabel
                    }) : null,
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                        layout: layout,
                        renderAsList: "ul",
                        children: [
                            !shouldRenderCards ? /*#__PURE__*/ (0, $7VQPk.jsx)($3fddb102737e1f1a$var$FilterableGallerySkeletonCards, {
                                count: skeletonCardCount
                            }) : null,
                            renderedItems.map(({ index: index, item: item, visible: visible }, renderIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lG1Of.FilterableItemIndexContext).Provider, {
                                    value: index,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                        hidden: visible ? undefined : true,
                                        style: visible ? $3fddb102737e1f1a$var$getCardEntranceStyle($3fddb102737e1f1a$var$getCardEntranceDelayIndex(renderIndex)) : undefined,
                                        "data-testid": visible ? 'filterable-gallery-item' : undefined,
                                        "data-gallery-card": visible ? '' : undefined,
                                        className: (0, $2jatx.default)([
                                            "_q32d11p5 _8wqw1osq _xqg4glyw",
                                            visible && "_tzy4idpf _t9ec13hh _v564p5ws _m602kb7n _qp04161g _sedtglyw",
                                            visible && animatedVisibleIndices.has(index) && "_tzy4kb7n _t9ec161g"
                                        ]),
                                        children: item
                                    })
                                }, index))
                        ]
                    }),
                    $3fddb102737e1f1a$var$getShouldRenderPagination(isPaginated, pageState.pageCount) && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "filterable-gallery-pagination",
                        "aria-busy": $3fddb102737e1f1a$var$toAriaBusy(hydration.isHydrating),
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1h6o _1bsb1osq _1rjcxy5q"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $sGleB.Pagination), {
                            pages: pageState.pageNumbers,
                            selectedIndex: pageState.currentPage - 1,
                            onChange: handlePageChange
                        })
                    }),
                    hasMoreToShow && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1h6o _1rjcxy5q"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                            type: "button",
                            "data-testid": "load-more-button",
                            onClick: handleLoadMoreClick,
                            disabled: isLoadMoreBusy,
                            "aria-busy": isLoadMoreBusy,
                            "data-event": "clicked",
                            "data-event-component": "button",
                            "data-event-container": "searchWithFilters",
                            "data-label": loadMoreText,
                            "data-label-english": "Load more",
                            className: (0, $2jatx.default)([
                                "_r06hglyw _11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1e0c1txw _4cvr1h6o _zulp1b66"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_4t3i1tcg _1bsb1tcg _1e0c116y _4cvr1h6o"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                                        label: "",
                                        spacing: "spacious"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfht94y _y3gn1e5h",
                                            "body-sm"
                                        ]),
                                        children: loadMoreText
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $3fddb102737e1f1a$var$UniformFilterableGallery = ({ searchConfiguration: searchConfiguration, showSearchInput: showSearchInput = true, displayLimit: displayLimit, filters: rawFilters, sorts: rawSorts, urlSync: urlSync = true, layout: layout = '4-4-4', facetDataSources: rawFacetDataSources, pageSize: rawPageSize, paginationMode: rawPaginationMode, loadMoreShowsAll: rawLoadMoreShowsAll, data: data, featuredItemSlugs: rawFeaturedItemSlugs, loadMoreLabel: loadMoreLabel, emptyStateLabel: emptyStateLabel })=>{
    const intl = (0, $8e22h.default)();
    // CMS-provided label wins (localized on the Uniform side); otherwise fall
    // back to the localized default for the active page locale.
    const resolvedEmptyStateLabel = emptyStateLabel ?? intl.formatMessage($3fddb102737e1f1a$var$messages.emptyState);
    const resolvedLoadMoreLabel = loadMoreLabel ?? intl.formatMessage($3fddb102737e1f1a$var$messages.loadMore);
    const itemDataArrayRef = (0, $1oC0p.useRef)([]);
    const [, setDataVersion] = (0, $1oC0p.useState)(0);
    const insideContainer = (0, $foNCS.useIsInsideLoaderProvider)();
    const pageSize = $3fddb102737e1f1a$var$resolvePositiveIntegerParameter(rawPageSize);
    const paginationMode = $3fddb102737e1f1a$var$resolvePaginationMode(rawPaginationMode);
    // When set, the first "Load more" click reveals every remaining match instead
    // of adding one more page. Pair it with `pageSize` for a short first page.
    const loadMoreShowsAll = $3fddb102737e1f1a$var$resolveBooleanParameter(rawLoadMoreShowsAll, false);
    // A connector gallery needs no container component: the echo is enough to
    // fetch the rest of the set from the browser.
    // The refetch query rides inside the `data` binding, so a resource bound at its
    // root needs no second parameter and no container component. Memoized, because
    // `readQueryEcho` allocates and the hook keys its seed on identity.
    const echo = (0, $1oC0p.useMemo)(()=>(0, $huvuR.readQueryEcho)($3fddb102737e1f1a$var$toQueryEcho(data)), [
        data
    ]);
    const dataItems = (0, $1oC0p.useMemo)(()=>$3fddb102737e1f1a$var$toDataItems(data), [
        data
    ]);
    // A container already owns the loader context, so hydrating here would fetch
    // items the provider below never receives.
    const resourceTotal = $3fddb102737e1f1a$var$toResourceTotal(data);
    // Numbered pages need the whole set for a correct page count and correct
    // filters, so paginated mode fetches the rest on load instead of on a click.
    const hydration = (0, $9aC9C.useConnectorHydration)(insideContainer ? null : echo, {
        total: resourceTotal,
        serverItemCount: dataItems?.length,
        autoLoad: paginationMode === 'paginated'
    });
    const hydrationRef = (0, $1oC0p.useRef)(hydration);
    hydrationRef.current = hydration;
    const featuredItemSlugs = (0, $1oC0p.useMemo)(()=>$3fddb102737e1f1a$var$resolveFeaturedSlugs(rawFeaturedItemSlugs), [
        rawFeaturedItemSlugs
    ]);
    const handleRegistryChange = (0, $1oC0p.useCallback)((data)=>{
        const previousData = itemDataArrayRef.current;
        if (data.length !== previousData.length || data.some((item, index)=>item !== previousData[index])) {
            itemDataArrayRef.current = data;
            setDataVersion((v)=>v + 1);
        }
    }, []);
    const wrapperComponent = (0, $1oC0p.useCallback)((slotProps)=>/*#__PURE__*/ (0, $7VQPk.jsx)($3fddb102737e1f1a$var$FilterableGallerySlot, {
            ...slotProps,
            itemDataArrayRef: itemDataArrayRef,
            searchConfiguration: searchConfiguration,
            showSearchInput: showSearchInput,
            displayLimit: displayLimit,
            rawFilters: rawFilters,
            rawSorts: rawSorts,
            urlSync: urlSync,
            layout: layout,
            rawFacetDataSources: rawFacetDataSources,
            pageSize: pageSize,
            paginationMode: paginationMode,
            resourceTotal: resourceTotal,
            loadMoreShowsAll: loadMoreShowsAll,
            hydrationRef: hydrationRef,
            dataItems: dataItems,
            featuredItemSlugs: featuredItemSlugs,
            loadMoreLabel: resolvedLoadMoreLabel,
            emptyStateLabel: resolvedEmptyStateLabel
        }), [
        searchConfiguration,
        showSearchInput,
        displayLimit,
        rawFilters,
        rawSorts,
        urlSync,
        layout,
        rawFacetDataSources,
        pageSize,
        paginationMode,
        resourceTotal,
        loadMoreShowsAll,
        dataItems,
        featuredItemSlugs,
        resolvedLoadMoreLabel,
        resolvedEmptyStateLabel
    ]);
    const galleryContent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lG1Of.FilterableItemRegistryProvider), {
        onRegistryChange: handleRegistryChange,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "filterableItems",
            wrapperComponent: wrapperComponent
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "uniform-filters",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: insideContainer ? galleryContent : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $foNCS.FilterableGalleryLoaderProvider), {
                extraItems: hydration.items,
                children: galleryContent
            })
        })
    });
};
/**
 * Owns the "Load more" click.
 *
 * A connector gallery fetches its remaining items on the first click. The reveal
 * waits for the last page, so the card entrance animation runs once rather than
 * once for each page that lands. Without a connector resource the click reveals
 * at once, as it always did.
 */ function $3fddb102737e1f1a$var$useLoadMore({ visibleCount: visibleCount, setVisibleCount: setVisibleCount, pageSize: pageSize, loadMoreShowsAll: loadMoreShowsAll, hasUnfetchedItems: hasUnfetchedItems, isHydrating: isHydrating, hydrateRest: hydrateRest, pendingFocusPositionRef: pendingFocusPositionRef }) {
    const [isPendingReveal, setIsPendingReveal] = (0, $1oC0p.useState)(false);
    const revealMore = (0, $1oC0p.useCallback)(()=>{
        setVisibleCount((previousVisibleCount)=>loadMoreShowsAll ? Infinity : $3fddb102737e1f1a$var$getNextVisibleCount(previousVisibleCount, pageSize));
    }, [
        loadMoreShowsAll,
        pageSize,
        setVisibleCount
    ]);
    const handleLoadMoreClick = (0, $1oC0p.useCallback)(()=>{
        pendingFocusPositionRef.current = visibleCount;
        if (hasUnfetchedItems) {
            hydrateRest?.();
            setIsPendingReveal(true);
            return;
        }
        revealMore();
    }, [
        hasUnfetchedItems,
        hydrateRest,
        pendingFocusPositionRef,
        revealMore,
        visibleCount
    ]);
    // The reveal the click deferred, once every page has arrived. `hasUnfetchedItems`
    // also clears when a page fails, so a failed fetch reveals what did arrive and
    // re-enables the button instead of disabling it for the rest of the session.
    (0, $1oC0p.useEffect)(()=>{
        if (!isPendingReveal || hasUnfetchedItems) return;
        setIsPendingReveal(false);
        revealMore();
    }, [
        isPendingReveal,
        hasUnfetchedItems,
        revealMore
    ]);
    return {
        handleLoadMoreClick: handleLoadMoreClick,
        isLoadMoreBusy: isPendingReveal || isHydrating
    };
}
const $3fddb102737e1f1a$var$hasSearchKeys = (searchConfiguration)=>(searchConfiguration?.keys.length ?? 0) > 0;
const $3fddb102737e1f1a$var$resolveBooleanParameter = (parameter, defaultValue)=>{
    if (typeof parameter === 'boolean') return parameter;
    if (typeof parameter?.value === 'boolean') return parameter.value;
    return defaultValue;
};
const $3fddb102737e1f1a$var$resolvePaginationMode = (parameter)=>{
    const rawValue = $3fddb102737e1f1a$var$unwrapParameterValue(parameter);
    return rawValue === 'paginated' ? 'paginated' : $3fddb102737e1f1a$var$DEFAULT_PAGINATION_MODE;
};
const $3fddb102737e1f1a$var$resolvePositiveIntegerParameter = (parameter)=>{
    const rawValue = typeof parameter === 'object' && parameter !== null ? parameter.value : parameter;
    const value = typeof rawValue === 'string' ? Number(rawValue) : rawValue;
    if (typeof value !== 'number' || !Number.isFinite(value)) return undefined;
    const integerValue = Math.floor(value);
    return integerValue > 0 ? integerValue : undefined;
};
const $3fddb102737e1f1a$var$resolveFeaturedSlugs = (parameter)=>{
    const rawValue = $3fddb102737e1f1a$var$unwrapParameterValue(parameter);
    if (!Array.isArray(rawValue)) return [];
    return rawValue.map((0, $H7SCD.normalizeUrlSlug)).filter((slug)=>slug !== undefined);
};
const $3fddb102737e1f1a$var$getOrderedIndicesForDataItems = (sourceDataItems, orderedDataItems)=>{
    const indexMap = new Map();
    sourceDataItems.forEach((dataItem, index)=>{
        const indices = indexMap.get(dataItem) ?? [];
        indices.push(index);
        indexMap.set(dataItem, indices);
    });
    return orderedDataItems.flatMap((dataItem)=>{
        const indices = indexMap.get(dataItem);
        const index = indices?.shift();
        return index === undefined ? [] : [
            index
        ];
    });
};
const $3fddb102737e1f1a$var$SKELETON_CARD_MIN_HEIGHT = 360;
const $3fddb102737e1f1a$var$CARD_ENTRANCE_START_DELAY_MS = 100;
const $3fddb102737e1f1a$var$CARD_ENTRANCE_DELAY_SECONDS = 0.2;
const $3fddb102737e1f1a$var$MAX_CARD_ENTRANCE_DELAY_SECONDS = 1.2;
const $3fddb102737e1f1a$var$MAX_STAGGERED_CARD_COUNT = $3fddb102737e1f1a$var$MAX_CARD_ENTRANCE_DELAY_SECONDS / $3fddb102737e1f1a$var$CARD_ENTRANCE_DELAY_SECONDS + 1;
const $3fddb102737e1f1a$var$FilterableGallerySkeletonCards = ({ count: count })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: Array.from({
            length: count
        }, (_, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                "data-testid": "filterable-gallery-skeleton-item",
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_q32d11p5 _8wqw1osq _xqg4glyw",
                    "_2mzuglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1e0c11p5"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4t3i1osq _1tke1gwv _1reo15vq _18m915vq _bfhkvuon _2rko1ylz _16qst7xp"
                        ]),
                        style: {
                            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_4t3i93m8 _1reo15vq _18m915vq"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                    width: "100%",
                                    height: "100%"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _zulppxbi _1yt41ejb"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                        width: "40%",
                                        height: "16px"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulpu2gc"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                                width: $3fddb102737e1f1a$var$getSkeletonLineWidth(index, 0),
                                                height: "24px"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                                width: $3fddb102737e1f1a$var$getSkeletonLineWidth(index, 1),
                                                height: "24px"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulp12x7 _6rth1wug"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                                width: "100%",
                                                height: "16px"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                                width: $3fddb102737e1f1a$var$getSkeletonLineWidth(index, 2),
                                                height: "16px"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                        width: "32%",
                                        height: "20px"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }, index))
    });
const $3fddb102737e1f1a$var$useAnimatedVisibleIndices = (shouldRenderCards, visibleIndices)=>{
    const [animatedVisibleIndices, setAnimatedVisibleIndices] = (0, $1oC0p.useState)(()=>new Set());
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldRenderCards) {
            setAnimatedVisibleIndices(new Set());
            return;
        }
        const timeoutId = window.setTimeout(()=>{
            setAnimatedVisibleIndices((previousIndices)=>{
                const nextIndices = new Set(previousIndices);
                visibleIndices.forEach((index)=>nextIndices.add(index));
                return nextIndices;
            });
        }, $3fddb102737e1f1a$var$CARD_ENTRANCE_START_DELAY_MS);
        return ()=>window.clearTimeout(timeoutId);
    }, [
        shouldRenderCards,
        visibleIndices
    ]);
    return animatedVisibleIndices;
};
const $3fddb102737e1f1a$var$getSkeletonLineWidth = (index, offset)=>{
    const widths = [
        '82%',
        '64%',
        '92%',
        '56%',
        '74%'
    ];
    return widths[(index + offset) % widths.length] ?? '72%';
};
const $3fddb102737e1f1a$var$getCardEntranceStyle = (index)=>({
        transitionDelay: `${$3fddb102737e1f1a$var$getCardEntranceDelay(index)}s`
    });
const $3fddb102737e1f1a$var$getCardEntranceDelayIndex = (renderIndex)=>renderIndex % $3fddb102737e1f1a$var$MAX_STAGGERED_CARD_COUNT;
const $3fddb102737e1f1a$var$getCardEntranceDelay = (index)=>Math.min($3fddb102737e1f1a$var$CARD_ENTRANCE_DELAY_SECONDS * index, $3fddb102737e1f1a$var$MAX_CARD_ENTRANCE_DELAY_SECONDS);
const $3fddb102737e1f1a$var$resolveSkeletonCardCount = (displayLimit, ssrItemCount)=>displayLimit ?? ssrItemCount;
const $3fddb102737e1f1a$var$getShouldApplyDisplayLimit = (displayLimit, shouldShowAllSearchResults)=>typeof displayLimit === 'number' && !shouldShowAllSearchResults;
const $3fddb102737e1f1a$var$getUsesVisibleCount = (pageSize, dataItems, isPaginated)=>!isPaginated && (pageSize !== undefined || dataItems !== undefined);
const $3fddb102737e1f1a$var$getIsPaginated = (paginationMode, pageSize)=>paginationMode === 'paginated' && pageSize !== undefined;
/** Paginated mode never reveals everything at once: a search lands on page one instead. */ const $3fddb102737e1f1a$var$getShouldShowAllSearchResults = (isPaginated, trimmedSearchQuery, displayLimitOverrideQuery)=>!isPaginated && trimmedSearchQuery.length > 0 && displayLimitOverrideQuery === trimmedSearchQuery;
const $3fddb102737e1f1a$var$getHasMoreToShow = ({ isPaginated: isPaginated, effectiveVisibleCount: effectiveVisibleCount, visibleCount: visibleCount, matchingCount: matchingCount, hasUnfetchedItems: hasUnfetchedItems })=>{
    if (isPaginated) return false;
    if (effectiveVisibleCount !== undefined && visibleCount < matchingCount) return true;
    return hasUnfetchedItems;
};
const $3fddb102737e1f1a$var$getShouldRenderPagination = (isPaginated, pageCount)=>isPaginated && pageCount > 1;
const $3fddb102737e1f1a$var$toAriaBusy = (isBusy)=>isBusy ? true : undefined;
const $3fddb102737e1f1a$var$getNextVisibleCount = (previousVisibleCount, pageSize)=>pageSize !== undefined ? previousVisibleCount + pageSize : Infinity;
/** Live-region count text; empty until items register, and at zero matches (the empty-state status covers that). */ const $3fddb102737e1f1a$var$getResultsCountText = (intl, isRegistered, totalItemCount, matchingCount)=>isRegistered && totalItemCount > 0 && matchingCount > 0 ? intl.formatMessage($3fddb102737e1f1a$var$messages.resultsCount, {
        count: matchingCount
    }) : '';
/** Brings the gallery top into view after a page swap. Instant when the visitor prefers reduced motion. */ const $3fddb102737e1f1a$var$scrollGalleryIntoView = (container)=>{
    if (!container || typeof container.scrollIntoView !== 'function') return;
    const prefersReducedMotion = typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    container.scrollIntoView({
        block: 'start',
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
};
/** Focuses the revealed card (its control, else the card itself) so focus isn't dropped to the page top. */ const $3fddb102737e1f1a$var$focusGalleryCardAtPosition = (container, position)=>{
    if (!container) return;
    const targetCard = container.querySelectorAll('[data-gallery-card]')[position];
    if (!targetCard) return;
    const focusable = targetCard.querySelector('a[href], button, [tabindex]:not([tabindex="-1"])');
    if (focusable) {
        focusable.focus();
        return;
    }
    // Temporary tabindex to focus the non-interactive card; cleared on blur.
    targetCard.tabIndex = -1;
    targetCard.addEventListener('blur', ()=>targetCard.removeAttribute('tabindex'), {
        once: true
    });
    targetCard.focus();
};
const $3fddb102737e1f1a$var$gallerySlotStyle = null;
const $3fddb102737e1f1a$var$emptyStateStyle = null;
const $3fddb102737e1f1a$var$visuallyHiddenStyle = null;
const $3fddb102737e1f1a$var$galleryItemStyle = null;
const $3fddb102737e1f1a$var$galleryItemEntranceStyle = null;
const $3fddb102737e1f1a$var$galleryItemVisibleStyle = null;
const $3fddb102737e1f1a$var$fullHeightCardStyle = null;
const $3fddb102737e1f1a$var$skeletonCardItemStyle = null;
const $3fddb102737e1f1a$var$skeletonCardStyle = null;
const $3fddb102737e1f1a$var$skeletonMediaStyle = null;
const $3fddb102737e1f1a$var$skeletonContentStyle = null;
const $3fddb102737e1f1a$var$skeletonTitleGroupStyle = null;
const $3fddb102737e1f1a$var$skeletonBodyGroupStyle = null;
const $3fddb102737e1f1a$var$paginationStyle = null;
const $3fddb102737e1f1a$var$loadMoreStyle = null;
const $3fddb102737e1f1a$var$loadMoreButtonStyle = null;
const $3fddb102737e1f1a$var$loadMoreChevronStyle = null;
const $3fddb102737e1f1a$var$loadMoreLabelStyle = null;
function $3fddb102737e1f1a$var$resolveInitialVisibleCount(pageSize, dataItemsLength) {
    if (pageSize !== undefined) return pageSize;
    if (dataItemsLength !== undefined) return dataItemsLength;
    return Infinity;
}
/**
 * Read the items out of the `data` binding.
 *
 * Two bindings are supported. `${#jptr:/Query/items}` hands over the array
 * directly. `${#jptr:/Query}` hands over the whole resolved resource, which for a
 * WAE connector resource is `{ sys, total, skip, limit, items, extensions }`.
 * Prefer the second one: it carries the refetch query as well, so the gallery can
 * fetch the rest of the set without a second binding.
 */ function $3fddb102737e1f1a$var$toDataItems(data) {
    if (Array.isArray(data)) return data.length > 0 ? data : undefined;
    // Unwrap a resolved resource, but only one that looks like a Contentful
    // collection: `total` or `sys.type === 'Array'` beside `items`. A narrow test
    // keeps a composition that binds some other object at `data` in the mode it
    // renders in today.
    if ($3fddb102737e1f1a$var$isRecord(data) && Array.isArray(data['items']) && $3fddb102737e1f1a$var$isCollectionEnvelope(data)) {
        const items = data['items'];
        return items.length > 0 ? items : undefined;
    }
    return undefined;
}
const $3fddb102737e1f1a$var$NO_HYDRATION = {
    items: [],
    isHydrating: false,
    error: null,
    done: true,
    hasUnfetchedItems: false,
    hydrateRest: ()=>undefined
};
/** Fully defaulted hydration state, so the slot needs no fallbacks inline. */ function $3fddb102737e1f1a$var$readHydration(ref) {
    return ref?.current ?? $3fddb102737e1f1a$var$NO_HYDRATION;
}
/** `total` from a resolved resource, so hydration knows when there is nothing left. */ function $3fddb102737e1f1a$var$toResourceTotal(data) {
    if (!$3fddb102737e1f1a$var$isRecord(data)) return undefined;
    return typeof data['total'] === 'number' ? data['total'] : undefined;
}
function $3fddb102737e1f1a$var$isCollectionEnvelope(data) {
    if (typeof data['total'] === 'number') return true;
    const sys = data['sys'];
    return $3fddb102737e1f1a$var$isRecord(sys) && sys['type'] === 'Array';
}
/**
 * Read the connector refetch query out of the same `data` binding.
 *
 * The `request` edgehancer echoes the effective query under
 * `extensions.wae`, so a resource bound at its root already carries everything
 * the browser needs to fetch the remaining pages. No second parameter, and no
 * container component.
 */ function $3fddb102737e1f1a$var$toQueryEcho(data) {
    if (!$3fddb102737e1f1a$var$isRecord(data)) return undefined;
    const extensions = data['extensions'];
    return $3fddb102737e1f1a$var$isRecord(extensions) ? extensions['wae'] : undefined;
}
function $3fddb102737e1f1a$var$getUniformBlockEntries(data) {
    const entries = Array.isArray(data) ? data : $3fddb102737e1f1a$var$isRecord(data) && Array.isArray(data['value']) ? data['value'] : [];
    return entries.filter($3fddb102737e1f1a$var$isFacetDataSourceEntry);
}
function $3fddb102737e1f1a$var$isFacetDataSourceEntry(entry) {
    return $3fddb102737e1f1a$var$isRecord(entry);
}
function $3fddb102737e1f1a$var$getSysId(item) {
    if (!$3fddb102737e1f1a$var$isRecord(item)) return undefined;
    const sys = item['sys'];
    if (!$3fddb102737e1f1a$var$isRecord(sys)) return undefined;
    return typeof sys['id'] === 'string' ? sys['id'] : undefined;
}
function $3fddb102737e1f1a$var$unwrapParameterValue(parameter) {
    if (parameter === undefined) return undefined;
    if (typeof parameter !== 'object' || parameter === null) return parameter;
    if (Array.isArray(parameter)) return parameter;
    return parameter.value;
}
function $3fddb102737e1f1a$var$isRecord(value) {
    return typeof value === 'object' && value !== null;
}
/**
 * Publishes the gallery's items + config to the loader context for the search
 * bar. `searchConfiguration`/`featuredItemSlugs` come from Uniform props that
 * aren't guaranteed reference-stable across renders, so this skips `register`
 * when the payload is unchanged — otherwise it sets state on the (ancestor)
 * loader provider every render, which re-renders this component and refires
 * the effect: an infinite update loop.
 */ function $3fddb102737e1f1a$var$usePublishGalleryConfig(items, searchConfiguration, featuredItemSlugs) {
    const register = (0, $foNCS.useFilterableGalleryLoader)()?.registerGalleryConfig;
    // Tracks what THIS hook last published, independent of reading it back off
    // the context it writes to — depending on `galleryConfig` from context
    // instead would refire this effect after every publish (register -> state
    // update -> context value changes -> this re-renders -> deps changed), an
    // extra render/effect cycle purely to re-verify what was just sent.
    const lastPublishedRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (!register) return;
        const next = {
            items: items,
            searchConfiguration: searchConfiguration,
            featuredItemSlugs: featuredItemSlugs
        };
        if ($3fddb102737e1f1a$var$isGalleryConfigEqual(next, lastPublishedRef.current)) return;
        lastPublishedRef.current = next;
        register(next);
    }, [
        register,
        items,
        searchConfiguration,
        featuredItemSlugs
    ]);
}
function $3fddb102737e1f1a$var$isGalleryConfigEqual(next, current) {
    if (!current) return false;
    return next.items === current.items && $3fddb102737e1f1a$var$isSearchConfigurationEqual(next.searchConfiguration, current.searchConfiguration) && $3fddb102737e1f1a$var$isStringArrayEqual(next.featuredItemSlugs, current.featuredItemSlugs);
}
/** Field-by-field, not JSON.stringify — stringify is object-key-order sensitive, which would false-negative on semantically identical configs and re-trigger the update loop this guards against. */ function $3fddb102737e1f1a$var$isSearchConfigurationEqual(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (a.threshold !== b.threshold) return false;
    if (a.ignoreLocation !== b.ignoreLocation) return false;
    if (a.featuredBoost !== b.featuredBoost) return false;
    if (a.keys.length !== b.keys.length) return false;
    return a.keys.every((key, index)=>{
        const other = b.keys[index];
        return other !== undefined && key.name === other.name && key.weight === other.weight;
    });
}
function $3fddb102737e1f1a$var$isStringArrayEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    return a.every((value, index)=>value === b[index]);
}
function $3fddb102737e1f1a$var$useFilterableBackfillState() {
    const loaderContext = (0, $foNCS.useFilterableGalleryLoader)();
    const extraItems = loaderContext?.extraItems ?? [];
    const hasLoaderRegistered = loaderContext?.currentRegistration !== null && loaderContext?.currentRegistration !== undefined;
    const isAwaitingBackfill = hasLoaderRegistered && extraItems.length === 0;
    return {
        extraItems: extraItems,
        isAwaitingBackfill: isAwaitingBackfill
    };
}
var $3fddb102737e1f1a$export$2e2bcd8739ae039 = $3fddb102737e1f1a$var$UniformFilterableGallery;

});
parcelRegister("lG1Of", function(module, exports) {
$parcel$export(module.exports, "FilterableItemIndexContext", function () { return $f4dd86ccea1056a6$export$2284b5017b55f87e; });
$parcel$export(module.exports, "FilterableItemRegistryProvider", function () { return $f4dd86ccea1056a6$export$408e600f5b338e55; });
$parcel$export(module.exports, "useFilterableItemRegistry", function () { return $f4dd86ccea1056a6$export$c3fea36cd05b76e9; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $f4dd86ccea1056a6$export$2284b5017b55f87e = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
const $f4dd86ccea1056a6$var$FilterableItemRegistryContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $f4dd86ccea1056a6$export$408e600f5b338e55 = ({ children: children, onRegistryChange: onRegistryChange })=>{
    const registryRef = (0, $1oC0p.useRef)(new Map());
    const prevDataRef = (0, $1oC0p.useRef)([]);
    const notify = (0, $1oC0p.useCallback)(()=>{
        const sorted = [
            ...registryRef.current.entries()
        ].sort(([a], [b])=>a - b).map(([, data])=>data);
        // Only notify if the data actually changed to prevent infinite re-render loops.
        const prev = prevDataRef.current;
        if (sorted.length === prev.length && sorted.every((d, i)=>d === prev[i])) return;
        prevDataRef.current = sorted;
        onRegistryChange(sorted);
    }, [
        onRegistryChange
    ]);
    const registerItem = (0, $1oC0p.useCallback)((index, data)=>{
        registryRef.current.set(index, data);
        notify();
    }, [
        notify
    ]);
    const unregisterItem = (0, $1oC0p.useCallback)((index)=>{
        registryRef.current.delete(index);
    // Don't notify synchronously on unregister — this runs during React's
    // commit/cleanup phase and calling setState here causes infinite loops.
    // The subsequent registerItem call (when the component remounts or data
    // changes) will notify with the correct up-to-date array.
    }, []);
    const contextValue = (0, $1oC0p.useMemo)(()=>({
            registerItem: registerItem,
            unregisterItem: unregisterItem
        }), [
        registerItem,
        unregisterItem
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f4dd86ccea1056a6$var$FilterableItemRegistryContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $f4dd86ccea1056a6$export$c3fea36cd05b76e9 = ()=>(0, $1oC0p.useContext)($f4dd86ccea1056a6$var$FilterableItemRegistryContext);

});

parcelRegister("sGleB", function(module, exports) {
$parcel$export(module.exports, "Pagination", function () { return $d54cd1250a40cc23$export$68f5e1453c188a82; });
/* pagination.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $clnBI = parcelRequire("clnBI");

var $Lp2P8 = parcelRequire("Lp2P8");

var $kbpa7 = parcelRequire("kbpa7");
// WAC Foundations "Page-level Pagination" spec. Two sizes, no prop: Large from the
// `sm` breakpoint up (20px numbers, 24px between arrows and numbers, 32px around),
// Regular below it (16px numbers, 16px between arrows and numbers, 4px sides).
// Below `xs` the gallery mock also drops every page except the first, last and
// current one, and tightens the gap to 8px, so the control fits a 375px viewport.
const $d54cd1250a40cc23$var$FONT_WEIGHT_SEMIBOLD = 600;
const $d54cd1250a40cc23$var$ELLIPSIS_OPACITY = 0.6;
const $d54cd1250a40cc23$var$baseStyles = null;
const $d54cd1250a40cc23$var$innerContainerStyles = null;
const $d54cd1250a40cc23$var$pagesContainerStyles = null;
const $d54cd1250a40cc23$var$numberTextStyles = null;
const $d54cd1250a40cc23$var$pageButtonStyles = null;
const $d54cd1250a40cc23$var$mobileHiddenStyles = null;
const $d54cd1250a40cc23$var$navigatorStyles = null;
const $d54cd1250a40cc23$var$ellipsisStyles = null;
// Stands in for pages the `xs` rule hides when no regular ellipsis sits beside them.
const $d54cd1250a40cc23$var$mobileEllipsisStyles = null;
const $d54cd1250a40cc23$var$ELLIPSIS = '\u2026';
/**
 * Indices the control always shows: the first page, the last page, and a window of
 * three around the current page (clamped to the ends). Everything between two shown
 * indices collapses to an ellipsis when it hides two or more pages. A single hidden
 * page renders as itself, because an ellipsis that stands for one number is noise.
 */ const $d54cd1250a40cc23$var$getAlwaysVisibleIndices = (totalPages, current)=>{
    const lastIndex = totalPages - 1;
    const visible = new Set([
        0,
        lastIndex
    ]);
    let windowStart;
    if (current <= 2) windowStart = 1;
    else if (current >= lastIndex - 2) windowStart = lastIndex - 3;
    else windowStart = current - 1;
    for(let i = windowStart; i < windowStart + 3; i++)if (i >= 0 && i <= lastIndex) visible.add(i);
    return visible;
};
const $d54cd1250a40cc23$var$markMobileHiddenPages = (items, current, lastIndex)=>{
    const marked = items.map((item)=>item.type === 'page' && item.index !== 0 && item.index !== lastIndex && item.index !== current ? {
            ...item,
            hiddenOnMobile: true
        } : item);
    // Insert a mobile-only ellipsis after each hidden run that has no real ellipsis
    // on either side, so the hidden pages still read as a gap on small screens.
    // A run beside a real ellipsis merges into that gap. A lone hidden page with no
    // ellipsis beside it stays visible, because an ellipsis never stands for one page.
    const result = [];
    let runStart = -1;
    marked.forEach((item, position)=>{
        const previous = result[result.length - 1];
        const isHidden = item.type === 'page' && item.hiddenOnMobile === true;
        if (isHidden && runStart === -1) runStart = position;
        if (!isHidden && runStart !== -1) {
            const before = marked[runStart - 1];
            const hasNeighbourEllipsis = before?.type === 'ellipsis' || item.type === 'ellipsis';
            const runLength = position - runStart;
            if (!hasNeighbourEllipsis && runLength === 1 && previous !== undefined) result[result.length - 1] = {
                ...previous,
                hiddenOnMobile: undefined
            };
            else if (!hasNeighbourEllipsis && previous !== undefined) result.push({
                type: 'mobile-ellipsis',
                key: `mobile-ellipsis-${runStart}`
            });
            runStart = -1;
        }
        result.push(item);
    });
    return result;
};
const $d54cd1250a40cc23$var$createPageRange = (pages, selectedIndex)=>{
    const totalPages = pages.length;
    if (totalPages === 0) return [];
    const lastIndex = totalPages - 1;
    const current = Math.min(Math.max(selectedIndex, 0), lastIndex);
    const alwaysVisible = $d54cd1250a40cc23$var$getAlwaysVisibleIndices(totalPages, current);
    const result = [];
    let hiddenRun = [];
    const flushHiddenRun = ()=>{
        if (hiddenRun.length >= 2) result.push({
            type: 'ellipsis',
            key: `ellipsis-${hiddenRun[0]}`
        });
        else hiddenRun.forEach((index)=>{
            result.push({
                type: 'page',
                page: pages[index],
                index: index,
                key: `page-${index}`
            });
        });
        hiddenRun = [];
    };
    for(let index = 0; index <= lastIndex; index++)if (alwaysVisible.has(index)) {
        flushHiddenRun();
        result.push({
            type: 'page',
            page: pages[index],
            index: index,
            key: `page-${index}`
        });
    } else hiddenRun.push(index);
    flushHiddenRun();
    return $d54cd1250a40cc23$var$markMobileHiddenPages(result, current, lastIndex);
};
const $d54cd1250a40cc23$export$68f5e1453c188a82 = ({ pages: pages = [], selectedIndex: selectedIndex = 0, label: label, pageLabel: pageLabel, previousLabel: previousLabel, nextLabel: nextLabel, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    // Use provided props or fall back to localized defaults
    const ariaLabels = {
        navigation: label || formatMessage({
            id: 'wac.design.pagination.navigation.label',
            defaultMessage: 'Pagination navigation'
        }),
        page: pageLabel || formatMessage({
            id: 'wac.design.pagination.page.label',
            defaultMessage: 'Page'
        }),
        previous: previousLabel || formatMessage({
            id: 'wac.design.pagination.previous.label',
            defaultMessage: 'Previous page'
        }),
        next: nextLabel || formatMessage({
            id: 'wac.design.pagination.next.label',
            defaultMessage: 'Next page'
        })
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    if (pages.length === 0) return null;
    const fireAnalytics = (label)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'pagination',
            source: 'pagination',
            attributes: {
                label: label
            }
        }).fire();
    };
    const handlePageClick = (event, pageIndex)=>{
        if (pageIndex === selectedIndex) return;
        const page = pages[pageIndex];
        if (page !== undefined) {
            fireAnalytics(`page ${page}`);
            onChange?.(event, page);
        }
    };
    const handlePreviousClick = (event)=>{
        if (selectedIndex === 0) return;
        const page = pages[selectedIndex - 1];
        if (page !== undefined) {
            fireAnalytics('previous');
            onChange?.(event, page);
        }
    };
    const handleNextClick = (event)=>{
        if (selectedIndex === pages.length - 1) return;
        const page = pages[selectedIndex + 1];
        if (page !== undefined) {
            fireAnalytics('next');
            onChange?.(event, page);
        }
    };
    const pageRange = $d54cd1250a40cc23$var$createPageRange(pages, selectedIndex);
    const isPreviousDisabled = selectedIndex === 0;
    const isNextDisabled = selectedIndex === pages.length - 1;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
        "aria-label": ariaLabels.navigation,
        className: (0, $2jatx.default)([
            "_1e0c116y _1yt4xy5q _4cvr1h6o _1bah1h6o _ect4z4z1 _11q71afi _vchhusvi _v7361b66 _chtu1b66"
        ]),
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1h6o _zulp1ejb _vchhusvi _8164pxbi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    onClick: handlePreviousClick,
                    disabled: isPreviousDisabled,
                    "aria-label": ariaLabels.previous,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _19itglyw _bfhk1j28 _80omtlke _2rko1b66 _1bsbxy5q _4t3ixy5q _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1qc2 _4bfu1r31 _1hmsglyw _ajmmnqa1 _n47e5hrz _1ygb1qgu _1ah3yh40 _j5dh13gf _vbqbs3kk"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                        label: ""
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _zulppxbi _1wm0u2gc"
                    ]),
                    children: pageRange.map((item)=>{
                        if (item.type === 'ellipsis') return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            "aria-hidden": "true",
                            "data-testid": "pagination-ellipsis",
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1jfw _4t3ixy5q _syaz1pfd _tzy41ck0 _uiztglyw",
                                "_ect41kw7 _1wybgktf _vwz4gktf _k48pni7l _1cqs7vkz"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: $d54cd1250a40cc23$var$ELLIPSIS
                        }, item.key);
                        if (item.type === 'mobile-ellipsis') return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            "aria-hidden": "true",
                            "data-testid": "pagination-mobile-ellipsis",
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1jfw _4t3ixy5q _syaz1pfd _tzy41ck0 _uiztglyw",
                                "_ect41kw7 _1wybgktf _vwz4gktf _k48pni7l _1cqs7vkz",
                                "_1e0cglyw _1m0a1txw"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: $d54cd1250a40cc23$var$ELLIPSIS
                        }, item.key);
                        const isSelected = item.index === selectedIndex;
                        const pageNumber = item.page;
                        const pageIndex = item.index;
                        if (pageNumber === undefined || pageIndex === undefined) return null;
                        return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            onClick: (event)=>handlePageClick(event, pageIndex),
                            "data-testid": "pagination-page",
                            "data-mobile-hidden": item.hiddenOnMobile ? 'true' : undefined,
                            "aria-current": isSelected ? 'page' : undefined,
                            "aria-label": `${ariaLabels.page} ${pageNumber}${isSelected ? ', current page' : ''}`,
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1bah1h6o _19itglyw _bfhk1j28 _80omtlke _2rko1ssb _1bsbxy5q _4t3ixy5q _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1qc2 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1fbp5hrz _1ygbm8mt _1ah3v77o _1lg61pfd _434t1afi",
                                "_ect41kw7 _1wybgktf _vwz4gktf _k48pni7l _1cqs7vkz",
                                item.hiddenOnMobile && "_1m0aglyw"
                            ]),
                            style: {
                                "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            },
                            children: pageNumber
                        }, item.key);
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    onClick: handleNextClick,
                    disabled: isNextDisabled,
                    "aria-label": ariaLabels.next,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _19itglyw _bfhk1j28 _80omtlke _2rko1b66 _1bsbxy5q _4t3ixy5q _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1qc2 _4bfu1r31 _1hmsglyw _ajmmnqa1 _n47e5hrz _1ygb1qgu _1ah3yh40 _j5dh13gf _vbqbs3kk"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                        label: ""
                    })
                })
            ]
        })
    });
};

});

parcelRegister("f4mYE", function(module, exports) {
$parcel$export(module.exports, "dispatchShowAllFilterableGalleryItems", function () { return $407123e77a052455$export$d81b1c3ad32cc0e3; });
$parcel$export(module.exports, "subscribeToShowAllFilterableGalleryItems", function () { return $407123e77a052455$export$d570aeec1ed41f70; });
const $407123e77a052455$export$4bc61210cf504a16 = 'wac:filterable-gallery:show-all-items';
const $407123e77a052455$export$d81b1c3ad32cc0e3 = (query)=>{
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent($407123e77a052455$export$4bc61210cf504a16, {
        detail: {
            query: query.trim()
        }
    }));
};
const $407123e77a052455$export$d570aeec1ed41f70 = (onShowAllItems)=>{
    if (typeof window === 'undefined') return ()=>undefined;
    const handleShowAllItems = (event)=>{
        onShowAllItems(event.detail);
    };
    window.addEventListener($407123e77a052455$export$4bc61210cf504a16, handleShowAllItems);
    return ()=>window.removeEventListener($407123e77a052455$export$4bc61210cf504a16, handleShowAllItems);
};

});

parcelRegister("huvuR", function(module, exports) {
$parcel$export(module.exports, "readQueryEcho", function () { return $7371e3b36c3f4ee7$export$d7a02b9544e49635; });
/**
 * Client half of the WAE Contentful connector.
 *
 * The connector's `request` edgehancer returns the Contentful REST collection
 * shape and echoes the EFFECTIVE query it posted under
 * `extensions.wae = { query, variables }` (see `request.ts` in
 * wac-management-service). The browser replays that same query with `skip`
 * advanced, so page two carries the identical filter, sort and selection set as
 * the server-rendered page one.
 *
 * Nothing here knows a content type. A new gallery costs a data type, not code.
 */ /** GraphQL variables the edgehancer posted, and the browser re-posts. */ const $7371e3b36c3f4ee7$export$d7a02b9544e49635 = (value)=>{
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    const candidate = value;
    if (typeof candidate.query !== 'string' || !candidate.query.trim()) return null;
    const variables = candidate.variables && typeof candidate.variables === 'object' && !Array.isArray(candidate.variables) ? candidate.variables : {};
    return {
        query: candidate.query,
        variables: variables
    };
};

});

parcelRegister("9aC9C", function(module, exports) {
$parcel$export(module.exports, "useConnectorHydration", function () { return $9abd93954a9252e6$export$a3247ea60c08921f; });

var $1oC0p = parcelRequire("1oC0p");

var $8FfzM = parcelRequire("8FfzM");

var $2yeoP = parcelRequire("2yeoP");
/**
 * Items for each hydration request.
 *
 * The echo carries the SERVER page size, which is small on purpose: a 9-item
 * server render keeps the HTML light. Replaying that same `limit` would page the
 * browser 9 items at a time, so 304 items would cost 33 requests, each one
 * re-rendering the gallery. The browser pages larger instead. A live probe
 * against Contentful returned 304 items in one request, so 100 is well inside
 * what the API allows.
 */ const $9abd93954a9252e6$var$HYDRATION_PAGE_SIZE = 100;
/**
 * Hydrates the items a connector data resource did not server-render, by
 * replaying the echoed query with `skip` advanced.
 *
 * The first replay starts after the server page, at `skip + limit` from the echo
 * variables. The seed identity is keyed on the query text and that offset, so a
 * parent re-render cannot reset the accumulated pages and collapse the gallery.
 *
 * Paging is off until something calls `hydrateRest`, so a visitor who never
 * clicks "Load more" costs no request. `hydrateRest` then walks every remaining
 * page, one request for each idle turn, and the items arrive progressively.
 * Pass `autoLoad` to start on load instead.
 */ /**
 * Where hydration starts, and whether anything is left to fetch.
 *
 * The offset counts the items the server actually returned, not the `limit` it
 * asked for. A short last page, or an echo with no `limit`, would otherwise send
 * the browser back over items already on screen.
 */ function $9abd93954a9252e6$var$resolveStart({ echo: echo, total: total, serverItemCount: serverItemCount }) {
    if (!echo) return {
        firstSkip: 0,
        hasRemainder: false
    };
    const serverPageSize = serverItemCount ?? echo.variables.limit ?? 0;
    const firstSkip = (echo.variables.skip ?? 0) + serverPageSize;
    const hasRemainder = typeof total === 'number' ? firstSkip < total : true;
    return {
        firstSkip: firstSkip,
        hasRemainder: hasRemainder
    };
}
/** The seed resource: no items of its own, plus the echo for the next page. */ function $9abd93954a9252e6$var$buildSeed(echo, firstSkip, hasRemainder) {
    if (!echo || !hasRemainder) return {
        items: [],
        query: null
    };
    return {
        items: [],
        query: {
            query: echo.query,
            variables: {
                ...echo.variables,
                skip: firstSkip,
                limit: $9abd93954a9252e6$var$HYDRATION_PAGE_SIZE
            }
        }
    };
}
const $9abd93954a9252e6$export$a3247ea60c08921f = (echo, { autoLoad: autoLoad = false, total: total, serverItemCount: serverItemCount } = {})=>{
    const executeQuery = (0, $1oC0p.useMemo)(()=>(0, $8FfzM.createExecuteConnectorQuery)(), []);
    const [isPaging, setIsPaging] = (0, $1oC0p.useState)(autoLoad);
    const { firstSkip: firstSkip, hasRemainder: hasRemainder } = $9abd93954a9252e6$var$resolveStart({
        echo: echo,
        total: total,
        serverItemCount: serverItemCount
    });
    const seedKey = echo && hasRemainder ? `${echo.query}::${firstSkip}::${String(total)}` : '';
    const seedRef = (0, $1oC0p.useRef)();
    if (!seedRef.current || seedRef.current.key !== seedKey) seedRef.current = {
        key: seedKey,
        value: $9abd93954a9252e6$var$buildSeed(echo, firstSkip, hasRemainder)
    };
    // `useDataConnector` walks the remaining pages by itself while `autoLoad` is
    // true, one page for each idle turn. So "load the rest" is a single flag flip.
    const { items: items, isLoading: isLoading, error: error, done: done } = (0, $2yeoP.useDataConnector)({
        initial: seedRef.current.value,
        executeQuery: executeQuery,
        autoLoad: isPaging
    });
    // A ref, so `hydrateRest` keeps one identity for the life of the component.
    const canPageRef = (0, $1oC0p.useRef)(false);
    canPageRef.current = Boolean(seedRef.current.value.query);
    const hydrateRest = (0, $1oC0p.useCallback)(()=>{
        if (!canPageRef.current) return;
        setIsPaging(true);
    }, []);
    // A failed page stops paging, so stop claiming that items are still coming.
    // Otherwise the caller waits for a reveal that never arrives.
    const hasUnfetchedItems = Boolean(seedRef.current.value.query) && !done && !error;
    return {
        items: items,
        isHydrating: isLoading,
        error: error,
        done: done,
        hasUnfetchedItems: hasUnfetchedItems,
        hydrateRest: hydrateRest
    };
};

});
parcelRegister("8FfzM", function(module, exports) {
$parcel$export(module.exports, "createExecuteConnectorQuery", function () { return $a13ea57c968be215$export$d70b96531cce1641; });

var $4Dhav = parcelRequire("4Dhav");
const $a13ea57c968be215$export$d70b96531cce1641 = (run = (0, $4Dhav.runConnectorQuery))=>{
    return async (echo)=>{
        const page = await run(echo);
        return {
            items: page.items,
            query: $a13ea57c968be215$export$beedc451beeb247e(echo, page)
        };
    };
};
const $a13ea57c968be215$export$beedc451beeb247e = (echo, page)=>{
    if (page.items.length === 0) return null;
    const nextSkip = page.skip + page.items.length;
    if (nextSkip >= page.total) return null;
    return (0, $4Dhav.withSkip)(echo, nextSkip);
};

});
parcelRegister("4Dhav", function(module, exports) {
$parcel$export(module.exports, "runConnectorQuery", function () { return $7af28e8f687b3d19$export$333e1ce5ce1d7d82; });
$parcel$export(module.exports, "withSkip", function () { return $7af28e8f687b3d19$export$a42f3303f6c88ff5; });

var $2iZII = parcelRequire("2iZII");

var $hKKzC = parcelRequire("hKKzC");
const $7af28e8f687b3d19$export$333e1ce5ce1d7d82 = async (echo)=>{
    const result = await (0, $2iZII.getContentfulGqlClient)().query(echo.query, echo.variables).toPromise();
    // Contentful answers a partially broken link with data PLUS errors. The
    // edgehancer downgrades that to a warning and keeps the data, so do the same:
    // one unpublished link must not empty a gallery page.
    const data = result.data;
    if (!data) throw new Error(`WAE connector: no data for the echoed query${result.error ? `: ${result.error.message}` : ''}`);
    const node = $7af28e8f687b3d19$var$findCollectionNode(data);
    // Contentful returns a `null` item for an entry the token cannot read. Dropping
    // them here keeps a blank card out of the gallery, whose dedupe cannot filter
    // them because a null has no `sys.id`.
    const rawItems = (Array.isArray(node?.items) ? node.items : []).filter((item)=>typeof item === 'object' && item !== null);
    return {
        items: (0, $hKKzC.reshapeCollection)(rawItems),
        total: typeof node?.total === 'number' ? node.total : rawItems.length,
        skip: echo.variables.skip ?? 0
    };
};
/** The first node that looks like a Contentful collection: `{ total?, items[] }`. */ const $7af28e8f687b3d19$var$findCollectionNode = (data)=>{
    for (const value of Object.values(data)){
        if (value && typeof value === 'object' && Array.isArray(value.items)) return value;
    }
    return undefined;
};
const $7af28e8f687b3d19$export$a42f3303f6c88ff5 = (echo, skip)=>({
        query: echo.query,
        variables: {
            ...echo.variables,
            skip: skip
        }
    });

});
parcelRegister("hKKzC", function(module, exports) {
$parcel$export(module.exports, "reshapeCollection", function () { return $62ca84bd4861a768$export$5680971a912d84f8; });
// COPIED from wac-uniform-publisher src/lib/wae-connector/reshape.ts — keep in sync.
// The only difference is bracket property access, e.g. `file['url']` instead of
// `file.url`, because wac-web sets `noPropertyAccessFromIndexSignature` and the
// publisher does not, plus `=== null || === undefined` in place of `== null`, because
// wac-web's eslint enforces eqeqeq. The logic is identical; diff the two before you
// edit either.
/**
 * GraphQL → Contentful-REST reshape.
 *
 * The WAE Contentful connector queries Contentful's **GraphQL** API, which
 * returns a FLAT item shape:
 *
 *   { sys: { id }, templateNameExternal: "…",
 *     categoryCollection: { items: [ { categoryNameExternal: "…" } ] },
 *     templateThumbnail: { url: "…", title: "…" } }
 *
 * But the existing WAC gallery components (`filterableCard`, etc.) and every
 * other consumer of the legacy `queryTemplates` data source bind to the
 * Contentful **CDA REST** entry shape:
 *
 *   { sys: { id }, fields: { templateNameExternal: "…",
 *     category: [ { fields: { categoryNameExternal: "…" } } ],
 *     templateThumbnail: { fields: { file: { url: "…", title: "…" } } } } }
 *
 * Reshaping GraphQL → REST here makes the connector a **drop-in replacement**
 * for `queryTemplates`: existing `$:fields.X` bindings keep working unchanged.
 *
 * ── EDGEHANCER CONTRACT ──────────────────────────────────────────────────
 * This module is dependency-free and intended to be copied VERBATIM into the
 * `wac-management-service` edgehancer (like `edgehancer-query.ts`). The
 * edgehancer should run `reshapeCollection()` on the Contentful GraphQL
 * response BEFORE returning it as the data resource result, so the runtime
 * data matches the REST shape. This repo's editor preview uses the same
 * function so authoring and runtime are identical.
 */ /** A Contentful asset detected in a GraphQL response (`{ url, title, ... }`). */ /**
 * Depth cap for the reshape walk, counted in JSON levels.
 *
 * The query builder already caps a nested selection at `EH_MAX_SELECTION_DEPTH`,
 * and each selection level yields about two JSON levels, so a generated query
 * never reaches this cap. It bounds the output of a raw query override instead.
 *
 * A cycle guard is deliberately absent. The input is a parsed Contentful GraphQL
 * response, and JSON holds no object cycle. A `WeakSet` guard would also rewrite
 * a legitimately shared object into a stub on its second visit.
 */ const $62ca84bd4861a768$var$MAX_RESHAPE_DEPTH = 12;
const $62ca84bd4861a768$var$ASSET_KEYS = new Set([
    'url',
    'title',
    'description',
    'width',
    'height',
    'contentType',
    'fileName',
    'size'
]);
/**
 * Heuristic: is this object a Contentful **Asset** as returned by GraphQL?
 * GraphQL assets expose `url` (and usually `title`/`width`/`contentType`) as
 * top-level scalars, with no `sys`-less nested `fields`.
 */ function $62ca84bd4861a768$var$isGraphQLAsset(value) {
    if (typeof value['url'] !== 'string') return false;
    // Every own key (besides `sys`) should be a known asset scalar.
    return Object.keys(value).every((k)=>k === 'sys' || $62ca84bd4861a768$var$ASSET_KEYS.has(k));
}
/** Reshape a GraphQL asset → REST asset (`{ fields: { file: { url, ... } } }`). */ function $62ca84bd4861a768$var$reshapeAsset(asset) {
    const file = {};
    if (asset.url !== undefined) file['url'] = asset.url;
    if (asset.fileName !== undefined) file['fileName'] = asset.fileName;
    if (asset.contentType !== undefined) file['contentType'] = asset.contentType;
    if (asset.width !== undefined || asset.height !== undefined) file['details'] = {
        image: {
            ...asset.width !== undefined ? {
                width: asset.width
            } : {},
            ...asset.height !== undefined ? {
                height: asset.height
            } : {}
        }
    };
    const fields = {
        file: file
    };
    if (asset.title !== undefined) {
        fields['title'] = asset.title;
        // The REST CDA keeps `title` beside `file`, but the WAC client mapper
        // (`map-template-item.ts`) puts it INSIDE `file`, and live compositions bind
        // `fields.<asset>.fields.file.title` for image alt text. Write both keys so
        // the connector matches those bindings and the REST shape at the same time.
        file['title'] = asset.title;
    }
    if (asset.description !== undefined) fields['description'] = asset.description;
    return {
        fields: fields
    };
}
/**
 * Reshape a single GraphQL field value into its REST equivalent.
 *
 * - Scalars / arrays of scalars: returned as-is.
 * - Assets (`{ url, title }`): → `{ fields: { file: { url, … }, title } }`.
 * - Collections (`{ items: [...] }`): → array of reshaped linked entries.
 * - Single linked entries (nested objects with their own fields): → `{ fields: {…} }`.
 */ function $62ca84bd4861a768$var$reshapeValue(value, depth = 0) {
    if (value === null || value === undefined || typeof value !== 'object') return value; // scalar
    // Depth guard: stop reshaping past the cap and return the branch untouched.
    // A nested selection set is capped in the query builder, so this only trips on
    // a hand-written raw query override that nests deeper than the cap.
    if (depth > $62ca84bd4861a768$var$MAX_RESHAPE_DEPTH) return value;
    if (Array.isArray(value)) return value.map((entry)=>$62ca84bd4861a768$var$reshapeValue(entry, depth + 1));
    const obj = value;
    // Collection → flatten `items` into an array of reshaped values. Each item
    // goes through `reshapeValue`, not straight to `reshapeLinkedEntry`, so a
    // collection OF ASSETS (e.g. `templatePreviewCollection`) gets the same
    // `{ fields: { file: { url } } }` envelope a single asset field gets. Sending
    // items directly to `reshapeLinkedEntry` skipped the asset branch and produced
    // `fields.templatePreview.0.fields.url`, which no card binding reads.
    if (Array.isArray(obj.items)) return (obj.items ?? []).map((item)=>$62ca84bd4861a768$var$reshapeValue(item, depth + 1));
    // Asset → REST asset shape.
    if ($62ca84bd4861a768$var$isGraphQLAsset(obj)) return $62ca84bd4861a768$var$reshapeAsset(obj);
    // Otherwise it's a single linked entry object.
    return $62ca84bd4861a768$var$reshapeLinkedEntry(obj, depth);
}
/**
 * Reshape a linked entry: lift its `sys`, and wrap all other (field) keys under
 * `fields`, recursing so nested references/assets are reshaped too.
 */ function $62ca84bd4861a768$var$reshapeLinkedEntry(entry, depth = 0) {
    if (entry === null || entry === undefined || typeof entry !== 'object' || Array.isArray(entry)) return entry;
    const obj = entry;
    const sys = obj['sys'];
    const fields = {};
    for (const [key, val] of Object.entries(obj)){
        if (key === 'sys') continue;
        // Reference fields generated by Contentful GraphQL end in `Collection`;
        // strip that suffix so REST bindings use the base field name.
        const restKey = key.endsWith('Collection') ? key.slice(0, -10) : key;
        fields[restKey] = $62ca84bd4861a768$var$reshapeValue(val, depth + 1);
    }
    return sys === undefined ? {
        fields: fields
    } : {
        sys: sys,
        fields: fields
    };
}
function $62ca84bd4861a768$export$1acd38e8400b1ae4(item) {
    return $62ca84bd4861a768$var$reshapeLinkedEntry(item);
}
function $62ca84bd4861a768$export$5680971a912d84f8(items) {
    return items.map($62ca84bd4861a768$export$1acd38e8400b1ae4);
}

});



parcelRegister("2yeoP", function(module, exports) {
$parcel$export(module.exports, "useDataConnector", function () { return $6f766a4feb298280$export$fea982f32dc9a0cf; });

var $1oC0p = parcelRequire("1oC0p");
const $6f766a4feb298280$var$scheduleIdle = (callback)=>{
    if (typeof requestIdleCallback !== 'undefined') {
        // A deadline, so a page with heavy third-party scripts cannot defer the
        // fetch for seconds while the button sits disabled.
        const id = requestIdleCallback(callback, {
            timeout: 500
        });
        return ()=>cancelIdleCallback(id);
    }
    // Defer to a macrotask rather than running inline, so the fetch never fires
    // re-entrantly during React's commit phase (where requestIdleCallback is
    // unavailable, for example in server render and in jsdom).
    const id = setTimeout(callback, 0);
    return ()=>clearTimeout(id);
};
const $6f766a4feb298280$export$fea982f32dc9a0cf = ({ initial: initial, executeQuery: executeQuery, autoLoad: autoLoad = true, keyExtractor: keyExtractor = $6f766a4feb298280$var$defaultKeyExtractor })=>{
    const [state, setState] = (0, $1oC0p.useState)(()=>({
            items: initial.items,
            isLoading: false,
            error: null,
            done: initial.query === null
        }));
    const mountedRef = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const keyExtractorRef = (0, $1oC0p.useRef)(keyExtractor);
    keyExtractorRef.current = keyExtractor;
    const nextQueryRef = (0, $1oC0p.useRef)(initial.query);
    const seenRef = (0, $1oC0p.useRef)(new Set());
    const loadingRef = (0, $1oC0p.useRef)(false);
    // Reset when the seed or the executor identity changes, for example when a
    // locale switch rebuilds both.
    (0, $1oC0p.useEffect)(()=>{
        nextQueryRef.current = initial.query;
        loadingRef.current = false;
        seenRef.current = new Set();
        for (const item of initial.items){
            const key = keyExtractorRef.current(item);
            if (key !== undefined) seenRef.current.add(key);
        }
        setState({
            items: initial.items,
            isLoading: false,
            error: null,
            done: initial.query === null
        });
    }, [
        initial,
        executeQuery
    ]);
    const loadMore = (0, $1oC0p.useCallback)(()=>{
        const query = nextQueryRef.current;
        if (!query || loadingRef.current) return;
        loadingRef.current = true;
        setState((prev)=>({
                ...prev,
                isLoading: true,
                error: null
            }));
        executeQuery(query).then((page)=>{
            if (!mountedRef.current) return;
            const fresh = page.items.filter((item)=>{
                const key = keyExtractorRef.current(item);
                if (key === undefined) return true;
                if (seenRef.current.has(key)) return false;
                seenRef.current.add(key);
                return true;
            });
            nextQueryRef.current = page.query;
            loadingRef.current = false;
            setState((prev)=>({
                    items: [
                        ...prev.items,
                        ...fresh
                    ],
                    isLoading: false,
                    error: null,
                    done: page.query === null
                }));
        }).catch((err)=>{
            if (!mountedRef.current) return;
            // Stop, and surface the error. A silent hang would leave the gallery
            // on skeleton cards, because `isAwaitingBackfill` never clears.
            loadingRef.current = false;
            setState((prev)=>({
                    ...prev,
                    isLoading: false,
                    error: err
                }));
        });
    }, [
        executeQuery
    ]);
    // Walk the full set one page at a time on idle.
    (0, $1oC0p.useEffect)(()=>{
        if (!autoLoad || state.done || state.isLoading || state.error) return;
        if (!nextQueryRef.current) return;
        return $6f766a4feb298280$var$scheduleIdle(loadMore);
    }, [
        autoLoad,
        state.done,
        state.isLoading,
        state.error,
        state.items,
        loadMore
    ]);
    return {
        ...state,
        loadMore: loadMore
    };
};
function $6f766a4feb298280$var$defaultKeyExtractor(item) {
    if (typeof item !== 'object' || item === null) return undefined;
    const record = item;
    const sys = record['sys'];
    if (typeof sys === 'object' && sys !== null) {
        const id = sys['id'];
        if (typeof id === 'string') return id;
    }
    return undefined;
}

});


parcelRegister("jh5WI", function(module, exports) {
$parcel$export(module.exports, "FILTER_DROPDOWN_DATA_ATTR", function () { return $4187681c2fe2739d$export$e0eb4323da102d75; });
$parcel$export(module.exports, "FilterControl", function () { return $4187681c2fe2739d$export$de444dcd5d6300ee; });
/* filter-control.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
const $4187681c2fe2739d$export$e0eb4323da102d75 = 'data-filter-dropdown';
const $4187681c2fe2739d$var$sanitizeForId = (value)=>value.replace(/[^\w-]/g, '-');
/** "Item" -> "items". Lowercases and pluralizes the filter label for "All items". */ const $4187681c2fe2739d$var$buildAllLabelNoun = (filterLabel)=>{
    const lower = filterLabel.toLowerCase();
    if (lower.endsWith('s')) return lower;
    if (/[^aeiou]y$/.test(lower)) return `${lower.slice(0, -1)}ies`;
    return `${lower}s`;
};
const $4187681c2fe2739d$var$buildPanelId = (filterId)=>`filter-panel-${$4187681c2fe2739d$var$sanitizeForId(filterId)}`;
const $4187681c2fe2739d$export$de444dcd5d6300ee = ({ filter: filter, activeCount: activeCount, isOpen: isOpen, subFilter: subFilter, labelMap: labelMap, onButtonClick: onButtonClick, onOptionToggle: onOptionToggle, onSelectAll: onSelectAll })=>{
    const intl = (0, $8e22h.default)();
    const filterLabel = filter.label ?? filter.id;
    const panelId = $4187681c2fe2739d$var$buildPanelId(filter.id);
    // An authored (localizable) label wins; the derived "All {label}" is only the fallback.
    const allLabel = filter.selectAllLabel || intl.formatMessage({
        id: 'uniformFilterableGallery.allOption',
        defaultMessage: 'All {filterLabel}'
    }, {
        filterLabel: $4187681c2fe2739d$var$buildAllLabelNoun(filterLabel)
    });
    // Collapsed label: "All items" with no selection, the option's own label with
    // exactly one, otherwise the filter label plus a count badge.
    const selectedOptionId = activeCount === 1 ? Object.keys(subFilter ?? {}).find((id)=>subFilter?.[id]?.committedActive) : undefined;
    const collapsedLabel = $4187681c2fe2739d$var$getCollapsedLabel({
        activeCount: activeCount,
        allLabel: allLabel,
        filterLabel: filterLabel,
        selectedLabel: selectedOptionId === undefined ? undefined : labelMap?.[selectedOptionId] ?? selectedOptionId
    });
    // Fold the count into the accessible name; the visible badge is aria-hidden.
    const accessibleName = activeCount > 1 ? `${filterLabel}, ${activeCount} selected` : collapsedLabel;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                type: "button",
                "aria-label": accessibleName,
                "aria-expanded": isOpen,
                "aria-controls": panelId,
                onClick: (event)=>{
                    event.preventDefault();
                    onButtonClick();
                },
                "data-product-key": "uniform",
                "data-event": "clicked",
                "data-event-component": "button",
                "data-event-container": "searchWithFilters",
                "data-label": filterLabel,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _vchhusvi _1bsb1osq _1ul91lit _p12f1feq _4t3i1jfw _ca0q1y44 _u5f37vkz _n3td1y44 _19bv7vkz _zulppxbi _bfhk1afi _19itkze7 _2rkogktf _syaz1pfd _ect4z4z1 _1wyb7vkz _k48p1nn1 _vwz41tcg _80omtlke _1ygb1qgu _1ah31y44 _12b6idpf _1rkbglyw",
                    isOpen && "_19it1qgu"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _zulpu2gc _1ul9idpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                ]),
                                children: collapsedLabel
                            }),
                            activeCount > 1 && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                "data-testid": "active-count-badge",
                                "aria-hidden": "true",
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf _1bsbgktf _4t3igktf _2rko1ssb _bfhk5hrz _syaz1afi _ect4z4z1 _1wybdlk8 _k48p1fw0 _vwz4gktf"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: activeCount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($4187681c2fe2739d$var$DropdownArrow, {
                        isOpen: isOpen
                    })
                ]
            }),
            isOpen && subFilter && /*#__PURE__*/ (0, $7VQPk.jsx)($4187681c2fe2739d$var$OptionsPanel, {
                panelId: panelId,
                groupLabel: filterLabel,
                filterId: filter.id,
                options: subFilter,
                onToggle: onOptionToggle,
                labelMap: labelMap,
                allLabel: allLabel,
                isAllSelected: activeCount === 0,
                onSelectAll: onSelectAll
            })
        ]
    });
};
// ---------------------------------------------------------------------------
// Internal sub-components (private to this file)
// ---------------------------------------------------------------------------
const $4187681c2fe2739d$var$getCollapsedLabel = ({ activeCount: activeCount, allLabel: allLabel, filterLabel: filterLabel, selectedLabel: selectedLabel })=>{
    if (activeCount === 0) return allLabel;
    if (activeCount === 1 && selectedLabel !== undefined) return selectedLabel;
    return filterLabel;
};
/**
 * Matches the Figma "carat-down" glyph exactly (node 933:335678) — Atlaskit's
 * stock chevron icon has a different, thinner glyph that reads as too small
 * at this size.
 */ const $4187681c2fe2739d$var$DropdownArrow = ({ isOpen: isOpen })=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1bsbdlk8 _4t3irdoj _1o9zidpf _syaz1pfd _v564kete",
            isOpen && "_t9ec1sub"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
            width: "13.213",
            height: "8.128",
            viewBox: "0 0 13.213 8.12828",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            focusable: "false",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.282391 2.04788C-0.0941303 1.65992 -0.0941305 1.04295 0.282391 0.654991L0.623465 0.303554C1.01627 -0.101184 1.66588 -0.101185 2.05868 0.303553L6.60648 4.98954L11.1543 0.303554C11.5471 -0.101184 12.1967 -0.101185 12.5895 0.303554L12.9306 0.654991C13.3071 1.04295 13.3071 1.65992 12.9306 2.04788L7.32409 7.82473C6.93129 8.22946 6.28168 8.22946 5.88887 7.82473L0.282391 2.04788Z",
                fill: "currentColor"
            })
        })
    });
const $4187681c2fe2739d$var$OptionsPanel = ({ panelId: panelId, groupLabel: groupLabel, filterId: filterId, options: options, onToggle: onToggle, labelMap: labelMap, allLabel: allLabel, isAllSelected: isAllSelected, onSelectAll: onSelectAll })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: panelId,
        role: "group",
        "aria-label": groupLabel,
        className: (0, $2jatx.default)([
            "_kqswstnw _vchhusvi _1ul9p3fh _1reo15vq _18m915vq _bfhk1afi _19it1ixx _2rko1y44 _1pbycs5v _152t4bvh _1yt4u2gc _16qs130s",
            filterId
        ]),
        [$4187681c2fe2739d$export$e0eb4323da102d75]: '',
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulpu2gc"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)($4187681c2fe2739d$var$OptionCheckbox, {
                    optionId: "all",
                    label: allLabel,
                    checked: isAllSelected,
                    inputId: $4187681c2fe2739d$var$buildOptionInputId(filterId, -1),
                    onToggle: onSelectAll
                }),
                Object.keys(options).map((optionId, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($4187681c2fe2739d$var$OptionCheckbox, {
                        optionId: optionId,
                        label: labelMap?.[optionId] ?? optionId,
                        checked: options[optionId]?.stagedActive ?? false,
                        inputId: $4187681c2fe2739d$var$buildOptionInputId(filterId, index),
                        onToggle: onToggle
                    }, optionId))
            ]
        })
    });
const $4187681c2fe2739d$var$buildOptionInputId = (filterId, index)=>`option-${$4187681c2fe2739d$var$sanitizeForId(filterId)}-${index}`;
const $4187681c2fe2739d$var$OptionCheckbox = ({ optionId: optionId, label: label, checked: checked, inputId: inputId, onToggle: onToggle })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
        htmlFor: inputId,
        className: (0, $2jatx.default)([
            "_vchhusvi _1bsb1osq _80omtlke _1e0c1txw _4cvr1h6o _ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _2rkoftgi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                id: inputId,
                type: "checkbox",
                checked: checked,
                onChange: ()=>onToggle(optionId),
                className: (0, $2jatx.default)([
                    "_kqswstnw _tzy4idpf _1bsbgktf _4t3igktf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jc1qgu _175vyh40"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1bsbf6fq _4t3if6fq _2rko1l7b _19it6lb8 _i0dlf6fq _1o9zidpf _12l2u2gc _11q71afi _1e0c1txw _1bah1h6o _4cvr1h6o _bfw71qgu _1c395hrz _uq4u1qgu",
                    checked ? 'checked' : ''
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _syaz1afi _tzy4idpf",
                        checked && "_tzy4kb7n"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "11.17",
                        height: "7.26",
                        viewBox: "0 0 11.1698 7.25995",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        "aria-hidden": "true",
                        focusable: "false",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.89 0.295063C11.2824 0.696189 11.2592 1.34412 10.839 1.71607L4.85995 7.00873C4.46092 7.36195 3.85499 7.3402 3.48232 6.95927L0.277834 3.68379C-0.0926113 3.30513 -0.0926115 2.69987 0.277834 2.32122C0.659939 1.93065 1.28848 1.93065 1.67059 2.32122L4.14761 4.85312L9.55101 0.235313C9.94354 -0.100149 10.5289 -0.0740284 10.89 0.295063Z",
                            fill: "currentColor"
                        })
                    })
                })
            }),
            label
        ]
    });
// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------
const $4187681c2fe2739d$var$triggerButtonStyle = null;
const $4187681c2fe2739d$var$labelTextStyle = null;
const $4187681c2fe2739d$var$labelGroupStyle = null;
const $4187681c2fe2739d$var$triggerButtonOpenStyle = null;
const $4187681c2fe2739d$var$activeCountBadgeStyle = null;
const $4187681c2fe2739d$var$dropdownArrowStyle = null;
const $4187681c2fe2739d$var$dropdownArrowRotatedStyle = null;
const $4187681c2fe2739d$var$panelStyle = null;
const $4187681c2fe2739d$var$optionListStyle = null;
const $4187681c2fe2739d$var$optionLabelStyle = null;
const $4187681c2fe2739d$var$checkboxStyle = null;
const $4187681c2fe2739d$var$checkmarkStyle = null;
const $4187681c2fe2739d$var$checkmarkVisibleStyle = null;
const $4187681c2fe2739d$var$hiddenCheckboxStyle = null;

});

parcelRegister("eAngy", function(module, exports) {
$parcel$export(module.exports, "Toolbar", function () { return $6dde010468313e76$export$4c260019440d418f; });
/* toolbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $iiNB7 = parcelRequire("iiNB7");

var $jh5WI = parcelRequire("jh5WI");

var $7HjDW = parcelRequire("7HjDW");

var $7EuEV = parcelRequire("7EuEV");
const $6dde010468313e76$export$4c260019440d418f = ({ filterDefs: filterDefs, sortDefs: sortDefs, canSearch: canSearch, showSearchInput: showSearchInput, filterObject: filterObject, searchQuery: searchQuery, selectedSortId: selectedSortId, dropdownVisibility: dropdownVisibility, labelMaps: labelMaps, onSearchChange: onSearchChange, onSearchSubmit: onSearchSubmit, onSearchClear: onSearchClear, onFilterButtonClick: onFilterButtonClick, onOptionToggle: onOptionToggle, onClearFilter: onClearFilter, onClearAllFilters: onClearAllFilters, onSortChange: onSortChange })=>{
    const intl = (0, $8e22h.default)();
    const hasActiveFilters = filterDefs.some((filter)=>(0, $iiNB7.countActiveFilterOptions)(filter.id, filterObject) > 0);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1y6m _1bah1yb4 _1n261q9c _ca0qckbl _u5f3idpf _n3td7vkz _19bvidpf _zulppxbi _1gde1bp4 _ag851y6m _81641ejb _1vlrckbl _kgiyidpf _1w0x1tcg _958cidpf",
                filterDefs.length > 1 && "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1vlrckbl _kgiyidpf _1w0x1tcg _958cidpf"
            ]),
            children: [
                showSearchInput && canSearch && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1f4911wp _16jlidpf _1o9zkb7n _i0dl1pna _1ul91178 _1e0c1txw _1bahesu3 _ahbq1wug _688gcs5v _11cgidpf _nssp1y6m _1fe7idpf _12ihidpf _1a1x1wug _1rfm1osq _1rkbglyw _12b6idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7HjDW.SearchField), {
                        value: searchQuery,
                        onChange: onSearchChange,
                        onSubmit: onSearchSubmit,
                        onClear: onSearchClear
                    })
                }),
                filterDefs.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1f49kb7n _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _1e0c1txw _2lx2vrvc _1n261g80 _zulppxbi _kqswh2mm _1fe7idpf _12ihidpf _1a1x1wug _1rfm1osq _14q21bp4"
                    ]),
                    children: [
                        filterDefs.map((filter)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                [(0, $jh5WI.FILTER_DROPDOWN_DATA_ATTR)]: '',
                                className: (0, $2jatx.default)([
                                    "_16jlidpf _1o9zidpf _i0dl1wug _1ul91lit _p12f1feq _1fe7idpf _12ihidpf _1a1x1wug _1rfm1osq _12b6idpf _1rkbglyw"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jh5WI.FilterControl), {
                                    filter: filter,
                                    activeCount: (0, $iiNB7.countActiveFilterOptions)(filter.id, filterObject),
                                    isOpen: !!dropdownVisibility[filter.id],
                                    subFilter: filterObject[filter.id],
                                    labelMap: labelMaps[filter.id],
                                    onButtonClick: ()=>onFilterButtonClick(filter.id),
                                    onOptionToggle: (optionId)=>onOptionToggle(filter.id, optionId),
                                    onSelectAll: ()=>onClearFilter(filter.id)
                                })
                            }, filter.id)),
                        hasActiveFilters && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            variant: "primary_alt",
                            size: "small",
                            onClick: onClearAllFilters,
                            className: (0, $2jatx.default)([
                                "_o5721q9c",
                                "body-md"
                            ]),
                            dataEventProps: {
                                'data-product-key': 'uniform',
                                'data-event': 'clicked',
                                'data-event-component': 'button',
                                'data-event-container': 'searchWithFilters',
                                'data-label': 'Clear Filters',
                                'data-label-english': 'Clear Filters'
                            },
                            children: intl.formatMessage({
                                id: 'uniformFilterableGallery.clearFilters',
                                defaultMessage: 'Clear Filters'
                            })
                        })
                    ]
                }),
                sortDefs.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhutpp _1f49cs5v _1e0c1txw _1bahesu3"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7EuEV.SortControl), {
                        sorts: sortDefs,
                        selectedSortId: selectedSortId,
                        onChange: onSortChange
                    })
                })
            ]
        })
    });
};
const $6dde010468313e76$var$toolbarSectionStyle = null;
const $6dde010468313e76$var$toolbarRowStyle = null;
const $6dde010468313e76$var$multiFilterToolbarRowStyle = null;
const $6dde010468313e76$var$searchContainerStyle = null;
const $6dde010468313e76$var$filterButtonRowStyle = null;
const $6dde010468313e76$var$filterWrapperStyle = null;
const $6dde010468313e76$var$clearFiltersButtonStyle = null;
const $6dde010468313e76$var$sortRowStyle = null;

});
parcelRegister("iiNB7", function(module, exports) {
$parcel$export(module.exports, "countActiveFilterOptions", function () { return $e9f05f3c168a82a3$export$c7d87b41bc3ef441; });
const $e9f05f3c168a82a3$export$c7d87b41bc3ef441 = (filterId, state)=>Object.values(state[filterId] ?? {}).reduce((count, option)=>option.committedActive ? count + 1 : count, 0);

});

parcelRegister("7HjDW", function(module, exports) {
$parcel$export(module.exports, "SearchField", function () { return $e6c01637ddd40d01$export$b94867ecbd698f21; });
/* search-field.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $dE0sS = parcelRequire("dE0sS");
const $e6c01637ddd40d01$export$b94867ecbd698f21 = ({ value: value, onChange: onChange, onSubmit: onSubmit, onClear: onClear })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const inputRef = (0, $1oC0p.useRef)(null);
    const [isFocused, setIsFocused] = (0, $1oC0p.useState)(false);
    const placeholder = intl.formatMessage({
        id: 'SearchBar.searchPlaceholder',
        defaultMessage: 'Search'
    });
    const fireFocusAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            origin: 'web',
            platform: 'web',
            product: 'marketing',
            source: 'none',
            userIdType: 'atlassianAccount',
            eventComponent: 'searchInput',
            event: 'clicked',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'component',
            attributes: {
                url: location.href,
                page_path: location.pathname,
                eventComponent: 'searchInput'
            }
        }).fire();
    };
    const handleFocus = ()=>{
        setIsFocused(true);
        fireFocusAnalyticsEvent();
    };
    const handleBlur = ()=>{
        if (value === '') setIsFocused(false);
    };
    const submitAndFocusInput = ()=>{
        inputRef.current?.focus();
        onSubmit();
    };
    const clearAndFocusInput = ()=>{
        onClear();
        inputRef.current?.focus();
    };
    const focusedClass = isFocused ? 'search-active' : '';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            submitAndFocusInput();
        },
        className: (0, $2jatx.default)([
            "_vchhusvi _4t3i1jfw _6rthidpf _1ul91178 _p12f1pna _1bsb1osq _1rkbglyw _11q7g7ng _19itkze7 _2rko1ylp _1e0c1txw _1n261q9c _1bah1yb4 _ca0qftgi _u5f31tcg _n3tdftgi _19bv1tcg _scffglyw _1rwq1j28 _xmji1r31 _gxxuglyw _34ir1o36 _5hv91osq _17ea1vuk _psgk1pfd _1heuz4z1 _125x7vkz _yizh1nn1 _5ce6k0sw _1ir3kb7n _1owa1w8u _mm6didpf _1tssglyw _krk61j28 _10709by0 _1f021txw _oki51h6o _1vh3esu3 _dier1q9c _qe2zh8dc _12nmbz2e _1d2m1ejb _11vyksb5 _p2rgx19p"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
            "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                ref: inputRef,
                className: focusedClass,
                type: "text",
                "aria-label": placeholder,
                placeholder: placeholder,
                value: value,
                onChange: (event)=>onChange(event.target.value),
                onFocus: handleFocus,
                onBlur: handleBlur
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: `search-buttons-container ${focusedClass}`,
                children: [
                    isFocused && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($e6c01637ddd40d01$var$SearchClearButton, {
                                onClick: clearAndFocusInput
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: "search-buttons-divider"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($e6c01637ddd40d01$var$SearchSubmitButton, {})
                ]
            })
        ]
    });
};
// ---------------------------------------------------------------------------
// Internal sub-components (private to this file; used only by SearchField)
// ---------------------------------------------------------------------------
const $e6c01637ddd40d01$var$SearchSubmitButton = ()=>{
    const intl = (0, $8e22h.default)();
    const label = intl.formatMessage({
        id: 'SearchButton.label',
        defaultMessage: 'Search'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "submit",
        "aria-label": label,
        "data-testid": "search-submit-button",
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "searchButton",
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _syazk553"
        ]),
        style: {
            "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_syaz1pfd _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbl52n _4t3i8jkm _w8l5l52n _17528jkm"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($e6c01637ddd40d01$var$SearchGlyph, {})
        })
    });
};
/**
 * Matches the Figma "in-Page Search" glyph exactly (node 933:335490) —
 * Atlaskit's stock search icon is a filled glyph with a different weight
 * than this stroke-based magnifying glass.
 */ const $e6c01637ddd40d01$var$SearchGlyph = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "17",
        height: "19",
        viewBox: "0 0 19.9609 21.1938",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.428 16.6609L18.5859 19.8188",
                stroke: "currentColor",
                strokeWidth: "2.75",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.17763 17.2303C13.625 17.2303 17.2303 13.625 17.2303 9.17763C17.2303 4.73029 13.625 1.125 9.17763 1.125C4.73029 1.125 1.125 4.73029 1.125 9.17763C1.125 13.625 4.73029 17.2303 9.17763 17.2303Z",
                stroke: "currentColor",
                strokeWidth: "2.25"
            })
        ]
    });
const $e6c01637ddd40d01$var$SearchClearButton = ({ onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const label = intl.formatMessage({
        id: 'SearchCloseButton.label',
        defaultMessage: 'Clear search'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        onClick: onClick,
        "aria-label": label,
        "data-testid": "search-close-button",
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "searchCloseButton",
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _syazk553 _30l3k553"
        ]),
        style: {
            "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
            size: "16",
            className: (0, $2jatx.default)([
                "_syaz1pfd _2rko1ssb _4t3i1wug"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            }
        })
    });
};
// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------
const $e6c01637ddd40d01$var$searchFieldStyle = null;
const $e6c01637ddd40d01$var$submitButtonStyle = null;
const $e6c01637ddd40d01$var$submitIconWrapperStyle = null;
const $e6c01637ddd40d01$var$clearButtonStyle = null;
const $e6c01637ddd40d01$var$clearIconStyle = null;

});

parcelRegister("7EuEV", function(module, exports) {
$parcel$export(module.exports, "SortControl", function () { return $7853d66fe8b17701$export$b0d8abc8911a4de9; });
/* sort-control.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $7853d66fe8b17701$export$b0d8abc8911a4de9 = ({ sorts: sorts, selectedSortId: selectedSortId, onChange: onChange })=>{
    if (sorts.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zulpu2gc _1wyboxwj"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: "Sort by"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                value: selectedSortId ?? '',
                onChange: (event)=>onChange(event.target.value),
                className: (0, $2jatx.default)([
                    "_19itj0fz _2rko1y44 _1yt418iy _11q7vuon _80omtlke"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                        value: "",
                        children: "None"
                    }),
                    sorts.map((sort)=>/*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                            value: sort.id,
                            children: sort.label
                        }, sort.id))
                ]
            })
        ]
    });
};
const $7853d66fe8b17701$var$sortControlStyle = null;
const $7853d66fe8b17701$var$sortSelectStyle = null;

});


parcelRegister("iPbWG", function(module, exports) {
$parcel$export(module.exports, "useFilterState", function () { return $31df0a65d93a9831$export$486dfeb2d6bb2b9b; });

var $1oC0p = parcelRequire("1oC0p");

var $cP432 = parcelRequire("cP432");

var $H7SCD = parcelRequire("H7SCD");

var $iSHOM = parcelRequire("iSHOM");

var $7Ofoh = parcelRequire("7Ofoh");

var $3MZcV = parcelRequire("3MZcV");
const $31df0a65d93a9831$export$486dfeb2d6bb2b9b = ({ items: items, filterDefs: filterDefs, urlSync: urlSync, optionsDataSources: optionsDataSources })=>{
    const fireFilterClickAnalytics = (0, $7Ofoh.useFireFilterClickAnalytics)();
    const [filterObject, setFilterObject] = (0, $1oC0p.useState)(()=>(0, $H7SCD.buildUniformFilterObject)(items, filterDefs, optionsDataSources));
    const [searchQuery, setSearchQuery] = (0, $1oC0p.useState)('');
    const [selectedSortId, setSelectedSortId] = (0, $1oC0p.useState)();
    const [dropdownVisibility, setDropdownVisibility] = (0, $1oC0p.useState)({});
    // The page the URL asks for. The paginated gallery owns the live page; this
    // only carries the URL value in on mount and on browser back/forward.
    const [urlPage, setUrlPage] = (0, $1oC0p.useState)((0, $3MZcV.FIRST_PAGE));
    const closedDropdownState = (0, $1oC0p.useMemo)(()=>Object.fromEntries(filterDefs.map((def)=>[
                def.id,
                false
            ])), [
        filterDefs
    ]);
    // Rebuild filter options when the filter schema or data shape changes,
    // preserving any existing user selections for options that still exist.
    // We use item count as a proxy for "items actually changed" to avoid
    // resetting selections when Uniform recreates data object references
    // on re-renders without changing the actual item set.
    const itemCount = items.length;
    (0, $1oC0p.useEffect)(()=>{
        const fresh = (0, $H7SCD.buildUniformFilterObject)(items, filterDefs, optionsDataSources);
        setFilterObject((prev)=>{
            // Merge: carry over existing selections for options that still exist.
            const merged = Object.fromEntries(Object.entries(fresh).map(([filterId, subFilter])=>[
                    filterId,
                    Object.fromEntries(Object.entries(subFilter).map(([optionId, option])=>[
                            optionId,
                            prev[filterId]?.[optionId] ?? option
                        ]))
                ]));
            // Bail out (return the same reference) when content is unchanged.
            // filterDefs/optionsDataSources come from Uniform $block props that
            // aren't guaranteed reference-stable across renders — without this
            // check, a fresh-but-equal object here re-triggers this effect on
            // every render (setState -> re-render -> new prop refs -> setState...),
            // an infinite update loop that leaves cards stuck at their entrance
            // animation's opacity:0.
            return $31df0a65d93a9831$var$isFilterObjectEqual(merged, prev) ? prev : merged;
        });
        const freshDropdownVisibility = Object.fromEntries(filterDefs.map((def)=>[
                def.id,
                false
            ]));
        setDropdownVisibility((prev)=>$31df0a65d93a9831$var$isDropdownVisibilityEqual(freshDropdownVisibility, prev) ? prev : freshDropdownVisibility);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        itemCount,
        filterDefs,
        optionsDataSources
    ]);
    // Disable URL sync in Uniform preview — writing query params breaks the preview iframe.
    // Computed once on mount via useRef since the preview state never changes mid-session.
    const isUniformPreviewRef = (0, $1oC0p.useRef)(typeof window !== 'undefined' && window.location.pathname.includes('/uniform-preview'));
    const effectiveUrlSync = urlSync && !isUniformPreviewRef.current;
    // Hydrate from URL on mount + on browser back/forward.
    (0, $1oC0p.useEffect)(()=>{
        if (!effectiveUrlSync || typeof window === 'undefined') return;
        const hydrate = ()=>{
            const urlState = (0, $iSHOM.readStateFromUrl)(window.location.search, filterDefs);
            setFilterObject((prev)=>(0, $iSHOM.filtersToUniformFilterObject)(urlState.filters, prev));
            setSearchQuery(urlState.query);
            setSelectedSortId(urlState.sortId);
            setUrlPage(urlState.page ?? (0, $3MZcV.FIRST_PAGE));
        };
        hydrate();
        window.addEventListener('popstate', hydrate);
        return ()=>window.removeEventListener('popstate', hydrate);
    }, [
        urlSync,
        filterDefs
    ]);
    const isAnyDropdownOpen = Object.values(dropdownVisibility).some(Boolean);
    // Every filter, search, or sort change writes page one: the paginated
    // gallery resets to page one on the same change, so the URL must agree.
    const pushUrl = (nextFilterObject, nextQuery, nextSortId, nextPage = (0, $3MZcV.FIRST_PAGE))=>{
        if (!effectiveUrlSync) return;
        (0, $iSHOM.writeStateToUrl)({
            filters: (0, $iSHOM.uniformFilterObjectToFlat)(nextFilterObject),
            query: nextQuery,
            sortId: nextSortId,
            page: nextPage
        });
    };
    /** Writes a page change next to the current filters, query, and sort. */ const pushPage = (nextPage)=>{
        pushUrl(filterObject, searchQuery, selectedSortId, nextPage);
    };
    // The GALLERY_SEARCH_EVENT listener subscribes once on mount, so route the
    // event through a ref that always holds the latest handler. This keeps
    // `filterObject`/`selectedSortId`/`pushUrl` fresh without re-subscribing.
    const handleGallerySearchRef = (0, $1oC0p.useRef)(()=>{});
    handleGallerySearchRef.current = (query)=>{
        const nextQuery = query ?? '';
        setSearchQuery(nextQuery);
        // A non-empty search clears filters (like the gallery's own submit),
        // so it ranks the full set — matching the search bar's suggestions.
        const nextFilterObject = nextQuery.trim() ? $31df0a65d93a9831$var$mapAllOptionsToInactive(filterObject) : filterObject;
        if (nextFilterObject !== filterObject) setFilterObject(nextFilterObject);
        // Mirror the new search state into the URL so a refresh or shared link
        // doesn't re-hydrate the now-cleared filters or the previous query.
        pushUrl(nextFilterObject, nextQuery, selectedSortId);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const listener = (e)=>handleGallerySearchRef.current(e.detail.query);
        window.addEventListener((0, $cP432.GALLERY_SEARCH_EVENT), listener);
        return ()=>window.removeEventListener((0, $cP432.GALLERY_SEARCH_EVENT), listener);
    }, []);
    const handleFilterButtonClick = (filterId)=>{
        fireFilterClickAnalytics(filterId);
        setDropdownVisibility((prev)=>({
                ...closedDropdownState,
                [filterId]: !prev[filterId]
            }));
    };
    const toggleFilterOption = (filterId, optionId)=>{
        setFilterObject((prev)=>{
            const subFilter = prev[filterId] ?? {};
            const current = subFilter[optionId];
            const nextActive = !current?.stagedActive;
            const next = {
                ...prev,
                [filterId]: {
                    ...subFilter,
                    [optionId]: {
                        committedActive: nextActive,
                        stagedActive: nextActive
                    }
                }
            };
            // Commit and push URL immediately so filters apply on selection,
            // not on dropdown close.
            pushUrl(next, searchQuery, selectedSortId);
            return next;
        });
    };
    const clearFilter = (filterId)=>{
        const cleared = $31df0a65d93a9831$var$mapAllOptionsToInactive({
            [filterId]: filterObject[filterId] ?? {}
        });
        const next = {
            ...filterObject,
            ...cleared
        };
        setFilterObject(next);
        pushUrl(next, searchQuery, selectedSortId);
    };
    const clearAllFilters = ()=>{
        const cleared = $31df0a65d93a9831$var$mapAllOptionsToInactive(filterObject);
        setFilterObject(cleared);
        pushUrl(cleared, searchQuery, selectedSortId);
    };
    const handleSearchSubmit = ()=>{
        const nextFilterObject = searchQuery ? $31df0a65d93a9831$var$mapAllOptionsToInactive(filterObject) : filterObject;
        setFilterObject(nextFilterObject);
        pushUrl(nextFilterObject, searchQuery, selectedSortId);
    };
    const handleSearchClear = ()=>{
        setSearchQuery('');
        pushUrl(filterObject, '', selectedSortId);
    };
    const handleSortChange = (nextSortId)=>{
        setSelectedSortId(nextSortId);
        pushUrl(filterObject, searchQuery, nextSortId);
    };
    const closeAllDropdownsAndCommit = ()=>{
        setDropdownVisibility(closedDropdownState);
    };
    return {
        filterObject: filterObject,
        searchQuery: searchQuery,
        selectedSortId: selectedSortId,
        dropdownVisibility: dropdownVisibility,
        isAnyDropdownOpen: isAnyDropdownOpen,
        setSearchQuery: setSearchQuery,
        handleFilterButtonClick: handleFilterButtonClick,
        toggleFilterOption: toggleFilterOption,
        clearFilter: clearFilter,
        clearAllFilters: clearAllFilters,
        handleSearchSubmit: handleSearchSubmit,
        handleSearchClear: handleSearchClear,
        handleSortChange: handleSortChange,
        closeAllDropdownsAndCommit: closeAllDropdownsAndCommit,
        urlPage: urlPage,
        pushPage: pushPage
    };
};
const $31df0a65d93a9831$var$isFilterObjectEqual = (a, b)=>{
    const filterIds = Object.keys(a);
    if (filterIds.length !== Object.keys(b).length) return false;
    return filterIds.every((filterId)=>{
        const aSubFilter = a[filterId] ?? {};
        const bSubFilter = b[filterId] ?? {};
        const optionIds = Object.keys(aSubFilter);
        if (optionIds.length !== Object.keys(bSubFilter).length) return false;
        return optionIds.every((optionId)=>{
            const aOption = aSubFilter[optionId];
            const bOption = bSubFilter[optionId];
            return aOption?.committedActive === bOption?.committedActive && aOption?.stagedActive === bOption?.stagedActive;
        });
    });
};
const $31df0a65d93a9831$var$isDropdownVisibilityEqual = (a, b)=>{
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((key)=>a[key] === b[key]);
};
const $31df0a65d93a9831$var$mapAllOptionsToInactive = (state)=>Object.fromEntries(Object.entries(state).map(([filterId, subFilter])=>[
            filterId,
            Object.fromEntries(Object.keys(subFilter ?? {}).map((optionId)=>[
                    optionId,
                    {
                        committedActive: false,
                        stagedActive: false
                    }
                ]))
        ]));

});
parcelRegister("cP432", function(module, exports) {
$parcel$export(module.exports, "GALLERY_SEARCH_EVENT", function () { return $d46df9a41fa8d9aa$export$5f4885e91e9f6714; });
const $d46df9a41fa8d9aa$export$5f4885e91e9f6714 = 'filterable-gallery-search';

});

parcelRegister("3MZcV", function(module, exports) {
$parcel$export(module.exports, "FIRST_PAGE", function () { return $56390272562fff54$export$5251f4527bc04956; });
$parcel$export(module.exports, "useGalleryPagination", function () { return $56390272562fff54$export$bd65c968246cab57; });

var $1oC0p = parcelRequire("1oC0p");

var $iSHOM = parcelRequire("iSHOM");
const $56390272562fff54$export$5251f4527bc04956 = 1;
function $56390272562fff54$export$b287f0ca5dbff6af(itemCount, pageSize) {
    if (!Number.isFinite(pageSize) || pageSize < 1) return $56390272562fff54$export$5251f4527bc04956;
    return Math.max($56390272562fff54$export$5251f4527bc04956, Math.ceil(Math.max(0, itemCount) / pageSize));
}
function $56390272562fff54$export$37065cd88a320a11(page, pageCount) {
    if (page === undefined || !Number.isFinite(page)) return $56390272562fff54$export$5251f4527bc04956;
    const integerPage = Math.floor(page);
    if (integerPage < $56390272562fff54$export$5251f4527bc04956) return $56390272562fff54$export$5251f4527bc04956;
    return Math.min(integerPage, Math.max($56390272562fff54$export$5251f4527bc04956, pageCount));
}
function $56390272562fff54$export$e100553742dcdf79(items, page, pageSize) {
    const start = (page - $56390272562fff54$export$5251f4527bc04956) * pageSize;
    return items.slice(start, start + pageSize);
}
function $56390272562fff54$export$d2bdb7c20492cc5({ items: items, pageSize: pageSize, resetKey: resetKey, externalPage: externalPage, totalHint: totalHint }) {
    const [requestedPage, setRequestedPage] = (0, $1oC0p.useState)(()=>$56390272562fff54$export$37065cd88a320a11(externalPage, Number.POSITIVE_INFINITY));
    const itemCount = Math.max(items.length, totalHint ?? 0);
    const pageCount = $56390272562fff54$export$b287f0ca5dbff6af(itemCount, pageSize);
    const currentPage = $56390272562fff54$export$37065cd88a320a11(requestedPage, pageCount);
    // Skip the mount: the initial state already honours `externalPage`.
    const previousResetKeyRef = (0, $1oC0p.useRef)(resetKey);
    (0, $1oC0p.useEffect)(()=>{
        if (previousResetKeyRef.current === resetKey) return;
        previousResetKeyRef.current = resetKey;
        setRequestedPage($56390272562fff54$export$5251f4527bc04956);
    }, [
        resetKey
    ]);
    // Declared after the reset effect on purpose: both fire in the same commit
    // when a URL hydrates filters and page together, and the last write wins.
    (0, $1oC0p.useEffect)(()=>{
        if (externalPage === undefined) return;
        setRequestedPage($56390272562fff54$export$37065cd88a320a11(externalPage, Number.POSITIVE_INFINITY));
    }, [
        externalPage
    ]);
    const setPage = (0, $1oC0p.useCallback)((page)=>{
        setRequestedPage($56390272562fff54$export$37065cd88a320a11(page, Number.POSITIVE_INFINITY));
    }, []);
    const pageNumbers = (0, $1oC0p.useMemo)(()=>Array.from({
            length: pageCount
        }, (_, index)=>index + $56390272562fff54$export$5251f4527bc04956), [
        pageCount
    ]);
    const pageItems = (0, $1oC0p.useMemo)(()=>$56390272562fff54$export$e100553742dcdf79(items, currentPage, pageSize), [
        items,
        currentPage,
        pageSize
    ]);
    return {
        currentPage: currentPage,
        pageCount: pageCount,
        pageNumbers: pageNumbers,
        pageItems: pageItems,
        setPage: setPage
    };
}
function $56390272562fff54$export$bd65c968246cab57({ isPaginated: isPaginated, items: items, loadedItemCount: loadedItemCount, pageSize: pageSize, filterObject: filterObject, searchQuery: searchQuery, sortId: sortId, urlPage: urlPage, hasUnfetchedItems: hasUnfetchedItems, resourceTotal: resourceTotal }) {
    const resetKey = (0, $1oC0p.useMemo)(()=>JSON.stringify([
            (0, $iSHOM.uniformFilterObjectToFlat)(filterObject),
            searchQuery,
            sortId
        ]), [
        filterObject,
        searchQuery,
        sortId
    ]);
    const isNarrowed = items.length !== loadedItemCount;
    const totalHint = $56390272562fff54$var$getTotalHint(isPaginated, hasUnfetchedItems, isNarrowed, resourceTotal);
    return $56390272562fff54$export$d2bdb7c20492cc5({
        items: items,
        pageSize: pageSize ?? Number.POSITIVE_INFINITY,
        resetKey: resetKey,
        externalPage: isPaginated ? urlPage : undefined,
        totalHint: totalHint
    });
}
function $56390272562fff54$var$getTotalHint(isPaginated, hasUnfetchedItems, isNarrowed, resourceTotal) {
    if (!isPaginated || !hasUnfetchedItems || isNarrowed) return undefined;
    return resourceTotal;
}

});


parcelRegister("ddUw7", function(module, exports) {
$parcel$export(module.exports, "useOutsideClick", function () { return $366b8f49f7729ef5$export$71b2224f1ce5e08e; });

var $1oC0p = parcelRequire("1oC0p");
const $366b8f49f7729ef5$export$71b2224f1ce5e08e = ({ isActive: isActive, insideMarkerAttribute: insideMarkerAttribute, onOutsideClick: onOutsideClick })=>{
    const onOutsideClickRef = (0, $1oC0p.useRef)(onOutsideClick);
    onOutsideClickRef.current = onOutsideClick;
    (0, $1oC0p.useEffect)(()=>{
        if (!isActive) return;
        const handleClick = (event)=>{
            const clickedInside = $366b8f49f7729ef5$var$isElementInsideMarkedAncestor(event.target, insideMarkerAttribute);
            if (!clickedInside) onOutsideClickRef.current();
        };
        document.addEventListener('click', handleClick);
        return ()=>document.removeEventListener('click', handleClick);
    }, [
        isActive,
        insideMarkerAttribute
    ]);
};
/**
 * Walks up from `target` until it finds an ancestor carrying
 * `markerAttribute`, or hits the document body. Returns true if the marker
 * was found along the way.
 */ const $366b8f49f7729ef5$var$isElementInsideMarkedAncestor = (target, markerAttribute)=>{
    let currentNode = target;
    while(currentNode && currentNode.nodeName !== 'BODY'){
        if (currentNode.hasAttribute(markerAttribute)) return true;
        currentNode = currentNode.parentElement;
    }
    return false;
};

});


parcelRegister("ccVGG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("hTiWM")).default; });

var $hTiWM = parcelRequire("hTiWM");

});
parcelRegister("hTiWM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $08b31e9a84ad8ff1$export$2e2bcd8739ae039; });
/* filterable-item.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $7sd2h = parcelRequire("7sd2h");

var $lG1Of = parcelRequire("lG1Of");
const $08b31e9a84ad8ff1$var$FilterableItem = ({ data: data, fullHeight: fullHeight = false })=>{
    const registry = (0, $lG1Of.useFilterableItemRegistry)();
    const index = (0, $1oC0p.useContext)((0, $lG1Of.FilterableItemIndexContext));
    const isFullHeight = $08b31e9a84ad8ff1$var$resolveBooleanParameter(fullHeight, false);
    (0, $1oC0p.useEffect)(()=>{
        if (!registry) return;
        registry.registerItem(index, data);
        return ()=>registry.unregisterItem(index);
    }, [
        registry,
        index,
        data
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7sd2h.FilterableCardItemDataContext).Provider, {
        value: data,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                isFullHeight && "_4t3i1osq _1e0c11p5"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "content"
            })
        })
    });
};
const $08b31e9a84ad8ff1$var$resolveBooleanParameter = (parameter, defaultValue)=>{
    if (typeof parameter === 'boolean') return parameter;
    if (typeof parameter?.value === 'boolean') return parameter.value;
    return defaultValue;
};
const $08b31e9a84ad8ff1$var$fullHeightStyle = null;
var $08b31e9a84ad8ff1$export$2e2bcd8739ae039 = $08b31e9a84ad8ff1$var$FilterableItem;

});


parcelRegister("lmfaS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1dc2bad774e96e47$export$2e2bcd8739ae039; });
/**
 * Structural Uniform components are interpreted and rendered by the parent form.
 * Returning null prevents a field definition from rendering outside that parent.
 */ const $1dc2bad774e96e47$export$cd717ba7e73eb4e6 = ()=>null;
var $1dc2bad774e96e47$export$2e2bcd8739ae039 = $1dc2bad774e96e47$export$cd717ba7e73eb4e6;

});

parcelRegister("3wi1O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $903d212917d1712a$export$2e2bcd8739ae039; });
/* uniform-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $dZNgt = parcelRequire("dZNgt");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $flZAN = parcelRequire("flZAN");

var $5Ntyw = parcelRequire("5Ntyw");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $lTkkF = parcelRequire("lTkkF");

var $jsxHL = parcelRequire("jsxHL");

var $eRzlV = parcelRequire("eRzlV");

var $6Q2bE = parcelRequire("6Q2bE");

var $3siaX = parcelRequire("3siaX");

var $5nFGj = parcelRequire("5nFGj");

var $8yzBO = parcelRequire("8yzBO");
const $903d212917d1712a$var$DEFAULT_ANALYTICS_LABEL = 'Form';
// Until consent-config resolves, require an explicit opt-in so consent is never assumed.
const $903d212917d1712a$var$DEFAULT_CONSENT_CONFIG = {
    locale: 'UNKNOWN',
    localeRequiresMarketingCommunicationOptIn: true
};
const $903d212917d1712a$var$formCss = null;
const $903d212917d1712a$var$headingCss = null;
const $903d212917d1712a$var$fieldsCss = null;
const $903d212917d1712a$var$fullWidthCss = null;
const $903d212917d1712a$var$fieldCss = null;
const $903d212917d1712a$var$labelCss = null;
const $903d212917d1712a$var$nameFieldsCss = null;
const $903d212917d1712a$var$controlCss = null;
const $903d212917d1712a$var$selectCss = null;
const $903d212917d1712a$var$textAreaCss = null;
const $903d212917d1712a$var$requiredCss = null;
const $903d212917d1712a$var$fieldsetCss = null;
const $903d212917d1712a$var$legendCss = null;
const $903d212917d1712a$var$optionCss = null;
const $903d212917d1712a$var$radioCss = null;
const $903d212917d1712a$var$checkboxCss = null;
const $903d212917d1712a$var$choiceOptionColumnsCss = null;
const $903d212917d1712a$var$checkboxLabelCss = null;
const $903d212917d1712a$var$conditionalFieldsCss = null;
const $903d212917d1712a$var$honeypotCss = null;
const $903d212917d1712a$var$legalCss = null;
const $903d212917d1712a$var$alertCss = null;
const $903d212917d1712a$var$actionCss = null;
const $903d212917d1712a$var$successCss = null;
const $903d212917d1712a$var$datePickerCss = null;
const $903d212917d1712a$var$FieldShell = ({ children: children, error: error, helpText: helpText, id: id, label: label, required: required, width: width })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul9idpf _1i82inbi _110eoqnp _1w8l1nn1 _6yb81cby _15loidpf _hp70idpf _1j73idpf _154midpf _1umk1d19 _1wgloqnp _99wb1nn1 _15x21cby _1vt3idpf _1sj5idpf _9cftidpf _1bzqidpf",
            width === 'full' && "_yyhyjvu9"
        ]),
        style: {
            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                htmlFor: id,
                className: (0, $2jatx.default)([
                    "_1wyboxwj _k48pbfng _vwz41k92"
                ]),
                children: [
                    label,
                    required && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_syaz1d19 _1e0c1nu9 _bozgv77o _s7n41q9y"
                        ]),
                        style: {
                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                        },
                        children: "*"
                    })
                ]
            }),
            children,
            helpText && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "helpText",
                id: `${id}-help`,
                children: helpText
            }),
            error && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "error",
                id: `${id}-error`,
                children: error
            })
        ]
    });
};
const $903d212917d1712a$var$RenderFields = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: props.fields.map((field)=>/*#__PURE__*/ (0, $7VQPk.jsx)($903d212917d1712a$var$RenderField, {
                ...props,
                field: field
            }, field.id))
    });
const $903d212917d1712a$var$RenderField = ({ clearErrors: clearErrors, errors: errors, field: field, getId: getId, setValue: setValue, values: values })=>{
    const intl = (0, $8e22h.default)();
    const inputProps = (key, id, hasHelpText = false)=>({
            'aria-describedby': [
                hasHelpText ? `${id}-help` : '',
                errors[key] ? `${id}-error` : ''
            ].filter(Boolean).join(' ') || undefined,
            'aria-invalid': Boolean(errors[key]),
            'data-field': key,
            id: id,
            name: key
        });
    const updateText = (key)=>(event)=>{
            setValue(key, event.target.value);
            clearErrors();
        };
    if (field.type === 'formNamesFields') return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _zulppxbi _yv0ehkll _1rqt9sye",
            field.width === 'full' && "_yyhyjvu9"
        ]),
        children: [
            'firstName',
            'lastName'
        ].map((key)=>{
            const id = getId(key, field.id);
            const label = intl.formatMessage(key === 'firstName' ? (0, $6Q2bE.uniformFormMessages).firstName : (0, $6Q2bE.uniformFormMessages).lastName);
            return /*#__PURE__*/ (0, $7VQPk.jsx)($903d212917d1712a$var$FieldShell, {
                error: errors[key],
                id: id,
                label: label,
                required: field.required,
                width: "half",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                    ...inputProps(key, id),
                    autoComplete: key === 'firstName' ? 'given-name' : 'family-name',
                    onChange: updateText(key),
                    required: field.required,
                    type: "text",
                    value: String(values[key] ?? ''),
                    className: (0, $2jatx.default)([
                        "_r06hglyw _bfhk1afi _19it79pa _2rko1ylz _vchhusvi _syaz1pfd _1e0c1ule _ect4z4z1 _1wyb1j6v _k48p1nn1 _vwz41k8s _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1osq _1tke1jfw _1ul9idpf _1yt4s8vo _1bsb1osq _858u5hrz _nt751r31 _49pcglyw _1hvw1o36 _pojj5hrz _1ygb1qgu _1ah312gs _srxe1d19 _1qo0p6ku"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                        "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                        "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                    }
                })
            }, key);
        })
    });
    const key = field.type === 'formEmailField' ? 'email' : field.type === 'formCompanyField' ? 'company' : field.type === 'formPhoneNumberField' ? 'number' : field.payloadKey;
    const id = getId(key, field.id);
    const required = field.type === 'formEmailField' || field.required;
    const label = field.type === 'formEmailField' ? field.label ?? intl.formatMessage((0, $6Q2bE.uniformFormMessages).email) : field.type === 'formCompanyField' ? field.label ?? intl.formatMessage((0, $6Q2bE.uniformFormMessages).company) : field.type === 'formPhoneNumberField' ? intl.formatMessage((0, $6Q2bE.uniformFormMessages).phone) : field.label;
    if (field.type === 'formCustomChoiceField' || field.type === 'formCountryOrStateField') return /*#__PURE__*/ (0, $7VQPk.jsx)($903d212917d1712a$var$ChoiceField, {
        clearErrors: clearErrors,
        errors: errors,
        field: field,
        getId: getId,
        setValue: setValue,
        values: values
    });
    if (field.type === 'formDatepickerField') return /*#__PURE__*/ (0, $7VQPk.jsx)($903d212917d1712a$var$FieldShell, {
        error: errors[key],
        helpText: field.helpText,
        id: id,
        label: label,
        required: required,
        width: field.width,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1gh5glyw _q1j21afi _i37k79pa _1h3z1ylz _4hlkusvi _19ce1pfd _68mp1ule _14j2z4z1 _9kfr1j6v _39vd1nn1 _nto81k8s _ej9oidpf _7mn9idpf _e8svidpf _ety7idpf _1lxa1osq _zmtn1jfw _fyazidpf _7b9ns8vo _1hbl1osq _ugjt5hrz _pyws1r31 _134oglyw _yx3j1o36 _1u2h5hrz _clq81qgu _14bd12gs _q5gj1d19 _n58sp6ku _68mp1txw _yisn1j6v"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flZAN.default), {
                id: id,
                testId: `${field.id}-datepicker`,
                isInvalid: Boolean(errors[key]),
                locale: intl.locale,
                name: key,
                onChange: (value)=>{
                    setValue(key, value);
                    clearErrors();
                },
                placeholder: ' ',
                selectProps: {
                    'aria-invalid': Boolean(errors[key]),
                    inputId: id,
                    isSearchable: false
                },
                value: String(values[key] ?? '')
            })
        })
    });
    const isCustomText = field.type === 'formCustomTextField';
    const helpText = isCustomText ? field.helpText : undefined;
    const placeholder = isCustomText ? field.placeholder : undefined;
    const common = {
        ...inputProps(key, id, Boolean(helpText)),
        autoComplete: field.type === 'formEmailField' ? 'email' : field.type === 'formCompanyField' ? 'organization' : field.type === 'formPhoneNumberField' ? 'tel' : undefined,
        onChange: updateText(key),
        placeholder: placeholder,
        required: required,
        value: String(values[key] ?? '')
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($903d212917d1712a$var$FieldShell, {
        error: errors[key],
        helpText: helpText,
        id: id,
        label: label,
        required: required,
        width: field.width,
        children: isCustomText && field.multiline ? /*#__PURE__*/ (0, $7VQPk.jsx)("textarea", {
            ...common,
            className: (0, $2jatx.default)([
                "_r06hglyw _bfhk1afi _19it79pa _2rko1ylz _vchhusvi _syaz1pfd _1e0c1ule _ect4z4z1 _1wyb1j6v _k48p1nn1 _vwz41k8s _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1osq _1tke1jfw _1ul9idpf _1yt4s8vo _1bsb1osq _858u5hrz _nt751r31 _49pcglyw _1hvw1o36 _pojj5hrz _1ygb1qgu _1ah312gs _srxe1d19 _1qo0p6ku",
                "_1tke1epz _1rjcu2gc _14zg1e54"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
            }
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
            ...common,
            type: field.type === 'formEmailField' ? 'email' : field.type === 'formPhoneNumberField' ? 'tel' : 'text',
            className: (0, $2jatx.default)([
                "_r06hglyw _bfhk1afi _19it79pa _2rko1ylz _vchhusvi _syaz1pfd _1e0c1ule _ect4z4z1 _1wyb1j6v _k48p1nn1 _vwz41k8s _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1osq _1tke1jfw _1ul9idpf _1yt4s8vo _1bsb1osq _858u5hrz _nt751r31 _49pcglyw _1hvw1o36 _pojj5hrz _1ygb1qgu _1ah312gs _srxe1d19 _1qo0p6ku"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
            }
        })
    });
};
const $903d212917d1712a$var$getRadioOrCheckboxColumns = (field)=>field.type === 'formCustomChoiceField' ? field.radioOrCheckboxColumns ?? 1 : 1;
const $903d212917d1712a$var$getCustomChoiceDisplay = (field)=>field.type === 'formCustomChoiceField' ? {
        helpText: field.helpText,
        placeholder: field.placeholder
    } : {
        helpText: undefined,
        placeholder: undefined
    };
const $903d212917d1712a$var$ChoiceField = ({ clearErrors: clearErrors, errors: errors, field: field, getId: getId, setValue: setValue, values: values })=>{
    const intl = (0, $8e22h.default)();
    const id = getId(field.payloadKey, field.id);
    const { helpText: helpText, placeholder: placeholder } = $903d212917d1712a$var$getCustomChoiceDisplay(field);
    const radioOrCheckboxColumns = $903d212917d1712a$var$getRadioOrCheckboxColumns(field);
    const selected = values[field.payloadKey];
    const selectedValues = Array.isArray(selected) ? selected : selected ? [
        selected
    ] : [];
    const conditionalFields = field.options.flatMap((option)=>selectedValues.includes(option.value) ? option.conditionalFields : []);
    const setChoice = (value)=>{
        setValue(field.payloadKey, value);
        clearErrors();
    };
    const describedBy = [
        helpText ? `${id}-help` : '',
        errors[field.payloadKey] ? `${id}-error` : ''
    ].filter(Boolean).join(' ') || undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul9idpf _1i82inbi _110eoqnp _1w8l1nn1 _6yb81cby _15loidpf _hp70idpf _1j73idpf _154midpf _1umk1d19 _1wgloqnp _99wb1nn1 _15x21cby _1vt3idpf _1sj5idpf _9cftidpf _1bzqidpf",
                    field.width === 'full' && "_yyhyjvu9"
                ]),
                style: {
                    "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                    "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                },
                children: [
                    field.controlType === 'select' ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                                htmlFor: id,
                                className: (0, $2jatx.default)([
                                    "_1wyboxwj _k48pbfng _vwz41k92"
                                ]),
                                children: [
                                    field.label,
                                    field.required && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: (0, $2jatx.default)([
                                            "_syaz1d19 _1e0c1nu9 _bozgv77o _s7n41q9y"
                                        ]),
                                        style: {
                                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                        },
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                                'aria-describedby': describedBy,
                                'aria-invalid': Boolean(errors[field.payloadKey]),
                                "data-field": field.payloadKey,
                                id: id,
                                name: field.payloadKey,
                                onChange: (event)=>setChoice(event.target.value),
                                required: field.required,
                                value: String(selected ?? ''),
                                className: (0, $2jatx.default)([
                                    "_r06hglyw _bfhk1afi _19it79pa _2rko1ylz _vchhusvi _syaz1pfd _1e0c1ule _ect4z4z1 _1wyb1j6v _k48p1nn1 _vwz41k8s _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1osq _1tke1jfw _1ul9idpf _1yt4s8vo _1bsb1osq _858u5hrz _nt751r31 _49pcglyw _1hvw1o36 _pojj5hrz _1ygb1qgu _1ah312gs _srxe1d19 _1qo0p6ku",
                                    "_1itkq0nh _ouxl1vge _12vemgnk _1lrw1u5s _y4tixy5q"
                                ]),
                                style: {
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                    "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                    "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                        value: "",
                                        children: placeholder ?? intl.formatMessage((0, $6Q2bE.uniformFormMessages).selectPlaceholder)
                                    }),
                                    field.options.map((option)=>/*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                            value: option.value,
                                            children: option.label
                                        }, option.id))
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("fieldset", {
                        "aria-describedby": describedBy,
                        className: (0, $2jatx.default)([
                            "_19itidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("legend", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1j6v _k48pni7l _vwz41k8s _6rthutpp _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                ]),
                                children: [
                                    field.label,
                                    field.required && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: (0, $2jatx.default)([
                                            "_syaz1d19 _1e0c1nu9 _bozgv77o _s7n41q9y"
                                        ]),
                                        style: {
                                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                        },
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                style: {
                                    '--option-columns': radioOrCheckboxColumns
                                },
                                className: (0, $2jatx.default)([
                                    "_1bbdb448 _1e79kb7n"
                                ]),
                                children: field.options.map((option)=>{
                                    const checked = selectedValues.includes(option.value);
                                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                                        className: (0, $2jatx.default)([
                                            "_4cvr1y6m _ltoz1xki _80omtlke _1e0c1txw _1wyboxwj _zulpu2gc _vwz41k92 _1pfhidpf _6rthu2gc"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                                "aria-invalid": Boolean(errors[field.payloadKey]),
                                                checked: checked,
                                                "data-field": field.payloadKey,
                                                name: field.payloadKey,
                                                onChange: (event)=>setChoice(field.controlType === 'radio' ? option.value : event.target.checked ? [
                                                        ...selectedValues,
                                                        option.value
                                                    ] : selectedValues.filter((value)=>value !== option.value)),
                                                type: field.controlType === 'radio' ? 'radio' : 'checkbox',
                                                value: option.value,
                                                className: (0, $2jatx.default)([
                                                    field.controlType === 'radio' && "_12yz5hrz _16jlidpf _1o9zidpf _i0dl1wug _4t3iv47k _18s81c53 _1bsbv47k",
                                                    field.controlType === 'checkboxGroup' && "_12yz5hrz _16jlidpf _1o9zidpf _i0dl1wug _4t3ipxbi _18s81c53 _1bsbpxbi"
                                                ]),
                                                style: {
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: option.label
                                            })
                                        ]
                                    }, option.id);
                                })
                            })
                        ]
                    }),
                    helpText && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "helpText",
                        id: `${id}-help`,
                        children: helpText
                    }),
                    errors[field.payloadKey] && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "error",
                        id: `${id}-error`,
                        children: errors[field.payloadKey]
                    })
                ]
            }),
            conditionalFields.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1bgi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($903d212917d1712a$var$RenderFields, {
                    clearErrors: clearErrors,
                    errors: errors,
                    fields: conditionalFields,
                    getId: getId,
                    setValue: setValue,
                    values: values
                })
            })
        ]
    });
};
const $903d212917d1712a$var$UniformForm = ({ alignment: alignment = 'start', buttonVariant: buttonVariant = 'primary', component: component, consentMode: consentMode = 'none', customEndpoint: customEndpoint, formHeader: formHeader, formId: formId, formType: formType, intercomAppId: intercomAppId, intercomTracking: intercomTracking = false, label: label = $903d212917d1712a$var$DEFAULT_ANALYTICS_LABEL, legalCopyOverride: legalCopyOverride, submitLabel: submitLabel, submissionEndpoint: submissionEndpoint, successButtonText: successButtonText, successButtonUrl: successButtonUrl, successMessage: successMessage })=>{
    const intl = (0, $8e22h.default)();
    const client = (0, $5Ntyw.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const fieldIdPrefix = (0, $1oC0p.useId)().replace(/:/g, '');
    const formRef = (0, $1oC0p.useRef)(null);
    const terminalRef = (0, $1oC0p.useRef)(null);
    const [values, setValues] = (0, $1oC0p.useState)({
        alternateEmail: '',
        marketingOptIn: 'false'
    });
    const [errors, setErrors] = (0, $1oC0p.useState)({});
    const [status, setStatus] = (0, $1oC0p.useState)('ready');
    const alignedContentCss = null;
    const fields = (0, $1oC0p.useMemo)(()=>(0, $3siaX.getFormFields)(component), [
        component
    ]);
    const configurationIssues = (0, $1oC0p.useMemo)(()=>[
            ...(0, $8yzBO.validateFormConfiguration)({
                fields: fields,
                formId: formId,
                formType: formType,
                intercomAppId: intercomAppId,
                intercomTracking: intercomTracking
            }),
            ...submissionEndpoint === 'custom' && !customEndpoint?.trim() ? [
                'customEndpoint is required when submissionEndpoint is custom'
            ] : []
        ], [
        customEndpoint,
        fields,
        formId,
        formType,
        intercomAppId,
        intercomTracking,
        submissionEndpoint
    ]);
    const getId = (key, fieldId = '')=>`${fieldIdPrefix}-${fieldId}-${key}`;
    const setValue = (key, value)=>setValues((current)=>({
                ...current,
                [key]: value
            }));
    const [consentConfig, setConsentConfig] = (0, $1oC0p.useState)($903d212917d1712a$var$DEFAULT_CONSENT_CONFIG);
    const hasImpliedMarketingConsent = consentConfig.localeRequiresMarketingCommunicationOptIn === false;
    const clearErrors = ()=>setErrors({});
    (0, $1oC0p.useEffect)(()=>{
        if (consentMode === 'none') return;
        let isSubscribed = true;
        client.getConsentConfig().then((config)=>{
            if (!isSubscribed || !config) return;
            setConsentConfig(config);
            if (config.localeRequiresMarketingCommunicationOptIn === false) setValues((current)=>({
                    ...current,
                    marketingOptIn: 'true'
                }));
        }).catch(()=>{
        // Keep DEFAULT_CONSENT_CONFIG so we never assume consent after a failed request.
        });
        return ()=>{
            isSubscribed = false;
        };
    }, [
        client,
        consentMode
    ]);
    const richLegalCopy = (0, $dZNgt.isRichTextValueConsideredEmpty)(legalCopyOverride) ? undefined : legalCopyOverride;
    const legalText = (richLegalCopy ? (0, $dZNgt.renderToText)(richLegalCopy.root) : undefined) ?? (consentMode === 'privacyPolicy' ? intl.formatMessage((0, $6Q2bE.uniformFormMessages).privacyPolicy) : consentMode === 'generalMarketingOptIn' ? intl.formatMessage((0, $6Q2bE.uniformFormMessages).generalMarketingOptIn) : consentMode === 'termsOfService' ? intl.formatMessage((0, $6Q2bE.uniformFormMessages).termsOfService) : consentMode === 'eapTermsOfService' ? intl.formatMessage((0, $6Q2bE.uniformFormMessages).eapTermsOfService) : consentMode === 'eapVirtualAgentTermsAndConditions' ? intl.formatMessage((0, $6Q2bE.uniformFormMessages).eapVirtualAgentTerms) : '');
    const legalContent = richLegalCopy ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
        uniformRichText: richLegalCopy.root
    }) : legalText;
    const fireTerminalAnalytics = (result, failureCategory)=>createAnalyticsEvent({
            eventType: 'ui',
            action: 'submitted',
            actionSubject: 'form',
            actionSubjectId: 'form',
            source: 'uniform',
            attributes: {
                label: label,
                formId: formId,
                formType: formType,
                status: result,
                ...failureCategory ? {
                    failureCategory: failureCategory
                } : {}
            }
        }).fire();
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (status === 'submitting' || configurationIssues.length) return;
        if (values['alternateEmail']) return;
        const nextErrors = (0, $8yzBO.validateFormValues)(fields, values, {
            required: intl.formatMessage((0, $6Q2bE.uniformFormMessages).required),
            invalidEmail: intl.formatMessage((0, $6Q2bE.uniformFormMessages).invalidEmail),
            businessEmail: intl.formatMessage((0, $6Q2bE.uniformFormMessages).businessEmail),
            firstNameRequired: intl.formatMessage((0, $6Q2bE.uniformFormMessages).firstNameRequired),
            lastNameRequired: intl.formatMessage((0, $6Q2bE.uniformFormMessages).lastNameRequired),
            companyRequired: intl.formatMessage((0, $6Q2bE.uniformFormMessages).companyRequired),
            phoneRequired: intl.formatMessage((0, $6Q2bE.uniformFormMessages).phoneRequired)
        });
        setErrors(nextErrors);
        const firstError = Object.keys(nextErrors)[0];
        if (firstError) {
            requestAnimationFrame(()=>formRef.current?.querySelector(`[data-field="${firstError}"], input[id$="-${firstError}"]`)?.focus());
            return;
        }
        setStatus('submitting');
        try {
            await (0, $5nFGj.submitUniformForm)({
                client: client,
                customEndpoint: customEndpoint,
                consentCheckboxValue: consentMode === 'generalMarketingOptIn' ? values['marketingOptIn'] === 'true' : true,
                consentMode: consentMode,
                displayedLegalText: legalText,
                formId: formId ?? '',
                formType: formType ?? '',
                formValues: (0, $8yzBO.buildVisibleFormPayload)(fields, values),
                intercomAppId: intercomAppId,
                intercomTracking: intercomTracking,
                locale: intl.locale,
                consentConfig: consentConfig,
                submissionEndpoint: submissionEndpoint
            });
            setStatus('success');
            fireTerminalAnalytics('success');
        } catch (error) {
            setStatus('error');
            fireTerminalAnalytics('error', error instanceof (0, $5nFGj.UniformFormSubmissionError) ? error.category : 'unknown');
        } finally{
            requestAnimationFrame(()=>terminalRef.current?.focus());
        }
    };
    if (configurationIssues.length) {
        if ((0, $eRzlV.isProduction)()) return null;
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            role: "alert",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    children: intl.formatMessage((0, $6Q2bE.uniformFormMessages).configurationError)
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("code", {
                    children: configurationIssues.join('; ')
                })
            ]
        });
    }
    if (status === 'success') return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: terminalRef,
        role: "status",
        tabIndex: -1,
        className: (0, $2jatx.default)([
            "_syaz1pfd _6rthidpf _1pfhpxbi",
            "_y3gnoues"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
        },
        children: [
            !(0, $dZNgt.isRichTextValueConsideredEmpty)(successMessage) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                uniformParameter: "successMessage"
            }),
            successButtonText && successButtonUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                dataEventProps: {
                    'data-product-key': 'uniform',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'form',
                    'data-event': 'clicked'
                },
                href: successButtonUrl,
                variant: buttonVariant,
                children: successButtonText
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_syaz1pfd _ect4z4z1 _1bsb1osq"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
            },
            children: [
                formHeader && /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_syaz1pfd _ect41vau _1wyb1k8s _vwz4viql _18s81km1",
                        "_y3gnoues"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                        "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
                    },
                    children: formHeader
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                    "aria-busy": status === 'submitting',
                    autoComplete: "on",
                    noValidate: true,
                    onSubmit: handleSubmit,
                    ref: formRef,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _zulppxbi _yv0ehkll _1rqt9sye"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($903d212917d1712a$var$RenderFields, {
                                clearErrors: clearErrors,
                                errors: errors,
                                fields: fields,
                                getId: getId,
                                setValue: setValue,
                                values: values
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            "aria-hidden": "true",
                            className: (0, $2jatx.default)([
                                "_4t3it94y _1e021cib _1reo15vq _18m915vq _kqswstnw _1bsbt94y"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                    htmlFor: getId('alternateEmail'),
                                    children: intl.formatMessage((0, $6Q2bE.uniformFormMessages).honeypot)
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    autoComplete: "new-password",
                                    "data-1p-ignore": "true",
                                    "data-lpignore": "true",
                                    id: getId('alternateEmail'),
                                    name: "alternateEmail",
                                    onChange: (event)=>setValue('alternateEmail', event.target.value),
                                    tabIndex: -1,
                                    type: "email",
                                    value: String(values['alternateEmail'] ?? '')
                                })
                            ]
                        }),
                        legalText && consentMode !== 'generalMarketingOptIn' && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1wyboxwj _vwz41k92 _6rthpxbi _1pfh1ejb",
                                "_y3gnoues"
                            ]),
                            style: {
                                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
                            },
                            children: legalContent
                        }),
                        consentMode === 'generalMarketingOptIn' && !hasImpliedMarketingConsent && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_4cvr1y6m _1e0c1txw _1wyboxwj _zulpu2gc _vwz41k92 _6rthpxbi _1pfh1ejb"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    "aria-labelledby": getId('marketingOptIn-label'),
                                    checked: values['marketingOptIn'] === 'true',
                                    onChange: (event)=>setValue('marketingOptIn', String(event.target.checked)),
                                    type: "checkbox",
                                    className: (0, $2jatx.default)([
                                        "_12yz5hrz _16jlidpf _1o9zidpf _i0dl1wug _4t3ipxbi _18s81c53 _1bsbpxbi"
                                    ]),
                                    style: {
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                    }
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    id: getId('marketingOptIn-label'),
                                    children: legalContent
                                })
                            ]
                        }),
                        status === 'error' && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            ref: terminalRef,
                            role: "alert",
                            tabIndex: -1,
                            className: (0, $2jatx.default)([
                                "_syaz1d19 _6rthpxbi _1pfhpxbi",
                                "_y3gnoues"
                            ]),
                            style: {
                                "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
                            },
                            children: intl.formatMessage((0, $6Q2bE.uniformFormMessages).submitError)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhpxbi",
                                "_y3gnoues"
                            ]),
                            style: {
                                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                isDisabled: status === 'submitting',
                                isLoading: status === 'submitting',
                                size: "large",
                                type: "submit",
                                variant: buttonVariant,
                                children: submitLabel ?? intl.formatMessage((0, $6Q2bE.uniformFormMessages).submit)
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $903d212917d1712a$export$2e2bcd8739ae039 = $903d212917d1712a$var$UniformForm;

});
parcelRegister("flZAN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b2d898245c4498a0$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $h4ELM = parcelRequire("h4ELM");

var $i7dvh = parcelRequire("i7dvh");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $f53LC = parcelRequire("f53LC");

var $c9bqK = parcelRequire("c9bqK");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jey32 = parcelRequire("jey32");
var $9bFTJ = parcelRequire("9bFTJ");
var $8IXWc = parcelRequire("8IXWc");
var $gw7QQ = parcelRequire("gw7QQ");

var $hpDnm = parcelRequire("hpDnm");

var $fzOo8 = parcelRequire("fzOo8");
var $56Xlo = parcelRequire("56Xlo");
var $3qZOw = parcelRequire("3qZOw");

var $5pnhH = parcelRequire("5pnhH");

var $7MmPk = parcelRequire("7MmPk");

var $7iXaE = parcelRequire("7iXaE");

var $ajGIz = parcelRequire("ajGIz");

var $9SsB3 = parcelRequire("9SsB3");

var $9RuQh = parcelRequire("9RuQh");
var $gtBsz = parcelRequire("gtBsz");

var $3c7rQ = parcelRequire("3c7rQ");

var $hnR5n = parcelRequire("hnR5n");

var $2Qfvn = parcelRequire("2Qfvn");

var $82jjj = parcelRequire("82jjj");

var $kPY04 = parcelRequire("kPY04");

var $6wccz = parcelRequire("6wccz");
function $b2d898245c4498a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2d898245c4498a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2d898245c4498a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2d898245c4498a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b2d898245c4498a0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b2d898245c4498a0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jlBwm.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jlBwm.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $i3Ugd.default)(this, result);
    };
}
function $b2d898245c4498a0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $b2d898245c4498a0$var$packageName = "@atlaskit/datetime-picker";
var $b2d898245c4498a0$var$packageVersion = "12.10.6";
function $b2d898245c4498a0$var$getValidDate(iso) {
    var date = (0, $gw7QQ.default)(iso);
    return (0, $9bFTJ.default)(date) ? {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    } : {};
}
function $b2d898245c4498a0$var$getShortISOString(date) {
    return (0, $jey32.default)(date, (0, $6wccz.convertTokens)('YYYY-MM-DD'));
}
var $b2d898245c4498a0$var$menuStyles = (0, $3dJ4i.css)({
    zIndex: (0, $hnR5n.layers).dialog(),
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $3c7rQ.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $3c7rQ.N50A), ", 0 0 1px ").concat((0, $3c7rQ.N60A)), ")"),
    overflow: 'hidden'
});
var $b2d898245c4498a0$var$Menu = function Menu(_ref) {
    var selectProps = _ref.selectProps, innerProps = _ref.innerProps;
    return (0, $3dJ4i.jsx)((0, $7iXaE.UNSAFE_LAYERING), {
        isDisabled: (0, $9SsB3.getBooleanFF)('platform.design-system-team.layering_qmiw3') ? false : true
    }, (0, $3dJ4i.jsx)((0, $82jjj.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({
            css: $b2d898245c4498a0$var$menuStyles
        }, innerProps), (0, $3dJ4i.jsx)((0, $5pnhH.default), (0, $c9bqK.default)({}, $b2d898245c4498a0$var$getValidDate(selectProps.calendarValue), $b2d898245c4498a0$var$getValidDate(selectProps.calendarView), {
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            calendarRef: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && "".concat(selectProps.testId, "--calendar"),
            weekStartDay: selectProps.calendarWeekStartDay
        }))),
        testId: selectProps.testId
    }));
};
var $b2d898245c4498a0$var$datePickerDefaultProps = {
    appearance: 'default',
    autoFocus: false,
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: function disabledDateFilter(_) {
        return false;
    },
    hideIcon: false,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7MmPk))),
    id: '',
    innerProps: {},
    isDisabled: false,
    isInvalid: false,
    name: '',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: function onBlur(_event) {},
    onChange: function onChange(_value) {},
    onFocus: function onFocus(_event) {},
    /* eslint-enable @repo/internal/react/use-noop */ selectProps: {},
    spacing: 'default',
    locale: 'en-US'
};
var $b2d898245c4498a0$export$df43d21f5faca9f7 = /*#__PURE__*/ function(_Component) {
    (0, $i7dvh.default)(DatePicker, _Component);
    var _super = $b2d898245c4498a0$var$_createSuper(DatePicker);
    function DatePicker(props) {
        var _this;
        (0, $cTewU.default)(this, DatePicker);
        _this = _super.call(this, props);
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "calendarRef", null);
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "containerRef", null);
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getSafeState", function() {
            return $b2d898245c4498a0$var$_objectSpread($b2d898245c4498a0$var$_objectSpread($b2d898245c4498a0$var$_objectSpread({}, _this.state), (0, (/*@__PURE__*/$parcel$interopDefault($hpDnm)))(_this.props, [
                'value',
                'isOpen'
            ])), (0, (/*@__PURE__*/$parcel$interopDefault($hpDnm)))(_this.props.selectProps, [
                'inputValue'
            ]));
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "isDateDisabled", function(date) {
            return _this.props.disabled.indexOf(date) > -1;
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onCalendarChange", function(_ref2) {
            var iso = _ref2.iso;
            var _iso$split = iso.split('-'), _iso$split2 = (0, $2qaZZ.default)(_iso$split, 3), year = _iso$split2[0], month = _iso$split2[1], date = _iso$split2[2];
            var newIso = iso;
            var parsedDate = parseInt(date, 10);
            var parsedMonth = parseInt(month, 10);
            var parsedYear = parseInt(year, 10);
            var lastDayInMonth = (0, $8IXWc.default)(new Date(parsedYear, parsedMonth - 1) // This needs to be -1, because the Date constructor expects an index of the given month
            ).getDate();
            if (lastDayInMonth < parsedDate) newIso = "".concat(year, "-").concat((0, $2Qfvn.padToTwo)(parsedMonth), "-").concat((0, $2Qfvn.padToTwo)(lastDayInMonth));
            else newIso = "".concat(year, "-").concat((0, $2Qfvn.padToTwo)(parsedMonth), "-").concat((0, $2Qfvn.padToTwo)(parsedDate));
            _this.setState({
                calendarValue: newIso
            });
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onCalendarSelect", function(_ref3) {
            var iso = _ref3.iso;
            _this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso
            });
            _this.props.onChange(iso);
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onInputClick", function() {
            if (!_this.props.isDisabled && !_this.getSafeState().isOpen) _this.setState({
                isOpen: true
            });
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onContainerBlur", function(event) {
            var _this$containerRef;
            var newlyFocusedElement = event.relatedTarget;
            if (!((_this$containerRef = _this.containerRef) !== null && _this$containerRef !== void 0 && _this$containerRef.contains(newlyFocusedElement))) _this.setState({
                isOpen: false
            });
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onSelectBlur", function(event) {
            var _this$containerRef2;
            var newlyFocusedElement = event.relatedTarget;
            if (_this.getSafeState().clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            _this.setState({
                clearingFromIcon: false
            });
            else if (!((_this$containerRef2 = _this.containerRef) !== null && _this$containerRef2 !== void 0 && _this$containerRef2.contains(newlyFocusedElement))) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            _this.setState({
                isOpen: false,
                isFocused: false
            });
            _this.props.onBlur(event);
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onSelectFocus", function(event) {
            var _this$getSafeState = _this.getSafeState(), clearingFromIcon = _this$getSafeState.clearingFromIcon, value = _this$getSafeState.value;
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            _this.setState({
                clearingFromIcon: false
            });
            else _this.setState({
                isOpen: true,
                calendarValue: value,
                isFocused: true
            });
            _this.props.onFocus(event);
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onTextInput", function(event) {
            var value = event.target.value;
            if (value) {
                var parsed = _this.parseDate(value);
                // Only try to set the date if we have month & day
                if (parsed && (0, $9bFTJ.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                _this.setState({
                    calendarValue: $b2d898245c4498a0$var$getShortISOString(parsed)
                });
            }
            _this.setState({
                isOpen: true
            });
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getSafeCalendarValue", function(calendarValue) {
            // If `calendarValue` has a year that is greater than 9999, default to
            // today's date
            var yearIsOverLimit = calendarValue.match(/^\d{5,}/);
            if (yearIsOverLimit) return $b2d898245c4498a0$var$getShortISOString(new Date());
            return calendarValue;
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onInputKeyDown", function(event) {
            var _this$getSafeState2 = _this.getSafeState(), value = _this$getSafeState2.value, calendarValue = _this$getSafeState2.calendarValue;
            var keyPressed = event.key.toLowerCase();
            switch(keyPressed){
                case 'escape':
                    _this.setState({
                        isOpen: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    var inputCount = (0, $9SsB3.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs') ? 1 : 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                    _this.setState({
                        clearingFromIcon: false,
                        value: ''
                    });
                    break;
                case 'enter':
                    if (!_this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!_this.isDateDisabled(calendarValue)) {
                        var _this$getSafeState3 = _this.getSafeState(), _value2 = _this$getSafeState3.value;
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        var safeCalendarValue = _this.getSafeCalendarValue(calendarValue);
                        var valueChanged = safeCalendarValue !== _value2;
                        _this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue
                        });
                        if (valueChanged) _this.props.onChange(safeCalendarValue);
                    }
                    break;
                default:
                    break;
            }
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onClear", function() {
            var changedState = {
                value: '',
                calendarValue: _this.props.defaultValue || $b2d898245c4498a0$var$getShortISOString(new Date())
            };
            if (!_this.props.hideIcon) changedState = $b2d898245c4498a0$var$_objectSpread($b2d898245c4498a0$var$_objectSpread({}, changedState), {}, {
                clearingFromIcon: true
            });
            _this.setState(changedState);
            _this.props.onChange('');
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "onSelectChange", function(_value, action) {
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') _this.onClear();
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "refCalendar", function(ref) {
            _this.calendarRef = ref;
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "handleSelectInputChange", function(selectInputValue, actionMeta) {
            var onInputChange = _this.props.selectProps.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            _this.setState({
                selectInputValue: selectInputValue
            });
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getContainerRef", function(ref) {
            var oldRef = _this.containerRef;
            _this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) _this.forceUpdate();
        });
        /**
     * There are two props that can change how the date is parsed.
     * The priority of props used is:
     *   1. parseInputValue
     *   2. locale
     */ (0, $f53LC.default)((0, $h4ELM.default)(_this), "parseDate", function(date) {
            var _this$props = _this.props, parseInputValue = _this$props.parseInputValue, dateFormat = _this$props.dateFormat;
            if (parseInputValue) return parseInputValue(date, dateFormat || (0, $2Qfvn.defaultDateFormat));
            var _this$getSafeState4 = _this.getSafeState(), l10n = _this$getSafeState4.l10n;
            return l10n.parseDate(date);
        });
        /**
     * There are multiple props that can change how the date is formatted.
     * The priority of props used is:
     *   1. formatDisplayLabel
     *   2. dateFormat
     *   3. locale
     */ (0, $f53LC.default)((0, $h4ELM.default)(_this), "formatDate", function(value) {
            var _this$props2 = _this.props, formatDisplayLabel = _this$props2.formatDisplayLabel, dateFormat = _this$props2.dateFormat;
            var _this$getSafeState5 = _this.getSafeState(), l10n = _this$getSafeState5.l10n;
            if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $2Qfvn.defaultDateFormat));
            var date = (0, $gw7QQ.default)(value);
            return dateFormat ? (0, $jey32.default)(date, (0, $6wccz.convertTokens)(dateFormat)) : l10n.formatDate(date);
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getPlaceholder", function() {
            var placeholder = _this.props.placeholder;
            if (placeholder) return placeholder;
            var _this$getSafeState6 = _this.getSafeState(), l10n = _this$getSafeState6.l10n;
            return l10n.formatDate((0, $2Qfvn.placeholderDatetime));
        });
        _this.state = {
            isOpen: _this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: _this.props.selectProps.inputValue || '',
            value: _this.props.value || _this.props.defaultValue,
            calendarValue: _this.props.value || _this.props.defaultValue || $b2d898245c4498a0$var$getShortISOString(new Date()),
            l10n: (0, $ajGIz.createLocalizationProvider)(_this.props.locale),
            locale: _this.props.locale
        };
        return _this;
    }
    (0, $avOEA.default)(DatePicker, [
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, appearance = _this$props3.appearance, autoFocus = _this$props3.autoFocus, disabled = _this$props3.disabled, hideIcon = _this$props3.hideIcon, icon = _this$props3.icon, id = _this$props3.id, innerProps = _this$props3.innerProps, isDisabled = _this$props3.isDisabled, disabledDateFilter = _this$props3.disabledDateFilter, maxDate = _this$props3.maxDate, minDate = _this$props3.minDate, isInvalid = _this$props3.isInvalid, name = _this$props3.name, nextMonthLabel = _this$props3.nextMonthLabel, previousMonthLabel = _this$props3.previousMonthLabel, selectProps = _this$props3.selectProps, spacing = _this$props3.spacing, locale = _this$props3.locale, testId = _this$props3.testId, weekStartDay = _this$props3.weekStartDay;
                var _this$getSafeState7 = this.getSafeState(), value = _this$getSafeState7.value, calendarValue = _this$getSafeState7.calendarValue, isOpen = _this$getSafeState7.isOpen, selectInputValue = _this$getSafeState7.selectInputValue;
                var actualSelectInputValue;
                if ((0, $9SsB3.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs')) actualSelectInputValue = selectInputValue || (value ? this.formatDate(value) : undefined);
                else actualSelectInputValue = selectInputValue;
                var menuIsOpen = isOpen && !isDisabled;
                var showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
                var dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
                var SingleValue = (0, $kPY04.makeSingleValue)({
                    lang: this.props.locale
                });
                var selectComponents = $b2d898245c4498a0$var$_objectSpread({
                    DropdownIndicator: dropDownIcon,
                    Menu: $b2d898245c4498a0$var$Menu,
                    SingleValue: SingleValue
                }, !showClearIndicator && {
                    ClearIndicator: (0, $2Qfvn.EmptyComponent)
                });
                var _selectProps$styles = selectProps.styles, selectStyles = _selectProps$styles === void 0 ? {} : _selectProps$styles;
                var disabledStyle = isDisabled ? {
                    pointerEvents: 'none',
                    color: "var(--ds-icon-disabled, inherit)"
                } : {};
                var calendarProps = {
                    calendarContainerRef: this.containerRef,
                    calendarRef: this.refCalendar,
                    calendarDisabled: disabled,
                    calendarDisabledDateFilter: disabledDateFilter,
                    calendarMaxDate: maxDate,
                    calendarMinDate: minDate,
                    calendarValue: value && $b2d898245c4498a0$var$getShortISOString((0, $gw7QQ.default)(value)),
                    calendarView: calendarValue,
                    onCalendarChange: this.onCalendarChange,
                    onCalendarSelect: this.onCalendarSelect,
                    calendarLocale: locale,
                    calendarWeekStartDay: weekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    previousMonthLabel: previousMonthLabel
                };
                return(// These event handlers must be on this element because the events come
                // from different child elements.
                (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, innerProps, {
                    role: "presentation",
                    onBlur: this.onContainerBlur,
                    onClick: this.onInputClick,
                    onInput: this.onTextInput,
                    onKeyDown: this.onInputKeyDown,
                    ref: this.getContainerRef,
                    "data-testid": testId && "".concat(testId, "--container")
                }), (0, $3dJ4i.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && "".concat(testId, "--input")
                }), (0, $3dJ4i.jsx)((0, $9RuQh.default), (0, $c9bqK.default)({
                    appearance: this.props.appearance,
                    enableAnimation: false,
                    menuIsOpen: menuIsOpen,
                    closeMenuOnSelect: true,
                    autoFocus: autoFocus,
                    instanceId: id,
                    isDisabled: isDisabled,
                    onBlur: this.onSelectBlur,
                    onFocus: this.onSelectFocus,
                    inputValue: actualSelectInputValue,
                    onInputChange: this.handleSelectInputChange,
                    components: selectComponents,
                    onChange: this.onSelectChange,
                    styles: (0, $gtBsz.m)(selectStyles, {
                        control: function control(base) {
                            return $b2d898245c4498a0$var$_objectSpread($b2d898245c4498a0$var$_objectSpread({}, base), disabledStyle);
                        },
                        indicatorsContainer: function indicatorsContainer(base) {
                            return $b2d898245c4498a0$var$_objectSpread($b2d898245c4498a0$var$_objectSpread({}, base), {}, {
                                paddingLeft: "var(--ds-space-025, 2px)",
                                // ICON_PADDING = 2
                                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                            });
                        }
                    }),
                    placeholder: this.getPlaceholder(),
                    value: value && {
                        label: this.formatDate(value),
                        value: value
                    }
                }, selectProps, calendarProps, {
                    isClearable: true,
                    spacing: spacing,
                    isInvalid: isInvalid,
                    testId: testId
                }))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.locale !== prevState.locale) return {
                    l10n: (0, $ajGIz.createLocalizationProvider)(nextProps.locale),
                    locale: nextProps.locale
                };
                else return null;
            }
        }
    ]);
    return DatePicker;
}((0, $1oC0p.Component));
(0, $f53LC.default)($b2d898245c4498a0$export$df43d21f5faca9f7, "defaultProps", $b2d898245c4498a0$var$datePickerDefaultProps);
var $b2d898245c4498a0$export$2e2bcd8739ae039 = (0, $56Xlo.default)({
    componentName: 'datePicker',
    packageName: $b2d898245c4498a0$var$packageName,
    packageVersion: $b2d898245c4498a0$var$packageVersion
})((0, $3qZOw.default)({
    onChange: (0, $fzOo8.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $b2d898245c4498a0$var$packageName,
            packageVersion: $b2d898245c4498a0$var$packageVersion
        }
    })
})($b2d898245c4498a0$export$df43d21f5faca9f7));

});
parcelRegister("jey32", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e009bc5989031bfa$export$2e2bcd8739ae039; });

var $9bFTJ = parcelRequire("9bFTJ");

var $iYyBF = parcelRequire("iYyBF");

var $486lh = parcelRequire("486lh");

var $furKp = parcelRequire("furKp");

var $5Xfmk = parcelRequire("5Xfmk");

var $7zXt2 = parcelRequire("7zXt2");

var $jcs1e = parcelRequire("jcs1e");

var $joxzS = parcelRequire("joxzS");

var $fLbYn = parcelRequire("fLbYn");

var $2DPo8 = parcelRequire("2DPo8");

var $bfEVG = parcelRequire("bfEVG");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e009bc5989031bfa$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e009bc5989031bfa$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e009bc5989031bfa$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e009bc5989031bfa$var$doubleQuoteRegExp = /''/g;
var $e009bc5989031bfa$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e009bc5989031bfa$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $fLbYn.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $2DPo8.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $bfEVG.default);
    var firstWeekContainsDate = (0, $joxzS.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $joxzS.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $486lh.default)(dirtyDate);
    if (!(0, $9bFTJ.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $7zXt2.default)(originalDate);
    var utcDate = (0, $iYyBF.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e009bc5989031bfa$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $5Xfmk.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($e009bc5989031bfa$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e009bc5989031bfa$var$cleanEscapedString(substring);
        var formatter = (0, $furKp.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $jcs1e.isProtectedWeekYearToken)(substring)) (0, $jcs1e.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $jcs1e.isProtectedDayOfYearToken)(substring)) (0, $jcs1e.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e009bc5989031bfa$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $e009bc5989031bfa$var$cleanEscapedString(input) {
    var matched = input.match($e009bc5989031bfa$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e009bc5989031bfa$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("9bFTJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b05a43630a6bfe2$export$2e2bcd8739ae039; });

var $ihrEv = parcelRequire("ihrEv");

var $486lh = parcelRequire("486lh");

var $fLbYn = parcelRequire("fLbYn");
function $6b05a43630a6bfe2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fLbYn.default)(1, arguments);
    if (!(0, $ihrEv.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $486lh.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("ihrEv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4ef43ad4ac636fb$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $fLbYn = parcelRequire("fLbYn");
function $d4ef43ad4ac636fb$export$2e2bcd8739ae039(value) {
    (0, $fLbYn.default)(1, arguments);
    return value instanceof Date || (0, $2zYm4.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});
parcelRegister("fLbYn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b794885b7d070c1b$export$2e2bcd8739ae039; });
function $b794885b7d070c1b$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("486lh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $301cd43b0494144b$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $fLbYn = parcelRequire("fLbYn");
function $301cd43b0494144b$export$2e2bcd8739ae039(argument) {
    (0, $fLbYn.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $2zYm4.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});


parcelRegister("iYyBF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dd08acb8b636f1ec$export$2e2bcd8739ae039; });

var $lCQ0y = parcelRequire("lCQ0y");

var $fLbYn = parcelRequire("fLbYn");

var $joxzS = parcelRequire("joxzS");
function $dd08acb8b636f1ec$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fLbYn.default)(2, arguments);
    var amount = (0, $joxzS.default)(dirtyAmount);
    return (0, $lCQ0y.default)(dirtyDate, -amount);
}

});
parcelRegister("lCQ0y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fbe57d4b16c66f0e$export$2e2bcd8739ae039; });

var $joxzS = parcelRequire("joxzS");

var $486lh = parcelRequire("486lh");

var $fLbYn = parcelRequire("fLbYn");
function $fbe57d4b16c66f0e$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fLbYn.default)(2, arguments);
    var timestamp = (0, $486lh.default)(dirtyDate).getTime();
    var amount = (0, $joxzS.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("joxzS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1ea4e0f24a5f148$export$2e2bcd8739ae039; });
function $e1ea4e0f24a5f148$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("furKp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b46f2e6c5e42e380$export$2e2bcd8739ae039; });

var $41tAL = parcelRequire("41tAL");

var $js4ku = parcelRequire("js4ku");

var $7Umrp = parcelRequire("7Umrp");

var $k8r6R = parcelRequire("k8r6R");

var $3n2CV = parcelRequire("3n2CV");

var $lujvg = parcelRequire("lujvg");

var $af1Ph = parcelRequire("af1Ph");
var $b46f2e6c5e42e380$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $b46f2e6c5e42e380$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $af1Ph.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $3n2CV.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $lujvg.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $lujvg.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $7Umrp.default)(date);
        // Padding
        return (0, $lujvg.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $lujvg.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $lujvg.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $lujvg.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $af1Ph.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $lujvg.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $k8r6R.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $lujvg.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $js4ku.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $lujvg.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $af1Ph.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $41tAL.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $lujvg.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $lujvg.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $lujvg.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $lujvg.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $b46f2e6c5e42e380$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $b46f2e6c5e42e380$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $b46f2e6c5e42e380$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $b46f2e6c5e42e380$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $b46f2e6c5e42e380$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $b46f2e6c5e42e380$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $af1Ph.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $af1Ph.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $lujvg.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $lujvg.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $af1Ph.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $af1Ph.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $af1Ph.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $b46f2e6c5e42e380$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $b46f2e6c5e42e380$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $b46f2e6c5e42e380$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $b46f2e6c5e42e380$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $b46f2e6c5e42e380$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $b46f2e6c5e42e380$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $b46f2e6c5e42e380$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $b46f2e6c5e42e380$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $b46f2e6c5e42e380$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $b46f2e6c5e42e380$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $lujvg.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $lujvg.default)(timestamp, token.length);
    }
};
function $b46f2e6c5e42e380$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $lujvg.default)(minutes, 2);
}
function $b46f2e6c5e42e380$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $lujvg.default)(Math.abs(offset) / 60, 2);
    }
    return $b46f2e6c5e42e380$var$formatTimezone(offset, dirtyDelimiter);
}
function $b46f2e6c5e42e380$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $lujvg.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $lujvg.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $b46f2e6c5e42e380$export$2e2bcd8739ae039 = $b46f2e6c5e42e380$var$formatters;

});
parcelRegister("41tAL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2ede35c8f9ad2009$export$2e2bcd8739ae039; });

var $486lh = parcelRequire("486lh");

var $fLbYn = parcelRequire("fLbYn");
var $2ede35c8f9ad2009$var$MILLISECONDS_IN_DAY = 86400000;
function $2ede35c8f9ad2009$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fLbYn.default)(1, arguments);
    var date = (0, $486lh.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $2ede35c8f9ad2009$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("js4ku", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e293fd9dbeebde48$export$2e2bcd8739ae039; });

var $486lh = parcelRequire("486lh");

var $jdmPj = parcelRequire("jdmPj");

var $8LKX1 = parcelRequire("8LKX1");

var $fLbYn = parcelRequire("fLbYn");
var $e293fd9dbeebde48$var$MILLISECONDS_IN_WEEK = 604800000;
function $e293fd9dbeebde48$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fLbYn.default)(1, arguments);
    var date = (0, $486lh.default)(dirtyDate);
    var diff = (0, $jdmPj.default)(date).getTime() - (0, $8LKX1.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e293fd9dbeebde48$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("jdmPj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dfd0f0158ab0438c$export$2e2bcd8739ae039; });

var $486lh = parcelRequire("486lh");

var $fLbYn = parcelRequire("fLbYn");
function $dfd0f0158ab0438c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fLbYn.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $486lh.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("8LKX1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $662722035d4ca0a8$export$2e2bcd8739ae039; });

var $7Umrp = parcelRequire("7Umrp");

var $jdmPj = parcelRequire("jdmPj");

var $fLbYn = parcelRequire("fLbYn");
function $662722035d4ca0a8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fLbYn.default)(1, arguments);
    var year = (0, $7Umrp.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $jdmPj.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("7Umrp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c1f2bb0dcc8a4d9$export$2e2bcd8739ae039; });

var $486lh = parcelRequire("486lh");

var $fLbYn = parcelRequire("fLbYn");

var $jdmPj = parcelRequire("jdmPj");
function $5c1f2bb0dcc8a4d9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fLbYn.default)(1, arguments);
    var date = (0, $486lh.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $jdmPj.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $jdmPj.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("k8r6R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea89956cda480347$export$2e2bcd8739ae039; });

var $486lh = parcelRequire("486lh");

var $8Nv7i = parcelRequire("8Nv7i");

var $1N6d8 = parcelRequire("1N6d8");

var $fLbYn = parcelRequire("fLbYn");
var $ea89956cda480347$var$MILLISECONDS_IN_WEEK = 604800000;
function $ea89956cda480347$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $fLbYn.default)(1, arguments);
    var date = (0, $486lh.default)(dirtyDate);
    var diff = (0, $8Nv7i.default)(date, options).getTime() - (0, $1N6d8.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $ea89956cda480347$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("8Nv7i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $667b0973a2654875$export$2e2bcd8739ae039; });

var $486lh = parcelRequire("486lh");

var $fLbYn = parcelRequire("fLbYn");

var $joxzS = parcelRequire("joxzS");

var $2DPo8 = parcelRequire("2DPo8");
function $667b0973a2654875$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fLbYn.default)(1, arguments);
    var defaultOptions = (0, $2DPo8.getDefaultOptions)();
    var weekStartsOn = (0, $joxzS.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $486lh.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("2DPo8", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", function () { return $1ec715f0d9e63002$export$430a3269e24b912e; });
var $1ec715f0d9e63002$var$defaultOptions = {};
function $1ec715f0d9e63002$export$430a3269e24b912e() {
    return $1ec715f0d9e63002$var$defaultOptions;
}
function $1ec715f0d9e63002$export$95365be1b0704abc(newOptions) {
    $1ec715f0d9e63002$var$defaultOptions = newOptions;
}

});


parcelRegister("1N6d8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14df2f64cd2bb967$export$2e2bcd8739ae039; });

var $3n2CV = parcelRequire("3n2CV");

var $fLbYn = parcelRequire("fLbYn");

var $8Nv7i = parcelRequire("8Nv7i");

var $joxzS = parcelRequire("joxzS");

var $2DPo8 = parcelRequire("2DPo8");
function $14df2f64cd2bb967$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fLbYn.default)(1, arguments);
    var defaultOptions = (0, $2DPo8.getDefaultOptions)();
    var firstWeekContainsDate = (0, $joxzS.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $3n2CV.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $8Nv7i.default)(firstWeek, options);
    return date;
}

});
parcelRegister("3n2CV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $27458eb093e04262$export$2e2bcd8739ae039; });

var $486lh = parcelRequire("486lh");

var $fLbYn = parcelRequire("fLbYn");

var $8Nv7i = parcelRequire("8Nv7i");

var $joxzS = parcelRequire("joxzS");

var $2DPo8 = parcelRequire("2DPo8");
function $27458eb093e04262$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fLbYn.default)(1, arguments);
    var date = (0, $486lh.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $2DPo8.getDefaultOptions)();
    var firstWeekContainsDate = (0, $joxzS.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8Nv7i.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8Nv7i.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("lujvg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fa4b8742b011bf6e$export$2e2bcd8739ae039; });
function $fa4b8742b011bf6e$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("af1Ph", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $774cb8b79bbd0b32$export$2e2bcd8739ae039; });

var $lujvg = parcelRequire("lujvg");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $774cb8b79bbd0b32$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $lujvg.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $lujvg.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $lujvg.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $lujvg.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $lujvg.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $lujvg.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $lujvg.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $lujvg.default)(fractionalSeconds, token.length);
    }
};
var $774cb8b79bbd0b32$export$2e2bcd8739ae039 = $774cb8b79bbd0b32$var$formatters;

});


parcelRegister("5Xfmk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $455e606dc9f644b8$export$2e2bcd8739ae039; });
var $455e606dc9f644b8$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $455e606dc9f644b8$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $455e606dc9f644b8$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $455e606dc9f644b8$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $455e606dc9f644b8$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $455e606dc9f644b8$var$timeLongFormatter(timePattern, formatLong));
};
var $455e606dc9f644b8$var$longFormatters = {
    p: $455e606dc9f644b8$var$timeLongFormatter,
    P: $455e606dc9f644b8$var$dateTimeLongFormatter
};
var $455e606dc9f644b8$export$2e2bcd8739ae039 = $455e606dc9f644b8$var$longFormatters;

});

parcelRegister("7zXt2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5849ee42351c5798$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $5849ee42351c5798$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("jcs1e", function(module, exports) {
$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $dfa4df40f21c6852$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $dfa4df40f21c6852$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $dfa4df40f21c6852$export$8073c1ae88f0e727; });
var $dfa4df40f21c6852$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $dfa4df40f21c6852$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $dfa4df40f21c6852$export$c6cc36aa33304772(token) {
    return $dfa4df40f21c6852$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $dfa4df40f21c6852$export$c6b49d6dceb604a1(token) {
    return $dfa4df40f21c6852$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $dfa4df40f21c6852$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("bfEVG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8310d82af8883710$export$2e2bcd8739ae039; });

var $69m75 = parcelRequire("69m75");
var $8310d82af8883710$export$2e2bcd8739ae039 = (0, $69m75.default);

});
parcelRegister("69m75", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $47a4bc90432d4525$export$2e2bcd8739ae039; });

var $d9WK4 = parcelRequire("d9WK4");

var $hC7jN = parcelRequire("hC7jN");

var $658UP = parcelRequire("658UP");

var $9x2pl = parcelRequire("9x2pl");

var $9hXn5 = parcelRequire("9hXn5");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $47a4bc90432d4525$var$locale = {
    code: 'en-US',
    formatDistance: (0, $d9WK4.default),
    formatLong: (0, $hC7jN.default),
    formatRelative: (0, $658UP.default),
    localize: (0, $9x2pl.default),
    match: (0, $9hXn5.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $47a4bc90432d4525$export$2e2bcd8739ae039 = $47a4bc90432d4525$var$locale;

});
parcelRegister("d9WK4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9949ae911e007c8f$export$2e2bcd8739ae039; });
var $9949ae911e007c8f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $9949ae911e007c8f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9949ae911e007c8f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $9949ae911e007c8f$export$2e2bcd8739ae039 = $9949ae911e007c8f$var$formatDistance;

});

parcelRegister("hC7jN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd2ba98ba838914b$export$2e2bcd8739ae039; });

var $j9YtV = parcelRequire("j9YtV");
var $cd2ba98ba838914b$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $cd2ba98ba838914b$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $cd2ba98ba838914b$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cd2ba98ba838914b$var$formatLong = {
    date: (0, $j9YtV.default)({
        formats: $cd2ba98ba838914b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $j9YtV.default)({
        formats: $cd2ba98ba838914b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $j9YtV.default)({
        formats: $cd2ba98ba838914b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cd2ba98ba838914b$export$2e2bcd8739ae039 = $cd2ba98ba838914b$var$formatLong;

});
parcelRegister("j9YtV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $df2dc60048c2e83a$export$2e2bcd8739ae039; });
function $df2dc60048c2e83a$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("658UP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $46da202c9cd4c5cb$export$2e2bcd8739ae039; });
var $46da202c9cd4c5cb$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $46da202c9cd4c5cb$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $46da202c9cd4c5cb$var$formatRelativeLocale[token];
};
var $46da202c9cd4c5cb$export$2e2bcd8739ae039 = $46da202c9cd4c5cb$var$formatRelative;

});

parcelRegister("9x2pl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6f0910467a8da1c7$export$2e2bcd8739ae039; });

var $avedE = parcelRequire("avedE");
var $6f0910467a8da1c7$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $6f0910467a8da1c7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $6f0910467a8da1c7$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $6f0910467a8da1c7$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $6f0910467a8da1c7$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $6f0910467a8da1c7$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $6f0910467a8da1c7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $6f0910467a8da1c7$var$localize = {
    ordinalNumber: $6f0910467a8da1c7$var$ordinalNumber,
    era: (0, $avedE.default)({
        values: $6f0910467a8da1c7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $avedE.default)({
        values: $6f0910467a8da1c7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $avedE.default)({
        values: $6f0910467a8da1c7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $avedE.default)({
        values: $6f0910467a8da1c7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $avedE.default)({
        values: $6f0910467a8da1c7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $6f0910467a8da1c7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $6f0910467a8da1c7$export$2e2bcd8739ae039 = $6f0910467a8da1c7$var$localize;

});
parcelRegister("avedE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7a57d4465480ea1c$export$2e2bcd8739ae039; });
function $7a57d4465480ea1c$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("9hXn5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6c33c17a7359a842$export$2e2bcd8739ae039; });

var $bGmUj = parcelRequire("bGmUj");

var $6e2Ck = parcelRequire("6e2Ck");
var $6c33c17a7359a842$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $6c33c17a7359a842$var$parseOrdinalNumberPattern = /\d+/i;
var $6c33c17a7359a842$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $6c33c17a7359a842$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $6c33c17a7359a842$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $6c33c17a7359a842$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6c33c17a7359a842$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $6c33c17a7359a842$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6c33c17a7359a842$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $6c33c17a7359a842$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $6c33c17a7359a842$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $6c33c17a7359a842$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $6c33c17a7359a842$var$match = {
    ordinalNumber: (0, $6e2Ck.default)({
        matchPattern: $6c33c17a7359a842$var$matchOrdinalNumberPattern,
        parsePattern: $6c33c17a7359a842$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $bGmUj.default)({
        matchPatterns: $6c33c17a7359a842$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6c33c17a7359a842$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $bGmUj.default)({
        matchPatterns: $6c33c17a7359a842$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6c33c17a7359a842$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $bGmUj.default)({
        matchPatterns: $6c33c17a7359a842$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6c33c17a7359a842$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $bGmUj.default)({
        matchPatterns: $6c33c17a7359a842$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6c33c17a7359a842$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $bGmUj.default)({
        matchPatterns: $6c33c17a7359a842$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6c33c17a7359a842$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6c33c17a7359a842$export$2e2bcd8739ae039 = $6c33c17a7359a842$var$match;

});
parcelRegister("bGmUj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $881562d5ed017f06$export$2e2bcd8739ae039; });
function $881562d5ed017f06$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $881562d5ed017f06$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $881562d5ed017f06$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $881562d5ed017f06$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $881562d5ed017f06$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("6e2Ck", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $48861496ed3cd1c7$export$2e2bcd8739ae039; });
function $48861496ed3cd1c7$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("8IXWc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $65a0ed2a7a917d34$export$2e2bcd8739ae039; });

var $486lh = parcelRequire("486lh");

var $fLbYn = parcelRequire("fLbYn");
function $65a0ed2a7a917d34$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fLbYn.default)(1, arguments);
    var date = (0, $486lh.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("gw7QQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c065b9983d56c148$export$2e2bcd8739ae039; });

var $jCeEo = parcelRequire("jCeEo");

var $fLbYn = parcelRequire("fLbYn");

var $joxzS = parcelRequire("joxzS");
function $c065b9983d56c148$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $fLbYn.default)(1, arguments);
    var additionalDigits = (0, $joxzS.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $c065b9983d56c148$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $c065b9983d56c148$var$parseYear(dateStrings.date, additionalDigits);
        date = $c065b9983d56c148$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $c065b9983d56c148$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $c065b9983d56c148$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $c065b9983d56c148$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $c065b9983d56c148$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $c065b9983d56c148$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $c065b9983d56c148$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $c065b9983d56c148$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($c065b9983d56c148$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($c065b9983d56c148$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($c065b9983d56c148$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $c065b9983d56c148$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $c065b9983d56c148$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $c065b9983d56c148$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($c065b9983d56c148$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $c065b9983d56c148$var$parseDateUnit(captures[1]);
    var month = $c065b9983d56c148$var$parseDateUnit(captures[2]) - 1;
    var day = $c065b9983d56c148$var$parseDateUnit(captures[3]);
    var week = $c065b9983d56c148$var$parseDateUnit(captures[4]);
    var dayOfWeek = $c065b9983d56c148$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$c065b9983d56c148$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $c065b9983d56c148$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$c065b9983d56c148$var$validateDate(year, month, day) || !$c065b9983d56c148$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $c065b9983d56c148$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $c065b9983d56c148$var$parseTime(timeString) {
    var captures = timeString.match($c065b9983d56c148$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $c065b9983d56c148$var$parseTimeUnit(captures[1]);
    var minutes = $c065b9983d56c148$var$parseTimeUnit(captures[2]);
    var seconds = $c065b9983d56c148$var$parseTimeUnit(captures[3]);
    if (!$c065b9983d56c148$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jCeEo.millisecondsInHour) + minutes * (0, $jCeEo.millisecondsInMinute) + seconds * 1000;
}
function $c065b9983d56c148$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $c065b9983d56c148$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($c065b9983d56c148$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$c065b9983d56c148$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jCeEo.millisecondsInHour) + minutes * (0, $jCeEo.millisecondsInMinute));
}
function $c065b9983d56c148$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $c065b9983d56c148$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $c065b9983d56c148$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $c065b9983d56c148$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($c065b9983d56c148$var$daysInMonths[month] || ($c065b9983d56c148$var$isLeapYearIndex(year) ? 29 : 28));
}
function $c065b9983d56c148$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($c065b9983d56c148$var$isLeapYearIndex(year) ? 366 : 365);
}
function $c065b9983d56c148$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $c065b9983d56c148$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $c065b9983d56c148$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});
parcelRegister("jCeEo", function(module, exports) {
$parcel$export(module.exports, "millisecondsInMinute", function () { return $e47cee3a6cf4a0ad$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $e47cee3a6cf4a0ad$export$7f72910d6dfd237a; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e47cee3a6cf4a0ad$export$dfd9b671c89acc8e = 7;
var $e47cee3a6cf4a0ad$export$3913210603d8e9ae = 365.2425;
var $e47cee3a6cf4a0ad$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e47cee3a6cf4a0ad$export$91246f0b9bd9beff = 60000;
var $e47cee3a6cf4a0ad$export$7f72910d6dfd237a = 3600000;
var $e47cee3a6cf4a0ad$export$397c2d5776aa9055 = 1000;
var $e47cee3a6cf4a0ad$export$4dec998e48f9c246 = -$e47cee3a6cf4a0ad$export$81caae6e1cc7a622;
var $e47cee3a6cf4a0ad$export$f2f5ae5a8e2d8f9f = 60;
var $e47cee3a6cf4a0ad$export$3c58128db900d44e = 3;
var $e47cee3a6cf4a0ad$export$80d7e435f744f319 = 12;
var $e47cee3a6cf4a0ad$export$4db7641526e3241f = 4;
var $e47cee3a6cf4a0ad$export$698aec755e92c695 = 3600;
var $e47cee3a6cf4a0ad$export$a77c1a7ebebe2a5a = 60;
var $e47cee3a6cf4a0ad$export$815a9362476d2fe3 = $e47cee3a6cf4a0ad$export$698aec755e92c695 * 24;
var $e47cee3a6cf4a0ad$export$34804a017b31e2fe = $e47cee3a6cf4a0ad$export$815a9362476d2fe3 * 7;
var $e47cee3a6cf4a0ad$export$7271e9e3478110d1 = $e47cee3a6cf4a0ad$export$815a9362476d2fe3 * $e47cee3a6cf4a0ad$export$3913210603d8e9ae;
var $e47cee3a6cf4a0ad$export$8e6600bbdee7dabb = $e47cee3a6cf4a0ad$export$7271e9e3478110d1 / 12;
var $e47cee3a6cf4a0ad$export$be1dccf2de902d31 = $e47cee3a6cf4a0ad$export$8e6600bbdee7dabb * 3;

});


parcelRegister("5pnhH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3f01595dacd58cea$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $hnYOn = parcelRequire("hnYOn");

var $duw73 = parcelRequire("duw73");

var $23fRn = parcelRequire("23fRn");
var $ctlY7 = parcelRequire("ctlY7");
var $53rTZ = parcelRequire("53rTZ");

var $aeC8u = parcelRequire("aeC8u");

var $fcCt7 = parcelRequire("fcCt7");

var $dCGhl = parcelRequire("dCGhl");

var $7I2le = parcelRequire("7I2le");

var $8IOH3 = parcelRequire("8IOH3");

var $62qHZ = parcelRequire("62qHZ");

var $14H52 = parcelRequire("14H52");

var $7fRLv = parcelRequire("7fRLv");

var $7fNdx = parcelRequire("7fNdx");

var $hx2cf = parcelRequire("hx2cf");

var $bXdbj = parcelRequire("bXdbj");

var $7pQpP = parcelRequire("7pQpP");
function $3f01595dacd58cea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f01595dacd58cea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f01595dacd58cea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f01595dacd58cea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f01595dacd58cea$var$boxStyles = (0, $53rTZ.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
var $3f01595dacd58cea$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "@atlaskit/calendar",
    packageVersion: "14.5.2"
};
var $3f01595dacd58cea$var$InnerCalendar = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function Calendar(_ref, ref) {
    var day = _ref.day, _ref$defaultDay = _ref.defaultDay, defaultDay = _ref$defaultDay === void 0 ? 0 : _ref$defaultDay, _ref$defaultMonth = _ref.defaultMonth, defaultMonth = _ref$defaultMonth === void 0 ? 0 : _ref$defaultMonth, _ref$defaultPreviousl = _ref.defaultPreviouslySelected, defaultPreviouslySelected = _ref$defaultPreviousl === void 0 ? (0, $7I2le.blankStringArray) : _ref$defaultPreviousl, _ref$defaultSelected = _ref.defaultSelected, defaultSelected = _ref$defaultSelected === void 0 ? (0, $7I2le.blankStringArray) : _ref$defaultSelected, _ref$defaultYear = _ref.defaultYear, defaultYear = _ref$defaultYear === void 0 ? 0 : _ref$defaultYear, disabled = _ref.disabled, disabledDateFilter = _ref.disabledDateFilter, minDate = _ref.minDate, maxDate = _ref.maxDate, month = _ref.month, nextMonthLabel = _ref.nextMonthLabel, _ref$onBlur = _ref.onBlur, onBlur = _ref$onBlur === void 0 ? (0, $duw73.default) : _ref$onBlur, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? (0, $duw73.default) : _ref$onChange, _ref$onFocus = _ref.onFocus, onFocus = _ref$onFocus === void 0 ? (0, $duw73.default) : _ref$onFocus, _ref$onSelect = _ref.onSelect, onSelect = _ref$onSelect === void 0 ? (0, $duw73.default) : _ref$onSelect, previouslySelected = _ref.previouslySelected, previousMonthLabel = _ref.previousMonthLabel, selected = _ref.selected, _ref$shouldSetFocusOn = _ref.shouldSetFocusOnCurrentDay, shouldSetFocusOnCurrentDay = _ref$shouldSetFocusOn === void 0 ? false : _ref$shouldSetFocusOn, today = _ref.today, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? 'en-US' : _ref$locale, year = _ref.year, analyticsContext = _ref.analyticsContext, _ref$weekStartDay = _ref.weekStartDay, weekStartDay = _ref$weekStartDay === void 0 ? 0 : _ref$weekStartDay, testId = _ref.testId, calendarRef = _ref.calendarRef, className = _ref.className, style = _ref.style, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
    var _useControlledDateSta = (0, $62qHZ.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    }), _useControlledDateSta2 = (0, $2qaZZ.default)(_useControlledDateSta.day, 2), dayValue = _useControlledDateSta2[0], setDayValue = _useControlledDateSta2[1], _useControlledDateSta3 = (0, $2qaZZ.default)(_useControlledDateSta.month, 2), monthValue = _useControlledDateSta3[0], setMonthValue = _useControlledDateSta3[1], _useControlledDateSta4 = (0, $2qaZZ.default)(_useControlledDateSta.year, 2), yearValue = _useControlledDateSta4[0], setYearValue = _useControlledDateSta4[1], _useControlledDateSta5 = (0, $2qaZZ.default)(_useControlledDateSta.today, 1), todayValue = _useControlledDateSta5[0], _useControlledDateSta6 = (0, $2qaZZ.default)(_useControlledDateSta.selected, 2), selectedValue = _useControlledDateSta6[0], setSelectedValue = _useControlledDateSta6[1], _useControlledDateSta7 = (0, $2qaZZ.default)(_useControlledDateSta.previous, 2), previouslySelectedValue = _useControlledDateSta7[0], setPreviouslySelectedValue = _useControlledDateSta7[1];
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), shouldSetFocus = _useState2[0], setShouldSetFocus = _useState2[1];
    var onChangeWithAnalytics = (0, $hnYOn.usePlatformLeafEventHandler)($3f01595dacd58cea$var$_objectSpread({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext
    }, $3f01595dacd58cea$var$analyticsAttributes));
    var _useHandleDateChange = (0, $7fNdx.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    }), navigate = _useHandleDateChange.navigate, handleClickNext = _useHandleDateChange.handleClickNext, handleClickPrev = _useHandleDateChange.handleClickPrev;
    var onSelectWithAnalytics = (0, $hnYOn.usePlatformLeafEventHandler)($3f01595dacd58cea$var$_objectSpread({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext
    }, $3f01595dacd58cea$var$analyticsAttributes));
    var _useHandleDateSelect = (0, $hx2cf.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    }), handleClickDay = _useHandleDateSelect.handleClickDay, handleContainerKeyDown = _useHandleDateSelect.handleContainerKeyDown;
    var _useFocusing = (0, $14H52.default)({
        onFocus: onFocus,
        onBlur: onBlur
    }), handleContainerBlur = _useFocusing.handleContainerBlur, handleContainerFocus = _useFocusing.handleContainerFocus;
    (0, $8IOH3.default)(calendarRef, {
        navigate: navigate
    });
    var _useLocale = (0, $bXdbj.default)({
        locale: locale,
        weekStartDay: weekStartDay
    }), monthsLong = _useLocale.monthsLong, daysShort = _useLocale.daysShort, daysLong = _useLocale.daysLong;
    var weeks = (0, $7fRLv.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    var getNextHeading = function getNextHeading() {
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        var nextMonth = monthValue % 12;
        var showNextYear = monthValue === 12;
        return "".concat(monthsLong[nextMonth], " ").concat(showNextYear ? yearValue + 1 : yearValue);
    };
    var getPreviousHeading = function getPreviousHeading() {
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        var previousMonth = (monthValue + 12 - 2) % 12;
        var showPreviousYear = monthValue === 1;
        return "".concat(monthsLong[previousMonth], " ").concat(showPreviousYear ? yearValue - 1 : yearValue);
    };
    var headerId = (0, $7pQpP.default)('month-year-header');
    return (0, $3dJ4i.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && "".concat(testId, "--container"),
        ref: ref
    }, (0, $3dJ4i.jsx)((0, $23fRn.default), {
        xcss: $3f01595dacd58cea$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && "".concat(testId, "--calendar")
    }, (0, $3dJ4i.jsx)((0, $ctlY7.default), {
        space: "space.150"
    }, (0, $3dJ4i.jsx)((0, $aeC8u.default), {
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), (0, $3dJ4i.jsx)((0, $23fRn.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && "".concat(testId, "--calendar-dates")
    }, (0, $3dJ4i.jsx)((0, $dCGhl.default), {
        daysShort: daysShort,
        testId: testId
    }), (0, $3dJ4i.jsx)((0, $fcCt7.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ var $3f01595dacd58cea$var$Calendar = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Calendar(props, ref) {
    return (0, $3dJ4i.jsx)($3f01595dacd58cea$var$InnerCalendar, (0, $c9bqK.default)({}, props, {
        ref: ref
    }));
}));
$3f01595dacd58cea$var$Calendar.displayName = 'Calendar';
var $3f01595dacd58cea$export$2e2bcd8739ae039 = $3f01595dacd58cea$var$Calendar;

});
parcelRegister("hnYOn", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $ca83c18ad2e57373$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $2s6Ge = parcelRequire("2s6Ge");

var $gvQUj = parcelRequire("gvQUj");
function $ca83c18ad2e57373$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ca83c18ad2e57373$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ca83c18ad2e57373$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ca83c18ad2e57373$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ca83c18ad2e57373$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $2s6Ge.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $gvQUj.useTrackedRef)(analyticsData);
    var fnRef = (0, $gvQUj.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $ca83c18ad2e57373$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("2s6Ge", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $1c9360d0315b8c3e$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $iZrkX = parcelRequire("iZrkX");

var $jMN5z = parcelRequire("jMN5z");
function $1c9360d0315b8c3e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $jMN5z.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $iZrkX.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("iZrkX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dd3321118c3ff31d$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $dWbSb = parcelRequire("dWbSb");
function $dd3321118c3ff31d$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $dd3321118c3ff31d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $dd3321118c3ff31d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dd3321118c3ff31d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $dd3321118c3ff31d$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $dd3321118c3ff31d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $dd3321118c3ff31d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $dd3321118c3ff31d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $dd3321118c3ff31d$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $dd3321118c3ff31d$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $dWbSb.default));

});
parcelRegister("dWbSb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a259e6e0a7e41ec5$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $a259e6e0a7e41ec5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a259e6e0a7e41ec5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a259e6e0a7e41ec5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a259e6e0a7e41ec5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a259e6e0a7e41ec5$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a259e6e0a7e41ec5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $a259e6e0a7e41ec5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $a259e6e0a7e41ec5$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $a259e6e0a7e41ec5$var$_objectSpread($a259e6e0a7e41ec5$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("jMN5z", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $e678940ae666dcd1$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $e678940ae666dcd1$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("gvQUj", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $c05894dbc72587b5$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $c05894dbc72587b5$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("duw73", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d26fca21edf316c$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $9d26fca21edf316c$export$2e2bcd8739ae039() {}

});

parcelRegister("23fRn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $17e82a073a9bd0e5$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $bcm6Z = parcelRequire("bcm6Z");

var $53rTZ = parcelRequire("53rTZ");

var $h3spv = parcelRequire("h3spv");
var $17e82a073a9bd0e5$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $17e82a073a9bd0e5$var$_excluded2 = [
    "className"
];
var $17e82a073a9bd0e5$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $17e82a073a9bd0e5$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $17e82a073a9bd0e5$var$_excluded2);
    var resolvedStyles = (0, $53rTZ.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $17e82a073a9bd0e5$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $bcm6Z.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bcm6Z.isSurfaceColorToken)(backgroundColor) && (0, $bcm6Z.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $bcm6Z.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $bcm6Z.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $bcm6Z.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $bcm6Z.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $bcm6Z.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $bcm6Z.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $bcm6Z.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $h3spv.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $17e82a073a9bd0e5$export$2e2bcd8739ae039 = $17e82a073a9bd0e5$export$e71c4d32a2263218;
var $17e82a073a9bd0e5$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("bcm6Z", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $8271f7a3fd5ebff5$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $8271f7a3fd5ebff5$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $8271f7a3fd5ebff5$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $8271f7a3fd5ebff5$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $8271f7a3fd5ebff5$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $8271f7a3fd5ebff5$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $8271f7a3fd5ebff5$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $8271f7a3fd5ebff5$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $8271f7a3fd5ebff5$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $8271f7a3fd5ebff5$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $8271f7a3fd5ebff5$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $8271f7a3fd5ebff5$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $8271f7a3fd5ebff5$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $8271f7a3fd5ebff5$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $8271f7a3fd5ebff5$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $8271f7a3fd5ebff5$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $8271f7a3fd5ebff5$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $8271f7a3fd5ebff5$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $8271f7a3fd5ebff5$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $8271f7a3fd5ebff5$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $8271f7a3fd5ebff5$export$38845ca010b93505; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $8271f7a3fd5ebff5$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $8271f7a3fd5ebff5$export$5e65a44e5b6ecadb; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $2IWu9 = parcelRequire("2IWu9");
function $8271f7a3fd5ebff5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8271f7a3fd5ebff5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8271f7a3fd5ebff5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8271f7a3fd5ebff5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8271f7a3fd5ebff5$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $8271f7a3fd5ebff5$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $8271f7a3fd5ebff5$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $8271f7a3fd5ebff5$export$632685d741f3dbbf = $8271f7a3fd5ebff5$var$_objectSpread($8271f7a3fd5ebff5$var$_objectSpread({}, $8271f7a3fd5ebff5$export$958d0ae7f2977ae4), $8271f7a3fd5ebff5$export$d2dc61f58390201c);
var $8271f7a3fd5ebff5$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $8271f7a3fd5ebff5$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $8271f7a3fd5ebff5$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $8271f7a3fd5ebff5$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $8271f7a3fd5ebff5$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $8271f7a3fd5ebff5$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $8271f7a3fd5ebff5$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $8271f7a3fd5ebff5$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $8271f7a3fd5ebff5$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $8271f7a3fd5ebff5$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $8271f7a3fd5ebff5$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $8271f7a3fd5ebff5$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $8271f7a3fd5ebff5$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $8271f7a3fd5ebff5$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $8271f7a3fd5ebff5$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $8271f7a3fd5ebff5$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $8271f7a3fd5ebff5$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $f53LC.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $8271f7a3fd5ebff5$export$e615f061ca585a6c = $8271f7a3fd5ebff5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7(spacingProperty, $8271f7a3fd5ebff5$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8271f7a3fd5ebff5$export$bf46c3f9eeafc71f = $8271f7a3fd5ebff5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7(spacingProperty, $8271f7a3fd5ebff5$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8271f7a3fd5ebff5$export$e7af83bafe7f9e63 = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7('backgroundColor', $8271f7a3fd5ebff5$export$d1d79bf68ac056bd);
var $8271f7a3fd5ebff5$export$3a1bcba60b23d7f0 = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7('color', $8271f7a3fd5ebff5$export$8473307aa00d6ea1);
var $8271f7a3fd5ebff5$export$45f3f4fe16f9f7d5 = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7('fontWeight', $8271f7a3fd5ebff5$export$303e322c6b1ed114);
var $8271f7a3fd5ebff5$export$68cc305da27dbaa4 = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7('fontFamily', $8271f7a3fd5ebff5$export$3c7e9587132614b4);
var $8271f7a3fd5ebff5$export$128f10c238242f83 = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7('font', $8271f7a3fd5ebff5$export$6ffa317d5e70375);
var $8271f7a3fd5ebff5$export$219d364c0da35ae4 = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7('font', $8271f7a3fd5ebff5$export$236bfe3a33ef1292);
var $8271f7a3fd5ebff5$export$38845ca010b93505 = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7('fontWeight', $8271f7a3fd5ebff5$export$855cfd311192d666);
var $8271f7a3fd5ebff5$export$ff257d957d48c421 = $8271f7a3fd5ebff5$export$ca0f9c2de39ffed7((0, $2IWu9.CURRENT_SURFACE_CSS_VAR), $8271f7a3fd5ebff5$export$41a358c9c2356760);
var $8271f7a3fd5ebff5$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $8271f7a3fd5ebff5$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("2IWu9", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $1fbd0ecc5e6aa1d1$export$9d7b58831ae93caa; });
var $1fbd0ecc5e6aa1d1$export$4ef52930e33717cd = 'data-theme';
var $1fbd0ecc5e6aa1d1$export$a00eac3f8684bcd0 = 'data-color-mode';
var $1fbd0ecc5e6aa1d1$export$2112803007239c61 = 'data-contrast-mode';
var $1fbd0ecc5e6aa1d1$export$352e418ed5b6193a = 'data-custom-theme';
var $1fbd0ecc5e6aa1d1$export$2faeed762aac6741 = 'light';
var $1fbd0ecc5e6aa1d1$export$6f0c6fb8c80fcc92 = 'ds';
var $1fbd0ecc5e6aa1d1$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $1fbd0ecc5e6aa1d1$export$dddac1532e822863 = "--".concat($1fbd0ecc5e6aa1d1$export$6f0c6fb8c80fcc92, "-token-not-found");
var $1fbd0ecc5e6aa1d1$export$9d7b58831ae93caa = "--".concat($1fbd0ecc5e6aa1d1$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("53rTZ", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $3ae2e055ebce7066$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $3ae2e055ebce7066$export$f6c783d06584602c; });

var $lFOXD = parcelRequire("lFOXD");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2zYm4 = parcelRequire("2zYm4");

var $3dJ4i = parcelRequire("3dJ4i");

var $bcm6Z = parcelRequire("bcm6Z");

var $7t0tI = parcelRequire("7t0tI");
function $3ae2e055ebce7066$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3ae2e055ebce7066$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3ae2e055ebce7066$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3ae2e055ebce7066$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3ae2e055ebce7066$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3ae2e055ebce7066$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $3ae2e055ebce7066$export$9a199fbafee0014e = {
    backgroundColor: (0, $bcm6Z.backgroundColorMap),
    blockSize: (0, $bcm6Z.dimensionMap),
    borderBlockColor: (0, $bcm6Z.borderColorMap),
    borderBlockEndColor: (0, $bcm6Z.borderColorMap),
    borderBlockEndWidth: (0, $bcm6Z.borderWidthMap),
    borderBlockStartColor: (0, $bcm6Z.borderColorMap),
    borderBlockStartWidth: (0, $bcm6Z.borderWidthMap),
    borderBlockWidth: (0, $bcm6Z.borderWidthMap),
    borderBottomColor: (0, $bcm6Z.borderColorMap),
    borderBottomLeftRadius: (0, $bcm6Z.borderRadiusMap),
    borderBottomRightRadius: (0, $bcm6Z.borderRadiusMap),
    borderBottomWidth: (0, $bcm6Z.borderWidthMap),
    borderColor: (0, $bcm6Z.borderColorMap),
    borderEndEndRadius: (0, $bcm6Z.borderRadiusMap),
    borderEndStartRadius: (0, $bcm6Z.borderRadiusMap),
    borderInlineColor: (0, $bcm6Z.borderColorMap),
    borderInlineEndColor: (0, $bcm6Z.borderColorMap),
    borderInlineEndWidth: (0, $bcm6Z.borderWidthMap),
    borderInlineStartColor: (0, $bcm6Z.borderColorMap),
    borderInlineStartWidth: (0, $bcm6Z.borderWidthMap),
    borderInlineWidth: (0, $bcm6Z.borderWidthMap),
    borderLeftColor: (0, $bcm6Z.borderColorMap),
    borderLeftWidth: (0, $bcm6Z.borderWidthMap),
    borderRadius: (0, $bcm6Z.borderRadiusMap),
    borderRightColor: (0, $bcm6Z.borderColorMap),
    borderRightWidth: (0, $bcm6Z.borderWidthMap),
    borderStartEndRadius: (0, $bcm6Z.borderRadiusMap),
    borderStartStartRadius: (0, $bcm6Z.borderRadiusMap),
    borderTopColor: (0, $bcm6Z.borderColorMap),
    borderTopLeftRadius: (0, $bcm6Z.borderRadiusMap),
    borderTopRightRadius: (0, $bcm6Z.borderRadiusMap),
    borderTopWidth: (0, $bcm6Z.borderWidthMap),
    borderWidth: (0, $bcm6Z.borderWidthMap),
    bottom: (0, $bcm6Z.allSpaceMap),
    boxShadow: (0, $bcm6Z.shadowMap),
    color: (0, $bcm6Z.textColorMap),
    columnGap: (0, $bcm6Z.positiveSpaceMap),
    font: (0, $bcm6Z.fontMap),
    fontFamily: (0, $bcm6Z.fontFamilyMap),
    fontWeight: (0, $bcm6Z.fontWeightMap),
    gap: (0, $bcm6Z.positiveSpaceMap),
    height: (0, $bcm6Z.dimensionMap),
    inlineSize: (0, $bcm6Z.dimensionMap),
    inset: (0, $bcm6Z.allSpaceMap),
    insetBlock: (0, $bcm6Z.allSpaceMap),
    insetBlockEnd: (0, $bcm6Z.allSpaceMap),
    insetBlockStart: (0, $bcm6Z.allSpaceMap),
    insetInline: (0, $bcm6Z.allSpaceMap),
    insetInlineEnd: (0, $bcm6Z.allSpaceMap),
    insetInlineStart: (0, $bcm6Z.allSpaceMap),
    left: (0, $bcm6Z.allSpaceMap),
    margin: (0, $bcm6Z.allSpaceMap),
    marginBlock: (0, $bcm6Z.allSpaceMap),
    marginBlockEnd: (0, $bcm6Z.allSpaceMap),
    marginBlockStart: (0, $bcm6Z.allSpaceMap),
    marginBottom: (0, $bcm6Z.allSpaceMap),
    marginInline: (0, $bcm6Z.allSpaceMap),
    marginInlineEnd: (0, $bcm6Z.allSpaceMap),
    marginInlineStart: (0, $bcm6Z.allSpaceMap),
    marginLeft: (0, $bcm6Z.allSpaceMap),
    marginRight: (0, $bcm6Z.allSpaceMap),
    marginTop: (0, $bcm6Z.allSpaceMap),
    maxBlockSize: (0, $bcm6Z.dimensionMap),
    maxHeight: (0, $bcm6Z.dimensionMap),
    maxInlineSize: (0, $bcm6Z.dimensionMap),
    maxWidth: (0, $bcm6Z.dimensionMap),
    minBlockSize: (0, $bcm6Z.dimensionMap),
    minHeight: (0, $bcm6Z.dimensionMap),
    minInlineSize: (0, $bcm6Z.dimensionMap),
    minWidth: (0, $bcm6Z.dimensionMap),
    opacity: (0, $bcm6Z.opacityMap),
    outlineColor: (0, $bcm6Z.borderColorMap),
    outlineOffset: (0, $bcm6Z.positiveSpaceMap),
    outlineWidth: (0, $bcm6Z.borderWidthMap),
    padding: (0, $bcm6Z.positiveSpaceMap),
    paddingBlock: (0, $bcm6Z.positiveSpaceMap),
    paddingBlockEnd: (0, $bcm6Z.positiveSpaceMap),
    paddingBlockStart: (0, $bcm6Z.positiveSpaceMap),
    paddingBottom: (0, $bcm6Z.positiveSpaceMap),
    paddingInline: (0, $bcm6Z.positiveSpaceMap),
    paddingInlineEnd: (0, $bcm6Z.positiveSpaceMap),
    paddingInlineStart: (0, $bcm6Z.positiveSpaceMap),
    paddingLeft: (0, $bcm6Z.positiveSpaceMap),
    paddingRight: (0, $bcm6Z.positiveSpaceMap),
    paddingTop: (0, $bcm6Z.positiveSpaceMap),
    right: (0, $bcm6Z.allSpaceMap),
    rowGap: (0, $bcm6Z.positiveSpaceMap),
    top: (0, $bcm6Z.allSpaceMap),
    width: (0, $bcm6Z.dimensionMap),
    zIndex: (0, $bcm6Z.layerMap)
};
var $3ae2e055ebce7066$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $3ae2e055ebce7066$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $2zYm4.default)($7t0tI)) === 'object' && (0, $2zYm4.default)($7t0tI.env) === 'object' && false;
};
var $3ae2e055ebce7066$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $3ae2e055ebce7066$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $3ae2e055ebce7066$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $2zYm4.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $2zYm4.default)(value) === 'object' && $3ae2e055ebce7066$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($3ae2e055ebce7066$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($3ae2e055ebce7066$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $3ae2e055ebce7066$export$9a199fbafee0014e)) return;
        var tokenValue = $3ae2e055ebce7066$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $3ae2e055ebce7066$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $3ae2e055ebce7066$var$transformStyles(style);
    return (0, $f53LC.default)({}, $3ae2e055ebce7066$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
var $3ae2e055ebce7066$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $3ae2e055ebce7066$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $lFOXD.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$3ae2e055ebce7066$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $3ae2e055ebce7066$export$f6c783d06584602c(style) {
    return $3ae2e055ebce7066$var$baseXcss(style);
}

});

parcelRegister("h3spv", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $c6a8c12db2e5a80d$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $c6a8c12db2e5a80d$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $c6a8c12db2e5a80d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $c6a8c12db2e5a80d$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($c6a8c12db2e5a80d$export$1ca2a26fecb070ae);
};
$c6a8c12db2e5a80d$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("ctlY7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $91493c034227c58f$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $53rTZ = parcelRequire("53rTZ");

var $9KKSt = parcelRequire("9KKSt");
var $91493c034227c58f$var$flexGrowMap = {
    hug: (0, $53rTZ.xcss)({
        flexGrow: 0
    }),
    fill: (0, $53rTZ.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $91493c034227c58f$var$Stack = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $91493c034227c58f$var$flexGrowMap[grow]
    ].concat((0, $lFOXD.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3dJ4i.jsx)((0, $9KKSt.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$91493c034227c58f$var$Stack.displayName = 'Stack';
var $91493c034227c58f$export$2e2bcd8739ae039 = $91493c034227c58f$var$Stack;

});
parcelRegister("9KKSt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $719cc5dab3027a3f$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $bcm6Z = parcelRequire("bcm6Z");

var $53rTZ = parcelRequire("53rTZ");
var $719cc5dab3027a3f$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $719cc5dab3027a3f$var$flexDirectionMap = {
    column: (0, $3dJ4i.css)({
        flexDirection: 'column'
    }),
    row: (0, $3dJ4i.css)({
        flexDirection: 'row'
    })
};
var $719cc5dab3027a3f$var$flexWrapMap = {
    wrap: (0, $3dJ4i.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3dJ4i.css)({
        flexWrap: 'nowrap'
    })
};
var $719cc5dab3027a3f$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        alignItems: 'stretch'
    })
};
var $719cc5dab3027a3f$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $719cc5dab3027a3f$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $53rTZ.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $719cc5dab3027a3f$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $bcm6Z.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $bcm6Z.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $bcm6Z.spaceStylesMap).rowGap[rowGap],
            alignItems && $719cc5dab3027a3f$var$alignItemsMap[alignItems],
            direction && $719cc5dab3027a3f$var$flexDirectionMap[direction],
            justifyContent && $719cc5dab3027a3f$var$justifyContentMap[justifyContent],
            wrap && $719cc5dab3027a3f$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$719cc5dab3027a3f$var$Flex.displayName = 'Flex';
var $719cc5dab3027a3f$export$2e2bcd8739ae039 = $719cc5dab3027a3f$var$Flex;

});


parcelRegister("aeC8u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7738cb2bdbc6e8b1$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $j447Q = parcelRequire("j447Q");

var $8cg9k = parcelRequire("8cg9k");

var $3NViD = parcelRequire("3NViD");

var $5xsYy = parcelRequire("5xsYy");

var $23fRn = parcelRequire("23fRn");
var $k4A03 = parcelRequire("k4A03");

var $7pQpP = parcelRequire("7pQpP");
var $7738cb2bdbc6e8b1$var$Header = /*#__PURE__*/ (0, $1oC0p.memo)(function Header(_ref) {
    var monthLongTitle = _ref.monthLongTitle, year = _ref.year, _ref$previousMonthLab = _ref.previousMonthLabel, previousMonthLabel = _ref$previousMonthLab === void 0 ? 'Previous month' : _ref$previousMonthLab, previousHeading = _ref.previousHeading, _ref$nextMonthLabel = _ref.nextMonthLabel, nextMonthLabel = _ref$nextMonthLabel === void 0 ? 'Next month' : _ref$nextMonthLabel, nextHeading = _ref.nextHeading, handleClickPrev = _ref.handleClickPrev, handleClickNext = _ref.handleClickNext, headerId = _ref.headerId, tabIndex = _ref.tabIndex, testId = _ref.testId;
    var announceId = (0, $7pQpP.default)('month-year-announce');
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), hasInteractedWithMonth = _useState2[0], setHasInteractedWithMonth = _useState2[1];
    var handlePrevMonthInteraction = function handlePrevMonthInteraction(e) {
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    var handleNextMonthInteraction = function handleNextMonthInteraction(e) {
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return (0, $3dJ4i.jsx)((0, $23fRn.default), {
        paddingInline: "space.100"
    }, (0, $3dJ4i.jsx)((0, $k4A03.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, (0, $3dJ4i.jsx)((0, $j447Q.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && "".concat(testId, "--previous-month"),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3NViD))),
        label: "".concat(previousMonthLabel, ", ").concat(previousHeading)
    }), (0, $3dJ4i.jsx)((0, $23fRn.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && "".concat(testId, "--current-month-year--container")
    }, (0, $3dJ4i.jsx)((0, $8cg9k.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && "".concat(testId, "--current-month-year")
    }, "".concat(monthLongTitle, " ").concat(year))), (0, $3dJ4i.jsx)((0, $j447Q.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && "".concat(testId, "--next-month"),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5xsYy))),
        label: "".concat(nextMonthLabel, ", ").concat(nextHeading)
    })));
});
$7738cb2bdbc6e8b1$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7738cb2bdbc6e8b1$export$2e2bcd8739ae039 = $7738cb2bdbc6e8b1$var$Header;

});
parcelRegister("j447Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de11974c3dd1712a$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $clAdI = parcelRequire("clAdI");

var $fRYjf = parcelRequire("fRYjf");

var $i8JRV = parcelRequire("i8JRV");
var $de11974c3dd1712a$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $de11974c3dd1712a$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $de11974c3dd1712a$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $gnQ3X.default)(_ref, $de11974c3dd1712a$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $de11974c3dd1712a$var$_excluded2);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $i8JRV.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'button',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fRYjf.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $clAdI.default), (0, $c9bqK.default)({}, saferRest, {
                // Top level props
                "aria-labelledby": baseProps['aria-labelledby'],
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $clAdI.default), (0, $c9bqK.default)({}, saferRest, {
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$de11974c3dd1712a$var$IconButton.displayName = 'IconButton';
var $de11974c3dd1712a$export$2e2bcd8739ae039 = $de11974c3dd1712a$var$IconButton;

});
parcelRegister("clAdI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8fd38ac2d3403192$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $5irl0 = parcelRequire("5irl0");

var $3ok5u = parcelRequire("3ok5u");

var $5Bwfa = parcelRequire("5Bwfa");

var $fjusW = parcelRequire("fjusW");

var $jP2pL = parcelRequire("jP2pL");
var $8fd38ac2d3403192$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $8fd38ac2d3403192$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $8fd38ac2d3403192$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $fjusW.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $fjusW.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $fjusW.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $8fd38ac2d3403192$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $8fd38ac2d3403192$var$enabledStyles = (0, $3dJ4i.css)({
    cursor: 'pointer'
});
var $8fd38ac2d3403192$var$disabledStyles = (0, $3dJ4i.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $8fd38ac2d3403192$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3ok5u.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $8fd38ac2d3403192$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $5Bwfa.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $5irl0.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $8fd38ac2d3403192$var$_excluded2);
    var resolvedStyles = (0, $jP2pL.parseXcss)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $3dJ4i.jsx)("button", (0, $c9bqK.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $8fd38ac2d3403192$var$baseStyles,
            $8fd38ac2d3403192$var$focusRingStyles,
            isDisabled ? $8fd38ac2d3403192$var$disabledStyles : $8fd38ac2d3403192$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $fjusW.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $fjusW.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $fjusW.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $fjusW.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $fjusW.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $fjusW.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $fjusW.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $fjusW.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $8fd38ac2d3403192$export$2e2bcd8739ae039 = $8fd38ac2d3403192$var$Pressable;

});
parcelRegister("5irl0", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $3db3d6e436043fac$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $1JtQr = parcelRequire("1JtQr");

var $e55Bn = parcelRequire("e55Bn");
function $3db3d6e436043fac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3db3d6e436043fac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3db3d6e436043fac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3db3d6e436043fac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3db3d6e436043fac$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $1JtQr.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $e55Bn.useTrackedRef)(analyticsData);
    var fnRef = (0, $e55Bn.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $3db3d6e436043fac$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("1JtQr", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $143124fc6e7581f6$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $lRPYB = parcelRequire("lRPYB");

var $eA06g = parcelRequire("eA06g");
function $143124fc6e7581f6$export$5bf35293e545f20c() {
    var analyticsContext = (0, $eA06g.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $lRPYB.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("lRPYB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $feb6dda1836d96d4$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5YlXt = parcelRequire("5YlXt");
function $feb6dda1836d96d4$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $feb6dda1836d96d4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $feb6dda1836d96d4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($feb6dda1836d96d4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $feb6dda1836d96d4$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $feb6dda1836d96d4$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $feb6dda1836d96d4$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $feb6dda1836d96d4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $feb6dda1836d96d4$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $feb6dda1836d96d4$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $5YlXt.default));

});
parcelRegister("5YlXt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $459396c91ab40eee$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $459396c91ab40eee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $459396c91ab40eee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $459396c91ab40eee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $459396c91ab40eee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $459396c91ab40eee$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $459396c91ab40eee$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $459396c91ab40eee$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $459396c91ab40eee$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $459396c91ab40eee$var$_objectSpread($459396c91ab40eee$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("eA06g", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $a9d48159f68e86bb$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $a9d48159f68e86bb$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("e55Bn", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $a405e0b5ae6a1d44$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $a405e0b5ae6a1d44$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("3ok5u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $278331f82f0d1e97$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $278331f82f0d1e97$export$2e2bcd8739ae039() {}

});

parcelRegister("5Bwfa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $41496b5adbcfb2f4$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $41496b5adbcfb2f4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("fjusW", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $b26043406ae8b5ba$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $b26043406ae8b5ba$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $b26043406ae8b5ba$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $b26043406ae8b5ba$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $b26043406ae8b5ba$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $b26043406ae8b5ba$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $b26043406ae8b5ba$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $b26043406ae8b5ba$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $b26043406ae8b5ba$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $b26043406ae8b5ba$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $b26043406ae8b5ba$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $b26043406ae8b5ba$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $b26043406ae8b5ba$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $b26043406ae8b5ba$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $b26043406ae8b5ba$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $b26043406ae8b5ba$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $b26043406ae8b5ba$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $b26043406ae8b5ba$export$5e65a44e5b6ecadb; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $lsJye = parcelRequire("lsJye");
function $b26043406ae8b5ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b26043406ae8b5ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b26043406ae8b5ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b26043406ae8b5ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b26043406ae8b5ba$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $b26043406ae8b5ba$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $b26043406ae8b5ba$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $b26043406ae8b5ba$export$632685d741f3dbbf = $b26043406ae8b5ba$var$_objectSpread($b26043406ae8b5ba$var$_objectSpread({}, $b26043406ae8b5ba$export$958d0ae7f2977ae4), $b26043406ae8b5ba$export$d2dc61f58390201c);
var $b26043406ae8b5ba$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $b26043406ae8b5ba$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $b26043406ae8b5ba$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $b26043406ae8b5ba$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $b26043406ae8b5ba$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $b26043406ae8b5ba$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $b26043406ae8b5ba$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $b26043406ae8b5ba$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $b26043406ae8b5ba$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $b26043406ae8b5ba$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $b26043406ae8b5ba$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $b26043406ae8b5ba$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $b26043406ae8b5ba$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $b26043406ae8b5ba$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $b26043406ae8b5ba$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $b26043406ae8b5ba$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $b26043406ae8b5ba$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $b26043406ae8b5ba$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $f53LC.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $b26043406ae8b5ba$export$e615f061ca585a6c = $b26043406ae8b5ba$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $b26043406ae8b5ba$export$ca0f9c2de39ffed7(spacingProperty, $b26043406ae8b5ba$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $b26043406ae8b5ba$export$bf46c3f9eeafc71f = $b26043406ae8b5ba$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $b26043406ae8b5ba$export$ca0f9c2de39ffed7(spacingProperty, $b26043406ae8b5ba$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $b26043406ae8b5ba$export$e7af83bafe7f9e63 = $b26043406ae8b5ba$export$ca0f9c2de39ffed7('backgroundColor', $b26043406ae8b5ba$export$d1d79bf68ac056bd);
var $b26043406ae8b5ba$export$3a1bcba60b23d7f0 = $b26043406ae8b5ba$export$ca0f9c2de39ffed7('color', $b26043406ae8b5ba$export$8473307aa00d6ea1);
var $b26043406ae8b5ba$export$45f3f4fe16f9f7d5 = $b26043406ae8b5ba$export$ca0f9c2de39ffed7('fontWeight', $b26043406ae8b5ba$export$303e322c6b1ed114);
var $b26043406ae8b5ba$export$68cc305da27dbaa4 = $b26043406ae8b5ba$export$ca0f9c2de39ffed7('fontFamily', $b26043406ae8b5ba$export$3c7e9587132614b4);
var $b26043406ae8b5ba$export$128f10c238242f83 = $b26043406ae8b5ba$export$ca0f9c2de39ffed7('font', $b26043406ae8b5ba$export$6ffa317d5e70375);
var $b26043406ae8b5ba$export$219d364c0da35ae4 = $b26043406ae8b5ba$export$ca0f9c2de39ffed7('font', $b26043406ae8b5ba$export$236bfe3a33ef1292);
var $b26043406ae8b5ba$export$38845ca010b93505 = $b26043406ae8b5ba$export$ca0f9c2de39ffed7('fontWeight', $b26043406ae8b5ba$export$855cfd311192d666);
var $b26043406ae8b5ba$export$ff257d957d48c421 = $b26043406ae8b5ba$export$ca0f9c2de39ffed7((0, $lsJye.CURRENT_SURFACE_CSS_VAR), $b26043406ae8b5ba$export$41a358c9c2356760);
var $b26043406ae8b5ba$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $b26043406ae8b5ba$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("lsJye", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $f9ff8c0307344357$export$9d7b58831ae93caa; });
var $f9ff8c0307344357$export$4ef52930e33717cd = 'data-theme';
var $f9ff8c0307344357$export$a00eac3f8684bcd0 = 'data-color-mode';
var $f9ff8c0307344357$export$2112803007239c61 = 'data-contrast-mode';
var $f9ff8c0307344357$export$352e418ed5b6193a = 'data-custom-theme';
var $f9ff8c0307344357$export$2faeed762aac6741 = 'light';
var $f9ff8c0307344357$export$6f0c6fb8c80fcc92 = 'ds';
var $f9ff8c0307344357$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $f9ff8c0307344357$export$dddac1532e822863 = "--".concat($f9ff8c0307344357$export$6f0c6fb8c80fcc92, "-token-not-found");
var $f9ff8c0307344357$export$9d7b58831ae93caa = "--".concat($f9ff8c0307344357$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("jP2pL", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $e6e4a731cfe135f2$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $e6e4a731cfe135f2$export$f6c783d06584602c; });

var $lFOXD = parcelRequire("lFOXD");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2zYm4 = parcelRequire("2zYm4");

var $3dJ4i = parcelRequire("3dJ4i");

var $fjusW = parcelRequire("fjusW");

var $7t0tI = parcelRequire("7t0tI");
function $e6e4a731cfe135f2$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e6e4a731cfe135f2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e6e4a731cfe135f2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e6e4a731cfe135f2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e6e4a731cfe135f2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e6e4a731cfe135f2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e6e4a731cfe135f2$export$9a199fbafee0014e = {
    backgroundColor: (0, $fjusW.backgroundColorMap),
    blockSize: (0, $fjusW.dimensionMap),
    borderBlockColor: (0, $fjusW.borderColorMap),
    borderBlockEndColor: (0, $fjusW.borderColorMap),
    borderBlockEndWidth: (0, $fjusW.borderWidthMap),
    borderBlockStartColor: (0, $fjusW.borderColorMap),
    borderBlockStartWidth: (0, $fjusW.borderWidthMap),
    borderBlockWidth: (0, $fjusW.borderWidthMap),
    borderBottomColor: (0, $fjusW.borderColorMap),
    borderBottomLeftRadius: (0, $fjusW.borderRadiusMap),
    borderBottomRightRadius: (0, $fjusW.borderRadiusMap),
    borderBottomWidth: (0, $fjusW.borderWidthMap),
    borderColor: (0, $fjusW.borderColorMap),
    borderEndEndRadius: (0, $fjusW.borderRadiusMap),
    borderEndStartRadius: (0, $fjusW.borderRadiusMap),
    borderInlineColor: (0, $fjusW.borderColorMap),
    borderInlineEndColor: (0, $fjusW.borderColorMap),
    borderInlineEndWidth: (0, $fjusW.borderWidthMap),
    borderInlineStartColor: (0, $fjusW.borderColorMap),
    borderInlineStartWidth: (0, $fjusW.borderWidthMap),
    borderInlineWidth: (0, $fjusW.borderWidthMap),
    borderLeftColor: (0, $fjusW.borderColorMap),
    borderLeftWidth: (0, $fjusW.borderWidthMap),
    borderRadius: (0, $fjusW.borderRadiusMap),
    borderRightColor: (0, $fjusW.borderColorMap),
    borderRightWidth: (0, $fjusW.borderWidthMap),
    borderStartEndRadius: (0, $fjusW.borderRadiusMap),
    borderStartStartRadius: (0, $fjusW.borderRadiusMap),
    borderTopColor: (0, $fjusW.borderColorMap),
    borderTopLeftRadius: (0, $fjusW.borderRadiusMap),
    borderTopRightRadius: (0, $fjusW.borderRadiusMap),
    borderTopWidth: (0, $fjusW.borderWidthMap),
    borderWidth: (0, $fjusW.borderWidthMap),
    bottom: (0, $fjusW.allSpaceMap),
    boxShadow: (0, $fjusW.shadowMap),
    color: (0, $fjusW.textColorMap),
    columnGap: (0, $fjusW.positiveSpaceMap),
    font: (0, $fjusW.fontMap),
    fontFamily: (0, $fjusW.fontFamilyMap),
    fontWeight: (0, $fjusW.fontWeightMap),
    gap: (0, $fjusW.positiveSpaceMap),
    height: (0, $fjusW.dimensionMap),
    inlineSize: (0, $fjusW.dimensionMap),
    inset: (0, $fjusW.allSpaceMap),
    insetBlock: (0, $fjusW.allSpaceMap),
    insetBlockEnd: (0, $fjusW.allSpaceMap),
    insetBlockStart: (0, $fjusW.allSpaceMap),
    insetInline: (0, $fjusW.allSpaceMap),
    insetInlineEnd: (0, $fjusW.allSpaceMap),
    insetInlineStart: (0, $fjusW.allSpaceMap),
    left: (0, $fjusW.allSpaceMap),
    margin: (0, $fjusW.allSpaceMap),
    marginBlock: (0, $fjusW.allSpaceMap),
    marginBlockEnd: (0, $fjusW.allSpaceMap),
    marginBlockStart: (0, $fjusW.allSpaceMap),
    marginBottom: (0, $fjusW.allSpaceMap),
    marginInline: (0, $fjusW.allSpaceMap),
    marginInlineEnd: (0, $fjusW.allSpaceMap),
    marginInlineStart: (0, $fjusW.allSpaceMap),
    marginLeft: (0, $fjusW.allSpaceMap),
    marginRight: (0, $fjusW.allSpaceMap),
    marginTop: (0, $fjusW.allSpaceMap),
    maxBlockSize: (0, $fjusW.dimensionMap),
    maxHeight: (0, $fjusW.dimensionMap),
    maxInlineSize: (0, $fjusW.dimensionMap),
    maxWidth: (0, $fjusW.dimensionMap),
    minBlockSize: (0, $fjusW.dimensionMap),
    minHeight: (0, $fjusW.dimensionMap),
    minInlineSize: (0, $fjusW.dimensionMap),
    minWidth: (0, $fjusW.dimensionMap),
    opacity: (0, $fjusW.opacityMap),
    outlineColor: (0, $fjusW.borderColorMap),
    outlineOffset: (0, $fjusW.positiveSpaceMap),
    outlineWidth: (0, $fjusW.borderWidthMap),
    padding: (0, $fjusW.positiveSpaceMap),
    paddingBlock: (0, $fjusW.positiveSpaceMap),
    paddingBlockEnd: (0, $fjusW.positiveSpaceMap),
    paddingBlockStart: (0, $fjusW.positiveSpaceMap),
    paddingBottom: (0, $fjusW.positiveSpaceMap),
    paddingInline: (0, $fjusW.positiveSpaceMap),
    paddingInlineEnd: (0, $fjusW.positiveSpaceMap),
    paddingInlineStart: (0, $fjusW.positiveSpaceMap),
    paddingLeft: (0, $fjusW.positiveSpaceMap),
    paddingRight: (0, $fjusW.positiveSpaceMap),
    paddingTop: (0, $fjusW.positiveSpaceMap),
    right: (0, $fjusW.allSpaceMap),
    rowGap: (0, $fjusW.positiveSpaceMap),
    top: (0, $fjusW.allSpaceMap),
    width: (0, $fjusW.dimensionMap),
    zIndex: (0, $fjusW.layerMap)
};
var $e6e4a731cfe135f2$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $e6e4a731cfe135f2$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $2zYm4.default)($7t0tI)) === 'object' && (0, $2zYm4.default)($7t0tI.env) === 'object' && false;
};
var $e6e4a731cfe135f2$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $e6e4a731cfe135f2$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $e6e4a731cfe135f2$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $2zYm4.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($e6e4a731cfe135f2$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $2zYm4.default)(value) === 'object' && $e6e4a731cfe135f2$var$safeSelectors.test(key)) {
            styleObj[key] = $e6e4a731cfe135f2$var$_transformStyles(value);
            return;
        }
        if ($e6e4a731cfe135f2$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($e6e4a731cfe135f2$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $e6e4a731cfe135f2$export$9a199fbafee0014e)) return;
        var tokenValue = $e6e4a731cfe135f2$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $e6e4a731cfe135f2$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $e6e4a731cfe135f2$var$_transformStyles(style);
    return (0, $f53LC.default)({}, $e6e4a731cfe135f2$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $e6e4a731cfe135f2$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $e6e4a731cfe135f2$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $e6e4a731cfe135f2$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $lFOXD.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$e6e4a731cfe135f2$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $e6e4a731cfe135f2$export$f6c783d06584602c(style) {
    return $e6e4a731cfe135f2$var$baseXcss(style);
}

});


parcelRegister("fRYjf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8da966d861f920b$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $nARcm = parcelRequire("nARcm");

var $1cz55 = parcelRequire("1cz55");

var $1dr2L = parcelRequire("1dr2L");

var $9Wbn5 = parcelRequire("9Wbn5");

var $hdXCn = parcelRequire("hdXCn");

var $gCX7a = parcelRequire("gCX7a");
var $3DGUN = parcelRequire("3DGUN");

var $8vj67 = parcelRequire("8vj67");

var $cE544 = parcelRequire("cE544");

var $7rTR9 = parcelRequire("7rTR9");

var $8tlza = parcelRequire("8tlza");

var $bZvNk = parcelRequire("bZvNk");

var $cJFOa = parcelRequire("cJFOa");

var $lv3b5 = parcelRequire("lv3b5");

var $jEOzw = parcelRequire("jEOzw");

var $akJ2l = parcelRequire("akJ2l");
function $b8da966d861f920b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b8da966d861f920b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b8da966d861f920b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b8da966d861f920b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b8da966d861f920b$var$tooltipZIndex = (0, $8tlza.layers).tooltip();
var $b8da966d861f920b$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "19.1.0"
};
// Inverts motion direction
var $b8da966d861f920b$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $b8da966d861f920b$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $b8da966d861f920b$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $jEOzw.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $1cz55.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $1cz55.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $nARcm.usePlatformLeafSyntheticEventHandler)($b8da966d861f920b$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $b8da966d861f920b$var$analyticsAttributes));
    var onHideHandler = (0, $nARcm.usePlatformLeafSyntheticEventHandler)($b8da966d861f920b$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $b8da966d861f920b$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $9Wbn5.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $9Wbn5.default)(onShowHandler);
    var onHideHandlerStable = (0, $9Wbn5.default)(onHideHandler);
    var delayStable = (0, $9Wbn5.default)(delay);
    var canAppearStable = (0, $9Wbn5.default)(canAppear);
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    var start = (0, $1oC0p.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $bZvNk.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $1oC0p.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $cJFOa.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $1dr2L.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $1cz55.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $akJ2l.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $akJ2l.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    (0, $hdXCn.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === 'mouse' && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $lv3b5.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $1oC0p.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children($b8da966d861f920b$var$_objectSpread($b8da966d861f920b$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $c9bqK.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7rTR9.default), {
        zIndex: $b8da966d861f920b$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cE544.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $b8da966d861f920b$var$invertedDirection[$b8da966d861f920b$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gCX7a.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3DGUN.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === 'show-immediate' ? 0 : (0, $8vj67.mediumDurationMs)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $b8da966d861f920b$var$_objectSpread($b8da966d861f920b$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$b8da966d861f920b$var$Tooltip.displayName = 'Tooltip';
var $b8da966d861f920b$export$2e2bcd8739ae039 = $b8da966d861f920b$var$Tooltip;

});
parcelRegister("nARcm", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $046ebd23398785e4$export$1a04351537078b55; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $fCluE = parcelRequire("fCluE");

var $avmEj = parcelRequire("avmEj");
function $046ebd23398785e4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $046ebd23398785e4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $046ebd23398785e4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $046ebd23398785e4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $046ebd23398785e4$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $fCluE.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $avmEj.useTrackedRef)(analyticsData);
    var fnRef = (0, $avmEj.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $046ebd23398785e4$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("fCluE", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $b5eb13c6ec6c9421$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $4RtuI = parcelRequire("4RtuI");

var $4YR4n = parcelRequire("4YR4n");
function $b5eb13c6ec6c9421$export$5bf35293e545f20c() {
    var analyticsContext = (0, $4YR4n.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $4RtuI.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("4RtuI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $38a2fd9dc051a7d7$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $7ZU0m = parcelRequire("7ZU0m");
function $38a2fd9dc051a7d7$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $38a2fd9dc051a7d7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $38a2fd9dc051a7d7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($38a2fd9dc051a7d7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $38a2fd9dc051a7d7$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $38a2fd9dc051a7d7$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $38a2fd9dc051a7d7$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $38a2fd9dc051a7d7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $38a2fd9dc051a7d7$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $38a2fd9dc051a7d7$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $7ZU0m.default));

});
parcelRegister("7ZU0m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0180ac11c25afb6c$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $0180ac11c25afb6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0180ac11c25afb6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0180ac11c25afb6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0180ac11c25afb6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0180ac11c25afb6c$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0180ac11c25afb6c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $0180ac11c25afb6c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $0180ac11c25afb6c$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $0180ac11c25afb6c$var$_objectSpread($0180ac11c25afb6c$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("4YR4n", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $3a05ee853953378b$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $3a05ee853953378b$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("avmEj", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $7a5e5e4f24850a47$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $7a5e5e4f24850a47$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("1cz55", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e021fcd64bd6415$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $0e021fcd64bd6415$export$2e2bcd8739ae039() {}

});

parcelRegister("1dr2L", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e2bfba1f0a7bff9$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $jl6GM = parcelRequire("jl6GM");
function $0e2bfba1f0a7bff9$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $jl6GM.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("jl6GM", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", function () { return $e1452ac5649c6c50$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $e1452ac5649c6c50$export$390330c10ff2b9a1 = 'ArrowUp';
var $e1452ac5649c6c50$export$a80636c6f41931fe = 'ArrowDown';
var $e1452ac5649c6c50$export$4af703091671bc = 'Home';
var $e1452ac5649c6c50$export$e2bc30913faa5db7 = 'End';
var $e1452ac5649c6c50$export$10f6869ed0a7d75b = 'Tab';
var $e1452ac5649c6c50$export$8152f929a25a0ff4 = 'Enter';
var $e1452ac5649c6c50$export$e51a3576c045c8d5 = 'Space';
var $e1452ac5649c6c50$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("9Wbn5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73c259f1b3660c1c$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $73c259f1b3660c1c$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)(value);
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("hdXCn", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $c8a1e573b8d80bff$export$469bb693f11edc7f; });

var $1oC0p = parcelRequire("1oC0p");

var $hPbfJ = parcelRequire("hPbfJ");
function $c8a1e573b8d80bff$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $1oC0p.useContext)((0, $hPbfJ.OpenLayerObserverContext));
    (0, $1oC0p.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}

});
parcelRegister("hPbfJ", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $cf9feda95c336b61$export$5fbf4d7fae6cdc00; });

var $1oC0p = parcelRequire("1oC0p");
var $cf9feda95c336b61$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});


parcelRegister("gCX7a", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", function () { return $c1ae0cdf408df17e$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $c1ae0cdf408df17e$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $h9NnU = parcelRequire("h9NnU");
var $c1ae0cdf408df17e$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $c1ae0cdf408df17e$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $1oC0p.createContext)($c1ae0cdf408df17e$export$d1e013d71d2e2121);
var $c1ae0cdf408df17e$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c1ae0cdf408df17e$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($c1ae0cdf408df17e$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $c1ae0cdf408df17e$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1oC0p.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $c1ae0cdf408df17e$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $c1ae0cdf408df17e$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $c1ae0cdf408df17e$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $c1ae0cdf408df17e$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $c1ae0cdf408df17e$var$ExitingPersistence = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $1oC0p.useState)([
        null,
        children
    ]), _useState2 = (0, $2qaZZ.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)([]), _useState4 = (0, $2qaZZ.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $1oC0p.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $h9NnU.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $2qaZZ.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $c1ae0cdf408df17e$export$7032ae6d9d98bedd(previousChildren);
    var current = $c1ae0cdf408df17e$export$7032ae6d9d98bedd(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $c1ae0cdf408df17e$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $c1ae0cdf408df17e$export$2ccbe4ff092af328(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $c1ae0cdf408df17e$export$e4c4c45693c3a7c(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $c1ae0cdf408df17e$export$e4c4c45693c3a7c(child, defaultContext);
    });
    return visibleChildren;
});
var $c1ae0cdf408df17e$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1oC0p.useContext)($c1ae0cdf408df17e$export$b9c4904d7a6929e6);
};
$c1ae0cdf408df17e$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $c1ae0cdf408df17e$export$2e2bcd8739ae039 = $c1ae0cdf408df17e$var$ExitingPersistence;

});
parcelRegister("h9NnU", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $c7d995ab0af417dc$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $c7d995ab0af417dc$export$f0f789643ba5a83c; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");
var $c7d995ab0af417dc$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $c7d995ab0af417dc$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$c7d995ab0af417dc$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $c7d995ab0af417dc$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $1oC0p.useState)($c7d995ab0af417dc$export$b7baf7667a68d87c), _useState2 = (0, $2qaZZ.default)(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        if (!$c7d995ab0af417dc$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dH1HR.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $c7d995ab0af417dc$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $c7d995ab0af417dc$export$ff7706047246b98b = function prefersReducedMotion() {
    return $c7d995ab0af417dc$export$f0f789643ba5a83c;
};

});


parcelRegister("3DGUN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2a664dab62019cf1$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $i4nkp = parcelRequire("i4nkp");

var $8vj67 = parcelRequire("8vj67");

var $6dyEs = parcelRequire("6dyEs");
function $2a664dab62019cf1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a664dab62019cf1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a664dab62019cf1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a664dab62019cf1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2a664dab62019cf1$var$directionMotions = {
    proportional: {
        bottom: 'translate3d(0, calc(5% + 4px), 0)',
        left: 'translate3d(calc(-5% - 4px), 0, 0)',
        right: 'translate3d(calc(5% + 4px), 0, 0)',
        top: 'translate3d(0, calc(-5% - 4px), 0)'
    },
    constant: {
        bottom: 'translate3d(0, 4px, 0)',
        left: 'translate3d(-4px, 0, 0)',
        right: 'translate3d(4px, 0, 0)',
        top: 'translate3d(0, -4px, 0)'
    }
};
var $2a664dab62019cf1$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $2a664dab62019cf1$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: $2a664dab62019cf1$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $2a664dab62019cf1$var$directionMotions[distance][direction]
        }),
        '50%': {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? 'none' : undefined
        }
    };
};
var $2a664dab62019cf1$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
        },
        to: $2a664dab62019cf1$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $2a664dab62019cf1$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $2a664dab62019cf1$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $8vj67.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $2a664dab62019cf1$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6dyEs.default), {
        duration: duration,
        enteringAnimation: $2a664dab62019cf1$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $2a664dab62019cf1$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $i4nkp.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $2a664dab62019cf1$export$2e2bcd8739ae039 = $2a664dab62019cf1$var$FadeIn;

});
parcelRegister("i4nkp", function(module, exports) {
$parcel$export(module.exports, "easeInOut", function () { return $d27ab23199c95aea$export$c07234257a03d5e9; });
var $d27ab23199c95aea$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $d27ab23199c95aea$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $d27ab23199c95aea$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

});

parcelRegister("8vj67", function(module, exports) {
$parcel$export(module.exports, "mediumDurationMs", function () { return $6310085d35bb98fc$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $6310085d35bb98fc$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $6310085d35bb98fc$export$368bacef0dacbe05 = 25;
var $6310085d35bb98fc$export$2023a81c8547415f = $6310085d35bb98fc$export$368bacef0dacbe05 * 4;
var $6310085d35bb98fc$export$6fa259be09e118a7 = $6310085d35bb98fc$export$368bacef0dacbe05 * 14;
var $6310085d35bb98fc$export$9424640c29bc466d = $6310085d35bb98fc$export$368bacef0dacbe05 * 28;

});

parcelRegister("6dyEs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $486ed6077402f4bd$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $h9NnU = parcelRequire("h9NnU");

var $8vj67 = parcelRequire("8vj67");

var $4QqIk = parcelRequire("4QqIk");

var $gCX7a = parcelRequire("gCX7a");

var $5FOBk = parcelRequire("5FOBk");
function $486ed6077402f4bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $486ed6077402f4bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $486ed6077402f4bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $486ed6077402f4bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $486ed6077402f4bd$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $486ed6077402f4bd$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $8vj67.largeDurationMs) : _ref$duration;
    var staggered = (0, $5FOBk.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $gCX7a.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $4QqIk.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $1oC0p.useState)(appear), _useState2 = (0, $2qaZZ.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === 'exiting') onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $486ed6077402f4bd$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($486ed6077402f4bd$var$_objectSpread($486ed6077402f4bd$var$_objectSpread({}, (0, $h9NnU.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $486ed6077402f4bd$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? 'forwards' : 'backwards',
                animationName: "".concat((0, $3dJ4i.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? 'paused' : 'running',
                animationTimingFunction: animationTimingFunction(state)
            })) : ''
        }, state);
    });
};
var $486ed6077402f4bd$export$2e2bcd8739ae039 = $486ed6077402f4bd$var$EnteringMotion;

});
parcelRegister("4QqIk", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", function () { return $3870bd95fc690793$export$4f34107a2b00f39c; });

var $1oC0p = parcelRequire("1oC0p");
var $3870bd95fc690793$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $3870bd95fc690793$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3870bd95fc690793$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $3870bd95fc690793$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3870bd95fc690793$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("5FOBk", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", function () { return $4218086bf3ac815e$export$25c7213fc07ec080; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $m1Ak9 = parcelRequire("m1Ak9");

var $esf7C = parcelRequire("esf7C");

var $fQe0f = parcelRequire("fQe0f");
var $4218086bf3ac815e$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $m1Ak9.default)
    };
});
var $4218086bf3ac815e$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $fQe0f.useUniqueId)();
    var context = (0, $1oC0p.useContext)($4218086bf3ac815e$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $4218086bf3ac815e$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1oC0p.useRef)([]);
    var indexes = [];
    var _useState = (0, $1oC0p.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $2qaZZ.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $esf7C.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($4218086bf3ac815e$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $4218086bf3ac815e$export$2e2bcd8739ae039 = $4218086bf3ac815e$var$StaggeredEntrance;

});
parcelRegister("m1Ak9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $042348e92a41fce8$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $042348e92a41fce8$export$2e2bcd8739ae039() {}

});

parcelRegister("esf7C", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $a85f691b4aa84a1d$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $a85f691b4aa84a1d$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("fQe0f", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", function () { return $b886930abe67c784$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1oC0p = parcelRequire("1oC0p");
function $b886930abe67c784$export$c485849f2e393253() {
    var identifier = (0, $1oC0p.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("cE544", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $934d26373c455d11$export$badac9ada3a0bdf9; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $eVddu = parcelRequire("eVddu");

var $bZ049 = parcelRequire("bZ049");

// Export types from PopperJS / React Popper
var $934d26373c455d11$var$viewportPadding = 5;
var $934d26373c455d11$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $934d26373c455d11$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $934d26373c455d11$var$defaultChildrenFn() {
    return null;
}
var $934d26373c455d11$var$defaultOffset = [
    0,
    8
];
function $934d26373c455d11$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $934d26373c455d11$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $934d26373c455d11$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, $2qaZZ.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $934d26373c455d11$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $bZ049.getMaxSizeModifiers)({
            viewportPadding: $934d26373c455d11$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($934d26373c455d11$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $lFOXD.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $lFOXD.default)(internalModifiers), (0, $lFOXD.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eVddu.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("bZ049", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $8b9571529d064d66$export$6d8c2b45c99d6e3f; });

var $2qaZZ = parcelRequire("2qaZZ");
function $8b9571529d064d66$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $2qaZZ.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("7rTR9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $56c661e7dc4697cd$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $aGW8j = parcelRequire("aGW8j");

var $fV6u8 = parcelRequire("fV6u8");

var $jMmvn = parcelRequire("jMmvn");

var $cl0MR = parcelRequire("cl0MR");

var $5PBAm = parcelRequire("5PBAm");
function $56c661e7dc4697cd$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $cl0MR.default)(mountStrategy);
    (0, $5PBAm.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $aGW8j.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fV6u8.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jMmvn.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("aGW8j", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $7c8aeba89b35592e$export$b40ec24ac8275656; });

var $7stVI = parcelRequire("7stVI");
function $7c8aeba89b35592e$export$ba05d765b8392e5e(flagResolver) {
    (0, $7stVI.setBooleanResolver)(flagResolver);
}
function $7c8aeba89b35592e$export$470e5c2be1411c89(name) {
    return (0, $7stVI.resolveBooleanFlag)(name);
}
function $7c8aeba89b35592e$export$b40ec24ac8275656(name) {
    return (0, $7stVI.resolveBooleanFlag)(name);
}

});
parcelRegister("7stVI", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $56e25d62f7ef7ba7$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $56e25d62f7ef7ba7$export$6333b6aff9fc6275; });

var $e06lR = parcelRequire("e06lR");

var $7t0tI = parcelRequire("7t0tI");
var $56e25d62f7ef7ba7$var$pkgName = '@atlaskit/platform-feature-flags';
var $56e25d62f7ef7ba7$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $56e25d62f7ef7ba7$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $56e25d62f7ef7ba7$var$ENV_ENABLE_PLATFORM_FF = $56e25d62f7ef7ba7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $56e25d62f7ef7ba7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $56e25d62f7ef7ba7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $56e25d62f7ef7ba7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $56e25d62f7ef7ba7$var$ENV_ENABLE_PLATFORM_FF || $56e25d62f7ef7ba7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $56e25d62f7ef7ba7$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $56e25d62f7ef7ba7$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$56e25d62f7ef7ba7$var$globalVar[$56e25d62f7ef7ba7$export$7e41b1b2bdee3f98] = $56e25d62f7ef7ba7$var$globalVar[$56e25d62f7ef7ba7$export$7e41b1b2bdee3f98] || $56e25d62f7ef7ba7$var$DEFAULT_PFF_GLOBAL;
function $56e25d62f7ef7ba7$export$f2b591175b3e424c(resolver) {
    $56e25d62f7ef7ba7$var$globalVar[$56e25d62f7ef7ba7$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $56e25d62f7ef7ba7$export$6333b6aff9fc6275(flagKey) {
    if ($56e25d62f7ef7ba7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $e06lR.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $56e25d62f7ef7ba7$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $56e25d62f7ef7ba7$var$globalVar[$56e25d62f7ef7ba7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("e06lR", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $a315fe0ea8d00ddc$export$1c9f709888824e05; });
var $a315fe0ea8d00ddc$var$_ref, $a315fe0ea8d00ddc$var$_process, $a315fe0ea8d00ddc$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a315fe0ea8d00ddc$var$TESTS_MODE = ($a315fe0ea8d00ddc$var$_ref = (globalThis === null || globalThis === void 0 || ($a315fe0ea8d00ddc$var$_process = globalThis.process) === null || $a315fe0ea8d00ddc$var$_process === void 0 || ($a315fe0ea8d00ddc$var$_process = $a315fe0ea8d00ddc$var$_process.env) === null || $a315fe0ea8d00ddc$var$_process === void 0 ? void 0 : $a315fe0ea8d00ddc$var$_process.JEST_WORKER_ID) !== undefined, $a315fe0ea8d00ddc$var$_ref !== void 0) ? $a315fe0ea8d00ddc$var$_ref : false;
var $a315fe0ea8d00ddc$var$DEBUG_MODE = !$a315fe0ea8d00ddc$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a315fe0ea8d00ddc$var$_process2 = globalThis.process) === null || $a315fe0ea8d00ddc$var$_process2 === void 0 || ($a315fe0ea8d00ddc$var$_process2 = $a315fe0ea8d00ddc$var$_process2.env) === null || $a315fe0ea8d00ddc$var$_process2 === void 0 ? void 0 : $a315fe0ea8d00ddc$var$_process2.NODE_ENV) !== 'production';
var $a315fe0ea8d00ddc$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a315fe0ea8d00ddc$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("fV6u8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b97135b29e6707ac$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $aC6cN = parcelRequire("aC6cN");
function $b97135b29e6707ac$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $1oC0p.useMemo)(function() {
        return (0, $aC6cN.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $aC6cN.appendPortalContainerIfNotAppended)(container);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            (0, $aC6cN.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(children, container);
}

});
parcelRegister("aC6cN", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $7ba2443d36397f64$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $7ba2443d36397f64$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $7ba2443d36397f64$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $7ba2443d36397f64$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $7ba2443d36397f64$export$95029ca7aca2989e; });

var $dPV4P = parcelRequire("dPV4P");
var $7ba2443d36397f64$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $dPV4P.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $7ba2443d36397f64$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $7ba2443d36397f64$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $dPV4P.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $dPV4P.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $7ba2443d36397f64$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $7ba2443d36397f64$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $7ba2443d36397f64$var$getPortalParent().removeChild(container);
};
var $7ba2443d36397f64$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $7ba2443d36397f64$var$getPortalParent().appendChild(container);
};
var $7ba2443d36397f64$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $7ba2443d36397f64$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($7ba2443d36397f64$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $dPV4P.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $7ba2443d36397f64$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($7ba2443d36397f64$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $dPV4P.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $dPV4P.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $7ba2443d36397f64$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("dPV4P", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", function () { return $a12c5011873f021b$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $a12c5011873f021b$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $a12c5011873f021b$export$13f57c02915787b3; });
var $a12c5011873f021b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $a12c5011873f021b$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $a12c5011873f021b$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("jMmvn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e663f50f530b7600$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $aGW8j = parcelRequire("aGW8j");

var $bbFLx = parcelRequire("bbFLx");

var $aC6cN = parcelRequire("aC6cN");
function $e663f50f530b7600$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $bbFLx.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $aC6cN.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $aC6cN.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $aGW8j.fg)('platform_design_system_suspend_portal_children') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $gUjjH.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("bbFLx", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $82511e9eababeeb9$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $82511e9eababeeb9$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);

});


parcelRegister("cl0MR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8fb80e83cb874697$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $bbFLx = parcelRequire("bbFLx");
var $8fb80e83cb874697$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $bbFLx.useIsomorphicLayoutEffect) : (0, $1oC0p.useEffect);
    }), _useState4 = (0, $2qaZZ.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $8fb80e83cb874697$export$2e2bcd8739ae039 = $8fb80e83cb874697$var$useIsSubsequentRender;

});

parcelRegister("5PBAm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $43eededa8e52b3af$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $7Vn3L = parcelRequire("7Vn3L");

var $iY4w8 = parcelRequire("iY4w8");
var $43eededa8e52b3af$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1oC0p.useEffect)(function() {
        (0, $iY4w8.default)((0, $7Vn3L.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $iY4w8.default)((0, $7Vn3L.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $43eededa8e52b3af$export$2e2bcd8739ae039 = $43eededa8e52b3af$var$useFirePortalEvent;

});
parcelRegister("7Vn3L", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $5c4fbe70684ff173$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $5c4fbe70684ff173$export$80816bd900e5bd00; });
var $5c4fbe70684ff173$export$ed5835cc67e87f72 = 'akPortalMount';
var $5c4fbe70684ff173$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("iY4w8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dcf155a0b004a942$export$2e2bcd8739ae039; });
var $dcf155a0b004a942$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $dcf155a0b004a942$var$getLayerName = function getLayerName(zIndex) {
    return $dcf155a0b004a942$var$zIndexToName.hasOwnProperty(zIndex) ? $dcf155a0b004a942$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $dcf155a0b004a942$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $dcf155a0b004a942$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $dcf155a0b004a942$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $dcf155a0b004a942$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("8tlza", function(module, exports) {
$parcel$export(module.exports, "layers", function () { return $62b1c2c94617225f$export$7be255094ccdc533; });

var $koO3Y = parcelRequire("koO3Y");

var $ds96g = parcelRequire("ds96g");
var $62b1c2c94617225f$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $62b1c2c94617225f$export$c93026a968943f95 = 'light';
var $62b1c2c94617225f$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $62b1c2c94617225f$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $62b1c2c94617225f$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $62b1c2c94617225f$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $62b1c2c94617225f$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $62b1c2c94617225f$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $62b1c2c94617225f$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $62b1c2c94617225f$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $ds96g.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $62b1c2c94617225f$export$6d8204c2cb2e06b8() / 4;
    (0, $koO3Y.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $62b1c2c94617225f$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $62b1c2c94617225f$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $62b1c2c94617225f$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $koO3Y.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $62b1c2c94617225f$export$ba1d834b86d72a09 = $62b1c2c94617225f$export$a1b3edb637fb4f35;
var $62b1c2c94617225f$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $ds96g.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $ds96g.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $ds96g.N30A), ")")
            }
        }
    };
};

});
parcelRegister("koO3Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ed9ce203ef433e32$export$2e2bcd8739ae039; });

var $6FIvK = parcelRequire("6FIvK");

var $7t0tI = parcelRequire("7t0tI");
function $ed9ce203ef433e32$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $6FIvK.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $ed9ce203ef433e32$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("6FIvK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4db91960ad9f4ca3$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $4db91960ad9f4ca3$var$printed = {};
function $4db91960ad9f4ca3$export$2e2bcd8739ae039(message) {
    if ($4db91960ad9f4ca3$var$printed[message]) return;
    $4db91960ad9f4ca3$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("ds96g", function(module, exports) {
$parcel$export(module.exports, "B200", function () { return $9cb4f2f8c9a4311b$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $9cb4f2f8c9a4311b$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $9cb4f2f8c9a4311b$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $9cb4f2f8c9a4311b$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $9cb4f2f8c9a4311b$export$920c0d5c49070351; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $9cb4f2f8c9a4311b$export$4b84fd0e2c617bd = '#FFEBE6';
var $9cb4f2f8c9a4311b$export$b34b069eff244586 = '#FFBDAD';
var $9cb4f2f8c9a4311b$export$be802dd0d8b57f35 = '#FF8F73';
var $9cb4f2f8c9a4311b$export$60847d42f9da92a6 = '#FF7452';
var $9cb4f2f8c9a4311b$export$4a7404f376229999 = '#FF5630';
var $9cb4f2f8c9a4311b$export$2010d0fb4295b346 = '#DE350B';
var $9cb4f2f8c9a4311b$export$2837b5a1a71d5c02 = '#BF2600';
var $9cb4f2f8c9a4311b$export$8d9596b529bbb9cf = '#FFFAE6';
var $9cb4f2f8c9a4311b$export$41060a744ab0b7ae = '#FFF0B3';
var $9cb4f2f8c9a4311b$export$1cc05bbbf340e559 = '#FFE380';
var $9cb4f2f8c9a4311b$export$5aae31392d72caaa = '#FFC400';
var $9cb4f2f8c9a4311b$export$c6930421db9fa514 = '#FFAB00';
var $9cb4f2f8c9a4311b$export$59619663aa6500fb = '#FF991F';
var $9cb4f2f8c9a4311b$export$874739ea9e379ab6 = '#FF8B00';
var $9cb4f2f8c9a4311b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $9cb4f2f8c9a4311b$export$69a3bf21b9686c2b = '#ABF5D1';
var $9cb4f2f8c9a4311b$export$afbce1382ec95f73 = '#79F2C0';
var $9cb4f2f8c9a4311b$export$747d86715d4175de = '#57D9A3';
var $9cb4f2f8c9a4311b$export$940e1f69e873f202 = '#36B37E';
var $9cb4f2f8c9a4311b$export$a49394138f7b8e85 = '#00875A';
var $9cb4f2f8c9a4311b$export$6fa04827ac68a4fb = '#006644';
var $9cb4f2f8c9a4311b$export$226de0355ed012f8 = '#DEEBFF';
var $9cb4f2f8c9a4311b$export$8c13c2ee36917869 = '#B3D4FF';
var $9cb4f2f8c9a4311b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $9cb4f2f8c9a4311b$export$215b7063051591f1 = '#2684FF';
var $9cb4f2f8c9a4311b$export$e62e8919cca44969 = '#0065FF';
var $9cb4f2f8c9a4311b$export$b3de0ae08da2ce64 = '#0052CC';
var $9cb4f2f8c9a4311b$export$a6ee3d71bc067634 = '#0747A6';
var $9cb4f2f8c9a4311b$export$67f15409e87642a1 = '#669DF1';
var $9cb4f2f8c9a4311b$export$f0539dbc42dbb067 = '#8FB8F6';
var $9cb4f2f8c9a4311b$export$363e4475840015bb = '#EAE6FF';
var $9cb4f2f8c9a4311b$export$4b0a4417ed59760f = '#C0B6F2';
var $9cb4f2f8c9a4311b$export$6011520a64d9a187 = '#998DD9';
var $9cb4f2f8c9a4311b$export$a7175d4e9206bc80 = '#8777D9';
var $9cb4f2f8c9a4311b$export$b48405b95304b5a1 = '#6554C0';
var $9cb4f2f8c9a4311b$export$c71e4279dd54a18d = '#5243AA';
var $9cb4f2f8c9a4311b$export$147899de772240ec = '#403294';
var $9cb4f2f8c9a4311b$export$2cf711fe14c66f06 = '#E6FCFF';
var $9cb4f2f8c9a4311b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $9cb4f2f8c9a4311b$export$776c9c497ef08533 = '#79E2F2';
var $9cb4f2f8c9a4311b$export$69cb3ca10c1e330e = '#00C7E6';
var $9cb4f2f8c9a4311b$export$9dc1ef0f3f48059b = '#00B8D9';
var $9cb4f2f8c9a4311b$export$7c835c78b6fcdef8 = '#00A3BF';
var $9cb4f2f8c9a4311b$export$6036577f95c3877e = '#008DA6';
var $9cb4f2f8c9a4311b$export$29a4f05edc054374 = '#FFFFFF';
var $9cb4f2f8c9a4311b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $9cb4f2f8c9a4311b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $9cb4f2f8c9a4311b$export$3e51e8f1440314ba = '#EBECF0';
var $9cb4f2f8c9a4311b$export$1ce2d1575d444ceb = '#DFE1E6';
var $9cb4f2f8c9a4311b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $9cb4f2f8c9a4311b$export$c2e91cbeada39b8b = '#B3BAC5';
var $9cb4f2f8c9a4311b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $9cb4f2f8c9a4311b$export$eaa8c8a70ac22806 = '#97A0AF';
var $9cb4f2f8c9a4311b$export$7c87d337fb91a97d = '#8993A4';
var $9cb4f2f8c9a4311b$export$d6447c357493214f = '#7A869A';
var $9cb4f2f8c9a4311b$export$f563ee71e9ee74cd = '#6B778C';
var $9cb4f2f8c9a4311b$export$e2ef2124cf4024b1 = '#5E6C84';
var $9cb4f2f8c9a4311b$export$eece5f492e429f08 = '#505F79';
var $9cb4f2f8c9a4311b$export$c39c0fe0f26207ae = '#42526E';
var $9cb4f2f8c9a4311b$export$7090862dc3038a9f = '#344563';
var $9cb4f2f8c9a4311b$export$ad0bacf983b7ddaa = '#253858';
var $9cb4f2f8c9a4311b$export$7d61b15e0da132af = '#172B4D';
var $9cb4f2f8c9a4311b$export$fbda843f0a27fe96 = '#091E42';
var $9cb4f2f8c9a4311b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $9cb4f2f8c9a4311b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $9cb4f2f8c9a4311b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $9cb4f2f8c9a4311b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $9cb4f2f8c9a4311b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $9cb4f2f8c9a4311b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $9cb4f2f8c9a4311b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $9cb4f2f8c9a4311b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $9cb4f2f8c9a4311b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $9cb4f2f8c9a4311b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $9cb4f2f8c9a4311b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $9cb4f2f8c9a4311b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $9cb4f2f8c9a4311b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $9cb4f2f8c9a4311b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $9cb4f2f8c9a4311b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $9cb4f2f8c9a4311b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $9cb4f2f8c9a4311b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $9cb4f2f8c9a4311b$export$2f6319cf7d736c2a = '#E6EDFA';
var $9cb4f2f8c9a4311b$export$95126bc8884d6634 = '#DCE5F5';
var $9cb4f2f8c9a4311b$export$8338d8c35d44ff1 = '#CED9EB';
var $9cb4f2f8c9a4311b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $9cb4f2f8c9a4311b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $9cb4f2f8c9a4311b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $9cb4f2f8c9a4311b$export$97e81faa16a182c7 = '#8C9CB8';
var $9cb4f2f8c9a4311b$export$bfe21c59123ecf33 = '#7988A3';
var $9cb4f2f8c9a4311b$export$ee82aa2ea6a1558 = '#67758F';
var $9cb4f2f8c9a4311b$export$682927c6ed76be02 = '#56637A';
var $9cb4f2f8c9a4311b$export$91fd9994c5be9757 = '#455166';
var $9cb4f2f8c9a4311b$export$d281fbfe3cff2df6 = '#3B475C';
var $9cb4f2f8c9a4311b$export$3902c91d8b98a753 = '#313D52';
var $9cb4f2f8c9a4311b$export$8e8133c1ba5845b5 = '#283447';
var $9cb4f2f8c9a4311b$export$33ff357f6620b39 = '#202B3D';
var $9cb4f2f8c9a4311b$export$633847cf062b69e0 = '#1B2638';
var $9cb4f2f8c9a4311b$export$9776a6e503bdbf76 = '#121A29';
var $9cb4f2f8c9a4311b$export$6c813d5160dff5db = '#0E1624';
var $9cb4f2f8c9a4311b$export$3d4f271a500072a = '#0D1424';
var $9cb4f2f8c9a4311b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $9cb4f2f8c9a4311b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $9cb4f2f8c9a4311b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $9cb4f2f8c9a4311b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $9cb4f2f8c9a4311b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $9cb4f2f8c9a4311b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $9cb4f2f8c9a4311b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $9cb4f2f8c9a4311b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $9cb4f2f8c9a4311b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $9cb4f2f8c9a4311b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $9cb4f2f8c9a4311b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $9cb4f2f8c9a4311b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $9cb4f2f8c9a4311b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $9cb4f2f8c9a4311b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $9cb4f2f8c9a4311b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $9cb4f2f8c9a4311b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $9cb4f2f8c9a4311b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $9cb4f2f8c9a4311b$export$d2adc5dedf09fced = '#292A2E';
var $9cb4f2f8c9a4311b$export$f51762073d2bb381 = '#94C748';
var $9cb4f2f8c9a4311b$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("bZvNk", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $8bae0df175e6fd60$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $8bae0df175e6fd60$var$registrations = new Set();
var $8bae0df175e6fd60$var$cleanupEndEventListeners = null;
function $8bae0df175e6fd60$var$onDragStart() {
    if ($8bae0df175e6fd60$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $8bae0df175e6fd60$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $8bae0df175e6fd60$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $8bae0df175e6fd60$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $8bae0df175e6fd60$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($8bae0df175e6fd60$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $8bae0df175e6fd60$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $8bae0df175e6fd60$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $8bae0df175e6fd60$var$cleanupEndEventListeners = null;
    var clone = Array.from($8bae0df175e6fd60$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $8bae0df175e6fd60$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $8bae0df175e6fd60$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $8bae0df175e6fd60$var$onDragStart
        }
    ]);
}
var $8bae0df175e6fd60$var$cleanupStartEventListeners = null;
function $8bae0df175e6fd60$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$8bae0df175e6fd60$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $8bae0df175e6fd60$var$cleanupStartEventListeners = $8bae0df175e6fd60$var$bindStartEvents();
    $8bae0df175e6fd60$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $8bae0df175e6fd60$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $8bae0df175e6fd60$var$registrations.delete(registration);
        if ($8bae0df175e6fd60$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $8bae0df175e6fd60$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $8bae0df175e6fd60$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("cJFOa", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $945a1e4099c8a93e$export$57bf213be019eeb0; });

var $gd7cl = parcelRequire("gd7cl");
// This file is a singleton for managing tooltips
var $945a1e4099c8a93e$var$active = null;
function $945a1e4099c8a93e$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($945a1e4099c8a93e$var$active && $945a1e4099c8a93e$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $gd7cl.clearScheduled)();
            $945a1e4099c8a93e$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $gd7cl.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $gd7cl.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $gd7cl.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($945a1e4099c8a93e$var$active && $945a1e4099c8a93e$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($945a1e4099c8a93e$var$active) {
            (0, $gd7cl.clearScheduled)();
            $945a1e4099c8a93e$var$active.entry.hide({
                isImmediate: true
            });
            $945a1e4099c8a93e$var$active.entry.done();
            $945a1e4099c8a93e$var$active = null;
        }
        // this tooltip is now the active tooltip
        $945a1e4099c8a93e$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $gd7cl.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("gd7cl", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", function () { return $bcd371a4e64be2d1$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $bcd371a4e64be2d1$export$5f4d6617421d489b; });
var $bcd371a4e64be2d1$var$delayId = null;
function $bcd371a4e64be2d1$export$eaf678f6f93f5250() {
    if ($bcd371a4e64be2d1$var$delayId != null) {
        window.clearTimeout($bcd371a4e64be2d1$var$delayId);
        $bcd371a4e64be2d1$var$delayId = null;
    }
}
function $bcd371a4e64be2d1$export$5f4d6617421d489b(fn, delay) {
    $bcd371a4e64be2d1$export$eaf678f6f93f5250();
    $bcd371a4e64be2d1$var$delayId = window.setTimeout(function() {
        $bcd371a4e64be2d1$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("lv3b5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fa6ef54a52a3e41b$export$2e2bcd8739ae039; });

var $kgNrN = parcelRequire("kgNrN");
function $fa6ef54a52a3e41b$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $kgNrN.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("kgNrN", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", function () { return $ec1ba875585b9d52$export$6ee17796e3d70de2; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $jDAXe = parcelRequire("jDAXe");
var $ec1ba875585b9d52$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $ec1ba875585b9d52$var$react18UseId = ($ec1ba875585b9d52$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $ec1ba875585b9d52$var$_React$useId !== void 0 ? $ec1ba875585b9d52$var$_React$useId : undefined;
function $ec1ba875585b9d52$export$f680877a34711e37() {
    if ($ec1ba875585b9d52$var$react18UseId && (0, $jDAXe.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $ec1ba875585b9d52$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $6JmtO.useUID)());
}
var $ec1ba875585b9d52$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($ec1ba875585b9d52$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $ec1ba875585b9d52$export$6ee17796e3d70de2() {
    if ($ec1ba875585b9d52$var$react18UseId && (0, $jDAXe.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $ec1ba875585b9d52$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $6JmtO.useUIDSeed)();
}

});
parcelRegister("jDAXe", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $e4be533559cb5c76$export$b40ec24ac8275656; });

var $Vamwe = parcelRequire("Vamwe");
function $e4be533559cb5c76$export$ba05d765b8392e5e(flagResolver) {
    (0, $Vamwe.setBooleanResolver)(flagResolver);
}
function $e4be533559cb5c76$export$470e5c2be1411c89(name) {
    return (0, $Vamwe.resolveBooleanFlag)(name);
}
function $e4be533559cb5c76$export$b40ec24ac8275656(name) {
    return (0, $Vamwe.resolveBooleanFlag)(name);
}

});
parcelRegister("Vamwe", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $0abd5cb45aaf1bfd$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $0abd5cb45aaf1bfd$export$6333b6aff9fc6275; });

var $jTMJ0 = parcelRequire("jTMJ0");

var $7t0tI = parcelRequire("7t0tI");
var $0abd5cb45aaf1bfd$var$pkgName = '@atlaskit/platform-feature-flags';
var $0abd5cb45aaf1bfd$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $0abd5cb45aaf1bfd$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $0abd5cb45aaf1bfd$var$ENV_ENABLE_PLATFORM_FF = $0abd5cb45aaf1bfd$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $0abd5cb45aaf1bfd$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $0abd5cb45aaf1bfd$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $0abd5cb45aaf1bfd$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $0abd5cb45aaf1bfd$var$ENV_ENABLE_PLATFORM_FF || $0abd5cb45aaf1bfd$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $0abd5cb45aaf1bfd$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $0abd5cb45aaf1bfd$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$0abd5cb45aaf1bfd$var$globalVar[$0abd5cb45aaf1bfd$export$7e41b1b2bdee3f98] = $0abd5cb45aaf1bfd$var$globalVar[$0abd5cb45aaf1bfd$export$7e41b1b2bdee3f98] || $0abd5cb45aaf1bfd$var$DEFAULT_PFF_GLOBAL;
function $0abd5cb45aaf1bfd$export$f2b591175b3e424c(resolver) {
    $0abd5cb45aaf1bfd$var$globalVar[$0abd5cb45aaf1bfd$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $0abd5cb45aaf1bfd$export$6333b6aff9fc6275(flagKey) {
    if ($0abd5cb45aaf1bfd$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $jTMJ0.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $0abd5cb45aaf1bfd$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $0abd5cb45aaf1bfd$var$globalVar[$0abd5cb45aaf1bfd$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("jTMJ0", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $e7c8f325f2bef225$export$1c9f709888824e05; });
var $e7c8f325f2bef225$var$_ref, $e7c8f325f2bef225$var$_process, $e7c8f325f2bef225$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $e7c8f325f2bef225$var$TESTS_MODE = ($e7c8f325f2bef225$var$_ref = (globalThis === null || globalThis === void 0 || ($e7c8f325f2bef225$var$_process = globalThis.process) === null || $e7c8f325f2bef225$var$_process === void 0 || ($e7c8f325f2bef225$var$_process = $e7c8f325f2bef225$var$_process.env) === null || $e7c8f325f2bef225$var$_process === void 0 ? void 0 : $e7c8f325f2bef225$var$_process.JEST_WORKER_ID) !== undefined, $e7c8f325f2bef225$var$_ref !== void 0) ? $e7c8f325f2bef225$var$_ref : false;
var $e7c8f325f2bef225$var$DEBUG_MODE = !$e7c8f325f2bef225$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($e7c8f325f2bef225$var$_process2 = globalThis.process) === null || $e7c8f325f2bef225$var$_process2 === void 0 || ($e7c8f325f2bef225$var$_process2 = $e7c8f325f2bef225$var$_process2.env) === null || $e7c8f325f2bef225$var$_process2 === void 0 ? void 0 : $e7c8f325f2bef225$var$_process2.NODE_ENV) !== 'production';
var $e7c8f325f2bef225$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$e7c8f325f2bef225$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});





parcelRegister("jEOzw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e4f8fb4bb1ffb106$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $e5Do8 = parcelRequire("e5Do8");
var $14TL2 = parcelRequire("14TL2");

var $ds96g = parcelRequire("ds96g");

var $5I6Jm = parcelRequire("5I6Jm");
function $e4f8fb4bb1ffb106$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e4f8fb4bb1ffb106$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e4f8fb4bb1ffb106$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e4f8fb4bb1ffb106$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e4f8fb4bb1ffb106$var$baseStyles = null;
var $e4f8fb4bb1ffb106$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $e4f8fb4bb1ffb106$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement((0, $5I6Jm.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $e5Do8.default)([
            "_1yt4nmcz _2rko1sit _11c8qk37 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $e4f8fb4bb1ffb106$var$_objectSpread($e4f8fb4bb1ffb106$var$_objectSpread({}, style), {}, {
            "--_a5vo3x": (0, $14TL2.default)("var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)")),
            "--_yr7xfv": (0, $14TL2.default)("var(--ds-background-neutral-bold, ".concat((0, $ds96g.N800), ")")),
            "--_ywovvi": (0, $14TL2.default)("var(--ds-text-inverse, ".concat((0, $ds96g.N0), ")"))
        })
    }, children);
});
$e4f8fb4bb1ffb106$var$TooltipContainer.displayName = 'TooltipContainer';
var $e4f8fb4bb1ffb106$export$2e2bcd8739ae039 = $e4f8fb4bb1ffb106$var$TooltipContainer;

});
parcelRegister("e5Do8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a420160478789140$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a420160478789140$var$ATOMIC_GROUP_LENGTH = 5;
function $a420160478789140$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $a420160478789140$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("14TL2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0c916a7755ebb0db$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $0c916a7755ebb0db$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("5I6Jm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $428648621ea18aac$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $8tlza = parcelRequire("8tlza");
function $428648621ea18aac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $428648621ea18aac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $428648621ea18aac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $428648621ea18aac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $428648621ea18aac$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $428648621ea18aac$var$primitiveStyles = (0, $3dJ4i.css)({
    zindex: "var(".concat($428648621ea18aac$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $428648621ea18aac$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $428648621ea18aac$var$_objectSpread($428648621ea18aac$var$_objectSpread({}, style), {}, (0, $f53LC.default)({}, $428648621ea18aac$var$VAR_PRIMITIVE_ZINDEX, (0, $8tlza.layers).tooltip()));
    return (0, $3dJ4i.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $3dJ4i.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $428648621ea18aac$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$428648621ea18aac$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $428648621ea18aac$export$2e2bcd8739ae039 = $428648621ea18aac$var$TooltipPrimitive;

});


parcelRegister("akJ2l", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", function () { return $785eb503a9d66766$export$642213d516a9b928; });
function $785eb503a9d66766$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("i8JRV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d34c8df176751622$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $FapDU = parcelRequire("FapDU");

var $kSarE = parcelRequire("kSarE");

var $cxEFW = parcelRequire("cxEFW");

var $4Q7px = parcelRequire("4Q7px");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $d34c8df176751622$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var isCircle = shape === 'circle';
    var baseProps = (0, $4Q7px.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kSarE.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cxEFW.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $FapDU.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return baseProps;
};
var $d34c8df176751622$export$2e2bcd8739ae039 = $d34c8df176751622$var$useIconButton;

});
parcelRegister("kSarE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f320f3f08df16125$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $4CAS9 = parcelRequire("4CAS9");
var $jP2pL = parcelRequire("jP2pL");
var $f320f3f08df16125$var$textStyles = (0, $jP2pL.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $f320f3f08df16125$var$iconStyles = (0, $jP2pL.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: 'none'
});
var $f320f3f08df16125$var$commonStyles = (0, $jP2pL.xcss)({
    transition: 'opacity 0.3s'
});
var $f320f3f08df16125$var$fadeStyles = (0, $jP2pL.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $f320f3f08df16125$var$beforeIconStyles = (0, $jP2pL.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
});
var $f320f3f08df16125$var$afterIconStyles = (0, $jP2pL.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $f320f3f08df16125$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4CAS9.default), {
        as: "span",
        xcss: [
            $f320f3f08df16125$var$commonStyles
        ].concat((0, $lFOXD.default)(type === 'text' ? [
            $f320f3f08df16125$var$textStyles
        ] : [
            $f320f3f08df16125$var$iconStyles
        ]), (0, $lFOXD.default)(isLoading ? [
            $f320f3f08df16125$var$fadeStyles
        ] : []), (0, $lFOXD.default)(position === 'before' ? [
            $f320f3f08df16125$var$beforeIconStyles
        ] : []), (0, $lFOXD.default)(position === 'after' ? [
            $f320f3f08df16125$var$afterIconStyles
        ] : []))
    }, children);
};
var $f320f3f08df16125$export$2e2bcd8739ae039 = $f320f3f08df16125$var$Content;

});
parcelRegister("4CAS9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $35d7502127e95c41$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $2UAHe = parcelRequire("2UAHe");

var $fjusW = parcelRequire("fjusW");

var $jP2pL = parcelRequire("jP2pL");
var $35d7502127e95c41$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $35d7502127e95c41$var$_excluded2 = [
    "className"
];
var $35d7502127e95c41$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $35d7502127e95c41$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $35d7502127e95c41$var$_excluded2);
    var resolvedStyles = (0, $jP2pL.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $35d7502127e95c41$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $fjusW.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fjusW.isSurfaceColorToken)(backgroundColor) && (0, $fjusW.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $fjusW.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $fjusW.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $fjusW.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $fjusW.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $fjusW.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $fjusW.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $fjusW.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $2UAHe.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $35d7502127e95c41$export$2e2bcd8739ae039 = $35d7502127e95c41$export$e71c4d32a2263218;
var $35d7502127e95c41$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("2UAHe", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $21ed46d8d58cebd4$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $21ed46d8d58cebd4$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $21ed46d8d58cebd4$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($21ed46d8d58cebd4$export$1ca2a26fecb070ae);
};
$21ed46d8d58cebd4$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("cxEFW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92181e62ed5bb59a$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $92181e62ed5bb59a$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $92181e62ed5bb59a$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, $92181e62ed5bb59a$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $92181e62ed5bb59a$export$2e2bcd8739ae039 = $92181e62ed5bb59a$var$IconRenderer;

});

parcelRegister("4Q7px", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3861c461d67a3194$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $8ZwYS = parcelRequire("8ZwYS");

var $1T8FE = parcelRequire("1T8FE");

var $8wO2B = parcelRequire("8wO2B");

var $71iyP = parcelRequire("71iyP");

var $4CAS9 = parcelRequire("4CAS9");
var $jP2pL = parcelRequire("jP2pL");

var $aABA1 = parcelRequire("aABA1");

var $FapDU = parcelRequire("FapDU");

var $dggek = parcelRequire("dggek");

var $jeWB2 = parcelRequire("jeWB2");

var $4VjSQ = parcelRequire("4VjSQ");

var $aIDyD = parcelRequire("aIDyD");
function $3861c461d67a3194$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3861c461d67a3194$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3861c461d67a3194$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3861c461d67a3194$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3861c461d67a3194$var$buttonStyles = (0, $jP2pL.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
var $3861c461d67a3194$var$defaultInteractiveStyles = (0, $jP2pL.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($aABA1.N500, ")")
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($aABA1.B75, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($aABA1.B400, ")")
    }
});
var $3861c461d67a3194$var$defaultInteractiveRefreshedStyles = (0, $jP2pL.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    }
});
var $3861c461d67a3194$var$defaultStyles = (0, $jP2pL.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($aABA1.N20A, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($aABA1.N500, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($aABA1.N500, ")")
    }
});
var $3861c461d67a3194$var$defaultRefreshedStyles = (0, $jP2pL.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    '::after': {
        content: '""',
        borderColor: 'color.border'
    },
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $3861c461d67a3194$var$primaryStyles = (0, $jP2pL.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $3861c461d67a3194$var$primaryInteractiveStyles = (0, $jP2pL.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $3861c461d67a3194$var$warningStyles = (0, $jP2pL.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $3861c461d67a3194$var$warningInteractiveStyles = (0, $jP2pL.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $3861c461d67a3194$var$dangerStyles = (0, $jP2pL.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $3861c461d67a3194$var$dangerInteractiveStyles = (0, $jP2pL.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $3861c461d67a3194$var$discoveryStyles = (0, $jP2pL.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $3861c461d67a3194$var$discoveryInteractiveStyles = (0, $jP2pL.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $3861c461d67a3194$var$subtleStyles = (0, $jP2pL.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $3861c461d67a3194$var$subtleRefreshedStyles = (0, $jP2pL.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: 'color.text.subtle',
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $3861c461d67a3194$var$subtleInteractiveStyles = (0, $jP2pL.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $3861c461d67a3194$var$subtleInteractiveRefreshedStyles = (0, $jP2pL.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: 'color.text.subtle'
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $3861c461d67a3194$var$linkDecorationUnsetStyles = (0, $jP2pL.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
var $3861c461d67a3194$var$disabledStyles = (0, $jP2pL.xcss)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($aABA1.N20A, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($aABA1.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($aABA1.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    '::after': {
        content: 'none'
    }
});
var $3861c461d67a3194$var$selectedStyles = (0, $jP2pL.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($aABA1.N700, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($aABA1.N20, ")")
    }
});
var $3861c461d67a3194$var$selectedRefreshedStyles = (0, $jP2pL.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    }
});
var $3861c461d67a3194$var$selectedInsideSplitButtonStyles = (0, $jP2pL.xcss)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $3861c461d67a3194$var$selectedInteractiveStyles = (0, $jP2pL.xcss)({
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($aABA1.N700, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($aABA1.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $3861c461d67a3194$var$selectedWarningStyles = (0, $jP2pL.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($aABA1.Y400, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($aABA1.N800, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($aABA1.Y400, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($aABA1.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $3861c461d67a3194$var$selectedDangerStyles = (0, $jP2pL.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($aABA1.R500, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($aABA1.R500, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($aABA1.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $3861c461d67a3194$var$selectedDiscoveryStyles = (0, $jP2pL.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($aABA1.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
var $3861c461d67a3194$var$spacingCompactStyles = (0, $jP2pL.xcss)({
    columnGap: 'space.050',
    height: "".concat(24 / 14, "em"),
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $3861c461d67a3194$var$circleStyles = (0, $jP2pL.xcss)({
    borderRadius: 'border.radius.circle'
});
var $3861c461d67a3194$var$fullWidthStyles = (0, $jP2pL.xcss)({
    width: '100%'
});
var $3861c461d67a3194$var$loadingStyles = (0, $jP2pL.xcss)({
    cursor: 'progress'
});
var $3861c461d67a3194$var$iconButtonStyles = (0, $jP2pL.xcss)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
var $3861c461d67a3194$var$iconButtonCompactStyles = (0, $jP2pL.xcss)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $3861c461d67a3194$var$buttonIconBeforeStyles = (0, $jP2pL.xcss)({
    paddingInlineStart: 'space.100'
});
var $3861c461d67a3194$var$buttonIconAfterStyles = (0, $jP2pL.xcss)({
    paddingInlineEnd: 'space.100'
});
var $3861c461d67a3194$var$splitButtonStyles = (0, $jP2pL.xcss)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
var $3861c461d67a3194$var$navigationSplitButtonStyles = (0, $jP2pL.xcss)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
var $3861c461d67a3194$var$loadingOverlayStyles = (0, $jP2pL.xcss)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $3861c461d67a3194$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $1oC0p.useRef)(null);
    var splitButtonContext = (0, $dggek.useSplitButtonContext)();
    var loadingLabelId = (0, $8wO2B.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $71iyP.fg)('platform-component-visual-refresh') ? 'subtle' : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $1T8FE.default)(localRef, autoFocus);
    return $3861c461d67a3194$var$_objectSpread({
        ref: (0, $8ZwYS.default)([
            localRef,
            ref
        ]),
        xcss: [
            $3861c461d67a3194$var$buttonStyles,
            appearance === 'default' && ((0, $71iyP.fg)('platform-component-visual-refresh') ? $3861c461d67a3194$var$defaultRefreshedStyles : $3861c461d67a3194$var$defaultStyles),
            appearance === 'default' && isInteractive && ((0, $71iyP.fg)('platform-component-visual-refresh') ? $3861c461d67a3194$var$defaultInteractiveRefreshedStyles : $3861c461d67a3194$var$defaultInteractiveStyles),
            appearance === 'primary' && $3861c461d67a3194$var$primaryStyles,
            appearance === 'primary' && isInteractive && $3861c461d67a3194$var$primaryInteractiveStyles,
            appearance === 'warning' && $3861c461d67a3194$var$warningStyles,
            appearance === 'warning' && isInteractive && $3861c461d67a3194$var$warningInteractiveStyles,
            appearance === 'danger' && $3861c461d67a3194$var$dangerStyles,
            appearance === 'danger' && isInteractive && $3861c461d67a3194$var$dangerInteractiveStyles,
            appearance === 'discovery' && $3861c461d67a3194$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $3861c461d67a3194$var$discoveryInteractiveStyles,
            appearance === 'subtle' && ((0, $71iyP.fg)('platform-component-visual-refresh') ? $3861c461d67a3194$var$subtleRefreshedStyles : $3861c461d67a3194$var$subtleStyles),
            appearance === 'subtle' && isInteractive && ((0, $71iyP.fg)('platform-component-visual-refresh') ? $3861c461d67a3194$var$subtleInteractiveRefreshedStyles : $3861c461d67a3194$var$subtleInteractiveStyles),
            $3861c461d67a3194$var$linkDecorationUnsetStyles,
            isSelected && ((0, $71iyP.fg)('platform-component-visual-refresh') ? $3861c461d67a3194$var$selectedRefreshedStyles : $3861c461d67a3194$var$selectedStyles),
            isSelected && isSplitButton && $3861c461d67a3194$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $3861c461d67a3194$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $3861c461d67a3194$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $3861c461d67a3194$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $3861c461d67a3194$var$selectedDiscoveryStyles,
            isDisabled && $3861c461d67a3194$var$disabledStyles,
            isCircle && !isSplitButton && $3861c461d67a3194$var$circleStyles,
            spacing === 'compact' && $3861c461d67a3194$var$spacingCompactStyles,
            hasIconBefore && $3861c461d67a3194$var$buttonIconBeforeStyles,
            hasIconAfter && $3861c461d67a3194$var$buttonIconAfterStyles,
            isIconButton && $3861c461d67a3194$var$iconButtonStyles,
            isIconButton && spacing === 'compact' && $3861c461d67a3194$var$iconButtonCompactStyles,
            shouldFitContainer && $3861c461d67a3194$var$fullWidthStyles,
            isLoading && $3861c461d67a3194$var$loadingStyles,
            isSplitButton && $3861c461d67a3194$var$splitButtonStyles,
            isNavigationSplitButton && $3861c461d67a3194$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dggek.SplitButtonContext).Provider, {
            value: undefined
        }, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4CAS9.default), {
            as: "span",
            xcss: $3861c461d67a3194$var$loadingOverlayStyles
        }, (0, $aIDyD.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $FapDU.default), {
            id: loadingLabelId
        }, (0, $4VjSQ.LOADING_LABEL))),
        'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $4VjSQ.LOADING_LABEL)) : ariaLabel,
        'aria-labelledby': isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $jeWB2.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $3861c461d67a3194$export$2e2bcd8739ae039 = $3861c461d67a3194$var$useButtonBase;

});
parcelRegister("8ZwYS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $68bd9a91c30eb46c$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $68bd9a91c30eb46c$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("1T8FE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1601a758e8c409f8$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $1601a758e8c409f8$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("8wO2B", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $635820fec7630682$export$f680877a34711e37; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $71iyP = parcelRequire("71iyP");
var $635820fec7630682$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $635820fec7630682$var$react18UseId = ($635820fec7630682$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $635820fec7630682$var$_React$useId !== void 0 ? $635820fec7630682$var$_React$useId : undefined;
function $635820fec7630682$export$f680877a34711e37() {
    if ($635820fec7630682$var$react18UseId && (0, $71iyP.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $635820fec7630682$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $6JmtO.useUID)());
}
var $635820fec7630682$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($635820fec7630682$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $635820fec7630682$export$6ee17796e3d70de2() {
    if ($635820fec7630682$var$react18UseId && (0, $71iyP.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $635820fec7630682$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $6JmtO.useUIDSeed)();
}

});
parcelRegister("71iyP", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $51c7062ed6d7ab71$export$b40ec24ac8275656; });

var $5MvDx = parcelRequire("5MvDx");
function $51c7062ed6d7ab71$export$ba05d765b8392e5e(flagResolver) {
    (0, $5MvDx.setBooleanResolver)(flagResolver);
}
function $51c7062ed6d7ab71$export$470e5c2be1411c89(name) {
    return (0, $5MvDx.resolveBooleanFlag)(name);
}
function $51c7062ed6d7ab71$export$b40ec24ac8275656(name) {
    return (0, $5MvDx.resolveBooleanFlag)(name);
}

});
parcelRegister("5MvDx", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $4359f9d94e52a55b$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $4359f9d94e52a55b$export$6333b6aff9fc6275; });

var $e9zwX = parcelRequire("e9zwX");

var $7t0tI = parcelRequire("7t0tI");
var $4359f9d94e52a55b$var$pkgName = '@atlaskit/platform-feature-flags';
var $4359f9d94e52a55b$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $4359f9d94e52a55b$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $4359f9d94e52a55b$var$ENV_ENABLE_PLATFORM_FF = $4359f9d94e52a55b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $4359f9d94e52a55b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $4359f9d94e52a55b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $4359f9d94e52a55b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $4359f9d94e52a55b$var$ENV_ENABLE_PLATFORM_FF || $4359f9d94e52a55b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $4359f9d94e52a55b$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $4359f9d94e52a55b$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$4359f9d94e52a55b$var$globalVar[$4359f9d94e52a55b$export$7e41b1b2bdee3f98] = $4359f9d94e52a55b$var$globalVar[$4359f9d94e52a55b$export$7e41b1b2bdee3f98] || $4359f9d94e52a55b$var$DEFAULT_PFF_GLOBAL;
function $4359f9d94e52a55b$export$f2b591175b3e424c(resolver) {
    $4359f9d94e52a55b$var$globalVar[$4359f9d94e52a55b$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $4359f9d94e52a55b$export$6333b6aff9fc6275(flagKey) {
    if ($4359f9d94e52a55b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $e9zwX.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $4359f9d94e52a55b$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $4359f9d94e52a55b$var$globalVar[$4359f9d94e52a55b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("e9zwX", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $a4dd77920cd1fc31$export$1c9f709888824e05; });
var $a4dd77920cd1fc31$var$_ref, $a4dd77920cd1fc31$var$_process, $a4dd77920cd1fc31$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a4dd77920cd1fc31$var$TESTS_MODE = ($a4dd77920cd1fc31$var$_ref = (globalThis === null || globalThis === void 0 || ($a4dd77920cd1fc31$var$_process = globalThis.process) === null || $a4dd77920cd1fc31$var$_process === void 0 || ($a4dd77920cd1fc31$var$_process = $a4dd77920cd1fc31$var$_process.env) === null || $a4dd77920cd1fc31$var$_process === void 0 ? void 0 : $a4dd77920cd1fc31$var$_process.JEST_WORKER_ID) !== undefined, $a4dd77920cd1fc31$var$_ref !== void 0) ? $a4dd77920cd1fc31$var$_ref : false;
var $a4dd77920cd1fc31$var$DEBUG_MODE = !$a4dd77920cd1fc31$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a4dd77920cd1fc31$var$_process2 = globalThis.process) === null || $a4dd77920cd1fc31$var$_process2 === void 0 || ($a4dd77920cd1fc31$var$_process2 = $a4dd77920cd1fc31$var$_process2.env) === null || $a4dd77920cd1fc31$var$_process2 === void 0 ? void 0 : $a4dd77920cd1fc31$var$_process2.NODE_ENV) !== 'production';
var $a4dd77920cd1fc31$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a4dd77920cd1fc31$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("aABA1", function(module, exports) {
$parcel$export(module.exports, "R500", function () { return $7b5a6ac20af343ad$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y400", function () { return $7b5a6ac20af343ad$export$59619663aa6500fb; });
$parcel$export(module.exports, "B75", function () { return $7b5a6ac20af343ad$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B400", function () { return $7b5a6ac20af343ad$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N20", function () { return $7b5a6ac20af343ad$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N500", function () { return $7b5a6ac20af343ad$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $7b5a6ac20af343ad$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $7b5a6ac20af343ad$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $7b5a6ac20af343ad$export$8d43898f60b96a82; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $7b5a6ac20af343ad$export$4b84fd0e2c617bd = '#FFEBE6';
var $7b5a6ac20af343ad$export$b34b069eff244586 = '#FFBDAD';
var $7b5a6ac20af343ad$export$be802dd0d8b57f35 = '#FF8F73';
var $7b5a6ac20af343ad$export$60847d42f9da92a6 = '#FF7452';
var $7b5a6ac20af343ad$export$4a7404f376229999 = '#FF5630';
var $7b5a6ac20af343ad$export$2010d0fb4295b346 = '#DE350B';
var $7b5a6ac20af343ad$export$2837b5a1a71d5c02 = '#BF2600';
var $7b5a6ac20af343ad$export$8d9596b529bbb9cf = '#FFFAE6';
var $7b5a6ac20af343ad$export$41060a744ab0b7ae = '#FFF0B3';
var $7b5a6ac20af343ad$export$1cc05bbbf340e559 = '#FFE380';
var $7b5a6ac20af343ad$export$5aae31392d72caaa = '#FFC400';
var $7b5a6ac20af343ad$export$c6930421db9fa514 = '#FFAB00';
var $7b5a6ac20af343ad$export$59619663aa6500fb = '#FF991F';
var $7b5a6ac20af343ad$export$874739ea9e379ab6 = '#FF8B00';
var $7b5a6ac20af343ad$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $7b5a6ac20af343ad$export$69a3bf21b9686c2b = '#ABF5D1';
var $7b5a6ac20af343ad$export$afbce1382ec95f73 = '#79F2C0';
var $7b5a6ac20af343ad$export$747d86715d4175de = '#57D9A3';
var $7b5a6ac20af343ad$export$940e1f69e873f202 = '#36B37E';
var $7b5a6ac20af343ad$export$a49394138f7b8e85 = '#00875A';
var $7b5a6ac20af343ad$export$6fa04827ac68a4fb = '#006644';
var $7b5a6ac20af343ad$export$226de0355ed012f8 = '#DEEBFF';
var $7b5a6ac20af343ad$export$8c13c2ee36917869 = '#B3D4FF';
var $7b5a6ac20af343ad$export$ecfc1dff386a3e7a = '#4C9AFF';
var $7b5a6ac20af343ad$export$215b7063051591f1 = '#2684FF';
var $7b5a6ac20af343ad$export$e62e8919cca44969 = '#0065FF';
var $7b5a6ac20af343ad$export$b3de0ae08da2ce64 = '#0052CC';
var $7b5a6ac20af343ad$export$a6ee3d71bc067634 = '#0747A6';
var $7b5a6ac20af343ad$export$67f15409e87642a1 = '#669DF1';
var $7b5a6ac20af343ad$export$f0539dbc42dbb067 = '#8FB8F6';
var $7b5a6ac20af343ad$export$363e4475840015bb = '#EAE6FF';
var $7b5a6ac20af343ad$export$4b0a4417ed59760f = '#C0B6F2';
var $7b5a6ac20af343ad$export$6011520a64d9a187 = '#998DD9';
var $7b5a6ac20af343ad$export$a7175d4e9206bc80 = '#8777D9';
var $7b5a6ac20af343ad$export$b48405b95304b5a1 = '#6554C0';
var $7b5a6ac20af343ad$export$c71e4279dd54a18d = '#5243AA';
var $7b5a6ac20af343ad$export$147899de772240ec = '#403294';
var $7b5a6ac20af343ad$export$2cf711fe14c66f06 = '#E6FCFF';
var $7b5a6ac20af343ad$export$7a8f4d33f6f9772c = '#B3F5FF';
var $7b5a6ac20af343ad$export$776c9c497ef08533 = '#79E2F2';
var $7b5a6ac20af343ad$export$69cb3ca10c1e330e = '#00C7E6';
var $7b5a6ac20af343ad$export$9dc1ef0f3f48059b = '#00B8D9';
var $7b5a6ac20af343ad$export$7c835c78b6fcdef8 = '#00A3BF';
var $7b5a6ac20af343ad$export$6036577f95c3877e = '#008DA6';
var $7b5a6ac20af343ad$export$29a4f05edc054374 = '#FFFFFF';
var $7b5a6ac20af343ad$export$e655ef011c4aa1a2 = '#FAFBFC';
var $7b5a6ac20af343ad$export$9fdfb749e33cdf97 = '#F4F5F7';
var $7b5a6ac20af343ad$export$3e51e8f1440314ba = '#EBECF0';
var $7b5a6ac20af343ad$export$1ce2d1575d444ceb = '#DFE1E6';
var $7b5a6ac20af343ad$export$8754fc7e6d8b3000 = '#C1C7D0';
var $7b5a6ac20af343ad$export$c2e91cbeada39b8b = '#B3BAC5';
var $7b5a6ac20af343ad$export$5f71e19f3a7ad9de = '#A5ADBA';
var $7b5a6ac20af343ad$export$eaa8c8a70ac22806 = '#97A0AF';
var $7b5a6ac20af343ad$export$7c87d337fb91a97d = '#8993A4';
var $7b5a6ac20af343ad$export$d6447c357493214f = '#7A869A';
var $7b5a6ac20af343ad$export$f563ee71e9ee74cd = '#6B778C';
var $7b5a6ac20af343ad$export$e2ef2124cf4024b1 = '#5E6C84';
var $7b5a6ac20af343ad$export$eece5f492e429f08 = '#505F79';
var $7b5a6ac20af343ad$export$c39c0fe0f26207ae = '#42526E';
var $7b5a6ac20af343ad$export$7090862dc3038a9f = '#344563';
var $7b5a6ac20af343ad$export$ad0bacf983b7ddaa = '#253858';
var $7b5a6ac20af343ad$export$7d61b15e0da132af = '#172B4D';
var $7b5a6ac20af343ad$export$fbda843f0a27fe96 = '#091E42';
var $7b5a6ac20af343ad$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $7b5a6ac20af343ad$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $7b5a6ac20af343ad$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $7b5a6ac20af343ad$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $7b5a6ac20af343ad$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $7b5a6ac20af343ad$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $7b5a6ac20af343ad$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $7b5a6ac20af343ad$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $7b5a6ac20af343ad$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $7b5a6ac20af343ad$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $7b5a6ac20af343ad$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $7b5a6ac20af343ad$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $7b5a6ac20af343ad$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $7b5a6ac20af343ad$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $7b5a6ac20af343ad$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $7b5a6ac20af343ad$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $7b5a6ac20af343ad$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $7b5a6ac20af343ad$export$2f6319cf7d736c2a = '#E6EDFA';
var $7b5a6ac20af343ad$export$95126bc8884d6634 = '#DCE5F5';
var $7b5a6ac20af343ad$export$8338d8c35d44ff1 = '#CED9EB';
var $7b5a6ac20af343ad$export$5368d76ae4fbbda7 = '#B8C7E0';
var $7b5a6ac20af343ad$export$9f0a771d16ec8d36 = '#ABBBD6';
var $7b5a6ac20af343ad$export$abcf8c38338b4aa5 = '#9FB0CC';
var $7b5a6ac20af343ad$export$97e81faa16a182c7 = '#8C9CB8';
var $7b5a6ac20af343ad$export$bfe21c59123ecf33 = '#7988A3';
var $7b5a6ac20af343ad$export$ee82aa2ea6a1558 = '#67758F';
var $7b5a6ac20af343ad$export$682927c6ed76be02 = '#56637A';
var $7b5a6ac20af343ad$export$91fd9994c5be9757 = '#455166';
var $7b5a6ac20af343ad$export$d281fbfe3cff2df6 = '#3B475C';
var $7b5a6ac20af343ad$export$3902c91d8b98a753 = '#313D52';
var $7b5a6ac20af343ad$export$8e8133c1ba5845b5 = '#283447';
var $7b5a6ac20af343ad$export$33ff357f6620b39 = '#202B3D';
var $7b5a6ac20af343ad$export$633847cf062b69e0 = '#1B2638';
var $7b5a6ac20af343ad$export$9776a6e503bdbf76 = '#121A29';
var $7b5a6ac20af343ad$export$6c813d5160dff5db = '#0E1624';
var $7b5a6ac20af343ad$export$3d4f271a500072a = '#0D1424';
var $7b5a6ac20af343ad$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $7b5a6ac20af343ad$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $7b5a6ac20af343ad$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $7b5a6ac20af343ad$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $7b5a6ac20af343ad$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $7b5a6ac20af343ad$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $7b5a6ac20af343ad$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $7b5a6ac20af343ad$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $7b5a6ac20af343ad$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $7b5a6ac20af343ad$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $7b5a6ac20af343ad$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $7b5a6ac20af343ad$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $7b5a6ac20af343ad$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $7b5a6ac20af343ad$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $7b5a6ac20af343ad$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $7b5a6ac20af343ad$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $7b5a6ac20af343ad$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $7b5a6ac20af343ad$export$d2adc5dedf09fced = '#292A2E';
var $7b5a6ac20af343ad$export$f51762073d2bb381 = '#94C748';
var $7b5a6ac20af343ad$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("dggek", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", function () { return $9a795bf2b0ba0f18$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $9a795bf2b0ba0f18$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");
var $9a795bf2b0ba0f18$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $9a795bf2b0ba0f18$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)($9a795bf2b0ba0f18$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("jeWB2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e01cc724fd369059$export$2e2bcd8739ae039; });
function $e01cc724fd369059$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $e01cc724fd369059$var$tabKeyCode = 9;
function $e01cc724fd369059$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $e01cc724fd369059$var$tabKeyCode) return;
    $e01cc724fd369059$var$abort(event);
}
function $e01cc724fd369059$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $e01cc724fd369059$var$abort,
        onMouseUpCapture: $e01cc724fd369059$var$abort,
        onKeyDownCapture: $e01cc724fd369059$var$onKey,
        onKeyUpCapture: $e01cc724fd369059$var$onKey,
        onTouchStartCapture: $e01cc724fd369059$var$abort,
        onTouchEndCapture: $e01cc724fd369059$var$abort,
        onPointerDownCapture: $e01cc724fd369059$var$abort,
        onPointerUpCapture: $e01cc724fd369059$var$abort,
        onClickCapture: $e01cc724fd369059$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $e01cc724fd369059$var$abort
    } : events;
}

});

parcelRegister("4VjSQ", function(module, exports) {
$parcel$export(module.exports, "LOADING_LABEL", function () { return $395be8c145e5f511$export$d4c5499dc806c969; });
var $395be8c145e5f511$export$d4c5499dc806c969 = ', Loading';

});

parcelRegister("aIDyD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7cdcb2c4f01882f3$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $9HgUz = parcelRequire("9HgUz");
function $7cdcb2c4f01882f3$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $7cdcb2c4f01882f3$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $7cdcb2c4f01882f3$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9HgUz.default), {
        size: $7cdcb2c4f01882f3$var$getIconSpacing(spacing),
        appearance: $7cdcb2c4f01882f3$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("9HgUz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70f53f7aa48ce5f3$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $e5Do8 = parcelRequire("e5Do8");

var $1oC0p = parcelRequire("1oC0p");

var $5Bwfa = parcelRequire("5Bwfa");

var $1uSkd = parcelRequire("1uSkd");

var $gXhK6 = parcelRequire("gXhK6");
/**
 * Returns the appropriate circle stroke color.
 */ function $70f53f7aa48ce5f3$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $1uSkd.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $1uSkd.N0), ")");
}
var $70f53f7aa48ce5f3$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $70f53f7aa48ce5f3$var$loadIn = null;
var $70f53f7aa48ce5f3$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $70f53f7aa48ce5f3$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $70f53f7aa48ce5f3$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $gXhK6.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $70f53f7aa48ce5f3$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $5Bwfa.default));
    $70f53f7aa48ce5f3$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $e5Do8.default)([
            $70f53f7aa48ce5f3$var$styles.wrapperStyles,
            $70f53f7aa48ce5f3$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $e5Do8.default)([
            $70f53f7aa48ce5f3$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $e5Do8.default)([
            $70f53f7aa48ce5f3$var$styles.circleStyles
        ])
    })));
}));
var $70f53f7aa48ce5f3$export$2e2bcd8739ae039 = $70f53f7aa48ce5f3$var$Spinner;

});
parcelRegister("1uSkd", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $1172bb9fce0835ed$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $1172bb9fce0835ed$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $1172bb9fce0835ed$export$4b84fd0e2c617bd = '#FFEBE6';
var $1172bb9fce0835ed$export$b34b069eff244586 = '#FFBDAD';
var $1172bb9fce0835ed$export$be802dd0d8b57f35 = '#FF8F73';
var $1172bb9fce0835ed$export$60847d42f9da92a6 = '#FF7452';
var $1172bb9fce0835ed$export$4a7404f376229999 = '#FF5630';
var $1172bb9fce0835ed$export$2010d0fb4295b346 = '#DE350B';
var $1172bb9fce0835ed$export$2837b5a1a71d5c02 = '#BF2600';
var $1172bb9fce0835ed$export$8d9596b529bbb9cf = '#FFFAE6';
var $1172bb9fce0835ed$export$41060a744ab0b7ae = '#FFF0B3';
var $1172bb9fce0835ed$export$1cc05bbbf340e559 = '#FFE380';
var $1172bb9fce0835ed$export$5aae31392d72caaa = '#FFC400';
var $1172bb9fce0835ed$export$c6930421db9fa514 = '#FFAB00';
var $1172bb9fce0835ed$export$59619663aa6500fb = '#FF991F';
var $1172bb9fce0835ed$export$874739ea9e379ab6 = '#FF8B00';
var $1172bb9fce0835ed$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1172bb9fce0835ed$export$69a3bf21b9686c2b = '#ABF5D1';
var $1172bb9fce0835ed$export$afbce1382ec95f73 = '#79F2C0';
var $1172bb9fce0835ed$export$747d86715d4175de = '#57D9A3';
var $1172bb9fce0835ed$export$940e1f69e873f202 = '#36B37E';
var $1172bb9fce0835ed$export$a49394138f7b8e85 = '#00875A';
var $1172bb9fce0835ed$export$6fa04827ac68a4fb = '#006644';
var $1172bb9fce0835ed$export$226de0355ed012f8 = '#DEEBFF';
var $1172bb9fce0835ed$export$8c13c2ee36917869 = '#B3D4FF';
var $1172bb9fce0835ed$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1172bb9fce0835ed$export$215b7063051591f1 = '#2684FF';
var $1172bb9fce0835ed$export$e62e8919cca44969 = '#0065FF';
var $1172bb9fce0835ed$export$b3de0ae08da2ce64 = '#0052CC';
var $1172bb9fce0835ed$export$a6ee3d71bc067634 = '#0747A6';
var $1172bb9fce0835ed$export$67f15409e87642a1 = '#669DF1';
var $1172bb9fce0835ed$export$f0539dbc42dbb067 = '#8FB8F6';
var $1172bb9fce0835ed$export$363e4475840015bb = '#EAE6FF';
var $1172bb9fce0835ed$export$4b0a4417ed59760f = '#C0B6F2';
var $1172bb9fce0835ed$export$6011520a64d9a187 = '#998DD9';
var $1172bb9fce0835ed$export$a7175d4e9206bc80 = '#8777D9';
var $1172bb9fce0835ed$export$b48405b95304b5a1 = '#6554C0';
var $1172bb9fce0835ed$export$c71e4279dd54a18d = '#5243AA';
var $1172bb9fce0835ed$export$147899de772240ec = '#403294';
var $1172bb9fce0835ed$export$2cf711fe14c66f06 = '#E6FCFF';
var $1172bb9fce0835ed$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1172bb9fce0835ed$export$776c9c497ef08533 = '#79E2F2';
var $1172bb9fce0835ed$export$69cb3ca10c1e330e = '#00C7E6';
var $1172bb9fce0835ed$export$9dc1ef0f3f48059b = '#00B8D9';
var $1172bb9fce0835ed$export$7c835c78b6fcdef8 = '#00A3BF';
var $1172bb9fce0835ed$export$6036577f95c3877e = '#008DA6';
var $1172bb9fce0835ed$export$29a4f05edc054374 = '#FFFFFF';
var $1172bb9fce0835ed$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1172bb9fce0835ed$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1172bb9fce0835ed$export$3e51e8f1440314ba = '#EBECF0';
var $1172bb9fce0835ed$export$1ce2d1575d444ceb = '#DFE1E6';
var $1172bb9fce0835ed$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1172bb9fce0835ed$export$c2e91cbeada39b8b = '#B3BAC5';
var $1172bb9fce0835ed$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1172bb9fce0835ed$export$eaa8c8a70ac22806 = '#97A0AF';
var $1172bb9fce0835ed$export$7c87d337fb91a97d = '#8993A4';
var $1172bb9fce0835ed$export$d6447c357493214f = '#7A869A';
var $1172bb9fce0835ed$export$f563ee71e9ee74cd = '#6B778C';
var $1172bb9fce0835ed$export$e2ef2124cf4024b1 = '#5E6C84';
var $1172bb9fce0835ed$export$eece5f492e429f08 = '#505F79';
var $1172bb9fce0835ed$export$c39c0fe0f26207ae = '#42526E';
var $1172bb9fce0835ed$export$7090862dc3038a9f = '#344563';
var $1172bb9fce0835ed$export$ad0bacf983b7ddaa = '#253858';
var $1172bb9fce0835ed$export$7d61b15e0da132af = '#172B4D';
var $1172bb9fce0835ed$export$fbda843f0a27fe96 = '#091E42';
var $1172bb9fce0835ed$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1172bb9fce0835ed$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1172bb9fce0835ed$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1172bb9fce0835ed$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1172bb9fce0835ed$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1172bb9fce0835ed$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1172bb9fce0835ed$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1172bb9fce0835ed$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1172bb9fce0835ed$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1172bb9fce0835ed$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1172bb9fce0835ed$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1172bb9fce0835ed$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1172bb9fce0835ed$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1172bb9fce0835ed$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1172bb9fce0835ed$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1172bb9fce0835ed$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1172bb9fce0835ed$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1172bb9fce0835ed$export$2f6319cf7d736c2a = '#E6EDFA';
var $1172bb9fce0835ed$export$95126bc8884d6634 = '#DCE5F5';
var $1172bb9fce0835ed$export$8338d8c35d44ff1 = '#CED9EB';
var $1172bb9fce0835ed$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1172bb9fce0835ed$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1172bb9fce0835ed$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1172bb9fce0835ed$export$97e81faa16a182c7 = '#8C9CB8';
var $1172bb9fce0835ed$export$bfe21c59123ecf33 = '#7988A3';
var $1172bb9fce0835ed$export$ee82aa2ea6a1558 = '#67758F';
var $1172bb9fce0835ed$export$682927c6ed76be02 = '#56637A';
var $1172bb9fce0835ed$export$91fd9994c5be9757 = '#455166';
var $1172bb9fce0835ed$export$d281fbfe3cff2df6 = '#3B475C';
var $1172bb9fce0835ed$export$3902c91d8b98a753 = '#313D52';
var $1172bb9fce0835ed$export$8e8133c1ba5845b5 = '#283447';
var $1172bb9fce0835ed$export$33ff357f6620b39 = '#202B3D';
var $1172bb9fce0835ed$export$633847cf062b69e0 = '#1B2638';
var $1172bb9fce0835ed$export$9776a6e503bdbf76 = '#121A29';
var $1172bb9fce0835ed$export$6c813d5160dff5db = '#0E1624';
var $1172bb9fce0835ed$export$3d4f271a500072a = '#0D1424';
var $1172bb9fce0835ed$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1172bb9fce0835ed$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1172bb9fce0835ed$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1172bb9fce0835ed$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1172bb9fce0835ed$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1172bb9fce0835ed$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1172bb9fce0835ed$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1172bb9fce0835ed$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1172bb9fce0835ed$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1172bb9fce0835ed$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1172bb9fce0835ed$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1172bb9fce0835ed$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1172bb9fce0835ed$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1172bb9fce0835ed$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1172bb9fce0835ed$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1172bb9fce0835ed$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1172bb9fce0835ed$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1172bb9fce0835ed$export$d2adc5dedf09fced = '#292A2E';
var $1172bb9fce0835ed$export$f51762073d2bb381 = '#94C748';
var $1172bb9fce0835ed$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("gXhK6", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $c57feb52ba0031bd$export$4e9f1640bbe7a1a8; });
var $c57feb52ba0031bd$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});






parcelRegister("8cg9k", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f7bf8aa39116462$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $3dJ4i = parcelRequire("3dJ4i");

var $42NVz = parcelRequire("42NVz");

var $6l5xj = parcelRequire("6l5xj");

var $7t0tI = parcelRequire("7t0tI");
var $5f7bf8aa39116462$var$_excluded = [
    "level"
];
// https://atlassian.design/foundations/typography
var $5f7bf8aa39116462$var$levelMap = {
    h900: 'h1',
    h800: 'h1',
    h700: 'h2',
    h600: 'h3',
    h500: 'h4',
    h400: 'h5',
    h300: 'h6',
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: 'div',
    h100: 'div'
};
var $5f7bf8aa39116462$var$headingResetStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $5f7bf8aa39116462$var$h900Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $5f7bf8aa39116462$var$h800Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $5f7bf8aa39116462$var$h700Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $5f7bf8aa39116462$var$h600Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.008em',
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $5f7bf8aa39116462$var$h500Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.006em',
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $5f7bf8aa39116462$var$h400Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $5f7bf8aa39116462$var$h300Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: 'uppercase'
});
var $5f7bf8aa39116462$var$h200Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $5f7bf8aa39116462$var$h100Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $5f7bf8aa39116462$var$inverseStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $5f7bf8aa39116462$var$subtlestStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $5f7bf8aa39116462$var$OldHeading = function OldHeading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? 'default' : _ref$color;
    typeof $7t0tI;
    var _useHeading = (0, $42NVz.useHeading)($5f7bf8aa39116462$var$levelMap[level]), _useHeading2 = (0, $2qaZZ.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === 'h200' || level === 'h100';
    var needsAriaRole = Markup === 'div' && hLevel;
    return (0, $3dJ4i.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $5f7bf8aa39116462$var$headingResetStyles,
            level === 'h100' && $5f7bf8aa39116462$var$h100Styles,
            level === 'h200' && $5f7bf8aa39116462$var$h200Styles,
            level === 'h300' && $5f7bf8aa39116462$var$h300Styles,
            level === 'h400' && $5f7bf8aa39116462$var$h400Styles,
            level === 'h500' && $5f7bf8aa39116462$var$h500Styles,
            level === 'h600' && $5f7bf8aa39116462$var$h600Styles,
            level === 'h700' && $5f7bf8aa39116462$var$h700Styles,
            level === 'h800' && $5f7bf8aa39116462$var$h800Styles,
            level === 'h900' && $5f7bf8aa39116462$var$h900Styles,
            color === 'inverse' && $5f7bf8aa39116462$var$inverseStyles,
            color === 'default' && isSubtleHeading && $5f7bf8aa39116462$var$subtlestStyles
        ]
    }, children);
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * // New component
 * <Heading size="xxlarge">Page title</Heading>
 *
 * // Old component
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $5f7bf8aa39116462$var$Heading = function Heading(_ref2) {
    var level = _ref2.level, props = (0, $gnQ3X.default)(_ref2, $5f7bf8aa39116462$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $3dJ4i.jsx)($5f7bf8aa39116462$var$OldHeading, (0, $c9bqK.default)({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $3dJ4i.jsx)((0, $6l5xj.default), props);
};
var $5f7bf8aa39116462$export$2e2bcd8739ae039 = $5f7bf8aa39116462$var$Heading;

});
parcelRegister("42NVz", function(module, exports) {
$parcel$export(module.exports, "useHeading", function () { return $2f1e13e15dc41dd3$export$97a37b1befbbf9b1; });

var $1oC0p = parcelRequire("1oC0p");
// Allows support for heading levels 1-9 via aria-level
var $2f1e13e15dc41dd3$var$HeadingLevelContext = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $2f1e13e15dc41dd3$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $1oC0p.useContext)($2f1e13e15dc41dd3$var$HeadingLevelContext);
};
var $2f1e13e15dc41dd3$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $2f1e13e15dc41dd3$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $2f1e13e15dc41dd3$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $2f1e13e15dc41dd3$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($2f1e13e15dc41dd3$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $2f1e13e15dc41dd3$export$2e2bcd8739ae039 = $2f1e13e15dc41dd3$var$HeadingLevelContextProvider;

});

parcelRegister("6l5xj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $49d8ffa483c5bf06$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $3dJ4i = parcelRequire("3dJ4i");

var $kJ3dn = parcelRequire("kJ3dn");
var $fE07D = parcelRequire("fE07D");

var $42NVz = parcelRequire("42NVz");

var $7t0tI = parcelRequire("7t0tI");
var $49d8ffa483c5bf06$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $49d8ffa483c5bf06$var$headingResetStyles = (0, $3dJ4i.css)({
    letterSpacing: 'normal',
    marginBlock: 0,
    textTransform: 'none'
});
var $49d8ffa483c5bf06$var$useColor = function useColor(colorProp) {
    var surface = (0, $fE07D.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $kJ3dn.inverseColorMap).hasOwnProperty(surface)) return (0, $kJ3dn.inverseColorMap)[surface];
    return colorProp || 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $49d8ffa483c5bf06$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, id = _ref.id, testId = _ref.testId, as = _ref.as, colorProp = _ref.color;
    typeof $7t0tI;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $42NVz.useHeading)($49d8ffa483c5bf06$var$sizeTagMap[size]), _useHeading2 = (0, $2qaZZ.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $49d8ffa483c5bf06$var$useColor(colorProp);
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $49d8ffa483c5bf06$var$headingResetStyles,
            size && $49d8ffa483c5bf06$var$headingSizeStylesMap[size],
            $49d8ffa483c5bf06$export$93e8ddd840a408f9[color]
        ]
    }, children);
};
var $49d8ffa483c5bf06$export$93e8ddd840a408f9 = {
    'color.text': (0, $3dJ4i.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    'color.text.inverse': (0, $3dJ4i.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    'color.text.warning.inverse': (0, $3dJ4i.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    })
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df829c6c0aa19bb57c0c77dc08d12d60>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $49d8ffa483c5bf06$var$headingSizeStylesMap = {
    xxlarge: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xlarge: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    large: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    medium: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    small: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xsmall: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xxsmall: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    })
};
var /**
 * @codegenEnd
 */ $49d8ffa483c5bf06$export$2e2bcd8739ae039 = $49d8ffa483c5bf06$var$Heading;

});
parcelRegister("kJ3dn", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", function () { return $f16a80fdfadd4676$export$2185ce37f9bdd963; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $8Pb5W = parcelRequire("8Pb5W");
function $f16a80fdfadd4676$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f16a80fdfadd4676$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f16a80fdfadd4676$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f16a80fdfadd4676$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f16a80fdfadd4676$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $f16a80fdfadd4676$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $f16a80fdfadd4676$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $f16a80fdfadd4676$export$632685d741f3dbbf = $f16a80fdfadd4676$var$_objectSpread($f16a80fdfadd4676$var$_objectSpread({}, $f16a80fdfadd4676$export$958d0ae7f2977ae4), $f16a80fdfadd4676$export$d2dc61f58390201c);
var $f16a80fdfadd4676$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $f16a80fdfadd4676$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $f16a80fdfadd4676$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $f16a80fdfadd4676$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $f16a80fdfadd4676$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $f16a80fdfadd4676$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $f16a80fdfadd4676$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $f16a80fdfadd4676$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $f16a80fdfadd4676$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $f16a80fdfadd4676$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $f16a80fdfadd4676$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $f16a80fdfadd4676$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $f16a80fdfadd4676$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $f16a80fdfadd4676$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $f16a80fdfadd4676$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $f16a80fdfadd4676$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $f16a80fdfadd4676$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $f16a80fdfadd4676$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $f53LC.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $f16a80fdfadd4676$export$e615f061ca585a6c = $f16a80fdfadd4676$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f16a80fdfadd4676$export$ca0f9c2de39ffed7(spacingProperty, $f16a80fdfadd4676$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f16a80fdfadd4676$export$bf46c3f9eeafc71f = $f16a80fdfadd4676$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f16a80fdfadd4676$export$ca0f9c2de39ffed7(spacingProperty, $f16a80fdfadd4676$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f16a80fdfadd4676$export$e7af83bafe7f9e63 = $f16a80fdfadd4676$export$ca0f9c2de39ffed7('backgroundColor', $f16a80fdfadd4676$export$d1d79bf68ac056bd);
var $f16a80fdfadd4676$export$3a1bcba60b23d7f0 = $f16a80fdfadd4676$export$ca0f9c2de39ffed7('color', $f16a80fdfadd4676$export$8473307aa00d6ea1);
var $f16a80fdfadd4676$export$45f3f4fe16f9f7d5 = $f16a80fdfadd4676$export$ca0f9c2de39ffed7('fontWeight', $f16a80fdfadd4676$export$303e322c6b1ed114);
var $f16a80fdfadd4676$export$68cc305da27dbaa4 = $f16a80fdfadd4676$export$ca0f9c2de39ffed7('fontFamily', $f16a80fdfadd4676$export$3c7e9587132614b4);
var $f16a80fdfadd4676$export$128f10c238242f83 = $f16a80fdfadd4676$export$ca0f9c2de39ffed7('font', $f16a80fdfadd4676$export$6ffa317d5e70375);
var $f16a80fdfadd4676$export$219d364c0da35ae4 = $f16a80fdfadd4676$export$ca0f9c2de39ffed7('font', $f16a80fdfadd4676$export$236bfe3a33ef1292);
var $f16a80fdfadd4676$export$38845ca010b93505 = $f16a80fdfadd4676$export$ca0f9c2de39ffed7('fontWeight', $f16a80fdfadd4676$export$855cfd311192d666);
var $f16a80fdfadd4676$export$ff257d957d48c421 = $f16a80fdfadd4676$export$ca0f9c2de39ffed7((0, $8Pb5W.CURRENT_SURFACE_CSS_VAR), $f16a80fdfadd4676$export$41a358c9c2356760);
var $f16a80fdfadd4676$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $f16a80fdfadd4676$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("8Pb5W", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $66cbb15388f8589b$export$9d7b58831ae93caa; });
var $66cbb15388f8589b$export$4ef52930e33717cd = 'data-theme';
var $66cbb15388f8589b$export$a00eac3f8684bcd0 = 'data-color-mode';
var $66cbb15388f8589b$export$2112803007239c61 = 'data-contrast-mode';
var $66cbb15388f8589b$export$352e418ed5b6193a = 'data-custom-theme';
var $66cbb15388f8589b$export$2faeed762aac6741 = 'light';
var $66cbb15388f8589b$export$6f0c6fb8c80fcc92 = 'ds';
var $66cbb15388f8589b$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $66cbb15388f8589b$export$dddac1532e822863 = "--".concat($66cbb15388f8589b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $66cbb15388f8589b$export$9d7b58831ae93caa = "--".concat($66cbb15388f8589b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("fE07D", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $b63aafac2d67020c$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $b63aafac2d67020c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $b63aafac2d67020c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($b63aafac2d67020c$export$1ca2a26fecb070ae);
};
$b63aafac2d67020c$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("3NViD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c52653820bbbd8f$var$_react = $2c52653820bbbd8f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2z5sZ = parcelRequire("2z5sZ");

var $2c52653820bbbd8f$var$_chevronLeft = $2c52653820bbbd8f$var$_interopRequireDefault((parcelRequire("dHs14")));
function $2c52653820bbbd8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2c52653820bbbd8f$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $2c52653820bbbd8f$var$_react.default.createElement($2z5sZ.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $2c52653820bbbd8f$var$_chevronLeft.default,
        iconType: "utility"
    }));
$2c52653820bbbd8f$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $2c52653820bbbd8f$var$_default = module.exports.default = $2c52653820bbbd8f$var$ChevronLeftLargeIcon;

});
parcelRegister("2z5sZ", function(module, exports) {
$parcel$export(module.exports, "IconFacade", function () { return $1de3172dffc9a161$export$3cfb73f70dfca966; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3zKGK = parcelRequire("3zKGK");

var $ctJWT = parcelRequire("ctJWT");
var $1de3172dffc9a161$var$_excluded = [
    "dangerouslySetGlyph"
];
var $1de3172dffc9a161$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $1de3172dffc9a161$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $1oC0p.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, $gnQ3X.default)(_ref, $1de3172dffc9a161$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $3zKGK.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, (0, $c9bqK.default)({}, props, {
                spacing: (0, $3zKGK.fg)('platform-visual-refresh-icons-facade-button-fix') ? $1de3172dffc9a161$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(_Icon, (0, $c9bqK.default)({}, props, {
                spacing: $1de3172dffc9a161$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ctJWT.default), (0, $c9bqK.default)({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $1de3172dffc9a161$export$2e2bcd8739ae039 = $1de3172dffc9a161$export$3cfb73f70dfca966;

});
parcelRegister("3zKGK", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $29a8db5b20f42793$export$b40ec24ac8275656; });

var $gFubI = parcelRequire("gFubI");
function $29a8db5b20f42793$export$ba05d765b8392e5e(flagResolver) {
    (0, $gFubI.setBooleanResolver)(flagResolver);
}
function $29a8db5b20f42793$export$470e5c2be1411c89(name) {
    return (0, $gFubI.resolveBooleanFlag)(name);
}
function $29a8db5b20f42793$export$b40ec24ac8275656(name) {
    return (0, $gFubI.resolveBooleanFlag)(name);
}

});
parcelRegister("gFubI", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $c227e4668c2188b9$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $c227e4668c2188b9$export$6333b6aff9fc6275; });

var $bjR9y = parcelRequire("bjR9y");

var $7t0tI = parcelRequire("7t0tI");
var $c227e4668c2188b9$var$pkgName = '@atlaskit/platform-feature-flags';
var $c227e4668c2188b9$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $c227e4668c2188b9$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $c227e4668c2188b9$var$ENV_ENABLE_PLATFORM_FF = $c227e4668c2188b9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $c227e4668c2188b9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $c227e4668c2188b9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $c227e4668c2188b9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $c227e4668c2188b9$var$ENV_ENABLE_PLATFORM_FF || $c227e4668c2188b9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $c227e4668c2188b9$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $c227e4668c2188b9$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$c227e4668c2188b9$var$globalVar[$c227e4668c2188b9$export$7e41b1b2bdee3f98] = $c227e4668c2188b9$var$globalVar[$c227e4668c2188b9$export$7e41b1b2bdee3f98] || $c227e4668c2188b9$var$DEFAULT_PFF_GLOBAL;
function $c227e4668c2188b9$export$f2b591175b3e424c(resolver) {
    $c227e4668c2188b9$var$globalVar[$c227e4668c2188b9$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $c227e4668c2188b9$export$6333b6aff9fc6275(flagKey) {
    if ($c227e4668c2188b9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $bjR9y.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $c227e4668c2188b9$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $c227e4668c2188b9$var$globalVar[$c227e4668c2188b9$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("bjR9y", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $83dab32332a4fcbb$export$1c9f709888824e05; });
var $83dab32332a4fcbb$var$_ref, $83dab32332a4fcbb$var$_process, $83dab32332a4fcbb$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $83dab32332a4fcbb$var$TESTS_MODE = ($83dab32332a4fcbb$var$_ref = (globalThis === null || globalThis === void 0 || ($83dab32332a4fcbb$var$_process = globalThis.process) === null || $83dab32332a4fcbb$var$_process === void 0 || ($83dab32332a4fcbb$var$_process = $83dab32332a4fcbb$var$_process.env) === null || $83dab32332a4fcbb$var$_process === void 0 ? void 0 : $83dab32332a4fcbb$var$_process.JEST_WORKER_ID) !== undefined, $83dab32332a4fcbb$var$_ref !== void 0) ? $83dab32332a4fcbb$var$_ref : false;
var $83dab32332a4fcbb$var$DEBUG_MODE = !$83dab32332a4fcbb$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($83dab32332a4fcbb$var$_process2 = globalThis.process) === null || $83dab32332a4fcbb$var$_process2 === void 0 || ($83dab32332a4fcbb$var$_process2 = $83dab32332a4fcbb$var$_process2.env) === null || $83dab32332a4fcbb$var$_process2 === void 0 ? void 0 : $83dab32332a4fcbb$var$_process2.NODE_ENV) !== 'production';
var $83dab32332a4fcbb$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$83dab32332a4fcbb$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("ctJWT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $915bd5f5f76165b5$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $5AaQ7 = parcelRequire("5AaQ7");

var $i01we = parcelRequire("i01we");
function $915bd5f5f76165b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $915bd5f5f76165b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $915bd5f5f76165b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $915bd5f5f76165b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $915bd5f5f76165b5$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $915bd5f5f76165b5$var$_objectSpread($915bd5f5f76165b5$var$_objectSpread({}, (0, $5AaQ7.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $915bd5f5f76165b5$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $915bd5f5f76165b5$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $915bd5f5f76165b5$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $915bd5f5f76165b5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $5AaQ7.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $3dJ4i.jsx)("span", (0, $c9bqK.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $915bd5f5f76165b5$var$_objectSpread({
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $i01we.getBackground)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $915bd5f5f76165b5$var$iconStyles,
            $915bd5f5f76165b5$var$baseHcmStyles,
            primaryColor === secondaryColor && $915bd5f5f76165b5$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $915bd5f5f76165b5$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $3dJ4i.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $915bd5f5f76165b5$export$2e2bcd8739ae039 = $915bd5f5f76165b5$export$f04a61298a47a40f;

});
parcelRegister("5AaQ7", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $4108b90c0fa9874d$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $4108b90c0fa9874d$export$3eb7d6130acfda37; });

var $blylh = parcelRequire("blylh");

var $3dJ4i = parcelRequire("3dJ4i");
var $4108b90c0fa9874d$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $4108b90c0fa9874d$var$smallStyles = (0, $3dJ4i.css)((0, $blylh.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $4108b90c0fa9874d$var$mediumStyles = (0, $3dJ4i.css)((0, $blylh.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $4108b90c0fa9874d$var$largeStyles = (0, $3dJ4i.css)((0, $blylh.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $4108b90c0fa9874d$var$xlargeStyles = (0, $3dJ4i.css)((0, $blylh.dimensions).xlarge);
var $4108b90c0fa9874d$export$ef0ad74202575b64 = {
    small: $4108b90c0fa9874d$var$smallStyles,
    medium: $4108b90c0fa9874d$var$mediumStyles,
    large: $4108b90c0fa9874d$var$largeStyles,
    xlarge: $4108b90c0fa9874d$var$xlargeStyles
};
var $4108b90c0fa9874d$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $blylh.dimensions)[size];
    return undefined;
};

});
parcelRegister("blylh", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $842c4b82b3f65392$export$62ad7b0c781000e9; });
var $842c4b82b3f65392$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $842c4b82b3f65392$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $842c4b82b3f65392$export$62ad7b0c781000e9 = {
    small: {
        width: $842c4b82b3f65392$export$c647cb0ee6e282fe.small,
        height: $842c4b82b3f65392$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $842c4b82b3f65392$export$c647cb0ee6e282fe.medium,
        height: $842c4b82b3f65392$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $842c4b82b3f65392$export$c647cb0ee6e282fe.large,
        height: $842c4b82b3f65392$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $842c4b82b3f65392$export$c647cb0ee6e282fe.xlarge,
        height: $842c4b82b3f65392$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("i01we", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $d1a967b8828781bc$export$18cb9425622d4e06; });
var $d1a967b8828781bc$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("dHs14", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f9505f3e918a89d$var$_react = $9f9505f3e918a89d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9f9505f3e918a89d$var$_UNSAFE_baseNew = $9f9505f3e918a89d$var$_interopRequireDefault((parcelRequire("4RT1x")));
function $9f9505f3e918a89d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f9505f3e918a89d$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $9f9505f3e918a89d$var$_react.default.createElement($9f9505f3e918a89d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$9f9505f3e918a89d$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $9f9505f3e918a89d$var$_default = module.exports.default = $9f9505f3e918a89d$var$ChevronLeftIcon;

});
parcelRegister("4RT1x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("eQM13")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("eQM13")).Icon; });

var $eQM13 = parcelRequire("eQM13");

});
parcelRegister("eQM13", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $acfb2b02e77b51ed$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $acfb2b02e77b51ed$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $3zKGK = parcelRequire("3zKGK");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $acfb2b02e77b51ed$var$commonSVGStyles = (0, $3dJ4i.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $acfb2b02e77b51ed$var$svgStyles = (0, $3dJ4i.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $acfb2b02e77b51ed$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $acfb2b02e77b51ed$var$utilityIconStyles = (0, $3dJ4i.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $acfb2b02e77b51ed$var$scaleStyles = (0, $3dJ4i.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $acfb2b02e77b51ed$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $acfb2b02e77b51ed$var$scaleSize = (0, $3dJ4i.css)({
    width: 'inherit',
    height: 'inherit'
});
var $acfb2b02e77b51ed$var$sizeMap = {
    core: {
        none: (0, $3dJ4i.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $3dJ4i.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $3dJ4i.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $3dJ4i.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $3dJ4i.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $acfb2b02e77b51ed$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $acfb2b02e77b51ed$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $acfb2b02e77b51ed$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $3zKGK.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $3dJ4i.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $acfb2b02e77b51ed$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $acfb2b02e77b51ed$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $acfb2b02e77b51ed$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $3dJ4i.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $acfb2b02e77b51ed$var$iconStyles,
            $acfb2b02e77b51ed$var$baseHcmStyles,
            shouldScale && $acfb2b02e77b51ed$var$scaleStyles,
            props.type === 'utility' && $acfb2b02e77b51ed$var$utilityIconStyles
        ]
    }, (0, $3dJ4i.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $acfb2b02e77b51ed$var$commonSVGStyles,
            $acfb2b02e77b51ed$var$svgStyles,
            shouldScale ? $acfb2b02e77b51ed$var$scaleSize : props.type === 'utility' ? $acfb2b02e77b51ed$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $acfb2b02e77b51ed$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $acfb2b02e77b51ed$export$2e2bcd8739ae039 = $acfb2b02e77b51ed$export$f04a61298a47a40f;

});




parcelRegister("5xsYy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $408682cb9622661e$var$_react = $408682cb9622661e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2z5sZ = parcelRequire("2z5sZ");

var $408682cb9622661e$var$_chevronRight = $408682cb9622661e$var$_interopRequireDefault((parcelRequire("5OM3I")));
function $408682cb9622661e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $408682cb9622661e$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $408682cb9622661e$var$_react.default.createElement($2z5sZ.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $408682cb9622661e$var$_chevronRight.default,
        iconType: "utility"
    }));
$408682cb9622661e$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $408682cb9622661e$var$_default = module.exports.default = $408682cb9622661e$var$ChevronRightLargeIcon;

});
parcelRegister("5OM3I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9bfbdf898b5516a0a7c630d609b6042>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43c6e6bf961727cc$var$_react = $43c6e6bf961727cc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $43c6e6bf961727cc$var$_UNSAFE_baseNew = $43c6e6bf961727cc$var$_interopRequireDefault((parcelRequire("4RT1x")));
function $43c6e6bf961727cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43c6e6bf961727cc$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $43c6e6bf961727cc$var$_react.default.createElement($43c6e6bf961727cc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
        type: 'utility'
    }, props));
$43c6e6bf961727cc$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $43c6e6bf961727cc$var$_default = module.exports.default = $43c6e6bf961727cc$var$ChevronRightIcon;

});


parcelRegister("k4A03", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9d01b3750ba11ce$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $53rTZ = parcelRequire("53rTZ");

var $9KKSt = parcelRequire("9KKSt");
var $e9d01b3750ba11ce$var$flexGrowMap = {
    hug: (0, $53rTZ.xcss)({
        flexGrow: 0
    }),
    fill: (0, $53rTZ.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $e9d01b3750ba11ce$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $e9d01b3750ba11ce$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $e9d01b3750ba11ce$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $e9d01b3750ba11ce$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($e9d01b3750ba11ce$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $e9d01b3750ba11ce$var$flexGrowMap[grow]
    ].concat((0, $lFOXD.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3dJ4i.jsx)((0, $9KKSt.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$e9d01b3750ba11ce$var$Inline.displayName = 'Inline';
var $e9d01b3750ba11ce$export$2e2bcd8739ae039 = $e9d01b3750ba11ce$var$Inline;

});

parcelRegister("7pQpP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $566386d6be25d43e$export$2e2bcd8739ae039; });

var $6JmtO = parcelRequire("6JmtO");
function $566386d6be25d43e$export$2e2bcd8739ae039(prefix) {
    var seed = (0, $6JmtO.useUIDSeed)();
    return "".concat(prefix, "-").concat(seed(prefix));
}

});


parcelRegister("fcCt7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b115d10e54c41f42$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $23fRn = parcelRequire("23fRn");

var $aZaKa = parcelRequire("aZaKa");

var $6XdeN = parcelRequire("6XdeN");
var $b115d10e54c41f42$var$WeekDays = /*#__PURE__*/ (0, $1oC0p.memo)(function WeekDays(_ref) {
    var weeks = _ref.weeks, handleClickDay = _ref.handleClickDay, monthsLong = _ref.monthsLong, shouldSetFocus = _ref.shouldSetFocus, tabIndex = _ref.tabIndex, testId = _ref.testId;
    return (0, $3dJ4i.jsx)((0, $23fRn.default), {
        role: "rowgroup",
        testId: testId && "".concat(testId, "--month")
    }, weeks.map(function(week, i) {
        return (0, $3dJ4i.jsx)((0, $6XdeN.default), {
            key: i,
            testId: testId && "".concat(testId, "--week")
        }, week.values.map(function(weekDay) {
            return (0, $3dJ4i.jsx)((0, $aZaKa.default), {
                key: "".concat(week.id, "-").concat(weekDay.id),
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day);
        }));
    }));
});
$b115d10e54c41f42$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b115d10e54c41f42$export$2e2bcd8739ae039 = $b115d10e54c41f42$var$WeekDays;

});
parcelRegister("aZaKa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7ff7ef5db108d041$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $duw73 = parcelRequire("duw73");

var $aPiMC = parcelRequire("aPiMC");

var $7HPDS = parcelRequire("7HPDS");
var $7ff7ef5db108d041$var$Date = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Date(_ref2, _ref) {
    var day = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isFocused = _ref2.isFocused, isFocused = _ref2$isFocused === void 0 ? false : _ref2$isFocused, _ref2$isToday = _ref2.isToday, isToday = _ref2$isToday === void 0 ? false : _ref2$isToday, dayLong = _ref2.dayLong, month = _ref2.month, monthLong = _ref2.monthLong, _ref2$onClick = _ref2.onClick, onClick = _ref2$onClick === void 0 ? (0, $duw73.default) : _ref2$onClick, _ref2$isPreviouslySel = _ref2.isPreviouslySelected, isPreviouslySelected = _ref2$isPreviouslySel === void 0 ? false : _ref2$isPreviouslySel, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$isSibling = _ref2.isSibling, isSibling = _ref2$isSibling === void 0 ? false : _ref2$isSibling, year = _ref2.year, shouldSetFocus = _ref2.shouldSetFocus, tabIndex = _ref2.tabIndex, testId = _ref2.testId;
    var dateRef = (0, $1oC0p.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $1oC0p.useEffect)(function() {
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    var focusRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    var handleClick = (0, $1oC0p.useCallback)(function() {
        var _dateRef$current = dateRef.current, dayValue = _dateRef$current.day, monthValue = _dateRef$current.month, yearValue = _dateRef$current.year, isDisabledValue = _dateRef$current.isDisabled;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var dateCellStyles = (0, $3dJ4i.css)((0, $7HPDS.dateCellStyles)());
    return (0, $3dJ4i.jsx)((0, $aPiMC.default), {
        role: "gridcell",
        alignItems: "center"
    }, (0, $3dJ4i.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": "".concat(day, ", ").concat(dayLong, " ").concat(monthLong, " ").concat(year),
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? "".concat(testId, "--selected-day") : "".concat(testId, "--day"))
    }, day));
}));
$7ff7ef5db108d041$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7ff7ef5db108d041$export$2e2bcd8739ae039 = $7ff7ef5db108d041$var$Date;

});
parcelRegister("aPiMC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7e1d3cc4636a3091$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $bcm6Z = parcelRequire("bcm6Z");

var $53rTZ = parcelRequire("53rTZ");
var $7e1d3cc4636a3091$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
var $7e1d3cc4636a3091$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
var $7e1d3cc4636a3091$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
var $7e1d3cc4636a3091$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $7e1d3cc4636a3091$var$justifyItemsMap = {
    start: (0, $3dJ4i.css)({
        justifyItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyItems: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyItems: 'stretch'
    })
};
var $7e1d3cc4636a3091$var$alignContentMap = {
    start: (0, $3dJ4i.css)({
        alignContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        alignContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        alignContent: 'stretch'
    })
};
var $7e1d3cc4636a3091$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    })
};
var $7e1d3cc4636a3091$var$baseStyles = (0, $3dJ4i.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: "var(".concat($7e1d3cc4636a3091$var$gridTemplateAreasVar, ")"),
    gridTemplateColumns: "var(".concat($7e1d3cc4636a3091$var$gridTemplateColumnsVar, ")"),
    gridTemplateRows: "var(".concat($7e1d3cc4636a3091$var$gridTemplateRowsVar, ")")
});
var $7e1d3cc4636a3091$var$gridAutoFlowMap = {
    row: (0, $3dJ4i.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, $3dJ4i.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $3dJ4i.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $3dJ4i.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $3dJ4i.css)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $7e1d3cc4636a3091$var$Grid = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || 'div';
    var resolvedStyles = (0, $53rTZ.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ var style = (0, $1oC0p.useMemo)(function() {
        var _ref2;
        return _ref2 = {}, (0, $f53LC.default)(_ref2, $7e1d3cc4636a3091$var$gridTemplateAreasVar, gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return "\"".concat(str, "\"");
        }).join('\n') || 'initial' : 'initial'), (0, $f53LC.default)(_ref2, $7e1d3cc4636a3091$var$gridTemplateColumnsVar, gridTemplateColumns || 'initial'), (0, $f53LC.default)(_ref2, $7e1d3cc4636a3091$var$gridTemplateRowsVar, gridTemplateRows || 'initial'), _ref2;
    }, [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $7e1d3cc4636a3091$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $bcm6Z.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $bcm6Z.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $bcm6Z.spaceStylesMap).rowGap[rowGap],
            alignItems && $7e1d3cc4636a3091$var$alignItemsMap[alignItems],
            alignContent && $7e1d3cc4636a3091$var$alignContentMap[alignContent],
            justifyContent && $7e1d3cc4636a3091$var$justifyContentMap[justifyContent],
            autoFlow && $7e1d3cc4636a3091$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$7e1d3cc4636a3091$var$Grid.displayName = 'Grid';
var $7e1d3cc4636a3091$export$2e2bcd8739ae039 = $7e1d3cc4636a3091$var$Grid;

});

parcelRegister("7HPDS", function(module, exports) {
$parcel$export(module.exports, "dateCellStyles", function () { return $59c49b9acb05046d$export$f62807af68630d86; });
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $7xbVq = parcelRequire("7xbVq");
var $59c49b9acb05046d$export$f62807af68630d86 = function dateCellStyles() {
    return {
        all: 'unset',
        display: 'block',
        padding: "var(--ds-space-050, 4px)".concat(" 9px"),
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: "var(--ds-text, ".concat((0, $7xbVq.N900), ")"),
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: "var(--ds-text-subtlest, ".concat((0, $7xbVq.N200), ")")
        },
        '&[data-today]': {
            color: "var(--ds-text-selected, ".concat((0, $7xbVq.B400), ")"),
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: "var(--ds-background-selected, ".concat((0, $7xbVq.B50), ")"),
            color: "var(--ds-text-subtle, ".concat((0, $7xbVq.N600), ")")
        },
        '&[data-selected]': {
            backgroundColor: "var(--ds-background-selected, ".concat((0, $7xbVq.N500), ")"),
            color: "var(--ds-text-selected, ".concat((0, $7xbVq.N0), ")")
        },
        '&[data-disabled]': {
            color: "var(--ds-text-disabled, ".concat((0, $7xbVq.N40), ")"),
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: "2px solid ".concat("var(--ds-border-focused, ".concat((0, $7xbVq.B200), ")"))
        },
        '&:hover': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $7xbVq.N30), ")"),
            color: "var(--ds-text, ".concat((0, $7xbVq.N900), ")")
        },
        '&:active': {
            backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $7xbVq.B50), ")"),
            color: "var(--ds-text, ".concat((0, $7xbVq.N900), ")")
        },
        '&[data-selected]:hover': {
            backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $7xbVq.B50), ")"),
            color: "var(--ds-text-selected, ".concat((0, $7xbVq.N600), ")")
        },
        '&[data-prev-selected]:hover': {
            color: "var(--ds-text-subtle, ".concat((0, $7xbVq.N600), ")")
        },
        '&[data-sibling]:hover': {
            color: "var(--ds-text-subtlest, ".concat((0, $7xbVq.N200), ")")
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: "var(--ds-text-disabled, ".concat((0, $7xbVq.N40), ")")
        }
    };
};

});
parcelRegister("7xbVq", function(module, exports) {
$parcel$export(module.exports, "B50", function () { return $57c4dd8dc4ab4bc8$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $57c4dd8dc4ab4bc8$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $57c4dd8dc4ab4bc8$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $57c4dd8dc4ab4bc8$export$29a4f05edc054374; });
$parcel$export(module.exports, "N30", function () { return $57c4dd8dc4ab4bc8$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $57c4dd8dc4ab4bc8$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N200", function () { return $57c4dd8dc4ab4bc8$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N500", function () { return $57c4dd8dc4ab4bc8$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $57c4dd8dc4ab4bc8$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N900", function () { return $57c4dd8dc4ab4bc8$export$fbda843f0a27fe96; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $57c4dd8dc4ab4bc8$export$4b84fd0e2c617bd = '#FFEBE6';
var $57c4dd8dc4ab4bc8$export$b34b069eff244586 = '#FFBDAD';
var $57c4dd8dc4ab4bc8$export$be802dd0d8b57f35 = '#FF8F73';
var $57c4dd8dc4ab4bc8$export$60847d42f9da92a6 = '#FF7452';
var $57c4dd8dc4ab4bc8$export$4a7404f376229999 = '#FF5630';
var $57c4dd8dc4ab4bc8$export$2010d0fb4295b346 = '#DE350B';
var $57c4dd8dc4ab4bc8$export$2837b5a1a71d5c02 = '#BF2600';
var $57c4dd8dc4ab4bc8$export$8d9596b529bbb9cf = '#FFFAE6';
var $57c4dd8dc4ab4bc8$export$41060a744ab0b7ae = '#FFF0B3';
var $57c4dd8dc4ab4bc8$export$1cc05bbbf340e559 = '#FFE380';
var $57c4dd8dc4ab4bc8$export$5aae31392d72caaa = '#FFC400';
var $57c4dd8dc4ab4bc8$export$c6930421db9fa514 = '#FFAB00';
var $57c4dd8dc4ab4bc8$export$59619663aa6500fb = '#FF991F';
var $57c4dd8dc4ab4bc8$export$874739ea9e379ab6 = '#FF8B00';
var $57c4dd8dc4ab4bc8$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $57c4dd8dc4ab4bc8$export$69a3bf21b9686c2b = '#ABF5D1';
var $57c4dd8dc4ab4bc8$export$afbce1382ec95f73 = '#79F2C0';
var $57c4dd8dc4ab4bc8$export$747d86715d4175de = '#57D9A3';
var $57c4dd8dc4ab4bc8$export$940e1f69e873f202 = '#36B37E';
var $57c4dd8dc4ab4bc8$export$a49394138f7b8e85 = '#00875A';
var $57c4dd8dc4ab4bc8$export$6fa04827ac68a4fb = '#006644';
var $57c4dd8dc4ab4bc8$export$226de0355ed012f8 = '#DEEBFF';
var $57c4dd8dc4ab4bc8$export$8c13c2ee36917869 = '#B3D4FF';
var $57c4dd8dc4ab4bc8$export$ecfc1dff386a3e7a = '#4C9AFF';
var $57c4dd8dc4ab4bc8$export$215b7063051591f1 = '#2684FF';
var $57c4dd8dc4ab4bc8$export$e62e8919cca44969 = '#0065FF';
var $57c4dd8dc4ab4bc8$export$b3de0ae08da2ce64 = '#0052CC';
var $57c4dd8dc4ab4bc8$export$a6ee3d71bc067634 = '#0747A6';
var $57c4dd8dc4ab4bc8$export$363e4475840015bb = '#EAE6FF';
var $57c4dd8dc4ab4bc8$export$4b0a4417ed59760f = '#C0B6F2';
var $57c4dd8dc4ab4bc8$export$6011520a64d9a187 = '#998DD9';
var $57c4dd8dc4ab4bc8$export$a7175d4e9206bc80 = '#8777D9';
var $57c4dd8dc4ab4bc8$export$b48405b95304b5a1 = '#6554C0';
var $57c4dd8dc4ab4bc8$export$c71e4279dd54a18d = '#5243AA';
var $57c4dd8dc4ab4bc8$export$147899de772240ec = '#403294';
var $57c4dd8dc4ab4bc8$export$2cf711fe14c66f06 = '#E6FCFF';
var $57c4dd8dc4ab4bc8$export$7a8f4d33f6f9772c = '#B3F5FF';
var $57c4dd8dc4ab4bc8$export$776c9c497ef08533 = '#79E2F2';
var $57c4dd8dc4ab4bc8$export$69cb3ca10c1e330e = '#00C7E6';
var $57c4dd8dc4ab4bc8$export$9dc1ef0f3f48059b = '#00B8D9';
var $57c4dd8dc4ab4bc8$export$7c835c78b6fcdef8 = '#00A3BF';
var $57c4dd8dc4ab4bc8$export$6036577f95c3877e = '#008DA6';
var $57c4dd8dc4ab4bc8$export$29a4f05edc054374 = '#FFFFFF';
var $57c4dd8dc4ab4bc8$export$e655ef011c4aa1a2 = '#FAFBFC';
var $57c4dd8dc4ab4bc8$export$9fdfb749e33cdf97 = '#F4F5F7';
var $57c4dd8dc4ab4bc8$export$3e51e8f1440314ba = '#EBECF0';
var $57c4dd8dc4ab4bc8$export$1ce2d1575d444ceb = '#DFE1E6';
var $57c4dd8dc4ab4bc8$export$8754fc7e6d8b3000 = '#C1C7D0';
var $57c4dd8dc4ab4bc8$export$c2e91cbeada39b8b = '#B3BAC5';
var $57c4dd8dc4ab4bc8$export$5f71e19f3a7ad9de = '#A5ADBA';
var $57c4dd8dc4ab4bc8$export$eaa8c8a70ac22806 = '#97A0AF';
var $57c4dd8dc4ab4bc8$export$7c87d337fb91a97d = '#8993A4';
var $57c4dd8dc4ab4bc8$export$d6447c357493214f = '#7A869A';
var $57c4dd8dc4ab4bc8$export$f563ee71e9ee74cd = '#6B778C';
var $57c4dd8dc4ab4bc8$export$e2ef2124cf4024b1 = '#5E6C84';
var $57c4dd8dc4ab4bc8$export$eece5f492e429f08 = '#505F79';
var $57c4dd8dc4ab4bc8$export$c39c0fe0f26207ae = '#42526E';
var $57c4dd8dc4ab4bc8$export$7090862dc3038a9f = '#344563';
var $57c4dd8dc4ab4bc8$export$ad0bacf983b7ddaa = '#253858';
var $57c4dd8dc4ab4bc8$export$7d61b15e0da132af = '#172B4D';
var $57c4dd8dc4ab4bc8$export$fbda843f0a27fe96 = '#091E42';
var $57c4dd8dc4ab4bc8$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $57c4dd8dc4ab4bc8$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $57c4dd8dc4ab4bc8$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $57c4dd8dc4ab4bc8$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $57c4dd8dc4ab4bc8$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $57c4dd8dc4ab4bc8$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $57c4dd8dc4ab4bc8$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $57c4dd8dc4ab4bc8$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $57c4dd8dc4ab4bc8$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $57c4dd8dc4ab4bc8$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $57c4dd8dc4ab4bc8$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $57c4dd8dc4ab4bc8$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $57c4dd8dc4ab4bc8$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $57c4dd8dc4ab4bc8$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $57c4dd8dc4ab4bc8$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $57c4dd8dc4ab4bc8$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $57c4dd8dc4ab4bc8$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $57c4dd8dc4ab4bc8$export$2f6319cf7d736c2a = '#E6EDFA';
var $57c4dd8dc4ab4bc8$export$95126bc8884d6634 = '#DCE5F5';
var $57c4dd8dc4ab4bc8$export$8338d8c35d44ff1 = '#CED9EB';
var $57c4dd8dc4ab4bc8$export$5368d76ae4fbbda7 = '#B8C7E0';
var $57c4dd8dc4ab4bc8$export$9f0a771d16ec8d36 = '#ABBBD6';
var $57c4dd8dc4ab4bc8$export$abcf8c38338b4aa5 = '#9FB0CC';
var $57c4dd8dc4ab4bc8$export$97e81faa16a182c7 = '#8C9CB8';
var $57c4dd8dc4ab4bc8$export$bfe21c59123ecf33 = '#7988A3';
var $57c4dd8dc4ab4bc8$export$ee82aa2ea6a1558 = '#67758F';
var $57c4dd8dc4ab4bc8$export$682927c6ed76be02 = '#56637A';
var $57c4dd8dc4ab4bc8$export$91fd9994c5be9757 = '#455166';
var $57c4dd8dc4ab4bc8$export$d281fbfe3cff2df6 = '#3B475C';
var $57c4dd8dc4ab4bc8$export$3902c91d8b98a753 = '#313D52';
var $57c4dd8dc4ab4bc8$export$8e8133c1ba5845b5 = '#283447';
var $57c4dd8dc4ab4bc8$export$33ff357f6620b39 = '#202B3D';
var $57c4dd8dc4ab4bc8$export$633847cf062b69e0 = '#1B2638';
var $57c4dd8dc4ab4bc8$export$9776a6e503bdbf76 = '#121A29';
var $57c4dd8dc4ab4bc8$export$6c813d5160dff5db = '#0E1624';
var $57c4dd8dc4ab4bc8$export$3d4f271a500072a = '#0D1424';
var $57c4dd8dc4ab4bc8$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $57c4dd8dc4ab4bc8$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $57c4dd8dc4ab4bc8$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $57c4dd8dc4ab4bc8$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $57c4dd8dc4ab4bc8$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $57c4dd8dc4ab4bc8$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $57c4dd8dc4ab4bc8$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $57c4dd8dc4ab4bc8$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $57c4dd8dc4ab4bc8$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $57c4dd8dc4ab4bc8$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $57c4dd8dc4ab4bc8$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $57c4dd8dc4ab4bc8$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $57c4dd8dc4ab4bc8$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $57c4dd8dc4ab4bc8$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $57c4dd8dc4ab4bc8$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $57c4dd8dc4ab4bc8$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $57c4dd8dc4ab4bc8$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

});



parcelRegister("6XdeN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5102857c1fc29a94$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3dJ4i = parcelRequire("3dJ4i");

var $aPiMC = parcelRequire("aPiMC");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ var $5102857c1fc29a94$var$WeekDayGrid = function WeekDayGrid(_ref) {
    var testId = _ref.testId, children = _ref.children, isHidden = _ref.isHidden;
    var row = (0, $3dJ4i.jsx)((0, $aPiMC.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? (0, $3dJ4i.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $5102857c1fc29a94$export$2e2bcd8739ae039 = $5102857c1fc29a94$var$WeekDayGrid;

});


parcelRegister("dCGhl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9eaf9ea63b1805c5$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $23fRn = parcelRequire("23fRn");
var $b4Iyq = parcelRequire("b4Iyq");
var $53rTZ = parcelRequire("53rTZ");

var $6XdeN = parcelRequire("6XdeN");
var $9eaf9ea63b1805c5$var$columnHeaderStyles = (0, $53rTZ.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
var $9eaf9ea63b1805c5$var$WeekHeader = /*#__PURE__*/ (0, $1oC0p.memo)(function WeekHeader(_ref) {
    var daysShort = _ref.daysShort, testId = _ref.testId;
    return (0, $3dJ4i.jsx)((0, $6XdeN.default), {
        isHidden: true,
        testId: testId && "".concat(testId, "--column-headers")
    }, daysShort.map(function(shortDay) {
        return (0, $3dJ4i.jsx)((0, $23fRn.default), {
            padding: "space.100",
            xcss: $9eaf9ea63b1805c5$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && "".concat(testId, "--column-header")
        }, (0, $3dJ4i.jsx)((0, $b4Iyq.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay));
    }));
});
$9eaf9ea63b1805c5$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9eaf9ea63b1805c5$export$2e2bcd8739ae039 = $9eaf9ea63b1805c5$var$WeekHeader;

});
parcelRegister("b4Iyq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8102a0fb7fdbf76c$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $lmxXn = parcelRequire("lmxXn");

var $bcm6Z = parcelRequire("bcm6Z");

var $h3spv = parcelRequire("h3spv");
var $8102a0fb7fdbf76c$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $8102a0fb7fdbf76c$var$resetStyles = (0, $3dJ4i.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $8102a0fb7fdbf76c$var$strongStyles = (0, $3dJ4i.css)({
    fontWeight: 'bold'
});
var $8102a0fb7fdbf76c$var$emStyles = (0, $3dJ4i.css)({
    fontStyle: 'italic'
});
var $8102a0fb7fdbf76c$var$textAlignMap = {
    center: (0, $3dJ4i.css)({
        textAlign: 'center'
    }),
    end: (0, $3dJ4i.css)({
        textAlign: 'end'
    }),
    start: (0, $3dJ4i.css)({
        textAlign: 'start'
    })
};
var $8102a0fb7fdbf76c$var$truncationStyles = (0, $3dJ4i.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $8102a0fb7fdbf76c$var$wordBreakMap = {
    breakAll: (0, $3dJ4i.css)({
        wordBreak: 'break-all'
    })
};
var $8102a0fb7fdbf76c$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $8102a0fb7fdbf76c$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($8102a0fb7fdbf76c$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $8102a0fb7fdbf76c$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $h3spv.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $bcm6Z.inverseColorMap).hasOwnProperty(surface)) return (0, $bcm6Z.inverseColorMap)[surface];
    if (colorProp === 'inherit') return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $8102a0fb7fdbf76c$var$Text = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $lmxXn.default)($8102a0fb7fdbf76c$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = $8102a0fb7fdbf76c$var$useHasTextAncestor();
    var color = $8102a0fb7fdbf76c$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $3dJ4i.jsx)(Component, {
        ref: ref,
        css: [
            $8102a0fb7fdbf76c$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bcm6Z.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $bcm6Z.textColorStylesMap)[color],
            maxLines && $8102a0fb7fdbf76c$var$truncationStyles,
            maxLines === 1 && $8102a0fb7fdbf76c$var$wordBreakMap.breakAll,
            align && $8102a0fb7fdbf76c$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $bcm6Z.textWeightStylesMap)[weight],
            Component === 'em' && $8102a0fb7fdbf76c$var$emStyles,
            Component === 'strong' && $8102a0fb7fdbf76c$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $3dJ4i.jsx)($8102a0fb7fdbf76c$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $8102a0fb7fdbf76c$export$2e2bcd8739ae039 = $8102a0fb7fdbf76c$var$Text;

});


parcelRegister("7I2le", function(module, exports) {
$parcel$export(module.exports, "arrowKeys", function () { return $59ce75675a9c41c2$export$8b15eca9c6d5c48a; });
$parcel$export(module.exports, "daysPerWeek", function () { return $59ce75675a9c41c2$export$3ae905d9742bef55; });
$parcel$export(module.exports, "monthsPerYear", function () { return $59ce75675a9c41c2$export$c9b7c010035d60c6; });
$parcel$export(module.exports, "blankStringArray", function () { return $59ce75675a9c41c2$export$8fa20d70624f8b9d; });
var $59ce75675a9c41c2$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
var $59ce75675a9c41c2$export$3ae905d9742bef55 = 7;
var $59ce75675a9c41c2$export$c9b7c010035d60c6 = 12;
var $59ce75675a9c41c2$export$8fa20d70624f8b9d = [];

});

parcelRegister("8IOH3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6599c16feec0a9b2$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $6599c16feec0a9b2$export$2e2bcd8739ae039(calendarRef, _ref) {
    var navigate = _ref.navigate;
    (0, $1oC0p.useImperativeHandle)(calendarRef, function() {
        return {
            navigate: navigate
        };
    }, [
        navigate
    ]);
}

});

parcelRegister("62qHZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4657a5bd6b2293c7$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $z0w18 = parcelRequire("z0w18");

var $8q1hX = parcelRequire("8q1hX");

var $dIpkX = parcelRequire("dIpkX");
function $4657a5bd6b2293c7$export$2e2bcd8739ae039(_ref) {
    var day = _ref.day, defaultDay = _ref.defaultDay, month = _ref.month, defaultMonth = _ref.defaultMonth, year = _ref.year, defaultYear = _ref.defaultYear, today = _ref.today, selected = _ref.selected, defaultSelected = _ref.defaultSelected, previouslySelected = _ref.previouslySelected, defaultPreviouslySelected = _ref.defaultPreviouslySelected;
    var _useLazyRef = (0, $8q1hX.default)(function() {
        var now = new Date();
        var thisDay = now.getDate();
        var thisMonth = now.getMonth() + 1;
        var thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    }), _useLazyRef$current = _useLazyRef.current, thisDay = _useLazyRef$current.thisDay, thisMonth = _useLazyRef$current.thisMonth, thisYear = _useLazyRef$current.thisYear;
    var _useControlled = (0, $z0w18.default)(day, function() {
        return defaultDay || thisDay;
    }), _useControlled2 = (0, $2qaZZ.default)(_useControlled, 2), dayValue = _useControlled2[0], setDayValue = _useControlled2[1];
    var _useControlled3 = (0, $z0w18.default)(month, function() {
        return defaultMonth || thisMonth;
    }), _useControlled4 = (0, $2qaZZ.default)(_useControlled3, 2), monthValue = _useControlled4[0], setMonthValue = _useControlled4[1];
    var _useControlled5 = (0, $z0w18.default)(year, function() {
        return defaultYear || thisYear;
    }), _useControlled6 = (0, $2qaZZ.default)(_useControlled5, 2), yearValue = _useControlled6[0], setYearValue = _useControlled6[1];
    var _useControlled7 = (0, $z0w18.default)(today, function() {
        return today || "".concat(thisYear, "-").concat((0, $dIpkX.default)(thisMonth), "-").concat((0, $dIpkX.default)(thisDay));
    }), _useControlled8 = (0, $2qaZZ.default)(_useControlled7, 1), todayValue = _useControlled8[0];
    var _useControlled9 = (0, $z0w18.default)(selected, function() {
        return defaultSelected;
    }), _useControlled10 = (0, $2qaZZ.default)(_useControlled9, 2), selectedValue = _useControlled10[0], setSelectedValue = _useControlled10[1];
    var _useControlled11 = (0, $z0w18.default)(previouslySelected, function() {
        return defaultPreviouslySelected;
    }), _useControlled12 = (0, $2qaZZ.default)(_useControlled11, 2), previouslySelectedValue = _useControlled12[0], setPreviouslySelectedValue = _useControlled12[1];
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("z0w18", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0693ab594b1851d4$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $0693ab594b1851d4$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $1oC0p.useState)(getDefaultPropValue), _useState2 = (0, $2qaZZ.default)(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $1oC0p.useRef)(isControlled);
    (0, $1oC0p.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $1oC0p.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("8q1hX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6211c053fd458ec4$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $6211c053fd458ec4$var$uniqueReferencedValue = {};
function $6211c053fd458ec4$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $1oC0p.useRef)($6211c053fd458ec4$var$uniqueReferencedValue);
    if (ref.current === $6211c053fd458ec4$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});

parcelRegister("dIpkX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9fc309d6c1077a1b$export$2e2bcd8739ae039; });
function $9fc309d6c1077a1b$export$2e2bcd8739ae039(num) {
    return num < 10 ? "0".concat(num) : "".concat(num);
}

});


parcelRegister("14H52", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0c879506cdef79cf$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $0c879506cdef79cf$export$2e2bcd8739ae039(_ref) {
    var onBlur = _ref.onBlur, onFocus = _ref.onFocus;
    var handleContainerBlur = (0, $1oC0p.useCallback)(function(event) {
        onBlur(event);
    }, [
        onBlur
    ]);
    var handleContainerFocus = (0, $1oC0p.useCallback)(function(event) {
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("7fRLv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5483a3c9d40ed7c7$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $gw7QQ = parcelRequire("gw7QQ");

var $7I2le = parcelRequire("7I2le");

var $6FO2b = parcelRequire("6FO2b");

var $aaMYH = parcelRequire("aaMYH");
function $5483a3c9d40ed7c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5483a3c9d40ed7c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5483a3c9d40ed7c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5483a3c9d40ed7c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5483a3c9d40ed7c7$var$useGetCalendarWithSixthWeek(calendar, _ref) {
    var month = _ref.month, year = _ref.year, weekStartDay = _ref.weekStartDay;
    var shouldDisplaySixthWeek = calendar.length % 6;
    var calendarLastValue = calendar[calendar.length - 1];
    return (0, $1oC0p.useMemo)(function() {
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            var lastDayIsSibling = calendarLastValue.siblingMonth;
            var sliceStart = lastDayIsSibling ? (0, $7I2le.daysPerWeek) : 0;
            return (0, $aaMYH.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $7I2le.daysPerWeek)).map(function(date) {
                return $5483a3c9d40ed7c7$var$_objectSpread($5483a3c9d40ed7c7$var$_objectSpread({}, date), {}, {
                    siblingMonth: true
                });
            });
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $5483a3c9d40ed7c7$export$2e2bcd8739ae039(_ref2) {
    var day = _ref2.day, daysLong = _ref2.daysLong, month = _ref2.month, year = _ref2.year, today = _ref2.today, disabled = _ref2.disabled, disabledDateFilter = _ref2.disabledDateFilter, minDateString = _ref2.minDate, maxDateString = _ref2.maxDate, selected = _ref2.selected, previouslySelected = _ref2.previouslySelected, weekStartDay = _ref2.weekStartDay;
    var calendar = (0, $1oC0p.useMemo)(function() {
        return (0, $aaMYH.default)(year, month - 1, {
            weekStartDay: weekStartDay
        });
    }, [
        month,
        weekStartDay,
        year
    ]);
    var calendarWithSixthWeek = $5483a3c9d40ed7c7$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push.apply(calendar, (0, $lFOXD.default)(calendarWithSixthWeek));
    var minDate = minDateString ? (0, $gw7QQ.default)(minDateString) : undefined;
    var maxDate = maxDateString ? (0, $gw7QQ.default)(maxDateString) : undefined;
    var needJsDate = minDateString || maxDateString;
    return (0, $1oC0p.useMemo)(function() {
        var weeks = [];
        calendar.forEach(function(date) {
            var dateAsString = (0, $6FO2b.default)(date, {
                fixMonth: true
            });
            var JSDate = needJsDate ? (0, $gw7QQ.default)(dateAsString) : undefined;
            var week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            var weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            var weekDayName = daysLong[weekDayOffset];
            var isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            var isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            var isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            var isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            var isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            var isFocused = day === date.day && !date.siblingMonth;
            var isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            var isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            var isSiblingMonth = !!date.siblingMonth;
            var isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6FO2b", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4dbd622672c10016$export$2e2bcd8739ae039; });

var $dIpkX = parcelRequire("dIpkX");
function $4dbd622672c10016$export$2e2bcd8739ae039(date, options) {
    return "".concat(date.year, "-").concat((0, $dIpkX.default)(date.month + (options && options.fixMonth ? 1 : 0)), "-").concat((0, $dIpkX.default)(date.day));
}

});

parcelRegister("aaMYH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7680d48c20bf760d$export$2e2bcd8739ae039; });
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $7I2le = parcelRequire("7I2le");

var $6v3DB = parcelRequire("6v3DB");
function $7680d48c20bf760d$export$2e2bcd8739ae039(year, month) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        weekStartDay: 0
    }, _ref$weekStartDay = _ref.weekStartDay, weekStartDay = _ref$weekStartDay === void 0 ? 0 : _ref$weekStartDay;
    var date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    var utcYear = date.getUTCFullYear();
    var utcMonth = date.getUTCMonth();
    var calendar = [];
    var firstDay = date.getUTCDay();
    var firstDate = -(((0, $7I2le.daysPerWeek) - weekStartDay + firstDay) % (0, $7I2le.daysPerWeek));
    var lastDate = (0, $6v3DB.default)(utcYear, utcMonth);
    var lastDay = (lastDate - firstDate) % (0, $7I2le.daysPerWeek);
    var lastDateOfPreviousMonth = (0, $6v3DB.default)(utcYear, utcMonth - 1);
    var dateCounter = firstDate;
    var currentDay;
    var currentDate;
    var currentDateObject = null;
    var calculatedMonth;
    var calculatedYear;
    var maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $7I2le.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $7I2le.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $7I2le.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $7I2le.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $7I2le.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("6v3DB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4bb875b86ed04a60$export$2e2bcd8739ae039; });
function $4bb875b86ed04a60$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("7fNdx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $54801ca29719ab21$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $7I2le = parcelRequire("7I2le");

var $6FO2b = parcelRequire("6FO2b");

var $6v3DB = parcelRequire("6v3DB");
function $54801ca29719ab21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54801ca29719ab21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54801ca29719ab21$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54801ca29719ab21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $54801ca29719ab21$var$getNextMonth = function getNextMonth(monthValue, yearValue) {
    var month = monthValue;
    var year = yearValue;
    if (month === (0, $7I2le.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
var $54801ca29719ab21$var$getPrevMonth = function getPrevMonth(monthValue, yearValue) {
    var month = monthValue;
    var year = yearValue;
    if (month === 1) {
        month = (0, $7I2le.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $54801ca29719ab21$export$2e2bcd8739ae039(_ref) {
    var _ref$day = (0, $2qaZZ.default)(_ref.day, 2), dayValue = _ref$day[0], setDayValue = _ref$day[1], _ref$month = (0, $2qaZZ.default)(_ref.month, 2), monthValue = _ref$month[0], setMonthValue = _ref$month[1], _ref$year = (0, $2qaZZ.default)(_ref.year, 2), yearValue = _ref$year[0], setYearValue = _ref$year[1], _ref$shouldSetFocus = (0, $2qaZZ.default)(_ref.shouldSetFocus, 2), _shouldSetFocus = _ref$shouldSetFocus[0], setShouldSetFocus = _ref$shouldSetFocus[1], onChange = _ref.onChange;
    var dateRef = (0, $1oC0p.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $1oC0p.useEffect)(function() {
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    var triggerOnChange = (0, $1oC0p.useCallback)(function(_ref2) {
        var year = _ref2.year, month = _ref2.month, day = _ref2.day, type = _ref2.type;
        var iso = (0, $6FO2b.default)({
            year: year,
            month: month,
            day: day
        });
        var isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    var navigate = (0, $1oC0p.useCallback)(function(type) {
        var _dateRef$current = dateRef.current, day = _dateRef$current.day, month = _dateRef$current.month, year = _dateRef$current.year;
        if (type === 'down') {
            var next = day + (0, $7I2le.daysPerWeek);
            var daysInMonth = (0, $6v3DB.default)(year, month - 1);
            if (next > daysInMonth) {
                var _getNextMonth = $54801ca29719ab21$var$getNextMonth(month, year), nextMonth = _getNextMonth.month, nextYear = _getNextMonth.year;
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            var prev = day - 1;
            if (prev < 1) {
                var _getPrevMonth = $54801ca29719ab21$var$getPrevMonth(month, year), prevMonth = _getPrevMonth.month, prevYear = _getPrevMonth.year;
                var prevDay = (0, $6v3DB.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            var _next = day + 1;
            var _daysInMonth = (0, $6v3DB.default)(year, month - 1);
            if (_next > _daysInMonth) {
                var _getNextMonth2 = $54801ca29719ab21$var$getNextMonth(month, year), _nextMonth = _getNextMonth2.month, _nextYear = _getNextMonth2.year;
                triggerOnChange({
                    year: _nextYear,
                    month: _nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: _next,
                type: type
            });
        } else if (type === 'up') {
            var _prev = day - (0, $7I2le.daysPerWeek);
            if (_prev < 1) {
                var _getPrevMonth2 = $54801ca29719ab21$var$getPrevMonth(month, year), _prevMonth = _getPrevMonth2.month, _prevYear = _getPrevMonth2.year;
                var _prevDay = (0, $6v3DB.default)(_prevYear, _prevMonth - 1) + _prev;
                triggerOnChange({
                    year: _prevYear,
                    month: _prevMonth,
                    day: _prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: _prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    var handleClickNext = (0, $1oC0p.useCallback)(function() {
        var _dateRef$current$getN = $54801ca29719ab21$var$_objectSpread($54801ca29719ab21$var$_objectSpread({}, dateRef.current), $54801ca29719ab21$var$getNextMonth(dateRef.current.month, dateRef.current.year)), day = _dateRef$current$getN.day, month = _dateRef$current$getN.month, year = _dateRef$current$getN.year;
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    var handleClickPrev = (0, $1oC0p.useCallback)(function() {
        var _dateRef$current$getP = $54801ca29719ab21$var$_objectSpread($54801ca29719ab21$var$_objectSpread({}, dateRef.current), $54801ca29719ab21$var$getPrevMonth(dateRef.current.month, dateRef.current.year)), day = _dateRef$current$getP.day, month = _dateRef$current$getP.month, year = _dateRef$current$getP.year;
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("hx2cf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc3738e761d33d01$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $7I2le = parcelRequire("7I2le");

var $6FO2b = parcelRequire("6FO2b");
function $cc3738e761d33d01$export$2e2bcd8739ae039(_ref) {
    var _ref$day = (0, $2qaZZ.default)(_ref.day, 1), dayValue = _ref$day[0], _ref$month = (0, $2qaZZ.default)(_ref.month, 1), monthValue = _ref$month[0], _ref$year = (0, $2qaZZ.default)(_ref.year, 1), yearValue = _ref$year[0], _ref$selected = (0, $2qaZZ.default)(_ref.selected, 2), selectedValue = _ref$selected[0], setSelectedValue = _ref$selected[1], _ref$previous = (0, $2qaZZ.default)(_ref.previous, 2), setPreviouslySelectedValue = _ref$previous[1], onSelect = _ref.onSelect, navigate = _ref.navigate;
    var dateRef = (0, $1oC0p.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $1oC0p.useEffect)(function() {
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    var triggerOnSelect = (0, $1oC0p.useCallback)(function(_ref2) {
        var year = _ref2.year, month = _ref2.month, day = _ref2.day;
        var iso = (0, $6FO2b.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    var handleClickDay = (0, $1oC0p.useCallback)(function(_ref3) {
        var year = _ref3.year, month = _ref3.month, day = _ref3.day;
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    var handleContainerKeyDown = (0, $1oC0p.useCallback)(function(e) {
        var key = e.key;
        var arrowKey = (0, $7I2le.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("bXdbj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8b3f6df30d2e2033$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $ajGIz = parcelRequire("ajGIz");
function $8b3f6df30d2e2033$export$2e2bcd8739ae039(_ref) {
    var locale = _ref.locale, weekStartDay = _ref.weekStartDay;
    var l10n = (0, $1oC0p.useMemo)(function() {
        return (0, $ajGIz.createLocalizationProvider)(locale);
    }, [
        locale
    ]);
    var monthsLong = (0, $1oC0p.useMemo)(function() {
        return l10n.getMonthsLong();
    }, [
        l10n
    ]);
    var daysShort = (0, $1oC0p.useMemo)(function() {
        return l10n.getDaysShort(weekStartDay);
    }, [
        l10n,
        weekStartDay
    ]);
    var daysLong = (0, $1oC0p.useMemo)(function() {
        return l10n.getDaysLong(weekStartDay);
    }, [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});
parcelRegister("ajGIz", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", function () { return $782cd0a2988d34c6$export$ea56ca58f08ffa52; });

var $lFOXD = parcelRequire("lFOXD");

var $3pylq = parcelRequire("3pylq");

var $joRGR = parcelRequire("joRGR");

var $brghe = parcelRequire("brghe");
var $782cd0a2988d34c6$export$ea56ca58f08ffa52 = function createLocalizationProvider(locale, formatterOptions) {
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    var normalizedLocale = (0, $3pylq.normalizeLocale)(locale);
    var formatDate = function formatDate(date) {
        return Intl.DateTimeFormat(normalizedLocale).format(date);
    };
    var formatTime = function formatTime(date) {
        return Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    };
    var getDays = function getDays() {
        var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var length = arguments.length > 1 ? arguments[1] : undefined;
        var dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        var weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        var rotatedWeekdays = weekStartDay > 0 ? [].concat((0, $lFOXD.default)(weekdays.slice(weekStartDay)), (0, $lFOXD.default)(weekdays.slice(0, weekStartDay))) : weekdays;
        return rotatedWeekdays.map(function(day) {
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            var result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    var getDaysShort = function getDaysShort() {
        var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return getDays(weekStartDay, 'short');
    };
    var getDaysLong = function getDaysLong() {
        var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return getDays(weekStartDay, 'long');
    };
    var getMonthsLong = function getMonthsLong() {
        var monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(function(month) {
            return(// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
        });
    };
    var parseDate = function parseDate(date) {
        return (0, $joRGR.createDateParser)(normalizedLocale)(date);
    };
    var formatToParts = function formatToParts() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ var fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        var fixedParts = (0, $brghe.toFormattedParts)(formatter.formatToParts(fixedDate));
        var originalParts = (0, $brghe.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("3pylq", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", function () { return $27be5902b628a5e1$export$dca0327c9b9c6498; });
var $27be5902b628a5e1$export$dca0327c9b9c6498 = function normalizeLocale(locale) {
    return locale.replace(/_/g, '-');
};

});

parcelRegister("joRGR", function(module, exports) {
$parcel$export(module.exports, "createDateParser", function () { return $e1f9e7f7d102bfec$export$cfa2ef2687faeda2; });

var $ao4zr = parcelRequire("ao4zr");

var $3pylq = parcelRequire("3pylq");
var $e1f9e7f7d102bfec$var$INVALID_DATE = new Date(NaN);
var $e1f9e7f7d102bfec$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
var $e1f9e7f7d102bfec$var$INVARIANT_DATE = (0, $ao4zr.toDate)($e1f9e7f7d102bfec$var$INVARIANT);
var $e1f9e7f7d102bfec$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
var $e1f9e7f7d102bfec$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
var $e1f9e7f7d102bfec$var$stripExtras = function stripExtras(str) {
    return str.replace(/\u200E/g, '');
};
var $e1f9e7f7d102bfec$var$extractDateParts = function extractDateParts(matchResult) {
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map(function(datePart) {
        return parseInt(datePart, 10);
    });
};
var $e1f9e7f7d102bfec$export$cfa2ef2687faeda2 = function createDateParser(locale) {
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    var normalizedLocale = (0, $3pylq.normalizeLocale)(locale);
    var dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    var rawDateString = dateFormatter.format($e1f9e7f7d102bfec$var$INVARIANT_DATE);
    var shortDate = $e1f9e7f7d102bfec$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    var formatMatch = shortDate.match($e1f9e7f7d102bfec$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    var formatParts = $e1f9e7f7d102bfec$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    var yearPosition = formatParts.indexOf($e1f9e7f7d102bfec$var$INVARIANT.year);
    var monthPosition = formatParts.indexOf($e1f9e7f7d102bfec$var$INVARIANT.month);
    var dayPosition = formatParts.indexOf($e1f9e7f7d102bfec$var$INVARIANT.day);
    return function(date) {
        var dateMatch = $e1f9e7f7d102bfec$var$stripExtras(date).match($e1f9e7f7d102bfec$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $e1f9e7f7d102bfec$var$INVALID_DATE;
        var dateParts = $e1f9e7f7d102bfec$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        var extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        var normalizedDate = (0, $ao4zr.normalizeDate)(extractedDate);
        if (!(0, $ao4zr.isValid)(normalizedDate)) return $e1f9e7f7d102bfec$var$INVALID_DATE;
        return (0, $ao4zr.toDate)(normalizedDate);
    };
};

});
parcelRegister("ao4zr", function(module, exports) {
$parcel$export(module.exports, "toDate", function () { return $78ffb0ee48d2a9fa$export$e67a095c620b86fe; });
$parcel$export(module.exports, "isValid", function () { return $78ffb0ee48d2a9fa$export$1ea939691cdc45b8; });
$parcel$export(module.exports, "normalizeDate", function () { return $78ffb0ee48d2a9fa$export$fcc71269590ba0a8; });
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ var $78ffb0ee48d2a9fa$export$abe96da78d4f59dd = function toDateObj(date) {
    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    };
};
var $78ffb0ee48d2a9fa$export$e67a095c620b86fe = function toDate(date) {
    return(// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day));
};
var $78ffb0ee48d2a9fa$export$553d7fa8e3805fc0 = function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
var $78ffb0ee48d2a9fa$export$f645ddd439eb259d = function getDaysInMonth(year, month) {
    // February depends on leap year
    if (month === 2 && $78ffb0ee48d2a9fa$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
var $78ffb0ee48d2a9fa$export$1ea939691cdc45b8 = function isValid(date) {
    var year = date.year, month = date.month, day = date.day;
    var daysInMonth = $78ffb0ee48d2a9fa$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
var $78ffb0ee48d2a9fa$export$fcc71269590ba0a8 = function normalizeDate(date) {
    var now = $78ffb0ee48d2a9fa$export$abe96da78d4f59dd(new Date());
    var year = date.year, month = date.month, day = date.day;
    // 19 should evaluate to 2019
    var fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    var normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    var normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    var normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("brghe", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", function () { return $853ed7964e51a1dc$export$9b7ca29af37c192; });

var $f53LC = parcelRequire("f53LC");
function $853ed7964e51a1dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $853ed7964e51a1dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $853ed7964e51a1dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $853ed7964e51a1dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $853ed7964e51a1dc$export$9b7ca29af37c192 = function toFormattedParts(rawParts) {
    return rawParts.reduce(function(result, datePart) {
        return $853ed7964e51a1dc$var$_objectSpread($853ed7964e51a1dc$var$_objectSpread({}, result), {}, (0, $f53LC.default)({}, datePart.type, datePart.value));
    }, {});
};

});




parcelRegister("7MmPk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a9eb90e4130daba$var$_react = $5a9eb90e4130daba$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9Gs1L = parcelRequire("9Gs1L");
function $5a9eb90e4130daba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5a9eb90e4130daba$var$CalendarIcon = (props)=>/*#__PURE__*/ $5a9eb90e4130daba$var$_react.default.createElement($9Gs1L.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5a9eb90e4130daba$var$CalendarIcon.displayName = 'CalendarIcon';
var $5a9eb90e4130daba$var$_default = $5a9eb90e4130daba$var$CalendarIcon;
module.exports.default = $5a9eb90e4130daba$var$_default;

});
parcelRegister("9Gs1L", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $70cdc6f96d7766bd$export$f04a61298a47a40f; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $7gyMa = parcelRequire("7gyMa");

var $3okE6 = parcelRequire("3okE6");

var $b1Paj = parcelRequire("b1Paj");
function $70cdc6f96d7766bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70cdc6f96d7766bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70cdc6f96d7766bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70cdc6f96d7766bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $70cdc6f96d7766bd$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': $70cdc6f96d7766bd$var$_objectSpread($70cdc6f96d7766bd$var$_objectSpread({}, (0, $b1Paj.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $70cdc6f96d7766bd$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $70cdc6f96d7766bd$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $70cdc6f96d7766bd$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $70cdc6f96d7766bd$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $b1Paj.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $7gyMa.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("span", (0, $c9bqK.default)({
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            '--icon-secondary-color': secondaryColor || (0, $3okE6.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $70cdc6f96d7766bd$var$iconStyles,
            $70cdc6f96d7766bd$var$baseHcmStyles,
            primaryColor === secondaryColor && $70cdc6f96d7766bd$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $70cdc6f96d7766bd$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $3dJ4i.css)({
                width: dimensions.width,
                height: dimensions.height,
                '> svg': dimensions
            })
        ]
    }));
});
var $70cdc6f96d7766bd$export$2e2bcd8739ae039 = $70cdc6f96d7766bd$export$f04a61298a47a40f;

});
parcelRegister("3okE6", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $2783a0cc072e25a1$export$18cb9425622d4e06; });
var $2783a0cc072e25a1$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $2783a0cc072e25a1$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
    return $2783a0cc072e25a1$var$themedBackground[mode];
};

});

parcelRegister("b1Paj", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $80777a0dc478c322$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $80777a0dc478c322$export$3eb7d6130acfda37; });

var $2gS0S = parcelRequire("2gS0S");

var $3dJ4i = parcelRequire("3dJ4i");
var $80777a0dc478c322$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $80777a0dc478c322$var$smallStyles = (0, $3dJ4i.css)((0, $2gS0S.dimensions).small);
var $80777a0dc478c322$var$mediumStyles = (0, $3dJ4i.css)((0, $2gS0S.dimensions).medium);
var $80777a0dc478c322$var$largeStyles = (0, $3dJ4i.css)((0, $2gS0S.dimensions).large);
var $80777a0dc478c322$var$xlargeStyles = (0, $3dJ4i.css)((0, $2gS0S.dimensions).xlarge);
var $80777a0dc478c322$export$ef0ad74202575b64 = {
    small: $80777a0dc478c322$var$smallStyles,
    medium: $80777a0dc478c322$var$mediumStyles,
    large: $80777a0dc478c322$var$largeStyles,
    xlarge: $80777a0dc478c322$var$xlargeStyles
};
var $80777a0dc478c322$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $2gS0S.dimensions)[size];
    return undefined;
};

});
parcelRegister("2gS0S", function(module, exports) {
$parcel$export(module.exports, "sizes", function () { return $1a76f94a75f2bd13$export$c647cb0ee6e282fe; });
$parcel$export(module.exports, "dimensions", function () { return $1a76f94a75f2bd13$export$62ad7b0c781000e9; });
var $1a76f94a75f2bd13$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $1a76f94a75f2bd13$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $1a76f94a75f2bd13$export$62ad7b0c781000e9 = {
    small: {
        width: $1a76f94a75f2bd13$export$c647cb0ee6e282fe.small,
        height: $1a76f94a75f2bd13$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $1a76f94a75f2bd13$export$c647cb0ee6e282fe.medium,
        height: $1a76f94a75f2bd13$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $1a76f94a75f2bd13$export$c647cb0ee6e282fe.large,
        height: $1a76f94a75f2bd13$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $1a76f94a75f2bd13$export$c647cb0ee6e282fe.xlarge,
        height: $1a76f94a75f2bd13$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("7iXaE", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_LAYERING", function () { return $55181ceb068ba4d3$export$a183686c3f6f4ea8; });

var $1oC0p = parcelRequire("1oC0p");

var $duw73 = parcelRequire("duw73");

var $9SsB3 = parcelRequire("9SsB3");
var $55181ceb068ba4d3$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $55181ceb068ba4d3$export$48b383b280e20440 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $duw73.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $55181ceb068ba4d3$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $1oC0p.useContext)($55181ceb068ba4d3$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $1oC0p.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($55181ceb068ba4d3$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $55181ceb068ba4d3$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $1oC0p.useRef)(0);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($55181ceb068ba4d3$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $55181ceb068ba4d3$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children;
    var currentLevel = (0, $1oC0p.useContext)($55181ceb068ba4d3$export$650d12d3c2ddb8fc);
    var isNested = currentLevel > 0;
    if (!(0, $9SsB3.getBooleanFF)('platform.design-system-team.layering_qmiw3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($55181ceb068ba4d3$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($55181ceb068ba4d3$var$LayeringProvider, null, content);
};

});
parcelRegister("9SsB3", function(module, exports) {
$parcel$export(module.exports, "getBooleanFF", function () { return $730f56eb37efb367$export$470e5c2be1411c89; });

var $hTZil = parcelRequire("hTZil");
function $730f56eb37efb367$export$ba05d765b8392e5e(flagResolver) {
    (0, $hTZil.setBooleanResolver)(flagResolver);
}
function $730f56eb37efb367$export$470e5c2be1411c89(name) {
    return (0, $hTZil.resolveBooleanFlag)(name);
}

});
parcelRegister("hTZil", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $d0871e9ff2eddfb2$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $d0871e9ff2eddfb2$export$6333b6aff9fc6275; });

var $giDjT = parcelRequire("giDjT");

var $7t0tI = parcelRequire("7t0tI");
var $d0871e9ff2eddfb2$var$pkgName = '@atlaskit/platform-feature-flags';
var $d0871e9ff2eddfb2$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $d0871e9ff2eddfb2$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $d0871e9ff2eddfb2$var$ENV_ENABLE_PLATFORM_FF = $d0871e9ff2eddfb2$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $d0871e9ff2eddfb2$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $d0871e9ff2eddfb2$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $d0871e9ff2eddfb2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $d0871e9ff2eddfb2$var$ENV_ENABLE_PLATFORM_FF || $d0871e9ff2eddfb2$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $d0871e9ff2eddfb2$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $d0871e9ff2eddfb2$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$d0871e9ff2eddfb2$var$globalVar[$d0871e9ff2eddfb2$export$7e41b1b2bdee3f98] = $d0871e9ff2eddfb2$var$globalVar[$d0871e9ff2eddfb2$export$7e41b1b2bdee3f98] || $d0871e9ff2eddfb2$var$DEFAULT_PFF_GLOBAL;
function $d0871e9ff2eddfb2$export$f2b591175b3e424c(resolver) {
    $d0871e9ff2eddfb2$var$globalVar[$d0871e9ff2eddfb2$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $d0871e9ff2eddfb2$export$6333b6aff9fc6275(flagKey) {
    if ($d0871e9ff2eddfb2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $giDjT.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $d0871e9ff2eddfb2$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $d0871e9ff2eddfb2$var$globalVar[$d0871e9ff2eddfb2$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("giDjT", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $bddcd3e288352e3d$export$1c9f709888824e05; });
var $bddcd3e288352e3d$var$_ref, $bddcd3e288352e3d$var$_globalThis$process, $bddcd3e288352e3d$var$_globalThis$process$e, $bddcd3e288352e3d$var$_globalThis$process2, $bddcd3e288352e3d$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $bddcd3e288352e3d$var$TESTS_MODE = ($bddcd3e288352e3d$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($bddcd3e288352e3d$var$_globalThis$process = globalThis.process) === null || $bddcd3e288352e3d$var$_globalThis$process === void 0 ? void 0 : ($bddcd3e288352e3d$var$_globalThis$process$e = $bddcd3e288352e3d$var$_globalThis$process.env) === null || $bddcd3e288352e3d$var$_globalThis$process$e === void 0 ? void 0 : $bddcd3e288352e3d$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $bddcd3e288352e3d$var$_ref !== void 0) ? $bddcd3e288352e3d$var$_ref : false;
var $bddcd3e288352e3d$var$DEBUG_MODE = !$bddcd3e288352e3d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($bddcd3e288352e3d$var$_globalThis$process2 = globalThis.process) === null || $bddcd3e288352e3d$var$_globalThis$process2 === void 0 ? void 0 : ($bddcd3e288352e3d$var$_globalThis$process2$ = $bddcd3e288352e3d$var$_globalThis$process2.env) === null || $bddcd3e288352e3d$var$_globalThis$process2$ === void 0 ? void 0 : $bddcd3e288352e3d$var$_globalThis$process2$.NODE_ENV) !== 'production';
var $bddcd3e288352e3d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$bddcd3e288352e3d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("9RuQh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $72e0fcf16e854471$export$2e2bcd8739ae039; });

var $kKAAc = parcelRequire("kKAAc");

var $fzOo8 = parcelRequire("fzOo8");
var $56Xlo = parcelRequire("56Xlo");
var $3qZOw = parcelRequire("3qZOw");

var $x5c8N = parcelRequire("x5c8N");
var $72e0fcf16e854471$var$packageName = "@atlaskit/select";
var $72e0fcf16e854471$var$packageVersion = "17.0.3";
var $72e0fcf16e854471$export$d1de3b251ccaa8a3 = (0, $x5c8N.default)((0, $kKAAc.default));
var $72e0fcf16e854471$var$createAndFireEventOnAtlaskit = (0, $fzOo8.default)('atlaskit');
var $72e0fcf16e854471$export$2e2bcd8739ae039 = (0, $56Xlo.default)({
    componentName: 'select',
    packageName: $72e0fcf16e854471$var$packageName,
    packageVersion: $72e0fcf16e854471$var$packageVersion
})((0, $3qZOw.default)({
    onChange: $72e0fcf16e854471$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $72e0fcf16e854471$var$packageName,
            packageVersion: $72e0fcf16e854471$var$packageVersion
        }
    })
})($72e0fcf16e854471$export$d1de3b251ccaa8a3));

});
parcelRegister("x5c8N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $06371cc3e6540293$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $h4ELM = parcelRequire("h4ELM");

var $i7dvh = parcelRequire("i7dvh");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $gtBsz = parcelRequire("gtBsz");

var $dWJ7u = parcelRequire("dWJ7u");

var $6prbz = parcelRequire("6prbz");

var $aO7Ea = parcelRequire("aO7Ea");

var $8UVcd = parcelRequire("8UVcd");
var $c6NI8 = parcelRequire("c6NI8");

var $B0vZV = parcelRequire("B0vZV");

var $60CiF = parcelRequire("60CiF");
var $06371cc3e6540293$var$_excluded = [
    "styles",
    "validationState",
    "isInvalid",
    "spacing",
    "isMulti",
    "appearance",
    "ariaLiveMessages"
];
function $06371cc3e6540293$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $06371cc3e6540293$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $06371cc3e6540293$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $06371cc3e6540293$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $06371cc3e6540293$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $06371cc3e6540293$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jlBwm.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jlBwm.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $i3Ugd.default)(this, result);
    };
}
function $06371cc3e6540293$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $06371cc3e6540293$export$2e2bcd8739ae039(WrappedComponent) {
    var _class;
    return _class = /*#__PURE__*/ function(_Component) {
        (0, $i7dvh.default)(AtlaskitSelect, _Component);
        var _super = $06371cc3e6540293$var$_createSuper(AtlaskitSelect);
        function AtlaskitSelect(props) {
            var _this;
            (0, $cTewU.default)(this, AtlaskitSelect);
            _this = _super.call(this, props);
            (0, $f53LC.default)((0, $h4ELM.default)(_this), "components", {});
            (0, $f53LC.default)((0, $h4ELM.default)(_this), "select", null);
            (0, $f53LC.default)((0, $h4ELM.default)(_this), "cacheComponents", function(components) {
                _this.components = $06371cc3e6540293$var$_objectSpread({
                    ClearIndicator: (0, $8UVcd.ClearIndicator) ? (0, $8UVcd.ClearIndicator) : undefined,
                    DropdownIndicator: (0, $8UVcd.DropdownIndicator),
                    LoadingIndicator: (0, $8UVcd.LoadingIndicator),
                    MultiValueRemove: (0, $c6NI8.MultiValueRemove),
                    IndicatorSeparator: (0, $c6NI8.IndicatorSeparator)
                }, components);
            });
            (0, $f53LC.default)((0, $h4ELM.default)(_this), "onSelectRef", function(ref) {
                _this.select = ref;
            });
            _this.cacheComponents = (0, $dWJ7u.default)(_this.cacheComponents, (0, (/*@__PURE__*/$parcel$interopDefault($6prbz)))).bind((0, $h4ELM.default)(_this));
            _this.cacheComponents(props.components || {});
            return _this;
        }
        (0, $avOEA.default)(AtlaskitSelect, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    this.cacheComponents(nextProps.components);
                }
            },
            {
                key: "focus",
                value: function focus() {
                    if (this.select) this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    if (this.select) this.select.blur();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, styles = _this$props.styles, validationState = _this$props.validationState, isInvalid = _this$props.isInvalid, spacing = _this$props.spacing, isMulti = _this$props.isMulti, appearance = _this$props.appearance, ariaLiveMessages = _this$props.ariaLiveMessages, props = (0, $gnQ3X.default)(_this$props, $06371cc3e6540293$var$_excluded);
                    var isCompact = spacing === 'compact';
                    // props must be spread first to stop `components` being overridden
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $c9bqK.default)({
                        ref: this.onSelectRef,
                        isMulti: isMulti,
                        "aria-live": "assertive",
                        ariaLiveMessages: (0, $60CiF.isOptionsGrouped)(this.props.options) ? $06371cc3e6540293$var$_objectSpread({
                            onFocus: (0, $60CiF.onFocus)
                        }, ariaLiveMessages) : $06371cc3e6540293$var$_objectSpread({}, ariaLiveMessages)
                    }, props, {
                        components: this.components,
                        styles: (0, $gtBsz.m)((0, $B0vZV.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
                        typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, this.props.appearance || 'default'), styles)
                    }));
                }
            }
        ]);
        return AtlaskitSelect;
    }((0, $1oC0p.Component)), (0, $f53LC.default)(_class, "defaultProps", {
        validationState: 'default',
        // TODO: uncomment the next line when cleaning up validationState prop so it has a default value
        // isInvalid: false,
        spacing: 'default',
        onClickPreventDefault: true,
        tabSelectsValue: false,
        components: {
            Input: (0, $aO7Ea.Input)
        },
        styles: {}
    }), _class;
}

});
parcelRegister("aO7Ea", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return $7de48160dc7a92b1$export$f5b8910cec6cf069; });

var $c9bqK = parcelRequire("c9bqK");

var $1oC0p = parcelRequire("1oC0p");

var $5r4Ts = parcelRequire("5r4Ts");
var $7de48160dc7a92b1$export$f5b8910cec6cf069 = function Input(props) {
    var passed_describedby = props.selectProps['aria-describedby'];
    var describedby = props['aria-describedby'] + (passed_describedby ? ' ' + passed_describedby : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5r4Ts.c).Input, (0, $c9bqK.default)({}, props, {
        "aria-describedby": describedby
    }));
};

});

parcelRegister("8UVcd", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", function () { return $67dfeba658161b06$export$ecf9cf59142dd54a; });
$parcel$export(module.exports, "DropdownIndicator", function () { return $67dfeba658161b06$export$ec98719d3db7f2e4; });
$parcel$export(module.exports, "LoadingIndicator", function () { return $67dfeba658161b06$export$7c20be4c1d342248; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $5r4Ts = parcelRequire("5r4Ts");

var $bTfkA = parcelRequire("bTfkA");

var $9aBO2 = parcelRequire("9aBO2");

var $79iPW = parcelRequire("79iPW");
function $67dfeba658161b06$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $67dfeba658161b06$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $67dfeba658161b06$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $67dfeba658161b06$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $67dfeba658161b06$var$iconContainerStyles = (0, $3dJ4i.css)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center'
});
var $67dfeba658161b06$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    return (0, $3dJ4i.jsx)((0, $5r4Ts.c).ClearIndicator, $67dfeba658161b06$var$_objectSpread($67dfeba658161b06$var$_objectSpread({}, props), {}, {
        innerProps: $67dfeba658161b06$var$_objectSpread($67dfeba658161b06$var$_objectSpread({}, props.innerProps), {}, {
            'aria-hidden': 'false'
        })
    }), (0, $3dJ4i.jsx)("button", {
        css: $67dfeba658161b06$var$iconContainerStyles,
        type: "button",
        tabIndex: -1
    }, (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9aBO2))), {
        size: "small",
        label: "clear"
    })));
};
var $67dfeba658161b06$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    return (0, $3dJ4i.jsx)((0, $5r4Ts.c).DropdownIndicator, props, (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($79iPW))), {
        label: "open"
    }));
};
var $67dfeba658161b06$export$7c20be4c1d342248 = function LoadingIndicator(props) {
    var loadingStyles = (0, $3dJ4i.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({
        css: loadingStyles
    }, props.innerProps), (0, $3dJ4i.jsx)((0, $bTfkA.default), {
        size: "small"
    })));
};

});
parcelRegister("bTfkA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8a80b930aaacbc48$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $5Bwfa = parcelRequire("5Bwfa");

var $g3hv9 = parcelRequire("g3hv9");

var $h2yvj = parcelRequire("h2yvj");
/**
 * Returns the appropriate circle stroke color.
 */ function $8a80b930aaacbc48$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $g3hv9.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $g3hv9.N0), ")");
}
var $8a80b930aaacbc48$var$rotate = (0, $3dJ4i.keyframes)({
    to: {
        transform: 'rotate(360deg)'
    }
});
var $8a80b930aaacbc48$var$rotateStyles = (0, $3dJ4i.css)({
    animation: "".concat($8a80b930aaacbc48$var$rotate, " 0.86s infinite"),
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $8a80b930aaacbc48$var$loadIn = (0, $3dJ4i.keyframes)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $8a80b930aaacbc48$var$loadInStyles = (0, $3dJ4i.css)({
    animation: "".concat($8a80b930aaacbc48$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $8a80b930aaacbc48$var$wrapperStyles = (0, $3dJ4i.css)({
    display: 'inline-flex',
    /**
   * Align better inline with text.
   */ verticalAlign: 'middle'
});
var $8a80b930aaacbc48$var$circleStyles = (0, $3dJ4i.css)({
    fill: 'none',
    strokeDasharray: 60,
    strokeDashoffset: 'inherit',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
    '@media screen and (forced-colors: active)': {
        filter: 'grayscale(100%)',
        stroke: 'CanvasText'
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $8a80b930aaacbc48$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $8a80b930aaacbc48$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $h2yvj.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $8a80b930aaacbc48$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $5Bwfa.default));
    $8a80b930aaacbc48$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $3dJ4i.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $8a80b930aaacbc48$var$wrapperStyles,
            $8a80b930aaacbc48$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $3dJ4i.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $8a80b930aaacbc48$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none'
    }, (0, $3dJ4i.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $8a80b930aaacbc48$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $8a80b930aaacbc48$export$2e2bcd8739ae039 = $8a80b930aaacbc48$var$Spinner;

});
parcelRegister("g3hv9", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $bafa8093dc6a757b$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $bafa8093dc6a757b$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $bafa8093dc6a757b$export$4b84fd0e2c617bd = '#FFEBE6';
var $bafa8093dc6a757b$export$b34b069eff244586 = '#FFBDAD';
var $bafa8093dc6a757b$export$be802dd0d8b57f35 = '#FF8F73';
var $bafa8093dc6a757b$export$60847d42f9da92a6 = '#FF7452';
var $bafa8093dc6a757b$export$4a7404f376229999 = '#FF5630';
var $bafa8093dc6a757b$export$2010d0fb4295b346 = '#DE350B';
var $bafa8093dc6a757b$export$2837b5a1a71d5c02 = '#BF2600';
var $bafa8093dc6a757b$export$8d9596b529bbb9cf = '#FFFAE6';
var $bafa8093dc6a757b$export$41060a744ab0b7ae = '#FFF0B3';
var $bafa8093dc6a757b$export$1cc05bbbf340e559 = '#FFE380';
var $bafa8093dc6a757b$export$5aae31392d72caaa = '#FFC400';
var $bafa8093dc6a757b$export$c6930421db9fa514 = '#FFAB00';
var $bafa8093dc6a757b$export$59619663aa6500fb = '#FF991F';
var $bafa8093dc6a757b$export$874739ea9e379ab6 = '#FF8B00';
var $bafa8093dc6a757b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $bafa8093dc6a757b$export$69a3bf21b9686c2b = '#ABF5D1';
var $bafa8093dc6a757b$export$afbce1382ec95f73 = '#79F2C0';
var $bafa8093dc6a757b$export$747d86715d4175de = '#57D9A3';
var $bafa8093dc6a757b$export$940e1f69e873f202 = '#36B37E';
var $bafa8093dc6a757b$export$a49394138f7b8e85 = '#00875A';
var $bafa8093dc6a757b$export$6fa04827ac68a4fb = '#006644';
var $bafa8093dc6a757b$export$226de0355ed012f8 = '#DEEBFF';
var $bafa8093dc6a757b$export$8c13c2ee36917869 = '#B3D4FF';
var $bafa8093dc6a757b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $bafa8093dc6a757b$export$215b7063051591f1 = '#2684FF';
var $bafa8093dc6a757b$export$e62e8919cca44969 = '#0065FF';
var $bafa8093dc6a757b$export$b3de0ae08da2ce64 = '#0052CC';
var $bafa8093dc6a757b$export$a6ee3d71bc067634 = '#0747A6';
var $bafa8093dc6a757b$export$363e4475840015bb = '#EAE6FF';
var $bafa8093dc6a757b$export$4b0a4417ed59760f = '#C0B6F2';
var $bafa8093dc6a757b$export$6011520a64d9a187 = '#998DD9';
var $bafa8093dc6a757b$export$a7175d4e9206bc80 = '#8777D9';
var $bafa8093dc6a757b$export$b48405b95304b5a1 = '#6554C0';
var $bafa8093dc6a757b$export$c71e4279dd54a18d = '#5243AA';
var $bafa8093dc6a757b$export$147899de772240ec = '#403294';
var $bafa8093dc6a757b$export$2cf711fe14c66f06 = '#E6FCFF';
var $bafa8093dc6a757b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $bafa8093dc6a757b$export$776c9c497ef08533 = '#79E2F2';
var $bafa8093dc6a757b$export$69cb3ca10c1e330e = '#00C7E6';
var $bafa8093dc6a757b$export$9dc1ef0f3f48059b = '#00B8D9';
var $bafa8093dc6a757b$export$7c835c78b6fcdef8 = '#00A3BF';
var $bafa8093dc6a757b$export$6036577f95c3877e = '#008DA6';
var $bafa8093dc6a757b$export$29a4f05edc054374 = '#FFFFFF';
var $bafa8093dc6a757b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $bafa8093dc6a757b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $bafa8093dc6a757b$export$3e51e8f1440314ba = '#EBECF0';
var $bafa8093dc6a757b$export$1ce2d1575d444ceb = '#DFE1E6';
var $bafa8093dc6a757b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $bafa8093dc6a757b$export$c2e91cbeada39b8b = '#B3BAC5';
var $bafa8093dc6a757b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $bafa8093dc6a757b$export$eaa8c8a70ac22806 = '#97A0AF';
var $bafa8093dc6a757b$export$7c87d337fb91a97d = '#8993A4';
var $bafa8093dc6a757b$export$d6447c357493214f = '#7A869A';
var $bafa8093dc6a757b$export$f563ee71e9ee74cd = '#6B778C';
var $bafa8093dc6a757b$export$e2ef2124cf4024b1 = '#5E6C84';
var $bafa8093dc6a757b$export$eece5f492e429f08 = '#505F79';
var $bafa8093dc6a757b$export$c39c0fe0f26207ae = '#42526E';
var $bafa8093dc6a757b$export$7090862dc3038a9f = '#344563';
var $bafa8093dc6a757b$export$ad0bacf983b7ddaa = '#253858';
var $bafa8093dc6a757b$export$7d61b15e0da132af = '#172B4D';
var $bafa8093dc6a757b$export$fbda843f0a27fe96 = '#091E42';
var $bafa8093dc6a757b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $bafa8093dc6a757b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $bafa8093dc6a757b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $bafa8093dc6a757b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $bafa8093dc6a757b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $bafa8093dc6a757b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $bafa8093dc6a757b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $bafa8093dc6a757b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $bafa8093dc6a757b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $bafa8093dc6a757b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $bafa8093dc6a757b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $bafa8093dc6a757b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $bafa8093dc6a757b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $bafa8093dc6a757b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $bafa8093dc6a757b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $bafa8093dc6a757b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $bafa8093dc6a757b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $bafa8093dc6a757b$export$2f6319cf7d736c2a = '#E6EDFA';
var $bafa8093dc6a757b$export$95126bc8884d6634 = '#DCE5F5';
var $bafa8093dc6a757b$export$8338d8c35d44ff1 = '#CED9EB';
var $bafa8093dc6a757b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $bafa8093dc6a757b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $bafa8093dc6a757b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $bafa8093dc6a757b$export$97e81faa16a182c7 = '#8C9CB8';
var $bafa8093dc6a757b$export$bfe21c59123ecf33 = '#7988A3';
var $bafa8093dc6a757b$export$ee82aa2ea6a1558 = '#67758F';
var $bafa8093dc6a757b$export$682927c6ed76be02 = '#56637A';
var $bafa8093dc6a757b$export$91fd9994c5be9757 = '#455166';
var $bafa8093dc6a757b$export$d281fbfe3cff2df6 = '#3B475C';
var $bafa8093dc6a757b$export$3902c91d8b98a753 = '#313D52';
var $bafa8093dc6a757b$export$8e8133c1ba5845b5 = '#283447';
var $bafa8093dc6a757b$export$33ff357f6620b39 = '#202B3D';
var $bafa8093dc6a757b$export$633847cf062b69e0 = '#1B2638';
var $bafa8093dc6a757b$export$9776a6e503bdbf76 = '#121A29';
var $bafa8093dc6a757b$export$6c813d5160dff5db = '#0E1624';
var $bafa8093dc6a757b$export$3d4f271a500072a = '#0D1424';
var $bafa8093dc6a757b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $bafa8093dc6a757b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $bafa8093dc6a757b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $bafa8093dc6a757b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $bafa8093dc6a757b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $bafa8093dc6a757b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $bafa8093dc6a757b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $bafa8093dc6a757b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $bafa8093dc6a757b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $bafa8093dc6a757b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $bafa8093dc6a757b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $bafa8093dc6a757b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $bafa8093dc6a757b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $bafa8093dc6a757b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $bafa8093dc6a757b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $bafa8093dc6a757b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $bafa8093dc6a757b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

});

parcelRegister("h2yvj", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $c67d636063f79563$export$4e9f1640bbe7a1a8; });
var $c67d636063f79563$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("9aBO2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ad25fbb11730d76$var$_react = $6ad25fbb11730d76$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bh9OT = parcelRequire("bh9OT");

var $6ad25fbb11730d76$var$_crossCircle = $6ad25fbb11730d76$var$_interopRequireDefault((parcelRequire("5YLcq")));
function $6ad25fbb11730d76$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ad25fbb11730d76$var$SelectClearIcon = (props)=>/*#__PURE__*/ $6ad25fbb11730d76$var$_react.default.createElement($bh9OT.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $6ad25fbb11730d76$var$_crossCircle.default
    }));
$6ad25fbb11730d76$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $6ad25fbb11730d76$var$_default = module.exports.default = $6ad25fbb11730d76$var$SelectClearIcon;

});
parcelRegister("bh9OT", function(module, exports) {
$parcel$export(module.exports, "IconFacade", function () { return $8358e641c5f64386$export$3cfb73f70dfca966; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3B3Y4 = parcelRequire("3B3Y4");

var $9S9xG = parcelRequire("9S9xG");
var $8358e641c5f64386$var$_excluded = [
    "dangerouslySetGlyph"
];
var $8358e641c5f64386$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $8358e641c5f64386$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $1oC0p.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, $gnQ3X.default)(_ref, $8358e641c5f64386$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $3B3Y4.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, (0, $c9bqK.default)({}, props, {
                spacing: (0, $3B3Y4.fg)('platform-visual-refresh-icons-facade-button-fix') ? $8358e641c5f64386$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(_Icon, (0, $c9bqK.default)({}, props, {
                spacing: $8358e641c5f64386$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9S9xG.default), (0, $c9bqK.default)({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $8358e641c5f64386$export$2e2bcd8739ae039 = $8358e641c5f64386$export$3cfb73f70dfca966;

});
parcelRegister("3B3Y4", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $29e7e7b7b61fcf80$export$b40ec24ac8275656; });

var $a916a = parcelRequire("a916a");
function $29e7e7b7b61fcf80$export$ba05d765b8392e5e(flagResolver) {
    (0, $a916a.setBooleanResolver)(flagResolver);
}
function $29e7e7b7b61fcf80$export$470e5c2be1411c89(name) {
    return (0, $a916a.resolveBooleanFlag)(name);
}
function $29e7e7b7b61fcf80$export$b40ec24ac8275656(name) {
    return (0, $a916a.resolveBooleanFlag)(name);
}

});
parcelRegister("a916a", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $762b98c3b3afb8b5$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $762b98c3b3afb8b5$export$6333b6aff9fc6275; });

var $6RLYB = parcelRequire("6RLYB");

var $7t0tI = parcelRequire("7t0tI");
var $762b98c3b3afb8b5$var$pkgName = '@atlaskit/platform-feature-flags';
var $762b98c3b3afb8b5$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $762b98c3b3afb8b5$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $762b98c3b3afb8b5$var$ENV_ENABLE_PLATFORM_FF = $762b98c3b3afb8b5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $762b98c3b3afb8b5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $762b98c3b3afb8b5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $762b98c3b3afb8b5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $762b98c3b3afb8b5$var$ENV_ENABLE_PLATFORM_FF || $762b98c3b3afb8b5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $762b98c3b3afb8b5$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $762b98c3b3afb8b5$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$762b98c3b3afb8b5$var$globalVar[$762b98c3b3afb8b5$export$7e41b1b2bdee3f98] = $762b98c3b3afb8b5$var$globalVar[$762b98c3b3afb8b5$export$7e41b1b2bdee3f98] || $762b98c3b3afb8b5$var$DEFAULT_PFF_GLOBAL;
function $762b98c3b3afb8b5$export$f2b591175b3e424c(resolver) {
    $762b98c3b3afb8b5$var$globalVar[$762b98c3b3afb8b5$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $762b98c3b3afb8b5$export$6333b6aff9fc6275(flagKey) {
    if ($762b98c3b3afb8b5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6RLYB.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $762b98c3b3afb8b5$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $762b98c3b3afb8b5$var$globalVar[$762b98c3b3afb8b5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6RLYB", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $4ffce86d396aa30a$export$1c9f709888824e05; });
var $4ffce86d396aa30a$var$_ref, $4ffce86d396aa30a$var$_process, $4ffce86d396aa30a$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $4ffce86d396aa30a$var$TESTS_MODE = ($4ffce86d396aa30a$var$_ref = (globalThis === null || globalThis === void 0 || ($4ffce86d396aa30a$var$_process = globalThis.process) === null || $4ffce86d396aa30a$var$_process === void 0 || ($4ffce86d396aa30a$var$_process = $4ffce86d396aa30a$var$_process.env) === null || $4ffce86d396aa30a$var$_process === void 0 ? void 0 : $4ffce86d396aa30a$var$_process.JEST_WORKER_ID) !== undefined, $4ffce86d396aa30a$var$_ref !== void 0) ? $4ffce86d396aa30a$var$_ref : false;
var $4ffce86d396aa30a$var$DEBUG_MODE = !$4ffce86d396aa30a$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($4ffce86d396aa30a$var$_process2 = globalThis.process) === null || $4ffce86d396aa30a$var$_process2 === void 0 || ($4ffce86d396aa30a$var$_process2 = $4ffce86d396aa30a$var$_process2.env) === null || $4ffce86d396aa30a$var$_process2 === void 0 ? void 0 : $4ffce86d396aa30a$var$_process2.NODE_ENV) !== 'production';
var $4ffce86d396aa30a$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$4ffce86d396aa30a$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("9S9xG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73008f1a553d25db$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $92HmH = parcelRequire("92HmH");

var $dTLAa = parcelRequire("dTLAa");
function $73008f1a553d25db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73008f1a553d25db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73008f1a553d25db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73008f1a553d25db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $73008f1a553d25db$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $73008f1a553d25db$var$_objectSpread($73008f1a553d25db$var$_objectSpread({}, (0, $92HmH.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $73008f1a553d25db$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $73008f1a553d25db$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $73008f1a553d25db$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $73008f1a553d25db$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $92HmH.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $3dJ4i.jsx)("span", (0, $c9bqK.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $73008f1a553d25db$var$_objectSpread({
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $dTLAa.getBackground)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $73008f1a553d25db$var$iconStyles,
            $73008f1a553d25db$var$baseHcmStyles,
            primaryColor === secondaryColor && $73008f1a553d25db$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $73008f1a553d25db$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $3dJ4i.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $73008f1a553d25db$export$2e2bcd8739ae039 = $73008f1a553d25db$export$f04a61298a47a40f;

});
parcelRegister("92HmH", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $6955f05db09b3602$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $6955f05db09b3602$export$3eb7d6130acfda37; });

var $iN8BS = parcelRequire("iN8BS");

var $3dJ4i = parcelRequire("3dJ4i");
var $6955f05db09b3602$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6955f05db09b3602$var$smallStyles = (0, $3dJ4i.css)((0, $iN8BS.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6955f05db09b3602$var$mediumStyles = (0, $3dJ4i.css)((0, $iN8BS.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6955f05db09b3602$var$largeStyles = (0, $3dJ4i.css)((0, $iN8BS.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6955f05db09b3602$var$xlargeStyles = (0, $3dJ4i.css)((0, $iN8BS.dimensions).xlarge);
var $6955f05db09b3602$export$ef0ad74202575b64 = {
    small: $6955f05db09b3602$var$smallStyles,
    medium: $6955f05db09b3602$var$mediumStyles,
    large: $6955f05db09b3602$var$largeStyles,
    xlarge: $6955f05db09b3602$var$xlargeStyles
};
var $6955f05db09b3602$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $iN8BS.dimensions)[size];
    return undefined;
};

});
parcelRegister("iN8BS", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $dae37b5cf31bcb62$export$62ad7b0c781000e9; });
var $dae37b5cf31bcb62$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $dae37b5cf31bcb62$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $dae37b5cf31bcb62$export$62ad7b0c781000e9 = {
    small: {
        width: $dae37b5cf31bcb62$export$c647cb0ee6e282fe.small,
        height: $dae37b5cf31bcb62$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $dae37b5cf31bcb62$export$c647cb0ee6e282fe.medium,
        height: $dae37b5cf31bcb62$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $dae37b5cf31bcb62$export$c647cb0ee6e282fe.large,
        height: $dae37b5cf31bcb62$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $dae37b5cf31bcb62$export$c647cb0ee6e282fe.xlarge,
        height: $dae37b5cf31bcb62$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("dTLAa", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $a1e552446a9b7b4f$export$18cb9425622d4e06; });
var $a1e552446a9b7b4f$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("5YLcq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45a72b3062bb41b7$var$_react = $45a72b3062bb41b7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $45a72b3062bb41b7$var$_UNSAFE_baseNew = $45a72b3062bb41b7$var$_interopRequireDefault((parcelRequire("4aQW1")));
function $45a72b3062bb41b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45a72b3062bb41b7$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $45a72b3062bb41b7$var$_react.default.createElement($45a72b3062bb41b7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$45a72b3062bb41b7$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $45a72b3062bb41b7$var$_default = module.exports.default = $45a72b3062bb41b7$var$CrossCircleIcon;

});
parcelRegister("4aQW1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("gLvtv")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("gLvtv")).Icon; });

var $gLvtv = parcelRequire("gLvtv");

});
parcelRegister("gLvtv", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $c34973612afa2d84$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $c34973612afa2d84$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $3B3Y4 = parcelRequire("3B3Y4");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $c34973612afa2d84$var$commonSVGStyles = (0, $3dJ4i.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $c34973612afa2d84$var$svgStyles = (0, $3dJ4i.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $c34973612afa2d84$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $c34973612afa2d84$var$utilityIconStyles = (0, $3dJ4i.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $c34973612afa2d84$var$scaleStyles = (0, $3dJ4i.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $c34973612afa2d84$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $c34973612afa2d84$var$scaleSize = (0, $3dJ4i.css)({
    width: 'inherit',
    height: 'inherit'
});
var $c34973612afa2d84$var$sizeMap = {
    core: {
        none: (0, $3dJ4i.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $3dJ4i.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $3dJ4i.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $3dJ4i.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $3dJ4i.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $c34973612afa2d84$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $c34973612afa2d84$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $c34973612afa2d84$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $3B3Y4.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $3dJ4i.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $c34973612afa2d84$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $c34973612afa2d84$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $c34973612afa2d84$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $3dJ4i.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $c34973612afa2d84$var$iconStyles,
            $c34973612afa2d84$var$baseHcmStyles,
            shouldScale && $c34973612afa2d84$var$scaleStyles,
            props.type === 'utility' && $c34973612afa2d84$var$utilityIconStyles
        ]
    }, (0, $3dJ4i.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $c34973612afa2d84$var$commonSVGStyles,
            $c34973612afa2d84$var$svgStyles,
            shouldScale ? $c34973612afa2d84$var$scaleSize : props.type === 'utility' ? $c34973612afa2d84$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $c34973612afa2d84$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $c34973612afa2d84$export$2e2bcd8739ae039 = $c34973612afa2d84$export$f04a61298a47a40f;

});




parcelRegister("79iPW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5347fc482cfd98df$var$_react = $5347fc482cfd98df$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bh9OT = parcelRequire("bh9OT");

var $5347fc482cfd98df$var$_chevronDown = $5347fc482cfd98df$var$_interopRequireDefault((parcelRequire("2QfWB")));
function $5347fc482cfd98df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5347fc482cfd98df$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $5347fc482cfd98df$var$_react.default.createElement($bh9OT.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $5347fc482cfd98df$var$_chevronDown.default,
        iconType: "utility"
    }));
$5347fc482cfd98df$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $5347fc482cfd98df$var$_default = module.exports.default = $5347fc482cfd98df$var$ChevronDownIcon;

});
parcelRegister("2QfWB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c58509c5f883b07cf4640f47a045782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $211cce499876fcf0$var$_react = $211cce499876fcf0$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $211cce499876fcf0$var$_UNSAFE_baseNew = $211cce499876fcf0$var$_interopRequireDefault((parcelRequire("4aQW1")));
function $211cce499876fcf0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $211cce499876fcf0$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $211cce499876fcf0$var$_react.default.createElement($211cce499876fcf0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: 'utility'
    }, props));
$211cce499876fcf0$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $211cce499876fcf0$var$_default = module.exports.default = $211cce499876fcf0$var$ChevronDownIcon;

});



parcelRegister("c6NI8", function(module, exports) {
$parcel$export(module.exports, "MultiValueRemove", function () { return $8d0c9b174566885c$export$8e1fd1a40e7a2f4a; });
$parcel$export(module.exports, "IndicatorSeparator", function () { return $8d0c9b174566885c$export$bd638c2ba7915668; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $9aBO2 = parcelRequire("9aBO2");

var $5r4Ts = parcelRequire("5r4Ts");

var $8UVcd = parcelRequire("8UVcd");
var $8d0c9b174566885c$var$disabledStyles = (0, $3dJ4i.css)({
    display: 'none'
});
var $8d0c9b174566885c$var$enabledStyles = (0, $3dJ4i.css)({
    display: 'inherit'
});
var $8d0c9b174566885c$export$8e1fd1a40e7a2f4a = function MultiValueRemove(props) {
    var isDisabled = props.selectProps.isDisabled;
    return (0, $3dJ4i.jsx)((0, $5r4Ts.c).MultiValueRemove, props, (0, $3dJ4i.jsx)("div", {
        css: isDisabled ? $8d0c9b174566885c$var$disabledStyles : $8d0c9b174566885c$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9aBO2))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
var $8d0c9b174566885c$export$bd638c2ba7915668 = null;

});

parcelRegister("B0vZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $06f3db1a3ffeba78$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $hnR5n = parcelRequire("hnR5n");

var $9SsB3 = parcelRequire("9SsB3");

var $3c7rQ = parcelRequire("3c7rQ");
function $06f3db1a3ffeba78$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $06f3db1a3ffeba78$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $06f3db1a3ffeba78$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $06f3db1a3ffeba78$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $06f3db1a3ffeba78$var$BORDER_WIDTH = 2;
var $06f3db1a3ffeba78$var$ICON_PADDING = 2;
var $06f3db1a3ffeba78$var$paddingExcludingBorder = (0, $hnR5n.gridSize)() - $06f3db1a3ffeba78$var$BORDER_WIDTH;
function $06f3db1a3ffeba78$export$2e2bcd8739ae039(validationState) {
    var isCompact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var appearance = arguments.length > 2 ? arguments[2] : undefined;
    return {
        container: function container(css, _ref) {
            var isDisabled = _ref.isDisabled;
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                fontFamily: "var(--ds-font-family-sans, ".concat((0, $hnR5n.fontFamily)(), ")"),
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            });
        },
        input: function input(css) {
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            });
        },
        control: function control(css, _ref2) {
            var isFocused = _ref2.isFocused, isDisabled = _ref2.isDisabled;
            var borderColor = isFocused ? "var(--ds-border-focused, ".concat((0, $3c7rQ.B100), ")") : "var(--ds-border-input, ".concat((0, $9SsB3.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? (0, $3c7rQ.N100) : (0, $3c7rQ.N20), ")");
            var backgroundColor = isFocused ? "var(--ds-background-input-pressed, ".concat((0, $3c7rQ.N0), ")") : "var(--ds-background-input, ".concat((0, $3c7rQ.N20), ")");
            var backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, ".concat((0, $3c7rQ.N0), ")") : "var(--ds-background-input-hovered, ".concat((0, $3c7rQ.N30), ")");
            if (isDisabled) {
                backgroundColor = "var(--ds-background-disabled, ".concat((0, $3c7rQ.N20), ")");
                borderColor = "var(--ds-background-disabled, ".concat((0, $3c7rQ.N20), ")");
            }
            if (validationState === 'error') borderColor = "var(--ds-border-danger, ".concat((0, $3c7rQ.R400), ")");
            if (validationState === 'success') borderColor = "var(--ds-border-success, ".concat((0, $3c7rQ.G400), ")");
            var borderColorHover = isFocused ? "var(--ds-border-focused, ".concat((0, $3c7rQ.B100), ")") : "var(--ds-border-input, ".concat((0, $9SsB3.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? (0, $3c7rQ.N100) : (0, $3c7rQ.N30), ")");
            if (validationState === 'error') borderColorHover = "var(--ds-border-danger, ".concat((0, $3c7rQ.R400), ")");
            if (validationState === 'success') borderColorHover = "var(--ds-border-success, ".concat((0, $3c7rQ.G400), ")");
            var transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? "var(--ds-border-focused, ".concat((0, $3c7rQ.B100), ")") : 'transparent';
                backgroundColor = isFocused ? "var(--ds-surface, ".concat((0, $3c7rQ.N0), ")") : 'transparent';
                backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, ".concat((0, $3c7rQ.N0), ")") : "var(--ds-background-input-hovered, ".concat((0, $3c7rQ.N30), ")");
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: (0, $9SsB3.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? "var(--ds-border-width, 1px)" : "var(--ds-border-width-outline, 2px)",
                boxShadow: 'none'
            }, (0, $9SsB3.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') && {
                '&:focus-within': {
                    boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", borderColor)
                }
            }), {}, {
                minHeight: isCompact ? (0, $hnR5n.gridSize)() * 4 : (0, $hnR5n.gridSize)() * 5,
                padding: 0,
                transition: "background-color ".concat(transitionDuration, " ease-in-out,\n        border-color ").concat(transitionDuration, " ease-in-out"),
                '::-webkit-scrollbar': {
                    height: (0, $hnR5n.gridSize)(),
                    width: (0, $hnR5n.gridSize)()
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            });
        },
        valueContainer: function valueContainer(css) {
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                paddingLeft: $06f3db1a3ffeba78$var$paddingExcludingBorder,
                paddingRight: $06f3db1a3ffeba78$var$paddingExcludingBorder,
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            });
        },
        clearIndicator: function clearIndicator(css) {
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                color: "var(--ds-text-subtlest, ".concat((0, $3c7rQ.N70), ")"),
                paddingLeft: $06f3db1a3ffeba78$var$ICON_PADDING,
                paddingRight: $06f3db1a3ffeba78$var$ICON_PADDING,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: "var(--ds-text-subtle, ".concat((0, $3c7rQ.N500), ")")
                }
            });
        },
        loadingIndicator: function loadingIndicator(css) {
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            });
        },
        dropdownIndicator: function dropdownIndicator(css, _ref3) {
            var isDisabled = _ref3.isDisabled;
            var color = "var(--ds-text-subtle, ".concat((0, $3c7rQ.N500), ")");
            if (isDisabled) color = "var(--ds-text-disabled, ".concat((0, $3c7rQ.N70), ")");
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                color: color,
                paddingLeft: $06f3db1a3ffeba78$var$ICON_PADDING,
                paddingRight: $06f3db1a3ffeba78$var$ICON_PADDING,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: "var(--ds-text-subtle, ".concat((0, $3c7rQ.N200), ")")
                }
            });
        },
        indicatorsContainer: function indicatorsContainer(css) {
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                paddingRight: $06f3db1a3ffeba78$var$paddingExcludingBorder - $06f3db1a3ffeba78$var$ICON_PADDING
            });
        },
        option: function option(css, _ref4) {
            var isFocused = _ref4.isFocused, isSelected = _ref4.isSelected, isDisabled = _ref4.isDisabled;
            var color = "var(--ds-text, ".concat((0, $3c7rQ.N800), ")");
            if (isDisabled) color = "var(--ds-text-disabled, ".concat((0, $3c7rQ.N70), ")");
            else if (isSelected) color = "var(--ds-text-selected, ".concat((0, $3c7rQ.B400), ")");
            var boxShadow;
            var backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, ".concat((0, $3c7rQ.B50), ")");
            else if (isSelected) backgroundColor = "var(--ds-background-selected, ".concat((0, $3c7rQ.B50), ")");
            else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, ".concat((0, $3c7rQ.N20), ")");
            if (!isDisabled && (isFocused || isSelected)) boxShadow = "inset 2px 0px 0px ".concat("var(--ds-border-selected, ".concat((0, $3c7rQ.B400), ")"));
            var cursor = isDisabled ? 'not-allowed' : css.cursor;
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, ".concat((0, $3c7rQ.N20), ")") : "var(--ds-background-neutral-subtle-pressed, ".concat((0, $3c7rQ.N30), ")") : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            });
        },
        placeholder: function placeholder(css, _ref5) {
            var isDisabled = _ref5.isDisabled;
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                color: isDisabled ? "var(--ds-text-disabled, ".concat((0, $3c7rQ.N300), ")") : "var(--ds-text-subtlest, ".concat((0, $3c7rQ.N200), ")")
            });
        },
        singleValue: function singleValue(css, _ref6) {
            var isDisabled = _ref6.isDisabled;
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                color: isDisabled ? "var(--ds-text-disabled, ".concat((0, $3c7rQ.N70), ")") : "var(--ds-text, ".concat((0, $3c7rQ.N800), ")"),
                lineHeight: "var(--ds-font-lineHeight-100, 16px)" // 16px
            });
        },
        menu: function menu(css) {
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            });
        },
        menuList: function menuList(css) {
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            });
        },
        multiValue: function multiValue(css, _ref7) {
            var isDisabled = _ref7.isDisabled, isFocused = _ref7.isFocused;
            var backgroundColor;
            var color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = "var(--ds-background-neutral, ".concat((0, $3c7rQ.N40), ")");
                color = "var(--ds-text-disabled, ".concat((0, $3c7rQ.N70), ")");
            } else if (isFocused) {
                backgroundColor = "var(--ds-background-selected, ".concat((0, $3c7rQ.N40), ")");
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = "var(--ds-background-neutral, ".concat((0, $3c7rQ.N40), ")");
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? "0 0 0 2px ".concat("var(--ds-surface, transparent)", ", 0 0 0 4px ", "var(--ds-border-focused, transparent)") : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color
            });
        },
        multiValueLabel: function multiValueLabel(css, _ref8) {
            var isDisabled = _ref8.isDisabled;
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? "var(--ds-text-disabled, ".concat((0, $3c7rQ.N70), ")") : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)"
            });
        },
        multiValueRemove: function multiValueRemove(css, _ref9) {
            var isFocused = _ref9.isFocused;
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, ".concat((0, $3c7rQ.R75), ")") : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: "var(--ds-background-danger-hovered, ".concat((0, $3c7rQ.R75), ")"),
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: "var(--ds-background-danger-pressed, ".concat((0, $3c7rQ.R75), ")"),
                    fill: "var(--ds-text-danger, #000)"
                }
            });
        },
        groupHeading: function groupHeading(css) {
            return $06f3db1a3ffeba78$var$_objectSpread($06f3db1a3ffeba78$var$_objectSpread({}, css), {}, {
                color: "var(--ds-text-subtle, ".concat((0, $3c7rQ.N200), ")")
            });
        }
    };
}

});

parcelRegister("60CiF", function(module, exports) {
$parcel$export(module.exports, "onFocus", function () { return $460073c10995b54f$export$ecf9bf35ad97eb74; });
$parcel$export(module.exports, "isOptionsGrouped", function () { return $460073c10995b54f$export$d2756249f53f9f8; });
// Used for overwriting ariaLiveMessages builtin onFocus method.
// Returns custom built string while focusing each group option. This string is used for screen reader announcement.
function $460073c10995b54f$export$ecf9bf35ad97eb74(props) {
    var _groupData$options$fi;
    var focused = props.focused, options = props.options;
    var isOptionFocused = function isOptionFocused(option) {
        return option === focused;
    };
    var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
        var _option$options;
        return (_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.some(isOptionFocused);
    });
    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
    return "Option ".concat(focused.label, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " group, item ").concat(groupOptionIndex + 1, " out of ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.options.length, ". All in all ");
}
var $460073c10995b54f$export$d2756249f53f9f8 = function isOptionsGrouped(arr) {
    return arr === null || arr === void 0 ? void 0 : arr.every(function(obj) {
        return obj.hasOwnProperty('options');
    });
};

});



parcelRegister("2Qfvn", function(module, exports) {
$parcel$export(module.exports, "EmptyComponent", function () { return $211c7711965d19ea$export$5e30e9a24d6c1203; });
$parcel$export(module.exports, "placeholderDatetime", function () { return $211c7711965d19ea$export$fff8babee5abe3e2; });
$parcel$export(module.exports, "defaultDateFormat", function () { return $211c7711965d19ea$export$75032c84f56650eb; });
$parcel$export(module.exports, "padToTwo", function () { return $211c7711965d19ea$export$a7de57e5b672ccdb; });
/**
 * This component is used to hide portions of Select component.
 */ var $211c7711965d19ea$export$5e30e9a24d6c1203 = function EmptyComponent() {
    return null;
};
var $211c7711965d19ea$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
var $211c7711965d19ea$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
var $211c7711965d19ea$export$9e6d8fcf62256b85 = 'h:mma';
var $211c7711965d19ea$export$75032c84f56650eb = 'YYYY/MM/DD';
function $211c7711965d19ea$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? "0".concat(number).slice(-2) : "".concat(number);
}
function $211c7711965d19ea$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    var needsLeadingZero = /^\d:/;
    var sanitizedTime = needsLeadingZero.test(time) ? "0".concat(time) : time;
    return "".concat(date, "T").concat(sanitizedTime).concat(zone);
}

});

parcelRegister("82jjj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d9d7d467f959167$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $h4ELM = parcelRequire("h4ELM");

var $i7dvh = parcelRequire("i7dvh");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $4cgdq = parcelRequire("4cgdq");

var $duw73 = parcelRequire("duw73");

var $2gS0S = parcelRequire("2gS0S");

var $9SsB3 = parcelRequire("9SsB3");

var $8q4Jo = parcelRequire("8q4Jo");
var $5YGDW = parcelRequire("5YGDW");
var $kUCSO = parcelRequire("kUCSO");

var $hnR5n = parcelRequire("hnR5n");
function $5d9d7d467f959167$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d9d7d467f959167$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d9d7d467f959167$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d9d7d467f959167$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5d9d7d467f959167$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5d9d7d467f959167$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jlBwm.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jlBwm.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $i3Ugd.default)(this, result);
    };
}
function $5d9d7d467f959167$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * This component renders layered content with fixed positioning.
 * Scroll is locked outside the layer to prevent the layered content from detaching from the
 * container ref.
 */ var $5d9d7d467f959167$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $i7dvh.default)(FixedLayer, _React$Component);
    var _super = $5d9d7d467f959167$var$_createSuper(FixedLayer);
    function FixedLayer() {
        var _this;
        (0, $cTewU.default)(this, FixedLayer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "update", (0, $duw73.default));
        return _this;
    }
    (0, $avOEA.default)(FixedLayer, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.inputValue !== this.props.inputValue) this.update();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, containerRef = _this$props.containerRef, content = _this$props.content, testId = _this$props.testId;
                // Wait for containerRef callback to cause a re-render
                if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", null);
                var divStyles = $5d9d7d467f959167$var$_objectSpread({
                    background: 'transparent',
                    position: 'absolute',
                    top: 0,
                    height: containerRef.getBoundingClientRect().height,
                    // Don't block the clear button
                    width: containerRef.getBoundingClientRect().width - parseInt((0, $2gS0S.sizes).small.slice(0, -2)) - (0, $hnR5n.gridSize)()
                }, (0, $9SsB3.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs') && {
                    pointerEvents: 'none'
                });
                return(/*#__PURE__*/ /* Need to wrap layer in a fixed position div so that it will render its content as fixed
         * We need to set the intial top value to where the container is and zIndex so that it still
         * applies since we're creating a new stacking context. */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8q4Jo.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4cgdq))), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kUCSO.Reference), null, function(_ref) {
                    var ref = _ref.ref;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
                        ref: ref,
                        "data-layer-child": true,
                        style: divStyles
                    });
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5YGDW.Popper), null, function(_ref2) {
                    var ref = _ref2.ref, style = _ref2.style, update = _ref2.update;
                    _this2.update = update;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
                        ref: ref,
                        style: $5d9d7d467f959167$var$_objectSpread($5d9d7d467f959167$var$_objectSpread({}, style), {}, {
                            zIndex: (0, $hnR5n.layers).dialog()
                        }),
                        "data-testid": testId && "".concat(testId, "--popper--container")
                    }, content);
                })));
            }
        }
    ]);
    return FixedLayer;
}((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);

});
parcelRegister("5YGDW", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $45a3a2643cc8c906$export$badac9ada3a0bdf9; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $eVddu = parcelRequire("eVddu");

// Export types from PopperJS / React Popper
var $45a3a2643cc8c906$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    },
    {
        name: 'preventOverflow',
        options: {
            padding: 5,
            rootBoundary: 'document'
        }
    }
];
function $45a3a2643cc8c906$var$defaultChildrenFn() {
    return null;
}
var $45a3a2643cc8c906$var$defaultOffset = [
    0,
    8
];
function $45a3a2643cc8c906$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $45a3a2643cc8c906$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $45a3a2643cc8c906$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy;
    var _offset = (0, $2qaZZ.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($45a3a2643cc8c906$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $lFOXD.default)(internalModifiers), (0, $lFOXD.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eVddu.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});


parcelRegister("kPY04", function(module, exports) {
$parcel$export(module.exports, "makeSingleValue", function () { return $f2b71cd81f7ede0a$export$6e30bf8cb1347b56; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $5r4Ts = parcelRequire("5r4Ts");
var $f2b71cd81f7ede0a$var$_excluded = [
    "children"
];
var $f2b71cd81f7ede0a$export$6e30bf8cb1347b56 = function makeSingleValue(_ref) {
    var lang = _ref.lang;
    return function(_ref2) {
        var children = _ref2.children, props = (0, $gnQ3X.default)(_ref2, $f2b71cd81f7ede0a$var$_excluded);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5r4Ts.c).SingleValue, (0, $c9bqK.default)({}, props, {
            innerProps: {
                lang: lang
            }
        }), children);
    };
};

});

parcelRegister("6wccz", function(module, exports) {
$parcel$export(module.exports, "convertTokens", function () { return $4bef323e9eb2ba94$export$4d5430175be73d45; });
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
var $4bef323e9eb2ba94$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
var $4bef323e9eb2ba94$var$v1tokens = Object.keys($4bef323e9eb2ba94$var$tokensMap).sort().reverse();
var $4bef323e9eb2ba94$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$4bef323e9eb2ba94$var$v1tokens.join('|') + '|.)', 'g');
function $4bef323e9eb2ba94$export$4d5430175be73d45(format) {
    var tokensCaptures = format.match($4bef323e9eb2ba94$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce(function(parsed, tokenString, index) {
        var v2token = $4bef323e9eb2ba94$var$tokensMap[tokenString];
        if (!v2token) {
            var escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        var endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            var filteredEscapedTextBuffer = parsed.escapedTextBuffer.map(function(token) {
                return token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token;
            }).filter(function(token) {
                return token !== "'";
            }).join('');
            parsed.formatBuffer.push("'".concat(filteredEscapedTextBuffer, "'"));
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("6Q2bE", function(module, exports) {
$parcel$export(module.exports, "uniformFormMessages", function () { return $8caf554b624aabc1$export$f51f1afdcc504aa5; });

var $fnHPc = parcelRequire("fnHPc");
const $8caf554b624aabc1$export$f51f1afdcc504aa5 = (0, $fnHPc.defineMessages)({
    firstName: {
        id: 'uniform.form.field.firstName',
        defaultMessage: 'First name'
    },
    lastName: {
        id: 'uniform.form.field.lastName',
        defaultMessage: 'Last name'
    },
    email: {
        id: 'uniform.form.field.email',
        defaultMessage: 'Email'
    },
    company: {
        id: 'uniform.form.field.company',
        defaultMessage: 'Company'
    },
    phone: {
        id: 'uniform.form.field.phone',
        defaultMessage: 'Phone number'
    },
    honeypot: {
        id: 'uniform.form.field.honeypot',
        defaultMessage: 'Email confirmation'
    },
    required: {
        id: 'uniform.form.validation.required',
        defaultMessage: 'This field is required.'
    },
    firstNameRequired: {
        id: 'uniform.form.validation.firstNameRequired',
        defaultMessage: 'Your first name is required.'
    },
    lastNameRequired: {
        id: 'uniform.form.validation.lastNameRequired',
        defaultMessage: 'Your last name is required.'
    },
    companyRequired: {
        id: 'uniform.form.validation.companyRequired',
        defaultMessage: 'Please enter a company.'
    },
    phoneRequired: {
        id: 'uniform.form.validation.phoneRequired',
        defaultMessage: 'Please provide phone number.'
    },
    invalidEmail: {
        id: 'uniform.form.validation.invalidEmail',
        defaultMessage: 'Enter a valid email address.'
    },
    businessEmail: {
        id: 'uniform.form.validation.businessEmail',
        defaultMessage: 'Enter a business email address.'
    },
    selectPlaceholder: {
        id: 'uniform.form.selectPlaceholder',
        defaultMessage: 'Select an option'
    },
    submit: {
        id: 'uniform.form.submit',
        defaultMessage: 'Submit'
    },
    submitError: {
        id: 'uniform.form.submitError',
        defaultMessage: 'There has been an error submitting - please try again later'
    },
    configurationError: {
        id: 'uniform.form.configurationError',
        defaultMessage: 'This form is not configured correctly.'
    },
    privacyPolicy: {
        id: 'uniform.form.consent.privacyPolicy',
        defaultMessage: 'By submitting this form, I acknowledge the Atlassian Privacy Policy.'
    },
    generalMarketingOptIn: {
        id: 'uniform.form.consent.generalMarketingOptIn',
        defaultMessage: 'Yes, I would like to receive marketing communications from Atlassian.'
    },
    termsOfService: {
        id: 'uniform.form.consent.termsOfService',
        defaultMessage: 'By submitting this form, I agree to the Atlassian Terms of Service.'
    },
    eapTermsOfService: {
        id: 'uniform.form.consent.eapTermsOfService',
        defaultMessage: 'By submitting this form, I agree to the Early Access Program Terms of Service.'
    },
    eapVirtualAgentTerms: {
        id: 'uniform.form.consent.eapVirtualAgentTerms',
        defaultMessage: 'By submitting this form, I agree to the Early Access Program terms and conditions.'
    }
});

});

parcelRegister("3siaX", function(module, exports) {
$parcel$export(module.exports, "getFormFields", function () { return $093cfd910f1fdcd6$export$5e097831852eb087; });

var $cSSNJ = parcelRequire("cSSNJ");
const $093cfd910f1fdcd6$var$asString = (value)=>typeof value === 'string' && value.trim() ? value.trim() : undefined;
const $093cfd910f1fdcd6$var$asBoolean = (value)=>value === true;
const $093cfd910f1fdcd6$var$getParameters = (component)=>Object.fromEntries(Object.entries(component.parameters ?? {}).map(([key, parameter])=>[
            key,
            parameter?.value
        ]));
const $093cfd910f1fdcd6$var$isContextualEditingPlaceholder = (component)=>component._id?.startsWith('placeholder_') ?? false;
const $093cfd910f1fdcd6$var$getComponents = (component, slotName)=>(component.slots?.[slotName] ?? []).filter((childComponent)=>!$093cfd910f1fdcd6$var$isContextualEditingPlaceholder(childComponent));
const $093cfd910f1fdcd6$var$parseOption = (component)=>{
    const parameters = $093cfd910f1fdcd6$var$getParameters(component);
    return {
        id: component._id ?? '',
        value: $093cfd910f1fdcd6$var$asString(parameters['value']) ?? '',
        label: $093cfd910f1fdcd6$var$asString(parameters['label']) ?? '',
        conditionalFields: $093cfd910f1fdcd6$export$2c719959d4a69eac($093cfd910f1fdcd6$var$getComponents(component, 'conditionalFields'))
    };
};
// eslint-disable-next-line complexity -- parses each supported Uniform field definition explicitly.
const $093cfd910f1fdcd6$var$parseFormField = (component)=>{
    const parameters = $093cfd910f1fdcd6$var$getParameters(component);
    const base = {
        id: component._id ?? '',
        width: parameters['width'] === 'half' ? 'half' : 'full'
    };
    switch(component.type){
        case 'formNamesFields':
            return {
                ...base,
                type: component.type,
                required: $093cfd910f1fdcd6$var$asBoolean(parameters['required'])
            };
        case 'formEmailField':
            return {
                ...base,
                type: component.type,
                businessEmailOnly: $093cfd910f1fdcd6$var$asBoolean(parameters['businessEmailOnly']),
                label: $093cfd910f1fdcd6$var$asString(parameters['label']),
                requiredMessage: $093cfd910f1fdcd6$var$asString(parameters['requiredMessage'])
            };
        case 'formCompanyField':
            return {
                ...base,
                type: component.type,
                required: $093cfd910f1fdcd6$var$asBoolean(parameters['required']),
                label: $093cfd910f1fdcd6$var$asString(parameters['label']),
                requiredMessage: $093cfd910f1fdcd6$var$asString(parameters['requiredMessage'])
            };
        case 'formPhoneNumberField':
            return {
                ...base,
                type: component.type,
                required: $093cfd910f1fdcd6$var$asBoolean(parameters['required'])
            };
        case 'formCustomTextField':
            return {
                ...base,
                type: component.type,
                payloadKey: $093cfd910f1fdcd6$var$asString(parameters['payloadKey']) ?? '',
                label: $093cfd910f1fdcd6$var$asString(parameters['label']) ?? '',
                placeholder: $093cfd910f1fdcd6$var$asString(parameters['placeholder']),
                helpText: $093cfd910f1fdcd6$var$asString(parameters['helpText']),
                required: $093cfd910f1fdcd6$var$asBoolean(parameters['required']),
                requiredMessage: $093cfd910f1fdcd6$var$asString(parameters['requiredMessage']),
                multiline: $093cfd910f1fdcd6$var$asBoolean(parameters['multiline'])
            };
        case 'formDatepickerField':
            {
                const valueOverride = $093cfd910f1fdcd6$var$asString(parameters['valueOverride']);
                return {
                    ...base,
                    type: component.type,
                    payloadKey: valueOverride ?? 'date',
                    valueOverride: valueOverride,
                    label: $093cfd910f1fdcd6$var$asString(parameters['label']) ?? 'Date',
                    placeholder: $093cfd910f1fdcd6$var$asString(parameters['placeholder']),
                    helpText: $093cfd910f1fdcd6$var$asString(parameters['helpText']),
                    required: $093cfd910f1fdcd6$var$asBoolean(parameters['required']),
                    requiredMessage: $093cfd910f1fdcd6$var$asString(parameters['requiredMessage'])
                };
            }
        case 'formCustomChoiceField':
            {
                const radioOrCheckboxColumns = parameters['radioOrCheckboxColumns'] === 'Three' ? 3 : parameters['radioOrCheckboxColumns'] === 'Two' ? 2 : 1;
                return {
                    ...base,
                    type: component.type,
                    controlType: parameters['controlType'] === 'radio' || parameters['controlType'] === 'checkboxGroup' ? parameters['controlType'] : 'select',
                    payloadKey: $093cfd910f1fdcd6$var$asString(parameters['payloadKey']) ?? '',
                    label: $093cfd910f1fdcd6$var$asString(parameters['label']) ?? '',
                    placeholder: $093cfd910f1fdcd6$var$asString(parameters['placeholder']),
                    helpText: $093cfd910f1fdcd6$var$asString(parameters['helpText']),
                    required: $093cfd910f1fdcd6$var$asBoolean(parameters['required']),
                    requiredMessage: $093cfd910f1fdcd6$var$asString(parameters['requiredMessage']),
                    radioOrCheckboxColumns: radioOrCheckboxColumns,
                    options: $093cfd910f1fdcd6$var$getComponents(component, 'options').map($093cfd910f1fdcd6$var$parseOption)
                };
            }
        case 'formCountryOrStateField':
            {
                const selectedOption = $093cfd910f1fdcd6$var$asString(parameters['options']) ?? $093cfd910f1fdcd6$var$asString(parameters['preset']);
                const preset = selectedOption === 'states' || selectedOption === 'usStates' ? 'states' : selectedOption === 'countriesAndStates' ? 'countriesAndStates' : 'countries';
                const isStatesField = preset === 'states';
                let stateField;
                if (preset === 'countriesAndStates') stateField = {
                    id: `${base.id}-state`,
                    type: 'formCountryOrStateField',
                    preset: 'states',
                    width: base.width,
                    controlType: 'select',
                    payloadKey: 'state',
                    label: 'State',
                    required: $093cfd910f1fdcd6$var$asBoolean(parameters['required']),
                    options: (0, $cSSNJ.getCountryOrStateOptions)('states').map((option)=>({
                            id: option.value,
                            ...option,
                            conditionalFields: []
                        }))
                };
                return {
                    ...base,
                    type: component.type,
                    preset: preset,
                    controlType: 'select',
                    payloadKey: isStatesField ? 'state' : 'country',
                    label: $093cfd910f1fdcd6$var$asString(parameters['label']) ?? (isStatesField ? 'State' : 'Country'),
                    required: $093cfd910f1fdcd6$var$asBoolean(parameters['required']),
                    requiredMessage: $093cfd910f1fdcd6$var$asString(parameters['requiredMessage']),
                    options: (0, $cSSNJ.getCountryOrStateOptions)(isStatesField ? 'states' : 'countries').map((option)=>({
                            id: option.value,
                            ...option,
                            conditionalFields: option.value === (0, $cSSNJ.UNITED_STATES_COUNTRY_VALUE) && stateField ? [
                                stateField
                            ] : []
                        }))
                };
            }
        default:
            return null;
    }
};
const $093cfd910f1fdcd6$export$2c719959d4a69eac = (components)=>components.map($093cfd910f1fdcd6$var$parseFormField).filter((field)=>field !== null);
const $093cfd910f1fdcd6$export$5e097831852eb087 = (component)=>$093cfd910f1fdcd6$export$2c719959d4a69eac($093cfd910f1fdcd6$var$getComponents(component, 'fields'));
const $093cfd910f1fdcd6$export$1ba0983f0c760de4 = (field)=>{
    switch(field.type){
        case 'formNamesFields':
            return [
                'firstName',
                'lastName'
            ];
        case 'formEmailField':
            return [
                'email'
            ];
        case 'formCompanyField':
            return [
                'company'
            ];
        case 'formPhoneNumberField':
            return [
                'number'
            ];
        case 'formCustomTextField':
        case 'formDatepickerField':
        case 'formCustomChoiceField':
        case 'formCountryOrStateField':
            return field.payloadKey ? [
                field.payloadKey
            ] : [];
    }
};

});
parcelRegister("cSSNJ", function(module, exports) {
$parcel$export(module.exports, "UNITED_STATES_COUNTRY_VALUE", function () { return $3fc61bbd995da6a6$export$91287853f897c851; });
$parcel$export(module.exports, "getCountryOrStateOptions", function () { return $3fc61bbd995da6a6$export$fcca1db5fd6c1561; });

var $feb0S = parcelRequire("feb0S");
const $3fc61bbd995da6a6$var$US_STATES_AND_TERRITORIES = [
    {
        label: 'Alabama',
        value: 'AL'
    },
    {
        label: 'Alaska',
        value: 'AK'
    },
    {
        label: 'American Samoa',
        value: 'AS'
    },
    {
        label: 'Arizona',
        value: 'AZ'
    },
    {
        label: 'Arkansas',
        value: 'AR'
    },
    {
        label: 'California',
        value: 'CA'
    },
    {
        label: 'Colorado',
        value: 'CO'
    },
    {
        label: 'Connecticut',
        value: 'CT'
    },
    {
        label: 'Delaware',
        value: 'DE'
    },
    {
        label: 'District of Columbia',
        value: 'DC'
    },
    {
        label: 'Florida',
        value: 'FL'
    },
    {
        label: 'Georgia',
        value: 'GA'
    },
    {
        label: 'Guam',
        value: 'GU'
    },
    {
        label: 'Hawaii',
        value: 'HI'
    },
    {
        label: 'Idaho',
        value: 'ID'
    },
    {
        label: 'Illinois',
        value: 'IL'
    },
    {
        label: 'Indiana',
        value: 'IN'
    },
    {
        label: 'Iowa',
        value: 'IA'
    },
    {
        label: 'Kansas',
        value: 'KS'
    },
    {
        label: 'Kentucky',
        value: 'KY'
    },
    {
        label: 'Louisiana',
        value: 'LA'
    },
    {
        label: 'Maine',
        value: 'ME'
    },
    {
        label: 'Maryland',
        value: 'MD'
    },
    {
        label: 'Massachusetts',
        value: 'MA'
    },
    {
        label: 'Michigan',
        value: 'MI'
    },
    {
        label: 'Minnesota',
        value: 'MN'
    },
    {
        label: 'Mississippi',
        value: 'MS'
    },
    {
        label: 'Missouri',
        value: 'MO'
    },
    {
        label: 'Montana',
        value: 'MT'
    },
    {
        label: 'Nebraska',
        value: 'NE'
    },
    {
        label: 'Nevada',
        value: 'NV'
    },
    {
        label: 'New Hampshire',
        value: 'NH'
    },
    {
        label: 'New Jersey',
        value: 'NJ'
    },
    {
        label: 'New Mexico',
        value: 'NM'
    },
    {
        label: 'New York',
        value: 'NY'
    },
    {
        label: 'North Carolina',
        value: 'NC'
    },
    {
        label: 'North Dakota',
        value: 'ND'
    },
    {
        label: 'Northern Mariana Islands',
        value: 'MP'
    },
    {
        label: 'Ohio',
        value: 'OH'
    },
    {
        label: 'Oklahoma',
        value: 'OK'
    },
    {
        label: 'Oregon',
        value: 'OR'
    },
    {
        label: 'Pennsylvania',
        value: 'PA'
    },
    {
        label: 'Puerto Rico',
        value: 'PR'
    },
    {
        label: 'Rhode Island',
        value: 'RI'
    },
    {
        label: 'South Carolina',
        value: 'SC'
    },
    {
        label: 'South Dakota',
        value: 'SD'
    },
    {
        label: 'Tennessee',
        value: 'TN'
    },
    {
        label: 'Texas',
        value: 'TX'
    },
    {
        label: 'U.S. Virgin Islands',
        value: 'VI'
    },
    {
        label: 'Utah',
        value: 'UT'
    },
    {
        label: 'Vermont',
        value: 'VT'
    },
    {
        label: 'Virginia',
        value: 'VA'
    },
    {
        label: 'Washington',
        value: 'WA'
    },
    {
        label: 'West Virginia',
        value: 'WV'
    },
    {
        label: 'Wisconsin',
        value: 'WI'
    },
    {
        label: 'Wyoming',
        value: 'WY'
    }
];
const $3fc61bbd995da6a6$export$91287853f897c851 = 'United States of America';
const $3fc61bbd995da6a6$export$fcca1db5fd6c1561 = (preset)=>preset === 'states' ? $3fc61bbd995da6a6$var$US_STATES_AND_TERRITORIES : (0, $feb0S.getWebinarCountries)(false).map((country)=>({
            label: country,
            value: country
        }));

});
parcelRegister("feb0S", function(module, exports) {
$parcel$export(module.exports, "WEBINAR_COMPANY_SIZES", function () { return $bd70a3a5b0a1e994$export$2b710402ae6a97a1; });
$parcel$export(module.exports, "getWebinarCountries", function () { return $bd70a3a5b0a1e994$export$b1855a90933b7cd2; });
$parcel$export(module.exports, "getWebinarCountryOptions", function () { return $bd70a3a5b0a1e994$export$82ce44e204ff2ddb; });

var $h7hnF = parcelRequire("h7hnF");
const $bd70a3a5b0a1e994$export$2b710402ae6a97a1 = [
    '1-10',
    '11-50',
    '51-250',
    '251-1K',
    '1K-5K',
    '5K-10K',
    '10K-50K',
    '50K-100K',
    '100K+'
];
const $bd70a3a5b0a1e994$var$WEBINAR_COUNTRIES = Object.keys((0, $h7hnF.webinarCountryMessages));
const $bd70a3a5b0a1e994$export$b1855a90933b7cd2 = (isJapanese)=>{
    const preferredCountry = isJapanese ? 'Japan' : 'United States of America';
    return [
        preferredCountry,
        ...$bd70a3a5b0a1e994$var$WEBINAR_COUNTRIES.filter((country)=>country !== preferredCountry)
    ];
};
const $bd70a3a5b0a1e994$export$82ce44e204ff2ddb = (intl, isJapanese)=>$bd70a3a5b0a1e994$export$b1855a90933b7cd2(isJapanese).map((value)=>{
        const message = (0, $h7hnF.webinarCountryMessages)[value];
        return {
            value: value,
            label: message ? intl.formatMessage(message) : value
        };
    });

});
parcelRegister("h7hnF", function(module, exports) {
$parcel$export(module.exports, "webinarCountryMessages", function () { return $b4707b94cd47ec95$export$2f9f28be04e33d9e; });

var $fnHPc = parcelRequire("fnHPc");
const $b4707b94cd47ec95$export$2f9f28be04e33d9e = (0, $fnHPc.defineMessages)({
    Afghanistan: {
        id: 'uniform.webinarForm.country.Afghanistan',
        defaultMessage: 'Afghanistan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Albania: {
        id: 'uniform.webinarForm.country.Albania',
        defaultMessage: 'Albania',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Algeria: {
        id: 'uniform.webinarForm.country.Algeria',
        defaultMessage: 'Algeria',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'American Samoa': {
        id: 'uniform.webinarForm.country.AmericanSamoa',
        defaultMessage: 'American Samoa',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Andorra: {
        id: 'uniform.webinarForm.country.Andorra',
        defaultMessage: 'Andorra',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Angola: {
        id: 'uniform.webinarForm.country.Angola',
        defaultMessage: 'Angola',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Anguilla: {
        id: 'uniform.webinarForm.country.Anguilla',
        defaultMessage: 'Anguilla',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Antarctica: {
        id: 'uniform.webinarForm.country.Antarctica',
        defaultMessage: 'Antarctica',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Antigua and Barbuda': {
        id: 'uniform.webinarForm.country.AntiguaandBarbuda',
        defaultMessage: 'Antigua and Barbuda',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Argentina: {
        id: 'uniform.webinarForm.country.Argentina',
        defaultMessage: 'Argentina',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Armenia: {
        id: 'uniform.webinarForm.country.Armenia',
        defaultMessage: 'Armenia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Aruba: {
        id: 'uniform.webinarForm.country.Aruba',
        defaultMessage: 'Aruba',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Australia: {
        id: 'uniform.webinarForm.country.Australia',
        defaultMessage: 'Australia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Austria: {
        id: 'uniform.webinarForm.country.Austria',
        defaultMessage: 'Austria',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Azerbaijan: {
        id: 'uniform.webinarForm.country.Azerbaijan',
        defaultMessage: 'Azerbaijan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Bahamas: {
        id: 'uniform.webinarForm.country.Bahamas',
        defaultMessage: 'Bahamas',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Bahrain: {
        id: 'uniform.webinarForm.country.Bahrain',
        defaultMessage: 'Bahrain',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Bangladesh: {
        id: 'uniform.webinarForm.country.Bangladesh',
        defaultMessage: 'Bangladesh',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Barbados: {
        id: 'uniform.webinarForm.country.Barbados',
        defaultMessage: 'Barbados',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Belarus: {
        id: 'uniform.webinarForm.country.Belarus',
        defaultMessage: 'Belarus',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Belgium: {
        id: 'uniform.webinarForm.country.Belgium',
        defaultMessage: 'Belgium',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Belize: {
        id: 'uniform.webinarForm.country.Belize',
        defaultMessage: 'Belize',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Benin: {
        id: 'uniform.webinarForm.country.Benin',
        defaultMessage: 'Benin',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Bermuda: {
        id: 'uniform.webinarForm.country.Bermuda',
        defaultMessage: 'Bermuda',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Bhutan: {
        id: 'uniform.webinarForm.country.Bhutan',
        defaultMessage: 'Bhutan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Bolivia: {
        id: 'uniform.webinarForm.country.Bolivia',
        defaultMessage: 'Bolivia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Bosnia and Herzegovina': {
        id: 'uniform.webinarForm.country.BosniaandHerzegovina',
        defaultMessage: 'Bosnia and Herzegovina',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Botswana: {
        id: 'uniform.webinarForm.country.Botswana',
        defaultMessage: 'Botswana',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Bouvet Island': {
        id: 'uniform.webinarForm.country.BouvetIsland',
        defaultMessage: 'Bouvet Island',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Brazil: {
        id: 'uniform.webinarForm.country.Brazil',
        defaultMessage: 'Brazil',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'British Indian Ocean Territory': {
        id: 'uniform.webinarForm.country.BritishIndianOceanTerritory',
        defaultMessage: 'British Indian Ocean Territory',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Brunei: {
        id: 'uniform.webinarForm.country.Brunei',
        defaultMessage: 'Brunei',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Bulgaria: {
        id: 'uniform.webinarForm.country.Bulgaria',
        defaultMessage: 'Bulgaria',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Burkina Faso': {
        id: 'uniform.webinarForm.country.BurkinaFaso',
        defaultMessage: 'Burkina Faso',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Burundi: {
        id: 'uniform.webinarForm.country.Burundi',
        defaultMessage: 'Burundi',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Cambodia: {
        id: 'uniform.webinarForm.country.Cambodia',
        defaultMessage: 'Cambodia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Cameroon: {
        id: 'uniform.webinarForm.country.Cameroon',
        defaultMessage: 'Cameroon',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Canada: {
        id: 'uniform.webinarForm.country.Canada',
        defaultMessage: 'Canada',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Cape Verde': {
        id: 'uniform.webinarForm.country.CapeVerde',
        defaultMessage: 'Cape Verde',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Cayman Islands': {
        id: 'uniform.webinarForm.country.CaymanIslands',
        defaultMessage: 'Cayman Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Central African Republic': {
        id: 'uniform.webinarForm.country.CentralAfricanRepublic',
        defaultMessage: 'Central African Republic',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Chad: {
        id: 'uniform.webinarForm.country.Chad',
        defaultMessage: 'Chad',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Chile: {
        id: 'uniform.webinarForm.country.Chile',
        defaultMessage: 'Chile',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    China: {
        id: 'uniform.webinarForm.country.China',
        defaultMessage: 'China',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Christmas Island': {
        id: 'uniform.webinarForm.country.ChristmasIsland',
        defaultMessage: 'Christmas Island',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Cocos Keeling Islands': {
        id: 'uniform.webinarForm.country.CocosKeelingIslands',
        defaultMessage: 'Cocos Keeling Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Colombia: {
        id: 'uniform.webinarForm.country.Colombia',
        defaultMessage: 'Colombia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Comoros: {
        id: 'uniform.webinarForm.country.Comoros',
        defaultMessage: 'Comoros',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Congo Democratic Peoples Republic': {
        id: 'uniform.webinarForm.country.CongoDemocraticPeoplesRepublic',
        defaultMessage: 'Congo Democratic Peoples Republic',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Congo Republic of': {
        id: 'uniform.webinarForm.country.CongoRepublicof',
        defaultMessage: 'Congo Republic of',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Cook Islands': {
        id: 'uniform.webinarForm.country.CookIslands',
        defaultMessage: 'Cook Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Costa Rica': {
        id: 'uniform.webinarForm.country.CostaRica',
        defaultMessage: 'Costa Rica',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Cote dIvoire Ivory Coast': {
        id: 'uniform.webinarForm.country.CotedIvoireIvoryCoast',
        defaultMessage: 'Cote dIvoire Ivory Coast',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Croatia Hrvatska': {
        id: 'uniform.webinarForm.country.CroatiaHrvatska',
        defaultMessage: 'Croatia Hrvatska',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Cuba: {
        id: 'uniform.webinarForm.country.Cuba',
        defaultMessage: 'Cuba',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Cyprus: {
        id: 'uniform.webinarForm.country.Cyprus',
        defaultMessage: 'Cyprus',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Czech Republic': {
        id: 'uniform.webinarForm.country.CzechRepublic',
        defaultMessage: 'Czech Republic',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Denmark: {
        id: 'uniform.webinarForm.country.Denmark',
        defaultMessage: 'Denmark',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Djibouti: {
        id: 'uniform.webinarForm.country.Djibouti',
        defaultMessage: 'Djibouti',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Dominica: {
        id: 'uniform.webinarForm.country.Dominica',
        defaultMessage: 'Dominica',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Dominican Republic': {
        id: 'uniform.webinarForm.country.DominicanRepublic',
        defaultMessage: 'Dominican Republic',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Ecuador: {
        id: 'uniform.webinarForm.country.Ecuador',
        defaultMessage: 'Ecuador',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Egypt: {
        id: 'uniform.webinarForm.country.Egypt',
        defaultMessage: 'Egypt',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'El Salvador': {
        id: 'uniform.webinarForm.country.ElSalvador',
        defaultMessage: 'El Salvador',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Equatorial Guinea': {
        id: 'uniform.webinarForm.country.EquatorialGuinea',
        defaultMessage: 'Equatorial Guinea',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Eritrea: {
        id: 'uniform.webinarForm.country.Eritrea',
        defaultMessage: 'Eritrea',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Estonia: {
        id: 'uniform.webinarForm.country.Estonia',
        defaultMessage: 'Estonia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Ethiopia: {
        id: 'uniform.webinarForm.country.Ethiopia',
        defaultMessage: 'Ethiopia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Falkland Islands': {
        id: 'uniform.webinarForm.country.FalklandIslands',
        defaultMessage: 'Falkland Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Faroe Islands': {
        id: 'uniform.webinarForm.country.FaroeIslands',
        defaultMessage: 'Faroe Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Fiji: {
        id: 'uniform.webinarForm.country.Fiji',
        defaultMessage: 'Fiji',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Finland: {
        id: 'uniform.webinarForm.country.Finland',
        defaultMessage: 'Finland',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    France: {
        id: 'uniform.webinarForm.country.France',
        defaultMessage: 'France',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'French Guiana': {
        id: 'uniform.webinarForm.country.FrenchGuiana',
        defaultMessage: 'French Guiana',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'French Polynesia': {
        id: 'uniform.webinarForm.country.FrenchPolynesia',
        defaultMessage: 'French Polynesia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'French Southern Territories': {
        id: 'uniform.webinarForm.country.FrenchSouthernTerritories',
        defaultMessage: 'French Southern Territories',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Gabon: {
        id: 'uniform.webinarForm.country.Gabon',
        defaultMessage: 'Gabon',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Gambia: {
        id: 'uniform.webinarForm.country.Gambia',
        defaultMessage: 'Gambia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Georgia: {
        id: 'uniform.webinarForm.country.Georgia',
        defaultMessage: 'Georgia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Germany: {
        id: 'uniform.webinarForm.country.Germany',
        defaultMessage: 'Germany',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Ghana: {
        id: 'uniform.webinarForm.country.Ghana',
        defaultMessage: 'Ghana',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Gibraltar: {
        id: 'uniform.webinarForm.country.Gibraltar',
        defaultMessage: 'Gibraltar',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Greece: {
        id: 'uniform.webinarForm.country.Greece',
        defaultMessage: 'Greece',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Greenland: {
        id: 'uniform.webinarForm.country.Greenland',
        defaultMessage: 'Greenland',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Grenada: {
        id: 'uniform.webinarForm.country.Grenada',
        defaultMessage: 'Grenada',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Guadeloupe: {
        id: 'uniform.webinarForm.country.Guadeloupe',
        defaultMessage: 'Guadeloupe',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Guam: {
        id: 'uniform.webinarForm.country.Guam',
        defaultMessage: 'Guam',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Guatemala: {
        id: 'uniform.webinarForm.country.Guatemala',
        defaultMessage: 'Guatemala',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Guernsey: {
        id: 'uniform.webinarForm.country.Guernsey',
        defaultMessage: 'Guernsey',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Guinea: {
        id: 'uniform.webinarForm.country.Guinea',
        defaultMessage: 'Guinea',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Guinea-Bissau': {
        id: 'uniform.webinarForm.country.GuineaBissau',
        defaultMessage: 'Guinea-Bissau',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Guyana: {
        id: 'uniform.webinarForm.country.Guyana',
        defaultMessage: 'Guyana',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Haiti: {
        id: 'uniform.webinarForm.country.Haiti',
        defaultMessage: 'Haiti',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Heard and McDonald Islands': {
        id: 'uniform.webinarForm.country.HeardandMcDonaldIslands',
        defaultMessage: 'Heard and McDonald Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Honduras: {
        id: 'uniform.webinarForm.country.Honduras',
        defaultMessage: 'Honduras',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Hong Kong': {
        id: 'uniform.webinarForm.country.HongKong',
        defaultMessage: 'Hong Kong',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Hungary: {
        id: 'uniform.webinarForm.country.Hungary',
        defaultMessage: 'Hungary',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Iceland: {
        id: 'uniform.webinarForm.country.Iceland',
        defaultMessage: 'Iceland',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    India: {
        id: 'uniform.webinarForm.country.India',
        defaultMessage: 'India',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Indonesia: {
        id: 'uniform.webinarForm.country.Indonesia',
        defaultMessage: 'Indonesia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Iran: {
        id: 'uniform.webinarForm.country.Iran',
        defaultMessage: 'Iran',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Iraq: {
        id: 'uniform.webinarForm.country.Iraq',
        defaultMessage: 'Iraq',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Ireland: {
        id: 'uniform.webinarForm.country.Ireland',
        defaultMessage: 'Ireland',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Isle of Man': {
        id: 'uniform.webinarForm.country.IsleofMan',
        defaultMessage: 'Isle of Man',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Israel: {
        id: 'uniform.webinarForm.country.Israel',
        defaultMessage: 'Israel',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Italy: {
        id: 'uniform.webinarForm.country.Italy',
        defaultMessage: 'Italy',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Jamaica: {
        id: 'uniform.webinarForm.country.Jamaica',
        defaultMessage: 'Jamaica',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Japan: {
        id: 'uniform.webinarForm.country.Japan',
        defaultMessage: 'Japan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Jersey: {
        id: 'uniform.webinarForm.country.Jersey',
        defaultMessage: 'Jersey',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Jordan: {
        id: 'uniform.webinarForm.country.Jordan',
        defaultMessage: 'Jordan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Kazakhstan: {
        id: 'uniform.webinarForm.country.Kazakhstan',
        defaultMessage: 'Kazakhstan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Kenya: {
        id: 'uniform.webinarForm.country.Kenya',
        defaultMessage: 'Kenya',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Kiribati: {
        id: 'uniform.webinarForm.country.Kiribati',
        defaultMessage: 'Kiribati',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Korea North': {
        id: 'uniform.webinarForm.country.KoreaNorth',
        defaultMessage: 'Korea North',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Korea South': {
        id: 'uniform.webinarForm.country.KoreaSouth',
        defaultMessage: 'Korea South',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Kuwait: {
        id: 'uniform.webinarForm.country.Kuwait',
        defaultMessage: 'Kuwait',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Kyrgyzstan: {
        id: 'uniform.webinarForm.country.Kyrgyzstan',
        defaultMessage: 'Kyrgyzstan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Laos: {
        id: 'uniform.webinarForm.country.Laos',
        defaultMessage: 'Laos',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Latvia: {
        id: 'uniform.webinarForm.country.Latvia',
        defaultMessage: 'Latvia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Lebanon: {
        id: 'uniform.webinarForm.country.Lebanon',
        defaultMessage: 'Lebanon',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Lesotho: {
        id: 'uniform.webinarForm.country.Lesotho',
        defaultMessage: 'Lesotho',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Liberia: {
        id: 'uniform.webinarForm.country.Liberia',
        defaultMessage: 'Liberia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Libya: {
        id: 'uniform.webinarForm.country.Libya',
        defaultMessage: 'Libya',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Liechtenstein: {
        id: 'uniform.webinarForm.country.Liechtenstein',
        defaultMessage: 'Liechtenstein',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Lithuania: {
        id: 'uniform.webinarForm.country.Lithuania',
        defaultMessage: 'Lithuania',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Luxembourg: {
        id: 'uniform.webinarForm.country.Luxembourg',
        defaultMessage: 'Luxembourg',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Macau: {
        id: 'uniform.webinarForm.country.Macau',
        defaultMessage: 'Macau',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Macedonia: {
        id: 'uniform.webinarForm.country.Macedonia',
        defaultMessage: 'Macedonia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Madagascar: {
        id: 'uniform.webinarForm.country.Madagascar',
        defaultMessage: 'Madagascar',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Malawi: {
        id: 'uniform.webinarForm.country.Malawi',
        defaultMessage: 'Malawi',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Malaysia: {
        id: 'uniform.webinarForm.country.Malaysia',
        defaultMessage: 'Malaysia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Maldives: {
        id: 'uniform.webinarForm.country.Maldives',
        defaultMessage: 'Maldives',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Mali: {
        id: 'uniform.webinarForm.country.Mali',
        defaultMessage: 'Mali',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Malta: {
        id: 'uniform.webinarForm.country.Malta',
        defaultMessage: 'Malta',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Marshall Islands': {
        id: 'uniform.webinarForm.country.MarshallIslands',
        defaultMessage: 'Marshall Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Martinique: {
        id: 'uniform.webinarForm.country.Martinique',
        defaultMessage: 'Martinique',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Mauritania: {
        id: 'uniform.webinarForm.country.Mauritania',
        defaultMessage: 'Mauritania',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Mauritius: {
        id: 'uniform.webinarForm.country.Mauritius',
        defaultMessage: 'Mauritius',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Mayotte: {
        id: 'uniform.webinarForm.country.Mayotte',
        defaultMessage: 'Mayotte',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Mexico: {
        id: 'uniform.webinarForm.country.Mexico',
        defaultMessage: 'Mexico',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Micronesia: {
        id: 'uniform.webinarForm.country.Micronesia',
        defaultMessage: 'Micronesia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Moldova: {
        id: 'uniform.webinarForm.country.Moldova',
        defaultMessage: 'Moldova',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Monaco: {
        id: 'uniform.webinarForm.country.Monaco',
        defaultMessage: 'Monaco',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Mongolia: {
        id: 'uniform.webinarForm.country.Mongolia',
        defaultMessage: 'Mongolia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Montenegro: {
        id: 'uniform.webinarForm.country.Montenegro',
        defaultMessage: 'Montenegro',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Montserrat: {
        id: 'uniform.webinarForm.country.Montserrat',
        defaultMessage: 'Montserrat',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Morocco: {
        id: 'uniform.webinarForm.country.Morocco',
        defaultMessage: 'Morocco',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Mozambique: {
        id: 'uniform.webinarForm.country.Mozambique',
        defaultMessage: 'Mozambique',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Myanmar: {
        id: 'uniform.webinarForm.country.Myanmar',
        defaultMessage: 'Myanmar',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Namibia: {
        id: 'uniform.webinarForm.country.Namibia',
        defaultMessage: 'Namibia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Nauru: {
        id: 'uniform.webinarForm.country.Nauru',
        defaultMessage: 'Nauru',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Nepal: {
        id: 'uniform.webinarForm.country.Nepal',
        defaultMessage: 'Nepal',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Netherlands: {
        id: 'uniform.webinarForm.country.Netherlands',
        defaultMessage: 'Netherlands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Netherlands Antilles': {
        id: 'uniform.webinarForm.country.NetherlandsAntilles',
        defaultMessage: 'Netherlands Antilles',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'New Caledonia': {
        id: 'uniform.webinarForm.country.NewCaledonia',
        defaultMessage: 'New Caledonia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'New Zealand': {
        id: 'uniform.webinarForm.country.NewZealand',
        defaultMessage: 'New Zealand',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Nicaragua: {
        id: 'uniform.webinarForm.country.Nicaragua',
        defaultMessage: 'Nicaragua',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Niger: {
        id: 'uniform.webinarForm.country.Niger',
        defaultMessage: 'Niger',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Nigeria: {
        id: 'uniform.webinarForm.country.Nigeria',
        defaultMessage: 'Nigeria',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Niue: {
        id: 'uniform.webinarForm.country.Niue',
        defaultMessage: 'Niue',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Norfolk Island': {
        id: 'uniform.webinarForm.country.NorfolkIsland',
        defaultMessage: 'Norfolk Island',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Northern Mariana Islands': {
        id: 'uniform.webinarForm.country.NorthernMarianaIslands',
        defaultMessage: 'Northern Mariana Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Norway: {
        id: 'uniform.webinarForm.country.Norway',
        defaultMessage: 'Norway',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Oman: {
        id: 'uniform.webinarForm.country.Oman',
        defaultMessage: 'Oman',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Pakistan: {
        id: 'uniform.webinarForm.country.Pakistan',
        defaultMessage: 'Pakistan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Palau: {
        id: 'uniform.webinarForm.country.Palau',
        defaultMessage: 'Palau',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Palestinian Territories': {
        id: 'uniform.webinarForm.country.PalestinianTerritories',
        defaultMessage: 'Palestinian Territories',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Panama: {
        id: 'uniform.webinarForm.country.Panama',
        defaultMessage: 'Panama',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Papua New Guinea': {
        id: 'uniform.webinarForm.country.PapuaNewGuinea',
        defaultMessage: 'Papua New Guinea',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Paraguay: {
        id: 'uniform.webinarForm.country.Paraguay',
        defaultMessage: 'Paraguay',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Peru: {
        id: 'uniform.webinarForm.country.Peru',
        defaultMessage: 'Peru',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Philippines: {
        id: 'uniform.webinarForm.country.Philippines',
        defaultMessage: 'Philippines',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Pitcairn: {
        id: 'uniform.webinarForm.country.Pitcairn',
        defaultMessage: 'Pitcairn',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Poland: {
        id: 'uniform.webinarForm.country.Poland',
        defaultMessage: 'Poland',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Portugal: {
        id: 'uniform.webinarForm.country.Portugal',
        defaultMessage: 'Portugal',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Puerto Rico': {
        id: 'uniform.webinarForm.country.PuertoRico',
        defaultMessage: 'Puerto Rico',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Qatar: {
        id: 'uniform.webinarForm.country.Qatar',
        defaultMessage: 'Qatar',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Reunion: {
        id: 'uniform.webinarForm.country.Reunion',
        defaultMessage: 'Reunion',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Romania: {
        id: 'uniform.webinarForm.country.Romania',
        defaultMessage: 'Romania',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Russian Federation': {
        id: 'uniform.webinarForm.country.RussianFederation',
        defaultMessage: 'Russian Federation',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Rwanda: {
        id: 'uniform.webinarForm.country.Rwanda',
        defaultMessage: 'Rwanda',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Saint Helena': {
        id: 'uniform.webinarForm.country.SaintHelena',
        defaultMessage: 'Saint Helena',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Saint Kitts and Nevis': {
        id: 'uniform.webinarForm.country.SaintKittsandNevis',
        defaultMessage: 'Saint Kitts and Nevis',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Saint Lucia': {
        id: 'uniform.webinarForm.country.SaintLucia',
        defaultMessage: 'Saint Lucia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Saint Pierre and Miquelon': {
        id: 'uniform.webinarForm.country.SaintPierreandMiquelon',
        defaultMessage: 'Saint Pierre and Miquelon',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Saint Vincent and the Grenadines': {
        id: 'uniform.webinarForm.country.SaintVincentandtheGrenadines',
        defaultMessage: 'Saint Vincent and the Grenadines',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Samoa: {
        id: 'uniform.webinarForm.country.Samoa',
        defaultMessage: 'Samoa',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'San Marino': {
        id: 'uniform.webinarForm.country.SanMarino',
        defaultMessage: 'San Marino',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Sao Tome and Principe': {
        id: 'uniform.webinarForm.country.SaoTomeandPrincipe',
        defaultMessage: 'Sao Tome and Principe',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Saudi Arabia': {
        id: 'uniform.webinarForm.country.SaudiArabia',
        defaultMessage: 'Saudi Arabia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Senegal: {
        id: 'uniform.webinarForm.country.Senegal',
        defaultMessage: 'Senegal',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Serbia: {
        id: 'uniform.webinarForm.country.Serbia',
        defaultMessage: 'Serbia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Serbia and Montenegro': {
        id: 'uniform.webinarForm.country.SerbiaandMontenegro',
        defaultMessage: 'Serbia and Montenegro',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Seychelles: {
        id: 'uniform.webinarForm.country.Seychelles',
        defaultMessage: 'Seychelles',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Sierra Leone': {
        id: 'uniform.webinarForm.country.SierraLeone',
        defaultMessage: 'Sierra Leone',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Singapore: {
        id: 'uniform.webinarForm.country.Singapore',
        defaultMessage: 'Singapore',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Slovak Republic': {
        id: 'uniform.webinarForm.country.SlovakRepublic',
        defaultMessage: 'Slovak Republic',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Slovenia: {
        id: 'uniform.webinarForm.country.Slovenia',
        defaultMessage: 'Slovenia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Solomon Islands': {
        id: 'uniform.webinarForm.country.SolomonIslands',
        defaultMessage: 'Solomon Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Somalia: {
        id: 'uniform.webinarForm.country.Somalia',
        defaultMessage: 'Somalia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'South Africa': {
        id: 'uniform.webinarForm.country.SouthAfrica',
        defaultMessage: 'South Africa',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'South Georgia and the South Sandwich Islands': {
        id: 'uniform.webinarForm.country.SouthGeorgiaandtheSouthSandwichIslands',
        defaultMessage: 'South Georgia and the South Sandwich Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Spain: {
        id: 'uniform.webinarForm.country.Spain',
        defaultMessage: 'Spain',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Sri Lanka': {
        id: 'uniform.webinarForm.country.SriLanka',
        defaultMessage: 'Sri Lanka',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Sudan: {
        id: 'uniform.webinarForm.country.Sudan',
        defaultMessage: 'Sudan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Suriname: {
        id: 'uniform.webinarForm.country.Suriname',
        defaultMessage: 'Suriname',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Svalbard and Jan Mayen Islands': {
        id: 'uniform.webinarForm.country.SvalbardandJanMayenIslands',
        defaultMessage: 'Svalbard and Jan Mayen Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Swaziland: {
        id: 'uniform.webinarForm.country.Swaziland',
        defaultMessage: 'Swaziland',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Sweden: {
        id: 'uniform.webinarForm.country.Sweden',
        defaultMessage: 'Sweden',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Switzerland: {
        id: 'uniform.webinarForm.country.Switzerland',
        defaultMessage: 'Switzerland',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Syria: {
        id: 'uniform.webinarForm.country.Syria',
        defaultMessage: 'Syria',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Taiwan: {
        id: 'uniform.webinarForm.country.Taiwan',
        defaultMessage: 'Taiwan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Tajikistan: {
        id: 'uniform.webinarForm.country.Tajikistan',
        defaultMessage: 'Tajikistan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Tanzania: {
        id: 'uniform.webinarForm.country.Tanzania',
        defaultMessage: 'Tanzania',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Thailand: {
        id: 'uniform.webinarForm.country.Thailand',
        defaultMessage: 'Thailand',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Timor-Leste': {
        id: 'uniform.webinarForm.country.TimorLeste',
        defaultMessage: 'Timor-Leste',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Togo: {
        id: 'uniform.webinarForm.country.Togo',
        defaultMessage: 'Togo',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Tokelau: {
        id: 'uniform.webinarForm.country.Tokelau',
        defaultMessage: 'Tokelau',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Tonga: {
        id: 'uniform.webinarForm.country.Tonga',
        defaultMessage: 'Tonga',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Trinidad and Tobago': {
        id: 'uniform.webinarForm.country.TrinidadandTobago',
        defaultMessage: 'Trinidad and Tobago',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Tunisia: {
        id: 'uniform.webinarForm.country.Tunisia',
        defaultMessage: 'Tunisia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Turkey: {
        id: 'uniform.webinarForm.country.Turkey',
        defaultMessage: 'Turkey',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Turkmenistan: {
        id: 'uniform.webinarForm.country.Turkmenistan',
        defaultMessage: 'Turkmenistan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Turks and Caicos Islands': {
        id: 'uniform.webinarForm.country.TurksandCaicosIslands',
        defaultMessage: 'Turks and Caicos Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Tuvalu: {
        id: 'uniform.webinarForm.country.Tuvalu',
        defaultMessage: 'Tuvalu',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Uganda: {
        id: 'uniform.webinarForm.country.Uganda',
        defaultMessage: 'Uganda',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Ukraine: {
        id: 'uniform.webinarForm.country.Ukraine',
        defaultMessage: 'Ukraine',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'United Arab Emirates': {
        id: 'uniform.webinarForm.country.UnitedArabEmirates',
        defaultMessage: 'United Arab Emirates',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'United Kingdom': {
        id: 'uniform.webinarForm.country.UnitedKingdom',
        defaultMessage: 'United Kingdom',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'United States of America': {
        id: 'uniform.webinarForm.country.UnitedStatesofAmerica',
        defaultMessage: 'United States of America',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Uruguay: {
        id: 'uniform.webinarForm.country.Uruguay',
        defaultMessage: 'Uruguay',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Uzbekistan: {
        id: 'uniform.webinarForm.country.Uzbekistan',
        defaultMessage: 'Uzbekistan',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Vanuatu: {
        id: 'uniform.webinarForm.country.Vanuatu',
        defaultMessage: 'Vanuatu',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Vatican City': {
        id: 'uniform.webinarForm.country.VaticanCity',
        defaultMessage: 'Vatican City',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Venezuela: {
        id: 'uniform.webinarForm.country.Venezuela',
        defaultMessage: 'Venezuela',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Vietnam: {
        id: 'uniform.webinarForm.country.Vietnam',
        defaultMessage: 'Vietnam',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Virgin Islands British': {
        id: 'uniform.webinarForm.country.VirginIslandsBritish',
        defaultMessage: 'Virgin Islands British',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Virgin Islands US': {
        id: 'uniform.webinarForm.country.VirginIslandsUS',
        defaultMessage: 'Virgin Islands US',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Wallis and Futuna Islands': {
        id: 'uniform.webinarForm.country.WallisandFutunaIslands',
        defaultMessage: 'Wallis and Futuna Islands',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    'Western Sahara': {
        id: 'uniform.webinarForm.country.WesternSahara',
        defaultMessage: 'Western Sahara',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Yemen: {
        id: 'uniform.webinarForm.country.Yemen',
        defaultMessage: 'Yemen',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Zambia: {
        id: 'uniform.webinarForm.country.Zambia',
        defaultMessage: 'Zambia',
        description: 'Country or territory label in the webinar registration country dropdown.'
    },
    Zimbabwe: {
        id: 'uniform.webinarForm.country.Zimbabwe',
        defaultMessage: 'Zimbabwe',
        description: 'Country or territory label in the webinar registration country dropdown.'
    }
});

});




parcelRegister("5nFGj", function(module, exports) {
$parcel$export(module.exports, "UniformFormSubmissionError", function () { return $7c77225bb94251f6$export$f03be7b0f3ccc7a0; });
$parcel$export(module.exports, "submitUniformForm", function () { return $7c77225bb94251f6$export$26e651920d3efda5; });

var $hhv63 = parcelRequire("hhv63");

var $eRzlV = parcelRequire("eRzlV");
const $7c77225bb94251f6$var$SUBMISSION_TIMEOUT_MS = 15000;
const $7c77225bb94251f6$var$DEFAULT_SUBMISSION_ENDPOINT = 'wacformlead';
const $7c77225bb94251f6$var$FORM_SUBMISSION_PATHS = {
    wacformlead: '/endpoint/streamhub/wacformlead',
    enterpriseformsubmit: '/enterprise-form-submit'
};
const $7c77225bb94251f6$var$toSameRootPath = (endpoint)=>{
    const trimmedEndpoint = endpoint?.trim();
    if (!trimmedEndpoint) return undefined;
    return `/${trimmedEndpoint.replace(/^\/+/, '')}`;
};
const $7c77225bb94251f6$var$getSubmissionEndpoint = (endpoint, customEndpoint)=>{
    if (endpoint === 'custom') {
        const customPath = $7c77225bb94251f6$var$toSameRootPath(customEndpoint);
        if (customPath) return {
            path: customPath,
            type: 'custom'
        };
    }
    if (endpoint === 'enterpriseformsubmit') return {
        path: $7c77225bb94251f6$var$FORM_SUBMISSION_PATHS.enterpriseformsubmit,
        type: endpoint
    };
    return {
        path: $7c77225bb94251f6$var$FORM_SUBMISSION_PATHS.wacformlead,
        type: $7c77225bb94251f6$var$DEFAULT_SUBMISSION_ENDPOINT
    };
};
const $7c77225bb94251f6$var$withTimeout = async (promise)=>{
    let timeoutId;
    const timeoutPromise = new Promise((_, reject)=>{
        timeoutId = setTimeout(()=>reject(new $7c77225bb94251f6$export$f03be7b0f3ccc7a0('timeout')), $7c77225bb94251f6$var$SUBMISSION_TIMEOUT_MS);
    });
    try {
        return await Promise.race([
            promise,
            timeoutPromise
        ]);
    } finally{
        if (timeoutId) clearTimeout(timeoutId);
    }
};
const $7c77225bb94251f6$var$isConsentHubDisabled = ()=>!(0, $eRzlV.isProduction)() && new URLSearchParams(window.location.search).get('disableConsentHub') === 'true';
class $7c77225bb94251f6$export$f03be7b0f3ccc7a0 extends Error {
    constructor(category){
        super(category);
        this.name = 'UniformFormSubmissionError';
        this.category = category;
    }
}
const $7c77225bb94251f6$var$getCookie = (name)=>{
    const match = document.cookie.split('; ').find((item)=>item.startsWith(`${name}=`))?.slice(name.length + 1);
    return match ? decodeURIComponent(match).replace(/"/g, '') : '';
};
const $7c77225bb94251f6$var$getAttribution = ()=>{
    const params = new URLSearchParams(window.location.search);
    return {
        utm_source: params.get('utm_source') ?? '',
        utm_medium: params.get('utm_medium') ?? '',
        utm_campaign: params.get('utm_campaign') ?? '',
        utm_content: params.get('utm_content') ?? '',
        utm_term: params.get('utm_term') ?? ''
    };
};
const $7c77225bb94251f6$var$getConsentLocale = (consentConfig, fallbackLocale)=>consentConfig?.locale ?? fallbackLocale;
const $7c77225bb94251f6$var$getConsentTexts = (consentMode, displayedLegalText)=>{
    switch(consentMode){
        case 'generalMarketingOptIn':
            return {
                consentLabelText: displayedLegalText
            };
        case 'privacyPolicy':
            return {
                privacyPolicyText: displayedLegalText
            };
        case 'termsOfService':
        case 'eapTermsOfService':
        case 'eapVirtualAgentTermsAndConditions':
            return {
                ndaText: displayedLegalText
            };
        case 'subscriptionKeyOnly':
            return {
                consentLabelText: ''
            };
        case 'none':
            return {};
    }
};
const $7c77225bb94251f6$export$26e651920d3efda5 = async ({ client: client, customEndpoint: customEndpoint, consentCheckboxValue: consentCheckboxValue, consentMode: consentMode, displayedLegalText: displayedLegalText, formId: formId, formType: formType, formValues: formValues, intercomAppId: intercomAppId, intercomTracking: intercomTracking, locale: locale, consentConfig: consentConfig, submissionEndpoint: submissionEndpoint })=>{
    const endpoint = $7c77225bb94251f6$var$getSubmissionEndpoint(submissionEndpoint, customEndpoint);
    const email = String(formValues['email'] ?? '');
    const consentLocale = $7c77225bb94251f6$var$getConsentLocale(consentConfig, locale);
    const controller = new AbortController();
    const timeout = window.setTimeout(()=>controller.abort(), $7c77225bb94251f6$var$SUBMISSION_TIMEOUT_MS);
    try {
        if (!$7c77225bb94251f6$var$isConsentHubDisabled() && consentMode !== 'none') try {
            const responseStatus = await $7c77225bb94251f6$var$withTimeout((0, $hhv63.updatePreferences)(client, {
                email: email,
                formId: formId,
                formUrl: window.location.href,
                paramsLocale: consentLocale,
                site: 'atlassian',
                source: 'uniform',
                consentCheckboxValue: consentCheckboxValue,
                ...$7c77225bb94251f6$var$getConsentTexts(consentMode, displayedLegalText)
            }, consentConfig));
            if (typeof responseStatus === 'number' && (responseStatus < 200 || responseStatus >= 300)) throw new Error(`Consent preferences update failed with status ${responseStatus}`);
        } catch (error) {
            if (error instanceof $7c77225bb94251f6$export$f03be7b0f3ccc7a0) throw error;
            throw new $7c77225bb94251f6$export$f03be7b0f3ccc7a0('preferences');
        }
        const now = new Date();
        let response;
        try {
            response = await fetch(`${(0, $eRzlV.getWacIntegrationUrl)()}${endpoint.path}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                signal: controller.signal,
                body: JSON.stringify({
                    ...formValues,
                    ...$7c77225bb94251f6$var$getAttribution(),
                    formType: formType,
                    ...endpoint.type === 'wacformlead' ? {
                        formDef: 'pointALead'
                    } : {},
                    formSubmissionId: crypto.randomUUID(),
                    created_at: now.toISOString(),
                    submitted: now.toString(),
                    source_sequence: now.getTime(),
                    locale: locale,
                    formUrl: window.location.href,
                    referrer: document.referrer,
                    userAgent: window.navigator.userAgent,
                    marketoCookieId: $7c77225bb94251f6$var$getCookie('_mkto_trk'),
                    anonymousId: $7c77225bb94251f6$var$getCookie('ajs_anonymous_id'),
                    atlassianId: $7c77225bb94251f6$var$getCookie('ajs_user_id'),
                    isIntercomTracking: intercomTracking,
                    intercomAppId: intercomTracking ? intercomAppId ?? '' : ''
                })
            });
        } catch  {
            if (controller.signal.aborted) throw new $7c77225bb94251f6$export$f03be7b0f3ccc7a0('timeout');
            throw new $7c77225bb94251f6$export$f03be7b0f3ccc7a0('lead');
        }
        if (!response.ok) throw new $7c77225bb94251f6$export$f03be7b0f3ccc7a0('lead');
    } finally{
        window.clearTimeout(timeout);
    }
};

});

parcelRegister("8yzBO", function(module, exports) {
$parcel$export(module.exports, "validateFormValues", function () { return $3d5e79173838bdeb$export$22be11368b300b4f; });
$parcel$export(module.exports, "validateFormConfiguration", function () { return $3d5e79173838bdeb$export$5d2fe55f227d58f8; });
$parcel$export(module.exports, "buildVisibleFormPayload", function () { return $3d5e79173838bdeb$export$d0723c11b00c5166; });
const $3d5e79173838bdeb$var$EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $3d5e79173838bdeb$var$PERSONAL_EMAIL_DOMAINS = new Set([
    'aol.com',
    'gmail.com',
    'hotmail.com',
    'icloud.com',
    'live.com',
    'outlook.com',
    'yahoo.com'
]);
const $3d5e79173838bdeb$var$ALLOWED_INTERCOM_APP_IDS = new Set([
    'p0ww63i2'
]);
const $3d5e79173838bdeb$var$isEmpty = (value)=>Array.isArray(value) ? value.length === 0 : !value?.trim();
const $3d5e79173838bdeb$export$587707c892e2649f = (fields, values)=>{
    const visibleFields = [];
    for (const field of fields){
        visibleFields.push(field);
        if (field.type !== 'formCustomChoiceField' && field.type !== 'formCountryOrStateField') continue;
        const selected = values[field.payloadKey];
        const selectedValues = Array.isArray(selected) ? selected : selected ? [
            selected
        ] : [];
        for (const option of field.options)if (selectedValues.includes(option.value)) visibleFields.push(...$3d5e79173838bdeb$export$587707c892e2649f(option.conditionalFields, values));
    }
    return visibleFields;
};
const $3d5e79173838bdeb$export$22be11368b300b4f = (fields, values, messages)=>{
    const errors = {};
    for (const field of $3d5e79173838bdeb$export$587707c892e2649f(fields, values))switch(field.type){
        case 'formNamesFields':
            if (field.required && $3d5e79173838bdeb$var$isEmpty(values['firstName'])) errors['firstName'] = messages.firstNameRequired;
            if (field.required && $3d5e79173838bdeb$var$isEmpty(values['lastName'])) errors['lastName'] = messages.lastNameRequired;
            break;
        case 'formEmailField':
            {
                const email = String(values['email'] ?? '').trim().toLowerCase();
                if (!email) errors['email'] = field.requiredMessage ?? messages.required;
                else if (!$3d5e79173838bdeb$var$EMAIL_PATTERN.test(email)) errors['email'] = messages.invalidEmail;
                else if (field.businessEmailOnly && $3d5e79173838bdeb$var$PERSONAL_EMAIL_DOMAINS.has(email.split('@')[1] ?? '')) errors['email'] = messages.businessEmail;
                break;
            }
        case 'formCompanyField':
            if (field.required && $3d5e79173838bdeb$var$isEmpty(values['company'])) errors['company'] = field.requiredMessage ?? messages.companyRequired;
            break;
        case 'formPhoneNumberField':
            if (field.required && $3d5e79173838bdeb$var$isEmpty(values['number'])) errors['number'] = messages.phoneRequired;
            break;
        case 'formCustomTextField':
        case 'formDatepickerField':
        case 'formCustomChoiceField':
        case 'formCountryOrStateField':
            if (field.required && $3d5e79173838bdeb$var$isEmpty(values[field.payloadKey])) errors[field.payloadKey] = field.requiredMessage ?? messages.required;
            break;
    }
    return errors;
};
const $3d5e79173838bdeb$export$5d2fe55f227d58f8 = ({ fields: fields, formId: formId, formType: formType, intercomAppId: intercomAppId, intercomTracking: intercomTracking })=>{
    const issues = [];
    const payloadKeys = new Set();
    let emailFieldCount = 0;
    if (!formId?.trim()) issues.push('formId is required');
    if (!formType?.trim()) issues.push('formType is required');
    if (intercomTracking && (!intercomAppId || !$3d5e79173838bdeb$var$ALLOWED_INTERCOM_APP_IDS.has(intercomAppId))) issues.push('intercomAppId is missing or is not allowlisted');
    // eslint-disable-next-line complexity -- validates the complete recursive authoring contract.
    const visit = (currentFields)=>{
        for (const field of currentFields){
            if (field.type === 'formEmailField') emailFieldCount += 1;
            const keys = field.type === 'formNamesFields' ? [
                'firstName',
                'lastName'
            ] : field.type === 'formEmailField' ? [
                'email'
            ] : field.type === 'formCompanyField' ? [
                'company'
            ] : field.type === 'formPhoneNumberField' ? [
                'number'
            ] : [
                field.payloadKey
            ];
            for (const key of keys){
                if (!key) {
                    issues.push('Custom fields require a payloadKey');
                    continue;
                }
                if (payloadKeys.has(key)) issues.push(`Duplicate payload key: ${key}`);
                payloadKeys.add(key);
            }
            if (field.type === 'formCustomChoiceField' || field.type === 'formCountryOrStateField') {
                if (!field.options.length) issues.push(`Choice field ${field.payloadKey} requires an option`);
                const optionValues = new Set();
                for (const option of field.options){
                    if (!option.value) issues.push(`Choice field ${field.payloadKey} has an empty option value`);
                    if (optionValues.has(option.value)) issues.push(`Choice field ${field.payloadKey} has duplicate option value: ${option.value}`);
                    optionValues.add(option.value);
                    visit(option.conditionalFields);
                }
            }
        }
    };
    visit(fields);
    if (emailFieldCount !== 1) issues.push('The form requires exactly one email field');
    return issues;
};
const $3d5e79173838bdeb$var$sanitizeString = (value)=>value.trim().replace(/</g, "\uFF1C").replace(/>/g, "\uFF1E");
const $3d5e79173838bdeb$export$d0723c11b00c5166 = (fields, values)=>{
    const payload = {};
    for (const field of $3d5e79173838bdeb$export$587707c892e2649f(fields, values)){
        const keys = field.type === 'formNamesFields' ? [
            'firstName',
            'lastName'
        ] : field.type === 'formEmailField' ? [
            'email'
        ] : field.type === 'formCompanyField' ? [
            'company'
        ] : field.type === 'formPhoneNumberField' ? [
            'number'
        ] : [
            field.payloadKey
        ];
        for (const key of keys){
            const value = values[key];
            if (Array.isArray(value)) payload[key] = value.map($3d5e79173838bdeb$var$sanitizeString).join(',');
            else if (typeof value === 'string') payload[key] = key === 'email' ? $3d5e79173838bdeb$var$sanitizeString(value).toLowerCase() : $3d5e79173838bdeb$var$sanitizeString(value);
        }
    }
    return payload;
};

});


parcelRegister("7d42O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c0a87c7a69a87c04$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $hcVGp = parcelRequire("hcVGp");
const $c0a87c7a69a87c04$var$UniformGlobalNav = ({ productKey: // This productKey is used for UFO instrumentation
// This prop is standardized to the value `uniform`
// See ldr/0018-set-standard-uniform-globalnav-productkey.md for more details
productKey = 'uniform', showCta: showCta = true })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
        productKey: productKey,
        isShowTryNowLink: showCta
    });
var $c0a87c7a69a87c04$export$2e2bcd8739ae039 = $c0a87c7a69a87c04$var$UniformGlobalNav;

});

parcelRegister("wwZ1W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $35f2008f0829ec0d$export$2e2bcd8739ae039; });
/* graph-paper-reveal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $35f2008f0829ec0d$var$containerStyles = null;
const $35f2008f0829ec0d$var$UniformGraphPaperReveal = ()=>{
    const ref = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const spotlight = ref.current;
        const parent = spotlight?.parentElement;
        function move(e) {
            if (!parent) return;
            const rect = parent.getBoundingClientRect();
            spotlight?.style.setProperty('--graph-grid-x', e.clientX - rect.left + 'px');
            spotlight?.style.setProperty('--graph-grid-y', e.clientY - rect.top + 'px');
        }
        if (window.PointerEvent) parent?.addEventListener('pointermove', move, {
            passive: true
        });
        return ()=>{
            parent?.removeEventListener('pointermove', move);
        };
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        className: (0, $2jatx.default)([
            "_kqswstnw _1r04idpf _1reo15vq _18m915vq _lcxvglyw _1kt9b3bt _1cs8stnw _1g0v1m4m _1tesidpf _1s6kxmqp _1ankwpg9 _wkf1atrn _aetrb3bt _18postnw _1bqq1mrw _9v7aidpf _16r21z0y"
        ])
    });
};
var $35f2008f0829ec0d$export$2e2bcd8739ae039 = $35f2008f0829ec0d$var$UniformGraphPaperReveal;

});

parcelRegister("f7IMH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0c2ad3f3cc2c800b$export$2e2bcd8739ae039; });
/* heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $dZNgt = parcelRequire("dZNgt");

var $jehLw = parcelRequire("jehLw");

var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");

var $ceJMD = parcelRequire("ceJMD");
const $0c2ad3f3cc2c800b$var$EMPHASIS_COLOR_TO_HEX = {
    purple: (0, $bNzAT.default)('color.primary.purple'),
    blue: (0, $bNzAT.default)('color.primary.blue'),
    orange: (0, $bNzAT.default)('color.extended.orange300')
};
/**
 * Recolors any `<em>` (italic) inside the heading to whatever value the
 * `--wac-heading-emphasis-color` CSS variable holds. The variable itself
 * is set as an inline style on the heading based on the `emphasisColor`
 * prop, which keeps this rule fully static so Compiled can extract it
 * cleanly at build time.
 */ const $0c2ad3f3cc2c800b$var$emphasisColorStyles = null;
const $0c2ad3f3cc2c800b$var$designRefreshEmphasisStyles = null;
const $0c2ad3f3cc2c800b$var$cssifySVG = (svgElement)=>{
    const svgString = (0, $jehLw.renderToStaticMarkup)(svgElement);
    return 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString) + '")';
};
const $0c2ad3f3cc2c800b$var$designRefreshBluesStyles = null;
const $0c2ad3f3cc2c800b$var$designRefreshPurpleOrangeStyles = null;
/**
 * AWF1 theme emphasis: renders the emphasised portion as outline
 * (stroked) text — the text fill is transparent so the page background
 * shows through, and a border around each glyph is drawn using the
 * heading's own text color.
 *
 * The specific `emphasisColor` value is intentionally ignored; any
 * emphasis selection simply triggers the outline effect using the same
 * color as the rest of the heading text.
 */ const $0c2ad3f3cc2c800b$var$awf1BlurReveal = null;
const $0c2ad3f3cc2c800b$var$awf1EmphasisStyles = null;
/**
 * Motion-blur ("smear") pseudo-element behind the outlined `<em>`.
 * The `::before` duplicates the text content (via `data-text`), renders
 * it with the heading text color, and applies the SVG directional
 * Gaussian blur filter to create a horizontal speed-streak effect.
 * Positioned behind the outlined text via `z-index: -1`.
 */ const $0c2ad3f3cc2c800b$var$awf1EmphasisBlurStyles = null;
/**
 * Hidden SVG containing the directional Gaussian blur filter used by
 * the AWF1 emphasis motion-blur effect.
 */ const $0c2ad3f3cc2c800b$var$Awf1SmearFilter = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsbidpf _4t3iidpf _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("filter", {
                id: "hero-smear",
                x: "-40%",
                y: "-40%",
                width: "180%",
                height: "180%",
                colorInterpolationFilters: "sRGB",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("feGaussianBlur", {
                    stdDeviation: "8 0.7"
                })
            })
        })
    });
// type WacTokenColor = "primary.black" | "primary.blue" | "primary.purple";
// interface CustomRichTextNode extends Record<string, unknown> {
//     type: "text" | "bold" | GestureLineType;
//     children?: CustomRichTextNode[];
//     text?: string;
//     version: number;
// }
// enum GestureLineType {
//     UNDERLINE_SQUIGGLE = "underline-squiggle",
//     EYELASH = "eyelash"
// }
// interface GestureLineNode extends CustomRichTextNode {
//     type: GestureLineType;
//     color: WacTokenColor;
//     children: CustomRichTextNode[];
// }
// interface CustomRichTextConfig {
//     content: CustomRichTextNode[];
//     plainText: string;
// }
const $0c2ad3f3cc2c800b$var$UniformHeading = ({ text: text, uniformRichText: uniformRichText, htmlTagType: // customRichText,
htmlTagType = 'h1', styleType: styleType = 'h1', alignment: alignment = 'start', wordWrap: wordWrap, emphasisColor: emphasisColor })=>{
    const { isDevTheme: isDevTheme, isAwf1Theme: isAwf1Theme } = (0, $eOIix.useTheme)();
    const useAwf1Blur = isAwf1Theme && !!emphasisColor;
    const isDesignRefreshEmphasisStyle = emphasisColor && emphasisColor.split('.').at(0) === 'designRefresh';
    const baseHeadingCss = null;
    const headingCss = [
        baseHeadingCss,
        // Only recolor `<em>` when the author explicitly picked a color.
        // Otherwise let italics render with the browser default font-style
        // and inherited color.
        emphasisColor && !isAwf1Theme && $0c2ad3f3cc2c800b$var$emphasisColorStyles,
        !isAwf1Theme && isDesignRefreshEmphasisStyle && $0c2ad3f3cc2c800b$var$designRefreshEmphasisStyles,
        !isAwf1Theme && emphasisColor === 'designRefresh.blues' && $0c2ad3f3cc2c800b$var$designRefreshBluesStyles,
        !isAwf1Theme && emphasisColor === 'designRefresh.purpleOrange' && $0c2ad3f3cc2c800b$var$designRefreshPurpleOrangeStyles,
        // AWF1 theme: any emphasis color → outline (stroked) text effect
        isAwf1Theme && emphasisColor && $0c2ad3f3cc2c800b$var$awf1EmphasisStyles,
        useAwf1Blur && $0c2ad3f3cc2c800b$var$awf1EmphasisBlurStyles,
        wordWrap && null
    ];
    // Inline-style overrides applied to the heading element. Sets the CSS
    // variable consumed by `emphasisColorStyles` (only when an emphasis
    // color is selected) and merges with the parent text color (if any)
    // so the heading itself still inherits container styling.
    //
    // Under AWF1 the emphasis stroke uses `currentColor` (inheriting the
    // heading text color), so the CSS variable is not needed.
    const headingStyle = {
        ...emphasisColor && !isDesignRefreshEmphasisStyle && !isAwf1Theme ? {
            ['--wac-heading-emphasis-color']: $0c2ad3f3cc2c800b$var$EMPHASIS_COLOR_TO_HEX[emphasisColor]
        } : null,
        color: 'var(--wac-color-heading)'
    };
    function resolveUniformRichText({ node: node, children: children }) {
        const nodeIsBold = (node)=>{
            return node.type === 'text' && (0, $dZNgt.getRichTextTagsFromTextFormat)(node.format).includes('strong');
        };
        const richTextValueHasBold = (value)=>{
            let hasBold = false;
            (0, $dZNgt.walkRichTextTree)(value, (node)=>{
                if (nodeIsBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const hasBoldText = richTextValueHasBold(node);
        const HeadingTag = htmlTagType;
        return /*#__PURE__*/ (0, $7VQPk.jsxs)(HeadingTag, {
            className: (0, $2jatx.default)([
                "_1mouze3t _y3gnoues _p12f1osq",
                emphasisColor && !isAwf1Theme && "_r7o3wj02 _cq6tn7od",
                !isAwf1Theme && isDesignRefreshEmphasisStyle && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz41gnr _1wybwebb _6rthpxbi _1cr81kdv _1rpf1j28 _1r2e1kdv _1nqb1x5a _1vb24pt2 _1alh1693 _so7d8pqr",
                !isAwf1Theme && emphasisColor === 'designRefresh.blues' && "_vhej128p _jlw81mtn",
                !isAwf1Theme && emphasisColor === 'designRefresh.purpleOrange' && "_vhej2rrj _jlw8izje",
                isAwf1Theme && emphasisColor && "_11gf1o8l _1ue0k553 _10bq1x6c _g3kh1rrh _5ms9eipq _ced1n7od _180v1q9c _c65lh2mm _pmtcu2gc _lvj71cl4",
                useAwf1Blur && "",
                useAwf1Blur && "_1m7c1q7a _15msstnw _16dxidpf _1rbvidpf _1fbbeipq _ea86idpf _1ktyeipq _kldx1rwr _1wib1mrw _ocbrglyw _19ug9vyt _o4xtluct _1qu3188d _1ciy6ui8 _emneeoah _zatjkb7n _4imw1ck0",
                wordWrap && "_1i4q1hna _3fcw150s",
                isDevTheme ? 'mono-font-family-heading' : isAwf1Theme ? 'sans-font-family-heading' : `${styleType} ${hasBoldText ? 'h1-contrast' : ''}`
            ]),
            style: {
                ...headingStyle,
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment),
                "--_12dmybu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue500')),
                "--_1lttd86": (0, $6ZVlx.default)($0c2ad3f3cc2c800b$var$cssifySVG((0, $ceJMD.blueShapesSVG)())),
                "--_1z9q1i": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.purple500')),
                "--_3zd0ej": (0, $6ZVlx.default)($0c2ad3f3cc2c800b$var$cssifySVG((0, $ceJMD.orangePurpleShapesSVG)())),
                "--_19gw9o2": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark100'))
            },
            children: [
                useAwf1Blur && /*#__PURE__*/ (0, $7VQPk.jsx)($0c2ad3f3cc2c800b$var$Awf1SmearFilter, {}),
                children
            ]
        });
    }
    /**
   * Custom text node resolver for AWF1 blur: when the text node has
   * italic format (format & 2), render `<em data-text="...">` so the
   * `::before` pseudo-element can duplicate the text for the blur
   * layer. This is part of React's render tree, so it survives
   * hydration — unlike imperative DOM manipulation via refs.
   */ function resolveAwf1TextNode({ node: node }) {
        const textNode = node;
        const tags = (0, $dZNgt.getRichTextTagsFromTextFormat)(textNode.format);
        const isItalic = tags.includes('em');
        const isBold = tags.includes('strong');
        let content = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: textNode.text
        });
        if (isBold) content = /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
            children: content
        });
        if (isItalic) content = /*#__PURE__*/ (0, $7VQPk.jsx)("em", {
            "data-text": textNode.text,
            children: content
        });
        return content;
    }
    function resolveUniformRichTextRenderer(node) {
        if (node.type === 'paragraph') return resolveUniformRichText;
        if (useAwf1Blur && node.type === 'text') return resolveAwf1TextNode;
        return undefined;
    }
    // const customRichTextIsConsideredEmpty = (
    //     customRichTextPropValue: CustomRichTextConfig | undefined
    // ) => {
    //     return (
    //         !customRichTextPropValue || customRichTextPropValue.plainText === ""
    //     );
    // };
    // const renderCustomRichText = () => {
    //     const nodeIsBold = (
    //         node: CustomRichTextNode
    //     ): node is CustomRichTextNode => {
    //         return node.type === "bold";
    //     };
    //     const walkCustomRichTextTree = (
    //         node: CustomRichTextNode,
    //         callBack: (node: CustomRichTextNode) => void
    //     ) => {
    //         callBack(node);
    //         if (node.children) {
    //             node.children.forEach((child) => {
    //                 walkCustomRichTextTree(child, callBack);
    //             });
    //         }
    //     };
    //     const customRichTextValueHasBold = (
    //         value: CustomRichTextNode
    //     ): boolean => {
    //         let hasBold = false;
    //         walkCustomRichTextTree(value, (node: CustomRichTextNode) => {
    //             if (nodeIsBold(node)) {
    //                 hasBold = true;
    //             }
    //         });
    //         return hasBold;
    //     };
    //     const hasBoldText = () => {
    //         let hasBold = false;
    //         customRichText?.content.forEach((node) => {
    //             if (customRichTextValueHasBold(node)) {
    //                 hasBold = true;
    //             }
    //         });
    //         return hasBold;
    //     };
    //     const HeadingTag = htmlTagType;
    //     const renderCustomRichTextNode = (
    //         node: CustomRichTextNode,
    //         index: number
    //     ) => {
    //         switch (node.type) {
    //             case "bold":
    //                 return (
    //                     <strong key={index}>
    //                         {node.children?.map((child, childIndex) =>
    //                             renderCustomRichTextNode(child, childIndex)
    //                         )}
    //                     </strong>
    //                 );
    //             case "underline-squiggle":
    //                 return (
    //                     <span
    //                         key={index}
    //                         css={css({
    //                             position: "relative"
    //                         })}
    //                     >
    //                         {getGestureLine(
    //                             node.type,
    //                             (node as GestureLineNode).color
    //                         )}
    //                         {node.children?.map((child, childIndex) =>
    //                             renderCustomRichTextNode(child, childIndex)
    //                         )}
    //                     </span>
    //                 );
    //             case "eyelash": {
    //                 return (
    //                     <>
    //                         <br />
    //                         <span
    //                             key={index}
    //                             css={css({ position: "relative" })}
    //                         >
    //                             {getGestureLine(
    //                                 node.type,
    //                                 (node as GestureLineNode).color
    //                             )}
    //                             {node.children?.map((child, childIndex) =>
    //                                 renderCustomRichTextNode(child, childIndex)
    //                             )}
    //                         </span>
    //                     </>
    //                 );
    //             }
    //             case "text":
    //             default:
    //                 return <span key={index}>{node.text || ""}</span>;
    //         }
    //     };
    //     return (
    //         <HeadingTag
    //             ref={headingRef as React.RefObject<HTMLHeadingElement>}
    //             css={headingCss}
    //             className={
    //                 isDarkTheme
    //                     ? "mono-font-family-heading"
    //                     : `${styleType} ${hasBoldText() ? "h1-contrast" : ""}`
    //             }
    //             style={headingStyle}
    //         >
    //             {customRichText?.content.map(
    //                 (node: CustomRichTextNode, index: number) =>
    //                     renderCustomRichTextNode(node, index)
    //             )}
    //         </HeadingTag>
    //     );
    // };
    const HeadingTag = htmlTagType;
    return !(0, $dZNgt.isRichTextValueConsideredEmpty)(uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
        node: uniformRichText?.root,
        resolveRichTextRenderer: resolveUniformRichTextRenderer
    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)(HeadingTag, {
        className: (0, $2jatx.default)([
            "_1mouze3t _y3gnoues _p12f1osq",
            emphasisColor && !isAwf1Theme && "_r7o3wj02 _cq6tn7od",
            !isAwf1Theme && isDesignRefreshEmphasisStyle && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz41gnr _1wybwebb _6rthpxbi _1cr81kdv _1rpf1j28 _1r2e1kdv _1nqb1x5a _1vb24pt2 _1alh1693 _so7d8pqr",
            !isAwf1Theme && emphasisColor === 'designRefresh.blues' && "_vhej128p _jlw81mtn",
            !isAwf1Theme && emphasisColor === 'designRefresh.purpleOrange' && "_vhej2rrj _jlw8izje",
            isAwf1Theme && emphasisColor && "_11gf1o8l _1ue0k553 _10bq1x6c _g3kh1rrh _5ms9eipq _ced1n7od _180v1q9c _c65lh2mm _pmtcu2gc _lvj71cl4",
            useAwf1Blur && "",
            useAwf1Blur && "_1m7c1q7a _15msstnw _16dxidpf _1rbvidpf _1fbbeipq _ea86idpf _1ktyeipq _kldx1rwr _1wib1mrw _ocbrglyw _19ug9vyt _o4xtluct _1qu3188d _1ciy6ui8 _emneeoah _zatjkb7n _4imw1ck0",
            wordWrap && "_1i4q1hna _3fcw150s",
            isDevTheme ? 'mono-font-family-heading' : isAwf1Theme ? 'sans-font-family-heading' : styleType
        ]),
        style: {
            ...headingStyle,
            "--_1v0xqnb": (0, $6ZVlx.default)(alignment),
            "--_12dmybu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue500')),
            "--_1lttd86": (0, $6ZVlx.default)($0c2ad3f3cc2c800b$var$cssifySVG((0, $ceJMD.blueShapesSVG)())),
            "--_1z9q1i": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.purple500')),
            "--_3zd0ej": (0, $6ZVlx.default)($0c2ad3f3cc2c800b$var$cssifySVG((0, $ceJMD.orangePurpleShapesSVG)())),
            "--_19gw9o2": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark100'))
        },
        children: [
            useAwf1Blur && /*#__PURE__*/ (0, $7VQPk.jsx)($0c2ad3f3cc2c800b$var$Awf1SmearFilter, {}),
            text
        ]
    });
};
var // const getGestureLine = (
//     gestureLine: GestureLineType,
//     gestureColor: WacTokenColor
// ) => {
//     switch (gestureLine) {
//         case "underline-squiggle":
//             return (
//                 <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="168"
//                     height="16"
//                     viewBox="0 0 168 16"
//                     fill="none"
//                     aria-hidden="true"
//                     css={css({
//                         position: "absolute",
//                         insetBlockEnd: token("space.negative.200"),
//                         insetInlineStart: "50%",
//                         transform: "translateX(-50%)"
//                     })}
//                 >
//                     <path
//                         d="M2.28772 11.6604C3.27772 12.0304 4.34772 11.9903 5.35772 11.8503C7.39772 11.5403 9.37772 10.8704 11.5877 10.1904C12.1377 9.84043 12.2377 9.88052 12.0577 9.53052C12.1777 9.40052 12.3777 9.17054 12.2377 9.05054C11.7477 8.23054 13.1677 7.92036 13.7077 7.62036C13.8777 8.38036 14.7577 8.34047 15.9677 7.98047C16.3177 7.88047 16.4477 7.83054 16.7777 7.80054C17.1377 7.75054 17.5177 7.69037 17.9177 7.63037C18.6977 7.55037 19.5677 7.43051 20.3677 7.52051C21.1777 7.59051 21.9477 7.82033 22.5477 8.34033C23.1577 8.85033 23.5977 9.61033 23.9377 10.3403C24.2777 11.0803 24.5277 11.7703 24.7977 12.3303C25.0477 12.8903 25.3077 13.2605 25.4377 13.4805C25.2677 13.7805 25.3077 14.2403 25.6877 14.5603C25.8477 14.7603 26.1177 14.8404 26.3877 14.9504C26.6777 15.0204 26.9977 15.0505 27.3177 15.0405C27.9777 14.9905 28.6077 14.7703 29.1477 14.6003C29.6277 14.4003 30.0777 14.2805 30.4177 14.2905C30.3777 14.3905 29.9477 14.8704 29.8977 14.9504C30.2677 15.0804 31.5877 14.5504 33.0877 13.6204C34.5877 12.6804 36.3277 11.3904 37.8377 10.1504C40.8877 7.70039 43.2477 5.65034 41.7577 7.85034C42.9077 7.23034 44.1177 6.56054 45.3277 5.80054C45.6277 5.61054 45.9377 5.42047 46.2477 5.23047L46.4577 5.10034L46.5577 5.05054C46.6177 5.02054 46.6877 4.98046 46.7477 4.97046H46.9577C46.9577 4.97046 47.0077 4.99048 47.0677 4.99048L47.3177 4.97046C47.6477 4.93046 47.9577 4.97046 48.2877 4.97046C49.5577 5.03046 50.7077 5.27036 51.5177 5.87036C52.3577 6.43036 53.0377 7.39032 53.8677 8.83032C54.2877 9.54032 54.7477 10.3605 55.4377 11.2405C56.1177 12.1105 57.1877 13.1003 58.5577 13.5903C58.8977 13.6903 59.2377 13.8104 59.5777 13.8804C59.9077 13.9304 60.2477 13.9705 60.5877 14.0005C61.2077 14.0005 61.8677 14.0004 62.4177 13.8804C62.6977 13.8304 62.9977 13.7905 63.2677 13.7205L64.0477 13.5005C64.5877 13.3605 65.0377 13.1605 65.5277 12.9805C69.2577 11.4205 72.3477 9.28033 75.4077 7.09033L77.3177 5.68042L78.2877 5.3103C78.6577 5.1603 78.9877 5.13052 79.3377 5.03052C79.5177 4.97052 79.6677 4.96045 79.8177 4.96045L80.2677 4.92041C80.4177 4.90041 80.5077 4.95044 80.6377 4.95044C80.7577 4.96044 80.8877 4.9505 80.9677 5.0105C81.3577 5.0805 81.7077 5.38037 82.1877 5.88037C83.1277 6.87037 84.1977 8.90048 86.2677 10.2405C86.7977 10.5505 87.3177 10.8705 87.8977 11.0505C88.1777 11.1505 88.4677 11.2603 88.7477 11.3403L89.6277 11.5005L90.1877 11.5903C90.3777 11.6103 90.5577 11.6904 90.7377 11.6204L91.7777 11.4004L93.0077 11.1504C99.5477 9.79039 105.978 9.92039 111.408 10.6504L111.248 10.4805C111.418 10.5405 111.958 10.4604 112.088 10.6704C113.168 10.3804 115.148 10.2204 116.858 10.1104C118.568 9.99035 120.008 9.98047 120.008 9.98047L126.178 9.68042C126.178 9.68042 128.828 10.0004 132.038 10.1804C135.248 10.3504 139.018 10.3505 141.168 9.75049C146.538 9.91049 151.978 9.90038 157.378 9.14038C157.378 9.14038 157.798 9.06042 158.458 8.93042C159.108 8.76042 159.998 8.50045 160.938 8.21045C161.878 7.90045 162.878 7.63048 163.728 7.24048C164.578 6.84048 165.308 6.46038 165.738 6.14038C166.818 5.34038 167.398 4.60032 167.398 4.08032C167.398 3.56032 166.798 3.26034 165.488 3.35034C164.838 3.40034 164.008 3.5403 162.978 3.8103C161.958 4.0903 160.678 4.30047 159.188 4.73047C159.108 4.69047 158.848 4.68034 158.798 4.60034C155.658 5.58034 152.388 5.81031 149.118 5.82031C147.488 5.85031 145.828 5.71044 144.178 5.70044C142.518 5.66044 140.838 5.55033 139.138 5.59033C139.218 5.88033 138.988 6.11045 138.788 5.96045L138.868 5.60034C134.278 6.20034 131.478 4.87037 127.188 5.88037C127.188 5.88037 127.698 5.43041 127.708 5.42041C124.088 5.28041 120.148 5.02035 115.968 4.86035C111.798 4.67035 107.398 4.61033 102.918 4.84033C101.798 4.92033 100.678 5.00032 99.5477 5.08032C98.4277 5.18032 97.2977 5.37051 96.1777 5.52051L94.4977 5.7605L92.8277 6.12036L91.1677 6.49048L90.4477 6.65039C90.5277 6.65039 90.4077 6.67039 90.3977 6.65039C90.3677 6.65039 90.3977 6.65037 90.3277 6.63037L90.0777 6.60034C89.8977 6.60034 89.7877 6.50046 89.6377 6.47046C89.3377 6.41046 89.1177 6.22034 88.8477 6.10034C88.3577 5.76034 87.8377 5.20043 87.2377 4.44043C86.6277 3.70043 85.9777 2.69047 84.7877 1.73047C84.5377 1.49047 84.1477 1.29032 83.8277 1.08032C83.4977 0.860322 83.1177 0.720332 82.7377 0.590332C81.9677 0.270332 81.2177 0.260439 80.4877 0.200439C80.5177 0.210439 80.5577 0.240498 80.5977 0.260498L80.5477 0.310303C80.8177 0.380303 81.2077 0.480342 81.6777 0.600342C82.1377 0.700342 82.7077 1.02054 83.2677 1.30054C84.3877 2.00054 85.2177 3.07043 85.7777 3.94043C86.3577 4.84043 86.7577 5.54052 87.1077 6.03052C87.4577 6.48052 87.6877 6.76048 87.6877 6.74048C86.5777 6.38048 85.6577 5.36052 84.6977 4.28052C84.1877 3.75052 83.6877 3.17048 82.9877 2.74048C82.3277 2.26048 81.5077 2.01037 80.6977 1.88037C79.8977 1.79037 79.0677 1.79041 78.3077 1.92041C77.4877 1.99041 76.8377 2.21041 76.0077 2.42041L75.6577 2.52051C75.5477 2.57051 75.4477 2.64045 75.3377 2.71045L74.8077 3.03052L73.9177 3.58032C73.3277 3.96032 72.7577 4.34047 72.1877 4.73047L71.9477 4.32031C72.9277 3.67031 73.7977 2.95035 74.5077 2.36035L74.6377 2.25049L74.8677 2.07031C75.0177 1.96031 75.1377 1.82049 75.2977 1.75049C75.5977 1.62049 75.8977 1.48039 76.0577 1.40039C76.4177 1.22039 76.7177 1.06042 76.9377 0.93042C76.6377 1.02042 76.3377 1.10043 76.0177 1.19043C75.8277 1.25043 75.6377 1.31036 75.4477 1.37036L75.0877 1.49048C74.9677 1.55048 74.8677 1.63044 74.7577 1.70044C74.2077 2.06044 73.6377 2.43031 73.0377 2.82031C71.9577 3.52031 70.7877 4.26048 69.5577 4.99048C68.3377 5.72048 67.0477 6.48035 65.7477 7.11035C64.4677 7.75035 63.1077 8.35031 61.9777 8.57031C61.4477 8.66031 60.9377 8.7304 60.6677 8.6604C60.3877 8.6004 60.2477 8.55031 59.9677 8.32031C59.6977 8.10031 59.3477 7.66033 58.9677 7.09033C58.5877 6.53033 58.1977 5.88043 57.7177 5.19043C56.8077 3.83043 55.4277 2.36054 53.8077 1.55054C52.1877 0.720537 50.5777 0.550342 49.3377 0.600342C49.3977 0.690342 49.6377 0.730479 49.9777 0.740479C50.3177 0.770479 50.7777 0.8304 51.2477 0.9104C51.7177 1.0204 52.2077 1.20043 52.5777 1.44043C52.9477 1.71043 53.2077 2.02036 53.2477 2.37036C52.0777 1.73036 50.7777 1.51044 49.5877 1.45044L48.6977 1.43042L47.8477 1.50049C47.5677 1.52049 47.2777 1.53032 47.0177 1.58032C46.6977 1.63032 46.3777 1.67046 46.0677 1.72046C46.0177 1.53046 46.0977 1.40053 46.2577 1.29053C46.3377 1.24053 46.4377 1.19039 46.5477 1.15039C46.6377 1.11039 46.7077 1.0903 46.7977 1.0603C47.1377 0.950303 47.5377 0.960381 47.6577 0.890381C47.5377 0.880381 47.3277 0.840352 47.0677 0.860352C46.9377 0.860352 46.7877 0.870371 46.6277 0.880371C46.3877 0.900371 46.1277 0.930439 45.8477 0.950439C45.6977 0.960439 45.5477 0.980488 45.3777 1.00049L45.1277 1.02051C45.0477 1.05051 44.9877 1.11039 44.9177 1.15039C44.6377 1.35039 44.3377 1.56053 44.0177 1.79053C43.6377 2.05053 43.2077 2.3404 42.7477 2.6604C40.9377 3.9104 38.5277 5.5904 35.7377 7.4104C34.3477 8.3304 32.8477 9.23033 31.3077 10.0903C30.9277 10.2903 30.5377 10.4804 30.1477 10.6804C29.7677 10.8504 29.3877 11.0204 28.9977 11.1904L28.4577 11.3704L28.1877 11.4705L28.0877 11.4905C27.9377 11.5305 27.8877 11.5305 27.8177 11.5205C27.6677 11.5205 27.5777 11.3805 27.5377 11.2505L27.2377 10.2505C27.0977 9.76049 26.9177 9.1703 26.6777 8.5603C26.4377 7.9403 26.0877 7.27035 25.6277 6.61035C25.3577 6.29035 25.0977 5.96041 24.7877 5.67041C24.4577 5.40041 24.1377 5.09038 23.7677 4.89038C22.2977 3.98038 20.7377 3.74048 19.4877 3.74048C18.1677 3.71048 17.0877 3.89035 15.9277 4.11035C15.7477 4.16035 15.5177 4.15049 15.3077 4.25049L14.7377 4.49048L13.9977 4.83032C13.5277 5.06032 13.0777 5.2805 12.6577 5.5105C10.9577 6.4105 9.43772 7.26043 8.02772 7.94043C6.62772 8.62043 5.32772 9.14035 4.32772 9.36035C3.83772 9.47035 3.42772 9.49046 3.18772 9.47046C2.95772 9.46046 2.81772 9.42033 2.64772 9.34033C2.36772 9.20033 2.02772 8.68046 1.82772 8.22046C1.59772 7.77046 1.46772 7.39051 1.29772 7.27051C1.13772 7.14051 0.99772 7.24036 0.86772 7.62036C0.73772 8.01036 0.61772 8.68038 0.80772 9.64038C0.63772 9.58038 0.44772 9.51041 0.28772 9.42041C0.58772 10.4404 1.30772 11.3504 2.30772 11.7004L2.28772 11.6604Z"
//                         fill={wacToken(`color.${gestureColor}`)}
//                     />
//                 </svg>
//             );
//         case "eyelash":
//             return (
//                 <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="117"
//                     height="117"
//                     viewBox="0 0 117 117"
//                     fill="none"
//                     aria-hidden="true"
//                     css={css({
//                         position: "absolute",
//                         insetInlineEnd: `calc(100% - ${token("space.100")})`,
//                         insetBlockStart: token("space.negative.150"),
//                         width: "auto",
//                         height: "90%"
//                     })}
//                 >
//                     <path
//                         d="M25.93 74.8872C25.1564 75.4245 12.3829 73.151 16.0089 71.2258C17.2313 70.3577 18.3652 70.4522 18.7372 71.7455C19.127 69.2416 21.5364 72.5841 22.7056 71.7691C22.3041 70.0211 25.7765 73.6706 25.115 71.8518C38.9455 69.9857 66.6537 86.9815 32.7862 76.7356C36.1641 75.956 32.987 75.2593 31.4693 75.6431C33.6248 77.8813 27.306 75.9325 26.1426 75.1589C28.1032 75.2061 24.8788 73.5526 25.9359 74.8813L25.93 74.8872Z"
//                         fill={wacToken(`color.${gestureColor}`)}
//                     />
//                     <path
//                         d="M51.0103 53.7517C49.2092 53.6395 41.6974 41.3562 40.7526 40.187C39.1994 37.311 43.345 37.0866 44.0123 39.5374C44.3489 39.9566 45.5123 43.4468 46.3568 41.9527C49.8823 42.7263 50.3548 48.9624 53.3311 49.3522C52.8528 50.173 53.9039 51.1533 53.6618 51.7025C54.5476 51.608 55.0377 52.795 54.8251 52.9013C58.5987 55.978 53.898 59.604 51.8784 55.1867C51.7248 55.3757 50.6973 54.5961 51.0102 53.7635L51.0103 53.7517Z"
//                         fill={wacToken(`color.${gestureColor}`)}
//                     />
//                     <path
//                         d="M96.948 30.7506C98.5602 32.788 98.4539 30.6385 97.6566 29.6523C96.198 31.477 96.2098 27.2133 96.6999 26.1208C96.7885 26.5637 97.5562 26.6346 97.4263 25.7133C95.5838 26.5637 94.0779 14.9005 98.5661 19.991C98.5779 20.1918 97.0838 20.4457 97.5739 20.6287C99.8121 19.9851 98.4007 21.9989 98.2767 22.5363C99.4578 22.3945 98.4066 23.0087 98.9086 23.0855C100.438 22.2764 98.0641 25.5598 99.57 24.6681C102.245 27.0834 99.564 32.7408 101.962 34.5478C99.44 36.2545 104.241 44.3981 98.8437 41.6462C97.3378 38.0734 96.3988 35.1147 96.948 30.7506Z"
//                         fill={wacToken(`color.${gestureColor}`)}
//                     />
//                     <path
//                         d="M67.6391 11.4579C71.2001 10.1291 71.1824 18.2727 72.8891 20.2983C75.2808 22.7136 85.4263 50.3746 77.5308 43.7665C74.5308 35.3689 70.6037 29.0087 68.2533 18.3672C67.7454 16.6664 65.0643 11.5051 67.6391 11.4579Z"
//                         fill={wacToken(`color.${gestureColor}`)}
//                     />
//                     <path
//                         d="M43.5337 100.854C45.9077 103.617 48.5592 99.584 50.7796 101.828C54.2166 106.222 27.3351 110.663 27.7485 105.737C28.6757 101.551 41.7739 102.826 43.5337 100.854Z"
//                         fill={wacToken(`color.${gestureColor}`)}
//                     />
//                 </svg>
//             );
//         default:
//             return null;
//     }
// };
$0c2ad3f3cc2c800b$export$2e2bcd8739ae039 = $0c2ad3f3cc2c800b$var$UniformHeading;

});
parcelRegister("ceJMD", function(module, exports) {
$parcel$export(module.exports, "blueShapesSVG", function () { return $ed2d318202bd2966$export$4b78ca8dd9f1ebf5; });
$parcel$export(module.exports, "orangePurpleShapesSVG", function () { return $ed2d318202bd2966$export$4f43b91428c248ba; });

var $7VQPk = parcelRequire("7VQPk");
const $ed2d318202bd2966$export$4b78ca8dd9f1ebf5 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "389",
        height: "207",
        viewBox: "0 0 389 207",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-250.535 100.922L-184.874 90.4661L-202.753 115.507L-202.021 146.247L-250.535 100.869V100.922ZM-134.949 110.698C-111.006 97.9941 -81.2595 107.09 -68.556 131.086L-5.14313 250.645C7.56036 274.589 -1.53593 304.335 -25.5314 317.038C-49.527 329.742 -79.2207 320.645 -91.9242 296.65L-155.337 177.09C-168.041 153.147 -158.944 123.401 -134.949 110.698Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M278.777 83.8796L287.299 149.802L262.78 131.191L231.989 131.034L278.725 83.8273L278.777 83.8796ZM265.603 199.1C277.575 223.409 267.59 252.842 243.281 264.865L121.892 324.776C97.5826 336.747 68.1501 326.762 56.1262 302.453C44.1023 278.144 54.1398 248.712 78.449 236.688L199.838 176.777C224.147 164.806 253.58 174.791 265.603 199.1Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-43.4141 -263.297L20.5739 -245.209L-6.14012 -229.996L-18.3731 -201.766L-43.3619 -263.297H-43.4141ZM57.3252 -205.844C84.4051 -207.308 107.512 -186.554 109.028 -159.474L116.347 -24.3354C117.811 2.74448 97.0564 25.8513 69.9765 27.3673C42.8966 28.8834 19.7897 8.07681 18.2737 -19.0031L10.9548 -154.141C9.49105 -181.221 30.2453 -204.328 57.3252 -205.844Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-300.983 -20.1016L-252.835 -65.9492L-253.358 -35.1576L-235.322 -10.2211L-301.035 -20.0493L-300.983 -20.1016ZM-200.244 -77.5549C-187.697 -101.603 -158.055 -110.96 -134.008 -98.4137L-13.9778 -35.8895C10.07 -23.3428 19.4278 6.29868 6.88113 30.3465C-5.66556 54.3943 -35.3071 63.752 -59.3549 51.2054L-179.385 -11.3189C-203.433 -23.8656 -212.79 -53.5071 -200.244 -77.5549Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M265.653 -107.927L270.881 -41.6388L247.303 -61.4521L216.564 -63.1773L265.653 -107.979V-107.927ZM246.676 6.50901C257.445 31.3932 245.996 60.3029 221.112 71.0721L96.9002 124.814C72.0159 135.583 43.1063 124.134 32.337 99.2499C21.5678 74.3656 33.0166 45.456 57.9008 34.6868L182.113 -19.0548C206.997 -29.8241 235.907 -18.3752 246.676 6.50901Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.7984 -116.866L34.6887 -50.7343L15.189 -74.5207L-14.7139 -81.8919L41.7984 -116.813V-116.866ZM2.01508 -7.91878C7.97473 18.5338 -8.59747 44.8295 -35.05 50.7892L-167.051 80.6398C-193.504 86.5995 -219.8 70.0274 -225.759 43.5748C-231.719 17.1222 -215.147 -9.17347 -188.694 -15.1331L-56.693 -44.9837C-30.2404 -50.9434 -3.9446 -34.3714 2.01508 -7.91878Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M242.811 189.743L188.389 151.528L218.658 145.986L239.569 123.402L242.811 189.743ZM166.694 102.23C140.66 94.6493 125.656 67.4126 133.236 41.3782L170.981 -88.5844C178.561 -114.619 205.798 -129.622 231.832 -122.042C257.867 -114.462 272.87 -87.2252 265.29 -61.1908L227.545 68.7718C219.965 94.8062 192.728 109.81 166.694 102.23Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.2233 -162.139L118.182 -113.155L87.4429 -114.2L62.1926 -96.5829L73.2233 -162.087V-162.139ZM128.847 -60.4066C152.686 -47.4417 161.468 -17.6434 148.503 6.19533L83.8357 125.075C70.8708 148.914 41.0724 157.696 17.2337 144.732C-6.60499 131.767 -15.3876 101.968 -2.42266 78.1296L62.245 -40.7501C75.2099 -64.5888 105.008 -73.3715 128.847 -60.4066Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-236.893 152.47L-180.589 117.078L-187.176 147.138L-174.421 175.159L-236.84 152.47H-236.893ZM-126.743 116.137C-109.701 95.069 -78.8045 91.7755 -57.6842 108.818L47.551 193.874C68.619 210.917 71.9124 241.813 54.8699 262.933C37.8273 284.053 6.93117 287.295 -14.1891 270.252L-119.424 185.196C-140.492 168.153 -143.786 137.257 -126.743 116.137Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-30.8142 -253.625L6.93022 -198.89L-23.3908 -204.222L-50.8367 -190.316L-30.8142 -253.677V-253.625ZM10.1192 -145.096C31.9191 -128.942 36.4673 -98.2026 20.3135 -76.4028L-60.299 32.3351C-76.4528 54.1349 -107.192 58.6831 -128.992 42.5292C-150.792 26.3754 -155.34 -4.36395 -139.186 -26.1638L-58.5739 -134.902C-42.42 -156.701 -11.6806 -161.25 10.1192 -145.096Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.1666 181.013L111.126 229.997L80.3862 228.952L55.1359 246.569L66.1666 181.065V181.013ZM121.79 282.798C145.629 295.763 154.412 325.561 141.447 349.4L76.779 468.28C63.8141 492.118 34.0158 500.901 10.1772 487.936C-13.6615 474.971 -22.4442 445.173 -9.47934 421.334L55.1883 302.454C68.1532 278.616 97.9515 269.833 121.79 282.798Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M320.289 163.447L353.643 220.953L323.844 213.268L295.405 225.03L320.289 163.447ZM352.702 274.799C373.142 292.573 375.338 323.574 357.563 344.067L268.743 446.218C250.969 466.658 219.968 468.854 199.475 451.08C179.035 433.305 176.839 402.304 194.614 381.811L283.434 279.661C301.208 259.22 332.209 257.024 352.702 274.799Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-185.816 166.688L-169.349 102.282L-153.456 128.63L-124.913 140.183L-185.816 166.74V166.688ZM-130.925 64.485C-133.068 37.4574 -112.941 13.7756 -85.9134 11.6323L49.0156 0.862955C76.0432 -1.28043 99.725 18.8465 101.868 45.8742C104.012 72.9018 83.8849 96.5836 56.8573 98.727L-78.0718 109.496C-105.099 111.64 -128.781 91.5127 -130.925 64.485Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-193.342 43.1568L-130.87 20.4159L-143.626 48.4369L-137.038 78.4966L-193.342 43.2091V43.1568ZM-78.017 30.7669C-56.8967 13.7244 -26.0004 17.0179 -8.95786 38.1381L76.0458 143.426C93.0883 164.546 89.795 195.442 68.6747 212.485C47.5545 229.527 16.6582 226.234 -0.384369 205.113L-85.388 99.826C-102.431 78.7057 -99.1372 47.8095 -78.017 30.7669Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-144.988 23.4496L-78.4909 22.5086L-99.7678 44.7267L-103.48 75.257L-144.988 23.3974V23.4496ZM-32.0158 49.7976C-6.50427 40.649 21.6212 53.9799 30.7699 79.4915L76.3561 206.945C85.5047 232.456 72.1738 260.582 46.6622 269.73C21.1506 278.879 -6.97473 265.548 -16.1234 240.037L-61.7096 112.583C-70.8582 87.0718 -57.5274 58.9463 -32.0158 49.7976Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-30.2357 244.846L-47.3828 180.596L-20.6166 195.809L9.91363 191.888L-30.1834 244.846H-30.2357ZM-32.3791 128.893C-47.4874 106.362 -41.4754 75.8838 -18.9437 60.7755L93.4536 -14.6091C115.985 -29.7174 146.463 -23.7055 161.572 -1.17375C176.68 21.358 170.668 51.836 148.136 66.9442L35.7389 142.329C13.2071 157.437 -17.2708 151.425 -32.3791 128.893Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M257.45 -217.185L302.409 -168.201L271.669 -169.246L246.419 -151.629L257.45 -217.133V-217.185ZM313.074 -115.4C336.912 -102.435 345.695 -72.6371 332.73 -48.7984L268.062 70.0814C255.097 93.9201 225.299 102.703 201.46 89.7378C177.622 76.7729 168.839 46.9746 181.804 23.1359L246.471 -95.7438C259.436 -119.583 289.235 -128.365 313.074 -115.4Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M122.314 73.3206L97.8999 135.165L85.4578 107.04L58.5869 91.9838L122.314 73.3206ZM55.032 167.787C53.7774 194.867 30.7751 215.778 3.69519 214.523L-131.495 208.197C-158.575 206.943 -179.486 183.94 -178.232 156.861C-176.977 129.781 -153.975 108.87 -126.895 110.124L8.29567 116.45C35.3756 117.704 56.2867 140.707 55.032 167.787Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M14.8776 151.684L-15.8095 210.653L-25.2718 181.378L-50.4174 163.656L14.9299 151.684H14.8776ZM-61.8662 238.674C-65.9439 265.493 -90.9327 283.947 -117.751 279.869L-251.582 259.585C-278.401 255.508 -296.855 230.519 -292.777 203.7C-288.7 176.882 -263.711 158.428 -236.892 162.505L-103.061 182.789C-76.2426 186.867 -57.7885 211.856 -61.8662 238.674Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.3516 381.288L26.3247 373.551L50.3202 354.26L57.9527 324.462L92.4038 381.288H92.3516ZM-16.2295 340.564C-42.7343 346.314 -68.8732 329.481 -74.6237 302.976L-103.272 170.713C-109.023 144.208 -92.1891 118.069 -65.6843 112.319C-39.1794 106.568 -13.0404 123.402 -7.28987 149.906L21.3583 282.169C27.1088 308.674 10.2754 334.813 -16.2295 340.564Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-193.711 76.5084L-144.204 32.0723L-145.615 62.8117L-128.312 88.2709L-193.711 76.5084ZM-91.2987 22.0349C-78.0724 -1.6469 -48.1695 -10.1159 -24.4877 3.11041L93.6602 69.1373C117.342 82.3636 125.811 112.266 112.585 135.948C99.3584 159.63 69.4555 168.099 45.7737 154.873L-72.3742 88.846C-96.056 75.6197 -104.525 45.7168 -91.2987 22.0349Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M101.921 58.525L140.45 4.36524L145.783 34.6864L168.262 55.7021L101.869 58.5774L101.921 58.525ZM189.853 -17.0686C197.59 -43.0507 224.879 -57.8976 250.913 -50.1605L380.667 -11.6318C406.649 -3.89465 421.496 23.3944 413.759 49.4288C406.021 75.4631 378.732 90.2577 352.698 82.5206L222.945 43.9918C196.963 36.2547 182.116 8.96573 189.853 -17.0686Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M568.915 177.667L566.667 244.112L545.495 221.79L515.174 216.667L568.915 177.667ZM537.34 289.228C545.234 315.158 530.648 342.604 504.718 350.498L375.278 390.02C349.349 397.914 321.903 383.328 314.009 357.398C306.115 331.469 320.7 304.023 346.63 296.129L476.07 256.607C502 248.713 529.446 263.298 537.34 289.228Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M311.086 -1.43771L359.233 -47.2854L358.711 -16.4937L376.746 8.4428L311.033 -1.38545L311.086 -1.43771ZM411.825 -58.9433C424.371 -82.9911 454.013 -92.3488 478.061 -79.8022L598.091 -17.2779C622.138 -4.73127 631.496 24.9103 618.949 48.9581C606.403 73.0059 576.761 82.3636 552.714 69.8169L432.684 7.29269C408.636 -5.25399 399.278 -34.8955 411.825 -58.9433Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M83.4648 2.01385L145.937 -20.7269L133.181 7.29396L139.768 37.3537L83.4648 2.06618V2.01385ZM198.79 -10.3237C219.91 -27.3663 250.806 -24.0728 267.849 -2.95252L352.852 102.335C369.895 123.455 366.601 154.351 345.481 171.394C324.361 188.437 293.465 185.143 276.422 164.023L191.418 58.7353C174.376 37.6151 177.669 6.71885 198.79 -10.3237Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-74.0977 -102.647L-16.7489 -136.262L-24.2768 -106.411L-12.4097 -78.0242L-74.0977 -102.647ZM37.0973 -135.53C54.7672 -156.075 85.7679 -158.375 106.313 -140.705L208.882 -52.408C229.427 -34.7381 231.728 -3.7374 214.058 16.8078C196.388 37.353 165.387 39.6532 144.842 21.9833L42.2728 -66.3139C21.7276 -83.9838 19.4274 -114.985 37.0973 -135.53Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M84.3086 -50.0568L150.806 -50.9978L129.529 -28.7797L125.817 1.75049L84.3086 -50.1091V-50.0568ZM197.229 -23.761C222.74 -32.9096 250.866 -19.5788 260.014 5.93273L305.601 133.386C314.749 158.898 301.418 187.023 275.907 196.172C250.395 205.32 222.27 191.989 213.121 166.478L167.535 39.0246C158.386 13.513 171.717 -14.6124 197.229 -23.761Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M90.9928 289.122L73.8457 224.872L100.612 240.085L131.142 236.164L91.0452 289.122H90.9928ZM88.8494 173.169C73.7411 150.638 79.7531 120.16 102.285 105.051L214.682 29.6668C237.214 14.5585 267.692 20.5705 282.8 43.1022C297.908 65.6339 291.896 96.1119 269.365 111.22L156.967 186.605C134.436 201.713 103.958 195.701 88.8494 173.169Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M74.5253 426.615L14.1966 398.647L43.0018 387.825L59.5737 361.895L74.5253 426.615ZM-15.9154 354.001C-42.8908 351.178 -62.4426 327.026 -59.6196 300.05L-45.5569 165.435C-42.7339 138.46 -18.5815 118.908 8.39387 121.731C35.3692 124.554 54.921 148.706 52.098 175.682L38.0353 310.297C35.2123 337.272 11.0599 356.824 -15.9154 354.001Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M209.14 -27.5756L257.288 -73.4232L256.765 -42.6316L274.801 -17.6951L209.088 -27.5233L209.14 -27.5756ZM309.88 -85.0289C322.426 -109.077 352.068 -118.434 376.116 -105.888L496.145 -43.3635C520.193 -30.8168 529.551 -1.17531 517.004 22.8725C504.457 46.9203 474.816 56.278 450.768 43.7314L330.738 -18.7929C306.691 -31.3396 297.333 -60.9811 309.88 -85.0289Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M178.717 154.926L241.189 132.185L228.433 160.206L235.02 190.266L178.717 154.978V154.926ZM294.042 142.536C315.162 125.494 346.058 128.787 363.101 149.908L448.104 255.195C465.147 276.315 461.853 307.211 440.733 324.254C419.613 341.297 388.717 338.003 371.674 316.883L286.67 211.595C269.628 190.475 272.921 159.579 294.042 142.536Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-15.7559 256.396L41.5929 222.781L34.0649 252.632L45.932 281.019L-15.7559 256.396ZM95.4391 223.513C113.109 202.968 144.11 200.668 164.655 218.337L267.224 306.635C287.769 324.305 290.069 355.305 272.4 375.851C254.73 396.396 223.729 398.696 203.184 381.026L100.615 292.729C80.0694 275.059 77.7692 244.058 95.4391 223.513Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.582 133.701L257.079 132.76L235.802 154.978L232.091 185.509L190.582 133.649V133.701ZM303.554 159.997C329.066 150.849 357.191 164.179 366.34 189.691L411.926 317.144C421.075 342.656 407.744 370.781 382.233 379.93C356.721 389.078 328.596 375.748 319.447 350.236L273.861 222.783C264.712 197.271 278.043 169.146 303.554 159.997Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M286.565 454.688L269.418 390.438L296.184 405.651L326.714 401.73L286.617 454.688H286.565ZM284.422 338.736C269.313 316.204 275.325 285.726 297.857 270.617L410.254 195.233C432.786 180.125 463.264 186.137 478.372 208.668C493.481 231.2 487.469 261.678 464.937 276.786L352.54 352.171C330.008 367.279 299.53 361.267 284.422 338.736Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-68.3457 -194.602L-8.64436 -165.327L-37.6586 -155.133L-54.7534 -129.569L-68.2934 -194.602H-68.3457ZM20.4744 -120.002C47.3975 -116.604 66.4265 -92.0334 62.9762 -65.1103L45.9337 69.1392C42.5356 96.0622 17.9651 115.091 -8.95802 111.641C-35.8811 108.191 -54.9102 83.6723 -51.4599 56.7493L-34.4173 -77.5001C-31.0192 -104.423 -6.44865 -123.452 20.4744 -120.002Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.668 -13.7203L96.0676 -25.8488L78.8158 -0.337156L80.3319 30.4022L30.668 -13.7203ZM146.463 -6.81963C170.093 -20.1505 200.048 -11.7337 213.327 11.8436L279.72 129.782C293.05 153.412 284.634 183.367 261.056 196.646C237.479 209.924 207.472 201.56 194.193 177.983L127.8 60.0437C114.469 36.4142 122.886 6.45893 146.463 -6.81963Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-17.2201 111.587L-68.6091 69.399L-38.0265 66.1578L-15.4948 45.1945L-17.2201 111.587ZM-86.5927 18.6373C-112 9.17503 -124.912 -19.1073 -115.398 -44.5143L-68.0863 -171.288C-58.624 -196.695 -30.3418 -209.608 -4.93475 -200.093C20.4723 -190.578 33.3849 -162.349 23.8704 -136.942L-23.4411 -10.1678C-32.9034 15.2392 -61.1856 28.1519 -86.5927 18.6373Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M485.852 106.204L459.661 167.317L448.003 138.825L421.603 123.037L485.852 106.204ZM415.957 198.735C413.918 225.763 390.341 246.047 363.313 244.008L228.332 233.866C201.304 231.827 181.02 208.25 183.059 181.223C185.098 154.195 208.675 133.911 235.703 135.95L370.684 146.092C397.712 148.131 417.996 171.708 415.957 198.735Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M387.405 35.5757L370.258 -28.6737L397.024 -13.4608L427.554 -17.3817L387.457 35.5757H387.405ZM385.262 -80.4287C370.153 -102.96 376.165 -133.438 398.697 -148.547L511.094 -223.931C533.626 -239.04 564.104 -233.028 579.212 -210.496C594.321 -187.964 588.309 -157.486 565.777 -142.378L453.38 -66.9933C430.848 -51.8851 400.37 -57.897 385.262 -80.4287Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M205.268 -146.978L204.066 -80.4811L182.528 -102.438L152.102 -107.09L205.268 -146.926V-146.978ZM175.418 -34.8948C183.73 -9.06956 169.563 18.5854 143.737 26.8976L14.9249 68.4061C-10.9003 76.7183 -38.5553 62.551 -46.8675 36.7258C-55.1797 10.9005 -41.0124 -16.7544 -15.1872 -25.0666L113.625 -66.5751C139.451 -74.8873 167.106 -60.72 175.418 -34.8948Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M252.528 13.3573L186.031 12.4686L207.883 -9.17445L212.379 -39.6001L252.476 13.3573H252.528ZM140.288 -15.9706C114.515 -7.55386 86.8074 -21.5643 78.3384 -47.3373L36.2025 -175.941C27.7858 -201.714 41.7962 -229.421 67.5692 -237.89C93.3422 -246.359 121.049 -232.296 129.518 -206.523L171.654 -77.9197C180.071 -52.1468 166.061 -24.4396 140.288 -15.9706Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M158.479 177.248L150.062 243.223L131.033 219.018L101.287 211.072L158.427 177.196L158.479 177.248ZM116.605 285.464C122.094 312.021 104.999 338.003 78.442 343.44L-54.1346 370.729C-80.6917 376.218 -106.674 359.123 -112.111 332.566C-117.548 306.009 -100.505 280.027 -73.9478 274.59L58.6287 247.301C85.1858 241.812 111.168 258.907 116.605 285.464Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M262.355 103.119L321.848 73.4249L312.333 102.7L322.266 131.819L262.355 103.171V103.119ZM375.537 77.7117C394.566 58.3689 425.671 58.1598 444.962 77.1889L541.362 172.178C560.705 191.207 560.914 222.312 541.885 241.603C522.856 260.893 491.751 261.155 472.46 242.125L376.06 147.137C356.717 128.107 356.508 97.0022 375.537 77.7117Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M233.762 99.6157L296.234 76.8749L283.478 104.896L290.065 134.956L233.762 99.668V99.6157ZM349.087 87.2258C370.207 70.1833 401.103 73.4768 418.145 94.597L503.149 199.884C520.192 221.005 516.898 251.901 495.778 268.944C474.658 285.986 443.762 282.693 426.719 261.572L341.715 156.285C324.673 135.165 327.966 104.268 349.087 87.2258Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M46.084 216.354L103.433 182.739L95.9047 212.59L107.772 240.976L46.084 216.354ZM157.331 183.471C175.001 162.926 206.002 160.625 226.547 178.295L329.116 266.592C349.661 284.262 351.961 315.263 334.292 335.808C316.622 356.353 285.621 358.654 265.076 340.984L162.507 252.687C141.961 235.017 139.661 204.016 157.331 183.471Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.5613 243.903L-36.5701 237.055L-12.8361 217.45L-5.62175 187.548L29.5613 243.903ZM-79.5948 204.59C-105.995 210.707 -132.395 194.187 -138.46 167.787L-168.885 35.8896C-175.002 9.48935 -158.482 -16.911 -132.082 -22.9752C-105.681 -29.0917 -79.2812 -12.5719 -73.2169 13.8284L-42.7912 145.725C-36.6747 172.126 -53.1945 198.526 -79.5948 204.59Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M247.721 79.9076L314.218 78.9666L292.941 101.185L289.229 131.715L247.721 79.8553V79.9076ZM360.693 106.203C386.205 97.0547 414.33 110.386 423.479 135.897L469.065 263.35C478.214 288.862 464.883 316.988 439.371 326.136C413.859 335.285 385.734 321.954 376.585 296.442L330.999 168.989C321.851 143.477 335.181 115.352 360.693 106.203Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M348.774 395.718L331.627 331.468L358.393 346.681L388.923 342.76L348.826 395.718H348.774ZM346.631 279.713C331.522 257.181 337.534 226.703 360.066 211.595L472.463 136.211C494.995 121.102 525.473 127.114 540.581 149.646C555.69 172.178 549.678 202.656 527.146 217.764L414.749 293.149C392.217 308.257 361.739 302.245 346.631 279.713Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-75.3027 194.709L-10.0078 207.256L-35.3626 224.717L-45.1385 253.888L-75.3027 194.709ZM30.037 243.275C56.9078 239.511 81.7399 258.175 85.5039 285.045L104.376 419.086C108.14 445.957 89.4769 470.788 62.6062 474.552C35.7354 478.316 10.9033 459.653 7.13931 432.783L-11.7329 298.742C-15.4969 271.871 3.16622 247.039 30.037 243.275Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-221.785 199.153L-234.07 133.805L-208.559 150.953L-177.819 149.384L-221.837 199.153H-221.785ZM-215.198 83.4097C-228.581 59.8324 -220.269 29.8772 -196.692 16.4941L-78.9098 -50.2124C-55.3325 -63.5955 -25.3774 -55.2834 -11.9943 -31.7061C1.38885 -8.1288 -6.9232 21.8264 -30.5005 35.2095L-148.282 101.916C-171.86 115.299 -201.815 106.987 -215.198 83.4097Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M316.466 -78.5991L297.646 -14.8202L282.695 -41.7432L254.622 -54.2899L316.466 -78.5991ZM257.863 21.4606C259.013 48.5405 237.997 71.4382 210.917 72.5883L75.6747 78.3911C48.5948 79.5413 25.6971 58.5256 24.547 31.4457C23.3969 4.36578 44.4125 -18.5319 71.4924 -19.682L206.735 -25.4848C233.815 -26.635 256.713 -5.61929 257.863 21.4606Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.8262 -212.17L140.814 -194.082L114.1 -178.869L101.867 -150.639L76.8783 -212.17H76.8262ZM177.618 -154.716C204.698 -156.18 227.804 -135.426 229.32 -108.346L236.639 26.7922C238.103 53.8721 217.349 76.9789 190.269 78.4949C163.189 80.011 140.082 59.2044 138.566 32.1245L131.247 -103.014C129.784 -130.094 150.538 -153.2 177.618 -154.716Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M181.38 -0.548485L229.528 -46.3961L229.005 -15.6045L247.041 9.33202L181.328 -0.496231L181.38 -0.548485ZM282.172 -58.0541C294.719 -82.1019 324.36 -91.4596 348.408 -78.9129L468.438 -16.3886C492.486 -3.84197 501.843 25.7995 489.297 49.8473C476.75 73.8951 447.108 83.2528 423.061 70.7061L303.031 8.18191C278.983 -4.36477 269.625 -34.0063 282.172 -58.0541Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M136.887 203.072L196.588 232.348L167.574 242.542L150.479 268.106L136.939 203.072H136.887ZM225.707 277.621C252.63 281.019 271.659 305.589 268.209 332.512L251.166 466.762C247.768 493.685 223.197 512.714 196.274 509.264C169.351 505.813 150.322 481.295 153.773 454.372L170.815 320.122C174.213 293.199 198.784 274.17 225.707 277.621Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M230.521 140.443L295.921 128.315L278.669 153.826L280.185 184.566L230.521 140.443ZM346.317 147.292C369.946 133.961 399.902 142.378 413.18 165.955L479.573 283.894C492.904 307.523 484.487 337.479 460.91 350.757C437.333 364.036 407.325 355.671 394.046 332.094L327.654 214.155C314.323 190.526 322.74 160.57 346.317 147.292Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M106.466 191.154L74.3673 132.917L104.009 141.229L132.709 130.093L106.466 191.154ZM76.5107 79.0703C56.4361 60.8254 54.9199 29.7723 73.1649 9.69766L164.181 -90.5189C182.426 -110.594 213.478 -112.11 233.553 -93.8647C253.628 -75.6197 255.144 -44.5667 236.899 -24.492L145.883 75.7246C127.638 95.7993 96.5854 97.3153 76.5107 79.0703Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M677.133 166.531L618.686 198.212L627.208 168.623L616.282 139.87L677.133 166.531ZM564.84 195.65C546.491 215.568 515.385 216.875 495.467 198.473L395.93 106.778C376.013 88.4284 374.706 57.3231 393.108 37.4052C411.509 17.4874 442.562 16.1804 462.48 34.5822L562.017 126.277C581.935 144.627 583.242 175.732 564.84 195.65Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.4082 1.85736L41.0154 -64.5354L61.7697 -41.7946L91.9863 -36.0441L37.4605 1.85736H37.4082ZM71.2843 -109.076C63.9131 -135.163 79.0736 -162.295 105.16 -169.666L235.384 -206.522C261.471 -213.893 288.603 -198.733 295.974 -172.646C303.345 -146.559 288.185 -119.427 262.098 -112.056L131.874 -75.2001C105.788 -67.8289 78.6555 -82.9895 71.2843 -109.076Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.957 -180.436L120.429 -203.177L107.673 -175.156L114.26 -145.096L57.957 -180.384V-180.436ZM173.23 -192.826C194.35 -209.868 225.246 -206.575 242.289 -185.455L327.292 -80.1672C344.335 -59.047 341.041 -28.1507 319.921 -11.1082C298.801 5.9344 267.905 2.64088 250.862 -18.4794L165.859 -123.767C148.816 -144.887 152.109 -175.783 173.23 -192.826Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.5957 46.1868L105.944 12.5722L98.4164 42.4229L110.284 70.8097L48.5957 46.1868ZM159.791 13.3041C177.461 -7.24108 208.461 -9.54133 229.006 8.12857L331.576 96.4258C352.121 114.096 354.421 145.096 336.751 165.642C319.081 186.187 288.08 188.487 267.535 170.817L164.966 82.5199C144.421 64.85 142.121 33.8493 159.791 13.3041Z",
                fill: "#4D8CED"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M61.7767 404.656L-4.35474 397.808L19.3793 378.204L26.5936 348.301L61.7767 404.656ZM-47.3271 365.396C-73.7274 371.512 -100.128 354.993 -106.192 328.592L-136.618 196.695C-142.734 170.295 -126.214 143.895 -99.8141 137.831C-73.4138 131.766 -47.0134 148.234 -40.9492 174.634L-10.5236 306.531C-4.40714 332.931 -20.9268 359.332 -47.3271 365.396Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M104.693 -199.1L171.191 -200.041L149.914 -177.823L146.202 -147.293L104.693 -199.153V-199.1ZM217.666 -172.805C243.177 -181.953 271.303 -168.622 280.451 -143.111L326.038 -15.6574C335.186 9.85416 321.855 37.9796 296.344 47.1282C270.832 56.2768 242.707 42.9459 233.558 17.4344L187.972 -110.019C178.823 -135.53 192.154 -163.656 217.666 -172.805Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M221.485 26.95L204.338 -37.2995L231.104 -22.0867L261.634 -26.0075L221.537 26.95H221.485ZM219.342 -89.0022C204.233 -111.534 210.245 -142.012 232.777 -157.12L345.174 -232.505C367.706 -247.613 398.184 -241.601 413.292 -219.069C428.401 -196.538 422.389 -166.06 399.857 -150.951L287.46 -75.5669C264.928 -60.4586 234.45 -66.4705 219.342 -89.0022Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M139.775 211.805L201.15 186.241L189.648 214.785L197.595 244.531L139.775 211.805ZM254.421 194.187C274.705 176.204 305.757 178.086 323.741 198.422L413.45 299.789C431.433 320.072 429.551 351.125 409.215 369.109C388.879 387.093 357.878 385.211 339.895 364.874L250.186 263.508C232.203 243.224 234.085 212.171 254.421 194.187Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M326.983 140.028L311.979 204.8L295.512 178.818L266.759 167.945L327.035 140.028H326.983ZM274.392 243.434C277.162 270.409 257.506 294.509 230.531 297.28L95.9152 311.029C68.9399 313.8 44.8397 294.143 42.069 267.168C39.2983 240.193 58.9548 216.092 85.9301 213.322L220.546 199.573C247.521 196.802 271.621 216.458 274.392 243.434Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M217.458 -18.8969L167.794 25.3302L169.362 -5.40919L152.163 -30.9208L217.51 -18.8969H217.458ZM114.837 35.1584C101.506 58.788 71.5505 67.1002 47.9732 53.7693L-69.9132 -12.7281C-93.5428 -26.0589 -101.855 -56.0141 -88.5241 -79.5914C-75.1932 -103.221 -45.238 -111.533 -21.6607 -98.2023L96.2257 -31.7049C119.855 -18.3741 128.167 11.5812 114.837 35.1584Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M97.4268 178.398L74.9473 115.822L102.864 128.735L132.976 122.304L97.4268 178.451V178.398ZM85.5596 63.0213C68.6216 41.8488 72.072 10.9527 93.2445 -5.98534L198.95 -90.5185C220.123 -107.457 251.019 -104.006 267.957 -82.8337C284.895 -61.6612 281.445 -30.765 260.272 -13.827L154.566 70.7062C133.394 87.6442 102.498 84.1938 85.5596 63.0213Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M345.591 261.625L377.847 203.492L386.525 233.03L411.2 251.431L345.539 261.678L345.591 261.625ZM424.635 176.674C429.393 149.96 454.904 132.238 481.618 136.995L614.822 160.834C641.536 165.591 659.258 191.103 654.501 217.817C649.744 244.531 624.232 262.253 597.518 257.495L464.314 233.657C437.6 228.9 419.878 203.388 424.635 176.674Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M319.19 269.677L261.527 236.585L291.169 228.325L309.937 203.912L319.242 269.677H319.19ZM235.441 189.483C208.831 184.307 191.423 158.587 196.598 131.925L222.319 -0.96516C227.494 -27.5746 253.215 -44.9831 279.877 -39.8076C306.538 -34.6321 323.895 -8.91137 318.719 17.7503L292.998 150.64C287.823 177.25 262.102 194.658 235.441 189.483Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M226.977 -282.64L290.965 -264.551L264.251 -249.339L252.018 -221.109L227.029 -282.64H226.977ZM327.716 -225.186C354.796 -226.65 377.902 -205.896 379.419 -178.816L386.738 -43.6776C388.201 -16.5977 367.447 6.50909 340.367 8.02515C313.287 9.5412 290.18 -11.2654 288.664 -38.3453L281.345 -173.483C279.882 -200.563 300.636 -223.67 327.716 -225.186Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-224.549 -33.6411L-176.401 -79.4888L-176.924 -48.6972L-158.888 -23.7606L-224.602 -33.5889L-224.549 -33.6411ZM-123.81 -91.1467C-111.263 -115.195 -81.6218 -124.552 -57.5741 -112.006L62.4559 -49.4813C86.5037 -36.9346 95.8614 -7.29312 83.3147 16.7547C70.768 40.8025 41.1265 50.1601 17.0787 37.6135L-102.951 -24.9107C-126.999 -37.4574 -136.357 -67.0989 -123.81 -91.1467Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M359.605 310.087L293.578 302.35L317.574 283.059L325.206 253.261L359.657 310.087H359.605ZM250.972 269.363C224.467 275.113 198.328 258.28 192.577 231.775L163.929 99.5121C158.179 73.0072 175.012 46.8683 201.517 41.1178C228.022 35.3672 254.161 52.2006 259.911 78.7054L288.559 210.968C294.31 237.473 277.477 263.612 250.972 269.363Z",
                fill: "#4D8CED"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M169.623 133.963L236.12 133.022L214.843 155.24L211.132 185.77L169.623 133.911V133.963ZM282.595 160.259C308.107 151.11 336.232 164.441 345.381 189.953L390.967 317.406C400.116 342.918 386.785 371.043 361.274 380.192C335.762 389.34 307.636 376.009 298.488 350.498L252.902 223.045C243.753 197.533 257.084 169.407 282.595 160.259Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-113.878 26.3229L-131.025 -37.9266L-104.259 -22.7137L-73.7289 -26.6346L-113.826 26.3229H-113.878ZM-116.022 -89.6294C-131.13 -112.161 -125.118 -142.639 -102.586 -157.747L9.81107 -233.132C32.3428 -248.24 62.8208 -242.228 77.929 -219.697C93.0373 -197.165 87.0254 -166.687 64.4936 -151.579L-47.9037 -76.1939C-70.4354 -61.0856 -100.913 -67.0976 -116.022 -89.6294Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M410.203 333.403L370.942 279.766L401.368 284.21L428.396 269.52L410.203 333.403ZM366.185 226.077C343.967 210.551 338.478 179.968 354.005 157.698L431.428 46.712C446.954 24.4939 477.537 19.0047 499.807 34.5312C522.078 50.0577 527.515 80.6403 511.988 102.911L434.565 213.896C419.038 236.115 388.456 241.604 366.185 226.077Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M328.909 136.159L327.707 202.656L306.168 180.699L275.742 176.047L328.909 136.211V136.159ZM299.058 248.242C307.37 274.067 293.203 301.722 267.378 310.035L138.566 351.543C112.74 359.855 85.0853 345.688 76.7731 319.863C68.4609 294.038 82.6282 266.383 108.453 258.07L237.266 216.562C263.091 208.25 290.746 222.417 299.058 248.242Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.3668 -3.21293L107.515 -49.0605L106.992 -18.2689L125.028 6.66757L59.3145 -3.16061L59.3668 -3.21293ZM160.106 -60.6662C172.653 -84.714 202.294 -94.0717 226.342 -81.5251L346.372 -19.0008C370.42 -6.45409 379.777 23.1874 367.231 47.2352C354.684 71.283 325.042 80.6407 300.995 68.094L180.965 5.56979C156.917 -6.97689 147.559 -36.6184 160.106 -60.6662Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-269.668 74.7848L-207.196 52.044L-219.952 80.0649L-213.365 110.125L-269.668 74.8371V74.7848ZM-154.395 62.395C-133.275 45.3524 -102.379 48.6459 -85.3365 69.7662L-0.332703 175.054C16.7099 196.174 13.4164 227.07 -7.70389 244.113C-28.8241 261.155 -59.7203 257.862 -76.7628 236.742L-161.767 131.454C-178.809 110.334 -175.516 79.4375 -154.395 62.395Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M232.454 129.886L215.307 65.6363L242.073 80.8492L272.603 76.9283L232.506 129.886H232.454ZM230.31 13.9335C215.202 -8.59819 221.214 -39.0761 243.746 -54.1844L356.143 -129.569C378.675 -144.677 409.153 -138.665 424.261 -116.134C439.369 -93.6019 433.357 -63.1239 410.826 -48.0156L298.428 27.369C275.897 42.4773 245.419 36.4653 230.31 13.9335Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M311.505 494.263L268.428 443.658L299.115 445.854L324.993 429.229L311.505 494.263ZM259.75 390.491C236.434 376.638 228.749 346.526 242.603 323.21L311.714 206.839C325.568 183.523 355.68 175.839 378.996 189.692C402.311 203.546 409.996 233.658 396.143 256.974L327.031 373.344C313.178 396.66 283.066 404.345 259.75 390.491Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M137.059 217.607L199.531 194.866L186.775 222.887L193.362 252.946L137.059 217.659V217.607ZM252.383 205.269C273.504 188.226 304.4 191.52 321.442 212.64L406.446 317.928C423.489 339.048 420.195 369.944 399.075 386.987C377.955 404.029 347.059 400.736 330.016 379.615L245.012 274.328C227.97 253.208 231.263 222.311 252.383 205.269Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M440.786 -295.289L485.745 -246.305L455.005 -247.35L429.755 -229.733L440.786 -295.237V-295.289ZM496.409 -193.504C520.248 -180.539 529.031 -150.741 516.066 -126.902L451.398 -8.02261C438.433 15.8161 408.635 24.5988 384.796 11.6339C360.958 -1.33099 352.175 -31.1294 365.14 -54.9681L429.807 -173.848C442.772 -197.687 472.571 -206.469 496.409 -193.504Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-101.131 270.093L-52.6171 224.611L-53.349 255.351L-35.4699 280.392L-101.079 270.041L-101.131 270.093ZM0.0789108 213.424C12.7824 189.481 42.5286 180.384 66.4718 193.088L186.031 256.553C209.974 269.257 219.071 299.003 206.367 322.946C193.664 346.889 163.918 355.986 139.974 343.282L20.4151 279.817C-3.52818 267.113 -12.6246 237.367 0.0789108 213.424Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M324.729 150.325L307.582 86.0759L334.348 101.289L364.878 97.3679L324.781 150.325H324.729ZM322.586 34.3209C307.477 11.7891 313.489 -18.6888 336.021 -33.7971L448.418 -109.182C470.95 -124.29 501.428 -118.278 516.536 -95.7464C531.645 -73.2146 525.633 -42.7367 503.101 -27.6284L390.704 47.7562C368.172 62.8645 337.694 56.8526 322.586 34.3209Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M163.644 -42.6136L144.824 21.1653L129.873 -5.75779L101.799 -18.3044L163.644 -42.6136ZM105.041 57.4984C106.191 84.5783 85.1752 107.476 58.0953 108.626L-77.1476 114.429C-104.227 115.579 -127.125 94.5634 -128.275 67.4835C-129.425 40.4036 -108.41 17.5059 -81.3297 16.3558L53.9129 10.5529C80.9929 9.40275 103.891 30.4185 105.041 57.4984Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.538 70.9435L213.368 128.763L183.622 120.817L155.078 132.318L180.485 70.9435H180.538ZM211.904 182.609C232.188 200.593 234.122 231.593 216.139 251.929L126.43 353.296C108.447 373.58 77.446 375.514 57.1099 357.53C36.7738 339.547 34.8917 308.546 52.8752 288.21L142.584 186.844C160.568 166.56 191.568 164.626 211.904 182.609Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M506.49 201.062L527.088 264.266L499.537 250.517L469.268 256.059L506.49 201.062ZM514.855 316.753C531.165 338.448 526.774 369.188 505.079 385.499L396.864 466.791C375.168 483.101 344.429 478.71 328.118 457.015C311.808 435.319 316.199 404.58 337.894 388.269L446.109 306.977C467.805 290.667 498.544 295.058 514.855 316.753Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-302.297 145.544L-244.948 111.93L-252.476 141.781L-240.609 170.167L-302.297 145.544ZM-191.05 112.662C-173.38 92.1166 -142.379 89.8161 -121.834 107.486L-19.2648 195.783C1.28036 213.453 3.58054 244.454 -14.0894 264.999C-31.7593 285.544 -62.76 287.845 -83.3051 270.175L-185.874 181.878C-206.419 164.208 -208.72 133.207 -191.05 112.662Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.1197 362.444L2.42732 307.657L32.7485 313.042L60.1944 299.136L40.1197 362.444ZM-0.761553 253.863C-22.5091 237.709 -27.0573 206.97 -10.9035 185.17L69.7612 76.4844C85.915 54.7369 116.654 50.1887 138.454 66.3425C160.254 82.4964 164.75 113.236 148.596 135.036L67.9314 243.721C51.7776 265.469 21.0383 270.017 -0.761553 253.863Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-110.231 179.156L-85.7649 117.311L-73.3228 145.437L-46.5042 160.493L-110.283 179.104L-110.231 179.156ZM-42.897 84.7423C-41.6424 57.6624 -18.6403 36.7512 8.43965 38.0059L143.63 44.384C170.71 45.6386 191.621 68.6406 190.367 95.7205C189.112 122.8 166.11 143.712 139.03 142.457L3.83934 136.079C-23.2406 134.824 -44.1517 111.822 -42.897 84.7423Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M337.111 -152.494L396.813 -123.219L367.798 -113.024L350.703 -87.4605L337.163 -152.494H337.111ZM425.931 -77.9459C452.854 -74.5479 471.884 -49.9773 468.433 -23.0542L451.391 111.195C447.993 138.118 423.422 157.147 396.499 153.697C369.576 150.247 350.547 125.728 353.997 98.8053L371.04 -35.444C374.438 -62.3671 399.008 -81.3963 425.931 -77.9459Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.44043 51.0242L-55.1293 70.524L-40.9097 43.2348L-45.9285 12.8614L8.44043 51.0242ZM-107.407 57.4546C-129.364 73.3993 -160.051 68.485 -175.996 46.5284L-255.458 -63.0459C-271.403 -85.0026 -266.489 -115.69 -244.532 -131.634C-222.575 -147.579 -191.888 -142.665 -175.943 -120.708L-96.4811 -11.1339C-80.5364 10.8228 -85.4505 41.5098 -107.407 57.4546Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.7377 -86.3604L84.1926 -130.797L82.781 -100.057L100.085 -74.6502L34.6855 -86.3604H34.7377ZM137.098 -140.886C150.324 -164.568 180.227 -173.037 203.909 -159.863L322.109 -93.9407C345.791 -80.7144 354.26 -50.8115 341.086 -27.1297C327.859 -3.44785 297.957 5.02101 274.275 -8.15298L156.075 -74.0752C132.393 -87.3015 123.924 -117.204 137.098 -140.886Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-95.543 -30.0601L-30.248 -17.5134L-55.6028 -0.0524883L-65.3787 29.1183L-95.543 -30.0601ZM9.79678 18.5061C36.6676 14.7421 61.4996 33.4052 65.2636 60.276L84.1358 194.316C87.8998 221.187 69.2367 246.019 42.3659 249.783C15.4951 253.547 -9.33692 234.884 -13.1009 208.013L-31.9731 73.9727C-35.7371 47.102 -17.074 22.2701 9.79678 18.5061Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M89.4162 21.5903L77.1309 -43.7568L102.642 -26.6097L133.382 -28.1781L89.3638 21.5903H89.4162ZM96.0031 -94.1527C82.62 -117.73 90.9322 -147.685 114.509 -161.068L232.291 -227.775C255.869 -241.158 285.824 -232.846 299.207 -209.268C312.59 -185.691 304.278 -155.736 280.701 -142.353L162.919 -75.6463C139.341 -62.2632 109.386 -70.5754 96.0031 -94.1527Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-67.5723 233.419L-20.5746 186.369L-20.3132 217.16L-1.65002 241.626L-67.5723 233.419ZM31.7033 173.508C43.6226 149.147 73.055 139.109 97.3642 151.029L218.91 210.573C243.272 222.493 253.309 251.925 241.39 276.234C229.47 300.543 200.038 310.633 175.729 298.714L54.1827 239.169C29.8212 227.25 19.7839 197.817 31.7033 173.508Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-75.0957 54.0554L-9.69627 41.9269L-26.9479 67.4385L-25.4318 98.1779L-75.0957 54.0554ZM40.6996 60.9561C64.3292 47.6252 94.2844 56.042 107.563 79.6193L173.956 197.558C187.287 221.188 178.87 251.143 155.293 264.421C131.715 277.7 101.708 269.335 88.4293 245.758L22.0364 127.819C8.70555 104.19 17.1223 74.2346 40.6996 60.9561Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M198.004 44.7518L147.661 88.1426L149.699 57.4555L132.918 31.6823L198.056 44.7518H198.004ZM94.5463 97.1342C80.8495 120.555 50.7899 128.396 27.3694 114.699L-89.4193 46.3203C-112.84 32.6236 -120.681 2.56362 -106.985 -20.8568C-93.2878 -44.2773 -63.2281 -52.1189 -39.8076 -38.4221L76.981 29.9574C100.401 43.6542 108.243 73.7138 94.5463 97.1342Z",
                fill: "#4D8CED"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M454.216 327.574L392.894 301.854L421.281 289.986L436.86 263.482L454.216 327.626V327.574ZM361.162 258.306C334.134 256.476 313.641 233.056 315.471 206.028L324.62 70.9945C326.449 43.9669 349.87 23.4741 376.897 25.3038C403.925 27.1335 424.418 50.554 422.588 77.5816L413.44 212.615C411.61 239.643 388.189 260.136 361.162 258.306Z",
                fill: "#4D8CED"
            })
        ]
    });
const $ed2d318202bd2966$export$4f43b91428c248ba = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "471",
        height: "220",
        viewBox: "0 0 471 220",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M162.119 -197.709L202.354 -153.871L174.845 -154.807L152.247 -139.04L162.119 -197.662V-197.709ZM211.899 -106.618C233.233 -95.0155 241.093 -68.3479 229.49 -47.0138L171.617 59.3758C160.014 80.7098 133.346 88.5698 112.012 76.9671C90.6781 65.3643 82.8182 38.6966 94.4209 17.3626L152.294 -89.027C163.897 -110.361 190.564 -118.221 211.899 -106.618Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M368.769 245.955L313.797 268.74L324.136 243.195L317.072 216.574L368.769 245.908V245.955ZM266.122 261.535C247.923 277.582 220.179 275.851 204.085 257.652L123.942 166.841C107.895 148.642 109.626 120.898 127.825 104.804C146.025 88.7101 173.768 90.488 189.863 108.687L270.006 199.498C286.053 217.697 284.322 245.441 266.122 261.535Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M95.5904 -125.332L118.515 -70.4064L92.9704 -80.6992L66.3496 -73.5879L95.5904 -125.332ZM111.357 -22.7323C127.451 -4.57961 125.767 23.2107 107.614 39.3048L16.9444 119.588C-1.20826 135.682 -28.9987 133.998 -45.0929 115.846C-61.187 97.6929 -59.5027 69.9024 -41.35 53.8083L49.3198 -26.4752C67.4725 -42.5693 95.2628 -40.8849 111.357 -22.7323Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-57.2564 -216.657L-10.7987 -179.463L-38.1681 -176.235L-58.0986 -157.24L-57.2564 -216.704V-216.657ZM5.76321 -134.221C28.5944 -125.987 40.4311 -100.817 32.1969 -77.9855L-8.88051 35.9832C-17.1147 58.8144 -42.2852 70.651 -65.1164 62.4168C-87.9476 54.1826 -99.7842 29.0122 -91.55 6.18103L-50.4726 -107.788C-42.2384 -130.619 -17.068 -142.456 5.76321 -134.221Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M449.099 199.404L394.127 222.188L404.466 196.644L397.402 170.023L449.099 199.357V199.404ZM346.5 214.984C328.3 231.031 300.556 229.3 284.462 211.1L204.319 120.29C188.272 102.091 190.003 74.3471 208.202 58.253C226.402 42.1589 254.145 43.9366 270.24 62.1361L350.383 152.946C366.43 171.146 364.699 198.889 346.5 214.984Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M288.066 34.8604L257.469 85.9031L250.591 59.2354L229.07 42.0652L288.066 34.8604ZM214.894 108.453C209.841 132.174 186.495 147.332 162.729 142.232L44.2684 116.922C20.5483 111.869 5.38986 88.523 10.4894 64.7561C15.589 40.9892 38.888 25.8775 62.6549 30.9771L181.115 56.288C204.835 61.3408 219.994 84.6866 214.894 108.453Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-38.168 -222.318L20.2668 -211.09L-2.42406 -195.463L-11.1729 -169.357L-38.168 -222.318ZM56.0575 -178.808C80.1051 -182.176 102.328 -165.474 105.697 -141.426L122.586 -21.469C125.955 2.57858 109.252 24.8015 85.2047 28.17C61.1571 31.5386 38.9341 14.8363 35.5656 -9.21132L18.6761 -129.169C15.3076 -153.216 32.0099 -175.439 56.0575 -178.808Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M484.704 -4.01823L531.162 33.1759L503.793 36.4041L483.862 55.3989L484.704 -4.06506V-4.01823ZM547.724 78.464C570.555 86.6982 582.392 111.869 574.158 134.7L533.08 248.669C524.846 271.5 499.676 283.336 476.845 275.102C454.013 266.868 442.177 241.698 450.411 218.867L491.488 104.898C499.723 82.0666 524.893 70.2298 547.724 78.464Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M405.45 312.016L371.718 262.985L398.853 267.804L423.415 255.359L405.45 312.016ZM368.911 214.89C349.448 200.433 345.378 172.924 359.834 153.414L432.024 56.1478C446.481 36.6852 473.99 32.6149 493.5 47.0715C513.009 61.5281 517.033 89.0379 502.576 108.547L430.386 205.814C415.93 225.276 388.42 229.347 368.911 214.89Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M410.175 171.239L350.992 165.11L372.233 147.566L378.689 120.805L410.175 171.239ZM312.488 136.057C288.861 141.531 265.235 126.746 259.808 103.12L232.579 -14.9194C227.105 -38.5459 241.889 -62.1725 265.515 -67.5996C289.142 -73.0734 312.768 -58.2893 318.196 -34.6627L345.425 83.3764C350.898 107.003 336.114 130.63 312.488 136.057Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M394.127 140.361L416.022 85.0142L427.157 110.185L451.158 123.659L394.08 140.314L394.127 140.361ZM454.386 55.8669C455.509 31.6322 476.095 12.9181 500.329 14.0409L621.316 19.7487C645.551 20.8716 664.265 41.4571 663.142 65.6918C662.019 89.9266 641.434 108.641 617.199 107.518L496.212 101.81C471.978 100.687 453.263 80.1017 454.386 55.8669Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M152.902 -224.096L206.331 -197.896L180.365 -188.773L165.066 -165.895L152.949 -224.096H152.902ZM232.39 -157.333C256.485 -154.292 273.515 -132.303 270.427 -108.209L255.175 11.9354C252.134 36.0298 230.145 53.0597 206.05 49.9718C181.956 46.884 164.926 24.9417 168.014 0.847351L183.266 -119.297C186.307 -143.391 208.296 -160.421 232.39 -157.333Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M177.418 212.27L219.478 170.163L219.712 197.72L236.414 219.615L177.418 212.27ZM266.31 158.654C276.977 136.852 303.317 127.869 325.072 138.536L433.848 191.825C455.65 202.492 464.633 228.832 453.966 250.587C443.299 272.342 416.958 281.372 395.203 270.705L286.428 217.416C264.626 206.749 255.643 180.409 266.31 158.654Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M156.224 -206.318L202.682 -169.123L175.312 -165.895L155.382 -146.9L156.224 -206.364V-206.318ZM219.244 -123.882C242.075 -115.648 253.912 -90.4773 245.677 -67.6461L204.6 46.3226C196.366 69.1538 171.195 80.9905 148.364 72.7563C125.533 64.5221 113.696 39.3517 121.93 16.5205L163.008 -97.4483C171.242 -120.279 196.413 -132.116 219.244 -123.882Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.9711 109.717L43.239 60.6859L70.3745 65.5048L94.9367 53.0599L76.9711 109.717ZM40.3851 12.5439C20.9225 -1.91273 16.8522 -29.4224 31.3088 -48.9318L103.498 -146.198C117.955 -165.661 145.465 -169.731 164.974 -155.275C184.484 -140.818 188.507 -113.308 174.05 -93.7988L101.861 3.46756C87.4043 22.9302 59.8946 27.0005 40.3851 12.5439Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M61.8593 -107.46L58.8183 -48.0429L40.1977 -68.3477L13.1091 -73.4006L61.8125 -107.46H61.8593ZM31.8232 -8.08842C38.5134 15.2574 24.9925 39.5858 1.69345 46.2293L-114.755 79.5404C-138.101 86.2307 -162.429 72.7097 -169.073 49.4107C-175.716 26.1116 -162.242 1.73659 -138.943 -4.90691L-22.4945 -38.218C0.851334 -44.9083 25.1797 -31.3875 31.8232 -8.08842Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M294.803 144.01L289.469 203.287L271.644 182.281L244.789 176.152L294.803 144.01ZM260.93 242.119C266.685 265.699 252.228 289.466 228.695 295.22L111.03 323.946C87.4505 329.701 63.6836 315.244 57.929 291.711C52.1745 268.178 66.6311 244.365 90.1641 238.61L207.829 209.884C231.409 204.129 255.176 218.586 260.93 242.119Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M236.742 341.35L177.653 334.426L199.127 317.163L205.958 290.495L236.789 341.35H236.742ZM139.57 304.858C115.849 310.004 92.4568 294.94 87.3104 271.219L61.6721 152.853C56.5258 129.133 71.5906 105.74 95.3107 100.594C119.031 95.4474 142.423 110.512 147.57 134.232L173.208 252.599C178.354 276.319 163.29 299.712 139.57 304.858Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.1855 -180.212L19.7059 -120.748L0.898178 -140.865L-26.1904 -145.684L22.2322 -180.212H22.1855ZM-6.91495 -80.6059C-0.0375214 -57.3536 -13.3245 -32.8849 -36.5768 -26.0075L-152.744 8.3797C-175.997 15.2571 -200.465 1.97014 -207.343 -21.2821C-214.22 -44.5344 -200.933 -69.0031 -177.681 -75.8805L-61.5133 -110.268C-38.261 -117.145 -13.7924 -103.858 -6.91495 -80.6059Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-271.812 163.754L-225.729 126.092L-228.255 153.508L-213.846 176.947L-271.812 163.754ZM-178.055 119.308C-165.236 98.6753 -138.147 92.3594 -117.562 105.179L-14.6809 169.087C5.95139 181.906 12.2674 208.995 -0.551758 229.58C-13.3709 250.166 -40.4596 256.529 -61.0451 243.71L-163.926 179.801C-184.558 166.982 -190.874 139.893 -178.055 119.308Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M98.8672 41.4573L156.132 57.6449L132.225 71.2594L121.277 96.5234L98.9139 41.4573H98.8672ZM189.022 92.8742C213.257 91.5642 233.936 110.138 235.293 134.373L241.843 255.313C243.153 279.547 224.579 300.226 200.344 301.583C176.11 302.94 155.431 284.319 154.074 260.085L147.524 139.145C146.214 114.91 164.788 94.231 189.022 92.8742Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-129.914 72.5226L-86.8249 31.492L-87.2928 59.0484L-71.1519 81.3651L-129.961 72.5694L-129.914 72.5226ZM-39.759 21.1056C-28.5306 -0.415558 -2.00335 -8.79021 19.5179 2.43824L126.937 58.3935C148.458 69.6219 156.833 96.1491 145.604 117.67C134.376 139.191 107.848 147.566 86.3272 136.338L-21.0917 80.3825C-42.6129 69.154 -50.9875 42.6269 -39.759 21.1056Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-83.082 132.127L-74.5672 73.2242L-57.9116 95.1665L-31.4312 102.699L-83.082 132.127ZM-44.0164 35.9364C-48.5078 12.0759 -32.8347 -10.8956 -8.97424 -15.387L110.047 -37.8438C133.908 -42.3352 156.879 -26.6622 161.371 -2.80175C165.862 21.0587 150.189 44.0303 126.329 48.5216L7.307 70.9786C-16.5535 75.47 -39.525 59.7969 -44.0164 35.9364Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-133.797 -195.931L-76.5318 -179.743L-100.439 -166.129L-111.387 -140.865L-133.75 -195.931H-133.797ZM-43.6418 -144.561C-19.4071 -145.871 1.27202 -127.297 2.62878 -103.062L9.17876 17.8774C10.4888 42.1122 -8.08504 62.7912 -32.3198 64.1479C-56.5545 65.5047 -77.2336 46.8842 -78.5904 22.6494L-85.1403 -98.2904C-86.4503 -122.525 -67.8765 -143.204 -43.6418 -144.561Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-38.4493 -54.3121L0.288826 -9.11773L-27.1741 -11.0358L-50.286 3.93539L-38.4025 -54.3121H-38.4493ZM8.19554 38.4161C29.1085 50.7206 36.0328 77.669 23.7283 98.582L-37.7943 202.913C-50.0989 223.826 -77.0472 230.75 -97.9602 218.446C-118.873 206.141 -125.797 179.193 -113.493 158.28L-51.9703 53.9488C-39.6657 33.0358 -12.7175 26.1116 8.19554 38.4161Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M201.982 355.573L150.05 326.519L176.484 318.847L193.046 296.811L201.982 355.573ZM126.236 284.553C102.376 280.202 86.5625 257.324 90.9135 233.417L112.669 114.255C117.02 90.3944 139.898 74.5809 163.805 78.9319C187.712 83.283 203.479 106.161 199.128 130.068L177.373 249.23C173.022 273.091 150.144 288.904 126.236 284.553Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.1093 -38.2648L65.3681 -78.0322L64.1049 -50.5225L79.5909 -27.785L21.0625 -38.2648H21.1093ZM112.715 -87.1086C124.551 -108.302 151.313 -115.882 172.506 -104.092L278.288 -45.0954C299.481 -33.2587 307.061 -6.4976 295.271 14.6961C283.434 35.8898 256.673 43.4689 235.479 31.679L129.698 -27.3171C108.504 -39.1537 100.925 -65.9149 112.715 -87.1086Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M318.195 -201.499L356.933 -156.304L329.47 -158.222L306.358 -143.251L318.242 -201.499H318.195ZM364.793 -108.77C385.706 -96.4658 392.63 -69.5174 380.326 -48.6044L318.803 55.7266C306.499 76.6396 279.551 83.5638 258.638 71.2593C237.725 58.9548 230.8 32.0064 243.105 11.0934L304.627 -93.2376C316.932 -114.151 343.88 -121.075 364.793 -108.77Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M558.577 208.387L506.646 179.333L533.08 171.66L549.641 149.625L558.577 208.387ZM482.879 137.367C459.019 133.016 443.205 110.138 447.556 86.2306L469.311 -32.9314C473.662 -56.7919 496.54 -72.6052 520.448 -68.2542C544.355 -63.9032 560.121 -41.0252 555.77 -17.118L534.015 102.044C529.664 125.904 506.786 141.718 482.879 137.367Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M386.782 -244.12L437.732 -213.335L411.064 -206.505L393.8 -185.03L386.829 -244.073L386.782 -244.12ZM460.142 -170.667C483.862 -165.521 498.927 -142.128 493.78 -118.408L468.095 -0.0414276C462.949 23.6787 439.556 38.7435 415.836 33.5972C392.116 28.4508 377.051 5.05826 382.198 -18.6619L407.883 -137.029C413.029 -160.749 436.421 -175.814 460.142 -170.667Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M408.49 -214.973L454.947 -177.778L427.578 -174.55L407.647 -155.555L408.49 -215.019V-214.973ZM471.509 -132.49C494.341 -124.256 506.177 -99.0856 497.943 -76.2544L456.866 37.7143C448.631 60.5455 423.461 72.3821 400.63 64.1479C377.799 55.9138 365.962 30.7433 374.196 7.91217L415.274 -106.057C423.508 -128.888 448.678 -140.725 471.509 -132.49Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M352.864 4.54333L319.132 -44.4876L346.267 -39.6688L370.829 -52.1135L352.864 4.54333ZM316.278 -92.6295C296.815 -107.086 292.745 -134.596 307.201 -154.105L379.391 -251.372C393.848 -270.835 421.357 -274.905 440.867 -260.448C460.376 -245.991 464.4 -218.482 449.943 -198.972L377.754 -101.706C363.297 -82.2432 335.787 -78.1729 316.278 -92.6295Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M618.51 -133.005L641.435 -78.0792L615.89 -88.3719L589.269 -81.2606L618.51 -133.005ZM634.277 -30.405C650.371 -12.2524 648.687 15.5381 630.534 31.6322L539.864 111.916C521.712 128.01 493.921 126.325 477.827 108.173C461.733 90.0201 463.417 62.2298 481.57 46.1357L572.24 -34.1478C590.392 -50.2419 618.183 -48.5577 634.277 -30.405Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M470.623 -228.962L517.08 -191.767L489.711 -188.539L469.78 -169.544L470.623 -229.008V-228.962ZM533.642 -146.526C556.473 -138.292 568.31 -113.121 560.076 -90.2901L518.998 23.6786C510.764 46.5098 485.594 58.3465 462.763 50.1122C439.931 41.8781 428.095 16.7077 436.329 -6.12354L477.406 -120.092C485.641 -142.923 510.811 -154.76 533.642 -146.526Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M486.576 -113.542L481.242 -54.2656L463.417 -75.2721L436.563 -81.4009L486.576 -113.542ZM452.657 -15.4337C458.411 8.14603 443.955 31.9128 420.422 37.6674L302.757 66.3936C279.177 72.1482 255.41 57.6915 249.656 34.1585C243.901 10.6255 258.358 -13.188 281.891 -18.9426L399.556 -47.6688C423.135 -53.4234 446.902 -38.9667 452.657 -15.4337Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M488.354 65.271L429.264 58.3467L450.738 41.0829L457.569 14.4154L488.401 65.271H488.354ZM391.181 28.8252C367.461 33.9716 344.068 18.9068 338.922 -4.81335L313.283 -123.18C308.137 -146.9 323.202 -170.293 346.922 -175.439C370.642 -180.585 394.035 -165.521 399.181 -141.8L424.819 -23.4339C429.966 0.286179 414.901 23.6788 391.181 28.8252Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M535.326 139.425L486.482 105.459L513.524 100.36L532.097 80.055L535.279 139.425H535.326ZM466.785 61.4344C443.44 54.7909 429.919 30.4625 436.562 7.11671L469.78 -109.378C476.423 -132.724 500.751 -146.245 524.097 -139.602C547.443 -132.958 560.964 -108.63 554.32 -85.2841L521.103 31.2112C514.459 54.557 490.131 68.0779 466.785 61.4344Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M320.863 205.439L367.32 242.634L339.951 245.862L320.021 264.857L320.863 205.393V205.439ZM383.882 287.922C406.714 296.156 418.55 321.326 410.316 344.158L369.239 458.126C361.004 480.958 335.834 492.794 313.003 484.56C290.172 476.326 278.335 451.155 286.569 428.324L327.647 314.355C335.881 291.524 361.051 279.688 383.882 287.922Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M399.602 160.526L445.685 122.863L443.159 150.28L457.569 173.719L399.602 160.526ZM493.406 116.08C506.225 95.4473 533.314 89.1313 553.899 101.95L656.78 165.859C677.412 178.678 683.728 205.767 670.909 226.352C658.09 246.938 631.001 253.301 610.416 240.481L507.535 176.573C486.903 163.754 480.587 136.665 493.406 116.08Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M86.5156 24.1935L129.605 -16.8372L129.137 10.7193L145.278 33.0358L86.4688 24.2402L86.5156 24.1935ZM176.671 -27.2236C187.899 -48.7448 214.426 -57.1193 235.948 -45.8908L343.366 10.0643C364.888 21.2927 373.262 47.82 362.034 69.3412C350.805 90.8624 324.278 99.2369 302.757 88.0085L195.338 32.0534C173.817 20.8249 165.442 -5.70237 176.671 -27.2236Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M597.551 348.275L538.461 341.35L559.936 324.086L566.766 297.419L597.598 348.275H597.551ZM500.331 311.829C476.611 316.975 453.219 301.91 448.072 278.19L422.434 159.824C417.287 136.104 432.352 112.711 456.072 107.564C479.793 102.418 503.185 117.483 508.332 141.203L533.97 259.57C539.116 283.29 524.051 306.682 500.331 311.829Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M423.883 192.199L483.394 191.357L464.352 211.241L461.03 238.563L423.883 192.152V192.199ZM524.986 215.779C547.817 207.591 572.987 219.521 581.175 242.353L621.972 356.415C630.159 379.246 618.229 404.417 595.397 412.604C572.566 420.792 547.396 408.861 539.209 386.03L498.412 271.968C490.224 249.137 502.155 223.966 524.986 215.779Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.144 79.4933L174.799 21.9944L198.753 35.6089L226.075 32.1L190.191 79.4933H190.144ZM188.226 -24.2763C174.705 -44.4407 180.086 -71.7165 200.25 -85.2374L300.838 -152.702C321.003 -166.223 348.278 -160.842 361.799 -140.678C375.32 -120.514 369.94 -93.2377 349.776 -79.7168L249.187 -12.2524C229.023 1.26851 201.747 -4.11183 188.226 -24.2763Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-59.5957 -88.7462L-19.3605 -44.9085L-46.8702 -45.8441L-69.4674 -30.0775L-59.5957 -88.6994V-88.7462ZM-9.81622 2.34463C11.5178 13.9474 19.3777 40.6149 7.77499 61.949L-50.0983 168.339C-61.701 189.673 -88.3687 197.533 -109.703 185.93C-131.037 174.327 -138.897 147.66 -127.294 126.325L-69.4206 19.9359C-57.8179 -1.39815 -31.1503 -9.25811 -9.81622 2.34463Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M223.923 172.83L270.381 210.024L243.012 213.253L223.081 232.247L223.923 172.783V172.83ZM286.99 255.312C309.821 263.547 321.658 288.717 313.423 311.548L272.346 425.517C264.112 448.348 238.941 460.185 216.11 451.951C193.279 443.717 181.442 418.546 189.677 395.715L230.754 281.746C238.988 258.915 264.159 247.078 286.99 255.312Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M355.203 281.372L300.23 304.156L310.57 278.611L303.505 251.991L355.203 281.325V281.372ZM252.603 296.904C234.404 312.952 206.66 311.221 190.566 293.021L110.423 202.211C94.3754 184.012 96.1064 156.268 114.306 140.174C132.505 124.08 160.249 125.858 176.343 144.057L256.486 234.867C272.533 253.067 270.802 280.81 252.603 296.904Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M338.5 66.4872L381.589 25.4566L381.121 53.0131L397.262 75.3297L338.453 66.534L338.5 66.4872ZM428.655 15.0703C439.883 -6.45095 466.411 -14.8255 487.932 -3.597L595.351 52.3581C616.872 63.5865 625.247 90.1138 614.018 111.635C602.79 133.156 576.262 141.531 554.741 130.302L447.322 74.3472C425.801 63.1187 417.427 36.5915 428.655 15.0703Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.9219 117.764L92.8302 97.4121L81.4147 122.489L87.3096 149.39L36.9219 117.81V117.764ZM140.13 106.675C159.031 91.4235 186.681 94.371 201.933 113.272L278.006 207.498C293.258 226.399 290.311 254.049 271.409 269.301C252.508 284.553 224.858 281.605 209.606 262.704L133.533 168.479C118.281 149.578 121.229 121.927 140.13 106.675Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-249.59 235.99L-198.266 205.907L-205.004 232.621L-194.383 258.026L-249.59 235.99ZM-150.078 206.562C-134.264 188.175 -106.521 186.117 -88.134 201.93L3.65855 280.951C22.0452 296.764 24.1037 324.508 8.29031 342.894C-7.52309 361.281 -35.2668 363.339 -53.6534 347.526L-145.446 268.506C-163.833 252.692 -165.891 224.949 -150.078 206.562Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M111.78 146.63L110.704 206.141L91.4282 186.491L64.1991 182.327L111.78 146.677V146.63ZM85.0654 246.938C92.5042 270.05 79.8254 294.799 56.7135 302.238L-58.5654 339.385C-81.6773 346.824 -106.427 334.146 -113.865 311.034C-121.304 287.922 -108.626 263.172 -85.5136 255.733L29.7652 218.586C52.8771 211.147 77.6265 223.826 85.0654 246.938Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M284.744 167.543L331.201 204.738L303.832 207.966L283.902 226.961L284.744 167.496V167.543ZM347.81 250.026C370.641 258.26 382.478 283.43 374.244 306.261L333.166 420.23C324.932 443.062 299.762 454.898 276.931 446.664C254.099 438.43 242.263 413.259 250.497 390.428L291.574 276.459C299.808 253.628 324.979 241.791 347.81 250.026Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M424.07 274.541L369.097 297.325L379.437 271.781L372.373 245.16L424.07 274.494V274.541ZM321.423 290.074C303.224 306.121 275.48 304.39 259.386 286.191L179.243 195.381C163.196 177.181 164.927 149.437 183.126 133.343C201.326 117.249 229.069 119.027 245.163 137.227L325.307 228.037C341.354 246.236 339.623 273.98 321.423 290.074Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M364.371 218.258L361.891 277.723L343.084 257.605L315.995 252.786L364.418 218.258H364.371ZM335.224 317.864C342.101 341.116 328.814 365.585 305.562 372.463L189.394 406.85C166.142 413.727 141.673 400.44 134.796 377.188C127.918 353.936 141.205 329.467 164.458 322.59L280.625 288.202C303.878 281.325 328.346 294.612 335.224 317.864Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M419.486 82.7684L462.575 41.7378L462.108 69.2943L478.249 91.6109L419.439 82.8153L419.486 82.7684ZM509.641 31.3515C520.87 9.83029 547.397 1.45564 568.918 12.6841L676.337 68.6393C697.858 79.8678 706.233 106.395 695.004 127.916C683.776 149.437 657.249 157.812 635.727 146.584L528.309 90.6283C506.787 79.3999 498.413 52.8727 509.641 31.3515Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M109.768 107.097L165.676 86.7452L154.26 111.822L160.155 138.723L109.768 107.143V107.097ZM212.976 96.0554C231.877 80.8034 259.527 83.7509 274.779 102.652L350.852 196.878C366.104 215.779 363.156 243.429 344.255 258.681C325.354 273.933 297.704 270.985 282.452 252.084L206.379 157.859C191.127 138.957 194.075 111.307 212.976 96.0554Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-183.623 201.697L-132.3 171.614L-139.037 198.328L-128.416 223.732L-183.623 201.697ZM-84.0641 172.269C-68.2507 153.882 -40.507 151.824 -22.1204 167.637L69.6722 246.657C88.0588 262.471 90.1174 290.214 74.304 308.601C58.4905 326.987 30.7469 329.046 12.3603 313.233L-79.4323 234.212C-97.8189 218.399 -99.8775 190.655 -84.0641 172.269Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-117.797 310.098L-90.8486 257.043L-82.0998 283.15L-59.4089 298.776L-117.75 310.098H-117.797ZM-49.9583 231.499C-46.5898 207.451 -24.3668 190.749 -0.319168 194.117L119.638 211.007C143.686 214.375 160.388 236.598 157.02 260.646C153.651 284.693 131.428 301.396 107.38 298.027L-12.577 281.138C-36.6245 277.769 -53.3268 255.546 -49.9583 231.499Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M281.376 51.3757L327.834 88.5699L300.465 91.798L280.534 110.793L281.376 51.3289V51.3757ZM344.396 133.858C367.227 142.092 379.064 167.263 370.83 190.094L329.752 304.063C321.518 326.894 296.348 338.731 273.516 330.496C250.685 322.262 238.849 297.092 247.083 274.26L288.16 160.292C296.394 137.46 321.565 125.624 344.396 133.858Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M515.021 199.451L460.049 222.235L470.388 196.691L463.324 170.07L515.021 199.404V199.451ZM412.374 215.03C394.175 231.078 366.431 229.347 350.337 211.147L270.194 120.337C254.147 102.138 255.878 74.3939 274.077 58.2998C292.277 42.2057 320.02 43.9836 336.115 62.1831L416.258 152.993C432.305 171.193 430.574 198.936 412.374 215.03Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M381.309 59.5631L378.829 119.027L360.021 98.9095L332.932 94.0906L381.355 59.5631H381.309ZM352.161 159.216C359.039 182.468 345.752 206.937 322.499 213.814L206.332 248.201C183.079 255.078 158.611 241.791 151.733 218.539C144.856 195.287 158.143 170.818 181.395 163.941L297.563 129.554C320.815 122.676 345.284 135.963 352.161 159.216Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M268.088 21.0119L323.996 0.660396L312.581 25.7372L318.476 52.6387L268.088 21.0587V21.0119ZM371.296 9.92378C390.197 -5.3282 417.847 -2.38072 433.099 16.5205L509.172 110.746C524.424 129.647 521.477 157.297 502.575 172.549C483.674 187.801 456.024 184.854 440.772 165.953L364.699 71.7272C349.447 52.8259 352.395 25.1758 371.296 9.92378Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M219.806 431.506L160.623 425.377L181.864 407.832L188.32 381.071L219.806 431.506ZM122.166 396.323C98.539 401.797 74.9125 387.013 69.4854 363.386L42.2564 245.347C36.7825 221.721 51.5667 198.094 75.1932 192.667C98.8198 187.24 122.446 201.977 127.873 225.604L155.102 343.643C160.576 367.269 145.792 390.896 122.166 396.323Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M62.3281 207.732L113.652 177.649L106.914 204.363L117.535 229.768L62.3281 207.732ZM161.84 178.304C177.654 159.917 205.397 157.859 223.784 173.672L315.577 252.692C333.963 268.506 336.022 296.249 320.208 314.636C304.395 333.023 276.651 335.081 258.265 319.268L166.472 240.247C148.085 224.434 146.027 196.69 161.84 178.304Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-1.39397 331.526L-35.1261 282.495L-7.99063 287.314L16.5716 274.869L-1.39397 331.526ZM-37.9332 234.399C-57.3959 219.943 -61.4662 192.433 -47.0096 172.924L25.1801 75.6572C39.6367 56.1946 67.1464 52.1243 86.6559 66.5809C106.165 81.0375 110.189 108.547 95.7322 128.057L23.5426 225.323C9.08592 244.786 -18.4238 248.856 -37.9332 234.399Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M410.268 18.6726L352.114 31.3515L366.805 8.05238L364.559 -19.4105L410.221 18.6259L410.268 18.6726ZM306.498 15.7719C285.726 28.3571 258.731 21.7137 246.145 0.941086L183.406 -102.641C170.821 -123.414 177.465 -150.409 198.237 -162.994C219.01 -175.58 246.005 -168.936 258.59 -148.163L321.329 -44.581C333.914 -23.8084 327.271 3.18669 306.498 15.7719Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.43071 216.761L-57.7701 229.206L-42.986 205.954L-45.0913 178.491L0.43071 216.714V216.761ZM-103.339 213.439C-124.158 225.931 -151.153 219.194 -163.598 198.375L-225.916 94.5114C-238.408 73.692 -231.671 46.6969 -210.851 34.252C-190.032 21.8071 -163.037 28.4974 -150.592 49.3169L-88.274 153.18C-75.7824 173.999 -82.5195 200.995 -103.339 213.439Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M82.725 390.615L71.7305 332.134L94.5617 347.479L122.071 346.076L82.6782 390.615H82.725ZM88.6199 286.986C76.6429 265.886 84.0817 239.078 105.182 227.101L210.589 167.403C231.689 155.426 258.497 162.865 270.474 183.965C282.451 205.065 275.012 231.873 253.912 243.85L148.505 303.548C127.405 315.525 100.597 308.086 88.6199 286.986Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-212.77 294.659L-208.465 235.288L-190.266 255.967L-163.318 261.582L-212.723 294.612L-212.77 294.659ZM-180.675 195.942C-186.851 172.456 -172.862 148.455 -149.376 142.279L-32.2721 111.401C-8.78592 105.225 15.2149 119.214 21.3906 142.7C27.5662 166.187 13.5774 190.187 -9.90877 196.363L-127.012 227.241C-150.498 233.417 -174.499 219.428 -180.675 195.942Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M80.2926 391.317L21.1094 385.188L42.3498 367.644L48.8062 340.882L80.2926 391.317ZM-17.3481 356.134C-40.9746 361.608 -64.6012 346.824 -70.0283 323.198L-97.2573 205.158C-102.731 181.532 -87.947 157.905 -64.3205 152.478C-40.694 147.051 -17.0674 161.789 -11.6403 185.415L15.5887 303.454C21.0625 327.081 6.27844 350.707 -17.3481 356.134Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M251.714 204.317L243.34 145.414L265.469 161.789L293.026 161.602L251.714 204.363V204.317ZM262.241 101.015C251.247 79.4 259.855 52.9195 281.47 41.925L389.403 -13.0008C411.018 -23.9954 437.499 -15.3868 448.493 6.22797C459.488 27.8428 450.879 54.3231 429.264 65.3176L321.331 120.244C299.716 131.238 273.236 122.63 262.241 101.015Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M220.414 330.824L162.821 315.899L186.448 301.723L196.834 276.225L220.414 330.777V330.824ZM129.136 281.418C104.948 283.243 83.8476 265.137 81.9762 240.949L72.7595 120.196C70.9348 96.0085 89.0407 74.9085 113.229 73.0371C137.417 71.1656 158.517 89.3183 160.388 113.506L169.605 234.259C171.429 258.447 153.324 279.547 129.136 281.418Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-138.006 205.673L-133.702 146.303L-115.502 166.982L-88.5538 172.596L-137.959 205.627L-138.006 205.673ZM-105.911 106.956C-112.087 83.4703 -98.098 59.4695 -74.6119 53.2938L42.4916 22.4156C65.9778 16.2399 89.9786 30.2287 96.1542 53.7149C102.33 77.2011 88.3411 101.202 64.8549 107.378L-52.2485 138.256C-75.7347 144.431 -99.7355 130.443 -105.911 106.956Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.4035 235.101L35.4719 206.048L61.9055 198.375L78.4675 176.339L87.4035 235.101ZM11.6582 164.128C-12.2022 159.777 -28.0156 136.899 -23.6646 112.992L-1.90952 -6.1702C2.44151 -30.0307 25.3195 -45.844 49.2268 -41.493C73.134 -37.142 88.9007 -14.264 84.5496 9.64323L62.7945 128.805C58.4434 152.666 35.5655 168.479 11.6582 164.128Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-97.3048 204.317L-53.0459 164.549L-54.3092 192.059L-38.8233 214.796L-97.3516 204.317H-97.3048ZM-5.69933 155.473C6.13734 134.279 32.8985 126.7 54.0922 138.49L159.874 197.486C181.067 209.323 188.647 236.084 176.857 257.277C165.02 278.471 138.259 286.05 117.065 274.26L11.2837 215.264C-9.90997 203.428 -17.4892 176.667 -5.69933 155.473Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M457.85 8.84778L496.588 54.0422L469.125 52.1241L446.013 67.0953L457.896 8.84778H457.85ZM504.494 101.576C525.407 113.881 532.332 140.829 520.027 161.742L458.505 266.073C446.2 286.986 419.252 293.91 398.339 281.606C377.426 269.301 370.501 242.353 382.806 221.44L444.329 117.109C456.633 96.1957 483.581 89.2715 504.494 101.576Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M404.609 15.4913L352.677 -13.5623L379.111 -21.2352L395.673 -43.271L404.609 15.4913ZM328.863 -55.4818C305.003 -59.8329 289.189 -82.711 293.54 -106.618L315.296 -225.78C319.647 -249.641 342.525 -265.454 366.432 -261.103C390.339 -256.752 406.106 -233.874 401.755 -209.967L380 -90.8048C375.649 -66.9443 352.771 -51.1308 328.863 -55.4818Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M313.049 103.635L370.314 119.822L346.407 133.437L335.459 158.701L313.096 103.635H313.049ZM403.204 155.005C427.439 153.695 448.118 172.268 449.475 196.503L456.025 317.443C457.335 341.678 438.761 362.357 414.526 363.714C390.291 365.07 369.612 346.45 368.255 322.215L361.706 201.275C360.396 177.041 378.969 156.362 403.204 155.005Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-102.637 270.097L-59.5476 229.066L-60.0155 256.622L-43.8745 278.939L-102.684 270.143L-102.637 270.097ZM-12.4817 218.68C-1.25323 197.158 25.274 188.784 46.7952 200.012L154.214 255.967C175.735 267.196 184.11 293.723 172.881 315.244C161.653 336.765 135.126 345.14 113.604 333.912L6.18565 277.956C-15.3356 266.728 -23.7101 240.201 -12.4817 218.68Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.2147 327.596L-0.130859 270.097L23.8232 283.711L51.1458 280.202L15.2615 327.596H15.2147ZM13.2965 223.779C-0.224453 203.615 5.15588 176.339 25.3203 162.818L125.909 95.3537C146.073 81.8328 173.349 87.2131 186.87 107.378C200.391 127.542 195.01 154.818 174.846 168.339L74.2577 235.803C54.0933 249.324 26.8174 243.944 13.2965 223.779Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M452.564 -195.651L503.513 -164.866L476.845 -158.035L459.581 -136.561L452.61 -195.604L452.564 -195.651ZM525.923 -122.198C549.643 -117.051 564.708 -93.6587 559.561 -69.9386L533.876 48.4281C528.73 72.1482 505.337 87.2131 481.617 82.0667C457.897 76.9203 442.832 53.5276 447.979 29.8075L473.664 -88.5591C478.81 -112.279 502.203 -127.344 525.923 -122.198Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M350.057 -159.579L405.965 -179.931L394.549 -154.854L400.444 -127.952L350.057 -159.532V-159.579ZM453.218 -170.667C472.119 -185.919 499.769 -182.972 515.021 -164.07L591.094 -69.8449C606.346 -50.9437 603.399 -23.2937 584.497 -8.04167C565.596 7.21031 537.946 4.26282 522.694 -14.6384L446.621 -108.864C431.369 -127.765 434.317 -155.415 453.218 -170.667Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M318.711 157.485L370.034 127.402L363.297 154.116L373.917 179.52L318.711 157.485ZM418.27 128.057C434.083 109.67 461.827 107.612 480.214 123.425L572.006 202.445C590.393 218.259 592.451 246.002 576.638 264.389C560.825 282.776 533.081 284.834 514.694 269.021L422.902 190C404.515 174.187 402.456 146.443 418.27 128.057Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M365.588 189.298L392.536 136.244L401.285 162.35L423.976 177.976L365.635 189.298H365.588ZM433.426 110.699C436.795 86.6516 459.018 69.9493 483.066 73.3178L603.023 90.2072C627.071 93.5758 643.773 115.799 640.404 139.846C637.036 163.894 614.813 180.596 590.765 177.228L470.808 160.338C446.76 156.97 430.058 134.747 433.426 110.699Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.9283 133.624L8.19611 84.5929L35.3316 89.4117L59.8938 76.9669L41.9283 133.624ZM5.38904 36.4975C-14.0736 22.0409 -18.1439 -5.46877 -3.6873 -24.9782L68.5023 -122.245C82.9589 -141.707 110.469 -145.778 129.978 -131.321C149.487 -116.864 153.511 -89.3547 139.054 -69.8452L66.8648 27.4213C52.4082 46.884 24.8985 50.9541 5.38904 36.4975Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.9393 67.7506L33.8348 12.4036L44.9697 37.5741L68.9705 51.0483L11.8926 67.7038L11.9393 67.7506ZM72.1987 -16.7903C73.3216 -41.0251 93.9071 -59.7392 118.142 -58.6163L239.128 -52.9085C263.363 -51.7857 282.077 -31.2001 280.954 -6.96538C279.832 17.2694 259.246 35.9835 235.011 34.8606L114.025 29.1528C89.79 28.03 71.0759 7.44444 72.1987 -16.7903Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.1094 185.275L66.5381 211.475L40.5723 220.598L25.2736 243.476L13.1561 185.275H13.1094ZM92.5975 251.991C116.692 255.032 133.722 277.021 130.634 301.115L115.382 421.26C112.341 445.354 90.3518 462.384 66.2574 459.296C42.163 456.208 25.1332 434.266 28.221 410.172L43.473 290.027C46.5141 265.933 68.5031 248.903 92.5975 251.991Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M400.865 -74.383L452.189 -104.466L445.452 -77.7516L456.072 -52.3472L400.865 -74.383ZM500.377 -103.811C516.191 -122.198 543.934 -124.256 562.321 -108.443L654.114 -29.4225C672.5 -13.6091 674.559 14.1346 658.745 32.5212C642.932 50.9078 615.188 52.9663 596.802 37.1529L505.009 -41.8674C486.623 -57.6808 484.564 -85.4244 500.377 -103.811Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M405.965 261.488L372.233 212.457L399.369 217.276L423.931 204.831L405.965 261.488ZM369.426 164.315C349.963 149.859 345.893 122.349 360.35 102.839L432.539 5.57288C446.996 -13.8898 474.506 -17.9601 494.015 -3.50346C513.525 10.9532 517.548 38.463 503.092 57.9724L430.902 155.239C416.445 174.701 388.936 178.772 369.426 164.315Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M520.682 300.039L461.171 299.244L480.727 279.875L484.751 252.646L520.635 300.039H520.682ZM420.234 273.793C397.169 281.325 372.373 268.786 364.793 245.721L327.084 130.63C319.552 107.565 332.09 82.7685 355.155 75.1893C378.221 67.6101 403.017 80.1953 410.596 103.26L448.305 218.352C455.837 241.417 443.299 266.213 420.234 273.793Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M402.361 177.462L429.31 124.407L438.058 150.513L460.749 166.14L402.408 177.462H402.361ZM470.2 98.8624C473.568 74.8148 495.791 58.1125 519.839 61.481L639.796 78.3704C663.844 81.739 680.546 103.962 677.178 128.01C673.809 152.057 651.586 168.76 627.538 165.391L507.581 148.501C483.534 145.133 466.831 122.91 470.2 98.8624Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M89.8828 -143.345L148.318 -132.116L125.627 -116.49L116.878 -90.3838L89.8828 -143.345ZM184.155 -99.8812C208.203 -103.25 230.426 -86.5473 233.794 -62.4997L250.684 57.4575C254.052 81.5051 237.35 103.728 213.302 107.097C189.255 110.465 167.032 93.7628 163.663 69.7152L146.774 -50.242C143.405 -74.2896 160.107 -96.5127 184.155 -99.8812Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M168.67 347.105L157.676 288.623L180.507 303.969L208.017 302.566L168.624 347.105H168.67ZM174.612 243.476C162.635 222.376 170.074 195.568 191.174 183.591L296.581 123.893C317.681 111.916 344.489 119.354 356.466 140.455C368.443 161.555 361.004 188.363 339.904 200.34L234.497 260.038C213.397 272.015 186.589 264.576 174.612 243.476Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.1108 -144.888L131.569 -107.694L104.199 -104.466L84.2687 -85.4712L85.1108 -144.935V-144.888ZM148.13 -62.4529C170.962 -54.2187 182.798 -29.0482 174.564 -6.217L133.487 107.752C125.252 130.583 100.082 142.42 77.2509 134.185C54.4197 125.951 42.583 100.781 50.8172 77.9496L91.8946 -36.0193C100.129 -58.8505 125.299 -70.6871 148.13 -62.4529Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M315.342 -1.49193L260.369 21.2924L270.708 -4.25223L263.644 -30.873L315.342 -1.53862V-1.49193ZM212.695 14.0876C194.495 30.135 166.752 28.4038 150.658 10.2044L70.5145 -80.6058C54.4672 -98.8052 56.1982 -126.549 74.3977 -142.643C92.5971 -158.737 120.341 -156.959 136.435 -138.76L216.578 -47.9496C232.625 -29.7502 230.894 -2.00648 212.695 14.0876Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M182.799 -135.11L180.319 -75.6463L161.511 -95.7641L134.423 -100.583L182.846 -135.11H182.799ZM153.698 -35.5047C160.576 -12.2524 147.289 12.2163 124.037 19.0938L7.8688 53.4808C-15.3835 60.3582 -39.8521 47.0712 -46.7295 23.819C-53.607 0.566696 -40.32 -23.9019 -17.0677 -30.7793L99.1 -65.1665C122.352 -72.0439 146.821 -58.7569 153.698 -35.5047Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-30.6348 261.488L15.4487 223.826L12.9223 251.242L27.3321 274.681L-30.6348 261.488ZM63.1229 217.042C75.942 196.41 103.031 190.094 123.616 202.913L226.497 266.821C247.129 279.641 253.445 306.729 240.626 327.315C227.807 347.9 200.718 354.263 180.133 341.444L77.252 277.535C56.6197 264.716 50.3037 237.627 63.1229 217.042Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.694 251.008L121.604 244.084L143.078 226.82L149.909 200.153L180.74 251.008H180.694ZM83.5207 214.563C59.8006 219.709 36.408 204.644 31.2617 180.924L5.6233 62.5572C0.476927 38.8371 15.5418 15.4446 39.2619 10.2982C62.982 5.15185 86.3746 20.2167 91.521 43.9368L117.159 162.303C122.306 186.023 107.241 209.416 83.5207 214.563Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.3669 177.649L-41.8165 171.52L-20.576 153.976L-14.1196 127.214L17.3669 177.649ZM-80.2739 142.466C-103.9 147.94 -127.527 133.156 -132.954 109.53L-160.183 -8.50961C-165.657 -32.1361 -150.873 -55.7626 -127.246 -61.1897C-103.62 -66.6168 -79.9932 -51.8795 -74.5661 -28.253L-47.3371 89.7862C-41.8632 113.413 -56.6474 137.039 -80.2739 142.466Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-82.1914 12.9181L-22.6806 12.076L-41.7222 31.9598L-45.0439 59.2823L-82.1914 12.8713V12.9181ZM18.8646 36.4978C41.6958 28.3104 66.8663 40.2407 75.0538 63.0719L115.85 177.134C124.038 199.966 112.108 225.136 89.2764 233.323C66.4452 241.511 41.2748 229.581 33.0874 206.749L-7.70933 92.6869C-15.8967 69.8557 -3.96655 44.6852 18.8646 36.4978Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M385.613 251.382L370.268 193.883L394.222 207.498L421.544 203.989L385.66 251.382H385.613ZM383.695 147.613C370.174 127.448 375.554 100.172 395.719 86.6514L496.307 19.1872C516.471 5.6663 543.747 11.0466 557.268 31.2111C570.789 51.3755 565.409 78.6513 545.244 92.1722L444.656 159.636C424.492 173.157 397.216 167.777 383.695 147.613Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.238 236.739L233.327 195.708L232.86 223.264L249 245.581L190.191 236.785L190.238 236.739ZM280.393 185.322C291.622 163.801 318.149 155.426 339.67 166.654L447.089 222.61C468.61 233.838 476.985 260.365 465.756 281.886C454.528 303.408 428.001 311.782 406.479 300.554L299.061 244.599C277.539 233.37 269.165 206.843 280.393 185.322Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-28.8574 -61.5641L27.0509 -81.9157L15.6353 -56.8387L21.5303 -29.9372L-28.8574 -61.5172V-61.5641ZM74.3508 -72.6521C93.252 -87.9041 120.902 -84.9566 136.154 -66.0554L212.227 28.17C227.479 47.0712 224.531 74.7214 205.63 89.9733C186.729 105.225 159.079 102.278 143.827 83.3766L67.7541 -10.8489C52.5021 -29.7501 55.4496 -57.4002 74.3508 -72.6521Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M527.326 364.93L468.143 358.801L489.383 341.257L495.839 314.496L527.326 364.93ZM429.685 329.748C406.059 335.222 382.432 320.437 377.005 296.811L349.776 178.772C344.302 155.145 359.086 131.519 382.713 126.092C406.339 120.664 429.966 135.402 435.393 159.028L462.622 277.067C468.096 300.694 453.312 324.321 429.685 329.748Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M427.768 200.199L487.278 199.357L468.237 219.241L464.915 246.564L427.768 200.153V200.199ZM528.824 223.732C551.655 215.545 576.825 227.475 585.013 250.306L625.809 364.369C633.997 387.2 622.067 412.37 599.235 420.558C576.404 428.745 551.234 416.815 543.046 393.984L502.25 279.921C494.062 257.09 505.993 231.92 528.824 223.732Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M244.883 228.224L296.206 198.141L289.469 224.855L300.089 250.259L244.883 228.224ZM344.442 198.796C360.255 180.409 387.999 178.351 406.385 194.164L498.178 273.184C516.565 288.998 518.623 316.741 502.81 335.128C486.996 353.515 459.253 355.573 440.866 339.76L349.073 260.739C330.687 244.926 328.628 217.182 344.442 198.796Z",
                fill: "#AF59E0"
            })
        ]
    });

});


parcelRegister("jGtmE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b0cf533147eaa151$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $us1N6 = parcelRequire("us1N6");
const $b0cf533147eaa151$var$renderHeroCarousel = ({ items: items })=>{
    // First pass to work through Uniform setting empty to "" vs undefined that underlying component expects
    // eslint-disable-next-line complexity
    const transformed = items.map((heroSlide)=>{
        const params = heroSlide.props?.children?.props?.data?.parameters;
        return {
            id: params.id?.value || undefined,
            eyebrow: params.tabEyebrow?.value || undefined,
            title: params?.tabLabel?.value || undefined,
            panel: {
                title: params.title?.value || undefined,
                body: params.body?.value || undefined,
                primaryCallToAction: params.buttonText?.value && params.buttonHref?.value ? {
                    text: params.buttonText?.value,
                    href: params.buttonHref?.value,
                    'aria-label': params.buttonAriaLabel?.value || undefined
                } : undefined,
                secondaryCallToAction: params.linkText?.value && params.linkHref?.value ? {
                    text: params.linkText?.value,
                    href: params.linkHref?.value,
                    type: params.linkType?.value || undefined,
                    ariaLabel: params.linkAriaLabel?.value || undefined
                } : undefined,
                bgColor: params.bgColor?.value || undefined,
                bgImage: {
                    lg: params.imageLarge?.value || undefined
                },
                layout: params.alignment?.value || undefined
            }
        };
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $us1N6.HeroCarousel), {
        tabsData: transformed
    });
};
const $b0cf533147eaa151$var$UniformHeroCarousel = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "tabdata",
            wrapperComponent: $b0cf533147eaa151$var$renderHeroCarousel
        })
    });
};
var $b0cf533147eaa151$export$2e2bcd8739ae039 = $b0cf533147eaa151$var$UniformHeroCarousel;

});
parcelRegister("us1N6", function(module, exports) {
$parcel$export(module.exports, "HeroCarousel", function () { return $13e2b0d7d2657b7f$export$b92905002f03c113; });
/* hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $hBYvx = parcelRequire("hBYvx");

var $660KI = parcelRequire("660KI");

var $kbpa7 = parcelRequire("kbpa7");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");
const $13e2b0d7d2657b7f$export$b92905002f03c113 = ({ tabsData: tabsData })=>{
    const [selectedTab, setSelectedTab] = (0, $1oC0p.useState)(0);
    const listRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { ref: lastTabRef, inView: isTabListEndVisible } = (0, $jKShK.useInView)({
        root: listRef?.current,
        threshold: 1
    });
    const { ref: firstTabRef, inView: isTabListStartVisible } = (0, $jKShK.useInView)({
        root: listRef?.current,
        threshold: 1
    });
    (0, $1oC0p.useEffect)(()=>{
        const listElement = listRef?.current;
        if (listElement) {
            const tabElement = listElement.children?.[selectedTab + 1];
            if (tabElement && typeof tabElement.scrollIntoView === 'function') {
                tabElement.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                    block: 'end'
                });
                tabElement.focus();
            }
        }
    }, [
        selectedTab
    ]);
    const onKeyDown = (e)=>{
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            let newFocusIndex = 0;
            if (e.key === 'ArrowRight') {
                newFocusIndex = selectedTab + 1;
                if (newFocusIndex >= tabsData.length) newFocusIndex = 0;
            } else if (e.key === 'ArrowLeft') {
                newFocusIndex = selectedTab - 1;
                // If we're at the start, move to the end
                if (newFocusIndex < 0) newFocusIndex = tabsData.length - 1;
            }
            setSelectedTab(newFocusIndex);
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "hero-carousel",
        "data-testid": "hero-carousel",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21sxn _1bsb1osq _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)($13e2b0d7d2657b7f$var$TabList, {
                    listRef: listRef,
                    isTabListViewable: isTabListStartVisible && isTabListEndVisible,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            ref: firstTabRef
                        }),
                        tabsData.map((tab, i)=>/*#__PURE__*/ (0, $7VQPk.jsxs)($13e2b0d7d2657b7f$var$Tab, {
                                isSelected: i === selectedTab,
                                id: tab.id,
                                onClick: ()=>{
                                    setSelectedTab(i);
                                    createAnalyticsEvent({
                                        eventType: 'ui',
                                        action: 'clicked',
                                        actionSubject: 'tab',
                                        actionSubjectId: 'heroCarouselTab',
                                        source: 'heroSection',
                                        attributes: {
                                            label: tab.title,
                                            tabIndex: i
                                        }
                                    }).fire();
                                },
                                onKeyDown: onKeyDown,
                                children: [
                                    tab.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syaz1afi _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "eyebrow-sm"
                                        ]),
                                        style: {
                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                        },
                                        children: tab.eyebrow
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syaz1afi _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "_syaz1afi _1wyb1j6v _k48pni7l _vwz410nf"
                                        ]),
                                        style: {
                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                        },
                                        children: tab.title
                                    })
                                ]
                            }, tab.id)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            ref: lastTabRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelContainer, {
                    children: tabsData.map((tab, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$Panel, {
                            isSelected: i === selectedTab,
                            id: tab.id,
                            panel: tab.panel,
                            titleAs: i === 0 ? 'h1' : 'h2'
                        }, tab.id))
                })
            ]
        })
    });
};
var $13e2b0d7d2657b7f$export$2e2bcd8739ae039 = $13e2b0d7d2657b7f$export$b92905002f03c113;
const $13e2b0d7d2657b7f$var$TabList = ({ children: children, listRef: listRef, isTabListViewable: isTabListViewable })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q71pfd _1bsb1osq _syaz1afi _1reo15vq _18m915vq _18zrzwfg _su071wqb"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            // @ts-expect-error - type mismatch
            ref: listRef,
            tabIndex: -1,
            role: "tablist",
            className: (0, $2jatx.default)([
                "_1tkegad4 _1e0c1txw _qtt8glyw _1mouidpf _195g1wug _18zridpf _1rjcie5z _1reo15zi _rjfvx6dd _b8yqzqdx _zcekze3t _kpfhglyw",
                isTabListViewable && "_1bah1h6o"
            ]),
            children: children
        })
    });
};
const $13e2b0d7d2657b7f$var$Tab = ({ children: children, isSelected: isSelected, id: id, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        tabIndex: isSelected ? 0 : -1,
        role: "tab",
        "aria-selected": isSelected ? 'true' : 'false',
        "aria-controls": `hero-panel-${id}`,
        id: `hero-tab-${id}`,
        onClick: onClick,
        onKeyDown: onKeyDown,
        "data-label": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_mqm21kma _v564ucvz _179rglyw _h7alglyw _r06hglyw _bfhk1j28 _ect41kw7 _1wyb1j6v _1bsb1ltq _1ul91ltq _80omtlke _1hu1v2br _1rjcu2gc _18zr1ejb _4cvrv2br _1e0c1txw _2lx21bp4 _zulp12x7 _oxutkb7n _svxhkb7n _1ah3j39m",
            isSelected && "_mqm21fhw _1wk5kb7n"
        ]),
        style: {
            "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron'))
        },
        children: children
    });
};
const $13e2b0d7d2657b7f$var$PanelContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};
const $13e2b0d7d2657b7f$var$Panel = ({ isSelected: isSelected, id: id, panel: panel, ...props })=>{
    const [isModalOpen, setIsModalOpen] = (0, $1oC0p.useState)(false);
    const baseStyle = null;
    const isVideoLink = panel.secondaryCallToAction?.type === 'video';
    const isForegroundLight = [
        'blue',
        'black'
    ].includes(panel.bgColor);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "tabpanel",
        id: `hero-panel-${id}`,
        "data-testid": `hero-panel-${id}`,
        "aria-hidden": !isSelected,
        // @ts-expect-error -- inert is a valid HTML attribute but missing from @compiled/react types
        inert: !isSelected ? '' : undefined,
        "aria-labelledby": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_v564twcc _yyhy183o _1ii7183o _1e0c11p5 _tzy4idpf _1pby1mrw _kqswh2mm",
            isSelected && "_tzy4kb7n _1pbykb7n",
            "_1kt9b3bt _1g0v1mrw _1cs8stnw _1tesidpf _1rusu6yl _aetrb3bt _1bqq1mrw _18postnw _16gxidpf _z0ai1osq _wbcj14i6 _1kje1h6o _1hfku6yl _1a1fdirt _19h91dfr _z0bc1ed2"
        ]),
        style: {
            '--bg-color': panel.bgColor === 'neutral' ? (0, $kbpa7.wacToken)(`color.neutral.light200`) : (0, $kbpa7.wacToken)(`color.primary.${panel.bgColor}`),
            "--_1gk99st": (0, $6ZVlx.default)(panel.bgImage?.lg ? `url(${panel.bgImage.lg})` : undefined),
            "--_1nhroy": (0, $6ZVlx.default)(panel.layout === 'end' ? '0% 50%' : 'center center')
        },
        children: [
            isVideoLink && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $660KI.Modal), {
                isOpen: isModalOpen,
                closeModal: ()=>{
                    setIsModalOpen(false);
                },
                closeLabel: 'Close video',
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBYvx.Video), {
                    muted: false,
                    videoType: "mp4",
                    videoLink: panel.secondaryCallToAction?.href
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_yyhy183o _1ii7183o _18zrzwfg _1rjcxncg _1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp1ejb _1qon1h6o _1lb81h6o _5qqy1h6o _su071wqb _1rqtcx6w _pdlmxy5q _10jxzqdx",
                    isForegroundLight && "_cg41uftu _125xuftu",
                    panel.layout === 'end' ? "_1uyy1d44 _1cxzv2br _10wbv2br _s0n3v2br" : panel.layout === 'start' ? "_1uyy1vi5 _1cxzv2br _10wbv2br _s0n3v2br" : "_1uyyeqnf"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelContent, {
                        panel: panel,
                        titleAs: props.titleAs
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelActions, {
                        ...panel,
                        onVideoClick: isVideoLink ? (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setIsModalOpen(true);
                        } : undefined
                    })
                ]
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelContent = ({ panel: panel, ...props })=>{
    const { titleAs: Title = 'h2' } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)(Title, {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "h1"
                ]),
                children: panel.title
            }),
            panel.body && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "body-lg"
                ]),
                children: panel.body
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelActions = (panel)=>{
    return panel && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1n261g80 _zulp1ejb",
            (panel.layout === 'start' || panel.layout === 'end') && "_msupv2br"
        ]),
        children: [
            panel.primaryCallToAction && /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PrimaryCallToAction, {
                bgColor: panel.bgColor,
                ...panel.primaryCallToAction
            }),
            panel.secondaryCallToAction && /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$SecondaryCallToAction, {
                ...panel
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PrimaryCallToAction = (props)=>{
    const { bgColor: bgColor, ...rest } = props;
    let variant = 'primary';
    if (bgColor === 'blue') variant = 'primary_alt';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        ...rest,
        variant: variant,
        "data-testid": "primary-cta",
        children: props.text
    });
};
const $13e2b0d7d2657b7f$var$SecondaryCallToAction = (panel)=>{
    const { secondaryCallToAction: secondaryCallToAction } = panel;
    const bgColor = [
        'blue',
        'black'
    ].includes(panel.bgColor) ? 'bgBlackBlue' : 'bgWhite';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const LinkAny = (0, $iPPTB.Link);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(LinkAny, {
        ...secondaryCallToAction,
        bgColor: bgColor,
        anchorProps: {
            'data-testid': 'secondary-cta'
        },
        onClick: panel.onVideoClick,
        onKeyDown: panel.onVideoClick,
        role: "button",
        tabIndex: 0,
        children: secondaryCallToAction?.text
    });
};
const $13e2b0d7d2657b7f$var$sectionStyles = null;
const $13e2b0d7d2657b7f$var$tabListStyle = null;
const $13e2b0d7d2657b7f$var$scrollableStyle = null;
const $13e2b0d7d2657b7f$var$fittableStyle = null;
const $13e2b0d7d2657b7f$var$tabStyle = null;
const $13e2b0d7d2657b7f$var$tabTextStyle = null;
const $13e2b0d7d2657b7f$var$tabTitleStyle = null;
const $13e2b0d7d2657b7f$var$tabSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelContainerStyle = null;
const $13e2b0d7d2657b7f$var$panelStyle = null;
const $13e2b0d7d2657b7f$var$panelSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelDetailsStyle = null;
const $13e2b0d7d2657b7f$var$panelEndStyle = null;
const $13e2b0d7d2657b7f$var$panelStartStyle = null;
const $13e2b0d7d2657b7f$var$panelCenteredStyle = null;
const $13e2b0d7d2657b7f$var$detailsTextStyle = null;
const $13e2b0d7d2657b7f$var$panelColorStyle = null;
const $13e2b0d7d2657b7f$var$actionContainerStyle = null;
const $13e2b0d7d2657b7f$var$actionStartStyle = null;

});
parcelRegister("660KI", function(module, exports) {
$parcel$export(module.exports, "Modal", function () { return $d050fad9e00c5863$export$2b77a92f1a5ad772; });
/* modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $3RaC6 = parcelRequire("3RaC6");

var $cNOwN = parcelRequire("cNOwN");

var $5kbMC = parcelRequire("5kbMC");
var $7M4vT = parcelRequire("7M4vT");
var $dYPjn = parcelRequire("dYPjn");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");
const $d050fad9e00c5863$export$2b77a92f1a5ad772 = ({ title: title, closeLabel: closeLabel, isOpen: isOpen, closeModal: closeModal, width: width, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7M4vT.default), {
        children: isOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kbMC.default), {
            onClose: closeModal,
            shouldScrollInViewport: true,
            width: width,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($d050fad9e00c5863$var$CustomHeader, {
                        title: title,
                        closeLabel: closeLabel
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt4xy5q"
                        ]),
                        children: children
                    })
                ]
            })
        })
    });
};
const $d050fad9e00c5863$var$CustomHeader = ({ title: title, closeLabel: closeLabel })=>{
    const intl = (0, $8e22h.default)();
    const { onClose: onClose, titleId: titleId } = (0, $dYPjn.useModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClose = (e)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'closeModal',
            source: 'modal',
            attributes: {
                label: 'close modal'
            }
        }).fire();
        onClose?.(e, {});
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0e1o6p _ae4v1h6o _1yt4xy5q _179rfxex"
        ]),
        style: {
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "card-title"
                ]),
                id: titleId,
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                appearance: "subtle-link",
                onClick: handleClose,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                    label: closeLabel ?? intl.formatMessage({
                        id: 'Modal.closeIconLabel',
                        defaultMessage: 'close modal'
                    })
                })
            })
        ]
    });
};
const $d050fad9e00c5863$var$mainContentStyle = null;
const $d050fad9e00c5863$var$titleStyle = null;

});



parcelRegister("dr4ha", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d40bb110636103fe$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $eizE0 = parcelRequire("eizE0");
const $d40bb110636103fe$var$UniformHeroScrollToEnlargeContainer = ({ isTransform: isTransform })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eizE0.ScrollToEnlarge), {
        isTransform: isTransform,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content"
        })
    });
};
var $d40bb110636103fe$export$2e2bcd8739ae039 = $d40bb110636103fe$var$UniformHeroScrollToEnlargeContainer;

});
parcelRegister("eizE0", function(module, exports) {
$parcel$export(module.exports, "ScrollToEnlarge", function () { return $3b02598d110ef439$export$d38db68c757989ac; });
/* scroll-to-enlarge.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $3b02598d110ef439$var$scaleUpSm = null;
const $3b02598d110ef439$var$scaleUpMd = null;
const $3b02598d110ef439$var$transformContainerStyles = null;
const $3b02598d110ef439$var$dimensionsUpSm = null;
const $3b02598d110ef439$var$dimensionsUpMd = null;
const $3b02598d110ef439$var$dimensionsContainerStyles = null;
const $3b02598d110ef439$export$d38db68c757989ac = ({ isTransform: isTransform = false, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            isTransform && "",
            isTransform && "",
            isTransform && "_8hrz1nut _p0azweqd _1tntp1rm _poph1jeq _9dw31mjz _ugw218v8 _1k2qeoah _1hcn8ymw _1gq6xeka",
            !isTransform && "",
            !isTransform && "",
            !isTransform && "_195g1wug _glte1v4r _poph1jeq _9dw31mjz _ugw218v8 _1k2qeoah _1hcn1e2f _1gq619ne"
        ]),
        style: {
            "--_dolbo3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease-both'))
        },
        children: children
    });
};

});


parcelRegister("1Gd1W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74902a183e2dfc7a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8J2ZV = parcelRequire("8J2ZV");

var $jQ0cd = parcelRequire("jQ0cd");
const $74902a183e2dfc7a$var$UniformHeroSection = (props)=>{
    const localizedSecondaryCtaHref = (0, $jQ0cd.useLocalizedHref)(props.secondaryCtaHref ?? '');
    const localizedButtonHref = (0, $jQ0cd.useLocalizedHref)(props.buttonHref?.path ?? '');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8J2ZV.default), {
        heading: props.heading,
        size: props.size,
        subheading: props.subheading,
        layout: props.layout ?? 'image-right',
        backgroundColor: props.backgroundColor,
        callToActionProps: props.buttonHref && props.buttonLabel ? {
            text: props.buttonLabel,
            href: localizedButtonHref,
            variant: props.buttonVariant ?? 'primary',
            dataEventProps: {
                'data-product-key': 'uniform',
                'data-event': 'clicked',
                'data-event-component': 'linkButton',
                'data-event-container': 'heroSection'
            }
        } : undefined,
        secondaryCta: props.secondaryCtaHref && props.secondaryCtaLabel ? {
            label: props.secondaryCtaLabel,
            href: localizedSecondaryCtaHref,
            dataEventProps: {
                'data-product-key': 'uniform',
                'data-event': 'clicked',
                'data-event-component': 'linkButton',
                'data-event-container': 'heroSection',
                'data-label': props.secondaryCtaLabel
            }
        } : undefined,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: props.imageAlt ?? ''
        } : undefined,
        secondaryImageProps: props.secondaryImageUrl ? {
            src: props.secondaryImageUrl,
            alt: ''
        } : undefined
    });
};
var $74902a183e2dfc7a$export$2e2bcd8739ae039 = $74902a183e2dfc7a$var$UniformHeroSection;

});
parcelRegister("8J2ZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3798516d873ca4cc$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");
const $3798516d873ca4cc$export$887967f05dc521ae = ({ layout: layout = 'image-right', ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        style: {
            '--background-color': `${props.backgroundColor ? (0, $kbpa7.wacToken)(props.backgroundColor) : 'transparent'}`
        },
        className: (0, $2jatx.default)([
            "_11q76ulk"
        ]),
        children: layout === 'image-both' ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroBothImages, {
            ...props
        }) : layout === 'no-image' ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroNoImage, {
            ...props
        }) : layout === 'image-below' ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroImageBelow, {
            ...props
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroOneImage, {
            layout: layout,
            ...props
        })
    });
};
var $3798516d873ca4cc$export$2e2bcd8739ae039 = $3798516d873ca4cc$export$887967f05dc521ae;
const $3798516d873ca4cc$var$DARK_BKGD_COLORS = [
    'color.primary.black'
];
const $3798516d873ca4cc$var$HeadingContent = ({ heading: heading, subheading: subheading, callToActionProps: callToActionProps, secondaryCta: secondaryCta, secondaryCtaType: secondaryCtaType, size: size = 'regular', backgroundColor: backgroundColor, layout: layout })=>{
    const { text: buttonText, ...buttonProps } = callToActionProps ?? {};
    const isLarge = size === 'large';
    const useLightText = backgroundColor ? $3798516d873ca4cc$var$DARK_BKGD_COLORS.includes(backgroundColor) : false;
    const uniqueId = (0, $1oC0p.useId)();
    const headingId = `hero-heading-${uniqueId}`;
    const buttonId = `hero-cta-${uniqueId}`;
    const secondaryCtaId = `hero-secondary-cta-${uniqueId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                id: headingId,
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)('color.neutral.light0') : 'inherit'
                },
                className: (0, $2jatx.default)([
                    "_18s8ze3t",
                    isLarge ? 'superhero' : undefined
                ]),
                children: heading
            }),
            subheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1pfhu2gc _6rthze3t",
                    isLarge ? 'body-lg' : 'body-md'
                ]),
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)('color.neutral.light0') : 'inherit'
                },
                children: subheading
            }),
            (buttonText || secondaryCta) && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1q51xy5q"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _1n261g80 _zulpv47k _4cvr1h6o _1bah1h6o",
                        $3798516d873ca4cc$var$isSideImageLayout(layout) && "_nssp1y6m"
                    ]),
                    children: [
                        buttonText && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            ...buttonProps,
                            id: buttonId,
                            size: "large",
                            ariaLabelledby: `${buttonId} ${headingId}`,
                            children: buttonText
                        }),
                        secondaryCta && /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroSecondaryCta, {
                            cta: secondaryCta,
                            type: secondaryCtaType,
                            id: secondaryCtaId,
                            headingId: headingId,
                            useLightText: useLightText
                        })
                    ]
                })
            })
        ]
    });
};
const $3798516d873ca4cc$var$HeroSecondaryCta = ({ cta: cta, type: type = 'link', id: id, headingId: headingId, useLightText: useLightText })=>{
    if (type === 'button') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        id: id,
        href: cta.href,
        variant: "secondary",
        size: "large",
        colorAgainst: useLightText ? 'black' : 'white',
        ariaLabelledby: `${id} ${headingId}`,
        dataEventProps: cta.dataEventProps,
        children: cta.label
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_85i51b66"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            text: cta.label,
            href: cta.href,
            "aria-label": cta.label,
            id: id,
            ariaLabelledby: `${id} ${headingId}`,
            bgColor: useLightText ? 'bgBlackBlue' : undefined,
            dataEventProps: cta.dataEventProps
        })
    });
};
const $3798516d873ca4cc$var$HeroOneImage = ({ layout: layout = 'image-right', imageProps: imageProps, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp1ejb _1rjc1jfw _y3gn1h6o _4cvr1h6o _1j8bwxkt _lagd18l3 _19wgxy5q _uj6kv2br _1ooboahv _1s0lxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        layout === 'image-left' && "_1b1qcs5v"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                        ...props,
                        layout: layout
                    })
                }),
                imageProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    maxPossibleWidth: 700,
                    src: imageProps.src,
                    alt: imageProps.alt ?? '',
                    loading: "eager",
                    width: imageProps.width,
                    height: imageProps.height
                })
            ]
        })
    });
};
const $3798516d873ca4cc$var$gridStyle = null;
const $3798516d873ca4cc$var$headingStyle = null;
const $3798516d873ca4cc$var$imageStartStyle = null;
const $3798516d873ca4cc$var$bodyStyle = null;
const $3798516d873ca4cc$var$buttonWrapperStyle = null;
/*
This is an experimental start to support the needs of the Hero variation with images on the sides, primary content centered
Initial support is seen on Product enterprise pages (such as /software/jira/enterprise) as served by WAC Authoring Engine

TODO: We need to understand the levels of configurability desired/needed to support a variety of use cases, collab with design.
  Currently it is very tailored to the aforementioned enterprise experience. 
  We may need to ensure we use Image so that we can add an alt text if needed.
*/ const $3798516d873ca4cc$var$HeroBothImages = ({ imageProps: imageProps, secondaryImageProps: secondaryImageProps, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_uaqo1yvm _13j9ydn5",
                    "_kqswh2mm _1e0c11p5 _10fp1h6o _y3gn1h6o _4cvr1h6o _6a6z1h6o _1rjc1jfw _14b51ssb _su07u2gc _1ooboahv _1s0lxncg _bxthb3bt _t4hxstnw _1yp51osq _1bpvsmen _brhgmgnk _5kbx1f51 _1gg8w2la _n4lfidpf _1nls12it _14xsidpf _16bh12it _1z0y9by0 _ixsu1osq _a6uwb3bt _dbttstnw _83tk1wn5 _10wjmgnk _tzs91f51 _wi3i1048 _1x65idpf _oppa12it _1ohy1kly _nd8fidpf _1yam12it _ugza1kly _mlxy9by0 _k4z51osq _xcpbpwvu"
                ]),
                style: {
                    "--_1d770q0": (0, $6ZVlx.default)(imageProps ? `url(${imageProps.src})` : 'none'),
                    "--_e5l2lr": (0, $6ZVlx.default)(secondaryImageProps ? `url(${secondaryImageProps.src})` : 'none')
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                    ...props,
                    size: "regular"
                })
            })
        })
    });
};
const $3798516d873ca4cc$var$gridTwoImagesStyle = null;
const $3798516d873ca4cc$var$HeroNoImage = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "10",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _1rjc1jfw _1ooboahv _1s0lxncg",
                "_85i5xncg"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                ...props
            })
        })
    });
};
const $3798516d873ca4cc$var$centerTextWrapperStyle = null;
const $3798516d873ca4cc$var$noImageBottomPaddingStyle = null;
const $3798516d873ca4cc$var$HeroImageBelow = ({ imageProps: imageProps, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "10",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _85i5xncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _1rjc1jfw _1ooboahv _1s0lxncg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                        ...props
                    })
                }),
                imageProps && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _1pfhxy5q _1nlx1osq _mezj1osq _v4pn1ule"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: imageProps.src,
                        alt: imageProps.alt ?? '',
                        loading: "eager",
                        width: imageProps.width,
                        height: imageProps.height
                    })
                })
            ]
        })
    });
};
const $3798516d873ca4cc$var$imageBelowContainerStyle = null;
const $3798516d873ca4cc$var$imageBelowImageWrapperStyle = null;
const $3798516d873ca4cc$var$isSideImageLayout = (layout)=>layout === 'image-left' || layout === 'image-right';
const $3798516d873ca4cc$var$ctaRowStyles = null;
const $3798516d873ca4cc$var$ctaStartStyles = null;
const $3798516d873ca4cc$var$ctaLinkStyles = null;

});


parcelRegister("gOX57", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0d3d16c86aa8462$export$2e2bcd8739ae039; });
/* hovering-teamwork-graph.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $BcgfF = parcelRequire("BcgfF");
const $f0d3d16c86aa8462$var$outerHoverBlockCss = null;
const $f0d3d16c86aa8462$var$textContainerCss = null;
const $f0d3d16c86aa8462$var$hoverHeadingCss = null;
const $f0d3d16c86aa8462$var$BodyParagraph = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: "body-lg",
        style: {
            marginBlockStart: "var(--ds-space-100, 8px)",
            marginBlockEnd: "var(--ds-space-400, 32px)"
        },
        children: children
    });
const $f0d3d16c86aa8462$var$resolveBodyTextRenderer = (node)=>node.type === 'paragraph' ? $f0d3d16c86aa8462$var$BodyParagraph : undefined;
const $f0d3d16c86aa8462$var$UniformHoveringTeamworkGraph = ({ heading: heading, bodyText: bodyText, ctaLabel: ctaLabel, ctaUrl: ctaUrl })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhkrf0c _1rjc1epz _kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o",
            "hovering-teamwork-graph"
        ]),
        style: {
            "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1bsb1osq _1pbykb7n"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1bsb1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsbhy7n _kqswstnw _1s4p1wug _z115h2mm"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kdam16sm",
                                        "text-container-hovering"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                            className: (0, $2jatx.default)([
                                                "_1pfhidpf _6rthidpf",
                                                "hover-heading"
                                            ]),
                                            children: heading
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                                            node: bodyText.root,
                                            resolveRichTextRenderer: $f0d3d16c86aa8462$var$resolveBodyTextRenderer
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: 'secondary',
                                    responsiveSize: {
                                        mobile: 'small',
                                        tablet: 'small',
                                        desktop: 'large',
                                        xl_desktop: 'large'
                                    },
                                    colorAgainst: 'black',
                                    href: ctaUrl,
                                    "aria-label": `${ctaLabel}, ${heading}`,
                                    dataEventProps: {
                                        'data-product-key': 'uniform',
                                        'data-event': 'clicked',
                                        'data-event-component': 'linkButton',
                                        'data-event-container': 'bodyContentInline',
                                        'data-label': ctaLabel,
                                        'data-label-english': ctaLabel
                                    },
                                    children: ctaLabel
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $BcgfF.AmbientShimmerGraph), {})
        ]
    });
};
var $f0d3d16c86aa8462$export$2e2bcd8739ae039 = $f0d3d16c86aa8462$var$UniformHoveringTeamworkGraph;

});
parcelRegister("BcgfF", function(module, exports) {
$parcel$export(module.exports, "AmbientShimmerGraph", function () { return $ca9f6fe6f5676a6f$export$5f1d30db716b1d35; });

var $7VQPk = parcelRequire("7VQPk");

var $UMzWl = parcelRequire("UMzWl");
const $ca9f6fe6f5676a6f$var$ambientMovementNodes = [
    {
        id: 'square-icon-jpd',
        x: 45.9,
        y: 17.4,
        shape: 'rectangle',
        size: 33,
        bgColor: 'purple400',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9I.svg'
    },
    {
        id: 'square-icon-jira',
        x: 48.4,
        y: 41.6,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9C.svg',
        shape: 'rectangle',
        size: 33,
        bgColor: 'blue700'
    },
    {
        id: 'square-icon-conf',
        x: 77.5,
        y: 50.2,
        shape: 'rectangle',
        size: 33,
        bgColor: 'blue700',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MY.svg'
    },
    {
        id: 'square-icon-loom',
        x: 57,
        y: 64.4,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9D.svg',
        shape: 'rectangle',
        size: 33,
        bgColor: 'blue700'
    },
    {
        id: 'square-icon-talent',
        x: 30.7,
        y: 63.5,
        shape: 'rectangle',
        size: 33,
        bgColor: 'orange300',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9J.svg'
    },
    {
        id: 'square-icon-jsm',
        x: 80,
        y: 90.6,
        shape: 'rectangle',
        size: 33,
        bgColor: 'yellow300',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9E.svg'
    },
    {
        id: 'square-icon-bitbucket',
        x: 86.3,
        y: 39.8,
        shape: 'rectangle',
        size: 33,
        bgColor: 'lime500',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9Z.svg'
    },
    {
        id: 'avatar-purple',
        x: 75.5,
        y: 31.4,
        shape: 'circle',
        size: 33,
        bgColor: 'purple500',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVS8.png'
    },
    {
        id: 'avatar-orange',
        x: 55.4,
        y: 50.6,
        shape: 'circle',
        size: 33,
        bgColor: 'orange300',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVSA.png'
    },
    {
        id: 'avatar-yellow',
        x: 73.7,
        y: 70.6,
        shape: 'circle',
        size: 33,
        bgColor: 'yellow300',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVSB.png'
    },
    {
        id: 'avatar-blue',
        x: 25.2,
        y: 73,
        shape: 'circle',
        size: 33,
        bgColor: 'blue700',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVS9.png'
    },
    {
        id: 'square-icon-chatgpt',
        x: 27.8,
        y: 87.1,
        shape: 'rectangle',
        size: 33,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUIK.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'art-icon-squiggle',
        x: 43,
        y: 68.3,
        shape: 'rectangle',
        size: 33,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMX.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'square-icon-other',
        x: 87.1,
        y: 78.7,
        shape: 'rectangle',
        size: 33,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA0.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'square-icon-gdrive',
        x: 92,
        y: 30.2,
        shape: 'rectangle',
        size: 33,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA5.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'art-icon-target',
        x: 67,
        y: 79.3,
        shape: 'rectangle',
        size: 33,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMV.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'art-icon-code',
        x: 68.1,
        y: 14.5,
        shape: 'rectangle',
        size: 24,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMS.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'art-icon-lightning',
        x: 69.5,
        y: 37.4,
        shape: 'rectangle',
        size: 24,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMN.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'art-icon-lightbulb',
        x: 68.1,
        y: 62.4,
        shape: 'rectangle',
        size: 24,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMQ.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'art-icon-dollar',
        x: 51.8,
        y: 76.2,
        shape: 'rectangle',
        size: 24,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMZ.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'square-icon-figma',
        x: 49.2,
        y: 60.4,
        shape: 'rectangle',
        size: 24,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA4.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'art-icon-video',
        x: 92.3,
        y: 57.8,
        shape: 'rectangle',
        size: 24,
        bgColor: 'neutral1100',
        borderWidth: 1.7,
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMP.svg',
        borderColor: 'neutral700'
    },
    {
        id: 'hex-blue-agent',
        x: 41.2,
        y: 49.5,
        shape: 'hexagon',
        size: 35,
        bgColor: 'blue600',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUII.svg'
    },
    {
        id: 'hex-orange',
        x: 59.3,
        y: 37.3,
        shape: 'hexagon',
        size: 35,
        bgColor: 'orange400',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUIH.svg'
    },
    {
        id: 'hex-lime-agent',
        x: 84.8,
        y: 23.2,
        shape: 'hexagon',
        size: 35,
        bgColor: 'lime500',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUIG.svg'
    },
    {
        id: 'hex-blue',
        x: 45.2,
        y: 90.2,
        shape: 'hexagon',
        size: 35,
        bgColor: 'blue300',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUIJ.svg'
    },
    {
        id: 'pill-project',
        x: 57,
        y: 24.8,
        shape: 'rectangle',
        size: 24,
        width: 62,
        bgColor: 'neutral1100',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVRW.svg',
        borderWidth: 1.7,
        borderColor: 'neutral700'
    },
    {
        id: 'pill-work-item',
        x: 67,
        y: 51,
        shape: 'rectangle',
        size: 24,
        width: 72,
        bgColor: 'neutral1100',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OV89.svg',
        borderWidth: 1.7,
        borderColor: 'neutral700'
    },
    {
        id: 'pill-focus-area',
        x: 37,
        y: 79.6,
        shape: 'rectangle',
        size: 24,
        width: 81,
        bgColor: 'neutral1100',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVRU.svg',
        borderWidth: 1.7,
        borderColor: 'neutral700'
    },
    {
        id: 'pill-roadmap',
        x: 83.2,
        y: 66.9,
        shape: 'rectangle',
        size: 24,
        width: 60,
        bgColor: 'neutral1100',
        bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVRV.svg',
        borderWidth: 1.7,
        borderColor: 'neutral700'
    }
];
const $ca9f6fe6f5676a6f$var$shimmerConnectors = [
    {
        from: 'square-icon-jpd',
        to: 'pill-project',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-jpd',
        to: 'hex-blue-agent',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-jpd',
        to: 'square-icon-jira',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-project',
        to: 'hex-orange',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-work-item',
        to: 'hex-orange',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-work-item',
        to: 'art-icon-lightbulb',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-work-item',
        to: 'art-icon-lightning',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'art-icon-lightning',
        to: 'avatar-purple',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'hex-orange',
        to: 'square-icon-jira',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-jira',
        to: 'hex-blue-agent',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-jira',
        to: 'avatar-orange',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'avatar-orange',
        to: 'pill-work-item',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'avatar-orange',
        to: 'square-icon-figma',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'avatar-orange',
        to: 'square-icon-loom',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'hex-blue',
        to: 'art-icon-dollar',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-loom',
        to: 'art-icon-dollar',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-loom',
        to: 'pill-work-item',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'art-icon-lightbulb',
        to: 'avatar-yellow',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'avatar-yellow',
        to: 'pill-roadmap',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'avatar-yellow',
        to: 'art-icon-target',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'art-icon-squiggle',
        to: 'art-icon-dollar',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'avatar-purple',
        to: 'hex-lime-agent',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'hex-lime-agent',
        to: 'square-icon-bitbucket',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-gdrive',
        to: 'square-icon-bitbucket',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'avatar-purple',
        to: 'square-icon-bitbucket',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-work-item',
        to: 'square-icon-conf',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'avatar-purple',
        to: 'square-icon-conf',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-bitbucket',
        to: 'square-icon-conf',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'avatar-blue',
        to: 'square-icon-chatgpt',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-roadmap',
        to: 'art-icon-video',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'art-icon-squiggle',
        to: 'pill-focus-area',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-talent',
        to: 'avatar-blue',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-talent',
        to: 'pill-focus-area',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-other',
        to: 'avatar-yellow',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'square-icon-jsm',
        to: 'avatar-yellow',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-focus-area',
        to: 'hex-blue',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-roadmap',
        to: 'pill-work-item',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-project',
        to: 'art-icon-code',
        isAnimated: true,
        animationEffect: 'shimmer'
    },
    {
        from: 'pill-project',
        to: 'avatar-purple',
        isAnimated: true,
        animationEffect: 'shimmer'
    }
];
const $ca9f6fe6f5676a6f$export$5f1d30db716b1d35 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
        nodes: $ca9f6fe6f5676a6f$var$ambientMovementNodes,
        connectors: $ca9f6fe6f5676a6f$var$shimmerConnectors,
        useOnlyExplicitConnectors: true,
        animateOnLoad: false,
        connectorType: "dotted",
        ambientMovement: true,
        showAnimationPauseControl: true,
        connectorColor: "neutral800",
        bgColor: "neutral1100",
        width: 1920,
        height: 1056
    });

});
parcelRegister("UMzWl", function(module, exports) {
$parcel$export(module.exports, "SpiderWebContainer", function () { return $0d50d6616177f8b7$export$5c2ce7618e6623c7; });
/* spiderweb-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $iZj3A = parcelRequire("iZj3A");

var $jElRc = parcelRequire("jElRc");

var $kbpa7 = parcelRequire("kbpa7");

var $idRu8 = parcelRequire("idRu8");

var $hNner = parcelRequire("hNner");

var $4xHTR = parcelRequire("4xHTR");

var $kCguZ = parcelRequire("kCguZ");

var $7h9Nf = parcelRequire("7h9Nf");

var $iDO3O = parcelRequire("iDO3O");

var $ldiHh = parcelRequire("ldiHh");

var $29NYv = parcelRequire("29NYv");

var $hiPUj = parcelRequire("hiPUj");

var $gHYtp = parcelRequire("gHYtp");
const $0d50d6616177f8b7$var$NODE_STAGGER = 0.06;
const $0d50d6616177f8b7$var$EDGE_DELAY_BASE = 0.3;
const $0d50d6616177f8b7$var$EDGE_STAGGER = 0.08;
const $0d50d6616177f8b7$var$NODE_ENTRANCE_DURATION_SEC = 0.6;
const $0d50d6616177f8b7$var$CONNECTOR_SOLID_DRAW_DURATION_SEC = 1;
const $0d50d6616177f8b7$var$CONNECTOR_DASHED_ENTRANCE_DURATION_SEC = 0.8;
const $0d50d6616177f8b7$var$OVERLAP_LOAD_ENTRANCE_FADE_SEC = 0.5;
const $0d50d6616177f8b7$var$ANIMATED_CONNECTOR_SHAPE_OPACITY_SEC = 0.6;
const $0d50d6616177f8b7$var$ANIMATED_CONNECTOR_SHAPE_APPEAR_OFFSET_SEC = 1;
/**
 * `animation-play-state` does not inherit; this scopes `paused` to all descendants
 * (and common pseudo-elements) so keyframe animations freeze in place.
 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors -- intentional descendant `animation-play-state` (non-inherited) */ const $0d50d6616177f8b7$var$spiderwebPauseScopeStyle = null;
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors */ function $0d50d6616177f8b7$var$clampLoadEntranceSpeedMultiplier(raw) {
    const m = raw ?? 1;
    if (!Number.isFinite(m) || m <= 0) return 1;
    return Math.min(10, Math.max(0.25, m));
}
function $0d50d6616177f8b7$var$computePhaseClockStartOffsetSec(animateOnLoad, nodeCount, edgeCount, nodeTotalDuration, connectorType, nodeStagger, nodeEntranceDurationSec, edgeDelayBase, edgeStagger, solidDrawDurationSec, dashedFadeDurationSec) {
    if (!animateOnLoad) return 0;
    const lastNodeDelay = nodeCount > 0 ? (nodeCount - 1) * nodeStagger : 0;
    const nodeEntranceEndSec = lastNodeDelay + nodeEntranceDurationSec;
    const connectorEntranceEndSec = edgeCount === 0 ? 0 : nodeTotalDuration + edgeDelayBase + Math.max(0, edgeCount - 1) * edgeStagger + (connectorType === 'solid' ? solidDrawDurationSec : dashedFadeDurationSec);
    return Math.max(nodeEntranceEndSec, connectorEntranceEndSec);
}
function $0d50d6616177f8b7$var$createNodeEntranceDelayFn(animateOnLoad, nodeStagger) {
    return (index)=>animateOnLoad ? index * nodeStagger : 0;
}
function $0d50d6616177f8b7$var$createConnectorEntranceDelayFn(animateOnLoad, nodeTotalDuration, edgeDelayBase, edgeStagger) {
    return (index)=>animateOnLoad ? nodeTotalDuration + edgeDelayBase + index * edgeStagger : 0;
}
function $0d50d6616177f8b7$var$overlapEntranceDelayValue(animateOnLoad, nodeTotalDuration, edgeDelayBase) {
    return animateOnLoad ? nodeTotalDuration + edgeDelayBase * 0.5 : 0;
}
function $0d50d6616177f8b7$var$openNodeModalIfPresent(node, setExpandingNodeId, setActiveModal) {
    if (!node.modalContent) return;
    setExpandingNodeId(node.id);
    setTimeout(()=>{
        setActiveModal(node.modalContent ?? null);
    }, 200);
}
function $0d50d6616177f8b7$var$resolveAnimationFlags(prefersReducedMotion, isVisible) {
    return {
        animated: prefersReducedMotion || isVisible,
        phaseMotionActive: !prefersReducedMotion && isVisible
    };
}
function $0d50d6616177f8b7$var$spiderWebDimensionValues(width, height) {
    return {
        widthValue: width ?? '100%',
        heightValue: height ?? 600
    };
}
function $0d50d6616177f8b7$var$computeViewBoxHeight(width, height, useViewportDimensions) {
    if (useViewportDimensions) return 0, $hNner.VIEWBOX_SCALE;
    if (typeof width === 'number' && typeof height === 'number') return Math.round((0, $hNner.VIEWBOX_SCALE) * height / width);
    return 0, $hNner.VIEWBOX_SCALE;
}
function $0d50d6616177f8b7$var$buildContainerStyle(width, height, bgColor, maxHeightViewport, useViewportDimensions) {
    const bg = bgColor !== undefined ? (0, $hNner.getFillColor)(bgColor) : undefined;
    if (useViewportDimensions) return {
        position: 'relative',
        backgroundColor: bg,
        overflow: 'hidden',
        width: '100vw',
        height: '90vh'
    };
    const hasExplicitWidth = width && typeof width === 'number' || typeof width === 'string';
    const hasExplicitHeight = height && typeof height === 'number' || typeof height === 'string';
    return {
        position: 'relative',
        backgroundColor: bg,
        overflow: 'hidden',
        maxWidth: width,
        width: '100%',
        maxHeight: maxHeightViewport ? '90vh' : !hasExplicitWidth && !hasExplicitHeight ? height : undefined,
        height: hasExplicitHeight && !hasExplicitWidth ? height : undefined,
        aspectRatio: hasExplicitWidth && hasExplicitHeight ? `${width} / ${height}` : undefined
    };
}
const $0d50d6616177f8b7$export$5c2ce7618e6623c7 = ({ nodes: nodes, connectors: explicitConnectors, useOnlyExplicitConnectors: useOnlyExplicitConnectors = false, connectorShape: connectorShape = 'straight', connectorType: connectorType = 'solid', bgColor: bgColor, width: width, height: height, maxNeighbors: maxNeighbors = 3, connectorColor: connectorColor = 'neutral700', connectorWidth: connectorWidth = 2, fontFamily: fontFamily = 'monospace', animateOnLoad: animateOnLoad = true, loadEntranceSpeedMultiplier: loadEntranceSpeedMultiplier, replayOnVisible: replayOnVisible = false, maxHeightViewport: maxHeightViewport = false, useViewportDimensions: useViewportDimensions = false, showAnimationPauseControl: showAnimationPauseControl = false, ambientMovement: ambientMovement = false, animationPhasesDrive: animationPhasesDrive = 'time', scrollSectionRef: scrollSectionRef, scrollMagnetAnchors: scrollMagnetAnchors, scrollMagnetMinProgressDelta: scrollMagnetMinProgressDelta, scrollMagnetSettleDebounceMs: scrollMagnetSettleDebounceMs, scrollMagnetDurationMs: scrollMagnetDurationMs, scrollMagnetDirectionDeadbandPx: scrollMagnetDirectionDeadbandPx, scrollMagnetDirectionBias: scrollMagnetDirectionBias, scrollPhaseProgressOverride: scrollPhaseProgressOverride, onScrollPhaseProgressChange: onScrollPhaseProgressChange, onSvgCanvasClick: onSvgCanvasClick, onNodeClick: onNodeClick, focusedConnector: focusedConnector, nodeFocus: nodeFocus })=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const { isVisible: isVisible, isCurrentlyVisible: isCurrentlyVisible } = (0, $iDO3O.useSpiderWebIntersectionVisibility)(containerRef, replayOnVisible);
    const prefersReducedMotion = (0, $29NYv.useSpiderWebReducedMotion)();
    const [activeModal, setActiveModal] = (0, $1oC0p.useState)(null);
    const [expandingNodeId, setExpandingNodeId] = (0, $1oC0p.useState)(null);
    const [animationsPaused, setAnimationsPaused] = (0, $1oC0p.useState)(false);
    const { animated: animated, phaseMotionActive: phaseMotionActive } = $0d50d6616177f8b7$var$resolveAnimationFlags(prefersReducedMotion, isVisible);
    const entranceM = $0d50d6616177f8b7$var$clampLoadEntranceSpeedMultiplier(loadEntranceSpeedMultiplier);
    const loadEntranceTimings = (0, $1oC0p.useMemo)(()=>({
            nodeStagger: $0d50d6616177f8b7$var$NODE_STAGGER / entranceM,
            edgeDelayBase: $0d50d6616177f8b7$var$EDGE_DELAY_BASE / entranceM,
            edgeStagger: $0d50d6616177f8b7$var$EDGE_STAGGER / entranceM,
            nodeEntranceDurationSec: $0d50d6616177f8b7$var$NODE_ENTRANCE_DURATION_SEC / entranceM,
            connectorSolidDrawDurationSec: $0d50d6616177f8b7$var$CONNECTOR_SOLID_DRAW_DURATION_SEC / entranceM,
            connectorDashedFadeDurationSec: $0d50d6616177f8b7$var$CONNECTOR_DASHED_ENTRANCE_DURATION_SEC / entranceM,
            overlapFadeDurationSec: $0d50d6616177f8b7$var$OVERLAP_LOAD_ENTRANCE_FADE_SEC / entranceM,
            animatedShapeOpacityDurationSec: $0d50d6616177f8b7$var$ANIMATED_CONNECTOR_SHAPE_OPACITY_SEC / entranceM,
            animatedShapeAppearOffsetSec: $0d50d6616177f8b7$var$ANIMATED_CONNECTOR_SHAPE_APPEAR_OFFSET_SEC / entranceM
        }), [
        entranceM
    ]);
    const nodeTotalDuration = nodes.length * loadEntranceTimings.nodeStagger;
    const { connectorConfigs: connectorConfigs, resolvedConnectors: resolvedConnectors } = (0, $kCguZ.useSpiderWebConnectorPlan)(nodes, maxNeighbors, explicitConnectors, useOnlyExplicitConnectors, connectorShape, connectorType);
    const phaseClockStartOffsetSec = (0, $1oC0p.useMemo)(()=>$0d50d6616177f8b7$var$computePhaseClockStartOffsetSec(animateOnLoad, nodes.length, connectorConfigs.length, nodeTotalDuration, connectorType, loadEntranceTimings.nodeStagger, loadEntranceTimings.nodeEntranceDurationSec, loadEntranceTimings.edgeDelayBase, loadEntranceTimings.edgeStagger, loadEntranceTimings.connectorSolidDrawDurationSec, loadEntranceTimings.connectorDashedFadeDurationSec), [
        animateOnLoad,
        nodes.length,
        connectorConfigs.length,
        nodeTotalDuration,
        connectorType,
        loadEntranceTimings.connectorDashedFadeDurationSec,
        loadEntranceTimings.connectorSolidDrawDurationSec,
        loadEntranceTimings.edgeDelayBase,
        loadEntranceTimings.edgeStagger,
        loadEntranceTimings.nodeEntranceDurationSec,
        loadEntranceTimings.nodeStagger
    ]);
    const skipLoadEntrance = !animateOnLoad;
    const nodeEntranceDelay = (0, $1oC0p.useMemo)(()=>$0d50d6616177f8b7$var$createNodeEntranceDelayFn(animateOnLoad, loadEntranceTimings.nodeStagger), [
        animateOnLoad,
        loadEntranceTimings.nodeStagger
    ]);
    const connectorEntranceDelay = (0, $1oC0p.useMemo)(()=>$0d50d6616177f8b7$var$createConnectorEntranceDelayFn(animateOnLoad, nodeTotalDuration, loadEntranceTimings.edgeDelayBase, loadEntranceTimings.edgeStagger), [
        animateOnLoad,
        loadEntranceTimings.edgeDelayBase,
        loadEntranceTimings.edgeStagger,
        nodeTotalDuration
    ]);
    const overlapEntranceDelay = $0d50d6616177f8b7$var$overlapEntranceDelayValue(animateOnLoad, nodeTotalDuration, loadEntranceTimings.edgeDelayBase);
    const hasAnyPhases = (0, $1oC0p.useMemo)(()=>(0, $ldiHh.anyNodeHasPhases)(nodes), [
        nodes
    ]);
    const scrollPhasesEnabled = animationPhasesDrive === 'scroll' && hasAnyPhases;
    const scrollProgressOverride01 = typeof scrollPhaseProgressOverride === 'number' && Number.isFinite(scrollPhaseProgressOverride) ? Math.min(1, Math.max(0, scrollPhaseProgressOverride)) : null;
    const scrollProgressListenerEnabled = scrollPhasesEnabled && scrollProgressOverride01 === null;
    const { progress: scrollPhaseProgress, isAttached: scrollProgressAttached } = (0, $7h9Nf.useSpiderwebDocumentSectionProgress)(scrollSectionRef, scrollProgressListenerEnabled);
    const effectiveScrollProgress = scrollProgressOverride01 !== null ? scrollProgressOverride01 : scrollPhaseProgress;
    (0, $1oC0p.useEffect)(()=>{
        onScrollPhaseProgressChange?.(effectiveScrollProgress);
    }, [
        effectiveScrollProgress,
        onScrollPhaseProgressChange
    ]);
    const scrollMagnetEnabled = scrollProgressListenerEnabled && !prefersReducedMotion && (scrollMagnetAnchors?.length ?? 0) > 0;
    (0, $hiPUj.useSpiderwebScrollMagnet)(scrollSectionRef, {
        enabled: scrollMagnetEnabled,
        anchors: scrollMagnetAnchors,
        minProgressDelta: scrollMagnetMinProgressDelta,
        settleDebounceMs: scrollMagnetSettleDebounceMs,
        scrollMagnetDurationMs: scrollMagnetDurationMs,
        scrollMagnetDirectionDeadbandPx: scrollMagnetDirectionDeadbandPx,
        scrollMagnetDirectionBias: scrollMagnetDirectionBias
    });
    const phaseDriveActive = animationPhasesDrive === 'scroll' ? scrollProgressOverride01 !== null ? true : scrollProgressAttached : phaseMotionActive;
    const effectivePhaseClockOffsetSec = animationPhasesDrive === 'scroll' ? 0 : phaseClockStartOffsetSec;
    const phaseNodePositions = (0, $ldiHh.useSpiderwebPhasePositions)(nodes, phaseDriveActive, effectivePhaseClockOffsetSec, animationsPaused, {
        drive: animationPhasesDrive,
        scrollProgress: effectiveScrollProgress
    });
    const nodePositions = (0, $4xHTR.useSpiderwebAmbientPositions)(nodes, phaseNodePositions, ambientMovement && !prefersReducedMotion && isCurrentlyVisible, animationsPaused);
    const aspectCorrection = (0, $gHYtp.useSpiderwebViewportAspect)(useViewportDimensions, useViewportDimensions ? containerRef : undefined);
    const handleNodeActivate = (0, $1oC0p.useCallback)((node)=>{
        onNodeClick?.(node);
        $0d50d6616177f8b7$var$openNodeModalIfPresent(node, setExpandingNodeId, setActiveModal);
    }, [
        onNodeClick
    ]);
    const animationsShouldPause = animationsPaused || !isCurrentlyVisible;
    (0, $1oC0p.useEffect)(()=>{
        const root = containerRef.current;
        if (!root) return;
        const svg = root.querySelector('svg');
        if (!(svg instanceof SVGSVGElement)) return;
        if (animationsShouldPause) svg.pauseAnimations?.();
        else svg.unpauseAnimations?.();
    }, [
        animationsShouldPause
    ]);
    const { widthValue: widthValue, heightValue: heightValue } = $0d50d6616177f8b7$var$spiderWebDimensionValues(width, height);
    const viewBoxHeight = $0d50d6616177f8b7$var$computeViewBoxHeight(widthValue, heightValue, useViewportDimensions);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: containerRef,
        "data-spiderweb-animations-paused": animationsShouldPause ? 'true' : undefined,
        style: $0d50d6616177f8b7$var$buildContainerStyle(width, height, bgColor, maxHeightViewport, useViewportDimensions),
        className: (0, $2jatx.default)([
            "_17pstrqk _95fktrqk _1wvttrqk"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $idRu8.SpiderWebContainerGraph), {
                viewBoxHeight: viewBoxHeight,
                useViewportDimensions: useViewportDimensions,
                aspectCorrection: aspectCorrection,
                resolvedConnectors: resolvedConnectors,
                nodes: nodes,
                animated: animated,
                continuousAnimationsEnabled: !prefersReducedMotion,
                continuousAnimationStartDelaySec: phaseClockStartOffsetSec,
                skipLoadEntrance: skipLoadEntrance,
                connectorColor: connectorColor,
                connectorWidth: connectorWidth,
                connectorEntranceDelay: connectorEntranceDelay,
                nodeEntranceDelay: nodeEntranceDelay,
                overlapEntranceDelay: overlapEntranceDelay,
                nodeLoadEntranceDurationSec: loadEntranceTimings.nodeEntranceDurationSec,
                connectorLoadEntranceSolidDrawDurationSec: loadEntranceTimings.connectorSolidDrawDurationSec,
                connectorLoadEntranceDashedFadeDurationSec: loadEntranceTimings.connectorDashedFadeDurationSec,
                connectorLoadEntranceAnimatedShapeOpacityDurationSec: loadEntranceTimings.animatedShapeOpacityDurationSec,
                connectorLoadEntranceAnimatedShapeAppearOffsetSec: loadEntranceTimings.animatedShapeAppearOffsetSec,
                overlapLoadEntranceFadeDurationSec: loadEntranceTimings.overlapFadeDurationSec,
                fontFamily: fontFamily,
                expandingNodeId: expandingNodeId,
                onNodeActivate: handleNodeActivate,
                allowNodeActivationWithoutModal: onNodeClick !== undefined,
                nodePositions: nodePositions,
                onSvgCanvasClick: onSvgCanvasClick,
                focusedConnector: focusedConnector,
                nodeFocus: nodeFocus
            }),
            showAnimationPauseControl ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _u7cogktf _1bsb1osq",
                    "pause-controls"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                        isPlaying: !animationsPaused,
                        onToggle: ()=>setAnimationsPaused((p)=>!p)
                    })
                })
            }) : null,
            activeModal && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iZj3A.AnimatedModal), {
                content: activeModal,
                onClose: ()=>{
                    setActiveModal(null);
                    setExpandingNodeId(null);
                }
            })
        ]
    });
}; /* eslint-enable complexity */ 

});
parcelRegister("iZj3A", function(module, exports) {
$parcel$export(module.exports, "AnimatedModal", function () { return $aeefb446612be563$export$e22fc00ba90d846a; });
/* animated-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $aeefb446612be563$var$animationDuration = '1.5s';
const $aeefb446612be563$var$contentRevealingKeyframes = null;
const $aeefb446612be563$var$expandingWhiteBackgroundKeyframes = null;
const $aeefb446612be563$var$dialogShiftingDownwardKeyframes = null;
const $aeefb446612be563$var$modalTopBarKeyframes = null;
const $aeefb446612be563$var$modalBackgroundStyle = null;
const $aeefb446612be563$var$modalBackgroundOverlayStyle = null;
const $aeefb446612be563$var$modalDialogStyle = null;
const $aeefb446612be563$var$modalTopBarStyle = null;
const $aeefb446612be563$var$expandingWhiteBackgroundStyle = null;
const $aeefb446612be563$var$contentRevealingStyle = null;
const $aeefb446612be563$var$headingStyle = null;
const $aeefb446612be563$var$closeButtonStyle = null;
const $aeefb446612be563$var$modalBackgroundOverlayButtonStyle = null;
const $aeefb446612be563$export$e22fc00ba90d846a = ({ content: content, onClose: onClose })=>{
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const [isClosing, setIsClosing] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        requestAnimationFrame(()=>setIsOpen(true));
    }, []);
    const handleClose = (0, $1oC0p.useCallback)(()=>{
        setIsClosing(true);
        setTimeout(()=>onClose?.(), 250);
    }, [
        onClose
    ]);
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === 'Escape') handleClose();
    }, [
        handleClose
    ]);
    (0, $1oC0p.useEffect)(()=>{
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, [
        handleKeyDown
    ]);
    const entered = isOpen && !isClosing;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "aria-hidden": !entered,
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1r04idpf _1pbyzo7u"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_4t3i1kxc _1bsbauwl _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1bah1h6o _4cvr1h6o _1reo1wug _18m91wug"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    "aria-label": "Close modal",
                    onClick: handleClose,
                    style: {
                        // eslint-disable-next-line -- scrim overlay; no scrim token for rgba
                        backgroundColor: entered ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0)'
                    },
                    className: (0, $2jatx.default)([
                        "_r06hglyw _kqswstnw _1r04idpf _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _v564pw66"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": content.heading ?? 'Modal',
                    "aria-labelledby": "anim-modal-heading",
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _18s8mvv2 _1pbykb7n _1yt4xy5q _p12fbxu3 _1bsb1vuk _1o51q7pw _j7hqp1kv _5sag12o8 _1pgll5pe"
                    ]),
                    style: {
                        "--_akkdnv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.quick-entrance'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pby1mrw _kqswstnw _1r04idpf _2rko1ylz _19pkidpf _2hwx1wug _otyridpf _18u01wug _j7hq1bcn _5sag12o8 _1pgll5pe _bfhk1afi _16qs1bct"
                            ]),
                            style: {
                                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                                "--_akkdnv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.quick-entrance')),
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4ivgg _1bsb1osq _1o51q7pw _j7hqq3qj _5sag12o8 _1pgll5pe"
                            ]),
                            style: {
                                "--_akkdnv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.quick-entrance'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    type: "button",
                                    onClick: handleClose,
                                    "aria-label": "Close modal",
                                    className: (0, $2jatx.default)([
                                        "_kqswstnw _152tidpf _rjxpidpf _11q7glyw _19itglyw _1wybv47k _80omtlke _syaz1qc2 _vwz4kb7n _1yt41b66"
                                    ]),
                                    style: {
                                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                    },
                                    children: "\xd7"
                                }),
                                content.heading && /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                                    id: "anim-modal-heading",
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulp7vkz _18s812pl _1wybgktf _k48pni7l"
                                    ]),
                                    children: [
                                        content.icon && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Image), {
                                            src: content.icon,
                                            alt: content.heading ?? '',
                                            width: 24,
                                            height: 24
                                        }),
                                        content.heading
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_mkrz1k1d _j7hq11k6 _5sag12o8 _1pgll5pe"
                            ]),
                            style: {
                                "--_akkdnv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.quick-entrance'))
                            },
                            children: [
                                content.text && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: content.text
                                }),
                                content.image && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Image), {
                                    src: content.image,
                                    alt: content.heading ?? ''
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("idRu8", function(module, exports) {
$parcel$export(module.exports, "SpiderWebContainerGraph", function () { return $3236218b2d24e80d$export$1a6bb9c248933ce1; });

var $7VQPk = parcelRequire("7VQPk");

var $8LkZ1 = parcelRequire("8LkZ1");

var $g14gy = parcelRequire("g14gy");

var $dhl4q = parcelRequire("dhl4q");

var $hNner = parcelRequire("hNner");
function $3236218b2d24e80d$var$toCenterPct(layout) {
    if (!layout) return undefined;
    return {
        x: layout.x,
        y: layout.y
    };
}
const $3236218b2d24e80d$export$1a6bb9c248933ce1 = ({ viewBoxHeight: viewBoxHeight, useViewportDimensions: useViewportDimensions = false, aspectCorrection: aspectCorrection, resolvedConnectors: resolvedConnectors, nodes: nodes, animated: animated, continuousAnimationsEnabled: continuousAnimationsEnabled, continuousAnimationStartDelaySec: continuousAnimationStartDelaySec, skipLoadEntrance: skipLoadEntrance, connectorColor: connectorColor, connectorWidth: connectorWidth, connectorEntranceDelay: connectorEntranceDelay, nodeEntranceDelay: nodeEntranceDelay, overlapEntranceDelay: overlapEntranceDelay, nodeLoadEntranceDurationSec: nodeLoadEntranceDurationSec, connectorLoadEntranceSolidDrawDurationSec: connectorLoadEntranceSolidDrawDurationSec, connectorLoadEntranceDashedFadeDurationSec: connectorLoadEntranceDashedFadeDurationSec, connectorLoadEntranceAnimatedShapeOpacityDurationSec: connectorLoadEntranceAnimatedShapeOpacityDurationSec, connectorLoadEntranceAnimatedShapeAppearOffsetSec: connectorLoadEntranceAnimatedShapeAppearOffsetSec, overlapLoadEntranceFadeDurationSec: overlapLoadEntranceFadeDurationSec, fontFamily: fontFamily, expandingNodeId: expandingNodeId, onNodeActivate: onNodeActivate, allowNodeActivationWithoutModal: allowNodeActivationWithoutModal, nodePositions: nodePositions, onSvgCanvasClick: onSvgCanvasClick, focusedConnector: focusedConnector, nodeFocus: nodeFocus })=>{
    const shimmerConnectors = resolvedConnectors.filter((connector)=>connector.animationEffect === 'shimmer');
    const shimmerIndexByConnectorIndex = new Map(shimmerConnectors.map((connector, index)=>[
            connector.index,
            index
        ]));
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: `0 0 ${(0, $hNner.VIEWBOX_SCALE)} ${viewBoxHeight}`,
        preserveAspectRatio: useViewportDimensions ? 'none' : 'xMidYMid meet',
        style: {
            width: '100%',
            height: '100%',
            display: 'block'
        },
        children: [
            onSvgCanvasClick ? /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: 0,
                y: 0,
                width: (0, $hNner.VIEWBOX_SCALE),
                height: viewBoxHeight,
                fill: "transparent",
                pointerEvents: "all",
                style: {
                    cursor: 'inherit'
                },
                onClick: (e)=>{
                    const svg = e.currentTarget.ownerSVGElement;
                    if (!svg) return;
                    onSvgCanvasClick((0, $hNner.clientPointToSpiderWebPercent)(svg, e.clientX, e.clientY, viewBoxHeight));
                }
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                children: resolvedConnectors.map((connector, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LkZ1.WebConnector), {
                        connector: connector,
                        animated: animated,
                        continuousAnimationsEnabled: continuousAnimationsEnabled,
                        continuousAnimationStartDelaySec: continuousAnimationStartDelaySec,
                        shimmerIndex: shimmerIndexByConnectorIndex.get(connector.index),
                        shimmerCount: shimmerConnectors.length,
                        delay: connectorEntranceDelay(i),
                        loadEntranceSolidDrawDurationSec: connectorLoadEntranceSolidDrawDurationSec,
                        loadEntranceDashedFadeDurationSec: connectorLoadEntranceDashedFadeDurationSec,
                        loadEntranceAnimatedShapeOpacityDurationSec: connectorLoadEntranceAnimatedShapeOpacityDurationSec,
                        loadEntranceAnimatedShapeAppearOffsetSec: connectorLoadEntranceAnimatedShapeAppearOffsetSec,
                        skipLoadEntrance: skipLoadEntrance,
                        color: connector.color ?? connectorColor,
                        strokeWidth: connectorWidth,
                        isAnimated: connector.isAnimated,
                        animationColor: connector.animationColor,
                        viewBoxHeight: viewBoxHeight,
                        fromPct: $3236218b2d24e80d$var$toCenterPct(nodePositions.get(connector.from.id)),
                        toPct: $3236218b2d24e80d$var$toCenterPct(nodePositions.get(connector.to.id)),
                        isFocused: focusedConnector !== undefined && focusedConnector.from === connector.from.id && focusedConnector.to === connector.to.id,
                        aspectCorrection: aspectCorrection
                    }, `${connector.from.id}-${connector.to.id}`))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: nodes.map((node, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $g14gy.WebNode), {
                        node: node,
                        animated: animated,
                        delay: nodeEntranceDelay(i),
                        loadEntranceDurationSec: nodeLoadEntranceDurationSec,
                        skipLoadEntrance: skipLoadEntrance,
                        onClick: allowNodeActivationWithoutModal || node.modalContent ? ()=>onNodeActivate(node) : undefined,
                        fontFamily: fontFamily,
                        isExpanding: expandingNodeId === node.id,
                        viewBoxHeight: viewBoxHeight,
                        aspectCorrection: aspectCorrection,
                        layoutPct: nodePositions.get(node.id),
                        focusVariant: nodeFocus?.nodeId === node.id ? nodeFocus.variant : undefined
                    }, node.id))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dhl4q.WebOverlapLayers), {
                nodes: nodes,
                viewBoxHeight: viewBoxHeight,
                animated: animated,
                delay: overlapEntranceDelay,
                loadEntranceFadeDurationSec: overlapLoadEntranceFadeDurationSec,
                skipLoadEntrance: skipLoadEntrance,
                nodePositions: nodePositions
            })
        ]
    });
};

});
parcelRegister("8LkZ1", function(module, exports) {
$parcel$export(module.exports, "WebConnector", function () { return $0a666eee294a6ae9$export$4c805283e52a8c6; });
/* spiderweb-connector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");

var $bfqoy = parcelRequire("bfqoy");

var $hNner = parcelRequire("hNner");
const $0a666eee294a6ae9$var$focusColor = 'hotpink';
const $0a666eee294a6ae9$var$focusDasharray = '10 10';
const $0a666eee294a6ae9$var$activeSelectionKeyframes = null;
const $0a666eee294a6ae9$var$activeConnectorCss = null;
const $0a666eee294a6ae9$var$FIXED_DASH_PATTERNS = {
    dashed: '8 6',
    dotted: '0 4'
};
const $0a666eee294a6ae9$var$DEFAULT_SOLID_DRAW_SEC = 1;
const $0a666eee294a6ae9$var$DEFAULT_DASHED_FADE_SEC = 0.8;
const $0a666eee294a6ae9$var$DEFAULT_ANIMATED_SHAPE_OPACITY_SEC = 0.6;
const $0a666eee294a6ae9$var$DEFAULT_ANIMATED_SHAPE_APPEAR_OFFSET_SEC = 1;
const $0a666eee294a6ae9$export$2327170491d03b31 = ({ connectorShape: connectorShape, fromId: fromId, toId: toId, animated: animated, delay: delay, skipLoadEntrance: skipLoadEntrance = false, animationColor: animationColor, length: length, animatedShapeOpacityDurationSec: animatedShapeOpacityDurationSec, animatedShapeAppearOffsetSec: animatedShapeAppearOffsetSec, aspectCorrection: aspectCorrection })=>{
    const appearDelay = delay + animatedShapeAppearOffsetSec;
    const style = animated ? skipLoadEntrance ? {
        opacity: 1
    } : {
        opacity: 1,
        transition: `opacity ${animatedShapeOpacityDurationSec}s ease ${appearDelay}s`
    } : {
        opacity: 0
    };
    const acX = aspectCorrection?.scaleX ?? 1;
    const acY = aspectCorrection?.scaleY ?? 1;
    const shapeTransform = acX !== 1 || acY !== 1 ? `scaleX(${acX}) scaleY(${acY})` : undefined;
    const duration = 10;
    const squarePath = 'm-5-9h10c2.2 0 4 1.8 4 4v10c0 2.2-1.8 4-4 4h-10c-2.2 0-4-1.8-4-4v-10c0-2.2 1.8-4 4-4z';
    const circlePath = 'm0 9c-5 0-9-4-9-9 0-5 4-9 9-9 5 0 9 4 9 9 0 5-4 9-9 9z';
    const pillPath = 'm-19-9h38c5 0 9 4 9 9 0 5-4 9-9 9h-38c-5 0-9-4-9-9 0-5 4-9 9-9z';
    const trianglePath = 'm-5-8l15 8-15 8z';
    const hexagonPath = 'm7.8-4.6v9.2l-8 4.6-8-4.6v-9.2l8-4.6z';
    const colorMap = {
        lime: [
            (0, $kbpa7.wacToken)('color.extended.lime500'),
            (0, $kbpa7.wacToken)('color.extended.lime100'),
            (0, $kbpa7.wacToken)('color.extended.lime300'),
            (0, $kbpa7.wacToken)('color.extended.lime500'),
            (0, $kbpa7.wacToken)('color.extended.lime200'),
            (0, $kbpa7.wacToken)('color.extended.lime400'),
            (0, $kbpa7.wacToken)('color.extended.lime200')
        ],
        purple: [
            (0, $kbpa7.wacToken)('color.extended.purple500'),
            (0, $kbpa7.wacToken)('color.extended.purple100'),
            (0, $kbpa7.wacToken)('color.extended.purple300'),
            (0, $kbpa7.wacToken)('color.extended.purple500'),
            (0, $kbpa7.wacToken)('color.extended.purple200'),
            (0, $kbpa7.wacToken)('color.extended.purple400'),
            (0, $kbpa7.wacToken)('color.extended.purple200')
        ],
        blue: [
            (0, $kbpa7.wacToken)('color.extended.blue500'),
            (0, $kbpa7.wacToken)('color.extended.blue800'),
            (0, $kbpa7.wacToken)('color.extended.blue600'),
            (0, $kbpa7.wacToken)('color.extended.blue300'),
            (0, $kbpa7.wacToken)('color.extended.blue700'),
            (0, $kbpa7.wacToken)('color.extended.blue400'),
            (0, $kbpa7.wacToken)('color.extended.blue600')
        ],
        yellow: [
            (0, $kbpa7.wacToken)('color.extended.yellow500'),
            (0, $kbpa7.wacToken)('color.extended.yellow100'),
            (0, $kbpa7.wacToken)('color.extended.yellow300'),
            (0, $kbpa7.wacToken)('color.extended.yellow500'),
            (0, $kbpa7.wacToken)('color.extended.yellow200'),
            (0, $kbpa7.wacToken)('color.extended.yellow400'),
            (0, $kbpa7.wacToken)('color.extended.yellow200')
        ],
        neutral: [
            (0, $kbpa7.wacToken)('color.neutral.light500'),
            (0, $kbpa7.wacToken)('color.neutral.light300'),
            (0, $kbpa7.wacToken)('color.neutral.light100'),
            (0, $kbpa7.wacToken)('color.neutral.light400'),
            (0, $kbpa7.wacToken)('color.neutral.light600'),
            (0, $kbpa7.wacToken)('color.neutral.light200'),
            (0, $kbpa7.wacToken)('color.neutral.light500')
        ]
    };
    const participatingShapes = [
        {
            shape: 'circle',
            path: circlePath,
            delay: 0,
            fill: colorMap[animationColor][0]
        },
        {
            shape: connectorShape === 'orthogonal' || shapeTransform !== undefined ? 'hexagon' : 'pill',
            path: connectorShape === 'orthogonal' || shapeTransform !== undefined ? hexagonPath : pillPath,
            delay: 5,
            fill: colorMap[animationColor][1]
        },
        {
            shape: 'triangle',
            path: trianglePath,
            delay: 2,
            fill: colorMap[animationColor][2]
        },
        {
            shape: 'circle',
            path: circlePath,
            delay: 3,
            fill: colorMap[animationColor][3]
        },
        {
            shape: 'triangle',
            path: trianglePath,
            delay: 9,
            fill: colorMap[animationColor][4]
        },
        {
            shape: 'square',
            path: squarePath,
            delay: 1,
            fill: colorMap[animationColor][5]
        },
        {
            shape: 'hexagon',
            path: hexagonPath,
            delay: 8,
            fill: colorMap[animationColor][6]
        }
    ];
    if (length < 400) participatingShapes.splice(-2, 2);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
        style: style,
        children: participatingShapes.map((shape, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                className: `anim-shape-animated`,
                fill: shape.fill,
                d: shape.path,
                style: shape.shape !== 'pill' && shape.shape !== 'triangle' ? {
                    transform: shapeTransform
                } : undefined,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("animateMotion", {
                    rotate: `${shape.shape === 'circle' || shape.shape === 'hexagon' || shape.shape === 'square' ? '0' : 'auto'}`,
                    dur: duration,
                    begin: `-${shape.delay}s;op.end-${shape.delay}s`,
                    repeatCount: "indefinite",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("mpath", {
                        href: `#connector-${fromId}-${toId}`
                    })
                })
            }, `anim-shape-${index}`))
    });
};
const $0a666eee294a6ae9$export$4c805283e52a8c6 = ({ connector: connector, animated: animated, delay: delay, loadEntranceSolidDrawDurationSec: loadEntranceSolidDrawDurationSec = $0a666eee294a6ae9$var$DEFAULT_SOLID_DRAW_SEC, loadEntranceDashedFadeDurationSec: loadEntranceDashedFadeDurationSec = $0a666eee294a6ae9$var$DEFAULT_DASHED_FADE_SEC, loadEntranceAnimatedShapeOpacityDurationSec: loadEntranceAnimatedShapeOpacityDurationSec = $0a666eee294a6ae9$var$DEFAULT_ANIMATED_SHAPE_OPACITY_SEC, loadEntranceAnimatedShapeAppearOffsetSec: loadEntranceAnimatedShapeAppearOffsetSec = $0a666eee294a6ae9$var$DEFAULT_ANIMATED_SHAPE_APPEAR_OFFSET_SEC, skipLoadEntrance: skipLoadEntrance = false, color: color = 'neutral400', strokeWidth: strokeWidth = 2, isAnimated: isAnimated = false, animationColor: animationColor = 'blue', viewBoxHeight: viewBoxHeight, fromPct: fromPct, toPct: toPct, isFocused: isFocused = false, continuousAnimationsEnabled: continuousAnimationsEnabled = true, continuousAnimationStartDelaySec: continuousAnimationStartDelaySec = 0, shimmerIndex: shimmerIndex, shimmerCount: shimmerCount, aspectCorrection: aspectCorrection })=>{
    const strokeColor = (0, $hNner.getFillColor)(color);
    const focusWidth = strokeWidth + 10;
    const pathRef = (0, $1oC0p.useRef)(null);
    const lastMeasuredDRef = (0, $1oC0p.useRef)(null);
    const [pathLength, setPathLength] = (0, $1oC0p.useState)(null);
    const d = (0, $hNner.generatePathD)(connector, viewBoxHeight, fromPct, toPct);
    const estimatedLength = (0, $hNner.estimatePathLength)(connector, viewBoxHeight, fromPct, toPct);
    const length = Math.max(Number(pathLength ?? 0), estimatedLength) * 2;
    const fixedDashArray = $0a666eee294a6ae9$var$FIXED_DASH_PATTERNS[connector.connectorType];
    const usesFixedDashArray = fixedDashArray !== undefined;
    const animationEffect = connector.animationEffect ?? (isAnimated ? 'travelingShapes' : undefined);
    const showTravelingShapes = continuousAnimationsEnabled && animationEffect === 'travelingShapes';
    const showShimmer = continuousAnimationsEnabled && animationEffect === 'shimmer' && shimmerIndex !== undefined && shimmerCount !== undefined;
    const shimmerOverlay = showShimmer ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bfqoy.SpiderWebConnectorShimmer), {
        d: d,
        connectorId: `${connector.from.id}-${connector.to.id}-${connector.index}`,
        strokeWidth: strokeWidth,
        viewBoxHeight: viewBoxHeight ?? (0, $hNner.VIEWBOX_SCALE),
        strokeDasharray: fixedDashArray,
        startDelaySec: continuousAnimationStartDelaySec,
        shimmerIndex: shimmerIndex,
        shimmerCount: shimmerCount
    }) : null;
    (0, $1oC0p.useLayoutEffect)(()=>{
        const path = pathRef.current;
        if (!path || usesFixedDashArray) return;
        lastMeasuredDRef.current = d;
        try {
            const total = path.getTotalLength();
            if (Number.isFinite(total) && total > 0) setPathLength(total);
        } catch  {
        /* JSDOM (and some edge environments) omit or break SVG path length APIs */ }
    }, [
        d,
        usesFixedDashArray
    ]);
    if (usesFixedDashArray) {
        const style = animated ? skipLoadEntrance ? {
            opacity: 1
        } : {
            opacity: 1,
            transition: `opacity ${loadEntranceDashedFadeDurationSec}s ease ${delay}s`
        } : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            id: `connector-group-${connector.from.id}-${connector.to.id}`,
            children: [
                isFocused ? /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    className: "connector-focus-halo",
                    d: d,
                    fill: "none",
                    stroke: $0a666eee294a6ae9$var$focusColor,
                    strokeWidth: focusWidth,
                    strokeLinecap: "butt",
                    strokeDasharray: $0a666eee294a6ae9$var$focusDasharray,
                    vectorEffect: "non-scaling-stroke",
                    style: style
                }) : null,
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: `connector-${connector.from.id}-${connector.to.id}`,
                    d: d,
                    fill: "none",
                    stroke: strokeColor,
                    strokeWidth: strokeWidth,
                    strokeDasharray: fixedDashArray,
                    strokeLinecap: "round",
                    style: style,
                    vectorEffect: "non-scaling-stroke"
                }),
                showTravelingShapes && /*#__PURE__*/ (0, $7VQPk.jsx)($0a666eee294a6ae9$export$2327170491d03b31, {
                    connectorShape: connector.connectorShape,
                    animationColor: animationColor,
                    fromId: connector.from.id,
                    toId: connector.to.id,
                    animated: animated,
                    delay: delay,
                    skipLoadEntrance: skipLoadEntrance,
                    length: length,
                    animatedShapeOpacityDurationSec: loadEntranceAnimatedShapeOpacityDurationSec,
                    animatedShapeAppearOffsetSec: loadEntranceAnimatedShapeAppearOffsetSec,
                    aspectCorrection: aspectCorrection
                }),
                shimmerOverlay
            ]
        });
    }
    const style = animated ? skipLoadEntrance ? {
        opacity: 1,
        strokeDashoffset: 0
    } : {
        opacity: 1,
        strokeDashoffset: 0,
        transition: `opacity 0.01s linear ${delay}s,
stroke-dashoffset ${loadEntranceSolidDrawDurationSec}s ease ${delay}s`
    } : {
        opacity: 0,
        strokeDashoffset: length
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
        id: `connector-group-${connector.from.id}-${connector.to.id}`,
        children: [
            isFocused ? /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                className: (0, $2jatx.default)([
                    "_j7hqw5yb _5sag1bs3 _tip812c5 _1pgl605o",
                    "connector-focus-halo"
                ]),
                d: d,
                fill: "none",
                stroke: $0a666eee294a6ae9$var$focusColor,
                strokeWidth: focusWidth,
                strokeLinecap: "butt",
                strokeDasharray: $0a666eee294a6ae9$var$focusDasharray,
                style: style,
                vectorEffect: "non-scaling-stroke"
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                ref: pathRef,
                id: `connector-${connector.from.id}-${connector.to.id}`,
                d: d,
                fill: "none",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeDasharray: length,
                strokeLinecap: "round",
                style: style,
                vectorEffect: "non-scaling-stroke"
            }),
            showTravelingShapes && /*#__PURE__*/ (0, $7VQPk.jsx)($0a666eee294a6ae9$export$2327170491d03b31, {
                connectorShape: connector.connectorShape,
                animationColor: animationColor,
                fromId: connector.from.id,
                toId: connector.to.id,
                animated: animated,
                delay: delay,
                skipLoadEntrance: skipLoadEntrance,
                length: length,
                animatedShapeOpacityDurationSec: loadEntranceAnimatedShapeOpacityDurationSec,
                animatedShapeAppearOffsetSec: loadEntranceAnimatedShapeAppearOffsetSec,
                aspectCorrection: aspectCorrection
            }),
            shimmerOverlay
        ]
    });
}; /* eslint-enable complexity */ 

});
parcelRegister("bfqoy", function(module, exports) {
$parcel$export(module.exports, "SpiderWebConnectorShimmer", function () { return $03cab9a126863527$export$1fff1b2f2f0425ff; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");

var $hNner = parcelRequire("hNner");
const $03cab9a126863527$var$SHIMMER_CONCURRENCY_RATIO = 0.2;
const $03cab9a126863527$var$SHIMMER_SLOT_DURATION_SEC = 3;
const $03cab9a126863527$var$SHIMMER_TRAVEL_DURATION_SEC = 1;
const $03cab9a126863527$var$SHIMMER_INITIAL_DELAY_SEC = 1;
const $03cab9a126863527$var$SHIMMER_LANE_OFFSET_SEC = 0.35;
const $03cab9a126863527$var$SHIMMER_PATH_LENGTH = 100;
const $03cab9a126863527$var$SHIMMER_PACKET_LENGTH = 18;
function $03cab9a126863527$export$cd1ca86224c222d9(shimmerCount) {
    return Math.max(1, Math.round(Math.max(0, shimmerCount) * $03cab9a126863527$var$SHIMMER_CONCURRENCY_RATIO));
}
function $03cab9a126863527$export$c5a6cc6ccc755c53(shimmerIndex, shimmerCount) {
    const safeCount = Math.max(1, shimmerCount);
    const safeIndex = Math.min(Math.max(0, shimmerIndex), safeCount - 1);
    const simultaneousShimmers = $03cab9a126863527$export$cd1ca86224c222d9(safeCount);
    const slotCount = Math.ceil(safeCount / simultaneousShimmers);
    const slotIndex = Math.floor(safeIndex / simultaneousShimmers);
    const laneIndex = safeIndex % simultaneousShimmers;
    const cycleDurationSec = slotCount * $03cab9a126863527$var$SHIMMER_SLOT_DURATION_SEC;
    return {
        beginSec: $03cab9a126863527$var$SHIMMER_INITIAL_DELAY_SEC + slotIndex * $03cab9a126863527$var$SHIMMER_SLOT_DURATION_SEC + laneIndex * $03cab9a126863527$var$SHIMMER_LANE_OFFSET_SEC,
        cycleDurationSec: cycleDurationSec,
        travelFraction: $03cab9a126863527$var$SHIMMER_TRAVEL_DURATION_SEC / cycleDurationSec
    };
}
function $03cab9a126863527$var$toSvgId(value) {
    return value.replace(/[^a-zA-Z0-9_-]/g, '-');
}
const $03cab9a126863527$export$1fff1b2f2f0425ff = ({ d: d, connectorId: connectorId, strokeWidth: strokeWidth, viewBoxHeight: viewBoxHeight, strokeDasharray: strokeDasharray, startDelaySec: startDelaySec, shimmerIndex: shimmerIndex, shimmerCount: shimmerCount })=>{
    const instanceId = $03cab9a126863527$var$toSvgId((0, $1oC0p.useId)());
    const safeId = `${instanceId}-${$03cab9a126863527$var$toSvgId(connectorId)}`;
    const maskId = `connector-shimmer-mask-${safeId}`;
    const blurId = `connector-shimmer-blur-${safeId}`;
    const timing = $03cab9a126863527$export$c5a6cc6ccc755c53(shimmerIndex, shimmerCount);
    const fadeFraction = Math.min(0.04, timing.travelFraction / 4);
    const visibleEndFraction = Math.max(fadeFraction, timing.travelFraction - fadeFraction);
    const packetStartOffset = $03cab9a126863527$var$SHIMMER_PATH_LENGTH + $03cab9a126863527$var$SHIMMER_PACKET_LENGTH;
    const packetEndOffset = -$03cab9a126863527$var$SHIMMER_PACKET_LENGTH;
    const maskPadding = 100;
    const animationBeginSec = startDelaySec + timing.beginSec;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("filter", {
                        id: blurId,
                        filterUnits: "userSpaceOnUse",
                        x: -maskPadding,
                        y: -maskPadding,
                        width: (0, $hNner.VIEWBOX_SCALE) + maskPadding * 2,
                        height: viewBoxHeight + maskPadding * 2,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("feGaussianBlur", {
                            stdDeviation: "5"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("mask", {
                        id: maskId,
                        maskUnits: "userSpaceOnUse",
                        x: -maskPadding,
                        y: -maskPadding,
                        width: (0, $hNner.VIEWBOX_SCALE) + maskPadding * 2,
                        height: viewBoxHeight + maskPadding * 2,
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("path", {
                            d: d,
                            pathLength: $03cab9a126863527$var$SHIMMER_PATH_LENGTH,
                            fill: "none",
                            stroke: (0, $kbpa7.wacToken)('color.neutral.light0'),
                            strokeWidth: Math.max(strokeWidth * 5, 10),
                            strokeLinecap: "round",
                            strokeDasharray: `${$03cab9a126863527$var$SHIMMER_PACKET_LENGTH} ${$03cab9a126863527$var$SHIMMER_PATH_LENGTH}`,
                            strokeDashoffset: packetStartOffset,
                            opacity: 0,
                            filter: `url(#${blurId})`,
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                                    attributeName: "stroke-dashoffset",
                                    values: `${packetStartOffset};${packetEndOffset};${packetEndOffset}`,
                                    keyTimes: `0;${timing.travelFraction};1`,
                                    dur: `${timing.cycleDurationSec}s`,
                                    begin: `${animationBeginSec}s`,
                                    repeatCount: "indefinite"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                                    attributeName: "opacity",
                                    values: "0;1;1;0;0",
                                    keyTimes: `0;${fadeFraction};${visibleEndFraction};${timing.travelFraction};1`,
                                    dur: `${timing.cycleDurationSec}s`,
                                    begin: `${animationBeginSec}s`,
                                    repeatCount: "indefinite"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                className: "connector-shimmer-overlay",
                d: d,
                fill: "none",
                stroke: (0, $kbpa7.wacToken)('color.neutral.light0'),
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                strokeLinecap: "round",
                mask: `url(#${maskId})`,
                vectorEffect: "non-scaling-stroke",
                pointerEvents: "none"
            })
        ]
    });
};

});
parcelRegister("hNner", function(module, exports) {
$parcel$export(module.exports, "VIEWBOX_SCALE", function () { return $d748960a540715c7$export$64bc08fea759b9f0; });
$parcel$export(module.exports, "getFillColor", function () { return $d748960a540715c7$export$c78c40f1f2c127ae; });
$parcel$export(module.exports, "pctToViewBox", function () { return $d748960a540715c7$export$3899a5677ef1fc8d; });
$parcel$export(module.exports, "pctToViewBoxY", function () { return $d748960a540715c7$export$78e6a7e9bbdd8e96; });
$parcel$export(module.exports, "clientPointToSpiderWebPercent", function () { return $d748960a540715c7$export$7853a2ad444a524a; });
$parcel$export(module.exports, "autoConnectNodes", function () { return $d748960a540715c7$export$33c89f7587b9100f; });
$parcel$export(module.exports, "resolveConnectors", function () { return $d748960a540715c7$export$c8a0ea4291e0d0f3; });
$parcel$export(module.exports, "generatePathD", function () { return $d748960a540715c7$export$b22c80dd8dfa9662; });
$parcel$export(module.exports, "getHexagonPoints", function () { return $d748960a540715c7$export$dc05ac4d5f7de039; });
$parcel$export(module.exports, "getTrianglePoints", function () { return $d748960a540715c7$export$d95c9ca32019fe2f; });
$parcel$export(module.exports, "estimatePathLength", function () { return $d748960a540715c7$export$8adba9b7b71a99aa; });
$parcel$export(module.exports, "LEADING_ICON_INSIDE_GAP_RATIO", function () { return $d748960a540715c7$export$d59c3929577b30f7; });
$parcel$export(module.exports, "LEADING_INSIDE_EXTRA_WIDTH_RATIO", function () { return $d748960a540715c7$export$7a959807e0cf14c4; });
$parcel$export(module.exports, "LEADING_ICON_OUTSIDE_GAP_RATIO", function () { return $d748960a540715c7$export$fb4aa8c61dd87a93; });
$parcel$export(module.exports, "leadingInsideIconSidePx", function () { return $d748960a540715c7$export$41a49f5d92e754fc; });
$parcel$export(module.exports, "effectiveLeadingImagePlacement", function () { return $d748960a540715c7$export$a81692d9beb437d2; });
$parcel$export(module.exports, "getRectangleBorderRadius", function () { return $d748960a540715c7$export$8d8431c26588b0d5; });
$parcel$export(module.exports, "getNodeLayoutDimensions", function () { return $d748960a540715c7$export$35acfb30685caca9; });
$parcel$export(module.exports, "getNodeOverlapLayout", function () { return $d748960a540715c7$export$a46bd226a7cc59a4; });

var $kbpa7 = parcelRequire("kbpa7");
const $d748960a540715c7$export$64bc08fea759b9f0 = 1000;
function $d748960a540715c7$export$c78c40f1f2c127ae(color) {
    if (color === 'transparent') return 'transparent';
    if (color === 'white') return (0, $kbpa7.wacToken)('color.neutral.light0');
    if (color === 'black') return (0, $kbpa7.wacToken)('color.primary.black');
    if (color.includes('secondary')) return (0, $kbpa7.wacToken)(`color.secondary.${color.replace('secondary', '')}`);
    const colorType = color.includes('neutral') ? 'neutral' : 'extended';
    const colorValue = color.includes('neutral') ? color.replace('neutral', 'light') : color;
    return (0, $kbpa7.wacToken)(`color.${colorType}.${colorValue}`);
}
function $d748960a540715c7$export$3899a5677ef1fc8d(pct) {
    return pct / 100 * $d748960a540715c7$export$64bc08fea759b9f0;
}
function $d748960a540715c7$export$78e6a7e9bbdd8e96(pct, viewBoxHeight) {
    return pct / 100 * viewBoxHeight;
}
function $d748960a540715c7$export$7853a2ad444a524a(svg, clientX, clientY, viewBoxHeight) {
    if (viewBoxHeight <= 0) return {
        x: 0,
        y: 0
    };
    const pt = svg.createSVGPoint();
    pt.x = clientX;
    pt.y = clientY;
    const ctm = svg.getScreenCTM();
    if (!ctm) return {
        x: 0,
        y: 0
    };
    const p = pt.matrixTransform(ctm.inverse());
    const x = p.x / $d748960a540715c7$export$64bc08fea759b9f0 * 100;
    const y = p.y / viewBoxHeight * 100;
    return {
        x: Math.round(x * 10) / 10,
        y: Math.round(y * 10) / 10
    };
}
function $d748960a540715c7$var$euclidean(a, b) {
    const dx = a.x - b.x;
    const dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
}
function $d748960a540715c7$var$connectorKey(a, b) {
    return a < b ? `${a}::${b}` : `${b}::${a}`;
}
function $d748960a540715c7$export$33c89f7587b9100f(nodes, maxNeighbors, explicitConnectors) {
    const seen = new Set();
    const connectionCount = new Map();
    const result = [];
    if (explicitConnectors) for (const connector of explicitConnectors){
        const key = $d748960a540715c7$var$connectorKey(connector.from, connector.to);
        if (!seen.has(key)) {
            seen.add(key);
            result.push(connector);
            connectionCount.set(connector.from, (connectionCount.get(connector.from) ?? 0) + 1);
            connectionCount.set(connector.to, (connectionCount.get(connector.to) ?? 0) + 1);
        }
    }
    for (const node of nodes){
        const currentCount = connectionCount.get(node.id) ?? 0;
        if (currentCount >= maxNeighbors) continue;
        const others = nodes.filter((n)=>n.id !== node.id).map((n)=>({
                node: n,
                dist: $d748960a540715c7$var$euclidean(node, n)
            })).sort((a, b)=>a.dist - b.dist);
        for (const { node: neighbor } of others){
            if ((connectionCount.get(node.id) ?? 0) >= maxNeighbors) break;
            const key = $d748960a540715c7$var$connectorKey(node.id, neighbor.id);
            if (seen.has(key)) continue;
            seen.add(key);
            result.push({
                from: node.id,
                to: neighbor.id
            });
            connectionCount.set(node.id, (connectionCount.get(node.id) ?? 0) + 1);
            connectionCount.set(neighbor.id, (connectionCount.get(neighbor.id) ?? 0) + 1);
        }
    }
    return result;
}
const $d748960a540715c7$var$SHAPE_CYCLE = [
    'arced',
    'straight',
    'curvy',
    'orthogonal'
];
function $d748960a540715c7$export$c8a0ea4291e0d0f3(connectorConfigs, nodes, globalConnectorShape, globalConnectorType) {
    const nodeMap = new Map(nodes.map((n)=>[
            n.id,
            n
        ]));
    return connectorConfigs.map((cfg, index)=>{
        const from = nodeMap.get(cfg.from);
        const to = nodeMap.get(cfg.to);
        if (!from || !to) return null;
        let shape = cfg.connectorShape ?? globalConnectorShape;
        if (shape === 'mixed') shape = $d748960a540715c7$var$SHAPE_CYCLE[index % $d748960a540715c7$var$SHAPE_CYCLE.length] ?? 'arced';
        const type = cfg.connectorType ?? globalConnectorType;
        return {
            from: from,
            to: to,
            connectorShape: shape,
            connectorType: type,
            index: index,
            connectorBias: cfg.connectorBias,
            isAnimated: cfg.isAnimated,
            animationEffect: cfg.animationEffect,
            color: cfg.color,
            animationColor: cfg.animationColor
        };
    }).filter((e)=>e !== null);
}
function $d748960a540715c7$var$resolveBendSign(connector) {
    if (connector.connectorBias === 'positive') return 1;
    if (connector.connectorBias === 'negative') return -1;
    return connector.index % 2 === 0 ? 1 : -1;
}
/* true = move horizontally first, false = vertical first */ function $d748960a540715c7$var$resolveOrthogonalHorizontalFirst(connector) {
    if (connector.connectorBias === 'positive') return true;
    if (connector.connectorBias === 'negative') return false;
    return connector.index % 2 === 0;
}
function $d748960a540715c7$export$b22c80dd8dfa9662(connector, viewBoxHeight = $d748960a540715c7$export$64bc08fea759b9f0, fromPct, toPct) {
    const fx = fromPct?.x ?? connector.from.x;
    const fy = fromPct?.y ?? connector.from.y;
    const tx = toPct?.x ?? connector.to.x;
    const ty = toPct?.y ?? connector.to.y;
    const x1 = $d748960a540715c7$export$3899a5677ef1fc8d(fx);
    const y1 = $d748960a540715c7$export$78e6a7e9bbdd8e96(fy, viewBoxHeight);
    const x2 = $d748960a540715c7$export$3899a5677ef1fc8d(tx);
    const y2 = $d748960a540715c7$export$78e6a7e9bbdd8e96(ty, viewBoxHeight);
    if (connector.connectorShape === 'straight') return `M ${x1} ${y1} L ${x2} ${y2}`;
    if (connector.connectorShape === 'orthogonal') {
        if ($d748960a540715c7$var$resolveOrthogonalHorizontalFirst(connector)) return `M ${x1} ${y1} L ${x2} ${y1} L ${x2} ${y2}`;
        return `M ${x1} ${y1} L ${x1} ${y2} L ${x2} ${y2}`;
    }
    const dx = x2 - x1;
    const dy = y2 - y1;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist === 0) return `M ${x1} ${y1} L ${x2} ${y2}`;
    const nx = -dy / dist;
    const ny = dx / dist;
    if (connector.connectorShape === 'arced') {
        const mx = (x1 + x2) / 2;
        const my = (y1 + y2) / 2;
        const offset = dist * 0.25;
        const direction = $d748960a540715c7$var$resolveBendSign(connector);
        const qx = mx + nx * offset * direction;
        const qy = my + ny * offset * direction;
        return `M ${x1} ${y1} Q ${qx} ${qy} ${x2} ${y2}`;
    }
    if (connector.connectorShape === 'curvy') {
        const offset = dist * 0.35;
        const direction = $d748960a540715c7$var$resolveBendSign(connector);
        const cx1 = x1 + dx * 0.33 + nx * offset * direction;
        const cy1 = y1 + dy * 0.33 + ny * offset * direction;
        const cx2 = x1 + dx * 0.66 - nx * offset * direction;
        const cy2 = y1 + dy * 0.66 - ny * offset * direction;
        return `M ${x1} ${y1} C ${cx1} ${cy1} ${cx2} ${cy2} ${x2} ${y2}`;
    }
    return `M ${x1} ${y1} L ${x2} ${y2}`;
}
function $d748960a540715c7$export$dc05ac4d5f7de039(cx, cy, r) {
    const points = [];
    for(let i = 0; i < 6; i++){
        const angle = Math.PI / 3 * i - Math.PI / 2;
        points.push(`${cx + r * Math.cos(angle)},${cy + r * Math.sin(angle)}`);
    }
    return points.join(' ');
}
function $d748960a540715c7$export$d95c9ca32019fe2f(cx, cy, r) {
    const top = `${cx},${cy - r}`;
    const bottomLeft = `${cx - r * 0.866},${cy + r * 0.5}`;
    const bottomRight = `${cx + r * 0.866},${cy + r * 0.5}`;
    return `${top} ${bottomLeft} ${bottomRight}`;
}
function $d748960a540715c7$export$8adba9b7b71a99aa(connector, viewBoxHeight = $d748960a540715c7$export$64bc08fea759b9f0, fromPct, toPct) {
    const fx = fromPct?.x ?? connector.from.x;
    const fy = fromPct?.y ?? connector.from.y;
    const tx = toPct?.x ?? connector.to.x;
    const ty = toPct?.y ?? connector.to.y;
    const x1 = $d748960a540715c7$export$3899a5677ef1fc8d(fx);
    const y1 = $d748960a540715c7$export$78e6a7e9bbdd8e96(fy, viewBoxHeight);
    const x2 = $d748960a540715c7$export$3899a5677ef1fc8d(tx);
    const y2 = $d748960a540715c7$export$78e6a7e9bbdd8e96(ty, viewBoxHeight);
    const dx = x2 - x1;
    const dy = y2 - y1;
    const straightDist = Math.sqrt(dx * dx + dy * dy);
    if (connector.connectorShape === 'arced') return straightDist * 1.2;
    if (connector.connectorShape === 'curvy') return straightDist * 1.5;
    if (connector.connectorShape === 'orthogonal') return Math.abs(dx) + Math.abs(dy);
    return straightDist;
}
const $d748960a540715c7$var$DEFAULT_NODE_SIZE = 100;
const $d748960a540715c7$var$PILL_ASPECT = 2.8;
const $d748960a540715c7$var$PILL_HORIZONTAL_PADDING = 0.8;
const $d748960a540715c7$var$RECTANGLE_HORIZONTAL_PADDING = 0.8;
const $d748960a540715c7$var$MONOSPACE_CHAR_WIDTH_RATIO = 0.6;
const $d748960a540715c7$export$d59c3929577b30f7 = 0.3;
const $d748960a540715c7$export$7a959807e0cf14c4 = 0.0005;
const $d748960a540715c7$export$fb4aa8c61dd87a93 = 0.14;
const $d748960a540715c7$export$ad3ca81369e18f68 = 1.15;
function $d748960a540715c7$export$41a49f5d92e754fc(node, maxBodySide) {
    const size = node.size ?? $d748960a540715c7$var$DEFAULT_NODE_SIZE;
    const fontFamily = node.fontFamily ?? 'monospace';
    const labelLayoutFontSize = fontFamily === 'monospace' ? size * 0.3 : size * 0.4;
    const desired = labelLayoutFontSize * $d748960a540715c7$export$ad3ca81369e18f68;
    return Math.min(Math.max(4, desired), maxBodySide);
}
function $d748960a540715c7$export$a81692d9beb437d2(node) {
    const raw = node.imagePlacement ?? 'background';
    if (raw === 'background' || !node.bgImage || !node.text || node.shape !== 'pill' && node.shape !== 'rectangle') return 'background';
    return raw;
}
const $d748960a540715c7$var$RECTANGLE_RX_DEFAULT_DIVISOR = 4;
function $d748960a540715c7$export$8d8431c26588b0d5(node, rectangleWidth, rectangleHeight) {
    if (node.shape !== 'rectangle') return 0;
    const minSide = Math.min(rectangleWidth, rectangleHeight);
    if (minSide <= 0) return 0;
    const maxRx = minSide / 2;
    const defaultRx = minSide / $d748960a540715c7$var$RECTANGLE_RX_DEFAULT_DIVISOR;
    const raw = node.borderRadius ?? defaultRx;
    return Math.min(Math.max(0, raw), maxRx);
}
/* eslint-disable-next-line complexity -- mirrors WebNode pill/rectangle leading layout */ function $d748960a540715c7$var$computeNodeBoxWidths(node) {
    const size = node.size ?? $d748960a540715c7$var$DEFAULT_NODE_SIZE;
    const fontFamily = node.fontFamily ?? 'monospace';
    const labelLayoutFontSize = fontFamily === 'monospace' ? size * 0.3 : size * 0.4;
    const placement = $d748960a540715c7$export$a81692d9beb437d2(node);
    const textStretchW = node.text && (node.shape === 'pill' || node.shape === 'rectangle') ? node.text.length * labelLayoutFontSize * $d748960a540715c7$var$MONOSPACE_CHAR_WIDTH_RATIO : 0;
    const pillBodyTextWidth = node.shape === 'pill' && node.text ? textStretchW + size * $d748960a540715c7$var$PILL_HORIZONTAL_PADDING : size * $d748960a540715c7$var$PILL_ASPECT;
    let pillWidth = pillBodyTextWidth;
    if (node.shape === 'pill' && node.text && node.bgImage && placement === 'insideLeading') {
        const iconSide = $d748960a540715c7$export$41a49f5d92e754fc(node, size);
        pillWidth = pillBodyTextWidth + iconSide + size * $d748960a540715c7$export$d59c3929577b30f7 + size * $d748960a540715c7$export$7a959807e0cf14c4;
    }
    const rectangleHeight = node.height ?? size;
    const rectangleBodyTextWidth = node.shape === 'rectangle' && node.text ? textStretchW + size * $d748960a540715c7$var$RECTANGLE_HORIZONTAL_PADDING : size;
    let rectangleWidth = node.width ?? (node.shape === 'rectangle' && node.text ? rectangleBodyTextWidth : size);
    if (node.width === undefined && node.shape === 'rectangle' && node.text && node.bgImage && placement === 'insideLeading') {
        const iconSide = $d748960a540715c7$export$41a49f5d92e754fc(node, rectangleHeight);
        rectangleWidth = rectangleBodyTextWidth + iconSide + rectangleHeight * $d748960a540715c7$export$d59c3929577b30f7 + Math.max(size, rectangleHeight) * $d748960a540715c7$export$7a959807e0cf14c4;
    }
    return {
        size: size,
        pillWidth: pillWidth,
        rectangleWidth: rectangleWidth,
        rectangleHeight: rectangleHeight
    };
}
function $d748960a540715c7$export$35acfb30685caca9(node) {
    const { size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight } = $d748960a540715c7$var$computeNodeBoxWidths(node);
    switch(node.shape){
        case 'pill':
            return {
                size: size,
                boxWidth: pillWidth,
                boxHeight: size
            };
        case 'rectangle':
            return {
                size: size,
                boxWidth: rectangleWidth,
                boxHeight: rectangleHeight
            };
        default:
            return {
                size: size,
                boxWidth: size,
                boxHeight: size
            };
    }
}
function $d748960a540715c7$export$a46bd226a7cc59a4(node, viewBoxHeight, centerPct) {
    const size = centerPct?.size !== undefined ? centerPct.size : node.size ?? $d748960a540715c7$var$DEFAULT_NODE_SIZE;
    const nodeForDims = {
        ...node,
        size: size
    };
    const dims = $d748960a540715c7$export$35acfb30685caca9(nodeForDims);
    const boxW = centerPct?.width !== undefined ? centerPct.width : dims.boxWidth;
    const boxH = centerPct?.height !== undefined ? centerPct.height : dims.boxHeight;
    const r = size / 2;
    const pillWidth = node.shape === 'pill' ? boxW : size * $d748960a540715c7$var$PILL_ASPECT;
    const rectangleWidth = node.shape === 'rectangle' ? boxW : dims.boxWidth;
    const rectangleHeight = node.shape === 'rectangle' ? boxH : dims.boxHeight;
    const px = centerPct?.x ?? node.x;
    const py = centerPct?.y ?? node.y;
    const rectangleBorderRadius = node.shape === 'rectangle' ? $d748960a540715c7$export$8d8431c26588b0d5(node, rectangleWidth, rectangleHeight) : undefined;
    return {
        cx: $d748960a540715c7$export$3899a5677ef1fc8d(px),
        cy: $d748960a540715c7$export$78e6a7e9bbdd8e96(py, viewBoxHeight),
        r: r,
        size: size,
        pillWidth: pillWidth,
        rectangleWidth: rectangleWidth,
        rectangleHeight: rectangleHeight,
        rectangleBorderRadius: rectangleBorderRadius,
        rotate: node.rotate ?? 0,
        shape: node.shape
    };
}

});



parcelRegister("g14gy", function(module, exports) {
$parcel$export(module.exports, "WebNode", function () { return $601e0abd0af527cc$export$7bcfb4ff058df62d; });
/* spiderweb-node.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");

var $75Q24 = parcelRequire("75Q24");

var $hNner = parcelRequire("hNner");
const $601e0abd0af527cc$var$activeSelectionKeyframes = null;
const $601e0abd0af527cc$var$groupStyle = null;
const $601e0abd0af527cc$var$DEFAULT_SIZE = 100;
const $601e0abd0af527cc$var$PILL_ASPECT = 2.8;
const $601e0abd0af527cc$var$PILL_HORIZONTAL_PADDING = 0.8;
const $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING = 0.8;
const $601e0abd0af527cc$var$MONOSPACE_CHAR_WIDTH_RATIO = 0.6;
function $601e0abd0af527cc$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
/* eslint-disable complexity */ const $601e0abd0af527cc$var$DEFAULT_LOAD_ENTRANCE_DURATION_SEC = 0.6;
const $601e0abd0af527cc$export$7bcfb4ff058df62d = ({ node: node, animated: animated, delay: delay, loadEntranceDurationSec: loadEntranceDurationSec = $601e0abd0af527cc$var$DEFAULT_LOAD_ENTRANCE_DURATION_SEC, skipLoadEntrance: skipLoadEntrance = false, fontFamily: fontFamily = 'monospace', onClick: onClick, isExpanding: isExpanding = false, viewBoxHeight: viewBoxHeight, aspectCorrection: aspectCorrection, layoutPct: layoutPct, focusVariant: focusVariant })=>{
    const [isHovered, setIsHovered] = (0, $1oC0p.useState)(false);
    const px = layoutPct?.x ?? node.x;
    const py = layoutPct?.y ?? node.y;
    const outerOpacity = $601e0abd0af527cc$var$clamp01(layoutPct?.opacity ?? node.opacity ?? 1);
    const cx = (0, $hNner.pctToViewBox)(px);
    const cy = (0, $hNner.pctToViewBoxY)(py, viewBoxHeight ?? (0, $hNner.VIEWBOX_SCALE));
    const size = layoutPct?.size ?? node.size ?? $601e0abd0af527cc$var$DEFAULT_SIZE;
    /** Base `node.size` can differ when scroll phases animate `layoutPct.size`. */ const nodeForInsideLeadingIconLayout = {
        ...node,
        size: size
    };
    const r = size / 2;
    const hasModal = !!node.modalContent;
    const patternId = `img-${node.id}`;
    const clipId = `clip-${node.id}`;
    const clipIconId = `clip-icon-${node.id}`;
    const resolvedFontFamilyForLayout = node.fontFamily ?? fontFamily;
    const labelLayoutFontSize = resolvedFontFamilyForLayout === 'monospace' ? size * 0.3 : size * 0.4;
    const imagePlacement = (0, $hNner.effectiveLeadingImagePlacement)(node);
    const useLeadingIcon = !!node.bgImage && !!node.text && imagePlacement !== 'background' && (node.shape === 'pill' || node.shape === 'rectangle');
    const useFullBleedBgImage = !node.bgImage || !useLeadingIcon;
    const textStretchW = node.text && (node.shape === 'pill' || node.shape === 'rectangle') ? node.text.length * labelLayoutFontSize * $601e0abd0af527cc$var$MONOSPACE_CHAR_WIDTH_RATIO : 0;
    const pillBodyTextWidth = node.shape === 'pill' && node.text ? textStretchW + size * $601e0abd0af527cc$var$PILL_HORIZONTAL_PADDING : size * $601e0abd0af527cc$var$PILL_ASPECT;
    let pillWidth = layoutPct?.width ?? (node.shape === 'pill' && node.text ? pillBodyTextWidth : size * $601e0abd0af527cc$var$PILL_ASPECT);
    if (layoutPct?.width === undefined && node.shape === 'pill' && node.text && node.bgImage && imagePlacement === 'insideLeading') {
        const iconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, size);
        const insideGap = size * (0, $hNner.LEADING_ICON_INSIDE_GAP_RATIO);
        const extraSlack = size * (0, $hNner.LEADING_INSIDE_EXTRA_WIDTH_RATIO);
        pillWidth = pillBodyTextWidth + iconSide + insideGap + extraSlack;
    }
    const rectangleHeight = layoutPct?.height ?? node.height ?? size;
    let rectangleWidth = layoutPct?.width ?? node.width ?? (node.shape === 'rectangle' && node.text ? textStretchW + size * $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING : size);
    const rectangleBodyTextWidth = node.shape === 'rectangle' && node.text ? textStretchW + size * $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING : size;
    if (layoutPct?.width === undefined && node.width === undefined && node.shape === 'rectangle' && node.text && node.bgImage && imagePlacement === 'insideLeading') {
        const iconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, rectangleHeight);
        const insideGap = rectangleHeight * (0, $hNner.LEADING_ICON_INSIDE_GAP_RATIO);
        const extraSlack = Math.max(size, rectangleHeight) * (0, $hNner.LEADING_INSIDE_EXTRA_WIDTH_RATIO);
        rectangleWidth = rectangleBodyTextWidth + iconSide + insideGap + extraSlack;
    }
    const rectangleRx = (0, $hNner.getRectangleBorderRadius)(node, rectangleWidth, rectangleHeight);
    let leadingIconGeom = null;
    if (useLeadingIcon && node.shape === 'pill') {
        const outsideIconSide = size;
        const insideIconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, size);
        const outsideGap = size * (0, $hNner.LEADING_ICON_OUTSIDE_GAP_RATIO);
        const sidePad = size * $601e0abd0af527cc$var$PILL_HORIZONTAL_PADDING / 2;
        if (imagePlacement === 'insideLeading') leadingIconGeom = {
            x: -pillWidth / 2 + sidePad,
            y: -insideIconSide / 2,
            w: insideIconSide,
            h: insideIconSide,
            rx: 0
        };
        else leadingIconGeom = {
            x: -pillWidth / 2 - outsideGap - outsideIconSide,
            y: -r,
            w: outsideIconSide,
            h: outsideIconSide,
            rx: 0
        };
    } else if (useLeadingIcon && node.shape === 'rectangle') {
        const outsideIconSide = rectangleHeight;
        const insideIconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, rectangleHeight);
        const outsideGap = rectangleHeight * (0, $hNner.LEADING_ICON_OUTSIDE_GAP_RATIO);
        const sidePad = size * $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING / 2;
        if (imagePlacement === 'insideLeading') leadingIconGeom = {
            x: -rectangleWidth / 2 + sidePad,
            y: -insideIconSide / 2,
            w: insideIconSide,
            h: insideIconSide,
            rx: 0
        };
        else leadingIconGeom = {
            x: -rectangleWidth / 2 - outsideGap - outsideIconSide,
            y: -rectangleHeight / 2,
            w: outsideIconSide,
            h: outsideIconSide,
            rx: 0
        };
    }
    const rotation = node.rotate ? `rotate(${node.rotate}deg)` : '';
    const tx = !isExpanding && isHovered ? cx + 2 : cx;
    const ty = !isExpanding && isHovered ? cy - 5 : cy;
    const innerScale = isExpanding ? 1.25 : animated ? 1 : 0;
    const acX = aspectCorrection?.scaleX ?? 1;
    const acY = aspectCorrection?.scaleY ?? 1;
    let innerTransition;
    if (isExpanding) innerTransition = 'opacity 0.3s ease, transform 0.3s ease';
    else if (isHovered) innerTransition = 'opacity 0.3s ease, transform 0.3s ease';
    else if (animated) innerTransition = skipLoadEntrance ? undefined : `opacity ${loadEntranceDurationSec}s ease ${delay}s, transform ${loadEntranceDurationSec}s ease ${delay}s`;
    const positionOuterStyle = {
        willChange: 'transform',
        backfaceVisibility: 'hidden',
        transformBox: 'view-box',
        transform: `translate3d(${tx}px, ${ty}px, 0)`,
        transformOrigin: '0 0',
        transition: 'transform 33ms linear',
        mixBlendMode: isExpanding || isHovered ? 'normal' : node.mixBlendMode ?? 'normal',
        opacity: outerOpacity
    };
    const textColor = (0, $hNner.getFillColor)(node.textColor ?? 'white');
    const innerStyle = {
        transform: `scale(${innerScale * acX}, ${innerScale * acY}) ${rotation}`,
        transformOrigin: '0 0',
        '--node-text-color': textColor,
        ...innerTransition ? {
            transition: innerTransition
        } : {}
    };
    const clickable = !!onClick;
    const groupProps = {
        style: {
            cursor: clickable ? 'pointer' : 'default'
        },
        onClick: clickable ? ()=>onClick?.() : undefined,
        role: clickable ? 'button' : undefined,
        tabIndex: clickable ? 0 : undefined,
        onKeyDown: clickable ? (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick?.();
            }
        } : undefined
    };
    const modalPointerHandlers = hasModal ? {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    } : {};
    const fill = (0, $hNner.getFillColor)(node.bgColor ?? 'blue500');
    const isRovoRainbowBorder = node.borderColor === 'rainbowRovo';
    const solidBorderColor = node.borderColor && node.borderColor !== 'rainbowRovo' ? node.borderColor : undefined;
    const defaultStrokeWidth = node.borderWidth ?? 2;
    const stroke = solidBorderColor ? (0, $hNner.getFillColor)(solidBorderColor) : 'none';
    const strokeWidth = solidBorderColor ? defaultStrokeWidth : 0;
    const rovoRingWidth = node.borderWidth ?? 6;
    const rovoRainbowLayer = isRovoRainbowBorder && (node.shape === 'pill' || node.shape === 'rectangle') ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $75Q24.RovoRainbowBorder), {
        nodeId: node.id,
        shape: node.shape === 'pill' ? 'pill' : 'rectangle',
        innerWidth: node.shape === 'pill' ? pillWidth : rectangleWidth,
        innerHeight: node.shape === 'pill' ? size : rectangleHeight,
        innerRectangleBorderRadius: node.shape === 'rectangle' ? rectangleRx : undefined,
        ringWidth: rovoRingWidth
    }) : null;
    const nodeFontFamily = node.fontFamily ?? fontFamily;
    const typeFace = nodeFontFamily === 'charlie' ? (0, $kbpa7.wacToken)('font.charlie.display') : 'monospace';
    const defaultFontWeight = nodeFontFamily === 'charlie' ? 600 : 400;
    const textFontWeight = node.fontWeight ?? defaultFontWeight;
    const renderDefs = ()=>{
        if (!node.bgImage) return null;
        if (useLeadingIcon && leadingIconGeom) {
            const g = leadingIconGeom;
            return /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: clipIconId,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        x: g.x,
                        y: g.y,
                        width: g.w,
                        height: g.h,
                        rx: g.rx
                    })
                })
            });
        }
        let clipShape;
        switch(node.shape){
            case 'circle':
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    cx: 0,
                    cy: 0,
                    r: r
                });
                break;
            case 'pill':
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: -pillWidth / 2,
                    y: -r,
                    width: pillWidth,
                    height: size,
                    rx: r
                });
                break;
            case 'rectangle':
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: -rectangleWidth / 2,
                    y: -rectangleHeight / 2,
                    width: rectangleWidth,
                    height: rectangleHeight,
                    rx: rectangleRx
                });
                break;
            case 'hexagon':
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                    points: (0, $hNner.getHexagonPoints)(0, 0, r)
                });
                break;
            case 'triangle':
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                    points: (0, $hNner.getTrianglePoints)(0, 0, r)
                });
                break;
        }
        const imgW = node.shape === 'rectangle' ? rectangleWidth : size;
        const imgH = node.shape === 'rectangle' ? rectangleHeight : size;
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: clipId,
                    children: clipShape
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("pattern", {
                    id: patternId,
                    patternUnits: "objectBoundingBox",
                    width: "1",
                    height: "1",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                        href: node.bgImage,
                        x: -imgW / 2,
                        y: -imgH / 2,
                        width: imgW,
                        height: imgH,
                        preserveAspectRatio: "xMidYMid slice"
                    })
                })
            ]
        });
    };
    const renderShape = ()=>{
        const clipPath = node.bgImage && useFullBleedBgImage ? `url(#${clipId})` : undefined;
        switch(node.shape){
            case 'circle':
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                            cx: 0,
                            cy: 0,
                            r: r,
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -r,
                            y: -r,
                            width: size,
                            height: size,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
            case 'pill':
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            x: -pillWidth / 2,
                            y: -r,
                            width: pillWidth,
                            height: size,
                            rx: r,
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -pillWidth / 2,
                            y: -r,
                            width: pillWidth,
                            height: size,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
            case 'rectangle':
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            x: -rectangleWidth / 2,
                            y: -rectangleHeight / 2,
                            width: rectangleWidth,
                            height: rectangleHeight,
                            rx: rectangleRx,
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -rectangleWidth / 2,
                            y: -rectangleHeight / 2,
                            width: rectangleWidth,
                            height: rectangleHeight,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
            case 'hexagon':
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                            points: (0, $hNner.getHexagonPoints)(0, 0, r),
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -r,
                            y: -r,
                            width: size,
                            height: size,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
            case 'triangle':
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                            points: (0, $hNner.getTrianglePoints)(0, 0, r),
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -r,
                            y: -r,
                            width: size,
                            height: size,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
        }
    };
    const renderLeadingIconStack = ()=>{
        if (!useLeadingIcon || !leadingIconGeom || !node.bgImage) return null;
        const g = leadingIconGeom;
        return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                href: node.bgImage,
                x: g.x,
                y: g.y,
                width: g.w,
                height: g.h,
                clipPath: `url(#${clipIconId})`,
                preserveAspectRatio: "xMidYMid slice"
            })
        });
    };
    const renderText = ()=>{
        const textSize = nodeFontFamily === 'monospace' ? size * 0.3 : size * 0.4;
        if (!node.text) return null;
        let textAnchor = 'middle';
        let textX = 0;
        if (useLeadingIcon && imagePlacement === 'insideLeading' && node.shape === 'pill') {
            textAnchor = 'start';
            const sidePad = size * $601e0abd0af527cc$var$PILL_HORIZONTAL_PADDING / 2;
            const gap = size * (0, $hNner.LEADING_ICON_INSIDE_GAP_RATIO);
            const iconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, size);
            textX = -pillWidth / 2 + sidePad + iconSide + gap;
        } else if (useLeadingIcon && imagePlacement === 'insideLeading' && node.shape === 'rectangle') {
            textAnchor = 'start';
            const sidePad = size * $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING / 2;
            const gap = rectangleHeight * (0, $hNner.LEADING_ICON_INSIDE_GAP_RATIO);
            const iconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, rectangleHeight);
            textX = -rectangleWidth / 2 + sidePad + iconSide + gap;
        }
        return /*#__PURE__*/ (0, $7VQPk.jsx)("text", {
            textRendering: "optimizeSpeed",
            x: textX,
            y: 0,
            textAnchor: textAnchor,
            dominantBaseline: "central",
            fill: textColor,
            fontSize: textSize,
            fontWeight: textFontWeight,
            fontFamily: typeFace,
            pointerEvents: "none",
            children: node.text
        });
    };
    const renderRectangleHtmlContent = ()=>{
        if (node.shape !== 'rectangle' || node.htmlContent === undefined || node.htmlContent === null) return null;
        const w = rectangleWidth;
        const h = rectangleHeight;
        const xhtmlWrapperStyle = {
            width: '100%',
            height: '100%',
            margin: 0,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            fontFamily: typeFace,
            color: textColor,
            lineHeight: 1.35,
            WebkitFontSmoothing: 'antialiased'
        };
        return /*#__PURE__*/ (0, $7VQPk.jsx)("foreignObject", {
            x: -w / 2,
            y: -h / 2,
            width: w,
            height: h,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement('div', {
                xmlns: 'http://www.w3.org/1999/xhtml',
                style: xhtmlWrapperStyle
            }, node.htmlContent)
        });
    };
    const focusClass = focusVariant === 'node-edit' ? 'spiderweb-node--focus-node-edit' : focusVariant === 'connector' ? 'spiderweb-node--focus-connector' : '';
    return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
        className: (0, $2jatx.default)([
            "_yc581r31 _ymio1r31 _18xqglyw _ypr0glyw _1bjo1o36 _zcxs1o36 _dl451q9v _uzb71q9v _1xkmgq9o _1okygq9o _7fy219bv _masb19bv _1npvsg8i _1ljwsg8i _1lfl1bs3 _9gqo1bs3 _t8mz12c5 _1shr12c5 _1uaj605o _1pn9605o _kja3tlke _1ugbewfl _ao4wewfl _5wjo1gnr _1bcy1gnr _9qyu1gnr _1oxm1gnr _qayc1gnr _1pnf1gnr _179o1gnr _oimw1f33 _16or1f33 _1oy11f33 _17651f33 _8qwq1f33 _ohkf1f33 _16dt1f33 _1rc3idpf _1t2iidpf _d7tpidpf _17opidpf _sk07idpf _1a7ridpf _9ersidpf _kgp4idpf _151didpf _1libidpf _1t7eidpf _1nvlidpf _6d9lidpf _922midpf _1duf1kwk _n6e41kwk _unli1kwk _1po11kwk _7n4p1kwk _1x7n1kwk _13il1kwk _7clvidpf _543pidpf _w6r8idpf _ol08idpf _mpitidpf _1jrwidpf _okkmidpf _fp9j1gnr _1yk91gnr _8izd1gnr _1f981gnr _gw491gnr _iree1gnr _1klh1gnr _pf5l1nn1 _1444viql _jl4d1wto _4rdb1k8s _11sg1k8s",
            `
        ${hasModal ? 'modal-interactive' : ''}
        ${hasModal && isHovered ? 'modal-hovered' : ''}
        ${focusClass}
        `
        ]),
        id: `node-group-${node.id}`,
        "data-modal-interactive": hasModal ? true : undefined,
        ...groupProps,
        ...modalPointerHandlers,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            style: positionOuterStyle,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    style: innerStyle,
                    children: [
                        rovoRainbowLayer,
                        renderDefs(),
                        renderShape(),
                        renderLeadingIconStack(),
                        renderRectangleHtmlContent(),
                        renderText()
                    ]
                }),
                focusVariant === 'connector' && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            fill: "black",
                            width: 170,
                            height: 40,
                            y: -25,
                            x: -80
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("text", {
                            fill: "white",
                            x: -70,
                            children: "Select another node"
                        })
                    ]
                })
            ]
        })
    });
}; /* eslint-enable complexity */ 

});
parcelRegister("75Q24", function(module, exports) {
$parcel$export(module.exports, "RovoRainbowBorder", function () { return $be99f48601e89603$export$2b048a65f5dc1409; });

var $7VQPk = parcelRequire("7VQPk");

var $hNner = parcelRequire("hNner");
const $be99f48601e89603$var$ROVO_QUADRANT_COLORS = [
    'lime500',
    'yellow400',
    'purple500',
    'blue500'
];
function $be99f48601e89603$var$safeNodeIdForSvg(nodeId) {
    return nodeId.replace(/[^\w.-]/g, '_');
}
const $be99f48601e89603$export$2b048a65f5dc1409 = ({ nodeId: nodeId, shape: shape, innerWidth: innerWidth, innerHeight: innerHeight, innerRectangleBorderRadius: innerRectangleBorderRadius, ringWidth: ringWidth })=>{
    const B = ringWidth;
    const W_out = innerWidth + 2 * B;
    const H_out = innerHeight + 2 * B;
    const x0 = -W_out / 2;
    const y0 = -H_out / 2;
    const halfW = W_out / 2;
    const halfH = H_out / 2;
    const rxOut = shape === 'pill' ? H_out / 2 : innerRectangleBorderRadius !== undefined ? Math.min(innerRectangleBorderRadius + B, Math.min(W_out, H_out) / 2) : Math.min(W_out, H_out) / 4;
    const sid = $be99f48601e89603$var$safeNodeIdForSvg(nodeId);
    const clipId = (q)=>`rr-${sid}-${q}`;
    const clips = /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                id: clipId('tl'),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: x0,
                    y: y0,
                    width: halfW,
                    height: halfH
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                id: clipId('tr'),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: 0,
                    y: y0,
                    width: halfW,
                    height: halfH
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                id: clipId('bl'),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: x0,
                    y: 0,
                    width: halfW,
                    height: halfH
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                id: clipId('br'),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: 0,
                    y: 0,
                    width: halfW,
                    height: halfH
                })
            })
        ]
    });
    const outerRectAttrs = {
        x: x0,
        y: y0,
        width: W_out,
        height: H_out,
        rx: rxOut
    };
    const quadrants = [
        'tl',
        'tr',
        'bl',
        'br'
    ].map((q, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            clipPath: `url(#${clipId(q)})`,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                ...outerRectAttrs,
                fill: (0, $hNner.getFillColor)($be99f48601e89603$var$ROVO_QUADRANT_COLORS[i] || 'lime500')
            })
        }, q));
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            clips,
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                className: "spiderweb-node__rovo-rainbow-border",
                pointerEvents: "none",
                children: quadrants
            })
        ]
    });
};

});


parcelRegister("dhl4q", function(module, exports) {
$parcel$export(module.exports, "WebOverlapLayers", function () { return $13171dd67522f5be$export$c70c1f7696a29479; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $hNner = parcelRequire("hNner");
function $13171dd67522f5be$var$localToWorld(lx, ly, L) {
    const rad = L.rotate * Math.PI / 180;
    const c = Math.cos(rad);
    const s = Math.sin(rad);
    return [
        L.cx + lx * c - ly * s,
        L.cy + lx * s + ly * c
    ];
}
function $13171dd67522f5be$var$worldToLocal(wx, wy, L) {
    const dx = wx - L.cx;
    const dy = wy - L.cy;
    const rad = -L.rotate * Math.PI / 180;
    const c = Math.cos(rad);
    const s = Math.sin(rad);
    return [
        dx * c - dy * s,
        dx * s + dy * c
    ];
}
function $13171dd67522f5be$var$layoutWorldAabb(L) {
    const { r: r, size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight, shape: shape } = L;
    const corners = (()=>{
        switch(shape){
            case 'circle':
                return [
                    [
                        -r,
                        -r
                    ],
                    [
                        r,
                        -r
                    ],
                    [
                        r,
                        r
                    ],
                    [
                        -r,
                        r
                    ]
                ];
            case 'pill':
                {
                    const x0 = -pillWidth / 2;
                    const x1 = pillWidth / 2;
                    const y0 = -r;
                    const y1 = -r + size;
                    return [
                        [
                            x0,
                            y0
                        ],
                        [
                            x1,
                            y0
                        ],
                        [
                            x1,
                            y1
                        ],
                        [
                            x0,
                            y1
                        ]
                    ];
                }
            case 'rectangle':
                {
                    const rh = rectangleHeight;
                    const x0 = -rectangleWidth / 2;
                    const x1 = rectangleWidth / 2;
                    const y0 = -rh / 2;
                    const y1 = rh / 2;
                    return [
                        [
                            x0,
                            y0
                        ],
                        [
                            x1,
                            y0
                        ],
                        [
                            x1,
                            y1
                        ],
                        [
                            x0,
                            y1
                        ]
                    ];
                }
            case 'hexagon':
                {
                    const pts = [];
                    for(let i = 0; i < 6; i++){
                        const a = Math.PI / 3 * i - Math.PI / 2;
                        pts.push([
                            r * Math.cos(a),
                            r * Math.sin(a)
                        ]);
                    }
                    return pts;
                }
            case 'triangle':
                return [
                    [
                        0,
                        -r
                    ],
                    [
                        -r * 0.866,
                        r * 0.5
                    ],
                    [
                        r * 0.866,
                        r * 0.5
                    ]
                ];
            default:
                return [
                    [
                        -r,
                        -r
                    ],
                    [
                        r,
                        -r
                    ],
                    [
                        r,
                        r
                    ],
                    [
                        -r,
                        r
                    ]
                ];
        }
    })();
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for (const [lx, ly] of corners){
        const [wx, wy] = $13171dd67522f5be$var$localToWorld(lx, ly, L);
        minX = Math.min(minX, wx);
        maxX = Math.max(maxX, wx);
        minY = Math.min(minY, wy);
        maxY = Math.max(maxY, wy);
    }
    return {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
    };
}
function $13171dd67522f5be$var$intersectWorldAabbs(a, b) {
    const minX = Math.max(a.minX, b.minX);
    const maxX = Math.min(a.maxX, b.maxX);
    const minY = Math.max(a.minY, b.minY);
    const maxY = Math.min(a.maxY, b.maxY);
    if (minX >= maxX || minY >= maxY) return null;
    return {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
    };
}
function $13171dd67522f5be$var$pointInLocalHexagon(lx, ly, r) {
    const vx = [];
    const vy = [];
    for(let i = 0; i < 6; i++){
        const a = Math.PI / 3 * i - Math.PI / 2;
        vx.push(r * Math.cos(a));
        vy.push(r * Math.sin(a));
    }
    let inside = false;
    for(let i = 0; i < 6; i++){
        const j = (i + 5) % 6;
        const xi = vx[i];
        const yi = vy[i];
        const xj = vx[j];
        const yj = vy[j];
        if (yi > ly !== yj > ly && lx < (xj - xi) * (ly - yi) / (yj - yi + 1e-12) + xi) inside = !inside;
    }
    return inside;
}
function $13171dd67522f5be$var$pointInLocalTriangle(lx, ly, r) {
    const x1 = 0;
    const y1 = -r;
    const x2 = -r * 0.866;
    const y2 = r * 0.5;
    const x3 = r * 0.866;
    const y3 = r * 0.5;
    const sign = (p1x, p1y, p2x, p2y, p3x, p3y)=>(p1x - p3x) * (p2y - p3y) - (p2x - p3x) * (p1y - p3y);
    const d1 = sign(lx, ly, x1, y1, x2, y2);
    const d2 = sign(lx, ly, x2, y2, x3, y3);
    const d3 = sign(lx, ly, x3, y3, x1, y1);
    const hasNeg = d1 < -0.000001 || d2 < -0.000001 || d3 < -0.000001;
    const hasPos = d1 > 1e-6 || d2 > 1e-6 || d3 > 1e-6;
    return !(hasNeg && hasPos);
}
function $13171dd67522f5be$var$pointInLocalShape(lx, ly, L) {
    const { r: r, size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight, shape: shape } = L;
    switch(shape){
        case 'circle':
            return lx * lx + ly * ly <= r * r + 1e-6;
        case 'pill':
            return lx >= -pillWidth / 2 - 1e-6 && lx <= pillWidth / 2 + 1e-6 && ly >= -r - 1e-6 && ly <= -r + size + 1e-6;
        case 'rectangle':
            {
                const rh = rectangleHeight;
                return lx >= -rectangleWidth / 2 - 1e-6 && lx <= rectangleWidth / 2 + 1e-6 && ly >= -rh / 2 - 1e-6 && ly <= rh / 2 + 1e-6;
            }
        case 'hexagon':
            return $13171dd67522f5be$var$pointInLocalHexagon(lx, ly, r);
        case 'triangle':
            return $13171dd67522f5be$var$pointInLocalTriangle(lx, ly, r);
        default:
            return lx * lx + ly * ly <= r * r + 1e-6;
    }
}
function $13171dd67522f5be$var$pointInWorldShape(wx, wy, L) {
    const [lx, ly] = $13171dd67522f5be$var$worldToLocal(wx, wy, L);
    return $13171dd67522f5be$var$pointInLocalShape(lx, ly, L);
}
const $13171dd67522f5be$var$INTERSECTION_AABB_GRID = 56;
function $13171dd67522f5be$var$getShapeIntersectionAabb(Ls, Lt) {
    const ab = $13171dd67522f5be$var$intersectWorldAabbs($13171dd67522f5be$var$layoutWorldAabb(Ls), $13171dd67522f5be$var$layoutWorldAabb(Lt));
    if (!ab) return null;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    let found = false;
    const gw = $13171dd67522f5be$var$INTERSECTION_AABB_GRID;
    const w = ab.maxX - ab.minX;
    const h = ab.maxY - ab.minY;
    for(let i = 0; i <= gw; i++)for(let j = 0; j <= gw; j++){
        const x = ab.minX + i / gw * w;
        const y = ab.minY + j / gw * h;
        if ($13171dd67522f5be$var$pointInWorldShape(x, y, Ls) && $13171dd67522f5be$var$pointInWorldShape(x, y, Lt)) {
            found = true;
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
    }
    if (!found) return null;
    const pad = Math.max((maxX - minX) * 0.02, (maxY - minY) * 0.02, 0.5);
    return {
        minX: minX - pad,
        maxX: maxX + pad,
        minY: minY - pad,
        maxY: maxY + pad
    };
}
function $13171dd67522f5be$var$clipPathShape(L) {
    const { cx: cx, cy: cy, r: r, size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight, rectangleBorderRadius: rectangleBorderRadius, rotate: rotate, shape: shape } = L;
    const tf = `translate(${cx},${cy}) rotate(${rotate})`;
    switch(shape){
        case 'circle':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: cx,
                cy: cy,
                r: r
            });
        case 'pill':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: -pillWidth / 2,
                y: -r,
                width: pillWidth,
                height: size,
                rx: r,
                transform: tf
            });
        case 'rectangle':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: -rectangleWidth / 2,
                y: -rectangleHeight / 2,
                width: rectangleWidth,
                height: rectangleHeight,
                rx: rectangleBorderRadius ?? Math.min(rectangleWidth, rectangleHeight) / 4,
                transform: tf
            });
        case 'hexagon':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: (0, $hNner.getHexagonPoints)(0, 0, r),
                transform: tf
            });
        case 'triangle':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: (0, $hNner.getTrianglePoints)(0, 0, r),
                transform: tf
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: cx,
                cy: cy,
                r: r
            });
    }
}
function $13171dd67522f5be$var$renderFilledShape(L, fill, fillOpacity) {
    const { r: r, size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight, rectangleBorderRadius: rectangleBorderRadius, shape: shape } = L;
    const op = fillOpacity !== undefined ? {
        fillOpacity: fillOpacity
    } : {};
    const cssFill = (0, $hNner.getFillColor)(fill);
    switch(shape){
        case 'circle':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: 0,
                cy: 0,
                r: r,
                fill: cssFill,
                ...op
            });
        case 'pill':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: -pillWidth / 2,
                y: -r,
                width: pillWidth,
                height: size,
                rx: r,
                fill: cssFill,
                ...op
            });
        case 'rectangle':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: -rectangleWidth / 2,
                y: -rectangleHeight / 2,
                width: rectangleWidth,
                height: rectangleHeight,
                rx: rectangleBorderRadius ?? Math.min(rectangleWidth, rectangleHeight) / 4,
                fill: cssFill,
                ...op
            });
        case 'hexagon':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: (0, $hNner.getHexagonPoints)(0, 0, r),
                fill: cssFill,
                ...op
            });
        case 'triangle':
            return /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: (0, $hNner.getTrianglePoints)(0, 0, r),
                fill: cssFill,
                ...op
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: 0,
                cy: 0,
                r: r,
                fill: cssFill,
                ...op
            });
    }
}
function $13171dd67522f5be$var$resolveIntersectionImageAabb(Ls, Lt) {
    const tight = $13171dd67522f5be$var$getShapeIntersectionAabb(Ls, Lt);
    if (tight) return tight;
    const loose = $13171dd67522f5be$var$intersectWorldAabbs($13171dd67522f5be$var$layoutWorldAabb(Ls), $13171dd67522f5be$var$layoutWorldAabb(Lt));
    if (loose) {
        const cx = (loose.minX + loose.maxX) / 2;
        const cy = (loose.minY + loose.maxY) / 2;
        const side = Math.max(Math.min(loose.maxX - loose.minX, loose.maxY - loose.minY, 48), 6);
        return {
            minX: cx - side / 2,
            maxX: cx + side / 2,
            minY: cy - side / 2,
            maxY: cy + side / 2
        };
    }
    const cx = (Ls.cx + Lt.cx) / 2;
    const cy = (Ls.cy + Lt.cy) / 2;
    const s = Math.min(Ls.r, Lt.r, 24) * 0.5;
    return {
        minX: cx - s,
        maxX: cx + s,
        minY: cy - s,
        maxY: cy + s
    };
}
function $13171dd67522f5be$var$renderOverlapImageInIntersection(href, aabb) {
    const w = Math.max(aabb.maxX - aabb.minX, 1);
    const h = Math.max(aabb.maxY - aabb.minY, 1);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
        href: href,
        x: aabb.minX,
        y: aabb.minY,
        width: w,
        height: h,
        preserveAspectRatio: "xMidYMid slice"
    });
}
function $13171dd67522f5be$var$normalizeOverlapFill(fill) {
    if (typeof fill === 'string') return {
        color: fill
    };
    return {
        color: fill.color,
        backgroundImage: fill.backgroundImage
    };
}
const $13171dd67522f5be$var$DEFAULT_OVERLAP_FADE_DURATION_SEC = 0.5;
const $13171dd67522f5be$export$c70c1f7696a29479 = ({ nodes: nodes, viewBoxHeight: viewBoxHeight, animated: animated = false, delay: delay = 0, loadEntranceFadeDurationSec: loadEntranceFadeDurationSec = $13171dd67522f5be$var$DEFAULT_OVERLAP_FADE_DURATION_SEC, skipLoadEntrance: skipLoadEntrance = false, nodePositions: nodePositions })=>{
    const reactId = (0, $1oC0p.useId)().replace(/:/g, '');
    const nodeMap = (0, $1oC0p.useMemo)(()=>new Map(nodes.map((n)=>[
                n.id,
                n
            ])), [
        nodes
    ]);
    const { clipIds: clipIds, layers: layers } = (0, $1oC0p.useMemo)(()=>{
        const clipIds = new Set();
        const layers = [];
        for (const node of nodes){
            if (!node.overlapColors?.length) continue;
            for (const entry of node.overlapColors){
                const otherId = entry.elementIdToOverlap;
                const otherNode = nodeMap.get(otherId);
                if (!otherNode) continue;
                const parsed = $13171dd67522f5be$var$normalizeOverlapFill({
                    color: entry.color,
                    backgroundImage: entry.backgroundImage
                });
                if (!parsed.color && !parsed.backgroundImage) continue;
                clipIds.add(otherId);
                const Ls = (0, $hNner.getNodeOverlapLayout)(node, viewBoxHeight, nodePositions?.get(node.id));
                const Lt = (0, $hNner.getNodeOverlapLayout)(otherNode, viewBoxHeight, nodePositions?.get(otherId));
                let imageAabb;
                if (parsed.backgroundImage) {
                    clipIds.add(node.id);
                    imageAabb = $13171dd67522f5be$var$resolveIntersectionImageAabb(Ls, Lt);
                }
                layers.push({
                    sourceId: node.id,
                    targetId: otherId,
                    parsed: parsed,
                    imageAabb: imageAabb
                });
            }
        }
        return {
            clipIds: clipIds,
            layers: layers
        };
    }, [
        nodes,
        nodeMap,
        viewBoxHeight,
        nodePositions
    ]);
    const clipId = (nodeId)=>`overlap-clip-${reactId}-${nodeId}`;
    if (layers.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: nodes.filter((n)=>clipIds.has(n.id)).map((n)=>{
                    const L = (0, $hNner.getNodeOverlapLayout)(n, viewBoxHeight, nodePositions?.get(n.id));
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: clipId(n.id),
                        clipPathUnits: "userSpaceOnUse",
                        children: $13171dd67522f5be$var$clipPathShape(L)
                    }, clipId(n.id));
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                style: {
                    isolation: 'isolate',
                    pointerEvents: 'none',
                    opacity: animated ? 1 : 0,
                    ...animated && skipLoadEntrance ? {} : {
                        transition: `opacity ${loadEntranceFadeDurationSec}s ease ${delay}s`
                    }
                },
                children: layers.map(({ sourceId: sourceId, targetId: targetId, parsed: parsed, imageAabb: imageAabb })=>{
                    const source = nodeMap.get(sourceId);
                    if (!source) return null;
                    const L = (0, $hNner.getNodeOverlapLayout)(source, viewBoxHeight, nodePositions?.get(sourceId));
                    const hasImage = Boolean(parsed.backgroundImage);
                    const hasColor = Boolean(parsed.color);
                    if (hasImage && imageAabb) return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        style: {
                            mixBlendMode: 'normal'
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                            clipPath: `url(#${clipId(targetId)})`,
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                                clipPath: `url(#${clipId(sourceId)})`,
                                children: [
                                    hasColor && parsed.color ? /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                        transform: `translate(${L.cx},${L.cy}) rotate(${L.rotate})`,
                                        children: $13171dd67522f5be$var$renderFilledShape(L, parsed.color)
                                    }) : null,
                                    $13171dd67522f5be$var$renderOverlapImageInIntersection(parsed.backgroundImage ?? '', imageAabb)
                                ]
                            })
                        })
                    }, `${sourceId}-${targetId}`);
                    const fillContent = parsed.color !== undefined ? $13171dd67522f5be$var$renderFilledShape(L, parsed.color) : null;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        style: {
                            mixBlendMode: 'normal'
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                            clipPath: `url(#${clipId(targetId)})`,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                transform: `translate(${L.cx},${L.cy}) rotate(${L.rotate})`,
                                children: fillContent
                            })
                        })
                    }, `${sourceId}-${targetId}`);
                })
            })
        ]
    });
};

});


parcelRegister("4xHTR", function(module, exports) {
$parcel$export(module.exports, "useSpiderwebAmbientPositions", function () { return $651d9150f360fb43$export$c7e087e29b633f6d; });

var $1oC0p = parcelRequire("1oC0p");
const $651d9150f360fb43$var$AMBIENT_FRAME_INTERVAL_MS = 1000 / 30;
const $651d9150f360fb43$var$AMBIENT_OVERLAP_FRAME_INTERVAL_MS = 1000 / 15;
const $651d9150f360fb43$var$AMBIENT_MAX_FRAME_DELTA_MS = 100;
const $651d9150f360fb43$var$AMBIENT_MAX_OFFSET_PCT = 0.8;
const $651d9150f360fb43$var$AMBIENT_MIN_CYCLE_SEC = 16;
const $651d9150f360fb43$var$AMBIENT_CYCLE_RANGE_SEC = 10;
const $651d9150f360fb43$var$TAU = Math.PI * 2;
function $651d9150f360fb43$var$hashString(value) {
    let hash = 2166136261;
    for(let i = 0; i < value.length; i++){
        hash ^= value.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
}
function $651d9150f360fb43$var$hashFraction(value, salt) {
    return $651d9150f360fb43$var$hashString(`${salt}:${value}`) / 0xffffffff;
}
function $651d9150f360fb43$export$987bbb337f84c3b7(nodeId) {
    const xAmplitude = $651d9150f360fb43$var$AMBIENT_MAX_OFFSET_PCT * (0.55 + $651d9150f360fb43$var$hashFraction(nodeId, 'xa') * 0.45);
    const yAmplitude = $651d9150f360fb43$var$AMBIENT_MAX_OFFSET_PCT * (0.55 + $651d9150f360fb43$var$hashFraction(nodeId, 'ya') * 0.45);
    return {
        xAmplitude: xAmplitude,
        yAmplitude: yAmplitude,
        xPhase: $651d9150f360fb43$var$hashFraction(nodeId, 'xp') * $651d9150f360fb43$var$TAU,
        yPhase: $651d9150f360fb43$var$hashFraction(nodeId, 'yp') * $651d9150f360fb43$var$TAU,
        xCycleSec: $651d9150f360fb43$var$AMBIENT_MIN_CYCLE_SEC + $651d9150f360fb43$var$hashFraction(nodeId, 'xc') * $651d9150f360fb43$var$AMBIENT_CYCLE_RANGE_SEC,
        yCycleSec: $651d9150f360fb43$var$AMBIENT_MIN_CYCLE_SEC + $651d9150f360fb43$var$hashFraction(nodeId, 'yc') * $651d9150f360fb43$var$AMBIENT_CYCLE_RANGE_SEC
    };
}
function $651d9150f360fb43$export$c0ea84c9b2a2a24d(previousMs, nowMs) {
    return Math.max(0, Math.min(nowMs - previousMs, $651d9150f360fb43$var$AMBIENT_MAX_FRAME_DELTA_MS)) / 1000;
}
function $651d9150f360fb43$export$2e077474460cded2(profile, elapsedSec) {
    return {
        x: Math.sin(elapsedSec / profile.xCycleSec * $651d9150f360fb43$var$TAU + profile.xPhase) * profile.xAmplitude,
        y: Math.sin(elapsedSec / profile.yCycleSec * $651d9150f360fb43$var$TAU + profile.yPhase) * profile.yAmplitude
    };
}
function $651d9150f360fb43$export$82f08e33bfcab16e(positions, profiles, elapsedSec) {
    const ambientPositions = new Map();
    for (const [nodeId, position] of positions){
        const profile = profiles.get(nodeId);
        if (!profile) {
            ambientPositions.set(nodeId, position);
            continue;
        }
        const offset = $651d9150f360fb43$export$2e077474460cded2(profile, elapsedSec);
        ambientPositions.set(nodeId, {
            ...position,
            x: position.x + offset.x,
            y: position.y + offset.y
        });
    }
    return ambientPositions;
}
function $651d9150f360fb43$export$c7e087e29b633f6d(nodes, basePositions, active, animationsPaused) {
    const profiles = (0, $1oC0p.useMemo)(()=>new Map(nodes.map((node)=>[
                node.id,
                $651d9150f360fb43$export$987bbb337f84c3b7(node.id)
            ])), [
        nodes
    ]);
    const frameIntervalMs = (0, $1oC0p.useMemo)(()=>nodes.some((node)=>node.overlapColors?.length) ? $651d9150f360fb43$var$AMBIENT_OVERLAP_FRAME_INTERVAL_MS : $651d9150f360fb43$var$AMBIENT_FRAME_INTERVAL_MS, [
        nodes
    ]);
    const [elapsedSec, setElapsedSec] = (0, $1oC0p.useState)(0);
    const elapsedSecRef = (0, $1oC0p.useRef)(0);
    const previousFrameMsRef = (0, $1oC0p.useRef)(null);
    const lastRenderMsRef = (0, $1oC0p.useRef)(0);
    (0, $1oC0p.useEffect)(()=>{
        if (!active || animationsPaused) {
            previousFrameMsRef.current = null;
            return;
        }
        let frameId = 0;
        const tick = (nowMs)=>{
            const previousFrameMs = previousFrameMsRef.current;
            previousFrameMsRef.current = nowMs;
            if (previousFrameMs !== null) elapsedSecRef.current += $651d9150f360fb43$export$c0ea84c9b2a2a24d(previousFrameMs, nowMs);
            if (nowMs - lastRenderMsRef.current >= frameIntervalMs) {
                lastRenderMsRef.current = nowMs;
                setElapsedSec(elapsedSecRef.current);
            }
            frameId = requestAnimationFrame(tick);
        };
        frameId = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(frameId);
    }, [
        active,
        animationsPaused,
        frameIntervalMs
    ]);
    return (0, $1oC0p.useMemo)(()=>active ? $651d9150f360fb43$export$82f08e33bfcab16e(basePositions, profiles, elapsedSec) : basePositions, [
        active,
        basePositions,
        elapsedSec,
        profiles
    ]);
}

});

parcelRegister("kCguZ", function(module, exports) {
$parcel$export(module.exports, "useSpiderWebConnectorPlan", function () { return $aaba49e65f69a395$export$e2164034fb892369; });

var $1oC0p = parcelRequire("1oC0p");

var $hNner = parcelRequire("hNner");
function $aaba49e65f69a395$export$e2164034fb892369(nodes, maxNeighbors, explicitConnectors, useOnlyExplicitConnectors, connectorShape, connectorType) {
    const connectorConfigs = (0, $1oC0p.useMemo)(()=>explicitConnectors && useOnlyExplicitConnectors ? explicitConnectors : (0, $hNner.autoConnectNodes)(nodes, maxNeighbors, explicitConnectors), [
        nodes,
        maxNeighbors,
        explicitConnectors,
        useOnlyExplicitConnectors
    ]);
    const resolvedConnectors = (0, $1oC0p.useMemo)(()=>(0, $hNner.resolveConnectors)(connectorConfigs, nodes, connectorShape, connectorType), [
        connectorConfigs,
        nodes,
        connectorShape,
        connectorType
    ]);
    return {
        connectorConfigs: connectorConfigs,
        resolvedConnectors: resolvedConnectors
    };
}

});

parcelRegister("7h9Nf", function(module, exports) {
$parcel$export(module.exports, "getNearestVerticalScrollContainer", function () { return $4a81c6d16703993d$export$5b614bdf9b8b0d5b; });
$parcel$export(module.exports, "computeDocumentSectionScrollProgress", function () { return $4a81c6d16703993d$export$da68696ce9c4a3f0; });
$parcel$export(module.exports, "useSpiderwebDocumentSectionProgress", function () { return $4a81c6d16703993d$export$234e79cf56f5baa8; });

var $1oC0p = parcelRequire("1oC0p");
function $4a81c6d16703993d$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
function $4a81c6d16703993d$export$5b614bdf9b8b0d5b(start) {
    let el = start;
    while(el){
        const { overflowY: overflowY } = getComputedStyle(el);
        const canScrollY = (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') && el.scrollHeight > el.clientHeight + 1;
        if (canScrollY) return el;
        el = el.parentElement;
    }
    return null;
}
function $4a81c6d16703993d$export$da68696ce9c4a3f0(section, scrollRoot) {
    if (scrollRoot) {
        const maxScroll = Math.max(0, scrollRoot.scrollHeight - scrollRoot.clientHeight);
        if (maxScroll <= 0) return 0;
        return $4a81c6d16703993d$var$clamp01(scrollRoot.scrollTop / maxScroll);
    }
    const trackH = section.offsetHeight;
    const viewH = window.innerHeight;
    const scrollable = trackH - viewH;
    const rect = section.getBoundingClientRect();
    if (scrollable <= 0) {
        if (rect.bottom <= 0) return 1;
        if (rect.top >= viewH) return 0;
        const past = Math.min(Math.max(-rect.top, 0), trackH);
        return trackH <= 0 ? 0 : $4a81c6d16703993d$var$clamp01(past / trackH);
    }
    const scrolled = Math.min(Math.max(-rect.top, 0), scrollable);
    return $4a81c6d16703993d$var$clamp01(scrolled / scrollable);
}
function $4a81c6d16703993d$export$234e79cf56f5baa8(sectionRef, enabled) {
    const [progress, setProgress] = (0, $1oC0p.useState)(0);
    const [isAttached, setIsAttached] = (0, $1oC0p.useState)(false);
    const isAttachedRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (!enabled || !sectionRef) {
            setProgress(0);
            if (isAttachedRef.current) {
                isAttachedRef.current = false;
                setIsAttached(false);
            }
            return;
        }
        let detach;
        let pollRafId = 0;
        let scrollFlushRafId = 0;
        let cancelled = false;
        const attach = (target)=>{
            const scrollContainer = $4a81c6d16703993d$export$5b614bdf9b8b0d5b(target);
            const flushProgress = ()=>{
                if (!cancelled) setProgress($4a81c6d16703993d$export$da68696ce9c4a3f0(target, scrollContainer));
            };
            const scheduleScrollFlush = ()=>{
                if (scrollFlushRafId !== 0) return;
                scrollFlushRafId = requestAnimationFrame(()=>{
                    scrollFlushRafId = 0;
                    flushProgress();
                });
            };
            flushProgress();
            isAttachedRef.current = true;
            setIsAttached(true);
            if (scrollContainer) scrollContainer.addEventListener('scroll', scheduleScrollFlush, {
                passive: true
            });
            else window.addEventListener('scroll', scheduleScrollFlush, {
                passive: true
            });
            window.addEventListener('resize', flushProgress);
            const ro = new ResizeObserver(flushProgress);
            ro.observe(target);
            if (scrollContainer) ro.observe(scrollContainer);
            detach = ()=>{
                cancelAnimationFrame(scrollFlushRafId);
                scrollFlushRafId = 0;
                if (scrollContainer) scrollContainer.removeEventListener('scroll', scheduleScrollFlush);
                else window.removeEventListener('scroll', scheduleScrollFlush);
                window.removeEventListener('resize', flushProgress);
                ro.disconnect();
                if (!cancelled) {
                    isAttachedRef.current = false;
                    setIsAttached(false);
                    setProgress(0);
                }
            };
        };
        const el = sectionRef.current;
        if (el) {
            attach(el);
            return ()=>{
                cancelled = true;
                detach?.();
            };
        }
        const poll = ()=>{
            if (cancelled) return;
            const node = sectionRef.current;
            if (node) {
                attach(node);
                return;
            }
            pollRafId = requestAnimationFrame(poll);
        };
        pollRafId = requestAnimationFrame(poll);
        return ()=>{
            cancelled = true;
            cancelAnimationFrame(pollRafId);
            detach?.();
        };
    }, [
        enabled,
        sectionRef
    ]);
    return {
        progress: progress,
        isAttached: isAttached
    };
}

});

parcelRegister("iDO3O", function(module, exports) {
$parcel$export(module.exports, "useSpiderWebIntersectionVisibility", function () { return $3aade048a6a44afa$export$5c64e593c0ce10f0; });

var $1oC0p = parcelRequire("1oC0p");
const $3aade048a6a44afa$var$INTERSECTION_THRESHOLD = 0.3;
function $3aade048a6a44afa$export$5c64e593c0ce10f0(containerRef, replayOnVisible) {
    const [hasBeenVisible, setHasBeenVisible] = (0, $1oC0p.useState)(false);
    const [isCurrentlyVisible, setIsCurrentlyVisible] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(([entry])=>{
            if (!entry) return;
            setIsCurrentlyVisible(entry.isIntersecting);
            if (entry.isIntersecting) setHasBeenVisible(true);
        }, {
            threshold: $3aade048a6a44afa$var$INTERSECTION_THRESHOLD
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        containerRef
    ]);
    return {
        isVisible: replayOnVisible ? isCurrentlyVisible : hasBeenVisible,
        isCurrentlyVisible: isCurrentlyVisible
    };
}

});

parcelRegister("ldiHh", function(module, exports) {
$parcel$export(module.exports, "anyNodeHasPhases", function () { return $bb5461f936702316$export$5343c19e01c17c38; });
$parcel$export(module.exports, "useSpiderwebPhasePositions", function () { return $bb5461f936702316$export$f63a5d7448e5031b; });

var $1oC0p = parcelRequire("1oC0p");

var $fVNxT = parcelRequire("fVNxT");

var $8uyM5 = parcelRequire("8uyM5");

var $hNner = parcelRequire("hNner");
function $bb5461f936702316$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function $bb5461f936702316$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
function $bb5461f936702316$var$clampMinSize(v) {
    return Math.max(1, v);
}
function $bb5461f936702316$var$dimsForSize(node, sz) {
    return (0, $hNner.getNodeLayoutDimensions)({
        ...node,
        size: sz
    });
}
function $bb5461f936702316$export$e7b17d4d0ffa305d(node, baseX, baseY, baseOpacity, phases, t) {
    const o0 = $bb5461f936702316$var$clamp01(baseOpacity);
    if (!phases?.length) return {
        x: baseX,
        y: baseY,
        opacity: o0
    };
    const bases = (0, $hNner.getNodeLayoutDimensions)(node);
    let x = baseX;
    let y = baseY;
    let opacity = o0;
    let sz = bases.size;
    let bw = bases.boxWidth;
    let bh = bases.boxHeight;
    let tAcc = 0;
    for (const p of phases){
        const holdEnd = tAcc + (p?.delay ?? 0);
        if (t < holdEnd) return {
            x: x,
            y: y,
            opacity: opacity,
            size: sz,
            width: bw,
            height: bh
        };
        tAcc = holdEnd;
        const moveEnd = tAcc + (p?.duration ?? 0);
        const opacityStart = opacity;
        const opacityEnd = p.opacity !== undefined ? $bb5461f936702316$var$clamp01(p.opacity) : opacity;
        const szStart = sz;
        const bwStart = bw;
        const bhStart = bh;
        const szEnd = p.size !== undefined ? $bb5461f936702316$var$clampMinSize(p.size) : szStart;
        const bwEnd = p.width !== undefined ? p.width : p.size !== undefined ? $bb5461f936702316$var$dimsForSize(node, szEnd).boxWidth : bwStart;
        const bhEnd = p.height !== undefined ? p.height : p.size !== undefined ? $bb5461f936702316$var$dimsForSize(node, szEnd).boxHeight : bhStart;
        if (t < moveEnd) {
            const u = (p?.duration ?? 0) > 0 ? (t - tAcc) / (p?.duration ?? 0) : 1;
            const e = $bb5461f936702316$var$easeInOutCubic(Math.min(1, Math.max(0, u)));
            const szMid = szStart + (szEnd - szStart) * e;
            const opacityMid = opacityStart + (opacityEnd - opacityStart) * e;
            const xEnd = p.x !== undefined ? p.x : x;
            const yEnd = p.y !== undefined ? p.y : y;
            let bwMid;
            if (p.width !== undefined) bwMid = bwStart + (bwEnd - bwStart) * e;
            else if (p.size !== undefined) bwMid = $bb5461f936702316$var$dimsForSize(node, szMid).boxWidth;
            else bwMid = bwStart;
            let bhMid;
            if (p.height !== undefined) bhMid = bhStart + (bhEnd - bhStart) * e;
            else if (p.size !== undefined) bhMid = $bb5461f936702316$var$dimsForSize(node, szMid).boxHeight;
            else bhMid = bhStart;
            return {
                x: x + (xEnd - x) * e,
                y: y + (yEnd - y) * e,
                opacity: opacityMid,
                size: szMid,
                width: bwMid,
                height: bhMid
            };
        }
        tAcc = moveEnd;
        x = p.x !== undefined ? p.x : x;
        y = p.y !== undefined ? p.y : y;
        opacity = opacityEnd;
        sz = szEnd;
        bw = bwEnd;
        bh = bhEnd;
    }
    return {
        x: x,
        y: y,
        opacity: opacity,
        size: sz,
        width: bw,
        height: bh
    };
}
function $bb5461f936702316$export$9e4cfa56a09d0b34(phases) {
    if (!phases?.length) return 0;
    if ((0, $fVNxT.animationPhasesUseScrollWindows)(phases)) return Math.max(0, ...phases.map((p)=>p.scrollWindowEnd ?? 0));
    let total = 0;
    for (const p of phases)total += p.delay + p.duration;
    return total;
}
function $bb5461f936702316$export$5343c19e01c17c38(nodes) {
    return nodes.some((n)=>n.animationPhases?.length);
}
function $bb5461f936702316$export$f63a5d7448e5031b(nodes, active, phaseClockStartOffsetSec, animationsPaused, options) {
    const drive = options?.drive ?? 'time';
    const scrollProgress = options?.scrollProgress ?? 0;
    const baseMap = (0, $1oC0p.useMemo)(()=>{
        const m = new Map();
        for (const n of nodes)m.set(n.id, {
            x: n.x,
            y: n.y,
            opacity: $bb5461f936702316$var$clamp01(n.opacity ?? 1)
        });
        return m;
    }, [
        nodes
    ]);
    const hasPhases = (0, $1oC0p.useMemo)(()=>$bb5461f936702316$export$5343c19e01c17c38(nodes), [
        nodes
    ]);
    const maxDurationSec = (0, $1oC0p.useMemo)(()=>{
        let max = 0;
        for (const n of nodes)max = Math.max(max, $bb5461f936702316$export$9e4cfa56a09d0b34(n.animationPhases));
        return max;
    }, [
        nodes
    ]);
    const [liveMap, setLiveMap] = (0, $1oC0p.useState)(()=>baseMap);
    (0, $1oC0p.useEffect)(()=>{
        setLiveMap(new Map(baseMap));
    }, [
        baseMap
    ]);
    const pausedRef = (0, $1oC0p.useRef)(animationsPaused);
    pausedRef.current = animationsPaused;
    const frozenScrollProgressRef = (0, $1oC0p.useRef)(0);
    const wasAnimationPausedRef = (0, $1oC0p.useRef)(false);
    const [scrollPauseEpoch, setScrollPauseEpoch] = (0, $1oC0p.useState)(0);
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (drive !== 'scroll') return;
        if (animationsPaused && !wasAnimationPausedRef.current) {
            frozenScrollProgressRef.current = scrollProgress;
            setScrollPauseEpoch((e)=>e + 1);
        }
        wasAnimationPausedRef.current = animationsPaused;
    }, [
        drive,
        animationsPaused,
        scrollProgress
    ]);
    const effectiveScrollProgress = drive === 'scroll' && animationsPaused ? frozenScrollProgressRef.current : scrollProgress;
    const scrollDerivedMap = (0, $1oC0p.useMemo)(()=>{
        if (drive !== 'scroll' || !active || !hasPhases) return baseMap;
        const m = new Map();
        const scrollPercent100 = effectiveScrollProgress * 100;
        for (const n of nodes){
            (0, $fVNxT.assertConsistentScrollWindows)(n.id, n.animationPhases);
            const phases = n.animationPhases;
            if ((0, $fVNxT.animationPhasesUseScrollWindows)(phases)) m.set(n.id, (0, $fVNxT.getLayoutAtScrollWindows)(n, n.x, n.y, n.opacity ?? 1, phases || [], scrollPercent100));
            else {
                const t = effectiveScrollProgress * (0, $8uyM5.ANIMATION_PHASES_SCROLL_TIMELINE_UNITS_DEFAULT);
                m.set(n.id, $bb5461f936702316$export$e7b17d4d0ffa305d(n, n.x, n.y, n.opacity ?? 1, phases, t));
            }
        }
        return m;
    }, [
        drive,
        active,
        hasPhases,
        nodes,
        baseMap,
        effectiveScrollProgress,
        scrollProgress,
        animationsPaused,
        scrollPauseEpoch
    ]);
    const timelineStartMsRef = (0, $1oC0p.useRef)(null);
    const pauseClockRef = (0, $1oC0p.useRef)({
        totalPausedMs: 0,
        segmentStartMs: null
    });
    const lastNodesKeyRef = (0, $1oC0p.useRef)('');
    (0, $1oC0p.useEffect)(()=>{
        if (drive !== 'time' || !active || !hasPhases) return;
        const applyLayouts = (elapsedSec)=>{
            const m = new Map();
            const scrollPctFromTime = maxDurationSec > 0 ? Math.min(100, elapsedSec / maxDurationSec * 100) : 0;
            for (const n of nodes){
                const phases = n.animationPhases;
                const layout = (0, $fVNxT.animationPhasesUseScrollWindows)(phases) && phases?.length ? (0, $fVNxT.getLayoutAtScrollWindows)(n, n.x, n.y, n.opacity ?? 1, phases, scrollPctFromTime) : $bb5461f936702316$export$e7b17d4d0ffa305d(n, n.x, n.y, n.opacity ?? 1, phases, elapsedSec);
                m.set(n.id, layout);
            }
            setLiveMap(m);
        };
        if (maxDurationSec <= 0) {
            applyLayouts(0);
            return;
        }
        const nodesKey = nodes.map((n)=>n.id).join('|');
        if (lastNodesKeyRef.current !== nodesKey) {
            lastNodesKeyRef.current = nodesKey;
            timelineStartMsRef.current = null;
            pauseClockRef.current = {
                totalPausedMs: 0,
                segmentStartMs: null
            };
        }
        if (timelineStartMsRef.current === null) timelineStartMsRef.current = performance.now();
        const start = timelineStartMsRef.current;
        let frame = 0;
        const offset = Math.max(0, phaseClockStartOffsetSec);
        const tick = ()=>{
            const pc = pauseClockRef.current;
            if (pausedRef.current) {
                if (pc.segmentStartMs === null) pc.segmentStartMs = performance.now();
            } else if (pc.segmentStartMs !== null) {
                pc.totalPausedMs += performance.now() - pc.segmentStartMs;
                pc.segmentStartMs = null;
            }
            let extraPauseMs = pc.totalPausedMs;
            if (pausedRef.current && pc.segmentStartMs !== null) extraPauseMs += performance.now() - pc.segmentStartMs;
            const wallSec = (performance.now() - start - extraPauseMs) / 1000;
            const phaseSec = Math.max(0, wallSec - offset);
            applyLayouts(phaseSec);
            const done = phaseSec >= maxDurationSec + 0.016;
            if (done) return;
            if (pausedRef.current) return;
            frame = requestAnimationFrame(tick);
        };
        frame = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(frame);
    }, [
        drive,
        active,
        hasPhases,
        maxDurationSec,
        nodes,
        phaseClockStartOffsetSec,
        animationsPaused
    ]);
    if (!active || !hasPhases) return baseMap;
    if (drive === 'scroll') return scrollDerivedMap;
    return liveMap;
}

});
parcelRegister("fVNxT", function(module, exports) {
$parcel$export(module.exports, "assertConsistentScrollWindows", function () { return $33c93afd8b1ce3e2$export$b59b19c04e0cd254; });
$parcel$export(module.exports, "animationPhasesUseScrollWindows", function () { return $33c93afd8b1ce3e2$export$bdca61665be3badc; });
$parcel$export(module.exports, "getLayoutAtScrollWindows", function () { return $33c93afd8b1ce3e2$export$11bc621456d0053f; });

var $hNner = parcelRequire("hNner");
function $33c93afd8b1ce3e2$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function $33c93afd8b1ce3e2$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
function $33c93afd8b1ce3e2$var$clampMinSize(v) {
    return Math.max(1, v);
}
function $33c93afd8b1ce3e2$var$dimsForSize(node, sz) {
    return (0, $hNner.getNodeLayoutDimensions)({
        ...node,
        size: sz
    });
}
function $33c93afd8b1ce3e2$export$b59b19c04e0cd254(nodeId, phases) {
    if (!phases?.length) return;
    const anyMarked = phases.some((p)=>p.scrollWindowStart !== undefined || p.scrollWindowEnd !== undefined);
    if (!anyMarked) return;
    if (!$33c93afd8b1ce3e2$export$bdca61665be3badc(phases)) throw new Error(`SpiderWeb node "${nodeId}": set scrollWindowStart and scrollWindowEnd on every phase, or on none.`);
}
function $33c93afd8b1ce3e2$export$bdca61665be3badc(phases) {
    if (!phases?.length) return false;
    return phases.every((p)=>p.scrollWindowStart !== undefined && p.scrollWindowEnd !== undefined);
}
function $33c93afd8b1ce3e2$export$a83e3b3235ff3c93(scrollWindowStart, scrollWindowEnd, target) {
    return {
        delay: 0,
        duration: 0,
        scrollWindowStart: scrollWindowStart,
        scrollWindowEnd: scrollWindowEnd,
        ...target.x !== undefined ? {
            x: target.x
        } : {},
        ...target.y !== undefined ? {
            y: target.y
        } : {},
        ...target.opacity !== undefined ? {
            opacity: target.opacity
        } : {},
        ...target.size !== undefined ? {
            size: target.size
        } : {},
        ...target.width !== undefined ? {
            width: target.width
        } : {},
        ...target.height !== undefined ? {
            height: target.height
        } : {}
    };
}
function $33c93afd8b1ce3e2$export$11bc621456d0053f(node, baseX, baseY, baseOpacity, phases, scrollPercent100) {
    const o0 = $33c93afd8b1ce3e2$var$clamp01(baseOpacity);
    const bases = (0, $hNner.getNodeLayoutDimensions)(node);
    let x = baseX;
    let y = baseY;
    let opacity = o0;
    let sz = bases.size;
    let bw = bases.boxWidth;
    let bh = bases.boxHeight;
    const sorted = [
        ...phases
    ].sort((a, b)=>(a.scrollWindowStart ?? 0) - (b.scrollWindowStart ?? 0));
    for (const p of sorted){
        const ws = p.scrollWindowStart ?? 0;
        const we = p.scrollWindowEnd ?? 0;
        if (we <= ws) continue;
        if (scrollPercent100 < ws) return {
            x: x,
            y: y,
            opacity: opacity,
            size: sz,
            width: bw,
            height: bh
        };
        const opacityStart = opacity;
        const opacityEnd = p.opacity !== undefined ? $33c93afd8b1ce3e2$var$clamp01(p.opacity) : opacity;
        const szStart = sz;
        const bwStart = bw;
        const bhStart = bh;
        const szEnd = p.size !== undefined ? $33c93afd8b1ce3e2$var$clampMinSize(p.size) : szStart;
        const bwEnd = p.width !== undefined ? p.width : p.size !== undefined ? $33c93afd8b1ce3e2$var$dimsForSize(node, szEnd).boxWidth : bwStart;
        const bhEnd = p.height !== undefined ? p.height : p.size !== undefined ? $33c93afd8b1ce3e2$var$dimsForSize(node, szEnd).boxHeight : bhStart;
        if (scrollPercent100 < we) {
            const span = we - ws;
            const u = span > 0 ? (scrollPercent100 - ws) / span : 1;
            const e = $33c93afd8b1ce3e2$var$easeInOutCubic(Math.min(1, Math.max(0, u)));
            const szMid = szStart + (szEnd - szStart) * e;
            const opacityMid = opacityStart + (opacityEnd - opacityStart) * e;
            const xEnd = p.x !== undefined ? p.x : x;
            const yEnd = p.y !== undefined ? p.y : y;
            let bwMid;
            if (p.width !== undefined) bwMid = bwStart + (bwEnd - bwStart) * e;
            else if (p.size !== undefined) bwMid = $33c93afd8b1ce3e2$var$dimsForSize(node, szMid).boxWidth;
            else bwMid = bwStart;
            let bhMid;
            if (p.height !== undefined) bhMid = bhStart + (bhEnd - bhStart) * e;
            else if (p.size !== undefined) bhMid = $33c93afd8b1ce3e2$var$dimsForSize(node, szMid).boxHeight;
            else bhMid = bhStart;
            return {
                x: x + (xEnd - x) * e,
                y: y + (yEnd - y) * e,
                opacity: opacityMid,
                size: szMid,
                width: bwMid,
                height: bhMid
            };
        }
        x = p.x !== undefined ? p.x : x;
        y = p.y !== undefined ? p.y : y;
        opacity = opacityEnd;
        sz = szEnd;
        bw = bwEnd;
        bh = bhEnd;
    }
    return {
        x: x,
        y: y,
        opacity: opacity,
        size: sz,
        width: bw,
        height: bh
    };
}

});

parcelRegister("8uyM5", function(module, exports) {
$parcel$export(module.exports, "ANIMATION_PHASES_SCROLL_TIMELINE_UNITS_DEFAULT", function () { return $c8cbf9fc738b688c$export$c4b0c59bc522bccc; });
const $c8cbf9fc738b688c$export$e787a4c2b0ebce40 = [
    'white',
    'black',
    'secondarynavy',
    'secondarygreen',
    'secondaryred',
    'transparent',
    'blue100',
    'blue200',
    'blue300',
    'blue400',
    'blue500',
    'blue600',
    'blue700',
    'blue800',
    'blue900',
    'lime100',
    'lime200',
    'lime300',
    'lime400',
    'lime500',
    'lime600',
    'lime700',
    'lime800',
    'lime900',
    'neutral100',
    'neutral200',
    'neutral300',
    'neutral400',
    'neutral500',
    'neutral600',
    'neutral700',
    'neutral800',
    'neutral900',
    'neutral1000',
    'neutral1100',
    'orange100',
    'orange200',
    'orange300',
    'orange400',
    'orange500',
    'orange600',
    'orange700',
    'orange800',
    'orange900',
    'purple100',
    'purple200',
    'purple300',
    'purple400',
    'purple500',
    'purple600',
    'purple700',
    'purple800',
    'purple900',
    'saffron100',
    'saffron200',
    'saffron300',
    'saffron400',
    'saffron500',
    'saffron600',
    'saffron700',
    'saffron800',
    'saffron900',
    'yellow100',
    'yellow200',
    'yellow300',
    'yellow400',
    'yellow500',
    'yellow600',
    'yellow700',
    'yellow800',
    'yellow900'
];
const $c8cbf9fc738b688c$export$c4b0c59bc522bccc = 100;

});


parcelRegister("29NYv", function(module, exports) {
$parcel$export(module.exports, "useSpiderWebReducedMotion", function () { return $ff75bf1daecde24a$export$6bfdea9e4d732151; });

var $1oC0p = parcelRequire("1oC0p");
function $ff75bf1daecde24a$export$6bfdea9e4d732151() {
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        setPrefersReducedMotion(mq.matches);
        const handler = (e)=>setPrefersReducedMotion(e.matches);
        mq.addEventListener('change', handler);
        return ()=>mq.removeEventListener('change', handler);
    }, []);
    return prefersReducedMotion;
}

});

parcelRegister("hiPUj", function(module, exports) {
$parcel$export(module.exports, "useSpiderwebScrollMagnet", function () { return $b2d50ed954fc873c$export$c86862ef68734dc4; });

var $1oC0p = parcelRequire("1oC0p");

var $7h9Nf = parcelRequire("7h9Nf");
function $b2d50ed954fc873c$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
function $b2d50ed954fc873c$export$bd5ac7dcb10bc8e2(raw) {
    if (!raw?.length) return [];
    const roundedKeys = new Set();
    const out = [];
    for (const x of raw){
        if (!Number.isFinite(x)) continue;
        const pct = Math.min(100, Math.max(0, x));
        const c = $b2d50ed954fc873c$var$clamp01(pct / 100);
        const key = Math.round(c * 1e5);
        if (roundedKeys.has(key)) continue;
        roundedKeys.add(key);
        out.push(c);
    }
    out.sort((a, b)=>a - b);
    return out;
}
function $b2d50ed954fc873c$export$ebd5525c2b6f70e(progress, anchors) {
    if (anchors.length === 0) return null;
    const p = $b2d50ed954fc873c$var$clamp01(progress);
    const firstAtOrAhead = anchors.find((a)=>a >= p);
    if (firstAtOrAhead !== undefined) return firstAtOrAhead;
    const tail = anchors.at(-1);
    return tail === undefined ? null : tail;
}
function $b2d50ed954fc873c$var$pickNearestByMetric(values, metric) {
    const first = values[0];
    if (first === undefined) return undefined;
    let best = first;
    let bestM = metric(best);
    for(let i = 1; i < values.length; i++){
        const v = values[i];
        if (v === undefined) continue;
        const m = metric(v);
        if (m < bestM) {
            bestM = m;
            best = v;
        }
    }
    return best;
}
function $b2d50ed954fc873c$export$262742de863515b3(progress, anchors, lastScrollDeltaPx, scrollDeadbandPx, directionBias) {
    if (anchors.length === 0) return null;
    const p = $b2d50ed954fc873c$var$clamp01(progress);
    const dead = scrollDeadbandPx;
    const ahead = anchors.filter((a)=>a > p);
    const behind = anchors.filter((a)=>a < p);
    if (lastScrollDeltaPx > dead) {
        const pick = $b2d50ed954fc873c$var$pickNearestByMetric(ahead, (a)=>a - p);
        if (pick !== undefined) return pick;
        const tail = anchors.at(-1);
        return tail === undefined ? null : tail;
    }
    if (lastScrollDeltaPx < -dead) {
        const pick = $b2d50ed954fc873c$var$pickNearestByMetric(behind, (a)=>p - a);
        if (pick !== undefined) return pick;
        return anchors[0] ?? null;
    }
    const normalizedDirectionBias = $b2d50ed954fc873c$var$clamp01(directionBias);
    const oppositeDirectionPenalty = 1 + normalizedDirectionBias * 8;
    const pick = $b2d50ed954fc873c$var$pickNearestByMetric(anchors, (a)=>{
        const delta = a - p;
        const absDelta = Math.abs(delta);
        if (lastScrollDeltaPx > 0 && delta < 0) return absDelta * oppositeDirectionPenalty;
        if (lastScrollDeltaPx < 0 && delta > 0) return absDelta * oppositeDirectionPenalty;
        return absDelta;
    });
    return pick === undefined ? null : pick;
}
function $b2d50ed954fc873c$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function $b2d50ed954fc873c$var$getScrollMagnetEndpoints(section, scrollContainer, progress) {
    const p = $b2d50ed954fc873c$var$clamp01(progress);
    if (scrollContainer) {
        const maxScroll = Math.max(0, scrollContainer.scrollHeight - scrollContainer.clientHeight);
        if (maxScroll <= 1) return null;
        return {
            mode: 'element',
            el: scrollContainer,
            startTop: scrollContainer.scrollTop,
            endTop: p * maxScroll
        };
    }
    const trackH = section.offsetHeight;
    const viewH = window.innerHeight;
    const scrollable = trackH - viewH;
    if (scrollable <= 1) return null;
    const rect = section.getBoundingClientRect();
    const endY = window.scrollY + rect.top + p * scrollable;
    return {
        mode: 'window',
        startY: window.scrollY,
        endY: Math.max(0, endY)
    };
}
function $b2d50ed954fc873c$var$runScrollMagnetEase(endpoints, durationMs, isCancelled, onRafScheduled, onRafCleared) {
    const startTime = performance.now();
    const step = ()=>{
        if (isCancelled()) {
            onRafCleared();
            return;
        }
        const now = performance.now();
        const t = Math.min(1, (now - startTime) / durationMs);
        const e = $b2d50ed954fc873c$var$easeInOutCubic(t);
        if (endpoints.mode === 'window') {
            const y = endpoints.startY + (endpoints.endY - endpoints.startY) * e;
            window.scrollTo(0, y);
        } else {
            const top = endpoints.startTop + (endpoints.endTop - endpoints.startTop) * e;
            endpoints.el.scrollTop = top;
        }
        if (t < 1) onRafScheduled(requestAnimationFrame(step));
        else onRafCleared();
    };
    onRafScheduled(requestAnimationFrame(step));
}
const $b2d50ed954fc873c$var$DEFAULT_MIN_DELTA = 0.004;
/** No `scroll` events for this long before we consider a settle (ms). */ const $b2d50ed954fc873c$var$DEFAULT_SETTLE_MS = 200;
const $b2d50ed954fc873c$var$DEFAULT_SUPPRESS_MS = 380;
/** Eased magnet scroll; a bit longer than typical native `smooth` scrolling. */ const $b2d50ed954fc873c$var$DEFAULT_MAGNET_DURATION_MS = 2000;
const $b2d50ed954fc873c$var$DEFAULT_DIRECTION_DEADBAND_PX = 2;
const $b2d50ed954fc873c$var$DEFAULT_DIRECTION_BIAS = 0;
function $b2d50ed954fc873c$export$c86862ef68734dc4(sectionRef, { enabled: enabled, anchors: anchors, minProgressDelta: minProgressDelta = $b2d50ed954fc873c$var$DEFAULT_MIN_DELTA, settleDebounceMs: settleDebounceMs = $b2d50ed954fc873c$var$DEFAULT_SETTLE_MS, suppressSettleMs: suppressSettleMs = $b2d50ed954fc873c$var$DEFAULT_SUPPRESS_MS, scrollMagnetDurationMs: scrollMagnetDurationMs = $b2d50ed954fc873c$var$DEFAULT_MAGNET_DURATION_MS, scrollMagnetDirectionDeadbandPx: scrollMagnetDirectionDeadbandPx = $b2d50ed954fc873c$var$DEFAULT_DIRECTION_DEADBAND_PX, scrollMagnetDirectionBias: scrollMagnetDirectionBias = $b2d50ed954fc873c$var$DEFAULT_DIRECTION_BIAS }) {
    const anchorsKey = (0, $1oC0p.useMemo)(()=>anchors === undefined || anchors.length === 0 ? '' : anchors.map((a)=>Number(a).toFixed(5)).join('|'), [
        anchors
    ]);
    const normalizedAnchors = (0, $1oC0p.useMemo)(()=>{
        if (anchorsKey === '') return [];
        const parsed = anchorsKey.split('|').map((s)=>Number(s));
        return $b2d50ed954fc873c$export$bd5ac7dcb10bc8e2(parsed);
    }, [
        anchorsKey
    ]);
    const minDeltaRef = (0, $1oC0p.useRef)(minProgressDelta);
    const settleMsRef = (0, $1oC0p.useRef)(settleDebounceMs);
    const suppressMsRef = (0, $1oC0p.useRef)(suppressSettleMs);
    const durationMsRef = (0, $1oC0p.useRef)(scrollMagnetDurationMs);
    const directionDeadbandPxRef = (0, $1oC0p.useRef)(scrollMagnetDirectionDeadbandPx);
    const directionBiasRef = (0, $1oC0p.useRef)(scrollMagnetDirectionBias);
    minDeltaRef.current = minProgressDelta;
    settleMsRef.current = settleDebounceMs;
    suppressMsRef.current = suppressSettleMs;
    durationMsRef.current = scrollMagnetDurationMs;
    directionDeadbandPxRef.current = scrollMagnetDirectionDeadbandPx;
    directionBiasRef.current = scrollMagnetDirectionBias;
    (0, $1oC0p.useEffect)(()=>{
        if (!enabled || !sectionRef || normalizedAnchors.length === 0 || minProgressDelta <= 0) return;
        let cancelled = false;
        let pollRafId = 0;
        let detach;
        let settleTimerId = 0;
        let suppressUntil = 0;
        let settleVerifyRafId = 0;
        const attach = (section)=>{
            const scrollContainer = (0, $7h9Nf.getNearestVerticalScrollContainer)(section);
            let magnetAnimRaf = 0;
            let lastScrollYForIntent = scrollContainer ? scrollContainer.scrollTop : window.scrollY;
            let lastIntentScrollDeltaPx = 0;
            const getScrollY = ()=>scrollContainer ? scrollContainer.scrollTop : window.scrollY;
            const clearMagnetAnim = ()=>{
                if (magnetAnimRaf !== 0) {
                    cancelAnimationFrame(magnetAnimRaf);
                    magnetAnimRaf = 0;
                }
            };
            const tryMagnet = ()=>{
                if (cancelled || performance.now() < suppressUntil) return;
                const p = (0, $7h9Nf.computeDocumentSectionScrollProgress)(section, scrollContainer);
                const minD = minDeltaRef.current;
                for (const a of normalizedAnchors){
                    if (Math.abs(a - p) < minD) return;
                }
                const target = $b2d50ed954fc873c$export$262742de863515b3(p, normalizedAnchors, lastIntentScrollDeltaPx, directionDeadbandPxRef.current, directionBiasRef.current);
                if (target === null) return;
                const endpoints = $b2d50ed954fc873c$var$getScrollMagnetEndpoints(section, scrollContainer, target);
                if (!endpoints) return;
                const durationMs = Math.max(120, durationMsRef.current);
                const startPx = endpoints.mode === 'window' ? endpoints.startY : endpoints.startTop;
                const endPx = endpoints.mode === 'window' ? endpoints.endY : endpoints.endTop;
                if (Math.abs(endPx - startPx) < 0.5) return;
                clearMagnetAnim();
                suppressUntil = performance.now() + durationMs + Math.max(120, suppressMsRef.current);
                $b2d50ed954fc873c$var$runScrollMagnetEase(endpoints, durationMs, ()=>cancelled, (id)=>{
                    magnetAnimRaf = id;
                }, ()=>{
                    magnetAnimRaf = 0;
                });
            };
            const scheduleSettle = ()=>{
                if (cancelled) return;
                if (settleVerifyRafId !== 0) {
                    cancelAnimationFrame(settleVerifyRafId);
                    settleVerifyRafId = 0;
                }
                if (performance.now() < suppressUntil) {
                    window.clearTimeout(settleTimerId);
                    settleTimerId = 0;
                    return;
                }
                window.clearTimeout(settleTimerId);
                settleTimerId = window.setTimeout(()=>{
                    settleTimerId = 0;
                    const yIdle = getScrollY();
                    settleVerifyRafId = requestAnimationFrame(()=>{
                        settleVerifyRafId = 0;
                        if (cancelled || performance.now() < suppressUntil) return;
                        if (Math.abs(getScrollY() - yIdle) > 0.5) return;
                        tryMagnet();
                    });
                }, settleMsRef.current);
            };
            const onScroll = ()=>{
                const y = getScrollY();
                if (performance.now() < suppressUntil) lastScrollYForIntent = y;
                else {
                    const delta = y - lastScrollYForIntent;
                    lastScrollYForIntent = y;
                    const db = directionDeadbandPxRef.current;
                    if (Math.abs(delta) >= db) lastIntentScrollDeltaPx = delta;
                }
                scheduleSettle();
            };
            const scrollTarget = scrollContainer ?? window;
            scrollTarget.addEventListener('scroll', onScroll, {
                passive: true
            });
            detach = ()=>{
                window.clearTimeout(settleTimerId);
                settleTimerId = 0;
                if (settleVerifyRafId !== 0) {
                    cancelAnimationFrame(settleVerifyRafId);
                    settleVerifyRafId = 0;
                }
                clearMagnetAnim();
                scrollTarget.removeEventListener('scroll', onScroll);
            };
        };
        const el = sectionRef.current;
        if (el) {
            attach(el);
            return ()=>{
                cancelled = true;
                detach?.();
            };
        }
        const poll = ()=>{
            if (cancelled) return;
            const node = sectionRef.current;
            if (node) {
                attach(node);
                return;
            }
            pollRafId = requestAnimationFrame(poll);
        };
        pollRafId = requestAnimationFrame(poll);
        return ()=>{
            cancelled = true;
            cancelAnimationFrame(pollRafId);
            detach?.();
        };
    }, [
        enabled,
        normalizedAnchors,
        sectionRef
    ]);
}

});

parcelRegister("gHYtp", function(module, exports) {
$parcel$export(module.exports, "useSpiderwebViewportAspect", function () { return $fd0a2876732bc244$export$a8bf72a0ed443cbd; });

var $1oC0p = parcelRequire("1oC0p");
const $fd0a2876732bc244$var$IDENTITY = {
    scaleX: 1,
    scaleY: 1
};
function $fd0a2876732bc244$var$computeCorrection(w, h) {
    if (w <= 0 || h <= 0) return $fd0a2876732bc244$var$IDENTITY;
    return {
        scaleX: Math.sqrt(h / w),
        scaleY: Math.sqrt(w / h)
    };
}
function $fd0a2876732bc244$export$a8bf72a0ed443cbd(active, sizeSourceRef) {
    const [dims, setDims] = (0, $1oC0p.useState)(()=>typeof window !== 'undefined' ? {
            w: window.innerWidth,
            h: window.innerHeight
        } : {
            w: 1,
            h: 1
        });
    (0, $1oC0p.useEffect)(()=>{
        if (!active) return;
        if (!sizeSourceRef) {
            const update = ()=>setDims({
                    w: window.innerWidth,
                    h: window.innerHeight
                });
            update();
            window.addEventListener('resize', update);
            return ()=>window.removeEventListener('resize', update);
        }
        const measure = ()=>{
            const el = sizeSourceRef.current;
            if (!el) return;
            const w = el.clientWidth;
            const h = el.clientHeight;
            setDims((prev)=>prev.w === w && prev.h === h ? prev : {
                    w: w,
                    h: h
                });
        };
        const el = sizeSourceRef.current;
        if (!el) return;
        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(el);
        return ()=>{
            ro.disconnect();
        };
    }, [
        active,
        sizeSourceRef
    ]);
    return (0, $1oC0p.useMemo)(()=>active ? $fd0a2876732bc244$var$computeCorrection(dims.w, dims.h) : $fd0a2876732bc244$var$IDENTITY, [
        active,
        dims.w,
        dims.h
    ]);
}

});




parcelRegister("6JkkA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c1fa0ef514a5e9e$export$2e2bcd8739ae039; });
/* image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");
const $5c1fa0ef514a5e9e$var$UniformImage = ({ source: source, altText: altText = '', width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false })=>{
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null;
    // @ts-ignore
    const responsiveStyles = null;
    const makeCircleStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: source,
            alt: altText
        },
        className: (0, $2jatx.default)([
            width && "_1bsbydm4",
            height && "_4t3i1j6h",
            tabletWidth && "_14b56k1b",
            desktopWidth && "_gltenwv8",
            tabletHeight && "_1xlo1phk",
            desktopHeight && "_165to2tq",
            makeCircle && "_2rko1ssb"
        ]),
        style: {
            ...imageStyle,
            "--_ad5ho1": (0, $6ZVlx.default)(width ? width : 'auto'),
            "--_13eytri": (0, $6ZVlx.default)(height ? height : 'auto'),
            "--_glhwna": (0, $6ZVlx.default)(tabletWidth ? tabletWidth : 'auto'),
            "--_l1cbh": (0, $6ZVlx.default)(desktopWidth ? desktopWidth : 'auto'),
            "--_1cb1a05": (0, $6ZVlx.default)(tabletHeight ? tabletHeight : 'auto'),
            "--_1ls2h32": (0, $6ZVlx.default)(desktopHeight ? desktopHeight : 'auto')
        }
    });
};
var $5c1fa0ef514a5e9e$export$2e2bcd8739ae039 = $5c1fa0ef514a5e9e$var$UniformImage;

});

parcelRegister("3jkl6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26110392bbc93120$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $lAAJP = parcelRequire("lAAJP");

var $ifNiy = parcelRequire("ifNiy");

var $3OVYv = parcelRequire("3OVYv");

var $lTkkF = parcelRequire("lTkkF");

var $i4BST = parcelRequire("i4BST");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $26110392bbc93120$var$UniformIntegration = (props)=>{
    const { eyebrow: eyebrow, title: title, titleAs: titleAs, titleAppearsAs: titleAppearsAs, body: body, richText: richText, linkLabel: linkLabel, linkHref: linkHref, logos: logos, clickableLogos: clickableLogos, background: background, backgroundColor: backgroundColor, flipLayout: flipLayout } = (0, $lAAJP.flattenLogoProps)(props);
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    if (isWacRefresh) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3OVYv.Integration), {
        title: title,
        titleAs: titleAs,
        titleAppearsAs: titleAppearsAs,
        body: richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: richText
        }) : body,
        linkLabel: linkLabel,
        linkHref: linkHref,
        linkDataEventProps: {
            'data-product-key': 'uniform',
            'data-event': 'clicked',
            'data-event-component': 'linkButton',
            'data-event-container': 'integrationsSection'
        },
        logoLinkDataEventProps: {
            'data-product-key': 'uniform',
            'data-event': 'clicked',
            'data-event-component': 'linkLogo',
            'data-event-container': 'integrationsSection'
        },
        clickableLogos: clickableLogos,
        logos: logos
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ifNiy.Integration), {
        eyebrow: eyebrow,
        title: title,
        titleAs: titleAs,
        titleAppearsAs: titleAppearsAs,
        body: richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: richText
        }) : body,
        linkLabel: linkLabel,
        linkHref: linkHref,
        linkDataEventProps: {
            'data-product-key': 'uniform',
            'data-event': 'clicked',
            'data-event-component': 'linkButton',
            'data-event-container': 'integrationsSection'
        },
        logoLinkDataEventProps: {
            'data-product-key': 'uniform',
            'data-event': 'clicked',
            'data-event-component': 'linkLogo',
            'data-event-container': 'integrationsSection'
        },
        logos: logos,
        background: background,
        backgroundColor: backgroundColor,
        flipLayout: flipLayout
    });
};
var $26110392bbc93120$export$2e2bcd8739ae039 = $26110392bbc93120$var$UniformIntegration;

});
parcelRegister("lAAJP", function(module, exports) {
$parcel$export(module.exports, "flattenLogoProps", function () { return $a69aeb5889de0c02$export$ffc5469ebe0e6998; });

var $f2QWG = parcelRequire("f2QWG");
const $a69aeb5889de0c02$export$ffc5469ebe0e6998 = (props)=>{
    return {
        ...props,
        logos: (0, $f2QWG.flattenValues)(props.logos)
    };
};

});

parcelRegister("ifNiy", function(module, exports) {
$parcel$export(module.exports, "Integration", function () { return $945afc5e0498e2e0$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2axoc = parcelRequire("2axoc");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $945afc5e0498e2e0$var$logoSizes = {
    regular: {
        size: '78px',
        cornerRadius: '18.7px'
    },
    large: {
        size: '100px',
        cornerRadius: '24px'
    }
};
const $945afc5e0498e2e0$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImageContainerStyles = null;
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1bsbcae7 _4t3icae7 _bfhk1afi _19itn5xp _2rko13r7 _gltef22m _165tf22m _2oz41w8s _1dbz130s"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
            "--_1jpuyj7": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].size),
            "--_1k7rxgg": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].cornerRadius)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: props.href,
            ...props.dataEventProps ?? {},
            className: (0, $2jatx.default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq _4cvr1h6o _1bah1h6o _1yt4u2gc"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1lze _4t3i1hr2"
                ]),
                style: {
                    "--_1yc6jpm": (0, $6ZVlx.default)(props.width ? `${props.width}px` : '100%'),
                    "--_15ph59j": (0, $6ZVlx.default)(props.width ? 'auto' : '100%')
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: props.src,
                    alt: props.alt,
                    style: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                    }
                })
            })
        })
    });
};
const $945afc5e0498e2e0$export$8912007324034abd = ({ eyebrow: eyebrow, title: title, titleAs: titleAs = 'h3', titleAppearsAs: titleAppearsAs, body: body, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, logoLinkDataEventProps: logoLinkDataEventProps, logos: logos, background: background = 'polygon', backgroundColor: backgroundColor = 'neutral.light100', flipLayout: flipLayout = false })=>{
    const numLogos = logos.filter((logo)=>logo.href ?? false).length;
    const logoSize = numLogos <= 6 ? 'large' : 'regular';
    const responsiveSectionDividerHeightsStyles = null;
    const sectionStyles = null;
    const polygonStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _kqswh2mm _1mou1miz _11q71hkw _1rjcq9zu",
            "_9luy1wqb _ce5au29b _wfa7llbu"
        ]),
        style: {
            "--_1reys1m": (0, $6ZVlx.default)(background === 'full' ? 0 : "var(--ds-space-800, 64px)"),
            "--_tpnriy": (0, $6ZVlx.default)(background === 'full' ? (0, $kbpa7.wacToken)(`color.${backgroundColor}`) : 'transparent')
        },
        children: [
            background === 'polygon' && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q71xvm _kqswstnw _1bsb1osq _4t3imhst _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _1kt9b3bt _1cs8stnw _iajm14o7 _kfgtq9zu _1mp41osq _1s6k1xvm _tgsmcdv4 _aetrb3bt _18postnw _1qdgq9zu _19nq1osq _z0ai1osq _16r21xvm _1oj41mhh"
                ]),
                style: {
                    "--_vp2za": (0, $6ZVlx.default)((0, $kbpa7.wacToken)(`color.${backgroundColor}`))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_195g1wug _p12f1osq _1bsb1osq _kqswh2mm _1pbykb7n _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _p12f1to9 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q _8fz6nklw _688gkb7n",
                            flipLayout && "_1f49kb7n",
                            numLogos === 7 && "_w9am12am _1bhm12am"
                        ]),
                        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($945afc5e0498e2e0$var$IntegrationLogo, {
                                ...logo,
                                logoSize: logoSize,
                                dataEventProps: logo.dataEventProps ?? logoLinkDataEventProps
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                        eyebrow: eyebrow,
                        title: title,
                        titleAs: titleAs,
                        titleAppearsAs: titleAppearsAs,
                        text: body,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref,
                                ...linkDataEventProps && {
                                    dataEventProps: linkDataEventProps
                                }
                            }
                        } : undefined,
                        alignment: {
                            mobile: 'center',
                            tablet: 'start',
                            desktop: 'start'
                        }
                    })
                ]
            })
        ]
    });
};
const $945afc5e0498e2e0$var$contentContainerStyles = null;
const $945afc5e0498e2e0$var$logosContainerStyles = null;
const $945afc5e0498e2e0$var$sevenLogosGridStyles = null;

});

parcelRegister("3OVYv", function(module, exports) {
$parcel$export(module.exports, "Integration", function () { return $a9c45609cd9ba3bf$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2axoc = parcelRequire("2axoc");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $a9c45609cd9ba3bf$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        src: props.src,
        alt: props.alt,
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    });
    if (!props.clickable) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsbys9h _4t3iys9h _1h1tkb7n _glte53f4 _165t53f4"
        ]),
        children: logoImage
    });
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsbys9h _4t3iys9h _1h1tkb7n _glte53f4 _165t53f4"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: props.href,
            ...props.dataEventProps ?? {},
            className: (0, $2jatx.default)([
                "_4t3i1osq _1bsb1osq _1hbx1doa _skp01k4l"
            ]),
            children: logoImage
        })
    });
};
const $a9c45609cd9ba3bf$export$8912007324034abd = ({ title: title, titleAs: titleAs = 'h3', titleAppearsAs: titleAppearsAs, body: body, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, logoLinkDataEventProps: logoLinkDataEventProps, clickableLogos: clickableLogos = true, logos: logos })=>{
    const sectionStyles = null;
    const responsiveButtonSize = {
        mobile: 'small',
        tablet: 'small',
        desktop: 'large',
        xl_desktop: 'large'
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _11q7g7ng _1e0c1txw _2lx21bp4 _zulpxncg _1rjcxncg _19wg1epz _16im1epz _pdlm16xz _1s0l16xz"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "8",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                    title: title,
                    titleAs: titleAs,
                    titleAppearsAs: titleAppearsAs,
                    text: body,
                    callToActionProps: linkLabel && linkHref ? {
                        button: {
                            href: linkHref
                        },
                        buttonText: linkLabel,
                        buttonVariant: 'secondary',
                        responsiveSize: responsiveButtonSize,
                        ...linkDataEventProps && {
                            dataEventProps: linkDataEventProps
                        }
                    } : undefined,
                    alignment: {
                        mobile: 'center',
                        tablet: 'center',
                        desktop: 'center'
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q"
                    ]),
                    children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a9c45609cd9ba3bf$var$IntegrationLogo, {
                            ...logo,
                            dataEventProps: logo.dataEventProps ?? logoLinkDataEventProps,
                            clickable: clickableLogos
                        }, index))
                })
            })
        ]
    });
};
const $a9c45609cd9ba3bf$var$logosContainerStyles = null;

});


parcelRegister("bkhKq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b9780893fe5c6ce3$export$2e2bcd8739ae039; });
/* invisible-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $b9780893fe5c6ce3$var$UniformInvisibleContent = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-content": props.content,
        className: (0, $2jatx.default)([
            "_1e0cglyw"
        ])
    });
};
var $b9780893fe5c6ce3$export$2e2bcd8739ae039 = $b9780893fe5c6ce3$var$UniformInvisibleContent;

});

parcelRegister("5uOL0", function(module, exports) {
$parcel$export(module.exports, "JiraAjAnimatedHero", function () { return $27b31cf32d3361d1$export$4613d02e4bdf8cad; });
/* jira-aj-animated-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $7kIQK = parcelRequire("7kIQK");
const $27b31cf32d3361d1$var$SCENE_WIDTH = 800;
const $27b31cf32d3361d1$var$SCENE_HEIGHT = 550;
// ADS sizing types do not support the CSS variables required for Uniform's authored dimensions.
const $27b31cf32d3361d1$var$styles = {
    container: "_kqswh2mm _1bsbexel _4t3inxy9 _p12f1oy6 _c71lobte _1h1t1qau _14b51crv _1xlo1kpv _glte3can _165t1c9k",
    scene: "_kqswstnw _1bsb1c3h _4t3i1deq _8hrz5d63 _lcxvglyw",
    tour: "_kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3i1osq _t9ec2k2r _1e0c1txw _4cvr1h6o _1bah1h6o _1pbykb7n",
    shapes: "_kqswstnw _1bsb1osq _4t3i1lk2",
    yellowShape: "_kqswstnw _152tidpf _rjxpidpf",
    greenShape: "_kqswstnw _u7coidpf _1e02idpf"
};
const $27b31cf32d3361d1$export$4613d02e4bdf8cad = ({ width: width = '100%', height: height = 'auto', maxWidth: maxWidth = '100%', maxHeight: maxHeight, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, aspectRatio: aspectRatio = '800/550', showDecorativeShapes: showDecorativeShapes = true })=>{
    const intl = (0, $8e22h.default)();
    const containerRef = (0, $1oC0p.useRef)(null);
    const [size, setSize] = (0, $1oC0p.useState)({
        width: 0,
        height: 0
    });
    // The server and first client render agree, and motion only starts after checking the preference.
    const [reducedMotion, setReducedMotion] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        const query = window.matchMedia('(prefers-reduced-motion: reduce)');
        const update = ()=>setReducedMotion(query.matches);
        update();
        query.addEventListener('change', update);
        return ()=>query.removeEventListener('change', update);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        const observer = new ResizeObserver((entries)=>{
            const entry = entries[0];
            if (!entry) return;
            const { width: measuredWidth, height: measuredHeight } = entry.contentRect;
            setSize((previous)=>previous.width === measuredWidth && previous.height === measuredHeight ? previous : {
                    width: measuredWidth,
                    height: measuredHeight
                });
        });
        observer.observe(container);
        return ()=>observer.disconnect();
    }, []);
    const scale = Math.max(0, Math.min(size.width / $27b31cf32d3361d1$var$SCENE_WIDTH, size.height / $27b31cf32d3361d1$var$SCENE_HEIGHT));
    const sizing = {
        '--jira-hero-width': width,
        '--jira-hero-height': height,
        '--jira-hero-max-width': maxWidth,
        '--jira-hero-max-height': maxHeight,
        '--jira-hero-tablet-width': tabletWidth,
        '--jira-hero-desktop-width': desktopWidth,
        '--jira-hero-tablet-height': tabletHeight,
        '--jira-hero-desktop-height': desktopHeight,
        '--jira-hero-aspect-ratio': aspectRatio
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        style: sizing,
        role: "img",
        "aria-label": intl.formatMessage({
            id: 'jira-aj-animated-hero.description',
            defaultMessage: 'Jira board showing an issue progressing from To Do through In Progress to Done.'
        }),
        className: (0, $2jatx.default)([
            $27b31cf32d3361d1$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "jira-aj-scene",
            "aria-hidden": "true",
            ref: (node)=>{
                node?.setAttribute('inert', '');
            },
            style: {
                transform: `scale(${scale})`,
                left: (size.width - $27b31cf32d3361d1$var$SCENE_WIDTH * scale) / 2,
                top: (size.height - $27b31cf32d3361d1$var$SCENE_HEIGHT * scale) / 2
            },
            className: (0, $2jatx.default)([
                $27b31cf32d3361d1$var$styles.scene
            ]),
            children: [
                showDecorativeShapes && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "data-testid": "jira-aj-decorative-shapes",
                    className: (0, $2jatx.default)([
                        $27b31cf32d3361d1$var$styles.shapes
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                            width: "311",
                            height: "220",
                            viewBox: "0 0 311 220",
                            fill: "none",
                            focusable: "false",
                            className: (0, $2jatx.default)([
                                $27b31cf32d3361d1$var$styles.yellowShape
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M7.34559 1.71298L310.956 0.712733L305.579 218.935L0.637246 219.618L7.34559 1.71298Z",
                                fill: "#FFA900"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                            width: "252",
                            height: "219",
                            viewBox: "0 0 252 219",
                            fill: "none",
                            focusable: "false",
                            className: (0, $2jatx.default)([
                                $27b31cf32d3361d1$var$styles.greenShape
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M2.76007 0.226074H251.614V212.007L0.0842285 218.146L2.76007 0.226074Z",
                                fill: "#82B536"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        $27b31cf32d3361d1$var$styles.tour
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7kIQK.AnimatedJiraTour), {
                        layoutMode: "fixed-scene",
                        displayMode: reducedMotion ? 'static' : 'animated'
                    })
                })
            ]
        })
    });
};

});

parcelRegister("6jbRM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3255cbe80369d8fd$export$2e2bcd8739ae039; });
/* jira-templates-tab-content-subgrid-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");
const $3255cbe80369d8fd$export$2f2a2862921598f6 = ()=>{
    const renderJiraTemplatesTabContent = ({ items: items })=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulpv47k _dm2511p5 _dbjgidpf _1hvkidpf _isu4idpf _15qmidpf _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf _pdlm14hz _glte1osq _1vsw13cz _18jf188f _azss12kr _1rqt1we7"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "jiraTemplatesTabContent",
        wrapperComponent: renderJiraTemplatesTabContent
    });
};
var $3255cbe80369d8fd$export$2e2bcd8739ae039 = $3255cbe80369d8fd$export$2f2a2862921598f6;

});

parcelRegister("h1pep", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4291428b2d892504$export$2e2bcd8739ae039; });
/* job-posting-subheading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jsxHL = parcelRequire("jsxHL");

var $5T1R4 = parcelRequire("5T1R4");
/** The reference page divides every segment with a pipe. */ const $4291428b2d892504$var$SEGMENT_SEPARATOR = ' | ';
/**
 * The one-line subheading under a careers job title: the category, then every
 * location, then the type.
 *
 * Mirrors the live Magnolia component `imkt.components.JobPostingDetails`, whose
 * params are `postingTeam`, `postingLocation` and `postingCommitment`, which map to
 * `icimsJob.category`, `icimsJob.locations` and `icimsJob.type`. Its fourth param
 * `remoteEligible` is empty on every sampled job, so this omits it.
 *
 * One deliberate difference from the reference: Magnolia emits the separator
 * before `postingCommitment` unconditionally, so a job with no `type` renders a
 * dangling `|` (see job 25169). 144 of 234 live jobs carry no `type`, so that
 * defect shows on most job pages. This drops empty segments instead.
 */ const $4291428b2d892504$var$UniformJobPostingSubheading = ({ category: rawCategory, locations: rawLocations, type: rawType, alignment: rawAlignment })=>{
    const alignment = $4291428b2d892504$var$unwrapText(rawAlignment) ?? 'center';
    const segments = [
        $4291428b2d892504$var$unwrapText(rawCategory),
        ...$4291428b2d892504$var$unwrapLocations(rawLocations),
        $4291428b2d892504$var$unwrapText(rawType)
    ].filter((segment)=>segment !== undefined);
    // An unbound or closed job resolves to nothing. Render no empty paragraph.
    if (segments.length === 0) return null;
    const alignmentStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            className: (0, $2jatx.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                "_y3gnoues",
                "_syazl3em",
                "body-lg"
            ]),
            style: {
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
            },
            children: segments.join($4291428b2d892504$var$SEGMENT_SEPARATOR)
        })
    });
};
const $4291428b2d892504$var$resetMargin = null;
const $4291428b2d892504$var$colorStyle = null;
function $4291428b2d892504$var$unwrapText(parameter) {
    const value = $4291428b2d892504$var$unwrapParameterValue(parameter);
    if (typeof value !== 'string') return undefined;
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
}
/** Cleans every raw iCIMS location string, and drops the ones that hold no text. */ function $4291428b2d892504$var$unwrapLocations(parameter) {
    const value = $4291428b2d892504$var$unwrapParameterValue(parameter);
    if (!Array.isArray(value)) return [];
    return value.map((entry)=>typeof entry === 'string' ? (0, $5T1R4.formatIcimsLocation)(entry) : undefined).filter((entry)=>entry !== undefined);
}
function $4291428b2d892504$var$unwrapParameterValue(parameter) {
    if (parameter === undefined) return undefined;
    if (typeof parameter !== 'object' || parameter === null) return parameter;
    if (Array.isArray(parameter)) return parameter;
    return parameter.value;
}
var $4291428b2d892504$export$2e2bcd8739ae039 = $4291428b2d892504$var$UniformJobPostingSubheading;

});
parcelRegister("5T1R4", function(module, exports) {
$parcel$export(module.exports, "formatIcimsLocation", function () { return $4f9ab36cddc5a871$export$afb1cc422f4ab888; });
/**
 * Formats one raw iCIMS location string into the `City, Country` shape the
 * careers job detail page shows.
 *
 * iCIMS sends a hyphen-delimited string whose third segment repeats the city and
 * the country and adds the state or the postal code, for example
 * `"Seattle - United States -   Seattle, Washington  United States"`. The live
 * Magnolia page keeps the first two segments only, so this drops the rest.
 *
 * Derived from job 26289 on 2026-08-06 by comparing the raw Contentful
 * `locations` array against the rendered `postingLocation` segments:
 *
 * | Raw                                                                | Result                        |
 * | ------------------------------------------------------------------ | ----------------------------- |
 * | `Seattle - United States -   Seattle, Washington  United States`   | `Seattle, United States`      |
 * | `Remote - Remote`                                                  | `Remote, Remote`              |
 * | `San Francisco - United States -   San Francisco, California 94104 United States` | `San Francisco, United States` |
 *
 * The careers gallery renders its own, different string (`"London or Remote"`),
 * so it deliberately does NOT share this function.
 *
 * @returns the formatted location, or `undefined` when the input holds no usable text.
 */ const $4f9ab36cddc5a871$export$afb1cc422f4ab888 = (raw)=>{
    if (typeof raw !== 'string') return undefined;
    const segments = raw.split(' - ').map((segment)=>segment.replace(/\s+/g, ' ').trim()).filter((segment)=>segment.length > 0);
    if (segments.length === 0) return undefined;
    return segments.slice(0, 2).join(', ');
};

});


parcelRegister("g9CPg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db671c237f518514$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $eY3N6 = parcelRequire("eY3N6");

var $gqkLW = parcelRequire("gqkLW");

var $kCjSr = parcelRequire("kCjSr");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $lDqnU = parcelRequire("lDqnU");

var $bUqvj = parcelRequire("bUqvj");

var $fSk0D = parcelRequire("fSk0D");

var $3riD8 = parcelRequire("3riD8");
const $db671c237f518514$var$TRACKING_EVENT_NAMES = {
    loggedInHeroProductCtaClicked: 'loggedInHeroProductCtaClicked',
    loggedInHeroAnotherSiteCtaClicked: 'loggedInHeroAnotherSiteCtaClicked',
    loggedInHeroExploreFeaturesClicked: 'loggedInHeroExploreFeaturesClicked',
    loggedInHeroCreateNewSiteClicked: 'loggedInHeroCreateNewSiteClicked'
};
const $db671c237f518514$var$EXISTING_SITES_URL = '/try/cloud/signup?bundle=service-collection&primaryCollectionProduct=jira-servicedesk.ondemand';
const $db671c237f518514$export$cbc42fadf8b93ea3 = {
    eventType: 'ui',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'jsmLoggedInHero',
    source: '/software/jira-service-management'
};
const $db671c237f518514$var$jsmLoggedInCss = null;
const $db671c237f518514$var$heroSectionCss = null;
const $db671c237f518514$var$anchorContainer = null;
const $db671c237f518514$var$jsmSiteBoxCss = null;
const $db671c237f518514$var$headingCss = null;
const $db671c237f518514$var$starCss = null;
const $db671c237f518514$var$differentSiteCss = null;
const $db671c237f518514$var$subHeadingContainerCss = null;
const $db671c237f518514$var$createNewSiteAnchorCss = null;
const $db671c237f518514$var$subHeadingCss = null;
const $db671c237f518514$var$nameUnderlineCss = null;
const $db671c237f518514$var$inlineJSMLogoCss = null;
const $db671c237f518514$var$siteInfoContainerCss = null;
const $db671c237f518514$var$sitenameIconCss = null;
const $db671c237f518514$var$sitenameIconTextCss = null;
const $db671c237f518514$var$sitenameAndAvatarContainerCss = null;
const $db671c237f518514$var$siteNameSpanCss = null;
const $db671c237f518514$var$tooltipWrapperCss = null;
const $db671c237f518514$var$avatarContainerCss = null;
const $db671c237f518514$var$linkPlaceholderCss = null;
/**
 * JSM Logged-In Hero Section
 *
 * This component only renders for users who are logged in and have at least one JSM site.
 * For all other users (logged-out or logged-in without JSM), it returns null.
 *
 * Mimics the LoggedInHeroSection from the Jira Software page with JSM-specific messaging.
 */ const $db671c237f518514$var$JsmLoggedInHeroSection = ()=>{
    const loggedInHasJsm = (0, $2WL8B.useLoggedInHasJSM)();
    // Don't render while profile is loading or if user doesn't have JSM
    if (!loggedInHasJsm) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($db671c237f518514$var$JsmLoggedInHeroContent, {});
};
const $db671c237f518514$var$JsmLoggedInHeroContent = ()=>{
    const loggedInUserProfile = (0, $3riD8.useLoggedInUser)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    const intl = (0, $8e22h.default)();
    // Try to get name from props, and fallback to hook if needed
    const userFirstName = user.name?.split(' ')[0] ?? loggedInUserProfile.name?.split(' ')[0];
    // Try to get picture from props, and fallback to hook if needed
    const userPicture = user?.picture ?? loggedInUserProfile.picture;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const localizedTryLinkWithoutIntent = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=service-collection&createNew=true&primaryCollectionProduct=jira-servicedesk.ondemand');
    const localizedTryLink = (0, $kCjSr.useJsmPlaygroundSignupHref)(localizedTryLinkWithoutIntent);
    const [hasMultipleJsms, setHasMultipleJsms] = (0, $1oC0p.useState)(false);
    const [siteName, setSiteName] = (0, $1oC0p.useState)('');
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)('');
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    const { hasMultipleSites: mostRecentHasMultipleJsms, siteName: mostRecentSiteName, siteUrl: mostRecentSiteUrl, siteInitials: mostRecentSiteInitials } = (0, $fSk0D.useRecentProductSite)({
        productKeyFilter: 'jira-servicedesk.ondemand',
        activityClientProduct: 'jira'
    });
    (0, $1oC0p.useEffect)(()=>{
        setHasMultipleJsms(mostRecentHasMultipleJsms);
        setSiteName(mostRecentSiteName);
        setSiteUrl(mostRecentSiteUrl);
        setSiteInitials(mostRecentSiteInitials);
    }, [
        mostRecentHasMultipleJsms,
        mostRecentSiteInitials,
        mostRecentSiteName,
        mostRecentSiteUrl
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            ...$db671c237f518514$export$cbc42fadf8b93ea3,
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: 'ATLAS-117392'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _11q71bjw _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5112am _85i553f4 _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _syaz1pfd _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_t9ecuuzf _kqswstnw _1e0c1o8l _u7conh1r _1e021vgi _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp',
                            alt: ''
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41vau _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraServiceManagementPageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rnk6ds _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_1p38jlt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron400'))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraServiceManagementPageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraServiceManagementPageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: 'Jira Service Management',
                                    // eslint-disable-next-line react/no-unstable-nested-components
                                    span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _ahbq14id _12l21lpd"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lDqnU.JiraServiceManagementMarkBrandV3), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler($db671c237f518514$var$TRACKING_EVENT_NAMES.loggedInHeroCreateNewSiteClicked),
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wyb7vkz _k48pni7l _vwz41f4h _syazu5k9"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new workspace"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhk1afi _2rko1y44 _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19itgo0a _1rjc7vkz _18zr7vkz _1mougktf _kqswh2mm"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_11q716ye _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                        ]),
                                        style: {
                                            "--_alcc52": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime300'))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                            className: (0, $2jatx.default)([
                                                "_syazsei6 _ect41vau _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o",
                                                "h4"
                                            ]),
                                            style: {
                                                "--_rhsgef": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime800')),
                                                "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                            },
                                            children: siteInitials
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3igktf"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqkLW.default), {
                                                    content: siteName,
                                                    position: 'top-end',
                                                    mousePosition: "top",
                                                    tag: 'span',
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                        className: (0, $2jatx.default)([
                                                            "_ect4z4z1 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                        ]),
                                                        style: {
                                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                                        },
                                                        children: siteName
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                ]),
                                                children: userPicture && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bUqvj.AvatarFacepile), {
                                                    max: 4,
                                                    iconSize: 24,
                                                    icons: [
                                                        userPicture
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                "data-testid": "goToJsmButton",
                                variant: "primary_alt",
                                href: siteUrl,
                                size: "large",
                                onClick: ()=>clickHandler($db671c237f518514$var$TRACKING_EVENT_NAMES.loggedInHeroProductCtaClicked),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "JiraServiceManagementPageTemplate.loggedInHero.goToJsm",
                                    defaultMessage: "Go to Jira Service Management"
                                })
                            })
                        ]
                    })
                }),
                hasMultipleJsms ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ect4z4z1 _1pfho7ao _1wybdlk8 _k48p1nn1 _gu181h6o"
                    ]),
                    style: {
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: intl.formatMessage({
                            id: 'JiraServiceManagementPageTemplate.loggedInHero.lookingForDifferentSite',
                            defaultMessage: 'Looking for a different workspace?'
                        }),
                        href: $db671c237f518514$var$EXISTING_SITES_URL,
                        type: "primary",
                        onClick: ()=>clickHandler($db671c237f518514$var$TRACKING_EVENT_NAMES.loggedInHeroAnotherSiteCtaClicked)
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3iqslr"
                    ])
                })
            ]
        })
    });
};
var $db671c237f518514$export$2e2bcd8739ae039 = $db671c237f518514$var$JsmLoggedInHeroSection;

});
parcelRegister("fSk0D", function(module, exports) {
$parcel$export(module.exports, "useRecentProductSite", function () { return $780bc3687a084d28$export$86e5df7c422dcc77; });

var $1oC0p = parcelRequire("1oC0p");

var $gV7D4 = parcelRequire("gV7D4");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");
const $780bc3687a084d28$var$GRAPHQL_GATEWAY_URL = 'https://www.atlassian.com/gateway/api/graphql';
const $780bc3687a084d28$var$START_URL = 'https://start.atlassian.com';
const $780bc3687a084d28$var$constructLoginUrl = (url)=>{
    const loginUrl = new URL(url);
    loginUrl.pathname = '/login.jsp';
    const searchParam = new URLSearchParams();
    const browseUrl = new URL(loginUrl);
    browseUrl.pathname = '/browse';
    searchParam.append('os_destination', browseUrl.href);
    loginUrl.search = searchParam.toString();
    return loginUrl;
};
// @ts-ignore
const $780bc3687a084d28$var$getSitenameFromUrl = (url)=>{
    try {
        const tempUrl = new URL(url);
        return tempUrl.hostname.split('.')[0] || '';
    } catch  {
        return '';
    }
};
const $780bc3687a084d28$var$filterSitesByProductKey = (sites, productKeyFilter)=>{
    if (sites) {
        const filteredSites = sites.filter((site)=>{
            return site.products.some((product)=>{
                return product.productKey.includes(productKeyFilter);
            });
        }) || [];
        return filteredSites;
    } else return [];
};
const $780bc3687a084d28$export$86e5df7c422dcc77 = ({ productKeyFilter: productKeyFilter, activityClientProduct: activityClientProduct = 'jira' })=>{
    const { profile: profile, user: user } = (0, $7GVWk.useUserContext)();
    const splitName = user.name?.split(' ');
    // @ts-ignore
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const activityClient = (0, $gV7D4.useActivityClient)('v3', 'www.atlassian.com', undefined, $780bc3687a084d28$var$GRAPHQL_GATEWAY_URL);
    const availableProductSites = $780bc3687a084d28$var$filterSitesByProductKey(profile.attributes?.existingSites, productKeyFilter);
    const hasMultipleSites = availableProductSites.length > 1;
    const [siteName, setSiteName] = (0, $1oC0p.useState)('');
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)('');
    const [cloudSiteId, setCloudSiteId] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        const promises = [];
        let mostRecentActivity;
        const fetchActivitiesPromise = activityClient.fetchActivities([
            50,
            125,
            250
        ], {
            limit: 5,
            products: [
                activityClientProduct
            ]
        }, [
            'workedOn',
            'viewed'
        ]).then((data)=>{
            // Filter activities to only include those from available product sites
            const filteredViewed = data.viewed.filter((activity)=>availableProductSites.some((site)=>site.cloudId === activity.object.rootContainerIdentifier.id));
            const filteredWorkedOn = data.workedOn.filter((activity)=>availableProductSites.some((site)=>site.cloudId === activity.object.rootContainerIdentifier.id));
            const mostRecentlyViewed = filteredViewed[0];
            const mostRecentlyWorkedOn = filteredWorkedOn[0];
            if (mostRecentlyViewed && mostRecentlyWorkedOn) mostRecentActivity = new Date(mostRecentlyViewed.timestamp) > new Date(mostRecentlyWorkedOn.timestamp) ? mostRecentlyViewed : mostRecentlyWorkedOn;
            else if (mostRecentlyWorkedOn) mostRecentActivity = mostRecentlyWorkedOn;
            else if (mostRecentlyViewed) mostRecentActivity = mostRecentlyViewed;
        }).catch((error)=>console.log(error));
        promises.push(fetchActivitiesPromise);
        Promise.allSettled(promises).then(()=>{
            if (mostRecentActivity) {
                const loginUrl = $780bc3687a084d28$var$constructLoginUrl(mostRecentActivity.object.url);
                setSiteUrl(loginUrl.href);
                setSiteName(loginUrl.hostname.split('.')[0] || '');
                setSiteInitials(loginUrl.hostname.slice(0, 1).toUpperCase() + loginUrl.hostname.slice(1, 2));
                setCloudSiteId(mostRecentActivity.object.rootContainerIdentifier.id);
            } else if (availableProductSites[0]) {
                const loginUrl = $780bc3687a084d28$var$constructLoginUrl(availableProductSites[0].url);
                setSiteUrl(loginUrl.href);
                setSiteName(loginUrl.hostname.split('.')[0] || '');
                setSiteInitials(loginUrl.hostname.slice(0, 1).toUpperCase() + loginUrl.hostname.slice(1, 2));
                setCloudSiteId(availableProductSites[0].cloudId);
            } else {
                setSiteUrl($780bc3687a084d28$var$START_URL);
                setSiteName('');
            }
        });
    }, []);
    return {
        splitName: splitName,
        hasMultipleSites: hasMultipleSites,
        siteName: siteName,
        siteUrl: siteUrl,
        siteInitials: siteInitials,
        cloudSiteId: cloudSiteId
    };
};

});


parcelRegister("kb6mk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $51c8bcd2894d7bd2$export$2e2bcd8739ae039; });
/* uniform-jsm-portal-playground.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $9IkPf = parcelRequire("9IkPf");

var $kbpa7 = parcelRequire("kbpa7");

var $lDmb2 = parcelRequire("lDmb2");

var $1dc5i = parcelRequire("1dc5i");

var $gx3aw = parcelRequire("gx3aw");

var $gIKKj = parcelRequire("gIKKj");

var $7FWq8 = parcelRequire("7FWq8");

var $1ka2O = parcelRequire("1ka2O");

var $6LK4C = parcelRequire("6LK4C");

var $1I0eq = parcelRequire("1I0eq");

var $4O4rl = parcelRequire("4O4rl");

var $8eU08 = parcelRequire("8eU08");

var $a9bUP = parcelRequire("a9bUP");

var $hCJtS = parcelRequire("hCJtS");

var $8gAsH = parcelRequire("8gAsH");

var $5QlcL = parcelRequire("5QlcL");

var $drhc4 = parcelRequire("drhc4");

var $24d04 = parcelRequire("24d04");

var $fhSO9 = parcelRequire("fhSO9");

var $3jVXj = parcelRequire("3jVXj");

var $cTci5 = parcelRequire("cTci5");

var $c0yqw = parcelRequire("c0yqw");

var $7575j = parcelRequire("7575j");

var $gjT5s = parcelRequire("gjT5s");
const $51c8bcd2894d7bd2$var$PREVIEW_DESIGN_WIDTH = 1168;
const $51c8bcd2894d7bd2$var$PREVIEW_DESIGN_HEIGHT = 750;
const $51c8bcd2894d7bd2$var$STATIC_MOBILE_MEDIA_QUERY = '(max-width: 779px)';
const $51c8bcd2894d7bd2$var$useIsStaticMobile = ()=>{
    const [isStaticMobile, setIsStaticMobile] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const query = window.matchMedia?.($51c8bcd2894d7bd2$var$STATIC_MOBILE_MEDIA_QUERY);
        if (!query) return;
        const update = ()=>setIsStaticMobile(query.matches);
        update();
        query.addEventListener('change', update);
        return ()=>query.removeEventListener('change', update);
    }, []);
    return isStaticMobile;
};
const $51c8bcd2894d7bd2$var$playgroundTeamTypes = {
    'it-support': 'it-support',
    'it-operations': 'operations',
    engineering: 'software-development',
    hr: 'human-resources'
};
const $51c8bcd2894d7bd2$var$getPlaygroundTabForTeamType = (teamType)=>Object.entries($51c8bcd2894d7bd2$var$playgroundTeamTypes).find(([, value])=>value === teamType)?.[0];
const $51c8bcd2894d7bd2$var$usePreviewScale = ()=>{
    const ref = (0, $1oC0p.useRef)(null);
    const [scale, setScale] = (0, $1oC0p.useState)(1);
    (0, $1oC0p.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        const measure = ()=>{
            const width = element.clientWidth;
            if (width > 0) setScale(Math.min(1, width / $51c8bcd2894d7bd2$var$PREVIEW_DESIGN_WIDTH));
        };
        const observer = new ResizeObserver(measure);
        observer.observe(element);
        measure();
        return ()=>observer.disconnect();
    }, []);
    return [
        ref,
        scale
    ];
};
const $51c8bcd2894d7bd2$var$DEMO_START_VISIBILITY = 0.5;
const $51c8bcd2894d7bd2$var$useHasBeenSeen = (ref, onVisible)=>{
    const [hasBeenSeen, setHasBeenSeen] = (0, $1oC0p.useState)(false);
    const onVisibleRef = (0, $1oC0p.useRef)(onVisible);
    onVisibleRef.current = onVisible;
    (0, $1oC0p.useEffect)(()=>{
        const element = ref.current;
        if (!element || hasBeenSeen) return;
        if (typeof IntersectionObserver === 'undefined') {
            setHasBeenSeen(true);
            return;
        }
        const observer = new IntersectionObserver((entries)=>{
            if (entries.some((entry)=>entry.isIntersecting)) {
                setHasBeenSeen(true);
                onVisibleRef.current?.();
            }
        }, {
            threshold: $51c8bcd2894d7bd2$var$DEMO_START_VISIBILITY
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        ref,
        hasBeenSeen
    ]);
    return hasBeenSeen;
};
const $51c8bcd2894d7bd2$var$CARD_HOVERED_DEBOUNCE_MS = 200;
const $51c8bcd2894d7bd2$export$f6249aad4d1fc250 = ({ initialActiveTab: initialActiveTab = 'it-support', cursorLabel: cursorLabel, cursorColor: cursorColor = 'yellow', defaultTeam: defaultTeam, pagePath: pagePath, errorFallback: errorFallback, errorFallbackRender: errorFallbackRender, onError: onError } = {})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const experimentResult = (0, $gIKKj.useExperiment)((0, $7FWq8.wacRefreshJsm));
    const isPlaygroundSignupIntentEnabled = experimentResult.type !== 'enrolled' ? (0, $7FWq8.wacRefreshJsm).defaultValue : experimentResult.value;
    const { search: search } = (0, $1ka2O.useLocation)();
    const [activeTab, setActiveTab] = (0, $1oC0p.useState)(()=>$51c8bcd2894d7bd2$var$getPlaygroundTabForTeamType(new URLSearchParams(search).get('team_type')) ?? initialActiveTab);
    const [isCursorActive, setIsCursorActive] = (0, $1oC0p.useState)(false);
    const [isCursorHovering, setIsCursorHovering] = (0, $1oC0p.useState)(false);
    const [isCursorClicking, setIsCursorClicking] = (0, $1oC0p.useState)(false);
    const [hasUserTakenOver, setHasUserTakenOver] = (0, $1oC0p.useState)(false);
    const isStaticMobile = $51c8bcd2894d7bd2$var$useIsStaticMobile();
    const cursorRef = (0, $1oC0p.useRef)(null);
    const isPointerInsidePreviewRef = (0, $1oC0p.useRef)(false);
    const isHoveringInteractiveRef = (0, $1oC0p.useRef)(false);
    const hasFiredViewRef = (0, $1oC0p.useRef)(false);
    const fireSectionViewed = (0, $1oC0p.useCallback)(()=>{
        if (hasFiredViewRef.current) return;
        hasFiredViewRef.current = true;
        createAnalyticsEvent({
            actionSubject: 'jsmPlaygroundSection',
            action: 'viewed',
            eventType: 'ui',
            source: 'playground',
            attributes: {
                component: 'interactive-playground',
                page_path: pagePath ?? (typeof window !== 'undefined' && window.location?.pathname && window.location.pathname !== '/' ? window.location.pathname : '/software/jira/service-management'),
                defaultTeam: defaultTeam ?? initialActiveTab.replace(/-/g, '_')
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        defaultTeam,
        initialActiveTab,
        pagePath
    ]);
    const hoverTimeoutRef = (0, $1oC0p.useRef)(null);
    const [previewColumnRef, previewScale] = $51c8bcd2894d7bd2$var$usePreviewScale();
    const hasPreviewBeenSeen = $51c8bcd2894d7bd2$var$useHasBeenSeen(previewColumnRef, fireSectionViewed);
    const fireCardHovered = (0, $1oC0p.useCallback)((currentTab)=>{
        createAnalyticsEvent({
            actionSubject: 'card',
            action: 'hovered',
            actionSubjectId: 'previewCard',
            eventType: 'ui',
            source: 'jsm-playground',
            attributes: {
                trackEventName: 'hovered-preview-card',
                eventContainer: 'jsm-playground',
                team_type: currentTab.replace(/-/g, '_'),
                tabId: currentTab,
                page_canonical_url: typeof document !== 'undefined' ? document.querySelector('link[rel="canonical"]')?.getAttribute('href') ?? 'https://www.atlassian.com/software/jira/service-management' : 'https://www.atlassian.com/software/jira/service-management',
                page_path: pagePath ?? (typeof window !== 'undefined' && window.location?.pathname && window.location.pathname !== '/' ? window.location.pathname : '/software/jira/service-management'),
                loginUserDetected: (0, $gx3aw.Cookie).readCookie('login_user_detected') ?? 'false'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pagePath
    ]);
    (0, $1oC0p.useEffect)(()=>{
        return ()=>{
            if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    const { recordTabExplored: recordTabExplored, handlePointerDown: handleExploredPointerDown, handleClick: handleExploredClick, handleKeyDown: handleExploredKeyDown, handleChange: handleExploredChange } = (0, $gjT5s.useJsmPlaygroundSectionExploredAnalytics)({
        initialActiveTab: initialActiveTab
    });
    const updateCursorPosition = (event)=>{
        const cursor = cursorRef.current;
        if (!cursor) return;
        const sectionBounds = event.currentTarget.getBoundingClientRect();
        cursor.style.setProperty('--cursor-x', `${event.clientX - sectionBounds.left}px`);
        cursor.style.setProperty('--cursor-y', `${event.clientY - sectionBounds.top}px`);
        const isClickable = $51c8bcd2894d7bd2$var$isClickableElement(event.target);
        if (isClickable !== isHoveringInteractiveRef.current) {
            isHoveringInteractiveRef.current = isClickable;
            setIsCursorHovering(isClickable);
        }
    };
    const handlePreviewPointerEnter = (event)=>{
        isPointerInsidePreviewRef.current = true;
        updateCursorPosition(event);
        setIsCursorActive(true);
        if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            if (isPointerInsidePreviewRef.current) fireCardHovered(activeTab);
        }, $51c8bcd2894d7bd2$var$CARD_HOVERED_DEBOUNCE_MS);
    };
    const handlePreviewPointerLeave = ()=>{
        isPointerInsidePreviewRef.current = false;
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
        isHoveringInteractiveRef.current = false;
        setIsCursorActive(false);
        setIsCursorHovering(false);
        setIsCursorClicking(false);
    };
    const handlePreviewFocusChange = ()=>{
        if (!isPointerInsidePreviewRef.current) {
            isHoveringInteractiveRef.current = false;
            setIsCursorActive(false);
            setIsCursorHovering(false);
            setIsCursorClicking(false);
        }
    };
    const handlePreviewFocus = (event)=>{
        if (!(0, $8gAsH.isJsmPlaygroundSkipAnimationTarget)(event.target)) setHasUserTakenOver(true);
        handlePreviewFocusChange();
    };
    const handlePreviewKeyDown = (event)=>{
        if ((0, $8gAsH.isJsmPlaygroundSkipAnimationTarget)(event.target)) return;
        setHasUserTakenOver(true);
    };
    const handlePreviewPointerDown = (event)=>{
        if (!(0, $8gAsH.isJsmPlaygroundSkipAnimationTarget)(event.target)) setHasUserTakenOver(true);
        if ($51c8bcd2894d7bd2$var$isClickableElement(event.target)) setIsCursorClicking(true);
    };
    const handlePreviewPointerUp = ()=>{
        setIsCursorClicking(false);
    };
    const [teamVisits, setTeamVisits] = (0, $1oC0p.useState)({});
    const [completedDemoTab, setCompletedDemoTab] = (0, $1oC0p.useState)(null);
    const activeTabRef = (0, $1oC0p.useRef)(activeTab);
    activeTabRef.current = activeTab;
    const onDemoComplete = (0, $1oC0p.useMemo)(()=>{
        const complete = (team)=>()=>{
                setCompletedDemoTab((current)=>activeTabRef.current === team ? team : current);
            };
        return {
            'it-support': complete('it-support'),
            'it-operations': complete('it-operations'),
            engineering: complete('engineering'),
            hr: complete('hr')
        };
    }, []);
    const isDemoComplete = completedDemoTab === activeTab;
    const [demoLayer, setDemoLayer] = (0, $1oC0p.useState)(null);
    const [skipLayer, setSkipLayer] = (0, $1oC0p.useState)(null);
    const { handlePreviewClick: handlePreviewClick } = (0, $7575j.useJsmPlaygroundAnalytics)(activeTab);
    const sectionRef = (0, $1oC0p.useRef)(null);
    const previewCardRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const section = sectionRef.current;
        if (!section) return;
        const onClick = (e)=>handleExploredClick(e);
        const onPointerDown = (e)=>handleExploredPointerDown(e);
        const onKeyDown = (e)=>handleExploredKeyDown(e);
        const onChange = (e)=>handleExploredChange(e);
        section.addEventListener('click', onClick);
        section.addEventListener('pointerdown', onPointerDown);
        section.addEventListener('keydown', onKeyDown);
        section.addEventListener('change', onChange);
        return ()=>{
            section.removeEventListener('click', onClick);
            section.removeEventListener('pointerdown', onPointerDown);
            section.removeEventListener('keydown', onKeyDown);
            section.removeEventListener('change', onChange);
        };
    }, [
        handleExploredClick,
        handleExploredPointerDown,
        handleExploredKeyDown,
        handleExploredChange
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const previewCard = previewCardRef.current;
        if (!previewCard) return;
        const onCardClick = (e)=>handlePreviewClick(e);
        previewCard.addEventListener('click', onCardClick);
        return ()=>{
            previewCard.removeEventListener('click', onCardClick);
        };
    }, [
        handlePreviewClick
    ]);
    // Each team tab links to the page with its own `team_type`, so the link is
    // meaningful before hydration and a reload reopens the same team.
    const teamTabHref = (team)=>{
        const searchParams = new URLSearchParams(search);
        searchParams.set('team_type', $51c8bcd2894d7bd2$var$playgroundTeamTypes[team]);
        return `?${searchParams.toString()}`;
    };
    const handleTabSelect = (id)=>{
        const team = id;
        if (isPlaygroundSignupIntentEnabled) {
            const currentUrl = new URL(window.location.href);
            (0, $9IkPf.setJsmPlaygroundSignupIntent)(currentUrl.searchParams, $51c8bcd2894d7bd2$var$playgroundTeamTypes[team]);
            history.replaceState({}, '', currentUrl);
            window.dispatchEvent(new Event((0, $9IkPf.JSM_PLAYGROUND_SIGNUP_INTENT_CHANGE_EVENT)));
        }
        if (team !== activeTab) {
            setTeamVisits((visits)=>({
                    ...visits,
                    [team]: (visits[team] ?? 0) + 1
                }));
            setCompletedDemoTab(null);
        }
        recordTabExplored(team);
        setHasUserTakenOver(false);
        setActiveTab(team);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        ref: sectionRef,
        "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).sectionLabel),
        className: (0, $2jatx.default)([
            "_kqswh2mm _vchhusvi _1bsb1osq _1reozryt _1q51xy5q _85i5oahv _18zr1ejb _owpuoahv"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _1bsb1ns9 _p12f1osq _195g1wug _6rthxy5q _1gzeuftu _zt0y5ihd _i2nbmzrp _1b2bagmp _10fj14h2 _t2io1vau _1xd71pd9"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lDmb2.TabList), {
                    activeTabId: activeTab,
                    "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).serviceTeamTabListLabel),
                    children: (0, $cTci5.teamTabs).map((teamTab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $drhc4.JsmPlaygroundTeamTab), {
                            tabId: teamTab.value,
                            href: teamTabHref(teamTab.value),
                            index: index,
                            title: intl.formatMessage(teamTab.label),
                            isActive: teamTab.value === activeTab,
                            onTabSelect: handleTabSelect
                        }, teamTab.value))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: previewColumnRef,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1bsb1osq _p12f17gh _195g1wug _vchhusvi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4O4rl.JsmPlaygroundCursor), {
                        ref: cursorRef,
                        label: cursorLabel ?? intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).customCursorLabel),
                        color: cursorColor,
                        isActive: isCursorActive && !isStaticMobile,
                        isHovering: isCursorHovering,
                        isClicking: isCursorClicking
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        style: {
                            height: `${$51c8bcd2894d7bd2$var$PREVIEW_DESIGN_HEIGHT * previewScale}px`
                        },
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1bsb1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            "data-preview-scale": previewScale,
                            style: {
                                transform: `scale(${previewScale})`
                            },
                            className: (0, $2jatx.default)([
                                "_1bsb17gh _4t3i1fbq _8hrz5d63"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8eU08.JsmPlaygroundDemoLayerContext).Provider, {
                                    value: demoLayer,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8eU08.JsmPlaygroundSkipLayerContext).Provider, {
                                        value: skipLayer,
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            ref: previewCardRef,
                                            "data-testid": "jsm-playground-preview",
                                            // @ts-expect-error -- inert is missing from React types
                                            inert: isStaticMobile ? '' : undefined,
                                            role: "none",
                                            onBlur: handlePreviewFocusChange,
                                            onFocus: handlePreviewFocus,
                                            onKeyDown: handlePreviewKeyDown,
                                            onPointerDown: handlePreviewPointerDown,
                                            onPointerEnter: handlePreviewPointerEnter,
                                            onPointerLeave: handlePreviewPointerLeave,
                                            onPointerMove: updateCursorPosition,
                                            onPointerUp: handlePreviewPointerUp,
                                            className: (0, $2jatx.default)([
                                                "_kqswh2mm _1pbykb7n _vchhusvi _1bsb1osq _4t3i1fbq _2rkopb1k _bfhkvuon _16qs192p _1reo15vq _18m915vq _80omglyw _11c8y28r _ect41tbl _syazi7uo _1yyebys6 _162wvehm _1gz61kw7 _1apm1kw7 _1efd1kw7 _5jed1kw7 _1i441kw7 _1ozt1kw7 _rq7n1kw7 _1h151kw7 _so911kw7 _k3pp1kw7 _8m901kw7 _g9eq1kw7 _vzp01kw7 _1dnz1kw7 _1umj1kw7 _uamo1kw7 _1oob1kw7 _1gc81kw7 _ttej1kw7 _2n331kw7 _1vqr1kw7 _lfbd1kw7 _18j71kw7 _xah11kw7 _hk1k1kw7 _lvkb1kw7 _1mft1kw7 _txxi1kw7 _i5ox1kw7 _1agy1kw7 _1jqt1kw7 _uh1c1kw7 _5kb91kw7 _lao61kw7 _assh1kw7 _brbe1kw7 _16ez1kw7 _18vw1kw7 _1kiy1kw7 _1y15agmp _1i231wug _1sq71h90",
                                                isStaticMobile && "_lcxvglyw"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c11p5 _yv0ei47z _2z05i47z _1bsb1osq _4t3i1osq _1tkeidpf"
                                                ]),
                                                children: (0, $cTci5.teamTabs).map((teamTab)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1dc5i.TabPanel), {
                                                        id: teamTab.value,
                                                        isActive: teamTab.value === activeTab,
                                                        // @ts-expect-error -- inert is missing from React types
                                                        inert: teamTab.value === activeTab ? undefined : '',
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fhSO9.JsmPlaygroundErrorBoundary), {
                                                            teamType: teamTab.value,
                                                            fallback: errorFallback ?? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5QlcL.JsmPlaygroundStaticScreen), {
                                                                team: teamTab.value
                                                            }),
                                                            fallbackRender: errorFallbackRender,
                                                            onError: onError,
                                                            resetKeys: [
                                                                teamVisits[teamTab.value]
                                                            ],
                                                            children: [
                                                                teamTab.value === 'it-support' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1I0eq.JsmPortalPlaygroundItSupportPreview), {
                                                                    isActive: activeTab === 'it-support' && hasPreviewBeenSeen,
                                                                    hasUserTakenOver: hasUserTakenOver,
                                                                    onDemoComplete: onDemoComplete['it-support']
                                                                }, teamVisits['it-support'] ?? 0),
                                                                teamTab.value === 'it-operations' && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_1e0c1txw _2lx21bp4 _1bsb1osq _4t3i1osq _2rkopb1k _1reo15vq _18m915vq"
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9bUP.JsmPlaygroundNavigation), {
                                                                            config: (0, $cTci5.teamNavigationConfig)[teamTab.value],
                                                                            teamName: intl.formatMessage(teamTab.label)
                                                                        }),
                                                                        activeTab === 'it-operations' && hasPreviewBeenSeen ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3jVXj.JsmPlaygroundItOperations), {
                                                                            hasUserTakenOver: hasUserTakenOver,
                                                                            onDemoComplete: onDemoComplete['it-operations']
                                                                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                            className: (0, $2jatx.default)([
                                                                                "_1e0c1txw _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1osq _2rkopb1k _bfhkvuon"
                                                                            ])
                                                                        })
                                                                    ]
                                                                }),
                                                                teamTab.value === 'engineering' && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_1e0c1txw _2lx21bp4 _1bsb1osq _4t3i1osq _2rkopb1k _1reo15vq _18m915vq"
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9bUP.JsmPlaygroundNavigation), {
                                                                            config: (0, $cTci5.teamNavigationConfig)[teamTab.value],
                                                                            teamName: intl.formatMessage(teamTab.label)
                                                                        }),
                                                                        activeTab === 'engineering' && hasPreviewBeenSeen ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $24d04.JsmPlaygroundEngineering), {
                                                                            hasUserTakenOver: hasUserTakenOver,
                                                                            onDemoComplete: onDemoComplete.engineering
                                                                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                            className: (0, $2jatx.default)([
                                                                                "_1e0c1txw _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1osq _2rkopb1k _bfhkvuon"
                                                                            ])
                                                                        })
                                                                    ]
                                                                }),
                                                                teamTab.value === 'hr' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6LK4C.JsmPortalPlaygroundHrPreview), {
                                                                    isActive: activeTab === 'hr' && hasPreviewBeenSeen,
                                                                    hasUserTakenOver: hasUserTakenOver,
                                                                    onDemoComplete: onDemoComplete.hr
                                                                }, teamVisits.hr ?? 0)
                                                            ]
                                                        })
                                                    }, teamTab.value))
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    ref: setDemoLayer,
                                    "aria-hidden": "true",
                                    className: (0, $2jatx.default)([
                                        "_kqswstnw _1r04idpf _1pbycs5v _lcxvglyw"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    ref: setSkipLayer,
                                    "data-testid": "jsm-playground-skip-layer",
                                    className: (0, $2jatx.default)([
                                        "_kqswstnw _1r04idpf _1pby11wp _lcxvglyw"
                                    ])
                                }),
                                hasPreviewBeenSeen && isDemoComplete && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCJtS.JsmPlaygroundSeeHowItWorks), {}, activeTab)
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $51c8bcd2894d7bd2$export$6386a938964c8fc2 = $51c8bcd2894d7bd2$export$f6249aad4d1fc250;
var $51c8bcd2894d7bd2$export$2e2bcd8739ae039 = $51c8bcd2894d7bd2$export$f6249aad4d1fc250;
const $51c8bcd2894d7bd2$var$playgroundSectionStyles = null;
const $51c8bcd2894d7bd2$var$tabListWrapperStyles = null;
const $51c8bcd2894d7bd2$var$panelStackStyles = null;
const $51c8bcd2894d7bd2$var$previewOuterStyles = null;
const $51c8bcd2894d7bd2$var$previewScaleFrameStyles = null;
const $51c8bcd2894d7bd2$var$previewScaleInnerStyles = null;
const $51c8bcd2894d7bd2$var$demoLayerStyles = null;
const $51c8bcd2894d7bd2$var$skipLayerStyles = null;
const $51c8bcd2894d7bd2$var$PRODUCT_FONT_STACK = '"Atlassian Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
const $51c8bcd2894d7bd2$var$previewCardStyles = null;
const $51c8bcd2894d7bd2$var$staticPreviewCardStyles = null;
const $51c8bcd2894d7bd2$var$blankPreviewStyles = null;
const $51c8bcd2894d7bd2$var$teamPreviewStyles = null;
const $51c8bcd2894d7bd2$var$isClickableElement = (target)=>{
    if (!(target instanceof HTMLElement)) return false;
    const clickableSelector = [
        'button',
        'a[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'label',
        '[role="button"]',
        '[role="checkbox"]',
        '[role="tab"]',
        '[role="link"]',
        '[data-clickable="true"]'
    ].join(', ');
    return Boolean(target.closest(clickableSelector));
};

});
parcelRegister("6LK4C", function(module, exports) {
$parcel$export(module.exports, "JsmPortalPlaygroundHrPreview", function () { return $3d38f4064d728eb5$export$d91ae4a2ae56f2b8; });
/* jsm-portal-playground-hr-preview.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lawKK = parcelRequire("lawKK");
var $8yRyJ = parcelRequire("8yRyJ");

var $cTci5 = parcelRequire("cTci5");

var $c0yqw = parcelRequire("c0yqw");

var $7575j = parcelRequire("7575j");

var $cmk36 = parcelRequire("cmk36");

var $g0WR9 = parcelRequire("g0WR9");

var $8eU08 = parcelRequire("8eU08");

var $8DlQO = parcelRequire("8DlQO");

var $bBczw = parcelRequire("bBczw");

var $jGmnw = parcelRequire("jGmnw");

var $8gAsH = parcelRequire("8gAsH");

var $7KwbR = parcelRequire("7KwbR");

var $dihia = parcelRequire("dihia");

var $8BSWR = parcelRequire("8BSWR");

var $jzTDB = parcelRequire("jzTDB");

var $2khEj = parcelRequire("2khEj");
const $3d38f4064d728eb5$var$SUMMARY_TAB = 0;
const $3d38f4064d728eb5$var$RESPONSES_TAB = 1;
const $3d38f4064d728eb5$var$shouldShowHrSkip = (isActive, isAnimationComplete, prefersReducedMotion)=>isActive && !isAnimationComplete && !prefersReducedMotion;
const $3d38f4064d728eb5$var$ORIGIN = {
    x: 0,
    y: 0
};
/**
 * The HR team's JSM Surveys page for its onboarding survey: a Summary of the answers, with a chart
 * that toggles to a table and a Rovo summary, and the individual Responses, each of which opens in a
 * panel beside the table.
 *
 * Tab panels unmount when left, so each tab replays its entrance when it is shown again. The
 * chart/table choice outlives that, so it is kept here, as is the open response, which the demo
 * drives.
 */ const $3d38f4064d728eb5$var$JsmPortalPlaygroundHrPreviewComponent = ({ isActive: isActive = true, hasUserTakenOver: hasUserTakenOver = false, onDemoComplete: onDemoComplete })=>{
    const intl = (0, $8e22h.default)();
    const prefersReducedMotion = (0, $bBczw.usePrefersReducedMotion)();
    const notifyDemoComplete = (0, $8DlQO.useNotifyDemoComplete)(onDemoComplete);
    const rootRef = (0, $1oC0p.useRef)(null);
    const demoLayer = (0, $8eU08.useJsmPlaygroundDemoLayer)();
    const demoLayerRef = (0, $1oC0p.useRef)(demoLayer);
    demoLayerRef.current = demoLayer;
    const [hasLocalTakenOver, setHasLocalTakenOver] = (0, $1oC0p.useState)(false);
    const isTakenOver = hasUserTakenOver || hasLocalTakenOver;
    const isTakenOverRef = (0, $1oC0p.useRef)(isTakenOver);
    isTakenOverRef.current = isTakenOver;
    const timersRef = (0, $1oC0p.useRef)([]);
    const handleTakeover = (0, $1oC0p.useCallback)((event)=>{
        if ((0, $8gAsH.isJsmPlaygroundSkipAnimationTarget)(event.target)) return;
        setHasLocalTakenOver(true);
        setCursor((previous)=>({
                ...previous,
                isVisible: false
            }));
        timersRef.current.forEach(window.clearTimeout);
        timersRef.current = [];
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (hasUserTakenOver) {
            setCursor((previous)=>({
                    ...previous,
                    isVisible: false
                }));
            timersRef.current.forEach(window.clearTimeout);
            timersRef.current = [];
        }
    }, [
        hasUserTakenOver
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const root = rootRef.current;
        if (!root || isTakenOver) return;
        root.addEventListener('focus', handleTakeover, true);
        root.addEventListener('keydown', handleTakeover);
        root.addEventListener('pointerdown', handleTakeover);
        return ()=>{
            root.removeEventListener('focus', handleTakeover, true);
            root.removeEventListener('keydown', handleTakeover);
            root.removeEventListener('pointerdown', handleTakeover);
        };
    }, [
        handleTakeover,
        isTakenOver
    ]);
    const [isAnimationComplete, setIsAnimationComplete] = (0, $1oC0p.useState)(false);
    const shouldFocusCompletedDemo = (0, $1oC0p.useRef)(false);
    const [selectedTab, setSelectedTab] = (0, $1oC0p.useState)($3d38f4064d728eb5$var$SUMMARY_TAB);
    const [questionOneView, setQuestionOneView] = (0, $1oC0p.useState)('chart');
    const [isInsightsOpen, setIsInsightsOpen] = (0, $1oC0p.useState)(false);
    const [isInsightsOpenedByDemo, setIsInsightsOpenedByDemo] = (0, $1oC0p.useState)(false);
    const [openResponseId, setOpenResponseId] = (0, $1oC0p.useState)(null);
    const [panelResponseId, setPanelResponseId] = (0, $1oC0p.useState)(null);
    // A scripted cursor never fires `:hover`, so the row it visits reveals its action by state.
    const [revealedResponseId, setRevealedResponseId] = (0, $1oC0p.useState)(null);
    const [cursor, setCursor] = (0, $1oC0p.useState)({
        target: 'start',
        isVisible: false,
        isPressed: false
    });
    const [cursorStops, setCursorStops] = (0, $1oC0p.useState)({
        start: $3d38f4064d728eb5$var$ORIGIN,
        tableToggle: $3d38f4064d728eb5$var$ORIGIN,
        insights: $3d38f4064d728eb5$var$ORIGIN,
        responsesTab: $3d38f4064d728eb5$var$ORIGIN,
        firstRowAction: $3d38f4064d728eb5$var$ORIGIN
    });
    // Off for the first paint, so the measured start lands without travelling there, and off again
    // for each silent reposition.
    const [isCursorTransitionEnabled, setIsCursorTransitionEnabled] = (0, $1oC0p.useState)(false);
    const { firePlaygroundScreenNavigated: firePlaygroundScreenNavigated } = (0, $7575j.useJsmPlaygroundAnalytics)('hr');
    const selectTab = (index)=>{
        // The Responses tab unmounts when left, so its open panel goes with it.
        setIsInsightsOpen(false);
        setOpenResponseId(null);
        setRevealedResponseId(null);
        setSelectedTab(index);
        firePlaygroundScreenNavigated({
            team_type: 'hr',
            screen_id: index === $3d38f4064d728eb5$var$RESPONSES_TAB ? 'survey_responses' : 'survey_summary',
            interaction_mode: 'manual_click'
        });
    };
    const changeInsightsOpen = (isOpen)=>{
        setIsInsightsOpenedByDemo(false);
        setIsInsightsOpen(isOpen);
    };
    const changeOpenResponse = (responseId)=>{
        setOpenResponseId(responseId);
        if (responseId) setPanelResponseId(responseId);
    };
    const measureStops = (0, $1oC0p.useCallback)((targets)=>{
        const root = rootRef.current;
        // Stops are in the coordinates of wherever the cursor renders.
        const origin = demoLayerRef.current ?? root;
        if (!root || !origin) return;
        const selectors = {
            tableToggle: `[data-testid="${(0, $2khEj.SURVEY_SHOW_TABLE_TEST_ID)}"]`,
            insights: `[data-testid="${(0, $dihia.SURVEY_INSIGHTS_TRIGGER_TEST_ID)}"]`,
            responsesTab: `[data-testid="${(0, $8BSWR.SURVEY_RESPONSES_TAB_TEST_ID)}"]`,
            firstRowAction: `[data-response-id="${(0, $7KwbR.SURVEY_DEMO_RESPONSE_ID)}"] button`
        };
        const next = {};
        for (const target of targets){
            const element = root.querySelector(selectors[target === 'start' ? 'tableToggle' : target]);
            if (!element) continue;
            const center = (0, $g0WR9.centerOf)((0, $g0WR9.rectWithin)(origin, element));
            // A short approach from below-left of the toggle, rather than flying in from a corner.
            next[target] = target === 'start' ? {
                x: center.x - 70,
                y: center.y + 70
            } : center;
        }
        setCursorStops((previous)=>({
                ...previous,
                ...next
            }));
    }, []);
    // Re-run once the layer exists: it mounts after this screen does.
    (0, $1oC0p.useLayoutEffect)(()=>{
        measureStops([
            'start',
            'tableToggle',
            'insights',
            'responsesTab'
        ]);
    }, [
        measureStops,
        demoLayer
    ]);
    (0, $1oC0p.useEffect)(()=>{
        setIsCursorTransitionEnabled(true);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (!isActive) return;
        if (prefersReducedMotion) {
            setIsAnimationComplete(true);
            notifyDemoComplete();
        }
    }, [
        isActive,
        notifyDemoComplete,
        prefersReducedMotion
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!isActive || prefersReducedMotion || isTakenOver || isAnimationComplete) return;
        timersRef.current = [];
        const at = (ms, run)=>{
            timersRef.current.push(window.setTimeout(()=>{
                if (!isTakenOverRef.current) run();
            }, ms));
        };
        const updateCursor = (next)=>setCursor((previous)=>({
                    ...previous,
                    ...next
                }));
        const jumpTo = (target)=>{
            setIsCursorTransitionEnabled(false);
            updateCursor({
                target: target
            });
        };
        const fadeBackIn = ()=>{
            setIsCursorTransitionEnabled(true);
            updateCursor({
                isVisible: true
            });
        };
        // Fades in already travelling onto the toggle, rather than appearing and then setting off.
        at((0, $7KwbR.SURVEY_DEMO).cursorIn, ()=>updateCursor({
                target: 'tableToggle',
                isVisible: true
            }));
        at((0, $7KwbR.SURVEY_DEMO).togglePress, ()=>updateCursor({
                isPressed: true
            }));
        at((0, $7KwbR.SURVEY_DEMO).toggleRelease, ()=>{
            setQuestionOneView('table');
            updateCursor({
                isPressed: false
            });
        });
        at((0, $7KwbR.SURVEY_DEMO).insightsMove, ()=>{
            // Re-measured: the table has just replaced the chart below the header.
            measureStops([
                'insights'
            ]);
            updateCursor({
                target: 'insights'
            });
        });
        at((0, $7KwbR.SURVEY_DEMO).insightsPress, ()=>updateCursor({
                isPressed: true
            }));
        at((0, $7KwbR.SURVEY_DEMO).insightsRelease, ()=>{
            setIsInsightsOpenedByDemo(true);
            setIsInsightsOpen(true);
            updateCursor({
                isPressed: false
            });
        });
        at((0, $7KwbR.SURVEY_DEMO).insightsCursorOut, ()=>updateCursor({
                isVisible: false
            }));
        at((0, $7KwbR.SURVEY_DEMO).responsesJump, ()=>jumpTo('responsesTab'));
        at((0, $7KwbR.SURVEY_DEMO).responsesIn, fadeBackIn);
        at((0, $7KwbR.SURVEY_DEMO).responsesPress, ()=>updateCursor({
                isPressed: true
            }));
        at((0, $7KwbR.SURVEY_DEMO).responsesRelease, ()=>{
            selectTab($3d38f4064d728eb5$var$RESPONSES_TAB);
            updateCursor({
                isPressed: false
            });
        });
        at((0, $7KwbR.SURVEY_DEMO).responsesCursorOut, ()=>updateCursor({
                isVisible: false
            }));
        at((0, $7KwbR.SURVEY_DEMO).firstRowJump, ()=>{
            // The Responses table only exists now, so its row is measured now.
            setRevealedResponseId((0, $7KwbR.SURVEY_DEMO_RESPONSE_ID));
            measureStops([
                'firstRowAction'
            ]);
            jumpTo('firstRowAction');
        });
        at((0, $7KwbR.SURVEY_DEMO).firstRowIn, fadeBackIn);
        at((0, $7KwbR.SURVEY_DEMO).firstRowPress, ()=>updateCursor({
                isPressed: true
            }));
        at((0, $7KwbR.SURVEY_DEMO).firstRowRelease, ()=>{
            changeOpenResponse((0, $7KwbR.SURVEY_DEMO_RESPONSE_ID));
            updateCursor({
                isPressed: false
            });
        });
        // Travel stays on: easing across to where the squeeze left the button is the point.
        at((0, $7KwbR.SURVEY_DEMO).firstRowReflow, ()=>measureStops([
                'firstRowAction'
            ]));
        at((0, $7KwbR.SURVEY_DEMO).cursorOut, ()=>{
            updateCursor({
                isVisible: false
            });
            setRevealedResponseId(null);
        });
        at((0, $7KwbR.SURVEY_DEMO).cursorOut + (0, $cmk36.DEMO_CURSOR_FADE_MS), ()=>{
            setIsAnimationComplete(true);
            notifyDemoComplete();
        });
        return ()=>{
            timersRef.current.forEach(window.clearTimeout);
            timersRef.current = [];
        };
    // Scheduled once per activation. `selectTab` and `changeOpenResponse` only use setters.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isActive,
        isAnimationComplete,
        prefersReducedMotion,
        measureStops,
        isTakenOver
    ]);
    const skipAnimation = ()=>{
        timersRef.current.forEach(window.clearTimeout);
        timersRef.current = [];
        setCursor((previous)=>({
                ...previous,
                isVisible: false,
                isPressed: false
            }));
        setQuestionOneView('table');
        setIsInsightsOpenedByDemo(false);
        setIsInsightsOpen(false);
        setRevealedResponseId(null);
        setSelectedTab($3d38f4064d728eb5$var$RESPONSES_TAB);
        setOpenResponseId((0, $7KwbR.SURVEY_DEMO_RESPONSE_ID));
        setPanelResponseId((0, $7KwbR.SURVEY_DEMO_RESPONSE_ID));
        setIsAnimationComplete(true);
        shouldFocusCompletedDemo.current = true;
        notifyDemoComplete();
    };
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (!shouldFocusCompletedDemo.current) return;
        const responseButton = rootRef.current?.querySelector(`[data-response-id="${(0, $7KwbR.SURVEY_DEMO_RESPONSE_ID)}"] button`);
        if (!responseButton) return;
        shouldFocusCompletedDemo.current = false;
        responseButton.focus();
    }, [
        openResponseId,
        selectedTab
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: rootRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _4t3i1osq _emshidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jGmnw.JsmPlaygroundScreen), {
                config: (0, $cTci5.teamNavigationConfig).hr,
                teamName: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).teamHr),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lawKK.default), {
                    id: "jsm-playground-hr-survey",
                    selected: selectedTab,
                    onChange: selectTab,
                    shouldUnmountTabPanelOnChange: true,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8BSWR.SurveyPageHeader), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8yRyJ.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2khEj.SurveySummary), {
                                questionOneView: questionOneView,
                                onQuestionOneViewChange: setQuestionOneView,
                                isInsightsOpen: isInsightsOpen,
                                onInsightsOpenChange: changeInsightsOpen,
                                shouldFocusInsightsOnOpen: !isInsightsOpenedByDemo
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8yRyJ.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jzTDB.SurveyResponses), {
                                openResponseId: openResponseId,
                                panelResponseId: panelResponseId,
                                onOpenResponseChange: changeOpenResponse,
                                revealedResponseId: revealedResponseId
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8gAsH.JsmPlaygroundSkipAnimationButton), {
                isVisible: $3d38f4064d728eb5$var$shouldShowHrSkip(isActive, isAnimationComplete, prefersReducedMotion) && !isTakenOver,
                label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).skipAnimation),
                onClick: skipAnimation
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cmk36.JsmPlaygroundDemoCursor), {
                label: (0, $7KwbR.SURVEY_DEMO_CURSOR_LABEL),
                testId: "jsm-hr-demo-cursor",
                container: demoLayer,
                hasUserTakenOver: isTakenOver,
                isPressed: cursor.isPressed,
                isTransitionEnabled: isCursorTransitionEnabled,
                isVisible: cursor.isVisible && isActive && !isTakenOver,
                x: cursorStops[cursor.target].x,
                y: cursorStops[cursor.target].y
            })
        ]
    });
};
const $3d38f4064d728eb5$export$d91ae4a2ae56f2b8 = /*#__PURE__*/ (0, $1oC0p.memo)($3d38f4064d728eb5$var$JsmPortalPlaygroundHrPreviewComponent);
const $3d38f4064d728eb5$var$rootStyles = null;

});
parcelRegister("8yRyJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63bb0b7661c0db5a$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $6jtA2 = parcelRequire("6jtA2");

var $6dioi = parcelRequire("6dioi");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $63bb0b7661c0db5a$var$TabPanel = function TabPanel(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTabPanel = (0, $6dioi.useTabPanel)(), role = _useTabPanel.role, id = _useTabPanel.id, hidden = _useTabPanel.hidden, ariaLabelledBy = _useTabPanel['aria-labelledby'], onMouseDown = _useTabPanel.onMouseDown, tabIndex = _useTabPanel.tabIndex;
    return (0, $3dJ4i.jsx)((0, $6jtA2.default), {
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex
    }, (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, children));
};
var $63bb0b7661c0db5a$export$2e2bcd8739ae039 = $63bb0b7661c0db5a$var$TabPanel;

});
parcelRegister("6jtA2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $498b766e86755a82$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jyhJE = parcelRequire("jyhJE");

var $8VPPm = parcelRequire("8VPPm");

var $eYlo4 = parcelRequire("eYlo4");
var $498b766e86755a82$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $498b766e86755a82$var$_excluded2 = [
    "className"
];
var $498b766e86755a82$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $498b766e86755a82$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $498b766e86755a82$var$_excluded2);
    var className = xcss && (0, $8VPPm.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $498b766e86755a82$var$baseStyles,
            backgroundColor && (0, $jyhJE.backgroundColorStylesMap)[backgroundColor],
            (0, $jyhJE.isSurfaceColorToken)(backgroundColor) && (0, $jyhJE.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $jyhJE.paddingStylesMap).padding[padding],
            paddingBlock && (0, $jyhJE.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $jyhJE.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $jyhJE.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $jyhJE.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $jyhJE.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $jyhJE.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $eYlo4.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $498b766e86755a82$export$2e2bcd8739ae039 = $498b766e86755a82$export$e71c4d32a2263218;
var $498b766e86755a82$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("jyhJE", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $e3bef327eea3b3aa$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $e3bef327eea3b3aa$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $e3bef327eea3b3aa$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $e3bef327eea3b3aa$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $e3bef327eea3b3aa$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $e3bef327eea3b3aa$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $e3bef327eea3b3aa$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $e3bef327eea3b3aa$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $e3bef327eea3b3aa$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $e3bef327eea3b3aa$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $e3bef327eea3b3aa$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $e3bef327eea3b3aa$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $e3bef327eea3b3aa$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $e3bef327eea3b3aa$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $e3bef327eea3b3aa$export$5e65a44e5b6ecadb; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $cqlqZ = parcelRequire("cqlqZ");
function $e3bef327eea3b3aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3bef327eea3b3aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3bef327eea3b3aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3bef327eea3b3aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e3bef327eea3b3aa$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $e3bef327eea3b3aa$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $e3bef327eea3b3aa$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $e3bef327eea3b3aa$export$632685d741f3dbbf = $e3bef327eea3b3aa$var$_objectSpread($e3bef327eea3b3aa$var$_objectSpread({}, $e3bef327eea3b3aa$export$958d0ae7f2977ae4), $e3bef327eea3b3aa$export$d2dc61f58390201c);
var $e3bef327eea3b3aa$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $e3bef327eea3b3aa$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $e3bef327eea3b3aa$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $e3bef327eea3b3aa$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $e3bef327eea3b3aa$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $e3bef327eea3b3aa$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $e3bef327eea3b3aa$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)"
};
var $e3bef327eea3b3aa$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $e3bef327eea3b3aa$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $e3bef327eea3b3aa$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $e3bef327eea3b3aa$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $e3bef327eea3b3aa$export$6cc560b4dedf3816 = {
    'font.size.050': "var(--ds-font-size-050, 11px)",
    'font.size.075': "var(--ds-font-size-075, 12px)",
    'font.size.100': "var(--ds-font-size-100, 14px)",
    'font.size.200': "var(--ds-font-size-200, 16px)",
    'font.size.300': "var(--ds-font-size-300, 20px)",
    'font.size.400': "var(--ds-font-size-400, 24px)",
    'font.size.500': "var(--ds-font-size-500, 29px)",
    'font.size.600': "var(--ds-font-size-600, 35px)"
};
var $e3bef327eea3b3aa$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $e3bef327eea3b3aa$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand': "var(--ds-font-family-brand, Charlie Sans)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.monospace': "var(--ds-font-family-monospace, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.sans': "var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"
};
var $e3bef327eea3b3aa$export$360c29a380c1a34 = {
    'font.lineHeight.1': "var(--ds-font-lineHeight-1, 1)",
    'font.lineHeight.100': "var(--ds-font-lineHeight-100, 16px)",
    'font.lineHeight.200': "var(--ds-font-lineHeight-200, 20px)",
    'font.lineHeight.300': "var(--ds-font-lineHeight-300, 24px)",
    'font.lineHeight.400': "var(--ds-font-lineHeight-400, 28px)",
    'font.lineHeight.500': "var(--ds-font-lineHeight-500, 32px)",
    'font.lineHeight.600': "var(--ds-font-lineHeight-600, 40px)"
};
var $e3bef327eea3b3aa$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $e3bef327eea3b3aa$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 500 14px/1 ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'ui.small': "var(--ds-font-ui-small, normal 400 11px/1 ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $e3bef327eea3b3aa$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $e3bef327eea3b3aa$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $f53LC.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $e3bef327eea3b3aa$export$e615f061ca585a6c = $e3bef327eea3b3aa$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e3bef327eea3b3aa$var$getSerializedStylesMap(spacingProperty, $e3bef327eea3b3aa$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e3bef327eea3b3aa$export$bf46c3f9eeafc71f = $e3bef327eea3b3aa$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e3bef327eea3b3aa$var$getSerializedStylesMap(spacingProperty, $e3bef327eea3b3aa$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e3bef327eea3b3aa$export$e7af83bafe7f9e63 = $e3bef327eea3b3aa$var$getSerializedStylesMap('backgroundColor', $e3bef327eea3b3aa$export$d1d79bf68ac056bd);
var $e3bef327eea3b3aa$export$3a1bcba60b23d7f0 = $e3bef327eea3b3aa$var$getSerializedStylesMap('color', $e3bef327eea3b3aa$export$8473307aa00d6ea1);
var $e3bef327eea3b3aa$export$f7183c9e2dbc2543 = $e3bef327eea3b3aa$var$getSerializedStylesMap('fontSize', $e3bef327eea3b3aa$export$6cc560b4dedf3816);
var $e3bef327eea3b3aa$export$45f3f4fe16f9f7d5 = $e3bef327eea3b3aa$var$getSerializedStylesMap('fontWeight', $e3bef327eea3b3aa$export$303e322c6b1ed114);
var $e3bef327eea3b3aa$export$68cc305da27dbaa4 = $e3bef327eea3b3aa$var$getSerializedStylesMap('fontFamily', $e3bef327eea3b3aa$export$3c7e9587132614b4);
var $e3bef327eea3b3aa$export$8be4a21014f48eb1 = $e3bef327eea3b3aa$var$getSerializedStylesMap('lineHeight', $e3bef327eea3b3aa$export$360c29a380c1a34);
var $e3bef327eea3b3aa$export$a1962444bbf058e = $e3bef327eea3b3aa$var$getSerializedStylesMap('font', $e3bef327eea3b3aa$export$b5bac06d7d8fd0d1);
var $e3bef327eea3b3aa$export$ca3e246f24657bd6 = $e3bef327eea3b3aa$var$getSerializedStylesMap('font', $e3bef327eea3b3aa$export$b27166c9cf2c9f74);
var $e3bef327eea3b3aa$export$ff257d957d48c421 = $e3bef327eea3b3aa$var$getSerializedStylesMap((0, $cqlqZ.CURRENT_SURFACE_CSS_VAR), $e3bef327eea3b3aa$export$41a358c9c2356760);
var $e3bef327eea3b3aa$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $e3bef327eea3b3aa$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("cqlqZ", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $90b88a2446292e13$export$9d7b58831ae93caa; });
var $90b88a2446292e13$export$4ef52930e33717cd = 'data-theme';
var $90b88a2446292e13$export$a00eac3f8684bcd0 = 'data-color-mode';
var $90b88a2446292e13$export$2112803007239c61 = 'data-contrast-mode';
var $90b88a2446292e13$export$352e418ed5b6193a = 'data-custom-theme';
var $90b88a2446292e13$export$2faeed762aac6741 = 'light';
var $90b88a2446292e13$export$6f0c6fb8c80fcc92 = 'ds';
var $90b88a2446292e13$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $90b88a2446292e13$export$dddac1532e822863 = "--".concat($90b88a2446292e13$export$6f0c6fb8c80fcc92, "-token-not-found");
var $90b88a2446292e13$export$9d7b58831ae93caa = "--".concat($90b88a2446292e13$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("8VPPm", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $680bd972eea8a832$export$a9c84988c8f81f2d; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2zYm4 = parcelRequire("2zYm4");

var $3dJ4i = parcelRequire("3dJ4i");

var $jyhJE = parcelRequire("jyhJE");

var $7t0tI = parcelRequire("7t0tI");
var $680bd972eea8a832$export$9a199fbafee0014e = {
    backgroundColor: (0, $jyhJE.backgroundColorMap),
    blockSize: (0, $jyhJE.dimensionMap),
    borderBlockColor: (0, $jyhJE.borderColorMap),
    borderBlockEndColor: (0, $jyhJE.borderColorMap),
    borderBlockEndWidth: (0, $jyhJE.borderWidthMap),
    borderBlockStartColor: (0, $jyhJE.borderColorMap),
    borderBlockStartWidth: (0, $jyhJE.borderWidthMap),
    borderBlockWidth: (0, $jyhJE.borderWidthMap),
    borderBottomColor: (0, $jyhJE.borderColorMap),
    borderBottomLeftRadius: (0, $jyhJE.borderRadiusMap),
    borderBottomRightRadius: (0, $jyhJE.borderRadiusMap),
    borderBottomWidth: (0, $jyhJE.borderWidthMap),
    borderColor: (0, $jyhJE.borderColorMap),
    borderEndEndRadius: (0, $jyhJE.borderRadiusMap),
    borderEndStartRadius: (0, $jyhJE.borderRadiusMap),
    borderInlineColor: (0, $jyhJE.borderColorMap),
    borderInlineEndColor: (0, $jyhJE.borderColorMap),
    borderInlineEndWidth: (0, $jyhJE.borderWidthMap),
    borderInlineStartColor: (0, $jyhJE.borderColorMap),
    borderInlineStartWidth: (0, $jyhJE.borderWidthMap),
    borderInlineWidth: (0, $jyhJE.borderWidthMap),
    borderLeftColor: (0, $jyhJE.borderColorMap),
    borderLeftWidth: (0, $jyhJE.borderWidthMap),
    borderRadius: (0, $jyhJE.borderRadiusMap),
    borderRightColor: (0, $jyhJE.borderColorMap),
    borderRightWidth: (0, $jyhJE.borderWidthMap),
    borderStartEndRadius: (0, $jyhJE.borderRadiusMap),
    borderStartStartRadius: (0, $jyhJE.borderRadiusMap),
    borderTopColor: (0, $jyhJE.borderColorMap),
    borderTopLeftRadius: (0, $jyhJE.borderRadiusMap),
    borderTopRightRadius: (0, $jyhJE.borderRadiusMap),
    borderTopWidth: (0, $jyhJE.borderWidthMap),
    borderWidth: (0, $jyhJE.borderWidthMap),
    bottom: (0, $jyhJE.allSpaceMap),
    boxShadow: (0, $jyhJE.shadowMap),
    color: (0, $jyhJE.textColorMap),
    columnGap: (0, $jyhJE.positiveSpaceMap),
    gap: (0, $jyhJE.positiveSpaceMap),
    height: (0, $jyhJE.dimensionMap),
    inlineSize: (0, $jyhJE.dimensionMap),
    inset: (0, $jyhJE.allSpaceMap),
    insetBlock: (0, $jyhJE.allSpaceMap),
    insetBlockEnd: (0, $jyhJE.allSpaceMap),
    insetBlockStart: (0, $jyhJE.allSpaceMap),
    insetInline: (0, $jyhJE.allSpaceMap),
    insetInlineEnd: (0, $jyhJE.allSpaceMap),
    insetInlineStart: (0, $jyhJE.allSpaceMap),
    left: (0, $jyhJE.allSpaceMap),
    margin: (0, $jyhJE.allSpaceMap),
    marginBlock: (0, $jyhJE.allSpaceMap),
    marginBlockEnd: (0, $jyhJE.allSpaceMap),
    marginBlockStart: (0, $jyhJE.allSpaceMap),
    marginBottom: (0, $jyhJE.allSpaceMap),
    marginInline: (0, $jyhJE.allSpaceMap),
    marginInlineEnd: (0, $jyhJE.allSpaceMap),
    marginInlineStart: (0, $jyhJE.allSpaceMap),
    marginLeft: (0, $jyhJE.allSpaceMap),
    marginRight: (0, $jyhJE.allSpaceMap),
    marginTop: (0, $jyhJE.allSpaceMap),
    maxBlockSize: (0, $jyhJE.dimensionMap),
    maxHeight: (0, $jyhJE.dimensionMap),
    maxInlineSize: (0, $jyhJE.dimensionMap),
    maxWidth: (0, $jyhJE.dimensionMap),
    minBlockSize: (0, $jyhJE.dimensionMap),
    minHeight: (0, $jyhJE.dimensionMap),
    minInlineSize: (0, $jyhJE.dimensionMap),
    minWidth: (0, $jyhJE.dimensionMap),
    opacity: (0, $jyhJE.opacityMap),
    outlineColor: (0, $jyhJE.borderColorMap),
    outlineOffset: (0, $jyhJE.positiveSpaceMap),
    outlineWidth: (0, $jyhJE.borderWidthMap),
    padding: (0, $jyhJE.positiveSpaceMap),
    paddingBlock: (0, $jyhJE.positiveSpaceMap),
    paddingBlockEnd: (0, $jyhJE.positiveSpaceMap),
    paddingBlockStart: (0, $jyhJE.positiveSpaceMap),
    paddingBottom: (0, $jyhJE.positiveSpaceMap),
    paddingInline: (0, $jyhJE.positiveSpaceMap),
    paddingInlineEnd: (0, $jyhJE.positiveSpaceMap),
    paddingInlineStart: (0, $jyhJE.positiveSpaceMap),
    paddingLeft: (0, $jyhJE.positiveSpaceMap),
    paddingRight: (0, $jyhJE.positiveSpaceMap),
    paddingTop: (0, $jyhJE.positiveSpaceMap),
    right: (0, $jyhJE.allSpaceMap),
    rowGap: (0, $jyhJE.positiveSpaceMap),
    top: (0, $jyhJE.allSpaceMap),
    width: (0, $jyhJE.dimensionMap),
    zIndex: (0, $jyhJE.layerMap)
};
var $680bd972eea8a832$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $680bd972eea8a832$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $2zYm4.default)($7t0tI)) === 'object' && (0, $2zYm4.default)($7t0tI.env) === 'object' && false;
};
var $680bd972eea8a832$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $680bd972eea8a832$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $680bd972eea8a832$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $2zYm4.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $2zYm4.default)(value) === 'object' && $680bd972eea8a832$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($680bd972eea8a832$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($680bd972eea8a832$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $680bd972eea8a832$export$9a199fbafee0014e)) return;
        var tokenValue = $680bd972eea8a832$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $680bd972eea8a832$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $680bd972eea8a832$var$transformStyles(style);
    return (0, $f53LC.default)({}, $680bd972eea8a832$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
var $680bd972eea8a832$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$680bd972eea8a832$var$uniqueSymbol];
    typeof $7t0tI === "undefined" || (0, $2zYm4.default)($7t0tI);
    return styles;
};
function $680bd972eea8a832$export$f6c783d06584602c(style) {
    return $680bd972eea8a832$var$baseXcss(style);
}

});

parcelRegister("eYlo4", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $ae6742557e7cc2b0$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $ae6742557e7cc2b0$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $ae6742557e7cc2b0$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($ae6742557e7cc2b0$export$1ca2a26fecb070ae);
};
$ae6742557e7cc2b0$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("cTci5", function(module, exports) {
$parcel$export(module.exports, "teamTabs", function () { return $8328d13c7f694ba3$export$f9447a93f72287e9; });
$parcel$export(module.exports, "teamNavigationConfig", function () { return $8328d13c7f694ba3$export$5b300413d2996207; });
$parcel$export(module.exports, "itSupportHelpCards", function () { return $8328d13c7f694ba3$export$803821140f108f4d; });
$parcel$export(module.exports, "portalArticles", function () { return $8328d13c7f694ba3$export$1636eaa2877a1778; });

var $c0yqw = parcelRequire("c0yqw");
const $8328d13c7f694ba3$export$f9447a93f72287e9 = [
    {
        label: (0, $c0yqw.jsmPortalPlaygroundMessages).teamItSupport,
        value: 'it-support'
    },
    {
        label: (0, $c0yqw.jsmPortalPlaygroundMessages).teamItOperations,
        value: 'it-operations'
    },
    {
        label: (0, $c0yqw.jsmPortalPlaygroundMessages).teamEngineering,
        value: 'engineering'
    },
    {
        label: (0, $c0yqw.jsmPortalPlaygroundMessages).teamHr,
        value: 'hr'
    }
];
const $8328d13c7f694ba3$export$5b300413d2996207 = {
    'it-support': {
        avatarAppearance: 'outlined',
        avatarInitial: 'A',
        showAskRovo: false,
        showBack: true,
        showCreate: false,
        showCustomizeHelpCenter: true,
        showSearch: false
    },
    'it-operations': {
        avatarAppearance: 'default',
        avatarInitial: 'P',
        showAskRovo: true,
        showBack: false,
        showCreate: true,
        showCustomizeHelpCenter: false,
        showSearch: true
    },
    engineering: {
        avatarAppearance: 'default',
        avatarInitial: 'A',
        showAskRovo: true,
        showBack: false,
        showCreate: true,
        showCustomizeHelpCenter: false,
        showSearch: true
    },
    hr: {
        avatarAppearance: 'default',
        avatarInitial: 'B',
        showAskRovo: true,
        showBack: false,
        showCreate: true,
        showCustomizeHelpCenter: false,
        showSearch: true
    }
};
const $8328d13c7f694ba3$var$lastUpdated = {
    laptop: '2025-03-04',
    vpn: '2025-11-15',
    password: '2025-07-22'
};
const $8328d13c7f694ba3$export$803821140f108f4d = [
    {
        id: 'laptop',
        tag: (0, $c0yqw.jsmPortalPlaygroundMessages).cardLaptopTag,
        tagAppearance: 'accent-lime',
        title: (0, $c0yqw.jsmPortalPlaygroundMessages).cardLaptopTitle,
        description: (0, $c0yqw.jsmPortalPlaygroundMessages).cardLaptopDesc,
        lastUpdated: $8328d13c7f694ba3$var$lastUpdated.laptop
    },
    {
        id: 'vpn',
        tag: (0, $c0yqw.jsmPortalPlaygroundMessages).cardVpnTag,
        tagAppearance: 'accent-blue',
        title: (0, $c0yqw.jsmPortalPlaygroundMessages).cardVpnTitle,
        description: (0, $c0yqw.jsmPortalPlaygroundMessages).cardVpnDesc,
        lastUpdated: $8328d13c7f694ba3$var$lastUpdated.vpn
    },
    {
        id: 'password',
        tag: (0, $c0yqw.jsmPortalPlaygroundMessages).cardPasswordTag,
        tagAppearance: 'accent-blue',
        title: (0, $c0yqw.jsmPortalPlaygroundMessages).cardPasswordTitle,
        description: (0, $c0yqw.jsmPortalPlaygroundMessages).cardPasswordDesc,
        lastUpdated: $8328d13c7f694ba3$var$lastUpdated.password
    }
];
const $8328d13c7f694ba3$var$leadParagraph = [
    1,
    0.62
];
const $8328d13c7f694ba3$var$tipParagraph = [
    0.8
];
const $8328d13c7f694ba3$export$1636eaa2877a1778 = {
    laptop: {
        id: 'laptop',
        title: (0, $c0yqw.jsmPortalPlaygroundMessages).articleLaptopTitle,
        intro: (0, $c0yqw.jsmPortalPlaygroundMessages).articleLaptopIntro,
        lastUpdated: $8328d13c7f694ba3$var$lastUpdated.laptop,
        sections: [
            {
                heading: (0, $c0yqw.jsmPortalPlaygroundMessages).articleLaptopSection1,
                paragraphs: [
                    $8328d13c7f694ba3$var$leadParagraph,
                    $8328d13c7f694ba3$var$tipParagraph
                ]
            },
            {
                heading: (0, $c0yqw.jsmPortalPlaygroundMessages).articleLaptopSection2,
                paragraphs: [
                    $8328d13c7f694ba3$var$leadParagraph
                ]
            }
        ]
    },
    vpn: {
        id: 'vpn',
        title: (0, $c0yqw.jsmPortalPlaygroundMessages).articleVpnTitle,
        intro: (0, $c0yqw.jsmPortalPlaygroundMessages).articleVpnIntro,
        lastUpdated: $8328d13c7f694ba3$var$lastUpdated.vpn,
        sections: [
            {
                heading: (0, $c0yqw.jsmPortalPlaygroundMessages).articleVpnSection1,
                paragraphs: [
                    $8328d13c7f694ba3$var$leadParagraph,
                    $8328d13c7f694ba3$var$tipParagraph
                ]
            },
            {
                heading: (0, $c0yqw.jsmPortalPlaygroundMessages).articleVpnSection2,
                paragraphs: [
                    $8328d13c7f694ba3$var$leadParagraph
                ]
            }
        ]
    },
    password: {
        id: 'password',
        title: (0, $c0yqw.jsmPortalPlaygroundMessages).articlePasswordTitle,
        intro: (0, $c0yqw.jsmPortalPlaygroundMessages).articlePasswordIntro,
        lastUpdated: $8328d13c7f694ba3$var$lastUpdated.password,
        sections: [
            {
                heading: (0, $c0yqw.jsmPortalPlaygroundMessages).articlePasswordSection1,
                paragraphs: [
                    $8328d13c7f694ba3$var$leadParagraph,
                    $8328d13c7f694ba3$var$tipParagraph
                ]
            },
            {
                heading: (0, $c0yqw.jsmPortalPlaygroundMessages).articlePasswordSection2,
                paragraphs: [
                    $8328d13c7f694ba3$var$leadParagraph
                ]
            }
        ]
    }
};

});
parcelRegister("c0yqw", function(module, exports) {
$parcel$export(module.exports, "jsmPortalPlaygroundMessages", function () { return $89a635c22a009d96$export$b222a186e28d4688; });

var $fnHPc = parcelRequire("fnHPc");
const $89a635c22a009d96$export$b222a186e28d4688 = (0, $fnHPc.defineMessages)({
    sectionLabel: {
        id: 'JsmPortalPlayground.sectionLabel',
        defaultMessage: 'Jira Service Management preview'
    },
    serviceTeamTabListLabel: {
        id: 'JsmPortalPlayground.serviceTeamTabListLabel',
        defaultMessage: 'Service team'
    },
    teamItSupport: {
        id: 'JsmPortalPlayground.teamItSupport',
        defaultMessage: 'IT support'
    },
    teamItOperations: {
        id: 'JsmPortalPlayground.teamItOperations',
        defaultMessage: 'IT operations'
    },
    teamEngineering: {
        id: 'JsmPortalPlayground.teamEngineering',
        defaultMessage: 'Engineering'
    },
    teamHr: {
        id: 'JsmPortalPlayground.teamHr',
        defaultMessage: 'HR'
    },
    customCursorLabel: {
        id: 'JsmPortalPlayground.customCursorLabel',
        defaultMessage: 'You'
    },
    seeHowItWorks: {
        id: 'JsmPortalPlayground.seeHowItWorks',
        defaultMessage: 'See how it works'
    },
    navigationPreviewLabel: {
        id: 'JsmPortalPlayground.navigationPreviewLabel',
        defaultMessage: 'Jira Service Management navigation preview for {teamName}'
    },
    productName: {
        id: 'JsmPortalPlayground.productName',
        defaultMessage: 'Jira Service Management'
    },
    back: {
        id: 'JsmPortalPlayground.back',
        defaultMessage: 'Back'
    },
    search: {
        id: 'JsmPortalPlayground.search',
        defaultMessage: 'Search'
    },
    create: {
        id: 'JsmPortalPlayground.create',
        defaultMessage: 'Create'
    },
    askRovo: {
        id: 'JsmPortalPlayground.askRovo',
        defaultMessage: 'Ask Rovo'
    },
    brandName: {
        id: 'JsmPortalPlayground.brandName',
        defaultMessage: 'Jira Service Management'
    },
    helpCenterTitle: {
        id: 'JsmPortalPlayground.helpCenterTitle',
        defaultMessage: 'Help center'
    },
    helpCenterSubtitle: {
        id: 'JsmPortalPlayground.helpCenterSubtitle',
        defaultMessage: 'Find helpful articles, forms and more - or ask Rovo for help'
    },
    askAiPlaceholder: {
        id: 'JsmPortalPlayground.askAiPlaceholder',
        defaultMessage: 'Ask AI for answers, support articles, or to raise a request for you.'
    },
    findHelpHeading: {
        id: 'JsmPortalPlayground.findHelpHeading',
        defaultMessage: 'Find the help you need'
    },
    customizeHelpCenter: {
        id: 'JsmPortalPlayground.customizeHelpCenter',
        defaultMessage: 'Customize the help center'
    },
    incidentTitle: {
        id: 'JsmPortalPlayground.incidentTitle',
        defaultMessage: 'Service outage impacting Payment API'
    },
    addToWorkItem: {
        id: 'JsmPortalPlayground.addToWorkItem',
        defaultMessage: 'Add to work item'
    },
    description: {
        id: 'JsmPortalPlayground.description',
        defaultMessage: 'Description'
    },
    collapseDescription: {
        id: 'JsmPortalPlayground.collapseDescription',
        defaultMessage: 'Collapse description'
    },
    expandDescription: {
        id: 'JsmPortalPlayground.expandDescription',
        defaultMessage: 'Expand description'
    },
    incidentDescriptionStart: {
        id: 'JsmPortalPlayground.incidentDescriptionStart',
        defaultMessage: 'Customers are unable to complete transactions.'
    },
    incidentDescriptionEnd: {
        id: 'JsmPortalPlayground.incidentDescriptionEnd',
        defaultMessage: 'alerts have indicated <service>Payment API</service> disruptions.'
    },
    impactedService: {
        id: 'JsmPortalPlayground.impactedService',
        defaultMessage: 'Impacted service'
    },
    paymentApi: {
        id: 'JsmPortalPlayground.paymentApi',
        defaultMessage: 'Payment API'
    },
    onCall: {
        id: 'JsmPortalPlayground.onCall',
        defaultMessage: 'On call'
    },
    open: {
        id: 'JsmPortalPlayground.open',
        defaultMessage: 'Open'
    },
    investigating: {
        id: 'JsmPortalPlayground.investigating',
        defaultMessage: 'Investigating'
    },
    monitoring: {
        id: 'JsmPortalPlayground.monitoring',
        defaultMessage: 'Monitoring'
    },
    resolved: {
        id: 'JsmPortalPlayground.resolved',
        defaultMessage: 'Resolved'
    },
    runAutomation: {
        id: 'JsmPortalPlayground.runAutomation',
        defaultMessage: 'Run an automation rule'
    },
    details: {
        id: 'JsmPortalPlayground.details',
        defaultMessage: 'Details'
    },
    collapseDetails: {
        id: 'JsmPortalPlayground.collapseDetails',
        defaultMessage: 'Collapse details'
    },
    assignee: {
        id: 'JsmPortalPlayground.assignee',
        defaultMessage: 'Assignee'
    },
    responders: {
        id: 'JsmPortalPlayground.responders',
        defaultMessage: 'Responders'
    },
    requestType: {
        id: 'JsmPortalPlayground.requestType',
        defaultMessage: 'Request Type'
    },
    incident: {
        id: 'JsmPortalPlayground.incident',
        defaultMessage: 'Incident'
    },
    majorIncident: {
        id: 'JsmPortalPlayground.majorIncident',
        defaultMessage: 'Major incident'
    },
    collaborationChannels: {
        id: 'JsmPortalPlayground.collaborationChannels',
        defaultMessage: 'Collaboration channels'
    },
    rovoOpsTitle: {
        id: 'JsmPortalPlayground.rovoOpsTitle',
        defaultMessage: 'Accelerate incident resolution with Rovo Ops'
    },
    rovoOpsDescription: {
        id: 'JsmPortalPlayground.rovoOpsDescription',
        defaultMessage: 'Leverage Rovo Ops to find similar incidents, identify root causes, and gather incident context.'
    },
    identifyRootCauses: {
        id: 'JsmPortalPlayground.identifyRootCauses',
        defaultMessage: 'Identify root causes'
    },
    findSimilarIncidents: {
        id: 'JsmPortalPlayground.findSimilarIncidents',
        defaultMessage: 'Find similar incidents'
    },
    likelyRootCauses: {
        id: 'JsmPortalPlayground.likelyRootCauses',
        defaultMessage: 'Likely root causes'
    },
    regenerateRootCauses: {
        id: 'JsmPortalPlayground.regenerateRootCauses',
        defaultMessage: 'Regenerate root causes'
    },
    collapseRovoOps: {
        id: 'JsmPortalPlayground.collapseRovoOps',
        defaultMessage: 'Collapse Rovo Ops'
    },
    expandRovoOps: {
        id: 'JsmPortalPlayground.expandRovoOps',
        defaultMessage: 'Expand Rovo Ops'
    },
    sources: {
        id: 'JsmPortalPlayground.sources',
        defaultMessage: 'Sources'
    },
    rovoOps: {
        id: 'JsmPortalPlayground.rovoOps',
        defaultMessage: 'Rovo Ops'
    },
    slack: {
        id: 'JsmPortalPlayground.slack',
        defaultMessage: 'Slack'
    },
    zoom: {
        id: 'JsmPortalPlayground.zoom',
        defaultMessage: 'Zoom'
    },
    paymentTeam: {
        id: 'JsmPortalPlayground.paymentTeam',
        defaultMessage: 'Payment Team'
    },
    alertSmartLinkTitle: {
        id: 'JsmPortalPlayground.alertSmartLinkTitle',
        defaultMessage: "Payment \u2013 High Error Rate"
    },
    alertSmartLinkLabel: {
        id: 'JsmPortalPlayground.alertSmartLinkLabel',
        defaultMessage: "P1 Payment \u2013 High Error Rate, 172 alerts",
        description: 'Accessible name for a P1 alert link. P1 is the alert priority.'
    },
    rootCauseStepDeployments: {
        id: 'JsmPortalPlayground.rootCauseStepDeployments',
        defaultMessage: 'Searching recent <chip>Payment API</chip> deployments'
    },
    rootCauseStepFeatureFlags: {
        id: 'JsmPortalPlayground.rootCauseStepFeatureFlags',
        defaultMessage: 'Scanning feature flags <chip>Payment FF</chip>'
    },
    rootCauseStepPairing: {
        id: 'JsmPortalPlayground.rootCauseStepPairing',
        defaultMessage: 'Finding likely root causes and pairing with recent <chip>New Payment</chip> release'
    },
    rootCauseStepDone: {
        id: 'JsmPortalPlayground.rootCauseStepDone',
        defaultMessage: 'Done'
    },
    rootCauseStepInProgress: {
        id: 'JsmPortalPlayground.rootCauseStepInProgress',
        defaultMessage: 'In progress'
    },
    rootCauseStepNotStarted: {
        id: 'JsmPortalPlayground.rootCauseStepNotStarted',
        defaultMessage: 'Not started'
    },
    rootCauseDeployment: {
        id: 'JsmPortalPlayground.rootCauseDeployment',
        defaultMessage: 'Deployment'
    },
    rootCauseFeatureFlag: {
        id: 'JsmPortalPlayground.rootCauseFeatureFlag',
        defaultMessage: 'Feature flag'
    },
    rootCauseConfidenceHigh: {
        id: 'JsmPortalPlayground.rootCauseConfidenceHigh',
        defaultMessage: 'High'
    },
    rootCauseConfidenceMedium: {
        id: 'JsmPortalPlayground.rootCauseConfidenceMedium',
        defaultMessage: 'Medium'
    },
    rootCauseConfidenceLow: {
        id: 'JsmPortalPlayground.rootCauseConfidenceLow',
        defaultMessage: 'Low'
    },
    rootCauseDeployedTwoDaysAgo: {
        id: 'JsmPortalPlayground.rootCauseDeployedTwoDaysAgo',
        defaultMessage: 'Deployment to production 2 days ago'
    },
    rootCauseDeployedEightDaysAgo: {
        id: 'JsmPortalPlayground.rootCauseDeployedEightDaysAgo',
        defaultMessage: 'Deployed to production 8 days ago'
    },
    rootCauseCardLabel: {
        id: 'JsmPortalPlayground.rootCauseCardLabel',
        defaultMessage: '{title}, {confidence} confidence, {reference}: {detail}',
        description: 'Accessible name for a likely root cause card. {reference} is a work item key such as DEP-874.'
    },
    rootCauseInsightLikely: {
        id: 'JsmPortalPlayground.rootCauseInsightLikely',
        defaultMessage: '<strong>Likely cause of outage.</strong> There are patterns of recent alerts that have similar root causes of <service>Payment API</service>. This was most likely caused by the recent deployment <deployment>Update payment</deployment> 2 days ago'
    },
    rootCauseInsightPossible: {
        id: 'JsmPortalPlayground.rootCauseInsightPossible',
        defaultMessage: '<strong>Possible contributing factor.</strong> The feature flag <featureFlag>Payment FF</featureFlag> was enabled on <service>Payment API</service> 8 days ago and touches a related code path, though its rollout window is less closely aligned with the alert spike than the deployment above.'
    },
    rootCauseInsightUnlikely: {
        id: 'JsmPortalPlayground.rootCauseInsightUnlikely',
        defaultMessage: '<strong>Unlikely, but not ruled out.</strong> The deployment <deployment>Payment retries</deployment> shipped 8 days ago and touches this service, but its timing correlates weakly with the alert spike compared to the more recent changes above.'
    },
    skipAnimation: {
        id: 'JsmPortalPlayground.skipAnimation',
        defaultMessage: 'Skip animation'
    },
    customizePanelTitle: {
        id: 'JsmPortalPlayground.customizePanelTitle',
        defaultMessage: 'Customize look and feel'
    },
    helpCenterNameField: {
        id: 'JsmPortalPlayground.helpCenterNameField',
        defaultMessage: 'Help center name'
    },
    logoField: {
        id: 'JsmPortalPlayground.logoField',
        defaultMessage: 'Logo'
    },
    bannerField: {
        id: 'JsmPortalPlayground.bannerField',
        defaultMessage: 'Help center banner'
    },
    textColorField: {
        id: 'JsmPortalPlayground.textColorField',
        defaultMessage: 'Text color'
    },
    primaryColorField: {
        id: 'JsmPortalPlayground.primaryColorField',
        defaultMessage: 'Primary color'
    },
    secondaryColorField: {
        id: 'JsmPortalPlayground.secondaryColorField',
        defaultMessage: 'Secondary color'
    },
    togglePrimaryColor: {
        id: 'JsmPortalPlayground.togglePrimaryColor',
        defaultMessage: 'Change the article banner color'
    },
    toggleSecondaryColor: {
        id: 'JsmPortalPlayground.toggleSecondaryColor',
        defaultMessage: 'Change the article icon color'
    },
    readArticle: {
        id: 'JsmPortalPlayground.readArticle',
        defaultMessage: 'Read the article: {title}'
    },
    lastUpdated: {
        id: 'JsmPortalPlayground.lastUpdated',
        defaultMessage: 'Last updated {date}',
        description: 'When a help center article was last edited. {date} is a formatted date.'
    },
    createdWithRovo: {
        id: 'JsmPortalPlayground.createdWithRovo',
        defaultMessage: 'Created with Rovo'
    },
    cardLaptopTag: {
        id: 'JsmPortalPlayground.cardLaptopTag',
        defaultMessage: 'How-to guides'
    },
    cardLaptopTitle: {
        id: 'JsmPortalPlayground.cardLaptopTitle',
        defaultMessage: 'Set up your new laptop'
    },
    cardLaptopDesc: {
        id: 'JsmPortalPlayground.cardLaptopDesc',
        defaultMessage: "Whether you're new to the company or replacing your device, this guide walks you through everything you need to get started."
    },
    cardVpnTag: {
        id: 'JsmPortalPlayground.cardVpnTag',
        defaultMessage: 'Common troubleshooting'
    },
    cardVpnTitle: {
        id: 'JsmPortalPlayground.cardVpnTitle',
        defaultMessage: 'VPN connection issues'
    },
    cardVpnDesc: {
        id: 'JsmPortalPlayground.cardVpnDesc',
        defaultMessage: 'Having trouble connecting remotely? Learn the most common causes of VPN issues, how to troubleshoot them, and when to raise a request.'
    },
    cardPasswordTag: {
        id: 'JsmPortalPlayground.cardPasswordTag',
        defaultMessage: 'Common troubleshooting'
    },
    cardPasswordTitle: {
        id: 'JsmPortalPlayground.cardPasswordTitle',
        defaultMessage: 'Password reset guide'
    },
    cardPasswordDesc: {
        id: 'JsmPortalPlayground.cardPasswordDesc',
        defaultMessage: 'Locked out of your account? Follow these steps to securely reset your password and regain access to your tools.'
    },
    closeButton: {
        id: 'JsmPortalPlayground.closeButton',
        defaultMessage: 'Close'
    },
    sendButton: {
        id: 'JsmPortalPlayground.sendButton',
        defaultMessage: 'Send'
    },
    articleBack: {
        id: 'JsmPortalPlayground.articleBack',
        defaultMessage: 'Back'
    },
    articleBackLabel: {
        id: 'JsmPortalPlayground.articleBackLabel',
        defaultMessage: 'Back to the help center'
    },
    draftWithRovo: {
        id: 'JsmPortalPlayground.draftWithRovo',
        defaultMessage: 'Draft with Rovo'
    },
    stillNeedHelpTitle: {
        id: 'JsmPortalPlayground.stillNeedHelpTitle',
        defaultMessage: 'Still need help?'
    },
    stillNeedHelpBody: {
        id: 'JsmPortalPlayground.stillNeedHelpBody',
        defaultMessage: 'Our AI helper can help you find what you need.'
    },
    askAnything: {
        id: 'JsmPortalPlayground.askAnything',
        defaultMessage: 'Ask anything'
    },
    submitRequest: {
        id: 'JsmPortalPlayground.submitRequest',
        defaultMessage: 'Submit a request'
    },
    articleLaptopTitle: {
        id: 'JsmPortalPlayground.articleLaptopTitle',
        defaultMessage: 'Set up your new laptop'
    },
    articleLaptopIntro: {
        id: 'JsmPortalPlayground.articleLaptopIntro',
        defaultMessage: 'Follow the steps below to get your new laptop ready for work. Any questions, feel free to message the team.'
    },
    articleLaptopSection1: {
        id: 'JsmPortalPlayground.articleLaptopSection1',
        defaultMessage: 'Login with your credentials'
    },
    articleLaptopSection2: {
        id: 'JsmPortalPlayground.articleLaptopSection2',
        defaultMessage: 'Install Slack'
    },
    articleVpnTitle: {
        id: 'JsmPortalPlayground.articleVpnTitle',
        defaultMessage: 'Connecting to the VPN with your mobile device'
    },
    articleVpnIntro: {
        id: 'JsmPortalPlayground.articleVpnIntro',
        defaultMessage: 'Follow the steps below to connect your phone to the VPN. Any questions, feel free to message the team.'
    },
    articleVpnSection1: {
        id: 'JsmPortalPlayground.articleVpnSection1',
        defaultMessage: 'Download your VPN app'
    },
    articleVpnSection2: {
        id: 'JsmPortalPlayground.articleVpnSection2',
        defaultMessage: 'Login with your credentials'
    },
    articlePasswordTitle: {
        id: 'JsmPortalPlayground.articlePasswordTitle',
        defaultMessage: 'Password reset guide'
    },
    articlePasswordIntro: {
        id: 'JsmPortalPlayground.articlePasswordIntro',
        defaultMessage: 'Follow the steps below to reset your password. Any questions, feel free to message the team.'
    },
    articlePasswordSection1: {
        id: 'JsmPortalPlayground.articlePasswordSection1',
        defaultMessage: 'Verify your identity'
    },
    articlePasswordSection2: {
        id: 'JsmPortalPlayground.articlePasswordSection2',
        defaultMessage: 'Set your new password'
    }
});

});


parcelRegister("7575j", function(module, exports) {
$parcel$export(module.exports, "isUntrustedClick", function () { return $a01504c201c14593$export$9a2efd1554bcf7cf; });
$parcel$export(module.exports, "useJsmPlaygroundAnalytics", function () { return $a01504c201c14593$export$b8415ad1f386a2d1; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $gx3aw = parcelRequire("gx3aw");
const $a01504c201c14593$var$getCanonicalUrl = ()=>{
    if (typeof document === 'undefined') return '';
    const canonical = document.querySelector('link[rel="canonical"]')?.getAttribute('href');
    if (canonical) return canonical;
    const [urlWithoutHash] = window.location.href.split('#');
    return urlWithoutHash ?? '';
};
const $a01504c201c14593$var$getPagePath = ()=>{
    if (typeof window !== 'undefined') return window.location.pathname;
    return '';
};
const $a01504c201c14593$var$getLoginUserDetected = ()=>{
    if (typeof document === 'undefined') return 'false';
    return (0, $gx3aw.Cookie).readCookie('login_user_detected') === 'true' ? 'true' : 'false';
};
const $a01504c201c14593$var$sanitizeId = (raw)=>{
    return raw.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
};
const $a01504c201c14593$var$resolveElementType = (target)=>{
    if (target.getAttribute('role') === 'checkbox' || target instanceof HTMLInputElement && target.type === 'checkbox') return 'checkbox';
    if (target.getAttribute('role') === 'tab') return 'tab';
    if (target.getAttribute('role') === 'button' || target instanceof HTMLButtonElement) return 'button';
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) return 'input';
    if (target.getAttribute('role') === 'link' || target instanceof HTMLAnchorElement) return 'link';
    return target.tagName.toLowerCase();
};
const $a01504c201c14593$var$resolveElementId = (target)=>{
    const explicitId = target.getAttribute('data-element-id') || target.getAttribute('data-testid') || target.id;
    if (explicitId) return $a01504c201c14593$var$sanitizeId(explicitId);
    const ariaLabel = target.getAttribute('aria-label');
    if (ariaLabel) return $a01504c201c14593$var$sanitizeId(ariaLabel);
    const text = target.textContent?.trim();
    if (text && text.length <= 40) return $a01504c201c14593$var$sanitizeId(text);
    return 'component';
};
const $a01504c201c14593$var$resolveLabel = (target)=>{
    const labelAttr = target.getAttribute('data-label') || target.getAttribute('aria-label');
    if (labelAttr) return labelAttr.trim();
    const text = target.textContent?.trim();
    if (text && text.length > 0 && text.length <= 80) return text;
    return undefined;
};
const $a01504c201c14593$var$INTERACTIVE_SELECTOR = [
    'button',
    'a[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'label',
    '[role="button"]',
    '[role="checkbox"]',
    '[role="tab"]',
    '[role="link"]',
    '[data-clickable="true"]'
].join(', ');
const $a01504c201c14593$export$9a2efd1554bcf7cf = (event)=>{
    if (!event) return false;
    const isUntrustedOverride = event.isTrustedOverride === false || event.nativeEvent?.isTrustedOverride === false;
    if (isUntrustedOverride) return true;
    return typeof event.isTrusted === 'boolean' && !event.isTrusted && true;
};
const $a01504c201c14593$export$b8415ad1f386a2d1 = (defaultTeamType = 'it_support')=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const lastClickRef = (0, $1oC0p.useRef)(null);
    const firePlaygroundScreenNavigated = (0, $1oC0p.useCallback)(({ team_type: team_type = defaultTeamType.replace(/-/g, '_'), screen_id: screen_id, interaction_mode: interaction_mode = 'manual_click' })=>{
        createAnalyticsEvent({
            actionSubject: 'playgroundScreen',
            action: 'navigated',
            eventType: 'ui',
            source: 'playground',
            attributes: {
                team_type: team_type,
                screen_id: screen_id,
                interaction_mode: interaction_mode
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        defaultTeamType
    ]);
    const fireTextFieldBlurred = (0, $1oC0p.useCallback)(({ screenId: screenId, elementId: elementId, actionSubjectId: actionSubjectId = elementId, hasChanged: hasChanged, inputLength: inputLength, teamType: teamType = defaultTeamType.replace(/-/g, '_'), extraAttributes: extraAttributes })=>{
        const loginCookie = typeof window !== 'undefined' ? (0, $gx3aw.Cookie).readCookie('login_user_detected') : null;
        const loginUserDetected = loginCookie === 'true' ? 'true' : 'false';
        createAnalyticsEvent({
            actionSubject: 'textField',
            action: 'blurred',
            actionSubjectId: actionSubjectId,
            eventType: 'ui',
            source: 'jsm-playground',
            attributes: {
                trackEventName: 'blurred-mock-input',
                eventContainer: 'jsm-playground',
                team_type: teamType,
                screen_id: screenId,
                element_id: elementId,
                hasChanged: hasChanged,
                inputLength: inputLength,
                ...typeof window !== 'undefined' ? {
                    page_canonical_url: window.location.href,
                    page_path: window.location.pathname
                } : {},
                loginUserDetected: loginUserDetected,
                ...extraAttributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        defaultTeamType
    ]);
    const handlePreviewClick = (0, $1oC0p.useCallback)((event, screenId = 'request_queue')=>{
        // Do NOT fire when automated / scripted animations click components.
        if ($a01504c201c14593$export$9a2efd1554bcf7cf(event)) return;
        const target = event.target;
        if (!target) return;
        const interactiveElement = target.closest($a01504c201c14593$var$INTERACTIVE_SELECTOR);
        if (!interactiveElement) return;
        const elementType = $a01504c201c14593$var$resolveElementType(interactiveElement);
        const elementId = $a01504c201c14593$var$resolveElementId(interactiveElement);
        // Prevent duplicate rapid clicks on the same component (e.g. accidental double-clicks or clicking while view transitions out)
        const now = Date.now();
        if (lastClickRef.current && lastClickRef.current.id === elementId && now - lastClickRef.current.time < 400) return;
        lastClickRef.current = {
            id: elementId,
            time: now
        };
        const label = $a01504c201c14593$var$resolveLabel(interactiveElement);
        const canonicalUrl = $a01504c201c14593$var$getCanonicalUrl();
        const pagePath = $a01504c201c14593$var$getPagePath();
        const loginUser = $a01504c201c14593$var$getLoginUserDetected();
        const teamType = defaultTeamType.replace(/-/g, '_');
        createAnalyticsEvent({
            actionSubject: 'component',
            action: 'clicked',
            eventType: 'ui',
            source: 'jsm-playground',
            attributes: {
                trackEventName: 'clicked-mock-ui',
                eventContainer: 'jsm-playground',
                team_type: teamType,
                screen_id: screenId,
                element_type: elementType,
                element_id: elementId,
                ...label ? {
                    label: label
                } : {},
                ...canonicalUrl ? {
                    page_canonical_url: canonicalUrl
                } : {},
                ...pagePath ? {
                    page_path: pagePath
                } : {},
                loginUserDetected: loginUser
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        defaultTeamType
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent,
        firePlaygroundScreenNavigated: firePlaygroundScreenNavigated,
        fireTextFieldBlurred: fireTextFieldBlurred,
        handlePreviewClick: handlePreviewClick
    };
};

});

parcelRegister("cmk36", function(module, exports) {
$parcel$export(module.exports, "DEMO_CURSOR_TRAVEL_MS", function () { return $b8ec0b960b7efa80$export$959945fc6a9bcc0e; });
$parcel$export(module.exports, "DEMO_CURSOR_FADE_MS", function () { return $b8ec0b960b7efa80$export$b670d668a496dfc6; });
$parcel$export(module.exports, "JsmPlaygroundDemoCursor", function () { return $b8ec0b960b7efa80$export$76c62c6565f47d43; });
/* jsm-playground-demo-cursor.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gUjjH = parcelRequire("gUjjH");
const $b8ec0b960b7efa80$export$959945fc6a9bcc0e = 1050;
const $b8ec0b960b7efa80$export$b670d668a496dfc6 = 400;
const $b8ec0b960b7efa80$export$76c62c6565f47d43 = ({ x: x, y: y, isVisible: isVisible, isPressed: isPressed, isTransitionEnabled: isTransitionEnabled, hasUserTakenOver: hasUserTakenOver, label: label, testId: testId = 'jsm-playground-demo-cursor', container: container })=>{
    const isShown = isVisible && !hasUserTakenOver;
    const cursor = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "aria-hidden": "true",
        "data-visible": isShown,
        "data-testid": testId,
        style: {
            '--demo-cursor-opacity': isShown ? 1 : 0,
            '--demo-cursor-scale': isShown ? 1 : 0.92,
            '--demo-cursor-transition': isTransitionEnabled ? `transform ${$b8ec0b960b7efa80$export$959945fc6a9bcc0e}ms cubic-bezier(0.33, 0, 0.2, 1)` : 'transform 0ms',
            '--demo-cursor-x': `${x}px`,
            '--demo-cursor-y': `${y}px`
        },
        className: (0, $2jatx.default)([
            "_kqswstnw _152tidpf _1e02idpf _1pby1fw0 _lcxvglyw _tzy4gotc _t9ecxu9f _8hrz5d63 _v5641xbo _sedtglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                fill: "none",
                height: "24",
                viewBox: "0 0 23 23",
                width: "24",
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _1e02idpf _syaz16e3 _kdam4pu6 _t9ec1h7a _8hrz5d63 _v5641o3v _sedtglyw",
                    isPressed && "_t9ec1np6"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M7.735 22.62 0 0l22.585 7.771-9.899 4.951-4.951 9.898Z",
                    fill: "currentColor",
                    stroke: "white",
                    strokeWidth: "1.5"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tutpp _1e021ejb _1e0c116y _4cvr1h6o _1bah1h6o _1rjcv77o _18zrutpp _2rko1rr0 _bfhk16e3 _syaz15cr _11c81af2 _o5721q9c _16qs130s"
                ]),
                children: label
            })
        ]
    });
    return container ? /*#__PURE__*/ (0, $gUjjH.createPortal)(cursor, container) : cursor;
};
const $b8ec0b960b7efa80$var$cursorStyles = null;
const $b8ec0b960b7efa80$var$cursorArrowStyles = null;
const $b8ec0b960b7efa80$var$cursorArrowPressedStyles = null;
const $b8ec0b960b7efa80$var$cursorLabelStyles = null;

});

parcelRegister("g0WR9", function(module, exports) {
$parcel$export(module.exports, "rectWithin", function () { return $fbb8b320d88883d1$export$5d9a49bcc4a54dfe; });
$parcel$export(module.exports, "centerOf", function () { return $fbb8b320d88883d1$export$cafcc6d33cfa0d85; });
const $fbb8b320d88883d1$export$5d9a49bcc4a54dfe = (container, element)=>{
    const scale = Number(container.closest('[data-preview-scale]')?.getAttribute('data-preview-scale')) || 1;
    const containerBox = container.getBoundingClientRect();
    const box = element.getBoundingClientRect();
    const left = (box.left - containerBox.left) / scale;
    const top = (box.top - containerBox.top) / scale;
    const width = box.width / scale;
    const height = box.height / scale;
    return {
        left: left,
        top: top,
        right: left + width,
        bottom: top + height,
        width: width,
        height: height
    };
};
const $fbb8b320d88883d1$export$cafcc6d33cfa0d85 = (rect)=>({
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2
    });

});

parcelRegister("8eU08", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundDemoLayerContext", function () { return $f2b28c79f67838fc$export$f5abb57bb917abea; });
$parcel$export(module.exports, "useJsmPlaygroundDemoLayer", function () { return $f2b28c79f67838fc$export$5a36469928091434; });
$parcel$export(module.exports, "JsmPlaygroundSkipLayerContext", function () { return $f2b28c79f67838fc$export$4477faaa98dcacae; });
$parcel$export(module.exports, "useJsmPlaygroundSkipLayer", function () { return $f2b28c79f67838fc$export$821bed065d3ab02c; });

var $1oC0p = parcelRequire("1oC0p");
const $f2b28c79f67838fc$export$f5abb57bb917abea = (0, $1oC0p.createContext)(null);
const $f2b28c79f67838fc$export$5a36469928091434 = ()=>(0, $1oC0p.useContext)($f2b28c79f67838fc$export$f5abb57bb917abea);
const $f2b28c79f67838fc$export$4477faaa98dcacae = (0, $1oC0p.createContext)(null);
const $f2b28c79f67838fc$export$821bed065d3ab02c = ()=>(0, $1oC0p.useContext)($f2b28c79f67838fc$export$4477faaa98dcacae);

});

parcelRegister("8DlQO", function(module, exports) {
$parcel$export(module.exports, "useNotifyDemoComplete", function () { return $c176647b1389dacc$export$397550e2a9896a63; });
$parcel$export(module.exports, "useDemoTimeline", function () { return $c176647b1389dacc$export$1faa374aadda83d1; });
$parcel$export(module.exports, "useDemoCursor", function () { return $c176647b1389dacc$export$ab1c195fe2906077; });

var $1oC0p = parcelRequire("1oC0p");

var $bBczw = parcelRequire("bBczw");
const $c176647b1389dacc$export$397550e2a9896a63 = (onDemoComplete)=>{
    const onDemoCompleteRef = (0, $1oC0p.useRef)(onDemoComplete);
    onDemoCompleteRef.current = onDemoComplete;
    const hasNotifiedRef = (0, $1oC0p.useRef)(false);
    return (0, $1oC0p.useCallback)(()=>{
        if (hasNotifiedRef.current) return;
        hasNotifiedRef.current = true;
        onDemoCompleteRef.current?.();
    }, []);
};
const $c176647b1389dacc$export$1faa374aadda83d1 = (isEnabled, hasUserTakenOver, schedule)=>{
    const prefersReducedMotion = (0, $bBczw.usePrefersReducedMotion)();
    const hasUserTakenOverRef = (0, $1oC0p.useRef)(hasUserTakenOver);
    hasUserTakenOverRef.current = hasUserTakenOver;
    const scheduleRef = (0, $1oC0p.useRef)(schedule);
    scheduleRef.current = schedule;
    const shouldPlay = isEnabled && !prefersReducedMotion;
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldPlay) return;
        const timers = [];
        scheduleRef.current((ms, run)=>{
            timers.push(window.setTimeout(()=>{
                if (!hasUserTakenOverRef.current) run();
            }, ms));
        });
        return ()=>timers.forEach(window.clearTimeout);
    }, [
        shouldPlay
    ]);
};
const $c176647b1389dacc$var$ORIGIN = {
    x: 0,
    y: 0
};
const $c176647b1389dacc$export$ab1c195fe2906077 = (initialTarget)=>{
    const [cursor, setCursor] = (0, $1oC0p.useState)({
        target: initialTarget,
        isVisible: false,
        isPressed: false
    });
    const [stops, setStops] = (0, $1oC0p.useState)({});
    const [isTransitionEnabled, setIsTransitionEnabled] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        setIsTransitionEnabled(true);
    }, []);
    const updateCursor = (0, $1oC0p.useCallback)((next)=>setCursor((previous)=>({
                ...previous,
                ...next
            })), []);
    const updateStops = (0, $1oC0p.useCallback)((next)=>setStops((previous)=>({
                ...previous,
                ...next
            })), []);
    return {
        isVisible: cursor.isVisible,
        isPressed: cursor.isPressed,
        position: stops[cursor.target] ?? $c176647b1389dacc$var$ORIGIN,
        isTransitionEnabled: isTransitionEnabled,
        setIsTransitionEnabled: setIsTransitionEnabled,
        updateCursor: updateCursor,
        updateStops: updateStops
    };
};

});
parcelRegister("bBczw", function(module, exports) {
$parcel$export(module.exports, "staggerDelay", function () { return $b9ee875a7241a2d7$export$166424e1e659f679; });
$parcel$export(module.exports, "usePrefersReducedMotion", function () { return $b9ee875a7241a2d7$export$c170580b40c8999d; });

var $1oC0p = parcelRequire("1oC0p");
const $b9ee875a7241a2d7$var$REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
const $b9ee875a7241a2d7$export$7c0c5615d5b4a96b = 'cubic-bezier(0.2, 0, 0, 1)';
const $b9ee875a7241a2d7$export$166424e1e659f679 = (index, stepMs)=>`${index * stepMs}ms`;
const $b9ee875a7241a2d7$var$getPrefersReducedMotion = ()=>typeof window !== 'undefined' && window.matchMedia?.($b9ee875a7241a2d7$var$REDUCED_MOTION_QUERY).matches === true;
const $b9ee875a7241a2d7$export$c170580b40c8999d = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $1oC0p.useState)($b9ee875a7241a2d7$var$getPrefersReducedMotion);
    (0, $1oC0p.useEffect)(()=>{
        const query = window.matchMedia?.($b9ee875a7241a2d7$var$REDUCED_MOTION_QUERY);
        if (!query) return;
        const update = ()=>setPrefersReducedMotion(query.matches);
        query.addEventListener?.('change', update);
        return ()=>query.removeEventListener?.('change', update);
    }, []);
    return prefersReducedMotion;
};

});


parcelRegister("jGmnw", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundScreen", function () { return $b29b372c87362226$export$79ca7f2a2eca1d25; });
/* jsm-playground-screen.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $a9bUP = parcelRequire("a9bUP");
const $b29b372c87362226$export$79ca7f2a2eca1d25 = ({ config: config, teamName: teamName, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _4t3i1osq _1tkeidpf _2rkopb1k _bfhkvuon _1reo15vq _18m915vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9bUP.JsmPlaygroundNavigation), {
                config: config,
                teamName: teamName
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dl1wug _1tkeidpf _1ul9idpf _1reo15vq _18m915vq"
                ]),
                children: children
            })
        ]
    });
const $b29b372c87362226$var$screenStyles = null;
const $b29b372c87362226$var$contentStyles = null;

});
parcelRegister("a9bUP", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundNavigation", function () { return $8333b625c497d1a4$export$7993a9e366a6b5de; });
/* jsm-playground-navigation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $1q52J = parcelRequire("1q52J");
var $2r6UE = parcelRequire("2r6UE");

var $bIY3n = parcelRequire("bIY3n");

var $muyyw = parcelRequire("muyyw");

var $7rGE7 = parcelRequire("7rGE7");

var $6A2DX = parcelRequire("6A2DX");

var $lPRxe = parcelRequire("lPRxe");

var $c0yqw = parcelRequire("c0yqw");

var $5GoT9 = parcelRequire("5GoT9");
const $8333b625c497d1a4$var$noop = ()=>{};
// Subtle buttons still paint a neutral rest background. The preview keeps that
// surface transparent until hover, matching the prototype.
const $8333b625c497d1a4$var$playgroundSubtleButtonStyle = `
[data-testid="jsm-playground-preview"] button[class*="_bfhksm61"]:not(:hover):not(:active):not(:disabled) {
	background-color: transparent;
}
`;
const $8333b625c497d1a4$var$BackButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($muyyw))), {
        label: "",
        size: "medium"
    });
const $8333b625c497d1a4$var$CreateButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bIY3n))), {
        label: "",
        size: "medium"
    });
const $8333b625c497d1a4$var$CustomizeButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7rGE7))), {
        label: "",
        size: "medium"
    });
const $8333b625c497d1a4$var$AskRovoIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.RovoIcon), {
        appearance: "brand",
        label: "",
        shouldUseHexLogo: true,
        size: "xsmall"
    });
const $8333b625c497d1a4$var$JsmPlaygroundNavigationComponent = ({ config: config, teamName: teamName, onCustomizeHelpCenterClick: onCustomizeHelpCenterClick })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_vchhusvi _1bsb1osq _4t3ioahv _1o9zidpf _1r62e4h9 _12ornqa1 _1ezz1l7x _bfhkvuon _11c8fhey _uiztglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("style", {
                children: $8333b625c497d1a4$var$playgroundSubtleButtonStyle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                "data-testid": "jsm-navigation-preview-contents",
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulpu2gc _vchhusvi _1bsb1osq _4t3i1osq _1rjcu2gc _18zrutpp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        role: "img",
                        "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).navigationPreviewLabel, {
                            teamName: teamName
                        }),
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _1ul9idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            "aria-hidden": "true",
                            "data-testid": "jsm-navigation-preview-chrome",
                            // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
                            inert: "",
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _zulpu2gc _1ul9idpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulp1b66 _1ul9idpf _1o9zidpf"
                                    ]),
                                    children: [
                                        config.showBack && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                            appearance: "subtle",
                                            icon: $8333b625c497d1a4$var$BackButtonIcon,
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).back),
                                            onClick: $8333b625c497d1a4$var$noop,
                                            spacing: "compact",
                                            tabIndex: -1
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _4cvr1h6o _zulp12x7 _1ul9idpf _18zr1b66 _o5721q9c"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraServiceManagementIcon), {
                                                    appearance: "brand",
                                                    label: "",
                                                    shouldUseNewLogoDesign: true,
                                                    size: "small"
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                    color: "color.text",
                                                    maxLines: 1,
                                                    weight: "bold",
                                                    children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).productName)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                config.showSearch && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _zulpu2gc _1ul9idpf _p12fwjsk _195g1wug"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5GoT9.JsmPlaygroundSearchField), {
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).search),
                                            placeholder: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).search),
                                            tabIndex: -1
                                        }),
                                        config.showCreate && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                            iconBefore: $8333b625c497d1a4$var$CreateButtonIcon,
                                            onClick: $8333b625c497d1a4$var$noop,
                                            tabIndex: -1,
                                            children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).create)
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bahesu3 _zulp1b66 _1o9zidpf _ahbq1wug"
                        ]),
                        children: [
                            config.showAskRovo && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                "aria-hidden": "true",
                                // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
                                inert: "",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                    iconBefore: $8333b625c497d1a4$var$AskRovoIcon,
                                    onClick: $8333b625c497d1a4$var$noop,
                                    tabIndex: -1,
                                    children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).askRovo)
                                })
                            }),
                            config.showCustomizeHelpCenter && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                iconBefore: $8333b625c497d1a4$var$CustomizeButtonIcon,
                                onClick: onCustomizeHelpCenterClick,
                                testId: "customize-help-center-button",
                                children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).customizeHelpCenter)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                "aria-hidden": "true",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1ejb _4t3i1ejb _1o9zidpf _2rko1rr0 _bfhk16e3",
                                    config.avatarAppearance === 'outlined' && "_1bsb19zt _4t3i19zt _19it1qvz"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                    color: "color.text.inverse",
                                    size: config.avatarAppearance === 'outlined' ? 'large' : 'medium',
                                    weight: "semibold",
                                    children: config.avatarInitial
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $8333b625c497d1a4$export$7993a9e366a6b5de = /*#__PURE__*/ (0, $1oC0p.memo)($8333b625c497d1a4$var$JsmPlaygroundNavigationComponent);
const $8333b625c497d1a4$var$navigationStyles = null;
const $8333b625c497d1a4$var$navigationContentsStyles = null;
const $8333b625c497d1a4$var$navigationChromeStyles = null;
const $8333b625c497d1a4$var$navigationChromeContentsStyles = null;
const $8333b625c497d1a4$var$navigationStartStyles = null;
const $8333b625c497d1a4$var$productLockupStyles = null;
const $8333b625c497d1a4$var$navigationMiddleStyles = null;
const $8333b625c497d1a4$var$navigationEndStyles = null;
const $8333b625c497d1a4$var$avatarStyles = null;
const $8333b625c497d1a4$var$outlinedAvatarStyles = null;

});
parcelRegister("1q52J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $108c219517a2a539$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $ckNUU = parcelRequire("ckNUU");

var $jPKwg = parcelRequire("jPKwg");

var $8F9nW = parcelRequire("8F9nW");
var $108c219517a2a539$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $108c219517a2a539$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $108c219517a2a539$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $gnQ3X.default)(_ref, $108c219517a2a539$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $108c219517a2a539$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckNUU.default), (0, $c9bqK.default)({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jPKwg.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8F9nW.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jPKwg.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jPKwg.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8F9nW.default), {
        icon: iconAfter
    })));
}));
$108c219517a2a539$var$Button.displayName = 'Button';
var $108c219517a2a539$export$2e2bcd8739ae039 = $108c219517a2a539$var$Button;

});
parcelRegister("ckNUU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8fae12bed0110775$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $4ZpaI = parcelRequire("4ZpaI");

var $kPutE = parcelRequire("kPutE");

var $gyCsW = parcelRequire("gyCsW");

var $4UF4U = parcelRequire("4UF4U");

var $6ur0l = parcelRequire("6ur0l");

var $eowPk = parcelRequire("eowPk");

var $1wI0n = parcelRequire("1wI0n");

var $2CHGg = parcelRequire("2CHGg");

var $8eWBi = parcelRequire("8eWBi");

var $klbBV = parcelRequire("klbBV");

var $cUZ6H = parcelRequire("cUZ6H");
var $8fae12bed0110775$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $8fae12bed0110775$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $8fae12bed0110775$var$LOADING_LABEL = ', Loading';
var $8fae12bed0110775$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_2rko12b0 _1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $8fae12bed0110775$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $8fae12bed0110775$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $8fae12bed0110775$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
var $8fae12bed0110775$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $8fae12bed0110775$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $8fae12bed0110775$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $8fae12bed0110775$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $8fae12bed0110775$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $8fae12bed0110775$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $gnQ3X.default)(_ref, $8fae12bed0110775$var$_excluded);
    var localRef = (0, $1oC0p.useRef)(null);
    var splitButtonContext = (0, $8eWBi.useSplitButtonContext)();
    var loadingLabelId = (0, $4UF4U.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gyCsW.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $8fae12bed0110775$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eowPk.Pressable), (0, $c9bqK.default)({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $kPutE.default)([
            localRef,
            ref
        ]),
        xcss: (0, $4ZpaI.cx)($8fae12bed0110775$var$styles.base, isInteractive && (0, $6ur0l.fg)('platform-dst-motion-uplift-button') && $8fae12bed0110775$var$styles.interactiveMotion, appearance === 'default' && $8fae12bed0110775$var$defaultStyles.root, appearance === 'default' && isInteractive && $8fae12bed0110775$var$defaultStyles.interactive, appearance === 'primary' && $8fae12bed0110775$var$primaryStyles.root, appearance === 'primary' && isInteractive && $8fae12bed0110775$var$primaryStyles.interactive, appearance === 'rovo' && $8fae12bed0110775$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $8fae12bed0110775$var$rovoStyles.interactive, appearance === 'warning' && $8fae12bed0110775$var$warningStyles.root, appearance === 'warning' && isInteractive && $8fae12bed0110775$var$warningStyles.interactive, appearance === 'danger' && $8fae12bed0110775$var$dangerStyles.root, appearance === 'danger' && isInteractive && $8fae12bed0110775$var$dangerStyles.interactive, appearance === 'discovery' && $8fae12bed0110775$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $8fae12bed0110775$var$discoveryStyles.interactive, appearance === 'subtle' && $8fae12bed0110775$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $8fae12bed0110775$var$subtleStyles.interactive, $8fae12bed0110775$var$styles.linkDecorationUnset, isSelected && $8fae12bed0110775$var$selectedStyles.root, isSelected && isSplitButton && $8fae12bed0110775$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $8fae12bed0110775$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $8fae12bed0110775$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $8fae12bed0110775$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $8fae12bed0110775$var$selectedStyles.discovery, isDisabled && $8fae12bed0110775$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $8fae12bed0110775$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $8fae12bed0110775$var$defaultStyles.disabled, spacing === 'compact' && $8fae12bed0110775$var$styles.spacingCompact, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $8fae12bed0110775$var$styles.circle, shouldFitContainer && $8fae12bed0110775$var$styles.fullWidth, hasIconBefore && $8fae12bed0110775$var$styles.buttonIconBefore, hasIconAfter && $8fae12bed0110775$var$styles.buttonIconAfter, isIconButton && $8fae12bed0110775$var$styles.iconButton, isIconButton && spacing === 'compact' && $8fae12bed0110775$var$styles.iconButtonCompact, isLoading && $8fae12bed0110775$var$styles.loading, isSplitButton && $8fae12bed0110775$var$styles.splitButton, isNavigationSplitButton && $8fae12bed0110775$var$styles.navigationSplitButton),
        isDisabled: isDisabled,
        "aria-live": "polite"
    }, isLoading && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($8fae12bed0110775$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $klbBV.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2CHGg.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $2jatx.default)([
            $8fae12bed0110775$var$styles.loadingOverlay
        ])
    }, (0, $cUZ6H.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1wI0n.default), {
        id: loadingLabelId
    }, $8fae12bed0110775$var$LOADING_LABEL)));
});
var $8fae12bed0110775$export$2e2bcd8739ae039 = $8fae12bed0110775$var$ButtonBase;

});
parcelRegister("1wI0n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $11caea18e3f41994$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $11caea18e3f41994$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $11caea18e3f41994$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $2jatx.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$11caea18e3f41994$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $11caea18e3f41994$export$2e2bcd8739ae039 = $11caea18e3f41994$var$VisuallyHidden;

});

parcelRegister("2CHGg", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", function () { return $1e910374663a06be$export$4b86304b2c0d7e71; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $1e910374663a06be$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("8eWBi", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", function () { return $5ffd1666483d758a$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");

var $2CHGg = parcelRequire("2CHGg");
var $5ffd1666483d758a$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)((0, $2CHGg.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("klbBV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eceec6718a09794b$export$2e2bcd8739ae039; });
function $eceec6718a09794b$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $eceec6718a09794b$var$tabKeyCode = 9;
function $eceec6718a09794b$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $eceec6718a09794b$var$tabKeyCode) return;
    $eceec6718a09794b$var$abort(event);
}
function $eceec6718a09794b$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $eceec6718a09794b$var$abort,
        onMouseUpCapture: $eceec6718a09794b$var$abort,
        onKeyDownCapture: $eceec6718a09794b$var$onKey,
        onKeyUpCapture: $eceec6718a09794b$var$onKey,
        onTouchStartCapture: $eceec6718a09794b$var$abort,
        onTouchEndCapture: $eceec6718a09794b$var$abort,
        onPointerDownCapture: $eceec6718a09794b$var$abort,
        onPointerUpCapture: $eceec6718a09794b$var$abort,
        onClickCapture: $eceec6718a09794b$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $eceec6718a09794b$var$abort
    } : events;
}

});

parcelRegister("cUZ6H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $967a1d95adaf28b4$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $avJzq = parcelRequire("avJzq");
function $967a1d95adaf28b4$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $967a1d95adaf28b4$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $967a1d95adaf28b4$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $avJzq.default), {
        size: $967a1d95adaf28b4$var$getIconSpacing(spacing),
        appearance: $967a1d95adaf28b4$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("avJzq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7a7025f57eb9b800$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $H5IMV = parcelRequire("H5IMV");

var $gMRcL = parcelRequire("gMRcL");
/**
 * Returns the appropriate circle stroke color.
 */ function $7a7025f57eb9b800$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $7a7025f57eb9b800$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $7a7025f57eb9b800$var$loadIn = null;
var $7a7025f57eb9b800$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $7a7025f57eb9b800$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $7a7025f57eb9b800$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $gMRcL.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $7a7025f57eb9b800$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $H5IMV.default));
    $7a7025f57eb9b800$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $2jatx.default)([
            $7a7025f57eb9b800$var$styles.wrapperStyles,
            $7a7025f57eb9b800$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $2jatx.default)([
            $7a7025f57eb9b800$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $2jatx.default)([
            $7a7025f57eb9b800$var$styles.circleStyles
        ])
    })));
}));
var $7a7025f57eb9b800$export$2e2bcd8739ae039 = $7a7025f57eb9b800$var$Spinner;

});
parcelRegister("H5IMV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0818746a787e862c$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $0818746a787e862c$var$interactionContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $0818746a787e862c$export$2e2bcd8739ae039 = $0818746a787e862c$var$interactionContext;

});

parcelRegister("gMRcL", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $c38a6667908bcaee$export$4e9f1640bbe7a1a8; });
var $c38a6667908bcaee$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("jPKwg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e706dd813f9068ea$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");
var $e706dd813f9068ea$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $e706dd813f9068ea$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $2jatx.default)([
            $e706dd813f9068ea$var$styles.common,
            type === 'text' && $e706dd813f9068ea$var$styles.text,
            type === 'icon' && $e706dd813f9068ea$var$styles.icon,
            isLoading && $e706dd813f9068ea$var$styles.fade
        ])
    }, children);
};
var $e706dd813f9068ea$export$2e2bcd8739ae039 = $e706dd813f9068ea$var$Content;

});

parcelRegister("8F9nW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $64e96ec3dc735095$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");
function $64e96ec3dc735095$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $64e96ec3dc735095$var$IconRenderer = function IconRenderer(_ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var Icon = _ref.icon;
    var isRenderProp = $64e96ec3dc735095$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $6ur0l.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, iconProps));
};
var $64e96ec3dc735095$export$2e2bcd8739ae039 = $64e96ec3dc735095$var$IconRenderer;

});


parcelRegister("2r6UE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1c63771bdb1fdd34$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $kPutE = parcelRequire("kPutE");

var $fUXyt = parcelRequire("fUXyt");

var $1wI0n = parcelRequire("1wI0n");

var $ckNUU = parcelRequire("ckNUU");

var $jPKwg = parcelRequire("jPKwg");

var $8F9nW = parcelRequire("8F9nW");
var $1c63771bdb1fdd34$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $1c63771bdb1fdd34$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $1c63771bdb1fdd34$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $gnQ3X.default)(_ref, $1c63771bdb1fdd34$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $1c63771bdb1fdd34$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckNUU.default), (0, $c9bqK.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jPKwg.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8F9nW.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1wI0n.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fUXyt.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckNUU.default), (0, $c9bqK.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $kPutE.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jPKwg.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8F9nW.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1wI0n.default), null, label)));
    });
}));
$1c63771bdb1fdd34$var$IconButton.displayName = 'IconButton';
var $1c63771bdb1fdd34$export$2e2bcd8739ae039 = $1c63771bdb1fdd34$var$IconButton;

});
parcelRegister("fUXyt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b96a48583736ff8e$export$2e2bcd8739ae039; });
/* tooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");


var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $jUbDK = parcelRequire("jUbDK");

var $7uNuF = parcelRequire("7uNuF");

var $4P6qn = parcelRequire("4P6qn");

var $5l9My = parcelRequire("5l9My");

var $kpgcC = parcelRequire("kpgcC");

var $gZd9E = parcelRequire("gZd9E");

var $dU3Gh = parcelRequire("dU3Gh");

var $6ur0l = parcelRequire("6ur0l");

var $ifOBO = parcelRequire("ifOBO");

var $al2wi = parcelRequire("al2wi");

var $4rWUk = parcelRequire("4rWUk");

var $jp38o = parcelRequire("jp38o");

var $2chlf = parcelRequire("2chlf");

var $iQsXC = parcelRequire("iQsXC");

var $ik7PK = parcelRequire("ik7PK");

var $57q2L = parcelRequire("57q2L");

var $j4xd9 = parcelRequire("j4xd9");

var $6Bn3J = parcelRequire("6Bn3J");

var $be8YJ = parcelRequire("be8YJ");

var $5MmLX = parcelRequire("5MmLX");

var $fwFxZ = parcelRequire("fwFxZ");
function $b96a48583736ff8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b96a48583736ff8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b96a48583736ff8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b96a48583736ff8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b96a48583736ff8e$var$tooltipZIndex = (0, $4rWUk.layers).tooltip();
var $b96a48583736ff8e$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "24.2.1"
};
// Inverts motion direction
var $b96a48583736ff8e$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $b96a48583736ff8e$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
 * gate is off, so this cannot affect the legacy path even if it gains a caller
 * there.
 *
 * `mouseover` also fires when the pointer crosses boundaries between elements
 * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
 * distinguishes a real re-entry from one of those.
 */ function $b96a48583736ff8e$var$isTopLayerPointerReEntry(_ref) {
    var trigger = _ref.trigger, relatedTarget = _ref.relatedTarget;
    if (!(0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) return false;
    // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $b96a48583736ff8e$var$Tooltip(_ref2) {
    var children = _ref2.children, _ref2$position = _ref2.position, position = _ref2$position === void 0 ? 'bottom' : _ref2$position, _ref2$mousePosition = _ref2.mousePosition, mousePosition = _ref2$mousePosition === void 0 ? 'bottom' : _ref2$mousePosition, content = _ref2.content, _ref2$truncate = _ref2.truncate, truncate = _ref2$truncate === void 0 ? false : _ref2$truncate, _ref2$component = _ref2.component, Container = _ref2$component === void 0 ? (0, $fwFxZ.default) : _ref2$component, _ref2$tag = _ref2.tag, TargetContainer = _ref2$tag === void 0 ? 'div' : _ref2$tag, testId = _ref2.testId, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 300 : _ref2$delay, _ref2$onShow = _ref2.onShow, onShow = _ref2$onShow === void 0 ? (0, $7uNuF.default) : _ref2$onShow, _ref2$onHide = _ref2.onHide, onHide = _ref2$onHide === void 0 ? (0, $7uNuF.default) : _ref2$onHide, canAppear = _ref2.canAppear, _ref2$hideTooltipOnCl = _ref2.hideTooltipOnClick, hideTooltipOnClick = _ref2$hideTooltipOnCl === void 0 ? false : _ref2$hideTooltipOnCl, _ref2$hideTooltipOnMo = _ref2.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref2$hideTooltipOnMo === void 0 ? false : _ref2$hideTooltipOnMo, analyticsContext = _ref2.analyticsContext, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$ignoreTooltipPo = _ref2.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref2$ignoreTooltipPo === void 0 ? false : _ref2$ignoreTooltipPo, _ref2$isScreenReaderA = _ref2.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref2$isScreenReaderA === void 0 ? false : _ref2$isScreenReaderA, shortcut = _ref2.shortcut, _ref2$shouldAlwaysFad = _ref2.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref2$shouldAlwaysFad === void 0 ? false : _ref2$shouldAlwaysFad, _ref2$shouldRenderToP = _ref2.shouldRenderToParent, shouldRenderToParent = _ref2$shouldRenderToP === void 0 ? false : _ref2$shouldRenderToP;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $jUbDK.usePlatformLeafSyntheticEventHandler)($b96a48583736ff8e$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $b96a48583736ff8e$var$analyticsAttributes));
    var onHideHandler = (0, $jUbDK.usePlatformLeafSyntheticEventHandler)($b96a48583736ff8e$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $b96a48583736ff8e$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $5l9My.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $5l9My.default)(onShowHandler);
    var onHideHandlerStable = (0, $5l9My.default)(onHideHandler);
    var delayStable = (0, $5l9My.default)(delay);
    var canAppearStable = (0, $5l9My.default)(canAppear);
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $5l9My.default)(shouldAlwaysFadeIn);
    var start = (0, $1oC0p.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $57q2L.register)({
            onRegister: function onRegister(_ref3) {
                var isDragging = _ref3.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    var isTopLayerPointerDismissedRef = (0, $1oC0p.useRef)(false);
    var tryShowTooltip = (0, $1oC0p.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Stay dismissed until the trigger is re-entered or blurred. Otherwise
     * light dismiss hides on pointerup and the next `mouseover` from a
     * boundary crossing inside the trigger re-shows it. Deliberately after
     * the "already active" branch, so a held press stays visible.
     */ if (isTopLayerPointerDismissedRef.current && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) return;
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref4) {
                var isImmediate = _ref4.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref5) {
                var isImmediate = _ref5.isImmediate;
                if (isImmediate) setState('hide');
                else if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $be8YJ.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $4P6qn.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    var handleExitFinish = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    var handlePopoverClose = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current4;
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $7uNuF.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        var shouldCancelPendingShow = stableState.current === 'hide' && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        stableState
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($b96a48583736ff8e$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current5;
        if ((_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current6;
        (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 || _apiRef$current6.requestHide({
            isImmediate: true
        });
    }, []);
    // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $kpgcC.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $6ur0l.fg)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current7;
        if (isMousePosition && (_apiRef$current7 = apiRef.current) !== null && _apiRef$current7 !== void 0 && _apiRef$current7.mousePos && targetRef.current) return (0, $6Bn3J.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $5MmLX.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $1oC0p.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = shouldRenderToParent ? (0, $1oC0p.Fragment) : $b96a48583736ff8e$var$TooltipPortal;
    var trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children($b96a48583736ff8e$var$_objectSpread($b96a48583736ff8e$var$_objectSpread($b96a48583736ff8e$var$_objectSpread({}, tooltipTriggerProps), testId ? {
        testId: "".concat(testId, "--container")
    } : {}), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $c9bqK.default)({}, tooltipTriggerProps, testId ? {
        'data-testid': "".concat(testId, "--container")
    } : undefined, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent);
    if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) {
        var _apiRef$current$mouse, _apiRef$current8;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($b96a48583736ff8e$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: (_apiRef$current$mouse = (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.mousePos) !== null && _apiRef$current$mouse !== void 0 ? _apiRef$current$mouse : undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: handlePopoverClose,
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ifOBO.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref6) {
        var ref = _ref6.ref, style = _ref6.style, update = _ref6.update, placement = _ref6.placement;
        var direction = isMousePosition ? undefined : $b96a48583736ff8e$var$invertedDirection[$b96a48583736ff8e$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gZd9E.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dU3Gh.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref7) {
            var className = _ref7.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $b96a48583736ff8e$var$_objectSpread($b96a48583736ff8e$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $b96a48583736ff8e$export$2e2bcd8739ae039 = $b96a48583736ff8e$var$Tooltip;
var $b96a48583736ff8e$var$TooltipPortal = function TooltipPortal(_ref8) {
    var children = _ref8.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $al2wi.default), {
        zIndex: $b96a48583736ff8e$var$tooltipZIndex
    }, children);
};
var $b96a48583736ff8e$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $b96a48583736ff8e$var$TopLayerTooltipPopup(_ref9) {
    var targetRef = _ref9.targetRef, tooltipPosition = _ref9.tooltipPosition, mousePos = _ref9.mousePos, position = _ref9.position, onMouseOut = _ref9.onMouseOut, onMouseOverTooltip = _ref9.onMouseOverTooltip, ignoreTooltipPointerEvents = _ref9.ignoreTooltipPointerEvents, truncate = _ref9.truncate, testId = _ref9.testId, shortcut = _ref9.shortcut, content = _ref9.content, Container = _ref9.Container, onClose = _ref9.onClose, onExitFinish = _ref9.onExitFinish, isOpen = _ref9.isOpen;
    var popoverRef = (0, $1oC0p.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    var placement = (0, $jp38o.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    var isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    var isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $ik7PK.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: function getPoint() {
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $j4xd9.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2chlf.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? "".concat(testId, "--popover") : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $b96a48583736ff8e$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $b96a48583736ff8e$var$tooltipMouseAnimationStyles.exit,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
        className: "Tooltip",
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $7uNuF.default)
    }) : content));
}

});
parcelRegister("jUbDK", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $e7dc46c9836acabf$export$1a04351537078b55; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $lAeva = parcelRequire("lAeva");

var $lWotc = parcelRequire("lWotc");
function $e7dc46c9836acabf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7dc46c9836acabf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7dc46c9836acabf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7dc46c9836acabf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e7dc46c9836acabf$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $lAeva.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $lWotc.useTrackedRef)(analyticsData);
    var fnRef = (0, $lWotc.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e7dc46c9836acabf$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("lAeva", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $fb68357fafafdd60$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $5RlZD = parcelRequire("5RlZD");

var $f4iAl = parcelRequire("f4iAl");
function $fb68357fafafdd60$export$5bf35293e545f20c() {
    var analyticsContext = (0, $f4iAl.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $5RlZD.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("5RlZD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4442f657dad3794f$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");

var $hdfIu = parcelRequire("hdfIu");
function $4442f657dad3794f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4442f657dad3794f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4442f657dad3794f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4442f657dad3794f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4442f657dad3794f$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $4442f657dad3794f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $4442f657dad3794f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4442f657dad3794f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4442f657dad3794f$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $4442f657dad3794f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $4442f657dad3794f$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            var payload = $4442f657dad3794f$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $4442f657dad3794f$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $hdfIu.default));
var $4442f657dad3794f$var$clonePayload = function clonePayload(payload) {
    if ((0, $6ur0l.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $4442f657dad3794f$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};

});
parcelRegister("hdfIu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c87fd79143e202d8$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $c87fd79143e202d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c87fd79143e202d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c87fd79143e202d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c87fd79143e202d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c87fd79143e202d8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $c87fd79143e202d8$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $c87fd79143e202d8$var$_objectSpread($c87fd79143e202d8$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("f4iAl", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $af85a560d14e3cfe$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $af85a560d14e3cfe$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("lWotc", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $ff91fef53b794049$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $ff91fef53b794049$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("kpgcC", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $edb2b5e7f6eb9521$export$469bb693f11edc7f; });

var $1oC0p = parcelRequire("1oC0p");

var $hMJou = parcelRequire("hMJou");

var $jeBFR = parcelRequire("jeBFR");
function $edb2b5e7f6eb9521$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $1oC0p.useContext)((0, $hMJou.OpenLayerObserverContext));
    var namespace = (0, $jeBFR.useOpenLayerObserverNamespace)();
    (0, $1oC0p.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("hMJou", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $cf2a21ab655d369d$export$5fbf4d7fae6cdc00; });

var $1oC0p = parcelRequire("1oC0p");
var $cf2a21ab655d369d$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("jeBFR", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $e00c8c75157cad69$export$1d57e79091cc3046; });

var $1oC0p = parcelRequire("1oC0p");

var $dJkk7 = parcelRequire("dJkk7");
function $e00c8c75157cad69$export$1d57e79091cc3046() {
    var namespace = (0, $1oC0p.useContext)((0, $dJkk7.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("dJkk7", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $9fef3e2222b977b0$export$644a49f3b8c50fcd; });

var $1oC0p = parcelRequire("1oC0p");
var $9fef3e2222b977b0$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});



parcelRegister("gZd9E", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", function () { return $c5dc8c1ab055debc$export$b9c4904d7a6929e6; });
$parcel$export(module.exports, "default", function () { return $c5dc8c1ab055debc$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $c5dc8c1ab055debc$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $c5dc8c1ab055debc$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $1oC0p.createContext)($c5dc8c1ab055debc$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $c5dc8c1ab055debc$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c5dc8c1ab055debc$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($c5dc8c1ab055debc$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $c5dc8c1ab055debc$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1oC0p.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $c5dc8c1ab055debc$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $c5dc8c1ab055debc$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $c5dc8c1ab055debc$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $c5dc8c1ab055debc$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $c5dc8c1ab055debc$var$ExitingPersistence = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $1oC0p.useState)([
        null,
        children
    ]), _useState2 = (0, $2qaZZ.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)([]), _useState4 = (0, $2qaZZ.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $1oC0p.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $2qaZZ.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $c5dc8c1ab055debc$var$childrenToArray(previousChildren);
    var current = $c5dc8c1ab055debc$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $c5dc8c1ab055debc$var$childrenToArray(children) : current;
    var missingKeys = $c5dc8c1ab055debc$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $c5dc8c1ab055debc$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $6ur0l.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $c5dc8c1ab055debc$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $c5dc8c1ab055debc$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c5dc8c1ab055debc$export$2e2bcd8739ae039 = $c5dc8c1ab055debc$var$ExitingPersistence;
$c5dc8c1ab055debc$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("dU3Gh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1f35c45210c7c08$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6Lg72 = parcelRequire("6Lg72");
var $a1f35c45210c7c08$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $a1f35c45210c7c08$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $a1f35c45210c7c08$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6Lg72.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $a1f35c45210c7c08$export$2e2bcd8739ae039 = $a1f35c45210c7c08$var$FadeIn;

});
parcelRegister("6Lg72", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ec3a17712f55a9a$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gFFNh = parcelRequire("gFFNh");

var $7uCPi = parcelRequire("7uCPi");

var $jXrKs = parcelRequire("jXrKs");

var $870LM = parcelRequire("870LM");

var $01Lf5 = parcelRequire("01Lf5");

var $cSL79 = parcelRequire("cSL79");
var $4ec3a17712f55a9a$var$zoomIn = null;
var $4ec3a17712f55a9a$var$zoomOut = null;
var $4ec3a17712f55a9a$var$fadeIn = null;
var $4ec3a17712f55a9a$var$fadeOut = null;
var $4ec3a17712f55a9a$var$fadeInFromTop = null;
var $4ec3a17712f55a9a$var$fadeOutFromTop = null;
var $4ec3a17712f55a9a$var$fadeInFromLeft = null;
var $4ec3a17712f55a9a$var$fadeOutFromLeft = null;
var $4ec3a17712f55a9a$var$fadeInFromBottom = null;
var $4ec3a17712f55a9a$var$fadeOutFromBottom = null;
var $4ec3a17712f55a9a$var$fadeInFromRight = null;
var $4ec3a17712f55a9a$var$fadeOutFromRight = null;
var $4ec3a17712f55a9a$var$fadeInFromTopConstant = null;
var $4ec3a17712f55a9a$var$fadeOutFromTopConstant = null;
var $4ec3a17712f55a9a$var$fadeInFromLeftConstant = null;
var $4ec3a17712f55a9a$var$fadeOutFromLeftConstant = null;
var $4ec3a17712f55a9a$var$fadeInFromBottomConstant = null;
var $4ec3a17712f55a9a$var$fadeOutFromBottomConstant = null;
var $4ec3a17712f55a9a$var$fadeInFromRightConstant = null;
var $4ec3a17712f55a9a$var$fadeOutFromRightConstant = null;
var $4ec3a17712f55a9a$var$slideInFromTop = null;
var $4ec3a17712f55a9a$var$slideOutFromTop = null;
var $4ec3a17712f55a9a$var$slideInFromRight = null;
var $4ec3a17712f55a9a$var$slideOutFromRight = null;
var $4ec3a17712f55a9a$var$slideInFromBottom = null;
var $4ec3a17712f55a9a$var$slideOutFromBottom = null;
var $4ec3a17712f55a9a$var$slideInFromLeft = null;
var $4ec3a17712f55a9a$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $4ec3a17712f55a9a$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $cSL79.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $01Lf5.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $870LM.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $1oC0p.useState)(appear), _useState2 = (0, $2qaZZ.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $jXrKs.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $7uCPi.exitingDurations)[duration] : (0, $gFFNh.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $2jatx.default)([
            (0, $2jatx.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $2jatx.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $2jatx.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $2jatx.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $2jatx.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $2jatx.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $2jatx.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $2jatx.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $2jatx.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $2jatx.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $2jatx.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $2jatx.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $2jatx.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $2jatx.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $2jatx.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $2jatx.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $2jatx.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $2jatx.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $2jatx.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $2jatx.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $2jatx.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $2jatx.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $2jatx.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $2jatx.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $2jatx.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $2jatx.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $2jatx.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $2jatx.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $2jatx.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $2jatx.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $2jatx.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $2jatx.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $2jatx.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $2jatx.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $2jatx.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $2jatx.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $2jatx.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $2jatx.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $2jatx.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $2jatx.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $2jatx.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $2jatx.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $2jatx.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $2jatx.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $2jatx.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $2jatx.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $2jatx.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $2jatx.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $2jatx.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $2jatx.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $2jatx.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $4ec3a17712f55a9a$export$2e2bcd8739ae039 = $4ec3a17712f55a9a$var$EnteringMotion;

});
parcelRegister("gFFNh", function(module, exports) {
$parcel$export(module.exports, "durations", function () { return $c230e513d6a6fe0b$export$38b928a7167ce124; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $c230e513d6a6fe0b$export$368bacef0dacbe05 = 25;
var $c230e513d6a6fe0b$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("7uCPi", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", function () { return $574973de4aee6014$export$30fa1a2e62ae150c; });

var $gFFNh = parcelRequire("gFFNh");
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $574973de4aee6014$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $574973de4aee6014$export$30fa1a2e62ae150c = {
    none: (0, $gFFNh.durations).none,
    small: (0, $gFFNh.durations).small * $574973de4aee6014$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $gFFNh.durations).medium * $574973de4aee6014$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $gFFNh.durations).large * $574973de4aee6014$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("jXrKs", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $e8790d44b9c1582f$export$b7baf7667a68d87c; });

var $kt1Rb = parcelRequire("kt1Rb");
var $e8790d44b9c1582f$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $kt1Rb.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("kt1Rb", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", function () { return $ee67f4d1373e3bd8$export$c5406bd59b374abd; });
var $ee67f4d1373e3bd8$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("870LM", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", function () { return $5e7f9306f8dac412$export$4f34107a2b00f39c; });

var $1oC0p = parcelRequire("1oC0p");
// Handle both browser and Node.js environments
var $5e7f9306f8dac412$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $5e7f9306f8dac412$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $5e7f9306f8dac412$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("01Lf5", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", function () { return $0054bd784ba62103$export$3b6f38abbdcbd000; });

var $1oC0p = parcelRequire("1oC0p");

var $gZd9E = parcelRequire("gZd9E");
var $0054bd784ba62103$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1oC0p.useContext)((0, $gZd9E.ExitingContext));
};

});

parcelRegister("cSL79", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", function () { return $960f1320129ddc24$export$25c7213fc07ec080; });

var $1oC0p = parcelRequire("1oC0p");

var $gNkpg = parcelRequire("gNkpg");

var $02C3S = parcelRequire("02C3S");
var $960f1320129ddc24$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $gNkpg.useUniqueId)();
    var context = (0, $1oC0p.useContext)((0, $02C3S.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("gNkpg", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", function () { return $c3a10d418b9b7633$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1oC0p = parcelRequire("1oC0p");
function $c3a10d418b9b7633$export$c485849f2e393253() {
    var identifier = (0, $1oC0p.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("02C3S", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", function () { return $007db6422c7790b6$export$5e65d7d58ae96ad8; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $62WDq = parcelRequire("62WDq");
var $007db6422c7790b6$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $7uNuF.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $007db6422c7790b6$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1oC0p.useRef)([]);
    var indexes = [];
    var _useState = (0, $1oC0p.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $2qaZZ.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $62WDq.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($007db6422c7790b6$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$007db6422c7790b6$export$2e2bcd8739ae039 = $007db6422c7790b6$var$StaggeredEntrance;

});
parcelRegister("62WDq", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $467069a810ef6edc$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $467069a810ef6edc$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});





parcelRegister("ifOBO", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $d4a0e293ccea340e$export$badac9ada3a0bdf9; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $eVddu = parcelRequire("eVddu");

var $6ur0l = parcelRequire("6ur0l");

var $cyMMK = parcelRequire("cyMMK");

var $ckpbE = parcelRequire("ckpbE");

// Export types from PopperJS / React Popper
var $d4a0e293ccea340e$var$viewportPadding = 5;
var $d4a0e293ccea340e$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $d4a0e293ccea340e$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $d4a0e293ccea340e$var$defaultChildrenFn() {
    return null;
}
var $d4a0e293ccea340e$var$defaultOffset = [
    0,
    8
];
function $d4a0e293ccea340e$export$badac9ada3a0bdf9(_ref) {
    var children = _ref.children, offset = _ref.offset, placement = _ref.placement, referenceElement = _ref.referenceElement, modifiers = _ref.modifiers, strategy = _ref.strategy, shouldFitViewport = _ref.shouldFitViewport;
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $6ur0l.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckpbE.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($d4a0e293ccea340e$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $d4a0e293ccea340e$var$LegacyPopper(_ref2) {
    var _ref2$children = _ref2.children, children = _ref2$children === void 0 ? $d4a0e293ccea340e$var$defaultChildrenFn : _ref2$children, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? $d4a0e293ccea340e$var$defaultOffset : _ref2$offset, _ref2$placement = _ref2.placement, placement = _ref2$placement === void 0 ? 'bottom-start' : _ref2$placement, _ref2$referenceElemen = _ref2.referenceElement, referenceElement = _ref2$referenceElemen === void 0 ? undefined : _ref2$referenceElemen, modifiers = _ref2.modifiers, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$shouldFitViewpo = _ref2.shouldFitViewport, shouldFitViewport = _ref2$shouldFitViewpo === void 0 ? false : _ref2$shouldFitViewpo;
    var _offset = (0, $2qaZZ.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $d4a0e293ccea340e$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $cyMMK.getMaxSizeModifiers)({
            viewportPadding: $d4a0e293ccea340e$var$viewportPadding
        }) : [];
        return [].concat($d4a0e293ccea340e$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $lFOXD.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $lFOXD.default)(internalModifiers), (0, $lFOXD.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eVddu.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("cyMMK", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $924e80bd086d6981$export$6d8c2b45c99d6e3f; });

var $2qaZZ = parcelRequire("2qaZZ");
function $924e80bd086d6981$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $2qaZZ.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});

parcelRegister("ckpbE", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", function () { return $8f9ae3e5e097304e$export$9802f50720ab826e; });
/* popper-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2qaZZ = parcelRequire("2qaZZ");


var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $jp38o = parcelRequire("jp38o");

var $2chlf = parcelRequire("2chlf");

var $iQsXC = parcelRequire("iQsXC");

var $ik7PK = parcelRequire("ik7PK");

var $8mOPg = parcelRequire("8mOPg");

var $2oBVx = parcelRequire("2oBVx");

var $hbDos = parcelRequire("hbDos");

var $a5gJN = parcelRequire("a5gJN");

var $bbpQp = parcelRequire("bbpQp");

var $1LWuw = parcelRequire("1LWuw");

var $ePv39 = parcelRequire("ePv39");

var $gFKSN = parcelRequire("gFKSN");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ var $8f9ae3e5e097304e$var$noopStyle = {};
var $8f9ae3e5e097304e$var$noopSetRef = (0, $7uNuF.default);
var $8f9ae3e5e097304e$var$noopUpdate = function noopUpdate() {
    return Promise.resolve(null);
};
var $8f9ae3e5e097304e$var$noopForceUpdate = function noopForceUpdate() {
    return {};
};
/**
 * `react-popper` stamps `data-popper-arrow` on the arrow element at runtime
 * but does not declare it on `arrowProps`. Widen the type so consumers that
 * rely on the attribute (CSS selectors, snapshots, tests) keep working.
 */ var $8f9ae3e5e097304e$var$noopArrowProps = {
    ref: $8f9ae3e5e097304e$var$noopSetRef,
    style: $8f9ae3e5e097304e$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function $8f9ae3e5e097304e$var$getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $8f9ae3e5e097304e$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    var _offset = (0, $2qaZZ.default)(offset, 2), along = _offset[0], away = _offset[1];
    if (along == null && away == null) return undefined;
    return [
        along !== null && along !== void 0 ? along : 0,
        away !== null && away !== void 0 ? away : 0
    ];
}
function $8f9ae3e5e097304e$export$9802f50720ab826e(_ref) {
    var _ref2;
    var children = _ref.children, offset = _ref.offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, referenceElement = _ref.referenceElement, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    var managerAnchor = (0, $ePv39.useManagerAnchor)();
    var effectiveReference = (_ref2 = referenceElement !== null && referenceElement !== void 0 ? referenceElement : managerAnchor) !== null && _ref2 !== void 0 ? _ref2 : undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    var htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    var virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    var htmlAnchorRef = (0, $1oC0p.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    var popoverRef = (0, $1oC0p.useRef)(null);
    var popoverId = (0, $8mOPg.usePopoverId)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    var _useState = (0, $1oC0p.useState)(htmlAnchor), _useState2 = (0, $2qaZZ.default)(_useState, 2), resolvedAnchor = _useState2[0], setResolvedAnchor = _useState2[1];
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    var topLayerPlacement = (0, $1oC0p.useMemo)(function() {
        return (0, $jp38o.fromLegacyPlacement)({
            legacy: (0, $bbpQp.toLegacyPlacement)(placement),
            offset: $8f9ae3e5e097304e$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    var isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: htmlAnchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen: isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    var virtualReferenceRef = (0, $1oC0p.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    var topLayerPlacementRef = (0, $1oC0p.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    var isVirtualEnabled = virtualReference != null;
    (0, $ik7PK.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen: isOpen,
        getPoint: function getPoint() {
            var current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $a5gJN.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $hbDos.isPageRtl)()
            });
        }
    });
    var _useReferenceVisibili = (0, $gFKSN.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    }), isReferenceHidden = _useReferenceVisibili.isReferenceHidden, hasPopperEscaped = _useReferenceVisibili.hasPopperEscaped;
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, $2oBVx.useWidthFromAnchor)({
        mode: 'none',
        popoverRef: popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen: isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    var resolvedOffset = $8f9ae3e5e097304e$var$popperToTopLayerOffset(offset);
    var fitGap = resolvedOffset ? "".concat(resolvedOffset[1], "px") : "var(--ds-space-100, 8px)";
    var placementAxis = $8f9ae3e5e097304e$var$getPlacementAxis(placement);
    (0, $1LWuw.useFitViewportMaxSize)({
        target: popoverRef,
        placementAxis: placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen: isOpen
    });
    var renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    var renderPropArg = {
        ref: $8f9ae3e5e097304e$var$noopSetRef,
        style: $8f9ae3e5e097304e$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $8f9ae3e5e097304e$var$noopUpdate,
        forceUpdate: $8f9ae3e5e097304e$var$noopForceUpdate,
        arrowProps: $8f9ae3e5e097304e$var$noopArrowProps
    };
    var content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2chlf.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false
    }, content);
}

});
parcelRegister("hbDos", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", function () { return $033a9cfdecb901d8$export$175375e9a2b5515d; });

var $7jKo6 = parcelRequire("7jKo6");
function $033a9cfdecb901d8$export$175375e9a2b5515d() {
    var document = (0, $7jKo6.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});
parcelRegister("7jKo6", function(module, exports) {
$parcel$export(module.exports, "getDocument", function () { return $553e4a68b3db4dd1$export$f65ca476c09acec0; });
var $553e4a68b3db4dd1$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("a5gJN", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", function () { return $75775abe4f7f1f00$export$b065aeb850c3e87f; });
/**
 * Reduces an anchor rect to the single viewport point that, wrapped in a
 * zero-size synthetic anchor, produces the same popover position
 * `useAnchorPosition` would for the given placement. This works because
 * `useAnchorPosition` only reads the edge / alignment corner of the rect,
 * so a coincident zero-size point is geometrically equivalent.
 *
 * RTL is resolved here so the downstream synthetic anchor only sees physical
 * coordinates. Defaults mirror `getPlacement` in
 * `@atlaskit/top-layer/placement-map` (`axis: 'block'`, `edge: 'end'`,
 * `align: 'center'`).
 */ function $75775abe4f7f1f00$export$b065aeb850c3e87f(_ref) {
    var _placement$axis, _placement$edge, _placement$align;
    var rect = _ref.rect, placement = _ref.placement, isRtl = _ref.isRtl;
    var axis = (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block';
    var edge = (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end';
    var align = (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        var _y = edge === 'start' ? rect.top : rect.bottom;
        var _x = $75775abe4f7f1f00$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: _x,
            y: _y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    var x = $75775abe4f7f1f00$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    var y = $75775abe4f7f1f00$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $75775abe4f7f1f00$var$horizontalForAlign(_ref2) {
    var rect = _ref2.rect, align = _ref2.align, isRtl = _ref2.isRtl;
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    var isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $75775abe4f7f1f00$var$verticalForAlign(_ref3) {
    var rect = _ref3.rect, align = _ref3.align;
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $75775abe4f7f1f00$var$inlineEdgeX(_ref4) {
    var rect = _ref4.rect, edge = _ref4.edge, isRtl = _ref4.isRtl;
    var isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("bbpQp", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", function () { return $8244c4ee16b1ce76$export$e9a6fdb80170ffd; });
/**
 * `@popperjs/core`'s `Placement` union is a strict subset of `TLegacyPlacement`
 * (the placement-map adds `top-center` / `bottom-center` on top of popper's
 * enum), so every value popper hands us is a valid legacy placement.
 *
 * The cast keeps the runtime path free of an extra module-level lookup that
 * bundlers can occasionally fail to wire up (observed as `Cannot read
 * properties of undefined (reading 'includes')` in component-test bundles).
 *
 * Shared so the React and imperative popper adapters resolve this identically.
 */ function $8244c4ee16b1ce76$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("1LWuw", function(module, exports) {
$parcel$export(module.exports, "useFitViewportMaxSize", function () { return $14a78d62e987bdf4$export$f16d8ac7373995e1; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $3KAUQ = parcelRequire("3KAUQ");
/**
 * Applies the `shouldFitViewport` size caps directly to the
 * `position-area`-anchored popover host. Pure CSS — the browser owns every
 * value, so there is no measurement, no scroll/resize listeners, and no
 * `--ds-popper-anchor-*` custom properties.
 *
 * **Primary (placement) axis** is capped to `calc(100% - 5px - gap)`. Because
 * the host carries `position-area`, its containing block *is* the position-area
 * cell — the region between the anchor edge and the viewport edge — so `100%`
 * resolves to that distance. The popover is pushed `gap` into the cell by its
 * offset margin (`margin-*`, set by `useAnchorPosition`), so the gap is
 * subtracted as well to keep the legacy `viewportPadding = 5` on the far edge.
 * The cap is also more correct than measuring the requested placement: the cell
 * follows whichever side `position-try-fallbacks` actually flips to, so it
 * tracks the flip automatically.
 *
 * **Cross axis** is capped to `calc(100dvw|dvh - 10px)` (viewport, legacy
 * `2 * viewportPadding`). `display: flex` (plus a `min-*-size: 0` reset on the
 * child) lets an oversized child shrink and reflow to the cap. The host stays
 * `overflow: visible` so it never clips the consumer surface's `box-shadow`;
 * scrolling content that cannot reflow is the consumer surface's own
 * responsibility (it owns `overflow`), matching legacy `react-popper`, which
 * applied the cap to the consumer's own element.
 *
 * `min-inline-size` is reset to `0`. `useWidthFromAnchor({ mode: 'none' })`
 * floors the host at `max-content` so a too-narrow span overflows and drives
 * `position-try-fallbacks` rather than wrapping. That floor is the opposite of
 * fitting: when it exceeds a cap, CSS min/max resolution lets the min win and
 * the host overflows the viewport. In fit mode the caps must win, so the floor
 * is neutralised here; `setStyle` restores the prior inline value on cleanup.
 *
 * Verified in Chromium: `max-block-size: calc(100% - …)` on a `position: fixed`
 * + `position-area` element resolves `100%` to the cell, not the viewport.
 */ var $14a78d62e987bdf4$var$CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
var $14a78d62e987bdf4$var$CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ var $14a78d62e987bdf4$var$VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ var $14a78d62e987bdf4$var$NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function $14a78d62e987bdf4$export$f16d8ac7373995e1(_ref) {
    var target = _ref.target, placementAxis = _ref.placementAxis, gap = _ref.gap, isEnabled = _ref.isEnabled, isOpen = _ref.isOpen;
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = target.current;
        if (!element || !isEnabled) return;
        var isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        var primaryAxisCap = "calc(100% - 5px - ".concat(gap, ")");
        var cleanupHost = (0, $3KAUQ.setStyle)({
            element: element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                //
                // This package only uses `mode: 'none'`. Note that `mode: 'min-anchor'`
                // puts its ANCHOR floor on the same property, so pairing this hook with
                // that mode would drop the anchor floor rather than a content floor. See
                // `@atlaskit/top-layer` `notes/decisions/width-from-anchor-floors.md`.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: $14a78d62e987bdf4$var$CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: $14a78d62e987bdf4$var$CROSS_BLOCK_CAP
                }
            ].concat((0, $lFOXD.default)($14a78d62e987bdf4$var$NON_ANCHOR_MARGIN_SIDES[placementAxis].map(function(property) {
                return {
                    property: property,
                    value: $14a78d62e987bdf4$var$VIEWPORT_PADDING
                };
            })))
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        var child = element.firstElementChild;
        var cleanupChild = child instanceof HTMLElement ? (0, $3KAUQ.setStyle)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return function() {
            cleanupHost();
            cleanupChild === null || cleanupChild === void 0 || cleanupChild();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}

});
parcelRegister("3KAUQ", function(module, exports) {
$parcel$export(module.exports, "setStyle", function () { return $2bb24db2502218b0$export$37a5fde709c1db82; });
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ function $2bb24db2502218b0$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("ePv39", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", function () { return $acbde9f2d71434af$export$941a7e8bf0b9eafd; });

var $1oC0p = parcelRequire("1oC0p");

var $3d6gN = parcelRequire("3d6gN");
function $acbde9f2d71434af$export$941a7e8bf0b9eafd() {
    return (0, $1oC0p.useContext)((0, $3d6gN.AnchorContext));
}

});
parcelRegister("3d6gN", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", function () { return $2567731303eebd89$export$8f73317645bb7b8e; });

var $1oC0p = parcelRequire("1oC0p");
var $2567731303eebd89$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});


parcelRegister("gFKSN", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", function () { return $c234d79f57bc2961$export$61d36e2b682e92f7; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $cQ6jD = parcelRequire("cQ6jD");
var $c234d79f57bc2961$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $c234d79f57bc2961$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $c234d79f57bc2961$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $c234d79f57bc2961$var$isClippedByAncestors(element) {
    var rect = element.getBoundingClientRect();
    var parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        var style = window.getComputedStyle(parent);
        var clipsHorizontally = $c234d79f57bc2961$var$isClippingOverflow(style.overflowX);
        var clipsVertically = $c234d79f57bc2961$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            var parentRect = parent.getBoundingClientRect();
            var horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            var verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $c234d79f57bc2961$export$61d36e2b682e92f7(_ref) {
    var anchor = _ref.anchor, popoverRef = _ref.popoverRef;
    var _useState = (0, $1oC0p.useState)($c234d79f57bc2961$var$INITIAL), _useState2 = (0, $2qaZZ.default)(_useState, 2), visibility = _useState2[0], setVisibility = _useState2[1];
    var measure = (0, $1oC0p.useCallback)(function() {
        if (!anchor) {
            setVisibility(function(previous) {
                return previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $c234d79f57bc2961$var$INITIAL;
            });
            return;
        }
        var viewport = (0, $cQ6jD.readViewport)();
        var anchorRect = anchor.getBoundingClientRect();
        var isReferenceHidden = $c234d79f57bc2961$var$isFullyOutsideViewport(anchorRect, viewport) || $c234d79f57bc2961$var$isClippedByAncestors(anchor);
        var popoverElement = popoverRef.current;
        var hasPopperEscaped = popoverElement ? $c234d79f57bc2961$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility(function(previous) {
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $1oC0p.useLayoutEffect)(function() {
        measure();
        if (typeof window === 'undefined') return undefined;
        var cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            var observer = new ResizeObserver(function() {
                return measure();
            });
            observer.observe(anchor);
            cleanups.push(function() {
                return observer.disconnect();
            });
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $dH1HR.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        var visual = window.visualViewport;
        if (visual) cleanups.push((0, $dH1HR.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return function() {
            cleanups.forEach(function(cleanup) {
                return cleanup();
            });
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("cQ6jD", function(module, exports) {
$parcel$export(module.exports, "readViewport", function () { return $958f3d88e0476523$export$64beed533e21f72d; });
/**
 * Returns the current viewport size in CSS pixels, preferring the visual
 * viewport (which accounts for pinch-zoom on touch devices) over the
 * layout viewport. Returns `{ width: 0, height: 0 }` in non-DOM
 * environments so callers can use the result unconditionally.
 */ function $958f3d88e0476523$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    var visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("al2wi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $786dd1f145e28c7f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $5dtvW = parcelRequire("5dtvW");

var $84ZGM = parcelRequire("84ZGM");

var $ekunX = parcelRequire("ekunX");

var $hajy9 = parcelRequire("hajy9");
function $786dd1f145e28c7f$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy, _ref$isClosed = _ref.isClosed, isClosed = _ref$isClosed === void 0 ? false : _ref$isClosed;
    var isSubsequentRender = (0, $ekunX.default)(mountStrategy);
    (0, $hajy9.default)(zIndex);
    return !(0, $6ur0l.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5dtvW.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $84ZGM.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}

});
parcelRegister("5dtvW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3cc50f87b2ee00c3$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $lFvcp = parcelRequire("lFvcp");

var $lpXSX = parcelRequire("lpXSX");

var $kE1ER = parcelRequire("kE1ER");

var $6ur0l = parcelRequire("6ur0l");

var $kFhR9 = parcelRequire("kFhR9");

var $ad16n = parcelRequire("ad16n");

var $6G3Rr = parcelRequire("6G3Rr");
function $3cc50f87b2ee00c3$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, _props$isClosed = props.isClosed, isClosed = _props$isClosed === void 0 ? false : _props$isClosed;
    var container = (0, $1oC0p.useMemo)(function() {
        return (0, $ad16n.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $lpXSX.useColorMode)();
    var isInsideThemeProvider = (0, $kE1ER.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $kFhR9.appendPortalContainerIfNotAppended)(container);
    (0, $1oC0p.useEffect)(function() {
        if ((0, $6ur0l.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $6G3Rr.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            (0, $6G3Rr.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lFvcp.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("lFvcp", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", function () { return $fc65a0cd27e86ce6$export$d8964aec282183a3; });
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $cn8ql = parcelRequire("cn8ql");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2jatx = parcelRequire("2jatx");

var $5Cxn4 = parcelRequire("5Cxn4");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $ddwoZ = parcelRequire("ddwoZ");

var $6CEKe = parcelRequire("6CEKe");

var $kjchv = parcelRequire("kjchv");

var $kBO8D = parcelRequire("kBO8D");

var $gB7F3 = parcelRequire("gB7F3");

var $4BV7u = parcelRequire("4BV7u");

var $iT08I = parcelRequire("iT08I");

var $3027V = parcelRequire("3027V");

var $3LpCd = parcelRequire("3LpCd");

var $kE1ER = parcelRequire("kE1ER");

var $jmuXs = parcelRequire("jmuXs");
function $fc65a0cd27e86ce6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc65a0cd27e86ce6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc65a0cd27e86ce6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc65a0cd27e86ce6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fc65a0cd27e86ce6$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $fc65a0cd27e86ce6$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $fc65a0cd27e86ce6$var$prefersDarkModeMql = $fc65a0cd27e86ce6$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $fc65a0cd27e86ce6$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $fc65a0cd27e86ce6$var$prefersDarkModeMql !== null && $fc65a0cd27e86ce6$var$prefersDarkModeMql !== void 0 && $fc65a0cd27e86ce6$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $fc65a0cd27e86ce6$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $fc65a0cd27e86ce6$export$d8964aec282183a3(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $1oC0p.useState)(defaultColorMode), _useState2 = (0, $2qaZZ.default)(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)($fc65a0cd27e86ce6$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, $2qaZZ.default)(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return $fc65a0cd27e86ce6$var$_objectSpread($fc65a0cd27e86ce6$var$_objectSpread({}, $fc65a0cd27e86ce6$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $1oC0p.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($fc65a0cd27e86ce6$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $1oC0p.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $fc65a0cd27e86ce6$var$_objectSpread($fc65a0cd27e86ce6$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $1oC0p.useRef)(null);
    var isInsideAppProvider = (0, $gB7F3.useIsInsideAppProvider)();
    var isAppProviderThemingEnabled = (0, $kBO8D.useIsAppProviderThemingEnabled)();
    var isInsideThemeProvider = (0, $kE1ER.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $1oC0p.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return lastSetGlobalThemePromiseRef.current;
                            case 1:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return cleanupLastFnCall();
                            case 1:
                                promise = (0, $kjchv.setGlobalTheme)($fc65a0cd27e86ce6$var$_objectSpread($fc65a0cd27e86ce6$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $jmuXs.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!$fc65a0cd27e86ce6$var$prefersDarkModeMql) return;
        var unbindListener = (0, $dH1HR.bind)($fc65a0cd27e86ce6$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $fc65a0cd27e86ce6$var$_objectSpread($fc65a0cd27e86ce6$var$_objectSpread({}, (0, $6CEKe.getThemeHtmlAttrs)($fc65a0cd27e86ce6$var$_objectSpread($fc65a0cd27e86ce6$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, $f53LC.default)({}, (0, $ddwoZ.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iT08I.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4BV7u.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3027V.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3LpCd.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3LpCd.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", (0, $c9bqK.default)({}, attrs, {
        className: (0, $2jatx.default)([
            $fc65a0cd27e86ce6$var$contentStyles.body
        ])
    }), children) : children)))));
}

});
parcelRegister("ddwoZ", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $99f59f9d5f55525f$export$4ef52930e33717cd; });
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", function () { return $99f59f9d5f55525f$export$cb374d25ded7f6ab; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $99f59f9d5f55525f$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $99f59f9d5f55525f$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $99f59f9d5f55525f$export$352e418ed5b6193a; });
var $99f59f9d5f55525f$export$4ef52930e33717cd = 'data-theme';
var $99f59f9d5f55525f$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $99f59f9d5f55525f$export$a00eac3f8684bcd0 = 'data-color-mode';
var $99f59f9d5f55525f$export$2112803007239c61 = 'data-contrast-mode';
var $99f59f9d5f55525f$export$352e418ed5b6193a = 'data-custom-theme';
var $99f59f9d5f55525f$export$6f0c6fb8c80fcc92 = 'ds';
var $99f59f9d5f55525f$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $99f59f9d5f55525f$export$dddac1532e822863 = "--".concat($99f59f9d5f55525f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $99f59f9d5f55525f$export$9d7b58831ae93caa = "--".concat($99f59f9d5f55525f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("6CEKe", function(module, exports) {
$parcel$export(module.exports, "getThemeHtmlAttrs", function () { return $4d25e5b6fffdce1a$export$e1f80cb7a749802f; });
$parcel$export(module.exports, "default", function () { return $4d25e5b6fffdce1a$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");

var $ddwoZ = parcelRequire("ddwoZ");

var $2QMHJ = parcelRequire("2QMHJ");

var $bTUDI = parcelRequire("bTUDI");

var $hvIPl = parcelRequire("hvIPl");

var $laSx9 = parcelRequire("laSx9");
function $4d25e5b6fffdce1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4d25e5b6fffdce1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4d25e5b6fffdce1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4d25e5b6fffdce1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4d25e5b6fffdce1a$var$defaultColorMode = 'light';
var $4d25e5b6fffdce1a$var$defaultContrastMode = 'no-preference';
var $4d25e5b6fffdce1a$export$e1f80cb7a749802f = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $2QMHJ.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $2QMHJ.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $2QMHJ.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $2QMHJ.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $2QMHJ.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $2QMHJ.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $2QMHJ.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $2QMHJ.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $2QMHJ.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $bTUDI.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, $f53LC.default)((0, $f53LC.default)({}, (0, $ddwoZ.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $ddwoZ.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $4d25e5b6fffdce1a$var$defaultColorMode : colorMode);
    if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) result = $4d25e5b6fffdce1a$var$_objectSpread($4d25e5b6fffdce1a$var$_objectSpread({}, result), {}, (0, $f53LC.default)({}, (0, $ddwoZ.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $4d25e5b6fffdce1a$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $laSx9.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $hvIPl.hash)(optionString);
        result[0, $ddwoZ.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $4d25e5b6fffdce1a$export$2e2bcd8739ae039 = $4d25e5b6fffdce1a$export$e1f80cb7a749802f;

});
parcelRegister("2QMHJ", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", function () { return $213637c63879d509$export$9aedcfa7336a207; });

var $6ur0l = parcelRequire("6ur0l");
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $213637c63879d509$var$getShapeDefault() {
    if ((0, $6ur0l.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $213637c63879d509$var$getMotionDefault() {
    return 'motion';
}
var $213637c63879d509$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $213637c63879d509$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $213637c63879d509$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("bTUDI", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", function () { return $8aa0c43506f19d94$export$62c37ab81302621a; });

var $2zYm4 = parcelRequire("2zYm4");

var $2qaZZ = parcelRequire("2qaZZ");

var $PgF0c = parcelRequire("PgF0c");

var $jVN95 = parcelRequire("jVN95");

var $2ReMa = parcelRequire("2ReMa");
var $8aa0c43506f19d94$var$customThemeOptions = 'UNSAFE_themeOptions';
var $8aa0c43506f19d94$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $PgF0c.isColorMode)(id) || // custom theme state
        kind === $8aa0c43506f19d94$var$customThemeOptions && (0, $2zYm4.default)(id) === 'object' || // other theme states
        (0, $2ReMa.isThemeKind)(kind) && typeof id === 'string' && (0, $jVN95.isThemeIds)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $2zYm4.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});
parcelRegister("PgF0c", function(module, exports) {
$parcel$export(module.exports, "isColorMode", function () { return $09a1afedcad33160$export$4a14e169b1de4ee7; });
var $09a1afedcad33160$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("jVN95", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", function () { return $e829767ffb170ca8$export$ea35b8958c39dd07; });

var $iHwpC = parcelRequire("iHwpC");
var $e829767ffb170ca8$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $iHwpC.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("iHwpC", function(module, exports) {
$parcel$export(module.exports, "themeIds", function () { return $d9d5628501e95603$export$7d43e72a58e3283f; });
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $d9d5628501e95603$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("2ReMa", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", function () { return $214bfe362f1e259a$export$958fa026be3a263e; });
var $214bfe362f1e259a$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $214bfe362f1e259a$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $214bfe362f1e259a$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});


parcelRegister("hvIPl", function(module, exports) {
$parcel$export(module.exports, "hash", function () { return $cbf81aaad6ec2b59$export$d6af199866bfb566; });
var $cbf81aaad6ec2b59$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("laSx9", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", function () { return $f6a4d564729befb5$export$53031ac1ecb71f44; });
var $f6a4d564729befb5$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};

});


parcelRegister("kjchv", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", function () { return $ec8f1bd22b4fc374$export$fd7e0dd2b74807f7; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $6ur0l = parcelRequire("6ur0l");

var $kLIaL = parcelRequire("kLIaL");

var $2QMHJ = parcelRequire("2QMHJ");

var $i61Ix = parcelRequire("i61Ix");

var $5fN82 = parcelRequire("5fN82");

var $2tMJ1 = parcelRequire("2tMJ1");

var $4ovac = parcelRequire("4ovac");

var $laSx9 = parcelRequire("laSx9");

var $22KIA = parcelRequire("22KIA");

var $d9CVL = parcelRequire("d9CVL");
function $ec8f1bd22b4fc374$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $ec8f1bd22b4fc374$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $ec8f1bd22b4fc374$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ec8f1bd22b4fc374$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ec8f1bd22b4fc374$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ec8f1bd22b4fc374$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ec8f1bd22b4fc374$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec8f1bd22b4fc374$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec8f1bd22b4fc374$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec8f1bd22b4fc374$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $ec8f1bd22b4fc374$export$fd7e0dd2b74807f7 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, themeOverridePreferences, overrideThemeCssLoadingTasks, mode, attrOfMissingCustomStyles, _iterator, _step, themeId, overrideThemeCss, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($ec8f1bd22b4fc374$var$_objectSpread($ec8f1bd22b4fc374$var$_objectSpread({}, (0, $2QMHJ.themeStateDefaults)), {}, {
                        typography: (0, $2QMHJ.themeStateDefaults)['typography'],
                        shape: (0, $2QMHJ.themeStateDefaults)['shape'](),
                        motion: (0, $2QMHJ.themeStateDefaults)['motion']()
                    }, (0, $kLIaL.getGlobalTheme)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $2QMHJ.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $2QMHJ.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $2QMHJ.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $2QMHJ.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $2QMHJ.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $2QMHJ.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $2QMHJ.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $2QMHJ.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $2QMHJ.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $6ur0l.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $4ovac.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $d9CVL.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }());
                    themeOverridePreferences = (0, $2tMJ1.getThemeOverridePreferences)(themeState); // Start loading override CSS before the first await. It is appended only after the standard
                    // themes have loaded so that the override cascade order remains deterministic.
                    overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map(function(themeId) {
                        return (0, $22KIA.loadThemeCss)(themeId);
                    }); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $laSx9.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $2QMHJ.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $5fN82.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("bozW0"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    if (!themeLoader) {
                        _context3.next = 9;
                        break;
                    }
                    _iterator = $ec8f1bd22b4fc374$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    _context3.next = 11;
                    break;
                case 9:
                    _context3.next = 10;
                    return Promise.all(overrideThemeCssLoadingTasks);
                case 10:
                    overrideThemeCss = _context3.sent;
                    _context3.next = 11;
                    return Promise.all(themeOverridePreferences.map(function(themeId, index) {
                        return (0, $d9CVL.loadAndAppendThemeCss)(themeId, overrideThemeCss[index]);
                    }));
                case 11:
                    autoUnbind = (0, $i61Ix.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 12:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("kLIaL", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $03e6e0dfd2a2925f$export$813ecdf77207a053; });

var $f53LC = parcelRequire("f53LC");

var $ddwoZ = parcelRequire("ddwoZ");

var $j1JeD = parcelRequire("j1JeD");

var $3AoBe = parcelRequire("3AoBe");
function $03e6e0dfd2a2925f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $03e6e0dfd2a2925f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $03e6e0dfd2a2925f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $03e6e0dfd2a2925f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $03e6e0dfd2a2925f$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $ddwoZ.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $ddwoZ.THEME_DATA_ATTRIBUTE)) || '';
    return $03e6e0dfd2a2925f$var$_objectSpread($03e6e0dfd2a2925f$var$_objectSpread({}, (0, $3AoBe.themeStringToObject)(theme)), (0, $j1JeD.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("j1JeD", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", function () { return $dda13311f31c9057$export$fcfb1976c88f9f75; });

var $1Kbnw = parcelRequire("1Kbnw");
var $dda13311f31c9057$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $1Kbnw.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("1Kbnw", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $1452e9d3400eda8f$export$83993de8eb66733; });
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $1452e9d3400eda8f$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("3AoBe", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $29c7d0d97982087a$export$f19b488f7c0547ee; });

var $2qaZZ = parcelRequire("2qaZZ");

var $PgF0c = parcelRequire("PgF0c");

var $jVN95 = parcelRequire("jVN95");

var $2ReMa = parcelRequire("2ReMa");
var $29c7d0d97982087a$var$customThemeOptions = 'UNSAFE_themeOptions';
var $29c7d0d97982087a$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $PgF0c.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $2ReMa.isThemeKind)(kind) && (0, $jVN95.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $29c7d0d97982087a$var$customThemeOptions) try {
            themeObject[$29c7d0d97982087a$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("i61Ix", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d2ca1e8a3f8ef116$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $6ur0l = parcelRequire("6ur0l");

var $6CEKe = parcelRequire("6CEKe");

var $8r6kq = parcelRequire("8r6kq");

var $9ep5A = parcelRequire("9ep5A");
function $d2ca1e8a3f8ef116$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $8r6kq.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $8r6kq.default).bind();
    } else (0, $8r6kq.default).unbind();
    if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $9ep5A.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $9ep5A.default).bind();
        } else (0, $9ep5A.default).unbind();
    }
    var themeAttributes = (0, $6CEKe.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $8r6kq.default).unbind();
        if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) (0, $9ep5A.default).unbind();
    };
}

});
parcelRegister("8r6kq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6245c10ec510151e$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $dH1HR = parcelRequire("dH1HR");

var $ddwoZ = parcelRequire("ddwoZ");

var $d9CVL = parcelRequire("d9CVL");
var $6245c10ec510151e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $6245c10ec510151e$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $ddwoZ.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $6245c10ec510151e$var$darkModeMql = $6245c10ec510151e$var$isMatchMediaAvailable && window.matchMedia((0, $d9CVL.darkModeMediaQuery));
var $6245c10ec510151e$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $cTewU.default)(this, ColorModeObserver);
        (0, $f53LC.default)(this, "unbindThemeChangeListener", null);
    }
    return (0, $avOEA.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$6245c10ec510151e$var$darkModeMql) return 'light';
                return $6245c10ec510151e$var$darkModeMql !== null && $6245c10ec510151e$var$darkModeMql !== void 0 && $6245c10ec510151e$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($6245c10ec510151e$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $dH1HR.bind)($6245c10ec510151e$var$darkModeMql, {
                    type: 'change',
                    listener: $6245c10ec510151e$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $6245c10ec510151e$var$SingletonColorModeObserver = new $6245c10ec510151e$var$ColorModeObserver();
var $6245c10ec510151e$export$2e2bcd8739ae039 = $6245c10ec510151e$var$SingletonColorModeObserver;

});
parcelRegister("d9CVL", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $993a506ee5821bf4$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $993a506ee5821bf4$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $993a506ee5821bf4$export$8662df6937d86fcb; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ddwoZ = parcelRequire("ddwoZ");

var $22KIA = parcelRequire("22KIA");
var $993a506ee5821bf4$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId, preloadedThemeCss) {
        var themeCss, style, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $ddwoZ.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $ddwoZ.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (!(preloadedThemeCss !== null && preloadedThemeCss !== void 0)) {
                        _context.next = 3;
                        break;
                    }
                    _t = preloadedThemeCss;
                    _context.next = 5;
                    break;
                case 3:
                    _context.next = 4;
                    return (0, $22KIA.loadThemeCss)(themeId);
                case 4:
                    _t = _context.sent;
                case 5:
                    themeCss = _t;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $993a506ee5821bf4$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $993a506ee5821bf4$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("22KIA", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", function () { return $17d001ec3b44fbc4$export$8a48286ed7df6720; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $gOLcS = parcelRequire("gOLcS");
var $17d001ec3b44fbc4$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $gOLcS.default)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("gOLcS", function(module, exports) {
$parcel$export(module.exports, "themeImportMap", function () { return $c3e5ef1e66533314$export$3a171c49f8c16356; });
$parcel$export(module.exports, "default", function () { return $c3e5ef1e66533314$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::3d041793de6aed48f20cb5e398199413>>
 * @codegenCommand yarn build tokens
 */ 














var $c3e5ef1e66533314$export$3a171c49f8c16356 = {
    'light': function light() {
        return (parcelRequire("5pF8t"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("2XBbS"));
    },
    'light-finesse': function lightFinesse() {
        return (parcelRequire("ffXMl"));
    },
    'light-increased-contrast-finesse': function lightIncreasedContrastFinesse() {
        return (parcelRequire("8bzTI"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("9N843"));
    },
    'dark': function dark() {
        return (parcelRequire("1k3jC"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("8uvK3"));
    },
    'dark-finesse': function darkFinesse() {
        return (parcelRequire("8nj2z"));
    },
    'dark-increased-contrast-finesse': function darkIncreasedContrastFinesse() {
        return (parcelRequire("gDUNx"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("eAX25"));
    },
    'spacing': function spacing() {
        return (parcelRequire("bVAnp"));
    },
    'typography': function typography() {
        return (parcelRequire("bx32n"));
    },
    'typography-finesse': function typographyFinesse() {
        return (parcelRequire("knwVr"));
    },
    'shape': function shape() {
        return (parcelRequire("af1oy"));
    },
    'motion': function motion() {
        return (parcelRequire("kZ6fy"));
    }
};
var $c3e5ef1e66533314$export$2e2bcd8739ae039 = $c3e5ef1e66533314$export$3a171c49f8c16356;

});
parcelRegister("5pF8t", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("b58ab").then(()=>parcelRequire('1OJeY'));

});
parcelRegister("eao4m", function(module, exports) {
"use strict";

function $a504ab8c5934a050$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("hwrhg")).resolve(id));
}
module.exports = $a504ab8c5934a050$var$load;

});
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});



parcelRegister("2XBbS", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("dOMKX").then(()=>parcelRequire('gyNr4'));

});

parcelRegister("ffXMl", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("kkk3s").then(()=>parcelRequire('3OvwU'));

});

parcelRegister("8bzTI", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("9QrBw").then(()=>parcelRequire('gFN0X'));

});

parcelRegister("9N843", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("3JZj9").then(()=>parcelRequire('1FH9S'));

});

parcelRegister("1k3jC", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("LxaxB").then(()=>parcelRequire('egpjM'));

});

parcelRegister("8uvK3", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("iVdGr").then(()=>parcelRequire('dacmv'));

});

parcelRegister("8nj2z", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("17q0V").then(()=>parcelRequire('gfJYY'));

});

parcelRegister("gDUNx", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("NMFb0").then(()=>parcelRequire('16wJQ'));

});

parcelRegister("eAX25", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("gwdOL").then(()=>parcelRequire('i3U2Z'));

});

parcelRegister("bVAnp", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("UkGjc").then(()=>parcelRequire('77k2s'));

});

parcelRegister("bx32n", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("5W4mY").then(()=>parcelRequire('7l1hI'));

});

parcelRegister("knwVr", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("bOWgd").then(()=>parcelRequire('bkGlR'));

});

parcelRegister("af1oy", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("hnBbb").then(()=>parcelRequire('i1rur'));

});

parcelRegister("kZ6fy", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("51GZe").then(()=>parcelRequire('jIZG8'));

});





parcelRegister("9ep5A", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b88e204b0f9fff6$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $dH1HR = parcelRequire("dH1HR");

var $ddwoZ = parcelRequire("ddwoZ");

var $d9CVL = parcelRequire("d9CVL");
var $6b88e204b0f9fff6$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $6b88e204b0f9fff6$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $ddwoZ.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $6b88e204b0f9fff6$var$contrastModeMql = $6b88e204b0f9fff6$var$isMatchMediaAvailable && window.matchMedia((0, $d9CVL.moreContrastMediaQuery));
var $6b88e204b0f9fff6$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $cTewU.default)(this, ContrastModeObserver);
        (0, $f53LC.default)(this, "unbindContrastChangeListener", null);
    }
    return (0, $avOEA.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$6b88e204b0f9fff6$var$contrastModeMql) return 'no-preference';
                return $6b88e204b0f9fff6$var$contrastModeMql !== null && $6b88e204b0f9fff6$var$contrastModeMql !== void 0 && $6b88e204b0f9fff6$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($6b88e204b0f9fff6$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $dH1HR.bind)($6b88e204b0f9fff6$var$contrastModeMql, {
                    type: 'change',
                    listener: $6b88e204b0f9fff6$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $6b88e204b0f9fff6$var$SingletonContrastModeObserver = new $6b88e204b0f9fff6$var$ContrastModeObserver();
var $6b88e204b0f9fff6$export$2e2bcd8739ae039 = $6b88e204b0f9fff6$var$SingletonContrastModeObserver;

});


parcelRegister("5fN82", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $3d34766063db62f4$export$bd1ac9300b0e885a; });

var $ddwoZ = parcelRequire("ddwoZ");

var $hvIPl = parcelRequire("hvIPl");
function $3d34766063db62f4$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $hvIPl.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $ddwoZ.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $ddwoZ.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("2tMJ1", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $1ce41600cc1d77c5$export$5d76d7014f4a5d08; });

var $lFOXD = parcelRequire("lFOXD");

var $6ur0l = parcelRequire("6ur0l");

var $gczk7 = parcelRequire("gczk7");
var $1ce41600cc1d77c5$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
var $1ce41600cc1d77c5$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(themeState) {
    if (!(0, $6ur0l.fg)('platform-dst-tokens-finesse')) return [];
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, typography = themeState.typography;
    var selectedThemes = [].concat((0, $lFOXD.default)(colorMode === 'auto' ? [
        light,
        dark
    ] : [
        themeState[colorMode]
    ]), [
        typography
    ]);
    if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) selectedThemes.forEach(function(themeId) {
        var increasedContrastTheme = (0, $gczk7.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    var themeOverridePreferences = selectedThemes.map(function(themeId) {
        return $1ce41600cc1d77c5$var$finesseOverrides[themeId];
    }).filter(function(themeId) {
        return themeId !== undefined;
    });
    return (0, $lFOXD.default)(new Set(themeOverridePreferences));
};

});
parcelRegister("gczk7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bcb92ada70b791ca$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $jvmc1 = parcelRequire("jvmc1");
function $bcb92ada70b791ca$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $jvmc1.default)).find(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});
parcelRegister("jvmc1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e33220a1cec15a3a$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $iHwpC = parcelRequire("iHwpC");


var $2QMHJ = parcelRequire("2QMHJ");
/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ // Retain Themes in this public type for backwards compatibility.
// platform-dst-tokens-finesse cleanup: Revisit when the temporary override themes are removed.
/**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $e33220a1cec15a3a$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $e33220a1cec15a3a$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
var $e33220a1cec15a3a$export$92ba366331403db2 = [].concat((0, $lFOXD.default)((0, $iHwpC.themeIds)), $e33220a1cec15a3a$export$ba8a43b83ecc69f8);
var $e33220a1cec15a3a$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e33220a1cec15a3a$export$2e2bcd8739ae039 = $e33220a1cec15a3a$export$9d64ff89b6869900;

});



parcelRegister("4ovac", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", function () { return $333193badf40c00b$export$dd6aeb7c823fc03d; });

var $lFOXD = parcelRequire("lFOXD");

var $6ur0l = parcelRequire("6ur0l");

var $gczk7 = parcelRequire("gczk7");
var $333193badf40c00b$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $gczk7.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $gczk7.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $lFOXD.default)(new Set(themePreferences));
};

});

parcelRegister("bozW0", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("2jrAx").then(()=>parcelRequire('gN1Na'));

});


parcelRegister("kBO8D", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", function () { return $f00e27be688eedea$export$a782702263f77544; });

var $1oC0p = parcelRequire("1oC0p");

var $kW16K = parcelRequire("kW16K");
var $f00e27be688eedea$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $1oC0p.useContext)((0, $kW16K.AppProviderThemingEnabledContext));
};

});
parcelRegister("kW16K", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", function () { return $f3da15668f118d1d$export$d2def9838ca456c0; });

var $1oC0p = parcelRequire("1oC0p");
var $f3da15668f118d1d$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});


parcelRegister("gB7F3", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", function () { return $c1560b6409a321fb$export$26aa23367bfbab0e; });

var $1oC0p = parcelRequire("1oC0p");

var $bxvpz = parcelRequire("bxvpz");
var $c1560b6409a321fb$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $1oC0p.useContext)((0, $bxvpz.InsideAppProviderContext));
};

});
parcelRegister("bxvpz", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", function () { return $866b246d207bf1b9$export$7981b2444296e410; });

var $1oC0p = parcelRequire("1oC0p");
var $866b246d207bf1b9$export$7981b2444296e410 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});


parcelRegister("4BV7u", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", function () { return $35b6ece75687b97c$export$49ddd74a6729fdb0; });

var $1oC0p = parcelRequire("1oC0p");
var $35b6ece75687b97c$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("iT08I", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", function () { return $dbfd78c0bdeba1dc$export$332347eeb335453c; });

var $1oC0p = parcelRequire("1oC0p");
var $dbfd78c0bdeba1dc$export$332347eeb335453c = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});

parcelRegister("3027V", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", function () { return $22f3058298351205$export$b06130bad0bbc70f; });

var $1oC0p = parcelRequire("1oC0p");
var $22f3058298351205$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("3LpCd", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", function () { return $2bd9a18a45a72df7$export$2c657da244d00bd6; });
$parcel$export(module.exports, "SetThemeContext", function () { return $2bd9a18a45a72df7$export$f7a97b47760e2a13; });

var $1oC0p = parcelRequire("1oC0p");
var $2bd9a18a45a72df7$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $2bd9a18a45a72df7$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("kE1ER", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", function () { return $f078d45607489ec1$export$7ca11437599d653d; });

var $1oC0p = parcelRequire("1oC0p");

var $iT08I = parcelRequire("iT08I");
var $f078d45607489ec1$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $1oC0p.useContext)((0, $iT08I.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

});

parcelRegister("jmuXs", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", function () { return $e18816047b725074$export$7d4a7e812d176b24; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $7jKo6 = parcelRequire("7jKo6");

var $gOLcS = parcelRequire("gOLcS");

var $62R0b = parcelRequire("62R0b");
var $e18816047b725074$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $62R0b.isThemeMounted)(themeId)) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $gOLcS.themeImportMap)[themeId]();
                case 3:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $e18816047b725074$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $7jKo6.getDocument)();
                    if (doc) {
                        _context2.next = 1;
                        break;
                    }
                    return _context2.abrupt("return");
                case 1:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $62R0b.isThemeMounted)(themeId)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return");
                case 2:
                    doc.head.appendChild(style);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $e18816047b725074$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 1;
                    return $e18816047b725074$var$loadThemeCss(themeId);
                case 1:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return");
                case 2:
                    $e18816047b725074$var$mountThemeCss(themeCss, themeId);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $e18816047b725074$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($e18816047b725074$var$loadAndMountThemeCss);
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();

});
parcelRegister("62R0b", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", function () { return $466c0b0c95abacc1$export$835a0dc855d02822; });

var $7jKo6 = parcelRequire("7jKo6");

var $ddwoZ = parcelRequire("ddwoZ");
function $466c0b0c95abacc1$export$835a0dc855d02822(themeId) {
    var doc = (0, $7jKo6.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $ddwoZ.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}

});



parcelRegister("lpXSX", function(module, exports) {
$parcel$export(module.exports, "useColorMode", function () { return $f97a62c3bc5965d2$export$20f3076712c8dfa; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $kLIaL = parcelRequire("kLIaL");

var $eRSM0 = parcelRequire("eRSM0");

var $4BV7u = parcelRequire("4BV7u");
function $f97a62c3bc5965d2$export$20f3076712c8dfa() {
    var value = (0, $1oC0p.useContext)((0, $4BV7u.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $kLIaL.getGlobalTheme)();
    var _useState = (0, $1oC0p.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, $2qaZZ.default)(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $eRSM0.ThemeMutationObserver)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("eRSM0", function(module, exports) {
$parcel$export(module.exports, "ThemeMutationObserver", function () { return $ad3080bd59a3ac26$export$b741a7c3bcb1c635; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $ddwoZ = parcelRequire("ddwoZ");

var $kLIaL = parcelRequire("kLIaL");
var $ad3080bd59a3ac26$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $cTewU.default)(this, ThemeMutationObserver);
        (0, $f53LC.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $avOEA.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $kLIaL.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $ddwoZ.THEME_DATA_ATTRIBUTE),
                            (0, $ddwoZ.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $f53LC.default)($ad3080bd59a3ac26$export$b741a7c3bcb1c635, "observer", null);
(0, $f53LC.default)($ad3080bd59a3ac26$export$b741a7c3bcb1c635, "callbacks", new Set());
var $ad3080bd59a3ac26$export$2e2bcd8739ae039 = $ad3080bd59a3ac26$export$b741a7c3bcb1c635;

});


parcelRegister("kFhR9", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $f0b57cd99edf4125$export$c582005add11e141; });

var $c2zFX = parcelRequire("c2zFX");

var $cZAuX = parcelRequire("cZAuX");
var $f0b57cd99edf4125$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $c2zFX.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $c2zFX.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $cZAuX.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $f0b57cd99edf4125$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $f0b57cd99edf4125$var$getPortalParent().appendChild(container);
};

});
parcelRegister("c2zFX", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", function () { return $8c415867edd739a8$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $8c415867edd739a8$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $8c415867edd739a8$export$13f57c02915787b3; });
var $8c415867edd739a8$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $8c415867edd739a8$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $8c415867edd739a8$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("cZAuX", function(module, exports) {
$parcel$export(module.exports, "getBody", function () { return $97577e5c39080aae$export$135b49d4bc2964c6; });
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $97577e5c39080aae$export$135b49d4bc2964c6 = function getBody() {
    return document.body;
};

});


parcelRegister("ad16n", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $76ebf9136cf2c1e3$export$26ae5ca175b4ec5a; });

var $c2zFX = parcelRequire("c2zFX");
var $76ebf9136cf2c1e3$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $c2zFX.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};

});

parcelRegister("6G3Rr", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", function () { return $4dc9a904daf2c8d4$export$da99f98bf3fe55b3; });

var $c2zFX = parcelRequire("c2zFX");

var $cZAuX = parcelRequire("cZAuX");
var $4dc9a904daf2c8d4$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $c2zFX.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $c2zFX.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $cZAuX.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $4dc9a904daf2c8d4$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $4dc9a904daf2c8d4$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("84ZGM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e1e8c95d65f3ddf$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $lFvcp = parcelRequire("lFvcp");

var $lpXSX = parcelRequire("lpXSX");

var $kE1ER = parcelRequire("kE1ER");

var $6ur0l = parcelRequire("6ur0l");

var $4pCYH = parcelRequire("4pCYH");

var $bMjH6 = parcelRequire("bMjH6");

var $llczt = parcelRequire("llczt");

var $hExAd = parcelRequire("hExAd");
function $5e1e8c95d65f3ddf$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, isClosed = props.isClosed;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $lpXSX.useColorMode)();
    var isInsideThemeProvider = (0, $kE1ER.useIsInsideThemeProvider)();
    (0, $4pCYH.useIsomorphicLayoutEffect)(function() {
        if ((0, $6ur0l.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                var tempPortalContainer = (0, $bMjH6.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                var portalParent = (0, $llczt.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return function() {
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $hExAd.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            var _tempPortalContainer = (0, $bMjH6.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(_tempPortalContainer);
            var _portalParent = (0, $llczt.createPortalParent)();
            if (!_tempPortalContainer || !_portalParent) return;
            _portalParent.appendChild(_tempPortalContainer);
            return function() {
                if (_tempPortalContainer) _portalParent.removeChild(_tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $6ur0l.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lFvcp.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $gUjjH.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("4pCYH", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $3367bb71d4b79492$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $3367bb71d4b79492$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);

});

parcelRegister("bMjH6", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $89337440606e961d$export$fef014d7cef9e543; });

var $c2zFX = parcelRequire("c2zFX");
var $89337440606e961d$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $89337440606e961d$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($89337440606e961d$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $c2zFX.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("llczt", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", function () { return $f8954f88e13a82c4$export$95029ca7aca2989e; });

var $c2zFX = parcelRequire("c2zFX");

var $cZAuX = parcelRequire("cZAuX");
var $f8954f88e13a82c4$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $f8954f88e13a82c4$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($f8954f88e13a82c4$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $c2zFX.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            var parent = document.createElement('div');
            parent.className = (0, $c2zFX.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $cZAuX.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});

parcelRegister("hExAd", function(module, exports) {
$parcel$export(module.exports, "removePortalParent", function () { return $cda039025aa60433$export$7b20876b2769b301; });

var $cZAuX = parcelRequire("cZAuX");
var $cda039025aa60433$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $cda039025aa60433$export$7b20876b2769b301 = function removePortalParent(parentElement) {
    if ($cda039025aa60433$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody;
            (_getBody = (0, $cZAuX.getBody)()) === null || _getBody === void 0 || _getBody.removeChild(parentElement);
        }
    }
};

});


parcelRegister("ekunX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a6ea80e118ca2892$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $4pCYH = parcelRequire("4pCYH");
var $a6ea80e118ca2892$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $4pCYH.useIsomorphicLayoutEffect) : (0, $1oC0p.useEffect);
    }), _useState4 = (0, $2qaZZ.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $a6ea80e118ca2892$export$2e2bcd8739ae039 = $a6ea80e118ca2892$var$useIsSubsequentRender;

});

parcelRegister("hajy9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c7f2890943792c8b$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $iVZv5 = parcelRequire("iVZv5");

var $wTv22 = parcelRequire("wTv22");
var $c7f2890943792c8b$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1oC0p.useEffect)(function() {
        (0, $wTv22.default)((0, $iVZv5.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $wTv22.default)((0, $iVZv5.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $c7f2890943792c8b$export$2e2bcd8739ae039 = $c7f2890943792c8b$var$useFirePortalEvent;

});
parcelRegister("iVZv5", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $dc8d418d94fa0a75$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $dc8d418d94fa0a75$export$80816bd900e5bd00; });
var $dc8d418d94fa0a75$export$ed5835cc67e87f72 = 'akPortalMount';
var $dc8d418d94fa0a75$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("wTv22", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $062e0a52205dac1d$export$2e2bcd8739ae039; });
var $062e0a52205dac1d$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $062e0a52205dac1d$var$getLayerName = function getLayerName(zIndex) {
    return $062e0a52205dac1d$var$zIndexToName.hasOwnProperty(zIndex) ? $062e0a52205dac1d$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $062e0a52205dac1d$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $062e0a52205dac1d$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $062e0a52205dac1d$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $062e0a52205dac1d$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("4rWUk", function(module, exports) {
$parcel$export(module.exports, "layers", function () { return $33d760d9b71e5bc4$export$7be255094ccdc533; });
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var $33d760d9b71e5bc4$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $33d760d9b71e5bc4$export$c93026a968943f95 = 'light';
var $33d760d9b71e5bc4$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $33d760d9b71e5bc4$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};

});

parcelRegister("57q2L", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $3ba1cee2ad190fd7$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $3ba1cee2ad190fd7$var$registrations = new Set();
var $3ba1cee2ad190fd7$var$cleanupEndEventListeners = null;
function $3ba1cee2ad190fd7$var$onDragStart() {
    if ($3ba1cee2ad190fd7$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $3ba1cee2ad190fd7$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $3ba1cee2ad190fd7$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $3ba1cee2ad190fd7$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $3ba1cee2ad190fd7$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($3ba1cee2ad190fd7$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $3ba1cee2ad190fd7$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $3ba1cee2ad190fd7$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $3ba1cee2ad190fd7$var$cleanupEndEventListeners = null;
    var clone = Array.from($3ba1cee2ad190fd7$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $3ba1cee2ad190fd7$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $3ba1cee2ad190fd7$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $3ba1cee2ad190fd7$var$onDragStart
        }
    ]);
}
var $3ba1cee2ad190fd7$var$cleanupStartEventListeners = null;
function $3ba1cee2ad190fd7$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$3ba1cee2ad190fd7$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $3ba1cee2ad190fd7$var$cleanupStartEventListeners = $3ba1cee2ad190fd7$var$bindStartEvents();
    $3ba1cee2ad190fd7$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $3ba1cee2ad190fd7$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $3ba1cee2ad190fd7$var$registrations.delete(registration);
        if ($3ba1cee2ad190fd7$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $3ba1cee2ad190fd7$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $3ba1cee2ad190fd7$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("j4xd9", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", function () { return $de28271a7304ada8$export$d26fd3d066ede49; });
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $de28271a7304ada8$var$getTriggerEdgeX(_ref) {
    var triggerRect = _ref.triggerRect, placement = _ref.placement;
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $de28271a7304ada8$var$getTriggerEdgeY(_ref2) {
    var triggerRect = _ref2.triggerRect, placement = _ref2.placement;
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $de28271a7304ada8$export$d26fd3d066ede49(_ref3) {
    var cursor = _ref3.cursor, triggerRect = _ref3.triggerRect, tooltipPosition = _ref3.tooltipPosition, placement = _ref3.placement;
    if (tooltipPosition === 'mouse-y') return {
        x: $de28271a7304ada8$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $de28271a7304ada8$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("6Bn3J", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", function () { return $4ce815dfe66d22db$export$2e68479e0a5d8746; });
function $4ce815dfe66d22db$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});

parcelRegister("be8YJ", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $82c7f771d165c260$export$57bf213be019eeb0; });

var $6ur0l = parcelRequire("6ur0l");
var $82c7f771d165c260$var$delayId = null;
function $82c7f771d165c260$var$clearScheduled() {
    if ($82c7f771d165c260$var$delayId != null) {
        window.clearTimeout($82c7f771d165c260$var$delayId);
        $82c7f771d165c260$var$delayId = null;
    }
}
function $82c7f771d165c260$var$scheduleTimeout(fn, delay) {
    $82c7f771d165c260$var$clearScheduled();
    $82c7f771d165c260$var$delayId = window.setTimeout(function() {
        $82c7f771d165c260$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips.
//
// Once we roll out top-layer and remove the legacy path, this manager can be simplified:
// - Singleton: Can be removed; the platform (popover="auto" or popover="hint") already enforces
//   only one tooltip open at a time.
// - Phase machine: Can be simplified; drop hide-animating and finishHideAnimation (legacy fade-out).
//   Use e.g. pending-show | visible | pending-hide with immediate hide.
// - API: Can drop or simplify mousePosition/mousePos if no longer needed; keep delay scheduling,
//   keep(), requestHide, abort, and minimal lifecycle.
var $82c7f771d165c260$var$active = null;
function $82c7f771d165c260$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($82c7f771d165c260$var$active && $82c7f771d165c260$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $82c7f771d165c260$var$clearScheduled();
            $82c7f771d165c260$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $82c7f771d165c260$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $82c7f771d165c260$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $82c7f771d165c260$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($82c7f771d165c260$var$active && $82c7f771d165c260$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($82c7f771d165c260$var$active) {
            $82c7f771d165c260$var$clearScheduled();
            $82c7f771d165c260$var$active.entry.hide({
                isImmediate: true
            });
            $82c7f771d165c260$var$active.entry.done();
            $82c7f771d165c260$var$active = null;
        }
        // this tooltip is now the active tooltip
        $82c7f771d165c260$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $82c7f771d165c260$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("5MmLX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4353199dab00495a$export$2e2bcd8739ae039; });

var $2vZJL = parcelRequire("2vZJL");
function $4353199dab00495a$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $2vZJL.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("fwFxZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b4da1296d9e52f31$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2uy7B = parcelRequire("2uy7B");
var $b4da1296d9e52f31$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $b4da1296d9e52f31$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, role = _ref.role;
    return /*#__PURE__*/ $1oC0p.createElement((0, $2uy7B.default), {
        ref: ref,
        style: style,
        className: (0, $2jatx.default)([
            $b4da1296d9e52f31$var$styles.base,
            truncate && $b4da1296d9e52f31$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$b4da1296d9e52f31$var$TooltipContainer.displayName = 'TooltipContainer';
var $b4da1296d9e52f31$export$2e2bcd8739ae039 = $b4da1296d9e52f31$var$TooltipContainer;

});
parcelRegister("2uy7B", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1d08d9f3fd6efb82$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jd4r4 = parcelRequire("jd4r4");
var $1d08d9f3fd6efb82$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $1d08d9f3fd6efb82$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, _ref$role = _ref.role, role = _ref$role === void 0 ? 'tooltip' : _ref$role;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        role: role,
        className: (0, $2jatx.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $1oC0p.createElement((0, $jd4r4.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$1d08d9f3fd6efb82$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $1d08d9f3fd6efb82$export$2e2bcd8739ae039 = $1d08d9f3fd6efb82$var$TooltipPrimitive;

});
parcelRegister("jd4r4", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", function () { return $dfc2ac0a140168c1$export$5bcbc43c84236222; });
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $dfc2ac0a140168c1$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $dfc2ac0a140168c1$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $dfc2ac0a140168c1$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $1oC0p.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $2jatx.default)([
                $dfc2ac0a140168c1$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});





parcelRegister("7rGE7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f24bc9c1eab75c89e7c91a5614e09120>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56bc22a1f74bb90f$var$_react = $56bc22a1f74bb90f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56bc22a1f74bb90f$var$_baseNew = $56bc22a1f74bb90f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $56bc22a1f74bb90f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56bc22a1f74bb90f$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $56bc22a1f74bb90f$var$_react.default.createElement($56bc22a1f74bb90f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.655.095 13.78 8.22a.75.75 0 0 1 0 1.06l-5.616 5.616a2 2 0 0 1-2.828 0L.604 10.164a2 2 0 0 1 0-2.828L5.689 2.25 4.595 1.155zM6.75 3.31 2.06 8h9.38zm4.69 6.19H2.06l4.336 4.336a.5.5 0 0 0 .708 0z" clip-rule="evenodd"/><path fill="currentcolor" d="M14.5 12a.75.75 0 0 0-.654.383v.002l-.003.003-.007.013-.026.046a17 17 0 0 0-.36.695c-.098.202-.202.43-.283.641-.068.177-.167.458-.167.717a1.5 1.5 0 0 0 3 0c0-.259-.1-.54-.167-.717a8 8 0 0 0-.284-.641 16 16 0 0 0-.36-.695l-.025-.046-.007-.013-.002-.004-.001-.001A.75.75 0 0 0 14.5 12"/>`
    }, props));
$56bc22a1f74bb90f$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $56bc22a1f74bb90f$var$_default = module.exports.default = $56bc22a1f74bb90f$var$PaintBucketIcon;

});

parcelRegister("lPRxe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe57e352cd82b470$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $lmxXn = parcelRequire("lmxXn");

var $3nCLO = parcelRequire("3nCLO");

var $b7FW2 = parcelRequire("b7FW2");

var $ahhSJ = parcelRequire("ahhSJ");
var $fe57e352cd82b470$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $fe57e352cd82b470$var$resetStyles = (0, $3dJ4i.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $fe57e352cd82b470$var$strongStyles = (0, $3dJ4i.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $fe57e352cd82b470$var$emStyles = (0, $3dJ4i.css)({
    fontStyle: 'italic'
});
var $fe57e352cd82b470$var$textAlignMap = {
    center: (0, $3dJ4i.css)({
        textAlign: 'center'
    }),
    end: (0, $3dJ4i.css)({
        textAlign: 'end'
    }),
    start: (0, $3dJ4i.css)({
        textAlign: 'start'
    })
};
var $fe57e352cd82b470$var$truncationStyles = (0, $3dJ4i.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $fe57e352cd82b470$var$wordBreakMap = {
    breakAll: (0, $3dJ4i.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $fe57e352cd82b470$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $b7FW2.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $ahhSJ.inverseColorMap).hasOwnProperty(surface)) return (0, $ahhSJ.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $fe57e352cd82b470$var$Text = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $lmxXn.default)($fe57e352cd82b470$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $3nCLO.useHasTextAncestor)();
    var color = $fe57e352cd82b470$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $3dJ4i.jsx)(Component, {
        ref: ref,
        css: [
            $fe57e352cd82b470$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $ahhSJ.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $ahhSJ.textColorStylesMap)[color],
            maxLines && $fe57e352cd82b470$var$truncationStyles,
            maxLines === 1 && $fe57e352cd82b470$var$wordBreakMap.breakAll,
            align && $fe57e352cd82b470$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $ahhSJ.textWeightStylesMap)[weight],
            Component === 'em' && $fe57e352cd82b470$var$emStyles,
            Component === 'strong' && $fe57e352cd82b470$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $3dJ4i.jsx)((0, $3nCLO.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $fe57e352cd82b470$export$2e2bcd8739ae039 = $fe57e352cd82b470$var$Text;

});
parcelRegister("3nCLO", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", function () { return $2761980be96a471d$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $2761980be96a471d$export$ae933c6cbe5643ad; });

var $1oC0p = parcelRequire("1oC0p");
var $2761980be96a471d$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $2761980be96a471d$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($2761980be96a471d$var$HasTextAncestorContext);
};
var $2761980be96a471d$export$ae933c6cbe5643ad = $2761980be96a471d$var$HasTextAncestorContext.Provider;

});

parcelRegister("b7FW2", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $8190e091a1e1664d$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $8190e091a1e1664d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $8190e091a1e1664d$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($8190e091a1e1664d$export$1ca2a26fecb070ae);
};
$8190e091a1e1664d$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("ahhSJ", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $77b95cdc448d5669$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $77b95cdc448d5669$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $77b95cdc448d5669$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $77b95cdc448d5669$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $77b95cdc448d5669$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $77b95cdc448d5669$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $77b95cdc448d5669$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $77b95cdc448d5669$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $77b95cdc448d5669$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $77b95cdc448d5669$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $77b95cdc448d5669$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $77b95cdc448d5669$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $77b95cdc448d5669$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $77b95cdc448d5669$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $77b95cdc448d5669$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $77b95cdc448d5669$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $77b95cdc448d5669$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $77b95cdc448d5669$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $77b95cdc448d5669$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $77b95cdc448d5669$export$38845ca010b93505; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $kjPhI = parcelRequire("kjPhI");
function $77b95cdc448d5669$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77b95cdc448d5669$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77b95cdc448d5669$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77b95cdc448d5669$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $77b95cdc448d5669$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $77b95cdc448d5669$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $77b95cdc448d5669$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $77b95cdc448d5669$export$632685d741f3dbbf = $77b95cdc448d5669$var$_objectSpread($77b95cdc448d5669$var$_objectSpread({}, $77b95cdc448d5669$export$958d0ae7f2977ae4), $77b95cdc448d5669$export$d2dc61f58390201c);
var $77b95cdc448d5669$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $77b95cdc448d5669$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $77b95cdc448d5669$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $77b95cdc448d5669$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $77b95cdc448d5669$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $77b95cdc448d5669$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $77b95cdc448d5669$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $77b95cdc448d5669$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $77b95cdc448d5669$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $77b95cdc448d5669$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $77b95cdc448d5669$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $77b95cdc448d5669$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $77b95cdc448d5669$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $77b95cdc448d5669$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $77b95cdc448d5669$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $77b95cdc448d5669$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $77b95cdc448d5669$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $77b95cdc448d5669$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $f53LC.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $77b95cdc448d5669$export$e615f061ca585a6c = $77b95cdc448d5669$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $77b95cdc448d5669$export$ca0f9c2de39ffed7(spacingProperty, $77b95cdc448d5669$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $77b95cdc448d5669$export$bf46c3f9eeafc71f = $77b95cdc448d5669$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $77b95cdc448d5669$export$ca0f9c2de39ffed7(spacingProperty, $77b95cdc448d5669$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $77b95cdc448d5669$export$e7af83bafe7f9e63 = $77b95cdc448d5669$export$ca0f9c2de39ffed7('backgroundColor', $77b95cdc448d5669$export$d1d79bf68ac056bd);
var $77b95cdc448d5669$export$3a1bcba60b23d7f0 = $77b95cdc448d5669$export$ca0f9c2de39ffed7('color', $77b95cdc448d5669$export$8473307aa00d6ea1);
var $77b95cdc448d5669$export$45f3f4fe16f9f7d5 = $77b95cdc448d5669$export$ca0f9c2de39ffed7('fontWeight', $77b95cdc448d5669$export$303e322c6b1ed114);
var $77b95cdc448d5669$export$68cc305da27dbaa4 = $77b95cdc448d5669$export$ca0f9c2de39ffed7('fontFamily', $77b95cdc448d5669$export$3c7e9587132614b4);
var $77b95cdc448d5669$export$128f10c238242f83 = $77b95cdc448d5669$export$ca0f9c2de39ffed7('font', $77b95cdc448d5669$export$6ffa317d5e70375);
var $77b95cdc448d5669$export$219d364c0da35ae4 = $77b95cdc448d5669$export$ca0f9c2de39ffed7('font', $77b95cdc448d5669$export$236bfe3a33ef1292);
var $77b95cdc448d5669$export$38845ca010b93505 = $77b95cdc448d5669$export$ca0f9c2de39ffed7('fontWeight', $77b95cdc448d5669$export$855cfd311192d666);
var $77b95cdc448d5669$export$ff257d957d48c421 = $77b95cdc448d5669$export$ca0f9c2de39ffed7((0, $kjPhI.CURRENT_SURFACE_CSS_VAR), $77b95cdc448d5669$export$41a358c9c2356760);
var $77b95cdc448d5669$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $77b95cdc448d5669$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("kjPhI", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $ecad5d10d98d550e$export$9d7b58831ae93caa; });
var $ecad5d10d98d550e$export$4ef52930e33717cd = 'data-theme';
var $ecad5d10d98d550e$export$a00eac3f8684bcd0 = 'data-color-mode';
var $ecad5d10d98d550e$export$2112803007239c61 = 'data-contrast-mode';
var $ecad5d10d98d550e$export$352e418ed5b6193a = 'data-custom-theme';
var $ecad5d10d98d550e$export$6f0c6fb8c80fcc92 = 'ds';
var $ecad5d10d98d550e$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $ecad5d10d98d550e$export$dddac1532e822863 = "--".concat($ecad5d10d98d550e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $ecad5d10d98d550e$export$9d7b58831ae93caa = "--".concat($ecad5d10d98d550e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("5GoT9", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundSearchField", function () { return $31480d3afd34e9d4$export$b5c50f4d9f26525a; });
/* jsm-playground-search-field.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $5ZCzy = parcelRequire("5ZCzy");

var $8KJ2x = parcelRequire("8KJ2x");
const $31480d3afd34e9d4$export$b5c50f4d9f26525a = ({ label: label, placeholder: placeholder, tabIndex: tabIndex, testId: testId })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _vchhusvi _1bsb1osq _1ul9idpf _16jlkb7n _1o9zkb7n _i0dl1wug _1q51e4h9 _85i5e4h9 _189ee4h9 _1dqonqa1 _1h6drsbi _2rko1qi0 _bfhk1j9a _1reo15vq _18m915vq _swxzy28r"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
            "aria-label": label,
            appearance: "none",
            elemBeforeInput: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _bozg12x7"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5ZCzy))), {
                    color: "var(--ds-icon-subtle, #505258)",
                    label: "",
                    size: "small"
                })
            }),
            isCompact: true,
            isReadOnly: true,
            placeholder: placeholder,
            tabIndex: tabIndex,
            testId: testId
        })
    });
const $31480d3afd34e9d4$var$searchFieldWrapperStyles = null;
const $31480d3afd34e9d4$var$searchIconWrapperStyles = null;

});



parcelRegister("8gAsH", function(module, exports) {
$parcel$export(module.exports, "isJsmPlaygroundSkipAnimationTarget", function () { return $fbdc13700dedd895$export$866587668269208e; });
$parcel$export(module.exports, "JsmPlaygroundSkipAnimationButton", function () { return $fbdc13700dedd895$export$4de209b9ee292c57; });
/* jsm-playground-skip-animation-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gUjjH = parcelRequire("gUjjH");

var $4DkqQ = parcelRequire("4DkqQ");
var $f6YGh = parcelRequire("f6YGh");

var $8eU08 = parcelRequire("8eU08");

var $bBczw = parcelRequire("bBczw");
const $fbdc13700dedd895$var$SKIP_ANIMATION_CONTROL = 'data-jsm-playground-skip-animation';
const $fbdc13700dedd895$export$866587668269208e = (target)=>target instanceof Element && target.closest(`[${$fbdc13700dedd895$var$SKIP_ANIMATION_CONTROL}]`) !== null;
const $fbdc13700dedd895$var$SKIP_ANIMATION_FADE_MS = 300;
const $fbdc13700dedd895$var$buttonStyles = (0, $f6YGh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBlock: 'space.100',
    paddingInline: 'space.150',
    backgroundColor: 'elevation.surface',
    color: 'color.text',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    whiteSpace: 'nowrap',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    }
});
const $fbdc13700dedd895$var$skipAnimationStyles = null;
const $fbdc13700dedd895$var$fadingStyles = null;
const $fbdc13700dedd895$export$4de209b9ee292c57 = ({ isVisible: isVisible, label: label, onClick: onClick })=>{
    const prefersReducedMotion = (0, $bBczw.usePrefersReducedMotion)();
    const skipLayer = (0, $8eU08.useJsmPlaygroundSkipLayer)();
    const [isRendered, setIsRendered] = (0, $1oC0p.useState)(isVisible);
    const [isFadingOut, setIsFadingOut] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (isVisible) {
            setIsRendered(true);
            setIsFadingOut(false);
            return;
        }
        if (!isRendered) return;
        if (prefersReducedMotion) {
            setIsRendered(false);
            setIsFadingOut(false);
            return;
        }
        setIsFadingOut(true);
        const timeout = window.setTimeout(()=>{
            setIsRendered(false);
        }, $fbdc13700dedd895$var$SKIP_ANIMATION_FADE_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        isRendered,
        isVisible,
        prefersReducedMotion
    ]);
    if (!isRendered) return null;
    const control = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-jsm-playground-skip-animation": "",
        className: (0, $2jatx.default)([
            "_kqswstnw _u7copxbi _1e02pxbi _rjxp1wug _1pby9y44 _1e0c1txw _1bsb1ns9 _tzy4kb7n _lcxv1wug _k8m0brmi _1oec188d _6fl46ui8 _1kxtglyw",
            isFadingOut && "_tzy4idpf _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4DkqQ.default), {
            xcss: $fbdc13700dedd895$var$buttonStyles,
            style: {
                borderRadius: "var(--ds-radius-full, 9999px)",
                borderStyle: 'none',
                // elevation.shadow.overlay is a soft drop plus a 1px hairline. The hairline
                // is what still reads as a border after border-style is none.
                // eslint-disable-next-line local/ensure-wac-token-usage
                boxShadow: '0 8px 12px rgba(30, 31, 33, 0.15)'
            },
            onClick: onClick,
            "aria-hidden": isFadingOut || undefined,
            // @ts-expect-error -- inert is valid HTML but is missing from React types
            inert: isFadingOut ? '' : undefined,
            children: label
        })
    });
    return skipLayer ? /*#__PURE__*/ (0, $gUjjH.createPortal)(control, skipLayer) : control;
};

});
parcelRegister("4DkqQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $35faa748cf73932f$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $2mFjt = parcelRequire("2mFjt");

var $lUXFg = parcelRequire("lUXFg");

var $etBkE = parcelRequire("etBkE");

var $ahhSJ = parcelRequire("ahhSJ");

var $f6YGh = parcelRequire("f6YGh");
var $35faa748cf73932f$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $35faa748cf73932f$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $35faa748cf73932f$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $ahhSJ.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $ahhSJ.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $ahhSJ.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $35faa748cf73932f$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $35faa748cf73932f$var$enabledStyles = (0, $3dJ4i.css)({
    cursor: 'pointer'
});
var $35faa748cf73932f$var$disabledStyles = (0, $3dJ4i.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $35faa748cf73932f$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $lUXFg.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $35faa748cf73932f$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $2mFjt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.3",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $35faa748cf73932f$var$_excluded2);
    var resolvedStyles = (0, $f6YGh.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)("button", (0, $c9bqK.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $35faa748cf73932f$var$baseStyles,
            $35faa748cf73932f$var$focusRingStyles,
            isDisabled ? $35faa748cf73932f$var$disabledStyles : $35faa748cf73932f$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ahhSJ.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $ahhSJ.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $ahhSJ.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $ahhSJ.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $ahhSJ.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $ahhSJ.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $ahhSJ.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $ahhSJ.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
});
var $35faa748cf73932f$export$2e2bcd8739ae039 = $35faa748cf73932f$var$Pressable;

});
parcelRegister("2mFjt", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $1b8daebf78885bf8$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $gO1Bt = parcelRequire("gO1Bt");

var $1HDkY = parcelRequire("1HDkY");
function $1b8daebf78885bf8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b8daebf78885bf8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b8daebf78885bf8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b8daebf78885bf8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b8daebf78885bf8$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gO1Bt.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1HDkY.useTrackedRef)(analyticsData);
    var fnRef = (0, $1HDkY.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $1b8daebf78885bf8$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("gO1Bt", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $c3c28f44effcd199$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $glTPb = parcelRequire("glTPb");

var $hRp2W = parcelRequire("hRp2W");
function $c3c28f44effcd199$export$5bf35293e545f20c() {
    var analyticsContext = (0, $hRp2W.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $glTPb.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("glTPb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be79e91598e9daf2$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $9Ej5K = parcelRequire("9Ej5K");
function $be79e91598e9daf2$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $be79e91598e9daf2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $be79e91598e9daf2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($be79e91598e9daf2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $be79e91598e9daf2$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $be79e91598e9daf2$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $be79e91598e9daf2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $be79e91598e9daf2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $be79e91598e9daf2$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $be79e91598e9daf2$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $9Ej5K.default));

});
parcelRegister("9Ej5K", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7066a8ad8c410e4d$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $7066a8ad8c410e4d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7066a8ad8c410e4d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7066a8ad8c410e4d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7066a8ad8c410e4d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7066a8ad8c410e4d$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7066a8ad8c410e4d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $7066a8ad8c410e4d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $7066a8ad8c410e4d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $7066a8ad8c410e4d$var$_objectSpread($7066a8ad8c410e4d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("hRp2W", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $d00ad0a12cf6ebb6$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $d00ad0a12cf6ebb6$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("1HDkY", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $13d8522820593bf2$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $13d8522820593bf2$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("lUXFg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff4d1c1222d4d672$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $ff4d1c1222d4d672$export$2e2bcd8739ae039() {}

});

parcelRegister("f6YGh", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $b0067c870dff3374$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $b0067c870dff3374$export$f6c783d06584602c; });

var $lFOXD = parcelRequire("lFOXD");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2zYm4 = parcelRequire("2zYm4");

var $3dJ4i = parcelRequire("3dJ4i");

var $ahhSJ = parcelRequire("ahhSJ");

var $7t0tI = parcelRequire("7t0tI");
function $b0067c870dff3374$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b0067c870dff3374$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b0067c870dff3374$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b0067c870dff3374$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b0067c870dff3374$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b0067c870dff3374$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b0067c870dff3374$export$9a199fbafee0014e = {
    backgroundColor: (0, $ahhSJ.backgroundColorMap),
    blockSize: (0, $ahhSJ.dimensionMap),
    borderBlockColor: (0, $ahhSJ.borderColorMap),
    borderBlockEndColor: (0, $ahhSJ.borderColorMap),
    borderBlockEndWidth: (0, $ahhSJ.borderWidthMap),
    borderBlockStartColor: (0, $ahhSJ.borderColorMap),
    borderBlockStartWidth: (0, $ahhSJ.borderWidthMap),
    borderBlockWidth: (0, $ahhSJ.borderWidthMap),
    borderBottomColor: (0, $ahhSJ.borderColorMap),
    borderBottomLeftRadius: (0, $ahhSJ.borderRadiusMap),
    borderBottomRightRadius: (0, $ahhSJ.borderRadiusMap),
    borderBottomWidth: (0, $ahhSJ.borderWidthMap),
    borderColor: (0, $ahhSJ.borderColorMap),
    borderEndEndRadius: (0, $ahhSJ.borderRadiusMap),
    borderEndStartRadius: (0, $ahhSJ.borderRadiusMap),
    borderInlineColor: (0, $ahhSJ.borderColorMap),
    borderInlineEndColor: (0, $ahhSJ.borderColorMap),
    borderInlineEndWidth: (0, $ahhSJ.borderWidthMap),
    borderInlineStartColor: (0, $ahhSJ.borderColorMap),
    borderInlineStartWidth: (0, $ahhSJ.borderWidthMap),
    borderInlineWidth: (0, $ahhSJ.borderWidthMap),
    borderLeftColor: (0, $ahhSJ.borderColorMap),
    borderLeftWidth: (0, $ahhSJ.borderWidthMap),
    borderRadius: (0, $ahhSJ.borderRadiusMap),
    borderRightColor: (0, $ahhSJ.borderColorMap),
    borderRightWidth: (0, $ahhSJ.borderWidthMap),
    borderStartEndRadius: (0, $ahhSJ.borderRadiusMap),
    borderStartStartRadius: (0, $ahhSJ.borderRadiusMap),
    borderTopColor: (0, $ahhSJ.borderColorMap),
    borderTopLeftRadius: (0, $ahhSJ.borderRadiusMap),
    borderTopRightRadius: (0, $ahhSJ.borderRadiusMap),
    borderTopWidth: (0, $ahhSJ.borderWidthMap),
    borderWidth: (0, $ahhSJ.borderWidthMap),
    bottom: (0, $ahhSJ.allSpaceMap),
    boxShadow: (0, $ahhSJ.shadowMap),
    color: (0, $ahhSJ.textColorMap),
    columnGap: (0, $ahhSJ.positiveSpaceMap),
    font: (0, $ahhSJ.fontMap),
    fontFamily: (0, $ahhSJ.fontFamilyMap),
    fontWeight: (0, $ahhSJ.fontWeightMap),
    gap: (0, $ahhSJ.positiveSpaceMap),
    height: (0, $ahhSJ.dimensionMap),
    inlineSize: (0, $ahhSJ.dimensionMap),
    inset: (0, $ahhSJ.allSpaceMap),
    insetBlock: (0, $ahhSJ.allSpaceMap),
    insetBlockEnd: (0, $ahhSJ.allSpaceMap),
    insetBlockStart: (0, $ahhSJ.allSpaceMap),
    insetInline: (0, $ahhSJ.allSpaceMap),
    insetInlineEnd: (0, $ahhSJ.allSpaceMap),
    insetInlineStart: (0, $ahhSJ.allSpaceMap),
    left: (0, $ahhSJ.allSpaceMap),
    margin: (0, $ahhSJ.allSpaceMap),
    marginBlock: (0, $ahhSJ.allSpaceMap),
    marginBlockEnd: (0, $ahhSJ.allSpaceMap),
    marginBlockStart: (0, $ahhSJ.allSpaceMap),
    marginBottom: (0, $ahhSJ.allSpaceMap),
    marginInline: (0, $ahhSJ.allSpaceMap),
    marginInlineEnd: (0, $ahhSJ.allSpaceMap),
    marginInlineStart: (0, $ahhSJ.allSpaceMap),
    marginLeft: (0, $ahhSJ.allSpaceMap),
    marginRight: (0, $ahhSJ.allSpaceMap),
    marginTop: (0, $ahhSJ.allSpaceMap),
    maxBlockSize: (0, $ahhSJ.dimensionMap),
    maxHeight: (0, $ahhSJ.dimensionMap),
    maxInlineSize: (0, $ahhSJ.dimensionMap),
    maxWidth: (0, $ahhSJ.dimensionMap),
    minBlockSize: (0, $ahhSJ.dimensionMap),
    minHeight: (0, $ahhSJ.dimensionMap),
    minInlineSize: (0, $ahhSJ.dimensionMap),
    minWidth: (0, $ahhSJ.dimensionMap),
    opacity: (0, $ahhSJ.opacityMap),
    outlineColor: (0, $ahhSJ.borderColorMap),
    outlineOffset: (0, $ahhSJ.allSpaceMap),
    outlineWidth: (0, $ahhSJ.borderWidthMap),
    padding: (0, $ahhSJ.positiveSpaceMap),
    paddingBlock: (0, $ahhSJ.positiveSpaceMap),
    paddingBlockEnd: (0, $ahhSJ.positiveSpaceMap),
    paddingBlockStart: (0, $ahhSJ.positiveSpaceMap),
    paddingBottom: (0, $ahhSJ.positiveSpaceMap),
    paddingInline: (0, $ahhSJ.positiveSpaceMap),
    paddingInlineEnd: (0, $ahhSJ.positiveSpaceMap),
    paddingInlineStart: (0, $ahhSJ.positiveSpaceMap),
    paddingLeft: (0, $ahhSJ.positiveSpaceMap),
    paddingRight: (0, $ahhSJ.positiveSpaceMap),
    paddingTop: (0, $ahhSJ.positiveSpaceMap),
    right: (0, $ahhSJ.allSpaceMap),
    rowGap: (0, $ahhSJ.positiveSpaceMap),
    top: (0, $ahhSJ.allSpaceMap),
    width: (0, $ahhSJ.dimensionMap),
    zIndex: (0, $ahhSJ.layerMap)
};
var $b0067c870dff3374$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $b0067c870dff3374$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $2zYm4.default)($7t0tI)) === 'object' && (0, $2zYm4.default)($7t0tI.env) === 'object' && false;
};
var $b0067c870dff3374$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $b0067c870dff3374$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $b0067c870dff3374$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $2zYm4.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($b0067c870dff3374$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $2zYm4.default)(value) === 'object' && $b0067c870dff3374$var$safeSelectors.test(key)) {
            styleObj[key] = $b0067c870dff3374$var$_transformStyles(value);
            return;
        }
        if ($b0067c870dff3374$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($b0067c870dff3374$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $b0067c870dff3374$export$9a199fbafee0014e)) return;
        var tokenValue = $b0067c870dff3374$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $b0067c870dff3374$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $b0067c870dff3374$var$_transformStyles(style);
    return (0, $f53LC.default)({}, $b0067c870dff3374$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $b0067c870dff3374$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $b0067c870dff3374$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $b0067c870dff3374$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $lFOXD.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$b0067c870dff3374$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $b0067c870dff3374$export$f6c783d06584602c(style) {
    return $b0067c870dff3374$var$baseXcss(style);
}

});



parcelRegister("7KwbR", function(module, exports) {
$parcel$export(module.exports, "SURVEY_DEMO_CURSOR_LABEL", function () { return $182ff3290c1ba457$export$7cd870b26d543ff9; });
$parcel$export(module.exports, "SURVEY_DEMO_RESPONSE_ID", function () { return $182ff3290c1ba457$export$119c8068fa49d589; });
$parcel$export(module.exports, "SURVEY_DEMO", function () { return $182ff3290c1ba457$export$8e327b935012e825; });

var $4s9kO = parcelRequire("4s9kO");

var $hZhs9 = parcelRequire("hZhs9");

var $cmk36 = parcelRequire("cmk36");
const $182ff3290c1ba457$export$7cd870b26d543ff9 = 'Belle';
const $182ff3290c1ba457$export$119c8068fa49d589 = (0, $4s9kO.surveyResponses).find((response)=>response.answers)?.id ?? '';
const $182ff3290c1ba457$var$TRAVEL_MS = (0, $cmk36.DEMO_CURSOR_TRAVEL_MS);
/** The cursor's own opacity fade. */ const $182ff3290c1ba457$var$FADE_MS = 400;
const $182ff3290c1ba457$var$PRESS_MS = 200;
/** A couple of frames, so a silent reposition paints before travel and the fade come back on. */ const $182ff3290c1ba457$var$TELEPORT_SETTLE_MS = 80;
/** The Insights card thinks, then types its summary out. */ const $182ff3290c1ba457$var$INSIGHT_LOAD_MS = (0, $4s9kO.INSIGHT_THINKING_MS) + Math.ceil((0, $hZhs9.INSIGHT_SUMMARY_TEXT).length / (0, $4s9kO.INSIGHT_CHARS_PER_SECOND) * 1000);
/** The last of the eight rows' 50ms-staggered, 260ms fades. */ const $182ff3290c1ba457$var$RESPONSES_LOAD_MS = 50 * ((0, $4s9kO.surveyResponses).length - 1) + 260;
/** The response panel's width transition, which narrows the table under the cursor. */ const $182ff3290c1ba457$var$PANEL_TRANSITION_MS = 260;
const $182ff3290c1ba457$var$toggleArrive = 400 + $182ff3290c1ba457$var$TRAVEL_MS;
const $182ff3290c1ba457$var$togglePress = $182ff3290c1ba457$var$toggleArrive + 500;
const $182ff3290c1ba457$var$toggleRelease = $182ff3290c1ba457$var$togglePress + $182ff3290c1ba457$var$PRESS_MS;
// Time to see the table land before moving on.
const $182ff3290c1ba457$var$insightsMove = $182ff3290c1ba457$var$toggleRelease + 900;
const $182ff3290c1ba457$var$insightsPress = $182ff3290c1ba457$var$insightsMove + $182ff3290c1ba457$var$TRAVEL_MS + 500;
const $182ff3290c1ba457$var$insightsRelease = $182ff3290c1ba457$var$insightsPress + $182ff3290c1ba457$var$PRESS_MS;
// The answer gets a beat to be read before the cursor comes back.
const $182ff3290c1ba457$var$responsesJump = $182ff3290c1ba457$var$insightsRelease + $182ff3290c1ba457$var$INSIGHT_LOAD_MS + 1400;
const $182ff3290c1ba457$var$responsesIn = $182ff3290c1ba457$var$responsesJump + $182ff3290c1ba457$var$TELEPORT_SETTLE_MS;
const $182ff3290c1ba457$var$responsesPress = $182ff3290c1ba457$var$responsesIn + $182ff3290c1ba457$var$FADE_MS + 500;
const $182ff3290c1ba457$var$responsesRelease = $182ff3290c1ba457$var$responsesPress + $182ff3290c1ba457$var$PRESS_MS;
const $182ff3290c1ba457$var$firstRowJump = $182ff3290c1ba457$var$responsesRelease + $182ff3290c1ba457$var$RESPONSES_LOAD_MS + 500;
const $182ff3290c1ba457$var$firstRowIn = $182ff3290c1ba457$var$firstRowJump + $182ff3290c1ba457$var$TELEPORT_SETTLE_MS;
const $182ff3290c1ba457$var$firstRowPress = $182ff3290c1ba457$var$firstRowIn + $182ff3290c1ba457$var$FADE_MS + 600;
const $182ff3290c1ba457$var$firstRowRelease = $182ff3290c1ba457$var$firstRowPress + $182ff3290c1ba457$var$PRESS_MS;
const $182ff3290c1ba457$export$8e327b935012e825 = {
    cursorIn: 400,
    togglePress: $182ff3290c1ba457$var$togglePress,
    toggleRelease: $182ff3290c1ba457$var$toggleRelease,
    insightsMove: $182ff3290c1ba457$var$insightsMove,
    insightsPress: $182ff3290c1ba457$var$insightsPress,
    insightsRelease: $182ff3290c1ba457$var$insightsRelease,
    insightsCursorOut: $182ff3290c1ba457$var$insightsRelease + 600,
    responsesJump: $182ff3290c1ba457$var$responsesJump,
    responsesIn: $182ff3290c1ba457$var$responsesIn,
    responsesPress: $182ff3290c1ba457$var$responsesPress,
    responsesRelease: $182ff3290c1ba457$var$responsesRelease,
    responsesCursorOut: $182ff3290c1ba457$var$responsesRelease + 400,
    firstRowJump: $182ff3290c1ba457$var$firstRowJump,
    firstRowIn: $182ff3290c1ba457$var$firstRowIn,
    firstRowPress: $182ff3290c1ba457$var$firstRowPress,
    firstRowRelease: $182ff3290c1ba457$var$firstRowRelease,
    // Opening the panel narrows the table, carrying the button with it; the cursor follows.
    firstRowReflow: $182ff3290c1ba457$var$firstRowRelease + $182ff3290c1ba457$var$PANEL_TRANSITION_MS,
    cursorOut: $182ff3290c1ba457$var$firstRowRelease + 1500
};

});
parcelRegister("4s9kO", function(module, exports) {
$parcel$export(module.exports, "SURVEY_CHART_HEIGHT", function () { return $5283d799ed1aa6eb$export$eff3bfdc924beab1; });
$parcel$export(module.exports, "surveyChoices", function () { return $5283d799ed1aa6eb$export$f51c01bd9f025b7b; });
$parcel$export(module.exports, "surveyTotals", function () { return $5283d799ed1aa6eb$export$101524a55f3a5d11; });
$parcel$export(module.exports, "surveyChartTicks", function () { return $5283d799ed1aa6eb$export$b3a7483b1aafc14e; });
$parcel$export(module.exports, "surveyChoiceLabels", function () { return $5283d799ed1aa6eb$export$27353fed25effd9; });
$parcel$export(module.exports, "surveyChoiceAppearances", function () { return $5283d799ed1aa6eb$export$24b907b522f7a06a; });
$parcel$export(module.exports, "surveyResponses", function () { return $5283d799ed1aa6eb$export$2b40b2b3a36683e9; });
$parcel$export(module.exports, "surveyInsight", function () { return $5283d799ed1aa6eb$export$c5e7e79799fab736; });
$parcel$export(module.exports, "INSIGHT_THINKING_MS", function () { return $5283d799ed1aa6eb$export$6a0de2145e07836c; });
$parcel$export(module.exports, "INSIGHT_CHARS_PER_SECOND", function () { return $5283d799ed1aa6eb$export$188aee513f800712; });

var $hZhs9 = parcelRequire("hZhs9");
const $5283d799ed1aa6eb$var$surveyViews = 118;
const $5283d799ed1aa6eb$export$eff3bfdc924beab1 = 206;
const $5283d799ed1aa6eb$var$surveyChoiceSources = [
    {
        id: 'veryDissatisfied',
        label: (0, $hZhs9.jsmPortalPlaygroundHrMessages).choiceVeryDissatisfied,
        barHeight: 41.92,
        responses: 2
    },
    {
        id: 'dissatisfied',
        label: (0, $hZhs9.jsmPortalPlaygroundHrMessages).choiceDissatisfied,
        barHeight: 87.43,
        responses: 8
    },
    {
        id: 'neutral',
        label: (0, $hZhs9.jsmPortalPlaygroundHrMessages).choiceNeutral,
        barHeight: 116.17,
        responses: 20
    },
    {
        id: 'satisfied',
        label: (0, $hZhs9.jsmPortalPlaygroundHrMessages).choiceSatisfied,
        barHeight: 184.44,
        responses: 30
    },
    {
        id: 'verySatisfied',
        label: (0, $hZhs9.jsmPortalPlaygroundHrMessages).choiceVerySatisfied,
        barHeight: 80.24,
        responses: 12
    }
];
const $5283d799ed1aa6eb$var$surveyResponseTotal = $5283d799ed1aa6eb$var$surveyChoiceSources.reduce((sum, choice)=>sum + choice.responses, 0);
const $5283d799ed1aa6eb$export$f51c01bd9f025b7b = $5283d799ed1aa6eb$var$surveyChoiceSources.map((choice)=>({
        ...choice,
        share: $5283d799ed1aa6eb$var$surveyResponseTotal === 0 ? 0 : choice.responses / $5283d799ed1aa6eb$var$surveyResponseTotal
    }));
const $5283d799ed1aa6eb$export$101524a55f3a5d11 = {
    views: $5283d799ed1aa6eb$var$surveyViews,
    responses: $5283d799ed1aa6eb$var$surveyResponseTotal,
    /** Responses divided by views. */ completionRate: $5283d799ed1aa6eb$var$surveyResponseTotal / $5283d799ed1aa6eb$var$surveyViews
};
const $5283d799ed1aa6eb$export$b3a7483b1aafc14e = [
    $5283d799ed1aa6eb$var$surveyResponseTotal,
    50,
    25,
    10,
    0
];
const $5283d799ed1aa6eb$export$27353fed25effd9 = Object.fromEntries($5283d799ed1aa6eb$export$f51c01bd9f025b7b.map((choice)=>[
        choice.id,
        choice.label
    ]));
const $5283d799ed1aa6eb$export$24b907b522f7a06a = {
    veryDissatisfied: 'removed',
    dissatisfied: 'removed',
    neutral: 'default',
    satisfied: 'success',
    verySatisfied: 'success'
};
const $5283d799ed1aa6eb$export$2b40b2b3a36683e9 = [
    {
        id: 'priya-hansra',
        respondent: 'Priya Hansra',
        satisfaction: 'verySatisfied',
        answers: {
            submitted: Date.UTC(2025, 9, 14, 9, 12),
            rewarding: (0, $hZhs9.jsmPortalPlaygroundHrMessages).responsePriyaRewarding
        }
    },
    {
        id: 'raul-gonzalez',
        respondent: 'Raul Gonzalez',
        satisfaction: 'satisfied',
        answers: {
            submitted: Date.UTC(2025, 9, 13, 16, 48),
            rewarding: (0, $hZhs9.jsmPortalPlaygroundHrMessages).responseRaulRewarding
        }
    },
    {
        id: 'olivia-yang',
        respondent: 'Olivia Yang',
        satisfaction: 'neutral',
        answers: {
            submitted: Date.UTC(2025, 9, 13, 11, 5),
            rewarding: (0, $hZhs9.jsmPortalPlaygroundHrMessages).responseOliviaRewarding
        }
    },
    {
        id: 'liam-estrada',
        respondent: 'Liam Estrada',
        satisfaction: 'satisfied',
        answers: {
            submitted: Date.UTC(2025, 9, 12, 14, 30),
            rewarding: (0, $hZhs9.jsmPortalPlaygroundHrMessages).responseLiamRewarding
        }
    },
    {
        id: 'melanie-lee',
        respondent: 'Melanie Lee',
        satisfaction: 'dissatisfied'
    },
    {
        id: 'robi-lopez',
        respondent: 'Robi Lopez',
        satisfaction: 'verySatisfied'
    },
    {
        id: 'florence-garcia',
        respondent: 'Florence Garcia',
        satisfaction: 'neutral'
    },
    {
        id: 'charles-rex',
        respondent: 'Charles Rex',
        satisfaction: 'veryDissatisfied'
    }
];
const $5283d799ed1aa6eb$export$c5e7e79799fab736 = {
    sentimentShare: 0.68,
    themes: [
        (0, $hZhs9.jsmPortalPlaygroundHrMessages).themeTechnicalReadiness,
        (0, $hZhs9.jsmPortalPlaygroundHrMessages).themeDocumentation,
        (0, $hZhs9.jsmPortalPlaygroundHrMessages).themeMentorship
    ]
};
const $5283d799ed1aa6eb$export$6a0de2145e07836c = 2200;
const $5283d799ed1aa6eb$export$188aee513f800712 = 120;

});
parcelRegister("hZhs9", function(module, exports) {
$parcel$export(module.exports, "jsmPortalPlaygroundHrMessages", function () { return $1ae293ac9a1d4f0c$export$1b5ffb4eaf4243ad; });
$parcel$export(module.exports, "INSIGHT_SUMMARY_TEXT", function () { return $1ae293ac9a1d4f0c$export$e417deca0162e8fb; });

var $fnHPc = parcelRequire("fnHPc");
const $1ae293ac9a1d4f0c$export$1b5ffb4eaf4243ad = (0, $fnHPc.defineMessages)({
    breadcrumbSpaces: {
        id: 'JsmPortalPlayground.hr.breadcrumbSpaces',
        defaultMessage: 'Spaces'
    },
    breadcrumbSpace: {
        id: 'JsmPortalPlayground.hr.breadcrumbSpace',
        defaultMessage: 'Vitafleet HR'
    },
    breadcrumbSurveys: {
        id: 'JsmPortalPlayground.hr.breadcrumbSurveys',
        defaultMessage: 'Surveys'
    },
    surveyTitle: {
        id: 'JsmPortalPlayground.hr.surveyTitle',
        defaultMessage: 'Onboarding survey'
    },
    statusActive: {
        id: 'JsmPortalPlayground.hr.statusActive',
        defaultMessage: 'Active'
    },
    copyLink: {
        id: 'JsmPortalPlayground.hr.copyLink',
        defaultMessage: 'Copy link'
    },
    edit: {
        id: 'JsmPortalPlayground.hr.edit',
        defaultMessage: 'Edit'
    },
    moreActions: {
        id: 'JsmPortalPlayground.hr.moreActions',
        defaultMessage: 'More actions'
    },
    tabSummary: {
        id: 'JsmPortalPlayground.hr.tabSummary',
        defaultMessage: 'Summary'
    },
    tabResponses: {
        id: 'JsmPortalPlayground.hr.tabResponses',
        defaultMessage: 'Responses'
    },
    statViews: {
        id: 'JsmPortalPlayground.hr.statViews',
        defaultMessage: '{count, number} views'
    },
    statResponses: {
        id: 'JsmPortalPlayground.hr.statResponses',
        defaultMessage: '{count, number} responses'
    },
    statCompletion: {
        id: 'JsmPortalPlayground.hr.statCompletion',
        defaultMessage: '{rate, number, percent} completion'
    },
    statSince: {
        id: 'JsmPortalPlayground.hr.statSince',
        defaultMessage: 'since 2nd Oct'
    },
    questionSummaries: {
        id: 'JsmPortalPlayground.hr.questionSummaries',
        defaultMessage: 'Question summaries'
    },
    exportResponses: {
        id: 'JsmPortalPlayground.hr.exportResponses',
        defaultMessage: 'Export responses'
    },
    questionOne: {
        id: 'JsmPortalPlayground.hr.questionOne',
        defaultMessage: 'How satisfied are you with the first onboarding session?'
    },
    questionTwo: {
        id: 'JsmPortalPlayground.hr.questionTwo',
        defaultMessage: 'What aspects of your job do you find most rewarding?'
    },
    questionTwoCardTitle: {
        id: 'JsmPortalPlayground.hr.questionTwoCardTitle',
        defaultMessage: 'Q2: {question}'
    },
    responseCount: {
        id: 'JsmPortalPlayground.hr.responseCount',
        defaultMessage: '{count, number} responses'
    },
    insights: {
        id: 'JsmPortalPlayground.hr.insights',
        defaultMessage: 'Insights'
    },
    resultsViewLabel: {
        id: 'JsmPortalPlayground.hr.resultsViewLabel',
        defaultMessage: 'Results view'
    },
    showChart: {
        id: 'JsmPortalPlayground.hr.showChart',
        defaultMessage: 'Show chart'
    },
    showTable: {
        id: 'JsmPortalPlayground.hr.showTable',
        defaultMessage: 'Show table'
    },
    chartLabel: {
        id: 'JsmPortalPlayground.hr.chartLabel',
        defaultMessage: 'Bar chart of responses: {data}'
    },
    chartDatum: {
        id: 'JsmPortalPlayground.hr.chartDatum',
        defaultMessage: '{choice} {count, number}'
    },
    choiceVeryDissatisfied: {
        id: 'JsmPortalPlayground.hr.choiceVeryDissatisfied',
        defaultMessage: 'Very dissatisfied'
    },
    choiceDissatisfied: {
        id: 'JsmPortalPlayground.hr.choiceDissatisfied',
        defaultMessage: 'Dissatisfied'
    },
    choiceNeutral: {
        id: 'JsmPortalPlayground.hr.choiceNeutral',
        defaultMessage: 'Neutral'
    },
    choiceSatisfied: {
        id: 'JsmPortalPlayground.hr.choiceSatisfied',
        defaultMessage: 'Satisfied'
    },
    choiceVerySatisfied: {
        id: 'JsmPortalPlayground.hr.choiceVerySatisfied',
        defaultMessage: 'Very satisfied'
    },
    choiceTableCaption: {
        id: 'JsmPortalPlayground.hr.choiceTableCaption',
        defaultMessage: 'Responses by choice'
    },
    columnChoice: {
        id: 'JsmPortalPlayground.hr.columnChoice',
        defaultMessage: 'Choice'
    },
    columnResponses: {
        id: 'JsmPortalPlayground.hr.columnResponses',
        defaultMessage: 'Responses'
    },
    columnPercentages: {
        id: 'JsmPortalPlayground.hr.columnPercentages',
        defaultMessage: 'Percentages'
    },
    searchResponses: {
        id: 'JsmPortalPlayground.hr.searchResponses',
        defaultMessage: 'Search responses'
    },
    responsesTableCaption: {
        id: 'JsmPortalPlayground.hr.responsesTableCaption',
        defaultMessage: 'Survey responses'
    },
    columnRespondent: {
        id: 'JsmPortalPlayground.hr.columnRespondent',
        defaultMessage: 'Respondent'
    },
    columnSubmitted: {
        id: 'JsmPortalPlayground.hr.columnSubmitted',
        defaultMessage: 'Submitted'
    },
    openResponse: {
        id: 'JsmPortalPlayground.hr.openResponse',
        defaultMessage: "Open {name}'s response"
    },
    closeResponse: {
        id: 'JsmPortalPlayground.hr.closeResponse',
        defaultMessage: "Close {name}'s response"
    },
    responsePanelLabel: {
        id: 'JsmPortalPlayground.hr.responsePanelLabel',
        defaultMessage: "{name}'s survey response"
    },
    surveyResponse: {
        id: 'JsmPortalPlayground.hr.surveyResponse',
        defaultMessage: 'Survey response'
    },
    expandResponse: {
        id: 'JsmPortalPlayground.hr.expandResponse',
        defaultMessage: 'Expand response'
    },
    closeResponsePanel: {
        id: 'JsmPortalPlayground.hr.closeResponsePanel',
        defaultMessage: 'Close response'
    },
    questionOneShort: {
        id: 'JsmPortalPlayground.hr.questionOneShort',
        defaultMessage: 'Q1'
    },
    questionTwoShort: {
        id: 'JsmPortalPlayground.hr.questionTwoShort',
        defaultMessage: 'Q2'
    },
    closeInsights: {
        id: 'JsmPortalPlayground.hr.closeInsights',
        defaultMessage: 'Close insights'
    },
    rovoThinking: {
        id: 'JsmPortalPlayground.hr.rovoThinking',
        defaultMessage: 'Rovo is thinking'
    },
    usesAi: {
        id: 'JsmPortalPlayground.hr.usesAi',
        defaultMessage: 'Uses AI. Verify results.'
    },
    helpful: {
        id: 'JsmPortalPlayground.hr.helpful',
        defaultMessage: 'Helpful'
    },
    notHelpful: {
        id: 'JsmPortalPlayground.hr.notHelpful',
        defaultMessage: 'Not helpful'
    },
    sentimentLabel: {
        id: 'JsmPortalPlayground.hr.sentimentLabel',
        defaultMessage: 'Positive sentiment'
    },
    sentimentShare: {
        id: 'JsmPortalPlayground.hr.sentimentShare',
        defaultMessage: '{share, number, percent}'
    },
    insightSummary: {
        id: 'JsmPortalPlayground.hr.insightSummary',
        defaultMessage: 'The overall tone is welcoming and enthusiastic, but there is significant underlying frustration regarding operational friction and information density. Employees feel valued by the culture but hindered by the "technical debt" of the onboarding process.'
    },
    topThemes: {
        id: 'JsmPortalPlayground.hr.topThemes',
        defaultMessage: 'Top themes'
    },
    themeTechnicalReadiness: {
        id: 'JsmPortalPlayground.hr.themeTechnicalReadiness',
        defaultMessage: 'Technical readiness & access'
    },
    themeDocumentation: {
        id: 'JsmPortalPlayground.hr.themeDocumentation',
        defaultMessage: 'Documentation quality'
    },
    themeMentorship: {
        id: 'JsmPortalPlayground.hr.themeMentorship',
        defaultMessage: 'Social & mentorship integration'
    },
    responsePriyaRewarding: {
        id: 'JsmPortalPlayground.hr.responsePriyaRewarding',
        defaultMessage: 'Pairing with my buddy in week one, I shipped something real on day three.'
    },
    responseRaulRewarding: {
        id: 'JsmPortalPlayground.hr.responseRaulRewarding',
        defaultMessage: 'The team is genuinely welcoming, but laptop access took most of my first week.'
    },
    responseOliviaRewarding: {
        id: 'JsmPortalPlayground.hr.responseOliviaRewarding',
        defaultMessage: 'Solving customer problems. The onboarding docs were out of date though.'
    },
    responseLiamRewarding: {
        id: 'JsmPortalPlayground.hr.responseLiamRewarding',
        defaultMessage: 'Seeing how much autonomy I have this early on.'
    }
});
const $1ae293ac9a1d4f0c$export$e417deca0162e8fb = String($1ae293ac9a1d4f0c$export$1b5ffb4eaf4243ad.insightSummary.defaultMessage);

});



parcelRegister("dihia", function(module, exports) {
$parcel$export(module.exports, "SURVEY_INSIGHTS_TRIGGER_TEST_ID", function () { return $b4aea5af1947d2d8$export$cd607c7bf024b035; });
$parcel$export(module.exports, "SurveyInsights", function () { return $b4aea5af1947d2d8$export$b9f9bf65d271be18; });
/* survey-insights.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $1q52J = parcelRequire("1q52J");

var $8kWtd = parcelRequire("8kWtd");

var $2JPM3 = parcelRequire("2JPM3");

var $izDBw = parcelRequire("izDBw");

var $4s9kO = parcelRequire("4s9kO");

var $hZhs9 = parcelRequire("hZhs9");

var $8ktfY = parcelRequire("8ktfY");

var $bBczw = parcelRequire("bBczw");

var $8ADkf = parcelRequire("8ADkf");

var $9rVRh = parcelRequire("9rVRh");
const $b4aea5af1947d2d8$var$InsightsIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8kWtd))), {
        label: "",
        size: "medium"
    });
const $b4aea5af1947d2d8$var$SentimentIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2JPM3))), {
        label: "",
        size: "small"
    });
const $b4aea5af1947d2d8$export$cd607c7bf024b035 = 'jsm-hr-survey-insights-trigger';
const $b4aea5af1947d2d8$export$b9f9bf65d271be18 = ({ isOpen: isOpen, onOpenChange: onOpenChange, shouldFocusOnOpen: shouldFocusOnOpen = true, testId: testId = $b4aea5af1947d2d8$export$cd607c7bf024b035 })=>{
    const intl = (0, $8e22h.default)();
    const cardId = (0, $1oC0p.useId)();
    const triggerRef = (0, $1oC0p.useRef)(null);
    const close = ()=>{
        onOpenChange(false);
        triggerRef.current?.querySelector('button')?.focus();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c116y"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                ref: triggerRef,
                className: (0, $2jatx.default)([
                    "_1e0c116y"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                    "aria-controls": isOpen ? cardId : undefined,
                    "aria-expanded": isOpen,
                    iconBefore: $b4aea5af1947d2d8$var$InsightsIcon,
                    isSelected: isOpen,
                    onClick: ()=>onOpenChange(!isOpen),
                    testId: testId,
                    children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).insights)
                })
            }),
            isOpen && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1pby1rya _152t1rgy _rjxpidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($b4aea5af1947d2d8$var$SurveyInsightsCard, {
                    id: cardId,
                    onClose: close,
                    shouldFocusOnOpen: shouldFocusOnOpen
                })
            })
        ]
    });
};
const $b4aea5af1947d2d8$var$SurveyInsightsCard = ({ id: id, onClose: onClose, shouldFocusOnOpen: shouldFocusOnOpen })=>{
    const intl = (0, $8e22h.default)();
    const [isThinking, setIsThinking] = (0, $1oC0p.useState)(true);
    const summary = intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).insightSummary);
    (0, $1oC0p.useEffect)(()=>{
        const timer = window.setTimeout(()=>setIsThinking(false), (0, $4s9kO.INSIGHT_THINKING_MS));
        return ()=>window.clearTimeout(timer);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        const closeOnEscape = (event)=>{
            if (event.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', closeOnEscape);
        return ()=>document.removeEventListener('keydown', closeOnEscape);
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ADkf.JsmPlaygroundRovoCard), {
        id: id,
        title: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).insights),
        closeLabel: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).closeInsights),
        onClose: onClose,
        isThinking: isThinking,
        thinkingLabel: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).rovoThinking),
        announcement: summary,
        footerNote: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).usesAi),
        helpfulLabel: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).helpful),
        notHelpfulLabel: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).notHelpful),
        shouldFocusOnOpen: shouldFocusOnOpen,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($b4aea5af1947d2d8$var$SurveyInsightResult, {
            summary: summary
        })
    });
};
/**
 * Reveals `text` a character at a time, like Rovo streaming its answer. Driven by elapsed time
 * rather than a per-character timer, so a dropped frame can't slow the reveal down.
 */ const $b4aea5af1947d2d8$var$useTypewriter = (text, shouldType)=>{
    const [count, setCount] = (0, $1oC0p.useState)(shouldType ? 0 : text.length);
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldType) {
            setCount(text.length);
            return;
        }
        const start = performance.now();
        let frame = 0;
        const tick = (now)=>{
            const next = Math.min(text.length, Math.floor((now - start) / 1000 * (0, $4s9kO.INSIGHT_CHARS_PER_SECOND)));
            setCount(next);
            if (next < text.length) frame = requestAnimationFrame(tick);
        };
        frame = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(frame);
    }, [
        text,
        shouldType
    ]);
    return {
        visibleText: text.slice(0, count),
        isDone: count >= text.length
    };
};
/**
 * The typed summary is hidden from assistive technology: the card announces the whole answer once
 * through its live region instead of it being read out as it types.
 */ const $b4aea5af1947d2d8$var$SurveyInsightResult = ({ summary: summary })=>{
    const intl = (0, $8e22h.default)();
    const prefersReducedMotion = (0, $bBczw.usePrefersReducedMotion)();
    const { visibleText: visibleText, isDone: isDone } = $b4aea5af1947d2d8$var$useTypewriter(summary, !prefersReducedMotion);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulputpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1wpz1y6m"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izDBw.default), {
                    appearance: "success",
                    iconBefore: $b4aea5af1947d2d8$var$SentimentIcon,
                    trailingMetric: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).sentimentShare, {
                        share: (0, $4s9kO.surveyInsight).sentimentShare
                    }),
                    children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).sentimentLabel)
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazi7uo _11c8fhey"
                ]),
                children: [
                    visibleText,
                    !isDone && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_y44vcrx5"
                        ]),
                        children: "\u258D"
                    })
                ]
            }),
            isDone && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpu2gc _y44v5zrp _1bumglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                        level: 6,
                        size: "xxsmall",
                        children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).topThemes)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _zulp12x7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw"
                        ]),
                        children: (0, $4s9kO.surveyInsight).themes.map((theme)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9rVRh.ThemeChip), {
                                    children: intl.formatMessage(theme)
                                })
                            }, theme.id))
                    })
                ]
            })
        ]
    });
};
const $b4aea5af1947d2d8$var$blink = null;
const $b4aea5af1947d2d8$var$themesIn = null;
const $b4aea5af1947d2d8$var$anchorStyles = null;
const $b4aea5af1947d2d8$var$triggerStyles = null;
// Hangs off the trigger's trailing edge, above the chart's positioned gridlines and bars. Local to
// the preview card's stacking context, so the playground cursor still paints over it.
const $b4aea5af1947d2d8$var$overlayStyles = null;
const $b4aea5af1947d2d8$var$resultStyles = null;
const $b4aea5af1947d2d8$var$sentimentStyles = null;
const $b4aea5af1947d2d8$var$summaryStyles = null;
const $b4aea5af1947d2d8$var$caretStyles = null;
const $b4aea5af1947d2d8$var$themesStyles = null;
const $b4aea5af1947d2d8$var$themeListStyles = null;
const $b4aea5af1947d2d8$var$themeItemStyles = null;

});
parcelRegister("izDBw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d85a376c0ccd74c8$export$2e2bcd8739ae039; });
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");


var $farUN = parcelRequire("farUN");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $d85a376c0ccd74c8$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $1oC0p.createElement((0, $farUN.default), baseProps, children);
};
$d85a376c0ccd74c8$var$Lozenge.displayName = 'Lozenge';
var $d85a376c0ccd74c8$export$2e2bcd8739ae039 = $d85a376c0ccd74c8$var$Lozenge;

});
parcelRegister("farUN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b0ad718e0708d2ca$export$2e2bcd8739ae039; });
/* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $f53LC = parcelRequire("f53LC");

var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bjsaS = parcelRequire("bjsaS");

var $4ZpaI = parcelRequire("4ZpaI");

var $a49AS = parcelRequire("a49AS");

var $fI3WF = parcelRequire("fI3WF");

var $6ur0l = parcelRequire("6ur0l");

var $40vaM = parcelRequire("40vaM");

var $hlnuj = parcelRequire("hlnuj");

var $6QyWL = parcelRequire("6QyWL");

var $eEtoF = parcelRequire("eEtoF");

var $aJelm = parcelRequire("aJelm");
function $b0ad718e0708d2ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0ad718e0708d2ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0ad718e0708d2ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0ad718e0708d2ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $b0ad718e0708d2ca$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $b0ad718e0708d2ca$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
var $b0ad718e0708d2ca$var$interactiveMotionStyles = {
    motion: "_v564k6bl _1ggl5xtf"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $b0ad718e0708d2ca$var$LozengeBase = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $fI3WF.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $1oC0p.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $aJelm.resolveLozengeColor)(appearance) || 'neutral';
    var _getThemeStyles = (0, $6QyWL.getThemeStyles)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $aJelm.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    var metricBadgeAppearance = function() {
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    }();
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : "min(".concat(maxWidthValue, ", 100%)")
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $1oC0p.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, $6ur0l.fg)('platform-dst-motion-uplift');
    var enableButtonMotionFG = (0, $6ur0l.fg)('platform-dst-motion-uplift-button');
    var innerContent = /*#__PURE__*/ $1oC0p.createElement("span", (0, $c9bqK.default)({
        "data-testid": testId ? "".concat(testId, "--content") : undefined
    }, enableMotionFG ? resizingWidth : undefined, {
        className: (0, $2jatx.default)([
            $b0ad718e0708d2ca$var$styles.content,
            spacing === 'spacious' && $b0ad718e0708d2ca$var$styles.contentSpacious,
            isInteractive && enableButtonMotionFG && $b0ad718e0708d2ca$var$styles.loadingMotion,
            isLoading && $b0ad718e0708d2ca$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $b0ad718e0708d2ca$var$styles.maxWidth
        ])
    }), iconBefore && /*#__PURE__*/ $1oC0p.createElement((0, $eEtoF.default), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $1oC0p.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $2jatx.default)([
            $b0ad718e0708d2ca$var$styles.text,
            enableMotionFG && resizing && !maxWidth ? $b0ad718e0708d2ca$var$styles.textClip : $b0ad718e0708d2ca$var$styles.textEllipsis,
            spacing === 'spacious' && $b0ad718e0708d2ca$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $2jatx.default)([
            $b0ad718e0708d2ca$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $bjsaS.default), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a49AS))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $1oC0p.createElement((0, $40vaM.default), (0, $c9bqK.default)({
        ref: ref,
        xcss: (0, $4ZpaI.cx)($b0ad718e0708d2ca$var$styles.container, !isLoading && enableButtonMotionFG ? $b0ad718e0708d2ca$var$interactiveMotionStyles.motion : enableMotionFG && $b0ad718e0708d2ca$var$styles.motionContainer, spacing === 'spacious' && $b0ad718e0708d2ca$var$styles.containerSpacious, !isSelected && $b0ad718e0708d2ca$var$styles.iconBorderFilter, $b0ad718e0708d2ca$var$styles[colorStyleKey], !isLoading && $b0ad718e0708d2ca$var$styles[interactiveStyleKey], hasTrailingMetric && $b0ad718e0708d2ca$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $b0ad718e0708d2ca$var$styles.containerBadgeNeutralAppearance)
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $b0ad718e0708d2ca$var$_objectSpread($b0ad718e0708d2ca$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'var(--border-color) !important' : 'transparent'),
            backgroundColor: isSelected ? $b0ad718e0708d2ca$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }, isSelected && {
        'data-selected': 'true'
    }), innerContent, isLoading && /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId ? "".concat(testId, "--loading-overlay") : undefined,
        className: (0, $2jatx.default)([
            $b0ad718e0708d2ca$var$styles.loadingOverlay,
            enableButtonMotionFG && $b0ad718e0708d2ca$var$styles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $hlnuj.default), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $2jatx.default)([
            $b0ad718e0708d2ca$var$styles.container,
            spacing === 'spacious' && $b0ad718e0708d2ca$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $b0ad718e0708d2ca$var$styles.containerBadgePadding,
            $b0ad718e0708d2ca$var$styles[colorStyleKey],
            $b0ad718e0708d2ca$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $b0ad718e0708d2ca$var$styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
var $b0ad718e0708d2ca$export$2e2bcd8739ae039 = $b0ad718e0708d2ca$var$LozengeBase;

});
parcelRegister("bjsaS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $83c752e59aa20135$export$2e2bcd8739ae039; });
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $86eve = parcelRequire("86eve");

var $elcRD = parcelRequire("elcRD");

var $7zAbH = parcelRequire("7zAbH");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $83c752e59aa20135$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $83c752e59aa20135$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $7zAbH.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ var $83c752e59aa20135$var$BadgeNew = /*#__PURE__*/ (0, $1oC0p.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    var _useThemeObserver = (0, $elcRD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    var resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $2jatx.default)([
            $83c752e59aa20135$var$stylesNew.root,
            $83c752e59aa20135$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $86eve.Text), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $83c752e59aa20135$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $83c752e59aa20135$export$2e2bcd8739ae039 = $83c752e59aa20135$var$BadgeNew;

});
parcelRegister("86eve", function(module, exports) {
$parcel$export(module.exports, "Text", function () { return $5e5a2230fb5ed8a9$export$5f1af8db9871e1d6; });
/* text.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lmxXn = parcelRequire("lmxXn");

var $1hVAg = parcelRequire("1hVAg");

var $9gr6w = parcelRequire("9gr6w");

var $cxZhB = parcelRequire("cxZhB");
var $5e5a2230fb5ed8a9$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $5e5a2230fb5ed8a9$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $9gr6w.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($5e5a2230fb5ed8a9$var$inverseColorMap.hasOwnProperty(surface)) return $5e5a2230fb5ed8a9$var$inverseColorMap[surface];
    return 'color.text';
};
var $5e5a2230fb5ed8a9$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $5e5a2230fb5ed8a9$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $5e5a2230fb5ed8a9$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $5e5a2230fb5ed8a9$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $5e5a2230fb5ed8a9$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $5e5a2230fb5ed8a9$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $lmxXn.default)($5e5a2230fb5ed8a9$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $cxZhB.useHasTextAncestor)();
    var color = $5e5a2230fb5ed8a9$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $1oC0p.createElement(Component, {
        id: id,
        className: (0, $2jatx.default)([
            $5e5a2230fb5ed8a9$var$styles.root,
            size && $5e5a2230fb5ed8a9$var$fontSizeMap[size],
            color && $5e5a2230fb5ed8a9$var$textColorMap[color],
            maxLines && $5e5a2230fb5ed8a9$var$styles.truncation,
            maxLines === 1 && $5e5a2230fb5ed8a9$var$styles.breakAll,
            align && $5e5a2230fb5ed8a9$var$styles["textAlign.".concat(align)],
            weight && $5e5a2230fb5ed8a9$var$fontWeightMap[weight],
            Component === 'em' && $5e5a2230fb5ed8a9$var$styles['as.em'],
            Component === 'strong' && $5e5a2230fb5ed8a9$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $1oC0p.createElement((0, $1hVAg.HasTextAncestorProvider), {
        value: true
    }, component);
});

});
parcelRegister("1hVAg", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $0f040bf2414a02ce$export$ae933c6cbe5643ad; });

var $jVpne = parcelRequire("jVpne");
var $0f040bf2414a02ce$export$ae933c6cbe5643ad = (0, $jVpne.HasTextAncestorContext).Provider;

});
parcelRegister("jVpne", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorContext", function () { return $e81705de5a12a842$export$19538d0bfc69c6e0; });

var $1oC0p = parcelRequire("1oC0p");
var $e81705de5a12a842$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});


parcelRegister("9gr6w", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $6beaa1fbc4e89f73$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");

var $YfvoV = parcelRequire("YfvoV");
var $6beaa1fbc4e89f73$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)((0, $YfvoV.SurfaceContext));
};
(0, $YfvoV.SurfaceContext).displayName = 'SurfaceProvider';

});
parcelRegister("YfvoV", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $0b51a1c6489fc4ed$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $0b51a1c6489fc4ed$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');

});


parcelRegister("cxZhB", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", function () { return $92281a9fec1fafd8$export$9322276ec105d055; });

var $1oC0p = parcelRequire("1oC0p");

var $jVpne = parcelRequire("jVpne");
var $92281a9fec1fafd8$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)((0, $jVpne.HasTextAncestorContext));
};

});


parcelRegister("elcRD", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", function () { return $a70d0160bfac86bb$export$3dd7971102e44fa8; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2C0oX = parcelRequire("2C0oX");

var $hfs88 = parcelRequire("hfs88");
var $a70d0160bfac86bb$export$3dd7971102e44fa8 = function useThemeObserver() {
    var _useState = (0, $1oC0p.useState)((0, $2C0oX.getGlobalTheme)()), _useState2 = (0, $2qaZZ.default)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        var observer = new (0, $hfs88.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $a70d0160bfac86bb$export$2e2bcd8739ae039 = $a70d0160bfac86bb$export$3dd7971102e44fa8;

});
parcelRegister("2C0oX", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $1e6f711b0f02f5c5$export$813ecdf77207a053; });

var $f53LC = parcelRequire("f53LC");

var $088M6 = parcelRequire("088M6");

var $87n0C = parcelRequire("87n0C");

var $3adPN = parcelRequire("3adPN");
function $1e6f711b0f02f5c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e6f711b0f02f5c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e6f711b0f02f5c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e6f711b0f02f5c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1e6f711b0f02f5c5$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $088M6.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $088M6.THEME_DATA_ATTRIBUTE)) || '';
    return $1e6f711b0f02f5c5$var$_objectSpread($1e6f711b0f02f5c5$var$_objectSpread({}, (0, $3adPN.themeStringToObject)(theme)), (0, $87n0C.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("088M6", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $000650bdc16ccd85$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $000650bdc16ccd85$export$a00eac3f8684bcd0; });
var $000650bdc16ccd85$export$4ef52930e33717cd = 'data-theme';
var $000650bdc16ccd85$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $000650bdc16ccd85$export$a00eac3f8684bcd0 = 'data-color-mode';
var $000650bdc16ccd85$export$2112803007239c61 = 'data-contrast-mode';
var $000650bdc16ccd85$export$352e418ed5b6193a = 'data-custom-theme';
var $000650bdc16ccd85$export$6f0c6fb8c80fcc92 = 'ds';
var $000650bdc16ccd85$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $000650bdc16ccd85$export$dddac1532e822863 = "--".concat($000650bdc16ccd85$export$6f0c6fb8c80fcc92, "-token-not-found");
var $000650bdc16ccd85$export$9d7b58831ae93caa = "--".concat($000650bdc16ccd85$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("87n0C", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", function () { return $5e90d345ff629133$export$fcfb1976c88f9f75; });

var $dKImh = parcelRequire("dKImh");
var $5e90d345ff629133$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $dKImh.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("dKImh", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $a031fae599ffe359$export$83993de8eb66733; });
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $a031fae599ffe359$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("3adPN", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $24dd097deef74ec5$export$f19b488f7c0547ee; });

var $2qaZZ = parcelRequire("2qaZZ");

var $jxyKn = parcelRequire("jxyKn");

var $IIKDf = parcelRequire("IIKDf");

var $7sZGO = parcelRequire("7sZGO");
var $24dd097deef74ec5$var$customThemeOptions = 'UNSAFE_themeOptions';
var $24dd097deef74ec5$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $jxyKn.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $7sZGO.isThemeKind)(kind) && (0, $IIKDf.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $24dd097deef74ec5$var$customThemeOptions) try {
            themeObject[$24dd097deef74ec5$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});
parcelRegister("jxyKn", function(module, exports) {
$parcel$export(module.exports, "isColorMode", function () { return $e39c0d725d125fa6$export$4a14e169b1de4ee7; });
var $e39c0d725d125fa6$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("IIKDf", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", function () { return $0866d2d16524e13a$export$ea35b8958c39dd07; });

var $atmk1 = parcelRequire("atmk1");
var $0866d2d16524e13a$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $atmk1.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("atmk1", function(module, exports) {
$parcel$export(module.exports, "themeIds", function () { return $79fded7e557e1d95$export$7d43e72a58e3283f; });
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $79fded7e557e1d95$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("7sZGO", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", function () { return $56fb002d3c596932$export$958fa026be3a263e; });
var $56fb002d3c596932$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $56fb002d3c596932$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $56fb002d3c596932$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});



parcelRegister("hfs88", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8e9a87a281766eb$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $088M6 = parcelRequire("088M6");

var $2C0oX = parcelRequire("2C0oX");
var $c8e9a87a281766eb$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $cTewU.default)(this, ThemeMutationObserver);
        (0, $f53LC.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $avOEA.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $2C0oX.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $088M6.THEME_DATA_ATTRIBUTE),
                            (0, $088M6.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $f53LC.default)($c8e9a87a281766eb$export$b741a7c3bcb1c635, "observer", null);
(0, $f53LC.default)($c8e9a87a281766eb$export$b741a7c3bcb1c635, "callbacks", new Set());
var $c8e9a87a281766eb$export$2e2bcd8739ae039 = $c8e9a87a281766eb$export$b741a7c3bcb1c635;

});


parcelRegister("7zAbH", function(module, exports) {
$parcel$export(module.exports, "formatValue", function () { return $5837df67c7fcdcd7$export$7c4d25c0c3217d8c; });
function $5837df67c7fcdcd7$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $5837df67c7fcdcd7$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $5837df67c7fcdcd7$var$getSafeValue(value);
    var safeMax = $5837df67c7fcdcd7$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("a49AS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7541b83ea71501fc$var$_react = $7541b83ea71501fc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7541b83ea71501fc$var$_iconNew = $7541b83ea71501fc$var$_interopRequireDefault((parcelRequire("c2o6J")));
function $7541b83ea71501fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7541b83ea71501fc$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $7541b83ea71501fc$var$_react.default.createElement($7541b83ea71501fc$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$7541b83ea71501fc$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $7541b83ea71501fc$var$_default = module.exports.default = $7541b83ea71501fc$var$ChevronDownIcon;

});
parcelRegister("c2o6J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", function () { return $8c385f365c08d6dd$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $8c385f365c08d6dd$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $8c385f365c08d6dd$var$svgStyles = null;
var $8c385f365c08d6dd$var$iconStyles = null;
var $8c385f365c08d6dd$var$smallIconStyles = null;
var $8c385f365c08d6dd$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $8c385f365c08d6dd$var$baseHcmStyles = null;
var $8c385f365c08d6dd$var$scaleSize = null;
var $8c385f365c08d6dd$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8c385f365c08d6dd$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8c385f365c08d6dd$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $8c385f365c08d6dd$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $8c385f365c08d6dd$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $2jatx.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $8c385f365c08d6dd$var$coreSizeSmall[spacing] : $8c385f365c08d6dd$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$8c385f365c08d6dd$export$2e2bcd8739ae039 = $8c385f365c08d6dd$export$f04a61298a47a40f;

});


parcelRegister("fI3WF", function(module, exports) {
$parcel$export(module.exports, "useResizing", function () { return $b6fe068590de8554$export$a300664a1a230956; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $7kals = parcelRequire("7kals");

var $59KDg = parcelRequire("59KDg");

var $67h8K = parcelRequire("67h8K");

var $lTsUv = parcelRequire("lTsUv");

var $cUIvB = parcelRequire("cUIvB");

var $3RhjB = parcelRequire("3RhjB");
/**
 * Which dimension(s) of the element to animate.
 *
 * - `'width'` animates only width changes.
 * - `'height'` animates only height changes.
 * - `'both'` animates width and height changes simultaneously.
 */ /**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $b6fe068590de8554$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $b6fe068590de8554$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $b6fe068590de8554$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var $b6fe068590de8554$export$a300664a1a230956 = function useResizing(_ref) {
    var dimension = _ref.dimension, duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $1oC0p.useRef)();
    var _useElementRef = (0, $59KDg.useElementRef)(), _useElementRef2 = (0, $2qaZZ.default)(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $cUIvB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $lTsUv.useRequestAnimationFrame)();
    (0, $3RhjB.useSnapshotBeforeUpdate)(function() {
        if ((0, $7kals.isReducedMotion)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $67h8K.useLayoutEffect)(function() {
        if ((0, $7kals.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$b6fe068590de8554$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var propertyList = $b6fe068590de8554$var$getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = $b6fe068590de8554$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});
parcelRegister("59KDg", function(module, exports) {
$parcel$export(module.exports, "useElementRef", function () { return $3c11f7360c01a5d8$export$ff879f35a69d56b7; });

var $1oC0p = parcelRequire("1oC0p");
var $3c11f7360c01a5d8$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $1oC0p.useRef)(null);
    var setRef = (0, $1oC0p.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("lTsUv", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", function () { return $ff05290b43a4926e$export$1775f27e7c8051ca; });

var $1oC0p = parcelRequire("1oC0p");
var $ff05290b43a4926e$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $ff05290b43a4926e$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ff05290b43a4926e$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("3RhjB", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", function () { return $2cf3c0c236410cec$export$9e95200239cd148b; });

var $1oC0p = parcelRequire("1oC0p");

var $67h8K = parcelRequire("67h8K");
var $2cf3c0c236410cec$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $1oC0p.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $67h8K.useLayoutEffect)(function() {
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("40vaM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2eaf57d09aa8fce1$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $lFOXD = parcelRequire("lFOXD");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $2rGHU = parcelRequire("2rGHU");

var $7uNuF = parcelRequire("7uNuF");

var $hGQNn = parcelRequire("hGQNn");

var $f8thQ = parcelRequire("f8thQ");

var $7TmWS = parcelRequire("7TmWS");

var $kR75I = parcelRequire("kR75I");

var $3vf05 = parcelRequire("3vf05");

var $2cBO8 = parcelRequire("2cBO8");

var $j2pUq = parcelRequire("j2pUq");
var $2eaf57d09aa8fce1$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $2eaf57d09aa8fce1$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $2eaf57d09aa8fce1$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $7TmWS.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $j2pUq.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $kR75I.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $kR75I.borderWidthMap)['border.width'], " solid")
        }
    }
});
var $2eaf57d09aa8fce1$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $2eaf57d09aa8fce1$var$enabledStyles = (0, $3dJ4i.css)({
    cursor: 'pointer'
});
var $2eaf57d09aa8fce1$var$disabledStyles = (0, $3dJ4i.css)({
    cursor: 'not-allowed'
});
var $2eaf57d09aa8fce1$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $7uNuF.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $2eaf57d09aa8fce1$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $hGQNn.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $2rGHU.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.4.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $2eaf57d09aa8fce1$var$_excluded2);
    var resolvedStyles = (0, $2cBO8.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)("button", (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $2eaf57d09aa8fce1$var$baseStyles,
            $2eaf57d09aa8fce1$var$focusRingStyles,
            isDisabled ? $2eaf57d09aa8fce1$var$disabledStyles : $2eaf57d09aa8fce1$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $f8thQ.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $3vf05.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $3vf05.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $3vf05.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $3vf05.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $3vf05.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $3vf05.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $3vf05.paddingStylesMap).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, $lFOXD.default)(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2eaf57d09aa8fce1$export$2e2bcd8739ae039 = $2eaf57d09aa8fce1$export$27c701ed9e449e99;

});
parcelRegister("2rGHU", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $1c7f3b28e2329e29$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $wG796 = parcelRequire("wG796");

var $lD31M = parcelRequire("lD31M");
function $1c7f3b28e2329e29$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c7f3b28e2329e29$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c7f3b28e2329e29$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c7f3b28e2329e29$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1c7f3b28e2329e29$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $wG796.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $lD31M.useTrackedRef)(analyticsData);
    var fnRef = (0, $lD31M.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $1c7f3b28e2329e29$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("wG796", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $0623a8499b86b4b0$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $6Tv48 = parcelRequire("6Tv48");

var $hAH5j = parcelRequire("hAH5j");
function $0623a8499b86b4b0$export$5bf35293e545f20c() {
    var analyticsContext = (0, $hAH5j.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $6Tv48.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("6Tv48", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $504ffa211e668923$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");

var $dOVOw = parcelRequire("dOVOw");
function $504ffa211e668923$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $504ffa211e668923$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $504ffa211e668923$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $504ffa211e668923$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $504ffa211e668923$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $504ffa211e668923$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $504ffa211e668923$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($504ffa211e668923$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $504ffa211e668923$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $504ffa211e668923$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $504ffa211e668923$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            var payload = $504ffa211e668923$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $504ffa211e668923$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $dOVOw.default));
var $504ffa211e668923$var$clonePayload = function clonePayload(payload) {
    if ((0, $6ur0l.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $504ffa211e668923$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};

});
parcelRegister("dOVOw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0298b8f18e3dc64b$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $0298b8f18e3dc64b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0298b8f18e3dc64b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0298b8f18e3dc64b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0298b8f18e3dc64b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0298b8f18e3dc64b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $0298b8f18e3dc64b$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $0298b8f18e3dc64b$var$_objectSpread($0298b8f18e3dc64b$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("hAH5j", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $cce7382d09f03b95$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $cce7382d09f03b95$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("lD31M", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $fbef96b9d2a43f6e$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $fbef96b9d2a43f6e$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("f8thQ", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $b04e52211c070a0e$export$e7af83bafe7f9e63; });
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3Rmu2 = parcelRequire("3Rmu2");

var $alKn9 = parcelRequire("alKn9");
var $b04e52211c070a0e$export$e7af83bafe7f9e63 = (0, $alKn9.getSerializedStylesMap)('backgroundColor', (0, $3Rmu2.backgroundColorMap));

});
parcelRegister("3Rmu2", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", function () { return $2cf7c3128a7f0ee9$export$d1d79bf68ac056bd; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74848f30a8ab0264055ca77ebdcac583>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $2cf7c3128a7f0ee9$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("alKn9", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", function () { return $788fd61de49550d7$export$ca0f9c2de39ffed7; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");
var $788fd61de49550d7$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, tokenName) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = (0, $3dJ4i.css)((0, $f53LC.default)({}, cssProperty, tokenMap[tokenName]));
        return emotionSpacingMap;
    }, {});
};

});


parcelRegister("7TmWS", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", function () { return $5bef78953ccd1e1c$export$1531ad5bb3fbedac; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2243347101d0284063f83cb3084a0b4>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $5bef78953ccd1e1c$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("kR75I", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", function () { return $f2ee420dcecda7f3$export$e1b83c5210c471b8; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee12747fee6f7445e430f52ee1f7b86>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ var $f2ee420dcecda7f3$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("3vf05", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", function () { return $28cfe71f44e91b7d$export$e615f061ca585a6c; });
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $Y3c80 = parcelRequire("Y3c80");

var $j2pUq = parcelRequire("j2pUq");
var $28cfe71f44e91b7d$export$e615f061ca585a6c = (0, $Y3c80.createSpacingStylesMap)((0, $j2pUq.positiveSpaceMap));

});
parcelRegister("Y3c80", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", function () { return $0b48151860de2857$export$f2bee1f59203ac70; });
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $alKn9 = parcelRequire("alKn9");
var $0b48151860de2857$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
var $0b48151860de2857$export$f2bee1f59203ac70 = function createSpacingStylesMap(tokenMap) {
    return $0b48151860de2857$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
        styleMap[spacingProperty] = (0, $alKn9.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("j2pUq", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", function () { return $ddc24d34823ec4f0$export$958d0ae7f2977ae4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40ae4d14447bdc898f255059f8589afd>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ var $ddc24d34823ec4f0$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("2cBO8", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $19aa078d5e8640de$export$a9c84988c8f81f2d; });

var $lFOXD = parcelRequire("lFOXD");

var $54JdB = parcelRequire("54JdB");
function $19aa078d5e8640de$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $19aa078d5e8640de$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $19aa078d5e8640de$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $19aa078d5e8640de$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $19aa078d5e8640de$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $19aa078d5e8640de$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $19aa078d5e8640de$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $19aa078d5e8640de$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $19aa078d5e8640de$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $lFOXD.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref = objArgs || {}, styles = _ref[0, $54JdB.uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("54JdB", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", function () { return $3b2066ea8babc688$export$43e479c916cb4ada; });
var $3b2066ea8babc688$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});



parcelRegister("hlnuj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca069e0646927ede$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $hGQNn = parcelRequire("hGQNn");

var $i1NUX = parcelRequire("i1NUX");
/**
 * Returns the appropriate circle stroke color.
 */ function $ca069e0646927ede$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $ca069e0646927ede$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $ca069e0646927ede$var$loadIn = null;
var $ca069e0646927ede$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $ca069e0646927ede$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $ca069e0646927ede$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $i1NUX.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $ca069e0646927ede$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $hGQNn.default));
    $ca069e0646927ede$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $2jatx.default)([
            $ca069e0646927ede$var$styles.wrapperStyles,
            $ca069e0646927ede$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $2jatx.default)([
            $ca069e0646927ede$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $2jatx.default)([
            $ca069e0646927ede$var$styles.circleStyles
        ])
    })));
}));
var $ca069e0646927ede$export$2e2bcd8739ae039 = $ca069e0646927ede$var$Spinner;

});
parcelRegister("i1NUX", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $d1ff0a9fdac8e386$export$4e9f1640bbe7a1a8; });
var $d1ff0a9fdac8e386$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("6QyWL", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", function () { return $4fc2b5188be17d82$export$a3fc04b8551e006a; });
// extract the category and key from the resolved color
var $4fc2b5188be17d82$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("eEtoF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aaab9abd9ed50716$export$2e2bcd8739ae039; });
/* icon-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $pZFYX = parcelRequire("pZFYX");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
var $aaab9abd9ed50716$var$getIconColor = function getIconColor(color) {
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
var $aaab9abd9ed50716$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ var $aaab9abd9ed50716$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $aaab9abd9ed50716$var$getIconColor(color);
    return (0, $6ur0l.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $pZFYX.Box), {
        xcss: $aaab9abd9ed50716$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$aaab9abd9ed50716$export$2e2bcd8739ae039 = $aaab9abd9ed50716$var$IconRenderer;

});
parcelRegister("pZFYX", function(module, exports) {
$parcel$export(module.exports, "Box", function () { return $04e22d8242646257$export$e71c4d32a2263218; });
/* box.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $YfvoV = parcelRequire("YfvoV");
var $04e22d8242646257$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $04e22d8242646257$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $04e22d8242646257$var$baseStyles = null;
var $04e22d8242646257$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $04e22d8242646257$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $04e22d8242646257$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $04e22d8242646257$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $04e22d8242646257$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $04e22d8242646257$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $04e22d8242646257$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
var $04e22d8242646257$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $04e22d8242646257$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $04e22d8242646257$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: (0, $2jatx.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $04e22d8242646257$var$backgroundColorMap[backgroundColor],
            backgroundColor && $04e22d8242646257$var$isSurfaceToken(backgroundColor) && $04e22d8242646257$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $04e22d8242646257$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $04e22d8242646257$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $04e22d8242646257$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $04e22d8242646257$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $YfvoV.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
function $04e22d8242646257$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $04e22d8242646257$var$setSurfaceTokenMap;
}

});


parcelRegister("aJelm", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", function () { return $7cf93bb09f8b948a$export$acf5d2b7dc999bda; });
// Map legacy appearance to new color values
var $7cf93bb09f8b948a$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $7cf93bb09f8b948a$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $7cf93bb09f8b948a$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};

});



parcelRegister("8ktfY", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundHeading", function () { return $147e8064d762d0bd$export$8c6017429d26fc9b; });

var $7VQPk = parcelRequire("7VQPk");

var $dTJrO = parcelRequire("dTJrO");
var $69vmd = parcelRequire("69vmd");
const $147e8064d762d0bd$export$8c6017429d26fc9b = ({ children: children, id: id, level: level, size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $69vmd.default), {
        value: level,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
            as: "div",
            id: id,
            size: size,
            children: children
        })
    });

});

parcelRegister("8ADkf", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundRovoCard", function () { return $fce10f6986e7a2b2$export$68aaed1f73fd834f; });
/* jsm-playground-rovo-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2r6UE = parcelRequire("2r6UE");

var $cNOwN = parcelRequire("cNOwN");

var $d6iWh = parcelRequire("d6iWh");

var $bmQfx = parcelRequire("bmQfx");

var $51it3 = parcelRequire("51it3");

var $lPRxe = parcelRequire("lPRxe");

var $4jcRW = parcelRequire("4jcRW");

var $FapDU = parcelRequire("FapDU");

var $8ktfY = parcelRequire("8ktfY");

var $4JioC = parcelRequire("4JioC");
const $fce10f6986e7a2b2$var$CloseIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
        label: "",
        size: "medium"
    });
const $fce10f6986e7a2b2$var$HelpfulIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51it3))), {
        label: "",
        size: "medium"
    });
const $fce10f6986e7a2b2$var$NotHelpfulIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmQfx))), {
        label: "",
        size: "medium"
    });
const $fce10f6986e7a2b2$var$noop = ()=>{};
/** Shorter than a real answer on purpose — they only need to read as "loading". */ const $fce10f6986e7a2b2$var$thinkingLineWidths = [
    '42%',
    '100%',
    '100%',
    '64%'
];
const $fce10f6986e7a2b2$export$68aaed1f73fd834f = ({ id: id, title: title, closeLabel: closeLabel, onClose: onClose, isThinking: isThinking, thinkingLabel: thinkingLabel, announcement: announcement, footerNote: footerNote, helpfulLabel: helpfulLabel, notHelpfulLabel: notHelpfulLabel, children: children, shouldFocusOnOpen: shouldFocusOnOpen = true })=>{
    const titleId = `${id ?? 'jsm-playground-rovo-card'}-title`;
    const closeRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (shouldFocusOnOpen) closeRef.current?.querySelector('button')?.focus();
    // Only on open: the card should not grab focus back if the prop changes later.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        id: id,
        role: "dialog",
        "aria-labelledby": titleId,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _1bsb1y37 _19itia51 _2rkopb1k _bfhk1bhr _16qs130s _1reo15vq _18m915vq _y44vw7xh _1bumglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulputpp _1yt4pxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                                id: titleId,
                                level: 5,
                                size: "xsmall",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                ref: closeRef,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                    appearance: "subtle",
                                    icon: $fce10f6986e7a2b2$var$CloseIcon,
                                    label: closeLabel,
                                    onClick: onClose,
                                    spacing: "compact"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y44vctyh _1bumglyw"
                        ]),
                        children: isThinking ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            "aria-hidden": "true",
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulputpp"
                            ]),
                            children: $fce10f6986e7a2b2$var$thinkingLineWidths.map((width, index)=>// Identical placeholders, so the index is the only meaningful key.
                                // eslint-disable-next-line react/no-array-index-key
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                                    borderRadius: "var(--ds-radius-xsmall, 2px)",
                                    height: "16px",
                                    width: width
                                }, index))
                        }) : children
                    }, isThinking ? 'thinking' : 'result')
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc _1tkexy5q _85i5utpp _18zrpxbi"
                ]),
                children: isThinking ? /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _4cvr1h6o _zulp12x7"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4JioC.JsmPlaygroundRovoMorphingShape), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: thinkingLabel
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            className: (0, $2jatx.default)([
                                "_1e0c116y _4cvr1h6o _zulp12x7"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d6iWh))), {
                                    color: "var(--ds-icon-subtle, #505258)",
                                    label: "",
                                    size: "small"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    children: footerNote
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            "aria-hidden": "true",
                            // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
                            inert: "",
                            className: (0, $2jatx.default)([
                                "_1e0c116y _4cvr1h6o _zulp12x7"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                    appearance: "subtle",
                                    icon: $fce10f6986e7a2b2$var$NotHelpfulIcon,
                                    label: notHelpfulLabel,
                                    onClick: $fce10f6986e7a2b2$var$noop,
                                    spacing: "compact",
                                    tabIndex: -1
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                    appearance: "subtle",
                                    icon: $fce10f6986e7a2b2$var$HelpfulIcon,
                                    label: helpfulLabel,
                                    onClick: $fce10f6986e7a2b2$var$noop,
                                    spacing: "compact",
                                    tabIndex: -1
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "aria-live": "polite",
                    children: isThinking ? '' : announcement
                })
            })
        ]
    });
};
const $fce10f6986e7a2b2$var$cardIn = null;
const $fce10f6986e7a2b2$var$resultIn = null;
const $fce10f6986e7a2b2$var$cardStyles = null;
const $fce10f6986e7a2b2$var$bodyStyles = null;
const $fce10f6986e7a2b2$var$headerStyles = null;
const $fce10f6986e7a2b2$var$phaseStyles = null;
const $fce10f6986e7a2b2$var$thinkingLinesStyles = null;
const $fce10f6986e7a2b2$var$footerStyles = null;
const $fce10f6986e7a2b2$var$footerGroupStyles = null;

});
parcelRegister("4JioC", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundRovoMorphingShape", function () { return $8dde84746681ee59$export$bbda8e93d8203d19; });
/* jsm-playground-rovo-morphing-shape.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bBczw = parcelRequire("bBczw");
const $8dde84746681ee59$var$FPS = 30;
const $8dde84746681ee59$var$TOTAL_FRAMES = 108;
const $8dde84746681ee59$var$CYCLE_S = $8dde84746681ee59$var$TOTAL_FRAMES / $8dde84746681ee59$var$FPS;
const $8dde84746681ee59$var$LOOP_CLOSE_FRAME = 107;
const $8dde84746681ee59$var$MORPH_SPLINE = '0.25 0 0.5 1';
const $8dde84746681ee59$var$CIRCLE = 'M50 0L56.5 0.4L62.9 1.7L69.1 3.8L75 6.7L80.4 10.3L85.4 14.6L89.7 19.6L93.3 25L96.2 30.9L98.3 37.1L99.6 43.5L100 50L99.6 56.5L98.3 62.9L96.2 69.1L93.3 75L89.7 80.4L85.4 85.4L80.4 89.7L75 93.3L69.1 96.2L62.9 98.3L56.5 99.6L50 100L43.5 99.6L37.1 98.3L30.9 96.2L25 93.3L19.6 89.7L14.6 85.4L10.3 80.4L6.7 75L3.8 69.1L1.7 62.9L0.4 56.5L0 50L0.4 43.5L1.7 37.1L3.8 30.9L6.7 25L10.3 19.6L14.6 14.6L19.6 10.3L25 6.7L30.9 3.8L37.1 1.7L43.5 0.4Z';
const $8dde84746681ee59$var$SQUARE = 'M0 0L8.3 0L16.7 0L25 0L33.3 0L41.7 0L50 0L58.3 0L66.7 0L75 0L83.3 0L91.7 0L100 0L100 8.3L100 16.7L100 25L100 33.3L100 41.7L100 50L100 58.3L100 66.7L100 75L100 83.3L100 91.7L100 100L91.7 100L83.3 100L75 100L66.7 100L58.3 100L50 100L41.7 100L33.3 100L25 100L16.7 100L8.3 100L0 100L0 91.7L0 83.3L0 75L0 66.7L0 58.3L0 50L0 41.7L0 33.3L0 25L0 16.7L0 8.3Z';
const $8dde84746681ee59$var$HEXAGON = 'M50 0L55.4 3.1L60.8 6.3L66.2 9.4L71.7 12.5L77.1 15.6L82.5 18.8L87.9 21.9L93.3 25L93.3 31.3L93.3 37.5L93.3 43.8L93.3 50L93.3 56.3L93.3 62.5L93.3 68.8L93.3 75L87.9 78.1L82.5 81.3L77.1 84.4L71.7 87.5L66.2 90.6L60.8 93.8L55.4 96.9L50 100L44.6 96.9L39.2 93.8L33.8 90.6L28.3 87.5L22.9 84.4L17.5 81.3L12.1 78.1L6.7 75L6.7 68.8L6.7 62.5L6.7 56.3L6.7 50L6.7 43.8L6.7 37.5L6.7 31.2L6.7 25L12.1 21.9L17.5 18.7L22.9 15.6L28.3 12.5L33.8 9.4L39.2 6.3L44.6 3.1Z';
const $8dde84746681ee59$var$TRIANGLE = 'M50 0L53.1 6.3L56.3 12.5L59.4 18.8L62.5 25L65.6 31.3L68.8 37.5L71.9 43.8L75 50L78.1 56.3L81.3 62.5L84.4 68.8L87.5 75L90.6 81.3L93.8 87.5L96.9 93.8L100 100L93.8 100L87.5 100L81.3 100L75 100L68.8 100L62.5 100L56.3 100L50 100L43.8 100L37.5 100L31.3 100L25 100L18.8 100L12.5 100L6.3 100L0 100L3.1 93.8L6.3 87.5L9.4 81.3L12.5 75L15.6 68.8L18.8 62.5L21.9 56.3L25 50L28.1 43.8L31.3 37.5L34.4 31.3L37.5 25L40.6 18.8L43.8 12.5L46.9 6.3Z';
const $8dde84746681ee59$var$AMBER = '#F5A623';
const $8dde84746681ee59$var$GREEN = '#82B536';
const $8dde84746681ee59$var$BLUE = '#1868DB';
const $8dde84746681ee59$var$PURPLE = '#BF63F3';
const $8dde84746681ee59$var$OUTLINE = [
    {
        frame: 0,
        value: $8dde84746681ee59$var$CIRCLE
    },
    {
        frame: 27,
        value: $8dde84746681ee59$var$SQUARE
    },
    {
        frame: 54,
        value: $8dde84746681ee59$var$HEXAGON
    },
    {
        frame: 80,
        value: $8dde84746681ee59$var$TRIANGLE
    },
    {
        frame: $8dde84746681ee59$var$LOOP_CLOSE_FRAME,
        value: $8dde84746681ee59$var$CIRCLE
    },
    {
        frame: $8dde84746681ee59$var$TOTAL_FRAMES,
        value: $8dde84746681ee59$var$CIRCLE
    }
];
const $8dde84746681ee59$var$ROTATION = [
    {
        frame: 0,
        value: '0 50 50'
    },
    {
        frame: 27,
        value: '180 50 50'
    },
    {
        frame: 54,
        value: '240 50 50'
    },
    {
        frame: 80,
        value: '360 50 50'
    },
    {
        frame: $8dde84746681ee59$var$LOOP_CLOSE_FRAME,
        value: '450 50 50'
    },
    {
        frame: $8dde84746681ee59$var$TOTAL_FRAMES,
        value: '450 50 50'
    }
];
const $8dde84746681ee59$var$FILL = [
    {
        frame: 0,
        value: $8dde84746681ee59$var$AMBER
    },
    {
        frame: 5,
        value: $8dde84746681ee59$var$AMBER
    },
    {
        frame: 11,
        value: $8dde84746681ee59$var$GREEN
    },
    {
        frame: 32,
        value: $8dde84746681ee59$var$GREEN
    },
    {
        frame: 37,
        value: $8dde84746681ee59$var$BLUE
    },
    {
        frame: 59,
        value: $8dde84746681ee59$var$BLUE
    },
    {
        frame: 64,
        value: $8dde84746681ee59$var$PURPLE
    },
    {
        frame: 86,
        value: $8dde84746681ee59$var$PURPLE
    },
    {
        frame: 91,
        value: $8dde84746681ee59$var$AMBER
    },
    {
        frame: $8dde84746681ee59$var$TOTAL_FRAMES,
        value: $8dde84746681ee59$var$AMBER
    }
];
const $8dde84746681ee59$var$values = (track)=>track.map((step)=>step.value).join(';');
const $8dde84746681ee59$var$keyTimes = (track)=>track.map((step)=>(step.frame / $8dde84746681ee59$var$TOTAL_FRAMES).toFixed(6)).join(';');
const $8dde84746681ee59$var$keySplines = (track)=>Array(track.length - 1).fill($8dde84746681ee59$var$MORPH_SPLINE).join(';');
const $8dde84746681ee59$var$SHAPE_SIZE = 16;
const $8dde84746681ee59$var$SLOT_SIZE = $8dde84746681ee59$var$SHAPE_SIZE + 8;
const $8dde84746681ee59$export$bbda8e93d8203d19 = ()=>{
    const prefersReducedMotion = (0, $bBczw.usePrefersReducedMotion)();
    const duration = `${$8dde84746681ee59$var$CYCLE_S}s`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb1tcg _4t3i1tcg"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
            width: $8dde84746681ee59$var$SHAPE_SIZE,
            height: $8dde84746681ee59$var$SHAPE_SIZE,
            viewBox: "0 0 100 100",
            "aria-hidden": "true",
            focusable: "false",
            className: (0, $2jatx.default)([
                "_1e0c1ule _1reo15vq _18m915vq"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: $8dde84746681ee59$var$CIRCLE,
                fill: $8dde84746681ee59$var$AMBER,
                children: !prefersReducedMotion && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                            attributeName: "d",
                            dur: duration,
                            repeatCount: "indefinite",
                            calcMode: "spline",
                            values: $8dde84746681ee59$var$values($8dde84746681ee59$var$OUTLINE),
                            keyTimes: $8dde84746681ee59$var$keyTimes($8dde84746681ee59$var$OUTLINE),
                            keySplines: $8dde84746681ee59$var$keySplines($8dde84746681ee59$var$OUTLINE)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            dur: duration,
                            repeatCount: "indefinite",
                            calcMode: "spline",
                            values: $8dde84746681ee59$var$values($8dde84746681ee59$var$ROTATION),
                            keyTimes: $8dde84746681ee59$var$keyTimes($8dde84746681ee59$var$ROTATION),
                            keySplines: $8dde84746681ee59$var$keySplines($8dde84746681ee59$var$ROTATION)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                            attributeName: "fill",
                            dur: duration,
                            repeatCount: "indefinite",
                            values: $8dde84746681ee59$var$values($8dde84746681ee59$var$FILL),
                            keyTimes: $8dde84746681ee59$var$keyTimes($8dde84746681ee59$var$FILL)
                        })
                    ]
                })
            })
        })
    });
};
const $8dde84746681ee59$var$slotStyles = null;
const $8dde84746681ee59$var$shapeStyles = null;

});


parcelRegister("9rVRh", function(module, exports) {
$parcel$export(module.exports, "ThemeChip", function () { return $082306bb1fde9245$export$1e2fc26afd8f3687; });
/* survey-theme-chip.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $082306bb1fde9245$export$1e2fc26afd8f3687 = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _4t3igktf _18zr1b66 _2rko12b0 _bfhki8nm _syazi7uo _11c8wadc _o5721q9c"
        ]),
        children: children
    });
const $082306bb1fde9245$var$themeChipStyles = null;

});


parcelRegister("8BSWR", function(module, exports) {
$parcel$export(module.exports, "SURVEY_RESPONSES_TAB_TEST_ID", function () { return $48546b2c74a543fe$export$3c98d85086b50a25; });
$parcel$export(module.exports, "SurveyPageHeader", function () { return $48546b2c74a543fe$export$1d0b4ac63345b11e; });
/* survey-page-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $15dQb = parcelRequire("15dQb");

var $kluHq = parcelRequire("kluHq");
var $8iGW0 = parcelRequire("8iGW0");

var $1q52J = parcelRequire("1q52J");
var $2r6UE = parcelRequire("2r6UE");

var $3OOxO = parcelRequire("3OOxO");

var $8DbjG = parcelRequire("8DbjG");

var $4ISy2 = parcelRequire("4ISy2");

var $izDBw = parcelRequire("izDBw");

var $eo5T7 = parcelRequire("eo5T7");
var $9T4IS = parcelRequire("9T4IS");

var $4s9kO = parcelRequire("4s9kO");

var $hZhs9 = parcelRequire("hZhs9");

var $8ktfY = parcelRequire("8ktfY");
const $48546b2c74a543fe$export$3c98d85086b50a25 = 'jsm-hr-survey-responses-tab';
const $48546b2c74a543fe$var$CopyLinkIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DbjG))), {
        label: "",
        size: "medium"
    });
const $48546b2c74a543fe$var$EditButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3OOxO))), {
        label: "",
        size: "medium"
    });
const $48546b2c74a543fe$var$MoreIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ISy2))), {
        label: "",
        size: "medium"
    });
const $48546b2c74a543fe$var$noop = ()=>{};
const $48546b2c74a543fe$var$breadcrumbs = [
    (0, $hZhs9.jsmPortalPlaygroundHrMessages).breadcrumbSpaces,
    (0, $hZhs9.jsmPortalPlaygroundHrMessages).breadcrumbSpace,
    (0, $hZhs9.jsmPortalPlaygroundHrMessages).breadcrumbSurveys,
    (0, $hZhs9.jsmPortalPlaygroundHrMessages).surveyTitle
];
const $48546b2c74a543fe$export$1d0b4ac63345b11e = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1o9zidpf _zulpu2gc _1q511ejb _18zrxy5q _femb1ff9 _c4vvidpf _pnka1dm9 _1qeh1fjl _1ll2dlk8 _79xxgktf _yt681wq8 _vi1p12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("style", {
                children: $48546b2c74a543fe$var$surveyTabPanelStyle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1b66"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true",
                        // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
                        inert: "",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8iGW0.default), {
                            children: $48546b2c74a543fe$var$breadcrumbs.map((crumb)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $kluHq.default), {
                                    text: intl.formatMessage(crumb)
                                }, crumb.id))
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc _85i5u2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulpu2gc _1ul9idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                                        level: 2,
                                        size: "large",
                                        children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).surveyTitle)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izDBw.default), {
                                        appearance: "success",
                                        children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).statusActive)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                "aria-hidden": "true",
                                // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
                                inert: "",
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _1o9zidpf _zulpu2gc"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                        iconBefore: $48546b2c74a543fe$var$CopyLinkIcon,
                                        onClick: $48546b2c74a543fe$var$noop,
                                        tabIndex: -1,
                                        children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).copyLink)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                        iconBefore: $48546b2c74a543fe$var$EditButtonIcon,
                                        onClick: $48546b2c74a543fe$var$noop,
                                        tabIndex: -1,
                                        children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).edit)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                        icon: $48546b2c74a543fe$var$MoreIcon,
                                        label: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).moreActions),
                                        onClick: $48546b2c74a543fe$var$noop,
                                        tabIndex: -1
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9T4IS.default), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eo5T7.default), {
                        children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).tabSummary)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eo5T7.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            "data-testid": $48546b2c74a543fe$export$3c98d85086b50a25,
                            className: (0, $2jatx.default)([
                                "_1e0c116y _4cvr1h6o _zulp1b66"
                            ]),
                            children: [
                                intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).tabResponses),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $15dQb.default), {
                                    children: (0, $4s9kO.surveyTotals).responses
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
// v13 tab panels pad 8px inline, and that rule is as specific as a nested override, so it wins.
// These panel ids belong only to this survey, and an id beats the tabs stylesheet.
const $48546b2c74a543fe$var$surveyTabPanelStyle = `
#jsm-playground-hr-survey-0-tab,
#jsm-playground-hr-survey-1-tab {
	padding-inline: 0;
}
#jsm-playground-hr-survey-0,
#jsm-playground-hr-survey-1 {
	padding-block: var(--ds-space-075, 6px);
}
`;
const $48546b2c74a543fe$var$headerStyles = null;
const $48546b2c74a543fe$var$titleBlockStyles = null;
const $48546b2c74a543fe$var$titleRowStyles = null;
const $48546b2c74a543fe$var$titleStyles = null;
const $48546b2c74a543fe$var$actionsStyles = null;
const $48546b2c74a543fe$var$tabLabelStyles = null;

});
parcelRegister("kluHq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ecfd95173e86bf38$export$2e2bcd8739ae039; });
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $6ur0l = parcelRequire("6ur0l");

var $k03fP = parcelRequire("k03fP");

var $973ut = parcelRequire("973ut");

var $1Coey = parcelRequire("1Coey");

var $f2eY1 = parcelRequire("f2eY1");

var $1KNTw = parcelRequire("1KNTw");
var $ecfd95173e86bf38$var$_excluded = [
    "analyticsContext",
    "component",
    "createAnalyticsEvent",
    "href",
    "elemBefore",
    "iconAfter",
    "iconBefore",
    "onClick",
    "onTooltipShown",
    "ref",
    "target",
    "testId",
    "text",
    "title",
    "truncationWidth",
    "aria-label",
    "aria-labelledby",
    "aria-current",
    "_overflowRef"
];
function $ecfd95173e86bf38$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ecfd95173e86bf38$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ecfd95173e86bf38$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ecfd95173e86bf38$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ecfd95173e86bf38$var$itemWrapperStyles = null;
var $ecfd95173e86bf38$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
var $ecfd95173e86bf38$var$ICON_WIDTH_ESTIMATE = 24;
var $ecfd95173e86bf38$var$staticItemStyles = null;
var $ecfd95173e86bf38$var$staticItemWithTruncationStyles = null;
var $ecfd95173e86bf38$var$staticItemWithoutTruncationStyles = null;
var $ecfd95173e86bf38$var$motionItemStyles = null;
var $ecfd95173e86bf38$var$BreadcrumbsItem = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref2) {
    var analyticsContext = _ref2.analyticsContext, component = _ref2.component, _createAnalyticsEvent = _ref2.createAnalyticsEvent, href = _ref2.href, elemBefore = _ref2.elemBefore, iconAfter = _ref2.iconAfter, iconBefore = _ref2.iconBefore, onClick = _ref2.onClick, onTooltipShown = _ref2.onTooltipShown, _ref = _ref2.ref, target = _ref2.target, testId = _ref2.testId, text = _ref2.text, title = _ref2.title, truncationWidth = _ref2.truncationWidth, ariaLabel = _ref2['aria-label'], ariaLabelledBy = _ref2['aria-labelledby'], ariaCurrent = _ref2['aria-current'], _overflowRef = _ref2._overflowRef, rest = (0, $gnQ3X.default)(_ref2, $ecfd95173e86bf38$var$_excluded);
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), stepElement = _useState2[0], setStepElement = _useState2[1];
    var setStepRef = (0, $1oC0p.useCallback)(function(element) {
        setStepElement(element);
    }, []);
    var resolvedElemBefore = elemBefore !== null && elemBefore !== void 0 ? elemBefore : iconBefore;
    var iconWidthAllowance = 0;
    if (resolvedElemBefore) iconWidthAllowance += $ecfd95173e86bf38$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $ecfd95173e86bf38$var$ICON_WIDTH_ESTIMATE;
    var _useOverflowable = (0, $1KNTw.default)(truncationWidth, stepElement, (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') ? 0 : iconWidthAllowance), _useOverflowable2 = (0, $2qaZZ.default)(_useOverflowable, 2), hasOverflow = _useOverflowable2[0], shouldShowTooltip = _useOverflowable2[1];
    if (!component && (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ $1oC0p.createElement((0, $973ut.default), {
        ref: _overflowRef,
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        elemBefore: resolvedElemBefore,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        onTooltipShown: onTooltipShown,
        shouldShowTooltip: shouldShowTooltip,
        stepRef: setStepRef,
        target: target,
        testId: testId,
        text: text,
        title: title,
        truncationWidth: truncationWidth,
        "aria-current": ariaCurrent
    });
    var buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    var dynamicItemStyles = (0, $f53LC.default)({}, $ecfd95173e86bf38$var$VAR_STEP_TRUNCATION_WIDTH, typeof truncationWidth !== 'undefined' && "".concat(truncationWidth, "px"));
    var step = !component ? /*#__PURE__*/ $1oC0p.createElement((0, $1Coey.default), (0, $c9bqK.default)({
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        elemBefore: resolvedElemBefore,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        truncationWidth: truncationWidth
    }, rest), text) : /*#__PURE__*/ $1oC0p.createElement((0, $f2eY1.default), (0, $c9bqK.default)({
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: resolvedElemBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title
    }, rest, {
        className: (0, $2jatx.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f1pis" : "_1ul9grf3 _1o9zzg3v",
            (0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') && "_v564hxmd _4bfu1j28 _1hms8stv _o7kshxmd _9oik1rpy _1ggl87vo _1nrmi7uo"
        ]),
        style: $ecfd95173e86bf38$var$_objectSpread($ecfd95173e86bf38$var$_objectSpread({}, truncationWidth ? $ecfd95173e86bf38$var$_objectSpread($ecfd95173e86bf38$var$_objectSpread({}, dynamicItemStyles), buttonOverrideStyles) : buttonOverrideStyles), {}, {
            "--_1fteikb": (0, $6ZVlx.default)("var(".concat($ecfd95173e86bf38$var$VAR_STEP_TRUNCATION_WIDTH, ") !important"))
        })
    }), text);
    return /*#__PURE__*/ $1oC0p.createElement("li", {
        ref: _overflowRef,
        className: (0, $2jatx.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3i59ms _4cvr1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ]),
        style: {
            "--_1fdrbou": (0, $6ZVlx.default)("".concat(24 / 14, "em"))
        }
    }, shouldShowTooltip ? /*#__PURE__*/ $1oC0p.createElement((0, $k03fP.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ecfd95173e86bf38$export$2e2bcd8739ae039 = $ecfd95173e86bf38$var$BreadcrumbsItem;

});
parcelRegister("k03fP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8f654f72640bae2$export$2e2bcd8739ae039; });
/* tooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");


var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $VEZbz = parcelRequire("VEZbz");

var $7uNuF = parcelRequire("7uNuF");

var $4P6qn = parcelRequire("4P6qn");

var $5l9My = parcelRequire("5l9My");

var $9K0mz = parcelRequire("9K0mz");

var $iJdNy = parcelRequire("iJdNy");

var $f4v82 = parcelRequire("f4v82");

var $6ur0l = parcelRequire("6ur0l");

var $34ocj = parcelRequire("34ocj");

var $78FwG = parcelRequire("78FwG");

var $i9dl0 = parcelRequire("i9dl0");

var $jp38o = parcelRequire("jp38o");

var $2chlf = parcelRequire("2chlf");

var $iQsXC = parcelRequire("iQsXC");

var $ik7PK = parcelRequire("ik7PK");

var $8TmK4 = parcelRequire("8TmK4");

var $hs4DK = parcelRequire("hs4DK");

var $7sfnr = parcelRequire("7sfnr");

var $kr1CD = parcelRequire("kr1CD");

var $i96qf = parcelRequire("i96qf");

var $caP7w = parcelRequire("caP7w");
function $e8f654f72640bae2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e8f654f72640bae2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e8f654f72640bae2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e8f654f72640bae2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e8f654f72640bae2$var$tooltipZIndex = (0, $i9dl0.layers).tooltip();
var $e8f654f72640bae2$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "24.2.1"
};
// Inverts motion direction
var $e8f654f72640bae2$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $e8f654f72640bae2$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
 * gate is off, so this cannot affect the legacy path even if it gains a caller
 * there.
 *
 * `mouseover` also fires when the pointer crosses boundaries between elements
 * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
 * distinguishes a real re-entry from one of those.
 */ function $e8f654f72640bae2$var$isTopLayerPointerReEntry(_ref) {
    var trigger = _ref.trigger, relatedTarget = _ref.relatedTarget;
    if (!(0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) return false;
    // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $e8f654f72640bae2$var$Tooltip(_ref2) {
    var children = _ref2.children, _ref2$position = _ref2.position, position = _ref2$position === void 0 ? 'bottom' : _ref2$position, _ref2$mousePosition = _ref2.mousePosition, mousePosition = _ref2$mousePosition === void 0 ? 'bottom' : _ref2$mousePosition, content = _ref2.content, _ref2$truncate = _ref2.truncate, truncate = _ref2$truncate === void 0 ? false : _ref2$truncate, _ref2$component = _ref2.component, Container = _ref2$component === void 0 ? (0, $caP7w.default) : _ref2$component, _ref2$tag = _ref2.tag, TargetContainer = _ref2$tag === void 0 ? 'div' : _ref2$tag, testId = _ref2.testId, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 300 : _ref2$delay, _ref2$onShow = _ref2.onShow, onShow = _ref2$onShow === void 0 ? (0, $7uNuF.default) : _ref2$onShow, _ref2$onHide = _ref2.onHide, onHide = _ref2$onHide === void 0 ? (0, $7uNuF.default) : _ref2$onHide, canAppear = _ref2.canAppear, _ref2$hideTooltipOnCl = _ref2.hideTooltipOnClick, hideTooltipOnClick = _ref2$hideTooltipOnCl === void 0 ? false : _ref2$hideTooltipOnCl, _ref2$hideTooltipOnMo = _ref2.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref2$hideTooltipOnMo === void 0 ? false : _ref2$hideTooltipOnMo, analyticsContext = _ref2.analyticsContext, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$ignoreTooltipPo = _ref2.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref2$ignoreTooltipPo === void 0 ? false : _ref2$ignoreTooltipPo, _ref2$isScreenReaderA = _ref2.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref2$isScreenReaderA === void 0 ? false : _ref2$isScreenReaderA, shortcut = _ref2.shortcut, _ref2$shouldAlwaysFad = _ref2.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref2$shouldAlwaysFad === void 0 ? false : _ref2$shouldAlwaysFad, _ref2$shouldRenderToP = _ref2.shouldRenderToParent, shouldRenderToParent = _ref2$shouldRenderToP === void 0 ? false : _ref2$shouldRenderToP;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $VEZbz.usePlatformLeafSyntheticEventHandler)($e8f654f72640bae2$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $e8f654f72640bae2$var$analyticsAttributes));
    var onHideHandler = (0, $VEZbz.usePlatformLeafSyntheticEventHandler)($e8f654f72640bae2$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $e8f654f72640bae2$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $5l9My.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $5l9My.default)(onShowHandler);
    var onHideHandlerStable = (0, $5l9My.default)(onHideHandler);
    var delayStable = (0, $5l9My.default)(delay);
    var canAppearStable = (0, $5l9My.default)(canAppear);
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $5l9My.default)(shouldAlwaysFadeIn);
    var start = (0, $1oC0p.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $8TmK4.register)({
            onRegister: function onRegister(_ref3) {
                var isDragging = _ref3.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    var isTopLayerPointerDismissedRef = (0, $1oC0p.useRef)(false);
    var tryShowTooltip = (0, $1oC0p.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Stay dismissed until the trigger is re-entered or blurred. Otherwise
     * light dismiss hides on pointerup and the next `mouseover` from a
     * boundary crossing inside the trigger re-shows it. Deliberately after
     * the "already active" branch, so a held press stays visible.
     */ if (isTopLayerPointerDismissedRef.current && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) return;
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref4) {
                var isImmediate = _ref4.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref5) {
                var isImmediate = _ref5.isImmediate;
                if (isImmediate) setState('hide');
                else if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $kr1CD.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $4P6qn.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    var handleExitFinish = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    var handlePopoverClose = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current4;
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $7uNuF.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        var shouldCancelPendingShow = stableState.current === 'hide' && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        stableState
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($e8f654f72640bae2$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current5;
        if ((_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current6;
        (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 || _apiRef$current6.requestHide({
            isImmediate: true
        });
    }, []);
    // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $9K0mz.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $6ur0l.fg)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current7;
        if (isMousePosition && (_apiRef$current7 = apiRef.current) !== null && _apiRef$current7 !== void 0 && _apiRef$current7.mousePos && targetRef.current) return (0, $7sfnr.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $i96qf.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $1oC0p.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = shouldRenderToParent ? (0, $1oC0p.Fragment) : $e8f654f72640bae2$var$TooltipPortal;
    var trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children($e8f654f72640bae2$var$_objectSpread($e8f654f72640bae2$var$_objectSpread($e8f654f72640bae2$var$_objectSpread({}, tooltipTriggerProps), testId ? {
        testId: "".concat(testId, "--container")
    } : {}), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $c9bqK.default)({}, tooltipTriggerProps, testId ? {
        'data-testid': "".concat(testId, "--container")
    } : undefined, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent);
    if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) {
        var _apiRef$current$mouse, _apiRef$current8;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($e8f654f72640bae2$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: (_apiRef$current$mouse = (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.mousePos) !== null && _apiRef$current$mouse !== void 0 ? _apiRef$current$mouse : undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: handlePopoverClose,
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $34ocj.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref6) {
        var ref = _ref6.ref, style = _ref6.style, update = _ref6.update, placement = _ref6.placement;
        var direction = isMousePosition ? undefined : $e8f654f72640bae2$var$invertedDirection[$e8f654f72640bae2$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iJdNy.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f4v82.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref7) {
            var className = _ref7.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $e8f654f72640bae2$var$_objectSpread($e8f654f72640bae2$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $e8f654f72640bae2$export$2e2bcd8739ae039 = $e8f654f72640bae2$var$Tooltip;
var $e8f654f72640bae2$var$TooltipPortal = function TooltipPortal(_ref8) {
    var children = _ref8.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $78FwG.default), {
        zIndex: $e8f654f72640bae2$var$tooltipZIndex
    }, children);
};
var $e8f654f72640bae2$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $e8f654f72640bae2$var$TopLayerTooltipPopup(_ref9) {
    var targetRef = _ref9.targetRef, tooltipPosition = _ref9.tooltipPosition, mousePos = _ref9.mousePos, position = _ref9.position, onMouseOut = _ref9.onMouseOut, onMouseOverTooltip = _ref9.onMouseOverTooltip, ignoreTooltipPointerEvents = _ref9.ignoreTooltipPointerEvents, truncate = _ref9.truncate, testId = _ref9.testId, shortcut = _ref9.shortcut, content = _ref9.content, Container = _ref9.Container, onClose = _ref9.onClose, onExitFinish = _ref9.onExitFinish, isOpen = _ref9.isOpen;
    var popoverRef = (0, $1oC0p.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    var placement = (0, $jp38o.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    var isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    var isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $ik7PK.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: function getPoint() {
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $hs4DK.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2chlf.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? "".concat(testId, "--popover") : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $e8f654f72640bae2$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $e8f654f72640bae2$var$tooltipMouseAnimationStyles.exit,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
        className: "Tooltip",
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $7uNuF.default)
    }) : content));
}

});
parcelRegister("VEZbz", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $0ad51decb1e66949$export$1a04351537078b55; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3b6IF = parcelRequire("3b6IF");

var $6wNqA = parcelRequire("6wNqA");
function $0ad51decb1e66949$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ad51decb1e66949$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ad51decb1e66949$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ad51decb1e66949$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0ad51decb1e66949$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3b6IF.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $6wNqA.useTrackedRef)(analyticsData);
    var fnRef = (0, $6wNqA.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $0ad51decb1e66949$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("3b6IF", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $25079c81f993451f$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $hj20n = parcelRequire("hj20n");

var $7MxWR = parcelRequire("7MxWR");
function $25079c81f993451f$export$5bf35293e545f20c() {
    var analyticsContext = (0, $7MxWR.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $hj20n.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("hj20n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c995c42cf7b36761$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");

var $e1aQ8 = parcelRequire("e1aQ8");
function $c995c42cf7b36761$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c995c42cf7b36761$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c995c42cf7b36761$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c995c42cf7b36761$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c995c42cf7b36761$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $c995c42cf7b36761$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $c995c42cf7b36761$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c995c42cf7b36761$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c995c42cf7b36761$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $c995c42cf7b36761$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $c995c42cf7b36761$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            var payload = $c995c42cf7b36761$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $c995c42cf7b36761$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $e1aQ8.default));
var $c995c42cf7b36761$var$clonePayload = function clonePayload(payload) {
    if ((0, $6ur0l.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $c995c42cf7b36761$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};

});
parcelRegister("e1aQ8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a34991401dfea476$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $a34991401dfea476$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a34991401dfea476$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a34991401dfea476$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a34991401dfea476$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a34991401dfea476$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $a34991401dfea476$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $a34991401dfea476$var$_objectSpread($a34991401dfea476$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("7MxWR", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $5aa7598968709617$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $5aa7598968709617$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("6wNqA", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $4c0c1296ba938519$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $4c0c1296ba938519$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("9K0mz", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $7178b108bda72db3$export$469bb693f11edc7f; });

var $1oC0p = parcelRequire("1oC0p");

var $4GLLH = parcelRequire("4GLLH");

var $5VTbq = parcelRequire("5VTbq");
function $7178b108bda72db3$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $1oC0p.useContext)((0, $4GLLH.OpenLayerObserverContext));
    var namespace = (0, $5VTbq.useOpenLayerObserverNamespace)();
    (0, $1oC0p.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("4GLLH", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $36a0237af5ea8c39$export$5fbf4d7fae6cdc00; });

var $1oC0p = parcelRequire("1oC0p");
var $36a0237af5ea8c39$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("5VTbq", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $451d14e41b1e0704$export$1d57e79091cc3046; });

var $1oC0p = parcelRequire("1oC0p");

var $cykKF = parcelRequire("cykKF");
function $451d14e41b1e0704$export$1d57e79091cc3046() {
    var namespace = (0, $1oC0p.useContext)((0, $cykKF.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("cykKF", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $9238c1dbca7d0277$export$644a49f3b8c50fcd; });

var $1oC0p = parcelRequire("1oC0p");
var $9238c1dbca7d0277$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});



parcelRegister("iJdNy", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", function () { return $da2721fe0c649a74$export$b9c4904d7a6929e6; });
$parcel$export(module.exports, "default", function () { return $da2721fe0c649a74$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $da2721fe0c649a74$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $da2721fe0c649a74$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $1oC0p.createContext)($da2721fe0c649a74$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $da2721fe0c649a74$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $da2721fe0c649a74$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($da2721fe0c649a74$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $da2721fe0c649a74$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1oC0p.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $da2721fe0c649a74$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $da2721fe0c649a74$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $da2721fe0c649a74$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $da2721fe0c649a74$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $da2721fe0c649a74$var$ExitingPersistence = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $1oC0p.useState)([
        null,
        children
    ]), _useState2 = (0, $2qaZZ.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)([]), _useState4 = (0, $2qaZZ.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $1oC0p.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $2qaZZ.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $da2721fe0c649a74$var$childrenToArray(previousChildren);
    var current = $da2721fe0c649a74$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $da2721fe0c649a74$var$childrenToArray(children) : current;
    var missingKeys = $da2721fe0c649a74$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $da2721fe0c649a74$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $6ur0l.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $da2721fe0c649a74$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $da2721fe0c649a74$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$da2721fe0c649a74$export$2e2bcd8739ae039 = $da2721fe0c649a74$var$ExitingPersistence;
$da2721fe0c649a74$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("f4v82", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af8f60431efe8715$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $aySFY = parcelRequire("aySFY");
var $af8f60431efe8715$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $af8f60431efe8715$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $af8f60431efe8715$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $aySFY.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $af8f60431efe8715$export$2e2bcd8739ae039 = $af8f60431efe8715$var$FadeIn;

});
parcelRegister("aySFY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b077dd9bef5c3b0$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $abaqY = parcelRequire("abaqY");

var $fCypL = parcelRequire("fCypL");

var $6JOmM = parcelRequire("6JOmM");

var $8q1Nr = parcelRequire("8q1Nr");

var $lM1gQ = parcelRequire("lM1gQ");

var $d06QA = parcelRequire("d06QA");
var $7b077dd9bef5c3b0$var$zoomIn = null;
var $7b077dd9bef5c3b0$var$zoomOut = null;
var $7b077dd9bef5c3b0$var$fadeIn = null;
var $7b077dd9bef5c3b0$var$fadeOut = null;
var $7b077dd9bef5c3b0$var$fadeInFromTop = null;
var $7b077dd9bef5c3b0$var$fadeOutFromTop = null;
var $7b077dd9bef5c3b0$var$fadeInFromLeft = null;
var $7b077dd9bef5c3b0$var$fadeOutFromLeft = null;
var $7b077dd9bef5c3b0$var$fadeInFromBottom = null;
var $7b077dd9bef5c3b0$var$fadeOutFromBottom = null;
var $7b077dd9bef5c3b0$var$fadeInFromRight = null;
var $7b077dd9bef5c3b0$var$fadeOutFromRight = null;
var $7b077dd9bef5c3b0$var$fadeInFromTopConstant = null;
var $7b077dd9bef5c3b0$var$fadeOutFromTopConstant = null;
var $7b077dd9bef5c3b0$var$fadeInFromLeftConstant = null;
var $7b077dd9bef5c3b0$var$fadeOutFromLeftConstant = null;
var $7b077dd9bef5c3b0$var$fadeInFromBottomConstant = null;
var $7b077dd9bef5c3b0$var$fadeOutFromBottomConstant = null;
var $7b077dd9bef5c3b0$var$fadeInFromRightConstant = null;
var $7b077dd9bef5c3b0$var$fadeOutFromRightConstant = null;
var $7b077dd9bef5c3b0$var$slideInFromTop = null;
var $7b077dd9bef5c3b0$var$slideOutFromTop = null;
var $7b077dd9bef5c3b0$var$slideInFromRight = null;
var $7b077dd9bef5c3b0$var$slideOutFromRight = null;
var $7b077dd9bef5c3b0$var$slideInFromBottom = null;
var $7b077dd9bef5c3b0$var$slideOutFromBottom = null;
var $7b077dd9bef5c3b0$var$slideInFromLeft = null;
var $7b077dd9bef5c3b0$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $7b077dd9bef5c3b0$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $d06QA.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $lM1gQ.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $8q1Nr.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $1oC0p.useState)(appear), _useState2 = (0, $2qaZZ.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $6JOmM.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $fCypL.exitingDurations)[duration] : (0, $abaqY.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $2jatx.default)([
            (0, $2jatx.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $2jatx.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $2jatx.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $2jatx.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $2jatx.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $2jatx.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $2jatx.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $2jatx.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $2jatx.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $2jatx.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $2jatx.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $2jatx.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $2jatx.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $2jatx.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $2jatx.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $2jatx.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $2jatx.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $2jatx.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $2jatx.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $2jatx.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $2jatx.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $2jatx.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $2jatx.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $2jatx.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $2jatx.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $2jatx.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $2jatx.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $2jatx.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $2jatx.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $2jatx.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $2jatx.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $2jatx.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $2jatx.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $2jatx.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $2jatx.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $2jatx.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $2jatx.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $2jatx.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $2jatx.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $2jatx.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $2jatx.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $2jatx.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $2jatx.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $2jatx.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $2jatx.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $2jatx.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $2jatx.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $2jatx.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $2jatx.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $2jatx.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $2jatx.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $7b077dd9bef5c3b0$export$2e2bcd8739ae039 = $7b077dd9bef5c3b0$var$EnteringMotion;

});
parcelRegister("abaqY", function(module, exports) {
$parcel$export(module.exports, "durations", function () { return $76930675c9eab534$export$38b928a7167ce124; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $76930675c9eab534$export$368bacef0dacbe05 = 25;
var $76930675c9eab534$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("fCypL", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", function () { return $b5f519a0c99fa777$export$30fa1a2e62ae150c; });

var $abaqY = parcelRequire("abaqY");
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $b5f519a0c99fa777$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $b5f519a0c99fa777$export$30fa1a2e62ae150c = {
    none: (0, $abaqY.durations).none,
    small: (0, $abaqY.durations).small * $b5f519a0c99fa777$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $abaqY.durations).medium * $b5f519a0c99fa777$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $abaqY.durations).large * $b5f519a0c99fa777$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("6JOmM", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $4e7e03c8d78dc257$export$b7baf7667a68d87c; });

var $5X0No = parcelRequire("5X0No");
var $4e7e03c8d78dc257$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $5X0No.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("5X0No", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", function () { return $455314721091da03$export$c5406bd59b374abd; });
var $455314721091da03$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("8q1Nr", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", function () { return $6212252752820fc0$export$4f34107a2b00f39c; });

var $1oC0p = parcelRequire("1oC0p");
// Handle both browser and Node.js environments
var $6212252752820fc0$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $6212252752820fc0$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $6212252752820fc0$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("lM1gQ", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", function () { return $fd9f10fd2d434832$export$3b6f38abbdcbd000; });

var $1oC0p = parcelRequire("1oC0p");

var $iJdNy = parcelRequire("iJdNy");
var $fd9f10fd2d434832$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1oC0p.useContext)((0, $iJdNy.ExitingContext));
};

});

parcelRegister("d06QA", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", function () { return $9770962b5f239ff1$export$25c7213fc07ec080; });

var $1oC0p = parcelRequire("1oC0p");

var $lK68s = parcelRequire("lK68s");

var $34OL8 = parcelRequire("34OL8");
var $9770962b5f239ff1$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $lK68s.useUniqueId)();
    var context = (0, $1oC0p.useContext)((0, $34OL8.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("lK68s", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", function () { return $fd42a732f4948236$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1oC0p = parcelRequire("1oC0p");
function $fd42a732f4948236$export$c485849f2e393253() {
    var identifier = (0, $1oC0p.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("34OL8", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", function () { return $23d91e86c19e2b1c$export$5e65d7d58ae96ad8; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $f9irv = parcelRequire("f9irv");
var $23d91e86c19e2b1c$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $7uNuF.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $23d91e86c19e2b1c$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1oC0p.useRef)([]);
    var indexes = [];
    var _useState = (0, $1oC0p.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $2qaZZ.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $f9irv.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($23d91e86c19e2b1c$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$23d91e86c19e2b1c$export$2e2bcd8739ae039 = $23d91e86c19e2b1c$var$StaggeredEntrance;

});
parcelRegister("f9irv", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $b07600997c6a3969$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $b07600997c6a3969$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});





parcelRegister("34ocj", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $23c483f5dabed1b7$export$badac9ada3a0bdf9; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $eVddu = parcelRequire("eVddu");

var $6ur0l = parcelRequire("6ur0l");

var $chlXf = parcelRequire("chlXf");

var $4FHe4 = parcelRequire("4FHe4");

// Export types from PopperJS / React Popper
var $23c483f5dabed1b7$var$viewportPadding = 5;
var $23c483f5dabed1b7$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $23c483f5dabed1b7$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $23c483f5dabed1b7$var$defaultChildrenFn() {
    return null;
}
var $23c483f5dabed1b7$var$defaultOffset = [
    0,
    8
];
function $23c483f5dabed1b7$export$badac9ada3a0bdf9(_ref) {
    var children = _ref.children, offset = _ref.offset, placement = _ref.placement, referenceElement = _ref.referenceElement, modifiers = _ref.modifiers, strategy = _ref.strategy, shouldFitViewport = _ref.shouldFitViewport;
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $6ur0l.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4FHe4.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($23c483f5dabed1b7$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $23c483f5dabed1b7$var$LegacyPopper(_ref2) {
    var _ref2$children = _ref2.children, children = _ref2$children === void 0 ? $23c483f5dabed1b7$var$defaultChildrenFn : _ref2$children, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? $23c483f5dabed1b7$var$defaultOffset : _ref2$offset, _ref2$placement = _ref2.placement, placement = _ref2$placement === void 0 ? 'bottom-start' : _ref2$placement, _ref2$referenceElemen = _ref2.referenceElement, referenceElement = _ref2$referenceElemen === void 0 ? undefined : _ref2$referenceElemen, modifiers = _ref2.modifiers, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$shouldFitViewpo = _ref2.shouldFitViewport, shouldFitViewport = _ref2$shouldFitViewpo === void 0 ? false : _ref2$shouldFitViewpo;
    var _offset = (0, $2qaZZ.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $23c483f5dabed1b7$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $chlXf.getMaxSizeModifiers)({
            viewportPadding: $23c483f5dabed1b7$var$viewportPadding
        }) : [];
        return [].concat($23c483f5dabed1b7$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $lFOXD.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $lFOXD.default)(internalModifiers), (0, $lFOXD.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eVddu.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("chlXf", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $8f081a4604520dd3$export$6d8c2b45c99d6e3f; });

var $2qaZZ = parcelRequire("2qaZZ");
function $8f081a4604520dd3$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $2qaZZ.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});

parcelRegister("4FHe4", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", function () { return $366c85836288e16d$export$9802f50720ab826e; });
/* popper-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2qaZZ = parcelRequire("2qaZZ");


var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $jp38o = parcelRequire("jp38o");

var $2chlf = parcelRequire("2chlf");

var $iQsXC = parcelRequire("iQsXC");

var $ik7PK = parcelRequire("ik7PK");

var $8mOPg = parcelRequire("8mOPg");

var $2oBVx = parcelRequire("2oBVx");

var $cuzhd = parcelRequire("cuzhd");

var $lAel2 = parcelRequire("lAel2");

var $2QYjE = parcelRequire("2QYjE");

var $ilzzH = parcelRequire("ilzzH");

var $4Ue2v = parcelRequire("4Ue2v");

var $ivP3T = parcelRequire("ivP3T");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ var $366c85836288e16d$var$noopStyle = {};
var $366c85836288e16d$var$noopSetRef = (0, $7uNuF.default);
var $366c85836288e16d$var$noopUpdate = function noopUpdate() {
    return Promise.resolve(null);
};
var $366c85836288e16d$var$noopForceUpdate = function noopForceUpdate() {
    return {};
};
/**
 * `react-popper` stamps `data-popper-arrow` on the arrow element at runtime
 * but does not declare it on `arrowProps`. Widen the type so consumers that
 * rely on the attribute (CSS selectors, snapshots, tests) keep working.
 */ var $366c85836288e16d$var$noopArrowProps = {
    ref: $366c85836288e16d$var$noopSetRef,
    style: $366c85836288e16d$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function $366c85836288e16d$var$getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $366c85836288e16d$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    var _offset = (0, $2qaZZ.default)(offset, 2), along = _offset[0], away = _offset[1];
    if (along == null && away == null) return undefined;
    return [
        along !== null && along !== void 0 ? along : 0,
        away !== null && away !== void 0 ? away : 0
    ];
}
function $366c85836288e16d$export$9802f50720ab826e(_ref) {
    var _ref2;
    var children = _ref.children, offset = _ref.offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, referenceElement = _ref.referenceElement, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    var managerAnchor = (0, $4Ue2v.useManagerAnchor)();
    var effectiveReference = (_ref2 = referenceElement !== null && referenceElement !== void 0 ? referenceElement : managerAnchor) !== null && _ref2 !== void 0 ? _ref2 : undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    var htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    var virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    var htmlAnchorRef = (0, $1oC0p.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    var popoverRef = (0, $1oC0p.useRef)(null);
    var popoverId = (0, $8mOPg.usePopoverId)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    var _useState = (0, $1oC0p.useState)(htmlAnchor), _useState2 = (0, $2qaZZ.default)(_useState, 2), resolvedAnchor = _useState2[0], setResolvedAnchor = _useState2[1];
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    var topLayerPlacement = (0, $1oC0p.useMemo)(function() {
        return (0, $jp38o.fromLegacyPlacement)({
            legacy: (0, $2QYjE.toLegacyPlacement)(placement),
            offset: $366c85836288e16d$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    var isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: htmlAnchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen: isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    var virtualReferenceRef = (0, $1oC0p.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    var topLayerPlacementRef = (0, $1oC0p.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    var isVirtualEnabled = virtualReference != null;
    (0, $ik7PK.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen: isOpen,
        getPoint: function getPoint() {
            var current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $lAel2.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $cuzhd.isPageRtl)()
            });
        }
    });
    var _useReferenceVisibili = (0, $ivP3T.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    }), isReferenceHidden = _useReferenceVisibili.isReferenceHidden, hasPopperEscaped = _useReferenceVisibili.hasPopperEscaped;
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, $2oBVx.useWidthFromAnchor)({
        mode: 'none',
        popoverRef: popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen: isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    var resolvedOffset = $366c85836288e16d$var$popperToTopLayerOffset(offset);
    var fitGap = resolvedOffset ? "".concat(resolvedOffset[1], "px") : "var(--ds-space-100, 8px)";
    var placementAxis = $366c85836288e16d$var$getPlacementAxis(placement);
    (0, $ilzzH.useFitViewportMaxSize)({
        target: popoverRef,
        placementAxis: placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen: isOpen
    });
    var renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    var renderPropArg = {
        ref: $366c85836288e16d$var$noopSetRef,
        style: $366c85836288e16d$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $366c85836288e16d$var$noopUpdate,
        forceUpdate: $366c85836288e16d$var$noopForceUpdate,
        arrowProps: $366c85836288e16d$var$noopArrowProps
    };
    var content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2chlf.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false
    }, content);
}

});
parcelRegister("cuzhd", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", function () { return $9183a6987e69b633$export$175375e9a2b5515d; });

var $ceF4b = parcelRequire("ceF4b");
function $9183a6987e69b633$export$175375e9a2b5515d() {
    var document = (0, $ceF4b.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});
parcelRegister("ceF4b", function(module, exports) {
$parcel$export(module.exports, "getDocument", function () { return $8e86a5ca984f7918$export$f65ca476c09acec0; });
var $8e86a5ca984f7918$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("lAel2", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", function () { return $fb68150c961265ba$export$b065aeb850c3e87f; });
/**
 * Reduces an anchor rect to the single viewport point that, wrapped in a
 * zero-size synthetic anchor, produces the same popover position
 * `useAnchorPosition` would for the given placement. This works because
 * `useAnchorPosition` only reads the edge / alignment corner of the rect,
 * so a coincident zero-size point is geometrically equivalent.
 *
 * RTL is resolved here so the downstream synthetic anchor only sees physical
 * coordinates. Defaults mirror `getPlacement` in
 * `@atlaskit/top-layer/placement-map` (`axis: 'block'`, `edge: 'end'`,
 * `align: 'center'`).
 */ function $fb68150c961265ba$export$b065aeb850c3e87f(_ref) {
    var _placement$axis, _placement$edge, _placement$align;
    var rect = _ref.rect, placement = _ref.placement, isRtl = _ref.isRtl;
    var axis = (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block';
    var edge = (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end';
    var align = (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        var _y = edge === 'start' ? rect.top : rect.bottom;
        var _x = $fb68150c961265ba$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: _x,
            y: _y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    var x = $fb68150c961265ba$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    var y = $fb68150c961265ba$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $fb68150c961265ba$var$horizontalForAlign(_ref2) {
    var rect = _ref2.rect, align = _ref2.align, isRtl = _ref2.isRtl;
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    var isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $fb68150c961265ba$var$verticalForAlign(_ref3) {
    var rect = _ref3.rect, align = _ref3.align;
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $fb68150c961265ba$var$inlineEdgeX(_ref4) {
    var rect = _ref4.rect, edge = _ref4.edge, isRtl = _ref4.isRtl;
    var isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("2QYjE", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", function () { return $213f399c6fabb8ac$export$e9a6fdb80170ffd; });
/**
 * `@popperjs/core`'s `Placement` union is a strict subset of `TLegacyPlacement`
 * (the placement-map adds `top-center` / `bottom-center` on top of popper's
 * enum), so every value popper hands us is a valid legacy placement.
 *
 * The cast keeps the runtime path free of an extra module-level lookup that
 * bundlers can occasionally fail to wire up (observed as `Cannot read
 * properties of undefined (reading 'includes')` in component-test bundles).
 *
 * Shared so the React and imperative popper adapters resolve this identically.
 */ function $213f399c6fabb8ac$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("ilzzH", function(module, exports) {
$parcel$export(module.exports, "useFitViewportMaxSize", function () { return $03726a75f18e3ddd$export$f16d8ac7373995e1; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $jY97Z = parcelRequire("jY97Z");
/**
 * Applies the `shouldFitViewport` size caps directly to the
 * `position-area`-anchored popover host. Pure CSS — the browser owns every
 * value, so there is no measurement, no scroll/resize listeners, and no
 * `--ds-popper-anchor-*` custom properties.
 *
 * **Primary (placement) axis** is capped to `calc(100% - 5px - gap)`. Because
 * the host carries `position-area`, its containing block *is* the position-area
 * cell — the region between the anchor edge and the viewport edge — so `100%`
 * resolves to that distance. The popover is pushed `gap` into the cell by its
 * offset margin (`margin-*`, set by `useAnchorPosition`), so the gap is
 * subtracted as well to keep the legacy `viewportPadding = 5` on the far edge.
 * The cap is also more correct than measuring the requested placement: the cell
 * follows whichever side `position-try-fallbacks` actually flips to, so it
 * tracks the flip automatically.
 *
 * **Cross axis** is capped to `calc(100dvw|dvh - 10px)` (viewport, legacy
 * `2 * viewportPadding`). `display: flex` (plus a `min-*-size: 0` reset on the
 * child) lets an oversized child shrink and reflow to the cap. The host stays
 * `overflow: visible` so it never clips the consumer surface's `box-shadow`;
 * scrolling content that cannot reflow is the consumer surface's own
 * responsibility (it owns `overflow`), matching legacy `react-popper`, which
 * applied the cap to the consumer's own element.
 *
 * `min-inline-size` is reset to `0`. `useWidthFromAnchor({ mode: 'none' })`
 * floors the host at `max-content` so a too-narrow span overflows and drives
 * `position-try-fallbacks` rather than wrapping. That floor is the opposite of
 * fitting: when it exceeds a cap, CSS min/max resolution lets the min win and
 * the host overflows the viewport. In fit mode the caps must win, so the floor
 * is neutralised here; `setStyle` restores the prior inline value on cleanup.
 *
 * Verified in Chromium: `max-block-size: calc(100% - …)` on a `position: fixed`
 * + `position-area` element resolves `100%` to the cell, not the viewport.
 */ var $03726a75f18e3ddd$var$CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
var $03726a75f18e3ddd$var$CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ var $03726a75f18e3ddd$var$VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ var $03726a75f18e3ddd$var$NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function $03726a75f18e3ddd$export$f16d8ac7373995e1(_ref) {
    var target = _ref.target, placementAxis = _ref.placementAxis, gap = _ref.gap, isEnabled = _ref.isEnabled, isOpen = _ref.isOpen;
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = target.current;
        if (!element || !isEnabled) return;
        var isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        var primaryAxisCap = "calc(100% - 5px - ".concat(gap, ")");
        var cleanupHost = (0, $jY97Z.setStyle)({
            element: element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                //
                // This package only uses `mode: 'none'`. Note that `mode: 'min-anchor'`
                // puts its ANCHOR floor on the same property, so pairing this hook with
                // that mode would drop the anchor floor rather than a content floor. See
                // `@atlaskit/top-layer` `notes/decisions/width-from-anchor-floors.md`.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: $03726a75f18e3ddd$var$CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: $03726a75f18e3ddd$var$CROSS_BLOCK_CAP
                }
            ].concat((0, $lFOXD.default)($03726a75f18e3ddd$var$NON_ANCHOR_MARGIN_SIDES[placementAxis].map(function(property) {
                return {
                    property: property,
                    value: $03726a75f18e3ddd$var$VIEWPORT_PADDING
                };
            })))
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        var child = element.firstElementChild;
        var cleanupChild = child instanceof HTMLElement ? (0, $jY97Z.setStyle)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return function() {
            cleanupHost();
            cleanupChild === null || cleanupChild === void 0 || cleanupChild();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}

});
parcelRegister("jY97Z", function(module, exports) {
$parcel$export(module.exports, "setStyle", function () { return $e89ab383aa69bfe7$export$37a5fde709c1db82; });
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ function $e89ab383aa69bfe7$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("4Ue2v", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", function () { return $392748551088070d$export$941a7e8bf0b9eafd; });

var $1oC0p = parcelRequire("1oC0p");

var $YWDnS = parcelRequire("YWDnS");
function $392748551088070d$export$941a7e8bf0b9eafd() {
    return (0, $1oC0p.useContext)((0, $YWDnS.AnchorContext));
}

});
parcelRegister("YWDnS", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", function () { return $0b73163f4fe336e9$export$8f73317645bb7b8e; });

var $1oC0p = parcelRequire("1oC0p");
var $0b73163f4fe336e9$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});


parcelRegister("ivP3T", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", function () { return $d7a2bb0b22841698$export$61d36e2b682e92f7; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $2ENtE = parcelRequire("2ENtE");
var $d7a2bb0b22841698$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $d7a2bb0b22841698$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $d7a2bb0b22841698$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $d7a2bb0b22841698$var$isClippedByAncestors(element) {
    var rect = element.getBoundingClientRect();
    var parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        var style = window.getComputedStyle(parent);
        var clipsHorizontally = $d7a2bb0b22841698$var$isClippingOverflow(style.overflowX);
        var clipsVertically = $d7a2bb0b22841698$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            var parentRect = parent.getBoundingClientRect();
            var horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            var verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $d7a2bb0b22841698$export$61d36e2b682e92f7(_ref) {
    var anchor = _ref.anchor, popoverRef = _ref.popoverRef;
    var _useState = (0, $1oC0p.useState)($d7a2bb0b22841698$var$INITIAL), _useState2 = (0, $2qaZZ.default)(_useState, 2), visibility = _useState2[0], setVisibility = _useState2[1];
    var measure = (0, $1oC0p.useCallback)(function() {
        if (!anchor) {
            setVisibility(function(previous) {
                return previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $d7a2bb0b22841698$var$INITIAL;
            });
            return;
        }
        var viewport = (0, $2ENtE.readViewport)();
        var anchorRect = anchor.getBoundingClientRect();
        var isReferenceHidden = $d7a2bb0b22841698$var$isFullyOutsideViewport(anchorRect, viewport) || $d7a2bb0b22841698$var$isClippedByAncestors(anchor);
        var popoverElement = popoverRef.current;
        var hasPopperEscaped = popoverElement ? $d7a2bb0b22841698$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility(function(previous) {
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $1oC0p.useLayoutEffect)(function() {
        measure();
        if (typeof window === 'undefined') return undefined;
        var cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            var observer = new ResizeObserver(function() {
                return measure();
            });
            observer.observe(anchor);
            cleanups.push(function() {
                return observer.disconnect();
            });
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $dH1HR.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        var visual = window.visualViewport;
        if (visual) cleanups.push((0, $dH1HR.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return function() {
            cleanups.forEach(function(cleanup) {
                return cleanup();
            });
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("2ENtE", function(module, exports) {
$parcel$export(module.exports, "readViewport", function () { return $1ef5b2594aa6dfad$export$64beed533e21f72d; });
/**
 * Returns the current viewport size in CSS pixels, preferring the visual
 * viewport (which accounts for pinch-zoom on touch devices) over the
 * layout viewport. Returns `{ width: 0, height: 0 }` in non-DOM
 * environments so callers can use the result unconditionally.
 */ function $1ef5b2594aa6dfad$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    var visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("78FwG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $53297dff8dc0b1cb$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $e9Blu = parcelRequire("e9Blu");

var $1Xk7f = parcelRequire("1Xk7f");

var $l11vw = parcelRequire("l11vw");

var $1xdcM = parcelRequire("1xdcM");
function $53297dff8dc0b1cb$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy, _ref$isClosed = _ref.isClosed, isClosed = _ref$isClosed === void 0 ? false : _ref$isClosed;
    var isSubsequentRender = (0, $l11vw.default)(mountStrategy);
    (0, $1xdcM.default)(zIndex);
    return !(0, $6ur0l.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $e9Blu.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1Xk7f.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}

});
parcelRegister("e9Blu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a4dee0083b564935$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $qcezg = parcelRequire("qcezg");

var $4tBDK = parcelRequire("4tBDK");

var $4VF72 = parcelRequire("4VF72");

var $6ur0l = parcelRequire("6ur0l");

var $IMcK1 = parcelRequire("IMcK1");

var $9BkRa = parcelRequire("9BkRa");

var $bK9wF = parcelRequire("bK9wF");
function $a4dee0083b564935$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, _props$isClosed = props.isClosed, isClosed = _props$isClosed === void 0 ? false : _props$isClosed;
    var container = (0, $1oC0p.useMemo)(function() {
        return (0, $9BkRa.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $4tBDK.useColorMode)();
    var isInsideThemeProvider = (0, $4VF72.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $IMcK1.appendPortalContainerIfNotAppended)(container);
    (0, $1oC0p.useEffect)(function() {
        if ((0, $6ur0l.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $bK9wF.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            (0, $bK9wF.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $qcezg.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("qcezg", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", function () { return $04ebeb3ba6f52029$export$d8964aec282183a3; });
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $cn8ql = parcelRequire("cn8ql");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2jatx = parcelRequire("2jatx");

var $5Cxn4 = parcelRequire("5Cxn4");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $1wNrJ = parcelRequire("1wNrJ");

var $iSsU5 = parcelRequire("iSsU5");

var $6lPMT = parcelRequire("6lPMT");

var $bgDvv = parcelRequire("bgDvv");

var $S2fl6 = parcelRequire("S2fl6");

var $jXLUL = parcelRequire("jXLUL");

var $5euxW = parcelRequire("5euxW");

var $5vRjS = parcelRequire("5vRjS");

var $BNIxw = parcelRequire("BNIxw");

var $4VF72 = parcelRequire("4VF72");

var $jjl1A = parcelRequire("jjl1A");
function $04ebeb3ba6f52029$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04ebeb3ba6f52029$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04ebeb3ba6f52029$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04ebeb3ba6f52029$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $04ebeb3ba6f52029$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $04ebeb3ba6f52029$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $04ebeb3ba6f52029$var$prefersDarkModeMql = $04ebeb3ba6f52029$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $04ebeb3ba6f52029$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $04ebeb3ba6f52029$var$prefersDarkModeMql !== null && $04ebeb3ba6f52029$var$prefersDarkModeMql !== void 0 && $04ebeb3ba6f52029$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $04ebeb3ba6f52029$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $04ebeb3ba6f52029$export$d8964aec282183a3(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $1oC0p.useState)(defaultColorMode), _useState2 = (0, $2qaZZ.default)(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)($04ebeb3ba6f52029$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, $2qaZZ.default)(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return $04ebeb3ba6f52029$var$_objectSpread($04ebeb3ba6f52029$var$_objectSpread({}, $04ebeb3ba6f52029$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $1oC0p.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($04ebeb3ba6f52029$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $1oC0p.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $04ebeb3ba6f52029$var$_objectSpread($04ebeb3ba6f52029$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $1oC0p.useRef)(null);
    var isInsideAppProvider = (0, $S2fl6.useIsInsideAppProvider)();
    var isAppProviderThemingEnabled = (0, $bgDvv.useIsAppProviderThemingEnabled)();
    var isInsideThemeProvider = (0, $4VF72.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $1oC0p.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return lastSetGlobalThemePromiseRef.current;
                            case 1:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return cleanupLastFnCall();
                            case 1:
                                promise = (0, $6lPMT.setGlobalTheme)($04ebeb3ba6f52029$var$_objectSpread($04ebeb3ba6f52029$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $jjl1A.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!$04ebeb3ba6f52029$var$prefersDarkModeMql) return;
        var unbindListener = (0, $dH1HR.bind)($04ebeb3ba6f52029$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $04ebeb3ba6f52029$var$_objectSpread($04ebeb3ba6f52029$var$_objectSpread({}, (0, $iSsU5.getThemeHtmlAttrs)($04ebeb3ba6f52029$var$_objectSpread($04ebeb3ba6f52029$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, $f53LC.default)({}, (0, $1wNrJ.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5euxW.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jXLUL.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5vRjS.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $BNIxw.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $BNIxw.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", (0, $c9bqK.default)({}, attrs, {
        className: (0, $2jatx.default)([
            $04ebeb3ba6f52029$var$contentStyles.body
        ])
    }), children) : children)))));
}

});
parcelRegister("1wNrJ", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $11cf22a0151f2f83$export$4ef52930e33717cd; });
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", function () { return $11cf22a0151f2f83$export$cb374d25ded7f6ab; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $11cf22a0151f2f83$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $11cf22a0151f2f83$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $11cf22a0151f2f83$export$352e418ed5b6193a; });
var $11cf22a0151f2f83$export$4ef52930e33717cd = 'data-theme';
var $11cf22a0151f2f83$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $11cf22a0151f2f83$export$a00eac3f8684bcd0 = 'data-color-mode';
var $11cf22a0151f2f83$export$2112803007239c61 = 'data-contrast-mode';
var $11cf22a0151f2f83$export$352e418ed5b6193a = 'data-custom-theme';
var $11cf22a0151f2f83$export$6f0c6fb8c80fcc92 = 'ds';
var $11cf22a0151f2f83$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $11cf22a0151f2f83$export$dddac1532e822863 = "--".concat($11cf22a0151f2f83$export$6f0c6fb8c80fcc92, "-token-not-found");
var $11cf22a0151f2f83$export$9d7b58831ae93caa = "--".concat($11cf22a0151f2f83$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("iSsU5", function(module, exports) {
$parcel$export(module.exports, "getThemeHtmlAttrs", function () { return $dbe3b0cb13b451a4$export$e1f80cb7a749802f; });
$parcel$export(module.exports, "default", function () { return $dbe3b0cb13b451a4$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");

var $1wNrJ = parcelRequire("1wNrJ");

var $bvSXY = parcelRequire("bvSXY");

var $kUsvr = parcelRequire("kUsvr");

var $777eU = parcelRequire("777eU");

var $iVLIw = parcelRequire("iVLIw");
function $dbe3b0cb13b451a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbe3b0cb13b451a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbe3b0cb13b451a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbe3b0cb13b451a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dbe3b0cb13b451a4$var$defaultColorMode = 'light';
var $dbe3b0cb13b451a4$var$defaultContrastMode = 'no-preference';
var $dbe3b0cb13b451a4$export$e1f80cb7a749802f = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $bvSXY.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $bvSXY.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $bvSXY.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $bvSXY.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $bvSXY.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $bvSXY.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $bvSXY.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $bvSXY.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $bvSXY.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $kUsvr.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, $f53LC.default)((0, $f53LC.default)({}, (0, $1wNrJ.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $1wNrJ.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $dbe3b0cb13b451a4$var$defaultColorMode : colorMode);
    if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) result = $dbe3b0cb13b451a4$var$_objectSpread($dbe3b0cb13b451a4$var$_objectSpread({}, result), {}, (0, $f53LC.default)({}, (0, $1wNrJ.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $dbe3b0cb13b451a4$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $iVLIw.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $777eU.hash)(optionString);
        result[0, $1wNrJ.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $dbe3b0cb13b451a4$export$2e2bcd8739ae039 = $dbe3b0cb13b451a4$export$e1f80cb7a749802f;

});
parcelRegister("bvSXY", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", function () { return $861d3a25bce38e75$export$9aedcfa7336a207; });

var $6ur0l = parcelRequire("6ur0l");
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $861d3a25bce38e75$var$getShapeDefault() {
    if ((0, $6ur0l.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $861d3a25bce38e75$var$getMotionDefault() {
    return 'motion';
}
var $861d3a25bce38e75$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $861d3a25bce38e75$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $861d3a25bce38e75$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("kUsvr", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", function () { return $f38f2653fa30ded5$export$62c37ab81302621a; });

var $2zYm4 = parcelRequire("2zYm4");

var $2qaZZ = parcelRequire("2qaZZ");

var $9Ncrq = parcelRequire("9Ncrq");

var $kuzNe = parcelRequire("kuzNe");

var $6ygzz = parcelRequire("6ygzz");
var $f38f2653fa30ded5$var$customThemeOptions = 'UNSAFE_themeOptions';
var $f38f2653fa30ded5$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $9Ncrq.isColorMode)(id) || // custom theme state
        kind === $f38f2653fa30ded5$var$customThemeOptions && (0, $2zYm4.default)(id) === 'object' || // other theme states
        (0, $6ygzz.isThemeKind)(kind) && typeof id === 'string' && (0, $kuzNe.isThemeIds)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $2zYm4.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});
parcelRegister("9Ncrq", function(module, exports) {
$parcel$export(module.exports, "isColorMode", function () { return $7212573a0ae8f760$export$4a14e169b1de4ee7; });
var $7212573a0ae8f760$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("kuzNe", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", function () { return $eeb25fc0776b074e$export$ea35b8958c39dd07; });

var $amTf6 = parcelRequire("amTf6");
var $eeb25fc0776b074e$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $amTf6.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("amTf6", function(module, exports) {
$parcel$export(module.exports, "themeIds", function () { return $78c6cf7ac9551152$export$7d43e72a58e3283f; });
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $78c6cf7ac9551152$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("6ygzz", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", function () { return $013b243a07c2a4fe$export$958fa026be3a263e; });
var $013b243a07c2a4fe$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $013b243a07c2a4fe$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $013b243a07c2a4fe$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});


parcelRegister("777eU", function(module, exports) {
$parcel$export(module.exports, "hash", function () { return $52decd7b8881d27d$export$d6af199866bfb566; });
var $52decd7b8881d27d$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("iVLIw", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", function () { return $dc82907ae142f548$export$53031ac1ecb71f44; });
var $dc82907ae142f548$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};

});


parcelRegister("6lPMT", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", function () { return $49fce0310da2f8cb$export$fd7e0dd2b74807f7; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $6ur0l = parcelRequire("6ur0l");

var $k8gOV = parcelRequire("k8gOV");

var $bvSXY = parcelRequire("bvSXY");

var $5j1ri = parcelRequire("5j1ri");

var $4TpNi = parcelRequire("4TpNi");

var $fHGhj = parcelRequire("fHGhj");

var $asCyv = parcelRequire("asCyv");

var $iVLIw = parcelRequire("iVLIw");

var $auRVf = parcelRequire("auRVf");

var $1XjXu = parcelRequire("1XjXu");
function $49fce0310da2f8cb$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $49fce0310da2f8cb$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $49fce0310da2f8cb$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $49fce0310da2f8cb$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $49fce0310da2f8cb$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $49fce0310da2f8cb$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $49fce0310da2f8cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $49fce0310da2f8cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $49fce0310da2f8cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $49fce0310da2f8cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $49fce0310da2f8cb$export$fd7e0dd2b74807f7 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, themeOverridePreferences, overrideThemeCssLoadingTasks, mode, attrOfMissingCustomStyles, _iterator, _step, themeId, overrideThemeCss, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($49fce0310da2f8cb$var$_objectSpread($49fce0310da2f8cb$var$_objectSpread({}, (0, $bvSXY.themeStateDefaults)), {}, {
                        typography: (0, $bvSXY.themeStateDefaults)['typography'],
                        shape: (0, $bvSXY.themeStateDefaults)['shape'](),
                        motion: (0, $bvSXY.themeStateDefaults)['motion']()
                    }, (0, $k8gOV.getGlobalTheme)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $bvSXY.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $bvSXY.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $bvSXY.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $bvSXY.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $bvSXY.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $bvSXY.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $bvSXY.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $bvSXY.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $bvSXY.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $6ur0l.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $asCyv.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $1XjXu.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }());
                    themeOverridePreferences = (0, $fHGhj.getThemeOverridePreferences)(themeState); // Start loading override CSS before the first await. It is appended only after the standard
                    // themes have loaded so that the override cascade order remains deterministic.
                    overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map(function(themeId) {
                        return (0, $auRVf.loadThemeCss)(themeId);
                    }); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $iVLIw.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $bvSXY.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $4TpNi.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("8AlUs"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    if (!themeLoader) {
                        _context3.next = 9;
                        break;
                    }
                    _iterator = $49fce0310da2f8cb$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    _context3.next = 11;
                    break;
                case 9:
                    _context3.next = 10;
                    return Promise.all(overrideThemeCssLoadingTasks);
                case 10:
                    overrideThemeCss = _context3.sent;
                    _context3.next = 11;
                    return Promise.all(themeOverridePreferences.map(function(themeId, index) {
                        return (0, $1XjXu.loadAndAppendThemeCss)(themeId, overrideThemeCss[index]);
                    }));
                case 11:
                    autoUnbind = (0, $5j1ri.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 12:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("k8gOV", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $ea819a280b4bc22c$export$813ecdf77207a053; });

var $f53LC = parcelRequire("f53LC");

var $1wNrJ = parcelRequire("1wNrJ");

var $52Ewg = parcelRequire("52Ewg");

var $9lE0w = parcelRequire("9lE0w");
function $ea819a280b4bc22c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea819a280b4bc22c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea819a280b4bc22c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea819a280b4bc22c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ea819a280b4bc22c$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $1wNrJ.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $1wNrJ.THEME_DATA_ATTRIBUTE)) || '';
    return $ea819a280b4bc22c$var$_objectSpread($ea819a280b4bc22c$var$_objectSpread({}, (0, $9lE0w.themeStringToObject)(theme)), (0, $52Ewg.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("52Ewg", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", function () { return $3abc91f4dcb738eb$export$fcfb1976c88f9f75; });

var $bfTZR = parcelRequire("bfTZR");
var $3abc91f4dcb738eb$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $bfTZR.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("bfTZR", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $831c883b06884652$export$83993de8eb66733; });
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $831c883b06884652$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("9lE0w", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $6ce51bdb4325b12c$export$f19b488f7c0547ee; });

var $2qaZZ = parcelRequire("2qaZZ");

var $9Ncrq = parcelRequire("9Ncrq");

var $kuzNe = parcelRequire("kuzNe");

var $6ygzz = parcelRequire("6ygzz");
var $6ce51bdb4325b12c$var$customThemeOptions = 'UNSAFE_themeOptions';
var $6ce51bdb4325b12c$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $9Ncrq.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $6ygzz.isThemeKind)(kind) && (0, $kuzNe.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $6ce51bdb4325b12c$var$customThemeOptions) try {
            themeObject[$6ce51bdb4325b12c$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("5j1ri", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3dcfd7e3b2dd061c$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $6ur0l = parcelRequire("6ur0l");

var $iSsU5 = parcelRequire("iSsU5");

var $9Fwm5 = parcelRequire("9Fwm5");

var $bDAXG = parcelRequire("bDAXG");
function $3dcfd7e3b2dd061c$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $9Fwm5.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $9Fwm5.default).bind();
    } else (0, $9Fwm5.default).unbind();
    if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $bDAXG.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $bDAXG.default).bind();
        } else (0, $bDAXG.default).unbind();
    }
    var themeAttributes = (0, $iSsU5.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $9Fwm5.default).unbind();
        if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) (0, $bDAXG.default).unbind();
    };
}

});
parcelRegister("9Fwm5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70a10a73609a3098$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $dH1HR = parcelRequire("dH1HR");

var $1wNrJ = parcelRequire("1wNrJ");

var $1XjXu = parcelRequire("1XjXu");
var $70a10a73609a3098$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $70a10a73609a3098$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $1wNrJ.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $70a10a73609a3098$var$darkModeMql = $70a10a73609a3098$var$isMatchMediaAvailable && window.matchMedia((0, $1XjXu.darkModeMediaQuery));
var $70a10a73609a3098$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $cTewU.default)(this, ColorModeObserver);
        (0, $f53LC.default)(this, "unbindThemeChangeListener", null);
    }
    return (0, $avOEA.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$70a10a73609a3098$var$darkModeMql) return 'light';
                return $70a10a73609a3098$var$darkModeMql !== null && $70a10a73609a3098$var$darkModeMql !== void 0 && $70a10a73609a3098$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($70a10a73609a3098$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $dH1HR.bind)($70a10a73609a3098$var$darkModeMql, {
                    type: 'change',
                    listener: $70a10a73609a3098$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $70a10a73609a3098$var$SingletonColorModeObserver = new $70a10a73609a3098$var$ColorModeObserver();
var $70a10a73609a3098$export$2e2bcd8739ae039 = $70a10a73609a3098$var$SingletonColorModeObserver;

});
parcelRegister("1XjXu", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $16cac87ce1a57f11$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $16cac87ce1a57f11$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $16cac87ce1a57f11$export$8662df6937d86fcb; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $1wNrJ = parcelRequire("1wNrJ");

var $auRVf = parcelRequire("auRVf");
var $16cac87ce1a57f11$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId, preloadedThemeCss) {
        var themeCss, style, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $1wNrJ.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $1wNrJ.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (!(preloadedThemeCss !== null && preloadedThemeCss !== void 0)) {
                        _context.next = 3;
                        break;
                    }
                    _t = preloadedThemeCss;
                    _context.next = 5;
                    break;
                case 3:
                    _context.next = 4;
                    return (0, $auRVf.loadThemeCss)(themeId);
                case 4:
                    _t = _context.sent;
                case 5:
                    themeCss = _t;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $16cac87ce1a57f11$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $16cac87ce1a57f11$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("auRVf", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", function () { return $7a46888e25068d7b$export$8a48286ed7df6720; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $7x826 = parcelRequire("7x826");
var $7a46888e25068d7b$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $7x826.default)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("7x826", function(module, exports) {
$parcel$export(module.exports, "themeImportMap", function () { return $57c1d8a037713856$export$3a171c49f8c16356; });
$parcel$export(module.exports, "default", function () { return $57c1d8a037713856$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::3d041793de6aed48f20cb5e398199413>>
 * @codegenCommand yarn build tokens
 */ 














var $57c1d8a037713856$export$3a171c49f8c16356 = {
    'light': function light() {
        return (parcelRequire("k3Q1V"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("86LCs"));
    },
    'light-finesse': function lightFinesse() {
        return (parcelRequire("h9qWR"));
    },
    'light-increased-contrast-finesse': function lightIncreasedContrastFinesse() {
        return (parcelRequire("7MrbQ"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("hnm06"));
    },
    'dark': function dark() {
        return (parcelRequire("2NLuG"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("6KnJF"));
    },
    'dark-finesse': function darkFinesse() {
        return (parcelRequire("cdBCL"));
    },
    'dark-increased-contrast-finesse': function darkIncreasedContrastFinesse() {
        return (parcelRequire("33U66"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("iBQWC"));
    },
    'spacing': function spacing() {
        return (parcelRequire("bVYOy"));
    },
    'typography': function typography() {
        return (parcelRequire("1Tycs"));
    },
    'typography-finesse': function typographyFinesse() {
        return (parcelRequire("ibomk"));
    },
    'shape': function shape() {
        return (parcelRequire("5GC6K"));
    },
    'motion': function motion() {
        return (parcelRequire("dj7iC"));
    }
};
var $57c1d8a037713856$export$2e2bcd8739ae039 = $57c1d8a037713856$export$3a171c49f8c16356;

});
parcelRegister("k3Q1V", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("9Pv3Q").then(()=>parcelRequire('eVq4L'));

});

parcelRegister("86LCs", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("5aqvz").then(()=>parcelRequire('d817B'));

});

parcelRegister("h9qWR", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("iiAXv").then(()=>parcelRequire('cIEfw'));

});

parcelRegister("7MrbQ", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("gLfbs").then(()=>parcelRequire('3n1Ab'));

});

parcelRegister("hnm06", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("igDeZ").then(()=>parcelRequire('9WvWi'));

});

parcelRegister("2NLuG", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("3xcxB").then(()=>parcelRequire('beJto'));

});

parcelRegister("6KnJF", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("jM1Bd").then(()=>parcelRequire('4nQJh'));

});

parcelRegister("cdBCL", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("g9s4F").then(()=>parcelRequire('1KX6O'));

});

parcelRegister("33U66", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("gD7kt").then(()=>parcelRequire('90zpJ'));

});

parcelRegister("iBQWC", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("CRHVO").then(()=>parcelRequire('7k99i'));

});

parcelRegister("bVYOy", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("essOt").then(()=>parcelRequire('193AU'));

});

parcelRegister("1Tycs", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("k1CnY").then(()=>parcelRequire('8Co75'));

});

parcelRegister("ibomk", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("cdJCT").then(()=>parcelRequire('oG2FH'));

});

parcelRegister("5GC6K", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("1lqyJ").then(()=>parcelRequire('f3wVg'));

});

parcelRegister("dj7iC", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("bb3YJ").then(()=>parcelRequire('3KA22'));

});





parcelRegister("bDAXG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87900205011a497c$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $dH1HR = parcelRequire("dH1HR");

var $1wNrJ = parcelRequire("1wNrJ");

var $1XjXu = parcelRequire("1XjXu");
var $87900205011a497c$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $87900205011a497c$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $1wNrJ.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $87900205011a497c$var$contrastModeMql = $87900205011a497c$var$isMatchMediaAvailable && window.matchMedia((0, $1XjXu.moreContrastMediaQuery));
var $87900205011a497c$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $cTewU.default)(this, ContrastModeObserver);
        (0, $f53LC.default)(this, "unbindContrastChangeListener", null);
    }
    return (0, $avOEA.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$87900205011a497c$var$contrastModeMql) return 'no-preference';
                return $87900205011a497c$var$contrastModeMql !== null && $87900205011a497c$var$contrastModeMql !== void 0 && $87900205011a497c$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($87900205011a497c$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $dH1HR.bind)($87900205011a497c$var$contrastModeMql, {
                    type: 'change',
                    listener: $87900205011a497c$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $87900205011a497c$var$SingletonContrastModeObserver = new $87900205011a497c$var$ContrastModeObserver();
var $87900205011a497c$export$2e2bcd8739ae039 = $87900205011a497c$var$SingletonContrastModeObserver;

});


parcelRegister("4TpNi", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $39004ea64f89cde2$export$bd1ac9300b0e885a; });

var $1wNrJ = parcelRequire("1wNrJ");

var $777eU = parcelRequire("777eU");
function $39004ea64f89cde2$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $777eU.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $1wNrJ.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $1wNrJ.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("fHGhj", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $b6ebaabed57e8d5d$export$5d76d7014f4a5d08; });

var $lFOXD = parcelRequire("lFOXD");

var $6ur0l = parcelRequire("6ur0l");

var $cwoG7 = parcelRequire("cwoG7");
var $b6ebaabed57e8d5d$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
var $b6ebaabed57e8d5d$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(themeState) {
    if (!(0, $6ur0l.fg)('platform-dst-tokens-finesse')) return [];
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, typography = themeState.typography;
    var selectedThemes = [].concat((0, $lFOXD.default)(colorMode === 'auto' ? [
        light,
        dark
    ] : [
        themeState[colorMode]
    ]), [
        typography
    ]);
    if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) selectedThemes.forEach(function(themeId) {
        var increasedContrastTheme = (0, $cwoG7.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    var themeOverridePreferences = selectedThemes.map(function(themeId) {
        return $b6ebaabed57e8d5d$var$finesseOverrides[themeId];
    }).filter(function(themeId) {
        return themeId !== undefined;
    });
    return (0, $lFOXD.default)(new Set(themeOverridePreferences));
};

});
parcelRegister("cwoG7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $91db9dc6597fca5a$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $kc1ip = parcelRequire("kc1ip");
function $91db9dc6597fca5a$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $kc1ip.default)).find(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});
parcelRegister("kc1ip", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eb35eefe44895b91$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $amTf6 = parcelRequire("amTf6");


var $bvSXY = parcelRequire("bvSXY");
/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ // Retain Themes in this public type for backwards compatibility.
// platform-dst-tokens-finesse cleanup: Revisit when the temporary override themes are removed.
/**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $eb35eefe44895b91$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $eb35eefe44895b91$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
var $eb35eefe44895b91$export$92ba366331403db2 = [].concat((0, $lFOXD.default)((0, $amTf6.themeIds)), $eb35eefe44895b91$export$ba8a43b83ecc69f8);
var $eb35eefe44895b91$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$eb35eefe44895b91$export$2e2bcd8739ae039 = $eb35eefe44895b91$export$9d64ff89b6869900;

});



parcelRegister("asCyv", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", function () { return $79da6d402be4b4d1$export$dd6aeb7c823fc03d; });

var $lFOXD = parcelRequire("lFOXD");

var $6ur0l = parcelRequire("6ur0l");

var $cwoG7 = parcelRequire("cwoG7");
var $79da6d402be4b4d1$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $cwoG7.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $cwoG7.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $lFOXD.default)(new Set(themePreferences));
};

});

parcelRegister("8AlUs", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("bXLpm").then(()=>parcelRequire('jtUQB'));

});


parcelRegister("bgDvv", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", function () { return $833fd5a46872b39e$export$a782702263f77544; });

var $1oC0p = parcelRequire("1oC0p");

var $lXaGE = parcelRequire("lXaGE");
var $833fd5a46872b39e$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $1oC0p.useContext)((0, $lXaGE.AppProviderThemingEnabledContext));
};

});
parcelRegister("lXaGE", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", function () { return $ffb765e1a80987fe$export$d2def9838ca456c0; });

var $1oC0p = parcelRequire("1oC0p");
var $ffb765e1a80987fe$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});


parcelRegister("S2fl6", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", function () { return $0a26c959ae234349$export$26aa23367bfbab0e; });

var $1oC0p = parcelRequire("1oC0p");

var $fFflc = parcelRequire("fFflc");
var $0a26c959ae234349$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $1oC0p.useContext)((0, $fFflc.InsideAppProviderContext));
};

});
parcelRegister("fFflc", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", function () { return $b67695bcfbfb58dd$export$7981b2444296e410; });

var $1oC0p = parcelRequire("1oC0p");
var $b67695bcfbfb58dd$export$7981b2444296e410 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});


parcelRegister("jXLUL", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", function () { return $e888b1dd17d10d21$export$49ddd74a6729fdb0; });

var $1oC0p = parcelRequire("1oC0p");
var $e888b1dd17d10d21$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("5euxW", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", function () { return $3cf5f46bb8883c74$export$332347eeb335453c; });

var $1oC0p = parcelRequire("1oC0p");
var $3cf5f46bb8883c74$export$332347eeb335453c = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});

parcelRegister("5vRjS", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", function () { return $4039352856fc1120$export$b06130bad0bbc70f; });

var $1oC0p = parcelRequire("1oC0p");
var $4039352856fc1120$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("BNIxw", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", function () { return $071a05a718d29ec3$export$2c657da244d00bd6; });
$parcel$export(module.exports, "SetThemeContext", function () { return $071a05a718d29ec3$export$f7a97b47760e2a13; });

var $1oC0p = parcelRequire("1oC0p");
var $071a05a718d29ec3$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $071a05a718d29ec3$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("4VF72", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", function () { return $396c605fd5f8e60d$export$7ca11437599d653d; });

var $1oC0p = parcelRequire("1oC0p");

var $5euxW = parcelRequire("5euxW");
var $396c605fd5f8e60d$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $1oC0p.useContext)((0, $5euxW.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

});

parcelRegister("jjl1A", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", function () { return $e0f019b18c505f65$export$7d4a7e812d176b24; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ceF4b = parcelRequire("ceF4b");

var $7x826 = parcelRequire("7x826");

var $l6VQ6 = parcelRequire("l6VQ6");
var $e0f019b18c505f65$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $l6VQ6.isThemeMounted)(themeId)) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $7x826.themeImportMap)[themeId]();
                case 3:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $e0f019b18c505f65$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $ceF4b.getDocument)();
                    if (doc) {
                        _context2.next = 1;
                        break;
                    }
                    return _context2.abrupt("return");
                case 1:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $l6VQ6.isThemeMounted)(themeId)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return");
                case 2:
                    doc.head.appendChild(style);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $e0f019b18c505f65$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 1;
                    return $e0f019b18c505f65$var$loadThemeCss(themeId);
                case 1:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return");
                case 2:
                    $e0f019b18c505f65$var$mountThemeCss(themeCss, themeId);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $e0f019b18c505f65$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($e0f019b18c505f65$var$loadAndMountThemeCss);
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();

});
parcelRegister("l6VQ6", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", function () { return $f5e7063883d1135a$export$835a0dc855d02822; });

var $ceF4b = parcelRequire("ceF4b");

var $1wNrJ = parcelRequire("1wNrJ");
function $f5e7063883d1135a$export$835a0dc855d02822(themeId) {
    var doc = (0, $ceF4b.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $1wNrJ.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}

});



parcelRegister("4tBDK", function(module, exports) {
$parcel$export(module.exports, "useColorMode", function () { return $3427116bcd20d6e9$export$20f3076712c8dfa; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $k8gOV = parcelRequire("k8gOV");

var $48KjW = parcelRequire("48KjW");

var $jXLUL = parcelRequire("jXLUL");
function $3427116bcd20d6e9$export$20f3076712c8dfa() {
    var value = (0, $1oC0p.useContext)((0, $jXLUL.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $k8gOV.getGlobalTheme)();
    var _useState = (0, $1oC0p.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, $2qaZZ.default)(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $48KjW.ThemeMutationObserver)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("48KjW", function(module, exports) {
$parcel$export(module.exports, "ThemeMutationObserver", function () { return $303bd71d4f309864$export$b741a7c3bcb1c635; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $1wNrJ = parcelRequire("1wNrJ");

var $k8gOV = parcelRequire("k8gOV");
var $303bd71d4f309864$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $cTewU.default)(this, ThemeMutationObserver);
        (0, $f53LC.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $avOEA.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $k8gOV.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $1wNrJ.THEME_DATA_ATTRIBUTE),
                            (0, $1wNrJ.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $f53LC.default)($303bd71d4f309864$export$b741a7c3bcb1c635, "observer", null);
(0, $f53LC.default)($303bd71d4f309864$export$b741a7c3bcb1c635, "callbacks", new Set());
var $303bd71d4f309864$export$2e2bcd8739ae039 = $303bd71d4f309864$export$b741a7c3bcb1c635;

});


parcelRegister("IMcK1", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $0869809613f14ca3$export$c582005add11e141; });

var $coUvn = parcelRequire("coUvn");

var $56rwa = parcelRequire("56rwa");
var $0869809613f14ca3$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $coUvn.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $coUvn.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $56rwa.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $0869809613f14ca3$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $0869809613f14ca3$var$getPortalParent().appendChild(container);
};

});
parcelRegister("coUvn", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", function () { return $90738eadd32d2027$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $90738eadd32d2027$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $90738eadd32d2027$export$13f57c02915787b3; });
var $90738eadd32d2027$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $90738eadd32d2027$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $90738eadd32d2027$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("56rwa", function(module, exports) {
$parcel$export(module.exports, "getBody", function () { return $3b72dbc012dfbf19$export$135b49d4bc2964c6; });
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $3b72dbc012dfbf19$export$135b49d4bc2964c6 = function getBody() {
    return document.body;
};

});


parcelRegister("9BkRa", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $6fd7bf7152c67406$export$26ae5ca175b4ec5a; });

var $coUvn = parcelRequire("coUvn");
var $6fd7bf7152c67406$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $coUvn.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};

});

parcelRegister("bK9wF", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", function () { return $88cb613bf4ca3b43$export$da99f98bf3fe55b3; });

var $coUvn = parcelRequire("coUvn");

var $56rwa = parcelRequire("56rwa");
var $88cb613bf4ca3b43$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $coUvn.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $coUvn.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $56rwa.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $88cb613bf4ca3b43$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $88cb613bf4ca3b43$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("1Xk7f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $16cae7baf7da1317$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $qcezg = parcelRequire("qcezg");

var $4tBDK = parcelRequire("4tBDK");

var $4VF72 = parcelRequire("4VF72");

var $6ur0l = parcelRequire("6ur0l");

var $3IH3n = parcelRequire("3IH3n");

var $4UilL = parcelRequire("4UilL");

var $1CRBZ = parcelRequire("1CRBZ");

var $aBDPE = parcelRequire("aBDPE");
function $16cae7baf7da1317$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, isClosed = props.isClosed;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $4tBDK.useColorMode)();
    var isInsideThemeProvider = (0, $4VF72.useIsInsideThemeProvider)();
    (0, $3IH3n.useIsomorphicLayoutEffect)(function() {
        if ((0, $6ur0l.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                var tempPortalContainer = (0, $4UilL.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                var portalParent = (0, $1CRBZ.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return function() {
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $aBDPE.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            var _tempPortalContainer = (0, $4UilL.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(_tempPortalContainer);
            var _portalParent = (0, $1CRBZ.createPortalParent)();
            if (!_tempPortalContainer || !_portalParent) return;
            _portalParent.appendChild(_tempPortalContainer);
            return function() {
                if (_tempPortalContainer) _portalParent.removeChild(_tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $6ur0l.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $qcezg.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $gUjjH.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("3IH3n", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $2b56e0a995b0ac6e$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $2b56e0a995b0ac6e$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);

});

parcelRegister("4UilL", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $392aa05442d90de1$export$fef014d7cef9e543; });

var $coUvn = parcelRequire("coUvn");
var $392aa05442d90de1$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $392aa05442d90de1$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($392aa05442d90de1$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $coUvn.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("1CRBZ", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", function () { return $12f2ed3ab0595a35$export$95029ca7aca2989e; });

var $coUvn = parcelRequire("coUvn");

var $56rwa = parcelRequire("56rwa");
var $12f2ed3ab0595a35$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $12f2ed3ab0595a35$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($12f2ed3ab0595a35$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $coUvn.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            var parent = document.createElement('div');
            parent.className = (0, $coUvn.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $56rwa.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});

parcelRegister("aBDPE", function(module, exports) {
$parcel$export(module.exports, "removePortalParent", function () { return $7b8c41ebcc73cd2a$export$7b20876b2769b301; });

var $56rwa = parcelRequire("56rwa");
var $7b8c41ebcc73cd2a$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $7b8c41ebcc73cd2a$export$7b20876b2769b301 = function removePortalParent(parentElement) {
    if ($7b8c41ebcc73cd2a$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody;
            (_getBody = (0, $56rwa.getBody)()) === null || _getBody === void 0 || _getBody.removeChild(parentElement);
        }
    }
};

});


parcelRegister("l11vw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f4cadc54e9db44ca$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $3IH3n = parcelRequire("3IH3n");
var $f4cadc54e9db44ca$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $3IH3n.useIsomorphicLayoutEffect) : (0, $1oC0p.useEffect);
    }), _useState4 = (0, $2qaZZ.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $f4cadc54e9db44ca$export$2e2bcd8739ae039 = $f4cadc54e9db44ca$var$useIsSubsequentRender;

});

parcelRegister("1xdcM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $11e31dc6e35c3e38$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $lvFIP = parcelRequire("lvFIP");

var $dfZsB = parcelRequire("dfZsB");
var $11e31dc6e35c3e38$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1oC0p.useEffect)(function() {
        (0, $dfZsB.default)((0, $lvFIP.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $dfZsB.default)((0, $lvFIP.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $11e31dc6e35c3e38$export$2e2bcd8739ae039 = $11e31dc6e35c3e38$var$useFirePortalEvent;

});
parcelRegister("lvFIP", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $fa8cdb5689efffbf$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $fa8cdb5689efffbf$export$80816bd900e5bd00; });
var $fa8cdb5689efffbf$export$ed5835cc67e87f72 = 'akPortalMount';
var $fa8cdb5689efffbf$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("dfZsB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9a6c59d4af051141$export$2e2bcd8739ae039; });
var $9a6c59d4af051141$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $9a6c59d4af051141$var$getLayerName = function getLayerName(zIndex) {
    return $9a6c59d4af051141$var$zIndexToName.hasOwnProperty(zIndex) ? $9a6c59d4af051141$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $9a6c59d4af051141$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $9a6c59d4af051141$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $9a6c59d4af051141$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $9a6c59d4af051141$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("i9dl0", function(module, exports) {
$parcel$export(module.exports, "layers", function () { return $d36369dc634158bb$export$7be255094ccdc533; });
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var $d36369dc634158bb$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $d36369dc634158bb$export$c93026a968943f95 = 'light';
var $d36369dc634158bb$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $d36369dc634158bb$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};

});

parcelRegister("8TmK4", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $679519dd1c132125$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $679519dd1c132125$var$registrations = new Set();
var $679519dd1c132125$var$cleanupEndEventListeners = null;
function $679519dd1c132125$var$onDragStart() {
    if ($679519dd1c132125$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $679519dd1c132125$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $679519dd1c132125$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $679519dd1c132125$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $679519dd1c132125$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($679519dd1c132125$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $679519dd1c132125$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $679519dd1c132125$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $679519dd1c132125$var$cleanupEndEventListeners = null;
    var clone = Array.from($679519dd1c132125$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $679519dd1c132125$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $679519dd1c132125$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $679519dd1c132125$var$onDragStart
        }
    ]);
}
var $679519dd1c132125$var$cleanupStartEventListeners = null;
function $679519dd1c132125$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$679519dd1c132125$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $679519dd1c132125$var$cleanupStartEventListeners = $679519dd1c132125$var$bindStartEvents();
    $679519dd1c132125$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $679519dd1c132125$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $679519dd1c132125$var$registrations.delete(registration);
        if ($679519dd1c132125$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $679519dd1c132125$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $679519dd1c132125$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("hs4DK", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", function () { return $cb48a69b2cf66f65$export$d26fd3d066ede49; });
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $cb48a69b2cf66f65$var$getTriggerEdgeX(_ref) {
    var triggerRect = _ref.triggerRect, placement = _ref.placement;
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $cb48a69b2cf66f65$var$getTriggerEdgeY(_ref2) {
    var triggerRect = _ref2.triggerRect, placement = _ref2.placement;
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $cb48a69b2cf66f65$export$d26fd3d066ede49(_ref3) {
    var cursor = _ref3.cursor, triggerRect = _ref3.triggerRect, tooltipPosition = _ref3.tooltipPosition, placement = _ref3.placement;
    if (tooltipPosition === 'mouse-y') return {
        x: $cb48a69b2cf66f65$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $cb48a69b2cf66f65$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("7sfnr", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", function () { return $56d7137a40f7a89f$export$2e68479e0a5d8746; });
function $56d7137a40f7a89f$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});

parcelRegister("kr1CD", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $ee0796613cb35465$export$57bf213be019eeb0; });

var $6ur0l = parcelRequire("6ur0l");
var $ee0796613cb35465$var$delayId = null;
function $ee0796613cb35465$var$clearScheduled() {
    if ($ee0796613cb35465$var$delayId != null) {
        window.clearTimeout($ee0796613cb35465$var$delayId);
        $ee0796613cb35465$var$delayId = null;
    }
}
function $ee0796613cb35465$var$scheduleTimeout(fn, delay) {
    $ee0796613cb35465$var$clearScheduled();
    $ee0796613cb35465$var$delayId = window.setTimeout(function() {
        $ee0796613cb35465$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips.
//
// Once we roll out top-layer and remove the legacy path, this manager can be simplified:
// - Singleton: Can be removed; the platform (popover="auto" or popover="hint") already enforces
//   only one tooltip open at a time.
// - Phase machine: Can be simplified; drop hide-animating and finishHideAnimation (legacy fade-out).
//   Use e.g. pending-show | visible | pending-hide with immediate hide.
// - API: Can drop or simplify mousePosition/mousePos if no longer needed; keep delay scheduling,
//   keep(), requestHide, abort, and minimal lifecycle.
var $ee0796613cb35465$var$active = null;
function $ee0796613cb35465$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($ee0796613cb35465$var$active && $ee0796613cb35465$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $ee0796613cb35465$var$clearScheduled();
            $ee0796613cb35465$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $ee0796613cb35465$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $ee0796613cb35465$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $ee0796613cb35465$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($ee0796613cb35465$var$active && $ee0796613cb35465$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($ee0796613cb35465$var$active) {
            $ee0796613cb35465$var$clearScheduled();
            $ee0796613cb35465$var$active.entry.hide({
                isImmediate: true
            });
            $ee0796613cb35465$var$active.entry.done();
            $ee0796613cb35465$var$active = null;
        }
        // this tooltip is now the active tooltip
        $ee0796613cb35465$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $ee0796613cb35465$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("i96qf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d35e0c9d5d3d2aa4$export$2e2bcd8739ae039; });

var $2vZJL = parcelRequire("2vZJL");
function $d35e0c9d5d3d2aa4$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $2vZJL.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("caP7w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8dce129ea14aeaf6$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kaCFf = parcelRequire("kaCFf");
var $8dce129ea14aeaf6$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $8dce129ea14aeaf6$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, role = _ref.role;
    return /*#__PURE__*/ $1oC0p.createElement((0, $kaCFf.default), {
        ref: ref,
        style: style,
        className: (0, $2jatx.default)([
            $8dce129ea14aeaf6$var$styles.base,
            truncate && $8dce129ea14aeaf6$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$8dce129ea14aeaf6$var$TooltipContainer.displayName = 'TooltipContainer';
var $8dce129ea14aeaf6$export$2e2bcd8739ae039 = $8dce129ea14aeaf6$var$TooltipContainer;

});
parcelRegister("kaCFf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eaf2bbbad9ff33b2$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $1pu78 = parcelRequire("1pu78");
var $eaf2bbbad9ff33b2$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $eaf2bbbad9ff33b2$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, _ref$role = _ref.role, role = _ref$role === void 0 ? 'tooltip' : _ref$role;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        role: role,
        className: (0, $2jatx.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $1oC0p.createElement((0, $1pu78.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$eaf2bbbad9ff33b2$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $eaf2bbbad9ff33b2$export$2e2bcd8739ae039 = $eaf2bbbad9ff33b2$var$TooltipPrimitive;

});
parcelRegister("1pu78", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", function () { return $106f7c41df772a28$export$5bcbc43c84236222; });
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $106f7c41df772a28$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $106f7c41df772a28$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $106f7c41df772a28$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $1oC0p.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $2jatx.default)([
                $106f7c41df772a28$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});




parcelRegister("973ut", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6a2779a12f467c31$export$2e2bcd8739ae039; });
/* breadcrumbs-item-base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kPutE = parcelRequire("kPutE");

var $k03fP = parcelRequire("k03fP");

var $1Coey = parcelRequire("1Coey");
var $6a2779a12f467c31$var$_excluded = [
    "ref",
    "testId"
];
var $6a2779a12f467c31$var$itemWrapperStyles = null;
var $6a2779a12f467c31$var$BreadcrumbsItemBase = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, elemBefore = _ref.elemBefore, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onClick = _ref.onClick, onTooltipShown = _ref.onTooltipShown, target = _ref.target, testId = _ref.testId, text = _ref.text, title = _ref.title, truncationWidth = _ref.truncationWidth, shouldShowTooltip = _ref.shouldShowTooltip, stepRef = _ref.stepRef, xcss = _ref.xcss, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], ariaCurrent = _ref['aria-current'];
    var resolvedElemBefore = elemBefore !== null && elemBefore !== void 0 ? elemBefore : iconBefore;
    var renderStep = function renderStep(triggerProps) {
        var _ref2 = triggerProps !== null && triggerProps !== void 0 ? triggerProps : {}, tooltipRef = _ref2.ref, _testId = _ref2.testId, tooltipTriggerProps = (0, $gnQ3X.default)(_ref2, $6a2779a12f467c31$var$_excluded);
        return /*#__PURE__*/ $1oC0p.createElement((0, $1Coey.default), {
            ref: tooltipRef ? (0, $kPutE.default)([
                stepRef,
                tooltipRef
            ]) : stepRef,
            analyticsContext: analyticsContext,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-current": ariaCurrent,
            elemBefore: resolvedElemBefore,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            target: target,
            testId: testId,
            title: title,
            triggerProps: triggerProps ? tooltipTriggerProps : undefined,
            truncationWidth: truncationWidth
        }, text);
    };
    var step = renderStep();
    return /*#__PURE__*/ $1oC0p.createElement("li", {
        ref: ref,
        className: (0, $2jatx.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _2lx2vrvc _1wpz1h6o _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1q9y _14rn1rpy _aetr1n76 _8yoa1h6o",
            xcss
        ])
    }, shouldShowTooltip ? /*#__PURE__*/ $1oC0p.createElement((0, $k03fP.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, renderStep) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6a2779a12f467c31$export$2e2bcd8739ae039 = $6a2779a12f467c31$var$BreadcrumbsItemBase;

});
parcelRegister("1Coey", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $12dc235d2e2d9639$export$2e2bcd8739ae039; });
/* step.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $4hQ8o = parcelRequire("4hQ8o");

var $4ZpaI = parcelRequire("4ZpaI");

var $7uNuF = parcelRequire("7uNuF");

var $6ur0l = parcelRequire("6ur0l");

var $kbw6D = parcelRequire("kbw6D");
var $eowPk = parcelRequire("eowPk");

var $9HmsN = parcelRequire("9HmsN");
var $12dc235d2e2d9639$var$_excluded = [
    "analyticsContext",
    "elemBefore",
    "href",
    "iconAfter",
    "iconBefore",
    "onClick",
    "target",
    "testId",
    "children",
    "title",
    "truncationWidth",
    "triggerProps",
    "aria-label",
    "aria-labelledby",
    "aria-current",
    "aria-describedby",
    "onBlur",
    "onFocus",
    "onMouseDown",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver"
];
function $12dc235d2e2d9639$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12dc235d2e2d9639$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12dc235d2e2d9639$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12dc235d2e2d9639$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $12dc235d2e2d9639$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "@atlaskit/breadcrumbs",
    packageVersion: "17.6.0"
};
var $12dc235d2e2d9639$var$noop = (0, $7uNuF.default);
var $12dc235d2e2d9639$var$styles = {
    root: "_11c8fhey _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zrze3t _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc",
    rootRefresh: "_vchhusvi _4t3i1k8s",
    rootT26Shape: "_2rkolb4i",
    interactiveMotion: "_v564hxmd _1hms8stv _4bfu1j28 _o7kshxmd _9oik1rpy _1ggl87vo _1nrmi7uo",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    withTruncation: "_1ul9idpf",
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperExternal: "_12l2v77o",
    iconWrapperExternalSmall: "_12l2ze3t",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
var $12dc235d2e2d9639$var$unboundedStyles = {
    iconWrapperSmall: "_w8l57vkz _17527vkz",
    iconWrapper: "_syaz1cv2"
};
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ var $12dc235d2e2d9639$var$Step = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _triggerProps$onMouse5, _triggerProps$onMouse6, _triggerProps$onMouse7, _triggerProps$onMouse8, _triggerProps$onFocus2, _triggerProps$onBlur2, _triggerProps$ariaDe2;
    var analyticsContext = _ref.analyticsContext, elemBefore = _ref.elemBefore, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, _ref$onClick = _ref.onClick, onClickProvided = _ref$onClick === void 0 ? $12dc235d2e2d9639$var$noop : _ref$onClick, target = _ref.target, testId = _ref.testId, children = _ref.children, title = _ref.title, truncationWidth = _ref.truncationWidth, triggerProps = _ref.triggerProps, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], ariaCurrent = _ref['aria-current'], ariaDescribedBy = _ref['aria-describedby'], onBlur = _ref.onBlur, onFocus = _ref.onFocus, onMouseDown = _ref.onMouseDown, onMouseMove = _ref.onMouseMove, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, rest = (0, $gnQ3X.default)(_ref, $12dc235d2e2d9639$var$_excluded);
    var resolvedElemBefore = elemBefore !== null && elemBefore !== void 0 ? elemBefore : iconBefore;
    var breadcrumbsSize = (0, $9HmsN.useBreadcrumbsSize)();
    var isSmall = breadcrumbsSize === 'small';
    var handleClick = (0, $4hQ8o.usePlatformLeafEventHandler)($12dc235d2e2d9639$var$_objectSpread({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $12dc235d2e2d9639$var$analyticsAttributes));
    var handleTriggerClick = function handleTriggerClick(event) {
        var _triggerProps$onClick;
        triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
        handleClick(event);
    };
    var controlRef = (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') ? ref : undefined;
    var textRef = (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') ? undefined : ref;
    var iconElement = resolvedElemBefore && /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId && "".concat(testId, "--icon-before"),
        className: (0, $2jatx.default)([
            $12dc235d2e2d9639$var$styles.iconWrapper,
            $12dc235d2e2d9639$var$unboundedStyles.iconWrapper,
            (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && $12dc235d2e2d9639$var$styles.iconWrapperExternal,
            isSmall && $12dc235d2e2d9639$var$styles.iconWrapperExternalSmall,
            isSmall && $12dc235d2e2d9639$var$unboundedStyles.iconWrapperSmall
        ])
    }, resolvedElemBefore);
    var content = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, !(0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && !isSmall && resolvedElemBefore, !(0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && isSmall && iconElement, /*#__PURE__*/ $1oC0p.createElement("span", {
        ref: textRef,
        className: (0, $2jatx.default)([
            $12dc235d2e2d9639$var$styles.text,
            truncationWidth != null && (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && $12dc235d2e2d9639$var$styles.textWithTruncation
        ])
    }, children), iconAfter);
    if (href) {
        var _triggerProps$onMouse, _triggerProps$onMouse2, _triggerProps$onMouse3, _triggerProps$onMouse4, _triggerProps$onFocus, _triggerProps$onBlur, _triggerProps$ariaDe;
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && iconElement, /*#__PURE__*/ $1oC0p.createElement((0, $kbw6D.Anchor), (0, $c9bqK.default)({}, rest, {
            ref: controlRef,
            "aria-current": ariaCurrent,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            href: href,
            onClick: handleTriggerClick,
            onMouseOver: (_triggerProps$onMouse = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOver) !== null && _triggerProps$onMouse !== void 0 ? _triggerProps$onMouse : onMouseOver,
            onMouseOut: (_triggerProps$onMouse2 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOut) !== null && _triggerProps$onMouse2 !== void 0 ? _triggerProps$onMouse2 : onMouseOut,
            onMouseMove: (_triggerProps$onMouse3 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseMove) !== null && _triggerProps$onMouse3 !== void 0 ? _triggerProps$onMouse3 : onMouseMove,
            onMouseDown: (_triggerProps$onMouse4 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseDown) !== null && _triggerProps$onMouse4 !== void 0 ? _triggerProps$onMouse4 : onMouseDown,
            onFocus: (_triggerProps$onFocus = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onFocus) !== null && _triggerProps$onFocus !== void 0 ? _triggerProps$onFocus : onFocus,
            onBlur: (_triggerProps$onBlur = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onBlur) !== null && _triggerProps$onBlur !== void 0 ? _triggerProps$onBlur : onBlur,
            "aria-describedby": (_triggerProps$ariaDe = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps['aria-describedby']) !== null && _triggerProps$ariaDe !== void 0 ? _triggerProps$ariaDe : ariaDescribedBy,
            target: target,
            testId: testId,
            title: title,
            xcss: (0, $4ZpaI.cx)($12dc235d2e2d9639$var$styles.root, isSmall && $12dc235d2e2d9639$var$styles.rootSmall, (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && $12dc235d2e2d9639$var$styles.rootRefresh, truncationWidth != null && (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && $12dc235d2e2d9639$var$styles.withTruncation, truncationWidth == null && $12dc235d2e2d9639$var$styles.withoutTruncation, (0, $6ur0l.fg)('platform-dst-shape-theme-default') && $12dc235d2e2d9639$var$styles.rootT26Shape, (0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') && $12dc235d2e2d9639$var$styles.interactiveMotion),
            style: {
                maxWidth: truncationWidth
            }
        }), content));
    }
    return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && iconElement, /*#__PURE__*/ $1oC0p.createElement((0, $eowPk.Pressable), (0, $c9bqK.default)({}, rest, {
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: handleTriggerClick,
        onMouseOver: (_triggerProps$onMouse5 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOver) !== null && _triggerProps$onMouse5 !== void 0 ? _triggerProps$onMouse5 : onMouseOver,
        onMouseOut: (_triggerProps$onMouse6 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOut) !== null && _triggerProps$onMouse6 !== void 0 ? _triggerProps$onMouse6 : onMouseOut,
        onMouseMove: (_triggerProps$onMouse7 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseMove) !== null && _triggerProps$onMouse7 !== void 0 ? _triggerProps$onMouse7 : onMouseMove,
        onMouseDown: (_triggerProps$onMouse8 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseDown) !== null && _triggerProps$onMouse8 !== void 0 ? _triggerProps$onMouse8 : onMouseDown,
        onFocus: (_triggerProps$onFocus2 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onFocus) !== null && _triggerProps$onFocus2 !== void 0 ? _triggerProps$onFocus2 : onFocus,
        onBlur: (_triggerProps$onBlur2 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onBlur) !== null && _triggerProps$onBlur2 !== void 0 ? _triggerProps$onBlur2 : onBlur,
        "aria-describedby": (_triggerProps$ariaDe2 = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps['aria-describedby']) !== null && _triggerProps$ariaDe2 !== void 0 ? _triggerProps$ariaDe2 : ariaDescribedBy,
        testId: testId,
        title: title,
        xcss: (0, $4ZpaI.cx)($12dc235d2e2d9639$var$styles.root, isSmall && $12dc235d2e2d9639$var$styles.rootSmall, (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && $12dc235d2e2d9639$var$styles.rootRefresh, truncationWidth != null && (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && $12dc235d2e2d9639$var$styles.withTruncation, truncationWidth == null && $12dc235d2e2d9639$var$styles.withoutTruncation, (0, $6ur0l.fg)('platform-dst-shape-theme-default') && $12dc235d2e2d9639$var$styles.rootT26Shape, (0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') && $12dc235d2e2d9639$var$styles.interactiveMotion),
        style: {
            maxWidth: truncationWidth
        }
    }), content));
});
var $12dc235d2e2d9639$export$2e2bcd8739ae039 = $12dc235d2e2d9639$var$Step;

});
parcelRegister("4hQ8o", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $31f130c46b2f10e3$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3b6IF = parcelRequire("3b6IF");

var $6wNqA = parcelRequire("6wNqA");
function $31f130c46b2f10e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $31f130c46b2f10e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $31f130c46b2f10e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $31f130c46b2f10e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $31f130c46b2f10e3$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3b6IF.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $6wNqA.useTrackedRef)(analyticsData);
    var fnRef = (0, $6wNqA.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $31f130c46b2f10e3$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("9HmsN", function(module, exports) {
$parcel$export(module.exports, "useBreadcrumbsSize", function () { return $70f98df613eda269$export$c60a2bbc99661fa2; });

var $1oC0p = parcelRequire("1oC0p");

var $3zYsU = parcelRequire("3zYsU");
function $70f98df613eda269$export$c60a2bbc99661fa2() {
    return (0, $1oC0p.useContext)((0, $3zYsU.default));
}

});
parcelRegister("3zYsU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $29b38b1b45ecced7$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
/**
 * Shared breadcrumbs size context for the primitives API and refreshed composed breadcrumbs.
 */ var $29b38b1b45ecced7$var$BreadcrumbsSizeContext = /*#__PURE__*/ (0, $1oC0p.createContext)('medium');
var $29b38b1b45ecced7$export$2e2bcd8739ae039 = $29b38b1b45ecced7$var$BreadcrumbsSizeContext;

});




parcelRegister("f2eY1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af22a713fc7fa26c$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $4hQ8o = parcelRequire("4hQ8o");

var $ddxTX = parcelRequire("ddxTX");

var $7uNuF = parcelRequire("7uNuF");

var $6ur0l = parcelRequire("6ur0l");
var $af22a713fc7fa26c$var$_excluded = [
    "analyticsContext",
    "component",
    "hasOverflow",
    "href",
    "iconAfter",
    "iconBefore",
    "onClick",
    "target",
    "testId"
];
function $af22a713fc7fa26c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af22a713fc7fa26c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af22a713fc7fa26c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af22a713fc7fa26c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $af22a713fc7fa26c$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "@atlaskit/breadcrumbs",
    packageVersion: "17.6.0"
};
var $af22a713fc7fa26c$var$noop = (0, $7uNuF.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ var $af22a713fc7fa26c$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, component = _ref.component, _ref$hasOverflow = _ref.hasOverflow, hasOverflow = _ref$hasOverflow === void 0 ? true : _ref$hasOverflow, _ref$href = _ref.href, href = _ref$href === void 0 ? '#' : _ref$href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, _ref$onClick = _ref.onClick, onClickProvided = _ref$onClick === void 0 ? $af22a713fc7fa26c$var$noop : _ref$onClick, target = _ref.target, testId = _ref.testId, props = (0, $gnQ3X.default)(_ref, $af22a713fc7fa26c$var$_excluded);
    var handleClicked = (0, $4hQ8o.usePlatformLeafEventHandler)($af22a713fc7fa26c$var$_objectSpread({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $af22a713fc7fa26c$var$analyticsAttributes));
    var resolvedIconAfter = (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') ? undefined : hasOverflow ? undefined : iconAfter;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ddxTX.default), (0, $c9bqK.default)({}, props, {
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: resolvedIconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    }));
});
var $af22a713fc7fa26c$export$2e2bcd8739ae039 = $af22a713fc7fa26c$var$StepOld;

});
parcelRegister("ddxTX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $99f6c96a28774b49$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $i60vt = parcelRequire("i60vt");

var $1Ar2T = parcelRequire("1Ar2T");

var $coysQ = parcelRequire("coysQ");
var $99f6c96a28774b49$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $99f6c96a28774b49$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $99f6c96a28774b49$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $7uNuF.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $7uNuF.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, $gnQ3X.default)(_ref, $99f6c96a28774b49$var$_excluded);
    var isOnlySingleIcon = (0, $coysQ.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($99f6c96a28774b49$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $1oC0p.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($99f6c96a28774b49$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $1oC0p.useMemo)(function() {
        return (0, $1Ar2T.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i60vt.default), (0, $c9bqK.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$99f6c96a28774b49$var$Button.displayName = 'Button';
var $99f6c96a28774b49$export$2e2bcd8739ae039 = $99f6c96a28774b49$var$Button;

});
parcelRegister("i60vt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d2c92e1fe7c5abe3$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $h4qVz = parcelRequire("h4qVz");

var $7uNuF = parcelRequire("7uNuF");

var $gyCsW = parcelRequire("gyCsW");

var $iENwh = parcelRequire("iENwh");

var $lp8ng = parcelRequire("lp8ng");

var $7dZ9n = parcelRequire("7dZ9n");

var $Id65j = parcelRequire("Id65j");

var $2iSFH = parcelRequire("2iSFH");

var $lIvFu = parcelRequire("lIvFu");

var $gUgJu = parcelRequire("gUgJu");

var $4LeoH = parcelRequire("4LeoH");
var $d2c92e1fe7c5abe3$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $d2c92e1fe7c5abe3$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ var $d2c92e1fe7c5abe3$var$iconBeforeSpacingFixStyle = (0, $3dJ4i.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $d2c92e1fe7c5abe3$var$iconAfterSpacingFixStyle = (0, $3dJ4i.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $d2c92e1fe7c5abe3$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $gUgJu.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $d2c92e1fe7c5abe3$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $gUgJu.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $3dJ4i.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $d2c92e1fe7c5abe3$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $7uNuF.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $7uNuF.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, $gnQ3X.default)(props, $d2c92e1fe7c5abe3$var$_excluded);
    var ourRef = (0, $1oC0p.useRef)();
    var setRef = (0, $1oC0p.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gyCsW.default)(ourRef, autoFocus);
    var interactionContext = (0, $1oC0p.useContext)((0, $lp8ng.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $h4qVz.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "25.2.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $1oC0p.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $3dJ4i.css)((0, $2iSFH.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $3dJ4i.jsx)((0, $iENwh.default), null, (0, $3dJ4i.jsx)(Component, (0, $c9bqK.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $d2c92e1fe7c5abe3$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $7dZ9n.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $lIvFu.getIconStyle)({
                spacing: spacing
            }),
            $d2c92e1fe7c5abe3$var$getSpacingFix(children, $d2c92e1fe7c5abe3$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $d2c92e1fe7c5abe3$var$getChildren(children, [
        fadeStyles,
        (0, $Id65j.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $lIvFu.getIconStyle)({
                spacing: spacing
            }),
            $d2c92e1fe7c5abe3$var$getSpacingFix(children, $d2c92e1fe7c5abe3$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3dJ4i.jsx)("span", {
        css: [
            (0, $4LeoH.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d2c92e1fe7c5abe3$export$2e2bcd8739ae039 = $d2c92e1fe7c5abe3$var$ButtonBase;

});
parcelRegister("h4qVz", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $c6d7b2a9648b3361$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $yju3w = parcelRequire("yju3w");

var $kvtzd = parcelRequire("kvtzd");
function $c6d7b2a9648b3361$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6d7b2a9648b3361$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6d7b2a9648b3361$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6d7b2a9648b3361$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c6d7b2a9648b3361$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $yju3w.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $kvtzd.useTrackedRef)(analyticsData);
    var fnRef = (0, $kvtzd.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c6d7b2a9648b3361$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("iENwh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9525ffd30b8f662$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $d9525ffd30b8f662$var$BORDER_WIDTH = 2;
var $d9525ffd30b8f662$var$baseFocusOutsideStyles = (0, $3dJ4i.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #4688EC)"),
    outlineOffset: $d9525ffd30b8f662$var$BORDER_WIDTH
});
var $d9525ffd30b8f662$var$baseInsetStyles = (0, $3dJ4i.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$d9525ffd30b8f662$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $d9525ffd30b8f662$var$focusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $d9525ffd30b8f662$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $d9525ffd30b8f662$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $d9525ffd30b8f662$var$insetFocusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $d9525ffd30b8f662$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $d9525ffd30b8f662$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ var $d9525ffd30b8f662$var$FocusRing = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $d9525ffd30b8f662$var$baseInsetStyles : $d9525ffd30b8f662$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $d9525ffd30b8f662$var$insetFocusRingStyles : $d9525ffd30b8f662$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $1oC0p.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $1oC0p.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$d9525ffd30b8f662$var$FocusRing.displayName = 'FocusRing';
var $d9525ffd30b8f662$export$2e2bcd8739ae039 = $d9525ffd30b8f662$var$FocusRing;

});

parcelRegister("7dZ9n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $54292e7c9d17673e$export$2e2bcd8739ae039; });
function $54292e7c9d17673e$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $54292e7c9d17673e$var$tabKeyCode = 9;
function $54292e7c9d17673e$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $54292e7c9d17673e$var$tabKeyCode) return;
    $54292e7c9d17673e$var$abort(event);
}
var $54292e7c9d17673e$var$block = {
    onMouseDownCapture: $54292e7c9d17673e$var$abort,
    onMouseUpCapture: $54292e7c9d17673e$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $54292e7c9d17673e$var$onKey,
    onKeyUpCapture: $54292e7c9d17673e$var$onKey,
    onTouchStartCapture: $54292e7c9d17673e$var$abort,
    onTouchEndCapture: $54292e7c9d17673e$var$abort,
    onPointerDownCapture: $54292e7c9d17673e$var$abort,
    onPointerUpCapture: $54292e7c9d17673e$var$abort,
    onClickCapture: $54292e7c9d17673e$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $54292e7c9d17673e$var$abort
};
var $54292e7c9d17673e$var$doNotBlock = {};
function $54292e7c9d17673e$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $54292e7c9d17673e$var$doNotBlock : $54292e7c9d17673e$var$block;
}

});

parcelRegister("Id65j", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", function () { return $084e44fe976af13a$export$7ad0316cc0dd65a; });
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3dJ4i = parcelRequire("3dJ4i");
function $084e44fe976af13a$export$7ad0316cc0dd65a(_ref) {
    var spacing = _ref.spacing;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("2iSFH", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", function () { return $1ad7abd53b7bc2ab$export$1b5827d324e945b1; });
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3dJ4i = parcelRequire("3dJ4i");
function $1ad7abd53b7bc2ab$export$1b5827d324e945b1(_ref) {
    var hasOverlay = _ref.hasOverlay;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("lIvFu", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", function () { return $fcf645aee9ad4432$export$864eea3f4ec3368f; });
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3dJ4i = parcelRequire("3dJ4i");
function $fcf645aee9ad4432$export$864eea3f4ec3368f(_ref) {
    var spacing = _ref.spacing;
    return (0, $3dJ4i.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : "0 2px",
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("gUgJu", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $032d2490dc97f14f$export$20bbd2efb0d734c4; });

var $1oC0p = parcelRequire("1oC0p");

var $5fTYD = parcelRequire("5fTYD");
var $032d2490dc97f14f$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $1oC0p.isValidElement)(children) && children.type === (0, $5fTYD.default);
};

});

parcelRegister("4LeoH", function(module, exports) {
$parcel$export(module.exports, "overlayCss", function () { return $3776b83bfa478fc4$export$1a9fe1b84c876bb5; });
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $3776b83bfa478fc4$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("1Ar2T", function(module, exports) {
$parcel$export(module.exports, "getCss", function () { return $127e21ee1f4b5fe4$export$955358618f994a11; });

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");
function $127e21ee1f4b5fe4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $127e21ee1f4b5fe4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $127e21ee1f4b5fe4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $127e21ee1f4b5fe4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $127e21ee1f4b5fe4$var$gridSize = 8;
var $127e21ee1f4b5fe4$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
var $127e21ee1f4b5fe4$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $127e21ee1f4b5fe4$var$lineHeights = {
    default: $127e21ee1f4b5fe4$var$heights.default,
    compact: $127e21ee1f4b5fe4$var$heights.compact,
    none: 'inherit'
};
var $127e21ee1f4b5fe4$var$padding = {
    // 10px gutter
    default: "0 ".concat($127e21ee1f4b5fe4$var$gridSize + $127e21ee1f4b5fe4$var$gridSize / 4, "px"),
    compact: "0 ".concat($127e21ee1f4b5fe4$var$gridSize + $127e21ee1f4b5fe4$var$gridSize / 4, "px"),
    none: '0'
};
var $127e21ee1f4b5fe4$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($127e21ee1f4b5fe4$var$gridSize / 4, "px"),
    default: "0 ".concat($127e21ee1f4b5fe4$var$gridSize / 4, "px"),
    none: '0'
};
var $127e21ee1f4b5fe4$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $127e21ee1f4b5fe4$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $127e21ee1f4b5fe4$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $127e21ee1f4b5fe4$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $127e21ee1f4b5fe4$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $127e21ee1f4b5fe4$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $127e21ee1f4b5fe4$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $127e21ee1f4b5fe4$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $127e21ee1f4b5fe4$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $127e21ee1f4b5fe4$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
/**
 * Anchor-text-color variants applied when the legacy `Button` is rendered as
 * an `<a>` (via `href`). Each `<variant>WithAnchorTextColorStyles` is a
 * self-contained appearance object that adds explicit `color` /
 * `text-decoration` on the base, `:hover`, and `:active` states, preventing
 * browser default or ambient anchor styles from overriding the button's
 * intended text color or adding an unwanted underline.
 *
 * Gated by `platform-dst-legacy-button-anchor-text-color` and used *instead*
 * of the base `<variant>Styles`. When cleaning up the gate: delete the base
 * `<variant>Styles` and rename the `WithAnchorTextColor` variant to replace
 * it.
 *
 * Link-like variants (`link`, `subtle-link`) keep their intentional underline
 * on `:hover` / `:active`.
 */ var $127e21ee1f4b5fe4$var$defaultWithAnchorTextColorStyles = $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$defaultStyles), {}, {
    textDecoration: 'none',
    '&:hover': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$defaultStyles['&:hover']), {}, {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$defaultStyles['&:active']), {}, {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    })
});
var $127e21ee1f4b5fe4$var$primaryWithAnchorTextColorStyles = $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$primaryStyles), {}, {
    textDecoration: 'none',
    '&:hover': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$primaryStyles['&:hover']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$primaryStyles['&:active']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
var $127e21ee1f4b5fe4$var$linkWithAnchorTextColorStyles = $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$linkStyles), {}, {
    textDecoration: 'none'
});
var $127e21ee1f4b5fe4$var$subtleWithAnchorTextColorStyles = $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$subtleStyles), {}, {
    textDecoration: 'none',
    '&:hover': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$subtleStyles['&:hover']), {}, {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    }),
    '&:active': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$subtleStyles['&:active']), {}, {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    })
});
var $127e21ee1f4b5fe4$var$subtleLinkWithAnchorTextColorStyles = $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$subtleLinkStyles), {}, {
    textDecoration: 'none'
});
var $127e21ee1f4b5fe4$var$warningWithAnchorTextColorStyles = $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$warningStyles), {}, {
    textDecoration: 'none',
    '&:hover': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$warningStyles['&:hover']), {}, {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$warningStyles['&:active']), {}, {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    })
});
var $127e21ee1f4b5fe4$var$dangerWithAnchorTextColorStyles = $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$dangerStyles), {}, {
    textDecoration: 'none',
    '&:hover': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$dangerStyles['&:hover']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, $127e21ee1f4b5fe4$var$dangerStyles['&:active']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
var $127e21ee1f4b5fe4$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $127e21ee1f4b5fe4$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    var appearanceStyles = (0, $6ur0l.fg)('platform-dst-legacy-button-anchor-text-color') ? $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, appearance === 'default' && $127e21ee1f4b5fe4$var$defaultWithAnchorTextColorStyles), appearance === 'primary' && $127e21ee1f4b5fe4$var$primaryWithAnchorTextColorStyles), appearance === 'link' && $127e21ee1f4b5fe4$var$linkWithAnchorTextColorStyles), appearance === 'subtle' && $127e21ee1f4b5fe4$var$subtleWithAnchorTextColorStyles), appearance === 'subtle-link' && $127e21ee1f4b5fe4$var$subtleLinkWithAnchorTextColorStyles), appearance === 'warning' && $127e21ee1f4b5fe4$var$warningWithAnchorTextColorStyles), appearance === 'danger' && $127e21ee1f4b5fe4$var$dangerWithAnchorTextColorStyles) : $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, appearance === 'default' && $127e21ee1f4b5fe4$var$defaultStyles), appearance === 'primary' && $127e21ee1f4b5fe4$var$primaryStyles), appearance === 'link' && $127e21ee1f4b5fe4$var$linkStyles), appearance === 'subtle' && $127e21ee1f4b5fe4$var$subtleStyles), appearance === 'subtle-link' && $127e21ee1f4b5fe4$var$subtleLinkStyles), appearance === 'warning' && $127e21ee1f4b5fe4$var$warningStyles), appearance === 'danger' && $127e21ee1f4b5fe4$var$dangerStyles);
    var activeStyles = appearanceStyles['&:active'];
    return $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $6ur0l.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: (0, $6ur0l.fg)('platform-dst-motion-uplift-button') ? "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))".concat(", box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)") : 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $127e21ee1f4b5fe4$var$heights[spacing],
        lineHeight: $127e21ee1f4b5fe4$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $127e21ee1f4b5fe4$var$singleIconPadding[spacing] : $127e21ee1f4b5fe4$var$padding[spacing],
        verticalAlign: $127e21ee1f4b5fe4$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $127e21ee1f4b5fe4$var$selectedStyles : $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, appearanceStyles), activeStyles && (0, $6ur0l.fg)('platform-dst-motion-uplift-button') && {
        '&:active': $127e21ee1f4b5fe4$var$_objectSpread($127e21ee1f4b5fe4$var$_objectSpread({}, activeStyles), {}, {
            transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
        })
    }), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $127e21ee1f4b5fe4$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $127e21ee1f4b5fe4$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $127e21ee1f4b5fe4$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            }
        }
    }, $127e21ee1f4b5fe4$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}

});

parcelRegister("coysQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $906275cde614a231$export$2e2bcd8739ae039; });

var $gUgJu = parcelRequire("gUgJu");
function $906275cde614a231$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $gUgJu.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});



parcelRegister("1KNTw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1470ca59107f4e46$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $1470ca59107f4e46$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    var shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    var _useState = (0, $1oC0p.useState)(Boolean(shouldCheckWidth)), _useState2 = (0, $2qaZZ.default)(_useState, 2), hasOverflow = _useState2[0], setOverflow = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $2qaZZ.default)(_useState3, 2), showTooltip = _useState4[0], setShowTooltip = _useState4[1];
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $1oC0p.useEffect)(function() {
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            var shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            var shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("8iGW0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $60b14f0f0969cd0d$export$2e2bcd8739ae039; });
/* breadcrumbs.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $gnQ3X = parcelRequire("gnQ3X");

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $4hQ8o = parcelRequire("4hQ8o");

var $ceF4b = parcelRequire("ceF4b");

var $kPutE = parcelRequire("kPutE");

var $7uNuF = parcelRequire("7uNuF");

var $6ur0l = parcelRequire("6ur0l");

var $9C3lz = parcelRequire("9C3lz");

var $39aYD = parcelRequire("39aYD");

var $h7Ki0 = parcelRequire("h7Ki0");

var $5jIzU = parcelRequire("5jIzU");

var $bcLWE = parcelRequire("bcLWE");

var $kLlT5 = parcelRequire("kLlT5");
var $60b14f0f0969cd0d$var$_excluded = [
    "analyticsContext",
    "children",
    "createAnalyticsEvent",
    "defaultExpanded",
    "ellipsisLabel",
    "isExpanded",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "label",
    "maxItems",
    "onExpand",
    "size",
    "testId"
];
function $60b14f0f0969cd0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $60b14f0f0969cd0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $60b14f0f0969cd0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $60b14f0f0969cd0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $60b14f0f0969cd0d$var$defaultMaxItems = 8;
var $60b14f0f0969cd0d$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
var $60b14f0f0969cd0d$var$defaultEllipsisLabel = 'Show more breadcrumbs';
var $60b14f0f0969cd0d$var$toArray = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.toArray;
var $60b14f0f0969cd0d$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "@atlaskit/breadcrumbs",
    packageVersion: "17.6.0"
};
var $60b14f0f0969cd0d$var$noop = (0, $7uNuF.default);
var $60b14f0f0969cd0d$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
var $60b14f0f0969cd0d$var$breadcrumbStylesOld = null;
var $60b14f0f0969cd0d$var$breadcrumbStylesNew = null;
var $60b14f0f0969cd0d$var$navStylesNew = null;
var $60b14f0f0969cd0d$var$ellipsisItemWrapperStyles = null;
// items will get collapsed into ellipsis dropdown
// therefore they are no longer rendered in the DOM
// they need to be passed in to the dropdown
function $60b14f0f0969cd0d$var$getItemProps(child) {
    var _ref = child.props, text = _ref.text, href = _ref.href, onClick = _ref.onClick, target = _ref.target;
    var wrappedOnClick = onClick ? function(event) {
        // Collapsed dropdown items can be activated via keyboard, but the
        // original BreadcrumbsItem onClick contract is mouse-based.
        if ('button' in event) onClick(event);
    } : undefined;
    return {
        text: text !== null && text !== void 0 ? text : '',
        href: href,
        onClick: wrappedOnClick,
        target: target
    };
}
function $60b14f0f0969cd0d$var$cloneBreadcrumbChild(child, index, itemCount, registerItem) {
    var _child$key;
    var isLast = index === itemCount - 1;
    var isCurrentItem = child.type === (0, $9C3lz.default);
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(child, $60b14f0f0969cd0d$var$_objectSpread({
        key: (_child$key = child.key) !== null && _child$key !== void 0 ? _child$key : index,
        _overflowRef: registerItem(index)
    }, isLast && !isCurrentItem ? {
        'aria-current': 'page'
    } : {})));
}
var $60b14f0f0969cd0d$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    if ((0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($60b14f0f0969cd0d$var$InnerBreadcrumbsNew, (0, $c9bqK.default)({}, props, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($60b14f0f0969cd0d$var$InnerBreadcrumbsOld, (0, $c9bqK.default)({}, props, {
        ref: ref
    }));
});
var $60b14f0f0969cd0d$var$InnerBreadcrumbsOld = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var _props$defaultExpande = props.defaultExpanded, defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande, isExpanded = props.isExpanded, _props$maxItems = props.maxItems, maxItems = _props$maxItems === void 0 ? $60b14f0f0969cd0d$var$defaultMaxItems : _props$maxItems, _props$itemsBeforeCol = props.itemsBeforeCollapse, itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol, _props$itemsAfterColl = props.itemsAfterCollapse, itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl, _props$children = props.children, children = _props$children === void 0 ? [] : _props$children, testId = props.testId, _props$onExpand = props.onExpand, providedExpanse = _props$onExpand === void 0 ? $60b14f0f0969cd0d$var$noop : _props$onExpand, analyticsContext = props.analyticsContext, _props$label = props.label, label = _props$label === void 0 ? $60b14f0f0969cd0d$var$defaultBreadcrumbsLabel : _props$label, _props$ellipsisLabel = props.ellipsisLabel, ellipsisLabel = _props$ellipsisLabel === void 0 ? $60b14f0f0969cd0d$var$defaultEllipsisLabel : _props$ellipsisLabel, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size;
    var _useState = (0, $1oC0p.useState)(defaultExpanded), _useState2 = (0, $2qaZZ.default)(_useState, 2), expanded = _useState2[0], setExpanse = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $2qaZZ.default)(_useState3, 2), isClickedBySpace = _useState4[0], setExpansionTrigger = _useState4[1];
    var wrapperRef = (0, $1oC0p.useRef)(null);
    var isControlled = typeof isExpanded !== 'undefined';
    var isExpansionHandled = providedExpanse !== $60b14f0f0969cd0d$var$noop;
    var shouldExpand = isControlled ? isExpanded : expanded;
    var focusFirstRevealedMemoized = (0, $1oC0p.useCallback)(function() {
        if (wrapperRef.current) {
            var listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            var interactiveElements = listItems.map(function(li) {
                return li.querySelector($60b14f0f0969cd0d$var$interactiveElementSelector);
            });
            var elementToFocus = interactiveElements[itemsBeforeCollapse];
            var firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $bcLWE.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    var handleExpansion = (0, $4hQ8o.usePlatformLeafEventHandler)($60b14f0f0969cd0d$var$_objectSpread({
        fn: function fn(event, analyticsEvent) {
            if (!isControlled) setExpanse(function(expanded) {
                return !expanded;
            });
            if (isExpansionHandled && isControlled || !isControlled) {
                var _getDocument;
                setExpansionTrigger(event.target === ((_getDocument = (0, $ceF4b.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement));
            }
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext
    }, $60b14f0f0969cd0d$var$analyticsAttributes));
    var childrenArray = $60b14f0f0969cd0d$var$toArray(children);
    var breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.map(childrenArray, function(child, index) {
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    var renderItemsWithEllipsis = function renderItemsWithEllipsis() {
        var allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        var beforeItems = allItems.slice(0, itemsBeforeCollapse);
        var afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [].concat((0, $lFOXD.default)(beforeItems), [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $39aYD.default), {
                key: "ellipsis",
                testId: testId && "".concat(testId, "--breadcrumb-ellipsis"),
                onClick: handleExpansion,
                label: ellipsisLabel
            })
        ], (0, $lFOXD.default)(afterItems));
    };
    var shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    var breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $h7Ki0.BreadcrumbsSizeProvider), {
        value: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("nav", {
        "aria-label": label,
        ref: (0, $kPutE.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("ol", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ])
    }, breadcrumbsItems)));
});
var $60b14f0f0969cd0d$var$InnerBreadcrumbsNew = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var _props$children2 = props.children, children = _props$children2 === void 0 ? [] : _props$children2, testId = props.testId, analyticsContext = props.analyticsContext, _props$label2 = props.label, label = _props$label2 === void 0 ? $60b14f0f0969cd0d$var$defaultBreadcrumbsLabel : _props$label2, _props$ellipsisLabel2 = props.ellipsisLabel, ellipsisLabel = _props$ellipsisLabel2 === void 0 ? $60b14f0f0969cd0d$var$defaultEllipsisLabel : _props$ellipsisLabel2, _props$size2 = props.size, size = _props$size2 === void 0 ? 'medium' : _props$size2, _createAnalyticsEvent = props.createAnalyticsEvent;
    var childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.toArray(children).filter(function(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).isValidElement(child);
    });
    var itemCount = childrenArray.length;
    var _useOverflowCollapse = (0, $kLlT5.default)(itemCount), collapsedIndices = _useOverflowCollapse.collapsedIndices, naturalWidthsReady = _useOverflowCollapse.naturalWidthsReady, registerItem = _useOverflowCollapse.registerItem, registerContainer = _useOverflowCollapse.registerContainer;
    var handleOverflowExpansion = (0, $4hQ8o.usePlatformLeafEventHandler)($60b14f0f0969cd0d$var$_objectSpread({
        fn: $60b14f0f0969cd0d$var$noop,
        action: 'expanded',
        analyticsData: analyticsContext
    }, $60b14f0f0969cd0d$var$analyticsAttributes));
    var collapsedItems = Array.from(collapsedIndices).sort(function(a, b) {
        return a - b;
    }).map(function(i) {
        return $60b14f0f0969cd0d$var$getItemProps(childrenArray[i]);
    });
    var renderedItems = [];
    var ellipsisInserted = false;
    childrenArray.forEach(function(child, index) {
        var isCollapsed = collapsedIndices.has(index);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("li", {
                    key: "ellipsis",
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _vchhusvi _4cvr1h6o _2lx2vrvc _1o9zidpf _1wpz1h6o _1pfhze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1h6o _14rn1rpy _aetr1n76 _8yoa1h6o"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5jIzU.default), {
                    collapsedItems: collapsedItems,
                    label: ellipsisLabel,
                    onClick: handleOverflowExpansion,
                    testId: testId && "".concat(testId, "--breadcrumb-ellipsis")
                })));
            }
            return;
        }
        renderedItems.push($60b14f0f0969cd0d$var$cloneBreadcrumbChild(child, index, itemCount, registerItem));
    });
    var measureItems = !naturalWidthsReady ? childrenArray.map(function(child, index) {
        return $60b14f0f0969cd0d$var$cloneBreadcrumbChild(child, index, itemCount, registerItem);
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $h7Ki0.BreadcrumbsSizeProvider), {
        value: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("nav", {
        "aria-label": label,
        ref: ref,
        tabIndex: -1,
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _1ul9idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("ol", {
        "data-testid": testId,
        ref: registerContainer,
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1ul9idpf _4cvr1q9y _1n261q9c _2mzuglyw _6rthidpf _1pfhidpf _12l2idpf _ahbqidpf _85i5idpf _1q51idpf _y4tiidpf _bozgidpf"
        ])
    }, naturalWidthsReady ? renderedItems : measureItems)));
});
var $60b14f0f0969cd0d$var$Breadcrumbs = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var analyticsContext = _ref2.analyticsContext, children = _ref2.children, createAnalyticsEvent = _ref2.createAnalyticsEvent, defaultExpanded = _ref2.defaultExpanded, ellipsisLabel = _ref2.ellipsisLabel, isExpanded = _ref2.isExpanded, itemsAfterCollapse = _ref2.itemsAfterCollapse, itemsBeforeCollapse = _ref2.itemsBeforeCollapse, label = _ref2.label, maxItems = _ref2.maxItems, onExpand = _ref2.onExpand, size = _ref2.size, testId = _ref2.testId, props = (0, $gnQ3X.default)(_ref2, $60b14f0f0969cd0d$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($60b14f0f0969cd0d$var$InnerBreadcrumbs, (0, $c9bqK.default)({}, props, {
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        size: size,
        ref: ref,
        testId: testId
    }));
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$60b14f0f0969cd0d$export$2e2bcd8739ae039 = $60b14f0f0969cd0d$var$Breadcrumbs;

});
parcelRegister("9C3lz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6ffa424c7c7e5731$export$2e2bcd8739ae039; });
/* breadcrumbs-current-item.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hbE8q = parcelRequire("hbE8q");

var $kPutE = parcelRequire("kPutE");

var $7uNuF = parcelRequire("7uNuF");

var $deg4B = parcelRequire("deg4B");

var $6ur0l = parcelRequire("6ur0l");

var $k03fP = parcelRequire("k03fP");

var $9HmsN = parcelRequire("9HmsN");

var $1KNTw = parcelRequire("1KNTw");
var $6ffa424c7c7e5731$var$_excluded = [
    "ref",
    "testId"
];
var $6ffa424c7c7e5731$var$COPY_RESET_DELAY_MS = 2000;
var $6ffa424c7c7e5731$var$ICON_WIDTH_ESTIMATE = 24;
var $6ffa424c7c7e5731$var$VAR_CURRENT_ITEM_TRUNCATION_WIDTH = '--breadcrumbs-current-item-max-width';
var $6ffa424c7c7e5731$var$unboundedStyles = {
    container: "_zulp1b66 _2rko12b0 _1rjcv77o _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k8s _1ql7kb7n",
    interactiveContainer: "_zulp1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _11c8fhey _1e0c116y _4cvr1h6o _vchhusvi _syazi7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _9h8hi7uo",
    interactiveContainerMotion: "_v5641rrn _1hms8stv _4bfu1j28 _o7kshxmd _9oiki7uo _1ggl87vo _1nrmi7uo",
    interactiveContainerSmall: "_11c8wadc",
    interactiveContainerLegacy: "_4t3i1k8s",
    interactiveContainerWithTruncation: "_1ul9idpf _p12fmvrb _1o9zkb7n",
    itemWrapper: "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _1wpz1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
    copyButtonWrapper: "_1e0c116y _tzy4idpf _gwqekb7n _1mygkb7n",
    iconWrapper: "_syaz1cv2",
    iconWrapperSmall: "_w8l57vkz _17527vkz"
};
var $6ffa424c7c7e5731$var$styles = {
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperExternal: "_12l2v77o",
    iconWrapperExternalSmall: "_12l2ze3t",
    text: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textSmall: "_11c8wadc _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
var $6ffa424c7c7e5731$var$BreadcrumbsCurrentItem = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var text = _ref.text, href = _ref.href, elemBefore = _ref.elemBefore, iconBefore = _ref.iconBefore, truncationWidth = _ref.truncationWidth, testId = _ref.testId, onCopyLink = _ref.onCopyLink, onTooltipShown = _ref.onTooltipShown, _overflowRef = _ref._overflowRef;
    var isSmall = (0, $9HmsN.useBreadcrumbsSize)() === 'small';
    var resolvedElemBefore = elemBefore !== null && elemBefore !== void 0 ? elemBefore : iconBefore;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), copied = _useState2[0], setCopied = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(null), _useState4 = (0, $2qaZZ.default)(_useState3, 2), linkElement = _useState4[0], setLinkElement = _useState4[1];
    var resetTimerRef = (0, $1oC0p.useRef)(null);
    var setLinkRef = (0, $1oC0p.useCallback)(function(element) {
        setLinkElement(element);
    }, []);
    var _useOverflowable = (0, $1KNTw.default)(truncationWidth, linkElement, (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') ? 0 : resolvedElemBefore ? $6ffa424c7c7e5731$var$ICON_WIDTH_ESTIMATE : 0), _useOverflowable2 = (0, $2qaZZ.default)(_useOverflowable, 2), shouldShowTooltip = _useOverflowable2[1];
    var handleCopy = (0, $1oC0p.useCallback)(function() {
        if (!navigator.clipboard) return;
        var url = new URL(href, window.location.href).href;
        navigator.clipboard.writeText(url).then(function() {
            setCopied(true);
            onCopyLink === null || onCopyLink === void 0 || onCopyLink();
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            resetTimerRef.current = setTimeout(function() {
                setCopied(false);
            }, $6ffa424c7c7e5731$var$COPY_RESET_DELAY_MS);
        }, (0, $7uNuF.default));
    }, [
        href,
        onCopyLink
    ]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
        };
    }, []);
    var iconElement = resolvedElemBefore && /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId && "".concat(testId, "--icon-before"),
        className: (0, $2jatx.default)([
            $6ffa424c7c7e5731$var$styles.iconWrapper,
            $6ffa424c7c7e5731$var$unboundedStyles.iconWrapper,
            (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && $6ffa424c7c7e5731$var$styles.iconWrapperExternal,
            isSmall && $6ffa424c7c7e5731$var$styles.iconWrapperExternalSmall,
            isSmall && $6ffa424c7c7e5731$var$unboundedStyles.iconWrapperSmall
        ])
    }, resolvedElemBefore);
    var textElement = /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            isSmall && $6ffa424c7c7e5731$var$styles.textSmall,
            !isSmall && $6ffa424c7c7e5731$var$styles.text,
            truncationWidth && $6ffa424c7c7e5731$var$styles.textWithTruncation
        ])
    }, text);
    var renderLink = function renderLink(triggerProps) {
        var _ref2 = triggerProps !== null && triggerProps !== void 0 ? triggerProps : {}, tooltipRef = _ref2.ref, _testId = _ref2.testId, tooltipTriggerProps = (0, $gnQ3X.default)(_ref2, $6ffa424c7c7e5731$var$_excluded);
        return /*#__PURE__*/ $1oC0p.createElement("a", (0, $c9bqK.default)({
            href: href,
            "aria-current": "page",
            "data-testid": testId,
            ref: tooltipRef ? (0, $kPutE.default)([
                setLinkRef,
                tooltipRef
            ]) : setLinkRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: truncationWidth ? {
                '--breadcrumbs-current-item-max-width': "".concat(truncationWidth, "px")
            } : undefined
        }, tooltipTriggerProps, {
            className: (0, $2jatx.default)([
                $6ffa424c7c7e5731$var$unboundedStyles.interactiveContainer,
                !(0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && $6ffa424c7c7e5731$var$unboundedStyles.interactiveContainerLegacy,
                isSmall && $6ffa424c7c7e5731$var$unboundedStyles.interactiveContainerSmall,
                truncationWidth && $6ffa424c7c7e5731$var$unboundedStyles.interactiveContainerWithTruncation,
                (0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') && $6ffa424c7c7e5731$var$unboundedStyles.interactiveContainerMotion
            ])
        }), !(0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && iconElement, textElement);
    };
    var copyButton = /*#__PURE__*/ $1oC0p.createElement((0, $k03fP.default), {
        content: copied ? 'Copied!' : 'Copy link',
        position: "bottom"
    }, function(tooltipProps) {
        return /*#__PURE__*/ $1oC0p.createElement("span", {
            "data-breadcrumbs-copy-link": true,
            "data-copied": copied || undefined,
            className: (0, $2jatx.default)([
                $6ffa424c7c7e5731$var$unboundedStyles.copyButtonWrapper
            ])
        }, /*#__PURE__*/ $1oC0p.createElement((0, $hbE8q.default), (0, $c9bqK.default)({}, tooltipProps, {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($deg4B))),
            isTooltipDisabled: true,
            label: copied ? 'Link copied' : 'Copy link',
            onClick: handleCopy,
            spacing: "compact",
            testId: testId && "".concat(testId, "--copy-link")
        })));
    });
    return /*#__PURE__*/ $1oC0p.createElement("li", {
        ref: _overflowRef,
        "data-breadcrumbs-current-item": true,
        className: (0, $2jatx.default)([
            $6ffa424c7c7e5731$var$unboundedStyles.itemWrapper
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            $6ffa424c7c7e5731$var$unboundedStyles.container
        ])
    }, (0, $6ur0l.fg)('platform_dst_breadcrumbs-refresh') && iconElement, shouldShowTooltip ? /*#__PURE__*/ $1oC0p.createElement((0, $k03fP.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, renderLink) : renderLink(), copyButton));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6ffa424c7c7e5731$export$2e2bcd8739ae039 = $6ffa424c7c7e5731$var$BreadcrumbsCurrentItem;

});
parcelRegister("deg4B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2795fc1ebee30d2a3977d5783012a5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a190cfac3d772e7$var$_react = $9a190cfac3d772e7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9a190cfac3d772e7$var$_iconNew = $9a190cfac3d772e7$var$_interopRequireDefault((parcelRequire("fBroF")));
function $9a190cfac3d772e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link
 * Usage guidance:
 * Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a190cfac3d772e7$var$LinkIcon = (props)=>/*#__PURE__*/ $9a190cfac3d772e7$var$_react.default.createElement($9a190cfac3d772e7$var$_iconNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$9a190cfac3d772e7$var$LinkIcon.displayName = 'LinkIcon';
var $9a190cfac3d772e7$var$_default = module.exports.default = $9a190cfac3d772e7$var$LinkIcon;

});


parcelRegister("39aYD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24aaba25ca0d51cf$export$2e2bcd8739ae039; });
/* ellipsis-item.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $4ZpaI = parcelRequire("4ZpaI");

var $7uNuF = parcelRequire("7uNuF");

var $6ur0l = parcelRequire("6ur0l");

var $eowPk = parcelRequire("eowPk");

var $9HmsN = parcelRequire("9HmsN");
var $24aaba25ca0d51cf$var$noop = (0, $7uNuF.default);
var $24aaba25ca0d51cf$var$itemWrapperStyles = null;
var $24aaba25ca0d51cf$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1wpz1h6o _1pfhze3t _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc",
    interactiveMotion: "_v564hxmd _1hms8stv _4bfu1j28 _o7kshxmd _9oik1rpy _1ggl87vo _1nrmi7uo"
};
var $24aaba25ca0d51cf$var$EllipsisItem = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var label = _ref.label, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? $24aaba25ca0d51cf$var$noop : _ref$onClick, testId = _ref.testId;
    var breadcrumbsSize = (0, $9HmsN.useBreadcrumbsSize)();
    var isSmall = breadcrumbsSize === 'small';
    return /*#__PURE__*/ $1oC0p.createElement("li", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3i59ms _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ]),
        style: {
            "--_1fdrbou": (0, $6ZVlx.default)("".concat(24 / 14, "em"))
        }
    }, /*#__PURE__*/ $1oC0p.createElement((0, $eowPk.Pressable), {
        "aria-label": label,
        onClick: onClick,
        xcss: (0, $4ZpaI.cx)($24aaba25ca0d51cf$var$styles.root, isSmall && $24aaba25ca0d51cf$var$styles.rootSmall, (0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') && $24aaba25ca0d51cf$var$styles.interactiveMotion),
        testId: testId
    }, "\u2026"));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$24aaba25ca0d51cf$export$2e2bcd8739ae039 = $24aaba25ca0d51cf$var$EllipsisItem;

});

parcelRegister("h7Ki0", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbsSizeProvider", function () { return $c776ff35e28865d5$export$2295e777093f3940; });

var $3zYsU = parcelRequire("3zYsU");
var $c776ff35e28865d5$export$2295e777093f3940 = (0, $3zYsU.default).Provider;

});

parcelRegister("5jIzU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3df14e6858be51f7$export$2e2bcd8739ae039; });
/* ellipsis-popup.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hbE8q = parcelRequire("hbE8q");

var $kQr5j = parcelRequire("kQr5j");

var $2F6JE = parcelRequire("2F6JE");

var $gydt6 = parcelRequire("gydt6");

var $9NuKL = parcelRequire("9NuKL");
var $3df14e6858be51f7$var$_excluded = [
    "triggerRef",
    "isSelected",
    "testId"
];
var $3df14e6858be51f7$var$groupWrapperStyles = null;
function $3df14e6858be51f7$export$2e2bcd8739ae039(_ref) {
    var collapsedItems = _ref.collapsedItems, label = _ref.label, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement((0, $kQr5j.default), {
        trigger: function trigger(_ref2) {
            var triggerRef = _ref2.triggerRef, isSelected = _ref2.isSelected, _triggerTestId = _ref2.testId, triggerProps = (0, $gnQ3X.default)(_ref2, $3df14e6858be51f7$var$_excluded);
            var handleClick = function handleClick(event) {
                var _triggerProps$onClick;
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                onClick === null || onClick === void 0 || onClick(event);
            };
            return /*#__PURE__*/ $1oC0p.createElement((0, $hbE8q.default), (0, $c9bqK.default)({}, triggerProps, {
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9NuKL))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            }));
        },
        placement: "bottom-start"
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            "_p12f1y37"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $gydt6.default), null, collapsedItems.map(function(item, i) {
        return /*#__PURE__*/ $1oC0p.createElement((0, $2F6JE.default), {
            key: i,
            href: item.href,
            target: item.target,
            onClick: item.onClick
        }, item.text);
    }))));
}

});
parcelRegister("kQr5j", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2cdac6920bbeb78$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $gzpW5 = parcelRequire("gzpW5");

var $lv5Ml = parcelRequire("lv5Ml");

var $kPutE = parcelRequire("kPutE");

var $7uNuF = parcelRequire("7uNuF");

var $645Xv = parcelRequire("645Xv");

var $4YraT = parcelRequire("4YraT");

var $5RBBI = parcelRequire("5RBBI");

var $3BRuV = parcelRequire("3BRuV");

var $6ur0l = parcelRequire("6ur0l");

var $l1FpZ = parcelRequire("l1FpZ");

var $i9dl0 = parcelRequire("i9dl0");

var $eZ4WW = parcelRequire("eZ4WW");

var $kYPkX = parcelRequire("kYPkX");

var $fpWNm = parcelRequire("fpWNm");

var $2Hjke = parcelRequire("2Hjke");

var $819ie = parcelRequire("819ie");

var $b2P2P = parcelRequire("b2P2P");
var $f2cdac6920bbeb78$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $f2cdac6920bbeb78$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2cdac6920bbeb78$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2cdac6920bbeb78$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2cdac6920bbeb78$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f2cdac6920bbeb78$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $f2cdac6920bbeb78$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $f2cdac6920bbeb78$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($f2cdac6920bbeb78$var$opposites[crossAxis]),
            "".concat($f2cdac6920bbeb78$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($f2cdac6920bbeb78$var$opposites[mainAxis]),
            "".concat($f2cdac6920bbeb78$var$opposites[mainAxis], "-").concat($f2cdac6920bbeb78$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($f2cdac6920bbeb78$var$opposites[mainAxis]),
        "".concat($f2cdac6920bbeb78$var$opposites[mainAxis], "-start"),
        "".concat($f2cdac6920bbeb78$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $f2cdac6920bbeb78$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $f2cdac6920bbeb78$var$DropdownMenuLegacy(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $7uNuF.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $i9dl0.layers).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel, _ref$shouldPreventEsc = _ref.shouldPreventEscapePropagation, shouldPreventEscapePropagation = _ref$shouldPreventEsc === void 0 ? false : _ref$shouldPreventEsc, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent;
    var _useControlledState = (0, $645Xv.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, $2qaZZ.default)(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $b2P2P.default)();
    var itemRef = (0, $819ie.default)();
    var _useLayering = (0, $3BRuV.useLayering)(), currentLevel = _useLayering.currentLevel;
    var fallbackPlacements = (0, $1oC0p.useMemo)(function() {
        return $f2cdac6920bbeb78$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $1oC0p.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $1oC0p.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabLeftOrEscapeKey = $f2cdac6920bbeb78$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $lv5Ml.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $f2cdac6920bbeb78$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $lv5Ml.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $b2P2P.PREFIX), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($f2cdac6920bbeb78$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $lv5Ml.KEY_LEFT))) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    var _useFocus = (0, $4YraT.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $1oC0p.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $7uNuF.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $7uNuF.default;
        return (0, $dH1HR.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $b2P2P.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, $lv5Ml.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $lv5Ml.KEY_SPACE) || e.key === (0, $lv5Ml.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $lv5Ml.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2Hjke.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $l1FpZ.Popup), (0, $c9bqK.default)({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, $gnQ3X.default)(_ref2, $f2cdac6920bbeb78$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($f2cdac6920bbeb78$var$_objectSpread($f2cdac6920bbeb78$var$_objectSpread($f2cdac6920bbeb78$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $kPutE.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gzpW5.default), (0, $c9bqK.default)({}, bindFocus, {
                ref: (0, $kPutE.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), (0, $c9bqK.default)({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kYPkX.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fpWNm.default), {
                spacing: spacing,
                maxHeight: $f2cdac6920bbeb78$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $f2cdac6920bbeb78$var$DropdownMenu = function DropdownMenu(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, _props$defaultOpen = props.defaultOpen, defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen, _props$isLoading = props.isLoading, isLoading = _props$isLoading === void 0 ? false : _props$isLoading, isOpen = props.isOpen, _props$onOpenChange = props.onOpenChange, onOpenChange = _props$onOpenChange === void 0 ? (0, $7uNuF.default) : _props$onOpenChange, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom-start' : _props$placement, _props$shouldFitConta = props.shouldFitContainer, shouldFitContainer = _props$shouldFitConta === void 0 ? false : _props$shouldFitConta, returnFocusRef = props.returnFocusRef, spacing = props.spacing, statusLabel = props.statusLabel, testId = props.testId, trigger = props.trigger, label = props.label, interactionName = props.interactionName, menuLabel = props.menuLabel;
    if ((0, $6ur0l.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eZ4WW.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($f2cdac6920bbeb78$var$DropdownMenuLegacy, props);
};
var $f2cdac6920bbeb78$export$2e2bcd8739ae039 = $f2cdac6920bbeb78$var$DropdownMenu;

});
parcelRegister("645Xv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $46a7bd1c1b940d55$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $46a7bd1c1b940d55$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $1oC0p.useState)(getDefaultPropValue), _useState2 = (0, $2qaZZ.default)(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $1oC0p.useRef)(isControlled);
    (0, $1oC0p.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $1oC0p.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("4YraT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $39f1d859301db223$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $39f1d859301db223$export$2e2bcd8739ae039() {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $1oC0p.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $1oC0p.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("5RBBI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $444f1300adfdb621$var$_react = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $444f1300adfdb621$var$_iconNew = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("fBroF")));
function $444f1300adfdb621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $444f1300adfdb621$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $444f1300adfdb621$var$_react.default.createElement($444f1300adfdb621$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$444f1300adfdb621$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $444f1300adfdb621$var$_default = module.exports.default = $444f1300adfdb621$var$ChevronDownIcon;

});

parcelRegister("3BRuV", function(module, exports) {
$parcel$export(module.exports, "useLayering", function () { return $2a0e5358e0c0ede6$export$c8b4d54e03dee6ed; });

var $1oC0p = parcelRequire("1oC0p");

var $9rPW1 = parcelRequire("9rPW1");

var $btXNJ = parcelRequire("btXNJ");

var $jFfzg = parcelRequire("jFfzg");
function $2a0e5358e0c0ede6$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $1oC0p.useContext)((0, $9rPW1.LevelContext));
    var layerNode = (0, $1oC0p.useContext)((0, $btXNJ.LevelNodeContext));
    var rootNode = (0, $1oC0p.useContext)((0, $jFfzg.RootNodeContext));
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $1oC0p.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});
parcelRegister("9rPW1", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $6e0eebdf67486dac$export$650d12d3c2ddb8fc; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $6e0eebdf67486dac$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);

});

parcelRegister("btXNJ", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", function () { return $85c0ca6976f7aa47$export$18f4d8b5b3a77f59; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $85c0ca6976f7aa47$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});

});

parcelRegister("jFfzg", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", function () { return $e50dec19652a45ff$export$fa973f110e8f6ca8; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $e50dec19652a45ff$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});

});


parcelRegister("l1FpZ", function(module, exports) {
$parcel$export(module.exports, "Popup", function () { return $f4e9d1bbd8c1c15c$export$129a32eedafa97c5; });
/* popup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");


var $4UF4U = parcelRequire("4UF4U");

var $98rDL = parcelRequire("98rDL");

var $9DwrQ = parcelRequire("9DwrQ");

var $3sKC0 = parcelRequire("3sKC0");

var $6ur0l = parcelRequire("6ur0l");

var $koJWX = parcelRequire("koJWX");

var $dlrsS = parcelRequire("dlrsS");

var $bnqXT = parcelRequire("bnqXT");

var $2sVl0 = parcelRequire("2sVl0");

var $bfTZw = parcelRequire("bfTZw");

var $a3nRU = parcelRequire("a3nRU");

var $6uqkr = parcelRequire("6uqkr");

var $izeje = parcelRequire("izeje");

var $2LdZF = parcelRequire("2LdZF");
var $f4e9d1bbd8c1c15c$var$defaultLayer = 400;
var $f4e9d1bbd8c1c15c$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $f4e9d1bbd8c1c15c$var$PopupLegacy = function PopupLegacy(props) {
    var xcss = props.xcss, _props$appearance = props.appearance, inAppearance = _props$appearance === void 0 ? 'default' : _props$appearance, isOpen = props.isOpen, providedId = props.id, offset = props.offset, testId = props.testId, trigger = props.trigger, content = props.content, onClose = props.onClose, boundary = props.boundary, _props$rootBoundary = props.rootBoundary, rootBoundary = _props$rootBoundary === void 0 ? 'viewport' : _props$rootBoundary, _props$shouldFlip = props.shouldFlip, shouldFlip = _props$shouldFlip === void 0 ? true : _props$shouldFlip, _props$placement = props.placement, placement = _props$placement === void 0 ? 'auto' : _props$placement, fallbackPlacements = props.fallbackPlacements, PopupContainer = props.popupComponent, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$zIndex = props.zIndex, zIndex = _props$zIndex === void 0 ? $f4e9d1bbd8c1c15c$var$defaultLayer : _props$zIndex, _props$shouldUseCaptu = props.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _props$shouldUseCaptu === void 0 ? false : _props$shouldUseCaptu, shouldIgnoreCloseEvent = props.shouldIgnoreCloseEvent, _props$shouldRenderTo = props.shouldRenderToParent, inShouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, _props$shouldFitConta = props.shouldFitContainer, shouldFitContainer = _props$shouldFitConta === void 0 ? false : _props$shouldFitConta, _props$shouldDisableF = props.shouldDisableFocusLock, shouldDisableFocusLock = _props$shouldDisableF === void 0 ? false : _props$shouldDisableF, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, strategy = props.strategy, role = props.role, label = props.label, titleId = props.titleId, modifiers = props.modifiers, shouldFitViewport = props.shouldFitViewport;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $izeje.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $2LdZF.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $4UF4U.useId)();
    var _usePopupAppearance = (0, $6uqkr.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $9DwrQ.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    var xcssPassthrough = {
        value: xcss
    };
    var renderPopperWrapper = /*#__PURE__*/ $1oC0p.createElement((0, $98rDL.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $1oC0p.createElement((0, $bfTZw.default), {
        xcss: xcssPassthrough.value,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        zIndex: zIndex,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $1oC0p.createElement((0, $koJWX.Manager), null, /*#__PURE__*/ $1oC0p.createElement((0, $dlrsS.Reference), null, function(_ref) {
        var ref = _ref.ref;
        return trigger({
            ref: !(0, $6ur0l.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $6ur0l.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), !(0, $6ur0l.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $1oC0p.createElement((0, $bnqXT.default), {
        zIndex: zIndex
    }, renderPopperWrapper)), (0, $6ur0l.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ $1oC0p.createElement((0, $3sKC0.default), {
        appear: true
    }, isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $1oC0p.createElement((0, $bnqXT.default), {
        zIndex: zIndex
    }, renderPopperWrapper))));
    if (shouldFitContainer) return /*#__PURE__*/ $1oC0p.createElement((0, $2sVl0.Box), {
        xcss: $f4e9d1bbd8c1c15c$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
};
var $f4e9d1bbd8c1c15c$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $1oC0p.memo)(function(props) {
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $6ur0l.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ $1oC0p.createElement((0, $a3nRU.PopupTopLayer), props);
    return /*#__PURE__*/ $1oC0p.createElement($f4e9d1bbd8c1c15c$var$PopupLegacy, props);
});

});
parcelRegister("98rDL", function(module, exports) {
$parcel$export(module.exports, "Layering", function () { return $6a6a4d3121d1496a$export$7c885f891c940977; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");

var $fOWCj = parcelRequire("fOWCj");

var $14UFy = parcelRequire("14UFy");

var $lR5og = parcelRequire("lR5og");

var $d7VLy = parcelRequire("d7VLy");
var $6a6a4d3121d1496a$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $1oC0p.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $14UFy.LevelContext).Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lR5og.LevelNodeContext).Provider, {
        value: levelNode
    }, children));
};
var $6a6a4d3121d1496a$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $1oC0p.useContext)((0, $14UFy.LevelContext));
    var parentNode = (0, $1oC0p.useContext)((0, $lR5og.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $1oC0p.useRef)(new (0, $fOWCj.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($6a6a4d3121d1496a$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $d7VLy.RootNodeContext).Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("fOWCj", function(module, exports) {
$parcel$export(module.exports, "LayerNode", function () { return $b848fea1a6e8e18c$export$da4f61fd78d35243; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");
var $b848fea1a6e8e18c$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, $cTewU.default)(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, $avOEA.default)(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, $lFOXD.default)(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});

parcelRegister("14UFy", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $0c921f7addf26ff2$export$650d12d3c2ddb8fc; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $0c921f7addf26ff2$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);

});

parcelRegister("lR5og", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", function () { return $fe92ba9b11da32e0$export$18f4d8b5b3a77f59; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $fe92ba9b11da32e0$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});

});

parcelRegister("d7VLy", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", function () { return $98e8bcf3608b5787$export$fa973f110e8f6ca8; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $98e8bcf3608b5787$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});

});


parcelRegister("9DwrQ", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $7040ed1e11dcb11b$export$469bb693f11edc7f; });

var $1oC0p = parcelRequire("1oC0p");

var $ibFuB = parcelRequire("ibFuB");

var $fDqlQ = parcelRequire("fDqlQ");
function $7040ed1e11dcb11b$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $1oC0p.useContext)((0, $ibFuB.OpenLayerObserverContext));
    var namespace = (0, $fDqlQ.useOpenLayerObserverNamespace)();
    (0, $1oC0p.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("ibFuB", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $d3d970a6571f3731$export$5fbf4d7fae6cdc00; });

var $1oC0p = parcelRequire("1oC0p");
var $d3d970a6571f3731$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("fDqlQ", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $b61ef05bf9f9f6a0$export$1d57e79091cc3046; });

var $1oC0p = parcelRequire("1oC0p");

var $fKek8 = parcelRequire("fKek8");
function $b61ef05bf9f9f6a0$export$1d57e79091cc3046() {
    var namespace = (0, $1oC0p.useContext)((0, $fKek8.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("fKek8", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $b766434eb566908b$export$644a49f3b8c50fcd; });

var $1oC0p = parcelRequire("1oC0p");
var $b766434eb566908b$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});



parcelRegister("3sKC0", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", function () { return $285824ceb8e13663$export$b9c4904d7a6929e6; });
$parcel$export(module.exports, "default", function () { return $285824ceb8e13663$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $285824ceb8e13663$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $285824ceb8e13663$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $1oC0p.createContext)($285824ceb8e13663$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $285824ceb8e13663$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $285824ceb8e13663$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($285824ceb8e13663$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $285824ceb8e13663$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1oC0p.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $285824ceb8e13663$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $285824ceb8e13663$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $285824ceb8e13663$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $285824ceb8e13663$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $285824ceb8e13663$var$ExitingPersistence = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $1oC0p.useState)([
        null,
        children
    ]), _useState2 = (0, $2qaZZ.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)([]), _useState4 = (0, $2qaZZ.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $1oC0p.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $2qaZZ.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $285824ceb8e13663$var$childrenToArray(previousChildren);
    var current = $285824ceb8e13663$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $285824ceb8e13663$var$childrenToArray(children) : current;
    var missingKeys = $285824ceb8e13663$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $285824ceb8e13663$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $6ur0l.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $285824ceb8e13663$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $285824ceb8e13663$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$285824ceb8e13663$export$2e2bcd8739ae039 = $285824ceb8e13663$var$ExitingPersistence;
$285824ceb8e13663$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("koJWX", function(module, exports) {
$parcel$export(module.exports, "Manager", function () { return $ed99b139b8c567b0$export$d0d38e7dec7a1a61; });

var $1oC0p = parcelRequire("1oC0p");

var $8q4Jo = parcelRequire("8q4Jo");

var $YWDnS = parcelRequire("YWDnS");

var $ei2t8 = parcelRequire("ei2t8");

var $bWueW = parcelRequire("bWueW");
function $ed99b139b8c567b0$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    var _useAnchorState = (0, $bWueW.useAnchorState)(), anchor = _useAnchorState.anchor, setAnchor = _useAnchorState.setAnchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8q4Jo.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ei2t8.AnchorSetterContext).Provider, {
        value: setAnchor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $YWDnS.AnchorContext).Provider, {
        value: anchor
    }, children)));
}

});
parcelRegister("ei2t8", function(module, exports) {
$parcel$export(module.exports, "AnchorSetterContext", function () { return $a674a96bd77096f0$export$804169e6eecdff16; });

var $1oC0p = parcelRequire("1oC0p");
var $a674a96bd77096f0$export$804169e6eecdff16 = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return undefined;
});

});

parcelRegister("bWueW", function(module, exports) {
$parcel$export(module.exports, "useAnchorState", function () { return $8b1c918adb89d611$export$1b1b50fdcd7ac375; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $8b1c918adb89d611$export$1b1b50fdcd7ac375() {
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), anchor = _useState2[0], setAnchor = _useState2[1];
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}

});


parcelRegister("dlrsS", function(module, exports) {
$parcel$export(module.exports, "Reference", function () { return $9b728a74d4c7bd6e$export$e0be378c32fb70a7; });

var $1oC0p = parcelRequire("1oC0p");

var $kUCSO = parcelRequire("kUCSO");

var $kPutE = parcelRequire("kPutE");

var $1d2it = parcelRequire("1d2it");
function $9b728a74d4c7bd6e$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var publishAnchor = (0, $1d2it.useManagerAnchorSetter)();
    var composedRef = (0, $1oC0p.useMemo)(function() {
        return (0, $kPutE.default)([
            publishAnchor,
            innerRef
        ]);
    }, [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kUCSO.Reference), {
        innerRef: composedRef
    }, children);
}

});
parcelRegister("1d2it", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchorSetter", function () { return $0e18c97bc9cd8d99$export$fcdda419d7091b3; });

var $1oC0p = parcelRequire("1oC0p");

var $ei2t8 = parcelRequire("ei2t8");
function $0e18c97bc9cd8d99$export$fcdda419d7091b3() {
    return (0, $1oC0p.useContext)((0, $ei2t8.AnchorSetterContext));
}

});


parcelRegister("bnqXT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8486c25b7199101f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $6oPnU = parcelRequire("6oPnU");

var $aDKLH = parcelRequire("aDKLH");

var $bEQX9 = parcelRequire("bEQX9");

var $jzpEB = parcelRequire("jzpEB");
function $8486c25b7199101f$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $bEQX9.default)(mountStrategy);
    (0, $jzpEB.default)(zIndex);
    return !(0, $6ur0l.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6oPnU.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $aDKLH.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("6oPnU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4a8cd7e79c334806$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $dTp91 = parcelRequire("dTp91");

var $iHhIT = parcelRequire("iHhIT");

var $9w0sl = parcelRequire("9w0sl");

var $2ZcrA = parcelRequire("2ZcrA");

var $1tAhj = parcelRequire("1tAhj");

var $hJRJg = parcelRequire("hJRJg");
function $4a8cd7e79c334806$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $1oC0p.useMemo)(function() {
        return (0, $1tAhj.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $iHhIT.useColorMode)();
    var isInsideThemeProvider = (0, $9w0sl.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $2ZcrA.appendPortalContainerIfNotAppended)(container);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            (0, $hJRJg.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dTp91.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("dTp91", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", function () { return $a1d3ea96e54efb91$export$d8964aec282183a3; });
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $cn8ql = parcelRequire("cn8ql");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2jatx = parcelRequire("2jatx");

var $5Cxn4 = parcelRequire("5Cxn4");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $6ur0l = parcelRequire("6ur0l");

var $jiPXk = parcelRequire("jiPXk");

var $lBlwk = parcelRequire("lBlwk");

var $9Fplq = parcelRequire("9Fplq");

var $cQjEj = parcelRequire("cQjEj");

var $cPe1A = parcelRequire("cPe1A");

var $38t7R = parcelRequire("38t7R");

var $dWnxz = parcelRequire("dWnxz");

var $d9KJa = parcelRequire("d9KJa");

var $caw1n = parcelRequire("caw1n");

var $9w0sl = parcelRequire("9w0sl");

var $7Gtqt = parcelRequire("7Gtqt");

var $6Nq1z = parcelRequire("6Nq1z");
function $a1d3ea96e54efb91$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1d3ea96e54efb91$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1d3ea96e54efb91$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1d3ea96e54efb91$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a1d3ea96e54efb91$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography'
};
var $a1d3ea96e54efb91$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $a1d3ea96e54efb91$var$prefersDarkModeMql = $a1d3ea96e54efb91$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $a1d3ea96e54efb91$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $a1d3ea96e54efb91$var$prefersDarkModeMql !== null && $a1d3ea96e54efb91$var$prefersDarkModeMql !== void 0 && $a1d3ea96e54efb91$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $a1d3ea96e54efb91$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $a1d3ea96e54efb91$export$d8964aec282183a3(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $1oC0p.useState)(defaultColorMode), _useState2 = (0, $2qaZZ.default)(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)($a1d3ea96e54efb91$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, $2qaZZ.default)(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return $a1d3ea96e54efb91$var$_objectSpread($a1d3ea96e54efb91$var$_objectSpread({}, $a1d3ea96e54efb91$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var _useState7 = (0, $1oC0p.useState)(false), _useState8 = (0, $2qaZZ.default)(_useState7, 2), hasHoistedInlineThemeStyles = _useState8[0], setHasHoistedInlineThemeStyles = _useState8[1];
    var setColorMode = (0, $1oC0p.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($a1d3ea96e54efb91$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $1oC0p.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $a1d3ea96e54efb91$var$_objectSpread($a1d3ea96e54efb91$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $1oC0p.useRef)(null);
    var isInsideAppProvider = (0, $cPe1A.useIsInsideAppProvider)();
    var isAppProviderThemingEnabled = (0, $cQjEj.useIsAppProviderThemingEnabled)();
    var isInsideThemeProvider = (0, $9w0sl.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $1oC0p.useLayoutEffect)(function() {
        if (!(0, $6ur0l.fg)('platform-static-theme-loading') || hasHoistedInlineThemeStyles) return;
        (0, $7Gtqt.getInlineThemeStyles)(theme, chosenColorMode).forEach(function(_ref2) {
            var id = _ref2.id, css = _ref2.css;
            if (document.head.querySelector("style[data-theme=\"".concat(id, "\"]"))) return;
            var style = document.createElement('style');
            style.dataset.theme = id;
            style.textContent = css;
            document.head.appendChild(style);
        });
        setHasHoistedInlineThemeStyles(true);
    }, [
        chosenColorMode,
        hasHoistedInlineThemeStyles,
        theme
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return lastSetGlobalThemePromiseRef.current;
                            case 1:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref3.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref4 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return cleanupLastFnCall();
                            case 1:
                                promise = (0, $9Fplq.setGlobalTheme)($a1d3ea96e54efb91$var$_objectSpread($a1d3ea96e54efb91$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref4.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        }
        // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $6Nq1z.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!$a1d3ea96e54efb91$var$prefersDarkModeMql) return;
        var unbindListener = (0, $dH1HR.bind)($a1d3ea96e54efb91$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $a1d3ea96e54efb91$var$_objectSpread($a1d3ea96e54efb91$var$_objectSpread({}, (0, $lBlwk.getThemeHtmlAttrs)($a1d3ea96e54efb91$var$_objectSpread($a1d3ea96e54efb91$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, $f53LC.default)({}, (0, $jiPXk.SUBTREE_THEME_ATTRIBUTE), true));
    var inlineThemeStyles = (0, $6ur0l.fg)('platform-static-theme-loading') && !hasHoistedInlineThemeStyles ? (0, $7Gtqt.getInlineThemeStyles)(theme, chosenColorMode) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dWnxz.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $38t7R.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $d9KJa.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $caw1n.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $caw1n.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", (0, $c9bqK.default)({}, attrs, {
        className: (0, $2jatx.default)([
            $a1d3ea96e54efb91$var$contentStyles.body
        ])
    }), inlineThemeStyles.map(function(_ref5) {
        var id = _ref5.id, css = _ref5.css;
        return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
        (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("style", {
            "data-theme": id,
            key: id
        }, css));
    }), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, inlineThemeStyles.map(function(_ref6) {
        var id = _ref6.id, css = _ref6.css;
        return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
        (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("style", {
            "data-theme": id,
            key: id
        }, css));
    }), children))))));
}

});
parcelRegister("jiPXk", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $e0d8001babbf2941$export$4ef52930e33717cd; });
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", function () { return $e0d8001babbf2941$export$cb374d25ded7f6ab; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $e0d8001babbf2941$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $e0d8001babbf2941$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $e0d8001babbf2941$export$352e418ed5b6193a; });
var $e0d8001babbf2941$export$4ef52930e33717cd = 'data-theme';
var $e0d8001babbf2941$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $e0d8001babbf2941$export$a00eac3f8684bcd0 = 'data-color-mode';
var $e0d8001babbf2941$export$2112803007239c61 = 'data-contrast-mode';
var $e0d8001babbf2941$export$352e418ed5b6193a = 'data-custom-theme';
var $e0d8001babbf2941$export$6f0c6fb8c80fcc92 = 'ds';
var $e0d8001babbf2941$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $e0d8001babbf2941$export$dddac1532e822863 = "--".concat($e0d8001babbf2941$export$6f0c6fb8c80fcc92, "-token-not-found");
var $e0d8001babbf2941$export$9d7b58831ae93caa = "--".concat($e0d8001babbf2941$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("lBlwk", function(module, exports) {
$parcel$export(module.exports, "getThemeHtmlAttrs", function () { return $fb9dbf2fa3c58118$export$e1f80cb7a749802f; });
$parcel$export(module.exports, "default", function () { return $fb9dbf2fa3c58118$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");

var $jiPXk = parcelRequire("jiPXk");

var $ezqcI = parcelRequire("ezqcI");

var $3SdOY = parcelRequire("3SdOY");

var $a1cUl = parcelRequire("a1cUl");

var $lwEVe = parcelRequire("lwEVe");
function $fb9dbf2fa3c58118$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb9dbf2fa3c58118$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb9dbf2fa3c58118$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb9dbf2fa3c58118$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fb9dbf2fa3c58118$var$defaultColorMode = 'light';
var $fb9dbf2fa3c58118$var$defaultContrastMode = 'no-preference';
var $fb9dbf2fa3c58118$export$e1f80cb7a749802f = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $3SdOY.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $3SdOY.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $3SdOY.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $3SdOY.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $3SdOY.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $3SdOY.themeStateDefaults)['shape'] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $3SdOY.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $3SdOY.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $3SdOY.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $ezqcI.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, $f53LC.default)((0, $f53LC.default)({}, (0, $jiPXk.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $jiPXk.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $fb9dbf2fa3c58118$var$defaultColorMode : colorMode);
    if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) result = $fb9dbf2fa3c58118$var$_objectSpread($fb9dbf2fa3c58118$var$_objectSpread({}, result), {}, (0, $f53LC.default)({}, (0, $jiPXk.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $fb9dbf2fa3c58118$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $lwEVe.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $a1cUl.hash)(optionString);
        result[0, $jiPXk.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $fb9dbf2fa3c58118$export$2e2bcd8739ae039 = $fb9dbf2fa3c58118$export$e1f80cb7a749802f;

});
parcelRegister("ezqcI", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", function () { return $a9b8a928f305d345$export$62c37ab81302621a; });

var $2zYm4 = parcelRequire("2zYm4");

var $2qaZZ = parcelRequire("2qaZZ");

var $knQgD = parcelRequire("knQgD");

var $lJYVo = parcelRequire("lJYVo");

var $keoD2 = parcelRequire("keoD2");
var $a9b8a928f305d345$var$customThemeOptions = 'UNSAFE_themeOptions';
var $a9b8a928f305d345$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $knQgD.isColorMode)(id) || // custom theme state
        kind === $a9b8a928f305d345$var$customThemeOptions && (0, $2zYm4.default)(id) === 'object' || // other theme states
        (0, $keoD2.isThemeKind)(kind) && typeof id === 'string' && (0, $lJYVo.isThemeIds)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $2zYm4.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});
parcelRegister("knQgD", function(module, exports) {
$parcel$export(module.exports, "isColorMode", function () { return $ed6e7fd2f305dfd8$export$4a14e169b1de4ee7; });
var $ed6e7fd2f305dfd8$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("lJYVo", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", function () { return $fd3d0f55e8307add$export$ea35b8958c39dd07; });

var $cVutf = parcelRequire("cVutf");
var $fd3d0f55e8307add$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $cVutf.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("cVutf", function(module, exports) {
$parcel$export(module.exports, "themeIds", function () { return $969271c3c34e711a$export$7d43e72a58e3283f; });
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $969271c3c34e711a$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("keoD2", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", function () { return $eba8382da9e8f7db$export$958fa026be3a263e; });
var $eba8382da9e8f7db$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $eba8382da9e8f7db$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $eba8382da9e8f7db$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});


parcelRegister("3SdOY", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", function () { return $2d2122d59341d517$export$9aedcfa7336a207; });
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $2d2122d59341d517$var$getMotionDefault() {
    return 'motion';
}
var $2d2122d59341d517$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography',
    motion: $2d2122d59341d517$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("a1cUl", function(module, exports) {
$parcel$export(module.exports, "hash", function () { return $74b4029eb7ff5374$export$d6af199866bfb566; });
var $74b4029eb7ff5374$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("lwEVe", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", function () { return $fabc5467265a8a58$export$53031ac1ecb71f44; });
var $fabc5467265a8a58$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};

});


parcelRegister("9Fplq", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", function () { return $01d0f619ea5f1f38$export$fd7e0dd2b74807f7; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $6ur0l = parcelRequire("6ur0l");

var $jng4I = parcelRequire("jng4I");

var $3SdOY = parcelRequire("3SdOY");

var $50Xx4 = parcelRequire("50Xx4");

var $13MvN = parcelRequire("13MvN");

var $dXhhs = parcelRequire("dXhhs");

var $aslni = parcelRequire("aslni");

var $lwEVe = parcelRequire("lwEVe");

var $ik1LR = parcelRequire("ik1LR");

var $4ZwzG = parcelRequire("4ZwzG");
function $01d0f619ea5f1f38$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $01d0f619ea5f1f38$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $01d0f619ea5f1f38$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $01d0f619ea5f1f38$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $01d0f619ea5f1f38$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $01d0f619ea5f1f38$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $01d0f619ea5f1f38$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $01d0f619ea5f1f38$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $01d0f619ea5f1f38$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $01d0f619ea5f1f38$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $01d0f619ea5f1f38$export$fd7e0dd2b74807f7 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, themeOverridePreferences, overrideThemeCssLoadingTasks, mode, attrOfMissingCustomStyles, _iterator, _step, themeId, overrideThemeCss, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($01d0f619ea5f1f38$var$_objectSpread($01d0f619ea5f1f38$var$_objectSpread({}, (0, $3SdOY.themeStateDefaults)), {}, {
                        typography: (0, $3SdOY.themeStateDefaults)['typography'],
                        shape: (0, $3SdOY.themeStateDefaults)['shape'],
                        motion: (0, $3SdOY.themeStateDefaults)['motion']()
                    }, (0, $jng4I.getGlobalTheme)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $3SdOY.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $3SdOY.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $3SdOY.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $3SdOY.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $3SdOY.themeStateDefaults)['shape'] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $3SdOY.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $3SdOY.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $3SdOY.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $3SdOY.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $6ur0l.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $aslni.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $4ZwzG.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }());
                    themeOverridePreferences = (0, $dXhhs.getThemeOverridePreferences)(themeState); // Start loading override CSS before the first await. It is appended only after the standard
                    // themes have loaded so that the override cascade order remains deterministic.
                    overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map(function(themeId) {
                        return (0, $ik1LR.loadThemeCss)(themeId);
                    }); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $lwEVe.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $3SdOY.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $13MvN.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("9dswR"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    if (!themeLoader) {
                        _context3.next = 9;
                        break;
                    }
                    _iterator = $01d0f619ea5f1f38$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    _context3.next = 11;
                    break;
                case 9:
                    _context3.next = 10;
                    return Promise.all(overrideThemeCssLoadingTasks);
                case 10:
                    overrideThemeCss = _context3.sent;
                    _context3.next = 11;
                    return Promise.all(themeOverridePreferences.map(function(themeId, index) {
                        return (0, $4ZwzG.loadAndAppendThemeCss)(themeId, overrideThemeCss[index]);
                    }));
                case 11:
                    autoUnbind = (0, $50Xx4.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 12:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("jng4I", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $e1aca27a69107784$export$813ecdf77207a053; });

var $f53LC = parcelRequire("f53LC");

var $jiPXk = parcelRequire("jiPXk");

var $lS0Y0 = parcelRequire("lS0Y0");

var $41IHR = parcelRequire("41IHR");
function $e1aca27a69107784$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e1aca27a69107784$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e1aca27a69107784$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e1aca27a69107784$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e1aca27a69107784$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $jiPXk.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $jiPXk.THEME_DATA_ATTRIBUTE)) || '';
    return $e1aca27a69107784$var$_objectSpread($e1aca27a69107784$var$_objectSpread({}, (0, $41IHR.themeStringToObject)(theme)), (0, $lS0Y0.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("lS0Y0", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", function () { return $febf641fe1830c30$export$fcfb1976c88f9f75; });

var $leZ2c = parcelRequire("leZ2c");
var $febf641fe1830c30$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $leZ2c.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("leZ2c", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $f76a3ff96cdfbadf$export$83993de8eb66733; });
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $f76a3ff96cdfbadf$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("41IHR", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $2ee9ef2b81ef5286$export$f19b488f7c0547ee; });

var $2qaZZ = parcelRequire("2qaZZ");

var $knQgD = parcelRequire("knQgD");

var $lJYVo = parcelRequire("lJYVo");

var $keoD2 = parcelRequire("keoD2");
var $2ee9ef2b81ef5286$var$customThemeOptions = 'UNSAFE_themeOptions';
var $2ee9ef2b81ef5286$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $knQgD.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $keoD2.isThemeKind)(kind) && (0, $lJYVo.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $2ee9ef2b81ef5286$var$customThemeOptions) try {
            themeObject[$2ee9ef2b81ef5286$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("50Xx4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3a6b21c1523c027d$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $6ur0l = parcelRequire("6ur0l");

var $lBlwk = parcelRequire("lBlwk");

var $bNE6F = parcelRequire("bNE6F");

var $cPbl7 = parcelRequire("cPbl7");
function $3a6b21c1523c027d$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $bNE6F.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $bNE6F.default).bind();
    } else (0, $bNE6F.default).unbind();
    if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $cPbl7.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $cPbl7.default).bind();
        } else (0, $cPbl7.default).unbind();
    }
    var themeAttributes = (0, $lBlwk.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $bNE6F.default).unbind();
        if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) (0, $cPbl7.default).unbind();
    };
}

});
parcelRegister("bNE6F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8973619e8c3ccbb5$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $dH1HR = parcelRequire("dH1HR");

var $jiPXk = parcelRequire("jiPXk");

var $4ZwzG = parcelRequire("4ZwzG");
var $8973619e8c3ccbb5$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $8973619e8c3ccbb5$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $jiPXk.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $8973619e8c3ccbb5$var$darkModeMql = $8973619e8c3ccbb5$var$isMatchMediaAvailable && window.matchMedia((0, $4ZwzG.darkModeMediaQuery));
var $8973619e8c3ccbb5$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $cTewU.default)(this, ColorModeObserver);
        (0, $f53LC.default)(this, "unbindThemeChangeListener", null);
    }
    return (0, $avOEA.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$8973619e8c3ccbb5$var$darkModeMql) return 'light';
                return $8973619e8c3ccbb5$var$darkModeMql !== null && $8973619e8c3ccbb5$var$darkModeMql !== void 0 && $8973619e8c3ccbb5$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($8973619e8c3ccbb5$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $dH1HR.bind)($8973619e8c3ccbb5$var$darkModeMql, {
                    type: 'change',
                    listener: $8973619e8c3ccbb5$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $8973619e8c3ccbb5$var$SingletonColorModeObserver = new $8973619e8c3ccbb5$var$ColorModeObserver();
var $8973619e8c3ccbb5$export$2e2bcd8739ae039 = $8973619e8c3ccbb5$var$SingletonColorModeObserver;

});
parcelRegister("4ZwzG", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $3a2620931b0f408b$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $3a2620931b0f408b$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $3a2620931b0f408b$export$8662df6937d86fcb; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $jiPXk = parcelRequire("jiPXk");

var $ik1LR = parcelRequire("ik1LR");
var $3a2620931b0f408b$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId, preloadedThemeCss) {
        var themeCss, style, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $jiPXk.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $jiPXk.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (!(preloadedThemeCss !== null && preloadedThemeCss !== void 0)) {
                        _context.next = 3;
                        break;
                    }
                    _t = preloadedThemeCss;
                    _context.next = 5;
                    break;
                case 3:
                    _context.next = 4;
                    return (0, $ik1LR.loadThemeCss)(themeId);
                case 4:
                    _t = _context.sent;
                case 5:
                    themeCss = _t;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $3a2620931b0f408b$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $3a2620931b0f408b$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("ik1LR", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", function () { return $d56b77ec4fcaa25d$export$8a48286ed7df6720; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $fAAnW = parcelRequire("fAAnW");
var $d56b77ec4fcaa25d$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $fAAnW.default)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("fAAnW", function(module, exports) {
$parcel$export(module.exports, "themeImportMap", function () { return $b596711ddee75457$export$3a171c49f8c16356; });
$parcel$export(module.exports, "default", function () { return $b596711ddee75457$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::3f58b313f1e628496675dd91b81ecfa1>>
 * @codegenCommand yarn build tokens
 */ 
















var $b596711ddee75457$export$3a171c49f8c16356 = {
    'light': function light() {
        return (parcelRequire("2622p"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("eX08l"));
    },
    'light-finesse': function lightFinesse() {
        return (parcelRequire("hIuL8"));
    },
    'light-increased-contrast-finesse': function lightIncreasedContrastFinesse() {
        return (parcelRequire("9IB2A"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("ijnkK"));
    },
    'UNSAFE-test-light': function UNSAFETestLight() {
        return (parcelRequire("8tn7A"));
    },
    'UNSAFE-test-dark': function UNSAFETestDark() {
        return (parcelRequire("ajpTO"));
    },
    'dark': function dark() {
        return (parcelRequire("9av7D"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("8L8VO"));
    },
    'dark-finesse': function darkFinesse() {
        return (parcelRequire("cI4MY"));
    },
    'dark-increased-contrast-finesse': function darkIncreasedContrastFinesse() {
        return (parcelRequire("hVsAp"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("lxkLo"));
    },
    'spacing': function spacing() {
        return (parcelRequire("2ymo0"));
    },
    'typography': function typography() {
        return (parcelRequire("1Tlqj"));
    },
    'typography-finesse': function typographyFinesse() {
        return (parcelRequire("iHn6L"));
    },
    'shape': function shape() {
        return (parcelRequire("15Cb5"));
    },
    'motion': function motion() {
        return (parcelRequire("goEqg"));
    }
};
var $b596711ddee75457$export$2e2bcd8739ae039 = $b596711ddee75457$export$3a171c49f8c16356;

});
parcelRegister("2622p", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("3m13q").then(()=>parcelRequire('1pgEr'));

});

parcelRegister("eX08l", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("gu9hV").then(()=>parcelRequire('88ud9'));

});

parcelRegister("hIuL8", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("9TExV").then(()=>parcelRequire('aHuFI'));

});

parcelRegister("9IB2A", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("lXYnR").then(()=>parcelRequire('15Jy5'));

});

parcelRegister("ijnkK", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("gFQbn").then(()=>parcelRequire('fls65'));

});

parcelRegister("8tn7A", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("hrBMX").then(()=>parcelRequire('7VOjH'));

});

parcelRegister("ajpTO", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("b4ogJ").then(()=>parcelRequire('frHiA'));

});

parcelRegister("9av7D", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("fJzZC").then(()=>parcelRequire('8nCkv'));

});

parcelRegister("8L8VO", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("5DraP").then(()=>parcelRequire('lCz2L'));

});

parcelRegister("cI4MY", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("1Zbb3").then(()=>parcelRequire('dIYzn'));

});

parcelRegister("hVsAp", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("jCKjo").then(()=>parcelRequire('lTGZE'));

});

parcelRegister("lxkLo", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("hZHbP").then(()=>parcelRequire('dKIZP'));

});

parcelRegister("2ymo0", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("9p60j").then(()=>parcelRequire('lH9PL'));

});

parcelRegister("1Tlqj", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("au0yf").then(()=>parcelRequire('gaKCN'));

});

parcelRegister("iHn6L", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("9d6O6").then(()=>parcelRequire('4F3lH'));

});

parcelRegister("15Cb5", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("5O4ep").then(()=>parcelRequire('f2tUF'));

});

parcelRegister("goEqg", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("5bzmV").then(()=>parcelRequire('i7vQM'));

});





parcelRegister("cPbl7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $95630b45dce2f35f$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $dH1HR = parcelRequire("dH1HR");

var $jiPXk = parcelRequire("jiPXk");

var $4ZwzG = parcelRequire("4ZwzG");
var $95630b45dce2f35f$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $95630b45dce2f35f$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $jiPXk.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $95630b45dce2f35f$var$contrastModeMql = $95630b45dce2f35f$var$isMatchMediaAvailable && window.matchMedia((0, $4ZwzG.moreContrastMediaQuery));
var $95630b45dce2f35f$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $cTewU.default)(this, ContrastModeObserver);
        (0, $f53LC.default)(this, "unbindContrastChangeListener", null);
    }
    return (0, $avOEA.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$95630b45dce2f35f$var$contrastModeMql) return 'no-preference';
                return $95630b45dce2f35f$var$contrastModeMql !== null && $95630b45dce2f35f$var$contrastModeMql !== void 0 && $95630b45dce2f35f$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($95630b45dce2f35f$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $dH1HR.bind)($95630b45dce2f35f$var$contrastModeMql, {
                    type: 'change',
                    listener: $95630b45dce2f35f$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $95630b45dce2f35f$var$SingletonContrastModeObserver = new $95630b45dce2f35f$var$ContrastModeObserver();
var $95630b45dce2f35f$export$2e2bcd8739ae039 = $95630b45dce2f35f$var$SingletonContrastModeObserver;

});


parcelRegister("13MvN", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $0c5bb3af31e373b1$export$bd1ac9300b0e885a; });

var $jiPXk = parcelRequire("jiPXk");

var $a1cUl = parcelRequire("a1cUl");
function $0c5bb3af31e373b1$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $a1cUl.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $jiPXk.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $jiPXk.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("dXhhs", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $a28e30a0e7553939$export$5d76d7014f4a5d08; });

var $lFOXD = parcelRequire("lFOXD");

var $6ur0l = parcelRequire("6ur0l");

var $dK4nn = parcelRequire("dK4nn");
var $a28e30a0e7553939$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
var $a28e30a0e7553939$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(themeState) {
    if (!(0, $6ur0l.fg)('platform-dst-tokens-finesse')) return [];
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, typography = themeState.typography;
    var selectedThemes = [].concat((0, $lFOXD.default)(colorMode === 'auto' ? [
        light,
        dark
    ] : [
        themeState[colorMode]
    ]), [
        typography
    ]);
    if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) selectedThemes.forEach(function(themeId) {
        var increasedContrastTheme = (0, $dK4nn.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    var themeOverridePreferences = selectedThemes.map(function(themeId) {
        return $a28e30a0e7553939$var$finesseOverrides[themeId];
    }).filter(function(themeId) {
        return themeId !== undefined;
    });
    return (0, $lFOXD.default)(new Set(themeOverridePreferences));
};

});
parcelRegister("dK4nn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a012f734d8a62e7a$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $d5R8m = parcelRequire("d5R8m");
function $a012f734d8a62e7a$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $d5R8m.default)).find(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});
parcelRegister("d5R8m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9884f53f698fd605$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cVutf = parcelRequire("cVutf");


/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ // Retain Themes in this public type for backwards compatibility.
// platform-dst-tokens-finesse cleanup: Revisit when the temporary override themes are removed.
/**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $9884f53f698fd605$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $9884f53f698fd605$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
var $9884f53f698fd605$export$92ba366331403db2 = [].concat((0, $lFOXD.default)((0, $cVutf.themeIds)), $9884f53f698fd605$export$ba8a43b83ecc69f8);
var $9884f53f698fd605$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'UNSAFE-test-light': {
        id: 'UNSAFE-test-light',
        displayName: 'UNSAFE Test Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-test-dark': {
        id: 'UNSAFE-test-dark',
        displayName: 'UNSAFE Test Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9884f53f698fd605$export$2e2bcd8739ae039 = $9884f53f698fd605$export$9d64ff89b6869900;

});



parcelRegister("aslni", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", function () { return $79cd197fa63b55ba$export$dd6aeb7c823fc03d; });

var $lFOXD = parcelRequire("lFOXD");

var $6ur0l = parcelRequire("6ur0l");

var $dK4nn = parcelRequire("dK4nn");
var $79cd197fa63b55ba$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $dK4nn.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $dK4nn.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $lFOXD.default)(new Set(themePreferences));
};

});

parcelRegister("9dswR", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("22s6p").then(()=>parcelRequire('aPWA8'));

});


parcelRegister("cQjEj", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", function () { return $959995451ddbd921$export$a782702263f77544; });

var $1oC0p = parcelRequire("1oC0p");

var $bVgNm = parcelRequire("bVgNm");
var $959995451ddbd921$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $1oC0p.useContext)((0, $bVgNm.AppProviderThemingEnabledContext));
};

});
parcelRegister("bVgNm", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", function () { return $8ae20bb90f51030e$export$d2def9838ca456c0; });

var $1oC0p = parcelRequire("1oC0p");
var $8ae20bb90f51030e$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});


parcelRegister("cPe1A", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", function () { return $9565207172e5025f$export$26aa23367bfbab0e; });

var $1oC0p = parcelRequire("1oC0p");

var $4b9dx = parcelRequire("4b9dx");
var $9565207172e5025f$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $1oC0p.useContext)((0, $4b9dx.InsideAppProviderContext));
};

});
parcelRegister("4b9dx", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", function () { return $30af56e2a9480cf7$export$7981b2444296e410; });

var $1oC0p = parcelRequire("1oC0p");
var $30af56e2a9480cf7$export$7981b2444296e410 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});


parcelRegister("38t7R", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", function () { return $2488b63f6425e9ea$export$49ddd74a6729fdb0; });

var $1oC0p = parcelRequire("1oC0p");
var $2488b63f6425e9ea$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("dWnxz", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", function () { return $a262f3c7c04b2c83$export$332347eeb335453c; });

var $1oC0p = parcelRequire("1oC0p");
var $a262f3c7c04b2c83$export$332347eeb335453c = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});

parcelRegister("d9KJa", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", function () { return $99405cb5ea1a9953$export$b06130bad0bbc70f; });

var $1oC0p = parcelRequire("1oC0p");
var $99405cb5ea1a9953$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("caw1n", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", function () { return $8dbf41f9ea1e7740$export$2c657da244d00bd6; });
$parcel$export(module.exports, "SetThemeContext", function () { return $8dbf41f9ea1e7740$export$f7a97b47760e2a13; });

var $1oC0p = parcelRequire("1oC0p");
var $8dbf41f9ea1e7740$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $8dbf41f9ea1e7740$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("9w0sl", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", function () { return $6ed774d1e7b07f94$export$7ca11437599d653d; });

var $1oC0p = parcelRequire("1oC0p");

var $dWnxz = parcelRequire("dWnxz");
var $6ed774d1e7b07f94$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $1oC0p.useContext)((0, $dWnxz.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

});

parcelRegister("7Gtqt", function(module, exports) {
$parcel$export(module.exports, "getInlineThemeStyles", function () { return $59834809f5e737a4$export$ae40e6ba718781b9; });

var $lFOXD = parcelRequire("lFOXD");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $fAAnW = parcelRequire("fAAnW");

var $dXhhs = parcelRequire("dXhhs");

var $aslni = parcelRequire("aslni");
function $59834809f5e737a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59834809f5e737a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59834809f5e737a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59834809f5e737a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * TODO: Remove this React 18 compatibility guard when React 19 has shipped everywhere.
 * At that point, use `import { use } from 'react'` directly.
 */ var $59834809f5e737a4$var$themeCssPromises = new Map();
function $59834809f5e737a4$var$getThemeCssPromise(themeId) {
    var themeCssPromise = $59834809f5e737a4$var$themeCssPromises.get(themeId);
    if (!themeCssPromise) {
        themeCssPromise = (0, $fAAnW.themeImportMap)[themeId]().then(function(_ref) {
            var css = _ref.default;
            return css;
        });
        $59834809f5e737a4$var$themeCssPromises.set(themeId, themeCssPromise);
    }
    return themeCssPromise;
}
function $59834809f5e737a4$var$getInlineThemeCss(themeId) {
    var _document$body$queryS, _document$body$queryS2;
    var reactUse = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).use;
    var isServer = globalThis.__SERVER__ === true || typeof document === 'undefined';
    if (isServer) return reactUse === null || reactUse === void 0 ? void 0 : reactUse($59834809f5e737a4$var$getThemeCssPromise(themeId));
    return (_document$body$queryS = (_document$body$queryS2 = document.body.querySelector("style[data-theme=\"".concat(themeId, "\"]"))) === null || _document$body$queryS2 === void 0 ? void 0 : _document$body$queryS2.textContent) !== null && _document$body$queryS !== void 0 ? _document$body$queryS : undefined;
}
function $59834809f5e737a4$export$ae40e6ba718781b9(theme, colorMode) {
    var themeState = $59834809f5e737a4$var$_objectSpread($59834809f5e737a4$var$_objectSpread({}, theme), {}, {
        colorMode: colorMode,
        contrastMode: 'no-preference'
    });
    var themeIds = [].concat((0, $lFOXD.default)((0, $aslni.getThemePreferences)(themeState)), (0, $lFOXD.default)((0, $dXhhs.getThemeOverridePreferences)(themeState)));
    return (0, $lFOXD.default)(new Set(themeIds)).map(function(themeId) {
        var css = $59834809f5e737a4$var$getInlineThemeCss(themeId);
        return css ? {
            id: themeId,
            css: css
        } : undefined;
    }).filter(function(style) {
        return style !== undefined;
    });
}

});

parcelRegister("6Nq1z", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", function () { return $4f2b819268df49a0$export$7d4a7e812d176b24; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ceF4b = parcelRequire("ceF4b");

var $fAAnW = parcelRequire("fAAnW");

var $7FQxt = parcelRequire("7FQxt");
var $4f2b819268df49a0$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $7FQxt.isThemeMounted)(themeId)) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $fAAnW.themeImportMap)[themeId]();
                case 3:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $4f2b819268df49a0$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $ceF4b.getDocument)();
                    if (doc) {
                        _context2.next = 1;
                        break;
                    }
                    return _context2.abrupt("return");
                case 1:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $7FQxt.isThemeMounted)(themeId)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return");
                case 2:
                    doc.head.appendChild(style);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $4f2b819268df49a0$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 1;
                    return $4f2b819268df49a0$var$loadThemeCss(themeId);
                case 1:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return");
                case 2:
                    $4f2b819268df49a0$var$mountThemeCss(themeCss, themeId);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $4f2b819268df49a0$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($4f2b819268df49a0$var$loadAndMountThemeCss);
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();

});
parcelRegister("7FQxt", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", function () { return $59651ddd3e04c131$export$835a0dc855d02822; });

var $ceF4b = parcelRequire("ceF4b");

var $jiPXk = parcelRequire("jiPXk");
function $59651ddd3e04c131$export$835a0dc855d02822(themeId) {
    var doc = (0, $ceF4b.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $jiPXk.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}

});



parcelRegister("iHhIT", function(module, exports) {
$parcel$export(module.exports, "useColorMode", function () { return $d9c9fd8f2eebbd00$export$20f3076712c8dfa; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $jng4I = parcelRequire("jng4I");

var $eSktL = parcelRequire("eSktL");

var $38t7R = parcelRequire("38t7R");
function $d9c9fd8f2eebbd00$export$20f3076712c8dfa() {
    var value = (0, $1oC0p.useContext)((0, $38t7R.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $jng4I.getGlobalTheme)();
    var _useState = (0, $1oC0p.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, $2qaZZ.default)(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $eSktL.ThemeMutationObserver)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("eSktL", function(module, exports) {
$parcel$export(module.exports, "ThemeMutationObserver", function () { return $ad45fe86b3d3daeb$export$b741a7c3bcb1c635; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $jiPXk = parcelRequire("jiPXk");

var $jng4I = parcelRequire("jng4I");
var $ad45fe86b3d3daeb$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $cTewU.default)(this, ThemeMutationObserver);
        (0, $f53LC.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $avOEA.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $jng4I.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $jiPXk.THEME_DATA_ATTRIBUTE),
                            (0, $jiPXk.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $f53LC.default)($ad45fe86b3d3daeb$export$b741a7c3bcb1c635, "observer", null);
(0, $f53LC.default)($ad45fe86b3d3daeb$export$b741a7c3bcb1c635, "callbacks", new Set());
var $ad45fe86b3d3daeb$export$2e2bcd8739ae039 = $ad45fe86b3d3daeb$export$b741a7c3bcb1c635;

});


parcelRegister("2ZcrA", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $22caee6186bd4f06$export$c582005add11e141; });

var $2bKYr = parcelRequire("2bKYr");

var $gbEsR = parcelRequire("gbEsR");
var $22caee6186bd4f06$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $2bKYr.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $2bKYr.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $gbEsR.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $22caee6186bd4f06$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $22caee6186bd4f06$var$getPortalParent().appendChild(container);
};

});
parcelRegister("2bKYr", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", function () { return $19810be5e8a7429a$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $19810be5e8a7429a$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $19810be5e8a7429a$export$13f57c02915787b3; });
var $19810be5e8a7429a$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $19810be5e8a7429a$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $19810be5e8a7429a$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("gbEsR", function(module, exports) {
$parcel$export(module.exports, "getBody", function () { return $bc8d0fcf5cb31063$export$135b49d4bc2964c6; });
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $bc8d0fcf5cb31063$export$135b49d4bc2964c6 = function getBody() {
    return document.body;
};

});


parcelRegister("1tAhj", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $1134a4011c3a0dca$export$26ae5ca175b4ec5a; });

var $2bKYr = parcelRequire("2bKYr");
var $1134a4011c3a0dca$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $2bKYr.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};

});

parcelRegister("hJRJg", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", function () { return $cea05117c878e1b0$export$da99f98bf3fe55b3; });

var $2bKYr = parcelRequire("2bKYr");

var $gbEsR = parcelRequire("gbEsR");
var $cea05117c878e1b0$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $2bKYr.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $2bKYr.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $gbEsR.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $cea05117c878e1b0$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $cea05117c878e1b0$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("aDKLH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7bf1d31d3a805f1f$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $dTp91 = parcelRequire("dTp91");

var $iHhIT = parcelRequire("iHhIT");

var $9w0sl = parcelRequire("9w0sl");

var $fKFBj = parcelRequire("fKFBj");

var $lWJQ2 = parcelRequire("lWJQ2");

var $fGY4g = parcelRequire("fGY4g");
function $7bf1d31d3a805f1f$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $iHhIT.useColorMode)();
    var isInsideThemeProvider = (0, $9w0sl.useIsInsideThemeProvider)();
    (0, $fKFBj.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $lWJQ2.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $fGY4g.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dTp91.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $gUjjH.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("fKFBj", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $b77b6becfdab2fd6$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $b77b6becfdab2fd6$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);

});

parcelRegister("lWJQ2", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $ffa2924a31c72df2$export$fef014d7cef9e543; });

var $2bKYr = parcelRequire("2bKYr");
var $ffa2924a31c72df2$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $ffa2924a31c72df2$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($ffa2924a31c72df2$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $2bKYr.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("fGY4g", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", function () { return $b6c95f78e689beb9$export$95029ca7aca2989e; });

var $2bKYr = parcelRequire("2bKYr");

var $gbEsR = parcelRequire("gbEsR");
var $b6c95f78e689beb9$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $b6c95f78e689beb9$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($b6c95f78e689beb9$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $2bKYr.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            var parent = document.createElement('div');
            parent.className = (0, $2bKYr.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $gbEsR.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});


parcelRegister("bEQX9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87cc8180ca3a9c9d$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $fKFBj = parcelRequire("fKFBj");
var $87cc8180ca3a9c9d$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $fKFBj.useIsomorphicLayoutEffect) : (0, $1oC0p.useEffect);
    }), _useState4 = (0, $2qaZZ.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $87cc8180ca3a9c9d$export$2e2bcd8739ae039 = $87cc8180ca3a9c9d$var$useIsSubsequentRender;

});

parcelRegister("jzpEB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e3f52f89b256387e$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $9TldW = parcelRequire("9TldW");

var $501Oe = parcelRequire("501Oe");
var $e3f52f89b256387e$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1oC0p.useEffect)(function() {
        (0, $501Oe.default)((0, $9TldW.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $501Oe.default)((0, $9TldW.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $e3f52f89b256387e$export$2e2bcd8739ae039 = $e3f52f89b256387e$var$useFirePortalEvent;

});
parcelRegister("9TldW", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $7339b6bb23489afb$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $7339b6bb23489afb$export$80816bd900e5bd00; });
var $7339b6bb23489afb$export$ed5835cc67e87f72 = 'akPortalMount';
var $7339b6bb23489afb$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("501Oe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3a3e5b196d191dd7$export$2e2bcd8739ae039; });
var $3a3e5b196d191dd7$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $3a3e5b196d191dd7$var$getLayerName = function getLayerName(zIndex) {
    return $3a3e5b196d191dd7$var$zIndexToName.hasOwnProperty(zIndex) ? $3a3e5b196d191dd7$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $3a3e5b196d191dd7$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $3a3e5b196d191dd7$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $3a3e5b196d191dd7$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $3a3e5b196d191dd7$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("bfTZw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $831c87242fd0438f$export$2e2bcd8739ae039; });
/* popper-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $f53LC = parcelRequire("f53LC");

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $3ulR4 = parcelRequire("3ulR4");

var $6sYhF = parcelRequire("6sYhF");

var $6ur0l = parcelRequire("6ur0l");

var $34ocj = parcelRequire("34ocj");

var $7bHim = parcelRequire("7bHim");

var $36YSS = parcelRequire("36YSS");

var $k4EmD = parcelRequire("k4EmD");
var $831c87242fd0438f$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden",
    "shouldFitViewport"
];
function $831c87242fd0438f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $831c87242fd0438f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $831c87242fd0438f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $831c87242fd0438f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $831c87242fd0438f$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $831c87242fd0438f$var$fullWidthStyles = null;
var $831c87242fd0438f$var$wrapperStyles = {
    root: "_2rko1mok _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    fullWidth: "_1bsb1osq",
    motion: "_c71l1kw7 _1e0c1txw"
};
var $831c87242fd0438f$var$scrollableStyles = null;
var $831c87242fd0438f$var$blanketStyles = null;
var $831c87242fd0438f$var$modalStyles = null;
var $831c87242fd0438f$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var $831c87242fd0438f$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
var $831c87242fd0438f$var$DefaultPopupComponent = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, _isReferenceHidden = props.isReferenceHidden, shouldFitViewport = props.shouldFitViewport, htmlAttributes = (0, $gnQ3X.default)(props, $831c87242fd0438f$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2jatx.default)([
            $831c87242fd0438f$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: !(0, $6ur0l.fg)('platform-dst-motion-uplift-popup') ? ref : undefined
    }), children);
});
function $831c87242fd0438f$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $831c87242fd0438f$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, zIndex = _ref.zIndex;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(null), _useState4 = (0, $2qaZZ.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $k4EmD.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $36YSS.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $3ulR4.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, $lFOXD.default)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $34ocj.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $1oC0p.createElement(PopupContainer, {
            className: (0, $2jatx.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $6ur0l.fg)('platform-design-system-apply-popup-wrapper-focus') && $831c87242fd0438f$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: !(0, $6ur0l.fg)('platform-dst-motion-uplift-popup') ? function(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            } : undefined,
            style: (0, $6ur0l.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $1oC0p.createElement((0, $7bHim.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        var isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
        var container = /*#__PURE__*/ $1oC0p.createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $831c87242fd0438f$var$_objectSpread($831c87242fd0438f$var$_objectSpread({}, style), {}, {
                zIndex: zIndex
            }),
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            "data-testid": "".concat(testId, "--container"),
            className: (0, $2jatx.default)([
                shouldFitContainer && $831c87242fd0438f$var$wrapperStyles.fullWidth
            ])
        }, /*#__PURE__*/ $1oC0p.createElement((0, $6sYhF.default), {
            enteringAnimation: !isAutoPlacement ? $831c87242fd0438f$var$placementMap[placement].enter : undefined,
            exitingAnimation: !isAutoPlacement ? $831c87242fd0438f$var$placementMap[placement].exit : undefined,
            xcss: $831c87242fd0438f$var$wrapperStyles.motion
        }, popupContainer));
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, (0, $6ur0l.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $1oC0p.createElement("div", {
            className: (0, $2jatx.default)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$831c87242fd0438f$export$2e2bcd8739ae039 = $831c87242fd0438f$var$PopperWrapper;

});
parcelRegister("3ulR4", function(module, exports) {
$parcel$export(module.exports, "useLayering", function () { return $28a5205ef70ad0f4$export$c8b4d54e03dee6ed; });

var $1oC0p = parcelRequire("1oC0p");

var $14UFy = parcelRequire("14UFy");

var $lR5og = parcelRequire("lR5og");

var $d7VLy = parcelRequire("d7VLy");
function $28a5205ef70ad0f4$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $1oC0p.useContext)((0, $14UFy.LevelContext));
    var layerNode = (0, $1oC0p.useContext)((0, $lR5og.LevelNodeContext));
    var rootNode = (0, $1oC0p.useContext)((0, $d7VLy.RootNodeContext));
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $1oC0p.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("6sYhF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4b541ebb1c4eb478$export$2e2bcd8739ae039; });
/* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $4ZpaI = parcelRequire("4ZpaI");

var $kPutE = parcelRequire("kPutE");

var $6ur0l = parcelRequire("6ur0l");

var $9PNEX = parcelRequire("9PNEX");

var $cNnbm = parcelRequire("cNnbm");

var $dHUFc = parcelRequire("dHUFc");

var $gmg24 = parcelRequire("gmg24");

var $3RhFB = parcelRequire("3RhFB");

var $5hHSl = parcelRequire("5hHSl");

var $cz7Js = parcelRequire("cz7Js");

var $lg2vC = parcelRequire("lg2vC");
function $4b541ebb1c4eb478$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b541ebb1c4eb478$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b541ebb1c4eb478$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b541ebb1c4eb478$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4b541ebb1c4eb478$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ var $4b541ebb1c4eb478$var$MotionLegacy = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, enteringAnimation = _ref.enteringAnimation, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimation = _ref.exitingAnimation, exitingAnimationXcss = _ref.exitingAnimationXcss, onFinishMotion = _ref.onFinish, xcss = _ref.xcss, styleProp = _ref.style, testId = _ref.testId;
    var staggered = (0, $lg2vC.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $5hHSl.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggedIsReady = staggered.isReady;
    var _useState = (0, $1oC0p.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $1oC0p.useRef)(null);
    var reanimateRef = (0, $1oC0p.useRef)();
    var animationRef = (0, $1oC0p.useRef)();
    var staggeredEntryRef = (0, $1oC0p.useRef)();
    (0, $1oC0p.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $1oC0p.useEffect)(function() {
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $1oC0p.useCallback)(function(state, cancelled) {
        // We are done animating, so we set the state to idle
        var newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $3RhFB.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $3RhFB.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $dHUFc.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $cNnbm.getDurationMs)((0, $gmg24.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var _styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $9PNEX.getComputedAnimationDurationMs)(_styles.animationName, _styles.animationDuration, _styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $1oC0p.useImperativeHandle)(ref, function() {
        return {
            reanimate: function reanimate(value) {
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $3RhFB.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $3RhFB.Reanimate).enter) setState('entering');
            }
        };
    });
    var style = {};
    var customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    var hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2jatx.default)([
            hasAnimationStyles && $4b541ebb1c4eb478$var$styles.base,
            state === 'init' && $4b541ebb1c4eb478$var$styles.hidden,
            (0, $4ZpaI.cx)(xcss, customAnimation)
        ]),
        ref: (0, $kPutE.default)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: styleProp || hasAnimationStyles ? $4b541ebb1c4eb478$var$_objectSpread($4b541ebb1c4eb478$var$_objectSpread({}, styleProp), style) : undefined,
        "data-testid": testId
    }, children);
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ var $4b541ebb1c4eb478$var$MotionNext = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, enteringAnimation = _ref2.enteringAnimation, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimation = _ref2.exitingAnimation, exitingAnimationXcss = _ref2.exitingAnimationXcss, onFinishMotion = _ref2.onFinish, xcss = _ref2.xcss, styleProp = _ref2.style, testId = _ref2.testId;
    var _useMotion = (0, $cz7Js.useMotion)({
        onFinish: onFinishMotion
    }), state = _useMotion.state, motionRef = _useMotion.ref, reanimate = _useMotion.reanimate;
    (0, $1oC0p.useImperativeHandle)(ref, function() {
        return {
            reanimate: reanimate
        };
    }, [
        reanimate
    ]);
    // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2jatx.default)([
            state === 'init' && $4b541ebb1c4eb478$var$styles.hidden,
            (0, $4ZpaI.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: $4b541ebb1c4eb478$var$_objectSpread($4b541ebb1c4eb478$var$_objectSpread({}, styleProp), {}, {
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        }),
        "data-testid": testId
    }, children);
});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ var $4b541ebb1c4eb478$var$Motion = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    if ((0, $6ur0l.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($4b541ebb1c4eb478$var$MotionNext, (0, $c9bqK.default)({}, props, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($4b541ebb1c4eb478$var$MotionLegacy, (0, $c9bqK.default)({}, props, {
        ref: ref
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$4b541ebb1c4eb478$export$2e2bcd8739ae039 = $4b541ebb1c4eb478$var$Motion;

});
parcelRegister("9PNEX", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", function () { return $728f65d39e6ea1d1$export$dd9b73a7482d05b6; });

var $fpI0J = parcelRequire("fpI0J");
var $728f65d39e6ea1d1$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $728f65d39e6ea1d1$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $728f65d39e6ea1d1$var$toTimeList = function toTimeList(value) {
    return $728f65d39e6ea1d1$var$toCssList(value).filter(function(time) {
        return $728f65d39e6ea1d1$var$cssTimePattern.test(time);
    }).map((0, $fpI0J.convertToMs));
};
var $728f65d39e6ea1d1$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $728f65d39e6ea1d1$var$toCssList(animationName);
    var durations = $728f65d39e6ea1d1$var$toTimeList(animationDuration);
    var delays = $728f65d39e6ea1d1$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("fpI0J", function(module, exports) {
$parcel$export(module.exports, "convertToMs", function () { return $b38b546bc5e67c86$export$75eee42ff540d8ae; });
var $b38b546bc5e67c86$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("cNnbm", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", function () { return $950c0b24f62c9bb0$export$d0038b6e47881463; });

var $lFOXD = parcelRequire("lFOXD");
var $950c0b24f62c9bb0$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, $lFOXD.default)(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("dHUFc", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $9fab3eb4bfb9d90b$export$b7baf7667a68d87c; });

var $9gI0P = parcelRequire("9gI0P");
var $9fab3eb4bfb9d90b$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $9gI0P.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("9gI0P", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", function () { return $6bf7bf9c56fcb15e$export$c5406bd59b374abd; });
var $6bf7bf9c56fcb15e$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("gmg24", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", function () { return $be8b231be20feb4d$export$82b92541889a035d; });

var $ceF4b = parcelRequire("ceF4b");
var $be8b231be20feb4d$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $ceF4b.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("3RhFB", function(module, exports) {
$parcel$export(module.exports, "Reanimate", function () { return $2cf4073abd5b8188$export$569340a66b14e0dc; });
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $2cf4073abd5b8188$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("5hHSl", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", function () { return $3d90930f627113ae$export$3b6f38abbdcbd000; });

var $1oC0p = parcelRequire("1oC0p");

var $3sKC0 = parcelRequire("3sKC0");
var $3d90930f627113ae$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1oC0p.useContext)((0, $3sKC0.ExitingContext));
};

});

parcelRegister("cz7Js", function(module, exports) {
$parcel$export(module.exports, "useMotion", function () { return $925ec062f3c5b103$export$2a51cfe9390d36ef; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $kPutE = parcelRequire("kPutE");

var $9PNEX = parcelRequire("9PNEX");

var $cNnbm = parcelRequire("cNnbm");

var $dHUFc = parcelRequire("dHUFc");

var $gmg24 = parcelRequire("gmg24");

var $b8lYm = parcelRequire("b8lYm");

var $3RhFB = parcelRequire("3RhFB");

var $5hHSl = parcelRequire("5hHSl");

var $lg2vC = parcelRequire("lg2vC");
function $925ec062f3c5b103$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, onStartMotion = _ref.onStart, initialState = _ref.initialState;
    var reducedMotion = (0, $dHUFc.isReducedMotion)();
    var staggered = (0, $lg2vC.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $5hHSl.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $1oC0p.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    var motionState = isExiting ? 'exiting' : state;
    var elementRef = (0, $1oC0p.useRef)(null);
    var onStartMotionRef = (0, $1oC0p.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    var reanimateRef = (0, $1oC0p.useRef)();
    var animationRef = (0, $1oC0p.useRef)();
    var staggeredEntryRef = (0, $1oC0p.useRef)();
    (0, $b8lYm.useLayoutEffect)(function() {
        if (motionState === 'exiting') {
            var _onStartMotionRef$cur;
            (_onStartMotionRef$cur = onStartMotionRef.current) === null || _onStartMotionRef$cur === void 0 || _onStartMotionRef$cur.call(onStartMotionRef, 'exiting');
        }
        if (motionState === 'entering') {
            var _onStartMotionRef$cur2;
            (_onStartMotionRef$cur2 = onStartMotionRef.current) === null || _onStartMotionRef$cur2 === void 0 || _onStartMotionRef$cur2.call(onStartMotionRef, 'entering');
        }
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $1oC0p.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $3RhFB.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $3RhFB.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $3RhFB.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $3RhFB.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $1oC0p.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $cNnbm.getDurationMs)((0, $gmg24.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $9PNEX.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $1oC0p.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $3RhFB.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $3RhFB.Reanimate).enter) setState('entering');
        else if (value === (0, $3RhFB.Reanimate).exit) setState('exiting');
    }, []);
    var ref = (0, $1oC0p.useMemo)(function() {
        return (0, $kPutE.default)([
            staggered.ref,
            elementRef
        ]);
    }, [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});
parcelRegister("b8lYm", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $81b17c55f362aab0$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $81b17c55f362aab0$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("lg2vC", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", function () { return $f79d09d20f4dc2af$export$25c7213fc07ec080; });

var $1oC0p = parcelRequire("1oC0p");

var $6zEUl = parcelRequire("6zEUl");

var $iVfC3 = parcelRequire("iVfC3");
var $f79d09d20f4dc2af$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $6zEUl.useUniqueId)();
    var context = (0, $1oC0p.useContext)((0, $iVfC3.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("6zEUl", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", function () { return $4c95be5fd6667d95$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1oC0p = parcelRequire("1oC0p");
function $4c95be5fd6667d95$export$c485849f2e393253() {
    var identifier = (0, $1oC0p.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("iVfC3", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", function () { return $dc69a93ad0d3a432$export$5e65d7d58ae96ad8; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $b8lYm = parcelRequire("b8lYm");
var $dc69a93ad0d3a432$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $7uNuF.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $dc69a93ad0d3a432$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1oC0p.useRef)([]);
    var indexes = [];
    var _useState = (0, $1oC0p.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $2qaZZ.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $b8lYm.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($dc69a93ad0d3a432$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$dc69a93ad0d3a432$export$2e2bcd8739ae039 = $dc69a93ad0d3a432$var$StaggeredEntrance;

});




parcelRegister("7bHim", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", function () { return $53bb2501ca86afda$export$51eddd7655ca235a; });

var $1oC0p = parcelRequire("1oC0p");
var $53bb2501ca86afda$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children);
};

});

parcelRegister("36YSS", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", function () { return $244128f3769b0d57$export$92dae2778ae88f9d; });
// eslint-disable-next-line no-duplicate-imports

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $7uNuF = parcelRequire("7uNuF");

var $3ulR4 = parcelRequire("3ulR4");

var $6ur0l = parcelRequire("6ur0l");

var $74SKX = parcelRequire("74SKX");

var $dSPa3 = parcelRequire("dSPa3");
var $244128f3769b0d57$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $3ulR4.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $dSPa3.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var mouseDownTarget = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $7uNuF.default;
        var closePopup = function closePopup(event) {
            if (shouldIgnoreCloseEvent !== null && shouldIgnoreCloseEvent !== void 0 && shouldIgnoreCloseEvent(event) && (0, $6ur0l.fg)('cc_blocks_changeboarding')) return;
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest, _event$target$closest2;
                    _currentLevel = (_event$target$closest = (_event$target$closest2 = event.target.closest("[data-ds--level]")) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.getAttribute('data-ds--level')) !== null && _event$target$closest !== void 0 ? _event$target$closest : null;
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                var _target$closest;
                var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                if (layeredElement) {
                    var closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $74SKX.isInteractiveElement)(document.activeElement) && (0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onMouseDown = function onMouseDown(event) {
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function onKeyDown(event) {
            var key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $6ur0l.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                var eventTarget = event.target instanceof HTMLElement ? event.target : null;
                var layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                var levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) {
                var shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        var unbind = (0, $7uNuF.default);
        if ((0, $6ur0l.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $dH1HR.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $dH1HR.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $7uNuF.default);
        unbindBlur = (0, $dH1HR.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            if ((0, $6ur0l.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("74SKX", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", function () { return $52736198c22af72c$export$3dee5e4542c672d9; });
var $52736198c22af72c$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $52736198c22af72c$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($52736198c22af72c$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("dSPa3", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", function () { return $a1b8011127defd75$export$641fa9c94086b46e; });

var $1oC0p = parcelRequire("1oC0p");
var $a1b8011127defd75$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $1oC0p.useRef)([]);
    var requestFrame = (0, $1oC0p.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $1oC0p.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $1oC0p.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("k4EmD", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", function () { return $e9d37dd91443dee7$export$10c5169755ce7bd7; });

var $1oC0p = parcelRequire("1oC0p");

var $4b05t = parcelRequire("4b05t");

var $7uNuF = parcelRequire("7uNuF");

var $3ulR4 = parcelRequire("3ulR4");

var $6ur0l = parcelRequire("6ur0l");

var $dSPa3 = parcelRequire("dSPa3");
var $e9d37dd91443dee7$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $dSPa3.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $3ulR4.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $1oC0p.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $7uNuF.default;
        if (shouldDisableFocusTrap && (0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $7uNuF.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $6ur0l.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($4b05t)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
            if ((0, $6ur0l.fg)('platform_dst-popup-trigger-initial-focus-ref') && shouldReturnFocus) requestFrame(function() {
                if (triggerRef !== null && triggerRef !== void 0 && triggerRef.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("a3nRU", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", function () { return $751cb2fb7038e7cb$export$e24b8cb659609dee; });
/* popup-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");


var $7uNuF = parcelRequire("7uNuF");

var $jRuYb = parcelRequire("jRuYb");

var $5gHxO = parcelRequire("5gHxO");

var $iXKed = parcelRequire("iXKed");

var $54Qbe = parcelRequire("54Qbe");

var $4FpR5 = parcelRequire("4FpR5");

var $7Ag5f = parcelRequire("7Ag5f");

var $lubRD = parcelRequire("lubRD");

var $f80cP = parcelRequire("f80cP");

var $bmNtW = parcelRequire("bmNtW");
function $751cb2fb7038e7cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $751cb2fb7038e7cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $751cb2fb7038e7cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $751cb2fb7038e7cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
var $751cb2fb7038e7cb$var$EMPTY_STYLE = {};
var $751cb2fb7038e7cb$export$e24b8cb659609dee = /*#__PURE__*/ (0, $1oC0p.memo)(function PopupTopLayer(_ref) {
    var _roleProps$role;
    var xcss = _ref.xcss, isOpen = _ref.isOpen, providedId = _ref.id, offsetProp = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, _ref$onClose = _ref.onClose, onClose = _ref$onClose === void 0 ? (0, $7uNuF.default) : _ref$onClose, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _fallbackPlacements = _ref.fallbackPlacements, _ref$shouldFlip = _ref.shouldFlip, _shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldReturnFocu = _ref.shouldReturnFocus, _shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, role = _ref.role, label = _ref.label, titleId = _ref.titleId, _zIndex = _ref.zIndex, _shouldRenderToParent = _ref.shouldRenderToParent, _strategy = _ref.strategy, _modifiers = _ref.modifiers, _boundary = _ref.boundary, _rootBoundary = _ref.rootBoundary, _shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, _shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor, _appearance = _ref.appearance;
    var triggerRef = (0, $1oC0p.useRef)(null);
    var popoverRef = (0, $1oC0p.useRef)(null);
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref rather than component state. Flipping state on every open
   * caused a needless re-render and, more importantly, raced the
   * initial-focus effect below. The ref is read in the open-side
   * effect to override the role-based default focus chosen by
   * `useInitialFocus` inside the underlying `Popover`.
   */ var consumerInitialFocusRef = (0, $1oC0p.useRef)(null);
    var setInitialFocusRef = (0, $1oC0p.useCallback)(function(value) {
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    /**
   * Override the role-based initial focus chosen by the underlying
   * `Popover` (its internal `useInitialFocus`).
   *
   * React flushes child effects before parent effects, so by the time
   * this effect runs the role-based default focus has already moved.
   * We then apply the legacy `Popup` contract:
   *
   * 1. If the consumer wired `setInitialFocusRef`, focus that element
   *    (escape hatch wins).
   * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
   *    The `autoFocus` prop on `Popup` opts out of any initial-focus
   *    movement, even for roles like `dialog`.
   *
   * When neither applies the role-based default from the underlying
   * `Popover` stays in place.
   */ (0, $1oC0p.useEffect)(function() {
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        var consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            var _trigger = triggerRef.current;
            if (_trigger && _trigger.isConnected) _trigger.focus();
        }
    }, [
        isOpen,
        autoFocus
    ]);
    var popoverId = (0, $lubRD.usePopoverId)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    var topLayerPlacement = (0, $1oC0p.useMemo)(function() {
        return (0, $5gHxO.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        });
    }, [
        placement,
        offsetProp
    ]);
    (0, $7Ag5f.useAnchoredPopover)($751cb2fb7038e7cb$var$_objectSpread({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    }, (0, $f80cP.getPopupAxisSizes)({
        shouldFitContainer: shouldFitContainer,
        shouldFitViewport: shouldFitViewport
    })));
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    var handleOnClose = (0, $1oC0p.useCallback)(function(_ref2) {
        var reason = _ref2.reason;
        onClose((0, $54Qbe.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    var contentProps = (0, $1oC0p.useMemo)(function() {
        return {
            isOpen: isOpen,
            update: (0, $7uNuF.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        };
    }, [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    var roleProps = (0, $bmNtW.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    var resolvedPopoverId = providedId !== null && providedId !== void 0 ? providedId : popoverId;
    var ariaAttributes = (0, $jRuYb.getAriaForTrigger)({
        role: (_roleProps$role = roleProps.role) !== null && _roleProps$role !== void 0 ? _roleProps$role : 'dialog',
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    var Container = PopupContainer;
    // Map to legacy TriggerProps.
    var triggerProps = {
        ref: function ref(node) {
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        // FUDGE(top-layer-api): cast to the narrow public TriggerProps['aria-haspopup'] union.
        // `getAriaForTrigger` derives `aria-haspopup` from the content's role and types it
        // as the wider WAI-ARIA union (boolean | 'dialog' | 'menu' | 'listbox' | 'tree' | 'grid').
        // We keep the public popup TriggerProps narrow (boolean | 'dialog') because the
        // top-layer API surface is not yet settled. Widening adopter types now would commit
        // us to a public surface we may revisit. The runtime value is unchanged; only the
        // TypeScript-visible type is narrowed at this boundary.
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, trigger(triggerProps), /*#__PURE__*/ $1oC0p.createElement((0, $4FpR5.Popover), (0, $c9bqK.default)({
        ref: popoverRef,
        id: resolvedPopoverId
    }, roleProps, {
        isOpen: isOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: topLayerPlacement,
        testId: testId && "".concat(testId, "--content")
    }), Container ? /*#__PURE__*/ $1oC0p.createElement(Container, {
        style: $751cb2fb7038e7cb$var$EMPTY_STYLE,
        id: providedId,
        "data-placement": placement,
        "data-testid": testId,
        tabIndex: autoFocus ? -1 : undefined,
        xcss: xcss,
        shouldFitViewport: shouldFitViewport
    }, content(contentProps)) : /*#__PURE__*/ // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
    // same element, so it is the scroll container. The wrapper exists only
    // to carry the consumer's `xcss`: `PopoverSurface` exposes no
    // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
    // surface. `width` works there; surface-level declarations apply one
    // level in. Same shape as `compositional/popup-content-top-layer.tsx`.
    $1oC0p.createElement((0, $iXKed.PopoverSurface), null, /*#__PURE__*/ $1oC0p.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: xcss
    }, content(contentProps)))));
});

});
parcelRegister("jRuYb", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", function () { return $e75afd82772513b4$export$9dd1d61dd4d4755; });
/**
 * Roles accepted by `getAriaForTrigger`.
 *
 * Excludes tooltip-family roles (`tooltip`, `note`, `status`, `alert`, `log`)
 * because the correct trigger wiring for those is `aria-describedby`, not
 * `aria-haspopup` / `aria-expanded` / `aria-controls`. Use `aria-describedby`
 * manually for tooltip triggers.
 */ /**
 * Maps each supported popover role to its `aria-haspopup` value.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. Roles that do not produce a popup use `undefined` instead (for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading), so they are intentionally excluded
 * from this mapping and from `getAriaForTrigger`.
 *
 * `true` is intentionally not a value in this mapping. The runtime only ever
 * produces the explicit string forms, so allowing it would invite consumers
 * to pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ var $e75afd82772513b4$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $e75afd82772513b4$export$9dd1d61dd4d4755(_ref) {
    var role = _ref.role, isOpen = _ref.isOpen, popoverId = _ref.popoverId;
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': $e75afd82772513b4$var$roleToAriaHasPopup[role],
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("5gHxO", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", function () { return $3d60395a837b4188$export$69e99ed50b2534c9; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $9pQwV = parcelRequire("9pQwV");
function $3d60395a837b4188$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d60395a837b4188$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d60395a837b4188$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d60395a837b4188$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3d60395a837b4188$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $9pQwV.placementMapping)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, $2qaZZ.default)(offset, 2), along = _offset[0], away = _offset[1];
    return $3d60395a837b4188$var$_objectSpread($3d60395a837b4188$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

});
parcelRegister("9pQwV", function(module, exports) {
$parcel$export(module.exports, "placementMapping", function () { return $6daf323927451260$export$27df359c528b7120; });
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $6daf323927451260$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("iXKed", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", function () { return $dce198a3d37c6467$export$8b7437164e479115; });
/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $dce198a3d37c6467$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $dce198a3d37c6467$export$8b7437164e479115(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $dce198a3d37c6467$var$styles.root
        ])
    }, children);
}

});

parcelRegister("54Qbe", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", function () { return $3b25cd5e207ca6fa$export$27b4de066896ac63; });
/**
 * Creates a synthetic DOM event from a `TPopoverCloseReason`.
 *
 * Useful when bridging the Popover primitive's `onClose({ reason })` callback
 * to a legacy API that expects a native DOM event - for example,
 * `@atlaskit/inline-dialog`'s `onClose(event)` contract.
 *
 * - `'escape'` → `KeyboardEvent('keydown', { key: 'Escape' })`
 * - `'light-dismiss'` → `MouseEvent('click')`
 *
 * For any other reason, a generic `Event('close')` is returned as a fallback.
 *
 * @example
 * ```tsx
 * import { createPopoverCloseEvent, type TPopoverCloseReason } from '@atlaskit/top-layer/popover';
 *
 * function onPopoverClose({ reason }: { reason: TPopoverCloseReason }) {
 *   legacyOnClose(createPopoverCloseEvent({ reason }));
 * }
 * ```
 */ function $3b25cd5e207ca6fa$export$27b4de066896ac63(_ref) {
    var reason = _ref.reason;
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});

parcelRegister("4FpR5", function(module, exports) {
$parcel$export(module.exports, "Popover", function () { return $365f0c0f4c2f1e2f$export$5b6b19405a83ff9d; });
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $3sHnI = parcelRequire("3sHnI");

var $dH1HR = parcelRequire("dH1HR");

var $kPutE = parcelRequire("kPutE");

var $8zODL = parcelRequire("8zODL");

var $9DwrQ = parcelRequire("9DwrQ");

var $lpIyL = parcelRequire("lpIyL");

var $aKDMe = parcelRequire("aKDMe");

var $5oWDo = parcelRequire("5oWDo");

var $hzVL6 = parcelRequire("hzVL6");

var $bHmOS = parcelRequire("bHmOS");
/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $365f0c0f4c2f1e2f$var$restoreFocus(_ref) {
    var popover = _ref.popover, focusRestorationTarget = _ref.focusRestorationTarget;
    if (!focusRestorationTarget) return;
    var ownerDocument = popover.ownerDocument;
    // Native restoration has finished. Preserve focus moved outside the popover.
    var activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $365f0c0f4c2f1e2f$var$supportsPopoverHint = (0, $8zODL.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// Not `all: initial`: the target is what `<body>` gave the portal path, not the
// spec initial values (UA serif, black, `color-scheme: normal`), and as an author
// declaration it would also override the UA `[popover]` rules (`position: fixed`,
// `display: none` when closed).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately. The `satisfies` check below fails the
// build if either copy drifts.
var $365f0c0f4c2f1e2f$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $365f0c0f4c2f1e2f$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug _p6861txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $365f0c0f4c2f1e2f$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $365f0c0f4c2f1e2f$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $365f0c0f4c2f1e2f$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function Popover(_ref2, ref) {
    var children = _ref2.children, _ref2$mode = _ref2.mode, modeProp = _ref2$mode === void 0 ? 'auto' : _ref2$mode, onClose = _ref2.onClose, onEnterFinish = _ref2.onEnterFinish, onExitFinish = _ref2.onExitFinish, _ref2$shouldAnimate = _ref2.shouldAnimate, shouldAnimate = _ref2$shouldAnimate === void 0 ? false : _ref2$shouldAnimate, placement = _ref2.placement, testId = _ref2.testId, isOpen = _ref2.isOpen, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimationXcss = _ref2.exitingAnimationXcss, role = _ref2.role, label = _ref2.label, labelledBy = _ref2.labelledBy, idProp = _ref2.id;
    var autoId = (0, $1oC0p.useId)();
    var ownRef = (0, $1oC0p.useRef)(null);
    var combinedRef = (0, $kPutE.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    var onCloseRef = (0, $1oC0p.useRef)(onClose);
    (0, $1oC0p.useLayoutEffect)(function() {
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $1oC0p.useCallback)(function() {
        var _onCloseRef$current;
        (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
            reason: 'programmatic'
        });
    }, []);
    (0, $9DwrQ.useNotifyOpenLayerObserver)({
        type: role && $365f0c0f4c2f1e2f$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$365f0c0f4c2f1e2f$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $1oC0p.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $aKDMe.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $365f0c0f4c2f1e2f$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    var closeReasonRef = (0, $1oC0p.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    var focusRestorationTargetRef = (0, $1oC0p.useRef)(null);
    var handleBeforeToggle = (0, $1oC0p.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var ownerDocument = popover.ownerDocument;
        var activeElement = ownerDocument.activeElement;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    var handleToggleClosed = (0, $1oC0p.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        var reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $365f0c0f4c2f1e2f$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                reason: reason
            });
        }
    }, []);
    var _useAnimatedVisibilit = (0, $5oWDo.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, isMounted = _useAnimatedVisibilit.isMounted, onBeforeToggle = _useAnimatedVisibilit.onBeforeToggle, onToggle = _useAnimatedVisibilit.onToggle;
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // popovers are handled above via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $hzVL6.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $bHmOS.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $dH1HR.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $lpIyL.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $dH1HR.bind)(element, {
            type: 'toggle',
            listener: function listener(event) {
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        var unbindBeforeToggle = (0, $dH1HR.bind)(element, {
            type: 'beforetoggle',
            listener: function listener(event) {
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2jatx.default)([
            $365f0c0f4c2f1e2f$var$styles.root,
            $365f0c0f4c2f1e2f$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $365f0c0f4c2f1e2f$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $365f0c0f4c2f1e2f$var$styles.exit,
            shouldAnimate && $365f0c0f4c2f1e2f$var$styles.motion,
            (0, $3sHnI.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("lpIyL", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", function () { return $f96e7f6144c7750c$export$89b923e18c14644d; });
function $f96e7f6144c7750c$export$89b923e18c14644d(_ref) {
    var element = _ref.element;
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw for unsupported pseudo-classes.
    try {
        return element.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}

});

parcelRegister("aKDMe", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", function () { return $7d3d0e1ae90813a7$export$63044d21bc3d3fa2; });

var $i9YJL = parcelRequire("i9YJL");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $7d3d0e1ae90813a7$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $7d3d0e1ae90813a7$export$63044d21bc3d3fa2(_ref) {
    var _placement$axis, _placement$edge, _placement$align, _placement$offset$gap, _placement$offset, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        // Not `??`: `undefined` must survive, so "not specified" stays
        // distinguishable from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $i9YJL.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $i9YJL.toCssLengthString)({
                value: (_placement$offset$gap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap) !== null && _placement$offset$gap !== void 0 ? _placement$offset$gap : $7d3d0e1ae90813a7$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $i9YJL.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("i9YJL", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", function () { return $d3882e68e57d5bef$export$63b6b0ff65d84d47; });
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $d3882e68e57d5bef$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("5oWDo", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", function () { return $3eecad3869ce16ec$export$1bccb45daf07907f; });

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $lpIyL = parcelRequire("lpIyL");

var $2u6NF = parcelRequire("2u6NF");
function $3eecad3869ce16ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3eecad3869ce16ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3eecad3869ce16ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3eecad3869ce16ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3eecad3869ce16ec$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        // Prevent an interrupted or unmounted lifecycle from firing a stale callback.
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $3eecad3869ce16ec$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $3eecad3869ce16ec$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
/**
 * Visibility lifecycle phase shared between `useAnimatedVisibility`,
 * `useFocusWrap`, `useInitialFocus`, and the `Popover` / `Dialog`
 * components.
 *
 * - `closed`: host element is unmounted. No DOM presence.
 * - `entering`: host element is mounted and the CSS entry transition
 *   is playing. **Only emitted when animation is enabled.** With
 *   animation disabled the lifecycle goes directly `closed → open`.
 * - `open`: host element is mounted and settled. No transition is
 *   playing.
 * - `exiting`: a native close has begun but the host element remains
 *   mounted. Usually this follows `isOpen` changing to `false`, but it can
 *   also begin with a browser-initiated dismissal while controlled intent
 *   is still open. With animation disabled, this phase lasts until the
 *   browser's closed `toggle` fires so native focus restoration can finish.
 *
 * State machine:
 * ```
 *   animation ON:   closed → entering → open → exiting → closed
 *   animation OFF:  closed →            open → exiting → closed
 *   interrupts:     entering → exiting (close mid-entry)
 *                   exiting  → entering (reopen mid-exit, animated)
 *                   exiting  → open     (reopen mid-handshake, non-animated)
 * ```
 */ function $3eecad3869ce16ec$var$getInitialVisibilityState(_ref3) {
    var isOpen = _ref3.isOpen, willAnimate = _ref3.willAnimate;
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility phase.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $3eecad3869ce16ec$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        var shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return $3eecad3869ce16ec$var$_objectSpread($3eecad3869ce16ec$var$_objectSpread({}, state), {}, {
            controlledIntent: 'open'
        });
    }
    if (action.type === 'close-requested') return $3eecad3869ce16ec$var$_objectSpread($3eecad3869ce16ec$var$_objectSpread({}, state), {}, {
        controlledIntent: 'closed'
    });
    if (action.type === 'exit-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return $3eecad3869ce16ec$var$_objectSpread($3eecad3869ce16ec$var$_objectSpread({}, state), {}, {
            phase: 'exiting'
        });
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return $3eecad3869ce16ec$var$_objectSpread($3eecad3869ce16ec$var$_objectSpread({}, state), {}, {
            phase: 'open'
        });
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return $3eecad3869ce16ec$var$_objectSpread($3eecad3869ce16ec$var$_objectSpread({}, state), {}, {
            phase: 'closed'
        });
    }
    return state;
}
function $3eecad3869ce16ec$export$1bccb45daf07907f(_ref4) {
    var isOpen = _ref4.isOpen, shouldAnimate = _ref4.shouldAnimate, elementRef = _ref4.elementRef, onEnterFinish = _ref4.onEnterFinish, onExitFinish = _ref4.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $2u6NF.prefersReducedMotion)();
    var _useReducer = (0, $1oC0p.useReducer)($3eecad3869ce16ec$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $3eecad3869ce16ec$var$getInitialVisibilityState), _useReducer2 = (0, $2qaZZ.default)(_useReducer, 2), visibilityState = _useReducer2[0], dispatch = _useReducer2[1];
    var phase = visibilityState.phase, controlledIntent = visibilityState.controlledIntent;
    // Keep stable refs to the latest callbacks so effects and animation settlement closures
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $1oC0p.useRef)(onEnterFinish);
    var onExitFinishRef = (0, $1oC0p.useRef)(onExitFinish);
    var willAnimateRef = (0, $1oC0p.useRef)(willAnimate);
    (0, $1oC0p.useLayoutEffect)(function() {
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Entry can commit `open` before its callback because the host stays mounted.
    // This ensures consumers observe the settled DOM rather than entering styles.
    // Treat the phase before the initial commit as closed so an initially open host
    // notifies consumers.
    var prevPhaseRef = (0, $1oC0p.useRef)('closed');
    (0, $1oC0p.useEffect)(function() {
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (prevPhase === phase) return;
        if (phase === 'open') {
            var _onEnterFinishRef$cur;
            (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    var isMounted = phase !== 'closed';
    var cancelExitSettlementRef = (0, $1oC0p.useRef)(function() {});
    // Exit must notify consumers before `closed` unmounts the host.
    var settleExit = (0, $1oC0p.useCallback)(function() {
        var _onExitFinishRef$curr;
        (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    // Primitives bind these stable callbacks to their native lifecycle events.
    // This keeps event ownership at the primitive while the hook owns state transitions.
    var onBeforeToggle = (0, $1oC0p.useCallback)(function(event) {
        // Any native transition supersedes a previous exit snapshot. This prevents
        // a stale settlement from closing a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot currentTarget because the DOM clears it after event dispatch.
        var element = event.currentTarget;
        if (event.newState === 'open' && element instanceof HTMLElement) {
            element.removeAttribute('inert');
            element.removeAttribute('aria-hidden');
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // We use a microtask to let native focus restoration happen before making the element inert.
            // The browser restores focus after beforetoggle returns, during its close steps.
            queueMicrotask(function() {
                // A controlled close can be interrupted by isOpen changing back to true,
                // which reopens the element before this microtask runs.
                if ((0, $lpIyL.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep closed content rendered, so make it non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'exit-started'
            });
        }
    }, []);
    var onToggle = (0, $1oC0p.useCallback)(function(event) {
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $3eecad3869ce16ec$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after synchronous `beforetoggle`.
        // Snapshot here so the exiting phase styles have committed and the list
        // represents the animations that actually govern exit settlement.
        cancelExitSettlementRef.current = $3eecad3869ce16ec$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $1oC0p.useLayoutEffect)(function() {
        return function() {
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        };
    }, []);
    // Entry settlement only removes entering styles. Its callback runs after the
    // resulting `open` commit in the effect above.
    (0, $1oC0p.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        return $3eecad3869ce16ec$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("2u6NF", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", function () { return $1cf3a875eb84c6e8$export$ff7706047246b98b; });

var $8zODL = parcelRequire("8zODL");
var $1cf3a875eb84c6e8$export$ff7706047246b98b = (0, $8zODL.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("hzVL6", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", function () { return $ccc2823ebeab7bab$export$4f6462e86a70abe5; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $cL5oo = parcelRequire("cL5oo");

var $js8uw = parcelRequire("js8uw");

var $jZbSj = parcelRequire("jZbSj");

var $7Znku = parcelRequire("7Znku");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $ccc2823ebeab7bab$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $ccc2823ebeab7bab$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $1oC0p.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$ccc2823ebeab7bab$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $dH1HR.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $7Znku.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $jZbSj.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $cL5oo.getFirstFocusable)({
                    container: element
                }) : (0, $js8uw.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("cL5oo", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", function () { return $949e0ea27b5905a0$export$748138f04a69bf21; });

var $emI4A = parcelRequire("emI4A");
function $949e0ea27b5905a0$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $emI4A.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("emI4A", function(module, exports) {
$parcel$export(module.exports, "getFocusables", function () { return $a7554ec1da21682c$export$f6768025e418420e; });

var $1mzlZ = parcelRequire("1mzlZ");
var $a7554ec1da21682c$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
var $a7554ec1da21682c$var$exclusionSelector = $a7554ec1da21682c$var$focusableExclusions.map(function(selector) {
    return ":not(".concat(selector, ")");
}).join('');
var $a7554ec1da21682c$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map(function(selector) {
    return "".concat(selector).concat($a7554ec1da21682c$var$exclusionSelector);
}).join(',');
function $a7554ec1da21682c$var$isVisible(element) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch (_unused) {
        return true;
    }
}
function $a7554ec1da21682c$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var containerLayer = (0, $1mzlZ.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($a7554ec1da21682c$var$focusableSelector)).filter(function(element) {
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $1mzlZ.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$a7554ec1da21682c$var$isVisible(element)) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("1mzlZ", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", function () { return $0fe34506fcc06972$export$3c9385904be131db; });
function $0fe34506fcc06972$export$3c9385904be131db(_ref) {
    var element = _ref.element;
    return element.closest('[popover], dialog');
}

});



parcelRegister("js8uw", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", function () { return $e2973806dd0e0a2e$export$73e81fa65335a75b; });

var $emI4A = parcelRequire("emI4A");
function $e2973806dd0e0a2e$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $emI4A.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("jZbSj", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", function () { return $e8ccecedf13ade64$export$a7db88e6d491b450; });
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * The currently focused element does not need to be tabbable. This prevents
 * navigation from getting stuck on an element that was programmatically or
 * pointer focused with `tabindex="-1"`. Negative-tab-index elements remain
 * excluded as destinations.
 *
 * Returns `null` if there is no focused element within the container.
 */ 
var $emI4A = parcelRequire("emI4A");
function $e8ccecedf13ade64$export$a7db88e6d491b450(_ref) {
    var _all3;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $emI4A.getFocusables)({
        container: container,
        filter: filter
    });
    var first = all[0];
    var last = all[all.length - 1];
    // Checking the elements directly narrows types from `HTMLElement | undefined`.
    if (!first || !last) return null;
    var current = container.ownerDocument.activeElement;
    if (!(current instanceof HTMLElement) || !container.contains(current)) return null;
    var index = all.indexOf(current);
    // The focused element can be absent from `all` when it is non-tabbable or
    // excluded by the filter. Find the first focusable element that follows it in
    // the DOM, which identifies the nearest focusable destination in either direction.
    if (index === -1) {
        var _all;
        var followingIndex = all.findIndex(function(element) {
            return Boolean(current.compareDocumentPosition(element) & current.DOCUMENT_POSITION_FOLLOWING);
        });
        if (direction === 'forwards') {
            var _all$followingIndex;
            // If nothing follows the current element, then wrap to the start.
            return (_all$followingIndex = all[followingIndex]) !== null && _all$followingIndex !== void 0 ? _all$followingIndex : first;
        }
        // The closest preceding element is immediately before the first following one.
        // A missing adjacent entry means the backward sequence wraps to the end.
        return (_all = all[followingIndex - 1]) !== null && _all !== void 0 ? _all : last;
    }
    // The current element is tabbable, so use its adjacent list entry and wrap
    // when it is already at the boundary.
    if (direction === 'forwards') {
        var _all2;
        return (_all2 = all[index + 1]) !== null && _all2 !== void 0 ? _all2 : first;
    }
    return (_all3 = all[index - 1]) !== null && _all3 !== void 0 ? _all3 : last;
}

});

parcelRegister("7Znku", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", function () { return $5d1053ad9cdaa349$export$b9590fdfeb5f722f; });

var $1mzlZ = parcelRequire("1mzlZ");
function $5d1053ad9cdaa349$export$b9590fdfeb5f722f(_ref) {
    var container = _ref.container;
    var focused = container.ownerDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $1mzlZ.getClosestLayer)({
        element: focused
    }) !== (0, $1mzlZ.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("bHmOS", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", function () { return $8845695c4b3ac893$export$e992c40175757a22; });

var $1oC0p = parcelRequire("1oC0p");

var $cL5oo = parcelRequire("cL5oo");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $8845695c4b3ac893$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $8845695c4b3ac893$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $8845695c4b3ac893$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $8845695c4b3ac893$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$8845695c4b3ac893$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $8845695c4b3ac893$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $cL5oo.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($8845695c4b3ac893$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $cL5oo.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($8845695c4b3ac893$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $cL5oo.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $8845695c4b3ac893$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $1oC0p.useRef)('closed');
    (0, $1oC0p.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $8845695c4b3ac893$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("7Ag5f", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopover", function () { return $58585f1684176935$export$147d8888d96bf7a3; });
/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate use `useAnchoredPopoverAtPoint`.
 *
 * Two runtime paths, each a function that applies its styles and returns the
 * cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the JavaScript
 * fallback in `./javascript-fallback`. The path is resolved ONCE, at the top of
 * the hook, and threaded through positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4UF4U = parcelRequire("4UF4U");

var $3rWWv = parcelRequire("3rWWv");

var $3lGt3 = parcelRequire("3lGt3");

var $bymQc = parcelRequire("bymQc");

var $aKDMe = parcelRequire("aKDMe");

var $eNJuh = parcelRequire("eNJuh");

var $jqhEN = parcelRequire("jqhEN");
/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to take for every
 * popover.
 */ function $58585f1684176935$var$getPopoverWritingMode(_ref) {
    var popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $58585f1684176935$var$measureAnchorSize(_ref2) {
    var anchor = _ref2.anchor, writingMode = _ref2.writingMode;
    if (writingMode === 'vertical') return {
        inline: "".concat(anchor.offsetHeight, "px"),
        block: "".concat(anchor.offsetWidth, "px")
    };
    return {
        inline: "".concat(anchor.offsetWidth, "px"),
        block: "".concat(anchor.offsetHeight, "px")
    };
}
var $58585f1684176935$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
var $58585f1684176935$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
function $58585f1684176935$var$isAnchorRelative(size) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a CSS
 * `<dashed-ident>`. `useId()` is the same source as every other id in the design
 * system, including the popover's own `id` that `aria-controls` and `popovertarget`
 * point at, so it is unique exactly where those are and collides exactly where
 * they do. See `useAnchoredPopover` for the one case that needs the host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $58585f1684176935$var$useNewAnchorName() {
    var id = (0, $4UF4U.useId)();
    return (0, $1oC0p.useMemo)(function() {
        return "--anchor-".concat(id.replace(/[^A-Za-z0-9_-]/g, '_'));
    }, [
        id
    ]);
}
/**
 * A referentially-stable, fully-resolved `TPlacement`, so a fresh inline
 * `placement` object does not re-run the effect.
 */ function $58585f1684176935$var$useStablePlacement(placement) {
    var resolved = (0, $aKDMe.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var minSize = resolved.minSize;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $1oC0p.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $58585f1684176935$export$147d8888d96bf7a3(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, placement = _ref3.placement, isOpen = _ref3.isOpen, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, _ref3$inlineSize = _ref3.inlineSize, inlineSize = _ref3$inlineSize === void 0 ? 'content' : _ref3$inlineSize, _ref3$blockSize = _ref3.blockSize, blockSize = _ref3$blockSize === void 0 ? 'content' : _ref3$blockSize, _ref3$shouldPreserveI = _ref3.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref3$shouldPreserveI === void 0 ? false : _ref3$shouldPreserveI, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo;
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    var fallbackAnchorName = $58585f1684176935$var$useNewAnchorName();
    var stablePlacement = $58585f1684176935$var$useStablePlacement(placement);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        var isUsingCssAnchorPositioning = (0, $eNJuh.supportsAnchorPositioning)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        var canUseAnchorSize = isUsingCssAnchorPositioning && (0, $jqhEN.supportsAnchorSize)();
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        var writingMode = $58585f1684176935$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        var needsAnchorSize = $58585f1684176935$var$isAnchorRelative(inlineSize) || $58585f1684176935$var$isAnchorRelative(blockSize) || isFitting && isUsingCssAnchorPositioning;
        var anchorSize = needsAnchorSize ? canUseAnchorSize ? $58585f1684176935$var$CSS_ANCHOR_SIZE : $58585f1684176935$var$measureAnchorSize({
            anchor: trigger,
            writingMode: writingMode
        }) : $58585f1684176935$var$NO_ANCHOR_SIZE;
        var sizeStyles = (0, $3lGt3.getAnchoredPopoverSizeDeclarations)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $3rWWv.applyAnchorPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $bymQc.applyJavaScriptFallbackPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}

});
parcelRegister("3rWWv", function(module, exports) {
$parcel$export(module.exports, "applyAnchorPositioning", function () { return $28319d78de5a8b0f$export$50da8074e1408934; });

var $lFOXD = parcelRequire("lFOXD");

var $5m44M = parcelRequire("5m44M");

var $h9gvu = parcelRequire("h9gvu");

var $6RQgC = parcelRequire("6RQgC");

var $0ZQU5 = parcelRequire("0ZQU5");

var $eqmNc = parcelRequire("eqmNc");

var $kboTk = parcelRequire("kboTk");

var $1fkIl = parcelRequire("1fkIl");
function $28319d78de5a8b0f$export$50da8074e1408934(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover, placement = _ref.placement, sizeStyles = _ref.sizeStyles, isFitting = _ref.isFitting, fallbackAnchorName = _ref.fallbackAnchorName;
    // Reuse rather than mint: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    var existingAnchorName = (0, $eqmNc.getExistingAnchorName)(anchor);
    var anchorName = existingAnchorName !== null && existingAnchorName !== void 0 ? existingAnchorName : fallbackAnchorName;
    var gap = (0, $6RQgC.edgeMargin)({
        placement: placement,
        offset: placement.offset.gap
    });
    var crossAxisShift = (0, $h9gvu.crossAxisShiftMargins)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    var popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $kboTk.placementToPositionArea)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $1fkIl.placementToTryFallbacks)({
                placement: placement
            })
        },
        /**
   * **`position-visibility: always`**
   *
   * `position-visibility` is used to control the visibility of an anchored
   * popover based on the visibility of the element being anchored to (the target).
   *
   * Default `position-visibility` value: `anchors-visible` → hide the anchored
   * popover when the target is fully clipped by an ancestor (eg a scroll container)
   * or is `visibility:hidden`.
   * Sadly this "automatic hiding" does not actually "close" the popover,
   * so things like `:popover-open` are still active, even though the popover
   * is no longer painted and no longer receives pointer input. Chrome keeps it
   * focusable and in the accessibility tree, so keyboard and screen reader users
   * can still land inside a surface that is not painted.
   * Per-engine behaviour: `notes/decisions/position-visibility-always.md`.
   *
   * Generally we have not run into issues with the default (`anchors-visible`)
   *
   * Exceptions:
   *  - Target is intentionally not visible (eg `position:absolute` moving it outside of
   *    its parent's "clipped boundary", or a `visibility:hidden` trigger)
   *  - A trigger is scrolled out of its scroll container while the popover is open.
   *
   * We are switching from `anchors-visible` → `always` _for now_ to force no
   * automatic hiding of the popover. There seems to be no compelling reason to use
   * the default value. If one arises in the future, we could look towards making
   *  this behaviour configurable.
   */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset browser default popover positioning that conflicts
        // with anchor positioning (UA: `inset: 0; margin: auto;`)
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gap
    ].concat((0, $lFOXD.default)(isFitting ? (0, $0ZQU5.getFitMarginDeclarations)({
        placement: placement,
        crossAxisShiftMargins: crossAxisShift
    }) : crossAxisShift), (0, $lFOXD.default)(sizeStyles));
    // Anchor names are never cleaned up: multiple popovers can share an anchor,
    // and even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only written when minted: a name
    // from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $5m44M.setStyle)({
        element: popover,
        styles: popoverStyles
    });
}

});
parcelRegister("5m44M", function(module, exports) {
$parcel$export(module.exports, "setStyle", function () { return $3e622b457dabb014$export$37a5fde709c1db82; });
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $3e622b457dabb014$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});

parcelRegister("h9gvu", function(module, exports) {
$parcel$export(module.exports, "crossAxisShiftMargins", function () { return $0338c687c3a0a66e$export$f7505ccec0897ae3; });
/**
 * The cross-axis shift, written antisymmetrically on BOTH cross-axis sides rather
 * than as one margin. Do not collapse it to one side: a single margin widens the
 * margin box, so `anchor-center` displaces the border box by only half the value,
 * a `<position-area>` fallback sliding across the cross axis drops it entirely,
 * and the widened box changes where the popover is judged to overflow.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $0338c687c3a0a66e$export$f7505ccec0897ae3(_ref) {
    var placement = _ref.placement, crossAxisShiftCssValue = _ref.crossAxisShiftCssValue, direction = _ref.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}

});

parcelRegister("6RQgC", function(module, exports) {
$parcel$export(module.exports, "edgeMargin", function () { return $50003c77726e71df$export$b94d052c6b40496; });
/**
 * The margin that creates the gap between the popover and its anchor.
 */ function $50003c77726e71df$export$b94d052c6b40496(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The side FACING the anchor is always opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}

});

parcelRegister("0ZQU5", function(module, exports) {
$parcel$export(module.exports, "getFitMarginDeclarations", function () { return $002ffac6f201016e$export$a7ffde4a856e8d8e; });

var $lFOXD = parcelRequire("lFOXD");

var $3lGt3 = parcelRequire("3lGt3");
/**
 * Every logical margin property the fit recipe can write. Declared here and
 * imported by `edge-margin.tsx` and `cross-axis-shift-margins.tsx`: two
 * structurally identical declarations are interchangeable to the compiler, so a
 * divergence would surface only as a silently-ignored property name at
 * `setStyle`.
 */ /**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $002ffac6f201016e$var$viewportFacingCrossAxisSides(_ref) {
    var align = _ref.align;
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $002ffac6f201016e$export$a7ffde4a856e8d8e(_ref2) {
    var placement = _ref2.placement, crossAxisShiftMargins = _ref2.crossAxisShiftMargins;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    var paddedProperties = new Set($002ffac6f201016e$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map(function(side) {
        return "margin-".concat(crossAxis, "-").concat(side);
    }));
    return [
        {
            property: "margin-".concat(placement.axis, "-").concat(placement.edge),
            value: (0, $3lGt3.VIEWPORT_PADDING)
        }
    ].concat((0, $lFOXD.default)(crossAxisShiftMargins.map(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        return paddedProperties.has(property) ? {
            property: property,
            value: "calc(".concat(value, " + ").concat((0, $3lGt3.VIEWPORT_PADDING), ")")
        } : {
            property: property,
            value: value
        };
    })));
}

});
parcelRegister("3lGt3", function(module, exports) {
$parcel$export(module.exports, "VIEWPORT_PADDING", function () { return $27044670ce9f5e5d$export$9f2fdbacbc62226e; });
$parcel$export(module.exports, "getAnchoredPopoverSizeDeclarations", function () { return $27044670ce9f5e5d$export$860b30329fa0b990; });
/**
 * The space kept clear between a popover and the viewport edge. Matches legacy
 * `@atlaskit/popper`'s `preventOverflow` padding of `5`.
 */ var $27044670ce9f5e5d$export$9f2fdbacbc62226e = '5px';
var $27044670ce9f5e5d$export$32ab78b2bb853a01 = '150px';
/**
 * Which way the POPOVER's inline axis runs; `'vertical'` covers the `vertical-*`
 * and `sideways-*` writing modes. Measured rather than assumed, because every
 * logical property this module writes resolves against the popover's own writing
 * mode, and so must the viewport unit paired with it.
 */ /**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $27044670ce9f5e5d$var$viewportUnit(_ref) {
    var axis = _ref.axis, writingMode = _ref.writingMode;
    var isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
/**
 * How one axis of an anchored popover is sized. Both axes take these four values
 * under identical rules.
 *
 * - `'content'`: sized by its content. Named after `flex-basis: content`; NOT
 *   `'auto'`, whose CSS meaning for a positioned box is shrink-to-fit, the very
 *   behaviour rule 4 removes.
 * - `'match-anchor'`: exactly the anchor's size on this axis.
 * - `'min-anchor'`: at least the anchor's size on this axis, free to grow.
 * - `'max-available'`: at most the space between the anchor and the viewport
 *   edge, content-sized below that. Capped by the `position-area` cell on the
 *   placement axis and by the viewport on the cross axis (a `span-*` cell is
 *   narrower than the viewport, so capping to it would wrap content that fits on
 *   screen).
 *
 * Four rules apply on top:
 *
 * 1. Fitting one axis fills a `'content'` other axis with `'max-available'` too.
 *    An explicit value is never overridden, so caps stay strictly per-axis.
 * 2. Fitting either axis floors the placement axis, because flipping is a
 *    whole-popover outcome. See `getPlacementAxisFloor`.
 * 3. The viewport cap is unconditional, so a non-fitting axis still cannot
 *    overhang the screen. `'max-available'` and `'content'` are therefore
 *    indistinguishable on the cross axis.
 * 4. A non-anchor-relative inline axis gets `inline-size: max-content`. Under
 *    `position-area` the containing block is the cell, so a CSS `auto` inline
 *    size shrink-to-fits a too-narrow cell and WRAPS into it, never overflowing
 *    and so never sliding to the roomier side. The caps still beat it, because a
 *    max beats a definite size. Not needed on the block axis, which does not
 *    wrap, nor on the JavaScript fallback, whose containing block is the
 *    viewport. Consumers opt out with `shouldPreserveInlineSize`.
 *
 * See `notes/decisions/fit-available-space.md`.
 */ /**
 * Narrowed rather than `string`, so a typo cannot reach `setStyle` as a
 * silently-ignored property name.
 */ /**
 * The anchor's size along each axis, as a CSS length. `null` when nothing needs
 * it, so the measurement is skipped.
 *
 * The CSS path uses the `self-` keywords, whose axes are the POPOVER's, so each
 * value matches the axis of the property it is set on (`anchor-size(inline)` and
 * `anchor-size(width)` are both silently wrong in a vertical writing mode). The
 * JavaScript fallback uses a measured pixel length, because `anchor-size()` needs
 * a `position-anchor` that path never sets. See
 * `notes/decisions/width-from-anchor-floors.md`.
 */ function $27044670ce9f5e5d$var$getCrossAxis(axis) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $27044670ce9f5e5d$var$viewportCap(_ref2) {
    var axis = _ref2.axis, writingMode = _ref2.writingMode;
    return "calc(100".concat($27044670ce9f5e5d$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    }), " - 2 * ").concat($27044670ce9f5e5d$export$9f2fdbacbc62226e, ")");
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $27044670ce9f5e5d$var$cellCap(_ref3) {
    var gap = _ref3.gap;
    return "calc(100% - ".concat($27044670ce9f5e5d$export$9f2fdbacbc62226e, " - ").concat(gap, ")");
}
/**
 * The anchor term of the placement-axis floor, and the one place it is capped.
 *
 * `'match-anchor'` earns a floor only where it can flip: a definite size clamps to
 * the cap and shrinks below the anchor instead of flipping.
 *
 * The `canFlip` clamp is deliberate both ways. With no flip in play an unclamped
 * floor beats `max-{axis}-size` (CSS resolves `min` last), making the viewport
 * backstop inert. With a flip in play, clamping would stop the floor exceeding
 * the cell cap, which is what drives the flip.
 */ function $27044670ce9f5e5d$var$getPlacementAxisAnchorFloor(_ref4) {
    var placementAxis = _ref4.placementAxis, placementAxisSize = _ref4.placementAxisSize, anchorValue = _ref4.anchorValue, canFlip = _ref4.canFlip, writingMode = _ref4.writingMode;
    var hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return undefined;
    if (canFlip) return anchorValue;
    return "min(".concat(anchorValue, ", ").concat($27044670ce9f5e5d$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    }), ")");
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells either side of the anchor add up to the viewport less the anchor,
 * so the roomier one is at least half of that. A floor whose margin box fits
 * inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` states
 * the lower bound for an anchor taller than the viewport.
 */ function $27044670ce9f5e5d$var$getDefaultPlacementAxisFloor(_ref5) {
    var placementAxis = _ref5.placementAxis, anchorValue = _ref5.anchorValue, gap = _ref5.gap, writingMode = _ref5.writingMode;
    if (anchorValue === null) return $27044670ce9f5e5d$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    var viewport = "100".concat($27044670ce9f5e5d$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    }));
    var halfOfRemainingViewport = "calc((".concat(viewport, " - ").concat(anchorValue, ") / 2 - ").concat(gap, " - ").concat($27044670ce9f5e5d$export$9f2fdbacbc62226e, ")");
    return "min(".concat($27044670ce9f5e5d$export$32ab78b2bb853a01, ", max(0px, ").concat(halfOfRemainingViewport, "))");
}
/**
 * The placement-axis floor: explicit minimums COMPOSE, the default does not.
 *
 * `placement.minSize` and the anchor term are both explicit requests, so they
 * compose as `max()`. `FALLBACK_MINIMUM_MAIN_AXIS_SIZE` never composes: it only
 * ever won by overriding a size the consumer asked for, and the anchor term drives
 * the flip on its own. Knock-on, intended: `minSize: 0` no longer removes an
 * anchor floor, because `max(0px, anchor)` IS the anchor.
 */ function $27044670ce9f5e5d$var$getPlacementAxisFloor(_ref6) {
    var minSize = _ref6.minSize, placementAxis = _ref6.placementAxis, placementAxisSize = _ref6.placementAxisSize, anchorValue = _ref6.anchorValue, gap = _ref6.gap, canFlip = _ref6.canFlip, writingMode = _ref6.writingMode;
    var anchorFloor = $27044670ce9f5e5d$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === undefined ? minSize : "max(".concat(minSize, ", ").concat(anchorFloor, ")");
    if (anchorFloor !== undefined) return anchorFloor;
    if (!canFlip) return undefined;
    return $27044670ce9f5e5d$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $27044670ce9f5e5d$export$860b30329fa0b990(_ref7) {
    var placement = _ref7.placement, inlineSize = _ref7.inlineSize, blockSize = _ref7.blockSize, isUsingCssAnchorPositioning = _ref7.isUsingCssAnchorPositioning, anchorSize = _ref7.anchorSize, writingMode = _ref7.writingMode, _ref7$shouldPreserveI = _ref7.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref7$shouldPreserveI === void 0 ? false : _ref7$shouldPreserveI;
    var placementAxis = placement.axis;
    var crossAxis = $27044670ce9f5e5d$var$getCrossAxis(placementAxis);
    // Rule 1. Feeds the per-axis CAPS only.
    var size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values instead, un-mirrored: flipping is a
    // whole-popover outcome, so a fit request on either axis turns the floor on.
    var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // ...but only where the floor is what causes the flip. On the JavaScript
    // fallback a floor only inflates the measured size the side is picked from, so
    // it would flip a popover that fits.
    var canFlip = isFitting && isUsingCssAnchorPositioning;
    var declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: "max-".concat(placementAxis, "-size"),
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $27044670ce9f5e5d$var$cellCap({
                gap: placement.offset.gap
            }) : $27044670ce9f5e5d$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: "max-".concat(crossAxis, "-size"),
            value: $27044670ce9f5e5d$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // A max beats a definite size, so the caps above still win over this.
    for(var _i = 0, _arr = [
        placementAxis,
        crossAxis
    ]; _i < _arr.length; _i++){
        var axis = _arr[_i];
        var anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: "".concat(axis, "-size"),
            value: anchorValue
        });
    }
    var placementAxisFloor = $27044670ce9f5e5d$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== undefined) declarations.push({
        property: "min-".concat(placementAxis, "-size"),
        value: placementAxisFloor
    });
    // A size contract, not a flip driver, so it is clamped to the cap.
    var crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: "min-".concat(crossAxis, "-size"),
        value: "min(".concat(crossAxisAnchorValue, ", ").concat($27044670ce9f5e5d$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        }), ")")
    });
    return declarations;
}

});


parcelRegister("eqmNc", function(module, exports) {
$parcel$export(module.exports, "getExistingAnchorName", function () { return $a8052c882b52f870$export$948d15b01d509455; });
/**
 * The `anchor-name` an element already carries, or `null`. Computed as well as
 * inline, so a name set from a STYLESHEET is found: a minted inline name would
 * otherwise override it for every other rule anchored to that element.
 * `anchor-name` is a list and `position-anchor` takes one ident, so the first
 * name is the one to anchor to.
 */ function $a8052c882b52f870$export$948d15b01d509455(element) {
    var declared = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    var first = declared.split(',')[0].trim();
    return first !== '' && first !== 'none' ? first : null;
}

});

parcelRegister("kboTk", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", function () { return $eb18249fcb9b4c8c$export$de49b61f233ddeb9; });
/**
 * Resolves a placement to CSS `position-area` syntax.
 *
 * The `align` field represents the *visual* alignment:
 * - `align: 'start'` means "aligned to the trigger's start edge" (left in LTR for block axis)
 * - `align: 'end'` means "aligned to the trigger's end edge"
 * - `align: 'center'` means centered (single-axis position-area)
 *
 * CSS `position-area` uses `span-*` keywords which indicate the *expansion direction*.
 * Visual start-alignment requires `span-{cross-axis}-end` (expand toward end = start-aligned).
 * This function handles the inversion internally.
 *
 * Takes the RESOLVED placement, which the hook threads through positioning,
 * sizing and margins alike, so nothing here can disagree with them.
 *
 * @example
 * // For a `block-end` placement, by `align`:
 * // 'center' → 'block-end'
 * // 'start'  → 'block-end span-inline-end'
 * // 'end'    → 'block-end span-inline-start'
 */ function $eb18249fcb9b4c8c$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("1fkIl", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", function () { return $0e87429697dc4edc$export$c4e16947a95d61f1; });
/**
 * The placement axis joined to its edge, e.g. `block-end`.
 */ /**
 * The cells to slide to along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not, and two options over the SAME cell have the same margin box and
 * the same fit result. That rules out three cells for an aligned placement: the
 * near span on the requested edge IS the base position-area, and on the opposite
 * edge the near and far spans are where `flip-{A}` and the diagonal flip land.
 *
 * A centred placement has no near or far, so it slides to both spans on both
 * edges.
 */ function $0e87429697dc4edc$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis, isOppositeEdge = _ref.isOppositeEdge;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    if (isOppositeEdge) return [
        edgeKey
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`; `align: 'end'` mirrors this.
    var far = align === 'start' ? 'start' : 'end';
    return [
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $0e87429697dc4edc$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $0e87429697dc4edc$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $0e87429697dc4edc$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        flipOnMainAxis,
        align !== 'center' ? $0e87429697dc4edc$var$flipDiagonally({
            axis: axis
        }) : null,
        $0e87429697dc4edc$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}

});


parcelRegister("bymQc", function(module, exports) {
$parcel$export(module.exports, "applyJavaScriptFallbackPositioning", function () { return $8694967087338cd1$export$89babc4c2047d2ba; });

var $lFOXD = parcelRequire("lFOXD");

var $dH1HR = parcelRequire("dH1HR");

var $FcGYz = parcelRequire("FcGYz");

var $86Hb0 = parcelRequire("86Hb0");

var $5m44M = parcelRequire("5m44M");

var $aeqzh = parcelRequire("aeqzh");

var $1BpWS = parcelRequire("1BpWS");

var $5RLqd = parcelRequire("5RLqd");
/**
 * Wrapped because jsdom throws on the unknown `:popover-open` selector.
 */ function $8694967087338cd1$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Observes the popover until its first non-zero layout, then self-disconnects;
 * ongoing movement is handled by the scroll and resize listeners. The popover is
 * `display: none` until `showPopover()`, and some browsers fire `toggle` before
 * layout, so RAF-after-toggle is unreliable.
 *
 * `null` where `ResizeObserver` is missing (non-DOM jest environments). There is
 * then no measurement to wait for, so the caller positions immediately and must
 * not hide the popover, because no reveal would follow.
 */ function $8694967087338cd1$var$createFirstLayoutObserver(_ref) {
    var popover = _ref.popover, onFirstLayout = _ref.onFirstLayout;
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        var observer = new ResizeObserver(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $5RLqd.warnFallbackFailure)({
            error: error
        });
        return null;
    }
}
function $8694967087338cd1$export$89babc4c2047d2ba(_ref2) {
    var anchor = _ref2.anchor, popover = _ref2.popover, placement = _ref2.placement, sizeStyles = _ref2.sizeStyles;
    // Already in the top layer via the `popover` attribute, so this only resets the
    // UA defaults and writes measured `top` / `left`.
    var cleanupBaseStyles = (0, $5m44M.setStyle)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            }
        ].concat((0, $lFOXD.default)(sizeStyles))
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    var undoPosition;
    var undoHide;
    // Resolved once per open and per resize, reused across scrolls: resolving is a
    // full style and layout flush, and a scroll cannot change what a CSS length
    // resolves to. A resize can (viewport units), and so can a re-open (a token
    // retargeted while closed).
    var resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probed INSIDE the popover: it is in the top layer, not the anchor's DOM
        // tree, so anywhere else resolves a token against a different scope.
        resolvedOffsets = {
            gap: (0, $1BpWS.resolveCssLengthToPixels)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $1BpWS.resolveCssLengthToPixels)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        var _undoHide;
        (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
        undoHide = undefined;
    }
    function restorePosition() {
        var _undoPosition;
        (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
        undoPosition = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (undoHide) return;
        undoHide = (0, $5m44M.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
   * Last resort. The base styles above reset the UA
   * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
   * sits in the viewport corner rather than centred.
   */ function centerInViewport() {
        restorePosition();
        undoPosition = (0, $5m44M.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function update() {
        try {
            var triggerRect = anchor.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            var _getResolvedOffsets = getResolvedOffsets(), gap = _getResolvedOffsets.gap, crossAxisShift = _getResolvedOffsets.crossAxisShift;
            var _computeFallbackPosit = (0, $aeqzh.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // A non-finite coordinate serialises to a declaration the browser drops,
            // landing the popover in the corner just as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $5m44M.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
        } catch (error) {
            (0, $5RLqd.warnFallbackFailure)({
                error: error
            });
            // Anchoring needs the trigger geometry we just failed to get, so the
            // centred position is the only one left to degrade to.
            try {
                centerInViewport();
            } catch (_unused2) {}
        } finally{
            // Unconditional. A popover in the wrong place is recoverable on the
            // next scroll or resize; one left at `opacity: 0` is invisible forever.
            reveal();
        }
    }
    function invalidateAndUpdate() {
        invalidateResolvedOffsets();
        update();
    }
    // One update per animation frame. Scroll reuses the resolved offsets; resize
    // re-resolves them.
    var scheduledScrollUpdate = (0, $FcGYz.default)(update);
    var scheduledResizeUpdate = (0, $FcGYz.default)(invalidateAndUpdate);
    var firstLayoutObserver = $8694967087338cd1$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: update
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open re-resolves the offsets.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            update();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs, in which case the initial
    // `toggle` has fired and the listener below would miss it.
    if ($8694967087338cd1$var$isPopoverOpen(popover)) positionOnNextLayout();
    return (0, $86Hb0.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
    (0, $dH1HR.bind)(popover, {
        type: 'toggle',
        listener: function listener(event) {
            var toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), function() {
        return firstLayoutObserver === null || firstLayoutObserver === void 0 ? void 0 : firstLayoutObserver.disconnect();
    }, (0, $dH1HR.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $dH1HR.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), function() {
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}

});
parcelRegister("86Hb0", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return $5e706038a0ecba3b$export$1be1fc439b849fdf; });
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $5e706038a0ecba3b$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("aeqzh", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", function () { return $772fd206795e2c93$export$d5ef1dac02135664; });

var $f53LC = parcelRequire("f53LC");
function $772fd206795e2c93$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $772fd206795e2c93$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $772fd206795e2c93$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $772fd206795e2c93$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * `TCrossAxisShiftOffset` with its CSS length already resolved to pixels. Only
 * this module needs the pixel form, because only this module does arithmetic.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $772fd206795e2c93$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $772fd206795e2c93$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $772fd206795e2c93$var$_objectSpread($772fd206795e2c93$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $772fd206795e2c93$var$_objectSpread($772fd206795e2c93$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $772fd206795e2c93$var$_objectSpread($772fd206795e2c93$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $772fd206795e2c93$var$_objectSpread($772fd206795e2c93$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $772fd206795e2c93$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $772fd206795e2c93$var$_objectSpread($772fd206795e2c93$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $772fd206795e2c93$var$_objectSpread($772fd206795e2c93$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $772fd206795e2c93$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $772fd206795e2c93$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $772fd206795e2c93$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $772fd206795e2c93$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("1BpWS", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", function () { return $12ad5fffb0042daa$export$98721546d2816d9e; });

var $5RLqd = parcelRequire("5RLqd");
/**
 * `null` when the environment cannot measure at all.
 */ function $12ad5fffb0042daa$var$measureWithProbe(_ref) {
    var value = _ref.value, container = _ref.container;
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    var view = container.ownerDocument.defaultView;
    if (!view) return null;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hidden from assistive tech and event targeting; defensive against
    // `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        var resolved = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(resolved) ? resolved : 0;
    } catch (error) {
        (0, $5RLqd.warnFallbackFailure)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $12ad5fffb0042daa$export$98721546d2816d9e(_ref2) {
    var _measureWithProbe;
    var value = _ref2.value, container = _ref2.container;
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    return (_measureWithProbe = $12ad5fffb0042daa$var$measureWithProbe({
        value: value,
        container: container
    })) !== null && _measureWithProbe !== void 0 ? _measureWithProbe : 0;
}

});
parcelRegister("5RLqd", function(module, exports) {
$parcel$export(module.exports, "warnFallbackFailure", function () { return $4456aff6223259a0$export$e142245b95267f17; });

function $4456aff6223259a0$export$e142245b95267f17(_ref) {
    var error = _ref.error;
    return;
}

});



parcelRegister("eNJuh", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorPositioning", function () { return $ac68ed2723ec48e0$export$7192e63dfa9e8124; });

var $df3gI = parcelRequire("df3gI");
var $ac68ed2723ec48e0$export$7192e63dfa9e8124 = (0, $df3gI.createCssDeclarationProbe)({
    property: 'anchor-name',
    value: '--a'
});

});
parcelRegister("df3gI", function(module, exports) {
$parcel$export(module.exports, "createCssDeclarationProbe", function () { return $9a3f36248c133aca$export$69de71b4b7c76bad; });

var $8zODL = parcelRequire("8zODL");
function $9a3f36248c133aca$export$69de71b4b7c76bad(_ref) {
    var property = _ref.property, value = _ref.value;
    return (0, $8zODL.default)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}

});


parcelRegister("jqhEN", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorSize", function () { return $e23e245d388e8650$export$1c8dd0d1c9df9c6e; });

var $df3gI = parcelRequire("df3gI");
var $e23e245d388e8650$export$1c8dd0d1c9df9c6e = (0, $df3gI.createCssDeclarationProbe)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});

});


parcelRegister("lubRD", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", function () { return $fa459a45d378636d$export$9198c6c168be2eeb; });

var $4UF4U = parcelRequire("4UF4U");
function $fa459a45d378636d$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id`, not React's `useId`: React's output contains
    // `:`, `«` and `»`, which are invalid in an HTML id token.
    return "popover-".concat((0, $4UF4U.useId)());
}

});

parcelRegister("f80cP", function(module, exports) {
$parcel$export(module.exports, "getPopupAxisSizes", function () { return $b037c348f96966f5$export$60eb6c71554f82c4; });
/**
 * Maps the legacy `shouldFitContainer` / `shouldFitViewport` pair onto
 * `useAnchoredPopover`'s per-axis sizes. Shared by the standard and the
 * compositional adapter so the two cannot drift.
 *
 * Both props can be set together while `inlineSize` takes one value, so
 * `shouldFitContainer` wins the inline axis, being the more specific request.
 * Fitting then applies to the block axis only, and still turns the
 * placement-axis floor on, so a cramped popup flips rather than letterboxing.
 *
 * Known cost on a `left-*` / `right-*` placement: the anchor floor is unclamped
 * so it can drive the flip, and a min beats a max, so a trigger wider than the
 * viewport is floored past the viewport cap. Not new, and not reconciled - see
 * `@atlaskit/top-layer`'s `notes/decisions/width-from-anchor-floors.md`.
 */ function $b037c348f96966f5$export$60eb6c71554f82c4(_ref) {
    var shouldFitContainer = _ref.shouldFitContainer, shouldFitViewport = _ref.shouldFitViewport;
    var blockSize = shouldFitViewport ? 'max-available' : 'content';
    if (shouldFitContainer) return {
        inlineSize: 'match-anchor',
        blockSize: blockSize
    };
    if (shouldFitViewport) return {
        inlineSize: 'max-available',
        blockSize: blockSize
    };
    return {
        inlineSize: 'content',
        blockSize: blockSize
    };
}

});

parcelRegister("bmNtW", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", function () { return $846821e05da8030e$export$892580369e97d8b9; });

var $1oC0p = parcelRequire("1oC0p");
function $846821e05da8030e$export$892580369e97d8b9(_ref) {
    var role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    return (0, $1oC0p.useMemo)(function() {
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId
            };
            return {
                role: role,
                label: label !== null && label !== void 0 ? label : 'Popup'
            };
        }
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId
    ]);
}

});


parcelRegister("6uqkr", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", function () { return $4b99f7c6562b3fe3$export$4065aef1d79a5730; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $3EAdB = parcelRequire("3EAdB");
function $4b99f7c6562b3fe3$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var canBecomeModal = _appearance === 'UNSAFE_modal-below-sm';
    /**
   * This gate removes unnecessary state changes across the below-sm boundary
   * The state change is only needed if the popup can become a modal - and this is maintained
   */ var shouldUseMediaQuery = !(0, $6ur0l.fg)('platform_dst_popup_media_query_perf_fix') || canBecomeModal;
    var mq = (0, $3EAdB.UNSAFE_useMediaQuery)('below.sm', shouldUseMediaQuery ? function(e) {
        setIsSmallViewport(!!e.matches);
    } : undefined);
    var _useState = (0, $1oC0p.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = canBecomeModal && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("3EAdB", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $2a9133bd18ad421c$export$49e55ae2c03d6045; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $jnTsu = parcelRequire("jnTsu");
var $2a9133bd18ad421c$var$_window, $2a9133bd18ad421c$var$_window$matchMedia, $2a9133bd18ad421c$var$_window2, $2a9133bd18ad421c$var$_window2$matchMedia, $2a9133bd18ad421c$var$_window3, $2a9133bd18ad421c$var$_window3$matchMedia, $2a9133bd18ad421c$var$_window4, $2a9133bd18ad421c$var$_window4$matchMedia, $2a9133bd18ad421c$var$_window5, $2a9133bd18ad421c$var$_window5$matchMedia, $2a9133bd18ad421c$var$_window6, $2a9133bd18ad421c$var$_window6$matchMedia, $2a9133bd18ad421c$var$_window7, $2a9133bd18ad421c$var$_window7$matchMedia, $2a9133bd18ad421c$var$_window8, $2a9133bd18ad421c$var$_window8$matchMedia, $2a9133bd18ad421c$var$_window9, $2a9133bd18ad421c$var$_window9$matchMedia, $2a9133bd18ad421c$var$_window0, $2a9133bd18ad421c$var$_window0$matchMedia, $2a9133bd18ad421c$var$_window1, $2a9133bd18ad421c$var$_window1$matchMedia;
var $2a9133bd18ad421c$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window = window) === null || $2a9133bd18ad421c$var$_window === void 0 || ($2a9133bd18ad421c$var$_window$matchMedia = $2a9133bd18ad421c$var$_window.matchMedia) === null || $2a9133bd18ad421c$var$_window$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window$matchMedia.call($2a9133bd18ad421c$var$_window, (0, $jnTsu.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window2 = window) === null || $2a9133bd18ad421c$var$_window2 === void 0 || ($2a9133bd18ad421c$var$_window2$matchMedia = $2a9133bd18ad421c$var$_window2.matchMedia) === null || $2a9133bd18ad421c$var$_window2$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window2$matchMedia.call($2a9133bd18ad421c$var$_window2, (0, $jnTsu.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window3 = window) === null || $2a9133bd18ad421c$var$_window3 === void 0 || ($2a9133bd18ad421c$var$_window3$matchMedia = $2a9133bd18ad421c$var$_window3.matchMedia) === null || $2a9133bd18ad421c$var$_window3$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window3$matchMedia.call($2a9133bd18ad421c$var$_window3, (0, $jnTsu.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window4 = window) === null || $2a9133bd18ad421c$var$_window4 === void 0 || ($2a9133bd18ad421c$var$_window4$matchMedia = $2a9133bd18ad421c$var$_window4.matchMedia) === null || $2a9133bd18ad421c$var$_window4$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window4$matchMedia.call($2a9133bd18ad421c$var$_window4, (0, $jnTsu.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window5 = window) === null || $2a9133bd18ad421c$var$_window5 === void 0 || ($2a9133bd18ad421c$var$_window5$matchMedia = $2a9133bd18ad421c$var$_window5.matchMedia) === null || $2a9133bd18ad421c$var$_window5$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window5$matchMedia.call($2a9133bd18ad421c$var$_window5, (0, $jnTsu.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window6 = window) === null || $2a9133bd18ad421c$var$_window6 === void 0 || ($2a9133bd18ad421c$var$_window6$matchMedia = $2a9133bd18ad421c$var$_window6.matchMedia) === null || $2a9133bd18ad421c$var$_window6$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window6$matchMedia.call($2a9133bd18ad421c$var$_window6, (0, $jnTsu.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window7 = window) === null || $2a9133bd18ad421c$var$_window7 === void 0 || ($2a9133bd18ad421c$var$_window7$matchMedia = $2a9133bd18ad421c$var$_window7.matchMedia) === null || $2a9133bd18ad421c$var$_window7$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window7$matchMedia.call($2a9133bd18ad421c$var$_window7, (0, $jnTsu.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window8 = window) === null || $2a9133bd18ad421c$var$_window8 === void 0 || ($2a9133bd18ad421c$var$_window8$matchMedia = $2a9133bd18ad421c$var$_window8.matchMedia) === null || $2a9133bd18ad421c$var$_window8$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window8$matchMedia.call($2a9133bd18ad421c$var$_window8, (0, $jnTsu.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window9 = window) === null || $2a9133bd18ad421c$var$_window9 === void 0 || ($2a9133bd18ad421c$var$_window9$matchMedia = $2a9133bd18ad421c$var$_window9.matchMedia) === null || $2a9133bd18ad421c$var$_window9$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window9$matchMedia.call($2a9133bd18ad421c$var$_window9, (0, $jnTsu.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window0 = window) === null || $2a9133bd18ad421c$var$_window0 === void 0 || ($2a9133bd18ad421c$var$_window0$matchMedia = $2a9133bd18ad421c$var$_window0.matchMedia) === null || $2a9133bd18ad421c$var$_window0$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window0$matchMedia.call($2a9133bd18ad421c$var$_window0, (0, $jnTsu.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($2a9133bd18ad421c$var$_window1 = window) === null || $2a9133bd18ad421c$var$_window1 === void 0 || ($2a9133bd18ad421c$var$_window1$matchMedia = $2a9133bd18ad421c$var$_window1.matchMedia) === null || $2a9133bd18ad421c$var$_window1$matchMedia === void 0 ? void 0 : $2a9133bd18ad421c$var$_window1$matchMedia.call($2a9133bd18ad421c$var$_window1, (0, $jnTsu.media).below.xl.replace('@media ', '').trim())
};
var $2a9133bd18ad421c$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $1oC0p.useRef)(listener);
    (0, $1oC0p.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $2a9133bd18ad421c$var$queries[queryString];
    (0, $1oC0p.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dH1HR.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("jnTsu", function(module, exports) {
$parcel$export(module.exports, "media", function () { return $e1cb2f3a664325f7$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $e1cb2f3a664325f7$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("izeje", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $d8469860cc7f84bb$export$7cc5c058dd769dff; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $d8469860cc7f84bb$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $2qaZZ.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("2LdZF", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $202ad36cabf059d2$export$5d3a2de79e07b376; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $202ad36cabf059d2$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $2qaZZ.default)(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});


parcelRegister("eZ4WW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ae8a9a16a9daa6cb$export$2e2bcd8739ae039; });
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $dH1HR = parcelRequire("dH1HR");

var $gzpW5 = parcelRequire("gzpW5");

var $lv5Ml = parcelRequire("lv5Ml");

var $7uNuF = parcelRequire("7uNuF");

var $645Xv = parcelRequire("645Xv");

var $4YraT = parcelRequire("4YraT");

var $5RBBI = parcelRequire("5RBBI");

var $e0047 = parcelRequire("e0047");

var $kKEgK = parcelRequire("kKEgK");

var $aW33c = parcelRequire("aW33c");

var $jp38o = parcelRequire("jp38o");

var $2chlf = parcelRequire("2chlf");

var $97eZA = parcelRequire("97eZA");

var $iQsXC = parcelRequire("iQsXC");

var $1vZTM = parcelRequire("1vZTM");
var $gnDNF = parcelRequire("gnDNF");

var $8mOPg = parcelRequire("8mOPg");

var $2oBVx = parcelRequire("2oBVx");

var $2Hjke = parcelRequire("2Hjke");
function $ae8a9a16a9daa6cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ae8a9a16a9daa6cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ae8a9a16a9daa6cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ae8a9a16a9daa6cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ae8a9a16a9daa6cb$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $ae8a9a16a9daa6cb$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
/**
 * Event types produced by trigger interactions.
 *
 * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
 * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
 * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
 */ function $ae8a9a16a9daa6cb$var$getRootMenuPopover(_ref) {
    var _menu$parentElement;
    var menu = _ref.menu;
    var parentMenu = (_menu$parentElement = menu.parentElement) === null || _menu$parentElement === void 0 ? void 0 : _menu$parentElement.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $ae8a9a16a9daa6cb$var$getRootMenuPopover({
        menu: parentMenu
    });
}
/**
 * Loading indicator for the dropdown menu.
 */ function $ae8a9a16a9daa6cb$var$LoadingIndicator(_ref2) {
    var _ref2$statusLabel = _ref2.statusLabel, statusLabel = _ref2$statusLabel === void 0 ? 'Loading' : _ref2$statusLabel, testId = _ref2.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        role: "menuitem",
        className: (0, $2jatx.default)([
            $ae8a9a16a9daa6cb$var$styles.spinnerContainer
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $kKEgK.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
}
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $ae8a9a16a9daa6cb$var$DropdownMenuTopLayer(_ref3) {
    var _ref5;
    var children = _ref3.children, _ref3$defaultOpen = _ref3.defaultOpen, defaultOpen = _ref3$defaultOpen === void 0 ? false : _ref3$defaultOpen, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, isOpenProp = _ref3.isOpen, _ref3$onOpenChange = _ref3.onOpenChange, onOpenChange = _ref3$onOpenChange === void 0 ? (0, $7uNuF.default) : _ref3$onOpenChange, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom-start' : _ref3$placement, _ref3$shouldFitContai = _ref3.shouldFitContainer, shouldFitContainer = _ref3$shouldFitContai === void 0 ? false : _ref3$shouldFitContai, returnFocusRef = _ref3.returnFocusRef, spacing = _ref3.spacing, statusLabel = _ref3.statusLabel, testId = _ref3.testId, trigger = _ref3.trigger, label = _ref3.label, interactionName = _ref3.interactionName, menuLabel = _ref3.menuLabel;
    var _useControlledState = (0, $645Xv.default)(isOpenProp, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, $2qaZZ.default)(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $1oC0p.useRef)(null);
    var popoverRef = (0, $1oC0p.useRef)(null);
    var popoverId = (0, $8mOPg.usePopoverId)();
    var topLayerPlacement = (0, $1oC0p.useMemo)(function() {
        return (0, $jp38o.fromLegacyPlacement)({
            legacy: placement
        });
    }, [
        placement
    ]);
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen
    });
    (0, $2oBVx.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'min-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: triggerRef,
        isOpen: isLocalOpen
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    var handleOnClose = (0, $1oC0p.useCallback)(function() {
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    var handleTriggerClicked = (0, $1oC0p.useCallback)(function(event) {
        var nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen);
        // Extract the native DOM event for onOpenChange
        var nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    var _useFocus = (0, $4YraT.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $1oC0p.useEffect)(function() {
        var _triggerRef$current;
        if (!isFocused || isLocalOpen) return;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        var isNestedTrigger = Boolean((_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.closest('[role="menu"]'));
        return (0, $dH1HR.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $lv5Ml.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    var handleNestedOpen = (0, $1oC0p.useCallback)(function(_ref4) {
        var trigger = _ref4.trigger;
        trigger.click();
    }, []);
    var handleTabClose = (0, $1oC0p.useCallback)(function() {
        var currentMenu = popoverRef.current;
        if (!currentMenu) return;
        // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $ae8a9a16a9daa6cb$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $gnDNF.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $1vZTM.isAtCurrentMenuLevel)
    });
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    var handleMenuClick = (0, $1oC0p.useCallback)(function(e) {
        var _e$target$closest, _e$target;
        if (!(e.target instanceof Element)) return;
        var menuItem = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        var isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        var isNestedTrigger = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    var ariaAttributes = (0, $aW33c.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    var narrowAriaAttributes = ariaAttributes;
    /**
   * Custom trigger consumers historically receive a callback ref,
   * and their code assumes it is one.
   * Using this wrapper for compatibility...
   */ var setTriggerRef = (0, $1oC0p.useCallback)(function(node) {
        triggerRef.current = node;
    }, []);
    var renderTrigger = function renderTrigger() {
        if (typeof trigger === 'function') return trigger($ae8a9a16a9daa6cb$var$_objectSpread($ae8a9a16a9daa6cb$var$_objectSpread({}, narrowAriaAttributes), {}, {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && "".concat(testId, "--trigger")
        }));
        return /*#__PURE__*/ $1oC0p.createElement((0, $gzpW5.default), (0, $c9bqK.default)({
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef
        }, narrowAriaAttributes, {
            isSelected: isLocalOpen,
            iconAfter: function iconAfter(iconProps) {
                return /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), (0, $c9bqK.default)({}, iconProps, {
                    size: "small"
                }));
            },
            onClick: handleTriggerClicked,
            testId: testId && "".concat(testId, "--trigger"),
            "aria-label": label,
            interactionName: interactionName
        }), trigger);
    };
    return /*#__PURE__*/ $1oC0p.createElement((0, $2Hjke.default), null, renderTrigger(), /*#__PURE__*/ $1oC0p.createElement((0, $2chlf.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: (_ref5 = menuLabel !== null && menuLabel !== void 0 ? menuLabel : label) !== null && _ref5 !== void 0 ? _ref5 : typeof trigger === 'string' ? trigger : 'Menu',
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: topLayerPlacement,
        testId: testId && "".concat(testId, "--content")
    }, /*#__PURE__*/ $1oC0p.createElement((0, $97eZA.PopoverSurface), null, /*#__PURE__*/ $1oC0p.createElement((0, $e0047.default), {
        maxHeight: $ae8a9a16a9daa6cb$var$MAX_HEIGHT,
        maxWidth: shouldFitContainer ? undefined : 800,
        onClick: handleMenuClick,
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-wrapper--menu-group")
    }, isLoading ? /*#__PURE__*/ $1oC0p.createElement($ae8a9a16a9daa6cb$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--menu-wrapper--loading-indicator")
    }) : children))));
}
var $ae8a9a16a9daa6cb$export$2e2bcd8739ae039 = $ae8a9a16a9daa6cb$var$DropdownMenuTopLayer;

});
parcelRegister("e0047", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a3111dc66a4922b6$export$2e2bcd8739ae039; });
/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gSD8q = parcelRequire("gSD8q");

var $6Ujzy = parcelRequire("6Ujzy");
var $a3111dc66a4922b6$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $a3111dc66a4922b6$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $a3111dc66a4922b6$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, $gnQ3X.default)(_ref, $a3111dc66a4922b6$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement((0, $gSD8q.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $1oC0p.createElement((0, $6Ujzy.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $2jatx.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $a3111dc66a4922b6$export$2e2bcd8739ae039 = $a3111dc66a4922b6$var$MenuGroup;

});
parcelRegister("gSD8q", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", function () { return $c4a00bdce2a58e9a$export$443076ec7ebce042; });

var $1oC0p = parcelRequire("1oC0p");

var $c4a00bdce2a58e9a$export$443076ec7ebce042 = /*#__PURE__*/ (0, $1oC0p.createContext)('cozy');

});

parcelRegister("6Ujzy", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $507727b3c154a991$export$9ca534b70725964d; });

var $1oC0p = parcelRequire("1oC0p");
var $507727b3c154a991$export$9ca534b70725964d = /*#__PURE__*/ (0, $1oC0p.createContext)('border');

});


parcelRegister("kKEgK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f1b7571fbdb54412$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $d8s09 = parcelRequire("d8s09");

var $hiA5j = parcelRequire("hiA5j");
/**
 * Returns the appropriate circle stroke color.
 */ function $f1b7571fbdb54412$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $f1b7571fbdb54412$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $f1b7571fbdb54412$var$loadIn = null;
var $f1b7571fbdb54412$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $f1b7571fbdb54412$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $f1b7571fbdb54412$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $hiA5j.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $f1b7571fbdb54412$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $d8s09.default));
    $f1b7571fbdb54412$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $2jatx.default)([
            $f1b7571fbdb54412$var$styles.wrapperStyles,
            $f1b7571fbdb54412$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $2jatx.default)([
            $f1b7571fbdb54412$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $2jatx.default)([
            $f1b7571fbdb54412$var$styles.circleStyles
        ])
    })));
}));
var $f1b7571fbdb54412$export$2e2bcd8739ae039 = $f1b7571fbdb54412$var$Spinner;

});
parcelRegister("d8s09", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9901be375341a274$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $9901be375341a274$var$interactionContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $9901be375341a274$export$2e2bcd8739ae039 = $9901be375341a274$var$interactionContext;

});

parcelRegister("hiA5j", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $c9801bc5705e83aa$export$4e9f1640bbe7a1a8; });
var $c9801bc5705e83aa$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("aW33c", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", function () { return $7f61afee40fa9131$export$9dd1d61dd4d4755; });
/**
 * Roles accepted by `getAriaForTrigger`.
 *
 * Excludes tooltip-family roles (`tooltip`, `note`, `status`, `alert`, `log`)
 * because the correct trigger wiring for those is `aria-describedby`, not
 * `aria-haspopup` / `aria-expanded` / `aria-controls`. Use `aria-describedby`
 * manually for tooltip triggers.
 */ /**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ /**
 * Non-undefined subset of `TAriaHasPopupValue`. Every role accepted by
 * `getAriaForTrigger` maps to a concrete `aria-haspopup` string, so the
 * trigger always receives a defined attribute value.
 */ var $7f61afee40fa9131$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $7f61afee40fa9131$export$9dd1d61dd4d4755(_ref) {
    var role = _ref.role, isOpen = _ref.isOpen, popoverId = _ref.popoverId;
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': $7f61afee40fa9131$var$roleToAriaHasPopup[role],
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("97eZA", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", function () { return $6a3065a90411b802$export$8b7437164e479115; });
/* popover-surface.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6a3065a90411b802$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $6a3065a90411b802$export$8b7437164e479115(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $6a3065a90411b802$var$styles.root
        ])
    }, children);
}

});

parcelRegister("1vZTM", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", function () { return $11a8b37b0f4d5d85$export$f1bba0ef464d60af; });
var $11a8b37b0f4d5d85$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $11a8b37b0f4d5d85$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $11a8b37b0f4d5d85$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $11a8b37b0f4d5d85$export$f1bba0ef464d60af(element, container) {
    var closestMenu = element.closest($11a8b37b0f4d5d85$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $11a8b37b0f4d5d85$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}

});

parcelRegister("gnDNF", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", function () { return $becdaac9202571a5$export$23dfbae28e0cc453; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $f8H33 = parcelRequire("f8H33");

var $lv5Ml = parcelRequire("lv5Ml");

var $2AUaL = parcelRequire("2AUaL");

var $6Q0QR = parcelRequire("6Q0QR");

var $9MqLT = parcelRequire("9MqLT");
var $becdaac9202571a5$var$menuScope = '[role="menu"]';
function $becdaac9202571a5$export$23dfbae28e0cc453(_ref) {
    var containerRef = _ref.containerRef, onClose = _ref.onClose, onNestedOpen = _ref.onNestedOpen, onNestedClose = _ref.onNestedClose, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, filter = _ref.filter;
    var handleKeyDown = (0, $1oC0p.useCallback)(function(event) {
        var _getDocument;
        var container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        var focused = (_getDocument = (0, $f8H33.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($becdaac9202571a5$var$menuScope) !== container) return;
        }
        if (event.key === (0, $lv5Ml.KEY_DOWN)) {
            var _getNextFocusable;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable = (0, $9MqLT.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })) === null || _getNextFocusable === void 0 || _getNextFocusable.focus();
            return;
        }
        if (event.key === (0, $lv5Ml.KEY_UP)) {
            var _getNextFocusable2;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable2 = (0, $9MqLT.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })) === null || _getNextFocusable2 === void 0 || _getNextFocusable2.focus();
            return;
        }
        if (event.key === (0, $lv5Ml.KEY_HOME)) {
            var _getFirstFocusable;
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (_getFirstFocusable = (0, $2AUaL.getFirstFocusable)({
                container: container,
                filter: filter
            })) === null || _getFirstFocusable === void 0 || _getFirstFocusable.focus();
            return;
        }
        if (event.key === (0, $lv5Ml.KEY_END)) {
            var _getLastFocusable;
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (_getLastFocusable = (0, $6Q0QR.getLastFocusable)({
                container: container,
                filter: filter
            })) === null || _getLastFocusable === void 0 || _getLastFocusable.focus();
            return;
        }
        if (event.key === (0, $lv5Ml.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                var _container$parentElem;
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                var isNested = ((_container$parentElem = container.parentElement) === null || _container$parentElem === void 0 ? void 0 : _container$parentElem.closest($becdaac9202571a5$var$menuScope)) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $1oC0p.useEffect)(function() {
        var container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $dH1HR.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});

parcelRegister("2Hjke", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f6e9684323ec880$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $59crJ = parcelRequire("59crJ");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $1f6e9684323ec880$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $1oC0p.useRef)({});
    var context = (0, $1oC0p.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $59crJ.SelectionStoreContext).Provider, {
        value: context
    }, children);
};
var $1f6e9684323ec880$export$2e2bcd8739ae039 = $1f6e9684323ec880$var$SelectionStore;

});
parcelRegister("59crJ", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", function () { return $3bf7729a1442a5d5$export$756f795847463ebd; });

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");
var $3bf7729a1442a5d5$export$756f795847463ebd = /*#__PURE__*/ (0, $1oC0p.createContext)({
    setItemState: (0, $7uNuF.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $7uNuF.default),
    getGroupState: function getGroupState() {
        return {};
    }
});

});



parcelRegister("kYPkX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f4613bb8d5df22d2$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $3BRuV = parcelRequire("3BRuV");

var $jkNLf = parcelRequire("jkNLf");

var $ibpVz = parcelRequire("ibpVz");
/**
 * Focus manager logic.
 */ var $f4613bb8d5df22d2$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $1oC0p.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $1oC0p.useState)(0), _useState2 = (0, $2qaZZ.default)(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $1oC0p.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $1oC0p.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $3BRuV.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    var isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $1oC0p.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bind)(window, {
            type: 'keydown',
            listener: (0, $jkNLf.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        });
    }, [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ibpVz.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $f4613bb8d5df22d2$export$2e2bcd8739ae039 = $f4613bb8d5df22d2$var$FocusManager;

});
parcelRegister("jkNLf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1367c18077dbf7d$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $lv5Ml = parcelRequire("lv5Ml");

var $6ur0l = parcelRequire("6ur0l");

var $b2P2P = parcelRequire("b2P2P");
var $e1367c18077dbf7d$var$actionMap = (0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)({}, (0, $lv5Ml.KEY_DOWN), 'next'), (0, $lv5Ml.KEY_UP), 'prev'), (0, $lv5Ml.KEY_HOME), 'first'), (0, $lv5Ml.KEY_END), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $e1367c18077dbf7d$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $e1367c18077dbf7d$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $e1367c18077dbf7d$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    var isNestedMenu = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $b2P2P.PREFIX), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $lv5Ml.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $lv5Ml.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $lv5Ml.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $lv5Ml.KEY_RIGHT)) {
            var activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        var action = $e1367c18077dbf7d$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $e1367c18077dbf7d$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $e1367c18077dbf7d$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $e1367c18077dbf7d$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $e1367c18077dbf7d$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("b2P2P", function(module, exports) {
$parcel$export(module.exports, "PREFIX", function () { return $80a779fdc756b14a$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "default", function () { return $80a779fdc756b14a$export$2e2bcd8739ae039; });

var $4UF4U = parcelRequire("4UF4U");
var $80a779fdc756b14a$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $80a779fdc756b14a$export$2e2bcd8739ae039() {
    var id = (0, $4UF4U.useId)();
    return "".concat($80a779fdc756b14a$export$8a682ae47622dbb9).concat(id);
}

});


parcelRegister("ibpVz", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", function () { return $d3cd5dc4e86ee29c$export$f18c1d4fc7326096; });

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");
var $d3cd5dc4e86ee29c$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    menuItemRefs: [],
    registerRef: (0, $7uNuF.default)
});

});


parcelRegister("fpWNm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b396cc4fe41b3611$export$2e2bcd8739ae039; });
/* menu-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");


var $e0047 = parcelRequire("e0047");

var $6ur0l = parcelRequire("6ur0l");

var $2sVl0 = parcelRequire("2sVl0");

var $kKEgK = parcelRequire("kKEgK");

var $lfpQV = parcelRequire("lfpQV");

var $aYl69 = parcelRequire("aYl69");

var $ibpVz = parcelRequire("ibpVz");
var $b396cc4fe41b3611$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
var $b396cc4fe41b3611$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement((0, $2sVl0.Box), {
        xcss: $b396cc4fe41b3611$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $1oC0p.createElement((0, $kKEgK.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $b396cc4fe41b3611$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $1oC0p.useContext)((0, $ibpVz.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $lfpQV.default)(menuItem) || (0, $aYl69.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $1oC0p.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $1oC0p.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (((0, $6ur0l.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $e0047.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $1oC0p.createElement($b396cc4fe41b3611$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $b396cc4fe41b3611$export$2e2bcd8739ae039 = $b396cc4fe41b3611$var$MenuWrapper;

});
parcelRegister("lfpQV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f77f0d81a5d4fadc$export$2e2bcd8739ae039; });
function $f77f0d81a5d4fadc$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("aYl69", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7fcfdf9f7453e64e$export$2e2bcd8739ae039; });
function $7fcfdf9f7453e64e$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("819ie", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d65a01ffb9c8846$export$2e2bcd8739ae039; });
// eslint-disable-next-line sort-imports

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $ibpVz = parcelRequire("ibpVz");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $5d65a01ffb9c8846$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $1oC0p.useContext)((0, $ibpVz.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        if (hasPopup && (0, $6ur0l.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $5d65a01ffb9c8846$export$2e2bcd8739ae039 = $5d65a01ffb9c8846$var$useRegisterItemWithFocusManager;

});


parcelRegister("2F6JE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f04a29c92098df8$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $kPutE = parcelRequire("kPutE");

var $3jKf2 = parcelRequire("3jKf2");

var $3aNfC = parcelRequire("3aNfC");

var $fUyZ7 = parcelRequire("fUyZ7");

var $6ur0l = parcelRequire("6ur0l");

var $819ie = parcelRequire("819ie");
var $1f04a29c92098df8$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $1f04a29c92098df8$var$DropdownMenuItem = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, $gnQ3X.default)(_ref, $1f04a29c92098df8$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var isNestedTrigger = !!rest['aria-haspopup'];
    var itemRef = (0, $819ie.default)(isNestedTrigger);
    var handleItemClick = (0, $1oC0p.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3aNfC.default), (0, $c9bqK.default)({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $kPutE.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fUyZ7.default), (0, $c9bqK.default)({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $kPutE.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3jKf2.default), (0, $c9bqK.default)({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $kPutE.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest, isNestedTrigger && (0, $6ur0l.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
        'aria-current': undefined
    } : {}), children);
});
var $1f04a29c92098df8$export$2e2bcd8739ae039 = $1f04a29c92098df8$var$DropdownMenuItem;

});
parcelRegister("3jKf2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26a7040c14ae4b3f$export$2e2bcd8739ae039; });
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $d8s09 = parcelRequire("d8s09");

var $5ELsL = parcelRequire("5ELsL");
var $26a7040c14ae4b3f$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $26a7040c14ae4b3f$var$ButtonItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, $gnQ3X.default)(props, $26a7040c14ae4b3f$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $1oC0p.useContext)((0, $d8s09.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $1oC0p.createElement((0, $5ELsL.default), (0, $c9bqK.default)({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $1oC0p.createElement("button", (0, $c9bqK.default)({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $26a7040c14ae4b3f$export$2e2bcd8739ae039 = $26a7040c14ae4b3f$var$ButtonItem;

});
parcelRegister("5ELsL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $41e5815576fb9a38$export$2e2bcd8739ae039; });
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6ur0l = parcelRequire("6ur0l");

var $iAPkr = parcelRequire("iAPkr");

var $gSD8q = parcelRequire("gSD8q");

var $6Ujzy = parcelRequire("6Ujzy");
var $41e5815576fb9a38$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $1oC0p.createElement(Component, props));
};
var $41e5815576fb9a38$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g",
    motionUnselected: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $41e5815576fb9a38$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $41e5815576fb9a38$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $41e5815576fb9a38$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $1oC0p.useContext)((0, $gSD8q.SpacingContext));
    var selectionStyle = (0, $1oC0p.useContext)((0, $6Ujzy.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $2jatx.default)([
                (0, $2jatx.default)([
                    $41e5815576fb9a38$var$styles.root,
                    $41e5815576fb9a38$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $41e5815576fb9a38$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') && $41e5815576fb9a38$var$styles.motionUnselected,
                    !isDisabled && isSelected && $41e5815576fb9a38$var$styles.selected,
                    !isDisabled && isSelected && (0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') && $41e5815576fb9a38$var$styles.motionSelected,
                    !isDisabled && isSelected && $41e5815576fb9a38$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $41e5815576fb9a38$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $41e5815576fb9a38$var$styles.selectedNotch,
                    isDisabled && $41e5815576fb9a38$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $1oC0p.createElement((0, $iAPkr.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $41e5815576fb9a38$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $1oC0p.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $2jatx.default)([
                    $41e5815576fb9a38$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $1oC0p.createElement("div", {
                className: (0, $2jatx.default)([
                    $41e5815576fb9a38$var$styles.content
                ])
            }, $41e5815576fb9a38$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $2jatx.default)([
                    $41e5815576fb9a38$var$styles.title,
                    shouldTitleWrap ? $41e5815576fb9a38$var$styles.wordBreak : $41e5815576fb9a38$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $1oC0p.createElement("span", {
                "data-item-description": true,
                className: (0, $2jatx.default)([
                    $41e5815576fb9a38$var$styles.description,
                    isDisabled && $41e5815576fb9a38$var$styles.disabledDescription,
                    shouldDescriptionWrap && $41e5815576fb9a38$var$styles.wordBreak,
                    !shouldDescriptionWrap && $41e5815576fb9a38$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $1oC0p.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $2jatx.default)([
                    $41e5815576fb9a38$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $41e5815576fb9a38$export$2e2bcd8739ae039 = $41e5815576fb9a38$var$MenuItemPrimitive;

});


parcelRegister("3aNfC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24f88279c234797c$export$2e2bcd8739ae039; });
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $d8s09 = parcelRequire("d8s09");

var $5ELsL = parcelRequire("5ELsL");
var $24f88279c234797c$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $24f88279c234797c$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $24f88279c234797c$var$CustomItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, $gnQ3X.default)(_ref, $24f88279c234797c$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $1oC0p.useContext)((0, $d8s09.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $1oC0p.createElement((0, $5ELsL.default), (0, $c9bqK.default)({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $24f88279c234797c$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $24f88279c234797c$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $24f88279c234797c$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled || undefined
        }), children);
    });
}));
var $24f88279c234797c$export$2e2bcd8739ae039 = $24f88279c234797c$var$CustomItem;

});

parcelRegister("fUyZ7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b9573939dca2874a$export$2e2bcd8739ae039; });
/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $exiIf = parcelRequire("exiIf");

var $d8s09 = parcelRequire("d8s09");

var $5ELsL = parcelRequire("5ELsL");
var $b9573939dca2874a$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $b9573939dca2874a$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $b9573939dca2874a$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $b9573939dca2874a$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $b9573939dca2874a$var$LinkItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, $gnQ3X.default)(props, $b9573939dca2874a$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $exiIf.useRouterLink)();
    var interactionContext = (0, $1oC0p.useContext)((0, $d8s09.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $b9573939dca2874a$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $b9573939dca2874a$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $1oC0p.createElement((0, $5ELsL.default), (0, $c9bqK.default)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $b9573939dca2874a$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $b9573939dca2874a$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $b9573939dca2874a$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled || undefined,
            ref: ref
        }), children);
    });
}));
var $b9573939dca2874a$export$2e2bcd8739ae039 = $b9573939dca2874a$var$LinkItem;

});
parcelRegister("exiIf", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", function () { return $a952a9b25975f955$export$6d558eab13290f59; });

var $1oC0p = parcelRequire("1oC0p");

var $9d01f = parcelRequire("9d01f");
var $a952a9b25975f955$export$6d558eab13290f59 = function useRouterLink() {
    var _useContext = (0, $1oC0p.useContext)((0, $9d01f.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("9d01f", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $6b4557bd30146432$export$2931e0ee690eee88; });

var $1oC0p = parcelRequire("1oC0p");
var $6b4557bd30146432$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $1oC0p.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $6b4557bd30146432$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($6b4557bd30146432$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$6b4557bd30146432$export$2e2bcd8739ae039 = $6b4557bd30146432$var$RouterLinkProvider;

});




parcelRegister("gydt6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c0ca44dee7e66262$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $4UF4U = parcelRequire("4UF4U");

var $eLcCD = parcelRequire("eLcCD");

var $bbNKW = parcelRequire("bbNKW");
var $c0ca44dee7e66262$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $c0ca44dee7e66262$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, $gnQ3X.default)(_ref, $c0ca44dee7e66262$var$_excluded);
    var uid = (0, $4UF4U.useId)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eLcCD.default), (0, $c9bqK.default)({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bbNKW.default), {
        id: titleId,
        title: title
    }), children);
});
var $c0ca44dee7e66262$export$2e2bcd8739ae039 = $c0ca44dee7e66262$var$DropdownMenuItemGroup;

});
parcelRegister("eLcCD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $abef3efa794f838e$export$2e2bcd8739ae039; });
/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lrruV = parcelRequire("lrruV");
var $abef3efa794f838e$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "label",
    "className"
];
var $abef3efa794f838e$var$itemHeadingTopMargin = 20;
var $abef3efa794f838e$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $abef3efa794f838e$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $abef3efa794f838e$var$skeletonHeadingHeight = 8;
var $abef3efa794f838e$var$skeletonHeadingMarginOffset = 3;
var $abef3efa794f838e$var$skeletonHeadingTopMargin = $abef3efa794f838e$var$itemHeadingTopMargin + ($abef3efa794f838e$var$itemHeadingContentHeight - $abef3efa794f838e$var$skeletonHeadingHeight) - $abef3efa794f838e$var$skeletonHeadingMarginOffset;
var $abef3efa794f838e$var$sectionPaddingTopBottom = 6;
var $abef3efa794f838e$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $abef3efa794f838e$var$Section = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, label = _ref.label, UNSAFE_className = _ref.className, rest = (0, $gnQ3X.default)(_ref, $abef3efa794f838e$var$_excluded);
    var content = isList ? /*#__PURE__*/ $1oC0p.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $1oC0p.Children).map((0, $1oC0p.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $1oC0p.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement((0, $lrruV.default), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            isSideNavSection && $abef3efa794f838e$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, content);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2jatx.default)([
            $abef3efa794f838e$var$styles.root,
            isScrollable ? $abef3efa794f838e$var$styles.scrollable : $abef3efa794f838e$var$styles.unscrollable,
            hasSeparator ? $abef3efa794f838e$var$styles.thinSeparator : $abef3efa794f838e$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $abef3efa794f838e$export$2e2bcd8739ae039 = $abef3efa794f838e$var$Section;

});
parcelRegister("lrruV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9c17313756cc8eb$export$2e2bcd8739ae039; });
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $f9c17313756cc8eb$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $f9c17313756cc8eb$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $f9c17313756cc8eb$var$HeadingItem = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, $gnQ3X.default)(_ref, $f9c17313756cc8eb$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $2jatx.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ])
    }, rest), children);
});
var $f9c17313756cc8eb$export$2e2bcd8739ae039 = $f9c17313756cc8eb$var$HeadingItem;

});


parcelRegister("bbNKW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8257515012d151f6$export$2e2bcd8739ae039; });
/* group-title.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $1oC0p = parcelRequire("1oC0p");

var $2sVl0 = parcelRequire("2sVl0");
var $8257515012d151f6$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ var $8257515012d151f6$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2sVl0.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $8257515012d151f6$var$styles.heading
    }, title);
};
var $8257515012d151f6$export$2e2bcd8739ae039 = $8257515012d151f6$var$GroupTitle;

});


parcelRegister("9NuKL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdb9e6baa42be79f49a55523cb2c1b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72208b9d41804615$var$_react = $72208b9d41804615$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $72208b9d41804615$var$_iconNew = $72208b9d41804615$var$_interopRequireDefault((parcelRequire("fBroF")));
function $72208b9d41804615$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/show-more-horizontal
 * Usage guidance:
 * Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72208b9d41804615$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $72208b9d41804615$var$_react.default.createElement($72208b9d41804615$var$_iconNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$72208b9d41804615$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $72208b9d41804615$var$_default = module.exports.default = $72208b9d41804615$var$ShowMoreHorizontalIcon;

});


parcelRegister("bcLWE", function(module, exports) {
$parcel$export(module.exports, "useOnRevealed", function () { return $8286018e4ee59a41$export$e9c4922b2ecf808a; });

var $1oC0p = parcelRequire("1oC0p");

var $hkAJf = parcelRequire("hkAJf");
function $8286018e4ee59a41$export$e9c4922b2ecf808a(callback, _ref) {
    var isExpanded = _ref.isExpanded, isDisabled = _ref.isDisabled;
    var prevExtended = (0, $hkAJf.default)(isExpanded);
    (0, $1oC0p.useEffect)(function() {
        var hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});

parcelRegister("kLlT5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f1d92cd2d3d16b0b$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $f1d92cd2d3d16b0b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f1d92cd2d3d16b0b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f1d92cd2d3d16b0b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f1d92cd2d3d16b0b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f1d92cd2d3d16b0b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f1d92cd2d3d16b0b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// The ellipsis trigger is a compact IconButton (24px) plus the trailing separator (24px).
var $f1d92cd2d3d16b0b$var$ELLIPSIS_WIDTH_ESTIMATE = 48;
// Measurements need layout timing in the browser, but should be a no-op for SSR.
var $f1d92cd2d3d16b0b$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
function $f1d92cd2d3d16b0b$var$setsEqual(a, b) {
    if (a.size !== b.size) return false;
    var _iterator = $f1d92cd2d3d16b0b$var$_createForOfIteratorHelper(a), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var v = _step.value;
            if (!b.has(v)) return false;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return true;
}
function $f1d92cd2d3d16b0b$var$getMiddleOutCollapseOrder(itemCount) {
    var lastIndex = itemCount - 1;
    var middleIndex = Math.floor((itemCount - 1) / 2);
    var collapseOrder = [];
    if (middleIndex > 0 && middleIndex < lastIndex) collapseOrder.push(middleIndex);
    for(var distance = 1; distance < itemCount; distance++){
        var leftIndex = middleIndex - distance;
        var rightIndex = middleIndex + distance;
        if (leftIndex > 0) collapseOrder.push(leftIndex);
        if (rightIndex < lastIndex) collapseOrder.push(rightIndex);
    }
    return collapseOrder;
}
function $f1d92cd2d3d16b0b$export$2e2bcd8739ae039(itemCount) {
    var itemRefs = (0, $1oC0p.useRef)([]);
    var containerRef = (0, $1oC0p.useRef)(null);
    var naturalWidths = (0, $1oC0p.useRef)([]);
    var naturalWidthsReady = (0, $1oC0p.useRef)(false);
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), naturalWidthsReadyState = _useState2[0], setNaturalWidthsReadyState = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(new Set()), _useState4 = (0, $2qaZZ.default)(_useState3, 2), collapsedIndices = _useState4[0], setCollapsedIndices = _useState4[1];
    // Intentionally runs after each render until refs have committed and natural widths are measured.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $f1d92cd2d3d16b0b$var$useLayoutEffect(function() {
        if (naturalWidthsReady.current) return;
        var widths = itemRefs.current.map(function(el) {
            var _el$offsetWidth;
            return (_el$offsetWidth = el === null || el === void 0 ? void 0 : el.offsetWidth) !== null && _el$offsetWidth !== void 0 ? _el$offsetWidth : 0;
        });
        if (widths.some(function(w) {
            return w > 0;
        })) {
            naturalWidths.current = widths;
            naturalWidthsReady.current = true;
            setNaturalWidthsReadyState(true);
        }
    });
    var recalculate = (0, $1oC0p.useCallback)(function() {
        var container = containerRef.current;
        if (!container || !naturalWidthsReady.current) return;
        var availableWidth = container.offsetWidth;
        var widths = naturalWidths.current;
        if (itemCount <= 2) {
            setCollapsedIndices(function(prev) {
                return prev.size === 0 ? prev : new Set();
            });
            return;
        }
        var totalWidth = widths.reduce(function(sum, w) {
            return sum + w;
        }, 0);
        if (totalWidth <= availableWidth) {
            setCollapsedIndices(function(prev) {
                return prev.size === 0 ? prev : new Set();
            });
            return;
        }
        var usedWidth = totalWidth;
        var newCollapsed = new Set();
        var _iterator2 = $f1d92cd2d3d16b0b$var$_createForOfIteratorHelper($f1d92cd2d3d16b0b$var$getMiddleOutCollapseOrder(itemCount)), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _widths$index;
                var index = _step2.value;
                if (newCollapsed.size === 0) usedWidth += $f1d92cd2d3d16b0b$var$ELLIPSIS_WIDTH_ESTIMATE;
                newCollapsed.add(index);
                usedWidth -= (_widths$index = widths[index]) !== null && _widths$index !== void 0 ? _widths$index : 0;
                if (usedWidth <= availableWidth) break;
            }
        // At the smallest sizes, even first + ellipsis + last may not fit.
        // In that case, also collapse the first item so only ellipsis + last is shown.
        // Note: this branch is only reachable when itemCount > 2 (the early return above
        // handles itemCount <= 2), so collapsing index 0 here always leaves at least one
        // visible item (the last) plus the ellipsis trigger.
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        if (usedWidth > availableWidth) newCollapsed.add(0);
        setCollapsedIndices(function(prev) {
            return $f1d92cd2d3d16b0b$var$setsEqual(prev, newCollapsed) ? prev : newCollapsed;
        });
    }, [
        itemCount
    ]);
    var registerItem = (0, $1oC0p.useCallback)(function(index) {
        return function(el) {
            itemRefs.current[index] = el;
        };
    }, []);
    var observerRef = (0, $1oC0p.useRef)(null);
    var registerContainer = (0, $1oC0p.useCallback)(function(el) {
        var _observerRef$current;
        // Disconnect any existing observer
        (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || _observerRef$current.disconnect();
        containerRef.current = el;
        if (!el) return;
        if (typeof ResizeObserver === 'undefined') return;
        // Set up ResizeObserver immediately when container mounts
        var observer = new ResizeObserver(function() {
            recalculate();
        });
        observer.observe(el);
        observerRef.current = observer;
    }, [
        recalculate
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (naturalWidthsReadyState) recalculate();
    }, [
        naturalWidthsReadyState,
        recalculate
    ]);
    // Cleanup observer on unmount
    (0, $1oC0p.useEffect)(function() {
        return function() {
            var _observerRef$current2;
            (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 || _observerRef$current2.disconnect();
        };
    }, []);
    (0, $1oC0p.useEffect)(function() {
        naturalWidthsReady.current = false;
        naturalWidths.current = [];
        setNaturalWidthsReadyState(false);
        setCollapsedIndices(new Set());
    }, [
        itemCount
    ]);
    return {
        collapsedIndices: collapsedIndices,
        naturalWidthsReady: naturalWidthsReadyState,
        registerItem: registerItem,
        registerContainer: registerContainer
    };
}

});


parcelRegister("eo5T7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $02b3ff7b366d6fac$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $gnCSJ = parcelRequire("gnCSJ");

var $6jtA2 = parcelRequire("6jtA2");

var $6dioi = parcelRequire("6dioi");
function $02b3ff7b366d6fac$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTab = (0, $6dioi.useTab)(), onClick = _useTab.onClick, id = _useTab.id, ariaControls = _useTab['aria-controls'], ariaPosinset = _useTab['aria-posinset'], ariaSelected = _useTab['aria-selected'], ariaSetsize = _useTab['aria-setsize'], onMouseDown = _useTab.onMouseDown, onKeyDown = _useTab.onKeyDown, role = _useTab.role, tabIndex = _useTab.tabIndex;
    return (0, $3dJ4i.jsx)((0, $6jtA2.default), {
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onMouseDown: onMouseDown,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex
    }, (0, $3dJ4i.jsx)((0, $gnCSJ.default), {
        shouldTruncate: true,
        UNSAFE_style: {
            color: 'inherit'
        }
    }, children));
}

});


parcelRegister("jzTDB", function(module, exports) {
$parcel$export(module.exports, "SurveyResponses", function () { return $6ac297cca63e97d7$export$93afb6cb3420c788; });
/* survey-responses.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $15dQb = parcelRequire("15dQb");

var $2r6UE = parcelRequire("2r6UE");

var $lw19E = parcelRequire("lw19E");

var $7qDyl = parcelRequire("7qDyl");

var $izDBw = parcelRequire("izDBw");

var $lPRxe = parcelRequire("lPRxe");

var $FapDU = parcelRequire("FapDU");

var $4s9kO = parcelRequire("4s9kO");

var $hZhs9 = parcelRequire("hZhs9");

var $8ktfY = parcelRequire("8ktfY");

var $aRZvb = parcelRequire("aRZvb");

var $fhOxS = parcelRequire("fhOxS");

var $5GoT9 = parcelRequire("5GoT9");

var $6IpWw = parcelRequire("6IpWw");

var $cKK6Q = parcelRequire("cKK6Q");

var $bygH9 = parcelRequire("bygH9");

var $1Uelu = parcelRequire("1Uelu");
const $6ac297cca63e97d7$var$OpenPanelIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7qDyl))), {
        label: "",
        size: "medium"
    });
const $6ac297cca63e97d7$var$ExportIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lw19E))), {
        label: "",
        size: "medium"
    });
const $6ac297cca63e97d7$var$noop = ()=>{};
const $6ac297cca63e97d7$export$93afb6cb3420c788 = ({ openResponseId: openResponseId, panelResponseId: panelResponseId, onOpenResponseChange: onOpenResponseChange, revealedResponseId: revealedResponseId = null })=>{
    const intl = (0, $8e22h.default)();
    const panelId = (0, $1oC0p.useId)();
    const regionRef = (0, $1oC0p.useRef)(null);
    const panelResponse = (0, $4s9kO.surveyResponses).find((response)=>response.id === panelResponseId);
    const isPanelOpen = openResponseId !== null;
    const toggleResponse = (responseId)=>onOpenResponseChange(openResponseId === responseId ? null : responseId);
    const closePanel = ()=>{
        onOpenResponseChange(null);
        regionRef.current?.querySelector(`[data-response-id="${panelResponseId}"] button`)?.focus();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulppxbi _vchhusvi _1bsb1osq _1q511ejb _18zrxy5q"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c116y _4cvr1h6o _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                                level: 3,
                                size: "small",
                                children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).tabResponses)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $15dQb.default), {
                                children: (0, $4s9kO.surveyTotals).responses
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                        "aria-hidden": "true",
                        // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
                        inert: "",
                        className: (0, $2jatx.default)([
                            "_1e0c116y _4cvr1h6o _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bsbd36x"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5GoT9.JsmPlaygroundSearchField), {
                                    label: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).searchResponses),
                                    placeholder: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).searchResponses),
                                    tabIndex: -1
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                icon: $6ac297cca63e97d7$var$ExportIcon,
                                label: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).exportResponses),
                                onClick: $6ac297cca63e97d7$var$noop,
                                tabIndex: -1
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: regionRef,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1o9zidpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1Uelu.SurveyTable), {
                            caption: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).responsesTableCaption),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1Uelu.SurveyTableHead), {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyHeadCell), {
                                            width: 245,
                                            isFirst: true,
                                            children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).columnRespondent)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyHeadCell), {
                                            width: 285,
                                            children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionOne)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyHeadCell), {
                                            width: 365,
                                            children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionTwo)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyHeadCell), {
                                            children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).columnSubmitted)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyTableBody), {
                                    children: (0, $4s9kO.surveyResponses).map((response, index)=>{
                                        const { answers: answers, id: id, respondent: respondent, satisfaction: satisfaction } = response;
                                        const isOpen = id === openResponseId;
                                        return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1Uelu.SurveyTableRow), {
                                            index: index,
                                            isSelected: isOpen,
                                            isActionRevealed: id === revealedResponseId,
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyCell), {
                                                    isFirst: true,
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                        className: (0, $2jatx.default)([
                                                            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                                className: (0, $2jatx.default)([
                                                                    "_1e0c1txw _4cvr1h6o _zulpu2gc _1ul9idpf"
                                                                ]),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aRZvb.JsmPlaygroundPersonAvatar), {
                                                                        src: (0, $cKK6Q.surveyRespondentAvatars)[id]
                                                                    }),
                                                                    answers ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                        className: (0, $2jatx.default)([
                                                                            "_1ul9idpf _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                                                        ]),
                                                                        children: respondent
                                                                    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                                                                                children: respondent
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhOxS.JsmPlaygroundRedactedLine), {
                                                                                width: 96
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            answers && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyRowAction), {
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    "data-response-id": id,
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                                        appearance: "subtle",
                                                                        "aria-controls": panelId,
                                                                        "aria-expanded": isOpen,
                                                                        icon: $6ac297cca63e97d7$var$OpenPanelIcon,
                                                                        isSelected: isOpen,
                                                                        label: intl.formatMessage(isOpen ? (0, $hZhs9.jsmPortalPlaygroundHrMessages).closeResponse : (0, $hZhs9.jsmPortalPlaygroundHrMessages).openResponse, {
                                                                            name: respondent
                                                                        }),
                                                                        onClick: ()=>toggleResponse(id),
                                                                        spacing: "compact"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyCell), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izDBw.default), {
                                                        appearance: (0, $4s9kO.surveyChoiceAppearances)[satisfaction],
                                                        children: answers ? intl.formatMessage((0, $4s9kO.surveyChoiceLabels)[satisfaction]) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhOxS.JsmPlaygroundRedactedLine), {
                                                            width: 56
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyCell), {
                                                    children: answers ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                        children: intl.formatMessage(answers.rewarding)
                                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhOxS.JsmPlaygroundRedactedLine), {
                                                        width: 220
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyCell), {
                                                    children: answers ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                        color: "color.text.subtle",
                                                        children: intl.formatDate(answers.submitted, {
                                                            dateStyle: 'medium',
                                                            timeStyle: 'short',
                                                            timeZone: 'UTC'
                                                        })
                                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhOxS.JsmPlaygroundRedactedLine), {
                                                        width: 104
                                                    })
                                                })
                                            ]
                                        }, id);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6IpWw.JsmPlaygroundSidePanel), {
                        isOpen: isPanelOpen,
                        testId: "jsm-hr-survey-response-track",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: panelId,
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq"
                            ]),
                            children: panelResponse?.answers && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bygH9.SurveyResponsePanel), {
                                response: {
                                    ...panelResponse,
                                    answers: panelResponse.answers
                                },
                                onClose: closePanel
                            }, panelResponse.id)
                        })
                    })
                ]
            })
        ]
    });
};
// ADS pads every tab panel by 8px inline, so this is the header's 32px less that.
const $6ac297cca63e97d7$var$responsesStyles = null;
const $6ac297cca63e97d7$var$headingRowStyles = null;
const $6ac297cca63e97d7$var$headingStyles = null;
const $6ac297cca63e97d7$var$toolbarStyles = null;
const $6ac297cca63e97d7$var$searchFieldStyles = null;
// Sized by the table, not the stage, so the panel beside it starts and ends level with it.
const $6ac297cca63e97d7$var$regionStyles = null;
const $6ac297cca63e97d7$var$tableColumnStyles = null;
const $6ac297cca63e97d7$var$respondentCellStyles = null;
const $6ac297cca63e97d7$var$personStyles = null;
const $6ac297cca63e97d7$var$nameStyles = null;
const $6ac297cca63e97d7$var$panelFillStyles = null;

});
parcelRegister("lw19E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa9d7b6bcc74fbc3$var$_react = $fa9d7b6bcc74fbc3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $fa9d7b6bcc74fbc3$var$_baseNew = $fa9d7b6bcc74fbc3$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $fa9d7b6bcc74fbc3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa9d7b6bcc74fbc3$var$DownloadIcon = (props)=>/*#__PURE__*/ $fa9d7b6bcc74fbc3$var$_react.default.createElement($fa9d7b6bcc74fbc3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$fa9d7b6bcc74fbc3$var$DownloadIcon.displayName = 'DownloadIcon';
var $fa9d7b6bcc74fbc3$var$_default = module.exports.default = $fa9d7b6bcc74fbc3$var$DownloadIcon;

});

parcelRegister("7qDyl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b10c2aaa76d32294bc7ed1c0a1888df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5689a47b296ece4e$var$_react = $5689a47b296ece4e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5689a47b296ece4e$var$_baseNew = $5689a47b296ece4e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $5689a47b296ece4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5689a47b296ece4e$var$PanelRightIcon = (props)=>/*#__PURE__*/ $5689a47b296ece4e$var$_react.default.createElement($5689a47b296ece4e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$5689a47b296ece4e$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $5689a47b296ece4e$var$_default = module.exports.default = $5689a47b296ece4e$var$PanelRightIcon;

});

parcelRegister("aRZvb", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundPersonAvatar", function () { return $d8c3ab1ef7881fe0$export$ddaa82c04f3fee49; });
/* jsm-playground-person-avatar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $4SA4u = parcelRequire("4SA4u");
const $d8c3ab1ef7881fe0$export$ddaa82c04f3fee49 = ({ src: src })=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_1e0c116y _1o9zidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
            size: "small",
            src: src
        })
    });
const $d8c3ab1ef7881fe0$var$avatarWrapperStyles = null;

});

parcelRegister("fhOxS", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundRedactedLine", function () { return $ccd14ac10dc7a4b1$export$22176b29baa0cc44; });
/* jsm-playground-redacted-line.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $4jcRW = parcelRequire("4jcRW");
const $ccd14ac10dc7a4b1$export$22176b29baa0cc44 = ({ width: width })=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_1e0c116y _1o9zidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
            borderRadius: "var(--ds-radius-xsmall, 2px)",
            height: "10px",
            isShimmering: false,
            width: `${width}px`
        })
    });
const $ccd14ac10dc7a4b1$var$redactedLineStyles = null;

});

parcelRegister("6IpWw", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundSidePanel", function () { return $ff2b819735c43986$export$30949bb046cf3d89; });
/* jsm-playground-side-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $ff2b819735c43986$export$30949bb046cf3d89 = ({ isOpen: isOpen, children: children, testId: testId })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": testId,
        "aria-hidden": !isOpen,
        // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
        inert: isOpen ? undefined : '',
        className: (0, $2jatx.default)([
            "_kqswh2mm _1o9zidpf _1wpz1fhb _1bsbidpf _tzy4idpf _1reo15vq _18m915vq _v56417l2 _sedtglyw",
            isOpen && "_1bsbqvgw _tzy4kb7n"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _kqswstnw _1cclidpf _rjxpidpf _1bsbp59q"
            ]),
            children: children
        })
    });
const $ff2b819735c43986$var$PANEL_WIDTH = '348px';
const $ff2b819735c43986$var$PANEL_GUTTER = "var(--ds-space-300, 24px)";
const $ff2b819735c43986$var$trackStyles = null;
const $ff2b819735c43986$var$trackOpenStyles = null;
const $ff2b819735c43986$var$panelSlotStyles = null;

});

parcelRegister("cKK6Q", function(module, exports) {
$parcel$export(module.exports, "surveyRespondentAvatars", function () { return $31b4f9cbdb883307$export$c6ee6547f4780a8c; });

var $b92Wa = parcelRequire("b92Wa");

var $45Guj = parcelRequire("45Guj");

var $dZcHX = parcelRequire("dZcHX");

var $4C1Kj = parcelRequire("4C1Kj");

var $lxpvK = parcelRequire("lxpvK");

var $au1C6 = parcelRequire("au1C6");

var $9SHlv = parcelRequire("9SHlv");

var $iHttj = parcelRequire("iHttj");
const $31b4f9cbdb883307$export$c6ee6547f4780a8c = {
    'priya-hansra': (0, (/*@__PURE__*/$parcel$interopDefault($au1C6))),
    'raul-gonzalez': (0, (/*@__PURE__*/$parcel$interopDefault($9SHlv))),
    'olivia-yang': (0, (/*@__PURE__*/$parcel$interopDefault($lxpvK))),
    'liam-estrada': (0, (/*@__PURE__*/$parcel$interopDefault($dZcHX))),
    'melanie-lee': (0, (/*@__PURE__*/$parcel$interopDefault($4C1Kj))),
    'robi-lopez': (0, (/*@__PURE__*/$parcel$interopDefault($iHttj))),
    'florence-garcia': (0, (/*@__PURE__*/$parcel$interopDefault($45Guj))),
    'charles-rex': (0, (/*@__PURE__*/$parcel$interopDefault($b92Wa)))
};

});
parcelRegister("b92Wa", function(module, exports) {
module.exports = new URL("charles-rex.9c35ddda.svg", import.meta.url).toString();

});

parcelRegister("45Guj", function(module, exports) {
module.exports = new URL("florence-garcia.d025ed3d.svg", import.meta.url).toString();

});

parcelRegister("dZcHX", function(module, exports) {
module.exports = new URL("liam-estrada.c11a3375.svg", import.meta.url).toString();

});

parcelRegister("4C1Kj", function(module, exports) {
module.exports = new URL("melanie-lee.2073b9d2.svg", import.meta.url).toString();

});

parcelRegister("lxpvK", function(module, exports) {
module.exports = new URL("olivia-yang.c5b87205.svg", import.meta.url).toString();

});

parcelRegister("au1C6", function(module, exports) {
module.exports = new URL("priya-hansra.4f1e4341.svg", import.meta.url).toString();

});

parcelRegister("9SHlv", function(module, exports) {
module.exports = new URL("raul-gonzalez.d0ff0024.svg", import.meta.url).toString();

});

parcelRegister("iHttj", function(module, exports) {
module.exports = new URL("robi-lopez.a1cbb413.svg", import.meta.url).toString();

});


parcelRegister("bygH9", function(module, exports) {
$parcel$export(module.exports, "SurveyResponsePanel", function () { return $9a4eec301bf930ad$export$9cb2b1fe6a667db2; });
/* survey-response-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2r6UE = parcelRequire("2r6UE");

var $56bcs = parcelRequire("56bcs");

var $cNOwN = parcelRequire("cNOwN");

var $96S9r = parcelRequire("96S9r");

var $9aJkx = parcelRequire("9aJkx");

var $izDBw = parcelRequire("izDBw");

var $lPRxe = parcelRequire("lPRxe");

var $4s9kO = parcelRequire("4s9kO");

var $hZhs9 = parcelRequire("hZhs9");

var $8ktfY = parcelRequire("8ktfY");

var $aRZvb = parcelRequire("aRZvb");

var $cKK6Q = parcelRequire("cKK6Q");
const $9a4eec301bf930ad$var$CloseIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
        label: "",
        size: "medium"
    });
const $9a4eec301bf930ad$var$ExpandIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96S9r))), {
        label: "",
        size: "medium"
    });
const $9a4eec301bf930ad$var$noop = ()=>{};
const $9a4eec301bf930ad$export$9cb2b1fe6a667db2 = ({ response: response, onClose: onClose })=>{
    const intl = (0, $8e22h.default)();
    const { id: id, respondent: respondent, satisfaction: satisfaction, answers: answers } = response;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "aria-label": intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).responsePanelLabel, {
            name: respondent
        }),
        "data-testid": "jsm-hr-survey-response-panel",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _1bsb1osq _4t3i1osq _19itia51 _2rko1mok _bfhkvuon _1reo15vq _18m91wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _zulpu2gc _1yt4pxbi _179ria51"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9aJkx))), {
                        color: "var(--ds-icon, #292A2E)",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                            level: 3,
                            size: "small",
                            children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).surveyResponse)
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_1e0c116y _lcxvglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                            appearance: "subtle",
                            icon: $9a4eec301bf930ad$var$ExpandIcon,
                            label: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).expandResponse),
                            onClick: $9a4eec301bf930ad$var$noop,
                            tabIndex: -1
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                        icon: $9a4eec301bf930ad$var$CloseIcon,
                        label: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).closeResponsePanel),
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _y44vl647 _1bumglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulputpp _1q51pxbi _18zrpxbi"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulpu2gc"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aRZvb.JsmPlaygroundPersonAvatar), {
                                        src: (0, $cKK6Q.surveyRespondentAvatars)[id]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        weight: "medium",
                                        children: respondent
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulp1b66 _vchhusvi _4t3i1tcg _18zru2gc _19itia51 _2rko12b0 _syazi7uo _11c8fhey _o5721q9c"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($56bcs))), {
                                        color: "var(--ds-icon-subtle, #505258)",
                                        label: "",
                                        size: "small"
                                    }),
                                    intl.formatDate(answers.submitted, {
                                        dateStyle: 'medium',
                                        timeStyle: 'short',
                                        timeZone: 'UTC'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("dl", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _18zrpxbi _85i5u2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulpu2gc _1rjcpxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("dt", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulpu2gc _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                color: "color.text.subtle",
                                                children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionOneShort)
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                weight: "bold",
                                                children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionOne)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("dd", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izDBw.default), {
                                            appearance: (0, $4s9kO.surveyChoiceAppearances)[satisfaction],
                                            children: intl.formatMessage((0, $4s9kO.surveyChoiceLabels)[satisfaction])
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulpu2gc _1rjcpxbi",
                                    "_mqm2ia51"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("dt", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulpu2gc _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                color: "color.text.subtle",
                                                children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionTwoShort)
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                weight: "bold",
                                                children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionTwo)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("dd", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                            children: intl.formatMessage(answers.rewarding)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $9a4eec301bf930ad$var$swapIn = null;
const $9a4eec301bf930ad$var$panelStyles = null;
const $9a4eec301bf930ad$var$panelHeaderStyles = null;
const $9a4eec301bf930ad$var$panelTitleStyles = null;
const $9a4eec301bf930ad$var$inertControlStyles = null;
const $9a4eec301bf930ad$var$panelContentStyles = null;
const $9a4eec301bf930ad$var$metaStyles = null;
const $9a4eec301bf930ad$var$personStyles = null;
const $9a4eec301bf930ad$var$dateChipStyles = null;
const $9a4eec301bf930ad$var$answerListStyles = null;
const $9a4eec301bf930ad$var$answerStyles = null;
const $9a4eec301bf930ad$var$ruledAnswerStyles = null;
const $9a4eec301bf930ad$var$questionStyles = null;
const $9a4eec301bf930ad$var$answerValueStyles = null;

});
parcelRegister("96S9r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a1eadea59cce5ec$var$_react = $6a1eadea59cce5ec$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6a1eadea59cce5ec$var$_baseNew = $6a1eadea59cce5ec$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6a1eadea59cce5ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a1eadea59cce5ec$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $6a1eadea59cce5ec$var$_react.default.createElement($6a1eadea59cce5ec$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$6a1eadea59cce5ec$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $6a1eadea59cce5ec$var$_default = module.exports.default = $6a1eadea59cce5ec$var$GrowDiagonalIcon;

});

parcelRegister("9aJkx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::698e254198d7222b92b3a04f2e78869b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ad835da12ab19c4$var$_react = $6ad835da12ab19c4$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6ad835da12ab19c4$var$_baseNew = $6ad835da12ab19c4$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6ad835da12ab19c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Survey".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for surveys.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ad835da12ab19c4$var$SurveyIcon = (props)=>/*#__PURE__*/ $6ad835da12ab19c4$var$_react.default.createElement($6ad835da12ab19c4$var$_baseNew.default, Object.assign({
        name: "SurveyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13 3.5a.5.5 0 0 0-.5-.5h-1v1.25a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75V3h-1a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zm-7 7V12H4.5v-1.5zm5.5 0V12h-4v-1.5zM6 7.5V9H4.5V7.5zm5.5 0V9h-4V7.5zm-5-6A.5.5 0 0 0 6 2v1.5h4V2a.5.5 0 0 0-.5-.5zm8 12.5a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2h1.065A2 2 0 0 1 6.5 0h3a2 2 0 0 1 1.935 1.5H12.5a2 2 0 0 1 2 2z"/>`
    }, props));
$6ad835da12ab19c4$var$SurveyIcon.displayName = 'SurveyIcon';
var $6ad835da12ab19c4$var$_default = module.exports.default = $6ad835da12ab19c4$var$SurveyIcon;

});


parcelRegister("1Uelu", function(module, exports) {
$parcel$export(module.exports, "SurveyTable", function () { return $e179caab54e4c8db$export$911751a7c8c64bd4; });
$parcel$export(module.exports, "SurveyTableHead", function () { return $e179caab54e4c8db$export$3c6423bf6a5143a8; });
$parcel$export(module.exports, "SurveyTableBody", function () { return $e179caab54e4c8db$export$cecacfb0d4bc762a; });
$parcel$export(module.exports, "SurveyHeadCell", function () { return $e179caab54e4c8db$export$8128e00580611a39; });
$parcel$export(module.exports, "SurveyCell", function () { return $e179caab54e4c8db$export$8d403e35cffce988; });
$parcel$export(module.exports, "SurveyTableRow", function () { return $e179caab54e4c8db$export$563296f148b72e8c; });
$parcel$export(module.exports, "SurveyRowAction", function () { return $e179caab54e4c8db$export$a5b31d29fbedccb6; });
/* survey-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $FapDU = parcelRequire("FapDU");

var $bBczw = parcelRequire("bBczw");
const $e179caab54e4c8db$export$911751a7c8c64bd4 = ({ caption: caption, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_vchhusvi _1bsb1osq _19itia51 _2rko1mok _bfhkvuon _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _yq5hcfaq _btyzidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("caption", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                        children: caption
                    })
                }),
                children
            ]
        })
    });
const $e179caab54e4c8db$export$3c6423bf6a5143a8 = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
        className: (0, $2jatx.default)([
            "_179rglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
            children: children
        })
    });
const $e179caab54e4c8db$export$cecacfb0d4bc762a = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
        className: (0, $2jatx.default)([
            "_179rglyw"
        ]),
        children: children
    });
const $e179caab54e4c8db$export$8128e00580611a39 = ({ width: width, isFirst: isFirst = false, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        scope: "col",
        style: width === undefined ? undefined : {
            width: `${width}px`
        },
        className: (0, $2jatx.default)([
            "_vchhusvi _1rjcutpp _18zrutpp _syazi7uo _11c8fhey _y3gnv2br _s7n4nkob",
            "_179ria51 _bfhkhfxm _11c8wadc _k48pwu06 _vwz4v47k",
            !isFirst && "_191wia51"
        ]),
        children: children
    });
const $e179caab54e4c8db$export$8d403e35cffce988 = ({ isFirst: isFirst = false, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("td", {
        className: (0, $2jatx.default)([
            "_vchhusvi _1rjcutpp _18zrutpp _syazi7uo _11c8fhey _y3gnv2br _s7n4nkob",
            !isFirst && "_191wia51"
        ]),
        children: children
    });
const $e179caab54e4c8db$export$563296f148b72e8c = ({ index: index, isSelected: isSelected = false, isActionRevealed: isActionRevealed = false, children: children, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        style: {
            animationDelay: (0, $bBczw.staggerDelay)(index, 50)
        },
        ...rest,
        className: (0, $2jatx.default)([
            "_179ria51 _y44v8ljg _v5641fu2 _qw09glyw _irr31dpa _2cz8kb7n _1ncskb7n _1bumglyw",
            isActionRevealed && "_bfhk1dpa _4e2xkb7n",
            isSelected && "_bfhk15s3 _4e2xkb7n _irr315s3"
        ]),
        children: children
    });
const $e179caab54e4c8db$export$a5b31d29fbedccb6 = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _1o9zidpf _tzy416fj _v5641d1a"
        ]),
        children: children
    });
// `--survey-row-action-opacity` is set by the row and read by its action, which lets the row reveal
// the action without a nested selector.
const $e179caab54e4c8db$var$fadeUp = null;
const $e179caab54e4c8db$var$frameStyles = null;
const $e179caab54e4c8db$var$tableStyles = null;
// The global CSS reset rules a 2px line under `thead` and `tbody`, which would stack on the rows'
// own 1px rules.
const $e179caab54e4c8db$var$sectionResetStyles = null;
const $e179caab54e4c8db$var$cellStyles = null;
const $e179caab54e4c8db$var$headCellStyles = null;
const $e179caab54e4c8db$var$dividerStyles = null;
// The hover fill fades on its own short timing, separate from the staggered entrance, so a hover
// never inherits a row's entrance delay.
const $e179caab54e4c8db$var$rowStyles = null;
const $e179caab54e4c8db$var$revealedRowStyles = null;
const $e179caab54e4c8db$var$selectedRowStyles = null;
const $e179caab54e4c8db$var$rowActionStyles = null;

});


parcelRegister("2khEj", function(module, exports) {
$parcel$export(module.exports, "SURVEY_SHOW_TABLE_TEST_ID", function () { return $cbbf16701424d9b0$export$3b0d9e4f0f5e7dc9; });
$parcel$export(module.exports, "SurveySummary", function () { return $cbbf16701424d9b0$export$bca96e39c79f2874; });
/* survey-summary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $15dQb = parcelRequire("15dQb");

var $2r6UE = parcelRequire("2r6UE");

var $leEwa = parcelRequire("leEwa");

var $lw19E = parcelRequire("lw19E");

var $4rx0e = parcelRequire("4rx0e");

var $lPRxe = parcelRequire("lPRxe");

var $4s9kO = parcelRequire("4s9kO");

var $hZhs9 = parcelRequire("hZhs9");

var $8ktfY = parcelRequire("8ktfY");

var $5GoT9 = parcelRequire("5GoT9");

var $kLZhO = parcelRequire("kLZhO");

var $jHUs4 = parcelRequire("jHUs4");

var $dihia = parcelRequire("dihia");

var $hXm4j = parcelRequire("hXm4j");
const $cbbf16701424d9b0$var$ChartIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($leEwa))), {
        label: "",
        size: "medium"
    });
const $cbbf16701424d9b0$var$TableViewIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4rx0e))), {
        label: "",
        size: "medium"
    });
const $cbbf16701424d9b0$var$ExportIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lw19E))), {
        label: "",
        size: "medium"
    });
const $cbbf16701424d9b0$var$noop = ()=>{};
const $cbbf16701424d9b0$export$3b0d9e4f0f5e7dc9 = 'jsm-hr-survey-show-table';
const $cbbf16701424d9b0$export$bca96e39c79f2874 = ({ questionOneView: questionOneView, onQuestionOneViewChange: onQuestionOneViewChange, isInsightsOpen: isInsightsOpen, onInsightsOpenChange: onInsightsOpenChange, shouldFocusInsightsOnOpen: shouldFocusInsightsOnOpen = true })=>{
    const intl = (0, $8e22h.default)();
    const [isQuestionTwoInsightsOpen, setIsQuestionTwoInsightsOpen] = (0, $1oC0p.useState)(false);
    const responseCount = intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).responseCount, {
        count: (0, $4s9kO.surveyTotals).responses
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb _vchhusvi _1bsb1osq _1q511ejb _18zrxy5q"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hXm4j.SurveyStatTiles), {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulppxbi"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                                level: 3,
                                size: "small",
                                children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionSummaries)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                "aria-hidden": "true",
                                // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
                                inert: "",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                    icon: $cbbf16701424d9b0$var$ExportIcon,
                                    label: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).exportResponses),
                                    onClick: $cbbf16701424d9b0$var$noop,
                                    tabIndex: -1
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1o9zidpf _zulppxbi _vchhusvi _1yt41ejb _19itia51 _2rko1mok _bfhkvuon"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1y6m _1bah1yb4 _zulppxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulp1b66 _1ul9idpf"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                                                level: 4,
                                                size: "xsmall",
                                                children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionOne)
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                size: "small",
                                                color: "color.text.subtle",
                                                children: responseCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o _1o9zidpf _zulp1b66"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dihia.SurveyInsights), {
                                                isOpen: isInsightsOpen,
                                                onOpenChange: onInsightsOpenChange,
                                                shouldFocusOnOpen: shouldFocusInsightsOnOpen
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                role: "group",
                                                "aria-label": intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).resultsViewLabel),
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _4cvr1h6o _vchhusvi _4t3izwfg _zulpv77o _18zrv77o _19itia51 _2rko1qi0 _bfhkvuon"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                        appearance: "subtle",
                                                        "aria-pressed": questionOneView === 'chart',
                                                        icon: $cbbf16701424d9b0$var$ChartIcon,
                                                        isSelected: questionOneView === 'chart',
                                                        label: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).showChart),
                                                        onClick: ()=>onQuestionOneViewChange('chart'),
                                                        spacing: "compact"
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                        appearance: "subtle",
                                                        "aria-pressed": questionOneView === 'table',
                                                        icon: $cbbf16701424d9b0$var$TableViewIcon,
                                                        isSelected: questionOneView === 'table',
                                                        label: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).showTable),
                                                        onClick: ()=>onQuestionOneViewChange('table'),
                                                        spacing: "compact",
                                                        testId: $cbbf16701424d9b0$export$3b0d9e4f0f5e7dc9
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            questionOneView === 'chart' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kLZhO.SurveyChoiceChart), {}, "chart") : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jHUs4.SurveyChoiceTable), {}, "table")
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1o9zidpf _zulppxbi _vchhusvi _1yt41ejb _19itia51 _2rkopb1k _bfhkvuon _1reo15vq _18m915vq"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulp1b66 _1ul9idpf"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                                                level: 4,
                                                size: "xsmall",
                                                children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionTwoCardTitle, {
                                                    question: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).questionTwo)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $15dQb.default), {
                                                children: responseCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dihia.SurveyInsights), {
                                        isOpen: isQuestionTwoInsightsOpen,
                                        onOpenChange: setIsQuestionTwoInsightsOpen,
                                        testId: "jsm-hr-survey-q2-insights-trigger"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq _p12fp3fh"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5GoT9.JsmPlaygroundSearchField), {
                                    label: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).searchResponses),
                                    placeholder: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).searchResponses),
                                    tabIndex: -1
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $cbbf16701424d9b0$var$summaryStyles = null;
const $cbbf16701424d9b0$var$resultsStyles = null;
const $cbbf16701424d9b0$var$resultsHeadingStyles = null;
// Not clipped: the Insights card hangs out of Question 1's header, over the chart and beyond.
const $cbbf16701424d9b0$var$questionCardStyles = null;
const $cbbf16701424d9b0$var$questionHeaderStyles = null;
const $cbbf16701424d9b0$var$questionTitleStyles = null;
const $cbbf16701424d9b0$var$questionActionsStyles = null;
// One outlined shell around both buttons, exactly as tall as the Insights button beside it.
// Q2 sits under Q1 and is clipped by the stage, so only its top border shows.
const $cbbf16701424d9b0$var$freeTextCardStyles = null;
const $cbbf16701424d9b0$var$freeTextHeaderStyles = null;
const $cbbf16701424d9b0$var$freeTextSearchStyles = null;
const $cbbf16701424d9b0$var$viewToggleStyles = null;

});
parcelRegister("4rx0e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::068663bc7237a4f6d91e480dd5b2499a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33c348af03bf3698$var$_react = $33c348af03bf3698$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $33c348af03bf3698$var$_baseNew = $33c348af03bf3698$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $33c348af03bf3698$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Table".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for tables, tabular data, and spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33c348af03bf3698$var$TableIcon = (props)=>/*#__PURE__*/ $33c348af03bf3698$var$_react.default.createElement($33c348af03bf3698$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8.75h-8v3.75H14a.5.5 0 0 0 .5-.5zM1.5 12a.5.5 0 0 0 .5.5h3V8.75H1.5zm13-8a.5.5 0 0 0-.5-.5H6.5v3.75h8zm-13 3.25H5V3.5H2a.5.5 0 0 0-.5.5zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$33c348af03bf3698$var$TableIcon.displayName = 'TableIcon';
var $33c348af03bf3698$var$_default = module.exports.default = $33c348af03bf3698$var$TableIcon;

});

parcelRegister("kLZhO", function(module, exports) {
$parcel$export(module.exports, "SurveyChoiceChart", function () { return $993ec712cee0d25a$export$c439f236be33042e; });
/* survey-choice-chart.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lPRxe = parcelRequire("lPRxe");

var $4s9kO = parcelRequire("4s9kO");

var $hZhs9 = parcelRequire("hZhs9");

var $bBczw = parcelRequire("bBczw");
const $993ec712cee0d25a$var$tickOffset = (index)=>`${index / ((0, $4s9kO.surveyChartTicks).length - 1) * 100}%`;
const $993ec712cee0d25a$export$c439f236be33042e = ()=>{
    const intl = (0, $8e22h.default)();
    const data = (0, $4s9kO.surveyChoices).map((choice)=>intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).chartDatum, {
            choice: intl.formatMessage(choice.label),
            count: choice.responses
        })).join(', ');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "img",
        "aria-label": intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).chartLabel, {
            data: data
        }),
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1q511ejb _1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bsb1osq _4t3ip7wg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1o9zidpf _1bsb66rk"
                        ]),
                        children: (0, $4s9kO.surveyChartTicks).map((tick, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                style: {
                                    top: $993ec712cee0d25a$var$tickOffset(index)
                                },
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _rjxpu2gc _t9ec1i34 _o5721q9c"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: intl.formatNumber(tick)
                                })
                            }, tick))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _16jlkb7n _1ul9idpf"
                        ]),
                        children: [
                            (0, $4s9kO.surveyChartTicks).map((tick, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    style: {
                                        top: $993ec712cee0d25a$var$tickOffset(index)
                                    },
                                    className: (0, $2jatx.default)([
                                        index === (0, $4s9kO.surveyChartTicks).length - 1 ? "_kqswstnw _dk5didpf _mqm2u693" : "_kqswstnw _dk5didpf _mqm2ia51"
                                    ])
                                }, tick)),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1e0c1txw _4cvresu3 _1bsb1osq _4t3i1osq"
                                ]),
                                children: (0, $4s9kO.surveyChoices).map((choice, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvresu3 _1bah1h6o _i0dlidpf _16jlkb7n _1ul9idpf _4t3i1osq"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            style: {
                                                height: `${choice.barHeight / (0, $4s9kO.SURVEY_CHART_HEIGHT) * 100}%`,
                                                animationDelay: (0, $bBczw.staggerDelay)(index, 70)
                                            },
                                            className: (0, $2jatx.default)([
                                                "_1e0c1ule _1bsb1r5k _p12f1st9 _1s1glb4i _5fbclb4i _bfhk1u25 _8hrzyfq0 _y44v5hxu _1bumglyw"
                                            ])
                                        })
                                    }, choice.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _vchhusvi _1bsb1osq _bozg66rk"
                ]),
                children: (0, $4s9kO.surveyChoices).map((choice)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _i0dlidpf _16jlkb7n _zulp1b66 _1ul9idpf _85i5u2gc _y3gn1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1ule _4t3ii2wt _191wia51"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: intl.formatMessage(choice.label)
                            })
                        ]
                    }, choice.id))
            })
        ]
    });
};
const $993ec712cee0d25a$var$Y_AXIS_GUTTER = '45px';
const $993ec712cee0d25a$var$grow = null;
const $993ec712cee0d25a$var$chartStyles = null;
const $993ec712cee0d25a$var$plotRowStyles = null;
const $993ec712cee0d25a$var$yAxisStyles = null;
const $993ec712cee0d25a$var$yAxisLabelStyles = null;
const $993ec712cee0d25a$var$plotStyles = null;
const $993ec712cee0d25a$var$gridlineStyles = null;
// The 0 line is the axis, not a gridline, so it is heavier and darker than the four above it.
const $993ec712cee0d25a$var$baselineStyles = null;
const $993ec712cee0d25a$var$barsStyles = null;
const $993ec712cee0d25a$var$barSlotStyles = null;
// Grows by transform rather than height, so the entrance never triggers layout.
const $993ec712cee0d25a$var$barStyles = null;
const $993ec712cee0d25a$var$xAxisStyles = null;
const $993ec712cee0d25a$var$xAxisSlotStyles = null;
const $993ec712cee0d25a$var$xAxisTickStyles = null;

});

parcelRegister("jHUs4", function(module, exports) {
$parcel$export(module.exports, "SurveyChoiceTable", function () { return $1cff9a988bf00001$export$8b84758a0738fbea; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $4s9kO = parcelRequire("4s9kO");

var $hZhs9 = parcelRequire("hZhs9");

var $1Uelu = parcelRequire("1Uelu");
const $1cff9a988bf00001$export$8b84758a0738fbea = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1Uelu.SurveyTable), {
        caption: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).choiceTableCaption),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1Uelu.SurveyTableHead), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyHeadCell), {
                        isFirst: true,
                        children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).columnChoice)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyHeadCell), {
                        width: 205,
                        children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).columnResponses)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyHeadCell), {
                        width: 245,
                        children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).columnPercentages)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyTableBody), {
                children: (0, $4s9kO.surveyChoices).map((choice, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1Uelu.SurveyTableRow), {
                        index: index,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyCell), {
                                isFirst: true,
                                children: intl.formatMessage(choice.label)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyCell), {
                                children: intl.formatNumber(choice.responses)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Uelu.SurveyCell), {
                                children: intl.formatNumber(choice.share, {
                                    style: 'percent',
                                    minimumFractionDigits: 1
                                })
                            })
                        ]
                    }, choice.id))
            })
        ]
    });
};

});

parcelRegister("hXm4j", function(module, exports) {
$parcel$export(module.exports, "SurveyStatTiles", function () { return $3f01ba9d898381a0$export$914064c03ea89e14; });
/* survey-stat-tiles.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $leEwa = parcelRequire("leEwa");

var $6pmKv = parcelRequire("6pmKv");

var $6hGO6 = parcelRequire("6hGO6");

var $lPRxe = parcelRequire("lPRxe");

var $4s9kO = parcelRequire("4s9kO");

var $hZhs9 = parcelRequire("hZhs9");
const $3f01ba9d898381a0$var$tiles = [
    {
        id: 'views',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6pmKv))),
        value: (0, $hZhs9.jsmPortalPlaygroundHrMessages).statViews,
        values: {
            count: (0, $4s9kO.surveyTotals).views
        },
        tone: 'purple',
        iconColor: "var(--ds-icon-accent-purple, #AF59E1)"
    },
    {
        id: 'responses',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($leEwa))),
        value: (0, $hZhs9.jsmPortalPlaygroundHrMessages).statResponses,
        values: {
            count: (0, $4s9kO.surveyTotals).responses
        },
        tone: 'gray',
        iconColor: "var(--ds-icon-accent-green, #22A06B)"
    },
    {
        id: 'completion',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6hGO6))),
        value: (0, $hZhs9.jsmPortalPlaygroundHrMessages).statCompletion,
        values: {
            rate: (0, $4s9kO.surveyTotals).completionRate
        },
        tone: 'blue',
        iconColor: "var(--ds-icon-accent-blue, #357DE8)"
    }
];
const $3f01ba9d898381a0$export$914064c03ea89e14 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _zulppxbi _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw"
        ]),
        children: $3f01ba9d898381a0$var$tiles.map(({ id: id, Icon: Icon, value: value, values: values, tone: tone, iconColor: iconColor })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _i0dlidpf _16jlkb7n _zulpu2gc _vchhusvi _1ul9idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1rjcutpp _bozgu2gc _y4tiutpp _19itia51 _2rko1mok _bfhkhp5a"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb1ylp _4t3i1ylp _2rkol0p1",
                            tone === 'purple' && "_bfhkp2ly",
                            tone === 'gray' && "_bfhkysee",
                            tone === 'blue' && "_bfhk1s93"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)(Icon, {
                            color: iconColor,
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1h6o _1ul9idpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_syazi7uo _11c81e3o"
                                ]),
                                children: intl.formatMessage(value, values)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: intl.formatMessage((0, $hZhs9.jsmPortalPlaygroundHrMessages).statSince)
                            })
                        ]
                    })
                ]
            }, id))
    });
};
const $3f01ba9d898381a0$var$rowStyles = null;
const $3f01ba9d898381a0$var$statTileStyles = null;
const $3f01ba9d898381a0$var$iconTileStyles = null;
const $3f01ba9d898381a0$var$purpleTileStyles = null;
const $3f01ba9d898381a0$var$grayTileStyles = null;
const $3f01ba9d898381a0$var$blueTileStyles = null;
const $3f01ba9d898381a0$var$valueStackStyles = null;
const $3f01ba9d898381a0$var$valueStyles = null;

});



parcelRegister("1I0eq", function(module, exports) {
$parcel$export(module.exports, "JsmPortalPlaygroundItSupportPreview", function () { return $0334483754968e60$export$dc37fb31f32cfcd0; });
/* jsm-portal-playground-it-support-preview.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2r6UE = parcelRequire("2r6UE");

var $kbhjb = parcelRequire("kbhjb");

var $cNOwN = parcelRequire("cNOwN");

var $6A2DX = parcelRequire("6A2DX");

var $izDBw = parcelRequire("izDBw");

var $lPRxe = parcelRequire("lPRxe");

var $8KJ2x = parcelRequire("8KJ2x");

var $cTci5 = parcelRequire("cTci5");

var $c0yqw = parcelRequire("c0yqw");

var $7575j = parcelRequire("7575j");

var $cmk36 = parcelRequire("cmk36");

var $g0WR9 = parcelRequire("g0WR9");

var $8eU08 = parcelRequire("8eU08");

var $8DlQO = parcelRequire("8DlQO");

var $8ktfY = parcelRequire("8ktfY");

var $bBczw = parcelRequire("bBczw");

var $a9bUP = parcelRequire("a9bUP");

var $8gAsH = parcelRequire("8gAsH");

var $9nVjm = parcelRequire("9nVjm");

var $6m4qq = parcelRequire("6m4qq");

var $6YRn3 = parcelRequire("6YRn3");

var $hdOkG = parcelRequire("hdOkG");
const $0334483754968e60$var$portalHeroCardHand = 'https://dam-cdn.atl.orangelogic.com/AssetLink/0bid83rvsfdq11202jt5hcyaph73i23q.png';
const $0334483754968e60$var$customizeSidebarLogo = 'https://dam-cdn.atl.orangelogic.com/AssetLink/ky3tntm8xu0531s421nd2v10s4k82o4h.png';
const $0334483754968e60$var$customizeSidebarBanner = 'https://dam-cdn.atl.orangelogic.com/AssetLink/gfv1s3xq155yt8u84652d53wj0os8166.png';
const $0334483754968e60$var$SendButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kbhjb))), {
        label: "",
        size: "medium"
    });
const $0334483754968e60$var$CloseButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
        label: "",
        size: "medium"
    });
const $0334483754968e60$export$fd473bc4525d968e = 200;
const $0334483754968e60$export$c6ac1d2cd37473f8 = 280;
const $0334483754968e60$var$ARTICLE_SWITCH_EASE = 'cubic-bezier(0.33, 0, 0.2, 1)';
const $0334483754968e60$var$usePortalArticleTransition = ()=>{
    const prefersReducedMotion = (0, $bBczw.usePrefersReducedMotion)();
    const [renderedArticleId, setRenderedArticleId] = (0, $1oC0p.useState)(null);
    const [phase, setPhase] = (0, $1oC0p.useState)('idle');
    const timersRef = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(()=>()=>{
            timersRef.current.forEach(window.clearTimeout);
            timersRef.current = [];
        }, []);
    const transitionTo = (0, $1oC0p.useCallback)((nextArticleId)=>{
        timersRef.current.forEach(window.clearTimeout);
        timersRef.current = [];
        if (prefersReducedMotion) {
            setRenderedArticleId(nextArticleId);
            setPhase('idle');
            return;
        }
        setPhase('out');
        timersRef.current.push(window.setTimeout(()=>{
            setRenderedArticleId(nextArticleId);
            setPhase('in');
            timersRef.current.push(window.setTimeout(()=>setPhase('idle'), $0334483754968e60$export$c6ac1d2cd37473f8));
        }, $0334483754968e60$export$fd473bc4525d968e));
    }, [
        prefersReducedMotion
    ]);
    const isOut = phase === 'out';
    const durationMs = isOut ? $0334483754968e60$export$fd473bc4525d968e : $0334483754968e60$export$c6ac1d2cd37473f8;
    return {
        article: renderedArticleId ? (0, $cTci5.portalArticles)[renderedArticleId] : null,
        openArticle: (0, $1oC0p.useCallback)((articleId)=>transitionTo(articleId), [
            transitionTo
        ]),
        openArticleImmediate: (0, $1oC0p.useCallback)((articleId)=>{
            timersRef.current.forEach(window.clearTimeout);
            timersRef.current = [];
            setRenderedArticleId(articleId);
            setPhase('idle');
        }, []),
        closeArticle: (0, $1oC0p.useCallback)(()=>transitionTo(null), [
            transitionTo
        ]),
        stageStyle: {
            opacity: isOut ? 0 : 1,
            transform: isOut ? 'scale(0.985)' : 'scale(1)',
            transition: `opacity ${durationMs}ms ${$0334483754968e60$var$ARTICLE_SWITCH_EASE}, transform ${durationMs}ms ${$0334483754968e60$var$ARTICLE_SWITCH_EASE}`
        }
    };
};
const $0334483754968e60$var$DEMO_ARTICLE_ID = 'vpn';
const $0334483754968e60$var$shouldRunItSupportDemo = (isActive, isAnimationComplete)=>isActive && !isAnimationComplete;
const $0334483754968e60$var$shouldShowSkipAnimation = (isActive, isAnimationComplete, prefersReducedMotion)=>$0334483754968e60$var$shouldRunItSupportDemo(isActive, isAnimationComplete) && !prefersReducedMotion;
const $0334483754968e60$var$JsmPortalPlaygroundItSupportPreviewComponent = ({ isActive: isActive = true, hasUserTakenOver: hasUserTakenOver = false, onDemoComplete: onDemoComplete })=>{
    const intl = (0, $8e22h.default)();
    const helpCenterNameFieldId = (0, $1oC0p.useId)();
    const rootRef = (0, $1oC0p.useRef)(null);
    const demoLayer = (0, $8eU08.useJsmPlaygroundDemoLayer)();
    const demoLayerRef = (0, $1oC0p.useRef)(demoLayer);
    demoLayerRef.current = demoLayer;
    const demoCursor = (0, $8DlQO.useDemoCursor)('start');
    const { updateStops: updateStops } = demoCursor;
    const [demoCardState, setDemoCardState] = (0, $1oC0p.useState)('idle');
    const [shouldPlayArticleDemo, setShouldPlayArticleDemo] = (0, $1oC0p.useState)(false);
    const [isAnimationComplete, setIsAnimationComplete] = (0, $1oC0p.useState)(false);
    const [shouldShowCompletedChat, setShouldShowCompletedChat] = (0, $1oC0p.useState)(false);
    const [isCustomizeOpen, setIsCustomizeOpen] = (0, $1oC0p.useState)(false);
    const [helpCenterName, setHelpCenterName] = (0, $1oC0p.useState)(()=>intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).helpCenterTitle));
    const initialHelpCenterNameRef = (0, $1oC0p.useRef)(helpCenterName);
    const [primaryColor, setPrimaryColor] = (0, $1oC0p.useState)('lime');
    const [secondaryColor, setSecondaryColor] = (0, $1oC0p.useState)('lime');
    const { firePlaygroundScreenNavigated: firePlaygroundScreenNavigated, fireTextFieldBlurred: fireTextFieldBlurred } = (0, $7575j.useJsmPlaygroundAnalytics)('it_support');
    const { article: openArticle, openArticle: handleOpenArticle, openArticleImmediate: openArticleImmediate, closeArticle: handleCloseArticle, stageStyle: stageStyle } = $0334483754968e60$var$usePortalArticleTransition();
    const prefersReducedMotion = (0, $bBczw.usePrefersReducedMotion)();
    const notifyDemoComplete = (0, $8DlQO.useNotifyDemoComplete)(onDemoComplete);
    const hasUserTakenOverRef = (0, $1oC0p.useRef)(hasUserTakenOver);
    hasUserTakenOverRef.current = hasUserTakenOver;
    const handleDemoChatFinished = (0, $1oC0p.useCallback)(()=>{
        if (!hasUserTakenOverRef.current) {
            setIsAnimationComplete(true);
            notifyDemoComplete();
        }
    }, [
        notifyDemoComplete
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (isActive && prefersReducedMotion) notifyDemoComplete();
    }, [
        isActive,
        notifyDemoComplete,
        prefersReducedMotion
    ]);
    const togglePrimaryColor = ()=>setPrimaryColor((color)=>color === 'lime' ? 'teal' : 'lime');
    const toggleSecondaryColor = ()=>setSecondaryColor((color)=>color === 'lime' ? 'teal' : 'lime');
    const openArticleFromCard = (articleId)=>{
        setShouldPlayArticleDemo(false);
        setShouldShowCompletedChat(false);
        firePlaygroundScreenNavigated({
            team_type: 'it_support',
            screen_id: `article_${articleId}`,
            interaction_mode: 'manual_click'
        });
        handleOpenArticle(articleId);
    };
    const closeArticle = ()=>{
        setShouldPlayArticleDemo(false);
        setShouldShowCompletedChat(false);
        handleCloseArticle();
    };
    const measureStops = (0, $1oC0p.useCallback)((targets)=>{
        const root = rootRef.current;
        const origin = demoLayerRef.current ?? root;
        if (!root || !origin) return;
        const find = (selector)=>root.querySelector(selector);
        const next = {};
        for (const target of targets){
            if (target === 'start' || target === 'customizeButton') {
                const button = find('[data-testid="customize-help-center-button"]');
                if (button) {
                    const box = (0, $g0WR9.rectWithin)(origin, button);
                    next.start = {
                        x: box.left - 40,
                        y: box.bottom + 24
                    };
                    next.customizeButton = (0, $g0WR9.centerOf)(box);
                }
            } else if (target === 'bannerSwatch' || target === 'iconSwatch') {
                const swatch = find(`[data-testid="${target === 'bannerSwatch' ? 'primary' : 'secondary'}-color-swatch"]`);
                if (swatch) next[target] = (0, $g0WR9.centerOf)((0, $g0WR9.rectWithin)(origin, swatch));
            } else {
                // Same node the prototype measures: the title wrapper, not an h3.
                const title = find(`[data-testid="jsm-portal-help-card-title-${$0334483754968e60$var$DEMO_ARTICLE_ID}"]`);
                if (title) {
                    const box = (0, $g0WR9.rectWithin)(origin, title);
                    next.articleCard = (0, $g0WR9.centerOf)(box);
                    next.cardApproach = {
                        x: box.left - 56,
                        y: box.bottom + 72
                    };
                }
            }
        }
        updateStops(next);
    }, [
        updateStops
    ]);
    (0, $1oC0p.useLayoutEffect)(()=>{
        measureStops([
            'start'
        ]);
    }, [
        measureStops,
        demoLayer
    ]);
    (0, $8DlQO.useDemoTimeline)($0334483754968e60$var$shouldRunItSupportDemo(isActive, isAnimationComplete), hasUserTakenOver, (at)=>{
        const { updateCursor: updateCursor, setIsTransitionEnabled: setIsTransitionEnabled } = demoCursor;
        at((0, $6m4qq.HUB_DEMO).cursorIn, ()=>updateCursor({
                target: 'customizeButton',
                isVisible: true
            }));
        at((0, $6m4qq.HUB_DEMO).buttonPress, ()=>{
            updateCursor({
                isPressed: true
            });
            setIsCustomizeOpen(true);
        });
        at((0, $6m4qq.HUB_DEMO).buttonRelease, ()=>updateCursor({
                isPressed: false
            }));
        at((0, $6m4qq.HUB_DEMO).bannerSwatchMove, ()=>{
            measureStops([
                'bannerSwatch'
            ]);
            updateCursor({
                target: 'bannerSwatch'
            });
        });
        at((0, $6m4qq.HUB_DEMO).bannerSwatchPress, ()=>{
            updateCursor({
                isPressed: true
            });
            togglePrimaryColor();
        });
        at((0, $6m4qq.HUB_DEMO).bannerSwatchRelease, ()=>updateCursor({
                isPressed: false
            }));
        at((0, $6m4qq.HUB_DEMO).iconSwatchMove, ()=>{
            measureStops([
                'iconSwatch'
            ]);
            updateCursor({
                target: 'iconSwatch'
            });
        });
        at((0, $6m4qq.HUB_DEMO).iconSwatchPress, ()=>{
            updateCursor({
                isPressed: true
            });
            toggleSecondaryColor();
        });
        at((0, $6m4qq.HUB_DEMO).iconSwatchRelease, ()=>updateCursor({
                isPressed: false
            }));
        at((0, $6m4qq.HUB_DEMO).cursorHide, ()=>updateCursor({
                isVisible: false
            }));
        at((0, $6m4qq.HUB_DEMO).cardApproachJump, ()=>{
            measureStops([
                'articleCard'
            ]);
            setIsTransitionEnabled(false);
            updateCursor({
                target: 'cardApproach'
            });
        });
        at((0, $6m4qq.HUB_DEMO).articleCardMove, ()=>{
            setIsTransitionEnabled(true);
            updateCursor({
                target: 'articleCard',
                isVisible: true
            });
            setDemoCardState('hovered');
        });
        at((0, $6m4qq.HUB_DEMO).articleCardPress, ()=>{
            updateCursor({
                isPressed: true
            });
            setDemoCardState('pressed');
            setShouldPlayArticleDemo(true);
            handleOpenArticle($0334483754968e60$var$DEMO_ARTICLE_ID);
        });
        at((0, $6m4qq.HUB_DEMO).articleCardRelease, ()=>{
            updateCursor({
                isPressed: false
            });
            setDemoCardState('idle');
        });
        at((0, $6m4qq.HUB_DEMO).cursorOut, ()=>updateCursor({
                isVisible: false
            }));
    });
    const skipAnimation = ()=>{
        demoCursor.updateCursor({
            isVisible: false,
            isPressed: false
        });
        setDemoCardState('idle');
        setIsCustomizeOpen(false);
        setPrimaryColor('teal');
        setSecondaryColor('teal');
        setShouldPlayArticleDemo(false);
        openArticleImmediate($0334483754968e60$var$DEMO_ARTICLE_ID);
        setShouldShowCompletedChat(true);
        setIsAnimationComplete(true);
        notifyDemoComplete();
    };
    const handleCustomizeToggle = (event)=>{
        if ((0, $7575j.isUntrustedClick)(event)) {
            setIsCustomizeOpen((isOpen)=>!isOpen);
            return;
        }
        const nextState = !isCustomizeOpen;
        firePlaygroundScreenNavigated({
            team_type: 'it_support',
            screen_id: nextState ? 'customize_sidebar' : 'help_center_hub',
            interaction_mode: 'manual_click'
        });
        setIsCustomizeOpen(nextState);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: rootRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1bsb1osq _4t3i1osq _2rkopb1k _bfhkvuon _1reo15vq _18m915vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9bUP.JsmPlaygroundNavigation), {
                config: (0, $cTci5.teamNavigationConfig)['it-support'],
                teamName: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).teamItSupport),
                onCustomizeHelpCenterClick: handleCustomizeToggle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: stageStyle,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _16jlkb7n _1tkeidpf _1ul9idpf _1bsb1osq _1reo15vq _18m915vq _sedtagmp _qp04agmp"
                ]),
                children: openArticle ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9nVjm.JsmPortalPlaygroundArticleView), {
                    article: openArticle,
                    secondaryColor: secondaryColor,
                    onBack: closeArticle,
                    shouldPlayDemo: shouldPlayArticleDemo && isActive && !shouldShowCompletedChat,
                    shouldCompleteChat: shouldShowCompletedChat,
                    hasUserTakenOver: hasUserTakenOver,
                    onDemoComplete: handleDemoChatFinished
                }, openArticle.id) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _yv0e5ern _16jlkb7n _1tkeidpf _1bsb1osq _1reo15vq _18m915vq _v564gpd8 _sedtglyw",
                        isCustomizeOpen && "_yv0e2pa4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _kqswh2mm _1ul9idpf _1tkeidpf _1bsb1osq _bfhkvuon _1reo15vq _18m915vq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _1o9zidpf _vchhusvi _1bsb1osq _1q511ejb _85i5utpp _18zr1ejb _bfhkvuon"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _kqswh2mm _vchhusvi _1bsb1osq _p12f1jnb _1tke18rv _1q511jfw _18zrxncg _2rko1mok _1itk14ki _1reo15vq _18m915vq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                                src: $0334483754968e60$var$portalHeroCardHand,
                                                alt: "",
                                                "aria-hidden": "true",
                                                className: (0, $2jatx.default)([
                                                    "_kqswstnw _u7coidpf _rjxp2bgk _1bsb1wug _4t3i1osq _lcxvglyw _uiztglyw"
                                                ])
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _2lx21bp4 _zulp1ejb _kqswh2mm _1pbykb7n _vchhusvi _1bsb1osq _p12f1v7s"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_1e0c1txw _2lx21bp4 _zulpu2gc"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                "aria-level": 1,
                                                                role: "heading",
                                                                className: (0, $2jatx.default)([
                                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fcv93 _syazi7uo _ect4r4hu _1wybvbgk _k48p1fw0 _vwz4xe7b _1dyz1h92"
                                                                ]),
                                                                children: helpCenterName || intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).helpCenterTitle)
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                                className: (0, $2jatx.default)([
                                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1p81 _syazi7uo _ect41gus _1wyba982 _k48pl8b6 _vwz4ftok"
                                                                ]),
                                                                children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).helpCenterSubtitle)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                        "aria-hidden": "true",
                                                        // @ts-expect-error -- inert is missing from @compiled/react types
                                                        inert: "",
                                                        className: (0, $2jatx.default)([
                                                            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulputpp _vchhusvi _1bsb1osq _p12f1pze _1rjcutpp _18zrpxbi _2rkopb1k _bfhkvuon _16qst7xp"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                className: (0, $2jatx.default)([
                                                                    "_16jlkb7n _1ul9idpf _swxzy28r"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                    appearance: "none",
                                                                    "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).askAiPlaceholder),
                                                                    placeholder: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).askAiPlaceholder),
                                                                    isReadOnly: true,
                                                                    tabIndex: -1
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                                icon: $0334483754968e60$var$SendButtonIcon,
                                                                label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).sendButton),
                                                                shape: "circle",
                                                                spacing: "compact",
                                                                tabIndex: -1
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zidpf _zulppxbi _vchhusvi _1bsb1osq _1q51pxbi _85i51ejb _18zr1ejb _bfhkvuon"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulputpp _vchhusvi _1bsb1osq _p12f1fra"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                "aria-level": 2,
                                                role: "heading",
                                                className: (0, $2jatx.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazi7uo _ect4r4hu _1wyb1tcg _k48p1fw0 _vwz4xe7b _y3gn1h6o"
                                                ]),
                                                children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).findHelpHeading)
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _4cvr1fhb _zulppxbi _1bsb1osq"
                                                ]),
                                                children: (0, $cTci5.itSupportHelpCards).map((card)=>/*#__PURE__*/ (0, $7VQPk.jsx)($0334483754968e60$var$HelpArticleCard, {
                                                        card: card,
                                                        primaryColor: primaryColor,
                                                        secondaryColor: secondaryColor,
                                                        onOpen: ()=>openArticleFromCard(card.id),
                                                        demoState: card.id === $0334483754968e60$var$DEMO_ARTICLE_ID ? demoCardState : 'idle'
                                                    }, card.id))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hdOkG.JsmPortalPlaygroundRovoLauncherMark), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            "data-testid": "jsm-portal-customize-sidebar",
                            "aria-hidden": !isCustomizeOpen,
                            // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
                            inert: isCustomizeOpen ? undefined : '',
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _1ul9idpf _1tkeidpf _4t3i1osq _vchhusvi _bfhk1bhr _gx38e4h9 _ngwonqa1 _14vn1l7x _1reo15vq _18m915vq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _1bah1yb4 _1o9zidpf _vchhusvi _1yt4pxbi"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                                            level: 2,
                                            size: "small",
                                            children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).customizePanelTitle)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                            appearance: "subtle",
                                            icon: $0334483754968e60$var$CloseButtonIcon,
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).closeButton),
                                            spacing: "compact",
                                            onClick: (event)=>{
                                                if (!(0, $7575j.isUntrustedClick)(event)) firePlaygroundScreenNavigated({
                                                    team_type: 'it_support',
                                                    screen_id: 'help_center_hub',
                                                    interaction_mode: 'manual_click'
                                                });
                                                setIsCustomizeOpen(false);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx21bp4 _zulp1ejb _vchhusvi _1yt4pxbi _1q51idpf _18m91wug"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($0334483754968e60$var$SidebarField, {
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).helpCenterNameField),
                                            htmlFor: helpCenterNameFieldId,
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1f4s1qi0 _1thzt94y"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                    id: helpCenterNameFieldId,
                                                    value: helpCenterName,
                                                    onChange: (event)=>setHelpCenterName(event.target.value),
                                                    onBlur: (event)=>{
                                                        const currentVal = event.target.value;
                                                        const hasChanged = currentVal !== initialHelpCenterNameRef.current;
                                                        fireTextFieldBlurred({
                                                            screenId: 'help_center_preview',
                                                            elementId: 'helpCenterName',
                                                            actionSubjectId: 'helpCenterName',
                                                            hasChanged: hasChanged,
                                                            inputLength: currentVal.length,
                                                            teamType: 'it_support'
                                                        });
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($0334483754968e60$var$SidebarField, {
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).logoField),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                                src: $0334483754968e60$var$customizeSidebarLogo,
                                                alt: "",
                                                className: (0, $2jatx.default)([
                                                    "_1bsbfhn8 _4t3ifhn8 _2rko12b0 _5ral1dfr"
                                                ])
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($0334483754968e60$var$SidebarField, {
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).bannerField),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                                src: $0334483754968e60$var$customizeSidebarBanner,
                                                alt: "",
                                                className: (0, $2jatx.default)([
                                                    "_1bsb1osq _1h1t1pgg _2rko1qi0 _5ral1dfr"
                                                ])
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($0334483754968e60$var$SidebarField, {
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).textColorField),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1bsb18e8 _4t3id4y9 _vchhusvi _2rko12b0",
                                                    "_bfhki7uo"
                                                ])
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($0334483754968e60$var$SidebarField, {
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).primaryColorField),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                type: "button",
                                                "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).togglePrimaryColor),
                                                "data-testid": "primary-color-swatch",
                                                onClick: togglePrimaryColor,
                                                className: (0, $2jatx.default)([
                                                    "_1bsb18e8 _4t3id4y9 _vchhusvi _2rko12b0",
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1dqoglyw _80omtlke",
                                                    primaryColor === 'teal' ? "_bfhk7xuz" : "_bfhkm890"
                                                ])
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($0334483754968e60$var$SidebarField, {
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).secondaryColorField),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                type: "button",
                                                "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).toggleSecondaryColor),
                                                "data-testid": "secondary-color-swatch",
                                                onClick: toggleSecondaryColor,
                                                className: (0, $2jatx.default)([
                                                    "_1bsb18e8 _4t3id4y9 _vchhusvi _2rko12b0",
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1dqoglyw _80omtlke",
                                                    secondaryColor === 'teal' ? "_bfhk8uof" : "_bfhk8645"
                                                ])
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cmk36.JsmPlaygroundDemoCursor), {
                label: (0, $6m4qq.DEMO_CURSOR_LABEL),
                testId: "jsm-portal-demo-cursor",
                container: demoLayer,
                hasUserTakenOver: hasUserTakenOver,
                isPressed: demoCursor.isPressed,
                isTransitionEnabled: demoCursor.isTransitionEnabled,
                isVisible: demoCursor.isVisible && isActive,
                x: demoCursor.position.x,
                y: demoCursor.position.y
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8gAsH.JsmPlaygroundSkipAnimationButton), {
                isVisible: $0334483754968e60$var$shouldShowSkipAnimation(isActive, isAnimationComplete, prefersReducedMotion) && !hasUserTakenOver,
                label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).skipAnimation),
                onClick: skipAnimation
            })
        ]
    });
};
const $0334483754968e60$export$dc37fb31f32cfcd0 = /*#__PURE__*/ (0, $1oC0p.memo)($0334483754968e60$var$JsmPortalPlaygroundItSupportPreviewComponent);
const $0334483754968e60$var$HelpArticleCard = ({ card: card, primaryColor: primaryColor, secondaryColor: secondaryColor, onOpen: onOpen, demoState: demoState })=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage(card.title);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        type: "button",
        "data-testid": `jsm-portal-help-card-${card.id}`,
        "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).readArticle, {
            title: title
        }),
        onClick: onOpen,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _i0dlidpf _16jlkb7n _1o9zkb7n _1ul9idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _y3gnv2br _80omtlke _bfhkvuon _189ee4h9 _1dqonqa1 _1h6d1l7x _2rkopb1k _1reo15vq _18m915vq _v564slvs _1dbz130s _1llwr915 _180dt7xp _1q8w1qs1 _sedtglyw",
            demoState === 'hovered' && "_16qs130s _t9ecr915",
            demoState === 'pressed' && "_16qst7xp _t9ec1qs1"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulpu2gc _1bsb1osq _vchhusvi _1rjcutpp _18zr1ejb",
                    primaryColor === 'teal' ? "_bfhk7xuz" : "_bfhkm890"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6YRn3.PortalArticleIconTile), {
                    color: secondaryColor,
                    size: "xlarge"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _16jlkb7n _zulppxbi _1yt41ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulppxbi"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izDBw.default), {
                                appearance: card.tagAppearance,
                                testId: `jsm-portal-help-card-tag-${card.id}`,
                                children: intl.formatMessage(card.tag)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                "data-testid": `jsm-portal-help-card-title-${card.id}`,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                                    level: 3,
                                    size: "small",
                                    children: title
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        maxLines: 2,
                        children: intl.formatMessage(card.description)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1n261g80 _zulp1b66 _1bsb1osq _1pfh1wug _1reo15vq _18m915vq"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulp1b66 _1o9zidpf _o5721q9c"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.RovoIcon), {
                                        appearance: "brand",
                                        label: "",
                                        shouldUseHexLogo: true,
                                        size: "xxsmall"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).createdWithRovo)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1o9zidpf _o5721q9c"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).lastUpdated, {
                                        date: (0, $6YRn3.formatCardDate)(card.lastUpdated)
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $0334483754968e60$var$SidebarField = ({ label: label, htmlFor: htmlFor, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66"
        ]),
        children: [
            htmlFor ? /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: htmlFor,
                className: (0, $2jatx.default)([
                    "_1e0c116y"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    size: "small",
                    weight: "bold",
                    color: "color.text.subtle",
                    children: label
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                size: "small",
                weight: "bold",
                color: "color.text.subtle",
                children: label
            }),
            children
        ]
    });
const $0334483754968e60$var$previewRootStyles = null;
const $0334483754968e60$var$stageStyles = null;
const $0334483754968e60$var$contentRowStyles = null;
const $0334483754968e60$var$contentRowOpenStyles = null;
const $0334483754968e60$var$helpHubStyles = null;
const $0334483754968e60$var$calloutBannerStyles = null;
const $0334483754968e60$var$heroStyles = null;
const $0334483754968e60$var$heroArtworkStyles = null;
const $0334483754968e60$var$heroContentStyles = null;
const $0334483754968e60$var$heroCopyStyles = null;
const $0334483754968e60$var$heroHeadingStyles = null;
const $0334483754968e60$var$heroSubtitleStyles = null;
const $0334483754968e60$var$promptInlineStyles = null;
const $0334483754968e60$var$promptFieldStyles = null;
const $0334483754968e60$var$findHelpBandStyles = null;
const $0334483754968e60$var$bandContentStyles = null;
const $0334483754968e60$var$findHelpHeadingStyles = null;
const $0334483754968e60$var$cardRowStyles = null;
const $0334483754968e60$var$cardStyles = null;
const $0334483754968e60$var$cardHoveredStyles = null;
const $0334483754968e60$var$cardPressedStyles = null;
const $0334483754968e60$var$cardHeaderStyles = null;
const $0334483754968e60$var$cardHeaderLimeStyles = null;
const $0334483754968e60$var$cardHeaderTealStyles = null;
const $0334483754968e60$var$cardBodyStyles = null;
const $0334483754968e60$var$cardHeadlineStyles = null;
const $0334483754968e60$var$bylineStyles = null;
const $0334483754968e60$var$bylineAttributionStyles = null;
const $0334483754968e60$var$bylineDateStyles = null;
const $0334483754968e60$var$sidebarStyles = null;
const $0334483754968e60$var$sidebarHeaderStyles = null;
const $0334483754968e60$var$sidebarBodyStyles = null;
const $0334483754968e60$var$sidebarFieldStyles = null;
// @atlaskit/textfield in wac-web hardcodes a 3px radius. The current field uses radius.medium.
const $0334483754968e60$var$helpCenterNameFieldStyles = null;
const $0334483754968e60$var$sidebarFieldLabelStyles = null;
const $0334483754968e60$var$sidebarLogoStyles = null;
const $0334483754968e60$var$sidebarBannerStyles = null;
const $0334483754968e60$var$colorSwatchStyles = null;
const $0334483754968e60$var$colorSwatchButtonStyles = null;
const $0334483754968e60$var$textColorSwatchStyles = null;
const $0334483754968e60$var$primarySwatchLimeStyles = null;
const $0334483754968e60$var$primarySwatchTealStyles = null;
const $0334483754968e60$var$secondarySwatchLimeStyles = null;
const $0334483754968e60$var$secondarySwatchTealStyles = null;

});
parcelRegister("kbhjb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1242cf2f07055f$var$_react = $eb1242cf2f07055f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $eb1242cf2f07055f$var$_baseNew = $eb1242cf2f07055f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $eb1242cf2f07055f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb1242cf2f07055f$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb1242cf2f07055f$var$_react.default.createElement($eb1242cf2f07055f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb1242cf2f07055f$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb1242cf2f07055f$var$_default = module.exports.default = $eb1242cf2f07055f$var$ArrowUpIcon;

});

parcelRegister("9nVjm", function(module, exports) {
$parcel$export(module.exports, "JsmPortalPlaygroundArticleView", function () { return $599c75a2618117f5$export$769e9d21582e4550; });
/* jsm-portal-playground-article-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $1q52J = parcelRequire("1q52J");

var $agxCc = parcelRequire("agxCc");

var $muyyw = parcelRequire("muyyw");

var $53VCz = parcelRequire("53VCz");

var $e4S7H = parcelRequire("e4S7H");

var $1zgVm = parcelRequire("1zgVm");
var $9jghN = parcelRequire("9jghN");
var $7SWbn = parcelRequire("7SWbn");

var $lPRxe = parcelRequire("lPRxe");

var $c0yqw = parcelRequire("c0yqw");

var $7575j = parcelRequire("7575j");

var $cmk36 = parcelRequire("cmk36");

var $g0WR9 = parcelRequire("g0WR9");

var $8eU08 = parcelRequire("8eU08");

var $8DlQO = parcelRequire("8DlQO");

var $8ktfY = parcelRequire("8ktfY");

var $6m4qq = parcelRequire("6m4qq");

var $6YRn3 = parcelRequire("6YRn3");

var $hdOkG = parcelRequire("hdOkG");
const $599c75a2618117f5$export$769e9d21582e4550 = ({ article: article, secondaryColor: secondaryColor, onBack: onBack, shouldPlayDemo: shouldPlayDemo = false, hasUserTakenOver: hasUserTakenOver = false, shouldCompleteChat: shouldCompleteChat = false, onDemoComplete: onDemoComplete })=>{
    const intl = (0, $8e22h.default)();
    const chat = (0, $hdOkG.usePortalRovoChat)();
    const pageRef = (0, $1oC0p.useRef)(null);
    const askPillRef = (0, $1oC0p.useRef)(null);
    const demoLayer = (0, $8eU08.useJsmPlaygroundDemoLayer)();
    const demoCursor = (0, $8DlQO.useDemoCursor)('start');
    const { updateCursor: updateCursor, updateStops: updateStops } = demoCursor;
    const [demoPillState, setDemoPillState] = (0, $1oC0p.useState)('idle');
    const { firePlaygroundScreenNavigated: firePlaygroundScreenNavigated } = (0, $7575j.useJsmPlaygroundAnalytics)('it_support');
    const handleBack = ()=>{
        firePlaygroundScreenNavigated({
            team_type: 'it_support',
            screen_id: 'help_center_hub',
            interaction_mode: 'manual_click'
        });
        onBack();
    };
    (0, $1oC0p.useLayoutEffect)(()=>{
        const origin = demoLayer ?? pageRef.current;
        const pill = askPillRef.current;
        if (!shouldPlayDemo || !origin || !pill) return;
        const box = (0, $g0WR9.rectWithin)(origin, pill);
        updateStops({
            start: {
                x: box.left - 72,
                y: box.top - 104
            },
            askPill: (0, $g0WR9.centerOf)(box)
        });
    }, [
        shouldPlayDemo,
        demoLayer,
        updateStops
    ]);
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (!shouldCompleteChat) return;
        updateCursor({
            isVisible: false,
            isPressed: false
        });
        setDemoPillState('idle');
        chat.completeNow();
    }, [
        chat.completeNow,
        shouldCompleteChat,
        updateCursor
    ]);
    (0, $8DlQO.useDemoTimeline)(shouldPlayDemo && !shouldCompleteChat, hasUserTakenOver, (at)=>{
        const { updateCursor: updateCursor } = demoCursor;
        at((0, $6m4qq.ARTICLE_DEMO).cursorIn, ()=>{
            updateCursor({
                target: 'askPill',
                isVisible: true
            });
            setDemoPillState('hovered');
        });
        at((0, $6m4qq.ARTICLE_DEMO).askPillPress, ()=>{
            updateCursor({
                isPressed: true
            });
            setDemoPillState('pressed');
            chat.open(askPillRef, {
                isDemo: true
            });
        });
        at((0, $6m4qq.ARTICLE_DEMO).askPillRelease, ()=>{
            updateCursor({
                isPressed: false
            });
            setDemoPillState('idle');
        });
        at((0, $6m4qq.ARTICLE_DEMO).cursorOut, ()=>updateCursor({
                isVisible: false
            }));
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: pageRef,
        "data-testid": "jsm-portal-article-page",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc _kqswh2mm _vchhusvi _1bsb1osq _4t3i1osq _1tkeidpf _1q51pxbi _85i5u2gc _18zr1jfw _bfhkhfxm _1reo15vq _18m915vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1wpz1h6o _zulpv47k _vchhusvi _1bsb12i9 _p12f1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                        type: "button",
                        "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).articleBackLabel),
                        "data-testid": "jsm-portal-article-back-button",
                        onClick: handleBack,
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1wpz1y6m _1e0c116y _zulp1b66 _1rjcv77o _18zr1b66 _1dqoglyw _2rko12b0 _bfhksm61 _syazi7uo _80omtlke _irr31dpa _128mdkaa _ra3xnqa1 _mizu1v1w _1ah3v77o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($muyyw))), {
                                label: "",
                                size: "small",
                                color: "var(--ds-text, #292A2E)"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                size: "medium",
                                weight: "medium",
                                children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).articleBack)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
                        space: "space.400",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1zgVm.default), {
                                alignItems: "center",
                                justifyContent: "space-between",
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6YRn3.PortalArticleIconTile), {
                                        color: secondaryColor,
                                        size: "medium"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9jghN.default), {
                                        space: "space.075",
                                        alignBlock: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                size: "large",
                                                color: "color.text.subtlest",
                                                children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).lastUpdated, {
                                                    date: intl.formatDate(article.lastUpdated, (0, $6YRn3.ARTICLE_DATE_FORMAT))
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                "aria-hidden": "true",
                                                // @ts-expect-error -- inert is missing from @compiled/react types
                                                inert: "",
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                                    iconBefore: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e4S7H))), {
                                                            label: ""
                                                        }),
                                                    spacing: "compact",
                                                    tabIndex: -1,
                                                    children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).draftWithRovo)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
                                space: "space.150",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        "aria-level": 1,
                                        role: "heading",
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazi7uo _ect41tbl _1wyb1ylp _k48pwu06 _vwz41gnr _1dyzz5jk"
                                        ]),
                                        children: intl.formatMessage(article.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        size: "large",
                                        children: intl.formatMessage(article.intro)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7SWbn.default), {
                        space: "space.300",
                        children: article.sections.map((section)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
                                space: "space.150",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                                        level: 2,
                                        size: "medium",
                                        children: intl.formatMessage(section.heading)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7SWbn.default), {
                                        space: "space.300",
                                        children: section.paragraphs.map((lines, paragraphIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7SWbn.default), {
                                                space: "space.150",
                                                "aria-hidden": "true",
                                                children: lines.map((width, lineIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        style: {
                                                            width: `${width * 100}%`
                                                        },
                                                        className: (0, $2jatx.default)([
                                                            "_4t3i1crf _2rkolb4i _bfhkizff"
                                                        ])
                                                    }, lineIndex))
                                            }, paragraphIndex))
                                    })
                                ]
                            }, section.heading.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _1o9zidpf _1pfh1wug _vchhusvi _1bsb1osq _1yt4utpp"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _vchhusvi _1bsb1osq _p12f1jnb _1rjcv47k _18zrxncg _2rko1mok _1itk14ki _1reo15vq _18m915vq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
                        space: "space.200",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
                                space: "space.100",
                                alignInline: "center",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        "aria-level": 2,
                                        role: "heading",
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazi7uo _ect4r4hu _1wyb1ylp _k48p1fw0 _vwz4xe7b _y3gn1h6o"
                                        ]),
                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).stillNeedHelpTitle)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f4w00 _syazi7uo _ect41gus _1wyb1gpt _k48pl8b6 _vwz41xr0 _y3gn1h6o"
                                        ]),
                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).stillNeedHelpBody)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                ref: askPillRef,
                                type: "button",
                                onClick: ()=>chat.open(askPillRef),
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulpu2gc _4t3i1wqb _1rjcutpp _18zrpxbi _1dqoglyw _2rko1tm3 _80omtlke _bfhki7uo _v564slvs _1dbz130s _180dt7xp _1q8w2nsj _sedtglyw",
                                    demoPillState === 'hovered' && "_16qs130s",
                                    demoPillState === 'pressed' && "_16qst7xp _t9ec2nsj"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($agxCc))), {
                                        label: "",
                                        color: "var(--ds-text-inverse, #FFFFFF)"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        weight: "medium",
                                        color: "color.text.inverse",
                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).askAnything)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb1u1b _4t3i1u1b _2rko1rr0 _bfhkdtwc"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53VCz))), {
                                            label: "",
                                            color: "var(--ds-text, #292A2E)"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                weight: "medium",
                                children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).submitRequest)
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hdOkG.JsmPortalPlaygroundRovoLauncher), {
                chat: chat,
                articleId: article.id,
                onStreamComplete: shouldPlayDemo ? onDemoComplete : undefined
            }),
            shouldPlayDemo && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cmk36.JsmPlaygroundDemoCursor), {
                label: (0, $6m4qq.DEMO_CURSOR_LABEL),
                testId: "jsm-portal-article-demo-cursor",
                container: demoLayer,
                hasUserTakenOver: hasUserTakenOver,
                isPressed: demoCursor.isPressed,
                isTransitionEnabled: demoCursor.isTransitionEnabled,
                isVisible: demoCursor.isVisible,
                x: demoCursor.position.x,
                y: demoCursor.position.y
            })
        ]
    });
};
const $599c75a2618117f5$var$pageStyles = null;
const $599c75a2618117f5$var$columnStyles = null;
const $599c75a2618117f5$var$backLinkStyles = null;
const $599c75a2618117f5$var$metaRowStyles = null;
const $599c75a2618117f5$var$articleTitleStyles = null;
const $599c75a2618117f5$var$redactedLineStyles = null;
const $599c75a2618117f5$var$stillNeedHelpBandStyles = null;
const $599c75a2618117f5$var$stillNeedHelpCardStyles = null;
const $599c75a2618117f5$var$stillNeedHelpTitleStyles = null;
const $599c75a2618117f5$var$stillNeedHelpBodyStyles = null;
const $599c75a2618117f5$var$askPillStyles = null;
const $599c75a2618117f5$var$askPillHoveredStyles = null;
const $599c75a2618117f5$var$askPillPressedStyles = null;
const $599c75a2618117f5$var$askPillActionStyles = null;

});
parcelRegister("e4S7H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3fb6c251dca849c$var$_react = $a3fb6c251dca849c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a3fb6c251dca849c$var$_baseNew = $a3fb6c251dca849c$var$_interopRequireDefault((parcelRequire("jcI35")));
function $a3fb6c251dca849c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3fb6c251dca849c$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $a3fb6c251dca849c$var$_react.default.createElement($a3fb6c251dca849c$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$a3fb6c251dca849c$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $a3fb6c251dca849c$var$_default = module.exports.default = $a3fb6c251dca849c$var$AiGenerativeTextIcon;

});

parcelRegister("6m4qq", function(module, exports) {
$parcel$export(module.exports, "DEMO_CURSOR_LABEL", function () { return $6da1c4bc844435a8$export$7b0421224f2ae302; });
$parcel$export(module.exports, "HUB_DEMO", function () { return $6da1c4bc844435a8$export$b7abc9af2f2aa3c5; });
$parcel$export(module.exports, "ARTICLE_DEMO", function () { return $6da1c4bc844435a8$export$ac8fa4bfba4a524f; });

var $cmk36 = parcelRequire("cmk36");
const $6da1c4bc844435a8$export$7b0421224f2ae302 = 'Adam';
const $6da1c4bc844435a8$var$PRESS_MS = 200;
const $6da1c4bc844435a8$var$ARRIVE_AND_PRESS = (0, $cmk36.DEMO_CURSOR_TRAVEL_MS) + 150;
const $6da1c4bc844435a8$var$CURSOR_FADE_MS = 400;
const $6da1c4bc844435a8$var$buttonPress = 500 + $6da1c4bc844435a8$var$ARRIVE_AND_PRESS;
const $6da1c4bc844435a8$var$bannerSwatchMove = $6da1c4bc844435a8$var$buttonPress + $6da1c4bc844435a8$var$PRESS_MS + 400;
const $6da1c4bc844435a8$var$bannerSwatchPress = $6da1c4bc844435a8$var$bannerSwatchMove + $6da1c4bc844435a8$var$ARRIVE_AND_PRESS;
const $6da1c4bc844435a8$var$iconSwatchMove = $6da1c4bc844435a8$var$bannerSwatchPress + $6da1c4bc844435a8$var$PRESS_MS + 300;
const $6da1c4bc844435a8$var$iconSwatchPress = $6da1c4bc844435a8$var$iconSwatchMove + $6da1c4bc844435a8$var$ARRIVE_AND_PRESS;
const $6da1c4bc844435a8$var$cursorHide = $6da1c4bc844435a8$var$iconSwatchPress + $6da1c4bc844435a8$var$PRESS_MS + 600;
const $6da1c4bc844435a8$var$cardApproachJump = $6da1c4bc844435a8$var$cursorHide + $6da1c4bc844435a8$var$CURSOR_FADE_MS;
const $6da1c4bc844435a8$var$articleCardMove = $6da1c4bc844435a8$var$cardApproachJump + 300;
const $6da1c4bc844435a8$var$articleCardPress = $6da1c4bc844435a8$var$articleCardMove + $6da1c4bc844435a8$var$ARRIVE_AND_PRESS;
const $6da1c4bc844435a8$export$b7abc9af2f2aa3c5 = {
    cursorIn: 500,
    buttonPress: $6da1c4bc844435a8$var$buttonPress,
    buttonRelease: $6da1c4bc844435a8$var$buttonPress + $6da1c4bc844435a8$var$PRESS_MS,
    bannerSwatchMove: $6da1c4bc844435a8$var$bannerSwatchMove,
    bannerSwatchPress: $6da1c4bc844435a8$var$bannerSwatchPress,
    bannerSwatchRelease: $6da1c4bc844435a8$var$bannerSwatchPress + $6da1c4bc844435a8$var$PRESS_MS,
    iconSwatchMove: $6da1c4bc844435a8$var$iconSwatchMove,
    iconSwatchPress: $6da1c4bc844435a8$var$iconSwatchPress,
    iconSwatchRelease: $6da1c4bc844435a8$var$iconSwatchPress + $6da1c4bc844435a8$var$PRESS_MS,
    cursorHide: $6da1c4bc844435a8$var$cursorHide,
    cardApproachJump: $6da1c4bc844435a8$var$cardApproachJump,
    articleCardMove: $6da1c4bc844435a8$var$articleCardMove,
    articleCardPress: $6da1c4bc844435a8$var$articleCardPress,
    articleCardRelease: $6da1c4bc844435a8$var$articleCardPress + $6da1c4bc844435a8$var$PRESS_MS,
    cursorOut: $6da1c4bc844435a8$var$articleCardPress + $6da1c4bc844435a8$var$PRESS_MS + 500
};
const $6da1c4bc844435a8$var$askPillPress = 1600 + $6da1c4bc844435a8$var$ARRIVE_AND_PRESS;
const $6da1c4bc844435a8$export$ac8fa4bfba4a524f = {
    cursorIn: 1600,
    askPillPress: $6da1c4bc844435a8$var$askPillPress,
    askPillRelease: $6da1c4bc844435a8$var$askPillPress + $6da1c4bc844435a8$var$PRESS_MS,
    cursorOut: $6da1c4bc844435a8$var$askPillPress + $6da1c4bc844435a8$var$PRESS_MS + 500
};

});

parcelRegister("6YRn3", function(module, exports) {
$parcel$export(module.exports, "formatCardDate", function () { return $9541e0d57421f7ee$export$7511c33f9e568e04; });
$parcel$export(module.exports, "ARTICLE_DATE_FORMAT", function () { return $9541e0d57421f7ee$export$866a57f135c6eb01; });
$parcel$export(module.exports, "PortalArticleIconTile", function () { return $9541e0d57421f7ee$export$46669ec40ed869de; });

var $7VQPk = parcelRequire("7VQPk");

var $5XjEk = parcelRequire("5XjEk");

var $1ntJv = parcelRequire("1ntJv");
const $9541e0d57421f7ee$export$1b6441f1e316c9b0 = '"Work Sans", "Atlassian Sans", sans-serif';
const $9541e0d57421f7ee$export$878c8bdbd757475a = 'linear-gradient(90deg, #E1EF8F 0%, #94E7D6 100%)';
const $9541e0d57421f7ee$var$cardDateFormatter = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
});
const $9541e0d57421f7ee$export$7511c33f9e568e04 = (isoDate)=>$9541e0d57421f7ee$var$cardDateFormatter.format(new Date(isoDate));
const $9541e0d57421f7ee$export$866a57f135c6eb01 = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
};
const $9541e0d57421f7ee$var$BookTileIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5XjEk)));
const $9541e0d57421f7ee$export$46669ec40ed869de = ({ color: color, size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1ntJv.default), {
        icon: $9541e0d57421f7ee$var$BookTileIcon,
        label: "",
        appearance: color === 'teal' ? 'tealBold' : 'limeBold',
        size: size
    });

});
parcelRegister("5XjEk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4561b46b8a64a14b$var$_react = $4561b46b8a64a14b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4561b46b8a64a14b$var$_baseNew = $4561b46b8a64a14b$var$_interopRequireDefault((parcelRequire("jcI35")));
function $4561b46b8a64a14b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4561b46b8a64a14b$var$BookOpenIcon = (props)=>/*#__PURE__*/ $4561b46b8a64a14b$var$_react.default.createElement($4561b46b8a64a14b$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$4561b46b8a64a14b$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $4561b46b8a64a14b$var$_default = module.exports.default = $4561b46b8a64a14b$var$BookOpenIcon;

});

parcelRegister("1ntJv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $100f00c43fff3ccb$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fJ2Oh = parcelRequire("fJ2Oh");
// Icon color mapping for Tile-based icons
var $100f00c43fff3ccb$var$iconColorMap = {
    blue: "_syaz6txe",
    blueBold: "_syaz1q3r",
    gray: "_syazdgkc",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syaz1q3r",
    lime: "_syaz8645",
    limeBold: "_syaz1q3r",
    magenta: "_syazv8hk",
    magentaBold: "_syaz1q3r",
    orange: "_syaz1j6y",
    orangeBold: "_syaz1q3r",
    purple: "_syazuq3u",
    purpleBold: "_syaz1q3r",
    red: "_syaznbxb",
    redBold: "_syaz1q3r",
    teal: "_syaz8uof",
    tealBold: "_syaz1q3r",
    yellow: "_syaz1oqg",
    yellowBold: "_syaz1q3r"
};
var $100f00c43fff3ccb$var$iconWrapperStyles = {
    root: "_vwz4idpf"
};
// Background color mapping for Tile component
var $100f00c43fff3ccb$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $100f00c43fff3ccb$export$2e2bcd8739ae039(props) {
    var Icon = props.icon, label = props.label, appearance = props.appearance, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, testId = props.testId;
    var ExpandedIcon = Icon;
    return /*#__PURE__*/ $1oC0p.createElement((0, $fJ2Oh.default), {
        size: size,
        backgroundColor: $100f00c43fff3ccb$var$backgroundColorMap[appearance],
        label: label,
        testId: testId
    }, /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            $100f00c43fff3ccb$var$iconColorMap[appearance],
            $100f00c43fff3ccb$var$iconWrapperStyles.root
        ])
    }, /*#__PURE__*/ $1oC0p.createElement(ExpandedIcon, {
        color: "currentColor",
        label: "",
        shouldScale: true
    })));
}

});
parcelRegister("fJ2Oh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b72d3cff63cf5151$export$2e2bcd8739ae039; });
/* tile.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

// Pixel sizes per tile size, used for retina validation
var $b72d3cff63cf5151$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
var $b72d3cff63cf5151$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq _1jpx1dfr"
};
var $b72d3cff63cf5151$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
var $b72d3cff63cf5151$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
var $b72d3cff63cf5151$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
};
function $b72d3cff63cf5151$export$2e2bcd8739ae039(props) {
    var children = props.children, label = props.label, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, backgroundColor = props.backgroundColor, hasBorder = props.hasBorder, _props$isInset = props.isInset, isInset = _props$isInset === void 0 ? true : _props$isInset, testId = props.testId;
    var containerRef = (0, $1oC0p.useRef)(null);
    // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $1oC0p.useEffect)(function() {
        var _tileSizePx$size;
        var container, images, defaultSizePx, tilePx, unbinds;
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $2jatx.default)([
            $b72d3cff63cf5151$var$styles.root,
            $b72d3cff63cf5151$var$sizeMap[size],
            isInset ? $b72d3cff63cf5151$var$styles.inset : $b72d3cff63cf5151$var$styles.nonInset,
            isInset && $b72d3cff63cf5151$var$insetSizeMap[size],
            $b72d3cff63cf5151$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $b72d3cff63cf5151$var$styles.border
        ])
    }, children);
}

});



parcelRegister("hdOkG", function(module, exports) {
$parcel$export(module.exports, "usePortalRovoChat", function () { return $491a1b8189da7bf1$export$24d0dfb1f803e48d; });
$parcel$export(module.exports, "JsmPortalPlaygroundRovoLauncher", function () { return $491a1b8189da7bf1$export$c4e01c030c022316; });
$parcel$export(module.exports, "JsmPortalPlaygroundRovoLauncherMark", function () { return $491a1b8189da7bf1$export$982521968a0c7807; });
/* jsm-portal-playground-rovo-chat.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2r6UE = parcelRequire("2r6UE");

var $bIY3n = parcelRequire("bIY3n");

var $gyofT = parcelRequire("gyofT");

var $agxCc = parcelRequire("agxCc");

var $l5ucJ = parcelRequire("l5ucJ");

var $6e3tU = parcelRequire("6e3tU");

var $cNOwN = parcelRequire("cNOwN");

var $3OOxO = parcelRequire("3OOxO");

var $OXM0c = parcelRequire("OXM0c");

var $d6iWh = parcelRequire("d6iWh");

var $jftXk = parcelRequire("jftXk");

var $8ZCO1 = parcelRequire("8ZCO1");

var $bmQfx = parcelRequire("bmQfx");

var $51it3 = parcelRequire("51it3");

var $6A2DX = parcelRequire("6A2DX");

var $lPRxe = parcelRequire("lPRxe");

var $FapDU = parcelRequire("FapDU");

var $c0yqw = parcelRequire("c0yqw");

var $drTWQ = parcelRequire("drTWQ");

var $7575j = parcelRequire("7575j");

var $bBczw = parcelRequire("bBczw");

var $4JioC = parcelRequire("4JioC");
const $491a1b8189da7bf1$var$NewChatButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3OOxO))), {
        label: "",
        size: "medium"
    });
const $491a1b8189da7bf1$var$CloseButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
        label: "",
        size: "medium"
    });
const $491a1b8189da7bf1$var$GoodAnswerButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51it3))), {
        label: ""
    });
const $491a1b8189da7bf1$var$BadAnswerButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmQfx))), {
        label: ""
    });
const $491a1b8189da7bf1$var$FeedbackButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e3tU))), {
        label: ""
    });
const $491a1b8189da7bf1$var$AddContextButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bIY3n))), {
        label: ""
    });
const $491a1b8189da7bf1$var$DictateButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ZCO1))), {
        label: ""
    });
const $491a1b8189da7bf1$var$noop = ()=>{};
const $491a1b8189da7bf1$var$VPN_ANSWER_BLOCKS = [
    {
        kind: 'paragraph',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerIntro
    },
    {
        kind: 'heading',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep1Heading
    },
    {
        kind: 'linkedParagraph',
        before: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep1Before,
        linkLabel: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep1Link,
        after: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep1After
    },
    {
        kind: 'heading',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep2Heading
    },
    {
        kind: 'bullets',
        items: [
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep2Bullet1,
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep2Bullet2
        ]
    },
    {
        kind: 'heading',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep3Heading
    },
    {
        kind: 'bullets',
        items: [
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep3Bullet1,
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerStep3Bullet2
        ]
    },
    {
        kind: 'paragraph',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).answerOutro
    }
];
const $491a1b8189da7bf1$var$LAPTOP_ANSWER_BLOCKS = [
    {
        kind: 'paragraph',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopAnswerIntro
    },
    {
        kind: 'heading',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopAnswerStep1Heading
    },
    {
        kind: 'paragraph',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopAnswerStep1Body
    },
    {
        kind: 'heading',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopAnswerStep2Heading
    },
    {
        kind: 'bullets',
        items: [
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopAnswerStep2Bullet1,
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopAnswerStep2Bullet2
        ]
    },
    {
        kind: 'heading',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopAnswerStep3Heading
    },
    {
        kind: 'bullets',
        items: [
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopAnswerStep3Bullet1
        ]
    },
    {
        kind: 'paragraph',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopAnswerOutro
    }
];
const $491a1b8189da7bf1$var$PASSWORD_ANSWER_BLOCKS = [
    {
        kind: 'paragraph',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordAnswerIntro
    },
    {
        kind: 'heading',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordAnswerStep1Heading
    },
    {
        kind: 'paragraph',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordAnswerStep1Body
    },
    {
        kind: 'heading',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordAnswerStep2Heading
    },
    {
        kind: 'bullets',
        items: [
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordAnswerStep2Bullet1,
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordAnswerStep2Bullet2
        ]
    },
    {
        kind: 'heading',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordAnswerStep3Heading
    },
    {
        kind: 'bullets',
        items: [
            (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordAnswerStep3Bullet1
        ]
    },
    {
        kind: 'paragraph',
        text: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordAnswerOutro
    }
];
const $491a1b8189da7bf1$var$ROVO_CONVERSATIONS = {
    vpn: {
        visitorQuestion: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).visitorQuestion,
        blocks: $491a1b8189da7bf1$var$VPN_ANSWER_BLOCKS
    },
    laptop: {
        visitorQuestion: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).laptopVisitorQuestion,
        blocks: $491a1b8189da7bf1$var$LAPTOP_ANSWER_BLOCKS
    },
    password: {
        visitorQuestion: (0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).passwordVisitorQuestion,
        blocks: $491a1b8189da7bf1$var$PASSWORD_ANSWER_BLOCKS
    }
};
const $491a1b8189da7bf1$var$THINKING_MS = 2200;
const $491a1b8189da7bf1$var$BLOCK_MS = 420;
const $491a1b8189da7bf1$var$AFTERWORD_MS = 500;
const $491a1b8189da7bf1$export$a5021e68570e1bd = $491a1b8189da7bf1$var$THINKING_MS + ($491a1b8189da7bf1$var$VPN_ANSWER_BLOCKS.length - 1) * $491a1b8189da7bf1$var$BLOCK_MS + $491a1b8189da7bf1$var$AFTERWORD_MS;
const $491a1b8189da7bf1$var$EXPAND_MS = 320;
const $491a1b8189da7bf1$var$PANEL_EASE = 'cubic-bezier(0.33, 0, 0.2, 1)';
const $491a1b8189da7bf1$var$LAUNCHER_SIZE = 40;
const $491a1b8189da7bf1$var$LAUNCHER_INSET = 16;
const $491a1b8189da7bf1$var$LAUNCHER_GRADIENT = 'linear-gradient(135deg, #E1EF8F 0%, #94E7D6 100%)';
const $491a1b8189da7bf1$var$PANEL_WIDTH = 400;
const $491a1b8189da7bf1$var$usePanelExpansion = (onClose, shouldShowComplete)=>{
    const [phase, setPhase] = (0, $1oC0p.useState)(shouldShowComplete ? 'expanded' : 'collapsed');
    const closeTimerRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (shouldShowComplete) {
            setPhase('expanded');
            return;
        }
        const frame = requestAnimationFrame(()=>setPhase('expanded'));
        return ()=>cancelAnimationFrame(frame);
    }, [
        shouldShowComplete
    ]);
    (0, $1oC0p.useEffect)(()=>()=>{
            if (closeTimerRef.current !== null) window.clearTimeout(closeTimerRef.current);
        }, []);
    const requestClose = ()=>{
        if (shouldShowComplete) {
            onClose();
            return;
        }
        setPhase('closing');
        closeTimerRef.current = window.setTimeout(onClose, $491a1b8189da7bf1$var$EXPAND_MS);
    };
    const isOpen = phase === 'expanded';
    const transition = (value)=>shouldShowComplete ? undefined : value;
    return {
        requestClose: requestClose,
        panelStyle: {
            borderRadius: isOpen ? "var(--ds-radius-large, 8px)" : `${$491a1b8189da7bf1$var$LAUNCHER_SIZE / 2}px`,
            top: isOpen ? `${$491a1b8189da7bf1$var$LAUNCHER_INSET}px` : `calc(100% - ${$491a1b8189da7bf1$var$LAUNCHER_INSET + $491a1b8189da7bf1$var$LAUNCHER_SIZE}px)`,
            width: isOpen ? `${$491a1b8189da7bf1$var$PANEL_WIDTH}px` : `${$491a1b8189da7bf1$var$LAUNCHER_SIZE}px`,
            transition: transition(`top ${$491a1b8189da7bf1$var$EXPAND_MS}ms ${$491a1b8189da7bf1$var$PANEL_EASE}, width ${$491a1b8189da7bf1$var$EXPAND_MS}ms ${$491a1b8189da7bf1$var$PANEL_EASE}, border-radius ${$491a1b8189da7bf1$var$EXPAND_MS}ms ${$491a1b8189da7bf1$var$PANEL_EASE}`)
        },
        fillStyle: {
            opacity: isOpen ? 0 : 1,
            transition: transition(`opacity 180ms ${$491a1b8189da7bf1$var$PANEL_EASE}`)
        },
        contentStyle: {
            opacity: isOpen ? 1 : 0,
            transition: transition(`opacity ${$491a1b8189da7bf1$var$EXPAND_MS / 2}ms ${$491a1b8189da7bf1$var$PANEL_EASE} ${isOpen ? $491a1b8189da7bf1$var$EXPAND_MS / 2 : 0}ms`)
        },
        glyphStyle: {
            opacity: isOpen ? 0 : 1,
            transition: transition(`opacity 140ms ${$491a1b8189da7bf1$var$PANEL_EASE}`)
        }
    };
};
const $491a1b8189da7bf1$var$useAnswerStream = (blocks, shouldRevealImmediately)=>{
    const [revealedCount, setRevealedCount] = (0, $1oC0p.useState)(shouldRevealImmediately ? blocks.length : 0);
    const [isComplete, setIsComplete] = (0, $1oC0p.useState)(shouldRevealImmediately);
    (0, $1oC0p.useEffect)(()=>{
        if (shouldRevealImmediately) {
            setRevealedCount(blocks.length);
            setIsComplete(true);
            return;
        }
        setRevealedCount(0);
        setIsComplete(false);
        const timers = blocks.map((_, index)=>window.setTimeout(()=>setRevealedCount(index + 1), $491a1b8189da7bf1$var$THINKING_MS + index * $491a1b8189da7bf1$var$BLOCK_MS));
        timers.push(window.setTimeout(()=>setIsComplete(true), $491a1b8189da7bf1$var$THINKING_MS + (blocks.length - 1) * $491a1b8189da7bf1$var$BLOCK_MS + $491a1b8189da7bf1$var$AFTERWORD_MS));
        return ()=>timers.forEach(window.clearTimeout);
    }, [
        blocks,
        shouldRevealImmediately
    ]);
    return {
        isThinking: revealedCount === 0,
        revealedCount: revealedCount,
        isComplete: isComplete
    };
};
const $491a1b8189da7bf1$export$24d0dfb1f803e48d = ()=>{
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const [isOpenedByDemo, setIsOpenedByDemo] = (0, $1oC0p.useState)(false);
    const [shouldStartComplete, setShouldStartComplete] = (0, $1oC0p.useState)(false);
    const [returnFocusTo, setReturnFocusTo] = (0, $1oC0p.useState)(null);
    const launcherRef = (0, $1oC0p.useRef)(null);
    const { firePlaygroundScreenNavigated: firePlaygroundScreenNavigated } = (0, $7575j.useJsmPlaygroundAnalytics)('it_support');
    (0, $1oC0p.useEffect)(()=>{
        if (isOpen || !returnFocusTo) return;
        returnFocusTo.current?.focus();
        setReturnFocusTo(null);
    }, [
        isOpen,
        returnFocusTo
    ]);
    const open = (0, $1oC0p.useCallback)((opener = launcherRef, { isDemo: isDemo = false } = {})=>{
        setReturnFocusTo(opener);
        setIsOpenedByDemo(isDemo);
        setShouldStartComplete(false);
        setIsOpen(true);
        if (!isDemo) firePlaygroundScreenNavigated({
            team_type: 'it_support',
            screen_id: 'virtual_agent_chat',
            interaction_mode: 'manual_click'
        });
    }, [
        firePlaygroundScreenNavigated
    ]);
    const close = (0, $1oC0p.useCallback)(({ shouldRestoreFocus: shouldRestoreFocus })=>{
        if (!shouldRestoreFocus) setReturnFocusTo(null);
        setIsOpen(false);
        setShouldStartComplete(false);
    }, []);
    const completeNow = (0, $1oC0p.useCallback)(()=>{
        setReturnFocusTo(null);
        setIsOpenedByDemo(true);
        setShouldStartComplete(true);
        setIsOpen(true);
    }, []);
    return {
        isOpen: isOpen,
        isOpenedByDemo: isOpenedByDemo,
        shouldStartComplete: shouldStartComplete,
        launcherRef: launcherRef,
        open: open,
        close: close,
        completeNow: completeNow
    };
};
const $491a1b8189da7bf1$export$c4e01c030c022316 = ({ chat: chat, articleId: articleId = 'vpn', onStreamComplete: onStreamComplete })=>{
    const intl = (0, $8e22h.default)();
    if (chat.isOpen) return /*#__PURE__*/ (0, $7VQPk.jsx)($491a1b8189da7bf1$var$RovoChatPanel, {
        articleId: articleId,
        onClose: chat.close,
        onStreamComplete: chat.isOpenedByDemo ? onStreamComplete : undefined,
        shouldFocusOnOpen: !chat.isOpenedByDemo,
        shouldStartComplete: chat.shouldStartComplete
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        ref: chat.launcherRef,
        type: "button",
        "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).askRovo),
        onClick: ()=>chat.open(),
        className: (0, $2jatx.default)([
            "_kqswstnw _u7co7vkz _rjxp7vkz _1pbyb4wl _1e0c116y _4cvr1h6o _1bah1h6o _1bsb1ylp _4t3i1ylp _vchhusvi _1yt4u2gc _1dqoglyw _2rko1rr0 _80omtlke _1itk4z1l _16qs130s"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($agxCc))), {
            label: "",
            color: "var(--ds-text, #292A2E)"
        })
    });
};
const $491a1b8189da7bf1$export$982521968a0c7807 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_kqswstnw _u7co7vkz _rjxp7vkz _1pbyb4wl _1e0c116y _4cvr1h6o _1bah1h6o _1bsb1ylp _4t3i1ylp _vchhusvi _1yt4u2gc _1dqoglyw _2rko1rr0 _80omtlke _1itk4z1l _16qs130s"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($agxCc))), {
            label: "",
            color: "var(--ds-text, #292A2E)"
        })
    });
const $491a1b8189da7bf1$var$RovoChatPanel = ({ articleId: articleId = 'vpn', onClose: onClose, onStreamComplete: onStreamComplete, shouldFocusOnOpen: shouldFocusOnOpen, shouldStartComplete: shouldStartComplete = false })=>{
    const intl = (0, $8e22h.default)();
    const prefersReducedMotion = (0, $bBczw.usePrefersReducedMotion)();
    const shouldShowComplete = prefersReducedMotion || shouldStartComplete;
    const panelRef = (0, $1oC0p.useRef)(null);
    const closeButtonRef = (0, $1oC0p.useRef)(null);
    const conversation = $491a1b8189da7bf1$var$ROVO_CONVERSATIONS[articleId] ?? $491a1b8189da7bf1$var$ROVO_CONVERSATIONS.vpn;
    const { isThinking: isThinking, revealedCount: revealedCount, isComplete: isComplete } = $491a1b8189da7bf1$var$useAnswerStream(conversation.blocks, shouldShowComplete);
    const onStreamCompleteRef = (0, $1oC0p.useRef)(onStreamComplete);
    onStreamCompleteRef.current = onStreamComplete;
    (0, $1oC0p.useEffect)(()=>{
        if (isComplete) onStreamCompleteRef.current?.();
    }, [
        isComplete
    ]);
    const { requestClose: requestClose, panelStyle: panelStyle, fillStyle: fillStyle, contentStyle: contentStyle, glyphStyle: glyphStyle } = $491a1b8189da7bf1$var$usePanelExpansion(()=>onClose({
            shouldRestoreFocus: panelRef.current?.contains(document.activeElement) ?? false
        }), shouldShowComplete);
    const requestCloseRef = (0, $1oC0p.useRef)(requestClose);
    requestCloseRef.current = requestClose;
    const { fireTextFieldBlurred: fireTextFieldBlurred } = (0, $7575j.useJsmPlaygroundAnalytics)('it_support');
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (shouldStartComplete) closeButtonRef.current?.focus();
    }, [
        shouldStartComplete
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (shouldFocusOnOpen) closeButtonRef.current?.focus();
        const handleKeyDown = (event)=>{
            const playground = panelRef.current?.closest('[data-preview-scale]') ?? panelRef.current;
            if (event.key === 'Escape' && event.target instanceof Node && playground?.contains(event.target)) requestCloseRef.current();
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, []);
    const answerAnnouncement = conversation.blocks.flatMap((block)=>{
        if (block.kind === 'bullets') return block.items.map((item)=>intl.formatMessage(item));
        if (block.kind === 'linkedParagraph') return [
            `${intl.formatMessage(block.before)} ${intl.formatMessage(block.linkLabel)} ${intl.formatMessage(block.after)}`
        ];
        return [
            intl.formatMessage(block.text)
        ];
    }).join(' ');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: panelRef,
        style: panelStyle,
        role: "dialog",
        "aria-label": intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).chatLabel),
        "data-testid": "jsm-portal-rovo-chat",
        className: (0, $2jatx.default)([
            "_kqswstnw _u7co7vkz _rjxp7vkz _1pby1kze _1e0c1txw _2lx21bp4 _vchhusvi _1reo15vq _18m915vq _bfhk1bhr _16qs130s"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                style: fillStyle,
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _lcxvglyw _1itk4z1l"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                style: glyphStyle,
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _1e02idpf _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ylp _4t3i1osq _lcxvglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($agxCc))), {
                    label: "",
                    color: "var(--ds-text, #292A2E)"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: contentStyle,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c1txw _2lx21bp4 _1o9zidpf _1bsb1kdj _4t3i1osq _1tkeidpf _11c8y28r"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1o9zidpf _zulp1b66 _1rjcu2gc _18zrutpp"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _16jlkb7n _zulp12x7 _1ul9idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: (0, $2jatx.default)([
                                            "_1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf _1bsbgktf _4t3igktf _2rko1rr0 _bfhk1e5c _syaz15cr _11c8wadc _k48pwu06"
                                        ]),
                                        children: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).chatName).charAt(0)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        weight: "semibold",
                                        maxLines: 1,
                                        children: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).chatName)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5ucJ))), {
                                        label: "",
                                        size: "small",
                                        color: "var(--ds-icon-subtle, #505258)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1o9zidpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($491a1b8189da7bf1$var$InertControls, {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                            appearance: "subtle",
                                            icon: $491a1b8189da7bf1$var$NewChatButtonIcon,
                                            label: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).newChat),
                                            onClick: $491a1b8189da7bf1$var$noop,
                                            spacing: "compact",
                                            tabIndex: -1
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                        ref: closeButtonRef,
                                        appearance: "subtle",
                                        icon: $491a1b8189da7bf1$var$CloseButtonIcon,
                                        label: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).closeChat),
                                        onClick: requestClose,
                                        spacing: "compact"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _16jlkb7n _zulppxbi _1tkeidpf _18m91wug _1reo15vq _1rjcutpp _18zrpxbi"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bahesu3 _1bsb1osq"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_vchhusvi _p12f1osq _1rjcu2gc _18zrutpp _2rko1mok _bfhk1856 _o5721q9c"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        size: "medium",
                                        color: "color.text.inverse",
                                        children: intl.formatMessage(conversation.visitorQuestion)
                                    })
                                })
                            }),
                            isThinking ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulpu2gc"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4JioC.JsmPlaygroundRovoMorphingShape), {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).thinking)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                "aria-hidden": "true",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulputpp _1bsb1osq"
                                ]),
                                children: [
                                    conversation.blocks.slice(0, revealedCount).map((block, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_y44vmmll _1bumglyw"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($491a1b8189da7bf1$var$AnswerBlockBody, {
                                                block: block
                                            })
                                        }, index)),
                                    isComplete && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_y44vmmll _1bumglyw",
                                            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulputpp"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c116y _4cvr1h6o _zulp12x7 _1rjc1b66 _18zru2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko12b0"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.ConfluenceIcon), {
                                                        appearance: "brand",
                                                        label: "",
                                                        shouldUseNewLogoDesign: true,
                                                        size: "xxsmall"
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                        size: "small",
                                                        children: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).sources)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)($491a1b8189da7bf1$var$InertControls, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                        appearance: "subtle",
                                                        icon: $491a1b8189da7bf1$var$GoodAnswerButtonIcon,
                                                        label: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).goodAnswer),
                                                        onClick: $491a1b8189da7bf1$var$noop,
                                                        spacing: "compact",
                                                        tabIndex: -1
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                        appearance: "subtle",
                                                        icon: $491a1b8189da7bf1$var$BadAnswerButtonIcon,
                                                        label: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).badAnswer),
                                                        onClick: $491a1b8189da7bf1$var$noop,
                                                        spacing: "compact",
                                                        tabIndex: -1
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                        appearance: "subtle",
                                                        icon: $491a1b8189da7bf1$var$FeedbackButtonIcon,
                                                        label: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).giveFeedback),
                                                        onClick: $491a1b8189da7bf1$var$noop,
                                                        spacing: "compact",
                                                        tabIndex: -1
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1o9zidpf _zulp1b66 _85i5u2gc _18zrutpp"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulpu2gc _vchhusvi _1bsb1osq _1rjcu2gc _18zrutpp _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko1qi0 _bfhkvuon"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                        type: "text",
                                        "aria-label": intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).askFollowUp),
                                        placeholder: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).askFollowUp),
                                        onBlur: (event)=>{
                                            const val = event.target.value;
                                            fireTextFieldBlurred({
                                                screenId: 'virtual_agent_chat',
                                                elementId: 'askFollowUp',
                                                actionSubjectId: 'askFollowUp',
                                                hasChanged: val.length > 0,
                                                inputLength: val.length,
                                                teamType: 'it_support'
                                            });
                                        },
                                        className: (0, $2jatx.default)([
                                            "_1bsb1osq _1rjcv77o _18zridpf _1wyb1trj _1dqoglyw _12ji1r31 _1qu2glyw _12y31o36 _syazi7uo _bfhk1j28 _1idr1rpy"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _4cvr1h6o _zulp12x7"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)($491a1b8189da7bf1$var$InertControls, {
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                            appearance: "subtle",
                                                            icon: $491a1b8189da7bf1$var$AddContextButtonIcon,
                                                            label: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).addContext),
                                                            onClick: $491a1b8189da7bf1$var$noop,
                                                            spacing: "compact",
                                                            tabIndex: -1
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                        "aria-hidden": "true",
                                                        className: (0, $2jatx.default)([
                                                            "_1e0c116y _4cvr1h6o _zulp12x7"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)($491a1b8189da7bf1$var$SlackMark, {}),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.ConfluenceIcon), {
                                                                appearance: "brand",
                                                                label: "",
                                                                shouldUseNewLogoDesign: true,
                                                                size: "xxsmall"
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                                size: "small",
                                                                color: "color.text.subtlest",
                                                                children: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).moreApps)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _4cvr1h6o _zulp12x7"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                        "aria-hidden": "true",
                                                        className: (0, $2jatx.default)([
                                                            "_1e0c116y _4cvr1h6o _zulp1b66"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gyofT))), {
                                                                label: "",
                                                                size: "small",
                                                                color: "var(--ds-icon-subtle, #505258)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                                size: "small",
                                                                color: "color.text.subtle",
                                                                children: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).agentPicker)
                                                            })
                                                        ]
                                                    }),
                                                    isComplete ? /*#__PURE__*/ (0, $7VQPk.jsx)($491a1b8189da7bf1$var$InertControls, {
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                            appearance: "subtle",
                                                            icon: $491a1b8189da7bf1$var$DictateButtonIcon,
                                                            label: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).dictate),
                                                            onClick: $491a1b8189da7bf1$var$noop,
                                                            spacing: "compact",
                                                            tabIndex: -1
                                                        })
                                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                        "aria-hidden": "true",
                                                        className: (0, $2jatx.default)([
                                                            "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb1tcg _4t3i1tcg _vchhusvi _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko12b0"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_1bsb19bv _4t3i19bv _2rkolb4i _bfhkybec"
                                                            ])
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _zulp1b66"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d6iWh))), {
                                        label: "",
                                        size: "small",
                                        color: "var(--ds-icon-subtle, #505258)"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: intl.formatMessage((0, $drTWQ.jsmPortalPlaygroundRovoChatMessages).disclosure)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jftXk))), {
                                        label: "",
                                        size: "small",
                                        color: "var(--ds-icon-subtle, #505258)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "aria-live": "polite",
                    children: isComplete ? answerAnnouncement : ''
                })
            })
        ]
    });
};
const $491a1b8189da7bf1$var$InertControls = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": "true",
        // @ts-expect-error -- inert is valid HTML but is missing from @compiled/react types
        inert: "",
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zulpv77o"
        ]),
        children: children
    });
const $491a1b8189da7bf1$var$AnswerBlockBody = ({ block: block })=>{
    const intl = (0, $8e22h.default)();
    if (block.kind === 'heading') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
        size: "medium",
        weight: "bold",
        children: intl.formatMessage(block.text)
    });
    if (block.kind === 'bullets') return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulputpp _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bozgv47k _1wybdlk8 _vwz4gktf _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1fozdlk8 _1wmcgktf _1bm11b66"
        ]),
        children: block.items.map((item)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    size: "medium",
                    children: intl.formatMessage(item)
                })
            }, item.id))
    });
    if (block.kind === 'linkedParagraph') return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lPRxe.default), {
        size: "medium",
        children: [
            `${intl.formatMessage(block.before)} `,
            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1b66 _1rjcv77o _18zr1b66 _2rko12b0 _bfhk15s3 _s7n41q9y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($OXM0c))), {
                        label: "",
                        size: "small",
                        color: "var(--ds-link, #1868DB)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        size: "medium",
                        color: "color.link",
                        children: intl.formatMessage(block.linkLabel)
                    })
                ]
            }),
            ` ${intl.formatMessage(block.after)}`
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
        size: "medium",
        children: intl.formatMessage(block.text)
    });
};
const $491a1b8189da7bf1$var$SlackMark = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 16,
        height: 16,
        viewBox: "23.53 23.8 33.35 33.35",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_1e0c1ule _1o9zidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#E01E5A",
                fillRule: "evenodd",
                d: "M30.5674 44.8842C30.5674 46.8232 29.0034 48.3881 27.0656 48.3881C25.1277 48.3881 23.5637 46.8179 23.5637 44.8842C23.5637 42.9505 25.1277 41.3804 27.0656 41.3804H30.5674V44.8842ZM32.3157 44.8842C32.3157 42.9452 33.8796 41.3804 35.8175 41.3804C37.7554 41.3804 39.3193 42.9452 39.3193 44.8842V53.6412C39.3193 55.5802 37.7554 57.145 35.8175 57.145C33.8796 57.145 32.3157 55.5802 32.3157 53.6412V44.8842Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#36C5F0",
                fillRule: "evenodd",
                d: "M35.8175 30.8153C33.8796 30.8153 32.3156 29.2504 32.3156 27.3115C32.3156 25.3725 33.8796 23.8076 35.8175 23.8076C37.7553 23.8076 39.3193 25.3725 39.3193 27.3115V30.8153H35.8175ZM35.8175 32.5909C37.7553 32.5909 39.3193 34.1558 39.3193 36.0948C39.3193 38.0338 37.7553 39.5986 35.8175 39.5986H27.0392C25.1013 39.5986 23.5374 38.0285 23.5374 36.0948C23.5374 34.1611 25.1013 32.5909 27.0392 32.5909H35.8175Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#2EB67D",
                fillRule: "evenodd",
                d: "M49.8472 36.0948C49.8472 34.1558 51.4111 32.5909 53.349 32.5909C55.2869 32.5909 56.8508 34.1558 56.8508 36.0948C56.8508 38.0338 55.2869 39.5986 53.349 39.5986H49.8472V36.0948ZM48.0989 36.0948C48.0989 38.0338 46.5349 39.5986 44.597 39.5986C42.6592 39.5986 41.0952 38.0338 41.0952 36.0948V27.3115C41.0952 25.3725 42.6592 23.8076 44.597 23.8076C46.5349 23.8076 48.0989 25.3725 48.0989 27.3115V36.0948Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#ECB22E",
                fillRule: "evenodd",
                d: "M44.597 50.1373C46.5349 50.1373 48.0989 51.7022 48.0989 53.6412C48.0989 55.5802 46.5349 57.145 44.597 57.145C42.6592 57.145 41.0952 55.5802 41.0952 53.6412V50.1373H44.597ZM44.597 48.3881C42.6592 48.3881 41.0952 46.8232 41.0952 44.8842C41.0952 42.9452 42.6592 41.3804 44.597 41.3804H53.3753C55.3132 41.3804 56.8772 42.9452 56.8772 44.8842C56.8772 46.8232 55.3132 48.3881 53.3753 48.3881H44.597Z"
            })
        ]
    });
const $491a1b8189da7bf1$var$blockIn = null;
const $491a1b8189da7bf1$var$launcherButtonStyles = null;
const $491a1b8189da7bf1$var$panelStyles = null;
const $491a1b8189da7bf1$var$launcherFillStyles = null;
const $491a1b8189da7bf1$var$launcherGlyphStyles = null;
const $491a1b8189da7bf1$var$panelContentStyles = null;
const $491a1b8189da7bf1$var$headerStyles = null;
const $491a1b8189da7bf1$var$headerNameStyles = null;
const $491a1b8189da7bf1$var$headerActionsStyles = null;
const $491a1b8189da7bf1$var$avatarStyles = null;
const $491a1b8189da7bf1$var$inertControlsStyles = null;
const $491a1b8189da7bf1$var$transcriptStyles = null;
const $491a1b8189da7bf1$var$questionRowStyles = null;
const $491a1b8189da7bf1$var$questionBubbleStyles = null;
const $491a1b8189da7bf1$var$thinkingRowStyles = null;
const $491a1b8189da7bf1$var$answerStyles = null;
const $491a1b8189da7bf1$var$blockInStyles = null;
const $491a1b8189da7bf1$var$afterwordStyles = null;
const $491a1b8189da7bf1$var$bulletsStyles = null;
const $491a1b8189da7bf1$var$resourceChipStyles = null;
const $491a1b8189da7bf1$var$sourcesChipStyles = null;
const $491a1b8189da7bf1$var$footerStyles = null;
const $491a1b8189da7bf1$var$composerStyles = null;
const $491a1b8189da7bf1$var$composerInputStyles = null;
const $491a1b8189da7bf1$var$composerToolbarStyles = null;
const $491a1b8189da7bf1$var$composerToolbarGroupStyles = null;
const $491a1b8189da7bf1$var$appMarksStyles = null;
const $491a1b8189da7bf1$var$slackMarkStyles = null;
const $491a1b8189da7bf1$var$agentPickerStyles = null;
const $491a1b8189da7bf1$var$stopButtonStyles = null;
const $491a1b8189da7bf1$var$stopSquareStyles = null;
const $491a1b8189da7bf1$var$disclosureStyles = null;

});
parcelRegister("8ZCO1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7122854feb0d3dc40d41eb59fb3bbcf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68c21f463002e277$var$_react = $68c21f463002e277$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $68c21f463002e277$var$_baseNew = $68c21f463002e277$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $68c21f463002e277$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Microphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: record sounds in Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68c21f463002e277$var$MicrophoneIcon = (props)=>/*#__PURE__*/ $68c21f463002e277$var$_react.default.createElement($68c21f463002e277$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A1.5 1.5 0 0 0 6.5 3v4a1.5 1.5 0 1 0 3 0V3A1.5 1.5 0 0 0 8 1.5M5 3a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0zM3.5 7a4.5 4.5 0 0 0 9 0H14c0 3.06-2.29 5.585-5.25 5.954V14.5H12V16H4v-1.5h3.25v-1.546A6 6 0 0 1 2 7z" clip-rule="evenodd"/>`
    }, props));
$68c21f463002e277$var$MicrophoneIcon.displayName = 'MicrophoneIcon';
var $68c21f463002e277$var$_default = module.exports.default = $68c21f463002e277$var$MicrophoneIcon;

});

parcelRegister("drTWQ", function(module, exports) {
$parcel$export(module.exports, "jsmPortalPlaygroundRovoChatMessages", function () { return $60a846d3bd24e447$export$5f89927e27271b23; });

var $fnHPc = parcelRequire("fnHPc");
const $60a846d3bd24e447$export$5f89927e27271b23 = (0, $fnHPc.defineMessages)({
    chatLabel: {
        id: 'JsmPortalPlayground.rovoChat.chatLabel',
        defaultMessage: 'Beaconstone Support chat'
    },
    chatName: {
        id: 'JsmPortalPlayground.rovoChat.chatName',
        defaultMessage: 'Beaconstone Support'
    },
    newChat: {
        id: 'JsmPortalPlayground.rovoChat.newChat',
        defaultMessage: 'New chat'
    },
    closeChat: {
        id: 'JsmPortalPlayground.rovoChat.closeChat',
        defaultMessage: 'Close chat'
    },
    visitorQuestion: {
        id: 'JsmPortalPlayground.rovoChat.visitorQuestion',
        defaultMessage: 'How do I setup VPN access for remote work?'
    },
    thinking: {
        id: 'JsmPortalPlayground.rovoChat.thinking',
        defaultMessage: 'Rovo is thinking'
    },
    answerIntro: {
        id: 'JsmPortalPlayground.rovoChat.answerIntro',
        defaultMessage: "Here's step-by-step instructions on how to setup Beaconstone VPN:"
    },
    answerStep1Heading: {
        id: 'JsmPortalPlayground.rovoChat.answerStep1Heading',
        defaultMessage: 'Step 1: Install VPN client'
    },
    answerStep1Before: {
        id: 'JsmPortalPlayground.rovoChat.answerStep1Before',
        defaultMessage: 'Download the approved VPN client from'
    },
    answerStep1Link: {
        id: 'JsmPortalPlayground.rovoChat.answerStep1Link',
        defaultMessage: 'VPN installer'
    },
    answerStep1After: {
        id: 'JsmPortalPlayground.rovoChat.answerStep1After',
        defaultMessage: 'then open the installer and follow the instructions'
    },
    answerStep2Heading: {
        id: 'JsmPortalPlayground.rovoChat.answerStep2Heading',
        defaultMessage: 'Step 2: Sign in with SSO'
    },
    answerStep2Bullet1: {
        id: 'JsmPortalPlayground.rovoChat.answerStep2Bullet1',
        defaultMessage: 'Open the VPN application and select "Sign-in"'
    },
    answerStep2Bullet2: {
        id: 'JsmPortalPlayground.rovoChat.answerStep2Bullet2',
        defaultMessage: 'Complete MFA verification with official credentials'
    },
    answerStep3Heading: {
        id: 'JsmPortalPlayground.rovoChat.answerStep3Heading',
        defaultMessage: 'Step 3: Connect'
    },
    answerStep3Bullet1: {
        id: 'JsmPortalPlayground.rovoChat.answerStep3Bullet1',
        defaultMessage: 'Select profile: Beaconstone-GB and click connect'
    },
    answerStep3Bullet2: {
        id: 'JsmPortalPlayground.rovoChat.answerStep3Bullet2',
        defaultMessage: 'Complete MFA verification with official credentials'
    },
    answerOutro: {
        id: 'JsmPortalPlayground.rovoChat.answerOutro',
        defaultMessage: 'You should now have secure remote access.'
    },
    passwordVisitorQuestion: {
        id: 'JsmPortalPlayground.rovoChat.password.visitorQuestion',
        defaultMessage: "I'm locked out of my account, how do I get back in?"
    },
    passwordAnswerIntro: {
        id: 'JsmPortalPlayground.rovoChat.password.answerIntro',
        defaultMessage: "Here's how to recover access and unlock your Beaconstone account:"
    },
    passwordAnswerStep1Heading: {
        id: 'JsmPortalPlayground.rovoChat.password.answerStep1Heading',
        defaultMessage: 'Step 1: Verify your identity'
    },
    passwordAnswerStep1Body: {
        id: 'JsmPortalPlayground.rovoChat.password.answerStep1Body',
        defaultMessage: 'Open the account recovery portal from any browser and submit your company email address.'
    },
    passwordAnswerStep2Heading: {
        id: 'JsmPortalPlayground.rovoChat.password.answerStep2Heading',
        defaultMessage: 'Step 2: Confirm via secondary device'
    },
    passwordAnswerStep2Bullet1: {
        id: 'JsmPortalPlayground.rovoChat.password.answerStep2Bullet1',
        defaultMessage: 'Approve the push notification on your registered authenticator app'
    },
    passwordAnswerStep2Bullet2: {
        id: 'JsmPortalPlayground.rovoChat.password.answerStep2Bullet2',
        defaultMessage: 'Enter the 6-digit backup security code if prompted'
    },
    passwordAnswerStep3Heading: {
        id: 'JsmPortalPlayground.rovoChat.password.answerStep3Heading',
        defaultMessage: 'Step 3: Set a new password'
    },
    passwordAnswerStep3Bullet1: {
        id: 'JsmPortalPlayground.rovoChat.password.answerStep3Bullet1',
        defaultMessage: 'Choose a new password with at least 12 characters'
    },
    passwordAnswerOutro: {
        id: 'JsmPortalPlayground.rovoChat.password.answerOutro',
        defaultMessage: 'You should now be able to sign in across all workspace apps.'
    },
    laptopVisitorQuestion: {
        id: 'JsmPortalPlayground.rovoChat.laptop.visitorQuestion',
        defaultMessage: 'What do I need to do on my first day to get my laptop ready?'
    },
    laptopAnswerIntro: {
        id: 'JsmPortalPlayground.rovoChat.laptop.answerIntro',
        defaultMessage: "Here's a quick checklist to get your new work laptop up and running:"
    },
    laptopAnswerStep1Heading: {
        id: 'JsmPortalPlayground.rovoChat.laptop.answerStep1Heading',
        defaultMessage: 'Step 1: Complete initial sign-in'
    },
    laptopAnswerStep1Body: {
        id: 'JsmPortalPlayground.rovoChat.laptop.answerStep1Body',
        defaultMessage: 'Power on your machine, connect to Wi-Fi, and sign in with your Beaconstone SSO credentials.'
    },
    laptopAnswerStep2Heading: {
        id: 'JsmPortalPlayground.rovoChat.laptop.answerStep2Heading',
        defaultMessage: 'Step 2: Install core workplace apps'
    },
    laptopAnswerStep2Bullet1: {
        id: 'JsmPortalPlayground.rovoChat.laptop.answerStep2Bullet1',
        defaultMessage: 'Open Company Portal to download Slack and Zoom'
    },
    laptopAnswerStep2Bullet2: {
        id: 'JsmPortalPlayground.rovoChat.laptop.answerStep2Bullet2',
        defaultMessage: "Sign in to Slack using your team's workspace domain"
    },
    laptopAnswerStep3Heading: {
        id: 'JsmPortalPlayground.rovoChat.laptop.answerStep3Heading',
        defaultMessage: 'Step 3: Enable device compliance'
    },
    laptopAnswerStep3Bullet1: {
        id: 'JsmPortalPlayground.rovoChat.laptop.answerStep3Bullet1',
        defaultMessage: 'Confirm disk encryption (FileVault / BitLocker) is active'
    },
    laptopAnswerOutro: {
        id: 'JsmPortalPlayground.rovoChat.laptop.answerOutro',
        defaultMessage: "You're now ready to collaborate with your team."
    },
    sources: {
        id: 'JsmPortalPlayground.rovoChat.sources',
        defaultMessage: '2 Sources'
    },
    goodAnswer: {
        id: 'JsmPortalPlayground.rovoChat.goodAnswer',
        defaultMessage: 'Good answer'
    },
    badAnswer: {
        id: 'JsmPortalPlayground.rovoChat.badAnswer',
        defaultMessage: 'Bad answer'
    },
    giveFeedback: {
        id: 'JsmPortalPlayground.rovoChat.giveFeedback',
        defaultMessage: 'Give feedback'
    },
    askFollowUp: {
        id: 'JsmPortalPlayground.rovoChat.askFollowUp',
        defaultMessage: 'Ask a follow-up'
    },
    addContext: {
        id: 'JsmPortalPlayground.rovoChat.addContext',
        defaultMessage: 'Add context'
    },
    moreApps: {
        id: 'JsmPortalPlayground.rovoChat.moreApps',
        defaultMessage: '+5'
    },
    agentPicker: {
        id: 'JsmPortalPlayground.rovoChat.agentPicker',
        defaultMessage: 'Auto'
    },
    dictate: {
        id: 'JsmPortalPlayground.rovoChat.dictate',
        defaultMessage: 'Dictate'
    },
    disclosure: {
        id: 'JsmPortalPlayground.rovoChat.disclosure',
        defaultMessage: 'Uses AI. Verify results.'
    }
});

});




parcelRegister("4O4rl", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundCursor", function () { return $5012cc110be3c0f1$export$18dede948c9e4eba; });
/* jsm-playground-cursor.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/prop-types */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $5012cc110be3c0f1$var$getCursorId = (dataCustomCursor, label)=>{
    if (dataCustomCursor) return dataCustomCursor;
    return typeof label === 'string' ? label.toLowerCase() : 'custom';
};
const $5012cc110be3c0f1$export$18dede948c9e4eba = /*#__PURE__*/ (0, $1oC0p.forwardRef)((props, ref)=>{
    const { label: label = 'You', color: color = 'yellow', isActive: isActive = false, isClicking: isClicking = false, isHovering: isHovering = false, style: style, dataCustomCursor: dataCustomCursor } = props;
    const isBlue = color === 'blue';
    const cursorId = $5012cc110be3c0f1$var$getCursorId(dataCustomCursor, label);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        "aria-hidden": "true",
        "data-custom-cursor": cursorId,
        "data-cursor-color": color,
        "data-cursor-active": String(isActive),
        "data-cursor-hovering": String(isHovering),
        "data-cursor-clicking": String(isClicking),
        style: style,
        className: (0, $2jatx.default)([
            "_kqswstnw _152tidpf _1e02idpf _1pbyqfx8 _1bsbidpf _4t3iidpf _tzy4idpf _lcxvglyw _m6k41e03 _t9ec11dw _v5641ux8 _v12nglyw",
            isActive && "_tzy4kb7n"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1bsbidpf _4t3iidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    width: "24",
                    height: "48",
                    viewBox: "0 0 23 23",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": "true",
                    className: (0, $2jatx.default)([
                        "_kqswstnw _152t1h22 _1e02idpf _1bsb1tcg _4t3ickbl _t9ec1h7a _8hrz1nty _syaz1kmu _v56414dd",
                        isBlue && "_syaz1856",
                        isHovering && "_t9ec19xa _kdamysas",
                        isClicking && "_t9ectew9 _kdamglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M7.73535 22.6201L0.000042 0.000059L22.5846 7.77092L12.6866 12.7218L7.73535 22.6201Z",
                        fill: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _152tdlk8 _1e02qslr _1e0c116y _4cvr1h6o _1bah1h6o _1rjc1b66 _18zrutpp _2rko1rr0 _bfhk1kmu _syazi7uo _11c81af2 _k48p1pd9 _o5721q9c _16qs130s _v5641yyy",
                        isBlue && "_bfhk1856 _syaz15cr",
                        isHovering && "_t9ec1ura",
                        isClicking && "_t9ec81wu"
                    ]),
                    children: label
                })
            ]
        })
    });
});
$5012cc110be3c0f1$export$18dede948c9e4eba.displayName = 'JsmPlaygroundCursor';
var $5012cc110be3c0f1$export$2e2bcd8739ae039 = $5012cc110be3c0f1$export$18dede948c9e4eba;
const $5012cc110be3c0f1$var$customCursorStyles = null;
const $5012cc110be3c0f1$var$customCursorVisibleStyles = null;
const $5012cc110be3c0f1$var$cursorBodyStyles = null;
const $5012cc110be3c0f1$var$customCursorLabelStyles = null;
const $5012cc110be3c0f1$var$labelBlueStyles = null;
const $5012cc110be3c0f1$var$labelHoveringStyles = null;
const $5012cc110be3c0f1$var$labelClickingStyles = null;
const $5012cc110be3c0f1$var$customCursorPointerStyles = null;
const $5012cc110be3c0f1$var$pointerBlueStyles = null;
const $5012cc110be3c0f1$var$pointerHoveringStyles = null;
const $5012cc110be3c0f1$var$pointerClickingStyles = null;

});

parcelRegister("hCJtS", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundSeeHowItWorks", function () { return $5dd112751102e3dd$export$1147d17e6b0dfc89; });
/* jsm-playground-see-how-it-works.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $c0yqw = parcelRequire("c0yqw");
const $5dd112751102e3dd$var$CLIPPING_OVERFLOW = [
    'auto',
    'clip',
    'hidden',
    'scroll'
];
const $5dd112751102e3dd$var$isGuideCutOff = (wrapper)=>{
    const bounds = {
        left: 0,
        right: document.documentElement.clientWidth,
        top: -Infinity,
        bottom: Infinity
    };
    for(let ancestor = wrapper.parentElement; ancestor; ancestor = ancestor.parentElement){
        const { overflowX: overflowX, overflowY: overflowY } = window.getComputedStyle(ancestor);
        const clipsX = $5dd112751102e3dd$var$CLIPPING_OVERFLOW.includes(overflowX);
        const clipsY = $5dd112751102e3dd$var$CLIPPING_OVERFLOW.includes(overflowY);
        if (!clipsX && !clipsY) continue;
        const rect = ancestor.getBoundingClientRect();
        if (clipsX) {
            bounds.left = Math.max(bounds.left, rect.left);
            bounds.right = Math.min(bounds.right, rect.right);
        }
        if (clipsY) {
            bounds.top = Math.max(bounds.top, rect.top);
            bounds.bottom = Math.min(bounds.bottom, rect.bottom);
        }
    }
    return Array.from(wrapper.querySelectorAll('svg, span')).some((part)=>{
        const rect = part.getBoundingClientRect();
        return rect.left < bounds.left || rect.right > bounds.right || rect.top < bounds.top || rect.bottom > bounds.bottom;
    });
};
const $5dd112751102e3dd$export$1147d17e6b0dfc89 = ()=>{
    const intl = (0, $8e22h.default)();
    const wrapperRef = (0, $1oC0p.useRef)(null);
    const measuredScaleRef = (0, $1oC0p.useRef)();
    const [fit, setFit] = (0, $1oC0p.useState)('measuring');
    const measure = (0, $1oC0p.useCallback)(()=>{
        const wrapper = wrapperRef.current;
        if (wrapper) setFit($5dd112751102e3dd$var$isGuideCutOff(wrapper) ? 'cut-off' : 'fits');
    }, []);
    (0, $1oC0p.useLayoutEffect)(()=>{
        const scale = wrapperRef.current?.closest('[data-preview-scale]')?.getAttribute('data-preview-scale') ?? null;
        if (scale !== measuredScaleRef.current) {
            measuredScaleRef.current = scale;
            measure();
        }
    });
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener('resize', measure);
        return ()=>window.removeEventListener('resize', measure);
    }, [
        measure
    ]);
    const isHidden = fit !== 'fits';
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: wrapperRef,
        "data-testid": "jsm-playground-see-how-it-works",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_kqswstnw _152tidpf _rjxpys9h _1pbyzo7u _t9ec1q5z _lcxvglyw _1mjbglyw",
            isHidden && "_3um015vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1y6m _zulp1b66 _1q51pxbi _syazi7uo"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                    width: "60",
                    height: "80",
                    viewBox: "0 0 60 80",
                    fill: "none",
                    className: (0, $2jatx.default)([
                        "_1o9zidpf _t9ec12z1 _y44v1fxj _1bumglyw",
                        isHidden && "_y44vglyw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M48 6 C44 6, 28 10, 18 26 C10 40, 10 62, 12 74",
                            stroke: "currentColor",
                            strokeWidth: "1.8",
                            strokeLinecap: "round"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M6 68 L12 74 L18 70",
                            stroke: "currentColor",
                            strokeWidth: "1.8",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect41fjl _1wybdlk8 _k48pwu06 _vwz4gktf _p12fys9h",
                        "_t9ecpfzq _y44v15bk _1bumglyw",
                        isHidden && "_y44vglyw"
                    ]),
                    children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).seeHowItWorks)
                })
            ]
        })
    });
};
const $5dd112751102e3dd$var$guideWrapperStyles = null;
const $5dd112751102e3dd$var$hiddenStyles = null;
const $5dd112751102e3dd$var$staticStyles = null;
const $5dd112751102e3dd$var$guideStyles = null;
const $5dd112751102e3dd$var$arrowIn = null;
const $5dd112751102e3dd$var$textIn = null;
const $5dd112751102e3dd$var$guideArrowStyles = null;
const $5dd112751102e3dd$var$guideTextStyles = null;
const $5dd112751102e3dd$var$guideTextMotionStyles = null;

});

parcelRegister("5QlcL", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundStaticScreen", function () { return $e39b5b33698b1fb4$export$7f540efafbaf28c0; });
/* jsm-playground-static-screen.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bSVv5 = parcelRequire("bSVv5");

var $cTci5 = parcelRequire("cTci5");

var $a9bUP = parcelRequire("a9bUP");
const $e39b5b33698b1fb4$var$staticScreenUrls = {
    'it-support': 'https://dam-cdn.atl.orangelogic.com/AssetLink/x0s66n055p312i8y4w0153a4tb2yc22t.png',
    'it-operations': 'https://dam-cdn.atl.orangelogic.com/AssetLink/jh44qvmk0s53hwx82c3n7sts30kvs8yt.png',
    engineering: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b0ojm3mywvr6326u13mg87fgrt8g2d74.png',
    hr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gvtrqkjkytb1ed5w27xftktdqcol5qvc.png'
};
const $e39b5b33698b1fb4$export$7f540efafbaf28c0 = ({ team: team })=>{
    const intl = (0, $8e22h.default)();
    const teamTab = (0, $cTci5.teamTabs).find(({ value: value })=>value === team);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": `jsm-playground-static-screen-${team}`,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _4t3i1osq _2rkopb1k _1reo15vq _18m915vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9bUP.JsmPlaygroundNavigation), {
                config: (0, $cTci5.teamNavigationConfig)[team],
                teamName: teamTab ? intl.formatMessage(teamTab.label) : ''
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: $e39b5b33698b1fb4$var$staticScreenUrls[team],
                alt: "",
                className: (0, $2jatx.default)([
                    "_1e0c1ule _16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1osq _1tkeidpf _5ral1dfr _rsufn17g"
                ])
            })
        ]
    });
};
const $e39b5b33698b1fb4$var$staticScreenStyles = null;
const $e39b5b33698b1fb4$var$screenImageStyles = null;

});

parcelRegister("drhc4", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundTeamTab", function () { return $36fa4c128e8a5acf$export$9b540809ab4e78b; });
/* jsm-playground-team-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");
// A copy of the wac-refresh `Tab` for the playground's team tabs. The shared Tab
// links to `#<tabId>`; the playground keeps the selected team in `team_type`
// instead, so these tabs link there and never put a hash in the URL.
const $36fa4c128e8a5acf$var$listItemStyles = null;
const $36fa4c128e8a5acf$var$tabLinkStyles = null;
const $36fa4c128e8a5acf$var$inactiveTabStyles = null;
const $36fa4c128e8a5acf$var$darkThemeInactiveTabStyles = null;
const $36fa4c128e8a5acf$var$activeTabStyles = null;
const $36fa4c128e8a5acf$var$darkThemeActiveTabStyles = null;
const $36fa4c128e8a5acf$var$initialActiveTabStyles = null;
const $36fa4c128e8a5acf$var$darkThemeInitialActiveTabStyles = null;
const $36fa4c128e8a5acf$export$9b540809ab4e78b = ({ tabId: tabId, href: href, index: index, title: title, isActive: isActive, onTabSelect: onTabSelect })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const tabRef = (0, $1oC0p.useRef)(null);
    const [isInitialRender, setIsInitialRender] = (0, $1oC0p.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $1oC0p.useEffect)(()=>{
        // TabList queues its initial highlight measurement in a layout effect.
        // Keep the SSR background until this frame, which runs after that measurement.
        const frame = requestAnimationFrame(()=>setIsInitialRender(false));
        return ()=>cancelAnimationFrame(frame);
    }, []);
    const handleClick = (0, $1oC0p.useCallback)((e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'tab',
            actionSubjectId: 'wacRefreshTab',
            source: 'tabsMenu',
            attributes: {
                label: title,
                tabId: tabId,
                tabIndex: index
            }
        }).fire();
        onTabSelect(tabId);
    }, [
        onTabSelect,
        tabId,
        title,
        index,
        createAnalyticsEvent
    ]);
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onTabSelect(tabId);
            return;
        }
        const currentTab = tabRef.current;
        const tabList = currentTab?.closest('[role="tablist"]');
        if (!tabList || !currentTab) return;
        const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        const currentIndex = tabs.indexOf(currentTab);
        if (currentIndex === -1) return;
        let nextIndex = null;
        switch(e.key){
            case 'ArrowRight':
                nextIndex = (currentIndex + 1) % tabs.length;
                break;
            case 'ArrowLeft':
                nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                break;
            case 'Home':
                nextIndex = 0;
                break;
            case 'End':
                nextIndex = tabs.length - 1;
                break;
            default:
                return;
        }
        e.preventDefault();
        tabs[nextIndex]?.click();
    }, [
        onTabSelect,
        tabId
    ]);
    // Track previous active state to only focus on changes, not initial mount
    const wasActive = (0, $1oC0p.useRef)(isActive);
    (0, $1oC0p.useEffect)(()=>{
        if (isActive && !wasActive.current && tabRef.current) tabRef.current.focus();
        wasActive.current = isActive;
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        "data-tab-id": tabId,
        role: "presentation",
        className: (0, $2jatx.default)([
            "_kqswh2mm _1pbykb7n _1hu1v2br _1e0c1txw _qtt8glyw _80omtlke"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            ref: tabRef,
            href: href,
            role: "tab",
            id: `tab-${tabId}`,
            "aria-controls": tabId,
            "aria-selected": isActive,
            tabIndex: isActive ? 0 : -1,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            // Disable the browser's built-in link-drag behavior. Without
            // this, mousedown + small movement on the anchor fires
            // `dragstart` instead of `click`, silently swallowing the
            // tab selection.
            draggable: false,
            onDragStart: (e)=>e.preventDefault(),
            "data-event-container": "tab",
            "data-event-id": tabId,
            "data-event-label": title,
            className: (0, $2jatx.default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o _1rjcu2gc _18zrv47k _o5721q9c _2rko1mv1 _4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke _v564cpn1 _12ji1r31 _1qu2glyw _12y31o36 _uiztglyw _1mymglyw _sedtglyw _1wyb7vkz _vwz41tcg _k48pbfng _owpu1f4h _fz89f6fq _1ol91ou6 _ecdxxy5q",
                isActive ? isDarkTheme ? "_syaz1pfd _9h8h1pfd _10531pfd _1j301afi _1ygb6lb8 _1ah3myb0" : "_syaz1afi _9h8h1afi _10531afi _1j301pfd _1ygb14ak _1ah3myb0" : isDarkTheme ? "_syaz1afi _1j307ga5 _1ygb14ak _1ah312gs _o7ksglyw _30l31afi _9h8h1afi _10531afi" : "_syaz1pfd _1j30dkka _1ygb6lb8 _1ah312gs _o7ksglyw _30l31pfd _9h8h1pfd _10531pfd",
                isActive && isInitialRender && !isDarkTheme && "_1jb31pfd",
                isActive && isInitialRender && isDarkTheme && "_1jb31afi"
            ]),
            style: {
                "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400')),
                "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
            },
            children: title
        })
    });
};

});

parcelRegister("24d04", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundEngineering", function () { return $d61fd6bc995e2568$export$8af436df7c6b2568; });
/* jsm-playground-engineering.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2r6UE = parcelRequire("2r6UE");

var $lFTUI = parcelRequire("lFTUI");

var $hrBjL = parcelRequire("hrBjL");

var $cNOwN = parcelRequire("cNOwN");

var $8DlQO = parcelRequire("8DlQO");

var $bBczw = parcelRequire("bBczw");

var $8gAsH = parcelRequire("8gAsH");

var $c0yqw = parcelRequire("c0yqw");

var $7575j = parcelRequire("7575j");

var $8wA3w = parcelRequire("8wA3w");

var $a6eKS = parcelRequire("a6eKS");

var $bGB9J = parcelRequire("bGB9J");

var $dXWnS = parcelRequire("dXWnS");

var $gzbU7 = parcelRequire("gzbU7");

var $3Bh8Q = parcelRequire("3Bh8Q");

var $4Bdsv = parcelRequire("4Bdsv");
const $d61fd6bc995e2568$var$shouldShowEngineeringSkip = (demoState, isAnimationComplete, prefersReducedMotion)=>demoState === 'autoplay' && !isAnimationComplete && !prefersReducedMotion;
const $d61fd6bc995e2568$var$isEngineeringDemoSettled = (demoState, prefersReducedMotion)=>demoState !== 'autoplay' || prefersReducedMotion;
const $d61fd6bc995e2568$var$PANEL_TRANSITION_MS = 260;
const $d61fd6bc995e2568$var$BACKLOG_STATUS = (0, $a6eKS.ENGINEERING_WORKFLOW)[4];
const $d61fd6bc995e2568$var$DismissIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
        label: "",
        size: "medium"
    });
const $d61fd6bc995e2568$var$getSelectedRow = (index)=>index === null ? null : (0, $a6eKS.ENGINEERING_QUEUE_ROWS)[index] ?? null;
const $d61fd6bc995e2568$var$cursorIn = 600;
const $d61fd6bc995e2568$var$rowPress = $d61fd6bc995e2568$var$cursorIn + (0, $8wA3w.ADAM_CURSOR_TRAVEL_MS) + 500;
const $d61fd6bc995e2568$var$rowClicked = $d61fd6bc995e2568$var$rowPress + 150;
const $d61fd6bc995e2568$var$cursorOutAfterRow = $d61fd6bc995e2568$var$rowClicked + 400;
const $d61fd6bc995e2568$var$retargetStatus = $d61fd6bc995e2568$var$cursorOutAfterRow + $d61fd6bc995e2568$var$PANEL_TRANSITION_MS + 250;
const $d61fd6bc995e2568$var$statusCursorIn = $d61fd6bc995e2568$var$retargetStatus + 150;
const $d61fd6bc995e2568$var$statusPress = $d61fd6bc995e2568$var$statusCursorIn + (0, $8wA3w.ADAM_CURSOR_TRAVEL_MS) + 500;
const $d61fd6bc995e2568$var$menuOpen = $d61fd6bc995e2568$var$statusPress + 200;
const $d61fd6bc995e2568$var$cursorToBacklog = $d61fd6bc995e2568$var$menuOpen + 250;
const $d61fd6bc995e2568$var$backlogPress = $d61fd6bc995e2568$var$cursorToBacklog + (0, $8wA3w.ADAM_CURSOR_TRAVEL_MS);
const $d61fd6bc995e2568$var$statusChanged = $d61fd6bc995e2568$var$backlogPress + 200;
const $d61fd6bc995e2568$var$cursorOut = $d61fd6bc995e2568$var$statusChanged + 400;
const $d61fd6bc995e2568$var$flagInAt = $d61fd6bc995e2568$var$cursorOut + 200;
const $d61fd6bc995e2568$var$FLAG_ENTER_MS = 320;
const $d61fd6bc995e2568$export$cafc2318f74631bc = {
    cursorIn: $d61fd6bc995e2568$var$cursorIn,
    rowPress: $d61fd6bc995e2568$var$rowPress,
    rowClicked: $d61fd6bc995e2568$var$rowClicked,
    cursorOutAfterRow: $d61fd6bc995e2568$var$cursorOutAfterRow,
    retargetStatus: $d61fd6bc995e2568$var$retargetStatus,
    statusCursorIn: $d61fd6bc995e2568$var$statusCursorIn,
    statusPress: $d61fd6bc995e2568$var$statusPress,
    menuOpen: $d61fd6bc995e2568$var$menuOpen,
    cursorToBacklog: $d61fd6bc995e2568$var$cursorToBacklog,
    backlogPress: $d61fd6bc995e2568$var$backlogPress,
    statusChanged: $d61fd6bc995e2568$var$statusChanged,
    cursorOut: $d61fd6bc995e2568$var$cursorOut,
    flagIn: $d61fd6bc995e2568$var$flagInAt
};
const $d61fd6bc995e2568$var$JsmPlaygroundEngineeringComponent = ({ demoState: demoState = 'autoplay', hasUserTakenOver: hasUserTakenOver, onDemoComplete: onDemoComplete })=>{
    const intl = (0, $8e22h.default)();
    const prefersReducedMotion = (0, $bBczw.usePrefersReducedMotion)();
    const notifyDemoComplete = (0, $8DlQO.useNotifyDemoComplete)(onDemoComplete);
    const shouldStartComplete = demoState === 'complete' || prefersReducedMotion;
    const [selectedRowIndex, setSelectedRowIndex] = (0, $1oC0p.useState)(shouldStartComplete ? 0 : null);
    const [statusOverrides, setStatusOverrides] = (0, $1oC0p.useState)(shouldStartComplete ? {
        0: $d61fd6bc995e2568$var$BACKLOG_STATUS
    } : {});
    const [isStatusMenuOpen, setIsStatusMenuOpen] = (0, $1oC0p.useState)(false);
    const [isFlagVisible, setIsFlagVisible] = (0, $1oC0p.useState)(shouldStartComplete);
    const [isFlagInstant, setIsFlagInstant] = (0, $1oC0p.useState)(shouldStartComplete);
    const [isFlagDismissed, setIsFlagDismissed] = (0, $1oC0p.useState)(false);
    const [isAnimationComplete, setIsAnimationComplete] = (0, $1oC0p.useState)($d61fd6bc995e2568$var$isEngineeringDemoSettled(demoState, prefersReducedMotion));
    const [cursor, setCursor] = (0, $1oC0p.useState)({
        isPressed: false,
        isTransitionEnabled: false,
        isVisible: false,
        target: 'row'
    });
    const [cursorPoints, setCursorPoints] = (0, $1oC0p.useState)({});
    const containerRef = (0, $1oC0p.useRef)(null);
    const firstRowRef = (0, $1oC0p.useRef)(null);
    const tableRef = (0, $1oC0p.useRef)(null);
    const statusTriggerRef = (0, $1oC0p.useRef)(null);
    const backlogItemRef = (0, $1oC0p.useRef)(null);
    const [tableHeight, setTableHeight] = (0, $1oC0p.useState)();
    const takeoverRef = (0, $1oC0p.useRef)(hasUserTakenOver);
    takeoverRef.current = hasUserTakenOver;
    const shouldFocusCompletedDemo = (0, $1oC0p.useRef)(false);
    const { firePlaygroundScreenNavigated: firePlaygroundScreenNavigated } = (0, $7575j.useJsmPlaygroundAnalytics)('engineering');
    const setRowStatus = (0, $1oC0p.useCallback)((index, status)=>setStatusOverrides((current)=>({
                ...current,
                [index]: status
            })), []);
    const measureTarget = (0, $1oC0p.useCallback)((element, xOffset)=>{
        const container = containerRef.current;
        if (!container || !element) return undefined;
        const containerRect = container.getBoundingClientRect();
        const targetRect = element.getBoundingClientRect();
        const scale = containerRect.width / container.offsetWidth || 1;
        return {
            x: (targetRect.left - containerRect.left + xOffset) / scale,
            y: (targetRect.top - containerRect.top + targetRect.height / 2) / scale
        };
    }, []);
    (0, $1oC0p.useLayoutEffect)(()=>{
        const measureRow = ()=>{
            const point = measureTarget(firstRowRef.current, 140);
            if (point) setCursorPoints((current)=>({
                    ...current,
                    row: point
                }));
        };
        measureRow();
        const container = containerRef.current;
        if (!container || typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(measureRow);
        observer.observe(container);
        return ()=>observer.disconnect();
    }, [
        measureTarget
    ]);
    (0, $1oC0p.useLayoutEffect)(()=>{
        const table = tableRef.current;
        if (!table) return;
        const measure = ()=>{
            const height = table.offsetHeight;
            if (height) setTableHeight(height);
        };
        measure();
        if (typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(measure);
        observer.observe(table);
        return ()=>observer.disconnect();
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (!$d61fd6bc995e2568$var$shouldShowEngineeringSkip(demoState, isAnimationComplete, prefersReducedMotion)) return;
        const timers = [];
        const schedule = (delay, action)=>{
            timers.push(window.setTimeout(()=>{
                if (!takeoverRef.current) action();
            }, delay));
        };
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.cursorIn, ()=>setCursor({
                isPressed: false,
                isTransitionEnabled: true,
                isVisible: true,
                target: 'row'
            }));
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.rowPress, ()=>setCursor((current)=>({
                    ...current,
                    isPressed: true
                })));
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.rowClicked, ()=>{
            setSelectedRowIndex(0);
            setCursor((current)=>({
                    ...current,
                    isPressed: false
                }));
        });
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.cursorOutAfterRow, ()=>setCursor((current)=>({
                    ...current,
                    isVisible: false
                })));
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.retargetStatus, ()=>{
            const point = measureTarget(statusTriggerRef.current, 34);
            if (point) setCursorPoints((current)=>({
                    ...current,
                    status: point
                }));
            setCursor({
                isPressed: false,
                isTransitionEnabled: true,
                isVisible: false,
                target: 'status'
            });
        });
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.statusCursorIn, ()=>setCursor((current)=>({
                    ...current,
                    isVisible: true
                })));
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.statusPress, ()=>setCursor((current)=>({
                    ...current,
                    isPressed: true
                })));
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.menuOpen, ()=>{
            setIsStatusMenuOpen(true);
            setCursor((current)=>({
                    ...current,
                    isPressed: false
                }));
        });
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.cursorToBacklog, ()=>{
            const point = measureTarget(backlogItemRef.current, 24);
            if (point) setCursorPoints((current)=>({
                    ...current,
                    backlog: point
                }));
            setCursor((current)=>({
                    ...current,
                    target: 'backlog'
                }));
        });
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.backlogPress, ()=>setCursor((current)=>({
                    ...current,
                    isPressed: true
                })));
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.statusChanged, ()=>{
            setRowStatus(0, $d61fd6bc995e2568$var$BACKLOG_STATUS);
            setIsStatusMenuOpen(false);
            setCursor((current)=>({
                    ...current,
                    isPressed: false
                }));
        });
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.cursorOut, ()=>setCursor((current)=>({
                    ...current,
                    isVisible: false
                })));
        schedule($d61fd6bc995e2568$export$cafc2318f74631bc.flagIn, ()=>setIsFlagVisible(true));
        return ()=>timers.forEach(window.clearTimeout);
    }, [
        demoState,
        isAnimationComplete,
        measureTarget,
        prefersReducedMotion,
        setRowStatus
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!prefersReducedMotion || demoState !== 'autoplay') return;
        setSelectedRowIndex(0);
        setRowStatus(0, $d61fd6bc995e2568$var$BACKLOG_STATUS);
        setIsStatusMenuOpen(false);
        setIsFlagVisible(true);
        setCursor((current)=>({
                ...current,
                isVisible: false
            }));
    }, [
        demoState,
        prefersReducedMotion,
        setRowStatus
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (hasUserTakenOver) setCursor((current)=>({
                ...current,
                isVisible: false
            }));
    }, [
        hasUserTakenOver
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!$d61fd6bc995e2568$var$shouldShowEngineeringSkip(demoState, isAnimationComplete, prefersReducedMotion)) {
            if (shouldStartComplete) notifyDemoComplete();
            return;
        }
        const timer = window.setTimeout(()=>{
            if (!takeoverRef.current) {
                setIsAnimationComplete(true);
                notifyDemoComplete();
            }
        }, $d61fd6bc995e2568$export$cafc2318f74631bc.flagIn + $d61fd6bc995e2568$var$FLAG_ENTER_MS);
        return ()=>window.clearTimeout(timer);
    }, [
        demoState,
        isAnimationComplete,
        notifyDemoComplete,
        prefersReducedMotion,
        shouldStartComplete
    ]);
    const skipAnimation = ()=>{
        setSelectedRowIndex(0);
        setRowStatus(0, $d61fd6bc995e2568$var$BACKLOG_STATUS);
        setIsStatusMenuOpen(false);
        setIsFlagVisible(true);
        setIsFlagInstant(true);
        setCursor({
            isPressed: false,
            isTransitionEnabled: false,
            isVisible: false,
            target: 'row'
        });
        setIsAnimationComplete(true);
        shouldFocusCompletedDemo.current = true;
        notifyDemoComplete();
    };
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (!shouldFocusCompletedDemo.current) return;
        shouldFocusCompletedDemo.current = false;
        statusTriggerRef.current?.focus();
    }, [
        isAnimationComplete,
        selectedRowIndex
    ]);
    const selectStatus = (0, $1oC0p.useCallback)((status)=>{
        if (selectedRowIndex !== null) setRowStatus(selectedRowIndex, status);
        setIsStatusMenuOpen(false);
        if (status.id === $d61fd6bc995e2568$var$BACKLOG_STATUS.id) setIsFlagVisible(true);
    }, [
        selectedRowIndex,
        setRowStatus
    ]);
    const selectedRow = $d61fd6bc995e2568$var$getSelectedRow(selectedRowIndex);
    const activeCursorPoint = cursorPoints[cursor.target];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "jsm-playground-engineering",
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _4t3i1osq _1tkeidpf _2lx21bp4 _1reo15vq _18m915vq _bfhkvuon"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Bdsv.JsmPlaygroundEngineeringToolbar), {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1tkeidpf _4cvr1y6m _18zr1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gzbU7.JsmPlaygroundEngineeringQueue), {
                        firstRowRef: firstRowRef,
                        onOpenRow: (index)=>{
                            const nextIndex = selectedRowIndex === index ? null : index;
                            if (nextIndex !== null) firePlaygroundScreenNavigated({
                                team_type: 'engineering',
                                screen_id: `queue_detail_IT-${350 + nextIndex}`,
                                interaction_mode: 'manual_click'
                            });
                            else firePlaygroundScreenNavigated({
                                team_type: 'engineering',
                                screen_id: 'incoming_requests_queue',
                                interaction_mode: 'manual_click'
                            });
                            setSelectedRowIndex(nextIndex);
                        },
                        onStatusChange: setRowStatus,
                        selectedRowIndex: selectedRowIndex,
                        statusOverrides: statusOverrides,
                        tableRef: tableRef
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": selectedRowIndex === null,
                        className: (0, $2jatx.default)([
                            "_vchhusvi _1bsbidpf _1o9zidpf _1wpz1fhb _1tkeidpf _1reo15vq _18m915vq _tzy4idpf _bozgidpf _v5641hku _sedtglyw",
                            selectedRowIndex !== null && "_1bsb13xl _bozg1ejb _tzy4kb7n"
                        ]),
                        children: selectedRowIndex !== null && selectedRow && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGB9J.JsmPlaygroundEngineeringDetail), {
                            height: tableHeight,
                            issueKey: `IT-${350 + selectedRowIndex}`,
                            onClose: ()=>{
                                firePlaygroundScreenNavigated({
                                    team_type: 'engineering',
                                    screen_id: 'incoming_requests_queue',
                                    interaction_mode: 'manual_click'
                                });
                                setSelectedRowIndex(null);
                            },
                            row: {
                                ...selectedRow,
                                status: statusOverrides[selectedRowIndex] ?? selectedRow.status
                            },
                            showSlaLabel: selectedRowIndex < 3,
                            statusControl: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Bh8Q.EngineeringStatusDropdown), {
                                isOpen: isStatusMenuOpen,
                                onOpenChange: setIsStatusMenuOpen,
                                onSelect: selectStatus,
                                status: statusOverrides[selectedRowIndex] ?? selectedRow.status,
                                backlogItemRef: backlogItemRef,
                                triggerRef: statusTriggerRef
                            })
                        }, selectedRowIndex)
                    })
                ]
            }),
            demoState === 'autoplay' && !prefersReducedMotion && activeCursorPoint && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8wA3w.JsmPlaygroundAdamCursor), {
                hasUserTakenOver: hasUserTakenOver,
                isPressed: cursor.isPressed,
                isTransitionEnabled: cursor.isTransitionEnabled,
                isVisible: cursor.isVisible,
                x: activeCursorPoint.x,
                y: activeCursorPoint.y
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8gAsH.JsmPlaygroundSkipAnimationButton), {
                isVisible: $d61fd6bc995e2568$var$shouldShowEngineeringSkip(demoState, isAnimationComplete, prefersReducedMotion) && !hasUserTakenOver,
                label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).skipAnimation),
                onClick: skipAnimation
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($d61fd6bc995e2568$var$EngineeringBacklogFlag, {
                isDismissed: isFlagDismissed,
                isInstant: isFlagInstant,
                isVisible: isFlagVisible,
                onDismiss: ()=>setIsFlagDismissed(true)
            })
        ]
    });
};
const $d61fd6bc995e2568$export$8af436df7c6b2568 = /*#__PURE__*/ (0, $1oC0p.memo)($d61fd6bc995e2568$var$JsmPlaygroundEngineeringComponent);
const $d61fd6bc995e2568$var$pageStyles = null;
const $d61fd6bc995e2568$var$boldTextStyles = null;
const $d61fd6bc995e2568$var$contentStyles = null;
const $d61fd6bc995e2568$var$detailWrapperStyles = null;
const $d61fd6bc995e2568$var$detailWrapperOpenStyles = null;
const $d61fd6bc995e2568$var$flagIn = null;
const $d61fd6bc995e2568$var$flagStyles = null;
const $d61fd6bc995e2568$var$flagDismissStyles = null;
const $d61fd6bc995e2568$var$flagInstantStyles = null;
const $d61fd6bc995e2568$var$BoldChunk = (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
        className: (0, $2jatx.default)([
            "_k48pwu06"
        ]),
        children: chunks
    });
const $d61fd6bc995e2568$var$EngineeringBacklogFlag = ({ isDismissed: isDismissed, isInstant: isInstant, isVisible: isVisible, onDismiss: onDismiss })=>{
    const intl = (0, $8e22h.default)();
    if (!isVisible || isDismissed) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "engineering-backlog-success",
        className: (0, $2jatx.default)([
            "_kqswstnw _u7co1ejb _1e021ejb _1pbyvi1j _1bsb1kdj _1om0pb1k _j7hq19by _5sag8lt4 _1pgl1jxq _bl8aglyw",
            isInstant && "_j7hqglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lFTUI.default), {
                appearance: "normal",
                actions: [
                    {
                        content: intl.formatMessage((0, $dXWnS.engineeringMessages).viewWorkItem),
                        onClick: ()=>{}
                    }
                ],
                description: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    ...(0, $dXWnS.engineeringMessages).moveSucceededDescription,
                    values: {
                        strong: $d61fd6bc995e2568$var$BoldChunk
                    }
                }),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))), {
                    color: "var(--ds-icon-success, #6A9A23)",
                    label: ""
                }),
                id: "engineering-backlog-success",
                title: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_k48pwu06"
                    ]),
                    children: intl.formatMessage((0, $dXWnS.engineeringMessages).moveSucceeded)
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tu2gc _rjxpu2gc"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                    appearance: "subtle",
                    icon: $d61fd6bc995e2568$var$DismissIcon,
                    label: intl.formatMessage((0, $dXWnS.engineeringMessages).dismiss),
                    onClick: onDismiss,
                    spacing: "compact"
                })
            })
        ]
    });
};

});
parcelRegister("8wA3w", function(module, exports) {
$parcel$export(module.exports, "ADAM_CURSOR_TRAVEL_MS", function () { return $9113a17f40d57f2a$export$4ea892fac769bc47; });
$parcel$export(module.exports, "JsmPlaygroundAdamCursor", function () { return $9113a17f40d57f2a$export$8adbfb5254a7eb5f; });
/* jsm-playground-adam-cursor.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $9113a17f40d57f2a$export$4ea892fac769bc47 = 1050;
const $9113a17f40d57f2a$export$8adbfb5254a7eb5f = ({ hasUserTakenOver: hasUserTakenOver, isPressed: isPressed, isTransitionEnabled: isTransitionEnabled, isVisible: isVisible, x: x, y: y })=>{
    const isShown = isVisible && !hasUserTakenOver;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "aria-hidden": "true",
        "data-testid": "jsm-playground-adam-cursor",
        style: {
            '--adam-cursor-opacity': isShown ? 1 : 0,
            '--adam-cursor-scale': isShown ? 1 : 0.92,
            '--adam-cursor-transition': isTransitionEnabled ? `transform ${$9113a17f40d57f2a$export$4ea892fac769bc47}ms cubic-bezier(0.33, 0, 0.2, 1)` : 'transform 0ms',
            '--adam-cursor-x': `${x}px`,
            '--adam-cursor-y': `${y}px`
        },
        className: (0, $2jatx.default)([
            "_kqswstnw _152tidpf _1e02idpf _1pby1fw0 _lcxvglyw _tzy41e9a _t9ec1jm9 _8hrz5d63 _v5641gh8 _sedtglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                fill: "none",
                height: "24",
                viewBox: "0 0 23 23",
                width: "24",
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _1e02idpf _syaz16e3 _kdam4pu6 _t9ec1h7a _8hrz5d63 _v5641o3v _sedtglyw",
                    isPressed && "_t9ec1np6"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M7.735 22.62 0 0l22.585 7.771-9.899 4.951-4.951 9.898Z",
                    fill: "currentColor",
                    stroke: "white",
                    strokeWidth: "1.5"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tutpp _1e021ejb _1e0c116y _4cvr1h6o _1bah1h6o _1rjcv77o _18zrutpp _2rko1rr0 _bfhk16e3 _syaz15cr _11c81af2 _o5721q9c _16qs130s"
                ]),
                children: "Adam"
            })
        ]
    });
};
const $9113a17f40d57f2a$var$cursorStyles = null;
const $9113a17f40d57f2a$var$cursorArrowStyles = null;
const $9113a17f40d57f2a$var$cursorArrowPressedStyles = null;
const $9113a17f40d57f2a$var$cursorLabelStyles = null;

});

parcelRegister("a6eKS", function(module, exports) {
$parcel$export(module.exports, "ENGINEERING_WORKFLOW", function () { return $9c892e7ca3c728f3$export$6b0381f3b41f65e1; });
$parcel$export(module.exports, "ENGINEERING_QUEUE_ROWS", function () { return $9c892e7ca3c728f3$export$b521ea2d566c8009; });
$parcel$export(module.exports, "ENGINEERING_REQUEST_TYPE_LABELS", function () { return $9c892e7ca3c728f3$export$cb5a2324588a72f9; });
$parcel$export(module.exports, "ENGINEERING_PRIORITY_LABELS", function () { return $9c892e7ca3c728f3$export$fd1b8be071bba8af; });

var $dXWnS = parcelRequire("dXWnS");
const $9c892e7ca3c728f3$export$6b0381f3b41f65e1 = [
    {
        id: 'toDo',
        label: (0, $dXWnS.engineeringMessages).statusToDo,
        tone: 'neutral'
    },
    {
        id: 'triaged',
        label: (0, $dXWnS.engineeringMessages).statusTriaged,
        tone: 'blue'
    },
    {
        id: 'inProgress',
        label: (0, $dXWnS.engineeringMessages).statusInProgress,
        tone: 'blue'
    },
    {
        id: 'pendingOnReporter',
        label: (0, $dXWnS.engineeringMessages).statusPendingOnReporter,
        tone: 'blue'
    },
    {
        id: 'addedToBacklog',
        label: (0, $dXWnS.engineeringMessages).addedToBacklog,
        tone: 'blue'
    },
    {
        id: 'completed',
        label: (0, $dXWnS.engineeringMessages).statusCompleted,
        tone: 'green'
    },
    {
        id: 'cancelled',
        label: (0, $dXWnS.engineeringMessages).statusCancelled,
        tone: 'neutral'
    }
];
const $9c892e7ca3c728f3$export$b521ea2d566c8009 = [
    {
        assignee: 'Issac Varghese',
        created: Date.UTC(2024, 5, 24),
        descriptionTail: (0, $dXWnS.engineeringMessages).descriptionTailMoreDetails,
        priority: 'Highest',
        reporter: 'Priya Hansra',
        requestType: 'bug',
        sla: (0, $dXWnS.engineeringMessages).slaToday1130Am,
        slaTone: 'breached',
        status: $9c892e7ca3c728f3$export$6b0381f3b41f65e1[2],
        summary: (0, $dXWnS.engineeringMessages).summarySaveButton
    },
    {
        assignee: 'Issac Varghese',
        created: Date.UTC(2024, 5, 24),
        descriptionTail: (0, $dXWnS.engineeringMessages).descriptionTailEndOfWeek,
        priority: 'Medium',
        reporter: 'Robi Lopez',
        requestType: 'feature',
        sla: (0, $dXWnS.engineeringMessages).slaToday1130Pm,
        slaTone: 'running',
        status: $9c892e7ca3c728f3$export$6b0381f3b41f65e1[4],
        summary: (0, $dXWnS.engineeringMessages).summaryExportCsv
    },
    {
        assignee: 'Jordan Ellis',
        created: Date.UTC(2024, 5, 3),
        descriptionTail: (0, $dXWnS.engineeringMessages).descriptionTailBlocking,
        priority: 'Highest',
        reporter: 'Raul Gonzalez',
        requestType: 'system',
        sla: (0, $dXWnS.engineeringMessages).slaToday1130Pm,
        slaTone: 'paused',
        status: $9c892e7ca3c728f3$export$6b0381f3b41f65e1[4],
        summary: (0, $dXWnS.engineeringMessages).summaryLoginTimeout
    },
    {
        assignee: 'Jordan Ellis',
        created: Date.UTC(2024, 5, 24),
        descriptionTail: (0, $dXWnS.engineeringMessages).descriptionTailEndOfWeek,
        priority: 'Lowest',
        reporter: 'Raul Gonzalez',
        requestType: 'feature',
        sla: (0, $dXWnS.engineeringMessages).sla25Jun1130Pm,
        slaTone: 'running',
        status: $9c892e7ca3c728f3$export$6b0381f3b41f65e1[2],
        summary: (0, $dXWnS.engineeringMessages).summaryDarkMode
    },
    {
        created: Date.UTC(2024, 5, 3),
        descriptionTail: (0, $dXWnS.engineeringMessages).descriptionTailBlocking,
        priority: 'Medium',
        reporter: 'Robi Lopez',
        requestType: 'support',
        sla: (0, $dXWnS.engineeringMessages).slaTomorrow500Pm,
        slaTone: 'running',
        status: $9c892e7ca3c728f3$export$6b0381f3b41f65e1[2],
        summary: (0, $dXWnS.engineeringMessages).summaryApiAuthError
    },
    {
        assignee: 'Laila Ali',
        created: Date.UTC(2024, 5, 11),
        descriptionTail: (0, $dXWnS.engineeringMessages).descriptionTailBlocking,
        priority: 'Medium',
        reporter: 'Raul Gonzalez',
        requestType: 'support',
        sla: (0, $dXWnS.engineeringMessages).slaTomorrow500Pm,
        slaTone: 'running',
        status: $9c892e7ca3c728f3$export$6b0381f3b41f65e1[2],
        summary: (0, $dXWnS.engineeringMessages).summaryConfigureSso
    },
    {
        assignee: 'Laila Ali',
        created: Date.UTC(2024, 5, 18),
        descriptionTail: (0, $dXWnS.engineeringMessages).descriptionTailBlocking,
        priority: 'Medium',
        reporter: 'Robi Lopez',
        requestType: 'support',
        sla: (0, $dXWnS.engineeringMessages).slaTomorrow1130Am,
        slaTone: 'running',
        status: $9c892e7ca3c728f3$export$6b0381f3b41f65e1[1],
        summary: (0, $dXWnS.engineeringMessages).summaryApiAuthError
    },
    {
        assignee: 'Kayla Parajuli',
        created: Date.UTC(2024, 5, 1),
        descriptionTail: (0, $dXWnS.engineeringMessages).descriptionTailEndOfWeek,
        priority: 'High',
        reporter: 'Robi Lopez',
        requestType: 'feature',
        sla: (0, $dXWnS.engineeringMessages).slaToday400Pm,
        slaTone: 'paused',
        status: $9c892e7ca3c728f3$export$6b0381f3b41f65e1[3],
        summary: (0, $dXWnS.engineeringMessages).summaryExportCsv
    },
    {
        created: Date.UTC(2024, 5, 11),
        descriptionTail: (0, $dXWnS.engineeringMessages).descriptionTailEndOfWeek,
        priority: 'Lowest',
        reporter: 'Priya Hansra',
        requestType: 'support',
        sla: (0, $dXWnS.engineeringMessages).slaToday1130Pm,
        slaTone: 'running',
        status: $9c892e7ca3c728f3$export$6b0381f3b41f65e1[0],
        summary: (0, $dXWnS.engineeringMessages).summaryCrmSync
    }
];
const $9c892e7ca3c728f3$export$cb5a2324588a72f9 = {
    bug: (0, $dXWnS.engineeringMessages).requestTypeBug,
    feature: (0, $dXWnS.engineeringMessages).requestTypeFeature,
    support: (0, $dXWnS.engineeringMessages).requestTypeSupport,
    system: (0, $dXWnS.engineeringMessages).requestTypeSystem
};
const $9c892e7ca3c728f3$export$fd1b8be071bba8af = {
    Highest: (0, $dXWnS.engineeringMessages).priorityHighest,
    High: (0, $dXWnS.engineeringMessages).priorityHigh,
    Medium: (0, $dXWnS.engineeringMessages).priorityMedium,
    Low: (0, $dXWnS.engineeringMessages).priorityLow,
    Lowest: (0, $dXWnS.engineeringMessages).priorityLowest
};

});
parcelRegister("dXWnS", function(module, exports) {
$parcel$export(module.exports, "engineeringMessages", function () { return $ef4ea112f0a008e8$export$ea5076892d1e0429; });

var $fnHPc = parcelRequire("fnHPc");
const $ef4ea112f0a008e8$export$ea5076892d1e0429 = (0, $fnHPc.defineMessages)({
    incomingRequests: {
        id: 'JsmPortalPlayground.engineering.incomingRequests',
        defaultMessage: 'Incoming requests'
    },
    list: {
        id: 'JsmPortalPlayground.engineering.list',
        defaultMessage: 'List'
    },
    addView: {
        id: 'JsmPortalPlayground.engineering.addView',
        defaultMessage: 'Add view'
    },
    calendar: {
        id: 'JsmPortalPlayground.engineering.calendar',
        defaultMessage: 'Calendar'
    },
    board: {
        id: 'JsmPortalPlayground.engineering.board',
        defaultMessage: 'Board'
    },
    searchWork: {
        id: 'JsmPortalPlayground.engineering.searchWork',
        defaultMessage: 'Search work'
    },
    requestType: {
        id: 'JsmPortalPlayground.engineering.requestType',
        defaultMessage: 'Request type'
    },
    status: {
        id: 'JsmPortalPlayground.engineering.status',
        defaultMessage: 'Status'
    },
    assignee: {
        id: 'JsmPortalPlayground.engineering.assignee',
        defaultMessage: 'Assignee'
    },
    triage: {
        id: 'JsmPortalPlayground.engineering.triage',
        defaultMessage: 'Triage'
    },
    moreActions: {
        id: 'JsmPortalPlayground.engineering.moreActions',
        defaultMessage: 'More actions'
    },
    selectAll: {
        id: 'JsmPortalPlayground.engineering.selectAll',
        defaultMessage: 'Select all requests'
    },
    type: {
        id: 'JsmPortalPlayground.engineering.type',
        defaultMessage: 'Type'
    },
    summary: {
        id: 'JsmPortalPlayground.engineering.summary',
        defaultMessage: 'Summary'
    },
    timeToResolution: {
        id: 'JsmPortalPlayground.engineering.timeToResolution',
        defaultMessage: 'Time to resolution'
    },
    priority: {
        id: 'JsmPortalPlayground.engineering.priority',
        defaultMessage: 'P'
    },
    detailsPriority: {
        id: 'JsmPortalPlayground.engineering.detailsPriority',
        defaultMessage: 'Priority'
    },
    created: {
        id: 'JsmPortalPlayground.engineering.created',
        defaultMessage: 'Created'
    },
    selectRequest: {
        id: 'JsmPortalPlayground.engineering.selectRequest',
        defaultMessage: 'Select {summary}'
    },
    openRequest: {
        id: 'JsmPortalPlayground.engineering.openRequest',
        defaultMessage: 'Open {summary}'
    },
    unassigned: {
        id: 'JsmPortalPlayground.engineering.unassigned',
        defaultMessage: 'Unassigned'
    },
    closeDetails: {
        id: 'JsmPortalPlayground.engineering.closeDetails',
        defaultMessage: 'Close details'
    },
    description: {
        id: 'JsmPortalPlayground.engineering.description',
        defaultMessage: 'Description'
    },
    collapseDescription: {
        id: 'JsmPortalPlayground.engineering.collapseDescription',
        defaultMessage: 'Collapse description'
    },
    expandDescription: {
        id: 'JsmPortalPlayground.engineering.expandDescription',
        defaultMessage: 'Expand description'
    },
    reporterLine: {
        id: 'JsmPortalPlayground.engineering.reporterLine',
        defaultMessage: '<strong>{reporter}</strong> raised this request via <link>Portal</link>'
    },
    descriptionBody: {
        id: 'JsmPortalPlayground.engineering.descriptionBody',
        defaultMessage: '{summary}. {tail}'
    },
    affectedArea: {
        id: 'JsmPortalPlayground.engineering.affectedArea',
        defaultMessage: 'Affected area'
    },
    settings: {
        id: 'JsmPortalPlayground.engineering.settings',
        defaultMessage: 'Settings'
    },
    affectedService: {
        id: 'JsmPortalPlayground.engineering.affectedService',
        defaultMessage: 'Affected service'
    },
    checkoutApi: {
        id: 'JsmPortalPlayground.engineering.checkoutApi',
        defaultMessage: 'Checkout API'
    },
    slas: {
        id: 'JsmPortalPlayground.engineering.slas',
        defaultMessage: 'SLAs'
    },
    details: {
        id: 'JsmPortalPlayground.engineering.details',
        defaultMessage: 'Details'
    },
    firstResponse: {
        id: 'JsmPortalPlayground.engineering.firstResponse',
        defaultMessage: 'First response'
    },
    met: {
        id: 'JsmPortalPlayground.engineering.met',
        defaultMessage: 'Met'
    },
    resolution: {
        id: 'JsmPortalPlayground.engineering.resolution',
        defaultMessage: 'Resolution'
    },
    activity: {
        id: 'JsmPortalPlayground.engineering.activity',
        defaultMessage: 'Activity'
    },
    addInternalNote: {
        id: 'JsmPortalPlayground.engineering.addInternalNote',
        defaultMessage: 'Add internal note'
    },
    replyToCustomer: {
        id: 'JsmPortalPlayground.engineering.replyToCustomer',
        defaultMessage: 'Reply to customer'
    },
    assignedRequest: {
        id: 'JsmPortalPlayground.engineering.assignedRequest',
        defaultMessage: 'assigned the request to {assignee}'
    },
    addedToTriage: {
        id: 'JsmPortalPlayground.engineering.addedToTriage',
        defaultMessage: 'added the request to the triage queue'
    },
    raisedRequest: {
        id: 'JsmPortalPlayground.engineering.raisedRequest',
        defaultMessage: 'raised this request'
    },
    yesterdayAt: {
        id: 'JsmPortalPlayground.engineering.yesterdayAt',
        defaultMessage: 'Yesterday at {time}'
    },
    addedToBacklog: {
        id: 'JsmPortalPlayground.engineering.addedToBacklog',
        defaultMessage: 'Added to backlog'
    },
    moveSucceeded: {
        id: 'JsmPortalPlayground.engineering.moveSucceeded',
        defaultMessage: 'Work item successfully added to backlog'
    },
    moveSucceededDescription: {
        id: 'JsmPortalPlayground.engineering.moveSucceededDescription',
        defaultMessage: 'This work item has been added to the <strong>Kanban backlog</strong> in Jira Software'
    },
    viewWorkItem: {
        id: 'JsmPortalPlayground.engineering.viewWorkItem',
        defaultMessage: 'View work item'
    },
    dismiss: {
        id: 'JsmPortalPlayground.engineering.dismiss',
        defaultMessage: 'Dismiss'
    },
    requestDetailsLabel: {
        id: 'JsmPortalPlayground.engineering.requestDetailsLabel',
        defaultMessage: '{key} details'
    },
    statusToDo: {
        id: 'JsmPortalPlayground.engineering.statusToDo',
        defaultMessage: 'To do'
    },
    statusTriaged: {
        id: 'JsmPortalPlayground.engineering.statusTriaged',
        defaultMessage: 'Triaged'
    },
    statusInProgress: {
        id: 'JsmPortalPlayground.engineering.statusInProgress',
        defaultMessage: 'In progress'
    },
    statusPendingOnReporter: {
        id: 'JsmPortalPlayground.engineering.statusPendingOnReporter',
        defaultMessage: 'Pending on reporter'
    },
    statusCompleted: {
        id: 'JsmPortalPlayground.engineering.statusCompleted',
        defaultMessage: 'Completed'
    },
    statusCancelled: {
        id: 'JsmPortalPlayground.engineering.statusCancelled',
        defaultMessage: 'Cancelled'
    },
    requestTypeBug: {
        id: 'JsmPortalPlayground.engineering.requestTypeBug',
        defaultMessage: 'Report a bug'
    },
    requestTypeFeature: {
        id: 'JsmPortalPlayground.engineering.requestTypeFeature',
        defaultMessage: 'Suggest a new feature'
    },
    requestTypeSupport: {
        id: 'JsmPortalPlayground.engineering.requestTypeSupport',
        defaultMessage: 'Technical support'
    },
    requestTypeSystem: {
        id: 'JsmPortalPlayground.engineering.requestTypeSystem',
        defaultMessage: 'Report a system problem'
    },
    priorityHighest: {
        id: 'JsmPortalPlayground.engineering.priorityHighest',
        defaultMessage: 'Highest'
    },
    priorityHigh: {
        id: 'JsmPortalPlayground.engineering.priorityHigh',
        defaultMessage: 'High'
    },
    priorityMedium: {
        id: 'JsmPortalPlayground.engineering.priorityMedium',
        defaultMessage: 'Medium'
    },
    priorityLow: {
        id: 'JsmPortalPlayground.engineering.priorityLow',
        defaultMessage: 'Low'
    },
    priorityLowest: {
        id: 'JsmPortalPlayground.engineering.priorityLowest',
        defaultMessage: 'Lowest'
    },
    priorityIconLabel: {
        id: 'JsmPortalPlayground.engineering.priorityIconLabel',
        defaultMessage: '{priority} priority',
        description: 'Accessible name for a priority icon. {priority} is a priority level, e.g. High.'
    },
    summarySaveButton: {
        id: 'JsmPortalPlayground.engineering.summarySaveButton',
        defaultMessage: 'Save button does nothing on the settings page'
    },
    summaryExportCsv: {
        id: 'JsmPortalPlayground.engineering.summaryExportCsv',
        defaultMessage: 'Allow exporting the queue to CSV'
    },
    summaryLoginTimeout: {
        id: 'JsmPortalPlayground.engineering.summaryLoginTimeout',
        defaultMessage: 'Login page is timing out for multiple users'
    },
    summaryDarkMode: {
        id: 'JsmPortalPlayground.engineering.summaryDarkMode',
        defaultMessage: 'Add a dark mode option to the reporting view'
    },
    summaryApiAuthError: {
        id: 'JsmPortalPlayground.engineering.summaryApiAuthError',
        defaultMessage: 'API returns an auth error after the latest release'
    },
    summaryConfigureSso: {
        id: 'JsmPortalPlayground.engineering.summaryConfigureSso',
        defaultMessage: 'Need help configuring SSO for the new workspace'
    },
    summaryCrmSync: {
        id: 'JsmPortalPlayground.engineering.summaryCrmSync',
        defaultMessage: 'Integration with the CRM stopped syncing overnight'
    },
    descriptionTailMoreDetails: {
        id: 'JsmPortalPlayground.engineering.descriptionTailMoreDetails',
        defaultMessage: 'Happy to provide more details if required.'
    },
    descriptionTailEndOfWeek: {
        id: 'JsmPortalPlayground.engineering.descriptionTailEndOfWeek',
        defaultMessage: 'I need this sorted before the end of the week.'
    },
    descriptionTailBlocking: {
        id: 'JsmPortalPlayground.engineering.descriptionTailBlocking',
        defaultMessage: 'This is blocking me from getting my work done today.'
    },
    slaToday1130Am: {
        id: 'JsmPortalPlayground.engineering.slaToday1130Am',
        defaultMessage: 'Today, 11:30 am'
    },
    slaToday400Pm: {
        id: 'JsmPortalPlayground.engineering.slaToday400Pm',
        defaultMessage: 'Today, 4:00 pm'
    },
    slaToday1130Pm: {
        id: 'JsmPortalPlayground.engineering.slaToday1130Pm',
        defaultMessage: 'Today, 11:30 pm'
    },
    slaTomorrow1130Am: {
        id: 'JsmPortalPlayground.engineering.slaTomorrow1130Am',
        defaultMessage: 'Tomorrow, 11:30 am'
    },
    slaTomorrow500Pm: {
        id: 'JsmPortalPlayground.engineering.slaTomorrow500Pm',
        defaultMessage: 'Tomorrow, 5:00 pm'
    },
    sla25Jun1130Pm: {
        id: 'JsmPortalPlayground.engineering.sla25Jun1130Pm',
        defaultMessage: '25 Jun, 11:30 pm'
    }
});

});


parcelRegister("bGB9J", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundEngineeringDetail", function () { return $49a262cbf68ddb31$export$e49ab55e85e76963; });
/* jsm-playground-engineering-detail.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $fiTNr = parcelRequire("fiTNr");

var $2r6UE = parcelRequire("2r6UE");

var $hrBjL = parcelRequire("hrBjL");

var $l5ucJ = parcelRequire("l5ucJ");

var $k3Xeq = parcelRequire("k3Xeq");

var $cNOwN = parcelRequire("cNOwN");

var $hG8Ki = parcelRequire("hG8Ki");

var $8ktfY = parcelRequire("8ktfY");

var $fK1fu = parcelRequire("fK1fu");

var $a6eKS = parcelRequire("a6eKS");

var $b7CRq = parcelRequire("b7CRq");

var $dXWnS = parcelRequire("dXWnS");
const $49a262cbf68ddb31$var$CloseIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
        label: "",
        size: "medium"
    });
const $49a262cbf68ddb31$var$CollapseIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k3Xeq))), {
        label: "",
        size: "medium"
    });
const $49a262cbf68ddb31$var$ExpandIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5ucJ))), {
        label: "",
        size: "medium"
    });
// Keep the demo's wall-clock times consistent between server and browser rendering.
const $49a262cbf68ddb31$var$activityTimeFormat = {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'UTC'
};
const $49a262cbf68ddb31$var$DetailPanel = ({ height: height, issueKey: issueKey, onClose: onClose, row: row, showSlaLabel: showSlaLabel, statusControl: statusControl })=>{
    const intl = (0, $8e22h.default)();
    const [isDescriptionExpanded, setIsDescriptionExpanded] = (0, $1oC0p.useState)(true);
    const summary = intl.formatMessage(row.summary);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "aria-label": intl.formatMessage((0, $dXWnS.engineeringMessages).requestDetailsLabel, {
            key: issueKey
        }),
        "data-testid": "engineering-request-detail",
        role: "group",
        style: height ? {
            height: `${height}px`
        } : undefined,
        className: (0, $2jatx.default)([
            "_vchhusvi _1bsbp59q _1o9zidpf _1wpz1y6m _1reo15vq _18m915vq _c71l1osq _1yt4pxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko1mok _bfhkhfxm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulppxbi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _zulpu2gc"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            className: (0, $2jatx.default)([
                                "_1e0c116y _4cvr1h6o _zulpu2gc _1o9zidpf _11c8fhey _k48p1wq8"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CRq.EngineeringRequestTypeIcon), {
                                    size: "medium",
                                    type: row.requestType
                                }),
                                issueKey
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1pbycs5v _1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _1bahesu3 _1wx91mok"
                            ]),
                            children: statusControl
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                            icon: $49a262cbf68ddb31$var$CloseIcon,
                            label: intl.formatMessage((0, $dXWnS.engineeringMessages).closeDetails),
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                    level: 2,
                    size: "large",
                    children: summary
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1yt4pxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _2rkopb1k _bfhkvuon"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _zulputpp"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fK1fu.EngineeringAvatar), {
                                    name: row.reporter
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _11c8fhey"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $dXWnS.engineeringMessages).reporterLine,
                                        values: {
                                            reporter: row.reporter,
                                            strong: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                    className: (0, $2jatx.default)([
                                                        "_k48p1wq8"
                                                    ]),
                                                    children: chunks
                                                }),
                                            link: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                    className: (0, $2jatx.default)([
                                                        "_syaz13af"
                                                    ]),
                                                    children: chunks
                                                })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                    appearance: "subtle",
                                    icon: isDescriptionExpanded ? $49a262cbf68ddb31$var$CollapseIcon : $49a262cbf68ddb31$var$ExpandIcon,
                                    label: intl.formatMessage(isDescriptionExpanded ? (0, $dXWnS.engineeringMessages).collapseDescription : (0, $dXWnS.engineeringMessages).expandDescription),
                                    onClick: ()=>setIsDescriptionExpanded((current)=>!current),
                                    spacing: "compact"
                                })
                            ]
                        }),
                        isDescriptionExpanded && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulpu2gc _11c8fhey"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                    className: (0, $2jatx.default)([
                                        "_syazazsu _k48pwu06"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $dXWnS.engineeringMessages).description
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $dXWnS.engineeringMessages).descriptionBody,
                                        values: {
                                            summary: summary,
                                            tail: intl.formatMessage(row.descriptionTail)
                                        }
                                    })
                                }),
                                row.requestType === 'system' && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulpu2gc _1q511b66"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            className: (0, $2jatx.default)([
                                                "_1bsb1obz _1o9zidpf _syazazsu _11c8fhey _k48p1wq8"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                ...(0, $dXWnS.engineeringMessages).affectedService
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hG8Ki.default), {
                                            text: intl.formatMessage((0, $dXWnS.engineeringMessages).checkoutApi)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)($49a262cbf68ddb31$var$CollapsibleCard, {
                    defaultExpanded: false,
                    title: intl.formatMessage((0, $dXWnS.engineeringMessages).slas),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($49a262cbf68ddb31$var$DetailRow, {
                            label: intl.formatMessage((0, $dXWnS.engineeringMessages).firstResponse),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulp12x7 _1ul9idpf _11c8fhey"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))), {
                                        color: "var(--ds-icon-success, #6A9A23)",
                                        label: "",
                                        size: "small"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $dXWnS.engineeringMessages).met
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($49a262cbf68ddb31$var$DetailRow, {
                            label: intl.formatMessage((0, $dXWnS.engineeringMessages).resolution),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CRq.EngineeringSlaTag), {
                                isLoading: !showSlaLabel,
                                row: row
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)($49a262cbf68ddb31$var$CollapsibleCard, {
                    title: intl.formatMessage((0, $dXWnS.engineeringMessages).details),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($49a262cbf68ddb31$var$DetailRow, {
                            label: intl.formatMessage((0, $dXWnS.engineeringMessages).assignee),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulp12x7 _1ul9idpf _11c8fhey"
                                ]),
                                children: [
                                    row.assignee ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fK1fu.EngineeringAvatar), {
                                        name: row.assignee
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fiTNr.default), {
                                        name: intl.formatMessage((0, $dXWnS.engineeringMessages).unassigned),
                                        size: "small"
                                    }),
                                    row.assignee ?? intl.formatMessage((0, $dXWnS.engineeringMessages).unassigned)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($49a262cbf68ddb31$var$DetailRow, {
                            label: intl.formatMessage((0, $dXWnS.engineeringMessages).requestType),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulp12x7 _1ul9idpf _11c8fhey"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CRq.EngineeringRequestTypeIcon), {
                                        size: "medium",
                                        type: row.requestType
                                    }),
                                    intl.formatMessage((0, $a6eKS.ENGINEERING_REQUEST_TYPE_LABELS)[row.requestType])
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($49a262cbf68ddb31$var$DetailRow, {
                            label: intl.formatMessage((0, $dXWnS.engineeringMessages).detailsPriority),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulp12x7 _1ul9idpf _11c8fhey"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CRq.EngineeringPriorityIcon), {
                                        priority: row.priority
                                    }),
                                    intl.formatMessage((0, $a6eKS.ENGINEERING_PRIORITY_LABELS)[row.priority])
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulputpp"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                            className: (0, $2jatx.default)([
                                "_11c81qyo"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $dXWnS.engineeringMessages).activity
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1bah1h6o _zulp1b66 _1rjcu2gc _18zr1b66 _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko1mok _bfhkvuon _11c8fhey _k48p1wq8"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $dXWnS.engineeringMessages).addInternalNote
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_syazazsu"
                                    ]),
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $dXWnS.engineeringMessages).replyToCustomer
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($49a262cbf68ddb31$var$ActivityItem, {
                            action: row.assignee ? intl.formatMessage((0, $dXWnS.engineeringMessages).assignedRequest, {
                                assignee: row.assignee
                            }) : intl.formatMessage((0, $dXWnS.engineeringMessages).addedToTriage),
                            actor: "Robi Lopez",
                            timestamp: intl.formatMessage((0, $dXWnS.engineeringMessages).yesterdayAt, {
                                time: intl.formatTime(Date.UTC(2024, 5, 23, 14, 42), $49a262cbf68ddb31$var$activityTimeFormat)
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($49a262cbf68ddb31$var$ActivityItem, {
                            action: intl.formatMessage((0, $dXWnS.engineeringMessages).raisedRequest),
                            actor: row.reporter,
                            timestamp: intl.formatMessage((0, $dXWnS.engineeringMessages).yesterdayAt, {
                                time: intl.formatTime(Date.UTC(2024, 5, 23, 14, 35), $49a262cbf68ddb31$var$activityTimeFormat)
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $49a262cbf68ddb31$var$DetailRow = ({ children: children, label: label })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc _1tkexy5q _1rjc1b66 _bozgpxbi _y4tiu2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1bsb1l8a _1o9zidpf _syazi7uo _11c8fhey _k48p1wq8"
                ]),
                children: label
            }),
            children
        ]
    });
const $49a262cbf68ddb31$var$ActivityItem = ({ action: action, actor: actor, timestamp: timestamp })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1y6m _zulpu2gc _1yt4u2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko1mok _bfhkvuon"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fK1fu.EngineeringAvatar), {
                name: actor
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1ul9idpf _2lx21bp4 _zulp1b66 _11c8fhey"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                className: (0, $2jatx.default)([
                                    "_k48pwu06"
                                ]),
                                children: actor
                            }),
                            " ",
                            action
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_syaz1rpy _11c8wadc"
                        ]),
                        children: timestamp
                    })
                ]
            })
        ]
    });
const $49a262cbf68ddb31$var$CollapsibleCard = ({ children: children, defaultExpanded: defaultExpanded = true, title: title })=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(defaultExpanded);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _2rkopb1k _bfhkvuon"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _1tke1jfw _18zrpxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                        className: (0, $2jatx.default)([
                            "_11c81qyo"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                        appearance: "subtle",
                        icon: isExpanded ? $49a262cbf68ddb31$var$CollapseIcon : $49a262cbf68ddb31$var$ExpandIcon,
                        label: title,
                        onClick: ()=>setIsExpanded((current)=>!current),
                        spacing: "compact"
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1rjcu2gc _7myae4h9 _1sw7nqa1 _qgnu1l7x"
                ]),
                children: children
            })
        ]
    });
};
const $49a262cbf68ddb31$export$e49ab55e85e76963 = $49a262cbf68ddb31$var$DetailPanel;
const $49a262cbf68ddb31$var$panelStyles = null;
const $49a262cbf68ddb31$var$panelContentStyles = null;
const $49a262cbf68ddb31$var$panelHeaderStyles = null;
const $49a262cbf68ddb31$var$issueKeyStyles = null;
const $49a262cbf68ddb31$var$headerStatusStyles = null;
const $49a262cbf68ddb31$var$cardStyles = null;
const $49a262cbf68ddb31$var$descriptionHeaderStyles = null;
const $49a262cbf68ddb31$var$reporterStyles = null;
const $49a262cbf68ddb31$var$mediumTextStyles = null;
const $49a262cbf68ddb31$var$linkStyles = null;
const $49a262cbf68ddb31$var$descriptionBodyStyles = null;
const $49a262cbf68ddb31$var$sectionLabelStyles = null;
const $49a262cbf68ddb31$var$boldTextStyles = null;
const $49a262cbf68ddb31$var$attributeRowStyles = null;
const $49a262cbf68ddb31$var$attributeLabelStyles = null;
const $49a262cbf68ddb31$var$detailRowStyles = null;
const $49a262cbf68ddb31$var$fieldLabelStyles = null;
const $49a262cbf68ddb31$var$fieldValueStyles = null;
const $49a262cbf68ddb31$var$collapsibleStyles = null;
const $49a262cbf68ddb31$var$collapsibleHeaderStyles = null;
const $49a262cbf68ddb31$var$collapsibleTitleStyles = null;
const $49a262cbf68ddb31$var$collapsibleBodyStyles = null;
const $49a262cbf68ddb31$var$activityStyles = null;
const $49a262cbf68ddb31$var$activityHeadingStyles = null;
const $49a262cbf68ddb31$var$composerStyles = null;
const $49a262cbf68ddb31$var$composerDividerStyles = null;
const $49a262cbf68ddb31$var$activityItemStyles = null;
const $49a262cbf68ddb31$var$activityCopyStyles = null;
const $49a262cbf68ddb31$var$timestampStyles = null;

});
parcelRegister("fiTNr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b243d17c9f343cfc$export$2e2bcd8739ae039; });
/* avatar.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bv8yJ = parcelRequire("bv8yJ");

var $4UF4U = parcelRequire("4UF4U");

var $6ur0l = parcelRequire("6ur0l");

var $a9Rvl = parcelRequire("a9Rvl");

var $etTbO = parcelRequire("etTbO");

var $iTcyG = parcelRequire("iTcyG");

var $hUa7f = parcelRequire("hUa7f");

var $2DsXJ = parcelRequire("2DsXJ");

var $fVlG0 = parcelRequire("fVlG0");

var $67qxZ = parcelRequire("67qxZ");

var $kmxY5 = parcelRequire("kmxY5");
function $b243d17c9f343cfc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b243d17c9f343cfc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b243d17c9f343cfc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b243d17c9f343cfc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b243d17c9f343cfc$var$packageName = "@atlaskit/avatar";
var $b243d17c9f343cfc$var$packageVersion = "28.0.0";
var $b243d17c9f343cfc$var$containerStyles = null;
var $b243d17c9f343cfc$var$normalizeAvatarSize = function normalizeAvatarSize(size) {
    return size === 'xsmall' && !(0, $6ur0l.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $b243d17c9f343cfc$var$Avatar = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, imgLoading = _ref.imgLoading, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHasPopup = _ref['aria-haspopup'];
    var _useAnalyticsEvents = (0, $bv8yJ.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $kmxY5.useAvatarContext)();
    var size = $b243d17c9f343cfc$var$normalizeAvatarSize(sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium');
    var customPresenceNode = /*#__PURE__*/ (0, $1oC0p.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $1oC0p.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall';
    // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    var indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    var lastAnalytics = (0, $1oC0p.useRef)(analyticsContext);
    var labelId = (0, $4UF4U.useId)();
    (0, $1oC0p.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $1oC0p.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $b243d17c9f343cfc$var$packageName,
                packageVersion: $b243d17c9f343cfc$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $b243d17c9f343cfc$var$_objectSpread({
            componentName: 'avatar',
            packageName: $b243d17c9f343cfc$var$packageName,
            packageVersion: $b243d17c9f343cfc$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled || ariaHasPopup;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $1oC0p.createElement((0, $hUa7f.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $1oC0p.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $2jatx.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $iTcyG.AvatarContentContext).Provider, {
        value: {
            as: (0, $2DsXJ.default)(isDisabled, href, onClick, ariaHasPopup),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ $1oC0p.createElement((0, $etTbO.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $1oC0p.createElement((0, $a9Rvl.AvatarContent), null)), isPresence && /*#__PURE__*/ $1oC0p.createElement((0, $fVlG0.default), {
        appearance: appearance,
        size: indicatorSize,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $1oC0p.createElement((0, $67qxZ.default), {
        appearance: appearance,
        size: indicatorSize,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$b243d17c9f343cfc$var$Avatar.displayName = 'Avatar';
var $b243d17c9f343cfc$export$2e2bcd8739ae039 = $b243d17c9f343cfc$var$Avatar;

});
parcelRegister("bv8yJ", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $85f93aa56bfd90af$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $hdpmQ = parcelRequire("hdpmQ");

var $krJUi = parcelRequire("krJUi");
function $85f93aa56bfd90af$export$5bf35293e545f20c() {
    var analyticsContext = (0, $krJUi.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $hdpmQ.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("hdpmQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8875406654ab6ca$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");

var $cxQrW = parcelRequire("cxQrW");
function $c8875406654ab6ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c8875406654ab6ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c8875406654ab6ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c8875406654ab6ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c8875406654ab6ca$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $c8875406654ab6ca$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $c8875406654ab6ca$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c8875406654ab6ca$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c8875406654ab6ca$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $c8875406654ab6ca$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $c8875406654ab6ca$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            var payload = $c8875406654ab6ca$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $c8875406654ab6ca$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $cxQrW.default));
var $c8875406654ab6ca$var$clonePayload = function clonePayload(payload) {
    if ((0, $6ur0l.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $c8875406654ab6ca$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};

});
parcelRegister("cxQrW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9221408723eeb02d$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $9221408723eeb02d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9221408723eeb02d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9221408723eeb02d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9221408723eeb02d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9221408723eeb02d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $9221408723eeb02d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $9221408723eeb02d$var$_objectSpread($9221408723eeb02d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("krJUi", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $ee29f070f173009f$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $ee29f070f173009f$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("a9Rvl", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", function () { return $76543f83b2291d7c$export$47fbc0b44cae5559; });
/* avatar-content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6ur0l = parcelRequire("6ur0l");

var $iTcyG = parcelRequire("iTcyG");

var $aYxqI = parcelRequire("aYxqI");
var $76543f83b2291d7c$var$boxShadowCssVar = '--avatar-box-shadow';
var $76543f83b2291d7c$var$bgColorCssVar = '--avatar-bg-color';
var $76543f83b2291d7c$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
var $76543f83b2291d7c$var$unboundStyles = {
    rootCustomBorder: "_11q7cxp3",
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonBorderContainerCustomBorder: "_11q7cxp3",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _1llweo6y"
};
var $76543f83b2291d7c$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5pe44 _1q51pe44 _y4tipe44 _bozgpe44 _6rthn6b1 _1pfhn6b1 _12l2n6b1 _ahbqn6b1",
    hexagonFocusContainer: "_85i5i44o _1q51i44o _y4tii44o _bozgi44o _6rthnlpx _1pfhnlpx _12l2nlpx _ahbqnlpx"
};
var $76543f83b2291d7c$var$widthHeightMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $76543f83b2291d7c$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $aYxqI.useEnsureIsInsideAvatar)();
    var _useContext = (0, $1oC0p.useContext)((0, $iTcyG.AvatarContentContext)), Container = _useContext.as, appearance = _useContext.appearance, avatarImage = _useContext.avatarImage, _useContext$borderCol = _useContext.borderColor, borderColor = _useContext$borderCol === void 0 ? "var(--ds-surface, #FFFFFF)" : _useContext$borderCol, href = _useContext.href, isDisabled = _useContext.isDisabled, label = _useContext.label, onClick = _useContext.onClick, contextRef = _useContext.ref, tabIndex = _useContext.tabIndex, target = _useContext.target, testId = _useContext.testId, size = _useContext.size, stackIndex = _useContext.stackIndex, ariaControls = _useContext['aria-controls'], ariaExpanded = _useContext['aria-expanded'], ariaHasPopup = _useContext['aria-haspopup'];
    var isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    var renderedContent = /*#__PURE__*/ $1oC0p.createElement(Container, (0, $c9bqK.default)({
        style: (0, $f53LC.default)((0, $f53LC.default)({}, $76543f83b2291d7c$var$bgColorCssVar, borderColor), $76543f83b2291d7c$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $2jatx.default)([
            $76543f83b2291d7c$var$unboundStyles.root,
            (0, $6ur0l.fg)('avatar-custom-border') && $76543f83b2291d7c$var$unboundStyles.rootCustomBorder,
            $76543f83b2291d7c$var$styles.root,
            appearance === 'square' && $76543f83b2291d7c$var$styles.square,
            appearance === 'circle' && $76543f83b2291d7c$var$styles.circle,
            appearance === 'hexagon' && $76543f83b2291d7c$var$unboundStyles.hexagon,
            $76543f83b2291d7c$var$widthHeightMap[size],
            stackIndex !== undefined && $76543f83b2291d7c$var$styles.positionRelative,
            isInteractive && !isDisabled && $76543f83b2291d7c$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $6ur0l.fg)('platform-dst-motion-uplift') && $76543f83b2291d7c$var$unboundStyles.interactiveMotion,
            isDisabled && $76543f83b2291d7c$var$styles.disabled
        ])
    }), children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        style: (0, $f53LC.default)((0, $f53LC.default)({}, $76543f83b2291d7c$var$bgColorCssVar, borderColor), $76543f83b2291d7c$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        "data-testid": testId ? "".concat(testId, "-hexagon-focus-container") : 'hexagon-focus-container',
        className: (0, $2jatx.default)([
            $76543f83b2291d7c$var$unboundStyles.hexagonFocusContainer,
            isInteractive && !isDisabled && (0, $6ur0l.fg)('platform-dst-motion-uplift') && $76543f83b2291d7c$var$unboundStyles.interactiveMotion,
            (0, $6ur0l.fg)('platform_editor_agent_mentions_drop_one_fixes') && $76543f83b2291d7c$var$hexagonBorderFixStyles.hexagonFocusContainer
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId ? "".concat(testId, "-hexagon-border-container") : 'hexagon-border-container',
        className: (0, $2jatx.default)([
            $76543f83b2291d7c$var$unboundStyles.hexagonBorderContainer,
            (0, $6ur0l.fg)('avatar-custom-border') && $76543f83b2291d7c$var$unboundStyles.hexagonBorderContainerCustomBorder,
            (0, $6ur0l.fg)('platform_editor_agent_mentions_drop_one_fixes') && $76543f83b2291d7c$var$hexagonBorderFixStyles.hexagonBorderContainer
        ])
    }, renderedContent));
});

});
parcelRegister("iTcyG", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", function () { return $dc071adda324a398$export$b983474ddd0b6d28; });

var $1oC0p = parcelRequire("1oC0p");
var $dc071adda324a398$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $dc071adda324a398$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $1oC0p.createContext)($dc071adda324a398$var$defaultAvatarContentProps);

});

parcelRegister("aYxqI", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideAvatar", function () { return $7fd9707578e68c31$export$7db5c57474082dd9; });

var $1oC0p = parcelRequire("1oC0p");

var $hUa7f = parcelRequire("hUa7f");
var $7fd9707578e68c31$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $1oC0p.useContext)((0, $hUa7f.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});
parcelRegister("hUa7f", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", function () { return $d08f8371f69be23b$export$6b4cbd90d24955ad; });

var $1oC0p = parcelRequire("1oC0p");
var $d08f8371f69be23b$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});



parcelRegister("etTbO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a8ae95999e347a3d$export$2e2bcd8739ae039; });
/* avatar-image.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cnoa5 = parcelRequire("cnoa5");

var $7surG = parcelRequire("7surG");

var $bJIZi = parcelRequire("bJIZi");
var $a8ae95999e347a3d$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
var $a8ae95999e347a3d$var$borderRadiusMap = {
    xxsmall: "_2rkolb4i",
    xsmall: "_2rkolb4i",
    UNSAFE_xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
var $a8ae95999e347a3d$var$nestedSvgStylesMap = {
    xxsmall: "_w8l57vkz _17527vkz",
    xsmall: "_w8l57vkz _17527vkz",
    UNSAFE_xsmall: "_w8l5gktf _1752gktf",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $a8ae95999e347a3d$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $1oC0p.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        var renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7surG))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--person"),
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cnoa5))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--agent"),
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJIZi))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--ship"),
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $1oC0p.createElement("span", {
            className: (0, $2jatx.default)([
                $a8ae95999e347a3d$var$styles.icon,
                $a8ae95999e347a3d$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $1oC0p.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $2jatx.default)([
            $a8ae95999e347a3d$var$styles.image,
            $a8ae95999e347a3d$var$borderRadiusMap[size],
            appearance === 'circle' && $a8ae95999e347a3d$var$styles.circle,
            appearance === 'hexagon' && $a8ae95999e347a3d$var$styles.hexagon
        ])
    });
};
var $a8ae95999e347a3d$export$2e2bcd8739ae039 = $a8ae95999e347a3d$var$AvatarImage;

});
parcelRegister("cnoa5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1078ad25bb88c0aacc625e83cbe31eaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0253439cf148f099$var$_react = $0253439cf148f099$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0253439cf148f099$var$_iconNew = $0253439cf148f099$var$_interopRequireDefault((parcelRequire("fBroF")));
function $0253439cf148f099$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0253439cf148f099$var$AiAgentIcon = (props)=>/*#__PURE__*/ $0253439cf148f099$var$_react.default.createElement($0253439cf148f099$var$_iconNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$0253439cf148f099$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $0253439cf148f099$var$_default = module.exports.default = $0253439cf148f099$var$AiAgentIcon;

});

parcelRegister("7surG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44bfe3fda6843e57916c639848bc7fcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56e2c3c1a9226f96$var$_react = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56e2c3c1a9226f96$var$_iconNew = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("fBroF")));
function $56e2c3c1a9226f96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56e2c3c1a9226f96$var$PersonIcon = (props)=>/*#__PURE__*/ $56e2c3c1a9226f96$var$_react.default.createElement($56e2c3c1a9226f96$var$_iconNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$56e2c3c1a9226f96$var$PersonIcon.displayName = 'PersonIcon';
var $56e2c3c1a9226f96$var$_default = module.exports.default = $56e2c3c1a9226f96$var$PersonIcon;

});

parcelRegister("bJIZi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a375ef61b97315ae7ff25123b3ed791c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88b6cb4950e3a695$var$_react = $88b6cb4950e3a695$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $88b6cb4950e3a695$var$_iconNew = $88b6cb4950e3a695$var$_interopRequireDefault((parcelRequire("fBroF")));
function $88b6cb4950e3a695$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88b6cb4950e3a695$var$ReleaseIcon = (props)=>/*#__PURE__*/ $88b6cb4950e3a695$var$_react.default.createElement($88b6cb4950e3a695$var$_iconNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$88b6cb4950e3a695$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $88b6cb4950e3a695$var$_default = module.exports.default = $88b6cb4950e3a695$var$ReleaseIcon;

});


parcelRegister("2DsXJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1eb5b0a223e733ef$export$2e2bcd8739ae039; });
var $1eb5b0a223e733ef$var$getCustomElement = function getCustomElement(isDisabled, href, onClick, ariaHasPopup) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $1eb5b0a223e733ef$export$2e2bcd8739ae039 = $1eb5b0a223e733ef$var$getCustomElement;

});

parcelRegister("fVlG0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b97cfe5ffcdcbebf$export$2e2bcd8739ae039; });
/* presence-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gtFjH = parcelRequire("gtFjH");
var $b97cfe5ffcdcbebf$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $b97cfe5ffcdcbebf$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $b97cfe5ffcdcbebf$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $b97cfe5ffcdcbebf$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
var $b97cfe5ffcdcbebf$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ var $b97cfe5ffcdcbebf$var$PresenceWrapper = function PresenceWrapper(_ref) {
    var size = _ref.size, appearance = _ref.appearance, children = _ref.children, borderColor = _ref.borderColor, presence = _ref.presence, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $2jatx.default)([
            $b97cfe5ffcdcbebf$var$styles.root,
            $b97cfe5ffcdcbebf$var$iconSizeMap[size],
            $b97cfe5ffcdcbebf$var$circleIconOffsetMap[size],
            appearance === 'square' && $b97cfe5ffcdcbebf$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $b97cfe5ffcdcbebf$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $gtFjH.default), {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};
var $b97cfe5ffcdcbebf$export$2e2bcd8739ae039 = $b97cfe5ffcdcbebf$var$PresenceWrapper;

});
parcelRegister("gtFjH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bfef6771700653ee$export$2e2bcd8739ae039; });
/* presence.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");


var $71hu7 = parcelRequire("71hu7");
var $bfef6771700653ee$var$BusyIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $bfef6771700653ee$var$FocusIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-icon-discovery, #AF59E1)",
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $bfef6771700653ee$var$OfflineIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $bfef6771700653ee$var$OnlineIndicator = /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $bfef6771700653ee$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $bfef6771700653ee$var$BusyIndicator;
        case 'focus':
            return $bfef6771700653ee$var$FocusIndicator;
        case 'offline':
            return $bfef6771700653ee$var$OfflineIndicator;
        case 'online':
            return $bfef6771700653ee$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $bfef6771700653ee$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $1oC0p.createElement((0, $71hu7.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $1oC0p.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $bfef6771700653ee$var$getPresence(presence)) : children);
};
var $bfef6771700653ee$export$2e2bcd8739ae039 = $bfef6771700653ee$var$AvatarPresence;

});
parcelRegister("71hu7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $51c63088bffa450d$export$2e2bcd8739ae039; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $51c63088bffa450d$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $51c63088bffa450d$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $51c63088bffa450d$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $2jatx.default)([
            $51c63088bffa450d$var$styles.root,
            $51c63088bffa450d$var$unboundStyles.root
        ])
    }, children);
};
var $51c63088bffa450d$export$2e2bcd8739ae039 = $51c63088bffa450d$var$IconWrapper;

});



parcelRegister("67qxZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4747fd4261f587f4$export$2e2bcd8739ae039; });
/* status-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jcqW2 = parcelRequire("jcqW2");
var $4747fd4261f587f4$var$styles = {
    root: "_kqswstnw"
};
var $4747fd4261f587f4$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $4747fd4261f587f4$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
var $4747fd4261f587f4$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
var $4747fd4261f587f4$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ var $4747fd4261f587f4$var$StatusWrapper = function StatusWrapper(_ref) {
    var size = _ref.size, status = _ref.status, appearance = _ref.appearance, borderColor = _ref.borderColor, children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $2jatx.default)([
            $4747fd4261f587f4$var$styles.root,
            $4747fd4261f587f4$var$iconSizeMap[size],
            $4747fd4261f587f4$var$circleIconOffsetMap[size],
            appearance === 'square' && $4747fd4261f587f4$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $4747fd4261f587f4$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $jcqW2.default), {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};
var $4747fd4261f587f4$export$2e2bcd8739ae039 = $4747fd4261f587f4$var$StatusWrapper;

});
parcelRegister("jcqW2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dfa40812b7de551e$export$2e2bcd8739ae039; });
/* status.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");


var $71hu7 = parcelRequire("71hu7");
var $dfa40812b7de551e$var$ApprovedIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $dfa40812b7de551e$var$DeclinedIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $dfa40812b7de551e$var$LockedIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
var $dfa40812b7de551e$var$WarningIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-warning, #E06C00)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
}));
function $dfa40812b7de551e$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $dfa40812b7de551e$var$ApprovedIndicator;
        case 'declined':
            return $dfa40812b7de551e$var$DeclinedIndicator;
        case 'locked':
            return $dfa40812b7de551e$var$LockedIndicator;
        case 'warning':
            return $dfa40812b7de551e$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $dfa40812b7de551e$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $1oC0p.createElement((0, $71hu7.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $1oC0p.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $dfa40812b7de551e$var$getStatus(status)) : children);
};
var $dfa40812b7de551e$export$2e2bcd8739ae039 = $dfa40812b7de551e$var$AvatarStatus;

});


parcelRegister("kmxY5", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", function () { return $ed30361b87960964$export$b50b87a1c4086b23; });

var $1oC0p = parcelRequire("1oC0p");

var $drWEt = parcelRequire("drWEt");
var $ed30361b87960964$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $1oC0p.useContext)((0, $drWEt.AvatarContext));
};

});
parcelRegister("drWEt", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", function () { return $9cab4b078588a820$export$a20dad690e1279e2; });

var $1oC0p = parcelRequire("1oC0p");
var $9cab4b078588a820$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});



parcelRegister("k3Xeq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::186cfd732e4641b5fdb3f2d7a456f10c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9b208a7dc18cd46$var$_react = $e9b208a7dc18cd46$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e9b208a7dc18cd46$var$_baseNew = $e9b208a7dc18cd46$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $e9b208a7dc18cd46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9b208a7dc18cd46$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $e9b208a7dc18cd46$var$_react.default.createElement($e9b208a7dc18cd46$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$e9b208a7dc18cd46$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $e9b208a7dc18cd46$var$_default = module.exports.default = $e9b208a7dc18cd46$var$ChevronUpIcon;

});

parcelRegister("hG8Ki", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cded249b4efd8b46$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $dFmdv = parcelRequire("dFmdv");

var $6ur0l = parcelRequire("6ur0l");

var $h7wWy = parcelRequire("h7wWy");

var $kAuxE = parcelRequire("kAuxE");

var $F5ucT = parcelRequire("F5ucT");

var $5XgGk = parcelRequire("5XgGk");

var $5qdE9 = parcelRequire("5qdE9");

var $9cKes = parcelRequire("9cKes");

var $amWOS = parcelRequire("amWOS");
var $cded249b4efd8b46$var$_excluded = [
    "appearance",
    "elemBefore",
    "color",
    "href",
    "testId",
    "text",
    "linkComponent",
    "migration_fallback",
    "maxWidth",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole"
];
var $cded249b4efd8b46$var$SimpleTagComponent = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, testId = _ref.testId, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, rest = (0, $gnQ3X.default)(_ref, $cded249b4efd8b46$var$_excluded);
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $6ur0l.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $9cKes.getLozengeAppearance)(color);
        return /*#__PURE__*/ $1oC0p.createElement((0, $dFmdv.default), (0, $c9bqK.default)({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), text);
    }
    // Use new TagNew component behind feature flag
    if ((0, $6ur0l.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $h7wWy.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ $1oC0p.createElement((0, $kAuxE.default), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: false,
            maxWidth: maxWidth,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $1oC0p.createElement((0, $amWOS.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ $1oC0p.createElement((0, $5XgGk.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ $1oC0p.createElement((0, $5qdE9.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 *
 * @deprecated `SimpleTag` is deprecated. Use the default `Tag` export from
 * `@atlaskit/tag` with `isRemovable={false}` instead, e.g. `<Tag text="…" isRemovable={false} />`.
 */ var $cded249b4efd8b46$var$SimpleTag = (0, $F5ucT.markAsTagMotionCapable)(/*#__PURE__*/ (0, $1oC0p.memo)($cded249b4efd8b46$var$SimpleTagComponent));
var $cded249b4efd8b46$export$2e2bcd8739ae039 = $cded249b4efd8b46$var$SimpleTag;

});
parcelRegister("dFmdv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f3056814d2fdead$export$2e2bcd8739ae039; });
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6ur0l = parcelRequire("6ur0l");

var $1ELKf = parcelRequire("1ELKf");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $9f3056814d2fdead$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $9f3056814d2fdead$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $9f3056814d2fdead$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $9f3056814d2fdead$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $9f3056814d2fdead$var$LegacyLozenge = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $1oC0p.useMemo)(function() {
        return $9f3056814d2fdead$var$appearanceTypes.includes(appearance) || $9f3056814d2fdead$var$newSemanticColors.includes(appearance) ? $9f3056814d2fdead$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $2jatx.default)([
            $9f3056814d2fdead$var$styles.container,
            $9f3056814d2fdead$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $9f3056814d2fdead$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $9f3056814d2fdead$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $2jatx.default)([
            $9f3056814d2fdead$var$styles.text,
            (0, $6ur0l.fg)('platform-lozenge-custom-letterspacing') && $9f3056814d2fdead$var$styles.customLetterspacing,
            $9f3056814d2fdead$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$9f3056814d2fdead$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $9f3056814d2fdead$var$LozengeWrapper = /*#__PURE__*/ (0, $1oC0p.memo)(function(props) {
    if ((0, $6ur0l.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $1oC0p.createElement((0, $1ELKf.default), props);
    return /*#__PURE__*/ $1oC0p.createElement($9f3056814d2fdead$var$LegacyLozenge, props);
});
$9f3056814d2fdead$var$LozengeWrapper.displayName = 'Lozenge';
var $9f3056814d2fdead$export$2e2bcd8739ae039 = $9f3056814d2fdead$var$LozengeWrapper;

});
parcelRegister("1ELKf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $134e9001bda907a5$export$2e2bcd8739ae039; });
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");


var $lqHcl = parcelRequire("lqHcl");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $134e9001bda907a5$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $1oC0p.createElement((0, $lqHcl.default), baseProps, children);
};
$134e9001bda907a5$var$Lozenge.displayName = 'Lozenge';
var $134e9001bda907a5$export$2e2bcd8739ae039 = $134e9001bda907a5$var$Lozenge;

});
parcelRegister("lqHcl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f99d88f32c4735b6$export$2e2bcd8739ae039; });
/* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $f53LC = parcelRequire("f53LC");

var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $4oKrJ = parcelRequire("4oKrJ");

var $4ZpaI = parcelRequire("4ZpaI");

var $iYq16 = parcelRequire("iYq16");

var $foP8r = parcelRequire("foP8r");

var $6ur0l = parcelRequire("6ur0l");

var $iqYf4 = parcelRequire("iqYf4");

var $lqlBg = parcelRequire("lqlBg");

var $iPhOu = parcelRequire("iPhOu");

var $bWlwC = parcelRequire("bWlwC");

var $bUQ1d = parcelRequire("bUQ1d");
function $f99d88f32c4735b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f99d88f32c4735b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f99d88f32c4735b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f99d88f32c4735b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $f99d88f32c4735b6$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $f99d88f32c4735b6$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
var $f99d88f32c4735b6$var$interactiveMotionStyles = {
    motion: "_v564k6bl _1ggl5xtf"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $f99d88f32c4735b6$var$LozengeBase = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $foP8r.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $1oC0p.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $bUQ1d.resolveLozengeColor)(appearance) || 'neutral';
    var _getThemeStyles = (0, $iPhOu.getThemeStyles)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $bUQ1d.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    var metricBadgeAppearance = function() {
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    }();
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : "min(".concat(maxWidthValue, ", 100%)")
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $1oC0p.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, $6ur0l.fg)('platform-dst-motion-uplift');
    var enableButtonMotionFG = (0, $6ur0l.fg)('platform-dst-motion-uplift-button');
    var innerContent = /*#__PURE__*/ $1oC0p.createElement("span", (0, $c9bqK.default)({
        "data-testid": testId ? "".concat(testId, "--content") : undefined
    }, enableMotionFG ? resizingWidth : undefined, {
        className: (0, $2jatx.default)([
            $f99d88f32c4735b6$var$styles.content,
            spacing === 'spacious' && $f99d88f32c4735b6$var$styles.contentSpacious,
            isInteractive && enableButtonMotionFG && $f99d88f32c4735b6$var$styles.loadingMotion,
            isLoading && $f99d88f32c4735b6$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $f99d88f32c4735b6$var$styles.maxWidth
        ])
    }), iconBefore && /*#__PURE__*/ $1oC0p.createElement((0, $bWlwC.default), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $1oC0p.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $2jatx.default)([
            $f99d88f32c4735b6$var$styles.text,
            enableMotionFG && resizing && !maxWidth ? $f99d88f32c4735b6$var$styles.textClip : $f99d88f32c4735b6$var$styles.textEllipsis,
            spacing === 'spacious' && $f99d88f32c4735b6$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $2jatx.default)([
            $f99d88f32c4735b6$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $4oKrJ.default), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iYq16))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $1oC0p.createElement((0, $iqYf4.default), (0, $c9bqK.default)({
        ref: ref,
        xcss: (0, $4ZpaI.cx)($f99d88f32c4735b6$var$styles.container, !isLoading && enableButtonMotionFG ? $f99d88f32c4735b6$var$interactiveMotionStyles.motion : enableMotionFG && $f99d88f32c4735b6$var$styles.motionContainer, spacing === 'spacious' && $f99d88f32c4735b6$var$styles.containerSpacious, !isSelected && $f99d88f32c4735b6$var$styles.iconBorderFilter, $f99d88f32c4735b6$var$styles[colorStyleKey], !isLoading && $f99d88f32c4735b6$var$styles[interactiveStyleKey], hasTrailingMetric && $f99d88f32c4735b6$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $f99d88f32c4735b6$var$styles.containerBadgeNeutralAppearance)
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $f99d88f32c4735b6$var$_objectSpread($f99d88f32c4735b6$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'var(--border-color) !important' : 'transparent'),
            backgroundColor: isSelected ? $f99d88f32c4735b6$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }, isSelected && {
        'data-selected': 'true'
    }), innerContent, isLoading && /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId ? "".concat(testId, "--loading-overlay") : undefined,
        className: (0, $2jatx.default)([
            $f99d88f32c4735b6$var$styles.loadingOverlay,
            enableButtonMotionFG && $f99d88f32c4735b6$var$styles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $lqlBg.default), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $2jatx.default)([
            $f99d88f32c4735b6$var$styles.container,
            spacing === 'spacious' && $f99d88f32c4735b6$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $f99d88f32c4735b6$var$styles.containerBadgePadding,
            $f99d88f32c4735b6$var$styles[colorStyleKey],
            $f99d88f32c4735b6$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $f99d88f32c4735b6$var$styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
var $f99d88f32c4735b6$export$2e2bcd8739ae039 = $f99d88f32c4735b6$var$LozengeBase;

});
parcelRegister("4oKrJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $333d6e9572353e63$export$2e2bcd8739ae039; });
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $a55Pn = parcelRequire("a55Pn");

var $4Q7Gf = parcelRequire("4Q7Gf");

var $40nAM = parcelRequire("40nAM");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $333d6e9572353e63$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $333d6e9572353e63$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $40nAM.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ var $333d6e9572353e63$var$BadgeNew = /*#__PURE__*/ (0, $1oC0p.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    var _useThemeObserver = (0, $4Q7Gf.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    var resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $2jatx.default)([
            $333d6e9572353e63$var$stylesNew.root,
            $333d6e9572353e63$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $a55Pn.Text), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $333d6e9572353e63$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $333d6e9572353e63$export$2e2bcd8739ae039 = $333d6e9572353e63$var$BadgeNew;

});
parcelRegister("4Q7Gf", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", function () { return $3861f9eabcac1515$export$3dd7971102e44fa8; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $7lVUp = parcelRequire("7lVUp");

var $cMWSn = parcelRequire("cMWSn");
var $3861f9eabcac1515$export$3dd7971102e44fa8 = function useThemeObserver() {
    var _useState = (0, $1oC0p.useState)((0, $7lVUp.getGlobalTheme)()), _useState2 = (0, $2qaZZ.default)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        var observer = new (0, $cMWSn.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $3861f9eabcac1515$export$2e2bcd8739ae039 = $3861f9eabcac1515$export$3dd7971102e44fa8;

});
parcelRegister("7lVUp", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $55a76a0fa12305cc$export$813ecdf77207a053; });

var $f53LC = parcelRequire("f53LC");

var $hEW4r = parcelRequire("hEW4r");

var $9TPyP = parcelRequire("9TPyP");

var $2vaEo = parcelRequire("2vaEo");
function $55a76a0fa12305cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55a76a0fa12305cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55a76a0fa12305cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55a76a0fa12305cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $55a76a0fa12305cc$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $hEW4r.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $hEW4r.THEME_DATA_ATTRIBUTE)) || '';
    return $55a76a0fa12305cc$var$_objectSpread($55a76a0fa12305cc$var$_objectSpread({}, (0, $2vaEo.themeStringToObject)(theme)), (0, $9TPyP.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("hEW4r", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $cdb337b3cc107d4c$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $cdb337b3cc107d4c$export$a00eac3f8684bcd0; });
var $cdb337b3cc107d4c$export$4ef52930e33717cd = 'data-theme';
var $cdb337b3cc107d4c$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $cdb337b3cc107d4c$export$a00eac3f8684bcd0 = 'data-color-mode';
var $cdb337b3cc107d4c$export$2112803007239c61 = 'data-contrast-mode';
var $cdb337b3cc107d4c$export$352e418ed5b6193a = 'data-custom-theme';
var $cdb337b3cc107d4c$export$6f0c6fb8c80fcc92 = 'ds';
var $cdb337b3cc107d4c$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $cdb337b3cc107d4c$export$dddac1532e822863 = "--".concat($cdb337b3cc107d4c$export$6f0c6fb8c80fcc92, "-token-not-found");
var $cdb337b3cc107d4c$export$9d7b58831ae93caa = "--".concat($cdb337b3cc107d4c$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("9TPyP", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", function () { return $73513f04cc6440aa$export$fcfb1976c88f9f75; });

var $8pDIo = parcelRequire("8pDIo");
var $73513f04cc6440aa$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $8pDIo.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("8pDIo", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $61ff771ef322a98d$export$83993de8eb66733; });
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $61ff771ef322a98d$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("2vaEo", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $1d26bcf7aec36bce$export$f19b488f7c0547ee; });

var $2qaZZ = parcelRequire("2qaZZ");

var $6LtIi = parcelRequire("6LtIi");

var $4mRiQ = parcelRequire("4mRiQ");

var $aHEQS = parcelRequire("aHEQS");
var $1d26bcf7aec36bce$var$customThemeOptions = 'UNSAFE_themeOptions';
var $1d26bcf7aec36bce$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $6LtIi.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $aHEQS.isThemeKind)(kind) && (0, $4mRiQ.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $1d26bcf7aec36bce$var$customThemeOptions) try {
            themeObject[$1d26bcf7aec36bce$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});
parcelRegister("6LtIi", function(module, exports) {
$parcel$export(module.exports, "isColorMode", function () { return $4ece2e4fe5a159ee$export$4a14e169b1de4ee7; });
var $4ece2e4fe5a159ee$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("4mRiQ", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", function () { return $32e2905c7b5c36c9$export$ea35b8958c39dd07; });

var $8ssGX = parcelRequire("8ssGX");
var $32e2905c7b5c36c9$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $8ssGX.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("8ssGX", function(module, exports) {
$parcel$export(module.exports, "themeIds", function () { return $628731da8c436743$export$7d43e72a58e3283f; });
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $628731da8c436743$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("aHEQS", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", function () { return $7cad9bd641ff8046$export$958fa026be3a263e; });
var $7cad9bd641ff8046$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $7cad9bd641ff8046$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $7cad9bd641ff8046$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});



parcelRegister("cMWSn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $94f7a34a37c9fe29$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $hEW4r = parcelRequire("hEW4r");

var $7lVUp = parcelRequire("7lVUp");
var $94f7a34a37c9fe29$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $cTewU.default)(this, ThemeMutationObserver);
        (0, $f53LC.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $avOEA.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $7lVUp.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $hEW4r.THEME_DATA_ATTRIBUTE),
                            (0, $hEW4r.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $f53LC.default)($94f7a34a37c9fe29$export$b741a7c3bcb1c635, "observer", null);
(0, $f53LC.default)($94f7a34a37c9fe29$export$b741a7c3bcb1c635, "callbacks", new Set());
var $94f7a34a37c9fe29$export$2e2bcd8739ae039 = $94f7a34a37c9fe29$export$b741a7c3bcb1c635;

});


parcelRegister("40nAM", function(module, exports) {
$parcel$export(module.exports, "formatValue", function () { return $2ea9766bf9dacc31$export$7c4d25c0c3217d8c; });
function $2ea9766bf9dacc31$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $2ea9766bf9dacc31$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $2ea9766bf9dacc31$var$getSafeValue(value);
    var safeMax = $2ea9766bf9dacc31$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("iYq16", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd0202fc87244d0a$var$_react = $dd0202fc87244d0a$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dd0202fc87244d0a$var$_iconNew = $dd0202fc87244d0a$var$_interopRequireDefault((parcelRequire("3d03q")));
function $dd0202fc87244d0a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd0202fc87244d0a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $dd0202fc87244d0a$var$_react.default.createElement($dd0202fc87244d0a$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$dd0202fc87244d0a$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $dd0202fc87244d0a$var$_default = module.exports.default = $dd0202fc87244d0a$var$ChevronDownIcon;

});
parcelRegister("3d03q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", function () { return $2562a0c525322246$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $2562a0c525322246$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $2562a0c525322246$var$svgStyles = null;
var $2562a0c525322246$var$iconStyles = null;
var $2562a0c525322246$var$smallIconStyles = null;
var $2562a0c525322246$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $2562a0c525322246$var$baseHcmStyles = null;
var $2562a0c525322246$var$scaleSize = null;
var $2562a0c525322246$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2562a0c525322246$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2562a0c525322246$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $2562a0c525322246$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $2562a0c525322246$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $2jatx.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $2562a0c525322246$var$coreSizeSmall[spacing] : $2562a0c525322246$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2562a0c525322246$export$2e2bcd8739ae039 = $2562a0c525322246$export$f04a61298a47a40f;

});


parcelRegister("foP8r", function(module, exports) {
$parcel$export(module.exports, "useResizing", function () { return $b360c343a87174c8$export$a300664a1a230956; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $5Z8yk = parcelRequire("5Z8yk");

var $UCjhT = parcelRequire("UCjhT");

var $lB1RN = parcelRequire("lB1RN");

var $3bRDb = parcelRequire("3bRDb");

var $dWlGQ = parcelRequire("dWlGQ");

var $jira5 = parcelRequire("jira5");
/**
 * Which dimension(s) of the element to animate.
 *
 * - `'width'` animates only width changes.
 * - `'height'` animates only height changes.
 * - `'both'` animates width and height changes simultaneously.
 */ /**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $b360c343a87174c8$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $b360c343a87174c8$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $b360c343a87174c8$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var $b360c343a87174c8$export$a300664a1a230956 = function useResizing(_ref) {
    var dimension = _ref.dimension, duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $1oC0p.useRef)();
    var _useElementRef = (0, $UCjhT.useElementRef)(), _useElementRef2 = (0, $2qaZZ.default)(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $dWlGQ.useSetTimeout)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $3bRDb.useRequestAnimationFrame)();
    (0, $jira5.useSnapshotBeforeUpdate)(function() {
        if ((0, $5Z8yk.isReducedMotion)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $lB1RN.useLayoutEffect)(function() {
        if ((0, $5Z8yk.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$b360c343a87174c8$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var propertyList = $b360c343a87174c8$var$getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = $b360c343a87174c8$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});
parcelRegister("5Z8yk", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $45b9489de7017895$export$b7baf7667a68d87c; });

var $cOJjo = parcelRequire("cOJjo");
var $45b9489de7017895$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $cOJjo.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("cOJjo", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", function () { return $954d4d8225603b5e$export$c5406bd59b374abd; });
var $954d4d8225603b5e$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("UCjhT", function(module, exports) {
$parcel$export(module.exports, "useElementRef", function () { return $0aa2f2a9e38d6b72$export$ff879f35a69d56b7; });

var $1oC0p = parcelRequire("1oC0p");
var $0aa2f2a9e38d6b72$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $1oC0p.useRef)(null);
    var setRef = (0, $1oC0p.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("lB1RN", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $fb8e805a6f0cc796$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $fb8e805a6f0cc796$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("3bRDb", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", function () { return $252c002f0a35992d$export$1775f27e7c8051ca; });

var $1oC0p = parcelRequire("1oC0p");
var $252c002f0a35992d$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $252c002f0a35992d$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $252c002f0a35992d$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("dWlGQ", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", function () { return $a261844eede92df0$export$4f34107a2b00f39c; });

var $1oC0p = parcelRequire("1oC0p");
// Handle both browser and Node.js environments
var $a261844eede92df0$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $a261844eede92df0$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a261844eede92df0$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("jira5", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", function () { return $e0c4c48462bb9c96$export$9e95200239cd148b; });

var $1oC0p = parcelRequire("1oC0p");

var $lB1RN = parcelRequire("lB1RN");
var $e0c4c48462bb9c96$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $1oC0p.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $lB1RN.useLayoutEffect)(function() {
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("iqYf4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d6b96289ea745a35$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $lFOXD = parcelRequire("lFOXD");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jeMKQ = parcelRequire("jeMKQ");

var $7uNuF = parcelRequire("7uNuF");

var $hnNY4 = parcelRequire("hnNY4");

var $65YbV = parcelRequire("65YbV");

var $hCL1F = parcelRequire("hCL1F");

var $61PKB = parcelRequire("61PKB");

var $97mBj = parcelRequire("97mBj");

var $4vMDQ = parcelRequire("4vMDQ");

var $jxd0s = parcelRequire("jxd0s");
var $d6b96289ea745a35$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $d6b96289ea745a35$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $d6b96289ea745a35$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $hCL1F.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $jxd0s.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $61PKB.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $61PKB.borderWidthMap)['border.width'], " solid")
        }
    }
});
var $d6b96289ea745a35$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $d6b96289ea745a35$var$enabledStyles = (0, $3dJ4i.css)({
    cursor: 'pointer'
});
var $d6b96289ea745a35$var$disabledStyles = (0, $3dJ4i.css)({
    cursor: 'not-allowed'
});
var $d6b96289ea745a35$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $7uNuF.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $d6b96289ea745a35$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $hnNY4.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $jeMKQ.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.4.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $d6b96289ea745a35$var$_excluded2);
    var resolvedStyles = (0, $4vMDQ.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)("button", (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $d6b96289ea745a35$var$baseStyles,
            $d6b96289ea745a35$var$focusRingStyles,
            isDisabled ? $d6b96289ea745a35$var$disabledStyles : $d6b96289ea745a35$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $65YbV.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $97mBj.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $97mBj.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $97mBj.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $97mBj.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $97mBj.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $97mBj.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $97mBj.paddingStylesMap).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, $lFOXD.default)(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d6b96289ea745a35$export$2e2bcd8739ae039 = $d6b96289ea745a35$export$27c701ed9e449e99;

});
parcelRegister("hCL1F", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", function () { return $cd4a769fa63d1520$export$1531ad5bb3fbedac; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2243347101d0284063f83cb3084a0b4>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $cd4a769fa63d1520$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("61PKB", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", function () { return $463afab26e494665$export$e1b83c5210c471b8; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee12747fee6f7445e430f52ee1f7b86>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ var $463afab26e494665$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});


parcelRegister("lqlBg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f98cc7fdac803753$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $1XY6l = parcelRequire("1XY6l");

var $fGsGB = parcelRequire("fGsGB");
/**
 * Returns the appropriate circle stroke color.
 */ function $f98cc7fdac803753$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $f98cc7fdac803753$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $f98cc7fdac803753$var$loadIn = null;
var $f98cc7fdac803753$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $f98cc7fdac803753$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $f98cc7fdac803753$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $fGsGB.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $f98cc7fdac803753$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $1XY6l.default));
    $f98cc7fdac803753$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $2jatx.default)([
            $f98cc7fdac803753$var$styles.wrapperStyles,
            $f98cc7fdac803753$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $2jatx.default)([
            $f98cc7fdac803753$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $2jatx.default)([
            $f98cc7fdac803753$var$styles.circleStyles
        ])
    })));
}));
var $f98cc7fdac803753$export$2e2bcd8739ae039 = $f98cc7fdac803753$var$Spinner;

});
parcelRegister("1XY6l", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $16e9ebff23c084a2$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $16e9ebff23c084a2$var$interactionContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $16e9ebff23c084a2$export$2e2bcd8739ae039 = $16e9ebff23c084a2$var$interactionContext;

});

parcelRegister("fGsGB", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $b6b107bac7b4132e$export$4e9f1640bbe7a1a8; });
var $b6b107bac7b4132e$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("iPhOu", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", function () { return $db4acec7359482a8$export$a3fc04b8551e006a; });
// extract the category and key from the resolved color
var $db4acec7359482a8$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("bWlwC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8b15ceee46d90b98$export$2e2bcd8739ae039; });
/* icon-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $2sVl0 = parcelRequire("2sVl0");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
var $8b15ceee46d90b98$var$getIconColor = function getIconColor(color) {
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
var $8b15ceee46d90b98$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ var $8b15ceee46d90b98$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $8b15ceee46d90b98$var$getIconColor(color);
    return (0, $6ur0l.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2sVl0.Box), {
        xcss: $8b15ceee46d90b98$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$8b15ceee46d90b98$export$2e2bcd8739ae039 = $8b15ceee46d90b98$var$IconRenderer;

});

parcelRegister("bUQ1d", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", function () { return $8acd4677936a0fdf$export$acf5d2b7dc999bda; });
// Map legacy appearance to new color values
var $8acd4677936a0fdf$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $8acd4677936a0fdf$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $8acd4677936a0fdf$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};

});




parcelRegister("h7wWy", function(module, exports) {
$parcel$export(module.exports, "colorMapping", function () { return $c76ca4fe0cf5cadd$export$3351a8d90bcc13aa; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // Color mapping from old color names to new color names
var $c76ca4fe0cf5cadd$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

});

parcelRegister("kAuxE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $efcedc65618db2dd$export$2e2bcd8739ae039; });
/* tag-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $3sHnI = parcelRequire("3sHnI");

var $5RBBI = parcelRequire("5RBBI");

var $6ur0l = parcelRequire("6ur0l");

var $eowPk = parcelRequire("eowPk");

var $lqlBg = parcelRequire("lqlBg");

var $h7wWy = parcelRequire("h7wWy");

var $cErYX = parcelRequire("cErYX");

var $gi6hM = parcelRequire("gi6hM");

var $aplsu = parcelRequire("aplsu");

var $F5ucT = parcelRequire("F5ucT");

var $f2xys = parcelRequire("f2xys");

var $ehNeI = parcelRequire("ehNeI");

var $dvm1o = parcelRequire("dvm1o");

var $0POMQ = parcelRequire("0POMQ");

var $f7JWn = parcelRequire("f7JWn");

var $kecTg = parcelRequire("kecTg");
var $efcedc65618db2dd$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
], $efcedc65618db2dd$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
];
var $efcedc65618db2dd$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    afterMotionStyles: "_1ul9utpp",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek",
    interactiveMotionStyles: "_v564k6bl _1ggl5xtf",
    activeMotionStyles: "_1reo15vq _18m915vq _8hrz1e5h",
    enteringMotionStyles: "_y44v1ukz _1bumglyw",
    exitingMotionStyles: "_y44v12ef _1bumglyw"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
var $efcedc65618db2dd$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
var $efcedc65618db2dd$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
var $efcedc65618db2dd$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
var $efcedc65618db2dd$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk _sedtglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk _1bumglyw",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $efcedc65618db2dd$var$TagNewComponent = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, trailingMetric = _ref.trailingMetric, other = (0, $gnQ3X.default)(_ref, $efcedc65618db2dd$var$_excluded);
    var normalizedText = (0, $cErYX.getTagText)(text);
    var _useTagRemoval = (0, $kecTg.useTagRemoval)(onBeforeRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var onShrinkOutExitComplete = (0, $1oC0p.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    var _useLink = (0, $0POMQ.useLink)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $dvm1o.useButtonInteraction)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $f7JWn.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var isMotionEnabled = (0, $6ur0l.fg)('platform-dst-motion-uplift-labels');
    var renderTagContent = function renderTagContent(tagRef) {
        var isEntering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isExiting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return /*#__PURE__*/ $1oC0p.createElement("span", (0, $c9bqK.default)({}, other, {
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $2jatx.default)([
                $efcedc65618db2dd$var$styles.baseStyles,
                !hasMargin && $efcedc65618db2dd$var$styles.noMarginStyles,
                $efcedc65618db2dd$var$colorStyles[color],
                $efcedc65618db2dd$var$borderIconFilterStyles.root,
                isLink && $efcedc65618db2dd$var$styles.interactiveBaseStyles,
                isLink && $efcedc65618db2dd$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $efcedc65618db2dd$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $efcedc65618db2dd$var$styles.activeMotionStyles,
                isEntering && $efcedc65618db2dd$var$styles.enteringMotionStyles,
                isExiting && $efcedc65618db2dd$var$styles.exitingMotionStyles,
                isLink && isLinkHovered && !isOverButton && $efcedc65618db2dd$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $efcedc65618db2dd$var$styles.interactiveHoverStyles,
                isRemovable && $efcedc65618db2dd$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $efcedc65618db2dd$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== '' && $efcedc65618db2dd$var$styles.trailingMetricEndPadding
            ])
        }), /*#__PURE__*/ $1oC0p.createElement((0, $gi6hM.LinkWrapper), {
            isLink: isLink,
            href: href,
            LinkComponent: LinkComponent,
            testId: testId,
            linkHandlers: linkHandlers,
            onClick: onClick
        }, /*#__PURE__*/ $1oC0p.createElement((0, $f2xys.default), {
            colorKey: color,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        }), elemBefore && /*#__PURE__*/ $1oC0p.createElement("span", {
            className: (0, $2jatx.default)([
                $efcedc65618db2dd$var$styles.beforeStyles
            ])
        }, elemBefore), /*#__PURE__*/ $1oC0p.createElement("span", {
            "data-tag-text": true,
            className: (0, $2jatx.default)([
                $efcedc65618db2dd$var$styles.textStyles
            ])
        }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $1oC0p.createElement("span", {
            "data-testid": testId && "".concat(testId, "--metric"),
            className: (0, $2jatx.default)([
                $efcedc65618db2dd$var$styles.trailingMetric
            ])
        }, trailingMetric)), removeButton && /*#__PURE__*/ $1oC0p.createElement("span", {
            className: (0, $2jatx.default)([
                $efcedc65618db2dd$var$styles.afterStyles,
                isMotionEnabled && $efcedc65618db2dd$var$styles.afterMotionStyles
            ])
        }, !isExiting && removeButton));
    };
    if (isMotionEnabled) return /*#__PURE__*/ $1oC0p.createElement((0, $ehNeI.TagMotion), {
        forwardedRef: ref,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status
    }, function(_ref2) {
        var isEntering = _ref2.isEntering, isExiting = _ref2.isExiting, motionRef = _ref2.ref;
        return renderTagContent(motionRef, isEntering, isExiting);
    });
    return /*#__PURE__*/ $1oC0p.createElement((0, $aplsu.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, renderTagContent(ref));
});
var $efcedc65618db2dd$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TagDropdownTrigger(_ref3, ref) {
    var _ref3$color = _ref3.color, color = _ref3$color === void 0 ? 'gray' : _ref3$color, text = _ref3.text, elemBefore = _ref3.elemBefore, testId = _ref3.testId, maxWidth = _ref3.maxWidth, _ref3$hasMargin = _ref3.hasMargin, hasMargin = _ref3$hasMargin === void 0 ? true : _ref3$hasMargin, onClick = _ref3.onClick, _ref3$isSelected = _ref3.isSelected, isSelected = _ref3$isSelected === void 0 ? false : _ref3$isSelected, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, _analyticsContext = _ref3.analyticsContext, _ref3$hasChevron = _ref3.hasChevron, hasChevron = _ref3$hasChevron === void 0 ? true : _ref3$hasChevron, swatchBefore = _ref3.swatchBefore, swatchBeforeLabel = _ref3.swatchBeforeLabel, swatchBeforeRole = _ref3.swatchBeforeRole, trailingMetric = _ref3.trailingMetric, other = (0, $gnQ3X.default)(_ref3, $efcedc65618db2dd$var$_excluded2);
    var resolvedColor = (0, $h7wWy.colorMapping)[color] || 'gray';
    var isMotionEnabled = (0, $6ur0l.fg)('platform-dst-motion-uplift-labels');
    return /*#__PURE__*/ $1oC0p.createElement((0, $eowPk.Pressable), (0, $c9bqK.default)({
        ref: ref,
        xcss: (0, $3sHnI.cx)($efcedc65618db2dd$var$styles.baseStyles, !hasMargin && $efcedc65618db2dd$var$styles.noMarginStyles, $efcedc65618db2dd$var$colorStyles[resolvedColor], $efcedc65618db2dd$var$borderIconFilterStyles.root, $efcedc65618db2dd$var$dropdownStyles.interactive, $efcedc65618db2dd$var$styles.focusRingStyles, $efcedc65618db2dd$var$borderIconInteractiveFilterStyles.root, isSelected && $efcedc65618db2dd$var$dropdownStyles.selected, isMotionEnabled && $efcedc65618db2dd$var$styles.interactiveMotionStyles, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $efcedc65618db2dd$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        testId: testId
    }, other), /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            $efcedc65618db2dd$var$dropdownStyles.content,
            isMotionEnabled && $efcedc65618db2dd$var$dropdownStyles.loadingMotion,
            isLoading && $efcedc65618db2dd$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $f2xys.default), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    }), elemBefore && /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            $efcedc65618db2dd$var$styles.beforeStyles,
            isSelected && $efcedc65618db2dd$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-tag-text": true,
        className: (0, $2jatx.default)([
            $efcedc65618db2dd$var$styles.textStyles,
            isSelected && $efcedc65618db2dd$var$styles.textStylesSelected
        ])
    }, (0, $cErYX.getTagText)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $2jatx.default)([
            $efcedc65618db2dd$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            $efcedc65618db2dd$var$dropdownStyles.loadingOverlay,
            isMotionEnabled && $efcedc65618db2dd$var$dropdownStyles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $lqlBg.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $efcedc65618db2dd$var$TagNew = (0, $F5ucT.markAsTagMotionCapable)(/*#__PURE__*/ (0, $1oC0p.memo)($efcedc65618db2dd$var$TagNewComponent));
var $efcedc65618db2dd$export$2e2bcd8739ae039 = $efcedc65618db2dd$var$TagNew;

});
parcelRegister("cErYX", function(module, exports) {
$parcel$export(module.exports, "getTagText", function () { return $935eed26c37afdd2$export$7d100de1166870f6; });
// Intentionally scoped to the UI-uplifted TagNew implementation.
var $935eed26c37afdd2$export$7d100de1166870f6 = function getTagText(text) {
    return Array.isArray(text) ? text.join('') : text;
};

});

parcelRegister("gi6hM", function(module, exports) {
$parcel$export(module.exports, "LinkWrapper", function () { return $bdc333fb288b6118$export$ce4b6a469c26f53f; });

var $1oC0p = parcelRequire("1oC0p");
function $bdc333fb288b6118$export$ce4b6a469c26f53f(_ref) {
    var isLink = _ref.isLink, href = _ref.href, LinkComponent = _ref.LinkComponent, testId = _ref.testId, children = _ref.children, onClick = _ref.onClick, linkHandlers = _ref.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children);
}

});

parcelRegister("aplsu", function(module, exports) {
$parcel$export(module.exports, "RemovableWrapper", function () { return $793ce269e6b7a218$export$898a500849bb5cf4; });
/* removable-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bbU2S = parcelRequire("bbU2S");

var $hh9uA = parcelRequire("hh9uA");

var $kTGm7 = parcelRequire("kTGm7");
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var $793ce269e6b7a218$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var $793ce269e6b7a218$var$motionWrapperStyles = null;
function $793ce269e6b7a218$export$898a500849bb5cf4(_ref) {
    var isRemovable = _ref.isRemovable, status = _ref.status, onShrinkOutExitComplete = _ref.onShrinkOutExitComplete, children = _ref.children;
    if (isRemovable) return /*#__PURE__*/ $1oC0p.createElement((0, $bbU2S.default), null, !(status === (0, $kTGm7.TagStatus).Removed) && /*#__PURE__*/ $1oC0p.createElement((0, $hh9uA.default), {
        key: $793ce269e6b7a218$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? function(phase) {
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, function(motion) {
        return /*#__PURE__*/ $1oC0p.createElement("span", {
            ref: motion.ref,
            className: (0, $2jatx.default)([
                "_1e0c116y"
            ])
        }, children);
    }));
    return children;
}

});
parcelRegister("bbU2S", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", function () { return $825c32420808eff2$export$b9c4904d7a6929e6; });
$parcel$export(module.exports, "default", function () { return $825c32420808eff2$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $825c32420808eff2$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $825c32420808eff2$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $1oC0p.createContext)($825c32420808eff2$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $825c32420808eff2$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $825c32420808eff2$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($825c32420808eff2$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $825c32420808eff2$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1oC0p.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $825c32420808eff2$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $825c32420808eff2$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $825c32420808eff2$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $825c32420808eff2$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $825c32420808eff2$var$ExitingPersistence = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $1oC0p.useState)([
        null,
        children
    ]), _useState2 = (0, $2qaZZ.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)([]), _useState4 = (0, $2qaZZ.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $1oC0p.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $2qaZZ.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $825c32420808eff2$var$childrenToArray(previousChildren);
    var current = $825c32420808eff2$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $825c32420808eff2$var$childrenToArray(children) : current;
    var missingKeys = $825c32420808eff2$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $825c32420808eff2$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $6ur0l.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $825c32420808eff2$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $825c32420808eff2$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$825c32420808eff2$export$2e2bcd8739ae039 = $825c32420808eff2$var$ExitingPersistence;
$825c32420808eff2$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("hh9uA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c93b6328e59771ae$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1mO61 = parcelRequire("1mO61");

var $io7gh = parcelRequire("io7gh");

var $g1BIN = parcelRequire("g1BIN");

var $gSu9v = parcelRequire("gSu9v");

var $dqrRv = parcelRequire("dqrRv");

var $jtmmM = parcelRequire("jtmmM");

var $fMtAl = parcelRequire("fMtAl");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $c93b6328e59771ae$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $g1BIN.useElementRef)(), _useElementRef2 = (0, $2qaZZ.default)(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $fMtAl.useExitingPersistence)();
    var requestAnimationFrame = (0, $dqrRv.useRequestAnimationFrame)();
    var setTimeout = (0, $jtmmM.useSetTimeout)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $gSu9v.useLayoutEffect)(function() {
        if (exiting.isExiting && element) {
            if ((0, $io7gh.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $1mO61.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $1mO61.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $c93b6328e59771ae$export$2e2bcd8739ae039 = $c93b6328e59771ae$var$ShrinkOut;

});
parcelRegister("1mO61", function(module, exports) {
$parcel$export(module.exports, "durations", function () { return $0feeb48ee7eff369$export$38b928a7167ce124; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $0feeb48ee7eff369$export$368bacef0dacbe05 = 25;
var $0feeb48ee7eff369$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("io7gh", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $d63019dfddce9897$export$b7baf7667a68d87c; });

var $5EI9q = parcelRequire("5EI9q");
var $d63019dfddce9897$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $5EI9q.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("5EI9q", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", function () { return $41e2efa324238d96$export$c5406bd59b374abd; });
var $41e2efa324238d96$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("g1BIN", function(module, exports) {
$parcel$export(module.exports, "useElementRef", function () { return $baaa000c564cea0a$export$ff879f35a69d56b7; });

var $1oC0p = parcelRequire("1oC0p");
var $baaa000c564cea0a$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $1oC0p.useRef)(null);
    var setRef = (0, $1oC0p.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("gSu9v", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $c4991416c58c0c56$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $c4991416c58c0c56$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("dqrRv", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", function () { return $9c6350de5815694b$export$1775f27e7c8051ca; });

var $1oC0p = parcelRequire("1oC0p");
var $9c6350de5815694b$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $9c6350de5815694b$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9c6350de5815694b$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("jtmmM", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", function () { return $e2d2134617683088$export$4f34107a2b00f39c; });

var $1oC0p = parcelRequire("1oC0p");
// Handle both browser and Node.js environments
var $e2d2134617683088$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $e2d2134617683088$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $e2d2134617683088$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("fMtAl", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", function () { return $b7d249bac52c182d$export$3b6f38abbdcbd000; });

var $1oC0p = parcelRequire("1oC0p");

var $bbU2S = parcelRequire("bbU2S");
var $b7d249bac52c182d$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1oC0p.useContext)((0, $bbU2S.ExitingContext));
};

});


parcelRegister("kTGm7", function(module, exports) {
$parcel$export(module.exports, "TagStatus", function () { return $f369ccaf26087882$export$74452314b63acabc; });
// Tag status enum
var $f369ccaf26087882$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

});


parcelRegister("F5ucT", function(module, exports) {
$parcel$export(module.exports, "markAsTagMotionCapable", function () { return $07b815e5a1d544b1$export$88b132e52a65ec37; });
var $07b815e5a1d544b1$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
function $07b815e5a1d544b1$export$88b132e52a65ec37(component) {
    Object.defineProperty(component, $07b815e5a1d544b1$var$tagMotionCapability, {
        value: true
    });
    return component;
}

});

parcelRegister("f2xys", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af311236e2b374fb$export$2e2bcd8739ae039; });
/* swatch-before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $af311236e2b374fb$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $af311236e2b374fb$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $af311236e2b374fb$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $1oC0p.createElement("span", (0, $c9bqK.default)({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        className: (0, $2jatx.default)([
            $af311236e2b374fb$var$tagSwatchBeforeStyles.swatch,
            $af311236e2b374fb$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    }));
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $c9bqK.default)({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $2jatx.default)([
            $af311236e2b374fb$var$tagSwatchBeforeStyles.swatch
        ])
    }));
}

});

parcelRegister("ehNeI", function(module, exports) {
$parcel$export(module.exports, "TagMotion", function () { return $a668d8879b00dcee$export$6adae1772ccf137c; });
/* tag-motion.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");


var $kPutE = parcelRequire("kPutE");

var $io7gh = parcelRequire("io7gh");

var $bbU2S = parcelRequire("bbU2S");

var $fMtAl = parcelRequire("fMtAl");

var $8iCE7 = parcelRequire("8iCE7");

var $kTGm7 = parcelRequire("kTGm7");
var $a668d8879b00dcee$var$tagMotionKey = 'atlaskit-tag-motion';
function $a668d8879b00dcee$var$TagMotionContent(_ref) {
    var children = _ref.children, forwardedRef = _ref.forwardedRef, onExitComplete = _ref.onExitComplete;
    var _useMotion = (0, $8iCE7.useMotion)({
        onFinish: function onFinish(phase) {
            if (phase === 'exiting') onExitComplete === null || onExitComplete === void 0 || onExitComplete();
        }
    }), motionRef = _useMotion.ref, state = _useMotion.state;
    var mergedRef = (0, $1oC0p.useMemo)(function() {
        return (0, $kPutE.default)([
            forwardedRef,
            motionRef
        ]);
    }, [
        forwardedRef,
        motionRef
    ]);
    return children({
        isEntering: state === 'entering',
        isExiting: state === 'exiting',
        ref: mergedRef
    });
}
function $a668d8879b00dcee$export$6adae1772ccf137c(_ref2) {
    var children = _ref2.children, forwardedRef = _ref2.forwardedRef, onExitComplete = _ref2.onExitComplete, status = _ref2.status;
    var hasCompletedReducedMotionExit = (0, $1oC0p.useRef)(false);
    var outerPresence = (0, $fMtAl.useExitingPersistence)();
    var isRemoved = status === (0, $kTGm7.TagStatus).Removed || outerPresence.isExiting;
    var shouldAppear = outerPresence.isInsideExitingPersistence && outerPresence.appear && !outerPresence.isExiting;
    var latestExitState = (0, $1oC0p.useRef)({
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    });
    latestExitState.current = {
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    };
    var onMotionExitComplete = (0, $1oC0p.useCallback)(function() {
        var latest = latestExitState.current;
        if (latest.outerPresence.isExiting) {
            var _latest$outerPresence, _latest$outerPresence2;
            (_latest$outerPresence = (_latest$outerPresence2 = latest.outerPresence).onFinish) === null || _latest$outerPresence === void 0 || _latest$outerPresence.call(_latest$outerPresence2);
        }
        if (latest.status === (0, $kTGm7.TagStatus).Removed) {
            var _latest$onExitComplet;
            (_latest$onExitComplet = latest.onExitComplete) === null || _latest$onExitComplet === void 0 || _latest$onExitComplet.call(latest);
        }
    }, []);
    (0, $1oC0p.useEffect)(function() {
        if (isRemoved && (0, $io7gh.isReducedMotion)() && !hasCompletedReducedMotionExit.current) {
            hasCompletedReducedMotionExit.current = true;
            onMotionExitComplete();
        }
    }, [
        isRemoved,
        onMotionExitComplete
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $bbU2S.default), {
        appear: shouldAppear
    }, !isRemoved && /*#__PURE__*/ $1oC0p.createElement($a668d8879b00dcee$var$TagMotionContent, {
        key: $a668d8879b00dcee$var$tagMotionKey,
        forwardedRef: forwardedRef,
        onExitComplete: onMotionExitComplete
    }, children));
}

});
parcelRegister("8iCE7", function(module, exports) {
$parcel$export(module.exports, "useMotion", function () { return $60adfb7d6bcf8fc3$export$2a51cfe9390d36ef; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $kPutE = parcelRequire("kPutE");

var $gIuc3 = parcelRequire("gIuc3");

var $3DRfE = parcelRequire("3DRfE");

var $io7gh = parcelRequire("io7gh");

var $gSu9v = parcelRequire("gSu9v");

var $hF1i3 = parcelRequire("hF1i3");

var $iBd17 = parcelRequire("iBd17");

var $fMtAl = parcelRequire("fMtAl");

var $kvqRa = parcelRequire("kvqRa");
function $60adfb7d6bcf8fc3$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, onStartMotion = _ref.onStart, initialState = _ref.initialState;
    var reducedMotion = (0, $io7gh.isReducedMotion)();
    var staggered = (0, $kvqRa.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $fMtAl.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $1oC0p.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    var motionState = isExiting ? 'exiting' : state;
    var elementRef = (0, $1oC0p.useRef)(null);
    var onStartMotionRef = (0, $1oC0p.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    var reanimateRef = (0, $1oC0p.useRef)();
    var animationRef = (0, $1oC0p.useRef)();
    var staggeredEntryRef = (0, $1oC0p.useRef)();
    (0, $gSu9v.useLayoutEffect)(function() {
        if (motionState === 'exiting') {
            var _onStartMotionRef$cur;
            (_onStartMotionRef$cur = onStartMotionRef.current) === null || _onStartMotionRef$cur === void 0 || _onStartMotionRef$cur.call(onStartMotionRef, 'exiting');
        }
        if (motionState === 'entering') {
            var _onStartMotionRef$cur2;
            (_onStartMotionRef$cur2 = onStartMotionRef.current) === null || _onStartMotionRef$cur2 === void 0 || _onStartMotionRef$cur2.call(onStartMotionRef, 'entering');
        }
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $1oC0p.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $iBd17.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $iBd17.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $iBd17.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $iBd17.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $1oC0p.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $3DRfE.getDurationMs)((0, $hF1i3.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $gIuc3.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $1oC0p.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $iBd17.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $iBd17.Reanimate).enter) setState('entering');
        else if (value === (0, $iBd17.Reanimate).exit) setState('exiting');
    }, []);
    var ref = (0, $1oC0p.useMemo)(function() {
        return (0, $kPutE.default)([
            staggered.ref,
            elementRef
        ]);
    }, [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});
parcelRegister("gIuc3", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", function () { return $c2b82d2d93ff0b53$export$dd9b73a7482d05b6; });

var $iXBf8 = parcelRequire("iXBf8");
var $c2b82d2d93ff0b53$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $c2b82d2d93ff0b53$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $c2b82d2d93ff0b53$var$toTimeList = function toTimeList(value) {
    return $c2b82d2d93ff0b53$var$toCssList(value).filter(function(time) {
        return $c2b82d2d93ff0b53$var$cssTimePattern.test(time);
    }).map((0, $iXBf8.convertToMs));
};
var $c2b82d2d93ff0b53$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $c2b82d2d93ff0b53$var$toCssList(animationName);
    var durations = $c2b82d2d93ff0b53$var$toTimeList(animationDuration);
    var delays = $c2b82d2d93ff0b53$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("iXBf8", function(module, exports) {
$parcel$export(module.exports, "convertToMs", function () { return $dcdaa0605081dab8$export$75eee42ff540d8ae; });
var $dcdaa0605081dab8$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("3DRfE", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", function () { return $2a6e523d0427f2cb$export$d0038b6e47881463; });

var $lFOXD = parcelRequire("lFOXD");
var $2a6e523d0427f2cb$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, $lFOXD.default)(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("hF1i3", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", function () { return $cdb7443b94133b40$export$82b92541889a035d; });

var $3lxT5 = parcelRequire("3lxT5");
var $cdb7443b94133b40$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $3lxT5.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});
parcelRegister("3lxT5", function(module, exports) {
$parcel$export(module.exports, "getDocument", function () { return $26fd9e980ff04c3d$export$f65ca476c09acec0; });
var $26fd9e980ff04c3d$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("iBd17", function(module, exports) {
$parcel$export(module.exports, "Reanimate", function () { return $d8a5c7a0aec5076a$export$569340a66b14e0dc; });
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $d8a5c7a0aec5076a$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("kvqRa", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", function () { return $eedb89088f58c673$export$25c7213fc07ec080; });

var $1oC0p = parcelRequire("1oC0p");

var $aLFS8 = parcelRequire("aLFS8");

var $7tMj5 = parcelRequire("7tMj5");
var $eedb89088f58c673$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $aLFS8.useUniqueId)();
    var context = (0, $1oC0p.useContext)((0, $7tMj5.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("aLFS8", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", function () { return $7d6ec620ea59c92d$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1oC0p = parcelRequire("1oC0p");
function $7d6ec620ea59c92d$export$c485849f2e393253() {
    var identifier = (0, $1oC0p.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("7tMj5", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", function () { return $5720b693696030e1$export$5e65d7d58ae96ad8; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $gSu9v = parcelRequire("gSu9v");
var $5720b693696030e1$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $7uNuF.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $5720b693696030e1$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1oC0p.useRef)([]);
    var indexes = [];
    var _useState = (0, $1oC0p.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $2qaZZ.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $gSu9v.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($5720b693696030e1$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5720b693696030e1$export$2e2bcd8739ae039 = $5720b693696030e1$var$StaggeredEntrance;

});




parcelRegister("dvm1o", function(module, exports) {
$parcel$export(module.exports, "useButtonInteraction", function () { return $9d4f40994650acbe$export$84acd183858d8235; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $9d4f40994650acbe$export$84acd183858d8235() {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isLinkHovered = _useState2[0], setIsLinkHovered = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $2qaZZ.default)(_useState3, 2), isOverButton = _useState4[0], setIsOverButton = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(false), _useState6 = (0, $2qaZZ.default)(_useState5, 2), isButtonFocused = _useState6[0], setIsButtonFocused = _useState6[1];
    var _useState7 = (0, $1oC0p.useState)(false), _useState8 = (0, $2qaZZ.default)(_useState7, 2), isLinkFocused = _useState8[0], setIsLinkFocused = _useState8[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $1oC0p.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $1oC0p.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $1oC0p.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}

});

parcelRegister("0POMQ", function(module, exports) {
$parcel$export(module.exports, "useLink", function () { return $00283234ae612103$export$dcf14c9974fe2767; });

var $aAFhS = parcelRequire("aAFhS");
function $00283234ae612103$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $aAFhS.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}

});
parcelRegister("aAFhS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b5d4af60109cd36$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $4ZpaI = parcelRequire("4ZpaI");

var $6ur0l = parcelRequire("6ur0l");

var $kbw6D = parcelRequire("kbw6D");
var $2sVl0 = parcelRequire("2sVl0");
var $7b5d4af60109cd36$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $7b5d4af60109cd36$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $7b5d4af60109cd36$var$iconStyles = null;
var $7b5d4af60109cd36$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, $gnQ3X.default)(_ref, $7b5d4af60109cd36$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement((0, $kbw6D.Anchor), (0, $c9bqK.default)({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $4ZpaI.cx)($7b5d4af60109cd36$var$styles.base, (0, $6ur0l.fg)('platform-dst-shape-theme-default') && $7b5d4af60109cd36$var$styles.baseT26Shape, appearance === 'default' && ((0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') ? $7b5d4af60109cd36$var$styles.defaultAppearanceMotion : $7b5d4af60109cd36$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') ? $7b5d4af60109cd36$var$styles.subtleAppearanceMotion : $7b5d4af60109cd36$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') ? $7b5d4af60109cd36$var$styles.inverseAppearanceMotion : $7b5d4af60109cd36$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7b5d4af60109cd36$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $1oC0p.createElement((0, $2sVl0.Box), {
        as: "span",
        xcss: $7b5d4af60109cd36$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $1oC0p.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $2jatx.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $7b5d4af60109cd36$var$Link = /*#__PURE__*/ (0, $1oC0p.forwardRef)($7b5d4af60109cd36$var$LinkWithoutRef);
var $7b5d4af60109cd36$export$2e2bcd8739ae039 = $7b5d4af60109cd36$var$Link;

});


parcelRegister("f7JWn", function(module, exports) {
$parcel$export(module.exports, "useRemoveButton", function () { return $b02b254773e4f83e$export$97d8be09cd53869b; });
/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kpZ3n = parcelRequire("kpZ3n");
function $b02b254773e4f83e$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $1oC0p.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $1oC0p.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $1oC0p.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kpZ3n.default), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}

});
parcelRegister("kpZ3n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edd58067d630d4e3$export$2e2bcd8739ae039; });
/* remove-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");


var $4ZpaI = parcelRequire("4ZpaI");

var $h6Fsc = parcelRequire("h6Fsc");

var $6ur0l = parcelRequire("6ur0l");

var $eowPk = parcelRequire("eowPk");
var $edd58067d630d4e3$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
var $edd58067d630d4e3$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $1oC0p.createElement((0, $eowPk.Pressable), {
        xcss: (0, $4ZpaI.cx)($edd58067d630d4e3$var$removeButtonStyles.root, shape === 'circle' && $edd58067d630d4e3$var$removeButtonStyles.circle, $edd58067d630d4e3$var$removeButtonStyles.newIcon, (0, $6ur0l.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && $edd58067d630d4e3$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$edd58067d630d4e3$export$2e2bcd8739ae039 = $edd58067d630d4e3$var$RemoveButton;

});


parcelRegister("kecTg", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", function () { return $eb9f1d36ce5b0fc3$export$f26019543e9f862f; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $lcVEa = parcelRequire("lcVEa");

var $kTGm7 = parcelRequire("kTGm7");
function $eb9f1d36ce5b0fc3$export$f26019543e9f862f(onBeforeRemoveAction) {
    var _useState = (0, $1oC0p.useState)((0, $kTGm7.TagStatus).Showing), _useState2 = (0, $2qaZZ.default)(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveRequest = (0, $1oC0p.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, $lcVEa.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $kTGm7.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $1oC0p.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $1oC0p.useCallback)(function() {
        return setStatus((0, $kTGm7.TagStatus).Removing);
    }, []);
    var showingTag = (0, $1oC0p.useCallback)(function() {
        return setStatus((0, $kTGm7.TagStatus).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}

});
parcelRegister("lcVEa", function(module, exports) {
$parcel$export(module.exports, "defaultBeforeRemoveAction", function () { return $f7076f6bcecda8ae$export$279e7025ed114474; });
var $f7076f6bcecda8ae$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};

});



parcelRegister("5XgGk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $455f671839f8bde6$export$2e2bcd8739ae039; });
/* base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $gnQ3X = parcelRequire("gnQ3X");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");
var $455f671839f8bde6$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $455f671839f8bde6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $455f671839f8bde6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $455f671839f8bde6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $455f671839f8bde6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $455f671839f8bde6$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $455f671839f8bde6$var$baseStyles = null;
var $455f671839f8bde6$var$interactiveStyles = null;
var $455f671839f8bde6$var$focusRingStyles = null;
var $455f671839f8bde6$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, $gnQ3X.default)(_ref, $455f671839f8bde6$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", (0, $c9bqK.default)({}, other, {
        ref: ref,
        style: $455f671839f8bde6$var$_objectSpread({}, style),
        className: (0, $2jatx.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $455f671839f8bde6$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$455f671839f8bde6$export$2e2bcd8739ae039 = $455f671839f8bde6$var$BaseTag;

});

parcelRegister("5qdE9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3f29f767118f2071$export$2e2bcd8739ae039; });
/* before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $3f29f767118f2071$var$beforeElementStyles = null;
var $3f29f767118f2071$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f29f767118f2071$export$2e2bcd8739ae039 = $3f29f767118f2071$var$Before;

});

parcelRegister("9cKes", function(module, exports) {
$parcel$export(module.exports, "getLozengeAppearance", function () { return $6b3918ce4e641165$export$4d9e331cafeacb9d; });
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $6b3918ce4e641165$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $6b3918ce4e641165$export$4d9e331cafeacb9d(color) {
    return $6b3918ce4e641165$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

});

parcelRegister("amWOS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $78c995cf9646177c$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cErYX = parcelRequire("cErYX");
var $78c995cf9646177c$var$baseStyles = null;
var $78c995cf9646177c$var$linkStyles = null;
var $78c995cf9646177c$var$hasAfterStyles = null;
var $78c995cf9646177c$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    var normalizedText = (0, $cErYX.getTagText)(text);
    if (href) return /*#__PURE__*/ $1oC0p.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $2jatx.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$78c995cf9646177c$export$2e2bcd8739ae039 = $78c995cf9646177c$var$Content;

});


parcelRegister("fK1fu", function(module, exports) {
$parcel$export(module.exports, "EngineeringAvatar", function () { return $59470e2d827d1713$export$ce8fb54f2ea3b8ce; });

var $7VQPk = parcelRequire("7VQPk");

var $fiTNr = parcelRequire("fiTNr");

var $e1eut = parcelRequire("e1eut");

var $7fh9b = parcelRequire("7fh9b");

var $guyZN = parcelRequire("guyZN");

var $kt1hq = parcelRequire("kt1hq");

var $ex7BS = parcelRequire("ex7BS");

var $iSrk8 = parcelRequire("iSrk8");

var $eVmtq = parcelRequire("eVmtq");
const $59470e2d827d1713$var$avatarUrls = {
    'Issac Varghese': (0, (/*@__PURE__*/$parcel$interopDefault($e1eut))),
    'Jordan Ellis': (0, (/*@__PURE__*/$parcel$interopDefault($7fh9b))),
    'Kayla Parajuli': (0, (/*@__PURE__*/$parcel$interopDefault($guyZN))),
    'Laila Ali': (0, (/*@__PURE__*/$parcel$interopDefault($kt1hq))),
    'Priya Hansra': (0, (/*@__PURE__*/$parcel$interopDefault($ex7BS))),
    'Raul Gonzalez': (0, (/*@__PURE__*/$parcel$interopDefault($iSrk8))),
    'Robi Lopez': (0, (/*@__PURE__*/$parcel$interopDefault($eVmtq)))
};
const $59470e2d827d1713$export$ce8fb54f2ea3b8ce = ({ name: name })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $fiTNr.default), {
        name: name,
        size: "small",
        src: $59470e2d827d1713$var$avatarUrls[name]
    });

});
parcelRegister("e1eut", function(module, exports) {
module.exports = new URL("issac-varghese--color--product-purple.a4368a72.svg", import.meta.url).toString();

});

parcelRegister("7fh9b", function(module, exports) {
module.exports = new URL("jordan--color--dev-lime.08e8e8d4.svg", import.meta.url).toString();

});

parcelRegister("guyZN", function(module, exports) {
module.exports = new URL("kayla-parajuli--color--teamwork-blue.0ccd5e75.svg", import.meta.url).toString();

});

parcelRegister("kt1hq", function(module, exports) {
module.exports = new URL("laila-ali--color--service-yellow.d33a2538.svg", import.meta.url).toString();

});

parcelRegister("ex7BS", function(module, exports) {
module.exports = new URL("priya-hansra--color--teamwork-blue.4f1e4341.svg", import.meta.url).toString();

});

parcelRegister("iSrk8", function(module, exports) {
module.exports = new URL("raul-gonzalez--color--dev-lime.d5cc25d2.svg", import.meta.url).toString();

});

parcelRegister("eVmtq", function(module, exports) {
module.exports = new URL("robi-lopez--color--service-yellow.b854034d.svg", import.meta.url).toString();

});


parcelRegister("b7CRq", function(module, exports) {
$parcel$export(module.exports, "EngineeringRequestTypeIcon", function () { return $f3b2be7299e7befd$export$f3241c039683ff81; });
$parcel$export(module.exports, "EngineeringPriorityIcon", function () { return $f3b2be7299e7befd$export$a20ef842ceeb1f13; });
$parcel$export(module.exports, "EngineeringSlaTag", function () { return $f3b2be7299e7befd$export$8da6ba192a1b8e9; });
/* jsm-playground-engineering-marks.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $ktqe1 = parcelRequire("ktqe1");

var $hrBjL = parcelRequire("hrBjL");

var $cybEc = parcelRequire("cybEc");

var $93qRN = parcelRequire("93qRN");

var $cNamI = parcelRequire("cNamI");

var $2vv6G = parcelRequire("2vv6G");

var $illxj = parcelRequire("illxj");

var $fxjaL = parcelRequire("fxjaL");

var $agfYy = parcelRequire("agfYy");

var $4UIef = parcelRequire("4UIef");

var $jXNsd = parcelRequire("jXNsd");

var $hoqkG = parcelRequire("hoqkG");

var $4jcRW = parcelRequire("4jcRW");

var $a6eKS = parcelRequire("a6eKS");

var $dXWnS = parcelRequire("dXWnS");
const $f3b2be7299e7befd$var$requestTypeConfig = {
    bug: (0, (/*@__PURE__*/$parcel$interopDefault($ktqe1))),
    feature: (0, (/*@__PURE__*/$parcel$interopDefault($cNamI))),
    support: (0, (/*@__PURE__*/$parcel$interopDefault($jXNsd))),
    system: (0, (/*@__PURE__*/$parcel$interopDefault($93qRN)))
};
const $f3b2be7299e7befd$export$f3241c039683ff81 = ({ size: size = 'small', type: type })=>{
    const Icon = $f3b2be7299e7befd$var$requestTypeConfig[type];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "data-testid": `engineering-request-type-${type}`,
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o",
            "_1o9zidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)(Icon, {
            color: "var(--ds-icon-subtle, #505258)",
            label: "",
            size: size
        })
    });
};
const $f3b2be7299e7befd$var$priorityConfig = {
    Highest: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($illxj))),
        color: "var(--ds-icon-danger, #C9372C)"
    },
    High: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2vv6G))),
        color: "var(--ds-icon-danger, #C9372C)"
    },
    Medium: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4UIef))),
        color: "var(--ds-icon-warning, #E06C00)"
    },
    Low: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxjaL))),
        color: "var(--ds-icon-information, #357DE8)"
    },
    Lowest: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($agfYy))),
        color: "var(--ds-icon-information, #357DE8)"
    }
};
const $f3b2be7299e7befd$export$a20ef842ceeb1f13 = ({ priority: priority })=>{
    const intl = (0, $8e22h.default)();
    const config = $f3b2be7299e7befd$var$priorityConfig[priority];
    const Icon = config.icon;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-label": intl.formatMessage((0, $dXWnS.engineeringMessages).priorityIconLabel, {
            priority: intl.formatMessage((0, $a6eKS.ENGINEERING_PRIORITY_LABELS)[priority])
        }),
        role: "img",
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)(Icon, {
            color: config.color,
            label: "",
            size: "small"
        })
    });
};
const $f3b2be7299e7befd$var$inlineFlexCenterStyles = null;
const $f3b2be7299e7befd$export$8da6ba192a1b8e9 = ({ isLoading: isLoading = false, row: row })=>{
    const intl = (0, $8e22h.default)();
    const isBreached = row.slaTone === 'breached';
    const iconColor = isBreached ? "var(--ds-icon-inverse, #FFFFFF)" : row.slaTone === 'met' ? "var(--ds-icon-success, #6A9A23)" : "var(--ds-icon-subtle, #505258)";
    const Icon = row.slaTone === 'met' ? (0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))) : row.slaTone === 'paused' ? (0, (/*@__PURE__*/$parcel$interopDefault($hoqkG))) : (0, (/*@__PURE__*/$parcel$interopDefault($cybEc)));
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4t3i1ejb _4cvr1h6o _zulp1b66 _18zru2gc _2rko1rr0 _bfhkysee _syazazsu _11c8fhey _k48p1wq8 _o5721q9c",
            isBreached && "_bfhkybec _syaz15cr"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)(Icon, {
                color: iconColor,
                label: "",
                size: "small"
            }),
            isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                borderRadius: "var(--ds-radius-xsmall, 2px)",
                height: 10,
                width: 104
            }) : intl.formatMessage(row.sla)
        ]
    });
};
const $f3b2be7299e7befd$var$requestTypeStyles = null;
const $f3b2be7299e7befd$var$slaTagStyles = null;
const $f3b2be7299e7befd$var$breachedSlaTagStyles = null;

});
parcelRegister("93qRN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::621a068ba1a664cb6c4f35ce5ba4a899>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69793c0a55888002$var$_react = $69793c0a55888002$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $69793c0a55888002$var$_baseNew = $69793c0a55888002$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $69793c0a55888002$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExclamationSquare".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Exclamation work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $69793c0a55888002$var$ExclamationSquareIcon = (props)=>/*#__PURE__*/ $69793c0a55888002$var$_react.default.createElement($69793c0a55888002$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM8.75 4v5h-1.5V4zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$69793c0a55888002$var$ExclamationSquareIcon.displayName = 'ExclamationSquareIcon';
var $69793c0a55888002$var$_default = module.exports.default = $69793c0a55888002$var$ExclamationSquareIcon;

});

parcelRegister("2vv6G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd64b41739e4b5a1ac8c09f1bbfed3e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d369b2aabf5573d$var$_react = $1d369b2aabf5573d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1d369b2aabf5573d$var$_baseNew = $1d369b2aabf5573d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $1d369b2aabf5573d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityHigh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for high work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d369b2aabf5573d$var$PriorityHighIcon = (props)=>/*#__PURE__*/ $1d369b2aabf5573d$var$_react.default.createElement($1d369b2aabf5573d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 9.25-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353z"/>`
    }, props));
$1d369b2aabf5573d$var$PriorityHighIcon.displayName = 'PriorityHighIcon';
var $1d369b2aabf5573d$var$_default = module.exports.default = $1d369b2aabf5573d$var$PriorityHighIcon;

});

parcelRegister("illxj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f7f41401ecfb3069835afe67e33c1e88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5aae4cda28ec374$var$_react = $d5aae4cda28ec374$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d5aae4cda28ec374$var$_baseNew = $d5aae4cda28ec374$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $d5aae4cda28ec374$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityHighest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for highest work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5aae4cda28ec374$var$PriorityHighestIcon = (props)=>/*#__PURE__*/ $d5aae4cda28ec374$var$_react.default.createElement($d5aae4cda28ec374$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 6.75-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625L2.913 8 8 4.65 13.087 8zm0 4.5-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.624.826 1.252L8 9.15l5.087 3.353z"/>`
    }, props));
$d5aae4cda28ec374$var$PriorityHighestIcon.displayName = 'PriorityHighestIcon';
var $d5aae4cda28ec374$var$_default = module.exports.default = $d5aae4cda28ec374$var$PriorityHighestIcon;

});

parcelRegister("fxjaL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0a790d91d8a02a088319fd35139d8a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4f8cf5786e19161$var$_react = $b4f8cf5786e19161$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b4f8cf5786e19161$var$_baseNew = $b4f8cf5786e19161$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $b4f8cf5786e19161$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityLow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for low work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4f8cf5786e19161$var$PriorityLowIcon = (props)=>/*#__PURE__*/ $b4f8cf5786e19161$var$_react.default.createElement($b4f8cf5786e19161$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 7.251-5.5 3.625a.75.75 0 0 1-.826 0l-5.5-3.625.826-1.252L8 9.352l5.087-3.353z"/>`
    }, props));
$b4f8cf5786e19161$var$PriorityLowIcon.displayName = 'PriorityLowIcon';
var $b4f8cf5786e19161$var$_default = module.exports.default = $b4f8cf5786e19161$var$PriorityLowIcon;

});

parcelRegister("agfYy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db2c7aa1b630cb99a798af669bcbc383>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7787ca7249dc0d64$var$_react = $7787ca7249dc0d64$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7787ca7249dc0d64$var$_baseNew = $7787ca7249dc0d64$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7787ca7249dc0d64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityLowest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for lowest work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7787ca7249dc0d64$var$PriorityLowestIcon = (props)=>/*#__PURE__*/ $7787ca7249dc0d64$var$_react.default.createElement($7787ca7249dc0d64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 9.251-5.5 3.625a.75.75 0 0 1-.826 0l-5.5-3.625.826-1.252L8 11.352l5.087-3.353zm0-4.5-5.5 3.625a.75.75 0 0 1-.826 0l-5.5-3.625.826-1.252L8 6.852l5.087-3.353z"/>`
    }, props));
$7787ca7249dc0d64$var$PriorityLowestIcon.displayName = 'PriorityLowestIcon';
var $7787ca7249dc0d64$var$_default = module.exports.default = $7787ca7249dc0d64$var$PriorityLowestIcon;

});

parcelRegister("4UIef", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8d7d06aafd80a5763505502d0e6cf1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $393eb3528fcccd74$var$_react = $393eb3528fcccd74$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $393eb3528fcccd74$var$_baseNew = $393eb3528fcccd74$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $393eb3528fcccd74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for medium work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $393eb3528fcccd74$var$PriorityMediumIcon = (props)=>/*#__PURE__*/ $393eb3528fcccd74$var$_react.default.createElement($393eb3528fcccd74$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 9.5V11H2V9.5zM14 5v1.5H2V5z"/>`
    }, props));
$393eb3528fcccd74$var$PriorityMediumIcon.displayName = 'PriorityMediumIcon';
var $393eb3528fcccd74$var$_default = module.exports.default = $393eb3528fcccd74$var$PriorityMediumIcon;

});

parcelRegister("jXNsd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7a13f46e9c312b11d97e22779cf7962>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e889e38d3b71ffd5$var$_react = $e889e38d3b71ffd5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e889e38d3b71ffd5$var$_baseNew = $e889e38d3b71ffd5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $e889e38d3b71ffd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tools".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'Service request' Jira work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e889e38d3b71ffd5$var$ToolsIcon = (props)=>/*#__PURE__*/ $e889e38d3b71ffd5$var$_react.default.createElement($e889e38d3b71ffd5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 5q0-.093-.006-.185L12.78 6.53a.75.75 0 0 1-1.004.052l-.056-.052-2.25-2.25a.75.75 0 0 1 0-1.06l1.714-1.715a3.5 3.5 0 0 0-3.406 4.864.75.75 0 0 1-.16.823l-5.829 5.83a.84.84 0 0 0 0 1.189l.064.058c.33.27.818.25 1.126-.058l5.74-5.741.088-.088.086-.073a.75.75 0 0 1 .738-.086 3.5 3.5 0 0 0 1.773.254l.162-.023A3.5 3.5 0 0 0 14.5 5m-5.43 5.241 3.97 3.97a.841.841 0 0 0 1.189-1.19L11.2 9.994q-.1.005-.2.006a5 5 0 0 1-1.47-.22zM1.662 1.896l.799 1.586H3.5V2.464l-1.602-.802zM16 5a5 5 0 0 1-3.062 4.61l2.351 2.35a2.34 2.34 0 0 1-3.31 3.311l-3.97-3.97-3.97 3.97a2.34 2.34 0 0 1-3.133.162L.73 15.27a2.34 2.34 0 0 1 0-3.31l5.094-5.095L3.94 4.982H2a.75.75 0 0 1-.67-.413L.08 2.087a.75.75 0 0 1 .14-.867l1-1 .09-.077a.75.75 0 0 1 .775-.064l2.5 1.25.09.054A.75.75 0 0 1 5 2v1.922l1.002 1.002A5 5 0 0 1 12.956.397l.083.041a.75.75 0 0 1 .153 1.18L11.061 3.75l1.188 1.188 2.133-2.131.07-.06a.75.75 0 0 1 1.15.297C15.86 3.646 16 4.307 16 5"/>`
    }, props));
$e889e38d3b71ffd5$var$ToolsIcon.displayName = 'ToolsIcon';
var $e889e38d3b71ffd5$var$_default = module.exports.default = $e889e38d3b71ffd5$var$ToolsIcon;

});



parcelRegister("gzbU7", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundEngineeringQueue", function () { return $6da7d49a7d6fdf2d$export$641030449f8b0e7d; });
/* jsm-playground-engineering-queue.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $fiTNr = parcelRequire("fiTNr");

var $4QQvk = parcelRequire("4QQvk");

var $56bcs = parcelRequire("56bcs");

var $4jcRW = parcelRequire("4jcRW");

var $fK1fu = parcelRequire("fK1fu");

var $a6eKS = parcelRequire("a6eKS");

var $b7CRq = parcelRequire("b7CRq");

var $dXWnS = parcelRequire("dXWnS");

var $3Bh8Q = parcelRequire("3Bh8Q");
const $6da7d49a7d6fdf2d$var$isInteractiveTarget = (target)=>target instanceof HTMLElement && Boolean(target.closest('button, input, [role="menuitem"]'));
const $6da7d49a7d6fdf2d$export$641030449f8b0e7d = ({ firstRowRef: firstRowRef, onOpenRow: onOpenRow, onStatusChange: onStatusChange, selectedRowIndex: selectedRowIndex, statusOverrides: statusOverrides, tableRef: tableRef })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1ul9idpf _16jlkb7n _1o9zkb7n _i0dl1wug _1wpz1fhb _1reo15vq _18m91wug"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: tableRef,
            role: "table",
            "aria-label": intl.formatMessage((0, $dXWnS.engineeringMessages).incomingRequests),
            className: (0, $2jatx.default)([
                "_vchhusvi _1bsb1osq _1ul9idpf _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko1mok _bfhkvuon"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    role: "row",
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _4t3ioahv _1r62e4h9 _12ornqa1 _1ezz1l7x _80omtlke _irr31dpa _oh03h2mm _g0pbkb7n _128mdkaa _ra3xnqa1 _mizu1v1w _1ah3ibij",
                        "_bfhkhfxm _syazazsu _11c8fhey _80om73ad _irr3hfxm"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            role: "columnheader",
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bsb1jfw _1ul91jfw _4cvr1h6o _1bah1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4QQvk.Checkbox), {
                                "aria-label": intl.formatMessage((0, $dXWnS.engineeringMessages).selectAll),
                                label: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($6da7d49a7d6fdf2d$var$TableHeader, {
                            width: 40,
                            message: (0, $dXWnS.engineeringMessages).type
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($6da7d49a7d6fdf2d$var$TableHeader, {
                            grow: true,
                            width: 168,
                            message: (0, $dXWnS.engineeringMessages).summary
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($6da7d49a7d6fdf2d$var$TableHeader, {
                            width: 180,
                            message: (0, $dXWnS.engineeringMessages).status
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($6da7d49a7d6fdf2d$var$TableHeader, {
                            width: 168,
                            message: (0, $dXWnS.engineeringMessages).timeToResolution
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($6da7d49a7d6fdf2d$var$TableHeader, {
                            width: 140,
                            message: (0, $dXWnS.engineeringMessages).assignee
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($6da7d49a7d6fdf2d$var$TableHeader, {
                            width: 36,
                            message: (0, $dXWnS.engineeringMessages).priority
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($6da7d49a7d6fdf2d$var$TableHeader, {
                            width: 172,
                            message: (0, $dXWnS.engineeringMessages).created
                        })
                    ]
                }),
                (0, $a6eKS.ENGINEERING_QUEUE_ROWS).map((sourceRow, index)=>{
                    const row = {
                        ...sourceRow,
                        status: statusOverrides[index] ?? sourceRow.status
                    };
                    const summary = intl.formatMessage(row.summary);
                    const open = ()=>onOpenRow(index);
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        "aria-label": intl.formatMessage((0, $dXWnS.engineeringMessages).openRequest, {
                            summary: summary
                        }),
                        "aria-selected": selectedRowIndex === index,
                        onClick: (event)=>{
                            if (!$6da7d49a7d6fdf2d$var$isInteractiveTarget(event.target)) open();
                        },
                        onKeyDown: (event)=>{
                            if (!$6da7d49a7d6fdf2d$var$isInteractiveTarget(event.target) && (event.key === 'Enter' || event.key === ' ')) {
                                event.preventDefault();
                                open();
                            }
                        },
                        ref: index === 0 ? firstRowRef : undefined,
                        role: "row",
                        tabIndex: 0,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _4t3ioahv _1r62e4h9 _12ornqa1 _1ezz1l7x _80omtlke _irr31dpa _oh03h2mm _g0pbkb7n _128mdkaa _ra3xnqa1 _mizu1v1w _1ah3ibij",
                            index === (0, $a6eKS.ENGINEERING_QUEUE_ROWS).length - 1 && "_1r62idpf",
                            selectedRowIndex === index && "_bfhk15s3 _irr315s3"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "cell",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bsb1jfw _1ul91jfw _4cvr1h6o _1bah1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4QQvk.Checkbox), {
                                    "aria-label": intl.formatMessage((0, $dXWnS.engineeringMessages).selectRequest, {
                                        summary: summary
                                    }),
                                    label: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "cell",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bsb1jfw _1ul91jfw _4cvr1h6o _1bah1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CRq.EngineeringRequestTypeIcon), {
                                    size: "medium",
                                    type: row.requestType
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "cell",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1ul993m8 _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _18zrutpp"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_p12f1osq _1reo15vq _18m915vq _syazi7uo _11c8fhey _y3gnv2br _1bto1l2s _o5721q9c"
                                    ]),
                                    children: index < 3 ? summary : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                                        borderRadius: "var(--ds-radius-xsmall, 2px)",
                                        height: 10,
                                        width: 140
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "cell",
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1e0c1txw _1bsbmgvx _1ul9mgvx _4cvr1h6o _18zrutpp _1digcs5v"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Bh8Q.EngineeringRowStatusDropdown), {
                                    onSelect: (status)=>onStatusChange(index, status),
                                    showLabel: index < 3,
                                    status: row.status
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "cell",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bsb93m8 _1ul993m8 _4cvr1h6o _18zrutpp"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CRq.EngineeringSlaTag), {
                                    isLoading: index >= 3,
                                    row: row
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                role: "cell",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bsb11ux _1ul911ux _4cvr1h6o _zulpu2gc _18zrutpp _11c8fhey"
                                ]),
                                children: [
                                    row.assignee ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fK1fu.EngineeringAvatar), {
                                        name: row.assignee
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fiTNr.default), {
                                        name: intl.formatMessage((0, $dXWnS.engineeringMessages).unassigned),
                                        size: "small"
                                    }),
                                    index < 3 ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                        ]),
                                        children: row.assignee ?? intl.formatMessage((0, $dXWnS.engineeringMessages).unassigned)
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                                        borderRadius: "var(--ds-radius-xsmall, 2px)",
                                        height: 10,
                                        width: 96
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "cell",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bsb14no _1ul914no _4cvr1h6o _1bah1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CRq.EngineeringPriorityIcon), {
                                    priority: row.priority
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "cell",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bsb1tkr _1ul91tkr _4cvr1h6o _18zrutpp"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c116y _4t3i1ejb _4cvr1h6o _zulp1b66 _p12f1osq _18zru2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko12b0 _11c8fhey _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($56bcs))), {
                                            color: "var(--ds-icon-subtle, #505258)",
                                            label: "",
                                            size: "small"
                                        }),
                                        index < 3 ? intl.formatDate(row.created, {
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric',
                                            timeZone: 'UTC'
                                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                                            borderRadius: "var(--ds-radius-xsmall, 2px)",
                                            height: 10,
                                            width: 72
                                        })
                                    ]
                                })
                            })
                        ]
                    }, `${index}-${row.summary.id}`);
                })
            ]
        })
    });
};
const $6da7d49a7d6fdf2d$var$TableHeader = ({ grow: grow = false, message: message, width: width })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "columnheader",
        style: {
            '--cell-width': `${width}px`,
            '--cell-flex': grow ? '1 1 auto' : '0 0 auto'
        },
        className: (0, $2jatx.default)([
            "_1e0c1txw _vchhusvi _1bsb4j0t _1ul94j0t _4t3i1osq _kkes1qfb _4cvr1h6o _18zrutpp _11c8fhey"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_11c8fhey _k48p1wq8 _o5721q9c"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                ...message
            })
        })
    });
// Keeps the region's full height (so a longer queue can still scroll) even though the row is
// top-aligned for the detail panel's sake. Columns past the panel clip rather than squash.
const $6da7d49a7d6fdf2d$var$tableViewportStyles = null;
const $6da7d49a7d6fdf2d$var$tableStyles = null;
const $6da7d49a7d6fdf2d$var$tableRowStyles = null;
const $6da7d49a7d6fdf2d$var$lastTableRowStyles = null;
const $6da7d49a7d6fdf2d$var$tableHeaderStyles = null;
const $6da7d49a7d6fdf2d$var$selectedRowStyles = null;
const $6da7d49a7d6fdf2d$var$cellStyles = null;
const $6da7d49a7d6fdf2d$var$headerTextStyles = null;
const $6da7d49a7d6fdf2d$var$checkboxCellStyles = null;
const $6da7d49a7d6fdf2d$var$typeCellStyles = null;
const $6da7d49a7d6fdf2d$var$summaryCellStyles = null;
const $6da7d49a7d6fdf2d$var$summaryTextStyles = null;
const $6da7d49a7d6fdf2d$var$statusCellStyles = null;
const $6da7d49a7d6fdf2d$var$slaCellStyles = null;
const $6da7d49a7d6fdf2d$var$assigneeCellStyles = null;
const $6da7d49a7d6fdf2d$var$priorityCellStyles = null;
const $6da7d49a7d6fdf2d$var$createdCellStyles = null;
const $6da7d49a7d6fdf2d$var$truncateStyles = null;
const $6da7d49a7d6fdf2d$var$dateTagStyles = null;

});
parcelRegister("4QQvk", function(module, exports) {
$parcel$export(module.exports, "Checkbox", function () { return $3884bf07db8a719d$export$48513f6b9f8ce62d; });
/* checkbox.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $adSrQ = parcelRequire("adSrQ");

var $kPutE = parcelRequire("kPutE");

var $6OUKn = parcelRequire("6OUKn");

var $2gnMZ = parcelRequire("2gnMZ");

var $34HAu = parcelRequire("34HAu");

var $hrc5Q = parcelRequire("hrc5Q");
var $3884bf07db8a719d$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var $3884bf07db8a719d$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
var $3884bf07db8a719d$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, $gnQ3X.default)(_ref, $3884bf07db8a719d$var$_excluded);
    var _useState = (0, $1oC0p.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, $2qaZZ.default)(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $adSrQ.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "19.1.1"
    });
    var internalRef = (0, $1oC0p.useRef)(null);
    var mergedRefs = (0, $kPutE.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $1oC0p.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $2gnMZ.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $1oC0p.createElement("input", (0, $c9bqK.default)({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2jatx.default)([
            $3884bf07db8a719d$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $1oC0p.createElement((0, $6OUKn.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $1oC0p.createElement((0, $34HAu.default), null, label, isRequired && /*#__PURE__*/ $1oC0p.createElement((0, $hrc5Q.default), null)));
}));
$3884bf07db8a719d$export$48513f6b9f8ce62d.displayName = 'Checkbox';
var // keep the default export for backwards compatibility
$3884bf07db8a719d$export$2e2bcd8739ae039 = $3884bf07db8a719d$export$48513f6b9f8ce62d;

});
parcelRegister("adSrQ", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $77155a8e8be35fc4$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $gKnyt = parcelRequire("gKnyt");

var $bruUQ = parcelRequire("bruUQ");
function $77155a8e8be35fc4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77155a8e8be35fc4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77155a8e8be35fc4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77155a8e8be35fc4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $77155a8e8be35fc4$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gKnyt.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $bruUQ.useTrackedRef)(analyticsData);
    var fnRef = (0, $bruUQ.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $77155a8e8be35fc4$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("gKnyt", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $c31336c408c2654a$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $5Jf7e = parcelRequire("5Jf7e");

var $6WqI5 = parcelRequire("6WqI5");
function $c31336c408c2654a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $6WqI5.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $5Jf7e.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("5Jf7e", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $42bce1655e5834ac$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");

var $2cOKT = parcelRequire("2cOKT");
function $42bce1655e5834ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $42bce1655e5834ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $42bce1655e5834ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $42bce1655e5834ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $42bce1655e5834ac$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $42bce1655e5834ac$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $42bce1655e5834ac$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($42bce1655e5834ac$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $42bce1655e5834ac$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $42bce1655e5834ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $42bce1655e5834ac$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            var payload = $42bce1655e5834ac$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $42bce1655e5834ac$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $2cOKT.default));
var $42bce1655e5834ac$var$clonePayload = function clonePayload(payload) {
    if ((0, $6ur0l.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $42bce1655e5834ac$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};

});
parcelRegister("2cOKT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $19b412b7efb2f6a9$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $19b412b7efb2f6a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19b412b7efb2f6a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19b412b7efb2f6a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19b412b7efb2f6a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $19b412b7efb2f6a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $19b412b7efb2f6a9$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $19b412b7efb2f6a9$var$_objectSpread($19b412b7efb2f6a9$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("6WqI5", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $50dce0eb302b0ab1$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $50dce0eb302b0ab1$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("bruUQ", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $854a32912f5cbfda$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $854a32912f5cbfda$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("6OUKn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f736e58b69e75d3$export$2e2bcd8739ae039; });
/* checkbox-icon.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var $4f736e58b69e75d3$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $4f736e58b69e75d3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $1oC0p.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $1oC0p.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $4f736e58b69e75d3$var$CheckboxIcon = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $1oC0p.useMemo)(function() {
        return $4f736e58b69e75d3$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $1oC0p.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $2jatx.default)([
            $4f736e58b69e75d3$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $1oC0p.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $2jatx.default)([
            $4f736e58b69e75d3$var$svgStyles.rect
        ])
    }), icon));
});
var $4f736e58b69e75d3$export$2e2bcd8739ae039 = $4f736e58b69e75d3$var$CheckboxIcon;

});

parcelRegister("2gnMZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1a5f876aa6930d86$export$2e2bcd8739ae039; });
/* label.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $1a5f876aa6930d86$var$baseStyles = null;
var $1a5f876aa6930d86$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
var $1a5f876aa6930d86$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var $1a5f876aa6930d86$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var $1a5f876aa6930d86$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
var $1a5f876aa6930d86$var$disabledCheckedStyles = null;
function $1a5f876aa6930d86$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, isChecked = _ref.isChecked, isIndeterminate = _ref.isIndeterminate, isInvalid = _ref.isInvalid, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $1oC0p.createElement("label", {
        className: (0, $2jatx.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("34HAu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23d38e6649c8a41f$export$2e2bcd8739ae039; });
/* label-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $23d38e6649c8a41f$var$labelTextStyles = null;
function $23d38e6649c8a41f$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("hrc5Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb1e56bf33435b09$export$2e2bcd8739ae039; });
/* required-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $cb1e56bf33435b09$var$requiredIndicatorStyles = null;
function $cb1e56bf33435b09$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}

});


parcelRegister("3Bh8Q", function(module, exports) {
$parcel$export(module.exports, "EngineeringRowStatusDropdown", function () { return $99bd7916ef58bc5c$export$5f04c7ebd41ccb4d; });
$parcel$export(module.exports, "EngineeringStatusDropdown", function () { return $99bd7916ef58bc5c$export$9ec3b747ce7370c8; });
/* jsm-playground-engineering-status.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $fhDEu = parcelRequire("fhDEu");
var $jRJoS = parcelRequire("jRJoS");
var $85WhL = parcelRequire("85WhL");

var $53VCz = parcelRequire("53VCz");

var $f4kGi = parcelRequire("f4kGi");

var $izDBw = parcelRequire("izDBw");

var $4jcRW = parcelRequire("4jcRW");

var $a6eKS = parcelRequire("a6eKS");
const $99bd7916ef58bc5c$var$BACKLOG_STATUS = (0, $a6eKS.ENGINEERING_WORKFLOW)[4];
const $99bd7916ef58bc5c$var$assignRef = (ref, node)=>{
    if (typeof ref === 'function') ref(node);
    else if (ref) ref.current = node;
};
const $99bd7916ef58bc5c$var$statusTriggerAppearance = (status)=>{
    if (status.tone === 'blue') return 'accent-blue';
    if (status.tone === 'green') return 'success';
    if (status.tone === 'red') return 'accent-red';
    return 'accent-gray';
};
const $99bd7916ef58bc5c$var$StatusLozenge = ({ showLabel: showLabel, status: status })=>{
    const intl = (0, $8e22h.default)();
    if (!showLabel) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
        height: 10,
        width: 80
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izDBw.default), {
        appearance: $99bd7916ef58bc5c$var$statusTriggerAppearance(status),
        children: intl.formatMessage(status.label)
    });
};
const $99bd7916ef58bc5c$var$StatusTransition = ({ status: status })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zulputpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53VCz))), {
                color: "var(--ds-icon-subtle, #505258)",
                label: "",
                size: "small"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($99bd7916ef58bc5c$var$StatusLozenge, {
                showLabel: true,
                status: status
            })
        ]
    });
const $99bd7916ef58bc5c$export$5f04c7ebd41ccb4d = ({ onSelect: onSelect, showLabel: showLabel, status: status })=>{
    const intl = (0, $8e22h.default)();
    const label = intl.formatMessage(status.label);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhDEu.default), {
            placement: "bottom-start",
            shouldRenderToParent: true,
            strategy: "absolute",
            testId: "engineering-row-status",
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $f4kGi.default), {
                    ...triggerProps,
                    "aria-label": label,
                    ref: triggerRef,
                    appearance: $99bd7916ef58bc5c$var$statusTriggerAppearance(status),
                    children: showLabel ? label : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                        borderRadius: "var(--ds-radius-xsmall, 2px)",
                        height: 10,
                        width: 64
                    })
                }),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb5x59 _1jbd1q9c"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $85WhL.default), {
                    children: (0, $a6eKS.ENGINEERING_WORKFLOW).filter((workflowStatus)=>workflowStatus.id !== status.id).map((workflowStatus)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jRJoS.default), {
                            elemAfter: /*#__PURE__*/ (0, $7VQPk.jsx)($99bd7916ef58bc5c$var$StatusTransition, {
                                status: workflowStatus
                            }),
                            onClick: ()=>onSelect(workflowStatus),
                            children: intl.formatMessage(workflowStatus.label)
                        }, workflowStatus.id))
                })
            })
        })
    });
};
const $99bd7916ef58bc5c$export$9ec3b747ce7370c8 = ({ backlogItemRef: backlogItemRef, isOpen: isOpen, onOpenChange: onOpenChange, onSelect: onSelect, status: status, triggerRef: triggerRef })=>{
    const intl = (0, $8e22h.default)();
    const label = intl.formatMessage(status.label);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhDEu.default), {
        isOpen: isOpen,
        onOpenChange: ({ isOpen: nextIsOpen })=>onOpenChange(nextIsOpen),
        placement: "bottom-end",
        shouldRenderToParent: true,
        strategy: "absolute",
        testId: "engineering-status",
        trigger: ({ triggerRef: dropdownRef, ...triggerProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $f4kGi.default), {
                ...triggerProps,
                "aria-label": label,
                appearance: "neutral",
                maxWidth: "100%",
                ref: (node)=>{
                    $99bd7916ef58bc5c$var$assignRef(dropdownRef, node);
                    triggerRef.current = node;
                },
                spacing: "spacious",
                children: label
            }),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsb5x59 _1jbd1q9c"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $85WhL.default), {
                children: (0, $a6eKS.ENGINEERING_WORKFLOW).filter((workflowStatus)=>workflowStatus.id !== status.id).map((workflowStatus)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: workflowStatus.id === $99bd7916ef58bc5c$var$BACKLOG_STATUS.id ? backlogItemRef : undefined,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jRJoS.default), {
                            elemAfter: /*#__PURE__*/ (0, $7VQPk.jsx)($99bd7916ef58bc5c$var$StatusTransition, {
                                status: workflowStatus
                            }),
                            onClick: ()=>onSelect(workflowStatus),
                            children: intl.formatMessage(workflowStatus.label)
                        })
                    }, workflowStatus.id))
            })
        })
    });
};
const $99bd7916ef58bc5c$var$statusMenuStyles = null;
const $99bd7916ef58bc5c$var$rowStatusDropdownStyles = null;
const $99bd7916ef58bc5c$var$statusTransitionStyles = null;

});
parcelRegister("fhDEu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b20733a2b48da4f4$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $gzpW5 = parcelRequire("gzpW5");

var $lv5Ml = parcelRequire("lv5Ml");

var $kPutE = parcelRequire("kPutE");

var $7uNuF = parcelRequire("7uNuF");

var $645Xv = parcelRequire("645Xv");

var $4YraT = parcelRequire("4YraT");

var $5RBBI = parcelRequire("5RBBI");

var $67RyF = parcelRequire("67RyF");

var $6ur0l = parcelRequire("6ur0l");

var $axD8z = parcelRequire("axD8z");

var $5IuSN = parcelRequire("5IuSN");

var $ktMX1 = parcelRequire("ktMX1");

var $aAEhY = parcelRequire("aAEhY");

var $lAIxe = parcelRequire("lAIxe");

var $5nInC = parcelRequire("5nInC");

var $dnhgz = parcelRequire("dnhgz");

var $9NzsX = parcelRequire("9NzsX");
var $b20733a2b48da4f4$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $b20733a2b48da4f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b20733a2b48da4f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b20733a2b48da4f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b20733a2b48da4f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b20733a2b48da4f4$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $b20733a2b48da4f4$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $b20733a2b48da4f4$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($b20733a2b48da4f4$var$opposites[crossAxis]),
            "".concat($b20733a2b48da4f4$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($b20733a2b48da4f4$var$opposites[mainAxis]),
            "".concat($b20733a2b48da4f4$var$opposites[mainAxis], "-").concat($b20733a2b48da4f4$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($b20733a2b48da4f4$var$opposites[mainAxis]),
        "".concat($b20733a2b48da4f4$var$opposites[mainAxis], "-start"),
        "".concat($b20733a2b48da4f4$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $b20733a2b48da4f4$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $b20733a2b48da4f4$var$DropdownMenuLegacy(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $7uNuF.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $5IuSN.layers).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel, _ref$shouldPreventEsc = _ref.shouldPreventEscapePropagation, shouldPreventEscapePropagation = _ref$shouldPreventEsc === void 0 ? false : _ref$shouldPreventEsc, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent;
    var _useControlledState = (0, $645Xv.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, $2qaZZ.default)(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $9NzsX.default)();
    var itemRef = (0, $dnhgz.default)();
    var _useLayering = (0, $67RyF.useLayering)(), currentLevel = _useLayering.currentLevel;
    var fallbackPlacements = (0, $1oC0p.useMemo)(function() {
        return $b20733a2b48da4f4$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $1oC0p.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $1oC0p.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabLeftOrEscapeKey = $b20733a2b48da4f4$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $lv5Ml.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $b20733a2b48da4f4$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $lv5Ml.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $9NzsX.PREFIX), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($b20733a2b48da4f4$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $lv5Ml.KEY_LEFT))) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    var _useFocus = (0, $4YraT.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $1oC0p.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $7uNuF.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $7uNuF.default;
        return (0, $dH1HR.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $9NzsX.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, $lv5Ml.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $lv5Ml.KEY_SPACE) || e.key === (0, $lv5Ml.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $lv5Ml.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5nInC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $axD8z.Popup), (0, $c9bqK.default)({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, $gnQ3X.default)(_ref2, $b20733a2b48da4f4$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($b20733a2b48da4f4$var$_objectSpread($b20733a2b48da4f4$var$_objectSpread($b20733a2b48da4f4$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $kPutE.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gzpW5.default), (0, $c9bqK.default)({}, bindFocus, {
                ref: (0, $kPutE.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), (0, $c9bqK.default)({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $aAEhY.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lAIxe.default), {
                spacing: spacing,
                maxHeight: $b20733a2b48da4f4$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $b20733a2b48da4f4$var$DropdownMenu = function DropdownMenu(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, _props$defaultOpen = props.defaultOpen, defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen, _props$isLoading = props.isLoading, isLoading = _props$isLoading === void 0 ? false : _props$isLoading, isOpen = props.isOpen, _props$onOpenChange = props.onOpenChange, onOpenChange = _props$onOpenChange === void 0 ? (0, $7uNuF.default) : _props$onOpenChange, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom-start' : _props$placement, _props$shouldFitConta = props.shouldFitContainer, shouldFitContainer = _props$shouldFitConta === void 0 ? false : _props$shouldFitConta, returnFocusRef = props.returnFocusRef, spacing = props.spacing, statusLabel = props.statusLabel, testId = props.testId, trigger = props.trigger, label = props.label, interactionName = props.interactionName, menuLabel = props.menuLabel;
    if ((0, $6ur0l.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ktMX1.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($b20733a2b48da4f4$var$DropdownMenuLegacy, props);
};
var $b20733a2b48da4f4$export$2e2bcd8739ae039 = $b20733a2b48da4f4$var$DropdownMenu;

});
parcelRegister("67RyF", function(module, exports) {
$parcel$export(module.exports, "useLayering", function () { return $475cf1117b66fc44$export$c8b4d54e03dee6ed; });

var $1oC0p = parcelRequire("1oC0p");

var $3djDS = parcelRequire("3djDS");

var $lPAbe = parcelRequire("lPAbe");

var $lw3RR = parcelRequire("lw3RR");
function $475cf1117b66fc44$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $1oC0p.useContext)((0, $3djDS.LevelContext));
    var layerNode = (0, $1oC0p.useContext)((0, $lPAbe.LevelNodeContext));
    var rootNode = (0, $1oC0p.useContext)((0, $lw3RR.RootNodeContext));
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $1oC0p.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});
parcelRegister("3djDS", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $2571d286992b98f1$export$650d12d3c2ddb8fc; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $2571d286992b98f1$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);

});

parcelRegister("lPAbe", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", function () { return $fe4a6d08bf2663ca$export$18f4d8b5b3a77f59; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $fe4a6d08bf2663ca$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});

});

parcelRegister("lw3RR", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", function () { return $fa9f96323f423db7$export$fa973f110e8f6ca8; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $fa9f96323f423db7$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});

});


parcelRegister("axD8z", function(module, exports) {
$parcel$export(module.exports, "Popup", function () { return $7acb5847813106a1$export$129a32eedafa97c5; });
/* popup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");


var $4UF4U = parcelRequire("4UF4U");

var $4D23u = parcelRequire("4D23u");

var $9k6Ve = parcelRequire("9k6Ve");

var $7XTnT = parcelRequire("7XTnT");

var $6ur0l = parcelRequire("6ur0l");

var $LduO3 = parcelRequire("LduO3");

var $anZif = parcelRequire("anZif");

var $bNhzD = parcelRequire("bNhzD");

var $2sVl0 = parcelRequire("2sVl0");

var $lQXVZ = parcelRequire("lQXVZ");

var $1RZPN = parcelRequire("1RZPN");

var $bxhyr = parcelRequire("bxhyr");

var $kJYJr = parcelRequire("kJYJr");

var $1YOVV = parcelRequire("1YOVV");
var $7acb5847813106a1$var$defaultLayer = 400;
var $7acb5847813106a1$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $7acb5847813106a1$var$PopupLegacy = function PopupLegacy(props) {
    var xcss = props.xcss, _props$appearance = props.appearance, inAppearance = _props$appearance === void 0 ? 'default' : _props$appearance, isOpen = props.isOpen, providedId = props.id, offset = props.offset, testId = props.testId, trigger = props.trigger, content = props.content, onClose = props.onClose, boundary = props.boundary, _props$rootBoundary = props.rootBoundary, rootBoundary = _props$rootBoundary === void 0 ? 'viewport' : _props$rootBoundary, _props$shouldFlip = props.shouldFlip, shouldFlip = _props$shouldFlip === void 0 ? true : _props$shouldFlip, _props$placement = props.placement, placement = _props$placement === void 0 ? 'auto' : _props$placement, fallbackPlacements = props.fallbackPlacements, PopupContainer = props.popupComponent, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$zIndex = props.zIndex, zIndex = _props$zIndex === void 0 ? $7acb5847813106a1$var$defaultLayer : _props$zIndex, _props$shouldUseCaptu = props.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _props$shouldUseCaptu === void 0 ? false : _props$shouldUseCaptu, shouldIgnoreCloseEvent = props.shouldIgnoreCloseEvent, _props$shouldRenderTo = props.shouldRenderToParent, inShouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, _props$shouldFitConta = props.shouldFitContainer, shouldFitContainer = _props$shouldFitConta === void 0 ? false : _props$shouldFitConta, _props$shouldDisableF = props.shouldDisableFocusLock, shouldDisableFocusLock = _props$shouldDisableF === void 0 ? false : _props$shouldDisableF, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, strategy = props.strategy, role = props.role, label = props.label, titleId = props.titleId, modifiers = props.modifiers, shouldFitViewport = props.shouldFitViewport;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $kJYJr.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $1YOVV.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $4UF4U.useId)();
    var _usePopupAppearance = (0, $bxhyr.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $9k6Ve.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    var xcssPassthrough = {
        value: xcss
    };
    var renderPopperWrapper = /*#__PURE__*/ $1oC0p.createElement((0, $4D23u.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $1oC0p.createElement((0, $lQXVZ.default), {
        xcss: xcssPassthrough.value,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        zIndex: zIndex,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $1oC0p.createElement((0, $LduO3.Manager), null, /*#__PURE__*/ $1oC0p.createElement((0, $anZif.Reference), null, function(_ref) {
        var ref = _ref.ref;
        return trigger({
            ref: !(0, $6ur0l.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $6ur0l.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), !(0, $6ur0l.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $1oC0p.createElement((0, $bNhzD.default), {
        zIndex: zIndex
    }, renderPopperWrapper)), (0, $6ur0l.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ $1oC0p.createElement((0, $7XTnT.default), {
        appear: true
    }, isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $1oC0p.createElement((0, $bNhzD.default), {
        zIndex: zIndex
    }, renderPopperWrapper))));
    if (shouldFitContainer) return /*#__PURE__*/ $1oC0p.createElement((0, $2sVl0.Box), {
        xcss: $7acb5847813106a1$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
};
var $7acb5847813106a1$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $1oC0p.memo)(function(props) {
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $6ur0l.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ $1oC0p.createElement((0, $1RZPN.PopupTopLayer), props);
    return /*#__PURE__*/ $1oC0p.createElement($7acb5847813106a1$var$PopupLegacy, props);
});

});
parcelRegister("4D23u", function(module, exports) {
$parcel$export(module.exports, "Layering", function () { return $35ec660fbc3d37b4$export$7c885f891c940977; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");

var $3mBT6 = parcelRequire("3mBT6");

var $3a4pi = parcelRequire("3a4pi");

var $jilM0 = parcelRequire("jilM0");

var $bA8Md = parcelRequire("bA8Md");
var $35ec660fbc3d37b4$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $1oC0p.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3a4pi.LevelContext).Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jilM0.LevelNodeContext).Provider, {
        value: levelNode
    }, children));
};
var $35ec660fbc3d37b4$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $1oC0p.useContext)((0, $3a4pi.LevelContext));
    var parentNode = (0, $1oC0p.useContext)((0, $jilM0.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $1oC0p.useRef)(new (0, $3mBT6.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($35ec660fbc3d37b4$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bA8Md.RootNodeContext).Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("3mBT6", function(module, exports) {
$parcel$export(module.exports, "LayerNode", function () { return $2730d0e1ab3eea41$export$da4f61fd78d35243; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");
var $2730d0e1ab3eea41$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, $cTewU.default)(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, $avOEA.default)(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, $lFOXD.default)(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});

parcelRegister("3a4pi", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $24d5b96b8aac9b70$export$650d12d3c2ddb8fc; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $24d5b96b8aac9b70$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);

});

parcelRegister("jilM0", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", function () { return $e0c09680cd394274$export$18f4d8b5b3a77f59; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $e0c09680cd394274$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});

});

parcelRegister("bA8Md", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", function () { return $86e9dd5ebebccac9$export$fa973f110e8f6ca8; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $86e9dd5ebebccac9$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});

});


parcelRegister("9k6Ve", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $6c9b59e3aecc58c5$export$469bb693f11edc7f; });

var $1oC0p = parcelRequire("1oC0p");

var $54xRF = parcelRequire("54xRF");

var $neGGZ = parcelRequire("neGGZ");
function $6c9b59e3aecc58c5$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $1oC0p.useContext)((0, $54xRF.OpenLayerObserverContext));
    var namespace = (0, $neGGZ.useOpenLayerObserverNamespace)();
    (0, $1oC0p.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("54xRF", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $3b1798401fff9711$export$5fbf4d7fae6cdc00; });

var $1oC0p = parcelRequire("1oC0p");
var $3b1798401fff9711$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("neGGZ", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $045d8abf1287a91f$export$1d57e79091cc3046; });

var $1oC0p = parcelRequire("1oC0p");

var $fryIw = parcelRequire("fryIw");
function $045d8abf1287a91f$export$1d57e79091cc3046() {
    var namespace = (0, $1oC0p.useContext)((0, $fryIw.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("fryIw", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $b3e44eb64e9f932f$export$644a49f3b8c50fcd; });

var $1oC0p = parcelRequire("1oC0p");
var $b3e44eb64e9f932f$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});



parcelRegister("7XTnT", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", function () { return $5cc9013fd0a671de$export$b9c4904d7a6929e6; });
$parcel$export(module.exports, "default", function () { return $5cc9013fd0a671de$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $5cc9013fd0a671de$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $5cc9013fd0a671de$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $1oC0p.createContext)($5cc9013fd0a671de$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $5cc9013fd0a671de$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5cc9013fd0a671de$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($5cc9013fd0a671de$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $5cc9013fd0a671de$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1oC0p.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $5cc9013fd0a671de$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $5cc9013fd0a671de$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $5cc9013fd0a671de$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $5cc9013fd0a671de$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $5cc9013fd0a671de$var$ExitingPersistence = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $1oC0p.useState)([
        null,
        children
    ]), _useState2 = (0, $2qaZZ.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)([]), _useState4 = (0, $2qaZZ.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $1oC0p.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $2qaZZ.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $5cc9013fd0a671de$var$childrenToArray(previousChildren);
    var current = $5cc9013fd0a671de$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $5cc9013fd0a671de$var$childrenToArray(children) : current;
    var missingKeys = $5cc9013fd0a671de$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $5cc9013fd0a671de$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $6ur0l.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $5cc9013fd0a671de$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $5cc9013fd0a671de$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5cc9013fd0a671de$export$2e2bcd8739ae039 = $5cc9013fd0a671de$var$ExitingPersistence;
$5cc9013fd0a671de$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("LduO3", function(module, exports) {
$parcel$export(module.exports, "Manager", function () { return $08dedbe6a358e7ce$export$d0d38e7dec7a1a61; });

var $1oC0p = parcelRequire("1oC0p");

var $8q4Jo = parcelRequire("8q4Jo");

var $9kKb2 = parcelRequire("9kKb2");

var $9PrNS = parcelRequire("9PrNS");

var $fazvf = parcelRequire("fazvf");
function $08dedbe6a358e7ce$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    var _useAnchorState = (0, $fazvf.useAnchorState)(), anchor = _useAnchorState.anchor, setAnchor = _useAnchorState.setAnchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8q4Jo.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9PrNS.AnchorSetterContext).Provider, {
        value: setAnchor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9kKb2.AnchorContext).Provider, {
        value: anchor
    }, children)));
}

});
parcelRegister("9kKb2", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", function () { return $6cb9cd1a08ed84df$export$8f73317645bb7b8e; });

var $1oC0p = parcelRequire("1oC0p");
var $6cb9cd1a08ed84df$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("9PrNS", function(module, exports) {
$parcel$export(module.exports, "AnchorSetterContext", function () { return $727e71aac2557606$export$804169e6eecdff16; });

var $1oC0p = parcelRequire("1oC0p");
var $727e71aac2557606$export$804169e6eecdff16 = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return undefined;
});

});

parcelRegister("fazvf", function(module, exports) {
$parcel$export(module.exports, "useAnchorState", function () { return $b0b3545165fc2b9d$export$1b1b50fdcd7ac375; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $b0b3545165fc2b9d$export$1b1b50fdcd7ac375() {
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), anchor = _useState2[0], setAnchor = _useState2[1];
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}

});


parcelRegister("anZif", function(module, exports) {
$parcel$export(module.exports, "Reference", function () { return $78fb98efebdff834$export$e0be378c32fb70a7; });

var $1oC0p = parcelRequire("1oC0p");

var $kUCSO = parcelRequire("kUCSO");

var $kPutE = parcelRequire("kPutE");

var $lUpne = parcelRequire("lUpne");
function $78fb98efebdff834$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var publishAnchor = (0, $lUpne.useManagerAnchorSetter)();
    var composedRef = (0, $1oC0p.useMemo)(function() {
        return (0, $kPutE.default)([
            publishAnchor,
            innerRef
        ]);
    }, [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kUCSO.Reference), {
        innerRef: composedRef
    }, children);
}

});
parcelRegister("lUpne", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchorSetter", function () { return $ff3282a0952793e1$export$fcdda419d7091b3; });

var $1oC0p = parcelRequire("1oC0p");

var $9PrNS = parcelRequire("9PrNS");
function $ff3282a0952793e1$export$fcdda419d7091b3() {
    return (0, $1oC0p.useContext)((0, $9PrNS.AnchorSetterContext));
}

});


parcelRegister("bNhzD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8961e711db897a6f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $gVFcc = parcelRequire("gVFcc");

var $lt22j = parcelRequire("lt22j");

var $hXJTU = parcelRequire("hXJTU");

var $bif4b = parcelRequire("bif4b");
function $8961e711db897a6f$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $hXJTU.default)(mountStrategy);
    (0, $bif4b.default)(zIndex);
    return !(0, $6ur0l.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gVFcc.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lt22j.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("gVFcc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c531ecd5cdf2cdac$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $kKxD1 = parcelRequire("kKxD1");

var $3ZjRx = parcelRequire("3ZjRx");

var $bQvvU = parcelRequire("bQvvU");

var $82ufM = parcelRequire("82ufM");

var $EBKcp = parcelRequire("EBKcp");

var $gRcVH = parcelRequire("gRcVH");
function $c531ecd5cdf2cdac$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $1oC0p.useMemo)(function() {
        return (0, $EBKcp.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $3ZjRx.useColorMode)();
    var isInsideThemeProvider = (0, $bQvvU.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $82ufM.appendPortalContainerIfNotAppended)(container);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            (0, $gRcVH.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kKxD1.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("kKxD1", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", function () { return $f1b23071eea2579e$export$d8964aec282183a3; });
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $cn8ql = parcelRequire("cn8ql");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2jatx = parcelRequire("2jatx");

var $5Cxn4 = parcelRequire("5Cxn4");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $6ur0l = parcelRequire("6ur0l");

var $jjBfD = parcelRequire("jjBfD");

var $iBQw6 = parcelRequire("iBQw6");

var $2K066 = parcelRequire("2K066");

var $4OnvQ = parcelRequire("4OnvQ");

var $eWZzw = parcelRequire("eWZzw");

var $7JjSk = parcelRequire("7JjSk");

var $kjffU = parcelRequire("kjffU");

var $795rY = parcelRequire("795rY");

var $cbdws = parcelRequire("cbdws");

var $bQvvU = parcelRequire("bQvvU");

var $dRpYb = parcelRequire("dRpYb");

var $1n3Ss = parcelRequire("1n3Ss");
function $f1b23071eea2579e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1b23071eea2579e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1b23071eea2579e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1b23071eea2579e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f1b23071eea2579e$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography'
};
var $f1b23071eea2579e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $f1b23071eea2579e$var$prefersDarkModeMql = $f1b23071eea2579e$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $f1b23071eea2579e$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $f1b23071eea2579e$var$prefersDarkModeMql !== null && $f1b23071eea2579e$var$prefersDarkModeMql !== void 0 && $f1b23071eea2579e$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $f1b23071eea2579e$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $f1b23071eea2579e$export$d8964aec282183a3(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $1oC0p.useState)(defaultColorMode), _useState2 = (0, $2qaZZ.default)(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)($f1b23071eea2579e$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, $2qaZZ.default)(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return $f1b23071eea2579e$var$_objectSpread($f1b23071eea2579e$var$_objectSpread({}, $f1b23071eea2579e$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, $2qaZZ.default)(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var _useState7 = (0, $1oC0p.useState)(false), _useState8 = (0, $2qaZZ.default)(_useState7, 2), hasHoistedInlineThemeStyles = _useState8[0], setHasHoistedInlineThemeStyles = _useState8[1];
    var setColorMode = (0, $1oC0p.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($f1b23071eea2579e$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $1oC0p.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $f1b23071eea2579e$var$_objectSpread($f1b23071eea2579e$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $1oC0p.useRef)(null);
    var isInsideAppProvider = (0, $eWZzw.useIsInsideAppProvider)();
    var isAppProviderThemingEnabled = (0, $4OnvQ.useIsAppProviderThemingEnabled)();
    var isInsideThemeProvider = (0, $bQvvU.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $1oC0p.useLayoutEffect)(function() {
        if (!(0, $6ur0l.fg)('platform-static-theme-loading') || hasHoistedInlineThemeStyles) return;
        (0, $dRpYb.getInlineThemeStyles)(theme, chosenColorMode).forEach(function(_ref2) {
            var id = _ref2.id, css = _ref2.css;
            if (document.head.querySelector("style[data-theme=\"".concat(id, "\"]"))) return;
            var style = document.createElement('style');
            style.dataset.theme = id;
            style.textContent = css;
            document.head.appendChild(style);
        });
        setHasHoistedInlineThemeStyles(true);
    }, [
        chosenColorMode,
        hasHoistedInlineThemeStyles,
        theme
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return lastSetGlobalThemePromiseRef.current;
                            case 1:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref3.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref4 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return cleanupLastFnCall();
                            case 1:
                                promise = (0, $2K066.setGlobalTheme)($f1b23071eea2579e$var$_objectSpread($f1b23071eea2579e$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref4.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        }
        // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $1n3Ss.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!$f1b23071eea2579e$var$prefersDarkModeMql) return;
        var unbindListener = (0, $dH1HR.bind)($f1b23071eea2579e$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $f1b23071eea2579e$var$_objectSpread($f1b23071eea2579e$var$_objectSpread({}, (0, $iBQw6.getThemeHtmlAttrs)($f1b23071eea2579e$var$_objectSpread($f1b23071eea2579e$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, $f53LC.default)({}, (0, $jjBfD.SUBTREE_THEME_ATTRIBUTE), true));
    var inlineThemeStyles = (0, $6ur0l.fg)('platform-static-theme-loading') && !hasHoistedInlineThemeStyles ? (0, $dRpYb.getInlineThemeStyles)(theme, chosenColorMode) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kjffU.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7JjSk.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $795rY.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cbdws.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cbdws.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", (0, $c9bqK.default)({}, attrs, {
        className: (0, $2jatx.default)([
            $f1b23071eea2579e$var$contentStyles.body
        ])
    }), inlineThemeStyles.map(function(_ref5) {
        var id = _ref5.id, css = _ref5.css;
        return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
        (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("style", {
            "data-theme": id,
            key: id
        }, css));
    }), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, inlineThemeStyles.map(function(_ref6) {
        var id = _ref6.id, css = _ref6.css;
        return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
        (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("style", {
            "data-theme": id,
            key: id
        }, css));
    }), children))))));
}

});
parcelRegister("jjBfD", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $e0fcaff49af2b3a1$export$4ef52930e33717cd; });
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", function () { return $e0fcaff49af2b3a1$export$cb374d25ded7f6ab; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $e0fcaff49af2b3a1$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $e0fcaff49af2b3a1$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $e0fcaff49af2b3a1$export$352e418ed5b6193a; });
var $e0fcaff49af2b3a1$export$4ef52930e33717cd = 'data-theme';
var $e0fcaff49af2b3a1$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $e0fcaff49af2b3a1$export$a00eac3f8684bcd0 = 'data-color-mode';
var $e0fcaff49af2b3a1$export$2112803007239c61 = 'data-contrast-mode';
var $e0fcaff49af2b3a1$export$352e418ed5b6193a = 'data-custom-theme';
var $e0fcaff49af2b3a1$export$6f0c6fb8c80fcc92 = 'ds';
var $e0fcaff49af2b3a1$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $e0fcaff49af2b3a1$export$dddac1532e822863 = "--".concat($e0fcaff49af2b3a1$export$6f0c6fb8c80fcc92, "-token-not-found");
var $e0fcaff49af2b3a1$export$9d7b58831ae93caa = "--".concat($e0fcaff49af2b3a1$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("iBQw6", function(module, exports) {
$parcel$export(module.exports, "getThemeHtmlAttrs", function () { return $d8c46b6b87017407$export$e1f80cb7a749802f; });
$parcel$export(module.exports, "default", function () { return $d8c46b6b87017407$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $6ur0l = parcelRequire("6ur0l");

var $jjBfD = parcelRequire("jjBfD");

var $7B4qb = parcelRequire("7B4qb");

var $gH2Lz = parcelRequire("gH2Lz");

var $2kjN1 = parcelRequire("2kjN1");

var $lXnVT = parcelRequire("lXnVT");
function $d8c46b6b87017407$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8c46b6b87017407$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8c46b6b87017407$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8c46b6b87017407$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d8c46b6b87017407$var$defaultColorMode = 'light';
var $d8c46b6b87017407$var$defaultContrastMode = 'no-preference';
var $d8c46b6b87017407$export$e1f80cb7a749802f = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $gH2Lz.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $gH2Lz.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $gH2Lz.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $gH2Lz.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $gH2Lz.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $gH2Lz.themeStateDefaults)['shape'] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $gH2Lz.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $gH2Lz.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $gH2Lz.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $7B4qb.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, $f53LC.default)((0, $f53LC.default)({}, (0, $jjBfD.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $jjBfD.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $d8c46b6b87017407$var$defaultColorMode : colorMode);
    if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) result = $d8c46b6b87017407$var$_objectSpread($d8c46b6b87017407$var$_objectSpread({}, result), {}, (0, $f53LC.default)({}, (0, $jjBfD.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $d8c46b6b87017407$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $lXnVT.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $2kjN1.hash)(optionString);
        result[0, $jjBfD.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $d8c46b6b87017407$export$2e2bcd8739ae039 = $d8c46b6b87017407$export$e1f80cb7a749802f;

});
parcelRegister("7B4qb", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", function () { return $587f6b1733ba397d$export$62c37ab81302621a; });

var $2zYm4 = parcelRequire("2zYm4");

var $2qaZZ = parcelRequire("2qaZZ");

var $59oeC = parcelRequire("59oeC");

var $1EqVD = parcelRequire("1EqVD");

var $6vN7v = parcelRequire("6vN7v");
var $587f6b1733ba397d$var$customThemeOptions = 'UNSAFE_themeOptions';
var $587f6b1733ba397d$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $59oeC.isColorMode)(id) || // custom theme state
        kind === $587f6b1733ba397d$var$customThemeOptions && (0, $2zYm4.default)(id) === 'object' || // other theme states
        (0, $6vN7v.isThemeKind)(kind) && typeof id === 'string' && (0, $1EqVD.isThemeIds)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $2zYm4.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});
parcelRegister("59oeC", function(module, exports) {
$parcel$export(module.exports, "isColorMode", function () { return $3c0097898c5ce3bc$export$4a14e169b1de4ee7; });
var $3c0097898c5ce3bc$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("1EqVD", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", function () { return $133e6a53ef1de328$export$ea35b8958c39dd07; });

var $eA4yj = parcelRequire("eA4yj");
var $133e6a53ef1de328$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $eA4yj.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("eA4yj", function(module, exports) {
$parcel$export(module.exports, "themeIds", function () { return $a9d7f5821516a7b3$export$7d43e72a58e3283f; });
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $a9d7f5821516a7b3$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("6vN7v", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", function () { return $4bdbbd91170d2eb6$export$958fa026be3a263e; });
var $4bdbbd91170d2eb6$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $4bdbbd91170d2eb6$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $4bdbbd91170d2eb6$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});


parcelRegister("gH2Lz", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", function () { return $c272ced7a1958e72$export$9aedcfa7336a207; });
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $c272ced7a1958e72$var$getMotionDefault() {
    return 'motion';
}
var $c272ced7a1958e72$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography',
    motion: $c272ced7a1958e72$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("2kjN1", function(module, exports) {
$parcel$export(module.exports, "hash", function () { return $1b1cccdd931c2beb$export$d6af199866bfb566; });
var $1b1cccdd931c2beb$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("lXnVT", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", function () { return $ffc1ac31e241a8f0$export$53031ac1ecb71f44; });
var $ffc1ac31e241a8f0$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};

});


parcelRegister("2K066", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", function () { return $1feff4057a6d0a04$export$fd7e0dd2b74807f7; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $6ur0l = parcelRequire("6ur0l");

var $8ugWp = parcelRequire("8ugWp");

var $gH2Lz = parcelRequire("gH2Lz");

var $bBccw = parcelRequire("bBccw");

var $81iho = parcelRequire("81iho");

var $99MaC = parcelRequire("99MaC");

var $9T4Iu = parcelRequire("9T4Iu");

var $lXnVT = parcelRequire("lXnVT");

var $kwEzm = parcelRequire("kwEzm");

var $fSWc9 = parcelRequire("fSWc9");
function $1feff4057a6d0a04$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1feff4057a6d0a04$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1feff4057a6d0a04$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1feff4057a6d0a04$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1feff4057a6d0a04$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1feff4057a6d0a04$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1feff4057a6d0a04$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1feff4057a6d0a04$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1feff4057a6d0a04$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1feff4057a6d0a04$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $1feff4057a6d0a04$export$fd7e0dd2b74807f7 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, themeOverridePreferences, overrideThemeCssLoadingTasks, mode, attrOfMissingCustomStyles, _iterator, _step, themeId, overrideThemeCss, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($1feff4057a6d0a04$var$_objectSpread($1feff4057a6d0a04$var$_objectSpread({}, (0, $gH2Lz.themeStateDefaults)), {}, {
                        typography: (0, $gH2Lz.themeStateDefaults)['typography'],
                        shape: (0, $gH2Lz.themeStateDefaults)['shape'],
                        motion: (0, $gH2Lz.themeStateDefaults)['motion']()
                    }, (0, $8ugWp.getGlobalTheme)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $gH2Lz.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $gH2Lz.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $gH2Lz.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $gH2Lz.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $gH2Lz.themeStateDefaults)['shape'] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $gH2Lz.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $gH2Lz.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $gH2Lz.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $gH2Lz.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $6ur0l.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $9T4Iu.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $fSWc9.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }());
                    themeOverridePreferences = (0, $99MaC.getThemeOverridePreferences)(themeState); // Start loading override CSS before the first await. It is appended only after the standard
                    // themes have loaded so that the override cascade order remains deterministic.
                    overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map(function(themeId) {
                        return (0, $kwEzm.loadThemeCss)(themeId);
                    }); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $lXnVT.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $gH2Lz.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $81iho.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("jg3Py"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    if (!themeLoader) {
                        _context3.next = 9;
                        break;
                    }
                    _iterator = $1feff4057a6d0a04$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    _context3.next = 11;
                    break;
                case 9:
                    _context3.next = 10;
                    return Promise.all(overrideThemeCssLoadingTasks);
                case 10:
                    overrideThemeCss = _context3.sent;
                    _context3.next = 11;
                    return Promise.all(themeOverridePreferences.map(function(themeId, index) {
                        return (0, $fSWc9.loadAndAppendThemeCss)(themeId, overrideThemeCss[index]);
                    }));
                case 11:
                    autoUnbind = (0, $bBccw.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 12:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("8ugWp", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $62de443287f194a1$export$813ecdf77207a053; });

var $f53LC = parcelRequire("f53LC");

var $jjBfD = parcelRequire("jjBfD");

var $kVYzc = parcelRequire("kVYzc");

var $eLqap = parcelRequire("eLqap");
function $62de443287f194a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62de443287f194a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62de443287f194a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62de443287f194a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $62de443287f194a1$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $jjBfD.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $jjBfD.THEME_DATA_ATTRIBUTE)) || '';
    return $62de443287f194a1$var$_objectSpread($62de443287f194a1$var$_objectSpread({}, (0, $eLqap.themeStringToObject)(theme)), (0, $kVYzc.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("kVYzc", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", function () { return $f3d81cd4737c8e17$export$fcfb1976c88f9f75; });

var $bLMPY = parcelRequire("bLMPY");
var $f3d81cd4737c8e17$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $bLMPY.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("bLMPY", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $8919f78d77a646d9$export$83993de8eb66733; });
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $8919f78d77a646d9$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("eLqap", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $abf9c0b07c5a5b4f$export$f19b488f7c0547ee; });

var $2qaZZ = parcelRequire("2qaZZ");

var $59oeC = parcelRequire("59oeC");

var $1EqVD = parcelRequire("1EqVD");

var $6vN7v = parcelRequire("6vN7v");
var $abf9c0b07c5a5b4f$var$customThemeOptions = 'UNSAFE_themeOptions';
var $abf9c0b07c5a5b4f$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $59oeC.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $6vN7v.isThemeKind)(kind) && (0, $1EqVD.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $abf9c0b07c5a5b4f$var$customThemeOptions) try {
            themeObject[$abf9c0b07c5a5b4f$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("bBccw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $871c9d453501df82$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $6ur0l = parcelRequire("6ur0l");

var $iBQw6 = parcelRequire("iBQw6");

var $hXACe = parcelRequire("hXACe");

var $acrtF = parcelRequire("acrtF");
function $871c9d453501df82$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $hXACe.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $hXACe.default).bind();
    } else (0, $hXACe.default).unbind();
    if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $acrtF.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $acrtF.default).bind();
        } else (0, $acrtF.default).unbind();
    }
    var themeAttributes = (0, $iBQw6.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $hXACe.default).unbind();
        if ((0, $6ur0l.fg)('platform_increased-contrast-themes')) (0, $acrtF.default).unbind();
    };
}

});
parcelRegister("hXACe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1345975812d9284$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $dH1HR = parcelRequire("dH1HR");

var $jjBfD = parcelRequire("jjBfD");

var $fSWc9 = parcelRequire("fSWc9");
var $d1345975812d9284$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $d1345975812d9284$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $jjBfD.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $d1345975812d9284$var$darkModeMql = $d1345975812d9284$var$isMatchMediaAvailable && window.matchMedia((0, $fSWc9.darkModeMediaQuery));
var $d1345975812d9284$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $cTewU.default)(this, ColorModeObserver);
        (0, $f53LC.default)(this, "unbindThemeChangeListener", null);
    }
    return (0, $avOEA.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$d1345975812d9284$var$darkModeMql) return 'light';
                return $d1345975812d9284$var$darkModeMql !== null && $d1345975812d9284$var$darkModeMql !== void 0 && $d1345975812d9284$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($d1345975812d9284$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $dH1HR.bind)($d1345975812d9284$var$darkModeMql, {
                    type: 'change',
                    listener: $d1345975812d9284$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $d1345975812d9284$var$SingletonColorModeObserver = new $d1345975812d9284$var$ColorModeObserver();
var $d1345975812d9284$export$2e2bcd8739ae039 = $d1345975812d9284$var$SingletonColorModeObserver;

});
parcelRegister("fSWc9", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $b9090a7d46d8e23e$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $b9090a7d46d8e23e$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $b9090a7d46d8e23e$export$8662df6937d86fcb; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $jjBfD = parcelRequire("jjBfD");

var $kwEzm = parcelRequire("kwEzm");
var $b9090a7d46d8e23e$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId, preloadedThemeCss) {
        var themeCss, style, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $jjBfD.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $jjBfD.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (!(preloadedThemeCss !== null && preloadedThemeCss !== void 0)) {
                        _context.next = 3;
                        break;
                    }
                    _t = preloadedThemeCss;
                    _context.next = 5;
                    break;
                case 3:
                    _context.next = 4;
                    return (0, $kwEzm.loadThemeCss)(themeId);
                case 4:
                    _t = _context.sent;
                case 5:
                    themeCss = _t;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $b9090a7d46d8e23e$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $b9090a7d46d8e23e$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("kwEzm", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", function () { return $ef1644083537ec46$export$8a48286ed7df6720; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $HiS0K = parcelRequire("HiS0K");
var $ef1644083537ec46$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $HiS0K.default)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("HiS0K", function(module, exports) {
$parcel$export(module.exports, "themeImportMap", function () { return $0822a77c14165a81$export$3a171c49f8c16356; });
$parcel$export(module.exports, "default", function () { return $0822a77c14165a81$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::3f58b313f1e628496675dd91b81ecfa1>>
 * @codegenCommand yarn build tokens
 */ 
















var $0822a77c14165a81$export$3a171c49f8c16356 = {
    'light': function light() {
        return (parcelRequire("3wgMe"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("fjLTv"));
    },
    'light-finesse': function lightFinesse() {
        return (parcelRequire("03rNC"));
    },
    'light-increased-contrast-finesse': function lightIncreasedContrastFinesse() {
        return (parcelRequire("bCW93"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("5G2En"));
    },
    'UNSAFE-test-light': function UNSAFETestLight() {
        return (parcelRequire("SI6zO"));
    },
    'UNSAFE-test-dark': function UNSAFETestDark() {
        return (parcelRequire("3AWwB"));
    },
    'dark': function dark() {
        return (parcelRequire("25bNp"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("fD5jk"));
    },
    'dark-finesse': function darkFinesse() {
        return (parcelRequire("bHOWA"));
    },
    'dark-increased-contrast-finesse': function darkIncreasedContrastFinesse() {
        return (parcelRequire("zMtn5"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("5pP8i"));
    },
    'spacing': function spacing() {
        return (parcelRequire("dC9R5"));
    },
    'typography': function typography() {
        return (parcelRequire("5QvJh"));
    },
    'typography-finesse': function typographyFinesse() {
        return (parcelRequire("j3MGU"));
    },
    'shape': function shape() {
        return (parcelRequire("h176r"));
    },
    'motion': function motion() {
        return (parcelRequire("Y4dHI"));
    }
};
var $0822a77c14165a81$export$2e2bcd8739ae039 = $0822a77c14165a81$export$3a171c49f8c16356;

});
parcelRegister("3wgMe", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("43436").then(()=>parcelRequire('iXba8'));

});

parcelRegister("fjLTv", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("eJJlC").then(()=>parcelRequire('ftfYG'));

});

parcelRegister("03rNC", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("k93p5").then(()=>parcelRequire('8dXKB'));

});

parcelRegister("bCW93", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("jaVsw").then(()=>parcelRequire('hHV8C'));

});

parcelRegister("5G2En", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("8mSHS").then(()=>parcelRequire('7K7J2'));

});

parcelRegister("SI6zO", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("63oAD").then(()=>parcelRequire('47bgx'));

});

parcelRegister("3AWwB", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("ghG2L").then(()=>parcelRequire('sUeBx'));

});

parcelRegister("25bNp", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("hG94b").then(()=>parcelRequire('neBMq'));

});

parcelRegister("fD5jk", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("2BJKb").then(()=>parcelRequire('ievS5'));

});

parcelRegister("bHOWA", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("83GcA").then(()=>parcelRequire('i1O1u'));

});

parcelRegister("zMtn5", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("8OpZE").then(()=>parcelRequire('9tikk'));

});

parcelRegister("5pP8i", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("ah4S5").then(()=>parcelRequire('iZwIX'));

});

parcelRegister("dC9R5", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("j7cyv").then(()=>parcelRequire('eAkXP'));

});

parcelRegister("5QvJh", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("bH6Zj").then(()=>parcelRequire('g70ly'));

});

parcelRegister("j3MGU", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("2iHCK").then(()=>parcelRequire('8oYoO'));

});

parcelRegister("h176r", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("gRRrC").then(()=>parcelRequire('97VPy'));

});

parcelRegister("Y4dHI", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("4vFpj").then(()=>parcelRequire('ft03R'));

});





parcelRegister("acrtF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76d056d96b0db6f4$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $dH1HR = parcelRequire("dH1HR");

var $jjBfD = parcelRequire("jjBfD");

var $fSWc9 = parcelRequire("fSWc9");
var $76d056d96b0db6f4$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $76d056d96b0db6f4$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $jjBfD.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $76d056d96b0db6f4$var$contrastModeMql = $76d056d96b0db6f4$var$isMatchMediaAvailable && window.matchMedia((0, $fSWc9.moreContrastMediaQuery));
var $76d056d96b0db6f4$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $cTewU.default)(this, ContrastModeObserver);
        (0, $f53LC.default)(this, "unbindContrastChangeListener", null);
    }
    return (0, $avOEA.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$76d056d96b0db6f4$var$contrastModeMql) return 'no-preference';
                return $76d056d96b0db6f4$var$contrastModeMql !== null && $76d056d96b0db6f4$var$contrastModeMql !== void 0 && $76d056d96b0db6f4$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($76d056d96b0db6f4$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $dH1HR.bind)($76d056d96b0db6f4$var$contrastModeMql, {
                    type: 'change',
                    listener: $76d056d96b0db6f4$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $76d056d96b0db6f4$var$SingletonContrastModeObserver = new $76d056d96b0db6f4$var$ContrastModeObserver();
var $76d056d96b0db6f4$export$2e2bcd8739ae039 = $76d056d96b0db6f4$var$SingletonContrastModeObserver;

});


parcelRegister("81iho", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $5d6c98a8f86dcfa2$export$bd1ac9300b0e885a; });

var $jjBfD = parcelRequire("jjBfD");

var $2kjN1 = parcelRequire("2kjN1");
function $5d6c98a8f86dcfa2$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $2kjN1.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $jjBfD.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $jjBfD.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("99MaC", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $6aaa51e92c470bea$export$5d76d7014f4a5d08; });

var $lFOXD = parcelRequire("lFOXD");

var $6ur0l = parcelRequire("6ur0l");

var $bEX7i = parcelRequire("bEX7i");
var $6aaa51e92c470bea$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
var $6aaa51e92c470bea$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(themeState) {
    if (!(0, $6ur0l.fg)('platform-dst-tokens-finesse')) return [];
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, typography = themeState.typography;
    var selectedThemes = [].concat((0, $lFOXD.default)(colorMode === 'auto' ? [
        light,
        dark
    ] : [
        themeState[colorMode]
    ]), [
        typography
    ]);
    if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) selectedThemes.forEach(function(themeId) {
        var increasedContrastTheme = (0, $bEX7i.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    var themeOverridePreferences = selectedThemes.map(function(themeId) {
        return $6aaa51e92c470bea$var$finesseOverrides[themeId];
    }).filter(function(themeId) {
        return themeId !== undefined;
    });
    return (0, $lFOXD.default)(new Set(themeOverridePreferences));
};

});
parcelRegister("bEX7i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87d1497e325dd814$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $lQ3R2 = parcelRequire("lQ3R2");
function $87d1497e325dd814$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $lQ3R2.default)).find(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});
parcelRegister("lQ3R2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe6171b2a2239c6b$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $eA4yj = parcelRequire("eA4yj");


/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ // Retain Themes in this public type for backwards compatibility.
// platform-dst-tokens-finesse cleanup: Revisit when the temporary override themes are removed.
/**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $fe6171b2a2239c6b$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $fe6171b2a2239c6b$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
var $fe6171b2a2239c6b$export$92ba366331403db2 = [].concat((0, $lFOXD.default)((0, $eA4yj.themeIds)), $fe6171b2a2239c6b$export$ba8a43b83ecc69f8);
var $fe6171b2a2239c6b$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'UNSAFE-test-light': {
        id: 'UNSAFE-test-light',
        displayName: 'UNSAFE Test Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-test-dark': {
        id: 'UNSAFE-test-dark',
        displayName: 'UNSAFE Test Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$fe6171b2a2239c6b$export$2e2bcd8739ae039 = $fe6171b2a2239c6b$export$9d64ff89b6869900;

});



parcelRegister("9T4Iu", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", function () { return $732ce8bff6260daf$export$dd6aeb7c823fc03d; });

var $lFOXD = parcelRequire("lFOXD");

var $6ur0l = parcelRequire("6ur0l");

var $bEX7i = parcelRequire("bEX7i");
var $732ce8bff6260daf$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $bEX7i.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $6ur0l.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $bEX7i.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $lFOXD.default)(new Set(themePreferences));
};

});

parcelRegister("jg3Py", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("5EkjC").then(()=>parcelRequire('cYtbv'));

});


parcelRegister("4OnvQ", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", function () { return $380e1213ae360336$export$a782702263f77544; });

var $1oC0p = parcelRequire("1oC0p");

var $5QqF5 = parcelRequire("5QqF5");
var $380e1213ae360336$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $1oC0p.useContext)((0, $5QqF5.AppProviderThemingEnabledContext));
};

});
parcelRegister("5QqF5", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", function () { return $44167d8609deb2bf$export$d2def9838ca456c0; });

var $1oC0p = parcelRequire("1oC0p");
var $44167d8609deb2bf$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});


parcelRegister("eWZzw", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", function () { return $ae263e644fe1418d$export$26aa23367bfbab0e; });

var $1oC0p = parcelRequire("1oC0p");

var $2dHig = parcelRequire("2dHig");
var $ae263e644fe1418d$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $1oC0p.useContext)((0, $2dHig.InsideAppProviderContext));
};

});
parcelRegister("2dHig", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", function () { return $19de60e0bc3c11e0$export$7981b2444296e410; });

var $1oC0p = parcelRequire("1oC0p");
var $19de60e0bc3c11e0$export$7981b2444296e410 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});


parcelRegister("7JjSk", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", function () { return $5a0c273476ca8a47$export$49ddd74a6729fdb0; });

var $1oC0p = parcelRequire("1oC0p");
var $5a0c273476ca8a47$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("kjffU", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", function () { return $ec916a6f8c227b21$export$332347eeb335453c; });

var $1oC0p = parcelRequire("1oC0p");
var $ec916a6f8c227b21$export$332347eeb335453c = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});

parcelRegister("795rY", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", function () { return $533d99f603436175$export$b06130bad0bbc70f; });

var $1oC0p = parcelRequire("1oC0p");
var $533d99f603436175$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("cbdws", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", function () { return $8de100647380fb77$export$2c657da244d00bd6; });
$parcel$export(module.exports, "SetThemeContext", function () { return $8de100647380fb77$export$f7a97b47760e2a13; });

var $1oC0p = parcelRequire("1oC0p");
var $8de100647380fb77$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $8de100647380fb77$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("bQvvU", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", function () { return $89fcfeffea3929bd$export$7ca11437599d653d; });

var $1oC0p = parcelRequire("1oC0p");

var $kjffU = parcelRequire("kjffU");
var $89fcfeffea3929bd$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $1oC0p.useContext)((0, $kjffU.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

});

parcelRegister("dRpYb", function(module, exports) {
$parcel$export(module.exports, "getInlineThemeStyles", function () { return $a1745ea064f21bf4$export$ae40e6ba718781b9; });

var $lFOXD = parcelRequire("lFOXD");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $HiS0K = parcelRequire("HiS0K");

var $99MaC = parcelRequire("99MaC");

var $9T4Iu = parcelRequire("9T4Iu");
function $a1745ea064f21bf4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1745ea064f21bf4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1745ea064f21bf4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1745ea064f21bf4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * TODO: Remove this React 18 compatibility guard when React 19 has shipped everywhere.
 * At that point, use `import { use } from 'react'` directly.
 */ var $a1745ea064f21bf4$var$themeCssPromises = new Map();
function $a1745ea064f21bf4$var$getThemeCssPromise(themeId) {
    var themeCssPromise = $a1745ea064f21bf4$var$themeCssPromises.get(themeId);
    if (!themeCssPromise) {
        themeCssPromise = (0, $HiS0K.themeImportMap)[themeId]().then(function(_ref) {
            var css = _ref.default;
            return css;
        });
        $a1745ea064f21bf4$var$themeCssPromises.set(themeId, themeCssPromise);
    }
    return themeCssPromise;
}
function $a1745ea064f21bf4$var$getInlineThemeCss(themeId) {
    var _document$body$queryS, _document$body$queryS2;
    var reactUse = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).use;
    var isServer = globalThis.__SERVER__ === true || typeof document === 'undefined';
    if (isServer) return reactUse === null || reactUse === void 0 ? void 0 : reactUse($a1745ea064f21bf4$var$getThemeCssPromise(themeId));
    return (_document$body$queryS = (_document$body$queryS2 = document.body.querySelector("style[data-theme=\"".concat(themeId, "\"]"))) === null || _document$body$queryS2 === void 0 ? void 0 : _document$body$queryS2.textContent) !== null && _document$body$queryS !== void 0 ? _document$body$queryS : undefined;
}
function $a1745ea064f21bf4$export$ae40e6ba718781b9(theme, colorMode) {
    var themeState = $a1745ea064f21bf4$var$_objectSpread($a1745ea064f21bf4$var$_objectSpread({}, theme), {}, {
        colorMode: colorMode,
        contrastMode: 'no-preference'
    });
    var themeIds = [].concat((0, $lFOXD.default)((0, $9T4Iu.getThemePreferences)(themeState)), (0, $lFOXD.default)((0, $99MaC.getThemeOverridePreferences)(themeState)));
    return (0, $lFOXD.default)(new Set(themeIds)).map(function(themeId) {
        var css = $a1745ea064f21bf4$var$getInlineThemeCss(themeId);
        return css ? {
            id: themeId,
            css: css
        } : undefined;
    }).filter(function(style) {
        return style !== undefined;
    });
}

});

parcelRegister("1n3Ss", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", function () { return $0ffaf263320f8972$export$7d4a7e812d176b24; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $fUlfp = parcelRequire("fUlfp");

var $HiS0K = parcelRequire("HiS0K");

var $ZCDzu = parcelRequire("ZCDzu");
var $0ffaf263320f8972$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $ZCDzu.isThemeMounted)(themeId)) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $HiS0K.themeImportMap)[themeId]();
                case 3:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $0ffaf263320f8972$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $fUlfp.getDocument)();
                    if (doc) {
                        _context2.next = 1;
                        break;
                    }
                    return _context2.abrupt("return");
                case 1:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $ZCDzu.isThemeMounted)(themeId)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return");
                case 2:
                    doc.head.appendChild(style);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $0ffaf263320f8972$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 1;
                    return $0ffaf263320f8972$var$loadThemeCss(themeId);
                case 1:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return");
                case 2:
                    $0ffaf263320f8972$var$mountThemeCss(themeCss, themeId);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $0ffaf263320f8972$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($0ffaf263320f8972$var$loadAndMountThemeCss);
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();

});
parcelRegister("fUlfp", function(module, exports) {
$parcel$export(module.exports, "getDocument", function () { return $b94c914588728ad6$export$f65ca476c09acec0; });
var $b94c914588728ad6$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});

parcelRegister("ZCDzu", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", function () { return $0b93ab2c33669c7e$export$835a0dc855d02822; });

var $fUlfp = parcelRequire("fUlfp");

var $jjBfD = parcelRequire("jjBfD");
function $0b93ab2c33669c7e$export$835a0dc855d02822(themeId) {
    var doc = (0, $fUlfp.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $jjBfD.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}

});



parcelRegister("3ZjRx", function(module, exports) {
$parcel$export(module.exports, "useColorMode", function () { return $2e7679dfc804603f$export$20f3076712c8dfa; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $8ugWp = parcelRequire("8ugWp");

var $9gDXU = parcelRequire("9gDXU");

var $7JjSk = parcelRequire("7JjSk");
function $2e7679dfc804603f$export$20f3076712c8dfa() {
    var value = (0, $1oC0p.useContext)((0, $7JjSk.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $8ugWp.getGlobalTheme)();
    var _useState = (0, $1oC0p.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, $2qaZZ.default)(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $9gDXU.ThemeMutationObserver)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("9gDXU", function(module, exports) {
$parcel$export(module.exports, "ThemeMutationObserver", function () { return $6bf49bf36ae19e56$export$b741a7c3bcb1c635; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $jjBfD = parcelRequire("jjBfD");

var $8ugWp = parcelRequire("8ugWp");
var $6bf49bf36ae19e56$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $cTewU.default)(this, ThemeMutationObserver);
        (0, $f53LC.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $avOEA.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $8ugWp.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $jjBfD.THEME_DATA_ATTRIBUTE),
                            (0, $jjBfD.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $f53LC.default)($6bf49bf36ae19e56$export$b741a7c3bcb1c635, "observer", null);
(0, $f53LC.default)($6bf49bf36ae19e56$export$b741a7c3bcb1c635, "callbacks", new Set());
var $6bf49bf36ae19e56$export$2e2bcd8739ae039 = $6bf49bf36ae19e56$export$b741a7c3bcb1c635;

});


parcelRegister("82ufM", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $5da5fa563ac41fbb$export$c582005add11e141; });

var $eC2DY = parcelRequire("eC2DY");

var $i8sx5 = parcelRequire("i8sx5");
var $5da5fa563ac41fbb$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $eC2DY.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $eC2DY.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $i8sx5.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $5da5fa563ac41fbb$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $5da5fa563ac41fbb$var$getPortalParent().appendChild(container);
};

});
parcelRegister("eC2DY", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", function () { return $aa36aa507370430e$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $aa36aa507370430e$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $aa36aa507370430e$export$13f57c02915787b3; });
var $aa36aa507370430e$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $aa36aa507370430e$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $aa36aa507370430e$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("i8sx5", function(module, exports) {
$parcel$export(module.exports, "getBody", function () { return $d33f1b567b325cbe$export$135b49d4bc2964c6; });
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $d33f1b567b325cbe$export$135b49d4bc2964c6 = function getBody() {
    return document.body;
};

});


parcelRegister("EBKcp", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $07a103be22da14fc$export$26ae5ca175b4ec5a; });

var $eC2DY = parcelRequire("eC2DY");
var $07a103be22da14fc$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $eC2DY.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};

});

parcelRegister("gRcVH", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", function () { return $c45ba0215f5bcd05$export$da99f98bf3fe55b3; });

var $eC2DY = parcelRequire("eC2DY");

var $i8sx5 = parcelRequire("i8sx5");
var $c45ba0215f5bcd05$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $eC2DY.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $eC2DY.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $i8sx5.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $c45ba0215f5bcd05$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $c45ba0215f5bcd05$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("lt22j", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fa0de2cc29813219$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $kKxD1 = parcelRequire("kKxD1");

var $3ZjRx = parcelRequire("3ZjRx");

var $bQvvU = parcelRequire("bQvvU");

var $vNvbN = parcelRequire("vNvbN");

var $dYt93 = parcelRequire("dYt93");

var $gwGEc = parcelRequire("gwGEc");
function $fa0de2cc29813219$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $3ZjRx.useColorMode)();
    var isInsideThemeProvider = (0, $bQvvU.useIsInsideThemeProvider)();
    (0, $vNvbN.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $dYt93.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $gwGEc.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kKxD1.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $gUjjH.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("vNvbN", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $05f94b710f88b557$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $05f94b710f88b557$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);

});

parcelRegister("dYt93", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $a2c77c93354aff24$export$fef014d7cef9e543; });

var $eC2DY = parcelRequire("eC2DY");
var $a2c77c93354aff24$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $a2c77c93354aff24$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($a2c77c93354aff24$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $eC2DY.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("gwGEc", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", function () { return $c080b76437c244b7$export$95029ca7aca2989e; });

var $eC2DY = parcelRequire("eC2DY");

var $i8sx5 = parcelRequire("i8sx5");
var $c080b76437c244b7$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $c080b76437c244b7$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($c080b76437c244b7$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $eC2DY.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            var parent = document.createElement('div');
            parent.className = (0, $eC2DY.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $i8sx5.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});


parcelRegister("hXJTU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d13b8d508e3f00f3$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $vNvbN = parcelRequire("vNvbN");
var $d13b8d508e3f00f3$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $vNvbN.useIsomorphicLayoutEffect) : (0, $1oC0p.useEffect);
    }), _useState4 = (0, $2qaZZ.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $d13b8d508e3f00f3$export$2e2bcd8739ae039 = $d13b8d508e3f00f3$var$useIsSubsequentRender;

});

parcelRegister("bif4b", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $838d100c87bf3533$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $hrWvK = parcelRequire("hrWvK");

var $g4Kq9 = parcelRequire("g4Kq9");
var $838d100c87bf3533$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1oC0p.useEffect)(function() {
        (0, $g4Kq9.default)((0, $hrWvK.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $g4Kq9.default)((0, $hrWvK.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $838d100c87bf3533$export$2e2bcd8739ae039 = $838d100c87bf3533$var$useFirePortalEvent;

});
parcelRegister("hrWvK", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $cb4258596de11f5d$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $cb4258596de11f5d$export$80816bd900e5bd00; });
var $cb4258596de11f5d$export$ed5835cc67e87f72 = 'akPortalMount';
var $cb4258596de11f5d$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("g4Kq9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb41073ee95cd8f8$export$2e2bcd8739ae039; });
var $bb41073ee95cd8f8$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $bb41073ee95cd8f8$var$getLayerName = function getLayerName(zIndex) {
    return $bb41073ee95cd8f8$var$zIndexToName.hasOwnProperty(zIndex) ? $bb41073ee95cd8f8$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $bb41073ee95cd8f8$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $bb41073ee95cd8f8$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $bb41073ee95cd8f8$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $bb41073ee95cd8f8$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("lQXVZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe8cf1fd749dcc28$export$2e2bcd8739ae039; });
/* popper-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $f53LC = parcelRequire("f53LC");

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jDeYn = parcelRequire("jDeYn");

var $lpMZq = parcelRequire("lpMZq");

var $6ur0l = parcelRequire("6ur0l");

var $33QEL = parcelRequire("33QEL");

var $66CU3 = parcelRequire("66CU3");

var $jvvo7 = parcelRequire("jvvo7");

var $dEa2q = parcelRequire("dEa2q");
var $fe8cf1fd749dcc28$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden",
    "shouldFitViewport"
];
function $fe8cf1fd749dcc28$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe8cf1fd749dcc28$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe8cf1fd749dcc28$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe8cf1fd749dcc28$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fe8cf1fd749dcc28$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $fe8cf1fd749dcc28$var$fullWidthStyles = null;
var $fe8cf1fd749dcc28$var$wrapperStyles = {
    root: "_2rko1mok _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    fullWidth: "_1bsb1osq",
    motion: "_c71l1kw7 _1e0c1txw"
};
var $fe8cf1fd749dcc28$var$scrollableStyles = null;
var $fe8cf1fd749dcc28$var$blanketStyles = null;
var $fe8cf1fd749dcc28$var$modalStyles = null;
var $fe8cf1fd749dcc28$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var $fe8cf1fd749dcc28$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
var $fe8cf1fd749dcc28$var$DefaultPopupComponent = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, _isReferenceHidden = props.isReferenceHidden, shouldFitViewport = props.shouldFitViewport, htmlAttributes = (0, $gnQ3X.default)(props, $fe8cf1fd749dcc28$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2jatx.default)([
            $fe8cf1fd749dcc28$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: !(0, $6ur0l.fg)('platform-dst-motion-uplift-popup') ? ref : undefined
    }), children);
});
function $fe8cf1fd749dcc28$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $fe8cf1fd749dcc28$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, zIndex = _ref.zIndex;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(null), _useState4 = (0, $2qaZZ.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $dEa2q.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $jvvo7.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $jDeYn.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, $lFOXD.default)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $33QEL.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $1oC0p.createElement(PopupContainer, {
            className: (0, $2jatx.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $6ur0l.fg)('platform-design-system-apply-popup-wrapper-focus') && $fe8cf1fd749dcc28$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: !(0, $6ur0l.fg)('platform-dst-motion-uplift-popup') ? function(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            } : undefined,
            style: (0, $6ur0l.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $1oC0p.createElement((0, $66CU3.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        var isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
        var container = /*#__PURE__*/ $1oC0p.createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $fe8cf1fd749dcc28$var$_objectSpread($fe8cf1fd749dcc28$var$_objectSpread({}, style), {}, {
                zIndex: zIndex
            }),
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            "data-testid": "".concat(testId, "--container"),
            className: (0, $2jatx.default)([
                shouldFitContainer && $fe8cf1fd749dcc28$var$wrapperStyles.fullWidth
            ])
        }, /*#__PURE__*/ $1oC0p.createElement((0, $lpMZq.default), {
            enteringAnimation: !isAutoPlacement ? $fe8cf1fd749dcc28$var$placementMap[placement].enter : undefined,
            exitingAnimation: !isAutoPlacement ? $fe8cf1fd749dcc28$var$placementMap[placement].exit : undefined,
            xcss: $fe8cf1fd749dcc28$var$wrapperStyles.motion
        }, popupContainer));
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, (0, $6ur0l.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $1oC0p.createElement("div", {
            className: (0, $2jatx.default)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fe8cf1fd749dcc28$export$2e2bcd8739ae039 = $fe8cf1fd749dcc28$var$PopperWrapper;

});
parcelRegister("jDeYn", function(module, exports) {
$parcel$export(module.exports, "useLayering", function () { return $e4ad4622981096cb$export$c8b4d54e03dee6ed; });

var $1oC0p = parcelRequire("1oC0p");

var $3a4pi = parcelRequire("3a4pi");

var $jilM0 = parcelRequire("jilM0");

var $bA8Md = parcelRequire("bA8Md");
function $e4ad4622981096cb$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $1oC0p.useContext)((0, $3a4pi.LevelContext));
    var layerNode = (0, $1oC0p.useContext)((0, $jilM0.LevelNodeContext));
    var rootNode = (0, $1oC0p.useContext)((0, $bA8Md.RootNodeContext));
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $1oC0p.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("lpMZq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f971ef1ce8575c78$export$2e2bcd8739ae039; });
/* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $4ZpaI = parcelRequire("4ZpaI");

var $kPutE = parcelRequire("kPutE");

var $6ur0l = parcelRequire("6ur0l");

var $8525t = parcelRequire("8525t");

var $6CsLI = parcelRequire("6CsLI");

var $dAWGc = parcelRequire("dAWGc");

var $b04Ht = parcelRequire("b04Ht");

var $dkxqd = parcelRequire("dkxqd");

var $es1Aw = parcelRequire("es1Aw");

var $g4KeR = parcelRequire("g4KeR");

var $87TD9 = parcelRequire("87TD9");
function $f971ef1ce8575c78$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f971ef1ce8575c78$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f971ef1ce8575c78$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f971ef1ce8575c78$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f971ef1ce8575c78$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ var $f971ef1ce8575c78$var$MotionLegacy = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, enteringAnimation = _ref.enteringAnimation, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimation = _ref.exitingAnimation, exitingAnimationXcss = _ref.exitingAnimationXcss, onFinishMotion = _ref.onFinish, xcss = _ref.xcss, styleProp = _ref.style, testId = _ref.testId;
    var staggered = (0, $87TD9.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $es1Aw.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggedIsReady = staggered.isReady;
    var _useState = (0, $1oC0p.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $1oC0p.useRef)(null);
    var reanimateRef = (0, $1oC0p.useRef)();
    var animationRef = (0, $1oC0p.useRef)();
    var staggeredEntryRef = (0, $1oC0p.useRef)();
    (0, $1oC0p.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $1oC0p.useEffect)(function() {
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $1oC0p.useCallback)(function(state, cancelled) {
        // We are done animating, so we set the state to idle
        var newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $dkxqd.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $dkxqd.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $dAWGc.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $6CsLI.getDurationMs)((0, $b04Ht.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var _styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $8525t.getComputedAnimationDurationMs)(_styles.animationName, _styles.animationDuration, _styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $1oC0p.useImperativeHandle)(ref, function() {
        return {
            reanimate: function reanimate(value) {
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $dkxqd.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $dkxqd.Reanimate).enter) setState('entering');
            }
        };
    });
    var style = {};
    var customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    var hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2jatx.default)([
            hasAnimationStyles && $f971ef1ce8575c78$var$styles.base,
            state === 'init' && $f971ef1ce8575c78$var$styles.hidden,
            (0, $4ZpaI.cx)(xcss, customAnimation)
        ]),
        ref: (0, $kPutE.default)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: styleProp || hasAnimationStyles ? $f971ef1ce8575c78$var$_objectSpread($f971ef1ce8575c78$var$_objectSpread({}, styleProp), style) : undefined,
        "data-testid": testId
    }, children);
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ var $f971ef1ce8575c78$var$MotionNext = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, enteringAnimation = _ref2.enteringAnimation, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimation = _ref2.exitingAnimation, exitingAnimationXcss = _ref2.exitingAnimationXcss, onFinishMotion = _ref2.onFinish, xcss = _ref2.xcss, styleProp = _ref2.style, testId = _ref2.testId;
    var _useMotion = (0, $g4KeR.useMotion)({
        onFinish: onFinishMotion
    }), state = _useMotion.state, motionRef = _useMotion.ref, reanimate = _useMotion.reanimate;
    (0, $1oC0p.useImperativeHandle)(ref, function() {
        return {
            reanimate: reanimate
        };
    }, [
        reanimate
    ]);
    // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2jatx.default)([
            state === 'init' && $f971ef1ce8575c78$var$styles.hidden,
            (0, $4ZpaI.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: $f971ef1ce8575c78$var$_objectSpread($f971ef1ce8575c78$var$_objectSpread({}, styleProp), {}, {
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        }),
        "data-testid": testId
    }, children);
});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ var $f971ef1ce8575c78$var$Motion = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    if ((0, $6ur0l.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($f971ef1ce8575c78$var$MotionNext, (0, $c9bqK.default)({}, props, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($f971ef1ce8575c78$var$MotionLegacy, (0, $c9bqK.default)({}, props, {
        ref: ref
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f971ef1ce8575c78$export$2e2bcd8739ae039 = $f971ef1ce8575c78$var$Motion;

});
parcelRegister("8525t", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", function () { return $5e2068df01a9fbd1$export$dd9b73a7482d05b6; });

var $kQxaZ = parcelRequire("kQxaZ");
var $5e2068df01a9fbd1$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $5e2068df01a9fbd1$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $5e2068df01a9fbd1$var$toTimeList = function toTimeList(value) {
    return $5e2068df01a9fbd1$var$toCssList(value).filter(function(time) {
        return $5e2068df01a9fbd1$var$cssTimePattern.test(time);
    }).map((0, $kQxaZ.convertToMs));
};
var $5e2068df01a9fbd1$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $5e2068df01a9fbd1$var$toCssList(animationName);
    var durations = $5e2068df01a9fbd1$var$toTimeList(animationDuration);
    var delays = $5e2068df01a9fbd1$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("kQxaZ", function(module, exports) {
$parcel$export(module.exports, "convertToMs", function () { return $f2d266156018cd35$export$75eee42ff540d8ae; });
var $f2d266156018cd35$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("6CsLI", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", function () { return $4d1c9b83facf4ab9$export$d0038b6e47881463; });

var $lFOXD = parcelRequire("lFOXD");
var $4d1c9b83facf4ab9$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, $lFOXD.default)(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("dAWGc", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $9e5c27b5695b3c0d$export$b7baf7667a68d87c; });

var $cxGQQ = parcelRequire("cxGQQ");
var $9e5c27b5695b3c0d$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $cxGQQ.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("cxGQQ", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", function () { return $9219ce7b59c90ff4$export$c5406bd59b374abd; });
var $9219ce7b59c90ff4$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("b04Ht", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", function () { return $8023572adc5346e8$export$82b92541889a035d; });

var $fUlfp = parcelRequire("fUlfp");
var $8023572adc5346e8$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $fUlfp.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("dkxqd", function(module, exports) {
$parcel$export(module.exports, "Reanimate", function () { return $9b471185cf51a898$export$569340a66b14e0dc; });
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $9b471185cf51a898$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("es1Aw", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", function () { return $a854e98df3b98efb$export$3b6f38abbdcbd000; });

var $1oC0p = parcelRequire("1oC0p");

var $7XTnT = parcelRequire("7XTnT");
var $a854e98df3b98efb$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1oC0p.useContext)((0, $7XTnT.ExitingContext));
};

});

parcelRegister("g4KeR", function(module, exports) {
$parcel$export(module.exports, "useMotion", function () { return $bb40e319cf16894e$export$2a51cfe9390d36ef; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $kPutE = parcelRequire("kPutE");

var $8525t = parcelRequire("8525t");

var $6CsLI = parcelRequire("6CsLI");

var $dAWGc = parcelRequire("dAWGc");

var $b04Ht = parcelRequire("b04Ht");

var $7QexR = parcelRequire("7QexR");

var $dkxqd = parcelRequire("dkxqd");

var $es1Aw = parcelRequire("es1Aw");

var $87TD9 = parcelRequire("87TD9");
function $bb40e319cf16894e$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, onStartMotion = _ref.onStart, initialState = _ref.initialState;
    var reducedMotion = (0, $dAWGc.isReducedMotion)();
    var staggered = (0, $87TD9.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $es1Aw.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $1oC0p.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    var motionState = isExiting ? 'exiting' : state;
    var elementRef = (0, $1oC0p.useRef)(null);
    var onStartMotionRef = (0, $1oC0p.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    var reanimateRef = (0, $1oC0p.useRef)();
    var animationRef = (0, $1oC0p.useRef)();
    var staggeredEntryRef = (0, $1oC0p.useRef)();
    (0, $7QexR.useLayoutEffect)(function() {
        if (motionState === 'exiting') {
            var _onStartMotionRef$cur;
            (_onStartMotionRef$cur = onStartMotionRef.current) === null || _onStartMotionRef$cur === void 0 || _onStartMotionRef$cur.call(onStartMotionRef, 'exiting');
        }
        if (motionState === 'entering') {
            var _onStartMotionRef$cur2;
            (_onStartMotionRef$cur2 = onStartMotionRef.current) === null || _onStartMotionRef$cur2 === void 0 || _onStartMotionRef$cur2.call(onStartMotionRef, 'entering');
        }
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $1oC0p.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $dkxqd.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $dkxqd.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $dkxqd.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $dkxqd.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $1oC0p.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $6CsLI.getDurationMs)((0, $b04Ht.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $8525t.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $1oC0p.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $dkxqd.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $dkxqd.Reanimate).enter) setState('entering');
        else if (value === (0, $dkxqd.Reanimate).exit) setState('exiting');
    }, []);
    var ref = (0, $1oC0p.useMemo)(function() {
        return (0, $kPutE.default)([
            staggered.ref,
            elementRef
        ]);
    }, [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});
parcelRegister("7QexR", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $5b58ac1a9794668b$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $5b58ac1a9794668b$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("87TD9", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", function () { return $5eaa213d5e3ceea2$export$25c7213fc07ec080; });

var $1oC0p = parcelRequire("1oC0p");

var $ivdUU = parcelRequire("ivdUU");

var $aFjyR = parcelRequire("aFjyR");
var $5eaa213d5e3ceea2$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $ivdUU.useUniqueId)();
    var context = (0, $1oC0p.useContext)((0, $aFjyR.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("ivdUU", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", function () { return $d785ead4224a9f97$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1oC0p = parcelRequire("1oC0p");
function $d785ead4224a9f97$export$c485849f2e393253() {
    var identifier = (0, $1oC0p.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("aFjyR", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", function () { return $7c3ce827c11e0e29$export$5e65d7d58ae96ad8; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $7QexR = parcelRequire("7QexR");
var $7c3ce827c11e0e29$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $7uNuF.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $7c3ce827c11e0e29$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1oC0p.useRef)([]);
    var indexes = [];
    var _useState = (0, $1oC0p.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $2qaZZ.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $7QexR.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($7c3ce827c11e0e29$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7c3ce827c11e0e29$export$2e2bcd8739ae039 = $7c3ce827c11e0e29$var$StaggeredEntrance;

});




parcelRegister("33QEL", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $23aa7f67e10caa0f$export$badac9ada3a0bdf9; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $eVddu = parcelRequire("eVddu");

var $6ur0l = parcelRequire("6ur0l");

var $fUgjR = parcelRequire("fUgjR");

var $8WnrL = parcelRequire("8WnrL");

// Export types from PopperJS / React Popper
var $23aa7f67e10caa0f$var$viewportPadding = 5;
var $23aa7f67e10caa0f$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $23aa7f67e10caa0f$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $23aa7f67e10caa0f$var$defaultChildrenFn() {
    return null;
}
var $23aa7f67e10caa0f$var$defaultOffset = [
    0,
    8
];
function $23aa7f67e10caa0f$export$badac9ada3a0bdf9(_ref) {
    var children = _ref.children, offset = _ref.offset, placement = _ref.placement, referenceElement = _ref.referenceElement, modifiers = _ref.modifiers, strategy = _ref.strategy, shouldFitViewport = _ref.shouldFitViewport;
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $6ur0l.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8WnrL.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($23aa7f67e10caa0f$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $23aa7f67e10caa0f$var$LegacyPopper(_ref2) {
    var _ref2$children = _ref2.children, children = _ref2$children === void 0 ? $23aa7f67e10caa0f$var$defaultChildrenFn : _ref2$children, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? $23aa7f67e10caa0f$var$defaultOffset : _ref2$offset, _ref2$placement = _ref2.placement, placement = _ref2$placement === void 0 ? 'bottom-start' : _ref2$placement, _ref2$referenceElemen = _ref2.referenceElement, referenceElement = _ref2$referenceElemen === void 0 ? undefined : _ref2$referenceElemen, modifiers = _ref2.modifiers, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$shouldFitViewpo = _ref2.shouldFitViewport, shouldFitViewport = _ref2$shouldFitViewpo === void 0 ? false : _ref2$shouldFitViewpo;
    var _offset = (0, $2qaZZ.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $23aa7f67e10caa0f$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $fUgjR.getMaxSizeModifiers)({
            viewportPadding: $23aa7f67e10caa0f$var$viewportPadding
        }) : [];
        return [].concat($23aa7f67e10caa0f$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $lFOXD.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $lFOXD.default)(internalModifiers), (0, $lFOXD.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eVddu.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("fUgjR", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $b948beaaf8326db9$export$6d8c2b45c99d6e3f; });

var $2qaZZ = parcelRequire("2qaZZ");
function $b948beaaf8326db9$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $2qaZZ.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});

parcelRegister("8WnrL", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", function () { return $6825ed89dc36f24e$export$9802f50720ab826e; });
/* popper-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2qaZZ = parcelRequire("2qaZZ");


var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $iJOpE = parcelRequire("iJOpE");

var $2hswD = parcelRequire("2hswD");

var $hVgGY = parcelRequire("hVgGY");

var $beBxD = parcelRequire("beBxD");

var $7dAij = parcelRequire("7dAij");

var $8pQ5I = parcelRequire("8pQ5I");

var $lvzf5 = parcelRequire("lvzf5");

var $i0Hrf = parcelRequire("i0Hrf");

var $8ZsIn = parcelRequire("8ZsIn");

var $fvtGZ = parcelRequire("fvtGZ");

var $cBqiy = parcelRequire("cBqiy");

var $4jo0m = parcelRequire("4jo0m");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ var $6825ed89dc36f24e$var$noopStyle = {};
var $6825ed89dc36f24e$var$noopSetRef = (0, $7uNuF.default);
var $6825ed89dc36f24e$var$noopUpdate = function noopUpdate() {
    return Promise.resolve(null);
};
var $6825ed89dc36f24e$var$noopForceUpdate = function noopForceUpdate() {
    return {};
};
/**
 * `react-popper` stamps `data-popper-arrow` on the arrow element at runtime
 * but does not declare it on `arrowProps`. Widen the type so consumers that
 * rely on the attribute (CSS selectors, snapshots, tests) keep working.
 */ var $6825ed89dc36f24e$var$noopArrowProps = {
    ref: $6825ed89dc36f24e$var$noopSetRef,
    style: $6825ed89dc36f24e$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function $6825ed89dc36f24e$var$getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $6825ed89dc36f24e$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    var _offset = (0, $2qaZZ.default)(offset, 2), along = _offset[0], away = _offset[1];
    if (along == null && away == null) return undefined;
    return [
        along !== null && along !== void 0 ? along : 0,
        away !== null && away !== void 0 ? away : 0
    ];
}
function $6825ed89dc36f24e$export$9802f50720ab826e(_ref) {
    var _ref2;
    var children = _ref.children, offset = _ref.offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, referenceElement = _ref.referenceElement, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    var managerAnchor = (0, $cBqiy.useManagerAnchor)();
    var effectiveReference = (_ref2 = referenceElement !== null && referenceElement !== void 0 ? referenceElement : managerAnchor) !== null && _ref2 !== void 0 ? _ref2 : undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    var htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    var virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    var htmlAnchorRef = (0, $1oC0p.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    var popoverRef = (0, $1oC0p.useRef)(null);
    var popoverId = (0, $7dAij.usePopoverId)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    var _useState = (0, $1oC0p.useState)(htmlAnchor), _useState2 = (0, $2qaZZ.default)(_useState, 2), resolvedAnchor = _useState2[0], setResolvedAnchor = _useState2[1];
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    var topLayerPlacement = (0, $1oC0p.useMemo)(function() {
        return (0, $iJOpE.fromLegacyPlacement)({
            legacy: (0, $8ZsIn.toLegacyPlacement)(placement),
            offset: $6825ed89dc36f24e$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    var isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, $hVgGY.useAnchorPosition)({
        anchorRef: htmlAnchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen: isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    var virtualReferenceRef = (0, $1oC0p.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    var topLayerPlacementRef = (0, $1oC0p.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    var isVirtualEnabled = virtualReference != null;
    (0, $beBxD.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen: isOpen,
        getPoint: function getPoint() {
            var current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $i0Hrf.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $lvzf5.isPageRtl)()
            });
        }
    });
    var _useReferenceVisibili = (0, $4jo0m.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    }), isReferenceHidden = _useReferenceVisibili.isReferenceHidden, hasPopperEscaped = _useReferenceVisibili.hasPopperEscaped;
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, $8pQ5I.useWidthFromAnchor)({
        mode: 'none',
        popoverRef: popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen: isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    var resolvedOffset = $6825ed89dc36f24e$var$popperToTopLayerOffset(offset);
    var fitGap = resolvedOffset ? "".concat(resolvedOffset[1], "px") : "var(--ds-space-100, 8px)";
    var placementAxis = $6825ed89dc36f24e$var$getPlacementAxis(placement);
    (0, $fvtGZ.useFitViewportMaxSize)({
        target: popoverRef,
        placementAxis: placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen: isOpen
    });
    var renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    var renderPropArg = {
        ref: $6825ed89dc36f24e$var$noopSetRef,
        style: $6825ed89dc36f24e$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $6825ed89dc36f24e$var$noopUpdate,
        forceUpdate: $6825ed89dc36f24e$var$noopForceUpdate,
        arrowProps: $6825ed89dc36f24e$var$noopArrowProps
    };
    var content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2hswD.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false
    }, content);
}

});
parcelRegister("iJOpE", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", function () { return $da4388e67fa84bf2$export$69e99ed50b2534c9; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $gmzZA = parcelRequire("gmzZA");
function $da4388e67fa84bf2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da4388e67fa84bf2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da4388e67fa84bf2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da4388e67fa84bf2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $da4388e67fa84bf2$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $gmzZA.placementMapping)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, $2qaZZ.default)(offset, 2), along = _offset[0], away = _offset[1];
    return $da4388e67fa84bf2$var$_objectSpread($da4388e67fa84bf2$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

});
parcelRegister("gmzZA", function(module, exports) {
$parcel$export(module.exports, "placementMapping", function () { return $be9a9eba5c1a6a30$export$27df359c528b7120; });
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $be9a9eba5c1a6a30$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("2hswD", function(module, exports) {
$parcel$export(module.exports, "Popover", function () { return $1a934bdcc3451402$export$5b6b19405a83ff9d; });
/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $3sHnI = parcelRequire("3sHnI");

var $dH1HR = parcelRequire("dH1HR");

var $kPutE = parcelRequire("kPutE");

var $8zODL = parcelRequire("8zODL");

var $7I1Nq = parcelRequire("7I1Nq");

var $7diZT = parcelRequire("7diZT");

var $eVDgA = parcelRequire("eVDgA");

var $680J1 = parcelRequire("680J1");

var $a3Jv4 = parcelRequire("a3Jv4");

var $dMQW7 = parcelRequire("dMQW7");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $1a934bdcc3451402$var$supportsPopoverHint = (0, $8zODL.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $1a934bdcc3451402$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $1a934bdcc3451402$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $1a934bdcc3451402$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $1a934bdcc3451402$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $1a934bdcc3451402$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $1oC0p.useId)();
    var ownRef = (0, $1oC0p.useRef)(null);
    var combinedRef = (0, $kPutE.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $680J1.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $a3Jv4.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $dMQW7.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $1oC0p.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $7I1Nq.useNotifyOpenLayerObserver)({
        type: role && $1a934bdcc3451402$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$1a934bdcc3451402$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $1oC0p.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $7diZT.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $1a934bdcc3451402$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $1oC0p.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $1oC0p.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $1oC0p.useRef)(null);
    var handleBeforeToggle = (0, $1oC0p.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $1oC0p.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $eVDgA.shouldFocusIntoPopover)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $dH1HR.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $dH1HR.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $dH1HR.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2jatx.default)([
            $1a934bdcc3451402$var$styles.root,
            $1a934bdcc3451402$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $1a934bdcc3451402$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $1a934bdcc3451402$var$styles.exit,
            shouldAnimate && $1a934bdcc3451402$var$styles.motion,
            (0, $3sHnI.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("7I1Nq", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $59ce0929215e7d5b$export$469bb693f11edc7f; });

var $1oC0p = parcelRequire("1oC0p");

var $imjRC = parcelRequire("imjRC");

var $48PyK = parcelRequire("48PyK");
function $59ce0929215e7d5b$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $1oC0p.useContext)((0, $imjRC.OpenLayerObserverContext));
    var namespace = (0, $48PyK.useOpenLayerObserverNamespace)();
    (0, $1oC0p.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("imjRC", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $d5d9b09c6e4c9e06$export$5fbf4d7fae6cdc00; });

var $1oC0p = parcelRequire("1oC0p");
var $d5d9b09c6e4c9e06$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("48PyK", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $303fe765b2446d5a$export$1d57e79091cc3046; });

var $1oC0p = parcelRequire("1oC0p");

var $iOvTa = parcelRequire("iOvTa");
function $303fe765b2446d5a$export$1d57e79091cc3046() {
    var namespace = (0, $1oC0p.useContext)((0, $iOvTa.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("iOvTa", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $db25a1f158fb6a79$export$644a49f3b8c50fcd; });

var $1oC0p = parcelRequire("1oC0p");
var $db25a1f158fb6a79$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});



parcelRegister("7diZT", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", function () { return $015af9bd020e2c40$export$63044d21bc3d3fa2; });

var $8bYji = parcelRequire("8bYji");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $015af9bd020e2c40$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $015af9bd020e2c40$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $015af9bd020e2c40$var$DEFAULT_GAP : (0, $8bYji.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $8bYji.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("8bYji", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", function () { return $5f6e222617ba90f0$export$63b6b0ff65d84d47; });
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $5f6e222617ba90f0$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("eVDgA", function(module, exports) {
$parcel$export(module.exports, "shouldFocusIntoPopover", function () { return $ade4d9161c960874$export$b12adccf56228c71; });
var $ade4d9161c960874$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $ade4d9161c960874$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $ade4d9161c960874$var$rolesThatMoveFocus.has(role);
}

});

parcelRegister("680J1", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", function () { return $47640d6fb8f6ec3f$export$1bccb45daf07907f; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $iX2qA = parcelRequire("iX2qA");
function $47640d6fb8f6ec3f$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $47640d6fb8f6ec3f$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $47640d6fb8f6ec3f$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $47640d6fb8f6ec3f$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $iX2qA.prefersReducedMotion)();
    var isNativeClosedRef = (0, $1oC0p.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $1oC0p.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, $2qaZZ.default)(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $1oC0p.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $1oC0p.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $1oC0p.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $47640d6fb8f6ec3f$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $1oC0p.useRef)('closed');
    (0, $1oC0p.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $1oC0p.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $47640d6fb8f6ec3f$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $1oC0p.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $1oC0p.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $1oC0p.useRef)('closed');
    (0, $1oC0p.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}

});
parcelRegister("iX2qA", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", function () { return $038f7a4d8cfbc4a8$export$ff7706047246b98b; });

var $8zODL = parcelRequire("8zODL");
var $038f7a4d8cfbc4a8$export$ff7706047246b98b = (0, $8zODL.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("a3Jv4", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", function () { return $752d7a8eeb1e2070$export$4f6462e86a70abe5; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $4exwW = parcelRequire("4exwW");

var $80GK8 = parcelRequire("80GK8");

var $33SPB = parcelRequire("33SPB");

var $eqZRF = parcelRequire("eqZRF");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $752d7a8eeb1e2070$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $752d7a8eeb1e2070$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $1oC0p.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$752d7a8eeb1e2070$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $dH1HR.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $eqZRF.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $33SPB.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $4exwW.getFirstFocusable)({
                    container: element
                }) : (0, $80GK8.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("4exwW", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", function () { return $31527aab23c6f9a7$export$748138f04a69bf21; });

var $gfGxL = parcelRequire("gfGxL");
function $31527aab23c6f9a7$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $gfGxL.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("gfGxL", function(module, exports) {
$parcel$export(module.exports, "getFocusables", function () { return $bd4f0c512ac8a456$export$f6768025e418420e; });

var $bBk5x = parcelRequire("bBk5x");

var $8jeUo = parcelRequire("8jeUo");
function $bd4f0c512ac8a456$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $8jeUo.selectors).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $bBk5x.isInSameLayer)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}

});
parcelRegister("bBk5x", function(module, exports) {
$parcel$export(module.exports, "isInSameLayer", function () { return $8722bb8768a73fbc$export$df8c72c64edc7260; });
var $8722bb8768a73fbc$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $8722bb8768a73fbc$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($8722bb8768a73fbc$var$topLayerSelector) === container.closest($8722bb8768a73fbc$var$topLayerSelector);
}

});

parcelRegister("8jeUo", function(module, exports) {
$parcel$export(module.exports, "selectors", function () { return $60cba99f32b271f8$export$e1252723db1c541; });
var $60cba99f32b271f8$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();

});



parcelRegister("80GK8", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", function () { return $5d4f7ab2a08f925b$export$73e81fa65335a75b; });

var $gfGxL = parcelRequire("gfGxL");
function $5d4f7ab2a08f925b$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $gfGxL.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("33SPB", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", function () { return $23ac2f44ed41174d$export$a7db88e6d491b450; });
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 
var $gfGxL = parcelRequire("gfGxL");

var $8jeUo = parcelRequire("8jeUo");
function $23ac2f44ed41174d$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $gfGxL.getFocusables)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $8jeUo.selectors).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}

});

parcelRegister("eqZRF", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", function () { return $a8237b6811fc22bb$export$b9590fdfeb5f722f; });

var $fUlfp = parcelRequire("fUlfp");

var $bBk5x = parcelRequire("bBk5x");
function $a8237b6811fc22bb$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $fUlfp.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $bBk5x.isInSameLayer)({
        element: focused,
        container: container
    });
}

});


parcelRegister("dMQW7", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", function () { return $a098d221689741c0$export$e992c40175757a22; });

var $1oC0p = parcelRequire("1oC0p");

var $4exwW = parcelRequire("4exwW");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $a098d221689741c0$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $a098d221689741c0$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $a098d221689741c0$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $a098d221689741c0$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$a098d221689741c0$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $a098d221689741c0$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $4exwW.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($a098d221689741c0$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $4exwW.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($a098d221689741c0$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $4exwW.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $a098d221689741c0$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $1oC0p.useRef)('closed');
    (0, $1oC0p.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $a098d221689741c0$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("hVgGY", function(module, exports) {
$parcel$export(module.exports, "useAnchorPosition", function () { return $d0c4b543943d7568$export$56b02a1e583f953c; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $FcGYz = parcelRequire("FcGYz");

var $8zODL = parcelRequire("8zODL");

var $lGPrG = parcelRequire("lGPrG");

var $klpSn = parcelRequire("klpSn");

var $iJ7Rz = parcelRequire("iJ7Rz");

var $3I46h = parcelRequire("3I46h");

var $a2R4A = parcelRequire("a2R4A");

var $7diZT = parcelRequire("7diZT");

var $e9Tqh = parcelRequire("e9Tqh");
// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $d0c4b543943d7568$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, $cTewU.default)(this, NoopResizeObserver);
    }
    return (0, $avOEA.default)(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $d0c4b543943d7568$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $d0c4b543943d7568$var$supportsAnchorPositioning = (0, $8zODL.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $d0c4b543943d7568$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $d0c4b543943d7568$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($d0c4b543943d7568$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $d0c4b543943d7568$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $d0c4b543943d7568$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $d0c4b543943d7568$var$useStablePlacement(placement) {
    var resolved = (0, $7diZT.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $1oC0p.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $d0c4b543943d7568$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $1oC0p.useId)();
    var stablePlacement = $d0c4b543943d7568$var$useStablePlacement(placement);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($d0c4b543943d7568$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $d0c4b543943d7568$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $d0c4b543943d7568$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $iJ7Rz.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $3I46h.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, $lFOXD.default)(crossAxisShift), (0, $lFOXD.default)($d0c4b543943d7568$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, $lFOXD.default)(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $d0c4b543943d7568$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $e9Tqh.setStyle)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $e9Tqh.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $e9Tqh.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $a2R4A.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $a2R4A.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $lGPrG.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $e9Tqh.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $FcGYz.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $d0c4b543943d7568$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($d0c4b543943d7568$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $klpSn.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $dH1HR.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $dH1HR.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

});
parcelRegister("lGPrG", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", function () { return $fca56d3390b60b92$export$d5ef1dac02135664; });

var $f53LC = parcelRequire("f53LC");
function $fca56d3390b60b92$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fca56d3390b60b92$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fca56d3390b60b92$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fca56d3390b60b92$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $fca56d3390b60b92$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $fca56d3390b60b92$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $fca56d3390b60b92$var$_objectSpread($fca56d3390b60b92$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $fca56d3390b60b92$var$_objectSpread($fca56d3390b60b92$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $fca56d3390b60b92$var$_objectSpread($fca56d3390b60b92$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $fca56d3390b60b92$var$_objectSpread($fca56d3390b60b92$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $fca56d3390b60b92$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $fca56d3390b60b92$var$_objectSpread($fca56d3390b60b92$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $fca56d3390b60b92$var$_objectSpread($fca56d3390b60b92$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $fca56d3390b60b92$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $fca56d3390b60b92$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $fca56d3390b60b92$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $fca56d3390b60b92$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("klpSn", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return $ecf9d73b7be6d182$export$1be1fc439b849fdf; });
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $ecf9d73b7be6d182$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("iJ7Rz", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", function () { return $da2287622df0311d$export$de49b61f233ddeb9; });

var $7diZT = parcelRequire("7diZT");
function $da2287622df0311d$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $7diZT.resolvePlacement)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("3I46h", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", function () { return $2b38a964f16ad5cb$export$c4e16947a95d61f1; });

var $7diZT = parcelRequire("7diZT");
/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $2b38a964f16ad5cb$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $2b38a964f16ad5cb$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $2b38a964f16ad5cb$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $7diZT.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $2b38a964f16ad5cb$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $2b38a964f16ad5cb$var$flipDiagonally({
            axis: axis
        }) : null,
        $2b38a964f16ad5cb$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}

});

parcelRegister("a2R4A", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", function () { return $7503427b7dd0335e$export$98721546d2816d9e; });
var $7503427b7dd0335e$var$elementCaches = new WeakMap();
function $7503427b7dd0335e$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $7503427b7dd0335e$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$7503427b7dd0335e$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $7503427b7dd0335e$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $7503427b7dd0335e$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$7503427b7dd0335e$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $7503427b7dd0335e$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $7503427b7dd0335e$var$elementCaches.set(element, cacheForElement);
}
function $7503427b7dd0335e$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $7503427b7dd0335e$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $7503427b7dd0335e$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}

});

parcelRegister("e9Tqh", function(module, exports) {
$parcel$export(module.exports, "setStyle", function () { return $a4ece5c657b29322$export$37a5fde709c1db82; });
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $a4ece5c657b29322$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("beBxD", function(module, exports) {
$parcel$export(module.exports, "useAnchorPositionAtPoint", function () { return $82de1f7f9f15a7a2$export$6f230729189a5b8a; });

var $1oC0p = parcelRequire("1oC0p");

var $hVgGY = parcelRequire("hVgGY");
/**
 * A point in viewport coordinates (CSS pixels) at which the synthetic
 * anchor should be placed.
 *
 * Axis-named (`x`/`y`) rather than edge-named (`left`/`top`) so the
 * shape is unambiguous in RTL writing modes - there is no ambiguity
 * about whether a coordinate is logical (`inline-start`/`block-start`)
 * or physical (`left`/`top`). Viewport coordinates are always
 * physical, so we name them with the physical axis labels.
 */ /**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $82de1f7f9f15a7a2$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $82de1f7f9f15a7a2$export$6f230729189a5b8a(_ref) {
    var popoverRef = _ref.popoverRef, placement = _ref.placement, getPoint = _ref.getPoint, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, isOpen = _ref.isOpen;
    var syntheticAnchorRef = (0, $1oC0p.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    var getPointRef = (0, $1oC0p.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $1oC0p.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var point = getPointRef.current();
        if (!point) return;
        var anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $82de1f7f9f15a7a2$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = "".concat(point.y, "px");
        anchor.style.left = "".concat(point.x, "px");
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $hVgGY.useAnchorPosition)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}

});

parcelRegister("7dAij", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", function () { return $5415e69cb232433d$export$9198c6c168be2eeb; });

var $4UF4U = parcelRequire("4UF4U");
function $5415e69cb232433d$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return "popover-".concat((0, $4UF4U.useId)());
}

});

parcelRegister("8pQ5I", function(module, exports) {
$parcel$export(module.exports, "useWidthFromAnchor", function () { return $620910c6c71aa1a6$export$7071d791a7b131ed; });

var $1oC0p = parcelRequire("1oC0p");

var $8zODL = parcelRequire("8zODL");

var $e9Tqh = parcelRequire("e9Tqh");
/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $620910c6c71aa1a6$var$supportsAnchorSize = (0, $8zODL.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $620910c6c71aa1a6$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $620910c6c71aa1a6$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $1oC0p.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($620910c6c71aa1a6$var$supportsAnchorSize()) return (0, $e9Tqh.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $e9Tqh.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($620910c6c71aa1a6$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($620910c6c71aa1a6$var$supportsAnchorSize()) return (0, $e9Tqh.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $e9Tqh.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($620910c6c71aa1a6$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $e9Tqh.setStyle)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}

});

parcelRegister("lvzf5", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", function () { return $fa87d4a45715249a$export$175375e9a2b5515d; });

var $fUlfp = parcelRequire("fUlfp");
function $fa87d4a45715249a$export$175375e9a2b5515d() {
    var document = (0, $fUlfp.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("i0Hrf", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", function () { return $d1c9ec14806c2a0b$export$b065aeb850c3e87f; });
/**
 * Reduces an anchor rect to the single viewport point that, wrapped in a
 * zero-size synthetic anchor, produces the same popover position
 * `useAnchorPosition` would for the given placement. This works because
 * `useAnchorPosition` only reads the edge / alignment corner of the rect,
 * so a coincident zero-size point is geometrically equivalent.
 *
 * RTL is resolved here so the downstream synthetic anchor only sees physical
 * coordinates. Defaults mirror `getPlacement` in
 * `@atlaskit/top-layer/placement-map` (`axis: 'block'`, `edge: 'end'`,
 * `align: 'center'`).
 */ function $d1c9ec14806c2a0b$export$b065aeb850c3e87f(_ref) {
    var _placement$axis, _placement$edge, _placement$align;
    var rect = _ref.rect, placement = _ref.placement, isRtl = _ref.isRtl;
    var axis = (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block';
    var edge = (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end';
    var align = (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        var _y = edge === 'start' ? rect.top : rect.bottom;
        var _x = $d1c9ec14806c2a0b$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: _x,
            y: _y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    var x = $d1c9ec14806c2a0b$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    var y = $d1c9ec14806c2a0b$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $d1c9ec14806c2a0b$var$horizontalForAlign(_ref2) {
    var rect = _ref2.rect, align = _ref2.align, isRtl = _ref2.isRtl;
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    var isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $d1c9ec14806c2a0b$var$verticalForAlign(_ref3) {
    var rect = _ref3.rect, align = _ref3.align;
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $d1c9ec14806c2a0b$var$inlineEdgeX(_ref4) {
    var rect = _ref4.rect, edge = _ref4.edge, isRtl = _ref4.isRtl;
    var isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("8ZsIn", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", function () { return $68ba4b68d6719110$export$e9a6fdb80170ffd; });
/**
 * `@popperjs/core`'s `Placement` union is a strict subset of `TLegacyPlacement`
 * (the placement-map adds `top-center` / `bottom-center` on top of popper's
 * enum), so every value popper hands us is a valid legacy placement.
 *
 * The cast keeps the runtime path free of an extra module-level lookup that
 * bundlers can occasionally fail to wire up (observed as `Cannot read
 * properties of undefined (reading 'includes')` in component-test bundles).
 *
 * Shared so the React and imperative popper adapters resolve this identically.
 */ function $68ba4b68d6719110$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("fvtGZ", function(module, exports) {
$parcel$export(module.exports, "useFitViewportMaxSize", function () { return $b4a0c88dfc9eb132$export$f16d8ac7373995e1; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $9rjhP = parcelRequire("9rjhP");
/**
 * Applies the `shouldFitViewport` size caps directly to the
 * `position-area`-anchored popover host. Pure CSS — the browser owns every
 * value, so there is no measurement, no scroll/resize listeners, and no
 * `--ds-popper-anchor-*` custom properties.
 *
 * **Primary (placement) axis** is capped to `calc(100% - 5px - gap)`. Because
 * the host carries `position-area`, its containing block *is* the position-area
 * cell — the region between the anchor edge and the viewport edge — so `100%`
 * resolves to that distance. The popover is pushed `gap` into the cell by its
 * offset margin (`margin-*`, set by `useAnchorPosition`), so the gap is
 * subtracted as well to keep the legacy `viewportPadding = 5` on the far edge.
 * The cap is also more correct than measuring the requested placement: the cell
 * follows whichever side `position-try-fallbacks` actually flips to, so it
 * tracks the flip automatically.
 *
 * **Cross axis** is capped to `calc(100dvw|dvh - 10px)` (viewport, legacy
 * `2 * viewportPadding`). `display: flex` (plus a `min-*-size: 0` reset on the
 * child) lets an oversized child shrink and reflow to the cap. The host stays
 * `overflow: visible` so it never clips the consumer surface's `box-shadow`;
 * scrolling content that cannot reflow is the consumer surface's own
 * responsibility (it owns `overflow`), matching legacy `react-popper`, which
 * applied the cap to the consumer's own element.
 *
 * `min-inline-size` is reset to `0`. `useWidthFromAnchor({ mode: 'none' })`
 * floors the host at `max-content` so a too-narrow span overflows and drives
 * `position-try-fallbacks` rather than wrapping. That floor is the opposite of
 * fitting: when it exceeds a cap, CSS min/max resolution lets the min win and
 * the host overflows the viewport. In fit mode the caps must win, so the floor
 * is neutralised here; `setStyle` restores the prior inline value on cleanup.
 *
 * Verified in Chromium: `max-block-size: calc(100% - …)` on a `position: fixed`
 * + `position-area` element resolves `100%` to the cell, not the viewport.
 */ var $b4a0c88dfc9eb132$var$CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
var $b4a0c88dfc9eb132$var$CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ var $b4a0c88dfc9eb132$var$VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ var $b4a0c88dfc9eb132$var$NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function $b4a0c88dfc9eb132$export$f16d8ac7373995e1(_ref) {
    var target = _ref.target, placementAxis = _ref.placementAxis, gap = _ref.gap, isEnabled = _ref.isEnabled, isOpen = _ref.isOpen;
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = target.current;
        if (!element || !isEnabled) return;
        var isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        var primaryAxisCap = "calc(100% - 5px - ".concat(gap, ")");
        var cleanupHost = (0, $9rjhP.setStyle)({
            element: element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                //
                // This package only uses `mode: 'none'`. Note that `mode: 'min-anchor'`
                // puts its ANCHOR floor on the same property, so pairing this hook with
                // that mode would drop the anchor floor rather than a content floor. See
                // `@atlaskit/top-layer` `notes/decisions/width-from-anchor-floors.md`.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: $b4a0c88dfc9eb132$var$CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: $b4a0c88dfc9eb132$var$CROSS_BLOCK_CAP
                }
            ].concat((0, $lFOXD.default)($b4a0c88dfc9eb132$var$NON_ANCHOR_MARGIN_SIDES[placementAxis].map(function(property) {
                return {
                    property: property,
                    value: $b4a0c88dfc9eb132$var$VIEWPORT_PADDING
                };
            })))
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        var child = element.firstElementChild;
        var cleanupChild = child instanceof HTMLElement ? (0, $9rjhP.setStyle)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return function() {
            cleanupHost();
            cleanupChild === null || cleanupChild === void 0 || cleanupChild();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}

});
parcelRegister("9rjhP", function(module, exports) {
$parcel$export(module.exports, "setStyle", function () { return $6df598952ca829cb$export$37a5fde709c1db82; });
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ function $6df598952ca829cb$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("cBqiy", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", function () { return $92cd570951a0a21d$export$941a7e8bf0b9eafd; });

var $1oC0p = parcelRequire("1oC0p");

var $9kKb2 = parcelRequire("9kKb2");
function $92cd570951a0a21d$export$941a7e8bf0b9eafd() {
    return (0, $1oC0p.useContext)((0, $9kKb2.AnchorContext));
}

});

parcelRegister("4jo0m", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", function () { return $323b8e9fafcdc4f0$export$61d36e2b682e92f7; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $1XYg2 = parcelRequire("1XYg2");
var $323b8e9fafcdc4f0$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $323b8e9fafcdc4f0$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $323b8e9fafcdc4f0$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $323b8e9fafcdc4f0$var$isClippedByAncestors(element) {
    var rect = element.getBoundingClientRect();
    var parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        var style = window.getComputedStyle(parent);
        var clipsHorizontally = $323b8e9fafcdc4f0$var$isClippingOverflow(style.overflowX);
        var clipsVertically = $323b8e9fafcdc4f0$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            var parentRect = parent.getBoundingClientRect();
            var horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            var verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $323b8e9fafcdc4f0$export$61d36e2b682e92f7(_ref) {
    var anchor = _ref.anchor, popoverRef = _ref.popoverRef;
    var _useState = (0, $1oC0p.useState)($323b8e9fafcdc4f0$var$INITIAL), _useState2 = (0, $2qaZZ.default)(_useState, 2), visibility = _useState2[0], setVisibility = _useState2[1];
    var measure = (0, $1oC0p.useCallback)(function() {
        if (!anchor) {
            setVisibility(function(previous) {
                return previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $323b8e9fafcdc4f0$var$INITIAL;
            });
            return;
        }
        var viewport = (0, $1XYg2.readViewport)();
        var anchorRect = anchor.getBoundingClientRect();
        var isReferenceHidden = $323b8e9fafcdc4f0$var$isFullyOutsideViewport(anchorRect, viewport) || $323b8e9fafcdc4f0$var$isClippedByAncestors(anchor);
        var popoverElement = popoverRef.current;
        var hasPopperEscaped = popoverElement ? $323b8e9fafcdc4f0$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility(function(previous) {
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $1oC0p.useLayoutEffect)(function() {
        measure();
        if (typeof window === 'undefined') return undefined;
        var cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            var observer = new ResizeObserver(function() {
                return measure();
            });
            observer.observe(anchor);
            cleanups.push(function() {
                return observer.disconnect();
            });
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $dH1HR.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        var visual = window.visualViewport;
        if (visual) cleanups.push((0, $dH1HR.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return function() {
            cleanups.forEach(function(cleanup) {
                return cleanup();
            });
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("1XYg2", function(module, exports) {
$parcel$export(module.exports, "readViewport", function () { return $16ea0b12153a1d4d$export$64beed533e21f72d; });
/**
 * Returns the current viewport size in CSS pixels, preferring the visual
 * viewport (which accounts for pinch-zoom on touch devices) over the
 * layout viewport. Returns `{ width: 0, height: 0 }` in non-DOM
 * environments so callers can use the result unconditionally.
 */ function $16ea0b12153a1d4d$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    var visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("66CU3", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", function () { return $47217af9f593b18f$export$51eddd7655ca235a; });

var $1oC0p = parcelRequire("1oC0p");
var $47217af9f593b18f$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children);
};

});

parcelRegister("jvvo7", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", function () { return $e3394294cd91120e$export$92dae2778ae88f9d; });
// eslint-disable-next-line no-duplicate-imports

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $7uNuF = parcelRequire("7uNuF");

var $jDeYn = parcelRequire("jDeYn");

var $6ur0l = parcelRequire("6ur0l");

var $i8aEv = parcelRequire("i8aEv");

var $5QNes = parcelRequire("5QNes");
var $e3394294cd91120e$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $jDeYn.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $5QNes.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var mouseDownTarget = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $7uNuF.default;
        var closePopup = function closePopup(event) {
            if (shouldIgnoreCloseEvent !== null && shouldIgnoreCloseEvent !== void 0 && shouldIgnoreCloseEvent(event) && (0, $6ur0l.fg)('cc_blocks_changeboarding')) return;
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest, _event$target$closest2;
                    _currentLevel = (_event$target$closest = (_event$target$closest2 = event.target.closest("[data-ds--level]")) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.getAttribute('data-ds--level')) !== null && _event$target$closest !== void 0 ? _event$target$closest : null;
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                var _target$closest;
                var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                if (layeredElement) {
                    var closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $i8aEv.isInteractiveElement)(document.activeElement) && (0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onMouseDown = function onMouseDown(event) {
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function onKeyDown(event) {
            var key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $6ur0l.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                var eventTarget = event.target instanceof HTMLElement ? event.target : null;
                var layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                var levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) {
                var shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        var unbind = (0, $7uNuF.default);
        if ((0, $6ur0l.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $dH1HR.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $dH1HR.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $7uNuF.default);
        unbindBlur = (0, $dH1HR.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            if ((0, $6ur0l.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("i8aEv", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", function () { return $d3313cabe6327b8b$export$3dee5e4542c672d9; });
var $d3313cabe6327b8b$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $d3313cabe6327b8b$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($d3313cabe6327b8b$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("5QNes", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", function () { return $4427ff900217f318$export$641fa9c94086b46e; });

var $1oC0p = parcelRequire("1oC0p");
var $4427ff900217f318$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $1oC0p.useRef)([]);
    var requestFrame = (0, $1oC0p.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $1oC0p.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $1oC0p.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("dEa2q", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", function () { return $9ef6cc29b3b35c27$export$10c5169755ce7bd7; });

var $1oC0p = parcelRequire("1oC0p");

var $4b05t = parcelRequire("4b05t");

var $7uNuF = parcelRequire("7uNuF");

var $jDeYn = parcelRequire("jDeYn");

var $6ur0l = parcelRequire("6ur0l");

var $5QNes = parcelRequire("5QNes");
var $9ef6cc29b3b35c27$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $5QNes.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $jDeYn.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $1oC0p.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $7uNuF.default;
        if (shouldDisableFocusTrap && (0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $7uNuF.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $6ur0l.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($4b05t)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
            if ((0, $6ur0l.fg)('platform_dst-popup-trigger-initial-focus-ref') && shouldReturnFocus) requestFrame(function() {
                if (triggerRef !== null && triggerRef !== void 0 && triggerRef.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("1RZPN", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", function () { return $15cab4b2cb886bdb$export$e24b8cb659609dee; });
/* popup-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");


var $7uNuF = parcelRequire("7uNuF");

var $lv7E9 = parcelRequire("lv7E9");

var $dreLK = parcelRequire("dreLK");

var $daMwn = parcelRequire("daMwn");

var $62iHF = parcelRequire("62iHF");

var $jka3b = parcelRequire("jka3b");

var $9q6Ou = parcelRequire("9q6Ou");

var $6YsXR = parcelRequire("6YsXR");

var $ez2cf = parcelRequire("ez2cf");

var $buevq = parcelRequire("buevq");
function $15cab4b2cb886bdb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15cab4b2cb886bdb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15cab4b2cb886bdb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15cab4b2cb886bdb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
var $15cab4b2cb886bdb$var$EMPTY_STYLE = {};
var $15cab4b2cb886bdb$export$e24b8cb659609dee = /*#__PURE__*/ (0, $1oC0p.memo)(function PopupTopLayer(_ref) {
    var _roleProps$role;
    var xcss = _ref.xcss, isOpen = _ref.isOpen, providedId = _ref.id, offsetProp = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, _ref$onClose = _ref.onClose, onClose = _ref$onClose === void 0 ? (0, $7uNuF.default) : _ref$onClose, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _fallbackPlacements = _ref.fallbackPlacements, _ref$shouldFlip = _ref.shouldFlip, _shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldReturnFocu = _ref.shouldReturnFocus, _shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, role = _ref.role, label = _ref.label, titleId = _ref.titleId, _zIndex = _ref.zIndex, _shouldRenderToParent = _ref.shouldRenderToParent, _strategy = _ref.strategy, _modifiers = _ref.modifiers, _boundary = _ref.boundary, _rootBoundary = _ref.rootBoundary, _shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, _shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor, _appearance = _ref.appearance;
    var triggerRef = (0, $1oC0p.useRef)(null);
    var popoverRef = (0, $1oC0p.useRef)(null);
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref rather than component state. Flipping state on every open
   * caused a needless re-render and, more importantly, raced the
   * initial-focus effect below. The ref is read in the open-side
   * effect to override the role-based default focus chosen by
   * `useInitialFocus` inside the underlying `Popover`.
   */ var consumerInitialFocusRef = (0, $1oC0p.useRef)(null);
    var setInitialFocusRef = (0, $1oC0p.useCallback)(function(value) {
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    /**
   * Override the role-based initial focus chosen by the underlying
   * `Popover` (its internal `useInitialFocus`).
   *
   * React flushes child effects before parent effects, so by the time
   * this effect runs the role-based default focus has already moved.
   * We then apply the legacy `Popup` contract:
   *
   * 1. If the consumer wired `setInitialFocusRef`, focus that element
   *    (escape hatch wins).
   * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
   *    The `autoFocus` prop on `Popup` opts out of any initial-focus
   *    movement, even for roles like `dialog`.
   *
   * When neither applies the role-based default from the underlying
   * `Popover` stays in place.
   */ (0, $1oC0p.useEffect)(function() {
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        var consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            var _trigger = triggerRef.current;
            if (_trigger && _trigger.isConnected) _trigger.focus();
        }
    }, [
        isOpen,
        autoFocus
    ]);
    var popoverId = (0, $6YsXR.usePopoverId)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    var topLayerPlacement = (0, $1oC0p.useMemo)(function() {
        return (0, $dreLK.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        });
    }, [
        placement,
        offsetProp
    ]);
    (0, $9q6Ou.useAnchoredPopover)($15cab4b2cb886bdb$var$_objectSpread({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    }, (0, $ez2cf.getPopupAxisSizes)({
        shouldFitContainer: shouldFitContainer,
        shouldFitViewport: shouldFitViewport
    })));
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    var handleOnClose = (0, $1oC0p.useCallback)(function(_ref2) {
        var reason = _ref2.reason;
        onClose((0, $62iHF.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    var contentProps = (0, $1oC0p.useMemo)(function() {
        return {
            isOpen: isOpen,
            update: (0, $7uNuF.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        };
    }, [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    var roleProps = (0, $buevq.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    var resolvedPopoverId = providedId !== null && providedId !== void 0 ? providedId : popoverId;
    var ariaAttributes = (0, $lv7E9.getAriaForTrigger)({
        role: (_roleProps$role = roleProps.role) !== null && _roleProps$role !== void 0 ? _roleProps$role : 'dialog',
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    var Container = PopupContainer;
    // Map to legacy TriggerProps.
    var triggerProps = {
        ref: function ref(node) {
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        // FUDGE(top-layer-api): cast to the narrow public TriggerProps['aria-haspopup'] union.
        // `getAriaForTrigger` derives `aria-haspopup` from the content's role and types it
        // as the wider WAI-ARIA union (boolean | 'dialog' | 'menu' | 'listbox' | 'tree' | 'grid').
        // We keep the public popup TriggerProps narrow (boolean | 'dialog') because the
        // top-layer API surface is not yet settled. Widening adopter types now would commit
        // us to a public surface we may revisit. The runtime value is unchanged; only the
        // TypeScript-visible type is narrowed at this boundary.
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, trigger(triggerProps), /*#__PURE__*/ $1oC0p.createElement((0, $jka3b.Popover), (0, $c9bqK.default)({
        ref: popoverRef,
        id: resolvedPopoverId
    }, roleProps, {
        isOpen: isOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: topLayerPlacement,
        testId: testId && "".concat(testId, "--content")
    }), Container ? /*#__PURE__*/ $1oC0p.createElement(Container, {
        style: $15cab4b2cb886bdb$var$EMPTY_STYLE,
        id: providedId,
        "data-placement": placement,
        "data-testid": testId,
        tabIndex: autoFocus ? -1 : undefined,
        xcss: xcss,
        shouldFitViewport: shouldFitViewport
    }, content(contentProps)) : /*#__PURE__*/ // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
    // same element, so it is the scroll container. The wrapper exists only
    // to carry the consumer's `xcss`: `PopoverSurface` exposes no
    // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
    // surface. `width` works there; surface-level declarations apply one
    // level in. Same shape as `compositional/popup-content-top-layer.tsx`.
    $1oC0p.createElement((0, $daMwn.PopoverSurface), null, /*#__PURE__*/ $1oC0p.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: xcss
    }, content(contentProps)))));
});

});
parcelRegister("lv7E9", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", function () { return $fa726cafdac5ce88$export$9dd1d61dd4d4755; });
/**
 * Roles accepted by `getAriaForTrigger`.
 *
 * Excludes tooltip-family roles (`tooltip`, `note`, `status`, `alert`, `log`)
 * because the correct trigger wiring for those is `aria-describedby`, not
 * `aria-haspopup` / `aria-expanded` / `aria-controls`. Use `aria-describedby`
 * manually for tooltip triggers.
 */ /**
 * Maps each supported popover role to its `aria-haspopup` value.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. Roles that do not produce a popup use `undefined` instead (for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading), so they are intentionally excluded
 * from this mapping and from `getAriaForTrigger`.
 *
 * `true` is intentionally not a value in this mapping. The runtime only ever
 * produces the explicit string forms, so allowing it would invite consumers
 * to pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ var $fa726cafdac5ce88$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $fa726cafdac5ce88$export$9dd1d61dd4d4755(_ref) {
    var role = _ref.role, isOpen = _ref.isOpen, popoverId = _ref.popoverId;
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': $fa726cafdac5ce88$var$roleToAriaHasPopup[role],
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("dreLK", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", function () { return $9c8940d04b0c33d5$export$69e99ed50b2534c9; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $9XcW4 = parcelRequire("9XcW4");
function $9c8940d04b0c33d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c8940d04b0c33d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c8940d04b0c33d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c8940d04b0c33d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9c8940d04b0c33d5$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $9XcW4.placementMapping)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, $2qaZZ.default)(offset, 2), along = _offset[0], away = _offset[1];
    return $9c8940d04b0c33d5$var$_objectSpread($9c8940d04b0c33d5$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

});
parcelRegister("9XcW4", function(module, exports) {
$parcel$export(module.exports, "placementMapping", function () { return $73f3a87fdd9933ee$export$27df359c528b7120; });
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $73f3a87fdd9933ee$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("daMwn", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", function () { return $9971d8dbb58da28e$export$8b7437164e479115; });
/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $9971d8dbb58da28e$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $9971d8dbb58da28e$export$8b7437164e479115(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $9971d8dbb58da28e$var$styles.root
        ])
    }, children);
}

});

parcelRegister("62iHF", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", function () { return $4651700cd81f123b$export$27b4de066896ac63; });
/**
 * Creates a synthetic DOM event from a `TPopoverCloseReason`.
 *
 * Useful when bridging the Popover primitive's `onClose({ reason })` callback
 * to a legacy API that expects a native DOM event - for example,
 * `@atlaskit/inline-dialog`'s `onClose(event)` contract.
 *
 * - `'escape'` → `KeyboardEvent('keydown', { key: 'Escape' })`
 * - `'light-dismiss'` → `MouseEvent('click')`
 *
 * For any other reason, a generic `Event('close')` is returned as a fallback.
 *
 * @example
 * ```tsx
 * import { createPopoverCloseEvent, type TPopoverCloseReason } from '@atlaskit/top-layer/popover';
 *
 * function onPopoverClose({ reason }: { reason: TPopoverCloseReason }) {
 *   legacyOnClose(createPopoverCloseEvent({ reason }));
 * }
 * ```
 */ function $4651700cd81f123b$export$27b4de066896ac63(_ref) {
    var reason = _ref.reason;
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});

parcelRegister("jka3b", function(module, exports) {
$parcel$export(module.exports, "Popover", function () { return $e117ae5e32c444af$export$5b6b19405a83ff9d; });
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $3sHnI = parcelRequire("3sHnI");

var $dH1HR = parcelRequire("dH1HR");

var $kPutE = parcelRequire("kPutE");

var $8zODL = parcelRequire("8zODL");

var $9k6Ve = parcelRequire("9k6Ve");

var $iZOS3 = parcelRequire("iZOS3");

var $lMv47 = parcelRequire("lMv47");

var $2yKY8 = parcelRequire("2yKY8");

var $66mAW = parcelRequire("66mAW");

var $eC17P = parcelRequire("eC17P");
/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $e117ae5e32c444af$var$restoreFocus(_ref) {
    var popover = _ref.popover, focusRestorationTarget = _ref.focusRestorationTarget;
    if (!focusRestorationTarget) return;
    var ownerDocument = popover.ownerDocument;
    // Native restoration has finished. Preserve focus moved outside the popover.
    var activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $e117ae5e32c444af$var$supportsPopoverHint = (0, $8zODL.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// Not `all: initial`: the target is what `<body>` gave the portal path, not the
// spec initial values (UA serif, black, `color-scheme: normal`), and as an author
// declaration it would also override the UA `[popover]` rules (`position: fixed`,
// `display: none` when closed).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately. The `satisfies` check below fails the
// build if either copy drifts.
var $e117ae5e32c444af$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $e117ae5e32c444af$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug _p6861txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $e117ae5e32c444af$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $e117ae5e32c444af$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $e117ae5e32c444af$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function Popover(_ref2, ref) {
    var children = _ref2.children, _ref2$mode = _ref2.mode, modeProp = _ref2$mode === void 0 ? 'auto' : _ref2$mode, onClose = _ref2.onClose, onEnterFinish = _ref2.onEnterFinish, onExitFinish = _ref2.onExitFinish, _ref2$shouldAnimate = _ref2.shouldAnimate, shouldAnimate = _ref2$shouldAnimate === void 0 ? false : _ref2$shouldAnimate, placement = _ref2.placement, testId = _ref2.testId, isOpen = _ref2.isOpen, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimationXcss = _ref2.exitingAnimationXcss, role = _ref2.role, label = _ref2.label, labelledBy = _ref2.labelledBy, idProp = _ref2.id;
    var autoId = (0, $1oC0p.useId)();
    var ownRef = (0, $1oC0p.useRef)(null);
    var combinedRef = (0, $kPutE.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    var onCloseRef = (0, $1oC0p.useRef)(onClose);
    (0, $1oC0p.useLayoutEffect)(function() {
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $1oC0p.useCallback)(function() {
        var _onCloseRef$current;
        (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
            reason: 'programmatic'
        });
    }, []);
    (0, $9k6Ve.useNotifyOpenLayerObserver)({
        type: role && $e117ae5e32c444af$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$e117ae5e32c444af$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $1oC0p.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $lMv47.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $e117ae5e32c444af$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    var closeReasonRef = (0, $1oC0p.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    var focusRestorationTargetRef = (0, $1oC0p.useRef)(null);
    var handleBeforeToggle = (0, $1oC0p.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var ownerDocument = popover.ownerDocument;
        var activeElement = ownerDocument.activeElement;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    var handleToggleClosed = (0, $1oC0p.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        var reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $e117ae5e32c444af$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                reason: reason
            });
        }
    }, []);
    var _useAnimatedVisibilit = (0, $2yKY8.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, isMounted = _useAnimatedVisibilit.isMounted, onBeforeToggle = _useAnimatedVisibilit.onBeforeToggle, onToggle = _useAnimatedVisibilit.onToggle;
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // popovers are handled above via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $66mAW.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $eC17P.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $dH1HR.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $iZOS3.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $dH1HR.bind)(element, {
            type: 'toggle',
            listener: function listener(event) {
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        var unbindBeforeToggle = (0, $dH1HR.bind)(element, {
            type: 'beforetoggle',
            listener: function listener(event) {
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2jatx.default)([
            $e117ae5e32c444af$var$styles.root,
            $e117ae5e32c444af$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $e117ae5e32c444af$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $e117ae5e32c444af$var$styles.exit,
            shouldAnimate && $e117ae5e32c444af$var$styles.motion,
            (0, $3sHnI.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("iZOS3", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", function () { return $dd456263433bcc5a$export$89b923e18c14644d; });
function $dd456263433bcc5a$export$89b923e18c14644d(_ref) {
    var element = _ref.element;
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw for unsupported pseudo-classes.
    try {
        return element.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}

});

parcelRegister("lMv47", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", function () { return $fdb62d9c4a4de8ff$export$63044d21bc3d3fa2; });

var $bWN11 = parcelRequire("bWN11");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $fdb62d9c4a4de8ff$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $fdb62d9c4a4de8ff$export$63044d21bc3d3fa2(_ref) {
    var _placement$axis, _placement$edge, _placement$align, _placement$offset$gap, _placement$offset, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        // Not `??`: `undefined` must survive, so "not specified" stays
        // distinguishable from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $bWN11.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $bWN11.toCssLengthString)({
                value: (_placement$offset$gap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap) !== null && _placement$offset$gap !== void 0 ? _placement$offset$gap : $fdb62d9c4a4de8ff$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $bWN11.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("bWN11", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", function () { return $8b2b21f4467ed1c2$export$63b6b0ff65d84d47; });
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $8b2b21f4467ed1c2$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("2yKY8", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", function () { return $1dd330ccee709956$export$1bccb45daf07907f; });

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $iZOS3 = parcelRequire("iZOS3");

var $f46oE = parcelRequire("f46oE");
function $1dd330ccee709956$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1dd330ccee709956$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1dd330ccee709956$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1dd330ccee709956$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1dd330ccee709956$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        // Prevent an interrupted or unmounted lifecycle from firing a stale callback.
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $1dd330ccee709956$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $1dd330ccee709956$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
/**
 * Visibility lifecycle phase shared between `useAnimatedVisibility`,
 * `useFocusWrap`, `useInitialFocus`, and the `Popover` / `Dialog`
 * components.
 *
 * - `closed`: host element is unmounted. No DOM presence.
 * - `entering`: host element is mounted and the CSS entry transition
 *   is playing. **Only emitted when animation is enabled.** With
 *   animation disabled the lifecycle goes directly `closed → open`.
 * - `open`: host element is mounted and settled. No transition is
 *   playing.
 * - `exiting`: a native close has begun but the host element remains
 *   mounted. Usually this follows `isOpen` changing to `false`, but it can
 *   also begin with a browser-initiated dismissal while controlled intent
 *   is still open. With animation disabled, this phase lasts until the
 *   browser's closed `toggle` fires so native focus restoration can finish.
 *
 * State machine:
 * ```
 *   animation ON:   closed → entering → open → exiting → closed
 *   animation OFF:  closed →            open → exiting → closed
 *   interrupts:     entering → exiting (close mid-entry)
 *                   exiting  → entering (reopen mid-exit, animated)
 *                   exiting  → open     (reopen mid-handshake, non-animated)
 * ```
 */ function $1dd330ccee709956$var$getInitialVisibilityState(_ref3) {
    var isOpen = _ref3.isOpen, willAnimate = _ref3.willAnimate;
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility phase.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $1dd330ccee709956$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        var shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return $1dd330ccee709956$var$_objectSpread($1dd330ccee709956$var$_objectSpread({}, state), {}, {
            controlledIntent: 'open'
        });
    }
    if (action.type === 'close-requested') return $1dd330ccee709956$var$_objectSpread($1dd330ccee709956$var$_objectSpread({}, state), {}, {
        controlledIntent: 'closed'
    });
    if (action.type === 'exit-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return $1dd330ccee709956$var$_objectSpread($1dd330ccee709956$var$_objectSpread({}, state), {}, {
            phase: 'exiting'
        });
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return $1dd330ccee709956$var$_objectSpread($1dd330ccee709956$var$_objectSpread({}, state), {}, {
            phase: 'open'
        });
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return $1dd330ccee709956$var$_objectSpread($1dd330ccee709956$var$_objectSpread({}, state), {}, {
            phase: 'closed'
        });
    }
    return state;
}
function $1dd330ccee709956$export$1bccb45daf07907f(_ref4) {
    var isOpen = _ref4.isOpen, shouldAnimate = _ref4.shouldAnimate, elementRef = _ref4.elementRef, onEnterFinish = _ref4.onEnterFinish, onExitFinish = _ref4.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $f46oE.prefersReducedMotion)();
    var _useReducer = (0, $1oC0p.useReducer)($1dd330ccee709956$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $1dd330ccee709956$var$getInitialVisibilityState), _useReducer2 = (0, $2qaZZ.default)(_useReducer, 2), visibilityState = _useReducer2[0], dispatch = _useReducer2[1];
    var phase = visibilityState.phase, controlledIntent = visibilityState.controlledIntent;
    // Keep stable refs to the latest callbacks so effects and animation settlement closures
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $1oC0p.useRef)(onEnterFinish);
    var onExitFinishRef = (0, $1oC0p.useRef)(onExitFinish);
    var willAnimateRef = (0, $1oC0p.useRef)(willAnimate);
    (0, $1oC0p.useLayoutEffect)(function() {
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Entry can commit `open` before its callback because the host stays mounted.
    // This ensures consumers observe the settled DOM rather than entering styles.
    // Treat the phase before the initial commit as closed so an initially open host
    // notifies consumers.
    var prevPhaseRef = (0, $1oC0p.useRef)('closed');
    (0, $1oC0p.useEffect)(function() {
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (prevPhase === phase) return;
        if (phase === 'open') {
            var _onEnterFinishRef$cur;
            (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    var isMounted = phase !== 'closed';
    var cancelExitSettlementRef = (0, $1oC0p.useRef)(function() {});
    // Exit must notify consumers before `closed` unmounts the host.
    var settleExit = (0, $1oC0p.useCallback)(function() {
        var _onExitFinishRef$curr;
        (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    // Primitives bind these stable callbacks to their native lifecycle events.
    // This keeps event ownership at the primitive while the hook owns state transitions.
    var onBeforeToggle = (0, $1oC0p.useCallback)(function(event) {
        // Any native transition supersedes a previous exit snapshot. This prevents
        // a stale settlement from closing a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot currentTarget because the DOM clears it after event dispatch.
        var element = event.currentTarget;
        if (event.newState === 'open' && element instanceof HTMLElement) {
            element.removeAttribute('inert');
            element.removeAttribute('aria-hidden');
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // We use a microtask to let native focus restoration happen before making the element inert.
            // The browser restores focus after beforetoggle returns, during its close steps.
            queueMicrotask(function() {
                // A controlled close can be interrupted by isOpen changing back to true,
                // which reopens the element before this microtask runs.
                if ((0, $iZOS3.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep closed content rendered, so make it non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'exit-started'
            });
        }
    }, []);
    var onToggle = (0, $1oC0p.useCallback)(function(event) {
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $1dd330ccee709956$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after synchronous `beforetoggle`.
        // Snapshot here so the exiting phase styles have committed and the list
        // represents the animations that actually govern exit settlement.
        cancelExitSettlementRef.current = $1dd330ccee709956$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $1oC0p.useLayoutEffect)(function() {
        return function() {
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        };
    }, []);
    // Entry settlement only removes entering styles. Its callback runs after the
    // resulting `open` commit in the effect above.
    (0, $1oC0p.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        return $1dd330ccee709956$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("f46oE", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", function () { return $af7c30fb3857ec26$export$ff7706047246b98b; });

var $8zODL = parcelRequire("8zODL");
var $af7c30fb3857ec26$export$ff7706047246b98b = (0, $8zODL.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("66mAW", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", function () { return $4714d47565a7d49d$export$4f6462e86a70abe5; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $bz0u6 = parcelRequire("bz0u6");

var $8DtoS = parcelRequire("8DtoS");

var $ln2Ii = parcelRequire("ln2Ii");

var $dnWUf = parcelRequire("dnWUf");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $4714d47565a7d49d$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $4714d47565a7d49d$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $1oC0p.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$4714d47565a7d49d$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $dH1HR.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $dnWUf.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $ln2Ii.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $bz0u6.getFirstFocusable)({
                    container: element
                }) : (0, $8DtoS.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("bz0u6", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", function () { return $86b356d433ffd16a$export$748138f04a69bf21; });

var $j8pey = parcelRequire("j8pey");
function $86b356d433ffd16a$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $j8pey.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("j8pey", function(module, exports) {
$parcel$export(module.exports, "getFocusables", function () { return $dee256983220829f$export$f6768025e418420e; });

var $562GW = parcelRequire("562GW");
var $dee256983220829f$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
var $dee256983220829f$var$exclusionSelector = $dee256983220829f$var$focusableExclusions.map(function(selector) {
    return ":not(".concat(selector, ")");
}).join('');
var $dee256983220829f$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map(function(selector) {
    return "".concat(selector).concat($dee256983220829f$var$exclusionSelector);
}).join(',');
function $dee256983220829f$var$isVisible(element) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch (_unused) {
        return true;
    }
}
function $dee256983220829f$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var containerLayer = (0, $562GW.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($dee256983220829f$var$focusableSelector)).filter(function(element) {
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $562GW.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$dee256983220829f$var$isVisible(element)) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("562GW", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", function () { return $3b5f99cadfbede80$export$3c9385904be131db; });
function $3b5f99cadfbede80$export$3c9385904be131db(_ref) {
    var element = _ref.element;
    return element.closest('[popover], dialog');
}

});



parcelRegister("8DtoS", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", function () { return $6498c5880b17f072$export$73e81fa65335a75b; });

var $j8pey = parcelRequire("j8pey");
function $6498c5880b17f072$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $j8pey.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("ln2Ii", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", function () { return $f8edd9c5959f81b6$export$a7db88e6d491b450; });
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * The currently focused element does not need to be tabbable. This prevents
 * navigation from getting stuck on an element that was programmatically or
 * pointer focused with `tabindex="-1"`. Negative-tab-index elements remain
 * excluded as destinations.
 *
 * Returns `null` if there is no focused element within the container.
 */ 
var $j8pey = parcelRequire("j8pey");
function $f8edd9c5959f81b6$export$a7db88e6d491b450(_ref) {
    var _all3;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $j8pey.getFocusables)({
        container: container,
        filter: filter
    });
    var first = all[0];
    var last = all[all.length - 1];
    // Checking the elements directly narrows types from `HTMLElement | undefined`.
    if (!first || !last) return null;
    var current = container.ownerDocument.activeElement;
    if (!(current instanceof HTMLElement) || !container.contains(current)) return null;
    var index = all.indexOf(current);
    // The focused element can be absent from `all` when it is non-tabbable or
    // excluded by the filter. Find the first focusable element that follows it in
    // the DOM, which identifies the nearest focusable destination in either direction.
    if (index === -1) {
        var _all;
        var followingIndex = all.findIndex(function(element) {
            return Boolean(current.compareDocumentPosition(element) & current.DOCUMENT_POSITION_FOLLOWING);
        });
        if (direction === 'forwards') {
            var _all$followingIndex;
            // If nothing follows the current element, then wrap to the start.
            return (_all$followingIndex = all[followingIndex]) !== null && _all$followingIndex !== void 0 ? _all$followingIndex : first;
        }
        // The closest preceding element is immediately before the first following one.
        // A missing adjacent entry means the backward sequence wraps to the end.
        return (_all = all[followingIndex - 1]) !== null && _all !== void 0 ? _all : last;
    }
    // The current element is tabbable, so use its adjacent list entry and wrap
    // when it is already at the boundary.
    if (direction === 'forwards') {
        var _all2;
        return (_all2 = all[index + 1]) !== null && _all2 !== void 0 ? _all2 : first;
    }
    return (_all3 = all[index - 1]) !== null && _all3 !== void 0 ? _all3 : last;
}

});

parcelRegister("dnWUf", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", function () { return $9beb1de675f1ad80$export$b9590fdfeb5f722f; });

var $562GW = parcelRequire("562GW");
function $9beb1de675f1ad80$export$b9590fdfeb5f722f(_ref) {
    var container = _ref.container;
    var focused = container.ownerDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $562GW.getClosestLayer)({
        element: focused
    }) !== (0, $562GW.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("eC17P", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", function () { return $aa357cc56f676bd3$export$e992c40175757a22; });

var $1oC0p = parcelRequire("1oC0p");

var $bz0u6 = parcelRequire("bz0u6");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $aa357cc56f676bd3$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $aa357cc56f676bd3$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $aa357cc56f676bd3$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $aa357cc56f676bd3$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$aa357cc56f676bd3$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $aa357cc56f676bd3$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $bz0u6.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($aa357cc56f676bd3$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $bz0u6.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($aa357cc56f676bd3$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $bz0u6.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $aa357cc56f676bd3$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $1oC0p.useRef)('closed');
    (0, $1oC0p.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $aa357cc56f676bd3$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("9q6Ou", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopover", function () { return $6dbbd3c564f0f785$export$147d8888d96bf7a3; });
/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate use `useAnchoredPopoverAtPoint`.
 *
 * Two runtime paths, each a function that applies its styles and returns the
 * cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the JavaScript
 * fallback in `./javascript-fallback`. The path is resolved ONCE, at the top of
 * the hook, and threaded through positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4UF4U = parcelRequire("4UF4U");

var $hGd2C = parcelRequire("hGd2C");

var $biTP4 = parcelRequire("biTP4");

var $awwHe = parcelRequire("awwHe");

var $lMv47 = parcelRequire("lMv47");

var $eETen = parcelRequire("eETen");

var $lnDRX = parcelRequire("lnDRX");
/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to take for every
 * popover.
 */ function $6dbbd3c564f0f785$var$getPopoverWritingMode(_ref) {
    var popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $6dbbd3c564f0f785$var$measureAnchorSize(_ref2) {
    var anchor = _ref2.anchor, writingMode = _ref2.writingMode;
    if (writingMode === 'vertical') return {
        inline: "".concat(anchor.offsetHeight, "px"),
        block: "".concat(anchor.offsetWidth, "px")
    };
    return {
        inline: "".concat(anchor.offsetWidth, "px"),
        block: "".concat(anchor.offsetHeight, "px")
    };
}
var $6dbbd3c564f0f785$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
var $6dbbd3c564f0f785$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
function $6dbbd3c564f0f785$var$isAnchorRelative(size) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a CSS
 * `<dashed-ident>`. `useId()` is the same source as every other id in the design
 * system, including the popover's own `id` that `aria-controls` and `popovertarget`
 * point at, so it is unique exactly where those are and collides exactly where
 * they do. See `useAnchoredPopover` for the one case that needs the host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $6dbbd3c564f0f785$var$useNewAnchorName() {
    var id = (0, $4UF4U.useId)();
    return (0, $1oC0p.useMemo)(function() {
        return "--anchor-".concat(id.replace(/[^A-Za-z0-9_-]/g, '_'));
    }, [
        id
    ]);
}
/**
 * A referentially-stable, fully-resolved `TPlacement`, so a fresh inline
 * `placement` object does not re-run the effect.
 */ function $6dbbd3c564f0f785$var$useStablePlacement(placement) {
    var resolved = (0, $lMv47.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var minSize = resolved.minSize;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $1oC0p.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $6dbbd3c564f0f785$export$147d8888d96bf7a3(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, placement = _ref3.placement, isOpen = _ref3.isOpen, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, _ref3$inlineSize = _ref3.inlineSize, inlineSize = _ref3$inlineSize === void 0 ? 'content' : _ref3$inlineSize, _ref3$blockSize = _ref3.blockSize, blockSize = _ref3$blockSize === void 0 ? 'content' : _ref3$blockSize, _ref3$shouldPreserveI = _ref3.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref3$shouldPreserveI === void 0 ? false : _ref3$shouldPreserveI, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo;
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    var fallbackAnchorName = $6dbbd3c564f0f785$var$useNewAnchorName();
    var stablePlacement = $6dbbd3c564f0f785$var$useStablePlacement(placement);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        var isUsingCssAnchorPositioning = (0, $eETen.supportsAnchorPositioning)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        var canUseAnchorSize = isUsingCssAnchorPositioning && (0, $lnDRX.supportsAnchorSize)();
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        var writingMode = $6dbbd3c564f0f785$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        var needsAnchorSize = $6dbbd3c564f0f785$var$isAnchorRelative(inlineSize) || $6dbbd3c564f0f785$var$isAnchorRelative(blockSize) || isFitting && isUsingCssAnchorPositioning;
        var anchorSize = needsAnchorSize ? canUseAnchorSize ? $6dbbd3c564f0f785$var$CSS_ANCHOR_SIZE : $6dbbd3c564f0f785$var$measureAnchorSize({
            anchor: trigger,
            writingMode: writingMode
        }) : $6dbbd3c564f0f785$var$NO_ANCHOR_SIZE;
        var sizeStyles = (0, $biTP4.getAnchoredPopoverSizeDeclarations)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $hGd2C.applyAnchorPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $awwHe.applyJavaScriptFallbackPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}

});
parcelRegister("hGd2C", function(module, exports) {
$parcel$export(module.exports, "applyAnchorPositioning", function () { return $cdf079a46153faed$export$50da8074e1408934; });

var $lFOXD = parcelRequire("lFOXD");

var $6GNUr = parcelRequire("6GNUr");

var $3R2qt = parcelRequire("3R2qt");

var $4DIHg = parcelRequire("4DIHg");

var $6tkFf = parcelRequire("6tkFf");

var $892OF = parcelRequire("892OF");

var $2j0Dh = parcelRequire("2j0Dh");

var $4liY4 = parcelRequire("4liY4");
function $cdf079a46153faed$export$50da8074e1408934(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover, placement = _ref.placement, sizeStyles = _ref.sizeStyles, isFitting = _ref.isFitting, fallbackAnchorName = _ref.fallbackAnchorName;
    // Reuse rather than mint: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    var existingAnchorName = (0, $892OF.getExistingAnchorName)(anchor);
    var anchorName = existingAnchorName !== null && existingAnchorName !== void 0 ? existingAnchorName : fallbackAnchorName;
    var gap = (0, $4DIHg.edgeMargin)({
        placement: placement,
        offset: placement.offset.gap
    });
    var crossAxisShift = (0, $3R2qt.crossAxisShiftMargins)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    var popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $2j0Dh.placementToPositionArea)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $4liY4.placementToTryFallbacks)({
                placement: placement
            })
        },
        /**
   * **`position-visibility: always`**
   *
   * `position-visibility` is used to control the visibility of an anchored
   * popover based on the visibility of the element being anchored to (the target).
   *
   * Default `position-visibility` value: `anchors-visible` → hide the anchored
   * popover when the target is fully clipped by an ancestor (eg a scroll container)
   * or is `visibility:hidden`.
   * Sadly this "automatic hiding" does not actually "close" the popover,
   * so things like `:popover-open` are still active, even though the popover
   * is no longer painted and no longer receives pointer input. Chrome keeps it
   * focusable and in the accessibility tree, so keyboard and screen reader users
   * can still land inside a surface that is not painted.
   * Per-engine behaviour: `notes/decisions/position-visibility-always.md`.
   *
   * Generally we have not run into issues with the default (`anchors-visible`)
   *
   * Exceptions:
   *  - Target is intentionally not visible (eg `position:absolute` moving it outside of
   *    its parent's "clipped boundary", or a `visibility:hidden` trigger)
   *  - A trigger is scrolled out of its scroll container while the popover is open.
   *
   * We are switching from `anchors-visible` → `always` _for now_ to force no
   * automatic hiding of the popover. There seems to be no compelling reason to use
   * the default value. If one arises in the future, we could look towards making
   *  this behaviour configurable.
   */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset browser default popover positioning that conflicts
        // with anchor positioning (UA: `inset: 0; margin: auto;`)
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gap
    ].concat((0, $lFOXD.default)(isFitting ? (0, $6tkFf.getFitMarginDeclarations)({
        placement: placement,
        crossAxisShiftMargins: crossAxisShift
    }) : crossAxisShift), (0, $lFOXD.default)(sizeStyles));
    // Anchor names are never cleaned up: multiple popovers can share an anchor,
    // and even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only written when minted: a name
    // from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $6GNUr.setStyle)({
        element: popover,
        styles: popoverStyles
    });
}

});
parcelRegister("6GNUr", function(module, exports) {
$parcel$export(module.exports, "setStyle", function () { return $4ded614bfb641d8d$export$37a5fde709c1db82; });
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $4ded614bfb641d8d$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});

parcelRegister("3R2qt", function(module, exports) {
$parcel$export(module.exports, "crossAxisShiftMargins", function () { return $2ce8341464c24287$export$f7505ccec0897ae3; });
/**
 * The cross-axis shift, written antisymmetrically on BOTH cross-axis sides rather
 * than as one margin. Do not collapse it to one side: a single margin widens the
 * margin box, so `anchor-center` displaces the border box by only half the value,
 * a `<position-area>` fallback sliding across the cross axis drops it entirely,
 * and the widened box changes where the popover is judged to overflow.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $2ce8341464c24287$export$f7505ccec0897ae3(_ref) {
    var placement = _ref.placement, crossAxisShiftCssValue = _ref.crossAxisShiftCssValue, direction = _ref.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}

});

parcelRegister("4DIHg", function(module, exports) {
$parcel$export(module.exports, "edgeMargin", function () { return $360d79c8541761ee$export$b94d052c6b40496; });
/**
 * The margin that creates the gap between the popover and its anchor.
 */ function $360d79c8541761ee$export$b94d052c6b40496(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The side FACING the anchor is always opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}

});

parcelRegister("6tkFf", function(module, exports) {
$parcel$export(module.exports, "getFitMarginDeclarations", function () { return $4b657b0833546033$export$a7ffde4a856e8d8e; });

var $lFOXD = parcelRequire("lFOXD");

var $biTP4 = parcelRequire("biTP4");
/**
 * Every logical margin property the fit recipe can write. Declared here and
 * imported by `edge-margin.tsx` and `cross-axis-shift-margins.tsx`: two
 * structurally identical declarations are interchangeable to the compiler, so a
 * divergence would surface only as a silently-ignored property name at
 * `setStyle`.
 */ /**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $4b657b0833546033$var$viewportFacingCrossAxisSides(_ref) {
    var align = _ref.align;
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $4b657b0833546033$export$a7ffde4a856e8d8e(_ref2) {
    var placement = _ref2.placement, crossAxisShiftMargins = _ref2.crossAxisShiftMargins;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    var paddedProperties = new Set($4b657b0833546033$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map(function(side) {
        return "margin-".concat(crossAxis, "-").concat(side);
    }));
    return [
        {
            property: "margin-".concat(placement.axis, "-").concat(placement.edge),
            value: (0, $biTP4.VIEWPORT_PADDING)
        }
    ].concat((0, $lFOXD.default)(crossAxisShiftMargins.map(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        return paddedProperties.has(property) ? {
            property: property,
            value: "calc(".concat(value, " + ").concat((0, $biTP4.VIEWPORT_PADDING), ")")
        } : {
            property: property,
            value: value
        };
    })));
}

});
parcelRegister("biTP4", function(module, exports) {
$parcel$export(module.exports, "VIEWPORT_PADDING", function () { return $83acad63ca408daa$export$9f2fdbacbc62226e; });
$parcel$export(module.exports, "getAnchoredPopoverSizeDeclarations", function () { return $83acad63ca408daa$export$860b30329fa0b990; });
/**
 * The space kept clear between a popover and the viewport edge. Matches legacy
 * `@atlaskit/popper`'s `preventOverflow` padding of `5`.
 */ var $83acad63ca408daa$export$9f2fdbacbc62226e = '5px';
var $83acad63ca408daa$export$32ab78b2bb853a01 = '150px';
/**
 * Which way the POPOVER's inline axis runs; `'vertical'` covers the `vertical-*`
 * and `sideways-*` writing modes. Measured rather than assumed, because every
 * logical property this module writes resolves against the popover's own writing
 * mode, and so must the viewport unit paired with it.
 */ /**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $83acad63ca408daa$var$viewportUnit(_ref) {
    var axis = _ref.axis, writingMode = _ref.writingMode;
    var isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
/**
 * How one axis of an anchored popover is sized. Both axes take these four values
 * under identical rules.
 *
 * - `'content'`: sized by its content. Named after `flex-basis: content`; NOT
 *   `'auto'`, whose CSS meaning for a positioned box is shrink-to-fit, the very
 *   behaviour rule 4 removes.
 * - `'match-anchor'`: exactly the anchor's size on this axis.
 * - `'min-anchor'`: at least the anchor's size on this axis, free to grow.
 * - `'max-available'`: at most the space between the anchor and the viewport
 *   edge, content-sized below that. Capped by the `position-area` cell on the
 *   placement axis and by the viewport on the cross axis (a `span-*` cell is
 *   narrower than the viewport, so capping to it would wrap content that fits on
 *   screen).
 *
 * Four rules apply on top:
 *
 * 1. Fitting one axis fills a `'content'` other axis with `'max-available'` too.
 *    An explicit value is never overridden, so caps stay strictly per-axis.
 * 2. Fitting either axis floors the placement axis, because flipping is a
 *    whole-popover outcome. See `getPlacementAxisFloor`.
 * 3. The viewport cap is unconditional, so a non-fitting axis still cannot
 *    overhang the screen. `'max-available'` and `'content'` are therefore
 *    indistinguishable on the cross axis.
 * 4. A non-anchor-relative inline axis gets `inline-size: max-content`. Under
 *    `position-area` the containing block is the cell, so a CSS `auto` inline
 *    size shrink-to-fits a too-narrow cell and WRAPS into it, never overflowing
 *    and so never sliding to the roomier side. The caps still beat it, because a
 *    max beats a definite size. Not needed on the block axis, which does not
 *    wrap, nor on the JavaScript fallback, whose containing block is the
 *    viewport. Consumers opt out with `shouldPreserveInlineSize`.
 *
 * See `notes/decisions/fit-available-space.md`.
 */ /**
 * Narrowed rather than `string`, so a typo cannot reach `setStyle` as a
 * silently-ignored property name.
 */ /**
 * The anchor's size along each axis, as a CSS length. `null` when nothing needs
 * it, so the measurement is skipped.
 *
 * The CSS path uses the `self-` keywords, whose axes are the POPOVER's, so each
 * value matches the axis of the property it is set on (`anchor-size(inline)` and
 * `anchor-size(width)` are both silently wrong in a vertical writing mode). The
 * JavaScript fallback uses a measured pixel length, because `anchor-size()` needs
 * a `position-anchor` that path never sets. See
 * `notes/decisions/width-from-anchor-floors.md`.
 */ function $83acad63ca408daa$var$getCrossAxis(axis) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $83acad63ca408daa$var$viewportCap(_ref2) {
    var axis = _ref2.axis, writingMode = _ref2.writingMode;
    return "calc(100".concat($83acad63ca408daa$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    }), " - 2 * ").concat($83acad63ca408daa$export$9f2fdbacbc62226e, ")");
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $83acad63ca408daa$var$cellCap(_ref3) {
    var gap = _ref3.gap;
    return "calc(100% - ".concat($83acad63ca408daa$export$9f2fdbacbc62226e, " - ").concat(gap, ")");
}
/**
 * The anchor term of the placement-axis floor, and the one place it is capped.
 *
 * `'match-anchor'` earns a floor only where it can flip: a definite size clamps to
 * the cap and shrinks below the anchor instead of flipping.
 *
 * The `canFlip` clamp is deliberate both ways. With no flip in play an unclamped
 * floor beats `max-{axis}-size` (CSS resolves `min` last), making the viewport
 * backstop inert. With a flip in play, clamping would stop the floor exceeding
 * the cell cap, which is what drives the flip.
 */ function $83acad63ca408daa$var$getPlacementAxisAnchorFloor(_ref4) {
    var placementAxis = _ref4.placementAxis, placementAxisSize = _ref4.placementAxisSize, anchorValue = _ref4.anchorValue, canFlip = _ref4.canFlip, writingMode = _ref4.writingMode;
    var hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return undefined;
    if (canFlip) return anchorValue;
    return "min(".concat(anchorValue, ", ").concat($83acad63ca408daa$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    }), ")");
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells either side of the anchor add up to the viewport less the anchor,
 * so the roomier one is at least half of that. A floor whose margin box fits
 * inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` states
 * the lower bound for an anchor taller than the viewport.
 */ function $83acad63ca408daa$var$getDefaultPlacementAxisFloor(_ref5) {
    var placementAxis = _ref5.placementAxis, anchorValue = _ref5.anchorValue, gap = _ref5.gap, writingMode = _ref5.writingMode;
    if (anchorValue === null) return $83acad63ca408daa$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    var viewport = "100".concat($83acad63ca408daa$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    }));
    var halfOfRemainingViewport = "calc((".concat(viewport, " - ").concat(anchorValue, ") / 2 - ").concat(gap, " - ").concat($83acad63ca408daa$export$9f2fdbacbc62226e, ")");
    return "min(".concat($83acad63ca408daa$export$32ab78b2bb853a01, ", max(0px, ").concat(halfOfRemainingViewport, "))");
}
/**
 * The placement-axis floor: explicit minimums COMPOSE, the default does not.
 *
 * `placement.minSize` and the anchor term are both explicit requests, so they
 * compose as `max()`. `FALLBACK_MINIMUM_MAIN_AXIS_SIZE` never composes: it only
 * ever won by overriding a size the consumer asked for, and the anchor term drives
 * the flip on its own. Knock-on, intended: `minSize: 0` no longer removes an
 * anchor floor, because `max(0px, anchor)` IS the anchor.
 */ function $83acad63ca408daa$var$getPlacementAxisFloor(_ref6) {
    var minSize = _ref6.minSize, placementAxis = _ref6.placementAxis, placementAxisSize = _ref6.placementAxisSize, anchorValue = _ref6.anchorValue, gap = _ref6.gap, canFlip = _ref6.canFlip, writingMode = _ref6.writingMode;
    var anchorFloor = $83acad63ca408daa$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === undefined ? minSize : "max(".concat(minSize, ", ").concat(anchorFloor, ")");
    if (anchorFloor !== undefined) return anchorFloor;
    if (!canFlip) return undefined;
    return $83acad63ca408daa$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $83acad63ca408daa$export$860b30329fa0b990(_ref7) {
    var placement = _ref7.placement, inlineSize = _ref7.inlineSize, blockSize = _ref7.blockSize, isUsingCssAnchorPositioning = _ref7.isUsingCssAnchorPositioning, anchorSize = _ref7.anchorSize, writingMode = _ref7.writingMode, _ref7$shouldPreserveI = _ref7.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref7$shouldPreserveI === void 0 ? false : _ref7$shouldPreserveI;
    var placementAxis = placement.axis;
    var crossAxis = $83acad63ca408daa$var$getCrossAxis(placementAxis);
    // Rule 1. Feeds the per-axis CAPS only.
    var size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values instead, un-mirrored: flipping is a
    // whole-popover outcome, so a fit request on either axis turns the floor on.
    var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // ...but only where the floor is what causes the flip. On the JavaScript
    // fallback a floor only inflates the measured size the side is picked from, so
    // it would flip a popover that fits.
    var canFlip = isFitting && isUsingCssAnchorPositioning;
    var declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: "max-".concat(placementAxis, "-size"),
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $83acad63ca408daa$var$cellCap({
                gap: placement.offset.gap
            }) : $83acad63ca408daa$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: "max-".concat(crossAxis, "-size"),
            value: $83acad63ca408daa$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // A max beats a definite size, so the caps above still win over this.
    for(var _i = 0, _arr = [
        placementAxis,
        crossAxis
    ]; _i < _arr.length; _i++){
        var axis = _arr[_i];
        var anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: "".concat(axis, "-size"),
            value: anchorValue
        });
    }
    var placementAxisFloor = $83acad63ca408daa$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== undefined) declarations.push({
        property: "min-".concat(placementAxis, "-size"),
        value: placementAxisFloor
    });
    // A size contract, not a flip driver, so it is clamped to the cap.
    var crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: "min-".concat(crossAxis, "-size"),
        value: "min(".concat(crossAxisAnchorValue, ", ").concat($83acad63ca408daa$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        }), ")")
    });
    return declarations;
}

});


parcelRegister("892OF", function(module, exports) {
$parcel$export(module.exports, "getExistingAnchorName", function () { return $5ee1593dabd05035$export$948d15b01d509455; });
/**
 * The `anchor-name` an element already carries, or `null`. Computed as well as
 * inline, so a name set from a STYLESHEET is found: a minted inline name would
 * otherwise override it for every other rule anchored to that element.
 * `anchor-name` is a list and `position-anchor` takes one ident, so the first
 * name is the one to anchor to.
 */ function $5ee1593dabd05035$export$948d15b01d509455(element) {
    var declared = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    var first = declared.split(',')[0].trim();
    return first !== '' && first !== 'none' ? first : null;
}

});

parcelRegister("2j0Dh", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", function () { return $1addd8b58f41725f$export$de49b61f233ddeb9; });
/**
 * Resolves a placement to CSS `position-area` syntax.
 *
 * The `align` field represents the *visual* alignment:
 * - `align: 'start'` means "aligned to the trigger's start edge" (left in LTR for block axis)
 * - `align: 'end'` means "aligned to the trigger's end edge"
 * - `align: 'center'` means centered (single-axis position-area)
 *
 * CSS `position-area` uses `span-*` keywords which indicate the *expansion direction*.
 * Visual start-alignment requires `span-{cross-axis}-end` (expand toward end = start-aligned).
 * This function handles the inversion internally.
 *
 * Takes the RESOLVED placement, which the hook threads through positioning,
 * sizing and margins alike, so nothing here can disagree with them.
 *
 * @example
 * // For a `block-end` placement, by `align`:
 * // 'center' → 'block-end'
 * // 'start'  → 'block-end span-inline-end'
 * // 'end'    → 'block-end span-inline-start'
 */ function $1addd8b58f41725f$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("4liY4", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", function () { return $3297d63945de95c3$export$c4e16947a95d61f1; });
/**
 * The placement axis joined to its edge, e.g. `block-end`.
 */ /**
 * The cells to slide to along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not, and two options over the SAME cell have the same margin box and
 * the same fit result. That rules out three cells for an aligned placement: the
 * near span on the requested edge IS the base position-area, and on the opposite
 * edge the near and far spans are where `flip-{A}` and the diagonal flip land.
 *
 * A centred placement has no near or far, so it slides to both spans on both
 * edges.
 */ function $3297d63945de95c3$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis, isOppositeEdge = _ref.isOppositeEdge;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    if (isOppositeEdge) return [
        edgeKey
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`; `align: 'end'` mirrors this.
    var far = align === 'start' ? 'start' : 'end';
    return [
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $3297d63945de95c3$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $3297d63945de95c3$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $3297d63945de95c3$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        flipOnMainAxis,
        align !== 'center' ? $3297d63945de95c3$var$flipDiagonally({
            axis: axis
        }) : null,
        $3297d63945de95c3$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}

});


parcelRegister("awwHe", function(module, exports) {
$parcel$export(module.exports, "applyJavaScriptFallbackPositioning", function () { return $7a96415be7b10391$export$89babc4c2047d2ba; });

var $lFOXD = parcelRequire("lFOXD");

var $dH1HR = parcelRequire("dH1HR");

var $FcGYz = parcelRequire("FcGYz");

var $fkfWb = parcelRequire("fkfWb");

var $6GNUr = parcelRequire("6GNUr");

var $eQIp0 = parcelRequire("eQIp0");

var $94pFA = parcelRequire("94pFA");

var $fWaJR = parcelRequire("fWaJR");
/**
 * Wrapped because jsdom throws on the unknown `:popover-open` selector.
 */ function $7a96415be7b10391$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Observes the popover until its first non-zero layout, then self-disconnects;
 * ongoing movement is handled by the scroll and resize listeners. The popover is
 * `display: none` until `showPopover()`, and some browsers fire `toggle` before
 * layout, so RAF-after-toggle is unreliable.
 *
 * `null` where `ResizeObserver` is missing (non-DOM jest environments). There is
 * then no measurement to wait for, so the caller positions immediately and must
 * not hide the popover, because no reveal would follow.
 */ function $7a96415be7b10391$var$createFirstLayoutObserver(_ref) {
    var popover = _ref.popover, onFirstLayout = _ref.onFirstLayout;
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        var observer = new ResizeObserver(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $fWaJR.warnFallbackFailure)({
            error: error
        });
        return null;
    }
}
function $7a96415be7b10391$export$89babc4c2047d2ba(_ref2) {
    var anchor = _ref2.anchor, popover = _ref2.popover, placement = _ref2.placement, sizeStyles = _ref2.sizeStyles;
    // Already in the top layer via the `popover` attribute, so this only resets the
    // UA defaults and writes measured `top` / `left`.
    var cleanupBaseStyles = (0, $6GNUr.setStyle)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            }
        ].concat((0, $lFOXD.default)(sizeStyles))
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    var undoPosition;
    var undoHide;
    // Resolved once per open and per resize, reused across scrolls: resolving is a
    // full style and layout flush, and a scroll cannot change what a CSS length
    // resolves to. A resize can (viewport units), and so can a re-open (a token
    // retargeted while closed).
    var resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probed INSIDE the popover: it is in the top layer, not the anchor's DOM
        // tree, so anywhere else resolves a token against a different scope.
        resolvedOffsets = {
            gap: (0, $94pFA.resolveCssLengthToPixels)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $94pFA.resolveCssLengthToPixels)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        var _undoHide;
        (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
        undoHide = undefined;
    }
    function restorePosition() {
        var _undoPosition;
        (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
        undoPosition = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (undoHide) return;
        undoHide = (0, $6GNUr.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
   * Last resort. The base styles above reset the UA
   * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
   * sits in the viewport corner rather than centred.
   */ function centerInViewport() {
        restorePosition();
        undoPosition = (0, $6GNUr.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function update() {
        try {
            var triggerRect = anchor.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            var _getResolvedOffsets = getResolvedOffsets(), gap = _getResolvedOffsets.gap, crossAxisShift = _getResolvedOffsets.crossAxisShift;
            var _computeFallbackPosit = (0, $eQIp0.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // A non-finite coordinate serialises to a declaration the browser drops,
            // landing the popover in the corner just as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $6GNUr.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
        } catch (error) {
            (0, $fWaJR.warnFallbackFailure)({
                error: error
            });
            // Anchoring needs the trigger geometry we just failed to get, so the
            // centred position is the only one left to degrade to.
            try {
                centerInViewport();
            } catch (_unused2) {}
        } finally{
            // Unconditional. A popover in the wrong place is recoverable on the
            // next scroll or resize; one left at `opacity: 0` is invisible forever.
            reveal();
        }
    }
    function invalidateAndUpdate() {
        invalidateResolvedOffsets();
        update();
    }
    // One update per animation frame. Scroll reuses the resolved offsets; resize
    // re-resolves them.
    var scheduledScrollUpdate = (0, $FcGYz.default)(update);
    var scheduledResizeUpdate = (0, $FcGYz.default)(invalidateAndUpdate);
    var firstLayoutObserver = $7a96415be7b10391$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: update
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open re-resolves the offsets.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            update();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs, in which case the initial
    // `toggle` has fired and the listener below would miss it.
    if ($7a96415be7b10391$var$isPopoverOpen(popover)) positionOnNextLayout();
    return (0, $fkfWb.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
    (0, $dH1HR.bind)(popover, {
        type: 'toggle',
        listener: function listener(event) {
            var toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), function() {
        return firstLayoutObserver === null || firstLayoutObserver === void 0 ? void 0 : firstLayoutObserver.disconnect();
    }, (0, $dH1HR.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $dH1HR.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), function() {
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}

});
parcelRegister("fkfWb", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return $b285162051c7fb31$export$1be1fc439b849fdf; });
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $b285162051c7fb31$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("eQIp0", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", function () { return $acf85d607856e5cc$export$d5ef1dac02135664; });

var $f53LC = parcelRequire("f53LC");
function $acf85d607856e5cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acf85d607856e5cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acf85d607856e5cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acf85d607856e5cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * `TCrossAxisShiftOffset` with its CSS length already resolved to pixels. Only
 * this module needs the pixel form, because only this module does arithmetic.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $acf85d607856e5cc$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $acf85d607856e5cc$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $acf85d607856e5cc$var$_objectSpread($acf85d607856e5cc$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $acf85d607856e5cc$var$_objectSpread($acf85d607856e5cc$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $acf85d607856e5cc$var$_objectSpread($acf85d607856e5cc$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $acf85d607856e5cc$var$_objectSpread($acf85d607856e5cc$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $acf85d607856e5cc$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $acf85d607856e5cc$var$_objectSpread($acf85d607856e5cc$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $acf85d607856e5cc$var$_objectSpread($acf85d607856e5cc$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $acf85d607856e5cc$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $acf85d607856e5cc$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $acf85d607856e5cc$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $acf85d607856e5cc$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("94pFA", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", function () { return $69a86647c32a8e33$export$98721546d2816d9e; });

var $fWaJR = parcelRequire("fWaJR");
/**
 * `null` when the environment cannot measure at all.
 */ function $69a86647c32a8e33$var$measureWithProbe(_ref) {
    var value = _ref.value, container = _ref.container;
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    var view = container.ownerDocument.defaultView;
    if (!view) return null;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hidden from assistive tech and event targeting; defensive against
    // `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        var resolved = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(resolved) ? resolved : 0;
    } catch (error) {
        (0, $fWaJR.warnFallbackFailure)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $69a86647c32a8e33$export$98721546d2816d9e(_ref2) {
    var _measureWithProbe;
    var value = _ref2.value, container = _ref2.container;
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    return (_measureWithProbe = $69a86647c32a8e33$var$measureWithProbe({
        value: value,
        container: container
    })) !== null && _measureWithProbe !== void 0 ? _measureWithProbe : 0;
}

});
parcelRegister("fWaJR", function(module, exports) {
$parcel$export(module.exports, "warnFallbackFailure", function () { return $b9a49a4c3228c35a$export$e142245b95267f17; });

function $b9a49a4c3228c35a$export$e142245b95267f17(_ref) {
    var error = _ref.error;
    return;
}

});



parcelRegister("eETen", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorPositioning", function () { return $aabfa4d026860d9e$export$7192e63dfa9e8124; });

var $fs6Ul = parcelRequire("fs6Ul");
var $aabfa4d026860d9e$export$7192e63dfa9e8124 = (0, $fs6Ul.createCssDeclarationProbe)({
    property: 'anchor-name',
    value: '--a'
});

});
parcelRegister("fs6Ul", function(module, exports) {
$parcel$export(module.exports, "createCssDeclarationProbe", function () { return $b3fed44351094acf$export$69de71b4b7c76bad; });

var $8zODL = parcelRequire("8zODL");
function $b3fed44351094acf$export$69de71b4b7c76bad(_ref) {
    var property = _ref.property, value = _ref.value;
    return (0, $8zODL.default)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}

});


parcelRegister("lnDRX", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorSize", function () { return $f90aac23de7282b0$export$1c8dd0d1c9df9c6e; });

var $fs6Ul = parcelRequire("fs6Ul");
var $f90aac23de7282b0$export$1c8dd0d1c9df9c6e = (0, $fs6Ul.createCssDeclarationProbe)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});

});


parcelRegister("6YsXR", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", function () { return $513ed06ecc67f20d$export$9198c6c168be2eeb; });

var $4UF4U = parcelRequire("4UF4U");
function $513ed06ecc67f20d$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id`, not React's `useId`: React's output contains
    // `:`, `«` and `»`, which are invalid in an HTML id token.
    return "popover-".concat((0, $4UF4U.useId)());
}

});

parcelRegister("ez2cf", function(module, exports) {
$parcel$export(module.exports, "getPopupAxisSizes", function () { return $a9a609be0b02e719$export$60eb6c71554f82c4; });
/**
 * Maps the legacy `shouldFitContainer` / `shouldFitViewport` pair onto
 * `useAnchoredPopover`'s per-axis sizes. Shared by the standard and the
 * compositional adapter so the two cannot drift.
 *
 * Both props can be set together while `inlineSize` takes one value, so
 * `shouldFitContainer` wins the inline axis, being the more specific request.
 * Fitting then applies to the block axis only, and still turns the
 * placement-axis floor on, so a cramped popup flips rather than letterboxing.
 *
 * Known cost on a `left-*` / `right-*` placement: the anchor floor is unclamped
 * so it can drive the flip, and a min beats a max, so a trigger wider than the
 * viewport is floored past the viewport cap. Not new, and not reconciled - see
 * `@atlaskit/top-layer`'s `notes/decisions/width-from-anchor-floors.md`.
 */ function $a9a609be0b02e719$export$60eb6c71554f82c4(_ref) {
    var shouldFitContainer = _ref.shouldFitContainer, shouldFitViewport = _ref.shouldFitViewport;
    var blockSize = shouldFitViewport ? 'max-available' : 'content';
    if (shouldFitContainer) return {
        inlineSize: 'match-anchor',
        blockSize: blockSize
    };
    if (shouldFitViewport) return {
        inlineSize: 'max-available',
        blockSize: blockSize
    };
    return {
        inlineSize: 'content',
        blockSize: blockSize
    };
}

});

parcelRegister("buevq", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", function () { return $85cdbf998e64e6ab$export$892580369e97d8b9; });

var $1oC0p = parcelRequire("1oC0p");
function $85cdbf998e64e6ab$export$892580369e97d8b9(_ref) {
    var role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    return (0, $1oC0p.useMemo)(function() {
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId
            };
            return {
                role: role,
                label: label !== null && label !== void 0 ? label : 'Popup'
            };
        }
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId
    ]);
}

});


parcelRegister("bxhyr", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", function () { return $866064be0cb45ca9$export$4065aef1d79a5730; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $3EAdB = parcelRequire("3EAdB");
function $866064be0cb45ca9$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var canBecomeModal = _appearance === 'UNSAFE_modal-below-sm';
    /**
   * This gate removes unnecessary state changes across the below-sm boundary
   * The state change is only needed if the popup can become a modal - and this is maintained
   */ var shouldUseMediaQuery = !(0, $6ur0l.fg)('platform_dst_popup_media_query_perf_fix') || canBecomeModal;
    var mq = (0, $3EAdB.UNSAFE_useMediaQuery)('below.sm', shouldUseMediaQuery ? function(e) {
        setIsSmallViewport(!!e.matches);
    } : undefined);
    var _useState = (0, $1oC0p.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = canBecomeModal && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});

parcelRegister("kJYJr", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $f1971ebb9d9e4ee3$export$7cc5c058dd769dff; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $f1971ebb9d9e4ee3$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $2qaZZ.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("1YOVV", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $1712e75041ba6d8d$export$5d3a2de79e07b376; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $1712e75041ba6d8d$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $2qaZZ.default)(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});


parcelRegister("5IuSN", function(module, exports) {
$parcel$export(module.exports, "layers", function () { return $4299047e500a467c$export$7be255094ccdc533; });
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var $4299047e500a467c$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $4299047e500a467c$export$c93026a968943f95 = 'light';
var $4299047e500a467c$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $4299047e500a467c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};

});

parcelRegister("ktMX1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ee8c7cbdf0395487$export$2e2bcd8739ae039; });
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $dH1HR = parcelRequire("dH1HR");

var $gzpW5 = parcelRequire("gzpW5");

var $lv5Ml = parcelRequire("lv5Ml");

var $7uNuF = parcelRequire("7uNuF");

var $645Xv = parcelRequire("645Xv");

var $4YraT = parcelRequire("4YraT");

var $5RBBI = parcelRequire("5RBBI");

var $hHYun = parcelRequire("hHYun");

var $blVTZ = parcelRequire("blVTZ");

var $d5zZY = parcelRequire("d5zZY");

var $iJOpE = parcelRequire("iJOpE");

var $2hswD = parcelRequire("2hswD");

var $cqKdH = parcelRequire("cqKdH");

var $hVgGY = parcelRequire("hVgGY");

var $iZkh4 = parcelRequire("iZkh4");

var $7S5uJ = parcelRequire("7S5uJ");

var $7dAij = parcelRequire("7dAij");

var $8pQ5I = parcelRequire("8pQ5I");

var $5nInC = parcelRequire("5nInC");
function $ee8c7cbdf0395487$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ee8c7cbdf0395487$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ee8c7cbdf0395487$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ee8c7cbdf0395487$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ee8c7cbdf0395487$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $ee8c7cbdf0395487$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
/**
 * Event types produced by trigger interactions.
 *
 * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
 * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
 * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
 */ function $ee8c7cbdf0395487$var$getRootMenuPopover(_ref) {
    var _menu$parentElement;
    var menu = _ref.menu;
    var parentMenu = (_menu$parentElement = menu.parentElement) === null || _menu$parentElement === void 0 ? void 0 : _menu$parentElement.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $ee8c7cbdf0395487$var$getRootMenuPopover({
        menu: parentMenu
    });
}
/**
 * Loading indicator for the dropdown menu.
 */ function $ee8c7cbdf0395487$var$LoadingIndicator(_ref2) {
    var _ref2$statusLabel = _ref2.statusLabel, statusLabel = _ref2$statusLabel === void 0 ? 'Loading' : _ref2$statusLabel, testId = _ref2.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        role: "menuitem",
        className: (0, $2jatx.default)([
            $ee8c7cbdf0395487$var$styles.spinnerContainer
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $blVTZ.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
}
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $ee8c7cbdf0395487$var$DropdownMenuTopLayer(_ref3) {
    var _ref5;
    var children = _ref3.children, _ref3$defaultOpen = _ref3.defaultOpen, defaultOpen = _ref3$defaultOpen === void 0 ? false : _ref3$defaultOpen, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, isOpenProp = _ref3.isOpen, _ref3$onOpenChange = _ref3.onOpenChange, onOpenChange = _ref3$onOpenChange === void 0 ? (0, $7uNuF.default) : _ref3$onOpenChange, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom-start' : _ref3$placement, _ref3$shouldFitContai = _ref3.shouldFitContainer, shouldFitContainer = _ref3$shouldFitContai === void 0 ? false : _ref3$shouldFitContai, returnFocusRef = _ref3.returnFocusRef, spacing = _ref3.spacing, statusLabel = _ref3.statusLabel, testId = _ref3.testId, trigger = _ref3.trigger, label = _ref3.label, interactionName = _ref3.interactionName, menuLabel = _ref3.menuLabel;
    var _useControlledState = (0, $645Xv.default)(isOpenProp, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, $2qaZZ.default)(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $1oC0p.useRef)(null);
    var popoverRef = (0, $1oC0p.useRef)(null);
    var popoverId = (0, $7dAij.usePopoverId)();
    var topLayerPlacement = (0, $1oC0p.useMemo)(function() {
        return (0, $iJOpE.fromLegacyPlacement)({
            legacy: placement
        });
    }, [
        placement
    ]);
    (0, $hVgGY.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen
    });
    (0, $8pQ5I.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'min-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: triggerRef,
        isOpen: isLocalOpen
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    var handleOnClose = (0, $1oC0p.useCallback)(function() {
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    var handleTriggerClicked = (0, $1oC0p.useCallback)(function(event) {
        var nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen);
        // Extract the native DOM event for onOpenChange
        var nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    var _useFocus = (0, $4YraT.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $1oC0p.useEffect)(function() {
        var _triggerRef$current;
        if (!isFocused || isLocalOpen) return;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        var isNestedTrigger = Boolean((_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.closest('[role="menu"]'));
        return (0, $dH1HR.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $lv5Ml.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    var handleNestedOpen = (0, $1oC0p.useCallback)(function(_ref4) {
        var trigger = _ref4.trigger;
        trigger.click();
    }, []);
    var handleTabClose = (0, $1oC0p.useCallback)(function() {
        var currentMenu = popoverRef.current;
        if (!currentMenu) return;
        // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $ee8c7cbdf0395487$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $7S5uJ.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $iZkh4.isAtCurrentMenuLevel)
    });
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    var handleMenuClick = (0, $1oC0p.useCallback)(function(e) {
        var _e$target$closest, _e$target;
        if (!(e.target instanceof Element)) return;
        var menuItem = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        var isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        var isNestedTrigger = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    var ariaAttributes = (0, $d5zZY.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    var narrowAriaAttributes = ariaAttributes;
    /**
   * Custom trigger consumers historically receive a callback ref,
   * and their code assumes it is one.
   * Using this wrapper for compatibility...
   */ var setTriggerRef = (0, $1oC0p.useCallback)(function(node) {
        triggerRef.current = node;
    }, []);
    var renderTrigger = function renderTrigger() {
        if (typeof trigger === 'function') return trigger($ee8c7cbdf0395487$var$_objectSpread($ee8c7cbdf0395487$var$_objectSpread({}, narrowAriaAttributes), {}, {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && "".concat(testId, "--trigger")
        }));
        return /*#__PURE__*/ $1oC0p.createElement((0, $gzpW5.default), (0, $c9bqK.default)({
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef
        }, narrowAriaAttributes, {
            isSelected: isLocalOpen,
            iconAfter: function iconAfter(iconProps) {
                return /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), (0, $c9bqK.default)({}, iconProps, {
                    size: "small"
                }));
            },
            onClick: handleTriggerClicked,
            testId: testId && "".concat(testId, "--trigger"),
            "aria-label": label,
            interactionName: interactionName
        }), trigger);
    };
    return /*#__PURE__*/ $1oC0p.createElement((0, $5nInC.default), null, renderTrigger(), /*#__PURE__*/ $1oC0p.createElement((0, $2hswD.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: (_ref5 = menuLabel !== null && menuLabel !== void 0 ? menuLabel : label) !== null && _ref5 !== void 0 ? _ref5 : typeof trigger === 'string' ? trigger : 'Menu',
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: topLayerPlacement,
        testId: testId && "".concat(testId, "--content")
    }, /*#__PURE__*/ $1oC0p.createElement((0, $cqKdH.PopoverSurface), null, /*#__PURE__*/ $1oC0p.createElement((0, $hHYun.default), {
        maxHeight: $ee8c7cbdf0395487$var$MAX_HEIGHT,
        maxWidth: shouldFitContainer ? undefined : 800,
        onClick: handleMenuClick,
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-wrapper--menu-group")
    }, isLoading ? /*#__PURE__*/ $1oC0p.createElement($ee8c7cbdf0395487$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--menu-wrapper--loading-indicator")
    }) : children))));
}
var $ee8c7cbdf0395487$export$2e2bcd8739ae039 = $ee8c7cbdf0395487$var$DropdownMenuTopLayer;

});
parcelRegister("hHYun", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ce455fa53f7d5800$export$2e2bcd8739ae039; });
/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $5gHa6 = parcelRequire("5gHa6");

var $2eblu = parcelRequire("2eblu");
var $ce455fa53f7d5800$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $ce455fa53f7d5800$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $ce455fa53f7d5800$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, $gnQ3X.default)(_ref, $ce455fa53f7d5800$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement((0, $5gHa6.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $1oC0p.createElement((0, $2eblu.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $2jatx.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $ce455fa53f7d5800$export$2e2bcd8739ae039 = $ce455fa53f7d5800$var$MenuGroup;

});
parcelRegister("5gHa6", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", function () { return $3d5fed6f18714f06$export$443076ec7ebce042; });

var $1oC0p = parcelRequire("1oC0p");

var $3d5fed6f18714f06$export$443076ec7ebce042 = /*#__PURE__*/ (0, $1oC0p.createContext)('cozy');

});

parcelRegister("2eblu", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $19f5b090ba2c6b26$export$9ca534b70725964d; });

var $1oC0p = parcelRequire("1oC0p");
var $19f5b090ba2c6b26$export$9ca534b70725964d = /*#__PURE__*/ (0, $1oC0p.createContext)('border');

});


parcelRegister("blVTZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $843e9206c5c45bd6$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $iKtxb = parcelRequire("iKtxb");

var $2jC15 = parcelRequire("2jC15");
/**
 * Returns the appropriate circle stroke color.
 */ function $843e9206c5c45bd6$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $843e9206c5c45bd6$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $843e9206c5c45bd6$var$loadIn = null;
var $843e9206c5c45bd6$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $843e9206c5c45bd6$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $843e9206c5c45bd6$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $2jC15.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $843e9206c5c45bd6$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $iKtxb.default));
    $843e9206c5c45bd6$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $2jatx.default)([
            $843e9206c5c45bd6$var$styles.wrapperStyles,
            $843e9206c5c45bd6$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $2jatx.default)([
            $843e9206c5c45bd6$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $2jatx.default)([
            $843e9206c5c45bd6$var$styles.circleStyles
        ])
    })));
}));
var $843e9206c5c45bd6$export$2e2bcd8739ae039 = $843e9206c5c45bd6$var$Spinner;

});
parcelRegister("iKtxb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da636ebf81f7f18a$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $da636ebf81f7f18a$var$interactionContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $da636ebf81f7f18a$export$2e2bcd8739ae039 = $da636ebf81f7f18a$var$interactionContext;

});

parcelRegister("2jC15", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $1afad8636e4b0173$export$4e9f1640bbe7a1a8; });
var $1afad8636e4b0173$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("d5zZY", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", function () { return $9877aa947e055a72$export$9dd1d61dd4d4755; });
/**
 * Roles accepted by `getAriaForTrigger`.
 *
 * Excludes tooltip-family roles (`tooltip`, `note`, `status`, `alert`, `log`)
 * because the correct trigger wiring for those is `aria-describedby`, not
 * `aria-haspopup` / `aria-expanded` / `aria-controls`. Use `aria-describedby`
 * manually for tooltip triggers.
 */ /**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ /**
 * Non-undefined subset of `TAriaHasPopupValue`. Every role accepted by
 * `getAriaForTrigger` maps to a concrete `aria-haspopup` string, so the
 * trigger always receives a defined attribute value.
 */ var $9877aa947e055a72$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $9877aa947e055a72$export$9dd1d61dd4d4755(_ref) {
    var role = _ref.role, isOpen = _ref.isOpen, popoverId = _ref.popoverId;
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': $9877aa947e055a72$var$roleToAriaHasPopup[role],
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("cqKdH", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", function () { return $90cbc416a930df36$export$8b7437164e479115; });
/* popover-surface.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $90cbc416a930df36$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $90cbc416a930df36$export$8b7437164e479115(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $90cbc416a930df36$var$styles.root
        ])
    }, children);
}

});

parcelRegister("iZkh4", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", function () { return $dd2da68e8ea5a143$export$f1bba0ef464d60af; });
var $dd2da68e8ea5a143$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $dd2da68e8ea5a143$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $dd2da68e8ea5a143$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $dd2da68e8ea5a143$export$f1bba0ef464d60af(element, container) {
    var closestMenu = element.closest($dd2da68e8ea5a143$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $dd2da68e8ea5a143$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}

});

parcelRegister("7S5uJ", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", function () { return $5bb1d6a73fc8e58b$export$23dfbae28e0cc453; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $fUlfp = parcelRequire("fUlfp");

var $lv5Ml = parcelRequire("lv5Ml");

var $4exwW = parcelRequire("4exwW");

var $80GK8 = parcelRequire("80GK8");

var $33SPB = parcelRequire("33SPB");
var $5bb1d6a73fc8e58b$var$menuScope = '[role="menu"]';
function $5bb1d6a73fc8e58b$export$23dfbae28e0cc453(_ref) {
    var containerRef = _ref.containerRef, onClose = _ref.onClose, onNestedOpen = _ref.onNestedOpen, onNestedClose = _ref.onNestedClose, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, filter = _ref.filter;
    var handleKeyDown = (0, $1oC0p.useCallback)(function(event) {
        var _getDocument;
        var container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        var focused = (_getDocument = (0, $fUlfp.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($5bb1d6a73fc8e58b$var$menuScope) !== container) return;
        }
        if (event.key === (0, $lv5Ml.KEY_DOWN)) {
            var _getNextFocusable;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable = (0, $33SPB.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })) === null || _getNextFocusable === void 0 || _getNextFocusable.focus();
            return;
        }
        if (event.key === (0, $lv5Ml.KEY_UP)) {
            var _getNextFocusable2;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable2 = (0, $33SPB.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })) === null || _getNextFocusable2 === void 0 || _getNextFocusable2.focus();
            return;
        }
        if (event.key === (0, $lv5Ml.KEY_HOME)) {
            var _getFirstFocusable;
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (_getFirstFocusable = (0, $4exwW.getFirstFocusable)({
                container: container,
                filter: filter
            })) === null || _getFirstFocusable === void 0 || _getFirstFocusable.focus();
            return;
        }
        if (event.key === (0, $lv5Ml.KEY_END)) {
            var _getLastFocusable;
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (_getLastFocusable = (0, $80GK8.getLastFocusable)({
                container: container,
                filter: filter
            })) === null || _getLastFocusable === void 0 || _getLastFocusable.focus();
            return;
        }
        if (event.key === (0, $lv5Ml.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                var _container$parentElem;
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                var isNested = ((_container$parentElem = container.parentElement) === null || _container$parentElem === void 0 ? void 0 : _container$parentElem.closest($5bb1d6a73fc8e58b$var$menuScope)) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $1oC0p.useEffect)(function() {
        var container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $dH1HR.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});

parcelRegister("5nInC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3eb186a9ff5d2180$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $fM8e9 = parcelRequire("fM8e9");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $3eb186a9ff5d2180$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $1oC0p.useRef)({});
    var context = (0, $1oC0p.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fM8e9.SelectionStoreContext).Provider, {
        value: context
    }, children);
};
var $3eb186a9ff5d2180$export$2e2bcd8739ae039 = $3eb186a9ff5d2180$var$SelectionStore;

});
parcelRegister("fM8e9", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", function () { return $b7c1b878bcb7ea2c$export$756f795847463ebd; });

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");
var $b7c1b878bcb7ea2c$export$756f795847463ebd = /*#__PURE__*/ (0, $1oC0p.createContext)({
    setItemState: (0, $7uNuF.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $7uNuF.default),
    getGroupState: function getGroupState() {
        return {};
    }
});

});



parcelRegister("aAEhY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b5c84b925051c93$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $67RyF = parcelRequire("67RyF");

var $cd9Fn = parcelRequire("cd9Fn");

var $bnGbp = parcelRequire("bnGbp");
/**
 * Focus manager logic.
 */ var $7b5c84b925051c93$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $1oC0p.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $1oC0p.useState)(0), _useState2 = (0, $2qaZZ.default)(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $1oC0p.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $1oC0p.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $67RyF.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    var isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $1oC0p.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bind)(window, {
            type: 'keydown',
            listener: (0, $cd9Fn.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        });
    }, [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bnGbp.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $7b5c84b925051c93$export$2e2bcd8739ae039 = $7b5c84b925051c93$var$FocusManager;

});
parcelRegister("cd9Fn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8e3e327b5a20edb6$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $lv5Ml = parcelRequire("lv5Ml");

var $6ur0l = parcelRequire("6ur0l");

var $9NzsX = parcelRequire("9NzsX");
var $8e3e327b5a20edb6$var$actionMap = (0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)({}, (0, $lv5Ml.KEY_DOWN), 'next'), (0, $lv5Ml.KEY_UP), 'prev'), (0, $lv5Ml.KEY_HOME), 'first'), (0, $lv5Ml.KEY_END), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $8e3e327b5a20edb6$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $8e3e327b5a20edb6$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8e3e327b5a20edb6$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    var isNestedMenu = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $6ur0l.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $9NzsX.PREFIX), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $lv5Ml.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $lv5Ml.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $lv5Ml.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $lv5Ml.KEY_RIGHT)) {
            var activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        var action = $8e3e327b5a20edb6$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $8e3e327b5a20edb6$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $8e3e327b5a20edb6$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $8e3e327b5a20edb6$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $8e3e327b5a20edb6$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("9NzsX", function(module, exports) {
$parcel$export(module.exports, "PREFIX", function () { return $722433794ff0067d$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "default", function () { return $722433794ff0067d$export$2e2bcd8739ae039; });

var $4UF4U = parcelRequire("4UF4U");
var $722433794ff0067d$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $722433794ff0067d$export$2e2bcd8739ae039() {
    var id = (0, $4UF4U.useId)();
    return "".concat($722433794ff0067d$export$8a682ae47622dbb9).concat(id);
}

});


parcelRegister("bnGbp", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", function () { return $84929058ade3cc56$export$f18c1d4fc7326096; });

var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");
var $84929058ade3cc56$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    menuItemRefs: [],
    registerRef: (0, $7uNuF.default)
});

});


parcelRegister("lAIxe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fb7f8176e3504c7c$export$2e2bcd8739ae039; });
/* menu-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");


var $hHYun = parcelRequire("hHYun");

var $6ur0l = parcelRequire("6ur0l");

var $2sVl0 = parcelRequire("2sVl0");

var $blVTZ = parcelRequire("blVTZ");

var $7DshK = parcelRequire("7DshK");

var $8DeAm = parcelRequire("8DeAm");

var $bnGbp = parcelRequire("bnGbp");
var $fb7f8176e3504c7c$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
var $fb7f8176e3504c7c$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement((0, $2sVl0.Box), {
        xcss: $fb7f8176e3504c7c$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $1oC0p.createElement((0, $blVTZ.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $fb7f8176e3504c7c$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $1oC0p.useContext)((0, $bnGbp.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $7DshK.default)(menuItem) || (0, $8DeAm.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $1oC0p.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $1oC0p.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (((0, $6ur0l.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $hHYun.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $1oC0p.createElement($fb7f8176e3504c7c$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $fb7f8176e3504c7c$export$2e2bcd8739ae039 = $fb7f8176e3504c7c$var$MenuWrapper;

});
parcelRegister("7DshK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58f21dca8a219b06$export$2e2bcd8739ae039; });
function $58f21dca8a219b06$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("8DeAm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $648d4798722b323b$export$2e2bcd8739ae039; });
function $648d4798722b323b$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("dnhgz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9bcad11636ec3a4e$export$2e2bcd8739ae039; });
// eslint-disable-next-line sort-imports

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");

var $bnGbp = parcelRequire("bnGbp");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $9bcad11636ec3a4e$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $1oC0p.useContext)((0, $bnGbp.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        if (hasPopup && (0, $6ur0l.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $9bcad11636ec3a4e$export$2e2bcd8739ae039 = $9bcad11636ec3a4e$var$useRegisterItemWithFocusManager;

});


parcelRegister("jRJoS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e7662f187da54a63$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $kPutE = parcelRequire("kPutE");

var $6bqa5 = parcelRequire("6bqa5");

var $1e1un = parcelRequire("1e1un");

var $1B4iK = parcelRequire("1B4iK");

var $6ur0l = parcelRequire("6ur0l");

var $dnhgz = parcelRequire("dnhgz");
var $e7662f187da54a63$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $e7662f187da54a63$var$DropdownMenuItem = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, $gnQ3X.default)(_ref, $e7662f187da54a63$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var isNestedTrigger = !!rest['aria-haspopup'];
    var itemRef = (0, $dnhgz.default)(isNestedTrigger);
    var handleItemClick = (0, $1oC0p.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1e1un.default), (0, $c9bqK.default)({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $kPutE.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1B4iK.default), (0, $c9bqK.default)({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $kPutE.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6bqa5.default), (0, $c9bqK.default)({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $kPutE.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest, isNestedTrigger && (0, $6ur0l.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
        'aria-current': undefined
    } : {}), children);
});
var $e7662f187da54a63$export$2e2bcd8739ae039 = $e7662f187da54a63$var$DropdownMenuItem;

});
parcelRegister("6bqa5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4808105639e83f10$export$2e2bcd8739ae039; });
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $iKtxb = parcelRequire("iKtxb");

var $Hz75K = parcelRequire("Hz75K");
var $4808105639e83f10$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $4808105639e83f10$var$ButtonItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, $gnQ3X.default)(props, $4808105639e83f10$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $1oC0p.useContext)((0, $iKtxb.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $1oC0p.createElement((0, $Hz75K.default), (0, $c9bqK.default)({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $1oC0p.createElement("button", (0, $c9bqK.default)({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $4808105639e83f10$export$2e2bcd8739ae039 = $4808105639e83f10$var$ButtonItem;

});
parcelRegister("Hz75K", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $082f410d9e0f3e2a$export$2e2bcd8739ae039; });
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6ur0l = parcelRequire("6ur0l");

var $iAPkr = parcelRequire("iAPkr");

var $5gHa6 = parcelRequire("5gHa6");

var $2eblu = parcelRequire("2eblu");
var $082f410d9e0f3e2a$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $1oC0p.createElement(Component, props));
};
var $082f410d9e0f3e2a$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g",
    motionUnselected: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $082f410d9e0f3e2a$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $082f410d9e0f3e2a$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $082f410d9e0f3e2a$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $1oC0p.useContext)((0, $5gHa6.SpacingContext));
    var selectionStyle = (0, $1oC0p.useContext)((0, $2eblu.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $2jatx.default)([
                (0, $2jatx.default)([
                    $082f410d9e0f3e2a$var$styles.root,
                    $082f410d9e0f3e2a$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $082f410d9e0f3e2a$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') && $082f410d9e0f3e2a$var$styles.motionUnselected,
                    !isDisabled && isSelected && $082f410d9e0f3e2a$var$styles.selected,
                    !isDisabled && isSelected && (0, $6ur0l.fg)('platform-dst-motion-uplift-list-item') && $082f410d9e0f3e2a$var$styles.motionSelected,
                    !isDisabled && isSelected && $082f410d9e0f3e2a$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $082f410d9e0f3e2a$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $082f410d9e0f3e2a$var$styles.selectedNotch,
                    isDisabled && $082f410d9e0f3e2a$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $1oC0p.createElement((0, $iAPkr.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $082f410d9e0f3e2a$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $1oC0p.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $2jatx.default)([
                    $082f410d9e0f3e2a$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $1oC0p.createElement("div", {
                className: (0, $2jatx.default)([
                    $082f410d9e0f3e2a$var$styles.content
                ])
            }, $082f410d9e0f3e2a$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $2jatx.default)([
                    $082f410d9e0f3e2a$var$styles.title,
                    shouldTitleWrap ? $082f410d9e0f3e2a$var$styles.wordBreak : $082f410d9e0f3e2a$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $1oC0p.createElement("span", {
                "data-item-description": true,
                className: (0, $2jatx.default)([
                    $082f410d9e0f3e2a$var$styles.description,
                    isDisabled && $082f410d9e0f3e2a$var$styles.disabledDescription,
                    shouldDescriptionWrap && $082f410d9e0f3e2a$var$styles.wordBreak,
                    !shouldDescriptionWrap && $082f410d9e0f3e2a$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $1oC0p.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $2jatx.default)([
                    $082f410d9e0f3e2a$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $082f410d9e0f3e2a$export$2e2bcd8739ae039 = $082f410d9e0f3e2a$var$MenuItemPrimitive;

});


parcelRegister("1e1un", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e4840eebafab4eb$export$2e2bcd8739ae039; });
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $iKtxb = parcelRequire("iKtxb");

var $Hz75K = parcelRequire("Hz75K");
var $0e4840eebafab4eb$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $0e4840eebafab4eb$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $0e4840eebafab4eb$var$CustomItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, $gnQ3X.default)(_ref, $0e4840eebafab4eb$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $1oC0p.useContext)((0, $iKtxb.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $1oC0p.createElement((0, $Hz75K.default), (0, $c9bqK.default)({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $0e4840eebafab4eb$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $0e4840eebafab4eb$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $0e4840eebafab4eb$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled || undefined
        }), children);
    });
}));
var $0e4840eebafab4eb$export$2e2bcd8739ae039 = $0e4840eebafab4eb$var$CustomItem;

});

parcelRegister("1B4iK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $129c9554bdd68de6$export$2e2bcd8739ae039; });
/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $cBUAV = parcelRequire("cBUAV");

var $iKtxb = parcelRequire("iKtxb");

var $Hz75K = parcelRequire("Hz75K");
var $129c9554bdd68de6$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $129c9554bdd68de6$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $129c9554bdd68de6$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $129c9554bdd68de6$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $129c9554bdd68de6$var$LinkItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, $gnQ3X.default)(props, $129c9554bdd68de6$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $cBUAV.useRouterLink)();
    var interactionContext = (0, $1oC0p.useContext)((0, $iKtxb.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $129c9554bdd68de6$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $129c9554bdd68de6$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $1oC0p.createElement((0, $Hz75K.default), (0, $c9bqK.default)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $129c9554bdd68de6$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $129c9554bdd68de6$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $129c9554bdd68de6$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled || undefined,
            ref: ref
        }), children);
    });
}));
var $129c9554bdd68de6$export$2e2bcd8739ae039 = $129c9554bdd68de6$var$LinkItem;

});
parcelRegister("cBUAV", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", function () { return $92e4d74118688fb5$export$6d558eab13290f59; });

var $1oC0p = parcelRequire("1oC0p");

var $bM55D = parcelRequire("bM55D");
var $92e4d74118688fb5$export$6d558eab13290f59 = function useRouterLink() {
    var _useContext = (0, $1oC0p.useContext)((0, $bM55D.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("bM55D", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $8928202a05713f5c$export$2931e0ee690eee88; });

var $1oC0p = parcelRequire("1oC0p");
var $8928202a05713f5c$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $1oC0p.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $8928202a05713f5c$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($8928202a05713f5c$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$8928202a05713f5c$export$2e2bcd8739ae039 = $8928202a05713f5c$var$RouterLinkProvider;

});




parcelRegister("85WhL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e4c00aae8b79e94$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $4UF4U = parcelRequire("4UF4U");

var $anLO6 = parcelRequire("anLO6");

var $jtZzC = parcelRequire("jtZzC");
var $5e4c00aae8b79e94$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $5e4c00aae8b79e94$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, $gnQ3X.default)(_ref, $5e4c00aae8b79e94$var$_excluded);
    var uid = (0, $4UF4U.useId)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $anLO6.default), (0, $c9bqK.default)({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jtZzC.default), {
        id: titleId,
        title: title
    }), children);
});
var $5e4c00aae8b79e94$export$2e2bcd8739ae039 = $5e4c00aae8b79e94$var$DropdownMenuItemGroup;

});
parcelRegister("anLO6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $78f122da400e4ade$export$2e2bcd8739ae039; });
/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2lWfr = parcelRequire("2lWfr");
var $78f122da400e4ade$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "label",
    "className"
];
var $78f122da400e4ade$var$itemHeadingTopMargin = 20;
var $78f122da400e4ade$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $78f122da400e4ade$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $78f122da400e4ade$var$skeletonHeadingHeight = 8;
var $78f122da400e4ade$var$skeletonHeadingMarginOffset = 3;
var $78f122da400e4ade$var$skeletonHeadingTopMargin = $78f122da400e4ade$var$itemHeadingTopMargin + ($78f122da400e4ade$var$itemHeadingContentHeight - $78f122da400e4ade$var$skeletonHeadingHeight) - $78f122da400e4ade$var$skeletonHeadingMarginOffset;
var $78f122da400e4ade$var$sectionPaddingTopBottom = 6;
var $78f122da400e4ade$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $78f122da400e4ade$var$Section = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, label = _ref.label, UNSAFE_className = _ref.className, rest = (0, $gnQ3X.default)(_ref, $78f122da400e4ade$var$_excluded);
    var content = isList ? /*#__PURE__*/ $1oC0p.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $1oC0p.Children).map((0, $1oC0p.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $1oC0p.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement((0, $2lWfr.default), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            isSideNavSection && $78f122da400e4ade$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, content);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2jatx.default)([
            $78f122da400e4ade$var$styles.root,
            isScrollable ? $78f122da400e4ade$var$styles.scrollable : $78f122da400e4ade$var$styles.unscrollable,
            hasSeparator ? $78f122da400e4ade$var$styles.thinSeparator : $78f122da400e4ade$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $78f122da400e4ade$export$2e2bcd8739ae039 = $78f122da400e4ade$var$Section;

});
parcelRegister("2lWfr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1b6ab9ceff63d5a4$export$2e2bcd8739ae039; });
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $1b6ab9ceff63d5a4$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $1b6ab9ceff63d5a4$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $1b6ab9ceff63d5a4$var$HeadingItem = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, $gnQ3X.default)(_ref, $1b6ab9ceff63d5a4$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $2jatx.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ])
    }, rest), children);
});
var $1b6ab9ceff63d5a4$export$2e2bcd8739ae039 = $1b6ab9ceff63d5a4$var$HeadingItem;

});


parcelRegister("jtZzC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e2f07cfdbcd6057f$export$2e2bcd8739ae039; });
/* group-title.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $1oC0p = parcelRequire("1oC0p");

var $2sVl0 = parcelRequire("2sVl0");
var $e2f07cfdbcd6057f$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ var $e2f07cfdbcd6057f$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2sVl0.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $e2f07cfdbcd6057f$var$styles.heading
    }, title);
};
var $e2f07cfdbcd6057f$export$2e2bcd8739ae039 = $e2f07cfdbcd6057f$var$GroupTitle;

});


parcelRegister("f4kGi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af874595044636fc$export$2e2bcd8739ae039; });
/* lozenge-dropdown-trigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $c9bqK = parcelRequire("c9bqK");

var $1oC0p = parcelRequire("1oC0p");


var $7uNuF = parcelRequire("7uNuF");

var $farUN = parcelRequire("farUN");
/**
 * __Lozenge Dropdown Trigger__
 *
 * An interactive lozenge component that acts as a dropdown trigger.
 * Built on LozengeBase with dropdown interaction patterns.
 *
 * - Supports all color variants from the lozenge
 * - Shows selected state with dedicated color tokens
 * - Includes a chevron icon on the right of the text
 * - Built for dropdown menu interactions
 * - Supports analytics events and UFO press interactions
 */ var $af874595044636fc$var$LozengeDropdownTrigger = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? (0, $7uNuF.default) : _ref$onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        isSelected: isSelected,
        isLoading: isLoading,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        onClick: onClick,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: children,
        'aria-controls': ariaControls,
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHaspopup,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ $1oC0p.createElement((0, $farUN.default), (0, $c9bqK.default)({
        ref: ref
    }, baseProps), children);
}));
$af874595044636fc$var$LozengeDropdownTrigger.displayName = 'LozengeDropdownTrigger';
var $af874595044636fc$export$2e2bcd8739ae039 = $af874595044636fc$var$LozengeDropdownTrigger;

});



parcelRegister("4Bdsv", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundEngineeringToolbar", function () { return $641da8c7977a2983$export$543a713957eb70c3; });
/* jsm-playground-engineering-toolbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1q52J = parcelRequire("1q52J");
var $2r6UE = parcelRequire("2r6UE");

var $fhDEu = parcelRequire("fhDEu");
var $jRJoS = parcelRequire("jRJoS");
var $85WhL = parcelRequire("85WhL");

var $bIY3n = parcelRequire("bIY3n");

var $97j0t = parcelRequire("97j0t");

var $56bcs = parcelRequire("56bcs");

var $l5ucJ = parcelRequire("l5ucJ");

var $eAAXu = parcelRequire("eAAXu");

var $4ISy2 = parcelRequire("4ISy2");

var $5GoT9 = parcelRequire("5GoT9");

var $dXWnS = parcelRequire("dXWnS");
const $641da8c7977a2983$var$AddViewButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bIY3n))), {
        label: "",
        size: "medium"
    });
const $641da8c7977a2983$var$FilterChevronIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5ucJ))), {
        label: "",
        size: "medium"
    });
const $641da8c7977a2983$var$MoreActionsIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ISy2))), {
        label: "",
        size: "medium"
    });
const $641da8c7977a2983$export$543a713957eb70c3 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpu2gc _1q51mszt _18zr1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-level": 3,
                        role: "heading",
                        className: (0, $2jatx.default)([
                            "_1mouidpf _ect4ttxp _1wybgktf _k48pni7l _vwz44jg8"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $dXWnS.engineeringMessages).incomingRequests
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvresu3"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _1o9zidpf _4cvr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                    "aria-pressed": true,
                                    type: "button",
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm _1e0c116y _4cvr1h6o _zulp12x7 _ahbq1ff9 _1rjc12x7 _18zrpxbi _189eidpf _bfhk1j28 _syaz6x5g _11c8fhey _k48p1wq8 _o5721q9c _80omtlke _1kt9b3bt _1cs8stnw _1fkridpf _z5wtidpf _1enwidpf _kfgte4h9 _1rus1l7x _aetrb3bt _18postnw _1gufidpf _g0nfu2gc _1czdu2gc _1qdg1dm9 _14mjlb4i _1hfkq98m _128mdkaa _ra3xnqa1 _mizu1v1w _1ah3ibij"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAAXu))), {
                                            label: "",
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            ...(0, $dXWnS.engineeringMessages).list
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1e0c1txw _1ul9idpf _16jlkb7n _1o9zkb7n _i0dl1wug _1wpz1fhb _4cvr1h6o _bozg1b66"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        "aria-hidden": true,
                                        className: (0, $2jatx.default)([
                                            "_kqswstnw _u7coidpf _1e02idpf _rjxpidpf _4t3ie4h9 _bfhk1l7x"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _1e0c116y _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhDEu.default), {
                                            placement: "bottom-start",
                                            shouldRenderToParent: true,
                                            testId: "engineering-add-view",
                                            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                    ...triggerProps,
                                                    ref: triggerRef,
                                                    appearance: "subtle",
                                                    icon: $641da8c7977a2983$var$AddViewButtonIcon,
                                                    label: intl.formatMessage((0, $dXWnS.engineeringMessages).addView),
                                                    spacing: "compact"
                                                }),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $85WhL.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jRJoS.default), {
                                                        elemBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($56bcs))), {
                                                            color: "currentColor",
                                                            label: "",
                                                            size: "small"
                                                        }),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                            ...(0, $dXWnS.engineeringMessages).calendar
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jRJoS.default), {
                                                        elemBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($97j0t))), {
                                                            color: "currentColor",
                                                            label: "",
                                                            size: "small"
                                                        }),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                            ...(0, $dXWnS.engineeringMessages).board
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulpu2gc _1rjcpxbi _18zr1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bsb1wdt _1o9zidpf _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5GoT9.JsmPlaygroundSearchField), {
                            label: intl.formatMessage((0, $dXWnS.engineeringMessages).searchWork),
                            placeholder: intl.formatMessage((0, $dXWnS.engineeringMessages).searchWork)
                        })
                    }),
                    [
                        (0, $dXWnS.engineeringMessages).requestType,
                        (0, $dXWnS.engineeringMessages).status,
                        (0, $dXWnS.engineeringMessages).assignee
                    ].map((message)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            "aria-hidden": true,
                            className: (0, $2jatx.default)([
                                "_1e0c116y _lcxvglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                iconAfter: $641da8c7977a2983$var$FilterChevronIcon,
                                tabIndex: -1,
                                children: intl.formatMessage(message)
                            })
                        }, message.id)),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                        "aria-hidden": true,
                        className: (0, $2jatx.default)([
                            "_1e0c116y _1o9zidpf _4cvr1h6o _zulp1b66 _ahbq1wug _lcxvglyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                tabIndex: -1,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...(0, $dXWnS.engineeringMessages).triage
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                icon: $641da8c7977a2983$var$MoreActionsIcon,
                                label: intl.formatMessage((0, $dXWnS.engineeringMessages).moreActions),
                                tabIndex: -1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $641da8c7977a2983$var$pageHeaderStyles = null;
const $641da8c7977a2983$var$pageTitleStyles = null;
const $641da8c7977a2983$var$viewBarStyles = null;
const $641da8c7977a2983$var$viewTabsStyles = null;
// Drawn to the ADS tab the prototype uses: a 6px/8px tab whose label span adds another 8px inline,
// the strip pulled left by the tab's own inline padding, a 1px baseline under the whole tab and the
// 2px selected indicator inset to the tab's padding.
const $641da8c7977a2983$var$activeViewStyles = null;
const $641da8c7977a2983$var$viewBarRemainderStyles = null;
const $641da8c7977a2983$var$viewBarRuleStyles = null;
const $641da8c7977a2983$var$addViewDropdownStyles = null;
const $641da8c7977a2983$var$toolbarStyles = null;
const $641da8c7977a2983$var$searchStyles = null;
const $641da8c7977a2983$var$inertControlStyles = null;
const $641da8c7977a2983$var$toolbarActionsStyles = null;

});


parcelRegister("fhSO9", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundErrorBoundary", function () { return $4795338eece9c93c$export$8873030977769b82; });
/* eslint-disable react/prop-types */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $gx3aw = parcelRequire("gx3aw");
const $4795338eece9c93c$var$getCanonicalUrl = ()=>{
    if (typeof document !== 'undefined') {
        const canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink?.href) return canonicalLink.href;
    }
    if (typeof window !== 'undefined' && window.location?.href) return window.location.href;
    return '';
};
const $4795338eece9c93c$var$getPagePath = ()=>{
    if (typeof window !== 'undefined' && window.location?.pathname) return window.location.pathname;
    return '';
};
const $4795338eece9c93c$var$getLoginUserDetected = ()=>{
    if (typeof document !== 'undefined') {
        const cookie = (0, $gx3aw.Cookie).readCookie('login_user_detected');
        if (cookie) return cookie;
    }
    return 'false';
};
class $4795338eece9c93c$var$InnerErrorBoundary extends (0, $1oC0p.Component) {
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onError?.(error, errorInfo);
    }
    componentDidUpdate(prevProps) {
        if (this.state.hasError && this.props.resetKeys) {
            const hasChanged = this.props.resetKeys.length !== prevProps.resetKeys?.length || this.props.resetKeys.some((key, index)=>key !== prevProps.resetKeys?.[index]);
            if (hasChanged) this.resetErrorBoundary();
        }
    }
    render() {
        if (this.state.hasError && this.state.error) {
            if (this.props.fallbackRender) return this.props.fallbackRender({
                error: this.state.error,
                resetErrorBoundary: this.resetErrorBoundary
            });
            if (this.props.fallback !== undefined) return this.props.fallback;
            return null;
        }
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false,
            error: null
        }, this.resetErrorBoundary = ()=>{
            this.props.onReset?.();
            this.setState({
                hasError: false,
                error: null
            });
        };
    }
}
const $4795338eece9c93c$export$8873030977769b82 = ({ children: children, activeTab: activeTab, teamType: teamType = activeTab ?? 'it_support', fallback: fallback = null, fallbackRender: fallbackRender, onError: onError, onReset: onReset, resetKeys: resetKeys })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleError = (error, info)=>{
        onError?.(error, info);
        createAnalyticsEvent({
            actionSubject: 'jsmPlaygroundSection',
            action: 'failed',
            actionSubjectId: 'errorBoundary',
            eventType: 'operational',
            source: 'jsm-playground',
            attributes: {
                trackEventName: 'playground-render-failed',
                eventContainer: 'jsm-playground',
                team_type: teamType.replace(/-/g, '_'),
                errorType: 'render_error',
                errorMessage: error?.message ?? String(error),
                componentStack: info?.componentStack ?? '',
                page_canonical_url: $4795338eece9c93c$var$getCanonicalUrl(),
                page_path: $4795338eece9c93c$var$getPagePath(),
                loginUserDetected: $4795338eece9c93c$var$getLoginUserDetected()
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($4795338eece9c93c$var$InnerErrorBoundary, {
        resetKeys: resetKeys ?? [
            teamType
        ],
        onError: handleError,
        onReset: onReset,
        fallback: fallback,
        fallbackRender: fallbackRender,
        children: children
    });
};
var $4795338eece9c93c$export$2e2bcd8739ae039 = $4795338eece9c93c$export$8873030977769b82;

});

parcelRegister("3jVXj", function(module, exports) {
$parcel$export(module.exports, "JsmPlaygroundItOperations", function () { return $a5128dc04fc1e597$export$d18c278cd1ad74c9; });
/* jsm-playground-it-operations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $aeRPX = parcelRequire("aeRPX");

var $1q52J = parcelRequire("1q52J");
var $2r6UE = parcelRequire("2r6UE");

var $kMnBu = parcelRequire("kMnBu");
var $i99jD = parcelRequire("i99jD");
var $aKsx2 = parcelRequire("aKsx2");

var $bIY3n = parcelRequire("bIY3n");

var $53VCz = parcelRequire("53VCz");

var $iCsNc = parcelRequire("iCsNc");

var $dNI7u = parcelRequire("dNI7u");

var $hrBjL = parcelRequire("hrBjL");

var $l5ucJ = parcelRequire("l5ucJ");

var $k3Xeq = parcelRequire("k3Xeq");

var $aTuVh = parcelRequire("aTuVh");

var $5Szrz = parcelRequire("5Szrz");

var $g02sa = parcelRequire("g02sa");

var $dq5XW = parcelRequire("dq5XW");

var $2HbHF = parcelRequire("2HbHF");

var $jKuSd = parcelRequire("jKuSd");

var $6A2DX = parcelRequire("6A2DX");

var $izDBw = parcelRequire("izDBw");

var $lPRxe = parcelRequire("lPRxe");

var $4jcRW = parcelRequire("4jcRW");

var $jdqfU = parcelRequire("jdqfU");

var $kbpa7 = parcelRequire("kbpa7");

var $cmk36 = parcelRequire("cmk36");

var $8DlQO = parcelRequire("8DlQO");

var $8ktfY = parcelRequire("8ktfY");

var $8gAsH = parcelRequire("8gAsH");

var $9Vcji = parcelRequire("9Vcji");

var $c0yqw = parcelRequire("c0yqw");
const $a5128dc04fc1e597$var$ROOT_CAUSES = [
    {
        title: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseDeployment,
        confidence: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseConfidenceHigh,
        confidenceAppearance: 'success',
        reference: 'DEP-874',
        detail: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseDeployedTwoDaysAgo
    },
    {
        title: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseFeatureFlag,
        confidence: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseConfidenceMedium,
        confidenceAppearance: 'moved',
        reference: 'FF-678',
        detail: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseDeployedEightDaysAgo
    },
    {
        title: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseDeployment,
        confidence: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseConfidenceLow,
        confidenceAppearance: 'default',
        reference: 'DEP-456',
        detail: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseDeployedEightDaysAgo
    }
];
const $a5128dc04fc1e597$var$ROOT_CAUSE_STEPS = [
    {
        id: 'deployments',
        width: 260
    },
    {
        id: 'feature-flags',
        width: 220
    },
    {
        id: 'pairing',
        width: 380
    }
];
const $a5128dc04fc1e597$var$ROOT_CAUSE_STEP_DURATION = 1400;
const $a5128dc04fc1e597$var$ROOT_CAUSE_REVEAL_PAUSE = 1400;
const $a5128dc04fc1e597$var$ROOT_CAUSE_ANALYSIS_DURATION = $a5128dc04fc1e597$var$ROOT_CAUSE_STEPS.length * $a5128dc04fc1e597$var$ROOT_CAUSE_STEP_DURATION + $a5128dc04fc1e597$var$ROOT_CAUSE_REVEAL_PAUSE;
const $a5128dc04fc1e597$var$PANEL_ENTER_DURATION_MS = 440;
const $a5128dc04fc1e597$var$PANEL_GROW_DURATION_MS = 480;
const $a5128dc04fc1e597$var$PRIYA_CLICK_AT = 650 + (0, $cmk36.DEMO_CURSOR_TRAVEL_MS) + 550;
const $a5128dc04fc1e597$var$PRIYA_RETARGET_AT = $a5128dc04fc1e597$var$PRIYA_CLICK_AT + $a5128dc04fc1e597$var$ROOT_CAUSE_ANALYSIS_DURATION + 200;
const $a5128dc04fc1e597$export$507574f4f7e4fdb9 = {
    cursorIn: 250,
    cursorToButton: 650,
    buttonPress: 650 + (0, $cmk36.DEMO_CURSOR_TRAVEL_MS) + 300,
    click: $a5128dc04fc1e597$var$PRIYA_CLICK_AT,
    cursorOutAfterClick: $a5128dc04fc1e597$var$PRIYA_CLICK_AT + 150,
    retargetFirstCause: $a5128dc04fc1e597$var$PRIYA_RETARGET_AT,
    cursorToFirstCause: $a5128dc04fc1e597$var$PRIYA_RETARGET_AT + (0, $cmk36.DEMO_CURSOR_TRAVEL_MS) + 200,
    firstCausePress: $a5128dc04fc1e597$var$PRIYA_RETARGET_AT + (0, $cmk36.DEMO_CURSOR_TRAVEL_MS) + 500,
    selectFirstCause: $a5128dc04fc1e597$var$PRIYA_RETARGET_AT + (0, $cmk36.DEMO_CURSOR_TRAVEL_MS) + 750,
    insightIn: $a5128dc04fc1e597$var$PRIYA_RETARGET_AT + (0, $cmk36.DEMO_CURSOR_TRAVEL_MS) + 1150,
    cursorOut: $a5128dc04fc1e597$var$PRIYA_RETARGET_AT + (0, $cmk36.DEMO_CURSOR_TRAVEL_MS) + 1550
};
const $a5128dc04fc1e597$var$noop = ()=>{};
const $a5128dc04fc1e597$var$STATUS_TRANSITIONS = [
    {
        message: (0, $c0yqw.jsmPortalPlaygroundMessages).investigating,
        appearance: 'inprogress'
    },
    {
        message: (0, $c0yqw.jsmPortalPlaygroundMessages).monitoring,
        appearance: 'inprogress'
    },
    {
        message: (0, $c0yqw.jsmPortalPlaygroundMessages).resolved,
        appearance: 'success'
    }
];
const $a5128dc04fc1e597$var$AddButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bIY3n))), {
        label: "",
        size: "medium"
    });
const $a5128dc04fc1e597$var$AutomationButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iCsNc))), {
        label: "",
        size: "medium"
    });
const $a5128dc04fc1e597$var$ChevronDownIconButton = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5ucJ))), {
        label: "",
        size: "medium"
    });
const $a5128dc04fc1e597$var$ChevronUpIconButton = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k3Xeq))), {
        label: "",
        size: "medium"
    });
const $a5128dc04fc1e597$var$RetryIconButton = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Szrz))), {
        label: "",
        size: "medium"
    });
const $a5128dc04fc1e597$var$BranchButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dNI7u))), {
        label: "",
        size: "medium"
    });
const $a5128dc04fc1e597$var$AiSearchButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dq5XW))), {
        label: "",
        size: "medium"
    });
const $a5128dc04fc1e597$var$ChevronDownButtonIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5ucJ))), {
        label: "",
        size: "medium"
    });
// IconTile's orange appearance fills the square, and its size is a fixed box, so
// padding on that box never shows around the cone. Draw the grey tile ourselves.
const $a5128dc04fc1e597$var$incidentIconTileStyles = null;
const $a5128dc04fc1e597$var$incidentIconTileMediumStyles = null;
const $a5128dc04fc1e597$var$incidentIconTileSmallStyles = null;
const $a5128dc04fc1e597$var$IncidentIconTile = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf _vchhusvi _bfhki8nm _syaz1j6y _2rko1mok",
            size === 'medium' ? "_1bsbxy5q _4t3ixy5q _1yt4u2gc" : "_1bsb1ou6 _4t3i1ou6"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aTuVh))), {
            size: size === 'medium' ? 'medium' : 'small',
            label: ""
        })
    });
const $a5128dc04fc1e597$var$usePrefersReducedMotion = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $1oC0p.useState)(()=>typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    (0, $1oC0p.useEffect)(()=>{
        const query = window.matchMedia('(prefers-reduced-motion: reduce)');
        const update = ()=>setPrefersReducedMotion(query.matches);
        update();
        query.addEventListener('change', update);
        return ()=>query.removeEventListener('change', update);
    }, []);
    return prefersReducedMotion;
};
const $a5128dc04fc1e597$var$JsmPlaygroundItOperationsComponent = ({ hasUserTakenOver: hasUserTakenOver, demoState: demoState = 'autoplay', onDemoComplete: onDemoComplete })=>{
    const intl = (0, $8e22h.default)();
    const prefersReducedMotion = $a5128dc04fc1e597$var$usePrefersReducedMotion();
    const notifyDemoComplete = (0, $8DlQO.useNotifyDemoComplete)(onDemoComplete);
    const shouldStartComplete = demoState === 'complete' || prefersReducedMotion;
    const shouldStartAnalyzing = demoState === 'analyzing';
    const shouldAutoplay = demoState === 'autoplay' && !prefersReducedMotion;
    const [isDescriptionOpen, setIsDescriptionOpen] = (0, $1oC0p.useState)(!shouldStartComplete && !shouldStartAnalyzing);
    const [isRovoExpanded, setIsRovoExpanded] = (0, $1oC0p.useState)(shouldStartComplete || shouldStartAnalyzing);
    const [isRovoResolved, setIsRovoResolved] = (0, $1oC0p.useState)(shouldStartComplete);
    const [selectedCauseIndex, setSelectedCauseIndex] = (0, $1oC0p.useState)(shouldStartComplete ? 0 : null);
    const [analysisRun, setAnalysisRun] = (0, $1oC0p.useState)({
        runningIndex: shouldStartAnalyzing ? 0 : null,
        doneCount: 0
    });
    const [isAnimationComplete, setIsAnimationComplete] = (0, $1oC0p.useState)(shouldStartComplete || demoState === 'initial');
    const [cursor, setCursor] = (0, $1oC0p.useState)({
        target: 'start',
        isVisible: false,
        isPressed: false
    });
    const [isCursorTransitionEnabled, setIsCursorTransitionEnabled] = (0, $1oC0p.useState)(false);
    const [isFirstCauseHighlighted, setIsFirstCauseHighlighted] = (0, $1oC0p.useState)(false);
    const [cursorStops, setCursorStops] = (0, $1oC0p.useState)({
        start: {
            x: 0,
            y: 0
        },
        rootCauseButton: {
            x: 0,
            y: 0
        },
        firstRootCause: {
            x: 0,
            y: 0
        }
    });
    const bodyRef = (0, $1oC0p.useRef)(null);
    const rootCauseButtonRef = (0, $1oC0p.useRef)(null);
    const firstRootCauseRef = (0, $1oC0p.useRef)(null);
    const hasUserTakenOverRef = (0, $1oC0p.useRef)(hasUserTakenOver);
    hasUserTakenOverRef.current = hasUserTakenOver;
    const measureCursorStops = (0, $1oC0p.useCallback)(()=>{
        const body = bodyRef.current;
        if (!body) return;
        const bodyBounds = body.getBoundingClientRect();
        const buttonBounds = rootCauseButtonRef.current?.getBoundingClientRect();
        const firstCauseBounds = firstRootCauseRef.current?.getBoundingClientRect();
        setCursorStops((previous)=>({
                start: buttonBounds ? {
                    x: bodyBounds.width * 0.5 - 150,
                    y: bodyBounds.height * 0.65
                } : previous.start,
                rootCauseButton: buttonBounds ? {
                    x: buttonBounds.left - bodyBounds.left + 16,
                    y: buttonBounds.top - bodyBounds.top + buttonBounds.height / 2
                } : previous.rootCauseButton,
                firstRootCause: firstCauseBounds ? {
                    x: firstCauseBounds.left - bodyBounds.left + 96,
                    y: firstCauseBounds.top - bodyBounds.top + 16
                } : previous.firstRootCause
            }));
    }, []);
    (0, $1oC0p.useLayoutEffect)(()=>{
        measureCursorStops();
        window.addEventListener('resize', measureCursorStops);
        return ()=>window.removeEventListener('resize', measureCursorStops);
    }, [
        measureCursorStops,
        isRovoExpanded,
        isRovoResolved
    ]);
    (0, $1oC0p.useEffect)(()=>{
        setIsCursorTransitionEnabled(true);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (hasUserTakenOver) setIsFirstCauseHighlighted(false);
    }, [
        hasUserTakenOver
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (shouldStartComplete) notifyDemoComplete();
    }, [
        notifyDemoComplete,
        shouldStartComplete
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldAutoplay) return;
        const timer = window.setTimeout(()=>{
            if (!hasUserTakenOverRef.current) notifyDemoComplete();
        }, $a5128dc04fc1e597$export$507574f4f7e4fdb9.cursorOut + (0, $cmk36.DEMO_CURSOR_FADE_MS));
        return ()=>window.clearTimeout(timer);
    }, [
        notifyDemoComplete,
        shouldAutoplay
    ]);
    const startRovoAnalysis = (0, $1oC0p.useCallback)(()=>{
        setIsDescriptionOpen(false);
        setIsRovoExpanded(true);
        setIsRovoResolved(false);
        setSelectedCauseIndex(null);
    }, []);
    const toggleRovo = (isExpanded)=>{
        setIsRovoExpanded(isExpanded);
        if (isExpanded) setIsDescriptionOpen(false);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (!isRovoExpanded || isRovoResolved || demoState === 'analyzing') return;
        const timers = [];
        $a5128dc04fc1e597$var$ROOT_CAUSE_STEPS.forEach((_, index)=>{
            timers.push(window.setTimeout(()=>setAnalysisRun((previous)=>({
                        ...previous,
                        runningIndex: index
                    })), index * $a5128dc04fc1e597$var$ROOT_CAUSE_STEP_DURATION));
            timers.push(window.setTimeout(()=>setAnalysisRun({
                    runningIndex: index,
                    doneCount: index + 1
                }), (index + 1) * $a5128dc04fc1e597$var$ROOT_CAUSE_STEP_DURATION - 20));
        });
        timers.push(window.setTimeout(()=>{
            setAnalysisRun({
                runningIndex: null,
                doneCount: $a5128dc04fc1e597$var$ROOT_CAUSE_STEPS.length
            });
        }, $a5128dc04fc1e597$var$ROOT_CAUSE_STEPS.length * $a5128dc04fc1e597$var$ROOT_CAUSE_STEP_DURATION));
        timers.push(window.setTimeout(()=>setIsRovoResolved(true), $a5128dc04fc1e597$var$ROOT_CAUSE_ANALYSIS_DURATION));
        return ()=>timers.forEach(window.clearTimeout);
    }, [
        demoState,
        isRovoExpanded,
        isRovoResolved
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldAutoplay) return;
        const timers = [];
        const at = (ms, run)=>{
            timers.push(window.setTimeout(()=>{
                if (!hasUserTakenOverRef.current) run();
            }, ms));
        };
        const updateCursor = (next)=>setCursor((previous)=>({
                    ...previous,
                    ...next
                }));
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.cursorIn, ()=>updateCursor({
                target: 'start',
                isVisible: true
            }));
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.cursorToButton, ()=>updateCursor({
                target: 'rootCauseButton'
            }));
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.buttonPress, ()=>updateCursor({
                isPressed: true
            }));
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.click, ()=>{
            updateCursor({
                isPressed: false
            });
            startRovoAnalysis();
        });
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.cursorOutAfterClick, ()=>updateCursor({
                isVisible: false
            }));
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.retargetFirstCause, ()=>{
            measureCursorStops();
            updateCursor({
                target: 'firstRootCause'
            });
        });
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.cursorToFirstCause, ()=>{
            updateCursor({
                isVisible: true
            });
            setIsFirstCauseHighlighted(true);
        });
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.firstCausePress, ()=>updateCursor({
                isPressed: true
            }));
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.selectFirstCause, ()=>updateCursor({
                isPressed: false
            }));
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.insightIn, ()=>setSelectedCauseIndex(0));
        at($a5128dc04fc1e597$export$507574f4f7e4fdb9.cursorOut, ()=>{
            updateCursor({
                isVisible: false
            });
            setIsFirstCauseHighlighted(false);
            setIsAnimationComplete(true);
        });
        return ()=>timers.forEach(window.clearTimeout);
    }, [
        measureCursorStops,
        shouldAutoplay,
        startRovoAnalysis
    ]);
    const skipAnimation = ()=>{
        setCursor((previous)=>({
                ...previous,
                isVisible: false,
                isPressed: false
            }));
        setIsDescriptionOpen(false);
        setIsRovoExpanded(true);
        setAnalysisRun({
            runningIndex: null,
            doneCount: $a5128dc04fc1e597$var$ROOT_CAUSE_STEPS.length
        });
        setIsRovoResolved(true);
        setSelectedCauseIndex(0);
        setIsFirstCauseHighlighted(false);
        setIsAnimationComplete(true);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: bodyRef,
        "data-testid": "it-operations-preview",
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _4cvr1y6m _zulp1ejb _vchhusvi _1bsb1osq _4t3i1osq _1yt41jfw _1reo15vq _18m915vq _bfhkvuon"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$WorkItemHeader, {}),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulp1ejb"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$DescriptionCard, {
                                isExpanded: isDescriptionOpen,
                                onToggle: ()=>setIsDescriptionOpen((previous)=>!previous)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$RovoOpsCard, {
                                firstRootCauseRef: firstRootCauseRef,
                                isFirstCauseHighlighted: isFirstCauseHighlighted,
                                isExpanded: isRovoExpanded,
                                isResolved: isRovoResolved,
                                onIdentify: startRovoAnalysis,
                                onSelectCause: setSelectedCauseIndex,
                                onToggle: toggleRovo,
                                shouldReduceMotion: prefersReducedMotion,
                                rootCauseButtonRef: rootCauseButtonRef,
                                run: analysisRun,
                                selectedCauseIndex: selectedCauseIndex
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi _1bsb1feq _1o9zidpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$StatusRow, {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$DetailsPanel, {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cmk36.JsmPlaygroundDemoCursor), {
                label: "Priya",
                hasUserTakenOver: hasUserTakenOver,
                isPressed: cursor.isPressed,
                isTransitionEnabled: isCursorTransitionEnabled,
                isVisible: cursor.isVisible,
                x: cursorStops[cursor.target].x,
                y: cursorStops[cursor.target].y
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8gAsH.JsmPlaygroundSkipAnimationButton), {
                isVisible: !isAnimationComplete && !hasUserTakenOver,
                label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).skipAnimation),
                onClick: skipAnimation
            })
        ]
    });
};
const $a5128dc04fc1e597$export$d18c278cd1ad74c9 = /*#__PURE__*/ (0, $1oC0p.memo)($a5128dc04fc1e597$var$JsmPlaygroundItOperationsComponent);
const $a5128dc04fc1e597$var$WorkItemHeader = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _zulppxbi _1tkexy5q"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulp12x7 _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$IncidentIconTile, {
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                        level: 1,
                        size: "large",
                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).incidentTitle)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_1e0c116y _lcxvglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                    icon: $a5128dc04fc1e597$var$AddButtonIcon,
                    label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).addToWorkItem),
                    onClick: $a5128dc04fc1e597$var$noop,
                    tabIndex: -1
                })
            })
        ]
    });
};
const $a5128dc04fc1e597$var$WorkItemCard = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulppxbi _vchhusvi _1bsb1osq _1yt4pxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _2rkopb1k _bfhkvuon"
        ]),
        children: children
    });
const $a5128dc04fc1e597$var$CardHeader = ({ title: title, elemBefore: elemBefore, action: action })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc _1tke1ejb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulp1b66 _1ul9idpf"
                ]),
                children: [
                    elemBefore,
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        color: "color.text.subtle",
                        weight: "semibold",
                        children: title
                    })
                ]
            }),
            action
        ]
    });
const $a5128dc04fc1e597$var$AlertSmartLink = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).alertSmartLinkLabel),
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zulp1b66 _vchhusvi _4t3iv47k _1yt4v77o _s7n4nkob _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko12b0"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _1reo15vq _18m915vq _2rko12b0"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aeRPX.default), {
                    appearance: "danger",
                    children: "P1"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                size: "small",
                children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).alertSmartLinkTitle)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _1reo15vq _18m915vq _2rko12b0"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aeRPX.default), {
                    appearance: "neutral",
                    children: "x172"
                })
            })
        ]
    });
};
const $a5128dc04fc1e597$var$EntityChip = ({ children: children, icon: icon })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zulp1b66 _vchhusvi _1ul9idpf _1rjcv77o _18zr1b66 _s7n4nkob _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko12b0 _bfhk1j28"
        ]),
        children: [
            icon,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                size: "small",
                children: children
            })
        ]
    });
const $a5128dc04fc1e597$var$paymentApiIconTileStyles = null;
const $a5128dc04fc1e597$var$PaymentApiIconTile = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _bfhk18ah _syaz1q3r _2rko1qi0 _vwz4idpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jKuSd))), {
            size: "small",
            label: ""
        })
    });
const $a5128dc04fc1e597$var$paymentServiceChipIconStyles = null;
const $a5128dc04fc1e597$var$PaymentServiceChipIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf _vchhusvi _1bsbpxbi _4t3ipxbi _bfhk18ah _syaz1q3r _2rko12b0 _vwz4idpf _w8l519bv _175219bv"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jKuSd))), {
            label: "",
            size: "small"
        })
    });
const $a5128dc04fc1e597$var$DescriptionCard = ({ isExpanded: isExpanded, onToggle: onToggle })=>{
    const intl = (0, $8e22h.default)();
    const bodyRef = (0, $1oC0p.useRef)(null);
    const [bodyHeight, setBodyHeight] = (0, $1oC0p.useState)();
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (bodyRef.current) setBodyHeight(bodyRef.current.scrollHeight);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$WorkItemCard, {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$CardHeader, {
                    title: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).description),
                    action: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                        appearance: "subtle",
                        icon: isExpanded ? $a5128dc04fc1e597$var$ChevronUpIconButton : $a5128dc04fc1e597$var$ChevronDownIconButton,
                        label: intl.formatMessage(isExpanded ? (0, $c0yqw.jsmPortalPlaygroundMessages).collapseDescription : (0, $c0yqw.jsmPortalPlaygroundMessages).expandDescription),
                        onClick: onToggle,
                        spacing: "compact"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: bodyRef,
                    "aria-hidden": !isExpanded,
                    style: {
                        maxHeight: isExpanded ? bodyHeight : 0
                    },
                    className: (0, $2jatx.default)([
                        "_1reo15vq _18m915vq _1pfhidpf _tzy4idpf _v5641r0a _sedtglyw",
                        isExpanded && "_1pfhpxbi _tzy4kb7n"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulppxbi"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lPRxe.default), {
                                        children: [
                                            intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).incidentDescriptionStart),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$AlertSmartLink, {}),
                                    ' ',
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            ...(0, $c0yqw.jsmPortalPlaygroundMessages).incidentDescriptionEnd,
                                            values: {
                                                service: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                                        children: chunks
                                                    })
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulpu2gc"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        color: "color.text.subtle",
                                        weight: "semibold",
                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).impactedService)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o _zulpu2gc _vchhusvi _1tke1jfw _1yt4u2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko1qi0"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _4cvr1h6o _zulpu2gc _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$PaymentApiIconTile, {}),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                        weight: "medium",
                                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).paymentApi)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _4cvr1h6o _zulp1b66 _1o9zidpf"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                        color: "color.text.subtlest",
                                                        size: "small",
                                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).onCall)
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Vcji.PriyaAvatar), {
                                                        size: 16
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $a5128dc04fc1e597$var$RovoOpsCard = ({ isExpanded: isExpanded, isResolved: isResolved, run: run, selectedCauseIndex: selectedCauseIndex, onIdentify: onIdentify, onSelectCause: onSelectCause, onToggle: onToggle, shouldReduceMotion: shouldReduceMotion, rootCauseButtonRef: rootCauseButtonRef, firstRootCauseRef: firstRootCauseRef, isFirstCauseHighlighted: isFirstCauseHighlighted })=>{
    const intl = (0, $8e22h.default)();
    const isAnalyzing = isExpanded && !isResolved;
    const bodyRef = (0, $1oC0p.useRef)(null);
    const hasMeasuredBodyRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useLayoutEffect)(()=>{
        const body = bodyRef.current;
        if (!body) return;
        const applyMeasuredHeight = ()=>{
            body.style.setProperty('--rovo-panel-max-height', `${body.scrollHeight}px`);
            hasMeasuredBodyRef.current = true;
        };
        if (!hasMeasuredBodyRef.current || shouldReduceMotion) {
            applyMeasuredHeight();
            return;
        }
        const timer = window.setTimeout(applyMeasuredHeight, 30);
        return ()=>window.clearTimeout(timer);
    }, [
        isAnalyzing,
        isExpanded,
        isResolved,
        selectedCauseIndex,
        shouldReduceMotion
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _2rkodlk8"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r041bs0 _2rko1tm3 _11q71nla _kdam1m5u _tzy4idpf _lcxvglyw _v5641ffu _sedtglyw",
                    isAnalyzing && "_tzy436bu"
                ]),
                style: {
                    "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron')),
                    "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                    "--_kizcys": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple600'))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _1pbyidpf _1reo15vq _18m915vq _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40 _2rkodlk8 _lcxvglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _152t1ssb _1e021ssb _1bsb1fra _4t3i1fra _1pfhhee1 _ahbqhee1 _tzy4idpf _11q7k0ad _j7hqsf8s _5sag1onc _1pglp3kn _tip812c5 _bl8aglyw",
                        isAnalyzing && "_tzy4kb7n"
                    ]),
                    style: {
                        "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron')),
                        "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_kizcys": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple600'))
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1pbykb7n"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$WorkItemCard, {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: bodyRef,
                        className: (0, $2jatx.default)([
                            "_1reo15vq _18m915vq _c71l2yfd _v56417zl _sedtglyw"
                        ]),
                        children: !isExpanded && isResolved ? /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$CardHeader, {
                            title: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).rovoOpsTitle),
                            elemBefore: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _1rjcv77o _18zr1b66"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Vcji.RovoOpsMark), {
                                    label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).rovoOps)
                                })
                            }),
                            action: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                appearance: "subtle",
                                icon: $a5128dc04fc1e597$var$ChevronDownIconButton,
                                label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).expandRovoOps),
                                onClick: ()=>onToggle(true),
                                spacing: "compact"
                            })
                        }) : !isExpanded ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1y6m _zulp1b66"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c116y _4cvr1h6o _1rjcv77o _18zr1b66"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Vcji.RovoOpsMark), {
                                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).rovoOps)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx21bp4 _zulpu2gc _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _2lx21bp4 _zulp1b66"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                    color: "color.text.subtle",
                                                    weight: "semibold",
                                                    children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).rovoOpsTitle)
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                    color: "color.text.subtlest",
                                                    children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).rovoOpsDescription)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _1n261g80 _zulp12x7"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                    ref: rootCauseButtonRef,
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c116y"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                                        iconBefore: $a5128dc04fc1e597$var$BranchButtonIcon,
                                                        onClick: onIdentify,
                                                        spacing: "compact",
                                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).identifyRootCauses)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c116y _lcxvglyw"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                                        iconBefore: $a5128dc04fc1e597$var$AiSearchButtonIcon,
                                                        onClick: $a5128dc04fc1e597$var$noop,
                                                        spacing: "compact",
                                                        tabIndex: -1,
                                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).findSimilarIncidents)
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulppxbi"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$CardHeader, {
                                    title: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).rovoOpsTitle),
                                    elemBefore: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c116y _4cvr1h6o _1rjcv77o _18zr1b66"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Vcji.RovoOpsMark), {
                                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).rovoOps)
                                        })
                                    }),
                                    action: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                        appearance: "subtle",
                                        icon: $a5128dc04fc1e597$var$ChevronUpIconButton,
                                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).collapseRovoOps),
                                        onClick: ()=>onToggle(false),
                                        spacing: "compact"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx21bp4 _zulpu2gc _vchhusvi _1bsb1osq _1yt4u2gc _2rko1mok _bfhkhfxm"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                    color: "color.text.subtle",
                                                    size: "small",
                                                    weight: "semibold",
                                                    children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).likelyRootCauses)
                                                }),
                                                isResolved && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c116y _lcxvglyw"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                                                        appearance: "subtle",
                                                        icon: $a5128dc04fc1e597$var$RetryIconButton,
                                                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).regenerateRootCauses),
                                                        onClick: $a5128dc04fc1e597$var$noop,
                                                        spacing: "compact",
                                                        tabIndex: -1
                                                    })
                                                })
                                            ]
                                        }),
                                        isResolved ? /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$ResolvedRootCauses, {
                                            firstRootCauseRef: firstRootCauseRef,
                                            isFirstCauseHighlighted: isFirstCauseHighlighted,
                                            onSelectCause: onSelectCause,
                                            selectedCauseIndex: selectedCauseIndex
                                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _2lx21bp4 _1rjc12x7"
                                            ]),
                                            children: $a5128dc04fc1e597$var$ROOT_CAUSE_STEPS.map((step, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$RootCauseStep, {
                                                    id: step.id,
                                                    isLast: index === $a5128dc04fc1e597$var$ROOT_CAUSE_STEPS.length - 1,
                                                    status: index < run.doneCount ? 'done' : index === run.runningIndex ? 'running' : 'pending',
                                                    width: step.width
                                                }, step.id))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    "aria-hidden": "true",
                                    className: (0, $2jatx.default)([
                                        "_1e0c116y _lcxvglyw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                                        iconBefore: $a5128dc04fc1e597$var$AiSearchButtonIcon,
                                        onClick: $a5128dc04fc1e597$var$noop,
                                        spacing: "compact",
                                        tabIndex: -1,
                                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).findSimilarIncidents)
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
const $a5128dc04fc1e597$var$BitbucketChipIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.BitbucketIcon), {
        appearance: "brand",
        label: "",
        shouldUseNewLogoDesign: true,
        size: "xxsmall"
    });
const $a5128dc04fc1e597$var$ROOT_CAUSE_STEP_COPY = {
    deployments: {
        message: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseStepDeployments,
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$BitbucketChipIcon, {})
    },
    'feature-flags': {
        message: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseStepFeatureFlags,
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$BitbucketChipIcon, {})
    },
    pairing: {
        message: (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseStepPairing,
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HbHF))), {
            color: "var(--ds-icon-subtle, #505258)",
            label: ""
        })
    }
};
const $a5128dc04fc1e597$var$RootCauseStepCopy = ({ id: id })=>{
    const { message: message, icon: icon } = $a5128dc04fc1e597$var$ROOT_CAUSE_STEP_COPY[id];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
        size: "small",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            ...message,
            values: {
                chip: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$EntityChip, {
                        icon: icon,
                        children: chunks
                    })
            }
        })
    });
};
const $a5128dc04fc1e597$var$RootCauseStep = ({ id: id, status: status, width: width, isLast: isLast })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1fhb _zulpu2gc _1tkexy5q"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _1q51u2gc"
                ]),
                children: [
                    status === 'done' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))), {
                        color: "var(--ds-icon-success, #6A9A23)",
                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseStepDone)
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        "aria-label": intl.formatMessage(status === 'running' ? (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseStepInProgress : (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseStepNotStarted),
                        role: "img",
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _vchhusvi _1bsbpxbi _4t3ipxbi _189e1dm9 _1dqogq9o _1h6d1cv2 _2rko1rr0",
                            status === 'running' && "",
                            status === 'running' && "_j7hqsf8s _5sag1rdr _1pglp3kn _tip812c5 _bl8aglyw"
                        ])
                    }),
                    !isLast && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1bsbe4h9 _16jlkb7n _1o9zkb7n _i0dl1wug _bfhk1l7x"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1n261g80 _zulp1b66 _1ul9idpf _1tkexy5q"
                ]),
                children: status === 'pending' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                    borderRadius: "var(--ds-radius-small, 4px)",
                    height: 12,
                    width: width
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$RootCauseStepCopy, {
                    id: id
                })
            })
        ]
    });
};
const $a5128dc04fc1e597$var$ResolvedRootCauses = ({ selectedCauseIndex: selectedCauseIndex, onSelectCause: onSelectCause, firstRootCauseRef: firstRootCauseRef, isFirstCauseHighlighted: isFirstCauseHighlighted })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc _j7hq17l3 _5sag1hnq _1pgl1jxq _1o511hrf _bl8aglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1fhb _1bsb1osq _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko1mok _bfhkhp5a"
                ]),
                children: $a5128dc04fc1e597$var$ROOT_CAUSES.map((cause, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                        ref: index === 0 ? firstRootCauseRef : undefined,
                        "aria-label": intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseCardLabel, {
                            title: intl.formatMessage(cause.title),
                            confidence: intl.formatMessage(cause.confidence),
                            reference: cause.reference,
                            detail: intl.formatMessage(cause.detail)
                        }),
                        "aria-pressed": selectedCauseIndex === index,
                        onClick: ()=>onSelectCause(selectedCauseIndex === index ? null : index),
                        type: "button",
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulpu2gc _vchhusvi _1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug _1yt4pxbi _19itidpf _bfhk1j28 _syazi7uo _11c8fhey _y3gnv2br _irr31dpa _mizu1v1w _ra3xnqa1 _128mdkaa _1ah312gs",
                            index < $a5128dc04fc1e597$var$ROOT_CAUSES.length - 1 && "_1ej8e4h9 _1vn8nqa1 _pxto1l7x",
                            selectedCauseIndex === index && "_bfhk15s3",
                            index === 0 && isFirstCauseHighlighted && "_bfhk1dpa"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc _1bsb1osq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        size: "small",
                                        weight: "semibold",
                                        children: intl.formatMessage(cause.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izDBw.default), {
                                        appearance: cause.confidenceAppearance,
                                        children: intl.formatMessage(cause.confidence)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulp1b66 _1rjcv77o _18zr1b66 _189ee4h9 _1dqonqa1 _1h6d1l7x _2rko12b0 _bfhk1j28"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g02sa))), {
                                        color: "var(--ds-icon-subtle, #505258)",
                                        label: "",
                                        size: "medium"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        size: "small",
                                        children: cause.reference
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                size: "small",
                                children: intl.formatMessage(cause.detail)
                            })
                        ]
                    }, cause.reference))
            }),
            selectedCauseIndex !== null && /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$RootCauseInsight, {
                index: selectedCauseIndex
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulp12x7"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _2rko12b0 _bfhk1j28"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.BitbucketIcon), {
                                    appearance: "brand",
                                    label: "",
                                    shouldUseNewLogoDesign: true,
                                    size: "xsmall"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _2rko12b0 _bfhk1j28",
                                    "_ahbqyjp0"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraIcon), {
                                    appearance: "brand",
                                    label: "",
                                    shouldUseNewLogoDesign: true,
                                    size: "xsmall"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _2rko12b0 _bfhk1j28",
                                    "_ahbqyjp0"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraServiceManagementIcon), {
                                    appearance: "brand",
                                    label: "",
                                    shouldUseNewLogoDesign: true,
                                    size: "xsmall"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        color: "color.text.subtle",
                        weight: "medium",
                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).sources)
                    })
                ]
            })
        ]
    });
};
const $a5128dc04fc1e597$var$ROOT_CAUSE_INSIGHTS = [
    (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseInsightLikely,
    (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseInsightPossible,
    (0, $c0yqw.jsmPortalPlaygroundMessages).rootCauseInsightUnlikely
];
const $a5128dc04fc1e597$var$RootCauseInsight = ({ index: index })=>{
    const appearance = $a5128dc04fc1e597$var$ROOT_CAUSES[index]?.confidenceAppearance;
    const insight = $a5128dc04fc1e597$var$ROOT_CAUSE_INSIGHTS[index];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_vchhusvi _1bsb1osq _1yt4pxbi _2rko1mok _bfhk1gly _j7hq17l3 _5sag1hnq _1pgl1jxq _1o511hrf _bl8aglyw",
            appearance === 'moved' && "_bfhk1917",
            appearance === 'default' && "_bfhki8nm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            className: (0, $2jatx.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
            ]),
            children: insight && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    ...insight,
                    values: {
                        strong: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                weight: "semibold",
                                children: chunks
                            }),
                        service: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$EntityChip, {
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$PaymentServiceChipIcon, {}),
                                children: chunks
                            }),
                        deployment: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$EntityChip, {
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$BitbucketChipIcon, {}),
                                children: chunks
                            }),
                        featureFlag: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$EntityChip, {
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$BitbucketChipIcon, {}),
                                children: chunks
                            })
                    }
                })
            })
        })
    });
};
const $a5128dc04fc1e597$var$StatusRow = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc _1tkexy5q"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c116y _gaq97079 _4lt01gz9 _y515grf3 _4mblagmp"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kMnBu.default), {
                    placement: "bottom-start",
                    shouldRenderToParent: true,
                    testId: "jsm-it-operations-status",
                    trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1q52J.default), {
                            ...triggerProps,
                            ref: triggerRef,
                            iconAfter: $a5128dc04fc1e597$var$ChevronDownButtonIcon,
                            children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).open)
                        }),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsbp3fh"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKsx2.default), {
                            children: $a5128dc04fc1e597$var$STATUS_TRANSITIONS.map((transition)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
                                    elemAfter: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c116y _4cvr1h6o _zulputpp"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53VCz))), {
                                                color: "var(--ds-icon-subtle, #505258)",
                                                label: "",
                                                size: "small"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izDBw.default), {
                                                appearance: transition.appearance,
                                                children: intl.formatMessage(transition.message)
                                            })
                                        ]
                                    }),
                                    onClick: $a5128dc04fc1e597$var$noop,
                                    children: intl.formatMessage(transition.message)
                                }, transition.message.id))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_1e0c116y _lcxvglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                    icon: $a5128dc04fc1e597$var$AutomationButtonIcon,
                    label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).runAutomation),
                    onClick: $a5128dc04fc1e597$var$noop,
                    tabIndex: -1
                })
            })
        ]
    });
};
const $a5128dc04fc1e597$var$DetailsPanel = ()=>{
    const intl = (0, $8e22h.default)();
    const [isMajorIncident, setIsMajorIncident] = (0, $1oC0p.useState)(true);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _2rkopb1k _bfhkvuon"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulppxbi _vchhusvi _1tkeoahv _1rjcutpp _18zrpxbi _1r62e4h9 _12ornqa1 _1ezz1l7x"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8ktfY.JsmPlaygroundHeading), {
                        level: 2,
                        size: "xsmall",
                        children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).details)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_1e0c116y _lcxvglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2r6UE.default), {
                            appearance: "subtle",
                            icon: $a5128dc04fc1e597$var$ChevronUpIconButton,
                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).collapseDetails),
                            onClick: $a5128dc04fc1e597$var$noop,
                            spacing: "compact",
                            tabIndex: -1
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1b66 _85i5u2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)($a5128dc04fc1e597$var$DetailField, {
                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).assignee),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Vcji.PriyaAvatar), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                children: "Priya Hansra"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)($a5128dc04fc1e597$var$DetailField, {
                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).responders),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Vcji.PaymentTeamAvatar), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).paymentTeam)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)($a5128dc04fc1e597$var$DetailField, {
                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).requestType),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$IncidentIconTile, {
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                children: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).incident)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($a5128dc04fc1e597$var$DetailField, {
                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).majorIncident),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jdqfU.default), {
                            id: "jsm-playground-major-incident",
                            isChecked: isMajorIncident,
                            label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).majorIncident),
                            onChange: ()=>setIsMajorIncident((previous)=>!previous)
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)($a5128dc04fc1e597$var$DetailField, {
                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).collaborationChannels),
                        isMultiline: true,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulp12x7 _1tke1ejb"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Vcji.SlackMark), {
                                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).slack)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                                        borderRadius: "var(--ds-radius-small, 4px)",
                                        height: 12,
                                        width: 120
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulp12x7 _1tke1ejb"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Vcji.ZoomMark), {
                                        label: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).zoom)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                                        borderRadius: "var(--ds-radius-small, 4px)",
                                        height: 12,
                                        width: 80
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $a5128dc04fc1e597$var$DetailField = ({ label: label, children: children, isMultiline: isMultiline = false })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _vchhusvi _1tke1jfw _1rjc1b66 _bozgpxbi _y4tiu2gc",
            isMultiline && "_4cvr1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1l8a _1o9zidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    weight: "medium",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulp12x7 _vchhusvi _1ul9idpf _1tkexy5q _16jlkb7n _1o9zkb7n _i0dl1wug _1rjc12x7 _18zru2gc",
                    isMultiline && "_2lx21bp4 _4cvr1fhb"
                ]),
                children: children
            })
        ]
    });
const $a5128dc04fc1e597$var$resolvedContentIn = null;
const $a5128dc04fc1e597$var$ringSpin = null;
const $a5128dc04fc1e597$var$pageStyles = null;
const $a5128dc04fc1e597$var$leftColumnStyles = null;
const $a5128dc04fc1e597$var$leftCardsStyles = null;
const $a5128dc04fc1e597$var$rightColumnStyles = null;
const $a5128dc04fc1e597$var$workItemHeaderStyles = null;
const $a5128dc04fc1e597$var$workItemTitleStyles = null;
const $a5128dc04fc1e597$var$workItemCardStyles = null;
const $a5128dc04fc1e597$var$cardHeaderStyles = null;
const $a5128dc04fc1e597$var$cardHeaderTitleStyles = null;
const $a5128dc04fc1e597$var$descriptionCardContentStyles = null;
const $a5128dc04fc1e597$var$descriptionDisclosureStyles = null;
const $a5128dc04fc1e597$var$descriptionDisclosureExpandedStyles = null;
const $a5128dc04fc1e597$var$descriptionBodyStyles = null;
const $a5128dc04fc1e597$var$paragraphStyles = null;
const $a5128dc04fc1e597$var$alertSmartLinkStyles = null;
const $a5128dc04fc1e597$var$roundedBadgeStyles = null;
const $a5128dc04fc1e597$var$impactedServiceSectionStyles = null;
const $a5128dc04fc1e597$var$impactedServiceRowStyles = null;
const $a5128dc04fc1e597$var$entityValueStyles = null;
const $a5128dc04fc1e597$var$onCallStyles = null;
const $a5128dc04fc1e597$var$inlineControlStyles = null;
const $a5128dc04fc1e597$var$inertControlStyles = null;
const $a5128dc04fc1e597$var$rovoCardFrameStyles = null;
const $a5128dc04fc1e597$var$rovoCardContentStyles = null;
const $a5128dc04fc1e597$var$rovoDisclosureStyles = null;
const $a5128dc04fc1e597$var$rovoGlowStyles = null;
const $a5128dc04fc1e597$var$rovoGlowVisibleStyles = null;
const $a5128dc04fc1e597$var$rovoRingStyles = null;
const $a5128dc04fc1e597$var$rovoRingBitmapStyles = null;
const $a5128dc04fc1e597$var$rovoRingVisibleStyles = null;
const $a5128dc04fc1e597$var$rovoInitialStyles = null;
const $a5128dc04fc1e597$var$rovoMarkWrapperStyles = null;
const $a5128dc04fc1e597$var$rovoInitialContentStyles = null;
const $a5128dc04fc1e597$var$rovoCopyStyles = null;
const $a5128dc04fc1e597$var$rovoActionsStyles = null;
const $a5128dc04fc1e597$var$rovoExpandedStyles = null;
const $a5128dc04fc1e597$var$rootCausePanelStyles = null;
const $a5128dc04fc1e597$var$rootCausePanelHeaderStyles = null;
const $a5128dc04fc1e597$var$rootCauseStepsStyles = null;
const $a5128dc04fc1e597$var$rootCauseStepStyles = null;
const $a5128dc04fc1e597$var$stepRailColumnStyles = null;
const $a5128dc04fc1e597$var$stepRailStyles = null;
const $a5128dc04fc1e597$var$pendingStepStyles = null;
const $a5128dc04fc1e597$var$runningStepStyles = null;
const $a5128dc04fc1e597$var$stepCopyStyles = null;
const $a5128dc04fc1e597$var$resolvedContentStyles = null;
const $a5128dc04fc1e597$var$rootCauseCardsStyles = null;
const $a5128dc04fc1e597$var$rootCauseCardStyles = null;
const $a5128dc04fc1e597$var$rootCauseCardDividerStyles = null;
const $a5128dc04fc1e597$var$selectedRootCauseCardStyles = null;
const $a5128dc04fc1e597$var$highlightedRootCauseCardStyles = null;
const $a5128dc04fc1e597$var$rootCauseTitleStyles = null;
const $a5128dc04fc1e597$var$referenceTagStyles = null;
const $a5128dc04fc1e597$var$rootCauseInsightStyles = null;
const $a5128dc04fc1e597$var$warningInsightStyles = null;
const $a5128dc04fc1e597$var$neutralInsightStyles = null;
const $a5128dc04fc1e597$var$entityChipStyles = null;
const $a5128dc04fc1e597$var$sourcesStyles = null;
const $a5128dc04fc1e597$var$sourceLogosStyles = null;
const $a5128dc04fc1e597$var$sourceLogoStyles = null;
const $a5128dc04fc1e597$var$sourceLogoOverlapStyles = null;
const $a5128dc04fc1e597$var$statusRowStyles = null;
const $a5128dc04fc1e597$var$statusDropdownStyles = null;
const $a5128dc04fc1e597$var$statusMenuContentStyles = null;
const $a5128dc04fc1e597$var$statusTransitionStyles = null;
const $a5128dc04fc1e597$var$detailsPanelStyles = null;
const $a5128dc04fc1e597$var$detailsHeaderStyles = null;
const $a5128dc04fc1e597$var$detailsBodyStyles = null;
const $a5128dc04fc1e597$var$detailFieldStyles = null;
const $a5128dc04fc1e597$var$multilineDetailFieldStyles = null;
const $a5128dc04fc1e597$var$detailLabelStyles = null;
const $a5128dc04fc1e597$var$detailValueStyles = null;
const $a5128dc04fc1e597$var$multilineDetailValueStyles = null;
const $a5128dc04fc1e597$var$collaborationRowStyles = null;

});
parcelRegister("aeRPX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7744f9153fad9b97$export$2e2bcd8739ae039; });
/* badge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");


var $6LKSU = parcelRequire("6LKSU");

var $lGmkD = parcelRequire("lGmkD");

var $8PbEc = parcelRequire("8PbEc");
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in `children`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $7744f9153fad9b97$var$Badge = /*#__PURE__*/ (0, $1oC0p.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    // Map old appearance names to new ones
    var newAppearance = (0, $6LKSU.appearanceMapping)[appearance];
    // Pre-format the value using the backward-compatible formatter (supports negative numbers)
    // then pass max={false} to BadgeNew so it doesn't apply its own (clamping) formatting.
    var formattedValue = typeof children === 'number' && typeof max === 'number' ? (0, $8PbEc.formatValueWithNegativeSupport)(children, max) : children;
    return /*#__PURE__*/ $1oC0p.createElement((0, $lGmkD.default), {
        appearance: newAppearance,
        max: false,
        style: style,
        testId: testId
    }, formattedValue);
});
var $7744f9153fad9b97$export$2e2bcd8739ae039 = $7744f9153fad9b97$var$Badge;

});
parcelRegister("6LKSU", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", function () { return $4edb80296dd08599$export$d21bba0569254935; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var $4edb80296dd08599$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

});

parcelRegister("lGmkD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc8ed7e008f1d291$export$2e2bcd8739ae039; });
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $a55Pn = parcelRequire("a55Pn");

var $fzV1r = parcelRequire("fzV1r");

var $llbs8 = parcelRequire("llbs8");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $fc8ed7e008f1d291$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $fc8ed7e008f1d291$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $llbs8.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ var $fc8ed7e008f1d291$var$BadgeNew = /*#__PURE__*/ (0, $1oC0p.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    var _useThemeObserver = (0, $fzV1r.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    var resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $2jatx.default)([
            $fc8ed7e008f1d291$var$stylesNew.root,
            $fc8ed7e008f1d291$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $a55Pn.Text), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $fc8ed7e008f1d291$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $fc8ed7e008f1d291$export$2e2bcd8739ae039 = $fc8ed7e008f1d291$var$BadgeNew;

});
parcelRegister("fzV1r", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", function () { return $b5765b581a2adbb6$export$3dd7971102e44fa8; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $gVq3M = parcelRequire("gVq3M");

var $jiYtW = parcelRequire("jiYtW");
var $b5765b581a2adbb6$export$3dd7971102e44fa8 = function useThemeObserver() {
    var _useState = (0, $1oC0p.useState)((0, $gVq3M.getGlobalTheme)()), _useState2 = (0, $2qaZZ.default)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        var observer = new (0, $jiYtW.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $b5765b581a2adbb6$export$2e2bcd8739ae039 = $b5765b581a2adbb6$export$3dd7971102e44fa8;

});
parcelRegister("gVq3M", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $c5262f301005a307$export$813ecdf77207a053; });

var $f53LC = parcelRequire("f53LC");

var $2fmxT = parcelRequire("2fmxT");

var $kA5VX = parcelRequire("kA5VX");

var $2ao3I = parcelRequire("2ao3I");
function $c5262f301005a307$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5262f301005a307$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5262f301005a307$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5262f301005a307$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c5262f301005a307$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $2fmxT.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $2fmxT.THEME_DATA_ATTRIBUTE)) || '';
    return $c5262f301005a307$var$_objectSpread($c5262f301005a307$var$_objectSpread({}, (0, $2ao3I.themeStringToObject)(theme)), (0, $kA5VX.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("2fmxT", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $1a2e789996ac0b3f$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $1a2e789996ac0b3f$export$a00eac3f8684bcd0; });
var $1a2e789996ac0b3f$export$4ef52930e33717cd = 'data-theme';
var $1a2e789996ac0b3f$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $1a2e789996ac0b3f$export$a00eac3f8684bcd0 = 'data-color-mode';
var $1a2e789996ac0b3f$export$2112803007239c61 = 'data-contrast-mode';
var $1a2e789996ac0b3f$export$352e418ed5b6193a = 'data-custom-theme';
var $1a2e789996ac0b3f$export$6f0c6fb8c80fcc92 = 'ds';
var $1a2e789996ac0b3f$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $1a2e789996ac0b3f$export$dddac1532e822863 = "--".concat($1a2e789996ac0b3f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $1a2e789996ac0b3f$export$9d7b58831ae93caa = "--".concat($1a2e789996ac0b3f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("kA5VX", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", function () { return $efbbc5bedd592aa3$export$fcfb1976c88f9f75; });

var $5Np7W = parcelRequire("5Np7W");
var $efbbc5bedd592aa3$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $5Np7W.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("5Np7W", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $4385051439d1cc36$export$83993de8eb66733; });
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $4385051439d1cc36$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("2ao3I", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $193f2d8f9b666c27$export$f19b488f7c0547ee; });

var $2qaZZ = parcelRequire("2qaZZ");

var $fmDDy = parcelRequire("fmDDy");

var $h0cbP = parcelRequire("h0cbP");

var $6KmtZ = parcelRequire("6KmtZ");
var $193f2d8f9b666c27$var$customThemeOptions = 'UNSAFE_themeOptions';
var $193f2d8f9b666c27$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $fmDDy.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $6KmtZ.isThemeKind)(kind) && (0, $h0cbP.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $193f2d8f9b666c27$var$customThemeOptions) try {
            themeObject[$193f2d8f9b666c27$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});
parcelRegister("fmDDy", function(module, exports) {
$parcel$export(module.exports, "isColorMode", function () { return $b2f7a82ffe542060$export$4a14e169b1de4ee7; });
var $b2f7a82ffe542060$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("h0cbP", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", function () { return $c60be4659988d12f$export$ea35b8958c39dd07; });

var $97RGZ = parcelRequire("97RGZ");
var $c60be4659988d12f$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $97RGZ.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("97RGZ", function(module, exports) {
$parcel$export(module.exports, "themeIds", function () { return $6a4e6aaeca747f54$export$7d43e72a58e3283f; });
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $6a4e6aaeca747f54$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("6KmtZ", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", function () { return $4e987a91afc11ec8$export$958fa026be3a263e; });
var $4e987a91afc11ec8$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $4e987a91afc11ec8$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $4e987a91afc11ec8$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});



parcelRegister("jiYtW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e0de9d30fbc7353e$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $2fmxT = parcelRequire("2fmxT");

var $gVq3M = parcelRequire("gVq3M");
var $e0de9d30fbc7353e$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $cTewU.default)(this, ThemeMutationObserver);
        (0, $f53LC.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $avOEA.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $gVq3M.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $2fmxT.THEME_DATA_ATTRIBUTE),
                            (0, $2fmxT.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $f53LC.default)($e0de9d30fbc7353e$export$b741a7c3bcb1c635, "observer", null);
(0, $f53LC.default)($e0de9d30fbc7353e$export$b741a7c3bcb1c635, "callbacks", new Set());
var $e0de9d30fbc7353e$export$2e2bcd8739ae039 = $e0de9d30fbc7353e$export$b741a7c3bcb1c635;

});


parcelRegister("llbs8", function(module, exports) {
$parcel$export(module.exports, "formatValue", function () { return $f894716b777cda09$export$7c4d25c0c3217d8c; });
function $f894716b777cda09$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $f894716b777cda09$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $f894716b777cda09$var$getSafeValue(value);
    var safeMax = $f894716b777cda09$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("8PbEc", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", function () { return $66cc1f10d8ed00c4$export$4b844743568d5983; });
function $66cc1f10d8ed00c4$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $66cc1f10d8ed00c4$export$4b844743568d5983(value, max) {
    var safeValue = $66cc1f10d8ed00c4$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $66cc1f10d8ed00c4$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("5Szrz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b87cc7d74b53f2f9074ecfc04ea4b65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $447d7d4ab5716b03$var$_react = $447d7d4ab5716b03$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $447d7d4ab5716b03$var$_baseNew = $447d7d4ab5716b03$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $447d7d4ab5716b03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $447d7d4ab5716b03$var$RetryIcon = (props)=>/*#__PURE__*/ $447d7d4ab5716b03$var$_react.default.createElement($447d7d4ab5716b03$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$447d7d4ab5716b03$var$RetryIcon.displayName = 'RetryIcon';
var $447d7d4ab5716b03$var$_default = module.exports.default = $447d7d4ab5716b03$var$RetryIcon;

});

parcelRegister("dq5XW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df727533991c4aac2a7e523738f16a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c5254c48f25ae0e$var$_react = $9c5254c48f25ae0e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9c5254c48f25ae0e$var$_baseNew = $9c5254c48f25ae0e$var$_interopRequireDefault((parcelRequire("jcI35")));
function $9c5254c48f25ae0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c5254c48f25ae0e$var$AiSearchIcon = (props)=>/*#__PURE__*/ $9c5254c48f25ae0e$var$_react.default.createElement($9c5254c48f25ae0e$var$_baseNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$9c5254c48f25ae0e$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $9c5254c48f25ae0e$var$_default = module.exports.default = $9c5254c48f25ae0e$var$AiSearchIcon;

});

parcelRegister("2HbHF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68d3004518164da8b43b6666a98b51e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f68acf877e24d3e$var$_react = $1f68acf877e24d3e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1f68acf877e24d3e$var$_baseNew = $1f68acf877e24d3e$var$_interopRequireDefault((parcelRequire("jcI35")));
function $1f68acf877e24d3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Compare".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for compare functionality in Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f68acf877e24d3e$var$CompareIcon = (props)=>/*#__PURE__*/ $1f68acf877e24d3e$var$_react.default.createElement($1f68acf877e24d3e$var$_baseNew.default, Object.assign({
        name: "CompareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.5 12.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M5 4.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m9 8.5a2.25 2.25 0 1 1-3-2.12V5.25C11 4.56 10.44 4 9.75 4H8V2.5h1.75a2.75 2.75 0 0 1 2.75 2.75v5.38a2.25 2.25 0 0 1 1.5 2.12m-7.5-8.5c0 .98-.627 1.809-1.5 2.118v5.382c0 .69.56 1.25 1.25 1.25H8v1.5H6.25a2.75 2.75 0 0 1-2.735-2.469L3.5 11.75V6.368A2.248 2.248 0 0 1 4.25 2 2.25 2.25 0 0 1 6.5 4.25"/>`
    }, props));
$1f68acf877e24d3e$var$CompareIcon.displayName = 'CompareIcon';
var $1f68acf877e24d3e$var$_default = module.exports.default = $1f68acf877e24d3e$var$CompareIcon;

});

parcelRegister("jKuSd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9df73e04155b1d816856b2d88c851c72>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e60a4302c7517db4$var$_react = $e60a4302c7517db4$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e60a4302c7517db4$var$_baseNew = $e60a4302c7517db4$var$_interopRequireDefault((parcelRequire("jcI35")));
function $e60a4302c7517db4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Service".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for roadmaps service.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e60a4302c7517db4$var$ServiceIcon = (props)=>/*#__PURE__*/ $e60a4302c7517db4$var$_react.default.createElement($e60a4302c7517db4$var$_baseNew.default, Object.assign({
        name: "ServiceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 12.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m0-9.5a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 0 1-5.394.75H8.74c-.371 0-.719.183-.928.49L5.408 8l2.403 3.51c.21.307.557.49.928.49h1.867a2.749 2.749 0 0 1 5.394.75 2.75 2.75 0 0 1-5.394.75H8.74a2.63 2.63 0 0 1-2.167-1.143L4.104 8.75H0v-1.5h4.104l2.468-3.607A2.63 2.63 0 0 1 8.74 2.5h1.867A2.749 2.749 0 0 1 16 3.25"/>`
    }, props));
$e60a4302c7517db4$var$ServiceIcon.displayName = 'ServiceIcon';
var $e60a4302c7517db4$var$_default = module.exports.default = $e60a4302c7517db4$var$ServiceIcon;

});

parcelRegister("jdqfU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dfd3990667cd7852$export$2e2bcd8739ae039; });
/* toggle.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $5Yz4U = parcelRequire("5Yz4U");

var $1oC0p = parcelRequire("1oC0p");

var $bRtGP = parcelRequire("bRtGP");

var $faH6P = parcelRequire("faH6P");

var $eadvm = parcelRequire("eadvm");

var $hd2BH = parcelRequire("hd2BH");

var $fThgT = parcelRequire("fThgT");

var $lfGWU = parcelRequire("lfGWU");

var $7CRPV = parcelRequire("7CRPV");

var $itnU9 = parcelRequire("itnU9");

var $1IXwf = parcelRequire("1IXwf");
function $dfd3990667cd7852$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dfd3990667cd7852$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dfd3990667cd7852$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dfd3990667cd7852$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dfd3990667cd7852$var$LOADING_LABEL = ', Loading';
var $dfd3990667cd7852$var$basicStyles = null;
var $dfd3990667cd7852$var$sizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
var $dfd3990667cd7852$var$atomicBaseStyles = null;
var $dfd3990667cd7852$var$atomicSizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz"
};
/**
 * Slider knob translate transforms per size, applied when checked.
 */ var $dfd3990667cd7852$var$atomicCheckedSliderStyles = {
    regular: "_7dwz1fbe",
    large: "_7dwzw12q"
};
/**
 * Applied when the toggle is checked
 */ var $dfd3990667cd7852$var$atomicCheckedStyles = null;
/**
 * Applied when the toggle is checked and not disabled.
 */ var $dfd3990667cd7852$var$atomicCheckedHoveredStyles = null;
/**
 * Applied when the toggle is unchecked and not disabled.
 */ var $dfd3990667cd7852$var$atomicUncheckedHoveredStyles = null;
/**
 * Applied when the toggle is disabled.
 */ var $dfd3990667cd7852$var$atomicDisabledStyles = null;
/**
 * Removes the unnecessary zIndex from the disabled toggle handle (legacy path)
 * that caused it to render above overlapping elements like select menus.
 */ var $dfd3990667cd7852$var$basicDisabledZIndexFixStyles = null;
/**
 * Removes the unnecessary zIndex from the disabled toggle handle (atomic path)
 * that caused it to render above overlapping elements like select menus.
 */ var $dfd3990667cd7852$var$atomicDisabledZIndexFixStyles = null;
var $dfd3990667cd7852$var$atomicInputStyles = null;
var $dfd3990667cd7852$var$noop = (0, $faH6P.default);
var $dfd3990667cd7852$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "@atlaskit/toggle",
    packageVersion: "15.6.1"
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ var $dfd3990667cd7852$var$Toggle = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$onBlur = props.onBlur, providedOnBlur = _props$onBlur === void 0 ? $dfd3990667cd7852$var$noop : _props$onBlur, _props$onChange = props.onChange, providedChange = _props$onChange === void 0 ? $dfd3990667cd7852$var$noop : _props$onChange, _props$onFocus = props.onFocus, providedFocus = _props$onFocus === void 0 ? $dfd3990667cd7852$var$noop : _props$onFocus, _props$size = props.size, size = _props$size === void 0 ? 'regular' : _props$size, _props$name = props.name, name = _props$name === void 0 ? '' : _props$name, _props$value = props.value, value = _props$value === void 0 ? '' : _props$value, isChecked = props.isChecked, isLoading = props.isLoading, analyticsContext = props.analyticsContext, id = props.id, testId = props.testId, label = props.label, descriptionId = props.descriptionId;
    var isControlled = typeof isChecked === 'undefined';
    var _useState = (0, $1oC0p.useState)(defaultChecked), _useState2 = (0, $2qaZZ.default)(_useState, 2), checked = _useState2[0], setChecked = _useState2[1];
    var loadingLabelId = (0, $eadvm.useId)();
    var handleBlur = (0, $bRtGP.usePlatformLeafEventHandler)($dfd3990667cd7852$var$_objectSpread({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext
    }, $dfd3990667cd7852$var$analyticsAttributes));
    var handleFocus = (0, $bRtGP.usePlatformLeafEventHandler)($dfd3990667cd7852$var$_objectSpread({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext
    }, $dfd3990667cd7852$var$analyticsAttributes));
    var handleChange = (0, $bRtGP.usePlatformLeafEventHandler)($dfd3990667cd7852$var$_objectSpread({
        fn: function fn(event, analyticsEvent) {
            if (isControlled) setChecked(function(checked) {
                return !checked;
            });
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext
    }, $dfd3990667cd7852$var$analyticsAttributes));
    var shouldChecked = isControlled ? checked : isChecked;
    var controlProps = $dfd3990667cd7852$var$_objectSpread($dfd3990667cd7852$var$_objectSpread({}, !(0, $lfGWU.fg)('platform-toggle-atomic-styles') && {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size
    }), {}, {
        'data-testid': testId ? testId : undefined
    });
    var labelId = (0, $eadvm.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("label", (0, $c9bqK.default)({}, controlProps, {
        className: (0, $5Yz4U.default)([
            !(0, $lfGWU.fg)('platform-toggle-atomic-styles') && "_v564kete _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1ys41v1w _krlfnqa1 _ju3ddkaa _1bkiby5v _1fltby5v _3xv2by5v _9471kcmj _ucab5w2r _mqf82sac _3dj22sac _1dl92sac _1div5w2r _1il8kb7n _y54d5w2r _irr31ibz _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1pluy7x8 _1uo81ibz _178cby5v _16rslghj _i5ec1w7i",
            !(0, $lfGWU.fg)('platform-toggle-atomic-styles') && $dfd3990667cd7852$var$sizeStyles[size],
            (0, $lfGWU.fg)('platform-toggle-atomic-styles') && "_v564kete _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _80omtlke _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _1ys41v1w _ju3ddkaa _16rslghj _i5ec1w7i",
            (0, $lfGWU.fg)('platform-toggle-atomic-styles') && $dfd3990667cd7852$var$atomicSizeStyles[size],
            shouldChecked && (0, $lfGWU.fg)('platform-toggle-atomic-styles') && "_bfhkkcmj",
            shouldChecked && (0, $lfGWU.fg)('platform-toggle-atomic-styles') && $dfd3990667cd7852$var$atomicCheckedSliderStyles[size],
            !isDisabled && shouldChecked && (0, $lfGWU.fg)('platform-toggle-atomic-styles') && "_irr3y7x8",
            !isDisabled && !shouldChecked && (0, $lfGWU.fg)('platform-toggle-atomic-styles') && "_irr31ibz",
            isDisabled && (0, $lfGWU.fg)('platform-toggle-atomic-styles') && "_bfhkby5v _syaz2sac _80om13gf _1g0vkb7n",
            (0, $lfGWU.fg)('platform-toggle-fix-disabled-zindex') && "_1il8n7od",
            isDisabled && (0, $lfGWU.fg)('platform-toggle-fix-disabled-zindex') && "_1g0vn7od"
        ])
    }), label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        id: labelId,
        hidden: true
    }, isLoading ? "".concat(label).concat($dfd3990667cd7852$var$LOADING_LABEL) : label) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && "".concat(testId, "--input"),
        "aria-labelledby": isLoading && label ? "".concat(labelId, " ").concat(loadingLabelId) : label ? labelId : undefined,
        "aria-describedby": descriptionId,
        className: (0, $5Yz4U.default)([
            (0, $lfGWU.fg)('platform-toggle-atomic-styles') && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _tzy4idpf _nt751snc _49pcagmp _1hvw10yn"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1IXwf.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, isLoading && shouldChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7CRPV.default), {
        size: "xsmall",
        appearance: "invert"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hd2BH))), {
        label: "",
        color: "currentColor",
        testId: testId && "".concat(testId, "--toggle-check-icon"),
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1IXwf.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, isLoading && !shouldChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7CRPV.default), {
        size: "xsmall",
        appearance: "invert"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fThgT))), {
        label: "",
        color: "currentColor",
        testId: testId && "".concat(testId, "--toggle-cross-icon"),
        size: "small"
    })), isLoading && !label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $itnU9.default), {
        id: loadingLabelId
    }, $dfd3990667cd7852$var$LOADING_LABEL));
}));
$dfd3990667cd7852$var$Toggle.displayName = 'Toggle';
var $dfd3990667cd7852$export$2e2bcd8739ae039 = $dfd3990667cd7852$var$Toggle;

});
parcelRegister("5Yz4U", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $011f72a5aa9d72a7$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $011f72a5aa9d72a7$var$ATOMIC_GROUP_LENGTH = 5;
function $011f72a5aa9d72a7$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $011f72a5aa9d72a7$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("bRtGP", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $8a2bacb9b86c57fa$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $ar795 = parcelRequire("ar795");

var $9SpbD = parcelRequire("9SpbD");
function $8a2bacb9b86c57fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a2bacb9b86c57fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a2bacb9b86c57fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a2bacb9b86c57fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8a2bacb9b86c57fa$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $ar795.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $9SpbD.useTrackedRef)(analyticsData);
    var fnRef = (0, $9SpbD.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $8a2bacb9b86c57fa$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("ar795", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $7991f7fb2b14cbbe$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $lx4Js = parcelRequire("lx4Js");

var $97T6X = parcelRequire("97T6X");
function $7991f7fb2b14cbbe$export$5bf35293e545f20c() {
    var analyticsContext = (0, $97T6X.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $lx4Js.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("lx4Js", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fad059bbff5622bf$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $bbNRi = parcelRequire("bbNRi");
function $fad059bbff5622bf$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $fad059bbff5622bf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $fad059bbff5622bf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fad059bbff5622bf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $fad059bbff5622bf$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $fad059bbff5622bf$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $fad059bbff5622bf$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $fad059bbff5622bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $fad059bbff5622bf$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $fad059bbff5622bf$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $bbNRi.default));

});
parcelRegister("bbNRi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $825765a6bba32e4e$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $825765a6bba32e4e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $825765a6bba32e4e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $825765a6bba32e4e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $825765a6bba32e4e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $825765a6bba32e4e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $825765a6bba32e4e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $825765a6bba32e4e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $825765a6bba32e4e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $825765a6bba32e4e$var$_objectSpread($825765a6bba32e4e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("97T6X", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $6a4f8475dab6f0a9$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $6a4f8475dab6f0a9$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("9SpbD", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $730cb1c106c03ef1$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $730cb1c106c03ef1$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("faH6P", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b0b93abdcb7d25ba$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $b0b93abdcb7d25ba$export$2e2bcd8739ae039() {}

});

parcelRegister("eadvm", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $a4fc79a71fde9594$export$f680877a34711e37; });

var $1oC0p = parcelRequire("1oC0p");
function $a4fc79a71fde9594$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("hd2BH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c875ac4b6f49561c$var$_react = $c875ac4b6f49561c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c875ac4b6f49561c$var$_baseNew = $c875ac4b6f49561c$var$_interopRequireDefault((parcelRequire("2gwPF")));
function $c875ac4b6f49561c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c875ac4b6f49561c$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $c875ac4b6f49561c$var$_react.default.createElement($c875ac4b6f49561c$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$c875ac4b6f49561c$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $c875ac4b6f49561c$var$_default = module.exports.default = $c875ac4b6f49561c$var$CheckMarkIcon;

});
parcelRegister("2gwPF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("8lZ86")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("8lZ86")).Icon; });

var $8lZ86 = parcelRequire("8lZ86");

});
parcelRegister("8lZ86", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $614fb3ff7ed5c19d$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $614fb3ff7ed5c19d$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $5Yz4U = parcelRequire("5Yz4U");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $614fb3ff7ed5c19d$var$svgStyles = null;
var $614fb3ff7ed5c19d$var$iconStyles = null;
var $614fb3ff7ed5c19d$var$smallIconStyles = null;
var $614fb3ff7ed5c19d$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $614fb3ff7ed5c19d$var$baseHcmStyles = null;
var $614fb3ff7ed5c19d$var$scaleSize = null;
var $614fb3ff7ed5c19d$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $614fb3ff7ed5c19d$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $614fb3ff7ed5c19d$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $614fb3ff7ed5c19d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $614fb3ff7ed5c19d$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $5Yz4U.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $5Yz4U.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $614fb3ff7ed5c19d$var$coreSizeSmall[spacing] : $614fb3ff7ed5c19d$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$614fb3ff7ed5c19d$export$2e2bcd8739ae039 = $614fb3ff7ed5c19d$export$f04a61298a47a40f;

});



parcelRegister("fThgT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6e34d167858ba514f74d5881b8440fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b91963cd4575560f$var$_react = $b91963cd4575560f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b91963cd4575560f$var$_baseNew = $b91963cd4575560f$var$_interopRequireDefault((parcelRequire("2gwPF")));
function $b91963cd4575560f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b91963cd4575560f$var$CrossIcon = (props)=>/*#__PURE__*/ $b91963cd4575560f$var$_react.default.createElement($b91963cd4575560f$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$b91963cd4575560f$var$CrossIcon.displayName = 'CrossIcon';
var $b91963cd4575560f$var$_default = module.exports.default = $b91963cd4575560f$var$CrossIcon;

});

parcelRegister("lfGWU", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $f78c5079a8443b2c$export$b40ec24ac8275656; });

var $2bqfw = parcelRequire("2bqfw");
function $f78c5079a8443b2c$export$ba05d765b8392e5e(flagResolver) {
    (0, $2bqfw.setBooleanResolver)(flagResolver);
}
function $f78c5079a8443b2c$export$470e5c2be1411c89(name) {
    return (0, $2bqfw.resolveBooleanFlag)(name);
}
function $f78c5079a8443b2c$export$b40ec24ac8275656(name) {
    return (0, $2bqfw.resolveBooleanFlag)(name);
}

});
parcelRegister("2bqfw", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $1970f866d0f419bd$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $1970f866d0f419bd$export$6333b6aff9fc6275; });

var $d1VQ1 = parcelRequire("d1VQ1");

var $3hK38 = parcelRequire("3hK38");

var $7t0tI = parcelRequire("7t0tI");
var $1970f866d0f419bd$var$pkgName = '@atlaskit/platform-feature-flags';
var $1970f866d0f419bd$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $1970f866d0f419bd$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $1970f866d0f419bd$var$ENV_ENABLE_PLATFORM_FF = $1970f866d0f419bd$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $1970f866d0f419bd$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $1970f866d0f419bd$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $1970f866d0f419bd$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $1970f866d0f419bd$var$ENV_ENABLE_PLATFORM_FF || $1970f866d0f419bd$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $1970f866d0f419bd$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $1970f866d0f419bd$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$1970f866d0f419bd$var$globalVar[$1970f866d0f419bd$export$7e41b1b2bdee3f98] = $1970f866d0f419bd$var$globalVar[$1970f866d0f419bd$export$7e41b1b2bdee3f98] || $1970f866d0f419bd$var$DEFAULT_PFF_GLOBAL;
function $1970f866d0f419bd$export$f2b591175b3e424c(resolver) {
    $1970f866d0f419bd$var$globalVar[$1970f866d0f419bd$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $1970f866d0f419bd$export$6333b6aff9fc6275(flagKey) {
    if ($1970f866d0f419bd$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3hK38.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $1970f866d0f419bd$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $1970f866d0f419bd$var$globalVar[$1970f866d0f419bd$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $1970f866d0f419bd$var$globalVar[$1970f866d0f419bd$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $d1VQ1.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $1970f866d0f419bd$var$globalVar[$1970f866d0f419bd$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("d1VQ1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0272b6a456dc3e16$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $6zbwW = parcelRequire("6zbwW");

var $3qTmu = parcelRequire("3qTmu");



var $0272b6a456dc3e16$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $0272b6a456dc3e16$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $cTewU.default)(this, FeatureGates);
    }
    return (0, $avOEA.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$0272b6a456dc3e16$var$_FeatureGates = $0272b6a456dc3e16$var$FeatureGates;
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "client", new (0, $6zbwW.Client)());
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$0272b6a456dc3e16$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $0272b6a456dc3e16$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $0272b6a456dc3e16$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$0272b6a456dc3e16$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $0272b6a456dc3e16$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $0272b6a456dc3e16$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "initializeCalled", $0272b6a456dc3e16$var$_FeatureGates.client.initializeCalled.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "initializeCompleted", $0272b6a456dc3e16$var$_FeatureGates.client.initializeCompleted.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "waitUntilInitializeCompleted", $0272b6a456dc3e16$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "initialize", $0272b6a456dc3e16$var$_FeatureGates.client.initialize.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "initializeWithProvider", $0272b6a456dc3e16$var$_FeatureGates.client.initializeWithProvider.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "initializeFromValues", $0272b6a456dc3e16$var$_FeatureGates.client.initializeFromValues.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "manuallyLogGateExposure", $0272b6a456dc3e16$var$_FeatureGates.client.manuallyLogGateExposure.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "getExperiment", $0272b6a456dc3e16$var$_FeatureGates.client.getExperiment.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "manuallyLogExperimentExposure", $0272b6a456dc3e16$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "manuallyLogLayerExposure", $0272b6a456dc3e16$var$_FeatureGates.client.manuallyLogLayerExposure.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "shutdownStatsig", $0272b6a456dc3e16$var$_FeatureGates.client.shutdownStatsig.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "overrideGate", $0272b6a456dc3e16$var$_FeatureGates.client.overrideGate.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "clearGateOverride", $0272b6a456dc3e16$var$_FeatureGates.client.clearGateOverride.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "overrideConfig", $0272b6a456dc3e16$var$_FeatureGates.client.overrideConfig.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "clearConfigOverride", $0272b6a456dc3e16$var$_FeatureGates.client.clearConfigOverride.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "setOverrides", $0272b6a456dc3e16$var$_FeatureGates.client.setOverrides.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "getOverrides", $0272b6a456dc3e16$var$_FeatureGates.client.getOverrides.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "clearAllOverrides", $0272b6a456dc3e16$var$_FeatureGates.client.clearAllOverrides.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "isCurrentUser", $0272b6a456dc3e16$var$_FeatureGates.client.isCurrentUser.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "onGateUpdated", $0272b6a456dc3e16$var$_FeatureGates.client.onGateUpdated.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "onExperimentValueUpdated", $0272b6a456dc3e16$var$_FeatureGates.client.onExperimentValueUpdated.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "onAnyUpdated", $0272b6a456dc3e16$var$_FeatureGates.client.onAnyUpdated.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "updateUser", $0272b6a456dc3e16$var$_FeatureGates.client.updateUser.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "updateUserWithProvider", $0272b6a456dc3e16$var$_FeatureGates.client.updateUserWithProvider.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "updateUserWithValues", $0272b6a456dc3e16$var$_FeatureGates.client.updateUserWithValues.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "getPackageVersion", $0272b6a456dc3e16$var$_FeatureGates.client.getPackageVersion.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "getLayer", $0272b6a456dc3e16$var$_FeatureGates.client.getLayer.bind($0272b6a456dc3e16$var$_FeatureGates.client));
(0, $f53LC.default)($0272b6a456dc3e16$var$FeatureGates, "getLayerValue", $0272b6a456dc3e16$var$_FeatureGates.client.getLayerValue.bind($0272b6a456dc3e16$var$_FeatureGates.client));
var $0272b6a456dc3e16$var$boundFGJS = $0272b6a456dc3e16$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $0272b6a456dc3e16$var$FeatureGates;
    else {
        var $0272b6a456dc3e16$var$_boundFGJS, $0272b6a456dc3e16$var$_boundFGJS$getPackage;
        $0272b6a456dc3e16$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $0272b6a456dc3e16$var$boundVersion = (($0272b6a456dc3e16$var$_boundFGJS = $0272b6a456dc3e16$var$boundFGJS) === null || $0272b6a456dc3e16$var$_boundFGJS === void 0 || ($0272b6a456dc3e16$var$_boundFGJS$getPackage = $0272b6a456dc3e16$var$_boundFGJS.getPackageVersion) === null || $0272b6a456dc3e16$var$_boundFGJS$getPackage === void 0 ? void 0 : $0272b6a456dc3e16$var$_boundFGJS$getPackage.call($0272b6a456dc3e16$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($0272b6a456dc3e16$var$boundVersion !== (0, $3qTmu.CLIENT_VERSION)) {
            var $0272b6a456dc3e16$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($0272b6a456dc3e16$var$boundVersion, " when module version ").concat((0, $3qTmu.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($0272b6a456dc3e16$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $0272b6a456dc3e16$export$2e2bcd8739ae039 = $0272b6a456dc3e16$var$boundFGJS;

});
parcelRegister("6zbwW", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $4c7ef4a94a2752da$export$1f2bb630327ac4b6; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");

var $j4WXu = parcelRequire("j4WXu");

var $6G5J2 = parcelRequire("6G5J2");

var $5sonf = parcelRequire("5sonf");

var $9L4cR = parcelRequire("9L4cR");

var $ff55A = parcelRequire("ff55A");

var $c7qxN = parcelRequire("c7qxN");

var $9PgvW = parcelRequire("9PgvW");

var $15Hgd = parcelRequire("15Hgd");

var $fCZpr = parcelRequire("fCZpr");

var $3qTmu = parcelRequire("3qTmu");
var $4c7ef4a94a2752da$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $4c7ef4a94a2752da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c7ef4a94a2752da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c7ef4a94a2752da$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c7ef4a94a2752da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4c7ef4a94a2752da$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $4c7ef4a94a2752da$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $4c7ef4a94a2752da$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $9PgvW.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $cTewU.default)(this, Client);
        (0, $f53LC.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $f53LC.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $f53LC.default)(this, "initWithDefaults", false);
        (0, $f53LC.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $f53LC.default)(this, "subscriptions", new (0, $j4WXu.default)());
        (0, $f53LC.default)(this, "dataAdapter", new (0, $c7qxN.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $f53LC.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $9PgvW.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $avOEA.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fCZpr.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $fCZpr.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fCZpr.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $fCZpr.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $3qTmu.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $4c7ef4a94a2752da$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $3qTmu.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $15Hgd.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $fCZpr.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $fCZpr.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $fCZpr.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $ff55A.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $6G5J2.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $6G5J2.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $9L4cR.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $fCZpr.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $fCZpr.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $4c7ef4a94a2752da$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $ff55A.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $ff55A.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $2qaZZ.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $4c7ef4a94a2752da$var$_objectSpread($4c7ef4a94a2752da$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $2qaZZ.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $fCZpr.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $4c7ef4a94a2752da$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $4c7ef4a94a2752da$var$_objectSpread($4c7ef4a94a2752da$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $4c7ef4a94a2752da$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $15Hgd.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $gnQ3X.default)(newClientOptions, $4c7ef4a94a2752da$var$_excluded);
                                this.user = (0, $fCZpr.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $4c7ef4a94a2752da$var$_objectSpread($4c7ef4a94a2752da$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($4c7ef4a94a2752da$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $fCZpr.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $3qTmu.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $5sonf.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $5sonf.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("j4WXu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de3c1ffb0c1d8c74$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $f72YL = parcelRequire("f72YL");
function $de3c1ffb0c1d8c74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de3c1ffb0c1d8c74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de3c1ffb0c1d8c74$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de3c1ffb0c1d8c74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $de3c1ffb0c1d8c74$export$a66cbd9b2289cd78 = '@all-features';
var $de3c1ffb0c1d8c74$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $cTewU.default)(this, Subscriptions);
        (0, $f53LC.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $avOEA.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $de3c1ffb0c1d8c74$var$_objectSpread($de3c1ffb0c1d8c74$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $de3c1ffb0c1d8c74$var$_objectSpread($de3c1ffb0c1d8c74$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $de3c1ffb0c1d8c74$var$_objectSpread($de3c1ffb0c1d8c74$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $de3c1ffb0c1d8c74$var$_objectSpread($de3c1ffb0c1d8c74$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($de3c1ffb0c1d8c74$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($de3c1ffb0c1d8c74$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($de3c1ffb0c1d8c74$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $de3c1ffb0c1d8c74$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("6G5J2", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $4dcb1b4aa064a5de$export$6dc24881a3d96325; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $fCZpr = parcelRequire("fCZpr");
var $4dcb1b4aa064a5de$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $cTewU.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $avOEA.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $2zYm4.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $2zYm4.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $fCZpr.migrateEvaluationDetails)(experiment.details), (0, $fCZpr.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("fCZpr", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $b60a0a3822fd584c$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $b60a0a3822fd584c$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $b60a0a3822fd584c$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $b60a0a3822fd584c$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $b60a0a3822fd584c$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $b60a0a3822fd584c$export$55fd683752d01e67; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $hMUFv = parcelRequire("hMUFv");

var $9L4cR = parcelRequire("9L4cR");

var $15Hgd = parcelRequire("15Hgd");
var $b60a0a3822fd584c$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $b60a0a3822fd584c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b60a0a3822fd584c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b60a0a3822fd584c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b60a0a3822fd584c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b60a0a3822fd584c$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $b60a0a3822fd584c$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $hMUFv.isFedRamp)() ? (0, $15Hgd.PerimeterType).FEDRAMP_MODERATE : (0, $15Hgd.PerimeterType).COMMERCIAL
    }, options);
};
var $b60a0a3822fd584c$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $2qaZZ.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $2qaZZ.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $2qaZZ.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $2qaZZ.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $b60a0a3822fd584c$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $b60a0a3822fd584c$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $gnQ3X.default)(options, $b60a0a3822fd584c$var$_excluded);
    return $b60a0a3822fd584c$var$_objectSpread($b60a0a3822fd584c$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $b60a0a3822fd584c$var$evaluationReasonMappings = Object.entries((0, $9L4cR.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $2qaZZ.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $b60a0a3822fd584c$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $b60a0a3822fd584c$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $2qaZZ.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $9L4cR.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $b60a0a3822fd584c$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("9L4cR", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $71abc426651447b6$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $71abc426651447b6$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("15Hgd", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $0cb7d0bb7316cb3c$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $0cb7d0bb7316cb3c$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $0cb7d0bb7316cb3c$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $0cb7d0bb7316cb3c$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $0cb7d0bb7316cb3c$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("5sonf", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $3f92796b1f06388e$export$936d0764594b6eb3; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $fCZpr = parcelRequire("fCZpr");
var $3f92796b1f06388e$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $cTewU.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $avOEA.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $2zYm4.default)(val) === (0, $2zYm4.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $fCZpr.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $fCZpr.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $fCZpr.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("ff55A", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b18c344f7ccccb0f$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $15Hgd = parcelRequire("15Hgd");

var $3qTmu = parcelRequire("3qTmu");

var $5mteR = parcelRequire("5mteR");
function $b18c344f7ccccb0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b18c344f7ccccb0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b18c344f7ccccb0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b18c344f7ccccb0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b18c344f7ccccb0f$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $b18c344f7ccccb0f$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $b18c344f7ccccb0f$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $b18c344f7ccccb0f$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $b18c344f7ccccb0f$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $b18c344f7ccccb0f$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $b18c344f7ccccb0f$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $b18c344f7ccccb0f$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $b18c344f7ccccb0f$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $b18c344f7ccccb0f$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $b18c344f7ccccb0f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $cTewU.default)(this, Fetcher);
    }
    return (0, $avOEA.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $5mteR.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $5mteR.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $b18c344f7ccccb0f$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $15Hgd.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $15Hgd.FeatureGateEnvironment).Production:
                        return $b18c344f7ccccb0f$export$18c93900db9358a4;
                    case (0, $15Hgd.FeatureGateEnvironment).Staging:
                        return $b18c344f7ccccb0f$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $15Hgd.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $15Hgd.FeatureGateEnvironment).Development:
                        return $b18c344f7ccccb0f$export$f058dbf75c3bc647;
                    case (0, $15Hgd.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $b18c344f7ccccb0f$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $b18c344f7ccccb0f$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $b18c344f7ccccb0f$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $b18c344f7ccccb0f$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $3qTmu.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $b18c344f7ccccb0f$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($b18c344f7ccccb0f$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($b18c344f7ccccb0f$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("3qTmu", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $27febe846ba58958$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $27febe846ba58958$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("5mteR", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $3e75b003c7b4c2e5$export$286baf652d0b1206; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $3e75b003c7b4c2e5$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $3e75b003c7b4c2e5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $3e75b003c7b4c2e5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3e75b003c7b4c2e5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $3e75b003c7b4c2e5$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $cTewU.default)(this, ResponseError);
        return $3e75b003c7b4c2e5$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $i7dvh.default)(ResponseError, _Error);
    return (0, $avOEA.default)(ResponseError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("c7qxN", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $8d2aba91e1b1de48$export$55fffef3474104af; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");
function $8d2aba91e1b1de48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d2aba91e1b1de48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d2aba91e1b1de48$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d2aba91e1b1de48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8d2aba91e1b1de48$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $8d2aba91e1b1de48$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $8d2aba91e1b1de48$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8d2aba91e1b1de48$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $8d2aba91e1b1de48$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $8d2aba91e1b1de48$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $cTewU.default)(this, NoFetchDataAdapter);
        _this = $8d2aba91e1b1de48$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $f53LC.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $i7dvh.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $avOEA.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $8d2aba91e1b1de48$var$_objectSpread($8d2aba91e1b1de48$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $8d2aba91e1b1de48$var$_objectSpread($8d2aba91e1b1de48$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $8d2aba91e1b1de48$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $8d2aba91e1b1de48$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});

parcelRegister("9PgvW", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $7275afd4e5f49627$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $7275afd4e5f49627$export$bcb28fbac1def494; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $3wfvf = parcelRequire("3wfvf");
function $7275afd4e5f49627$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7275afd4e5f49627$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7275afd4e5f49627$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7275afd4e5f49627$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7275afd4e5f49627$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7275afd4e5f49627$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7275afd4e5f49627$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7275afd4e5f49627$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7275afd4e5f49627$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7275afd4e5f49627$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7275afd4e5f49627$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $7275afd4e5f49627$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $7275afd4e5f49627$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $7275afd4e5f49627$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $7275afd4e5f49627$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $7275afd4e5f49627$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $cTewU.default)(this, PersistentOverrideAdapter);
        this._overrides = $7275afd4e5f49627$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $avOEA.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $7275afd4e5f49627$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $7275afd4e5f49627$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $7275afd4e5f49627$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $2qaZZ.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $2qaZZ.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($7275afd4e5f49627$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($7275afd4e5f49627$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $7275afd4e5f49627$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $7275afd4e5f49627$var$_objectSpread($7275afd4e5f49627$var$_objectSpread({}, $7275afd4e5f49627$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $2qaZZ.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $2qaZZ.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($7275afd4e5f49627$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($7275afd4e5f49627$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($7275afd4e5f49627$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($7275afd4e5f49627$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $7275afd4e5f49627$var$_objectSpread($7275afd4e5f49627$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $7275afd4e5f49627$var$_objectSpread($7275afd4e5f49627$var$_objectSpread({}, current.details), {}, {
                        reason: $7275afd4e5f49627$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($7275afd4e5f49627$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($7275afd4e5f49627$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($7275afd4e5f49627$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($7275afd4e5f49627$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($7275afd4e5f49627$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($7275afd4e5f49627$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $7275afd4e5f49627$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($7275afd4e5f49627$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $7275afd4e5f49627$var$_objectSpread($7275afd4e5f49627$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $7275afd4e5f49627$var$_objectSpread($7275afd4e5f49627$var$_objectSpread({}, current.details), {}, {
                        reason: $7275afd4e5f49627$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($7275afd4e5f49627$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $7275afd4e5f49627$var$_objectSpread($7275afd4e5f49627$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $7275afd4e5f49627$var$_objectSpread($7275afd4e5f49627$var$_objectSpread({}, current.details), {}, {
                        reason: $7275afd4e5f49627$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("3hK38", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $2646ae1c4bd947c1$export$1c9f709888824e05; });
var $2646ae1c4bd947c1$var$_process, $2646ae1c4bd947c1$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $2646ae1c4bd947c1$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($2646ae1c4bd947c1$var$_process = globalThis.process) === null || $2646ae1c4bd947c1$var$_process === void 0 || ($2646ae1c4bd947c1$var$_process = $2646ae1c4bd947c1$var$_process.env) === null || $2646ae1c4bd947c1$var$_process === void 0 ? void 0 : $2646ae1c4bd947c1$var$_process.JEST_WORKER_ID) !== undefined;
var $2646ae1c4bd947c1$var$DEBUG_MODE = !$2646ae1c4bd947c1$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($2646ae1c4bd947c1$var$_process2 = globalThis.process) === null || $2646ae1c4bd947c1$var$_process2 === void 0 || ($2646ae1c4bd947c1$var$_process2 = $2646ae1c4bd947c1$var$_process2.env) === null || $2646ae1c4bd947c1$var$_process2 === void 0 ? void 0 : $2646ae1c4bd947c1$var$_process2.NODE_ENV) !== 'production';
var $2646ae1c4bd947c1$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$2646ae1c4bd947c1$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("7CRPV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58d5d7cf155fc2b9$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5Yz4U = parcelRequire("5Yz4U");

var $1oC0p = parcelRequire("1oC0p");

var $etBkE = parcelRequire("etBkE");

var $8Bpcs = parcelRequire("8Bpcs");
/**
 * Returns the appropriate circle stroke color.
 */ function $58d5d7cf155fc2b9$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $58d5d7cf155fc2b9$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $58d5d7cf155fc2b9$var$loadIn = null;
var $58d5d7cf155fc2b9$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $58d5d7cf155fc2b9$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $58d5d7cf155fc2b9$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $8Bpcs.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $58d5d7cf155fc2b9$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $etBkE.default));
    $58d5d7cf155fc2b9$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $5Yz4U.default)([
            $58d5d7cf155fc2b9$var$styles.wrapperStyles,
            $58d5d7cf155fc2b9$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $5Yz4U.default)([
            $58d5d7cf155fc2b9$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $5Yz4U.default)([
            $58d5d7cf155fc2b9$var$styles.circleStyles
        ])
    })));
}));
var $58d5d7cf155fc2b9$export$2e2bcd8739ae039 = $58d5d7cf155fc2b9$var$Spinner;

});
parcelRegister("8Bpcs", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $64355396a25dde3a$export$4e9f1640bbe7a1a8; });
var $64355396a25dde3a$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("itnU9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d72d7a64d47850c4$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $5Yz4U = parcelRequire("5Yz4U");
var $d72d7a64d47850c4$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $d72d7a64d47850c4$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $5Yz4U.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$d72d7a64d47850c4$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $d72d7a64d47850c4$export$2e2bcd8739ae039 = $d72d7a64d47850c4$var$VisuallyHidden;

});

parcelRegister("1IXwf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $141811c3aa68820d$export$2e2bcd8739ae039; });
/* icon-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");


var $lmFZB = parcelRequire("lmFZB");

var $gtDMQ = parcelRequire("gtDMQ");
var $141811c3aa68820d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ var $141811c3aa68820d$var$IconContainer = function IconContainer(_ref) {
    var children = _ref.children, size = _ref.size, isHidden = _ref.isHidden, position = _ref.position;
    return /*#__PURE__*/ $1oC0p.createElement((0, $gtDMQ.default), {
        as: "span",
        xcss: (0, $lmFZB.cx)($141811c3aa68820d$var$styles.iconContainer, isHidden && $141811c3aa68820d$var$styles.hidden, size === 'regular' && $141811c3aa68820d$var$styles.iconContainerRegular, size === 'large' && $141811c3aa68820d$var$styles.iconContainerLarge, position === 'left' && $141811c3aa68820d$var$styles.left, position === 'right' && $141811c3aa68820d$var$styles.right)
    }, children);
};
var $141811c3aa68820d$export$2e2bcd8739ae039 = $141811c3aa68820d$var$IconContainer;

});
parcelRegister("lmFZB", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $f8dc39e5fbe3f115$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $62Qlw = parcelRequire("62Qlw");
var $f8dc39e5fbe3f115$var$strictApi = (0, $62Qlw.createStrictAPI)();
var $f8dc39e5fbe3f115$export$dbf350e5966cf602 = $f8dc39e5fbe3f115$var$strictApi.css;
var $f8dc39e5fbe3f115$export$eb1ecd84a24ee424 = $f8dc39e5fbe3f115$var$strictApi.cssMap;
$f8dc39e5fbe3f115$var$strictApi.cssMap;
var $f8dc39e5fbe3f115$export$a274e22fb40f762e = $f8dc39e5fbe3f115$var$strictApi.cx;
var $f8dc39e5fbe3f115$var$XCSSProp = $f8dc39e5fbe3f115$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("62Qlw", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $466b88d41cb1e1fd$export$39716b4af53f4ad; });

var $6TG2G = parcelRequire("6TG2G");

var $j1SH6 = parcelRequire("j1SH6");
function $466b88d41cb1e1fd$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $6TG2G.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $6TG2G.createStrictSetupError)();
        },
        cx: $j1SH6.cx,
        XCSSProp () {
            throw (0, $6TG2G.createStrictSetupError)();
        }
    };
}

});
parcelRegister("6TG2G", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $50587ddbfd431449$export$c4df1cb0c2b4d77c; });
const $50587ddbfd431449$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $50587ddbfd431449$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("j1SH6", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $dda88974e76e2c32$export$a274e22fb40f762e; });

var $9Id13 = parcelRequire("9Id13");
const $dda88974e76e2c32$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $9Id13.default)(actualStyles);
};

});
parcelRegister("9Id13", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $712251d44bfde9af$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $712251d44bfde9af$var$ATOMIC_GROUP_LENGTH = 5;
function $712251d44bfde9af$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $712251d44bfde9af$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("gtDMQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bfee37999772c601$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $5Yz4U = parcelRequire("5Yz4U");

var $kptWq = parcelRequire("kptWq");
var $bfee37999772c601$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $bfee37999772c601$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $bfee37999772c601$var$baseStyles = null;
var $bfee37999772c601$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $bfee37999772c601$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $bfee37999772c601$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $bfee37999772c601$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $bfee37999772c601$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $bfee37999772c601$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $bfee37999772c601$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $bfee37999772c601$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $bfee37999772c601$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $bfee37999772c601$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: (0, $5Yz4U.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $bfee37999772c601$var$backgroundColorMap[backgroundColor],
            backgroundColor && $bfee37999772c601$var$isSurfaceToken(backgroundColor) && $bfee37999772c601$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $bfee37999772c601$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $bfee37999772c601$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $bfee37999772c601$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $bfee37999772c601$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $kptWq.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $bfee37999772c601$export$2e2bcd8739ae039 = $bfee37999772c601$var$Box;
function $bfee37999772c601$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $bfee37999772c601$var$setSurfaceTokenMap;
}

});
parcelRegister("kptWq", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $edbd5e32caca20a0$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $edbd5e32caca20a0$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $edbd5e32caca20a0$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($edbd5e32caca20a0$export$1ca2a26fecb070ae);
};
$edbd5e32caca20a0$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});




parcelRegister("9Vcji", function(module, exports) {
$parcel$export(module.exports, "RovoOpsMark", function () { return $b55f1919731c3886$export$f035f9e181e9758e; });
$parcel$export(module.exports, "SlackMark", function () { return $b55f1919731c3886$export$1f928fe4a46b6a85; });
$parcel$export(module.exports, "ZoomMark", function () { return $b55f1919731c3886$export$c5d0ff8d5e68b2a8; });
$parcel$export(module.exports, "PriyaAvatar", function () { return $b55f1919731c3886$export$e55b3b20113a9928; });
$parcel$export(module.exports, "PaymentTeamAvatar", function () { return $b55f1919731c3886$export$da709c9d313b82e0; });
/* jsm-playground-incident-marks.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $4SA4u = parcelRequire("4SA4u");

var $bSVv5 = parcelRequire("bSVv5");

var $AuGuY = parcelRequire("AuGuY");

var $jkcY3 = parcelRequire("jkcY3");

var $6SYT3 = parcelRequire("6SYT3");

var $6VLXp = parcelRequire("6VLXp");

var $c0yqw = parcelRequire("c0yqw");
const $b55f1919731c3886$export$f035f9e181e9758e = ({ label: label, size: size = 16 })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        alt: label,
        height: size,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6SYT3))),
        width: size,
        className: (0, $2jatx.default)([
            "_1e0c1ule _1o9zidpf"
        ])
    });
const $b55f1919731c3886$export$1f928fe4a46b6a85 = ({ label: label, size: size = 16 })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-label": label,
        height: size,
        role: "img",
        viewBox: "23.53 23.8 33.35 33.35",
        width: size,
        className: (0, $2jatx.default)([
            "_1e0c1ule _1o9zidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.5674 44.8842C30.5674 46.8232 29.0034 48.3881 27.0656 48.3881C25.1277 48.3881 23.5637 46.8179 23.5637 44.8842C23.5637 42.9505 25.1277 41.3804 27.0656 41.3804H30.5674V44.8842ZM32.3157 44.8842C32.3157 42.9452 33.8796 41.3804 35.8175 41.3804C37.7554 41.3804 39.3193 42.9452 39.3193 44.8842V53.6412C39.3193 55.5802 37.7554 57.145 35.8175 57.145C33.8796 57.145 32.3157 55.5802 32.3157 53.6412V44.8842Z",
                fill: "#E01E5A",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.8175 30.8153C33.8796 30.8153 32.3156 29.2504 32.3156 27.3115C32.3156 25.3725 33.8796 23.8076 35.8175 23.8076C37.7553 23.8076 39.3193 25.3725 39.3193 27.3115V30.8153H35.8175ZM35.8175 32.5909C37.7553 32.5909 39.3193 34.1558 39.3193 36.0948C39.3193 38.0338 37.7553 39.5986 35.8175 39.5986H27.0392C25.1013 39.5986 23.5374 38.0285 23.5374 36.0948C23.5374 34.1611 25.1013 32.5909 27.0392 32.5909H35.8175Z",
                fill: "#36C5F0",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M49.8472 36.0948C49.8472 34.1558 51.4111 32.5909 53.349 32.5909C55.2869 32.5909 56.8508 34.1558 56.8508 36.0948C56.8508 38.0338 55.2869 39.5986 53.349 39.5986H49.8472V36.0948ZM48.0989 36.0948C48.0989 38.0338 46.5349 39.5986 44.597 39.5986C42.6592 39.5986 41.0952 38.0338 41.0952 36.0948V27.3115C41.0952 25.3725 42.6592 23.8076 44.597 23.8076C46.5349 23.8076 48.0989 25.3725 48.0989 27.3115V36.0948Z",
                fill: "#2EB67D",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44.597 50.1373C46.5349 50.1373 48.0989 51.7022 48.0989 53.6412C48.0989 55.5802 46.5349 57.145 44.597 57.145C42.6592 57.145 41.0952 55.5802 41.0952 53.6412V50.1373H44.597ZM44.597 48.3881C42.6592 48.3881 41.0952 46.8232 41.0952 44.8842C41.0952 42.9452 42.6592 41.3804 44.597 41.3804H53.3753C55.3132 41.3804 56.8772 42.9452 56.8772 44.8842C56.8772 46.8232 55.3132 48.3881 53.3753 48.3881H44.597Z",
                fill: "#ECB22E",
                fillRule: "evenodd"
            })
        ]
    });
const $b55f1919731c3886$export$c5d0ff8d5e68b2a8 = ({ label: label, size: size = 16 })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        alt: label,
        height: size,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6VLXp))),
        width: size,
        className: (0, $2jatx.default)([
            "_1e0c1ule _1o9zidpf _2rko12b0"
        ])
    });
const $b55f1919731c3886$export$e55b3b20113a9928 = ({ size: size = 24 })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
        name: "Priya Hansra",
        size: size === 16 ? 'xsmall' : 'small',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jkcY3)))
    });
const $b55f1919731c3886$export$da709c9d313b82e0 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        alt: intl.formatMessage((0, $c0yqw.jsmPortalPlaygroundMessages).paymentTeam),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($AuGuY))),
        className: (0, $2jatx.default)([
            "_1e0c1ule _vchhusvi _1bsb1ejb _4t3i1ejb _1o9zidpf _2rko1qi0"
        ])
    });
};
const $b55f1919731c3886$var$markStyles = null;
const $b55f1919731c3886$var$roundedMarkStyles = null;
const $b55f1919731c3886$var$paymentTeamAvatarStyles = null;

});
parcelRegister("AuGuY", function(module, exports) {
module.exports = new URL("payment-team-grogu.aab22ed9.svg", import.meta.url).toString();

});

parcelRegister("jkcY3", function(module, exports) {
module.exports = new URL("priya-hansra.f33aca40.svg", import.meta.url).toString();

});

parcelRegister("6SYT3", function(module, exports) {
module.exports = new URL("rovo-ops.ab4fa33e.svg", import.meta.url).toString();

});

parcelRegister("6VLXp", function(module, exports) {
module.exports = new URL("zoom.69d69e10.svg", import.meta.url).toString();

});



parcelRegister("gjT5s", function(module, exports) {
$parcel$export(module.exports, "useJsmPlaygroundSectionExploredAnalytics", function () { return $ca85c1c7780ed746$export$ea527cb7076dd5ae; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $gx3aw = parcelRequire("gx3aw");
const $ca85c1c7780ed746$export$17445b12040d34b2 = ()=>{
    if (typeof document !== 'undefined') {
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical?.href) return canonical.href;
    }
    if (typeof window !== 'undefined') return window.location.href.split('#')[0] ?? '';
    return '';
};
const $ca85c1c7780ed746$export$d72b1b7bb75ba57c = ()=>{
    if (typeof window !== 'undefined') return window.location.pathname;
    return '';
};
const $ca85c1c7780ed746$export$f6171dd7b4f18af3 = ()=>{
    if (typeof document !== 'undefined') {
        const cookieVal = (0, $gx3aw.Cookie).readCookie('login_user_detected');
        if (cookieVal) return cookieVal;
    }
    return 'false';
};
const $ca85c1c7780ed746$export$29ccc5fb573d95b3 = (target)=>{
    if (!(target instanceof HTMLElement || target instanceof SVGElement)) return false;
    const element = target;
    const customizeSelector = [
        '[data-testid="customize-help-center-button"]',
        '[data-testid="jsm-portal-customize-sidebar"]',
        '[data-testid="primary-color-swatch"]',
        '[data-testid="secondary-color-swatch"]',
        '#helpCenterName',
        '[aria-label="Help center name"]',
        '[name="helpCenterName"]',
        'button[aria-label="Customize the help center"]',
        'button[aria-label="Close"]'
    ].join(', ');
    if (element.closest(customizeSelector)) return true;
    const text = element.textContent?.trim();
    if (text === 'Customize the help center' || text === 'Customize look and feel' || text === 'Change the article banner color' || text === 'Change the article icon color') return true;
    const ariaLabel = element.getAttribute('aria-label');
    if (ariaLabel === 'Customize the help center' || ariaLabel === 'Customize look and feel' || ariaLabel === 'Change the article banner color' || ariaLabel === 'Change the article icon color') return true;
    return false;
};
const $ca85c1c7780ed746$export$ea527cb7076dd5ae = ({ initialActiveTab: initialActiveTab = 'it-support' } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const sessionStartTimeRef = (0, $1oC0p.useRef)(Date.now());
    const tabsExploredRef = (0, $1oC0p.useRef)([
        initialActiveTab
    ]);
    const interactionCountRef = (0, $1oC0p.useRef)(0);
    const didCustomizeRef = (0, $1oC0p.useRef)(false);
    const hasFiredRef = (0, $1oC0p.useRef)(false);
    const lastPointerDownRef = (0, $1oC0p.useRef)(null);
    const recordTabExplored = (0, $1oC0p.useCallback)((tab)=>{
        if (!tabsExploredRef.current.includes(tab)) tabsExploredRef.current.push(tab);
    }, []);
    const checkCustomize = (0, $1oC0p.useCallback)((target)=>{
        if ($ca85c1c7780ed746$export$29ccc5fb573d95b3(target)) didCustomizeRef.current = true;
    }, []);
    const recordInteraction = (0, $1oC0p.useCallback)(()=>{
        interactionCountRef.current += 1;
    }, []);
    const handlePointerDown = (0, $1oC0p.useCallback)((event)=>{
        lastPointerDownRef.current = {
            target: event.target,
            time: Date.now()
        };
        recordInteraction();
        checkCustomize(event.target);
    }, [
        checkCustomize,
        recordInteraction
    ]);
    const handleClick = (0, $1oC0p.useCallback)((event)=>{
        const now = Date.now();
        const isFromRecentPointerDown = lastPointerDownRef.current && now - lastPointerDownRef.current.time < 300 && (lastPointerDownRef.current.target === event.target || event.target instanceof Node && lastPointerDownRef.current.target instanceof Node && (event.target.contains(lastPointerDownRef.current.target) || lastPointerDownRef.current.target.contains(event.target)));
        if (!isFromRecentPointerDown) recordInteraction();
        checkCustomize(event.target);
    }, [
        checkCustomize,
        recordInteraction
    ]);
    const handleKeyDown = (0, $1oC0p.useCallback)((event)=>{
        if ([
            'Shift',
            'Control',
            'Alt',
            'Meta'
        ].includes(event.key)) return;
        recordInteraction();
        checkCustomize(event.target);
    }, [
        checkCustomize,
        recordInteraction
    ]);
    const handleChange = (0, $1oC0p.useCallback)((event)=>{
        recordInteraction();
        checkCustomize(event.target);
    }, [
        checkCustomize,
        recordInteraction
    ]);
    const fireExploredSummary = (0, $1oC0p.useCallback)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        const dwellMs = Math.max(0, Math.round(Date.now() - sessionStartTimeRef.current));
        const tabs = tabsExploredRef.current;
        createAnalyticsEvent({
            actionSubject: 'section',
            action: 'explored',
            actionSubjectId: 'jsmPlayground',
            eventType: 'ui',
            source: 'jsm-playground',
            attributes: {
                trackEventName: 'explored-playground-summary',
                eventContainer: 'jsm-playground',
                tabsExplored: [
                    ...tabs
                ],
                tabCountExplored: tabs.length,
                dwellMs: dwellMs,
                interactionCount: interactionCountRef.current,
                didCustomize: didCustomizeRef.current,
                page_canonical_url: $ca85c1c7780ed746$export$17445b12040d34b2(),
                page_path: $ca85c1c7780ed746$export$d72b1b7bb75ba57c(),
                loginUserDetected: $ca85c1c7780ed746$export$f6171dd7b4f18af3()
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireExploredSummaryRef = (0, $1oC0p.useRef)(fireExploredSummary);
    fireExploredSummaryRef.current = fireExploredSummary;
    (0, $1oC0p.useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === 'hidden') fireExploredSummaryRef.current();
            else if (document.visibilityState === 'visible') // Reset when the visitor returns so subsequent tab switches or page exit fire updated metrics
            hasFiredRef.current = false;
        };
        const handlePageExit = ()=>{
            fireExploredSummaryRef.current();
        };
        if (typeof document !== 'undefined') document.addEventListener('visibilitychange', handleVisibilityChange);
        if (typeof window !== 'undefined') {
            window.addEventListener('beforeunload', handlePageExit);
            window.addEventListener('pagehide', handlePageExit);
        }
        return ()=>{
            if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', handleVisibilityChange);
            if (typeof window !== 'undefined') {
                window.removeEventListener('beforeunload', handlePageExit);
                window.removeEventListener('pagehide', handlePageExit);
            }
            fireExploredSummaryRef.current();
        };
    }, []);
    return {
        tabsExploredRef: tabsExploredRef,
        interactionCountRef: interactionCountRef,
        didCustomizeRef: didCustomizeRef,
        recordTabExplored: recordTabExplored,
        recordInteraction: recordInteraction,
        handlePointerDown: handlePointerDown,
        handleClick: handleClick,
        handleKeyDown: handleKeyDown,
        handleChange: handleChange,
        fireExploredSummary: fireExploredSummary
    };
};

});


parcelRegister("ks0ka", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6351c758da902f43$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $jQ0cd = parcelRequire("jQ0cd");

var $aIIww = parcelRequire("aIIww");

var $iPPTB = parcelRequire("iPPTB");
const $6351c758da902f43$export$64bc9cd96d3d9a80 = (props)=>{
    let localizedHref = (0, $jQ0cd.useLocalizedHref)(props.href);
    const localizedPartnerDirectoryUrl = (0, $aIIww.useLocalizedPartnerDirectoryHref)(props.href);
    if (props.href !== localizedPartnerDirectoryUrl) localizedHref = localizedPartnerDirectoryUrl;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        ...props,
        "aria-label": props.text,
        href: localizedHref,
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event-component': 'linkButton',
            'data-event-container': 'link',
            'data-event': 'clicked'
        }
    });
};
var $6351c758da902f43$export$2e2bcd8739ae039 = $6351c758da902f43$export$64bc9cd96d3d9a80;

});

parcelRegister("42RaW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ba822808b700e2b$export$2e2bcd8739ae039; });
/* listv2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $iQZ6I = parcelRequire("iQZ6I");
// Helper functions to reduce complexity
const $3ba822808b700e2b$var$createResponsiveGapObject = (gapv2)=>({
        mobile: gapv2.mobile ?? '0',
        tablet: gapv2?.tablet ?? gapv2.mobile ?? '0',
        desktop: gapv2?.desktop ?? gapv2?.tablet ?? gapv2.mobile ?? '0'
    });
const $3ba822808b700e2b$var$createResponsiveOrientationObject = (orientation)=>({
        mobile: orientation.mobile || 'vertical',
        tablet: orientation.tablet || orientation.mobile || 'vertical',
        desktop: orientation.desktop || orientation.tablet || orientation.mobile || 'vertical'
    });
const $3ba822808b700e2b$var$createResponsiveWrappedChildContentObject = (wrappedChildContent)=>({
        mobile: wrappedChildContent?.mobile || 'nowrap',
        tablet: wrappedChildContent?.tablet || wrappedChildContent?.mobile || 'nowrap',
        desktop: wrappedChildContent?.desktop || wrappedChildContent?.tablet || wrappedChildContent?.mobile || 'nowrap'
    });
const $3ba822808b700e2b$var$createResponsiveJustifyContentObject = (justifyContent)=>({
        mobile: justifyContent.mobile || 'flex-start',
        tablet: justifyContent?.tablet || justifyContent?.mobile || 'flex-start',
        desktop: justifyContent?.desktop || justifyContent?.tablet || justifyContent.mobile || 'flex-start'
    });
const $3ba822808b700e2b$var$getFlexWrapValue = (value)=>{
    if (value === 'wrap') return 'wrap';
    if (value === 'wrap-reverse') return 'wrap-reverse';
    return 'nowrap';
};
const $3ba822808b700e2b$var$zeroMarginPadding = null;
const $3ba822808b700e2b$var$resetListStyles = null;
const $3ba822808b700e2b$var$createRenderListItems = (listType)=>{
    return ({ items: items })=>{
        if (listType === 'ol') return items.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                    "_qtt8glyw _1e0c1txw _2lx21bp4 _zulp1crf _1lp7vrvc _q8t51q9y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iQZ6I.ListItemNumber), {
                        value: index + 1
                    }),
                    item
                ]
            }, index));
        return items.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                className: (0, $2jatx.default)([
                    "_kkk2n7od _1e0c1txw",
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: item
            }, index));
    };
};
const $3ba822808b700e2b$var$UniformListV2 = ({ listType: listType, gapv2: gapv2 = {
    mobile: '0'
}, orientation: orientation = {
    mobile: 'vertical'
}, wrappedChildContent: wrappedChildContent = {
    mobile: 'nowrap'
}, justifyContent: justifyContent = {
    mobile: 'flex-start'
} })=>{
    const gapObject = $3ba822808b700e2b$var$createResponsiveGapObject(gapv2);
    const orientationObject = $3ba822808b700e2b$var$createResponsiveOrientationObject(orientation);
    const wrappedChildContentObject = $3ba822808b700e2b$var$createResponsiveWrappedChildContentObject(wrappedChildContent);
    const justifyContentObject = $3ba822808b700e2b$var$createResponsiveJustifyContentObject(justifyContent);
    // css() calls must be inline for Compiled CSS static analysis
    const listStyle = null;
    const orientationStyle = null;
    const wrappedChildContentStyle = null;
    const justifyContentStyle = null;
    const renderListItems = $3ba822808b700e2b$var$createRenderListItems(listType);
    const ListTypeComponent = listType || 'ul';
    return /*#__PURE__*/ (0, $7VQPk.jsx)(ListTypeComponent, {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp17fv _19wg1im9 _pdlm1bxm",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            "_1hmt1wth _16wj1p3b _1q2jw4vn",
            "_1e0c1txw _2lx21luv _1lp71gkj _1ini19q3",
            "_1e0c1txw _1n261g80 _zkhy1g80 _45zz1g80",
            "_1bahown3 _e8gh2fwo _msup1t9b"
        ]),
        style: {
            "--_1lzn2ck": (0, $6ZVlx.default)('var(--ds-space-' + gapObject.mobile + ')'),
            "--_9e7v2h": (0, $6ZVlx.default)('var(--ds-space-' + gapObject.tablet + ')'),
            "--_1xgygbw": (0, $6ZVlx.default)('var(--ds-space-' + gapObject.desktop + ')'),
            "--_1kdc6hg": (0, $6ZVlx.default)(orientationObject.mobile === 'horizontal' ? 'row' : 'column'),
            "--_1tsuz96": (0, $6ZVlx.default)(orientationObject.tablet === 'horizontal' ? 'row' : 'column'),
            "--_1m7tih1": (0, $6ZVlx.default)(orientationObject.desktop === 'horizontal' ? 'row' : 'column'),
            "--_vie9y1": (0, $6ZVlx.default)(justifyContentObject.mobile),
            "--_1rrey82": (0, $6ZVlx.default)(justifyContentObject.tablet),
            "--_pc7561": (0, $6ZVlx.default)(justifyContentObject.desktop)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "listItems",
            wrapperComponent: renderListItems
        })
    });
};
var $3ba822808b700e2b$export$2e2bcd8739ae039 = $3ba822808b700e2b$var$UniformListV2;

});
parcelRegister("iQZ6I", function(module, exports) {
$parcel$export(module.exports, "ListItemNumber", function () { return $365d9b22a97d5b30$export$448080ad20b09ab8; });
/* list-item-number.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $365d9b22a97d5b30$export$448080ad20b09ab8 = (props)=>{
    const { value: value } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3ickbl _1bsbckbl _2rko1osq _11q7cafw _1e0c1txw _1bah1h6o _4cvr1h6o _syazculw _y3gn1h6o _ect41vau _1wybgktf _zg8l4jg8 _k48p1fw0 _vwz4183y"
        ]),
        style: {
            "--_1bnl49": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue200')),
            "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900')),
            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
        },
        children: value
    });
};

});


parcelRegister("5c1uT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd7e060da4850d2d$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $behZZ = parcelRequire("behZZ");

var $lAAJP = parcelRequire("lAAJP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fd7e060da4850d2d$var$UniformLogos = (intakeProps)=>{
    const { title: title, logos: logos } = (0, $lAAJP.flattenLogoProps)(intakeProps);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $behZZ.Logos), {
        title: title,
        logos: logos
    });
};
var $fd7e060da4850d2d$export$2e2bcd8739ae039 = $fd7e060da4850d2d$var$UniformLogos;

});
parcelRegister("behZZ", function(module, exports) {
$parcel$export(module.exports, "Logos", function () { return $511c14fce74817fd$export$c847549a613b9060; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $jElRc = parcelRequire("jElRc");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $6ltia = parcelRequire("6ltia");

var $i4BST = parcelRequire("i4BST");

var $faxYF = parcelRequire("faxYF");
// Per GWP-11501 design spec:
// - All logos render in a 32px-tall container at every breakpoint.
// - Default max width is 140px; logos that need more horizontal room (e.g.
//   HarperCollins) can opt into the wider 240px slot via `wider: true`.
//
// Note (per Dan's dev notes on GWP-11501):
// - Items #6 (remove play/pause for reduced motion) and #7 (padding rules
//   when the button is removed) are deferred — there is an ongoing Slack
//   discussion about the right reduced-motion treatment, so we keep the
//   existing PlayPauseControls behavior.
// - Item #8 (N100 background option) is handled at the Uniform
//   `blockContainer` level (which already exposes Neutral Light 100), not
//   on the Logos pattern itself.
const $511c14fce74817fd$var$LOGO_HEIGHT_PX = 32;
const $511c14fce74817fd$var$LOGO_MAX_WIDTH_PX = 140;
const $511c14fce74817fd$var$LOGO_WIDER_MAX_WIDTH_PX = 240;
const $511c14fce74817fd$var$hasDarkParentBackground = (parentBackgroundColor)=>{
    if (!parentBackgroundColor || parentBackgroundColor === 'transparent') return false;
    try {
        return (0, $6ltia.isDarkColor)(parentBackgroundColor);
    } catch  {
        return false;
    }
};
const $511c14fce74817fd$var$getLogoFilter = (isDarkParentBackground, isDarkTheme, isWacRefresh)=>{
    if (isDarkParentBackground) return 'brightness(0) invert(1)';
    if (isDarkTheme) return 'brightness(0) invert(1) opacity(.725)';
    if (isWacRefresh) return 'brightness(0) saturate(100%) invert(20%) sepia(5%) saturate(755%) hue-rotate(185deg) brightness(98%) contrast(86%)';
    return 'grayscale(100%) brightness(66%)';
};
/**
 * Measures the logos list and computes:
 * - `maxWidth`: a pixel budget to apply to the <ul> so flex-wrap distributes
 *   logos into evenly-sized rows (same row count, balanced widths).
 * - `overflowsViewport`: true when all logos can't fit on one row, meaning the
 *   marquee should be shown instead.
 */ function $511c14fce74817fd$var$useBalancedMaxWidth(logoCount) {
    const wrapperRef = (0, $1oC0p.useRef)(null);
    const listRef = (0, $1oC0p.useRef)(null);
    const [containerWidth, setContainerWidth] = (0, $1oC0p.useState)(0);
    const [measured, setMeasured] = (0, $1oC0p.useState)({
        widths: [],
        gap: 0
    });
    // Mirrors the last overflowsViewport result. Used to add a buffer when
    // switching back from marquee to logos — see the useMemo below.
    const overflowsViewportRef = (0, $1oC0p.useRef)(false);
    // Watch the wrapper div width. We observe the wrapper (not the <ul>) so
    // that applying maxWidth to the <ul> doesn't trigger the observer again.
    (0, $1oC0p.useEffect)(()=>{
        const el = wrapperRef.current;
        if (!el) return;
        const observer = new ResizeObserver(([entry])=>{
            // Ignore zero-width reports — the wrapper can briefly report zero
            // when hidden. Keep the last real width so overflowsViewport stays stable.
            if (entry && entry.contentRect.width > 0) setContainerWidth(entry.contentRect.width);
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    // Measure each logo's natural width and the gap between them.
    // Temporarily removes maxWidth and forces nowrap so all items are on one
    // row, giving accurate individual widths and a correct gap reading.
    (0, $1oC0p.useEffect)(()=>{
        const ul = listRef.current;
        if (!ul) return;
        const measure = ()=>{
            const prevMaxWidth = ul.style.maxWidth;
            const prevMargin = ul.style.margin;
            const prevFlexWrap = ul.style.flexWrap;
            ul.style.maxWidth = 'none';
            ul.style.margin = '0';
            // Force all items onto one row so the gap between adjacent items
            // can be measured. The CSS class sets width:100% which overrides
            // width:max-content, so we use flexWrap:nowrap instead.
            ul.style.flexWrap = 'nowrap';
            try {
                const items = Array.from(ul.querySelectorAll(':scope > li'));
                const widths = items.map((el)=>el.getBoundingClientRect().width);
                // Skip if all widths are zero — the list is hidden and not giving real values.
                if (widths.length > 0 && widths.every((w)=>w === 0)) return;
                // Detect same-row items by vertical overlap rather than exact
                // top equality — alignItems:center means different-height logos
                // have different top values even when on the same row.
                let gap = 0;
                const r0 = items[0]?.getBoundingClientRect();
                const r1 = items[1]?.getBoundingClientRect();
                if (r0 && r1 && r1.top < r0.bottom && r0.top < r1.bottom) gap = r1.left - r0.right;
                setMeasured({
                    widths: widths,
                    gap: gap
                });
            } finally{
                ul.style.maxWidth = prevMaxWidth;
                ul.style.margin = prevMargin;
                ul.style.flexWrap = prevFlexWrap;
            }
        };
        // Don't re-measure while the marquee is showing — we already know logos
        // overflow, and hidden items can return unreliable widths.
        if (overflowsViewportRef.current) return;
        // Wait for images to load before measuring (they affect logo widths).
        let cancelled = false;
        const images = Array.from(ul.querySelectorAll('img'));
        const unloaded = images.filter((img)=>!img.complete);
        if (unloaded.length === 0) measure();
        else Promise.all(unloaded.map((img)=>new Promise((res)=>img.addEventListener('load', ()=>res(), {
                    once: true
                })))).then(()=>{
            if (!cancelled) measure();
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        logoCount,
        containerWidth
    ]);
    const { maxWidth: maxWidth, overflowsViewport: overflowsViewport } = (0, $1oC0p.useMemo)(()=>{
        const result = (maxWidth, overflowsViewport)=>{
            overflowsViewportRef.current = overflowsViewport;
            return {
                maxWidth: maxWidth,
                overflowsViewport: overflowsViewport
            };
        };
        const { widths: widths, gap: gap } = measured;
        if (!containerWidth || widths.length === 0) return result(undefined, false);
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0) + gap * (widths.length - 1);
        // Everything fits on one row — no constraint needed.
        // Add a one-gap buffer when switching back from marquee to logos to
        // prevent flickering when resizing near the transition point.
        const clearanceNeeded = overflowsViewportRef.current ? gap : 0;
        if (totalWidth <= containerWidth - clearanceNeeded) return result(undefined, false);
        // Greedily split logos into rows given a max row pixel width budget.
        // Returns the pixel width of each row.
        const splitIntoRowWidths = (budget)=>{
            const rowWidths = [];
            let rowWidth = 0;
            for (const w of widths){
                const needed = rowWidth === 0 ? w : gap + w;
                if (rowWidth > 0 && rowWidth + needed > budget) {
                    rowWidths.push(rowWidth);
                    rowWidth = w;
                } else rowWidth += needed;
            }
            rowWidths.push(rowWidth);
            return rowWidths;
        };
        const currentRowWidths = splitIntoRowWidths(containerWidth);
        const numRows = currentRowWidths.length;
        if (numRows <= 1) return result(undefined, true);
        // Score by the minimum row width — maximising it ensures no row is
        // disproportionately short.
        const score = (rowWidths)=>Math.min(...rowWidths);
        // Candidate budgets: pixel width of every possible contiguous subsequence
        // of logos. These are the only meaningful flex-wrap split points.
        const candidateBudgets = new Set();
        for(let start = 0; start < widths.length; start++){
            let rowW = 0;
            for(let end = start; end < widths.length; end++){
                rowW += (widths[end] ?? 0) + (end > start ? gap : 0);
                candidateBudgets.add(rowW);
            }
        }
        let best;
        let bestScore = score(currentRowWidths);
        for (const budget of candidateBudgets){
            if (budget >= containerWidth) continue;
            const rowWidths = splitIntoRowWidths(budget);
            if (rowWidths.length !== numRows) continue;
            const s = score(rowWidths);
            if (s > bestScore) {
                bestScore = s;
                best = `${budget}px`;
            }
        }
        return result(best, true);
    }, [
        measured,
        containerWidth
    ]);
    return {
        maxWidth: maxWidth,
        overflowsViewport: overflowsViewport,
        wrapperRef: wrapperRef,
        listRef: listRef
    };
}
const $511c14fce74817fd$export$c847549a613b9060 = ({ title: title, logos: logos })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const [parentBackgroundRef, parentBackgroundColor] = (0, $faxYF.useStylePropertyVariableValueFromParent)('--wac-background-color');
    const parentBackgroundDivRef = parentBackgroundRef;
    const isDarkParentBackground = $511c14fce74817fd$var$hasDarkParentBackground(parentBackgroundColor);
    // Declared here (not inside the isWacRefresh block) so hooks are never called conditionally.
    // Default to true (running); correct to false after mount if the user prefers reduced motion.
    // We do this in useEffect (not useState initializer) to avoid SSR/hydration mismatches,
    // since window.matchMedia is not available on the server.
    const [marqueeRunning, setMarqueeRunning] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) setMarqueeRunning(false);
    }, []);
    const logoFilterStyle = {
        filter: $511c14fce74817fd$var$getLogoFilter(isDarkParentBackground, isDarkTheme, isWacRefresh)
    };
    const { maxWidth: maxWidth, overflowsViewport: overflowsViewport, wrapperRef: wrapperRef, listRef: listRef } = $511c14fce74817fd$var$useBalancedMaxWidth(logos.length);
    const showMarquee = isWacRefresh && overflowsViewport;
    const logosComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: wrapperRef,
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            ref: listRef,
            style: maxWidth ? {
                maxWidth: maxWidth,
                margin: '0 auto'
            } : undefined,
            className: (0, $2jatx.default)([
                "_1e0c1txw _1n261g80 _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o",
                isWacRefresh && "_gy1pxncg _4t3izwfg _99s6xncg _ikjdxncg _1plridpf"
            ]),
            children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        isWacRefresh && "_4t3i1osq _1e0c1txw _4cvr1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: logo.src,
                        alt: logo.alt,
                        className: (0, $2jatx.default)([
                            "_4t3izwfg _1bsb1wug",
                            isWacRefresh ? "_4t3izwfg _1bsb1wug _p12f4dhv _5ral1f51 _rsuf1h6o" : logo.heightPercentage ? "_4t3in8c9" : logo.width && "_1bsb1y7t _4t3i1wug"
                        ]),
                        style: {
                            ...logoFilterStyle,
                            "--_120hwu8": (0, $6ZVlx.default)(logo.wider ? `${$511c14fce74817fd$var$LOGO_WIDER_MAX_WIDTH_PX}px` : `${$511c14fce74817fd$var$LOGO_MAX_WIDTH_PX}px`),
                            "--_mpa0nt": (0, $6ZVlx.default)(logo.heightPercentage, "%"),
                            "--_daj5q9": (0, $6ZVlx.default)(logo.width, "px")
                        }
                    })
                }, index))
        })
    });
    if (isWacRefresh) {
        const marqueeLogos = [
            ...logos,
            ...logos,
            ...logos,
            ...logos
        ];
        const originalCount = logos.length;
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: parentBackgroundDivRef,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1rjcxncg"
                ]),
                children: [
                    showMarquee ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _2lx21bp4 _zulp1ejb"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq _p12f1s5k _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1reo15vq _1nwpfglr"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                    className: (0, $2jatx.default)([
                                        "_1bsb1osq _o5721q9c",
                                        "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1bsb1ns9",
                                        "_gy1pxncg _4t3izwfg _99s6xncg _ikjdxncg _1plridpf",
                                        "_y44vhu9l _1y0c1sq4"
                                    ]),
                                    style: {
                                        "--_1cyjtg3": (0, $6ZVlx.default)(marqueeRunning ? 'running' : 'paused')
                                    },
                                    children: marqueeLogos.map((logo, index)=>{
                                        const isOriginal = index < originalCount;
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                            "aria-hidden": !isOriginal,
                                            className: (0, $2jatx.default)([
                                                "_4t3i1osq _1e0c1txw _4cvr1h6o"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                                src: logo.src,
                                                alt: logo.alt,
                                                className: (0, $2jatx.default)([
                                                    "_4t3i1osq _1bsb1ns9 _5ral1f51 _rsuf1h6o",
                                                    "_p12f4dhv"
                                                ]),
                                                style: {
                                                    ...logoFilterStyle,
                                                    "--_120hwu8": (0, $6ZVlx.default)(logo.wider ? `${$511c14fce74817fd$var$LOGO_WIDER_MAX_WIDTH_PX}px` : `${$511c14fce74817fd$var$LOGO_MAX_WIDTH_PX}px`)
                                                }
                                            })
                                        }, index);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0cglyw _1fj21osq _1lmq1txw _1rdhh9n0"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                                    isPlaying: marqueeRunning,
                                    onToggle: ()=>setMarqueeRunning((r)=>!r)
                                })
                            })
                        ]
                    }) : logosComponent,
                    showMarquee && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: wrapperRef,
                        "aria-hidden": true,
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _1e02idpf _rjxpidpf _3um015vq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            ref: listRef,
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1n261g80 _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o",
                                "_gy1pxncg _4t3izwfg _99s6xncg _ikjdxncg _1plridpf"
                            ]),
                            children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_4t3i1osq _1e0c1txw _4cvr1h6o"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                        src: logo.src,
                                        alt: logo.alt,
                                        className: (0, $2jatx.default)([
                                            "_4t3izwfg _1bsb1wug"
                                        ])
                                    })
                                }, index))
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: parentBackgroundDivRef,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpoahv _pdlmxncg _y3gn1h6o"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: title
            }),
            logosComponent
        ]
    });
};
const $511c14fce74817fd$var$regularLogoStyles = null;
// visibility:hidden (not display:none) so ResizeObserver and
// getBoundingClientRect() still return real dimensions.
const $511c14fce74817fd$var$measurementOnlyStyles = null;
const $511c14fce74817fd$var$logosWrapperStyle = null;
const $511c14fce74817fd$var$logosContainerStyle = null;
const $511c14fce74817fd$var$marqueeLogoStyles = null;
const $511c14fce74817fd$var$marqueeListItemStyles = null;
const $511c14fce74817fd$var$listStyles = null;
// Per GWP-11501 (#1, #2, #3, #9): a single 32px-tall row with 80px between
// logos at every breakpoint. Updated to 64px gap with WEBPLAN-324.
//
// The columnGap overrides are repeated at the same breakpoints used in
// logosContainerStyle so that they win at every viewport size without
// relying on !important. CSS specificity for a media-query rule is equal
// to the same rule outside a media query, so the last declaration in source
// order wins — and since wacRefreshSizeStyles is applied after
// logosContainerStyle in the css array, these values take effect correctly.
const $511c14fce74817fd$var$wacRefreshSizeStyles = null;
const $511c14fce74817fd$var$marqueeContainerStyles = null;
const $511c14fce74817fd$var$marqueeListContainerStyles = null;
const $511c14fce74817fd$var$animationKeyframesStyles = null;
const $511c14fce74817fd$var$marqueeControlsContainerStyles = null;

});


parcelRegister("f8O2Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $684b9f8001657ce7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $jE3Ci = parcelRequire("jE3Ci");
const $684b9f8001657ce7$export$d64e2f97651f7f4d = (props)=>{
    const appearance = props.color === 'red' ? 'danger' : props.color || 'neutral';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
        appearance: appearance,
        text: props.text
    });
};
var $684b9f8001657ce7$export$2e2bcd8739ae039 = $684b9f8001657ce7$export$d64e2f97651f7f4d;

});

parcelRegister("1bORF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8b242b5b67c6eb2$export$2e2bcd8739ae039; });
/* marketo-form.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-physical-properties */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $3riD8 = parcelRequire("3riD8");

var $9rnwe = parcelRequire("9rnwe");

var $cv6Xk = parcelRequire("cv6Xk");

var $66KLr = parcelRequire("66KLr");
const $b8b242b5b67c6eb2$export$980a56d8a39cbfab = 'Marketo form';
const $b8b242b5b67c6eb2$var$LOGGED_IN_PREFILL_WHITEPAPER_FORM_ID = 1583;
const $b8b242b5b67c6eb2$var$marketoErrorIconBackground = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23AE2A19'/%3E%3Cpath d='M12 5.75v8' stroke='%23FFFFFF' stroke-width='2.25' stroke-linecap='round'/%3E%3Ccircle cx='12' cy='17.75' r='1.35' fill='%23FFFFFF'/%3E%3C/svg%3E\")";
const $b8b242b5b67c6eb2$var$marketoFormWrapperCss = null;
const $b8b242b5b67c6eb2$var$marketoFormContainerCss = null;
const $b8b242b5b67c6eb2$var$primaryAltMarketoButtonCss = null;
const $b8b242b5b67c6eb2$var$japaneseNameOrderCss = null;
const $b8b242b5b67c6eb2$var$messageCss = null;
const $b8b242b5b67c6eb2$var$loggedInContactCss = null;
const $b8b242b5b67c6eb2$var$zeroMargin = null;
const $b8b242b5b67c6eb2$var$UniformMarketoForm = ({ label: label, successButtonText: successButtonText, successButtonUrl: successButtonUrl, alignment: alignment = 'start', buttonVariant: buttonVariant = 'primary', ...ids })=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const hasFiredTerminalAnalyticsRef = (0, $1oC0p.useRef)(false);
    const [prefilledContactInfo, setPrefilledContactInfo] = (0, $1oC0p.useState)();
    const [isEditingPrefilledContact, setIsEditingPrefilledContact] = (0, $1oC0p.useState)(false);
    const intl = (0, $8e22h.default)();
    const isJapaneseLocale = intl.locale.toLowerCase().split(/[-_]/)[0] === 'ja';
    const { isProduction: isProduction } = (0, $9rnwe.useEnvironmentInfo)();
    const loggedInUser = (0, $3riD8.useLoggedInUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const marketoConfig = (0, $1oC0p.useMemo)(()=>(0, $66KLr.getMarketoConfig)(ids, isProduction), [
        ids.formId,
        ids.formIdStg,
        isProduction
    ]);
    const marketoLocalization = (0, $1oC0p.useMemo)(()=>(0, $cv6Xk.getMarketoFormLocalization)(intl), [
        intl
    ]);
    const { status: status, prefillContactInfo: prefillContactInfo, revealContactFields: revealContactFields } = (0, $66KLr.useMarketoForm)({
        containerRef: containerRef,
        config: marketoConfig,
        localization: marketoLocalization
    });
    const analyticsLabel = label?.trim() || $b8b242b5b67c6eb2$export$980a56d8a39cbfab;
    const successMessage = intl.formatMessage({
        id: 'uniform.marketoForm.successMessage',
        defaultMessage: 'Thank you for your submission!'
    });
    const errorMessage = intl.formatMessage({
        id: 'uniform.marketoForm.errorMessage',
        defaultMessage: 'An error occurred while processing this request. Please try again.'
    });
    const shouldShowSuccessButton = Boolean(successButtonText && successButtonUrl);
    const alignmentCss = null;
    (0, $1oC0p.useEffect)(()=>{
        const name = loggedInUser.name?.trim();
        const email = loggedInUser.email?.trim();
        if (status !== 'form') {
            setPrefilledContactInfo(undefined);
            setIsEditingPrefilledContact(false);
            return;
        }
        if (marketoConfig.formId !== $b8b242b5b67c6eb2$var$LOGGED_IN_PREFILL_WHITEPAPER_FORM_ID || !loggedInUser.isUserLoggedIn || !name || !email) {
            revealContactFields();
            setPrefilledContactInfo(undefined);
            setIsEditingPrefilledContact(false);
            return;
        }
        if (prefillContactInfo({
            name: name,
            email: email
        })) {
            setPrefilledContactInfo({
                name: name,
                email: email
            });
            setIsEditingPrefilledContact(false);
        }
    }, [
        loggedInUser.email,
        loggedInUser.isUserLoggedIn,
        loggedInUser.name,
        marketoConfig.formId,
        prefillContactInfo,
        revealContactFields,
        status
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (status !== 'success' && status !== 'error') {
            hasFiredTerminalAnalyticsRef.current = false;
            return;
        }
        if (hasFiredTerminalAnalyticsRef.current) return;
        hasFiredTerminalAnalyticsRef.current = true;
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'submitted',
            actionSubject: 'form',
            actionSubjectId: 'marketoForm',
            source: 'uniform',
            attributes: {
                label: analyticsLabel,
                status: status,
                formId: marketoConfig.formId,
                orgId: marketoConfig.orgId
            }
        }).fire();
    }, [
        analyticsLabel,
        createAnalyticsEvent,
        marketoConfig.formId,
        marketoConfig.orgId,
        status
    ]);
    const shouldShowFormContainer = status === 'loading' || status === 'form';
    const shouldShowPrefilledContact = status === 'form' && prefilledContactInfo && !isEditingPrefilledContact;
    const loggedInAsText = intl.formatMessage({
        id: 'uniform.marketoForm.loggedInAs',
        defaultMessage: "You're logged in as:"
    });
    const updateContactInfoText = intl.formatMessage({
        id: 'uniform.marketoForm.updateContactInfo',
        defaultMessage: 'Update contact info'
    });
    const handleUpdateContactInfo = ()=>{
        revealContactFields();
        setIsEditingPrefilledContact(true);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'updateContactInfo',
            source: 'uniformMarketoForm',
            attributes: {
                label: updateContactInfoText
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "uniform-marketo-form",
            className: (0, $2jatx.default)([
                "_1bsb1osq _q3s11pfd _1qgo1pfd",
                "_1ic2oues _1nuuoues _1jl2oues _iz0loues"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
            },
            children: [
                shouldShowPrefilledContact && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_syaz1pfd _6rthoahv _1e0c1txw _2lx21bp4 _zulppxbi"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: loggedInAsText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "body-md"
                            ]),
                            children: [
                                prefilledContactInfo.name,
                                /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                prefilledContactInfo.email
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: updateContactInfoText,
                            type: "inline",
                            href: '#_',
                            onClick: (event)=>{
                                event.preventDefault();
                                handleUpdateContactInfo();
                            },
                            "aria-label": "update contact info"
                        })
                    ]
                }),
                shouldShowFormContainer && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    "aria-busy": status === 'loading',
                    "data-testid": "uniform-marketo-form-container",
                    ref: containerRef,
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _syaz1pfd _ect4z4z1 _3nnsusvi _zl51pxbi _1yrb1txw _f5ehvrvc _4yf31g80 _74951osq _1xkkewfl _17nwewfl _1vo1aq80 _1tvq1pfd _il3sz4z1 _bot3usvi _rdu01ule _1ko91osq _1jbv1osq _1voj12pl _ausx1rya _92hiewfl _1d9kewfl _c40t1osq _1kw1agmp _1wvqgrf3 _5wwygrf3 _1j2jgrf3 _1gqdgrf3 _k8hoidpf _xidjidpf _1gnkkb7n _9au0cs5v _1qpc11wp _nr3o1gsb _vr1ihqbx _1jpqhqbx _j2e8qfx8 _1ofcqfx8 _1v1vqfx8 _2r3sqfx8 _1h7b1sen _1ods1sen _10l51sen _7pra1sen _1yxr18b4 _1b4b18b4 _7wa11y6m _n1zf1y6m _1ulfusvi _9e84usvi _1s6husvi _1vag1txw _kguk1txw _1s571txw _1ak51bp4 _1d1a1bp4 _1we81bp4 _ml8xagmp _1t9vagmp _ys84agmp _178ugrf3 _s3uzgrf3 _e66ogrf3 _rv3pgrf3 _risjgrf3 _8et8grf3 _1phtgrf3 _bipugrf3 _a469grf3 _10gkgrf3 _1u0cgrf3 _x9n8grf3 _1rzcgrf3 _2rlogrf3 _vxy5grf3 _1obgewfl _1xmwewfl _10cmewfl _2h9vewfl _nuteewfl _15fbewfl _1e2oaq80 _1y61aq80 _1ul7aq80 _q4b61y6m _1efiusvi _zus81x3z _iy5r1ule _1f61agmp _ip93svw9 _10pzoxwj _1idvbfng _10ce1k92 _vqajsz9k _1prugrf3 _1xjtgrf3 _1b4wgrf3 _slr3grf3 _5ql5aq80 _ymovglyw _1snkglyw _16q6glyw _sfpgglyw _1hl9glyw _1okcglyw _kh74uftu _ajpyuftu _1cefuftu _pmsluftu _w1rtuftu _1xjiuftu _gokr42cd _1ofw42cd _rvwm42cd _1gaw42cd _eilb42cd _1wju42cd _1jzl1ylz _1aid1ylz _yw7f1ylz _y1jw1ylz _i3531ylz _thhq1ylz _cyxqusvi _vz6susvi _hfycusvi _1uq3usvi _1sv8usvi _1fjwusvi _xkkv1x3z _16ew1x3z _1t3y1x3z _13kw1x3z _1g3e1x3z _oi3z1x3z _1xzm1ule _1eip1ule _2qd91ule _1dcp1ule _186i1ule _cjrp1ule _sglbsvw9 _1xzwsvw9 _11cdsvw9 _j6pwsvw9 _1isesvw9 _18k9svw9 _17zq1nn1 _8sq41nn1 _3n9w1nn1 _14zz1nn1 _23kb1nn1 _188m1nn1 _tr11grf3 _wcpugrf3 _6mhbgrf3 _1g86grf3 _1xn1grf3 _1gtngrf3 _x503grf3 _1nilgrf3 _1e8kgrf3 _39nxgrf3 _1tiggrf3 _32vjgrf3 _1e4tgrf3 _s61dgrf3 _cuxigrf3 _cjn4grf3 _1oxagrf3 _ty7qgrf3 _16f5grf3 _1njngrf3 _l6pogrf3 _1bv6grf3 _fky2grf3 _72gbgrf3 _f4i31osq _1g8z1osq _yvpp1osq _1ob61osq _yd261osq _vb781osq _a1wv1jfw _c2cu1jfw _1kck1jfw _vj9u1jfw _1vya1jfw _ouuu1jfw _siznidpf _168hidpf _z9cwidpf _1tfiidpf _7jpdidpf _197iidpf _10bs199u _1x5t199u _riyg199u _1f81199u _1hkl199u _1vzg199u _4svtaq80 _17faaq80 _1vptaq80 _1o9qaq80 _17b1aq80 _pu15aq80 _ouuu1epz _1npm1a66 _jtkj1e54 _1sthq0nh _1l4y1vge _1gfrmgnk _152q1u5s _6aol1kev _jfv7u7mq _1shdu7mq _yz8d1nn1 _1wff1nn1 _8oqhkb7n _v2ivkb7n _plbyfb2h _1a3lfb2h _5yd8fb2h _1utr1ju4 _1koa1ju4 _19k11ju4 _obqn1r31 _1xtg1r31 _acpa1r31 _1thcglyw _1o7rglyw _q8heglyw _18tr1o36 _5a4l1o36 _1kzr1o36 _1uqhu7mq _1x8xu7mq _1r4psvw9 _1g8fsvw9 _swgcoqnp _mu2doqnp _zez41nn1 _1y2e1nn1 _1djn1cby _2xx61cby _13na1b66 _1r4k1b66 _eo21aq80 _han1fb2h _1l5gfb2h _n40u1r31 _3scl1r31 _1m2j8stv _1ng58stv _nxonnqa1 _e940nqa1 _6esp1y6m _jxqou2gc _1mz711p5 _h3s8ap22 _1fhd1b66 _1pptu2gc _1hbfaq80 _gjlnglyw _15yeuftu _14mb1ssb _1fdlmgnk _p2q7m07m _s2dysr7k _6z2v1b66 _1jfrusvi _jc2ftlke _12hq1n7u _nokiidpf _1mcpidpf _kdsuf6fq _3qydf6fq _a2s61cvy _1o4rf6fq _1yki1h6o _amu01h6o _1mgnf6fq _kmukfb2h _ui87fb2h _11h7glyw _kwyq1r31 _b21jglyw _cjyx1o36 _10csm8mt _gxmlv77o _15pkfb2h _gd6fd60m _mxv8fb2h _l27w1y6m _1aj51pfd _1jzwtlke _1tqo116y _1focf6fq _ekay1y6m _4otj1ule _14o8svw9 _1jsh1j6v _t5i81nn1 _1td51k8s _vdx8grf3 _1wqqgrf3 _ra68grf3 _vvf5grf3 _zsdmaq80 _9ynv1h6o _k7o0u2gc _1ieg11p5 _wlrd1pjz _ghtn1b66 _1fcku2gc _1jrgaq80 _1frfglyw _x4efuftu _cckpsr7k _1mkc1ssb _dq5xusvi _1e8rtlke _244r1n7u _1ee2gktf _1l8vgrf3 _160kgrf3 _1f88grf3 _1b5rgrf3 _odrkgktf _1n6o1h6o _1bra1h6o _mxshgktf _ycbv5hrz _mdrj1ssb _17nub3bt _13n41ule _1kdz19bv _tbfa1u4m _bpak19bv _9whrfb2h _1fv1fb2h _12sxglyw _lwe01r31 _pajgglyw _v0hx1o36 _1xvqm8mt _7d6fv77o _4af7fb2h _1f2n1h7a _17zyly96 _17xj13gf _ti1hp4k8 _1tzip4k8 _k92v13gf _93hc1pfd _k9di1h6o _1d83tlke _etl3116y _3qoegktf _1vy81ule _1ob5pxbi _8mrhb4wl _1ng01osq _1ljbgrf3 _1mnugrf3 _ad36grf3 _1ktsgrf3 _14ru1ule _44nq1osq _c9xe1h6o _eumsfb2h _8x6t1n3h _t1hq1mv1 _60zfusvi _mfn3uftu _8suttlke _rx16116y _1an5svw9 _13r41k92 _21l3bfng _1lx11h6o _17tn1k8s _yie01feq _uyqt1ylp _5oea68cl _jhhut7ji _1mph1h6o _1sks1r31 _u2vqglyw _1ecsnqa1 _1s5l1dxf _v5jd1me0 _vds61r31 _v6hwglyw _wknb1o36 _15oj1qgu _n27s1b66 _1epc1o2u _19ee1rfp _1s6q1rfp _1jdemzrp _1yplmzrp _q4j7uftu _1pzouftu _1aa113gf _151a13gf _1rseglyw _he5cglyw _1r1g1rfp _1jkv1rfp _s0291d19 _1t1rglyw _1xhyv77o _tq3x1q9y _1stu1nu9 _huph1h90 _6s0s1h90 _c2ov1b66 _98csqete _1ga71h90 _783b1h90 _1d96mzrp _x2omagmp _j3slagmp _8b91idpf _4m5jagmp _gqg31mkj _8k98svw9 _9vq5oqnp _k9201nn1 _12n11cby _143dgrf3 _1d6ggrf3 _60d0grf3 _p5ywgrf3 _w2kagrf3 _1jzsgrf3 _13t0grf3 _1jfagrf3 _tegsagmp _11v2agmp _1ymz1mkj _fbw91mkj _1npn1mkj _oq42p6ku _1n53p6ku _ilqzp6ku _u1sjnfgu _1lk7nfgu _16qxnfgu _yad5nfgu _b5ry1uww _e5ti1uww _628r1uww _1h421uww _xe2emgnk _10g2mgnk _1n1gmgnk _1hkfmgnk _17ue7eu9 _1k7q7eu9 _372u7eu9 _q97t7eu9 _1yci1t61 _t0pt1t61 _kq9u1t61 _1ut81t61 _mn0gnfgu _1w1951lc _vg6hmgnk _jvnu7eu9 _i0le1t61",
                        isJapaneseLocale && "_1gnkidpf _xidjkb7n",
                        buttonVariant === 'primary_alt' && "_eums4xxr _mfn31x3z _v5jdsjrr"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                        "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                        "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_1aetymw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light500')),
                        "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill')),
                        "--_pysqvm": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.150ms')),
                        "--_kqkuu4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-in-out')),
                        "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900')),
                        "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                        "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                        "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron')),
                        "--_t0cjdu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron200'))
                    }
                }),
                status === 'success' && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    role: "status",
                    className: (0, $2jatx.default)([
                        "_syaz1pfd _18s81yj3"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: successMessage
                        }),
                        shouldShowSuccessButton && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            href: successButtonUrl,
                            variant: buttonVariant,
                            dataEventProps: {
                                'data-product-key': 'uniform',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'form',
                                'data-event': 'clicked'
                            },
                            children: successButtonText
                        })
                    ]
                }),
                status === 'error' && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_syaz1pfd _18s81yj3",
                        "body-md"
                    ]),
                    role: "alert",
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: errorMessage
                })
            ]
        })
    });
};
var $b8b242b5b67c6eb2$export$2e2bcd8739ae039 = $b8b242b5b67c6eb2$var$UniformMarketoForm;

});
parcelRegister("cv6Xk", function(module, exports) {
$parcel$export(module.exports, "getMarketoFormLocalization", function () { return $89cd886b8ddae4f9$export$46fc5cbe6cbfad04; });

var $fnHPc = parcelRequire("fnHPc");

var $epray = parcelRequire("epray");
const $89cd886b8ddae4f9$var$messages = (0, $fnHPc.defineMessages)({
    firstNameLabel: {
        id: 'uniform.marketoForm.field.firstName.label',
        defaultMessage: 'First Name'
    },
    lastNameLabel: {
        id: 'uniform.marketoForm.field.lastName.label',
        defaultMessage: 'Last Name'
    },
    businessEmailLabel: {
        id: 'uniform.marketoForm.field.businessEmail.label',
        defaultMessage: 'Email'
    },
    businessEmailInstruction: {
        id: 'uniform.marketoForm.field.businessEmail.instruction',
        defaultMessage: 'Please enter your work email.'
    },
    companyLabel: {
        id: 'uniform.marketoForm.field.company.label',
        defaultMessage: 'Company'
    },
    jobTitleLabel: {
        id: 'uniform.marketoForm.field.jobTitle.label',
        defaultMessage: 'Job Title'
    },
    phoneLabel: {
        id: 'uniform.marketoForm.field.phone.label',
        defaultMessage: 'Work Phone #'
    },
    stateLabel: {
        id: 'uniform.marketoForm.field.state.label',
        defaultMessage: 'State'
    },
    requestTypeLabel: {
        id: 'uniform.marketoForm.field.requestType.label',
        defaultMessage: 'Request Type'
    },
    commentsLabel: {
        id: 'uniform.marketoForm.field.comments.label',
        defaultMessage: 'Comments'
    },
    departmentLabel: {
        id: 'uniform.marketoForm.field.department.label',
        defaultMessage: 'Department'
    },
    roleLabel: {
        id: 'uniform.marketoForm.field.role.label',
        defaultMessage: 'Role (C)'
    },
    personaRoleLabel: {
        id: 'uniform.marketoForm.field.personaRole.label',
        defaultMessage: 'Which best describes your role?'
    },
    opportunityDescriptionLabel: {
        id: 'uniform.marketoForm.field.opportunityDescription.label',
        defaultMessage: 'Your message'
    },
    companySizeLabel: {
        id: 'uniform.marketoForm.field.companySize.label',
        defaultMessage: 'Company Size'
    },
    departmentSizeLabel: {
        id: 'uniform.marketoForm.field.departmentSize.label',
        defaultMessage: 'Department Size'
    },
    productInterestLabel: {
        id: 'uniform.marketoForm.field.productInterest.label',
        defaultMessage: 'What are you primarily interested in?'
    },
    pickYourProductsLabel: {
        id: 'uniform.marketoForm.field.pickYourProducts.label',
        defaultMessage: 'Pick your Products'
    },
    physicalCopyRequestedLabel: {
        id: 'uniform.marketoForm.field.physicalCopyRequested.label',
        defaultMessage: 'Send a physical copy of the handbook (US Only)'
    },
    jsmUserCountLabel: {
        id: 'uniform.marketoForm.field.jsmUserCount.label',
        defaultMessage: 'Number of Agents'
    },
    countryLabel: {
        id: 'uniform.marketoForm.field.country.label',
        defaultMessage: 'Country'
    },
    selectCountryOption: {
        id: 'uniform.marketoForm.option.selectCountry',
        defaultMessage: 'Select...'
    },
    salesContactLabel: {
        id: 'uniform.marketoForm.field.salesContact.label',
        defaultMessage: "I'd like to be contacted by the Atlassian Sales team about Atlassian products and services.",
        description: 'Optional checkbox on a Marketo form requesting contact from the Atlassian Sales team.'
    },
    marketingConsentLabel: {
        id: 'uniform.marketoForm.field.marketingConsent.label',
        defaultMessage: 'Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.'
    },
    privacyPolicyLink: {
        id: 'uniform.marketoForm.privacyPolicy.link',
        defaultMessage: 'Privacy Policy'
    },
    privacyPolicyHtml: {
        id: 'uniform.marketoForm.field.privacyPolicy.html',
        defaultMessage: "By submitting this form, I acknowledge receipt of Atlassian's {privacyPolicyLink}."
    },
    submitButton: {
        id: 'uniform.marketoForm.submitButton',
        defaultMessage: 'Submit'
    },
    yesOption: {
        id: 'uniform.marketoForm.option.yes',
        defaultMessage: 'Yes'
    },
    noOption: {
        id: 'uniform.marketoForm.option.no',
        defaultMessage: 'No'
    },
    requiredValidation: {
        id: 'uniform.marketoForm.validation.required',
        defaultMessage: 'This field is required.'
    },
    emailValidation: {
        id: 'uniform.marketoForm.validation.email',
        defaultMessage: 'Please enter a valid email address'
    },
    emailRealAddressValidation: {
        id: 'uniform.marketoForm.validation.emailRealAddress',
        defaultMessage: 'Please type a real email address.'
    },
    businessEmailDomainValidation: {
        id: 'uniform.marketoForm.validation.businessEmailDomain',
        defaultMessage: 'Please enter your business email address. This form does not accept addresses from {domain}'
    }
});
const $89cd886b8ddae4f9$var$PRIVACY_POLICY_HREF = 'https://www.atlassian.com/legal/privacy-policy';
const $89cd886b8ddae4f9$var$addFieldAliases = (fields, aliases, field)=>{
    aliases.forEach((alias)=>{
        fields[(0, $epray.normalizeMarketoKey)(alias)] = field;
    });
};
const $89cd886b8ddae4f9$var$getPrivacyPolicyHtml = (intl)=>intl.formatMessage($89cd886b8ddae4f9$var$messages.privacyPolicyHtml, {
        privacyPolicyLink: `<a href="${$89cd886b8ddae4f9$var$PRIVACY_POLICY_HREF}" rel="noopener noreferrer" target="_blank">${intl.formatMessage($89cd886b8ddae4f9$var$messages.privacyPolicyLink)}</a>`
    });
const $89cd886b8ddae4f9$export$46fc5cbe6cbfad04 = (intl)=>{
    const fields = {};
    const firstName = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.firstNameLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.firstNameLabel)
    };
    const lastName = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.lastNameLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.lastNameLabel)
    };
    const businessEmail = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.businessEmailLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.businessEmailLabel),
        instructionHtml: intl.formatMessage($89cd886b8ddae4f9$var$messages.businessEmailInstruction),
        placeholder: ' '
    };
    const company = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.companyLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.companyLabel)
    };
    const jobTitle = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.jobTitleLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.jobTitleLabel)
    };
    const phone = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.phoneLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.phoneLabel)
    };
    const state = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.stateLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.stateLabel)
    };
    const requestType = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.requestTypeLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.requestTypeLabel)
    };
    const comments = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.commentsLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.commentsLabel)
    };
    const department = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.departmentLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.departmentLabel)
    };
    const role = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.roleLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.roleLabel)
    };
    const personaRole = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.personaRoleLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.personaRoleLabel)
    };
    const opportunityDescription = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.opportunityDescriptionLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.opportunityDescriptionLabel)
    };
    const companySize = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.companySizeLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.companySizeLabel)
    };
    const departmentSize = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.departmentSizeLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.departmentSizeLabel)
    };
    const productInterest = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.productInterestLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.productInterestLabel)
    };
    const pickYourProducts = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.pickYourProductsLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.pickYourProductsLabel)
    };
    const physicalCopyRequested = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.physicalCopyRequestedLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.physicalCopyRequestedLabel)
    };
    const jsmUserCount = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.jsmUserCountLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.jsmUserCountLabel)
    };
    const country = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.countryLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.countryLabel)
    };
    const salesContact = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.salesContactLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.salesContactLabel)
    };
    const marketingConsent = {
        label: intl.formatMessage($89cd886b8ddae4f9$var$messages.marketingConsentLabel),
        ariaLabel: intl.formatMessage($89cd886b8ddae4f9$var$messages.marketingConsentLabel)
    };
    const privacyPolicy = {
        html: $89cd886b8ddae4f9$var$getPrivacyPolicyHtml(intl)
    };
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'FirstName',
        'first_name',
        'firstname'
    ], firstName);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'LastName',
        'last_name',
        'lastname'
    ], lastName);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Email',
        'emailAddress',
        'businessEmail',
        'business_email'
    ], businessEmail);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Company',
        'companyName',
        'company_name'
    ], company);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Title',
        'JobTitle',
        'job_title'
    ], jobTitle);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Phone',
        'PhoneNumber',
        'phone_number'
    ], phone);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'State'
    ], state);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'RequestType',
        'Request_Type'
    ], requestType);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Comments'
    ], comments);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Department'
    ], department);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Role__c',
        'RoleC'
    ], role);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Persona_Role__c',
        'PersonaRoleC'
    ], personaRole);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Opportunity_Description__c',
        'OpportunityDescriptionC'
    ], opportunityDescription);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Company_Size_Range_from_User__c',
        'CompanySizeRangeFromUserC'
    ], companySize);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Department_Size__c',
        'DepartmentSizeC'
    ], departmentSize);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'ProductInterest__c',
        'ProductInterestC'
    ], productInterest);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'PickYourProducts',
        'Pick_Your_Products'
    ], pickYourProducts);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'formPhysicalCopyRequested',
        'PhysicalCopyRequested'
    ], physicalCopyRequested);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'JSMUserCountfromUser',
        'JSMUserCountFromUser'
    ], jsmUserCount);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'Country'
    ], country);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'mktoHandraiserInterest'
    ], salesContact);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'form_gmoiGranted',
        'gmoiGranted',
        'marketingConsent',
        'marketing_consent'
    ], marketingConsent);
    $89cd886b8ddae4f9$var$addFieldAliases(fields, [
        'AcknowledgePrivacyPolicySignUp',
        'AcknowledgePrivacyPolicySubmission',
        'form_privacyPolicy',
        'privacyPolicy',
        'privacy_policy'
    ], privacyPolicy);
    const selectCountry = intl.formatMessage($89cd886b8ddae4f9$var$messages.selectCountryOption);
    const yes = intl.formatMessage($89cd886b8ddae4f9$var$messages.yesOption);
    const no = intl.formatMessage($89cd886b8ddae4f9$var$messages.noOption);
    const required = intl.formatMessage($89cd886b8ddae4f9$var$messages.requiredValidation);
    const email = intl.formatMessage($89cd886b8ddae4f9$var$messages.emailValidation);
    const emailRealAddress = intl.formatMessage($89cd886b8ddae4f9$var$messages.emailRealAddressValidation);
    const businessEmailDomain = intl.formatMessage($89cd886b8ddae4f9$var$messages.businessEmailDomainValidation, {
        domain: '{{domain}}'
    });
    return {
        locale: intl.locale,
        submitButton: intl.formatMessage($89cd886b8ddae4f9$var$messages.submitButton),
        fields: fields,
        options: {
            '': selectCountry,
            'country:': selectCountry,
            'departmentsizec:': selectCountry,
            'jsmusercountfromuser:': selectCountry,
            true: yes,
            yes: yes,
            false: no,
            no: no
        },
        validationMessages: {
            'this field is required': required,
            'this field is required.': required,
            'must be valid email': email,
            'must be valid email.': email,
            'must be valid email. example@yourdomain.com': email,
            'please enter a valid email address': email,
            'please enter a valid email address.': email,
            'please type a real email address': emailRealAddress,
            'please type a real email address.': emailRealAddress,
            'please enter your business email address. this form does not accept addresses from': businessEmailDomain,
            'please enter your business email address. this form does not accept addresses from {{domain}}': businessEmailDomain
        }
    };
};

});
parcelRegister("epray", function(module, exports) {
$parcel$export(module.exports, "normalizeMarketoKey", function () { return $81ef8d10072e3a8f$export$27e023c28c7d4c9f; });
$parcel$export(module.exports, "applyMarketoFormLocalization", function () { return $81ef8d10072e3a8f$export$e17b30bc5851d5b; });
$parcel$export(module.exports, "observeMarketoValidationLocalization", function () { return $81ef8d10072e3a8f$export$59b464a12fad8b55; });

var $a0utR = parcelRequire("a0utR");
const $81ef8d10072e3a8f$var$warnedLocalizationKeys = new Set();
const $81ef8d10072e3a8f$var$sanitizeRichText = (html)=>(0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(html, {
        allowedTags: [
            'a',
            'br',
            'em',
            'p',
            'span',
            'strong'
        ],
        allowedAttributes: {
            a: [
                'href',
                'rel',
                'target'
            ]
        }
    });
const $81ef8d10072e3a8f$export$27e023c28c7d4c9f = (value)=>(value ?? '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
const $81ef8d10072e3a8f$var$normalizeValidationMessage = (value)=>(value ?? '').replace(/\s+/g, ' ').trim().toLowerCase();
const $81ef8d10072e3a8f$var$warnInDevelopment = (key, message)=>{
    return;
};
const $81ef8d10072e3a8f$var$getControlKey = (control)=>$81ef8d10072e3a8f$export$27e023c28c7d4c9f(control?.name || control?.id);
const $81ef8d10072e3a8f$var$findControlById = (formElement, id)=>{
    if (!id) return null;
    return Array.from(formElement.querySelectorAll('input, select, textarea')).find((control)=>control.id === id) ?? null;
};
const $81ef8d10072e3a8f$var$findAssociatedControl = (formElement, element)=>{
    if (element instanceof HTMLLabelElement && element.htmlFor) return $81ef8d10072e3a8f$var$findControlById(formElement, element.htmlFor);
    const fieldWrap = element.closest('.mktoFieldWrap');
    return fieldWrap?.querySelector('input, select, textarea') ?? null;
};
const $81ef8d10072e3a8f$var$findOptionControl = (formElement, label)=>{
    if (label.htmlFor) {
        const control = $81ef8d10072e3a8f$var$findControlById(formElement, label.htmlFor);
        if (control instanceof HTMLInputElement) return control;
    }
    const previousElement = label.previousElementSibling;
    if (previousElement instanceof HTMLInputElement) return previousElement;
    return null;
};
const $81ef8d10072e3a8f$var$getFieldLocalization = (localization, control)=>{
    const fieldKey = $81ef8d10072e3a8f$var$getControlKey(control);
    if (!fieldKey) return undefined;
    const fieldLocalization = localization.fields[fieldKey];
    if (!fieldLocalization) $81ef8d10072e3a8f$var$warnInDevelopment(`field:${fieldKey}`, `Marketo form field localization missing for key "${fieldKey}".`);
    return fieldLocalization;
};
const $81ef8d10072e3a8f$var$getElementFieldLocalization = (formElement, element, localization)=>{
    const associatedControl = $81ef8d10072e3a8f$var$findAssociatedControl(formElement, element);
    if (associatedControl) return $81ef8d10072e3a8f$var$getFieldLocalization(localization, associatedControl);
    const row = element.closest('.mktoFormRow');
    const rowFieldKey = Array.from(row?.classList ?? []).map($81ef8d10072e3a8f$export$27e023c28c7d4c9f).find((key)=>localization.fields[key]);
    return rowFieldKey ? localization.fields[rowFieldKey] : undefined;
};
const $81ef8d10072e3a8f$var$setLabelText = (label, text)=>{
    const requiredAsterisks = Array.from(label.querySelectorAll('.mktoAsterix'));
    requiredAsterisks.forEach((asterisk)=>asterisk.remove());
    label.textContent = text;
    requiredAsterisks.forEach((asterisk)=>label.appendChild(asterisk));
};
const $81ef8d10072e3a8f$var$localizeFieldLabels = (formElement, localization)=>{
    formElement.querySelectorAll('label.mktoLabel').forEach((label)=>{
        const control = $81ef8d10072e3a8f$var$findAssociatedControl(formElement, label);
        const fieldLocalization = $81ef8d10072e3a8f$var$getFieldLocalization(localization, control);
        if (fieldLocalization?.label) $81ef8d10072e3a8f$var$setLabelText(label, fieldLocalization.label);
    });
};
const $81ef8d10072e3a8f$var$localizeFieldAttributes = (formElement, localization)=>{
    formElement.querySelectorAll('input, select, textarea').forEach((control)=>{
        const fieldLocalization = $81ef8d10072e3a8f$var$getFieldLocalization(localization, control);
        if (!fieldLocalization) return;
        if (fieldLocalization.placeholder && (control instanceof HTMLInputElement || control instanceof HTMLTextAreaElement)) control.placeholder = fieldLocalization.placeholder;
        if (fieldLocalization.ariaLabel && (control.hasAttribute('aria-label') || !control.id)) control.setAttribute('aria-label', fieldLocalization.ariaLabel);
    });
};
const $81ef8d10072e3a8f$var$getOptionLocalization = (localization, fieldKey, value, includeSharedOption = true)=>{
    const optionKey = $81ef8d10072e3a8f$export$27e023c28c7d4c9f(value);
    return localization.options[`${fieldKey}:${optionKey}`] ?? (includeSharedOption ? localization.options[optionKey] : undefined);
};
const $81ef8d10072e3a8f$var$getLocalizedRegionName = (localization, value)=>{
    if (!/^[A-Z]{2}$/i.test(value)) return undefined;
    const DisplayNames = Intl.DisplayNames;
    try {
        return DisplayNames ? new DisplayNames([
            localization.locale
        ], {
            type: 'region'
        }).of(value) : undefined;
    } catch  {
        return undefined;
    }
};
const $81ef8d10072e3a8f$var$localizeSelectOptions = (formElement, localization)=>{
    formElement.querySelectorAll('select').forEach((select)=>{
        const fieldKey = $81ef8d10072e3a8f$var$getControlKey(select);
        if (!fieldKey) return;
        select.querySelectorAll('option').forEach((option)=>{
            const localizedOption = $81ef8d10072e3a8f$var$getOptionLocalization(localization, fieldKey, option.value, fieldKey !== 'country') ?? (fieldKey === 'country' ? $81ef8d10072e3a8f$var$getLocalizedRegionName(localization, option.value) : undefined);
            if (localizedOption) {
                option.textContent = localizedOption;
                return;
            }
            if (option.value || option.textContent?.trim()) $81ef8d10072e3a8f$var$warnInDevelopment(`option:${fieldKey}:${option.value || option.textContent}`, `Marketo form option localization missing for key "${fieldKey}:${option.value}".`);
        });
    });
};
const $81ef8d10072e3a8f$var$localizeChoiceLabels = (formElement, localization)=>{
    formElement.querySelectorAll('.mktoCheckboxList label:not(.mktoLabel), .mktoRadioList label:not(.mktoLabel)').forEach((label)=>{
        const control = $81ef8d10072e3a8f$var$findOptionControl(formElement, label);
        const fieldKey = $81ef8d10072e3a8f$var$getControlKey(control);
        if (!control || !fieldKey) return;
        const checkboxList = label.closest('.mktoCheckboxList');
        const isOnlyCheckboxOption = control.type === 'checkbox' && checkboxList?.querySelectorAll('input[type="checkbox"]').length === 1;
        const fieldLocalization = localization.fields[fieldKey];
        if (isOnlyCheckboxOption && fieldLocalization?.label) {
            label.textContent = fieldLocalization.label;
            return;
        }
        const localizedOption = $81ef8d10072e3a8f$var$getOptionLocalization(localization, fieldKey, control.value);
        if (localizedOption) {
            label.textContent = localizedOption;
            return;
        }
        $81ef8d10072e3a8f$var$warnInDevelopment(`option:${fieldKey}:${control.value}`, `Marketo form choice localization missing for key "${fieldKey}:${control.value}".`);
    });
};
const $81ef8d10072e3a8f$var$isStandalonePrivacyNotice = (element)=>{
    // Marketo's standalone HTML blocks have generated names rather than field aliases.
    const text = (element.textContent ?? '').replace(/\s+/g, ' ').trim();
    return text === "By submitting this form, I acknowledge receipt of Atlassian's Privacy Policy." && Boolean(element.querySelector('a[href="https://www.atlassian.com/legal/privacy-policy"]'));
};
const $81ef8d10072e3a8f$var$localizeInstructions = (formElement, localization)=>{
    formElement.querySelectorAll('.mktoInstruction').forEach((element)=>{
        const fieldLocalization = $81ef8d10072e3a8f$var$getElementFieldLocalization(formElement, element, localization);
        if (fieldLocalization?.instructionHtml) element.innerHTML = $81ef8d10072e3a8f$var$sanitizeRichText(fieldLocalization.instructionHtml);
    });
    formElement.querySelectorAll('.mktoHtmlText').forEach((element)=>{
        const fieldLocalization = $81ef8d10072e3a8f$var$getElementFieldLocalization(formElement, element, localization) ?? ($81ef8d10072e3a8f$var$isStandalonePrivacyNotice(element) ? localization.fields['privacypolicy'] : undefined);
        if (fieldLocalization?.html) element.innerHTML = $81ef8d10072e3a8f$var$sanitizeRichText(fieldLocalization.html);
    });
};
const $81ef8d10072e3a8f$var$localizeSubmitButton = (formElement, localization)=>{
    if (!localization.submitButton) return;
    formElement.querySelectorAll('button[type="submit"], .mktoButton').forEach((button)=>{
        button.textContent = localization.submitButton;
    });
};
const $81ef8d10072e3a8f$export$db5a6189c03df9cf = (formElement, localization)=>{
    formElement.querySelectorAll('.mktoErrorMsg').forEach((element)=>{
        const validationKey = $81ef8d10072e3a8f$var$normalizeValidationMessage(element.textContent);
        const localizedMessage = localization.validationMessages[validationKey];
        if (localizedMessage && element.textContent !== localizedMessage) {
            element.textContent = localizedMessage;
            return;
        }
        if (validationKey && !localizedMessage) $81ef8d10072e3a8f$var$warnInDevelopment(`validation:${validationKey}`, `Marketo form validation localization missing for message "${validationKey}".`);
    });
};
const $81ef8d10072e3a8f$export$e17b30bc5851d5b = (formElement, localization)=>{
    $81ef8d10072e3a8f$var$localizeFieldLabels(formElement, localization);
    $81ef8d10072e3a8f$var$localizeFieldAttributes(formElement, localization);
    $81ef8d10072e3a8f$var$localizeSelectOptions(formElement, localization);
    $81ef8d10072e3a8f$var$localizeChoiceLabels(formElement, localization);
    $81ef8d10072e3a8f$var$localizeInstructions(formElement, localization);
    $81ef8d10072e3a8f$var$localizeSubmitButton(formElement, localization);
    $81ef8d10072e3a8f$export$db5a6189c03df9cf(formElement, localization);
};
const $81ef8d10072e3a8f$export$59b464a12fad8b55 = (formElement, localization)=>{
    if (typeof MutationObserver === 'undefined') return undefined;
    const observer = new MutationObserver(()=>{
        $81ef8d10072e3a8f$export$db5a6189c03df9cf(formElement, localization);
    });
    observer.observe(formElement, {
        childList: true,
        subtree: true,
        characterData: true
    });
    return observer;
};

});


parcelRegister("66KLr", function(module, exports) {
$parcel$export(module.exports, "getMarketoConfig", function () { return $7815b961bbb56392$export$cda5a25a69a446d; });
$parcel$export(module.exports, "useMarketoForm", function () { return $7815b961bbb56392$export$44382482aed502ec; });

var $1oC0p = parcelRequire("1oC0p");

var $2gCne = parcelRequire("2gCne");

var $epray = parcelRequire("epray");

var $lP5iv = parcelRequire("lP5iv");
const $7815b961bbb56392$export$6658056c8325828c = 'https://pages.eml.atlassian.com';
const $7815b961bbb56392$export$72a1d2a8a4208855 = 'https://app-ab35.marketo.com';
const $7815b961bbb56392$export$7ea6ecaa6cf33f3c = '594-ATC-127';
const $7815b961bbb56392$export$7fc5ebd62956ada8 = '353-DGC-691';
const $7815b961bbb56392$export$7eaf5ca899a502a7 = 'https://preferences.atlassian.com/rest/forms/config';
const $7815b961bbb56392$export$17e935c096909554 = 'https://preferences.stg.atlassian.com/rest/forms/config';
const $7815b961bbb56392$var$MARKETING_CONTEXT_STORAGE_KEY = 'marketingContext';
const $7815b961bbb56392$var$MARKETO_READY_POLL_MS = 250;
const $7815b961bbb56392$var$MARKETO_READY_TIMEOUT_MS = 15000;
const $7815b961bbb56392$var$MARKETO_LOAD_FORM_TIMEOUT_MS = 15000;
const $7815b961bbb56392$var$MARKETO_SUBMIT_TIMEOUT_MS = 15000;
const $7815b961bbb56392$var$toFormId = (formId)=>Number(formId);
const $7815b961bbb56392$var$getMarketoFormElementId = (formId)=>`mktoForm_${formId}`;
const $7815b961bbb56392$var$getMarketoScriptKey = (scriptHost, orgId)=>`${scriptHost}:${orgId}`;
const $7815b961bbb56392$var$getMarketoScriptId = (scriptHost, orgId)=>`marketo-${orgId}-${scriptHost.replace(/[^a-zA-Z0-9]/g, '-')}`;
const $7815b961bbb56392$var$loadedMarketoInstances = new Map();
const $7815b961bbb56392$var$loadingMarketoScripts = new Map();
const $7815b961bbb56392$export$cda5a25a69a446d = (ids, isProduction)=>{
    const hasStagingFormId = ids.formIdStg !== undefined && ids.formIdStg !== null && ids.formIdStg !== '';
    const shouldUseProductionForm = isProduction || !hasStagingFormId;
    const selectedFormId = shouldUseProductionForm ? ids.formId : ids.formIdStg;
    return {
        scriptHost: shouldUseProductionForm ? $7815b961bbb56392$export$6658056c8325828c : $7815b961bbb56392$export$72a1d2a8a4208855,
        preferencesUrl: shouldUseProductionForm ? $7815b961bbb56392$export$7eaf5ca899a502a7 : $7815b961bbb56392$export$17e935c096909554,
        orgId: shouldUseProductionForm ? $7815b961bbb56392$export$7ea6ecaa6cf33f3c : $7815b961bbb56392$export$7fc5ebd62956ada8,
        formId: $7815b961bbb56392$var$toFormId(selectedFormId ?? ids.formId)
    };
};
const $7815b961bbb56392$var$waitForMarketo = (scriptElement, scriptKey)=>{
    return new Promise((resolve, reject)=>{
        const cleanup = ()=>{
            scriptElement.removeEventListener('load', handleLoad);
            scriptElement.removeEventListener('error', handleError);
            window.clearInterval(pollId);
            window.clearTimeout(timeoutId);
        };
        function handleLoad() {
            scriptElement.dataset['marketoLoaded'] = 'true';
            updateMarketo();
        }
        function updateMarketo() {
            if (scriptElement.dataset['marketoLoaded'] === 'true' && window.MktoForms2) {
                const marketo = window.MktoForms2;
                $7815b961bbb56392$var$loadedMarketoInstances.set(scriptKey, marketo);
                cleanup();
                resolve(marketo);
            }
        }
        function handleError() {
            cleanup();
            scriptElement.remove();
            $7815b961bbb56392$var$loadedMarketoInstances.delete(scriptKey);
            reject(new Error('Failed to load Marketo.'));
        }
        scriptElement.addEventListener('load', handleLoad);
        scriptElement.addEventListener('error', handleError);
        const pollId = window.setInterval(updateMarketo, $7815b961bbb56392$var$MARKETO_READY_POLL_MS);
        const timeoutId = window.setTimeout(()=>{
            cleanup();
            scriptElement.remove();
            $7815b961bbb56392$var$loadedMarketoInstances.delete(scriptKey);
            reject(new Error('Timed out waiting for Marketo.'));
        }, $7815b961bbb56392$var$MARKETO_READY_TIMEOUT_MS);
        updateMarketo();
    });
};
const $7815b961bbb56392$var$loadMarketoScript = (scriptHost, orgId)=>{
    if (typeof window === 'undefined' || typeof document === 'undefined') return Promise.reject(new Error('Marketo forms can only load in the browser.'));
    const scriptKey = $7815b961bbb56392$var$getMarketoScriptKey(scriptHost, orgId);
    const scriptId = $7815b961bbb56392$var$getMarketoScriptId(scriptHost, orgId);
    const existingScript = document.getElementById(scriptId);
    const cachedInstance = $7815b961bbb56392$var$loadedMarketoInstances.get(scriptKey);
    if (cachedInstance && existingScript) return Promise.resolve(cachedInstance);
    if (!existingScript && window.MktoForms2 && !document.querySelector('script[data-marketo-script="true"], script[id^="marketo-"]')) return Promise.resolve(window.MktoForms2);
    const pendingScript = $7815b961bbb56392$var$loadingMarketoScripts.get(scriptKey);
    if (pendingScript && existingScript) return pendingScript;
    if (existingScript) {
        const loadPromise = $7815b961bbb56392$var$waitForMarketo(existingScript, scriptKey).finally(()=>{
            $7815b961bbb56392$var$loadingMarketoScripts.delete(scriptKey);
        });
        $7815b961bbb56392$var$loadingMarketoScripts.set(scriptKey, loadPromise);
        return loadPromise;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = `${scriptHost}/js/forms2/js/forms2.min.js`;
    script.dataset['marketoScript'] = 'true';
    script.dataset['marketoKey'] = scriptKey;
    document.body.appendChild(script);
    const loadPromise = $7815b961bbb56392$var$waitForMarketo(script, scriptKey).finally(()=>{
        $7815b961bbb56392$var$loadingMarketoScripts.delete(scriptKey);
    });
    $7815b961bbb56392$var$loadingMarketoScripts.set(scriptKey, loadPromise);
    return loadPromise;
};
const $7815b961bbb56392$var$getSubmitButtonText = (form)=>{
    return form.getFormElem?.().find?.('button[type="submit"]')?.text?.() ?? '';
};
const $7815b961bbb56392$var$getRenderedSubmitButton = (formElement)=>formElement.querySelector('button[type="submit"], .mktoButton');
const $7815b961bbb56392$var$getRenderedSubmitButtonText = (formElement)=>$7815b961bbb56392$var$getRenderedSubmitButton(formElement)?.textContent?.trim() ?? '';
const $7815b961bbb56392$var$restoreSubmitButton = (formElement, submitButtonText)=>{
    const submitButton = $7815b961bbb56392$var$getRenderedSubmitButton(formElement);
    if (!submitButton) return;
    if (submitButtonText) submitButton.textContent = submitButtonText;
    submitButton.disabled = false;
    submitButton.removeAttribute('disabled');
};
const $7815b961bbb56392$var$hasMarketoValidationError = (formElement)=>Boolean(formElement.querySelector('.mktoInvalid, .mktoError'));
const $7815b961bbb56392$var$getVisibleLabelText = (element)=>(element.textContent ?? '').replace(/\*/g, '').trim();
const $7815b961bbb56392$var$normalizeMarketoFieldKey = (value)=>(value ?? '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
const $7815b961bbb56392$var$marketoRowClassesByFieldKey = {
    firstname: 'FirstName',
    firstnamec: 'FirstName',
    lastname: 'LastName',
    lastnamec: 'LastName',
    email: 'Email',
    emailaddress: 'Email',
    company: 'Company',
    companyname: 'Company',
    country: 'Country',
    state: 'State',
    phone: 'Phone',
    phonenumber: 'Phone',
    persontitle: 'PersonTitle',
    jobtitle: 'PersonTitle',
    title: 'PersonTitle',
    acknowledgeprivacypolicysignup: 'AcknowledgePrivacyPolicySignUp',
    acknowledgeprivacypolicysubmission: 'AcknowledgePrivacyPolicySubmission',
    formprivacypolicy: 'form_privacyPolicy',
    privacypolicy: 'privacyPolicy',
    consentprivacypolicygranted: 'consent_privacyPolicy_granted',
    formgmoigranted: 'form_gmoiGranted'
};
const $7815b961bbb56392$var$MARKETO_PAIRED_HALF_ROW_CLASS = 'marketoFormRow--pairedHalf';
const $7815b961bbb56392$var$MARKETO_EMAIL_COMPANY_PAIR_ROW_CLASS = 'marketoFormRow--emailCompanyPair';
const $7815b961bbb56392$var$getControlRowClass = (control)=>$7815b961bbb56392$var$marketoRowClassesByFieldKey[$7815b961bbb56392$var$normalizeMarketoFieldKey(control.name || control.id || control.getAttribute('data-name'))];
const $7815b961bbb56392$var$isHiddenControl = (control)=>control instanceof HTMLInputElement && control.type === 'hidden';
const $7815b961bbb56392$var$getVisibleRowByClass = (formElement, className)=>{
    const row = formElement.querySelector(`.mktoFormRow.${className}`);
    return row && !row.hasAttribute('hidden') ? row : null;
};
const $7815b961bbb56392$var$updateMarketoRowLayoutPairs = (formElement)=>{
    formElement.querySelectorAll(`.mktoFormRow.${$7815b961bbb56392$var$MARKETO_PAIRED_HALF_ROW_CLASS}, .mktoFormRow.${$7815b961bbb56392$var$MARKETO_EMAIL_COMPANY_PAIR_ROW_CLASS}`).forEach((row)=>{
        row.classList.remove($7815b961bbb56392$var$MARKETO_PAIRED_HALF_ROW_CLASS, $7815b961bbb56392$var$MARKETO_EMAIL_COMPANY_PAIR_ROW_CLASS);
    });
    const firstNameRow = $7815b961bbb56392$var$getVisibleRowByClass(formElement, 'FirstName');
    const lastNameRow = $7815b961bbb56392$var$getVisibleRowByClass(formElement, 'LastName');
    if (firstNameRow && lastNameRow) {
        firstNameRow.classList.add($7815b961bbb56392$var$MARKETO_PAIRED_HALF_ROW_CLASS);
        lastNameRow.classList.add($7815b961bbb56392$var$MARKETO_PAIRED_HALF_ROW_CLASS);
    }
    const emailRow = $7815b961bbb56392$var$getVisibleRowByClass(formElement, 'Email');
    const companyRow = $7815b961bbb56392$var$getVisibleRowByClass(formElement, 'Company');
    if (emailRow && companyRow) {
        emailRow.classList.add($7815b961bbb56392$var$MARKETO_PAIRED_HALF_ROW_CLASS);
        companyRow.classList.add($7815b961bbb56392$var$MARKETO_PAIRED_HALF_ROW_CLASS, $7815b961bbb56392$var$MARKETO_EMAIL_COMPANY_PAIR_ROW_CLASS);
    }
};
const $7815b961bbb56392$var$normalizeMarketoRows = (formElement)=>{
    formElement.querySelectorAll('.mktoFormRow').forEach((row)=>{
        const controls = Array.from(row.querySelectorAll('input, select, textarea'));
        controls.forEach((control)=>{
            const rowClass = $7815b961bbb56392$var$getControlRowClass(control);
            if (rowClass) row.classList.add(rowClass);
        });
        const hasOnlyHiddenControls = controls.length > 0 && controls.every($7815b961bbb56392$var$isHiddenControl);
        const hasVisibleStaticContent = Boolean(row.querySelector('.mktoHtmlText, .mktoInstruction, button, .mktoButton'));
        if (hasOnlyHiddenControls && !hasVisibleStaticContent) row.setAttribute('hidden', '');
    });
    $7815b961bbb56392$var$updateMarketoRowLayoutPairs(formElement);
};
const $7815b961bbb56392$var$normalizeMarketoMarkup = (formElement)=>{
    document.querySelectorAll('#mktoForms2BaseStyle, #mktoForms2ThemeStyle').forEach((element)=>element.remove());
    formElement.querySelectorAll('style, .mktoGutter, .mktoClear, .mktoOffset').forEach((element)=>element.remove());
    formElement.removeAttribute('style');
    formElement.querySelectorAll('*').forEach((element)=>{
        element.removeAttribute('style');
    });
    $7815b961bbb56392$var$normalizeMarketoRows(formElement);
    const submitText = formElement.getAttribute('data-submit');
    if (submitText) formElement.querySelectorAll('button').forEach((button)=>{
        button.textContent = submitText;
    });
    formElement.querySelectorAll('.mktoLabel').forEach((element)=>{
        element.classList.add('body-sm', 'bold');
        const requiredAsterisk = element.querySelector('.mktoAsterix');
        if (requiredAsterisk) element.appendChild(requiredAsterisk);
    });
    formElement.querySelectorAll('.mktoFieldWrap').forEach((fieldWrap)=>{
        const checkboxList = fieldWrap.querySelector('.mktoCheckboxList');
        if (!checkboxList) return;
        const fieldLabel = Array.from(fieldWrap.children).find((element)=>element instanceof HTMLElement && element.classList.contains('mktoLabel'));
        if (!fieldLabel || !$7815b961bbb56392$var$getVisibleLabelText(fieldLabel)) return;
        const optionLabels = Array.from(checkboxList.querySelectorAll('label'));
        const hasVisibleOptionLabel = optionLabels.some((label)=>$7815b961bbb56392$var$getVisibleLabelText(label));
        if (hasVisibleOptionLabel) return;
        optionLabels.forEach((label)=>label.remove());
        fieldLabel.classList.remove('body-sm', 'bold');
        fieldLabel.classList.add('body-md');
        checkboxList.appendChild(fieldLabel);
    });
    formElement.querySelectorAll('input, select, textarea, button, .mktoHtmlText').forEach((element)=>{
        element.classList.add('body-md');
    });
    formElement.querySelectorAll('.mktoCheckboxList label, .mktoRadioList label').forEach((element)=>{
        element.classList.add('body-md');
    });
    formElement.querySelectorAll('.mktoInstruction, .mktoErrorMsg').forEach((element)=>{
        element.classList.add('fine-print');
    });
};
const $7815b961bbb56392$var$prepareMarketoFormTarget = (container, formId)=>{
    container.innerHTML = '';
    const form = document.createElement('form');
    form.id = $7815b961bbb56392$var$getMarketoFormElementId(formId);
    container.appendChild(form);
};
const $7815b961bbb56392$var$getRenderedMarketoForm = (container, form, formId)=>{
    const targetForm = container.querySelector(`#${$7815b961bbb56392$var$getMarketoFormElementId(formId)}`);
    if (targetForm && targetForm.children.length > 0) return targetForm;
    return form.render();
};
const $7815b961bbb56392$export$d321bd6a3054130a = async (formElement, preferencesUrl)=>{
    if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
    try {
        const response = await window.fetch(preferencesUrl);
        if (!response.ok) throw new Error(`Failed to fetch Marketo preferences: ${response.status}`);
        const data = await response.json();
        const country = formElement.querySelector('select#Country');
        if (country && data.locale) {
            country.closest('.mktoFormRow')?.setAttribute('hidden', '');
            country.value = data.locale;
        }
        const gdprInput = formElement.querySelector('input[name="form_gmoiGranted"]');
        if (gdprInput && data.localeRequiresMarketingCommunicationOptIn === false) {
            gdprInput.closest('.mktoFormRow')?.setAttribute('hidden', '');
            gdprInput.checked = true;
        }
        $7815b961bbb56392$var$updateMarketoRowLayoutPairs(formElement);
    } catch (error) {
        console.error('Failed to retrieve Marketo preferences', error);
    }
};
const $7815b961bbb56392$export$3470cd51343d304e = ()=>{
    try {
        const marketingContext = (0, $2gCne.getLocalStorage)($7815b961bbb56392$var$MARKETING_CONTEXT_STORAGE_KEY, true);
        const parsedMarketingContext = marketingContext ? JSON.parse(marketingContext) : null;
        const { sfdcCampaignId: sfdcCampaignId = '', source: source = '', medium: medium = '', campaign: campaign = '', content: content = '' } = parsedMarketingContext?.utm || {};
        return {
            UTM_SFDC_Campaign_ID__c: sfdcCampaignId,
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmContent: content
        };
    } catch (error) {
        console.error('Failed to read or parse marketingContext from localStorage', error);
        return {};
    }
};
const $7815b961bbb56392$export$590d28857fa84cd7 = (form, submitButtonText = $7815b961bbb56392$var$getSubmitButtonText(form))=>{
    const timestamp = new Date().toISOString();
    const currentUrl = typeof window === 'undefined' ? '' : window.location.href;
    return {
        form_anyConsentUpdatedAt: timestamp,
        form_gmoiUpdatedAt: timestamp,
        form_privacyPolicyUpdatedAt: timestamp,
        form_gmoiFormUrl: currentUrl,
        form_privacyPolicyFormUrl: currentUrl,
        form_submitButton: submitButtonText,
        ...$7815b961bbb56392$export$3470cd51343d304e()
    };
};
const $7815b961bbb56392$var$MARKETO_PREFILL_HIDDEN_ATTRIBUTE = 'data-marketo-prefill-hidden';
const $7815b961bbb56392$var$MARKETO_CONTACT_ROW_CLASSES = [
    'FirstName',
    'LastName',
    'Email',
    'Company',
    'PersonTitle'
];
const $7815b961bbb56392$var$setMarketoContactFieldsHidden = (formElement, hidden)=>{
    $7815b961bbb56392$var$MARKETO_CONTACT_ROW_CLASSES.forEach((rowClass)=>{
        const row = formElement.querySelector(`.mktoFormRow.${rowClass}`);
        if (!row) return;
        if (hidden) {
            if (!row.hasAttribute('hidden')) {
                row.setAttribute($7815b961bbb56392$var$MARKETO_PREFILL_HIDDEN_ATTRIBUTE, '');
                row.setAttribute('hidden', '');
            }
            return;
        }
        if (row.hasAttribute($7815b961bbb56392$var$MARKETO_PREFILL_HIDDEN_ATTRIBUTE)) {
            row.removeAttribute($7815b961bbb56392$var$MARKETO_PREFILL_HIDDEN_ATTRIBUTE);
            row.removeAttribute('hidden');
        }
    });
    $7815b961bbb56392$var$updateMarketoRowLayoutPairs(formElement);
};
const $7815b961bbb56392$var$getMarketoContactFieldValues = (formElement, contactInfo)=>{
    const [firstName = '', ...lastNameParts] = contactInfo.name.trim().split(/\s+/);
    const candidateValues = {
        FirstName: firstName,
        LastName: lastNameParts.join(' '),
        Email: contactInfo.email.trim()
    };
    return Object.fromEntries(Object.entries(candidateValues).filter(([fieldName])=>formElement.querySelector(`[name="${fieldName}"], #${fieldName}`)));
};
const $7815b961bbb56392$var$setRenderedMarketoContactFieldValues = (formElement, values)=>{
    Object.entries(values).forEach(([fieldName, value])=>{
        const input = formElement.querySelector(`input[name="${fieldName}"], input#${fieldName}`);
        if (input) input.value = value;
    });
};
const $7815b961bbb56392$export$44382482aed502ec = ({ containerRef: containerRef, config: config, localization: localization })=>{
    const [status, setStatus] = (0, $1oC0p.useState)('loading');
    const activeConfigKeyRef = (0, $1oC0p.useRef)();
    const activeFormRef = (0, $1oC0p.useRef)();
    const renderedFormRef = (0, $1oC0p.useRef)();
    const { scriptHost: scriptHost, preferencesUrl: preferencesUrl, orgId: orgId, formId: formId } = config;
    const configKey = (0, $1oC0p.useMemo)(()=>`${scriptHost}:${preferencesUrl}:${orgId}:${formId}`, [
        formId,
        orgId,
        preferencesUrl,
        scriptHost
    ]);
    const prefillContactInfo = (0, $1oC0p.useCallback)((contactInfo)=>{
        const form = activeFormRef.current;
        const renderedForm = renderedFormRef.current;
        if (!form || !renderedForm) return false;
        const values = $7815b961bbb56392$var$getMarketoContactFieldValues(renderedForm, contactInfo);
        if (!values['Email'] || !values['FirstName'] && !values['LastName']) return false;
        form.vals(values);
        $7815b961bbb56392$var$setRenderedMarketoContactFieldValues(renderedForm, values);
        $7815b961bbb56392$var$setMarketoContactFieldsHidden(renderedForm, true);
        return true;
    }, []);
    const revealContactFields = (0, $1oC0p.useCallback)(()=>{
        const renderedForm = renderedFormRef.current;
        if (renderedForm) $7815b961bbb56392$var$setMarketoContactFieldsHidden(renderedForm, false);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        let isMounted = true;
        let submitTimeoutId;
        let validationLocalizationObserver;
        const loadTimeoutId = window.setTimeout(()=>{
            if (isMounted) setStatus('error');
        }, $7815b961bbb56392$var$MARKETO_LOAD_FORM_TIMEOUT_MS);
        const clearSubmitTimeout = ()=>{
            if (submitTimeoutId) {
                window.clearTimeout(submitTimeoutId);
                submitTimeoutId = undefined;
            }
        };
        const setLoadedStatus = (nextStatus)=>{
            window.clearTimeout(loadTimeoutId);
            clearSubmitTimeout();
            if (isMounted) setStatus(nextStatus);
        };
        if (activeConfigKeyRef.current !== configKey) {
            activeConfigKeyRef.current = configKey;
            setStatus('loading');
        }
        $7815b961bbb56392$var$loadMarketoScript(scriptHost, orgId).then((marketo)=>{
            if (!isMounted || !containerRef.current) return;
            try {
                $7815b961bbb56392$var$prepareMarketoFormTarget(containerRef.current, formId);
                marketo.loadForm(scriptHost, orgId, formId, (form)=>{
                    if (!isMounted || !containerRef.current) return;
                    if (!form) {
                        setLoadedStatus('error');
                        return;
                    }
                    const renderedForm = $7815b961bbb56392$var$getRenderedMarketoForm(containerRef.current, form, formId);
                    activeFormRef.current = form;
                    renderedFormRef.current = renderedForm;
                    $7815b961bbb56392$var$normalizeMarketoMarkup(renderedForm);
                    if (localization) {
                        (0, $epray.applyMarketoFormLocalization)(renderedForm, localization);
                        validationLocalizationObserver = (0, $epray.observeMarketoValidationLocalization)(renderedForm, localization);
                    }
                    const submitButtonText = $7815b961bbb56392$var$getRenderedSubmitButtonText(renderedForm) || $7815b961bbb56392$var$getSubmitButtonText(form);
                    if (renderedForm.parentElement !== containerRef.current) {
                        containerRef.current.innerHTML = '';
                        containerRef.current.appendChild(renderedForm);
                    }
                    form.onValidate?.((nativeValid = true)=>{
                        if (!nativeValid || !localization) return;
                        (0, $lP5iv.validateBusinessEmailDomain)(form, renderedForm, localization);
                    });
                    form.onSubmit(()=>{
                        clearSubmitTimeout();
                        try {
                            form.vals($7815b961bbb56392$export$590d28857fa84cd7(form, submitButtonText));
                            submitTimeoutId = window.setTimeout(()=>{
                                if (!isMounted) return;
                                (0, $lP5iv.setMarketoSubmittable)(form, true);
                                $7815b961bbb56392$var$restoreSubmitButton(renderedForm, submitButtonText);
                                if (!$7815b961bbb56392$var$hasMarketoValidationError(renderedForm)) setLoadedStatus('error');
                            }, $7815b961bbb56392$var$MARKETO_SUBMIT_TIMEOUT_MS);
                        } catch (error) {
                            console.error('Failed to prepare Marketo submission', error);
                            (0, $lP5iv.setMarketoSubmittable)(form, true);
                            $7815b961bbb56392$var$restoreSubmitButton(renderedForm, submitButtonText);
                            setLoadedStatus('error');
                        }
                    });
                    form.onSuccess(()=>{
                        clearSubmitTimeout();
                        setLoadedStatus('success');
                        return false;
                    });
                    setLoadedStatus('form');
                    window.setTimeout(()=>{
                        if (isMounted) $7815b961bbb56392$export$d321bd6a3054130a(renderedForm, preferencesUrl);
                    }, 0);
                });
            } catch  {
                setLoadedStatus('error');
            }
        }).catch(()=>{
            setLoadedStatus('error');
        });
        return ()=>{
            isMounted = false;
            activeFormRef.current = undefined;
            renderedFormRef.current = undefined;
            window.clearTimeout(loadTimeoutId);
            clearSubmitTimeout();
            validationLocalizationObserver?.disconnect();
        };
    }, [
        configKey,
        containerRef,
        formId,
        localization,
        orgId,
        preferencesUrl,
        scriptHost
    ]);
    return {
        status: status,
        prefillContactInfo: prefillContactInfo,
        revealContactFields: revealContactFields
    };
};

});
parcelRegister("lP5iv", function(module, exports) {
$parcel$export(module.exports, "setMarketoSubmittable", function () { return $c14645c1c2ea5c0a$export$371b3f9cdfe752d1; });
$parcel$export(module.exports, "validateBusinessEmailDomain", function () { return $c14645c1c2ea5c0a$export$74cfff971d9af9fa; });
const $c14645c1c2ea5c0a$var$EMAIL_PATTERN = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
const $c14645c1c2ea5c0a$var$BUSINESS_EMAIL_VALIDATION_KEY = 'please enter your business email address. this form does not accept addresses from {{domain}}';
const $c14645c1c2ea5c0a$var$EMAIL_VALIDATION_KEY = 'please enter a valid email address';
const $c14645c1c2ea5c0a$var$FREE_EMAIL_DOMAINS = [
    '@gmail',
    '@yahoo',
    '@aol',
    '@comcast',
    '@hotmail',
    '@ymail',
    '@msn',
    '@mac',
    '@sina',
    '@freemail',
    '@me',
    '@icloud',
    '@live',
    '@gnail',
    '@gmsil',
    '@gmial',
    '@gamil',
    '@gail'
];
const $c14645c1c2ea5c0a$export$468caa2e6d59a612 = (email)=>{
    const value = email.trim().toLowerCase();
    const atIndex = value.indexOf('@');
    if (atIndex === -1) return undefined;
    const domain = value.substring(atIndex);
    const domainParts = domain.split('.');
    const isFreeEmailDomain = $c14645c1c2ea5c0a$var$FREE_EMAIL_DOMAINS.some((freeEmailDomain)=>{
        if (freeEmailDomain === '@comcast' && domain === '@comcast.com') return false;
        return domainParts.includes(freeEmailDomain);
    });
    return isFreeEmailDomain ? domain.substring(1) : undefined;
};
const $c14645c1c2ea5c0a$export$371b3f9cdfe752d1 = (form, canSubmit)=>{
    if (form.submittable) {
        form.submittable(canSubmit);
        return;
    }
    form.submitable?.(canSubmit);
};
const $c14645c1c2ea5c0a$var$getLocalizedValidationMessage = (localization, key, fallback)=>localization.validationMessages[key] ?? fallback;
const $c14645c1c2ea5c0a$var$getBusinessEmailValidationMessage = (localization, domain)=>$c14645c1c2ea5c0a$var$getLocalizedValidationMessage(localization, $c14645c1c2ea5c0a$var$BUSINESS_EMAIL_VALIDATION_KEY, 'Please enter your business email address. This form does not accept addresses from {{domain}}').replace('{{domain}}', domain);
const $c14645c1c2ea5c0a$var$findEmailInput = (formElement)=>formElement.querySelector('input#Email, input[name="Email"]');
const $c14645c1c2ea5c0a$var$getMarketoEmailField = (form, emailInput)=>form.getFormElem?.().find?.('#Email') ?? emailInput;
const $c14645c1c2ea5c0a$var$showEmailValidationError = (form, formElement, message)=>{
    const emailInput = $c14645c1c2ea5c0a$var$findEmailInput(formElement);
    if (!emailInput) return;
    const marketoEmailField = $c14645c1c2ea5c0a$var$getMarketoEmailField(form, emailInput);
    marketoEmailField.focus?.();
    emailInput.classList.add('mktoInvalid');
    emailInput.setAttribute('aria-invalid', 'true');
    form.showErrorMessage?.(message, marketoEmailField);
};
const $c14645c1c2ea5c0a$export$74cfff971d9af9fa = (form, formElement, localization)=>{
    const emailInput = $c14645c1c2ea5c0a$var$findEmailInput(formElement);
    const emailValue = emailInput?.value.trim() ?? '';
    if (!emailInput || !emailValue) return true;
    if (!$c14645c1c2ea5c0a$var$EMAIL_PATTERN.test(emailValue)) {
        const message = $c14645c1c2ea5c0a$var$getLocalizedValidationMessage(localization, $c14645c1c2ea5c0a$var$EMAIL_VALIDATION_KEY, 'Please enter a valid email address');
        $c14645c1c2ea5c0a$export$371b3f9cdfe752d1(form, false);
        $c14645c1c2ea5c0a$var$showEmailValidationError(form, formElement, message);
        return false;
    }
    const restrictedDomain = $c14645c1c2ea5c0a$export$468caa2e6d59a612(emailValue);
    if (restrictedDomain) {
        $c14645c1c2ea5c0a$export$371b3f9cdfe752d1(form, false);
        $c14645c1c2ea5c0a$var$showEmailValidationError(form, formElement, $c14645c1c2ea5c0a$var$getBusinessEmailValidationMessage(localization, restrictedDomain));
        return false;
    }
    $c14645c1c2ea5c0a$export$371b3f9cdfe752d1(form, true);
    return true;
};

});



parcelRegister("96bxg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c23a9551caa87274$export$2e2bcd8739ae039; });
/* migration-placeholder.tsx generated by @compiled/babel-plugin v0.28.8 */ parcelRequire("7VQPk");
parcelRequire("1oC0p");

parcelRequire("kbpa7");
/**
 * Migration Placeholder component.
 *
 * Rendered by the AI migration agent when a Magnolia section cannot be mapped
 * confidently to a Uniform component. In production (NODE_ENV === "production")
 * this renders nothing so that placeholder sections are invisible to end-users.
 * In all other environments (dev, staging, preview) it renders a clearly-visible
 * red banner showing the suggested component name and a link to the source page,
 * so that reviewers can quickly identify and replace it.
 */ const $c23a9551caa87274$var$UniformMigrationPlaceholder = ({ suggestedComponent: suggestedComponent, reviewerTag: reviewerTag, confidence: confidence, sectionName: sectionName, sectionId: sectionId, sourcePageUrl: sourcePageUrl })=>{
    return null;
};
var $c23a9551caa87274$export$2e2bcd8739ae039 = $c23a9551caa87274$var$UniformMigrationPlaceholder;

});

parcelRegister("iSxa6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d66bc09b4415831b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $euqle = parcelRequire("euqle");

var $lTkkF = parcelRequire("lTkkF");
const $d66bc09b4415831b$var$UniformMobileApp = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $euqle.MobileApp), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkLabel: props.linkLabel,
        linkHref: props.linkHref,
        linkDataEventProps: {
            'data-product-key': 'uniform',
            'data-event': 'clicked',
            'data-event-component': 'linkButton',
            'data-event-container': 'mobileAppSection'
        },
        imageSrc: props.imageSrc,
        imageAlt: props.imageAlt,
        appleAppStoreUrl: props.appleAppStoreUrl,
        googlePlayStoreUrl: props.googlePlayStoreUrl
    });
};
var $d66bc09b4415831b$export$2e2bcd8739ae039 = $d66bc09b4415831b$var$UniformMobileApp;

});
parcelRegister("euqle", function(module, exports) {
$parcel$export(module.exports, "MobileApp", function () { return $dec4263d3b3e8269$export$f81bbe9088ca57b0; });
/* mobile-app.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $2axoc = parcelRequire("2axoc");

var $bSVv5 = parcelRequire("bSVv5");
const $dec4263d3b3e8269$export$f81bbe9088ca57b0 = ({ title: title, description: description, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, imageSrc: imageSrc, imageAlt: imageAlt = '', appleAppStoreUrl: appleAppStoreUrl, googlePlayStoreUrl: googlePlayStoreUrl })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleAppStoreClick = (0, $1oC0p.useCallback)((store)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: store === 'apple' ? 'appleAppStore' : 'googlePlayStore',
            source: 'mobileAppSection',
            attributes: {
                label: store === 'apple' ? 'Download on the Apple App Store' : 'Get it on the Google Play Store'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1pfhxncg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yd3xy5q _40tuxncg _1mou1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                        title: title,
                        titleAs: "h2",
                        text: description,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref,
                                ...linkDataEventProps && {
                                    dataEventProps: linkDataEventProps
                                }
                            }
                        } : undefined
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulppxbi _1pfhxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: appleAppStoreUrl,
                                onClick: ()=>handleAppStoreClick('apple'),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3g0xj4162q6vj8iis1nr5pkh2scjm13a.png",
                                    alt: intl.formatMessage({
                                        id: 'mobile-app.apple-store-alt',
                                        defaultMessage: 'Download on the Apple App Store'
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: googlePlayStoreUrl,
                                onClick: ()=>handleAppStoreClick('google'),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/md1w60b88865q56fl84744t5u0heh751.png",
                                    alt: intl.formatMessage({
                                        id: 'mobile-app.google-play-alt',
                                        defaultMessage: 'Get it on the Google Play Store'
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: imageSrc,
                    alt: imageAlt,
                    className: (0, $2jatx.default)([
                        "_glte1osq _165t1pna _12rrk5xz _1vkhidpf _1x6l1osq _1bsb1osq _4t3ia91z _5ral1dfr _rsufq0ho"
                    ])
                })
            })
        ]
    });
};
const $dec4263d3b3e8269$var$sectionStyles = null;
const $dec4263d3b3e8269$var$leftSideContentStyles = null;
const $dec4263d3b3e8269$var$appStoreLinksContainerStyles = null;
const $dec4263d3b3e8269$var$imageContainerStyles = null;
const $dec4263d3b3e8269$var$imageStyles = null;

});


parcelRegister("lATol", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5a6303ec758cb0a2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $60KY6 = parcelRequire("60KY6");
// Pass modalSize as the width directly to the Modal component
const $5a6303ec758cb0a2$var$UniformModal = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $60KY6.ModalLink), {
        modalTitle: props.modalTitle,
        modalCloseLabel: props.modalCloseLabel,
        ctaText: props.ctaText,
        modalWidth: props.modalSize,
        modalLinkType: props.modalLinkType,
        modalDataEventProps: {
            'data-product-key': 'uniform',
            'data-event': 'clicked',
            'data-event-component': 'linkButton',
            'data-event-container': 'modal'
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "modalContent"
        })
    });
};
var $5a6303ec758cb0a2$export$2e2bcd8739ae039 = $5a6303ec758cb0a2$var$UniformModal;

});
parcelRegister("60KY6", function(module, exports) {
$parcel$export(module.exports, "ModalLink", function () { return $6d4cc7ee45c7a136$export$cf363aa9ce73688b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iPPTB = parcelRequire("iPPTB");

var $660KI = parcelRequire("660KI");
const $6d4cc7ee45c7a136$export$cf363aa9ce73688b = ({ modalTitle: modalTitle, modalCloseLabel: modalCloseLabel, children: children, ctaText: ctaText, modalWidth: modalWidth, modalLinkType: modalLinkType = 'modal', modalDataEventProps: modalDataEventProps })=>{
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const openModal = (e)=>{
        e.preventDefault();
        setIsOpen(true);
    };
    const closeModal = (0, $1oC0p.useCallback)(()=>setIsOpen(false), []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                onClick: openModal,
                "aria-label": 'modal-link',
                text: ctaText,
                href: "#modal-section",
                type: modalLinkType,
                dataEventProps: modalDataEventProps
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $660KI.Modal), {
                closeModal: closeModal,
                closeLabel: modalCloseLabel,
                title: modalTitle,
                isOpen: isOpen,
                width: modalWidth,
                children: children
            })
        ]
    });
};

});


parcelRegister("1dXNn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00319547551a5f9c$export$2e2bcd8739ae039; });
/* nav-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eOIix = parcelRequire("eOIix");

var $2Df35 = parcelRequire("2Df35");

var $cR2Ov = parcelRequire("cR2Ov");

var $hcVGp = parcelRequire("hcVGp");

var $gn6Qa = parcelRequire("gn6Qa");

var $7FUnn = parcelRequire("7FUnn");
const $00319547551a5f9c$var$getStringParameter = (component, parameterId)=>{
    const value = component.parameters?.[parameterId]?.value;
    return typeof value === 'string' ? value : undefined;
};
const $00319547551a5f9c$var$getSlot = (component, slotId)=>component.slots?.[slotId] ?? [];
const $00319547551a5f9c$var$toDropdownLink = (component, productKey)=>{
    if (component.type !== 'navLink') return;
    const text = $00319547551a5f9c$var$getStringParameter(component, 'linkText');
    const href = $00319547551a5f9c$var$getStringParameter(component, 'linkUrl');
    if (!text || !href) return;
    return {
        text: text,
        href: href,
        dataEventProps: {
            'data-product-key': productKey,
            'data-event': 'clicked',
            'data-event-component': 'linkButton',
            'data-event-container': 'navbarDropdown'
        }
    };
};
const $00319547551a5f9c$var$toDropdownSections = (dropdownItems, productKey)=>{
    const contentItems = [];
    let directLinks = [];
    const flushDirectLinks = ()=>{
        if (directLinks.length > 0) {
            contentItems.push({
                links: directLinks
            });
            directLinks = [];
        }
    };
    dropdownItems.forEach((item)=>{
        const directLink = $00319547551a5f9c$var$toDropdownLink(item, productKey);
        if (directLink) {
            directLinks.push(directLink);
            return;
        }
        if (item.type === 'navDropdownGroup') {
            flushDirectLinks();
            const header = $00319547551a5f9c$var$getStringParameter(item, 'heading');
            const links = $00319547551a5f9c$var$getSlot(item, 'navLinks').map((link)=>$00319547551a5f9c$var$toDropdownLink(link, productKey)).filter((link)=>Boolean(link));
            if (links.length > 0) contentItems.push({
                header: header,
                links: links
            });
            return;
        }
        if (item.type === 'horizontalDivider') {
            flushDirectLinks();
            const authoredLineStyle = $00319547551a5f9c$var$getStringParameter(item, 'lineStyle');
            const lineStyle = authoredLineStyle === 'dotted' ? 'dotted' : 'solid';
            contentItems.push({
                divider: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7FUnn.default), {
                    lineStyle: lineStyle
                })
            });
        }
    });
    flushDirectLinks();
    return contentItems.filter((item, index, items)=>{
        const previousItem = items[index - 1];
        return !('divider' in item) || previousItem !== undefined && !('divider' in previousItem) && items.slice(index + 1).some((laterItem)=>!('divider' in laterItem));
    });
};
const $00319547551a5f9c$var$toNavLink = (component, index, productKey)=>{
    const globalLinksKey = component._id ?? `${component.type}-${index}`;
    if (component.type === 'navLink') {
        const link = $00319547551a5f9c$var$toDropdownLink(component, productKey);
        if (!link) return;
        return {
            globalLinksKey: globalLinksKey,
            linkText: link.text,
            href: link.href,
            hasDropdown: false,
            productKey: productKey
        };
    }
    if (component.type !== 'navDropdown') return;
    const linkText = $00319547551a5f9c$var$getStringParameter(component, 'dropdownText');
    const contentSections = $00319547551a5f9c$var$toDropdownSections($00319547551a5f9c$var$getSlot(component, 'navItems'), productKey);
    const hasDivider = contentSections.some((section)=>'divider' in section);
    const activeHrefs = contentSections.flatMap((section)=>'divider' in section ? [] : section.links.map((link)=>link.href).filter(Boolean));
    if (!linkText || contentSections.length === 0) return;
    return {
        globalLinksKey: globalLinksKey,
        linkText: linkText,
        hasDropdown: true,
        productKey: productKey,
        activeHrefs: activeHrefs,
        containerPosition: 'relative',
        containerStyles: {
            width: 'fit-content'
        },
        content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
            contentSections: contentSections,
            orientation: hasDivider ? 'column' : undefined
        })
    };
};
const $00319547551a5f9c$var$toMobileLinks = (links)=>links.map((link)=>({
            globalLinksKey: link.globalLinksKey,
            linkText: link.linkText,
            hasDropdown: link.hasDropdown,
            href: link.hasDropdown ? undefined : link.href,
            productKey: link.productKey,
            dropdownType: link.hasDropdown ? link.globalLinksKey : undefined
        }));
const $00319547551a5f9c$var$logoBrandByProductKey = {
    atlassianGuard: 'guard',
    jiraServiceManagementAssets: 'assets',
    bamboo: 'bamboo',
    bitbucket: 'bitbucket',
    compass: 'compass',
    confluence: 'confluence',
    crucible: 'crucible',
    customerServiceManagement: 'customerservicemanagement',
    feedback: 'feedback',
    focus: 'focus',
    foundation: 'foundation',
    jira: 'jira',
    jiraAlign: 'jiraalign',
    jiraProductDiscovery: 'jiraproductdiscovery',
    jiraServiceDesk: 'jiraservicemanagement',
    jiraServiceManagement: 'jiraservicemanagement',
    jiraSoftware: 'jira',
    jiraWorkManagement: 'jira',
    loom: 'loom',
    rovo: 'rovo',
    rovoDev: 'rovodev',
    sourcetreeapp: 'sourcetree',
    statuspage: 'statuspage',
    talent: 'talent',
    trello: 'trello'
};
const $00319547551a5f9c$var$getLogoBrand = (productKey)=>productKey === undefined ? undefined : $00319547551a5f9c$var$logoBrandByProductKey[productKey];
const $00319547551a5f9c$var$productLabelStyle = null;
const $00319547551a5f9c$var$UniformNavBar = ({ component: component, type: type, primaryLabel: primaryLabel, productKey: productKey, primaryUrl: primaryUrl, ctaText: ctaText, ctaUrl: ctaUrl, ctaButtonVariant: ctaButtonVariant = 'primary' })=>{
    const analyticsProductKey = productKey ?? 'uniform';
    const navItems = component.slots?.['navItems'] ?? [];
    const navLinks = navItems.map((item, index)=>$00319547551a5f9c$var$toNavLink(item, index, analyticsProductKey)).filter((link)=>Boolean(link));
    const hasCta = Boolean(ctaText && ctaUrl);
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    if (type === 'compound') {
        const compoundNav = {
            compoundSubNavTitle: primaryLabel,
            compoundSubNavTitleHref: primaryUrl,
            compoundSubNavLinksProps: navLinks,
            productKey: analyticsProductKey,
            optionalClassName: 'collections-nav'
        };
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
            productKey: analyticsProductKey,
            compoundNav: compoundNav
        });
    }
    if (type !== 'product') return null;
    const logoBrand = $00319547551a5f9c$var$getLogoBrand(productKey);
    const productLogo = logoBrand ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: logoBrand,
        type: "logo",
        appearance: "brand",
        height: "26px",
        darkTheme: isDarkTheme
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1wybv47k _k48p1pd9 _vwz4gktf _syazl3em"
        ]),
        children: primaryLabel
    });
    const mobileLinks = [
        {
            mobileLinkKey: 'uniform-nav-links',
            mobileLinksProps: $00319547551a5f9c$var$toMobileLinks(navLinks)
        }
    ];
    const additionalMenuPageObjectsArray = navLinks.flatMap((link)=>link.hasDropdown && /*#__PURE__*/ (0, $1oC0p.isValidElement)(link.content) ? [
            {
                menuPageKey: link.globalLinksKey,
                menuPageObjects: link.content
            }
        ] : []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
        productLogo: productLogo,
        mobileLogo: productLogo,
        productLogoUrl: primaryUrl,
        productLogoAriaLabel: primaryLabel,
        productKey: analyticsProductKey,
        productPageNavLinks: navLinks,
        mobileLinksSections: mobileLinks,
        additionalMenuPageObjectsArray: additionalMenuPageObjectsArray,
        isShowTryNowLink: hasCta,
        isIncludeMobileCTA: hasCta,
        navigationTrynowCtaText: hasCta ? ctaText : undefined,
        navigationTrynowCtaUrl: hasCta ? ctaUrl : undefined,
        navigationTrynowCtaButtonVariant: ctaButtonVariant,
        mobileCtaText: hasCta ? ctaText : undefined,
        mobileCtaUrl: hasCta ? ctaUrl : undefined,
        mobileCtaButtonVariant: ctaButtonVariant
    });
};
var $00319547551a5f9c$export$2e2bcd8739ae039 = $00319547551a5f9c$var$UniformNavBar;

});

parcelRegister("dXbVO", function(module, exports) {
$parcel$export(module.exports, "resolveNavigationTabHref", function () { return $27ec3900e5df732f$export$f0babb472a71211; });
$parcel$export(module.exports, "default", function () { return $27ec3900e5df732f$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");
const $27ec3900e5df732f$export$f0babb472a71211 = (href, urlSlug)=>{
    const resolvedHref = typeof href === 'string' ? href : href?.path;
    return resolvedHref || urlSlug;
};
const $27ec3900e5df732f$var$UniformNavigationTab = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "tabContents"
    });
var $27ec3900e5df732f$export$2e2bcd8739ae039 = $27ec3900e5df732f$var$UniformNavigationTab;

});

parcelRegister("3fweY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8a883e9ccb504427$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $hPhTP = parcelRequire("hPhTP");

var $dXbVO = parcelRequire("dXbVO");
const $8a883e9ccb504427$var$getNavigationTabParameters = (item)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).isValidElement(item)) return undefined;
    const props = item.props;
    if (props.data?.parameters) return props.data.parameters;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.toArray(props.children).map($8a883e9ccb504427$var$getNavigationTabParameters).find((parameters)=>parameters !== undefined);
};
const $8a883e9ccb504427$var$getParameterValue = (parameter)=>{
    if (typeof parameter === 'string' || typeof parameter === 'boolean' || parameter === undefined) return parameter;
    if ('path' in parameter) return parameter;
    return parameter.value;
};
const $8a883e9ccb504427$var$getStringParameterValue = (parameter)=>{
    const value = $8a883e9ccb504427$var$getParameterValue(parameter);
    return typeof value === 'string' ? value : undefined;
};
const $8a883e9ccb504427$var$getLinkParameterValue = (parameter)=>{
    const value = $8a883e9ccb504427$var$getParameterValue(parameter);
    return typeof value === 'boolean' ? undefined : value;
};
const $8a883e9ccb504427$var$UniformNavigationTabs = ({ appearance: appearance, layout: layout = 'stacked', eyebrow: eyebrow, showControls: showControls, useHistoryRouting: useHistoryRouting = false })=>{
    const renderNavigationTabs = (0, $1oC0p.useCallback)(({ items: items })=>{
        const tabsData = items.flatMap((item, index)=>{
            const params = $8a883e9ccb504427$var$getNavigationTabParameters(item);
            const href = (0, $dXbVO.resolveNavigationTabHref)($8a883e9ccb504427$var$getLinkParameterValue(params?.['href']), $8a883e9ccb504427$var$getStringParameterValue(params?.['urlSlug']));
            if (!href) return [];
            return [
                {
                    id: $8a883e9ccb504427$var$getParameterValue(params?.['id']) ?? `navigation-tab-${index}`,
                    title: $8a883e9ccb504427$var$getParameterValue(params?.['title']) ?? $8a883e9ccb504427$var$getParameterValue(params?.['label']),
                    href: href,
                    iconUrl: $8a883e9ccb504427$var$getParameterValue(params?.['iconUrl']),
                    iconSize: $8a883e9ccb504427$var$getParameterValue(params?.['iconSize']),
                    disableIconPadding: $8a883e9ccb504427$var$getParameterValue(params?.['disableIconPadding']),
                    tabComponent: item
                }
            ];
        });
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hPhTP.NavigationTabsSection), {
            tabsData: tabsData,
            appearance: appearance,
            layout: layout,
            eyebrow: eyebrow,
            showControls: showControls,
            useHistoryRouting: useHistoryRouting
        });
    }, [
        appearance,
        eyebrow,
        layout,
        showControls,
        useHistoryRouting
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "navigationItems",
        wrapperComponent: renderNavigationTabs
    });
};
var $8a883e9ccb504427$export$2e2bcd8739ae039 = $8a883e9ccb504427$var$UniformNavigationTabs;

});
parcelRegister("hPhTP", function(module, exports) {
$parcel$export(module.exports, "NavigationTabsSection", function () { return $be9f3c46d89b2cc3$export$5f25d9f2ad875810; });
/* navigation-tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $6C7e6 = parcelRequire("6C7e6");

var $80kL5 = parcelRequire("80kL5");

var $kRNnF = parcelRequire("kRNnF");
const $be9f3c46d89b2cc3$var$sectionCss = null;
const $be9f3c46d89b2cc3$var$stackedSectionCss = null;
const $be9f3c46d89b2cc3$var$gridMaxWidth = (0, $6C7e6.WCL_GRID_MAX_WIDTH) + (0, $6C7e6.WCL_GRID_PADDING_LG) * 2;
const $be9f3c46d89b2cc3$var$navigationTabsGridFrameCss = null;
const $be9f3c46d89b2cc3$var$navigationTabsGridCss = null;
const $be9f3c46d89b2cc3$var$navigationTabsGridSpanCss = null;
const $be9f3c46d89b2cc3$var$contentCss = null;
const $be9f3c46d89b2cc3$var$normalizePathname = (href)=>{
    const parsed = new URL(href, window.location.origin);
    const segments = parsed.pathname.split('/');
    if ((0, $80kL5.isValidLocale)(segments[1] ?? '')) segments.splice(1, 1);
    const pathname = segments.join('/').replace(/\/+$/, '');
    return pathname || '/';
};
const $be9f3c46d89b2cc3$var$isEligibleHistoryActivation = (event, href)=>{
    const target = event.currentTarget.target.trim().toLowerCase();
    return !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.altKey && !event.ctrlKey && !event.shiftKey && (!target || target === '_self') && !event.currentTarget.hasAttribute('download') && new URL(href, window.location.origin).origin === window.location.origin;
};
const $be9f3c46d89b2cc3$export$5f25d9f2ad875810 = ({ tabsData: tabsData, appearance: appearance = 'wide', layout: layout = 'stacked', useHistoryRouting: useHistoryRouting = false, eyebrow: eyebrow, showControls: showControls = layout === 'overflow' })=>{
    const [activeHref, setActiveHref] = (0, $1oC0p.useState)();
    const resolveActiveHref = (0, $1oC0p.useCallback)(()=>{
        const pathname = $be9f3c46d89b2cc3$var$normalizePathname(window.location.href);
        return tabsData.find((tab)=>{
            const destination = new URL(tab.href, window.location.origin);
            return destination.origin === window.location.origin && $be9f3c46d89b2cc3$var$normalizePathname(tab.href) === pathname;
        })?.href;
    }, [
        tabsData
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const synchronize = ()=>setActiveHref(resolveActiveHref());
        synchronize();
        window.addEventListener('popstate', synchronize);
        return ()=>window.removeEventListener('popstate', synchronize);
    }, [
        resolveActiveHref
    ]);
    const onLinkClick = (0, $1oC0p.useCallback)((event, href)=>{
        if (!$be9f3c46d89b2cc3$var$isEligibleHistoryActivation(event, href)) return;
        event.preventDefault();
        const destination = new URL(href, window.location.origin);
        window.history.pushState(null, '', `${destination.pathname}${destination.search}${destination.hash}`);
        setActiveHref(resolveActiveHref());
    }, [
        resolveActiveHref
    ]);
    const activeTab = tabsData.find((tab)=>tab.href === activeHref);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        id: "navigation-tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12f1osq _1ul9idpf _1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
            layout === 'stacked' && "_ca0qgktf _u5f3idpf _n3tdgktf _19bvidpf _4cvr1h6o _zulp1ejb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kRNnF.NavigationTabsList), {
                tabsData: tabsData,
                appearance: appearance,
                layout: layout,
                eyebrow: eyebrow,
                showControls: showControls,
                activeHref: activeHref,
                onLinkClick: useHistoryRouting ? onLinkClick : undefined
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "navigation-tabs-grid",
                className: (0, $2jatx.default)([
                    "_vchhusvi _1bsb1osq _p12f1osq _195g1wug _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                    "_1e0c11p5 _yv0ecx6w"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _1ul9idpf",
                        "_yyhyjvu9 _1ul9idpf"
                    ]),
                    children: activeTab?.tabComponent
                })
            })
        ]
    });
};

});
parcelRegister("kRNnF", function(module, exports) {
$parcel$export(module.exports, "NavigationTabsList", function () { return $e57524a87e5d2fa0$export$453926ee57223b73; });
/* navigation-tabs-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $bwWCK = parcelRequire("bwWCK");

var $kbpa7 = parcelRequire("kbpa7");

var $6C7e6 = parcelRequire("6C7e6");

var $hEHzK = parcelRequire("hEHzK");

var $cZGiX = parcelRequire("cZGiX");
const $e57524a87e5d2fa0$var$navigationCss = null;
const $e57524a87e5d2fa0$var$headerCss = null;
const $e57524a87e5d2fa0$var$eyebrowCss = null;
const $e57524a87e5d2fa0$var$gridMaxWidth = (0, $6C7e6.WCL_GRID_MAX_WIDTH) + (0, $6C7e6.WCL_GRID_PADDING_LG) * 2;
const $e57524a87e5d2fa0$var$navigationTabsGridFrameCss = null;
const $e57524a87e5d2fa0$var$navigationTabsOverflowCss = null;
const $e57524a87e5d2fa0$var$controlsCss = null;
const $e57524a87e5d2fa0$var$viewportCss = null;
const $e57524a87e5d2fa0$var$listCss = null;
const $e57524a87e5d2fa0$var$stackedListCss = null;
const $e57524a87e5d2fa0$var$wideStackedListCss = null;
const $e57524a87e5d2fa0$var$overflowListCss = null;
const $e57524a87e5d2fa0$var$itemCss = null;
const $e57524a87e5d2fa0$export$453926ee57223b73 = ({ tabsData: tabsData, appearance: appearance, layout: layout, eyebrow: eyebrow, showControls: showControls, activeHref: activeHref, onLinkClick: onLinkClick })=>{
    const intl = (0, $8e22h.default)();
    const scroll = (0, $cZGiX.useNavigationTabsScroll)();
    const controlDistance = scroll.viewportRef.current?.clientWidth ?? 300;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
        "aria-label": intl.formatMessage({
            id: 'navigation-tabs.navigation-label',
            defaultMessage: 'Navigation tabs'
        }),
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12f1osq _1ul9idpf"
        ]),
        children: [
            (eyebrow || showControls) && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                "data-testid": "navigation-tabs-header",
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1e0c1txw _4cvr1h6o _1bah1yb4 _6rthv47k",
                    "_vchhusvi _1bsb1osq _p12f1osq _195g1wug _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx"
                ]),
                children: [
                    eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        "data-testid": "navigation-tabs-eyebrow",
                        className: (0, $2jatx.default)([
                            "_1mouidpf _12l21wug _syaz1pfd _1iqs1jhh _ect4z4z1 _1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4f6fq _y3gn1e5h _1p1dangw"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: eyebrow
                    }),
                    showControls && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "navigation-tabs-controls",
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _ahbq1wug"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bwWCK.GalleryControls), {
                            iconAppearance: "chevron",
                            onPrevious: ()=>scroll.scrollBy(-controlDistance),
                            onNext: ()=>scroll.scrollBy(controlDistance),
                            isFirstItemVisible: !scroll.scrollState.canScrollPrevious,
                            isLastItemVisible: !scroll.scrollState.canScrollNext
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: scroll.viewportRef,
                "data-testid": "navigation-tabs-viewport",
                onPointerDown: scroll.onPointerDown,
                onPointerMove: scroll.onPointerMove,
                onPointerUp: scroll.onPointerEnd,
                onPointerCancel: scroll.onPointerCancel,
                onLostPointerCapture: scroll.onLostPointerCapture,
                onClickCapture: scroll.onClickCapture,
                className: (0, $2jatx.default)([
                    "_1bsb1osq _p12f1osq _1ul9idpf _1reo1wug _kpfhglyw _1cicglyw",
                    layout === 'overflow' && "_vchhusvi _1bsb1osq _p12f1osq _bozg1a44 _y4tiidpf _fitg1a44 _auqu1vi7 _5dgq1wqb _1818osjt"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                    ref: scroll.listRef,
                    "data-layout": layout,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _zulpu2gc",
                        layout === 'stacked' ? "_1bsb1osq _1n261tfl" : "_1bsb1ris _1n261q9c",
                        appearance === 'wide' && layout === 'stacked' && "_1bah1h6o"
                    ]),
                    children: tabsData.map((tab)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            className: (0, $2jatx.default)([
                                "_1o9zidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hEHzK.NavigationTabsLink), {
                                ...tab,
                                appearance: appearance,
                                isActive: activeHref === tab.href,
                                onClick: onLinkClick ? (event)=>onLinkClick(event, tab.href) : undefined
                            })
                        }, tab.id))
                })
            })
        ]
    });
};

});
parcelRegister("hEHzK", function(module, exports) {
$parcel$export(module.exports, "NavigationTabsLink", function () { return $c05f11395cb26058$export$12ce4efff8e59253; });
/* navigation-tabs-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $c05f11395cb26058$var$iconDimensions = {
    'x-small': '24px',
    small: '32px',
    medium: '40px',
    large: '48px'
};
const $c05f11395cb26058$var$linkCss = null;
const $c05f11395cb26058$var$wideLinkCss = null;
const $c05f11395cb26058$var$compactLinkCss = null;
const $c05f11395cb26058$var$inactiveLinkCss = null;
const $c05f11395cb26058$var$wideInactiveLinkCss = null;
const $c05f11395cb26058$var$compactInactiveLinkCss = null;
const $c05f11395cb26058$var$activeLinkCss = null;
const $c05f11395cb26058$var$wideActiveLinkCss = null;
const $c05f11395cb26058$var$compactIconCss = null;
const $c05f11395cb26058$var$noIconPaddingCss = null;
const $c05f11395cb26058$export$12ce4efff8e59253 = ({ title: title, href: href, iconUrl: iconUrl, iconSize: iconSize, disableIconPadding: disableIconPadding, appearance: appearance, isActive: isActive, onClick: onClick })=>{
    const size = iconSize ?? 'x-small';
    const icon = iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        src: iconUrl,
        alt: "",
        width: $c05f11395cb26058$var$iconDimensions[size],
        height: $c05f11395cb26058$var$iconDimensions[size],
        draggable: false
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
        href: href,
        "aria-current": isActive ? 'page' : undefined,
        onClick: onClick,
        "data-product-key": "uniform",
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "navigationTabs",
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _syaz1kw7 _4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke _1ygb1qgu _1ah3yh40",
            appearance === 'wide' ? "_zulpu2gc _o5721q9c _ca0q1crf _u5f37vkz _n3td1crf _19bv7vkz _19it1vrj _2rko53f4" : "_2lx21bp4 _zulp1b66 _1ul911ux _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _2rko19bv _y3gn1h6o",
            isActive ? "_bfhk1bjw _k48p1fw0 _4bfu1r31 _1hms8stv _ajmmnqa1" : "_bfhkdkka",
            appearance === 'wide' && !isActive && "_bfhkg7ng",
            appearance === 'compact' && !isActive && "_bfhkg7ng",
            appearance === 'wide' && isActive && "_19it1qgu"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: [
            appearance === 'compact' && icon ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _1bah1h6o _ca0q19bv _u5f37vkz _n3td19bv _19bv7vkz",
                    disableIconPadding && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: icon
            }) : icon,
            title
        ]
    });
};

});

parcelRegister("cZGiX", function(module, exports) {
$parcel$export(module.exports, "useNavigationTabsScroll", function () { return $7b1d18deeca807cd$export$3f9d4f813c40a67a; });

var $1oC0p = parcelRequire("1oC0p");
const $7b1d18deeca807cd$var$SCROLL_BOUNDARY_TOLERANCE = 1;
const $7b1d18deeca807cd$var$DRAG_THRESHOLD = 15;
const $7b1d18deeca807cd$export$3f9d4f813c40a67a = ()=>{
    const viewportRef = (0, $1oC0p.useRef)(null);
    const listRef = (0, $1oC0p.useRef)(null);
    const dragStateRef = (0, $1oC0p.useRef)();
    const suppressClickRef = (0, $1oC0p.useRef)(false);
    const [scrollState, setScrollState] = (0, $1oC0p.useState)({
        canScrollPrevious: false,
        canScrollNext: false,
        isScrollable: false
    });
    const clearDrag = (0, $1oC0p.useCallback)((pointerId)=>{
        const viewport = viewportRef.current;
        const activePointerId = pointerId ?? dragStateRef.current?.pointerId;
        if (viewport && activePointerId !== undefined && viewport.hasPointerCapture(activePointerId)) viewport.releasePointerCapture(activePointerId);
        dragStateRef.current = undefined;
    }, []);
    const clearAllDragState = (0, $1oC0p.useCallback)((pointerId)=>{
        clearDrag(pointerId);
        suppressClickRef.current = false;
    }, [
        clearDrag
    ]);
    const updateScrollState = (0, $1oC0p.useCallback)(()=>{
        const viewport = viewportRef.current;
        if (!viewport) return;
        const isScrollable = viewport.scrollWidth > viewport.clientWidth + $7b1d18deeca807cd$var$SCROLL_BOUNDARY_TOLERANCE;
        setScrollState({
            isScrollable: isScrollable,
            canScrollPrevious: isScrollable && viewport.scrollLeft > $7b1d18deeca807cd$var$SCROLL_BOUNDARY_TOLERANCE,
            canScrollNext: isScrollable && viewport.scrollLeft < viewport.scrollWidth - viewport.clientWidth - $7b1d18deeca807cd$var$SCROLL_BOUNDARY_TOLERANCE
        });
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        const viewport = viewportRef.current;
        if (!viewport) return;
        const resizeObserver = typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(updateScrollState);
        resizeObserver?.observe(viewport);
        if (listRef.current) resizeObserver?.observe(listRef.current);
        viewport.addEventListener('scroll', updateScrollState, {
            passive: true
        });
        updateScrollState();
        return ()=>{
            resizeObserver?.disconnect();
            viewport.removeEventListener('scroll', updateScrollState);
            clearAllDragState();
        };
    }, [
        clearAllDragState,
        updateScrollState
    ]);
    const scrollBy = (0, $1oC0p.useCallback)((distance)=>{
        const viewport = viewportRef.current;
        if (!viewport) return;
        viewport.scrollBy({
            left: distance,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
    }, []);
    const onPointerDown = (0, $1oC0p.useCallback)((event)=>{
        const viewport = viewportRef.current;
        clearAllDragState();
        if (!viewport || !event.isPrimary || event.button !== 0 || viewport.scrollWidth <= viewport.clientWidth) return;
        dragStateRef.current = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startScrollLeft: viewport.scrollLeft
        };
        viewport.setPointerCapture(event.pointerId);
    }, [
        clearAllDragState
    ]);
    const onPointerMove = (0, $1oC0p.useCallback)((event)=>{
        const viewport = viewportRef.current;
        const dragState = dragStateRef.current;
        if (!viewport || !dragState || dragState.pointerId !== event.pointerId) return;
        const distance = event.clientX - dragState.startX;
        if (Math.abs(distance) > $7b1d18deeca807cd$var$DRAG_THRESHOLD) suppressClickRef.current = true;
        viewport.scrollLeft = dragState.startScrollLeft - distance;
    }, []);
    const onPointerEnd = (0, $1oC0p.useCallback)((event)=>clearDrag(event.pointerId), [
        clearDrag
    ]);
    const onPointerCancel = (0, $1oC0p.useCallback)((event)=>clearAllDragState(event.pointerId), [
        clearAllDragState
    ]);
    const onLostPointerCapture = (0, $1oC0p.useCallback)((event)=>clearDrag(event.pointerId), [
        clearDrag
    ]);
    const onClickCapture = (0, $1oC0p.useCallback)((event)=>{
        if (!suppressClickRef.current) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClickRef.current = false;
    }, []);
    return {
        viewportRef: viewportRef,
        listRef: listRef,
        scrollState: scrollState,
        updateScrollState: updateScrollState,
        scrollBy: scrollBy,
        onPointerDown: onPointerDown,
        onPointerMove: onPointerMove,
        onPointerEnd: onPointerEnd,
        onPointerCancel: onPointerCancel,
        onLostPointerCapture: onLostPointerCapture,
        onClickCapture: onClickCapture
    };
};

});




parcelRegister("3E1lH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d007356a760321ff$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $8e22h = parcelRequire("8e22h");

var $i4BST = parcelRequire("i4BST");

var $1pIeE = parcelRequire("1pIeE");

var $9D78w = parcelRequire("9D78w");

var $eOIix = parcelRequire("eOIix");

var $bTseT = parcelRequire("bTseT");

var $cdqsq = parcelRequire("cdqsq");

var $CBwmG = parcelRequire("CBwmG");

var $2Df35 = parcelRequire("2Df35");

var $jsxHL = parcelRequire("jsxHL");

var $iLjCW = parcelRequire("iLjCW");

var $hcVGp = parcelRequire("hcVGp");

var $11JLp = parcelRequire("11JLp");

var $lT2z5 = parcelRequire("lT2z5");

var $7Sdq5 = parcelRequire("7Sdq5");

var $6VSBC = parcelRequire("6VSBC");

var $5W3jS = parcelRequire("5W3jS");

var $fbo5H = parcelRequire("fbo5H");

var $atyps = parcelRequire("atyps");

var $lgKym = parcelRequire("lgKym");

var $hCHU3 = parcelRequire("hCHU3");

var $1iUL9 = parcelRequire("1iUL9");

var $g2lQR = parcelRequire("g2lQR");

var $aYwTu = parcelRequire("aYwTu");

var $8IN8s = parcelRequire("8IN8s");

var $cimg4 = parcelRequire("cimg4");

var $aYVVm = parcelRequire("aYVVm");

var $4c8eJ = parcelRequire("4c8eJ");

var $1K6kz = parcelRequire("1K6kz");

var $3wzIU = parcelRequire("3wzIU");

var $cQSG9 = parcelRequire("cQSG9");

var $cF9FY = parcelRequire("cF9FY");

var $hfydu = parcelRequire("hfydu");

var $3yqd8 = parcelRequire("3yqd8");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $9xKEy = parcelRequire("9xKEy");

var $17RBn = parcelRequire("17RBn");

var $8MWwK = parcelRequire("8MWwK");

var $cMLH3 = parcelRequire("cMLH3");

var $lpEyw = parcelRequire("lpEyw");

var $8xC9Z = parcelRequire("8xC9Z");
/**
 * GWP-12151: maps the 1mind experiment cell to its vendor deployment id. The
 * `control` cell is intentionally absent (no launcher — keep the current chat).
 */ const $d007356a760321ff$var$ONE_MIND_DEPLOYMENT_BY_VARIANT = {
    ai_guide: (0, $cdqsq.ONE_MIND_DEPLOYMENTS).aiGuide,
    stephen: (0, $cdqsq.ONE_MIND_DEPLOYMENTS).stephen
};
// Track both `data-dwell-id` elements (the default) and Uniform container
// roots, which are instrumented with `data-uniform-container-id`.
const $d007356a760321ff$var$DWELL_TRACKABILITY = [
    (0, $3yqd8.defaultTrackability),
    (0, $8MWwK.containerTrackability)
];
const $d007356a760321ff$export$6955bcca4cd3539f = (props)=>{
    const { component: component, siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix, dwellTimeEnabled: dwellTimeEnabled, darkTheme: darkTheme, devTheme: devTheme, awf1Theme: awf1Theme, wacRefresh: wacRefresh } = props;
    const fullSiteSelectorProductKey = siteSelectorProductKey === 'jira-service-management' ? 'jira-servicedesk.ondemand' : `${siteSelectorProductKey}.ondemand`;
    const locale = (0, $17RBn.useLocale)();
    const isBootIntercom = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp5381AddIntercomWidgetToUniform);
    const intercomAppId = locale === 'ja' ? 'p0ww63i2' : '';
    const isSalesWidgetBxpWebPlatform = intercomAppId !== '' && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).salesWidgetBxpWebPlatform);
    const contentSlot = component.slots?.['content'] ?? [];
    const navSlot = component.slots?.['nav'] ?? [];
    const pageNavigation = navSlot.length > 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "nav"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($d007356a760321ff$export$f24150b9675a2c65, {
        component: component
    });
    const pageHasGlobalFooterComponent = !!contentSlot.find((content)=>content.type === 'globalFooter');
    const isSalesWidgetBxpWebPlatformDeveloper = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).salesWidgetBxpWebPlatformDeveloper);
    // GWP-12151: the experiment cohort scopes this to the JPD product-discovery
    // page only; on every other Uniform page it is `notEnrolled` and this is a
    // no-op. In the 1mind variant cells we replace the chat provider entirely
    // with the vendor launcher; `control` keeps today's Omnichannel/Intercom.
    const oneMind = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp12151Superhuman1mind);
    const oneMindDeploymentId = oneMind.type === (0, $gIKKj.EnrollmentType).ENROLLED ? $d007356a760321ff$var$ONE_MIND_DEPLOYMENT_BY_VARIANT[oneMind.value] : undefined;
    const pageContent = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $eOIix.ThemeProvider), {
        isDarkEnabled: !!darkTheme,
        isDevEnabled: !!devTheme,
        isAwf1Enabled: !!awf1Theme,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1pIeE.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8xC9Z.OptionalSiteSelectorContextProvider), {
                    siteSelectorProductKey: fullSiteSelectorProductKey,
                    siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                name: "enhancedBannerSlot"
                            })
                        }),
                        pageNavigation,
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                                id: "content",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                    name: "content"
                                })
                            })
                        })
                    ]
                })
            }),
            !pageHasGlobalFooterComponent && /*#__PURE__*/ (0, $7VQPk.jsx)($d007356a760321ff$export$1b198b648cc5b0ce, {
                component: component
            })
        ]
    });
    if (oneMindDeploymentId) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i4BST.WacRefreshProvider), {
        isWacRefresh: wacRefresh,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfydu.DwellTimeContextProvider), {
            enabled: !!dwellTimeEnabled,
            trackability: $d007356a760321ff$var$DWELL_TRACKABILITY,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $CBwmG.OneMindProvider), {
                deploymentId: oneMindDeploymentId,
                variantName: oneMind.type === (0, $gIKKj.EnrollmentType).ENROLLED ? oneMind.value : undefined,
                children: pageContent
            })
        })
    });
    if (isSalesWidgetBxpWebPlatformDeveloper || isSalesWidgetBxpWebPlatform) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i4BST.WacRefreshProvider), {
        isWacRefresh: wacRefresh,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfydu.DwellTimeContextProvider), {
            enabled: !!dwellTimeEnabled,
            trackability: $d007356a760321ff$var$DWELL_TRACKABILITY,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
                children: pageContent
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i4BST.WacRefreshProvider), {
        isWacRefresh: wacRefresh,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfydu.DwellTimeContextProvider), {
            enabled: !!dwellTimeEnabled,
            trackability: $d007356a760321ff$var$DWELL_TRACKABILITY,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
                appId: intercomAppId,
                triggerBoot: isBootIntercom,
                children: pageContent
            })
        })
    });
};
const $d007356a760321ff$export$f24150b9675a2c65 = ({ component: component })=>{
    const intl = (0, $8e22h.default)();
    const pageNavType = component.parameters && component.parameters['nav'] && component.parameters['nav'].value;
    let pageNav;
    switch(pageNavType){
        case 'confluence':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCHU3.default), {});
            break;
        case 'bitbucket':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $atyps.BitbucketNav), {});
            break;
        case 'confluence-template-experiment':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1iUL9.ConfluenceTemplateHeaderContainer), {});
            break;
        case 'collections':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Sdq5.CollectionsCompoundNav), {});
            break;
        case 'enterprise':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6VSBC.default), {});
            break;
        case 'jira-software':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {});
            break;
        case 'jira-service-management':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYVVm.default), {});
            break;
        case 'jira-product-discovery':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYwTu.default), {});
            break;
        case 'gwp-7880-jira-software-templates-experiment':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cimg4.default), {});
            break;
        case 'gwp-7880-jira-service-management-templates-experiment':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4c8eJ.default), {});
            break;
        case 'compass':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lgKym.CompassNav), {});
            break;
        case 'atlassian-access':
        case 'guard':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g2lQR.GuardNav), {});
            break;
        case 'rovo':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3wzIU.RovoNav), {});
            break;
        case 'rovo-dev':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lpEyw.RovoDevNav), {});
            break;
        case 'career-details':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cMLH3.CareerDetailsNavbar), {});
            break;
        case 'loom':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1K6kz.LoomNav), {});
            break;
        case 'sourcetree-app':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cF9FY.SourcetreeAppNav), {});
            break;
        case 'jac':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fbo5H.JacNavbar), {});
            break;
        case 'jsm-anchor':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9D78w.ProductNavBar), {
                productHref: "/software/jira/service-management",
                productName: "jiraservicemanagement",
                ariaLabel: intl.formatMessage({
                    id: 'wacJiraServiceManagementNavigation.logo-label',
                    defaultMessage: 'Jira Service Management logo'
                }),
                dataProductKey: "jiraServiceManagement",
                showFreeHrefButton: false,
                logoLinkWrapperWidth: "279px"
            });
            break;
        case 'simplified-jira-software':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $11JLp.SimplifiedProductNav), {
                productLogoUrl: "/software/jira",
                productLogoAriaLabel: intl.formatMessage({
                    id: 'wacJiraSoftwareNavigation.logo-label',
                    defaultMessage: 'Jira Software logo'
                }),
                productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                    brand: "jira",
                    type: "logo",
                    appearance: "brand",
                    height: "32px",
                    width: "83px"
                }),
                productKey: "jira",
                isShowTryNowLink: false
            });
            break;
        case 'global-nav-no-try-now-cta':
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                productKey: "uniform",
                isShowTryNowLink: false
            });
            break;
        case 'none':
            break;
        case 'global':
        default:
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                productKey: "uniform",
                isShowTryNowLink: true
            });
            break;
    }
    return pageNav;
};
const $d007356a760321ff$export$1b198b648cc5b0ce = ({ component: component })=>{
    const pageFooterType = component.parameters && component.parameters['footer'] && component.parameters['footer'].value;
    let pageFooter;
    switch(pageFooterType){
        case 'bitbucket':
            pageFooter = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lT2z5.BitbucketFooter), {});
            break;
        case 'sourcetree-app':
            pageFooter = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cQSG9.SourcetreeAppFooter), {});
            break;
        case 'foundation':
            pageFooter = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5W3jS.FoundationFooter), {});
            break;
        case 'none':
            break;
        case 'global':
        default:
            pageFooter = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {});
            break;
    }
    return pageFooter;
};
var $d007356a760321ff$export$2e2bcd8739ae039 = $d007356a760321ff$export$6955bcca4cd3539f;

});
parcelRegister("1pIeE", function(module, exports) {
$parcel$export(module.exports, "useProductTemplateContext", function () { return $c8bd6f25249f43f7$export$9aa15cd8273c8730; });
$parcel$export(module.exports, "default", function () { return $c8bd6f25249f43f7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $c8bd6f25249f43f7$var$ProductTemplateContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    template: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTemplate: ()=>{}
});
const $c8bd6f25249f43f7$export$d254455f6d2132ac = ({ children: children })=>{
    const [template, setTemplate] = (0, $1oC0p.useState)(null);
    const value = (0, $1oC0p.useMemo)(()=>({
            template: template,
            setTemplate: setTemplate
        }), [
        template
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($c8bd6f25249f43f7$var$ProductTemplateContext.Provider, {
        value: value,
        children: children
    });
};
const $c8bd6f25249f43f7$export$9aa15cd8273c8730 = ()=>{
    const context = (0, $1oC0p.useContext)($c8bd6f25249f43f7$var$ProductTemplateContext);
    if (!context) throw new Error('useProductTemplateContext must be used within a ProductTemplateContextProvider');
    return context;
};
var $c8bd6f25249f43f7$export$2e2bcd8739ae039 = $c8bd6f25249f43f7$export$d254455f6d2132ac;

});

parcelRegister("cdqsq", function(module, exports) {
$parcel$export(module.exports, "ONE_MIND_DEPLOYMENTS", function () { return $53119d246337efdb$export$f78999e4a0208638; });
$parcel$export(module.exports, "injectOneMindLauncher", function () { return $53119d246337efdb$export$f4b8b6e73d41ec0a; });
$parcel$export(module.exports, "subscribeToOneMindMessages", function () { return $53119d246337efdb$export$d5cfd99e032247f1; });
$parcel$export(module.exports, "removeOneMindLauncher", function () { return $53119d246337efdb$export$d908d7c8585a2a07; });
/**
 * 1mind.ai "superhuman" launcher-script loader (GWP-12151).
 *
 * 1mind is an AI-powered GTM chat vendor deployed via an external "launcher"
 * script tag (`https://launcher.1mind.com/<deploymentId>`). Each persona is a
 * distinct deployment id. There is no generic script-loader util in wac-web, so
 * this mirrors the established vendor pattern (see
 * `libraries/intercom/src/init.ts`) with Marketo-style idempotency
 * (see `use-marketo-form.ts`): inject at most once per deployment id, client
 * side only, and remove the tag on teardown.
 *
 * The two persona deployment ids for the JPD product-discovery A/B/C test:
 *  - aiGuide: "AI Guide" (waveform variant)
 *  - stephen: "Stephen"  (human-persona variant)
 */ const $53119d246337efdb$export$6aed88a865665cf7 = 'https://launcher.1mind.com';
const $53119d246337efdb$export$f78999e4a0208638 = {
    aiGuide: 'deployment-rprgpn5ltf',
    stephen: 'deployment-fhn85kw52t'
};
/**
 * Module-level guard so the same deployment is never injected twice even if a
 * consumer remounts within the same page lifetime (React StrictMode double
 * effects, provider re-mounts, etc.).
 */ const $53119d246337efdb$var$injectedDeployments = new Set();
const $53119d246337efdb$export$248394e1ef03b487 = (deploymentId)=>`onemind-launcher-${deploymentId}`;
const $53119d246337efdb$export$f4b8b6e73d41ec0a = (deploymentId, { onLoad: onLoad, onError: onError } = {})=>{
    if (typeof document === 'undefined' || !deploymentId) return;
    const scriptId = $53119d246337efdb$export$248394e1ef03b487(deploymentId);
    if ($53119d246337efdb$var$injectedDeployments.has(deploymentId) || document.getElementById(scriptId)) {
        $53119d246337efdb$var$injectedDeployments.add(deploymentId);
        return;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = `${$53119d246337efdb$export$6aed88a865665cf7}/${deploymentId}`;
    if (onLoad) script.addEventListener('load', onLoad);
    if (onError) script.addEventListener('error', onError);
    document.body.appendChild(script);
    $53119d246337efdb$var$injectedDeployments.add(deploymentId);
};
const $53119d246337efdb$export$9573e919f79b39c2 = (origin)=>{
    if (origin === $53119d246337efdb$export$6aed88a865665cf7) return true;
    try {
        const { protocol: protocol, hostname: hostname } = new URL(origin);
        return protocol === 'https:' && (hostname === '1mind.com' || hostname.endsWith('.1mind.com'));
    } catch  {
        return false;
    }
};
const $53119d246337efdb$export$66df334826c3d5d5 = (data)=>{
    if (typeof data === 'string') return data || undefined;
    if (typeof data !== 'object' || data === null) return undefined;
    const record = data;
    const candidate = record['type'] ?? record['event'] ?? record['name'];
    return typeof candidate === 'string' && candidate ? candidate : undefined;
};
const $53119d246337efdb$export$d5cfd99e032247f1 = (onMessage)=>{
    if (typeof window === 'undefined') return ()=>{};
    const handleMessage = (event)=>{
        if (!$53119d246337efdb$export$9573e919f79b39c2(event.origin)) return;
        const eventName = $53119d246337efdb$export$66df334826c3d5d5(event.data);
        if (eventName) onMessage(eventName);
    };
    window.addEventListener('message', handleMessage);
    return ()=>window.removeEventListener('message', handleMessage);
};
const $53119d246337efdb$export$d908d7c8585a2a07 = (deploymentId)=>{
    if (typeof document === 'undefined' || !deploymentId) return;
    const existing = document.getElementById($53119d246337efdb$export$248394e1ef03b487(deploymentId));
    existing?.parentNode?.removeChild(existing);
    $53119d246337efdb$var$injectedDeployments.delete(deploymentId);
};

});

parcelRegister("CBwmG", function(module, exports) {
$parcel$export(module.exports, "OneMindProvider", function () { return $264f49b51892efda$export$dd6459a9ec82cb6b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $cdqsq = parcelRequire("cdqsq");
const $264f49b51892efda$export$862e5b574cb3ae7a = 'oneMindWidget';
const $264f49b51892efda$export$dd6459a9ec82cb6b = ({ deploymentId: deploymentId, variantName: variantName, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    // Keep the latest factory in a ref so the injection effect depends only on
    // `deploymentId` — otherwise a new `createAnalyticsEvent` identity would tear
    // down and re-inject the vendor script on every render.
    const createAnalyticsEventRef = (0, $1oC0p.useRef)(createAnalyticsEvent);
    createAnalyticsEventRef.current = createAnalyticsEvent;
    const fireOneMindEvent = (0, $1oC0p.useCallback)((action, attributes = {})=>{
        createAnalyticsEventRef.current({
            eventType: 'ui',
            action: action,
            actionSubject: $264f49b51892efda$export$862e5b574cb3ae7a,
            actionSubjectId: deploymentId,
            source: $264f49b51892efda$export$862e5b574cb3ae7a,
            attributes: {
                deploymentId: deploymentId,
                ...variantName && {
                    variantName: variantName
                },
                ...attributes
            }
        }).fire();
    }, [
        deploymentId,
        variantName
    ]);
    (0, $1oC0p.useEffect)(()=>{
        (0, $cdqsq.injectOneMindLauncher)(deploymentId, {
            onLoad: ()=>fireOneMindEvent('loaded'),
            onError: ()=>fireOneMindEvent('failed')
        });
        return ()=>(0, $cdqsq.removeOneMindLauncher)(deploymentId);
    }, [
        deploymentId,
        fireOneMindEvent
    ]);
    (0, $1oC0p.useEffect)(()=>(0, $cdqsq.subscribeToOneMindMessages)((vendorEventName)=>fireOneMindEvent('engaged', {
                vendorEventName: vendorEventName
            })), [
        fireOneMindEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: children
    });
};
var $264f49b51892efda$export$2e2bcd8739ae039 = $264f49b51892efda$export$dd6459a9ec82cb6b;

});

parcelRegister("11JLp", function(module, exports) {
$parcel$export(module.exports, "SimplifiedProductNav", function () { return $19832aa4d1b41b16$export$f845ae70be78414d; });
/* simplified-product-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $zADBD = parcelRequire("zADBD");

var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $3riD8 = parcelRequire("3riD8");

var $4Rcm1 = parcelRequire("4Rcm1");

var $9KOR3 = parcelRequire("9KOR3");

var $aFrXh = parcelRequire("aFrXh");

var $5BEho = parcelRequire("5BEho");
const $19832aa4d1b41b16$var$simplifiedProductPageNavStyle = null;
const $19832aa4d1b41b16$var$simplifiedProductPageNavStyleLoggedOut = null;
const $19832aa4d1b41b16$var$simplifiedNavAtlasIconContainerStyle = null;
const $19832aa4d1b41b16$var$simplifiedNavAtlasIconStyle = null;
const $19832aa4d1b41b16$var$simplifiedNavContentWrapperStyle = null;
const $19832aa4d1b41b16$var$simplifiedProductPageNavDarkThemeStyle = null;
const $19832aa4d1b41b16$var$simplifiedProductPageNavContentStyle = null;
const $19832aa4d1b41b16$var$simplifiedProductPageNavLogoLinkStyle = null;
const $19832aa4d1b41b16$var$simplifiedProductPageNavActionsStyle = null;
const $19832aa4d1b41b16$export$f845ae70be78414d = ({ productLogo: productLogo, productLogoHeight: productLogoHeight = 24, productLogoUrl: productLogoUrl, productLogoAriaLabel: productLogoAriaLabel, productKey: productKey, isShowTryNowLink: isShowTryNowLink = true, isShowUserProfile: isShowUserProfile = true, navigationTrynowCtaText: navigationTrynowCtaText, navigationTrynowCtaUrl: navigationTrynowCtaUrl, navigationTrynowCtaOnClick: navigationTrynowCtaOnClick, navigationTrynowCtaButtonVariant: navigationTrynowCtaButtonVariant = 'primary' })=>{
    const intl = (0, $8e22h.default)();
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const [, setIsOpenSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(false);
    const searchAndProfileRef = (0, $1oC0p.useRef)(null);
    const defaultCtaText = intl.formatMessage({
        id: 'productpagesubnav.try-now-button-label',
        defaultMessage: 'Get it free'
    });
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const defaultCtaUrl = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?application=wac&signupSource=jira-ai-native');
    const themedProductLogo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).isValidElement(productLogo) && typeof productLogo.type !== 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(productLogo, {
        darkTheme: isDarkTheme
    }) : productLogo;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
        globalNavItemKeys: [],
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("header", {
            className: (0, $2jatx.default)([
                "_kqsw1if8 _152tidpf _1pbyqfx8 _1e0c11p5 _yv0ei47z _4cvr1h6o _1bsb1osq _4t3i18pe _1j8b1r3t _tyvec120 _bfhk1afi _1omrglyw",
                !isUserLoggedIn && "_xdv4glyw",
                isDarkTheme && "_bfhk1pfd _1ckk1afi _g3f41afi",
                "simplified-product-nav-container"
            ]),
            "data-testid": "simplified-product-nav",
            style: {
                '--product-nav-logo-height': `${productLogoHeight}px`,
                "--_eiqaqt": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).height),
                "--_g4vgbd": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).productColumnsDesktop),
                "--_1wx61mb": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).productColumnsWide),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                    href: (0, $jQ0cd.useLocalizedHref)('/'),
                    "aria-label": intl.formatMessage({
                        id: 'simplifiedProductSubNav.atlassian-logo-label',
                        defaultMessage: 'Atlassian home'
                    }),
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "productPageNav",
                    "data-product-key": productKey,
                    className: (0, $2jatx.default)([
                        "_1e0cglyw _1xlo88uy _14b588uy _181n1txw _q8t51h6o _e8gh1h6o _p7vbidpf _1jb35hrz"
                    ]),
                    style: {
                        "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3i8vuz _1bsb8vuz _1e0c1txw _1bah1h6o _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $zADBD.AtlassianIcon), {
                            size: "medium",
                            appearance: "inverse"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1ul9idpf _4t3i1osq _18zr1n1m _1b1q11wp _1wfqidpf"
                    ]),
                    style: {
                        "--_1mhfb35": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).outerInset)
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
                        "aria-label": intl.formatMessage({
                            id: 'productPageNav.main-nav-label',
                            defaultMessage: 'Main'
                        }),
                        className: (0, $2jatx.default)([
                            "_vchhusvi _1e0c1txw _4cvr1h6o _1bah1yb4 _zulp1ejb _1bsb1osq _4t3i1osq _195g1wug _8164utpp"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5BEho.SkipToContent), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _kqswh2mm _152t1lya _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3i1h1e _1b941txw _1xjx1h1e _e2oo1wug _17521h1e _w8l51wug _4x20glyw",
                                    "navigation-bar-logo-link"
                                ]),
                                href: productLogoUrl,
                                "aria-label": productLogoAriaLabel,
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "productPageNav",
                                "data-product-key": productKey,
                                children: themedProductLogo
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bahesu3 _1o9zidpf _3um015vq",
                                    !requestInProgress && "_3um0ewfl"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aFrXh.NavUtilities), {
                                    isShowTryNowLink: isShowTryNowLink,
                                    productKey: productKey,
                                    isShowSearchButton: false,
                                    setIsOpenSearch: setIsOpenSearch,
                                    navigationTrynowCtaText: navigationTrynowCtaText ?? defaultCtaText,
                                    navigationTrynowCtaUrl: navigationTrynowCtaUrl ?? defaultCtaUrl,
                                    navigationTrynowCtaOnClick: navigationTrynowCtaOnClick,
                                    navigationTrynowCtaButtonVariant: navigationTrynowCtaButtonVariant,
                                    isDisplayDivider: false,
                                    searchAndProfileRef: searchAndProfileRef,
                                    isShowAppSwitcher: false,
                                    isShowUserProfile: isShowUserProfile,
                                    navType: "productNav"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});

parcelRegister("lT2z5", function(module, exports) {
$parcel$export(module.exports, "BitbucketFooter", function () { return $d9ce239d06825d00$export$afd0363f76a301c9; });
/* bitbucket-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $6xclR = parcelRequire("6xclR");

var $efeGz = parcelRequire("efeGz");
const $d9ce239d06825d00$var$globalFooterStyle = null;
const $d9ce239d06825d00$var$globalFooterContentContainerStyle = null;
const $d9ce239d06825d00$export$afd0363f76a301c9 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _11q71afi _1e0c1txw _2lx2vrvc _1bah1h6o"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1afi _1rjcpxbi _1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _195g1tcg _dm251txw _10jx1fra _owpuidpf _xtn71wqb"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $efeGz.BitbucketFooterTop), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6xclR.BitbucketFooterBottom), {})
            ]
        })
    });

});
parcelRegister("6xclR", function(module, exports) {
$parcel$export(module.exports, "BitbucketFooterBottom", function () { return $b77cb42cc02018d8$export$1a0aacf81bbdc390; });
/* bitbucket-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $e3HD6 = parcelRequire("e3HD6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
// ==================================================================
// CSS styling
// ==================================================================
const $b77cb42cc02018d8$var$containerStyle = null;
const $b77cb42cc02018d8$var$linkStyle = null;
const $b77cb42cc02018d8$var$copyrightStyle = null;
const $b77cb42cc02018d8$var$linksAndLanguageStyle = null;
const $b77cb42cc02018d8$var$listStyle = null;
const $b77cb42cc02018d8$var$bottomViewAllLinkLiAnchorStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
const $b77cb42cc02018d8$var$BottomLinks = ()=>{
    const intl = (0, $8e22h.default)();
    (0, $1oC0p.useEffect)(()=>{
        const w = window;
        if (w.AtlOneTrustWrapper?.updatePolicyLinks) w.AtlOneTrustWrapper.updatePolicyLinks();
    }, []);
    const bottomLinks = [
        {
            text: intl.formatMessage({
                id: 'bitbucket.globalfooter.bottom.privacy-policy',
                defaultMessage: 'Privacy policy'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy'),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: 'bitbucket.globalfooter.bottom.notice-at-collection',
                defaultMessage: 'Notice at Collection'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy#additional-disclosures-for-ca-residents'),
            isOneTrustWrapped: true
        },
        {
            text: intl.formatMessage({
                id: 'bitbucket.globalfooter.bottom.terms',
                defaultMessage: 'Terms of use'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/cloud-terms-of-service'),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: 'bitbucket.globalfooter.bottom.trust.security',
                defaultMessage: 'Trust & security'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/atlassian-customer-agreement#intro'),
            isOneTrustWrapped: false
        }
    ];
    const bottomViewAllLink = {
        text: intl.formatMessage({
            id: 'bitbucket.globalfooter.bottom.view-all-products',
            defaultMessage: 'View all Atlassian products'
        }),
        href: (0, $jQ0cd.useLocalizedHref)('/software'),
        bgColor: 'bgWhite'
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            bottomLinks.map((bottomLink)=>{
                if (bottomLink.isOneTrustWrapped) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: 'link-wrapper atl-policy-link-container',
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e3HD6.LinkWithIcon), {
                        linkText: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        isHaveIcon: false,
                        isUsePlainSpanTagForLinkText: true,
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1pfd _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                            'atl-policy-link'
                        ]),
                        spanLinkTextClassName: 'atl-policy-link-text',
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        }
                    })
                }, bottomLink.text);
                else return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        bgColor: "bgColored",
                        "aria-label": "footer-link",
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1pfd _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        }
                    })
                }, bottomLink.text);
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    text: bottomViewAllLink.text,
                    href: bottomViewAllLink.href,
                    type: "primary",
                    bgColor: 'bgColored',
                    "aria-label": "footer-link",
                    className: (0, $2jatx.default)([
                        "_syaz1pfd _1wyboxwj _4bfu1r31 _1hmsglyw _ajmmnqa1 _1dyz1a1y _ect4kipj _1a3b1r31 _9oik1r31 _1ydc1r31 _4fpr8stv _1bnx8stv _1x288stv _5goinqa1 _jf4cnqa1 _1726nqa1 _1ygbdrmc"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                    }
                })
            }, bottomViewAllLink.text.trim().replace(' ', '-'))
        ]
    });
};
const $b77cb42cc02018d8$var$copyRightYear = new Date().getFullYear();
const $b77cb42cc02018d8$export$1a0aacf81bbdc390 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-v2-bottom",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rjc1tcg _18zrpxbi _1e0c1txw _2lx21bp4 _zulpxy5q _su071ady _19wgxy5q _owpu1tcg _1inivrvc _msup1yb4 _1jsv1h6o",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "data-testid": "footer-copyright",
                    className: (0, $2jatx.default)([
                        "_syaz1qc2 _vwz4f6fq _4t3if6fq _1wybdlk8 _10hl1h6o"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                    },
                    children: [
                        "Copyright \xa9 ",
                        $b77cb42cc02018d8$var$copyRightYear,
                        " Atlassian"
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
                        name: "global-footer-v2-bottom-links",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($b77cb42cc02018d8$var$BottomLinks, {})
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("efeGz", function(module, exports) {
$parcel$export(module.exports, "BitbucketFooterTop", function () { return $3c80a5d60bf18c13$export$64d78c3a7aa7d045; });
/* bitbucket-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $kbpa7 = parcelRequire("kbpa7");

var $aejAB = parcelRequire("aejAB");

var $dO2Fq = parcelRequire("dO2Fq");
// ==================================================================
// CSS styling
// ==================================================================
const $3c80a5d60bf18c13$var$containerStyle = null;
const $3c80a5d60bf18c13$var$linksWrapperStyle = null;
const $3c80a5d60bf18c13$export$26b6a80e48da8316 = {
    margin: '0',
    padding: '0',
    border: '0',
    fontSize: '100%',
    verticalAlign: 'baseline'
};
// ==================================================================
// Rendering Functions
// ==================================================================
const $3c80a5d60bf18c13$var$headerContainerStyle = null;
const $3c80a5d60bf18c13$var$listOfLinksColumnHeaderStyle = null;
const $3c80a5d60bf18c13$var$listOfLinksUlStyle = null;
const $3c80a5d60bf18c13$var$textStyle = null;
const $3c80a5d60bf18c13$var$connectTextStyle = null;
const $3c80a5d60bf18c13$var$socialButtonStandardStyle = null;
const $3c80a5d60bf18c13$var$socialButtonsStyle = null;
const $3c80a5d60bf18c13$var$twitterLinkStyle = null;
const $3c80a5d60bf18c13$var$facebookLinkStyle = null;
const $3c80a5d60bf18c13$var$socialButtonsListStyle = null;
const $3c80a5d60bf18c13$var$socialButtonsGroupStyle = null;
const $3c80a5d60bf18c13$var$bitbucketTextStyle = null;
const $3c80a5d60bf18c13$var$ConnectColumn = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3izwfg _1pfhze3t _6rthxy5q _1e0c1txw _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wybw1gv _o10x10nf _1p1dangw _syaz1x3z _k48p53lb _ect48q0o",
                        "eyebrow-md"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: "Connect with us"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _qtt8glyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _syaz1mpp _s7n41q9y"
                    ]),
                    children: "Sign up for Git articles and resources:"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dO2Fq.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_k48p1nn1 _1wyb1j6v _syaz1mpp _s7n41q9y"
                            ]),
                            children: "Connect with Bitbucket"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                            className: (0, $2jatx.default)([
                                "_vwz4kb7n _syazkhc1 _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bozgidpf _qtt8glyw _1aaxusic _ahbq19bv"
                            ]),
                            style: {
                                "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "https://www.facebook.com/Atlassian",
                                        title: "Atlassian on Facebook",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1qc2 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q71tu0 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                        },
                                        children: "Facebook"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "https://twitter.com/bitbucket",
                                        title: "Follow us on Twitter",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1qc2 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q713k9 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                        },
                                        children: "Twitter"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $3c80a5d60bf18c13$export$64d78c3a7aa7d045 = ()=>{
    const intl = (0, $8e22h.default)();
    const resourcesLinkList = {
        headerText: intl.formatMessage({
            id: 'bitbucket.top.resources',
            defaultMessage: 'Resources'
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.technical.support',
                    defaultMessage: 'Technical support'
                }),
                href: intl.formatMessage({
                    id: 'bitbucket.globalfooter.technical.support.link',
                    defaultMessage: 'https://support.atlassian.com/help/#/bitbucket'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.documentation',
                    defaultMessage: 'Documentation'
                }),
                href: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.documentation.link',
                    defaultMessage: 'https://confluence.atlassian.com/display/BITBUCKET'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.plan.pricing',
                    defaultMessage: 'Plans & pricing'
                }),
                href: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.plan.pricing.link',
                    defaultMessage: 'https://bitbucket.org/product/pricing'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.version.control',
                    defaultMessage: 'What is Version Control?'
                }),
                href: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.version.control.link',
                    defaultMessage: 'https://bitbucket.org/product/version-control-software'
                })
            }
        ]
    };
    const bitbucketLinkList = {
        headerText: intl.formatMessage({
            id: 'bitbucket.top.bitbucket',
            defaultMessage: 'Bitbucket'
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.blog',
                    defaultMessage: 'Blog'
                }),
                href: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.blog.link',
                    defaultMessage: 'https://bitbucket.org/blog/'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.bitbucket.writing.program',
                    defaultMessage: 'Bitbucket writing program'
                }),
                href: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.bitbucket.writing.program.link',
                    defaultMessage: 'https://bitbucket.org/product/write'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.api',
                    defaultMessage: 'API'
                }),
                href: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.api.link',
                    defaultMessage: 'https://developer.atlassian.com/bitbucket'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.site.status',
                    defaultMessage: 'Site status'
                }),
                href: intl.formatMessage({
                    id: 'bitbucket.globalfooter.top.site.status.link',
                    defaultMessage: 'http://status.bitbucket.org/'
                })
            }
        ]
    };
    // // Adding pdf to french locale for compliance
    // if (location.pathname.startsWith("/fr")) {
    //     bitbucketLinkList.listOfLinks.push({
    //         text: `Index de l'égalité professionnelle`,
    //         href: "https://dam-cdn.atl.orangelogic.com/AssetLink/qey7mu25028ek1rp0ru28l45l8y3fm5r/2025-France-Gender-Equality-Index.pdf"
    //     });
    // }
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-bitbucket-top",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhkg7ng _1rjc1tcg _18zrpxbi _2rko16cp _1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _umua1ady _owpu1tcg"
            ]),
            style: {
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpxy5q _1da71t02 _bcla1tcg _kd3kckbl _1rqt1raq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...bitbucketLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...resourcesLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($3c80a5d60bf18c13$var$ConnectColumn, {})
                ]
            })
        })
    });
};

});
parcelRegister("dO2Fq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4537f13a77503f08$export$2e2bcd8739ae039; });
/* bitbucket-mailing-list-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $ldrV1 = parcelRequire("ldrV1");

var $eC3qs = parcelRequire("eC3qs");

var $1ka2O = parcelRequire("1ka2O");
const $4537f13a77503f08$var$inputContainerStyle = null;
const $4537f13a77503f08$var$errorStyles = null;
const $4537f13a77503f08$var$inputStyle = null;
const $4537f13a77503f08$var$searchInputContainerStyle = null;
const $4537f13a77503f08$var$validateEmail = (email)=>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const $4537f13a77503f08$export$501844742ea3c924 = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const intl = (0, $8e22h.default)();
    const emptyEmailError = intl.formatMessage({
        id: 'BitbucketFooter.top.emptyEmailError',
        defaultMessage: 'This field is required'
    });
    const invalidEmailError = intl.formatMessage({
        id: 'BitbucketFooter.top.invalidEmailError',
        defaultMessage: 'This field requires a valid email address'
    });
    const [errorMessage, setErrorMessage] = (0, $1oC0p.useState)('');
    const [isValidatingEmail] = (0, $1oC0p.useState)(false);
    const [emailInput, setEmailInput] = (0, $1oC0p.useState)('');
    const [honeypotInput, setHoneypotInput] = (0, $1oC0p.useState)('');
    const [signupSuccess, setSignupSuccess] = (0, $1oC0p.useState)(false);
    const [consentConfig, setConsentConfig] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        if (isValidatingEmail) {
            if (emailInput === '') setErrorMessage(emptyEmailError);
            else $4537f13a77503f08$var$validateEmail(emailInput) ? setErrorMessage('') : setErrorMessage(invalidEmailError);
        }
    }, [
        isValidatingEmail,
        emailInput,
        emptyEmailError,
        invalidEmailError
    ]);
    (0, $1oC0p.useEffect)(()=>{
        getConsentConfig();
    }, []);
    const getConsentConfig = async ()=>{
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const consentConfigUrl = `${stargateUrl}/preferencesV2/consent-config`;
        await fetch(consentConfigUrl, {
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json; charset=UTF-8'
            },
            method: 'POST'
        }).then((response)=>response.json()).then((data)=>setConsentConfig(data)).catch(()=>{
            console.error('Failed to fetch consent config');
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (emailInput === '') {
            setErrorMessage(emptyEmailError);
            return;
        }
        if (!$4537f13a77503f08$var$validateEmail(emailInput)) return;
        if (honeypotInput) return;
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const postUrl = `${stargateUrl}/preferencesV2/update`;
        // These are hardcoded values that are required by the endpoint.
        // https://bitbucket.org/atlassian/magnolia-resources/annotate/f65b7a5bf31677bcde32caa3305364c7ffb88808/resources/js/components/generic/exact-target-formV2.ts?at=qa
        await fetch(postUrl, {
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json; charset=UTF-8'
            },
            method: 'POST',
            body: JSON.stringify({
                consentCheckboxValue: true,
                consentLabelText: '',
                email: emailInput,
                formId: '2ed5d5c4-fe00-4259-a4e0-e82e997a371b',
                formUrl: location.href,
                locale: consentConfig?.locale || 'UNKNOWN',
                privacyPolicyText: '',
                site: 'atlassian'
            })
        }).then(()=>setSignupSuccess(true)).catch(()=>{
            setErrorMessage(intl.formatMessage({
                id: 'Bitbucket.top.signupError',
                defaultMessage: 'There was a server error submitting.'
            }));
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($4537f13a77503f08$export$eac6122d3091f0d0, {
        errorMessage: errorMessage,
        emailInput: emailInput,
        setEmailInput: setEmailInput,
        setHoneypotInput: setHoneypotInput,
        signupSuccess: signupSuccess,
        handleSubmit: handleSubmit
    });
};
const $4537f13a77503f08$var$buttonStyle = null;
const $4537f13a77503f08$export$eac6122d3091f0d0 = (props)=>{
    const { errorMessage: errorMessage, emailInput: emailInput, setEmailInput: setEmailInput, setHoneypotInput: setHoneypotInput, signupSuccess: signupSuccess, handleSubmit: handleSubmit } = props;
    const intl = (0, $8e22h.default)();
    const subscribeText = intl.formatMessage({
        id: 'BitbucketFooter.top.subscribe',
        defaultMessage: 'Subscribe'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            !signupSuccess && /*#__PURE__*/ (0, $7VQPk.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1y6m _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1o8l _y3gn1e5h _1bsb1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eC3qs.TextInput), {
                                    name: "email",
                                    value: emailInput,
                                    id: "email",
                                    testId: "email",
                                    label: "",
                                    placeholder: "email@example.com",
                                    onChangeHandler: setEmailInput,
                                    validation: (value)=>{
                                        if (value === '') return [
                                            false,
                                            intl.formatMessage({
                                                id: 'BitbucketFooter.top.emptyEmailError',
                                                defaultMessage: 'This field is required'
                                            })
                                        ];
                                        else if (!$4537f13a77503f08$var$validateEmail(value)) return [
                                            false,
                                            intl.formatMessage({
                                                id: 'BitbucketFooter.top.invalidEmailError',
                                                defaultMessage: 'This field requires a valid email address'
                                            })
                                        ];
                                        return [
                                            true,
                                            ''
                                        ];
                                    },
                                    className: (0, $2jatx.default)([
                                        "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                                    ])
                                }),
                                errorMessage && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_syaz1du8 _1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfh1y44"
                                    ]),
                                    children: errorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0cglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                type: "text",
                                name: "list name",
                                "aria-label": "keep this field blank",
                                onChange: (e)=>setHoneypotInput(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                            type: 'secondary',
                            text: subscribeText,
                            inputType: 'submit',
                            dataEventProps: {
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-product-key': 'bitbucket',
                                'data-event-container': 'button'
                            },
                            size: 'large',
                            color: 'whiteblue',
                            "aria-label": subscribeText,
                            className: (0, $2jatx.default)([
                                "_ahbq7vkz _1pfh1y44"
                            ])
                        })
                    ]
                })
            }),
            signupSuccess && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "Bitbucket.top.signup-success",
                    defaultMessage: "Thanks for signing up!"
                })
            })
        ]
    });
};
var $4537f13a77503f08$export$2e2bcd8739ae039 = $4537f13a77503f08$export$501844742ea3c924;

});



parcelRegister("5W3jS", function(module, exports) {
$parcel$export(module.exports, "FoundationFooter", function () { return $da82294b1d5e4337$export$cbd202374efd0f28; });
/* foundation-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $7Iejs = parcelRequire("7Iejs");

var $eXpub = parcelRequire("eXpub");
const $da82294b1d5e4337$var$foundationFooterStyle = null;
const $da82294b1d5e4337$var$foundationFooterDarkThemeStyle = null;
const $da82294b1d5e4337$var$foundationFooterContentContainerStyle = null;
const $da82294b1d5e4337$var$foundationFooterContentContainerDarkThemeStyle = null;
const $da82294b1d5e4337$export$cbd202374efd0f28 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler })=>{
    const { isDarkTheme: isDarkTheme, isDevTheme: isDevTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "global-footer-foundation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eOIix.ThemeProvider), {
            isDarkEnabled: isDarkTheme,
            isDevEnabled: isDevTheme,
            isAwf1Enabled: false,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _11q71afi _1e0c1txw _2lx2vrvc _1bah1h6o",
                    isDarkTheme && "_11q7k553"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhk1afi _1rjcpxbi _1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _195g1tcg _dm251txw _10jx1fra _owpuidpf _xtn71wqb",
                        isDarkTheme && "_bfhk1j28"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eXpub.FoundationFooterTop), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Iejs.FoundationFooterBottom), {
                            selectedLanguage: selectedLanguage,
                            onLanguageChangeHandler: onLanguageChangeHandler
                        })
                    ]
                })
            })
        })
    });
};

});
parcelRegister("7Iejs", function(module, exports) {
$parcel$export(module.exports, "FoundationFooterBottom", function () { return $36a8b35729f986eb$export$7c10dae08b65b846; });
/* foundation-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $aKcYL = parcelRequire("aKcYL");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");
// ==================================================================
// CSS styling
// ==================================================================
const $36a8b35729f986eb$var$containerStyle = null;
const $36a8b35729f986eb$var$linkStyle = null;
const $36a8b35729f986eb$var$linkDarkThemeStyle = null;
const $36a8b35729f986eb$var$copyrightStyle = null;
const $36a8b35729f986eb$var$copyrightDarkThemeStyle = null;
const $36a8b35729f986eb$var$linksAndLanguageStyle = null;
const $36a8b35729f986eb$var$listStyle = null;
const $36a8b35729f986eb$var$listDarkThemeStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
const $36a8b35729f986eb$var$BottomLinks = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const intl = (0, $8e22h.default)();
    const bottomLinks = [
        {
            text: intl.formatMessage({
                id: 'foundation.globalfooter.bottom.privacy-policy',
                defaultMessage: 'Privacy policy'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy')
        },
        {
            text: intl.formatMessage({
                id: 'foundation.globalfooter.bottom.terms',
                defaultMessage: 'Terms of use'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/cloud-terms-of-service')
        }
    ];
    return bottomLinks.map((bottomLink)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                text: bottomLink.text,
                href: bottomLink.href,
                type: "anchor",
                bgColor: isDarkTheme ? 'bgBlackBlue' : 'bgColored',
                "aria-label": "footer-link",
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1pfd _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                    isDarkTheme && "_syaz1141"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                }
            })
        }, bottomLink.text));
};
const $36a8b35729f986eb$var$copyRightYear = new Date().getFullYear();
const $36a8b35729f986eb$var$selectorFallbackStyle = null;
const $36a8b35729f986eb$var$selectorFallbackDarkThemeStyle = null;
const $36a8b35729f986eb$var$labelStyle = null;
const $36a8b35729f986eb$var$arrowStyle = null;
const $36a8b35729f986eb$var$SelectorFallback = ({ selectedLanguage: selectedLanguage })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const intl = (0, $8e22h.default)();
    const language = selectedLanguage || intl.locale || 'en';
    const languageLabel = (0, $aKcYL.languages).find((lang)=>lang.value === language)?.label;
    // eslint-disable-next-line local/ensure-wac-token-usage
    const globeColor = isDarkTheme ? (0, $kbpa7.wacToken)('color.neutral.light0') : '#42526e';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_syazvwuj _80omtlke _1e0c116y _4cvr1h6o",
            isDarkTheme && "_syaz1afi"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKcYL.LanguageGlobeIcon), {
                color: globeColor
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ahbq1b66 _1wyboxwj"
                ]),
                children: languageLabel
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_ahbq1b66 _1wyb1k8s"
                ]),
                children: "\u25BE"
            })
        ]
    });
};

const $36a8b35729f986eb$var$LanguageSelectorLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).lazy(()=>(parcelRequire("8S8FG")).then(({ LanguageSelector: LanguageSelector })=>({
            default: LanguageSelector
        })).catch((error)=>{
        console.error(error);
        return {
            default: $36a8b35729f986eb$var$SelectorFallback
        };
    }));
const $36a8b35729f986eb$export$7c10dae08b65b846 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler, className: className })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const [isClient, setIsClient] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        setIsClient(true);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-foundation-bottom",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rjc1tcg _18zrpxbi _1e0c1txw _2lx21bp4 _zulpxy5q _su071ady _19wgxy5q _owpu1tcg _1inivrvc _msup1yb4 _1jsv1h6o",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "data-testid": "footer-copyright",
                    className: (0, $2jatx.default)([
                        "_syaz1qc2 _vwz4f6fq _4t3if6fq _1wybdlk8 _10hl1h6o",
                        isDarkTheme && "_syaz89wr"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                        "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800'))
                    },
                    children: [
                        "Copyright \xa9 ",
                        $36a8b35729f986eb$var$copyRightYear,
                        " Atlassian"
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
                            name: "global-footer-foundation-bottom-links",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                className: (0, $2jatx.default)([
                                    "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o _1g451qgu _40h8yh40",
                                    isDarkTheme && "_1vjw1afi _43ds1141 _90151141 _1i3i1okz _13tc1okz _oxk41141 _1rmw1141"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                    "--_1hwkv7u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1100'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($36a8b35729f986eb$var$BottomLinks, {})
                            })
                        }),
                        isClient ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                            fallback: /*#__PURE__*/ (0, $7VQPk.jsx)($36a8b35729f986eb$var$SelectorFallback, {
                                selectedLanguage: selectedLanguage
                            }),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($36a8b35729f986eb$var$LanguageSelectorLazy, {
                                selectedLanguage: selectedLanguage,
                                onLanguageChangeHandler: onLanguageChangeHandler
                            })
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)($36a8b35729f986eb$var$SelectorFallback, {
                            selectedLanguage: selectedLanguage
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("8S8FG", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("bNb0m"),
    $eao4m("bFVA4"),
    $eao4m("8t8fq")
]).then(()=>parcelRequire('gieZF'));

});


parcelRegister("eXpub", function(module, exports) {
$parcel$export(module.exports, "FoundationFooterTop", function () { return $710774bf09a33315$export$853df614c70aad23; });
/* foundation-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $2Df35 = parcelRequire("2Df35");

var $aejAB = parcelRequire("aejAB");
// The Foundation site is hosted separately from atlassian.com, so every link to it
// has to be absolute - the footer itself renders on atlassian.com Uniform pages.
const $710774bf09a33315$var$FOUNDATION_SITE = 'https://www.atlassianfoundation.org';
// ==================================================================
// CSS styling
// ==================================================================
const $710774bf09a33315$var$containerStyle = null;
const $710774bf09a33315$var$containerDarkThemeStyle = null;
const $710774bf09a33315$var$linksWrapperStyle = null;
const $710774bf09a33315$var$logoContainerStyle = null;
const $710774bf09a33315$var$logoLinkStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
const $710774bf09a33315$var$messages = (0, $fnHPc.defineMessages)({
    ariaLabelLogo: {
        id: 'foundation.globalfooter.top.logo-label',
        defaultMessage: 'Atlassian Foundation logo'
    }
});
const $710774bf09a33315$var$FoundationLogoLink = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3izwfg _1pfhze3t _6rthxy5q _1e0c1txw _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            "aria-label": intl.formatMessage($710774bf09a33315$var$messages.ariaLabelLogo),
            href: `${$710774bf09a33315$var$FOUNDATION_SITE}/`,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalFooterFoundation",
            className: (0, $2jatx.default)([
                "_1e0c116y _4cvr1h6o _1bsb1osq _p12f1178 _w8l51osq _17521wug _1ygb1qgu _1ah3yh40"
            ]),
            style: {
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                brand: "foundation",
                type: "logo",
                appearance: "brand",
                width: 280,
                height: 25,
                darkTheme: isDarkTheme
            })
        })
    });
};
const $710774bf09a33315$export$853df614c70aad23 = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const intl = (0, $8e22h.default)();
    const aboutLinkList = {
        headerText: intl.formatMessage({
            id: 'foundation.globalfooter.top.about',
            defaultMessage: 'About'
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.about-us',
                    defaultMessage: 'About us'
                }),
                href: `${$710774bf09a33315$var$FOUNDATION_SITE}/about`
            },
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.our-policies',
                    defaultMessage: 'Our policies'
                }),
                href: `${$710774bf09a33315$var$FOUNDATION_SITE}/policies`
            },
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.contact-us',
                    defaultMessage: 'Contact us'
                }),
                href: 'https://atlassianfoundation.atlassian.net/servicedesk/customer/portals'
            }
        ]
    };
    const focusAreasLinkList = {
        headerText: intl.formatMessage({
            id: 'foundation.globalfooter.top.focus-areas',
            defaultMessage: 'Focus areas'
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.philanthropy',
                    defaultMessage: 'Philanthropy'
                }),
                href: `${$710774bf09a33315$var$FOUNDATION_SITE}/how-we-work/education`
            },
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.atlassian-for-nonprofits',
                    defaultMessage: 'Atlassian for Nonprofits'
                }),
                href: 'https://www.atlassian.com/teams/nonprofits'
            },
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.volunteering-and-donating',
                    defaultMessage: 'Volunteering & donating'
                }),
                href: `${$710774bf09a33315$var$FOUNDATION_SITE}/how-we-work/volunteering-and-donating`
            }
        ]
    };
    const partnersLinkList = {
        headerText: intl.formatMessage({
            id: 'foundation.globalfooter.top.partners',
            defaultMessage: 'Partners'
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.education-partners',
                    defaultMessage: 'Education partners'
                }),
                href: `${$710774bf09a33315$var$FOUNDATION_SITE}/Education-partners`
            },
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.pledge',
                    defaultMessage: 'Pledge 1%'
                }),
                href: `${$710774bf09a33315$var$FOUNDATION_SITE}/how-we-work/pledge`
            },
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.crisis-response-partners',
                    defaultMessage: 'Crisis response partners'
                }),
                href: `${$710774bf09a33315$var$FOUNDATION_SITE}/Education-partners/crisis-response-partners`
            },
            {
                text: intl.formatMessage({
                    id: 'foundation.globalfooter.top.impact-investing',
                    defaultMessage: 'Impact investing'
                }),
                href: `${$710774bf09a33315$var$FOUNDATION_SITE}/how-we-work/impact-investing`
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-foundation-top",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhkg7ng _1rjc1tcg _18zrpxbi _2rko16cp _1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _umua1ady _owpu1tcg",
                isDarkTheme && "_bfhk1j28"
            ]),
            style: {
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpxy5q _1da71t02 _bcla1tcg _kd3kckbl _1rqt1x32"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($710774bf09a33315$var$FoundationLogoLink, {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...aboutLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...focusAreasLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...partnersLinkList
                    })
                ]
            })
        })
    });
};

});


parcelRegister("fbo5H", function(module, exports) {
$parcel$export(module.exports, "JacNavbar", function () { return $dafddddada2c1ebf$export$56b1f48c0b125acc; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $gNdrj = parcelRequire("gNdrj");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $cR2Ov = parcelRequire("cR2Ov");

var $9KOR3 = parcelRequire("9KOR3");

var $gn6Qa = parcelRequire("gn6Qa");

var $cB958 = parcelRequire("cB958");

var $1jBLM = parcelRequire("1jBLM");
const $dafddddada2c1ebf$var$JiraLogo = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
};
const $dafddddada2c1ebf$export$56b1f48c0b125acc = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    const intl = (0, $8e22h.default)();
    const ctaText = intl.formatMessage({
        id: 'JiraFeatureSoftwarePageTemplate.navbar.getItFree',
        defaultMessage: 'Get it free'
    });
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&edition=free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, [
        openCrossFlow,
        productNavCtaCTAClickFunction,
        isUseOpenCrossFlow
    ]);
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: 'fit-content !important',
            margin: 0
        };
    }, []);
    // Teams Hrefs
    const marketingHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/marketing');
    const engineeringHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/engineering');
    const designHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/design');
    const operationsHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/operations');
    const itHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/it');
    // Use Cases Hrefs
    const gettingStartedHref = (0, $jQ0cd.useLocalizedHref)('https://community.atlassian.com/learning/hub/jira');
    const planningHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/planning');
    const campaignManagementHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/campaign-management');
    const agileProjectManagementHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/agile-project-management');
    const programManagementHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/program-management');
    //Company Size Hrefs
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/enterprise');
    const solutionsDropdown = (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
            contentSections: [
                {
                    header: intl.formatMessage({
                        id: 'software-jira.navbar.solutions.teams.header',
                        defaultMessage: 'Teams'
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.marketing',
                                defaultMessage: 'Marketing'
                            }),
                            href: marketingHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.engineering',
                                defaultMessage: 'Engineering'
                            }),
                            href: engineeringHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.design',
                                defaultMessage: 'Design'
                            }),
                            href: designHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.operations',
                                defaultMessage: 'Operations'
                            }),
                            href: operationsHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.it',
                                defaultMessage: 'IT'
                            }),
                            href: itHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: 'software-jira.navbar.solutions.useCases.header',
                        defaultMessage: 'Use Cases'
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.getting-started',
                                defaultMessage: 'Getting started'
                            }),
                            href: gettingStartedHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.planning',
                                defaultMessage: 'Planning'
                            }),
                            href: planningHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.campaign-management',
                                defaultMessage: 'Campaign Management'
                            }),
                            href: campaignManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.agile-project-management',
                                defaultMessage: 'Agile Project Management'
                            }),
                            href: agileProjectManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.program-management',
                                defaultMessage: 'Program Management'
                            }),
                            href: programManagementHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: 'software-jira.navbar.solutions.companySize.header',
                        defaultMessage: 'Company Size'
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.companySize.enterprise',
                                defaultMessage: 'Enterprise'
                            }),
                            href: enterpriseHref
                        }
                    ]
                }
            ]
        }), [
        intl,
        gettingStartedHref,
        marketingHref,
        engineeringHref,
        designHref,
        operationsHref,
        itHref,
        planningHref,
        campaignManagementHref,
        agileProjectManagementHref,
        programManagementHref,
        enterpriseHref
    ]);
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/guides/getting-started/introduction');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/pricing');
    const productLogoHref = (0, $jQ0cd.useLocalizedHref)('/software/jira');
    const templatesLinkContent = (0, $1oC0p.useMemo)(()=>{
        return {
            globalLinksKey: 'templates',
            linkText: intl.formatMessage({
                id: 'software-jira.navbar.templates',
                defaultMessage: 'Templates'
            }),
            productKey: 'jira',
            hasDropdown: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1jBLM.TemplateCategoriesDropdown), {}),
            dropdownType: 'templates',
            containerPosition: 'relative'
        };
    }, [
        intl
    ]);
    const featuresLinkContent = (0, $1oC0p.useMemo)(()=>({
            globalLinksKey: 'features',
            linkText: intl.formatMessage({
                id: 'software-jira.navbar.features',
                defaultMessage: 'Features'
            }),
            productKey: 'jira',
            hasDropdown: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cB958.FeaturesDropdown), {}),
            dropdownType: 'features',
            containerPosition: 'relative'
        }), [
        intl
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            featuresLinkContent,
            {
                globalLinksKey: 'solutions',
                linkText: intl.formatMessage({
                    id: 'software-jira.navbar.solutions',
                    defaultMessage: 'Solutions'
                }),
                hasDropdown: true,
                productKey: 'jira',
                containerPosition: 'relative',
                containerStyles: solutionsDropdownStyles,
                dropdownType: 'solutions',
                content: solutionsDropdown
            },
            {
                globalLinksKey: 'productGuide',
                linkText: intl.formatMessage({
                    id: 'software-jira.navbar.product-guide-gwp-7518',
                    defaultMessage: 'Guide'
                }),
                hasDropdown: false,
                productKey: 'jira',
                href: guidesHref
            },
            templatesLinkContent,
            {
                globalLinksKey: 'pricing',
                linkText: intl.formatMessage({
                    id: 'software-jira.navbar.pricing',
                    defaultMessage: 'Pricing'
                }),
                hasDropdown: false,
                productKey: 'jira',
                href: pricingHref
            }
        ], [
        intl,
        featuresLinkContent,
        templatesLinkContent,
        solutionsDropdown,
        solutionsDropdownStyles,
        guidesHref,
        pricingHref
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gNdrj.JiraSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
                globalNavItemKeys: globalNavItemKeys,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
                    productLogoUrl: productLogoHref,
                    productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($dafddddada2c1ebf$var$JiraLogo, {}),
                    productLogoAriaLabel: intl.formatMessage({
                        id: 'wacJiraSoftwareNavigation.logo-label',
                        defaultMessage: 'Jira Software logo'
                    }),
                    mobileCtaText: intl.formatMessage({
                        id: 'JiraeSoftwarePageTemplate.navbar.getitfree',
                        defaultMessage: 'Get it free'
                    }),
                    mobileCtaUrl: signupLink,
                    mobileCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($dafddddada2c1ebf$var$JiraLogo, {}),
                    navigationTrynowCtaText: ctaText,
                    navigationTrynowCtaUrl: signupLink,
                    navigationTrynowCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    productPageNavLinks: links,
                    mobileLinksSections: [
                        {
                            mobileLinkKey: 'mobile-jira',
                            mobileLinksProps: links
                        }
                    ],
                    additionalMenuPageObjectsArray: [
                        {
                            menuPageKey: 'solutions',
                            menuPageObjects: links.find((link)=>link.globalLinksKey === 'solutions')?.content
                        },
                        {
                            menuPageKey: 'templates',
                            menuPageObjects: links.find((link)=>link.globalLinksKey === 'templates')?.content
                        }
                    ],
                    isShowAppSwitcher: false,
                    isShowUserProfile: false
                })
            })
        ]
    });
};
$dafddddada2c1ebf$export$56b1f48c0b125acc.displayName = 'JiraSoftwareNav';
var $dafddddada2c1ebf$export$2e2bcd8739ae039 = $dafddddada2c1ebf$export$56b1f48c0b125acc;

});

parcelRegister("cimg4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c26c977f7fa25d25$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $1pIeE = parcelRequire("1pIeE");

var $iHYHa = parcelRequire("iHYHa");

var $8IN8s = parcelRequire("8IN8s");
const $c26c977f7fa25d25$var$JiraSoftwareNavUniform = ()=>{
    const { template: template } = (0, $1pIeE.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $1oC0p.useState)(false);
    const openModalForTemplateClickAction = (0, $1oC0p.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template?.templateId,
                templateName: template?.templateName,
                productKey: template?.productKey
            });
        };
    }, [
        openModalForTemplate,
        template?.templateId,
        template?.templateName,
        template?.productKey
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (template?.templateId && template?.templateName && template?.productKey) setIsUseOpenCrossFlow(true);
    }, [
        template?.templateId,
        template?.templateName,
        template?.productKey
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$c26c977f7fa25d25$var$JiraSoftwareNavUniform.displayName = 'JiraSoftwareNavUniform';
var $c26c977f7fa25d25$export$2e2bcd8739ae039 = $c26c977f7fa25d25$var$JiraSoftwareNavUniform;

});

parcelRegister("4c8eJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1b68c0ea2ce93d4$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $1pIeE = parcelRequire("1pIeE");

var $iHYHa = parcelRequire("iHYHa");

var $aYVVm = parcelRequire("aYVVm");
const $a1b68c0ea2ce93d4$var$JiraServiceManagementSoftwareNavV2Uniform = ()=>{
    const { template: template } = (0, $1pIeE.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $1oC0p.useState)(false);
    const openModalForTemplateClickAction = (0, $1oC0p.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template?.templateId,
                templateName: template?.templateName,
                productKey: template?.productKey
            });
        };
    }, [
        openModalForTemplate,
        template?.templateId,
        template?.templateName,
        template?.productKey
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (template?.templateId && template?.templateName && template?.productKey) setIsUseOpenCrossFlow(true);
    }, [
        template?.templateId,
        template?.templateName,
        template?.productKey
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYVVm.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$a1b68c0ea2ce93d4$var$JiraServiceManagementSoftwareNavV2Uniform.displayName = 'JiraServiceManagementSoftwareNavV2Uniform';
var $a1b68c0ea2ce93d4$export$2e2bcd8739ae039 = $a1b68c0ea2ce93d4$var$JiraServiceManagementSoftwareNavV2Uniform;

});

parcelRegister("cQSG9", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppFooter", function () { return $8415a60865fc69c3$export$e1512df89103926d; });
/* sourcetree-app-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $qW9Nb = parcelRequire("qW9Nb");

var $8LmPp = parcelRequire("8LmPp");
const $8415a60865fc69c3$var$globalFooterStyle = null;
const $8415a60865fc69c3$var$globalFooterContentContainerStyle = null;
const $8415a60865fc69c3$export$e1512df89103926d = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _11q71afi _1e0c1txw _2lx2vrvc _1bah1h6o"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1afi _1rjcpxbi _1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _195g1tcg _dm251txw _10jx1fra _owpuidpf _xtn71wqb"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LmPp.SourcetreeAppFooterTop), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $qW9Nb.SourcetreeAppFooterBottom), {})
            ]
        })
    });

});
parcelRegister("qW9Nb", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppFooterBottom", function () { return $e18ab648d292d24b$export$89b0be2f0f7ea8dd; });
/* sourcetree-app-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $e3HD6 = parcelRequire("e3HD6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
// ==================================================================
// CSS styling
// ==================================================================
const $e18ab648d292d24b$var$containerStyle = null;
const $e18ab648d292d24b$var$linkStyle = null;
const $e18ab648d292d24b$var$copyrightStyle = null;
const $e18ab648d292d24b$var$linksAndLanguageStyle = null;
const $e18ab648d292d24b$var$listStyle = null;
const $e18ab648d292d24b$var$bottomViewAllLinkLiAnchorStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
const $e18ab648d292d24b$var$BottomLinks = ()=>{
    const intl = (0, $8e22h.default)();
    (0, $1oC0p.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (window?.AtlOneTrustWrapper?.updatePolicyLinks) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.AtlOneTrustWrapper.updatePolicyLinks();
    }, []);
    const bottomLinks = [
        {
            text: intl.formatMessage({
                id: 'sourcetreeapp.globalfooter.bottom.privacy-policy',
                defaultMessage: 'Privacy policy'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy'),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: 'sourcetreeapp.globalfooter.bottom.notice-at-collection',
                defaultMessage: 'Notice at Collection'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy#additional-disclosures-for-ca-residents'),
            isOneTrustWrapped: true
        },
        {
            text: intl.formatMessage({
                id: 'sourcetreeapp.globalfooter.bottom.terms',
                defaultMessage: 'Terms of use'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/cloud-terms-of-service'),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: 'sourcetreeapp.globalfooter.bottom.trust.security',
                defaultMessage: 'Trust & security'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/atlassian-customer-agreement#intro'),
            isOneTrustWrapped: false
        }
    ];
    const bottomViewAllLink = {
        text: intl.formatMessage({
            id: 'sourcetreeapp.globalfooter.bottom.view-all-products',
            defaultMessage: 'View all Atlassian products'
        }),
        href: (0, $jQ0cd.useLocalizedHref)('/software'),
        bgColor: 'bgWhite'
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            bottomLinks.map((bottomLink)=>{
                if (bottomLink.isOneTrustWrapped) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: 'link-wrapper atl-policy-link-container',
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e3HD6.LinkWithIcon), {
                        linkText: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        isHaveIcon: false,
                        isUsePlainSpanTagForLinkText: true,
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1pfd _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                            'atl-policy-link'
                        ]),
                        spanLinkTextClassName: 'atl-policy-link-text',
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        }
                    })
                }, bottomLink.text);
                else return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        bgColor: "bgColored",
                        "aria-label": "footer-link",
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1pfd _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        }
                    })
                }, bottomLink.text);
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    text: bottomViewAllLink.text,
                    href: bottomViewAllLink.href,
                    type: "primary",
                    bgColor: 'bgColored',
                    "aria-label": "footer-link",
                    className: (0, $2jatx.default)([
                        "_syaz1pfd _1wyboxwj _4bfu1r31 _1hmsglyw _ajmmnqa1 _1dyz1a1y _ect4kipj _1a3b1r31 _9oik1r31 _1ydc1r31 _4fpr8stv _1bnx8stv _1x288stv _5goinqa1 _jf4cnqa1 _1726nqa1 _1ygbdrmc"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                    }
                })
            }, bottomViewAllLink.text.trim().replace(' ', '-'))
        ]
    });
};
const $e18ab648d292d24b$var$copyRightYear = new Date().getFullYear();
const $e18ab648d292d24b$export$89b0be2f0f7ea8dd = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-v2-bottom",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rjc1tcg _18zrpxbi _1e0c1txw _2lx21bp4 _zulpxy5q _su071ady _19wgxy5q _owpu1tcg _1inivrvc _msup1yb4 _1jsv1h6o",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "data-testid": "footer-copyright",
                    className: (0, $2jatx.default)([
                        "_syaz1qc2 _vwz4f6fq _4t3if6fq _1wybdlk8 _10hl1h6o"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                    },
                    children: [
                        "Copyright \xa9 ",
                        $e18ab648d292d24b$var$copyRightYear,
                        " Atlassian"
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
                        name: "global-footer-v2-bottom-links",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($e18ab648d292d24b$var$BottomLinks, {})
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("8LmPp", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppFooterTop", function () { return $f9eec892615b5033$export$e7a002b3133bbe21; });
/* sourcetree-app-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $aejAB = parcelRequire("aejAB");

var $1ka2O = parcelRequire("1ka2O");

var $huLm0 = parcelRequire("huLm0");
// ==================================================================
// CSS styling
// ==================================================================
const $f9eec892615b5033$var$containerStyle = null;
const $f9eec892615b5033$var$linksWrapperStyle = null;
const $f9eec892615b5033$export$26b6a80e48da8316 = {
    margin: '0',
    padding: '0',
    border: '0',
    fontSize: '100%',
    verticalAlign: 'baseline'
};
// ==================================================================
// Rendering Functions
// ==================================================================
const $f9eec892615b5033$var$headerContainerStyle = null;
const $f9eec892615b5033$var$listOfLinksColumnHeaderStyle = null;
const $f9eec892615b5033$var$listOfLinksUlStyle = null;
const $f9eec892615b5033$var$textStyle = null;
const $f9eec892615b5033$var$connectTextStyle = null;
const $f9eec892615b5033$var$socialButtonStandardStyle = null;
const $f9eec892615b5033$var$socialButtonsStyle = null;
const $f9eec892615b5033$var$twitterLinkStyle = null;
const $f9eec892615b5033$var$facebookLinkStyle = null;
const $f9eec892615b5033$var$socialButtonsListStyle = null;
const $f9eec892615b5033$var$socialButtonsGroupStyle = null;
const $f9eec892615b5033$var$sourcetreeTextStyle = null;
const $f9eec892615b5033$var$ConnectColumn = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3izwfg _1pfhze3t _6rthxy5q _1e0c1txw _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wybw1gv _o10x10nf _1p1dangw _syaz1x3z _k48p53lb _ect48q0o",
                        "eyebrow-md"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: "Connect with us"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _qtt8glyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _syaz1mpp _s7n41q9y"
                    ]),
                    children: "Sign up for Git articles and resources:"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $huLm0.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_k48p1nn1 _1wyb1j6v _syaz1mpp _s7n41q9y"
                            ]),
                            children: "Connect with Sourcetree"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                            className: (0, $2jatx.default)([
                                "_vwz4kb7n _syazkhc1 _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bozgidpf _qtt8glyw _1aaxusic _ahbq19bv"
                            ]),
                            style: {
                                "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "https://www.facebook.com/Atlassian",
                                        title: "Atlassian on Facebook",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1qc2 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q71tu0 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                        },
                                        children: "Facebook"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "https://twitter.com/sourcetree",
                                        title: "Follow us on Twitter",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1qc2 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q713k9 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                        },
                                        children: "Twitter"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $f9eec892615b5033$export$e7a002b3133bbe21 = ()=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const resourcesLinkList = {
        headerText: intl.formatMessage({
            id: 'sourcetreeapp.top.resources',
            defaultMessage: 'Resources'
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'sourcetreeapp.globalfooter.top.support',
                    defaultMessage: 'Support'
                }),
                href: intl.formatMessage({
                    id: 'sourcetreeapp.globalfooter.top.support.link',
                    defaultMessage: 'https://support.atlassian.com/sourcetree'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'sourcetreeapp.globalfooter.top.documentation',
                    defaultMessage: 'Documentation'
                }),
                href: intl.formatMessage({
                    id: 'sourcetreeapp.globalfooter.top.documentation.link',
                    defaultMessage: 'https://confluence.atlassian.com/get-started-with-sourcetree'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'sourcetreeapp.globalfooter.top.about.atlassian',
                    defaultMessage: 'About Atlassian'
                }),
                href: intl.formatMessage({
                    id: 'sourcetreeapp.globalfooter.top.about.atlassian.link',
                    defaultMessage: 'https://www.atlassian.com/company'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'sourcetreeapp.globalfooter.top.download.archive',
                    defaultMessage: 'Download archive'
                }),
                href: intl.formatMessage({
                    id: 'sourcetreeapp.globalfooter.top.download.archive.link',
                    defaultMessage: 'https://sourcetreeapp.com/download-archives'
                })
            }
        ]
    };
    const sourcetreeAppLinkList = {
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'sourcetreeapp.top.blog',
                    defaultMessage: 'Blog'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/blog/sourcetree')
            }
        ]
    };
    // Adding pdf to french locale for compliance
    if (location.pathname.startsWith('/fr')) sourcetreeAppLinkList.listOfLinks.push({
        text: `Index de l'\xe9galit\xe9 professionnelle`,
        href: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qey7mu25028ek1rp0ru28l45l8y3fm5r/2025-France-Gender-Equality-Index.pdf'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-sourcetreeapp-top",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhkg7ng _1rjc1tcg _18zrpxbi _2rko16cp _1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _umua1ady _owpu1tcg"
            ]),
            style: {
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpxy5q _1da71t02 _bcla1tcg _kd3kckbl _1rqt1raq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...sourcetreeAppLinkList,
                        logoType: "sourcetreeapp"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...resourcesLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($f9eec892615b5033$var$ConnectColumn, {})
                ]
            })
        })
    });
};

});
parcelRegister("huLm0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $97b566dc024060a4$export$2e2bcd8739ae039; });
/* sourcetree-app-mailing-list-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $ldrV1 = parcelRequire("ldrV1");

var $eC3qs = parcelRequire("eC3qs");

var $1ka2O = parcelRequire("1ka2O");
const $97b566dc024060a4$var$inputContainerStyle = null;
const $97b566dc024060a4$var$errorStyles = null;
const $97b566dc024060a4$var$inputStyle = null;
const $97b566dc024060a4$var$searchInputContainerStyle = null;
const $97b566dc024060a4$var$validateEmail = (email)=>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const $97b566dc024060a4$export$d8d3a333528c91a5 = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const intl = (0, $8e22h.default)();
    const emptyEmailError = intl.formatMessage({
        id: 'SourcetreeAppFooter.top.emptyEmailError',
        defaultMessage: 'This field is required'
    });
    const invalidEmailError = intl.formatMessage({
        id: 'SourcetreeAppFooter.top.invalidEmailError',
        defaultMessage: 'This field requires a valid email address'
    });
    const [errorMessage, setErrorMessage] = (0, $1oC0p.useState)('');
    const [isValidatingEmail] = (0, $1oC0p.useState)(false);
    const [emailInput, setEmailInput] = (0, $1oC0p.useState)('');
    const [honeypotInput, setHoneypotInput] = (0, $1oC0p.useState)('');
    const [signupSuccess, setSignupSuccess] = (0, $1oC0p.useState)(false);
    const [consentConfig, setConsentConfig] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        if (isValidatingEmail) {
            if (emailInput === '') setErrorMessage(emptyEmailError);
            else $97b566dc024060a4$var$validateEmail(emailInput) ? setErrorMessage('') : setErrorMessage(invalidEmailError);
        }
    }, [
        isValidatingEmail,
        emailInput,
        emptyEmailError,
        invalidEmailError
    ]);
    (0, $1oC0p.useEffect)(()=>{
        getConsentConfig();
    }, []);
    const getConsentConfig = async ()=>{
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const consentConfigUrl = `${stargateUrl}/preferencesV2/consent-config`;
        await fetch(consentConfigUrl, {
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json; charset=UTF-8'
            },
            method: 'POST'
        }).then((response)=>response.json()).then((data)=>setConsentConfig(data)).catch(()=>{
            console.error('Failed to fetch consent config');
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (emailInput === '') {
            setErrorMessage(emptyEmailError);
            return;
        }
        if (!$97b566dc024060a4$var$validateEmail(emailInput)) return;
        if (honeypotInput) return;
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const postUrl = `${stargateUrl}/preferencesV2/update`;
        // These are hardcoded values that are required by the endpoint.
        // https://bitbucket.org/atlassian/magnolia-resources/annotate/f65b7a5bf31677bcde32caa3305364c7ffb88808/resources/js/components/generic/exact-target-formV2.ts?at=qa
        await fetch(postUrl, {
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json; charset=UTF-8'
            },
            method: 'POST',
            body: JSON.stringify({
                consentCheckboxValue: true,
                consentLabelText: '',
                email: emailInput,
                formId: '2ed5d5c4-fe00-4259-a4e0-e82e997a371b',
                formUrl: location.href,
                locale: consentConfig?.locale || 'UNKNOWN',
                privacyPolicyText: '',
                site: 'atlassian'
            })
        }).then(()=>setSignupSuccess(true)).catch(()=>{
            setErrorMessage(intl.formatMessage({
                id: 'SourcetreeApp.top.signupError',
                defaultMessage: 'There was a server error submitting.'
            }));
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($97b566dc024060a4$export$b59b70495d14eb0, {
        errorMessage: errorMessage,
        emailInput: emailInput,
        setEmailInput: setEmailInput,
        setHoneypotInput: setHoneypotInput,
        signupSuccess: signupSuccess,
        handleSubmit: handleSubmit
    });
};
const $97b566dc024060a4$var$buttonStyle = null;
const $97b566dc024060a4$export$b59b70495d14eb0 = (props)=>{
    const { errorMessage: errorMessage, emailInput: emailInput, setEmailInput: setEmailInput, setHoneypotInput: setHoneypotInput, signupSuccess: signupSuccess, handleSubmit: handleSubmit } = props;
    const intl = (0, $8e22h.default)();
    const subscribeText = intl.formatMessage({
        id: 'SourcetreeAppFooter.top.subscribe',
        defaultMessage: 'Subscribe'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            !signupSuccess && /*#__PURE__*/ (0, $7VQPk.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1y6m _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1o8l _y3gn1e5h _1bsb1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eC3qs.TextInput), {
                                    name: "email",
                                    value: emailInput,
                                    id: "email",
                                    testId: "email",
                                    label: "",
                                    placeholder: "email@example.com",
                                    onChangeHandler: setEmailInput,
                                    validation: (value)=>{
                                        if (value === '') return [
                                            false,
                                            intl.formatMessage({
                                                id: 'SourcetreeAppFooter.top.emptyEmailError',
                                                defaultMessage: 'This field is required'
                                            })
                                        ];
                                        else if (!$97b566dc024060a4$var$validateEmail(value)) return [
                                            false,
                                            intl.formatMessage({
                                                id: 'SourcetreeAppFooter.top.invalidEmailError',
                                                defaultMessage: 'This field requires a valid email address'
                                            })
                                        ];
                                        return [
                                            true,
                                            ''
                                        ];
                                    },
                                    className: (0, $2jatx.default)([
                                        "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                                    ])
                                }),
                                errorMessage && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_syaz1du8 _1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfh1y44"
                                    ]),
                                    children: errorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0cglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                type: "text",
                                name: "list name",
                                "aria-label": "keep this field blank",
                                onChange: (e)=>setHoneypotInput(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                            type: 'secondary',
                            text: subscribeText,
                            inputType: 'submit',
                            dataEventProps: {
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-product-key': 'sourcetreeapp',
                                'data-event-container': 'button'
                            },
                            size: 'large',
                            color: 'whiteblue',
                            "aria-label": subscribeText,
                            className: (0, $2jatx.default)([
                                "_ahbq7vkz _1pfh1y44"
                            ])
                        })
                    ]
                })
            }),
            signupSuccess && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "SourcetreeApp.top.signup-success",
                    defaultMessage: "Thanks for signing up!"
                })
            })
        ]
    });
};
var $97b566dc024060a4$export$2e2bcd8739ae039 = $97b566dc024060a4$export$d8d3a333528c91a5;

});



parcelRegister("cF9FY", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppNav", function () { return $f790ae6eedb0a62d$export$5ba9b99d6060872; });
/* sourcetree-app-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $hnmMQ = parcelRequire("hnmMQ");

var $lGmrg = parcelRequire("lGmrg");
const $f790ae6eedb0a62d$var$stickyWrapperStyle = null;
const $f790ae6eedb0a62d$var$imktNavbarStyle = null;
const $f790ae6eedb0a62d$var$containerFluidStyle = null;
const $f790ae6eedb0a62d$export$d6a07a1754b0e052 = '68px';
const $f790ae6eedb0a62d$var$navigationBarWrapperCss = null;
const $f790ae6eedb0a62d$var$navWrapper = null;
const $f790ae6eedb0a62d$var$navbarStyle = null;
const $f790ae6eedb0a62d$var$navigationBarLogoCss = null;
const $f790ae6eedb0a62d$var$navigationBarLogoLink = null;
const $f790ae6eedb0a62d$var$logoStyle = null;
const $f790ae6eedb0a62d$var$buttonWrapperCss = null;
const $f790ae6eedb0a62d$var$DOWNLOAD_URL = 'https://product-downloads.atlassian.com/software/sourcetree/ga/Sourcetree_4.2.19_317.zip';
const $f790ae6eedb0a62d$export$5ba9b99d6060872 = ()=>{
    const intl = (0, $8e22h.default)();
    const [isDisclaimerOpen, setIsDisclaimerOpen] = (0, $1oC0p.useState)(false);
    const buttonText = intl.formatMessage({
        id: 'sourcetreeapp.globalnav.button.download.free',
        defaultMessage: 'Download free'
    });
    const handleDownloadButtonClick = (event)=>{
        // prevent immediate navigation to the zip
        event.preventDefault();
        // open the disclaimer modal
        setIsDisclaimerOpen(true);
    };
    const handleDisclaimerClose = ()=>{
        setIsDisclaimerOpen(false);
    };
    const handleDisclaimerConfirm = ()=>{
        // user accepted: close modal
        setIsDisclaimerOpen(false);
        // then trigger the real download
        window.location.href = $f790ae6eedb0a62d$var$DOWNLOAD_URL;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_vwz4kb7n _vchhusvi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1f491mrw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
                    className: (0, $2jatx.default)([
                        "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1e0c1ule _1f491mrw _1bsb1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_vwz4kb7n _vchhusvi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bfhk1afi _16qs130s _1ul91osq _11rm1hrf _kqswh2mm _c71l11ux _1reo15vq _18m915vq _1pby1406 _1tket9kd"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4cvr1h6o _bfhku67f _1e0c1txw _2lx2vrvc _1bah1h6o _1pbyqfx8 _4t3i88uy"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _2lx2vrvc _1pbyouyt _195g1tcg _hy3utfvk _fy4xidpf _1h1i1wqb"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq _4t3i1osq"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _4cvr1h6o _1o3j1wug"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                href: "/",
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                    image: {
                                                        src: 'https://wac-cdn.atlassian.com/dam/jcr:f32681c1-355d-4806-b29c-319b0c6ecb06/Sourcetree-blue.svg?cdnVersion=3108',
                                                        alt: 'Sourcetree logo'
                                                    },
                                                    className: (0, $2jatx.default)([
                                                        "_vwz4kb7n _vchhusvi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _syaz5hrz _4t3i1ul9 _p12f1osq _lcxvglyw _1gwz1ou6 _1d1fqslr"
                                                    ]),
                                                    style: {
                                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _j2s1glyw"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                                variant: "primary",
                                                size: "small",
                                                color: "blue",
                                                href: $f790ae6eedb0a62d$var$DOWNLOAD_URL,
                                                onClick: handleDownloadButtonClick,
                                                dataEventProps: {
                                                    'data-event': 'clicked',
                                                    'data-event-component': 'linkButton',
                                                    'data-event-container': 'navbar',
                                                    'data-product-key': 'sourcetreeapp',
                                                    'data-label-english': 'Download free'
                                                },
                                                children: buttonText
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lGmrg.SourcetreeAppDisclaimer), {
                isOpen: isDisclaimerOpen,
                onClose: handleDisclaimerClose,
                onConfirm: handleDisclaimerConfirm
            })
        ]
    });
};

});
parcelRegister("lGmrg", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppDisclaimer", function () { return $3b97da82052263e7$export$5eb017b420702dcb; });
/* sourcetree-app-disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $3b97da82052263e7$var$overlayStyle = null;
const $3b97da82052263e7$var$modalStyle = null;
const $3b97da82052263e7$var$closeButtonStyle = null;
const $3b97da82052263e7$var$headingStyle = null;
const $3b97da82052263e7$var$descriptionContainerStyle = null;
const $3b97da82052263e7$var$bodyTextStyle = null;
const $3b97da82052263e7$var$checkboxRowStyle = null;
const $3b97da82052263e7$var$checkboxInputStyle = null;
const $3b97da82052263e7$var$checkboxTextWrapperStyle = null;
const $3b97da82052263e7$var$checkboxTextStyle = null;
const $3b97da82052263e7$var$linkStyle = null;
const $3b97da82052263e7$var$actionsStyle = null;
const $3b97da82052263e7$var$cancelButtonStyle = null;
const $3b97da82052263e7$var$DOWNLOAD_URL = 'https://product-downloads.atlassian.com/software/sourcetree/ga/Sourcetree_4.2.16_307.zip';
const $3b97da82052263e7$var$POST_DOWNLOAD_URL = 'https://sourcetreeapp.com/post-download-content';
const $3b97da82052263e7$export$5eb017b420702dcb = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm })=>{
    const intl = (0, $8e22h.default)();
    const [isChecked, setIsChecked] = (0, $1oC0p.useState)(false);
    if (!isOpen) return null;
    const title = intl.formatMessage({
        id: 'sourcetreeapp.disclaimer.title',
        defaultMessage: 'Important information'
    });
    const description = intl.formatMessage({
        id: 'sourcetreeapp.disclaimer.description',
        defaultMessage: 'To continue downloading this product you must read and agree to the Atlassian Software License Agreement and Privacy Policy.'
    });
    const downloadLabel = intl.formatMessage({
        id: 'sourcetreeapp.disclaimer.download',
        defaultMessage: 'Download'
    });
    const cancelLabel = intl.formatMessage({
        id: 'sourcetreeapp.disclaimer.cancel',
        defaultMessage: 'Cancel'
    });
    const licenseText = intl.formatMessage({
        id: 'sourcetreeapp.disclaimer.software-license',
        defaultMessage: 'Atlassian Software License Agreement'
    });
    const privacyText = intl.formatMessage({
        id: 'sourcetreeapp.disclaimer.privacy-policy',
        defaultMessage: 'Privacy Policy'
    });
    const handleDownloadClick = (event)=>{
        event.preventDefault();
        if (!isChecked) return;
        onConfirm();
        // Open download in new tab
        window.open($3b97da82052263e7$var$DOWNLOAD_URL, '_blank');
        // Redirect current tab
        window.location.assign($3b97da82052263e7$var$POST_DOWNLOAD_URL);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "sourcetreeapp-disclaimer-modal",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "sourcetreeapp-disclaimer-heading",
            className: (0, $2jatx.default)([
                "_kqsw1n9t _1r04idpf _bfhk16p9 _1reo15vq _18m915vq _y3gn1h6o _1pbyjwwv _1e0c1txw _4cvr1h6o _1bah1h6o _v56412fe _3um0ewfl _tzy4kb7n"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk1afi _vchhusvi _1bsb1wug _p12fkbql _19pkidpf _2hwx1wug _otyridpf _18u01wug _2rko1l7b _16qs130s _kqswh2mm _y3gn1e5h _ect412pn _syazkhc1"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        "aria-label": intl.formatMessage({
                            id: 'sourcetreeapp.disclaimer.close',
                            defaultMessage: 'Close overlay'
                        }),
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tpxbi _rjxppxbi _19itglyw _bfhk1j28 _80omtlke _1wybgktf _vwz4kb7n _k48p1fw0 _syazcj8d"
                        ]),
                        style: {
                            "--_1bik04v": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark900'))
                        },
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        id: "sourcetreeapp-disclaimer-heading",
                        className: (0, $2jatx.default)([
                            "_1wyb1k92 _vwz4kb7n _k48p1nn1 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _y4tior1b _19pkidpf _2hwxidpf _otyridpf _18u0idpf _179r1w88 _y3gn1e5h _syazkhc1"
                        ]),
                        style: {
                            "--_1hwkv7u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1100')),
                            "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _y3gn1e5h"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_1wyb1j6v _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazkhc1"
                            ]),
                            style: {
                                "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                            },
                            children: description
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _yv0e1p7m _727qftgi _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1q51idpf _y3gn1e5h _4cvr1y6m"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                            htmlFor: "download-eula-checkbox",
                            style: {
                                display: 'contents'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    type: "checkbox",
                                    id: "download-eula-checkbox",
                                    name: "download-eula-checkbox",
                                    checked: isChecked,
                                    onChange: (e)=>setIsChecked(e.target.checked),
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfhi2wt _1wpz1y6m"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1pfh12gs _1wpz1y6m"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1tcg _syaz1kw7"
                                        ]),
                                        children: [
                                            "I agree to the",
                                            ' ',
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                href: "https://www.atlassian.com/legal/software-license-agreement",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: (0, $2jatx.default)([
                                                    "_syaz5hrz _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
                                                ]),
                                                style: {
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                },
                                                children: licenseText
                                            }),
                                            ' ',
                                            "and",
                                            ' ',
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: (0, $2jatx.default)([
                                                    "_syaz5hrz _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
                                                ]),
                                                style: {
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                },
                                                children: privacyText
                                            }),
                                            "."
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_mqm21w88 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _y3gnusic"
                        ]),
                        style: {
                            "--_1hwkv7u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1100'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                variant: "primary",
                                size: "small",
                                type: "button",
                                onClick: handleDownloadClick,
                                isDisabled: !isChecked,
                                children: downloadLabel
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                type: "button",
                                onClick: onClose,
                                className: (0, $2jatx.default)([
                                    "_1wyb1j6v _vwz4bs82 _k48p1nn1 _syaz5hrz _11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ahbqftgi _80omtlke _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                },
                                children: cancelLabel
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});


parcelRegister("cMLH3", function(module, exports) {
$parcel$export(module.exports, "CareerDetailsNavbar", function () { return $66e0682d5d156f6b$export$91cb0bb483ff1ce4; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cR2Ov = parcelRequire("cR2Ov");

var $hcVGp = parcelRequire("hcVGp");
const $66e0682d5d156f6b$export$91cb0bb483ff1ce4 = ()=>{
    const intl = (0, $8e22h.default)();
    // Title
    const careersHref = (0, $jQ0cd.useLocalizedHref)('/company/careers');
    // Top-level flat links
    const browseJobsHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/all-jobs');
    const earlyCareersHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/earlycareers');
    // Our Teams dropdown
    const engineeringHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/engineering');
    const aiEngineeringHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/engineering/ai');
    const salesHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/sales');
    const allTeamsHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/teams');
    // Team Experience dropdown
    const teamAnywhereHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/teamanywhere');
    const teamEveryoneHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/team-everyone');
    const employeeAwardsHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/employee-awards');
    // Candidate Resources dropdown
    const candidateResourcesHubHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/resources');
    const applyingHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/resources/applying');
    const interviewingHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/resources/interviewing');
    const careerGrowthHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/resources/career-growth');
    const benefitsAndPerksHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/resources/perk-and-benefits');
    const talentCommunityHref = (0, $jQ0cd.useLocalizedHref)('https://join.atlassian.com/atlassian-talent-community/talentcommunity/form');
    const awardsHref = (0, $jQ0cd.useLocalizedHref)('/company/careers/resources/awards');
    const props = {
        compoundSubNavTitle: intl.formatMessage({
            id: 'CareerDetailsNavbar.title',
            defaultMessage: 'Careers'
        }),
        compoundSubNavTitleHref: careersHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: 'browse-jobs',
                linkText: intl.formatMessage({
                    id: 'CareerDetailsNavbar.browseJobs',
                    defaultMessage: 'Browse Jobs'
                }),
                hasDropdown: false,
                href: browseJobsHref
            },
            {
                globalLinksKey: 'our-teams',
                linkText: intl.formatMessage({
                    id: 'CareerDetailsNavbar.ourTeams',
                    defaultMessage: 'Our Teams'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.engineering',
                                        defaultMessage: 'Engineering'
                                    }),
                                    href: engineeringHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.aiAndMachineLearning',
                                        defaultMessage: 'AI and Machine Learning'
                                    }),
                                    href: aiEngineeringHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.sales',
                                        defaultMessage: 'Sales'
                                    }),
                                    href: salesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.allTeams',
                                        defaultMessage: 'All Teams'
                                    }),
                                    href: allTeamsHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'early-careers',
                linkText: intl.formatMessage({
                    id: 'CareerDetailsNavbar.earlyCareers',
                    defaultMessage: 'Early Careers'
                }),
                hasDropdown: false,
                href: earlyCareersHref
            },
            {
                globalLinksKey: 'team-experience',
                linkText: intl.formatMessage({
                    id: 'CareerDetailsNavbar.teamExperience',
                    defaultMessage: 'Team Experience'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.teamAnywhere',
                                        defaultMessage: 'Team Anywhere'
                                    }),
                                    href: teamAnywhereHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.teamEveryone',
                                        defaultMessage: 'Team Everyone'
                                    }),
                                    href: teamEveryoneHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.employeeAwards',
                                        defaultMessage: 'Employee Awards'
                                    }),
                                    href: employeeAwardsHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'candidate-resources',
                linkText: intl.formatMessage({
                    id: 'CareerDetailsNavbar.candidateResources',
                    defaultMessage: 'Candidate Resources'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.candidateResourcesHub',
                                        defaultMessage: 'Candidate Resources Hub'
                                    }),
                                    href: candidateResourcesHubHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.tipsForApplying',
                                        defaultMessage: 'Tips for Applying'
                                    }),
                                    href: applyingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.interviewing',
                                        defaultMessage: 'Interviewing'
                                    }),
                                    href: interviewingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.careerGrowth',
                                        defaultMessage: 'Career Growth'
                                    }),
                                    href: careerGrowthHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.benefitsAndPerks',
                                        defaultMessage: 'Benefits and Perks'
                                    }),
                                    href: benefitsAndPerksHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.talentCommunity',
                                        defaultMessage: 'Talent Community'
                                    }),
                                    href: talentCommunityHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CareerDetailsNavbar.awards',
                                        defaultMessage: 'Awards'
                                    }),
                                    href: awardsHref
                                }
                            ]
                        }
                    ]
                })
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
        productKey: 'careers',
        compoundNav: props
    });
};

});

parcelRegister("lpEyw", function(module, exports) {
$parcel$export(module.exports, "RovoDevNav", function () { return $ce46063e2c74000e$export$446da800ffd5a425; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $hnmMQ = parcelRequire("hnmMQ");

var $jQ0cd = parcelRequire("jQ0cd");

var $gn6Qa = parcelRequire("gn6Qa");
const $ce46063e2c74000e$export$446da800ffd5a425 = ()=>{
    const intl = (0, $8e22h.default)();
    const oldSignupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=devai');
    const newSignupLink = (0, $jQ0cd.useLocalizedHref)('/software/jira/dev');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/rovo-dev/pricing');
    const documentationHref = (0, $jQ0cd.useLocalizedHref)('https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents');
    const logo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg',
            alt: 'Rovo Dev'
        },
        style: {
            height: '26px'
        }
    });
    let linkProps = [
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                id: 'RovoDevNav.pricing',
                defaultMessage: 'Pricing'
            }),
            hasDropdown: false,
            productKey: 'rovoDev',
            href: pricingHref
        },
        {
            globalLinksKey: 'documentation',
            linkText: intl.formatMessage({
                id: 'RovoDevNav.documentation',
                defaultMessage: 'Documentation'
            }),
            hasDropdown: false,
            productKey: 'rovoDev',
            href: documentationHref
        }
    ];
    const oldCtaText = intl.formatMessage({
        id: 'RovoDevNav.tryItFree',
        defaultMessage: 'Try it Free'
    });
    const newCtaText = intl.formatMessage({
        id: 'RovoDevNav.tryJira',
        defaultMessage: 'Try Jira'
    });
    const isEol = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).rovoDevEolProductNav);
    if (isEol) linkProps = linkProps.filter((link)=>link.globalLinksKey !== 'pricing');
    const signupLink = isEol ? newSignupLink : oldSignupLink;
    const ctaText = isEol ? newCtaText : oldCtaText;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
        productLogoUrl: "/software/rovo-dev",
        productLogo: logo,
        productLogoAriaLabel: intl.formatMessage({
            id: 'RovoDevNav.productLogoAriaLabel',
            defaultMessage: 'Rovo Dev logo'
        }),
        mobileCtaText: ctaText,
        navigationTrynowCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileLogo: logo,
        productPageNavLinks: linkProps,
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: 'mobile-rovo-dev',
                mobileLinksProps: linkProps
            }
        ]
    });
};

});

parcelRegister("8xC9Z", function(module, exports) {
$parcel$export(module.exports, "OptionalSiteSelectorContextProvider", function () { return $770969627e2933b5$export$ef73016e54e00d81; });

var $7VQPk = parcelRequire("7VQPk");

var $iHYHa = parcelRequire("iHYHa");
const $770969627e2933b5$export$ef73016e54e00d81 = (props)=>{
    const { siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix, children: children } = props;
    if (!siteSelectorProductKey) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iHYHa.SiteSelectorContextProvider), {
        productKey: siteSelectorProductKey,
        analyticsPrefix: siteSelectorAnalyticsPrefix ?? siteSelectorProductKey,
        internalLinkAfterIdentity: siteSelectorProductKey === 'confluence.ondemand' ? '/team-playbook/plays/choose-your-site' : undefined,
        children: children
    });
};

});


parcelRegister("7xYdG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8abc8eb98b0d0a1c$export$2e2bcd8739ae039; });
/* pagination.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $sGleB = parcelRequire("sGleB");
const $8abc8eb98b0d0a1c$var$centerStyles = null;
const $8abc8eb98b0d0a1c$var$UniformPagination = (props)=>{
    // Generate pages array from total pages
    const pagesArray = Array.from({
        length: props.pages
    }, (_, i)=>i + 1);
    // For now, using defaults until page logic is implemented
    const selectedIndex = 0;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $sGleB.Pagination), {
            pages: pagesArray,
            selectedIndex: selectedIndex
        })
    });
};
var $8abc8eb98b0d0a1c$export$2e2bcd8739ae039 = $8abc8eb98b0d0a1c$var$UniformPagination;

});

parcelRegister("gebIf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $88f904a45e3c98a2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $2smMv = parcelRequire("2smMv");

var $lTkkF = parcelRequire("lTkkF");
const $88f904a45e3c98a2$var$UniformPanel = (props)=>{
    const panelProps = {
        panelType: props.panelType,
        label: props.label,
        description: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.description ?? null
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2smMv.Panel), {
        ...panelProps
    });
};
var $88f904a45e3c98a2$export$2e2bcd8739ae039 = $88f904a45e3c98a2$var$UniformPanel;

});

parcelRegister("9tius", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc353b3611f7f2c4$export$2e2bcd8739ae039; });
/* personalization-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $aj5Hv = parcelRequire("aj5Hv");

var $jiOui = parcelRequire("jiOui");

var $gIKKj = parcelRequire("gIKKj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $eRzlV = parcelRequire("eRzlV");

var $iSeHD = parcelRequire("iSeHD");

var $9rnwe = parcelRequire("9rnwe");

var $4L5aK = parcelRequire("4L5aK");

var $3o1l4 = parcelRequire("3o1l4");
const $bc353b3611f7f2c4$var$VariantsStatus = {
    NO_VARIANT_MATCH: 'no_variant_match',
    VARIANTS_AVAILABLE: 'variants_available',
    FETCHING_SEGMENTS: 'fetching_segments',
    SEGMENT_FETCH_ERROR: 'segment_fetch_error',
    MISSING_USER_SEGMENTS: 'missing_user_segments',
    PERSONALIZATION_DISABLED: 'personalization_disabled',
    NOT_ENROLLED_IN_EXPERIMENT: 'not_enrolled_in_experiment'
};
const $bc353b3611f7f2c4$var$renderMessages = {
    [$bc353b3611f7f2c4$var$VariantsStatus.NO_VARIANT_MATCH]: 'No variants match. Rendering Default',
    [$bc353b3611f7f2c4$var$VariantsStatus.MISSING_USER_SEGMENTS]: 'No User Segments acquired. Rendering Default',
    [$bc353b3611f7f2c4$var$VariantsStatus.PERSONALIZATION_DISABLED]: 'Personalization is disabled. Rendering Default',
    [$bc353b3611f7f2c4$var$VariantsStatus.SEGMENT_FETCH_ERROR]: 'Error fetching User Segments. Rendering Default',
    [$bc353b3611f7f2c4$var$VariantsStatus.NOT_ENROLLED_IN_EXPERIMENT]: 'User not enrolled in experiment. Rendering Default',
    [$bc353b3611f7f2c4$var$VariantsStatus.FETCHING_SEGMENTS]: 'Fetching User Segments. Temporarily rendering Default',
    [$bc353b3611f7f2c4$var$VariantsStatus.VARIANTS_AVAILABLE]: ''
};
const $bc353b3611f7f2c4$var$VariantSelector = (props)=>{
    return(// this should only be one item, but the SlotWrapper expects an array
    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: props.items.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                children: item
            }, `variant-${index}`))
    }));
};
// Helper function to render default slot
const $bc353b3611f7f2c4$var$renderDefaultSlot = (variantStatus, setRenderMessage)=>{
    setRenderMessage($bc353b3611f7f2c4$var$renderMessages[variantStatus]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "default",
        wrapperComponent: $bc353b3611f7f2c4$var$VariantSelector
    });
};
const $bc353b3611f7f2c4$var$isSegmentGroup = (entry)=>'matchMode' in entry && 'segments' in entry;
/**
 * Normalize the user's value for a given segment type to a string array.
 * All segment types are normalized to string[] for uniform comparison.
 */ const $bc353b3611f7f2c4$var$getUserValues = (segmentType, personalizationSegmentValues)=>{
    const raw = personalizationSegmentValues[segmentType];
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    return [
        raw
    ];
};
/**
 * Evaluate a single SegmentRule against the user's profile values.
 * Applies the rule's operator (defaults to "is" for legacy data with no operator).
 */ const $bc353b3611f7f2c4$var$evaluateSegmentRule = (rule, personalizationSegmentValues)=>{
    const op = rule.operator ?? 'is';
    const userValues = $bc353b3611f7f2c4$var$getUserValues(rule.segmentType, personalizationSegmentValues);
    // Helper: does any rule target match any user value, given a comparator?
    const positiveMatch = (comparator)=>rule.value.some((v)=>userValues.some((u)=>comparator(u, v)));
    switch(op){
        case 'is':
        // "matches" is an alias for "is" (exact equality on discrete values)
        case 'matches':
            return positiveMatch((u, v)=>u === v);
        case 'is_not':
        // "not_matches" is an alias for "is_not"
        case 'not_matches':
            return !positiveMatch((u, v)=>u === v);
        case 'includes':
            return positiveMatch((u, v)=>u.includes(v));
        case 'not_includes':
            return !positiveMatch((u, v)=>u.includes(v));
        case 'matches_regex':
            // Compile each regex once per target value (not inside the inner loop)
            return rule.value.some((v)=>{
                const re = new RegExp(v);
                return userValues.some((u)=>re.test(u));
            });
        case 'not_matches_regex':
            return !rule.value.some((v)=>{
                const re = new RegExp(v);
                return userValues.some((u)=>re.test(u));
            });
        default:
            return false;
    }
};
/**
 * Evaluate a SegmentGroup against the user's profile values.
 * matchMode "any" = OR across rules, "all" = AND across rules.
 */ const $bc353b3611f7f2c4$var$evaluateSegmentGroup = (group, personalizationSegmentValues)=>{
    const check = group.matchMode === 'any' ? 'some' : 'every';
    return group.segments[check]((rule)=>$bc353b3611f7f2c4$var$evaluateSegmentRule(rule, personalizationSegmentValues));
};
// Helper function to find matching variant index
const $bc353b3611f7f2c4$var$findMatchingVariant = (variantCandidates, personalizationSegmentValues)=>{
    if (!personalizationSegmentValues) return -1;
    return variantCandidates.findIndex((variantCandidate)=>{
        const rawValue = variantCandidate.parameters?.['personalizationSegment']?.value;
        if (!rawValue || rawValue.length === 0) return false;
        const firstEntry = rawValue[0];
        if (!firstEntry) return false;
        // Detect format by checking whether the first item is a SegmentGroup
        if ($bc353b3611f7f2c4$var$isSegmentGroup(firstEntry)) {
            const groups = rawValue;
            // ALL groups must pass (AND between groups)
            return groups.every((group)=>$bc353b3611f7f2c4$var$evaluateSegmentGroup(group, personalizationSegmentValues));
        }
        // Legacy flat format: all rules are AND-ed together ("is" operator implied when absent)
        const segments = rawValue;
        return segments.every((rule)=>$bc353b3611f7f2c4$var$evaluateSegmentRule(rule, personalizationSegmentValues));
    });
};
// Profile-derived segments can report "complete" from SSR context and still change
// value once GUPS returns, so they cannot rule a variant out while segments are pending.
const $bc353b3611f7f2c4$var$PROFILE_DERIVED_SEGMENT_TYPES = new Set([
    (0, $3o1l4.UserSegmentTypes).JOB_FUNCTION,
    (0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE,
    (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS,
    (0, $3o1l4.UserSegmentTypes).PRODUCT_USED_EVER,
    (0, $3o1l4.UserSegmentTypes).FIRST_RECOMMENDATION,
    (0, $3o1l4.UserSegmentTypes).SECOND_RECOMMENDATION,
    (0, $3o1l4.UserSegmentTypes).THIRD_RECOMMENDATION,
    (0, $3o1l4.UserSegmentTypes).FOURTH_RECOMMENDATION,
    (0, $3o1l4.UserSegmentTypes).COLLECTION_OPTIONS
]);
const $bc353b3611f7f2c4$var$isSettledRuleFailing = (rule, personalizationSegmentValues, statuses)=>statuses[rule.segmentType] === 'complete' && !$bc353b3611f7f2c4$var$PROFILE_DERIVED_SEGMENT_TYPES.has(rule.segmentType) && !$bc353b3611f7f2c4$var$evaluateSegmentRule(rule, personalizationSegmentValues);
// A variant is ruled out when it can no longer match, whatever the pending segments return
const $bc353b3611f7f2c4$var$isVariantRuledOut = (variantCandidate, personalizationSegmentValues, statuses)=>{
    const rawValue = variantCandidate.parameters?.['personalizationSegment']?.value;
    // findMatchingVariant never selects a variant without segments
    const firstEntry = rawValue?.[0];
    if (!rawValue || !firstEntry) return true;
    if ($bc353b3611f7f2c4$var$isSegmentGroup(firstEntry)) return rawValue.some((group)=>group.matchMode === 'any' ? group.segments.every((rule)=>$bc353b3611f7f2c4$var$isSettledRuleFailing(rule, personalizationSegmentValues, statuses)) : group.segments.some((rule)=>$bc353b3611f7f2c4$var$isSettledRuleFailing(rule, personalizationSegmentValues, statuses)));
    return rawValue.some((rule)=>$bc353b3611f7f2c4$var$isSettledRuleFailing(rule, personalizationSegmentValues, statuses));
};
// Helper function to get final personalization values
const $bc353b3611f7f2c4$var$getFinalPersonalizationValues = (userSegments, overrides)=>{
    const finalValues = {
        ...userSegments,
        ...overrides?.useOverrides ? overrides : {},
        useOverrides: overrides?.useOverrides || false,
        enrollInExperiment: overrides?.enrollInExperiment || false
    };
    return finalValues;
};
const $bc353b3611f7f2c4$var$ExperimentallyPersonalizedSection = ({ experimentId: experimentId, setVariantStatus: setVariantStatus, overrides: overrides, setRenderMessage: setRenderMessage, variantComponent: variantComponent })=>{
    const experimentStatus = (0, $gIKKj.useExperiment)({
        experimentName: experimentId,
        parameterName: 'enrolled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>typeof value === 'boolean'
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Personalization Experiment - configured in Uniform',
            expectedReleaseDate: 'unknown - configured in Uniform',
            expectedRuntime: 'unknown - configured in Uniform',
            context: {
                urls: []
            }
        }
    });
    const showTreatment = experimentStatus.type === 'enrolled' && experimentStatus.value;
    (0, $1oC0p.useEffect)(()=>{
        if (!showTreatment && !overrides?.enrollInExperiment) {
            if (setVariantStatus) setVariantStatus($bc353b3611f7f2c4$var$VariantsStatus.NOT_ENROLLED_IN_EXPERIMENT);
        }
    }, [
        showTreatment,
        overrides?.enrollInExperiment,
        setVariantStatus
    ]);
    if (!showTreatment && !overrides?.enrollInExperiment) return $bc353b3611f7f2c4$var$renderDefaultSlot($bc353b3611f7f2c4$var$VariantsStatus.NOT_ENROLLED_IN_EXPERIMENT, setRenderMessage);
    return variantComponent;
};
const $bc353b3611f7f2c4$var$getRequiredSegmentTypes = (variantCandidates)=>{
    const requiredSegments = new Set();
    variantCandidates.forEach((variantCandidate)=>{
        const rawValue = variantCandidate.parameters?.['personalizationSegment']?.value;
        if (!rawValue || rawValue.length === 0) return;
        const firstEntry = rawValue[0];
        if (!firstEntry) return;
        if ($bc353b3611f7f2c4$var$isSegmentGroup(firstEntry)) // New group format: extract segment types from nested segments
        rawValue.forEach((group)=>{
            group.segments.forEach(({ segmentType: segmentType })=>requiredSegments.add(segmentType));
        });
        else // Legacy flat format
        rawValue.forEach(({ segmentType: segmentType })=>requiredSegments.add(segmentType));
    });
    return [
        ...requiredSegments
    ];
};
const $bc353b3611f7f2c4$var$STATIC_PERSONALIZATION_HYDRATION_RULES = [
    {
        field: (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG,
            'clusterTag',
            'anchor'
        ],
        hasIncomingValue: (value)=>typeof value === 'string' && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ''
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).SUB_ANCHOR,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).SUB_ANCHOR,
            'subAnchor'
        ],
        hasIncomingValue: (value)=>typeof value === 'string' && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ''
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).CHANNEL,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).CHANNEL
        ],
        hasIncomingValue: (value)=>typeof value === 'string' && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ''
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).UTM_CONTENT,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).UTM_CONTENT,
            'utmContent'
        ],
        hasIncomingValue: (value)=>typeof value === 'string' && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ''
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).JOB_FUNCTION,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).JOB_FUNCTION
        ],
        hasIncomingValue: (value)=>typeof value === 'string' && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ''
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).GEOLOCATION,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).GEOLOCATION
        ],
        hasIncomingValue: (value)=>typeof value === 'string' && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ''
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE
        ],
        hasIncomingValue: (value)=>typeof value === 'string' && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ''
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).LOGIN_STATUS,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).LOGIN_STATUS
        ],
        hasIncomingValue: (value)=>typeof value === 'string' && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ''
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS
        ],
        hasIncomingValue: (value)=>Array.isArray(value) && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || Array.isArray(value) && value.length === 0
    }
];
const $bc353b3611f7f2c4$var$hydrateStaticPersonalizationValues = (previousOverrides, personalizationValues)=>{
    let didChange = false;
    const nextOverrides = {
        ...previousOverrides
    };
    $bc353b3611f7f2c4$var$STATIC_PERSONALIZATION_HYDRATION_RULES.forEach(({ field: field, hasIncomingValue: hasIncomingValue, isMissingOverrideValue: isMissingOverrideValue })=>{
        const incomingValue = personalizationValues[field];
        if (hasIncomingValue(incomingValue) && isMissingOverrideValue(nextOverrides[field])) {
            nextOverrides[field] = incomingValue;
            didChange = true;
        }
    });
    return didChange ? nextOverrides : previousOverrides;
};
const $bc353b3611f7f2c4$var$readStaticPersonalizationValuesFromQuirks = (uniformContext)=>{
    const contextWithStorage = uniformContext;
    const directQuirks = contextWithStorage?.quirks ?? {};
    const storageQuirks = contextWithStorage?.storage?.data?.quirks ?? {};
    const quirks = {
        ...storageQuirks,
        ...directQuirks
    };
    return $bc353b3611f7f2c4$var$STATIC_PERSONALIZATION_HYDRATION_RULES.reduce((acc, { field: field, sourceKeys: sourceKeys, hasIncomingValue: hasIncomingValue })=>{
        const candidateValue = sourceKeys.map((sourceKey)=>quirks[sourceKey]).find((value)=>hasIncomingValue(value));
        if (hasIncomingValue(candidateValue)) acc[field] = candidateValue;
        return acc;
    }, {});
};
// Helper function to validate personalization prerequisites
const $bc353b3611f7f2c4$var$validatePersonalizationPrerequisites = (shouldPersonalize, isProd, userSegments, statuses, error, segmentFetchErrors, requiredSegmentTypes, overrides)=>{
    // Check if any required segments are still fetching
    const areRequiredSegmentsFetching = requiredSegmentTypes.some((segmentType)=>!statuses[segmentType] || statuses[segmentType] === 'fetching' || statuses[segmentType] === 'idle');
    if (areRequiredSegmentsFetching) return {
        isValid: false,
        status: $bc353b3611f7f2c4$var$VariantsStatus.FETCHING_SEGMENTS
    };
    if (!shouldPersonalize && isProd) return {
        isValid: false,
        status: $bc353b3611f7f2c4$var$VariantsStatus.PERSONALIZATION_DISABLED
    };
    if (!userSegments) return {
        isValid: false,
        status: $bc353b3611f7f2c4$var$VariantsStatus.MISSING_USER_SEGMENTS
    };
    const hasRequiredSegmentFetchErrors = requiredSegmentTypes.length > 0 && (segmentFetchErrors || []).some((segmentType)=>requiredSegmentTypes.includes(segmentType));
    if (error && !overrides?.useOverrides && hasRequiredSegmentFetchErrors) return {
        isValid: false,
        status: $bc353b3611f7f2c4$var$VariantsStatus.SEGMENT_FETCH_ERROR
    };
    return {
        isValid: true
    };
};
// UniformSlot renders wrapperComponent as an element type, so each index needs a stable
// component or the variant remounts every time the selection memo recomputes
const $bc353b3611f7f2c4$var$singleVariantSelectors = new Map();
const $bc353b3611f7f2c4$var$getSingleVariantSelector = (chosenVariantIndex)=>{
    const cached = $bc353b3611f7f2c4$var$singleVariantSelectors.get(chosenVariantIndex);
    if (cached) return cached;
    const SingleVariantSelector = (slotProps)=>$bc353b3611f7f2c4$var$VariantSelector({
            ...slotProps,
            items: [
                slotProps.items[chosenVariantIndex]
            ]
        });
    $bc353b3611f7f2c4$var$singleVariantSelectors.set(chosenVariantIndex, SingleVariantSelector);
    return SingleVariantSelector;
};
// Helper function to create variant component
const $bc353b3611f7f2c4$var$createVariantComponent = (chosenVariantIndex, isNoContentSwapEnabled)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "variants",
        wrapperComponent: isNoContentSwapEnabled ? $bc353b3611f7f2c4$var$getSingleVariantSelector(chosenVariantIndex) : (slotProps)=>$bc353b3611f7f2c4$var$VariantSelector({
                ...slotProps,
                items: [
                    slotProps.items[chosenVariantIndex]
                ]
            })
    });
// Helper function to set render message for variant
const $bc353b3611f7f2c4$var$setVariantRenderMessage = (variantCandidates, chosenVariantIndex, overrides, setRenderMessage)=>{
    const variantName = $bc353b3611f7f2c4$var$getCurrentVariantName(variantCandidates, chosenVariantIndex);
    const sourceType = overrides?.useOverrides ? 'Overrides' : 'User Segments';
    setRenderMessage(`Rendering "${variantName}" Variant based on ${sourceType}`);
};
const $bc353b3611f7f2c4$var$getCurrentVariantName = (variantCandidates, chosenVariantIndex)=>{
    return variantCandidates[chosenVariantIndex]?.parameters?.['variantName']?.value || 'unknown';
};
const $bc353b3611f7f2c4$var$toKebabCase = (value)=>value.trim().replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, '').toLowerCase();
const $bc353b3611f7f2c4$var$getVariantPersonalizationIdentifier = (variantCandidate)=>{
    const rawValue = variantCandidate.parameters?.['personalizationSegment']?.value;
    const entries = rawValue ?? [];
    const segmentRules = entries.flatMap((entry)=>$bc353b3611f7f2c4$var$isSegmentGroup(entry) ? entry.segments : [
            entry
        ]);
    const anchorRule = segmentRules.find((rule)=>rule.segmentType === (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG || rule.segmentType === (0, $3o1l4.UserSegmentTypes).SUB_ANCHOR);
    const anchorValue = anchorRule?.value.find((value)=>value.length > 0);
    if (anchorValue) return $bc353b3611f7f2c4$var$toKebabCase(anchorValue);
    const variantName = variantCandidate.parameters?.['variantName']?.value;
    return typeof variantName === 'string' && variantName.length > 0 ? $bc353b3611f7f2c4$var$toKebabCase(variantName) : undefined;
};
// eslint-disable-next-line complexity
const $bc353b3611f7f2c4$var$PersonalizedSection = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const [variantStatus, setVariantStatus] = (0, $1oC0p.useState)(null);
    const [hasMounted, setHasMounted] = (0, $1oC0p.useState)(false);
    const { data: userSegments, error: error, segmentFetchErrors: segmentFetchErrors, statuses: statuses } = (0, $3o1l4.useUserSegments)();
    const isNoContentSwapEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).personalizationNoContentSwap);
    const shouldPersonalize = (0, $jiOui.getDynamicConfig)({
        config: (0, $aj5Hv.dynamicConfigManifest).isPersonalizationEnabled,
        defaultValue: false
    });
    const isProd = (0, $eRzlV.isProduction)();
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition?.data?._id;
    // Memoize slots to prevent infinite loops
    const variantSlots = (0, $1oC0p.useMemo)(()=>props.component.slots?.['variants'] ?? [], [
        props.component.slots
    ]);
    const hasLoadingSlot = (props.component.slots?.['loading']?.length ?? 0) > 0;
    const isFetchingRequiredSegment = props.requiredSegmentTypes.some((segmentType)=>statuses[segmentType] === 'fetching');
    (0, $1oC0p.useEffect)(()=>{
        if (hasLoadingSlot) setHasMounted(true);
    }, [
        hasLoadingSlot
    ]);
    // Compute variant selection synchronously during render (SSR + Client)
    const { selectedVariantKey: selectedVariantKey, computedStatus: computedStatus, renderedExperience: renderedExperience } = (0, $1oC0p.useMemo)(()=>{
        const validation = $bc353b3611f7f2c4$var$validatePersonalizationPrerequisites(shouldPersonalize, isProd, userSegments, statuses, error, segmentFetchErrors, props.requiredSegmentTypes, props.overrides);
        const personalizationValues = $bc353b3611f7f2c4$var$getFinalPersonalizationValues(userSegments, props.overrides);
        if (!validation.isValid) {
            // Settle on default while segments are pending once no variant can still match
            const isDefaultSettled = isNoContentSwapEnabled && validation.status === $bc353b3611f7f2c4$var$VariantsStatus.FETCHING_SEGMENTS && variantSlots.every((variantCandidate)=>$bc353b3611f7f2c4$var$isVariantRuledOut(variantCandidate, personalizationValues, statuses));
            return {
                selectedVariantKey: 'default_experience',
                computedStatus: isDefaultSettled ? $bc353b3611f7f2c4$var$VariantsStatus.NO_VARIANT_MATCH : validation.status,
                renderedExperience: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: "default",
                    wrapperComponent: $bc353b3611f7f2c4$var$VariantSelector
                })
            };
        }
        // Process personalization logic
        const chosenVariantIndex = $bc353b3611f7f2c4$var$findMatchingVariant(variantSlots, personalizationValues);
        // Check if variant was found
        if (chosenVariantIndex < 0) return {
            selectedVariantKey: 'default_experience',
            computedStatus: $bc353b3611f7f2c4$var$VariantsStatus.NO_VARIANT_MATCH,
            renderedExperience: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "default",
                wrapperComponent: $bc353b3611f7f2c4$var$VariantSelector
            })
        };
        const variantName = $bc353b3611f7f2c4$var$getCurrentVariantName(variantSlots, chosenVariantIndex);
        const selectedVariant = variantSlots[chosenVariantIndex];
        const variantIdentifier = selectedVariant ? $bc353b3611f7f2c4$var$getVariantPersonalizationIdentifier(selectedVariant) : undefined;
        const variantComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "uniform-personalization-variant",
            "data-personalization-identifier": variantIdentifier,
            "data-variant-name": variantName,
            children: $bc353b3611f7f2c4$var$createVariantComponent(chosenVariantIndex, isNoContentSwapEnabled)
        });
        // Handle experimental personalization
        if (props.experimentId) return {
            selectedVariantKey: variantName,
            computedStatus: $bc353b3611f7f2c4$var$VariantsStatus.VARIANTS_AVAILABLE,
            renderedExperience: /*#__PURE__*/ (0, $7VQPk.jsx)($bc353b3611f7f2c4$var$ExperimentallyPersonalizedSection, {
                containerName: props.containerName,
                setRenderMessage: props.setRenderMessage,
                setVariantStatus: setVariantStatus,
                experimentId: props.experimentId,
                variantComponent: variantComponent,
                overrides: props.overrides,
                component: props.component
            })
        };
        return {
            selectedVariantKey: variantName,
            computedStatus: $bc353b3611f7f2c4$var$VariantsStatus.VARIANTS_AVAILABLE,
            renderedExperience: variantComponent
        };
    }, [
        error,
        segmentFetchErrors,
        isNoContentSwapEnabled,
        props.overrides,
        props.setRenderMessage,
        props.experimentId,
        props.containerName,
        props.component,
        props.requiredSegmentTypes,
        shouldPersonalize,
        isProd,
        statuses,
        userSegments,
        variantSlots
    ]);
    // With the gate on, render the loading slot from the server render onwards while a
    // variant could still match, so visitors never see the default and then a different
    // variant. With it off, keep the server render on default and only show the loading
    // slot after mount while a required segment is fetching.
    const showLoadingSlot = hasLoadingSlot && computedStatus === $bc353b3611f7f2c4$var$VariantsStatus.FETCHING_SEGMENTS && (shouldPersonalize || !isProd) && (isNoContentSwapEnabled || hasMounted && isFetchingRequiredSegment);
    // Update render message as a side effect (client-only)
    (0, $1oC0p.useEffect)(()=>{
        if (computedStatus === $bc353b3611f7f2c4$var$VariantsStatus.VARIANTS_AVAILABLE) {
            const chosenVariantIndex = variantSlots.findIndex((v)=>$bc353b3611f7f2c4$var$getCurrentVariantName(variantSlots, variantSlots.indexOf(v)) === selectedVariantKey);
            if (chosenVariantIndex >= 0) $bc353b3611f7f2c4$var$setVariantRenderMessage(variantSlots, chosenVariantIndex, props.overrides, props.setRenderMessage);
        } else props.setRenderMessage(showLoadingSlot ? 'Fetching User Segments. Rendering Loading' : $bc353b3611f7f2c4$var$renderMessages[computedStatus]);
        setVariantStatus(computedStatus);
    }, [
        computedStatus,
        selectedVariantKey,
        variantSlots,
        props.overrides,
        props.setRenderMessage,
        showLoadingSlot
    ]);
    // Send analytics metrics (client-only)
    (0, $1oC0p.useEffect)(()=>{
        if (!selectedVariantKey || !variantStatus || showLoadingSlot) return;
        if (analyticsClient && typeof window !== 'undefined') createAnalyticsEvent({
            name: 'waePersonalizationVariantRender',
            action: 'personalizationVariantRender',
            actionSubject: 'uniformPage',
            eventType: 'screen',
            source: window.location.pathname,
            attributes: {
                containerName: props.containerName,
                path: window.location.pathname,
                compositionId: compositionId,
                variantName: selectedVariantKey,
                status: variantStatus
            }
        }).fire();
    }, [
        compositionId,
        createAnalyticsEvent,
        selectedVariantKey,
        props.containerName,
        variantStatus,
        analyticsClient,
        showLoadingSlot
    ]);
    if (showLoadingSlot) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "loading",
        wrapperComponent: $bc353b3611f7f2c4$var$VariantSelector
    });
    return renderedExperience;
};
const $bc353b3611f7f2c4$var$UniformPersonalizationContainer = (props)=>{
    const isProd = (0, $eRzlV.isProduction)();
    const isUniformEditMode = typeof window !== 'undefined' && window.location.pathname.includes('/uniform-preview');
    const { personalizationValues: personalizationValues, uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    const currentComposition = (0, $01zo5.useUniformCurrentComposition)();
    const requiredSegmentTypes = (0, $1oC0p.useMemo)(()=>$bc353b3611f7f2c4$var$getRequiredSegmentTypes(props.component.slots?.['variants'] ?? []), [
        props.component.slots
    ]);
    const [overrides, setOverrides] = (0, $1oC0p.useState)(()=>{
        const initialOverrides = {
            useOverrides: false,
            enrollInExperiment: false,
            ...personalizationValues
        };
        return initialOverrides;
    });
    const [renderMessage, setRenderMessage] = (0, $1oC0p.useState)('');
    const [isContainerHovered, setIsContainerHovered] = (0, $1oC0p.useState)(false);
    const [isControlsPinned, setIsControlsPinned] = (0, $1oC0p.useState)(false);
    const [isControlsActive, setIsControlsActive] = (0, $1oC0p.useState)(false);
    const isActiveLayer = isContainerHovered || isControlsPinned || isControlsActive || isUniformEditMode;
    (0, $1oC0p.useEffect)(()=>{
        if (!personalizationValues) return;
        // `personalizationValues` are seeded in page-wrapper-streaming and mirrored to Uniform quirks.
        // Treat these as static bootstrap values and only fill missing override fields.
        setOverrides((previousOverrides)=>$bc353b3611f7f2c4$var$hydrateStaticPersonalizationValues(previousOverrides, personalizationValues));
    }, [
        personalizationValues
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!isUniformEditMode) return;
        const syncQuirkValues = ()=>{
            const nextQuirkValues = $bc353b3611f7f2c4$var$readStaticPersonalizationValuesFromQuirks(uniformContext);
            setOverrides((previousOverrides)=>$bc353b3611f7f2c4$var$hydrateStaticPersonalizationValues(previousOverrides, nextQuirkValues));
        };
        syncQuirkValues();
        const intervalId = window.setInterval(syncQuirkValues, 250);
        return ()=>{
            window.clearInterval(intervalId);
        };
    }, [
        isUniformEditMode,
        uniformContext
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        onMouseEnter: !isProd ? ()=>setIsContainerHovered(true) : undefined,
        onMouseLeave: !isProd ? ()=>setIsContainerHovered(false) : undefined,
        className: (0, $2jatx.default)([
            !isProd && "_kqswh2mm _12ji1j28 _1qu2nqa1 _12y3yh40 _2rko1ylz _v564lu1q _1ubtygsz"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_138yw56": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue300'))
        },
        children: [
            !isProd && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    zIndex: isActiveLayer ? 2147483000 : 1
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4L5aK.PersonalizationOverrideControls), {
                    values: overrides,
                    setValues: setOverrides,
                    renderMessage: renderMessage,
                    isContainerHovered: isContainerHovered,
                    requiredSegmentTypes: requiredSegmentTypes,
                    isPinned: isControlsPinned,
                    setIsPinned: setIsControlsPinned,
                    setIsActive: setIsControlsActive,
                    compositionSlug: currentComposition?.data?.projectMapNodes?.[0]?.path ?? currentComposition?.data?._slug
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($bc353b3611f7f2c4$var$PersonalizedSection, {
                ...props,
                overrides: overrides,
                setRenderMessage: setRenderMessage,
                experimentId: props.experimentId,
                requiredSegmentTypes: requiredSegmentTypes
            })
        ]
    });
};
var $bc353b3611f7f2c4$export$2e2bcd8739ae039 = $bc353b3611f7f2c4$var$UniformPersonalizationContainer;

});
parcelRegister("4L5aK", function(module, exports) {
$parcel$export(module.exports, "PersonalizationOverrideControls", function () { return $0a7d65259cee0cad$export$3509149ef9c5f46; });
/* personalization-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $LDFpB = parcelRequire("LDFpB");

var $grkXZ = parcelRequire("grkXZ");

var $eC3qs = parcelRequire("eC3qs");

var $kbpa7 = parcelRequire("kbpa7");

var $aL9gN = parcelRequire("aL9gN");

var $8c0sT = parcelRequire("8c0sT");

var $3o1l4 = parcelRequire("3o1l4");
const $0a7d65259cee0cad$var$LABEL_STYLES = null;
const $0a7d65259cee0cad$var$isUniformPersonalizationEditMode = ()=>typeof window !== 'undefined' && window.location.pathname.includes('/uniform-preview');
const $0a7d65259cee0cad$var$PersonalizationControlPanel = ({ values: values, handleSelectChange: handleSelectChange, requiredSegmentTypes: requiredSegmentTypes })=>{
    const isSegmentControlVisible = (segmentType)=>requiredSegmentTypes.includes(segmentType);
    const getMultiSelectValues = (segmentType)=>{
        const segmentValues = values[segmentType];
        if (Array.isArray(segmentValues)) return segmentValues;
        if (typeof segmentValues === 'string' && segmentValues.length > 0) return [
            segmentValues
        ];
        return [];
    };
    const renderSegmentControl = (control)=>{
        const segmentValue = values[control.segmentType];
        switch(control.ux){
            case 'dropdown':
                {
                    const selectedValue = typeof segmentValue === 'string' ? segmentValue : '';
                    const selectedLabel = control.getSelectedLabel?.(selectedValue, control.options) ?? control.defaultLabel;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grkXZ.DropdownSelector), {
                        name: control.segmentType,
                        id: control.segmentType,
                        label: control.label,
                        options: control.options,
                        defaultValue: {
                            value: selectedValue,
                            label: selectedLabel
                        },
                        onChangeHandler: (value)=>{
                            handleSelectChange(control.segmentType, value);
                        }
                    });
                }
            case 'textbox':
                {
                    const textboxValue = typeof segmentValue === 'string' ? segmentValue : '';
                    const textboxPlaceholder = control.placeholder ?? '';
                    if (control.segmentType === (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: control.segmentType,
                                className: (0, $2jatx.default)([
                                    "_1e0c1ule _syazvkha _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                                ]),
                                style: {
                                    "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                                },
                                children: control.label
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                id: control.segmentType,
                                "data-testid": control.segmentType,
                                type: "text",
                                value: textboxValue,
                                onChange: (event)=>{
                                    const nextValue = control.transformValue ? control.transformValue(event.target.value) : event.target.value;
                                    handleSelectChange(control.segmentType, nextValue);
                                },
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq"
                                ])
                            })
                        ]
                    });
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eC3qs.TextInput), {
                        id: control.segmentType,
                        name: control.segmentType,
                        label: control.label,
                        placeholder: textboxPlaceholder,
                        value: textboxValue,
                        onChangeHandler: (value)=>{
                            const nextValue = control.transformValue ? control.transformValue(value) : value;
                            handleSelectChange(control.segmentType, nextValue);
                        }
                    });
                }
            case 'multi-select':
                {
                    const selectedValues = getMultiSelectValues(control.segmentType);
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: control.segmentType,
                                className: (0, $2jatx.default)([
                                    "_1e0c1ule _syazvkha _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                                ]),
                                style: {
                                    "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                                },
                                children: control.label
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _zulp1b66 _1yt4u2gc _19ituwss _2rko1y44 _1tke1ylp _4cvr1h6o"
                                ]),
                                style: {
                                    "--_1itghbz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark700'))
                                },
                                children: control.options.map((option)=>{
                                    const isSelected = selectedValues.includes(option.value);
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            const updatedProducts = isSelected ? selectedValues.filter((product)=>product !== option.value) : [
                                                ...selectedValues,
                                                option.value
                                            ];
                                            handleSelectChange(control.segmentType, updatedProducts);
                                        },
                                        className: (0, $2jatx.default)([
                                            "_1yt418iy _bfhk12ap _syaz1qa5 _19itglyw _2rko1y44 _80omtlke _1wyboxwj _irr31pld"
                                        ]),
                                        style: {
                                            "--_d682il": (0, $6ZVlx.default)(isSelected ? (0, $kbpa7.wacToken)('color.extended.blue300') : (0, $kbpa7.wacToken)('color.neutral.light200')),
                                            "--_1lbdk6y": (0, $6ZVlx.default)(isSelected ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.neutral.dark200')),
                                            "--_1p9lqnx": (0, $6ZVlx.default)(isSelected ? (0, $kbpa7.wacToken)('color.extended.blue400') : (0, $kbpa7.wacToken)('color.neutral.light300'))
                                        },
                                        children: option.label
                                    }, option.value);
                                })
                            })
                        ]
                    });
                }
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-personalization-toggle": "enrollInExperiment",
                onPointerDownCapture: (event)=>{
                    event.stopPropagation();
                },
                onMouseDown: (event)=>{
                    event.stopPropagation();
                },
                onClick: (event)=>{
                    event.stopPropagation();
                    if ($0a7d65259cee0cad$var$isUniformPersonalizationEditMode()) return;
                    const target = event.target;
                    if (target instanceof HTMLInputElement && target.type === 'checkbox') {
                        handleSelectChange('enrollInExperiment', target.checked);
                        return;
                    }
                    handleSelectChange('enrollInExperiment', !values.enrollInExperiment);
                },
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleSelectChange('enrollInExperiment', !values.enrollInExperiment);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $LDFpB.Checkbox), {
                    id: "enrollInExperiment",
                    name: "enrollInExperiment",
                    value: "enrollInExperiment",
                    label: "Enroll in Experiment Treatment?",
                    checked: values.enrollInExperiment
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-personalization-toggle": "useOverrides",
                onPointerDownCapture: (event)=>{
                    event.stopPropagation();
                },
                onMouseDown: (event)=>{
                    event.stopPropagation();
                },
                onClick: (event)=>{
                    event.stopPropagation();
                    if ($0a7d65259cee0cad$var$isUniformPersonalizationEditMode()) return;
                    const target = event.target;
                    if (target instanceof HTMLInputElement && target.type === 'checkbox') {
                        handleSelectChange('useOverrides', target.checked);
                        return;
                    }
                    handleSelectChange('useOverrides', !values.useOverrides);
                },
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleSelectChange('useOverrides', !values.useOverrides);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $LDFpB.Checkbox), {
                    id: "useOverrides",
                    name: "useOverrides",
                    value: "useOverrides",
                    label: "Use Overrides?",
                    checked: values.useOverrides
                })
            }),
            (0, $aL9gN.SEGMENT_CONTROL_CONFIGS).filter(({ segmentType: segmentType })=>isSegmentControlVisible(segmentType)).map((control)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: renderSegmentControl(control)
                }, control.segmentType)),
            (0, $aL9gN.RECOMMENDATION_FIELDS).filter(({ segmentType: segmentType })=>isSegmentControlVisible(segmentType)).map(({ segmentType: segmentType, label: label, defaultValue: defaultValue, defaultLabel: defaultLabel })=>{
                const selectedValue = values[segmentType] || defaultValue;
                const selectedOption = (0, $aL9gN.PRODUCT_OPTIONS).find((opt)=>opt.value === selectedValue);
                return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grkXZ.DropdownSelector), {
                        name: segmentType,
                        id: segmentType,
                        label: label,
                        options: (0, $aL9gN.PRODUCT_OPTIONS),
                        defaultValue: {
                            value: selectedValue,
                            label: selectedOption?.label || defaultLabel
                        },
                        onChangeHandler: (value)=>{
                            handleSelectChange(segmentType, value);
                        }
                    })
                }, segmentType);
            })
        ]
    });
};
const $0a7d65259cee0cad$export$3509149ef9c5f46 = ({ values: values, setValues: setValues, renderMessage: renderMessage, isContainerHovered: isContainerHovered, isPinned: isPinned = false, setIsPinned: setIsPinned = ()=>undefined, setIsActive: setIsActive = ()=>undefined, requiredSegmentTypes: requiredSegmentTypes = Object.values((0, $3o1l4.UserSegmentTypes)), compositionSlug: compositionSlug })=>{
    const controlsRootRef = (0, $1oC0p.useRef)(null);
    const skipNextDogEarClickRef = (0, $1oC0p.useRef)(false);
    const valuesRef = (0, $1oC0p.useRef)(values);
    const togglePinnedStateRef = (0, $1oC0p.useRef)(()=>undefined);
    const [isPointerInside, setIsPointerInside] = (0, $1oC0p.useState)(false);
    const [isFocusWithin, setIsFocusWithin] = (0, $1oC0p.useState)(false);
    const isVisible = isPinned || isPointerInside || isFocusWithin;
    const isTriggerVisible = isContainerHovered || isPinned;
    const triggerTitleByPinned = {
        true: 'Hide Personalization Controls',
        false: 'Show Personalization Controls'
    };
    const triggerIconByPinned = {
        true: "\uD83D\uDCCC",
        false: "\uD83D\uDC65"
    };
    const togglePinnedState = ()=>{
        setIsPinned((previousState)=>{
            const nextPinnedState = !previousState;
            if (!nextPinnedState) {
                setIsPointerInside(false);
                setIsFocusWithin(false);
            }
            setIsActive(nextPinnedState);
            return nextPinnedState;
        });
    };
    const handleSelectChange = (field, value)=>{
        setValues((previousValues)=>({
                ...previousValues,
                [field]: value
            }));
    };
    valuesRef.current = values;
    togglePinnedStateRef.current = togglePinnedState;
    (0, $1oC0p.useEffect)(()=>{
        if (!$0a7d65259cee0cad$var$isUniformPersonalizationEditMode()) return;
        const handleNativeTogglePointer = (event)=>{
            const controlsRoot = controlsRootRef.current;
            const target = event.target;
            if (!controlsRoot || !(target instanceof Element)) return;
            if (!controlsRoot.contains(target)) return;
            const dogEarRow = target.closest('[data-personalization-dogear="toggle"]');
            const enrollRow = target.closest('[data-personalization-toggle="enrollInExperiment"]');
            const overridesRow = target.closest('[data-personalization-toggle="useOverrides"]');
            if (!dogEarRow && !enrollRow && !overridesRow) return;
            event.stopPropagation();
            if (event.cancelable) event.preventDefault();
            if (dogEarRow) {
                skipNextDogEarClickRef.current = true;
                togglePinnedStateRef.current();
                return;
            }
            const currentValues = valuesRef.current;
            if (enrollRow) {
                const nextValue = !currentValues.enrollInExperiment;
                handleSelectChange('enrollInExperiment', nextValue);
                return;
            }
            const nextValue = !currentValues.useOverrides;
            handleSelectChange('useOverrides', nextValue);
        };
        document.addEventListener('pointerdown', handleNativeTogglePointer, {
            capture: true
        });
        document.addEventListener('mousedown', handleNativeTogglePointer, {
            capture: true
        });
        return ()=>{
            document.removeEventListener('pointerdown', handleNativeTogglePointer, {
                capture: true
            });
            document.removeEventListener('mousedown', handleNativeTogglePointer, {
                capture: true
            });
        };
    }, []);
    // Only show the dog-ear when container is hovered
    if (!isContainerHovered && !isPinned) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: controlsRootRef,
        "data-testid": "personalization-controls",
        className: (0, $2jatx.default)([
            "_kqswstnw _152t12gs _1e0212gs _1pbyrpof _lcxvglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                "data-personalization-dogear": "toggle",
                title: triggerTitleByPinned[String(isPinned)],
                onMouseEnter: ()=>{
                    setIsPointerInside(true);
                    setIsActive(true);
                },
                onPointerDownCapture: (event)=>{
                    event.stopPropagation();
                },
                onMouseDown: (event)=>{
                    event.stopPropagation();
                },
                onMouseLeave: ()=>{
                    setIsPointerInside(false);
                    if (!isPinned && !isFocusWithin) setIsActive(false);
                },
                onFocus: ()=>{
                    setIsFocusWithin(true);
                    setIsActive(true);
                },
                onBlur: ()=>{
                    setIsFocusWithin(false);
                    if (!isPinned && !isPointerInside) setIsActive(false);
                },
                onClick: ()=>{
                    if (skipNextDogEarClickRef.current) {
                        skipNextDogEarClickRef.current = false;
                        return;
                    }
                    togglePinnedState();
                },
                onKeyDown: (event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        togglePinnedState();
                    }
                },
                role: "button",
                tabIndex: 0,
                "aria-pressed": isPinned,
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _1e02idpf _1pby14ny _1bsbckbl _4t3ickbl _80omtlke _v5641hdd _tzy4m419 _t9ecxhmw _lcxv1wug"
                ]),
                style: {
                    "--_1tbzjj3": (0, $6ZVlx.default)(Number(isTriggerVisible)),
                    "--_vdcdv1": (0, $6ZVlx.default)([
                        'scale(0.8)',
                        'scale(1)'
                    ][Number(isTriggerVisible)])
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _1e02idpf _1bsbckbl _4t3ickbl _bfhk1wym _2rko10tc _v5641hdd _16qs75vm _irr317i2"
                        ]),
                        style: {
                            "--_138yw56": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue300')),
                            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                            "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800')),
                            "--_xvz68f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue400'))
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152t1ssb _1e021ssb _t9ec1ooe _syaz1afi _1wyb7vkz _vwz4kb7n _lcxvglyw _w19j1ybc"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800'))
                        },
                        children: triggerIconByPinned[String(isPinned)]
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                onMouseEnter: ()=>{
                    setIsPointerInside(true);
                    setIsActive(true);
                },
                onMouseLeave: ()=>{
                    if (!isPinned) {
                        setIsPointerInside(false);
                        if (!isFocusWithin) setIsActive(false);
                    }
                },
                onFocus: ()=>{
                    setIsFocusWithin(true);
                    setIsActive(true);
                },
                onBlur: (event)=>{
                    const relatedTarget = event.relatedTarget;
                    if (relatedTarget && event.currentTarget.contains(relatedTarget)) return;
                    setIsFocusWithin(false);
                    if (!isPinned && !isPointerInside) setIsActive(false);
                },
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tckbl _1e02ftgi _1bsbgx0z _c71l1rxh _1pby1n5q _1yt4pxbi _1e0c1txw _2lx21bp4 _zulpu2gc _bfhk1afi _2rko1ylz _16qs1eyy _19ituwss _lcxv1wug"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800')),
                    "--_1itghbz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark700'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybz4z1 _syazvkha"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                            },
                            children: "Personalization Controls"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt412x7 _1wyboqnp _syazf329 _bfhk1tl1 _2rko1y44 _19it1xn2"
                        ]),
                        style: {
                            "--_1osm7si": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark300')),
                            "--_o8p2jx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron100')),
                            "--_1g0po9p": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron300'))
                        },
                        children: "These controls and the blue border are only visible in pre-production environments"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_18m91wug _c71l1auj _y4ti1b66"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($0a7d65259cee0cad$var$PersonalizationControlPanel, {
                            values: values,
                            handleSelectChange: handleSelectChange,
                            requiredSegmentTypes: requiredSegmentTypes
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt4u2gc _bfhk1bjw _syazf329"
                        ]),
                        style: {
                            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
                            "--_1osm7si": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark300'))
                        },
                        children: renderMessage
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8c0sT.ShareableUrlDisplay), {
                        values: values,
                        compositionSlug: compositionSlug
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("LDFpB", function(module, exports) {
$parcel$export(module.exports, "Checkbox", function () { return $5d7641ed610c7620$export$48513f6b9f8ce62d; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $5d7641ed610c7620$var$textStyle = null;
const $5d7641ed610c7620$var$containerStyle = null;
const $5d7641ed610c7620$var$checkboxStyle = null;
const $5d7641ed610c7620$export$48513f6b9f8ce62d = (props)=>{
    const { id: id, name: name, value: value, label: label, color: color = 'light', accentColor: accentColor = '#0065ff', disabled: disabled, testId: testId, checked: checked, indeterminate: indeterminate, className: className } = props;
    const ref = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (ref.current) {
            if (indeterminate) ref.current.indeterminate = indeterminate;
            else ref.current.checked = checked || false;
        }
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _4cvr1y6m _ca0qyh40 _u5f3idpf _n3tdyh40 _19bvidpf _vwz4bs82",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                id: id,
                type: "checkbox",
                "data-testid": testId ? testId : id,
                style: {
                    accentColor: accentColor
                },
                ref: ref,
                name: name,
                value: value,
                disabled: disabled || false,
                className: (0, $2jatx.default)([
                    "_s7n4nkob _1bsb7vkz _4t3i7vkz _19pk1y44 _2hwxidpf _otyridpf _18u0idpf _1372tlke _d0altlke _jomr3739 _irr33739"
                ])
            }),
            label && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                style: {
                    color: color == 'dark' ? '#172b4d' : '#5e6c84'
                },
                htmlFor: id,
                className: (0, $2jatx.default)([
                    "_80omtlke _1wyboxwj _k48p1nn1 _ahbqftgi"
                ]),
                children: label
            })
        ]
    });
};

});

parcelRegister("aL9gN", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_OPTIONS", function () { return $d46db8d2ad95ca24$export$77dfeb66b7077b0e; });
$parcel$export(module.exports, "RECOMMENDATION_FIELDS", function () { return $d46db8d2ad95ca24$export$559658cad198e966; });
$parcel$export(module.exports, "SEGMENT_CONTROL_CONFIGS", function () { return $d46db8d2ad95ca24$export$fbbf6361625054cb; });

var $3o1l4 = parcelRequire("3o1l4");
const $d46db8d2ad95ca24$var$JOB_FUNCTION_OPTIONS = [
    {
        value: 'engineering',
        label: 'Engineering'
    },
    {
        value: 'product management',
        label: 'Product Management'
    },
    {
        value: 'design',
        label: 'Design'
    },
    {
        value: 'data science',
        label: 'Data Science'
    },
    {
        value: 'marketing',
        label: 'Marketing'
    },
    {
        value: 'sales',
        label: 'Sales'
    },
    {
        value: 'human resources',
        label: 'Human Resources'
    },
    {
        value: 'finance',
        label: 'Finance'
    },
    {
        value: 'operations',
        label: 'Operations'
    },
    {
        value: 'legal',
        label: 'Legal'
    },
    {
        value: 'customer success',
        label: 'Customer Success'
    },
    {
        value: 'executive',
        label: 'Executive'
    },
    {
        value: 'other',
        label: 'Other'
    },
    {
        value: 'information technology',
        label: 'Information Technology'
    },
    {
        value: 'customer service',
        label: 'Customer Service'
    },
    {
        value: 'program management',
        label: 'Program Management'
    },
    {
        value: 'c-suite',
        label: 'C-Suite'
    }
];
const $d46db8d2ad95ca24$export$77dfeb66b7077b0e = [
    {
        value: 'jira-software',
        label: 'Jira'
    },
    {
        value: 'confluence',
        label: 'Confluence'
    },
    {
        value: 'jira-servicedesk',
        label: 'JSM'
    },
    {
        value: 'loom',
        label: 'Loom'
    },
    {
        value: 'jira-product-discovery',
        label: 'JPD'
    },
    {
        value: 'rovo.ondemand',
        label: 'Rovo (On Demand)'
    },
    {
        value: 'rovo',
        label: 'Rovo'
    }
];
const $d46db8d2ad95ca24$export$671e1872ab21a444 = [
    {
        value: 'TWC',
        label: 'Teamwork Collection'
    }
];
const $d46db8d2ad95ca24$var$OWNED_PRODUCT_OPTIONS = [
    {
        value: 'jira-software',
        label: 'Jira'
    },
    {
        value: 'confluence',
        label: 'Confluence'
    },
    {
        value: 'bitbucket',
        label: 'Bitbucket'
    },
    {
        value: 'compass',
        label: 'Compass'
    },
    {
        value: 'jira-product-discovery',
        label: 'Jira Product Discovery'
    },
    {
        value: 'jira-servicedesk',
        label: 'Jira Service Management'
    },
    {
        value: 'statuspage',
        label: 'Statuspage'
    },
    {
        value: 'loom',
        label: 'Loom'
    },
    {
        value: 'rovo.ondemand',
        label: 'Rovo (On Demand)'
    },
    {
        value: 'rovo',
        label: 'Rovo'
    },
    {
        value: 'trello',
        label: 'Trello'
    }
];
const $d46db8d2ad95ca24$var$LOGIN_STATUS_OPTIONS = [
    {
        value: 'loggedIn',
        label: 'Logged In'
    },
    {
        value: 'loggedOut',
        label: 'Logged Out'
    }
];
const $d46db8d2ad95ca24$var$GEO_REGION_OPTIONS = [
    {
        value: 'apac',
        label: 'APAC'
    },
    {
        value: 'amer',
        label: 'AMER'
    },
    {
        value: 'emea',
        label: 'EMEA'
    },
    {
        value: 'unknown',
        label: 'Unknown'
    }
];
const $d46db8d2ad95ca24$var$DOMAIN_TYPE_OPTIONS = [
    {
        value: 'BUSINESS',
        label: 'Business'
    },
    {
        value: 'PERSONAL',
        label: 'Personal'
    }
];
const $d46db8d2ad95ca24$export$559658cad198e966 = [
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).FIRST_RECOMMENDATION,
        label: 'First Recommendation',
        defaultValue: 'jira',
        defaultLabel: 'Jira'
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).SECOND_RECOMMENDATION,
        label: 'Second Recommendation',
        defaultValue: 'confluence',
        defaultLabel: 'Confluence'
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).THIRD_RECOMMENDATION,
        label: 'Third Recommendation',
        defaultValue: 'jsm',
        defaultLabel: 'JSM'
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).FOURTH_RECOMMENDATION,
        label: 'Fourth Recommendation',
        defaultValue: 'loom',
        defaultLabel: 'Loom'
    }
];
const $d46db8d2ad95ca24$export$fbbf6361625054cb = [
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).LOGIN_STATUS,
        ux: 'dropdown',
        label: 'Login Status',
        options: $d46db8d2ad95ca24$var$LOGIN_STATUS_OPTIONS,
        defaultLabel: 'Logged Out',
        getSelectedLabel: (value, options)=>options.find((option)=>option.value === value)?.label || 'Logged Out'
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).GEOLOCATION,
        ux: 'dropdown',
        label: 'Geo Region',
        options: $d46db8d2ad95ca24$var$GEO_REGION_OPTIONS,
        defaultLabel: 'Select geo region',
        getSelectedLabel: (value, options)=>options.find((option)=>option.value === value)?.label || 'Select geo region'
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).JOB_FUNCTION,
        ux: 'dropdown',
        label: 'Job Function',
        options: $d46db8d2ad95ca24$var$JOB_FUNCTION_OPTIONS,
        defaultLabel: 'Select job function',
        getSelectedLabel: (value, options)=>options.find((option)=>option.value === value)?.label || 'Select job function'
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE,
        ux: 'dropdown',
        label: 'Domain Type',
        options: $d46db8d2ad95ca24$var$DOMAIN_TYPE_OPTIONS,
        defaultLabel: 'Personal',
        getSelectedLabel: (value, options)=>options.find((option)=>option.value === value)?.label || 'Personal'
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS,
        ux: 'multi-select',
        label: 'Owned Products',
        options: $d46db8d2ad95ca24$var$OWNED_PRODUCT_OPTIONS
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).PRODUCT_USED_EVER,
        ux: 'multi-select',
        label: 'Product Used Ever',
        options: $d46db8d2ad95ca24$export$77dfeb66b7077b0e
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG,
        ux: 'textbox',
        label: 'Anchor/Cluster Tag',
        transformValue: (value)=>value.toLowerCase()
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).SUB_ANCHOR,
        ux: 'textbox',
        label: 'Sub-Anchor',
        transformValue: (value)=>value.toLowerCase()
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).CHANNEL,
        ux: 'textbox',
        label: 'Channel',
        transformValue: (value)=>value.toLowerCase()
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).UTM_CONTENT,
        ux: 'textbox',
        label: 'UTM Content'
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).COLLECTION_OPTIONS,
        ux: 'multi-select',
        label: 'Collection Options',
        options: $d46db8d2ad95ca24$export$671e1872ab21a444
    }
];

});

parcelRegister("8c0sT", function(module, exports) {
$parcel$export(module.exports, "ShareableUrlDisplay", function () { return $57f9bd42a5f24666$export$6ba48ce7dcbe77e2; });
/* personalization-shareable-url.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $4u4go = parcelRequire("4u4go");
const $57f9bd42a5f24666$export$6ba48ce7dcbe77e2 = ({ values: values, compositionSlug: compositionSlug })=>{
    const fullUrl = (0, $4u4go.getShareableUrl)(values, compositionSlug);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp12x7 _1yt4u2gc _bfhkg7ng _2rko1y44 _19ituwss"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
            "--_1itghbz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark700'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1wyboqnp _k48pni7l _syazvkha"
                ]),
                style: {
                    "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                },
                children: "Shareable URL"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                type: "text",
                readOnly: true,
                value: fullUrl || '(no overrides set)',
                title: fullUrl || undefined,
                onFocus: (e)=>e.target.select(),
                className: (0, $2jatx.default)([
                    "_1wyb1l5c _ect4k7ds _1bsb1osq _1yt4u49m _19ituwss _2rko1y44 _bfhk4p6s _syaznb8g _80om2mo4 _vchhusvi"
                ]),
                style: {
                    "--_1itghbz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark700')),
                    "--_qaw7xs": (0, $6ZVlx.default)(fullUrl ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.neutral.light200')),
                    "--_1kpc469": (0, $6ZVlx.default)(fullUrl ? (0, $kbpa7.wacToken)('color.neutral.dark100') : (0, $kbpa7.wacToken)('color.neutral.dark500')),
                    "--_vkq7lc": (0, $6ZVlx.default)(fullUrl ? 'text' : 'default')
                }
            })
        ]
    });
};

});



parcelRegister("6b4fD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fdaa82d029e6fb56$export$2e2bcd8739ae039; });
/* pixel-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $fdaa82d029e6fb56$var$VIEWBOX = 44; // icon coordinate space (44x44)
const $fdaa82d029e6fb56$var$SQUARE = 2; // square edge in icon units
const $fdaa82d029e6fb56$var$NUM = (attrs, name)=>{
    const m = new RegExp(`\\b${name}=["'](-?\\d+(?:\\.\\d+)?)["']`).exec(attrs);
    return m?.[1] ? parseFloat(m[1]) : null;
};
function $fdaa82d029e6fb56$var$parseCells(svg) {
    const cells = [];
    const rectRe = /<rect\b([^>]*?)\/?>/g;
    let m;
    while(m = rectRe.exec(svg)){
        const attrs = m[1];
        // Only the icon's pixel squares (SQUARE x SQUARE). This skips structural
        // rects such as clipPath/mask bounds (e.g. a full 44x44 rect in <defs>).
        if ($fdaa82d029e6fb56$var$NUM(attrs, 'width') !== $fdaa82d029e6fb56$var$SQUARE || $fdaa82d029e6fb56$var$NUM(attrs, 'height') !== $fdaa82d029e6fb56$var$SQUARE) continue;
        cells.push([
            $fdaa82d029e6fb56$var$NUM(attrs, 'x') ?? 0,
            $fdaa82d029e6fb56$var$NUM(attrs, 'y') ?? 0
        ]);
    }
    return cells;
}
function $fdaa82d029e6fb56$var$parseColor(svg) {
    const m = /fill="(#[0-9a-fA-F]{3,8})"/.exec(svg);
    return m?.[1] ?? '#4D8CED';
}
const $fdaa82d029e6fb56$var$canvasCss = null;
const $fdaa82d029e6fb56$var$DEFAULT_SIZE = 44;
const $fdaa82d029e6fb56$var$UniformPixelIcon = ({ svg: svg, size: size, color: color })=>{
    const canvasRef = (0, $1oC0p.useRef)(null);
    // Coerce `size` to a positive finite number. Uniform delivers parameter
    // values as strings, so a raw `size` could be "88" (or "" / undefined),
    // which would turn every downstream calculation into NaN without this.
    const numericSize = (()=>{
        const parsed = Number(size);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : $fdaa82d029e6fb56$var$DEFAULT_SIZE;
    })();
    (0, $1oC0p.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        let cleanupAnimation;
        let cancelled = false;
        const setup = (svgMarkup)=>{
            if (cancelled) return;
            // Use the coerced numeric size for all geometry below.
            const size = numericSize;
            const scale = size / $fdaa82d029e6fb56$var$VIEWBOX;
            const sq = $fdaa82d029e6fb56$var$SQUARE * scale;
            const half = sq / 2;
            const fill = color ?? $fdaa82d029e6fb56$var$parseColor(svgMarkup);
            const cells = $fdaa82d029e6fb56$var$parseCells(svgMarkup);
            if (cells.length === 0) return;
            // Repulsion tuned relative to the icon size so it scales with `size`.
            const HOVER_RADIUS = size * 0.62; // reach (px)
            const PUSH_MAX = size * 0.2; // strongest displacement, right at the cursor
            const STIFFNESS = 0.06; // pull toward target offset (floaty)
            const DAMPING = 0.82; // velocity retained each frame (momentum/overshoot)
            const SETTLE = 0.05; // offset/velocity threshold to call it rest
            const springs = cells.map(([x, y])=>({
                    rx: (x + $fdaa82d029e6fb56$var$SQUARE / 2) * scale,
                    ry: (y + $fdaa82d029e6fb56$var$SQUARE / 2) * scale,
                    ox: 0,
                    oy: 0,
                    vx: 0,
                    vy: 0
                }));
            const dpr = Math.max(1, window.devicePixelRatio || 1);
            canvas.width = Math.round(size * dpr);
            canvas.height = Math.round(size * dpr);
            canvas.style.width = `${size}px`;
            canvas.style.height = `${size}px`;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            let mouseX = -9999;
            let mouseY = -9999;
            let pointerOver = false;
            let raf = 0;
            let running = false;
            let visible = true;
            function draw() {
                if (!ctx) return;
                ctx.clearRect(0, 0, size, size);
                ctx.fillStyle = fill;
                for (const s of springs)ctx.fillRect(s.rx + s.ox - half, s.ry + s.oy - half, sq, sq);
            }
            function frame() {
                let active = false;
                for (const s of springs){
                    let tx = 0;
                    let ty = 0;
                    if (pointerOver) {
                        const dx = s.rx - mouseX; // points away from the cursor
                        const dy = s.ry - mouseY;
                        const d = Math.hypot(dx, dy);
                        if (d < HOVER_RADIUS && d > 0.001) {
                            const f = 1 - d / HOVER_RADIUS;
                            const push = PUSH_MAX * f * f; // squared falloff
                            const inv = push / d;
                            tx = dx * inv;
                            ty = dy * inv;
                        }
                    }
                    s.vx = s.vx * DAMPING + (tx - s.ox) * STIFFNESS;
                    s.vy = s.vy * DAMPING + (ty - s.oy) * STIFFNESS;
                    s.ox += s.vx;
                    s.oy += s.vy;
                    if (Math.abs(s.ox) > SETTLE || Math.abs(s.oy) > SETTLE || Math.abs(s.vx) > SETTLE || Math.abs(s.vy) > SETTLE) active = true;
                }
                draw();
                if (visible && (pointerOver || active)) raf = requestAnimationFrame(frame);
                else {
                    running = false;
                    // Only collapse to the clean resting icon while on-screen. When
                    // hidden we keep the spring state so the loop can resume settling
                    // on re-entry.
                    if (visible) {
                        for (const s of springs){
                            s.ox = 0;
                            s.oy = 0;
                            s.vx = 0;
                            s.vy = 0;
                        }
                        draw();
                    }
                }
            }
            function start() {
                if (!running && visible) {
                    running = true;
                    raf = requestAnimationFrame(frame);
                }
            }
            const springsActive = ()=>springs.some((s)=>Math.abs(s.ox) > SETTLE || Math.abs(s.oy) > SETTLE || Math.abs(s.vx) > SETTLE || Math.abs(s.vy) > SETTLE);
            const target = canvas.parentElement ?? canvas;
            const onMove = (e)=>{
                const rect = canvas.getBoundingClientRect();
                mouseX = e.clientX - rect.left;
                mouseY = e.clientY - rect.top;
                pointerOver = true;
                start();
            };
            const onLeave = ()=>{
                pointerOver = false;
                start();
            };
            draw();
            target.addEventListener('pointermove', onMove);
            target.addEventListener('pointerleave', onLeave);
            // Pause the render loop entirely while the icon is scrolled out of view.
            const io = new IntersectionObserver(([entry])=>{
                visible = !!entry?.isIntersecting;
                if (visible) {
                    draw();
                    if (pointerOver || springsActive()) start();
                }
            }, {
                threshold: 0
            });
            io.observe(canvas);
            cleanupAnimation = ()=>{
                cancelAnimationFrame(raf);
                running = false;
                io.disconnect();
                target.removeEventListener('pointermove', onMove);
                target.removeEventListener('pointerleave', onLeave);
            };
        };
        // The SVG markup is loaded from the provided image src URL. A raw SVG
        // string is intentionally not supported here.
        fetch(svg).then((res)=>res.text()).then(setup).catch(()=>{
        /* Ignore fetch failures — the icon simply does not render. */ });
        return ()=>{
            cancelled = true;
            cleanupAnimation?.();
        };
    }, [
        svg,
        numericSize,
        color
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("canvas", {
        ref: canvasRef,
        // width/height are derived from the runtime size, so they must stay
        // inline — they cannot be statically extracted into css({}).
        style: {
            width: numericSize,
            height: numericSize
        },
        className: (0, $2jatx.default)([
            "_lcxvglyw"
        ])
    });
};
var $fdaa82d029e6fb56$export$2e2bcd8739ae039 = $fdaa82d029e6fb56$var$UniformPixelIcon;

});

parcelRegister("hTABe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af39737a9845d2ac$export$2e2bcd8739ae039; });
/* pixel-repel-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $af39737a9845d2ac$var$SQUARE = 2; // square edge (px)
const $af39737a9845d2ac$var$SPACING = 16; // lattice pitch — dots sit 16px apart
const $af39737a9845d2ac$var$REST_RGB = [
    0x4b,
    0x4d,
    0x51
]; // #4B4D51
const $af39737a9845d2ac$var$REST_ALPHA = 0.4; // 40% opacity at rest
const $af39737a9845d2ac$var$WAKE_RGB_DARK = [
    255,
    255,
    255
]; // displaced dots brighten to white
const $af39737a9845d2ac$var$HOVER_RADIUS = 130; // repulsion reach (px)
const $af39737a9845d2ac$var$PUSH_MAX = 56; // strongest displacement, right at the cursor (px)
const $af39737a9845d2ac$var$OPACITY_SCALE = 26; // displacement (px) at which a dot reaches full opacity
const $af39737a9845d2ac$var$STIFFNESS = 0.055; // pull toward the target offset
const $af39737a9845d2ac$var$DAMPING = 0.6; // velocity retained each frame (<1)
const $af39737a9845d2ac$var$SETTLE = 0.25; // offset/velocity threshold to retire a spring
const $af39737a9845d2ac$var$backgroundCss = null;
const $af39737a9845d2ac$var$MASK_MOBILE = // eslint-disable-next-line local/ensure-wac-token-usage
'linear-gradient(180deg, transparent 0, #000 160px, #000 calc(100% - 160px), transparent 100%)';
const $af39737a9845d2ac$var$MASK_TABLET = // eslint-disable-next-line local/ensure-wac-token-usage
'linear-gradient(180deg, transparent 0, #000 220px, #000 calc(100% - 220px), transparent 100%)';
const $af39737a9845d2ac$var$canvasCss = null;
const $af39737a9845d2ac$var$UniformPixelRepelGrid = ()=>{
    const canvasRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        const parent = canvas.parentElement;
        if (!parent) return;
        const rest = $af39737a9845d2ac$var$REST_RGB;
        const restAlpha = $af39737a9845d2ac$var$REST_ALPHA;
        const wake = $af39737a9845d2ac$var$WAKE_RGB_DARK;
        // Offscreen layer holding the resting dot field (drawn once per resize).
        const layer = document.createElement('canvas');
        const layerCtx = layer.getContext('2d');
        if (!layerCtx) return;
        let width = 0;
        let height = 0;
        let cols = 0;
        let rows = 0;
        let offsetX = 0;
        let offsetY = 0;
        let dpr = 1;
        let raf = 0;
        let frameId = 0;
        let visible = true;
        let running = false;
        // Live springs keyed by lattice index. A cell only gets a spring while it
        // is within reach of the cursor or still settling back to rest afterwards.
        const springs = new Map();
        // Pointer kept in CSS px relative to the canvas. We keep the last known
        // position after the pointer leaves so springs relax from where they were.
        let mouseX = -9999;
        let mouseY = -9999;
        let pointerOver = false;
        function drawStatic() {
            ctx?.clearRect(0, 0, width, height);
            if (layer.width === 0 || layer.height === 0) return;
            ctx?.drawImage(layer, 0, 0, width, height);
        }
        function build() {
            if (!parent || !canvas || !ctx || !layerCtx) return;
            const rect = parent.getBoundingClientRect();
            width = rect.width;
            height = rect.height;
            // Bail while the parent has no layout box yet (e.g. hidden/0-size).
            // Sizing the canvases to 0 makes drawImage throw on the empty layer.
            if (width <= 0 || height <= 0) return;
            dpr = Math.max(1, window.devicePixelRatio || 1);
            canvas.width = Math.round(width * dpr);
            canvas.height = Math.round(height * dpr);
            canvas.style.width = `${width}px`;
            canvas.style.height = `${height}px`;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            layer.width = canvas.width;
            layer.height = canvas.height;
            layerCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
            cols = Math.ceil(width / $af39737a9845d2ac$var$SPACING) + 1;
            rows = Math.ceil(height / $af39737a9845d2ac$var$SPACING) + 1;
            offsetX = (width - (cols - 1) * $af39737a9845d2ac$var$SPACING) / 2;
            offsetY = $af39737a9845d2ac$var$SPACING / 2;
            // Pre-render the resting field once.
            layerCtx.clearRect(0, 0, width, height);
            layerCtx.fillStyle = `rgba(${rest[0]}, ${rest[1]}, ${rest[2]}, ${restAlpha})`;
            const half = $af39737a9845d2ac$var$SQUARE / 2;
            for(let gy = 0; gy < rows; gy++){
                const ry = offsetY + gy * $af39737a9845d2ac$var$SPACING;
                for(let gx = 0; gx < cols; gx++){
                    const rx = offsetX + gx * $af39737a9845d2ac$var$SPACING;
                    layerCtx.fillRect(rx - half, ry - half, $af39737a9845d2ac$var$SQUARE, $af39737a9845d2ac$var$SQUARE);
                }
            }
            // Rest positions changed — drop stale springs and repaint clean.
            springs.clear();
            drawStatic();
        }
        function frame() {
            frameId++;
            // 1. Refresh repulsion targets for every cell currently within reach.
            if (pointerOver) {
                const gxMin = Math.max(0, Math.floor((mouseX - $af39737a9845d2ac$var$HOVER_RADIUS - offsetX) / $af39737a9845d2ac$var$SPACING));
                const gxMax = Math.min(cols - 1, Math.ceil((mouseX + $af39737a9845d2ac$var$HOVER_RADIUS - offsetX) / $af39737a9845d2ac$var$SPACING));
                const gyMin = Math.max(0, Math.floor((mouseY - $af39737a9845d2ac$var$HOVER_RADIUS - offsetY) / $af39737a9845d2ac$var$SPACING));
                const gyMax = Math.min(rows - 1, Math.ceil((mouseY + $af39737a9845d2ac$var$HOVER_RADIUS - offsetY) / $af39737a9845d2ac$var$SPACING));
                for(let gy = gyMin; gy <= gyMax; gy++){
                    const ry = offsetY + gy * $af39737a9845d2ac$var$SPACING;
                    for(let gx = gxMin; gx <= gxMax; gx++){
                        const rx = offsetX + gx * $af39737a9845d2ac$var$SPACING;
                        const dx = rx - mouseX; // points away from the cursor
                        const dy = ry - mouseY;
                        const d = Math.hypot(dx, dy);
                        if (d >= $af39737a9845d2ac$var$HOVER_RADIUS) continue;
                        const key = gy * cols + gx;
                        let s = springs.get(key);
                        if (!s) {
                            s = {
                                rx: rx,
                                ry: ry,
                                ox: 0,
                                oy: 0,
                                vx: 0,
                                vy: 0,
                                tx: 0,
                                ty: 0,
                                touched: 0
                            };
                            springs.set(key, s);
                        }
                        if (d > 0.001) {
                            // Soft repulsion: strongest at the cursor, easing to
                            // nothing at the rim. Squared falloff keeps the near
                            // field punchy and the outer field gentle, so the
                            // dots part organically.
                            const f = 1 - d / $af39737a9845d2ac$var$HOVER_RADIUS;
                            const push = $af39737a9845d2ac$var$PUSH_MAX * f * f;
                            const inv = push / d;
                            s.tx = dx * inv;
                            s.ty = dy * inv;
                        } else {
                            s.tx = 0;
                            s.ty = 0;
                        }
                        s.touched = frameId;
                    }
                }
            }
            // 2. Integrate every spring. Cells not refreshed this frame relax to
            //    rest.
            const dead = [];
            springs.forEach((s, key)=>{
                if (s.touched !== frameId) {
                    s.tx = 0;
                    s.ty = 0;
                }
                s.vx = s.vx * $af39737a9845d2ac$var$DAMPING + (s.tx - s.ox) * $af39737a9845d2ac$var$STIFFNESS;
                s.vy = s.vy * $af39737a9845d2ac$var$DAMPING + (s.ty - s.oy) * $af39737a9845d2ac$var$STIFFNESS;
                s.ox += s.vx;
                s.oy += s.vy;
                if (s.touched !== frameId && Math.abs(s.ox) < $af39737a9845d2ac$var$SETTLE && Math.abs(s.oy) < $af39737a9845d2ac$var$SETTLE && Math.abs(s.vx) < $af39737a9845d2ac$var$SETTLE && Math.abs(s.vy) < $af39737a9845d2ac$var$SETTLE) dead.push(key);
            });
            // 3. Render: blit the resting field, lift each displaced dot off its
            //    rest position, then paint it at higher opacity in proportion to
            //    how far it moved (same grey, just from rest up to full wake
            //    colour).
            drawStatic();
            const half = $af39737a9845d2ac$var$SQUARE / 2;
            const clearPad = $af39737a9845d2ac$var$SQUARE / 2 + 0.5;
            const clearSize = $af39737a9845d2ac$var$SQUARE + 1;
            springs.forEach((s)=>{
                ctx?.clearRect(s.rx - clearPad, s.ry - clearPad, clearSize, clearSize);
            });
            springs.forEach((s)=>{
                if (!ctx) return;
                const mag = Math.hypot(s.ox, s.oy);
                const w = mag < $af39737a9845d2ac$var$OPACITY_SCALE ? mag / $af39737a9845d2ac$var$OPACITY_SCALE : 1;
                const rr = rest[0] + (wake[0] - rest[0]) * w;
                const gg = rest[1] + (wake[1] - rest[1]) * w;
                const bb = rest[2] + (wake[2] - rest[2]) * w;
                ctx.fillStyle = `rgba(${rr | 0}, ${gg | 0}, ${bb | 0}, ${restAlpha})`;
                ctx.fillRect(s.rx + s.ox - half, s.ry + s.oy - half, $af39737a9845d2ac$var$SQUARE, $af39737a9845d2ac$var$SQUARE);
            });
            for (const deadKey of dead)springs.delete(deadKey);
            if (visible && (pointerOver || springs.size > 0)) raf = requestAnimationFrame(frame);
            else {
                running = false;
                if (visible) drawStatic(); // settle on the clean resting field
            }
        }
        function start() {
            if (!running && visible) {
                running = true;
                raf = requestAnimationFrame(frame);
            }
        }
        const onPointerMove = (e)=>{
            const rect = canvas.getBoundingClientRect();
            mouseX = e.clientX - rect.left;
            mouseY = e.clientY - rect.top;
            pointerOver = true;
            start();
        };
        const onPointerLeave = ()=>{
            pointerOver = false;
            start();
        };
        build();
        const ro = new ResizeObserver(build);
        ro.observe(parent);
        // Pause entirely while the parent is scrolled out of view.
        const io = new IntersectionObserver(([entry])=>{
            visible = !!entry?.isIntersecting;
            if (visible) {
                drawStatic();
                if (pointerOver || springs.size > 0) start();
            }
        }, {
            threshold: 0
        });
        io.observe(parent);
        parent.addEventListener('pointermove', onPointerMove);
        parent.addEventListener('pointerleave', onPointerLeave);
        return ()=>{
            cancelAnimationFrame(raf);
            running = false;
            ro.disconnect();
            io.disconnect();
            parent.removeEventListener('pointermove', onPointerMove);
            parent.removeEventListener('pointerleave', onPointerLeave);
        };
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq _lcxvglyw _1kt9b3bt _1cs8stnw _1tesidpf _1s6kk553"
                ]),
                style: {
                    "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100'))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("canvas", {
                ref: canvasRef,
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq _lcxvglyw _1w80fvh4 _1nwpfvh4 _p7o0hqc2 _1fyihqc2"
                ])
            })
        ]
    });
};
var $af39737a9845d2ac$export$2e2bcd8739ae039 = $af39737a9845d2ac$var$UniformPixelRepelGrid;

});

parcelRegister("8HKOE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $304464287c39195e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $lqyi6 = parcelRequire("lqyi6");

var $5JoNJ = parcelRequire("5JoNJ");

var $jQ0cd = parcelRequire("jQ0cd");
const $304464287c39195e$export$668a169209c124af = (props)=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(props.ctaUrl ?? '');
    const button = ()=>{
        if (props.ctaText && props.ctaText !== '' && props.ctaUrl && props.ctaUrl !== '') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
            href: localizedHref,
            dataEventProps: {
                'data-product-key': 'uniform',
                'data-event-component': 'linkButton',
                'data-event-container': 'ctaSection',
                'data-event': 'clicked'
            },
            children: props.ctaText
        });
        return;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5JoNJ.CallToAction), {
        header: props.title,
        paragraph: props.description,
        button: button() ?? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "ctaButton"
        }),
        backgroundColor: props.backgroundColor
    });
};
var $304464287c39195e$export$2e2bcd8739ae039 = $304464287c39195e$export$668a169209c124af;

});
parcelRegister("5JoNJ", function(module, exports) {
$parcel$export(module.exports, "CallToAction", function () { return $fb865668dbde9df8$export$9438b36140854db6; });
/* call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kbpa7 = parcelRequire("kbpa7");
const $fb865668dbde9df8$var$callToActionStyles = null;
const $fb865668dbde9df8$var$typographyOverrides = null;
const $fb865668dbde9df8$var$polygonStyles = null;
const $fb865668dbde9df8$var$contentStyles = null;
const $fb865668dbde9df8$export$9438b36140854db6 = ({ header: header, paragraph: paragraph, button: button, backgroundColor: backgroundColor = 'black' })=>{
    const buttonProps = backgroundColor === 'blue' ? {
        variant: 'primary_alt',
        colorAgainst: 'other'
    } : {
        variant: 'primary',
        colorAgainst: 'black'
    };
    const transformedButton = /*#__PURE__*/ (0, $1oC0p.cloneElement)(button, buttonProps);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_p12f1git _195g1wug _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            style: {
                '--background-color': (0, $kbpa7.wacToken)(`color.primary.${backgroundColor}`)
            },
            className: (0, $2jatx.default)([
                "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulpu2gc _6rthxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    "h3"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)('color.neutral.light0')
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    ".body-md"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)('color.neutral.light0')
                                },
                                children: paragraph
                            })
                        ]
                    })
                }),
                transformedButton
            ]
        })
    });
};

});


parcelRegister("eNJPT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $afccc8c3590eb47f$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $aSRUp = parcelRequire("aSRUp");

var $fbPwh = parcelRequire("fbPwh");
const $afccc8c3590eb47f$var$UniformPricingTable = (props)=>{
    const { urlSlug: urlSlug, componentLocale: componentLocale } = props;
    const waePricingGqlEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).waePricingGql);
    if (urlSlug && componentLocale && waePricingGqlEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aSRUp.PricingTableWithFetch), {
        urlSlug: urlSlug,
        locale: componentLocale
    });
    const { tableData: tableData, planTitles: planTitles } = props;
    if (tableData && planTitles) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fbPwh.PricingTableWithoutFetch), {
        urlSlug: urlSlug,
        tableData: tableData,
        planTitles: planTitles
    });
    return null;
};
var $afccc8c3590eb47f$export$2e2bcd8739ae039 = $afccc8c3590eb47f$var$UniformPricingTable;

});
parcelRegister("aSRUp", function(module, exports) {
$parcel$export(module.exports, "PricingTableWithFetch", function () { return $868abf2bb378cad9$export$4bd18d0f013c2a19; });

var $7VQPk = parcelRequire("7VQPk");

var $dRFrW = parcelRequire("dRFrW");

var $iHcWb = parcelRequire("iHcWb");

var $fJ2o2 = parcelRequire("fJ2o2");

var $UL5H4 = parcelRequire("UL5H4");
const $868abf2bb378cad9$export$4bd18d0f013c2a19 = ({ urlSlug: urlSlug, locale: locale })=>{
    const { tableData: tableData, planTitles: planTitles, hasError: hasError } = (0, $fJ2o2.useTableData)({
        urlSlug: urlSlug,
        locale: locale
    });
    const dwellTimeAttributes = (0, $iHcWb.useDwellTimeElementAttributes)({
        id: 'pricing-table'
    });
    if (!tableData.length || hasError) return null;
    const transformedSections = (0, $UL5H4.transformContentfulDataToTableData)(tableData, planTitles);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...dwellTimeAttributes,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dRFrW.Table), {
            header: {
                titles: [
                    '',
                    ...planTitles
                ]
            },
            sections: transformedSections
        })
    });
};

});
parcelRegister("dRFrW", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return $b9d7b6c0db29432c$export$54ec01a60f47d33d; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $aZeEU = parcelRequire("aZeEU");

var $7nLiY = parcelRequire("7nLiY");

var $f2yw3 = parcelRequire("f2yw3");

var $2d5gn = parcelRequire("2d5gn");

var $iyRde = parcelRequire("iyRde");
const $b9d7b6c0db29432c$export$54ec01a60f47d33d = (props)=>{
    const { sections: sections, header: header } = props;
    const tableId = (0, $1oC0p.useId)().replace(/:/g, '_');
    const columnCount = (0, $iyRde.getColumnCount)(sections);
    // Build column header ids aligned with titles (index 0 is the empty row-header column)
    const columnIds = header.titles.map((title, index)=>{
        const isEmpty = !title || title.trim() === '';
        return isEmpty ? '' : `${0, $f2yw3.tableHeadCellIdPrefix}${tableId}_${index}`;
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $aZeEU.Table), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f2yw3.Header), {
                ...header,
                tableId: tableId
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                children: sections.map((section, sectionIndex)=>{
                    const groupId = `tblGroup_${tableId}_${sectionIndex}`;
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2d5gn.SectionHeader), {
                                sectionTitle: section.title,
                                totalColumnCount: columnCount,
                                groupId: groupId
                            }),
                            section.rows.map((row, rowIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7nLiY.ContentRow), {
                                    row: row,
                                    rowKey: `${sectionIndex}-${rowIndex}`,
                                    columnTitles: header.titles,
                                    columnIds: columnIds,
                                    groupId: groupId
                                }, `${sectionIndex}-${rowIndex}`))
                        ]
                    }, sectionIndex);
                })
            })
        ]
    });
};

});
parcelRegister("aZeEU", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return $9f0dfcae0b55fad4$export$54ec01a60f47d33d; });
/* table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $9f0dfcae0b55fad4$export$54ec01a60f47d33d = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("table", {
        ...props,
        className: (0, $2jatx.default)([
            "_2lx21bp4 _1kqm1n9t _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _y3gn1h6o _yq5hcfaq _btyzidpf _suga1txw _1e0c5mfb"
        ])
    });
};
const $9f0dfcae0b55fad4$var$tableCss = null;

});

parcelRegister("7nLiY", function(module, exports) {
$parcel$export(module.exports, "ContentRow", function () { return $6ff8e900985492c0$export$47e3a1a30e4428e1; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $gqWzq = parcelRequire("gqWzq");

var $eRo5f = parcelRequire("eRo5f");
const $6ff8e900985492c0$export$47e3a1a30e4428e1 = (props)=>{
    const { row: row, rowKey: rowKey, columnTitles: columnTitles, columnIds: columnIds, groupId: groupId } = props;
    const rowHeaderId = `tblRow_${rowKey}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqWzq.Row), {
        children: row.map((cell, cellIndex)=>cellIndex === 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqWzq.RowHeaderCell), {
                id: rowHeaderId,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eRo5f.ContentCell), {
                    isRowHeader: true,
                    cellData: cell
                })
            }, cellIndex) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqWzq.RowCell), {
                // @ts-expect-error -- columnTitle is a valid prop but TypeScript can't infer it through HTMLAttributes
                columnTitle: columnTitles[cellIndex],
                headers: [
                    groupId,
                    columnIds[cellIndex],
                    rowHeaderId
                ].filter(Boolean).join(' '),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eRo5f.ContentCell), {
                    cellData: cell
                })
            }, cellIndex))
    }, rowKey);
};

});
parcelRegister("gqWzq", function(module, exports) {
$parcel$export(module.exports, "Row", function () { return $5e9f8bd96dfbc6ed$export$b59bdbef9ce70de2; });
$parcel$export(module.exports, "RowHeaderCell", function () { return $5e9f8bd96dfbc6ed$export$90b286dd97c43ca1; });
$parcel$export(module.exports, "RowCell", function () { return $5e9f8bd96dfbc6ed$export$502da2b9cfd708e5; });
/* row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $5e9f8bd96dfbc6ed$export$b59bdbef9ce70de2 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        ...props,
        className: (0, $2jatx.default)([
            "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhk1afi _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _1ckvidpf _irr3g7ng _1o4gh1cn _a5ztgktf _suga1txw _1gde1bp4"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        }
    });
};
const $5e9f8bd96dfbc6ed$export$90b286dd97c43ca1 = (props)=>{
    const { children: children, ...thProps } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...thProps,
        scope: "row",
        className: (0, $2jatx.default)([
            "_y3gnv2br _16nmgktf _1w6hgktf _gtp7dkka _1kmxdlk8 _1ggmdlk8 _1ykzdlk8 _1maedlk8",
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1pfd _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zkze7 _10msglyw"
        ]),
        style: {
            fontWeight: 'normal',
            ...thProps.style ?? {},
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _1reo15vq"
            ]),
            children: children
        })
    });
};
const $5e9f8bd96dfbc6ed$export$502da2b9cfd708e5 = (props)=>{
    const { children: children = null, columnTitle: columnTitle, headers: headers, ...tdProps } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("td", {
        ...tdProps,
        headers: headers,
        className: (0, $2jatx.default)([
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1pfd _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zkze7 _10msglyw"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: columnTitle
            }),
            children
        ]
    });
};
const $5e9f8bd96dfbc6ed$var$rowCss = null;
const $5e9f8bd96dfbc6ed$var$rowHeaderCellCss = null;
const $5e9f8bd96dfbc6ed$var$rowHeaderCellSpanCss = null;
const $5e9f8bd96dfbc6ed$var$cellCss = null;
const $5e9f8bd96dfbc6ed$var$cellColumnTitleCss = null;

});

parcelRegister("eRo5f", function(module, exports) {
$parcel$export(module.exports, "ContentCell", function () { return $f6ee043c88307016$export$6245b75abe178459; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $9cfv2 = parcelRequire("9cfv2");
const $f6ee043c88307016$export$6245b75abe178459 = (props)=>{
    const { cellData: cellData, isRowHeader: isRowHeader } = props;
    if (cellData === null) return null;
    switch(cellData.type){
        case 'text':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9cfv2.CellTextContent), {
                data: cellData,
                isRowHeader: isRowHeader
            });
        case 'check':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9cfv2.CellCheckContent), {});
        case 'expander':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9cfv2.CellExpanderContent), {
                data: cellData
            });
        case 'hyperlink':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9cfv2.CellHyperlinkContent), {
                data: cellData
            });
        case 'render':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9cfv2.CellRenderContent), {
                data: cellData
            });
        default:
            return null;
    }
};

});
parcelRegister("9cfv2", function(module, exports) {
$parcel$export(module.exports, "CellTextContent", function () { return $0f3119adb0167f8e$export$6336b55f7613eff7; });
$parcel$export(module.exports, "CellCheckContent", function () { return $0f3119adb0167f8e$export$2ff19a9fa1e2bf3d; });
$parcel$export(module.exports, "CellExpanderContent", function () { return $0f3119adb0167f8e$export$9df6260913c83267; });
$parcel$export(module.exports, "CellHyperlinkContent", function () { return $0f3119adb0167f8e$export$baed7aa80eb77f27; });
$parcel$export(module.exports, "CellRenderContent", function () { return $0f3119adb0167f8e$export$70b9bce915221e55; });
/* cell-variants.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $g3AHF = parcelRequire("g3AHF");

var $iPPTB = parcelRequire("iPPTB");

var $jE3Ci = parcelRequire("jE3Ci");

var $1UFdE = parcelRequire("1UFdE");

var $6wlOq = parcelRequire("6wlOq");
const $0f3119adb0167f8e$export$6336b55f7613eff7 = (props)=>{
    const { data: data, isRowHeader: isRowHeader } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _zulpu2gc",
            isRowHeader && "_bozg1ul9"
        ]),
        children: [
            data.check && !isRowHeader && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1UFdE.Checkmark), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    data.check && "_1q5171o5"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6wlOq.TextContent), {
                    data: data.value
                })
            }),
            data.lozenge && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                    text: data.lozenge
                })
            })
        ]
    });
};
const $0f3119adb0167f8e$export$2ff19a9fa1e2bf3d = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1UFdE.Checkmark), {});
};
const $0f3119adb0167f8e$export$9df6260913c83267 = (props)=>{
    const { data: data } = props;
    const label = data.lozenge ? /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        children: [
            data.label,
            " ",
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                text: data.lozenge
            })
        ]
    }) : data.label;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3AHF.Expand), {
        label: label,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6wlOq.TextContent), {
            data: data.body
        })
    });
};
const $0f3119adb0167f8e$export$baed7aa80eb77f27 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        // id={rowDescId} // todo
        text: props.data.label,
        href: props.data.href,
        type: 'primary',
        "aria-label": props.data.label,
        ariaLabel: props.data.label,
        dataEventProps: props.data.dataEventProps,
        className: (0, $2jatx.default)([
            "_1wybdlk8 _ahbq1y44"
        ])
    });
};
const $0f3119adb0167f8e$export$70b9bce915221e55 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        children: props.data.render()
    });
};

});
parcelRegister("1UFdE", function(module, exports) {
$parcel$export(module.exports, "Checkmark", function () { return $da6c779bf5fb98aa$export$4f481e0a96cfbed6; });
/* checkmark.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $OKl9V = parcelRequire("OKl9V");
const $da6c779bf5fb98aa$export$4f481e0a96cfbed6 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "data-testid": "checkmark",
        className: (0, $2jatx.default)([
            "_bfhk1oqd _2rko1ssb _syaz1afi _1e0c1o8l _1o9zidpf _k48p8n31 _vwz41tcg _y3gn1h6o _4t3i1tcg _1bsb1tcg"
        ]),
        style: {
            "--_1blpe4f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime700')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
            name: "featurecheckmark",
            size: "xs",
            color: (0, $kbpa7.wacToken)('color.neutral.light0')
        })
    });
};
const $da6c779bf5fb98aa$var$containerInnerCss = null;

});

parcelRegister("6wlOq", function(module, exports) {
$parcel$export(module.exports, "TextContent", function () { return $5f507ad3866dd3ee$export$1b51c6466e79404f; });
/* text-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");
const $5f507ad3866dd3ee$export$1b51c6466e79404f = (props)=>{
    const { data: data } = props;
    if (data.type === 'plaintext') return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: data.value
    });
    if (data.type === 'richtext') return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: data.value
        })
    });
    throw new Error(`unknown text-content type: ${data.type}`);
};
const $5f507ad3866dd3ee$var$textCss = null;

});




parcelRegister("f2yw3", function(module, exports) {
$parcel$export(module.exports, "tableHeadCellIdPrefix", function () { return $c552d35f75ace184$export$c9c38e95a06bf3ae; });
$parcel$export(module.exports, "Header", function () { return $c552d35f75ace184$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $kkI7v = parcelRequire("kkI7v");
const $c552d35f75ace184$export$c9c38e95a06bf3ae = 'tblHead_';
const $c552d35f75ace184$export$8b251419efc915eb = (props)=>{
    const { titles: titles, stickyOffset: stickyOffset, tableId: tableId } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kkI7v.Head), {
        stickyOffset: stickyOffset,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kkI7v.HeadRow), {
            children: titles.map((heading, index)=>{
                const isEmpty = !heading || heading.trim() === '';
                if (isEmpty) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kkI7v.HeadCell), {
                    role: "presentation"
                }, index);
                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kkI7v.HeadCell), {
                    id: `${$c552d35f75ace184$export$c9c38e95a06bf3ae}${tableId}_${index}`,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulpftgi _4cvr1y6m"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1pfd _k48p1fw0"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: heading
                        })
                    })
                }, index);
            })
        })
    });
};
const $c552d35f75ace184$var$headCellDivCss = null;
const $c552d35f75ace184$var$headCellSpanCss = null;

});
parcelRegister("kkI7v", function(module, exports) {
$parcel$export(module.exports, "Head", function () { return $c67150df85e56c57$export$e93312b7773dfcac; });
$parcel$export(module.exports, "HeadRow", function () { return $c67150df85e56c57$export$b008e842a2213343; });
$parcel$export(module.exports, "HeadCell", function () { return $c67150df85e56c57$export$4e8024263ace498b; });
/* head.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $c67150df85e56c57$export$e93312b7773dfcac = (props)=>{
    const { stickyOffset: stickyOffset } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
        ...props,
        className: (0, $2jatx.default)([
            "_179rh1cn _sugaglyw _1pbykb7n _11q71afi"
        ]),
        style: {
            ...stickyOffset === undefined ? {} : {
                top: stickyOffset,
                position: 'sticky'
            },
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        }
    });
};
const $c67150df85e56c57$export$b008e842a2213343 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        ...props,
        className: (0, $2jatx.default)([
            "_17gvangw _7dd6v2br"
        ])
    });
};
const $c67150df85e56c57$export$4e8024263ace498b = (props)=>{
    const scope = props.role === 'presentation' ? undefined : 'col';
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...props,
        scope: scope,
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1pfd _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zkze7 _10msglyw"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        }
    });
};
const $c67150df85e56c57$var$headCss = null;
const $c67150df85e56c57$var$headRowCss = null;
const $c67150df85e56c57$var$headCellStyles = null;

});


parcelRegister("2d5gn", function(module, exports) {
$parcel$export(module.exports, "SectionHeader", function () { return $9a107ca5ddd4bc8f$export$8adb256d999cd5a0; });
/* section-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $c6XWZ = parcelRequire("c6XWZ");
const $9a107ca5ddd4bc8f$export$8adb256d999cd5a0 = (props)=>{
    const { sectionTitle: sectionTitle, totalColumnCount: totalColumnCount, groupId: groupId } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c6XWZ.SectionHeader), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c6XWZ.SectionHeaderCell), {
            id: groupId,
            colSpan: totalColumnCount,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_syaz1pfd _1bsb1osq _k48p8n31 _4t3i1wug _1e0c1ule _1i4q1hna"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: sectionTitle
            })
        })
    });
};
const $9a107ca5ddd4bc8f$var$sectionHeaderSpanCss = null;

});
parcelRegister("c6XWZ", function(module, exports) {
$parcel$export(module.exports, "SectionHeader", function () { return $4c1bb22f5b9b23e6$export$8adb256d999cd5a0; });
$parcel$export(module.exports, "SectionHeaderCell", function () { return $4c1bb22f5b9b23e6$export$32421cd0bed4993f; });
/* section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $4c1bb22f5b9b23e6$export$8adb256d999cd5a0 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        ...props,
        className: (0, $2jatx.default)([
            "_syaz1pfd _2lx21bp4 _19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhkg7ng _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _sugaglyw"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        }
    });
};
const $4c1bb22f5b9b23e6$export$32421cd0bed4993f = (props)=>{
    const { scope: scope = 'rowgroup', ...rest } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...rest,
        scope: scope,
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1pfd _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zkze7 _10msglyw"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        }
    });
};
const $4c1bb22f5b9b23e6$var$sectionHeaderCss = null;
const $4c1bb22f5b9b23e6$var$sectionHeaderCellCss = null;

});


parcelRegister("iyRde", function(module, exports) {
$parcel$export(module.exports, "getColumnCount", function () { return $2eb7cdc84015c3e9$export$813bef8f01765aa1; });
function $2eb7cdc84015c3e9$export$813bef8f01765aa1(sections) {
    return $2eb7cdc84015c3e9$var$getColumnCountOfRowsOfSections(sections);
}
function $2eb7cdc84015c3e9$var$getColumnCountOfRowsOfSections(sections) {
    if (sections.length === 0) throw new Error('sections count should be > 0');
    let columnCount;
    sections.forEach((section, index)=>{
        try {
            const columnCountOfRows = $2eb7cdc84015c3e9$var$getColumnCountOfRows(section.rows);
            if (columnCount === undefined) columnCount = columnCountOfRows;
            else {
                if (columnCount !== columnCountOfRows) throw new Error(`inconsistent number of columns: section at index ${index} contains ${columnCountOfRows} columns; expected ${columnCount} columns based on previous section(s)`);
            }
        } catch (error) {
            throw new Error(`error at table section index ${index}`, {
                cause: error
            });
        }
    });
    if (columnCount === undefined) throw new Error('column count is undefined');
    return columnCount;
}
function $2eb7cdc84015c3e9$var$getColumnCountOfRows(rows) {
    if (rows.length === 0) throw new Error('rows count should be > 0');
    let columnCount;
    rows.forEach((row, index)=>{
        if (columnCount === undefined) columnCount = row.length;
        else {
            if (row.length !== columnCount) throw new Error(`inconsistent number of columns: row at index ${index} contains ${row.length} columns; expected ${columnCount} columns based on previous row(s)`);
        }
    });
    if (columnCount === undefined) throw new Error('column count is undefined');
    if (columnCount === 0) throw new Error('columnCount should not be 0');
    return columnCount;
}

});


parcelRegister("fJ2o2", function(module, exports) {
$parcel$export(module.exports, "useTableData", function () { return $93faad57ef417f58$export$98b14d297b92183b; });

var $1oC0p = parcelRequire("1oC0p");

var $9EINl = parcelRequire("9EINl");

var $e8CU5 = parcelRequire("e8CU5");
const $93faad57ef417f58$export$98b14d297b92183b = ({ urlSlug: urlSlug, locale: locale })=>{
    const [tableData, setTableData] = (0, $1oC0p.useState)([]);
    const [planTitles, setPlanTitles] = (0, $1oC0p.useState)([]);
    const [hasError, setHasError] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        (0, $9EINl.getPricingPageAdditionalContent)({
            urlSlug: urlSlug,
            locale: locale
        }).then((data)=>{
            if (data) {
                const { features: features, planTitles: fetched } = (0, $e8CU5.mapAdditionalContentToTableData)(data);
                setTableData(features);
                setPlanTitles(fetched);
            }
        }).catch(()=>{
            setHasError(true);
        });
    }, []);
    return {
        tableData: tableData,
        planTitles: planTitles,
        hasError: hasError
    };
};

});
parcelRegister("9EINl", function(module, exports) {
$parcel$export(module.exports, "getPricingPageAdditionalContent", function () { return $4f99ac0f0ee29bbd$export$c894316808cfd187; });

var $2iZII = parcelRequire("2iZII");

var $5TsOI = parcelRequire("5TsOI");
const $4f99ac0f0ee29bbd$export$c894316808cfd187 = async ({ urlSlug: urlSlug, locale: locale })=>{
    const result = await (0, $2iZII.getContentfulGqlClient)().query((0, $5TsOI.pricingPageAdditionalContentQuery), {
        urlSlug: urlSlug,
        locale: locale
    });
    return result.data;
};

});
parcelRegister("5TsOI", function(module, exports) {
$parcel$export(module.exports, "pricingPageAdditionalContentQuery", function () { return $1bd70f13cf074cdf$export$195f6723562f4848; });

var $1dWiR = parcelRequire("1dWiR");
const $1bd70f13cf074cdf$export$195f6723562f4848 = (0, $1dWiR.gql)`
	query pricingPageAdditionalContent($urlSlug: String!, $locale: String!) {
		pricingCollection(where: { urlSlug: $urlSlug }, locale: $locale, limit: 1) {
			items {
				pricingTitleInternal
				comparePlansCollection(limit: 10) {
					items {
						planTitleExternal
					}
				}
				compareFeaturesTitle
				compareFeaturesCollection(limit: 10) {
					items {
						featureGroupTitleExternal
						featuresCollection(limit: 20) {
							items {
								callOut
								featureNameExternal
								description {
									json
								}
								relevantPlanCollection {
									items {
										planTitleExternal
									}
								}
								relevantUrl
								featureAdditionalInformationCollection(limit: 15) {
									items {
										featureAdditionalInformation
										relevantPlanCollection(limit: 15) {
											items {
												planTitleExternal
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

});


parcelRegister("e8CU5", function(module, exports) {
$parcel$export(module.exports, "mapAdditionalContentToTableData", function () { return $8e6aa8d54d0eb567$export$f18b590b4399852b; });

var $gVC4y = parcelRequire("gVC4y");
// --- Mapping ---
const $8e6aa8d54d0eb567$var$mapFeatureItem = (feature)=>({
        fields: {
            featureNameExternal: feature.featureNameExternal,
            description: typeof feature.description?.json === 'object' && feature.description.json?.nodeType === 'document' ? (0, $gVC4y.richTextToHTML)(feature.description.json) : undefined,
            relevantUrl: feature.relevantUrl ?? undefined,
            callOut: feature.callOut ?? undefined,
            relevantPlan: feature.relevantPlanCollection.items.map((plan)=>({
                    fields: {
                        planTitleExternal: plan.planTitleExternal
                    }
                })),
            featureAdditionalInformation: feature.featureAdditionalInformationCollection.items.map((info)=>({
                    fields: {
                        featureAdditionalInformation: info.featureAdditionalInformation,
                        relevantPlan: info.relevantPlanCollection.items.map((plan)=>({
                                fields: {
                                    planTitleExternal: plan.planTitleExternal
                                }
                            }))
                    }
                }))
        }
    });
const $8e6aa8d54d0eb567$var$mapCompareFeatureGroup = (group)=>({
        fields: {
            featureGroupTitleExternal: group.featureGroupTitleExternal,
            features: group.featuresCollection.items.map($8e6aa8d54d0eb567$var$mapFeatureItem)
        }
    });
const $8e6aa8d54d0eb567$export$f18b590b4399852b = (data)=>{
    const item = data.pricingCollection.items[0];
    if (!item) return {
        planTitles: [],
        features: []
    };
    return {
        planTitles: item.comparePlansCollection.items.map((plan)=>plan.planTitleExternal),
        features: item.compareFeaturesCollection.items.map($8e6aa8d54d0eb567$var$mapCompareFeatureGroup)
    };
};

});


parcelRegister("UL5H4", function(module, exports) {
$parcel$export(module.exports, "transformContentfulDataToTableData", function () { return $b05fdcdb944104b1$export$d095b9a7d993b440; });
const $b05fdcdb944104b1$export$e28b7b712925a1 = (featureGroup)=>{
    const { fields: fields } = featureGroup;
    return fields.featureGroupTitleExternal;
};
const $b05fdcdb944104b1$export$74a00f18b9031fa7 = (featureFields)=>{
    return featureFields.featureNameExternal || '';
};
const $b05fdcdb944104b1$export$c2c44121b33af1d6 = (featureFields, planTitles)=>{
    return planTitles.map((planTitle)=>{
        const isRelevant = featureFields.relevantPlan?.some((plan)=>plan.fields?.planTitleExternal === planTitle);
        const additionalInfo = // @ts-expect-error -- Contentful field type does not include featureAdditionalInformation
        featureFields?.featureAdditionalInformation?.find(// @ts-expect-error -- Contentful field type mismatch
        (info)=>{
            return !!info.fields?.relevantPlan?.some((plan)=>plan.fields?.planTitleExternal === planTitle);
        })?.fields.featureAdditionalInformation;
        // 1. if there is featureAdditionalInformation, use that as type rich text (links, etc.)
        if (additionalInfo) return {
            type: 'text',
            check: additionalInfo && isRelevant,
            value: {
                type: 'richtext',
                value: additionalInfo
            }
        };
        // 2. if isRelevant, use type check with empty value
        if (isRelevant) return {
            type: 'check'
        };
        // 3. otherwise, use type text with empty value
        return {
            type: 'text',
            value: {
                type: 'plaintext',
                value: ''
            }
        };
    });
};
const $b05fdcdb944104b1$export$4de3ae5ff94aba4 = (featureFields, featureName, descriptionText)=>{
    if (featureFields.relevantUrl) return {
        type: 'hyperlink',
        label: featureName,
        href: featureFields.relevantUrl,
        dataEventProps: {
            'data-event': 'clicked',
            'data-event-component': 'linkButton',
            'data-event-container': 'priceFeaturesTable',
            'data-product-key': 'uniform',
            'data-label': featureName
        }
    };
    if (descriptionText) return {
        type: 'expander',
        label: featureName,
        lozenge: featureFields.callOut,
        body: {
            type: 'richtext',
            value: descriptionText || featureName
        }
    };
    return {
        type: 'text',
        value: {
            type: 'plaintext',
            value: featureName
        },
        lozenge: featureFields.callOut,
        check: false
    };
};
const $b05fdcdb944104b1$export$6fa65ac9a366ed09 = (feature, planTitles)=>{
    const featureFields = feature.fields;
    // left side column link or label
    const featureName = $b05fdcdb944104b1$export$74a00f18b9031fa7(featureFields);
    // individual cells
    const planCells = $b05fdcdb944104b1$export$c2c44121b33af1d6(featureFields, planTitles);
    // left side column
    const featureCell = $b05fdcdb944104b1$export$4de3ae5ff94aba4(featureFields, featureName, featureFields.description);
    return [
        featureCell,
        ...planCells
    ];
};
const $b05fdcdb944104b1$export$11afdf5edf7de08e = (featureGroup, planTitles)=>{
    const sectionTitle = $b05fdcdb944104b1$export$e28b7b712925a1(featureGroup);
    const rows = featureGroup.fields.features?.map((feature)=>$b05fdcdb944104b1$export$6fa65ac9a366ed09(feature, planTitles)) || [];
    return {
        title: sectionTitle,
        rows: rows
    };
};
const $b05fdcdb944104b1$export$d095b9a7d993b440 = (contentfulData, planTitles)=>{
    return contentfulData.map((featureGroup)=>$b05fdcdb944104b1$export$11afdf5edf7de08e(featureGroup, planTitles));
};

});


parcelRegister("fbPwh", function(module, exports) {
$parcel$export(module.exports, "PricingTableWithoutFetch", function () { return $efc1a62b9eef8e52$export$59022707a1d78214; });

var $7VQPk = parcelRequire("7VQPk");

var $dRFrW = parcelRequire("dRFrW");

var $iHcWb = parcelRequire("iHcWb");

var $427lS = parcelRequire("427lS");

var $UL5H4 = parcelRequire("UL5H4");
const $efc1a62b9eef8e52$export$59022707a1d78214 = (props)=>{
    const { tableData: tableData = [], planTitles: planTitles, urlSlug: urlSlug } = props;
    const effectivePlanTitles = (0, $427lS.useEffectivePlanTitles)(planTitles, urlSlug);
    const transformedSections = (0, $UL5H4.transformContentfulDataToTableData)(tableData, effectivePlanTitles);
    const dwellTimeAttributes = (0, $iHcWb.useDwellTimeElementAttributes)({
        id: 'pricing-table'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...dwellTimeAttributes,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dRFrW.Table), {
            header: {
                titles: [
                    '',
                    ...effectivePlanTitles
                ]
            },
            sections: transformedSections
        })
    });
};

});
parcelRegister("427lS", function(module, exports) {
$parcel$export(module.exports, "useEffectivePlanTitles", function () { return $5e47849f1b30080b$export$807d4632af6d16a7; });

var $lc7EO = parcelRequire("lc7EO");
const $5e47849f1b30080b$export$807d4632af6d16a7 = (planTitles, urlSlug)=>{
    // Single source of truth for the JPD plan-title allow-list (gated
    // behind the GWP-10907 feature flag). Always invoked to satisfy the
    // Rules of Hooks; the result is only USED for `product-discovery`.
    const jpdPlanTitlesAllowList = (0, $lc7EO.useJpdPlanTitlesAllowList)();
    const allTitles = planTitles.map(({ fields: fields })=>fields.planTitleExternal);
    if (urlSlug === 'product-discovery') {
        const allowSet = new Set(jpdPlanTitlesAllowList);
        return allTitles.filter((title)=>allowSet.has(title));
    }
    return allTitles;
};

});



parcelRegister("lPMtR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4e8bd012cc4b17f$export$2e2bcd8739ae039; });
/* product-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
const $d4e8bd012cc4b17f$export$fef9b561ff2e7cb1 = ({ id: id, name: name, description: description, href: href, className: className, imgSrc: imgSrc, imgAlt: imgAlt, type: type = 'secondary' })=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(href ?? '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleCardClick = (0, $1oC0p.useCallback)((productKey)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'productCard',
            source: 'customerStories',
            attributes: {
                product: productKey
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    let normalizedId;
    if (id === 'jira-software') normalizedId = 'jira';
    else if (id === 'atlassian-access') normalizedId = 'guard';
    else if (id) // The id for some products in Contentful have "-" in between (ex. jira-service-management), so we need to remove it to match data-product-key values in the global nav
    normalizedId = id.replace(/-/g, '');
    else normalizedId = name.replace(/ /g, '').toLowerCase();
    const iconSize = type === 'primary' ? 44 : 32;
    const cardContent = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1aax1e5h _12l2utpp _4cvr1h6o _1bah1h6o _4t3i1ady _1bsb1ady _1wpz1q9y"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: imgSrc ?? 'https://dam-cdn.atl.orangelogic.com/AssetLink/5sd7w3j2d7rdm7354yi413c5s1eo6s10.webp',
                        alt: imgAlt ?? '',
                        width: iconSize,
                        height: iconSize
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpv77o _1q51v77o _1tke1ady",
                    "_1b2mvd4q _gp0igktf",
                    !description && "_1bah1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "h6",
                        children: name
                    }),
                    description && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "body-sm",
                        children: description
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1mouu2gc _13255hrz",
            className
        ]),
        "data-testid": "wae-product-card",
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: href ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: (0, $jQ0cd.isLocalizableHref)(href) ? localizedHref : href,
            target: (0, $jQ0cd.isLocalizableHref)(href) ? undefined : '_blank',
            rel: (0, $jQ0cd.isLocalizableHref)(href) ? undefined : 'noreferrer',
            onClick: ()=>handleCardClick(normalizedId),
            children: cardContent
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: cardContent
        })
    });
};
const $d4e8bd012cc4b17f$var$cardStyle = null;
const $d4e8bd012cc4b17f$var$iconStyle = null;
const $d4e8bd012cc4b17f$var$textContainerStyle = null;
const $d4e8bd012cc4b17f$var$noDescriptionStyle = null;
const $d4e8bd012cc4b17f$var$overrideTextStyling = null;
var $d4e8bd012cc4b17f$export$2e2bcd8739ae039 = $d4e8bd012cc4b17f$export$fef9b561ff2e7cb1;

});

parcelRegister("4oasi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $222f1f27398983e7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $klmj6 = parcelRequire("klmj6");

var $lTkkF = parcelRequire("lTkkF");

var $jQ0cd = parcelRequire("jQ0cd");
const $222f1f27398983e7$export$228b49acf1bf4a77 = (props)=>{
    const localizedLinkHref = (0, $jQ0cd.useLocalizedHref)(props.linkHref?.path ?? '');
    const localizedButtonHref = (0, $jQ0cd.useLocalizedHref)(props.buttonHref?.path ?? '');
    const callToActionProps = $222f1f27398983e7$var$transformCtaProps({
        ...props,
        linkHref: props.linkHref ? {
            path: localizedLinkHref
        } : undefined,
        buttonHref: props.buttonHref ? {
            path: localizedButtonHref
        } : undefined
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $klmj6.ProductCardBlock), {
        title: props.title,
        text: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.text,
        titleAs: props.titleAs,
        logo: props.logo,
        eyebrow: props.eyebrow,
        alignment: props.alignment,
        callToActionProps: callToActionProps,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: props.imageAlt ?? ''
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                alt: props.iconAlt ?? ''
            }
        } : undefined,
        orientation: props.orientation,
        columns: props.columns,
        backgroundColor: props.backgroundColor
    });
};
function $222f1f27398983e7$var$transformCtaProps({ buttonHref: buttonHref, buttonLabel: buttonLabel, buttonVariant: buttonVariant, linkHref: linkHref, linkText: linkText, linkType: linkType }) {
    const isButton = !!buttonHref?.path && !!buttonLabel;
    const isLink = !!linkHref?.path && !!linkText;
    if (isButton || isLink) {
        const ctaProps = {
            button: isButton ? {
                href: buttonHref.path,
                dataEventProps: {
                    'data-product-key': 'uniform',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'productCardBlock',
                    'data-event': 'clicked',
                    'data-label': buttonLabel
                }
            } : undefined,
            buttonText: buttonLabel ?? undefined,
            buttonVariant: buttonVariant ?? undefined,
            link: isLink ? {
                href: linkHref.path,
                text: linkText,
                type: linkType,
                dataEventProps: {
                    'data-product-key': 'uniform',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'productCardBlock',
                    'data-event': 'clicked',
                    'data-label': linkText
                }
            } : undefined
        };
        return ctaProps;
    }
    return undefined;
}
var $222f1f27398983e7$export$2e2bcd8739ae039 = $222f1f27398983e7$export$228b49acf1bf4a77;

});
parcelRegister("klmj6", function(module, exports) {
$parcel$export(module.exports, "ProductCardBlock", function () { return $7ee1c2a1142c9873$export$c17e706797abe921; });
/* product-card-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $63bv7 = parcelRequire("63bv7");

var $kbpa7 = parcelRequire("kbpa7");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");
const $7ee1c2a1142c9873$export$9bc3333acc9b342f = {
    jira: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Jira logo',
        text: 'Jira'
    },
    jiraProductDiscovery: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraProductDiscoveryIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Jira Product Discovery logo',
        text: 'Jira Product Discovery'
    },
    jiraServiceManagement: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraServiceManagementIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Jira Service Management logo',
        text: 'Jira Service Management'
    },
    statuspage: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.StatuspageIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Statuspage logo',
        text: 'Statuspage'
    },
    confluence: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.ConfluenceIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Confluence logo',
        text: 'Confluence'
    },
    trello: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.TrelloIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Trello logo',
        text: 'Trello'
    },
    loom: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.LoomIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Loom logo',
        text: 'Loom'
    },
    bitbucket: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.BitbucketIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Bitbucket logo',
        text: 'Bitbucket'
    },
    rovoDev: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m075131gef201aeok8g484w063t363hc.svg',
        alt: 'Rovo Dev logo',
        text: 'Rovo Dev',
        image: true
    },
    compass: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.CompassIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Compass logo',
        text: 'Compass'
    },
    guard: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.GuardIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Guard logo',
        text: 'Guard'
    },
    focus: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.FocusIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Focus logo',
        text: 'Focus'
    },
    talent: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.TalentIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Talent logo',
        text: 'Talent'
    },
    rovo: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qe401oio4a2o006h83v3861f5xg6gc76.svg',
        alt: 'Rovo logo',
        text: 'Rovo',
        image: true
    },
    jiraAlign: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraAlignIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Jira Align logo',
        text: 'Jira Align'
    },
    assets: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.AssetsIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Assets logo',
        text: 'Assets'
    },
    customerServiceManagement: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.CustomerServiceManagementIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Customer Service Management logo',
        text: 'Customer Service Management'
    },
    bamboo: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.BambooIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Bamboo logo',
        text: 'Bamboo'
    },
    pipelines: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w5y63772u3hv13stbj352ut7x2h001jf.svg',
        alt: 'Pipelines logo',
        text: 'Pipelines',
        image: true
    },
    dx: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1mx06b178gpdjg8u7kjg38ci80p80eln.svg',
        alt: 'DX logo',
        text: 'DX',
        image: true
    },
    sourcetree: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1o5et30ftpu1nt3m25bbcmg44k5apcr6.svg',
        alt: 'SourceTree logo',
        text: 'SourceTree',
        image: true
    },
    crowd: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.CrowdIcon), {
            appearance: "brand",
            size: "medium"
        }),
        alt: 'Crowd logo',
        text: 'Crowd'
    },
    teamworkCollection: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/78ylq28783ef6w7c21vu5y84ngku10fx.svg',
        alt: 'Teamwork Collection logo',
        height: 20
    },
    strategyCollection: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h5mj8675hs2i21g7687jagjoax1uy14n.svg',
        alt: 'Strategy Collection logo',
        height: 20
    },
    serviceCollection: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/f481qls2e2g883b2us2ek546yg4c44g1.svg',
        alt: 'Service Collection logo',
        height: 20
    },
    softwareCollection: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1j5jdr1kj625ayo48v421j3o05hg8nkg.svg',
        alt: 'Software Collection logo',
        height: 20
    },
    productCollection: {
        src: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12NA4X.svg',
        alt: 'Product Collection',
        height: 20
    }
};
const $7ee1c2a1142c9873$var$imageStyle = null;
const $7ee1c2a1142c9873$var$zeroMarginCss = null;
const $7ee1c2a1142c9873$var$iconSizes = {
    'x-small': 24,
    small: 32,
    medium: 48,
    large: 64
};
const $7ee1c2a1142c9873$var$contentColumnsLayout = {
    10: {
        assetSpan: 3,
        contentStart: 2
    },
    // 10 columns content block means 3 columns for asset, 7 for text
    12: {
        assetSpan: 4,
        contentStart: 1
    }
};
const $7ee1c2a1142c9873$var$renderCta = ({ ctaProps: ctaProps, buttonSize: buttonSize, alignment: alignment, backgroundColor: backgroundColor, titleId: titleId, buttonId: buttonId, linkId: linkId })=>{
    if ('button' in ctaProps && ctaProps.button !== undefined) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bahv2pz _e8gh13g9 _msupokkc"
        ]),
        style: {
            "--_1k0ic5x": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.mobile),
            "--_y1mwbz": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.tablet),
            "--_isgew2": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.desktop)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                ...ctaProps.button,
                id: buttonId,
                size: buttonSize,
                variant: backgroundColor && backgroundColor === '#1868DB' && (ctaProps.buttonVariant === 'primary' || !ctaProps.buttonVariant) ? 'secondary' : ctaProps.buttonVariant ?? 'primary',
                colorAgainst: backgroundColor === '#1868DB' ? 'other' : 'white',
                ariaLabelledby: `${buttonId} ${titleId}`,
                dataEventProps: ctaProps.dataEventProps,
                className: (0, $2jatx.default)([
                    "_i0dl1ris"
                ]),
                children: ctaProps.buttonText
            }),
            ctaProps.link && // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Link component renders text content via the text prop from ctaProps.link
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                id: linkId,
                ariaLabelledby: `${linkId} ${titleId}`,
                type: "primary",
                bgColor: $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) ? 'bgBlackBlue' : 'bgWhite',
                ...ctaProps.link
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            id: linkId,
            ariaLabelledby: `${linkId} ${titleId}`,
            type: "primary",
            bgColor: $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) ? 'bgBlackBlue' : 'bgWhite',
            ...ctaProps.link,
            children: ctaProps.link?.text
        })
    });
};
const $7ee1c2a1142c9873$var$renderIcon = (icon)=>{
    if (icon?.linkedIcon) {
        const linkedIconSize = icon?.linkedIcon?.size ? $7ee1c2a1142c9873$var$iconSizes[icon.linkedIcon.size] : $7ee1c2a1142c9873$var$iconSizes['medium'];
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: icon.linkedIcon.url,
                alt: icon.linkedIcon.alt ?? '',
                width: linkedIconSize,
                height: linkedIconSize
            })
        });
    }
    if (icon?.iconComponent) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: icon.iconComponent
    });
    return null;
};
const $7ee1c2a1142c9873$var$isDarkBackgroundColor = (color)=>{
    return color ? [
        '#1868DB',
        '#101214'
    ].includes(color) : false;
};
const $7ee1c2a1142c9873$export$c17e706797abe921 = ({ logo: logo, eyebrow: eyebrow, title: title, text: text, imageProps: imageProps, spotIllustrationUrl: spotIllustrationUrl, icon: icon, callToActionProps: callToActionProps, alignment: alignment = 'start', orientation: orientation = 'vertical', columns: columns = 10, backgroundColor: backgroundColor, ...props })=>{
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = 'h3' } = props;
    const isSmallDetailStyling = [
        'h4'
    ].includes(TitleComponent);
    const isLargeTextStyling = TitleComponent === 'h2';
    const buttonSize = isSmallDetailStyling ? 'small' : 'large';
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `product-card-block-title-${uniqueId}`;
    const buttonId = `product-card-block-button-${uniqueId}`;
    const linkId = `product-card-block-link-${uniqueId}`;
    const textElement = typeof text === 'string' ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            isLargeTextStyling ? 'body-lg' : 'body-md'
        ]),
        children: text
    }) : text;
    const bgColorStyle = null;
    const textContent = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb _1q51hl9w _1bah1yb4 _1b1q1cw5 _4t3i1osq _1qgobi35"
        ]),
        style: {
            "--_1jxeyjv": (0, $6ZVlx.default)(orientation === 'horizontal' ? "var(--ds-space-100, 8px)" : undefined),
            "--_7o75ha": (0, $6ZVlx.default)($7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1ejb"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1y6m _zulpu2gc"
                        ]),
                        children: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo] && 'text' in $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo] ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo].image ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                    src: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.src,
                                    alt: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.alt,
                                    className: (0, $2jatx.default)([
                                        "_1bsbzwfg"
                                    ])
                                }) : $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo].src,
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_ect41vau _1wybqslr _zg8l4jg8 _k48p1nn1 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1ule"
                                    ]),
                                    style: {
                                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                    },
                                    children: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo].text
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.src,
                            alt: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.alt,
                            height: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.height ?? 32,
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _5ral1f51 _rsuf2bpp"
                            ])
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulpu2gc",
                            "product-card-block-text-content"
                        ]),
                        children: [
                            eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "_syaz1ef4",
                                    isSmallDetailStyling ? 'eyebrow-sm' : 'eyebrow-md'
                                ]),
                                style: {
                                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                },
                                children: eyebrow
                            }),
                            title && /*#__PURE__*/ (0, $7VQPk.jsx)(TitleComponent, {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "card-title"
                                ]),
                                id: titleId,
                                children: title
                            }),
                            text && textElement
                        ]
                    })
                ]
            }),
            callToActionProps && $7ee1c2a1142c9873$var$renderCta({
                ctaProps: callToActionProps,
                buttonSize: buttonSize,
                alignment: alignment,
                backgroundColor: backgroundColor,
                titleId: titleId,
                buttonId: buttonId,
                linkId: linkId
            })
        ]
    });
    const assetStyles = null;
    const horizontalSpotIllustrationStyles = null;
    const assetContent = imageProps ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1b1q7d4p"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
            ...imageProps,
            alt: imageProps.alt ?? '',
            className: (0, $2jatx.default)([
                "_18zxcq2i _mezj1osq _bna71wug _1jpx1f51"
            ])
        })
    }) : spotIllustrationUrl ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1b1q7d4p",
            "_181n1txw _q8t51h6o _e8gh1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
            src: spotIllustrationUrl,
            alt: "",
            width: 236,
            height: 236
        })
    }) : icon ? $7ee1c2a1142c9873$var$renderIcon(icon) : null;
    const gapBetweenIconAndText = null;
    const productCardPadding = null;
    if (orientation === 'vertical') return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e1faxbu",
            "_1yt41ejb",
            "_y3gnv2pz _uj6k13g9 _10hlokkc _1e0c1txw _2lx21bp4 _zulp1ejb _11q79r5u _4cvr1fhb _1bah1fhb _4t3i1osq",
            icon && "_zulppxbi",
            "_2rko1ylz _19itkze7"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1k0ic5x": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.mobile),
            "--_y1mwbz": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.tablet),
            "--_isgew2": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.desktop),
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: [
            assetContent,
            textContent
        ]
    });
    const fullWidthGridStyles = null;
    const horizontalProductCard = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1yt41ejb",
            "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _1j8bcx6w _1vsw1vi7 _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg",
            "_1e1faxbu",
            "_kqswh2mm _1pbykb7n _1v6zvn47 _1oyh1c27",
            !backgroundColor && "_2rko1ylz _19itkze7"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1mhd7en": (0, $6ZVlx.default)(orientation === 'horizontal-reverse' ? $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]['contentStart'] : $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]['contentStart'] + $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]['assetSpan']),
            "--_4xfsov": (0, $6ZVlx.default)(numColumns - $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]['assetSpan']),
            "--_1fmoioe": (0, $6ZVlx.default)(orientation === 'horizontal' ? $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]['contentStart'] : $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]['contentStart'] + numColumns - $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]['assetSpan']),
            "--_1d5meks": (0, $6ZVlx.default)($7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]['assetSpan']),
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: [
            orientation === 'horizontal' ? assetContent : null,
            textContent,
            orientation === 'horizontal-reverse' ? assetContent : null
        ]
    });
    switch(numColumns){
        case 10:
        case 12:
            if (backgroundColor) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e1faxbu",
                    "_2rko1ylz _19itkze7",
                    "_1bsb1osq _kqswh2mm"
                ]),
                style: {
                    "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1bsbauwl _14b5zqdx _b8yq87gh _4t3i1osq _1e021ssb _t9eczr6s _11q79r5u _2rko1ylz"
                        ]),
                        style: {
                            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
                        }
                    }),
                    horizontalProductCard
                ]
            });
            return horizontalProductCard;
    }
};
const $7ee1c2a1142c9873$var$borderRadiusStyle = null;

});


parcelRegister("aSjAq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26797f95b8532f82$export$2e2bcd8739ae039; });
/* return-to-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $2axoc = parcelRequire("2axoc");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $gP8Hr = parcelRequire("gP8Hr");
const $26797f95b8532f82$var$UniformReturnToProduct = ({ header: header, subHeading: subHeading, buttonText: buttonText, buttonUrl: buttonUrl, productKey: productKey, templateName: templateName, templateId: templateId, linkText: linkText, linkUrl: linkUrl })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    if (!buttonUrl && !(productKey && templateName && templateId)) return null;
    const buttonSize = {
        mobile: 'xlarge',
        tablet: 'xlarge',
        desktop: 'xlarge',
        xl_desktop: 'xlarge'
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb _1yt41ejb _85i5xy5q _2rko1ylz _bfhk1bjw",
            isDarkTheme && "_189et94y _1dqonqa1 _1h6dinbi _bfhklkxj"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
            "--_1px5u0o": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1000'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                title: header,
                titleAs: "h2",
                titleAppearsAs: "card-title",
                text: subHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1yb4 _1bsb1osq _4cvresu3 _zulp1ejb _1n261g80 _1gde1bp4 _81641ejb _ag851fhb"
                ]),
                children: [
                    linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: linkText,
                        href: linkUrl,
                        "aria-label": linkText
                    }),
                    buttonUrl ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                        href: buttonUrl,
                        responsiveSize: buttonSize,
                        children: buttonText
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gP8Hr.default), {
                        text: buttonText,
                        productKey: productKey ?? '',
                        pluginModuleKey: templateId,
                        templateName: templateName ?? '',
                        responsiveSize: buttonSize
                    })
                ]
            })
        ]
    });
};
const $26797f95b8532f82$var$containerStyles = null;
const $26797f95b8532f82$var$darkThemeContainerStyles = null;
const $26797f95b8532f82$var$ctaContainerStyles = null;
var $26797f95b8532f82$export$2e2bcd8739ae039 = $26797f95b8532f82$var$UniformReturnToProduct;

});
parcelRegister("gP8Hr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bccaaeb31231192a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $1pIeE = parcelRequire("1pIeE");

var $iHYHa = parcelRequire("iHYHa");

var $dziIc = parcelRequire("dziIc");

var $2WL8B = parcelRequire("2WL8B");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $17RBn = parcelRequire("17RBn");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $bccaaeb31231192a$var$UniformTemplateModalButton = ({ text: text, productKey: productKey, templateName: templateName, pluginModuleKey: pluginModuleKey, href: href, responsiveSize: responsiveSize, autoModalOpen: autoModalOpen = false, type: type = 'button' })=>{
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const { setTemplate: setTemplate } = (0, $1pIeE.useProductTemplateContext)();
    // AIS = Atlassian Identity Service - provides user's existing Atlassian sites
    const aisSites = (0, $2WL8B.useSitesWithCurrentProduct)();
    const locale = (0, $17RBn.useLocale)();
    const localizedSignupHref = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup');
    const defaultHref = $bccaaeb31231192a$var$getDefaultHref({
        productKey: productKey,
        locale: locale
    });
    const [buttonProps, setButtonProps] = (0, $1oC0p.useState)({
        href: defaultHref,
        responsiveSize: responsiveSize
    });
    const fullStargateProductKey = productKey === 'jira-service-management' ? 'jira-servicedesk.ondemand' : productKey === 'jira-product-discovery' ? productKey : `${productKey}.ondemand`;
    (0, $1oC0p.useEffect)(()=>{
        if (pluginModuleKey && productKey) {
            const templateData = {
                templateId: pluginModuleKey,
                templateName: templateName,
                productKey: fullStargateProductKey
            };
            setTemplate(templateData);
            // Get site URLs for the current product
            const siteUrls = aisSites?.map((site)=>site.url) ?? [];
            // Determine action based on user's sites
            const action = (0, $dziIc.getTemplateAction)({
                templateData: templateData,
                siteUrls: siteUrls,
                localizedSignupHref: localizedSignupHref
            });
            if (action.type === 'modal') setButtonProps({
                onClick: (event)=>{
                    event.stopPropagation();
                    event.preventDefault();
                    openModalForTemplate(templateData);
                }
            });
            else setButtonProps({
                href: action.href
            });
        } else if (href) setButtonProps({
            href: (0, $jQ0cd.getLocalizedHref)({
                href: href,
                locale: locale
            })
        });
        return ()=>{
            setTemplate(null);
        };
    }, [
        openModalForTemplate,
        templateName,
        pluginModuleKey,
        fullStargateProductKey,
        href,
        productKey,
        locale,
        aisSites,
        localizedSignupHref,
        setTemplate
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jpdWacRedirectTemplateAfterLogin)) return;
        if (!autoModalOpen || !pluginModuleKey || !aisSites || aisSites.length === 0) return;
        const urlParams = new URLSearchParams(location.search);
        const tryTemplate = urlParams.get('tryTemplate');
        if (tryTemplate !== pluginModuleKey) return;
        openModalForTemplate({
            templateId: pluginModuleKey,
            templateName: templateName,
            productKey: fullStargateProductKey
        });
    }, [
        autoModalOpen,
        pluginModuleKey,
        aisSites,
        openModalForTemplate,
        templateName,
        fullStargateProductKey
    ]);
    const dataEventProps = {
        'data-product-key': 'uniform',
        'data-event': 'clicked',
        'data-event-component': 'linkButton',
        'data-event-container': 'modal'
    };
    return type === 'link' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        href: 'href' in buttonProps && buttonProps.href || defaultHref,
        text: text,
        dataEventProps: dataEventProps,
        "aria-label": text
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        ...buttonProps,
        dataEventProps: dataEventProps,
        children: text
    });
};
function $bccaaeb31231192a$var$getDefaultHref(args) {
    const { locale: locale, productKey: productKey } = args;
    if (productKey === 'jira-software') return (0, $jQ0cd.getLocalizedHref)({
        href: '/try/cloud/signup?bundle=jira&edition=free',
        locale: locale
    });
    if (productKey === 'confluence') return (0, $jQ0cd.getLocalizedHref)({
        href: '/try/cloud/signup?bundle=confluence&edition=free',
        locale: locale
    });
    if (productKey === 'jira-service-management') return (0, $jQ0cd.getLocalizedHref)({
        href: '/try/cloud/signup?bundle=jira-service-management&edition=free',
        locale: locale
    });
    if (productKey === 'jira-product-discovery') return (0, $jQ0cd.getLocalizedHref)({
        href: '/try/cloud/signup?bundle=jira-product-discovery&edition=free',
        locale: locale
    });
    return '';
}
var $bccaaeb31231192a$export$2e2bcd8739ae039 = $bccaaeb31231192a$var$UniformTemplateModalButton;

});
parcelRegister("dziIc", function(module, exports) {
$parcel$export(module.exports, "getTemplateAction", function () { return $bbf78a31d6ae35df$export$4935503ffd4d8306; });

var $20OkY = parcelRequire("20OkY");

var $lact3 = parcelRequire("lact3");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $bbf78a31d6ae35df$export$4935503ffd4d8306 = (params)=>{
    const { templateData: templateData, siteUrls: siteUrls, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    // If user has existing sites, show modal
    if (siteUrls.length > 0) return {
        type: 'modal',
        templateData: templateData
    };
    // Otherwise, redirect directly
    const href = $bbf78a31d6ae35df$var$getRedirectHref({
        templateData: templateData,
        redirectToIdentity: redirectToIdentity,
        internalLinkAfterIdentity: internalLinkAfterIdentity,
        localizedSignupHref: localizedSignupHref
    });
    return {
        type: 'redirect',
        href: href
    };
};
const $bbf78a31d6ae35df$var$getRedirectHref = (params)=>{
    const { templateData: templateData, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    const { templateId: templateId, templateName: templateName } = templateData;
    if (redirectToIdentity && internalLinkAfterIdentity) return $bbf78a31d6ae35df$var$getIdentityUrl(templateId, templateName, internalLinkAfterIdentity);
    return $bbf78a31d6ae35df$var$getCloudSignupUrl(templateData, localizedSignupHref, internalLinkAfterIdentity);
};
const $bbf78a31d6ae35df$var$isJiraProduct = (productKey)=>[
        (0, $20OkY.ProductKeys).JIRA_CORE,
        (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY
    ].includes(productKey);
const $bbf78a31d6ae35df$var$getCloudSignupUrl = (templateData, localizedSignupHref, internalLinkAfterIdentity)=>{
    const { templateId: templateId, templateName: templateName, productKey: productKey } = templateData;
    let url = `${localizedSignupHref}?product=${productKey}&templateId=${templateId}&edition=free`;
    if (templateId === 'jsw.agentic-development-with-cmp') {
        const jiraAiSignupUrl = new URL(localizedSignupHref, location.origin);
        jiraAiSignupUrl.searchParams.append('signupSource', 'jira-ai-native');
        return jiraAiSignupUrl.toString();
    }
    if ($bbf78a31d6ae35df$var$isJiraProduct(productKey)) {
        const urlParams = new URLSearchParams(location.search);
        if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jpdWacRedirectTemplateAfterLogin)) {
            if (!urlParams.has('p')) {
                urlParams.set('tryTemplate', templateId);
                urlParams.set('templateModal', templateId);
            }
            url += `&continue=${encodeURIComponent(`${location.href}?${urlParams.toString()}`)}`;
        } else {
            if (!urlParams.has('p')) urlParams.append('templateModal', templateId);
            url += `&continue=${encodeURIComponent(`${location.href}?${urlParams.toString()}`)}`;
        }
    } else if (productKey === (0, $20OkY.ProductKeys).CONFLUENCE) {
        const continueUrl = `${(0, $lact3.getWacIntegrationUrl)()}${internalLinkAfterIdentity ?? ''}?templateId=${templateId + encodeURIComponent('&templateName=' + encodeURIComponent(templateName))}`;
        url = `${url}&continue=${encodeURIComponent(continueUrl)}`;
    }
    return url;
};
const $bbf78a31d6ae35df$var$getIdentityUrl = (templateId, templateName, internalLinkAfterIdentity)=>{
    const loginUrl = `${(0, $lact3.getIdentityBaseUrl)()}/login?`;
    const continueUrl = `${(0, $lact3.getWacIntegrationUrl)()}${internalLinkAfterIdentity}?templateName=${encodeURIComponent(templateName)}&templateId=${templateId}`;
    return `${loginUrl}&continue=${encodeURIComponent(continueUrl)}`;
};

});



parcelRegister("exkom", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ee40bb10698e2e3$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");

var $ghWaY = parcelRequire("ghWaY");

var $8zfxq = parcelRequire("8zfxq");

var $fboYQ = parcelRequire("fboYQ");

var $1xzPJ = parcelRequire("1xzPJ");

var $cwkIh = parcelRequire("cwkIh");

var $l5Cys = parcelRequire("l5Cys");

var $gBTmU = parcelRequire("gBTmU");

var $3Nxop = parcelRequire("3Nxop");

var $7iwdN = parcelRequire("7iwdN");

var $7pPqA = parcelRequire("7pPqA");
const $5ee40bb10698e2e3$var$UniformRoadmapFeatures = (props)=>{
    const { data: ssrData, roadmapFeaturesLocale: roadmapFeaturesLocale, roadmapName: roadmapName, lastUpdated: lastUpdated } = props;
    const pageBasePath = roadmapName === 'Data Center' ? (0, $7iwdN.DATACENTER_BASE_PATH) : (0, $7iwdN.CLOUD_BASE_PATH);
    const { filters: filters, sortCriteria: sortCriteria, selectedFeature: selectedFeature } = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === 'undefined') return {
            filters: (0, $7iwdN.emptyFilters),
            sortCriteria: undefined,
            selectedFeature: undefined
        };
        const filters = {
            category: (0, $7pPqA.getQueryParamFromWindow)('category'),
            search: (0, $7pPqA.getQueryParamFromWindow)('search'),
            status: (0, $7pPqA.getQueryParamFromWindow)('status'),
            selectedProduct: (0, $7pPqA.getQueryParamFromWindow)('selectedProduct')
        };
        const sortCriteria = {
            key: (0, $7pPqA.getQueryParamFromWindow)('sortBy')[0],
            direction: (0, $7pPqA.getQueryParamFromWindow)('sort')[0]
        };
        let selectedFeature;
        const slug = (0, $7pPqA.getSlugFromWindow)({
            basePath: pageBasePath
        });
        if (slug) selectedFeature = {
            pid: (0, $7pPqA.getQueryParamFromWindow)('p')?.[0],
            slug: slug
        };
        return {
            filters: filters,
            sortCriteria: sortCriteria,
            selectedFeature: selectedFeature
        };
    }, []);
    const { result: csrData } = (0, $fboYQ.useQuery)({
        locale: roadmapFeaturesLocale,
        roadmapName: roadmapName
    });
    const features = csrData?.roadmapFeatureCollection?.items ?? ssrData?.roadmapFeatureCollection?.items;
    const filterOptionsByKey = {
        category: ssrData?.taxonomyRoadmapCategoryCollection.items.map((item)=>({
                value: item.queryParameter,
                label: item.roadmapCategoryNameExternal
            })) ?? [],
        selectedProduct: (()=>{
            if (!ssrData?.taxonomyRoadmapAppCollection.items) return [];
            // Group apps by filterQueryParam and keep only the shortest label for each
            const groupedByQueryParam = new Map();
            for (const item of ssrData.taxonomyRoadmapAppCollection.items){
                const queryParam = item.filterQueryParam;
                const currentName = item.roadmapAppNameExternal;
                const existing = groupedByQueryParam.get(queryParam);
                if (!existing || currentName.length < existing.length) groupedByQueryParam.set(queryParam, currentName);
            }
            return Array.from(groupedByQueryParam.entries()).map(([value, label])=>({
                    value: value,
                    label: label
                }));
        })(),
        status: ssrData?.taxonomyRoadmapStatusCollection.items.map((item)=>({
                value: item.roadmapStatusNameExternal,
                label: item.roadmapStatusNameExternal
            })) ?? []
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Ntyw.BxpWebStargateClientProvider), {
        baseUrl: "https://www.atlassian.com/gateway/api",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7iwdN.RoadmapFeaturesContextProvider), {
            pageBasePath: pageBasePath,
            locale: roadmapFeaturesLocale,
            filters: filters,
            sortCriteria: sortCriteria,
            selectedFeature: selectedFeature,
            features: features,
            filterOptionsByKey: filterOptionsByKey,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gBTmU.RoadmapSubNav), {}),
                    roadmapName === 'Data Center' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8zfxq.DataCenterRoadmapSubscriptionForm), {
                        lastUpdated: lastUpdated
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ghWaY.CloudRoadmapSubscriptionForm), {
                        lastUpdated: lastUpdated
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Nxop.SearchWithFilters), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l5Cys.Layout), {
                        columnHeaders: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cwkIh.ColumnHeaders), {}),
                        cards: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1xzPJ.Cards), {})
                    })
                ]
            })
        })
    });
};
var $5ee40bb10698e2e3$export$2e2bcd8739ae039 = $5ee40bb10698e2e3$var$UniformRoadmapFeatures;

});
parcelRegister("ghWaY", function(module, exports) {
$parcel$export(module.exports, "CloudRoadmapSubscriptionForm", function () { return $1e06e34af93c7062$export$8792f89e1deb1e3; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6nmH5 = parcelRequire("6nmH5");
const $1e06e34af93c7062$export$8792f89e1deb1e3 = (props)=>{
    const { lastUpdated: lastUpdated } = props;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nmH5.RoadmapSubscriptionForm), {
        lastUpdated: lastUpdated,
        formId: "a9ce9de2-9120-4fa9-a982-12a369254cad",
        formImage: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5i7x2g3g1ap10qp6r31tyi2tw4ho75dq.png',
            alt: intl.formatMessage({
                id: 'roadmapSubscription.image.alt',
                defaultMessage: 'Cloud Roadmap'
            })
        },
        heading: intl.formatMessage({
            id: 'roadmapSubscription.heading',
            defaultMessage: 'Cloud Roadmap'
        }),
        description: intl.formatMessage({
            id: 'roadmapSubscription.description',
            defaultMessage: "Check out the latest features in Cloud and learn about what we're working on. Subscribe to receive an email each quarter highlighting our newly released features, updated time frames, and more."
        })
    });
};

});
parcelRegister("6nmH5", function(module, exports) {
$parcel$export(module.exports, "RoadmapSubscriptionForm", function () { return $5922717f55943bb5$export$d9154e81ff5ef57d; });
/* roadmap-subscription-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $5Ntyw = parcelRequire("5Ntyw");

var $lqyi6 = parcelRequire("lqyi6");

var $jE3Ci = parcelRequire("jE3Ci");

var $kbpa7 = parcelRequire("kbpa7");

var $OKl9V = parcelRequire("OKl9V");

var $7iwdN = parcelRequire("7iwdN");
// Constants
const $5922717f55943bb5$var$EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $5922717f55943bb5$var$FORM_CONFIG = {
    locale: 'US-CA',
    site: 'atlassian'
};
// Helper function
const $5922717f55943bb5$var$isValidEmail = (email)=>{
    return $5922717f55943bb5$var$EMAIL_REGEX.test(email);
};
// Format english date with suffixes
const $5922717f55943bb5$var$getOrdinalSuffix = (day, locale)=>{
    if (locale.startsWith('en')) {
        if (day > 3 && day < 21) return 'th';
        switch(day % 10){
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    }
    return '';
};
const $5922717f55943bb5$var$formatDateWithIntl = (isoDate, locale)=>{
    try {
        const date = new Date(isoDate);
        const intlLocale = locale || 'en-US';
        const month = new Intl.DateTimeFormat(intlLocale, {
            month: 'long',
            timeZone: 'UTC'
        }).format(date);
        const day = date.getUTCDate();
        const year = date.getUTCFullYear();
        const ordinal = $5922717f55943bb5$var$getOrdinalSuffix(day, intlLocale);
        return `${month} ${day}${ordinal}, ${year}`;
    } catch  {
        return isoDate;
    }
};
const $5922717f55943bb5$export$d9154e81ff5ef57d = (props)=>{
    const [email, setEmail] = (0, $1oC0p.useState)('');
    const [honeypot, setHoneypot] = (0, $1oC0p.useState)('');
    const [isSubmitted, setIsSubmitted] = (0, $1oC0p.useState)(false);
    const [isLoading, setIsLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)('');
    const bxpClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const intl = (0, $8e22h.default)();
    const { locale: locale } = (0, $7iwdN.useRoadmapFeaturesContext)();
    const lastUpdatedDate = $5922717f55943bb5$var$formatDateWithIntl(props.lastUpdated, locale);
    const handleSubmit = (0, $1oC0p.useCallback)(async (e)=>{
        e.preventDefault();
        // Honeypot check - silent return if bot
        if (honeypot) return;
        // Validate email
        if (!email || !$5922717f55943bb5$var$isValidEmail(email)) {
            setError(intl.formatMessage({
                id: 'roadmapSubscription.error.invalidEmail',
                defaultMessage: 'Enter a valid email address.'
            }));
            return;
        }
        setIsLoading(true);
        setError('');
        try {
            if (!bxpClient?.updateConsentPreferences) throw new Error('Consent service unavailable');
            await bxpClient.updateConsentPreferences({
                locale: $5922717f55943bb5$var$FORM_CONFIG.locale,
                formId: props.formId,
                site: $5922717f55943bb5$var$FORM_CONFIG.site,
                email: email,
                formUrl: window.location.href,
                consentLabelText: '',
                privacyPolicyText: '',
                consentCheckboxValue: true
            });
            setIsSubmitted(true);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : intl.formatMessage({
                id: 'roadmapSubscription.error.serverError',
                defaultMessage: 'There was a server error submitting. Please try again.'
            });
            setError(errorMessage);
        } finally{
            setIsLoading(false);
        }
    }, [
        email,
        honeypot,
        bxpClient
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: "roadmap-subscription-form",
        className: (0, $2jatx.default)([
            "_6rthgktf _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f1fra _kqswh2mm _ahbq1wug _12l21wug"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1n261g80 _zulp1ylp _4cvr1y6m"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _1e0c1txw _1bah1h6o _4cvr1fhb _1f49kb7n _xg5ucs5v _1u0vkb7n _xz68kb7n _jueshwvj _o3vb1fhb"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthd439 _1e0c1txw _2lx21bp4 _1bahesu3 _4t3i1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: props.formImage.src,
                                    alt: props.formImage.alt
                                },
                                style: {
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: '100%'
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1ogm _1e0c1txw _2lx21bp4 _zulpgktf _1f49cs5v _xg5ukb7n _1u0vkb7n _xz68kb7n _jues1ssb"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulpftgi _1n261g80"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                                        text: intl.formatMessage({
                                            id: 'roadmapSubscription.lastUpdated',
                                            defaultMessage: 'Last Updated'
                                        }),
                                        appearance: "purple"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8"
                                        ]),
                                        children: [
                                            "\xa0",
                                            lastUpdatedDate
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_1wybckbl _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz4cjiy"
                                ]),
                                children: props.heading
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wyb7vkz _vwz4yu22 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: props.description
                            }),
                            !isSubmitted ? /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                                onSubmit: handleSubmit,
                                noValidate: true,
                                "aria-label": intl.formatMessage({
                                    id: 'roadmapSubscription.form.ariaLabel',
                                    defaultMessage: 'Roadmap subscription form'
                                }),
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulp1crf _p12fdgin"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                        htmlFor: "email-subscription",
                                        className: (0, $2jatx.default)([
                                            "_1wybdlk8 _k48pni7l _1e0c1ule"
                                        ]),
                                        children: intl.formatMessage({
                                            id: 'roadmapSubscription.emailLabel',
                                            defaultMessage: 'Your company email'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulp1crf _4cvr1fhb"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                                type: "email",
                                                name: "email",
                                                id: "email-subscription",
                                                value: email,
                                                onChange: (e)=>setEmail(e.target.value),
                                                required: true,
                                                disabled: isLoading,
                                                "aria-invalid": !!error,
                                                "aria-describedby": error ? 'email-error' : undefined,
                                                className: (0, $2jatx.default)([
                                                    "_1bsb1osq _ca0q19bv _u5f31crf _n3td19bv _19bv1crf _1wybdlk8 _19itxb7o _2rko1y44 _12ji1r31 _1qu2glyw _12y31o36 _858u5hrz _7ehig5r6"
                                                ]),
                                                style: {
                                                    "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100')),
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                                type: "submit",
                                                variant: "primary",
                                                size: "large",
                                                isDisabled: isLoading,
                                                isLoading: isLoading,
                                                dataEventProps: {
                                                    'data-product-key': 'roadmap',
                                                    'data-event': 'clicked',
                                                    'data-event-component': 'linkButton',
                                                    'data-event-container': 'form',
                                                    'data-label': 'subscribeButton'
                                                },
                                                className: (0, $2jatx.default)([
                                                    "_ca0q19bv _u5f31tcg _n3td19bv _19bv1tcg _1wyb7vkz _k48pni7l _syaz1afi _bfhk5hrz _19itglyw _2rko1y44 _80omtlke _v564z97a _o5721q9c _m45j5hrz _wa112nsj _1j551ck0 _j5dh13gf"
                                                ]),
                                                style: {
                                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                },
                                                children: intl.formatMessage({
                                                    id: 'roadmapSubscription.button.subscribe',
                                                    defaultMessage: 'Subscribe'
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswstnw _1e02xq2a _1bsbt94y _4t3it94y _1reo15vq _18m915vq"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                            type: "text",
                                            name: "list_name",
                                            "aria-label": intl.formatMessage({
                                                id: 'roadmapSubscription.honeypot.ariaLabel',
                                                defaultMessage: 'Keep this field blank'
                                            }),
                                            value: honeypot,
                                            onChange: (e)=>setHoneypot(e.target.value),
                                            tabIndex: -1
                                        })
                                    }),
                                    error && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        id: "email-error",
                                        role: "alert",
                                        className: (0, $2jatx.default)([
                                            "_syaz1d19 _1wybdlk8 _1pfhftgi"
                                        ]),
                                        style: {
                                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                        },
                                        children: error
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                role: "status",
                                "aria-live": "polite",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulp1crf _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _2rko1y44"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                                        name: "checkmarkcircle",
                                        size: "small",
                                        color: "var(--ds-icon-success, #6A9A23)"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb7vkz"
                                        ]),
                                        children: intl.formatMessage({
                                            id: 'roadmapSubscription.success.message',
                                            defaultMessage: 'Thanks for subscribing!'
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "status",
                                "aria-live": "polite",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulp1crf _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _2rko1y44"
                                ])
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $5922717f55943bb5$var$parentContainerStyle = null;
const $5922717f55943bb5$var$containerStyle = null;
const $5922717f55943bb5$var$rowStyle = null;
const $5922717f55943bb5$var$leftColumnStyle = null;
const $5922717f55943bb5$var$rightColumnStyle = null;
const $5922717f55943bb5$var$lastUpdatedContainerStyle = null;
const $5922717f55943bb5$var$dateTextStyle = null;
const $5922717f55943bb5$var$headingStyle = null;
const $5922717f55943bb5$var$descriptionStyle = null;
const $5922717f55943bb5$var$formStyle = null;
const $5922717f55943bb5$var$labelStyle = null;
const $5922717f55943bb5$var$emailInputContainerStyle = null;
const $5922717f55943bb5$var$emailInputStyle = null;
const $5922717f55943bb5$var$honeypotStyle = null;
const $5922717f55943bb5$var$submitButtonStyle = null;
const $5922717f55943bb5$var$errorStyle = null;
const $5922717f55943bb5$var$successMessageContainerStyle = null;
const $5922717f55943bb5$var$successMessageTextStyle = null;
const $5922717f55943bb5$var$imageContainerStyle = null;

});
parcelRegister("7iwdN", function(module, exports) {
$parcel$export(module.exports, "CLOUD_BASE_PATH", function () { return $3ab8d70c989cf75c$export$6d5070f150ecd91; });
$parcel$export(module.exports, "DATACENTER_BASE_PATH", function () { return $3ab8d70c989cf75c$export$c66cccefb563e9a1; });
$parcel$export(module.exports, "useRoadmapFeaturesContext", function () { return $3ab8d70c989cf75c$export$8bb3881bbfbce6f5; });
$parcel$export(module.exports, "RoadmapFeaturesContextProvider", function () { return $3ab8d70c989cf75c$export$cc9094b62665bcf1; });
$parcel$export(module.exports, "emptyFilters", function () { return $3ab8d70c989cf75c$export$68abacd3bc566b56; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $3ab8d70c989cf75c$export$6d5070f150ecd91 = '/roadmap/cloud';
const $3ab8d70c989cf75c$export$c66cccefb563e9a1 = '/roadmap/data-center';
const $3ab8d70c989cf75c$var$RoadmapFeaturesContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $3ab8d70c989cf75c$export$8bb3881bbfbce6f5 = ()=>{
    const ctx = (0, $1oC0p.useContext)($3ab8d70c989cf75c$var$RoadmapFeaturesContext);
    if (!ctx) throw new Error('missing context provider for RoadmapFeaturesContext');
    return ctx;
};
const $3ab8d70c989cf75c$export$cc9094b62665bcf1 = (props)=>{
    const { pageBasePath: pageBasePath, locale: locale, filterOptionsByKey: filterOptionsByKey } = props;
    // filters
    const initialFilters = $3ab8d70c989cf75c$var$getInitialFilters(props.filters ?? {});
    const [filters, setFilters] = (0, $1oC0p.useState)(initialFilters);
    // sort
    const [sortCriteria, setSortCriteria] = (0, $1oC0p.useState)(props.sortCriteria);
    // selected feature
    const [selectedFeature, setSelectedFeature] = (0, $1oC0p.useState)(props.selectedFeature);
    // results
    const [features, setFeatures] = (0, $1oC0p.useState)(props.features);
    (0, $1oC0p.useEffect)(()=>{
        setFeatures(props.features);
    }, [
        props.features
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($3ab8d70c989cf75c$var$RoadmapFeaturesContext.Provider, {
        value: {
            pageBasePath: pageBasePath,
            locale: locale,
            features: features,
            setFeatures: setFeatures,
            filters: filters,
            setFilters: setFilters,
            filterOptionsByKey: filterOptionsByKey,
            sortCriteria: sortCriteria,
            setSortCriteria: setSortCriteria,
            selectedFeature: selectedFeature,
            setSelectedFeature: setSelectedFeature
        },
        children: props.children
    });
};
const $3ab8d70c989cf75c$export$68abacd3bc566b56 = {
    category: [],
    status: [],
    search: [],
    selectedProduct: []
};
function $3ab8d70c989cf75c$var$getInitialFilters(filters) {
    return {
        ...$3ab8d70c989cf75c$export$68abacd3bc566b56,
        ...filters
    };
}

});



parcelRegister("8zfxq", function(module, exports) {
$parcel$export(module.exports, "DataCenterRoadmapSubscriptionForm", function () { return $d8b41fff14bc5e04$export$e25b0a8474e430cf; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6nmH5 = parcelRequire("6nmH5");
const $d8b41fff14bc5e04$export$e25b0a8474e430cf = (props)=>{
    const { lastUpdated: lastUpdated } = props;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nmH5.RoadmapSubscriptionForm), {
        lastUpdated: lastUpdated,
        formId: "16f4d97b-db1e-49ba-9edd-61a5ae678459",
        formImage: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2nl3q4f4uqjjnr853405jk53476o6r8r.png',
            alt: intl.formatMessage({
                id: 'roadmapSubscription.data-center.image.alt',
                defaultMessage: 'Data Center Roadmap'
            })
        },
        heading: intl.formatMessage({
            id: 'roadmapSubscription.data-center.heading',
            defaultMessage: 'Data Center Roadmap'
        }),
        description: intl.formatMessage({
            id: 'roadmapSubscription.data-center.description',
            defaultMessage: "Check out the latest features in Data Center and learn about what we\u2019re working on. Subscribe to receive an email each quarter highlighting our newly released features, updated time frames, and more."
        })
    });
};

});

parcelRegister("fboYQ", function(module, exports) {
$parcel$export(module.exports, "useQuery", function () { return $e0787dfb3b69a913$export$dd0a697e1782aedd; });

var $1oC0p = parcelRequire("1oC0p");

var $hoxx0 = parcelRequire("hoxx0");
function $e0787dfb3b69a913$export$dd0a697e1782aedd(props) {
    const { locale: locale, roadmapName: roadmapName } = props;
    const [result, setResult] = (0, $1oC0p.useState)(undefined);
    const [pending, setPending] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        setPending(true);
        (0, $hoxx0.getRoadmapFeatures)({
            locale: locale,
            limit: (0, $hoxx0.ROADMAP_FEATURES_ALL_ITEMS_PAGE_SIZE),
            roadmapName: roadmapName
        }).then(setResult).finally(()=>{
            setPending(false);
        });
    }, []);
    return {
        result: result,
        pending: pending
    };
}

});

parcelRegister("1xzPJ", function(module, exports) {
$parcel$export(module.exports, "Cards", function () { return $798cc825a6441e0c$export$c8d38e0dcc0f5a1; });
/* cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2LBZM = parcelRequire("2LBZM");

var $20kWR = parcelRequire("20kWR");

var $i2afm = parcelRequire("i2afm");
const $798cc825a6441e0c$export$c8d38e0dcc0f5a1 = ()=>{
    const intl = (0, $8e22h.default)();
    const features = (0, $2LBZM.useFilteredAndSortedRoadmapFeatures)();
    if (!features) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1ejb"
                ]),
                children: features.length === 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bah1h6o _4cvr1h6o _1yt4oahv _syazazsu"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        children: intl.formatMessage({
                            id: 'roadmapFeatures.noResults',
                            defaultMessage: 'No Results'
                        })
                    })
                }) : features.map((data)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $20kWR.Card), {
                        data: data
                    }, data.slug))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i2afm.SelectedFeatureModal), {})
        ]
    });
};
const $798cc825a6441e0c$var$cardsCss = null;
const $798cc825a6441e0c$var$noResultsCss = null;

});
parcelRegister("2LBZM", function(module, exports) {
$parcel$export(module.exports, "useFilteredAndSortedRoadmapFeatures", function () { return $ffa62b15e7d75df3$export$be6200d55ad2dcf6; });
$parcel$export(module.exports, "useSetFilter", function () { return $ffa62b15e7d75df3$export$a522d27da4074c2; });
$parcel$export(module.exports, "useFilter", function () { return $ffa62b15e7d75df3$export$3274cf84b703fff; });
$parcel$export(module.exports, "useSetSearch", function () { return $ffa62b15e7d75df3$export$a23792301e1faab8; });
$parcel$export(module.exports, "useSearch", function () { return $ffa62b15e7d75df3$export$bd221a7c56b93941; });
$parcel$export(module.exports, "useSetSelectedFeature", function () { return $ffa62b15e7d75df3$export$7e1378d2861c08e9; });
$parcel$export(module.exports, "useClearSelectedFeature", function () { return $ffa62b15e7d75df3$export$848481c86eff5af3; });
$parcel$export(module.exports, "useSelectedFeatureData", function () { return $ffa62b15e7d75df3$export$90d5ab95131b086c; });
$parcel$export(module.exports, "useSort", function () { return $ffa62b15e7d75df3$export$6292515ceca0b297; });
$parcel$export(module.exports, "useFilterOptions", function () { return $ffa62b15e7d75df3$export$e00e2ace74badd4e; });

var $7iwdN = parcelRequire("7iwdN");

var $2OD6N = parcelRequire("2OD6N");

var $7pPqA = parcelRequire("7pPqA");
const $ffa62b15e7d75df3$export$be6200d55ad2dcf6 = ()=>{
    const { features: features, filters: filters, sortCriteria: sortCriteria } = (0, $7iwdN.useRoadmapFeaturesContext)();
    if (!features) return null;
    const filteredAndSortedFeatures = (0, $2OD6N.getFilteredAndSortedRoadmapFeatures)({
        features: features,
        filters: filters,
        sortCriteria: sortCriteria
    });
    return (0, $2OD6N.getNormalizedFeatures)(filteredAndSortedFeatures);
};
const $ffa62b15e7d75df3$export$a522d27da4074c2 = ()=>{
    const { setFilters: setFilters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function setFilter(filterKey, values) {
        (0, $7pPqA.setQueryParam)(filterKey, values);
        setFilters((prev)=>({
                ...prev,
                [filterKey]: values
            }));
    };
};
const $ffa62b15e7d75df3$export$7eba469e65994459 = ()=>{
    const { setFilters: setFilters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function clearFilter(filterKey) {
        (0, $7pPqA.setQueryParam)(filterKey, []);
        setFilters((prev)=>({
                ...prev,
                [filterKey]: []
            }));
    };
};
const $ffa62b15e7d75df3$export$3274cf84b703fff = (filterKey)=>{
    const { filters: filters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return filters[filterKey];
};
const $ffa62b15e7d75df3$export$a23792301e1faab8 = ()=>{
    const setFilter = $ffa62b15e7d75df3$export$a522d27da4074c2();
    return function setSearch(value) {
        setFilter('search', [
            value
        ]);
    };
};
const $ffa62b15e7d75df3$export$bd221a7c56b93941 = ()=>{
    const { filters: filters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return filters.search[0];
};
const $ffa62b15e7d75df3$export$7e1378d2861c08e9 = ()=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function setSelectedFeature(feature) {
        (0, $7pPqA.setQueryParam)('p', []);
        if (feature.pid) (0, $7pPqA.setQueryParam)('p', [
            feature.pid
        ]);
        (0, $7pPqA.setSlug)(feature.slug, {
            basePath: ctx.pageBasePath
        });
        ctx.setSelectedFeature(feature);
    };
};
const $ffa62b15e7d75df3$export$60c6c640e9838831 = ()=>(0, $7iwdN.useRoadmapFeaturesContext)().selectedFeature;
const $ffa62b15e7d75df3$export$848481c86eff5af3 = ()=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function clearSelectedFeature() {
        (0, $7pPqA.setQueryParam)('p', []);
        (0, $7pPqA.clearSlug)({
            basePath: ctx.pageBasePath
        });
        ctx.setSelectedFeature(undefined);
    };
};
const $ffa62b15e7d75df3$export$90d5ab95131b086c = ()=>{
    const { features: features } = (0, $7iwdN.useRoadmapFeaturesContext)();
    const selectedFeature = $ffa62b15e7d75df3$export$60c6c640e9838831();
    if (!features || !selectedFeature) return undefined;
    const feature = features.find((feature)=>feature.slug === selectedFeature.slug);
    if (!feature) return undefined;
    return (0, $2OD6N.getNormalizedFeature)(feature);
};
const $ffa62b15e7d75df3$export$5b8a3c885421eb7c = ()=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function setSortCriteria(sortCriteria) {
        if (sortCriteria === undefined) {
            ctx.setSortCriteria(undefined);
            (0, $7pPqA.setQueryParams)({
                sortBy: [],
                sort: []
            });
            return;
        }
        const { key: key, direction: direction } = sortCriteria;
        ctx.setSortCriteria({
            key: key,
            direction: direction
        });
        (0, $7pPqA.setQueryParams)({
            sortBy: [
                key
            ],
            sort: [
                direction
            ]
        });
    };
};
const $ffa62b15e7d75df3$export$6292515ceca0b297 = (key)=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    const setSortCriteria = $ffa62b15e7d75df3$export$5b8a3c885421eb7c();
    if (!ctx.sortCriteria || ctx.sortCriteria.key !== key) return {
        sortDirection: undefined,
        onClick: ()=>{
            setSortCriteria({
                key: key,
                direction: 'asc'
            });
        }
    };
    const sortDirection = ctx.sortCriteria.direction;
    return {
        sortDirection: ctx.sortCriteria.direction,
        onClick: ()=>{
            if (sortDirection === undefined) setSortCriteria({
                key: key,
                direction: 'asc'
            });
            if (sortDirection === 'asc') setSortCriteria({
                key: key,
                direction: 'desc'
            });
            if (sortDirection === 'desc') setSortCriteria(undefined);
        }
    };
};
const $ffa62b15e7d75df3$export$e00e2ace74badd4e = (filterKey)=>{
    const { filterOptionsByKey: filterOptionsByKey } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return filterOptionsByKey[filterKey].sort((a, b)=>a.label > b.label ? 1 : -1);
};
const $ffa62b15e7d75df3$export$7ae092e5866bd7d3 = ()=>{
    const setFilter = $ffa62b15e7d75df3$export$a522d27da4074c2();
    const setSortCriteria = $ffa62b15e7d75df3$export$5b8a3c885421eb7c();
    return function reset() {
        setSortCriteria(undefined);
        setFilter('search', []);
        setFilter('status', []);
        setFilter('category', []);
        setFilter('selectedProduct', []);
    };
};

});
parcelRegister("2OD6N", function(module, exports) {
$parcel$export(module.exports, "getFilteredAndSortedRoadmapFeatures", function () { return $c1e231f117ad5b91$export$e45024fbc7d2fc41; });
$parcel$export(module.exports, "getNormalizedFeature", function () { return $c1e231f117ad5b91$export$6df6eeaa7a8a9e78; });
$parcel$export(module.exports, "getNormalizedFeatures", function () { return $c1e231f117ad5b91$export$a75feafd6c41cba5; });
/**
 * Fields that MUST be present on a `RoadmapFeature` for the card to be
 * renderable. Anything else (status, category, timeFrame, appsCollection)
 * is treated as optional and degrades gracefully in the UI.
 */ const $c1e231f117ad5b91$var$REQUIRED_FEATURE_FIELDS = [
    'slug',
    'title',
    'description'
];
function $c1e231f117ad5b91$export$8dc07767f0c64e1a(feature) {
    const missing = [];
    for (const key of $c1e231f117ad5b91$var$REQUIRED_FEATURE_FIELDS){
        const value = feature[key];
        if (value === undefined || value === null || value === '') {
            missing.push(key);
            continue;
        }
        if (key === 'description' && !feature.description?.json) missing.push('description.json');
    }
    return missing;
}
function $c1e231f117ad5b91$export$61226a13c8799f3d(features) {
    return features.filter((feature)=>{
        const missing = $c1e231f117ad5b91$export$8dc07767f0c64e1a(feature);
        if (missing.length === 0) return true;
        // eslint-disable-next-line no-console
        console.error(`[roadmap-features] Skipping malformed roadmap feature; missing required field(s): ${missing.join(', ')}.`, {
            slug: feature.slug,
            pid: feature.pid
        });
        return false;
    });
}
function $c1e231f117ad5b91$export$e45024fbc7d2fc41(args) {
    const { features: features, filters: filters, sortCriteria: sortCriteria } = args;
    const validFeatures = $c1e231f117ad5b91$export$61226a13c8799f3d(features);
    let filtered = validFeatures.filter((feature)=>{
        return $c1e231f117ad5b91$var$matchesCategory(feature, filters.category) && $c1e231f117ad5b91$var$matchesSelectedProduct(feature, filters.selectedProduct) && $c1e231f117ad5b91$var$matchesSearch(feature, filters.search) && $c1e231f117ad5b91$var$matchesStatus(feature, filters.status);
    });
    if (sortCriteria) filtered = [
        ...filtered
    ].sort((a, b)=>$c1e231f117ad5b91$var$compareFeatures(a, b, sortCriteria));
    return filtered;
}
function $c1e231f117ad5b91$var$extractTextFromJson(json) {
    if (typeof json === 'string') return json;
    if (typeof json === 'number' || typeof json === 'boolean') return String(json);
    if (json === null || json === undefined) return '';
    if (Array.isArray(json)) return json.map((item)=>$c1e231f117ad5b91$var$extractTextFromJson(item)).join(' ');
    if (typeof json === 'object') return Object.values(json).map((value)=>$c1e231f117ad5b91$var$extractTextFromJson(value)).join(' ');
    return '';
}
function $c1e231f117ad5b91$var$matchesSearch(feature, searchTerms) {
    if (searchTerms.length === 0) return true;
    const titleText = (feature.title ?? '').toLowerCase();
    const descriptionText = feature.description?.json ? $c1e231f117ad5b91$var$extractTextFromJson(feature.description.json).toLowerCase() : '';
    const aggregateText = `${titleText} ${descriptionText}`;
    return searchTerms.every((term)=>aggregateText.includes(term.toLowerCase()));
}
function $c1e231f117ad5b91$var$matchesCategory(feature, categories) {
    if (categories.length === 0) return true;
    if (!feature.category?.queryParameter) return false;
    return categories.includes(feature.category.queryParameter);
}
function $c1e231f117ad5b91$var$matchesSelectedProduct(feature, selectedProducts) {
    if (selectedProducts.length === 0) return true;
    return (feature.appsCollection?.items ?? []).some((app)=>selectedProducts.includes(app.filterQueryParam));
}
function $c1e231f117ad5b91$var$matchesStatus(feature, statuses) {
    if (statuses.length === 0) return true;
    if (!feature.status?.roadmapStatusNameExternal) return false;
    return statuses.includes(feature.status.roadmapStatusNameExternal);
}
/**
 * Extracts a sortable numeric value from a normalized timeframe string.
 * Returns a number where higher values represent later dates.
 * Single quarters sort before ranges with the same start date.
 * For non-standard formats, returns 0 (will sort to the beginning).
 */ function $c1e231f117ad5b91$var$getTimeFrameSortValue(timeFrame) {
    // Pattern: QX YYYY (e.g., "Q4 2026")
    const singleQuarterPattern = /^Q([1-4])\s+(\d{4})$/;
    const singleMatch = singleQuarterPattern.exec(timeFrame);
    if (singleMatch && singleMatch[1] && singleMatch[2]) {
        const quarter = parseInt(singleMatch[1], 10);
        const year = parseInt(singleMatch[2], 10);
        return year * 10 + quarter;
    }
    // Pattern: QX - QY YYYY (e.g., "Q3 - Q4 2024")
    // Add small offset (0.1) so ranges sort after single quarters with same start date
    const rangeSameYearPattern = /^Q([1-4])\s*-\s*Q([1-4])\s+(\d{4})$/;
    const rangeSameYearMatch = rangeSameYearPattern.exec(timeFrame);
    if (rangeSameYearMatch && rangeSameYearMatch[1] && rangeSameYearMatch[3]) {
        const quarter = parseInt(rangeSameYearMatch[1], 10);
        const year = parseInt(rangeSameYearMatch[3], 10);
        return year * 10 + quarter + 0.1;
    }
    // Pattern: QX YYYY - QY YYYY (e.g., "Q1 2024 - Q2 2025")
    // Add small offset (0.1) so ranges sort after single quarters with same start date
    const rangeDifferentYearsPattern = /^Q([1-4])\s+(\d{4})\s*-\s*Q([1-4])\s+(\d{4})$/;
    const rangeDifferentYearsMatch = rangeDifferentYearsPattern.exec(timeFrame);
    if (rangeDifferentYearsMatch && rangeDifferentYearsMatch[1] && rangeDifferentYearsMatch[2]) {
        const quarter = parseInt(rangeDifferentYearsMatch[1], 10);
        const year = parseInt(rangeDifferentYearsMatch[2], 10);
        return year * 10 + quarter + 0.1;
    }
    // Pattern: YYYY (e.g., "2026") - treat as Q1 of that year
    const yearOnlyPattern = /^(\d{4})$/;
    const yearOnlyMatch = yearOnlyPattern.exec(timeFrame);
    if (yearOnlyMatch && yearOnlyMatch[1]) {
        const year = parseInt(yearOnlyMatch[1], 10);
        return year * 10 + 1; // Treat as Q1
    }
    // Non-standard formats (e.g., "Coming Soon") - return 0 to sort to beginning
    return 0;
}
function $c1e231f117ad5b91$var$getSortValue(feature, key) {
    switch(key){
        case 'title':
            return feature.title ?? '';
        case 'category':
            return feature.category?.roadmapCategoryNameExternal ?? '';
        case 'status':
            return feature.status?.roadmapStatusNameExternal ?? '';
        case 'timeFrame':
            // Use normalized timeframe and convert to sortable numeric value
            return $c1e231f117ad5b91$var$getTimeFrameSortValue($c1e231f117ad5b91$export$6df6eeaa7a8a9e78(feature).timeFrame ?? '');
        default:
            return '';
    }
}
function $c1e231f117ad5b91$var$compareFeatures(a, b, sortCriteria) {
    const { key: key, direction: direction } = sortCriteria;
    const multiplier = direction === 'asc' ? 1 : -1;
    const aValue = $c1e231f117ad5b91$var$getSortValue(a, key);
    const bValue = $c1e231f117ad5b91$var$getSortValue(b, key);
    if (aValue < bValue) return -1 * multiplier;
    if (aValue > bValue) return 1 * multiplier;
    return 0;
}
function $c1e231f117ad5b91$var$normalizeTimeFrame(timeFrame) {
    // Pattern: YYYY QX (e.g., "2026 Q4")
    const singleYearQuarterPattern = /^(\d{4})\s+(Q[1-4])$/;
    const singleMatch = singleYearQuarterPattern.exec(timeFrame);
    if (singleMatch) return `${singleMatch[2]} ${singleMatch[1]}`;
    // Pattern: QX - YYYY QY (e.g., "Q3 - 2024 Q4")
    const rangeWithYearQuarterPattern = /^(Q[1-4])\s*-\s*(\d{4})\s+(Q[1-4])$/;
    const rangeMatch = rangeWithYearQuarterPattern.exec(timeFrame);
    if (rangeMatch) return `${rangeMatch[1]} - ${rangeMatch[3]} ${rangeMatch[2]}`;
    // Pattern: YYYY QX - YYYY QY (e.g., "2024 Q1 - 2024 Q2" or "2024 Q1 - 2025 Q2")
    const rangeWithTwoYearQuartersPattern = /^(\d{4})\s+(Q[1-4])\s*-\s*(\d{4})\s+(Q[1-4])$/;
    const twoYearRangeMatch = rangeWithTwoYearQuartersPattern.exec(timeFrame);
    if (twoYearRangeMatch) {
        const [, year1, quarter1, year2, quarter2] = twoYearRangeMatch;
        if (year1 === year2) return `${quarter1} - ${quarter2} ${year1}`;
        return `${quarter1} ${year1} - ${quarter2} ${year2}`;
    }
    // Pattern: QX YYYY - QY YYYY (e.g., "Q1 2024 - Q2 2025") - already normalized format
    const alreadyNormalizedRangePattern = /^Q([1-4])\s+(\d{4})\s*-\s*Q([1-4])\s+(\d{4})$/;
    const alreadyNormalizedMatch = alreadyNormalizedRangePattern.exec(timeFrame);
    if (alreadyNormalizedMatch) // Already in normalized format, return as-is
    return timeFrame;
    // Pattern: QX - QY YYYY (e.g., "Q3 - Q4 2024") - already normalized format
    const alreadyNormalizedSameYearRangePattern = /^Q([1-4])\s*-\s*Q([1-4])\s+(\d{4})$/;
    const alreadyNormalizedSameYearMatch = alreadyNormalizedSameYearRangePattern.exec(timeFrame);
    if (alreadyNormalizedSameYearMatch) // Already in normalized format, return as-is
    return timeFrame;
    // Return as-is if no pattern matches (already normalized or different format)
    return timeFrame;
}
function $c1e231f117ad5b91$export$6df6eeaa7a8a9e78(feature) {
    return {
        ...feature,
        timeFrame: feature.timeFrame ? $c1e231f117ad5b91$var$normalizeTimeFrame(feature.timeFrame) : feature.timeFrame
    };
}
function $c1e231f117ad5b91$export$a75feafd6c41cba5(features) {
    return features.map((feature)=>$c1e231f117ad5b91$export$6df6eeaa7a8a9e78(feature));
}

});

parcelRegister("7pPqA", function(module, exports) {
$parcel$export(module.exports, "getQueryParamFromWindow", function () { return $310042fbac99da87$export$c88f6acd6921f5e8; });
$parcel$export(module.exports, "setQueryParam", function () { return $310042fbac99da87$export$8abc040b5116ed65; });
$parcel$export(module.exports, "setQueryParams", function () { return $310042fbac99da87$export$7755017099c85a0d; });
$parcel$export(module.exports, "setSlug", function () { return $310042fbac99da87$export$8863edec1beb539e; });
$parcel$export(module.exports, "getSlugFromWindow", function () { return $310042fbac99da87$export$e5c851c2cbeb3bc9; });
$parcel$export(module.exports, "clearSlug", function () { return $310042fbac99da87$export$497d95d751f2c8ad; });

var $3fFrT = parcelRequire("3fFrT");
/**
 * Extracts the locale prefix from a URL pathname if present
 * Returns undefined for default locale (en) or if no locale prefix exists
 */ function $310042fbac99da87$var$getLocaleFromPath(pathname) {
    const pathParts = pathname.split('/').filter(Boolean);
    const firstPart = pathParts[0];
    if (firstPart && (0, $3fFrT.LOCALES).includes(firstPart)) return firstPart;
    return undefined;
}
function $310042fbac99da87$export$95fd5664a53dd0c5(param, search) {
    const urlParams = new URLSearchParams(search);
    const value = urlParams.get(param);
    return value ? value.split(';') : [];
}
function $310042fbac99da87$export$c88f6acd6921f5e8(param) {
    return $310042fbac99da87$export$95fd5664a53dd0c5(param, window.location.search);
}
function $310042fbac99da87$export$8abc040b5116ed65(key, values) {
    if (typeof window === 'undefined') return;
    const urlParams = new URLSearchParams(window.location.search);
    const value = values.join(';');
    if (value) urlParams.set(key, value);
    else urlParams.delete(key);
    // Build query string manually to avoid URL-encoding semicolons
    const queryString = Array.from(urlParams.entries()).map(([k, v])=>{
        const encodedKey = encodeURIComponent(k);
        // Keep semicolons unencoded in values
        const encodedValue = v.split(';').map((part)=>encodeURIComponent(part)).join(';');
        return `${encodedKey}=${encodedValue}`;
    }).join('&');
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}${window.location.hash}`;
    window.history.pushState({}, '', newUrl);
}
function $310042fbac99da87$export$7755017099c85a0d(params) {
    Object.entries(params).forEach(([key, values])=>{
        $310042fbac99da87$export$8abc040b5116ed65(key, values);
    });
}
function $310042fbac99da87$export$8863edec1beb539e(value, opts = {}) {
    if (typeof window === 'undefined') return;
    const { basePath: basePath } = opts;
    // Extract locale from current URL path
    const currentLocale = $310042fbac99da87$var$getLocaleFromPath(window.location.pathname);
    let newPath;
    if (basePath) {
        // Treat basePath as non-changeable
        const basePathParts = basePath.split('/').filter(Boolean);
        // If a part exists after the base path, remove it (it will be replaced by the new slug)
        // If no part exists after the base path, remove nothing (just append the new slug)
        // Result is always: [locale] + basePath + new slug
        if (currentLocale) newPath = `/${currentLocale}/${basePathParts.join('/')}/${value}`;
        else newPath = `/${basePathParts.join('/')}/${value}`;
    } else {
        // Original behavior when basePath is not specified
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        newPath = pathParts.length > 0 ? `/${pathParts.join('/')}/${value}` : `/${value}`;
    }
    const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
    window.history.pushState({}, '', newUrl);
}
function $310042fbac99da87$export$29f5936f887dc758(pathname, opts = {}) {
    // either /roadmap/cloud or /roadmap/data-center
    const { basePath: basePath } = opts;
    const currentPathParts = pathname.split('/').filter(Boolean);
    if (basePath) {
        const basePathParts = basePath.split('/').filter(Boolean);
        // Set offeset for locale if it exists
        const currentLocale = $310042fbac99da87$var$getLocaleFromPath(pathname);
        const offset = currentLocale ? 1 : 0;
        // Check if current path starts with base path (accounting for locale offset)
        const startsWithBase = basePathParts.every((part, index)=>currentPathParts[index + offset] === part);
        if (startsWithBase && currentPathParts.length > basePathParts.length + offset) // Return the part after the basePath (accounting for locale offset)
        return currentPathParts[basePathParts.length + offset];
        // No part exists after the basePath, return undefined
        return undefined;
    } else // No basePath specified, return the last path part
    return currentPathParts.length > 0 ? currentPathParts[currentPathParts.length - 1] : undefined;
}
function $310042fbac99da87$export$e5c851c2cbeb3bc9(opts = {}) {
    return $310042fbac99da87$export$29f5936f887dc758(window.location.pathname, opts);
}
function $310042fbac99da87$export$497d95d751f2c8ad(opts = {}) {
    if (typeof window === 'undefined') return;
    const { basePath: basePath } = opts;
    // Extract locale from current URL path
    const currentLocale = $310042fbac99da87$var$getLocaleFromPath(window.location.pathname);
    const currentPathParts = window.location.pathname.split('/').filter(Boolean);
    if (basePath) {
        const basePathParts = basePath.split('/').filter(Boolean);
        // Calculate offset for locale if it exists
        const offset = currentLocale ? 1 : 0;
        // Check if current path starts with base path (accounting for locale offset)
        const startsWithBase = basePathParts.every((part, index)=>currentPathParts[index + offset] === part);
        // Only clear if there's a part after the base path
        if (startsWithBase && currentPathParts.length > basePathParts.length + offset) {
            // Remove the part after the basePath, preserving locale
            let newPath;
            if (currentLocale) newPath = `/${currentLocale}/${basePathParts.join('/')}`;
            else newPath = `/${basePathParts.join('/')}`;
            const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
            window.history.pushState({}, '', newUrl);
        }
    // If no part exists after the base path, don't change the URL
    } else {
        // No basePath specified, use original behavior
        const pathParts = [
            ...currentPathParts
        ];
        if (pathParts.length > 0) pathParts.pop();
        const newPath = pathParts.length > 0 ? `/${pathParts.join('/')}` : '/';
        const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
        window.history.pushState({}, '', newUrl);
    }
}

});


parcelRegister("20kWR", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $66d70741ba057020$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $iPPTB = parcelRequire("iPPTB");

var $jE3Ci = parcelRequire("jE3Ci");

var $bNzAT = parcelRequire("bNzAT");

var $2LBZM = parcelRequire("2LBZM");

var $8xJXU = parcelRequire("8xJXU");

var $5M3ad = parcelRequire("5M3ad");
const $66d70741ba057020$export$60332b2344f7fe41 = (props)=>{
    const { data: data } = props;
    const intl = (0, $8e22h.default)();
    const learnMoreLabel = intl.formatMessage({
        id: 'roadmapFeatures.learnMore',
        defaultMessage: 'Learn more'
    });
    const setSelectedFeature = (0, $2LBZM.useSetSelectedFeature)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = (0, $1oC0p.useCallback)(()=>{
        setSelectedFeature({
            slug: data.slug,
            pid: data.pid
        });
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'card',
            actionSubjectId: 'roadmapFeatureCard',
            source: 'roadmap',
            attributes: {
                label: data.title ?? '',
                slug: data.slug
            }
        }).fire();
    }, [
        setSelectedFeature,
        createAnalyticsEvent,
        data.slug,
        data.pid,
        data.title
    ]);
    const handleKeyDown = (0, $1oC0p.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
        }
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        role: "button",
        tabIndex: 0,
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c11p5 _yv0e1kd1 _2z051wug _zulp1e2i _4cvrv2br _1bahv2br _1yt41ejb _19itkze7 _bfhk1afi _2rko1ylz _80omtlke _vchhusvi _v564slvs _o7ks1kw8 _1dbz130s _1mjb1txw _na0i1bp4 _2osnutpp"
        ]),
        style: {
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light400')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_6td02k": (0, $6ZVlx.default)((0, $bNzAT.default)('corner.radius.card'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rthutpp"
                        ]),
                        children: data.title ?? ''
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_6rthutpp"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8xJXU.FeatureDescription), {
                            content: data.description
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: learnMoreLabel,
                            "aria-label": learnMoreLabel,
                            href: data.slug,
                            type: "primary",
                            isStyleOnly: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq"
                ]),
                children: data.category?.roadmapCategoryNameExternal ?? ''
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq",
                    "_1pfhyh40"
                ]),
                children: data.status?.roadmapStatusNameExternal && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5M3ad.StatusLozenge), {
                    text: data.status.roadmapStatusNameExternal
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq"
                ]),
                children: data.timeFrame ?? ''
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq",
                    "_1pfhyh40",
                    "_1e0c1txw _1n261g80 _zulp1b66"
                ]),
                children: (data.appsCollection?.items ?? []).map((app)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                        text: app.roadmapAppNameExternal,
                        appearance: "neutral"
                    }, app.filterQueryParam))
            })
        ]
    });
};
const $66d70741ba057020$var$cardRowCss = null;
const $66d70741ba057020$var$cellCss = null;
const $66d70741ba057020$var$titleCss = null;
const $66d70741ba057020$var$descriptionCss = null;
const $66d70741ba057020$var$lozengeCellCss = null;
const $66d70741ba057020$var$appsCell = null;

});
parcelRegister("8xJXU", function(module, exports) {
$parcel$export(module.exports, "FeatureDescription", function () { return $d9c1fa5ed5ffbd36$export$4f8b226fdcec19c2; });

var $7VQPk = parcelRequire("7VQPk");

var $gA8LO = parcelRequire("gA8LO");

var $lTkkF = parcelRequire("lTkkF");
const $d9c1fa5ed5ffbd36$export$4f8b226fdcec19c2 = (props)=>{
    if (!props.content?.json) return null;
    const html = (0, $gA8LO.documentToHtmlString)(props.content.json);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
        text: html
    });
};

});

parcelRegister("5M3ad", function(module, exports) {
$parcel$export(module.exports, "StatusLozenge", function () { return $db082f33ca913662$export$f72db4ad1e9b3e6d; });

var $7VQPk = parcelRequire("7VQPk");

var $jE3Ci = parcelRequire("jE3Ci");
const $db082f33ca913662$export$f72db4ad1e9b3e6d = (props)=>{
    const statusColor = $db082f33ca913662$var$getStatusColor(props.text.toLowerCase());
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
        text: props.text,
        appearance: statusColor
    });
};
const $db082f33ca913662$var$getStatusColor = (status)=>{
    let statusColor = 'neutral';
    if (status === 'future') statusColor = 'purple';
    if (status === 'coming soon') statusColor = 'saffron';
    if (status === 'released') statusColor = 'lime';
    if (status === 'completed') statusColor = 'neutral';
    return statusColor;
};

});


parcelRegister("i2afm", function(module, exports) {
$parcel$export(module.exports, "SelectedFeatureModal", function () { return $c3c189e8679067b6$export$ef9ca2eb313283f6; });
/* selected-feature-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $660KI = parcelRequire("660KI");

var $kbpa7 = parcelRequire("kbpa7");

var $2LBZM = parcelRequire("2LBZM");

var $8xJXU = parcelRequire("8xJXU");

var $5M3ad = parcelRequire("5M3ad");
const $c3c189e8679067b6$var$PRIMARY_BLACK = (0, $kbpa7.wacToken)('color.primary.black');
const $c3c189e8679067b6$var$NEUTRAL_LIGHT = (0, $kbpa7.wacToken)('color.neutral.dark800');
const $c3c189e8679067b6$export$ef9ca2eb313283f6 = ()=>{
    const selectedFeature = (0, $2LBZM.useSelectedFeatureData)();
    const clearSelectedFeature = (0, $2LBZM.useClearSelectedFeature)();
    const [isCopied, setIsCopied] = (0, $1oC0p.useState)(false);
    const intl = (0, $8e22h.default)();
    /**
   * NOTE: We cannot use className="eyebrow-lg" and className="h4" here because:
   *
   * 1. The Modal component wraps the title prop in <p className="card-title">, which creates
   *    invalid HTML nesting when we pass a fragment with <p> and <h4> elements. Browsers
   *    auto-correct this invalid structure, which breaks CSS selector matching.
   *
   * 2. When using both className and css prop together, Compiled CSS may not properly merge
   *    the styles. The css prop styles can override or interfere with className-based styles
   *    from TypographyStyles, even when they don't explicitly conflict.
   *
   * 3. CSS specificity issues: The parent .card-title class combined with how Compiled CSS
   *    generates atomic CSS classes can cause the TypographyStyles className selectors to
   *    not match correctly in this nested context.
   *
   * Therefore, we manually apply the eyebrow-lg and h4 styles via the css prop to ensure
   * they work correctly. These styles match the definitions in typography-styles.tsx.
   */ const header = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_ect4z4z1 _k48p1fw0 _1wyb1j6v _vwz41k8s _1p1dangw _syazpu0n _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rthu2gc"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1m80sa1": (0, $6ZVlx.default)($c3c189e8679067b6$var$NEUTRAL_LIGHT)
                },
                children: selectedFeature?.category?.roadmapCategoryNameExternal ?? ''
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_ect41vau _k48p1fw0 _syazqgwi _1wyb1k92 _vwz41slo _1lzoimiu _119z1m1q _3p1c1k8s _py5ol07h _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                style: {
                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                    "--_1t10uu9": (0, $6ZVlx.default)($c3c189e8679067b6$var$PRIMARY_BLACK)
                },
                children: selectedFeature?.title
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $660KI.Modal), {
        isOpen: !!selectedFeature,
        closeModal: clearSelectedFeature,
        title: header,
        width: "medium",
        closeLabel: intl.formatMessage({
            id: 'SelectedFeatureModal.close',
            defaultMessage: 'Close'
        }),
        children: selectedFeature && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8xJXU.FeatureDescription), {
                    content: selectedFeature.description
                }),
                selectedFeature.relatedLinksCollection?.items && selectedFeature.relatedLinksCollection.items.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhpxbi _6rthpxbi"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulpu2gc"
                        ]),
                        children: selectedFeature.relatedLinksCollection.items.map((link, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    text: link.ctaButtonText,
                                    href: link.ctaUrl,
                                    type: "primary",
                                    "aria-label": link.ctaButtonText,
                                    dataEventProps: {
                                        'data-product-key': 'roadmap',
                                        'data-event': 'clicked',
                                        'data-event-component': 'linkButton',
                                        'data-event-container': 'modal'
                                    }
                                })
                            }, index))
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                    htmlFor: "shareable-url-input",
                                    children: intl.formatMessage({
                                        id: 'SelectedFeatureModal.share',
                                        defaultMessage: 'Share this update:'
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _zulppxbi _4cvr1h6o"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                            id: "shareable-url-input",
                                            readOnly: true,
                                            value: $c3c189e8679067b6$var$getShareableUrl(),
                                            className: (0, $2jatx.default)([
                                                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _4t3ixy5q _19itcqhi _2rko1mok _1yt4h8dc _kqswh2mm _152t1l04"
                                            ]),
                                            style: {
                                                "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                            size: "small",
                                            onClick: ()=>{
                                                navigator.clipboard.writeText($c3c189e8679067b6$var$getShareableUrl());
                                                setIsCopied(true);
                                                setTimeout(()=>{
                                                    setIsCopied(false);
                                                }, 2000);
                                            },
                                            dataEventProps: {
                                                'data-product-key': 'roadmap',
                                                'data-event': 'clicked',
                                                'data-event-component': 'button',
                                                'data-event-container': 'modal'
                                            },
                                            children: isCopied ? intl.formatMessage({
                                                id: 'SelectedFeatureModal.linkCopied',
                                                defaultMessage: 'Link Copied'
                                            }) : intl.formatMessage({
                                                id: 'SelectedFeatureModal.copyLink',
                                                defaultMessage: 'Copy link'
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _zulp1y44"
                            ]),
                            children: [
                                selectedFeature.status?.roadmapStatusNameExternal && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5M3ad.StatusLozenge), {
                                    text: selectedFeature.status.roadmapStatusNameExternal
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: selectedFeature.timeFrame ?? ''
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                intl.formatMessage({
                                    id: 'SelectedFeatureModal.availableIn',
                                    defaultMessage: 'This update is available in:'
                                }),
                                "\xa0",
                                (selectedFeature.appsCollection?.items ?? []).map((item)=>item.roadmapAppNameExternal).join(', ')
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
function $c3c189e8679067b6$var$getShareableUrl() {
    return window.location.href;
}

});


parcelRegister("cwkIh", function(module, exports) {
$parcel$export(module.exports, "ColumnHeaders", function () { return $b36c734c8491a922$export$945861bc4c775e51; });
/* column-headers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $2LBZM = parcelRequire("2LBZM");

var $1OYBO = parcelRequire("1OYBO");
const $b36c734c8491a922$export$42bd9088661ffb03 = 'minmax(0, 4fr) minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2.1fr)';
const $b36c734c8491a922$export$945861bc4c775e51 = ()=>{
    const intl = (0, $8e22h.default)();
    const titleSortProps = (0, $2LBZM.useSort)('title');
    const categorySortProps = (0, $2LBZM.useSort)('category');
    const statusSortProps = (0, $2LBZM.useSort)('status');
    const timeFrameSortProps = (0, $2LBZM.useSort)('timeFrame');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c11p5 _yv0e1kd1 _2z051wug _zulp1e2i _4cvr1h6o _1bahv2br _1yt4vu7j _179rkze7 _syaz1sqi _1wyb1crf _y3gn1e5h _vchhusvi _1mjbglyw"
        ]),
        style: {
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                ...titleSortProps,
                sortable: true,
                label: intl.formatMessage({
                    id: 'roadmapFeatures.update',
                    defaultMessage: 'Update'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                ...categorySortProps,
                sortable: true,
                label: intl.formatMessage({
                    id: 'roadmapFeatures.category',
                    defaultMessage: 'Category'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                ...statusSortProps,
                sortable: true,
                label: intl.formatMessage({
                    id: 'roadmapFeatures.status',
                    defaultMessage: 'Status'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                ...timeFrameSortProps,
                sortable: true,
                label: intl.formatMessage({
                    id: 'roadmapFeatures.time',
                    defaultMessage: 'Time'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                sortable: false,
                label: intl.formatMessage({
                    id: 'roadmapFeatures.apps',
                    defaultMessage: 'Apps'
                })
            })
        ]
    });
};
const $b36c734c8491a922$var$headerRowCss = null;

});
parcelRegister("1OYBO", function(module, exports) {
$parcel$export(module.exports, "ColumnHeader", function () { return $80d006960efe257e$export$5667c09b71ee0f05; });
/* column-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eY3N6 = parcelRequire("eY3N6");
const $80d006960efe257e$export$5667c09b71ee0f05 = (props)=>{
    const { label: label, sortable: sortable, sortDirection: sortDirection, onClick: onClick } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const sortSymbol = sortDirection === 'asc' ? "\u2191" : sortDirection === 'desc' ? "\u2193" : '';
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'sortColumn',
            source: 'roadmapFeatures',
            attributes: {
                label: label,
                sortDirection: sortDirection
            }
        }).fire();
        onClick?.();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_k48pni7l _o5721q9c _y3gn1e5h _1e0c116y _4cvr1h6o _zulp1y44"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
            type: "button",
            onClick: handleClick,
            className: (0, $2jatx.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _11q7glyw _1e0c116y _4cvr1h6o _zulp1y44 _11c81kw7 _syaz1kw7 _80omtlke _d0altlke"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_vwz4cjiy _1wyb7vkz"
                    ]),
                    children: label
                }),
                sortable && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _4cvr1h6o _1bah1h6o _1bsb1crf _4t3i1crf _1wyb7vkz"
                    ]),
                    children: sortSymbol ?? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c1o8l _1bsbftgi _4t3iftgi"
                        ])
                    })
                })
            ]
        })
    });
};
const $80d006960efe257e$var$headerCellCss = null;
const $80d006960efe257e$var$labelTextCss = null;
const $80d006960efe257e$var$headerButtonCss = null;
const $80d006960efe257e$var$sortIconWrapperCss = null;
const $80d006960efe257e$var$sortIconPlaceholderCss = null;

});


parcelRegister("l5Cys", function(module, exports) {
$parcel$export(module.exports, "Layout", function () { return $ba7cbf8f19b1a13e$export$c84671f46d6a1ca; });
/* layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $ba7cbf8f19b1a13e$export$c84671f46d6a1ca = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c11p5 _2z051wug _1p571ejb _19pkidpf _2hwx1wug _otyridpf _18u01wug _vchhusvi"
        ]),
        children: [
            props.columnHeaders,
            props.cards
        ]
    });
};
const $ba7cbf8f19b1a13e$var$layoutCss = null;

});

parcelRegister("gBTmU", function(module, exports) {
$parcel$export(module.exports, "RoadmapSubNav", function () { return $01679870f9c69967$export$4202a6ef24dd93ce; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $jIii1 = parcelRequire("jIii1");
const $01679870f9c69967$export$4202a6ef24dd93ce = ({ className: className })=>{
    const intl = (0, $8e22h.default)();
    const ROADMAP_NAV_CONFIG = {
        heading: {
            label: intl.formatMessage({
                id: 'roadmapSubNav.heading',
                defaultMessage: 'Roadmaps'
            }),
            linkUrl: (0, $jQ0cd.useLocalizedHref)('/roadmap/cloud')
        },
        navItems: [
            {
                label: intl.formatMessage({
                    id: 'roadmapSubNav.cloud',
                    defaultMessage: 'Cloud'
                }),
                linkUrl: (0, $jQ0cd.useLocalizedHref)('/roadmap/cloud')
            },
            {
                label: intl.formatMessage({
                    id: 'roadmapSubNav.dataCenter',
                    defaultMessage: 'Data Center'
                }),
                linkUrl: (0, $jQ0cd.useLocalizedHref)('/roadmap/data-center')
            }
        ],
        cta: {
            label: intl.formatMessage({
                id: 'roadmapSubNav.exploreMigration',
                defaultMessage: 'Explore how to migrate'
            }),
            linkUrl: '/migration'
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jIii1.SubNav), {
        headingLabel: ROADMAP_NAV_CONFIG.heading.label,
        headingLinkUrl: ROADMAP_NAV_CONFIG.heading.linkUrl,
        navItems: ROADMAP_NAV_CONFIG.navItems.map((item)=>({
                label: item.label,
                linkUrl: item.linkUrl
            })),
        cta: {
            label: ROADMAP_NAV_CONFIG.cta.label,
            linkUrl: ROADMAP_NAV_CONFIG.cta.linkUrl
        },
        className: className
    });
};
$01679870f9c69967$export$4202a6ef24dd93ce.displayName = 'RoadmapSubNav';

});
parcelRegister("jIii1", function(module, exports) {
$parcel$export(module.exports, "SubNav", function () { return $ef3257635b4117cf$export$4a51633636d7017c; });
/* subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $l5ucJ = parcelRequire("l5ucJ");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $ef3257635b4117cf$var$NAV_HEIGHT = 68;
const $ef3257635b4117cf$var$subNavContainerCss = null;
const $ef3257635b4117cf$var$subNavWrapperCss = null;
const $ef3257635b4117cf$var$subNavWrapperAtTopCss = null;
const $ef3257635b4117cf$var$subNavInnerCss = null;
const $ef3257635b4117cf$var$headingLinkCss = null;
const $ef3257635b4117cf$var$desktopNavCss = null;
const $ef3257635b4117cf$var$navListCss = null;
const $ef3257635b4117cf$var$navItemLinkCss = null;
const $ef3257635b4117cf$var$navItemLinkActiveCss = null;
const $ef3257635b4117cf$var$mobileNavCss = null;
const $ef3257635b4117cf$var$mobileDropdownButtonCss = null;
const $ef3257635b4117cf$var$chevronIconCss = null;
const $ef3257635b4117cf$var$chevronIconRotatedCss = null;
const $ef3257635b4117cf$var$mobileDropdownCss = null;
const $ef3257635b4117cf$var$mobileDropdownListCss = null;
const $ef3257635b4117cf$var$mobileDropdownItemCss = null;
const $ef3257635b4117cf$var$mobileDropdownLinkCss = null;
const $ef3257635b4117cf$var$mobileDropdownLinkActiveCss = null;
const $ef3257635b4117cf$var$mobileCTACss = null;
const $ef3257635b4117cf$var$isLinkActive = (linkUrl)=>{
    if (typeof window === 'undefined') return false;
    const currentPath = window.location.pathname;
    const linkPath = new URL(linkUrl, window.location.origin).pathname;
    return currentPath === linkPath || currentPath.startsWith(linkPath + '/');
};
const $ef3257635b4117cf$var$useSubNavAnalytics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const fireNavLinkClicked = (0, $1oC0p.useCallback)((label, container)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'subNavLink',
            source: container,
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireMobileDropdownClicked = (0, $1oC0p.useCallback)((isOpen)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'mobileDropdown',
            source: 'roadmapSubnav',
            attributes: {
                action: isOpen ? 'close' : 'open'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireNavLinkClicked: fireNavLinkClicked,
        fireMobileDropdownClicked: fireMobileDropdownClicked
    };
};
const $ef3257635b4117cf$export$4a51633636d7017c = ({ headingLabel: headingLabel, headingLinkUrl: headingLinkUrl, navItems: navItems, cta: cta, className: className })=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $1oC0p.useState)(false);
    const [isAtTop, setIsAtTop] = (0, $1oC0p.useState)(false);
    const dropdownId = (0, $1oC0p.useId)();
    const { fireNavLinkClicked: fireNavLinkClicked, fireMobileDropdownClicked: fireMobileDropdownClicked } = $ef3257635b4117cf$var$useSubNavAnalytics();
    const navRef = (0, $1oC0p.useRef)(null);
    const containerRef = (0, $1oC0p.useRef)(null);
    // handle z-index based on scroll position
    // when scrolled >= 68px (nav height), subnav overlaps nav, so set z-index to 10
    (0, $1oC0p.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollY = window.scrollY || window.pageYOffset;
            setIsAtTop(scrollY >= $ef3257635b4117cf$var$NAV_HEIGHT);
        };
        // check initial scroll position
        handleScroll();
        window.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const toggleDropdown = (0, $1oC0p.useCallback)(()=>{
        setIsDropdownOpen((prev)=>{
            fireMobileDropdownClicked(prev);
            return !prev;
        });
    }, [
        fireMobileDropdownClicked
    ]);
    const closeDropdown = (0, $1oC0p.useCallback)(()=>{
        setIsDropdownOpen(false);
    }, []);
    const handleDropdownKeyDown = (0, $1oC0p.useCallback)((event)=>{
        if (event.key === 'Escape' && isDropdownOpen) setIsDropdownOpen(false);
    }, [
        isDropdownOpen
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_152tidpf _kqsw1if8 _1pfh1cg9 _1bsb1osq _1pbykb7n",
            isAtTop && "_1pbyzo7u",
            className
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: navRef,
            role: "navigation",
            "aria-label": `${headingLabel} navigation`,
            className: (0, $2jatx.default)([
                "_kqsw1if8 _152tidpf _1bsb1osq _bfhk1afi _v564guk9 _1pbykb7n _ahbq1vh9 _3l1aidpf _161bidpf"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _4t3ivbgk _p12f1fra _195g1wug _1pbykb7n _12l21stb _161bidpf _165tt9kd _pdlm1ejb"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: headingLinkUrl,
                            "data-testid": "subnav-heading-link",
                            onClick: ()=>fireNavLinkClicked(headingLabel, 'roadmap'),
                            className: (0, $2jatx.default)([
                                "_syaz1pfd _4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41vau _1wyb1k92 _k48pni7l _vwz4cjiy _1o9zidpf _30l3ftjs _1ygb1qgu _1ah3v77o _1baslb4i _3p1c1k8s"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                                "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800')),
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            },
                            children: headingLabel
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0cglyw _dm251txw _1jsv1h6o _glte1osq _msup1yb4 _pdlmxy5q"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                    role: "list",
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulp1ejb _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                    ]),
                                    children: navItems.map((item, index)=>{
                                        const isActive = $ef3257635b4117cf$var$isLinkActive(item.linkUrl);
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                href: item.linkUrl,
                                                "data-testid": `subnav-item-${index}`,
                                                "aria-current": isActive ? 'page' : undefined,
                                                onClick: ()=>fireNavLinkClicked(item.label, 'roadmapSubnav'),
                                                className: (0, $2jatx.default)([
                                                    "_syaz1pfd _4bfu1r31 _1hmsglyw _ajmmnqa1 _ect4z4z1 _1wyb1j6v _k48pbfng _1yt4hyhw _2rkolb4i _v564h5h4 _30l3ftjs _1ygb1qgu _1ah3v77o",
                                                    isActive && "_syazftjs _k48pni7l _179r19d8 _2rkoidpf"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800')),
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                },
                                                children: item.label
                                            })
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "secondary",
                                    href: cta.linkUrl,
                                    "data-testid": "subnav-cta",
                                    dataEventProps: {
                                        'data-product-key': 'roadmap',
                                        'data-event': 'clicked',
                                        'data-event-component': 'linkButton',
                                        'data-event-container': 'roadmapSubnav'
                                    },
                                    children: cta.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _zulppxbi _1bsb1osq _1bah1yb4 _kqsw1if8 _152tidpf _dm25glyw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    type: "button",
                                    onClick: toggleDropdown,
                                    onKeyDown: handleDropdownKeyDown,
                                    "aria-expanded": isDropdownOpen,
                                    "aria-controls": dropdownId,
                                    "aria-haspopup": "true",
                                    "data-testid": "subnav-mobile-dropdown-button",
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulpu2gc _bfhk1j28 _19itglyw _80omtlke _ect4z4z1 _1wyboxwj _k48pbfng _syaz1pfd _1yt41bs6 _2rkolb4i _irr3dkka _1ygb1qgu _1ah3v77o"
                                    ]),
                                    style: {
                                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                        "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_v564kete",
                                            isDropdownOpen && "_t9ec1sub"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5ucJ))), {
                                            label: isDropdownOpen ? 'Close navigation menu' : 'Open navigation menu',
                                            color: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "secondary",
                                    href: cta.linkUrl,
                                    "data-testid": "subnav-mobile-cta",
                                    dataEventProps: {
                                        'data-product-key': 'roadmap',
                                        'data-event': 'clicked',
                                        'data-event-component': 'linkButton',
                                        'data-event-container': 'roadmapSubnav'
                                    },
                                    className: (0, $2jatx.default)([
                                        "_bfhk1afi"
                                    ]),
                                    style: {
                                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                    },
                                    children: cta.label
                                })
                            ]
                        })
                    ]
                }),
                isDropdownOpen && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    id: dropdownId,
                    "data-testid": "subnav-mobile-dropdown",
                    className: (0, $2jatx.default)([
                        "_kqswstnw _152t1osq _1e02idpf _rjxpidpf _bfhk1afi _179rn5xp _1pbyqfx8 _dm25glyw"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                        "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        role: "list",
                        className: (0, $2jatx.default)([
                            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                        ]),
                        children: navItems.map((item, index)=>{
                            const isActive = $ef3257635b4117cf$var$isLinkActive(item.linkUrl);
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                className: (0, $2jatx.default)([
                                    "_179r1ixx _8gg5glyw"
                                ]),
                                style: {
                                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: item.linkUrl,
                                    onClick: closeDropdown,
                                    "data-testid": `subnav-mobile-item-${index}`,
                                    "aria-current": isActive ? 'page' : undefined,
                                    className: (0, $2jatx.default)([
                                        "_1e0c1ule _syaz1pfd _4bfu1r31 _1hmsglyw _ajmmnqa1 _ect4z4z1 _1wyb1j6v _k48pbfng _1yt4pxbi _irr3g7ng _30l3ftjs _1ygb1qgu _1ah31i6y",
                                        isActive && "_bfhkdkka _syazftjs _k48pni7l"
                                    ]),
                                    style: {
                                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                                        "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800')),
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                        "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                                    },
                                    children: item.label
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
$ef3257635b4117cf$export$4a51633636d7017c.displayName = 'SubNav';

});


parcelRegister("3Nxop", function(module, exports) {
$parcel$export(module.exports, "SearchWithFilters", function () { return $5701f908310c3ff2$export$164878005b1b038c; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $ihYMb = parcelRequire("ihYMb");

var $2LBZM = parcelRequire("2LBZM");
const $5701f908310c3ff2$export$164878005b1b038c = ()=>{
    const searchValueFromUrl = (0, $2LBZM.useSearch)() || '';
    const [searchStringValue, setSearchStringValue] = (0, $1oC0p.useState)(searchValueFromUrl);
    const [searchInputFieldFocused, setSearchInputFieldFocused] = (0, $1oC0p.useState)(false);
    const setFilter = (0, $2LBZM.useSetFilter)();
    const setSearch = (0, $2LBZM.useSetSearch)();
    const appValue = (0, $2LBZM.useFilter)('selectedProduct');
    const statusValue = (0, $2LBZM.useFilter)('status');
    const categoryValue = (0, $2LBZM.useFilter)('category');
    const appOptions = (0, $2LBZM.useFilterOptions)('selectedProduct');
    const statusOptions = (0, $2LBZM.useFilterOptions)('status');
    const categoryOptions = (0, $2LBZM.useFilterOptions)('category');
    const filterObject = (0, $1oC0p.useMemo)(()=>{
        // Order matches column headers: Category, Status, Apps
        return {
            category: categoryOptions.reduce((acc, opt)=>{
                const isSelected = categoryValue.includes(opt.value);
                return {
                    ...acc,
                    [opt.label]: {
                        committedActive: isSelected,
                        stagedActive: isSelected
                    }
                };
            }, {}),
            status: statusOptions.reduce((acc, opt)=>{
                const isSelected = statusValue.includes(opt.value);
                return {
                    ...acc,
                    [opt.label]: {
                        committedActive: isSelected,
                        stagedActive: isSelected
                    }
                };
            }, {}),
            app: appOptions.reduce((acc, opt)=>{
                // Check if the option's value is in the filter values from URL
                const isSelected = appValue.includes(opt.value);
                return {
                    ...acc,
                    [opt.label]: {
                        committedActive: isSelected,
                        stagedActive: isSelected
                    }
                };
            }, {})
        };
    }, [
        categoryOptions,
        categoryValue,
        statusOptions,
        statusValue,
        appOptions,
        appValue
    ]);
    const [filterObjectState, setFilterObjectState] = (0, $1oC0p.useState)(filterObject);
    // Sync search string value with URL params
    (0, $1oC0p.useEffect)(()=>{
        setSearchStringValue(searchValueFromUrl);
    }, [
        searchValueFromUrl
    ]);
    // Sync filter object state with URL params
    (0, $1oC0p.useEffect)(()=>{
        setFilterObjectState(filterObject);
    }, [
        filterObject
    ]);
    const clearSearchField = (0, $1oC0p.useCallback)(()=>{
        setSearchStringValue('');
        setSearchInputFieldFocused(false);
        setSearch('');
    }, [
        setSearch
    ]);
    const runSearchWithFilters = (0, $1oC0p.useCallback)((filterObj, searchTerm)=>{
        setFilterObjectState(filterObj);
        // search
        setSearch(searchTerm);
        // app (selectedProduct) filter
        const appFilterValue = [];
        Object.entries(filterObj.app).map(([label, { committedActive: committedActive }])=>{
            if (committedActive) {
                const option = appOptions.find((opt)=>opt.label === label);
                if (option) appFilterValue.push(option.value);
            }
        });
        setFilter('selectedProduct', appFilterValue);
        // category filter
        const categoryFilterValue = [];
        Object.entries(filterObj.category).map(([label, { committedActive: committedActive }])=>{
            if (committedActive) {
                const option = categoryOptions.find((opt)=>opt.label === label);
                if (option) categoryFilterValue.push(option.value);
            }
        });
        setFilter('category', categoryFilterValue);
        // status filter
        const statusFilterValue = [];
        Object.entries(filterObj.status).map(([label, { committedActive: committedActive }])=>{
            if (committedActive) {
                const option = statusOptions.find((opt)=>opt.label === label);
                if (option) statusFilterValue.push(option.value);
            }
        });
        setFilter('status', statusFilterValue);
    }, [
        appOptions,
        categoryOptions,
        statusOptions,
        setFilter,
        setSearch
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ihYMb.default), {
        filterObject: filterObjectState,
        searchStringValue: searchStringValue,
        searchInputFieldFocused: searchInputFieldFocused,
        setSearchInputFieldFocused: setSearchInputFieldFocused,
        setFilterObjectValue: setFilterObjectState,
        setSearchString: setSearchStringValue,
        clearSearchField: clearSearchField,
        runSearchWithFilters: runSearchWithFilters
    });
};

});
parcelRegister("ihYMb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $920593310c76585f$export$2e2bcd8739ae039; });
/* uniform-search-with-filters.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $lgRQS = parcelRequire("lgRQS");

var $hjTlF = parcelRequire("hjTlF");

var $8OrKI = parcelRequire("8OrKI");
const $920593310c76585f$var$UniformSearchWithFilters = ({ filterObject: filterObject, searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, setFilterObjectValue: setFilterObjectValue, setSearchInputFieldFocused: setSearchInputFieldFocused, setSearchString: setSearchString, clearSearchField: clearSearchField, runSearchWithFilters: runSearchWithFilters })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const localizedMap = {
        app: intl.formatMessage({
            id: 'uniformSearchWithFilters.filter.app',
            defaultMessage: 'App'
        }),
        category: intl.formatMessage({
            id: 'uniformSearchWithFilters.filter.category',
            defaultMessage: 'Category'
        }),
        status: intl.formatMessage({
            id: 'uniformSearchWithFilters.filter.status',
            defaultMessage: 'Status'
        })
    };
    const clearFiltersText = intl.formatMessage({
        id: 'uniformSearchWithFilters.clearFilters',
        defaultMessage: 'Clear Filters'
    });
    const clearAllFilters = ()=>{
        setFilterObjectValue((prevState)=>{
            const cleared = {};
            Object.keys(prevState).forEach((category)=>{
                const categoryKey = category;
                cleared[categoryKey] = {};
                Object.keys(prevState[categoryKey]).forEach((optionName)=>{
                    cleared[categoryKey][optionName] = {
                        committedActive: false,
                        stagedActive: false
                    };
                });
            });
            runSearchWithFilters(cleared, searchStringValue);
            return cleared;
        });
    };
    const whichFilterModalIsOpenObjectDefaultState = {
        app: false,
        category: false,
        status: false
    };
    Object.freeze(whichFilterModalIsOpenObjectDefaultState);
    const [whichFilterModalIsOpenObject, updateWhichFilterModalIsOpenObject] = (0, $1oC0p.useState)(whichFilterModalIsOpenObjectDefaultState);
    // Updates the state of which filter modal is open
    // If a modal is closing, we commit all the stagedActive values
    const updateWhichFilterModalIsShown = (subFilter)=>{
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        updateWhichFilterModalIsOpenObject(()=>({
                ...whichFilterModalIsOpenObjectDefaultState,
                [subFilter]: !whichFilterModalIsOpenObject[subFilter]
            }));
        if (isModalClosing.length > 0) setFilterObjectValue((prevState)=>{
            filterObject = {
                ...prevState,
                ...(0, $8OrKI.commitAllStagedActiveValues)(prevState)
            };
            runSearchWithFilters(filterObject, searchStringValue);
            return filterObject;
        });
    };
    // Updates the stagedActive value of the filter
    const updateSubFilterStagedValue = (subFilterName, filterOptionName)=>{
        setFilterObjectValue((prevState)=>{
            return {
                ...prevState,
                [subFilterName]: {
                    ...prevState[subFilterName],
                    [filterOptionName]: {
                        ...prevState[subFilterName][filterOptionName],
                        stagedActive: !prevState[subFilterName][filterOptionName].stagedActive
                    }
                }
            };
        });
    };
    // Handles logic for determining which filter modal to show
    const getFilterModal = (showFilter, filterKey)=>{
        if (!showFilter || !whichFilterModalIsOpenObject[filterKey]) return null;
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hjTlF.UniformFilterModal), {
            subFilter: filterKey,
            subFilterObject: filterObject[filterKey],
            updateFilterObject: (filterOptionName)=>updateSubFilterStagedValue(filterKey, filterOptionName)
        });
    };
    const filterButtonClickWrapper = (ev, filterCategory)=>{
        ev.preventDefault();
        createAnalyticsEvent({
            origin: 'web',
            platform: 'web',
            product: 'marketing',
            source: 'none',
            userIdType: 'atlassianAccount',
            eventComponent: 'uniformFilterButton',
            event: 'clicked',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'component',
            attributes: {
                labelEnglish: filterCategory,
                url: location.href,
                page_path: location.pathname,
                eventComponent: 'uniformFilterButton'
            }
        }).fire();
        updateWhichFilterModalIsShown(filterCategory);
    };
    // If any filter modal is open, show the modal
    const showModal = Object.values(whichFilterModalIsOpenObject).filter((isActiveValue)=>isActiveValue).length > 0;
    const handleDocumentClick = (0, $1oC0p.useCallback)((event)=>{
        if (showModal) {
            let parentNode = event.target;
            while(parentNode && parentNode.nodeName !== 'BODY'){
                if (parentNode.id === 'uniform-filter-modal-component-parent') return;
                parentNode = parentNode.parentNode;
            }
        }
        // If we are here, it means the click was outside the modal
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        if (isModalClosing.length > 0) {
            updateWhichFilterModalIsOpenObject(()=>({
                    ...whichFilterModalIsOpenObjectDefaultState
                }));
            setFilterObjectValue((prevState)=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                filterObject = {
                    ...prevState,
                    ...(0, $8OrKI.commitAllStagedActiveValues)(prevState)
                };
                runSearchWithFilters(filterObject, searchStringValue);
                return filterObject;
            });
        }
    }, [
        showModal
    ]);
    // Attach and detach the event listener for the document click
    // This is used to determine if there is a click outside of the filter modals
    (0, $1oC0p.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener('click', handleDocumentClick, false);
        // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener('click', handleDocumentClick, false);
        };
    }, [
        handleDocumentClick
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "uniform-filters",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                className: (0, $2jatx.default)([
                    "_18s812pl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261q9c _1bah1yb4 _zulppxbi _8rdu1g80"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1n261q9c _i0dlmko7 _1bahesu3 _8fz61osq _1a8l1osq _o5kc1y6m"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lgRQS.SearchBar), {
                                searchStringValue: searchStringValue,
                                setSearchString: setSearchString,
                                runSearch: ()=>runSearchWithFilters(filterObject, searchStringValue),
                                searchInputFieldFocused: searchInputFieldFocused,
                                setSearchInputFieldFocused: setSearchInputFieldFocused,
                                clearSearchField: clearSearchField
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1e0c1txw _1n261q9c _i0dl1ns9 _v5646lqh _zulpu2gc _1a8l1osq _1s4p1osq _8rdu1g80"
                            ]),
                            children: [
                                [
                                    'category',
                                    'status',
                                    'app'
                                ].map((key, index)=>{
                                    const filterKey = key;
                                    // Inefficient, we should look into memoizing this
                                    const numFiltersActive = (0, $8OrKI.getActiveFiltersByFilterType)(filterKey, filterObject);
                                    const buttonClassNameBuilder = `body-md ${numFiltersActive ? 'filter-active' : ''} ${whichFilterModalIsOpenObject[filterKey] ? 'selected' : ''}`;
                                    const filterModal = getFilterModal(showModal, filterKey);
                                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lqyi6.Button), {
                                                variant: "secondary",
                                                size: "small",
                                                className: (0, $2jatx.default)([
                                                    "_blhd1wug _1tvskb7n _1bzwkb7n _1a8l1wug _1fqbf1gs _1p3ku2gc _128g18ms _1n7jdkka _19lcdkka _1w3o1qk7 _1og01qk7 _mtmv1qk7 _1il01txw _1qqaglyw",
                                                    buttonClassNameBuilder
                                                ]),
                                                id: "uniform-filter-modal-component-parent",
                                                onClick: (ev)=>filterButtonClickWrapper(ev, filterKey),
                                                style: {
                                                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                                                    "--_548yx2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple100'))
                                                },
                                                children: [
                                                    localizedMap[filterKey],
                                                    " ",
                                                    $920593310c76585f$var$filterDropDownArrowSVG,
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                        className: (0, $2jatx.default)([
                                                            "_1e0cglyw _4cvr1h6o _1bah1h6o _11q7kj3p _2rko1ssb _ahbqu2gc _syaz1pfd _1bsbv47k _4t3iv47k _k48pni7l _vwz4kb7n",
                                                            "fine-print"
                                                        ]),
                                                        style: {
                                                            "--_1jqqkxh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple300')),
                                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                                        },
                                                        children: numFiltersActive
                                                    })
                                                ]
                                            }),
                                            filterModal
                                        ]
                                    }, index);
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "uniform-filter-button",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        variant: "primary_alt",
                                        size: "small",
                                        onClick: clearAllFilters,
                                        className: (0, $2jatx.default)([
                                            "_o5721q9c",
                                            "body-md"
                                        ]),
                                        children: clearFiltersText
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const $920593310c76585f$var$filterDropDownArrowSVG = /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
    width: "10",
    height: "6",
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "uniform-filter-dropdown-arrow",
    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
        d: "M9 1.18164L5 4.818L1 1.18164",
        stroke: (0, $kbpa7.wacToken)('color.primary.black'),
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
const $920593310c76585f$var$uniformFiltersSectionContainerStyle = null;
const $920593310c76585f$var$uniformFiltersContainerStyle = null;
const $920593310c76585f$var$filterButtonContainerStyle = null;
const $920593310c76585f$var$filterButtonStyles = null;
const $920593310c76585f$var$filterButtonCountStyles = null;
const $920593310c76585f$var$clearFiltersButtonStyle = null;
const $920593310c76585f$var$searchButtonContainerStyle = null;
var $920593310c76585f$export$2e2bcd8739ae039 = $920593310c76585f$var$UniformSearchWithFilters;

});
parcelRegister("lgRQS", function(module, exports) {
$parcel$export(module.exports, "SearchBar", function () { return $638264a52bcdb51e$export$79d13b60110f33be; });
/* search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $3n8tj = parcelRequire("3n8tj");

var $03P38 = parcelRequire("03P38");
const $638264a52bcdb51e$export$79d13b60110f33be = ({ searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, setSearchString: setSearchString, setSearchInputFieldFocused: setSearchInputFieldFocused, clearSearchField: clearSearchField, runSearch: runSearch })=>{
    const intl = (0, $8e22h.default)();
    let createAnalyticsEvent = null;
    try {
        const analyticsHook = (0, $eY3N6.useAnalyticsEvents)();
        createAnalyticsEvent = analyticsHook.createAnalyticsEvent;
    } catch (e) {
    // Analytics provider not available
    }
    const searchRef = (0, $1oC0p.useRef)(null);
    const onSearchInputChange = (event)=>{
        setSearchString(event.target.value);
    };
    const handleSearchBarFocus = ()=>{
        setSearchInputFieldFocused(true);
        if (createAnalyticsEvent) createAnalyticsEvent({
            origin: 'web',
            platform: 'web',
            product: 'marketing',
            source: 'none',
            userIdType: 'atlassianAccount',
            eventComponent: 'searchInput',
            event: 'clicked',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'component',
            attributes: {
                url: location.href,
                page_path: location.pathname,
                eventComponent: 'searchInput'
            }
        }).fire();
    };
    const handleOnBlur = ()=>{
        if (searchStringValue === '') setSearchInputFieldFocused(false);
        else setSearchInputFieldFocused(true);
    };
    const handleSearchButtonClick = (0, $1oC0p.useCallback)(()=>{
        if (searchRef.current) searchRef.current.focus();
        runSearch();
    }, [
        runSearch
    ]);
    const handleClearSearchButtonClick = ()=>{
        clearSearchField();
        if (searchRef.current) searchRef.current.focus();
    };
    const searchClassName = searchInputFieldFocused ? 'search-active' : '';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        onSubmit: (evt)=>{
            evt.preventDefault();
            handleSearchButtonClick();
        },
        className: (0, $2jatx.default)([
            "_4t3i1jfw _6rthidpf _1bsb1osq _12l2pxbi _11q7dkka _2rko1jfw _1e0c1txw _1n261q9c _1bah1yb4 _1yt4119w _scffglyw _1rwq1j28 _xmji1r31 _gxxuglyw _34ir1o36 _5hv91osq _17ea1vuk _psgk1pfd _1owa1w8u _4u6k1j28 _10709by0 _1f021txw _oki51h6o _1vh3esu3 _dier1q9c _qe2zh8dc _12nmbz2e _1d2m1ejb _11vyksb5 _p2rgx19p"
        ]),
        style: {
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                className: searchClassName,
                type: "text",
                "aria-label": intl?.formatMessage({
                    id: 'SearchBar.searchPlaceholder',
                    defaultMessage: 'Search'
                }) || 'Search',
                placeholder: intl?.formatMessage({
                    id: 'SearchBar.searchPlaceholder',
                    defaultMessage: 'Search'
                }) || 'Search',
                onFocus: handleSearchBarFocus,
                onBlur: handleOnBlur,
                onChange: onSearchInputChange,
                value: searchStringValue,
                ref: searchRef
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: `search-buttons-container ${searchClassName}`,
                children: [
                    searchInputFieldFocused && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $03P38.UniformSearchCloseButton), {
                                onClick: handleClearSearchButtonClick
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: "search-buttons-divider"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3n8tj.UniformSearchButton), {})
                ]
            })
        ]
    });
};
const $638264a52bcdb51e$var$searchBarContainerStyle = null;

});
parcelRegister("3n8tj", function(module, exports) {
$parcel$export(module.exports, "UniformSearchButton", function () { return $d01e7f55404b7a17$export$fcc9da1be4557ae1; });
/* uniform-search-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $5ZCzy = parcelRequire("5ZCzy");

var $kbpa7 = parcelRequire("kbpa7");
const $d01e7f55404b7a17$var$searchIconStyle = null;
const $d01e7f55404b7a17$var$searchIconSvgStyle = null;
const $d01e7f55404b7a17$export$fcc9da1be4557ae1 = ()=>{
    let searchLabel = 'Search';
    try {
        const intl = (0, $8e22h.default)();
        searchLabel = intl.formatMessage({
            id: 'SearchButton.label',
            defaultMessage: 'Search'
        });
    } catch (e) {
    // IntlProvider not available, use default
    }
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'searchSubmit',
            source: 'searchWithFilters',
            attributes: {
                label: searchLabel
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "submit",
        id: "search-icon",
        "aria-label": searchLabel,
        onClick: handleClick,
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _syazk553"
        ]),
        style: {
            "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_syaz1pfd _2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _irr3g7ng"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5ZCzy))), {
                label: searchLabel,
                size: "medium"
            })
        })
    });
};

});

parcelRegister("03P38", function(module, exports) {
$parcel$export(module.exports, "UniformSearchCloseButton", function () { return $cf60fc5b8402956c$export$5170f7b0a027f68a; });
/* uniform-search-close-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $dE0sS = parcelRequire("dE0sS");
const $cf60fc5b8402956c$var$searchButtonStyle = null;
const $cf60fc5b8402956c$var$searchIconStyle = null;
const $cf60fc5b8402956c$export$5170f7b0a027f68a = (props)=>{
    let searchCloseLabel = 'Clear search';
    try {
        const intl = (0, $8e22h.default)();
        searchCloseLabel = intl.formatMessage({
            id: 'SearchCloseButton.label',
            defaultMessage: 'Clear search'
        });
    } catch (e) {
    // IntlProvider not available, use default
    }
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = (e)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'clearSearch',
            source: 'searchWithFilters',
            attributes: {
                label: searchCloseLabel
            }
        }).fire();
        props.onClick(e);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        onClick: handleClick,
        id: "search-close-icon",
        "aria-label": searchCloseLabel,
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _syazk553 _30l3k553"
        ]),
        style: {
            "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
            size: '16',
            className: (0, $2jatx.default)([
                "_syaz1pfd _2rko1ssb _4t3i1wug"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            }
        })
    });
};

});


parcelRegister("hjTlF", function(module, exports) {
$parcel$export(module.exports, "UniformFilterModal", function () { return $f44020fab7cdce9e$export$a3fbc260ab4db874; });
/* uniform-filter-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bNzAT = parcelRequire("bNzAT");

var $OKl9V = parcelRequire("OKl9V");
const $f44020fab7cdce9e$export$a3fbc260ab4db874 = ({ subFilter: subFilter, subFilterObject: subFilterObject, updateFilterObject: updateFilterObject })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _bfhku67f _2rkogktf _1pbycs5v _152t4bvh _ca0q7vkz _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _16qs130s",
            subFilter
        ]),
        id: "uniform-filter-modal-component-parent",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4"
            ]),
            children: Object.keys(subFilterObject).map((filterOptionName, index)=>{
                const filterObject = subFilterObject[filterOptionName];
                const active = filterObject.stagedActive;
                const optionId = `option-${subFilter.replace(/\s/g, '')}-${index}`;
                return /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                    htmlFor: optionId,
                    className: (0, $2jatx.default)([
                        "_19pkftgi _2hwxidpf _otyridpf _18u0idpf _80omtlke _1e0c1txw _1n261q9c _4cvr1h6o _1bah1y6m"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                            id: optionId,
                            type: "checkbox",
                            onClick: ()=>updateFilterObject(filterOptionName),
                            className: (0, $2jatx.default)([
                                "_kqswstnw _tzy4idpf _lcxvglyw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_1bsbgktf _4t3igktf _2rko1l7b _19it1yau _i0dlgktf _12l2ftgi _11q71afi _1e0c1txw _1bah1h6o _4cvr1h6o _bfw71qgu _1c395hrz _uq4u1qgu",
                                active ? 'checked' : ''
                            ]),
                            style: {
                                "--_19gw9o2": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark100')),
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
                                "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_tzy4idpf",
                                    active && "_tzy4kb7n"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                                    name: "featurecheckmark",
                                    size: "xs",
                                    color: (0, $bNzAT.default)('color.neutral.light0')
                                })
                            })
                        }),
                        filterOptionName
                    ]
                }, filterOptionName);
            })
        })
    });
};
const $f44020fab7cdce9e$var$uniformFilterModalStyle = null;
const $f44020fab7cdce9e$var$filterRadioButtonContainerStyle = null;
const $f44020fab7cdce9e$var$checkboxSpanStyle = null;
const $f44020fab7cdce9e$var$iconSpanBaseStyle = null;
const $f44020fab7cdce9e$var$iconSpanVisibleStyle = null;
const $f44020fab7cdce9e$var$hiddenInputStyle = null;
const $f44020fab7cdce9e$var$filterListContainerStyle = null;

});

parcelRegister("8OrKI", function(module, exports) {
$parcel$export(module.exports, "commitAllStagedActiveValues", function () { return $91b56c3aa2113c4b$export$995b34954b6e3c5d; });
$parcel$export(module.exports, "getActiveFiltersByFilterType", function () { return $91b56c3aa2113c4b$export$5c95673afb2371b8; });
const $91b56c3aa2113c4b$export$995b34954b6e3c5d = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = {
            ...prevState[filterCategory],
            ...Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    committedActive: filterOptionValue.stagedActive
                };
                return acc;
            }, {})
        };
        return acc;
    }, {});
};
const $91b56c3aa2113c4b$export$32ef36095a2643ff = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = {
            ...prevState[filterCategory],
            ...Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    stagedActive: false
                };
                return acc;
            }, {})
        };
        return acc;
    }, {});
};
const $91b56c3aa2113c4b$export$6e8eccaa2da87c2a = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = {
            ...prevState[filterCategory],
            ...Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    stagedActive: filterOptionValue.committedActive
                };
                return acc;
            }, {})
        };
        return acc;
    }, {});
};
const $91b56c3aa2113c4b$export$5c95673afb2371b8 = (filter, filterObject)=>{
    if (filter === 'all') return Object.values(filterObject).reduce((acc, filterCategory)=>acc + Object.values(filterCategory).reduce((subacc, filterOption)=>filterOption.committedActive ? subacc + 1 : subacc, 0), 0);
    else return Object.values(filterObject[filter]).reduce((acc, subFilter)=>subFilter.committedActive ? acc + 1 : acc, 0);
};

});




parcelRegister("6smfw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ead486866758e335$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $9mOHh = parcelRequire("9mOHh");
const $ead486866758e335$var$UniformRovoChatBox = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9mOHh.RovoChatBoxContainer), {});
};
var $ead486866758e335$export$2e2bcd8739ae039 = $ead486866758e335$var$UniformRovoChatBox;

});
parcelRegister("9mOHh", function(module, exports) {
$parcel$export(module.exports, "ChatHeader", function () { return $d988f9da35c79665$export$1263ff8fe28ec69f; });
$parcel$export(module.exports, "RovoChatBoxContainer", function () { return $d988f9da35c79665$export$acbe8b1c07595f91; });
/* chat.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2u2Jd = parcelRequire("2u2Jd");

var $eY3N6 = parcelRequire("eY3N6");

var $gqkLW = parcelRequire("gqkLW");

var $iSeHD = parcelRequire("iSeHD");

var $5AtlP = parcelRequire("5AtlP");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $3riD8 = parcelRequire("3riD8");

var $9jvKE = parcelRequire("9jvKE");

var $ewaN9 = parcelRequire("ewaN9");

var $l9P27 = parcelRequire("l9P27");
const $d988f9da35c79665$var$sectionStyles = null;
const $d988f9da35c79665$var$chatHeaderContainerStyles = null;
const $d988f9da35c79665$var$rovoLoaderStyles = null;
const $d988f9da35c79665$var$h1Styles = null;
const $d988f9da35c79665$var$textfieldContainerStyles = null;
const $d988f9da35c79665$var$ctaButtonStyles = null;
const $d988f9da35c79665$var$disabledInteractionCss = null;
const $d988f9da35c79665$var$RovoPillButton = ({ isDisabled: isDisabled, onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const askRovoLabel = intl.formatMessage({
        id: 'RovoChat.askRovo',
        defaultMessage: 'Ask Rovo'
    });
    const tooltipContent = intl.formatMessage({
        id: 'RovoChat.writePromptTooltip',
        defaultMessage: 'Write a prompt'
    });
    const button = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        variant: "primary",
        size: "small",
        onClick: isDisabled ? undefined : onClick,
        dataEventProps: {
            'data-product-key': 'rovo',
            'data-event': 'clicked',
            'data-event-component': 'linkButton',
            'data-event-container': 'rovoChatBox'
        },
        className: (0, $2jatx.default)([
            "_1tke1ylp",
            isDisabled && "_lcxvglyw _80om73ad"
        ]),
        children: askRovoLabel
    });
    // Only show tooltip when button is disabled (no text entered)
    if (isDisabled) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqkLW.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            style: {
                display: 'inline-block'
            },
            children: button
        })
    });
    // No tooltip when button is enabled (user has typed something)
    return button;
};
const $d988f9da35c79665$var$inputStyles = null;
const $d988f9da35c79665$var$chatBoxContainerStyles = null;
const $d988f9da35c79665$var$getNamedHeader = (firstName)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "RovoChat.greeting",
        defaultMessage: "Hey {name},{br}let's get to work",
        values: {
            name: (0, $5AtlP.getFirstName)(firstName),
            br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
        }
    });
};
const $d988f9da35c79665$export$1263ff8fe28ec69f = ()=>{
    const { isUserLoggedIn: isUserLoggedIn, name: name } = (0, $3riD8.useLoggedInUser)();
    const firstName = (0, $5AtlP.getFirstName)(name ?? '');
    // If 'gwp-9000-new-rovo-video-hero' is enabled, <h1> shows the video; else, Rovo Chat Header uses <h1>.
    // Check feature flag at render time to allow tests to mock it properly
    const isNewRovoVideoHeroEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9000NewRovoVideoHero);
    const getMessage = ()=>{
        if (isUserLoggedIn && firstName) return $d988f9da35c79665$var$getNamedHeader(firstName);
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "RovoChat.greeting",
            defaultMessage: "Hey there,{br}ready to get to work?",
            values: {
                br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
            }
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_p12fbxu3 _1bsb1osq _y3gn1h6o _1e0c1txw _2lx21bp4 _4cvr1h6o _zulpa982 _1p57a982 _gy1pa982 _6rth1tcg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1j2z _4t3i1j2z _1ul914no _1tke14no _p12f14no _c71l14no _19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3 _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _1e0c1ule _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2u2Jd))), {
                    options: {
                        loop: true,
                        autoplay: true,
                        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($l9P27))),
                        rendererSettings: {
                            preserveAspectRatio: 'xMidYMid slice'
                        }
                    },
                    height: 36,
                    width: 36
                })
            }),
            isNewRovoVideoHeroEnabled ? /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz48vuz _1wybckbl _k48p9y44"
                ]),
                children: getMessage()
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz48vuz _1wybckbl _k48p9y44"
                ]),
                children: getMessage()
            })
        ]
    });
};
const $d988f9da35c79665$export$e7a1e4b67bd87c97 = ({ textareaRef: externalRef, value: externalValue, onValueChange: onValueChange, previewValue: previewValue })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const hasTrackedTyping = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(false);
    // Attribution for the productionized `gwp-8979-rovo-chat-on-wac` experiment.
    (0, $izdHQ.useFeatureExposed)('gwp-8979-rovo-chat-on-wac', 'Test');
    const defaultPlaceholder = intl.formatMessage({
        id: 'RovoChat.placeholder',
        defaultMessage: 'Find something, plan something, or make something'
    });
    const placeholder = previewValue || defaultPlaceholder;
    const internalRef = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(null);
    const textareaRef = externalRef || internalRef;
    const MAX_HEIGHT = 140; // keep in sync with inputStyles.maxHeight
    const resizeToContent = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useCallback(()=>{
        const el = textareaRef.current;
        if (!el) return;
        el.style.height = 'auto';
        const next = Math.min(el.scrollHeight, MAX_HEIGHT);
        el.style.height = `${next}px`;
    }, [
        textareaRef,
        MAX_HEIGHT
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(()=>{
        resizeToContent();
    }, [
        resizeToContent
    ]);
    const handleChange = ()=>{
        resizeToContent();
    };
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState('');
    const displayValue = externalValue ?? value;
    const fireTypingAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useCallback(()=>{
        if (!hasTrackedTyping.current && analyticsClient) {
            hasTrackedTyping.current = true;
            createAnalyticsEvent({
                product: 'marketing',
                platform: 'web',
                eventType: 'ui',
                action: 'typed',
                actionSubject: 'textInput',
                actionSubjectId: 'rovoChatBox',
                attributes: {
                    url: location.href
                }
            }).fire();
        }
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const handleClick = ()=>{
        const prompt = displayValue.trim();
        if (!prompt) return;
        // Fire analytics event for submission
        if (analyticsClient) createAnalyticsEvent({
            product: 'marketing',
            platform: 'web',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'rovoChatBox',
            attributes: {
                url: location.href,
                promptLength: prompt.length
            }
        }).fire();
        const chatUrl = new URL('https://home.atlassian.com/chat');
        chatUrl.searchParams.set('rovoChatPathway', 'chat');
        chatUrl.searchParams.set('rovoChatPrompt', prompt);
        const loginUrl = `https://id.atlassian.com/login?continue=${encodeURIComponent(chatUrl.toString())}`;
        console.log('generated URL: ', loginUrl);
        window.location.assign(loginUrl);
    };
    const isButtonDisabled = !displayValue.trim();
    const handleKeyDown = (e)=>{
        // Submit on Enter (but allow Shift+Enter for new lines)
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleClick();
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bsb1xup _2lx21bp4 _4cvr1fhb _zulputpp _vchhusvi _2rko1crf _19itn5xp _11q71j9a _16qs130s _1yt41s3g _1jj0utpp _14b5cv93 _1reo15vq _18m915vq"
        ]),
        style: {
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("textarea", {
                ref: textareaRef,
                tabIndex: 0,
                placeholder: placeholder,
                maxLength: 1000,
                value: displayValue,
                onChange: (e)=>{
                    const newValue = e.target.value;
                    setValue(newValue);
                    onValueChange?.(newValue);
                    handleChange(e);
                    // Fire analytics event on first character typed
                    if (newValue.length > 0) fireTypingAnalytics();
                },
                onKeyDown: handleKeyDown,
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1tkegktf _c71l11ux _18m91wug _19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb7vkz _ect41kw7 _vwz4bs82 _slp31hna _1i4q1hna _o5721jtm _14zgglyw _nt751r31 _49pcglyw _1hvw1o36"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _1bahesu3 _1bsb1osq _zulpu2gc"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($d988f9da35c79665$var$RovoPillButton, {
                    isDisabled: isButtonDisabled,
                    onClick: handleClick
                })
            })
        ]
    });
};
const $d988f9da35c79665$export$acbe8b1c07595f91 = ()=>{
    const [chatValue, setChatValue] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState('');
    const [previewValue, setPreviewValue] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState('');
    const textareaRef = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(null);
    const handleColdStartButtonClick = (prompt)=>{
        setChatValue(prompt);
        setPreviewValue(''); // Clear preview when button is clicked
    };
    const handleColdStartButtonHover = (prompt)=>{
        // Only show preview if there's no current value
        if (!chatValue) setPreviewValue(prompt);
    };
    const handleColdStartButtonHoverEnd = ()=>{
        setPreviewValue('');
    };
    // Auto-focus textarea on mount
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(()=>{
        textareaRef.current?.focus({
            preventScroll: true
        });
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _p12fcv93 _1bsb1osq _zulpftgi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($d988f9da35c79665$export$e7a1e4b67bd87c97, {
                textareaRef: textareaRef,
                value: chatValue,
                onValueChange: setChatValue,
                previewValue: previewValue
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ewaN9.ColdStartButtonsRow), {
                onButtonClick: handleColdStartButtonClick,
                onButtonHover: handleColdStartButtonHover,
                onButtonHoverEnd: handleColdStartButtonHoverEnd
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9jvKE.AIFooter), {})
        ]
    });
};
const $d988f9da35c79665$export$9b4d0c63c2bc86a3 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($d988f9da35c79665$export$1263ff8fe28ec69f, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($d988f9da35c79665$export$acbe8b1c07595f91, {})
        ]
    });
};

});
parcelRegister("9jvKE", function(module, exports) {
$parcel$export(module.exports, "AIFooter", function () { return $dd34a5a7e0bde922$export$b209bc813a85fb1d; });
/* ai-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $d6iWh = parcelRequire("d6iWh");
const $dd34a5a7e0bde922$var$footerStyles = null;
const $dd34a5a7e0bde922$var$contentStyles = null;
const $dd34a5a7e0bde922$var$linkStyles = null;
const $dd34a5a7e0bde922$var$iconStyles = null;
const $dd34a5a7e0bde922$var$textStyles = null;
const $dd34a5a7e0bde922$export$b209bc813a85fb1d = ({ href: href = 'https://www.atlassian.com/trust/atlassian-intelligence' })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _vchhusvi"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulp1y44 _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bah1h6o _4cvr1h6o _syazdgkc"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d6iWh))), {
                        label: "Information",
                        size: "small"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                    href: href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: (0, $2jatx.default)([
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_ect4ttxp _k48pi7a9 _1wyb1crf _vwz47vkz _syaz1rpy _1iqs1rm4 _zg8l4jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "RovoChat.usesAI",
                            defaultMessage: "Uses AI. Verify results."
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("ewaN9", function(module, exports) {
$parcel$export(module.exports, "ColdStartButtonsRow", function () { return $f3203383727f3391$export$f8e46ea9cdd11698; });
/* cold-starts-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $igfKj = parcelRequire("igfKj");

var $cNamI = parcelRequire("cNamI");

var $5ZCzy = parcelRequire("5ZCzy");

var $kbpa7 = parcelRequire("kbpa7");
const $f3203383727f3391$var$buttonStyles = null;
const $f3203383727f3391$var$iconStyles = null;
const $f3203383727f3391$var$textStyles = null;
const $f3203383727f3391$var$buttonsContainerStyles = null;
const $f3203383727f3391$export$b99f19cc0647223e = ({ icon: icon, buttonText: buttonText, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        onClick: onClick,
        type: "button",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulpi2wt _1yt4h8dc _2rko1y44 _19itn5xp _11q7g7ng _80omtlke _v5641gvb _1tkezwfg _19lcdkka _4cvxinbi _1sntg7ng _pojj6u2e _1ygb1qgu _1ah3yh40 _j6xt6u2e _q4ztinbi"
        ]),
        style: {
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect4zeyy _k48p1nn1 _1wybdlk8 _vwz41yan _y3gn1h6o _syaz1qc2 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _o5721q9c"
                ]),
                style: {
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                },
                children: buttonText
            })
        ]
    });
};
const $f3203383727f3391$export$f8e46ea9cdd11698 = ({ onButtonClick: onButtonClick, onButtonHover: onButtonHover, onButtonHoverEnd: onButtonHoverEnd })=>{
    const intl = (0, $8e22h.default)();
    const coldStartButtons = [
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($igfKj))), {
                label: "Chart trend up"
            }),
            labelId: 'RovoChat.coldStart.stayUpToDate',
            label: intl.formatMessage({
                id: 'RovoChat.coldStart.stayUpToDate',
                defaultMessage: 'Stay up to date'
            }),
            prompt: intl.formatMessage({
                id: 'RovoChat.coldStart.stayUpToDatePrompt',
                defaultMessage: "What's new this week that I should know about?"
            })
        },
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5ZCzy))), {
                label: "Search"
            }),
            labelId: 'RovoChat.coldStart.findInformation',
            label: intl.formatMessage({
                id: 'RovoChat.coldStart.findInformation',
                defaultMessage: 'Find information'
            }),
            prompt: intl.formatMessage({
                id: 'RovoChat.coldStart.findInformationPrompt',
                defaultMessage: 'Help me find information about [topic or process]'
            })
        },
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNamI))), {
                label: "Lightbulb"
            }),
            labelId: 'RovoChat.coldStart.brainstormIdeas',
            label: intl.formatMessage({
                id: 'RovoChat.coldStart.brainstormIdeas',
                defaultMessage: 'Brainstorm ideas'
            }),
            prompt: intl.formatMessage({
                id: 'RovoChat.coldStart.brainstormIdeasPrompt',
                defaultMessage: "Let's brainstorm ideas for [project, campaign, or topic]."
            })
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _zulpftgi _ca0q7vkz _u5f31crf _n3td7vkz _19bv1crf _1bsb1osq _1bah1h6o _1n261g80"
        ]),
        children: coldStartButtons.map((button)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                onMouseEnter: ()=>onButtonHover?.(button.prompt),
                onMouseLeave: ()=>onButtonHoverEnd?.(),
                onFocus: ()=>onButtonHover?.(button.prompt),
                onBlur: ()=>onButtonHoverEnd?.(),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($f3203383727f3391$export$b99f19cc0647223e, {
                    icon: button.icon,
                    buttonText: button.label,
                    onClick: ()=>onButtonClick?.(button.prompt)
                })
            }, button.labelId);
        })
    });
};

});
parcelRegister("igfKj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fb18bc89cea9c558386c877fcbee03e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4b5ef773c6fdc64$var$_react = $d4b5ef773c6fdc64$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d4b5ef773c6fdc64$var$_baseNew = $d4b5ef773c6fdc64$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $d4b5ef773c6fdc64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4b5ef773c6fdc64$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $d4b5ef773c6fdc64$var$_react.default.createElement($d4b5ef773c6fdc64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$d4b5ef773c6fdc64$var$ChartTrendUpIcon.displayName = 'ChartTrendUpIcon';
var $d4b5ef773c6fdc64$var$_default = module.exports.default = $d4b5ef773c6fdc64$var$ChartTrendUpIcon;

});


parcelRegister("l9P27", function(module, exports) {
module.exports = JSON.parse("{\"assets\":[{\"id\":\"58\",\"layers\":[{\"ind\":57,\"ty\":4,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"rc\",\"p\":{\"a\":0,\"k\":[18.5,30]},\"r\":{\"a\":0,\"k\":0},\"s\":{\"a\":0,\"k\":[37,60]}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,0]},\"o\":{\"a\":0,\"k\":0}}]},{\"ind\":0,\"ty\":4,\"ks\":{\"s\":{\"a\":0,\"k\":[133.33,133.33]}},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[1.67,-0.92],[0.04,-0.02],[0.41,-1.27],[0,-0.57],[0,0],[0,0],[0,0],[0,-2.55],[0,0],[0.23,-0.7],[0.03,-0.07],[0,0],[0,1.95],[0,0],[1.68,0.97],[0,0]],\"o\":[[-1.65,-0.95],[-0.03,0.02],[-1.18,0.69],[-0.16,0.52],[0,0],[0,0],[0,0],[2.21,1.27],[0,0],[0,0.75],[-0.02,0.07],[0,0],[1.69,-0.97],[0,0],[0,-1.94],[0,0],[0,0]],\"v\":[[8.5,0.73],[3.15,0.68],[3.05,0.74],[0.59,3.79],[0.34,5.44],[0.34,12.63],[7.12,16.54],[9.35,17.82],[12.92,24],[12.92,42.55],[12.57,44.73],[12.5,44.96],[24.59,37.98],[27.31,33.27],[27.31,14.71],[24.59,10.01],[21.5,8.23]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.31,0.32,0.35,1]},\"r\":2,\"o\":{\"a\":0,\"k\":100}},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]}]}]},{\"id\":\"61\",\"layers\":[{\"ind\":60,\"ty\":0,\"parent\":56,\"ks\":{},\"w\":37,\"h\":60,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"58\"},{\"ind\":56,\"ty\":3,\"ks\":{\"a\":{\"a\":0,\"k\":[18.5,30]},\"p\":{\"a\":0,\"k\":[18.5,93]}},\"ip\":0,\"op\":385,\"st\":0}]},{\"id\":\"53\",\"layers\":[{\"ind\":6,\"ty\":4,\"parent\":5,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":5,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1140]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":8,\"ty\":4,\"parent\":7,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":7,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,912]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":10,\"ty\":4,\"parent\":9,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":9,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,684]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":12,\"ty\":4,\"parent\":11,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":11,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,456]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":14,\"ty\":4,\"parent\":13,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":13,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,228]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":16,\"ty\":4,\"parent\":15,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":15,\"ty\":3,\"parent\":4,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":18,\"ty\":4,\"parent\":17,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":17,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1311]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":20,\"ty\":4,\"parent\":19,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":19,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1083]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":22,\"ty\":4,\"parent\":21,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":21,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,855]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":24,\"ty\":4,\"parent\":23,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":23,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,627]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":26,\"ty\":4,\"parent\":25,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":25,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,399]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":28,\"ty\":4,\"parent\":27,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":27,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,171]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":30,\"ty\":4,\"parent\":29,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":29,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1254]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":32,\"ty\":4,\"parent\":31,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":31,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1026]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":34,\"ty\":4,\"parent\":33,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":33,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,798]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":36,\"ty\":4,\"parent\":35,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":35,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,570]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":38,\"ty\":4,\"parent\":37,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":37,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,342]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":40,\"ty\":4,\"parent\":39,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":39,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,114]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":42,\"ty\":4,\"parent\":41,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":41,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1197]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":44,\"ty\":4,\"parent\":43,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":43,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,969]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":46,\"ty\":4,\"parent\":45,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":45,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,741]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":48,\"ty\":4,\"parent\":47,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":47,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,513]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":50,\"ty\":4,\"parent\":49,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":49,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,285]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":52,\"ty\":4,\"parent\":51,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":51,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,57]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":4,\"ty\":3,\"parent\":3,\"ks\":{\"a\":{\"a\":0,\"k\":[28.5,700.5]},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[28.5,-439.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":192,\"s\":[28.5,-325.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":384,\"s\":[28.5,-211.5],\"h\":1}]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":3,\"ty\":3,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1140]}},\"ip\":0,\"op\":385,\"st\":0}]},{\"id\":\"120\",\"layers\":[{\"ind\":119,\"ty\":4,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"rc\",\"p\":{\"a\":0,\"k\":[18,30]},\"r\":{\"a\":0,\"k\":0},\"s\":{\"a\":0,\"k\":[36,60]}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,0]},\"o\":{\"a\":0,\"k\":0}}]},{\"ind\":0,\"ty\":4,\"ks\":{\"s\":{\"a\":0,\"k\":[133.33,133.33]}},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,-1.95],[0,0],[-1.68,-0.97],[0,0],[0,0],[-1.67,0.92],[-0.04,0.02],[-0.41,1.27],[0,0.57],[0,0],[0,0],[0,0],[0,2.55],[0,0],[-0.22,0.7],[-0.03,0.07]],\"o\":[[0,0],[-1.69,0.97],[0,0],[0,1.94],[0,0],[0,0],[1.66,0.95],[0.03,-0.02],[1.19,-0.68],[0.17,-0.52],[0,0],[0,0],[0,0],[-2.21,-1.27],[0,0],[0,-0.75],[0.03,-0.07],[0,0]],\"v\":[[14.81,0],[2.72,6.97],[0,11.68],[0,30.24],[2.73,34.95],[5.59,36.61],[18.8,44.23],[24.16,44.28],[24.26,44.21],[26.72,41.16],[26.98,39.52],[26.98,32.33],[19.98,28.3],[17.96,27.13],[14.39,20.96],[14.39,2.41],[14.73,0.23],[14.81,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.31,0.32,0.35,1]},\"r\":2,\"o\":{\"a\":0,\"k\":100}},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]}]}]},{\"id\":\"123\",\"layers\":[{\"ind\":122,\"ty\":0,\"parent\":118,\"ks\":{},\"w\":36,\"h\":60,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"120\"},{\"ind\":118,\"ty\":3,\"ks\":{\"a\":{\"a\":0,\"k\":[18,30]},\"p\":{\"a\":0,\"k\":[39,168.63]}},\"ip\":0,\"op\":385,\"st\":0}]},{\"id\":\"115\",\"layers\":[{\"ind\":68,\"ty\":4,\"parent\":67,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":67,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,57]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":70,\"ty\":4,\"parent\":69,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":69,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,285]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":72,\"ty\":4,\"parent\":71,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":71,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1197]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":74,\"ty\":4,\"parent\":73,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":73,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,969]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":76,\"ty\":4,\"parent\":75,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":75,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,741]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":78,\"ty\":4,\"parent\":77,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":77,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,513]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":80,\"ty\":4,\"parent\":79,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":79,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,114]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":82,\"ty\":4,\"parent\":81,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":81,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,342]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":84,\"ty\":4,\"parent\":83,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":83,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1254]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":86,\"ty\":4,\"parent\":85,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":85,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1026]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":88,\"ty\":4,\"parent\":87,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":87,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,798]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":90,\"ty\":4,\"parent\":89,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":89,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,570]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":92,\"ty\":4,\"parent\":91,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":91,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,171]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":94,\"ty\":4,\"parent\":93,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":93,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,399]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":96,\"ty\":4,\"parent\":95,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":95,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1311]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":98,\"ty\":4,\"parent\":97,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":97,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1083]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":100,\"ty\":4,\"parent\":99,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":99,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,855]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":102,\"ty\":4,\"parent\":101,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":101,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,627]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":104,\"ty\":4,\"parent\":103,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":103,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,0]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":106,\"ty\":4,\"parent\":105,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":105,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,228]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":108,\"ty\":4,\"parent\":107,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":107,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1140]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":110,\"ty\":4,\"parent\":109,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":109,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,912]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":112,\"ty\":4,\"parent\":111,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":111,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,684]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":114,\"ty\":4,\"parent\":113,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":113,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,456]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":66,\"ty\":3,\"parent\":65,\"ks\":{\"a\":{\"a\":0,\"k\":[28.5,700.5]},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[28.5,700.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":192,\"s\":[28.5,586.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":384,\"s\":[28.5,472.5],\"h\":1}]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":65,\"ty\":3,\"ks\":{\"p\":{\"a\":0,\"k\":[1,229]}},\"ip\":0,\"op\":385,\"st\":0}]}],\"fr\":60,\"h\":64,\"ip\":0,\"layers\":[{\"ind\":63,\"ty\":0,\"td\":1,\"parent\":2,\"ks\":{},\"w\":37,\"h\":123,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"61\"},{\"ind\":55,\"ty\":0,\"tt\":1,\"parent\":2,\"ks\":{\"a\":{\"a\":0,\"k\":[0,1140]}},\"w\":57,\"h\":2541,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"53\"},{\"ind\":2,\"ty\":3,\"parent\":1,\"ks\":{\"p\":{\"a\":0,\"k\":[25,-63]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":125,\"ty\":0,\"td\":1,\"parent\":64,\"ks\":{},\"w\":57,\"h\":199,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"123\"},{\"ind\":117,\"ty\":0,\"tt\":1,\"parent\":64,\"ks\":{\"a\":{\"a\":0,\"k\":[1,229]}},\"w\":58,\"h\":1630,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"115\"},{\"ind\":64,\"ty\":3,\"parent\":1,\"ks\":{\"p\":{\"a\":0,\"k\":[-17,-134.63]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":1,\"ty\":3,\"parent\":0,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":0,\"ty\":3,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0}],\"meta\":{\"g\":\"https://jitter.video\"},\"op\":384,\"v\":\"5.7.4\",\"w\":64}");

});



parcelRegister("2Oxuw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $312f7aad558dbf1f$export$2e2bcd8739ae039; });
/* rovo-chat-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $312f7aad558dbf1f$var$uniformSlotContainerCss = null;
const $312f7aad558dbf1f$var$UniformRovoChatContainer = ()=>{
    const contentContainerRef = (0, $1oC0p.useRef)(null);
    const [interacting, setInteracting] = (0, $1oC0p.useState)(false);
    const interactingRef = (0, $1oC0p.useRef)(interacting);
    (0, $1oC0p.useEffect)(()=>{
        interactingRef.current = interacting;
    }, [
        interacting
    ]);
    // On-load
    (0, $1oC0p.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let cleanup;
        let wheelTimeout = null;
        let keyTimeout = null;
        const container = contentContainerRef.current;
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (!interactingRef.current) setInteracting(true);
            };
            const handleFirstClick = ()=>{
                handleFirstInteraction();
                enableScrollEvents();
            };
            // Scroll blocking
            function preventDefault(e) {
                e.preventDefault();
                handleFirstInteraction();
            }
            function onWheel(e) {
                preventDefault(e);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onKeyDown(e) {
                preventDefault(e);
                if (keyTimeout) clearTimeout(keyTimeout);
                keyTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onTouchMove(e) {
                preventDefault(e);
            }
            function onTouchEnd() {
                enableScrollEvents();
            }
            function blockScrollEvents() {
                window.addEventListener('wheel', onWheel, {
                    passive: false
                });
                window.addEventListener('touchmove', onTouchMove, {
                    passive: false
                });
                window.addEventListener('touchend', onTouchEnd, {
                    passive: false
                });
                window.addEventListener('touchcancel', onTouchEnd, {
                    passive: false
                });
                window.addEventListener('keydown', onKeyDown, {
                    passive: false
                });
            }
            function enableScrollEvents() {
                window.removeEventListener('wheel', onWheel);
                window.removeEventListener('touchmove', onTouchMove);
                window.removeEventListener('touchend', onTouchEnd);
                window.removeEventListener('touchcancel', onTouchEnd);
                window.removeEventListener('keydown', onKeyDown);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                if (keyTimeout) clearTimeout(keyTimeout);
            }
            blockScrollEvents();
            // Content container click interactions
            if (container) container.addEventListener('click', handleFirstClick, {
                once: true
            });
            // Also listen for global clicks as fallback
            const handleGlobalClick = ()=>{
                handleFirstInteraction();
                window.removeEventListener('click', handleGlobalClick);
            };
            window.addEventListener('click', handleGlobalClick);
            // Store cleanup function
            cleanup = ()=>{
                enableScrollEvents();
                if (container) container.removeEventListener('click', handleFirstClick);
                window.removeEventListener('click', handleGlobalClick);
            };
        }
        // Intersection Observer setup
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer?.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (container) observer.observe(container);
        // Cleanup - ensure scroll events are always re-enabled
        return ()=>{
            if (observer && container) observer.unobserve(container);
            if (cleanup) cleanup();
        };
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhkg7ng"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _1bsb2faw _4t3i1wug _1reo15vq _18m915vq _3zmjv4q2",
                    "_t9eclznx"
                ]),
                style: {
                    "--_1s9vxgj": (0, $6ZVlx.default)(interacting ? 'translateX(-120px)' : 'translateX(0)')
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1bsb2faw _4t3i1wug _1reo15vq _18m915vq _1fbdv4q2",
                    "_t9ec1c6a"
                ]),
                style: {
                    "--_1hbuzec": (0, $6ZVlx.default)(interacting ? 'translateX(120px)' : 'translateX(0)')
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: contentContainerRef,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _4t3i1o9t _c71l1o9t _1reo15vq _18m915vq _kqswh2mm _1xloz8o0 _1jopz8o0 _165tcv93 _1jc2cv93"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: "chatContent"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$imageStyles,
                    className: (0, $2jatx.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$imageStyles
                })
            })
        ]
    });
};
var $312f7aad558dbf1f$export$2e2bcd8739ae039 = $312f7aad558dbf1f$var$UniformRovoChatContainer;
const $312f7aad558dbf1f$var$desktopAssetStyle = {
    width: '787px'
};
const $312f7aad558dbf1f$var$desktopLeftAssetCss = null;
const $312f7aad558dbf1f$var$desktopRightAssetCss = null;
const $312f7aad558dbf1f$var$desktopCss = null;
const $312f7aad558dbf1f$var$tabletCss = null;
const $312f7aad558dbf1f$var$mobileCss = null;
const $312f7aad558dbf1f$var$imageStyles = {
    width: '100%',
    display: 'block'
};
const $312f7aad558dbf1f$var$sectionCss = null;

});

parcelRegister("4Aw5W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61a1b380208f9747$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $9mOHh = parcelRequire("9mOHh");
const $61a1b380208f9747$var$UniformRovoChatHeader = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9mOHh.ChatHeader), {});
};
var $61a1b380208f9747$export$2e2bcd8739ae039 = $61a1b380208f9747$var$UniformRovoChatHeader;

});

parcelRegister("4LrCk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14b3a29ed349294b$export$2e2bcd8739ae039; });
/* rovo-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $8e22h = parcelRequire("8e22h");

var $aKeh7 = parcelRequire("aKeh7");

var $1iN19 = parcelRequire("1iN19");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iBzDE = parcelRequire("iBzDE");

var $awV4v = parcelRequire("awV4v");
// Helper function for scroll event management (extracted to reduce complexity)
const $14b3a29ed349294b$var$createScrollEventHandlers = (handleFirstInteraction, enableScrollEvents, wheelTimeout, keyTimeout)=>{
    const preventDefault = (e)=>{
        e.preventDefault();
        handleFirstInteraction();
    };
    const onWheel = (e)=>{
        preventDefault(e);
        if (wheelTimeout.current) clearTimeout(wheelTimeout.current);
        wheelTimeout.current = setTimeout(enableScrollEvents, 20);
    };
    const onKeyDown = (e)=>{
        preventDefault(e);
        if (keyTimeout.current) clearTimeout(keyTimeout.current);
        keyTimeout.current = setTimeout(enableScrollEvents, 20);
    };
    const onTouchMove = (e)=>{
        preventDefault(e);
    };
    const onTouchEnd = ()=>{
        enableScrollEvents();
    };
    return {
        onWheel: onWheel,
        onKeyDown: onKeyDown,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
};
const $14b3a29ed349294b$export$9b3d5715b22fca44 = ({ defaultHeading: defaultHeading, defaultSubheading: defaultSubheading, videoCarousel: videoCarousel, primaryCtaLabel: primaryCtaLabel, primaryCtaHref: primaryCtaHref, headingTag: headingTag = 'h1', flattenData: flattenData = true })=>{
    const uniqueId = (0, $1oC0p.useId)();
    const headingId = `rovo-hero-heading-${uniqueId}`;
    const ctaButtonId = `rovo-hero-cta-${uniqueId}`;
    const videoCarouselData = flattenData ? (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $1oC0p.useRef)([]);
    const videoContainerRef = (0, $1oC0p.useRef)(null);
    const { firePlayPauseClicked: firePlayPauseClicked, fireTeamSelected: fireTeamSelected } = (0, $iBzDE.useRovoHeroAnalytics)();
    const [current, setCurrent] = (0, $1oC0p.useState)(-1);
    const currentRef = (0, $1oC0p.useRef)(current);
    const [playing, setPlaying] = (0, $1oC0p.useState)(true);
    const [durations, setDurations] = (0, $1oC0p.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $1oC0p.useState)(0);
    const [viewportWidth, setViewportWidth] = (0, $1oC0p.useState)(typeof window !== 'undefined' ? window.innerWidth : 0);
    (0, $1oC0p.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]);
    // Helper function for setting up video durations (using useCallback to make it stable)
    const setupVideoDurations = (0, $1oC0p.useCallback)(()=>{
        videoCarouselData.forEach((_, idx)=>{
            const video = videoRefs.current[idx];
            if (!video) return;
            if (video.readyState >= 1) setDurations((durs)=>{
                const copy = [
                    ...durs
                ];
                copy[idx] = video.duration;
                return copy;
            });
            else video.onloadedmetadata = ()=>{
                setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
            };
        });
    }, [
        videoCarouselData
    ]);
    // Helper to set up scroll blocking and event listeners (using useCallback to reduce complexity)
    const setupScrollBlockingAndEvents = (0, $1oC0p.useCallback)((handleFirstInteraction, wheelTimeout, keyTimeout)=>{
        const enableScrollEvents = (handlers)=>{
            window.removeEventListener('wheel', handlers.onWheel);
            window.removeEventListener('touchmove', handlers.onTouchMove);
            window.removeEventListener('touchend', handlers.onTouchEnd);
            window.removeEventListener('touchcancel', handlers.onTouchEnd);
            window.removeEventListener('keydown', handlers.onKeyDown);
            if (wheelTimeout.current) clearTimeout(wheelTimeout.current);
            if (keyTimeout.current) clearTimeout(keyTimeout.current);
        };
        const handlers = $14b3a29ed349294b$var$createScrollEventHandlers(handleFirstInteraction, ()=>enableScrollEvents(handlers), wheelTimeout, keyTimeout);
        const handleFirstClick = ()=>{
            handleFirstInteraction();
            enableScrollEvents(handlers);
        };
        // Block scroll events
        window.addEventListener('wheel', handlers.onWheel, {
            passive: false
        });
        window.addEventListener('touchmove', handlers.onTouchMove, {
            passive: false
        });
        window.addEventListener('touchend', handlers.onTouchEnd, {
            passive: false
        });
        window.addEventListener('touchcancel', handlers.onTouchEnd, {
            passive: false
        });
        window.addEventListener('keydown', handlers.onKeyDown, {
            passive: false
        });
        return {
            handleFirstClick: handleFirstClick,
            enableScrollEvents: ()=>enableScrollEvents(handlers)
        };
    }, []);
    // On-load
    (0, $1oC0p.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let cleanup;
        const wheelTimeout = {
            current: null
        };
        const keyTimeout = {
            current: null
        };
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (currentRef.current === -1) setCurrent(0);
            };
            const { handleFirstClick: handleFirstClick, enableScrollEvents: enableScrollEvents } = setupScrollBlockingAndEvents(handleFirstInteraction, wheelTimeout, keyTimeout);
            // Video container click interactions
            const container = videoContainerRef.current;
            if (container) container.addEventListener('pointerdown', handleFirstClick, {
                once: true
            });
            // Video durations
            setupVideoDurations();
            // Store cleanup function
            cleanup = ()=>{
                enableScrollEvents();
                if (container) {
                    container.removeEventListener('pointerdown', handleFirstInteraction);
                    container.removeEventListener('keydown', handleFirstInteraction);
                }
            };
        }
        // Intersection Observer setup
        const videoContainer = videoContainerRef.current;
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer?.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (videoContainer) observer.observe(videoContainer);
        // Cleanup - ensure scroll events are always re-enabled
        return ()=>{
            if (observer && videoContainer) observer.unobserve(videoContainer);
            if (cleanup) cleanup();
        };
    }, [
        setupVideoDurations,
        setupScrollBlockingAndEvents
    ]);
    // Video handlers - using useCallback to reduce complexity
    const handleEnded = (0, $1oC0p.useCallback)(()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    }, [
        current,
        videoCarouselData.length
    ]);
    const togglePlay = (0, $1oC0p.useCallback)(()=>{
        setPlaying((p)=>{
            firePlayPauseClicked(p ? 'pause' : 'play');
            return !p;
        });
    }, [
        firePlayPauseClicked
    ]);
    const handleTeamClick = (0, $1oC0p.useCallback)((idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        const team = videoCarouselData[idx]?.team ?? String(idx);
        fireTeamSelected(team);
        setCurrent(idx);
        setPlaying(true);
    }, [
        current,
        fireTeamSelected,
        videoCarouselData
    ]);
    // Pause/play current video
    (0, $1oC0p.useEffect)(()=>{
        if (current === -1) return;
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]);
    const currentDuration = durations[current] || 10;
    // Responsive asset type - extracted to reduce complexity
    (0, $1oC0p.useEffect)(()=>{
        const breakpoints = [
            768,
            1024
        ];
        const prevWidth = {
            current: window.innerWidth
        };
        let resizeTimeout;
        const crossedBreakpoint = (prev, curr)=>breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? 'desktop' : viewportWidth >= 768 ? 'tablet' : 'mobile';
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhkg7ng"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _3zmjv4q2",
                    "_t9ecawya"
                ]),
                style: {
                    "--_q1e0bz": (0, $6ZVlx.default)(current !== -1 ? 'translateX(-120px)' : 'translateX(0)')
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1fbdv4q2",
                    "_t9ec1vhi"
                ]),
                style: {
                    "--_1ri7xgi": (0, $6ZVlx.default)(current !== -1 ? 'translateX(120px)' : 'translateX(0)')
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _1rjcxncg _133i1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o"
                            ]),
                            children: [
                                defaultSubheading && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_16mf1vau _12n91k8s _179m1k92 _1k84oxwj",
                                        "body-lg subheading"
                                    ]),
                                    style: {
                                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                    },
                                    children: defaultSubheading
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_4cvr1h6o _1pfhpxbi"
                                    ]),
                                    children: headingTag === 'h1' ? /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                        id: headingId,
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        id: headingId,
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    })
                                }),
                                primaryCtaLabel && primaryCtaHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1n261g80 _zulputpp _1bah1h6o _1mou1ejb _urukpxbi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        id: ctaButtonId,
                                        href: primaryCtaHref,
                                        ariaLabelledby: `${ctaButtonId} ${headingId}`,
                                        dataEventProps: {
                                            'data-product-key': 'uniform',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'heroSection'
                                        },
                                        className: (0, $2jatx.default)([
                                            "_3fcw1q9c _1cqs1j6v _1bys1k92 _1jw8bfng"
                                        ]),
                                        children: primaryCtaLabel
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: videoContainerRef,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e021ssb _t9eczr6s",
                            "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                                    ref: (el)=>videoRefs.current[idx] = el,
                                    src: assetType === 'desktop' ? desktopVideoSrc : assetType === 'tablet' ? tabletVideoSrc : mobileVideoSrc,
                                    muted: true,
                                    playsInline: true,
                                    onEnded: handleEnded,
                                    autoPlay: idx === current && playing,
                                    controls: false,
                                    "aria-label": ariaLabel,
                                    preload: "auto",
                                    poster: (assetType === 'desktop' ? desktopPoster : assetType === 'tablet' ? tabletPoster : mobilePoster) ?? undefined,
                                    className: (0, $2jatx.default)([
                                        "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje",
                                        "_3um09e9j _4t3i14wr"
                                    ]),
                                    style: {
                                        "--_1gakljb": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? 'visible' : 'hidden'),
                                        "--_myddx4": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? '100%' : 0)
                                    }
                                }, team))
                        })
                    }),
                    current !== -1 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _y44v12h9 _1e0c11p5 _yv0e1qft _476dutpp _19d71wug _zzszh9n0"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    type: "button",
                                    onClick: togglePlay,
                                    "aria-label": intl.formatMessage(playing ? {
                                        id: 'rovo-hero.pause',
                                        defaultMessage: 'Pause'
                                    } : {
                                        id: 'rovo-hero.play',
                                        defaultMessage: 'Play'
                                    }),
                                    "aria-pressed": playing,
                                    className: (0, $2jatx.default)([
                                        "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1ygb1qgu _1ah3yh40 _1tzgkb7n _1acakb7n"
                                    ]),
                                    style: {
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_4t3izwfg _1bsbzwfg _bfhk6qu4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr389wr _1tjq269p"
                                        ]),
                                        style: {
                                            "--_1q70ahv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1000')),
                                            "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800')),
                                            "--_1osm7si": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark300'))
                                        },
                                        children: playing ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aKeh7))), {
                                            label: intl.formatMessage({
                                                id: 'rovo-hero.pause',
                                                defaultMessage: 'Pause'
                                            })
                                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iN19))), {
                                            label: intl.formatMessage({
                                                id: 'rovo-hero.play',
                                                defaultMessage: 'Play'
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq"
                                    ]),
                                    children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>handleTeamClick(idx),
                                            "aria-label": intl.formatMessage({
                                                id: 'rovo-hero.team-button',
                                                defaultMessage: 'Play {team} video'
                                            }, {
                                                team: team
                                            }),
                                            "aria-pressed": idx === current,
                                            className: (0, $2jatx.default)([
                                                "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _ect41vau _1wyb1j6v _k48p1fw0 _vwz41k8s _1ygb1qgu _1ah3yh40",
                                                "_syaz11o1 _d0almf54"
                                            ]),
                                            style: {
                                                "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                                "--_6ivkis": (0, $6ZVlx.default)(idx === current ? (0, $kbpa7.wacToken)('color.primary.blue') : (0, $kbpa7.wacToken)('color.neutral.light800')),
                                                "--_ly6rcl": (0, $6ZVlx.default)(idx === current ? 'auto' : 'pointer')
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhk6u2e _1mou1ilp",
                                                        idx === 0 && "_2rkonggr",
                                                        idx === videoCarouselData.length - 1 && "_2rkof82g"
                                                    ]),
                                                    style: {
                                                        "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                                                    },
                                                    children: idx === current && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_4t3i1osq _1bsb1osq _bfhk5hrz _kqswstnw _1e02idpf _152tidpf",
                                                            "_y44vytlo _1y0c1ru5",
                                                            "fillBar"
                                                        ]),
                                                        style: {
                                                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                                            "--_1fmqpqp": (0, $6ZVlx.default)(currentDuration, "s"),
                                                            "--_w3huxx": (0, $6ZVlx.default)(playing ? 'running' : 'paused')
                                                        }
                                                    }, fillBarResetKey)
                                                }),
                                                team
                                            ]
                                        }, team))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$imageStyles,
                    className: (0, $2jatx.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$imageStyles
                })
            })
        ]
    });
};
/* eslint-enable complexity */ const $14b3a29ed349294b$var$UniformRovoHeroWithFeatureGate = (props)=>{
    const isGwp10221 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10221RovoProductTourFixScrollAnimation);
    if (isGwp10221) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $awV4v.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($14b3a29ed349294b$export$9b3d5715b22fca44, {
        ...props
    });
};
var $14b3a29ed349294b$export$2e2bcd8739ae039 = $14b3a29ed349294b$var$UniformRovoHeroWithFeatureGate;
const $14b3a29ed349294b$var$desktopAssetStyle = {
    width: '787px'
};
const $14b3a29ed349294b$var$desktopLeftAssetCss = null;
const $14b3a29ed349294b$var$desktopRightAssetCss = null;
const $14b3a29ed349294b$var$desktopCss = null;
const $14b3a29ed349294b$var$tabletCss = null;
const $14b3a29ed349294b$var$mobileCss = null;
const $14b3a29ed349294b$var$imageStyles = {
    width: '100%',
    display: 'block'
};
const $14b3a29ed349294b$var$sectionCss = null;
const $14b3a29ed349294b$var$containerCss = null;
const $14b3a29ed349294b$var$subheadingCss = null;
const $14b3a29ed349294b$var$headingContainerCss = null;
const $14b3a29ed349294b$var$headingCss = null;
const $14b3a29ed349294b$var$mainHeadingCss = null;
const $14b3a29ed349294b$var$ctaContainerCss = null;
const $14b3a29ed349294b$var$ctaCss = null;
const $14b3a29ed349294b$var$videoContainerCss = null;
const $14b3a29ed349294b$var$videoDimensionsCss = null;
const $14b3a29ed349294b$var$videoCss = null;
const $14b3a29ed349294b$var$fadeIn = null;
const $14b3a29ed349294b$var$controlContainerCss = null;
const $14b3a29ed349294b$var$barContainerCss = null;
const $14b3a29ed349294b$var$buttonCss = null;
const $14b3a29ed349294b$var$buttonCirlceCss = null;
const $14b3a29ed349294b$var$firstBarCss = null;
const $14b3a29ed349294b$var$lastBarCss = null;
const $14b3a29ed349294b$var$barbuttonCss = null;
const $14b3a29ed349294b$var$barCss = null;
const $14b3a29ed349294b$var$fillBarCss = null;
const $14b3a29ed349294b$var$fill = null;

});
parcelRegister("iBzDE", function(module, exports) {
$parcel$export(module.exports, "useRovoHeroAnalytics", function () { return $bbd9a66500e3e4bd$export$b341deb4ffc5f20b; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
function $bbd9a66500e3e4bd$export$b341deb4ffc5f20b() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const firePlayPauseClicked = (0, $1oC0p.useCallback)((label)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'playPause',
            source: 'heroSection',
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireTeamSelected = (0, $1oC0p.useCallback)((team)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'teamSelector',
            source: 'heroSection',
            attributes: {
                team: team
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        firePlayPauseClicked: firePlayPauseClicked,
        fireTeamSelected: fireTeamSelected
    };
}

});

parcelRegister("awV4v", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db601b64e1cb1430$export$2e2bcd8739ae039; });
/* rovo-hero-gwp10221.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $8e22h = parcelRequire("8e22h");

var $aKeh7 = parcelRequire("aKeh7");

var $1iN19 = parcelRequire("1iN19");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $iBzDE = parcelRequire("iBzDE");
const $db601b64e1cb1430$var$UniformRovoHero = ({ defaultHeading: defaultHeading, defaultSubheading: defaultSubheading, videoCarousel: videoCarousel, primaryCtaLabel: primaryCtaLabel, primaryCtaHref: primaryCtaHref, headingTag: headingTag = 'h1', flattenData: flattenData = true })=>{
    const videoCarouselData = flattenData ? (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $1oC0p.useRef)([]);
    const videoContainerRef = (0, $1oC0p.useRef)(null);
    const [current, setCurrent] = (0, $1oC0p.useState)(-1);
    const currentRef = (0, $1oC0p.useRef)(current);
    const [playing, setPlaying] = (0, $1oC0p.useState)(true);
    const [durations, setDurations] = (0, $1oC0p.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $1oC0p.useState)(0);
    // @ts-expect-error never read
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const prevViewportWidth = (0, $1oC0p.useRef)(typeof window !== 'undefined' ? window.innerWidth : 0);
    const [viewportWidth, setViewportWidth] = (0, $1oC0p.useState)(typeof window !== 'undefined' ? window.innerWidth : 0);
    (0, $1oC0p.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]);
    // On-load
    (0, $1oC0p.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let wheelTimeout = null;
        let keyTimeout = null;
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (currentRef.current === -1) setCurrent(0);
            };
            const handleFirstClick = ()=>{
                handleFirstInteraction();
                enableScrollEvents();
            };
            // Scroll blocking
            function preventDefault(e) {
                e.preventDefault();
                handleFirstInteraction();
            }
            function onWheel(e) {
                preventDefault(e);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onKeyDown(e) {
                preventDefault(e);
                if (keyTimeout) clearTimeout(keyTimeout);
                keyTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onTouchMove(e) {
                preventDefault(e);
            }
            function onTouchEnd() {
                enableScrollEvents();
            }
            function blockScrollEvents() {
                window.addEventListener('wheel', onWheel, {
                    passive: false
                });
                window.addEventListener('touchmove', onTouchMove, {
                    passive: false
                });
                window.addEventListener('touchend', onTouchEnd, {
                    passive: false
                });
                window.addEventListener('touchcancel', onTouchEnd, {
                    passive: false
                });
                window.addEventListener('keydown', onKeyDown, {
                    passive: false
                });
            }
            function enableScrollEvents() {
                window.removeEventListener('wheel', onWheel);
                window.removeEventListener('touchmove', onTouchMove);
                window.removeEventListener('touchend', onTouchEnd);
                window.removeEventListener('touchcancel', onTouchEnd);
                window.removeEventListener('keydown', onKeyDown);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                if (keyTimeout) clearTimeout(keyTimeout);
            }
            blockScrollEvents();
            // Video container click interactions
            const container = videoContainerRef.current;
            if (container) container.addEventListener('pointerdown', handleFirstClick, {
                once: true
            });
            // Video durations
            videoCarouselData.forEach((_, idx)=>{
                const video = videoRefs.current[idx];
                if (!video) return;
                if (video.readyState >= 1) setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
                else video.onloadedmetadata = ()=>{
                    setDurations((durs)=>{
                        const copy = [
                            ...durs
                        ];
                        copy[idx] = video.duration;
                        return copy;
                    });
                };
            });
            // Cleanup
            return ()=>{
                enableScrollEvents();
                if (container) {
                    container.removeEventListener('pointerdown', handleFirstInteraction);
                    container.removeEventListener('keydown', handleFirstInteraction);
                }
            };
        }
        // Intersection Observer setup
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer?.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (videoContainerRef.current) observer.observe(videoContainerRef.current);
        // Cleanup
        return ()=>{
            if (observer && videoContainerRef.current) observer.unobserve(videoContainerRef.current);
        };
    }, []);
    // Play next video on end, looping
    const handleEnded = ()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    };
    // Pause/play current video
    (0, $1oC0p.useEffect)(()=>{
        if (current === -1) return;
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]);
    const { firePlayPauseClicked: firePlayPauseClicked, fireTeamSelected: fireTeamSelected } = (0, $iBzDE.useRovoHeroAnalytics)();
    // Pause/play toggle
    const togglePlay = ()=>{
        setPlaying((p)=>{
            firePlayPauseClicked(p ? 'pause' : 'play');
            return !p;
        });
    };
    // Jump to a specific video and start from beginning
    const handleTeamClick = (idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        const team = videoCarouselData[idx]?.team ?? String(idx);
        fireTeamSelected(team);
        setCurrent(idx);
        setPlaying(true);
    };
    const currentDuration = durations[current] || 10;
    // Responsive asset type
    (0, $1oC0p.useEffect)(()=>{
        let resizeTimeout;
        const breakpoints = [
            768,
            1024
        ];
        // Store previous width outside the handler so it persists
        const prevViewportWidth = {
            current: window.innerWidth
        };
        function crossedBreakpoint(prev, curr) {
            return breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        }
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevViewportWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevViewportWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? 'desktop' : viewportWidth >= 768 ? 'tablet' : 'mobile';
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhkg7ng"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _3zmjv4q2",
                    "_t9ecawya"
                ]),
                style: {
                    "--_q1e0bz": (0, $6ZVlx.default)(current !== -1 ? 'translateX(-120px)' : 'translateX(0)')
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $db601b64e1cb1430$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1fbdv4q2",
                    "_t9ec1vhi"
                ]),
                style: {
                    "--_1ri7xgi": (0, $6ZVlx.default)(current !== -1 ? 'translateX(120px)' : 'translateX(0)')
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $db601b64e1cb1430$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _1rjcxncg _133i1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o"
                            ]),
                            children: [
                                defaultSubheading && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_16mf1vau _12n91k8s _179m1k92 _1k84oxwj",
                                        "body-lg subheading"
                                    ]),
                                    style: {
                                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                    },
                                    children: defaultSubheading
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_4cvr1h6o _1pfhpxbi"
                                    ]),
                                    children: headingTag === 'h1' ? /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    })
                                }),
                                primaryCtaLabel && primaryCtaHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1n261g80 _zulputpp _1bah1h6o _1mou1ejb _urukpxbi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        href: primaryCtaHref,
                                        dataEventProps: {
                                            'data-product-key': 'uniform',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'heroSection'
                                        },
                                        className: (0, $2jatx.default)([
                                            "_3fcw1q9c _1cqs1j6v _1bys1k92 _1jw8bfng"
                                        ]),
                                        children: primaryCtaLabel
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: videoContainerRef,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e021ssb _t9eczr6s",
                            "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                                    ref: (el)=>videoRefs.current[idx] = el,
                                    src: assetType === 'desktop' ? desktopVideoSrc : assetType === 'tablet' ? tabletVideoSrc : mobileVideoSrc,
                                    muted: true,
                                    playsInline: true,
                                    onEnded: handleEnded,
                                    autoPlay: idx === current && playing,
                                    controls: false,
                                    "aria-label": ariaLabel,
                                    preload: "auto",
                                    poster: (assetType === 'desktop' ? desktopPoster : assetType === 'tablet' ? tabletPoster : mobilePoster) ?? undefined,
                                    className: (0, $2jatx.default)([
                                        "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje",
                                        "_3um09e9j _4t3i14wr"
                                    ]),
                                    style: {
                                        "--_1gakljb": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? 'visible' : 'hidden'),
                                        "--_myddx4": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? '100%' : 0)
                                    }
                                }, team))
                        })
                    }),
                    current !== -1 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _y44v12h9 _1e0c11p5 _yv0e1qft _476dutpp _19d71wug _zzszh9n0"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    type: "button",
                                    onClick: togglePlay,
                                    "aria-label": intl.formatMessage(playing ? {
                                        id: 'rovo-hero.pause',
                                        defaultMessage: 'Pause'
                                    } : {
                                        id: 'rovo-hero.play',
                                        defaultMessage: 'Play'
                                    }),
                                    "aria-pressed": playing,
                                    className: (0, $2jatx.default)([
                                        "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1ygb1qgu _1ah3yh40 _1tzgkb7n _1acakb7n"
                                    ]),
                                    style: {
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_4t3izwfg _1bsbzwfg _bfhk6qu4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr389wr _1tjq269p"
                                        ]),
                                        style: {
                                            "--_1q70ahv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1000')),
                                            "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800')),
                                            "--_1osm7si": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark300'))
                                        },
                                        children: playing ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aKeh7))), {
                                            label: intl.formatMessage({
                                                id: 'rovo-hero.pause',
                                                defaultMessage: 'Pause'
                                            })
                                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iN19))), {
                                            label: intl.formatMessage({
                                                id: 'rovo-hero.play',
                                                defaultMessage: 'Play'
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq"
                                    ]),
                                    children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>handleTeamClick(idx),
                                            "aria-label": intl.formatMessage({
                                                id: 'rovo-hero.team-button',
                                                defaultMessage: 'Play {team} video'
                                            }, {
                                                team: team
                                            }),
                                            "aria-pressed": idx === current,
                                            className: (0, $2jatx.default)([
                                                "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _ect41vau _1wyb1j6v _k48p1fw0 _vwz41k8s _1ygb1qgu _1ah3yh40",
                                                "_syaz11o1 _d0almf54"
                                            ]),
                                            style: {
                                                "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                                "--_6ivkis": (0, $6ZVlx.default)(idx === current ? (0, $kbpa7.wacToken)('color.primary.blue') : (0, $kbpa7.wacToken)('color.neutral.light800')),
                                                "--_ly6rcl": (0, $6ZVlx.default)(idx === current ? 'auto' : 'pointer')
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhk6u2e _1mou1ilp",
                                                        idx === 0 && "_2rkonggr",
                                                        idx === videoCarouselData.length - 1 && "_2rkof82g"
                                                    ]),
                                                    style: {
                                                        "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                                                    },
                                                    children: idx === current && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_4t3i1osq _1bsb1osq _bfhk5hrz _kqswstnw _1e02idpf _152tidpf",
                                                            "_y44vytlo _1y0c1ru5",
                                                            "fillBar"
                                                        ]),
                                                        style: {
                                                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                                            "--_1fmqpqp": (0, $6ZVlx.default)(currentDuration, "s"),
                                                            "--_w3huxx": (0, $6ZVlx.default)(playing ? 'running' : 'paused')
                                                        }
                                                    }, fillBarResetKey)
                                                }),
                                                team
                                            ]
                                        }, team))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $db601b64e1cb1430$var$imageStyles,
                    className: (0, $2jatx.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $db601b64e1cb1430$var$imageStyles
                })
            })
        ]
    });
};
var $db601b64e1cb1430$export$2e2bcd8739ae039 = $db601b64e1cb1430$var$UniformRovoHero;
const $db601b64e1cb1430$var$desktopAssetStyle = {
    width: '787px'
};
const $db601b64e1cb1430$var$desktopLeftAssetCss = null;
const $db601b64e1cb1430$var$desktopRightAssetCss = null;
const $db601b64e1cb1430$var$desktopCss = null;
const $db601b64e1cb1430$var$tabletCss = null;
const $db601b64e1cb1430$var$mobileCss = null;
const $db601b64e1cb1430$var$imageStyles = {
    width: '100%',
    display: 'block'
};
const $db601b64e1cb1430$var$sectionCss = null;
const $db601b64e1cb1430$var$containerCss = null;
const $db601b64e1cb1430$var$subheadingCss = null;
const $db601b64e1cb1430$var$headingContainerCss = null;
const $db601b64e1cb1430$var$headingCss = null;
const $db601b64e1cb1430$var$mainHeadingCss = null;
const $db601b64e1cb1430$var$ctaContainerCss = null;
const $db601b64e1cb1430$var$ctaCss = null;
const $db601b64e1cb1430$var$videoContainerCss = null;
const $db601b64e1cb1430$var$videoDimensionsCss = null;
const $db601b64e1cb1430$var$videoCss = null;
const $db601b64e1cb1430$var$fadeIn = null;
const $db601b64e1cb1430$var$controlContainerCss = null;
const $db601b64e1cb1430$var$barContainerCss = null;
const $db601b64e1cb1430$var$buttonCss = null;
const $db601b64e1cb1430$var$buttonCirlceCss = null;
const $db601b64e1cb1430$var$firstBarCss = null;
const $db601b64e1cb1430$var$lastBarCss = null;
const $db601b64e1cb1430$var$barbuttonCss = null;
const $db601b64e1cb1430$var$barCss = null;
const $db601b64e1cb1430$var$fillBarCss = null;
const $db601b64e1cb1430$var$fill = null;

});


parcelRegister("v15B3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4094c0fa404a407$export$2e2bcd8739ae039; });
/* scrollable-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $2VIbp = parcelRequire("2VIbp");

var $bSVv5 = parcelRequire("bSVv5");

var $jE3Ci = parcelRequire("jE3Ci");

var $kbpa7 = parcelRequire("kbpa7");
const $d4094c0fa404a407$var$messages = (0, $fnHPc.defineMessages)({
    scrollableRegionLabel: {
        id: 'UniformScrollableHeroCards.scrollableRegionLabel',
        defaultMessage: 'Scrollable content'
    }
});
/** Maps Uniform scrollable lozenge color (incl. saffron) to design Lozenge appearance. */ const $d4094c0fa404a407$var$scrollableLozengeColorToAppearance = (color)=>{
    switch(color){
        case 'blue':
        case 'neutral':
        case 'saffron':
        case 'lime':
        case 'purple':
            return color;
        default:
            return 'neutral';
    }
};
const $d4094c0fa404a407$var$backgroundColorMap = {
    blue100: (0, $kbpa7.wacToken)('color.extended.blue100'),
    primaryBlack: (0, $kbpa7.wacToken)('color.primary.black'),
    light100: (0, $kbpa7.wacToken)('color.neutral.light100')
};
const $d4094c0fa404a407$var$UniformScrollableHeroCards = (props)=>{
    const intl = (0, $8e22h.default)();
    const { flattenData: flattenData = true, backgroundColor: backgroundColor = 'blue100', scrollableRegionLabel: scrollableRegionLabel = intl.formatMessage($d4094c0fa404a407$var$messages.scrollableRegionLabel) } = props;
    let { scrollableCard: scrollableCard } = props;
    if (flattenData) {
        const flattened = (0, $2VIbp.flattenScrollableCardProps)(props);
        scrollableCard = flattened.scrollableCard;
    }
    const containerBackgroundColor = $d4094c0fa404a407$var$backgroundColorMap[backgroundColor];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            background: containerBackgroundColor
        },
        className: (0, $2jatx.default)([
            "_1rjcpxbi _18zr1jfw _1bhl1ejb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            "aria-label": scrollableRegionLabel,
            // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
            tabIndex: 0,
            className: (0, $2jatx.default)([
                "_1bsb1s9t _p12f1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _9nneu2gc _1yt4u2gc _zulp1ejb _85i51ejb _1reo1wug _rjfvx6dd _1fjgurpi _a5o9189v _15peu2gc _1v6mg7ng _gce7u2gc _aayn1q9v _155au2gc _1w1e15zi _2osnpxbi"
            ]),
            style: {
                "--_12dmybu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue500')),
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
            },
            children: scrollableCard?.map((card, index)=>{
                const cardContent = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                            appearance: $d4094c0fa404a407$var$scrollableLozengeColorToAppearance(card.scrollableCardLozengeColor),
                            text: card.scrollableCardLozengeText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_18s86fpf _1yt414kv _th3simiu _lrmn10nf",
                                "scrollable-card-title"
                            ]),
                            children: card.scrollableCardTitle
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: card.scrollableCardImage,
                            alt: card.scrollableCardAltText ?? ''
                        })
                    ]
                });
                return card.scrollableCardUrl?.path ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                    href: card.scrollableCardUrl.path,
                    "aria-label": card.scrollableCardUrl.alt || card.scrollableCardTitle,
                    className: (0, $2jatx.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q71afi _2rko1ylz _16qst7xp _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf",
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazn7od _80omtlke _v564iooc _1llwjtcz _1dbz130s _y2mv1i7g"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                        "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                        "--_12dmybu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue500'))
                    },
                    children: cardContent
                }, index) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q71afi _2rko1ylz _16qst7xp _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                        "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
                    },
                    children: cardContent
                }, index);
            })
        })
    });
};
const $d4094c0fa404a407$var$containerStyles = null;
const $d4094c0fa404a407$var$scrollableContainer = null;
const $d4094c0fa404a407$var$titleStyles = null;
const $d4094c0fa404a407$var$cardWrapper = null;
const $d4094c0fa404a407$var$clickableCardStyles = null;
var $d4094c0fa404a407$export$2e2bcd8739ae039 = $d4094c0fa404a407$var$UniformScrollableHeroCards;

});
parcelRegister("2VIbp", function(module, exports) {
$parcel$export(module.exports, "flattenScrollableCardProps", function () { return $2f8a6ad73f8e2a83$export$f91448e13674e82b; });

var $f2QWG = parcelRequire("f2QWG");
const $2f8a6ad73f8e2a83$export$f91448e13674e82b = (props)=>{
    return {
        ...props,
        scrollableCard: (0, $f2QWG.flattenValues)(props.scrollableCard)
    };
};

});


parcelRegister("71GXn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0984c2e73b0694a4$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $5f18E = parcelRequire("5f18E");

var $j5L4q = parcelRequire("j5L4q");
const $0984c2e73b0694a4$var$UniformSideNav = ({ component: component })=>{
    const slotItems = component.slots?.['sideNavItems'] ?? null;
    if (!slotItems) return;
    const sideNavItems = (0, $j5L4q.transformNavItemData)(slotItems);
    const props = {
        title: component.parameters?.['title']?.value,
        sideNavItems: sideNavItems
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5f18E.SideNav), {
        ...props
    });
};
var $0984c2e73b0694a4$export$2e2bcd8739ae039 = $0984c2e73b0694a4$var$UniformSideNav;

});
parcelRegister("5f18E", function(module, exports) {
$parcel$export(module.exports, "SideNav", function () { return $0ecd955324bfea13$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bIY3n = parcelRequire("bIY3n");

var $35KAt = parcelRequire("35KAt");

var $50Va3 = parcelRequire("50Va3");

var $7HoXo = parcelRequire("7HoXo");

var $kbpa7 = parcelRequire("kbpa7");
const $0ecd955324bfea13$var$MobileExpandableNav = ({ title: title, children: children })=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $1oC0p.useState)(0);
    const navRef = (0, $1oC0p.useRef)(null);
    const buttonRef = (0, $1oC0p.useRef)(null);
    const contentRef = (0, $1oC0p.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    };
    // Calculate button position for nav positioning
    (0, $1oC0p.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener('resize', updateButtonPosition);
        window.addEventListener('scroll', updateButtonPosition);
        return ()=>{
            window.removeEventListener('resize', updateButtonPosition);
            window.removeEventListener('scroll', updateButtonPosition);
        };
    }, []);
    // Prevent body scroll when nav is open
    (0, $1oC0p.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'unset';
        return ()=>{
            document.body.style.overflow = 'unset';
        };
    }, [
        isExpanded
    ]);
    // Handle click outside to close nav
    (0, $1oC0p.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: navRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                type: "button",
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1wqb _bfhkdkka _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _kqswh2mm _1pbyibnn _irr36u2e _1ygbm8mt _1ah316gc _s51sxy5q"
                ]),
                style: {
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                    "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _syaz5hrz"
                        ]),
                        style: {
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($35KAt))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bIY3n))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "eyebrow-md",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: contentRef,
                id: "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_bfhk1afi _1bsb1osq _18zr1wqb _v564vpel _1reo1wug _18m91wug _s51sxy5q",
                    isExpanded ? "_kqsw1n9t _152t1um1 _dk5didpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhk1afi _1q51v47k _85i51wqb _18zr1wqb _s51sxy5q" : "_kqsw1n9t _c71lidpf _tzy4idpf _lcxvglyw _152tidpf _dk5didpf _1bsbauwl"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_ab93rs": (0, $6ZVlx.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1reo1wug _18m91wug"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $0ecd955324bfea13$export$6b43f262d1299a2e = ({ sideNavItems: sideNavItems })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _18s8ze3t _1yt4ze3t _1reo1wug _18m91wug _1jc21nkh _1xeyn5xp",
            "sidenav-menu"
        ]),
        style: {
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
        },
        children: sideNavItems.map((sideNavItem)=>{
            if (sideNavItem.type === 'collection') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50Va3.SideNavCollection), {
                type: "collection",
                collectionName: sideNavItem.collectionName,
                sideNavItems: sideNavItem.sideNavItems,
                depth: 0
            }, sideNavItem.collectionName);
            if (sideNavItem.type === 'link') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7HoXo.SideNavLink), {
                dataEventProps: sideNavItem.dataEventProps,
                type: "link",
                text: sideNavItem.text,
                href: sideNavItem.href,
                anchors: sideNavItem.anchors,
                depth: 0
            }, sideNavItem.text);
            return null;
        })
    });
};
const $0ecd955324bfea13$export$1a35787d6353cf6a = ({ title: title, sideNavItems: sideNavItems })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
                id: "side-nav-desktop",
                "aria-label": intl.formatMessage({
                    id: 'hub.sidenav.desktop.label',
                    defaultMessage: `{hub_topics} desktop navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_19itkze7 _2rko1ylz _1yt4v47k _85i51wqb _4t3i1ns9"
                ]),
                style: {
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1tke1wqb _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
                id: "side-nav-tablet-mobile",
                "aria-label": intl.formatMessage({
                    id: 'hub.sidenav.mobile.label',
                    defaultMessage: `{hub_topics} mobile navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_dm25glyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$var$MobileExpandableNav, {
                    title: title,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                })
            })
        ]
    });
};
const $0ecd955324bfea13$var$desktopCss = null;
const $0ecd955324bfea13$var$tabletMobileCss = null;
const $0ecd955324bfea13$var$listCss = null;
const $0ecd955324bfea13$var$containerCss = null;
const $0ecd955324bfea13$var$desktopTitleCss = null;
const $0ecd955324bfea13$var$mobileIconCss = null;
const $0ecd955324bfea13$var$mobileExpandableButtonCss = null;
const $0ecd955324bfea13$var$mobileNavContentCss = null;
const $0ecd955324bfea13$var$mobileNavContentCollapsedCss = null;
const $0ecd955324bfea13$var$mobileInnerContentCss = null;

});
parcelRegister("35KAt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2405f9fef6522c08$var$_react = $2405f9fef6522c08$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2405f9fef6522c08$var$_baseNew = $2405f9fef6522c08$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $2405f9fef6522c08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2405f9fef6522c08$var$MinusIcon = (props)=>/*#__PURE__*/ $2405f9fef6522c08$var$_react.default.createElement($2405f9fef6522c08$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$2405f9fef6522c08$var$MinusIcon.displayName = 'MinusIcon';
var $2405f9fef6522c08$var$_default = module.exports.default = $2405f9fef6522c08$var$MinusIcon;

});

parcelRegister("50Va3", function(module, exports) {
$parcel$export(module.exports, "SideNavCollection", function () { return $b6213a9c990feedf$export$fe1fe92908738381; });
/* side-nav-collection.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $g3AHF = parcelRequire("g3AHF");

var $kbpa7 = parcelRequire("kbpa7");

var $7HoXo = parcelRequire("7HoXo");

var $hUjxd = parcelRequire("hUjxd");
const $b6213a9c990feedf$var$MAX_DEPTH = 2;
const $b6213a9c990feedf$export$fe1fe92908738381 = ({ collectionName: collectionName, depth: depth = 0, sideNavItems: sideNavItems })=>{
    // Recursively check if any child link (including in nested collections) is active
    const currRoute = (0, $hUjxd.getCurrRoute)();
    const checkItems = (items)=>{
        return items.some((item)=>{
            if (item.type === 'link') return currRoute === item.href;
            if (item.type === 'collection') return checkItems(item.sideNavItems);
            return false;
        });
    };
    const isExpanded = checkItems(sideNavItems);
    if (depth >= $b6213a9c990feedf$var$MAX_DEPTH) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _1e0c1txw _4cvr1h6o _1hoqm8mt _1x9y16gc _2yuyidpf",
            "_1q511hly _85i513kw _1qt71y8y"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_hv9tvx": (0, $6ZVlx.default)(depth === 0 ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"),
            "--_101944t": (0, $6ZVlx.default)(depth === 0 ? "var(--ds-space-200, 16px)" : "var(--ds-space-050, 4px)"),
            "--_1jm1u1b": (0, $6ZVlx.default)(depth === 0 ? 0 : "var(--ds-space-050, 4px)")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3AHF.Expand), {
            eventDataName: collectionName,
            actionSubject: "linkButton",
            label: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: depth === 0 ? 'h6' : 'body-md',
                style: {
                    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text')
                },
                children: collectionName
            }),
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_qtt8glyw _18s8ze3t _1yt4ze3t"
                ]),
                children: sideNavItems.map((sideNavItem)=>{
                    if (sideNavItem.type === 'collection') return /*#__PURE__*/ (0, $7VQPk.jsx)($b6213a9c990feedf$export$fe1fe92908738381, {
                        type: "collection",
                        collectionName: sideNavItem.collectionName,
                        sideNavItems: sideNavItem.sideNavItems,
                        depth: depth + 1
                    }, sideNavItem.collectionName);
                    if (sideNavItem.type === 'link') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7HoXo.SideNavLink), {
                        dataEventProps: sideNavItem.dataEventProps,
                        type: "link",
                        text: sideNavItem.text,
                        href: sideNavItem.href,
                        anchors: sideNavItem.anchors,
                        depth: depth + 1
                    }, sideNavItem.text);
                    return null;
                })
            })
        })
    }, collectionName);
};
const $b6213a9c990feedf$var$listStyleNoneCss = null;
const $b6213a9c990feedf$var$listItemCss = null;

});
parcelRegister("7HoXo", function(module, exports) {
$parcel$export(module.exports, "SideNavLink", function () { return $c9ec576db80f44f7$export$ed4b92678aaeea6b; });
/* side-nav-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hufYT = parcelRequire("hufYT");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $hUjxd = parcelRequire("hUjxd");
const $c9ec576db80f44f7$export$ed4b92678aaeea6b = ({ text: text, href: href, dataEventProps: dataEventProps, anchors: anchors, depth: depth = 0, isAnchorLink: isAnchorLink = false, isAnchorAtTop: isAnchorAtTop = false })=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(href);
    const { headingIdAtTop: headingIdAtTop } = (0, $hUjxd.useHeadingAtTop)(anchors);
    const currRoute = (0, $hUjxd.getCurrRoute)();
    const isActive = currRoute === href;
    const shouldShowIcon = isActive && !headingIdAtTop && !isAnchorLink || isAnchorAtTop;
    const shouldBold = isActive && !isAnchorLink || isAnchorAtTop;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _18s8ze3t _1yt4ze3t",
            "_1e0c1ule",
            depth === 0 && "_1rjcpxbi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                href: localizedHref,
                ...dataEventProps,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1ygbm8mt _1ah316gc",
                    depth > 0 && "_1rjcu2gc",
                    !isActive && !isAnchorAtTop && "_ll8p5hrz"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1tcg _4t3i1tcg _1e0c1txw _1o9zidpf _4cvr1h6o _1bah1h6o _12l21b66 _1wpz1y6m"
                        ]),
                        children: shouldShowIcon && /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hufYT))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: depth === 0 || shouldBold ? 'h6' : 'body-md',
                        style: {
                            fontFamily: (0, $kbpa7.wacToken)('font.charlie.text')
                        },
                        children: text
                    })
                ]
            }),
            anchors && anchors.length > 0 && isActive && /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_qtt8glyw _18s8ze3t _1yt4ze3t",
                    "_bozgxy5q"
                ]),
                children: anchors.map((anchor)=>{
                    const anchorIsAtTop = headingIdAtTop === anchor.id;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c9ec576db80f44f7$export$ed4b92678aaeea6b, {
                        dataEventProps: dataEventProps,
                        type: "link",
                        href: `${localizedHref}#${anchor.id}`,
                        text: anchor.text,
                        depth: depth + 1,
                        isAnchorLink: true,
                        isAnchorAtTop: anchorIsAtTop
                    }, anchor.id);
                })
            })
        ]
    });
};
const $c9ec576db80f44f7$var$listStyleNoneCss = null;
const $c9ec576db80f44f7$var$listItemCss = null;
const $c9ec576db80f44f7$var$navLinkCss = null;
const $c9ec576db80f44f7$var$navLinkHoverCss = null;
const $c9ec576db80f44f7$var$subLevelLinkCss = null;
const $c9ec576db80f44f7$var$dotContainerCss = null;

});
parcelRegister("hufYT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::91b7b1dd505c61eb66599e7102bdd558>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbb1a286b256a7f9$var$_react = $cbb1a286b256a7f9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cbb1a286b256a7f9$var$_baseNew = $cbb1a286b256a7f9$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cbb1a286b256a7f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightExtraLarge".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing the thickest border stroke width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbb1a286b256a7f9$var$StrokeWeightExtraLargeIcon = (props)=>/*#__PURE__*/ $cbb1a286b256a7f9$var$_react.default.createElement($cbb1a286b256a7f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0" clip-rule="evenodd"/>`
    }, props));
$cbb1a286b256a7f9$var$StrokeWeightExtraLargeIcon.displayName = 'StrokeWeightExtraLargeIcon';
var $cbb1a286b256a7f9$var$_default = module.exports.default = $cbb1a286b256a7f9$var$StrokeWeightExtraLargeIcon;

});

parcelRegister("hUjxd", function(module, exports) {
$parcel$export(module.exports, "getCurrRoute", function () { return $c6090ca8172758e6$export$846018c5dc1df5c3; });
$parcel$export(module.exports, "useHeadingAtTop", function () { return $c6090ca8172758e6$export$ff897c2042dc87d8; });

var $1oC0p = parcelRequire("1oC0p");

var $3fFrT = parcelRequire("3fFrT");
const $c6090ca8172758e6$export$846018c5dc1df5c3 = ()=>{
    let currRoute = window.location.pathname;
    if (currRoute === '/uniform-preview') {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const pathParam = urlParams.get('path');
        currRoute = pathParam ? decodeURIComponent(pathParam) : '';
    }
    // Remove locale
    for (const locale of (0, $3fFrT.LOCALES))if (currRoute.startsWith(`/${locale}/`)) {
        currRoute = currRoute.slice(`/${locale}`.length);
        break;
    }
    return currRoute;
};
const $c6090ca8172758e6$export$ff897c2042dc87d8 = (anchors)=>{
    const [headingIdAtTop, setHeadingIdAtTop] = (0, $1oC0p.useState)(null);
    const [validAnchorIds, setValidAnchorIds] = (0, $1oC0p.useState)(new Set());
    const headingIdRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const bodyContent = document.getElementById('body-content');
        if (!anchors || anchors.length === 0 || !bodyContent) {
            setValidAnchorIds((prevValidIds)=>{
                if (prevValidIds.size > 0) return new Set();
                return prevValidIds;
            });
            return;
        }
        // Handle scroll to anchored section
        document.documentElement.style.scrollBehavior = 'smooth';
        const headerHeightStr = getComputedStyle(document.documentElement).getPropertyValue('--wae-header-height').trim();
        document.documentElement.style.scrollPaddingTop = headerHeightStr || '80px';
        // Used below to calculate distance from top of viewport
        const headerHeight = parseInt(headerHeightStr.replace('px', ''), 10) || 80;
        const anchorHeadings = anchors.map((anchor)=>document.getElementById(`${anchor.id}`)).filter((heading)=>heading instanceof HTMLElement);
        // Check which heading is at the top of the viewport
        const checkHeadingAtTop = ()=>{
            const viewportTop = window.scrollY + headerHeight;
            let headingAtTop = null;
            for (const heading of anchorHeadings){
                const rect = heading?.getBoundingClientRect();
                const headingTop = window.scrollY + (rect?.top ?? 0);
                if (headingTop >= viewportTop - 100 && headingTop <= viewportTop + 100) headingAtTop = heading;
            }
            if (headingAtTop) {
                const newId = headingAtTop.id;
                if (newId !== headingIdRef.current) {
                    headingIdRef.current = newId;
                    setHeadingIdAtTop(newId);
                }
            }
        };
        // Create intersection observer to detect when headings reach the top
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const rect = entry.boundingClientRect;
                    const viewportTop = headerHeight;
                    // Check if heading is at the top of the viewport (within 100px)
                    if (rect.top >= viewportTop - 100 && rect.top <= viewportTop + 100) {
                        const id = entry.target.id;
                        if (id !== headingIdRef.current) {
                            headingIdRef.current = id;
                            setHeadingIdAtTop(id);
                        }
                    }
                }
            });
        }, {
            root: null,
            rootMargin: `${-headerHeight}px 0px 0px 0px`,
            threshold: [
                0,
                0.1,
                0.5,
                0.9,
                1
            ]
        });
        // Observe all headings
        anchorHeadings.forEach((heading)=>observer.observe(heading));
        // Scroll to anchor element
        const scrollToAnchor = (hash)=>{
            if (!hash) return;
            const targetHeading = anchorHeadings.find((h)=>h.id === hash);
            if (targetHeading) // Use requestAnimationFrame to ensure DOM is ready
            requestAnimationFrame(()=>{
                targetHeading.scrollIntoView({
                    behavior: 'smooth'
                });
            });
        };
        // Check on scroll
        const handleScroll = ()=>{
            checkHeadingAtTop();
        };
        // Handle hash changes (e.g., when clicking anchor links)
        const handleHashChange = ()=>{
            const hash = window.location.hash.slice(1); // Remove '#'
            scrollToAnchor(hash);
        };
        // Initial check
        checkHeadingAtTop();
        // Scroll to anchor on initial page load if hash is present
        const initialHash = window.location.hash.slice(1);
        if (initialHash) // Use a small timeout to ensure page is fully rendered
        setTimeout(()=>{
            scrollToAnchor(initialHash);
        }, 100);
        window.addEventListener('scroll', handleScroll, {
            passive: true
        });
        window.addEventListener('resize', handleScroll, {
            passive: true
        });
        window.addEventListener('hashchange', handleHashChange);
        // Cleanup
        return ()=>{
            anchorHeadings.forEach((heading)=>observer.unobserve(heading));
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
            window.removeEventListener('hashchange', handleHashChange);
            document.documentElement.style.scrollBehavior = '';
            document.documentElement.style.scrollPaddingTop = '';
        };
    }, [
        anchors
    ]);
    // Update URL anchor when heading changes
    (0, $1oC0p.useEffect)(()=>{
        if (headingIdAtTop) {
            const currentHash = window.location.hash.slice(1); // Remove '#'
            if (currentHash !== headingIdAtTop) {
                const newUrl = `${window.location.pathname}${window.location.search}#${headingIdAtTop}`;
                window.history.replaceState(null, '', newUrl); // update URL without adding to history
            }
        }
    }, [
        headingIdAtTop
    ]);
    return {
        headingIdAtTop: headingIdAtTop,
        validAnchorIds: validAnchorIds
    };
};

});




parcelRegister("j5L4q", function(module, exports) {
$parcel$export(module.exports, "transformNavItemData", function () { return $ec6d0de2a0c3a497$export$bbcc1b49937dee22; });
const $ec6d0de2a0c3a497$export$bbcc1b49937dee22 = (slots)=>{
    return slots.map((childComponent)=>{
        const childProps = childComponent.parameters ?? {};
        if (childComponent.type === 'sideNavLink') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const anchors = childProps['anchors']?.value;
            return {
                type: 'link',
                text: childProps['text']?.value,
                href: childProps['href']?.value,
                anchors: anchors ? anchors.map((anchor)=>{
                    return {
                        text: anchor?.fields?.text?.value,
                        id: anchor?.fields?.id?.value
                    };
                }) : null,
                dataEventProps: {
                    'data-product-key': 'uniform',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'sideNav',
                    'data-event': 'clicked'
                }
            };
        }
        if (childComponent.type === 'sideNavCollection') return {
            type: 'collection',
            collectionName: childProps['collectionName']?.value,
            sideNavItems: $ec6d0de2a0c3a497$export$bbcc1b49937dee22(childComponent.slots?.['sideNavItems'])
        };
        return;
    });
};

});


parcelRegister("3DCiB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6e00143a5b9453fa$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $50Va3 = parcelRequire("50Va3");

var $j5L4q = parcelRequire("j5L4q");
const $6e00143a5b9453fa$var$UniformSideNavCollection = ({ component: component })=>{
    const slotItems = component.slots?.['sideNavItems'] ?? null;
    if (!slotItems) return;
    const sideNavItems = (0, $j5L4q.transformNavItemData)(slotItems);
    const props = {
        type: 'collection',
        collectionName: component.parameters?.['collectionName']?.value,
        sideNavItems: sideNavItems
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50Va3.SideNavCollection), {
        ...props
    });
};
var $6e00143a5b9453fa$export$2e2bcd8739ae039 = $6e00143a5b9453fa$var$UniformSideNavCollection;

});

parcelRegister("acEyk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d6c9de186a63542c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $7HoXo = parcelRequire("7HoXo");
const $d6c9de186a63542c$var$UniformSideNavLink = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7HoXo.SideNavLink), {
        ...props,
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event-component': 'linkButton',
            'data-event-container': 'sideNav',
            'data-event': 'clicked'
        }
    });
};
var $d6c9de186a63542c$export$2e2bcd8739ae039 = $d6c9de186a63542c$var$UniformSideNavLink;

});

parcelRegister("ies6q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8d6774ae7c2be16$export$2e2bcd8739ae039; });
/* sign-up-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $6KUQg = parcelRequire("6KUQg");

var $irRyj = parcelRequire("irRyj");

var $32ARy = parcelRequire("32ARy");

var $kCjSr = parcelRequire("kCjSr");

var $kbpa7 = parcelRequire("kbpa7");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $1ka2O = parcelRequire("1ka2O");

var $eRzlV = parcelRequire("eRzlV");

var $i4BST = parcelRequire("i4BST");

var $a0YMz = parcelRequire("a0YMz");

var $bry8i = parcelRequire("bry8i");

var $2SlL9 = parcelRequire("2SlL9");
const $b8d6774ae7c2be16$export$143e70f94b3fb702 = (providerList)=>{
    return providerList.reduce((previous, key)=>({
            ...previous,
            [key.toLowerCase()]: key
        }), {});
};
const $b8d6774ae7c2be16$var$SERVICE_COLLECTION_COBRANDING = 'wac--service-collection-jsm-cobranding';
const $b8d6774ae7c2be16$var$JSM_SERVICE_MANAGEMENT_PATH = '/software/jira/service-management';
const $b8d6774ae7c2be16$var$UniformSignUpForm = ({ socialProviders: socialProviders, helpText: helpText, textColor: textColor = 'default', inline: inline = false, inlineSubmitVersion: inlineSubmitVersion, continueUrl: continueUrl })=>{
    const intl = (0, $8e22h.default)();
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const location = (0, $1ka2O.useLocation)();
    const playgroundContinueUrl = (0, $kCjSr.useJsmPlaygroundSignupHref)(continueUrl ?? '');
    const isJsmServiceManagementPage = location.pathname.includes($b8d6774ae7c2be16$var$JSM_SERVICE_MANAGEMENT_PATH);
    const getContinueUrl = playgroundContinueUrl ? ()=>playgroundContinueUrl.startsWith('/') ? (0, $eRzlV.getWacIntegrationUrl)() + playgroundContinueUrl : playgroundContinueUrl : undefined;
    const defaultHelpText = intl.formatMessage({
        id: 'signupForm.accountCreation.helperTextTeam26',
        defaultMessage: 'Use a work email to find teammates and get access to Rovo AI'
    });
    const configuredHelpText = helpText?.trim();
    const emailHelpText = configuredHelpText || defaultHelpText;
    const sparkJiraPtEmbeddedSignup = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).sparkJiraPtEmbeddedSignup);
    const isEmbeddedSignupEnabled = sparkJiraPtEmbeddedSignup.type === 'enrolled' && sparkJiraPtEmbeddedSignup.value === true;
    // Uniform Canvas preview has no Statsig enrollment — show embedded signup when selected
    const isUniformPreview = location.pathname.includes('/uniform-preview');
    const useInlineInput = inlineSubmitVersion === 'inlineSubmit';
    const wantsEmbeddedSignup = inlineSubmitVersion === 'embeddedSignup';
    const useEmbeddedSignup = wantsEmbeddedSignup && (isEmbeddedSignupEnabled || isUniformPreview);
    const useInlineSocial = inline || inlineSubmitVersion === 'inlineSocialSubmit' || wantsEmbeddedSignup;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            textColor === 'light' && "_syaz1afi"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
            identityCobranding: isJsmServiceManagementPage ? $b8d6774ae7c2be16$var$SERVICE_COLLECTION_COBRANDING : undefined,
            getContinueUrl: getContinueUrl,
            Login: null,
            Separator: useInlineSocial ? null : undefined,
            Error: useInlineInput || useInlineSocial ? null : undefined,
            Input: useInlineInput ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2SlL9.InlineInputSubmit), {
                helpText: configuredHelpText,
                darkMode: textColor === 'light'
            }) : useEmbeddedSignup ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a0YMz.InlineInputSubmitSocialEmbeddedSignup), {}) : useInlineSocial ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bry8i.InlineInputSubmitSocial), {
                helpText: configuredHelpText
            }) : isWacRefresh ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {
                helpText: emailHelpText
            }) : undefined,
            Submit: useInlineInput || useInlineSocial ? null : undefined,
            Social: useInlineSocial ? null : socialProviders?.length ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    useInlineInput && "_jq8g1ady"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
                    providers: $b8d6774ae7c2be16$export$143e70f94b3fb702(socialProviders)
                })
            }) : undefined
        })
    });
};
var $b8d6774ae7c2be16$export$2e2bcd8739ae039 = $b8d6774ae7c2be16$var$UniformSignUpForm;
const $b8d6774ae7c2be16$var$socialButtonHeightCss = null;
const $b8d6774ae7c2be16$var$lightTextColorCss = null;

});
parcelRegister("a0YMz", function(module, exports) {
$parcel$export(module.exports, "InlineInputSubmitSocialEmbeddedSignup", function () { return $59d349d5463f92aa$export$9fc0c10e8a3ff0c4; });
/* inline-input-submit-social-embedded-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $cGEBM = parcelRequire("cGEBM");

var $gM7M2 = parcelRequire("gM7M2");

var $iTHVN = parcelRequire("iTHVN");

var $kbpa7 = parcelRequire("kbpa7");

var $jquiH = parcelRequire("jquiH");

var $5UiwV = parcelRequire("5UiwV");

var $2BAOV = parcelRequire("2BAOV");

var $iMoR7 = parcelRequire("iMoR7");
/** Atlaskit `media.above.md` — horizontal desktop layout at 1024px+ */ const $59d349d5463f92aa$var$DESKTOP_MQ = '(min-width: 64rem)';
const $59d349d5463f92aa$export$9fc0c10e8a3ff0c4 = ()=>{
    const intl = (0, $8e22h.default)();
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const [isDesktop, setIsDesktop] = (0, $1oC0p.useState)(()=>typeof window !== 'undefined' ? window.matchMedia($59d349d5463f92aa$var$DESKTOP_MQ).matches : false);
    const errorMessageText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.invalidEmail',
        defaultMessage: 'Please enter a valid email address.'
    });
    const labelText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.enterWorkEmail',
        defaultMessage: 'Enter work email'
    });
    (0, $1oC0p.useEffect)(()=>{
        const mediaQuery = window.matchMedia($59d349d5463f92aa$var$DESKTOP_MQ);
        const onChange = ()=>setIsDesktop(mediaQuery.matches);
        onChange();
        mediaQuery.addEventListener('change', onChange);
        return ()=>mediaQuery.removeEventListener('change', onChange);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (!email.trim()) {
            setValid(undefined);
            setIsEmailValid(false);
            return;
        }
        const valid = (0, $gM7M2.emailIsValid)(email);
        if (!valid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(valid);
        setIsEmailValid(valid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    const fields = {
        email: email,
        setEmail: setEmail,
        isValid: isValid,
        errorMessageText: errorMessageText
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "inline-input-submit-social-embedded-signup",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _zulp1b66"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: "inline_email_embedded_signup_input",
                className: (0, $2jatx.default)([
                    "_19itidpf _ogtohxbz _4t3it94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1bsbt94y _o5721q9c"
                ]),
                children: labelText
            }),
            isDesktop ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($59d349d5463f92aa$var$DesktopForm, {
                        ...fields
                    }),
                    isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        role: "alert",
                        className: (0, $2jatx.default)([
                            "_syaz1tmw _1wybepq8 _vwz4bs82 _ahbq1tcg _12l21tcg"
                        ]),
                        style: {
                            "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                        },
                        children: errorMessageText
                    }) : null
                ]
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)($59d349d5463f92aa$var$StackedForm, {
                ...fields
            })
        ]
    });
};
const $59d349d5463f92aa$var$DesktopForm = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wpz1y6m _1bsb6chn _p12f1qop _4t3i1wup _1e0c1txw _4cvr1h6o _zulp19bv _bfhkdkka _2rko53f4 _vchhusvi _1yt4u2gc"
        ]),
        style: {
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _4cvr1h6o _zulpu2gc _1bsb1ris _1ul9ufrr _4t3i18e8 _bfhk1afi _19itn6xs _16qs1s9l _2rko12am _vchhusvi _1rjc1y44 _y4ti1y44 _bozgpxbi",
                    props.isValid === undefined && "_3fmv1v1w _1eviglyw",
                    props.isValid === false && "_1h6d1bqt _16qsglyw",
                    props.isValid === true && "_1h6d1mps _16qsglyw"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_vchhusvi _11ztmzrp _fkwnmzrp _16krmzrp _mhuumzrp _1rufagmp _1qo3agmp _1y95agmp _jrruagmp _7hwbgrf3 _1g96grf3 _tuhhgrf3 _1lzdgrf3 _ta1nagmp _1pksagmp _d83fagmp _kxb5agmp _18dqaq80 _10pbaq80 _1d6vaq80 _uk6paq80 _ahub1osq _9m3z1osq _4r0n1osq _1q7x1osq _125x1gpt _o6k11gpt _1mye1gpt _yizh1nn1 _1r9h1nn1 _wv8r1nn1 _1cis16s9 _1fp816s9 _11ms16s9 _62vcgrf3 _k369grf3 _1716grf3 _1u33grf3 _s3rzgrf3 _gf89grf3 _rocqagmp _tp17agmp _k1x1agmp _xmji1snc _18hy1snc _1g951snc _gxxuagmp _18mlagmp _1blmagmp _34ir10yn _dqpe10yn _iakj10yn _5ce61x3z _1wb71gpt",
                            "_16jlkb7n _1o9zidpf _i0dl1m00 _4t3i1osq _1ul93xl8 _omtmidpf _6ndb1osq _1yzy15vq _bgrh15vq _509t1l2s _1ru31q9c"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jquiH.InlineInputEmbeddedSignup), {
                            ...props
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1o9zidpf _1e0c1txw _4cvr1h6o _jq8gande _d4lfande _1hbsgrf3 _1u71grf3 _y2qtgrf3 _fl8bgrf3 _187zagmp _10gv1h90 _14hp1h90 _105q1f52 _1s3gns44 _wlxp1j3c"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2BAOV.InlineSubmit), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _nzz57vkz _odpm16s9 _13t31v5p",
                    "_1o9zidpf _o5721q9c"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5UiwV.InlineSeparator), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_7diruftu _stfg5ouf _zs121fu0 _d32v1x3z _1o7p1gpt _1q9tl8b6 _1jmq1a66 _1r4a16s9 _1hbsgrf3 _1u71grf3 _y2qtgrf3 _fl8bgrf3 _187zagmp _1wtn1bt6 _fb25a982 _14hp1h90 _6pup1iji _1ll7uftu _qprfuftu _1agt1yb6 _1xcs1yb6 _z29h11zf _wlxp11zf _1pv01snc _1m1b1snc _qh55agmp _lt2aagmp _ph3k10yn _1twe10yn _1752gktf _erubgktf _xwbjgktf _w8l5gktf",
                    "_1bsb1wug _1o9zidpf _1e0c1txw _4cvr1h6o _jq8gmuma _d4lfmuma"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iMoR7.SocialButton), {})
            })
        ]
    });
const $59d349d5463f92aa$var$StackedForm = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1ul91mjv _p12fjsxk _1e0c1txw _2lx21bp4 _4cvr1fhb _zulputpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1fhb _zulp1b66 _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1fhb _1bsb1osq",
                            props.isValid === undefined && "_fora1v1w _uae6glyw",
                            props.isValid === false && "_1km11bqt _stnyglyw",
                            props.isValid === true && "_1km11mps _stnyglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_vchhusvi _11ztmzrp _fkwnmzrp _16krmzrp _mhuumzrp _1rufagmp _1qo3agmp _1y95agmp _jrruagmp _7hwbgrf3 _1g96grf3 _tuhhgrf3 _1lzdgrf3 _ta1nagmp _1pksagmp _d83fagmp _kxb5agmp _18dqaq80 _10pbaq80 _1d6vaq80 _uk6paq80 _ahub1osq _9m3z1osq _4r0n1osq _1q7x1osq _125x1gpt _o6k11gpt _1mye1gpt _yizh1nn1 _1r9h1nn1 _wv8r1nn1 _1cis16s9 _1fp816s9 _11ms16s9 _62vcgrf3 _k369grf3 _1716grf3 _1u33grf3 _s3rzgrf3 _gf89grf3 _rocqagmp _tp17agmp _k1x1agmp _xmji1snc _18hy1snc _1g951snc _gxxuagmp _18mlagmp _1blmagmp _34ir10yn _dqpe10yn _iakj10yn _5ce61x3z _1wb71gpt",
                                "_1bsb1osq _4t3i1a70 _bfhk1afi _19it14ak _16qs1s9l _2rko12am _vchhusvi _bozgpxbi _y4tipxbi"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jquiH.InlineInputEmbeddedSignup), {
                                ...props
                            })
                        })
                    }),
                    props.isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        role: "alert",
                        className: (0, $2jatx.default)([
                            "_syaz1tmw _1wybepq8 _vwz4bs82 _ahbqpxbi"
                        ]),
                        style: {
                            "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                        },
                        children: props.errorMessageText
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _jq8gande _d4lfande _1hbsgrf3 _1u71grf3 _y2qtgrf3 _fl8bgrf3 _187zaq80 _14hpaq80 _105q1f52 _1s3gud7t _wlxp147i"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2BAOV.InlineSubmit), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_7diruftu _stfg5ouf _zs121fu0 _d32v1x3z _1o7p1gpt _1q9tl8b6 _1jmq1a66 _1r4a16s9 _1hbsgrf3 _1u71grf3 _y2qtgrf3 _fl8bgrf3 _187zagmp _1wtn1bt6 _fb25a982 _14hp1h90 _6pup1iji _1ll7uftu _qprfuftu _1agt1yb6 _1xcs1yb6 _z29h11zf _wlxp11zf _1pv01snc _1m1b1snc _qh55agmp _lt2aagmp _ph3k10yn _1twe10yn _1752gktf _erubgktf _xwbjgktf _w8l5gktf",
                    "_1bsb1osq _1e0c1txw _jq8gande _d4lfande _14hpaq80 _187zaq80"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iMoR7.SocialButton), {
                    label: "Continue with Google"
                })
            })
        ]
    });
const $59d349d5463f92aa$var$containerCss = null;
const $59d349d5463f92aa$var$srOnlyCss = null;
/** Desktop: min 680 / max 905; height = field 53 + outer pad 8×2 */ const $59d349d5463f92aa$var$desktopLayoutCss = null;
/** Stacked: min 300 / max 490 */ const $59d349d5463f92aa$var$stackedLayoutCss = null;
const $59d349d5463f92aa$var$stackedFieldGroupCss = null;
const $59d349d5463f92aa$var$desktopFieldCss = null;
const $59d349d5463f92aa$var$stackedFieldCss = null;
const $59d349d5463f92aa$var$desktopFieldFocusCss = null;
const $59d349d5463f92aa$var$stackedFieldFocusCss = null;
const $59d349d5463f92aa$var$desktopFieldInvalidCss = null;
const $59d349d5463f92aa$var$stackedFieldInvalidCss = null;
const $59d349d5463f92aa$var$desktopFieldValidCss = null;
const $59d349d5463f92aa$var$stackedFieldValidCss = null;
/** Kill Atlaskit TextField chrome — field wrappers own the ring */ const $59d349d5463f92aa$var$fieldInputChromeCss = null;
const $59d349d5463f92aa$var$desktopInputCss = null;
const $59d349d5463f92aa$var$stackedInputCss = null;
/** Nested desktop: white fill through pad+border; outline covers field edge */ const $59d349d5463f92aa$var$desktopSubmitFocusCss = {
    outline: `2px solid ${"var(--ds-border-focused, #4688EC)"} !important`,
    outlineOffset: '4px !important',
    boxShadow: `0 0 0 6px ${(0, $kbpa7.wacToken)('color.neutral.light0')} !important`
};
/** Stacked: standard ADS focus (button is not nested in the field) */ const $59d349d5463f92aa$var$stackedSubmitFocusCss = {
    outline: `2px solid ${"var(--ds-border-focused, #4688EC)"} !important`,
    outlineOffset: '2px !important',
    boxShadow: `0 0 0 2px ${(0, $kbpa7.wacToken)('color.neutral.light0')} !important`
};
const $59d349d5463f92aa$var$desktopSubmitCss = null;
const $59d349d5463f92aa$var$stackedSubmitCss = null;
const $59d349d5463f92aa$var$separatorCss = null;
const $59d349d5463f92aa$var$desktopSeparatorCss = null;
const $59d349d5463f92aa$var$socialButtonCss = null;
const $59d349d5463f92aa$var$desktopSocialCss = null;
const $59d349d5463f92aa$var$stackedSocialCss = null;
const $59d349d5463f92aa$var$errorTextCss = {
    color: "var(--ds-text-danger, #AE2E24)",
    fontSize: (0, $iTHVN.fontSize).xs,
    lineHeight: 1.5
};
const $59d349d5463f92aa$var$errorCss = null;
const $59d349d5463f92aa$var$stackedErrorCss = null;

});
parcelRegister("jquiH", function(module, exports) {
$parcel$export(module.exports, "InlineInputEmbeddedSignup", function () { return $1df4914771cff87a$export$28ef78648af81365; });
/* inline-input-embedded-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8IRDn = parcelRequire("8IRDn");

var $5J9KJ = parcelRequire("5J9KJ");

var $8mdo4 = parcelRequire("8mdo4");

var $8KJ2x = parcelRequire("8KJ2x");

var $cGEBM = parcelRequire("cGEBM");

var $kbpa7 = parcelRequire("kbpa7");
const $1df4914771cff87a$export$28ef78648af81365 = ({ email: email, setEmail: setEmail, isValid: isValid, errorMessageText: errorMessageText })=>{
    // Validation (isValid / setIsEmailValid) is owned by InlineInputSubmitSocialEmbeddedSignup
    const { setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const intl = (0, $8e22h.default)();
    const placeholderText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.enterWorkEmail',
        defaultMessage: 'Enter work email'
    });
    const validMessage = intl.formatMessage({
        id: 'gwp.accountSignin.validEmailIcon',
        defaultMessage: 'Email is valid'
    });
    // Border/focus/valid/invalid chrome lives on InlineInputSubmitSocialEmbeddedSignup field wrappers
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3i1osq _vchhusvi _1bsb1osq _1e0c1txw _4cvr1h6o _7yjtidpf _ldgnidpf _un3pidpf _29hzidpf _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _k8em1osq _bhl91osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: "",
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _4t3i1osq _1bsb1osq _hbmn1rnp _1m2akb7n _rn4vkb7n _e38j1wug _eedjidpf _1dp61osq _v5rg15vq _nzdf15vq _a0twmzrp _1dxgglyw _xuhridpf _1vm6agmp _1j8q1osq _pytk1osq _5hv91osq _1rwq1j28 _psgk1pfd _1heuz4z1 _125xf6fq _1yzy15vq _bgrh15vq _62vcgrf3 _509t1l2s _1ru31q9c _yizhowjs _ixrd1txw _hlcb1h6o _5ce6inbi _1wb7f6fq _1k9xmzrp _89vmmzrp _tp17agmp _k1x1agmp _18hy1snc _1g951snc _18mlagmp _1blmagmp _dqpe10yn _iakj10yn _20kcagmp _6kab1h6o",
                        isValid !== undefined && "_1u33grf3"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                        "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            "aria-hidden": "true",
                            className: (0, $2jatx.default)([
                                "_1e0c116y _1o9zidpf _12l2u2gc _syaz1pfd _1752f6fq _w8l5f6fq"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8IRDn))), {
                                label: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                            ...fieldProps,
                            autoComplete: "email",
                            id: "inline_email_embedded_signup_input",
                            "aria-label": placeholderText,
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        }),
                        isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1wpz1h6o _1o9zidpf _kqswh2mm _1pbykb7n _bfhk1afi _2rko1ssb _vwz4idpf _1752f6fq _w8l5f6fq",
                                "_syazs4qr"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5J9KJ))), {
                                label: errorMessageText
                            })
                        }) : isValid === true ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1wpz1h6o _1o9zidpf _kqswh2mm _1pbykb7n _bfhk1afi _2rko1ssb _vwz4idpf _1752f6fq _w8l5f6fq",
                                "_1nj181oq"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8mdo4))), {
                                label: validMessage
                            })
                        }) : null
                    ]
                })
        })
    });
};
const $1df4914771cff87a$var$containerCss = null;
const $1df4914771cff87a$var$inlineInputCss = null;
/** Keep 1Password/autofill tight to the status icon */ const $1df4914771cff87a$var$inlineInputWithStatusCss = null;
const $1df4914771cff87a$var$emailIconCss = null;
/**
 * Figma status icons: 18×18, no extra end padding (field chrome supplies 16px).
 * White background covers autofill when icons sit close.
 */ const $1df4914771cff87a$var$iconCss = null;
const $1df4914771cff87a$var$invalidIconCss = null;
const $1df4914771cff87a$var$validIconCss = null;

});

parcelRegister("5UiwV", function(module, exports) {
$parcel$export(module.exports, "InlineSeparator", function () { return $a6dd9f4a57acb821$export$55fab221c0b96fcc; });
/* inline-separator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
const $a6dd9f4a57acb821$export$55fab221c0b96fcc = ()=>{
    const intl = (0, $8e22h.default)();
    const separatorText = intl.formatMessage({
        id: 'embeddedSignup.separator.or',
        defaultMessage: 'or'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1wpz1h6o _syaz1pfd _1o9zidpf _ect4z4z1 _1wybf6fq _vwz41f4h _y3gn1h6o _o5721q9c"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
        },
        children: separatorText
    });
};
const $a6dd9f4a57acb821$var$inlineSeparatorCss = null;

});

parcelRegister("2BAOV", function(module, exports) {
$parcel$export(module.exports, "InlineSubmit", function () { return $ccddc125f5ee162e$export$7839993e4eae1cc3; });
/* inline-submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $53VCz = parcelRequire("53VCz");

var $cGEBM = parcelRequire("cGEBM");

var $lqyi6 = parcelRequire("lqyi6");
const $ccddc125f5ee162e$export$7839993e4eae1cc3 = ({ showArrow: showArrow = false } = {})=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $cGEBM.useAccountCreationContext)();
    const buttonText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.submit',
        defaultMessage: 'Sign up'
    });
    const ariaLabel = intl.formatMessage({
        id: 'WacSignupForm.socialSignUpButtonSignUpWithEmail',
        defaultMessage: 'Sign up with email'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lqyi6.Button), {
        type: "submit",
        disabled: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        "aria-label": ariaLabel,
        "data-testid": "embedded-signup-submit",
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event': 'clicked',
            'data-event-component': 'button',
            'data-event-container': 'signup',
            'data-label': buttonText,
            'data-label-english': 'Sign up'
        },
        className: (0, $2jatx.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _ect41kw7 _1wybf6fq _k48p1nn1 _zulpu2gc _4t3ickbl _1bah1h6o _1ul91wug _o5721q9c _1bsb1ns9 _15fl1n1a _1d2w1n1a _1svy1n1a _seovidpf _1rfm1osq _1rkb1osq"
        ]),
        children: [
            buttonText,
            showArrow ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_1e0c116y _17527vkz _w8l57vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53VCz))), {
                    label: ""
                })
            }) : null
        ]
    });
};
const $ccddc125f5ee162e$var$buttonCss = null;
const $ccddc125f5ee162e$var$arrowCss = null;

});

parcelRegister("iMoR7", function(module, exports) {
$parcel$export(module.exports, "SocialButton", function () { return $0d3eb5f998e1413a$export$6d89b1d283cda84a; });
/* social-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $jUqeL = parcelRequire("jUqeL");

var $cGEBM = parcelRequire("cGEBM");

var $lqyi6 = parcelRequire("lqyi6");

var $bNzAT = parcelRequire("bNzAT");
const $0d3eb5f998e1413a$export$6d89b1d283cda84a = ({ label: label = 'Google' })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $cGEBM.useAccountCreationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lqyi6.Button), {
        role: "link",
        "aria-label": intl.formatMessage({
            id: 'social.label.signup',
            defaultMessage: 'sign up with {provider}'
        }, {
            provider: 'Google'
        }),
        onClick: ()=>onClickSocialButton('google'),
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event': 'clicked',
            'data-event-component': 'button',
            'data-event-container': 'signup',
            'data-label': 'sign up with Google',
            'data-label-english': 'sign up with Google'
        },
        className: (0, $2jatx.default)([
            "_4cvr1h6o _bfhk1afi _19itlfd3 _vchhusvi _syazd34b _1e0c1txw _ect41kw7 _1wybf6fq _k48p1nn1 _zulp1kwk _4t3ickbl _1bah1h6o _1ul91wug _o5721q9c _1bsb1ns9 _erubf6fq _xwbjf6fq _1rfm1osq _1rkb1osq"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUqeL.ProviderLogo), {
                logo: "google"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: label
            })
        ]
    });
};
const $0d3eb5f998e1413a$var$buttonCss = null;

});


parcelRegister("bry8i", function(module, exports) {
$parcel$export(module.exports, "InlineInputSubmitSocial", function () { return $cf45e524158d5f0c$export$4fe054d3cd5243b3; });
/* inline-input-submit-social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $cGEBM = parcelRequire("cGEBM");

var $gM7M2 = parcelRequire("gM7M2");

var $iTHVN = parcelRequire("iTHVN");

var $kbpa7 = parcelRequire("kbpa7");

var $ieOG3 = parcelRequire("ieOG3");

var $5UiwV = parcelRequire("5UiwV");

var $2BAOV = parcelRequire("2BAOV");

var $iMoR7 = parcelRequire("iMoR7");
const $cf45e524158d5f0c$export$4fe054d3cd5243b3 = ({ helpText: helpText })=>{
    const intl = (0, $8e22h.default)();
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const defaultHelpText = intl.formatMessage({
        id: 'signupForm.accountCreation.helperTextTeam26',
        defaultMessage: 'Use a work email to find teammates and get access to Rovo AI'
    });
    const emailHelpText = helpText?.trim() || defaultHelpText;
    const errorMessageText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.invalidEmail',
        defaultMessage: 'Please enter a valid email address.'
    });
    const placeholderText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.workEmail',
        defaultMessage: 'Work email'
    });
    (0, $1oC0p.useEffect)(()=>{
        const valid = (0, $gM7M2.emailIsValid)(email);
        if (!valid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(valid);
        setIsEmailValid(valid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _zulp1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                className: (0, $2jatx.default)([
                    "_syaz1kw7 _ect4z4z1 _k48powjs _1wybdlk8 _13ioglyw",
                    "_ahbq1tcg _12l21tcg"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: placeholderText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c1txw _zulppxbi _1bsb1osq _1gde1bp4 _8164utpp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _d4lf1h90 _1xlockbl _dwk3usvi _q8t51h6o _1jb31afi _z21jkze7 _1kkm1ylp _1lp7vrvc _19wgutpp",
                            isValid === undefined && "_zvlo1c1e _idghuuyu",
                            isValid === false && "_xqvj1d19 _nxbcp6ku",
                            isValid === true && "_xqvj81oq _nxbc1g3m"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                            "--_p6wr00": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue600')),
                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                            "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1bsb1osq _89vyidpf _5rvh1wug _32nkidpf _wws01wug"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ieOG3.InlineInput), {
                                        email: email,
                                        setEmail: setEmail,
                                        isValid: isValid,
                                        setValid: setValid,
                                        errorMessageText: errorMessageText
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_ahbq1tcg _12l21tcg",
                                            "_476d1y44"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                                htmlFor: "inline_email_embedded_signup_input",
                                                className: (0, $2jatx.default)([
                                                    "_ect4z4z1 _1wyb1crf _vwz4bs82 _1pfhi2wt _tzy4txnc",
                                                    "_181nglyw"
                                                ]),
                                                style: {
                                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                                },
                                                children: emailHelpText
                                            }),
                                            isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                role: "alert",
                                                className: (0, $2jatx.default)([
                                                    "_181nglyw",
                                                    "_syaz1d19 _1wybepq8 _vwz4bs82"
                                                ]),
                                                style: {
                                                    "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                                                    "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                                                },
                                                children: errorMessageText
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2BAOV.InlineSubmit), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5UiwV.InlineSeparator), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1ll71iji _6pup1iji"
                        ]),
                        style: {
                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iMoR7.SocialButton), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_ahbq1tcg _12l21tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                        htmlFor: "inline_email_embedded_signup_input",
                        className: (0, $2jatx.default)([
                            "_ect4z4z1 _1wyb1crf _vwz4bs82 _1pfhi2wt _tzy4txnc",
                            "_sugaglyw"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: emailHelpText
                    }),
                    isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        role: "alert",
                        className: (0, $2jatx.default)([
                            "_sugaglyw",
                            "_syaz1d19 _1wybepq8 _vwz4bs82"
                        ]),
                        style: {
                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                            "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                        },
                        children: errorMessageText
                    }) : null
                ]
            })
        ]
    });
};
const $cf45e524158d5f0c$var$containerCss = null;
const $cf45e524158d5f0c$var$labelCss = null;
const $cf45e524158d5f0c$var$inputSubmitSocialContainerCss = null;
const $cf45e524158d5f0c$var$inputSubmitGroupCss = null;
const $cf45e524158d5f0c$var$inputSubmitGroupFocusCss = null;
const $cf45e524158d5f0c$var$inputCss = null;
const $cf45e524158d5f0c$var$helpTextContainerCss = null;
const $cf45e524158d5f0c$var$helpTextMobileCss = null;
const $cf45e524158d5f0c$var$helpTextCss = null;
const $cf45e524158d5f0c$var$helpErrorTextMobileCss = null;
const $cf45e524158d5f0c$var$helpErrorTextDesktopCss = null;
const $cf45e524158d5f0c$var$errorMessageCss = null;
const $cf45e524158d5f0c$var$inlineInputInvalidCss = null;
const $cf45e524158d5f0c$var$inputValidCss = null;
const $cf45e524158d5f0c$var$socialButtonWrapperCss = null;

});
parcelRegister("ieOG3", function(module, exports) {
$parcel$export(module.exports, "InlineInput", function () { return $11df3b80482dd58e$export$36d3e0619bb09209; });
/* inline-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8mdo4 = parcelRequire("8mdo4");

var $kInl4 = parcelRequire("kInl4");

var $8KJ2x = parcelRequire("8KJ2x");

var $cGEBM = parcelRequire("cGEBM");

var $gM7M2 = parcelRequire("gM7M2");

var $kbpa7 = parcelRequire("kbpa7");
const $11df3b80482dd58e$export$36d3e0619bb09209 = ({ email: email, setEmail: setEmail, isValid: isValid, setValid: setValid, errorMessageText: errorMessageText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const intl = (0, $8e22h.default)();
    const placeholderText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.emailPlaceholder',
        defaultMessage: 'you@company.com'
    });
    const validMessage = intl.formatMessage({
        id: 'gwp.accountSignin.validEmailIcon',
        defaultMessage: 'Email is valid'
    });
    (0, $1oC0p.useEffect)(()=>{
        const valid = (0, $gM7M2.emailIsValid)(email);
        if (!valid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(valid);
        setIsEmailValid(valid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid,
        setValid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3ickbl _vchhusvi _1bsb1osq _1e0c1txw _4cvr1h6o _7yjtidpf _ldgnidpf _un3pidpf _29hzidpf _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _k8em1osq _bhl91osq _1xlo1osq _1j301afi _1o4gkze7 _a5zt1ylp",
            isValid === false && "_1s801d19 _13z4p6ku",
            isValid === true && "_1s8081oq _13z41g3m"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
            "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: "",
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _4t3i1osq _hbmn1rnp _pytk1osq _1rwq1j28 _psgk1pfd _1heuz4z1 _125xf6fq _1yzy15vq _bgrh15vq _v69ygrf3 _ogxmmccc _1qtqgrf3 _n9z4a982 _509t1l2s _yizhowjs _ixrd1txw _hlcb1h6o _5ce6inbi _1wb7f6fq _1k9xmzrp _1gzemzrp _zt0yglyw _zbayidpf _bp7oagmp _k8em1osq _6kab1h6o"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                ...fieldProps,
                                autoComplete: "email",
                                id: "inline_email_embedded_signup_input",
                                "aria-label": placeholderText,
                                onBlur: ()=>setIsReadyForInvalid(true),
                                onChange: (e)=>{
                                    setEmail(e.target.value);
                                    setTypeAheadEmail(e.target.value);
                                    fieldProps.onChange(e);
                                },
                                placeholder: placeholderText,
                                testId: "email_field",
                                type: "email",
                                value: email
                            }),
                            isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1wpz1h6o _1752gktf _w8l5gktf _chtu1tcg",
                                    "_syaz1d19"
                                ]),
                                style: {
                                    "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kInl4))), {
                                    label: errorMessageText
                                })
                            }) : isValid === true ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1wpz1h6o _1752gktf _w8l5gktf _chtu1tcg",
                                    "_1nj181oq"
                                ]),
                                style: {
                                    "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8mdo4))), {
                                    label: validMessage
                                })
                            }) : null
                        ]
                    })
                })
        })
    });
};
const $11df3b80482dd58e$var$containerCss = null;
const $11df3b80482dd58e$var$inlineInputCss = null;
const $11df3b80482dd58e$var$inlineInputInvalidCss = null;
const $11df3b80482dd58e$var$inlineInputValidCss = null;
const $11df3b80482dd58e$var$iconCss = null;
const $11df3b80482dd58e$var$invalidIconCss = null;
const $11df3b80482dd58e$var$validIconCss = null;

});
parcelRegister("kInl4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7adb5fd03a25925a35432d6cd30431e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f14a0553115fd956$var$_react = $f14a0553115fd956$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f14a0553115fd956$var$_baseNew = $f14a0553115fd956$var$_interopRequireDefault((parcelRequire("jcI35")));
function $f14a0553115fd956$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowDanger".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing statuses that signal critical issues that demand attention
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f14a0553115fd956$var$StatusWorkflowDangerIcon = (props)=>/*#__PURE__*/ $f14a0553115fd956$var$_react.default.createElement($f14a0553115fd956$var$_baseNew.default, Object.assign({
        name: "StatusWorkflowDangerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-7V9h1.5V3.5z" clip-rule="evenodd"/>`
    }, props));
$f14a0553115fd956$var$StatusWorkflowDangerIcon.displayName = 'StatusWorkflowDangerIcon';
var $f14a0553115fd956$var$_default = module.exports.default = $f14a0553115fd956$var$StatusWorkflowDangerIcon;

});



parcelRegister("2SlL9", function(module, exports) {
$parcel$export(module.exports, "InlineInputSubmit", function () { return $aae7ac099dc370ce$export$f6b43c228755b29a; });
/* inline-input-submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8mdo4 = parcelRequire("8mdo4");

var $kInl4 = parcelRequire("kInl4");

var $8KJ2x = parcelRequire("8KJ2x");

var $cGEBM = parcelRequire("cGEBM");

var $gM7M2 = parcelRequire("gM7M2");

var $iTHVN = parcelRequire("iTHVN");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $aae7ac099dc370ce$export$f6b43c228755b29a = ({ helpText: helpText, darkMode: darkMode = false })=>{
    const intl = (0, $8e22h.default)();
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const defaultHelpText = intl.formatMessage({
        id: 'signupForm.accountCreation.helperTextTeam26',
        defaultMessage: 'Use a work email to find teammates and get access to Rovo AI'
    });
    const emailHelpText = helpText?.trim() || defaultHelpText;
    const errorMessageText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.invalidEmail',
        defaultMessage: 'Please enter a valid email address.'
    });
    const placeholderText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.workEmail',
        defaultMessage: 'Work email'
    });
    const emailPlaceholder = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.emailPlaceholder',
        defaultMessage: 'you@company.com'
    });
    const validMessage = intl.formatMessage({
        id: 'gwp.accountSignin.validEmailIcon',
        defaultMessage: 'Email is valid'
    });
    const buttonText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.submit',
        defaultMessage: 'Sign up'
    });
    (0, $1oC0p.useEffect)(()=>{
        const valid = (0, $gM7M2.emailIsValid)(email);
        if (!valid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(valid);
        setIsEmailValid(valid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _zulp1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                className: (0, $2jatx.default)([
                    "_syaz1kw7 _ect4z4z1 _k48pbfng _1wybdlk8 _ahbqidpf _13ioglyw",
                    "_ahbqidpf _12l2idpf"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: placeholderText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4t3i1ady _vchhusvi _4cvr1h6o _bfhk1afi _19itkze7 _2rko1ylp _zulputpp _1bsb1osq _14q21bp4 _15sj1wug _1bqcglyw _wfwp1j28 _11laidpf _1wm0pxbi _30wv1fhb",
                    darkMode && "_bfhk1j28 _psgkuftu _5ce6uftu",
                    isValid === undefined && "_1u6l1c1e _jyzfuuyu",
                    isValid === false && "_1h6d1d19 _16qsp6ku",
                    isValid === true && "_1h6d81oq _16qs1g3m"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                    "--_p6wr00": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue600')),
                    "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                    "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1ul9idpf _4t3i1osq _15sj1ady _wfwp1afi _1bqckze7 _11la1ylp _7yjtidpf _ldgnidpf _un3pidpf _29hzidpf _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _k8em1osq _bhl91osq _89vyidpf _5rvh1wug _32nkidpf _wws01wug"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                            "aria-required": true,
                            isRequired: true,
                            label: "",
                            name: "email",
                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _4t3i1osq _hbmn1rnp _pytk1osq _1rwq1j28 _psgk1kw7 _1heu1kw7 _125x1j6v _1yzy15vq _bgrh15vq _62vcmccc _509t1l2s _ixrd1txw _hlcb1h6o _4cvu1kw7 _1wb71j6v _1k9xmzrp _1gzemzrp _zt0yglyw _zbayidpf _bp7oagmp _k8em1osq _6kab1h6o"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                            ...fieldProps,
                                            autoComplete: "email",
                                            id: "inline_email_embedded_signup_input",
                                            "aria-label": emailPlaceholder,
                                            onBlur: ()=>setIsReadyForInvalid(true),
                                            onChange: (e)=>{
                                                setEmail(e.target.value);
                                                setTypeAheadEmail(e.target.value);
                                                fieldProps.onChange(e);
                                            },
                                            placeholder: emailPlaceholder,
                                            testId: "email_field",
                                            type: "email",
                                            value: email
                                        }),
                                        isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _1wpz1h6o _1752gktf _w8l5gktf",
                                                "_syaz1d19"
                                            ]),
                                            style: {
                                                "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                            },
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kInl4))), {
                                                label: errorMessageText
                                            })
                                        }) : isValid === true ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _1wpz1h6o _1752gktf _w8l5gktf",
                                                "_1nj181oq"
                                            ]),
                                            style: {
                                                "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
                                            },
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8mdo4))), {
                                                label: validMessage
                                            })
                                        }) : null
                                    ]
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                        type: "submit",
                        disabled: isSubmitting || hasSubmitted && !formError,
                        onClick: onClickSubmitButton,
                        "data-testid": "embedded-signup-submit",
                        dataEventProps: {
                            'data-product-key': 'uniform',
                            'data-event': 'clicked',
                            'data-event-component': 'button',
                            'data-event-container': 'signup',
                            'data-label': buttonText,
                            'data-label-english': 'Sign up'
                        },
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _vchhusvi _1e0c1txw _ect41kw7 _1wyb1j6v _k48p1nn1 _4t3i1ady _1bah1h6o _1ul91wug _o5721q9c _1bsb1ns9 _19pk1n1a _2hwx1n1a _otyr1n1a _18u0idpf _1qwo1osq _1cbbidpf _l9wpidpf _f4o9idpf _14dmidpf"
                        ]),
                        children: buttonText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_ahbqidpf _12l2idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                        htmlFor: "inline_email_embedded_signup_input",
                        className: (0, $2jatx.default)([
                            "_ect4z4z1 _1wyb1crf _vwz4bs82 _1pfhi2wt _syazjdj5 _tzy4txnc"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: emailHelpText
                    }),
                    isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        role: "alert",
                        className: (0, $2jatx.default)([
                            "_syaz1d19 _1wybepq8 _vwz4bs82"
                        ]),
                        style: {
                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                            "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                        },
                        children: errorMessageText
                    }) : null
                ]
            })
        ]
    });
};
const $aae7ac099dc370ce$var$containerCss = null;
const $aae7ac099dc370ce$var$labelCss = null;
const $aae7ac099dc370ce$var$inputSubmitGroupCss = null;
const $aae7ac099dc370ce$var$inputSubmitGroupFocusCss = null;
const $aae7ac099dc370ce$var$inputWrapperCss = null;
const $aae7ac099dc370ce$var$inputInnerCss = null;
const $aae7ac099dc370ce$var$buttonCss = null;
const $aae7ac099dc370ce$var$helpTextContainerCss = null;
const $aae7ac099dc370ce$var$helpTextCss = null;
const $aae7ac099dc370ce$var$errorMessageCss = null;
const $aae7ac099dc370ce$var$darkModeBgCss = null;
const $aae7ac099dc370ce$var$invalidBorderCss = null;
const $aae7ac099dc370ce$var$validBorderCss = null;
const $aae7ac099dc370ce$var$iconCss = null;
const $aae7ac099dc370ce$var$invalidIconCss = null;
const $aae7ac099dc370ce$var$validIconCss = null;

});


parcelRegister("a9JqH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $376ff53084535d3b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $kM0Jm = parcelRequire("kM0Jm");
const $376ff53084535d3b$var$UniformSimpleTableCell = ({ text: text, icon: icon })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kM0Jm.GenericTableSimpleCell), {
        text: text,
        icon: icon
    });
};
var $376ff53084535d3b$export$2e2bcd8739ae039 = $376ff53084535d3b$var$UniformSimpleTableCell;

});
parcelRegister("kM0Jm", function(module, exports) {
$parcel$export(module.exports, "GenericTableSimpleCell", function () { return $20dd41b0610be1b8$export$ca0bc85adb068c8b; });
/* generic-table-simple-cell.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $OKl9V = parcelRequire("OKl9V");
const $20dd41b0610be1b8$var$cellCss = null;
const $20dd41b0610be1b8$var$cellContentCss = null;
const $20dd41b0610be1b8$var$iconCircleCss = null;
const $20dd41b0610be1b8$var$checkmarkCircleCss = null;
const $20dd41b0610be1b8$var$crossCircleCss = null;
const $20dd41b0610be1b8$export$ca0bc85adb068c8b = ({ text: text, icon: icon, ...props })=>{
    const iconElement = icon === 'checkmark' ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_2rko1ssb _1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _1pfht94y",
            "_bfhk1oqd"
        ]),
        style: {
            "--_1blpe4f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime700'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
            name: "featurecheckmark",
            size: "xxs",
            color: (0, $kbpa7.wacToken)('color.neutral.light0')
        })
    }) : icon === 'x' ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_2rko1ssb _1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _1pfht94y",
            "_bfhk1d19"
        ]),
        style: {
            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_t9ec1cm0"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                name: "cross",
                size: "xxs",
                color: (0, $kbpa7.wacToken)('color.neutral.light0')
            })
        })
    }) : null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
        ...props,
        className: (0, $2jatx.default)([
            "_k48p1nn1 _y3gn1e5h _syaz1pfd _1wybdlk8 _bfhk1kw7 _1e0cdav6 _s7n4jp4b _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zkze7 _10msglyw _1bz3idpf _1rkbz113 _12b6z113 _1rfmz113 _1xouidpf _5yuhidpf _u1n41if8 _rjzgcs5v _6pi5s3kk _1hivb3bt _zo1cidpf _1sg9idpf _f9opglyw _4fgostnw _1kijt94y"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1y6m _zulpftgi"
            ]),
            children: [
                iconElement,
                text
            ]
        })
    });
};

});


parcelRegister("kSxbf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b17f3e2035b9709a$export$2e2bcd8739ae039; });
/* single-stat.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $6iKF0 = parcelRequire("6iKF0");

var $4Fnxt = parcelRequire("4Fnxt");
const $b17f3e2035b9709a$var$UniformSingleStat = ({ number: number, symbolCharacter: symbolCharacter, description: description })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_p12fdgin _1e0c1txw _2lx21bp4 _zulp1b66 _4cvr1h6o _1bah1h6o _ect4zzfg _syazeipq _8164idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("dt", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _zulp1b66 _4cvrh9n0 _k48p1fw0 _srwz1h22"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1wyb1qr7 _1cqst9kd"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
                            fallback: null,
                            children: sectionIsVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Fnxt.AnimateCount), {
                                children: number
                            }) : number
                        })
                    }),
                    symbolCharacter && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1wyb16xz _vwz417n1 _1cqs1ylp _1bys1n2x"
                        ]),
                        children: symbolCharacter
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("dd", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o",
                    "monobrow"
                ]),
                children: description
            })
        ]
    });
};
const $b17f3e2035b9709a$var$statContainerStyles = null;
const $b17f3e2035b9709a$var$statInnerContainerStyles = null;
const $b17f3e2035b9709a$var$statNumberStyles = null;
const $b17f3e2035b9709a$var$statSymbolCharacterStyles = null;
const $b17f3e2035b9709a$var$statDescriptionStyles = null;
var $b17f3e2035b9709a$export$2e2bcd8739ae039 = $b17f3e2035b9709a$var$UniformSingleStat;

});

parcelRegister("dXwUh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66223983e87b0882$export$2e2bcd8739ae039; });
/* single-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");
// eslint-disable-next-line complexity
const $66223983e87b0882$var$UniformSingleTab = (props)=>{
    const { orientation: orientation = {
        mobile: 'vertical'
    }, gap: gap = {
        mobile: '0'
    } } = props;
    const gapObject = {
        mobile: gap.mobile ?? '0',
        // @ts-ignore
        tablet: gap?.tablet ?? gap.mobile ?? '0',
        // @ts-ignore
        desktop: gap?.desktop ?? gap?.tablet ?? gap.mobile ?? '0'
    };
    const styles = null;
    const orientationObject = {
        mobile: orientation.mobile || 'vertical',
        // @ts-ignore
        tablet: orientation.tablet || orientation.mobile || 'vertical',
        desktop: // @ts-ignore
        orientation.desktop || // @ts-ignore
        orientation.tablet || orientation.mobile || 'vertical'
    };
    const orientationStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _4t3i1wug _1e0c1txw _zulp17fv _19wg1im9 _pdlm1bxm",
            "_1e0c1txw _2lx21luv _1lp71gkj _1ini19q3"
        ]),
        style: {
            "--_1lzn2ck": (0, $6ZVlx.default)('var(--ds-space-' + gapObject.mobile + ')'),
            "--_9e7v2h": (0, $6ZVlx.default)('var(--ds-space-' + gapObject.tablet + ')'),
            "--_1xgygbw": (0, $6ZVlx.default)('var(--ds-space-' + gapObject.desktop + ')'),
            "--_1kdc6hg": (0, $6ZVlx.default)(orientationObject.mobile === 'horizontal' ? 'row' : 'column'),
            "--_1tsuz96": (0, $6ZVlx.default)(orientationObject.tablet === 'horizontal' ? 'row' : 'column'),
            "--_1m7tih1": (0, $6ZVlx.default)(orientationObject.desktop === 'horizontal' ? 'row' : 'column')
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "tabContents"
        })
    });
};
var $66223983e87b0882$export$2e2bcd8739ae039 = $66223983e87b0882$var$UniformSingleTab;

});

parcelRegister("aeR15", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d6734395d472436$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $87vyU = parcelRequire("87vyU");

var $kK9LF = parcelRequire("kK9LF");
const $5d6734395d472436$var$mapCardsToSlidingLayout = (cards)=>cards.map((card)=>({
            title: card.title,
            color: card.color,
            icon: card.icon,
            ctaLinkUrl: card.ctaLinkUrl,
            ctaLinkText: card.ctaLinkText
        }));
const $5d6734395d472436$var$UniformSlidingLayout = (props)=>{
    const { brightnessMode: brightnessMode = 'light', colorMode: colorMode = 'none', flattenData: flattenData = true } = props;
    let { cards: cards } = props;
    if (flattenData) cards = (0, $87vyU.flattenSlidingLayoutCardProps)(props).cards;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kK9LF.SlidingLayout), {
        cards: $5d6734395d472436$var$mapCardsToSlidingLayout(cards),
        brightnessMode: brightnessMode,
        colorMode: colorMode
    });
};
var $5d6734395d472436$export$2e2bcd8739ae039 = $5d6734395d472436$var$UniformSlidingLayout;

});
parcelRegister("87vyU", function(module, exports) {
$parcel$export(module.exports, "flattenSlidingLayoutCardProps", function () { return $823cac3ca669dfae$export$5f5dbdd0872865aa; });

var $f2QWG = parcelRequire("f2QWG");
const $823cac3ca669dfae$export$5f5dbdd0872865aa = (props)=>{
    return {
        ...props,
        cards: (0, $f2QWG.flattenValues)(props.cards)
    };
};

});

parcelRegister("kK9LF", function(module, exports) {
$parcel$export(module.exports, "SlidingLayout", function () { return $734e627ca5482ae7$export$bd6d395cec230f31; });
/* sliding-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $734e627ca5482ae7$var$SWITCH_DELAY_MS = 2000;
const $734e627ca5482ae7$var$CONTAINER_GAP_PX = "var(--ds-space-300, 24px)";
const $734e627ca5482ae7$var$intervalFeaturedShrinking = '25%, 100%';
const $734e627ca5482ae7$var$intervalClickedToFeatured = '25%, 65%';
const $734e627ca5482ae7$var$intervalOtherCardExpanding = '37%, 50%';
const $734e627ca5482ae7$var$intervalOtherCardShrinking = '75%, 100%';
const $734e627ca5482ae7$var$featuredFromLeftToLeftSmallTop = null;
const $734e627ca5482ae7$var$featuredFromLeftToLeftSmallBottom = null;
const $734e627ca5482ae7$var$featuredFromRightToRightSmallTop = null;
const $734e627ca5482ae7$var$featuredFromRightToRightSmallBottom = null;
const $734e627ca5482ae7$var$smallTopFromLeftSmallToLeftFeatured = null;
const $734e627ca5482ae7$var$smallBottomFromLeftSmallToLeftFeatured = null;
const $734e627ca5482ae7$var$smallTopFromRightSmallToRightFeatured = null;
const $734e627ca5482ae7$var$smallBottomFromRightSmallToRightFeatured = null;
const $734e627ca5482ae7$var$smallTopFromLeftToRight = null;
const $734e627ca5482ae7$var$smallBottomFromLeftToRight = null;
const $734e627ca5482ae7$var$smallTopFromRightToLeft = null;
const $734e627ca5482ae7$var$smallBottomFromRightToLeft = null;
const $734e627ca5482ae7$var$slidingLayoutSectionStyle = null;
const $734e627ca5482ae7$var$slidingLayoutContainerInnerStyle = null;
const $734e627ca5482ae7$var$slidingLayoutStyles = null;
const $734e627ca5482ae7$var$cardStyles = null;
const $734e627ca5482ae7$var$clickableElementStyle = null;
const $734e627ca5482ae7$var$cardInnerStyle = null;
const $734e627ca5482ae7$var$cardPadding = null;
const $734e627ca5482ae7$var$cardContentStyle = null;
const $734e627ca5482ae7$var$cardTitleStyle = null;
const $734e627ca5482ae7$var$getCardColor = (color, brightnessMode, colorMode)=>{
    const tree = {
        default: {
            light: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light200'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.neutral.light200'),
                borderColor: (0, $kbpa7.wacToken)('color.neutral.light0'),
                buttonColor: (0, $kbpa7.wacToken)('color.neutral.light0')
            },
            dark: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light1000'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.neutral.light1000'),
                borderColor: (0, $kbpa7.wacToken)('color.neutral.light1000'),
                buttonColor: (0, $kbpa7.wacToken)('color.neutral.light1000')
            }
        },
        purple: {
            light: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.extended.purple200'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.extended.purple200'),
                borderColor: (0, $kbpa7.wacToken)('color.extended.purple500'),
                buttonColor: (0, $kbpa7.wacToken)('color.extended.purple500')
            },
            dark: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.extended.purple500'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.extended.purple500'),
                borderColor: (0, $kbpa7.wacToken)('color.extended.purple500'),
                buttonColor: (0, $kbpa7.wacToken)('color.extended.purple500')
            }
        },
        saffron: {
            light: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.extended.saffron200'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.extended.saffron200'),
                borderColor: (0, $kbpa7.wacToken)('color.extended.saffron500'),
                buttonColor: (0, $kbpa7.wacToken)('color.extended.saffron500')
            },
            dark: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.extended.saffron600'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.extended.saffron600'),
                borderColor: (0, $kbpa7.wacToken)('color.extended.saffron600'),
                buttonColor: (0, $kbpa7.wacToken)('color.extended.saffron600')
            }
        },
        lime: {
            light: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.extended.lime200'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.extended.lime200'),
                borderColor: (0, $kbpa7.wacToken)('color.extended.lime500'),
                buttonColor: (0, $kbpa7.wacToken)('color.extended.lime500')
            },
            dark: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.extended.lime500'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.extended.lime500'),
                borderColor: (0, $kbpa7.wacToken)('color.extended.lime500'),
                buttonColor: (0, $kbpa7.wacToken)('color.extended.lime500')
            }
        },
        blue: {
            light: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.extended.blue200'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.extended.blue200'),
                borderColor: (0, $kbpa7.wacToken)('color.extended.blue500'),
                buttonColor: (0, $kbpa7.wacToken)('color.extended.blue700')
            },
            dark: {
                none: '',
                backgroundColor: (0, $kbpa7.wacToken)('color.extended.blue700'),
                polygonBackgroundColor: (0, $kbpa7.wacToken)('color.extended.blue700'),
                borderColor: (0, $kbpa7.wacToken)('color.extended.blue500'),
                buttonColor: (0, $kbpa7.wacToken)('color.extended.blue700')
            }
        }
    };
    const palette = tree[color] ?? tree.default;
    return palette[brightnessMode][colorMode];
};
const $734e627ca5482ae7$export$bd6d395cec230f31 = ({ cards: cards, brightnessMode: brightnessMode = 'light', colorMode: colorMode = 'none' })=>{
    const intl = (0, $8e22h.default)();
    const normalizedCards = [
        0,
        1,
        2
    ].map((index)=>({
            title: cards[index]?.title ?? '',
            color: cards[index]?.color ?? 'default',
            ctaLinkUrl: cards[index]?.ctaLinkUrl ?? '#',
            ctaLinkText: cards[index]?.ctaLinkText ?? 'Visit link',
            icon: cards[index]?.icon
        }));
    const [cardRoles, setCardRoles] = (0, $1oC0p.useState)([
        'smallTop',
        'smallBottom',
        'featured'
    ]);
    const [featuredSide, setFeaturedSide] = (0, $1oC0p.useState)('right');
    const [isSwitching, setIsSwitching] = (0, $1oC0p.useState)(false);
    const [animationContext, setAnimationContext] = (0, $1oC0p.useState)(null);
    const [containerWidthPx, setContainerWidthPx] = (0, $1oC0p.useState)(0);
    const animationTimeoutRef = (0, $1oC0p.useRef)(null);
    const containerRef = (0, $1oC0p.useRef)(null);
    const clearAnimationTimer = ()=>{
        if (animationTimeoutRef.current !== null) {
            clearTimeout(animationTimeoutRef.current);
            animationTimeoutRef.current = null;
        }
    };
    (0, $1oC0p.useEffect)(()=>{
        return clearAnimationTimer;
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        const containerElement = containerRef.current;
        if (!containerElement) return;
        const updateContainerWidth = ()=>{
            setContainerWidthPx(containerElement.getBoundingClientRect().width);
        };
        updateContainerWidth();
        const resizeObserver = new ResizeObserver(updateContainerWidth);
        resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, []);
    const handleExpand = (index)=>{
        if (isSwitching || cardRoles[index] === 'featured') return;
        const currentFeaturedIndex = cardRoles.findIndex((role)=>role === 'featured');
        if (currentFeaturedIndex === -1) return;
        const clickedRole = cardRoles[index];
        if (!clickedRole) return;
        const otherSmallIndex = cardRoles.findIndex((role, cardIndex)=>role !== 'featured' && cardIndex !== index);
        const otherSmallRole = cardRoles[otherSmallIndex];
        if (otherSmallIndex === -1 || !otherSmallRole || otherSmallRole === 'featured') return;
        const nextFeaturedSide = featuredSide === 'left' ? 'right' : 'left';
        clearAnimationTimer();
        setIsSwitching(true);
        setAnimationContext({
            clickedIndex: index,
            featuredIndex: currentFeaturedIndex,
            otherIndex: otherSmallIndex,
            clickedRole: clickedRole,
            otherRole: otherSmallRole,
            nextFeaturedSide: nextFeaturedSide
        });
        animationTimeoutRef.current = window.setTimeout(()=>{
            setCardRoles((currentRoles)=>{
                const nextRoles = [
                    ...currentRoles
                ];
                nextRoles[index] = 'featured';
                nextRoles[currentFeaturedIndex] = clickedRole;
                return nextRoles;
            });
            setFeaturedSide(nextFeaturedSide);
            setAnimationContext(null);
            setIsSwitching(false);
            clearAnimationTimer();
        }, $734e627ca5482ae7$var$SWITCH_DELAY_MS);
    };
    const containerHeightPx = colorMode === 'polygonBackgroundColor' ? 544 : 484;
    const getCardArea = (index)=>cardRoles[index] ?? 'smallTop';
    const getAnimationParticipant = (index)=>{
        if (!animationContext) return undefined;
        if (index === animationContext.clickedIndex) return 'clicked';
        if (index === animationContext.featuredIndex) return 'featured';
        if (index === animationContext.otherIndex) return 'other';
        return undefined;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1yt41ejb _17jj1pfd _r2321afi",
            `style_${colorMode} brightness_${brightnessMode}`
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbg505 _p12f1osq"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: containerRef,
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1tke1hqu _kqswh2mm _1e0c11p5 _zulp1ejb _yv0e16hb _2z05fsjm _51kj1ule _18reu60i _14wb1p52 _1mjb1txw _na0i1bp4 _2osn1ejb _1kne1wug _1jgoidpf",
                    `sliding-layout-container style_${colorMode} featured-side_${featuredSide} ${isSwitching ? 'is-switching' : ''}`
                ]),
                style: {
                    '--sliding-layout-container-width': `${containerWidthPx}px`,
                    '--sliding-layout-container-height': `${containerHeightPx}px`,
                    '--sliding-layout-gap': $734e627ca5482ae7$var$CONTAINER_GAP_PX,
                    '--sl-small-width': 'calc((var(--sliding-layout-container-width) - (2 * var(--sliding-layout-gap))) / 3)',
                    '--sl-featured-width': 'calc((2 * var(--sl-small-width)) + var(--sliding-layout-gap))',
                    '--sl-small-height': 'calc((var(--sliding-layout-container-height) - var(--sliding-layout-gap)) / 2)',
                    '--sl-height-featured': 'var(--sliding-layout-container-height)',
                    '--sl-left-featured-left': '0px',
                    '--sl-left-featured-right': 'calc(var(--sliding-layout-container-width) - var(--sl-featured-width))',
                    '--sl-left-small-on-right-side': 'calc(var(--sliding-layout-container-width) - var(--sl-small-width))',
                    '--sl-left-small-on-left-side': '0px',
                    '--sl-top-featured': '0px',
                    '--sl-top-small-top': '0px',
                    '--sl-top-small-bottom': 'calc(var(--sl-small-height) + var(--sliding-layout-gap))',
                    '--sl-animation-duration': `${$734e627ca5482ae7$var$SWITCH_DELAY_MS}ms`
                },
                children: normalizedCards.map((card, index)=>{
                    const cardArea = getCardArea(index);
                    const isFeatured = cardArea === 'featured';
                    const participant = getAnimationParticipant(index);
                    const isAnimating = Boolean(participant && animationContext);
                    const directionClass = animationContext ? animationContext.nextFeaturedSide : 'none';
                    const clickedRoleClass = animationContext ? animationContext.clickedRole : 'none';
                    const cardStyle = {
                        '--sliding-layout-card-color': $734e627ca5482ae7$var$getCardColor(card.color ?? 'default', brightnessMode, colorMode)
                    };
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _k8m01l1k _1oec1doz _6fl41ytf _2rko1ylz _1m9pau6p _uumyhg3g _1kua1vcn _12ygstnw _3mrk1kv4 _1tij1ytf _1l5dq7pw _5g2ekb7n _1p9bglyw _1fnrbdh1 _nwzlpz9l _8skb1t7z _e1761qov _3yyk1vxk _161g1s8t _1run1uut _8onc1l6u _lemz1b2n _ix9ga82m _ehvy1ed8 _vrrtp2y3 _emf4egat _1idj11wp _j1pdcs5v _z115h2mm _1s4p1osq _nqop1wug _16mq1wug _1kne1wug _rqkdglyw _13hzglyw _1jgoidpf _f19eglyw _ahee1ule _qeckglyw _15dkglyw _1vmpidpf _xvf3gx0z _1nu6idpf _zs4repas _o83e1x9s _1e5rgoum _19fr1afi _16yglkxj _fszclkxj _154zlkxj _zc5t1pfd _ztau1afi _1tym1afi _1mip1afi _1wicwzwm _8dmgwzwm _1xvwnqa1 _7locnqa1 _facyt94y _b3xzt94y _wibws3kk _5z0rs3kk _sxj2t7xp _1ih0t7xp _1654130s _12ye130s _1h4h1sjd _1enm1sjd _ewbhyh40 _19zrnqa1 _1wtaidpf _1u3nnqa1 _1m651vwv _1hxmyh40 _14fs1sjd _285b1sjd _qodz1o8l _pogitlke _pfk4glyw _8r1bkb7n _1k8vnqa1 _y6hxrwpw _lxl41ekt _1g6q1ssb _197k19bv _f9ti19bv _76jg19bv _1o8j19bv _dztwgktf _19qnyh40 _53ln1crf _1o0k1ul9 _12id14y2 _1pt919bv _62ym14y2 _5r4j19bv _1xkst94y _1u891sjd _7vrn1sjd _gicd1afi _10ql1sjd _17551j28 _qll91j28 _bld21j28 _1kmi1j28 _1igy1r31 _k6sx1r31 _1lh31r31 _1x171r31 _9h8w1sjd _nb7o1sjd _1ies1pfd _n76r1pfd _eai01pfd _o9ia1pfd _15dc1afi _1l3o1afi _ozv11pfd _1wky1pfd _1xw31pfd _jjgt1pfd _120q1sjd _zfdc1sjd _1jk81afi _1thm1afi _d2y91afi _1q5o1afi _1u8n1afi _10q0lkxj _zme9lkxj _5ypz1afi _2vet1afi _dhog1afi _d8vj1afi _ywwk1sjd _17051sjd _17vglkxj _xplkkb7n _6jpk1kw7 _qv791kw7 _1xrw1pfd _1fak1pfd _qg6k1afi _17u21afi _hu5z1pfd _1oge1pfd _zu6l1sjd _m64l1sjd _v5621afi _m5jb1sjd _9qti1afi _ndac1afi _1fzy1pfd _tfzm1pfd _exmn1afi _hhmg1afi _1uuo1sjd _15e81sjd _1r3clkxj _a44i1sjd",
                            `card${index} switching_${isSwitching} style_${colorMode} brightness_${brightnessMode} color_${card.color} side_${featuredSide} role_${cardArea} ${isFeatured && !isSwitching ? 'featured' : 'small'} ${isAnimating ? 'is-animating' : ''} ${participant ? `participant_${participant}` : ''} clicked-role_${clickedRoleClass} direction_${directionClass}`
                        ]),
                        style: {
                            ...cardStyle,
                            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                            "--_akkdnv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.quick-entrance')),
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_1px5u0o": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1000')),
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswstnw _1bsb1osq _4t3i1osq _z115h2mm",
                                'card-inner' + index
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1yt41ejb _h2snoahv",
                                    `card-padding style_${colorMode}`
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_8hrz1nty _v564f1gs _p12f1f28 _8fz61j3l _1qkj18ws _1q8u1h7a",
                                        isFeatured && !isSwitching ? 'featured' : 'small'
                                    ]),
                                    children: [
                                        card.icon && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                            image: {
                                                width: 30,
                                                height: 30,
                                                src: card.icon,
                                                alt: ''
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                            className: (0, $2jatx.default)([
                                                "_vwz4cjiy _k48p9y44 _1wyb1ejb _18s812pl"
                                            ]),
                                            children: card.title
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            className: `buttonelement expander style_${colorMode} brightness_${brightnessMode}`,
                                            children: "\uFF0B"
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                            disabled: isSwitching,
                                            className: (0, $2jatx.default)([
                                                "_19itglyw _kqswstnw _1r04idpf _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _y4c0glyw _1mjbglyw",
                                                `clickable-element ${isFeatured ? 'featured' : 'small'}`
                                            ]),
                                            onClick: ()=>handleExpand(index),
                                            "aria-label": intl.formatMessage({
                                                id: 'adg4.sliding-layout.expand-button-aria-label',
                                                defaultMessage: 'Expand'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                            className: `buttonelement visitor style_${colorMode} brightness_${brightnessMode} color_${card.color}`,
                                            href: card.ctaLinkUrl,
                                            children: card.ctaLinkText
                                        })
                                    ]
                                })
                            })
                        })
                    }, card.title);
                })
            })
        })
    });
};

});


parcelRegister("4YtaH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e0d1d4802d3e1efb$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $dZNgt = parcelRequire("dZNgt");

var $28KSV = parcelRequire("28KSV");

var $lTkkF = parcelRequire("lTkkF");

var $gVC4y = parcelRequire("gVC4y");
const $e0d1d4802d3e1efb$var$UniformSpeakers = ({ speakers: speakers, title: title })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedSpeakers = (0, $f2QWG.flattenValues)(speakers);
    const reshapedSpeakers = flattenedSpeakers.map((flattenedProps)=>{
        return {
            ...flattenedProps,
            bio: flattenedProps.shortBiographyContentfulRichText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                text: (0, $gVC4y.richTextToHTML)(flattenedProps.shortBiographyContentfulRichText)
            }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(flattenedProps.shortBiography) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                uniformRichText: flattenedProps.shortBiography?.root
            }) : undefined
        };
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $28KSV.Speakers), {
        speakers: reshapedSpeakers,
        title: title
    });
};
var $e0d1d4802d3e1efb$export$2e2bcd8739ae039 = $e0d1d4802d3e1efb$var$UniformSpeakers;

});
parcelRegister("28KSV", function(module, exports) {
$parcel$export(module.exports, "Speakers", function () { return $593b735d86f47a1e$export$b1b4379f828ca70a; });
/* speakers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $593b735d86f47a1e$var$Speaker = ({ name: name, photoSrc: photoSrc, jobTitle: jobTitle, company: company, bio: bio, size: size })=>{
    const nameAndTitle = (showOnlyOnMobile)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulp1b66 _1gzvv77o _8164idpf",
                showOnlyOnMobile ? "_181nglyw" : "_sugaglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                        "card-title-sm"
                    ]),
                    children: name
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                        "body-sm"
                    ]),
                    children: [
                        jobTitle,
                        company && `, ${company}`
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _55brvrvc _zulppxbi _8164u2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi _1gdevrvc _ag851h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: photoSrc,
                        alt: "",
                        className: (0, $2jatx.default)([
                            "_2rko1ssb",
                            size === 'large' && "_4t3i68cl _1bsb68cl",
                            size === 'small' && "_4t3icmky _1bsbcmky"
                        ])
                    }),
                    nameAndTitle(true)
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpv47k _9808pxbi"
                ]),
                children: [
                    nameAndTitle(false),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "body-md",
                        children: bio
                    })
                ]
            })
        ]
    });
};
const $593b735d86f47a1e$export$b1b4379f828ca70a = ({ speakers: speakers, title: title })=>{
    const intl = (0, $8e22h.default)();
    const defaultTitleSingleSpeaker = intl.formatMessage({
        id: 'speakers.defaultTitle.single',
        defaultMessage: 'More about the speaker'
    });
    const defaultTitleMultipleSpeakers = intl.formatMessage({
        id: 'speakers.defaultTitle.multiple',
        defaultMessage: 'More about the speakers'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1q51xy5q _85i51epz _1j301bjw"
        ]),
        style: {
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: speakers.length === 1 ? '8' : speakers.length === 2 ? '10' : '12',
            tabletLayout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk1bjw _1e0c1txw _2lx21bp4 _1yt4xncg _1q51xy5q _zulpxy5q _umua1jfw _s51sidpf"
                ]),
                style: {
                    "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o",
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "eyebrow-md"
                        ]),
                        children: title ?? (speakers.length === 1 ? defaultTitleSingleSpeaker : defaultTitleMultipleSpeakers)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        // Adding role="list" is prudent when using list-style: none, because some browser/screen-reader combinations have historically stopped announcing an unstyled <ul> as a list.
                        role: "list",
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1e0c11p5 _yv0ex3dc _zulpxncg _1ph4hkll",
                            (speakers.length === 5 || speakers.length === 6) && "_yv0e16hb",
                            speakers.length === 7 && "_yv0e1ezz"
                        ]),
                        children: speakers.map((speakerProps, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($593b735d86f47a1e$var$Speaker, {
                                ...speakerProps,
                                size: speakers.length < 4 ? 'large' : 'small'
                            }, index))
                    })
                ]
            })
        })
    });
};
const $593b735d86f47a1e$var$speakerStyles = null;
const $593b735d86f47a1e$var$imageContainerStyles = null;
const $593b735d86f47a1e$var$imageStyles = null;
const $593b735d86f47a1e$var$largeImageStyles = null;
const $593b735d86f47a1e$var$smallImageStyles = null;
const $593b735d86f47a1e$var$textContainerStyles = null;
const $593b735d86f47a1e$var$nameAndTitleStyles = null;
const $593b735d86f47a1e$var$showOnlyOnMobileStyles = null;
const $593b735d86f47a1e$var$hideOnMobileStyles = null;
const $593b735d86f47a1e$var$sectionStyles = null;
const $593b735d86f47a1e$var$mainContainerStyles = null;
const $593b735d86f47a1e$var$titleStyles = null;
const $593b735d86f47a1e$var$speakersContainerStyles = null;
const $593b735d86f47a1e$var$fiveOrSixSpeakersContainerStyles = null;
const $593b735d86f47a1e$var$sevenSpeakersContainerStyles = null;
const $593b735d86f47a1e$var$noMarginStyles = null;

});


parcelRegister("kfc2o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $27eb9bd54e7ff40d$export$2e2bcd8739ae039; });
/* split-color-background-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $i4BST = parcelRequire("i4BST");
const $27eb9bd54e7ff40d$var$UniformSplitColorBackgroundContainer = ({ topColor: topColor, bottomColor: bottomColor, sectionDivider: sectionDivider, extendBackgroundColor: extendBackgroundColor })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const baseStyle = null;
    const minHeightStyle = null;
    const horizontalStyle = null;
    const highLeftStyle = null;
    const highRightStyle = null;
    const polygonStyle = null;
    const coverStyles = null;
    const sectionDividerComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _4t3iq9zu _1bsb1osq _11q7jj3k _152t1ssb _t9ec1i34 _1kt9b3bt _cfu11ule _kfgt1osq _1mp41osq _1cs8stnw _iajmidpf _1rus1utj",
            bottomColor === 'transparent' && sectionDivider === 'high-left' && "_mkrz7yzi",
            bottomColor === 'transparent' && sectionDivider === 'high-right' && "_mkrz1swj",
            bottomColor === 'transparent' && sectionDivider === 'polygon' && "_mkrz1ljl",
            sectionDivider === 'high-left' && "_tgsmte2m",
            sectionDivider === 'high-right' && "_tgsmrjfx",
            sectionDivider === 'polygon' && "_tgsmwog4"
        ]),
        style: {
            "--_nlw01g": (0, $6ZVlx.default)(topColor),
            "--_130a3qa": (0, $6ZVlx.default)(bottomColor)
        }
    });
    const xlDesktopExtendedBackgroundColorStyle = null;
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsbauwl _4t3i1osq _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s",
            isWacRefresh && "_6ru5u57m _1i7q1hy1",
            sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $6ZVlx.default)(topColor),
            "--_130a3qa": (0, $6ZVlx.default)(bottomColor)
        },
        children: sectionDivider && sectionDividerComponent
    });
    const slotWrapper = ({ items: items })=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _9luy1wqb _ce5au29b _wfa7llbu",
            sectionDivider && "_1tkeq9zu",
            !extendBackgroundColor && sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !extendBackgroundColor && !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $6ZVlx.default)(topColor),
            "--_130a3qa": (0, $6ZVlx.default)(bottomColor)
        },
        children: [
            sectionDivider && !extendBackgroundColor && sectionDividerComponent,
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "component",
                wrapperComponent: sectionDivider ? slotWrapper : undefined
            })
        ]
    });
};
var $27eb9bd54e7ff40d$export$2e2bcd8739ae039 = $27eb9bd54e7ff40d$var$UniformSplitColorBackgroundContainer;

});

parcelRegister("4YxT8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26a575f7b3af25c6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $8HBY7 = parcelRequire("8HBY7");

var $8bW04 = parcelRequire("8bW04");
const $26a575f7b3af25c6$var$UniformStaticPricingCards = ({ staticPricingCards: staticPricingCards })=>{
    const flattenedProps = (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    staticPricingCards);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8bW04.PricingCards), {
        children: flattenedProps.map((cardProps, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
                ...cardProps
            }, index))
    });
};
var $26a575f7b3af25c6$export$2e2bcd8739ae039 = $26a575f7b3af25c6$var$UniformStaticPricingCards;

});

parcelRegister("3rWcE", function(module, exports) {
$parcel$export(module.exports, "UniformStatsSection", function () { return $b524ec055947d1b4$export$a5aec67e611930b9; });

var $7VQPk = parcelRequire("7VQPk");

var $kbpa7 = parcelRequire("kbpa7");

var $4Fnxt = parcelRequire("4Fnxt");
const $b524ec055947d1b4$export$a5aec67e611930b9 = (props)=>{
    const statsProps = {
        headerText: props.title,
        bigStat: {
            stat: props.primaryStatNumber,
            statText: props.primaryStatDescription,
            statColor: (0, $kbpa7.wacToken)('color.primary.blue'),
            statSymbol: {
                symbolCharacter: props.primaryStatSymbolCharacter,
                symbolCharacterColor: (0, $kbpa7.wacToken)('color.primary.blue')
            }
        },
        littleStats: [
            {
                stat: props.secondaryStatNumber,
                statText: props.secondaryStatDescription,
                statColor: (0, $kbpa7.wacToken)('color.primary.blue'),
                statSymbol: {
                    symbolCharacter: props.secondaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $kbpa7.wacToken)('color.primary.blue')
                }
            },
            {
                stat: props.tertiaryStatNumber,
                statText: props.tertiaryStatDescription,
                statColor: (0, $kbpa7.wacToken)('color.primary.blue'),
                statSymbol: {
                    symbolCharacter: props.tertiaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $kbpa7.wacToken)('color.primary.blue')
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Fnxt.Stats), {
        ...statsProps
    });
};

});

parcelRegister("j4sH0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b09338c9a9b6a724$export$2e2bcd8739ae039; });
/* sub-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $b09338c9a9b6a724$var$lightTextStyles = null;
const $b09338c9a9b6a724$var$isDarkBackgroundColor = (color)=>{
    return color ? [
        '#1868DB',
        '#101214'
    ].includes(color) : false;
};
const $b09338c9a9b6a724$var$UniformsubProduct = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3i7urh _1bsb7urh"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: props.imageUrl,
                            alt: props.imageAlt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4z4z1 _1wyb1l3r _zg8l4jg8 _k48p1nn1 _vwz4dlk8",
                    $b09338c9a9b6a724$var$isDarkBackgroundColor(props.backgroundColor) && "_syaz1afi"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: props.title
            })
        ]
    });
};
var $b09338c9a9b6a724$export$2e2bcd8739ae039 = $b09338c9a9b6a724$var$UniformsubProduct;

});

parcelRegister("fDTuB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ee0aaa11219dbd34$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $a25eA = parcelRequire("a25eA");

var $at2aH = parcelRequire("at2aH");

var $GVdPS = parcelRequire("GVdPS");
const $ee0aaa11219dbd34$var$fragmentWrapper = ({ items: items })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: items
    });
const $ee0aaa11219dbd34$var$UniformTable = ({ firstColumnHeaderExists: firstColumnHeaderExists = false })=>{
    const columnHeadersWrapper = ({ items: items })=>{
        // +1 for the blank label column when firstColumnHeaderExists is false
        const headerCellCount = items.length;
        // Only compute equal column widths when there are header cells to count from
        const totalColumns = headerCellCount > 0 ? headerCellCount + (firstColumnHeaderExists ? 0 : 1) : 0;
        const colWidth = totalColumns > 0 ? `${(100 / totalColumns).toFixed(4)}%` : undefined;
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $at2aH.GenericTableThead), {
            colWidth: colWidth,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $at2aH.GenericTableHeadRow), {
                children: [
                    !firstColumnHeaderExists && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a25eA.GenericTableColumnHeader), {
                        "aria-hidden": "true",
                        colWidth: colWidth
                    }),
                    items
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $GVdPS.GenericTable), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "columnHeaders",
                wrapperComponent: columnHeadersWrapper
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: "rows",
                    wrapperComponent: $ee0aaa11219dbd34$var$fragmentWrapper
                })
            })
        ]
    });
};
var $ee0aaa11219dbd34$export$2e2bcd8739ae039 = $ee0aaa11219dbd34$var$UniformTable;

});

parcelRegister("jrzD7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d531d1fea5c075df$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $a25eA = parcelRequire("a25eA");
const $d531d1fea5c075df$var$UniformTableColumnHeader = ({ text: text })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a25eA.GenericTableColumnHeader), {
        children: text
    });
};
var $d531d1fea5c075df$export$2e2bcd8739ae039 = $d531d1fea5c075df$var$UniformTableColumnHeader;

});

parcelRegister("hcVIx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f433ee5ecce2290$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $at2aH = parcelRequire("at2aH");
const $4f433ee5ecce2290$var$UniformTableHeaderRow = ({ text: text })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $at2aH.GenericTableSectionHeaderRow), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $at2aH.GenericTableSectionHeaderCell), {
            colSpan: 999,
            children: text
        })
    });
};
var $4f433ee5ecce2290$export$2e2bcd8739ae039 = $4f433ee5ecce2290$var$UniformTableHeaderRow;

});

parcelRegister("lyzDC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $62afe0d6526eeffc$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $cZmh0 = parcelRequire("cZmh0");
const $62afe0d6526eeffc$var$fragmentWrapper = ({ items: items })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: items
    });
const $62afe0d6526eeffc$var$UniformTableRow = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cZmh0.GenericTableRow), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "cells",
            wrapperComponent: $62afe0d6526eeffc$var$fragmentWrapper
        })
    });
};
var $62afe0d6526eeffc$export$2e2bcd8739ae039 = $62afe0d6526eeffc$var$UniformTableRow;

});

parcelRegister("evFps", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $97121cc693296ff7$export$2e2bcd8739ae039; });
/* tabs-12-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $2axoc = parcelRequire("2axoc");

var $kbpa7 = parcelRequire("kbpa7");

var $7kpd6 = parcelRequire("7kpd6");

var $cwAPf = parcelRequire("cwAPf");

var $i4BST = parcelRequire("i4BST");
const $97121cc693296ff7$var$uniformTabsContainerStyles = null;
const $97121cc693296ff7$var$UniformTabs12Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = 'bgWhite', enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false, tabSize: tabSize = 'large' })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const renderTabs = (0, $1oC0p.useCallback)(({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            const params = // @ts-expect-error props doesn't exist on type
            item.props?.children?.props?.data?.parameters;
            return {
                id: params?.id?.value ?? `tab-${index}`,
                title: params?.title?.value,
                iconUrl: params?.iconUrl?.value,
                tabComponent: item
            };
        });
        if (isWacRefresh) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cwAPf.TabsSection), {
            tabsData: tabsData,
            tabSize: tabSize
        });
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7kpd6.TabsSection), {
            alignment: "center",
            tabsData: tabsData,
            // Non refresh 12 column tabs are only large size. Small breaks the grid layout.
            tabSize: "large",
            bgColor: bgColor,
            enableRovoBorder: enableRovoBorder,
            enableResponsiveTabSize: enableResponsiveTabSize
        });
    }, [
        bgColor,
        enableRovoBorder,
        enableResponsiveTabSize
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "8",
                tabletLayout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                    title: headerText,
                    text: subHeaderText,
                    titleAs: "h2",
                    alignment: isWacRefresh ? {
                        mobile: 'start',
                        tablet: 'center',
                        desktop: 'center'
                    } : 'center'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $97121cc693296ff7$export$2e2bcd8739ae039 = $97121cc693296ff7$var$UniformTabs12Col;

});
parcelRegister("7kpd6", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $55e394e1b826b27b$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $4q5Ua = parcelRequire("4q5Ua");

var $6Iidb = parcelRequire("6Iidb");

var $kFhJA = parcelRequire("kFhJA");

var $aeZV4 = parcelRequire("aeZV4");
const $55e394e1b826b27b$export$502de1d4d55224c1 = ({ alignment: alignment = 'start', tabsData: tabsData, tabSize: tabSize = 'large', bgColor: bgColor = 'bgWhite', enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const sectionStyles = null;
    const fullWidthContainerStyles = null;
    const enableIconTabs = tabsData.every((tab)=>tab.iconUrl);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $aeZV4.Tabs), {
            tabIds: tabsData.map((tab)=>tab.id),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Iidb.DraggableTabList), {
                    tabSize: tabSize,
                    alignment: alignment,
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $4q5Ua.DraggableTab), {
                            tabIndex: index,
                            title: tab.title,
                            iconUrl: enableIconTabs ? tab.iconUrl : undefined,
                            tabSize: tabSize,
                            bgColor: bgColor,
                            className: "round-tab",
                            enableRovoBorder: enableIconTabs && enableRovoBorder,
                            enableResponsiveTabSize: enableIconTabs && enableResponsiveTabSize
                        }, index))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        tabSize === 'large' && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _1reoewfl _18m9ewfl _bozgzwfg _y4tizwfg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                        "tab-panels"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $kFhJA.TabPanel), {
                            panelIndex: index,
                            id: tab.id || `tab-${index}`,
                            children: tab.tabComponent
                        }, index))
                })
            ]
        })
    });
};

});
parcelRegister("4q5Ua", function(module, exports) {
$parcel$export(module.exports, "DraggableTab", function () { return $2726a747230786c6$export$3a29ca89d63c5c20; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $aeZV4 = parcelRequire("aeZV4");
const $2726a747230786c6$export$3a29ca89d63c5c20 = ({ id: id, focus: focus, tabIndex: tabIndex, title: title, iconUrl: iconUrl, tabSize: tabSize = 'large', bgColor: bgColor = 'bgWhite', label: label, dataEventProps: dataEventProps, className: className, enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false, children: children, ...props })=>{
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $aeZV4.useTabsContext)();
    const startX = (0, $1oC0p.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $1oC0p.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
        // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            if (tabRef.current.parentElement?.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: 'smooth'
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event('select'));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        startX.current = e.clientX ?? 0;
        props.onMouseDown?.(e);
    };
    const onClick = (0, $1oC0p.useCallback)((e)=>{
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        props.onClick?.(e);
        if (isTabSelected) return;
        goToTab(tabIndex);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === 'Space' || e.code === 'Enter') {
            goToTab(tabIndex);
            e.preventDefault();
        }
    };
    const tabColor = bgColor === 'bgWhite' ? (0, $kbpa7.wacToken)('color.neutral.light200') : (0, $kbpa7.wacToken)('color.neutral.light0');
    const tabStyles = null;
    const rovoBorderStyles = null;
    const borderStyles = null;
    const largeTabStyles = null;
    const smallTabStyles = null;
    const iconTabStyles = null;
    const iconLargeTabStyles = null;
    const iconSmallTabStyles = null;
    const responsiveIconTabStyles = null;
    const iconLargeContainerStyles = null;
    const iconSmallContainerStyles = null;
    const responsiveIconContainerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...props,
        // @ts-expect-error not on type
        ref: tabRef,
        className: className,
        children: !!children ? /*#__PURE__*/ (0, $1oC0p.cloneElement)(children, {
            onMouseDown: onMouseDown,
            onClick: onClick,
            onKeyDown: onKeyDown,
            ...dataEventProps
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
            type: "button",
            id: `tab${id}`,
            role: "tab",
            "aria-selected": isTabSelected,
            "aria-controls": `panel${id}`,
            "aria-label": label,
            title: label,
            tabIndex: isTabSelected ? 0 : -1,
            className: (0, $2jatx.default)([
                "_o5721q9c _1ul9ymf6 _bfhk1jrh _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko1mv1 _19itq75r _80omtlke _4cvx5hrz _iidzm8mt _1kyx1g23",
                iconUrl && "_2lx21bp4 _2rkoi2wt _1wyb1j6v",
                iconUrl && enableRovoBorder ? "_1h6d1j28 _1s79mzrp _1esp1ws1 _494pusvi _iusibx47" : "_1npj1bjw _1s795hrz",
                iconUrl && enableResponsiveTabSize && "_4t3i1n2x _1ul9176v _1yt437zh _1xlocmky _1d2y11ux _6ytt139i",
                !iconUrl && tabSize === 'large' && "_ca0qdlk8 _u5f31f4h _n3tddlk8 _19bv1f4h _vwz41f4h _4t3i1wqb _1wyb1cby",
                !iconUrl && tabSize === 'small' && "_1yt41c98 _vwz4v47k _4t3i1ylp _1wyb1j6v",
                iconUrl && !enableResponsiveTabSize && tabSize === 'large' && "_4t3icmky _1ul911ux _1yt4139i",
                iconUrl && !enableResponsiveTabSize && tabSize === 'small' && "_4t3i1n2x _1ul9176v _1yt437zh",
                `${isTabSelected ? 'currentTab' : ''}`
            ]),
            // how to adjust for different page? or just remove?
            "data-product-key": "template",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "tabsMenu",
            "data-label": title,
            onMouseDown: onMouseDown,
            onClick: onClick,
            onKeyDown: onKeyDown,
            ...dataEventProps,
            style: {
                "--_7aj7gm": (0, $6ZVlx.default)(tabColor),
                "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
            },
            children: [
                iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        !enableResponsiveTabSize && tabSize === 'large' && "_4t3ickbl _1bsbckbl",
                        !enableResponsiveTabSize && tabSize === 'small' && "_4t3i10mc _1bsb10mc",
                        enableResponsiveTabSize && "_4t3i10mc _1bsb10mc _1xlockbl _14b5ckbl",
                        "default-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: `${iconUrl || ''}`,
                        alt: '',
                        draggable: false
                    })
                }),
                title
            ]
        })
    });
};
$2726a747230786c6$export$3a29ca89d63c5c20.tabsRole = 'Tab';

});
parcelRegister("aeZV4", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return $0f3c3abb0b914582$export$5c3d36c3adf0ba92; });
$parcel$export(module.exports, "Tabs", function () { return $0f3c3abb0b914582$export$b2539bed5023c21c; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $aHkxS = parcelRequire("aHkxS");

var $jgQie = parcelRequire("jgQie");
const $0f3c3abb0b914582$var$TabsContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $0f3c3abb0b914582$export$5c3d36c3adf0ba92 = ()=>{
    const context = (0, $1oC0p.useContext)($0f3c3abb0b914582$var$TabsContext);
    if (!context) throw new Error('useTabsContext must be used within Tabs');
    return context;
};
let $0f3c3abb0b914582$var$nextId = 0;
function $0f3c3abb0b914582$var$getTabIndexFromUrl(tabIds) {
    if (typeof window === 'undefined') return null;
    const params = new URLSearchParams(window.location.search);
    const tabParam = params.get('tab');
    if (!tabParam) return null;
    const index = tabIds.indexOf(tabParam);
    return index !== -1 ? index : null;
}
const $0f3c3abb0b914582$export$b2539bed5023c21c = ({ id: id, initialTab: initialTab, loop: loop = true, tabIds: externalTabIds, children: children, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)(initialTab ?? 0);
    const [userSelected, setUserSelected] = (0, $1oC0p.useState)(false);
    // Apply the `tab` querystring after mount to avoid a hydration mismatch
    (0, $1oC0p.useEffect)(()=>{
        if (!externalTabIds || externalTabIds.length === 0) return;
        const urlIndex = $0f3c3abb0b914582$var$getTabIndexFromUrl(externalTabIds);
        if (urlIndex !== null) setCurrentTab(urlIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [focus, setFocus] = (0, $1oC0p.useState)(false);
    const tabIds = (0, $1oC0p.useRef)([]);
    const contextId = (0, $1oC0p.useRef)(`:tabs:${id ? id : $0f3c3abb0b914582$var$nextId++}:`);
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD,
        ...useInViewOptionsContainer
    });
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $jgQie.deepForEach)(children, (child)=>{
            if ((0, $jgQie.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        const tabsCount = getTabsCount();
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - tabsCount;
        // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
        // Map children to dynamically setup refs
        return (0, $jgQie.deepMap)(children, (child)=>{
            let result = child;
            // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement;
            // Get the active element id
            const activeElementId = windowAvailable ? window.document.activeElement?.id : null;
            // Clone TabList and Tab components to have refs
            if ((0, $jgQie.isTabList)(child)) {
                let listIndex = 0;
                // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $1oC0p.Children).toArray(child.props.children).filter((0, $jgQie.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                    children: (0, $jgQie.deepMap)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $1oC0p.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $jgQie.isTabPanel)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = {
                    ...existingProps,
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                };
                panelIndex++;
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, props);
            }
            return result;
        });
    }
    const unsetUserSelected = ()=>{
        setUserSelected(false);
    };
    const goToTab = (tabIndex)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
        setUserSelected(true);
        if (externalTabIds && externalTabIds.length > tabIndex && typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            params.set('tab', externalTabIds[tabIndex]);
            const newUrl = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
            window.history.replaceState(null, '', newUrl);
        }
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === 'ArrowLeft' || e.code === 'ArrowUp') goToPrevTab();
        else if (e.code === 'ArrowRight' || e.code === 'ArrowDown') goToNextTab();
        else if (e.code === 'End') // Select last tab (End key)
        goToFirstTab();
        else if (e.code === 'Home') // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true);
        // This prevents scrollbars from moving around
        e.preventDefault();
    };
    // Reset the userSelected state when the section is visible again
    (0, $1oC0p.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]);
    // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    const containerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($0f3c3abb0b914582$var$TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            unsetUserSelected: unsetUserSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: containerScrollRef,
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulp1jfw _1reo15vq _18m915vq"
            ]),
            children: getChildren()
        })
    });
};

});
parcelRegister("jgQie", function(module, exports) {
$parcel$export(module.exports, "isTab", function () { return $5fe887815c1bacdb$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $5fe887815c1bacdb$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $5fe887815c1bacdb$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $5fe887815c1bacdb$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $5fe887815c1bacdb$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $5fe887815c1bacdb$export$519ada94592b97fc; });

var $1oC0p = parcelRequire("1oC0p");
function $5fe887815c1bacdb$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $5fe887815c1bacdb$export$bdc9792d96913679 = $5fe887815c1bacdb$var$makeTypeChecker('Tab');
const $5fe887815c1bacdb$export$9c326233b9ae5588 = $5fe887815c1bacdb$var$makeTypeChecker('TabList');
const $5fe887815c1bacdb$export$9e12445c79db89b = $5fe887815c1bacdb$var$makeTypeChecker('TabPanel');
const $5fe887815c1bacdb$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === 'function';
function $5fe887815c1bacdb$var$isTabChild(child) {
    return $5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9c326233b9ae5588(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child);
}
function $5fe887815c1bacdb$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($5fe887815c1bacdb$export$dbaa4172856e20ab(child)) return (0, $1oC0p.cloneElement)(child, {
        ...child.props,
        ...additionalProps
    });
    return child;
}
function $5fe887815c1bacdb$export$ce7eaaed37329a1b(children, callback) {
    return (0, $1oC0p.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($5fe887815c1bacdb$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === 'object') // Clone the child that has children and map them too
        return (0, $1oC0p.cloneElement)(child, {
            ...child.props,
            children: $5fe887815c1bacdb$export$ce7eaaed37329a1b(child.props.children, callback)
        });
        return child;
    });
}
function $5fe887815c1bacdb$export$519ada94592b97fc(children, callback) {
    return (0, $1oC0p.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === 'object') {
            if ($5fe887815c1bacdb$export$9c326233b9ae5588(child)) callback(child, index);
            $5fe887815c1bacdb$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});



parcelRegister("6Iidb", function(module, exports) {
$parcel$export(module.exports, "DraggableTabList", function () { return $5334c6b54e489af6$export$dbb4ac5a817c6612; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $aeZV4 = parcelRequire("aeZV4");
const $5334c6b54e489af6$export$dbb4ac5a817c6612 = ({ alignment: alignment = 'start', tabSize: // @ts-expect-error unused
// eslint-disable-next-line @typescript-eslint/no-unused-vars
tabSize = 'large', children: children })=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const mouseDown = (0, $1oC0p.useRef)(false);
    const startX = (0, $1oC0p.useRef)(0);
    const scrollLeft = (0, $1oC0p.useRef)(0);
    const canDrag = (0, $1oC0p.useRef)(false);
    const { onKeyDown: onKeyDown } = (0, $aeZV4.useTabsContext)();
    const startDragging = (mouse, touch)=>{
        if (!canDrag.current) return;
        // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener('mouseup', stopDragging);
        document.addEventListener('mousemove', move);
        mouseDown.current = true;
        startX.current = (touch && touch.touches[0] ? touch.touches[0].clientX : mouse?.clientX) ?? 0;
        scrollLeft.current = containerRef.current?.scrollLeft ?? 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
        // Stop listening for mouseup and mousemove events
        document.removeEventListener('mouseup', stopDragging);
        document.removeEventListener('mousemove', move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    (0, $1oC0p.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        const setStartingPoint = ()=>{
            if (containerRef.current) {
                if (canDrag.current) {
                    const tabPanels = document.querySelector('.tab-panels');
                    const tabPanelsStyle = tabPanels && window.getComputedStyle(tabPanels);
                    containerRef.current.setAttribute('style', `padding-left: calc(${tabPanelsStyle?.marginLeft} + ${tabPanelsStyle?.paddingLeft});`);
                } else if (alignment === 'start') containerRef.current.setAttribute('style', 'margin-inline: 0px; padding-inline: 0px;');
            }
        };
        if (!containerRef.current) return;
        const observer = new ResizeObserver(()=>{
            updateCanDrag();
            setStartingPoint();
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    });
    const wrapperStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1reo15vq _p12f1osq _195g1wug _18zrzwfg _11q81vi7 _su071wqb _3hzp1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            // @ts-expect-error type
            onTouchStart: (e)=>startDragging(undefined, e),
            // @ts-expect-error type
            onMouseDown: (e)=>startDragging(e),
            onTouchEnd: (e)=>{
                // @ts-expect-error type
                move(undefined, e);
                stopDragging();
            },
            // @ts-expect-error type
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1bsb1ns9 _p12f1osq _1moupxbi _zulp1ejb",
                "tab-list"
            ]),
            tabIndex: -1,
            role: "tablist",
            children: children
        })
    });
};
const $5334c6b54e489af6$var$tabsContainerStyles = null;
$5334c6b54e489af6$export$dbb4ac5a817c6612.tabsRole = 'TabList';

});

parcelRegister("kFhJA", function(module, exports) {
$parcel$export(module.exports, "TabPanel", function () { return $73f95d72bd57759d$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");

var $jgQie = parcelRequire("jgQie");

var $aeZV4 = parcelRequire("aeZV4");
const $73f95d72bd57759d$var$hidePanelStyle = null;
const $73f95d72bd57759d$export$3d96ec278d3efce4 = ({ forceRender: forceRender, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole, ...props })=>{
    const { isCurrentTab: isCurrentTab } = (0, $aeZV4.useTabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? 'active-panel' : '';
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const originalChildrenCount = (0, $1oC0p.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { css: existingCss, ...propsWithoutCss } = props;
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith('aria-') && key !== 'role'));
    const inlineHideStyle = !isTabSelected && !forceRender ? {
        display: 'none'
    } : undefined;
    if (!shouldHideRole) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...filteredProps,
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                'tab-panel',
                activeClass
            ].join(' ')
        ]),
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                'tab-panel',
                activeClass
            ].join(' ')
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$73f95d72bd57759d$export$3d96ec278d3efce4.tabsRole = 'TabPanel';

});


parcelRegister("cwAPf", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $0addd04cdd862bb0$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kbpa7 = parcelRequire("kbpa7");

var $60ByZ = parcelRequire("60ByZ");

var $lDmb2 = parcelRequire("lDmb2");

var $1dc5i = parcelRequire("1dc5i");
const $0addd04cdd862bb0$var$getResolvedTabId = (tab, index)=>tab.id ?? `tab-${index + 1}`;
const $0addd04cdd862bb0$var$getTabIdFromHash = (tabsData)=>{
    if (typeof window === 'undefined') return undefined;
    const hash = window.location.hash.slice(1);
    return tabsData.find((tab, index)=>$0addd04cdd862bb0$var$getResolvedTabId(tab, index) === hash) ? hash : undefined;
};
const $0addd04cdd862bb0$var$sectionStyles = null;
const $0addd04cdd862bb0$var$tabListInnerContainerStyles = null;
// Single-cell grid that stacks every TabPanel in the same `gridArea: 1 / 1`,
// so the active panel and inactive panels share the same screen position.
// The container auto-sizes to the tallest panel — no layout shift between
// tabs, and we get a true opacity-only cross-fade. Same idiom as
// `customer-testimonials` (panel grid: 1fr / 1fr). Spec: GWP-11578.
const $0addd04cdd862bb0$var$panelStackStyles = null;
const $0addd04cdd862bb0$export$502de1d4d55224c1 = ({ tabsData: tabsData, tabSize: tabSize = 'large' })=>{
    // Match SSR (no hash on the server) to avoid a hydration mismatch; the hash is applied after mount.
    const [activeTabId, setActiveTabId] = (0, $1oC0p.useState)(()=>tabsData[0] ? $0addd04cdd862bb0$var$getResolvedTabId(tabsData[0], 0) : undefined);
    // Only focus on user selection; for hash-driven selection the browser focuses the target panel.
    const [shouldFocusActiveTab, setShouldFocusActiveTab] = (0, $1oC0p.useState)(false);
    const handleTabSelect = (tabId)=>{
        setShouldFocusActiveTab(true);
        setActiveTabId(tabId);
        // Update URL hash without scrolling
        window.history.replaceState(null, '', `#${tabId}`);
    };
    // Apply the deep-linked tab and listen for back/forward navigation
    (0, $1oC0p.useEffect)(()=>{
        const initialTabId = $0addd04cdd862bb0$var$getTabIdFromHash(tabsData);
        if (initialTabId) {
            setShouldFocusActiveTab(false);
            setActiveTabId(initialTabId);
        }
        const handleHashChange = ()=>{
            const tabId = $0addd04cdd862bb0$var$getTabIdFromHash(tabsData);
            if (tabId) {
                setShouldFocusActiveTab(false);
                setActiveTabId(tabId);
            }
        };
        window.addEventListener('hashchange', handleHashChange);
        return ()=>{
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [
        tabsData
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpxy5q _19wg1jfw _pdlmoahv _1es1idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "10",
                tabletLayout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_195g1wug _p12f1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lDmb2.TabList), {
                        activeTabId: activeTabId,
                        children: tabsData.map((tab, index)=>{
                            const resolvedId = $0addd04cdd862bb0$var$getResolvedTabId(tab, index);
                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $60ByZ.Tab), {
                                tabId: resolvedId,
                                index: index,
                                title: tab.title,
                                isActive: resolvedId === activeTabId,
                                onTabSelect: handleTabSelect,
                                tabSize: tabSize,
                                focusOnActivate: shouldFocusActiveTab
                            }, resolvedId);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _yv0ehkll _2z05hkll"
                    ]),
                    children: tabsData.map((tab, index)=>{
                        const resolvedId = $0addd04cdd862bb0$var$getResolvedTabId(tab, index);
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1dc5i.TabPanel), {
                            id: resolvedId,
                            isActive: resolvedId === activeTabId,
                            children: tab.tabComponent
                        }, resolvedId);
                    })
                })
            })
        ]
    });
};

});


parcelRegister("eWY7v", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bd4a0508f0e82f76$export$2e2bcd8739ae039; });
/* tabs-8-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $2axoc = parcelRequire("2axoc");

var $7kpd6 = parcelRequire("7kpd6");
const $bd4a0508f0e82f76$var$uniformTabsContainerStyles = null;
const $bd4a0508f0e82f76$var$UniformTabs8Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = 'bgWhite' })=>{
    const renderTabs = ({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            const params = // @ts-ignore
            item.props?.children?.props?.data?.parameters;
            return {
                id: params?.id?.value ?? `tab-${index}`,
                title: params?.title?.value,
                tabComponent: item
            };
        });
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7kpd6.TabsSection), {
            alignment: "start",
            tabsData: tabsData,
            tabSize: 'small',
            bgColor: bgColor
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                title: headerText,
                titleAs: "h2",
                alignment: "start",
                text: subHeaderText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $bd4a0508f0e82f76$export$2e2bcd8739ae039 = $bd4a0508f0e82f76$var$UniformTabs8Col;

});

parcelRegister("kov0f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f8a7af495f51869f$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $feDrk = parcelRequire("feDrk");
const $f8a7af495f51869f$var$UniformTakeoverBanner = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $feDrk.TakeoverBanner), {
        ...props,
        dataEventProps: {
            'data-product-key': 'uniform',
            'data-event-component': 'linkButton',
            'data-event-container': 'takeoverBanner',
            'data-event': 'clicked'
        }
    });
};
var $f8a7af495f51869f$export$2e2bcd8739ae039 = $f8a7af495f51869f$var$UniformTakeoverBanner;

});
parcelRegister("feDrk", function(module, exports) {
$parcel$export(module.exports, "TakeoverBanner", function () { return $22525f9721467aac$export$d9a54014f9277bbe; });
/* takeover-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $cNOwN = parcelRequire("cNOwN");

var $bQjAr = parcelRequire("bQjAr");

var $hdakC = parcelRequire("hdakC");

var $hNGnM = parcelRequire("hNGnM");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");
const $22525f9721467aac$var$CalendarIcon = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "18",
        height: "24",
        viewBox: "0 0 18 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                clipPath: "url(#clip0_453_18476)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.875 3.875H10.625V2H13.125V3.875H17.5V21.375H0V3.875H4.375V2H6.875V3.875ZM6.875 6.375V8.25H4.375V6.375H2.5V10.75H15V6.375H13.125V8.25H10.625V6.375H6.875Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_453_18476",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "17.5",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $22525f9721467aac$var$LocationIcon = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "14",
        height: "24",
        viewBox: "0 0 14 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                clipPath: "url(#clip0_453_18479)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.57503 21.0625L1.17169 13.2277C-1.83124 8.87341 1.28569 2.9375 6.57503 2.9375C11.8644 2.9375 14.9813 8.87341 11.9784 13.2277L6.57503 21.0625ZM6.57501 12.625C8.3009 12.625 9.70001 11.2259 9.70001 9.5C9.70001 7.77411 8.3009 6.375 6.57501 6.375C4.84912 6.375 3.45001 7.77411 3.45001 9.5C3.45001 11.2259 4.84912 12.625 6.57501 12.625Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_453_18479",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "13.15",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $22525f9721467aac$export$d9a54014f9277bbe = ({ logoUrl: logoUrl, logoAlt: logoAlt, dates: dates, location: location, title: title, body: body, buttonLabel: buttonLabel, buttonHref: buttonHref, linkText: linkText, linkHref: linkHref, dataEventProps: dataEventProps, mediaType: mediaType = 'video', videoUrl: videoUrl, posterUrl: posterUrl, videoDescription: videoDescription, imageUrl: imageUrl, imageAlt: imageAlt, onClose: onClose })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [isDismissed, setIsDismissed] = (0, $1oC0p.useState)(false);
    const headingId = (0, $1oC0p.useId)();
    const buttonId = (0, $1oC0p.useId)();
    const linkId = (0, $1oC0p.useId)();
    const closeLabel = intl.formatMessage({
        id: 'takeoverBanner.closeButtonLabel',
        defaultMessage: 'Close'
    });
    const handleClose = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'closeTakeoverBanner',
            source: 'takeoverBanner',
            attributes: {
                label: 'Close banner'
            }
        }).fire();
        setIsDismissed(true);
        onClose?.();
    };
    const shouldRenderImage = mediaType === 'image';
    if (isDismissed) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "takeover-banner",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq _18s8ze3t _kqswh2mm _1e0c1txw _4t3ixilx _c71lglyw _4cvr1fhb _1bah1h6o _1ikw1y37 _tnru1wug _123r1pna _1o8315vq _98bk1wug _bfhk1pfd _1tgfze3t"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    "aria-label": closeLabel,
                    onClick: handleClose,
                    className: (0, $2jatx.default)([
                        "_r06hglyw _kqswstnw _152tpxbi _rjxppxbi _1pby11wp _1e0c116y _4cvr1h6o _1bah1h6o _vchhusvi _16jlidpf _1o9zidpf _i0dl1wug _1h1t1ekt _15k51jfw _1kz61jfw _uhwn1jfw _ugzy1jfw _bu0k1jfw _ofie1jfw _1yt4ze3t _19itglyw _2rko1osq _bfhk1j28 _80omtlke _1ygb7g83 _1ah3v77o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_bfhk6u2e _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _vchhusvi _16jlidpf _1o9zidpf _i0dl1wug _1h1t1ekt _15k51jfw _1kz61jfw _uhwn1jfw _ugzy1jfw _bu0k1jfw _ofie1jfw _16jxxy5q _11lcxy5q _15mnxy5q _16m5xy5q _1km9xy5q _wvzdxy5q _irr3s3kk _1di6s3kk"
                        ]),
                        style: {
                            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1pfd _1e0c1txw _vwz4idpf"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                                label: "",
                                size: "medium",
                                color: "currentColor"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                    layout: "6-6",
                    tabletLayout: "6-6",
                    mobileLayout: "12",
                    verticalAlignment: "center",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1e0c1txw _zulp1ejb _2lx21bp4 _1bah1h6o _4cvr1y6m _1wpz1fhb _vchhusvi _bfhk1pfd _1rjc1jfw _l6bk1afi _qpy4ze3t _1hig1afi _17t3ze3t"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx21bp4 _zulppxbi"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                            src: logoUrl,
                                            alt: logoAlt ?? '',
                                            className: (0, $2jatx.default)([
                                                "_1wpz1y6m _1e0c1ule _4t3i1f4h _p12f1osq _1bsb1wug _165t1ylp _1ikw12am"
                                            ])
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _1n261g80 _gy1pxy5q _1p57u2gc"
                                            ]),
                                            children: [
                                                dates && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_syaz1afi _4cvr1h6o _1e0c1txw _zulputpp _o5721q9c"
                                                    ]),
                                                    style: {
                                                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_4cvr1h6o _1e0c116y _1o9zidpf _1bah1h6o _vwz4idpf _1bsbf6fq"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($22525f9721467aac$var$CalendarIcon, {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: "body-md-bold",
                                                            children: dates
                                                        })
                                                    ]
                                                }),
                                                location && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_syaz1afi _4cvr1h6o _1e0c1txw _zulputpp _o5721q9c"
                                                    ]),
                                                    style: {
                                                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_4cvr1h6o _1e0c116y _1o9zidpf _1bah1h6o _vwz4idpf _1bsbf6fq"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($22525f9721467aac$var$LocationIcon, {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: "body-md-bold",
                                                            children: location
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx21bp4 _zulp1b66 _1bsb1osq"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: "card-title",
                                            id: headingId,
                                            children: title
                                        }),
                                        body && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: "body-md",
                                            children: body
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1n261g80 _gy1pv47k _1p57v47k _4cvr1h6o"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                            href: buttonHref,
                                            id: buttonId,
                                            size: "small",
                                            variant: "secondary",
                                            colorAgainst: "black",
                                            dataEventProps: dataEventProps,
                                            ariaLabelledby: `${headingId} ${buttonId}`,
                                            children: buttonLabel
                                        }),
                                        linkText && linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                            text: linkText,
                                            href: linkHref,
                                            id: linkId,
                                            type: "primary",
                                            bgColor: "bgBlackBlue",
                                            dataEventProps: dataEventProps,
                                            ariaLabelledby: `${headingId} ${linkId}`,
                                            "aria-label": linkText
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1e0c11p5 _1wpz1fhb _1bsb1osq _sugaglyw"
                            ]),
                            children: shouldRenderImage && imageUrl ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hdakC.BlurredBackgroundImage), {
                                src: imageUrl,
                                alt: imageAlt ?? ''
                            }) : shouldRenderImage ? null : videoUrl ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hNGnM.BlurredBackgroundVideo), {
                                src: videoUrl,
                                poster: posterUrl,
                                videoDescription: videoDescription
                            }) : posterUrl ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hdakC.BlurredBackgroundImage), {
                                src: posterUrl,
                                alt: videoDescription ?? ''
                            }) : null
                        })
                    ]
                })
            ]
        })
    });
};
const $22525f9721467aac$var$containerStyles = null;
const $22525f9721467aac$var$closeButtonStyles = null;
const $22525f9721467aac$var$closeButtonCircleStyles = null;
const $22525f9721467aac$var$closeIconStyles = null;
const $22525f9721467aac$var$leftSideStyles = null;
const $22525f9721467aac$var$rightSideStyles = null;
const $22525f9721467aac$var$timePlaceDetailsStyles = null;
const $22525f9721467aac$var$timePlaceDetailStyles = null;
const $22525f9721467aac$var$timePlaceDetailIconStyles = null;
const $22525f9721467aac$var$copyGroupStyles = null;
const $22525f9721467aac$var$buttonAreaStyles = null;
const $22525f9721467aac$var$logoAndTimePlaceDetailsStyles = null;
const $22525f9721467aac$var$logoImageStyles = null;
$22525f9721467aac$export$d9a54014f9277bbe.displayName = 'TakeoverBanner';

});
parcelRegister("hdakC", function(module, exports) {
$parcel$export(module.exports, "BlurredBackgroundImage", function () { return $4c0e50e3bc46280b$export$b1fd66ca6619e8bb; });
/* blurred-background-image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $4c0e50e3bc46280b$export$b1fd66ca6619e8bb = ({ src: src, alt: alt, caption: caption, className: className, style: style, contentType: contentType, maxPossibleWidth: maxPossibleWidth, ...rest })=>{
    if (!src) return null;
    const image = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c11p5 _16jlkb7n _1wpz1fhb _10fp1fhb _1reo15vq _18m915vq _7ccakre2 _bfhk1afi",
            className
        ]),
        style: {
            ...style,
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04ze3t _kdamxov6 _t9ec17pv _lcxvglyw _28uc1ule _h4u91osq _sfo51osq _6o691dfr"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: src,
                    alt: "",
                    contentType: contentType,
                    maxPossibleWidth: maxPossibleWidth
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1pbykb7n _1wpz1h6o _10fp1h6o _1h1tcq2i _15k5jdz9 _1kz61mnx _28uc1ule _h4u91osq _sfo51osq _6o691dfr"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    ...rest,
                    src: src,
                    alt: alt,
                    contentType: contentType,
                    maxPossibleWidth: maxPossibleWidth
                })
            })
        ]
    });
    return caption ? /*#__PURE__*/ (0, $7VQPk.jsxs)("figure", {
        className: (0, $2jatx.default)([
            "_18s8ze3t"
        ]),
        children: [
            image,
            /*#__PURE__*/ (0, $7VQPk.jsx)("figcaption", {
                className: (0, $2jatx.default)([
                    "_1pfhu2gc",
                    "body-sm"
                ]),
                children: caption
            })
        ]
    }) : image;
};
const $4c0e50e3bc46280b$var$imageWrapperStyles = null;
const $4c0e50e3bc46280b$var$backgroundImageStyles = null;
const $4c0e50e3bc46280b$var$foregroundImageFrameStyles = null;
$4c0e50e3bc46280b$export$b1fd66ca6619e8bb.displayName = 'BlurredBackgroundImage';

});

parcelRegister("hNGnM", function(module, exports) {
$parcel$export(module.exports, "BlurredBackgroundVideo", function () { return $98abea4f78d1deec$export$e241ccdc594df92f; });
/* blurred-background-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jElRc = parcelRequire("jElRc");

var $kbpa7 = parcelRequire("kbpa7");
const $98abea4f78d1deec$export$e241ccdc594df92f = ({ src: src, poster: poster, videoDescription: videoDescription })=>{
    const backgroundVideoRef = (0, $1oC0p.useRef)(null);
    const foregroundVideoRef = (0, $1oC0p.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, $1oC0p.useState)(false);
    const syncBackgroundVideo = (0, $1oC0p.useCallback)(()=>{
        const backgroundVideo = backgroundVideoRef.current;
        const foregroundVideo = foregroundVideoRef.current;
        if (!backgroundVideo || !foregroundVideo) return;
        if (Math.abs(backgroundVideo.currentTime - foregroundVideo.currentTime) > 0.25) backgroundVideo.currentTime = foregroundVideo.currentTime;
    }, []);
    const pauseVideos = (0, $1oC0p.useCallback)(()=>{
        foregroundVideoRef.current?.pause();
        backgroundVideoRef.current?.pause();
        setIsPlaying(false);
    }, []);
    const playVideos = (0, $1oC0p.useCallback)(()=>{
        const foregroundVideo = foregroundVideoRef.current;
        const backgroundVideo = backgroundVideoRef.current;
        if (!foregroundVideo) return;
        syncBackgroundVideo();
        if (backgroundVideo) backgroundVideo.play().catch(()=>undefined);
        foregroundVideo.play().then(()=>{
            setIsPlaying(true);
        }).catch(()=>{
            backgroundVideo?.pause();
            setIsPlaying(false);
        });
    }, [
        syncBackgroundVideo
    ]);
    const handleToggleVideoPlayback = (0, $1oC0p.useCallback)(()=>{
        if (isPlaying) {
            pauseVideos();
            return;
        }
        playVideos();
    }, [
        isPlaying,
        pauseVideos,
        playVideos
    ]);
    const handleForegroundVideoPlay = (0, $1oC0p.useCallback)(()=>{
        const backgroundVideo = backgroundVideoRef.current;
        syncBackgroundVideo();
        if (backgroundVideo?.paused) backgroundVideo.play().catch(()=>undefined);
        setIsPlaying(true);
    }, [
        syncBackgroundVideo
    ]);
    const handleForegroundVideoPause = (0, $1oC0p.useCallback)(()=>{
        backgroundVideoRef.current?.pause();
        setIsPlaying(false);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        const foregroundVideo = foregroundVideoRef.current;
        if (!foregroundVideo) return undefined;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry?.isIntersecting) {
                foregroundVideo.currentTime = 0;
                if (backgroundVideoRef.current) backgroundVideoRef.current.currentTime = 0;
                playVideos();
                return;
            }
            pauseVideos();
        }, {
            threshold: 0.5
        });
        observer.observe(foregroundVideo);
        return ()=>{
            observer.disconnect();
        };
    }, [
        pauseVideos,
        playVideos
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c11p5 _16jlkb7n _1wpz1fhb _10fp1fhb _1reo15vq _18m915vq _7ccakre2 _bfhk1afi"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                ref: backgroundVideoRef,
                src: src,
                playsInline: true,
                muted: true,
                preload: "auto",
                poster: poster,
                loop: true,
                "aria-hidden": "true",
                tabIndex: -1,
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04ze3t _15k51osq _1kz61osq _19itidpf _kdamxov6 _t9ec17pv _5ral1dfr _lcxvglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("track", {
                    kind: "captions"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1pbykb7n _1wpz1h6o _10fp1h6o _1h1tcq2i _15k5jdz9 _1kz61mnx"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        ref: foregroundVideoRef,
                        src: src,
                        playsInline: true,
                        muted: true,
                        preload: "auto",
                        poster: poster,
                        loop: true,
                        "aria-label": videoDescription ?? '',
                        "aria-hidden": !videoDescription,
                        onPlay: handleForegroundVideoPlay,
                        onPause: handleForegroundVideoPause,
                        onEnded: handleForegroundVideoPause,
                        onTimeUpdate: syncBackgroundVideo,
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _15k51osq _1kz61osq _19itidpf _bfhk1j28 _5ral1f51"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("track", {
                            kind: "captions"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _u7copxbi _rjxppxbi _1pbycs5v"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                            isPlaying: isPlaying,
                            onToggle: handleToggleVideoPlayback,
                            mediaLabel: videoDescription
                        })
                    })
                ]
            })
        ]
    });
};
const $98abea4f78d1deec$var$videoWrapperStyles = null;
const $98abea4f78d1deec$var$backgroundVideoStyles = null;
const $98abea4f78d1deec$var$foregroundVideoFrameStyles = null;
const $98abea4f78d1deec$var$foregroundVideoStyles = null;
const $98abea4f78d1deec$var$videoControlsStyles = null;
$98abea4f78d1deec$export$e241ccdc594df92f.displayName = 'BlurredBackgroundVideo';

});



parcelRegister("gSQsG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4d767380087f2189$export$2e2bcd8739ae039; });
/* teamwork-graph.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $dZNgt = parcelRequire("dZNgt");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $UMzWl = parcelRequire("UMzWl");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $iRMRa = parcelRequire("iRMRa");

var $ivETl = parcelRequire("ivETl");

var $fk4mX = parcelRequire("fk4mX");
const $4d767380087f2189$var$GRID_IMG = 'https://dam-cdn.atl.orangelogic.com/AssetLink/857qv237n203wnkea8wgamk2a2us4uy2.png';
const $4d767380087f2189$var$JIRA_IMG = 'https://dam-cdn.atl.orangelogic.com/AssetLink/jc0417320bg81b53h4sgs70q6l464500.svg';
const $4d767380087f2189$var$textPosition = {
    x: 22,
    y: 70
};
const $4d767380087f2189$var$videoPosition = {
    x: 68,
    y: 47
};
const $4d767380087f2189$var$vidFrontDimension = 560;
const $4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS = [
    {
        x: 105,
        y: 20
    },
    {
        x: 0,
        y: 20
    }
];
const $4d767380087f2189$var$LOZENGE_POSITIONS = [
    {
        x: $4d767380087f2189$var$videoPosition.x - 1,
        y: $4d767380087f2189$var$videoPosition.y + 11
    },
    {
        x: $4d767380087f2189$var$videoPosition.x + 2,
        y: $4d767380087f2189$var$videoPosition.y + 18
    },
    {
        x: $4d767380087f2189$var$videoPosition.x + 4,
        y: $4d767380087f2189$var$videoPosition.y + 25
    }
];
const $4d767380087f2189$var$LOZENGE_ATTRIBUTES = {
    shape: 'rectangle',
    color: 'blue600',
    textColor: 'white',
    fontFamily: 'charlie',
    fontWeight: 400,
    imagePlacement: 'outsideLeading',
    size: 40,
    opacity: 0
};
const $4d767380087f2189$var$ICON_SHRUNKEN_SIZE = 38;
const $4d767380087f2189$var$ICON_NORMAL_SIZE = 72;
const $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE = 100;
const $4d767380087f2189$var$AVATAR_NORMAL_SIZE = 220;
const $4d767380087f2189$var$PILL_SHRUNKEN_SIZE = 45;
const $4d767380087f2189$var$PILL_NORMAL_SIZE = 65;
const $4d767380087f2189$var$FRAME_1_LEAVING_NODES_REF = {
    x: 32,
    y: 40
};
const $4d767380087f2189$var$FRAME_1_LEAVING_NODES_ANCHOR_AT_ZOOM = {
    x: 100,
    y: 40
};
const $4d767380087f2189$var$FRAME_1_LEAVING_POSITION_SCALE = 2.2;
function $4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(nodeX, nodeY) {
    return {
        x: $4d767380087f2189$var$FRAME_1_LEAVING_NODES_ANCHOR_AT_ZOOM.x + $4d767380087f2189$var$FRAME_1_LEAVING_POSITION_SCALE * (nodeX - $4d767380087f2189$var$FRAME_1_LEAVING_NODES_REF.x),
        y: $4d767380087f2189$var$FRAME_1_LEAVING_NODES_ANCHOR_AT_ZOOM.y + $4d767380087f2189$var$FRAME_1_LEAVING_POSITION_SCALE * (nodeY - $4d767380087f2189$var$FRAME_1_LEAVING_NODES_REF.y)
    };
}
/* frame 1 */ const $4d767380087f2189$var$FRAME_1_ZOOMIN_START = 3;
const $4d767380087f2189$var$FRAME_1_ZOOMIN_END = 9;
const $4d767380087f2189$var$FRAME_1_ADJUST_1_START = 9;
const $4d767380087f2189$var$FRAME_1_ADJUST_1_END = 11;
const $4d767380087f2189$var$FRAME_1_ADJUST_2_START = 11;
const $4d767380087f2189$var$FRAME_1_ADJUST_2_END = 13;
const $4d767380087f2189$var$FRAME_1_ADJUST_3_START = 13;
const $4d767380087f2189$var$FRAME_1_ADJUST_3_END = 15;
/* transition from frame 1 to frame 2 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START = 15;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END = 19;
/* frame 2 */ const $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_1 = 19;
const $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_2 = 20;
const $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_3 = 21;
const $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_START = 25;
const $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_END = 26;
/* transition from frame 2 to frame 3 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START = 29;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END = 33;
/* frame 3 */ const $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_1 = 33;
const $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_2 = 34;
const $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_3 = 35;
const $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_START = 39;
const $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_END = 40;
/* transition from frame 3 to frame 4 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START = 43;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END = 47;
/* frame 4 */ const $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_1 = 47;
const $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_2 = 48;
const $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_3 = 49;
const $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_START = 53;
const $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_END = 54;
/* transition from frame 4 to frame 5 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START = 57;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END = 61;
/* frame 5 */ const $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_1 = 61;
const $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_2 = 62;
const $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_3 = 63;
const $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_START = 67;
const $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_END = 68;
/* transition from frame 5 to frame 6 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START = 72;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END = 76;
/* frame 6 */ const $4d767380087f2189$var$FRAME_6_ADJUST_1_START = 76;
const $4d767380087f2189$var$FRAME_6_ADJUST_1_END = 79;
const $4d767380087f2189$var$FRAME_6_ADJUST_2_START = 79;
const $4d767380087f2189$var$FRAME_6_ADJUST_2_END = 82;
const $4d767380087f2189$var$FRAME_6_ADJUST_3_START = 82;
const $4d767380087f2189$var$FRAME_6_ADJUST_3_END = 84;
/* transition from frame 6 to frame 7 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START = 87;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END = 91;
/* frame 7 */ const $4d767380087f2189$var$FRAME_7_ADJUST_1_START = 91;
const $4d767380087f2189$var$FRAME_7_ADJUST_1_END = 92;
const $4d767380087f2189$var$FRAME_7_ADJUST_2_START = 94;
const $4d767380087f2189$var$FRAME_7_ADJUST_2_END = 97;
const $4d767380087f2189$var$FRAME_7_ADJUST_3_START = 97;
const $4d767380087f2189$var$FRAME_7_ADJUST_3_END = 100;
const $4d767380087f2189$var$FRAME_6_NODES_SHRINKING = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
    width: 1,
    height: 1,
    size: 1,
    opacity: 0,
    x: 18.6,
    y: 74.9
};
const $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
    x: -150
};
const $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
    x: -50,
    y: -50
};
const $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
    x: -50,
    y: 150
};
const $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
    x: 150,
    y: -50
};
const $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
    x: -150
};
const $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH = 768;
const $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_HEIGHT_SCALE = $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH / 440;
const $4d767380087f2189$var$scaledMobileTeamworkGraphHeight = (heightAt440)=>Math.round(heightAt440 * $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_HEIGHT_SCALE);
const $4d767380087f2189$var$mobileHeadingCss = {
    fontSize: '4rem'
};
const $4d767380087f2189$var$mobileDescriptionCss = {
    fontSize: '3rem'
};
const $4d767380087f2189$var$desktopHeadingCss = {
    fontSize: '2rem'
};
const $4d767380087f2189$var$desktopDescriptionCSS = {
    fontSize: '1.5rem'
};
const $4d767380087f2189$var$stickyWrapperCss = null;
const $4d767380087f2189$var$navigationContainerCss = null;
const $4d767380087f2189$var$progressTimelineCss = null;
const $4d767380087f2189$var$skipButtonCss = null;
const $4d767380087f2189$var$barsCss = null;
const $4d767380087f2189$var$barsBehindCss = null;
const $4d767380087f2189$var$barsFrontCss = null;
const $4d767380087f2189$var$gradientOverlayStyle = null;
const $4d767380087f2189$var$teamworkGraphDesktopOnlyStyles = null;
const $4d767380087f2189$var$teamworkGraphMobileOnlyStyles = null;
const $4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages = (0, $fnHPc.defineMessages)({
    frame2Heading: {
        id: 'teamworkGraph.frame2.heading.default',
        defaultMessage: 'With shared data from everywhere'
    },
    frame2Description: {
        id: 'teamworkGraph.frame2.description.default',
        defaultMessage: 'Connect data from every source to bring context to decisions, ideas, and workflows'
    },
    frame3Heading: {
        id: 'teamworkGraph.frame3.heading.default',
        defaultMessage: 'Connected to impact'
    },
    frame3Description: {
        id: 'teamworkGraph.frame3.description.default',
        defaultMessage: 'Teams and AI operate with awareness of priorities and time progress.'
    },
    frame4Heading: {
        id: 'teamworkGraph.frame4.heading.default',
        defaultMessage: 'In sync across every team'
    },
    frame4Description: {
        id: 'teamworkGraph.frame4.description.default',
        defaultMessage: 'Shared context means AI outputs are relevant and you never miss a beat.'
    },
    frame5Heading: {
        id: 'teamworkGraph.frame5.heading.default',
        defaultMessage: "Getting it 'Done' faster"
    },
    frame5Description: {
        id: 'teamworkGraph.frame5.description.default',
        defaultMessage: 'When teams are aligned and context-aware, they tap into Rovo to get their work done faster, with confidence.'
    }
});
const $4d767380087f2189$var$TEAMWORK_GRAPH_SKIP_SCROLL_MS = 1600;
const $4d767380087f2189$var$TEAMWORK_GRAPH_SKIP_SCROLL_TOP_PADDING_PX = 16;
const $4d767380087f2189$export$e061a00b0877e539 = [
    0,
    $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
    $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
    $4d767380087f2189$var$FRAME_1_ADJUST_3_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
    $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_3,
    $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
    $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_3,
    $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
    $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_3,
    $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
    $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_3,
    $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
    $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
    $4d767380087f2189$var$FRAME_6_ADJUST_3_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
    $4d767380087f2189$var$FRAME_7_ADJUST_2_END,
    100
];
const $4d767380087f2189$export$bc031c6e33a9c0cf = [
    ...$4d767380087f2189$export$e061a00b0877e539
];
function $4d767380087f2189$var$easeInOutCubicSkipScroll(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
/* eslint-disable complexity */ const $4d767380087f2189$var$UniformTeamworkGraph = (props)=>{
    const { frame1Heading: frame1Heading, frame1Subheading: frame1Subheading, frame2Heading: frame2Heading, frame2Description: frame2Description, frame2VideoUrl: frame2VideoUrl, frame2VideoImg: frame2VideoImg, frame3Heading: frame3Heading, frame3Description: frame3Description, frame3VideoUrl: frame3VideoUrl, frame3VideoImg: frame3VideoImg, frame4Heading: frame4Heading, frame4Description: frame4Description, frame4VideoUrl: frame4VideoUrl, frame4VideoImg: frame4VideoImg, frame5Heading: frame5Heading, frame5Description: frame5Description, frame5VideoUrl: frame5VideoUrl, frame5VideoImg: frame5VideoImg, frame7Heading: frame7Heading, stickyHeight: // scrollMagnetAnchors = DEFAULT_SCROLL_MAGNET_ANCHORS,
    // scrollMagnetMinProgressDelta,
    // scrollMagnetDirectionBias,
    stickyHeight = 1950, onDesktopScrollPhaseProgressChange: onDesktopScrollPhaseProgressChange } = props;
    // const orderedScrollMagnetAnchors = [...scrollMagnetAnchors].sort(
    //     (left, right) => left - right
    // );
    // Safari does not play the inline videos, so it falls back to still images
    const { isSafari: isSafariBrowser } = (0, $ivETl.useDeviceInfo)();
    const bgImageSafari = (src)=>{
        if (isSafariBrowser) return src;
        return undefined;
    };
    const htmlVideoSafari = (src)=>{
        if (isSafariBrowser) return null;
        return /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
            style: {
                width: '100%',
                height: '100%',
                position: 'relative',
                borderRadius: '10px',
                pointerEvents: 'none'
            },
            src: src,
            autoPlay: true,
            muted: true,
            loop: true,
            playsInline: true
        });
    };
    const intl = (0, $8e22h.default)();
    const frame2HeadingWithDefault = frame2Heading || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame2Heading);
    const frame2DescriptionWithDefault = frame2Description || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame2Description);
    const frame3HeadingWithDefault = frame3Heading || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame3Heading);
    const frame3DescriptionWithDefault = frame3Description || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame3Description);
    const frame4HeadingWithDefault = frame4Heading || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame4Heading);
    const frame4DescriptionWithDefault = frame4Description || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame4Description);
    const frame5HeadingWithDefault = frame5Heading || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame5Heading);
    const frame5DescriptionWithDefault = frame5Description || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame5Description);
    const pullingInContextString = intl.formatMessage({
        id: 'teamworkGraph.framesAl.pullingInContext',
        defaultMessage: 'Pulling in context...'
    });
    const teamworkGraphMobileNodesA = [
        {
            id: 'mobile-component-A-grid-left',
            x: 30,
            y: 0,
            width: 800,
            height: 1600,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7862q04hkv188isqi7vuls055j6f64fq.png'
        },
        {
            id: 'mobile-component-A-dot-top-left',
            x: 3,
            y: -2,
            shape: 'circle',
            bgColor: 'transparent',
            size: 1
        },
        {
            id: 'mobile-component-A-dot-top-right',
            x: 101,
            y: 9,
            shape: 'circle',
            bgColor: 'transparent',
            size: 1
        },
        {
            id: 'mobile-component-A-dot-right-bottom',
            x: 101,
            y: 89,
            shape: 'circle',
            bgColor: 'transparent',
            size: 1
        },
        {
            id: 'mobile-component-A-avatar-blue-top',
            x: 50,
            y: 50,
            shape: 'circle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vvs64iqhos5vy1u702ok4u50s42m10ii.png',
            size: 425
        },
        {
            id: 'mobile-component-A-icon-figma-top',
            x: 70,
            y: 0,
            size: 130,
            shape: 'rectangle',
            borderColor: 'white',
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg'
        },
        {
            id: 'mobile-component-A-rectangle-project',
            x: 3,
            y: 13,
            shape: 'rectangle',
            bgColor: 'black',
            borderColor: 'blue600',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.project',
                defaultMessage: 'Project'
            }),
            textColor: 'white',
            size: 130
        },
        {
            id: 'mobile-component-A-hex-wrench-1',
            x: 20,
            y: 26,
            shape: 'hexagon',
            size: 70,
            bgColor: 'blue600',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x6bd18r1i1qx1k7xt61pbnnskyf76y4r.svg'
        },
        {
            id: 'mobile-component-A-hex-wrench-2',
            x: 80,
            y: 33,
            shape: 'hexagon',
            size: 70,
            bgColor: 'blue600',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x6bd18r1i1qx1k7xt61pbnnskyf76y4r.svg'
        },
        {
            id: 'mobile-component-A-icon-circle-arrow',
            x: 97,
            y: 52,
            size: 130,
            shape: 'rectangle',
            bgColor: 'black',
            borderColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6k3dp10ut224t4oa4ih2ns74gx2r07yh.svg'
        },
        {
            id: 'mobile-component-A-icon-microsoft-teams',
            x: 3,
            y: 50,
            size: 130,
            shape: 'rectangle',
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FS.png'
        },
        {
            id: 'mobile-component-A-rectangle-prompt',
            borderColor: 'rainbowRovo',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/82b230b227f1f2nass7sp15dt05ib3ni.jpg',
            x: 50,
            y: 88,
            width: 800,
            height: 285,
            shape: 'rectangle'
        }
    ];
    const teamworkGraphMobileNodesB = [
        {
            id: 'mobile-component-B-dot-top',
            x: 50,
            y: 0,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-B-dot-left-bottom',
            x: -1,
            y: 40,
            shape: 'circle',
            bgColor: 'transparent',
            size: 1
        },
        {
            id: 'mobile-component-B-dot-right-bottom',
            x: 101,
            y: 89,
            shape: 'circle',
            bgColor: 'transparent',
            size: 1
        },
        {
            id: 'mobile-component-B-grid-right',
            x: 60,
            y: 50,
            width: 800,
            height: 1600,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/58tq64t0d72pjl8y7cgijgl8ag5a23tf.png'
        },
        {
            id: 'mobile-component-B-icon-confluence',
            x: 50,
            y: 7,
            size: 130,
            shape: 'rectangle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i8rco43kk1s7kmr72f303wo4esw3s57j.svg'
        },
        {
            id: 'mobile-component-B-icon-figma-bottom',
            x: 87,
            y: 43,
            size: 130,
            shape: 'rectangle',
            borderColor: 'white',
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg'
        },
        {
            id: 'mobile-component-B-lozenge-marketing-veronica',
            x: 55,
            y: 54,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.marketingVeronica',
                defaultMessage: 'Marketing / Veronica'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-B-lozenge-meeting-recordings',
            x: 50,
            y: 62,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.meetingRecordings',
                defaultMessage: 'Meeting Recordings'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-B-lozenge-campaign-ad-refresh',
            x: 45,
            y: 70,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.campaignAdRefresh',
                defaultMessage: 'Campaign Ad Refresh'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-B-rectangle-assets',
            x: 37,
            y: 87,
            width: 700,
            height: 400,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ycp11j6s2wt83bh3wy7713h1r85mv8ex.png'
        }
    ];
    const teamworkGraphMobileNodesC = [
        {
            id: 'mobile-component-C-dot-top',
            x: 10,
            y: 0,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-C-icon-figma-bottom',
            x: 12,
            y: 91,
            size: 130,
            shape: 'rectangle',
            borderColor: 'white',
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg'
        },
        {
            id: 'mobile-component-C-dot-left',
            x: -2,
            y: 15,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-C-frame-text',
            x: 50,
            y: 50,
            shape: 'rectangle',
            bgColor: 'transparent',
            width: 700,
            height: 800,
            textColor: 'white',
            fontFamily: 'charlie',
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: 'left'
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$mobileHeadingCss,
                        children: frame2HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$mobileDescriptionCss,
                        children: frame2DescriptionWithDefault
                    })
                ]
            })
        }
    ];
    const teamworkGraphMobileNodesD = [
        {
            id: 'mobile-component-D-dot-top',
            x: 15,
            y: 0,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-D-dot-right',
            x: 101,
            y: 0,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-D-icon-gdrive',
            x: 80,
            y: 10,
            size: 130,
            shape: 'rectangle',
            borderColor: 'white',
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x6fti424cg1dyn52m750hns8386vyw2o.svg'
        },
        {
            id: 'mobile-component-D-lozenge-strategy-brief',
            x: 45,
            y: 35,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.strategyBrief',
                defaultMessage: 'Strategy Brief'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-D-lozenge-portal-repo-20',
            x: 50,
            y: 45,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.portalRepo2',
                defaultMessage: 'Portal Repo 2.0'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-D-lozenge-okr',
            x: 65,
            y: 55,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.okrAdd300kAccounts',
                defaultMessage: '[01.KR2] Add 300k accounts'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-D-rectangle-in-progress',
            x: 62,
            y: 84,
            width: 700,
            height: 400,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q2408086s36q3g576cw1b2042ni4t57c.png'
        }
    ];
    const teamworkGraphMobileNodesE = [
        {
            id: 'mobile-component-E-dot-top',
            x: 80,
            y: 0,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-E-dot-left',
            x: 0,
            y: 80,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-E-icon-sharepoint-bottom',
            x: 80,
            y: 91,
            size: 130,
            shape: 'rectangle',
            borderColor: 'white',
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EWOC.svg'
        },
        {
            id: 'mobile-component-E-frame-text',
            x: 50,
            y: 50,
            shape: 'rectangle',
            bgColor: 'transparent',
            width: 700,
            height: 800,
            textColor: 'white',
            fontFamily: 'charlie',
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: 'left'
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$mobileHeadingCss,
                        children: frame3HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$mobileDescriptionCss,
                        children: frame3DescriptionWithDefault
                    })
                ]
            })
        }
    ];
    const teamworkGraphMobileNodesF = [
        {
            id: 'mobile-component-F-dot-top',
            x: 80,
            y: 0,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-F-dot-left',
            x: 0,
            y: 20,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-F-lozenge-portal-redesign-brainstorm',
            x: 58,
            y: 34,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.portalRedesignBrainstorm',
                defaultMessage: 'Portal Redesign Brainstorm'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-F-lozenge-portal-designs',
            x: 65,
            y: 44,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.portalDesigns',
                defaultMessage: 'Portal Designs'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-F-lozenge-okr',
            x: 50,
            y: 54,
            text: intl.formatMessage({
                id: 'teamworkGraph.mobile.frameFokrLabel',
                defaultMessage: '[O1.KR2] Add 300k accounts'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-F-rectangle-comment',
            x: 42,
            y: 84,
            width: 700,
            height: 400,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2gf42uyw6x35g346v1337b15dx434t0a.png'
        },
        {
            id: 'mobile-component-F-dot-bottom-right',
            x: 0,
            y: 100,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        }
    ];
    const teamworkGraphMobileNodesG = [
        {
            id: 'mobile-component-G-frame-text',
            x: 50,
            y: 50,
            shape: 'rectangle',
            bgColor: 'transparent',
            width: 700,
            height: 800,
            textColor: 'white',
            fontFamily: 'charlie',
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: 'left'
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$mobileHeadingCss,
                        children: frame4HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$mobileDescriptionCss,
                        children: frame4DescriptionWithDefault
                    })
                ]
            })
        }
    ];
    const teamworkGraphMobileNodesH = [
        {
            id: 'mobile-component-H-dot-top-left',
            x: -5,
            y: 0,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-H-dot-top-right',
            x: 111,
            y: 0,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-H-dot-middle-left',
            x: -20,
            y: 60,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-H-icon-figma',
            x: 70,
            y: 18,
            size: 130,
            shape: 'rectangle',
            borderColor: 'white',
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg'
        },
        {
            id: 'mobile-component-H-icon-microsoft',
            x: 14,
            y: 30,
            size: 130,
            shape: 'rectangle',
            borderColor: 'white',
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/72jyk7b1r48ul3cb6qusr6b1yu61td3t.svg'
        },
        {
            id: 'mobile-component-H-lozenge-partner-research-notes',
            x: 50,
            y: 40,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.partnerResearchNotes',
                defaultMessage: 'Partner Research Notes'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-H-lozenge-fin-300',
            x: 55,
            y: 50,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.fin300AccountMicroservice',
                defaultMessage: 'FIN-300: Account Microservice'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-H-lozenge-design-walkthrough',
            x: 65,
            y: 60,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.designWalkthrough',
                defaultMessage: 'Design Walkthrough'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie'
        },
        {
            id: 'mobile-component-H-rectangle-avatars',
            x: 65,
            y: 84,
            width: 700,
            height: 400,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/32agfh01wn5t07ah5781p287ap8sxoh4.png'
        },
        {
            id: 'mobile-component-H-dot-bottom',
            x: 20,
            y: 100,
            size: 20,
            shape: 'circle'
        }
    ];
    const teamworkGraphMobileNodesI = [
        {
            id: 'mobile-component-I-frame-text',
            x: 50,
            y: 25,
            shape: 'rectangle',
            bgColor: 'transparent',
            width: 700,
            height: 800,
            textColor: 'white',
            fontFamily: 'charlie',
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: 'left'
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$mobileHeadingCss,
                        children: frame5HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$mobileDescriptionCss,
                        children: frame5DescriptionWithDefault
                    })
                ]
            })
        },
        {
            id: 'mobile-component-I-dot-top',
            x: 20,
            y: 0,
            size: 20,
            shape: 'circle'
        },
        {
            id: 'mobile-component-I-dot-mid',
            x: 10,
            y: 40,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-I-dot-left-mid',
            x: -9,
            y: 60,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-I-dot-right-mid',
            x: 110,
            y: 60,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-I-dot-left-bottom',
            x: -9,
            y: 90,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-I-dot-right-bottom',
            x: 111,
            y: 90,
            size: 1,
            shape: 'circle',
            bgColor: 'transparent'
        },
        {
            id: 'mobile-component-I-avatar-blue',
            x: 50,
            y: 80,
            shape: 'circle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vvs64iqhos5vy1u702ok4u50s42m10ii.png',
            size: 425
        }
    ];
    /* desktop nodes */ const teamworkGraphAllFramesNodes = [
        {
            id: 'perpetual-grid',
            x: 150,
            y: 99,
            width: 880,
            height: 700,
            opacity: 0,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: $4d767380087f2189$var$GRID_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    opacity: 1,
                    x: 100,
                    y: 99
                },
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    opacity: 1,
                    x: 50,
                    y: 0
                },
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    opacity: 1,
                    x: 0,
                    y: 99
                },
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    opacity: 1,
                    x: 99,
                    y: 0
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-grid-center',
            x: 20,
            y: 42,
            width: 440,
            height: 350,
            opacity: 0,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: $4d767380087f2189$var$GRID_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 50,
                    y: 50,
                    width: 880,
                    height: 701,
                    opacity: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-text-get-knowledge-flowing',
            x: 28,
            y: 18,
            shape: 'rectangle',
            width: 500,
            height: 200,
            bgColor: 'transparent',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    textAlign: 'left'
                },
                children: frame1Heading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(frame1Heading) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                    node: frame1Heading['root'] || frame1Heading
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "gwp.refresh.teamworkGraph.frame1.heading",
                        values: (0, $iRMRa.DEFAULT_VALUES),
                        defaultMessage: "Get knowledge <br></br> <strong>flowing</strong>"
                    })
                })
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: -50,
                    y: -100,
                    opacity: 0,
                    size: 180
                }
            ]
        },
        {
            id: 'frame-1-text-starts-with-context',
            x: 28,
            y: 83,
            shape: 'rectangle',
            width: 500,
            height: 300,
            bgColor: 'transparent',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: 'left'
                },
                children: [
                    frame1Subheading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(frame1Subheading) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                        node: frame1Subheading['root'] || frame1Subheading
                    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                style: $4d767380087f2189$var$desktopHeadingCss,
                                children: intl.formatMessage({
                                    id: 'gwp.refresh.teamworkGraph.frame1.subheading',
                                    defaultMessage: "It all starts with context\u2026"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                style: $4d767380087f2189$var$desktopDescriptionCSS,
                                children: intl.formatMessage({
                                    id: 'gwp.refresh.teamworkGraph.frame1.description',
                                    defaultMessage: 'Link teams, work, and goals to unlock context right in your flow of work.'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        bgColor: "bgBlackBlue",
                        href: '/platform/teamwork-graph',
                        "aria-label": intl.formatMessage({
                            id: 'gwp.refresh.teamworkGraph.frame1.link',
                            defaultMessage: 'Explore Teamwork Graph'
                        }),
                        text: intl.formatMessage({
                            id: 'gwp.refresh.teamworkGraph.frame1.link',
                            defaultMessage: 'Explore Teamwork Graph'
                        }),
                        dataEventProps: {
                            'data-product-key': 'uniform',
                            'data-event': 'clicked',
                            'data-event-component': 'link',
                            'data-event-container': 'teamworkGraph',
                            'data-label': 'Explore Teamwork Graph',
                            'data-label-english': 'Explore Teamwork Graph'
                        }
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: -18,
                    y: 150,
                    opacity: 1,
                    size: 130
                }
            ]
        },
        {
            id: 'all-frames-behind-avatar-blue',
            x: 20,
            y: 42,
            shape: 'circle',
            size: 1,
            opacity: 0,
            bgColor: 'blue800',
            borderColor: 'blue400',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 50,
                    y: 50,
                    opacity: 0.5,
                    size: 320
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 50,
                    y: 50,
                    opacity: 0.2,
                    size: 300
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    opacity: 0,
                    x: 150,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 50,
                    y: 50,
                    size: 210
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_2_END,
                    x: 50,
                    y: 50,
                    size: 350,
                    opacity: 0.5
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_3_END,
                    x: 50,
                    y: 50,
                    size: 1,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-squiggle',
            x: 28,
            y: 31,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xcosenf3w13o8pq585o705fxys5q03x2.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 50,
                    y: 50,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-avatar-blue',
            x: 20,
            y: 42,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vvs64iqhos5vy1u702ok4u50s42m10ii.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 50,
                    y: 50,
                    opacity: 1,
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-pill-project',
            x: 9,
            y: 33,
            shape: 'pill',
            size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4RZ.svg',
            imagePlacement: 'insideLeading',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.project',
                defaultMessage: 'Project'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 20,
                    y: 20,
                    opacity: 1,
                    size: $4d767380087f2189$var$PILL_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-agent-top',
            x: 27,
            y: 40.5,
            shape: 'circle',
            size: 1,
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZG.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 74,
                    y: 44,
                    size: 30
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-agent-left',
            x: 22,
            y: 48,
            shape: 'circle',
            size: 1,
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZH.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 65,
                    y: 64,
                    size: 30
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-agent-right',
            x: 31,
            y: 46,
            shape: 'circle',
            size: 1,
            bgColor: 'transparent',
            opacity: 1,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZF.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 88,
                    y: 59,
                    size: 30
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-loom-to-shrink',
            x: 27,
            y: 48,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4t8837ogw4s4t31c7x0hgfb523o7s4v1.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 76,
                    y: 65,
                    opacity: 1,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-shrink-to-microsoft-teams',
            x: 27,
            y: 48,
            shape: 'rectangle',
            size: 1,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N54W.png',
            borderColor: 'white',
            borderWidth: 2,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 76,
                    y: 65,
                    opacity: 1,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-icon-circle-arrow-with-sprint-text',
            x: 12,
            y: 47,
            shape: 'rectangle',
            size: 1,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.sprint',
                defaultMessage: 'Sprint'
            }),
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZE.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'blue600',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 25,
                    y: 50,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-icon-circle-arrow',
            x: 12,
            y: 47,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'blue600',
            opacity: 1,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6k3dp10ut224t4oa4ih2ns74gx2r07yh.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 25,
                    y: 50,
                    size: 1,
                    opacity: 0
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-icon-figma',
            x: 18,
            y: 53,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 20,
                    y: 75,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-icon-people-team-with-team-text',
            x: 27,
            y: 61,
            shape: 'rectangle',
            size: 1,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.teamtext',
                defaultMessage: 'Team'
            }),
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZC.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'blue600',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 20,
                    y: 75,
                    opacity: 1,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-icon-people-team',
            x: 27,
            y: 61,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'blue600',
            opacity: 1,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/301nl85gds5kr47oo2125d47333e6c73.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 20,
                    y: 75,
                    opacity: 0,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-icon-jira',
            x: 8,
            y: 60,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'blue600',
            bgImage: $4d767380087f2189$var$JIRA_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 10,
                    y: 50,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-chip-team-r',
            x: 32,
            y: 40,
            shape: 'rectangle',
            size: 1,
            opacity: 0,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZC.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'blue500',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.team',
                defaultMessage: 'Team'
            }),
            textColor: 'white',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 70,
                    y: 25,
                    opacity: 0,
                    size: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 74,
                    y: 15,
                    size: 1,
                    opacity: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_2_END,
                    x: 74,
                    y: 15,
                    size: 46,
                    opacity: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_3_END,
                    x: 95,
                    y: 22,
                    size: 46,
                    opacity: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-chip-video-tr',
            x: 32,
            y: 40,
            shape: 'rectangle',
            size: 1,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZD.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'blue500',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.video',
                defaultMessage: 'Video'
            }),
            textColor: 'white',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 70,
                    y: 25,
                    size: 46
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 74,
                    y: 15,
                    size: 46,
                    opacity: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-chip-video-left',
            x: -30,
            y: 50,
            shape: 'rectangle',
            size: 1,
            opacity: 0,
            bgColor: 'black',
            borderColor: 'blue500',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.video',
                defaultMessage: 'Video'
            }),
            textColor: 'white',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 3,
                    y: 34,
                    opacity: 1,
                    size: 46
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-icon-behind-microsoft-teams',
            x: 32,
            y: 40,
            shape: 'circle',
            size: 1,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(32, 40),
                    size: 1,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-microsoft-teams-to-shrink',
            x: 32,
            y: 40,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N54W.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 90,
                    y: 40,
                    opacity: 0,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-1-shrink-to-icon-loom',
            x: 32,
            y: 40,
            shape: 'rectangle',
            size: 1,
            opacity: 0,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4t8837ogw4s4t31c7x0hgfb523o7s4v1.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 90,
                    y: 40,
                    opacity: 1,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        /* nodes that go away */ {
            id: 'frame-1-pill-work-item',
            x: 34,
            y: 54,
            shape: 'pill',
            size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S2.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'lime400',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.workItem',
                defaultMessage: 'Work Item'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(34, 54),
                    size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-avatar-green',
            x: 42,
            y: 35,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: 'lime500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ppop74d2k67771avyr8hs635pkasin70.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(42, 35),
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-rocket',
            x: 50,
            y: 33,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'lime500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6ql83bjjch2xkvh7643ki04g3k2vkj1p.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(50, 33),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-brackets',
            x: 39,
            y: 45,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'lime500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/u33nvnm154b801i82t4075s0j0f2q727.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(39, 45),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-bitbucket',
            x: 45,
            y: 51,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'lime500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s6xb2173woj4m00n36b754t44126al0l.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(45, 51),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-pill-roadmap',
            x: 67,
            y: 15,
            shape: 'pill',
            size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S2.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'purple500',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.roadmap',
                defaultMessage: 'Roadmap'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(67, 15),
                    size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-avatar-purple',
            x: 75,
            y: 37,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: 'purple500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yk6fc6h475wmi67s827prloh073l01g1.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(75, 37),
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-lightbulb',
            x: 77,
            y: 23,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'purple500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1di7856lu37ve153ja4m4wcg17b8y26j.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(77, 23),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-video',
            x: 57,
            y: 25,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'purple500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0qdhoxv5o6b3mleiuc6ej43re1gsn8b0.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(57, 25),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-target',
            x: 70,
            y: 47,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'purple500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/65wycilre16o225ia50e84d3a22ch140.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(70, 47),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-bookmark',
            x: 67,
            y: 32,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'purple500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2v746wlx1l1r41a6s5p63e7y102ko2l4.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(67, 32),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-jpd',
            x: 84,
            y: 30,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'purple500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/klkr50gx181r0p8chweefx38e7hf48s1.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(84, 30),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-avatar-yellow',
            x: 63,
            y: 54,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: 'yellow300',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ua8r3l3j055g4k8t3vcw5x0qd3b3b3wa.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(63, 54),
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-lightning-bolt',
            x: 59,
            y: 41,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'yellow300',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/uo0v4gsxcfjo34e3evp630ba0653j558.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(59, 41),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-jsm',
            x: 57,
            y: 60,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'yellow300',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nj3c8i7014gw1sba21en752f0q4pq0sx.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(57, 60),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-bell',
            x: 69,
            y: 65,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'yellow300',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3gjch6tk0wbw3801u4656e82213h5xvm.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(69, 65),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-pill-focus-area',
            x: 84,
            y: 70,
            shape: 'pill',
            size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S7.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'yellow500',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame1.focusArea',
                defaultMessage: 'Focus Area'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(84, 70),
                    size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-avatar-orange',
            x: 92,
            y: 47,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: 'yellow500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5o2o2enoi03yotn523u7t1505kw351en.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(92, 47),
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-dollar',
            x: 81,
            y: 43,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'yellow500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qmtxbl7050fm60rs86110t4h8553436v.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(81, 43),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-star-talent',
            x: 88,
            y: 59,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'yellow500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fwhk18bh22311008ugi5s2i62s5iv632.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(88, 59),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-csm',
            x: 52,
            y: 50,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'yellow300',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N54R.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(52, 50),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-microsoft',
            x: 93,
            y: 31,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/72jyk7b1r48ul3cb6qusr6b1yu61td3t.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(93, 31),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-gdrive',
            x: 62,
            y: 71,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x6fti424cg1dyn52m750hns8386vyw2o.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(62, 71),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: 'frame-1-icon-sharepoint',
            x: 75,
            y: 57,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N539.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(75, 57),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        /* frame 2 bridging elements */ {
            id: 'frame-1-and-2-bridge',
            x: 101,
            y: 80,
            shape: 'circle',
            size: 5,
            bgColor: 'blue300',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 50,
                    y: 80
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_2_END,
                    x: 120,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 20,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-1-prompt-box',
            x: 101,
            y: 80,
            shape: 'rectangle',
            size: 1,
            width: 1,
            height: 1,
            opacity: 1,
            borderColor: 'rainbowRovo',
            bgColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MT.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 50,
                    y: 80,
                    opacity: 1,
                    width: 350,
                    height: 115
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        /* frame 2 */ {
            id: 'frame-2-text',
            x: $4d767380087f2189$var$textPosition.x + 100,
            y: $4d767380087f2189$var$textPosition.y,
            width: 300,
            height: 400,
            opacity: 0,
            shape: 'rectangle',
            fontFamily: 'charlie',
            fontWeight: 400,
            bgColor: 'transparent',
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: 'left'
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$desktopHeadingCss,
                        children: frame2HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$desktopDescriptionCSS,
                        children: frame2DescriptionWithDefault
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    opacity: 1,
                    x: $4d767380087f2189$var$textPosition.x,
                    y: $4d767380087f2189$var$textPosition.y
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-icon-confluence',
            x: 120,
            y: 30,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            opacity: 1,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MY.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 20,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-icon-hubspot',
            x: 140,
            y: 15,
            shape: 'rectangle',
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MV.svg',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 40,
                    y: 15
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-icon-figma',
            x: 175,
            y: 30,
            shape: 'rectangle',
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 75,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-dot-top-right',
            x: 225,
            y: -10,
            shape: 'circle',
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 125,
                    y: -10
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-dot-top',
            x: 125,
            y: -50,
            shape: 'circle',
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 25,
                    y: -50
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-rovo-prompt-text',
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            shape: 'rectangle',
            size: 70,
            fontFamily: 'charlie',
            fontWeight: 400,
            bgColor: 'neutral900',
            borderColor: 'rainbowRovo',
            borderRadius: 5,
            text: pullingInContextString,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S0.svg',
            imagePlacement: 'insideLeading',
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-lozenge-1',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FX.svg',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame2.lozenge1',
                defaultMessage: 'Marketing / Veronica'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[0].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[0].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-lozenge-2',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FS.png',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame2.lozenge1',
                defaultMessage: 'Meeting Recordings'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[1].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[1].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-lozenge-3',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FT.png',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame2.lozenge1',
                defaultMessage: 'Campaign Ad Refresh'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_3,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[2].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[2].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: 'frame-2-video-expand',
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            shape: 'rectangle',
            width: 10,
            height: 10,
            opacity: 0,
            bgColor: 'neutral800',
            borderColor: 'rainbowRovo',
            borderRadius: 10,
            bgImage: bgImageSafari(frame2VideoImg || 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N40J.webp'),
            htmlContent: htmlVideoSafari(frame2VideoUrl || 'https://dam-cdn.atl.orangelogic.com/AssetLink/elqg4r36c8cgw17o0yh87a6ghe6s5e75.webm'),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_END,
                    width: $4d767380087f2189$var$vidFrontDimension,
                    height: $4d767380087f2189$var$vidFrontDimension,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        /* frame 3 */ {
            id: 'frame-3-text',
            x: $4d767380087f2189$var$textPosition.x + 100,
            y: $4d767380087f2189$var$textPosition.y + 100,
            width: 300,
            height: 400,
            opacity: 0,
            shape: 'rectangle',
            fontFamily: 'charlie',
            fontWeight: 400,
            bgColor: 'transparent',
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: 'left'
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$desktopHeadingCss,
                        children: frame3HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$desktopDescriptionCSS,
                        children: frame3DescriptionWithDefault
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    opacity: 1,
                    x: $4d767380087f2189$var$textPosition.x,
                    y: $4d767380087f2189$var$textPosition.y
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: 'frame-3-icon-gdrive',
            x: 220,
            y: 130,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x6fti424cg1dyn52m750hns8386vyw2o.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 120,
                    y: 130
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 20,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: 'frame-3-icon-cursor',
            x: 250,
            y: 170,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MZ.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 150,
                    y: 170
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 50,
                    y: 70
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: 'frame-3-dot-bottom',
            x: 230,
            y: 210,
            shape: 'rectangle',
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 130,
                    y: 210
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 30,
                    y: 110
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: 'behind-frame-3-and-5-dot-1',
            x: 183,
            y: 130,
            shape: 'rectangle',
            size: 5,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 83,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 65,
                    y: 20
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 0
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'behind-frame-3-and-5-dot-2',
            x: 183,
            y: 130,
            shape: 'rectangle',
            size: 5,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 83,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 65,
                    y: 20
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-3-and-5-icon-jira',
            x: 183,
            y: 130,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9C.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 83,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 65,
                    y: 20
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-3-dot-left',
            x: 0,
            y: 200,
            shape: 'circle',
            size: 15,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: -50,
                    y: 100
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: 'frame-3-and-5-dot-right-bottom',
            x: 250,
            y: 200,
            shape: 'circle',
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 150,
                    y: 100
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 0,
                    y: 0
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-3-rovo-prompt-text',
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            shape: 'rectangle',
            size: 70,
            fontFamily: 'charlie',
            fontWeight: 400,
            bgColor: 'neutral900',
            borderColor: 'rainbowRovo',
            borderRadius: 5,
            text: pullingInContextString,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S0.svg',
            imagePlacement: 'insideLeading',
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: 'frame-3-lozenge-1',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4G0.svg',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame3.lozenge1',
                defaultMessage: 'Strategy Brief'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[0].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[0].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: 'frame-3-lozenge-2',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4G1.svg',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame3.lozenge1',
                defaultMessage: 'Portal Repo 2.0'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[1].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[1].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: 'frame-3-lozenge-3',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FZ.png',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame3.lozenge1',
                defaultMessage: 'Portal Feature Gates'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_3,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[2].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[2].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: 'frame-3-video-expand',
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            shape: 'rectangle',
            width: 10,
            height: 10,
            opacity: 0,
            bgColor: 'neutral800',
            borderColor: 'rainbowRovo',
            borderRadius: 10,
            bgImage: bgImageSafari(frame3VideoImg || 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N40H.webp'),
            htmlContent: htmlVideoSafari(frame3VideoUrl || 'https://dam-cdn.atl.orangelogic.com/AssetLink/30e047lljh5y7j5n433ls66055u8t018.webm'),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y,
                    width: 1,
                    height: 1,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_END,
                    width: $4d767380087f2189$var$vidFrontDimension,
                    height: $4d767380087f2189$var$vidFrontDimension,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        /* bridge from frame 3 to frame 4 */ {
            id: 'frame-3-and-4-bridge',
            x: 222,
            y: 120,
            shape: 'circle',
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 122,
                    y: 20
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        /* frame 4 */ {
            id: 'frame-4-icon-loom',
            x: 120,
            y: -80,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9D.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 20,
                    y: 20
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-icon-sharepoint',
            x: 170,
            y: -70,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N539.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 70,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-icon-canva',
            x: 150,
            y: -90,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5Q6.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 50,
                    y: 10
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-dot-top',
            x: 175,
            y: -90,
            shape: 'circle',
            size: 4,
            opacity: 1,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 75,
                    y: -10
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-dot-right',
            x: 205,
            y: -20,
            shape: 'circle',
            size: 4,
            opacity: 1,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 105,
                    y: 80
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-text',
            x: $4d767380087f2189$var$textPosition.x + 100,
            y: $4d767380087f2189$var$textPosition.y - 100,
            width: 300,
            height: 400,
            opacity: 0,
            shape: 'rectangle',
            fontFamily: 'charlie',
            fontWeight: 400,
            bgColor: 'transparent',
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: 'left'
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$desktopHeadingCss,
                        children: frame4HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$desktopDescriptionCSS,
                        children: frame4DescriptionWithDefault
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    opacity: 1,
                    x: $4d767380087f2189$var$textPosition.x,
                    y: $4d767380087f2189$var$textPosition.y
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-rovo-prompt-text',
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            shape: 'rectangle',
            size: 70,
            fontFamily: 'charlie',
            fontWeight: 400,
            bgColor: 'neutral900',
            borderColor: 'rainbowRovo',
            borderRadius: 5,
            text: pullingInContextString,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S0.svg',
            imagePlacement: 'insideLeading',
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-lozenge-1',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z2.svg',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame4.lozenge1',
                defaultMessage: 'Portal Redesign Brainstorm'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[0].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[0].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-lozenge-2',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z3.svg',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame4.lozenge1',
                defaultMessage: 'Portal Designs'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[1].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[1].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-lozenge-3',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z4.svg',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame4.lozenge1',
                defaultMessage: ' [O1.KR2] Add 300K Accounts'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_3,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[2].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[2].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: 'frame-4-video-expand',
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            shape: 'rectangle',
            width: 10,
            height: 10,
            opacity: 0,
            bgColor: 'neutral800',
            borderColor: 'rainbowRovo',
            borderRadius: 10,
            bgImage: bgImageSafari(frame4VideoImg || 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N40I.webp'),
            htmlContent: htmlVideoSafari(frame4VideoUrl || 'https://dam-cdn.atl.orangelogic.com/AssetLink/ny32egn16elq2656p0mpl83368pr3wlx.webm'),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y,
                    width: 1,
                    height: 1,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_END,
                    width: $4d767380087f2189$var$vidFrontDimension,
                    height: $4d767380087f2189$var$vidFrontDimension,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        /* frame 5 */ {
            id: 'frame-5-text',
            x: $4d767380087f2189$var$textPosition.x - 100,
            y: $4d767380087f2189$var$textPosition.y + 100,
            width: 300,
            height: 400,
            opacity: 0,
            shape: 'rectangle',
            fontFamily: 'charlie',
            fontWeight: 400,
            bgColor: 'transparent',
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: 'left'
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$desktopHeadingCss,
                        children: frame5HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$desktopDescriptionCSS,
                        children: frame5DescriptionWithDefault
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    opacity: 1,
                    x: $4d767380087f2189$var$textPosition.x,
                    y: $4d767380087f2189$var$textPosition.y
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-5-rovo-prompt-text',
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            shape: 'rectangle',
            size: 70,
            fontFamily: 'charlie',
            fontWeight: 400,
            bgColor: 'neutral900',
            borderColor: 'rainbowRovo',
            borderRadius: 5,
            text: pullingInContextString,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S0.svg',
            imagePlacement: 'insideLeading',
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-5-lozenge-1',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4YZ.png',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame5.lozenge1',
                defaultMessage: 'Partner Calls'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[0].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[0].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-5-lozenge-2',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z0.svg',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame5.lozenge1',
                defaultMessage: 'FIN-300: Account Microservice'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[1].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[1].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-5-lozenge-3',
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z1.svg',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame5.lozenge1',
                defaultMessage: 'Design Walkthrough'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_3,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[2].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[2].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-5-icon-microsoft',
            shape: 'rectangle',
            x: -60,
            y: 177,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA0.svg',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 40,
                    y: 77
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: 'frame-5-video-expand',
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            shape: 'rectangle',
            width: 10,
            height: 10,
            opacity: 0,
            bgColor: 'neutral800',
            borderColor: 'rainbowRovo',
            borderRadius: 10,
            bgImage: bgImageSafari(frame5VideoImg || 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N40G.webp'),
            htmlContent: htmlVideoSafari(frame5VideoUrl || 'https://dam-cdn.atl.orangelogic.com/AssetLink/jl7534n20m4g3xtquu6wn3i5i13113q5.webm'),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y,
                    width: 1,
                    height: 1,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_END,
                    width: $4d767380087f2189$var$vidFrontDimension,
                    height: $4d767380087f2189$var$vidFrontDimension,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        /* frame 6 */ {
            id: 'frame-6-grid-left',
            x: 150,
            y: 30,
            width: 880,
            height: 701,
            opacity: 0,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: $4d767380087f2189$var$GRID_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 0,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-grid-right',
            x: 200,
            y: 90,
            width: 880,
            height: 701,
            opacity: 0,
            shape: 'rectangle',
            bgColor: 'transparent',
            bgImage: $4d767380087f2189$var$GRID_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 100,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-behind-assets-top',
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-behind-assets-bottom',
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 7.4,
                    y: 70
                }
            ]
        },
        {
            id: 'frame-6-behind-in-progress-top',
            x: 180,
            y: 30,
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: 'frame-6-behind-in-progress-bottom',
            x: 180,
            y: 30,
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 30.7,
                    y: 63.8
                }
            ]
        },
        {
            id: 'frame-6-behind-done-top',
            x: 195,
            y: 80,
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 95,
                    y: 80
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 33.1,
                    y: 82.6
                }
            ]
        },
        {
            id: 'frame-6-behind-done-bottom',
            x: 195,
            y: 80,
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 95,
                    y: 80
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-lozenge-marketing-team',
            x: 110,
            y: 20,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.marketingTeam',
                defaultMessage: 'Marketing team'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FX.svg',
            imagePlacement: 'outsideLeading',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            size: 20,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 10,
                    y: 25,
                    opacity: 0,
                    size: 20
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 10,
                    y: 30,
                    opacity: 1,
                    size: 30
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-lozenge-meeting-recordings',
            x: 113,
            y: 20,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.meetingRecordings',
                defaultMessage: 'Meeting Recordings'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FS.png',
            imagePlacement: 'outsideLeading',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            size: 20,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 10,
                    y: 25,
                    opacity: 0,
                    size: 20
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_2_END,
                    x: 13,
                    y: 35,
                    opacity: 1,
                    size: 30
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-lozenge-campaign-ad-refresh',
            x: 116,
            y: 20,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.campaignAdRefresh',
                defaultMessage: 'Campaign Ad Refresh'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MU.png',
            imagePlacement: 'outsideLeading',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            size: 20,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 10,
                    y: 25,
                    opacity: 0,
                    size: 20
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_3_END,
                    x: 16,
                    y: 40,
                    opacity: 1,
                    size: 30
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-rectangle-assets',
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: 'rectangle',
            width: 100,
            height: 50,
            opacity: 0,
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/n77suu8uq6g15lwd755l77a3833ai6b3.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1],
                    width: 200,
                    height: 100,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'final-screen-behind-squiggle-to-idea',
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: 'circle',
            opacity: 0,
            size: 1,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1],
                    opacity: 0,
                    size: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 1.6,
                    y: 49,
                    opacity: 1
                }
            ]
        },
        {
            id: 'final-screen-icon-squiggle',
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: 'rectangle',
            size: 1,
            opacity: 0,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xcosenf3w13o8pq585o705fxys5q03x2.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1],
                    opacity: 0,
                    size: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 7.4,
                    y: 70,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
                    opacity: 1
                }
            ]
        },
        {
            id: 'frame-6-dot-offscreen-bottom-left',
            x: 100,
            y: 100,
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: -30,
                    y: 100
                }
            ]
        },
        {
            id: 'frame-6-icon-figma',
            x: 150,
            y: 97,
            shape: 'rectangle',
            borderColor: 'white',
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 50,
                    y: 97
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-behind-comment',
            x: 120,
            y: 75,
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 20,
                    y: 75
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 16.4,
                    y: 91.3
                }
            ]
        },
        {
            id: 'frame-6-rectangle-comment',
            x: 120,
            y: 75,
            shape: 'rectangle',
            width: 100,
            height: 50,
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2gf42uyw6x35g346v1337b15dx434t0a.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 20,
                    y: 75,
                    width: 200,
                    height: 100
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-behind-from-assets-to-avatars-rectangle',
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 40,
                    y: 5
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-rectangle-avatars',
            x: 140,
            y: 5,
            shape: 'rectangle',
            width: 200,
            height: 100,
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/32agfh01wn5t07ah5781p287ap8sxoh4.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 40,
                    y: 5
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-rectangle-in-progress',
            x: 180,
            y: 30,
            shape: 'rectangle',
            width: 200,
            height: 100,
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/426lxf8r1u73b7e5768ts0dd2w26n11l.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-icon-loom',
            x: 80,
            y: 30,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            opacity: 0,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4t8837ogw4s4t31c7x0hgfb523o7s4v1.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 30.7,
                    y: 63.8,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
                    opacity: 1
                }
            ]
        },
        {
            id: 'frame-6-rectangle-done',
            x: 195,
            y: 80,
            shape: 'rectangle',
            width: 200,
            height: 100,
            bgColor: 'transparent',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b4d1tn2sdy0s36i56c857db6w1k1u2b4.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 95,
                    y: 80
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-icon-confluence',
            x: 95,
            y: 80,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            opacity: 0,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MY.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 33.1,
                    y: 82.6,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
                    opacity: 1
                }
            ]
        },
        {
            id: 'frame-6-behind-from-in-progress-to-avatar',
            x: 180,
            y: 30,
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: 'frame-6-behind-from-done-to-avatar',
            x: 195,
            y: 80,
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 95,
                    y: 80
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: 'frame-6-behind-from-assets-to-avatar',
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: 'frame-6-behind-from-comment-to-avatar',
            x: 120,
            y: 75,
            shape: 'circle',
            size: 4,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 20,
                    y: 75
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: 'final-screen-behind-avatar-blue-to-jpd',
            x: 150,
            y: 50,
            shape: 'circle',
            size: 1,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 16.6,
                    y: 44.2
                }
            ]
        },
        {
            id: 'final-screen-avatar-blue',
            x: 150,
            y: 50,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vvs64iqhos5vy1u702ok4u50s42m10ii.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-6-lozenge-partner-research',
            x: 140,
            y: 15,
            size: 30,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.partnerCalls',
                defaultMessage: 'Partner Calls'
            }),
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4YZ.png',
            imagePlacement: 'outsideLeading',
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 40
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-lozenge-fin-300',
            x: 143,
            y: 20,
            size: 30,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.fin300AccountMicroservice',
                defaultMessage: 'FIN-300: Account Microservice'
            }),
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z0.svg',
            imagePlacement: 'outsideLeading',
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 43
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-design-demo',
            x: 143,
            y: 25,
            size: 30,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.designDemo',
                defaultMessage: 'Design Demo'
            }),
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z1.svg',
            imagePlacement: 'outsideLeading',
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 43
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-lozenge-portal-redesign-brainstorm',
            x: 123,
            y: 85,
            size: 30,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.portalRedesignBrainstorm',
                defaultMessage: 'Portal Redesign Brainstorm'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z2.svg',
            imagePlacement: 'outsideLeading',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 23
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-lozenge-portal-designs',
            x: 123,
            y: 90,
            size: 30,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.portalDesigns',
                defaultMessage: 'Portal Designs'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z3.svg',
            imagePlacement: 'outsideLeading',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 23
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-okr',
            x: 126,
            y: 95,
            size: 30,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.okrAdd300kAccounts',
                defaultMessage: '[01.KR2] Add 300k accounts'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z4.svg',
            imagePlacement: 'outsideLeading',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 26
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-lozenge-strategy-brief',
            x: 180,
            y: 40,
            size: 30,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.strategyBrief',
                defaultMessage: 'Strategy Brief'
            }),
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z2.svg',
            imagePlacement: 'outsideLeading',
            shape: 'rectangle',
            bgColor: 'blue600',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-lozenge-portal-feature-gates',
            x: 183,
            y: 45,
            size: 30,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.portalFeatureGates',
                defaultMessage: 'Portal Feature Gates'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FZ.png',
            imagePlacement: 'outsideLeading',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 83
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: 'frame-6-portal-repo-2-point-0',
            x: 186,
            y: 50,
            size: 30,
            text: intl.formatMessage({
                id: 'teamworkGraph.frame6.portalRepo2',
                defaultMessage: 'Portal Repo 2.0'
            }),
            shape: 'rectangle',
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4G1.svg',
            imagePlacement: 'outsideLeading',
            textColor: 'white',
            fontFamily: 'charlie',
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 86
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        /* frame 7 */ {
            id: 'frame-7-center-text',
            x: 140,
            y: 45,
            shape: 'rectangle',
            width: 700,
            height: 200,
            opacity: 0,
            bgColor: 'transparent',
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    textAlign: 'center'
                },
                children: frame7Heading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(frame7Heading) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                    node: frame7Heading['root'] || frame7Heading
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "gwp.refresh.teamworkGraph.frame7.heading",
                        values: (0, $iRMRa.DEFAULT_VALUES),
                        defaultMessage: "So you can make <br></br> <strong>smarter moves, faster</strong>"
                    })
                })
            }),
            textColor: 'white',
            fontWeight: 400,
            fontFamily: 'charlie',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 40,
                    y: 45,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_1_END,
                    x: 50,
                    y: 45,
                    opacity: 1
                }
            ]
        },
        {
            id: 'frame-7-pill-meeting-notes',
            x: 20,
            y: 75,
            shape: 'rectangle',
            size: 20,
            opacity: 0,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50K.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'blue600',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame7.meetingNotes',
                defaultMessage: 'Meeting notes'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 16.4,
                    y: 91.3,
                    size: 47,
                    opacity: 1
                }
            ]
        },
        /* frame 7 — enter from off-screen during 6 to 7 transition */ {
            id: 'frame-7-icon-hubspot',
            x: 0,
            y: -100,
            shape: 'rectangle',
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MV.svg',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 5,
                    y: 5,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-dot-x-30-y-0',
            x: 90,
            y: -100,
            shape: 'circle',
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 30,
                    y: -4
                }
            ]
        },
        {
            id: 'frame-7-dot-x-50-y-0',
            x: 150,
            y: -100,
            shape: 'circle',
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 50,
                    y: -4
                }
            ]
        },
        {
            id: 'frame-7-dot-x-60-y-0',
            x: 200,
            y: -100,
            shape: 'circle',
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 60,
                    y: -4
                }
            ]
        },
        {
            id: 'frame-7-dot-x-65-y-0',
            x: 250,
            y: -100,
            shape: 'circle',
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 65,
                    y: 0
                }
            ]
        },
        {
            id: 'frame-7-dot-x-70-y-0',
            x: 260,
            y: -100,
            shape: 'circle',
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 70,
                    y: -4
                }
            ]
        },
        {
            id: 'frame-7-dot-x-80-y-0',
            x: 300,
            y: -100,
            shape: 'circle',
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 80,
                    y: -4
                }
            ]
        },
        {
            id: 'frame-7-icon-jira-top',
            x: 100,
            y: -99,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'blue600',
            bgImage: $4d767380087f2189$var$JIRA_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 38.4,
                    y: 1,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-focus-top',
            x: 200,
            y: -57,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'orange300',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MW.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 63.6,
                    y: 3.8,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-behind-avatar-lime-top',
            x: 250,
            y: -71,
            shape: 'circle',
            size: 1,
            opacity: 0,
            bgColor: 'lime800',
            borderColor: 'lime500',
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 81.8,
                    y: 8.8
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_2_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: 'frame-7-avatar-lime-top',
            x: 250,
            y: -71,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: 'lime500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N520.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 81.8,
                    y: 8.8,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-pill-campaign',
            x: 90,
            y: -99,
            shape: 'rectangle',
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50N.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'blue600',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame7.campaign',
                defaultMessage: 'Campaign'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.2,
                    y: 8.8,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-pill-pr',
            x: 300,
            y: -100,
            shape: 'rectangle',
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZC.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'lime500',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame7.pullRequestAbbrev',
                defaultMessage: 'PR',
                description: 'Abbreviation for pull request, shown on a small pill label in a marketing animation'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 98.1,
                    y: 10,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-behind-avatar-orange',
            x: 200,
            y: -60,
            shape: 'circle',
            size: 1,
            opacity: 0,
            bgColor: 'orange800',
            borderColor: 'orange300',
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 53,
                    y: 17.5
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_1_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: 'frame-7-avatar-orange',
            x: 200,
            y: -60,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: 'orange300',
            textColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N51Z.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 53,
                    y: 17.5,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-bookmark',
            x: 90,
            y: -70,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2v746wlx1l1r41a6s5p63e7y102ko2l4.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 27.7,
                    y: 17.7,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-bitbucket',
            x: 300,
            y: -20,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'lime500',
            textColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s6xb2173woj4m00n36b754t44126al0l.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 92.3,
                    y: 22.9,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-rovo-dev',
            x: 250,
            y: -20,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'lime400',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MX.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 71.6,
                    y: 24.9,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-behind-avatar-purple',
            x: 50,
            y: -96,
            shape: 'circle',
            size: 1,
            opacity: 0,
            bgColor: 'purple800',
            borderColor: 'purple500',
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 8,
                    y: 27.6
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_2_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: 'frame-7-avatar-purple',
            x: 50,
            y: -96,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: 'purple500',
            textColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N51X.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 8,
                    y: 27.6,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-pill-goal',
            x: 225,
            y: -10,
            shape: 'rectangle',
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50M.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'orange300',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame7.goal',
                defaultMessage: 'Goal'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 61.4,
                    y: 31.1,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-purple-jpd',
            x: 70,
            y: -20,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'purple500',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/67p4f030jo35j028ayr2hw4tioa5i200.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 16.6,
                    y: 44.2,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-pill-idea',
            x: 20,
            y: -20,
            shape: 'rectangle',
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50L.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'purple500',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame7.idea',
                defaultMessage: 'Idea'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 1.6,
                    y: 49,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        /* frame 7 nodes moving downward */ {
            id: 'frame-7-behind-avatar-saffron',
            x: 280,
            y: 22,
            shape: 'circle',
            size: 1,
            opacity: 0,
            bgColor: 'blue600',
            borderColor: 'blue400',
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 86.4,
                    y: 52
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_1_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: 'frame-7-avatar-saffron',
            x: 280,
            y: 22,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: 'blue600',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N521.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 86.4,
                    y: 52,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-rocket',
            x: 200,
            y: 20,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ptn36e828x7k02745o673wfoe4mpofj2.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 57.1,
                    y: 62,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-target',
            x: 300,
            y: 63.5,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/65wycilre16o225ia50e84d3a22ch140.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 96.1,
                    y: 63.5,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-behind-loom',
            x: 180,
            y: 30,
            shape: 'rectangle',
            size: 1,
            opacity: 0,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 30.7,
                    y: 63.8
                }
            ]
        },
        {
            id: 'frame-7-icon-bell',
            x: 250,
            y: 25,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3gjch6tk0wbw3801u4656e82213h5xvm.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 71.2,
                    y: 64.3,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-csm',
            x: 150,
            y: 40,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'yellow300',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N54R.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 46.1,
                    y: 73.7,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-gdrive',
            x: 270,
            y: 78.1,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'black',
            borderColor: 'white',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA5.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 87.9,
                    y: 78.1,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-icon-behind-confluence',
            x: 100,
            y: 80,
            shape: 'circle',
            size: 1,
            bgColor: 'transparent',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 33.1,
                    y: 82.6
                }
            ]
        },
        {
            id: 'frame-7-icon-jsm',
            x: 200,
            y: 40,
            shape: 'rectangle',
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: 'yellow300',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nj3c8i7014gw1sba21en752f0q4pq0sx.svg',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 58.8,
                    y: 87.1,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-dot-x-0-y-90',
            x: 100,
            y: 90,
            shape: 'circle',
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 0,
                    y: 90
                }
            ]
        },
        {
            id: 'frame-7-behind-avatar-lime-bottom',
            x: 250,
            y: 91.8,
            shape: 'circle',
            size: 1,
            opacity: 0,
            bgColor: 'lime800',
            borderColor: 'lime500',
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 76.5,
                    y: 91.8
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_2_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: 'frame-7-avatar-lime-bottom',
            x: 250,
            y: 91.8,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: 'lime400',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N522.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 76.5,
                    y: 91.8,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-pill-release',
            x: 300,
            y: 92.5,
            shape: 'rectangle',
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: 'black',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50J.svg',
            imagePlacement: 'insideLeading',
            borderColor: 'lime500',
            textColor: 'white',
            text: intl.formatMessage({
                id: 'teamworkGraph.frame7.release',
                defaultMessage: 'Release'
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 92.8,
                    y: 92.5,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: 'frame-7-behind-avatar-yellow',
            x: 150,
            y: 99,
            shape: 'circle',
            size: 1,
            opacity: 0,
            bgColor: 'yellow700',
            borderColor: 'yellow400',
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 47.5,
                    y: 99
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_1_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: 'frame-7-avatar-yellow',
            x: 150,
            y: 99,
            shape: 'circle',
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: 'yellow400',
            bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N51Y.png',
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 47.5,
                    y: 99,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        }
    ];
    const sectionRef = (0, $1oC0p.useRef)(null);
    const desktopShellRef = (0, $1oC0p.useRef)(null);
    const skipTargetRef = (0, $1oC0p.useRef)(null);
    const skipScrollRafRef = (0, $1oC0p.useRef)(0);
    const skipScrollMountedRef = (0, $1oC0p.useRef)(true);
    const skipAnimatingRef = (0, $1oC0p.useRef)(false);
    const hasEverFullyScrolledPastSectionRef = (0, $1oC0p.useRef)(false);
    const prevDesktopScrollPhaseRef = (0, $1oC0p.useRef)('track');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [percentageScrolled, setPercentageScrolled] = (0, $1oC0p.useState)(0);
    const [hasScrolledPast, setHasScrolledPast] = (0, $1oC0p.useState)(false);
    const [hasScrolledAboveAgain, setHasScrolledAboveAgain] = (0, $1oC0p.useState)(false);
    const [desktopScrollPhase, setDesktopScrollPhase] = (0, $1oC0p.useState)('track');
    /** Holds the graph at final scroll progress (same as natural dock) while skipping. */ const [skipEndFrameHold, setSkipEndFrameHold] = (0, $1oC0p.useState)(false);
    const [skipScrollAnimating, setSkipScrollAnimating] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (prevDesktopScrollPhaseRef.current === 'docked' && desktopScrollPhase === 'track') hasEverFullyScrolledPastSectionRef.current = false;
        prevDesktopScrollPhaseRef.current = desktopScrollPhase;
    }, [
        desktopScrollPhase
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (hasScrolledPast && skipEndFrameHold) setSkipEndFrameHold(false);
    }, [
        hasScrolledPast,
        skipEndFrameHold
    ]);
    (0, $1oC0p.useEffect)(()=>{
        skipScrollMountedRef.current = true;
        return ()=>{
            skipScrollMountedRef.current = false;
            if (skipScrollRafRef.current !== 0) {
                cancelAnimationFrame(skipScrollRafRef.current);
                skipScrollRafRef.current = 0;
            }
        };
    }, []);
    const handleDesktopSkipClick = (0, $1oC0p.useCallback)((e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            source: 'teamworkGraph'
        }).fire();
        if (skipAnimatingRef.current) return;
        const target = skipTargetRef.current;
        if (!target) return;
        skipAnimatingRef.current = true;
        setSkipScrollAnimating(true);
        setSkipEndFrameHold(true);
        const startY = window.scrollY;
        const endY = Math.max(0, Math.round(target.getBoundingClientRect().top + window.scrollY - $4d767380087f2189$var$TEAMWORK_GRAPH_SKIP_SCROLL_TOP_PADDING_PX));
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion || Math.abs(endY - startY) < 2) {
            window.scrollTo(0, endY);
            skipAnimatingRef.current = false;
            setSkipScrollAnimating(false);
            target.focus({
                preventScroll: true
            });
            return;
        }
        const t0 = performance.now();
        const duration = $4d767380087f2189$var$TEAMWORK_GRAPH_SKIP_SCROLL_MS;
        const step = (now)=>{
            if (!skipScrollMountedRef.current) {
                skipAnimatingRef.current = false;
                setSkipScrollAnimating(false);
                return;
            }
            const t = Math.min(1, (now - t0) / duration);
            const y = startY + (endY - startY) * $4d767380087f2189$var$easeInOutCubicSkipScroll(t);
            window.scrollTo(0, y);
            if (t < 1) skipScrollRafRef.current = requestAnimationFrame(step);
            else {
                skipScrollRafRef.current = 0;
                skipAnimatingRef.current = false;
                setSkipScrollAnimating(false);
                target.focus({
                    preventScroll: true
                });
            }
        };
        skipScrollRafRef.current = requestAnimationFrame(step);
    }, [
        createAnalyticsEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const section = sectionRef.current;
        if (!section) return;
        const updateSectionScrollState = ()=>{
            const el = sectionRef.current;
            if (!el) return;
            const rect = el.getBoundingClientRect();
            const fullyPast = rect.bottom <= 0;
            setPercentageScrolled(rect.top * -1 / rect.height * 100);
            setHasScrolledPast(fullyPast);
            if (fullyPast) hasEverFullyScrolledPastSectionRef.current = true;
            setHasScrolledAboveAgain(hasEverFullyScrolledPastSectionRef.current && !fullyPast);
            setDesktopScrollPhase((phase)=>{
                if (phase === 'track') return fullyPast ? 'docked' : 'track';
                const shell = desktopShellRef.current;
                if (shell) {
                    const shellTop = shell.getBoundingClientRect().top;
                    if (shellTop > 6) return 'track';
                }
                return 'docked';
            });
        };
        updateSectionScrollState();
        window.addEventListener('scroll', updateSectionScrollState, {
            passive: true
        });
        window.addEventListener('resize', updateSectionScrollState);
        const ro = new ResizeObserver(updateSectionScrollState);
        ro.observe(section);
        const shell = desktopShellRef.current;
        if (shell) ro.observe(shell);
        return ()=>{
            window.removeEventListener('scroll', updateSectionScrollState);
            window.removeEventListener('resize', updateSectionScrollState);
            ro.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: {
            margin: '0',
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _uwwnglyw _mkl21kxc _7vpg15vq _1io315vq",
                    `desktop_container_${desktopScrollPhase} scroll_past_${hasScrolledPast} scroll_above_again_${hasScrolledAboveAgain}`
                ]),
                ref: desktopShellRef,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: `tall_height_${desktopScrollPhase}`,
                    ref: sectionRef,
                    style: {
                        position: 'relative',
                        minHeight: `${stickyHeight}vh`
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _p12f1osq _kqsw1if8 _19pkidpf _2hwx1wug _otyridpf _18u01wug _152tdvcx _1e02idpf",
                            `sticky_${desktopScrollPhase}`
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                                // scrollMagnetAnchors={orderedScrollMagnetAnchors}
                                // scrollMagnetMinProgressDelta={
                                //     scrollMagnetMinProgressDelta
                                // }
                                // scrollMagnetDirectionBias={
                                //     scrollMagnetDirectionBias
                                // }
                                bgColor: "black",
                                animationPhasesDrive: "scroll",
                                scrollSectionRef: sectionRef,
                                scrollPhaseProgressOverride: desktopScrollPhase === 'docked' || skipEndFrameHold ? 1 : null,
                                onScrollPhaseProgressChange: onDesktopScrollPhaseProgressChange,
                                nodes: teamworkGraphAllFramesNodes,
                                connectors: (0, $fk4mX.teamworkGraphAllFramesConnectors),
                                useOnlyExplicitConnectors: true,
                                connectorColor: "blue300",
                                connectorWidth: 3,
                                replayOnVisible: false,
                                useViewportDimensions: true,
                                fontFamily: "monospace",
                                animateOnLoad: false
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _1r04idpf _1bsb1osq _4t3i10fc _lcxvglyw _1pbycs5v _17djb3bt _147jb3bt _175istnw _1nwdstnw _ozr6idpf _yotaidpf _k71uidpf _1ckaidpf _21xqoyl8 _6h4ooyl8 _11951osq _axqm1osq _1a3tglyw _1vuxglyw _110xcs5v _gwe3cs5v _14ux1wug _4o4c1ahs _7rhxidpf _k71u1wug _iseyc9k5"
                                ]),
                                style: {
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _kqswstnw _1pby11wp _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152t1us8 _u7co1wug _1e02idpf _rjxpidpf _1bsb1nrf _1e0c1txw _zulpu2gc _1yt44jca",
                                    "navigation-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _1bsb1osq _4t3iftgi _16jlkb7n _lcxvglyw _1pbycs5v _1reo15vq _18m915vq _2rko1mv1",
                                            "progress-timeline"
                                        ]),
                                        style: {
                                            "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill'))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1bsb1osq _4t3iftgi _kqswstnw _1e0c1txw _2lx2vrvc _zulpftgi",
                                                    "_bfhkgb8a",
                                                    "bars behind"
                                                ]),
                                                style: {
                                                    "--_19a6bh5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light900'))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1bsb1osq _4t3iftgi _kqswstnw _1e0c1txw _2lx2vrvc _zulpftgi",
                                                    "_bfhk5hrz",
                                                    "bars front"
                                                ]),
                                                style: {
                                                    clipPath: `polygon(0 0, ${percentageScrolled}% 0, ${percentageScrolled}% 100%, 0 100%)`,
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: "skip-button-area",
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                            className: (0, $2jatx.default)([
                                                "_bfhk1d0o _80omtlke _1e0c1o8l _syaz1afi _19it1hdd _2rko1mv1 _1yt44jca _ect41vau _1wybutpp _vwz4kb7n _irr36rs1",
                                                skipScrollAnimating && "_lcxvglyw _tzy41cit",
                                                "skip-button"
                                            ]),
                                            href: "#skip-graph",
                                            "aria-busy": skipScrollAnimating,
                                            "aria-disabled": skipScrollAnimating,
                                            onClick: handleDesktopSkipClick,
                                            style: {
                                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                                "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill')),
                                                "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                            },
                                            children: intl.formatMessage({
                                                id: 'teamworkGraph.skipButton',
                                                defaultMessage: 'Skip'
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _uwwn1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    style: {
                        width: '100%',
                        margin: '0 auto'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesA,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsA),
                            connectorColor: "blue600",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(537)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesB,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsB),
                            connectorColor: "blue600",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(705)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesC,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsC),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(330)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesD,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsD),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(550)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesE,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsE),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(330)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesF,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsF),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(550)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesG,
                            useOnlyExplicitConnectors: true,
                            connectors: [],
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(300)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesH,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsH),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(550)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesI,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsI),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(800)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: skipTargetRef,
                className: "skip-to-bottom",
                id: "skip-graph",
                tabIndex: -1
            })
        ]
    });
};
var $4d767380087f2189$export$2e2bcd8739ae039 = $4d767380087f2189$var$UniformTeamworkGraph;

});
parcelRegister("fk4mX", function(module, exports) {
$parcel$export(module.exports, "teamworkGraphAllFramesConnectors", function () { return $f9897010521bbd9d$export$756326ff129c0dcc; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsA", function () { return $f9897010521bbd9d$export$b965507d386cb99d; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsB", function () { return $f9897010521bbd9d$export$dd9213ac7d5a9d04; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsC", function () { return $f9897010521bbd9d$export$621ed6415af9863e; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsD", function () { return $f9897010521bbd9d$export$74d164615ea757fb; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsE", function () { return $f9897010521bbd9d$export$a2089f34a89c6aea; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsF", function () { return $f9897010521bbd9d$export$c30288e07ec1214e; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsH", function () { return $f9897010521bbd9d$export$b558969562a813f5; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsI", function () { return $f9897010521bbd9d$export$f08b61eee7038f83; });
const $f9897010521bbd9d$export$756326ff129c0dcc = [
    {
        from: 'frame-1-pill-project',
        to: 'frame-1-avatar-blue',
        connectorType: 'dashed',
        color: 'blue600'
    },
    {
        from: 'frame-1-pill-project',
        to: 'frame-1-icon-circle-arrow',
        color: 'blue600'
    },
    {
        from: 'frame-1-icon-jira',
        to: 'frame-1-icon-circle-arrow',
        color: 'neutral500'
    },
    {
        from: 'frame-1-icon-figma',
        to: 'frame-1-icon-circle-arrow',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'blue500'
    },
    {
        from: 'frame-1-avatar-blue',
        to: 'frame-1-agent-left',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'blue500'
    },
    {
        from: 'frame-1-agent-left',
        to: 'frame-1-loom-to-shrink',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'blue500'
    },
    {
        from: 'frame-1-microsoft-teams-to-shrink',
        to: 'frame-1-agent-right',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'blue500'
    },
    {
        from: 'frame-1-agent-right',
        to: 'frame-1-loom-to-shrink',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'blue500'
    },
    {
        from: 'frame-1-avatar-blue',
        to: 'frame-1-icon-squiggle',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'blue600'
    },
    {
        from: 'frame-1-avatar-blue',
        to: 'frame-1-icon-chat',
        connectorShape: 'arced',
        connectorType: 'dashed',
        color: 'blue600'
    },
    {
        from: 'frame-1-avatar-blue',
        to: 'frame-1-icon-figma',
        connectorType: 'dashed',
        color: 'blue600'
    },
    {
        from: 'frame-1-icon-figma',
        to: 'frame-1-icon-people-team',
        color: 'neutral500'
    },
    {
        from: 'frame-1-icon-chat',
        to: 'frame-1-icon-trello',
        connectorShape: 'arced',
        color: 'blue600'
    },
    {
        from: 'frame-1-icon-sharepoint',
        to: 'frame-1-pill-focus-area',
        color: 'neutral500'
    },
    {
        from: 'frame-1-icon-star-talent',
        to: 'frame-1-pill-focus-area',
        color: 'yellow500'
    },
    {
        from: 'frame-1-avatar-green',
        to: 'frame-1-icon-bitbucket',
        connectorType: 'dashed',
        color: 'lime500'
    },
    {
        from: 'frame-1-pill-roadmap',
        to: 'frame-1-icon-lightbulb',
        connectorShape: 'arced',
        connectorType: 'dashed',
        connectorBias: 'negative',
        color: 'purple500'
    },
    {
        from: 'frame-1-icon-bookmark',
        to: 'frame-1-icon-lightbulb',
        color: 'purple500'
    },
    {
        from: 'frame-1-icon-bookmark',
        to: 'frame-1-icon-target',
        color: 'purple500'
    },
    {
        from: 'frame-1-icon-jpd',
        to: 'frame-1-icon-lightbulb',
        connectorShape: 'curvy',
        connectorBias: 'negative',
        color: 'purple500'
    },
    {
        from: 'frame-1-avatar-purple',
        to: 'frame-1-icon-lightbulb',
        connectorType: 'dashed',
        color: 'purple500'
    },
    {
        from: 'frame-1-avatar-purple',
        to: 'frame-1-icon-target',
        connectorShape: 'arced',
        connectorType: 'dashed',
        connectorBias: 'negative',
        color: 'purple500'
    },
    {
        from: 'frame-1-icon-lightning-bolt',
        to: 'frame-1-icon-target',
        color: 'neutral500'
    },
    {
        from: 'frame-1-icon-sharepoint',
        to: 'frame-1-icon-target',
        color: 'neutral500'
    },
    {
        from: 'frame-1-icon-video',
        to: 'frame-1-icon-bookmark',
        color: 'neutral500'
    },
    {
        from: 'frame-1-icon-lightning-bolt',
        to: 'frame-1-icon-bookmark',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'neutral500'
    },
    {
        from: 'frame-1-avatar-yellow',
        to: 'frame-1-icon-lightning-bolt',
        connectorType: 'dashed',
        color: 'yellow300'
    },
    {
        from: 'frame-1-avatar-yellow',
        to: 'frame-1-icon-bell',
        connectorShape: 'arced',
        connectorType: 'dashed',
        connectorBias: 'negative',
        color: 'yellow300'
    },
    {
        from: 'frame-1-avatar-yellow',
        to: 'frame-1-icon-jsm',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'yellow300'
    },
    {
        from: 'frame-1-icon-sharepoint',
        to: 'frame-1-icon-star-talent',
        color: 'yellow500'
    },
    {
        from: 'frame-1-avatar-orange',
        to: 'frame-1-icon-star-talent',
        connectorShape: 'arced',
        connectorType: 'dashed',
        color: 'yellow500'
    },
    {
        from: 'frame-1-icon-dollar',
        to: 'frame-1-avatar-orange',
        connectorShape: 'arced',
        connectorType: 'dashed',
        color: 'yellow500'
    },
    {
        from: 'frame-1-avatar-blue',
        to: 'frame-1-agent-top',
        connectorType: 'dashed',
        color: 'blue600'
    },
    {
        from: 'frame-1-agent-top',
        to: 'frame-1-microsoft-teams-to-shrink',
        connectorType: 'dashed',
        color: 'blue600'
    },
    {
        from: 'frame-1-icon-brackets',
        to: 'frame-1-icon-behind-microsoft-teams',
        color: 'lime500'
    },
    {
        from: 'frame-1-icon-bitbucket',
        to: 'frame-1-icon-rocket',
        color: 'lime500'
    },
    {
        from: 'frame-1-icon-lightning-bolt',
        to: 'frame-1-icon-rocket',
        color: 'neutral500'
    },
    {
        from: 'frame-1-icon-bookmark',
        to: 'frame-1-pill-roadmap',
        color: 'purple500'
    },
    {
        from: 'frame-1-pill-work-item',
        to: 'frame-1-icon-bitbucket',
        connectorShape: 'curvy',
        connectorBias: 'positive',
        color: 'lime500'
    },
    {
        from: 'frame-1-icon-lightning-bolt',
        to: 'frame-1-icon-csm',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'neutral500'
    },
    {
        from: 'frame-1-icon-lightning-bolt',
        to: 'frame-1-icon-video',
        color: 'neutral500',
        connectorShape: 'arced',
        connectorBias: 'negative'
    },
    {
        from: 'frame-1-pill-roadmap',
        to: 'frame-1-icon-video',
        color: 'neutral500',
        connectorShape: 'arced',
        connectorBias: 'positive'
    },
    {
        from: 'frame-1-icon-brackets',
        to: 'frame-1-pill-work-item',
        color: 'lime500'
    },
    {
        from: 'frame-1-icon-behind-microsoft-teams',
        to: 'frame-1-avatar-green',
        connectorShape: 'arced',
        connectorType: 'dashed',
        connectorBias: 'negative',
        color: 'lime500'
    },
    {
        from: 'frame-1-icon-csm',
        to: 'frame-1-avatar-yellow',
        connectorShape: 'arced',
        color: 'neutral500'
    },
    {
        from: 'frame-1-icon-sharepoint',
        to: 'frame-1-avatar-orange',
        connectorShape: 'arced',
        connectorBias: 'negative',
        connectorType: 'dashed',
        color: 'yellow500'
    },
    {
        from: 'frame-1-icon-sharepoint',
        to: 'frame-1-icon-dollar',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'yellow500'
    },
    {
        from: 'frame-1-icon-jsm',
        to: 'frame-1-icon-gdrive',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'yellow300'
    },
    {
        from: 'frame-1-icon-microsoft',
        to: 'frame-1-icon-dollar',
        color: 'yellow500'
    },
    {
        from: 'frame-1-icon-microsoft',
        to: 'frame-1-icon-jpd',
        color: 'purple500'
    },
    {
        from: 'frame-1-microsoft-teams-to-shrink',
        to: 'frame-1-chip-video-tr',
        color: 'blue500'
    },
    {
        from: 'frame-1-prompt-box',
        to: 'frame-1-and-2-bridge',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true,
        color: 'blue300'
    },
    {
        from: 'frame-1-chip-team-r',
        to: 'frame-1-chip-video-tr',
        connectorShape: 'straight',
        color: 'blue500'
    },
    /* frame 2 */ {
        to: 'frame-2-dot-left',
        from: 'frame-2-icon-confluence',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        from: 'frame-2-icon-confluence',
        to: 'frame-2-dot-top',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        from: 'frame-2-icon-confluence',
        to: 'frame-2-icon-hubspot',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        from: 'frame-2-icon-hubspot',
        to: 'frame-2-icon-figma',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    {
        from: 'frame-2-icon-figma',
        to: 'frame-2-dot-top-right',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    /* frame 3 */ {
        from: 'frame-2-icon-confluence',
        to: 'frame-3-icon-gdrive',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    {
        from: 'frame-3-icon-gdrive',
        to: 'frame-3-icon-cursor',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        from: 'frame-3-icon-cursor',
        to: 'frame-3-dot-bottom',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        to: 'frame-3-dot-left',
        from: 'frame-3-icon-gdrive',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    {
        to: 'frame-3-and-5-icon-jira',
        from: 'frame-3-icon-gdrive',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    {
        from: 'frame-3-and-5-icon-jira',
        to: 'frame-3-and-5-dot-right-bottom',
        connectorShape: 'curvy',
        isAnimated: true,
        connectorBias: 'positive'
    },
    /* bridge from frame 3 to frame 4 */ {
        to: 'frame-3-and-5-icon-jira',
        from: 'frame-4-icon-loom',
        connectorShape: 'curvy',
        isAnimated: true,
        connectorBias: 'positive'
    },
    /* frame 4 */ {
        from: 'frame-4-dot-top',
        to: 'frame-4-icon-canva',
        isAnimated: true
    },
    {
        from: 'frame-4-dot-right',
        to: 'frame-4-icon-sharepoint',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    {
        from: 'frame-4-icon-canva',
        to: 'frame-4-icon-loom',
        isAnimated: true
    },
    {
        from: 'frame-4-icon-sharepoint',
        to: 'frame-4-icon-loom',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    /* bridge from frame 5 to frame 6 */ {
        from: 'frame-5-behind-figma',
        to: 'frame-6-behind-rectangle-assets',
        connectorShape: 'curvy',
        connectorBias: 'negative'
    },
    {
        from: 'behind-frame-3-and-5-dot-1',
        to: 'behind-frame-3-and-5-dot-2',
        connectorShape: 'curvy',
        isAnimated: true,
        connectorBias: 'negative'
    },
    /* frame 6 */ {
        to: 'frame-6-dot-offscreen-bottom-left',
        from: 'frame-6-behind-comment',
        connectorShape: 'arced',
        connectorBias: 'positive'
    },
    {
        to: 'frame-6-icon-figma',
        from: 'frame-6-rectangle-comment',
        connectorShape: 'arced',
        connectorBias: 'negative'
    },
    {
        to: 'frame-6-rectangle-avatars',
        from: 'frame-6-behind-in-progress-top',
        connectorShape: 'curvy',
        connectorBias: 'negative'
    },
    {
        to: 'frame-6-icon-figma',
        from: 'frame-6-behind-done-bottom',
        connectorShape: 'arced',
        isAnimated: true,
        connectorBias: 'positive'
    },
    {
        from: 'frame-6-behind-assets-bottom',
        to: 'frame-6-behind-from-assets-to-avatar',
        color: 'blue500',
        connectorShape: 'curvy',
        connectorBias: 'negative'
    },
    {
        from: 'frame-6-behind-assets-top',
        to: 'frame-6-behind-from-assets-to-avatars-rectangle',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        from: 'frame-6-behind-comment',
        to: 'frame-6-behind-from-comment-to-avatar',
        connectorShape: 'arced',
        color: 'blue500',
        connectorBias: 'positive'
    },
    {
        to: 'frame-6-behind-in-progress-bottom',
        from: 'frame-6-behind-from-in-progress-to-avatar',
        color: 'blue500',
        connectorShape: 'arced',
        connectorBias: 'positive'
    },
    {
        from: 'frame-6-behind-done-top',
        to: 'frame-6-behind-from-done-to-avatar',
        color: 'blue500',
        connectorShape: 'curvy',
        connectorBias: 'positive'
    },
    /* frame 7 connectors */ {
        to: 'final-screen-behind-avatar-blue-to-jpd',
        from: 'final-screen-avatar-blue',
        color: 'neutral500'
    },
    {
        to: 'final-screen-behind-squiggle-to-idea',
        from: 'final-screen-icon-squiggle',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-bookmark',
        to: 'frame-7-icon-purple-jpd',
        color: 'neutral500'
    },
    {
        from: 'frame-7-avatar-purple',
        to: 'frame-7-icon-purple-jpd',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'neutral500'
    },
    {
        from: 'frame-7-pill-campaign',
        to: 'frame-7-avatar-purple',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'neutral500'
    },
    {
        from: 'frame-7-pill-campaign',
        to: 'frame-7-icon-hubspot',
        connectorShape: 'arced',
        connectorBias: 'negative'
    },
    {
        from: 'frame-7-pill-campaign',
        to: 'frame-7-dot-x-30-y-0',
        connectorShape: 'arced',
        color: 'blue600',
        connectorBias: 'negative'
    },
    {
        from: 'frame-7-avatar-purple',
        to: 'frame-7-pill-idea',
        color: 'neutral500'
    },
    {
        from: 'frame-7-behind-loom',
        to: 'frame-7-icon-csm',
        color: 'blue300'
    },
    {
        from: 'frame-7-icon-behind-confluence',
        to: 'frame-7-icon-csm',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-bell',
        to: 'frame-7-avatar-lime-bottom',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-rocket',
        to: 'frame-7-icon-bell',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-rocket',
        to: 'frame-7-icon-csm',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'yellow400'
    },
    {
        from: 'frame-7-avatar-yellow',
        to: 'frame-7-icon-csm',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'yellow400'
    },
    {
        from: 'frame-7-avatar-yellow',
        to: 'frame-7-icon-jsm',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-csm',
        to: 'frame-7-icon-jsm',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-bell',
        to: 'frame-7-icon-jsm',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-bitbucket',
        to: 'frame-7-avatar-saffron',
        connectorBias: 'negative',
        connectorShape: 'arced',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-bell',
        to: 'frame-7-avatar-saffron',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'blue600'
    },
    {
        from: 'frame-7-avatar-saffron',
        to: 'frame-7-icon-gdrive',
        color: 'blue600'
    },
    {
        from: 'frame-7-icon-target',
        to: 'frame-7-avatar-saffron',
        color: 'blue600'
    },
    {
        from: 'frame-7-pill-release',
        to: 'frame-7-avatar-lime-bottom',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-gdrive',
        to: 'frame-7-avatar-lime-bottom',
        color: 'neutral500'
    },
    {
        from: 'frame-7-avatar-lime-top',
        to: 'frame-7-pill-pr',
        color: 'lime500'
    },
    {
        from: 'frame-7-avatar-lime-top',
        to: 'frame-7-icon-rovo-dev',
        color: 'lime500'
    },
    {
        from: 'frame-7-avatar-lime-top',
        to: 'frame-7-icon-bitbucket',
        color: 'lime500'
    },
    {
        from: 'frame-7-dot-x-50-y-0',
        to: 'frame-7-avatar-orange',
        color: 'orange300'
    },
    {
        from: 'frame-7-icon-focus-top',
        to: 'frame-7-avatar-orange',
        color: 'orange300'
    },
    {
        from: 'frame-7-icon-focus-top',
        to: 'frame-7-dot-x-60-y-0'
    },
    {
        from: 'frame-7-icon-focus-top',
        to: 'frame-7-dot-x-65-y-0'
    },
    {
        from: 'frame-7-icon-jira-top',
        to: 'frame-7-avatar-orange',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'orange300'
    },
    {
        from: 'frame-7-pill-goal',
        to: 'frame-7-avatar-orange',
        connectorShape: 'arced',
        connectorBias: 'negative',
        color: 'orange300'
    },
    {
        from: 'frame-7-pill-campaign',
        to: 'frame-7-icon-bookmark',
        color: 'neutral500'
    },
    {
        from: 'frame-7-icon-bookmark',
        to: 'frame-7-icon-jira-top',
        connectorShape: 'arced',
        color: 'neutral500'
    },
    {
        from: 'frame-7-avatar-lime-top',
        to: 'frame-7-icon-focus-top',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'neutral500'
    },
    {
        from: 'frame-7-avatar-lime-top',
        to: 'frame-7-dot-x-80-y-0',
        color: 'lime500'
    },
    {
        from: 'frame-7-icon-behind-confluence',
        to: 'frame-7-avatar-yellow',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'yellow400'
    },
    {
        from: 'frame-7-icon-jsm',
        to: 'frame-7-avatar-lime-bottom',
        connectorShape: 'arced',
        color: 'neutral500'
    },
    {
        from: 'frame-7-dot-x-0-y-90',
        to: 'pill-meeting-notes',
        connectorShape: 'arced',
        connectorBias: 'positive',
        color: 'blue600'
    }
];
const $f9897010521bbd9d$export$b965507d386cb99d = [
    {
        from: 'mobile-component-A-icon-figma-top',
        to: 'mobile-component-A-avatar-blue-top',
        connectorShape: 'arced',
        connectorBias: 'negative'
    },
    {
        from: 'mobile-component-A-hex-wrench-2',
        to: 'mobile-component-A-avatar-blue-top'
    },
    {
        from: 'mobile-component-A-rectangle-prompt',
        to: 'mobile-component-A-avatar-blue-top',
        color: 'blue300'
    },
    {
        from: 'mobile-component-A-hex-wrench-1',
        to: 'mobile-component-A-avatar-blue-top'
    },
    {
        from: 'mobile-component-A-hex-wrench-1',
        to: 'mobile-component-A-rectangle-project'
    },
    {
        from: 'mobile-component-A-icon-microsoft-teams',
        to: 'mobile-component-A-rectangle-project'
    },
    {
        from: 'mobile-component-A-icon-circle-arrow',
        to: 'mobile-component-A-avatar-blue-top',
        connectorShape: 'arced',
        connectorBias: 'negative'
    },
    {
        from: 'mobile-component-A-rectangle-project',
        to: 'mobile-component-A-dot-top-left'
    },
    {
        from: 'mobile-component-A-hex-wrench-2',
        to: 'mobile-component-A-dot-top-right',
        connectorShape: 'arced',
        connectorBias: 'positive'
    }
];
const $f9897010521bbd9d$export$dd9213ac7d5a9d04 = [
    {
        from: 'mobile-component-B-icon-confluence',
        to: 'mobile-component-B-dot-top',
        color: 'blue300'
    },
    {
        from: 'mobile-component-B-icon-confluence',
        to: 'mobile-component-B-dot-left-bottom',
        color: 'blue300',
        isAnimated: true,
        connectorShape: 'arced',
        connectorBias: 'negative'
    },
    {
        from: 'mobile-component-B-icon-confluence',
        to: 'mobile-component-B-icon-figma-bottom',
        color: 'blue300',
        isAnimated: true,
        connectorShape: 'arced',
        connectorBias: 'positive'
    },
    {
        to: 'mobile-component-B-dot-right-bottom',
        from: 'mobile-component-B-icon-figma-bottom',
        color: 'blue300',
        isAnimated: true,
        connectorShape: 'arced',
        connectorBias: 'positive'
    },
    {
        from: 'mobile-component-B-icon-confluence',
        to: 'mobile-component-B-rectangle-assets',
        color: 'blue300',
        isAnimated: true,
        connectorShape: 'curvy',
        connectorBias: 'positive',
        animationColor: 'blue'
    }
];
const $f9897010521bbd9d$export$621ed6415af9863e = [
    {
        from: 'mobile-component-C-dot-top',
        to: 'mobile-component-C-icon-figma-bottom',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true,
        animationColor: 'blue'
    },
    {
        from: 'mobile-component-C-dot-top',
        to: 'mobile-component-C-dot-left',
        connectorShape: 'arced',
        connectorBias: 'negative'
    }
];
const $f9897010521bbd9d$export$74d164615ea757fb = [
    {
        from: 'mobile-component-D-dot-top',
        to: 'mobile-component-D-icon-gdrive',
        isAnimated: true,
        connectorShape: 'arced',
        connectorBias: 'positive'
    },
    {
        from: 'mobile-component-D-icon-gdrive',
        to: 'mobile-component-D-dot-right',
        connectorShape: 'arced',
        connectorBias: 'positive'
    },
    {
        from: 'mobile-component-D-dot-top',
        to: 'mobile-component-D-rectangle-in-progress',
        isAnimated: true,
        connectorShape: 'arced',
        connectorBias: 'negative'
    }
];
const $f9897010521bbd9d$export$a2089f34a89c6aea = [
    {
        from: 'mobile-component-E-dot-top',
        to: 'mobile-component-E-icon-sharepoint-bottom',
        isAnimated: true,
        connectorShape: 'arced',
        connectorBias: 'negative'
    },
    {
        from: 'mobile-component-E-icon-sharepoint-bottom',
        to: 'mobile-component-E-dot-left',
        connectorShape: 'arced',
        isAnimated: true,
        connectorBias: 'negative'
    }
];
const $f9897010521bbd9d$export$c30288e07ec1214e = [
    {
        from: 'mobile-component-F-dot-top',
        to: 'mobile-component-F-dot-left',
        isAnimated: true,
        connectorShape: 'arced',
        connectorBias: 'negative'
    },
    {
        from: 'mobile-component-F-dot-top',
        to: 'mobile-component-F-rectangle-comment',
        connectorShape: 'arced',
        isAnimated: true,
        connectorBias: 'negative'
    },
    {
        to: 'mobile-component-F-dot-bottom-right',
        from: 'mobile-component-F-rectangle-comment',
        connectorShape: 'arced',
        isAnimated: true,
        connectorBias: 'positive'
    }
];
const $f9897010521bbd9d$export$b558969562a813f5 = [
    {
        from: 'mobile-component-H-dot-top-left',
        to: 'mobile-component-H-icon-figma',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    {
        to: 'mobile-component-H-dot-top-right',
        from: 'mobile-component-H-icon-figma',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    {
        from: 'mobile-component-H-dot-top-left',
        to: 'mobile-component-H-icon-microsoft',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        to: 'mobile-component-H-dot-middle-left',
        from: 'mobile-component-H-icon-microsoft',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        from: 'mobile-component-H-dot-top-left',
        to: 'mobile-component-H-rectangle-avatars',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        to: 'mobile-component-H-dot-bottom',
        from: 'mobile-component-H-rectangle-avatars',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    }
];
const $f9897010521bbd9d$export$f08b61eee7038f83 = [
    {
        from: 'mobile-component-I-dot-top',
        to: 'mobile-component-I-dot-mid',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    {
        from: 'mobile-component-I-dot-mid',
        to: 'mobile-component-I-avatar-blue',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        from: 'mobile-component-I-dot-mid',
        to: 'mobile-component-I-dot-left-mid',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        from: 'mobile-component-I-dot-mid',
        to: 'mobile-component-I-dot-right-mid',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    },
    {
        from: 'mobile-component-I-avatar-blue',
        to: 'mobile-component-I-dot-left-bottom',
        connectorShape: 'arced',
        connectorBias: 'negative',
        isAnimated: true
    },
    {
        from: 'mobile-component-I-avatar-blue',
        to: 'mobile-component-I-dot-right-bottom',
        connectorShape: 'arced',
        connectorBias: 'positive',
        isAnimated: true
    }
];

});


parcelRegister("cwpkM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0641dc4fa0c9006d$export$2e2bcd8739ae039; });
/* template-preview.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $1wldG = parcelRequire("1wldG");

var $e3eMt = parcelRequire("e3eMt");
const $0641dc4fa0c9006d$var$UniformTemplatePreview = ({ templatePreview: templatePreview, templateType: templateType })=>{
    if (!templatePreview) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_y3gn1h6o _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e3eMt.UniformTemplatePreviewWindow), {
            url: templatePreview.file.url ?? '',
            alt: templatePreview.description ?? '',
            templateType: templateType || (0, $1wldG.TemplateType).Page
        })
    });
};
const $0641dc4fa0c9006d$var$templatePreviewSection = null;
var $0641dc4fa0c9006d$export$2e2bcd8739ae039 = $0641dc4fa0c9006d$var$UniformTemplatePreview;

});
parcelRegister("e3eMt", function(module, exports) {
$parcel$export(module.exports, "UniformTemplatePreviewWindow", function () { return $d2c1227d2c24707c$export$7796399069f4fd6e; });
/* template-preview-window.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kz1DD = parcelRequire("kz1DD");

var $eY3N6 = parcelRequire("eY3N6");

var $1wldG = parcelRequire("1wldG");

var $kbpa7 = parcelRequire("kbpa7");

var $gRDcE = parcelRequire("gRDcE");

var $yKFYG = parcelRequire("yKFYG");
const $d2c1227d2c24707c$var$previewTopBar = null;
const $d2c1227d2c24707c$var$previewBarDot = null;
const $d2c1227d2c24707c$var$previewImage = null;
const $d2c1227d2c24707c$export$7796399069f4fd6e = ({ url: url, alt: alt, templateType: templateType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const templatePreview = null;
    const previewScreenshot = null;
    const whiteboardPreviewWrapper = null;
    const zoomControls = null;
    const zoomControl = null;
    const regionLabel = intl.formatMessage({
        id: 'template-preview.scrollable-content',
        defaultMessage: 'Scrollbar'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ]),
        children: templateType === (0, $1wldG.TemplateType).Whiteboard ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkkhc1"
                    ]),
                    style: {
                        "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhk1afi _2rko1ssb"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhk1afi _2rko1ssb"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhk1afi _2rko1ssb"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    role: "region",
                    "aria-label": regionLabel,
                    className: (0, $2jatx.default)([
                        "_4t3i1gwv _18m91wug _bfhk1afi _1yxn1b66 _1ein1b66 _19itn5xp _11qbbn52 _12fm15vq",
                        "_80om1qgj _ou2u1osq"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                        "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kz1DD.TransformWrapper), {
                        children: ({ zoomIn: zoomIn, zoomOut: zoomOut })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kz1DD.TransformComponent), {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                            src: url,
                                            alt: alt,
                                            className: (0, $2jatx.default)([
                                                "_1bsb1osq _p12f1osq"
                                            ])
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulpu2gc _kqswstnw _u7copxbi _rjxppxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    zoomIn();
                                                    createAnalyticsEvent({
                                                        eventType: 'ui',
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'zoomIn',
                                                        source: 'templatePreview'
                                                    }).fire();
                                                },
                                                "aria-label": intl.formatMessage({
                                                    id: 'template-preview.zoom-in',
                                                    defaultMessage: 'Zoom In'
                                                }),
                                                className: (0, $2jatx.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gRDcE.ZoomIn), {
                                                    size: "16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    zoomOut();
                                                    createAnalyticsEvent({
                                                        eventType: 'ui',
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'zoomOut',
                                                        source: 'templatePreview'
                                                    }).fire();
                                                },
                                                "aria-label": intl.formatMessage({
                                                    id: 'template-preview.zoom-out',
                                                    defaultMessage: 'Zoom Out'
                                                }),
                                                className: (0, $2jatx.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $yKFYG.ZoomOut), {
                                                    size: "16"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkkhc1"
                    ]),
                    style: {
                        "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhk1afi _2rko1ssb"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhk1afi _2rko1ssb"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhk1afi _2rko1ssb"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    role: "region",
                    "aria-label": regionLabel,
                    className: (0, $2jatx.default)([
                        "_4t3i1gwv _18m91wug _bfhk1afi _1yxn1b66 _1ein1b66 _19itn5xp _11qbbn52 _12fm15vq"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                        "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: url,
                        alt: alt,
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _p12f1osq"
                        ])
                    })
                })
            ]
        })
    });
};

});


parcelRegister("aSmcz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("eFi9k")).default; });

var $eFi9k = parcelRequire("eFi9k");

});
parcelRegister("eFi9k", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc721b325f003ef7$export$2e2bcd8739ae039; });
/* templates-search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $foNCS = parcelRequire("foNCS");

var $eY3N6 = parcelRequire("eY3N6");

var $53VCz = parcelRequire("53VCz");

var $cNOwN = parcelRequire("cNOwN");

var $5ZCzy = parcelRequire("5ZCzy");

var $kbpa7 = parcelRequire("kbpa7");

var $17RBn = parcelRequire("17RBn");

var $jQ0cd = parcelRequire("jQ0cd");

var $3riD8 = parcelRequire("3riD8");

var $3lGAh = parcelRequire("3lGAh");

var $9rnwe = parcelRequire("9rnwe");

var $cP432 = parcelRequire("cP432");

var $H7SCD = parcelRequire("H7SCD");

var $f4mYE = parcelRequire("f4mYE");
const $fc721b325f003ef7$var$SEARCH_QUERY_PARAM = 'term';
/** Upper bound on the search query length, applied wherever raw input enters state. */ const $fc721b325f003ef7$var$MAX_SEARCH_QUERY_LENGTH = 256;
const $fc721b325f003ef7$var$INVERSE_TEXT_COLOR = "var(--ds-text-inverse, #FFFFFF)";
/**
 * Sanitizes raw search input before it enters component state.
 *
 * Applied at every entry point (keystrokes and URL hydration), so all
 * downstream consumers — the URL `?term=` param, the gallery search event,
 * suggestions, and analytics — receive a bounded, cleaned string. HTML/URL
 * escaping is handled by React and URLSearchParams downstream; this focuses on:
 * - stripping control characters (e.g. from a paste),
 * - collapsing runs of whitespace to a single space,
 * - capping the length at {@link MAX_SEARCH_QUERY_LENGTH}.
 */ const $fc721b325f003ef7$var$sanitizeSearchQuery = (raw)=>raw// Collapse any whitespace (incl. tabs/newlines) to a single space first,
    // so those characters aren't caught by the control-character strip below.
    .replace(/\s+/g, ' ')// Strip remaining control characters (e.g. from a paste).
    // eslint-disable-next-line no-control-regex
    .replace(/[\u0000-\u001F\u007F]/g, '').slice(0, $fc721b325f003ef7$var$MAX_SEARCH_QUERY_LENGTH);
const $fc721b325f003ef7$var$SUGGESTIONS_LISTBOX_ID = 'templates-search-suggestions-listbox';
const $fc721b325f003ef7$var$ALL_RESULTS_OPTION_ID = 'templates-search-all-results-option';
const $fc721b325f003ef7$var$buildSuggestionOptionId = (index)=>`templates-search-suggestion-option-${index}`;
const $fc721b325f003ef7$var$messages = (0, $fnHPc.defineMessages)({
    heading: {
        id: 'templates-search-bar.heading',
        defaultMessage: 'Search all templates below'
    },
    subheading: {
        id: 'templates-search-bar.subheading',
        defaultMessage: 'Find Atlassian templates in one place.'
    },
    placeholder: {
        id: 'templates-search-bar.placeholder',
        defaultMessage: 'Search templates'
    },
    clearSearch: {
        id: 'templates-search-bar.clear-search',
        defaultMessage: 'Clear search'
    },
    allSearchResults: {
        id: 'templates-search-bar.all-search-results',
        defaultMessage: 'All search results'
    }
});
const $fc721b325f003ef7$var$DEFAULT_PROPS = {
    suggestionLabelPath: 'fields.templateNameExternal',
    suggestionProductPath: 'fields.product.0.fields.productNameReference.fields.productName',
    suggestionHrefPath: 'fields.fullUrlSlug',
    maxSuggestions: 6
};
const $fc721b325f003ef7$var$handleSuggestionKeyDown = ({ event: event, suggestions: suggestions, activeIndex: activeIndex, setActiveIndex: setActiveIndex, setValue: setValue, submitSearch: submitSearch, submitAllResults: submitAllResults, dismissSuggestions: dismissSuggestions })=>{
    // "All search results" is the final navigable row, past the last suggestion.
    const allResultsIndex = suggestions.length;
    if (event.key === 'Escape') {
        event.preventDefault();
        dismissSuggestions();
        return;
    }
    if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveIndex((current)=>Math.min(current + 1, allResultsIndex));
        return;
    }
    if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveIndex((current)=>Math.max(current - 1, 0));
        return;
    }
    if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        if (activeIndex === allResultsIndex) {
            submitAllResults();
            return;
        }
        const suggestion = suggestions[activeIndex];
        if (!suggestion) return;
        if (suggestion.href) {
            window.location.href = suggestion.href;
            return;
        }
        setValue(suggestion.queryValue);
        submitSearch(suggestion.queryValue);
    }
};
const $fc721b325f003ef7$var$ANALYTICS_SOURCE = 'templatesSearchBar';
const $fc721b325f003ef7$var$ANALYTICS_CONTAINER = 'templatesSearchBar';
/** Wait this long after the last keystroke before deciding a query truly returned no results. */ const $fc721b325f003ef7$var$NO_RESULTS_DEBOUNCE_MS = 500;
const $fc721b325f003ef7$var$buildAnalyticsAttributes = (searchQuery)=>({
        product: 'templates',
        pageUrl: typeof window === 'undefined' ? '' : window.location.href,
        pagePath: typeof window === 'undefined' ? '' : window.location.pathname,
        searchQuery: searchQuery
    });
/**
 * GASv3 instrumentation for the templates search bar. Fires three events that
 * back the search-health metrics (usage rate, top queries, zero-results rate):
 * - `engaged`  — once per mount, the first time the user interacts. Fired for
 *   all users (carries no query) so usage rate stays accurate.
 * - `submitted` — when a search is executed (submit, "all results", or a
 *   suggestion selection), carrying the query for top-query analysis.
 * - `noResults` — debounced; when a settled, non-empty query yields no
 *   template matches.
 *
 * Search terms are tracked for LOGGED-OUT users only: both the `submitted` and
 * `noResults` events carry the raw `searchQuery`, so they are gated on the
 * logged-out state. Login state comes from `useLoggedInUser`, which defaults to
 * logged-out until the session check settles.
 *
 * Modeled on the global nav search bar's `createAnalyticsEvent` usage.
 */ const $fc721b325f003ef7$var$useTemplatesSearchAnalytics = ({ query: query, templateMatchCount: templateMatchCount })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    // Search-term tracking is for logged-out users only.
    const shouldTrackSearchTerms = !isUserLoggedIn;
    const hasEngagedRef = (0, $1oC0p.useRef)(false);
    const lastNoResultsQueryRef = (0, $1oC0p.useRef)(null);
    const trackEngaged = (0, $1oC0p.useCallback)(()=>{
        if (hasEngagedRef.current) return;
        hasEngagedRef.current = true;
        createAnalyticsEvent({
            eventName: 'engageTemplatesSearch',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'search',
            actionSubjectId: 'templatesSearchInput',
            eventContainer: $fc721b325f003ef7$var$ANALYTICS_CONTAINER,
            source: $fc721b325f003ef7$var$ANALYTICS_SOURCE,
            attributes: $fc721b325f003ef7$var$buildAnalyticsAttributes('')
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const trackSubmitted = (0, $1oC0p.useCallback)((submittedQuery)=>{
        // Search terms are only captured for logged-out users.
        if (!shouldTrackSearchTerms) return;
        const trimmed = submittedQuery.trim();
        if (!trimmed) return;
        createAnalyticsEvent({
            eventName: 'submitTemplatesSearch',
            eventType: 'ui',
            action: 'submitted',
            actionSubject: 'search',
            actionSubjectId: 'templatesSearchBar',
            eventContainer: $fc721b325f003ef7$var$ANALYTICS_CONTAINER,
            source: $fc721b325f003ef7$var$ANALYTICS_SOURCE,
            attributes: $fc721b325f003ef7$var$buildAnalyticsAttributes(trimmed)
        }).fire();
    }, [
        createAnalyticsEvent,
        shouldTrackSearchTerms
    ]);
    const trackCleared = (0, $1oC0p.useCallback)(()=>{
        // Carries no query, so it fires for all users (no logged-out gate).
        createAnalyticsEvent({
            eventName: 'clearTemplatesSearch',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'templatesSearchClear',
            eventContainer: $fc721b325f003ef7$var$ANALYTICS_CONTAINER,
            source: $fc721b325f003ef7$var$ANALYTICS_SOURCE,
            attributes: $fc721b325f003ef7$var$buildAnalyticsAttributes('')
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    // Debounced zero-results detection: only fire once per distinct query, and
    // only after the suggestions for that query have settled. Carries the query,
    // so it is gated to logged-out users.
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldTrackSearchTerms) return;
        const trimmed = query.trim();
        if (!trimmed) {
            lastNoResultsQueryRef.current = null;
            return;
        }
        if (templateMatchCount > 0) return;
        if (lastNoResultsQueryRef.current === trimmed) return;
        const timeoutId = setTimeout(()=>{
            lastNoResultsQueryRef.current = trimmed;
            createAnalyticsEvent({
                eventName: 'templatesSearchNoResults',
                eventType: 'ui',
                action: 'displayed',
                actionSubject: 'search',
                actionSubjectId: 'templatesSearchNoResults',
                eventContainer: $fc721b325f003ef7$var$ANALYTICS_CONTAINER,
                source: $fc721b325f003ef7$var$ANALYTICS_SOURCE,
                attributes: $fc721b325f003ef7$var$buildAnalyticsAttributes(trimmed)
            }).fire();
        }, $fc721b325f003ef7$var$NO_RESULTS_DEBOUNCE_MS);
        return ()=>clearTimeout(timeoutId);
    }, [
        query,
        templateMatchCount,
        createAnalyticsEvent,
        shouldTrackSearchTerms
    ]);
    return {
        trackEngaged: trackEngaged,
        trackSubmitted: trackSubmitted,
        trackCleared: trackCleared
    };
};
/** Suggestions from the gallery's shared items + config (so they match the gallery); falls back to the `items` prop when there's no gallery context. */ const $fc721b325f003ef7$var$useSuggestions = ({ rawItems: rawItems, query: query, labelPath: labelPath, productPath: productPath, hrefPath: hrefPath, maxSuggestions: maxSuggestions, formatSuggestionLabel: formatSuggestionLabel, activeLocale: activeLocale })=>{
    const galleryConfig = (0, $foNCS.useFilterableGalleryLoader)()?.galleryConfig ?? null;
    const items = (0, $1oC0p.useMemo)(()=>galleryConfig?.items ?? $fc721b325f003ef7$var$normaliseItems(rawItems), [
        galleryConfig,
        rawItems
    ]);
    return (0, $1oC0p.useMemo)(()=>$fc721b325f003ef7$var$buildSuggestions({
            query: query,
            items: items,
            labelPath: labelPath,
            productPath: productPath,
            hrefPath: hrefPath,
            searchConfiguration: galleryConfig?.searchConfiguration,
            featuredItemSlugs: galleryConfig?.featuredItemSlugs ?? [],
            maxSuggestions: maxSuggestions,
            formatSuggestionLabel: formatSuggestionLabel,
            activeLocale: activeLocale
        }), [
        query,
        items,
        labelPath,
        productPath,
        hrefPath,
        galleryConfig,
        maxSuggestions,
        formatSuggestionLabel,
        activeLocale
    ]);
};
const $fc721b325f003ef7$var$TemplatesSearchBar = ({ heading: heading, subheading: subheading, placeholder: placeholder, items: rawItems, suggestionLabelPath: suggestionLabelPath = $fc721b325f003ef7$var$DEFAULT_PROPS.suggestionLabelPath, suggestionProductPath: suggestionProductPath = $fc721b325f003ef7$var$DEFAULT_PROPS.suggestionProductPath, suggestionHrefPath: suggestionHrefPath = $fc721b325f003ef7$var$DEFAULT_PROPS.suggestionHrefPath, maxSuggestions: maxSuggestions = $fc721b325f003ef7$var$DEFAULT_PROPS.maxSuggestions })=>{
    const intl = (0, $8e22h.default)();
    // Search bar chrome is localized from the active page locale; the default
    // (English) locale resolves to the original copy. CMS-provided overrides
    // take precedence. See GWP-12213.
    const resolvedHeading = heading ?? intl.formatMessage($fc721b325f003ef7$var$messages.heading);
    const resolvedSubheading = subheading ?? intl.formatMessage($fc721b325f003ef7$var$messages.subheading);
    const resolvedPlaceholder = placeholder ?? intl.formatMessage($fc721b325f003ef7$var$messages.placeholder);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "data-testid": "templates-search-bar",
        className: (0, $2jatx.default)([
            "_bfhk1pfd _syaz1afi _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _ca0qys9h _u5f31tcg _n3tdys9h _19bv1tcg _1reoewfl _18m9ewfl _1kmxvbgk _1ggm7vkz _1ykzvbgk _1mae7vkz"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_syaz1gfe _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb8pqr _vwz41btq _k48p1fw0 _1cqsviql",
                    "templates-search-bar-heading"
                ]),
                style: {
                    color: $fc721b325f003ef7$var$INVERSE_TEXT_COLOR
                },
                children: resolvedHeading
            }),
            resolvedSubheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syaz1gfe _18s81yj3 _1wyb1k92 _vwz419ii",
                    "templates-search-bar-subheading"
                ]),
                style: {
                    color: $fc721b325f003ef7$var$INVERSE_TEXT_COLOR
                },
                children: resolvedSubheading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($fc721b325f003ef7$var$TemplatesSearchForm, {
                placeholder: resolvedPlaceholder,
                rawItems: rawItems,
                suggestionLabelPath: suggestionLabelPath,
                suggestionProductPath: suggestionProductPath,
                suggestionHrefPath: suggestionHrefPath,
                maxSuggestions: maxSuggestions
            })
        ]
    });
};
const $fc721b325f003ef7$var$TemplatesSearchForm = ({ placeholder: placeholder, rawItems: rawItems, suggestionLabelPath: suggestionLabelPath, suggestionProductPath: suggestionProductPath, suggestionHrefPath: suggestionHrefPath, maxSuggestions: maxSuggestions })=>{
    const intl = (0, $8e22h.default)();
    const intlLocale = (0, $17RBn.useLocale)();
    const activeLocale = (0, $9rnwe.useWAEContextSafe)()?.locale ?? intlLocale;
    const formatSuggestionLabel = (0, $1oC0p.useMemo)(()=>({ title: title, product: product })=>intl.formatMessage({
                id: 'templates-search-bar.suggestion-label',
                defaultMessage: '{title} - {product} Template'
            }, {
                title: title,
                product: product
            }), [
        intl
    ]);
    const [value, setValue] = (0, $1oC0p.useState)('');
    const [isFocused, setIsFocused] = (0, $1oC0p.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $1oC0p.useState)(false);
    const [activeIndex, setActiveIndex] = (0, $1oC0p.useState)(-1);
    const suggestions = $fc721b325f003ef7$var$useSuggestions({
        rawItems: rawItems,
        query: value,
        labelPath: suggestionLabelPath,
        productPath: suggestionProductPath,
        hrefPath: suggestionHrefPath,
        maxSuggestions: maxSuggestions,
        formatSuggestionLabel: formatSuggestionLabel,
        activeLocale: activeLocale
    });
    // The raw typed-query row is always present, so a true "no results" signal
    // counts only suggestions backed by an actual template (those with an href).
    const templateMatchCount = suggestions.filter((suggestion)=>Boolean(suggestion.href)).length;
    const { trackEngaged: trackEngaged, trackSubmitted: trackSubmitted, trackCleared: trackCleared } = $fc721b325f003ef7$var$useTemplatesSearchAnalytics({
        query: value,
        templateMatchCount: templateMatchCount
    });
    const shouldShowSuggestions = isFocused && !isDismissed && value.trim().length > 0 && suggestions.length > 0;
    const dismissSuggestions = ()=>{
        setIsDismissed(true);
        setActiveIndex(-1);
    };
    const activeDescendantId = shouldShowSuggestions && activeIndex >= 0 ? activeIndex >= suggestions.length ? $fc721b325f003ef7$var$ALL_RESULTS_OPTION_ID : $fc721b325f003ef7$var$buildSuggestionOptionId(activeIndex) : undefined;
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const hydrateFromUrl = ()=>{
            const params = new URLSearchParams(window.location.search);
            // Sanitize here too: the URL param can be hand-crafted and bypasses the input.
            setValue($fc721b325f003ef7$var$sanitizeSearchQuery(params.get($fc721b325f003ef7$var$SEARCH_QUERY_PARAM) ?? ''));
        };
        hydrateFromUrl();
        window.addEventListener('popstate', hydrateFromUrl);
        return ()=>window.removeEventListener('popstate', hydrateFromUrl);
    }, []);
    const submitSearch = (nextValue = value)=>{
        trackSubmitted(nextValue);
        $fc721b325f003ef7$var$writeSearchQuery(nextValue);
        setIsFocused(false);
        setActiveIndex(-1);
    };
    const clearSearch = ()=>{
        trackCleared();
        setValue('');
        $fc721b325f003ef7$var$writeSearchQuery('');
        setActiveIndex(-1);
    };
    const submitAllSearchResults = ()=>{
        submitSearch();
        (0, $f4mYE.dispatchShowAllFilterableGalleryItems)(value);
    };
    const handleKeyDown = (event)=>{
        if (!shouldShowSuggestions) return;
        $fc721b325f003ef7$var$handleSuggestionKeyDown({
            event: event,
            suggestions: suggestions,
            activeIndex: activeIndex,
            setActiveIndex: setActiveIndex,
            setValue: setValue,
            submitSearch: submitSearch,
            submitAllResults: submitAllSearchResults,
            dismissSuggestions: dismissSuggestions
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        role: "search",
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) setIsFocused(false);
        },
        onFocus: ()=>{
            setIsFocused(true);
            setIsDismissed(false);
            trackEngaged();
        },
        onSubmit: (event)=>{
            event.preventDefault();
            submitAllSearchResults();
        },
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _p12fbxu3 _1pfh1ady"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1ylp _2rkogktf _bfhk1afi _1e0c1txw _4cvr1h6o _ca0qidpf _u5f37vkz _n3tdidpf _19bvgktf _syaz1pfd"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_syazdgkc _1e0c1txw _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _12l2utpp"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5ZCzy))), {
                            label: "",
                            size: "medium"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                        "aria-label": placeholder,
                        placeholder: placeholder,
                        value: value,
                        maxLength: $fc721b325f003ef7$var$MAX_SEARCH_QUERY_LENGTH,
                        role: "combobox",
                        "aria-autocomplete": "list",
                        "aria-expanded": shouldShowSuggestions,
                        "aria-controls": $fc721b325f003ef7$var$SUGGESTIONS_LISTBOX_ID,
                        "aria-activedescendant": activeDescendantId,
                        onChange: (event)=>{
                            setValue($fc721b325f003ef7$var$sanitizeSearchQuery(event.target.value));
                            setIsFocused(true);
                            setIsDismissed(false);
                            setActiveIndex(-1);
                            trackEngaged();
                        },
                        onKeyDown: handleKeyDown,
                        className: (0, $2jatx.default)([
                            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _bfhk1j28 _syaz1pfd _1wyb1j6v _vwz4bs82 _ect41kw7"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        }
                    }),
                    value && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        "aria-label": intl.formatMessage($fc721b325f003ef7$var$messages.clearSearch),
                        onClick: clearSearch,
                        className: (0, $2jatx.default)([
                            "_bfhk1j28 _19itidpf _syaz1pfd _80omtlke _1e0c1txw _4cvr1h6o _1bah1h6o _16jlidpf _1o9zidpf _i0dl1wug _1yt41b66"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                            label: "",
                            size: "medium"
                        })
                    })
                ]
            }),
            shouldShowSuggestions && /*#__PURE__*/ (0, $7VQPk.jsx)($fc721b325f003ef7$var$SuggestionsPanel, {
                suggestions: suggestions,
                activeIndex: activeIndex,
                query: value,
                setActiveIndex: setActiveIndex,
                onSelect: (suggestion)=>{
                    setValue(suggestion.queryValue);
                    submitSearch(suggestion.queryValue);
                },
                onAllResults: submitAllSearchResults,
                allResultsLabel: intl.formatMessage($fc721b325f003ef7$var$messages.allSearchResults)
            })
        ]
    });
};
const $fc721b325f003ef7$var$normaliseItems = (rawItems)=>{
    if (Array.isArray(rawItems)) return rawItems;
    if ((0, $3lGAh.isContentfulEnvelope)(rawItems)) return rawItems.items;
    return [];
};
const $fc721b325f003ef7$var$resolveStrings = (item, path)=>(0, $H7SCD.coerceToPrimitiveArray)((0, $H7SCD.resolveFieldPath)(item, path));
const $fc721b325f003ef7$var$resolveString = (item, path)=>$fc721b325f003ef7$var$resolveStrings(item, path)[0];
/** Fallback config (when the gallery shares none) ranking title above product, over the search bar's own display paths. */ const $fc721b325f003ef7$var$buildRankingConfig = (labelPath, productPath)=>({
        keys: [
            {
                name: labelPath,
                weight: 1
            },
            ...productPath ? [
                {
                    name: productPath,
                    weight: 0.7
                }
            ] : []
        ]
    });
/** Builds the dropdown: the raw query first, then items ranked by the same search the gallery uses, deduped by display label. */ const $fc721b325f003ef7$var$buildSuggestions = ({ query: query, items: items, labelPath: labelPath, productPath: productPath, hrefPath: hrefPath, searchConfiguration: searchConfiguration, featuredItemSlugs: featuredItemSlugs, maxSuggestions: maxSuggestions, formatSuggestionLabel: formatSuggestionLabel, activeLocale: activeLocale })=>{
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return [];
    const lowerQuery = trimmedQuery.toLowerCase();
    const suggestionLimit = Math.max(maxSuggestions, 0);
    if (suggestionLimit === 0) return [];
    const suggestions = [
        {
            id: `query-${lowerQuery}`,
            label: trimmedQuery,
            queryValue: trimmedQuery
        }
    ];
    if (suggestionLimit === 1) return suggestions;
    const rankedItems = (0, $H7SCD.searchWithFeaturedBoost)(items, trimmedQuery, searchConfiguration ?? $fc721b325f003ef7$var$buildRankingConfig(labelPath, productPath), featuredItemSlugs);
    const seen = new Set([
        lowerQuery
    ]);
    for (const item of rankedItems){
        const title = $fc721b325f003ef7$var$resolveString(item, labelPath);
        if (!title) continue;
        const product = $fc721b325f003ef7$var$resolveString(item, productPath);
        const label = product ? formatSuggestionLabel({
            title: title,
            product: product
        }) : title;
        const key = label.toLowerCase();
        if (seen.has(key)) continue;
        seen.add(key);
        const href = $fc721b325f003ef7$var$resolveString(item, hrefPath);
        suggestions.push({
            id: key,
            label: label,
            queryValue: title,
            href: href ? (0, $jQ0cd.getLocalizedHref)({
                href: href,
                locale: activeLocale
            }) : undefined
        });
        if (suggestions.length >= suggestionLimit) break;
    }
    return suggestions;
};
const $fc721b325f003ef7$var$writeSearchQuery = (query)=>{
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const trimmedQuery = query.trim();
    if (trimmedQuery) params.set($fc721b325f003ef7$var$SEARCH_QUERY_PARAM, trimmedQuery);
    else params.delete($fc721b325f003ef7$var$SEARCH_QUERY_PARAM);
    const nextSearch = params.toString();
    const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`;
    if (nextUrl !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
        window.history.pushState({}, '', nextUrl);
        window.dispatchEvent(new Event('popstate'));
    }
    window.dispatchEvent(new CustomEvent((0, $cP432.GALLERY_SEARCH_EVENT), {
        detail: {
            query: trimmedQuery
        }
    }));
};
const $fc721b325f003ef7$var$SuggestionsPanel = ({ suggestions: suggestions, activeIndex: activeIndex, query: query, setActiveIndex: setActiveIndex, onSelect: onSelect, onAllResults: onAllResults, allResultsLabel: allResultsLabel })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "templates-search-suggestions",
        className: (0, $2jatx.default)([
            "_kqswstnw _1pbyqfx8 _152t8vuz _1e02idpf _1bsb1osq _bfhk1afi _syaz1pfd _2rkogktf _ca0q1ou6 _u5f31f4h _n3tdqslr _19bv1f4h _y3gn1e5h _19ithueu _16qs130s"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
            id: $fc721b325f003ef7$var$SUGGESTIONS_LISTBOX_ID,
            role: "listbox",
            "aria-label": allResultsLabel,
            className: (0, $2jatx.default)([
                "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _2lx21bp4 _zulpu2gc"
            ]),
            children: [
                suggestions.map((suggestion, index)=>{
                    const isActive = index === activeIndex;
                    const sharedCss = [
                        $fc721b325f003ef7$var$suggestionButtonStyle,
                        isActive ? $fc721b325f003ef7$var$activeSuggestionStyle : null
                    ];
                    const label = /*#__PURE__*/ (0, $7VQPk.jsx)($fc721b325f003ef7$var$HighlightedText, {
                        text: suggestion.label,
                        query: query
                    });
                    // role="presentation" <li> keeps valid <ul> markup while the
                    // option (link, or button for the typed-query row) stays a
                    // direct listbox child.
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        role: "presentation",
                        children: suggestion.href ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            id: $fc721b325f003ef7$var$buildSuggestionOptionId(index),
                            role: "option",
                            "aria-selected": isActive,
                            "aria-label": suggestion.label,
                            href: suggestion.href,
                            tabIndex: -1,
                            onMouseDown: (event)=>event.preventDefault(),
                            onMouseEnter: ()=>setActiveIndex(index),
                            onFocus: ()=>setActiveIndex(index),
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _19itidpf _bfhk1j28 _syaz1pfd _80omtlke _1e0c1ule _y3gn1e5h _1yt418iy _1tkezwfg _1wyb1j6v _vwz4bs82 _ect41kw7",
                                isActive && "_bfhkdkka"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                            },
                            children: label
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            id: $fc721b325f003ef7$var$buildSuggestionOptionId(index),
                            role: "option",
                            "aria-selected": isActive,
                            "aria-label": suggestion.label,
                            tabIndex: -1,
                            onMouseDown: (event)=>event.preventDefault(),
                            onMouseEnter: ()=>setActiveIndex(index),
                            onFocus: ()=>setActiveIndex(index),
                            onClick: ()=>onSelect(suggestion),
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _19itidpf _bfhk1j28 _syaz1pfd _80omtlke _1e0c1ule _y3gn1e5h _1yt418iy _1tkezwfg _1wyb1j6v _vwz4bs82 _ect41kw7",
                                isActive && "_bfhkdkka"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                            },
                            children: label
                        })
                    }, suggestion.id);
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    role: "presentation",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                        type: "button",
                        id: $fc721b325f003ef7$var$ALL_RESULTS_OPTION_ID,
                        role: "option",
                        "aria-selected": activeIndex === suggestions.length,
                        tabIndex: -1,
                        onMouseDown: (event)=>event.preventDefault(),
                        onMouseEnter: ()=>setActiveIndex(suggestions.length),
                        onFocus: ()=>setActiveIndex(suggestions.length),
                        onClick: onAllResults,
                        className: (0, $2jatx.default)([
                            "_19itidpf _bfhk1j28 _syaz13af _80omtlke _1e0c116y _4cvr1h6o _zulp1b66 _1pfhpxbi _1yt418iy _1wyb1j6v _k48pni7l _ect41kw7 _13ixdkka _irr3dkka _mizu1r31 _1dit1r31 _ra3xglyw _ksodglyw _128midpf _4hz8idpf",
                            activeIndex === suggestions.length && "_bfhkdkka"
                        ]),
                        style: {
                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                        },
                        children: [
                            allResultsLabel,
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53VCz))), {
                                label: "",
                                size: "small"
                            })
                        ]
                    })
                })
            ]
        })
    });
const $fc721b325f003ef7$var$HighlightedText = ({ text: text, query: query })=>{
    const trimmedQuery = query.trim();
    const index = text.toLowerCase().indexOf(trimmedQuery.toLowerCase());
    if (!trimmedQuery || index < 0) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: text
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            text.slice(0, index),
            /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: text.slice(index, index + trimmedQuery.length)
            }),
            text.slice(index + trimmedQuery.length)
        ]
    });
};
const $fc721b325f003ef7$var$sectionStyle = null;
const $fc721b325f003ef7$var$headingStyle = null;
const $fc721b325f003ef7$var$subheadingStyle = null;
const $fc721b325f003ef7$var$searchFormStyle = null;
const $fc721b325f003ef7$var$inputShellStyle = null;
const $fc721b325f003ef7$var$searchIconStyle = null;
const $fc721b325f003ef7$var$inputStyle = null;
const $fc721b325f003ef7$var$clearButtonStyle = null;
const $fc721b325f003ef7$var$suggestionsPanelStyle = null;
const $fc721b325f003ef7$var$suggestionsListStyle = null;
const $fc721b325f003ef7$var$suggestionButtonStyle = null;
const $fc721b325f003ef7$var$activeSuggestionStyle = null;
const $fc721b325f003ef7$var$allResultsButtonStyle = null;
var $fc721b325f003ef7$export$2e2bcd8739ae039 = $fc721b325f003ef7$var$TemplatesSearchBar;

});


parcelRegister("aQkGJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ace99c1f3a3aa172$export$2e2bcd8739ae039; });
/* terminal-typing.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $dZNgt = parcelRequire("dZNgt");

var $kbpa7 = parcelRequire("kbpa7");
const $ace99c1f3a3aa172$var$terminalGlowInKeyframes = null;
const $ace99c1f3a3aa172$var$terminalGlowInCss = null;
const $ace99c1f3a3aa172$var$outerCss = null;
// Block-level wrapper whose width is the space available to the terminal. The
// fit-to-width hook measures this element's `clientWidth` as the budget the
// scaled content must fit within, so it MUST reflect the real available width
// rather than shrink to its (nowrap) content. `width: 100%` makes it fill the
// containing block even inside shrink-to-fit parents (e.g. a centered grid/flex
// item, as on the hero), and `minWidth: 0` lets it shrink below content size in
// flex/grid tracks. `maxWidth: 100%` is a final guard against the box itself
// ever exceeding the container.
const $ace99c1f3a3aa172$var$fitBoxCss = null;
// Holds the measured (natural-size) content and collapses to the *scaled*
// dimensions so the inline-block terminal box above hugs the fitted content
// (a bare `transform: scale` would leave the pre-scale layout size reserved).
//
// Clip the horizontal axis only: the sizer is the absolutely-positioned
// scaler's containing block, so `overflow-x: clip` here is what actually
// contains the scaled `nowrap` content and the left/right glow puffs. The
// vertical axis stays `visible` so the decorative top/bottom glow — which is
// designed to poke past the terminal's edges — is NOT sheared off flat at the
// box edge. Overflow never affects layout, so the sizer still collapses to the
// scaled footprint.
const $ace99c1f3a3aa172$var$fitSizerCss = null;
// The element the fit scale is applied to. Scaling from the top-left keeps the
// content anchored to the terminal's origin. It stays in normal flow until the
// first measurement completes (so SSR / first paint reserve the real size);
// `fitScalerMeasuredCss` then lifts it out of flow so the sizer can collapse to
// the scaled footprint.
const $ace99c1f3a3aa172$var$fitScalerCss = null;
const $ace99c1f3a3aa172$var$fitScalerMeasuredCss = null;
const $ace99c1f3a3aa172$var$textStaticCss = null;
const $ace99c1f3a3aa172$var$rowCss = null;
const $ace99c1f3a3aa172$var$gridContainerCss = null;
const $ace99c1f3a3aa172$var$cursorBaseCss = null;
const $ace99c1f3a3aa172$var$cursorWrapperCss = null;
const $ace99c1f3a3aa172$var$bgLayerCss = null;
const $ace99c1f3a3aa172$var$segmentPuffCss = null;
const $ace99c1f3a3aa172$var$coloredSegmentWrapperCss = null;
// Both grid cells (ghost + visible) stack in the same single grid track.
const $ace99c1f3a3aa172$var$gridCellCss = null;
// The ghost cell only reserves space — it is never shown.
const $ace99c1f3a3aa172$var$ghostCellCss = null;
const $ace99c1f3a3aa172$var$cursorPuffCss = null;
const $ace99c1f3a3aa172$export$a01a3609ac119822 = {
    typeMs: 60,
    backspaceMs: 35,
    holdMs: 1500,
    pauseMs: 400,
    blinkMs: 500,
    fontSizePt: 36,
    boxWidthPx: null,
    paddingPx: 16,
    borderRadiusPx: 12
};
const $ace99c1f3a3aa172$var$PROMPT_COLOR = '#B1E4F7';
const $ace99c1f3a3aa172$var$WHITE = (0, $kbpa7.wacToken)('color.neutral.light0');
const $ace99c1f3a3aa172$export$dfcde2f400484b1d = {
    lime: (0, $kbpa7.wacToken)('color.extended.lime400'),
    // These three colors have no design-token equivalent;
    /* eslint-disable local/ensure-wac-token-usage */ cyan: '#7BD3EA',
    saffron: (0, $kbpa7.wacToken)('color.extended.saffron300'),
    coral: '#F87B6B',
    blue: '#1E88FF'
};
const $ace99c1f3a3aa172$var$DEFAULT_HIGHLIGHT_COLOR = $ace99c1f3a3aa172$export$dfcde2f400484b1d.lime;
/** Extract the `{ root }` node from either Uniform value shape. */ function $ace99c1f3a3aa172$var$getRichTextRoot(value) {
    if (!value || typeof value !== 'object') return undefined;
    const root = value.root;
    return root && typeof root === 'object' ? root : undefined;
}
/**
 * Walk a Uniform rich-text tree and collapse it into the terminal's
 * `[white, highlighted, white, ...]` segment shape. Any text node whose
 * format includes italic (`<em>`) becomes a highlighted segment painted in
 * `highlightColor`; everything else is white. Consecutive runs of the same
 * color are merged so the typing animation advances one visual word at a time.
 * The editor may place the italic word anywhere in the phrase.
 */ function $ace99c1f3a3aa172$var$richTextToSegments(root, highlightColor) {
    const segments = [];
    const pushText = (text, isItalic)=>{
        if (!text) return;
        const color = isItalic ? highlightColor : $ace99c1f3a3aa172$var$WHITE;
        const last = segments[segments.length - 1];
        if (last && last.color === color) last.text += text;
        else segments.push({
            text: text,
            color: color
        });
    };
    const walk = (node)=>{
        if ((0, $dZNgt.isRichTextNodeType)(node, 'text')) {
            const isItalic = (0, $dZNgt.getRichTextTagsFromTextFormat)(node.format).includes('em');
            pushText(node.text, isItalic);
            return;
        }
        node.children?.forEach(walk);
    };
    walk(root);
    return segments;
}
/**
 * Convert the editor-supplied phrases into the `Segment[][]` the typing
 * animation consumes. Empty phrases (no rich text, or rich text considered
 * empty by Uniform) are skipped so unused slots behave as if absent. Each
 * phrase is prefixed with the shared `>` prompt segment.
 */ function $ace99c1f3a3aa172$var$buildPhrases(phraseInputs) {
    const promptSegment = {
        text: '>',
        color: $ace99c1f3a3aa172$var$PROMPT_COLOR
    };
    const phrases = [];
    for (const input of phraseInputs){
        const root = $ace99c1f3a3aa172$var$getRichTextRoot(input.richText);
        if (!root || (0, $dZNgt.isRichTextValueConsideredEmpty)(input.richText)) continue;
        const highlightColor = input.highlightColor || $ace99c1f3a3aa172$var$DEFAULT_HIGHLIGHT_COLOR;
        const segments = $ace99c1f3a3aa172$var$richTextToSegments(root, highlightColor);
        if (segments.length === 0) continue;
        phrases.push([
            promptSegment,
            ...segments
        ]);
    }
    return phrases;
}
// Tablet/mobile sizing keeps the hero terminal readable on small screens.
// On desktop we fall back to the live `TerminalTypingSettings` (which the
// floating Typing controls panel can tune) — see the merge of `size` and
// `settings` below.
//
// These are the terminal's *natural* (unscaled) sizes per breakpoint. The
// terminal text is `white-space: nowrap` and never wraps, so on very narrow
// viewports the longest phrase can still be wider than the screen even at the
// smallest breakpoint's font size — which overflowed the page horizontally in
// every browser at ≤ 320px (no browser breaks a nowrap line). The component
// therefore *measures* the natural content width and the available width and
// applies a `transform: scale(fit)` so the terminal always shrinks to fit (see
// `useFitToWidth`). These per-breakpoint sizes stay as the readable targets for
// screens wide enough to show them at 1×.
const $ace99c1f3a3aa172$var$SIZE_BY_BREAKPOINT = {
    desktop: {
        fontSize: '40px',
        cursorWidth: 39,
        cursorHeight: 74,
        padding: 14,
        promptGap: 16,
        borderRadius: 12
    },
    tablet: {
        fontSize: '36px',
        cursorWidth: 21,
        cursorHeight: 39,
        padding: 12,
        promptGap: 12,
        borderRadius: 10
    },
    // Small screens (≥ 480px, < 768px).
    mobile: {
        fontSize: '32px',
        cursorWidth: 15,
        cursorHeight: 30,
        padding: 10,
        promptGap: 10,
        borderRadius: 8
    },
    // X-small screens (< 480px). This is the band that overflowed at ≤ 320px;
    // the fit-to-width scaling (see `useFitToWidth`) guarantees it fits there.
    xsmall: {
        fontSize: '26px',
        cursorWidth: 12,
        cursorHeight: 24,
        padding: 8,
        promptGap: 8,
        borderRadius: 6
    }
};
function $ace99c1f3a3aa172$var$getBreakpoint(width) {
    if (width >= 1024) return 'desktop';
    if (width >= 768) return 'tablet';
    if (width >= 480) return 'mobile';
    return 'xsmall';
}
function $ace99c1f3a3aa172$var$useBreakpoint() {
    const [bp, setBp] = (0, $1oC0p.useState)(()=>{
        if (typeof window === 'undefined') return 'desktop';
        return $ace99c1f3a3aa172$var$getBreakpoint(window.innerWidth);
    });
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const onResize = ()=>setBp($ace99c1f3a3aa172$var$getBreakpoint(window.innerWidth));
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    return bp;
}
// The terminal's baseline (un-shrunk) scale. The hero historically renders at
// 0.9×; fit-to-width only ever scales *down* from here on narrow viewports.
const $ace99c1f3a3aa172$var$FIT_SCALE_MAX = 0.9;
function $ace99c1f3a3aa172$var$useFitToWidth(contentRef, availableRef, deps, // Optional additional element whose natural width must also fit (e.g. the
// `topLine` heading, which is `nowrap` and can be WIDER than the terminal
// rows). The scale ratio is computed from the widest of {content, extra} so
// the whole box — heading included — always fits and is never clipped by the
// container's `overflow-x: clip`.
extraWidthRef, // Horizontal padding (px, one side) of the terminal box that wraps the
// `extraWidthRef` element. The extra element's `scrollWidth` is its content
// width WITHOUT the box padding, but the real footprint that must fit is
// `content + 2×padding`. Adding it here stops the padded box overflowing (and
// being clipped) by exactly the padding amount on each side.
extraWidthPadding = 0) {
    const [fit, setFit] = (0, $1oC0p.useState)({
        scale: $ace99c1f3a3aa172$var$FIT_SCALE_MAX,
        naturalWidth: null,
        naturalHeight: null
    });
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const content = contentRef.current;
        const available = availableRef.current;
        if (!content || !available) return;
        const measure = ()=>{
            // Natural, unscaled size of the longest phrase + cursor, widened to
            // include any `extraWidthRef` element (the heading) so a heading wider
            // than the terminal rows is still fully accounted for in the fit ratio.
            const extra = extraWidthRef?.current;
            // The extra (heading) width must include the wrapping box's horizontal
            // padding (both sides), since its `scrollWidth` is padding-exclusive but
            // the rendered footprint is `content + 2×padding`.
            const extraWidth = extra ? extra.scrollWidth + extraWidthPadding * 2 : 0;
            const naturalWidth = Math.max(content.scrollWidth, extraWidth);
            const naturalHeight = content.scrollHeight;
            // Width available to the terminal. The component can be dropped into
            // arbitrary containers (the hero's centered grid item, a narrow
            // column-layout cell, a plain block), and in each the real budget is a
            // different ancestor:
            //
            //  1. Shrink-to-fit ancestor (e.g. a centered grid/flex item on the
            //     hero): the wrapper sizes to its own `nowrap` content and reports a
            //     width that is already too wide, which would make the fit ratio ~1
            //     and skip the shrink.
            //  2. Constrained ancestor (e.g. a column-layout cell): some ancestor
            //     is narrower than the wrapper's reported content width and clips it.
            //
            // Walking a bounded set of ancestors and taking the SMALLEST positive
            // `clientWidth` is correct for both: it never exceeds the narrowest
            // containing block (so the box can't be clipped by a column cell), and
            // it ignores an over-wide shrink-to-fit wrapper. The walk is bounded to
            // a few levels so it stays cheap and never climbs out to the viewport.
            const MAX_ANCESTOR_WALK = 6;
            let availableWidth = available.clientWidth || Number.POSITIVE_INFINITY;
            let node = available.parentElement;
            for(let i = 0; node && i < MAX_ANCESTOR_WALK; i += 1){
                const w = node.clientWidth;
                if (w > 0) availableWidth = Math.min(availableWidth, w);
                node = node.parentElement;
            }
            if (naturalWidth <= 0 || !Number.isFinite(availableWidth) || availableWidth <= 0) return;
            // Cap at the baseline (never enlarge past it); shrink further when the
            // natural content is wider than the available space.
            const next = Math.min($ace99c1f3a3aa172$var$FIT_SCALE_MAX, availableWidth / naturalWidth);
            setFit((prev)=>// Avoid thrashing on sub-pixel jitter.
                Math.abs(prev.scale - next) > 0.005 || prev.naturalWidth !== naturalWidth || prev.naturalHeight !== naturalHeight ? {
                    scale: next,
                    naturalWidth: naturalWidth,
                    naturalHeight: naturalHeight
                } : prev);
        };
        // Measure synchronously once (deterministic first paint), then again on the
        // next frame (to catch fonts/async layout), and on every resize.
        measure();
        const raf = window.requestAnimationFrame(measure);
        const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(()=>window.requestAnimationFrame(measure)) : undefined;
        ro?.observe(available);
        ro?.observe(content);
        if (extraWidthRef?.current) ro?.observe(extraWidthRef.current);
        window.addEventListener('resize', measure);
        return ()=>{
            window.cancelAnimationFrame(raf);
            ro?.disconnect();
            window.removeEventListener('resize', measure);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return fit;
}
function $ace99c1f3a3aa172$var$phraseLength(segments) {
    return segments.reduce((n, s)=>n + s.text.length, 0);
}
function $ace99c1f3a3aa172$var$findLongestIndex(phrases) {
    let idx = 0;
    let max = -1;
    phrases.forEach((p, i)=>{
        const len = $ace99c1f3a3aa172$var$phraseLength(p);
        if (len > max) {
            max = len;
            idx = i;
        }
    });
    return idx;
}
// Number of characters in the prompt segment (`>`). Backspacing stops here
// so the prompt stays visible across phrase swaps and the cursor parks
// at the position of the first letter (after the prompt gap).
const $ace99c1f3a3aa172$var$PROMPT_LENGTH = 1;
function $ace99c1f3a3aa172$var$renderSegments(segments, charLimit, promptGap, paddingPx, visible) {
    const nodes = [];
    let remaining = charLimit;
    for(let i = 0; i < segments.length; i++){
        const seg = segments[i];
        // Add a viewport-scaled gap immediately after the prompt segment ('>')
        const isPrompt = i === 0;
        const style = {
            color: seg.color
        };
        if (isPrompt) style.marginRight = promptGap;
        if (remaining <= 0) {
            nodes.push(/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                style: style,
                children: ''
            }, i));
            continue;
        }
        const slice = seg.text.slice(0, remaining);
        const isColoured = seg.color !== $ace99c1f3a3aa172$var$WHITE;
        // For coloured segments we wrap the letters in a relative inline-block
        // and drop two blurred "puffs" of the segment's colour that sit just
        // outside the terminal — above and below — so they tint only the
        // slice of the surrounding blue halo that lines up with the coloured
        // word. The rest of the halo stays its original blue.
        // The hidden ghost render (used to lock the terminal's width) must
        // NOT paint puffs, otherwise they would show up at the longest
        // phrase's positions even before that phrase types in.
        if (isColoured && visible) {
            const c = seg.color;
            // Tall puff that extends from outside the terminal edge into the
            // terminal interior. The colored span's wrapper has no stacking
            // context, so the puff's `zIndex: -2` bubbles up to the outer
            // terminal stacking context where the opaque background layer
            // (`zIndex: -1`) covers the inside portion — leaving only the
            // sliver that pokes past the terminal edge visible against the
            // surrounding blue halo.
            const sliver = 6;
            const puffHeight = Math.max(36, paddingPx * 2.6);
            const edgeOffset = -(paddingPx + sliver);
            // Runtime-only puff values (the rest live in segmentPuffCss).
            const sharedPuff = {
                height: puffHeight,
                background: `radial-gradient(50% 100% at 50% 50%, ${c}E6 0%, ${c}80 35%, ${c}33 65%, transparent 85%)`
            };
            nodes.push(/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                style: style,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c1o8l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        "aria-hidden": true,
                        style: {
                            ...sharedPuff,
                            top: edgeOffset
                        },
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1e021xgq _rjxp1xgq _kdamkfah _lcxvglyw _1pby1m4m"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        "aria-hidden": true,
                        style: {
                            ...sharedPuff,
                            bottom: edgeOffset
                        },
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1e021xgq _rjxp1xgq _kdamkfah _lcxvglyw _1pby1m4m"
                        ])
                    }),
                    slice
                ]
            }, i));
        } else nodes.push(/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            style: style,
            children: slice
        }, i));
        remaining -= slice.length;
    }
    return nodes;
}
function $ace99c1f3a3aa172$var$usePrefersReducedMotion() {
    const [reduced, setReduced] = (0, $1oC0p.useState)(()=>{
        if (typeof window === 'undefined' || !window.matchMedia) return false;
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    });
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window === 'undefined' || !window.matchMedia) return;
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        const handler = ()=>setReduced(mq.matches);
        mq.addEventListener?.('change', handler);
        return ()=>mq.removeEventListener?.('change', handler);
    }, []);
    return reduced;
}
const $ace99c1f3a3aa172$var$CURSOR_PUFF_GRADIENT = `radial-gradient(50% 100% at 50% 50%, #FFFFFFCC 0%, #FFFFFF66 35%, #FFFFFF22 65%, transparent 85%)`;
// The blinking cursor plus its top/bottom white halo "puffs" that poke past
// the terminal edge. Extracted to keep the main component's complexity down.
const $ace99c1f3a3aa172$var$TerminalCursor = ({ cursorStyle: cursorStyle, padding: padding, showCursor: showCursor })=>{
    const sliver = 6;
    const puffHeight = Math.max(36, padding * 2.6);
    const edgeOffset = -(padding + sliver);
    const puffStyle = {
        height: puffHeight,
        background: $ace99c1f3a3aa172$var$CURSOR_PUFF_GRADIENT,
        opacity: showCursor ? 0.5 : 0
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c116y _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": true,
                style: {
                    ...puffStyle,
                    top: edgeOffset
                },
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e021a77 _rjxp1a77 _kdamkfah _lcxvglyw _1pby1m4m _v564glyw"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": true,
                style: {
                    ...puffStyle,
                    bottom: edgeOffset
                },
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e021a77 _rjxp1a77 _kdamkfah _lcxvglyw _1pby1m4m _v564glyw"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                style: cursorStyle,
                className: (0, $2jatx.default)([
                    "_1e0c1o8l _ahbq161r _2rko1y44 _v564glyw _16jlidpf _1o9zidpf _i0dl1wug"
                ])
            })
        ]
    });
};
/**
 * Resolve the terminal's pixel sizing for the current breakpoint. On desktop the
 * appearance is driven by `settings` (so the Typing controls panel can tune it
 * live); on tablet/mobile it falls back to the breakpoint-tuned `size` so the
 * hero terminal stays readable on small screens. Cursor dimensions scale with
 * font size on desktop (height = 1.6×, width = 0.84×) to keep proportion across
 * the full size range. Extracted from the component to keep its complexity down.
 */ function $ace99c1f3a3aa172$var$resolveSizing(settings, breakpoint) {
    const size = $ace99c1f3a3aa172$var$SIZE_BY_BREAKPOINT[breakpoint];
    if (breakpoint !== 'desktop') return {
        cursorWidth: size.cursorWidth,
        cursorHeight: size.cursorHeight,
        fontSize: size.fontSize,
        padding: size.padding,
        borderRadius: size.borderRadius,
        promptGap: size.promptGap
    };
    return {
        cursorWidth: settings.fontSizePt * 0.84,
        cursorHeight: settings.fontSizePt * 1.6,
        fontSize: `${settings.fontSizePt}pt`,
        padding: settings.paddingPx,
        borderRadius: settings.borderRadiusPx,
        // Prompt gap is responsive across all breakpoints (not tunable).
        promptGap: size.promptGap
    };
}
const $ace99c1f3a3aa172$export$1d34efe4d74e14fe = 8;
const $ace99c1f3a3aa172$export$946aacf49505b3d2 = ({ settings: settings = $ace99c1f3a3aa172$export$a01a3609ac119822, paused: paused = false, topLine: topLine, phrases: phraseInputs })=>{
    const reducedMotion = $ace99c1f3a3aa172$var$usePrefersReducedMotion();
    const breakpoint = $ace99c1f3a3aa172$var$useBreakpoint();
    const isDesktop = breakpoint === 'desktop';
    const phrases = $ace99c1f3a3aa172$var$buildPhrases(phraseInputs ?? []);
    const longestIndex = $ace99c1f3a3aa172$var$findLongestIndex(phrases);
    const [phraseIndex, setPhraseIndex] = (0, $1oC0p.useState)(0);
    // Fit-to-width: measure the whole terminal box (`fitScalerRef`) against the
    // space available to the component (`fitBoxRef`) and shrink it to fit. This
    // is what keeps the `white-space: nowrap` terminal from overflowing the page
    // horizontally on very narrow viewports (≤ 320px) in every browser — a bare
    // font-size step can't guarantee a long phrase fits, but scaling by the exact
    // measured ratio always does. On wide-enough screens `scale` stays at the
    // `FIT_SCALE_MAX` baseline (0.9) — i.e. the historical appearance is unchanged.
    //
    // These hooks (refs + the measuring hook) must run unconditionally, before
    // the empty-phrases early return below, to satisfy the rules of hooks. Their
    // re-measure signal is derived from the longest phrase; when there are no
    // phrases it is a stable empty string, which is harmless.
    const fitBoxRef = (0, $1oC0p.useRef)(null);
    const fitScalerRef = (0, $1oC0p.useRef)(null);
    // Heading element — fed to `useFitToWidth` as an extra width to fit, because
    // the `nowrap` heading can be wider than the terminal rows (see the hook).
    const topLineRef = (0, $1oC0p.useRef)(null);
    const longestSignal = (phrases[longestIndex] ?? []).map((s)=>s.text).join('\u0000');
    // Resolve sizing once up here so the terminal box's horizontal padding can be
    // fed into the fit-to-width measurement (the heading's footprint = its content
    // width + the box padding on both sides). Reused for rendering below.
    const sizing = $ace99c1f3a3aa172$var$resolveSizing(settings, breakpoint);
    const { scale: scale, naturalWidth: naturalWidth, naturalHeight: naturalHeight } = $ace99c1f3a3aa172$var$useFitToWidth(fitScalerRef, fitBoxRef, [
        breakpoint,
        // Re-measure when sizing-affecting inputs change. Font size and padding
        // derive deterministically from the breakpoint + settings, so keying on
        // those plus the breakpoint and the longest-phrase text covers all cases.
        settings.fontSizePt,
        settings.paddingPx,
        longestSignal,
        // The heading text affects its measured width, so re-measure on change.
        topLine,
        // The box padding affects the heading's required footprint.
        sizing.padding
    ], topLineRef, sizing.padding);
    // Start at PROMPT_LENGTH so the leading `>` is visible from first paint
    // and never gets typed/erased during the loop.
    const [charCount, setCharCount] = (0, $1oC0p.useState)($ace99c1f3a3aa172$var$PROMPT_LENGTH);
    const [phase, setPhase] = (0, $1oC0p.useState)('typing');
    const [cursorVisible, setCursorVisible] = (0, $1oC0p.useState)(true);
    // `phrases` can be empty if every slot was left blank. Default to an empty
    // segment list so the typing effects below never read `undefined`; the
    // component early-returns `null` (after all hooks) when there are none.
    const currentSegments = phrases[phraseIndex] ?? [];
    const currentTotal = $ace99c1f3a3aa172$var$phraseLength(currentSegments);
    // Per spec: cursor blinks only after a phrase is fully typed, until
    // backspacing begins. While typing, backspacing, or in the pause
    // between phrases, the cursor stays solid.
    const idle = phase === 'typing' && charCount >= currentTotal;
    // Drive typing / backspacing
    (0, $1oC0p.useEffect)(()=>{
        if (reducedMotion) return;
        let id;
        if (phase === 'typing') {
            if (charCount < currentTotal) // Always let an in-progress phrase finish typing — even while paused —
            // so the visible word lands on a complete state.
            id = setTimeout(()=>setCharCount((c)=>c + 1), settings.typeMs);
            else if (!paused) // Fully typed: hold, then start backspacing. While paused, hold here
            // indefinitely (no schedule) until `paused` flips back to false.
            id = setTimeout(()=>setPhase('backspacing'), settings.holdMs);
        } else if (charCount > $ace99c1f3a3aa172$var$PROMPT_LENGTH) // Backspacing is also part of "the current message finishing", so we
        // let it complete even while paused.
        id = setTimeout(()=>setCharCount((c)=>c - 1), settings.backspaceMs);
        else // Erased back to the prompt: always advance to the next phrase, even
        // while paused. This way, if pause arrived mid-backspace, we still
        // settle on a fully-typed phrase (the next one) rather than holding
        // on the bare prompt. The hold itself happens in the `phase==='typing'
        // && fully typed` branch above.
        id = setTimeout(()=>{
            setPhraseIndex((i)=>(i + 1) % phrases.length);
            setPhase('typing');
        }, settings.pauseMs);
        return ()=>{
            if (id) clearTimeout(id);
        };
    }, [
        phase,
        charCount,
        currentTotal,
        reducedMotion,
        paused,
        settings.typeMs,
        settings.backspaceMs,
        settings.holdMs,
        settings.pauseMs
    ]);
    // Cursor blink — only while idle (fully typed or fully erased)
    (0, $1oC0p.useEffect)(()=>{
        if (reducedMotion) {
            setCursorVisible(true);
            return;
        }
        if (!idle) {
            setCursorVisible(true);
            return;
        }
        const id = setInterval(()=>setCursorVisible((v)=>!v), settings.blinkMs);
        return ()=>clearInterval(id);
    }, [
        idle,
        reducedMotion,
        settings.blinkMs
    ]);
    // Nothing to type if every phrase slot was left empty. All hooks above have
    // already run, so this early return keeps the rules of hooks intact.
    if (phrases.length === 0) return null;
    // Reduced motion: render static phrase 1 with non-blinking cursor
    const displaySegments = reducedMotion ? phrases[0] : currentSegments;
    const displayCount = reducedMotion ? $ace99c1f3a3aa172$var$phraseLength(phrases[0]) : charCount;
    const showCursor = reducedMotion ? true : cursorVisible;
    const longestSegments = phrases[longestIndex];
    const longestCount = $ace99c1f3a3aa172$var$phraseLength(longestSegments);
    // Responsive pixel sizing for this breakpoint, resolved once above (see
    // `resolveSizing` for the desktop-vs-small-screen behavior).
    const { cursorWidth: cursorWidth, cursorHeight: cursorHeight, fontSize: fontSize, padding: padding, borderRadius: borderRadius, promptGap: promptGap } = sizing;
    // Cursor fills the terminal's content area. The cursor's explicit
    // pixel height drives the terminal's interior height; combined with
    // the box's padding, this leaves padding-px of dark space above and
    // below the cursor. The text is centered alongside it via the
    // inline-flex row.
    // Runtime-only cursor values (static ones live in cursorBaseCss).
    const cursorStyle = {
        width: cursorWidth,
        height: cursorHeight,
        backgroundColor: $ace99c1f3a3aa172$var$WHITE,
        opacity: showCursor ? 1 : 0
    };
    // Runtime-only text values (static ones live in textStaticCss).
    const textStyle = {
        fontFamily: "'Atlassian Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace",
        fontSize: fontSize,
        color: $ace99c1f3a3aa172$var$WHITE
    };
    // Explicit box width is desktop-only — on tablet/mobile we always let
    // the ghost measure the natural width so the box scales naturally with
    // the responsive font size.
    const explicitWidth = isDesktop && typeof settings.boxWidthPx === 'number';
    // Runtime-only outer values (static ones live in outerCss). The transform
    // in outerCss creates the stacking context the colored puffs land in.
    const outerStyle = {
        borderRadius: borderRadius,
        padding: padding
    };
    if (explicitWidth) outerStyle.minWidth = settings.boxWidthPx;
    // Derived fit values (not hooks — safe after the early return). The hooks
    // that produce `scale`/`naturalWidth`/`naturalHeight` run unconditionally
    // near the top of the component.
    const measured = naturalWidth !== null && naturalHeight !== null;
    // Collapse the sizer to the scaled footprint so the surrounding layout
    // reserves only the fitted size (transforms alone don't affect layout size).
    const sizerStyle = measured ? {
        width: naturalWidth * scale,
        height: naturalHeight * scale
    } : {};
    const scalerStyle = {
        transform: `scale(${scale})`
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: fitBoxRef,
        className: (0, $2jatx.default)([
            "_1e0c1ule _1bsb1osq _1ul9idpf _p12f1osq _1reozryt"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            style: sizerStyle,
            className: (0, $2jatx.default)([
                "_kqswh2mm _1reozryt _18m9ewfl"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: fitScalerRef,
                style: scalerStyle,
                className: (0, $2jatx.default)([
                    "_8hrz5d63",
                    measured && "_kqswstnw _152tidpf _1e02idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    style: outerStyle,
                    className: (0, $2jatx.default)([
                        "_y44v14qp",
                        "_1e0c1o8l _vchhusvi _t9ec1aqe _8hrz5d63 _kqswh2mm _p12f1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            "aria-hidden": true,
                            className: (0, $2jatx.default)([
                                "_kqswstnw _1r04idpf _1pby1mrw _lcxvglyw _bfhk1pfd"
                            ]),
                            style: {
                                borderRadius: borderRadius,
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            }
                        }),
                        topLine ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            ref: topLineRef,
                            style: {
                                ...textStyle,
                                marginBottom: promptGap
                            },
                            className: (0, $2jatx.default)([
                                "_vwz4kb7n _k48pbfng _1dyzso38 _o5721q9c"
                            ]),
                            children: topLine
                        }) : null,
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            "aria-hidden": true,
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _yv0ehkll _2z05hkll"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    style: textStyle,
                                    className: (0, $2jatx.default)([
                                        "_vwz4kb7n _k48pbfng _1dyzso38 _o5721q9c",
                                        "_1e0c116y _4cvr1h6o",
                                        "_yyhykb7n _1ii7kb7n",
                                        "_3um015vq"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            children: $ace99c1f3a3aa172$var$renderSegments(longestSegments, longestCount, promptGap, padding, false)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            style: {
                                                ...cursorStyle,
                                                opacity: 1
                                            },
                                            className: (0, $2jatx.default)([
                                                "_1e0c1o8l _ahbq161r _2rko1y44 _v564glyw _16jlidpf _1o9zidpf _i0dl1wug"
                                            ])
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    style: textStyle,
                                    className: (0, $2jatx.default)([
                                        "_vwz4kb7n _k48pbfng _1dyzso38 _o5721q9c",
                                        "_1e0c116y _4cvr1h6o",
                                        "_yyhykb7n _1ii7kb7n"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            children: $ace99c1f3a3aa172$var$renderSegments(displaySegments, displayCount, promptGap, padding, true)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($ace99c1f3a3aa172$var$TerminalCursor, {
                                            cursorStyle: cursorStyle,
                                            padding: padding,
                                            showCursor: showCursor
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/**
 * Uniform entry point. Collapses the flat `phraseN` / `phraseNColor` params
 * into the ordered `PhraseInput[]` the animation consumes, then renders the
 * core {@link UniformTerminalTyping} component.
 */ const $ace99c1f3a3aa172$var$UniformTerminalTypingComponent = (props)=>{
    const phrases = [];
    for(let i = 1; i <= $ace99c1f3a3aa172$export$1d34efe4d74e14fe; i++){
        const richText = props[`phrase${i}`];
        const highlightColor = props[`phrase${i}Color`];
        phrases.push({
            richText: richText,
            highlightColor: highlightColor
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)($ace99c1f3a3aa172$export$946aacf49505b3d2, {
        topLine: props.topLine,
        phrases: phrases
    });
};
var $ace99c1f3a3aa172$export$2e2bcd8739ae039 = $ace99c1f3a3aa172$var$UniformTerminalTypingComponent;

});

parcelRegister("11uBo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd0ee32942954c5a$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $dZNgt = parcelRequire("dZNgt");

var $lTkkF = parcelRequire("lTkkF");

var $jsxHL = parcelRequire("jsxHL");
const $fd0ee32942954c5a$export$bd5da47596094494 = ({ text: text, richText: richText, uniformRichText: uniformRichText, style: style = 'body-lg', alignment: alignment = 'left', tagType: tagType })=>{
    const hasRichText = Boolean(richText) || !(0, $dZNgt.isRichTextValueConsideredEmpty)(uniformRichText);
    // defaults to p when no tagType is provided
    // Use div instead of p when rich text is present to avoid nested <p> tags
    const Component = hasRichText && (!tagType || tagType === 'p') ? 'div' : tagType || 'p';
    const alignmentStyle = null;
    const boldStyling = null;
    const resetMargin = null;
    const colorStyle = null;
    // When rich text is rendered, its paragraphs need to inherit typography from
    // the style class on the wrapper instead of the global paragraph defaults.
    const richTextInheritCss = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)(Component, {
            className: (0, $2jatx.default)([
                style?.includes('bold') && "_3dt51fw0",
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                "_y3gnoues",
                hasRichText && "_q7gq1kw7 _zcqx1kw7 _ecfq1kw7 _1csa1kw7",
                "_syazl3em",
                style
            ]),
            style: {
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
            },
            children: richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                text: richText
            }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                uniformParameter: "uniformRichText"
            }) : text
        })
    });
};
var $fd0ee32942954c5a$export$2e2bcd8739ae039 = $fd0ee32942954c5a$export$bd5da47596094494;

});

parcelRegister("hnLdc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $961aae6f61765b8c$export$2e2bcd8739ae039; });
/* text-with-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jsxHL = parcelRequire("jsxHL");

var $11uBo = parcelRequire("11uBo");

var $2ggtO = parcelRequire("2ggtO");
const $961aae6f61765b8c$export$69f8fbc89c62ee2a = 'body-md';
const $961aae6f61765b8c$export$8cea64591eaafc6 = (props)=>{
    const { text: text, style: style = $961aae6f61765b8c$export$69f8fbc89c62ee2a, icon: icon } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "data-testid": "TextWithIcon-icon",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ggtO.Icon), {
                        name: icon,
                        size: style === 'body-sm' ? 'small' : 'medium'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        style === 'body-sm' && "_1pfht94y",
                        style === 'body-md' && "_1pfh1l7b"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $11uBo.default), {
                        text: text,
                        style: style
                    })
                })
            ]
        })
    });
};
const $961aae6f61765b8c$var$wrapperCss = null;
const $961aae6f61765b8c$var$smTextCss = null;
const $961aae6f61765b8c$var$mdTextCss = null;
var $961aae6f61765b8c$export$2e2bcd8739ae039 = $961aae6f61765b8c$export$8cea64591eaafc6;

});
parcelRegister("2ggtO", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $74139676dd5cc642$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $f3oWf = parcelRequire("f3oWf");
const $74139676dd5cc642$export$f04a61298a47a40f = (props)=>{
    const { name: name, size: size } = props;
    if (!name) return /*#__PURE__*/ (0, $7VQPk.jsx)($74139676dd5cc642$var$GlyphIcon, {
        size: size,
        name: "TaskInProgressIcon"
    });
    const mapping = (0, $f3oWf.iconMapping)[name];
    if (mapping?.version === 'glyph') return /*#__PURE__*/ (0, $7VQPk.jsx)($74139676dd5cc642$var$GlyphIcon, {
        ...props
    });
    else if (mapping?.version === 'core') return /*#__PURE__*/ (0, $7VQPk.jsx)($74139676dd5cc642$var$CoreIcon, {
        ...props
    });
    else {
        console.log('error with icon name:', name);
        return /*#__PURE__*/ (0, $7VQPk.jsx)($74139676dd5cc642$var$GlyphIcon, {
            size: size,
            name: "TaskInProgressIcon"
        });
    }
};
const $74139676dd5cc642$var$iconWrapperSmallCss = null;
const $74139676dd5cc642$var$iconWrapperMediumCss = null;
const $74139676dd5cc642$var$CoreIcon = (props)=>{
    const { name: name, size: size } = props;
    const BaseIcon = (0, $f3oWf.iconMapping)[name]?.component;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            size === 'small' && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === 'medium' && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)(BaseIcon, {
            icon: name
        })
    });
};
const $74139676dd5cc642$var$GlyphIcon = (props)=>{
    const { name: name, size: size } = props;
    const BaseGlyphIcon = (0, $f3oWf.iconMapping)[name]?.component;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            size === 'small' && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === 'small' && "_17521o4j",
            size === 'medium' && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === 'medium' && "_1q511lya _17521txs"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)(BaseGlyphIcon, {
            icon: name,
            size: size
        })
    });
};
const $74139676dd5cc642$var$glyphIconWrapperSmallCss = null;
const $74139676dd5cc642$var$glyphIconWrapperMediumCss = null;

});


parcelRegister("9VQLz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b99260984a741dac$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $gLm0b = parcelRequire("gLm0b");

var $cSBgL = parcelRequire("cSBgL");

var $af53x = parcelRequire("af53x");
const $b99260984a741dac$var$OUTGROW_LOADER_URL = 'https://dyv6f9ner1ir9.cloudfront.net/assets/js/nloader.js';
const $b99260984a741dac$var$SUPPORT_FORM_PRODUCTION_HOST = 'https://support-form-app-ui.prod-east.frontend.public.atl-paas.net';
const $b99260984a741dac$var$SUPPORT_FORM_STAGING_HOST = 'https://support-form-app-ui.stg-east.frontend.public.atl-paas.net';
const $b99260984a741dac$var$SUPPORT_FORM_MANIFEST_PATH = '/assets/asset-manifest.json';
const $b99260984a741dac$var$SUPPORT_FORM_APP_TARGET_ID = 'support-form-app';
const $b99260984a741dac$var$SUPPORT_FORM_SCOPE_SELECTOR = '[data-third-party-embed-scope="supportForm"]';
const $b99260984a741dac$var$ECOSYSTEMS_IFRAME_ORIGIN = 'https://atlassian.wvc-test.ecosystems.io';
const $b99260984a741dac$var$ECOSYSTEMS_IFRAME_ID = 'webapp-frame';
const $b99260984a741dac$var$MAX_IFRAME_HEIGHT_PX = 100000;
const $b99260984a741dac$var$SCRIPT_LOAD_TIMEOUT_MS = 15000;
const $b99260984a741dac$var$loadingScripts = new Map();
const $b99260984a741dac$var$findScript = (url)=>Array.from(document.scripts).find((script)=>script.src === url);
const $b99260984a741dac$var$loadScript = (url, isReady)=>{
    if (isReady()) return Promise.resolve();
    const cachedScript = $b99260984a741dac$var$loadingScripts.get(url);
    if (cachedScript?.script.isConnected) return cachedScript.promise;
    $b99260984a741dac$var$loadingScripts.delete(url);
    $b99260984a741dac$var$findScript(url)?.remove();
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.defer = true;
    script.dataset['thirdPartyEmbedScript'] = 'true';
    const promise = new Promise((resolve, reject)=>{
        const cleanupListeners = ()=>{
            clearTimeout(timeoutId);
            script.removeEventListener('load', handleLoad);
            script.removeEventListener('error', handleError);
        };
        const handleLoad = ()=>{
            cleanupListeners();
            if (isReady()) resolve();
            else reject(new Error('Provider global was unavailable after script load'));
        };
        const handleError = ()=>{
            cleanupListeners();
            reject(new Error('Provider script failed to load'));
        };
        const timeoutId = window.setTimeout(()=>{
            cleanupListeners();
            reject(new Error('Provider script load timed out'));
        }, $b99260984a741dac$var$SCRIPT_LOAD_TIMEOUT_MS);
        script.addEventListener('load', handleLoad);
        script.addEventListener('error', handleError);
    });
    const loadingScript = {
        promise: promise,
        script: script
    };
    $b99260984a741dac$var$loadingScripts.set(url, loadingScript);
    promise.then(()=>{
        if ($b99260984a741dac$var$loadingScripts.get(url) === loadingScript) $b99260984a741dac$var$loadingScripts.delete(url);
    }, ()=>{
        if ($b99260984a741dac$var$loadingScripts.get(url) === loadingScript) $b99260984a741dac$var$loadingScripts.delete(url);
        script.remove();
    });
    document.head.appendChild(script);
    return promise;
};
const $b99260984a741dac$var$logFailure = (provider, phase)=>{
    console.error(`[thirdPartyEmbed] ${provider} ${phase} failed`);
};
const $b99260984a741dac$var$getSupportFormHost = ()=>window.location.hostname === 'www.atlassian.com' ? $b99260984a741dac$var$SUPPORT_FORM_PRODUCTION_HOST : $b99260984a741dac$var$SUPPORT_FORM_STAGING_HOST;
const $b99260984a741dac$var$getApprovedSupportAssetUrl = (value, host, extension)=>{
    if (typeof value !== 'string') throw new Error('Support-form manifest asset is missing');
    const url = new URL(value);
    const approvedHost = new URL(host);
    if (url.origin !== approvedHost.origin || url.username !== '' || url.password !== '' || !url.pathname.startsWith('/assets/') || !url.pathname.endsWith(extension)) throw new Error('Support-form manifest asset is not approved');
    return url.href;
};
const $b99260984a741dac$var$loadSupportFormAssets = async (host, scriptKey, stylesheetKey, signal)=>{
    const response = await fetch(`${host}${$b99260984a741dac$var$SUPPORT_FORM_MANIFEST_PATH}`, {
        credentials: 'include',
        signal: signal
    });
    if (!response.ok) throw new Error('Support-form manifest failed to load');
    const manifest = await response.json();
    if (typeof manifest !== 'object' || manifest === null || Array.isArray(manifest)) throw new Error('Support-form manifest is invalid');
    const entries = manifest;
    return {
        scriptUrl: $b99260984a741dac$var$getApprovedSupportAssetUrl(entries[scriptKey], host, '.js'),
        stylesheetUrl: $b99260984a741dac$var$getApprovedSupportAssetUrl(entries[stylesheetKey], host, '.css')
    };
};
const $b99260984a741dac$var$waitForElementLoad = (element, signal)=>new Promise((resolve, reject)=>{
        if (signal.aborted) {
            reject(new Error('Support-form initialization was cancelled'));
            return;
        }
        const cleanup = ()=>{
            clearTimeout(timeoutId);
            element.removeEventListener('load', handleLoad);
            element.removeEventListener('error', handleError);
            signal.removeEventListener('abort', handleAbort);
        };
        const handleLoad = ()=>{
            cleanup();
            resolve();
        };
        const handleError = ()=>{
            cleanup();
            reject(new Error('Support-form asset failed to load'));
        };
        const handleAbort = ()=>{
            cleanup();
            reject(new Error('Support-form initialization was cancelled'));
        };
        const timeoutId = window.setTimeout(()=>{
            cleanup();
            reject(new Error('Support-form asset load timed out'));
        }, $b99260984a741dac$var$SCRIPT_LOAD_TIMEOUT_MS);
        element.addEventListener('load', handleLoad);
        element.addEventListener('error', handleError);
        signal.addEventListener('abort', handleAbort, {
            once: true
        });
    });
const $b99260984a741dac$var$waitForSupportFormRender = (target, signal)=>new Promise((resolve, reject)=>{
        if (signal.aborted) {
            reject(new Error('Support-form initialization was cancelled'));
            return;
        }
        if (target.childElementCount > 0) {
            resolve();
            return;
        }
        const cleanup = ()=>{
            clearTimeout(timeoutId);
            observer.disconnect();
            signal.removeEventListener('abort', handleAbort);
        };
        const handleAbort = ()=>{
            cleanup();
            reject(new Error('Support-form initialization was cancelled'));
        };
        const observer = new MutationObserver(()=>{
            if (target.childElementCount === 0) return;
            cleanup();
            resolve();
        });
        const timeoutId = window.setTimeout(()=>{
            cleanup();
            reject(new Error('Support form did not render'));
        }, $b99260984a741dac$var$SCRIPT_LOAD_TIMEOUT_MS);
        observer.observe(target, {
            childList: true
        });
        signal.addEventListener('abort', handleAbort, {
            once: true
        });
    });
const $b99260984a741dac$var$splitSelectorList = (selectorList)=>{
    const selectors = [];
    let bracketDepth = 0;
    let parenthesisDepth = 0;
    let start = 0;
    for(let index = 0; index < selectorList.length; index += 1){
        const character = selectorList[index];
        if (character === '[') bracketDepth += 1;
        else if (character === ']') bracketDepth -= 1;
        else if (character === '(') parenthesisDepth += 1;
        else if (character === ')') parenthesisDepth -= 1;
        else if (character === ',' && bracketDepth === 0 && parenthesisDepth === 0) {
            selectors.push(selectorList.slice(start, index).trim());
            start = index + 1;
        }
    }
    selectors.push(selectorList.slice(start).trim());
    return selectors;
};
const $b99260984a741dac$var$scopeSupportFormRules = (rules, isInsideKeyframes = false)=>{
    for (const rule of Array.from(rules)){
        if (rule instanceof CSSKeyframesRule) {
            $b99260984a741dac$var$scopeSupportFormRules(rule.cssRules, true);
            continue;
        }
        if (rule instanceof CSSStyleRule && !isInsideKeyframes) {
            rule.selectorText = $b99260984a741dac$var$splitSelectorList(rule.selectorText).map((selector)=>`:where(${$b99260984a741dac$var$SUPPORT_FORM_SCOPE_SELECTOR}) ${selector}`).join(', ');
            continue;
        }
        if ('cssRules' in rule && rule.cssRules instanceof CSSRuleList) $b99260984a741dac$var$scopeSupportFormRules(rule.cssRules, isInsideKeyframes);
    }
};
const $b99260984a741dac$var$loadScopedSupportFormStylesheet = async (stylesheetUrl, signal)=>{
    // Magnolia loads this URL through a stylesheet link. Its cached response can
    // lack CORS headers (and Vary: Origin), so fetch a fresh CORS response before
    // reading the CSS for scoping.
    const response = await fetch(stylesheetUrl, {
        credentials: 'include',
        cache: 'reload',
        signal: signal
    });
    if (!response.ok) throw new Error('Support-form stylesheet failed to load');
    const stylesheet = new CSSStyleSheet();
    stylesheet.replaceSync(await response.text());
    $b99260984a741dac$var$scopeSupportFormRules(stylesheet.cssRules);
    return stylesheet;
};
const $b99260984a741dac$var$keepSupportFormHeightInSync = (appTarget)=>{
    let minimumHeight = 0;
    const updateMinimumHeight = ()=>{
        const contentHeight = Math.ceil(appTarget.scrollHeight);
        if (contentHeight <= minimumHeight) return;
        minimumHeight = contentHeight;
        appTarget.style.minHeight = `${minimumHeight}px`;
    };
    const mutationObserver = new MutationObserver(updateMinimumHeight);
    mutationObserver.observe(appTarget, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
    });
    const resizeObserver = typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(updateMinimumHeight);
    resizeObserver?.observe(appTarget);
    window.addEventListener('resize', updateMinimumHeight);
    updateMinimumHeight();
    return ()=>{
        mutationObserver.disconnect();
        resizeObserver?.disconnect();
        window.removeEventListener('resize', updateMinimumHeight);
        appTarget.style.removeProperty('min-height');
    };
};
const $b99260984a741dac$var$prepareSupportFormAssets = async (scriptKey, stylesheetKey, signal)=>{
    const load = async (host)=>{
        const assets = await $b99260984a741dac$var$loadSupportFormAssets(host, scriptKey, stylesheetKey, signal);
        const stylesheet = await $b99260984a741dac$var$loadScopedSupportFormStylesheet(assets.stylesheetUrl, signal);
        return {
            assets: assets,
            stylesheet: stylesheet
        };
    };
    const host = $b99260984a741dac$var$getSupportFormHost();
    try {
        return await load(host);
    } catch (error) {
        if (signal.aborted || host === $b99260984a741dac$var$SUPPORT_FORM_PRODUCTION_HOST) throw error;
        // Retry before executing any app JavaScript so environments are never mixed.
        return load($b99260984a741dac$var$SUPPORT_FORM_PRODUCTION_HOST);
    }
};
const $b99260984a741dac$var$initializeSupportForm = async (host, scriptKey, stylesheetKey, signal)=>{
    if (document.querySelectorAll('[data-third-party-embed-provider="supportForm"]').length !== 1) throw new Error('Support form must be unique');
    host.replaceChildren();
    const appTarget = document.createElement('div');
    appTarget.id = $b99260984a741dac$var$SUPPORT_FORM_APP_TARGET_ID;
    host.appendChild(appTarget);
    const { assets: assets, stylesheet: stylesheet } = await $b99260984a741dac$var$prepareSupportFormAssets(scriptKey, stylesheetKey, signal);
    if (signal.aborted) throw new Error('Support-form initialization was cancelled');
    const script = document.createElement('script');
    script.src = assets.scriptUrl;
    script.async = true;
    script.dataset['thirdPartyEmbedScript'] = 'true';
    document.adoptedStyleSheets = [
        ...document.adoptedStyleSheets,
        stylesheet
    ];
    const scriptLoaded = $b99260984a741dac$var$waitForElementLoad(script, signal);
    const formRendered = $b99260984a741dac$var$waitForSupportFormRender(appTarget, signal);
    document.head.appendChild(script);
    try {
        await Promise.all([
            scriptLoaded,
            formRendered
        ]);
        if (signal.aborted) throw new Error('Support-form initialization was cancelled');
        const cleanupHeightSynchronization = $b99260984a741dac$var$keepSupportFormHeightInSync(appTarget);
        return ()=>{
            cleanupHeightSynchronization();
            document.adoptedStyleSheets = document.adoptedStyleSheets.filter((adoptedStylesheet)=>adoptedStylesheet !== stylesheet);
        };
    } catch (error) {
        document.adoptedStyleSheets = document.adoptedStyleSheets.filter((adoptedStylesheet)=>adoptedStylesheet !== stylesheet);
        throw error;
    }
};
const $b99260984a741dac$var$getEmbedKey = (embed)=>{
    if (embed.provider === 'cstStaticForm') return `${embed.provider}:${embed.formName}:${embed.height}`;
    if (embed.provider === 'outgrow') return `${embed.provider}:${embed.embedId}:${embed.embedUrl}:${embed.title}`;
    if (embed.provider === 'supportForm') return `${embed.provider}:${embed.scriptKey}:${embed.stylesheetKey}`;
    return `${embed.provider}:${embed.embedUrl}`;
};
const $b99260984a741dac$var$initializeOutgrow = async (embed)=>{
    if (document.querySelectorAll(`[id="${embed.embedId}"]`).length !== 1) throw new Error('Outgrow embed ID must be unique');
    await $b99260984a741dac$var$loadScript($b99260984a741dac$var$OUTGROW_LOADER_URL, ()=>typeof window.initIframe === 'function');
    window.initIframe?.(embed.embedId);
};
const $b99260984a741dac$var$initializeEcosystemsIframe = (iframe)=>{
    if (document.querySelectorAll(`[id="${$b99260984a741dac$var$ECOSYSTEMS_IFRAME_ID}"]`).length !== 1) throw new Error('Ecosystems iframe ID must be unique');
    const handleResizeMessage = (event)=>{
        if (event.origin !== $b99260984a741dac$var$ECOSYSTEMS_IFRAME_ORIGIN || event.source !== iframe.contentWindow) return;
        if (typeof event.data !== 'object' || event.data === null) return;
        if (event.data.type !== 'resize-iframe') return;
        const height = event.data.height;
        if (typeof height !== 'number' || !Number.isFinite(height)) return;
        if (height <= 0 || height > $b99260984a741dac$var$MAX_IFRAME_HEIGHT_PX) return;
        iframe.style.height = `${height}px`;
    };
    window.addEventListener('message', handleResizeMessage);
    return ()=>window.removeEventListener('message', handleResizeMessage);
};
const $b99260984a741dac$export$904dfb4fab740e3d = ({ rawHtml: rawHtml })=>{
    const parsedEmbed = (0, $1oC0p.useMemo)(()=>(0, $af53x.parseThirdPartyEmbedHtml)(rawHtml), [
        rawHtml
    ]);
    const { analyticsOptOut: analyticsOptOut, isConsentLoaded: isConsentLoaded } = (0, $gLm0b.useOneTrustContext)();
    const mountRef = (0, $1oC0p.useRef)(null);
    const supportFormHostRef = (0, $1oC0p.useRef)(null);
    const iframeRef = (0, $1oC0p.useRef)(null);
    const embedKey = parsedEmbed ? $b99260984a741dac$var$getEmbedKey(parsedEmbed) : undefined;
    const [failure, setFailure] = (0, $1oC0p.useState)(null);
    const requiresPerformanceConsent = parsedEmbed?.provider === 'outgrow' || parsedEmbed?.provider === 'ecosystemsIframe';
    const hasConsent = !requiresPerformanceConsent || isConsentLoaded && !analyticsOptOut;
    const shouldRender = parsedEmbed !== null && hasConsent && failure?.embedKey !== embedKey;
    (0, $1oC0p.useEffect)(()=>{
        if (parsedEmbed !== null) return;
        $b99260984a741dac$var$logFailure('unknown', 'parse');
    }, [
        parsedEmbed
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldRender || !parsedEmbed) return;
        if (parsedEmbed.provider === 'cstStaticForm') return;
        if (parsedEmbed.provider === 'ecosystemsIframe') {
            if (!iframeRef.current) return;
            try {
                return $b99260984a741dac$var$initializeEcosystemsIframe(iframeRef.current);
            } catch  {
                $b99260984a741dac$var$logFailure(parsedEmbed.provider, 'initialize');
                setFailure({
                    embedKey: $b99260984a741dac$var$getEmbedKey(parsedEmbed)
                });
                return;
            }
        }
        if (parsedEmbed.provider === 'supportForm') {
            if (!supportFormHostRef.current) return;
            let active = true;
            const host = supportFormHostRef.current;
            const abortController = new AbortController();
            let cleanupSupportForm = ()=>{};
            $b99260984a741dac$var$initializeSupportForm(host, parsedEmbed.scriptKey, parsedEmbed.stylesheetKey, abortController.signal).then((cleanup)=>{
                if (active) cleanupSupportForm = cleanup;
                else cleanup();
            }, ()=>{
                if (!active) return;
                host.replaceChildren();
                $b99260984a741dac$var$logFailure(parsedEmbed.provider, 'initialize');
                setFailure({
                    embedKey: $b99260984a741dac$var$getEmbedKey(parsedEmbed)
                });
            });
            return ()=>{
                active = false;
                abortController.abort();
                cleanupSupportForm();
                document.querySelectorAll('script[data-third-party-embed-script="true"][src*="support-form-app-ui"]').forEach((script)=>script.remove());
                host.replaceChildren();
            };
        }
        if (!mountRef.current) return;
        let active = true;
        const initialize = $b99260984a741dac$var$initializeOutgrow(parsedEmbed);
        initialize.catch(()=>{
            if (!active) return;
            $b99260984a741dac$var$logFailure(parsedEmbed.provider, 'initialize');
            setFailure({
                embedKey: $b99260984a741dac$var$getEmbedKey(parsedEmbed)
            });
        });
        return ()=>{
            active = false;
            mountRef.current?.replaceChildren();
        };
    }, [
        parsedEmbed,
        shouldRender
    ]);
    if (!shouldRender || !parsedEmbed) return null;
    if (parsedEmbed.provider === 'cstStaticForm') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cSBgL.CstStaticFormEmbed), {
        formName: parsedEmbed.formName,
        height: parsedEmbed.height
    }, embedKey);
    if (parsedEmbed.provider === 'outgrow') return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: mountRef,
        className: "op-interactive",
        id: parsedEmbed.embedId,
        "data-title": parsedEmbed.title,
        "data-url": parsedEmbed.embedUrl,
        "data-width": "100%",
        "data-third-party-embed-provider": "outgrow"
    });
    if (parsedEmbed.provider === 'ecosystemsIframe') return /*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
        ref: iframeRef,
        id: $b99260984a741dac$var$ECOSYSTEMS_IFRAME_ID,
        src: parsedEmbed.embedUrl,
        title: "Atlassian web application",
        style: {
            width: '100%',
            borderWidth: 0,
            overflow: 'hidden'
        },
        scrolling: "no",
        "data-third-party-embed-provider": "ecosystemsIframe",
        onError: ()=>{
            $b99260984a741dac$var$logFailure(parsedEmbed.provider, 'load');
            setFailure({
                embedKey: $b99260984a741dac$var$getEmbedKey(parsedEmbed)
            });
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: supportFormHostRef,
        "data-third-party-embed-provider": "supportForm",
        "data-third-party-embed-scope": "supportForm"
    });
};
var $b99260984a741dac$export$2e2bcd8739ae039 = $b99260984a741dac$export$904dfb4fab740e3d;

});
parcelRegister("cSBgL", function(module, exports) {
$parcel$export(module.exports, "CstStaticFormEmbed", function () { return $5ca355a576adbe25$export$6fa393139bc2f61e; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
const $5ca355a576adbe25$var$CST_STATIC_FORM_ORIGIN = 'https://support-forms-ui.atlassian.com';
const $5ca355a576adbe25$var$getCstStaticFormRedirect = (value)=>{
    try {
        const destination = new URL(value, window.location.href);
        if (destination.protocol !== 'https:' || destination.username || destination.password) return null;
        if (destination.origin !== window.location.origin && destination.origin !== $5ca355a576adbe25$var$CST_STATIC_FORM_ORIGIN && destination.origin !== 'https://support.atlassian.com') return null;
        return destination.href;
    } catch  {
        return null;
    }
};
const $5ca355a576adbe25$export$6fa393139bc2f61e = ({ formName: formName, height: height })=>{
    const intl = (0, $8e22h.default)();
    const iframeRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const iframe = iframeRef.current;
        if (!iframe) return;
        // Match the CST loader's URL construction without evaluating author HTML or
        // installing its permanent global message listeners.
        const handleMessage = (event)=>{
            if (event.origin !== $5ca355a576adbe25$var$CST_STATIC_FORM_ORIGIN || event.source !== iframe.contentWindow) return;
            if (typeof event.data !== 'string') return;
            const [action, value] = event.data.split('|');
            if (!value) return;
            if (action === 'resize' && /^[1-9]\d{0,5}$/.test(value) && Number(value) <= 100000) iframe.height = value;
            else if (action === 'redirect') {
                const destination = $5ca355a576adbe25$var$getCstStaticFormRedirect(value);
                if (destination) window.location.replace(destination);
            }
        };
        window.addEventListener('message', handleMessage);
        iframe.src = `${$5ca355a576adbe25$var$CST_STATIC_FORM_ORIGIN}/forms/${formName}${window.location.search}`;
        return ()=>window.removeEventListener('message', handleMessage);
    }, [
        formName
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
        ref: iframeRef,
        id: `${formName}-iframe`,
        className: "cst-static-form-iframe",
        height: height,
        width: "100%",
        frameBorder: "0",
        scrolling: "no",
        title: intl.formatMessage({
            id: 'ThirdPartyEmbed.cstStaticFormTitle',
            defaultMessage: 'Atlassian support form'
        }),
        "data-third-party-embed-provider": "cstStaticForm"
    });
};

});

parcelRegister("af53x", function(module, exports) {
$parcel$export(module.exports, "parseThirdPartyEmbedHtml", function () { return $abb6ae8c353ffd62$export$5a01be6dabf77b78; });
parcelRequire("gjvyh");
var $cryJ7 = parcelRequire("cryJ7");
var $gjvyh = parcelRequire("gjvyh");
const $abb6ae8c353ffd62$var$OUTGROW_HOSTNAME = 'atlassian931.outgrow.us';
const $abb6ae8c353ffd62$var$OUTGROW_LOADER_HOSTNAME = 'dyv6f9ner1ir9.cloudfront.net';
const $abb6ae8c353ffd62$var$SUPPORT_FORM_HOSTNAMES = new Set([
    'support-form-app-ui.prod-east.frontend.public.atl-paas.net',
    'support-form-app-ui.stg-east.frontend.public.atl-paas.net'
]);
const $abb6ae8c353ffd62$var$SUPPORT_FORM_SHIM_PATH = '/assets/js-app-shim.js';
const $abb6ae8c353ffd62$var$SUPPORT_FORM_PRODUCTION_MANIFEST_URL = 'https://support-form-app-ui.prod-east.frontend.public.atl-paas.net/assets/asset-manifest.json';
const $abb6ae8c353ffd62$var$SUPPORT_FORM_STAGING_MANIFEST_URL = 'https://support-form-app-ui.stg-east.frontend.public.atl-paas.net/assets/asset-manifest.json';
const $abb6ae8c353ffd62$var$SAFE_SUPPORT_FORM_ASSET_KEY = /^[a-z0-9][a-z0-9-]{0,127}\.(?:js|css)$/;
const $abb6ae8c353ffd62$var$ECOSYSTEMS_IFRAME_HOSTNAME = 'atlassian.wvc-test.ecosystems.io';
const $abb6ae8c353ffd62$var$ECOSYSTEMS_IFRAME_ID = 'webapp-frame';
const $abb6ae8c353ffd62$var$SAFE_EMBED_ID = /^[A-Za-z0-9_-]{1,128}$/;
const $abb6ae8c353ffd62$var$isWhitespace = (node)=>node.type === 'text' && node.data.trim() === '';
const $abb6ae8c353ffd62$var$meaningfulChildren = (children)=>children.filter((node)=>!$abb6ae8c353ffd62$var$isWhitespace(node));
const $abb6ae8c353ffd62$var$isElement = (node, name)=>node !== undefined && (0, $cryJ7).isTag(node) && node.name === name;
const $abb6ae8c353ffd62$var$hasOnlyAttributes = (element, allowedAttributes)=>{
    const allowed = new Set(allowedAttributes);
    return Object.keys(element.attribs).every((attribute)=>allowed.has(attribute) && !attribute.toLowerCase().startsWith('on'));
};
const $abb6ae8c353ffd62$var$hasExactClasses = (element, expectedClasses)=>{
    const actualClasses = (element.attribs['class'] ?? '').split(/\s+/).filter(Boolean).sort();
    return actualClasses.join(' ') === [
        ...expectedClasses
    ].sort().join(' ');
};
const $abb6ae8c353ffd62$var$getScriptText = (script)=>$abb6ae8c353ffd62$var$meaningfulChildren(script.children).map((node)=>node.type === 'text' ? node.data : '').join('');
const $abb6ae8c353ffd62$var$isOptionalJavaScriptType = (element)=>{
    const type = element.attribs['type'];
    return type === undefined || type === 'text/javascript';
};
const $abb6ae8c353ffd62$var$parseApprovedHttpsUrl = (value)=>{
    try {
        const url = new URL(value);
        if (url.protocol !== 'https:' || url.username !== '' || url.password !== '' || url.port !== '') return null;
        return url;
    } catch  {
        return null;
    }
};
const $abb6ae8c353ffd62$var$isApprovedOutgrowMount = (element)=>$abb6ae8c353ffd62$var$hasOnlyAttributes(element, [
        'class',
        'id',
        'data-title',
        'data-url',
        'data-width'
    ]) && $abb6ae8c353ffd62$var$hasExactClasses(element, [
        'op-interactive'
    ]) && $abb6ae8c353ffd62$var$meaningfulChildren(element.children).length === 0 && element.attribs['data-width'] === '100%';
const $abb6ae8c353ffd62$var$isApprovedScriptElement = (element, allowedAttributes)=>$abb6ae8c353ffd62$var$hasOnlyAttributes(element, allowedAttributes) && $abb6ae8c353ffd62$var$isOptionalJavaScriptType(element);
const $abb6ae8c353ffd62$var$isApprovedOutgrowConfiguration = (embedId, title, approvedUrl, scriptText)=>$abb6ae8c353ffd62$var$SAFE_EMBED_ID.test(embedId) && title !== '' && approvedUrl?.hostname === $abb6ae8c353ffd62$var$OUTGROW_HOSTNAME && approvedUrl.pathname === `/${embedId}` && scriptText.includes($abb6ae8c353ffd62$var$OUTGROW_LOADER_HOSTNAME) && scriptText.includes(`initIframe('${embedId}')`);
const $abb6ae8c353ffd62$var$isApprovedSupportFormMount = (element)=>$abb6ae8c353ffd62$var$hasOnlyAttributes(element, [
        'class'
    ]) && $abb6ae8c353ffd62$var$hasExactClasses(element, [
        'wac-form'
    ]) && $abb6ae8c353ffd62$var$meaningfulChildren(element.children).length === 0;
const $abb6ae8c353ffd62$var$isApprovedSupportFormShimUrl = (url)=>url !== null && $abb6ae8c353ffd62$var$SUPPORT_FORM_HOSTNAMES.has(url.hostname) && url.pathname === $abb6ae8c353ffd62$var$SUPPORT_FORM_SHIM_PATH && url.search === '' && url.hash === '';
const $abb6ae8c353ffd62$var$escapeRegularExpression = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const $abb6ae8c353ffd62$var$hasStringProperty = (script, property, value)=>new RegExp(`\\b${property}\\s*:\\s*(['"])${$abb6ae8c353ffd62$var$escapeRegularExpression(value)}\\1`).test(script);
const $abb6ae8c353ffd62$var$getSingleItemArrayProperty = (script, property)=>{
    const expression = new RegExp(`\\b${property}\\s*:\\s*\\[\\s*(['"])([^'"]+)\\1\\s*\\]`, 'g');
    let value = null;
    let match = expression.exec(script);
    while(match){
        if (value !== null) return null;
        value = match[2];
        match = expression.exec(script);
    }
    return value;
};
const $abb6ae8c353ffd62$var$getApprovedSupportFormConfiguration = (script)=>{
    if (!script.includes('window.jsAppShim') || !script.includes($abb6ae8c353ffd62$var$SUPPORT_FORM_PRODUCTION_MANIFEST_URL) || !script.includes($abb6ae8c353ffd62$var$SUPPORT_FORM_STAGING_MANIFEST_URL) || !$abb6ae8c353ffd62$var$hasStringProperty(script, 'target', '.wac-form') || !$abb6ae8c353ffd62$var$hasStringProperty(script, 'position', 'after') || !$abb6ae8c353ffd62$var$hasStringProperty(script, 'appTargetId', 'support-form-app')) return null;
    const scriptKey = $abb6ae8c353ffd62$var$getSingleItemArrayProperty(script, 'scripts');
    const stylesheetKey = $abb6ae8c353ffd62$var$getSingleItemArrayProperty(script, 'styles');
    if (!scriptKey || !stylesheetKey || !$abb6ae8c353ffd62$var$SAFE_SUPPORT_FORM_ASSET_KEY.test(scriptKey) || !$abb6ae8c353ffd62$var$SAFE_SUPPORT_FORM_ASSET_KEY.test(stylesheetKey) || !scriptKey.endsWith('.js') || !stylesheetKey.endsWith('.css') || scriptKey.slice(0, -3) !== stylesheetKey.slice(0, -4)) return null;
    return {
        scriptKey: scriptKey,
        stylesheetKey: stylesheetKey
    };
};
const $abb6ae8c353ffd62$var$hasApprovedIframeStyles = (style)=>{
    const declarations = style.split(';').map((declaration)=>declaration.trim()).filter(Boolean);
    if (declarations.length !== 3) return false;
    const normalizedDeclarations = declarations.map((declaration)=>declaration.replace(/\s+/g, '').toLowerCase());
    return new Set(normalizedDeclarations).size === 3 && normalizedDeclarations.includes('width:100%') && normalizedDeclarations.includes('border:none') && normalizedDeclarations.includes('overflow:hidden');
};
const $abb6ae8c353ffd62$var$APPROVED_ECOSYSTEMS_RESIZE_SCRIPT = /^\s*window\.addEventListener\s*\(\s*(['"])message\1\s*,\s*\(?\s*event\s*\)?\s*=>\s*\{\s*if\s*\(\s*event\.data\.type\s*===\s*(['"])resize-iframe\2\s*\)\s*\{\s*const\s+iframe\s*=\s*document\.getElementById\s*\(\s*(['"])webapp-frame\3\s*\)\s*;\s*iframe\.style\.height\s*=\s*event\.data\.height\s*\+\s*(['"])px\4\s*;\s*\}\s*\}\s*\)\s*;?\s*$/;
const $abb6ae8c353ffd62$var$hasApprovedEcosystemsResizeSignature = (script)=>$abb6ae8c353ffd62$var$APPROVED_ECOSYSTEMS_RESIZE_SCRIPT.test(script);
const $abb6ae8c353ffd62$var$isApprovedEcosystemsIframeNode = (iframe)=>$abb6ae8c353ffd62$var$hasOnlyAttributes(iframe, [
        'id',
        'src',
        'style',
        'scrolling'
    ]) && iframe.attribs['id'] === $abb6ae8c353ffd62$var$ECOSYSTEMS_IFRAME_ID && iframe.attribs['scrolling'] === 'no' && $abb6ae8c353ffd62$var$hasApprovedIframeStyles(iframe.attribs['style'] ?? '') && $abb6ae8c353ffd62$var$meaningfulChildren(iframe.children).length === 0;
const $abb6ae8c353ffd62$var$isApprovedEcosystemsConfiguration = (embedUrl, script)=>embedUrl?.hostname === $abb6ae8c353ffd62$var$ECOSYSTEMS_IFRAME_HOSTNAME && embedUrl.pathname === '/' && embedUrl.search === '' && embedUrl.hash === '' && $abb6ae8c353ffd62$var$hasApprovedEcosystemsResizeSignature(script);
const $abb6ae8c353ffd62$var$parseOutgrow = (root)=>{
    if (!$abb6ae8c353ffd62$var$hasOnlyAttributes(root, [])) return null;
    const children = $abb6ae8c353ffd62$var$meaningfulChildren(root.children);
    if (children.length !== 2) return null;
    const [mountNode, scriptNode] = children;
    if (!$abb6ae8c353ffd62$var$isElement(mountNode, 'div') || !$abb6ae8c353ffd62$var$isElement(scriptNode, 'script')) return null;
    if (!$abb6ae8c353ffd62$var$isApprovedOutgrowMount(mountNode)) return null;
    if (!$abb6ae8c353ffd62$var$isApprovedScriptElement(scriptNode, [
        'type'
    ])) return null;
    const embedId = mountNode.attribs['id'] ?? '';
    const embedUrl = mountNode.attribs['data-url'] ?? '';
    const title = mountNode.attribs['data-title']?.trim() ?? '';
    const approvedUrl = $abb6ae8c353ffd62$var$parseApprovedHttpsUrl(embedUrl);
    const scriptText = $abb6ae8c353ffd62$var$getScriptText(scriptNode);
    if (!$abb6ae8c353ffd62$var$isApprovedOutgrowConfiguration(embedId, title, approvedUrl, scriptText)) return null;
    return {
        provider: 'outgrow',
        embedId: embedId,
        embedUrl: approvedUrl.toString(),
        title: title
    };
};
const $abb6ae8c353ffd62$var$parseSupportForm = (children)=>{
    if (children.length !== 3) return null;
    const [mountNode, externalScriptNode, inlineScriptNode] = children;
    if (!$abb6ae8c353ffd62$var$isElement(mountNode, 'div') || !$abb6ae8c353ffd62$var$isElement(externalScriptNode, 'script') || !$abb6ae8c353ffd62$var$isElement(inlineScriptNode, 'script')) return null;
    if (!$abb6ae8c353ffd62$var$isApprovedSupportFormMount(mountNode)) return null;
    if (!$abb6ae8c353ffd62$var$isApprovedScriptElement(externalScriptNode, [
        'src',
        'type'
    ]) || $abb6ae8c353ffd62$var$meaningfulChildren(externalScriptNode.children).length !== 0 || !$abb6ae8c353ffd62$var$isApprovedScriptElement(inlineScriptNode, [
        'type'
    ])) return null;
    const shimUrl = $abb6ae8c353ffd62$var$parseApprovedHttpsUrl(externalScriptNode.attribs['src'] ?? '');
    if (!$abb6ae8c353ffd62$var$isApprovedSupportFormShimUrl(shimUrl)) return null;
    const inlineScript = $abb6ae8c353ffd62$var$getScriptText(inlineScriptNode);
    const configuration = $abb6ae8c353ffd62$var$getApprovedSupportFormConfiguration(inlineScript);
    if (!configuration) return null;
    return {
        provider: 'supportForm',
        ...configuration
    };
};
const $abb6ae8c353ffd62$var$parseEcosystemsIframe = (children)=>{
    if (children.length !== 2) return null;
    const [iframeNode, scriptNode] = children;
    if (!$abb6ae8c353ffd62$var$isElement(iframeNode, 'iframe') || !$abb6ae8c353ffd62$var$isElement(scriptNode, 'script')) return null;
    if (!$abb6ae8c353ffd62$var$isApprovedEcosystemsIframeNode(iframeNode) || !$abb6ae8c353ffd62$var$isApprovedScriptElement(scriptNode, [
        'type'
    ])) return null;
    const embedUrl = $abb6ae8c353ffd62$var$parseApprovedHttpsUrl(iframeNode.attribs['src'] ?? '');
    if (!$abb6ae8c353ffd62$var$isApprovedEcosystemsConfiguration(embedUrl, $abb6ae8c353ffd62$var$getScriptText(scriptNode))) return null;
    return {
        provider: 'ecosystemsIframe',
        embedUrl: embedUrl.toString()
    };
};
// Recognize configuration only; never execute the pasted JavaScript.
const $abb6ae8c353ffd62$var$CST_STATIC_FORM_INITIALIZER = /^\s*(?:var|let|const)\s+([A-Za-z_$][\w$]*)\s*=\s*new\s+CstStaticForm\s*\(\s*\)\s*;\s*\1\.initialize\s*\(\s*\{([^{}]+)\}\s*\)\s*;\s*\1\.display\s*\(\s*\)\s*;?\s*$/;
const $abb6ae8c353ffd62$var$parseCstStaticFormConfiguration = (script)=>{
    const configuration = $abb6ae8c353ffd62$var$CST_STATIC_FORM_INITIALIZER.exec(script)?.[2];
    if (!configuration) return null;
    const properties = configuration.trim().replace(/,\s*$/, '').split(',');
    if (properties.length !== 2) return null;
    const values = new Map();
    for (const property of properties){
        const match = /^\s*(?:(['"])(formName|height)\1|(formName|height))\s*:\s*(['"])([a-z0-9-]+)\4\s*$/.exec(property);
        if (!match) return null;
        values.set(match[2] ?? match[3] ?? '', match[5] ?? '');
    }
    const formName = values.get('formName') ?? '';
    const height = values.get('height') ?? '';
    if (!/^[a-z0-9][a-z0-9-]{0,127}$/.test(formName) || !/^[1-9]\d{0,5}$/.test(height) || Number(height) > 100000) return null;
    return {
        provider: 'cstStaticForm',
        formName: formName,
        height: Number(height)
    };
};
const $abb6ae8c353ffd62$var$parseCstStaticForm = (root)=>{
    if (!$abb6ae8c353ffd62$var$hasOnlyAttributes(root, [
        'id'
    ]) || root.attribs['id'] !== 'cst-static-forms-container') return null;
    const children = $abb6ae8c353ffd62$var$meaningfulChildren(root.children);
    const [loader, initializer] = children;
    if (children.length !== 2 || !$abb6ae8c353ffd62$var$isElement(loader, 'script') || !$abb6ae8c353ffd62$var$isElement(initializer, 'script')) return null;
    if (!$abb6ae8c353ffd62$var$isApprovedScriptElement(loader, [
        'src',
        'type'
    ]) || $abb6ae8c353ffd62$var$meaningfulChildren(loader.children).length !== 0 || !$abb6ae8c353ffd62$var$isApprovedScriptElement(initializer, [
        'type'
    ]) || loader.attribs['src'] !== 'https://support-forms-ui.atlassian.com/assets/js/cst-static-forms-api.js') return null;
    return $abb6ae8c353ffd62$var$parseCstStaticFormConfiguration($abb6ae8c353ffd62$var$getScriptText(initializer));
};
const $abb6ae8c353ffd62$export$5a01be6dabf77b78 = (rawHtml)=>{
    if (rawHtml.trim() === '') return null;
    const document = (0, $gjvyh.parseDocument)(rawHtml, {
        decodeEntities: true,
        lowerCaseAttributeNames: true,
        lowerCaseTags: true
    });
    const roots = $abb6ae8c353ffd62$var$meaningfulChildren(document.children);
    if (roots.length === 1 && $abb6ae8c353ffd62$var$isElement(roots[0], 'div')) {
        const cstStaticForm = $abb6ae8c353ffd62$var$parseCstStaticForm(roots[0]);
        if (cstStaticForm) return cstStaticForm;
        const outgrow = $abb6ae8c353ffd62$var$parseOutgrow(roots[0]);
        if (outgrow) return outgrow;
    }
    return $abb6ae8c353ffd62$var$parseSupportForm(roots) ?? $abb6ae8c353ffd62$var$parseEcosystemsIframe(roots);
};

});
parcelRegister("gjvyh", function(module, exports) {
$parcel$export(module.exports, "parseDocument", function () { return $be06e53d43e1ec4b$export$b6a9369736b19f4d; });
$parcel$export(module.exports, "DomUtils", function () { return (parcelRequire("cryJ7")); });

var $hft5G = parcelRequire("hft5G");

var $eXmj2 = parcelRequire("eXmj2");

var $icOSY = parcelRequire("icOSY");

var $3uWD7 = parcelRequire("3uWD7");
parcelRequire("cryJ7");
var $4Ue08 = parcelRequire("4Ue08");
var $cryJ7 = parcelRequire("cryJ7");
function $be06e53d43e1ec4b$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $eXmj2.DomHandler)(undefined, options);
    new (0, $hft5G.Parser)(handler, options).end(data);
    return handler.root;
}
function $be06e53d43e1ec4b$export$d66b332881d9723f(data, options) {
    return $be06e53d43e1ec4b$export$b6a9369736b19f4d(data, options).children;
}
function $be06e53d43e1ec4b$export$d6f7114fde618113(callback, options, elementCallback) {
    const handler = new (0, $eXmj2.DomHandler)((error)=>callback(error, handler.root), options, elementCallback);
    return new (0, $hft5G.Parser)(handler, options);
}
function $be06e53d43e1ec4b$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $eXmj2.DomHandler)(callback, options, elementCallback);
    return new (0, $hft5G.Parser)(handler, options);
}
const $be06e53d43e1ec4b$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $be06e53d43e1ec4b$export$5267abf679cd576b(feed, options = $be06e53d43e1ec4b$var$parseFeedDefaultOptions) {
    return (0, $4Ue08.getFeed)($be06e53d43e1ec4b$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("hft5G", function(module, exports) {
$parcel$export(module.exports, "Parser", function () { return $c8ea672a2bd30a4f$export$7acfa6ed01010e37; });

var $icOSY = parcelRequire("icOSY");

var $9i7QI = parcelRequire("9i7QI");
const $c8ea672a2bd30a4f$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $c8ea672a2bd30a4f$var$pTag = new Set([
    "p"
]);
const $c8ea672a2bd30a4f$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $c8ea672a2bd30a4f$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $c8ea672a2bd30a4f$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $c8ea672a2bd30a4f$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "h1",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "h2",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "h3",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "h4",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "h5",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "h6",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "select",
        $c8ea672a2bd30a4f$var$formTags
    ],
    [
        "input",
        $c8ea672a2bd30a4f$var$formTags
    ],
    [
        "output",
        $c8ea672a2bd30a4f$var$formTags
    ],
    [
        "button",
        $c8ea672a2bd30a4f$var$formTags
    ],
    [
        "datalist",
        $c8ea672a2bd30a4f$var$formTags
    ],
    [
        "textarea",
        $c8ea672a2bd30a4f$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $c8ea672a2bd30a4f$var$ddtTags
    ],
    [
        "dt",
        $c8ea672a2bd30a4f$var$ddtTags
    ],
    [
        "address",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "article",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "aside",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "blockquote",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "details",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "div",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "dl",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "fieldset",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "figcaption",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "figure",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "footer",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "form",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "header",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "hr",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "main",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "nav",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "ol",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "pre",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "section",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "table",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "ul",
        $c8ea672a2bd30a4f$var$pTag
    ],
    [
        "rt",
        $c8ea672a2bd30a4f$var$rtpTags
    ],
    [
        "rp",
        $c8ea672a2bd30a4f$var$rtpTags
    ],
    [
        "tbody",
        $c8ea672a2bd30a4f$var$tableSectionTags
    ],
    [
        "tfoot",
        $c8ea672a2bd30a4f$var$tableSectionTags
    ]
]);
const $c8ea672a2bd30a4f$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $c8ea672a2bd30a4f$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $c8ea672a2bd30a4f$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $c8ea672a2bd30a4f$var$reNameEnd = /\s|\//;
class $c8ea672a2bd30a4f$export$7acfa6ed01010e37 {
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.htmlMode = !this.options.xmlMode;
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : this.htmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : this.htmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $icOSY.default))(this.options, this);
        this.foreignContext = [
            !this.htmlMode
        ];
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp, endIndex) {
        var _a, _b;
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $9i7QI.fromCodePoint)(cp));
        this.startIndex = endIndex;
    }
    /**
     * Checks if the current tag is a void element. Override this if you want
     * to specify your own additional void elements.
     */ isVoidElement(name) {
        return this.htmlMode && $c8ea672a2bd30a4f$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = this.htmlMode && $c8ea672a2bd30a4f$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[0])){
            const element = this.stack.shift();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.unshift(name);
            if (this.htmlMode) {
                if ($c8ea672a2bd30a4f$var$foreignContextElements.has(name)) this.foreignContext.unshift(true);
                else if ($c8ea672a2bd30a4f$var$htmlIntegrationElements.has(name)) this.foreignContext.unshift(false);
            }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if (this.htmlMode && ($c8ea672a2bd30a4f$var$foreignContextElements.has(name) || $c8ea672a2bd30a4f$var$htmlIntegrationElements.has(name))) this.foreignContext.shift();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.indexOf(name);
            if (pos !== -1) for(let index = 0; index <= pos; index++){
                const element = this.stack.shift();
                // We know the stack has sufficient elements.
                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, index !== pos);
            }
            else if (this.htmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (this.htmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, "br");
            (_f = (_e = this.cbs).onopentag) === null || _f === void 0 || _f.call(_e, "br", {}, true);
            (_h = (_g = this.cbs).onclosetag) === null || _h === void 0 || _h.call(_g, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.options.recognizeSelfClosing || this.foreignContext[0]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[0] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.shift();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $9i7QI.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $icOSY.QuoteType).Double ? '"' : quote === (0, $icOSY.QuoteType).Single ? "'" : quote === (0, $icOSY.QuoteType).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($c8ea672a2bd30a4f$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (!this.htmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = 0; index < this.stack.length; index++)this.cbs.onclosetag(this.stack[index], true);
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.foreignContext.length = 0;
        this.foreignContext.unshift(!this.htmlMode);
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
}

});
parcelRegister("icOSY", function(module, exports) {
$parcel$export(module.exports, "QuoteType", function () { return $d410d1d6cd672176$export$cbf5509cea2ad22; });
$parcel$export(module.exports, "default", function () { return $d410d1d6cd672176$export$2e2bcd8739ae039; });

var $9i7QI = parcelRequire("9i7QI");
var $d410d1d6cd672176$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($d410d1d6cd672176$var$CharCodes || ($d410d1d6cd672176$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $d410d1d6cd672176$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["InEntity"] = 25] = "InEntity";
})($d410d1d6cd672176$var$State || ($d410d1d6cd672176$var$State = {}));
function $d410d1d6cd672176$var$isWhitespace(c) {
    return c === $d410d1d6cd672176$var$CharCodes.Space || c === $d410d1d6cd672176$var$CharCodes.NewLine || c === $d410d1d6cd672176$var$CharCodes.Tab || c === $d410d1d6cd672176$var$CharCodes.FormFeed || c === $d410d1d6cd672176$var$CharCodes.CarriageReturn;
}
function $d410d1d6cd672176$var$isEndOfTagSection(c) {
    return c === $d410d1d6cd672176$var$CharCodes.Slash || c === $d410d1d6cd672176$var$CharCodes.Gt || $d410d1d6cd672176$var$isWhitespace(c);
}
function $d410d1d6cd672176$var$isASCIIAlpha(c) {
    return c >= $d410d1d6cd672176$var$CharCodes.LowerA && c <= $d410d1d6cd672176$var$CharCodes.LowerZ || c >= $d410d1d6cd672176$var$CharCodes.UpperA && c <= $d410d1d6cd672176$var$CharCodes.UpperZ;
}
var $d410d1d6cd672176$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($d410d1d6cd672176$export$cbf5509cea2ad22 || ($d410d1d6cd672176$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $d410d1d6cd672176$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
class $d410d1d6cd672176$export$2e2bcd8739ae039 {
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $d410d1d6cd672176$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $d410d1d6cd672176$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityDecoder = new (0, $9i7QI.EntityDecoder)(xmlMode ? (0, $9i7QI.xmlDecodeTree) : (0, $9i7QI.htmlDecodeTree), (cp, consumed)=>this.emitCodePoint(cp, consumed));
    }
    reset() {
        this.state = $d410d1d6cd672176$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $d410d1d6cd672176$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    stateText(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($d410d1d6cd672176$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $d410d1d6cd672176$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $d410d1d6cd672176$var$CharCodes.Amp) this.startEntity();
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $d410d1d6cd672176$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $d410d1d6cd672176$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $d410d1d6cd672176$var$CharCodes.Gt || $d410d1d6cd672176$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $d410d1d6cd672176$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $d410d1d6cd672176$var$CharCodes.Amp) this.startEntity();
            } else if (this.fastForwardTo($d410d1d6cd672176$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $d410d1d6cd672176$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $d410d1d6cd672176$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $d410d1d6cd672176$var$Sequences.Cdata.length) {
                this.state = $d410d1d6cd672176$var$State.InCommentLike;
                this.currentSequence = $d410d1d6cd672176$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $d410d1d6cd672176$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $d410d1d6cd672176$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $d410d1d6cd672176$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$d410d1d6cd672176$var$isEndOfTagSection(c) : $d410d1d6cd672176$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $d410d1d6cd672176$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.ExclamationMark) {
            this.state = $d410d1d6cd672176$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $d410d1d6cd672176$var$CharCodes.Questionmark) {
            this.state = $d410d1d6cd672176$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === $d410d1d6cd672176$var$Sequences.TitleEnd[2]) this.startSpecial($d410d1d6cd672176$var$Sequences.TitleEnd, 3);
            else this.state = !this.xmlMode && lower === $d410d1d6cd672176$var$Sequences.ScriptEnd[2] ? $d410d1d6cd672176$var$State.BeforeSpecialS : $d410d1d6cd672176$var$State.InTagName;
        } else if (c === $d410d1d6cd672176$var$CharCodes.Slash) this.state = $d410d1d6cd672176$var$State.BeforeClosingTagName;
        else {
            this.state = $d410d1d6cd672176$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($d410d1d6cd672176$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $d410d1d6cd672176$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($d410d1d6cd672176$var$isWhitespace(c)) ;
        else if (c === $d410d1d6cd672176$var$CharCodes.Gt) this.state = $d410d1d6cd672176$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $d410d1d6cd672176$var$State.InClosingTagName : $d410d1d6cd672176$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Gt || $d410d1d6cd672176$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $d410d1d6cd672176$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $d410d1d6cd672176$var$CharCodes.Gt || this.fastForwardTo($d410d1d6cd672176$var$CharCodes.Gt)) {
            this.state = $d410d1d6cd672176$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $d410d1d6cd672176$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $d410d1d6cd672176$var$State.Text;
            this.sectionStart = this.index + 1;
        } else if (c === $d410d1d6cd672176$var$CharCodes.Slash) this.state = $d410d1d6cd672176$var$State.InSelfClosingTag;
        else if (!$d410d1d6cd672176$var$isWhitespace(c)) {
            this.state = $d410d1d6cd672176$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $d410d1d6cd672176$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$d410d1d6cd672176$var$isWhitespace(c)) {
            this.state = $d410d1d6cd672176$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Eq || $d410d1d6cd672176$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $d410d1d6cd672176$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Eq) this.state = $d410d1d6cd672176$var$State.BeforeAttributeValue;
        else if (c === $d410d1d6cd672176$var$CharCodes.Slash || c === $d410d1d6cd672176$var$CharCodes.Gt) {
            this.cbs.onattribend($d410d1d6cd672176$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $d410d1d6cd672176$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$d410d1d6cd672176$var$isWhitespace(c)) {
            this.cbs.onattribend($d410d1d6cd672176$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $d410d1d6cd672176$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.DoubleQuote) {
            this.state = $d410d1d6cd672176$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $d410d1d6cd672176$var$CharCodes.SingleQuote) {
            this.state = $d410d1d6cd672176$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$d410d1d6cd672176$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $d410d1d6cd672176$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $d410d1d6cd672176$var$CharCodes.DoubleQuote ? $d410d1d6cd672176$export$cbf5509cea2ad22.Double : $d410d1d6cd672176$export$cbf5509cea2ad22.Single, this.index);
            this.state = $d410d1d6cd672176$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $d410d1d6cd672176$var$CharCodes.Amp) this.startEntity();
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $d410d1d6cd672176$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $d410d1d6cd672176$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($d410d1d6cd672176$var$isWhitespace(c) || c === $d410d1d6cd672176$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($d410d1d6cd672176$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $d410d1d6cd672176$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $d410d1d6cd672176$var$CharCodes.Amp) this.startEntity();
    }
    stateBeforeDeclaration(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.OpeningSquareBracket) {
            this.state = $d410d1d6cd672176$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $d410d1d6cd672176$var$CharCodes.Dash ? $d410d1d6cd672176$var$State.BeforeComment : $d410d1d6cd672176$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Gt || this.fastForwardTo($d410d1d6cd672176$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $d410d1d6cd672176$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Gt || this.fastForwardTo($d410d1d6cd672176$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $d410d1d6cd672176$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Dash) {
            this.state = $d410d1d6cd672176$var$State.InCommentLike;
            this.currentSequence = $d410d1d6cd672176$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $d410d1d6cd672176$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $d410d1d6cd672176$var$CharCodes.Gt || this.fastForwardTo($d410d1d6cd672176$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $d410d1d6cd672176$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $d410d1d6cd672176$var$Sequences.ScriptEnd[3]) this.startSpecial($d410d1d6cd672176$var$Sequences.ScriptEnd, 4);
        else if (lower === $d410d1d6cd672176$var$Sequences.StyleEnd[3]) this.startSpecial($d410d1d6cd672176$var$Sequences.StyleEnd, 4);
        else {
            this.state = $d410d1d6cd672176$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    startEntity() {
        this.baseState = this.state;
        this.state = $d410d1d6cd672176$var$State.InEntity;
        this.entityStart = this.index;
        this.entityDecoder.startEntity(this.xmlMode ? (0, $9i7QI.DecodingMode).Strict : this.baseState === $d410d1d6cd672176$var$State.Text || this.baseState === $d410d1d6cd672176$var$State.InSpecialTag ? (0, $9i7QI.DecodingMode).Legacy : (0, $9i7QI.DecodingMode).Attribute);
    }
    stateInEntity() {
        const length = this.entityDecoder.write(this.buffer, this.index - this.offset);
        // If `length` is positive, we are done with the entity.
        if (length >= 0) {
            this.state = this.baseState;
            if (length === 0) this.index = this.entityStart;
        } else // Mark buffer as consumed.
        this.index = this.offset + this.buffer.length - 1;
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $d410d1d6cd672176$var$State.Text || this.state === $d410d1d6cd672176$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $d410d1d6cd672176$var$State.InAttributeValueDq || this.state === $d410d1d6cd672176$var$State.InAttributeValueSq || this.state === $d410d1d6cd672176$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $d410d1d6cd672176$var$State.Text:
                    this.stateText(c);
                    break;
                case $d410d1d6cd672176$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $d410d1d6cd672176$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $d410d1d6cd672176$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $d410d1d6cd672176$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $d410d1d6cd672176$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $d410d1d6cd672176$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $d410d1d6cd672176$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $d410d1d6cd672176$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $d410d1d6cd672176$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $d410d1d6cd672176$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $d410d1d6cd672176$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $d410d1d6cd672176$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $d410d1d6cd672176$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $d410d1d6cd672176$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $d410d1d6cd672176$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $d410d1d6cd672176$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $d410d1d6cd672176$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $d410d1d6cd672176$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $d410d1d6cd672176$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $d410d1d6cd672176$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $d410d1d6cd672176$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $d410d1d6cd672176$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $d410d1d6cd672176$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $d410d1d6cd672176$var$State.InEntity:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $d410d1d6cd672176$var$State.InEntity) {
            this.entityDecoder.end();
            this.state = this.baseState;
        }
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        // If there is no remaining data, we are done.
        if (this.sectionStart >= endIndex) return;
        if (this.state === $d410d1d6cd672176$var$State.InCommentLike) {
            if (this.currentSequence === $d410d1d6cd672176$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $d410d1d6cd672176$var$State.InTagName || this.state === $d410d1d6cd672176$var$State.BeforeAttributeName || this.state === $d410d1d6cd672176$var$State.BeforeAttributeValue || this.state === $d410d1d6cd672176$var$State.AfterAttributeName || this.state === $d410d1d6cd672176$var$State.InAttributeName || this.state === $d410d1d6cd672176$var$State.InAttributeValueSq || this.state === $d410d1d6cd672176$var$State.InAttributeValueDq || this.state === $d410d1d6cd672176$var$State.InAttributeValueNq || this.state === $d410d1d6cd672176$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {
        if (this.baseState !== $d410d1d6cd672176$var$State.Text && this.baseState !== $d410d1d6cd672176$var$State.InSpecialTag) {
            if (this.sectionStart < this.entityStart) this.cbs.onattribdata(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.onattribentity(cp);
        } else {
            if (this.sectionStart < this.entityStart) this.cbs.ontext(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.ontextentity(cp, this.sectionStart);
        }
    }
}

});


parcelRegister("eXmj2", function(module, exports) {
$parcel$export(module.exports, "CDATA", function () { return (parcelRequire("iDCDs")).CDATA; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("iDCDs")).Comment; });
$parcel$export(module.exports, "Document", function () { return (parcelRequire("iDCDs")).Document; });
$parcel$export(module.exports, "Element", function () { return (parcelRequire("iDCDs")).Element; });
$parcel$export(module.exports, "hasChildren", function () { return (parcelRequire("iDCDs")).hasChildren; });
$parcel$export(module.exports, "isCDATA", function () { return (parcelRequire("iDCDs")).isCDATA; });
$parcel$export(module.exports, "isComment", function () { return (parcelRequire("iDCDs")).isComment; });
$parcel$export(module.exports, "isDocument", function () { return (parcelRequire("iDCDs")).isDocument; });
$parcel$export(module.exports, "isTag", function () { return (parcelRequire("iDCDs")).isTag; });
$parcel$export(module.exports, "isText", function () { return (parcelRequire("iDCDs")).isText; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return (parcelRequire("iDCDs")).ProcessingInstruction; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("iDCDs")).Text; });
$parcel$export(module.exports, "DomHandler", function () { return $02cf5a5657c633c1$export$ff8ccbac9225de62; });

var $3uWD7 = parcelRequire("3uWD7");

var $iDCDs = parcelRequire("iDCDs");
// Default options
const $02cf5a5657c633c1$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $02cf5a5657c633c1$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $iDCDs.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $02cf5a5657c633c1$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $02cf5a5657c633c1$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $iDCDs.Document)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $3uWD7.ElementType).Tag : undefined;
        const element = new (0, $iDCDs.Element)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $3uWD7.ElementType).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $iDCDs.Text)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $3uWD7.ElementType).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $iDCDs.Comment)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $iDCDs.Text)("");
        const node = new (0, $iDCDs.CDATA)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $iDCDs.ProcessingInstruction)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $02cf5a5657c633c1$export$2e2bcd8739ae039 = $02cf5a5657c633c1$export$ff8ccbac9225de62;

});
parcelRegister("3uWD7", function(module, exports) {
$parcel$export(module.exports, "ElementType", function () { return $28c1a71a2ed681fa$export$b992dc138d950e31; });
$parcel$export(module.exports, "isTag", function () { return $28c1a71a2ed681fa$export$3bf645f08efe3292; });
$parcel$export(module.exports, "Root", function () { return $28c1a71a2ed681fa$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Text", function () { return $28c1a71a2ed681fa$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Directive", function () { return $28c1a71a2ed681fa$export$befdefbdce210f91; });
$parcel$export(module.exports, "Comment", function () { return $28c1a71a2ed681fa$export$4d299b491347818a; });
$parcel$export(module.exports, "Script", function () { return $28c1a71a2ed681fa$export$2f8b47a141e57afc; });
$parcel$export(module.exports, "Style", function () { return $28c1a71a2ed681fa$export$d9e45bc13d335801; });
$parcel$export(module.exports, "Tag", function () { return $28c1a71a2ed681fa$export$3288d34c523a1192; });
$parcel$export(module.exports, "CDATA", function () { return $28c1a71a2ed681fa$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Doctype", function () { return $28c1a71a2ed681fa$export$31b44af36ff2c60f; });
/** Types of elements found in htmlparser2's DOM */ var $28c1a71a2ed681fa$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($28c1a71a2ed681fa$export$b992dc138d950e31 || ($28c1a71a2ed681fa$export$b992dc138d950e31 = {}));
function $28c1a71a2ed681fa$export$3bf645f08efe3292(elem) {
    return elem.type === $28c1a71a2ed681fa$export$b992dc138d950e31.Tag || elem.type === $28c1a71a2ed681fa$export$b992dc138d950e31.Script || elem.type === $28c1a71a2ed681fa$export$b992dc138d950e31.Style;
}
const $28c1a71a2ed681fa$export$be92b6f5f03c0fe9 = $28c1a71a2ed681fa$export$b992dc138d950e31.Root;
const $28c1a71a2ed681fa$export$5f1af8db9871e1d6 = $28c1a71a2ed681fa$export$b992dc138d950e31.Text;
const $28c1a71a2ed681fa$export$befdefbdce210f91 = $28c1a71a2ed681fa$export$b992dc138d950e31.Directive;
const $28c1a71a2ed681fa$export$4d299b491347818a = $28c1a71a2ed681fa$export$b992dc138d950e31.Comment;
const $28c1a71a2ed681fa$export$2f8b47a141e57afc = $28c1a71a2ed681fa$export$b992dc138d950e31.Script;
const $28c1a71a2ed681fa$export$d9e45bc13d335801 = $28c1a71a2ed681fa$export$b992dc138d950e31.Style;
const $28c1a71a2ed681fa$export$3288d34c523a1192 = $28c1a71a2ed681fa$export$b992dc138d950e31.Tag;
const $28c1a71a2ed681fa$export$1f8b8f7e5c763232 = $28c1a71a2ed681fa$export$b992dc138d950e31.CDATA;
const $28c1a71a2ed681fa$export$31b44af36ff2c60f = $28c1a71a2ed681fa$export$b992dc138d950e31.Doctype;

});

parcelRegister("iDCDs", function(module, exports) {
$parcel$export(module.exports, "Text", function () { return $d919d6aeb388ae18$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $d919d6aeb388ae18$export$4d299b491347818a; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return $d919d6aeb388ae18$export$9269dce19ee35e96; });
$parcel$export(module.exports, "CDATA", function () { return $d919d6aeb388ae18$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Document", function () { return $d919d6aeb388ae18$export$b34a105447964f9f; });
$parcel$export(module.exports, "Element", function () { return $d919d6aeb388ae18$export$db77ccec0bb4ccac; });
$parcel$export(module.exports, "isTag", function () { return $d919d6aeb388ae18$export$3bf645f08efe3292; });
$parcel$export(module.exports, "isCDATA", function () { return $d919d6aeb388ae18$export$c2d65aed98d39b56; });
$parcel$export(module.exports, "isText", function () { return $d919d6aeb388ae18$export$1879817ac5c922b7; });
$parcel$export(module.exports, "isComment", function () { return $d919d6aeb388ae18$export$3ab01370f5e64ac8; });
$parcel$export(module.exports, "isDocument", function () { return $d919d6aeb388ae18$export$62858bae88b53fd0; });
$parcel$export(module.exports, "hasChildren", function () { return $d919d6aeb388ae18$export$bd5ff50f0e53d41c; });

var $3uWD7 = parcelRequire("3uWD7");
class $d919d6aeb388ae18$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $d919d6aeb388ae18$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $d919d6aeb388ae18$export$c3569d91cd44d357 extends $d919d6aeb388ae18$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $d919d6aeb388ae18$export$5f1af8db9871e1d6 extends $d919d6aeb388ae18$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $3uWD7.ElementType).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $d919d6aeb388ae18$export$4d299b491347818a extends $d919d6aeb388ae18$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $3uWD7.ElementType).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $d919d6aeb388ae18$export$9269dce19ee35e96 extends $d919d6aeb388ae18$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $3uWD7.ElementType).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $d919d6aeb388ae18$export$62be934f90997196 extends $d919d6aeb388ae18$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $d919d6aeb388ae18$export$1f8b8f7e5c763232 extends $d919d6aeb388ae18$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $3uWD7.ElementType).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $d919d6aeb388ae18$export$b34a105447964f9f extends $d919d6aeb388ae18$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $3uWD7.ElementType).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $d919d6aeb388ae18$export$db77ccec0bb4ccac extends $d919d6aeb388ae18$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $3uWD7.ElementType).Script : name === "style" ? (0, $3uWD7.ElementType).Style : (0, $3uWD7.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $d919d6aeb388ae18$export$3bf645f08efe3292(node) {
    return (0, $3uWD7.isTag)(node);
}
function $d919d6aeb388ae18$export$c2d65aed98d39b56(node) {
    return node.type === (0, $3uWD7.ElementType).CDATA;
}
function $d919d6aeb388ae18$export$1879817ac5c922b7(node) {
    return node.type === (0, $3uWD7.ElementType).Text;
}
function $d919d6aeb388ae18$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $3uWD7.ElementType).Comment;
}
function $d919d6aeb388ae18$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $3uWD7.ElementType).Directive;
}
function $d919d6aeb388ae18$export$62858bae88b53fd0(node) {
    return node.type === (0, $3uWD7.ElementType).Root;
}
function $d919d6aeb388ae18$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $d919d6aeb388ae18$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($d919d6aeb388ae18$export$1879817ac5c922b7(node)) result = new $d919d6aeb388ae18$export$5f1af8db9871e1d6(node.data);
    else if ($d919d6aeb388ae18$export$3ab01370f5e64ac8(node)) result = new $d919d6aeb388ae18$export$4d299b491347818a(node.data);
    else if ($d919d6aeb388ae18$export$3bf645f08efe3292(node)) {
        const children = recursive ? $d919d6aeb388ae18$var$cloneChildren(node.children) : [];
        const clone = new $d919d6aeb388ae18$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($d919d6aeb388ae18$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $d919d6aeb388ae18$var$cloneChildren(node.children) : [];
        const clone = new $d919d6aeb388ae18$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($d919d6aeb388ae18$export$62858bae88b53fd0(node)) {
        const children = recursive ? $d919d6aeb388ae18$var$cloneChildren(node.children) : [];
        const clone = new $d919d6aeb388ae18$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($d919d6aeb388ae18$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $d919d6aeb388ae18$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $d919d6aeb388ae18$var$cloneChildren(childs) {
    const children = childs.map((child)=>$d919d6aeb388ae18$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("cryJ7", function(module, exports) {
$parcel$export(module.exports, "isTag", function () { return (parcelRequire("iDCDs")).isTag; });
$parcel$export(module.exports, "isCDATA", function () { return (parcelRequire("iDCDs")).isCDATA; });
$parcel$export(module.exports, "isText", function () { return (parcelRequire("iDCDs")).isText; });
$parcel$export(module.exports, "isComment", function () { return (parcelRequire("iDCDs")).isComment; });
$parcel$export(module.exports, "isDocument", function () { return (parcelRequire("iDCDs")).isDocument; });
$parcel$export(module.exports, "hasChildren", function () { return (parcelRequire("iDCDs")).hasChildren; });

var $fuBcm = parcelRequire("fuBcm");

var $lArpp = parcelRequire("lArpp");

var $e1vNN = parcelRequire("e1vNN");

var $gC7RG = parcelRequire("gC7RG");

var $2Rwg3 = parcelRequire("2Rwg3");

var $aApAQ = parcelRequire("aApAQ");

var $4Ue08 = parcelRequire("4Ue08");
parcelRequire("eXmj2");
var $iDCDs = parcelRequire("iDCDs");
$parcel$exportWildcard(module.exports, $fuBcm);
$parcel$exportWildcard(module.exports, $lArpp);
$parcel$exportWildcard(module.exports, $e1vNN);
$parcel$exportWildcard(module.exports, $gC7RG);
$parcel$exportWildcard(module.exports, $2Rwg3);
$parcel$exportWildcard(module.exports, $aApAQ);
$parcel$exportWildcard(module.exports, $4Ue08);

});
parcelRegister("fuBcm", function(module, exports) {
$parcel$export(module.exports, "getOuterHTML", function () { return $b476832a56d40fe4$export$39484b727cc2f324; });
$parcel$export(module.exports, "getInnerHTML", function () { return $b476832a56d40fe4$export$7ed15b4d2218408; });
$parcel$export(module.exports, "getText", function () { return $b476832a56d40fe4$export$c72d34660a162238; });
$parcel$export(module.exports, "textContent", function () { return $b476832a56d40fe4$export$e0e0794250e9118f; });
$parcel$export(module.exports, "innerText", function () { return $b476832a56d40fe4$export$5864bc2a45f1eb81; });
parcelRequire("eXmj2");
var $iDCDs = parcelRequire("iDCDs");

var $1iDL6 = parcelRequire("1iDL6");

var $3uWD7 = parcelRequire("3uWD7");
function $b476832a56d40fe4$export$39484b727cc2f324(node, options) {
    return (0, $1iDL6.default)(node, options);
}
function $b476832a56d40fe4$export$7ed15b4d2218408(node, options) {
    return (0, $iDCDs.hasChildren)(node) ? node.children.map((node)=>$b476832a56d40fe4$export$39484b727cc2f324(node, options)).join("") : "";
}
function $b476832a56d40fe4$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($b476832a56d40fe4$export$c72d34660a162238).join("");
    if ((0, $iDCDs.isTag)(node)) return node.name === "br" ? "\n" : $b476832a56d40fe4$export$c72d34660a162238(node.children);
    if ((0, $iDCDs.isCDATA)(node)) return $b476832a56d40fe4$export$c72d34660a162238(node.children);
    if ((0, $iDCDs.isText)(node)) return node.data;
    return "";
}
function $b476832a56d40fe4$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($b476832a56d40fe4$export$e0e0794250e9118f).join("");
    if ((0, $iDCDs.hasChildren)(node) && !(0, $iDCDs.isComment)(node)) return $b476832a56d40fe4$export$e0e0794250e9118f(node.children);
    if ((0, $iDCDs.isText)(node)) return node.data;
    return "";
}
function $b476832a56d40fe4$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($b476832a56d40fe4$export$5864bc2a45f1eb81).join("");
    if ((0, $iDCDs.hasChildren)(node) && (node.type === (0, $3uWD7.ElementType).Tag || (0, $iDCDs.isCDATA)(node))) return $b476832a56d40fe4$export$5864bc2a45f1eb81(node.children);
    if ((0, $iDCDs.isText)(node)) return node.data;
    return "";
}

});
parcelRegister("1iDL6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f26502146716073$export$2e2bcd8739ae039; });
/*
 * Module dependencies
 */ 
var $3uWD7 = parcelRequire("3uWD7");

var $fyijY = parcelRequire("fyijY");

var $kd8gO = parcelRequire("kd8gO");
const $0f26502146716073$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $0f26502146716073$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $0f26502146716073$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    const encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $0f26502146716073$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $fyijY.encodeXML) : (0, $fyijY.escapeAttribute);
    return Object.keys(attributes).map((key)=>{
        var _a, _b;
        const value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $kd8gO.attributeNames).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return `${key}="${encode(value)}"`;
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ const $0f26502146716073$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $0f26502146716073$export$b3890eb0ae9dca99(node, options = {}) {
    const nodes = "length" in node ? node : [
        node
    ];
    let output = "";
    for(let i = 0; i < nodes.length; i++)output += $0f26502146716073$var$renderNode(nodes[i], options);
    return output;
}
var $0f26502146716073$export$2e2bcd8739ae039 = $0f26502146716073$export$b3890eb0ae9dca99;
function $0f26502146716073$var$renderNode(node, options) {
    switch(node.type){
        case $3uWD7.Root:
            return $0f26502146716073$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $3uWD7.Doctype:
        case $3uWD7.Directive:
            return $0f26502146716073$var$renderDirective(node);
        case $3uWD7.Comment:
            return $0f26502146716073$var$renderComment(node);
        case $3uWD7.CDATA:
            return $0f26502146716073$var$renderCdata(node);
        case $3uWD7.Script:
        case $3uWD7.Style:
        case $3uWD7.Tag:
            return $0f26502146716073$var$renderTag(node, options);
        case $3uWD7.Text:
            return $0f26502146716073$var$renderText(node, options);
    }
}
const $0f26502146716073$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
const $0f26502146716073$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $0f26502146716073$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $kd8gO.elementNames).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $0f26502146716073$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = {
            ...opts,
            xmlMode: false
        };
    }
    if (!opts.xmlMode && $0f26502146716073$var$foreignElements.has(elem.name)) opts = {
        ...opts,
        xmlMode: "foreign"
    };
    let tag = `<${elem.name}`;
    const attribs = $0f26502146716073$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += ` ${attribs}`;
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $0f26502146716073$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $0f26502146716073$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$0f26502146716073$var$singleTag.has(elem.name)) tag += `</${elem.name}>`;
    }
    return tag;
}
function $0f26502146716073$var$renderDirective(elem) {
    return `<${elem.data}>`;
}
function $0f26502146716073$var$renderText(elem, opts) {
    var _a;
    let data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $0f26502146716073$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $fyijY.encodeXML)(data) : (0, $fyijY.escapeText)(data);
    return data;
}
function $0f26502146716073$var$renderCdata(elem) {
    return `<![CDATA[${elem.children[0].data}]]>`;
}
function $0f26502146716073$var$renderComment(elem) {
    return `<!--${elem.data}-->`;
}

});
parcelRegister("kd8gO", function(module, exports) {
$parcel$export(module.exports, "elementNames", function () { return $eb6b6fd5b634514d$export$82b917442d249e05; });
$parcel$export(module.exports, "attributeNames", function () { return $eb6b6fd5b634514d$export$b4cfbfd90280b005; });
const $eb6b6fd5b634514d$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));
const $eb6b6fd5b634514d$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));

});



parcelRegister("lArpp", function(module, exports) {
$parcel$export(module.exports, "getChildren", function () { return $fb723899e88ae848$export$f8cf48ee793b41be; });
$parcel$export(module.exports, "getParent", function () { return $fb723899e88ae848$export$58081aedf094d85b; });
$parcel$export(module.exports, "getSiblings", function () { return $fb723899e88ae848$export$f312c3733b79ac0d; });
$parcel$export(module.exports, "getAttributeValue", function () { return $fb723899e88ae848$export$1e335898aa11b111; });
$parcel$export(module.exports, "hasAttrib", function () { return $fb723899e88ae848$export$aa37f90c17957f38; });
$parcel$export(module.exports, "getName", function () { return $fb723899e88ae848$export$7d9f7e9c1c02b41e; });
$parcel$export(module.exports, "nextElementSibling", function () { return $fb723899e88ae848$export$9be3779649ef9cc7; });
$parcel$export(module.exports, "prevElementSibling", function () { return $fb723899e88ae848$export$c8bafb6e59c0b8e; });
parcelRequire("eXmj2");
var $iDCDs = parcelRequire("iDCDs");
function $fb723899e88ae848$export$f8cf48ee793b41be(elem) {
    return (0, $iDCDs.hasChildren)(elem) ? elem.children : [];
}
function $fb723899e88ae848$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $fb723899e88ae848$export$f312c3733b79ac0d(elem) {
    const parent = $fb723899e88ae848$export$58081aedf094d85b(elem);
    if (parent != null) return $fb723899e88ae848$export$f8cf48ee793b41be(parent);
    const siblings = [
        elem
    ];
    let { prev: prev, next: next } = elem;
    while(prev != null){
        siblings.unshift(prev);
        ({ prev: prev } = prev);
    }
    while(next != null){
        siblings.push(next);
        ({ next: next } = next);
    }
    return siblings;
}
function $fb723899e88ae848$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $fb723899e88ae848$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $fb723899e88ae848$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $fb723899e88ae848$export$9be3779649ef9cc7(elem) {
    let { next: next } = elem;
    while(next !== null && !(0, $iDCDs.isTag)(next))({ next: next } = next);
    return next;
}
function $fb723899e88ae848$export$c8bafb6e59c0b8e(elem) {
    let { prev: prev } = elem;
    while(prev !== null && !(0, $iDCDs.isTag)(prev))({ prev: prev } = prev);
    return prev;
}

});

parcelRegister("e1vNN", function(module, exports) {
$parcel$export(module.exports, "removeElement", function () { return $a359d3ef402d2a32$export$f883456a56996078; });
$parcel$export(module.exports, "replaceElement", function () { return $a359d3ef402d2a32$export$2dfe578f95754f6a; });
$parcel$export(module.exports, "appendChild", function () { return $a359d3ef402d2a32$export$1b8e57c9ea42f1d2; });
$parcel$export(module.exports, "append", function () { return $a359d3ef402d2a32$export$10d8903dec122b9d; });
$parcel$export(module.exports, "prependChild", function () { return $a359d3ef402d2a32$export$47b51e6d100007bc; });
$parcel$export(module.exports, "prepend", function () { return $a359d3ef402d2a32$export$68159836694e22c1; });
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $a359d3ef402d2a32$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        const childs = elem.parent.children;
        const childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $a359d3ef402d2a32$export$2dfe578f95754f6a(elem, replacement) {
    const prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    const next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    const parent = replacement.parent = elem.parent;
    if (parent) {
        const childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $a359d3ef402d2a32$export$1b8e57c9ea42f1d2(parent, child) {
    $a359d3ef402d2a32$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        const sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $a359d3ef402d2a32$export$10d8903dec122b9d(elem, next) {
    $a359d3ef402d2a32$export$f883456a56996078(next);
    const { parent: parent } = elem;
    const currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            const childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $a359d3ef402d2a32$export$47b51e6d100007bc(parent, child) {
    $a359d3ef402d2a32$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        const sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $a359d3ef402d2a32$export$68159836694e22c1(elem, prev) {
    $a359d3ef402d2a32$export$f883456a56996078(prev);
    const { parent: parent } = elem;
    if (parent) {
        const childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

});

parcelRegister("gC7RG", function(module, exports) {
$parcel$export(module.exports, "filter", function () { return $c1864bb9c7218342$export$3dea766d36a8935f; });
$parcel$export(module.exports, "find", function () { return $c1864bb9c7218342$export$71aa6c912b956294; });
$parcel$export(module.exports, "findOneChild", function () { return $c1864bb9c7218342$export$ac03a862904ce329; });
$parcel$export(module.exports, "findOne", function () { return $c1864bb9c7218342$export$a541876d5d7daf90; });
$parcel$export(module.exports, "existsOne", function () { return $c1864bb9c7218342$export$9d99dce58ac4a31b; });
$parcel$export(module.exports, "findAll", function () { return $c1864bb9c7218342$export$18200ea6c8035394; });
parcelRequire("eXmj2");
var $iDCDs = parcelRequire("iDCDs");
function $c1864bb9c7218342$export$3dea766d36a8935f(test, node, recurse = true, limit = Infinity) {
    return $c1864bb9c7218342$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $c1864bb9c7218342$export$71aa6c912b956294(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */ const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    /** Stack of the indices within the arrays. */ const indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $iDCDs.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $c1864bb9c7218342$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $c1864bb9c7218342$export$a541876d5d7daf90(test, nodes, recurse = true) {
    const searchedNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    for(let i = 0; i < searchedNodes.length; i++){
        const node = searchedNodes[i];
        if ((0, $iDCDs.isTag)(node) && test(node)) return node;
        if (recurse && (0, $iDCDs.hasChildren)(node) && node.children.length > 0) {
            const found = $c1864bb9c7218342$export$a541876d5d7daf90(test, node.children, true);
            if (found) return found;
        }
    }
    return null;
}
function $c1864bb9c7218342$export$9d99dce58ac4a31b(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [
        nodes
    ]).some((node)=>(0, $iDCDs.isTag)(node) && test(node) || (0, $iDCDs.hasChildren)(node) && $c1864bb9c7218342$export$9d99dce58ac4a31b(test, node.children));
}
function $c1864bb9c7218342$export$18200ea6c8035394(test, nodes) {
    const result = [];
    const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    const indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if ((0, $iDCDs.isTag)(elem) && test(elem)) result.push(elem);
        if ((0, $iDCDs.hasChildren)(elem) && elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

});

parcelRegister("2Rwg3", function(module, exports) {
$parcel$export(module.exports, "testElement", function () { return $21598dc8dcd67346$export$7b31db6b5a0b2f32; });
$parcel$export(module.exports, "getElements", function () { return $21598dc8dcd67346$export$73eac51a39d6b0eb; });
$parcel$export(module.exports, "getElementById", function () { return $21598dc8dcd67346$export$83595b84fc78b9b4; });
$parcel$export(module.exports, "getElementsByTagName", function () { return $21598dc8dcd67346$export$af941c3c7c3b40f5; });
$parcel$export(module.exports, "getElementsByClassName", function () { return $21598dc8dcd67346$export$764e2797d3aa1cff; });
$parcel$export(module.exports, "getElementsByTagType", function () { return $21598dc8dcd67346$export$f5d981e30be5545b; });
parcelRequire("eXmj2");
var $iDCDs = parcelRequire("iDCDs");

var $gC7RG = parcelRequire("gC7RG");
/**
 * A map of functions to check nodes against.
 */ const $21598dc8dcd67346$var$Checks = {
    tag_name (name) {
        if (typeof name === "function") return (elem)=>(0, $iDCDs.isTag)(elem) && name(elem.name);
        else if (name === "*") return 0, $iDCDs.isTag;
        return (elem)=>(0, $iDCDs.isTag)(elem) && elem.name === name;
    },
    tag_type (type) {
        if (typeof type === "function") return (elem)=>type(elem.type);
        return (elem)=>elem.type === type;
    },
    tag_contains (data) {
        if (typeof data === "function") return (elem)=>(0, $iDCDs.isText)(elem) && data(elem.data);
        return (elem)=>(0, $iDCDs.isText)(elem) && elem.data === data;
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $21598dc8dcd67346$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return (elem)=>(0, $iDCDs.isTag)(elem) && value(elem.attribs[attrib]);
    return (elem)=>(0, $iDCDs.isTag)(elem) && elem.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $21598dc8dcd67346$var$combineFuncs(a, b) {
    return (elem)=>a(elem) || b(elem);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $21598dc8dcd67346$var$compileTest(options) {
    const funcs = Object.keys(options).map((key)=>{
        const value = options[key];
        return Object.prototype.hasOwnProperty.call($21598dc8dcd67346$var$Checks, key) ? $21598dc8dcd67346$var$Checks[key](value) : $21598dc8dcd67346$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($21598dc8dcd67346$var$combineFuncs);
}
function $21598dc8dcd67346$export$7b31db6b5a0b2f32(options, node) {
    const test = $21598dc8dcd67346$var$compileTest(options);
    return test ? test(node) : true;
}
function $21598dc8dcd67346$export$73eac51a39d6b0eb(options, nodes, recurse, limit = Infinity) {
    const test = $21598dc8dcd67346$var$compileTest(options);
    return test ? (0, $gC7RG.filter)(test, nodes, recurse, limit) : [];
}
function $21598dc8dcd67346$export$83595b84fc78b9b4(id, nodes, recurse = true) {
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $gC7RG.findOne)($21598dc8dcd67346$var$getAttribCheck("id", id), nodes, recurse);
}
function $21598dc8dcd67346$export$af941c3c7c3b40f5(tagName, nodes, recurse = true, limit = Infinity) {
    return (0, $gC7RG.filter)($21598dc8dcd67346$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $21598dc8dcd67346$export$764e2797d3aa1cff(className, nodes, recurse = true, limit = Infinity) {
    return (0, $gC7RG.filter)($21598dc8dcd67346$var$getAttribCheck("class", className), nodes, recurse, limit);
}
function $21598dc8dcd67346$export$f5d981e30be5545b(type, nodes, recurse = true, limit = Infinity) {
    return (0, $gC7RG.filter)($21598dc8dcd67346$var$Checks["tag_type"](type), nodes, recurse, limit);
}

});

parcelRegister("aApAQ", function(module, exports) {
$parcel$export(module.exports, "removeSubsets", function () { return $7b511e7cac3304c1$export$171dc294232ebeef; });
$parcel$export(module.exports, "DocumentPosition", function () { return $7b511e7cac3304c1$export$406a59d989e8005a; });
$parcel$export(module.exports, "compareDocumentPosition", function () { return $7b511e7cac3304c1$export$17303b8fea718ecc; });
$parcel$export(module.exports, "uniqueSort", function () { return $7b511e7cac3304c1$export$1c267319665a7e7e; });
parcelRequire("eXmj2");
var $iDCDs = parcelRequire("iDCDs");
function $7b511e7cac3304c1$export$171dc294232ebeef(nodes) {
    let idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        const node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(let ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $7b511e7cac3304c1$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($7b511e7cac3304c1$export$406a59d989e8005a || ($7b511e7cac3304c1$export$406a59d989e8005a = {}));
function $7b511e7cac3304c1$export$17303b8fea718ecc(nodeA, nodeB) {
    const aParents = [];
    const bParents = [];
    if (nodeA === nodeB) return 0;
    let current = (0, $iDCDs.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $iDCDs.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    const maxIdx = Math.min(aParents.length, bParents.length);
    let idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $7b511e7cac3304c1$export$406a59d989e8005a.DISCONNECTED;
    const sharedParent = aParents[idx - 1];
    const siblings = sharedParent.children;
    const aSibling = aParents[idx];
    const bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $7b511e7cac3304c1$export$406a59d989e8005a.FOLLOWING | $7b511e7cac3304c1$export$406a59d989e8005a.CONTAINED_BY;
        return $7b511e7cac3304c1$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $7b511e7cac3304c1$export$406a59d989e8005a.PRECEDING | $7b511e7cac3304c1$export$406a59d989e8005a.CONTAINS;
    return $7b511e7cac3304c1$export$406a59d989e8005a.PRECEDING;
}
function $7b511e7cac3304c1$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter((node, i, arr)=>!arr.includes(node, i + 1));
    nodes.sort((a, b)=>{
        const relative = $7b511e7cac3304c1$export$17303b8fea718ecc(a, b);
        if (relative & $7b511e7cac3304c1$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $7b511e7cac3304c1$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}

});

parcelRegister("4Ue08", function(module, exports) {
$parcel$export(module.exports, "getFeed", function () { return $392740bc828b1f99$export$ad32138c9e09ad4; });

var $fuBcm = parcelRequire("fuBcm");

var $2Rwg3 = parcelRequire("2Rwg3");
function $392740bc828b1f99$export$ad32138c9e09ad4(doc) {
    const feedRoot = $392740bc828b1f99$var$getOneElement($392740bc828b1f99$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $392740bc828b1f99$var$getAtomFeed(feedRoot) : $392740bc828b1f99$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $392740bc828b1f99$var$getAtomFeed(feedRoot) {
    var _a;
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: (0, $2Rwg3.getElementsByTagName)("entry", childs).map((item)=>{
            var _a;
            const { children: children } = item;
            const entry = {
                media: $392740bc828b1f99$var$getMediaElements(children)
            };
            $392740bc828b1f99$var$addConditionally(entry, "id", "id", children);
            $392740bc828b1f99$var$addConditionally(entry, "title", "title", children);
            const href = (_a = $392740bc828b1f99$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            const description = $392740bc828b1f99$var$fetch("summary", children) || $392740bc828b1f99$var$fetch("content", children);
            if (description) entry.description = description;
            const pubDate = $392740bc828b1f99$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $392740bc828b1f99$var$addConditionally(feed, "id", "id", childs);
    $392740bc828b1f99$var$addConditionally(feed, "title", "title", childs);
    const href = (_a = $392740bc828b1f99$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $392740bc828b1f99$var$addConditionally(feed, "description", "subtitle", childs);
    const updated = $392740bc828b1f99$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $392740bc828b1f99$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $392740bc828b1f99$var$getRssFeed(feedRoot) {
    var _a, _b;
    const childs = (_b = (_a = $392740bc828b1f99$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $2Rwg3.getElementsByTagName)("item", feedRoot.children).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $392740bc828b1f99$var$getMediaElements(children)
            };
            $392740bc828b1f99$var$addConditionally(entry, "id", "guid", children);
            $392740bc828b1f99$var$addConditionally(entry, "title", "title", children);
            $392740bc828b1f99$var$addConditionally(entry, "link", "link", children);
            $392740bc828b1f99$var$addConditionally(entry, "description", "description", children);
            const pubDate = $392740bc828b1f99$var$fetch("pubDate", children) || $392740bc828b1f99$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $392740bc828b1f99$var$addConditionally(feed, "title", "title", childs);
    $392740bc828b1f99$var$addConditionally(feed, "link", "link", childs);
    $392740bc828b1f99$var$addConditionally(feed, "description", "description", childs);
    const updated = $392740bc828b1f99$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $392740bc828b1f99$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const $392740bc828b1f99$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
const $392740bc828b1f99$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $392740bc828b1f99$var$getMediaElements(where) {
    return (0, $2Rwg3.getElementsByTagName)("media:content", where).map((elem)=>{
        const { attribs: attribs } = elem;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for (const attrib of $392740bc828b1f99$var$MEDIA_KEYS_STRING)if (attribs[attrib]) media[attrib] = attribs[attrib];
        for (const attrib of $392740bc828b1f99$var$MEDIA_KEYS_INT)if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $392740bc828b1f99$var$getOneElement(tagName, node) {
    return (0, $2Rwg3.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $392740bc828b1f99$var$fetch(tagName, where, recurse = false) {
    return (0, $fuBcm.textContent)((0, $2Rwg3.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $392740bc828b1f99$var$addConditionally(obj, prop, tagName, where, recurse = false) {
    const val = $392740bc828b1f99$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $392740bc828b1f99$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});





parcelRegister("hTage", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b04807a9d06153e2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $dZNgt = parcelRequire("dZNgt");

var $j60mo = parcelRequire("j60mo");

var $lTkkF = parcelRequire("lTkkF");
const $b04807a9d06153e2$var$UniformValueProps = ({ title: title, subtitle: subtitle, cards: cards, mediaAspectRatio: mediaAspectRatio })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedCards = (0, $f2QWG.flattenValues)(cards);
    const renderedCards = flattenedCards.map((card)=>({
            ...card,
            description: card.richTextDescription && !(0, $dZNgt.isRichTextValueConsideredEmpty)(card.richTextDescription) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                uniformRichText: card.richTextDescription.root
            }) : card.description
        }));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j60mo.default), {
        title: title,
        subtitle: subtitle,
        cards: renderedCards,
        mediaAspectRatio: mediaAspectRatio
    });
};
var $b04807a9d06153e2$export$2e2bcd8739ae039 = $b04807a9d06153e2$var$UniformValueProps;

});
parcelRegister("j60mo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $13c7e41ebe801b17$export$2e2bcd8739ae039; });
/* value-props.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $7kals = parcelRequire("7kals");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $jlQlZ = parcelRequire("jlQlZ");
const $13c7e41ebe801b17$var$DEFAULT_CYCLE_DURATION_MS = 6000;
const $13c7e41ebe801b17$var$containerCss = null;
const $13c7e41ebe801b17$var$titleContainerCss = null;
const $13c7e41ebe801b17$var$zeroMarginCss = null;
const $13c7e41ebe801b17$var$mobileSectionCss = null;
const $13c7e41ebe801b17$var$desktopSectionCss = null;
const $13c7e41ebe801b17$var$nonDesktopSectionCss = null;
const $13c7e41ebe801b17$var$mediaCss = null;
const $13c7e41ebe801b17$var$standaloneMediaCss = null;
const $13c7e41ebe801b17$var$cardsRowCss = null;
const $13c7e41ebe801b17$var$cardListCss = null;
const $13c7e41ebe801b17$var$mediaFillCss = null;
const $13c7e41ebe801b17$var$mediaAspectRatio1x1Css = null;
const $13c7e41ebe801b17$var$mediaAspectRatio16x9Css = null;
const $13c7e41ebe801b17$var$mediaContainerCss = null;
const $13c7e41ebe801b17$var$mobileInlineMediaCss = null;
const $13c7e41ebe801b17$var$mediaLayerCss = null;
const $13c7e41ebe801b17$var$mediaLayerActiveCss = null;
const $13c7e41ebe801b17$var$mediaLayerInactiveCss = null;
const $13c7e41ebe801b17$var$fadeUpDelay01Css = null;
const $13c7e41ebe801b17$var$fadeUpDelay02Css = null;
const $13c7e41ebe801b17$var$fadeUpDelay03Css = null;
const $13c7e41ebe801b17$var$mobileCardListWrapperCss = null;
const $13c7e41ebe801b17$var$mobileBottomFadeCss = null;
const $13c7e41ebe801b17$var$mobileBottomFadeVisibleCss = null;
const $13c7e41ebe801b17$var$mobileBottomFadeHiddenCss = null;
const $13c7e41ebe801b17$var$fadeUpCss = null;
// Applied when IO fires — unpauses the fade-up animation
const $13c7e41ebe801b17$var$fadeUpActiveCss = null;
const $13c7e41ebe801b17$var$VideoContent = ({ card: card, isActive: isActive, videoType: videoType, onDuration: onDuration, onPlayingChange: onPlayingChange })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // Once a card has been active AND is in a visible section, keep its
    // <source> permanently so the browser retains buffered video data.
    // Videos inside hidden responsive sections (offsetParent is null)
    // never set hasBeenActive, preventing duplicate downloads.
    const [hasBeenActive, setHasBeenActive] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (isActive && !hasBeenActive) {
            const video = videoRef.current;
            if (video && video.offsetParent !== null) setHasBeenActive(true);
        }
    }, [
        isActive,
        hasBeenActive
    ]);
    // Play when active, pause when inactive.
    // Skip videos inside hidden responsive sections (offsetParent is null
    // when an ancestor has display:none).
    (0, $1oC0p.useEffect)(()=>{
        const video = videoRef.current;
        if (!video) return;
        if (!isActive) {
            video.pause();
            onPlayingChange?.(false);
            return;
        }
        // Don't play videos in hidden responsive sections
        if (video.offsetParent === null) return;
        video.currentTime = 0;
        if (video.readyState >= 1 && video.duration && isFinite(video.duration)) onDuration?.(Math.round(video.duration * 1000));
        onPlayingChange?.(true);
        video.play().catch(()=>{
            onPlayingChange?.(false);
        });
    }, [
        isActive,
        onDuration,
        onPlayingChange
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const video = videoRef.current;
        if (!video) return;
        const handleMetadata = ()=>{
            if (video.duration && isFinite(video.duration)) onDuration?.(Math.round(video.duration * 1000));
        };
        const handlePlaying = ()=>onPlayingChange?.(true);
        const handleNotPlaying = ()=>onPlayingChange?.(false);
        if (video.readyState >= 1) handleMetadata();
        video.addEventListener('loadedmetadata', handleMetadata);
        video.addEventListener('playing', handlePlaying);
        video.addEventListener('pause', handleNotPlaying);
        video.addEventListener('waiting', handleNotPlaying);
        return ()=>{
            video.removeEventListener('loadedmetadata', handleMetadata);
            video.removeEventListener('playing', handlePlaying);
            video.removeEventListener('pause', handleNotPlaying);
            video.removeEventListener('waiting', handleNotPlaying);
        };
    }, [
        onDuration,
        onPlayingChange
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
        ref: videoRef,
        "data-value-props-video": true,
        muted: true,
        loop: true,
        playsInline: true,
        preload: isActive ? 'auto' : 'none',
        "aria-label": isActive ? card.mediaAlt || card.title : undefined,
        "aria-hidden": !isActive,
        className: (0, $2jatx.default)([
            "_1bsb1osq _4t3i1osq _5ral1dfr _1e0c1ule"
        ]),
        children: hasBeenActive && /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
            src: card.videoSrc,
            type: `video/${videoType}`
        })
    });
};
const $13c7e41ebe801b17$var$MediaContent = ({ card: card, isActive: isActive = true, onDuration: onDuration, onPlayingChange: onPlayingChange })=>{
    if (card.imageSrc) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        src: card.imageSrc,
        alt: isActive ? card.mediaAlt || card.title : '',
        "aria-hidden": !isActive,
        className: (0, $2jatx.default)([
            "_1bsb1osq _4t3i1osq _5ral1dfr _1e0c1ule"
        ])
    });
    if (card.videoSrc) {
        const videoFormat = card.videoSrc.split('.').at(-1);
        const videoType = videoFormat === 'webm' ? 'webm' : 'mp4';
        return /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$VideoContent, {
            card: card,
            isActive: isActive,
            videoType: videoType,
            onDuration: onDuration,
            onPlayingChange: onPlayingChange
        });
    }
    return null;
};
const $13c7e41ebe801b17$var$MediaStack = /*#__PURE__*/ (0, $1oC0p.memo)(({ cards: cards, activeIndex: activeIndex, mediaAspectRatio: mediaAspectRatio, onDuration: onDuration, onPlayingChange: onPlayingChange })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _1reo15vq _18m915vq _2rko1ylz",
            mediaAspectRatio === '16 / 9' && "_1h1tcq2i",
            mediaAspectRatio === '1 / 1' && "_1h1t1ekt"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
        },
        children: cards.map((card, index)=>{
            const isCardActive = index === activeIndex;
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": !isCardActive,
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq _tnoq12jn",
                    isCardActive && "_tzy4kb7n",
                    !isCardActive && "_tzy4idpf _lcxvglyw"
                ]),
                style: {
                    "--_1mnvk9u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.400ms')),
                    "--_kqkuu4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-in-out'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$MediaContent, {
                    card: card,
                    isActive: isCardActive,
                    onDuration: isCardActive ? onDuration : undefined,
                    onPlayingChange: isCardActive ? onPlayingChange : undefined
                })
            }, index);
        })
    }));
const $13c7e41ebe801b17$var$CardListItem = /*#__PURE__*/ (0, $1oC0p.memo)(({ card: card, index: index, activeIndex: activeIndex, dataEventProps: dataEventProps, isPlaying: isPlaying, cycleDurationMs: cycleDurationMs, activeVideoDurationMs: activeVideoDurationMs, isActiveVideoPlaying: isActiveVideoPlaying, onCardClick: onCardClick, onAdvance: onAdvance, onPlayPauseToggle: onPlayPauseToggle, mediaTile: mediaTile })=>{
    const isActive = index === activeIndex;
    const onActivate = (0, $1oC0p.useCallback)(()=>onCardClick(index), [
        onCardClick,
        index
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jlQlZ.ValuePropCard), {
                card: card,
                isActive: isActive,
                index: index,
                dataEventProps: dataEventProps,
                onActivate: onActivate,
                isPlaying: isPlaying,
                onAdvance: onAdvance,
                cycleDurationMs: cycleDurationMs,
                activeVideoDurationMs: isActive ? activeVideoDurationMs : null,
                isActiveVideoPlaying: isActive ? isActiveVideoPlaying : false,
                onPlayPauseToggle: onPlayPauseToggle
            }),
            isActive && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule _476dutpp _1rfm1osq _1cro1wwu _wqfn5q54 _1e0r1lkl _dqw81hrf"
                ]),
                style: {
                    "--_1mnvk9u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.400ms')),
                    "--_kqkuu4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-in-out'))
                },
                children: mediaTile
            })
        ]
    });
});
const $13c7e41ebe801b17$var$CardListSection = /*#__PURE__*/ (0, $1oC0p.memo)(({ cards: cards, activeIndex: activeIndex, dataEventProps: dataEventProps, isPlaying: isPlaying, cycleDurationMs: cycleDurationMs, activeVideoDurationMs: activeVideoDurationMs, isActiveVideoPlaying: isActiveVideoPlaying, onCardClick: onCardClick, onAdvance: onAdvance, onPlayPauseToggle: onPlayPauseToggle, mediaTile: mediaTile, ulRef: ulRef, minHeight: minHeight, showMobileFade: showMobileFade })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1fhb _zulppxbi _8164idpf",
            showMobileFade !== undefined && "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                ref: ulRef,
                style: minHeight !== undefined ? {
                    minHeight: minHeight
                } : undefined,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _a64kxy5q _1oyh1wqb"
                ]),
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$CardListItem, {
                        card: card,
                        index: index,
                        activeIndex: activeIndex,
                        dataEventProps: dataEventProps,
                        isPlaying: isPlaying,
                        cycleDurationMs: cycleDurationMs,
                        activeVideoDurationMs: activeVideoDurationMs,
                        isActiveVideoPlaying: isActiveVideoPlaying,
                        onCardClick: onCardClick,
                        onAdvance: onAdvance,
                        onPlayPauseToggle: onPlayPauseToggle,
                        mediaTile: mediaTile
                    }, index))
            }),
            showMobileFade !== undefined && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": true,
                "data-testid": "value-props-mobile-bottom-fade",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf _rjxpidpf _u7coidpf _4t3it9kd _1pbycs5v _11q71m2d _lcxvglyw _181nglyw _tnoq1v0p",
                    showMobileFade ? "_tzy4kb7n" : "_tzy4idpf"
                ]),
                style: {
                    "--_kqkuu4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-in-out'))
                }
            })
        ]
    }));
const $13c7e41ebe801b17$var$ValueProps = ({ title: title, subtitle: subtitle, cards: cards, mediaAspectRatio: mediaAspectRatio = '1 / 1', dataEventProps: dataEventProps, cycleDurationMs: cycleDurationMs = $13c7e41ebe801b17$var$DEFAULT_CYCLE_DURATION_MS })=>{
    // ── State ────────────────────────────────────────────────────────────────
    const [activeIndex, setActiveIndex] = (0, $1oC0p.useState)(0);
    const [isPlaying, setIsPlaying] = (0, $1oC0p.useState)(false);
    const [activeVideoDurationMs, setActiveVideoDurationMs] = (0, $1oC0p.useState)(null);
    const [isActiveVideoPlaying, setIsActiveVideoPlaying] = (0, $1oC0p.useState)(false);
    const [cardListMinHeight, setCardListMinHeight] = (0, $1oC0p.useState)(undefined);
    const [tabletCardListMinHeight, setTabletCardListMinHeight] = (0, $1oC0p.useState)(undefined);
    const [fadeVisible, setFadeVisible] = (0, $1oC0p.useState)(false);
    const [hasEnteredView, setHasEnteredView] = (0, $1oC0p.useState)(false);
    // ── Refs ─────────────────────────────────────────────────────────────────
    const containerRef = (0, $1oC0p.useRef)(null);
    const cardListRef = (0, $1oC0p.useRef)(null);
    const tabletCardListRef = (0, $1oC0p.useRef)(null);
    const { ref: ioRef, inView: inView } = (0, $jKShK.useInView)({
        threshold: 0.35
    });
    const fadeTimerRef = (0, $1oC0p.useRef)(null);
    // ── Effects ──────────────────────────────────────────────────────────────
    (0, $1oC0p.useEffect)(()=>{
        if (inView) {
            setActiveIndex(0);
            setFadeVisible(false);
            setIsPlaying(!(0, $7kals.isReducedMotion)());
            setHasEnteredView(true);
        } else setIsPlaying(false);
    }, [
        inView
    ]);
    (0, $1oC0p.useLayoutEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        const videos = container.querySelectorAll('video[data-value-props-video]');
        videos.forEach((video)=>{
            // Skip videos inside hidden responsive sections (display:none on
            // an ancestor).  offsetParent is null for such elements.
            if (video.offsetParent === null) return;
            if (isPlaying) // eslint-disable-next-line @typescript-eslint/no-empty-function
            video.play().catch(()=>{});
            else video.pause();
        });
    }, [
        isPlaying,
        activeIndex
    ]);
    (0, $1oC0p.useEffect)(()=>{
        setActiveVideoDurationMs(null);
    }, [
        activeIndex
    ]);
    // Track each section's card list max height and lock it as min-height
    // so the column never shrinks when an active card collapses.
    (0, $1oC0p.useEffect)(()=>{
        const observers = [];
        const rafIds = [];
        const watch = (el, setter)=>{
            if (!el) return;
            let rafId = 0;
            const observer = new ResizeObserver(()=>{
                cancelAnimationFrame(rafId);
                rafId = requestAnimationFrame(()=>{
                    const h = el.getBoundingClientRect().height;
                    setter(h);
                });
                rafIds.push(rafId);
            });
            observer.observe(el);
            observers.push(observer);
        };
        watch(cardListRef.current, (h)=>setCardListMinHeight((prev)=>prev === undefined || h > prev ? h : prev));
        watch(tabletCardListRef.current, (h)=>setTabletCardListMinHeight((prev)=>prev === undefined || h > prev ? h : prev));
        return ()=>{
            observers.forEach((o)=>o.disconnect());
            rafIds.forEach((id)=>cancelAnimationFrame(id));
        };
    }, []);
    // ── Handlers ─────────────────────────────────────────────────────────────
    const handleAdvance = (0, $1oC0p.useCallback)(()=>{
        setActiveIndex((prev)=>(prev + 1) % cards.length);
    }, [
        cards.length
    ]);
    const handleCardClick = (0, $1oC0p.useCallback)((index)=>{
        if (index === activeIndex) return;
        setActiveIndex(index);
        setIsPlaying(!(0, $7kals.isReducedMotion)());
        // Mobile bottom fade — manual select only, not auto-advance
        if (!(0, $7kals.isReducedMotion)()) {
            if (fadeTimerRef.current) clearTimeout(fadeTimerRef.current);
            setFadeVisible(true);
            fadeTimerRef.current = setTimeout(()=>{
                setFadeVisible(false);
                fadeTimerRef.current = null;
            }, 1800);
        }
    }, [
        activeIndex
    ]);
    const handlePlayPauseToggle = (0, $1oC0p.useCallback)(()=>{
        setIsPlaying((prev)=>!prev);
    }, []);
    const handleVideoDuration = (0, $1oC0p.useCallback)((ms)=>{
        setActiveVideoDurationMs(ms);
    }, []);
    const handleVideoPlayingChange = (0, $1oC0p.useCallback)((playing)=>{
        setIsActiveVideoPlaying(playing);
    }, []);
    const setContainerRef = (0, $1oC0p.useCallback)((node)=>{
        containerRef.current = node;
        ioRef(node);
    }, [
        ioRef
    ]);
    // ── Early return ─────────────────────────────────────────────────────────
    if (!cards || cards.length === 0) return null;
    const activeCard = cards[activeIndex];
    // Desktop/tablet MediaStack — rendered once, hidden on mobile via
    // standaloneMediaCss.  Shared across the desktop and tablet responsive
    // sections instead of duplicated in each ColumnLayout.
    const desktopMediaContent = activeCard && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _1ul9idpf _1rfm1osq",
            "_sugaglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$MediaStack, {
            cards: cards,
            activeIndex: activeIndex,
            mediaAspectRatio: mediaAspectRatio,
            onDuration: handleVideoDuration,
            onPlayingChange: handleVideoPlayingChange
        })
    });
    // Mobile MediaStack — rendered once inside the mobile section's
    // CardListSection, always mounted so video buffers persist across
    // card switches.  Hidden on tablet/desktop via mobileInlineMediaCss.
    const mobileMediaTile = /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$MediaStack, {
        cards: cards,
        activeIndex: activeIndex,
        mediaAspectRatio: mediaAspectRatio,
        onDuration: handleVideoDuration,
        onPlayingChange: handleVideoPlayingChange
    });
    const sharedCardListProps = {
        cards: cards,
        activeIndex: activeIndex,
        dataEventProps: dataEventProps,
        isPlaying: isPlaying,
        cycleDurationMs: cycleDurationMs,
        activeVideoDurationMs: activeVideoDurationMs,
        isActiveVideoPlaying: isActiveVideoPlaying,
        onCardClick: handleCardClick,
        onAdvance: handleAdvance,
        onPlayPauseToggle: handlePlayPauseToggle,
        mediaTile: null
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: setContainerRef,
        "data-testid": "value-props",
        className: (0, $2jatx.default)([
            "_1rjcys9h _1e0c1txw _2lx21bp4 _zulpxncg _13og16xz _133ixncg _8164xy5q"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                layout: "8-4",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "_1e0c1txw _2lx21bp4 _zulpu2gc _109k8k1a"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "_tzy4idpf _1cro18q0 _wqfn9cwz _1e0r5ucs _dqw8q7pw _1c1qtrqk _bl8a1wwu _2hwzoi7t _1gx9p3kn _3e9gq7pw _1dwqtrqk",
                                    hasEnteredView && "_1c1qo91m _1dwqo91m",
                                    "_ju251yx9"
                                ]),
                                style: {
                                    "--_5u0ty6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.200ms'))
                                },
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "_tzy4idpf _1cro18q0 _wqfn9cwz _1e0r5ucs _dqw8q7pw _1c1qtrqk _bl8a1wwu _2hwzoi7t _1gx9p3kn _3e9gq7pw _1dwqtrqk",
                                    hasEnteredView && "_1c1qo91m _1dwqo91m",
                                    "_ju25fnf5",
                                    "body-lg"
                                ]),
                                style: {
                                    "--_5u0ty6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.200ms'))
                                },
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_tzy4idpf _1cro18q0 _wqfn9cwz _1e0r5ucs _dqw8q7pw _1c1qtrqk _bl8a1wwu _2hwzoi7t _1gx9p3kn _3e9gq7pw _1dwqtrqk",
                    hasEnteredView && "_1c1qo91m _1dwqo91m",
                    subtitle ? "_ju25188d" : "_ju25fnf5"
                ]),
                style: {
                    "--_5u0ty6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.200ms'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _dm251ule"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                            layout: "6-6",
                            verticalAlignment: "center",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$CardListSection, {
                                    ...sharedCardListProps,
                                    ulRef: cardListRef,
                                    minHeight: cardListMinHeight
                                }),
                                desktopMediaContent
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _181n1ule _dm25glyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                            layout: "6-6",
                            verticalAlignment: "center",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$CardListSection, {
                                    ...sharedCardListProps,
                                    ulRef: tabletCardListRef,
                                    minHeight: tabletCardListMinHeight
                                }),
                                desktopMediaContent
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _181nglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                            layout: "6-6",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$CardListSection, {
                                    ...sharedCardListProps,
                                    mediaTile: mobileMediaTile,
                                    showMobileFade: fadeVisible
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _1ul9idpf _1rfm1osq"
                                    ])
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $13c7e41ebe801b17$export$2e2bcd8739ae039 = $13c7e41ebe801b17$var$ValueProps;

});
parcelRegister("jlQlZ", function(module, exports) {
$parcel$export(module.exports, "ValuePropCard", function () { return $46cd2396a421c6d3$export$6de1d248f98ef1d; });
/* value-prop-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iPPTB = parcelRequire("iPPTB");

var $jElRc = parcelRequire("jElRc");

var $kbpa7 = parcelRequire("kbpa7");
const $46cd2396a421c6d3$var$DEFAULT_CYCLE_DURATION_MS = 6000;
const $46cd2396a421c6d3$var$prefersReducedMotion = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $46cd2396a421c6d3$var$cardWrapperCss = null;
const $46cd2396a421c6d3$var$containerCss = null;
const $46cd2396a421c6d3$var$inCardPlayPauseCss = null;
const $46cd2396a421c6d3$var$cardContainerFocusCss = null;
const $46cd2396a421c6d3$var$progressBarContainerCss = null;
const $46cd2396a421c6d3$var$progressBarContainerActiveCss = null;
const $46cd2396a421c6d3$var$progressBarContainerInactiveCss = null;
const $46cd2396a421c6d3$var$barVisibleCss = null;
const $46cd2396a421c6d3$var$barHiddenCss = null;
const $46cd2396a421c6d3$var$progressBarFillKeyframes = null;
const $46cd2396a421c6d3$var$progressBarFillCss = null;
const $46cd2396a421c6d3$var$contentCss = null;
const $46cd2396a421c6d3$var$titleCss = null;
const $46cd2396a421c6d3$var$inactiveTitleCss = null;
const $46cd2396a421c6d3$var$cardHoverTitleCss = null;
const $46cd2396a421c6d3$var$descriptionCss = null;
const $46cd2396a421c6d3$var$linkContainerCss = null;
const $46cd2396a421c6d3$var$bodyExpandCss = null;
const $46cd2396a421c6d3$var$bodyExpandActiveCss = null;
const $46cd2396a421c6d3$var$bodyExpandInactiveCss = null;
const $46cd2396a421c6d3$var$bodyInnerCss = null;
const $46cd2396a421c6d3$var$gradientMaskCss = null;
const $46cd2396a421c6d3$var$gradientMaskVisibleCss = null;
const $46cd2396a421c6d3$var$gradientMaskHiddenCss = null;
function $46cd2396a421c6d3$var$computeFillBarState({ card: card, isActive: isActive, isPlaying: isPlaying, isActiveVideoPlaying: isActiveVideoPlaying, activeVideoDurationMs: activeVideoDurationMs, cycleDurationMs: cycleDurationMs }) {
    const showBar = isActive;
    const fillDurationMs = card.videoSrc && activeVideoDurationMs ? activeVideoDurationMs : cycleDurationMs;
    const isFillBarRunning = card.videoSrc ? isPlaying && isActiveVideoPlaying : isPlaying;
    return {
        showBar: showBar,
        fillDurationMs: fillDurationMs,
        isFillBarRunning: isFillBarRunning
    };
}
const $46cd2396a421c6d3$var$CardBody = /*#__PURE__*/ (0, $1oC0p.memo)(({ card: card, isActive: isActive, dataEventProps: dataEventProps })=>{
    const [isTransitioning, setIsTransitioning] = (0, $1oC0p.useState)(false);
    const isFirstRender = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if ($46cd2396a421c6d3$var$prefersReducedMotion) return;
        setIsTransitioning(true);
        const t = setTimeout(()=>setIsTransitioning(false), 600);
        return ()=>clearTimeout(t);
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1rjcu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3 _v56419rf",
                    !isActive && "_syazly96",
                    `card-title-sm${!isActive ? ' card-inactive-title' : ''}`
                ]),
                style: {
                    "--_m369gh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.250ms')),
                    "--_kqkuu4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-in-out')),
                    "--_1aetymw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light500'))
                },
                children: card.title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                "aria-hidden": !isActive,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c11p5 _1bsb1osq _1reozryt _18m9zryt",
                    isActive ? "_2z05hkll _tzy4kb7n _1pfhu2gc _10t81iqs _xrrpcbtt _1xq5zc05" : "_2z0563bf _tzy4idpf _1pfhidpf"
                ]),
                style: {
                    "--_1qitjtl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease.cubic-out'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1tkeidpf _1reo15vq _18m915vq"
                        ]),
                        children: [
                            card.description && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "body-md"
                                ]),
                                children: card.description
                            }),
                            isActive && card.linkText && card.linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1q51u2gc"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    "aria-label": card.linkText,
                                    text: card.linkText,
                                    href: card.linkHref,
                                    type: "primary",
                                    dataEventProps: dataEventProps,
                                    anchorProps: {
                                        tabIndex: 0
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": true,
                        "data-testid": "value-prop-gradient-mask",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1e02idpf _rjxpidpf _u7coidpf _4t3i1f4h _11q71m2d _lcxvglyw _tnoq1mbg",
                            isTransitioning ? "_tzy4kb7n" : "_tzy4idpf"
                        ])
                    })
                ]
            })
        ]
    });
});
function $46cd2396a421c6d3$var$buildInteractiveProps(isActive, title, onActivate, handleKeyDown) {
    if (isActive) return {
        'aria-label': title
    };
    return {
        role: 'button',
        tabIndex: 0,
        'aria-pressed': false,
        'aria-label': title,
        onClick: onActivate,
        onKeyDown: handleKeyDown
    };
}
const $46cd2396a421c6d3$export$6de1d248f98ef1d = ({ card: card, isActive: isActive, index: index, dataEventProps: dataEventProps, onActivate: onActivate, isPlaying: isPlaying = true, onAdvance: onAdvance, cycleDurationMs: cycleDurationMs = $46cd2396a421c6d3$var$DEFAULT_CYCLE_DURATION_MS, activeVideoDurationMs: activeVideoDurationMs = null, isActiveVideoPlaying: isActiveVideoPlaying = false, onPlayPauseToggle: onPlayPauseToggle, fillColor: fillColor })=>{
    const { showBar: showBar, fillDurationMs: fillDurationMs, isFillBarRunning: isFillBarRunning } = $46cd2396a421c6d3$var$computeFillBarState({
        card: card,
        isActive: isActive,
        isPlaying: isPlaying,
        isActiveVideoPlaying: isActiveVideoPlaying,
        activeVideoDurationMs: activeVideoDurationMs,
        cycleDurationMs: cycleDurationMs
    });
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onActivate?.();
        }
    }, [
        onActivate
    ]);
    const interactiveProps = (0, $1oC0p.useMemo)(()=>$46cd2396a421c6d3$var$buildInteractiveProps(isActive, card.title, onActivate, handleKeyDown), [
        isActive,
        card.title,
        onActivate,
        handleKeyDown
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm",
            !isActive && "_1wnbfb2h _1k3sfb2h"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: [
            isActive && onPlayPauseToggle && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: (el)=>{
                    const button = el?.querySelector('button');
                    if (button) button.tabIndex = 0;
                },
                className: (0, $2jatx.default)([
                    "_kqswpfqs _6rthu2gc _1rqistnw _1ob9idpf _isae1rgy _12ho1ssb _sfej1i34 _1t06u6a3"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                    isPlaying: Boolean(isPlaying),
                    onToggle: onPlayPauseToggle,
                    mediaLabel: card.title
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                "data-testid": `value-prop-card-${index}`,
                "data-active": isActive,
                ...interactiveProps,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _zulppxbi _80omtlke _y3gn1e5h _1bsb1osq",
                    "_1ygb7g83 _1ah3yh40 _1basi2wt"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": !showBar,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsbi2wt _1o9zidpf _2rko1ylz _1reo15vq _18m915vq _kqswh2mm _tnoqol88",
                            isActive && "_bfhk1bjw",
                            !isActive && "_bfhk1j28",
                            showBar && "_tzy4kb7n",
                            !showBar && "_tzy4idpf"
                        ]),
                        style: {
                            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                            "--_m369gh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.250ms')),
                            "--_kqkuu4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-in-out')),
                            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
                        },
                        children: isActive && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            onAnimationEnd: onAdvance,
                            className: (0, $2jatx.default)([
                                "_kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3iidpf _bfhk5hrz _j7hqpi17 _1pglp3kn _1o51q7pw"
                            ]),
                            style: {
                                animationDuration: `${fillDurationMs}ms`,
                                animationPlayState: isFillBarRunning ? 'running' : 'paused',
                                ...fillColor ? {
                                    backgroundColor: fillColor
                                } : undefined,
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($46cd2396a421c6d3$var$CardBody, {
                        card: card,
                        isActive: isActive,
                        dataEventProps: dataEventProps
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("3QKwy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3060f0168074f205$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");
const $3060f0168074f205$var$UniformVariant = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "content"
    });
};
var $3060f0168074f205$export$2e2bcd8739ae039 = $3060f0168074f205$var$UniformVariant;

});

parcelRegister("lEcJc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb51508c51ba651c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");
const $bb51508c51ba651c$var$UniformVariantContainer = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "content"
    });
var $bb51508c51ba651c$export$2e2bcd8739ae039 = $bb51508c51ba651c$var$UniformVariantContainer;

});

parcelRegister("1GX5U", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b0a9b5927ee6753$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $lE15B = parcelRequire("lE15B");
const $3b0a9b5927ee6753$var$UniformVideo = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        ...props
    });
};
var $3b0a9b5927ee6753$export$2e2bcd8739ae039 = $3b0a9b5927ee6753$var$UniformVideo;

});

parcelRegister("fzMpf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ccbd79059002b008$export$2e2bcd8739ae039; });
/* video-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $8e22h = parcelRequire("8e22h");

var $aKeh7 = parcelRequire("aKeh7");

var $1iN19 = parcelRequire("1iN19");

var $kbpa7 = parcelRequire("kbpa7");

var $a83FW = parcelRequire("a83FW");
const $ccbd79059002b008$var$UniformVideoCarousel = ({ videoCarousel: videoCarousel, flattenData: flattenData = true })=>{
    const videoCarouselData = flattenData ? (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $1oC0p.useRef)([]);
    const videoContainerRef = (0, $1oC0p.useRef)(null);
    const [current, setCurrent] = (0, $1oC0p.useState)(0);
    const currentRef = (0, $1oC0p.useRef)(current);
    const [playing, setPlaying] = (0, $1oC0p.useState)(true);
    const [durations, setDurations] = (0, $1oC0p.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $1oC0p.useState)(0);
    // @ts-ignore
    const prevViewportWidth = (0, $1oC0p.useRef)(typeof window !== 'undefined' ? window.innerWidth : 0);
    const [viewportWidth, setViewportWidth] = (0, $1oC0p.useState)(typeof window !== 'undefined' ? window.innerWidth : 0);
    (0, $1oC0p.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]);
    // On-load - set up video durations
    (0, $1oC0p.useEffect)(()=>{
        // Video durations
        videoCarouselData.forEach((_, idx)=>{
            const video = videoRefs.current[idx];
            if (!video) return;
            if (video.readyState >= 1) setDurations((durs)=>{
                const copy = [
                    ...durs
                ];
                copy[idx] = video.duration;
                return copy;
            });
            else video.onloadedmetadata = ()=>{
                setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
            };
        });
    }, [
        videoCarouselData
    ]);
    // Play next video on end, looping
    const handleEnded = ()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    };
    // Pause/play current video
    (0, $1oC0p.useEffect)(()=>{
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]);
    const { firePlayPauseClicked: firePlayPauseClicked, fireTeamSelected: fireTeamSelected } = (0, $a83FW.useVideoCarouselAnalytics)();
    // Pause/play toggle
    const togglePlay = ()=>{
        setPlaying((p)=>{
            firePlayPauseClicked(p ? 'pause' : 'play');
            return !p;
        });
    };
    // Jump to a specific video and start from beginning
    const handleTeamClick = (idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        const team = videoCarouselData[idx]?.team ?? String(idx);
        fireTeamSelected(team);
        setCurrent(idx);
        setPlaying(true);
    };
    const currentDuration = durations[current] || 10;
    // Responsive asset type
    (0, $1oC0p.useEffect)(()=>{
        let resizeTimeout;
        const breakpoints = [
            768,
            1024
        ];
        // Store previous width outside the handler so it persists
        const prevViewportWidth = {
            current: window.innerWidth
        };
        function crossedBreakpoint(prev, curr) {
            return breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        }
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevViewportWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevViewportWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? 'desktop' : viewportWidth >= 768 ? 'tablet' : 'mobile';
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: videoContainerRef,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e021ssb _t9eczr6s",
                    "_1bsb1osq _4t3ieo28 _1vkh124j _tnru1jje"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                    ]),
                    children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                            ref: (el)=>videoRefs.current[idx] = el,
                            src: assetType === 'desktop' ? desktopVideoSrc : assetType === 'tablet' ? tabletVideoSrc : mobileVideoSrc,
                            muted: true,
                            playsInline: true,
                            onEnded: handleEnded,
                            autoPlay: idx === current && playing,
                            controls: false,
                            "aria-label": ariaLabel || intl.formatMessage({
                                id: 'video-carousel.video-label',
                                defaultMessage: '{team} video'
                            }, {
                                team: team
                            }),
                            preload: "auto",
                            poster: (assetType === 'desktop' ? desktopPoster : assetType === 'tablet' ? tabletPoster : mobilePoster) ?? undefined,
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _4t3ieo28 _1vkh124j _tnru1jje",
                                "_1e0c1ule _3um0fb4w _4t3i1n6k _5ral1dfr"
                            ]),
                            style: {
                                "--_t6p2i5": (0, $6ZVlx.default)(idx === current ? 'visible' : 'hidden'),
                                "--_1t4czwq": (0, $6ZVlx.default)(idx === current ? '100%' : 0)
                            }
                        }, team))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _1e0c11p5 _yv0e15eh _1ul9idpf _476dutpp _19d71wug _zzszh9n0"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            onClick: togglePlay,
                            "aria-label": intl.formatMessage(playing ? {
                                id: 'rovo-hero.pause',
                                defaultMessage: 'Pause'
                            } : {
                                id: 'rovo-hero.play',
                                defaultMessage: 'Play'
                            }),
                            "aria-pressed": playing,
                            className: (0, $2jatx.default)([
                                "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1ygb1qgu _1ah3yh40 _1tzgkb7n _1acakb7n"
                            ]),
                            style: {
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_4t3izwfg _1bsbzwfg _bfhk6qu4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr389wr _1tjq269p"
                                ]),
                                style: {
                                    "--_1q70ahv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1000')),
                                    "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800')),
                                    "--_1osm7si": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark300'))
                                },
                                children: playing ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aKeh7))), {
                                    label: intl.formatMessage({
                                        id: 'rovo-hero.pause',
                                        defaultMessage: 'Pause'
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iN19))), {
                                    label: intl.formatMessage({
                                        id: 'rovo-hero.play',
                                        defaultMessage: 'Play'
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq _1ul9idpf _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>handleTeamClick(idx),
                                    "aria-label": intl.formatMessage({
                                        id: 'video-carousel.team-button',
                                        defaultMessage: 'Play {team} video'
                                    }, {
                                        team: team
                                    }),
                                    "aria-pressed": idx === current,
                                    className: (0, $2jatx.default)([
                                        "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1ul9idpf _1o9zkb7n _ect41vau _1wyb1j6v _k48p1fw0 _vwz41k8s _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1ygb1qgu _1ah3yh40",
                                        "_syaz11o1 _d0almf54"
                                    ]),
                                    style: {
                                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                        "--_6ivkis": (0, $6ZVlx.default)(idx === current ? (0, $kbpa7.wacToken)('color.primary.blue') : (0, $kbpa7.wacToken)('color.neutral.light800')),
                                        "--_ly6rcl": (0, $6ZVlx.default)(idx === current ? 'auto' : 'pointer')
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhk6u2e _1mou1ilp",
                                                idx === 0 && "_2rkonggr",
                                                idx === videoCarouselData.length - 1 && "_2rkof82g"
                                            ]),
                                            style: {
                                                "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                                            },
                                            children: idx === current && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3i1osq _1bsb1osq _bfhk5hrz _kqswstnw _1e02idpf _152tidpf",
                                                    "_y44vytlo _1y0c1ru5",
                                                    "fillBar"
                                                ]),
                                                style: {
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                                    "--_1fmqpqp": (0, $6ZVlx.default)(currentDuration, "s"),
                                                    "--_w3huxx": (0, $6ZVlx.default)(playing ? 'running' : 'paused')
                                                }
                                            }, fillBarResetKey)
                                        }),
                                        team
                                    ]
                                }, team))
                        })
                    ]
                })
            })
        ]
    });
};
var $ccbd79059002b008$export$2e2bcd8739ae039 = $ccbd79059002b008$var$UniformVideoCarousel;
const $ccbd79059002b008$var$containerCss = null;
const $ccbd79059002b008$var$videoContainerCss = null;
const $ccbd79059002b008$var$videoDimensionsCss = null;
const $ccbd79059002b008$var$videoCss = null;
const $ccbd79059002b008$var$controlContainerCss = null;
const $ccbd79059002b008$var$barContainerCss = null;
const $ccbd79059002b008$var$buttonCss = null;
const $ccbd79059002b008$var$buttonCirlceCss = null;
const $ccbd79059002b008$var$firstBarCss = null;
const $ccbd79059002b008$var$lastBarCss = null;
const $ccbd79059002b008$var$barbuttonCss = null;
const $ccbd79059002b008$var$barCss = null;
const $ccbd79059002b008$var$fillBarCss = null;
const $ccbd79059002b008$var$fill = null;

});
parcelRegister("a83FW", function(module, exports) {
$parcel$export(module.exports, "useVideoCarouselAnalytics", function () { return $c5c412151d6a4fe0$export$10e1b210df4c0057; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
function $c5c412151d6a4fe0$export$10e1b210df4c0057() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const firePlayPauseClicked = (0, $1oC0p.useCallback)((label)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'playPause',
            source: 'videoCarousel',
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireTeamSelected = (0, $1oC0p.useCallback)((team)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'teamSelector',
            source: 'videoCarousel',
            attributes: {
                team: team
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        firePlayPauseClicked: firePlayPauseClicked,
        fireTeamSelected: fireTeamSelected
    };
}

});


parcelRegister("10B1c", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $282bf8c854158ca1$export$2e2bcd8739ae039; });
/* webinar-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $9Cjg1 = parcelRequire("9Cjg1");

var $hUkOo = parcelRequire("hUkOo");
const $282bf8c854158ca1$var$webinarButtonCss = null;
const $282bf8c854158ca1$var$alignmentCss = {
    center: "_4cvr1h6o",
    start: "_4cvr1y6m"
};
const $282bf8c854158ca1$var$getWebinarMode = (conversionTime)=>{
    if (conversionTime === undefined) return 'scheduled';
    return conversionTime <= Date.now() ? 'on-demand' : 'scheduled';
};
const $282bf8c854158ca1$var$UniformWebinarButton = ({ onDemandConversionDateTime: onDemandConversionDateTime, fullUrlPath: fullUrlPath, alignment: alignment = 'center' })=>{
    const intl = (0, $8e22h.default)();
    const conversionTime = (0, $9Cjg1.getConversionTime)(onDemandConversionDateTime);
    const [mode, setMode] = (0, $1oC0p.useState)(()=>$282bf8c854158ca1$var$getWebinarMode(conversionTime));
    (0, $1oC0p.useEffect)(()=>{
        let timeoutId;
        const updateMode = ()=>{
            const nextMode = $282bf8c854158ca1$var$getWebinarMode(conversionTime);
            setMode(nextMode);
            if (nextMode !== 'scheduled' || conversionTime === undefined) return;
            const remainingTime = conversionTime - Date.now();
            timeoutId = setTimeout(updateMode, Math.min(remainingTime, (0, $9Cjg1.MAX_TIMEOUT_MS)));
        };
        updateMode();
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        conversionTime
    ]);
    const buttonLabel = mode === 'on-demand' ? intl.formatMessage((0, $hUkOo.webinarFormMessages).watchButton) : intl.formatMessage((0, $hUkOo.webinarFormMessages).registerButton);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc",
            $282bf8c854158ca1$var$alignmentCss[alignment]
        ]),
        children: [
            mode === 'scheduled' && conversionTime !== undefined && /*#__PURE__*/ (0, $7VQPk.jsx)("time", {
                dateTime: onDemandConversionDateTime.datetime,
                className: "body-md",
                children: intl.formatDate(conversionTime, {
                    day: 'numeric',
                    month: 'short',
                    weekday: 'short',
                    year: 'numeric'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                href: fullUrlPath,
                variant: mode === 'on-demand' ? 'primary' : 'primary_alt',
                dataEventProps: {
                    'data-product-key': 'uniform',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'webinar',
                    'data-event': 'clicked'
                },
                children: buttonLabel
            })
        ]
    });
};
var $282bf8c854158ca1$export$2e2bcd8739ae039 = $282bf8c854158ca1$var$UniformWebinarButton;

});
parcelRegister("9Cjg1", function(module, exports) {
$parcel$export(module.exports, "MAX_TIMEOUT_MS", function () { return $064d1e2cd0014c59$export$b88a0020a1dbd8e7; });
$parcel$export(module.exports, "getConversionTime", function () { return $064d1e2cd0014c59$export$cf265889abadf770; });
$parcel$export(module.exports, "default", function () { return $064d1e2cd0014c59$export$2e2bcd8739ae039; });
/* webinar-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hhv63 = parcelRequire("hhv63");

var $5Ntyw = parcelRequire("5Ntyw");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $eRzlV = parcelRequire("eRzlV");

var $9rnwe = parcelRequire("9rnwe");

var $27bq5 = parcelRequire("27bq5");

var $hUkOo = parcelRequire("hUkOo");

var $feb0S = parcelRequire("feb0S");

var $eCT8P = parcelRequire("eCT8P");
const $064d1e2cd0014c59$var$WEBINAR_ENDPOINT = '/endpoint/webinarsignup/bigmarker';
const $064d1e2cd0014c59$var$STAGING_WAC_ORIGIN = 'https://wac.stg.internal.atlassian.com';
const $064d1e2cd0014c59$var$STAGING_WAC_HOSTNAMES = new Set([
    '127.0.0.1',
    'localhost',
    'wac-web.stg-east.frontend.public.atl-paas.net'
]);
const $064d1e2cd0014c59$var$REGISTRATION_TIMEOUT_MS = 15000;
const $064d1e2cd0014c59$var$CONSENT_TIMEOUT_MS = 5000;
const $064d1e2cd0014c59$export$b88a0020a1dbd8e7 = 2147483647;
const $064d1e2cd0014c59$var$DEFAULT_ANALYTICS_LABEL = 'Webinar form';
const $064d1e2cd0014c59$var$EMPTY_VALUES = {
    firstName: '',
    lastName: '',
    company: '',
    department: '',
    jobTitle: '',
    email: '',
    phone: '',
    companySize: '',
    country: '',
    eventId: '',
    alternateEmail: '',
    marketingOptIn: false
};
const $064d1e2cd0014c59$var$formCss = null;
const $064d1e2cd0014c59$var$headingCss = null;
const $064d1e2cd0014c59$var$fieldsCss = null;
const $064d1e2cd0014c59$var$fieldCss = null;
const $064d1e2cd0014c59$var$fullWidthFieldCss = null;
const $064d1e2cd0014c59$var$labelCss = null;
const $064d1e2cd0014c59$var$requiredIndicatorCss = null;
const $064d1e2cd0014c59$var$controlCss = null;
const $064d1e2cd0014c59$var$selectCss = null;
const $064d1e2cd0014c59$var$errorCss = null;
const $064d1e2cd0014c59$var$sessionFieldsetCss = null;
const $064d1e2cd0014c59$var$legendCss = null;
const $064d1e2cd0014c59$var$sessionOptionCss = null;
const $064d1e2cd0014c59$var$radioCss = null;
const $064d1e2cd0014c59$var$singleSessionCss = null;
const $064d1e2cd0014c59$var$disclosureCss = null;
const $064d1e2cd0014c59$var$checkboxLabelCss = null;
const $064d1e2cd0014c59$var$checkboxCss = null;
const $064d1e2cd0014c59$var$privacyLinkCss = null;
const $064d1e2cd0014c59$var$alertCss = null;
const $064d1e2cd0014c59$var$visuallyHiddenCss = null;
const $064d1e2cd0014c59$var$RequiredIndicator = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_syaz1d19 _1e0c1nu9 _bozgv77o _s7n41q9y"
        ]),
        style: {
            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
        },
        children: "*"
    });
const $064d1e2cd0014c59$var$FieldShell = ({ id: id, label: label, error: error, fullWidth: fullWidth = false, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul9idpf",
            fullWidth && "_1e3cjvu9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                htmlFor: id,
                className: (0, $2jatx.default)([
                    "_1wyboxwj _k48pbfng _vwz41k92"
                ]),
                children: [
                    label,
                    /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$RequiredIndicator, {})
                ]
            }),
            children,
            error && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                id: `${id}-error`,
                className: (0, $2jatx.default)([
                    "_syaz1d19 _1wyboqnp _k48p1nn1 _vwz41cby"
                ]),
                style: {
                    "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                },
                children: error
            })
        ]
    });
const $064d1e2cd0014c59$var$TextField = ({ id: id, field: field, label: label, value: value, error: error, autoComplete: autoComplete, fullWidth: fullWidth = false, type: type = 'text', onChange: onChange })=>/*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$FieldShell, {
        id: id,
        label: label,
        error: error,
        fullWidth: fullWidth,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
            "aria-describedby": error ? `${id}-error` : undefined,
            "aria-invalid": Boolean(error),
            autoComplete: autoComplete,
            "data-field": field,
            id: id,
            name: field,
            onChange: onChange,
            required: true,
            type: type,
            value: value,
            className: (0, $2jatx.default)([
                "_r06hglyw _bfhk1afi _19it79pa _2rko1ylz _vchhusvi _syaz1pfd _1e0c1ule _ect4z4z1 _1wyb1j6v _k48p1nn1 _vwz41k8s _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1osq _1tke1jfw _1ul9idpf _1yt4s8vo _1bsb1osq _858u5hrz _7ehi1ju4 _nt751r31 _49pcglyw _1hvw1o36 _srxe1d19 _1qo0p6ku"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
            }
        })
    });
const $064d1e2cd0014c59$export$cf265889abadf770 = (onDemandConversionDateTime)=>{
    const dateTime = typeof onDemandConversionDateTime === 'string' ? onDemandConversionDateTime : onDemandConversionDateTime?.datetime;
    if (typeof dateTime !== 'string') return undefined;
    const conversionTime = Date.parse(dateTime);
    return Number.isNaN(conversionTime) ? undefined : conversionTime;
};
const $064d1e2cd0014c59$var$parseWallClockDate = (dateTime)=>{
    const match = /^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})T(?<hour>\d{2}):(?<minute>\d{2})(?::(?<second>\d{2}))?/.exec(dateTime);
    if (!match?.groups) return undefined;
    const { year: year, month: month, day: day, hour: hour, minute: minute, second: second = '0' } = match.groups;
    const date = new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second));
    const hasMatchingComponents = date.getFullYear() === Number(year) && date.getMonth() === Number(month) - 1 && date.getDate() === Number(day) && date.getHours() === Number(hour) && date.getMinutes() === Number(minute) && date.getSeconds() === Number(second);
    return hasMatchingComponents ? date : undefined;
};
const $064d1e2cd0014c59$var$formatSessionDate = (date, formatDate)=>{
    const dateOptions = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    };
    const timeOptions = {
        hour: 'numeric',
        minute: '2-digit'
    };
    return {
        dateLabel: formatDate(date, dateOptions),
        timeLabel: formatDate(date, timeOptions)
    };
};
const $064d1e2cd0014c59$var$getStructuredSessionDate = (session, formatDate)=>{
    const structuredDateTime = typeof session.date === 'string' ? session.date : session.date?.datetime;
    if (!structuredDateTime) return undefined;
    const parsedDate = $064d1e2cd0014c59$var$parseWallClockDate(structuredDateTime);
    if (!parsedDate) return undefined;
    return $064d1e2cd0014c59$var$formatSessionDate(parsedDate, formatDate);
};
const $064d1e2cd0014c59$var$getSessionDisplayLabel = (session, formatDate)=>{
    const structuredDate = $064d1e2cd0014c59$var$getStructuredSessionDate(session, formatDate);
    const timezoneCity = session.timezoneCity?.trim();
    if (structuredDate) {
        const timeLabel = timezoneCity ? `${structuredDate.timeLabel} ${timezoneCity}` : session.timeCityLabel?.trim() || structuredDate.timeLabel;
        return `${structuredDate.dateLabel} \u{2014} ${timeLabel}`;
    }
    const dateLabel = session.dateLabel?.trim() ?? '';
    const timeCityLabel = timezoneCity || session.timeCityLabel?.trim();
    return `${dateLabel}${dateLabel && timeCityLabel ? ` \u{2014} ${timeCityLabel}` : ''}`;
};
const $064d1e2cd0014c59$var$getWebinarEndpoint = ()=>{
    if (typeof window === 'undefined') return $064d1e2cd0014c59$var$WEBINAR_ENDPOINT;
    const hostname = window.location.hostname.toLowerCase();
    return $064d1e2cd0014c59$var$STAGING_WAC_HOSTNAMES.has(hostname) ? `${$064d1e2cd0014c59$var$STAGING_WAC_ORIGIN}${$064d1e2cd0014c59$var$WEBINAR_ENDPOINT}` : $064d1e2cd0014c59$var$WEBINAR_ENDPOINT;
};
const $064d1e2cd0014c59$var$withTimeout = async (promise, timeoutMs)=>{
    let timeoutId;
    const timeoutPromise = new Promise((_, reject)=>{
        timeoutId = setTimeout(()=>reject(new Error('Request timed out')), timeoutMs);
    });
    try {
        return await Promise.race([
            promise,
            timeoutPromise
        ]);
    } finally{
        if (timeoutId) clearTimeout(timeoutId);
    }
};
const $064d1e2cd0014c59$var$postRegistration = async (payload)=>{
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), $064d1e2cd0014c59$var$REGISTRATION_TIMEOUT_MS);
    try {
        const response = await fetch($064d1e2cd0014c59$var$getWebinarEndpoint(), {
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            signal: controller.signal
        });
        if (!response.ok) throw new Error(`Webinar registration failed with status ${response.status}`);
        const data = await response.json();
        if (typeof data.conference_url !== 'string' || !data.conference_url) throw new Error('Webinar registration response did not include a conference URL');
        return data.conference_url;
    } finally{
        clearTimeout(timeoutId);
    }
};
const $064d1e2cd0014c59$var$WebinarFormContent = ({ label: label, onDemandConversionDateTime: onDemandConversionDateTime, showPhone: showPhone = false, blockPersonalEmails: blockPersonalEmails = false, alignment: alignment = 'start', buttonVariant: buttonVariant = 'primary', sessions: sessions = [] })=>{
    const intl = (0, $8e22h.default)();
    const { locale: waeLocale } = (0, $9rnwe.useWAEContext)();
    const locale = waeLocale ?? intl.locale;
    const language = locale.toLowerCase().split(/[-_]/)[0] ?? 'en';
    const isJapanese = language === 'ja';
    const privacyPolicyHref = (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy');
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const consentConfig = (0, $hhv63.useConsentHubClientConfig)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const formRef = (0, $1oC0p.useRef)(null);
    const serverErrorRef = (0, $1oC0p.useRef)(null);
    const submitInFlightRef = (0, $1oC0p.useRef)(false);
    const idPrefix = (0, $1oC0p.useId)().replace(/:/g, '');
    const [mode, setMode] = (0, $1oC0p.useState)();
    const [hasInitialized, setHasInitialized] = (0, $1oC0p.useState)(false);
    const [values, setValues] = (0, $1oC0p.useState)($064d1e2cd0014c59$var$EMPTY_VALUES);
    const [errors, setErrors] = (0, $1oC0p.useState)({});
    const [serverError, setServerError] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const { flattenedSessions: flattenedSessions, hasSessionWithoutDate: hasSessionWithoutDate } = (0, $1oC0p.useMemo)(()=>{
        const flattened = (0, $f2QWG.flattenValues)(sessions) ?? [];
        const normalized = flattened.map((session, index)=>session ?? sessions[index]);
        const withDisplayLabels = normalized.map((session)=>session ? {
                ...session,
                displayLabel: $064d1e2cd0014c59$var$getSessionDisplayLabel(session, intl.formatDate)
            } : undefined);
        return {
            flattenedSessions: withDisplayLabels.filter((session)=>typeof session?.eventId === 'string' && Boolean(session.eventId.trim()) && Boolean(session.displayLabel)),
            hasSessionWithoutDate: withDisplayLabels.some((session)=>typeof session?.eventId === 'string' && Boolean(session.eventId.trim()) && !session.displayLabel)
        };
    }, [
        intl.formatDate,
        sessions
    ]);
    const hasMalformedConfiguration = flattenedSessions.length === 0 || flattenedSessions.length !== sessions.length;
    const hasMultipleSessions = mode === 'scheduled' && flattenedSessions.length > 1;
    const selectedSession = flattenedSessions.find((session)=>session.eventId === values.eventId) ?? flattenedSessions[0];
    const analyticsLabel = label?.trim() || $064d1e2cd0014c59$var$DEFAULT_ANALYTICS_LABEL;
    const countries = (0, $1oC0p.useMemo)(()=>(0, $feb0S.getWebinarCountryOptions)(intl, isJapanese), [
        intl,
        isJapanese
    ]);
    const alignedContentCss = null;
    const conversionTime = $064d1e2cd0014c59$export$cf265889abadf770(onDemandConversionDateTime);
    (0, $1oC0p.useEffect)(()=>{
        let timeoutId;
        const updateMode = ()=>{
            if (conversionTime === undefined) {
                setMode(undefined);
                return;
            }
            const remainingTime = conversionTime - Date.now();
            if (remainingTime <= 0) {
                setMode('on-demand');
                return;
            }
            setMode('scheduled');
            timeoutId = setTimeout(updateMode, Math.min(remainingTime, $064d1e2cd0014c59$export$b88a0020a1dbd8e7));
        };
        updateMode();
        setHasInitialized(true);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        conversionTime
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const firstEventId = flattenedSessions[0]?.eventId ?? '';
        setValues((current)=>current.eventId === firstEventId ? current : {
                ...current,
                eventId: firstEventId
            });
    }, [
        flattenedSessions
    ]);
    const getId = (field)=>`${idPrefix}-webinar-${field}`;
    const clearFieldError = (field)=>{
        setErrors((current)=>{
            if (!current[field]) return current;
            const next = {
                ...current
            };
            delete next[field];
            return next;
        });
    };
    const updateTextValue = (field)=>(event)=>{
            setValues((current)=>({
                    ...current,
                    [field]: event.target.value
                }));
            clearFieldError(field);
        };
    const updateSelectValue = (field)=>(event)=>{
            setValues((current)=>({
                    ...current,
                    [field]: event.target.value
                }));
            clearFieldError(field);
        };
    const focusFirstError = (validationErrors)=>{
        const firstError = Object.keys(validationErrors)[0];
        if (firstError) requestAnimationFrame(()=>{
            formRef.current?.querySelector(`[data-field="${firstError}"]`)?.focus();
        });
    };
    const fireTerminalAnalytics = (status, eventId, currentMode)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'submitted',
            actionSubject: 'form',
            actionSubjectId: 'webinarForm',
            source: 'uniform',
            attributes: {
                label: analyticsLabel,
                status: status,
                eventId: eventId,
                mode: currentMode,
                sessionCount: flattenedSessions.length
            }
        }).fire();
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (submitInFlightRef.current || !mode || !selectedSession || hasMalformedConfiguration) return;
        if (values.alternateEmail) return;
        const validationErrors = (0, $eCT8P.validateWebinarForm)(values, {
            blockPersonalEmails: blockPersonalEmails,
            hasMultipleSessions: hasMultipleSessions,
            isJapanese: isJapanese,
            messages: {
                businessEmail: (domain)=>intl.formatMessage((0, $hUkOo.webinarFormMessages).businessEmail, {
                        domain: domain
                    }),
                invalidEmail: intl.formatMessage((0, $hUkOo.webinarFormMessages).invalidEmail),
                required: intl.formatMessage((0, $hUkOo.webinarFormMessages).required)
            },
            showPhone: showPhone
        });
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length) {
            focusFirstError(validationErrors);
            return;
        }
        submitInFlightRef.current = true;
        setIsSubmitting(true);
        setServerError(false);
        const eventId = selectedSession.eventId;
        const payload = {
            eventId: eventId,
            email: values.email.trim(),
            firstName: values.firstName.trim(),
            lastName: values.lastName.trim(),
            job_title: values.jobTitle.trim(),
            country: values.country,
            company_size: values.companySize,
            currLanguage: language,
            addCompanyName: true,
            addPhoneNumber: showPhone,
            ...isJapanese ? {
                department: values.department.trim()
            } : {},
            company: values.company.trim(),
            ...showPhone ? {
                phone: values.phone.trim()
            } : {},
            ...(0, $27bq5.getWebinarUtmAttribution)()
        };
        const privacyPolicyText = intl.formatMessage((0, $hUkOo.webinarFormMessages).privacyDisclosure);
        const consentLabelText = intl.formatMessage((0, $hUkOo.webinarFormMessages).marketingOptIn);
        const consentPromise = $064d1e2cd0014c59$var$withTimeout((0, $hhv63.updatePreferences)(stargateClient, {
            consentCheckboxValue: values.marketingOptIn,
            consentLabelText: consentLabelText,
            email: values.email.trim(),
            formId: 'webinarForm',
            formUrl: window.location.href,
            locale: locale,
            paramsLocale: locale,
            privacyPolicyText: privacyPolicyText,
            site: 'atlassian',
            source: 'uniform'
        }, consentConfig), $064d1e2cd0014c59$var$CONSENT_TIMEOUT_MS).catch(()=>undefined);
        try {
            const [conferenceUrl] = await Promise.all([
                $064d1e2cd0014c59$var$postRegistration(payload),
                consentPromise
            ]);
            fireTerminalAnalytics('success', eventId, mode);
            if (isJapanese) {
                const analyticsWindow = window;
                analyticsWindow.dataLayer = analyticsWindow.dataLayer ?? [];
                analyticsWindow.dataLayer.push({
                    event: 'JapanWebinarRegistration',
                    id: eventId
                });
            }
            window.location.assign(conferenceUrl);
        } catch  {
            setServerError(true);
            fireTerminalAnalytics('error', eventId, mode);
            requestAnimationFrame(()=>serverErrorRef.current?.focus());
        } finally{
            submitInFlightRef.current = false;
            setIsSubmitting(false);
        }
    };
    if (!hasInitialized) return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        "aria-live": "polite",
        children: intl.formatMessage((0, $hUkOo.webinarFormMessages).initializing)
    });
    if (!mode || hasMalformedConfiguration || !selectedSession) {
        if ((0, $eRzlV.isProduction)()) return null;
        return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            role: "alert",
            children: intl.formatMessage(hasSessionWithoutDate ? (0, $hUkOo.webinarFormMessages).sessionDateConfigurationError : (0, $hUkOo.webinarFormMessages).configurationError)
        });
    }
    const heading = mode === 'on-demand' ? intl.formatMessage((0, $hUkOo.webinarFormMessages).onDemandHeading) : intl.formatMessage((0, $hUkOo.webinarFormMessages).registerHeading);
    const submitLabel = mode === 'on-demand' ? intl.formatMessage((0, $hUkOo.webinarFormMessages).watchButton) : intl.formatMessage((0, $hUkOo.webinarFormMessages).registerButton);
    const showMarketingOptIn = Boolean(consentConfig.localeRequiresMarketingCommunicationOptIn);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            "data-testid": "uniform-webinar-form",
            className: (0, $2jatx.default)([
                "_syaz1pfd _ect4z4z1 _1bsb1osq"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_18s81km1 _3dt51fw0",
                        "_y3gnoues",
                        "body-md bold"
                    ]),
                    style: {
                        "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
                    },
                    children: heading
                }),
                mode === 'scheduled' && flattenedSessions.length === 1 && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_k48pni7l _18s81km1",
                        "_y3gnoues"
                    ]),
                    style: {
                        "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
                    },
                    children: selectedSession.displayLabel
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                    autoComplete: "on",
                    noValidate: true,
                    onSubmit: handleSubmit,
                    ref: formRef,
                    children: [
                        hasMultipleSessions && /*#__PURE__*/ (0, $7VQPk.jsxs)("fieldset", {
                            "aria-describedby": errors.eventId ? `${getId('eventId')}-error` : undefined,
                            className: (0, $2jatx.default)([
                                "_19itidpf _18s81km1 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("legend", {
                                    className: (0, $2jatx.default)([
                                        "_1wyb1j6v _k48pni7l _6rthutpp _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                    ]),
                                    children: [
                                        intl.formatMessage((0, $hUkOo.webinarFormMessages).sessionLegend),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$RequiredIndicator, {})
                                    ]
                                }),
                                flattenedSessions.map((session)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                                        className: (0, $2jatx.default)([
                                            "_4cvr1y6m _80omtlke _1e0c1txw _zulpu2gc _6rthu2gc"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                                checked: values.eventId === session.eventId,
                                                "data-field": "eventId",
                                                name: "eventId",
                                                onChange: ()=>{
                                                    setValues((current)=>({
                                                            ...current,
                                                            eventId: session.eventId
                                                        }));
                                                    clearFieldError('eventId');
                                                },
                                                required: true,
                                                type: "radio",
                                                value: session.eventId,
                                                className: (0, $2jatx.default)([
                                                    "_12yz5hrz _4t3iv47k _18s81c53 _1bsbv47k"
                                                ]),
                                                style: {
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: session.displayLabel
                                            })
                                        ]
                                    }, session.eventId)),
                                errors.eventId && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    id: `${getId('eventId')}-error`,
                                    className: (0, $2jatx.default)([
                                        "_syaz1d19 _1wyboqnp _k48p1nn1 _vwz41cby"
                                    ]),
                                    style: {
                                        "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                    },
                                    children: errors.eventId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            "data-testid": "webinar-form-fields",
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _zulppxbi _yv0ehkll _1rqt9sye"
                            ]),
                            children: [
                                isJapanese ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$TextField, {
                                            autoComplete: "family-name",
                                            error: errors.lastName,
                                            field: "lastName",
                                            id: getId('lastName'),
                                            label: intl.formatMessage((0, $hUkOo.webinarFormMessages).lastName),
                                            onChange: updateTextValue('lastName'),
                                            value: values.lastName
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$TextField, {
                                            autoComplete: "given-name",
                                            error: errors.firstName,
                                            field: "firstName",
                                            id: getId('firstName'),
                                            label: intl.formatMessage((0, $hUkOo.webinarFormMessages).firstName),
                                            onChange: updateTextValue('firstName'),
                                            value: values.firstName
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$TextField, {
                                            autoComplete: "given-name",
                                            error: errors.firstName,
                                            field: "firstName",
                                            id: getId('firstName'),
                                            label: intl.formatMessage((0, $hUkOo.webinarFormMessages).firstName),
                                            onChange: updateTextValue('firstName'),
                                            value: values.firstName
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$TextField, {
                                            autoComplete: "family-name",
                                            error: errors.lastName,
                                            field: "lastName",
                                            id: getId('lastName'),
                                            label: intl.formatMessage((0, $hUkOo.webinarFormMessages).lastName),
                                            onChange: updateTextValue('lastName'),
                                            value: values.lastName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$TextField, {
                                    autoComplete: "email",
                                    error: errors.email,
                                    field: "email",
                                    fullWidth: true,
                                    id: getId('email'),
                                    label: intl.formatMessage((0, $hUkOo.webinarFormMessages).email),
                                    onChange: updateTextValue('email'),
                                    type: "email",
                                    value: values.email
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$TextField, {
                                    autoComplete: "organization",
                                    error: errors.company,
                                    field: "company",
                                    id: getId('company'),
                                    label: intl.formatMessage((0, $hUkOo.webinarFormMessages).company),
                                    onChange: updateTextValue('company'),
                                    value: values.company
                                }),
                                isJapanese && /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$TextField, {
                                    autoComplete: "organization-title",
                                    error: errors.department,
                                    field: "department",
                                    id: getId('department'),
                                    label: intl.formatMessage((0, $hUkOo.webinarFormMessages).department),
                                    onChange: updateTextValue('department'),
                                    value: values.department
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$TextField, {
                                    autoComplete: "organization-title",
                                    error: errors.jobTitle,
                                    field: "jobTitle",
                                    id: getId('jobTitle'),
                                    label: intl.formatMessage((0, $hUkOo.webinarFormMessages).jobTitle),
                                    onChange: updateTextValue('jobTitle'),
                                    value: values.jobTitle
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$FieldShell, {
                                    error: errors.companySize,
                                    id: getId('companySize'),
                                    label: intl.formatMessage((0, $hUkOo.webinarFormMessages).companySize),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                                        "aria-describedby": errors.companySize ? `${getId('companySize')}-error` : undefined,
                                        "aria-invalid": Boolean(errors.companySize),
                                        "data-field": "companySize",
                                        id: getId('companySize'),
                                        name: "company_size",
                                        onChange: updateSelectValue('companySize'),
                                        required: true,
                                        value: values.companySize,
                                        className: (0, $2jatx.default)([
                                            "_r06hglyw _bfhk1afi _19it79pa _2rko1ylz _vchhusvi _syaz1pfd _1e0c1ule _ect4z4z1 _1wyb1j6v _k48p1nn1 _vwz41k8s _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1osq _1tke1jfw _1ul9idpf _1yt4s8vo _1bsb1osq _858u5hrz _7ehi1ju4 _nt751r31 _49pcglyw _1hvw1o36 _srxe1d19 _1qo0p6ku",
                                            "_1itkq0nh _ouxl1vge _12vemgnk _1lrw1u5s _y4tixy5q"
                                        ]),
                                        style: {
                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                                            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                                disabled: true,
                                                value: "",
                                                children: intl.formatMessage((0, $hUkOo.webinarFormMessages).selectOption)
                                            }),
                                            (0, $feb0S.WEBINAR_COMPANY_SIZES).map((companySize)=>/*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                                    value: companySize,
                                                    children: companySize
                                                }, companySize))
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$FieldShell, {
                                    error: errors.country,
                                    id: getId('country'),
                                    label: intl.formatMessage((0, $hUkOo.webinarFormMessages).country),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                                        "aria-describedby": errors.country ? `${getId('country')}-error` : undefined,
                                        "aria-invalid": Boolean(errors.country),
                                        autoComplete: "country-name",
                                        "data-field": "country",
                                        id: getId('country'),
                                        name: "country",
                                        onChange: updateSelectValue('country'),
                                        required: true,
                                        value: values.country,
                                        className: (0, $2jatx.default)([
                                            "_r06hglyw _bfhk1afi _19it79pa _2rko1ylz _vchhusvi _syaz1pfd _1e0c1ule _ect4z4z1 _1wyb1j6v _k48p1nn1 _vwz41k8s _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1osq _1tke1jfw _1ul9idpf _1yt4s8vo _1bsb1osq _858u5hrz _7ehi1ju4 _nt751r31 _49pcglyw _1hvw1o36 _srxe1d19 _1qo0p6ku",
                                            "_1itkq0nh _ouxl1vge _12vemgnk _1lrw1u5s _y4tixy5q"
                                        ]),
                                        style: {
                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                                            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                                disabled: true,
                                                value: "",
                                                children: intl.formatMessage((0, $hUkOo.webinarFormMessages).selectOption)
                                            }),
                                            countries.map(({ value: value, label: countryLabel })=>/*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                                    value: value,
                                                    children: countryLabel
                                                }, value))
                                        ]
                                    })
                                }),
                                showPhone && /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$TextField, {
                                    autoComplete: "tel",
                                    error: errors.phone,
                                    field: "phone",
                                    id: getId('phone'),
                                    label: intl.formatMessage((0, $hUkOo.webinarFormMessages).phone),
                                    onChange: updateTextValue('phone'),
                                    type: "tel",
                                    value: values.phone
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            "aria-hidden": "true",
                            className: (0, $2jatx.default)([
                                "_4t3it94y _1e021cib _1reo15vq _18m915vq _kqswstnw _1bsbt94y"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                    htmlFor: getId('alternateEmail'),
                                    children: intl.formatMessage((0, $hUkOo.webinarFormMessages).alternateEmail)
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    autoComplete: "off",
                                    id: getId('alternateEmail'),
                                    name: "alternate_email",
                                    onChange: updateTextValue('alternateEmail'),
                                    tabIndex: -1,
                                    type: "text",
                                    value: values.alternateEmail
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                            className: (0, $2jatx.default)([
                                "_1wyboxwj _vwz41k92 _18s81hxf",
                                "_y3gnoues"
                            ]),
                            style: {
                                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
                            },
                            children: [
                                intl.formatMessage((0, $hUkOo.webinarFormMessages).privacyDisclosure),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: privacyPolicyHref,
                                    className: (0, $2jatx.default)([
                                        "_syaz5hrz _ahbq1b66"
                                    ]),
                                    style: {
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                    },
                                    children: intl.formatMessage((0, $hUkOo.webinarFormMessages).privacyPolicy)
                                }),
                                "."
                            ]
                        }),
                        showMarketingOptIn && /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                            className: (0, $2jatx.default)([
                                "_4cvr1y6m _1e0c1txw _1wyboxwj _zulpu2gc _vwz41k92 _6rthpxbi"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    checked: values.marketingOptIn,
                                    onChange: (event)=>setValues((current)=>({
                                                ...current,
                                                marketingOptIn: event.target.checked
                                            })),
                                    type: "checkbox",
                                    className: (0, $2jatx.default)([
                                        "_12yz5hrz _16jlidpf _1o9zidpf _i0dl1wug _4t3ipxbi _18s81c53 _1bsbpxbi"
                                    ]),
                                    style: {
                                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                    }
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: intl.formatMessage((0, $hUkOo.webinarFormMessages).marketingOptIn)
                                })
                            ]
                        }),
                        serverError && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            ref: serverErrorRef,
                            role: "alert",
                            tabIndex: -1,
                            className: (0, $2jatx.default)([
                                "_syaz1d19 _1moupxbi",
                                "_y3gnoues"
                            ]),
                            style: {
                                "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
                            },
                            children: intl.formatMessage((0, $hUkOo.webinarFormMessages).submitError)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gnoues"
                            ]),
                            style: {
                                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                isDisabled: isSubmitting,
                                isLoading: isSubmitting,
                                size: "large",
                                type: "submit",
                                variant: buttonVariant,
                                children: submitLabel
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $064d1e2cd0014c59$var$UniformWebinarForm = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($064d1e2cd0014c59$var$WebinarFormContent, {
            ...props
        })
    });
var $064d1e2cd0014c59$export$2e2bcd8739ae039 = $064d1e2cd0014c59$var$UniformWebinarForm;

});
parcelRegister("27bq5", function(module, exports) {
$parcel$export(module.exports, "getWebinarUtmAttribution", function () { return $6d5db2a3857b353c$export$4f0802f6ad9af800; });

var $2gCne = parcelRequire("2gCne");
const $6d5db2a3857b353c$var$EMPTY_ATTRIBUTION = {
    'utm_sfdc-campaign-id': '',
    utm_source: '',
    utm_bmcr_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_content: ''
};
const $6d5db2a3857b353c$var$URL_KEYS = [
    'utm_sfdc-campaign_id',
    'utm_source',
    'utm_bmcr_source',
    'utm_medium',
    'utm_campaign',
    'utm_content'
];
const $6d5db2a3857b353c$var$asString = (value)=>typeof value === 'string' ? value : '';
const $6d5db2a3857b353c$var$getUrlAttribution = (params)=>({
        'utm_sfdc-campaign-id': params.get('utm_sfdc-campaign_id') ?? '',
        utm_source: params.get('utm_source') ?? '',
        utm_bmcr_source: params.get('utm_bmcr_source') ?? '',
        utm_medium: params.get('utm_medium') ?? '',
        utm_campaign: params.get('utm_campaign') ?? '',
        utm_content: params.get('utm_content') ?? ''
    });
const $6d5db2a3857b353c$var$getStoredAttribution = (rawMarketingContext)=>{
    if (!rawMarketingContext) return $6d5db2a3857b353c$var$EMPTY_ATTRIBUTION;
    try {
        const marketingContext = JSON.parse(rawMarketingContext);
        return {
            'utm_sfdc-campaign-id': $6d5db2a3857b353c$var$asString(marketingContext.utm?.sfdcCampaignId),
            utm_source: $6d5db2a3857b353c$var$asString(marketingContext.utm?.source),
            utm_bmcr_source: '',
            utm_medium: $6d5db2a3857b353c$var$asString(marketingContext.utm?.medium),
            utm_campaign: $6d5db2a3857b353c$var$asString(marketingContext.utm?.campaign),
            utm_content: $6d5db2a3857b353c$var$asString(marketingContext.utm?.content)
        };
    } catch  {
        return $6d5db2a3857b353c$var$EMPTY_ATTRIBUTION;
    }
};
const $6d5db2a3857b353c$export$4f0802f6ad9af800 = (search = typeof window === 'undefined' ? '' : window.location.search, rawMarketingContext = (0, $2gCne.getLocalStorage)('marketingContext', true))=>{
    const params = new URLSearchParams(search);
    const hasUrlAttribution = $6d5db2a3857b353c$var$URL_KEYS.some((key)=>params.has(key));
    if (hasUrlAttribution) return $6d5db2a3857b353c$var$getUrlAttribution(params);
    return $6d5db2a3857b353c$var$getStoredAttribution(rawMarketingContext);
};

});

parcelRegister("hUkOo", function(module, exports) {
$parcel$export(module.exports, "webinarFormMessages", function () { return $8e449aede1df927f$export$736db69ccf25597c; });

var $fnHPc = parcelRequire("fnHPc");
const $8e449aede1df927f$export$736db69ccf25597c = (0, $fnHPc.defineMessages)({
    initializing: {
        id: 'uniform.webinarForm.initializing',
        defaultMessage: "Loading registration form\u2026"
    },
    configurationError: {
        id: 'uniform.webinarForm.configurationError',
        defaultMessage: 'This webinar registration form is not configured correctly.'
    },
    sessionDateConfigurationError: {
        id: 'uniform.webinarForm.sessionDateConfigurationError',
        defaultMessage: 'Each webinar session needs either a structured Date or a Date Label.'
    },
    registerHeading: {
        id: 'uniform.webinarForm.registerHeading',
        defaultMessage: 'Register now:'
    },
    onDemandHeading: {
        id: 'uniform.webinarForm.onDemandHeading',
        defaultMessage: 'Watch on-demand:'
    },
    sessionLegend: {
        id: 'uniform.webinarForm.sessionLegend',
        defaultMessage: 'Select a date and time'
    },
    firstName: {
        id: 'uniform.webinarForm.field.firstName',
        defaultMessage: 'First name'
    },
    lastName: {
        id: 'uniform.webinarForm.field.lastName',
        defaultMessage: 'Last name'
    },
    company: {
        id: 'uniform.webinarForm.field.company',
        defaultMessage: 'Company name'
    },
    department: {
        id: 'uniform.webinarForm.field.department',
        defaultMessage: 'Department'
    },
    jobTitle: {
        id: 'uniform.webinarForm.field.jobTitle',
        defaultMessage: 'Job title'
    },
    email: {
        id: 'uniform.webinarForm.field.email',
        defaultMessage: 'Work email'
    },
    phone: {
        id: 'uniform.webinarForm.field.phone',
        defaultMessage: 'Phone number'
    },
    companySize: {
        id: 'uniform.webinarForm.field.companySize',
        defaultMessage: 'Company size'
    },
    country: {
        id: 'uniform.webinarForm.field.country',
        defaultMessage: 'Country'
    },
    selectOption: {
        id: 'uniform.webinarForm.field.selectOption',
        defaultMessage: 'Select an option'
    },
    alternateEmail: {
        id: 'uniform.webinarForm.field.alternateEmail',
        defaultMessage: 'Alternate email'
    },
    required: {
        id: 'uniform.webinarForm.validation.required',
        defaultMessage: 'This field is required.'
    },
    invalidEmail: {
        id: 'uniform.webinarForm.validation.invalidEmail',
        defaultMessage: 'Enter a valid email address.'
    },
    businessEmail: {
        id: 'uniform.webinarForm.validation.businessEmail',
        defaultMessage: 'Enter your business email address. This form does not accept addresses from {domain}.'
    },
    privacyDisclosure: {
        id: 'uniform.webinarForm.privacyDisclosure',
        defaultMessage: "By submitting this form, I acknowledge receipt of Atlassian\u2019s"
    },
    privacyPolicy: {
        id: 'uniform.webinarForm.privacyPolicy',
        defaultMessage: 'Privacy Policy'
    },
    marketingOptIn: {
        id: 'uniform.webinarForm.marketingOptIn',
        defaultMessage: 'Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.'
    },
    registerButton: {
        id: 'uniform.webinarForm.registerButton',
        defaultMessage: 'Register now'
    },
    watchButton: {
        id: 'uniform.webinarForm.watchButton',
        defaultMessage: 'Watch now'
    },
    submitError: {
        id: 'uniform.webinarForm.submitError',
        defaultMessage: 'We could not complete your registration. Please try again.'
    }
});

});

parcelRegister("eCT8P", function(module, exports) {
$parcel$export(module.exports, "validateWebinarForm", function () { return $0377d31bce69dc4d$export$36aac608fce31ecb; });
const $0377d31bce69dc4d$var$EMAIL_PATTERN = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
const $0377d31bce69dc4d$var$PERSONAL_EMAIL_DOMAINS = new Set([
    'aol.com',
    'apple.com',
    'gmail.com',
    'hotmail.com',
    'icloud.com',
    'live.com',
    'mac.com',
    'me.com',
    'msn.com',
    'outlook.com',
    'yahoo.com',
    'ymail.com'
]);
const $0377d31bce69dc4d$export$8ea3bea9b40a8063 = (email)=>$0377d31bce69dc4d$var$EMAIL_PATTERN.test(email.trim());
const $0377d31bce69dc4d$export$cc6a9cf82fdb2403 = (email)=>{
    const domain = email.trim().toLowerCase().split('@')[1];
    return domain && $0377d31bce69dc4d$var$PERSONAL_EMAIL_DOMAINS.has(domain) ? domain : undefined;
};
const $0377d31bce69dc4d$export$36aac608fce31ecb = (values, options)=>{
    const errors = {};
    const require = (field)=>{
        const value = values[field];
        if (typeof value === 'string' && !value.trim()) errors[field] = options.messages.required;
    };
    require('firstName');
    require('lastName');
    require('company');
    require('jobTitle');
    require('email');
    require('companySize');
    require('country');
    if (options.showPhone) require('phone');
    if (options.isJapanese) require('department');
    if (options.hasMultipleSessions) require('eventId');
    if (!errors.email && !$0377d31bce69dc4d$export$8ea3bea9b40a8063(values.email)) errors.email = options.messages.invalidEmail;
    if (!errors.email && options.blockPersonalEmails) {
        const personalDomain = $0377d31bce69dc4d$export$cc6a9cf82fdb2403(values.email);
        if (personalDomain) errors.email = options.messages.businessEmail(personalDomain);
    }
    return errors;
};

});




parcelRegister("kFmOH", function(module, exports) {
$parcel$export(module.exports, "getLiveComposition", function () { return $1c72a4933c82b76c$export$82e79184fef3861b; });

var $kf4PU = parcelRequire("kf4PU");
const $1c72a4933c82b76c$var$REQUEST_TIMEOUT_MS = 5000;
/** One retry — see the comment on the request loop below. */ const $1c72a4933c82b76c$var$MAX_ATTEMPTS = 2;
const $1c72a4933c82b76c$var$RETRY_DELAY_MS = 500;
const $1c72a4933c82b76c$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $1c72a4933c82b76c$export$82e79184fef3861b = async (queryParams, route, currLocale = 'en-US')=>{
    const projectId = queryParams.get('projectId');
    const compositionId = queryParams.get('compositionId');
    const compositionState = queryParams.get('compositionState') ?? 'draft';
    const contentfulEnv = queryParams.get('contentfulEnv') ?? 'master';
    const contentfulState = queryParams.get('contentfulState') ?? 'draft';
    const locale = queryParams.get('locale') ?? (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[currLocale] ?? 'en-US';
    const pageUrl = route.startsWith('/') ? route : `/${route}`;
    const wacmanParams = new URLSearchParams({
        projectId: projectId ?? '',
        compositionId: compositionId ?? '',
        compositionState: compositionState,
        contentfulEnv: contentfulEnv,
        contentfulState: contentfulState,
        locale: locale,
        pageUrl: pageUrl,
        hydrate: 'true'
    });
    const baseEndpoint = "https://wac-management-service.us-east-1.prod.atl-paas.net";
    if (!baseEndpoint) {
        console.warn('getLiveComposition: WAC_MANAGEMENT_API_BASE_URL is not configured');
        return undefined;
    }
    const endpoint = `${baseEndpoint}/api/v1/uniform/composition/get?${wacmanParams.toString()}`;
    // A composition that is not already cached in S3 has to be regenerated before
    // wac-management-service can answer, and a cold regeneration regularly takes
    // longer than REQUEST_TIMEOUT_MS. The first request then aborts and the page
    // renders blank with nothing but a console warning — the "reload and it works"
    // behaviour. One retry lands after that regeneration has finished.
    //
    // Only a timeout or a 5xx is retried. A 4xx means the request itself is wrong
    // (unknown compositionId, bad project) and asking again cannot change that.
    for(let attempt = 1; attempt <= $1c72a4933c82b76c$var$MAX_ATTEMPTS; attempt++){
        const isLastAttempt = attempt === $1c72a4933c82b76c$var$MAX_ATTEMPTS;
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), $1c72a4933c82b76c$var$REQUEST_TIMEOUT_MS);
        try {
            const response = await fetch(endpoint, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                signal: controller.signal
            });
            clearTimeout(timeoutId);
            if (!response.ok) {
                const retryable = response.status >= 500;
                if (retryable && !isLastAttempt) {
                    console.warn(`getLiveComposition: wac-management-service responded ${response.status}, retrying`);
                    await $1c72a4933c82b76c$var$delay($1c72a4933c82b76c$var$RETRY_DELAY_MS);
                    continue;
                }
                console.warn(`getLiveComposition: wac-management-service responded ${response.status}`);
                return undefined;
            }
            const result = await response.json();
            if (result.error) console.warn('getLiveComposition: error in response:', result.error);
            return result.composition;
        } catch (e) {
            clearTimeout(timeoutId);
            const err = e instanceof Error ? e : new Error(String(e));
            if (!isLastAttempt) {
                console.warn(`getLiveComposition: fetch failed - ${err.name}: ${err.message}, retrying`);
                await $1c72a4933c82b76c$var$delay($1c72a4933c82b76c$var$RETRY_DELAY_MS);
                continue;
            }
            console.warn(`getLiveComposition: fetch failed - ${err.name}: ${err.message}`);
            return undefined;
        }
    }
    return undefined;
};

});

parcelRegister("g70ym", function(module, exports) {
$parcel$export(module.exports, "UniformMissingComponent", function () { return $ff4b1737eead1b52$export$ec79654869ecfe2e; });
/* uniform-missing-component.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $ff4b1737eead1b52$export$ec79654869ecfe2e = ({ componentName: componentName })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        id: `UNIFORM-MISSING-COMPONENT-${componentName}`,
        "data-nosnippet": true,
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            "_1e0cglyw"
        ])
    });
};

});



//# sourceMappingURL=index.9d784e57.js.map
